webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _upgrade_adapter = __webpack_require__(1);
	
	var _core = __webpack_require__(4);
	
	// set angular to production mode if app is set
	if (true) {
	    (0, _core.enableProdMode)();
	}
	
	var version = __webpack_require__(334);
	window.version = version;
	
	// Default modules & sub modules
	var modules = ['ngCookies', 'ngResource', 'ui.bootstrap', 'ui.router', 'rp.system', 'rp.pages', 'rp.auth', 'rp.landing', 'rp.changelog'];
	angular.module('rp', modules);
	
	// system
	// call file-upload shim
	var systemModule = angular.module('rp.system', []);
	
	// pages
	var pagesModule = angular.module('rp.pages', ['ngDialog', 'angularSpinner', 'ng-sortable']);
	
	// auth
	var authModule = angular.module('rp.auth', []);
	
	// landing
	var landingModule = angular.module('rp.landing', []);
	
	var changelogModule = angular.module('rp.changelog', []);
	
	// load child components
	__webpack_require__(335)(systemModule);
	__webpack_require__(447)(pagesModule);
	__webpack_require__(866)(authModule);
	__webpack_require__(879)(landingModule);
	__webpack_require__(945)(changelogModule);
	
	angular.element(document).ready(function () {
	    //Then init the app
	    _upgrade_adapter.upgradeAdapter.bootstrap(document.body, ['rp'], { strictDi: true });
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var upgrade_1 = __webpack_require__(2);
	exports.upgradeAdapter = new upgrade_1.UpgradeAdapter();


/***/ },
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */
/***/ function(module, exports) {

	module.exports = "2.6.1\n"

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // styling
	    __webpack_require__(336)();
	    // services
	    __webpack_require__(387)(ngModule);
	    // routes
	    __webpack_require__(440)(ngModule);
	};

/***/ },
/* 336 */
[1589, 337],
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function () {
	    // helpers
	    __webpack_require__(338);
	    __webpack_require__(347);
	    __webpack_require__(350);
	    __webpack_require__(353);
	    __webpack_require__(356);
	    // popup stylesheets
	    __webpack_require__(359);
	    __webpack_require__(361);
	    // pages
	    __webpack_require__(363);
	    __webpack_require__(365);
	    // custom styles
	    __webpack_require__(367);
	};

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(339);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!./font-awesome.css", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!./font-awesome.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(341) + ");src:url(" + __webpack_require__(342) + "?#iefix&v=4.0.3) format(\"embedded-opentype\"),url(" + __webpack_require__(343) + ") format(\"woff\"),url(" + __webpack_require__(344) + ") format(\"truetype\"),url(" + __webpack_require__(345) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font-family:FontAwesome;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857142858em;text-align:center}.fa-ul{padding-left:0;margin-left:2.142857142857143em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.142857142857143em;width:2.142857142857143em;top:.14285714285714285em;text-align:center}.fa-li.fa-lg{left:-1.8571428571428572em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:spin 2s infinite linear}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=1);transform:rotate(90deg)}.fa-rotate-180{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2);transform:rotate(180deg)}.fa-rotate-270{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=3);transform:rotate(270deg)}.fa-flip-horizontal{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);transform:scaleX(-1)}.fa-flip-vertical{filter:progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);transform:scaleY(-1)}.fa-stack{position:relative!important;display:inline-block!important;width:2em!important;height:2em!important;line-height:2em!important;vertical-align:middle!important}.fa-stack-1x,.fa-stack-2x{position:absolute!important;left:0!important;width:100%!important;text-align:center!important}.fa-stack-1x{line-height:inherit!important}.fa-stack-2x{font-size:2em!important}.fa-inverse{color:#fff!important}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-asc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-desc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}", ""]);
	
	// exports


/***/ },
/* 340 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7149833697a959306ec3012a8588dcfa.eot";

/***/ },
/* 342 */
341,
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d95d6f5d5ab7cfefd09651800b69bd54.woff";

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4668ed2440df82d3fd2f8be9d31d07d.ttf";

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "65bcbc899f379216109acd0b6c494618.svg";

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(348);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!./flags16.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!./flags16.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".f16 .flag{display:inline-block;height:16px;width:16px;vertical-align:text-top;line-height:16px;background:url(" + __webpack_require__(349) + ") no-repeat}.f16 ._African_Union{background-position:0 -16px}.f16 ._Arab_League{background-position:0 -32px}.f16 ._ASEAN{background-position:0 -48px}.f16 ._CARICOM{background-position:0 -64px}.f16 ._CIS{background-position:0 -80px}.f16 ._Commonwealth{background-position:0 -96px}.f16 ._England{background-position:0 -112px}.f16 ._European_Union,.f16 .eu{background-position:0 -128px}.f16 ._Islamic_Conference{background-position:0 -144px}.f16 ._Kosovo{background-position:0 -160px}.f16 ._NATO{background-position:0 -176px}.f16 ._Northern_Cyprus{background-position:0 -192px}.f16 ._Northern_Ireland{background-position:0 -208px}.f16 ._Olimpic_Movement{background-position:0 -224px}.f16 ._OPEC{background-position:0 -240px}.f16 ._Red_Cross{background-position:0 -256px}.f16 ._Scotland{background-position:0 -272px}.f16 ._Somaliland{background-position:0 -288px}.f16 ._Tibet{background-position:0 -304px}.f16 ._United_Nations{background-position:0 -320px}.f16 ._Wales{background-position:0 -336px}.f16 .ad{background-position:0 -352px}.f16 .ae{background-position:0 -368px}.f16 .af{background-position:0 -384px}.f16 .ag{background-position:0 -400px}.f16 .ai{background-position:0 -416px}.f16 .al{background-position:0 -432px}.f16 .am{background-position:0 -448px}.f16 .ao{background-position:0 -464px}.f16 .aq{background-position:0 -480px}.f16 .ar{background-position:0 -496px}.f16 .as{background-position:0 -512px}.f16 .at{background-position:0 -528px}.f16 .au{background-position:0 -544px}.f16 .aw{background-position:0 -560px}.f16 .ax{background-position:0 -576px}.f16 .az{background-position:0 -592px}.f16 .ba{background-position:0 -608px}.f16 .bb{background-position:0 -624px}.f16 .bd{background-position:0 -640px}.f16 .be{background-position:0 -656px}.f16 .bf{background-position:0 -672px}.f16 .bg{background-position:0 -688px}.f16 .bh{background-position:0 -704px}.f16 .bi{background-position:0 -720px}.f16 .bj{background-position:0 -736px}.f16 .bm{background-position:0 -752px}.f16 .bn{background-position:0 -768px}.f16 .bo{background-position:0 -784px}.f16 .br{background-position:0 -800px}.f16 .bs{background-position:0 -816px}.f16 .bt{background-position:0 -832px}.f16 .bw{background-position:0 -848px}.f16 .by{background-position:0 -864px}.f16 .bz{background-position:0 -880px}.f16 .ca{background-position:0 -896px}.f16 .cg{background-position:0 -912px}.f16 .cf{background-position:0 -928px}.f16 .cd{background-position:0 -944px}.f16 .ch{background-position:0 -960px}.f16 .ci{background-position:0 -976px}.f16 .ck{background-position:0 -992px}.f16 .cl{background-position:0 -1008px}.f16 .cm{background-position:0 -1024px}.f16 .cn{background-position:0 -1040px}.f16 .co{background-position:0 -1056px}.f16 .cr{background-position:0 -1072px}.f16 .cu{background-position:0 -1088px}.f16 .cv{background-position:0 -1104px}.f16 .cy{background-position:0 -1120px}.f16 .cz{background-position:0 -1136px}.f16 .de{background-position:0 -1152px}.f16 .dj{background-position:0 -1168px}.f16 .dk{background-position:0 -1184px}.f16 .dm{background-position:0 -1200px}.f16 .do{background-position:0 -1216px}.f16 .dz{background-position:0 -1232px}.f16 .ec{background-position:0 -1248px}.f16 .ee{background-position:0 -1264px}.f16 .eg{background-position:0 -1280px}.f16 .eh{background-position:0 -1296px}.f16 .er{background-position:0 -1312px}.f16 .es{background-position:0 -1328px}.f16 .et{background-position:0 -1344px}.f16 .fi{background-position:0 -1360px}.f16 .fj{background-position:0 -1376px}.f16 .fm{background-position:0 -1392px}.f16 .fo{background-position:0 -1408px}.f16 .bl,.f16 .cp,.f16 .fr,.f16 .mf,.f16 .yt{background-position:0 -1424px}.f16 .ga{background-position:0 -1440px}.f16 .gb,.f16 .sh{background-position:0 -1456px}.f16 .gd{background-position:0 -1472px}.f16 .ge{background-position:0 -1488px}.f16 .gg{background-position:0 -1504px}.f16 .gh{background-position:0 -1520px}.f16 .gi{background-position:0 -1536px}.f16 .gl{background-position:0 -1552px}.f16 .gm{background-position:0 -1568px}.f16 .gn{background-position:0 -1584px}.f16 .gp{background-position:0 -1600px}.f16 .gq{background-position:0 -1616px}.f16 .gr{background-position:0 -1632px}.f16 .gt{background-position:0 -1648px}.f16 .gu{background-position:0 -1664px}.f16 .gw{background-position:0 -1680px}.f16 .gy{background-position:0 -1696px}.f16 .hk{background-position:0 -1712px}.f16 .hn{background-position:0 -1728px}.f16 .hr{background-position:0 -1744px}.f16 .ht{background-position:0 -1760px}.f16 .hu{background-position:0 -1776px}.f16 .id,.f16 .mc{background-position:0 -1792px}.f16 .ie{background-position:0 -1808px}.f16 .il{background-position:0 -1824px}.f16 .im{background-position:0 -1840px}.f16 .in{background-position:0 -1856px}.f16 .iq{background-position:0 -1872px}.f16 .ir{background-position:0 -1888px}.f16 .is{background-position:0 -1904px}.f16 .it{background-position:0 -1920px}.f16 .je{background-position:0 -1936px}.f16 .jm{background-position:0 -1952px}.f16 .jo{background-position:0 -1968px}.f16 .jp{background-position:0 -1984px}.f16 .ke{background-position:0 -2000px}.f16 .kg{background-position:0 -2016px}.f16 .kh{background-position:0 -2032px}.f16 .ki{background-position:0 -2048px}.f16 .km{background-position:0 -2064px}.f16 .kn{background-position:0 -2080px}.f16 .kp{background-position:0 -2096px}.f16 .kr{background-position:0 -2112px}.f16 .kw{background-position:0 -2128px}.f16 .ky{background-position:0 -2144px}.f16 .kz{background-position:0 -2160px}.f16 .la{background-position:0 -2176px}.f16 .lb{background-position:0 -2192px}.f16 .lc{background-position:0 -2208px}.f16 .li{background-position:0 -2224px}.f16 .lk{background-position:0 -2240px}.f16 .lr{background-position:0 -2256px}.f16 .ls{background-position:0 -2272px}.f16 .lt{background-position:0 -2288px}.f16 .lu{background-position:0 -2304px}.f16 .lv{background-position:0 -2320px}.f16 .ly{background-position:0 -2336px}.f16 .ma{background-position:0 -2352px}.f16 .md{background-position:0 -2368px}.f16 .me{background-position:0 -2384px}.f16 .mg{background-position:0 -2400px}.f16 .mh{background-position:0 -2416px}.f16 .mk{background-position:0 -2432px}.f16 .ml{background-position:0 -2448px}.f16 .mm{background-position:0 -2464px}.f16 .mn{background-position:0 -2480px}.f16 .mo{background-position:0 -2496px}.f16 .mq{background-position:0 -2512px}.f16 .mr{background-position:0 -2528px}.f16 .ms{background-position:0 -2544px}.f16 .mt{background-position:0 -2560px}.f16 .mu{background-position:0 -2576px}.f16 .mv{background-position:0 -2592px}.f16 .mw{background-position:0 -2608px}.f16 .mx{background-position:0 -2624px}.f16 .my{background-position:0 -2640px}.f16 .mz{background-position:0 -2656px}.f16 .na{background-position:0 -2672px}.f16 .nc{background-position:0 -2688px}.f16 .ne{background-position:0 -2704px}.f16 .ng{background-position:0 -2720px}.f16 .ni{background-position:0 -2736px}.f16 .bq,.f16 .nl{background-position:0 -2752px}.f16 .bv,.f16 .no,.f16 .nq,.f16 .sj{background-position:0 -2768px}.f16 .np{background-position:0 -2784px}.f16 .nr{background-position:0 -2800px}.f16 .nz{background-position:0 -2816px}.f16 .om{background-position:0 -2832px}.f16 .pa{background-position:0 -2848px}.f16 .pe{background-position:0 -2864px}.f16 .pf{background-position:0 -2880px}.f16 .pg{background-position:0 -2896px}.f16 .ph{background-position:0 -2912px}.f16 .pk{background-position:0 -2928px}.f16 .pl{background-position:0 -2944px}.f16 .pr{background-position:0 -2960px}.f16 .ps{background-position:0 -2976px}.f16 .pt{background-position:0 -2992px}.f16 .pw{background-position:0 -3008px}.f16 .py{background-position:0 -3024px}.f16 .qa{background-position:0 -3040px}.f16 .re{background-position:0 -3056px}.f16 .ro{background-position:0 -3072px}.f16 .rs{background-position:0 -3088px}.f16 .ru{background-position:0 -3104px}.f16 .rw{background-position:0 -3120px}.f16 .sa{background-position:0 -3136px}.f16 .sb{background-position:0 -3152px}.f16 .sc{background-position:0 -3168px}.f16 .sd{background-position:0 -3184px}.f16 .se{background-position:0 -3200px}.f16 .sg{background-position:0 -3216px}.f16 .si{background-position:0 -3232px}.f16 .sk{background-position:0 -3248px}.f16 .sl{background-position:0 -3264px}.f16 .sm{background-position:0 -3280px}.f16 .sn{background-position:0 -3296px}.f16 .so{background-position:0 -3312px}.f16 .sr{background-position:0 -3328px}.f16 .st{background-position:0 -3344px}.f16 .sv{background-position:0 -3360px}.f16 .sy{background-position:0 -3376px}.f16 .sz{background-position:0 -3392px}.f16 .tc{background-position:0 -3408px}.f16 .td{background-position:0 -3424px}.f16 .tg{background-position:0 -3440px}.f16 .th{background-position:0 -3456px}.f16 .tj{background-position:0 -3472px}.f16 .tl{background-position:0 -3488px}.f16 .tm{background-position:0 -3504px}.f16 .tn{background-position:0 -3520px}.f16 .to{background-position:0 -3536px}.f16 .tr{background-position:0 -3552px}.f16 .tt{background-position:0 -3568px}.f16 .tv{background-position:0 -3584px}.f16 .tw{background-position:0 -3600px}.f16 .tz{background-position:0 -3616px}.f16 .ua{background-position:0 -3632px}.f16 .ug{background-position:0 -3648px}.f16 .us{background-position:0 -3664px}.f16 .uy{background-position:0 -3680px}.f16 .uz{background-position:0 -3696px}.f16 .va{background-position:0 -3712px}.f16 .vc{background-position:0 -3728px}.f16 .ve{background-position:0 -3744px}.f16 .vg{background-position:0 -3760px}.f16 .vi{background-position:0 -3776px}.f16 .vn{background-position:0 -3792px}.f16 .vu{background-position:0 -3808px}.f16 .ws{background-position:0 -3824px}.f16 .ye{background-position:0 -3840px}.f16 .za{background-position:0 -3856px}.f16 .zm{background-position:0 -3872px}.f16 .zw{background-position:0 -3888px}.f16 .sx{background-position:0 -3904px}.f16 .cw{background-position:0 -3920px}.f16 .ss{background-position:0 -3936px}.f16 .iana{background-position:0 -7808px!important}.f16 .ap{background-position:0 -7840px!important}", ""]);
	
	// exports


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "96570e26d71fedde4ab5b6123ce2917a.png";

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(351);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!./flags32.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!./flags32.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".f32 .flag{display:inline-block!important;height:32px!important;width:32px!important;vertical-align:text-top!important;line-height:32px!important;background:url(" + __webpack_require__(352) + ") no-repeat!important}.f32 ._African_Union(OAS){background-position:0 -32px!important}.f32 ._Arab_League{background-position:0 -64px!important}.f32 ._ASEAN{background-position:0 -96px!important}.f32 ._CARICOM{background-position:0 -128px!important}.f32 ._CIS{background-position:0 -160px!important}.f32 ._Commonwealth{background-position:0 -192px!important}.f32 ._England{background-position:0 -224px!important}.f32 .eu{background-position:0 -256px!important}.f32 ._Islamic_Conference{background-position:0 -288px!important}.f32 ._Kosovo{background-position:0 -320px!important}.f32 ._NATO{background-position:0 -352px!important}.f32 ._Northern_Cyprus{background-position:0 -384px!important}.f32 ._Northern_Ireland{background-position:0 -416px!important}.f32 ._Olimpic_Movement{background-position:0 -448px!important}.f32 ._OPEC{background-position:0 -480px!important}.f32 ._Red_Cross{background-position:0 -512px!important}.f32 ._Scotland{background-position:0 -544px!important}.f32 ._Somaliland{background-position:0 -576px!important}.f32 ._Tibet{background-position:0 -608px!important}.f32 ._United_Nations{background-position:0 -640px!important}.f32 ._Wales{background-position:0 -672px!important}.f32 .ad{background-position:0 -704px!important}.f32 .ae{background-position:0 -736px!important}.f32 .af{background-position:0 -768px!important}.f32 .ag{background-position:0 -800px!important}.f32 .ai{background-position:0 -832px!important}.f32 .al{background-position:0 -864px!important}.f32 .am{background-position:0 -896px!important}.f32 .an{background-position:0 -928px!important}.f32 .ao{background-position:0 -960px!important}.f32 .aq{background-position:0 -992px!important}.f32 .ar{background-position:0 -1024px!important}.f32 .as{background-position:0 -1056px!important}.f32 .at{background-position:0 -1088px!important}.f32 .au{background-position:0 -1120px!important}.f32 .aw{background-position:0 -1152px!important}.f32 .az{background-position:0 -1184px!important}.f32 .ba{background-position:0 -1216px!important}.f32 .bb{background-position:0 -1248px!important}.f32 .bd{background-position:0 -1280px!important}.f32 .be{background-position:0 -1312px!important}.f32 .bf{background-position:0 -1344px!important}.f32 .bg{background-position:0 -1376px!important}.f32 .bh{background-position:0 -1408px!important}.f32 .bi{background-position:0 -1440px!important}.f32 .bj{background-position:0 -1472px!important}.f32 .bm{background-position:0 -1504px!important}.f32 .bn{background-position:0 -1536px!important}.f32 .bo{background-position:0 -1568px!important}.f32 .br{background-position:0 -1600px!important}.f32 .bs{background-position:0 -1632px!important}.f32 .bt{background-position:0 -1664px!important}.f32 .bw{background-position:0 -1696px!important}.f32 .by{background-position:0 -1728px!important}.f32 .bz{background-position:0 -1760px!important}.f32 .ca{background-position:0 -1792px!important}.f32 .cd{background-position:0 -1824px!important}.f32 .cf{background-position:0 -1856px!important}.f32 .cg{background-position:0 -1888px!important}.f32 .ch{background-position:0 -1920px!important}.f32 .ci{background-position:0 -1952px!important}.f32 .ck{background-position:0 -1984px!important}.f32 .cl{background-position:0 -2016px!important}.f32 .cm{background-position:0 -2048px!important}.f32 .cn{background-position:0 -2080px!important}.f32 .co{background-position:0 -2112px!important}.f32 .cr{background-position:0 -2144px!important}.f32 .cu{background-position:0 -2176px!important}.f32 .cv{background-position:0 -2208px!important}.f32 .cy{background-position:0 -2240px!important}.f32 .cz{background-position:0 -2272px!important}.f32 .de{background-position:0 -2304px!important}.f32 .dj{background-position:0 -2336px!important}.f32 .dk{background-position:0 -2368px!important}.f32 .dm{background-position:0 -2400px!important}.f32 .do{background-position:0 -2432px!important}.f32 .dz{background-position:0 -2464px!important}.f32 .ec{background-position:0 -2496px!important}.f32 .ee{background-position:0 -2528px!important}.f32 .eg{background-position:0 -2560px!important}.f32 .eh{background-position:0 -2592px!important}.f32 .er{background-position:0 -2624px!important}.f32 .es{background-position:0 -2656px!important}.f32 .et{background-position:0 -2688px!important}.f32 .fi{background-position:0 -2720px!important}.f32 .fj{background-position:0 -2752px!important}.f32 .fm{background-position:0 -2784px!important}.f32 .fo{background-position:0 -2816px!important}.f32 .fr{background-position:0 -2848px!important}.f32 .ga{background-position:0 -2880px!important}.f32 .gb{background-position:0 -2912px!important}.f32 .gd{background-position:0 -2944px!important}.f32 .ge{background-position:0 -2976px!important}.f32 .gg{background-position:0 -3008px!important}.f32 .gh{background-position:0 -3040px!important}.f32 .gi{background-position:0 -3072px!important}.f32 .gl{background-position:0 -3104px!important}.f32 .gm{background-position:0 -3136px!important}.f32 .gn{background-position:0 -3168px!important}.f32 .gp{background-position:0 -3200px!important}.f32 .gq{background-position:0 -3232px!important}.f32 .gr{background-position:0 -3264px!important}.f32 .gt{background-position:0 -3296px!important}.f32 .gu{background-position:0 -3328px!important}.f32 .gw{background-position:0 -3360px!important}.f32 .gy{background-position:0 -3392px!important}.f32 .hk{background-position:0 -3424px!important}.f32 .hn{background-position:0 -3456px!important}.f32 .hr{background-position:0 -3488px!important}.f32 .ht{background-position:0 -3520px!important}.f32 .hu{background-position:0 -3552px!important}.f32 .id,.f32 .mc{background-position:0 -3584px!important}.f32 .ie{background-position:0 -3616px!important}.f32 .il{background-position:0 -3648px!important}.f32 .im{background-position:0 -3680px!important}.f32 .in{background-position:0 -3712px!important}.f32 .iq{background-position:0 -3744px!important}.f32 .ir{background-position:0 -3776px!important}.f32 .is{background-position:0 -3808px!important}.f32 .it{background-position:0 -3840px!important}.f32 .je{background-position:0 -3872px!important}.f32 .jm{background-position:0 -3904px!important}.f32 .jo{background-position:0 -3936px!important}.f32 .jp{background-position:0 -3968px!important}.f32 .ke{background-position:0 -4000px!important}.f32 .kg{background-position:0 -4032px!important}.f32 .kh{background-position:0 -4064px!important}.f32 .ki{background-position:0 -4096px!important}.f32 .km{background-position:0 -4128px!important}.f32 .kn{background-position:0 -4160px!important}.f32 .kp{background-position:0 -4192px!important}.f32 .kr{background-position:0 -4224px!important}.f32 .kw{background-position:0 -4256px!important}.f32 .ky{background-position:0 -4288px!important}.f32 .kz{background-position:0 -4320px!important}.f32 .la{background-position:0 -4352px!important}.f32 .lb{background-position:0 -4384px!important}.f32 .lc{background-position:0 -4416px!important}.f32 .li{background-position:0 -4448px!important}.f32 .lk{background-position:0 -4480px!important}.f32 .lr{background-position:0 -4512px!important}.f32 .ls{background-position:0 -4544px!important}.f32 .lt{background-position:0 -4576px!important}.f32 .lu{background-position:0 -4608px!important}.f32 .lv{background-position:0 -4640px!important}.f32 .ly{background-position:0 -4672px!important}.f32 .ma{background-position:0 -4704px!important}.f32 .md{background-position:0 -4736px!important}.f32 .me{background-position:0 -4768px!important}.f32 .mg{background-position:0 -4800px!important}.f32 .mh{background-position:0 -4832px!important}.f32 .mk{background-position:0 -4864px!important}.f32 .ml{background-position:0 -4896px!important}.f32 .mm{background-position:0 -4928px!important}.f32 .mn{background-position:0 -4960px!important}.f32 .mo{background-position:0 -4992px!important}.f32 .mq{background-position:0 -5024px!important}.f32 .mr{background-position:0 -5056px!important}.f32 .ms{background-position:0 -5088px!important}.f32 .mt{background-position:0 -5120px!important}.f32 .mu{background-position:0 -5152px!important}.f32 .mv{background-position:0 -5184px!important}.f32 .mw{background-position:0 -5216px!important}.f32 .mx{background-position:0 -5248px!important}.f32 .my{background-position:0 -5280px!important}.f32 .mz{background-position:0 -5312px!important}.f32 .na{background-position:0 -5344px!important}.f32 .nc{background-position:0 -5376px!important}.f32 .ne{background-position:0 -5408px!important}.f32 .ng{background-position:0 -5440px!important}.f32 .ni{background-position:0 -5472px!important}.f32 .nl{background-position:0 -5504px!important}.f32 .no{background-position:0 -5536px!important}.f32 .np{background-position:0 -5568px!important}.f32 .nr{background-position:0 -5600px!important}.f32 .nz{background-position:0 -5632px!important}.f32 .om{background-position:0 -5664px!important}.f32 .pa{background-position:0 -5696px!important}.f32 .pe{background-position:0 -5728px!important}.f32 .pf{background-position:0 -5760px!important}.f32 .pg{background-position:0 -5792px!important}.f32 .ph{background-position:0 -5824px!important}.f32 .pk{background-position:0 -5856px!important}.f32 .pl{background-position:0 -5888px!important}.f32 .pr{background-position:0 -5920px!important}.f32 .ps{background-position:0 -5952px!important}.f32 .pt{background-position:0 -5984px!important}.f32 .pw{background-position:0 -6016px!important}.f32 .py{background-position:0 -6048px!important}.f32 .qa{background-position:0 -6080px!important}.f32 .re{background-position:0 -6112px!important}.f32 .ro{background-position:0 -6144px!important}.f32 .rs{background-position:0 -6176px!important}.f32 .ru{background-position:0 -6208px!important}.f32 .rw{background-position:0 -6240px!important}.f32 .sa{background-position:0 -6272px!important}.f32 .sb{background-position:0 -6304px!important}.f32 .sc{background-position:0 -6336px!important}.f32 .sd{background-position:0 -6368px!important}.f32 .se{background-position:0 -6400px!important}.f32 .sg{background-position:0 -6432px!important}.f32 .si{background-position:0 -6464px!important}.f32 .sk{background-position:0 -6496px!important}.f32 .sl{background-position:0 -6528px!important}.f32 .sm{background-position:0 -6560px!important}.f32 .sn{background-position:0 -6592px!important}.f32 .so{background-position:0 -6624px!important}.f32 .sr{background-position:0 -6656px!important}.f32 .st{background-position:0 -6688px!important}.f32 .sv{background-position:0 -6720px!important}.f32 .sy{background-position:0 -6752px!important}.f32 .sz{background-position:0 -6784px!important}.f32 .tc{background-position:0 -6816px!important}.f32 .td{background-position:0 -6848px!important}.f32 .tg{background-position:0 -6880px!important}.f32 .th{background-position:0 -6912px!important}.f32 .tj{background-position:0 -6944px!important}.f32 .tl{background-position:0 -6976px!important}.f32 .tm{background-position:0 -7008px!important}.f32 .tn{background-position:0 -7040px!important}.f32 .to{background-position:0 -7072px!important}.f32 .tr{background-position:0 -7104px!important}.f32 .tt{background-position:0 -7136px!important}.f32 .tv{background-position:0 -7168px!important}.f32 .tw{background-position:0 -7200px!important}.f32 .tz{background-position:0 -7232px!important}.f32 .ua{background-position:0 -7264px!important}.f32 .ug{background-position:0 -7296px!important}.f32 .us{background-position:0 -7328px!important}.f32 .uy{background-position:0 -7360px!important}.f32 .uz{background-position:0 -7392px!important}.f32 .va{background-position:0 -7424px!important}.f32 .vc{background-position:0 -7456px!important}.f32 .ve{background-position:0 -7488px!important}.f32 .vg{background-position:0 -7520px!important}.f32 .vi{background-position:0 -7552px!important}.f32 .vn{background-position:0 -7584px!important}.f32 .vu{background-position:0 -7616px!important}.f32 .ws{background-position:0 -7648px!important}.f32 .ye{background-position:0 -7680px!important}.f32 .za{background-position:0 -7712px!important}.f32 .zm,.f32 .zw{background-position:0 -7744px!important}.f32 .iana{background-position:0 -7808px!important}.f32 .ap{background-position:0 -7840px!important}", ""]);
	
	// exports


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c489e115d3c30bfd6a067905261717b.png";

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(354);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!./flags16-bw.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!./flags16-bw.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".f16-bw .flag{display:inline-block;height:16px;width:16px;vertical-align:text-top;line-height:16px;background:url(" + __webpack_require__(355) + ") no-repeat}.f16-bw ._African_Union{background-position:0 -16px}.f16-bw ._Arab_League{background-position:0 -32px}.f16-bw ._ASEAN{background-position:0 -48px}.f16-bw ._CARICOM{background-position:0 -64px}.f16-bw ._CIS{background-position:0 -80px}.f16-bw ._Commonwealth{background-position:0 -96px}.f16-bw ._England{background-position:0 -112px}.f16-bw ._European_Union,.f16-bw .eu{background-position:0 -128px}.f16-bw ._Islamic_Conference{background-position:0 -144px}.f16-bw ._Kosovo{background-position:0 -160px}.f16-bw ._NATO{background-position:0 -176px}.f16-bw ._Northern_Cyprus{background-position:0 -192px}.f16-bw ._Northern_Ireland{background-position:0 -208px}.f16-bw ._Olimpic_Movement{background-position:0 -224px}.f16-bw ._OPEC{background-position:0 -240px}.f16-bw ._Red_Cross{background-position:0 -256px}.f16-bw ._Scotland{background-position:0 -272px}.f16-bw ._Somaliland{background-position:0 -288px}.f16-bw ._Tibet{background-position:0 -304px}.f16-bw ._United_Nations{background-position:0 -320px}.f16-bw ._Wales{background-position:0 -336px}.f16-bw .ad{background-position:0 -352px}.f16-bw .ae{background-position:0 -368px}.f16-bw .af{background-position:0 -384px}.f16-bw .ag{background-position:0 -400px}.f16-bw .ai{background-position:0 -416px}.f16-bw .al{background-position:0 -432px}.f16-bw .am{background-position:0 -448px}.f16-bw .ao{background-position:0 -464px}.f16-bw .aq{background-position:0 -480px}.f16-bw .ar{background-position:0 -496px}.f16-bw .as{background-position:0 -512px}.f16-bw .at{background-position:0 -528px}.f16-bw .au{background-position:0 -544px}.f16-bw .aw{background-position:0 -560px}.f16-bw .ax{background-position:0 -576px}.f16-bw .az{background-position:0 -592px}.f16-bw .ba{background-position:0 -608px}.f16-bw .bb{background-position:0 -624px}.f16-bw .bd{background-position:0 -640px}.f16-bw .be{background-position:0 -656px}.f16-bw .bf{background-position:0 -672px}.f16-bw .bg{background-position:0 -688px}.f16-bw .bh{background-position:0 -704px}.f16-bw .bi{background-position:0 -720px}.f16-bw .bj{background-position:0 -736px}.f16-bw .bm{background-position:0 -752px}.f16-bw .bn{background-position:0 -768px}.f16-bw .bo{background-position:0 -784px}.f16-bw .br{background-position:0 -800px}.f16-bw .bs{background-position:0 -816px}.f16-bw .bt{background-position:0 -832px}.f16-bw .bw{background-position:0 -848px}.f16-bw .by{background-position:0 -864px}.f16-bw .bz{background-position:0 -880px}.f16-bw .ca{background-position:0 -896px}.f16-bw .cg{background-position:0 -912px}.f16-bw .cf{background-position:0 -928px}.f16-bw .cd{background-position:0 -944px}.f16-bw .ch{background-position:0 -960px}.f16-bw .ci{background-position:0 -976px}.f16-bw .ck{background-position:0 -992px}.f16-bw .cl{background-position:0 -1008px}.f16-bw .cm{background-position:0 -1024px}.f16-bw .cn{background-position:0 -1040px}.f16-bw .co{background-position:0 -1056px}.f16-bw .cr{background-position:0 -1072px}.f16-bw .cu{background-position:0 -1088px}.f16-bw .cv{background-position:0 -1104px}.f16-bw .cy{background-position:0 -1120px}.f16-bw .cz{background-position:0 -1136px}.f16-bw .de{background-position:0 -1152px}.f16-bw .dj{background-position:0 -1168px}.f16-bw .dk{background-position:0 -1184px}.f16-bw .dm{background-position:0 -1200px}.f16-bw .do{background-position:0 -1216px}.f16-bw .dz{background-position:0 -1232px}.f16-bw .ec{background-position:0 -1248px}.f16-bw .ee{background-position:0 -1264px}.f16-bw .eg{background-position:0 -1280px}.f16-bw .eh{background-position:0 -1296px}.f16-bw .er{background-position:0 -1312px}.f16-bw .es{background-position:0 -1328px}.f16-bw .et{background-position:0 -1344px}.f16-bw .fi{background-position:0 -1360px}.f16-bw .fj{background-position:0 -1376px}.f16-bw .fm{background-position:0 -1392px}.f16-bw .fo{background-position:0 -1408px}.f16-bw .bl,.f16-bw .cp,.f16-bw .fr,.f16-bw .mf,.f16-bw .yt{background-position:0 -1424px}.f16-bw .ga{background-position:0 -1440px}.f16-bw .gb,.f16-bw .sh{background-position:0 -1456px}.f16-bw .gd{background-position:0 -1472px}.f16-bw .ge{background-position:0 -1488px}.f16-bw .gg{background-position:0 -1504px}.f16-bw .gh{background-position:0 -1520px}.f16-bw .gi{background-position:0 -1536px}.f16-bw .gl{background-position:0 -1552px}.f16-bw .gm{background-position:0 -1568px}.f16-bw .gn{background-position:0 -1584px}.f16-bw .gp{background-position:0 -1600px}.f16-bw .gq{background-position:0 -1616px}.f16-bw .gr{background-position:0 -1632px}.f16-bw .gt{background-position:0 -1648px}.f16-bw .gu{background-position:0 -1664px}.f16-bw .gw{background-position:0 -1680px}.f16-bw .gy{background-position:0 -1696px}.f16-bw .hk{background-position:0 -1712px}.f16-bw .hn{background-position:0 -1728px}.f16-bw .hr{background-position:0 -1744px}.f16-bw .ht{background-position:0 -1760px}.f16-bw .hu{background-position:0 -1776px}.f16-bw .id,.f16-bw .mc{background-position:0 -1792px}.f16-bw .ie{background-position:0 -1808px}.f16-bw .il{background-position:0 -1824px}.f16-bw .im{background-position:0 -1840px}.f16-bw .in{background-position:0 -1856px}.f16-bw .iq{background-position:0 -1872px}.f16-bw .ir{background-position:0 -1888px}.f16-bw .is{background-position:0 -1904px}.f16-bw .it{background-position:0 -1920px}.f16-bw .je{background-position:0 -1936px}.f16-bw .jm{background-position:0 -1952px}.f16-bw .jo{background-position:0 -1968px}.f16-bw .jp{background-position:0 -1984px}.f16-bw .ke{background-position:0 -2000px}.f16-bw .kg{background-position:0 -2016px}.f16-bw .kh{background-position:0 -2032px}.f16-bw .ki{background-position:0 -2048px}.f16-bw .km{background-position:0 -2064px}.f16-bw .kn{background-position:0 -2080px}.f16-bw .kp{background-position:0 -2096px}.f16-bw .kr{background-position:0 -2112px}.f16-bw .kw{background-position:0 -2128px}.f16-bw .ky{background-position:0 -2144px}.f16-bw .kz{background-position:0 -2160px}.f16-bw .la{background-position:0 -2176px}.f16-bw .lb{background-position:0 -2192px}.f16-bw .lc{background-position:0 -2208px}.f16-bw .li{background-position:0 -2224px}.f16-bw .lk{background-position:0 -2240px}.f16-bw .lr{background-position:0 -2256px}.f16-bw .ls{background-position:0 -2272px}.f16-bw .lt{background-position:0 -2288px}.f16-bw .lu{background-position:0 -2304px}.f16-bw .lv{background-position:0 -2320px}.f16-bw .ly{background-position:0 -2336px}.f16-bw .ma{background-position:0 -2352px}.f16-bw .md{background-position:0 -2368px}.f16-bw .me{background-position:0 -2384px}.f16-bw .mg{background-position:0 -2400px}.f16-bw .mh{background-position:0 -2416px}.f16-bw .mk{background-position:0 -2432px}.f16-bw .ml{background-position:0 -2448px}.f16-bw .mm{background-position:0 -2464px}.f16-bw .mn{background-position:0 -2480px}.f16-bw .mo{background-position:0 -2496px}.f16-bw .mq{background-position:0 -2512px}.f16-bw .mr{background-position:0 -2528px}.f16-bw .ms{background-position:0 -2544px}.f16-bw .mt{background-position:0 -2560px}.f16-bw .mu{background-position:0 -2576px}.f16-bw .mv{background-position:0 -2592px}.f16-bw .mw{background-position:0 -2608px}.f16-bw .mx{background-position:0 -2624px}.f16-bw .my{background-position:0 -2640px}.f16-bw .mz{background-position:0 -2656px}.f16-bw .na{background-position:0 -2672px}.f16-bw .nc{background-position:0 -2688px}.f16-bw .ne{background-position:0 -2704px}.f16-bw .ng{background-position:0 -2720px}.f16-bw .ni{background-position:0 -2736px}.f16-bw .bq,.f16-bw .nl{background-position:0 -2752px}.f16-bw .bv,.f16-bw .no,.f16-bw .nq,.f16-bw .sj{background-position:0 -2768px}.f16-bw .np{background-position:0 -2784px}.f16-bw .nr{background-position:0 -2800px}.f16-bw .nz{background-position:0 -2816px}.f16-bw .om{background-position:0 -2832px}.f16-bw .pa{background-position:0 -2848px}.f16-bw .pe{background-position:0 -2864px}.f16 .iana{background-position:0 -7808px!important}.f16 .ap{background-position:0 -7840px!important}.f16-bw .pf{background-position:0 -2880px}.f16-bw .pg{background-position:0 -2896px}.f16-bw .ph{background-position:0 -2912px}.f16-bw .pk{background-position:0 -2928px}.f16-bw .pl{background-position:0 -2944px}.f16-bw .pr{background-position:0 -2960px}.f16-bw .ps{background-position:0 -2976px}.f16-bw .pt{background-position:0 -2992px}.f16-bw .pw{background-position:0 -3008px}.f16-bw .py{background-position:0 -3024px}.f16-bw .qa{background-position:0 -3040px}.f16-bw .re{background-position:0 -3056px}.f16-bw .ro{background-position:0 -3072px}.f16-bw .rs{background-position:0 -3088px}.f16-bw .ru{background-position:0 -3104px}.f16-bw .rw{background-position:0 -3120px}.f16-bw .sa{background-position:0 -3136px}.f16-bw .sb{background-position:0 -3152px}.f16-bw .sc{background-position:0 -3168px}.f16-bw .sd{background-position:0 -3184px}.f16-bw .se{background-position:0 -3200px}.f16-bw .sg{background-position:0 -3216px}.f16-bw .si{background-position:0 -3232px}.f16-bw .sk{background-position:0 -3248px}.f16-bw .sl{background-position:0 -3264px}.f16-bw .sm{background-position:0 -3280px}.f16-bw .sn{background-position:0 -3296px}.f16-bw .so{background-position:0 -3312px}.f16-bw .sr{background-position:0 -3328px}.f16-bw .st{background-position:0 -3344px}.f16-bw .sv{background-position:0 -3360px}.f16-bw .sy{background-position:0 -3376px}.f16-bw .sz{background-position:0 -3392px}.f16-bw .tc{background-position:0 -3408px}.f16-bw .td{background-position:0 -3424px}.f16-bw .tg{background-position:0 -3440px}.f16-bw .th{background-position:0 -3456px}.f16-bw .tj{background-position:0 -3472px}.f16-bw .tl{background-position:0 -3488px}.f16-bw .tm{background-position:0 -3504px}.f16-bw .tn{background-position:0 -3520px}.f16-bw .to{background-position:0 -3536px}.f16-bw .tr{background-position:0 -3552px}.f16-bw .tt{background-position:0 -3568px}.f16-bw .tv{background-position:0 -3584px}.f16-bw .tw{background-position:0 -3600px}.f16-bw .tz{background-position:0 -3616px}.f16-bw .ua{background-position:0 -3632px}.f16-bw .ug{background-position:0 -3648px}.f16-bw .us{background-position:0 -3664px}.f16-bw .uy{background-position:0 -3680px}.f16-bw .uz{background-position:0 -3696px}.f16-bw .va{background-position:0 -3712px}.f16-bw .vc{background-position:0 -3728px}.f16-bw .ve{background-position:0 -3744px}.f16-bw .vg{background-position:0 -3760px}.f16-bw .vi{background-position:0 -3776px}.f16-bw .vn{background-position:0 -3792px}.f16-bw .vu{background-position:0 -3808px}.f16-bw .ws{background-position:0 -3824px}.f16-bw .ye{background-position:0 -3840px}.f16-bw .za{background-position:0 -3856px}.f16-bw .zm{background-position:0 -3872px}.f16-bw .zw{background-position:0 -3888px}.f16-bw .sx{background-position:0 -3904px}.f16-bw .cw{background-position:0 -3920px}.f16-bw .ss{background-position:0 -3936px}.f16-bw .iana{background-position:0 -7808px!important}.f16-bw .ap{background-position:0 -7840px!important}", ""]);
	
	// exports


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "12955bc959ed23e8412bab6223c29794.png";

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(357);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!./flags32-bw.css", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!./flags32-bw.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".f32-bw .flag{display:inline-block!important;height:32px!important;width:32px!important;vertical-align:text-top!important;line-height:32px!important;background:url(" + __webpack_require__(358) + ") no-repeat!important}.f32-bw ._African_Union(OAS){background-position:0 -32px!important}.f32-bw ._Arab_League{background-position:0 -64px!important}.f32-bw ._ASEAN{background-position:0 -96px!important}.f32-bw ._CARICOM{background-position:0 -128px!important}.f32-bw ._CIS{background-position:0 -160px!important}.f32-bw ._Commonwealth{background-position:0 -192px!important}.f32-bw ._England{background-position:0 -224px!important}.f32-bw .eu{background-position:0 -256px!important}.f32-bw ._Islamic_Conference{background-position:0 -288px!important}.f32-bw ._Kosovo{background-position:0 -320px!important}.f32-bw ._NATO{background-position:0 -352px!important}.f32-bw ._Northern_Cyprus{background-position:0 -384px!important}.f32-bw ._Northern_Ireland{background-position:0 -416px!important}.f32-bw ._Olimpic_Movement{background-position:0 -448px!important}.f32-bw ._OPEC{background-position:0 -480px!important}.f32-bw ._Red_Cross{background-position:0 -512px!important}.f32-bw ._Scotland{background-position:0 -544px!important}.f32-bw ._Somaliland{background-position:0 -576px!important}.f32-bw ._Tibet{background-position:0 -608px!important}.f32-bw ._United_Nations{background-position:0 -640px!important}.f32-bw ._Wales{background-position:0 -672px!important}.f32-bw .ad{background-position:0 -704px!important}.f32-bw .ae{background-position:0 -736px!important}.f32-bw .af{background-position:0 -768px!important}.f32-bw .ag{background-position:0 -800px!important}.f32-bw .ai{background-position:0 -832px!important}.f32-bw .al{background-position:0 -864px!important}.f32-bw .am{background-position:0 -896px!important}.f32-bw .an{background-position:0 -928px!important}.f32-bw .ao{background-position:0 -960px!important}.f32-bw .aq{background-position:0 -992px!important}.f32-bw .ar{background-position:0 -1024px!important}.f32-bw .as{background-position:0 -1056px!important}.f32-bw .at{background-position:0 -1088px!important}.f32-bw .au{background-position:0 -1120px!important}.f32-bw .aw{background-position:0 -1152px!important}.f32-bw .az{background-position:0 -1184px!important}.f32-bw .ba{background-position:0 -1216px!important}.f32-bw .bb{background-position:0 -1248px!important}.f32-bw .bd{background-position:0 -1280px!important}.f32-bw .be{background-position:0 -1312px!important}.f32-bw .bf{background-position:0 -1344px!important}.f32-bw .bg{background-position:0 -1376px!important}.f32-bw .bh{background-position:0 -1408px!important}.f32-bw .bi{background-position:0 -1440px!important}.f32-bw .bj{background-position:0 -1472px!important}.f32-bw .bm{background-position:0 -1504px!important}.f32-bw .bn{background-position:0 -1536px!important}.f32-bw .bo{background-position:0 -1568px!important}.f32-bw .br{background-position:0 -1600px!important}.f32-bw .bs{background-position:0 -1632px!important}.f32-bw .bt{background-position:0 -1664px!important}.f32-bw .bw{background-position:0 -1696px!important}.f32-bw .by{background-position:0 -1728px!important}.f32-bw .bz{background-position:0 -1760px!important}.f32-bw .ca{background-position:0 -1792px!important}.f32-bw .cd{background-position:0 -1824px!important}.f32-bw .cf{background-position:0 -1856px!important}.f32-bw .cg{background-position:0 -1888px!important}.f32-bw .ch{background-position:0 -1920px!important}.f32-bw .ci{background-position:0 -1952px!important}.f32-bw .ck{background-position:0 -1984px!important}.f32-bw .cl{background-position:0 -2016px!important}.f32-bw .cm{background-position:0 -2048px!important}.f32-bw .cn{background-position:0 -2080px!important}.f32-bw .co{background-position:0 -2112px!important}.f32-bw .cr{background-position:0 -2144px!important}.f32-bw .cu{background-position:0 -2176px!important}.f32-bw .cv{background-position:0 -2208px!important}.f32-bw .cy{background-position:0 -2240px!important}.f32-bw .cz{background-position:0 -2272px!important}.f32-bw .de{background-position:0 -2304px!important}.f32-bw .dj{background-position:0 -2336px!important}.f32-bw .dk{background-position:0 -2368px!important}.f32-bw .dm{background-position:0 -2400px!important}.f32-bw .do{background-position:0 -2432px!important}.f32-bw .dz{background-position:0 -2464px!important}.f32-bw .ec{background-position:0 -2496px!important}.f32-bw .ee{background-position:0 -2528px!important}.f32-bw .eg{background-position:0 -2560px!important}.f32-bw .eh{background-position:0 -2592px!important}.f32-bw .er{background-position:0 -2624px!important}.f32-bw .es{background-position:0 -2656px!important}.f32-bw .et{background-position:0 -2688px!important}.f32-bw .fi{background-position:0 -2720px!important}.f32-bw .fj{background-position:0 -2752px!important}.f32-bw .fm{background-position:0 -2784px!important}.f32-bw .fo{background-position:0 -2816px!important}.f32-bw .fr{background-position:0 -2848px!important}.f32-bw .ga{background-position:0 -2880px!important}.f32-bw .gb{background-position:0 -2912px!important}.f32-bw .gd{background-position:0 -2944px!important}.f32-bw .ge{background-position:0 -2976px!important}.f32-bw .gg{background-position:0 -3008px!important}.f32-bw .gh{background-position:0 -3040px!important}.f32-bw .gi{background-position:0 -3072px!important}.f32-bw .gl{background-position:0 -3104px!important}.f32-bw .gm{background-position:0 -3136px!important}.f32-bw .gn{background-position:0 -3168px!important}.f32-bw .gp{background-position:0 -3200px!important}.f32-bw .gq{background-position:0 -3232px!important}.f32-bw .gr{background-position:0 -3264px!important}.f32-bw .gt{background-position:0 -3296px!important}.f32-bw .gu{background-position:0 -3328px!important}.f32-bw .gw{background-position:0 -3360px!important}.f32-bw .gy{background-position:0 -3392px!important}.f32-bw .hk{background-position:0 -3424px!important}.f32-bw .hn{background-position:0 -3456px!important}.f32-bw .hr{background-position:0 -3488px!important}.f32-bw .ht{background-position:0 -3520px!important}.f32-bw .hu{background-position:0 -3552px!important}.f32-bw .id,.f32-bw .mc{background-position:0 -3584px!important}.f32-bw .ie{background-position:0 -3616px!important}.f32-bw .il{background-position:0 -3648px!important}.f32-bw .im{background-position:0 -3680px!important}.f32-bw .in{background-position:0 -3712px!important}.f32-bw .iq{background-position:0 -3744px!important}.f32-bw .ir{background-position:0 -3776px!important}.f32-bw .is{background-position:0 -3808px!important}.f32-bw .it{background-position:0 -3840px!important}.f32-bw .je{background-position:0 -3872px!important}.f32-bw .jm{background-position:0 -3904px!important}.f32-bw .jo{background-position:0 -3936px!important}.f32-bw .jp{background-position:0 -3968px!important}.f32-bw .ke{background-position:0 -4000px!important}.f32-bw .kg{background-position:0 -4032px!important}.f32-bw .kh{background-position:0 -4064px!important}.f32-bw .ki{background-position:0 -4096px!important}.f32-bw .km{background-position:0 -4128px!important}.f32-bw .kn{background-position:0 -4160px!important}.f32-bw .kp{background-position:0 -4192px!important}.f32-bw .kr{background-position:0 -4224px!important}.f32-bw .kw{background-position:0 -4256px!important}.f32-bw .ky{background-position:0 -4288px!important}.f32-bw .kz{background-position:0 -4320px!important}.f32-bw .la{background-position:0 -4352px!important}.f32-bw .lb{background-position:0 -4384px!important}.f32-bw .lc{background-position:0 -4416px!important}.f32-bw .li{background-position:0 -4448px!important}.f32-bw .lk{background-position:0 -4480px!important}.f32-bw .lr{background-position:0 -4512px!important}.f32-bw .ls{background-position:0 -4544px!important}.f32-bw .lt{background-position:0 -4576px!important}.f32-bw .lu{background-position:0 -4608px!important}.f32-bw .lv{background-position:0 -4640px!important}.f32-bw .ly{background-position:0 -4672px!important}.f32-bw .ma{background-position:0 -4704px!important}.f32-bw .md{background-position:0 -4736px!important}.f32-bw .me{background-position:0 -4768px!important}.f32-bw .mg{background-position:0 -4800px!important}.f32-bw .mh{background-position:0 -4832px!important}.f32-bw .mk{background-position:0 -4864px!important}.f32-bw .ml{background-position:0 -4896px!important}.f32-bw .mm{background-position:0 -4928px!important}.f32-bw .mn{background-position:0 -4960px!important}.f32-bw .mo{background-position:0 -4992px!important}.f32-bw .mq{background-position:0 -5024px!important}.f32-bw .mr{background-position:0 -5056px!important}.f32-bw .ms{background-position:0 -5088px!important}.f32-bw .mt{background-position:0 -5120px!important}.f32-bw .mu{background-position:0 -5152px!important}.f32-bw .mv{background-position:0 -5184px!important}.f32-bw .mw{background-position:0 -5216px!important}.f32-bw .mx{background-position:0 -5248px!important}.f32-bw .my{background-position:0 -5280px!important}.f32-bw .mz{background-position:0 -5312px!important}.f32-bw .na{background-position:0 -5344px!important}.f32-bw .nc{background-position:0 -5376px!important}.f32-bw .ne{background-position:0 -5408px!important}.f32-bw .ng{background-position:0 -5440px!important}.f32-bw .ni{background-position:0 -5472px!important}.f32-bw .nl{background-position:0 -5504px!important}.f32-bw .no{background-position:0 -5536px!important}.f32-bw .np{background-position:0 -5568px!important}.f32-bw .nr{background-position:0 -5600px!important}.f32-bw .nz{background-position:0 -5632px!important}.f32-bw .om{background-position:0 -5664px!important}.f32-bw .pa{background-position:0 -5696px!important}.f32-bw .pe{background-position:0 -5728px!important}.f32-bw .pf{background-position:0 -5760px!important}.f32-bw .pg{background-position:0 -5792px!important}.f32-bw .ph{background-position:0 -5824px!important}.f32-bw .pk{background-position:0 -5856px!important}.f32-bw .pl{background-position:0 -5888px!important}.f32-bw .pr{background-position:0 -5920px!important}.f32-bw .ps{background-position:0 -5952px!important}.f32-bw .pt{background-position:0 -5984px!important}.f32-bw .pw{background-position:0 -6016px!important}.f32-bw .py{background-position:0 -6048px!important}.f32-bw .qa{background-position:0 -6080px!important}.f32-bw .re{background-position:0 -6112px!important}.f32-bw .ro{background-position:0 -6144px!important}.f32-bw .rs{background-position:0 -6176px!important}.f32-bw .ru{background-position:0 -6208px!important}.f32-bw .rw{background-position:0 -6240px!important}.f32-bw .sa{background-position:0 -6272px!important}.f32-bw .sb{background-position:0 -6304px!important}.f32-bw .sc{background-position:0 -6336px!important}.f32-bw .sd{background-position:0 -6368px!important}.f32-bw .se{background-position:0 -6400px!important}.f32-bw .sg{background-position:0 -6432px!important}.f32-bw .si{background-position:0 -6464px!important}.f32-bw .sk{background-position:0 -6496px!important}.f32-bw .sl{background-position:0 -6528px!important}.f32-bw .sm{background-position:0 -6560px!important}.f32-bw .sn{background-position:0 -6592px!important}.f32-bw .so{background-position:0 -6624px!important}.f32-bw .sr{background-position:0 -6656px!important}.f32-bw .st{background-position:0 -6688px!important}.f32-bw .sv{background-position:0 -6720px!important}.f32-bw .sy{background-position:0 -6752px!important}.f32-bw .sz{background-position:0 -6784px!important}.f32-bw .tc{background-position:0 -6816px!important}.f32-bw .td{background-position:0 -6848px!important}.f32-bw .tg{background-position:0 -6880px!important}.f32-bw .th{background-position:0 -6912px!important}.f32-bw .tj{background-position:0 -6944px!important}.f32-bw .tl{background-position:0 -6976px!important}.f32-bw .tm{background-position:0 -7008px!important}.f32-bw .tn{background-position:0 -7040px!important}.f32-bw .to{background-position:0 -7072px!important}.f32-bw .tr{background-position:0 -7104px!important}.f32-bw .tt{background-position:0 -7136px!important}.f32-bw .tv{background-position:0 -7168px!important}.f32-bw .tw{background-position:0 -7200px!important}.f32-bw .tz{background-position:0 -7232px!important}.f32-bw .ua{background-position:0 -7264px!important}.f32-bw .ug{background-position:0 -7296px!important}.f32-bw .us{background-position:0 -7328px!important}.f32-bw .uy{background-position:0 -7360px!important}.f32-bw .uz{background-position:0 -7392px!important}.f32-bw .va{background-position:0 -7424px!important}.f32-bw .vc{background-position:0 -7456px!important}.f32-bw .ve{background-position:0 -7488px!important}.f32-bw .vg{background-position:0 -7520px!important}.f32-bw .vi{background-position:0 -7552px!important}.f32-bw .vn{background-position:0 -7584px!important}.f32-bw .vu{background-position:0 -7616px!important}.f32-bw .ws{background-position:0 -7648px!important}.f32-bw .ye{background-position:0 -7680px!important}.f32-bw .za{background-position:0 -7712px!important}.f32-bw .zm,.f32-bw .zw{background-position:0 -7744px!important}.f32-bw .iana{background-position:0 -7808px!important}.f32-bw .ap{background-position:0 -7840px!important}", ""]);
	
	// exports


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7bc12ec4e3c25d032979873ffcd8bfad.png";

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(360);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./ngDialog.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./ngDialog.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes ngdialog-fadeout{0%{opacity:1}to{opacity:0}}@keyframes ngdialog-fadein{0%{opacity:0}to{opacity:1}}.ngdialog{box-sizing:border-box}.ngdialog *,.ngdialog :after,.ngdialog :before{box-sizing:inherit}.ngdialog{position:fixed;overflow:auto;-webkit-overflow-scrolling:touch;z-index:10000;top:0;right:0;bottom:0;left:0}.ngdialog.ngdialog-disabled-animation,.ngdialog.ngdialog-disabled-animation .ngdialog-content,.ngdialog.ngdialog-disabled-animation .ngdialog-overlay{animation:none!important}.ngdialog-overlay{position:fixed;background:rgba(0,0,0,.4);top:0;right:0;bottom:0;left:0;-webkit-backface-visibility:hidden;animation:ngdialog-fadein .5s}.ngdialog-no-overlay{pointer-events:none}.ngdialog.ngdialog-closing .ngdialog-overlay{-webkit-backface-visibility:hidden;animation:ngdialog-fadeout .5s}.ngdialog-content{background:#fff;-webkit-backface-visibility:hidden;animation:ngdialog-fadein .5s;pointer-events:all}.ngdialog.ngdialog-closing .ngdialog-content{-webkit-backface-visibility:hidden;animation:ngdialog-fadeout .5s}.ngdialog-close:before{font-family:Helvetica,Arial,sans-serif;content:\"\\D7\";cursor:pointer}body.ngdialog-open,html.ngdialog-open{overflow:hidden}", ""]);
	
	// exports


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(362);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./ngDialog-theme-default.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./ngDialog-theme-default.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes ngdialog-flyin{0%{opacity:0;transform:translateY(-40px)}to{opacity:1;transform:translateY(0)}}@keyframes ngdialog-flyout{0%{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(-40px)}}.ngdialog.ngdialog-theme-default{padding-bottom:100px;padding-top:100px}.ngdialog.ngdialog-theme-default.ngdialog-closing .ngdialog-content{animation:ngdialog-flyout .5s}.ngdialog.ngdialog-theme-default .ngdialog-content{animation:ngdialog-flyin .5s;background:#f0f0f0;border-radius:5px;color:#444;font-family:Helvetica,sans-serif;font-size:1.1em;line-height:1.5em;margin:0 auto;max-width:100%;padding:1em;position:relative;width:60%}.ngdialog.ngdialog-theme-default .ngdialog-close{border-radius:5px;cursor:pointer;position:absolute;right:0;top:0}.ngdialog.ngdialog-theme-default .ngdialog-close:before{background:transparent;border-radius:3px;color:#bbb;content:\"\\D7\";font-size:26px;font-weight:400;height:30px;line-height:26px;position:absolute;right:3px;text-align:center;top:3px;width:30px}.ngdialog.ngdialog-theme-default .ngdialog-close:active:before,.ngdialog.ngdialog-theme-default .ngdialog-close:hover:before{color:#777}.ngdialog.ngdialog-theme-default .ngdialog-message{margin-bottom:.5em}.ngdialog.ngdialog-theme-default .ngdialog-input{margin-bottom:1em}.ngdialog.ngdialog-theme-default .ngdialog-input input[type=email],.ngdialog.ngdialog-theme-default .ngdialog-input input[type=password],.ngdialog.ngdialog-theme-default .ngdialog-input input[type=text],.ngdialog.ngdialog-theme-default .ngdialog-input input[type=url],.ngdialog.ngdialog-theme-default .ngdialog-input textarea{background:#fff;border:0;border-radius:3px;font-family:inherit;font-size:inherit;font-weight:inherit;margin:0 0 .25em;min-height:2.5em;padding:.25em .67em;width:100%}.ngdialog.ngdialog-theme-default .ngdialog-input input[type=email]:focus,.ngdialog.ngdialog-theme-default .ngdialog-input input[type=password]:focus,.ngdialog.ngdialog-theme-default .ngdialog-input input[type=text]:focus,.ngdialog.ngdialog-theme-default .ngdialog-input input[type=url]:focus,.ngdialog.ngdialog-theme-default .ngdialog-input textarea:focus{box-shadow:inset 0 0 0 2px #8dbdf1;outline:none}.ngdialog.ngdialog-theme-default .ngdialog-buttons{*zoom:1}.ngdialog.ngdialog-theme-default .ngdialog-buttons:after{content:\"\";display:table;clear:both}.ngdialog.ngdialog-theme-default .ngdialog-button{border:0;border-radius:3px;cursor:pointer;float:right;font-family:inherit;font-size:.8em;letter-spacing:.1em;line-height:1em;margin:0 0 0 .5em;padding:.75em 2em;text-transform:uppercase}.ngdialog.ngdialog-theme-default .ngdialog-button:focus{animation:ngdialog-pulse 1.1s infinite;outline:none}@media (max-width:568px){.ngdialog.ngdialog-theme-default .ngdialog-button:focus{animation:none}}.ngdialog.ngdialog-theme-default .ngdialog-button.ngdialog-button-primary{background:#3288e6;color:#fff}.ngdialog.ngdialog-theme-default .ngdialog-button.ngdialog-button-secondary{background:#e0e0e0;color:#777}", ""]);
	
	// exports


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(364);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./login.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./login.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".login{background-color:#232323!important}.login .logo{width:247px;margin:0 auto;margin-top:60px;padding:15px;text-align:center}.login .content{background-color:none;width:291px;margin:0 auto;margin-bottom:0;padding:30px;padding-top:20px;padding-bottom:15px}.login .content .m-wrap{width:249px;border:0!important;background:#d2d2d2}.login .content .input-icon{border-left:3px solid #00ba53!important}.login .content .control-group{margin-bottom:30px!important}.login .content .control-group .fa{color:#818181}.login .content .input-icon .m-wrap{margin:0!important;font-family:roboto-reg;font-size:.9rem}.login .copyright{text-align:center;width:250px;margin:0 auto;padding:10px 10px 0;color:#818181;font-size:11px}@media (max-width:480px){.login .logo{margin-top:10px}.login .content{padding:30px;width:222px}.login .content h3{font-size:22px}.login .content .m-wrap{width:180px}.login .checkbox{font-size:13px}}.btnLogin2015{cursor:pointer;width:auto;min-width:88px;border:0;border-radius:2px;padding:8px 18px;background-color:#00ba53;box-shadow:0 2px 3px #0d0d0d;font-family:roboto-reg;font-size:.875rem;text-align:center}.btnCircle2015:focus,.btnLogin2015:hover{box-shadow:0 3px 4px #030303}.btnLogin2015:active{box-shadow:0 4px 6px #030303}.LoginCtrl{text-align:center}.LoginCtrl a{color:#a8a8a8!important;font-family:roboto-reg}", ""]);
	
	// exports


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(366);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!./changelog.css", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!./changelog.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".changelog{background-color:#232323!important}.changelog .logo{width:247px;margin:0 auto;margin-top:60px;padding:15px;text-align:center}.changelog .content{background-color:#fff;width:70%;margin:0 auto;margin-bottom:0;padding:30px;padding-top:20px;padding-bottom:15px}.changelog .copyright{text-align:center;width:250px;margin:0 auto;padding:10px 10px 0;color:#818181;font-size:11px}.changelogCtrl a{font-family:roboto-reg}.changelogCtrl .pageTitle{font-size:34px;margin:0 0 30px;line-height:34px}.changelog < ul < li{margin-bottom:30px}#loadMore{background-color:#e54d42;box-shadow:0 6px 0 #c34238;color:#fff;width:100%;cursor:pointer;display:block;text-decoration:none;border-bottom:0;padding:12px 0;margin:50px auto;position:relative;font-weight:700;font-size:20px;text-align:center;border-radius:4px;opacity:1}#loadMore:hover{opacity:.9;top:2px;box-shadow:0 4px 0 #c34238}", ""]);
	
	// exports


/***/ },
/* 367 */
[1590, 368],
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Open Sans;src:url(" + __webpack_require__(369) + ")}@font-face{font-family:ITCAvantGardeStd-Bk;src:url(" + __webpack_require__(370) + ");src:url(" + __webpack_require__(371) + ") format(\"woff\"),url(" + __webpack_require__(372) + ") format(\"truetype\"),url(" + __webpack_require__(373) + ") format(\"svg\")}@font-face{font-family:ITCAvantGardeStd-Bold;src:url(" + __webpack_require__(374) + ");src:url(" + __webpack_require__(375) + ") format(\"woff\"),url(" + __webpack_require__(376) + ") format(\"truetype\"),url(" + __webpack_require__(377) + ") format(\"svg\")}@font-face{font-family:roboto-reg;src:url(" + __webpack_require__(378) + ")}@font-face{font-family:roboto-light;src:url(" + __webpack_require__(379) + ")}@font-face{font-family:roboto-medium;src:url(" + __webpack_require__(380) + ")}@font-face{font-family:roboto-bold;src:url(" + __webpack_require__(381) + ")}@font-face{font-family:roboto-reg-cond;src:url(" + __webpack_require__(382) + ")}h1,h2,h3,h4,h5{font-family:inherit;font-weight:700;line-height:20px;margin:10px 0;color:inherit;text-rendering:optimizelegibility;font-weight:300}h1{font-family:roboto-reg;font-size:1.4rem;text-align:left;white-space:nowrap;color:#323232}h2{font-size:31.5px}h3{font-family:roboto-reg;font-size:1.05rem;padding:10px 0;text-align:left;white-space:nowrap;color:#323232}h4{font-size:17.5px}h5{font-size:14px}h1 small,h2 small,h5 small{font-weight:400;line-height:1;color:#999}h3 small,h4 small{color:#444;font-size:14px}h1 small{font-size:24.5px}h2 small{font-size:17.5px}img{width:auto\\9;max-width:100%;height:auto;vertical-align:middle;-ms-interpolation-mode:bicubic;border:0}p{margin:0 0 10px}a{color:#383e4b;text-shadow:none!important;outline:0}a:active,a:focus,a:hover{outline:0!important;outline:none!important}a.badge:focus,a.badge:hover,a.label:focus,a.label:hover{cursor:pointer;text-decoration:none;color:#fff}a.muted:focus,a.muted:hover{color:gray}a.text-warning:focus,a.text-warning:hover{color:#a47e3c}ul{margin:0 0 10px 25px;padding:0}ol ul,ul ol,ul ul{margin-bottom:0}dd,dt,li{line-height:20px}dt{font-weight:700}dd{margin-left:10px}strong{font-weight:700}em{font-style:italic}audio,video{display:inline-block;*display:inline;*zoom:1}audio:not([controls]){display:none}sub{font-size:75%;line-height:0;position:relative;bottom:-.25em;vertical-align:baseline}blockquote p{font-size:17.5px;font-weight:300;line-height:1.25;margin-bottom:0}blockquote small:before{content:\"\\2014\\A0\"}blockquote.pull-right{float:right;padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0}blockquote.pull-right p,blockquote.pull-right small{text-align:right}blockquote.pull-right small:before{content:\"\"}blockquote.pull-right small:after{content:\"\\A0\\2014\"}blockquote:after,blockquote:before,q:after,q:before{content:\"\"}address{font-style:normal;line-height:20px;display:block;margin-bottom:20px}code{font-family:Monaco,Menlo,Consolas,Courier New,monospace;font-size:12px;padding:0 3px 2px;padding:2px 4px;white-space:nowrap;color:#333;color:#d14;border:1px solid #e1e1e8;border-radius:3px;background-color:#f7f7f9}pre code{padding:0;white-space:pre;white-space:pre-wrap;color:inherit;border:0;background-color:transparent}.item{cursor:default;pointer-events:auto}.sub{font-size:smaller;position:absolute!important;z-index:999999!important;display:block!important;overflow:hidden!important;padding-top:5px;padding-left:10px;color:#777}.err{font-size:12px;margin:15px;padding:15px;color:#c53f00;border:1px solid #000;background-color:#f0f0f0}.well{border:1px solid #eee;border-radius:0;background-color:#fafafa;box-shadow:none!important}.center-item{text-align:center}.tab{float:left;width:15%;height:350px;overflow:auto}.tab button{display:block;background-color:inherit;color:#000;padding:9px 25px;width:100%;outline:none;text-align:left;cursor:pointer;transition:.3s}.tab button:hover{background-color:#00ff73}.tab button.active{background-color:#00ba53}.tabcontent{float:left;padding:1% 12px;width:80%}.flex-contianer{display:flex;justify-content:space-between;height:200px;border:1px solid red}.col-md-1{-ms-flex:0 0 8.333333%;flex:0 0 8.333333%;max-width:8.333333%}.col-md-2{-ms-flex:0 0 16.666667%;flex:0 0 16.666667%;max-width:16.666667%}.col-md-3{-ms-flex:0 0 25%;flex:0 0 25%;max-width:25%}.col-md-4{-ms-flex:0 0 33.333333%;flex:0 0 33.333333%;max-width:33.333333%}.col-md-5{-ms-flex:0 0 41.666667%;flex:0 0 41.666667%;max-width:41.666667%}.col-md-6{-ms-flex:0 0 50%;flex:0 0 50%;max-width:50%}.col-md-7{-ms-flex:0 0 58.333333%;flex:0 0 58.333333%;max-width:58.333333%}.col-md-8{-ms-flex:0 0 66.666667%;flex:0 0 66.666667%;max-width:66.666667%}.col-md-9{-ms-flex:0 0 75%;flex:0 0 75%;max-width:75%}.col-md-10{-ms-flex:0 0 83.333333%;flex:0 0 83.333333%;max-width:83.333333%}.col-md-11{-ms-flex:0 0 91.666667%;flex:0 0 91.666667%;max-width:91.666667%}.col-md-12{-ms-flex:0 0 100%;flex:0 0 100%;max-width:100%}div[class^=col-md] input,div[class^=col-md] select{width:auto}.input-row{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-15px}.collapsible{background-color:#00ba53;cursor:pointer;padding:10px;width:100%;border:none;text-align:left;outline:none;font-size:15px}.collapsible:hover,button[id=modalCollapse]>.active{background-color:#00ff73}.collapsible:after{content:\"\\25BE\";font-weight:700;float:right;margin-left:5px}.collapsible.active:after{content:\"\\2212\"}.collapse-content{padding:0 18px;max-height:0;overflow:hidden;transition:max-height .2s ease-out;background-color:#f1f1f1}input[name=input80]{width:80%}div#regexModal.modal{display:none;position:fixed;z-index:1;width:50%;overflow:auto}div#regexModal>.modal-body{max-height:300px}div#regexModal>.modal-footer{box-shadow:none;background-color:transparent;border-top:none}.repeatedN{background-color:#ca3c3c!important;color:#fff!important}.repeatedR{background-color:#3c4aca!important;color:#fff!important}.color-guarded{color:#fff;background-color:#377fc7}.color-elevated{color:#000;background-color:#f5d800}.color-high{color:#000;background-color:#f88b12}.color-severe{color:#fff;background-color:#ff3131}.tabs{position:relative;background:#fff;padding-bottom:1%}.tabs input[name=tab-control]{display:none}.tabs .content section h2,.tabs ul li label{font-weight:700;font-size:18px;color:#008c41}.tabs ul{list-style-type:none;padding-left:0;display:flex;flex-direction:row;margin-bottom:10px;justify-content:space-between;align-items:flex-end;flex-wrap:wrap}.tabs ul li{box-sizing:border-box;flex:1;width:25%;padding:0 10px;text-align:center}.tabs ul li label{transition:all .3s ease-in-out;color:#929daf;padding:5px auto;overflow:hidden;text-overflow:ellipsis;display:block;cursor:pointer;transition:all .2s ease-in-out;white-space:nowrap;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tabs ul li label br{display:none}.tabs ul li label svg{fill:#929daf;height:1.2em;vertical-align:bottom;margin-right:.2em;transition:all .2s ease-in-out}.tabs ul li label:active,.tabs ul li label:focus,.tabs ul li label:hover{outline:0;color:#bec5cf}.tabs ul li label:active svg,.tabs ul li label:focus svg,.tabs ul li label:hover svg{fill:#bec5cf}.tabs .slider{position:relative;width:33%;transition:all .33s cubic-bezier(.38,.8,.32,1.07)}.tabs .slider .indicator{position:relative;max-width:100%;margin:0 auto;height:3px;background:#008c41;border-radius:1px}.tabs .content{margin-top:0}.tabs .content section{display:none;animation-name:content;animation-direction:normal;animation-duration:.3s;animation-timing-function:ease-in-out;animation-iteration-count:1;line-height:1.4}.tabs .content section h2{color:#00ba57;display:none}.tabs .content section h2:after{content:\"\";position:relative;display:block;width:30px;height:3px;background:#00ba57;margin-top:5px;left:1px}@media (max-width:600px){.tabs input[name=tab-control]:first-of-type:checked ~ ul>li:nth-child(1)>label{background:rgba(0,0,0,.08)}}.tabs input[name=tab-control]:first-of-type:checked ~ .slider{transform:translateX(0)}.tabs input[name=tab-control]:first-of-type:checked ~ .content>section:nth-child(1){display:block}.tabs input[name=tab-control]:first-of-type:checked ~ ul>li:nth-child(1)>label{cursor:default;color:#008c41}@media (max-width:600px){.tabs input[name=tab-control]:nth-of-type(2):checked~ul>li:nth-child(2)>label{background:rgba(0,0,0,.08)}}.tabs input[name=tab-control]:nth-of-type(2):checked~.slider{transform:translateX(100%)}.tabs input[name=tab-control]:nth-of-type(2):checked~.content>section:nth-child(2){display:block}.tabs input[name=tab-control]:nth-of-type(2):checked~ul>li:nth-child(2)>label{cursor:default;color:#008c41}@media (max-width:600px){.tabs input[name=tab-control]:nth-of-type(3):checked~ul>li:nth-child(3)>label{background:rgba(0,0,0,.08)}}.tabs input[name=tab-control]:nth-of-type(3):checked~.slider{transform:translateX(200%)}.tabs input[name=tab-control]:nth-of-type(3):checked~.content>section:nth-child(3){display:block}.tabs input[name=tab-control]:nth-of-type(3):checked~ul>li:nth-child(3)>label{cursor:default;color:#008c41}@keyframes content{0%{opacity:0;transform:translateY(5%)}to{opacity:1;transform:translateY(0)}}@media (max-width:1000px){.tabs ul li label{white-space:normal}.tabs ul li label br{display:initial}.tabs ul li label svg{height:1.5em}}@media (max-width:600px){.tabs ul li label{padding:5px;border-radius:5px}.tabs .slider,.tabs ul li label span{display:none}.tabs .content{margin-top:20px}.tabs .content section h2{display:block}}.checkbox-container{top:50%;left:50%;font-family:Helvetica Neue,Helvetica,Arial,sans-serif}.checkbox-container input[type=checkbox]{display:none}.checkbox-container label{cursor:pointer;display:inline-block}.checkbox-container .checkbox{display:inline-block;width:15px;height:15px;padding-left:1%;background:#d0d0d0}.checkbox-container .checkbox:after{content:\"\";position:absolute;width:0;height:3px;background:#008c41;transform:translate(4px,11px) rotate(-45deg);transform-origin:left;transition:all .15s;transition-delay:0ms}.checkbox-container .checkbox:before{content:\"\";position:absolute;width:0;height:3px;background:#008c41;transform:translate(1px,6px) rotate(45deg);transform-origin:left;transition:all .15s;transition-delay:.15s}.checkbox-container input[type=checkbox]:checked~.checkbox:before{width:7px;transition-delay:0ms}.checkbox-container input[type=checkbox]:checked~.checkbox:after{width:13px;transition-delay:.15s}div#checkbox-container>.checkbox{min-height:20px;padding-left:1%}.searchbar{background-color:#fff;width:30vw;line-height:25px;margin-top:3px;padding:5px 3px;height:25px;border-radius:1px;position:absolute;left:60%;transform:translateX(-50%)}.searchbar *{box-sizing:border-box}.searchbar .filters-container{position:relative;left:-6px}.searchbar .filters-container .hidden{opacity:0}.searchbar .filters-container .arrow{position:absolute;top:7px;right:115px;z-index:40}.searchbar .filters-container .arrow:after{content:\"\";display:block;width:11px;height:11px;background-clip:padding-box;background-color:#fff;transform:rotate(45deg)}.searchbar .filters-container .arrow-border{position:absolute;top:6px;right:115px}.searchbar .filters-container .arrow-border:after{content:\"\";display:block;width:12px;height:11px;background-clip:padding-box;background-color:#ccc;transform:rotate(45deg)}.searchbar .filters-container .hint-menu{position:absolute;background-color:#fff;top:11px;right:0;min-width:300px;padding:10px 14px;box-shadow:0 0 5px 0 #eee;border:1px solid #ccc;border-radius:6px}.searchbar .filters-container .hint-menu.with-help{width:360px}.searchbar .filters-container .hint-menu.with-help .help-title{font-weight:600;margin:3px 0 6px}.searchbar .filters-container .hint-menu .section-header{position:relative;margin:2px 0}.searchbar .filters-container .hint-menu .section-header hr{width:100%;top:11px;margin:0!important;position:absolute}.searchbar .filters-container .hint-menu .section-header .header-label{text-transform:capitalize;color:#999;background:#fff;z-index:20;position:relative;padding:0 10px 0 0;font-size:13px;color:#aaa}.searchbar .filters-container .clear_search{padding-top:20px;color:#000;font-weight:700;vertical-align:top}.searchbar .filters-container .clear_search .remove_item{color:#999;cursor:pointer;margin-right:5px;line-height:22px}.searchbar .filters-container .clear_search .remove_item:hover{color:#000}.searchbar .filter-controls{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-radius:3px;-webkit-font-smoothing:antialiased;position:relative;z-index:500;width:30%;display:inline-block;color:#333;cursor:pointer}.searchbar .filter-controls .count{width:60%;padding:0 5px;float:right;text-align:center;background-color:#eee;display:inline-block;transition:width .75s ease;white-space:nowrap;border-radius:2px;cursor:pointer}.searchbar .filter-controls .count span.value{width:100%;visibility:visible;opacity:1;transition:visibility .5s,opacity .5s ease}.searchbar .filter-controls .count.green{background-color:green;margin-right:1px}.searchbar .filter-controls .count.green:hover{background-color:#005c00}.searchbar .filter-controls .count .white{color:#fff;font-weight:700}.searchbar .filter-controls .search{right:62%;width:64px;padding:0 5px;text-align:center;background-color:#ddd;white-space:nowrap;transition:width .75s ease;border-radius:2px;position:absolute}.searchbar .filter-controls .search .search-block i{position:relative;left:50%;transform:translateX(-50%)}.searchbar .filter-controls .search .search-block .search-text{opacity:0}.searchbar .filter-controls .search .divider{opacity:0;position:absolute;left:48%;top:10%;bottom:10%;border-left:1px solid #fff}.searchbar .filter-controls .search .filter-block{opacity:0;height:0}.searchbar .filter-controls .search .filter-block span.filter-text{position:absolute;transform:translateX(-50%);opacity:0}.searchbar .filter-controls .search:hover{width:150px;transition-duration:compact(.4s,false,false,false,false,false,false,false,false,false)}.searchbar .filter-controls .search:hover .divider{transition-delay:compact(.3s,false,false,false,false,false,false,false,false,false);transition-duration:compact(.2s,false,false,false,false,false,false,false,false,false);opacity:1}.searchbar .filter-controls .search:hover .filter-block{opacity:1;width:50%}.searchbar .filter-controls .search:hover .filter-block span.filter-text{transition-delay:compact(.3s,false,false,false,false,false,false,false,false,false);transition-duration:compact(.2s,false,false,false,false,false,false,false,false,false);opacity:1;position:absolute;left:25%}.searchbar .filter-controls .search:hover .search-block{display:inline-block;width:50%;transition-duration:compact(.4s,false,false,false,false,false,false,false,false,false);transform:translateX(0)}.searchbar .filter-controls .search:hover .search-block i{left:30%}.searchbar .filter-controls .search:hover .search-block .search-text{opacity:1;transform:translateX(50%);position:absolute}.searchbar .filter-controls .search-static{right:62%;width:64px;padding:0 5px;text-align:center;background-color:#ddd;white-space:nowrap;transition:width .75s ease;border-radius:2px;position:absolute}.searchbar .filter-controls .search-static:hover{background-color:#aaa}.searchbar .filter-controls .search-static .search-block i{position:relative;left:50%;transform:translateX(-50%)}.searchbar .filter-controls .search-static .search-block .search-text{opacity:0}.searchbar .search-input{-webkit-font-smoothing:antialiased;position:relative;width:70%;z-index:500;float:left;border-radius:6px;display:inline-block;color:#333}.searchbar .search-input input.main-input{height:25px;width:100%;font-size:18px;border:none;overflow:hidden;background:transparent;margin:0;padding:0 8px;outline:none;z-index:2;letter-spacing:0;word-spacing:0;position:relative;font-family:Arial,sans-serif;direction:ltr;box-shadow:none}.searchbar .search-input input.main-input:focus{outline:none}.searchbar .search-input .background-container{color:transparent;position:absolute;left:0;right:0;top:0;z-index:1;outline:0 none #555459;font-size:18px;font-family:Arial,sans-serif;letter-spacing:0;word-spacing:0;margin:3px 8px 0;white-space:pre;overflow:hidden}.searchbar .search-input .background-container .hint-value{color:#ccc}.searchbar .search-input .hint-menu-container{position:relative;left:-6px}.searchbar .search-input .hint-menu-container.hidden{display:none}.searchbar .search-input .hint-menu-container .arrow{position:absolute;top:7px;left:20px;z-index:40}.searchbar .search-input .hint-menu-container .arrow:after{content:\"\";display:block;width:11px;height:11px;background-clip:padding-box;background-color:#fff;transform:rotate(45deg)}.searchbar .search-input .hint-menu-container .arrow-border{position:absolute;top:6px;left:20px}.searchbar .search-input .hint-menu-container .arrow-border:after{content:\"\";display:block;width:12px;height:11px;background-clip:padding-box;background-color:#ccc;transform:rotate(45deg)}.searchbar .search-input .hint-menu-container .hint-menu{position:absolute;background-color:#fff;top:11px;left:0;min-width:300px;padding:10px 14px;box-shadow:0 0 5px 0 #eee;border:1px solid #ccc;border-radius:6px}.searchbar .search-input .hint-menu-container .hint-menu.with-help{width:360px}.searchbar .search-input .hint-menu-container .hint-menu.with-help .help-title{font-weight:600;margin:3px 0 6px}.searchbar .search-input .hint-menu-container .hint-menu .section-header{position:relative;margin:2px 0}.searchbar .search-input .hint-menu-container .hint-menu .section-header hr{width:100%;top:11px;margin:0!important;position:absolute}.searchbar .search-input .hint-menu-container .hint-menu .section-header .header-label{text-transform:capitalize;color:#999;background:#fff;z-index:20;position:relative;padding:0 10px 0 7px;font-size:13px;color:#aaa}.searchbar .search-input .background-container .modifier,.searchbar .search-input .hint-menu.with-help .modifier{position:relative;z-index:10}.searchbar .search-input .background-container .modifier.incomplete:before,.searchbar .search-input .hint-menu.with-help .modifier.incomplete:before{right:0;border-color:#ffdcb1;background:#ffebaa;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#ffebaa),color-stop(1,#fff9dc));border-right:none;border-top-right-radius:0;border-bottom-right-radius:0}.searchbar .search-input .background-container .modifier:before,.searchbar .search-input .hint-menu.with-help .modifier:before{content:\" \";position:absolute;top:-1px;left:0;z-index:-1;right:-1px;bottom:0;display:block;box-sizing:border-box;border-radius:5px;border:1px solid #8cd5b7;background:#e5f4ee;background:-webkit-gradient(linear,left bottom,left top,color-stop(0,#ccecdf),color-stop(1,#e9f6f1))}.searchbar .search-input .hint-menu.with-help .modifier{cursor:pointer;border-radius:3px}.filters-container ul.search-input-list{margin:0;padding:0;list-style-type:none;overflow-y:auto;position:relative;max-height:200px;display:block}.filters-container ul.search-input-list li{margin:0;padding:2px 8px 2px 0;border-radius:3px;float:none;vertical-align:top}.filters-container ul.search-input-list li .modifier-value{color:#aaa}.filters-container ul.search-input-list li .remove_item{margin-right:5px;cursor:pointer;color:#999;line-height:20px}.filters-container ul.search-input-list li .remove_item:hover{color:#000}.filters-container ul.search-input-list li.selected,.filters-container ul.search-input-list li:hover{background-color:#f7f7f7}.filters-container ul.search-input-list li.current{background-color:#399eff;color:#fff}.filters-container ul.search-input-list li.current .modifier-value{color:#ddd}.filters-container ul.search-input-list li:nth-of-type(2){float:none}.sBar{width:600px;margin:5px auto 0;border:1px solid #aaa;border-radius:3px;background-color:#fff}.sBar .searchButtons{float:right;width:20%}.sBar .searchText{float:left;overflow-y:auto;width:80%;min-height:30px;max-height:42px}input.searchInput{float:left;width:150px;min-width:0;height:30px;margin:0;padding:0;border:0;outline:0;background:transparent}.search-field,.term-list{border-radius:3px}.searchBtn{float:right;margin:2px;padding:3px;cursor:pointer;-webkit-border-radius:3px;-moz-border-radius:3px;background-color:#ccc}div[action=include]{background-color:#90c695}div[action=exclude],div[action=include]{float:left;margin:3px 0 0 3px;padding:2px;-webkit-border-radius:3px;-moz-border-radius:3px}div[action=exclude]{background-color:#f22613}.closeSearchObj{padding:1px;opacity:.7}.closeSearchObj:hover{cursor:pointer;opacity:1}button{font-size:.7rem!important;width:auto;min-width:60px;padding:7px 10px 5px;cursor:pointer;text-align:center;letter-spacing:.6px;border:0;border-radius:4px;background-color:#ccc;font-size:smaller;margin:0;box-shadow:0 2px 3px #7e7e7e}button.rndCrnBtn{border-radius:5px}button.epbRed:active,button.epbRed:hover{background:red!important}button.epbGreen:active,button.epbGreen:hover{background:#0f0}button.epbGrey:active,button.epbGrey:hover{background:#666}button.right{float:right}button.close{padding:0;cursor:pointer;border:0;background:transparent;-webkit-appearance:none}.btn-primary{color:#fff;border-color:#04c #04c #002a80;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);background-color:#006dcc;background-image:linear-gradient(180deg,#08c,#04c);background-repeat:repeat-x;text-shadow:0 -1px 0 rgba(0,0,0,.25);*background-color:#04c}.btn-primary.active,.btn-primary.disabled,.btn-primary:active,.btn-primary:focus,.btn-primary:hover,.btn-primary[disabled]{color:#fff;background-color:#04c;*background-color:#003bb3}.btn-primary.active,.btn-primary:active{background-color:#039\\9}.btn-primary.active{color:hsla(0,0%,100%,.75)}.btn-primary .caret{border-top-color:#fff;border-bottom-color:#fff}.pure-button{font-family:inherit;font-size:100%;line-height:normal;display:inline-block;zoom:1;padding:.5em 1em;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-align:center;vertical-align:baseline;white-space:nowrap;text-decoration:none;color:#444;color:rgba(0,0,0,.8);border:1px solid #999;border:0 transparent;border-radius:4px;background-color:#e6e6e6;*display:inline;-webkit-user-drag:none;*font-size:90%;*overflow:visible;*color:#444}.pure-button::-moz-focus-inner{padding:0;border:0}.pure-button:focus,.pure-button:hover{background-image:linear-gradient(transparent,rgba(0,0,0,.05) 40%,rgba(0,0,0,.1))}.pure-button:focus{outline:0}.pure-button:active{box-shadow:inset 0 0 0 1px rgba(0,0,0,.15),inset 0 0 6px rgba(0,0,0,.2)}.pure-button[disabled]{cursor:not-allowed;opacity:.4;border:0;background-image:none;box-shadow:none;-khtml-opacity:.4;-moz-opacity:.4}.button-error{color:#fff!important;border-radius:4px!important;text-shadow:0 1px 1px rgba(0,0,0,.2)!important}.button-success{background:#1cb841!important;color:#fff}.button-error{background:#ca3c3c!important}.btnRaised2015{font-family:roboto-reg;font-size:.7rem;width:auto;min-width:60px;padding:7px 10px 5px;cursor:pointer;text-align:center;letter-spacing:.6px;border:0;border-radius:2px;background-color:#ccc;box-shadow:0 2px 3px #7e7e7e}.btnRaised2015:focus,.btnRaised2015:hover{box-shadow:0 3px 4px #888}.btnRaised2015:active{box-shadow:0 4px 6px #888}.btnArchive2015{font-family:roboto-reg;font-size:.7rem;width:auto;min-width:60px;padding:7px 10px 5px;cursor:pointer;text-align:center;letter-spacing:.6px;color:#fff;border:0;border-radius:2px;background-color:#bc272e;box-shadow:0 2px 3px #7e7e7e}.btnArchive2015:hover{box-shadow:0 3px 4px #888}.btnArchive2015:active{box-shadow:0 4px 6px #888}.btnRestore2015{font-family:roboto-reg;font-size:.7rem;width:auto;min-width:60px;padding:7px 10px 5px;cursor:pointer;text-align:center;letter-spacing:.6px;color:#fff;border:0;border-radius:2px;background-color:#17b02b;box-shadow:0 2px 3px #7e7e7e}.btnRestore2015:hover{box-shadow:0 3px 4px #888}.btnRestore2015:active{box-shadow:0 4px 6px #888}.btnTableDate2015{font-family:roboto-light;font-size:.7rem;line-height:18px;float:left;width:auto;min-width:60px;max-width:150px;padding:7px 10px 5px;cursor:pointer;text-align:center;letter-spacing:.6px;color:#fff;border:0;border-radius:2px;background-color:#37a9d5;box-shadow:0 2px 3px #7e7e7e}.btnTableDate2015:hover{box-shadow:0 3px 4px #888}.btnTableDate2015:active{box-shadow:0 4px 6px #888}.support-button{position:fixed;right:0;bottom:0;padding:8px;background-color:#232323}.support-button .support-text{color:#fff}.support-button .support-text:hover{cursor:pointer;color:#fff;text-decoration:underline}.buttonHolder{text-align:center}.resetButton{margin-right:5px;color:#b3b3b3;border:0;background:#4e4e4e;box-shadow:0 2px 3px #242424}.resetButton:focus,.resetButton:hover{box-shadow:0 3px 4px #000}.prevButton{margin-right:5px;color:#070707;border:0;background:#666;box-shadow:0 2px 3px #242424}.prevButton:focus,.prevButton:hover{box-shadow:0 3px 4px #000}.saveToggle{margin-right:5px;color:#070707;border:0;background:#a8730b;box-shadow:0 2px 3px #242424}.saveToggle:focus,.saveToggle:hover{box-shadow:0 3px 4px #000}.qMarkButton{margin-right:5px;border:0;background:#888;box-shadow:0 2px 3px #242424}.qMarkButton:focus,.qMarkButton:hover{box-shadow:0 3px 4px #000}.prevButton:disabled,.qMarkButton:disabled,.resetButton:disabled,.saveToggle:disabled{background:#ccc;box-shadow:none;color:#888;cursor:default}.prevButton:disabled:hover,.qMarkButton:disabled:hover,.resetButton:disabled:hover,.saveToggle:disabled:hover{box-shadow:none;cursor:default}#force-table{position:relative;right:30px;float:right;margin-bottom:-100%}#forcechartinfo{overflow:auto;height:650px;margin-left:0}#forcechartinfo table{width:100%}#forcechartinfo table tr:nth-child(odd){background-color:#ddd}#forcechartinfo table tr td{font-size:12px;margin:7px 7px 11px;padding:7px}#stealthforcechart,#stealthforcechart svg{height:90%!important}.node{border:1px solid #f0f!important}.conn{font:10px sans-serif;fill:#000}.conn_link{fill:none;stroke:#ccc;stroke-width:1.5px}.drag{opacity:.3}.chord{fill-opacity:.67}.chordlabel{font-size:15px!important}#chordchartinfo{overflow:scroll;height:650px;margin-left:0}#chordchartinfo table{width:100%}#chordchartinfo table tr:nth-child(odd){background-color:#93d1c8}#chordchartinfo table tr td{font-size:12px;margin:7px 7px 11px;padding:7px}.colorHover{height:10px;width:10px;margin:0 3px -1px 0;display:inline-block}.hoverTitle{text-transform:capitalize}.lineChartline{stroke-width:1.5;fill:none}.legendLines{font-size:11px;cursor:pointer}.legendLines.grey{cursor:default!important}.path{animation:dash 1.5s ease-in-out infinite,color 3s ease-in-out infinite;stroke-dasharray:1,200;stroke-dashoffset:0;stroke-linecap:round}.crosshair-h{height:1px;margin-top:-1px;border-top:1px dashed #aaa}.crosshair-v{width:1px;margin-left:-1px;border-left:2px dashed #aaa}.hair{position:absolute;background:0}.hoverChart{cursor:crosshair}.axis{z-index:1000;font-family:sans-serif;font-size:10px;fill:gray;overflow:hidden;elevation:above}.axis .tick text,.axis text{font-family:sans-serif;font-size:10px;fill:#333}.axis line,.axis path{stroke-width:1;fill:none;stroke:#d3d3d3;shape-rendering:crispEdges}.brush{z-index:-999!important;overflow:visible}.brush .extent{stroke:gray;fill:#1e90ff;fill-opacity:.365}.chart{margin-top:20px;fill:#eee}.chart .node,.chart .node:hover{cursor:pointer!important}.grid .tick{opacity:.6!important;background:0;stroke:#d3d3d3;fill:none!important;shape-rendering:crispEdges}.grid path{stroke-width:0;fill:none}.area{opacity:.5;stroke-width:0}#rowchart .row{cursor:pointer}#rowchart.home{margin:40px 0 0 -17px}#sevButtons{margin:0;padding:0}.severity-deselect{transition:opacity .25s ease-in-out;opacity:.4!important}.btnCircle2015{width:100%;margin:5px 0;cursor:pointer;border-radius:2px;outline:0;box-shadow:0 2px 4px #777}.btnCircle2015:focus,.btnCircle2015:hover{box-shadow:0 3px 4px #888}.btnCircle2015:active{box-shadow:0 4px 6px #888}.btnCircle2015.alert4{background-color:#ff3131}.btnCircle2015.alert3{background-color:#f88b12}.btnCircle2015.alert2{background-color:#f5d800}.btnCircle2015.alert1{background-color:#377fc7}.severityHolder2015{position:relative;top:45%;padding-bottom:15px;transform:translateY(-45%)}.severitySvg2015{position:absolute;display:block;float:left;width:20px;padding-left:7px}.severityValues2015{font-family:roboto-reg;font-size:1.05rem;float:right;padding-right:15px}.country{stroke-width:.5px;stroke:#4a4a4a;cursor:pointer}.pie-slice{fill:#fff}#piechart .arc{cursor:pointer}/*!\n * Stylesheet for the Date Range Picker, for use with Bootstrap 2.x\n *\n * Copyright 2013-2015 Dan Grossman ( http://www.dangrossman.info )\n * Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php\n *\n * Built for http://www.improvely.com\n */.datepicker2015{font-family:roboto-medium;font-size:.9rem;margin:16px 0 0;cursor:pointer;color:#2e99cb}.daterangepicker.dropdown-menu{max-width:none;z-index:3000}.daterangepicker.opensleft .calendar,.daterangepicker.opensleft .ranges{float:left;margin:4px}.daterangepicker.openscenter .calendar,.daterangepicker.openscenter .ranges,.daterangepicker.opensright .calendar,.daterangepicker.opensright .ranges{float:right;margin:4px}.daterangepicker .ranges .range_inputs>div{float:left}.daterangepicker .ranges .range_inputs>div:nth-child(2){padding-left:11px}.daterangepicker .calendar.single .calendar-date{border:none}.daterangepicker .daterangepicker_end_input label,.daterangepicker .daterangepicker_start_input label{color:#333;font-size:11px;margin-bottom:2px;text-transform:uppercase;text-shadow:1px 1px 0 #fff}.daterangepicker.dropup{margin-top:-5px}.daterangepicker option.disabled,.daterangepicker td.disabled,.daterangepicker td.off{color:#999}.daterangepicker td.available.today,.daterangepicker td.available:hover,.daterangepicker th.available:hover{background:#eee;border-radius:4px}.daterangepicker td.active,.daterangepicker td.active:hover,.daterangepicker td.today.active{background-color:#006dcc;background-repeat:repeat-x;border-color:#04c #04c #002a80;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);color:#fff;text-shadow:0 -1px 0 rgba(0,0,0,.25);border-radius:4px}.daterangepicker td.week,.daterangepicker th.week{font-size:80%;color:#ccc}.daterangepicker select.monthselect,.daterangepicker select.yearselect{font-size:12px;padding:1px;height:auto;margin:0;cursor:default}.daterangepicker select.monthselect{margin-right:2%;width:56%}.daterangepicker select.yearselect{width:40%}.daterangepicker select.ampmselect,.daterangepicker select.hourselect,.daterangepicker select.minuteselect,.daterangepicker select.secondselect{width:60px;margin-bottom:0}.daterangepicker_start_input{float:left}.daterangepicker_end_input{float:left;padding-left:11px}.daterangepicker_input{margin:5px 0 0 5px}.daterangepicker{position:absolute;top:100px;left:20px;margin-top:1px;padding:4px;border-radius:4px;background:#fff}.daterangepicker .dropdown-menu{z-index:3000;max-width:none}.daterangepicker .ranges{width:160px;text-align:left}.daterangepicker .calendar{display:none;max-width:250px}.daterangepicker.show-calendar .calendar{display:block}.daterangepicker .calendar.single .calendar-date{border:0}.daterangepicker .calendar td,.daterangepicker .calendar th{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;text-align:center;white-space:nowrap}.daterangepicker .ranges input{font-size:11px}.daterangepicker .ranges ul{margin:0;padding:0;list-style:none}.daterangepicker .ranges li{font-size:13px;margin-bottom:8px;padding:3px 12px;cursor:pointer;color:#08c;border:1px solid #f5f5f5;border-radius:5px;background:#f5f5f5}.daterangepicker .ranges li.active,.daterangepicker .ranges li:hover{color:#fff;border:1px solid #08c;background:#08c}.daterangepicker .calendar-date{padding:4px;border:1px solid #ddd;border-radius:4px;background:#fff}.daterangepicker .calendar-time{line-height:30px;margin:8px auto 0;text-align:center}.daterangepicker.opensleft:before{position:absolute;top:-7px;right:9px;display:inline-block;content:\"\";border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);border-left:7px solid transparent}.daterangepicker.opensleft:after{position:absolute;top:-6px;right:10px;display:inline-block;content:\"\";border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.openscenter:before{top:-7px;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);border-left:7px solid transparent}.daterangepicker.openscenter:after,.daterangepicker.openscenter:before{position:absolute;right:0;left:0;display:inline-block;width:0;margin-right:auto;margin-left:auto;content:\"\"}.daterangepicker.openscenter:after{top:-6px;border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.opensright:before{position:absolute;top:-7px;left:9px;display:inline-block;content:\"\";border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);border-left:7px solid transparent}.daterangepicker.opensright:after{position:absolute;top:-6px;left:10px;display:inline-block;content:\"\";border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.daterangepicker.dropup:before{top:auto;bottom:-7px;border-top:7px solid #ccc;border-bottom:initial}.daterangepicker.dropup:after{top:auto;bottom:-6px;border-top:6px solid #fff;border-bottom:initial}.daterangepicker table{width:100%;margin:0}.daterangepicker td,.daterangepicker th{width:20px;height:20px;cursor:pointer;text-align:center;white-space:nowrap;border-radius:4px}.daterangepicker option.disabled,.daterangepicker td.disabled,.daterangepicker td.off{color:#999}.daterangepicker td.available.today,.daterangepicker td.available:hover,.daterangepicker th.available:hover{background:#eee}.daterangepicker td.in-range{background:#ebf4f8}.daterangepicker td.today.active{border-color:#04c #04c #002a80;background-color:#006dcc}.daterangepicker td.active,.daterangepicker td.today.active{color:#fff;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);background-repeat:repeat-x;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.daterangepicker td.active{background-color:#08c!important;background-color:#006dcc}.daterangepicker td.active:hover{color:#fff;border-color:#04c #04c #002a80;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);background-color:#006dcc;background-repeat:repeat-x;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.daterangepicker th.month{width:auto}form{margin:0}button,select{cursor:pointer}button,input{line-height:normal;*overflow:visible}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}button,html input[type=button]{cursor:pointer}button,input,label,select{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:20px;margin:0;vertical-align:middle}label{display:block;margin-bottom:5px}input{width:206px;margin-left:0}input[type=color],input[type=date],input[type=email],input[type=month],input[type=number],input[type=password],input[type=search],input[type=tel],input[type=text],input[type=time],input[type=url],input[type=week]{font-size:14px;line-height:20px;display:inline-block;height:18px;margin-bottom:10px;padding:4px 6px;vertical-align:middle;color:#555;border-radius:4px;border-color:rgba(82,168,236,.8);outline:0;outline:thin dotted\\9;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(82,168,236,.6);transition:border .2s linear,box-shadow .2s linear;border:1px solid #ccc;background-color:#fff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input[type=checkbox][disabled],input[type=checkbox][readonly],input[type=radio][disabled],input[type=radio][readonly]{background-color:transparent}input[type=button],input[type=checkbox],input[type=radio],input[type=reset],input[type=submit]{cursor:pointer}input[type=search]{box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}input[type=checkbox],input[type=radio]{line-height:normal;margin:4px 0 0;margin-top:1px\\9;*margin-top:0}input[type=button],input[type=checkbox],input[type=file],input[type=image],input[type=radio],input[type=reset],input[type=submit]{width:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:thin dotted #333;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}input:-moz-placeholder{color:#999}input.m-wrap{font-family:Segoe UI,Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-weight:400;line-height:20px}input[type=email].m-wrap,input[type=password].m-wrap,input[type=text].m-wrap{font-size:14px;font-weight:400;line-height:20px;height:20px;padding:6px!important;vertical-align:top;color:#333;border-radius:0;outline:0;background:transparent;background-color:#fff;background-image:none!important;box-shadow:none!important;-webkit-appearance:none!important;filter:none!important}input.m-wrap{border:1px solid #e5e5e5}input[type=email].m-wrap:focus,input[type=password].m-wrap:focus,input[type=text].m-wrap:focus{border-color:#999;outline:0!important;box-shadow:none}input[disabled]{cursor:not-allowed;background-color:#f4f4f4!important}input[type=file]{width:6.3em \\0/IE9;height:1.5em;margin:5px}input[multiple]{width:6.2em \\0/IE9}select{font-size:14px;line-height:20px;display:inline-block;height:20px;margin-bottom:10px;padding:4px 6px;vertical-align:middle;color:#555;border-radius:4px;width:220px;border:1px solid #ccc;background-color:#fff}select[multiple],select[size]{height:auto}select:focus{outline:thin dotted #333;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}input[type=file],select{line-height:30px;height:30px;*margin-top:4px}textarea:focus{border-color:rgba(82,168,236,.8);outline:0;outline:thin dotted\\9;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(82,168,236,.6)}input:-ms-input-placeholder,input::-webkit-input-placeholder,textarea:-moz-placeholder,textarea:-ms-input-placeholder,textarea::-webkit-input-placeholder{color:#999}.checkbox,.radio{min-height:20px;padding-left:20px}.checkbox input[type=checkbox],.radio input[type=radio]{float:left;margin-left:-20px}.controls>.checkbox:first-child,.controls>.radio:first-child{padding-top:5px}input[class*=span],select[class*=span],textarea[class*=span]{float:none;margin-left:0}.row-fluid input[class*=span],.row-fluid select[class*=span],.row-fluid textarea[class*=span]{display:inline-block;float:none;margin-left:0}.row-fluid .checkbox[class*=span],.row-fluid .radio[class*=span]{padding-top:5px}input[disabled],input[readonly],select[disabled],select[readonly]{cursor:not-allowed;background-color:#eee}.control-group.warning input:focus,.control-group.warning select:focus,.control-group.warning textarea:focus{border-color:#a47e3c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #dbc59e}.control-group.error .checkbox,.control-group.error .control-label,.control-group.error .help-block,.control-group.error .radio,.control-group.error input,.control-group.error select,.control-group.error textarea{color:#b94a48}.control-group.error input,.control-group.error select,.control-group.error textarea{border-color:#b94a48;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.control-group.error input:focus,.control-group.error select:focus,.control-group.error textarea:focus{border-color:#953b39;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #d59392}.control-group.success .checkbox,.control-group.success .control-label,.control-group.success .help-block,.control-group.success .radio,.control-group.success input,.control-group.success select,.control-group.success textarea{color:#468847}.control-group.success input,.control-group.success select,.control-group.success textarea{border-color:#468847;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.control-group.success input:focus,.control-group.success select:focus,.control-group.success textarea:focus{border-color:#356635;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #7aba7b}.control-group.info .checkbox,.control-group.info .control-label,.control-group.info .help-block,.control-group.info .radio,.control-group.info input,.control-group.info select,.control-group.info textarea{color:#3a87ad}.control-group.info input,.control-group.info select,.control-group.info textarea{border-color:#3a87ad;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.control-group.info input:focus,.control-group.info select:focus,.control-group.info textarea:focus{border-color:#2d6987;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #7ab5d3}input:focus:invalid,select:focus:invalid,textarea:focus:invalid{border-color:#ee5f5b}input:focus:invalid:focus,select:focus:invalid:focus,textarea:focus:invalid:focus{border-color:#e9322d;box-shadow:0 0 6px #f8b9b7}select:focus{outline:none!important}.help-block{display:block;margin-bottom:10px;color:#595959}.form-horizontal input,.form-horizontal select,.form-horizontal textarea{display:inline-block;margin-bottom:0;vertical-align:middle;*display:inline;*zoom:1}.form-horizontal .hide{display:none}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{float:left;margin-right:3px;margin-left:0}.control-group{margin-bottom:10px}.form-horizontal .control-group{margin-bottom:20px;*zoom:1}.form-horizontal .control-group:after,.form-horizontal .control-group:before{line-height:0;display:table;content:\"\"}.form-horizontal .control-group:after{clear:both}.form-horizontal .control-label{float:left;width:160px;padding-top:5px;text-align:right}.form-horizontal .controls{margin-left:180px;*display:inline-block;*padding-left:20px;*margin-left:0}.form-horizontal .controls:first-child{*padding-left:180px}.form-horizontal .help-block{margin-bottom:0}.form-horizontal input+.help-block,.form-horizontal select+.help-block,.form-horizontal textarea+.help-block{margin-top:10px}.label{font-size:11.844px;font-weight:700;line-height:14px;display:inline-block;padding:2px 4px;vertical-align:baseline;white-space:nowrap;color:#fff;border-radius:3px;background-color:#999;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.label:empty{display:none}.input-icon.left.twoFa i{margin:4px 2px 4px 10px!important}.input-error{color:#0f0}.disabled,.disabled:hover{cursor:auto!important;text-decoration:none;color:#666}#iocForm input,#iocForm select{width:95%}#iocForm input[type=radio]{width:40px;margin:-3px 0 0}#iocForm .radiolabel{display:inline-block;width:70px}#userForm{padding:10px 10px 0}#userForm h4{margin:0 0 10px;padding:0;float:none;clear:both}#userForm .userSection{padding:2px 10px;margin:0 0 20px;float:none;clear:both}#userForm input,#userForm label{display:inline-block}#userForm label{height:15px}#userForm ul.userCliList{margin:0;padding:0;position:relative}#userForm ul.userCliList li{position:relative;top:0;margin:0 5px 5px 0;padding:3px 5px;display:inline-block;vertical-align:top;width:auto;border:2px solid #000;border-radius:4px;font-weight:700}#userForm ul.userCliList li ul{margin:0 0 0 5px;padding:0;border:none;font-weight:400}#userForm ul.userCliList li ul li{border:none;float:none;display:block;line-height:10px}#userForm .formLabel{font-size:12px;width:120px}#userForm input[type=checkbox]{margin:0 4px 0 0}#userForm .control-group,#userForm .control-group.has-error,#userForm .control-group .help-block{margin:0;padding:0}.formError{font-size:11px;color:red}#lanegraph .laneAlert{display:none;float:right;width:140px;padding:0 10px;text-align:center;color:#fff;background-color:#c00}.laneInfo{line-height:20px;min-height:30px;padding:7px;list-style:none}.laneInfo:hover{cursor:pointer}.laneInfo .infoDivExpandBtn{font-size:18px;line-height:25px;top:0;bottom:0;float:right;width:25px;height:25px;text-align:center;vertical-align:top;color:#828282;border-radius:5px;background-color:#383838}.laneInfo .lanegraphlist{display:inline-block;overflow:auto;width:85%;word-wrap:break-word}.laneInfo:nth-child(odd){background-color:#474747}.laneactive{color:#1a1a1a;background-color:#e6e6e6!important}.patternPane{position:relative}.patternPane .closeBtnContainer{position:absolute;z-index:200}.patternPane .closeBtnContainer .closeBtn{line-height:30px;width:30px;height:30px;margin-top:40px;text-align:center;color:#fff;background-color:#c00}.patternPane .closeBtnContainer:hover{cursor:pointer}.patternPane .container{position:absolute;z-index:100;width:100%}.lanePatternInfoPane{display:block;overflow:auto;margin-top:40px;padding:20px;padding-bottom:20px;background-color:#232323}.lanePatternInfoPane .patternRow{border-top:1px solid #ccc}.lanePatternInfoPane .pr-outer{position:relative;display:table;min-height:60px}.patternPane div.title{font-family:Helvetica Neue;font-size:20px;font-weight:300;padding-bottom:15px;text-align:center}.lanePatternInfoPane div.pattern-row-container{display:table-cell;vertical-align:middle}.lanePatternInfoPane div.pattern-row-icon{float:left;padding:0 0 0 20px}.lanePatternInfoPane div.pattern-row-type{font-family:Helvetica Neue;font-size:16px;font-weight:300;line-height:36px;float:left;padding-left:15px}.lanePatternInfoPane div.pattern-row-selected{float:left;padding-left:20px}.lanePatternInfoPane div.pattern-row-selected li{list-style:none}.lanePatternInfoPane div.pattern-result-count{font-family:Helvetica Neue;font-size:18px;font-weight:300;line-height:36px;text-align:center}.lanePatternInfoPane input[type=checkbox]{visibility:hidden}.squaredTwo{position:relative;float:left;width:36px;height:36px;background:#666;background:linear-gradient(top,#666,#999 40%,#606060)}.squaredTwo label{position:absolute;top:1px;left:1px;width:34px;height:34px;cursor:pointer;background-color:#e6e6e6}.squaredTwo label:after{position:absolute;top:7px;left:8px;width:14px;height:8px;content:\"\";transform:rotate(-45deg);opacity:0;border:5px solid #666;border-top:0;border-right:0;background:transparent}.squaredTwo label:hover:after{opacity:.3}.squaredTwo input[type=checkbox]:checked+label:after{opacity:1}.patternInfoRight{display:block;overflow:scroll;margin-top:40px;background-color:#e6e6e6}.patternInfoRight .rightList{line-height:30px;min-height:30px;padding:7px;list-style:none}.patternInfoRight .rightList:nth-child(odd){background-color:#b3b3b3}.patternInfoRight .matchError{padding-top:50%;text-align:center}#lanegraph .chart{background:#3f3f3f}#autoExpand{display:inline-block;margin-left:20px}.lanegraph-temp-bg{padding:10px 20px 12px 15px;color:#b3b3b3!important;background:#3f3f3f}.patternInfoRight{color:#000}#OsIcon{display:inline-block;width:40px;min-height:30px;margin:0 5px}.userlogo{top:0;float:left;margin:0;padding:0}.epmap{font-weight:700;cursor:pointer;text-decoration:underline;color:#4b8df8}#killchainrange{margin:-6px 0 0 20px}#spinner{overflow:hidden;width:24px;height:24px;margin:0;-webkit-animation-name:spinnerRotate;-webkit-animation-duration:2s;-webkit-animation-timing-function:linear;-webkit-animation-iteration-count:infinite;white-space:nowrap;text-indent:24px;background-color:#000;-webkit-mask-image:url(" + __webpack_require__(383) + ")}.slspan{height:100%;display:block;border-right:1px solid #ccc;padding:1px 10px}.slspan:last-child{border:none}h4.slh4{margin:-5px 0 5px}.slInfoSection{margin:0;position:0;display:inline-block;width:45%}#lanegraph .axis .tick text{fill:#ddd}#mapInfo{z-index:99999;overflow:hidden;position:fixed;right:30px;width:380px}#map{z-index:500!important;width:100%}#mapInfo .formLabel{font-size:12px;display:inline-block}#mapInfo input[type=checkbox]{margin:-3px 5px 0 0}.map .table{width:100%;margin:0;text-align:left}.map div.tableholder{margin-bottom:10px;padding:0 4px 4px;opacity:.9;background-color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.map div.tableheading{font-weight:700;line-height:20px;padding:5px;cursor:pointer}.map div.tableheading:hover{background-color:#fefefe}.map div.tableheading i{line-height:20px;float:right}#map .leaflet-popup-content a{display:block;border-bottom:1px solid transparent}#map .leaflet-popup-content a:hover{color:#000;border-bottom-color:#0da4d3}.modal{position:fixed;z-index:1050;top:10%;left:50%;width:560px;margin-left:-280px;border:1px solid #999;border:1px solid rgba(0,0,0,.3);border-radius:6px;outline:0;background-color:#fff;background-clip:padding-box;box-shadow:0 3px 7px rgba(0,0,0,.3);*border:1px solid #999}.modal.fade{top:-25%;transition:opacity .3s linear,top .3s ease-out}.modal.fade.in{top:10%}.modal-header{padding:9px 15px;border-bottom:1px solid #eee}.modal-header .close{margin-top:2px}.modal-header h3{line-height:30px;margin:0}.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px}.modal-footer,.modal-form{margin-bottom:0}.modal-footer{padding:14px 15px 15px;text-align:right;border-top:1px solid #ddd;border-radius:0 0 6px 6px;background-color:#f5f5f5;box-shadow:inset 0 1px 0 #fff;*zoom:1}.modal-footer:after,.modal-footer:before{line-height:0;display:table;content:\"\"}.modal-footer:after{clear:both}div#descModalID.modal-body{float:left;white-space:pre-wrap}.user-settings-modal{background-color:#fff}.user-settings-modal i{cursor:pointer}.user-settings-modal .checkBox-slider{position:relative;float:none;margin-top:16px}.progress{overflow:hidden;height:20px;margin-bottom:20px;border-radius:4px;background-color:#f7f7f7;background-image:linear-gradient(180deg,#f5f5f5,#f9f9f9);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress,.progress .bar{background-repeat:repeat-x}.progress .bar{font-size:12px;float:left;box-sizing:border-box;width:0;height:100%;transition:width .6s ease;text-align:center;color:#fff;background-color:#0e90d2;background-image:linear-gradient(180deg,#149bdf,#0480be);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);text-shadow:0 -1px 0 rgba(0,0,0,.25)}.progress .bar+.bar{box-shadow:inset 1px 0 0 rgba(0,0,0,.15),inset 0 -1px 0 rgba(0,0,0,.15)}.progress.active .bar{animation:progress-bar-stripes 2s linear infinite}.progress-success .bar,.progress .bar-success{background-color:#5eb95e;background-image:linear-gradient(180deg,#62c462,#57a957);background-repeat:repeat-x}.progress-info .bar,.progress .bar-info{background-color:#4bb1cf;background-image:linear-gradient(180deg,#5bc0de,#339bb9);background-repeat:repeat-x}.sel-file{font-size:smaller;padding:1px 5px;color:grey}.sel-file img{float:left;width:18px;height:18px;padding-right:10px}.progress{display:inline-block;width:100px;border:3px groove #ccc}.progress div{font-size:smaller;width:0;background:orange}.drop-box{width:200px;height:65px;padding-top:35px;text-align:center;border:5px dashed #ddd;background:#f8f8f8}.cant_leave_blank{color:red}.floorOrderInput{width:50px}.user-settings-modal ul.nav li{float:left}.user-settings-modal ul.nav li a{padding:5px 7px;text-decoration:none;color:#333;text-shadow:0 1px 0 #fff}.user-settings-modal ul.nav li:nth-of-type(2){float:left}.user-settings-modal ul.nav li:nth-of-type(2) a{padding:5px 7px;text-decoration:none;color:#333;text-shadow:0 1px 0 #fff}.pull-right{float:right}.pull-left{float:left}.hide{display:none}.show{display:block}.visible-ie8,.visible-ie9{display:none}.plusMinus{font-weight:700;line-height:19px;display:inline-block;width:20px;height:20px;margin:0 5px 0 0;padding:0;text-align:center;color:#fff;border-radius:5px;background:#ddd}.plusMinus,.titleClick{cursor:pointer}.titleSelected{color:#c48b1f!important}.spinner{position:relative;z-index:10}.spinnerContainer{position:absolute;top:50%;left:50%}.isLink{font-weight:700;cursor:pointer;color:#37a9d5}.isLink:hover{font-weight:700;color:#18495c}.help-block{color:#b94a48}.greenText{color:#0d9100}.pointer{cursor:pointer}.center-logo{display:block;margin-right:auto;margin-left:auto}.title2015{font-family:roboto-reg;font-size:1.05rem;display:block;width:100%;padding:9px 0 13px;text-align:left;white-space:nowrap;color:#303030}.tableDate2015{font-family:roboto-light;font-size:.7rem;line-height:18px;padding:7px 10px 5px;cursor:default;text-align:center;letter-spacing:.6px;color:#fff;border:0;border-radius:2px;background-color:#37a9d5}.firstHeaderTitle{float:left;width:auto;padding:7px 10px 5px;text-align:left}.firstColumn{padding:1px 1px 1px 20px;text-align:left!important}a.cellioccount{cursor:pointer}a.cellioccount,div.cellioccount{font-family:roboto-medium;font-size:1.05rem;color:#ab0c1a}.iconstroke{color:#f2f2f2;-webkit-text-stroke:1px #8e8e8e}.dropdownheader2015{font-family:roboto-reg;font-size:.8rem;width:auto;min-width:88px;margin-top:3px;margin-right:20px;padding:8px 36px 8px 18px;cursor:pointer;color:#bfbfbf;border:0;background-color:none}.dropdownheader2015:focus,.dropdownheader2015:hover{color:red;background-color:#ff0!important}.dropdownheader2015:active{color:#fff;background-color:none}.dropdownmenu2015{font-size:.8rem;background-color:#bfbfbf}.dropdownmenu2015:hover{cursor:default}.checkBox-slider{cursor:pointer!important;position:relative}.checkBox-slider input[type=checkbox]{display:none}.checkBox-slider label{position:absolute;z-index:1;top:0;right:0;bottom:0;left:0;display:block;width:30px;height:10px;margin:auto;transition:all .3s ease-in 0s;border-radius:5px;background:#e1e3df;box-shadow:inset 0 0 0 1px #bfbfbf}.checkBox-slider .greenLabel{background:#4caf50!important;box-shadow:inset 0 0 0 8px #4caf50!important}.checkBox-slider label>input[type=checkbox]{cursor:pointer!important}.checkBox-slider label>input[type=checkbox]+span{cursor:pointer!important;left:-5px;background:#e1e3df;box-shadow:inset 0 0 0 0 #fff,0 1px 2px 0 #1a1a1a}.checkBox-slider label>input[type=checkbox]+span,.checkBox-slider label>input[type=checkbox]:checked+span{position:absolute;z-index:2;top:-4.8px;display:block;width:20px;height:20px;content:\"\";transition:box-shadow .5s ease-in 0s,left .3s ease-in 0s;border:0;border-radius:50%}.checkBox-slider label>input[type=checkbox]:checked+span{right:0;bottom:0;left:15px;background:#36933e;box-shadow:inset 0 0 0 1px #389c42,0 1px 2px 0 #1a1a1a}.changelog-main{width:600px;margin:20px auto 30px;padding:30px;background-color:#fff}.changelog-back{position:absolute;left:30px;color:#fff}.changelog-back:hover{cursor:pointer}.changelog-title{font-weight:700;text-align:center}#editServices{float:right;margin:7px 0 0 10px}#editServicesContainer{position:absolute;z-index:9999;right:0;width:auto;margin:37px 50px 0 0;padding:7px;border-radius:8px;background:#fff;box-shadow:0 6px 8px #818181}.editNetworkContainer{margin:5px 50px 0 0!important}.term-list{font-family:Arvo,Helvetica Neue,Helvetica,arial,sans-serif;font-weight:400;position:absolute;width:30%;margin:32px auto 2em;padding:5px 10px 0;list-style:none inside;text-align:left;color:#777;border:1px solid #ddd;background:#fff}.term-list li{padding:.5em;border-bottom:1px solid #eee}.term-list li.selected{background-color:#ecf0f1}.term-list strong{font-weight:700;color:#444}.hidden{display:none}.title2015 .toggleValue{font-family:ubuntu;font-size:14px!important;font-weight:700;line-height:24px;display:inline-block;float:right;width:24px;height:24px;margin:0 0 -24px;text-align:center;color:#000;border:1px solid #000;border-radius:3px}.checkboxValue,.toggleLineValue,.toggleLog,.toggleStacked,.toggleValue{cursor:pointer;float:right;display:inline-block;border:1px solid #000;border-radius:3px;margin:-25px 0 0 1px}.checkboxValue:hover,.toggleLineValue:hover,.toggleLog:hover,.toggleStacked:hover,.toggleValue:hover{background:#ddd}.toggleStacked{display:inline-block}.toggleLineValue,.toggleLog{display:inline-block;border:1px solid #000;border-radius:3px}.title2015 .complete{display:inline-block;margin:0 0 -5px}.title2015 .complete svg{display:block}div.spinner-table{margin-top:-10px;margin-left:10px}.spinnerParent{position:relative}.applicationResults{overflow-y:auto;max-width:220px;max-height:300px;margin:0;padding:0}.customIocApp.customIocAppSelect,.customIocApp:hover{background:#ecf0f1}#contextMenu{z-index:9999}#contextMenu ul.dropdown-menu li{text-align:center}#contextMenu a{cursor:pointer}.noselect{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none}#sevTable tr:first-child,#sevTable tr:hover{cursor:pointer;background:#fefefe}.ioc_atts,div .ioc_atts{margin:0;padding:0}.ioc_atts{display:block!important;float:none;clear:both;width:auto;border-bottom:0;background:0}.ioc_atts .title{font-weight:700;background-color:#999}.ioc_atts:first-child{border-top:0}.ioc_atts:last-child{border-bottom:0}.ioc_atts span{display:inline-block!important}.addAttribute,.ioc_atts span{margin:0;padding:0;text-align:center}.addAttribute{font-size:20px;font-weight:700;line-height:20px;display:inline-block;width:20px;height:20px;cursor:pointer;color:#444;border:2px solid #444;border-radius:6px;background:0}.addAttribute:hover{color:#fff;background:#444}.trash{width:20px;height:20px;margin:10px 0 0;cursor:pointer;transform:scale(1.5)}.custom_alert{margin:20px 0 0 -30px}.searchSidebar{float:left;width:auto;max-width:11%;min-width:65px;margin:0;padding:0;border-radius:2px;background-color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.searchTable{float:left;width:88%;margin:0 0 0 1%}.searchSidebar h4{font-size:15px;margin:5px 10px;padding:0}.searchSidebar ul{margin:10px 0;padding:0}.searchSidebar li{margin:0 5px;padding:0 8px;list-style-type:none;border:2px solid #fff;border-radius:6px}.searchSidebar li a{display:block;padding:2px 0;cursor:pointer}.searchSidebar li a:hover{text-decoration:none;color:#000}.searchSidebar li.selectedSearchMode{border:2px solid #333;background-color:#eee}.searchSidebar li:hover{background-color:#eee}.tooltip{font-size:11px;line-height:1.4;position:absolute;z-index:1030;display:block;opacity:0;visibility:hidden;width:auto;padding:4px;cursor:default;pointer-events:none;color:#000;border:1px solid;background-color:#ffe;shape-rendering:crispEdges}.tooltip.in{opacity:.8}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:8px;text-align:center;text-decoration:none;color:#fff;border-radius:4px;background-color:#000}.hoverRules{min-width:200px;line-height:16px;margin:0 auto}.hoverNodes,.hoverRules{font-size:10px;width:auto;padding:5px 10px;text-align:left;opacity:.9;border:1px solid #ccc;border-radius:8px;background:#fff}.hoverNodes{position:absolute;z-index:9999;overflow:hidden}.hoverNodes div{line-height:16px;margin:0;padding:0}#footimg{max-width:100%;margin-left:5px}.titleCenter{text-align:center}.nav{font-family:Helvetica,sans-serif;margin-left:0;list-style:none}.nav .dropdown-toggle .caret{margin-top:6px;border-top-color:#999;border-bottom-color:#999}.nav .active .dropdown-toggle .caret,.nav .dropdown-toggle:focus .caret,.nav .dropdown-toggle:hover .caret{border-top-color:#fff;border-bottom-color:#fff}.nav>.dropdown.active>a:focus,.nav>.dropdown.active>a:hover{cursor:pointer}.nav>li.dropdown.open.active>a:focus,.nav>li.dropdown.open.active>a:hover{color:#fff;border-color:#999;background-color:#999}.nav>li>a{display:block}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li>a>img{max-width:none}.nav>.disabled>a{color:#999}.nav>.disabled>a:focus,.nav>.disabled>a:hover{cursor:default;text-decoration:none;background-color:transparent}.nav li.dropdown.open.active .caret,.nav li.dropdown.open .caret,.nav li.dropdown.open a:focus .caret,.nav li.dropdown.open a:hover .caret{opacity:1;border-top-color:#fff;border-bottom-color:#fff}ul.nav li:nth-of-type(2){float:right}ul.nav li:nth-of-type(2) a{padding:10px 15px;text-decoration:none;color:#999;text-shadow:0 1px 0 #fff}.nav-pills:after,.nav-pills:before,.nav-tabs:after,.nav-tabs:before{line-height:0;display:table;content:\"\"}.nav-pills:after,.nav-tabs:after{clear:both}.navbar{overflow:visible;margin-bottom:20px}.navbar .nav .dropdown-toggle .caret{margin-top:8px}.navbar .nav>li>a:focus,.navbar .nav>li>a:hover{text-decoration:none;color:#333;background-color:transparent}.navbar .nav>.active>a,.navbar .nav>.active>a:focus,.navbar .nav>.active>a:hover{text-decoration:none;color:#555;background-color:#e5e5e5;box-shadow:inset 0 3px 8px rgba(0,0,0,.125)}.navbar .btn-navbar{display:none;float:right;margin-right:5px;margin-left:5px;padding:7px 10px;color:#fff;border-color:#e5e5e5 #e5e5e5 #bfbfbf;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);background-color:#ededed;background-image:linear-gradient(180deg,#f2f2f2,#e5e5e5);background-repeat:repeat-x;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.075);text-shadow:0 -1px 0 rgba(0,0,0,.25)}.navbar .btn-navbar.active,.navbar .btn-navbar.disabled,.navbar .btn-navbar:active,.navbar .btn-navbar:focus,.navbar .btn-navbar:hover,.navbar .btn-navbar[disabled]{color:#fff;background-color:#e5e5e5}.navbar .btn-navbar.active,.navbar .btn-navbar:active{background-color:#ccc\\9}.navbar .nav li.dropdown>a:focus .caret,.navbar .nav li.dropdown>a:hover .caret{border-top-color:#333;border-bottom-color:#333}.navbar .nav li.dropdown.active>.dropdown-toggle,.navbar .nav li.dropdown.open.active>.dropdown-toggle,.navbar .nav li.dropdown.open>.dropdown-toggle{color:#555;background-color:#e5e5e5}.navbar .nav li.dropdown.open>.dropdown-toggle .caret{border-top-color:#555;border-bottom-color:#555}.navbar .nav li.dropdown>.dropdown-toggle .caret{border-top-color:#777;border-bottom-color:#777}.navbar .nav li.dropdown.active>.dropdown-toggle .caret,.navbar .nav li.dropdown.open.active>.dropdown-toggle .caret{border-top-color:#555;border-bottom-color:#555}.navbar .nav>li>.dropdown-menu.pull-right,.navbar .pull-right>li>.dropdown-menu{right:0;left:auto}.navbar .nav>li>.dropdown-menu.pull-right:before,.navbar .pull-right>li>.dropdown-menu:before{right:12px;left:auto}.navbar .nav>li>.dropdown-menu.pull-right:after,.navbar .pull-right>li>.dropdown-menu:after{right:13px;left:auto}.navbar .nav>li>.dropdown-menu.pull-right .dropdown-menu,.navbar .pull-right>li>.dropdown-menu .dropdown-menu{right:100%;left:auto;margin-right:-1px;margin-left:0;border-radius:6px 0 6px 6px}.navbar-inner{min-height:40px;padding-right:20px;padding-left:20px;border:1px solid #d4d4d4;border-radius:4px;background-color:#fafafa;background-image:linear-gradient(180deg,#fff,#f2f2f2);background-repeat:repeat-x;box-shadow:0 1px 4px rgba(0,0,0,.065);*zoom:1}.navbar-inner:after,.navbar-inner:before{line-height:0;display:table;content:\"\"}.navbar-inner:after{clear:both}.navbar .brand:focus,.navbar .brand:hover{text-decoration:none}.navbar-fixed-top{top:0;position:fixed;z-index:1030;right:0;left:0;margin-bottom:0}.navbar-fixed-top .navbar-inner{box-shadow:0 1px 10px rgba(0,0,0,.1);padding-right:0;padding-left:0;border-radius:0;border-width:0 0 1px}.navbar .nav>li>.dropdown-menu:before{position:absolute;top:-7px;left:9px;display:inline-block;content:\"\";border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0,0,0,.2);border-left:7px solid transparent}.navbar .nav>li>.dropdown-menu:after{position:absolute;top:-6px;left:10px;display:inline-block;content:\"\";border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent}.navbar-inverse .navbar-inner{border-color:#252525;background-color:#1b1b1b;background-image:linear-gradient(180deg,#222,#111);background-repeat:repeat-x}.navbar-inverse .nav>li>a{color:#999;text-shadow:0 -1px 0 rgba(0,0,0,.25)}.navbar-inverse .brand:focus,.navbar-inverse .brand:hover,.navbar-inverse .nav>li>a:focus,.navbar-inverse .nav>li>a:hover{color:#fff}.navbar-inverse .nav>li>a:focus,.navbar-inverse .nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .nav .active>a,.navbar-inverse .nav .active>a:focus,.navbar-inverse .nav .active>a:hover,.navbar-inverse .nav li.dropdown.active>.dropdown-toggle,.navbar-inverse .nav li.dropdown.open.active>.dropdown-toggle,.navbar-inverse .nav li.dropdown.open>.dropdown-toggle{color:#fff;background-color:#232323}.navbar-inverse .nav li.dropdown.open>.dropdown-toggle .caret,.navbar-inverse .nav li.dropdown>a:focus .caret,.navbar-inverse .nav li.dropdown>a:hover .caret{border-top-color:#fff;border-bottom-color:#fff}.navbar-inverse .nav li.dropdown>.dropdown-toggle .caret{border-top-color:#999;border-bottom-color:#999}.navbar-inverse .nav li.dropdown.active>.dropdown-toggle .caret,.navbar-inverse .nav li.dropdown.open.active>.dropdown-toggle .caret{border-top-color:#fff;border-bottom-color:#fff}.navbar-inverse .btn-navbar{color:#fff;border-color:#040404 #040404 #000;border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);background-color:#0e0e0e;background-image:linear-gradient(180deg,#151515,#040404);background-repeat:repeat-x;text-shadow:0 -1px 0 rgba(0,0,0,.25);*background-color:#040404}.navbar-inverse .btn-navbar.active,.navbar-inverse .btn-navbar.disabled,.navbar-inverse .btn-navbar:active,.navbar-inverse .btn-navbar:focus,.navbar-inverse .btn-navbar:hover,.navbar-inverse .btn-navbar[disabled]{color:#fff;background-color:#040404;*background-color:#000}.navbar-inverse .btn-navbar.active,.navbar-inverse .btn-navbar:active{background-color:#000\\9}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;padding:10px;font-weight:700;font-family:Helvetica,sans-serif;font-size:.8em;line-height:1em}.nav-tabs>li.active{cursor:default!important;border:2px solid #f5f5f5;border-bottom-color:#000;background-color:transparent}.nav-tabs>li.active a{color:#000}.nav-tabs>li:hover{background:none;cursor:pointer}.nav-tabs>li>a{text-decoration:none;color:#444}.nav-tabs>li>a:focus,.nav-tabs>li>a:hover{color:#000;cursor:pointer;background:none}.dropdown{z-index:99999;position:relative}.dropdown a{color:#333;text-decoration:none}.dropdown-menu{font-family:Segoe UI,Helvetica,Arial,sans-serif;font-size:14px;position:absolute;z-index:99999;top:100%;left:0;display:none;float:left;min-width:140px;width:auto;margin:0;padding:0;list-style:none;border-radius:6px;background-color:#fff;background-clip:padding-box;*border-right-width:2px;*border-bottom-width:2px;border:1px solid #ddd;box-shadow:0 1px 8px rgba(0,0,0,.1);text-shadow:none}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu>a{color:#333}.dropdown-menu>a:focus,.dropdown-menu>a:hover{text-decoration:none;color:#fff}.dropdown-menu>li>a{font-weight:400;line-height:20px;display:block;clear:both;padding:3px 20px;white-space:nowrap;color:#333}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#fff;background-color:#0081c2;background-image:linear-gradient(180deg,#08c,#0077b3);background-repeat:repeat-x}.dropdown-menu.extended:after,.dropdown-menu.extended:before{border-bottom-color:#ddd!important}.dropdown-menu.extended li a:hover{color:#000;background-color:#f5f5f5;background-image:none;filter:none}.dropdown-menu.extended li:first-child a{border-top:0;border-bottom:1px solid #f4f4f4!important}.dropdown-menu.extended li:last-child a{border-top:1px solid #fff!important;border-bottom:1px solid #f4f4f4!important}.dropdown-menu.notification li>a>.label{width:10px;margin-right:2px;padding:2px 4px;text-align:center!important}.dropdown-menu.notification li>a>.label i{text-align:center!important}.dropdown-menu.notification li a .time{font-size:12px;font-weight:600;font-style:italic;text-align:right}.dropdown-menu>.active>a{text-decoration:none;color:#0f0;outline:0;background-color:#0081c2;background-image:linear-gradient(180deg,#08c,#0077b3);background-repeat:repeat-x}.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{text-decoration:none;color:#fff;outline:0;background-color:none}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#999}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{cursor:default;text-decoration:none;background-color:transparent;background-image:none}.dropdown-menu li>a{font-weight:400;line-height:18px;display:block;clear:both;padding:6px 0;white-space:nowrap;text-decoration:none;color:#333}.dropdown-menu li>a:hover{text-decoration:none;color:#333!important;background-color:#eee;background-image:none;filter:none}.dropdown-toggle:active,.open .dropdown-toggle{outline:0}.dropdown.open .dropdown-toggle{color:#fff}.caret{display:inline-block;width:0;height:0;content:\"\";vertical-align:top;border-top:4px solid #000;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown .caret{margin:8px 5px 0;padding:0}.dropdown:hover .caret{opacity:1;color:#fff}.open{*z-index:1000}.open>.dropdown-menu{display:block}.pull-right>.dropdown-menu{right:0;left:auto}.well{min-height:20px;margin-bottom:20px;padding:19px;border:1px solid #e3e3e3;border-radius:4px;background-color:#f5f5f5;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.fade{transition:opacity .15s linear;opacity:0}.fade.in{opacity:1}.collapse{position:relative;overflow:hidden;height:0;transition:height .35s ease}.collapse.in{height:auto}.close{font-size:20px;font-weight:700;line-height:20px;float:right;opacity:.2;color:#000;text-shadow:0 1px 0 #fff}.close:focus,.close:hover{cursor:pointer;text-decoration:none;opacity:.4;color:#000}.alert{margin-bottom:20px;padding:8px 35px 8px 14px;color:#c09853;border:1px solid #fbeed5;border-radius:4px;background-color:#fcf8e3;text-shadow:0 1px 0 hsla(0,0%,100%,.5)}.alert h4{margin:0;color:#c09853}.alert .close{line-height:20px;position:relative;top:-2px;right:-21px}.alert-success{color:#468847;border-color:#d6e9c6;background-color:#dff0d8}.alert-success h4{color:#468847}.alert-danger,.alert-error{color:#b94a48;border-color:#eed3d7;background-color:#f2dede}.alert-danger h4,.alert-error h4{color:#b94a48}.alert-info{border-color:#bce8f1;background-color:#d9edf7}.alert-info,.alert-info h4{color:#3a87ad}.alert-block{padding-top:14px;padding-bottom:14px}.alert-block>p,.alert-block>ul{margin-bottom:0}.alert-block p+p{margin-top:5px}.tabs-stacked .open>a:focus,.tabs-stacked .open>a:hover{border-color:#999}.tabbable:after,.tabbable:before{line-height:0;display:table;content:\"\"}.tabbable:after{clear:both}.tab-content{overflow:auto}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.tabs-below>.nav-tabs>li>a:focus,.tabs-below>.nav-tabs>li>a:hover{border-top-color:#ddd;border-bottom-color:transparent}.tabs-below>.nav-tabs>.active>a:focus,.tabs-below>.nav-tabs>.active>a:hover{border-color:transparent #ddd #ddd}.tabs-left>.nav-tabs>li>a:focus,.tabs-left>.nav-tabs>li>a:hover{border-color:#eee #ddd #eee #eee}.tabs-left>.nav-tabs .active>a:focus,.tabs-left>.nav-tabs .active>a:hover{border-color:#ddd transparent #ddd #ddd;*border-right-color:#fff}.tabs-right>.nav-tabs>li>a:focus,.tabs-right>.nav-tabs>li>a:hover{border-color:#eee #eee #eee #ddd}.tabs-right>.nav-tabs .active>a:focus,.tabs-right>.nav-tabs .active>a:hover{border-color:#ddd #ddd #ddd transparent;*border-left-color:#fff}#networkmapspan{margin:0 0 10px}#networkmap{overflow:hidden}#clientServerConnection{font-family:roboto-reg!important;position:absolute;z-index:1000;top:36%;left:30%;display:block;width:40%;min-width:600px;height:40%;min-height:300px;padding:6px 1% 4px 2%;letter-spacing:.6px;border:0;border-radius:2px!important;background-color:#fff;box-shadow:0 2px 3px #7e7e7e}#clientServerConnection table tr td,#clientServerConnection table tr th{padding:0 5px}#clientServerConnection table tr:nth-child(2n){background:#ccc}.csTime{display:block;width:130px}#closeConnections{font-size:20px;float:right;width:28px;height:24px;margin:-20px 0 0;padding:3px 0 2px 1px;cursor:pointer;text-align:center;color:#000;border-radius:15px;background:#cccbcb;box-shadow:0 1px 2px #7e7e7e}#networkmapInfoTitle{width:96%;margin:0 0 5px;border-bottom:2px solid #000}.listTitle{font-weight:700;display:inline-block;color:#000}.listTitleLink{display:inline-block;margin:0 20px 0 0;cursor:pointer;color:#aaa}.listTitleLink:hover{text-decoration:underline;color:#aaa}.nodeList{display:block!important;margin:0 0 2px;border-radius:2px!important}.listButton1,.listButton2,.listButton3,.listButton11{font-family:roboto-reg!important;font-size:.7rem!important;display:inline-block;width:auto;padding:6px 1% 4px 2%;cursor:pointer;text-align:center;letter-spacing:.6px;border:0;border-radius:2px!important;background-color:#ccc;background-color:#e6e7e8;box-shadow:0 2px 3px #7e7e7e}.listButton1{width:82%}.listButton11{width:66%}.listButton2{width:11%;min-width:5%;background-color:#cccbcb}.listButton3{width:11%;min-width:5%;background-color:#a6a8ab}.nodeList span.buttonSelected{margin-left:-1px;padding:5px 1% 5px 2%!important;border:1px solid #aaa;border-radius:3px!important;background:none!important;background-color:none!important;box-shadow:none}.nodeList .listButton3.buttonSelected{padding:5px 1%!important}.listSVG{width:18%}.listIP{width:40%;text-align:left}.listHostname{line-height:11px;width:40%;text-align:center}.listHostname,.listIP,.listSVG{display:inline-block;float:left;overflow:visible}.listbw{margin:0 2% 0 0}.listbw,.listConn{float:right;padding-left:1%;text-align:center}.listInfo{display:block;margin:0 5px 5px;padding:5px 10px}.listInfo h5{font-weight:700;font-style:10px!important;margin:0 0 5px;padding:0}.connBox{margin:0;padding:8px 13px;border:1px solid #ccc;border-radius:2px}.connLeft{width:25%}.connLeft2{width:45%}.connLeft,.connLeft2{display:inline-block;text-align:center;color:#aaa}.connBox .bwConn{display:block;margin:3px 0;padding:3px 0;border-radius:2px;background:#929497}.bwConn .connLeft,.bwConn .connLeft2,.connBox .bwConn{font-size:10px!important;font-weight:700;color:#fff!important}.bwConn .connLeft,.bwConn .connLeft2{cursor:pointer}#networkmapInfo{margin:0 0 10px;padding:0 4px 0 2px}.nodeListTitle{overflow:hidden}.nodeListTitle .nlt{font-size:12px;font-weight:700;display:inline-block;padding:3px 4px;cursor:pointer}.nodeListTitle .nlt:hover{text-decoration:underline}.nodeListTitle .ntlApp,.nodeListTitle .ntlType{cursor:default!important;text-decoration:none!important}.nodeListTitle .nlt:last-child{float:right}.ntlType{width:14%}.ntlType2{width:10%}.ntlIP{width:35%}.ntlIP2{width:26%}.ntlMach{width:15%}.ntlMach2{width:17%}.ntlApp{width:7%;text-align:center!important}.ntlApp,.ntlConn{float:right}line.linkSelect{stroke-width:4px!important;stroke:#ffd500!important}.nodeSelect circle,.nodeSelect path,.nodeSelect rect{stroke:#333;stroke-width:2}.forceSelect circle,.forceSelect path,.forceSelect rect{stroke:#1dc44a;stroke-width:2}.groupNodes circle,.groupNodes polygon,.groupNodes rect{stroke:#691b0e;stroke-width:2}.forceSelect path,.groupNodes path,.nodeSelect path{stroke:none}.netSearch{border-radius:5px}#networkmapButtons{width:700px;margin:0 auto}#networkmapButtonsAction,#networkmapButtonsRep{top:0;float:left;margin:0;text-align:center}#listIps{font-weight:700;top:0;float:left;width:auto;margin:0;margin:7px 0 0 20px;cursor:pointer;text-align:center}.showHideIp{position:absolute;overflow-y:auto;width:auto;max-width:130px;height:auto;max-height:400px;margin:5px 0 10px;padding:10px 15px;text-align:left;border-radius:8px;background:#fff;box-shadow:0 6px 8px #818181}.showHideIp .selected{color:#006a82}.showHideIp .notSelected:hover,.showHideIp .selected:hover{text-decoration:underline}.showHideIp .tableLabel{display:inline-block;margin:0 0 2px;text-align:right}.showHideIp input[type=checkbox]{left:0;display:inline-block;margin:-3px 5px 0 2px;text-align:left}.clickable{cursor:pointer}.clickable:hover{text-decoration:underline}#networkmapButtonsAction{width:45%}#networkmapButtonsEdits{float:right}#networkmapButtonsAction button{font-size:10px;font-weight:700;height:32px;margin:0 3px 3px;text-transform:uppercase;background:#cccbcb}.freezeG{margin-left:10px}#hideLineChart{text-align:center}.networkLineChart{display:block;width:100%;height:100px}.networkLineChart.hlcHide{display:block;overflow:hidden;width:0;height:0;transition:height .3s ease-in-out}#timeSlider .axis{font:10px sans-serif;-webkit-user-select:none;-moz-user-select:none;user-select:none}#timeSlider .axis .domain{fill:none;stroke:#000;stroke-opacity:.3;stroke-width:10px;stroke-linecap:round}#timeSlider .axis .halo{fill:none;stroke:#ddd;stroke-width:8px;stroke-linecap:round}#timeSlider .slider .handle{cursor:pointer;fill:#fff;stroke:#000;stroke-opacity:.5;stroke-width:1.25px}#timeSlider .axis .tick{width:20px!important}#linkSlider{display:inline-block}#linkSlider .axis{font:10px sans-serif;-webkit-user-select:none;-moz-user-select:none;user-select:none}#linkSlider .axis .domain{fill:none;stroke:#000;stroke-opacity:.3;stroke-width:10px;stroke-linecap:round}#linkSlider .axis .halo{fill:none;stroke:#ddd;stroke-width:8px;stroke-linecap:round}#linkSlider .slider .handle{cursor:pointer;fill:#fff;stroke:#000;stroke-opacity:.5;stroke-width:1.25px}#linkSlider .axis .tick{width:20px!important}.editcutomname{margin:0;padding:0}.editcutomname input{font-size:11px;width:55%;margin:0;padding:0}.localConns:hover,.remoteConns:hover{cursor:pointer;text-decoration:underline}.serviceCheck{display:block;width:auto;margin:0 10px 0 0;padding:0}html{font-size:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{font-family:Open Sans;font-size:12px;line-height:20px;margin:0!important;padding:0!important;color:#333;background:#232323;direction:ltr;height:100%}details,footer,header,nav,section{display:block}.row{margin-left:-20px;*zoom:1}.row:after,.row:before{line-height:0;display:table;content:\"\"}.row:after{clear:both}[class*=span]{float:left;min-height:1px;margin-left:20px}.row-fluid{width:100%;*zoom:1}.row-fluid:after,.row-fluid:before{line-height:0;display:table;content:\"\"}.row-fluid:after{clear:both}.row-fluid [class*=span]{display:block;float:left;box-sizing:border-box;width:100%;min-height:30px;margin-left:2.127659574468085%;*margin-left:2.074468085106383%}.row-fluid [class*=span]:first-child{margin-left:0}.row-fluid .span12{width:100%;*width:99.94681%}.row-fluid .span11{width:91.48936170212765%;*width:91.43617%}.row-fluid .span9{width:74.46808510638297%;*width:74.41489%}.row-fluid .span8{width:65.95744680851064%;*width:65.90426%}.row-fluid .span7{width:57.44680851063829%;*width:57.39362%}.row-fluid .span6{width:48.93617021276595%;*width:48.88298%}.row-fluid .span5{width:40.42553191489362%;*width:40.37234%}.row-fluid .span4{width:31.914893617021278%;*width:31.8617%}.row-fluid .span3{width:23.404255319148934%;*width:23.35106%}.row-fluid .span2{width:14.893617021276595%;*width:14.84043%}.row-fluid .span1{width:6.382978723404255%;*width:6.32979%}.row-fluid .offset12:first-child{margin-left:102.12765957446808%;*margin-left:102.02128%}.row-fluid .offset11:first-child{margin-left:93.61702127659574%;*margin-left:93.51064%}.row-fluid .offset10:first-child{margin-left:85.1063829787234%;*margin-left:85%}.row-fluid .offset9:first-child{margin-left:76.59574468085106%;*margin-left:76.48936%}.row-fluid .offset8:first-child{margin-left:68.08510638297872%;*margin-left:67.97872%}.row-fluid .offset7:first-child{margin-left:59.574468085106375%;*margin-left:59.46809%}.row-fluid .offset6:first-child{margin-left:51.063829787234035%;*margin-left:50.95745%}.row-fluid .offset5:first-child{margin-left:42.5531914893617%;*margin-left:42.44681%}.row-fluid .offset4:first-child{margin-left:34.04255319148936%;*margin-left:33.93617%}.row-fluid .offset3:first-child{margin-left:25.53191489361702%;*margin-left:25.42553%}.row-fluid .offset2:first-child{margin-left:17.02127659574468%;*margin-left:16.91489%}.row-fluid .offset1:first-child{margin-left:8.51063829787234%;*margin-left:8.40426%}.row-fluid [class*=span].hide,[class*=span].hide{display:none}.row-fluid [class*=span].pull-right,[class*=span].pull-right{float:right}.container-fluid{min-width:940px;padding-right:32px!important;padding-left:32px!important;*zoom:1}.container-fluid:after,.container-fluid:before{line-height:0;display:table;content:\"\"}.container-fluid:after{clear:both}.container-fluidmap{min-width:940px;padding-right:40px!important;padding-left:40px!important}.header{margin:0!important;padding:0!important}.header.navbar-fixed-top{z-index:99999!important}.header .logo{font-weight:700;float:left;margin:0;margin-top:6px}.header .leftHead,.header .middleHead,.header .rightHead{width:33%;margin:0;padding:0;display:block;float:left;height:100%}.header .leftHead #welcome,.header .middleHead #welcome,.header .rightHead #welcome{color:#fff;text-decoration:none;background:none}.header .leftHead #welcome:hover,.header .middleHead #welcome:hover,.header .rightHead #welcome:hover{background:none}.header .leftHead #welcome .caret,.header .middleHead #welcome .caret,.header .rightHead #welcome .caret{border-top:4px solid #f0261e;border-right:4px solid transparent;border-left:4px solid transparent;margin:7px 0 0 3px}.header .leftHead ul.dropdown-menu li>a:hover,.header .middleHead ul.dropdown-menu li>a:hover,.header .rightHead ul.dropdown-menu li>a:hover{border-radius:4px}.header .rightHead ul{margin-top:5px}.header .leftHead .logo{margin:3px 10px}.header ul.nav .clientToggle li:nth-of-type(2){float:none}.header ul.nav .clientToggle li:nth-of-type(2) a{padding:5px 0;text-decoration:none;color:#333;text-shadow:none}.header .clientToggle{position:relative;margin:8px 0 0 30px;padding:0;display:inline-block;float:none;height:100%;max-width:218px;color:#999;vertical-align:center;text-align:center}.header .clientToggle ul{width:100%;padding:5px 0;margin:3px 0 0}.header .clientToggle span a{color:#999}.header .clientToggle a:hover{cursor:pointer;color:#fff}.header .clientToggle li.clientActive a,.header .clientToggle li .clientActive a{text-decoration:underline}.header .mapToggle{position:absolute;margin:0;padding:0 0 0 20px;display:inline-block;float:none;height:100%;width:300px}.header .mapToggle .moveIcon{color:#fff;cursor:pointer}.header .mapToggle .moveIcon i{margin:3px 0 0}.header .mapToggle .moveIcon:hover{color:#f0261e}.header .mapToggle #mapButtons.hideButtons{opacity:0;width:1px;max-width:1px;padding:0;margin:0;border:none;overflow:hidden;transition:width,.5s,ease-out,0s}.header .mapToggle #mapButtons.showButtons{opacity:1;width:1px;max-width:1px;margin:0 0 0 5px;box-shadow:none;border:none;transition:width,.5s,ease-out,0s}.header .mapToggle .clientCoord{border:2px solid #000;border-radius:7px;display:inline-block;margin:0 3px;padding:1px 7px;font-weight:700;background:#000;color:#fff;cursor:pointer;vertical-align:top;font-family:Arvo,Helvetica Neue,Helvetica,arial,sans-serif}.header .mapToggle .clientCoord.current,.header .mapToggle .clientCoord:hover{text-decoration:none;background:#fff;color:#000}.header .hide_list{display:none;opacity:0;max-width:0;max-height:0;transition:all,.5s,ease-out,0s}.header .client_dropdown{color:#fff;font-size:1.2em;cursor:pointer}.header .client_dropdown .caret{border-top:5px solid #fff;border-right:5px solid transparent;border-left:5px solid transparent;margin:7px 0 0 7px}.header .middleHead .centerDivZero{width:1px}.header .middleHead .centerDiv,.header .middleHead .centerDivZero{float:none;margin:3px auto 0;padding:0;transition:all,.5s,ease-out,0s}.header .middleHead .centerDiv{width:210px}.header .middleHead .hideGlass{opacity:0;height:0;width:0;display:none}.header .middleHead .hideGlass,.header .middleHead .showGlass{left:49%;margin-top:4px;position:absolute;transition:all,.5s,ease-out,0s}.header .middleHead .showGlass{opacity:1;display:block;width:30px;width:26px;cursor:pointer}.header .middleHead input[type=text].hideInput{width:0;padding:0;margin:0;border:none;transition:all,.5s,ease-out,0s}.header .middleHead input[type=text].showInput{width:208px;padding:3px 5px;margin:0 auto;box-shadow:none;border:none;transition:all,.5s,ease-out,0s}.header .middleHead .centerDivZero #remainingSites{position:relative;overflow-y:auto;max-width:0;max-height:0;transition:all,.5s,ease-out,0s}.header .middleHead .centerDiv #remainingSites{max-width:218px;max-height:600px;margin:0;padding:0;transition:all,.5s,ease-out,0s}.header .btn-navbar{margin-bottom:0;padding-top:10px;padding-right:0;padding-bottom:6px;color:#fff;border:0;background-image:none;box-shadow:none;filter:none}.header .btn-navbar:hover{text-decoration:none}.header .navbar-inner{width:100%;height:42px;margin-left:0 0 0 110px;padding:0;border:0;box-shadow:none;background-color:#000!important;background-image:none!important;filter:none!important}.header .nav{display:block}.header .nav>li{margin:0;padding:0}.header .nav>li.dropdown,.header .nav>li.dropdown>a{padding-right:4px;padding-left:4px}.header .nav>li.dropdown:last-child{padding-right:2px}.header .nav>li.dropdown .dropdown-toggle{padding-top:12px}.header .nav>li.dropdown .dropdown-toggle i{font-size:18px}.header .nav>li.dropdown.user .dropdown-toggle:hover{text-decoration:none}.header .nav>li.dropdown.user .dropdown-toggle .username{color:#ddd}.header .nav li.currentClient{color:#fff;margin:10px 0 0 60px;display:inline-block}.header .nav li.dropdown.user .dropdown-toggle i{font-size:16px;display:inline-block;margin:0;margin-top:5px}.header .nav>li.dropdown.user .dropdown-menu i{display:inline-block;width:15px}.header .nav .dropdown-menu{margin-top:3px}.header .nav li.dropdown .dropdown-toggle i{color:#8a8a8a!important}.header .hor-menu .search-form form input:-ms-input-placeholder,.header .hor-menu .search-form form input::-webkit-input-placeholder{color:#999}.header .title{font-family:Arvo,Helvetica Neue,Helvetica,arial,sans-serif;font-size:170%;font-weight:400;width:100%;margin:3em 0 1em;text-align:center;color:#2a5ba3;text-shadow:#fff 1px 1px 0,#ddd 2px 2px,#ddd 3px 3px 1px}.sidebar-toggler{background-color:#242424;background-image:url(" + __webpack_require__(384) + ")}.sidebar-toggler:hover{opacity:1}.content{width:100%;margin-top:70px}.footer{width:auto;position:relative;bottom:0;background-color:#232323;font-size:12px;padding:8px 2% 5px 240px}.footer:after,.footer:before{line-height:0;display:table;content:\"\"}.footer:after{clear:both}.footer .footer-inner{display:inline-block;float:left;color:#999}.footer .footer-tools .go-top:hover{opacity:.7}.page-sidebar-closed .footer{padding:8px 2% 5px 40px}.tab-content{overflow:hidden;padding:0}.box{overflow:hidden;padding:5px;border-radius:2px;box-shadow:0 1px 0 1px #e4e6eb}.box .box-content{padding:10px;background:#fff}.control-label{margin-top:2px}.current{text-decoration:underline}.row-fluid{padding:0 0 3px}.page-header{margin:20px 0 30px;padding-bottom:9px;border-bottom:1px solid #eee}.page-header-fixed .page-container{margin-top:42px}.page-container{margin:0;padding:0;min-height:100%}.page-content{margin:0 0 0 220px;padding:0;background:#f5f5f5;width:auto}.page-content,.page-sidebar{height:100%;overflow:visible}.page-sidebar{position:fixed;z-index:9999;background-color:#232323;width:240px;display:block}.page-sidebar .page-sidebar-menu{overflow-y:auto}.page-sidebar .sidebar-search input{color:#d6d6d6;color:#d6d6d6!important;background-color:#242424!important;background-color:#383e4b!important}.page-sidebar .sidebar-search input:-moz-placeholder,.page-sidebar .sidebar-search input:-ms-input-placeholder,.page-sidebar .sidebar-search input::-webkit-input-placeholder{color:#d6d6d6!important}.page-sidebar .sidebar-search .input-box{border-bottom:1px solid #7d7d7d!important}.page-sidebar .page-sidebar-menu::-webkit-scrollbar{display:none;width:0}.page-sidebar-fixed ul.page-sidebar-menu>li>a{transition:all .2s ease}.page-sidebar ul>li>a>.arrow:before{font-family:FontAwesome;font-size:16px;font-weight:300;display:inline;float:right;height:auto;margin-top:1px;margin-right:5px;content:\"\\F104\";text-shadow:none}.page-sidebar ul>li>a:hover{cursor:pointer}.page-sidebar .sidebar-toggler{width:29px!important;height:29px;cursor:pointer;opacity:.5;background-repeat:no-repeat}ul.page-sidebar-menu{margin:0;padding:0;list-style:none}ul.page-sidebar-menu>li.start>a{border-top-color:transparent!important}ul.page-sidebar-menu>li>a{color:#f5f5f5!important;border-top:1px solid #2d323d!important;font-size:14px;font-weight:300;position:relative;display:block;margin:0;padding:1.2vh 15px;text-decoration:none;border:0;min-height:18px;max-height:32px}ul.page-sidebar-menu>li:last-child>a{border-bottom:1px solid transparent!important;border-bottom-color:transparent!important}ul.page-sidebar-menu>li a i{color:#f5f5f5}ul.page-sidebar-menu>li.open>a,ul.page-sidebar-menu>li:hover>a,ul.page-sidebar-menu>li>a:hover{background:#424242}ul.page-sidebar-menu>li.active>a{font-weight:700;color:#424242!important;border-top-color:transparent!important;background:#f5f5f5!important}ul.page-sidebar-menu>li.active>a i{color:#232323}ul.page-sidebar-menu>li>ul.sub-menu>li:first-child>a{border-top:0!important}ul.page-sidebar-menu>li>ul.sub-menu>li.active>a,ul.page-sidebar-menu>li>ul.sub-menu>li>a:hover{color:#fff!important;background:#424242!important}ul.page-sidebar-menu>li>ul.sub-menu li.open>a,ul.page-sidebar-menu>li>ul.sub-menu li>ul.sub-menu>li.active>a,ul.page-sidebar-menu>li>ul.sub-menu li>ul.sub-menu>li>a:hover{color:#fff!important;background:#2d323d!important}ul.page-sidebar-menu li>ul.sub-menu>li>a{color:#bdbdbd}ul.page-sidebar-menu>li>a .arrow.open:before,ul.page-sidebar-menu>li>a .arrow:before{color:#7d7d7d!important}ul.page-sidebar-menu>li>ul.sub-menu a .arrow.open:before,ul.page-sidebar-menu>li>ul.sub-menu a .arrow:before{color:#707070!important}ul.page-sidebar-menu>li>a>.arrow.open:before{color:#8a8a8a!important}ul.page-sidebar-menu>li.active>a .arrow.open:before,ul.page-sidebar-menu>li.active>a .arrow:before{color:#fff!important}ul.page-sidebar-menu>li{display:block;margin:0;padding:0;border:0}ul.page-sidebar-menu>li>a>.arrow.open:before{font-family:FontAwesome;font-size:16px;font-weight:300;display:inline;float:right;height:auto;margin-top:1px;margin-right:3px;content:\"\\F107\";text-shadow:none}ul.page-sidebar-menu>li>ul.sub-menu{display:none;clear:both;margin:0;list-style:none}ul.page-sidebar-menu>li.active>ul.sub-menu,ul.page-sidebar-menu>li.active>ul.sub-menu>li.active ul.sub-menu,ul.page-sidebar-menu>li.active>ul.sub-menu>li.active ul.sub-menu>li.active ul.sub-menu{display:block}ul.page-sidebar-menu>li>ul.sub-menu>li{margin:0;margin-top:1px!important;padding:0;background:0}ul.page-sidebar-menu>li>ul.sub-menu>li>a{font-size:14px;font-weight:300;display:block;margin:0;padding:7px 0;padding-left:44px!important;text-decoration:none;background:0}ul.page-sidebar-menu>li>ul.sub-menu>li ul.sub-menu{display:none;clear:both;margin:0;list-style:none}ul.page-sidebar-menu>li>ul.sub-menu li>a>.arrow:before{margin-right:20px;content:\"\\F104\"}ul.page-sidebar-menu>li>ul.sub-menu li>a>.arrow.open:before,ul.page-sidebar-menu>li>ul.sub-menu li>a>.arrow:before{font-family:FontAwesome;font-size:16px;font-weight:300;display:inline;float:right;height:auto;margin-top:1px;text-shadow:none}ul.page-sidebar-menu>li>ul.sub-menu li>a>.arrow.open:before{margin-right:18px;content:\"\\F107\"}ul.page-sidebar-menu>li>ul.sub-menu li>ul.sub-menu>li>a{font-size:14px;font-weight:300;display:block;margin:0;padding:5px 0;text-decoration:none;background:0}ul.page-sidebar-menu>li>ul.sub-menu li>ul.sub-menu>li>a>i{font-size:13px}ul.page-sidebar-menu>li>ul.sub-menu>li ul.sub-menu li{margin:0;margin-top:1px!important;padding:0;background:0}ul.page-sidebar-menu>li>ul.sub-menu>li>ul.sub-menu>li>a{padding-left:60px}ul.page-sidebar-menu>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a{padding-left:80px}ul.page-sidebar-menu>li>a i{font-size:16px;margin-right:5px;text-shadow:none}ul.page-sidebar-menu>li.break{margin-bottom:20px}ul.page-sidebar-menu>li.active>a{border:0;text-shadow:none}ul.page-sidebar-menu>li.active>a .selected{position:absolute;top:8px;right:-1px;display:block;float:right;width:8px;height:25px;background-image:url(" + __webpack_require__(385) + ")}.sidebar-toggler{margin-left:3px}.page-sidebar-closed .page-sidebar .sidebar-search{width:29px;height:34px;margin-bottom:15px!important;margin-left:3px}.page-sidebar-closed .page-sidebar .sidebar-search input{font-size:14px;width:70%;margin:0;margin-right:15px;padding-right:0;padding-bottom:0;padding-left:0;border:0;box-shadow:none}.page-sidebar-closed .page-sidebar .sidebar-search .submit{display:block;float:right;width:13px;height:13px;margin-top:8px;background-repeat:no-repeat}.page-sidebar-closed .page-sidebar .sidebar-search .input-box{border-bottom:0!important}.page-sidebar-closed .page-sidebar .sidebar-search.open{overflow:hidden;width:100%}.page-sidebar-closed .page-sidebar .sidebar-search.open input{display:inline-block!important;width:100%;margin-top:3px;padding-bottom:2px;padding-left:10px}.page-sidebar-closed .page-sidebar .sidebar-search.open .submit{display:inline-block;width:13px;height:13px;margin:10px 8px 9px 6px!important}.page-sidebar-closed .page-sidebar .sidebar-search.open .remove{display:inline-block!important;float:left!important;width:11px;height:11px;margin:11px 6px 7px 8px!important;background-repeat:no-repeat}.page-sidebar-closed .page-sidebar .sidebar-search{margin-top:6px;margin-bottom:6px}.page-sidebar-closed ul.page-sidebar-menu>li>a .selected{right:-3px!important}.page-sidebar-closed ul.page-sidebar-menu>li>a section>.title{display:none!important}.page-sidebar-closed ul.page-sidebar-menu{overflow:visible;background-color:#232323}.page-sidebar-closed ul.page-sidebar-menu>li>a{padding-left:7px}.page-sidebar-closed ul.page-sidebar-menu>li:hover{position:relative!important;z-index:2000}.page-sidebar-closed ul.page-sidebar-menu>li:hover>a>i{margin-right:10px}.page-sidebar-closed ul.page-sidebar-menu>li:hover{overflow:visible;z-index:999999;display:block!important;width:225px!important;background-color:#232323}.page-sidebar-closed ul.page-sidebar-menu>li:hover .selected{display:none}.page-sidebar-closed ul.page-sidebar-menu>li:hover>a>i{margin-right:7px}.page-sidebar-closed ul.page-sidebar-menu>li:hover .title{display:inline!important}.page-sidebar-closed ul.page-sidebar-menu>li:hover>.sub-menu{position:absolute!important;background-color:#232323;z-index:2000;top:100%;left:36px;display:block!important;width:189px!important;margin-top:0}.page-sidebar-closed ul.page-sidebar-menu>li:hover>.sub-menu>li>.sub-menu,.page-sidebar-closed ul.page-sidebar-menu>li:hover>.sub-menu>li>.sub-menu>li>.sub-menu{width:189px!important}.page-sidebar-closed ul.page-sidebar-menu>li:hover>.sub-menu>li>a{padding-left:15px!important}.page-sidebar-closed ul.page-sidebar-menu>li:first-child{width:35px!important}.page-sidebar-closed ul.page-sidebar-menu>li>.sub-menu{display:none!important}.page-sidebar-closed ul.page-sidebar-menu>li>ul.sub-menu>li>.sub-menu>li>a{padding-left:30px!important}.page-sidebar-closed ul.page-sidebar-menu>li>ul.sub-menu>li>.sub-menu>li>.sub-menu>li>a{padding-left:45px!important}.page-sidebar-closed .page-sidebar{width:35px}.page-sidebar-closed .page-content{margin-left:35px!important}.page-sidebar-closed .page-sidebar .sidebar-search.open{background-color:#383e4b!important}.page-sidebar-closed .page-sidebar .sidebar-search.open .remove{background-image:url(" + __webpack_require__(386) + ")}.page-sidebar-fixed.page-sidebar-closed ul.page-sidebar-menu>li>a{transition:all .2s ease}.page-sidebar-closed #footimg{display:none}.page-footer-fixed .footer{background-color:#242424}.page-footer-fixed .footer .footer-inner{color:#999}.page-header-fixed-survey{position:relative;height:100vh;background:#fff}.page-content-survey{background:0}.servicesLineChart{display:block;width:100%}.servicesLineChart.hlcHide{display:block;overflow:hidden;width:0;height:0;transition:height .3s ease-in-out}#services{overflow-x:auto}#servicesOutter{position:relative}.clients .client,.servers .server,.services .app,.services .service{cursor:pointer}#buttonContainer{position:absolute;transform:translateX(-50%);left:50%}.vectors{border:2px solid #000;border-radius:7px;display:inline-block;margin:0 3px;padding:1px 7px;background:#fff;font-weight:700;color:#000;cursor:pointer;font-family:Arvo,Helvetica Neue,Helvetica,arial,sans-serif}.vectors.current,.vectors:hover{background:#000;color:#fff;text-decoration:none}.clearfix{*zoom:1}.clearfix:after,.clearfix:before{line-height:0;display:table;content:\"\"}.clearfix:after{clear:both}button.createUser{margin:10px 0}table{overflow-x:auto;display:block;font-family:roboto-reg;font-size:.7rem;max-width:100%;border-spacing:0;border-collapse:collapse;background-color:transparent}table tbody{display:table;width:100%}table#sevTable,table td,table th{text-align:center}table#sevTable{width:100%}table#sevTable .first{width:135px;padding:1px;text-align:left!important}table#sevTable .firstTitle{padding:1px 1px 1px 20px;text-align:left!important}table#sevTable tr{text-align:center}table#sevTable tr .last{float:right;width:auto;padding:1px 10px 1px 1px;text-align:right!important}table#sevTable tr .timestampText{float:right}table#sevTable tr th.tableTitles{margin:0 3px;padding:0 10px}table#sevTable tr td{margin:0;padding:3px 5px;max-width:400px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}table#sevTable button.tableTime{font-size:11px;float:right;max-width:125px;padding:4px 10px}table.listUser{width:100%}table.listUser tr{border-bottom:1px solid #ccc}table.listUser th{font-weight:700}table.listUser td{padding:5px 10px!important;min-width:100px}table td[class*=span],table th[class*=span]{display:table-cell;float:none;margin-left:0}table#pageTwoInfoTable{width:90%;border-spacing:5px;border-collapse:separate}table#pageTwoInfoTable tr{width:100%}table#pageTwoInfoTable tr td{width:auto;padding:7px;word-wrap:break-word;background:#eee}table#pageTwoInfoTable tr th{background:#bbb}hr{margin:20px 0;border:0;border-top:1px solid #e0dfdf;border-bottom:1px solid #fefefe}th{font-size:12px!important;max-width:60px}td.file{max-width:200px;word-wrap:break-word}#sevTable{text-align:center}#sevTable tr{height:50px;border-bottom:1px solid #ccc}#sevTable td.last_seen{width:180px;text-align:left}.table{width:100%;margin-bottom:20px;background-color:#fff}.table td,.table th{line-height:20px;padding:8px;text-align:left;vertical-align:top;border-top:1px solid #ddd}.table th{font-weight:700}.table thead th{vertical-align:bottom}.table caption+thead tr:first-child td,.table caption+thead tr:first-child th,.table colgroup+thead tr:first-child td,.table colgroup+thead tr:first-child th,.table thead:first-child tr:first-child td,.table thead:first-child tr:first-child th{border-top:0}.table tbody+tbody{border-top:2px solid #ddd}.table-condensed td,.table-condensed th{padding:4px 5px}.table thead tr th{font-size:14px;font-weight:600}.tableTitles2015{font-family:roboto-medium;font-size:.7rem!important;margin:0 3px;padding:6px 10px}.tableModal{position:relative;padding:20px;background-color:#fff}.tableModal .title-row{font-weight:600;list-style:none}.tableModal .tableContainer,.tableModal ul{position:relative;overflow:auto;height:100%}.tableModal ul{margin:0;padding:0;list-style:none}.tableModal .table-items li:nth-child(odd){background:#f8f8f8}.tableModal li{line-height:30px;min-height:30px}.tableModal .table-items li{border-top:1px solid #ccc}.tableModal .tableHeader{font-size:15pt;line-height:25px;height:25px;padding-bottom:40px}.tableModal .tableHeader a{float:right;cursor:pointer;text-decoration:none}.tableModal .tableHeader a:hover{cursor:pointer}.tableModal li div{display:block;float:left;padding:3px 5px}.tableModal .drag-handle{cursor:pointer;text-align:center}.tableModal .table-title{font-weight:600}.tableModal .table-title,.tableModal .table-value{border-bottom:1px solid #ccc}.tableModal .column-toggle{min-height:30px}.tableModal .checkBox-slider{position:relative;float:none;margin-top:13px}.input-icon input{padding-right:25px!important}.input-icon.left i{font-size:16px;position:absolute!important;z-index:1;display:block!important;width:16px;height:16px;margin:9px 2px 4px 10px;text-align:center;color:#ccc}.input-icon.left input{padding-left:33px!important}#sTable a.tableRight{float:right;cursor:pointer}#sTable a.tableLeft{float:left;cursor:pointer}.table-paginator-container{display:flex;align-items:center;justify-content:center;margin:20px 0;text-align:center}.table-paginator{border-bottom:none;font-family:roboto-light;font-size:1.05rem;line-height:1.75em;background-color:none}.table-paginator a{margin:0 2px;cursor:pointer;text-align:center}.table-paginator a.first{margin:0 2px;cursor:pointer;text-align:left!important}.table-paginator span{cursor:pointer}.table-paginator span:hover{text-decoration:underline}.table-paginator span.dots,.table-paginator span.plain-text{cursor:default!important;text-decoration:none!important}.table-paginator span.middlePages{margin:0 3px}.table-paginator .active{text-decoration:underline}.breakdown{display:block;width:100%;max-width:250px;height:30px;line-height:30px;margin:0;padding:0;border-radius:2px;font-weight:700;overflow:hidden;color:#fff}.breakdown .orig,.breakdown .resp{height:30px;display:inline-block;float:left;margin:0;padding:0;text-align:center}.breakdown .orig{background:#f3b333}.breakdown .orig.blank{background:#444}.breakdown .resp{background:#50c2e0}.breakdown .resp.blank{background:#aaa}.zoneClient{margin:2px 10px 2px -5px;padding:1px 5px}.zoneClientFinal{margin:0;padding:0 0 2px}.zoneClientFinalZones{margin:0 0 0 10px;padding:0}.sectionZC{margin:10px 0;padding:10px;border:2px solid #ccc;border-radius:8px}.zoneClient{cursor:pointer;border-radius:4px}.sel,.zoneClient:hover{background:#ddd}.zcTitle{font-size:14px;font-weight:700}#zcFooter{float:left!important;margin:10px 0 -5px}.clickCZ:hover{text-decoration:underline}.hideShowHist{margin:10px 0 20px}.tab-inner{width:50%;margin:0 auto}.reports-list{line-height:15px;list-style-type:none}.report-columns{overflow:auto;float:left}.report-columns,.report-columns ul{min-height:200px}.reports_drag{background-color:#000}.report-columns li{margin:0 0 5px;list-style-type:none;margin-left:-15px;line-height:25px;width:100%;padding:5px;background-color:#eee;box-shadow:1px 1px 1px 0 #c2c2c2}.report-columns li.pointer{cursor:pointer}.report-columns .active-edit,.report-columns li.pointer:hover{background-color:#ddd}.report-columns span.test{float:right}.report-columns span.test i{line-height:25px}.report-columns span.test i.fa-times{color:red}.report-columns li i{font-size:15px}.report-columns li i.green{color:#4caf50;cursor:pointer}.report-columns li i.green:hover{color:#1b5e20}.report-columns li i.red{color:#f44336;cursor:pointer}.report-columns li i.red:hover{color:#b71c1c}.report-columns li i.grey{color:#9e9e9e;cursor:pointer}.report-columns li i.grey:hover{color:#212121}.report-columns li i.save{color:#000;cursor:pointer}.save-reports{float:right;margin:0 5px 5px;bottom:0}.edit-pane label{display:block;font-size:12px}div.zone-label{width:100%;padding:3px}div.zone-label:hover{background-color:#e8f5e9}:checked+div.zone-label{background-color:#c8e6c9}.edit-pane input[type=checkbox]{width:0;display:none;height:0;padding:0;margin:0;vertical-align:top;position:relative;*overflow:hidden}.edit-pane input.threshold{width:90px}.edit-pane a.check-all-btn{font-size:9px;float:left}input.rule{width:100%}", ""]);
	
	// exports


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "629a55a7e793da068dc580d184cc0e31.ttf";

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6a2db9f9b31a8116fc57cc8b6b3f324a.eot";

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6bf4fabad5fbfac09fadc4f0cda3fa65.woff";

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8419d2aae0d55647e7824879684f21da.ttf";

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "880750da868b36b4ee778fd5984c65b5.svg";

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c926073f9aa0a951197600481c8cfcc8.eot";

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4ed2b24d3d8f096240f17cfd2b4170b.woff";

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "41759918b872463b4c0efe06526a8309.ttf";

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4fd446f9343a57e0db794982b6cec452.svg";

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "df7b648ce5356ea1ebce435b3459fd60.ttf";

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "46e48ce0628835f68a7369d0254e4283.ttf";

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "894a2ede85a483bf9bedefd4db45cdb9.ttf";

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e31fcf1885e371e19f5786c2bdfeae1b.ttf";

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e6fd95f0cb839566476ec9b6df34849c.ttf";

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3f50d7087acd55fcda8ba6d77b1d59f6.png";

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cfd270a8a06caae6799be6a014bdf7bd.jpg";

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d2d0703ca2ce707c4541001947c3abd2.png";

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a9b2c424d81b5b6aed2d1a19287ab74d.png";

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var upgrade_adapter_1 = __webpack_require__(1);
	var global_ts_1 = __webpack_require__(388);
	module.exports = function (ngModule) {
	    // load global services
	    ngModule.factory('Global', global_ts_1.Global);
	    // load intercepter
	    ngModule.factory('httpInterceptor', __webpack_require__(389));
	    ngModule.factory('socketIo', __webpack_require__(390));
	    ngModule.config(__webpack_require__(439));
	    // upgrade services
	    upgrade_adapter_1.upgradeAdapter.upgradeNg1Provider('Global');
	    // temp upgrade for angular 2
	    upgrade_adapter_1.upgradeAdapter.upgradeNg1Provider('$location');
	};


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	// global service for global variables
	exports.Global = function () {
	    var _this = this;
	    _this._data = {
	        version: window.version,
	        api: ("https://api-demo.mantix4.com")
	    };
	    return _this._data;
	};


/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($q, $location, $window) {
	    return {
	        request: function request(config) {
	            config.headers = config.headers || {};
	            if ($window.sessionStorage.token) {
	                config.headers.Authorization = 'Bearer ' + $window.sessionStorage.token;
	            }
	            return config;
	        },
	        response: function response(_response) {
	            if (_response.status === 401 || _response.status === 500) {
	                $location.url('/login');
	            }
	            return _response || $q.when(_response);
	        }
	    };
	}
	
	ctrl.$inject = ['$q', '$location', '$window'];
	module.exports = ctrl;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(io) {'use strict';
	
	//Global service for global variables
	function ctrl($location, $q, $window) {
	    return function (namespace) {
	        var defer = $q.defer();
	        var socket = io.connect(("https://api-demo.mantix4.com") + namespace, {
	            secure: true,
	            query: 'token=' + $window.sessionStorage.token,
	            forceNew: true
	        });
	        defer.resolve(socket);
	        return defer.promise;
	    };
	}
	
	ctrl.$inject = ['$location', '$q', '$window'];
	module.exports = ctrl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(391)))

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var url = __webpack_require__(392);
	var parser = __webpack_require__(397);
	var Manager = __webpack_require__(404);
	var debug = __webpack_require__(394)('socket.io-client');
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = lookup;
	
	/**
	 * Managers cache.
	 */
	
	var cache = exports.managers = {};
	
	/**
	 * Looks up an existing `Manager` for multiplexing.
	 * If the user summons:
	 *
	 *   `io('http://localhost/a');`
	 *   `io('http://localhost/b');`
	 *
	 * We reuse the existing instance based on same scheme/port/host,
	 * and we initialize sockets for each namespace.
	 *
	 * @api public
	 */
	
	function lookup (uri, opts) {
	  if (typeof uri === 'object') {
	    opts = uri;
	    uri = undefined;
	  }
	
	  opts = opts || {};
	
	  var parsed = url(uri);
	  var source = parsed.source;
	  var id = parsed.id;
	  var path = parsed.path;
	  var sameNamespace = cache[id] && path in cache[id].nsps;
	  var newConnection = opts.forceNew || opts['force new connection'] ||
	                      false === opts.multiplex || sameNamespace;
	
	  var io;
	
	  if (newConnection) {
	    debug('ignoring socket cache for %s', source);
	    io = Manager(source, opts);
	  } else {
	    if (!cache[id]) {
	      debug('new io instance for %s', source);
	      cache[id] = Manager(source, opts);
	    }
	    io = cache[id];
	  }
	  if (parsed.query && !opts.query) {
	    opts.query = parsed.query;
	  } else if (opts && 'object' === typeof opts.query) {
	    opts.query = encodeQueryString(opts.query);
	  }
	  return io.socket(parsed.path, opts);
	}
	/**
	 *  Helper method to parse query objects to string.
	 * @param {object} query
	 * @returns {string}
	 */
	function encodeQueryString (obj) {
	  var str = [];
	  for (var p in obj) {
	    if (obj.hasOwnProperty(p)) {
	      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
	    }
	  }
	  return str.join('&');
	}
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = parser.protocol;
	
	/**
	 * `connect`.
	 *
	 * @param {String} uri
	 * @api public
	 */
	
	exports.connect = lookup;
	
	/**
	 * Expose constructors for standalone build.
	 *
	 * @api public
	 */
	
	exports.Manager = __webpack_require__(404);
	exports.Socket = __webpack_require__(431);


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module dependencies.
	 */
	
	var parseuri = __webpack_require__(393);
	var debug = __webpack_require__(394)('socket.io-client:url');
	
	/**
	 * Module exports.
	 */
	
	module.exports = url;
	
	/**
	 * URL parser.
	 *
	 * @param {String} url
	 * @param {Object} An object meant to mimic window.location.
	 *                 Defaults to window.location.
	 * @api public
	 */
	
	function url (uri, loc) {
	  var obj = uri;
	
	  // default to window.location
	  loc = loc || global.location;
	  if (null == uri) uri = loc.protocol + '//' + loc.host;
	
	  // relative path support
	  if ('string' === typeof uri) {
	    if ('/' === uri.charAt(0)) {
	      if ('/' === uri.charAt(1)) {
	        uri = loc.protocol + uri;
	      } else {
	        uri = loc.host + uri;
	      }
	    }
	
	    if (!/^(https?|wss?):\/\//.test(uri)) {
	      debug('protocol-less url %s', uri);
	      if ('undefined' !== typeof loc) {
	        uri = loc.protocol + '//' + uri;
	      } else {
	        uri = 'https://' + uri;
	      }
	    }
	
	    // parse
	    debug('parse %s', uri);
	    obj = parseuri(uri);
	  }
	
	  // make sure we treat `localhost:80` and `localhost` equally
	  if (!obj.port) {
	    if (/^(http|ws)$/.test(obj.protocol)) {
	      obj.port = '80';
	    } else if (/^(http|ws)s$/.test(obj.protocol)) {
	      obj.port = '443';
	    }
	  }
	
	  obj.path = obj.path || '/';
	
	  var ipv6 = obj.host.indexOf(':') !== -1;
	  var host = ipv6 ? '[' + obj.host + ']' : obj.host;
	
	  // define unique id
	  obj.id = obj.protocol + '://' + host + ':' + obj.port;
	  // define href
	  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));
	
	  return obj;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * Parses an URI
	 *
	 * @author Steven Levithan <stevenlevithan.com> (MIT license)
	 * @api private
	 */
	
	var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
	
	var parts = [
	    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
	];
	
	module.exports = function parseuri(str) {
	    var src = str,
	        b = str.indexOf('['),
	        e = str.indexOf(']');
	
	    if (b != -1 && e != -1) {
	        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
	    }
	
	    var m = re.exec(str || ''),
	        uri = {},
	        i = 14;
	
	    while (i--) {
	        uri[parts[i]] = m[i] || '';
	    }
	
	    if (b != -1 && e != -1) {
	        uri.source = src;
	        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
	        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
	        uri.ipv6uri = true;
	    }
	
	    return uri;
	};


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(395);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(396);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 396 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var debug = __webpack_require__(394)('socket.io-parser');
	var json = __webpack_require__(398);
	var Emitter = __webpack_require__(400);
	var binary = __webpack_require__(401);
	var isBuf = __webpack_require__(403);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	exports.protocol = 4;
	
	/**
	 * Packet types.
	 *
	 * @api public
	 */
	
	exports.types = [
	  'CONNECT',
	  'DISCONNECT',
	  'EVENT',
	  'ACK',
	  'ERROR',
	  'BINARY_EVENT',
	  'BINARY_ACK'
	];
	
	/**
	 * Packet type `connect`.
	 *
	 * @api public
	 */
	
	exports.CONNECT = 0;
	
	/**
	 * Packet type `disconnect`.
	 *
	 * @api public
	 */
	
	exports.DISCONNECT = 1;
	
	/**
	 * Packet type `event`.
	 *
	 * @api public
	 */
	
	exports.EVENT = 2;
	
	/**
	 * Packet type `ack`.
	 *
	 * @api public
	 */
	
	exports.ACK = 3;
	
	/**
	 * Packet type `error`.
	 *
	 * @api public
	 */
	
	exports.ERROR = 4;
	
	/**
	 * Packet type 'binary event'
	 *
	 * @api public
	 */
	
	exports.BINARY_EVENT = 5;
	
	/**
	 * Packet type `binary ack`. For acks with binary arguments.
	 *
	 * @api public
	 */
	
	exports.BINARY_ACK = 6;
	
	/**
	 * Encoder constructor.
	 *
	 * @api public
	 */
	
	exports.Encoder = Encoder;
	
	/**
	 * Decoder constructor.
	 *
	 * @api public
	 */
	
	exports.Decoder = Decoder;
	
	/**
	 * A socket.io Encoder instance
	 *
	 * @api public
	 */
	
	function Encoder() {}
	
	/**
	 * Encode a packet as a single string if non-binary, or as a
	 * buffer sequence, depending on packet type.
	 *
	 * @param {Object} obj - packet object
	 * @param {Function} callback - function to handle encodings (likely engine.write)
	 * @return Calls callback with Array of encodings
	 * @api public
	 */
	
	Encoder.prototype.encode = function(obj, callback){
	  debug('encoding packet %j', obj);
	
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    encodeAsBinary(obj, callback);
	  }
	  else {
	    var encoding = encodeAsString(obj);
	    callback([encoding]);
	  }
	};
	
	/**
	 * Encode packet as string.
	 *
	 * @param {Object} packet
	 * @return {String} encoded
	 * @api private
	 */
	
	function encodeAsString(obj) {
	  var str = '';
	  var nsp = false;
	
	  // first is type
	  str += obj.type;
	
	  // attachments if we have them
	  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
	    str += obj.attachments;
	    str += '-';
	  }
	
	  // if we have a namespace other than `/`
	  // we append it followed by a comma `,`
	  if (obj.nsp && '/' != obj.nsp) {
	    nsp = true;
	    str += obj.nsp;
	  }
	
	  // immediately followed by the id
	  if (null != obj.id) {
	    if (nsp) {
	      str += ',';
	      nsp = false;
	    }
	    str += obj.id;
	  }
	
	  // json data
	  if (null != obj.data) {
	    if (nsp) str += ',';
	    str += json.stringify(obj.data);
	  }
	
	  debug('encoded %j as %s', obj, str);
	  return str;
	}
	
	/**
	 * Encode packet as 'buffer sequence' by removing blobs, and
	 * deconstructing packet into object with placeholders and
	 * a list of buffers.
	 *
	 * @param {Object} packet
	 * @return {Buffer} encoded
	 * @api private
	 */
	
	function encodeAsBinary(obj, callback) {
	
	  function writeEncoding(bloblessData) {
	    var deconstruction = binary.deconstructPacket(bloblessData);
	    var pack = encodeAsString(deconstruction.packet);
	    var buffers = deconstruction.buffers;
	
	    buffers.unshift(pack); // add packet info to beginning of data list
	    callback(buffers); // write all the buffers
	  }
	
	  binary.removeBlobs(obj, writeEncoding);
	}
	
	/**
	 * A socket.io Decoder instance
	 *
	 * @return {Object} decoder
	 * @api public
	 */
	
	function Decoder() {
	  this.reconstructor = null;
	}
	
	/**
	 * Mix in `Emitter` with Decoder.
	 */
	
	Emitter(Decoder.prototype);
	
	/**
	 * Decodes an ecoded packet string into packet JSON.
	 *
	 * @param {String} obj - encoded packet
	 * @return {Object} packet
	 * @api public
	 */
	
	Decoder.prototype.add = function(obj) {
	  var packet;
	  if ('string' == typeof obj) {
	    packet = decodeString(obj);
	    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
	      this.reconstructor = new BinaryReconstructor(packet);
	
	      // no attachments, labeled binary but no binary data to follow
	      if (this.reconstructor.reconPack.attachments === 0) {
	        this.emit('decoded', packet);
	      }
	    } else { // non-binary full packet
	      this.emit('decoded', packet);
	    }
	  }
	  else if (isBuf(obj) || obj.base64) { // raw binary data
	    if (!this.reconstructor) {
	      throw new Error('got binary data when not reconstructing a packet');
	    } else {
	      packet = this.reconstructor.takeBinaryData(obj);
	      if (packet) { // received final buffer
	        this.reconstructor = null;
	        this.emit('decoded', packet);
	      }
	    }
	  }
	  else {
	    throw new Error('Unknown type: ' + obj);
	  }
	};
	
	/**
	 * Decode a packet String (JSON data)
	 *
	 * @param {String} str
	 * @return {Object} packet
	 * @api private
	 */
	
	function decodeString(str) {
	  var p = {};
	  var i = 0;
	
	  // look up type
	  p.type = Number(str.charAt(0));
	  if (null == exports.types[p.type]) return error();
	
	  // look up attachments if type binary
	  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
	    var buf = '';
	    while (str.charAt(++i) != '-') {
	      buf += str.charAt(i);
	      if (i == str.length) break;
	    }
	    if (buf != Number(buf) || str.charAt(i) != '-') {
	      throw new Error('Illegal attachments');
	    }
	    p.attachments = Number(buf);
	  }
	
	  // look up namespace (if any)
	  if ('/' == str.charAt(i + 1)) {
	    p.nsp = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (',' == c) break;
	      p.nsp += c;
	      if (i == str.length) break;
	    }
	  } else {
	    p.nsp = '/';
	  }
	
	  // look up id
	  var next = str.charAt(i + 1);
	  if ('' !== next && Number(next) == next) {
	    p.id = '';
	    while (++i) {
	      var c = str.charAt(i);
	      if (null == c || Number(c) != c) {
	        --i;
	        break;
	      }
	      p.id += str.charAt(i);
	      if (i == str.length) break;
	    }
	    p.id = Number(p.id);
	  }
	
	  // look up json data
	  if (str.charAt(++i)) {
	    p = tryParse(p, str.substr(i));
	  }
	
	  debug('decoded %s as %j', str, p);
	  return p;
	}
	
	function tryParse(p, str) {
	  try {
	    p.data = json.parse(str);
	  } catch(e){
	    return error();
	  }
	  return p; 
	};
	
	/**
	 * Deallocates a parser's resources
	 *
	 * @api public
	 */
	
	Decoder.prototype.destroy = function() {
	  if (this.reconstructor) {
	    this.reconstructor.finishedReconstruction();
	  }
	};
	
	/**
	 * A manager of a binary event's 'buffer sequence'. Should
	 * be constructed whenever a packet of type BINARY_EVENT is
	 * decoded.
	 *
	 * @param {Object} packet
	 * @return {BinaryReconstructor} initialized reconstructor
	 * @api private
	 */
	
	function BinaryReconstructor(packet) {
	  this.reconPack = packet;
	  this.buffers = [];
	}
	
	/**
	 * Method to be called when binary data received from connection
	 * after a BINARY_EVENT packet.
	 *
	 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
	 * @return {null | Object} returns null if more binary data is expected or
	 *   a reconstructed packet object if all buffers have been received.
	 * @api private
	 */
	
	BinaryReconstructor.prototype.takeBinaryData = function(binData) {
	  this.buffers.push(binData);
	  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
	    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
	    this.finishedReconstruction();
	    return packet;
	  }
	  return null;
	};
	
	/**
	 * Cleans up binary packet reconstruction variables.
	 *
	 * @api private
	 */
	
	BinaryReconstructor.prototype.finishedReconstruction = function() {
	  this.reconPack = null;
	  this.buffers = [];
	};
	
	function error(data){
	  return {
	    type: exports.ERROR,
	    data: 'parser error'
	  };
	}


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
	;(function () {
	  // Detect the `define` function exposed by asynchronous module loaders. The
	  // strict `define` check is necessary for compatibility with `r.js`.
	  var isLoader = "function" === "function" && __webpack_require__(399);
	
	  // A set of types used to distinguish objects from primitives.
	  var objectTypes = {
	    "function": true,
	    "object": true
	  };
	
	  // Detect the `exports` object exposed by CommonJS implementations.
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  // Use the `global` object exposed by Node (including Browserify via
	  // `insert-module-globals`), Narwhal, and Ringo as the default context,
	  // and the `window` object in browsers. Rhino exports a `global` function
	  // instead.
	  var root = objectTypes[typeof window] && window || this,
	      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;
	
	  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  // Public: Initializes JSON 3 using the given `context` object, attaching the
	  // `stringify` and `parse` functions to the specified `exports` object.
	  function runInContext(context, exports) {
	    context || (context = root["Object"]());
	    exports || (exports = root["Object"]());
	
	    // Native constructor aliases.
	    var Number = context["Number"] || root["Number"],
	        String = context["String"] || root["String"],
	        Object = context["Object"] || root["Object"],
	        Date = context["Date"] || root["Date"],
	        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
	        TypeError = context["TypeError"] || root["TypeError"],
	        Math = context["Math"] || root["Math"],
	        nativeJSON = context["JSON"] || root["JSON"];
	
	    // Delegate to the native `stringify` and `parse` implementations.
	    if (typeof nativeJSON == "object" && nativeJSON) {
	      exports.stringify = nativeJSON.stringify;
	      exports.parse = nativeJSON.parse;
	    }
	
	    // Convenience aliases.
	    var objectProto = Object.prototype,
	        getClass = objectProto.toString,
	        isProperty, forEach, undef;
	
	    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
	    var isExtended = new Date(-3509827334573292);
	    try {
	      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
	      // results for certain dates in Opera >= 10.53.
	      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
	        // Safari < 2.0.2 stores the internal millisecond time value correctly,
	        // but clips the values returned by the date methods to the range of
	        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
	        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
	    } catch (exception) {}
	
	    // Internal: Determines whether the native `JSON.stringify` and `parse`
	    // implementations are spec-compliant. Based on work by Ken Snyder.
	    function has(name) {
	      if (has[name] !== undef) {
	        // Return cached feature test result.
	        return has[name];
	      }
	      var isSupported;
	      if (name == "bug-string-char-index") {
	        // IE <= 7 doesn't support accessing string characters using square
	        // bracket notation. IE 8 only supports this for primitives.
	        isSupported = "a"[0] != "a";
	      } else if (name == "json") {
	        // Indicates whether both `JSON.stringify` and `JSON.parse` are
	        // supported.
	        isSupported = has("json-stringify") && has("json-parse");
	      } else {
	        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
	        // Test `JSON.stringify`.
	        if (name == "json-stringify") {
	          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
	          if (stringifySupported) {
	            // A test function object with a custom `toJSON` method.
	            (value = function () {
	              return 1;
	            }).toJSON = value;
	            try {
	              stringifySupported =
	                // Firefox 3.1b1 and b2 serialize string, number, and boolean
	                // primitives as object literals.
	                stringify(0) === "0" &&
	                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
	                // literals.
	                stringify(new Number()) === "0" &&
	                stringify(new String()) == '""' &&
	                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
	                // does not define a canonical JSON representation (this applies to
	                // objects with `toJSON` properties as well, *unless* they are nested
	                // within an object or array).
	                stringify(getClass) === undef &&
	                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
	                // FF 3.1b3 pass this test.
	                stringify(undef) === undef &&
	                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
	                // respectively, if the value is omitted entirely.
	                stringify() === undef &&
	                // FF 3.1b1, 2 throw an error if the given value is not a number,
	                // string, array, object, Boolean, or `null` literal. This applies to
	                // objects with custom `toJSON` methods as well, unless they are nested
	                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
	                // methods entirely.
	                stringify(value) === "1" &&
	                stringify([value]) == "[1]" &&
	                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
	                // `"[null]"`.
	                stringify([undef]) == "[null]" &&
	                // YUI 3.0.0b1 fails to serialize `null` literals.
	                stringify(null) == "null" &&
	                // FF 3.1b1, 2 halts serialization if an array contains a function:
	                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
	                // elides non-JSON values from objects and arrays, unless they
	                // define custom `toJSON` methods.
	                stringify([undef, getClass, null]) == "[null,null,null]" &&
	                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
	                // where character escape codes are expected (e.g., `\b` => `\u0008`).
	                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
	                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
	                stringify(null, value) === "1" &&
	                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
	                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
	                // serialize extended years.
	                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
	                // The milliseconds are optional in ES 5, but required in 5.1.
	                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
	                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
	                // four-digit years instead of six-digit years. Credits: @Yaffle.
	                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
	                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
	                // values less than 1000. Credits: @Yaffle.
	                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
	            } catch (exception) {
	              stringifySupported = false;
	            }
	          }
	          isSupported = stringifySupported;
	        }
	        // Test `JSON.parse`.
	        if (name == "json-parse") {
	          var parse = exports.parse;
	          if (typeof parse == "function") {
	            try {
	              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
	              // Conforming implementations should also coerce the initial argument to
	              // a string prior to parsing.
	              if (parse("0") === 0 && !parse(false)) {
	                // Simple parsing test.
	                value = parse(serialized);
	                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
	                if (parseSupported) {
	                  try {
	                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
	                    parseSupported = !parse('"\t"');
	                  } catch (exception) {}
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
	                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
	                      // certain octal literals.
	                      parseSupported = parse("01") !== 1;
	                    } catch (exception) {}
	                  }
	                  if (parseSupported) {
	                    try {
	                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
	                      // points. These environments, along with FF 3.1b1 and 2,
	                      // also allow trailing commas in JSON objects and arrays.
	                      parseSupported = parse("1.") !== 1;
	                    } catch (exception) {}
	                  }
	                }
	              }
	            } catch (exception) {
	              parseSupported = false;
	            }
	          }
	          isSupported = parseSupported;
	        }
	      }
	      return has[name] = !!isSupported;
	    }
	
	    if (!has("json")) {
	      // Common `[[Class]]` name aliases.
	      var functionClass = "[object Function]",
	          dateClass = "[object Date]",
	          numberClass = "[object Number]",
	          stringClass = "[object String]",
	          arrayClass = "[object Array]",
	          booleanClass = "[object Boolean]";
	
	      // Detect incomplete support for accessing string characters by index.
	      var charIndexBuggy = has("bug-string-char-index");
	
	      // Define additional utility methods if the `Date` methods are buggy.
	      if (!isExtended) {
	        var floor = Math.floor;
	        // A mapping between the months of the year and the number of days between
	        // January 1st and the first of the respective month.
	        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
	        // Internal: Calculates the number of days between the Unix epoch and the
	        // first day of the given month.
	        var getDay = function (year, month) {
	          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
	        };
	      }
	
	      // Internal: Determines if a property is a direct property of the given
	      // object. Delegates to the native `Object#hasOwnProperty` method.
	      if (!(isProperty = objectProto.hasOwnProperty)) {
	        isProperty = function (property) {
	          var members = {}, constructor;
	          if ((members.__proto__ = null, members.__proto__ = {
	            // The *proto* property cannot be set multiple times in recent
	            // versions of Firefox and SeaMonkey.
	            "toString": 1
	          }, members).toString != getClass) {
	            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
	            // supports the mutable *proto* property.
	            isProperty = function (property) {
	              // Capture and break the object's prototype chain (see section 8.6.2
	              // of the ES 5.1 spec). The parenthesized expression prevents an
	              // unsafe transformation by the Closure Compiler.
	              var original = this.__proto__, result = property in (this.__proto__ = null, this);
	              // Restore the original prototype chain.
	              this.__proto__ = original;
	              return result;
	            };
	          } else {
	            // Capture a reference to the top-level `Object` constructor.
	            constructor = members.constructor;
	            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
	            // other environments.
	            isProperty = function (property) {
	              var parent = (this.constructor || constructor).prototype;
	              return property in this && !(property in parent && this[property] === parent[property]);
	            };
	          }
	          members = null;
	          return isProperty.call(this, property);
	        };
	      }
	
	      // Internal: Normalizes the `for...in` iteration algorithm across
	      // environments. Each enumerated key is yielded to a `callback` function.
	      forEach = function (object, callback) {
	        var size = 0, Properties, members, property;
	
	        // Tests for bugs in the current environment's `for...in` algorithm. The
	        // `valueOf` property inherits the non-enumerable flag from
	        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
	        (Properties = function () {
	          this.valueOf = 0;
	        }).prototype.valueOf = 0;
	
	        // Iterate over a new instance of the `Properties` class.
	        members = new Properties();
	        for (property in members) {
	          // Ignore all properties inherited from `Object.prototype`.
	          if (isProperty.call(members, property)) {
	            size++;
	          }
	        }
	        Properties = members = null;
	
	        // Normalize the iteration algorithm.
	        if (!size) {
	          // A list of non-enumerable properties inherited from `Object.prototype`.
	          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
	          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
	          // properties.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, length;
	            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
	            for (property in object) {
	              // Gecko <= 1.0 enumerates the `prototype` property of functions under
	              // certain conditions; IE does not.
	              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for each non-enumerable property.
	            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
	          };
	        } else if (size == 2) {
	          // Safari <= 2.0.4 enumerates shadowed properties twice.
	          forEach = function (object, callback) {
	            // Create a set of iterated properties.
	            var members = {}, isFunction = getClass.call(object) == functionClass, property;
	            for (property in object) {
	              // Store each property name to prevent double enumeration. The
	              // `prototype` property of functions is not enumerated due to cross-
	              // environment inconsistencies.
	              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
	                callback(property);
	              }
	            }
	          };
	        } else {
	          // No bugs detected; use the standard `for...in` algorithm.
	          forEach = function (object, callback) {
	            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
	            for (property in object) {
	              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
	                callback(property);
	              }
	            }
	            // Manually invoke the callback for the `constructor` property due to
	            // cross-environment inconsistencies.
	            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
	              callback(property);
	            }
	          };
	        }
	        return forEach(object, callback);
	      };
	
	      // Public: Serializes a JavaScript `value` as a JSON string. The optional
	      // `filter` argument may specify either a function that alters how object and
	      // array members are serialized, or an array of strings and numbers that
	      // indicates which properties should be serialized. The optional `width`
	      // argument may be either a string or number that specifies the indentation
	      // level of the output.
	      if (!has("json-stringify")) {
	        // Internal: A map of control characters and their escaped equivalents.
	        var Escapes = {
	          92: "\\\\",
	          34: '\\"',
	          8: "\\b",
	          12: "\\f",
	          10: "\\n",
	          13: "\\r",
	          9: "\\t"
	        };
	
	        // Internal: Converts `value` into a zero-padded string such that its
	        // length is at least equal to `width`. The `width` must be <= 6.
	        var leadingZeroes = "000000";
	        var toPaddedString = function (width, value) {
	          // The `|| 0` expression is necessary to work around a bug in
	          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
	          return (leadingZeroes + (value || 0)).slice(-width);
	        };
	
	        // Internal: Double-quotes a string `value`, replacing all ASCII control
	        // characters (characters with code unit values between 0 and 31) with
	        // their escaped equivalents. This is an implementation of the
	        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
	        var unicodePrefix = "\\u00";
	        var quote = function (value) {
	          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
	          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
	          for (; index < length; index++) {
	            var charCode = value.charCodeAt(index);
	            // If the character is a control character, append its Unicode or
	            // shorthand escape sequence; otherwise, append the character as-is.
	            switch (charCode) {
	              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
	                result += Escapes[charCode];
	                break;
	              default:
	                if (charCode < 32) {
	                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
	                  break;
	                }
	                result += useCharIndex ? symbols[index] : value.charAt(index);
	            }
	          }
	          return result + '"';
	        };
	
	        // Internal: Recursively serializes an object. Implements the
	        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
	        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
	          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
	          try {
	            // Necessary for host object support.
	            value = object[property];
	          } catch (exception) {}
	          if (typeof value == "object" && value) {
	            className = getClass.call(value);
	            if (className == dateClass && !isProperty.call(value, "toJSON")) {
	              if (value > -1 / 0 && value < 1 / 0) {
	                // Dates are serialized according to the `Date#toJSON` method
	                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
	                // for the ISO 8601 date time string format.
	                if (getDay) {
	                  // Manually compute the year, month, date, hours, minutes,
	                  // seconds, and milliseconds if the `getUTC*` methods are
	                  // buggy. Adapted from @Yaffle's `date-shim` project.
	                  date = floor(value / 864e5);
	                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
	                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
	                  date = 1 + date - getDay(year, month);
	                  // The `time` value specifies the time within the day (see ES
	                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
	                  // to compute `A modulo B`, as the `%` operator does not
	                  // correspond to the `modulo` operation for negative numbers.
	                  time = (value % 864e5 + 864e5) % 864e5;
	                  // The hours, minutes, seconds, and milliseconds are obtained by
	                  // decomposing the time within the day. See section 15.9.1.10.
	                  hours = floor(time / 36e5) % 24;
	                  minutes = floor(time / 6e4) % 60;
	                  seconds = floor(time / 1e3) % 60;
	                  milliseconds = time % 1e3;
	                } else {
	                  year = value.getUTCFullYear();
	                  month = value.getUTCMonth();
	                  date = value.getUTCDate();
	                  hours = value.getUTCHours();
	                  minutes = value.getUTCMinutes();
	                  seconds = value.getUTCSeconds();
	                  milliseconds = value.getUTCMilliseconds();
	                }
	                // Serialize extended years correctly.
	                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
	                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
	                  // Months, dates, hours, minutes, and seconds should have two
	                  // digits; milliseconds should have three.
	                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
	                  // Milliseconds are optional in ES 5.0, but required in 5.1.
	                  "." + toPaddedString(3, milliseconds) + "Z";
	              } else {
	                value = null;
	              }
	            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
	              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
	              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
	              // ignores all `toJSON` methods on these objects unless they are
	              // defined directly on an instance.
	              value = value.toJSON(property);
	            }
	          }
	          if (callback) {
	            // If a replacement function was provided, call it to obtain the value
	            // for serialization.
	            value = callback.call(object, property, value);
	          }
	          if (value === null) {
	            return "null";
	          }
	          className = getClass.call(value);
	          if (className == booleanClass) {
	            // Booleans are represented literally.
	            return "" + value;
	          } else if (className == numberClass) {
	            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
	            // `"null"`.
	            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
	          } else if (className == stringClass) {
	            // Strings are double-quoted and escaped.
	            return quote("" + value);
	          }
	          // Recursively serialize objects and arrays.
	          if (typeof value == "object") {
	            // Check for cyclic structures. This is a linear search; performance
	            // is inversely proportional to the number of unique nested objects.
	            for (length = stack.length; length--;) {
	              if (stack[length] === value) {
	                // Cyclic structures cannot be serialized by `JSON.stringify`.
	                throw TypeError();
	              }
	            }
	            // Add the object to the stack of traversed objects.
	            stack.push(value);
	            results = [];
	            // Save the current indentation level and indent one additional level.
	            prefix = indentation;
	            indentation += whitespace;
	            if (className == arrayClass) {
	              // Recursively serialize array elements.
	              for (index = 0, length = value.length; index < length; index++) {
	                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
	                results.push(element === undef ? "null" : element);
	              }
	              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
	            } else {
	              // Recursively serialize object members. Members are selected from
	              // either a user-specified list of property names, or the object
	              // itself.
	              forEach(properties || value, function (property) {
	                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
	                if (element !== undef) {
	                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
	                  // is not the empty string, let `member` {quote(property) + ":"}
	                  // be the concatenation of `member` and the `space` character."
	                  // The "`space` character" refers to the literal space
	                  // character, not the `space` {width} argument provided to
	                  // `JSON.stringify`.
	                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
	                }
	              });
	              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
	            }
	            // Remove the object from the traversed object stack.
	            stack.pop();
	            return result;
	          }
	        };
	
	        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
	        exports.stringify = function (source, filter, width) {
	          var whitespace, callback, properties, className;
	          if (objectTypes[typeof filter] && filter) {
	            if ((className = getClass.call(filter)) == functionClass) {
	              callback = filter;
	            } else if (className == arrayClass) {
	              // Convert the property names array into a makeshift set.
	              properties = {};
	              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
	            }
	          }
	          if (width) {
	            if ((className = getClass.call(width)) == numberClass) {
	              // Convert the `width` to an integer and create a string containing
	              // `width` number of space characters.
	              if ((width -= width % 1) > 0) {
	                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
	              }
	            } else if (className == stringClass) {
	              whitespace = width.length <= 10 ? width : width.slice(0, 10);
	            }
	          }
	          // Opera <= 7.54u2 discards the values associated with empty string keys
	          // (`""`) only if they are used directly within an object member list
	          // (e.g., `!("" in { "": 1})`).
	          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
	        };
	      }
	
	      // Public: Parses a JSON source string.
	      if (!has("json-parse")) {
	        var fromCharCode = String.fromCharCode;
	
	        // Internal: A map of escaped control characters and their unescaped
	        // equivalents.
	        var Unescapes = {
	          92: "\\",
	          34: '"',
	          47: "/",
	          98: "\b",
	          116: "\t",
	          110: "\n",
	          102: "\f",
	          114: "\r"
	        };
	
	        // Internal: Stores the parser state.
	        var Index, Source;
	
	        // Internal: Resets the parser state and throws a `SyntaxError`.
	        var abort = function () {
	          Index = Source = null;
	          throw SyntaxError();
	        };
	
	        // Internal: Returns the next token, or `"$"` if the parser has reached
	        // the end of the source string. A token may be a string, number, `null`
	        // literal, or Boolean literal.
	        var lex = function () {
	          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
	          while (Index < length) {
	            charCode = source.charCodeAt(Index);
	            switch (charCode) {
	              case 9: case 10: case 13: case 32:
	                // Skip whitespace tokens, including tabs, carriage returns, line
	                // feeds, and space characters.
	                Index++;
	                break;
	              case 123: case 125: case 91: case 93: case 58: case 44:
	                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
	                // the current position.
	                value = charIndexBuggy ? source.charAt(Index) : source[Index];
	                Index++;
	                return value;
	              case 34:
	                // `"` delimits a JSON string; advance to the next character and
	                // begin parsing the string. String tokens are prefixed with the
	                // sentinel `@` character to distinguish them from punctuators and
	                // end-of-string tokens.
	                for (value = "@", Index++; Index < length;) {
	                  charCode = source.charCodeAt(Index);
	                  if (charCode < 32) {
	                    // Unescaped ASCII control characters (those with a code unit
	                    // less than the space character) are not permitted.
	                    abort();
	                  } else if (charCode == 92) {
	                    // A reverse solidus (`\`) marks the beginning of an escaped
	                    // control character (including `"`, `\`, and `/`) or Unicode
	                    // escape sequence.
	                    charCode = source.charCodeAt(++Index);
	                    switch (charCode) {
	                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
	                        // Revive escaped control characters.
	                        value += Unescapes[charCode];
	                        Index++;
	                        break;
	                      case 117:
	                        // `\u` marks the beginning of a Unicode escape sequence.
	                        // Advance to the first character and validate the
	                        // four-digit code point.
	                        begin = ++Index;
	                        for (position = Index + 4; Index < position; Index++) {
	                          charCode = source.charCodeAt(Index);
	                          // A valid sequence comprises four hexdigits (case-
	                          // insensitive) that form a single hexadecimal value.
	                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
	                            // Invalid Unicode escape sequence.
	                            abort();
	                          }
	                        }
	                        // Revive the escaped character.
	                        value += fromCharCode("0x" + source.slice(begin, Index));
	                        break;
	                      default:
	                        // Invalid escape sequence.
	                        abort();
	                    }
	                  } else {
	                    if (charCode == 34) {
	                      // An unescaped double-quote character marks the end of the
	                      // string.
	                      break;
	                    }
	                    charCode = source.charCodeAt(Index);
	                    begin = Index;
	                    // Optimize for the common case where a string is valid.
	                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
	                      charCode = source.charCodeAt(++Index);
	                    }
	                    // Append the string as-is.
	                    value += source.slice(begin, Index);
	                  }
	                }
	                if (source.charCodeAt(Index) == 34) {
	                  // Advance to the next character and return the revived string.
	                  Index++;
	                  return value;
	                }
	                // Unterminated string.
	                abort();
	              default:
	                // Parse numbers and literals.
	                begin = Index;
	                // Advance past the negative sign, if one is specified.
	                if (charCode == 45) {
	                  isSigned = true;
	                  charCode = source.charCodeAt(++Index);
	                }
	                // Parse an integer or floating-point value.
	                if (charCode >= 48 && charCode <= 57) {
	                  // Leading zeroes are interpreted as octal literals.
	                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
	                    // Illegal octal literal.
	                    abort();
	                  }
	                  isSigned = false;
	                  // Parse the integer component.
	                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
	                  // Floats cannot contain a leading decimal point; however, this
	                  // case is already accounted for by the parser.
	                  if (source.charCodeAt(Index) == 46) {
	                    position = ++Index;
	                    // Parse the decimal component.
	                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal trailing decimal.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Parse exponents. The `e` denoting the exponent is
	                  // case-insensitive.
	                  charCode = source.charCodeAt(Index);
	                  if (charCode == 101 || charCode == 69) {
	                    charCode = source.charCodeAt(++Index);
	                    // Skip past the sign following the exponent, if one is
	                    // specified.
	                    if (charCode == 43 || charCode == 45) {
	                      Index++;
	                    }
	                    // Parse the exponential component.
	                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
	                    if (position == Index) {
	                      // Illegal empty exponent.
	                      abort();
	                    }
	                    Index = position;
	                  }
	                  // Coerce the parsed value to a JavaScript number.
	                  return +source.slice(begin, Index);
	                }
	                // A negative sign may only precede numbers.
	                if (isSigned) {
	                  abort();
	                }
	                // `true`, `false`, and `null` literals.
	                if (source.slice(Index, Index + 4) == "true") {
	                  Index += 4;
	                  return true;
	                } else if (source.slice(Index, Index + 5) == "false") {
	                  Index += 5;
	                  return false;
	                } else if (source.slice(Index, Index + 4) == "null") {
	                  Index += 4;
	                  return null;
	                }
	                // Unrecognized token.
	                abort();
	            }
	          }
	          // Return the sentinel `$` character if the parser has reached the end
	          // of the source string.
	          return "$";
	        };
	
	        // Internal: Parses a JSON `value` token.
	        var get = function (value) {
	          var results, hasMembers;
	          if (value == "$") {
	            // Unexpected end of input.
	            abort();
	          }
	          if (typeof value == "string") {
	            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
	              // Remove the sentinel `@` character.
	              return value.slice(1);
	            }
	            // Parse object and array literals.
	            if (value == "[") {
	              // Parses a JSON array, returning a new JavaScript array.
	              results = [];
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing square bracket marks the end of the array literal.
	                if (value == "]") {
	                  break;
	                }
	                // If the array literal contains elements, the current token
	                // should be a comma separating the previous element from the
	                // next.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "]") {
	                      // Unexpected trailing `,` in array literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each array element.
	                    abort();
	                  }
	                }
	                // Elisions and leading commas are not permitted.
	                if (value == ",") {
	                  abort();
	                }
	                results.push(get(value));
	              }
	              return results;
	            } else if (value == "{") {
	              // Parses a JSON object, returning a new JavaScript object.
	              results = {};
	              for (;; hasMembers || (hasMembers = true)) {
	                value = lex();
	                // A closing curly brace marks the end of the object literal.
	                if (value == "}") {
	                  break;
	                }
	                // If the object literal contains members, the current token
	                // should be a comma separator.
	                if (hasMembers) {
	                  if (value == ",") {
	                    value = lex();
	                    if (value == "}") {
	                      // Unexpected trailing `,` in object literal.
	                      abort();
	                    }
	                  } else {
	                    // A `,` must separate each object member.
	                    abort();
	                  }
	                }
	                // Leading commas are not permitted, object property names must be
	                // double-quoted strings, and a `:` must separate each property
	                // name and value.
	                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
	                  abort();
	                }
	                results[value.slice(1)] = get(lex());
	              }
	              return results;
	            }
	            // Unexpected token encountered.
	            abort();
	          }
	          return value;
	        };
	
	        // Internal: Updates a traversed object member.
	        var update = function (source, property, callback) {
	          var element = walk(source, property, callback);
	          if (element === undef) {
	            delete source[property];
	          } else {
	            source[property] = element;
	          }
	        };
	
	        // Internal: Recursively traverses a parsed JSON object, invoking the
	        // `callback` function for each value. This is an implementation of the
	        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
	        var walk = function (source, property, callback) {
	          var value = source[property], length;
	          if (typeof value == "object" && value) {
	            // `forEach` can't be used to traverse an array in Opera <= 8.54
	            // because its `Object#hasOwnProperty` implementation returns `false`
	            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
	            if (getClass.call(value) == arrayClass) {
	              for (length = value.length; length--;) {
	                update(value, length, callback);
	              }
	            } else {
	              forEach(value, function (property) {
	                update(value, property, callback);
	              });
	            }
	          }
	          return callback.call(source, property, value);
	        };
	
	        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
	        exports.parse = function (source, callback) {
	          var result, value;
	          Index = 0;
	          Source = "" + source;
	          result = get(lex());
	          // If a JSON string contains multiple tokens, it is invalid.
	          if (lex() != "$") {
	            abort();
	          }
	          // Reset the parser state.
	          Index = Source = null;
	          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
	        };
	      }
	    }
	
	    exports["runInContext"] = runInContext;
	    return exports;
	  }
	
	  if (freeExports && !isLoader) {
	    // Export for CommonJS environments.
	    runInContext(root, freeExports);
	  } else {
	    // Export for web browsers and JavaScript engines.
	    var nativeJSON = root.JSON,
	        previousJSON = root["JSON3"],
	        isRestored = false;
	
	    var JSON3 = runInContext(root, (root["JSON3"] = {
	      // Public: Restores the original value of the global `JSON` object and
	      // returns a reference to the `JSON3` object.
	      "noConflict": function () {
	        if (!isRestored) {
	          isRestored = true;
	          root.JSON = nativeJSON;
	          root["JSON3"] = previousJSON;
	          nativeJSON = previousJSON = null;
	        }
	        return JSON3;
	      }
	    }));
	
	    root.JSON = {
	      "parse": JSON3.parse,
	      "stringify": JSON3.stringify
	    };
	  }
	
	  // Export for asynchronous module loaders.
	  if (isLoader) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return JSON3;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), (function() { return this; }())))

/***/ },
/* 399 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 400 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks[event] = this._callbacks[event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  var self = this;
	  this._callbacks = this._callbacks || {};
	
	  function on() {
	    self.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks[event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks[event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks[event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks[event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/
	
	/**
	 * Module requirements
	 */
	
	var isArray = __webpack_require__(402);
	var isBuf = __webpack_require__(403);
	
	/**
	 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
	 * Anything with blobs or files should be fed through removeBlobs before coming
	 * here.
	 *
	 * @param {Object} packet - socket.io event packet
	 * @return {Object} with deconstructed packet and list of buffers
	 * @api public
	 */
	
	exports.deconstructPacket = function(packet){
	  var buffers = [];
	  var packetData = packet.data;
	
	  function _deconstructPacket(data) {
	    if (!data) return data;
	
	    if (isBuf(data)) {
	      var placeholder = { _placeholder: true, num: buffers.length };
	      buffers.push(data);
	      return placeholder;
	    } else if (isArray(data)) {
	      var newData = new Array(data.length);
	      for (var i = 0; i < data.length; i++) {
	        newData[i] = _deconstructPacket(data[i]);
	      }
	      return newData;
	    } else if ('object' == typeof data && !(data instanceof Date)) {
	      var newData = {};
	      for (var key in data) {
	        newData[key] = _deconstructPacket(data[key]);
	      }
	      return newData;
	    }
	    return data;
	  }
	
	  var pack = packet;
	  pack.data = _deconstructPacket(packetData);
	  pack.attachments = buffers.length; // number of binary 'attachments'
	  return {packet: pack, buffers: buffers};
	};
	
	/**
	 * Reconstructs a binary packet from its placeholder packet and buffers
	 *
	 * @param {Object} packet - event packet with placeholders
	 * @param {Array} buffers - binary buffers to put in placeholder positions
	 * @return {Object} reconstructed packet
	 * @api public
	 */
	
	exports.reconstructPacket = function(packet, buffers) {
	  var curPlaceHolder = 0;
	
	  function _reconstructPacket(data) {
	    if (data && data._placeholder) {
	      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
	      return buf;
	    } else if (isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        data[i] = _reconstructPacket(data[i]);
	      }
	      return data;
	    } else if (data && 'object' == typeof data) {
	      for (var key in data) {
	        data[key] = _reconstructPacket(data[key]);
	      }
	      return data;
	    }
	    return data;
	  }
	
	  packet.data = _reconstructPacket(packet.data);
	  packet.attachments = undefined; // no longer useful
	  return packet;
	};
	
	/**
	 * Asynchronously removes Blobs or Files from data via
	 * FileReader's readAsArrayBuffer method. Used before encoding
	 * data as msgpack. Calls callback with the blobless data.
	 *
	 * @param {Object} data
	 * @param {Function} callback
	 * @api private
	 */
	
	exports.removeBlobs = function(data, callback) {
	  function _removeBlobs(obj, curKey, containingObject) {
	    if (!obj) return obj;
	
	    // convert any blob
	    if ((global.Blob && obj instanceof Blob) ||
	        (global.File && obj instanceof File)) {
	      pendingBlobs++;
	
	      // async filereader
	      var fileReader = new FileReader();
	      fileReader.onload = function() { // this.result == arraybuffer
	        if (containingObject) {
	          containingObject[curKey] = this.result;
	        }
	        else {
	          bloblessData = this.result;
	        }
	
	        // if nothing pending its callback time
	        if(! --pendingBlobs) {
	          callback(bloblessData);
	        }
	      };
	
	      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
	    } else if (isArray(obj)) { // handle array
	      for (var i = 0; i < obj.length; i++) {
	        _removeBlobs(obj[i], i, obj);
	      }
	    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
	      for (var key in obj) {
	        _removeBlobs(obj[key], key, obj);
	      }
	    }
	  }
	
	  var pendingBlobs = 0;
	  var bloblessData = data;
	  _removeBlobs(bloblessData);
	  if (!pendingBlobs) {
	    callback(bloblessData);
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 402 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 403 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	module.exports = isBuf;
	
	/**
	 * Returns true if obj is a buffer or an arraybuffer.
	 *
	 * @api private
	 */
	
	function isBuf(obj) {
	  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var eio = __webpack_require__(405);
	var Socket = __webpack_require__(431);
	var Emitter = __webpack_require__(432);
	var parser = __webpack_require__(397);
	var on = __webpack_require__(434);
	var bind = __webpack_require__(435);
	var debug = __webpack_require__(394)('socket.io-client:manager');
	var indexOf = __webpack_require__(429);
	var Backoff = __webpack_require__(438);
	
	/**
	 * IE6+ hasOwnProperty
	 */
	
	var has = Object.prototype.hasOwnProperty;
	
	/**
	 * Module exports
	 */
	
	module.exports = Manager;
	
	/**
	 * `Manager` constructor.
	 *
	 * @param {String} engine instance or engine uri/opts
	 * @param {Object} options
	 * @api public
	 */
	
	function Manager (uri, opts) {
	  if (!(this instanceof Manager)) return new Manager(uri, opts);
	  if (uri && ('object' === typeof uri)) {
	    opts = uri;
	    uri = undefined;
	  }
	  opts = opts || {};
	
	  opts.path = opts.path || '/socket.io';
	  this.nsps = {};
	  this.subs = [];
	  this.opts = opts;
	  this.reconnection(opts.reconnection !== false);
	  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
	  this.reconnectionDelay(opts.reconnectionDelay || 1000);
	  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
	  this.randomizationFactor(opts.randomizationFactor || 0.5);
	  this.backoff = new Backoff({
	    min: this.reconnectionDelay(),
	    max: this.reconnectionDelayMax(),
	    jitter: this.randomizationFactor()
	  });
	  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
	  this.readyState = 'closed';
	  this.uri = uri;
	  this.connecting = [];
	  this.lastPing = null;
	  this.encoding = false;
	  this.packetBuffer = [];
	  this.encoder = new parser.Encoder();
	  this.decoder = new parser.Decoder();
	  this.autoConnect = opts.autoConnect !== false;
	  if (this.autoConnect) this.open();
	}
	
	/**
	 * Propagate given event to sockets and emit on `this`
	 *
	 * @api private
	 */
	
	Manager.prototype.emitAll = function () {
	  this.emit.apply(this, arguments);
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
	    }
	  }
	};
	
	/**
	 * Update `socket.id` of all sockets
	 *
	 * @api private
	 */
	
	Manager.prototype.updateSocketIds = function () {
	  for (var nsp in this.nsps) {
	    if (has.call(this.nsps, nsp)) {
	      this.nsps[nsp].id = this.engine.id;
	    }
	  }
	};
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Manager.prototype);
	
	/**
	 * Sets the `reconnection` config.
	 *
	 * @param {Boolean} true/false if it should automatically reconnect
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnection = function (v) {
	  if (!arguments.length) return this._reconnection;
	  this._reconnection = !!v;
	  return this;
	};
	
	/**
	 * Sets the reconnection attempts config.
	 *
	 * @param {Number} max reconnection attempts before giving up
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionAttempts = function (v) {
	  if (!arguments.length) return this._reconnectionAttempts;
	  this._reconnectionAttempts = v;
	  return this;
	};
	
	/**
	 * Sets the delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelay = function (v) {
	  if (!arguments.length) return this._reconnectionDelay;
	  this._reconnectionDelay = v;
	  this.backoff && this.backoff.setMin(v);
	  return this;
	};
	
	Manager.prototype.randomizationFactor = function (v) {
	  if (!arguments.length) return this._randomizationFactor;
	  this._randomizationFactor = v;
	  this.backoff && this.backoff.setJitter(v);
	  return this;
	};
	
	/**
	 * Sets the maximum delay between reconnections.
	 *
	 * @param {Number} delay
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.reconnectionDelayMax = function (v) {
	  if (!arguments.length) return this._reconnectionDelayMax;
	  this._reconnectionDelayMax = v;
	  this.backoff && this.backoff.setMax(v);
	  return this;
	};
	
	/**
	 * Sets the connection timeout. `false` to disable
	 *
	 * @return {Manager} self or value
	 * @api public
	 */
	
	Manager.prototype.timeout = function (v) {
	  if (!arguments.length) return this._timeout;
	  this._timeout = v;
	  return this;
	};
	
	/**
	 * Starts trying to reconnect if reconnection is enabled and we have not
	 * started reconnecting yet
	 *
	 * @api private
	 */
	
	Manager.prototype.maybeReconnectOnOpen = function () {
	  // Only try to reconnect if it's the first time we're connecting
	  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
	    // keeps reconnection from firing twice for the same reconnection loop
	    this.reconnect();
	  }
	};
	
	/**
	 * Sets the current transport `socket`.
	 *
	 * @param {Function} optional, callback
	 * @return {Manager} self
	 * @api public
	 */
	
	Manager.prototype.open =
	Manager.prototype.connect = function (fn, opts) {
	  debug('readyState %s', this.readyState);
	  if (~this.readyState.indexOf('open')) return this;
	
	  debug('opening %s', this.uri);
	  this.engine = eio(this.uri, this.opts);
	  var socket = this.engine;
	  var self = this;
	  this.readyState = 'opening';
	  this.skipReconnect = false;
	
	  // emit `open`
	  var openSub = on(socket, 'open', function () {
	    self.onopen();
	    fn && fn();
	  });
	
	  // emit `connect_error`
	  var errorSub = on(socket, 'error', function (data) {
	    debug('connect_error');
	    self.cleanup();
	    self.readyState = 'closed';
	    self.emitAll('connect_error', data);
	    if (fn) {
	      var err = new Error('Connection error');
	      err.data = data;
	      fn(err);
	    } else {
	      // Only do this if there is no fn to handle the error
	      self.maybeReconnectOnOpen();
	    }
	  });
	
	  // emit `connect_timeout`
	  if (false !== this._timeout) {
	    var timeout = this._timeout;
	    debug('connect attempt will timeout after %d', timeout);
	
	    // set timer
	    var timer = setTimeout(function () {
	      debug('connect attempt timed out after %d', timeout);
	      openSub.destroy();
	      socket.close();
	      socket.emit('error', 'timeout');
	      self.emitAll('connect_timeout', timeout);
	    }, timeout);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	
	  this.subs.push(openSub);
	  this.subs.push(errorSub);
	
	  return this;
	};
	
	/**
	 * Called upon transport open.
	 *
	 * @api private
	 */
	
	Manager.prototype.onopen = function () {
	  debug('open');
	
	  // clear old subs
	  this.cleanup();
	
	  // mark as open
	  this.readyState = 'open';
	  this.emit('open');
	
	  // add new subs
	  var socket = this.engine;
	  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
	  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
	  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
	  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
	  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
	  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
	};
	
	/**
	 * Called upon a ping.
	 *
	 * @api private
	 */
	
	Manager.prototype.onping = function () {
	  this.lastPing = new Date();
	  this.emitAll('ping');
	};
	
	/**
	 * Called upon a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.onpong = function () {
	  this.emitAll('pong', new Date() - this.lastPing);
	};
	
	/**
	 * Called with data.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondata = function (data) {
	  this.decoder.add(data);
	};
	
	/**
	 * Called when parser fully decodes a packet.
	 *
	 * @api private
	 */
	
	Manager.prototype.ondecoded = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon socket error.
	 *
	 * @api private
	 */
	
	Manager.prototype.onerror = function (err) {
	  debug('error', err);
	  this.emitAll('error', err);
	};
	
	/**
	 * Creates a new socket for the given `nsp`.
	 *
	 * @return {Socket}
	 * @api public
	 */
	
	Manager.prototype.socket = function (nsp, opts) {
	  var socket = this.nsps[nsp];
	  if (!socket) {
	    socket = new Socket(this, nsp, opts);
	    this.nsps[nsp] = socket;
	    var self = this;
	    socket.on('connecting', onConnecting);
	    socket.on('connect', function () {
	      socket.id = self.engine.id;
	    });
	
	    if (this.autoConnect) {
	      // manually call here since connecting evnet is fired before listening
	      onConnecting();
	    }
	  }
	
	  function onConnecting () {
	    if (!~indexOf(self.connecting, socket)) {
	      self.connecting.push(socket);
	    }
	  }
	
	  return socket;
	};
	
	/**
	 * Called upon a socket close.
	 *
	 * @param {Socket} socket
	 */
	
	Manager.prototype.destroy = function (socket) {
	  var index = indexOf(this.connecting, socket);
	  if (~index) this.connecting.splice(index, 1);
	  if (this.connecting.length) return;
	
	  this.close();
	};
	
	/**
	 * Writes a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Manager.prototype.packet = function (packet) {
	  debug('writing packet %j', packet);
	  var self = this;
	  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;
	
	  if (!self.encoding) {
	    // encode, then write to engine with result
	    self.encoding = true;
	    this.encoder.encode(packet, function (encodedPackets) {
	      for (var i = 0; i < encodedPackets.length; i++) {
	        self.engine.write(encodedPackets[i], packet.options);
	      }
	      self.encoding = false;
	      self.processPacketQueue();
	    });
	  } else { // add packet to the queue
	    self.packetBuffer.push(packet);
	  }
	};
	
	/**
	 * If packet buffer is non-empty, begins encoding the
	 * next packet in line.
	 *
	 * @api private
	 */
	
	Manager.prototype.processPacketQueue = function () {
	  if (this.packetBuffer.length > 0 && !this.encoding) {
	    var pack = this.packetBuffer.shift();
	    this.packet(pack);
	  }
	};
	
	/**
	 * Clean up transport subscriptions and packet buffer.
	 *
	 * @api private
	 */
	
	Manager.prototype.cleanup = function () {
	  debug('cleanup');
	
	  var subsLength = this.subs.length;
	  for (var i = 0; i < subsLength; i++) {
	    var sub = this.subs.shift();
	    sub.destroy();
	  }
	
	  this.packetBuffer = [];
	  this.encoding = false;
	  this.lastPing = null;
	
	  this.decoder.destroy();
	};
	
	/**
	 * Close the current socket.
	 *
	 * @api private
	 */
	
	Manager.prototype.close =
	Manager.prototype.disconnect = function () {
	  debug('disconnect');
	  this.skipReconnect = true;
	  this.reconnecting = false;
	  if ('opening' === this.readyState) {
	    // `onclose` will not fire because
	    // an open event never happened
	    this.cleanup();
	  }
	  this.backoff.reset();
	  this.readyState = 'closed';
	  if (this.engine) this.engine.close();
	};
	
	/**
	 * Called upon engine close.
	 *
	 * @api private
	 */
	
	Manager.prototype.onclose = function (reason) {
	  debug('onclose');
	
	  this.cleanup();
	  this.backoff.reset();
	  this.readyState = 'closed';
	  this.emit('close', reason);
	
	  if (this._reconnection && !this.skipReconnect) {
	    this.reconnect();
	  }
	};
	
	/**
	 * Attempt a reconnection.
	 *
	 * @api private
	 */
	
	Manager.prototype.reconnect = function () {
	  if (this.reconnecting || this.skipReconnect) return this;
	
	  var self = this;
	
	  if (this.backoff.attempts >= this._reconnectionAttempts) {
	    debug('reconnect failed');
	    this.backoff.reset();
	    this.emitAll('reconnect_failed');
	    this.reconnecting = false;
	  } else {
	    var delay = this.backoff.duration();
	    debug('will wait %dms before reconnect attempt', delay);
	
	    this.reconnecting = true;
	    var timer = setTimeout(function () {
	      if (self.skipReconnect) return;
	
	      debug('attempting reconnect');
	      self.emitAll('reconnect_attempt', self.backoff.attempts);
	      self.emitAll('reconnecting', self.backoff.attempts);
	
	      // check again for the case socket closed in above events
	      if (self.skipReconnect) return;
	
	      self.open(function (err) {
	        if (err) {
	          debug('reconnect attempt error');
	          self.reconnecting = false;
	          self.reconnect();
	          self.emitAll('reconnect_error', err.data);
	        } else {
	          debug('reconnect success');
	          self.onreconnect();
	        }
	      });
	    }, delay);
	
	    this.subs.push({
	      destroy: function () {
	        clearTimeout(timer);
	      }
	    });
	  }
	};
	
	/**
	 * Called upon successful reconnect.
	 *
	 * @api private
	 */
	
	Manager.prototype.onreconnect = function () {
	  var attempt = this.backoff.attempts;
	  this.reconnecting = false;
	  this.backoff.reset();
	  this.updateSocketIds();
	  this.emitAll('reconnect', attempt);
	};


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(406);


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	
	module.exports = __webpack_require__(407);
	
	/**
	 * Exports parser
	 *
	 * @api public
	 *
	 */
	module.exports.parser = __webpack_require__(414);


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var transports = __webpack_require__(408);
	var Emitter = __webpack_require__(422);
	var debug = __webpack_require__(394)('engine.io-client:socket');
	var index = __webpack_require__(429);
	var parser = __webpack_require__(414);
	var parseuri = __webpack_require__(393);
	var parsejson = __webpack_require__(430);
	var parseqs = __webpack_require__(423);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Socket;
	
	/**
	 * Socket constructor.
	 *
	 * @param {String|Object} uri or options
	 * @param {Object} options
	 * @api public
	 */
	
	function Socket (uri, opts) {
	  if (!(this instanceof Socket)) return new Socket(uri, opts);
	
	  opts = opts || {};
	
	  if (uri && 'object' === typeof uri) {
	    opts = uri;
	    uri = null;
	  }
	
	  if (uri) {
	    uri = parseuri(uri);
	    opts.hostname = uri.host;
	    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
	    opts.port = uri.port;
	    if (uri.query) opts.query = uri.query;
	  } else if (opts.host) {
	    opts.hostname = parseuri(opts.host).host;
	  }
	
	  this.secure = null != opts.secure ? opts.secure
	    : (global.location && 'https:' === location.protocol);
	
	  if (opts.hostname && !opts.port) {
	    // if no port is specified manually, use the protocol default
	    opts.port = this.secure ? '443' : '80';
	  }
	
	  this.agent = opts.agent || false;
	  this.hostname = opts.hostname ||
	    (global.location ? location.hostname : 'localhost');
	  this.port = opts.port || (global.location && location.port
	      ? location.port
	      : (this.secure ? 443 : 80));
	  this.query = opts.query || {};
	  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
	  this.upgrade = false !== opts.upgrade;
	  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
	  this.forceJSONP = !!opts.forceJSONP;
	  this.jsonp = false !== opts.jsonp;
	  this.forceBase64 = !!opts.forceBase64;
	  this.enablesXDR = !!opts.enablesXDR;
	  this.timestampParam = opts.timestampParam || 't';
	  this.timestampRequests = opts.timestampRequests;
	  this.transports = opts.transports || ['polling', 'websocket'];
	  this.readyState = '';
	  this.writeBuffer = [];
	  this.prevBufferLen = 0;
	  this.policyPort = opts.policyPort || 843;
	  this.rememberUpgrade = opts.rememberUpgrade || false;
	  this.binaryType = null;
	  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
	  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;
	
	  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
	  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
	    this.perMessageDeflate.threshold = 1024;
	  }
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx || null;
	  this.key = opts.key || null;
	  this.passphrase = opts.passphrase || null;
	  this.cert = opts.cert || null;
	  this.ca = opts.ca || null;
	  this.ciphers = opts.ciphers || null;
	  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  var freeGlobal = typeof global === 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
	      this.extraHeaders = opts.extraHeaders;
	    }
	  }
	
	  // set on handshake
	  this.id = null;
	  this.upgrades = null;
	  this.pingInterval = null;
	  this.pingTimeout = null;
	
	  // set on heartbeat
	  this.pingIntervalTimer = null;
	  this.pingTimeoutTimer = null;
	
	  this.open();
	}
	
	Socket.priorWebsocketSuccess = false;
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Protocol version.
	 *
	 * @api public
	 */
	
	Socket.protocol = parser.protocol; // this is an int
	
	/**
	 * Expose deps for legacy compatibility
	 * and standalone browser access.
	 */
	
	Socket.Socket = Socket;
	Socket.Transport = __webpack_require__(413);
	Socket.transports = __webpack_require__(408);
	Socket.parser = __webpack_require__(414);
	
	/**
	 * Creates transport of the given type.
	 *
	 * @param {String} transport name
	 * @return {Transport}
	 * @api private
	 */
	
	Socket.prototype.createTransport = function (name) {
	  debug('creating transport "%s"', name);
	  var query = clone(this.query);
	
	  // append engine.io protocol identifier
	  query.EIO = parser.protocol;
	
	  // transport name
	  query.transport = name;
	
	  // session id if we already have one
	  if (this.id) query.sid = this.id;
	
	  var transport = new transports[name]({
	    agent: this.agent,
	    hostname: this.hostname,
	    port: this.port,
	    secure: this.secure,
	    path: this.path,
	    query: query,
	    forceJSONP: this.forceJSONP,
	    jsonp: this.jsonp,
	    forceBase64: this.forceBase64,
	    enablesXDR: this.enablesXDR,
	    timestampRequests: this.timestampRequests,
	    timestampParam: this.timestampParam,
	    policyPort: this.policyPort,
	    socket: this,
	    pfx: this.pfx,
	    key: this.key,
	    passphrase: this.passphrase,
	    cert: this.cert,
	    ca: this.ca,
	    ciphers: this.ciphers,
	    rejectUnauthorized: this.rejectUnauthorized,
	    perMessageDeflate: this.perMessageDeflate,
	    extraHeaders: this.extraHeaders
	  });
	
	  return transport;
	};
	
	function clone (obj) {
	  var o = {};
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      o[i] = obj[i];
	    }
	  }
	  return o;
	}
	
	/**
	 * Initializes transport to use and starts probe.
	 *
	 * @api private
	 */
	Socket.prototype.open = function () {
	  var transport;
	  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
	    transport = 'websocket';
	  } else if (0 === this.transports.length) {
	    // Emit error on next tick so it can be listened to
	    var self = this;
	    setTimeout(function () {
	      self.emit('error', 'No transports available');
	    }, 0);
	    return;
	  } else {
	    transport = this.transports[0];
	  }
	  this.readyState = 'opening';
	
	  // Retry with the next transport if the transport is disabled (jsonp: false)
	  try {
	    transport = this.createTransport(transport);
	  } catch (e) {
	    this.transports.shift();
	    this.open();
	    return;
	  }
	
	  transport.open();
	  this.setTransport(transport);
	};
	
	/**
	 * Sets the current transport. Disables the existing one (if any).
	 *
	 * @api private
	 */
	
	Socket.prototype.setTransport = function (transport) {
	  debug('setting transport %s', transport.name);
	  var self = this;
	
	  if (this.transport) {
	    debug('clearing existing transport %s', this.transport.name);
	    this.transport.removeAllListeners();
	  }
	
	  // set up transport
	  this.transport = transport;
	
	  // set up transport listeners
	  transport
	  .on('drain', function () {
	    self.onDrain();
	  })
	  .on('packet', function (packet) {
	    self.onPacket(packet);
	  })
	  .on('error', function (e) {
	    self.onError(e);
	  })
	  .on('close', function () {
	    self.onClose('transport close');
	  });
	};
	
	/**
	 * Probes a transport.
	 *
	 * @param {String} transport name
	 * @api private
	 */
	
	Socket.prototype.probe = function (name) {
	  debug('probing transport "%s"', name);
	  var transport = this.createTransport(name, { probe: 1 });
	  var failed = false;
	  var self = this;
	
	  Socket.priorWebsocketSuccess = false;
	
	  function onTransportOpen () {
	    if (self.onlyBinaryUpgrades) {
	      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
	      failed = failed || upgradeLosesBinary;
	    }
	    if (failed) return;
	
	    debug('probe transport "%s" opened', name);
	    transport.send([{ type: 'ping', data: 'probe' }]);
	    transport.once('packet', function (msg) {
	      if (failed) return;
	      if ('pong' === msg.type && 'probe' === msg.data) {
	        debug('probe transport "%s" pong', name);
	        self.upgrading = true;
	        self.emit('upgrading', transport);
	        if (!transport) return;
	        Socket.priorWebsocketSuccess = 'websocket' === transport.name;
	
	        debug('pausing current transport "%s"', self.transport.name);
	        self.transport.pause(function () {
	          if (failed) return;
	          if ('closed' === self.readyState) return;
	          debug('changing transport and sending upgrade packet');
	
	          cleanup();
	
	          self.setTransport(transport);
	          transport.send([{ type: 'upgrade' }]);
	          self.emit('upgrade', transport);
	          transport = null;
	          self.upgrading = false;
	          self.flush();
	        });
	      } else {
	        debug('probe transport "%s" failed', name);
	        var err = new Error('probe error');
	        err.transport = transport.name;
	        self.emit('upgradeError', err);
	      }
	    });
	  }
	
	  function freezeTransport () {
	    if (failed) return;
	
	    // Any callback called by transport should be ignored since now
	    failed = true;
	
	    cleanup();
	
	    transport.close();
	    transport = null;
	  }
	
	  // Handle any error that happens while probing
	  function onerror (err) {
	    var error = new Error('probe error: ' + err);
	    error.transport = transport.name;
	
	    freezeTransport();
	
	    debug('probe transport "%s" failed because of error: %s', name, err);
	
	    self.emit('upgradeError', error);
	  }
	
	  function onTransportClose () {
	    onerror('transport closed');
	  }
	
	  // When the socket is closed while we're probing
	  function onclose () {
	    onerror('socket closed');
	  }
	
	  // When the socket is upgraded while we're probing
	  function onupgrade (to) {
	    if (transport && to.name !== transport.name) {
	      debug('"%s" works - aborting "%s"', to.name, transport.name);
	      freezeTransport();
	    }
	  }
	
	  // Remove all listeners on the transport and on self
	  function cleanup () {
	    transport.removeListener('open', onTransportOpen);
	    transport.removeListener('error', onerror);
	    transport.removeListener('close', onTransportClose);
	    self.removeListener('close', onclose);
	    self.removeListener('upgrading', onupgrade);
	  }
	
	  transport.once('open', onTransportOpen);
	  transport.once('error', onerror);
	  transport.once('close', onTransportClose);
	
	  this.once('close', onclose);
	  this.once('upgrading', onupgrade);
	
	  transport.open();
	};
	
	/**
	 * Called when connection is deemed open.
	 *
	 * @api public
	 */
	
	Socket.prototype.onOpen = function () {
	  debug('socket open');
	  this.readyState = 'open';
	  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
	  this.emit('open');
	  this.flush();
	
	  // we check for `readyState` in case an `open`
	  // listener already closed the socket
	  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
	    debug('starting upgrade probes');
	    for (var i = 0, l = this.upgrades.length; i < l; i++) {
	      this.probe(this.upgrades[i]);
	    }
	  }
	};
	
	/**
	 * Handles a packet.
	 *
	 * @api private
	 */
	
	Socket.prototype.onPacket = function (packet) {
	  if ('opening' === this.readyState || 'open' === this.readyState ||
	      'closing' === this.readyState) {
	    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);
	
	    this.emit('packet', packet);
	
	    // Socket is live - any packet counts
	    this.emit('heartbeat');
	
	    switch (packet.type) {
	      case 'open':
	        this.onHandshake(parsejson(packet.data));
	        break;
	
	      case 'pong':
	        this.setPing();
	        this.emit('pong');
	        break;
	
	      case 'error':
	        var err = new Error('server error');
	        err.code = packet.data;
	        this.onError(err);
	        break;
	
	      case 'message':
	        this.emit('data', packet.data);
	        this.emit('message', packet.data);
	        break;
	    }
	  } else {
	    debug('packet received with socket readyState "%s"', this.readyState);
	  }
	};
	
	/**
	 * Called upon handshake completion.
	 *
	 * @param {Object} handshake obj
	 * @api private
	 */
	
	Socket.prototype.onHandshake = function (data) {
	  this.emit('handshake', data);
	  this.id = data.sid;
	  this.transport.query.sid = data.sid;
	  this.upgrades = this.filterUpgrades(data.upgrades);
	  this.pingInterval = data.pingInterval;
	  this.pingTimeout = data.pingTimeout;
	  this.onOpen();
	  // In case open handler closes socket
	  if ('closed' === this.readyState) return;
	  this.setPing();
	
	  // Prolong liveness of socket on heartbeat
	  this.removeListener('heartbeat', this.onHeartbeat);
	  this.on('heartbeat', this.onHeartbeat);
	};
	
	/**
	 * Resets ping timeout.
	 *
	 * @api private
	 */
	
	Socket.prototype.onHeartbeat = function (timeout) {
	  clearTimeout(this.pingTimeoutTimer);
	  var self = this;
	  self.pingTimeoutTimer = setTimeout(function () {
	    if ('closed' === self.readyState) return;
	    self.onClose('ping timeout');
	  }, timeout || (self.pingInterval + self.pingTimeout));
	};
	
	/**
	 * Pings server every `this.pingInterval` and expects response
	 * within `this.pingTimeout` or closes connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.setPing = function () {
	  var self = this;
	  clearTimeout(self.pingIntervalTimer);
	  self.pingIntervalTimer = setTimeout(function () {
	    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
	    self.ping();
	    self.onHeartbeat(self.pingTimeout);
	  }, self.pingInterval);
	};
	
	/**
	* Sends a ping packet.
	*
	* @api private
	*/
	
	Socket.prototype.ping = function () {
	  var self = this;
	  this.sendPacket('ping', function () {
	    self.emit('ping');
	  });
	};
	
	/**
	 * Called on `drain` event
	 *
	 * @api private
	 */
	
	Socket.prototype.onDrain = function () {
	  this.writeBuffer.splice(0, this.prevBufferLen);
	
	  // setting prevBufferLen = 0 is very important
	  // for example, when upgrading, upgrade packet is sent over,
	  // and a nonzero prevBufferLen could cause problems on `drain`
	  this.prevBufferLen = 0;
	
	  if (0 === this.writeBuffer.length) {
	    this.emit('drain');
	  } else {
	    this.flush();
	  }
	};
	
	/**
	 * Flush write buffers.
	 *
	 * @api private
	 */
	
	Socket.prototype.flush = function () {
	  if ('closed' !== this.readyState && this.transport.writable &&
	    !this.upgrading && this.writeBuffer.length) {
	    debug('flushing %d packets in socket', this.writeBuffer.length);
	    this.transport.send(this.writeBuffer);
	    // keep track of current length of writeBuffer
	    // splice writeBuffer and callbackBuffer on `drain`
	    this.prevBufferLen = this.writeBuffer.length;
	    this.emit('flush');
	  }
	};
	
	/**
	 * Sends a message.
	 *
	 * @param {String} message.
	 * @param {Function} callback function.
	 * @param {Object} options.
	 * @return {Socket} for chaining.
	 * @api public
	 */
	
	Socket.prototype.write =
	Socket.prototype.send = function (msg, options, fn) {
	  this.sendPacket('message', msg, options, fn);
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {String} packet type.
	 * @param {String} data.
	 * @param {Object} options.
	 * @param {Function} callback function.
	 * @api private
	 */
	
	Socket.prototype.sendPacket = function (type, data, options, fn) {
	  if ('function' === typeof data) {
	    fn = data;
	    data = undefined;
	  }
	
	  if ('function' === typeof options) {
	    fn = options;
	    options = null;
	  }
	
	  if ('closing' === this.readyState || 'closed' === this.readyState) {
	    return;
	  }
	
	  options = options || {};
	  options.compress = false !== options.compress;
	
	  var packet = {
	    type: type,
	    data: data,
	    options: options
	  };
	  this.emit('packetCreate', packet);
	  this.writeBuffer.push(packet);
	  if (fn) this.once('flush', fn);
	  this.flush();
	};
	
	/**
	 * Closes the connection.
	 *
	 * @api private
	 */
	
	Socket.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.readyState = 'closing';
	
	    var self = this;
	
	    if (this.writeBuffer.length) {
	      this.once('drain', function () {
	        if (this.upgrading) {
	          waitForUpgrade();
	        } else {
	          close();
	        }
	      });
	    } else if (this.upgrading) {
	      waitForUpgrade();
	    } else {
	      close();
	    }
	  }
	
	  function close () {
	    self.onClose('forced close');
	    debug('socket closing - telling transport to close');
	    self.transport.close();
	  }
	
	  function cleanupAndClose () {
	    self.removeListener('upgrade', cleanupAndClose);
	    self.removeListener('upgradeError', cleanupAndClose);
	    close();
	  }
	
	  function waitForUpgrade () {
	    // wait for upgrade to finish since we can't send packets while pausing a transport
	    self.once('upgrade', cleanupAndClose);
	    self.once('upgradeError', cleanupAndClose);
	  }
	
	  return this;
	};
	
	/**
	 * Called upon transport error
	 *
	 * @api private
	 */
	
	Socket.prototype.onError = function (err) {
	  debug('socket error %j', err);
	  Socket.priorWebsocketSuccess = false;
	  this.emit('error', err);
	  this.onClose('transport error', err);
	};
	
	/**
	 * Called upon transport close.
	 *
	 * @api private
	 */
	
	Socket.prototype.onClose = function (reason, desc) {
	  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
	    debug('socket close with reason: "%s"', reason);
	    var self = this;
	
	    // clear timers
	    clearTimeout(this.pingIntervalTimer);
	    clearTimeout(this.pingTimeoutTimer);
	
	    // stop event from firing again for transport
	    this.transport.removeAllListeners('close');
	
	    // ensure transport won't stay open
	    this.transport.close();
	
	    // ignore further transport communication
	    this.transport.removeAllListeners();
	
	    // set ready state
	    this.readyState = 'closed';
	
	    // clear session id
	    this.id = null;
	
	    // emit close event
	    this.emit('close', reason, desc);
	
	    // clean buffers after, so users can still
	    // grab the buffers on `close` event
	    self.writeBuffer = [];
	    self.prevBufferLen = 0;
	  }
	};
	
	/**
	 * Filters upgrades, returning only those matching client transports.
	 *
	 * @param {Array} server upgrades
	 * @api private
	 *
	 */
	
	Socket.prototype.filterUpgrades = function (upgrades) {
	  var filteredUpgrades = [];
	  for (var i = 0, j = upgrades.length; i < j; i++) {
	    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
	  }
	  return filteredUpgrades;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies
	 */
	
	var XMLHttpRequest = __webpack_require__(409);
	var XHR = __webpack_require__(411);
	var JSONP = __webpack_require__(426);
	var websocket = __webpack_require__(427);
	
	/**
	 * Export transports.
	 */
	
	exports.polling = polling;
	exports.websocket = websocket;
	
	/**
	 * Polling transport polymorphic constructor.
	 * Decides on xhr vs jsonp based on feature detection.
	 *
	 * @api private
	 */
	
	function polling (opts) {
	  var xhr;
	  var xd = false;
	  var xs = false;
	  var jsonp = false !== opts.jsonp;
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    xd = opts.hostname !== location.hostname || port !== opts.port;
	    xs = opts.secure !== isSSL;
	  }
	
	  opts.xdomain = xd;
	  opts.xscheme = xs;
	  xhr = new XMLHttpRequest(opts);
	
	  if ('open' in xhr && !opts.forceJSONP) {
	    return new XHR(opts);
	  } else {
	    if (!jsonp) throw new Error('JSONP disabled');
	    return new JSONP(opts);
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module
	
	var hasCORS = __webpack_require__(410);
	
	module.exports = function (opts) {
	  var xdomain = opts.xdomain;
	
	  // scheme must be same when usign XDomainRequest
	  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	  var xscheme = opts.xscheme;
	
	  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
	  // https://github.com/Automattic/engine.io-client/pull/217
	  var enablesXDR = opts.enablesXDR;
	
	  // XMLHttpRequest can be disabled on IE
	  try {
	    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
	      return new XMLHttpRequest();
	    }
	  } catch (e) { }
	
	  // Use XDomainRequest for IE8 if enablesXDR is true
	  // because loading bar keeps flashing when using jsonp-polling
	  // https://github.com/yujiosaka/socke.io-ie8-loading-example
	  try {
	    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
	      return new XDomainRequest();
	    }
	  } catch (e) { }
	
	  if (!xdomain) {
	    try {
	      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
	    } catch (e) { }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 410 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 *
	 * Logic borrowed from Modernizr:
	 *
	 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
	 */
	
	try {
	  module.exports = typeof XMLHttpRequest !== 'undefined' &&
	    'withCredentials' in new XMLHttpRequest();
	} catch (err) {
	  // if XMLHttp support is disabled in IE then it will throw
	  // when trying to create
	  module.exports = false;
	}


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module requirements.
	 */
	
	var XMLHttpRequest = __webpack_require__(409);
	var Polling = __webpack_require__(412);
	var Emitter = __webpack_require__(422);
	var inherit = __webpack_require__(424);
	var debug = __webpack_require__(394)('engine.io-client:polling-xhr');
	
	/**
	 * Module exports.
	 */
	
	module.exports = XHR;
	module.exports.Request = Request;
	
	/**
	 * Empty function
	 */
	
	function empty () {}
	
	/**
	 * XHR Polling constructor.
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function XHR (opts) {
	  Polling.call(this, opts);
	
	  if (global.location) {
	    var isSSL = 'https:' === location.protocol;
	    var port = location.port;
	
	    // some user agents have empty `location.port`
	    if (!port) {
	      port = isSSL ? 443 : 80;
	    }
	
	    this.xd = opts.hostname !== global.location.hostname ||
	      port !== opts.port;
	    this.xs = opts.secure !== isSSL;
	  } else {
	    this.extraHeaders = opts.extraHeaders;
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(XHR, Polling);
	
	/**
	 * XHR supports binary
	 */
	
	XHR.prototype.supportsBinary = true;
	
	/**
	 * Creates a request.
	 *
	 * @param {String} method
	 * @api private
	 */
	
	XHR.prototype.request = function (opts) {
	  opts = opts || {};
	  opts.uri = this.uri();
	  opts.xd = this.xd;
	  opts.xs = this.xs;
	  opts.agent = this.agent || false;
	  opts.supportsBinary = this.supportsBinary;
	  opts.enablesXDR = this.enablesXDR;
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  // other options for Node.js client
	  opts.extraHeaders = this.extraHeaders;
	
	  return new Request(opts);
	};
	
	/**
	 * Sends data.
	 *
	 * @param {String} data to send.
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	XHR.prototype.doWrite = function (data, fn) {
	  var isBinary = typeof data !== 'string' && data !== undefined;
	  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
	  var self = this;
	  req.on('success', fn);
	  req.on('error', function (err) {
	    self.onError('xhr post error', err);
	  });
	  this.sendXhr = req;
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	XHR.prototype.doPoll = function () {
	  debug('xhr poll');
	  var req = this.request();
	  var self = this;
	  req.on('data', function (data) {
	    self.onData(data);
	  });
	  req.on('error', function (err) {
	    self.onError('xhr poll error', err);
	  });
	  this.pollXhr = req;
	};
	
	/**
	 * Request constructor
	 *
	 * @param {Object} options
	 * @api public
	 */
	
	function Request (opts) {
	  this.method = opts.method || 'GET';
	  this.uri = opts.uri;
	  this.xd = !!opts.xd;
	  this.xs = !!opts.xs;
	  this.async = false !== opts.async;
	  this.data = undefined !== opts.data ? opts.data : null;
	  this.agent = opts.agent;
	  this.isBinary = opts.isBinary;
	  this.supportsBinary = opts.supportsBinary;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	
	  this.create();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Creates the XHR object and sends the request.
	 *
	 * @api private
	 */
	
	Request.prototype.create = function () {
	  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	
	  var xhr = this.xhr = new XMLHttpRequest(opts);
	  var self = this;
	
	  try {
	    debug('xhr open %s: %s', this.method, this.uri);
	    xhr.open(this.method, this.uri, this.async);
	    try {
	      if (this.extraHeaders) {
	        xhr.setDisableHeaderCheck(true);
	        for (var i in this.extraHeaders) {
	          if (this.extraHeaders.hasOwnProperty(i)) {
	            xhr.setRequestHeader(i, this.extraHeaders[i]);
	          }
	        }
	      }
	    } catch (e) {}
	    if (this.supportsBinary) {
	      // This has to be done after open because Firefox is stupid
	      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
	      xhr.responseType = 'arraybuffer';
	    }
	
	    if ('POST' === this.method) {
	      try {
	        if (this.isBinary) {
	          xhr.setRequestHeader('Content-type', 'application/octet-stream');
	        } else {
	          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
	        }
	      } catch (e) {}
	    }
	
	    try {
	      xhr.setRequestHeader('Accept', '*/*');
	    } catch (e) {}
	
	    // ie6 check
	    if ('withCredentials' in xhr) {
	      xhr.withCredentials = true;
	    }
	
	    if (this.hasXDR()) {
	      xhr.onload = function () {
	        self.onLoad();
	      };
	      xhr.onerror = function () {
	        self.onError(xhr.responseText);
	      };
	    } else {
	      xhr.onreadystatechange = function () {
	        if (4 !== xhr.readyState) return;
	        if (200 === xhr.status || 1223 === xhr.status) {
	          self.onLoad();
	        } else {
	          // make sure the `error` event handler that's user-set
	          // does not throw in the same tick and gets caught here
	          setTimeout(function () {
	            self.onError(xhr.status);
	          }, 0);
	        }
	      };
	    }
	
	    debug('xhr data %s', this.data);
	    xhr.send(this.data);
	  } catch (e) {
	    // Need to defer since .create() is called directly fhrom the constructor
	    // and thus the 'error' event can only be only bound *after* this exception
	    // occurs.  Therefore, also, we cannot throw here at all.
	    setTimeout(function () {
	      self.onError(e);
	    }, 0);
	    return;
	  }
	
	  if (global.document) {
	    this.index = Request.requestsCount++;
	    Request.requests[this.index] = this;
	  }
	};
	
	/**
	 * Called upon successful response.
	 *
	 * @api private
	 */
	
	Request.prototype.onSuccess = function () {
	  this.emit('success');
	  this.cleanup();
	};
	
	/**
	 * Called if we have data.
	 *
	 * @api private
	 */
	
	Request.prototype.onData = function (data) {
	  this.emit('data', data);
	  this.onSuccess();
	};
	
	/**
	 * Called upon error.
	 *
	 * @api private
	 */
	
	Request.prototype.onError = function (err) {
	  this.emit('error', err);
	  this.cleanup(true);
	};
	
	/**
	 * Cleans up house.
	 *
	 * @api private
	 */
	
	Request.prototype.cleanup = function (fromError) {
	  if ('undefined' === typeof this.xhr || null === this.xhr) {
	    return;
	  }
	  // xmlhttprequest
	  if (this.hasXDR()) {
	    this.xhr.onload = this.xhr.onerror = empty;
	  } else {
	    this.xhr.onreadystatechange = empty;
	  }
	
	  if (fromError) {
	    try {
	      this.xhr.abort();
	    } catch (e) {}
	  }
	
	  if (global.document) {
	    delete Request.requests[this.index];
	  }
	
	  this.xhr = null;
	};
	
	/**
	 * Called upon load.
	 *
	 * @api private
	 */
	
	Request.prototype.onLoad = function () {
	  var data;
	  try {
	    var contentType;
	    try {
	      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
	    } catch (e) {}
	    if (contentType === 'application/octet-stream') {
	      data = this.xhr.response || this.xhr.responseText;
	    } else {
	      if (!this.supportsBinary) {
	        data = this.xhr.responseText;
	      } else {
	        try {
	          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
	        } catch (e) {
	          var ui8Arr = new Uint8Array(this.xhr.response);
	          var dataArray = [];
	          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
	            dataArray.push(ui8Arr[idx]);
	          }
	
	          data = String.fromCharCode.apply(null, dataArray);
	        }
	      }
	    }
	  } catch (e) {
	    this.onError(e);
	  }
	  if (null != data) {
	    this.onData(data);
	  }
	};
	
	/**
	 * Check if it has XDomainRequest.
	 *
	 * @api private
	 */
	
	Request.prototype.hasXDR = function () {
	  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
	};
	
	/**
	 * Aborts the request.
	 *
	 * @api public
	 */
	
	Request.prototype.abort = function () {
	  this.cleanup();
	};
	
	/**
	 * Aborts pending requests when unloading the window. This is needed to prevent
	 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
	 * emitted.
	 */
	
	Request.requestsCount = 0;
	Request.requests = {};
	
	if (global.document) {
	  if (global.attachEvent) {
	    global.attachEvent('onunload', unloadHandler);
	  } else if (global.addEventListener) {
	    global.addEventListener('beforeunload', unloadHandler, false);
	  }
	}
	
	function unloadHandler () {
	  for (var i in Request.requests) {
	    if (Request.requests.hasOwnProperty(i)) {
	      Request.requests[i].abort();
	    }
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(413);
	var parseqs = __webpack_require__(423);
	var parser = __webpack_require__(414);
	var inherit = __webpack_require__(424);
	var yeast = __webpack_require__(425);
	var debug = __webpack_require__(394)('engine.io-client:polling');
	
	/**
	 * Module exports.
	 */
	
	module.exports = Polling;
	
	/**
	 * Is XHR2 supported?
	 */
	
	var hasXHR2 = (function () {
	  var XMLHttpRequest = __webpack_require__(409);
	  var xhr = new XMLHttpRequest({ xdomain: false });
	  return null != xhr.responseType;
	})();
	
	/**
	 * Polling interface.
	 *
	 * @param {Object} opts
	 * @api private
	 */
	
	function Polling (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (!hasXHR2 || forceBase64) {
	    this.supportsBinary = false;
	  }
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(Polling, Transport);
	
	/**
	 * Transport name.
	 */
	
	Polling.prototype.name = 'polling';
	
	/**
	 * Opens the socket (triggers polling). We write a PING message to determine
	 * when the transport is open.
	 *
	 * @api private
	 */
	
	Polling.prototype.doOpen = function () {
	  this.poll();
	};
	
	/**
	 * Pauses polling.
	 *
	 * @param {Function} callback upon buffers are flushed and transport is paused
	 * @api private
	 */
	
	Polling.prototype.pause = function (onPause) {
	  var self = this;
	
	  this.readyState = 'pausing';
	
	  function pause () {
	    debug('paused');
	    self.readyState = 'paused';
	    onPause();
	  }
	
	  if (this.polling || !this.writable) {
	    var total = 0;
	
	    if (this.polling) {
	      debug('we are currently polling - waiting to pause');
	      total++;
	      this.once('pollComplete', function () {
	        debug('pre-pause polling complete');
	        --total || pause();
	      });
	    }
	
	    if (!this.writable) {
	      debug('we are currently writing - waiting to pause');
	      total++;
	      this.once('drain', function () {
	        debug('pre-pause writing complete');
	        --total || pause();
	      });
	    }
	  } else {
	    pause();
	  }
	};
	
	/**
	 * Starts polling cycle.
	 *
	 * @api public
	 */
	
	Polling.prototype.poll = function () {
	  debug('polling');
	  this.polling = true;
	  this.doPoll();
	  this.emit('poll');
	};
	
	/**
	 * Overloads onData to detect payloads.
	 *
	 * @api private
	 */
	
	Polling.prototype.onData = function (data) {
	  var self = this;
	  debug('polling got data %s', data);
	  var callback = function (packet, index, total) {
	    // if its the first message we consider the transport open
	    if ('opening' === self.readyState) {
	      self.onOpen();
	    }
	
	    // if its a close packet, we close the ongoing requests
	    if ('close' === packet.type) {
	      self.onClose();
	      return false;
	    }
	
	    // otherwise bypass onData and handle the message
	    self.onPacket(packet);
	  };
	
	  // decode payload
	  parser.decodePayload(data, this.socket.binaryType, callback);
	
	  // if an event did not trigger closing
	  if ('closed' !== this.readyState) {
	    // if we got data we're not polling
	    this.polling = false;
	    this.emit('pollComplete');
	
	    if ('open' === this.readyState) {
	      this.poll();
	    } else {
	      debug('ignoring poll - transport state "%s"', this.readyState);
	    }
	  }
	};
	
	/**
	 * For polling, send a close packet.
	 *
	 * @api private
	 */
	
	Polling.prototype.doClose = function () {
	  var self = this;
	
	  function close () {
	    debug('writing close packet');
	    self.write([{ type: 'close' }]);
	  }
	
	  if ('open' === this.readyState) {
	    debug('transport open - closing');
	    close();
	  } else {
	    // in case we're trying to close while
	    // handshaking is in progress (GH-164)
	    debug('transport not open - deferring close');
	    this.once('open', close);
	  }
	};
	
	/**
	 * Writes a packets payload.
	 *
	 * @param {Array} data packets
	 * @param {Function} drain callback
	 * @api private
	 */
	
	Polling.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	  var callbackfn = function () {
	    self.writable = true;
	    self.emit('drain');
	  };
	
	  parser.encodePayload(packets, this.supportsBinary, function (data) {
	    self.doWrite(data, callbackfn);
	  });
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	Polling.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'https' : 'http';
	  var port = '';
	
	  // cache busting is forced
	  if (false !== this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  if (!this.supportsBinary && !query.sid) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // avoid port if default for schema
	  if (this.port && (('https' === schema && this.port !== 443) ||
	     ('http' === schema && this.port !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(414);
	var Emitter = __webpack_require__(422);
	
	/**
	 * Module exports.
	 */
	
	module.exports = Transport;
	
	/**
	 * Transport abstract constructor.
	 *
	 * @param {Object} options.
	 * @api private
	 */
	
	function Transport (opts) {
	  this.path = opts.path;
	  this.hostname = opts.hostname;
	  this.port = opts.port;
	  this.secure = opts.secure;
	  this.query = opts.query;
	  this.timestampParam = opts.timestampParam;
	  this.timestampRequests = opts.timestampRequests;
	  this.readyState = '';
	  this.agent = opts.agent || false;
	  this.socket = opts.socket;
	  this.enablesXDR = opts.enablesXDR;
	
	  // SSL options for Node.js client
	  this.pfx = opts.pfx;
	  this.key = opts.key;
	  this.passphrase = opts.passphrase;
	  this.cert = opts.cert;
	  this.ca = opts.ca;
	  this.ciphers = opts.ciphers;
	  this.rejectUnauthorized = opts.rejectUnauthorized;
	
	  // other options for Node.js client
	  this.extraHeaders = opts.extraHeaders;
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Transport.prototype);
	
	/**
	 * Emits an error.
	 *
	 * @param {String} str
	 * @return {Transport} for chaining
	 * @api public
	 */
	
	Transport.prototype.onError = function (msg, desc) {
	  var err = new Error(msg);
	  err.type = 'TransportError';
	  err.description = desc;
	  this.emit('error', err);
	  return this;
	};
	
	/**
	 * Opens the transport.
	 *
	 * @api public
	 */
	
	Transport.prototype.open = function () {
	  if ('closed' === this.readyState || '' === this.readyState) {
	    this.readyState = 'opening';
	    this.doOpen();
	  }
	
	  return this;
	};
	
	/**
	 * Closes the transport.
	 *
	 * @api private
	 */
	
	Transport.prototype.close = function () {
	  if ('opening' === this.readyState || 'open' === this.readyState) {
	    this.doClose();
	    this.onClose();
	  }
	
	  return this;
	};
	
	/**
	 * Sends multiple packets.
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	Transport.prototype.send = function (packets) {
	  if ('open' === this.readyState) {
	    this.write(packets);
	  } else {
	    throw new Error('Transport not open');
	  }
	};
	
	/**
	 * Called upon open
	 *
	 * @api private
	 */
	
	Transport.prototype.onOpen = function () {
	  this.readyState = 'open';
	  this.writable = true;
	  this.emit('open');
	};
	
	/**
	 * Called with data.
	 *
	 * @param {String} data
	 * @api private
	 */
	
	Transport.prototype.onData = function (data) {
	  var packet = parser.decodePacket(data, this.socket.binaryType);
	  this.onPacket(packet);
	};
	
	/**
	 * Called with a decoded packet.
	 */
	
	Transport.prototype.onPacket = function (packet) {
	  this.emit('packet', packet);
	};
	
	/**
	 * Called upon close.
	 *
	 * @api private
	 */
	
	Transport.prototype.onClose = function () {
	  this.readyState = 'closed';
	  this.emit('close');
	};


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var keys = __webpack_require__(415);
	var hasBinary = __webpack_require__(416);
	var sliceBuffer = __webpack_require__(417);
	var after = __webpack_require__(418);
	var utf8 = __webpack_require__(419);
	
	var base64encoder;
	if (global && global.ArrayBuffer) {
	  base64encoder = __webpack_require__(420);
	}
	
	/**
	 * Check if we are running an android browser. That requires us to use
	 * ArrayBuffer with polling transports...
	 *
	 * http://ghinda.net/jpeg-blob-ajax-android/
	 */
	
	var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
	
	/**
	 * Check if we are running in PhantomJS.
	 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
	 * https://github.com/ariya/phantomjs/issues/11395
	 * @type boolean
	 */
	var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);
	
	/**
	 * When true, avoids using Blobs to encode payloads.
	 * @type boolean
	 */
	var dontSendBlobs = isAndroid || isPhantomJS;
	
	/**
	 * Current protocol version.
	 */
	
	exports.protocol = 3;
	
	/**
	 * Packet types.
	 */
	
	var packets = exports.packets = {
	    open:     0    // non-ws
	  , close:    1    // non-ws
	  , ping:     2
	  , pong:     3
	  , message:  4
	  , upgrade:  5
	  , noop:     6
	};
	
	var packetslist = keys(packets);
	
	/**
	 * Premade error packet.
	 */
	
	var err = { type: 'error', data: 'parser error' };
	
	/**
	 * Create a blob api even for blob builder when vendor prefixes exist
	 */
	
	var Blob = __webpack_require__(421);
	
	/**
	 * Encodes a packet.
	 *
	 *     <packet type id> [ <data> ]
	 *
	 * Example:
	 *
	 *     5hello world
	 *     3
	 *     4
	 *
	 * Binary is encoded in an identical principle
	 *
	 * @api private
	 */
	
	exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
	  if ('function' == typeof supportsBinary) {
	    callback = supportsBinary;
	    supportsBinary = false;
	  }
	
	  if ('function' == typeof utf8encode) {
	    callback = utf8encode;
	    utf8encode = null;
	  }
	
	  var data = (packet.data === undefined)
	    ? undefined
	    : packet.data.buffer || packet.data;
	
	  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
	    return encodeArrayBuffer(packet, supportsBinary, callback);
	  } else if (Blob && data instanceof global.Blob) {
	    return encodeBlob(packet, supportsBinary, callback);
	  }
	
	  // might be an object with { base64: true, data: dataAsBase64String }
	  if (data && data.base64) {
	    return encodeBase64Object(packet, callback);
	  }
	
	  // Sending data as a utf-8 string
	  var encoded = packets[packet.type];
	
	  // data fragment is optional
	  if (undefined !== packet.data) {
	    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
	  }
	
	  return callback('' + encoded);
	
	};
	
	function encodeBase64Object(packet, callback) {
	  // packet data is an object { base64: true, data: dataAsBase64String }
	  var message = 'b' + exports.packets[packet.type] + packet.data.data;
	  return callback(message);
	}
	
	/**
	 * Encode packet helpers for binary types
	 */
	
	function encodeArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var data = packet.data;
	  var contentArray = new Uint8Array(data);
	  var resultBuffer = new Uint8Array(1 + data.byteLength);
	
	  resultBuffer[0] = packets[packet.type];
	  for (var i = 0; i < contentArray.length; i++) {
	    resultBuffer[i+1] = contentArray[i];
	  }
	
	  return callback(resultBuffer.buffer);
	}
	
	function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  var fr = new FileReader();
	  fr.onload = function() {
	    packet.data = fr.result;
	    exports.encodePacket(packet, supportsBinary, true, callback);
	  };
	  return fr.readAsArrayBuffer(packet.data);
	}
	
	function encodeBlob(packet, supportsBinary, callback) {
	  if (!supportsBinary) {
	    return exports.encodeBase64Packet(packet, callback);
	  }
	
	  if (dontSendBlobs) {
	    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
	  }
	
	  var length = new Uint8Array(1);
	  length[0] = packets[packet.type];
	  var blob = new Blob([length.buffer, packet.data]);
	
	  return callback(blob);
	}
	
	/**
	 * Encodes a packet with binary data in a base64 string
	 *
	 * @param {Object} packet, has `type` and `data`
	 * @return {String} base64 encoded message
	 */
	
	exports.encodeBase64Packet = function(packet, callback) {
	  var message = 'b' + exports.packets[packet.type];
	  if (Blob && packet.data instanceof global.Blob) {
	    var fr = new FileReader();
	    fr.onload = function() {
	      var b64 = fr.result.split(',')[1];
	      callback(message + b64);
	    };
	    return fr.readAsDataURL(packet.data);
	  }
	
	  var b64data;
	  try {
	    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
	  } catch (e) {
	    // iPhone Safari doesn't let you apply with typed arrays
	    var typed = new Uint8Array(packet.data);
	    var basic = new Array(typed.length);
	    for (var i = 0; i < typed.length; i++) {
	      basic[i] = typed[i];
	    }
	    b64data = String.fromCharCode.apply(null, basic);
	  }
	  message += global.btoa(b64data);
	  return callback(message);
	};
	
	/**
	 * Decodes a packet. Changes format to Blob if requested.
	 *
	 * @return {Object} with `type` and `data` (if any)
	 * @api private
	 */
	
	exports.decodePacket = function (data, binaryType, utf8decode) {
	  if (data === undefined) {
	    return err;
	  }
	  // String data
	  if (typeof data == 'string') {
	    if (data.charAt(0) == 'b') {
	      return exports.decodeBase64Packet(data.substr(1), binaryType);
	    }
	
	    if (utf8decode) {
	      data = tryDecode(data);
	      if (data === false) {
	        return err;
	      }
	    }
	    var type = data.charAt(0);
	
	    if (Number(type) != type || !packetslist[type]) {
	      return err;
	    }
	
	    if (data.length > 1) {
	      return { type: packetslist[type], data: data.substring(1) };
	    } else {
	      return { type: packetslist[type] };
	    }
	  }
	
	  var asArray = new Uint8Array(data);
	  var type = asArray[0];
	  var rest = sliceBuffer(data, 1);
	  if (Blob && binaryType === 'blob') {
	    rest = new Blob([rest]);
	  }
	  return { type: packetslist[type], data: rest };
	};
	
	function tryDecode(data) {
	  try {
	    data = utf8.decode(data);
	  } catch (e) {
	    return false;
	  }
	  return data;
	}
	
	/**
	 * Decodes a packet encoded in a base64 string
	 *
	 * @param {String} base64 encoded message
	 * @return {Object} with `type` and `data` (if any)
	 */
	
	exports.decodeBase64Packet = function(msg, binaryType) {
	  var type = packetslist[msg.charAt(0)];
	  if (!base64encoder) {
	    return { type: type, data: { base64: true, data: msg.substr(1) } };
	  }
	
	  var data = base64encoder.decode(msg.substr(1));
	
	  if (binaryType === 'blob' && Blob) {
	    data = new Blob([data]);
	  }
	
	  return { type: type, data: data };
	};
	
	/**
	 * Encodes multiple messages (payload).
	 *
	 *     <length>:data
	 *
	 * Example:
	 *
	 *     11:hello world2:hi
	 *
	 * If any contents are binary, they will be encoded as base64 strings. Base64
	 * encoded strings are marked with a b before the length specifier
	 *
	 * @param {Array} packets
	 * @api private
	 */
	
	exports.encodePayload = function (packets, supportsBinary, callback) {
	  if (typeof supportsBinary == 'function') {
	    callback = supportsBinary;
	    supportsBinary = null;
	  }
	
	  var isBinary = hasBinary(packets);
	
	  if (supportsBinary && isBinary) {
	    if (Blob && !dontSendBlobs) {
	      return exports.encodePayloadAsBlob(packets, callback);
	    }
	
	    return exports.encodePayloadAsArrayBuffer(packets, callback);
	  }
	
	  if (!packets.length) {
	    return callback('0:');
	  }
	
	  function setLengthHeader(message) {
	    return message.length + ':' + message;
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
	      doneCallback(null, setLengthHeader(message));
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(results.join(''));
	  });
	};
	
	/**
	 * Async array map using after
	 */
	
	function map(ary, each, done) {
	  var result = new Array(ary.length);
	  var next = after(ary.length, done);
	
	  var eachWithIndex = function(i, el, cb) {
	    each(el, function(error, msg) {
	      result[i] = msg;
	      cb(error, result);
	    });
	  };
	
	  for (var i = 0; i < ary.length; i++) {
	    eachWithIndex(i, ary[i], next);
	  }
	}
	
	/*
	 * Decodes data when a payload is maybe expected. Possible binary contents are
	 * decoded from their base64 representation
	 *
	 * @param {String} data, callback method
	 * @api public
	 */
	
	exports.decodePayload = function (data, binaryType, callback) {
	  if (typeof data != 'string') {
	    return exports.decodePayloadAsBinary(data, binaryType, callback);
	  }
	
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var packet;
	  if (data == '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	  var length = ''
	    , n, msg;
	
	  for (var i = 0, l = data.length; i < l; i++) {
	    var chr = data.charAt(i);
	
	    if (':' != chr) {
	      length += chr;
	    } else {
	      if ('' == length || (length != (n = Number(length)))) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      msg = data.substr(i + 1, n);
	
	      if (length != msg.length) {
	        // parser error - ignoring payload
	        return callback(err, 0, 1);
	      }
	
	      if (msg.length) {
	        packet = exports.decodePacket(msg, binaryType, true);
	
	        if (err.type == packet.type && err.data == packet.data) {
	          // parser error in individual packet - ignoring payload
	          return callback(err, 0, 1);
	        }
	
	        var ret = callback(packet, i + n, l);
	        if (false === ret) return;
	      }
	
	      // advance cursor
	      i += n;
	      length = '';
	    }
	  }
	
	  if (length != '') {
	    // parser error - ignoring payload
	    return callback(err, 0, 1);
	  }
	
	};
	
	/**
	 * Encodes multiple messages (payload) as binary.
	 *
	 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
	 * 255><data>
	 *
	 * Example:
	 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
	 *
	 * @param {Array} packets
	 * @return {ArrayBuffer} encoded payload
	 * @api private
	 */
	
	exports.encodePayloadAsArrayBuffer = function(packets, callback) {
	  if (!packets.length) {
	    return callback(new ArrayBuffer(0));
	  }
	
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(data) {
	      return doneCallback(null, data);
	    });
	  }
	
	  map(packets, encodeOne, function(err, encodedPackets) {
	    var totalLength = encodedPackets.reduce(function(acc, p) {
	      var len;
	      if (typeof p === 'string'){
	        len = p.length;
	      } else {
	        len = p.byteLength;
	      }
	      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
	    }, 0);
	
	    var resultArray = new Uint8Array(totalLength);
	
	    var bufferIndex = 0;
	    encodedPackets.forEach(function(p) {
	      var isString = typeof p === 'string';
	      var ab = p;
	      if (isString) {
	        var view = new Uint8Array(p.length);
	        for (var i = 0; i < p.length; i++) {
	          view[i] = p.charCodeAt(i);
	        }
	        ab = view.buffer;
	      }
	
	      if (isString) { // not true binary
	        resultArray[bufferIndex++] = 0;
	      } else { // true binary
	        resultArray[bufferIndex++] = 1;
	      }
	
	      var lenStr = ab.byteLength.toString();
	      for (var i = 0; i < lenStr.length; i++) {
	        resultArray[bufferIndex++] = parseInt(lenStr[i]);
	      }
	      resultArray[bufferIndex++] = 255;
	
	      var view = new Uint8Array(ab);
	      for (var i = 0; i < view.length; i++) {
	        resultArray[bufferIndex++] = view[i];
	      }
	    });
	
	    return callback(resultArray.buffer);
	  });
	};
	
	/**
	 * Encode as Blob
	 */
	
	exports.encodePayloadAsBlob = function(packets, callback) {
	  function encodeOne(packet, doneCallback) {
	    exports.encodePacket(packet, true, true, function(encoded) {
	      var binaryIdentifier = new Uint8Array(1);
	      binaryIdentifier[0] = 1;
	      if (typeof encoded === 'string') {
	        var view = new Uint8Array(encoded.length);
	        for (var i = 0; i < encoded.length; i++) {
	          view[i] = encoded.charCodeAt(i);
	        }
	        encoded = view.buffer;
	        binaryIdentifier[0] = 0;
	      }
	
	      var len = (encoded instanceof ArrayBuffer)
	        ? encoded.byteLength
	        : encoded.size;
	
	      var lenStr = len.toString();
	      var lengthAry = new Uint8Array(lenStr.length + 1);
	      for (var i = 0; i < lenStr.length; i++) {
	        lengthAry[i] = parseInt(lenStr[i]);
	      }
	      lengthAry[lenStr.length] = 255;
	
	      if (Blob) {
	        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
	        doneCallback(null, blob);
	      }
	    });
	  }
	
	  map(packets, encodeOne, function(err, results) {
	    return callback(new Blob(results));
	  });
	};
	
	/*
	 * Decodes data when a payload is maybe expected. Strings are decoded by
	 * interpreting each byte as a key code for entries marked to start with 0. See
	 * description of encodePayloadAsBinary
	 *
	 * @param {ArrayBuffer} data, callback method
	 * @api public
	 */
	
	exports.decodePayloadAsBinary = function (data, binaryType, callback) {
	  if (typeof binaryType === 'function') {
	    callback = binaryType;
	    binaryType = null;
	  }
	
	  var bufferTail = data;
	  var buffers = [];
	
	  var numberTooLong = false;
	  while (bufferTail.byteLength > 0) {
	    var tailArray = new Uint8Array(bufferTail);
	    var isString = tailArray[0] === 0;
	    var msgLength = '';
	
	    for (var i = 1; ; i++) {
	      if (tailArray[i] == 255) break;
	
	      if (msgLength.length > 310) {
	        numberTooLong = true;
	        break;
	      }
	
	      msgLength += tailArray[i];
	    }
	
	    if(numberTooLong) return callback(err, 0, 1);
	
	    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
	    msgLength = parseInt(msgLength);
	
	    var msg = sliceBuffer(bufferTail, 0, msgLength);
	    if (isString) {
	      try {
	        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
	      } catch (e) {
	        // iPhone Safari doesn't let you apply to typed arrays
	        var typed = new Uint8Array(msg);
	        msg = '';
	        for (var i = 0; i < typed.length; i++) {
	          msg += String.fromCharCode(typed[i]);
	        }
	      }
	    }
	
	    buffers.push(msg);
	    bufferTail = sliceBuffer(bufferTail, msgLength);
	  }
	
	  var total = buffers.length;
	  buffers.forEach(function(buffer, i) {
	    callback(exports.decodePacket(buffer, binaryType, true), i, total);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 415 */
/***/ function(module, exports) {

	
	/**
	 * Gets the keys for an object.
	 *
	 * @return {Array} keys
	 * @api private
	 */
	
	module.exports = Object.keys || function keys (obj){
	  var arr = [];
	  var has = Object.prototype.hasOwnProperty;
	
	  for (var i in obj) {
	    if (has.call(obj, i)) {
	      arr.push(i);
	    }
	  }
	  return arr;
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(402);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      if (obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 417 */
/***/ function(module, exports) {

	/**
	 * An abstraction for slicing an arraybuffer even when
	 * ArrayBuffer.prototype.slice is not supported
	 *
	 * @api public
	 */
	
	module.exports = function(arraybuffer, start, end) {
	  var bytes = arraybuffer.byteLength;
	  start = start || 0;
	  end = end || bytes;
	
	  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }
	
	  if (start < 0) { start += bytes; }
	  if (end < 0) { end += bytes; }
	  if (end > bytes) { end = bytes; }
	
	  if (start >= bytes || start >= end || bytes === 0) {
	    return new ArrayBuffer(0);
	  }
	
	  var abv = new Uint8Array(arraybuffer);
	  var result = new Uint8Array(end - start);
	  for (var i = start, ii = 0; i < end; i++, ii++) {
	    result[ii] = abv[i];
	  }
	  return result.buffer;
	};


/***/ },
/* 418 */
/***/ function(module, exports) {

	module.exports = after
	
	function after(count, callback, err_cb) {
	    var bail = false
	    err_cb = err_cb || noop
	    proxy.count = count
	
	    return (count === 0) ? callback() : proxy
	
	    function proxy(err, result) {
	        if (proxy.count <= 0) {
	            throw new Error('after called too many times')
	        }
	        --proxy.count
	
	        // after first error, rest are passed to err_cb
	        if (err) {
	            bail = true
	            callback(err)
	            // future error callbacks will go to error handler
	            callback = err_cb
	        } else if (proxy.count === 0 && !bail) {
	            callback(null, result)
	        }
	    }
	}
	
	function noop() {}


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/wtf8 v1.0.0 by @mathias */
	;(function(root) {
	
		// Detect free variables `exports`
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code,
		// and use it as `root`
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var stringFromCharCode = String.fromCharCode;
	
		// Taken from https://mths.be/punycode
		function ucs2decode(string) {
			var output = [];
			var counter = 0;
			var length = string.length;
			var value;
			var extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		// Taken from https://mths.be/punycode
		function ucs2encode(array) {
			var length = array.length;
			var index = -1;
			var value;
			var output = '';
			while (++index < length) {
				value = array[index];
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
			}
			return output;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function createByte(codePoint, shift) {
			return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
		}
	
		function encodeCodePoint(codePoint) {
			if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
				return stringFromCharCode(codePoint);
			}
			var symbol = '';
			if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
				symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
			}
			else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
				symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
				symbol += createByte(codePoint, 6);
			}
			else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
				symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
				symbol += createByte(codePoint, 12);
				symbol += createByte(codePoint, 6);
			}
			symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
			return symbol;
		}
	
		function wtf8encode(string) {
			var codePoints = ucs2decode(string);
			var length = codePoints.length;
			var index = -1;
			var codePoint;
			var byteString = '';
			while (++index < length) {
				codePoint = codePoints[index];
				byteString += encodeCodePoint(codePoint);
			}
			return byteString;
		}
	
		/*--------------------------------------------------------------------------*/
	
		function readContinuationByte() {
			if (byteIndex >= byteCount) {
				throw Error('Invalid byte index');
			}
	
			var continuationByte = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			if ((continuationByte & 0xC0) == 0x80) {
				return continuationByte & 0x3F;
			}
	
			// If we end up here, it’s not a continuation byte.
			throw Error('Invalid continuation byte');
		}
	
		function decodeSymbol() {
			var byte1;
			var byte2;
			var byte3;
			var byte4;
			var codePoint;
	
			if (byteIndex > byteCount) {
				throw Error('Invalid byte index');
			}
	
			if (byteIndex == byteCount) {
				return false;
			}
	
			// Read the first byte.
			byte1 = byteArray[byteIndex] & 0xFF;
			byteIndex++;
	
			// 1-byte sequence (no continuation bytes)
			if ((byte1 & 0x80) == 0) {
				return byte1;
			}
	
			// 2-byte sequence
			if ((byte1 & 0xE0) == 0xC0) {
				var byte2 = readContinuationByte();
				codePoint = ((byte1 & 0x1F) << 6) | byte2;
				if (codePoint >= 0x80) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 3-byte sequence (may include unpaired surrogates)
			if ((byte1 & 0xF0) == 0xE0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
				if (codePoint >= 0x0800) {
					return codePoint;
				} else {
					throw Error('Invalid continuation byte');
				}
			}
	
			// 4-byte sequence
			if ((byte1 & 0xF8) == 0xF0) {
				byte2 = readContinuationByte();
				byte3 = readContinuationByte();
				byte4 = readContinuationByte();
				codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
					(byte3 << 0x06) | byte4;
				if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
					return codePoint;
				}
			}
	
			throw Error('Invalid WTF-8 detected');
		}
	
		var byteArray;
		var byteCount;
		var byteIndex;
		function wtf8decode(byteString) {
			byteArray = ucs2decode(byteString);
			byteCount = byteArray.length;
			byteIndex = 0;
			var codePoints = [];
			var tmp;
			while ((tmp = decodeSymbol()) !== false) {
				codePoints.push(tmp);
			}
			return ucs2encode(codePoints);
		}
	
		/*--------------------------------------------------------------------------*/
	
		var wtf8 = {
			'version': '1.0.0',
			'encode': wtf8encode,
			'decode': wtf8decode
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return wtf8;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = wtf8;
			} else { // in Narwhal or RingoJS v0.7.0-
				var object = {};
				var hasOwnProperty = object.hasOwnProperty;
				for (var key in wtf8) {
					hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.wtf8 = wtf8;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)(module), (function() { return this; }())))

/***/ },
/* 420 */
/***/ function(module, exports) {

	/*
	 * base64-arraybuffer
	 * https://github.com/niklasvh/base64-arraybuffer
	 *
	 * Copyright (c) 2012 Niklas von Hertzen
	 * Licensed under the MIT license.
	 */
	(function(){
	  "use strict";
	
	  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	
	  // Use a lookup table to find the index.
	  var lookup = new Uint8Array(256);
	  for (var i = 0; i < chars.length; i++) {
	    lookup[chars.charCodeAt(i)] = i;
	  }
	
	  exports.encode = function(arraybuffer) {
	    var bytes = new Uint8Array(arraybuffer),
	    i, len = bytes.length, base64 = "";
	
	    for (i = 0; i < len; i+=3) {
	      base64 += chars[bytes[i] >> 2];
	      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
	      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
	      base64 += chars[bytes[i + 2] & 63];
	    }
	
	    if ((len % 3) === 2) {
	      base64 = base64.substring(0, base64.length - 1) + "=";
	    } else if (len % 3 === 1) {
	      base64 = base64.substring(0, base64.length - 2) + "==";
	    }
	
	    return base64;
	  };
	
	  exports.decode =  function(base64) {
	    var bufferLength = base64.length * 0.75,
	    len = base64.length, i, p = 0,
	    encoded1, encoded2, encoded3, encoded4;
	
	    if (base64[base64.length - 1] === "=") {
	      bufferLength--;
	      if (base64[base64.length - 2] === "=") {
	        bufferLength--;
	      }
	    }
	
	    var arraybuffer = new ArrayBuffer(bufferLength),
	    bytes = new Uint8Array(arraybuffer);
	
	    for (i = 0; i < len; i+=4) {
	      encoded1 = lookup[base64.charCodeAt(i)];
	      encoded2 = lookup[base64.charCodeAt(i+1)];
	      encoded3 = lookup[base64.charCodeAt(i+2)];
	      encoded4 = lookup[base64.charCodeAt(i+3)];
	
	      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
	      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
	      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
	    }
	
	    return arraybuffer;
	  };
	})();


/***/ },
/* 421 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Create a blob builder even when vendor prefixes exist
	 */
	
	var BlobBuilder = global.BlobBuilder
	  || global.WebKitBlobBuilder
	  || global.MSBlobBuilder
	  || global.MozBlobBuilder;
	
	/**
	 * Check if Blob constructor is supported
	 */
	
	var blobSupported = (function() {
	  try {
	    var a = new Blob(['hi']);
	    return a.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if Blob constructor supports ArrayBufferViews
	 * Fails in Safari 6, so we need to map to ArrayBuffers there.
	 */
	
	var blobSupportsArrayBufferView = blobSupported && (function() {
	  try {
	    var b = new Blob([new Uint8Array([1,2])]);
	    return b.size === 2;
	  } catch(e) {
	    return false;
	  }
	})();
	
	/**
	 * Check if BlobBuilder is supported
	 */
	
	var blobBuilderSupported = BlobBuilder
	  && BlobBuilder.prototype.append
	  && BlobBuilder.prototype.getBlob;
	
	/**
	 * Helper function that maps ArrayBufferViews to ArrayBuffers
	 * Used by BlobBuilder constructor and old browsers that didn't
	 * support it in the Blob constructor.
	 */
	
	function mapArrayBufferViews(ary) {
	  for (var i = 0; i < ary.length; i++) {
	    var chunk = ary[i];
	    if (chunk.buffer instanceof ArrayBuffer) {
	      var buf = chunk.buffer;
	
	      // if this is a subarray, make a copy so we only
	      // include the subarray region from the underlying buffer
	      if (chunk.byteLength !== buf.byteLength) {
	        var copy = new Uint8Array(chunk.byteLength);
	        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
	        buf = copy.buffer;
	      }
	
	      ary[i] = buf;
	    }
	  }
	}
	
	function BlobBuilderConstructor(ary, options) {
	  options = options || {};
	
	  var bb = new BlobBuilder();
	  mapArrayBufferViews(ary);
	
	  for (var i = 0; i < ary.length; i++) {
	    bb.append(ary[i]);
	  }
	
	  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
	};
	
	function BlobConstructor(ary, options) {
	  mapArrayBufferViews(ary);
	  return new Blob(ary, options || {});
	};
	
	module.exports = (function() {
	  if (blobSupported) {
	    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
	  } else if (blobBuilderSupported) {
	    return BlobBuilderConstructor;
	  } else {
	    return undefined;
	  }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 422 */
400,
/* 423 */
/***/ function(module, exports) {

	/**
	 * Compiles a querystring
	 * Returns string representation of the object
	 *
	 * @param {Object}
	 * @api private
	 */
	
	exports.encode = function (obj) {
	  var str = '';
	
	  for (var i in obj) {
	    if (obj.hasOwnProperty(i)) {
	      if (str.length) str += '&';
	      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
	    }
	  }
	
	  return str;
	};
	
	/**
	 * Parses a simple querystring into an object
	 *
	 * @param {String} qs
	 * @api private
	 */
	
	exports.decode = function(qs){
	  var qry = {};
	  var pairs = qs.split('&');
	  for (var i = 0, l = pairs.length; i < l; i++) {
	    var pair = pairs[i].split('=');
	    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	  }
	  return qry;
	};


/***/ },
/* 424 */
/***/ function(module, exports) {

	
	module.exports = function(a, b){
	  var fn = function(){};
	  fn.prototype = b.prototype;
	  a.prototype = new fn;
	  a.prototype.constructor = a;
	};

/***/ },
/* 425 */
/***/ function(module, exports) {

	'use strict';
	
	var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
	  , length = 64
	  , map = {}
	  , seed = 0
	  , i = 0
	  , prev;
	
	/**
	 * Return a string representing the specified number.
	 *
	 * @param {Number} num The number to convert.
	 * @returns {String} The string representation of the number.
	 * @api public
	 */
	function encode(num) {
	  var encoded = '';
	
	  do {
	    encoded = alphabet[num % length] + encoded;
	    num = Math.floor(num / length);
	  } while (num > 0);
	
	  return encoded;
	}
	
	/**
	 * Return the integer value specified by the given string.
	 *
	 * @param {String} str The string to convert.
	 * @returns {Number} The integer value represented by the string.
	 * @api public
	 */
	function decode(str) {
	  var decoded = 0;
	
	  for (i = 0; i < str.length; i++) {
	    decoded = decoded * length + map[str.charAt(i)];
	  }
	
	  return decoded;
	}
	
	/**
	 * Yeast: A tiny growing id generator.
	 *
	 * @returns {String} A unique id.
	 * @api public
	 */
	function yeast() {
	  var now = encode(+new Date());
	
	  if (now !== prev) return seed = 0, prev = now;
	  return now +'.'+ encode(seed++);
	}
	
	//
	// Map each character to its index.
	//
	for (; i < length; i++) map[alphabet[i]] = i;
	
	//
	// Expose the `yeast`, `encode` and `decode` functions.
	//
	yeast.encode = encode;
	yeast.decode = decode;
	module.exports = yeast;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module requirements.
	 */
	
	var Polling = __webpack_require__(412);
	var inherit = __webpack_require__(424);
	
	/**
	 * Module exports.
	 */
	
	module.exports = JSONPPolling;
	
	/**
	 * Cached regular expressions.
	 */
	
	var rNewline = /\n/g;
	var rEscapedNewline = /\\n/g;
	
	/**
	 * Global JSONP callbacks.
	 */
	
	var callbacks;
	
	/**
	 * Noop.
	 */
	
	function empty () { }
	
	/**
	 * JSONP Polling constructor.
	 *
	 * @param {Object} opts.
	 * @api public
	 */
	
	function JSONPPolling (opts) {
	  Polling.call(this, opts);
	
	  this.query = this.query || {};
	
	  // define global callbacks array if not present
	  // we do this here (lazily) to avoid unneeded global pollution
	  if (!callbacks) {
	    // we need to consider multiple engines in the same page
	    if (!global.___eio) global.___eio = [];
	    callbacks = global.___eio;
	  }
	
	  // callback identifier
	  this.index = callbacks.length;
	
	  // add callback to jsonp global
	  var self = this;
	  callbacks.push(function (msg) {
	    self.onData(msg);
	  });
	
	  // append to query string
	  this.query.j = this.index;
	
	  // prevent spurious errors from being emitted when the window is unloaded
	  if (global.document && global.addEventListener) {
	    global.addEventListener('beforeunload', function () {
	      if (self.script) self.script.onerror = empty;
	    }, false);
	  }
	}
	
	/**
	 * Inherits from Polling.
	 */
	
	inherit(JSONPPolling, Polling);
	
	/*
	 * JSONP only supports binary as base64 encoded strings
	 */
	
	JSONPPolling.prototype.supportsBinary = false;
	
	/**
	 * Closes the socket.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doClose = function () {
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  if (this.form) {
	    this.form.parentNode.removeChild(this.form);
	    this.form = null;
	    this.iframe = null;
	  }
	
	  Polling.prototype.doClose.call(this);
	};
	
	/**
	 * Starts a poll cycle.
	 *
	 * @api private
	 */
	
	JSONPPolling.prototype.doPoll = function () {
	  var self = this;
	  var script = document.createElement('script');
	
	  if (this.script) {
	    this.script.parentNode.removeChild(this.script);
	    this.script = null;
	  }
	
	  script.async = true;
	  script.src = this.uri();
	  script.onerror = function (e) {
	    self.onError('jsonp poll error', e);
	  };
	
	  var insertAt = document.getElementsByTagName('script')[0];
	  if (insertAt) {
	    insertAt.parentNode.insertBefore(script, insertAt);
	  } else {
	    (document.head || document.body).appendChild(script);
	  }
	  this.script = script;
	
	  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);
	
	  if (isUAgecko) {
	    setTimeout(function () {
	      var iframe = document.createElement('iframe');
	      document.body.appendChild(iframe);
	      document.body.removeChild(iframe);
	    }, 100);
	  }
	};
	
	/**
	 * Writes with a hidden iframe.
	 *
	 * @param {String} data to send
	 * @param {Function} called upon flush.
	 * @api private
	 */
	
	JSONPPolling.prototype.doWrite = function (data, fn) {
	  var self = this;
	
	  if (!this.form) {
	    var form = document.createElement('form');
	    var area = document.createElement('textarea');
	    var id = this.iframeId = 'eio_iframe_' + this.index;
	    var iframe;
	
	    form.className = 'socketio';
	    form.style.position = 'absolute';
	    form.style.top = '-1000px';
	    form.style.left = '-1000px';
	    form.target = id;
	    form.method = 'POST';
	    form.setAttribute('accept-charset', 'utf-8');
	    area.name = 'd';
	    form.appendChild(area);
	    document.body.appendChild(form);
	
	    this.form = form;
	    this.area = area;
	  }
	
	  this.form.action = this.uri();
	
	  function complete () {
	    initIframe();
	    fn();
	  }
	
	  function initIframe () {
	    if (self.iframe) {
	      try {
	        self.form.removeChild(self.iframe);
	      } catch (e) {
	        self.onError('jsonp polling iframe removal error', e);
	      }
	    }
	
	    try {
	      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
	      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
	      iframe = document.createElement(html);
	    } catch (e) {
	      iframe = document.createElement('iframe');
	      iframe.name = self.iframeId;
	      iframe.src = 'javascript:0';
	    }
	
	    iframe.id = self.iframeId;
	
	    self.form.appendChild(iframe);
	    self.iframe = iframe;
	  }
	
	  initIframe();
	
	  // escape \n to prevent it from being converted into \r\n by some UAs
	  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
	  data = data.replace(rEscapedNewline, '\\\n');
	  this.area.value = data.replace(rNewline, '\\n');
	
	  try {
	    this.form.submit();
	  } catch (e) {}
	
	  if (this.iframe.attachEvent) {
	    this.iframe.onreadystatechange = function () {
	      if (self.iframe.readyState === 'complete') {
	        complete();
	      }
	    };
	  } else {
	    this.iframe.onload = complete;
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Module dependencies.
	 */
	
	var Transport = __webpack_require__(413);
	var parser = __webpack_require__(414);
	var parseqs = __webpack_require__(423);
	var inherit = __webpack_require__(424);
	var yeast = __webpack_require__(425);
	var debug = __webpack_require__(394)('engine.io-client:websocket');
	var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
	
	/**
	 * Get either the `WebSocket` or `MozWebSocket` globals
	 * in the browser or try to resolve WebSocket-compatible
	 * interface exposed by `ws` for Node-like environment.
	 */
	
	var WebSocket = BrowserWebSocket;
	if (!WebSocket && typeof window === 'undefined') {
	  try {
	    WebSocket = __webpack_require__(428);
	  } catch (e) { }
	}
	
	/**
	 * Module exports.
	 */
	
	module.exports = WS;
	
	/**
	 * WebSocket transport constructor.
	 *
	 * @api {Object} connection options
	 * @api public
	 */
	
	function WS (opts) {
	  var forceBase64 = (opts && opts.forceBase64);
	  if (forceBase64) {
	    this.supportsBinary = false;
	  }
	  this.perMessageDeflate = opts.perMessageDeflate;
	  Transport.call(this, opts);
	}
	
	/**
	 * Inherits from Transport.
	 */
	
	inherit(WS, Transport);
	
	/**
	 * Transport name.
	 *
	 * @api public
	 */
	
	WS.prototype.name = 'websocket';
	
	/*
	 * WebSockets support binary
	 */
	
	WS.prototype.supportsBinary = true;
	
	/**
	 * Opens socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doOpen = function () {
	  if (!this.check()) {
	    // let probe timeout
	    return;
	  }
	
	  var uri = this.uri();
	  var protocols = void (0);
	  var opts = {
	    agent: this.agent,
	    perMessageDeflate: this.perMessageDeflate
	  };
	
	  // SSL options for Node.js client
	  opts.pfx = this.pfx;
	  opts.key = this.key;
	  opts.passphrase = this.passphrase;
	  opts.cert = this.cert;
	  opts.ca = this.ca;
	  opts.ciphers = this.ciphers;
	  opts.rejectUnauthorized = this.rejectUnauthorized;
	  if (this.extraHeaders) {
	    opts.headers = this.extraHeaders;
	  }
	
	  try {
	    this.ws = BrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
	  } catch (err) {
	    return this.emit('error', err);
	  }
	
	  if (this.ws.binaryType === undefined) {
	    this.supportsBinary = false;
	  }
	
	  if (this.ws.supports && this.ws.supports.binary) {
	    this.supportsBinary = true;
	    this.ws.binaryType = 'nodebuffer';
	  } else {
	    this.ws.binaryType = 'arraybuffer';
	  }
	
	  this.addEventListeners();
	};
	
	/**
	 * Adds event listeners to the socket
	 *
	 * @api private
	 */
	
	WS.prototype.addEventListeners = function () {
	  var self = this;
	
	  this.ws.onopen = function () {
	    self.onOpen();
	  };
	  this.ws.onclose = function () {
	    self.onClose();
	  };
	  this.ws.onmessage = function (ev) {
	    self.onData(ev.data);
	  };
	  this.ws.onerror = function (e) {
	    self.onError('websocket error', e);
	  };
	};
	
	/**
	 * Writes data to socket.
	 *
	 * @param {Array} array of packets.
	 * @api private
	 */
	
	WS.prototype.write = function (packets) {
	  var self = this;
	  this.writable = false;
	
	  // encodePacket efficient as it uses WS framing
	  // no need for encodePayload
	  var total = packets.length;
	  for (var i = 0, l = total; i < l; i++) {
	    (function (packet) {
	      parser.encodePacket(packet, self.supportsBinary, function (data) {
	        if (!BrowserWebSocket) {
	          // always create a new object (GH-437)
	          var opts = {};
	          if (packet.options) {
	            opts.compress = packet.options.compress;
	          }
	
	          if (self.perMessageDeflate) {
	            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
	            if (len < self.perMessageDeflate.threshold) {
	              opts.compress = false;
	            }
	          }
	        }
	
	        // Sometimes the websocket has already been closed but the browser didn't
	        // have a chance of informing us about it yet, in that case send will
	        // throw an error
	        try {
	          if (BrowserWebSocket) {
	            // TypeError is thrown when passing the second argument on Safari
	            self.ws.send(data);
	          } else {
	            self.ws.send(data, opts);
	          }
	        } catch (e) {
	          debug('websocket closed before onclose event');
	        }
	
	        --total || done();
	      });
	    })(packets[i]);
	  }
	
	  function done () {
	    self.emit('flush');
	
	    // fake drain
	    // defer to next tick to allow Socket to clear writeBuffer
	    setTimeout(function () {
	      self.writable = true;
	      self.emit('drain');
	    }, 0);
	  }
	};
	
	/**
	 * Called upon close
	 *
	 * @api private
	 */
	
	WS.prototype.onClose = function () {
	  Transport.prototype.onClose.call(this);
	};
	
	/**
	 * Closes socket.
	 *
	 * @api private
	 */
	
	WS.prototype.doClose = function () {
	  if (typeof this.ws !== 'undefined') {
	    this.ws.close();
	  }
	};
	
	/**
	 * Generates uri for connection.
	 *
	 * @api private
	 */
	
	WS.prototype.uri = function () {
	  var query = this.query || {};
	  var schema = this.secure ? 'wss' : 'ws';
	  var port = '';
	
	  // avoid port if default for schema
	  if (this.port && (('wss' === schema && this.port !== 443) ||
	    ('ws' === schema && this.port !== 80))) {
	    port = ':' + this.port;
	  }
	
	  // append timestamp to URI
	  if (this.timestampRequests) {
	    query[this.timestampParam] = yeast();
	  }
	
	  // communicate binary support capabilities
	  if (!this.supportsBinary) {
	    query.b64 = 1;
	  }
	
	  query = parseqs.encode(query);
	
	  // prepend ? to query
	  if (query.length) {
	    query = '?' + query;
	  }
	
	  var ipv6 = this.hostname.indexOf(':') !== -1;
	  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
	};
	
	/**
	 * Feature detection for WebSocket.
	 *
	 * @return {Boolean} whether this transport is available.
	 * @api public
	 */
	
	WS.prototype.check = function () {
	  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 428 */
1268,
/* 429 */
/***/ function(module, exports) {

	
	var indexOf = [].indexOf;
	
	module.exports = function(arr, obj){
	  if (indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 430 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * JSON parse.
	 *
	 * @see Based on jQuery#parseJSON (MIT) and JSON2
	 * @api private
	 */
	
	var rvalidchars = /^[\],:{}\s]*$/;
	var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
	var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
	var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
	var rtrimLeft = /^\s+/;
	var rtrimRight = /\s+$/;
	
	module.exports = function parsejson(data) {
	  if ('string' != typeof data || !data) {
	    return null;
	  }
	
	  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');
	
	  // Attempt to parse using the native JSON parser first
	  if (global.JSON && JSON.parse) {
	    return JSON.parse(data);
	  }
	
	  if (rvalidchars.test(data.replace(rvalidescape, '@')
	      .replace(rvalidtokens, ']')
	      .replace(rvalidbraces, ''))) {
	    return (new Function('return ' + data))();
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var parser = __webpack_require__(397);
	var Emitter = __webpack_require__(432);
	var toArray = __webpack_require__(433);
	var on = __webpack_require__(434);
	var bind = __webpack_require__(435);
	var debug = __webpack_require__(394)('socket.io-client:socket');
	var hasBin = __webpack_require__(436);
	
	/**
	 * Module exports.
	 */
	
	module.exports = exports = Socket;
	
	/**
	 * Internal events (blacklisted).
	 * These events can't be emitted by the user.
	 *
	 * @api private
	 */
	
	var events = {
	  connect: 1,
	  connect_error: 1,
	  connect_timeout: 1,
	  connecting: 1,
	  disconnect: 1,
	  error: 1,
	  reconnect: 1,
	  reconnect_attempt: 1,
	  reconnect_failed: 1,
	  reconnect_error: 1,
	  reconnecting: 1,
	  ping: 1,
	  pong: 1
	};
	
	/**
	 * Shortcut to `Emitter#emit`.
	 */
	
	var emit = Emitter.prototype.emit;
	
	/**
	 * `Socket` constructor.
	 *
	 * @api public
	 */
	
	function Socket (io, nsp, opts) {
	  this.io = io;
	  this.nsp = nsp;
	  this.json = this; // compat
	  this.ids = 0;
	  this.acks = {};
	  this.receiveBuffer = [];
	  this.sendBuffer = [];
	  this.connected = false;
	  this.disconnected = true;
	  if (opts && opts.query) {
	    this.query = opts.query;
	  }
	  if (this.io.autoConnect) this.open();
	}
	
	/**
	 * Mix in `Emitter`.
	 */
	
	Emitter(Socket.prototype);
	
	/**
	 * Subscribe to open, close and packet events
	 *
	 * @api private
	 */
	
	Socket.prototype.subEvents = function () {
	  if (this.subs) return;
	
	  var io = this.io;
	  this.subs = [
	    on(io, 'open', bind(this, 'onopen')),
	    on(io, 'packet', bind(this, 'onpacket')),
	    on(io, 'close', bind(this, 'onclose'))
	  ];
	};
	
	/**
	 * "Opens" the socket.
	 *
	 * @api public
	 */
	
	Socket.prototype.open =
	Socket.prototype.connect = function () {
	  if (this.connected) return this;
	
	  this.subEvents();
	  this.io.open(); // ensure open
	  if ('open' === this.io.readyState) this.onopen();
	  this.emit('connecting');
	  return this;
	};
	
	/**
	 * Sends a `message` event.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.send = function () {
	  var args = toArray(arguments);
	  args.unshift('message');
	  this.emit.apply(this, args);
	  return this;
	};
	
	/**
	 * Override `emit`.
	 * If the event is in `events`, it's emitted normally.
	 *
	 * @param {String} event name
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.emit = function (ev) {
	  if (events.hasOwnProperty(ev)) {
	    emit.apply(this, arguments);
	    return this;
	  }
	
	  var args = toArray(arguments);
	  var parserType = parser.EVENT; // default
	  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
	  var packet = { type: parserType, data: args };
	
	  packet.options = {};
	  packet.options.compress = !this.flags || false !== this.flags.compress;
	
	  // event ack callback
	  if ('function' === typeof args[args.length - 1]) {
	    debug('emitting packet with ack id %d', this.ids);
	    this.acks[this.ids] = args.pop();
	    packet.id = this.ids++;
	  }
	
	  if (this.connected) {
	    this.packet(packet);
	  } else {
	    this.sendBuffer.push(packet);
	  }
	
	  delete this.flags;
	
	  return this;
	};
	
	/**
	 * Sends a packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.packet = function (packet) {
	  packet.nsp = this.nsp;
	  this.io.packet(packet);
	};
	
	/**
	 * Called upon engine `open`.
	 *
	 * @api private
	 */
	
	Socket.prototype.onopen = function () {
	  debug('transport is open - connecting');
	
	  // write connect packet if necessary
	  if ('/' !== this.nsp) {
	    if (this.query) {
	      this.packet({type: parser.CONNECT, query: this.query});
	    } else {
	      this.packet({type: parser.CONNECT});
	    }
	  }
	};
	
	/**
	 * Called upon engine `close`.
	 *
	 * @param {String} reason
	 * @api private
	 */
	
	Socket.prototype.onclose = function (reason) {
	  debug('close (%s)', reason);
	  this.connected = false;
	  this.disconnected = true;
	  delete this.id;
	  this.emit('disconnect', reason);
	};
	
	/**
	 * Called with socket packet.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onpacket = function (packet) {
	  if (packet.nsp !== this.nsp) return;
	
	  switch (packet.type) {
	    case parser.CONNECT:
	      this.onconnect();
	      break;
	
	    case parser.EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.BINARY_EVENT:
	      this.onevent(packet);
	      break;
	
	    case parser.ACK:
	      this.onack(packet);
	      break;
	
	    case parser.BINARY_ACK:
	      this.onack(packet);
	      break;
	
	    case parser.DISCONNECT:
	      this.ondisconnect();
	      break;
	
	    case parser.ERROR:
	      this.emit('error', packet.data);
	      break;
	  }
	};
	
	/**
	 * Called upon a server event.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onevent = function (packet) {
	  var args = packet.data || [];
	  debug('emitting event %j', args);
	
	  if (null != packet.id) {
	    debug('attaching ack callback to event');
	    args.push(this.ack(packet.id));
	  }
	
	  if (this.connected) {
	    emit.apply(this, args);
	  } else {
	    this.receiveBuffer.push(args);
	  }
	};
	
	/**
	 * Produces an ack callback to emit with an event.
	 *
	 * @api private
	 */
	
	Socket.prototype.ack = function (id) {
	  var self = this;
	  var sent = false;
	  return function () {
	    // prevent double callbacks
	    if (sent) return;
	    sent = true;
	    var args = toArray(arguments);
	    debug('sending ack %j', args);
	
	    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
	    self.packet({
	      type: type,
	      id: id,
	      data: args
	    });
	  };
	};
	
	/**
	 * Called upon a server acknowlegement.
	 *
	 * @param {Object} packet
	 * @api private
	 */
	
	Socket.prototype.onack = function (packet) {
	  var ack = this.acks[packet.id];
	  if ('function' === typeof ack) {
	    debug('calling ack %s with %j', packet.id, packet.data);
	    ack.apply(this, packet.data);
	    delete this.acks[packet.id];
	  } else {
	    debug('bad ack %s', packet.id);
	  }
	};
	
	/**
	 * Called upon server connect.
	 *
	 * @api private
	 */
	
	Socket.prototype.onconnect = function () {
	  this.connected = true;
	  this.disconnected = false;
	  this.emit('connect');
	  this.emitBuffered();
	};
	
	/**
	 * Emit buffered events (received and emitted).
	 *
	 * @api private
	 */
	
	Socket.prototype.emitBuffered = function () {
	  var i;
	  for (i = 0; i < this.receiveBuffer.length; i++) {
	    emit.apply(this, this.receiveBuffer[i]);
	  }
	  this.receiveBuffer = [];
	
	  for (i = 0; i < this.sendBuffer.length; i++) {
	    this.packet(this.sendBuffer[i]);
	  }
	  this.sendBuffer = [];
	};
	
	/**
	 * Called upon server disconnect.
	 *
	 * @api private
	 */
	
	Socket.prototype.ondisconnect = function () {
	  debug('server disconnect (%s)', this.nsp);
	  this.destroy();
	  this.onclose('io server disconnect');
	};
	
	/**
	 * Called upon forced client/server side disconnections,
	 * this method ensures the manager stops tracking us and
	 * that reconnections don't get triggered for this.
	 *
	 * @api private.
	 */
	
	Socket.prototype.destroy = function () {
	  if (this.subs) {
	    // clean subscriptions to avoid reconnections
	    for (var i = 0; i < this.subs.length; i++) {
	      this.subs[i].destroy();
	    }
	    this.subs = null;
	  }
	
	  this.io.destroy(this);
	};
	
	/**
	 * Disconnects the socket manually.
	 *
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.close =
	Socket.prototype.disconnect = function () {
	  if (this.connected) {
	    debug('performing disconnect (%s)', this.nsp);
	    this.packet({ type: parser.DISCONNECT });
	  }
	
	  // remove socket from pool
	  this.destroy();
	
	  if (this.connected) {
	    // fire events
	    this.onclose('io client disconnect');
	  }
	  return this;
	};
	
	/**
	 * Sets the compress flag.
	 *
	 * @param {Boolean} if `true`, compresses the sending data
	 * @return {Socket} self
	 * @api public
	 */
	
	Socket.prototype.compress = function (compress) {
	  this.flags = this.flags || {};
	  this.flags.compress = compress;
	  return this;
	};


/***/ },
/* 432 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	module.exports = Emitter;
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 433 */
/***/ function(module, exports) {

	module.exports = toArray
	
	function toArray(list, index) {
	    var array = []
	
	    index = index || 0
	
	    for (var i = index || 0; i < list.length; i++) {
	        array[i - index] = list[i]
	    }
	
	    return array
	}


/***/ },
/* 434 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = on;
	
	/**
	 * Helper for subscriptions.
	 *
	 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
	 * @param {String} event name
	 * @param {Function} callback
	 * @api public
	 */
	
	function on (obj, ev, fn) {
	  obj.on(ev, fn);
	  return {
	    destroy: function () {
	      obj.removeListener(ev, fn);
	    }
	  };
	}


/***/ },
/* 435 */
/***/ function(module, exports) {

	/**
	 * Slice reference.
	 */
	
	var slice = [].slice;
	
	/**
	 * Bind `obj` to `fn`.
	 *
	 * @param {Object} obj
	 * @param {Function|String} fn or string
	 * @return {Function}
	 * @api public
	 */
	
	module.exports = function(obj, fn){
	  if ('string' == typeof fn) fn = obj[fn];
	  if ('function' != typeof fn) throw new Error('bind() requires a function');
	  var args = slice.call(arguments, 2);
	  return function(){
	    return fn.apply(obj, args.concat(slice.call(arguments)));
	  }
	};


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	 * Module requirements.
	 */
	
	var isArray = __webpack_require__(437);
	
	/**
	 * Module exports.
	 */
	
	module.exports = hasBinary;
	
	/**
	 * Checks for binary data.
	 *
	 * Right now only Buffer and ArrayBuffer are supported..
	 *
	 * @param {Object} anything
	 * @api public
	 */
	
	function hasBinary(data) {
	
	  function _hasBinary(obj) {
	    if (!obj) return false;
	
	    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
	         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
	         (global.Blob && obj instanceof Blob) ||
	         (global.File && obj instanceof File)
	        ) {
	      return true;
	    }
	
	    if (isArray(obj)) {
	      for (var i = 0; i < obj.length; i++) {
	          if (_hasBinary(obj[i])) {
	              return true;
	          }
	      }
	    } else if (obj && 'object' == typeof obj) {
	      // see: https://github.com/Automattic/has-binary/pull/4
	      if (obj.toJSON && 'function' == typeof obj.toJSON) {
	        obj = obj.toJSON();
	      }
	
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
	          return true;
	        }
	      }
	    }
	
	    return false;
	  }
	
	  return _hasBinary(data);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 437 */
402,
/* 438 */
/***/ function(module, exports) {

	
	/**
	 * Expose `Backoff`.
	 */
	
	module.exports = Backoff;
	
	/**
	 * Initialize backoff timer with `opts`.
	 *
	 * - `min` initial timeout in milliseconds [100]
	 * - `max` max timeout [10000]
	 * - `jitter` [0]
	 * - `factor` [2]
	 *
	 * @param {Object} opts
	 * @api public
	 */
	
	function Backoff(opts) {
	  opts = opts || {};
	  this.ms = opts.min || 100;
	  this.max = opts.max || 10000;
	  this.factor = opts.factor || 2;
	  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
	  this.attempts = 0;
	}
	
	/**
	 * Return the backoff duration.
	 *
	 * @return {Number}
	 * @api public
	 */
	
	Backoff.prototype.duration = function(){
	  var ms = this.ms * Math.pow(this.factor, this.attempts++);
	  if (this.jitter) {
	    var rand =  Math.random();
	    var deviation = Math.floor(rand * this.jitter * ms);
	    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
	  }
	  return Math.min(ms, this.max) | 0;
	};
	
	/**
	 * Reset the number of attempts.
	 *
	 * @api public
	 */
	
	Backoff.prototype.reset = function(){
	  this.attempts = 0;
	};
	
	/**
	 * Set the minimum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMin = function(min){
	  this.ms = min;
	};
	
	/**
	 * Set the maximum duration
	 *
	 * @api public
	 */
	
	Backoff.prototype.setMax = function(max){
	  this.max = max;
	};
	
	/**
	 * Set the jitter
	 *
	 * @api public
	 */
	
	Backoff.prototype.setJitter = function(jitter){
	  this.jitter = jitter;
	};
	


/***/ },
/* 439 */
/***/ function(module, exports) {

	'use strict';
	
	// http interceptor to check auth failures for xhr requests
	
	function ctrl($httpProvider) {
	    $httpProvider.interceptors.push('httpInterceptor');
	}
	
	ctrl.$inject = ['$httpProvider'];
	module.exports = ctrl;

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // system config
	    ngModule.config(__webpack_require__(441));
	    // remove the /#! from urls
	    ngModule.config(__webpack_require__(446));
	};

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkLoggedIn($q, $timeout, $http, $location, $window, Global, $state) {
	    // Initialize a new promise
	    var deferred = $q.defer();
	    // Make an AJAX call to check if the user is logged in
	    if ($window.sessionStorage.token) {
	        $http.get(("https://api-demo.mantix4.com") + '/api/loggedin').success(function (result) {
	            Global.user = result.user;
	            $timeout(deferred.resolve);
	            $window.sessionStorage.token = result.token;
	            Global.user.settings_global.current = result.current;
	        }).error(function (user) {
	            $window.sessionStorage.token = null;
	            $timeout(deferred.reject);
	            $location.url('/login');
	        });
	    } else {
	        $timeout(deferred.reject);
	        $location.url('/login');
	    }
	    return deferred.promise;
	};
	checkLoggedIn.$inject = ['$q', '$timeout', '$http', '$location', '$window', 'Global', '$state'];
	
	// Check if the user is not conntected
	function checkLoggedOut($q, $timeout, $http, $location, $window, Global, $state) {
	    // Initialize a new promise
	    var deferred = $q.defer();
	    // if there's still a token, take them back home (not login page)
	    if ($window.sessionStorage.token) {
	        // dont check if user is resetting password (passChangeToken)
	        $http.get('/api/loggedin').success(function (result) {
	            // if success
	            $timeout(deferred.reject);
	            // go home
	            $location.url('/live');
	            $window.sessionStorage.token = result.token;
	            Global.user.settings_global.current = result.current;
	            console.log($state.current.url);
	            if ($state.current.url === '/live') {
	                // for now if we're on the live page already, lets do a refresh
	                $window.location.reload();
	            } else {
	                $location.url('/live');
	                // $window.location.reload();
	            }
	        }).error(function (user) {
	            $timeout(deferred.resolve);
	            $location.url('/login');
	        });
	    } else {
	        $timeout(deferred.resolve);
	    }
	    return deferred.promise;
	}
	checkLoggedOut.$inject = ['$q', '$timeout', '$http', '$location', '$window', 'Global', '$state'];
	
	// var bugsnag = JSON.parse(window.bugsnag);
	// setting up route
	function ctrl($stateProvider, $urlRouterProvider) {
	    // For unmatched routes:
	    $urlRouterProvider.otherwise('/live');
	    // states for my app
	    $stateProvider.state('auth', {
	        template: __webpack_require__(442),
	        resolve: {
	            loggedout: checkLoggedOut
	        }
	    }).state('changelog', {
	        template: __webpack_require__(443)
	    }).state('landing', {
	        template: __webpack_require__(444),
	        controller: 'mainPageController',
	        controllerAs: 'main',
	        resolve: {
	            loggedin: checkLoggedIn
	        }
	    }).state('pages', {
	        template: __webpack_require__(445),
	        controller: 'mainPageController',
	        controllerAs: 'main',
	        resolve: {
	            loggedin: checkLoggedIn
	        }
	    });
	}
	
	ctrl.$inject = ['$stateProvider', '$urlRouterProvider'];
	module.exports = ctrl;
	
	// angular.module('rp.system').config(['bugsnagProvider',
	//     function (bugsnagProvider) {
	//         if (bugsnag.enabled) {
	//             bugsnagProvider
	//                 .apiKey(bugsnag.api)
	//                 .releaseStage(bugsnag.env)
	//                 .appVersion(JSON.parse(window.version).l3);
	//         }
	// }])

/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = "<section class=\"login login-page\">\n    <div ui-view></div>\n</section>";

/***/ },
/* 443 */
/***/ function(module, exports) {

	module.exports = "<section class=\"changelog changelog-page\">\n    <div ui-view></div>\n</section>";

/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = "<div class=\"page-header-fixed\">\n    <div class=\"header navbar navbar-inverse navbar-fixed-top\" ui-view=\"header\" data-role=\"navigation\"></div>\n    <div class=\"dashboard-container\">\n        <div ui-view></div>\n    </div>\n    <!-- <div class='footer'>\n        <div class='footer-inner'>\n            <section copyright id=\"support-button\"></section> | <a ng-href=\"/changelog\" style=\"color:#999999\"> Change Log </a>\n        </div>\n    </div> -->\n</div>";

/***/ },
/* 445 */
/***/ function(module, exports) {

	module.exports = "<div class=\"page-header-fixed\">\n    <div class=\"header navbar navbar-inverse navbar-fixed-top\" ui-view=\"header\" data-role=\"navigation\"></div>\n    <div class=\"page-container\">\n        <!-- SIDEBAR -->\n        <div class=\"page-sidebar nav-collapse collapse\">\n            <div ui-view=\"sidebar\"></div>\n        </div>\n        <div ui-view></div>\n    </div>\n\n    <div class='footer'>\n        <div class='footer-inner'>\n            <section copyright id=\"support-button\"></section>\n            <!--| <a ng-href=\"/changelog\" style=\"color:#999999\"> Change Log </a>-->\n        </div>\n    </div>\n</div>";

/***/ },
/* 446 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($locationProvider) {
	    $locationProvider.html5Mode({
	        enabled: true,
	        requireBase: false
	    }); // new url config (no #! prepended)
	}
	
	ctrl.$inject = ['$locationProvider'];
	module.exports = ctrl;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // services
	    __webpack_require__(448)(ngModule);
	    // routes
	    ngModule.config(__webpack_require__(566));
	    // controllers
	    __webpack_require__(669)(ngModule);
	    // filters
	    __webpack_require__(787)(ngModule);
	    // directives
	    __webpack_require__(792)(ngModule);
	};

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // time object
	
	    // id generator
	    ngModule.service('generateId', __webpack_require__(449));
	
	    // data fetcher
	    ngModule.service('getData', __webpack_require__(450));
	    ngModule.service('settings', __webpack_require__(451));
	    ngModule.service('fetchData', __webpack_require__(452));
	    ngModule.service('fetchStream', __webpack_require__(453));
	
	    // lane row symbol generator
	    ngModule.factory('laneRowSymbols', __webpack_require__(454));
	    ngModule.factory('dictionary', __webpack_require__(455));
	    ngModule.factory('getSize', __webpack_require__(456));
	    ngModule.factory('timeFormat', __webpack_require__(458));
	    ngModule.config(__webpack_require__(565));
	};

/***/ },
/* 449 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
	    return function () {
	        function makeid() {
	            var text = "";
	            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	            for (var i = 0; i < 5; i++) {
	                text += possible.charAt(Math.floor(Math.random() * possible.length));
	            }
	            return text;
	        }
	        return makeid();
	    };
	};

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function service($q, $location, $resource) {
	    return function (params, time, body) {
	        var deferred = $q.defer();
	        function excludeTime(obj, doIt) {
	            var newObj = {};
	            if (doIt) {
	                for (var i in obj) {
	                    if (i != 'start' && i != 'end') {
	                        newObj[i] = obj[i];
	                    }
	                }
	                return newObj;
	            } else {
	                return obj;
	            }
	        }
	        // TODO - ADD viz.GETparams to time if exists
	        var Rest,
	            timeParam = {},
	            searchParams = {};
	        if (time) {
	            timeParam = time;
	        }
	
	        // remove start and end from location if time param exists (and if time is already defined) - i.e. requery
	        if (time && typeof $location.$$search.start !== 'undefined' && typeof $location.$$search.end !== 'undefined') {
	            searchParams = angular.copy(excludeTime($location.$$search, true));
	        } else {
	            searchParams = angular.copy(excludeTime($location.$$search, false));
	        }
	        if (body) {
	            for (var p in body) {
	                searchParams[p] = body[p];
	            }
	        }
	        if (params.key) {
	            // if the result is a piece of an object..
	            Rest = $resource(("https://api-demo.mantix4.com") + params.get, timeParam, {
	                query: { method: 'GET', params: searchParams, isArray: false }
	            });
	            Rest.query(function (data) {
	                return deferred.resolve(data[params.key]);
	            });
	        }
	        // else if (params.sql) {
	        //     //if the result is an array
	        //     Rest = $resource(params.get, timeParam, {
	        //         query: { method: 'GET', params: searchParams, isArray: true }
	        //     });
	        //     Rest.query(function (data) {
	        //         return deferred.resolve(data);
	        //     })
	        // }
	        else {
	                // if the result is an array
	                Rest = $resource(("https://api-demo.mantix4.com") + params.get, timeParam, {
	                    query: { method: 'GET', params: searchParams, isArray: true }
	                });
	                Rest.query(function (data) {
	                    return deferred.resolve(data);
	                });
	            }
	        return deferred.promise;
	    };
	}
	
	service.$inject = ['$q', '$location', '$resource'];
	module.exports = service;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function service($q, Global, $state, $http) {
	    var _this = this;
	    // get settings for specific key
	    // USAGE: VARIABLE = settings.get(KEY);
	    _this.get = function (key) {
	        var controller = $state.current.controller;
	        // if controller exists in the settings
	        if (Global.user.settings_local.hasOwnProperty(controller)) {
	            // if the settings key exists in the controller
	            if (Global.user.settings_local[controller].hasOwnProperty(key)) {
	                // send back the value of the key
	                return Global.user.settings_local[controller][key];
	            } else {
	                return false;
	            }
	        } else {
	            return false;
	        }
	    };
	    // set settings for specific key
	    // USAGE: settings.set(KEY, VALUE).then(function () { DO SOMETHING });
	    // NOTE: set VALUE to false (boolean) if removing a value - the server will take care of removing the setting obj's values
	    _this.set = function (key, value) {
	        var deferred = $q.defer();
	        function run(k, v, callback) {
	            // grab the controller name from the state object
	            var controller = $state.current.controller;
	            // make post to server side to do the work
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/users/settingslocal',
	                data: {
	                    key: key,
	                    value: value,
	                    controller: controller
	                }
	            }).success(function (settings) {
	                Global.user.settings_local = settings;
	                return callback(true);
	            });
	        }
	        run(key, value, function () {
	            deferred.resolve();
	        });
	        return deferred.promise;
	    };
	    return _this;
	}
	
	service.$inject = ['$q', 'Global', '$state', '$http'];
	module.exports = service;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function service($http, $q, $location) {
	    return function (url) {
	        var defer = $q.defer();
	        var config = {};
	        config.params = $location.$$search;
	        $http.get(("https://api-demo.mantix4.com") + url, config).then(function (result) {
	            if (typeof result.data.rows !== "undefined") {
	                defer.resolve(result.data.rows);
	            } else {
	                defer.resolve(result.data);
	            }
	        }, function (err) {
	            defer.reject(err);
	        });
	        return defer.promise;
	    };
	}
	
	service.$inject = ['$http', '$q', '$location'];
	module.exports = service;

/***/ },
/* 453 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function service($http, $q, $location, $window) {
	    return function (command, socket, params, time) {
	        var model = this;
	        model.socket = socket;
	        model.command = command;
	        model.p = angular.copy($location.$$search); // we dont want to overwrite the existing $location
	        // add params if they are presented
	        if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) === 'object') {
	            for (var i in params) {
	                model.p[i] = params[i];
	            }
	        }
	        // if time
	        if ((typeof time === 'undefined' ? 'undefined' : _typeof(time)) === 'object') {
	            model.p.start = time.start;
	            model.p.end = time.end;
	        }
	        if (typeof model.p.type !== 'undefined') {
	            model.type = model.p.type;
	        }
	        if (typeof model.p.reqId !== 'undefined') {
	            model.reqId = model.p.reqId;
	        }
	        model.defer = $q.defer();
	        model.socket.emit(model.command, model.p);
	        model.socket.on(model.command, function (data) {
	            if (typeof data.reqId !== 'undefined' && typeof model.reqId !== 'undefined') {
	                if (model.reqId !== data.reqId) {
	                    return;
	                }
	            }
	            if (data === 'done') {
	                model.socket.removeListener(model.command);
	                if (typeof model.type !== 'undefined') {
	                    model.defer.resolve(model.type);
	                } else {
	                    model.defer.resolve();
	                }
	                delete model.defer;
	                return;
	            }
	            // else if (data.error === 'error') {
	            //     model.socket.removeListener(model.command);
	            //     if (data.code === 4608) {
	            //         model.defer.reject(); // if a timeout error
	            //     } else {
	            //         model.defer.resolve();
	            //     }
	            //     delete model.defer;
	            //     return;
	            // }
	            else {
	                    model.defer.notify(data);
	                }
	        });
	        return model.defer.promise;
	    };
	}
	
	service.$inject = ['$http', '$q', '$location', '$window'];
	module.exports = service;

/***/ },
/* 454 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
	    var laneRowSymbols = function laneRowSymbols(type, element, color1, color2) {
	        switch (type) {
	            case 'Conn':
	                element.append('svg:polygon').attr('points', '24.585,6.299 24.585,9.064 11.195,9.064 11.195,14.221 24.585,14.221 24.585,16.986 31.658,11.643 ').attr('fill', color1);
	                element.append('svg:polygon').attr('points', '10.99,17.822 3.916,23.166 10.99,28.51 10.99,25.744 24.287,25.744 24.287,20.59 10.99,20.59 ').attr('fill', color1);
	                return;
	            case 'IOC Severity':
	                element.append('svg:polygon').attr('transform', 'translate(0, 3)').attr('points', '18.155,3.067 5.133,26.932 31.178,26.932 ').attr('fill', color1);
	                element.append('svg:polygon').attr('transform', 'translate(0, 3)').attr('points', '19.037,21.038 19.626,12.029 15.888,12.029 16.477,21.038 ').attr('fill', color2);
	                element.append('rect').attr('transform', 'translate(0, 3)').attr('x', 16.376).attr('y', 22.045).attr('fill', color2).attr('width', 2.838).attr('height', 2.448);
	                return;
	            case 'DNS':
	                element.append('svg:path').attr('d', 'M20.909,13.115c0-0.07,0-0.106-0.071-0.106c-0.283,0-6.022,0.813-7.935,0.956' + 'c-0.036,0.955-0.071,2.053-0.071,3.009l2.267,0.106v8.707c0,0.071-0.035,0.143-0.142,0.178l-1.877,0.07' + 'c-0.035,0.92-0.035,1.982-0.035,2.938c1.452,0,3.33-0.036,4.818-0.036h4.888V26l-1.949-0.07' + 'C20.801,22.39,20.874,16.938,20.909,13.115z').attr('fill', color1);
	                element.append('svg:path').attr('d', 'M17.473,10.921c1.771,0,3.329-1.274,3.329-3.187c0-1.486-1.098-2.867-3.152-2.867' + 'c-1.948,0-3.259,1.451-3.259,2.938C14.391,9.611,15.949,10.921,17.473,10.921z').attr('fill', color1);
	                return;
	            case 'HTTP':
	                element.append('circle').style('fill', color1).attr('cx', 18).attr('cy', 18).attr('r', 14);
	                element.append('svg:path').attr('d', 'M24.715,19.976l-2.057-1.122l-1.384-0.479l-1.051,0.857l-1.613-0.857l0.076-0.867l-1.062-0.325l0.31-1.146' + 'l-1.692,0.593l-0.724-1.616l0.896-1.049l1.108,0.082l0.918-0.511l0.806,1.629l0.447,0.087l-0.326-1.965l0.855-0.556l0.496-1.458' + 'l1.395-1.011l1.412-0.155l-0.729-0.7L22.06,9.039l1.984-0.283l0.727-0.568L22.871,6.41l-0.912,0.226L21.63,6.109l-1.406-0.352' + 'l-0.406,0.596l0.436,0.957l-0.485,1.201L18.636,7.33l-2.203-0.934l1.97-1.563L17.16,3.705l-2.325,0.627L8.91,3.678L6.39,6.285' + 'l2.064,1.242l1.479,1.567l0.307,2.399l1.009,1.316l1.694,2.576l0.223,0.177l-0.69-1.864l1.58,2.279l0.869,1.03' + 'c0,0,1.737,0.646,1.767,0.569c0.027-0.07,1.964,1.598,1.964,1.598l1.084,0.52L19.456,21.1l-0.307,1.775l1.17,1.996l0.997,1.242' + 'l-0.151,2.002L20.294,32.5l0.025,2.111l1.312-0.626c0,0,2.245-3.793,2.368-3.554c0.122,0.238,2.129-2.76,2.129-2.76l1.666-1.26' + 'l0.959-3.195l-2.882-1.775L24.715,19.976z').attr('fill', '#3f3f3f').attr('transform', 'translate(4,4) scale(0.75)');
	                return;
	            case 'SSL':
	                element.append('svg:path').attr('fill', color1).attr('d', 'M25.5,16.1v-2.7h0c0,0,0,0,0,0c0-4.1-3.3-7.4-7.4-7.4c-4.1,0-7.4,3.3-7.4,7.4c0,0,0,0,0,0v2.7H9.3' + 'v11.8h17.8V16.1H25.5z M22.9,13.7v2.4h-9.4v-2.4c0,0,0,0,0,0c0-2.6,1.5-5,4.7-5C21.3,8.8,22.9,11.1,22.9,13.7' + 'C22.9,13.7,22.9,13.7,22.9,13.7z');
	                return;
	            case 'Endpoint':
	                element.append('svg:path').attr('d', 'M28.649,8.6H7.351c-0.684,0-1.238,0.554-1.238,1.238v14.363c0,0.684,0.554,1.238,1.238,1.238h7.529' + 'l-1.09,3.468v0.495h8.419v-0.495l-1.09-3.468h7.529c0.684,0,1.237-0.555,1.237-1.238V9.838C29.887,9.153,29.333,8.6,28.649,8.6z' + 'M28.477,22.072H7.635V10.074h20.842V22.072z').attr('fill', color1);
	                return;
	            case 'Stealth':
	                element.append('path').attr('fill', color1).attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828' + 'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439' + 'C28.014,15.545,26.676,21.468,23.587,26.751z');
	                element.append('svg:path').attr('fill', color2).attr('d', 'M13.699,23.661c1.801,3.481,2.743,4.875,4.457,4.875l0.011-19.85c0,0-2.988,2.794-7.09,3.251' + 'C11.076,16.238,11.938,20.26,13.699,23.661z');
	                return;
	            case 'Stealth_drop':
	                element.append('svg:path').attr('fill', color1).attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828' + 'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439' + 'C28.014,15.545,26.676,21.468,23.587,26.751z');
	                element.append('svg:path').attr('fill', color2).attr('d', 'M13.699,23.661c1.801,3.481,2.743,4.875,4.457,4.875l0.011-19.85c0,0-2.988,2.794-7.09,3.251' + 'C11.076,16.238,11.938,20.26,13.699,23.661z');
	                return;
	            case 'Email':
	                element.append('polygon').style('fill', color1).attr('points', '18,17.3 8.7,11.6 27.3,11.6 ');
	                element.append('polygon').style('fill', color1).attr('points', '28.4,24.4 7.6,24.4 7.6,13.1 18,19.7 28.4,13.1 ');
	                return;
	            case 'File':
	                element.append('svg:path').attr('d', 'M13.702,12.807h13.189c-0.436-0.655-1.223-1.104-2.066-1.104c0,0-7.713,0-8.361,0' + 'c-0.386-0.796-1.278-1.361-2.216-1.361H7.562c-1.625,0-1.968,0.938-1.839,2.025l2.104,11.42c0.146,0.797,0.791,1.461,1.594,1.735' + 'c0,0,2.237-10.702,2.378-11.308C12.005,13.334,12.403,12.807,13.702,12.807z').attr('fill', color1);
	                element.append('svg:path').attr('d', 'M29.697,13.898c0,0-14.47-0.037-14.68-0.037c-1.021,0-1.435,0.647-1.562,1.289l-2.414,10.508h16.716' + 'c1.146,0,2.19-0.821,2.383-1.871l1.399-7.859C31.778,14.706,31.227,13.848,29.697,13.898z').attr('fill', color1);
	                return;
	            case 'Applications':
	                element.append('rect').attr('x', 10).attr('y', 10).attr('height', 4).attr('width', 17).style('fill', color1);
	                element.append('rect').attr('x', 10).attr('y', 16).attr('height', 4).attr('width', 17).style('fill', color1);
	                element.append('rect').attr('x', 10).attr('y', 22).attr('height', 4).attr('width', 17).style('fill', color1);
	                return;
	            case 'Active Defense':
	                element.append('svg:path').attr('transform', 'translate(9,6)').attr('d', 'M9,0L0,4v6c0,5.4,3.6,10,8.5,11.5C13.4,20,17,15.4,17,10V4L9,0z M3.8,10h4L3.2,5.1h5.6l4,5.9h-3l4,6L3.8,10z').attr('fill', color1);
	                return;
	            default:
	                return;
	        }
	    };
	    return laneRowSymbols;
	};

/***/ },
/* 455 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
	    var dictionary = function dictionary(word) {
	        switch (word) {
	            case 'zone':
	                return 'Zone';
	            case 'local_user':
	                return 'Local User';
	            case 'local_ip':
	                return 'Local IP';
	            case 'remote_user':
	                return 'Remote User';
	            case 'remote_ip':
	                return 'Remote IP';
	            case 'type':
	                return 'Type';
	            default:
	                return word;
	        }
	    };
	    return dictionary;
	};

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	module.exports = function () {
	    var getSize = function getSize(element, type, width) {
	        var selection = $(element).closest('div:regex(class, span\d*)'); //select span
	        var module = d3.select(selection[0]);
	        var span = module.attr('class');
	        if (module.attr('default-height') === 'true') {
	            span = null;
	        }
	        var width = selection.width();
	        var height = 0; // 0 so it doesn't break incase there's no match (it just won't show)
	        // i'm putting the differen't visuals' switches in functions so having switches within switches doesn't get confusing
	        function pieChart(width) {
	            switch (span) {
	                case 'span5':
	                    return width / 2.3;
	                case 'span4':
	                    return width / 1.65;
	                // case 'span6':
	                //     return width/2.4
	                default:
	                    return width / 2.3; // anything that would be appropriate as a default here
	            }
	        }
	        function barChart(width) {
	            switch (span) {
	                case 'span7':
	                    return width / 3;
	                case 'span8':
	                    return width / 11;
	                case 'span12':
	                    return width / 10;
	                default:
	                    return width / 4; // anything that would be appropriate as a default here
	            }
	        }
	        function linechart(width) {
	            switch (span) {
	                case 'span12':
	                    return width / 10.5;
	                case 'span11':
	                    return width / 8.5;
	                case 'span8':
	                    return width / 7;
	                case 'span7':
	                    return width / 3.3;
	                case 'span6':
	                    return width / 3;
	                case 'span10':
	                    return width / 6;
	                default:
	                    return width / 4; // anything that would be appropriate as a default here
	            }
	        }
	        function curvegraph(width) {
	            switch (span) {
	                case 'span12':
	                    return width / 10.5;
	                case 'span11':
	                    return width / 8.5;
	                case 'span8':
	                    return width / 12;
	                case 'span7':
	                    return width / 3.3;
	                case 'span6':
	                    return width / 3;
	                case 'span10':
	                    return width / 6;
	                default:
	                    return width / 4; // anything that would be appropriate as a default here
	            }
	        }
	        function geoChart(width) {
	            switch (span) {
	                case 'span5':
	                    return width / 2;
	                default:
	                    return width / 2; // anything that would be appropriate as a default here
	            }
	        }
	        switch (type) {
	            case 'pieChart':
	                return {
	                    width: width,
	                    height: pieChart(width)
	                };
	                break;
	            case 'barChart':
	                return {
	                    width: width,
	                    height: barChart(width)
	                };
	                break;
	            case 'linechart':
	                return {
	                    width: width,
	                    height: linechart(width)
	                };
	                break;
	            case 'curvegraph':
	                return {
	                    width: width,
	                    height: curvegraph(width)
	                };
	                break;
	            case 'rowChart':
	                return {
	                    width: width
	                };
	                break;
	            case 'geoChart':
	                return {
	                    width: width,
	                    height: geoChart(width)
	                };
	                break;
	            default:
	                return {
	                    height: height,
	                    width: width
	                };
	        }
	    };
	    return getSize;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 457 */,
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _moment = __webpack_require__(459);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function () {
	    var timeFormat = function timeFormat(time, format) {
	        switch (format) {
	            case 'strdDateObj':
	                return new Date(time * 1000);
	                break;
	            case 'chartHover':
	                return (0, _moment2.default)(time).format('YYYY/MM/DD HH:mm');
	                break;
	            case 'table':
	            case 'tables':
	                return _moment2.default.unix(time).format('YYYY/MM/DD HH:mm:ss');
	                break;
	            case 'tableMinMax':
	            case 'tablesMinMax':
	                return _moment2.default.unix(time).format('MMMM D, YYYY h:mm A');
	                break;
	            case 'first_seen':
	                if ((0, _moment2.default)(new Date()).unix() - time < 86400) {
	                    return "New";
	                }
	                return Math.round(((0, _moment2.default)(new Date()).unix() - time) / 86400) + " Days ago";
	                break;
	            case 'timeSlider':
	                return (0, _moment2.default)(time * 1000).format('YYYY/MM/DD HH:mm:ss');
	                break;
	            case 'laneGraphExpanded':
	                return (0, _moment2.default)(time * 1000).format('YYYY/MM/DD HH:mm:ss.SS');
	                break;
	            case 'laneGraphPreview':
	                return (0, _moment2.default)(time * 1000).format('YYYY/MM/DD HH:mm:ss.SS');
	                break;
	            case 'iochits':
	                return (0, _moment2.default)(time * 1000).format('YYYY-MM-DD HH:mm:ss');
	                break;
	            default:
	                return _moment2.default.unix(time).format('YYYY/MM/DD HH:mm:ss');
	                break;
	        }
	    };
	    return timeFormat;
	};

/***/ },
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */
/***/ function(module, exports) {

	'use strict';
	
	function config(usSpinnerConfigProvider) {
	    usSpinnerConfigProvider.setTheme('table', {
	        lines: 13 // number of lines to draw
	        , length: 4 // length of each line
	        , width: 2 // line thickness
	        , radius: 4 // radius of the inner circle
	    });
	
	    usSpinnerConfigProvider.setTheme('general', {
	        lines: 13 // number of lines to draw
	        , length: 9 // length of each line
	        , width: 5 // line thickness
	        , radius: 13 // radius of the inner circle
	        , scale: 1 // scales overall size of the spinner
	        , corners: 1 // corner roundness (0..1)
	    });
	}
	
	config.$inject = ['usSpinnerConfigProvider'];
	module.exports = config;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function config($stateProvider) {
	    // set default parent states
	    $stateProvider.state('pages.main', {
	        views: {
	            "": {
	                template: __webpack_require__(567),
	                controllerAs: 'page'
	            },
	            "header": {
	                template: __webpack_require__(568),
	                controller: 'HeaderController',
	                controllerAs: 'header'
	            },
	            "sidebar": {
	                template: __webpack_require__(571),
	                controller: 'sidebarController',
	                controllerAs: 'sidebar'
	            }
	        }
	    });
	    // add individual page groups
	    __webpack_require__(573)($stateProvider);
	    __webpack_require__(580)($stateProvider);
	    __webpack_require__(600)($stateProvider);
	    __webpack_require__(602)($stateProvider);
	    __webpack_require__(606)($stateProvider);
	    __webpack_require__(608)($stateProvider);
	    __webpack_require__(621)($stateProvider);
	    __webpack_require__(631)($stateProvider);
	    __webpack_require__(633)($stateProvider);
	    __webpack_require__(640)($stateProvider);
	    __webpack_require__(647)($stateProvider);
	    __webpack_require__(649)($stateProvider);
	    //require('./hybrid_alerts')($stateProvider);
	}
	
	config.$inject = ['$stateProvider'];
	module.exports = config;

/***/ },
/* 567 */
/***/ function(module, exports) {

	module.exports = "<div class=\"page-content\">\n    <div class=\"container-fluidmap\">\n    <alert-message></alert-message>\n        <div ui-view></div>\n    </div>\n</div>";

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"navbar-inner\">\n    <div style=\"background-color: #232323;\" class=\"container-fluid\">\n        <a ng-click=\"go('/')\" href=\"\">\n            <img class=\"logo\" src=\"" + __webpack_require__(569) + "\" alt=\"\"/>\n        </a>\n       <!--  <a href=\"javascript:;\" class=\"btn-navbar collapsed\" data-toggle=\"collapse\" data-target=\".nav-collapse\">\n            <img src=\"" + __webpack_require__(570) + "\" alt=\"\"/>\n        </a> -->\n        <ul class=\"nav\">\n            <li><searchbar /></li>\n            <li dropdown>\n                <a dropdown-toggle href=\"#\" id=\"welcome\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">Welcome, {{global.user.email}} <b class=\"caret\"></b></a>\n                <ul class=\"dropdown-menu\">\n                    <li><a href=\"\" ng-click=\"openSettingsModal()\"><i class=\"fa fa-cog\"></i> My Preferences</a></li>\n                    <li ng-show=\"global.user.user_level === 'superadmin' || global.user.user_level === 'admin'\"><a href=\"#\" ng-click=\"go('/manage_users')\"><i class=\"fa fa-user\"></i> User Management</a></li>\n                    <li ng-if=\"global.user.user_level === 'superadmin'\"><a href=\"#\" ng-click=\"go('/manage_feeds')\"><i class=\"fa fa-rss\"></i> Feed Management</a></li>\n                    <li><a href=\"#\" ng-click=\"logout()\"><i class=\"fa fa-power-off\"></i> Logout</a></li>\n                </ul>\n            </li>\n            <span style=\"margin-left: 1rem; margin-right: 1rem\"><a href=\"/dashboard\" style=\"color: #fff\">Dashboard</a></span>\n             <div class=\"clientToggle\" dropdown>\n                <span><a dropdown-toggle href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">{{global.user.settings_global.current.client}}<b class=\"caret\"></b></a> {{global.user.settings_global.current.name}} </span>\n                <ul class=\"dropdown-menu\">\n                    <li ng-repeat=\"(client, info) in global.user.access\" ng-click=\"header.changeClient(client)\" ng-class=\"(global.user.settings_global.current.client == client) ? 'clientActive' : ''\"><a>{{client}}</a></li>\n                </ul>\n            </div>\n        </ul>\n    </div>\n</div>\n";

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "72a1572aa79543efeffed14e49bdfdef.png";

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c22d2f5d63ba4b75d219e8152419381.png";

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<ul class=\"page-sidebar-menu\" sidebar>\n    <li> <!-- SIDEBAR TOGGLER BUTTON -->\n        <div class=\"sidebar-toggler\"></div>\n    </li>\n    <li data-ng-repeat=\"parent in sideBarItems\" class=\"heading\" ng-show=\"display(parent)\" ng-class=\"nodeClass(parent)\" >\n        <a ng-click=\"select(parent.url)\" href=\"\">\n            <section ng-switch=\"::parent.title\">\n                <section ng-switch-when=\"Stealth\">\n                    <i class=\"fa {{::parent.icon}}\"></i>\n                    <span class=\"title\">\n                        <img ng-src=\"{{stealthLogo(parent)}}\"/>\n                    </span>\n                </section>\n                <section ng-switch-default>\n                    <i ng-if=\"(parent.iconreplace == true)\" name=\"{{::parent.icon}}\" sidebar-icon></i>\n                    <i ng-if=\"!(parent.iconreplace)\" class=\"fa {{::parent.icon}}\"></i>\n                    <span class=\"title\">{{::parent.title}}</span>\n                </section>\n            </section>\n            <span ng-class=\"parentClassSelected(parent.url)\" id=\"heading_sub\"></span>\n        </a>\n        <ul ng-show=\"parent.children.length > 0\" class=\"sub-menu\">\n            <li data-ng-repeat=\"child in parent.children\" ng-show=\"display(child)\" ng-class=\"nodeClass(child, true)\">\n                <a ng-click=\"select(child.url)\">\n                    <i ng-if=\"(child.iconreplace == true)\" name=\"{{::child.icon}}\" sidebar-icon></i>\n                    <i ng-if=\"!(child.iconreplace)\" class=\"fa {{::child.icon}}\"></i>\n                    {{child.title}}\n                </a>\n                <ul ng-show=\"child.children.length > 0\" class=\"sub-menu\">\n                    <li data-ng-repeat=\"grandchild in child.children\" ng-show=\"display(grandchild)\" ng-class=\"nodeClass(grandchild, true)\">\n                        <a ng-click=\"select(grandchild.url)\">\n                            <i ng-if=\"(grandchild.iconreplace == true)\" name=\"{{::grandchild.icon}}\" sidebar-icon></i>\n                            <i ng-if=\"!(grandchild.iconreplace)\" class=\"fa {{::grandchild.icon}}\"></i>\n                            {{grandchild.title}}\n                        </a>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n    </li>\n</ul>\n<div class=\"support-button\" class='hidden-phone hidden-tablet' ng-click=\"openSupportModal()\">\n    <span class=\"support-text\">SUPPORT <img src='" + __webpack_require__(572) + "' alt=''/></span>\n</div>";

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4571f16fd4ef762c2ec79d272a3e27a9.png";

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // NEW LOCAL IPS
	    .state('pages.main.new_remote', {
	        url: '/new_remote',
	        template: __webpack_require__(574),
	        controller: 'newRemoteController',
	        controllerAs: 'page',
	        data: {
	            title: 'New Remote IP Addresses Detected',
	            daterange: true
	        }
	    })
	    // // NEW LOCAL IPS
	    //     .state('pages.main.new_local_ip', {
	    //         url: '/new_local_ip',
	    //         template: require('../views/anomalies/new_local_ip.html'),
	    //         controller: 'newLocalIpController',
	    //         controllerAs: 'page',
	    //         data: {
	    //             title: 'New Local IPs Seen',
	    //             daterange: true
	    //         }
	    //     })
	    // // NEW LOCAL MAC
	    //     .state('pages.main.new_local_mac', {
	    //         url: '/new_local_mac',
	    //         template: require('../views/anomalies/new_local_mac.html'),
	    //         controller: 'newLocalMacController',
	    //         controllerAs: 'page',
	    //         data: {
	    //             title: 'New Local MAC Addresses Seen',
	    //             daterange: true
	    //         }
	    //     })
	    // NEW DNS QUERIES
	    .state('pages.main.new_dns_queries', {
	        url: '/new_dns_queries',
	        template: __webpack_require__(575),
	        controller: 'newDnsQueriesController',
	        controllerAs: 'page',
	        data: {
	            title: 'New DNS Queries Detected',
	            daterange: true
	        }
	    })
	    // NEW HTTP HOSTS
	    .state('pages.main.new_http_domains', {
	        url: '/new_http_domains',
	        template: __webpack_require__(576),
	        controller: 'newHttpDomainsController',
	        controllerAs: 'page',
	        data: {
	            title: 'New HTTP Domains Detected',
	            daterange: true
	        }
	    })
	    // NEW SSL HOSTS
	    .state('pages.main.new_ssl_hosts', {
	        url: '/new_ssl_hosts',
	        template: __webpack_require__(577),
	        controller: 'newSslHostsController',
	        controllerAs: 'page',
	        data: {
	            title: 'New SSL Server Names Detected',
	            daterange: true
	        }
	    })
	    // NEW SSH REMOTE IPS
	    .state('pages.main.new_ssh_remote', {
	        url: '/new_ssh_remote',
	        template: __webpack_require__(578),
	        controller: 'newSshRemoteController',
	        controllerAs: 'page',
	        data: {
	            title: 'New Responder SSH Server/Client Detected',
	            daterange: true
	        }
	    })
	    // NEW FTP REMOTE IPS
	    .state('pages.main.new_ftp_remote', {
	        url: '/new_ftp_remote',
	        template: __webpack_require__(579),
	        controller: 'newFtpRemoteController',
	        controllerAs: 'page',
	        data: {
	            title: 'New Responder FTP Server/Client Detected',
	            daterange: true
	        }
	    });
	};

/***/ },
/* 574 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\"># of New Remote IPs / Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Remote IP Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 575 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\"># of New DNS Queries / Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">DNS Resolver Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 576 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\"># of New HTTP Domains / Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">HTTP Server Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 577 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\"># of New SSL / Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">SSL Server Names Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 578 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7 \">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\"># of New SSH / Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">SSH Server/Client Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 579 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\"># of New FTPs / Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">FTP Server/Client Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // L7 APP
	    // BY LAYER 7 APP
	    .state('pages.main.app_by_l7', {
	        url: '/app_by_l7',
	        template: __webpack_require__(581),
	        controller: 'appByl7Controller',
	        controllerAs: 'page',
	        data: {
	            title: 'Layer 7 Applications',
	            daterange: true
	        }
	    })
	    // BY LAYER 7 APP RESPONDER
	    .state('pages.main.app_by_l7_resp', {
	        url: '/app_by_l7_resp',
	        template: __webpack_require__(582),
	        controller: 'appByl7RespController',
	        controllerAs: 'page',
	        data: {
	            title: 'Layer 7 Applications By Responder',
	            daterange: true
	        }
	    })
	    // BY LAYER 7 APP RESPONDER ORIGIN
	    .state('pages.main.app_by_l7_resp_orig', {
	        url: '/app_by_l7_resp_orig',
	        template: __webpack_require__(583),
	        controller: 'appByl7RespOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Layer 7 Applications By Responder to Origin',
	            daterange: true
	        }
	    })
	    // DNS
	    // DNS BY QUERY TYPE
	    .state('pages.main.dns_by_type', {
	        url: '/dns_by_type',
	        template: __webpack_require__(584),
	        controller: 'dnsByTypeController',
	        controllerAs: 'page',
	        data: {
	            title: 'DNS by Query Type',
	            daterange: true
	        }
	    })
	    // DNS BY QUERY TYPE RESP
	    .state('pages.main.dns_by_type_resp', {
	        url: '/dns_by_type_resp',
	        template: __webpack_require__(585),
	        controller: 'dnsByTypeRespController',
	        controllerAs: 'page',
	        data: {
	            title: 'Responder DNS by Query Type',
	            subtitleElm: {
	                'Query Type': 'qtype_name'
	            },
	            daterange: true
	        }
	    })
	    // DNS BY QUERY TYPE RESP & ORIG
	    .state('pages.main.dns_by_type_resp_orig', {
	        url: '/dns_by_type_resp_orig',
	        template: __webpack_require__(586),
	        controller: 'dnsByTypeRespOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Responder / Origin DNS by Query Type',
	            subtitleElm: {
	                'Query Type': 'qtype_name'
	            },
	            daterange: true
	        }
	    })
	    // DNS BY RESOLVER
	    .state('pages.main.dns_by_resolver', {
	        url: '/dns_by_resolver',
	        template: __webpack_require__(587),
	        controller: 'dnsByResolverController',
	        controllerAs: 'page',
	        data: {
	            title: 'DNS by Resolver',
	            daterange: true
	        }
	    })
	    // DNS BY RESOLVER TYPE
	    .state('pages.main.dns_by_resolver_type', {
	        url: '/dns_by_resolver_type',
	        template: __webpack_require__(588),
	        controller: 'dnsByResolverTypeController',
	        controllerAs: 'page',
	        data: {
	            title: 'DNS by Resolver & Query Type',
	            daterange: true
	        }
	    })
	    // HTTP
	    // HTTP BY DOMAIN
	    .state('pages.main.http_by_domain', {
	        url: '/http_by_domain',
	        template: __webpack_require__(589),
	        controller: 'httpByDomainController',
	        controllerAs: 'page',
	        data: {
	            title: 'HTTP By Domain',
	            daterange: true
	        }
	    })
	    // HTTP BY SUBDOMAIN
	    .state('pages.main.http_by_domain_sub', {
	        url: '/http_by_domain_sub',
	        template: __webpack_require__(590),
	        controller: 'httpByDomainSubController',
	        controllerAs: 'page',
	        data: {
	            title: 'HTTP By Subdomain',
	            daterange: true
	        }
	    })
	    // HTTP BY URI
	    .state('pages.main.http_by_domain_uri', {
	        url: '/http_by_domain_uri',
	        template: __webpack_require__(591),
	        controller: 'httpByDomainUriController',
	        controllerAs: 'page',
	        data: {
	            title: 'HTTP By URI',
	            daterange: true
	        }
	    })
	    // SSL
	    // SSL BY SERVER
	    .state('pages.main.ssl_by_server', {
	        url: '/ssl_by_server',
	        template: __webpack_require__(592),
	        controller: 'sslByServerController',
	        controllerAs: 'page',
	        data: {
	            title: 'SSL Top Level Server Name',
	            daterange: true
	        }
	    })
	    // SSL BY SERVER
	    .state('pages.main.ssl_by_server_name', {
	        url: '/ssl_by_server_name',
	        template: __webpack_require__(593),
	        controller: 'sslByServerNameController',
	        controllerAs: 'page',
	        data: {
	            title: 'SSL Server Name',
	            daterange: true
	        }
	    })
	    // SSL BY SERVER
	    .state('pages.main.ssl_by_server_name_orig', {
	        url: '/ssl_by_server_name_orig',
	        template: __webpack_require__(594),
	        controller: 'sslByServerNameOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'SSL Server Name by Origin',
	            daterange: true
	        }
	    })
	    // FTP
	    // RESPONDER FTP
	    .state('pages.main.ftp_resp`', {
	        url: '/ftp_resp',
	        template: __webpack_require__(595),
	        controller: 'ftpRespController',
	        controllerAs: 'page',
	        data: {
	            title: 'FTP By Responder',
	            daterange: true
	        }
	    })
	    // RESPONDER ORIGIN FTP
	    .state('pages.main.ftp_resp_orig', {
	        url: '/ftp_resp_orig',
	        template: __webpack_require__(596),
	        controller: 'ftpRespOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'FTP By Responder to Origin',
	            daterange: true
	        }
	    })
	    // SSH
	    // SSH STATUS
	    .state('pages.main.ssh_status', {
	        url: '/ssh_status',
	        template: __webpack_require__(597),
	        controller: 'sshStatusController',
	        controllerAs: 'page',
	        data: {
	            title: 'SSH Status',
	            daterange: true
	        }
	    })
	    // SSH STATUS RESP
	    .state('pages.main.ssh_status_resp', {
	        url: '/ssh_status_resp',
	        template: __webpack_require__(598),
	        controller: 'sshStatusRespController',
	        controllerAs: 'page',
	        data: {
	            title: 'Responder SSH Status',
	            daterange: true
	        }
	    })
	    // SSH STATUS RESP ORIG
	    .state('pages.main.ssh_status_resp_orig', {
	        url: '/ssh_status_resp_orig',
	        template: __webpack_require__(599),
	        controller: 'sshStatusRespOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Responder / Origin SSH Status',
	            daterange: true
	        }
	    });
	};

/***/ },
/* 581 */
/***/ function(module, exports) {

	module.exports = "<div dc>\n    <section head></section>\n    <section id=\"loading-error\" loading-error></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Bandwidth {{(!page.settings.get('toggleVal')) ? 'B' : page.settings.get('toggleVal')}}</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\"># of Layer 7 Application Connections</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 582 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"tablesection\">\n        <div class=\"tablecontainer col-md-12 col-lg-11\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 583 */
582,
/* 584 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">DNS Queries</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Query Type Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n                <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n            </div>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 585 */
582,
/* 586 */
582,
/* 587 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">DNS Resolvers</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015 titleClick\"><span ng-click=\"page.toggleView(true)\" ng-class=\"{titleSelected: page.showHide}\">Locations</span> | <span ng-click=\"page.toggleView(false)\" ng-class=\"{titleSelected: !page.showHide}\">Distribution</span></div>\n            <div ng-show=\"!page.showHide\">\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n            </div>\n            <div ng-show=\"page.showHide\">\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n                <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n            </div>\n        </div>\n    </div>\n</section>";

/***/ },
/* 588 */
582,
/* 589 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">HTTP Connections</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">HTTP Domain Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 590 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">HTTP Connections</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">HTTP Subdomain Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 591 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"tablesection\">\n        <div class=\"tablecontainer col-md-12 col-lg-11\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 592 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">SSL Top Level Connections</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">SSL Top Level Server Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 593 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">SSL Connections</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">SSL Server Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 594 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">SSL Server Name by Origin Connections</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">SSL Server Name by Origin Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 595 */
582,
/* 596 */
582,
/* 597 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">SSH Connections</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">SSH Status Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 598 */
591,
/* 599 */
591,
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider.state('pages.main.archive', {
	        url: '/archive',
	        template: __webpack_require__(601),
	        controller: 'archiveController',
	        controllerAs: 'page',
	        data: {
	            title: 'Archive',
	            daterange: true
	        }
	    });
	};

/***/ },
/* 601 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <button class='pull-right pure-button' ng-show=\"archiveBtn\" type='button' ng-click=\"emptyarchive()\" value='' href=''>Empty Archive</button>\n    </div>\n    <br />\n    <div class=\"row-fluid\">\n        <div class=\"span4 spinnerParent\">\n            <div class=\"title2015\">Remote IP Locations</div>\n            <div style=\"background-color:#FFF;\" class=\"box\" id=\"getsize\">\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n            </div>\n        </div>\n        <div class=\"span8\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Archived IOC Notifications Per Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n    </div>\n    <br />\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // FILES
	    // BY MIME
	    .state('pages.main.files_by_mime', {
	        url: '/files_by_mime',
	        template: __webpack_require__(603),
	        controller: 'filesByMimeController',
	        controllerAs: 'page',
	        data: {
	            title: 'Files By MIME',
	            daterange: true
	        }
	    })
	    // BY MIME TYPE
	    .state('pages.main.files_by_mime_type', {
	        url: '/files_by_mime_type',
	        template: __webpack_require__(604),
	        controller: 'filesByMimeTypeController',
	        controllerAs: 'page',
	        data: {
	            title: 'Files By MIME Type',
	            daterange: true
	        }
	    })
	    // BY MIME TYPE
	    .state('pages.main.files_by_mime_type_filename', {
	        url: '/files_by_mime_type_filename',
	        template: __webpack_require__(605),
	        controller: 'filesByFileNameController',
	        controllerAs: 'page',
	        data: {
	            title: 'Files By File Name',
	            daterange: true
	        }
	    });
	};

/***/ },
/* 603 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Files By Mime Per Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Files Distribution by Mime</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 604 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Files By Mime Type Per Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Files Distribution by Mime Type</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 605 */
582,
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // FEED MANAGEMENT
	    .state('pages.main.manage_feeds', {
	        url: '/manage_feeds',
	        template: __webpack_require__(607),
	        controller: 'manageFeedController',
	        controllerAs: 'page',
	        data: {
	            title: 'Feed Management',
	            daterange: false
	        }
	    });
	};

/***/ },
/* 607 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"tabs\">\n      \n        <!--      <input type=\"radio\" id=\"tab1\" name=\"tab-control\" checked> -->\n      <input type=\"radio\" id=\"tab2\" name=\"tab-control\" checked>\n      <input type=\"radio\" id=\"tab3\" name=\"tab-control\">  \n      <ul>\n          <!--        <li ><label for=\"tab1\" id=\"lb1\" role=\"button\" ng-click=\"page.loadSensors()\"><br><span>Sensors</span></label></li> -->\n        <li ><label for=\"tab2\" id=\"lb2\" role=\"button\" ng-click=\"page.loadRegexs()\"><br><span>Feeds</span></label></li>\n        <li ><label for=\"tab3\" id=\"lb3\" role=\"button\"><br><span>Regexes</span></label></li>    \n    \n      </ul>\n      \n      <div class=\"slider\"><div class=\"indicator\"></div></div>\n      <div class=\"content\" style=\"border: 1px solid #929daf;border-top: 0;\">\n          <!-- The sensors section is currently disabled because we do not yet support this feature\n              (sduran)\n        <section >\n            <div class=\"row-fluid\">\n                <div class=\"tab\">\n                    <button name=\"sensorLink\" class=\"tablinks\" ng-repeat=\"sensor in page.sensors\" ng-click=\"page.openSensor($index,sensor.sensor_id)\">{{sensor.client}}</button>\n                </div>\n                <div class=\"tabcontent\" name=\"sensorContent\">\n                    <h1>Select one sensor</h1>\n                </div>\n                <div class=\"tabcontent\" name=\"sensorContent\" ng-repeat=\"sensor in page.sensors\" id=\"{{sensor.sensor_id}}\"style=\"display: none;\">\n                    <div class=\"col-md-3\">\n                        <div class=\"checkbox-container\">\n                            <input type=\"checkbox\" id=\"{{sensor.sensor_id+'selectAll'}}\" ng-click=\"page.selectAll(sensor.sensor_id)\"/>\n                            <label class=\"checkbox\" for=\"{{sensor.sensor_id+'selectAll'}}\"></label>\n                            <label for=\"{{sensor.sensor_id+'selectAll'}}\">Select all</label>\n                        </div>\n                    </div>\n                    <br>\n                    <div  ng-repeat=\"feed in page.feeds\" ng-if=\"$index % 4 == 0\" class=\"input-row\">\n                        <div class=\"col-md-3\" ng-hide=\"page.feeds[$index].name===undefined\">\n                            <div class=\"checkbox-container\">\n                                <input type=\"checkbox\" id=\"{{sensor.sensor_id+'rememberMe'+$index}}\"/>\n                                <label class=\"checkbox\" for=\"{{sensor.sensor_id+'rememberMe'+$index}}\"></label>\n                                <label for=\"{{sensor.sensor_id+'rememberMe'+$index}}\">{{page.feeds[$index].name}}</label>\n                            </div>\n                        </div>\n                        <div class=\"col-md-3\" ng-hide=\"page.feeds[$index+1].name===undefined\">\n                            <div class=\"checkbox-container\">\n                                <input type=\"checkbox\" id=\"{{sensor.sensor_id+'rememberMe'+($index+1)}}\"/>\n                                <label class=\"checkbox\" for=\"{{sensor.sensor_id+'rememberMe'+($index+1)}}\"></label>\n                                <label for=\"{{sensor.sensor_id+'rememberMe'+($index+1)}}\">{{page.feeds[$index+1].name}}</label>\n                            </div>\n                        </div>\n                        <div class=\"col-md-3\" ng-hide=\"page.feeds[$index+2].name===undefined\" >\n                            <div class=\"checkbox-container\">\n                                <input type=\"checkbox\" id=\"{{sensor.sensor_id+'rememberMe'+($index+2)}}\"/>\n                                <label class=\"checkbox\" for=\"{{sensor.sensor_id+'rememberMe'+($index+2)}}\"></label>\n                                <label for=\"{{sensor.sensor_id+'rememberMe'+($index+2)}}\">{{page.feeds[$index+2].name}}</label>\n                            </div>\n                        </div>\n                        <div class=\"col-md-3\" ng-hide=\"page.feeds[$index+3].name===undefined\">\n                            <div class=\"checkbox-container\">\n                                <input type=\"checkbox\" id=\"{{sensor.sensor_id+'rememberMe'+($index+3)}}\"/>\n                                <label class=\"checkbox\" for=\"{{sensor.sensor_id+'rememberMe'+($index+3)}}\"></label>\n                                <label for=\"{{sensor.sensor_id+'rememberMe'+($index+3)}}\">{{page.feeds[$index+3].name}}</label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"input-row\">\n                        <div class=\"col-md-6\" style=\"text-align: left;\" >\n                            \n                        </div>\n                        <div class=\"col-md-6\" style=\"text-align: right;\">\n                            <button ng-disabled=\"page.btnSensorFeeds\" type=\"button\" class=\"button-success pure-button\"  ng-click=\"page.saveSensorFeeds(sensor.sensor_id)\" >Apply changes</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </section>\n          -->\n        <section >\n        <div class=\"row-fluid\">\n            <div class=\"tab\">\n                <button ng-click=\"page.addFeed()\">Add new feed</button>\n                <button class=\"tablinks\" name=\"feedlink\" ng-repeat=\"feed in page.feeds\" ng-click=\"page.openFeed($index,feed)\">{{feed.tmpname}}</button>\n            </div>\n            <div class=\"tabcontent\" name=\"feed\" id=\"emptyFeed\">\n                <h1>Select one feed</h2>\n            </div>\n            <form name=\"page.feedForm\" novalidate>\n                <div class=\"tabcontent\" name=\"feed\" ng-repeat=\"feed in page.feeds track by $index\" id=\"{{feed.tmpname}}\" style=\"display: none;\">\n                    <div ng-repeat=\"alert in alerts\">\n                        <notification ng-model=\"alert\"></notification>\n                      </div>\n                    <div class=\"input-row\">\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.name\">Name</label>\n                            <input required type=\"text\" ng-model=\"feed.name\" name=\"name{{$index}}\" placeholder=\"Name\" id=\"feed.name\" >\n                            <p ng-show=\"page.feedForm['name'+$index].$error.required\" class=\"help-block\">A name is required.</p>\n                        </div>\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.regex\">Regular expression</label>\n                            <select ng-model=\"feed.regex\" name=\"regex{{$index}}\" required id=\"feed.regex\">\n                                <option disabled value=\"\">Select the perfect regex</option>\n                                <option ng-repeat=\"regex in page.regexs\" value=\"{{regex.name}}\" title=\"{{regex.regex}}\" ng-selected=\"feed.regex==regex.name\">{{regex.name}}</option>\n                            </select>\n                            <p ng-show=\"page.feedForm['regex'+$index].$error.required\" class=\"help-block\">Select one regex.</p>\n                        </div>\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.helper\">Splitter</label>\n                            <select ng-model=\"feed.helper\" id=\"feed.helper\">\n                                <option value=\"\">Select the splitter</option>\n                                <option ng-repeat=\"regex in page.regexs\" value=\"{{regex.name}}\" title=\"{{regex.regex}}\" ng-selected=\"feed.helper==regex.name\">{{regex.name}}</option>\n                            </select>\n                        </div>\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.frequency\">Frequency</label>\n                            <select ng-model=\"feed.frequency\" name=\"frequency{{$index}}\" required id=\"feed.frequency\">\n                                <option disabled=\"disabled\" value=\"\">Select a frequency</option>\n                                <option ng-selected=\"feed.frequency=='HOURLY'\" value=\"HOURLY\">Every hour</option>\n                                <option ng-selected=\"feed.frequency=='DAILY'\" value=\"DAILY\">Every day</option>\n                                <option ng-selected=\"feed.frequency=='WEEKLY'\" value=\"WEEKLY\">Every week</option>\n                                <option ng-selected=\"feed.frequency=='MONTHLY'\" value=\"MONTHLY\">Every month</option>\n                            </select>\n                            <p ng-show=\"page.feedForm['frequency'+$index].$error.required\" class=\"help-block\">Select one frequency.</p>\n                        </div>\n                    </div>\n                    <div class=\"input-row\">\n                        <label for=\"feed.url\">Address</label>\n                        <input type=\"url\" ng-model=\"feed.url\" name=\"url{{$index}}\" placeholder=\"URL\" class=\"col-md-12\" required id=\"feed.url\">\n                        <p ng-show=\"page.feedForm['url'+$index].$error.required\" class=\"help-block\">A URL is required.</p>\n                        <p ng-show=\"page.feedForm['url'+$index].$invalid\" class=\"help-block\"> Invalid URL.</p>\n                    </div>\n                    <h3>IOCs</h3>\n                    <div class=\"input-row\">\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.ioc_name\">Name</label>\n                            <input required type=\"text\" ng-model=\"feed.ioc_name\" name=\"ioc_name{{$index}}\" placeholder=\"Name\" id=\"feed.ioc_name\"/>\n                            <p ng-show=\"page.feedForm['ioc_name'+$index].$error.required\" class=\"help-block\">A IOC-Name is required.</p>\n                        </div>\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.ioc_detection\">Detection</label>\n                            <input required type=\"text\" ng-model=\"feed.ioc_detection\" name=\"ioc_detection{{$index}}\"  placeholder=\"Detection\" id=\"feed.ioc_detection\" />\n                            <p ng-show=\"page.feedForm['ioc_detection'+$index].$error.required\" class=\"help-block\">A IOC-Detection is required.</p>\n                        </div>\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.ioc_class\">Class</label>\n                            <input required type=\"text\" ng-model=\"feed.ioc_class\" name=\"ioc_class{{$index}}\" placeholder=\"Class\" id=\"feed.ioc_class\" />\n                            <p ng-show=\"page.feedForm['ioc_class'+$index].$error.required\" class=\"help-block\">A IOC-Class is required.</p>\n                        </div>\n                        <div class=\"col-md-3\" >\n                            <label for=\"feed.ioc_stage\">Stage</label>\n                            <input required type=\"text\" ng-model=\"feed.ioc_stage\" name=\"ioc_stage{{$index}}\" placeholder=\"Stage\" id=\"feed.ioc_stage\" />\n                            <p ng-show=\"page.feedForm['ioc_stage'+$index].$error.required\" class=\"help-block\">A IOC-Stage is required.</p>\n                        </div>\n                        <br>\n                    </div>\n                    <div class=\"input-row\">\n                        <div class=\"col-md-3\">\n                            <label for=\"feed.ioc_type\">Type</label>\n                            <select ng-model=\"feed.ioc_type\" name=\"ioc_type{{$index}}\" required id=\"feed.ioc_type\">\n                                <option>Unassigned</option>\n                                <option ng-selected=\"feed.ioc_type=='ip'\" value=\"ip\">Ip</option>\n                                <option ng-selected=\"feed.ioc_type=='file'\" value=\"file\">File Name</option>\n                                <option ng-selected=\"feed.ioc_type=='hash'\" value=\"hash\">File Hash</option>\n                                <option ng-selected=\"feed.ioc_type=='http'\" value=\"http\">Http</option>\n                            </select>\n                            <p ng-show=\"page.feedForm['ioc_type'+$index].$error.required\" class=\"help-block\">Select a IOC-Type.</p>\n                        </div>\n                        <div class=\"col-md-3\">\n                            <label for=\"feed.ioc_severity\">Severity</label>\n                            <select ng-model=\"feed.ioc_severity\" name=\"ioc_severity{{$index}}\" required>\n                                <option>Unassigned</option>\n                                <option ng-selected=\"feed.ioc_severity==1\" value=\"1\" class=\"color-guarded\">Guarded</option>\n                                <option ng-selected=\"feed.ioc_severity==2\" value=\"2\" class=\"color-elevated\">Elevated</option>\n                                <option ng-selected=\"feed.ioc_severity==3\" value=\"3\" class=\"color-high\">High</option>\n                                <option ng-selected=\"feed.ioc_severity==4\" value=\"4\" class=\"color-severe\">Severe</option>\n                            </select>\n                            <p ng-show=\"page.feedForm['ioc_severity'+$index].$error.required\" class=\"help-block\">Select a IOC-Severity.</p>\n                        </div>\n                    </div>\n                    <h3>Last run </h3>\n                    <div class=\"input-row\">\n                        <div class=\"col-md-3\">\n                            <input type=\"text\" ng-model=\"feed.last_run\" placeholder=\"Last run\" disabled />\n                        </div>\n                        <div class=\"col-md-9\">\n                            <input type=\"text\" ng-model=\"feed.sample\"  placeholder=\"Sample\" disabled style=\"width:100%\"/>\n                        </div>\n                    </div>\n                    <br>\n                    <div class=\"input-row\">\n                        <div class=\"col-md-6\" style=\"text-align: left;\" >\n                            \n                        </div>\n                        <div class=\"col-md-6\" style=\"text-align: right;\">\n                            <button type=\"button\" class=\"button-error pure-button\"  ng-click=\"page.deleteFeed(feed, $index)\" ng-show=\"feed.id!==undefined\">Delete</button>\n                            <button type=\"button\" class=\"pure-button\"  ng-click=\"page.deleteFeed(feed, $index)\" ng-show=\"feed.id===undefined\">Cancel</button>\n                            <button type=\"button\" class=\"button-success pure-button\" ng-disabled=\"page.feedForm.$invalid||page.btnFeeds\" ng-click=\"page.saveFeed(feed, $index)\" >{{feed.id===undefined?'Save':'Update'}}</button>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n        </section>\n        <section>\n          <div id=\"regexModal\" >\n            <div class=\"modal-header\">\n                <h3 class=\"modal-title\">Regex Manager</h3>\n            </div>\n            <div class=\"modal-body\" style=\"overflow-y: scroll; position: relative;\">\n                <div class=\"row-fluid\" >\n                    <div class=\"row-fluid\">\n                        <div class=\"span5\">\n                            <label class=\"formLabel\">Regex name  <i class=\"fa fa-question\" title=\"Repeated names will throw error.\"></i></label>\n                        </div>\n                        <div class=\"span5\">\n                            <label class=\"formLabel\">Regex value</label>\n                        </div>\n                        <div class=\"span2\"></div>\n                    </div>\n                    <div class=\"row-fluid\" ng-repeat=\"regex in page.modal_regexs track by $index\" >\n                        <div class=\"span5\">\n                            <input name=\"input80\" type=\"text\" ng-model=\"regex.name\" placeholder=\"{{regex.namHolder}}\"value=\"{{regex.name}}\" class=\"iocRuleInput\" ng-change=\"page.validateRegex(regex)\" ng-class=\"{'repeatedN' : regex.repeatedN}\" maxlength=\"25\">\n                        </div>    \n                        <div class=\"span5\">\n                            <input name=\"input80\" type=\"text\" ng-model=\"regex.regex\" placeholder=\"{{regex.regHolder}}\" value=\"{{regex.regex}}\" class=\"iocRuleInput\" ng-change=\"page.validateRegex(regex)\"  ng-class=\" {'repeatedR' : regex.repeatedR}\">\n                        </div>    \n                        <div class=\"span2\">\n                            <span class=\"trash fa fa-trash-o\" ng-click=\"page.removeRegex($index)\"></span>\n                            <span ng-show=\"$last\" class=\"addAttribute\" ng-click=\"page.addRegex()\">+</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"modal-body\">\n                <form>\n                    <button class=\"collapsible\" id=\"modalCollapse\" ng-click=\"page.collapse()\">Test Area</button>\n                    <div class=\"collapse-content\">\n                        <div class=\"row-fluid\" style=\"padding-top: 3%;\">\n                            <div class=\"span2\">\n                                <label class=\"formLabel\">Regex to be tested</label>\n                            </div>\n                            <div class=\"span3\">\n                                <select id=\"regex_demo\" style=\"width: auto;\" ng-model=\"page.regex_test\">\n                                    <option value=\"\">Select one </option>\n                                    <option value=\"regex_demo\" style=\"color:darkturquoise\">RegexDemo</option>\n                                    <option value=\"regex_helper\" style=\"color: olivedrab;\">RegexWithHelper</option>\n                                    <option ng-repeat=\"regex in page.modal_regexs\" value=\"{{regex.regex}}\" title=\"{{regex.regex}}\" >{{regex.name}}</option>\n                                </select>\n                            </div>\n                            <div class=\"span2\">\n                                <label class=\"formLabel\">Helper to be tested</label>\n                            </div>\n                            <div class=\"span3\">\n                                <select id=\"reghelpdemo\" ng-model=\"page.help_test\" style=\"width: auto;\" >\n                                    <option value=\"\">Select one</option>\n                                    <option value=\"helper_demo\"style=\"color: olivedrab;\" >Helper Demo</option>\n                                    <option ng-repeat=\"regex in page.modal_regexs\" value=\"{{regex.regex}}\" title=\"{{regex.regex}}\" >{{regex.name}}</option>                                \n                                </select>\n                            </div>\n                            <div class=\"span1\">\n                                <button ng-click=\"page.tryRegex()\" type=\"submit\">Try it</button>\n                            </div>\n                        </div>\n                        <div class=\"row-fluid\">\n                            <div class=\"span2\">\n                                <label class=\"formLabel\">Input for regex</label>\n                            </div>\n                            <div class=\"span9\">\n                                <textarea id=\"regPre\" style=\"resize: none; overflow: scroll; width: 100%; \" ng-model=\"page.regPre\" ></textarea>\n                            </div>\n                        </div>\n                        <div class=\"row-fluid\" style=\"display: none;\" id=\"help_out\">\n                            <div class=\"span2\">\n                                <label class=\"formLabel\">Expected output from helper</label>\n                            </div>\n                            <div class=\"span9\">\n                                <textarea id=\"regPostHelp\" style=\"resize: none; overflow: scroll; width: 100%; \" ng-model=\"page.helpOut\" disabled></textarea>\n                            </div>\n                        </div>\n                        <div class=\"row-fluid\">\n                            <div class=\"span2\">\n                                <label class=\"formLabel\">Expected output</label>\n                            </div>\n                            <div class=\"span9\">\n                                <textarea id=\"regPost\" style=\"resize: none; overflow: scroll; width: 100%; \" ng-model=\"page.regOut\"disabled></textarea>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button class=\"button-success pure-button\" ng-click=\"page.saveRegexs()\" id=\"saveFeed\">Save Changes</button>\n            </div>\n        </div>\n        </section>\n      </div>\n    </div>\n    \n\n</section>\n";

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // INBOUND RESP
	    .state('pages.main.inbound_resp', {
	        url: '/inbound_resp',
	        template: __webpack_require__(609),
	        controller: 'inboundRespController',
	        controllerAs: 'page',
	        data: {
	            title: 'Inbound Responder Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // INBOUND ORIG COUNTRY
	    .state('pages.main.inbound_orig_country', {
	        url: '/inbound_orig_country',
	        template: __webpack_require__(610),
	        controller: 'inboundOrigCountryController',
	        controllerAs: 'page',
	        data: {
	            title: 'Inbound Originator Country / Responder Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // INBOUND ORIG
	    .state('pages.main.inbound_orig', {
	        url: '/inbound_orig',
	        template: __webpack_require__(611),
	        controller: 'inboundOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Inbound Originator / Responder Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // OUTBOUND RESP COUNTRY
	    .state('pages.main.outbound_resp_country', {
	        url: '/outbound_resp_country',
	        template: __webpack_require__(612),
	        controller: 'outboundRespCountryController',
	        controllerAs: 'page',
	        data: {
	            title: 'Outbound Responder Country Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // OUTBOUND RESP
	    .state('pages.main.outbound_resp', {
	        url: '/outbound_resp',
	        template: __webpack_require__(613),
	        controller: 'outboundRespController',
	        controllerAs: 'page',
	        data: {
	            title: 'Outbound Responder Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // OUTBOUND ORIG
	    .state('pages.main.outbound_orig', {
	        url: '/outbound_orig',
	        template: __webpack_require__(614),
	        controller: 'outboundOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Outbound Originator / Responder Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // LATERAL RESP
	    .state('pages.main.lateral_resp', {
	        url: '/lateral_resp',
	        template: __webpack_require__(615),
	        controller: 'lateralRespController',
	        controllerAs: 'page',
	        data: {
	            title: 'Lateral Responder Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // LATERAL ORIG
	    .state('pages.main.lateral_orig', {
	        url: '/lateral_orig',
	        template: __webpack_require__(616),
	        controller: 'lateralOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Outbound Originator / Responder Bandwidth Usage',
	            daterange: true
	        }
	    })
	    // INTERNAL MAP
	    .state('pages.main.lateral_map', {
	        url: '/lateral_map',
	        template: __webpack_require__(617),
	        controller: 'lateralMapController',
	        controllerAs: 'page',
	        data: {
	            title: 'Lateral Connections Map',
	            daterange: true,
	            selectrefresh: true
	        }
	    })
	    // SERVICES MAP
	    .state('pages.main.services', {
	        url: '/services',
	        template: __webpack_require__(618),
	        controller: 'servicesController',
	        controllerAs: 'page',
	        data: {
	            title: 'Services',
	            daterange: true
	        }
	    })
	    // NETWORK ASSETS
	    .state('pages.main.network_assets', {
	        url: '/network_assets',
	        template: __webpack_require__(619),
	        controller: 'networkAssetsController',
	        controllerAs: 'page',
	        data: {
	            title: 'Network Assets',
	            daterange: false
	        }
	    })
	
	    // JA3
	    .state('pages.main.top_ja3', {
	        url: '/top_ja3',
	        template: __webpack_require__(620),
	        controller: 'topJA3Controller',
	        controllerAs: 'page',
	        data: {
	            title: 'Top JA3 hashes',
	            daterange: false
	        }
	    });
	};

/***/ },
/* 609 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Bandwidth {{(!page.settings.get('toggleVal')) ? 'B' : page.settings.get('toggleVal')}}</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <div class=\"title2015\"> </div>\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 610 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Bandwidth {{(!page.settings.get('toggleVal')) ? 'B' : page.settings.get('toggleVal')}}</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Responder IP Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 611 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <div class=\"title2015\"> </div>\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 612 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Bandwidth {{(!page.settings.get('toggleVal')) ? 'B' : page.settings.get('toggleVal')}}</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Remote IP Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 613 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Bandwidth {{(!page.settings.get('toggleVal')) ? 'B' : page.settings.get('toggleVal')}}</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 614 */
613,
/* 615 */
609,
/* 616 */
609,
/* 617 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <section head></section>\n    <lateralmap socket=\"page.socket\" main=\"main\" settings=\"page.settings\" save-node-info=\"page.saveNodeInfo\" edit-associated-groups=\"page.editAssociatedGroups\" create-edit-group=\"page.createEditGroup\" delete-group=\"page.deleteGroup\" get-groups=\"page.getGroups\" set-groups=\"page.setGroups\"></lateralmap>\n</div>";

/***/ },
/* 618 */
/***/ function(module, exports) {

	module.exports = "<section dc>\n    <section head></section>\n    <div id=\"servicesOutter\">\n        <div class=\"row-fluid\">\n            <div class=\"span12\">\n                <span id=\"hideLineChart\" class=\"plusMinus\"></span>\n                <div class=\"spinnerParent servicesLineChart\">\n                    <div class=\"title2015 \">Bandwidth {{(!page.settings.get('toggleVal')) ? 'B' : page.settings.get('toggleVal')}}</div>\n                    <div class=\"spinnerContainer\">\n                        <div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div>\n                    </div>\n                    <div id=\"linechart\" type=\"services\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row-fluid\">\n            <div class=\"span12\">\n                <div id=\"buttonContainer\"></div>\n            </div>\n        </div>\n        <div class=\"row-fluid\">\n            <div class=\"span2\">\n                <span class=\"complete\" ng-show=\"page.complete\">\n                    <svg fill=\"none\" stroke=\"none\" height=\"20\" width=\"20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-293 385 24 24\" xml:space=\"preserve\">\n                    <path fill=\"none\" stroke=\"none\" d=\"M-293,385h24v24h-24V385z\"/>\n                    <path fill=\"#00A800\" d=\"M-281,387c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S-275.5,387-281,387z M-283,402l-5-5l1.4-1.4l3.6,3.6l7.6-7.6l1.4,1.4L-283,402z\"/></svg>\n                </span>\n            </div>\n            <!-- <div class=\"span2\"></div> -->\n            <div class=\"span2\"><div class=\"title2015 titleCenter\">Origins</div></div>\n            <div class=\"span4\"><div class=\"title2015 titleCenter\">Protocol / Services</div></div>\n            <div class=\"span2\"><div class=\"title2015 titleCenter\">Responders</div></div>\n            <div class=\"span2\"></div>\n        </div>\n        <div class=\"row-fluid\">\n            <div class=\"spinnerParent\">\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.servicesIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            </div>\n            <div uid=\"{{page.servicesIdentifiers.id}}\" services></div>\n        </div>\n    </div>\n</section>";

/***/ },
/* 619 */
582,
/* 620 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"tablesection\">\n        <div class=\"tablecontainer col-md-12 col-lg-11\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n\n";

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function ($stateProvider) {
	    $stateProvider
	        .state('pages.main.inbound_ioc', {
	        url: '/inbound_ioc',
	        template: __webpack_require__(622),
	        controller: 'inboundIocController',
	        controllerAs: 'page',
	        data: {
	            title: 'Inbound Indicator of Compromise Events',
	            daterange: true,
	        }
	    })
	        .state('pages.main.outbound_ioc', {
	        url: '/outbound_ioc',
	        template: __webpack_require__(623),
	        controller: 'outboundIocController',
	        controllerAs: 'page',
	        data: {
	            title: 'Outbound Indicator of Compromise Events',
	            daterange: true,
	        }
	    })
	        .state('pages.main.lateral_ioc', {
	        url: '/lateral_ioc',
	        template: __webpack_require__(624),
	        controller: 'lateralIocController',
	        controllerAs: 'page',
	        data: {
	            title: 'Lateral Indicator of Compromise Events',
	            daterange: true,
	        }
	    })
	        .state('pages.main.ioc_events_drilldown', {
	        url: '/ioc_events_drilldown',
	        template: __webpack_require__(625),
	        controller: 'iocEventsDrilldownController',
	        controllerAs: 'page',
	        data: {
	            title: 'Indicator of Compromise Events',
	            daterange: true
	        }
	    })
	        .state('pages.main.custom_ioc', {
	        url: '/custom_ioc',
	        params: { include: null, time: null },
	        template: __webpack_require__(626),
	        controller: 'customIOCController',
	        controllerAs: 'page',
	        data: {
	            title: "Custom Indicator of Compromise Rules",
	            daterange: false
	        }
	    })
	        .state('pages.main.whitelist', {
	        url: '/whitelist',
	        params: { include: null, time: null },
	        template: __webpack_require__(627),
	        controller: 'whitelistController',
	        controllerAs: 'page',
	        data: {
	            title: "Whitelist Indicator of Compromise Rules",
	            daterange: false
	        }
	    })
	        .state('pages.main.ad_events', {
	        url: '/ad_events',
	        template: __webpack_require__(628),
	        controller: 'adEventsController',
	        controllerAs: 'page',
	        data: {
	            title: 'Active Events Defense',
	            daterange: true
	        }
	    })
	        .state('pages.main.ad_events_drill', {
	        url: '/ad_events_drill',
	        template: __webpack_require__(629),
	        controller: 'adEventsDrillController',
	        controllerAs: 'page',
	        data: {
	            title: 'Active Events Defense',
	            daterange: true
	        }
	    })
	        .state('pages.main.cyr3con', {
	        url: '/cyr3con',
	        template: __webpack_require__(630),
	        controller: 'cyr3conController',
	        controllerAs: 'page',
	        data: {
	            title: 'cyr3con',
	            daterange: false,
	        }
	    });
	};


/***/ },
/* 622 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n     <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">IOC Events</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span1\">\n            <div class=\"title2015\">IOC Classes</div>\n            <section id=\"sevButtons\" uid=\"{{page.sevLevIdentifiers.id}}\" severity-levels></section>\n        </div>\n        <div class=\"span6 spinnerParent\"><!--4 -->\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.rowChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"rowchart\" uid=\"{{page.rowChartIdentifiers.id}}\" class=\"home\" make-row-chart></div>\n        </div>\n        <div class=\"span5 spinnerParent\"> <!--5 -->\n            <div class=\"title2015\">IOC Source Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 623 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">IOC Events</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span1\">\n            <div class=\"title2015\">IOC Classes</div>\n            <section id=\"sevButtons\" uid=\"{{page.sevLevIdentifiers.id}}\" severity-levels></section>\n        </div>\n        <div class=\"span6 spinnerParent\"><!--4 -->\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.rowChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"rowchart\" uid=\"{{page.rowChartIdentifiers.id}}\" class=\"home\" make-row-chart></div>\n        </div>\n        <div class=\"span5 spinnerParent\"> <!--5 -->\n            <div class=\"title2015\">IOC Source Locations</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.geoChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"geochart\" uid=\"{{page.geoChartIdentifiers.id}}\" make-geo-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 624 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n     <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">IOC Events</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 625 */
/***/ function(module, exports) {

	module.exports = "<style type=\"text/css\">\n    .axis path,\n    .axis line {\n        fill: none;\n        stroke: #000;\n        shape-rendering: crispEdges;\n    }\n    .x.axis path {\n    display: none;\n    }\n    .y.axis path {\n    /*display: none;*/\n    }\n    .swimlane-curvegraph .line {\n    fill: none;\n    stroke: steelblue;\n    stroke-width: 1.5px;\n    }\n    .grid path {\n    stroke-width: 0;\n    }\n</style>\n<section head></section>\n<div class=\"row-fluid\">\n    <div class=\"span12\">\n        <div style=\"background-color:#FFF;\" class=\"box\">\n            <div class=\"box-content\">\n                <div class='span4 slspan'>\n                    <h4 class=\"slh4\">Origin IP <span ng-show=\"infoData.orig_cc !== 'N/A'\" class=\"f32\"><span class=\"flag {{infoData.orig_cc.toLowerCase()}}\"></span></span></span></h4>\n                        <div class=\"slInfoSection\" ng-show=\"infoData.orig_country !== 'N/A'\">\n                            <span><strong>Country: </strong>{{infoData.orig_country}}</span>\n                        </div>\n                        <div class=\"slInfoSection\" ng-show=\"infoData.orig_ip !== 'N/A'\">\n                            <span><strong>IP: </strong>{{infoData.orig_ip}}</span>\n                        </div>\n                        <div class=\"slInfoSection\" ng-show=\"infoData.orig_hostname !== 'N/A'\">\n                            <span><strong>Hostname: </strong>{{infoData.orig_hostname}}</span>\n                        </div>\n                        <div class=\"slInfoSection\" ng-show=\"infoData.orig_user !== 'N/A'\">\n                            <span><strong>User: </strong>{{infoData.orig_user}}</span>\n                        </div>\n                        <div class=\"slInfoSection\" ng-show=\"infoData.orig_asn_name !== 'N/A'\">\n                            <span><strong>ASN: </strong>{{infoData.orig_asn_name}}</span>\n                        </div>\n                        <div class=\"slInfoSection\" ng-show=\"infoData.sensor !== 'N/A'\">\n                            <span><strong>Zone: </strong>{{infoData.sensor}}</span>\n                        </div>\n                </div>\n                <div class='span4 slspan'>\n                    <h4 class=\"slh4\">Responder IP <span ng-show=\"infoData.resp_cc !== 'N/A'\"><span class=\"f32\"><span class=\"flag {{infoData.resp_cc.toLowerCase()}}\"></span></span></span></h4>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.resp_country !== 'N/A'\">\n                        <span><strong>Country: </strong>{{infoData.resp_country}}</span>\n                    </div>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.resp_ip !== 'N/A'\">\n                        <span><strong>IP: </strong>{{infoData.resp_ip}}</span>\n                    </div>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.resp_hostname !== 'N/A'\">\n                        <span><strong>Hostname: </strong>{{infoData.resp_hostname}}</span>\n                    </div>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.resp_user !== 'N/A'\">\n                        <span><strong>User: </strong>{{infoData.resp_user}}</span>\n                    </div>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.resp_asn_name !== 'N/A'\">\n                        <span><strong>ASN: </strong>{{infoData.resp_asn_name}}</span>\n                    </div>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.last !== 'N/A'\">\n                        <span><strong>Last IOC Hit: </strong>{{infoData.last}}</span>\n                    </div>\n                </div>\n                <div class=\"span4 slspan\">\n                    <h4 class=\"slh4\">IOC Information</h4>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.ioc_class !== 'N/A'\">\n                        <span><strong>IOC: </strong>{{infoData.ioc_class}}</span>\n                    </div>\n                    <div class=\"slInfoSection\" ng-show=\"infoData.ioc_type !== 'N/A'\">\n                        <span><strong>IOC Type: </strong>{{infoData.ioc_type}}</span>\n                    </div>\n                    <div ng-show=\"infoData.desc !== 'N/A'\">\n                        <span><strong>IOC Info: </strong>{{infoData.desc}}</span>\n                    </div>\n                   <!--  <div class=\"slInfoSection\" ng-show=\"infoData.resp_country !== 'N/A'\">\n                        <a id=\"ioc_attr_link\" href=\"\" ng-click=\"getChildIOC()\" class=\"epmap\">Show all Attributes</a>\n                    </div> -->\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<br />\n<div class=\"row-fluid\">\n    <div id=\"lanegraph\" lane-graph class=\"lanegraph-temp-bg\"></div>\n</div>\n<br />";

/***/ },
/* 626 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"alert alert-danger animated fadeIn\" ng-show=\"error\">There was an error adding IOC. Please check for duplicates.</div>\n        <div class=\"box\" style=\"background-color:#FFF;\">\n            <form name=\"page.customIOCForm\" id=\"iocForm\" >\n                <div ng-init=\"page.setForm(page.customIOCForm);\">\n                    <span class=\"span2\">\n                        <label class=\"formLabel\">IOC Class:</label>\n                        <input required type=\"text\" ng-model=\"page.formFields.ioc_class\" placeholder=\"eg Custom IOC\">\n                    </span>\n                    <span class=\"span2\">\n                        <label class=\"formLabel\">IOC Severity:</label>\n                        <select ng-model=\"page.formFields.ioc_severity\" ng-init=\"page.formFields.ioc_severity = page.formFields.ioc_severity || '1'\" required>\n                            <option value=\"1\">1 Guarded</option>\n                            <option value=\"2\">2 Elevated</option>\n                            <option value=\"3\">3 High</option>\n                            <option value=\"4\">4 Severe</option>\n                        </select>\n                    </span>\n                    <span class=\"span1\">\n                        <label class=\"formLabel\">Alert:</label>\n                        <div class=\"checkBox-slider custom_alert\">\n                            <label ng-class=\"{greenLabel: page.formFields.ioc_alert}\"><input  type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"page.formFields.ioc_alert\" ng-checked=\"page.formFields.ioc_alert != 0\" ng-true-value=\"1\" ng-false-value=\"0\">\n                                <span>&nbsp;</span>\n                            </label>\n                        </div>\n                    </span>\n                    <span class=\"span1\" ng-show=\"global.user.settings_global.active_defense\">\n                        <label class=\"formLabel\">Active Defense:</label>\n                        <div class=\"checkBox-slider custom_alert\">\n                            <label ng-class=\"{greenLabel: page.formFields.active_defense}\"><input  type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"page.formFields.active_defense\" ng-checked=\"page.formFields.active_defense != 0\" ng-true-value=\"1\" ng-false-value=\"0\">\n                                <span>&nbsp;</span>\n                            </label>\n                        </div>\n                    </span>\n                    <span class=\"span5\">\n                        <div class=\"row-fluid\">\n                            <span class=\"span5\">\n                                <label class=\"formLabel\">IOC Type:</label>\n                            </span>\n                            <span class=\"span5\">\n                                <label class=\"formLabel\">IOC Rule:</label>\n                            </span>\n                            <span class=\"span2\">\n                            </span>\n                        </div>\n                        <div class=\"row-fluid\" ng-repeat=\"(index,att) in page.formFields.ioc_attribute\">\n                            <span class=\"span5\">\n                                <select ng-model=\"att.type\" ng-change=\"page.checkApps(index)\" ng-init=\"att.type = att.type\" required>\n                                    <option value=\"\" disabled>Select a Type</option>\n                                    <option value=\"IPType\">IP Address</option>\n                                    <option value=\"IPSubType\">IP Subnet</option>\n                                    <!-- <option value=\"l7proto\">Layer 7 Protocol</option> -->\n                                    <option value=\"FileType\">File Name</option>\n                                    <option value=\"HashType\" >File Hash</option>\n                                    <option value=\"HTTPType\" >HTTP Domain</option>\n                                    <!-- <option value=\"country\">Country</option> -->\n                                </select>\n                            </span>\n                            <span class=\"span5\">\n                                <input required type=\"text\" ng-model=\"att.rule\" class=\"iocRuleInput\" placeholder=\"eg 1.2.3.4\" ng-change=\"page.checkApps(index)\" autocomplete=\"off\">\n                                <ul class=\"applicationResults\" class=\"term-list hidden\">\n                                    <li ng-repeat=\"app in page.filteredApps[index]\" ng-click=\"page.setRule(index,app)\" class=\"customIocApp\">{{app}}</li>\n                                </ul>\n                            </span>\n                            <span class=\"span2\">\n                                <span class=\"trash fa fa-trash-o\" ng-click=\"page.removeAttribute(index)\"></span>\n                                <span ng-show=\"$last\" class=\"addAttribute\" ng-click=\"page.addAttribute()\">+</span>\n                            </span>\n                        </div>\n                    </span>\n                    <span class=\"span1\">\n                        <label class=\"formLabel\">{{page.editMode.value ? 'Edit IOC: ' : 'Create IOC: '}}</label>\n                        <button ng-click=\"page.handleInsert(page.formFields)\" class=\"button-success pure-button\" ng-disabled=\"page.customIOCForm.$invalid\">Save</button>\n                        <label ng-show=\"page.appNotEqual\" class=\"formError\">IOC Rule must be in list</label>\n                    </span>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br />\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 627 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"alert alert-danger animated fadeIn\" ng-show=\"error\">There was an error adding IOC. Please check for duplicates.</div>\n        <div class=\"box\" style=\"background-color:#FFF;\">\n            <form name=\"page.customIOCForm\" id=\"iocForm\">\n                <div ng-init=\"page.setForm(page.customIOCForm);\">\n                    <span class=\"span2\">\n                        <label class=\"formLabel\">IOC Type:</label>\n                        <select ng-model=\"page.formFields.ioc_type\" ng-init=\"page.formFields.ioc_type = page.formFields.ioc_type\" required>\n                            <option value=\"\" disabled>Select a Type</option>\n                            <option value=\"IPType\">IP Address</option>\n                            <option value=\"IPSubType\">IP Subnet</option>\n                            <option value=\"FileType\">File Name</option>\n                            <option value=\"HashType\" >File Hash</option>\n                            <option value=\"HTTPType\" >HTTP Domain</option>\n                        </select>\n                    </span>\n                    <span class=\"span2\">\n                        <label class=\"formLabel\">IOC Rule:</label>\n                        <input required type=\"text\" ng-model=\"page.formFields.ioc_rule\" ng-change=\"page.isSelected()\" placeholder=\"eg 1.2.3.4\">\n                    </span>\n                    <span class=\"span2\">\n                        <span class=\"radiolabel\">Ends With:</span> <input type=\"radio\" name=\"radio\" ng-model=\"page.formFields.radio\" ng-click=\"page.isSelected('before')\" ng-value=\"'before'\"><br />\n                        <span class=\"radiolabel\">Starts With:</span> <input type=\"radio\" name=\"radio\" ng-model=\"page.formFields.radio\" ng-click=\"page.isSelected('after')\" ng-value=\"'after'\"><br />\n                        <span class=\"radiolabel\">Contains:</span> <input type=\"radio\" name=\"radio\" ng-model=\"page.formFields.radio\" ng-click=\"page.isSelected('contains')\" ng-value=\"'contains'\"><br />\n                    </span>\n                    <span class=\"span2\">\n                        <label class=\"formLabel\">{{page.editMode.value ? 'Edit: ' : 'Create: '}}</label>\n                        <button type=\"submit\" ng-click=\"page.handleInsert(page.formFields)\" class=\"button-success pure-button\" ng-disabled=\"page.customIOCForm.$invalid\">Whitelist</button>\n                    </span>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br />\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 628 */
582,
/* 629 */
582,
/* 630 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <iframe\n            ng-src=\"{{page.url}}\"\n            class=\"e2e-iframe-untrusted-src\"\n            style=\"width: 100%; height: -webkit-fill-available\"\n            frameborder=\"0\"\n            allowfullscren=\"allowfullscren\"></iframe>\n</section>";

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider.state('pages.main.search', {
	        url: '/search',
	        params: { include: null, exclude: null, time: null, mode: null },
	        template: __webpack_require__(632),
	        controller: 'searchController',
	        controllerAs: 'page',
	        data: {
	            title: 'Search',
	            daterange: true,
	            manualSearch: true // this activates a button in the search bar and changes the auto search rules
	        }
	    });
	};

/***/ },
/* 632 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"searchSidebar\">\n            <table-search-sidebar></table-search-sidebar>\n        </div>\n        <div>\n            <div class=\"searchTable\" class=\"row-fluid\">\n                <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n            </div>\n        </div>\n    </div>\n</section>";

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // STEALTH
	    // STEALTH DEPLOY CONFIG
	    .state('pages.main.stealth_deploy_config', {
	        url: '/stealth_deploy_config',
	        template: __webpack_require__(634),
	        controller: 'stealthDeployConfigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Stealth Deployment Configuration',
	            daterange: true
	        }
	    })
	    // STEALTH OP VIEW
	    .state('pages.main.stealth_op_view', {
	        url: '/stealth_op_view',
	        template: __webpack_require__(635),
	        controller: 'stealthOpViewController',
	        controllerAs: 'page',
	        data: {
	            title: 'Stealth Operational View',
	            daterange: true
	        }
	    })
	    // STEALTH CONN
	    .state('pages.main.stealth_conn', {
	        url: '/stealth_conn',
	        template: __webpack_require__(636),
	        controller: 'stealthConnController',
	        controllerAs: 'page',
	        data: {
	            title: 'Stealth User Connections',
	            daterange: true
	        }
	    })
	    // STEALTH CONN ORIG
	    .state('pages.main.stealth_conn_orig', {
	        url: '/stealth_conn_orig',
	        template: __webpack_require__(637),
	        controller: 'stealthConnOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Stealth Origin User Connections',
	            daterange: true
	        }
	    })
	    // STEALTH EVENTS
	    .state('pages.main.stealth_events', {
	        url: '/stealth_events',
	        template: __webpack_require__(638),
	        controller: 'stealthEventsController',
	        controllerAs: 'page',
	        data: {
	            title: 'Stealth Events',
	            daterange: true
	        }
	    })
	    // STEALTH EVENTS ORIG
	    .state('pages.main.stealth_events_orig', {
	        url: '/stealth_events_orig',
	        template: __webpack_require__(639),
	        controller: 'stealthEventsOrigController',
	        controllerAs: 'page',
	        data: {
	            title: 'Stealth Events Origin',
	            daterange: true
	        }
	    });
	};

/***/ },
/* 634 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span12 spinnerParent\">\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-stealth_deploy_config\" spinner-start-active=\"true\"></div></div>\n            <div id=\"stealthforcechart\" make-stealth-force-chart></div>\n        </div>\n    </div>\n</section>";

/***/ },
/* 635 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span9 spinnerParent\">\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-stealth_op_view\" spinner-start-active=\"true\"></div></div>\n            <div id=\"forcechart\" make-coi-chart></div>\n        </div>\n        <div class=\"span3\">\n            <div id=\"forcechartinfo\"></div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 636 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <div class=\"title2015\">Bandwidth Per Hour (MB/Hour)</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 637 */
582,
/* 638 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"title2015\">Enpoint Events Per Hour</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Endpoint Events Distribution by Type</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 639 */
582,
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // ENDPOINT BY TYPE
	    .state('pages.main.endpoint_by_type', {
	        url: '/endpoint_by_type',
	        template: __webpack_require__(641),
	        controller: 'endpointTypeController',
	        controllerAs: 'page',
	        data: {
	            title: 'Events By Type',
	            daterange: true
	        }
	    })
	    // ENDPOINT EVENTS USER
	    .state('pages.main.endpoint_by_type_and_user', {
	        url: '/endpoint_by_type_and_user',
	        template: __webpack_require__(642),
	        controller: 'endpointTypeUserController',
	        controllerAs: 'page',
	        data: {
	            title: 'Endpoints Triggering Event',
	            subtitleElm: {
	                'Event Type': 'event_type'
	            },
	            daterange: true
	        }
	    })
	    // ENDPOINT BY LOCAL IP
	    .state('pages.main.endpoint_by_user', {
	        url: '/endpoint_by_user',
	        template: __webpack_require__(643),
	        controller: 'endpointUserController',
	        controllerAs: 'page',
	        data: {
	            title: 'Events By User',
	            daterange: true
	        }
	    })
	    // ENDPOINT EVENTS LOCAL BY ALERT INFO
	    .state('pages.main.endpoint_by_user_and_type', {
	        url: '/endpoint_by_user_and_type',
	        template: __webpack_require__(644),
	        controller: 'endpointUserTypeController',
	        controllerAs: 'page',
	        data: {
	            title: 'Endpoints Triggering Event',
	            subtitleElm: {
	                'Zone': 'zone',
	                'Local Hostname': 'local_hostname'
	            },
	            daterange: true
	        }
	    })
	    // ENDPOINT EVENTS SHAREPOINT
	    .state('pages.main.endpoint_events_sharepoint', {
	        url: '/endpoint_events_sharepoint',
	        template: __webpack_require__(645),
	        controller: 'endpointEventsSharepointController',
	        controllerAs: 'page',
	        data: {
	            title: 'MS Events',
	            daterange: true
	        }
	    })
	    // ENDPOINT EVENTS SHAREPOINT DRILL
	    .state('pages.main.endpoint_events_sharepoint_drill', {
	        url: '/endpoint_events_sharepoint_drill',
	        template: __webpack_require__(646),
	        controller: 'endpointEventsSharepointDrillController',
	        controllerAs: 'page',
	        data: {
	            title: 'MS Local Events',
	            subtitleElm: {
	                'Event Type': 'event_type'
	            },
	            daterange: true
	        }
	    });
	};

/***/ },
/* 641 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Endpoint Events Per Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Endpoint Events Distribution by Type</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 642 */
582,
/* 643 */
/***/ function(module, exports) {

	module.exports = "<section dc data-ng-controller=\"endpointUserController\">\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Endpoint Events Per Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Endpoint Events Distribution by User</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 644 */
582,
/* 645 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">MS Events Per Hour</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">MS Events Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>\n    <div class=\"row-fluid\">\n            <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>\n";

/***/ },
/* 646 */
582,
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // USER MANAGEMENT
	    .state('pages.main.manage_users', {
	        url: '/manage_users',
	        template: __webpack_require__(648),
	        controller: 'manageUserController',
	        controllerAs: 'page',
	        data: {
	            title: 'User Management',
	            daterange: false
	        }
	    });
	};

/***/ },
/* 648 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n\n    <div class=\"row-fluid\" ng-hide=\"page.editPane\">\n        <div class=\"span12\">\n            <div class=\"box\" style=\"background-color:#FFF;\">\n                <table class=\"listUser\" ng-hide=\"page.historyShow\">\n                    <tr style=\"font-weight:bold\">\n                        <th>Email</th><th>User Level</th><th></th><th></th><th></th>\n                    </tr>\n                    <tr ng-repeat=\"user in page.users\">\n                        <td><span>{{user.email}}</span></td>\n                        <td><span>{{page.userLevelDisplay(user)}}</span></td>\n                        <td><span type=\"button\" class=\"pure-button\" ng-click=\"page.viewHistory(user)\">View History</span></td>\n                        <td><button type=\"button\" class=\"button-error pure-button\" ng-show=\"(user.email != global.user.email)\" ng-click=\"page.delete(user, $index)\">Delete</button></td>\n                        <td ng-click=\"page.editUser(user, $index)\" style=\"cursor:pointer\"><svg height=\"30\" width=\"30\"><path transform=\"translate(0,6)\" style=\"fill:#555555;\" d=\"M15.3,16c0.6,0,1.2,0.1,1.7,0.4c0.7-0.8,1.2-1.8,1.6-2.8c-1.4-0.6-2.3-2-2.3-3.6c0-1.6,1-3,2.3-3.6c-0.4-1-0.9-2-1.6-2.8C16.5,3.9,15.9,4,15.3,4c-2.1,0-3.9-1.7-4-3.8C10.7,0.1,10,0,9.3,0s-1.4,0.1-2,0.2C7.2,2.3,5.5,4,3.3,4C2.7,4,2.1,3.9,1.6,3.6C0.9,4.4,0.4,5.4,0,6.4C1.4,7,2.3,8.4,2.3,10c0,1.6-1,3-2.3,3.6c0.4,1,0.9,2,1.6,2.8C2.1,16.1,2.7,16,3.3,16c2.1,0,3.9,1.7,4,3.8c0.7,0.1,1.3,0.2,2,0.2s1.4-0.1,2-0.2C11.4,17.7,13.2,16,15.3,16zM5.3,10c0-2.2,1.8-4,4-4s4,1.8,4,4c0,2.2-1.8,4-4,4S5.3,12.2,5.3,10z\"/></path></svg></td>\n                    </tr>\n                </table>\n                <span ng-show=\"page.historyShow\" class=\"hideShowHist\"><span type=\"button\" class=\"pure-button\" ng-click=\"page.hideHistory()\">Hide History</span></span>\n                <table class=\"listUser\" ng-show=\"page.historyShow\">\n                    <tr style=\"font-weight:bold\">\n                        <th class=\"firstHeaderTitle\">Time</th><th>User</th><th>IP</th><th>Result</th><th>Useragent</th>\n                    </tr>\n                    <tr ng-repeat=\"hist in page.history\">\n                        <td><div class=\"tableDate2015\">{{hist.time}}</div></td>\n                        <td><span>{{hist.user}}</span></td>\n                        <td><span>{{hist.ip}}</span></td>\n                        <td><span>{{hist.result}}</span></td>\n                        <td><span>{{hist.useragent}}</span></td>\n                    </tr>\n                </table>\n            </div>\n            <button ng-hide=\"page.historyShow\" ng-click=\"page.createUser()\" class=\"button-success pure-button createUser\">Create New User</button>\n        </div>\n    </div>\n    <div class=\"row-fluid\" ng-show=\"page.editPane\">\n        <div class=\"span12\">\n            <div id=\"userForm\" class=\"box\" style=\"background-color:#FFF;\">\n                <form name=\"page.form\">\n                    <h4>User Info</h4>\n                    <div class=\"userSection\">\n                        <label class=\"formLabel\">Email:*</label> <input required type=\"email\" ng-model=\"page.user.email\" ng-disabled=\"(page.formMode == 'edit')\"><br/>\n                        <label class=\"formLabel\">User Level:*</label>\n                        <select ng-model=\"page.user.user_level\" required>\n                            <option value=\"superadmin\" ng-show=\"global.user.user_level === 'superadmin'\">Super Admin</option>\n                            <option value=\"admin\" ng-show=\"global.user.user_level === 'admin' || global.user.user_level === 'superadmin'\">Admin</option>\n                            <option value=\"user\">User</option>\n                        </select><br/>\n                    </div>\n                    <h4>Clients/Zones</h4>\n                    <div class=\"userSection\">\n                        <ul class=\"userCliList\">\n                            <li ng-repeat=\"(key, value) in page.user.access\">\n                                <span>{{key}}</span>\n                                <ul>\n                                    <li ng-repeat=\"(keyspace, obj) in value.sites\">\n                                        <input type=\"checkbox\" ng-model=\"obj.checked\" name=\"hide_stealth\" /><label class=\"formLabel\">{{obj.name}}</label>\n                                    </li>\n                                </ul>\n                            </li>\n                        </ul>\n                        <span class=\"control-group\" ng-class=\"{ 'has-error' : page.siteNotSelected(page.user) }\">\n                            <span ng-show=\"page.siteNotSelected(page.user)\" class=\"help-block\">Select at least one site</span>\n                        </span>\n                    </div>\n                    <h4>Show/Hide</h4>\n                    <div class=\"userSection\">\n                        <input type=\"checkbox\" ng-model=\"page.user.settings_global.threat_hunting\" name=\"show_threat\" /><label class=\"formLabel\">Show Threat Hunting</label><br/>\n                        <input type=\"checkbox\" ng-model=\"page.user.settings_global.cyr3con\" name=\"show_cyr3con\" /><label class=\"formLabel\">Show cyr3con</label><br/>\n                        <input type=\"checkbox\" ng-model=\"page.user.settings_global.stealth\" name=\"show_stealth\" /><label class=\"formLabel\">Show Stealth</label><br/>\n                        <input type=\"checkbox\" ng-model=\"page.user.settings_global.active_defense\" name=\"show_ad\" /><label class=\"formLabel\">Show Active Defense</label><br/>\n                        <input type=\"checkbox\" ng-model=\"page.user.settings_global.system_events\" name=\"show_se\" /><label class=\"formLabel\">Show System Events</label><br/>\n                        <input type=\"checkbox\" ng-model=\"page.user.settings_global.network_map\" name=\"show_nm\" /><label class=\"formLabel\">Show Network Map</label><br/>\n                        <input type=\"checkbox\" ng-model=\"page.user.settings_global.proxy_blocked\" name=\"show_proxy_blocked\" /><label class=\"formLabel\">Show Proxy Blocked</label><br/>\n                    </div>\n                    <h4  ng-if=\"page.formMode == 'edit'\">Change Password (optional)</h4>\n                    <div class=\"userSection\" ng-if=\"page.formMode == 'edit'\">\n                        <div class=\"control-group\" ng-class=\"{ 'has-error' : page.user.password.$invalid }\">\n                            <input type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"New Password\" ng-model=\"page.user.password\" ng-minlength=\"8\" ng-maxlength=\"100\" >\n                            <p ng-show=\"page.form.password.$error.minlength\" class=\"help-block\">Password is too short.</p>\n                            <p ng-show=\"page.form.password.$error.maxlength\" class=\"help-block\">Password is too long.</p>\n                        </div>\n                        <div class=\"control-group\" ng-class=\"{ 'has-error' : page.form.cpassword.$viewValue != page.form.password.$viewValue }\">\n                            <input type=\"password\" name=\"cpassword\" class=\"form-control\" placeholder=\"Repeat password\" ng-model=\"page.user.cpassword\" ng-minlength=\"8\" ng-maxlength=\"100\">\n                            <p ng-show=\" page.form.cpassword.$viewValue != page.form.password.$viewValue\" class=\"help-block\">Passwords dont match</p>\n                        </div>\n                    </div>\n                    <div class=\"userSection\">\n                        <div class=\"alert alert-danger animated fadeIn\" ng-show=\"formerror\">{{formerror}}</div>\n                        <!-- EDITING -->\n                        <button ng-if=\"page.formMode == 'edit'\" type=\"submit\" ng-click=\"page.saveBtn(page.user, page.form)\" class=\"button-success pure-button\">Save</button>\n                        <!-- CREATING -->\n                        <button ng-if=\"page.formMode == 'create'\" type=\"submit\" ng-click=\"page.doneBtn(page.user, page.form)\" class=\"button-success pure-button\">Done</button>\n                        <!-- OTHER -->\n                        <button type=\"button\" class=\"pure-button\" ng-click=\"page.cancel(page.form)\">Cancel</button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</section>";

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function ($stateProvider) {
	    $stateProvider
	    // Failed SSL Certificate Validation
	    .state('pages.main.ssl_certs', {
	        url: '/ssl_certs',
	        template: __webpack_require__(650),
	        controller: 'sslCertsController',
	        controllerAs: 'page',
	        data: {
	            title: 'Failed SSL Certificate Validations',
	            daterange: true
	        }
	    })
	    // DNS Exfiltration (UDP Tunneling)
	    .state('pages.main.dns_exfil_udp_tunnels', {
	        url: '/dns_exfil_udp_tunnels',
	        template: __webpack_require__(651),
	        controller: 'dnsExfilTunnelsController',
	        controllerAs: 'page',
	        data: {
	            title: 'DNS Exfiltration (UDP Tunneling) [> 60sec]',
	            daterange: true
	        }
	    })
	    // DNS Exfiltration (Subdomains on a Top Level Domain)
	    .state('pages.main.dns_exfil_subdomains', {
	        url: '/dns_exfil_subdomains',
	        template: __webpack_require__(652),
	        controller: 'dnsExfilSubdomainsController',
	        controllerAs: 'page',
	        data: {
	            title: 'Subdomains Stacking',
	            daterange: true
	        }
	    })
	    // DNS Exfiltration (DNS Queries)
	    // .state('pages.main.dns_exfil_queries',
	    // {
	    //     url: '/dns_exfil_queries',
	    //     template: require('../views/hunting/dns_exfil_queries.html'),
	    //     controller: 'dnsExfilQueriesController',
	    //     controllerAs: 'page',
	    //     data:
	    //     {
	    //         title: 'DNS Exfiltration (DNS Queries) Events',
	    //         daterange: true
	    //     }
	    // })
	    // Kaminsky DNS Attack (Duplicate DNS Source Ports)
	    .state('pages.main.dns_poisoning', {
	        url: '/dns_poisoning',
	        template: __webpack_require__(653),
	        controller: 'dnsPoisoning',
	        controllerAs: 'page',
	        data: {
	            title: 'Kaminsky DNS Attack (Duplicate DNS Source Ports)',
	            daterange: true
	        }
	    })
	    // DNS Tunnel (DNScat2)
	    .state('pages.main.dns_tunnel_dnscat2', {
	        url: '/dns_tunnel_dnscat2',
	        template: __webpack_require__(654),
	        controller: 'dnsTunnelDnscat2',
	        controllerAs: 'page',
	        data: {
	            title: 'DNS Tunnel (DNScat2)',
	            daterange: true
	        }
	    })
	    // DNS Tunnel (Iodine-1)
	    .state('pages.main.dns_tunnel_iodine_1', {
	        url: '/dns_tunnel_iodine_1',
	        template: __webpack_require__(655),
	        controller: 'dnsTunnelIodine1',
	        controllerAs: 'page',
	        data: {
	            title: 'Iodine DNS Tunnel (DNS null returns)',
	            daterange: true
	        }
	    })
	    // DNS Tunnel (Iodine-2)
	    .state('pages.main.dns_tunnel_iodine_2', {
	        url: '/dns_tunnel_iodine_2',
	        template: __webpack_require__(656),
	        controller: 'dnsTunnelIodine2',
	        controllerAs: 'page',
	        data: {
	            title: 'DNS Tunnel (Iodine-2)',
	            daterange: true
	        }
	    })
	    // Suspicious Subdomains
	    .state('pages.main.dns_exfil_queries', {
	        url: '/suspicious_subdomains',
	        template: __webpack_require__(657),
	        controller: 'suspiciousSubdomains',
	        controllerAs: 'page',
	        data: {
	            title: 'Suspicious Subdomains',
	            daterange: true
	        }
	    })
	    // Long Duration Connections
	    .state('pages.main.long_duration_conns', {
	        url: '/long_duration_conns',
	        template: __webpack_require__(658),
	        controller: 'longDurationConns',
	        controllerAs: 'page',
	        data: {
	            title: 'Long Duration Connections [> 60sec]',
	            daterange: true
	        }
	    })
	    // Large HTTP Responses (More than 1KB)
	    .state('pages.main.large_http_responses', {
	        url: '/large_http_responses',
	        template: __webpack_require__(659),
	        controller: 'largeHttpResponses',
	        controllerAs: 'page',
	        data: {
	            title: 'Large HTTP Responses [> 1KB]',
	            daterange: true
	        }
	    })
	    // Non-Standard HTTP
	    .state('pages.main.non_standard_http', {
	        url: '/non_standard_http',
	        template: __webpack_require__(660),
	        controller: 'nonStandardHttp',
	        controllerAs: 'page',
	        data: {
	            title: 'Non-Standard HTTP',
	            daterange: true
	        }
	    })
	    // Services Breakdown
	    .state('pages.main.services_breakdown', {
	        url: '/services_breakdown',
	        template: __webpack_require__(661),
	        controller: 'servicesBreakdown',
	        controllerAs: 'page',
	        data: {
	            title: 'Services Breakdown',
	            daterange: true
	        }
	    })
	    // User-Agents (HTTP)
	    .state('pages.main.user_agents', {
	        url: '/user_agents',
	        template: __webpack_require__(662),
	        controller: 'userAgents',
	        controllerAs: 'page',
	        data: {
	            title: 'User-Agents (HTTP)',
	            daterange: true
	        }
	    })
	    // Top Responder Ports
	    .state('pages.main.top_responder_ports', {
	        url: '/top_responder_ports',
	        template: __webpack_require__(663),
	        controller: 'topResponderPorts',
	        controllerAs: 'page',
	        data: {
	            title: 'Top Responder Ports',
	            daterange: true
	        }
	    })
	    // Top Internal Producers
	    .state('pages.main.top_internal_producers', {
	        url: '/top_internal_producers',
	        template: __webpack_require__(664),
	        controller: 'topInternalProducers',
	        controllerAs: 'page',
	        data: {
	            title: 'Top Internal Producers',
	            daterange: true
	        }
	    })
	    // Top Referred Hosts
	    .state('pages.main.top_referred_hosts', {
	        url: '/top_referred_hosts',
	        template: __webpack_require__(665),
	        controller: 'topReferredHosts',
	        controllerAs: 'page',
	        data: {
	            title: 'Top Referred Hosts',
	            daterange: true
	        }
	    })
	    // Most Popular Sites
	    .state('pages.main.most_popular_sites', {
	        url: '/most_popular_sites',
	        template: __webpack_require__(666),
	        controller: 'mostPopularSites',
	        controllerAs: 'page',
	        data: {
	            title: 'Most Popular Sites',
	            daterange: true
	        }
	    })
	    // HTTP Beacons
	    .state('pages.main.http_beacons', {
	        url: '/http_beacons',
	        template: __webpack_require__(667),
	        controller: 'httpBeacons',
	        controllerAs: 'page',
	        data: {
	            title: 'HTTP Beacons',
	            daterange: true
	        }
	    })
	    // DNS Beacons
	    .state('pages.main.dns_beacons', {
	        url: '/dns_beacons',
	        template: __webpack_require__(668),
	        controller: 'dnsBeacons',
	        controllerAs: 'page',
	        data: {
	            title: 'DNS Beacons',
	            daterange: true
	        }
	    });
	};

/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports = "<section>\n    <section head></section>\n    <!--<div class=\"row-fluid\">\n        <div class=\"span7\">\n            <div class=\"spinnerParent\">\n                <div class=\"title2015\">Subject Connections</div>\n                <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.lineChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n                <div id=\"linechart\" uid=\"{{page.lineChartIdentifiers.id}}\" make-line-chart></div>\n            </div>\n        </div>\n        <div class=\"span5 spinnerParent\">\n            <div class=\"title2015\">Subject Distribution</div>\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-{{page.pieChartIdentifiers.id}}\" spinner-start-active=\"true\"></div></div>\n            <div id=\"piechart\" uid=\"{{page.pieChartIdentifiers.id}}\" make-pie-chart></div>\n        </div>\n    </div>-->\n    <div class=\"row-fluid\">\n        <div class=\"span12\">\n            <sev-table uid=\"{{page.tableIdentifiers.id}}\"></sev-table>\n        </div>\n    </div>\n</section>";

/***/ },
/* 651 */
650,
/* 652 */
650,
/* 653 */
650,
/* 654 */
650,
/* 655 */
650,
/* 656 */
650,
/* 657 */
650,
/* 658 */
650,
/* 659 */
650,
/* 660 */
650,
/* 661 */
650,
/* 662 */
650,
/* 663 */
650,
/* 664 */
650,
/* 665 */
650,
/* 666 */
650,
/* 667 */
650,
/* 668 */
650,
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    __webpack_require__(670)(ngModule);
	    __webpack_require__(679)(ngModule);
	    __webpack_require__(702)(ngModule);
	    __webpack_require__(706)(ngModule);
	    __webpack_require__(713)(ngModule);
	    __webpack_require__(726)(ngModule);
	    __webpack_require__(740)(ngModule);
	    __webpack_require__(742)(ngModule);
	    __webpack_require__(749)(ngModule);
	    __webpack_require__(751)(ngModule);
	    __webpack_require__(758)(ngModule);
	    __webpack_require__(760)(ngModule);
	    __webpack_require__(763)(ngModule);
	    __webpack_require__(783)(ngModule);
	};

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // header
	    ngModule.controller('HeaderController', __webpack_require__(671));
	    // sidebar
	    ngModule.controller('sidebarController', __webpack_require__(673));
	    // main
	    ngModule.controller('mainPageController', __webpack_require__(676));
	};

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, $rootScope, Global, $location, $http, $state, $window, timeFormat, ngDialog) {
	    $scope.global = Global;
	    var model = this;
	
	    //////////////////////////
	    //// CLIENT AND ZONES ////
	    //////////////////////////
	    this.changeClient = function (client) {
	        // if the client is different from the current one
	        if ($scope.global.user.settings_global.current.client !== client) {
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/users/change_client',
	                data: {
	                    client: client
	                }
	            }).success(function (result) {
	                delete $window.sessionStorage.token;
	                $window.sessionStorage.token = result.token;
	                $scope.global.user.settings_global.current = result.current;
	                if ($state.current.url === '/live') {
	                    // for now if we're on the live page already, lets do a refresh
	                    $window.location.reload();
	                } else {
	                    // else we just change page
	                    if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
	                        // copy the time and strip out any other vars when clicking sidebar items
	                        var time = angular.copy({ start: $location.$$search.start, end: $location.$$search.end });
	                        $location.path('/live').search(time);
	                    } else {
	                        $location.path('/live').search({});
	                    }
	                }
	            }).error(function () {
	                alert('"' + $scope.global.user.email + '" does not have access to the "' + client + '" Client');
	            });
	        }
	    };
	
	    //////////////////////////////
	    /////////// SEARCH ///////////
	    //////////////////////////////
	    // on load check state to see if search needs to be set to manual or not
	    if (typeof $state.current.data.manualSearch !== 'undefined') {
	        // check to see if it exists in state
	        if ($state.current.data.manualSearch === true) {
	            // make sure the value is set to true
	            // set model to true
	            model.manualSearch = true;
	            $scope.main.setManualSearch(model.manualSearch);
	        }
	    }
	    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
	        // set parent scope searchmode to false if this state's is true
	        if (model.manualSearch) {
	            $scope.main.setManualSearch(false);
	            // on state change disable the manual search if it exists
	            model.manualSearch = false;
	        }
	        // run settign function on main controller
	        // then proceed to check if this route needs it turned on
	        if (!toState.hasOwnProperty('data')) {
	            return;
	        }
	        if (!toState.data.manualSearch) {
	            return;
	        } // make sure the value is set to true if it even exists
	        model.manualSearch = true;
	        $scope.main.setManualSearch(model.manualSearch);
	    });
	
	    ////////////////////////////
	    //// ACCOUNT MANAGEMENT //// (LOGGED IN USER)
	    ////////////////////////////
	    $scope.openSettingsModal = function () {
	        var model = this;
	        // set error to false
	        model.error = false;
	        // set local user variable as refrence for what the user looked like before modal opening
	        var user = angular.copy($scope.global.user);
	        // set the user object for the modal
	        model.user = angular.copy($scope.global.user);
	        ///////////
	        // TAB 1 //
	        ///////////////////
	        // EMAIL EDITING //
	        ///////////////////
	        // set email edit mode to false by default
	        model.emailEditMode = false;
	        var emailChanged = false;
	        model.emailEditModeToggle = function (form) {
	            if (model.emailEditMode) {
	                model.emailEditMode = false;
	                // set emailChanged according to if email eas actually changed
	                if (form.$valid && model.user.email !== user.email) {
	                    model.error = false; // clear any error that may have existed upon trying new change
	                    emailChanged = true;
	                    // send save signal here
	                    $http({
	                        method: 'POST',
	                        url: ("https://api-demo.mantix4.com") + '/api/users/updateemail',
	                        data: {
	                            email: user.email,
	                            newEmail: model.user.email
	                        }
	                    }).success(function (token) {
	                        // delete old token
	                        delete $window.sessionStorage.token;
	                        // set new token
	                        $window.sessionStorage.token = token;
	                        // then set original user email to this new value
	                        user.email = angular.copy(model.user.email);
	                        $scope.global.user.email = model.user.email;
	                    }).error(function (data) {
	                        model.error = data.message; // set error message
	                        model.user.email = user.email;
	                    });
	                } else {
	                    emailChanged = false;
	                }
	            } else {
	                model.emailEditMode = true;
	            }
	        };
	        model.emailEditModeCancel = function () {
	            // just reset the model.email back to the original / since last save
	            model.email = user.email;
	            // turn off edit mode
	            model.emailEditMode = false;
	            model.user.email = user.email;
	        };
	        //////////////////////
	        // PASSWORD EDITING //
	        //////////////////////
	        model.submitPassword = function (form) {
	            // check to make sure the form is completely valid
	            if (form.$valid && model.user.password && model.user.cpassword === model.user.password && model.user.password !== '') {
	                var r = confirm('Are you sure? You will be logged out.');
	                if (r == true) {
	                    $http({
	                        method: 'POST',
	                        url: ("https://api-demo.mantix4.com") + '/api/users/updatepass',
	                        data: {
	                            newPass: model.user.password
	                        }
	                    }).success(function (token) {
	                        $scope.logout();
	                    }).error(function (data) {
	                        model.error = data.message; // set error message
	                        model.user.email = user.email;
	                    });
	                } else {
	                    model.user.password = '';
	                    model.user.cpassword = '';
	                }
	            }
	        };
	        ///////////
	        // TAB 2 //
	        ////////////////
	        // TWO FACTOR //
	        ////////////////
	        model.twoFactorSwitch = false;
	        model.otpurl = '';
	        model.otpkey = '';
	        model.twoFactorMode = 'disabled';
	        // if exists in the user object set mode to enabled
	        if (user.two_step_auth_set) {
	            model.twoFactorMode = 'enabled';
	            model.twoFactorSwitch = true;
	        }
	        model.toggleTwoFactorConfig = function (active) {
	            model.error = false; // kill any error messages
	            // if mode is disabled and action is on, set to temporary 'setup' mode
	            if (active && model.twoFactorMode === 'disabled') {
	                model.twoFactorMode = 'setup';
	                $http({
	                    method: 'GET',
	                    url: ("https://api-demo.mantix4.com") + '/api/users/generateotp'
	                }).success(function (key) {
	                    model.otpkey = key.ascii;
	                    model.otpurl = key.otpauth_url;
	                });
	            } else if (!active) {
	                // else if not active
	                if (model.twoFactorMode === 'setup') {
	                    // if still setting up change mode to disabled
	                    model.twoFactorMode = 'disabled';
	                } else {
	                    // else remove the user's key and mark disabled
	                    $http({
	                        method: 'POST',
	                        url: ("https://api-demo.mantix4.com") + '/api/users/setotp',
	                        data: {
	                            key: false
	                        }
	                    }).success(function (token) {
	                        // get token back and reassign it
	                        model.twoFactorMode = 'disabled';
	                        // update user
	                        model.user.two_step_auth_set = null;
	                        $scope.global.user.two_step_auth_set = null;
	                    });
	                }
	            }
	        };
	        model.twoFactorSubmit = function (form) {
	            model.error = false; // kill any error messages
	            if (form.$valid) {
	                $http({
	                    method: 'POST',
	                    url: ("https://api-demo.mantix4.com") + '/api/users/setotp',
	                    data: {
	                        passcode: form.verify.$modelValue,
	                        key: model.otpkey
	                    }
	                }).success(function () {
	                    // update user objects
	                    model.user.two_step_auth_set = true;
	                    $scope.global.user.two_step_auth_set = true;
	                }).error(function (data) {
	                    model.error = data.message; // set error message
	                });
	            }
	        };
	        ///////////
	        // TAB 3 //
	        /////////////
	        // REPORTS //
	        /////////////
	        // default reports
	        var defaultAvailableReportsList = function defaultAvailableReportsList() {
	            return [{
	                title: 'IOC Events',
	                single: true,
	                type: 'iocevents'
	            }];
	        };
	        var defaultReportSettings = function defaultReportSettings() {
	            return {
	                hour: null,
	                day: null
	            };
	        };
	        // set default report settings to null
	        model.reportSettings = defaultReportSettings();
	        // edit mode is set to false by default
	        model.reportsEditMode = false;
	        // helper function used to filter the AVAILABLE list depending on if the report is a 'single' or not
	        model.checkForOneReport = function (item) {
	            var result = true; // hide items by default
	            for (var c = 0, len = model.user.settings_global.reports.length; c < len; c++) {
	                if (item.single && model.user.settings_global.reports[c].type === item.type) {
	                    result = false;
	                }
	            }
	            return result;
	        };
	        // populate the available reports from the defaultReports function
	        model.available = defaultAvailableReportsList();
	        // Sortable config for current reports list
	        model.currentConfig = {
	            group: 'reportsGroup',
	            animation: 150,
	            sort: false,
	            onAdd: function onAdd(evt) {
	                // model.reportSettings = angular.copy(defaultReportSettings()); // because its a new add, lets add default settings to the form's model
	                // evt.model.settings = angular.copy(model.reportSettings); // assign settings to the evt object before sending it to the edit function
	                model.editReport(evt.newIndex); // run edit function on new report
	                model.available = angular.copy(defaultAvailableReportsList()); // update available reports
	            },
	            onRemove: function onRemove(evt) {
	                model.available = angular.copy(defaultAvailableReportsList()); // update available reports
	                // close edit pane and remove incomplete form (if removing current open one)
	            }
	        };
	
	        model.editReport = function (index) {
	            // turn on edit mode
	            model.reportsEditMode = true;
	            // check to see if the report has settings or not
	            if (model.user.settings_global.reports[index].hasOwnProperty('settings')) {
	                // replace our model with that
	                model.reportSettings = angular.copy(model.user.settings_global.reports[index].settings);
	                // delete the settings in list for now
	                delete model.user.settings_global.reports[index].settings;
	            } else {
	                // add default fields to our form
	                model.reportSettings = angular.copy(defaultReportSettings());
	            }
	        };
	        model.saveReportEdit = function (form) {
	            if (!form.$valid) {
	                return;
	            } // return if form is not valid
	            var fields = angular.copy(model.reportSettings);
	            for (var i = 0, len = model.user.settings_global.reports.length; i < len; i++) {
	                if (!model.user.settings_global.reports[i].hasOwnProperty('settings')) {
	                    model.user.settings_global.reports[i].settings = fields; // assign the fields to the reports settings
	                    continue; // end loop
	                }
	            }
	            var reports = angular.copy(model.user.settings_global.reports);
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/users/reports',
	                data: {
	                    reports: reports
	                }
	            }).success(function (token) {
	                // reset form
	                if (form) {
	                    form.$setPristine();
	                    form.$setUntouched();
	                }
	                // delete old token
	                delete $window.sessionStorage.token;
	                // set new token
	                $window.sessionStorage.token = token;
	                // assingn the new report settings to the static user obj
	                user.settings_global.reports = reports;
	                $scope.global.user.settings_global.reports = reports;
	                // add settings obj to the selected report
	                model.reportsEditMode = false;
	                model.reportSettings = defaultReportSettings();
	            });
	        };
	        model.deleteReport = function (index) {
	            var c = confirm("Are you sure you want to delete this report?");
	            if (c) {
	                // now remove the item and save
	                model.user.settings_global.reports.splice(index, 1); // remove item
	                var reports = angular.copy(model.user.settings_global.reports);
	                $http({
	                    method: 'POST',
	                    url: ("https://api-demo.mantix4.com") + '/api/users/reports',
	                    data: {
	                        reports: reports
	                    }
	                }).success(function (token) {
	                    // delete old token
	                    delete $window.sessionStorage.token;
	                    // set new token
	                    $window.sessionStorage.token = token;
	                    // assingn the new report settings to the static user obj
	                    user.settings_global.reports = reports;
	                    $scope.global.user.settings_global.reports = reports;
	                    // add settings obj to the selected report
	                    model.reportsEditMode = false;
	                    model.reportSettings = defaultReportSettings();
	                });
	            }
	        };
	        model.closeReportEdit = function (form) {
	            // reset form
	            if (form) {
	                form.$setPristine();
	                form.$setUntouched();
	            }
	            // crude check to see if the settings are default
	            var isdefault = false;
	            for (var i in model.reportSettings) {
	                if (!model.reportSettings[i]) {
	                    isdefault = true;
	                }
	            }
	            // find the report with no assigned settings and remove it from the list
	            for (var _i = 0, len = model.user.settings_global.reports.length; _i < len; _i++) {
	                if (!model.user.settings_global.reports[_i].hasOwnProperty('settings')) {
	                    if (isdefault) {
	                        // remove item
	                        model.user.settings_global.reports.splice(_i, 1); // remove item
	                    }
	                    continue; // break loop
	                }
	            }
	
	            // return edit mode to false
	            model.reportsEditMode = false;
	            model.available = angular.copy(defaultAvailableReportsList()); // update available reports
	        };
	        ///////////
	        // TAB 4 //
	        ////////////
	        // ALERTS //
	        ////////////
	        model.isActive = function () {
	            var result = false;
	            if (model.user.settings_global.alerts.lvl4 || model.user.settings_global.alerts.lvl3 || model.user.settings_global.alerts.lvl2 || model.user.settings_global.alerts.lvl1) {
	                result = true;
	            }
	            if (user.settings_global.stealth && model.user.settings_global.alerts.stealth) {
	                result = true;
	            }
	            return result;
	        };
	        model.alertChange = function () {
	            var result = false;
	            if (model.user.settings_global.alerts.frequency !== user.settings_global.alerts.frequency || !model.user.settings_global.alerts.frequency) {
	                result = true;
	            }
	            return result;
	        };
	        model.alertSubmit = function (form) {
	            model.error = false; // kill any error messages
	            if (!model.isActive() || form.$valid) {
	                // else remove the user's key and mark disabled
	                $http({
	                    method: 'POST',
	                    url: ("https://api-demo.mantix4.com") + '/api/users/alerts',
	                    data: {
	                        alerts: angular.copy(model.user.settings_global.alerts)
	                    }
	                }).success(function (token) {
	                    // delete old token
	                    delete $window.sessionStorage.token;
	                    // set new token
	                    $window.sessionStorage.token = token;
	                    // assingn the new report settings to the static user obj
	                    user.settings_global.alerts = angular.copy(model.user.settings_global.alerts);
	                });
	            }
	        };
	
	        // modal config
	        ngDialog.open({
	            template: __webpack_require__(672),
	            plain: true,
	            appendTo: ['.page-content', '.map-container'],
	            scope: model,
	            preCloseCallback: function preCloseCallback() {
	                // use the doneEdit function since it already checks for changes
	                // model.doneEdit();
	            }
	        });
	    };
	    ////////////////////////////
	    //// DATABASE SWITCHING ////
	    ////////////////////////////
	
	
	    ////////////////////////////
	    //// OTHER HEADER STUFF ////
	    ////////////////////////////
	    $scope.logout = function () {
	        ngDialog.close();
	        delete $window.sessionStorage.token;
	        $location.url('/login');
	    };
	    // this is being used for the home button right now
	    $scope.go = function (path) {
	        var search = {};
	        if ($location.$$search.start && $location.$$search.end) {
	            search.start = $location.$$search.start;
	            search.end = $location.$$search.end;
	        }
	        if (path === '/manage_users' || path === '/manage_feeds') {
	            $location.url(path);
	        } else if ($window.location.pathname === '/live' && path === '/') {
	            // reload inbound_ioc only if on home and logo is clicked
	            $window.location.reload();
	        } else {
	            $window.location.assign('/live');
	        }
	    };
	}
	
	ctrl.$inject = ['$scope', '$rootScope', 'Global', '$location', '$http', '$state', '$window', 'timeFormat', 'ngDialog'];
	module.exports = ctrl;

/***/ },
/* 672 */
/***/ function(module, exports) {

	module.exports = "<div class=\"user-settings-modal\">\n    <div class=\"modal-header\">\n        <h3>User settings</h3> <div class=\"alert alert-danger animated fadeIn\" ng-show=\"error\">{{error}}</div>\n    </div>\n    <div class=\"modal-body\">\n        <tabset>\n            <tab>\n                <tab-heading>\n                    General Settings\n                </tab-heading>\n                <div class=\"tab-inner\">\n                    <form name=\"emailForm\" class=\"form-horizontal\" ng-submit=\"emailEditModeToggle(emailForm)\" novalidate>\n                        <!-- EMAIL -->\n                        <div class=\"control-group\" ng-class=\"{ 'has-error' : emailForm.email.$invalid && !emailForm.email.$pristine }\">\n                            <label class=\"control-label\">Email *</label>\n                            <div class=\"controls\">\n                                <input ng-disabled=\"!emailEditMode\" type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"user.email\">\n                                <i ng-click=\"emailEditModeToggle(emailForm)\" ng-class=\"emailEditMode ? 'fa fa-check': 'fa fa-cog'\"></i>\n                                <i ng-show=\"emailEditMode\" ng-click=\"emailEditModeCancel()\" class=\"fa fa-ban\"></i>\n                                <p ng-show=\"emailForm.email.$invalid && !emailForm.email.$pristine\" class=\"help-block\">Enter a valid email.</p>\n                            </div>\n                        </div>\n                    </form>\n                    <hr>\n                    <!-- NEW PASSWORD -->\n                    <form name=\"passwordForm\" class=\"form-horizontal\" ng-submit=\"submitPassword(passwordForm)\" novalidate>\n                        <div class=\"control-group\" ng-class=\"{ 'has-error' : passwordForm.password.$invalid }\">\n                            <label class=\"control-label\">New Password</label>\n                            <div class=\"controls\">\n                                <input type=\"password\" name=\"password\" class=\"form-control\" placeholder=\"New Password\" ng-model=\"user.password\" ng-minlength=\"8\" ng-maxlength=\"100\">\n                                <p ng-show=\"passwordForm.password.$error.minlength\" class=\"help-block\">Password is too short.</p>\n                                <p ng-show=\"passwordForm.password.$error.maxlength\" class=\"help-block\">Password is too long.</p>\n                            </div>\n                        </div>\n                        <div class=\"control-group\" ng-class=\"{ 'has-error' : passwordForm.cpassword.$viewValue != passwordForm.password.$viewValue }\">\n                            <label class=\"control-label\">Repeat Password</label>\n                            <div class=\"controls\">\n                                <input type=\"password\" name=\"cpassword\" class=\"form-control\" placeholder=\"Repeat password\" ng-model=\"user.cpassword\" ng-minlength=\"8\" ng-maxlength=\"100\">\n                                <p ng-show=\" passwordForm.cpassword.$viewValue != passwordForm.password.$viewValue\" class=\"help-block\">Passwords do not match</p>\n                            </div>\n                        </div>\n\n                        <div class=\"control-group\">\n                            <div class=\"controls\">\n                                <button type=\"submit\" class=\"pure-button\">Change password</button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </tab>\n            <tab>\n                <tab-heading>\n                    2 Step Authentication\n                </tab-heading>\n                <div class=\"tab-inner\">\n                    <form name=\"authForm\" class=\"form-horizontal\" ng-submit=\"submit2Auth(authForm)\" novalidate>\n                        <div class=\"control-group\">\n                            <label class=\"control-label\">Two Step Authentication</label>\n                            <div class=\"controls\">\n                                <div class=\"checkBox-slider\">\n                                    <input type=\"checkbox\" name=\"switch\" class=\"switch\" ng-model=\"twoFactorSwitch\" ng-checked=\"twoFactorSwitch\" />\n                                    <label for=\"switch\" class=\"label\"></label>\n                                    <label ng-class=\"{'greenLabel': twoFactorSwitch}\"><input type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"twoFactorSwitch\" ng-change=\"toggleTwoFactorConfig(twoFactorSwitch)\" ng-checked=\"twoFactorSwitch\" /><span>&nbsp;</span></label>\n                                </div>\n                                <br />\n                            </div>\n                            <div ng-show=\"(twoFactorSwitch && (!user.two_step_auth_set))\">\n                                <div class=\"control-group\">\n                                    <label class=\"control-label\">2-step QR code</label>\n                                    <div ng-if=\"otpurl\" class=\"controls\"><qr-code stle=\"width:300px;height:300px\" code=\"{{otpurl}}\"></qr-code></div>\n                                </div>\n                                <div class=\"control-group\" ng-class=\"{ 'has-error' : authForm.verify.$invalid }\">\n                                    <label class=\"control-label\">Verify 2-step</label>\n                                    <div class=\"controls\">\n                                        <input type=\"verify\" required name=\"verify\" class=\"form-control\" placeholder=\"Confirm 6 digit code\" ng-model=\"otpverify\" ng-minlength=\"6\" ng-maxlength=\"6\">\n                                        <p ng-show=\"authForm.verify.$error.minlength\" class=\"help-block\">code is too short.</p>\n                                        <p ng-show=\"authForm.verify.$error.maxlength\" class=\"help-block\">code is too long.</p>\n                                    </div>\n                                </div>\n                                <div class=\"control-group\">\n                                    <div class=\"controls\">\n                                        <button type=\"submit\" ng-click=\"twoFactorSubmit(authForm)\" class=\"pure-button\">Submit</button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </tab>\n            <tab>\n                <tab-heading>\n                    Reports\n                </tab-heading>\n                <div class=\"row-fluid report-columns\">\n                    <div class=\"span4 available\">\n                        <h4>Available Reports</h4>\n                        <ul ng-sortable=\"{\n                            group: 'reportsGroup',\n                            animation: 150,\n                            sort: false,\n                            disabled: reportsEditMode }\">\n                            <li ng-repeat=\"item in available | filter: checkForOneReport\" ng-class=\"reportsEditMode ? '': 'pointer'\">{{item.title}}</li>\n                        </ul>\n                    </div>\n                    <div class=\"span4 current\">\n                        <h4>Current Reports</h4>\n                        <ul ng-sortable=\"currentConfig\">\n                            <li ng-repeat=\"(key, item) in user.settings_global.reports\" ng-class=\"(item.hasOwnProperty('settings')) ? 'pointer' : 'active-edit'\">{{item.title}}\n                            <span class=\"test\">\n                                <i ng-click=\"editReport(key)\" ng-class=\"reportsEditMode ? '': 'fa fa-cog'\"></i>\n                                <i ng-click=\"deleteReport(key)\" ng-class=\"reportsEditMode ? '': 'fa fa-times'\"></i> </li>\n                            </span>\n                        </ul>\n                    </div>\n                    <div class=\"span4\" ng-show=\"reportsEditMode\">\n                        <h4>Edit</h4>\n                        <div class=\"editcolumn\">\n                            <form name=\"reportsEditForm\" novalidate>\n                                Daily report time *\n                                <br />\n                                <div>\n                                    <select required ng-model=\"reportSettings.hour\" style=\"width:50%; float:left\" name=\"hour\">\n                                        <option value=\"\"></option>\n                                        <option value=\"0000\">12:00</option>\n                                        <option value=\"0030\">12:30</option>\n                                        <option value=\"0100\">1:00</option>\n                                        <option value=\"0130\">1:30</option>\n                                        <option value=\"0200\">2:00</option>\n                                        <option value=\"0230\">2:30</option>\n                                        <option value=\"0300\">3:00</option>\n                                        <option value=\"0330\">3:30</option>\n                                        <option value=\"0400\">4:00</option>\n                                        <option value=\"0430\">4:30</option>\n                                        <option value=\"0500\">5:00</option>\n                                        <option value=\"0530\">5:30</option>\n                                        <option value=\"0600\">6:00</option>\n                                        <option value=\"0630\">6:30</option>\n                                        <option value=\"0700\">7:00</option>\n                                        <option value=\"0730\">7:30</option>\n                                        <option value=\"0800\">8:00</option>\n                                        <option value=\"0830\">8:30</option>\n                                        <option value=\"0900\">9:00</option>\n                                        <option value=\"0930\">9:30</option>\n                                        <option value=\"0100\">10:00</option>\n                                        <option value=\"1030\">10:30</option>\n                                        <option value=\"1100\">11:00</option>\n                                        <option value=\"1130\">11:30</option>\n                                    </select>\n                                    <select required ng-model=\"reportSettings.ampm\" style=\"width:50%; float:left\" name=\"ampm\">\n                                        <option value=\"\"></option>\n                                        <option value=\"am\">AM</option>\n                                        <option value=\"pm\">PM</option>\n                                    </select>\n                                    <p ng-show=\"((reportsEditForm.hour.$invalid && reportsEditForm.hour.$dirty) || (reportsEditForm.ampm.$invalid && reportsEditForm.ampm.$dirty))\" style=\"margin-bottom:0\" class=\"help-block\">Both time fields are required.</p>\n                                </div>\n                                <br />\n                                <p ng-show=\"reportsEditForm.day.$invalid && reportsEditForm.day.$dirty\" class=\"help-block\">Starting day is required.</p>\n                                <button ng-click=\"saveReportEdit(reportsEditForm)\" class=\"pure-button button-success\"> Save </button>\n                                <button ng-click=\"closeReportEdit(reportsEditForm)\" class=\"pure-button button-error\"> Close </button>\n                            </form>\n                        </div>\n                    </div>\n                </div>\n            </tab>\n            <tab>\n                <tab-heading>\n                    Alerts\n                </tab-heading>\n                <div class=\"tab-inner\">\n                    <form name=\"alertForm\" class=\"form-horizontal\" ng-submit=\"alertSubmit(alertForm)\" novalidate>\n                        <div class=\"control-group\" >\n                            <label class=\"control-label\">IOC Severity (level 4)</label>\n                            <div class=\"controls\">\n                                <div class=\"checkBox-slider\">\n                                    <input type=\"checkbox\" name=\"switch\" class=\"switch\" ng-model=\"user.settings_global.alerts.lvl4\" ng-checked=\"user.settings_global.alerts.lvl4\" />\n                                    <label for=\"switch\" class=\"label\"></label>\n                                    <label ng-class=\"{'greenLabel': user.settings_global.alerts.lvl4}\"><input type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"user.settings_global.alerts.lvl4\" ng-change=\"alertSubmit(alertForm)\" ng-checked=\"user.settings_global.alerts.lvl4\" /><span>&nbsp;</span></label>\n                                </div>\n                            </div>\n                            <br />\n                            <label class=\"control-label\">IOC Severity (level 3)</label>\n                            <div class=\"controls\">\n                                <div class=\"checkBox-slider\">\n                                    <input type=\"checkbox\" name=\"switch\" class=\"switch\" ng-model=\"user.settings_global.alerts.lvl3\" ng-checked=\"user.settings_global.alerts.lvl3\" />\n                                    <label for=\"switch\" class=\"label\"></label>\n                                    <label ng-class=\"{'greenLabel': user.settings_global.alerts.lvl3}\"><input type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"user.settings_global.alerts.lvl3\" ng-change=\"alertSubmit(alertForm)\" ng-checked=\"user.settings_global.alerts.lvl3\" /><span>&nbsp;</span></label>\n                                </div>\n                            </div>\n                            <br />\n                            <label class=\"control-label\">IOC Severity (level 2)</label>\n                            <div class=\"controls\">\n                                <div class=\"checkBox-slider\">\n                                    <input type=\"checkbox\" name=\"switch\" class=\"switch\" ng-model=\"user.settings_global.alerts.lvl2\" ng-checked=\"user.settings_global.alerts.lvl2\" />\n                                    <label for=\"switch\" class=\"label\"></label>\n                                    <label ng-class=\"{'greenLabel': user.settings_global.alerts.lvl2}\"><input type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"user.settings_global.alerts.lvl2\" ng-change=\"alertSubmit(alertForm)\" ng-checked=\"user.settings_global.alerts.lvl2\" /><span>&nbsp;</span></label>\n                                </div>\n                            </div>\n                            <br />\n                            <label class=\"control-label\">IOC Severity (level 1)</label>\n                            <div class=\"controls\">\n                                <div class=\"checkBox-slider\">\n                                    <input type=\"checkbox\" name=\"switch\" class=\"switch\" ng-model=\"user.settings_global.alerts.lvl1\" ng-checked=\"user.settings_global.alerts.lvl1\" />\n                                    <label for=\"switch\" class=\"label\"></label>\n                                    <label ng-class=\"{'greenLabel': user.settings_global.alerts.lvl1}\"><input type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"user.settings_global.alerts.lvl1\" ng-change=\"alertSubmit(alertForm)\" ng-checked=\"user.settings_global.alerts.lvl1\" /><span>&nbsp;</span></label>\n                                </div>\n                            </div>\n                            <br />\n                            <span ng-show=\"global.user.settings_global.stealth\">\n                                <label class=\"control-label\">Stealth User IOC</label>\n                                <div class=\"controls\">\n                                    <div class=\"checkBox-slider\">\n                                        <input type=\"checkbox\" name=\"switch\" class=\"switch\" ng-model=\"user.settings_global.alerts.stealth\" ng-checked=\"user.settings_global.alerts.stealth\" />\n                                        <label for=\"switch\" class=\"label\"></label>\n                                        <label ng-class=\"{'greenLabel': user.settings_global.alerts.stealth}\"><input type=\"checkbox\" name=\"switch\" id=\"switch\" ng-model=\"user.settings_global.alerts.stealth\" ng-change=\"alertSubmit(alertForm)\" ng-checked=\"user.settings_global.alerts.stealth\" /><span>&nbsp;</span></label>\n                                    </div>\n                                </div>\n                                <br />\n                            </span>\n                            <div ng-show=\"isActive()\">\n                                <label class=\"control-label\">Maximum Frequency*</label>\n                                <div class=\"controls\">\n                                    <select required ng-model=\"user.settings_global.alerts.frequency\" name=\"frequency\">\n                                        <option value=\"60\">Once a minute</option>\n                                        <option value=\"3600\">Once an hour</option>\n                                        <option value=\"86400\">Once a day</option>\n                                    </select>\n                                    <p ng-show=\"alertForm.frequency.$invalid && !alertForm.frequency.$dirty\" class=\"help-block\">Please select a max alert frequency.</p>\n                                </div>\n                                <br />\n                                <div ng-show=\"alertChange()\" class=\"control-group\">\n                                    <div class=\"controls\">\n                                        <button type=\"submit\" class=\"pure-button\">Save</button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </tab>\n        </tabset>\n    </div>\n</div>";

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, $location, $state) {
	    $scope.global = Global;
	    $scope.select = function (url) {
	        if (url && url !== $location.$$url.replace('/', '')) {
	            $scope.main.cleanup().then(function () {
	                if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
	                    // copy the time and strip out any other vars when clicking sidebar items
	                    var time = angular.copy({ start: $location.$$search.start, end: $location.$$search.end });
	                    $location.path(url).search(time);
	                } else {
	                    $location.path(url).search({});
	                }
	            });
	        }
	    };
	    // this function allows us to hide sidebar elements based on what is defined in the sidebar array
	    $scope.display = function (node) {
	        var show = true;
	        if (node.hasOwnProperty("hideAccess")) {
	            show = node.hideAccess;
	        }
	        return show;
	    };
	    // Removed parentClass and updated nodeClass methods because I really hate hardcoded crap. Juan
	    $scope.nodeClass = function (node) {
	        var hasParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var currentUrl = $location.path().substring(1) || 'home';
	        var hasChildren = node.hasOwnProperty("children");
	
	        var containsUrl = function containsUrl() {
	            var curr_node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : node;
	
	            if (curr_node.url == currentUrl) return true;
	
	            if (curr_node.hasOwnProperty("orphans")) {
	                for (var _i = 0, _len = curr_node.orphans.length; _i < _len; _i++) {
	                    if (curr_node.orphans[_i] == currentUrl) return true;
	                }
	            }
	
	            if (curr_node.hasOwnProperty("children")) {
	                for (var _i2 = 0, _len2 = curr_node.children.length; _i2 < _len2; _i2++) {
	                    if (containsUrl(curr_node.children[_i2])) return true;
	                }
	            }
	
	            return false;
	        };
	
	        if (containsUrl()) {
	            if (!hasParent && !hasChildren) return "start active";
	
	            if (!hasParent && hasChildren) return "start active open";
	
	            if (hasParent && hasChildren) return "active open";
	
	            if (hasParent && !hasChildren) return "active";
	        }
	
	        return "";
	    };
	
	    $scope.parentClassSelected = function (page) {
	        var currentRoute = $location.path().substring(1) || 'home';
	
	        return page === currentRoute ? 'selected' : '';
	    };
	
	    $scope.stealthLogo = function (link) {
	        var currentRoute = $location.path().substring(1) || 'home';
	        var url = __webpack_require__(674);
	        if (link.children.length > 0) {
	            for (var i = 0, len = link.children.length; i < len; i++) {
	                if (link.children[i].url === currentRoute) {
	                    url = __webpack_require__(675);
	                }
	            };
	        }
	        return url;
	    };
	    ////////////////////////
	    //// SUPPORT BUTTON ////
	    ////////////////////////
	    // even thought the support button is in the footer
	    $scope.openSupportModal = function () {
	        location.href = "mailto:support@mantix4.com?Subject=Website Support Request";
	    };
	
	    var sideBarItems = [{ // IOC NOTIFICATIONS
	        'title': 'IOC Notifications',
	        'url': false,
	        'icon': 'fa-warning',
	        'children': [{
	            'title': 'Outbound IOC',
	            'url': 'outbound_ioc',
	            'icon': 'fa-warning'
	            // 'hideAccess': [1], // if you'd like to limit access to a specific child instead
	        }, {
	            'title': 'Inbound IOC',
	            'url': 'inbound_ioc',
	            'icon': 'fa-warning'
	            // 'hideAccess': [1], // if you'd like to limit access to a specific child instead
	        }, {
	            'title': 'Lateral IOC',
	            'url': 'lateral_ioc',
	            'icon': 'fa-warning'
	            // 'hideAccess': [1], // if you'd like to limit access to a specific child instead
	        },
	        /*
	                      {
	                          'title': 'Custom IOC',
	                          'url': 'custom_ioc',
	                          'iconreplace': true,
	                          'icon': 'fa-blacklist'
	                      },
	                      {
	                          'title': 'Whitelist',
	                          'url': 'whitelist',
	                          'iconreplace': true,
	                          'icon': 'fa-whitelist'
	                      },
	        */
	        // {
	        //     'title': 'IOC Feeds',
	        //     'url': 'ioc_feeds',
	        //     'iconreplace': true,
	        //     'icon': 'fa-blacklist'
	        // },
	        {
	            'title': 'AD Events',
	            'url': 'ad_events',
	            'hideAccess': $scope.global.user.settings_global.active_defense,
	            'iconreplace': true,
	            'icon': 'fa-active-defense',
	            'orphans': ['ad_events_drill'] /*,
	                                           {
	                                              'title': 'cyr3con',
	                                              'url': 'cyr3con',
	                                              'hideAccess': $scope.global.user.settings_global.cyr3con,
	                                              'icon': 'fa-warning'
	                                           }*/
	        }]
	    }, { // Threat Hunting.
	        'title': 'Threat Hunting',
	        'hideAccess': $scope.global.user.settings_global.threat_hunting,
	        'url': false,
	        'icon': 'fa-eye',
	        'children': [
	        // Hide Hybrid Alerts until the page is finished
	        // {
	        //     'title': 'Hybrid Alerts',
	        //     'url': 'hybrid_alerts',
	        //     'icon': 'fa-exchange'
	        // },
	        /*{
	            'title': 'Attack Detection',
	            'url': false,
	            'iconreplace': true,
	            'icon': 'fa-active-defense',
	            'children': []
	        },*/
	        { // ANOMALIES
	            'title': 'Anomalies',
	            'url': false,
	            'icon': 'fa-asterisk',
	            'children': [
	            // {
	            //     'title': 'New Local IPs',
	            //     'url': 'new_local_ip',
	            //     'icon': 'fa-exchange',
	            //     'orphans': []
	            // },
	            // {
	            //     'title': 'New Local MAC',
	            //     'url': 'new_local_mac',
	            //     'icon': 'fa-exchange',
	            //     'orphans': []
	            // },
	            {
	                'title': 'New Remote IPs',
	                'url': 'new_remote',
	                'icon': 'fa-exchange'
	            }, {
	                'title': 'New DNS Queries',
	                'url': 'new_dns_queries',
	                'icon': 'fa-info-circle'
	            }, {
	                'title': 'New HTTP Domains',
	                'url': 'new_http_domains',
	                'icon': 'fa-globe'
	            }, {
	                'title': 'New SSL Server Names',
	                'url': 'new_ssl_hosts',
	                'icon': 'fa-lock'
	            }, {
	                'title': 'New SSH Resp IPs',
	                'url': 'new_ssh_remote',
	                'icon': 'fa-lock'
	            }, {
	                'title': 'New FTP Resp IPs',
	                'url': 'new_ftp_remote',
	                'icon': 'fa-lock'
	            }]
	        }, {
	            'title': 'Tunnel Detection',
	            'url': false,
	            'icon': 'fa-exchange',
	            'children': [{
	                'title': 'Long Duration Conns',
	                'url': 'long_duration_conns',
	                'icon': 'fa-clock-o'
	            }, {
	                'title': 'DNS Exfil (UDP Tunnels)',
	                'url': 'dns_exfil_udp_tunnels',
	                'icon': 'fa-exchange'
	            }]
	        }, {
	            'title': 'Command & Control',
	            'url': false,
	            'icon': 'fa-desktop',
	            'children': [{
	                'title': 'Subdomain Stacking',
	                'url': 'dns_exfil_subdomains',
	                'icon': 'fa-globe'
	            }, {
	                'title': 'Large HTTP Responses',
	                'url': 'large_http_responses',
	                'icon': 'fa-download' /*,
	                                      {
	                                         'title': 'HTTP Beacons',
	                                         'url': 'http_beacons',
	                                         'iconreplace': true,
	                                         'icon': 'icon-broadcast'
	                                      },
	                                      {
	                                         'title': 'DNS Beacons',
	                                         'url': 'dns_beacons',
	                                         'iconreplace': true,
	                                         'icon': 'icon-broadcast'
	                                      }*/
	            }]
	        }, {
	            'title': 'Suspicious Hosts',
	            'url': false,
	            'icon': 'fa-search',
	            'children': [
	            /*{
	                'title': 'Kaminsky DNS Attack',
	                'url': 'dns_poisoning',
	                'iconreplace': true,
	                'icon': 'fa-active-defense'
	            },*/
	            {
	                'title': 'Failed SSL Certificates',
	                'url': 'ssl_certs',
	                'icon': 'fa-lock'
	            }, {
	                'title': 'Top Internal Producers',
	                'url': 'top_internal_producers',
	                'icon': 'fa-info-circle'
	            }, {
	                'title': 'Non-Standard HTTP',
	                'url': 'non_standard_http',
	                'icon': 'fa-sitemap'
	            }, {
	                'title': 'User-Agents (HTTP)',
	                'url': 'user_agents',
	                'icon': 'fa-user'
	            }]
	        }, {
	            'title': 'Statistics',
	            'url': false,
	            'icon': 'fa-bar-chart-o',
	            'children': [{
	                'title': 'Top Responder Ports',
	                'url': 'top_responder_ports',
	                'icon': 'fa-bar-chart-o'
	            }, {
	                'title': 'Top Referred Hosts',
	                'url': 'top_referred_hosts',
	                'icon': 'fa-bar-chart-o'
	            }, {
	                'title': 'Most Popular Sites',
	                'url': 'most_popular_sites',
	                'icon': 'fa-bar-chart-o'
	            }, {
	                'title': 'Services Breakdown',
	                'url': 'services_breakdown',
	                'icon': 'fa-list-alt'
	            }]
	        }]
	    }, { // GENERAL NETWORK
	        'title': 'General Network',
	        'url': false,
	        'icon': 'fa-sitemap',
	        'children': [{
	            'title': 'Outbound Connections',
	            'url': 'outbound_resp_country',
	            'icon': 'fa-cloud-upload',
	            'orphans': ['outbound_resp', 'outbound_orig']
	        }, {
	            'title': 'Inbound Connections',
	            'url': 'inbound_resp',
	            'icon': 'fa-cloud-download',
	            'orphans': ['inbound_orig_country', 'inbound_orig']
	        }, {
	            'title': 'Lateral Connections',
	            'url': 'lateral_resp',
	            'icon': 'fa-cloud-upload',
	            'orphans': ['lateral_orig']
	        }, {
	            'title': 'Lateral Map',
	            'hideAccess': $scope.global.user.settings_global.network_map,
	            'url': 'lateral_map',
	            'icon': 'fa-code-fork'
	        }, {
	            'title': 'Services Map',
	            'url': 'services',
	            'icon': 'fa-code-fork',
	            'orphans': ['services']
	        }, {
	            'title': 'Network Assets',
	            'url': 'network_assets',
	            'icon': 'fa-user'
	        }]
	    }, { // STEALTH
	        'title': 'Stealth',
	        'hideAccess': $scope.global.user.settings_global.stealth,
	        'url': false,
	        'icon': 'fa-shield',
	        'children': [{
	            'title': 'Stealth Deploy Config',
	            'url': 'stealth_deploy_config',
	            'icon': 'fa-code-fork'
	        }, {
	            'title': 'Stealth Ops View',
	            'url': 'stealth_op_view',
	            'icon': 'fa-shield'
	        }, {
	            'title': 'Stealth User Connections',
	            'url': 'stealth_conn',
	            'icon': 'fa-user',
	            'orphans': ['stealth_conn_orig']
	        }, {
	            'title': 'Stealth Events',
	            'url': 'stealth_events',
	            'icon': 'fa-desktop',
	            'orphans': ['stealth_events_orig']
	        }]
	    }, { // APPLICATIONS
	        'title': 'Applications',
	        'url': false,
	        'icon': 'fa-bars',
	        'children': [{
	            'title': 'L7 Applications',
	            'url': 'app_by_l7',
	            'icon': 'fa-bars',
	            'orphans': ['app_by_l7_resp', 'app_by_l7_resp_orig']
	        }, {
	            'title': 'DNS by Resolver',
	            'url': 'dns_by_resolver',
	            'icon': 'fa-level-down',
	            'orphans': ['dns_by_resolver_type', 'dns_by_type_resp_orig']
	        }, {
	            'title': 'DNS by Query Type',
	            'url': 'dns_by_type',
	            'icon': 'fa-level-down',
	            'orphans': ['dns_by_type_resp', 'dns_by_type_resp_orig']
	        }, {
	            'title': 'HTTP By Domain',
	            'url': 'http_by_domain',
	            'icon': 'fa-globe',
	            'orphans': ['http_by_domain_sub', 'http_by_domain_uri']
	        }, {
	            'title': 'SSL Server Name',
	            'url': 'ssl_by_server',
	            'icon': 'fa-lock',
	            'orphans': ['ssl_by_server_name', 'ssl_by_server_name_orig']
	        }, {
	            'title': 'FTP By Responder',
	            'url': 'ftp_resp',
	            'icon': 'fa-file',
	            'orphans': ['ftp_resp_orig']
	        }, {
	            'title': 'SSH Status',
	            'url': 'ssh_status',
	            'icon': 'fa-chevron-right',
	            'orphans': ['ssh_status_resp', 'ssh_status_resp_orig']
	        }]
	    }, { // FILES
	        'title': 'Files Seen',
	        'url': false,
	        'icon': 'fa-folder',
	        'children': [{
	            'title': 'Files By MIME',
	            'url': 'files_by_mime',
	            'icon': 'fa-folder-open',
	            'orphans': ['files_by_mime_type', 'files_by_mime_type_filename']
	        }]
	    }, { // SYSTEM EVENTS
	        'title': 'System Events',
	        'hideAccess': $scope.global.user.settings_global.system_events,
	        'url': false,
	        'icon': 'fa-user',
	        'children': [{
	            'title': 'Endpoint By Type',
	            'url': 'endpoint_by_type',
	            'icon': 'fa-desktop',
	            'orphans': ['endpoint_by_type_and_user']
	        }, {
	            'title': 'Endpoint By Host',
	            'url': 'endpoint_by_user',
	            'icon': 'fa-desktop',
	            'orphans': ['endpoint_by_user_and_type']
	        }, {
	            'title': 'MS Events',
	            'url': 'endpoint_events_sharepoint',
	            'icon': 'fa-desktop',
	            'orphans': ['endpoint_events_sharepoint_drill']
	        }]
	    }, { // SEARCH
	        'title': 'Search',
	        'url': 'search',
	        'icon': 'fa-search'
	    }];
	    // if user is kiosk, simply remove all items from the sidebar that are not summary or the ioc_notifications
	    if ($scope.global.user.user_level === 'kiosk') {
	        var newList = [];
	        for (var i = 0, len = sideBarItems.length; i < len; i++) {
	            if (sideBarItems[i].title === 'IOC Notifications' || sideBarItems[i].title === 'Live Connections Dash') {
	                newList.push(sideBarItems[i]);
	            }
	        }
	        sideBarItems = newList;
	    }
	    $scope.sideBarItems = sideBarItems;
	};
	
	ctrl.$inject = ['$scope', 'Global', '$location', '$state'];
	module.exports = ctrl;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e9e56e7c36c10de8c73d8e4cd7fb41fd.png";

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "dc14fe432731181bdfef29e908b8720e.png";

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(crossfilter) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function ctrl($scope, generateId, $q, $http, fetchStream, $stateParams, $location, $window) {
	    var model = this; // used to assign functions and methods to master controller
	    // DEFAULT VARIABLES
	    var updateInterval = 60000; // used with the update timer
	    model.searchCategories = {}; // holds dropdown search modifiers
	    var defaultDayRange = 1;
	    model.manualSearch = false;
	
	    model.safeApply = function (fn) {
	        var phase = $scope.$root.$$phase;
	        if (phase == '$apply' || phase == '$digest') {
	            if (fn && typeof fn === 'function') {
	                fn();
	            }
	        } else {
	            $scope.$apply(fn);
	        }
	    };
	
	    //////////////////////////////////////////////////////////////////////////////////////////////
	    // THIS IS THE CONTROLLER FOR THE MAIN MASTER WRAPPER. BELOW ARE METHODS THAT FUCK SHIT UP. //
	    //////////////////////////////////////////////////////////////////////////////////////////////
	
	    //////////////////////////
	    ///////    TIME    ///////
	    //////////////////////////
	    // by default we'll set the time to to the default day range
	    model.time = {
	        start: Math.round(new Date().getTime() / 1000) - 3600 * 24 * defaultDayRange,
	        end: Math.round(new Date().getTime() / 1000)
	    };
	    model.getTime = function () {
	        var t = void 0;
	        if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
	            t = {
	                start: $location.$$search.start,
	                end: $location.$$search.end
	            };
	        } else {
	            t = model.time;
	        }
	        return t;
	    };
	    model.setTime = function (newTime) {
	        return $q(function (resolve, reject) {
	            // do nothing if the new time doesnt have start or end
	            if (!newTime.hasOwnProperty('start') && !newTime.hasOwnProperty('end')) {
	                return reject();
	            }
	            model.time.start = newTime.start;
	            model.time.end = newTime.end;
	            return resolve(Object.create(model.time));
	            // return resolve({start: Object.create(model.time).start, end: Object.create(model.time).end});
	        });
	    };
	    model.rollTime = function (miliseconds) {
	        // NOTE: values in our time object is rounded so the value inputed may need to be shorter
	        return $q(function (resolve) {
	            var oldTime = Object.create(model.getTime());
	            var newTime = {
	                start: oldTime.start + miliseconds / 1000,
	                end: oldTime.end + miliseconds / 1000
	            };
	            model.setTime(newTime);
	            return resolve({ current: newTime, old: oldTime });
	        });
	    };
	
	    //////////////////////////////
	    ///////    UPDATING    ///////
	    //////////////////////////////
	    // dimension and group builder
	    model.buildDimGroup = function (rows, identifiers) {
	        var deferred = $q.defer();
	        // stop if there is no grouping defined in the settings
	        if (!model.dataObjects[identifiers.key].settings) {
	            deferred.reject();
	        } else if (!model.dataObjects[identifiers.key].settings.hasOwnProperty('grouping')) {
	            deferred.reject();
	        } else if (rows.length > 0) {
	            var run = function run(callback) {
	                // set values that dont get reduced on
	                var dontReduceOn = ['basic_constraints_path_len', 'bucket', 'cert_count', 'certificate_exponent', 'certificate_key_length', 'certificate_not_valid_after', 'certificate_not_valid_before', 'certificate_version', 'cyrin_confidence', 'cyrin_id', 'cyrin_severity', 'depth', 'desktop_height', 'desktop_width', 'duration', 'events_id', 'first_seen', 'get_bulk_requests', 'get_requests', 'get_responses', 'group', 'hour', 'ioc_alert', 'ioc_child', 'ioc_severity', 'last_seen', 'orig_asn', 'orig_lat', 'orig_long', 'orig_port', 'orig_user', 'p', 'port_num', 'qclass', 'qtype', 'qtype_name', 'rcode', 'reply_code', 'resp_asn', 'resp_lat', 'resp_long', 'resp_port', 'resp_user', 'request_body_len', 'response', 'response_body_len', 'response_to', 'rounded', 'serial', 'set_requests', 'status_code', 'suppress_for', 'till', 'time', 'top_domain', 'trans_depth', 'trans_id', 'type', 'ttls', 'version', 'z'];
	                var initialData = { visible: false };
	                if (_typeof(rows[0]) === 'object') {
	                    for (var c in rows[0]) {
	                        if (rows[0][c] === null || typeof rows[0][c] === "string" || _.isNaN(Number(rows[0][c]))) {
	                            initialData[c] = null;
	                        } else {
	                            initialData[c] = 0;
	                        }
	                    }
	                }
	                // this function compiles our dimension function
	                var compileDim = function compileDim(groupby) {
	                    var dimString = '(function (cfObj) { return cfObj.dimension(function (d) { \n';
	                    dimString += 'return ';
	                    for (var d = 0, dlen = groupby.length; d < dlen; d++) {
	                        dimString += 'd.' + groupby[d];
	                        if (d !== dlen - 1) {
	                            dimString += ' + ';
	                        }
	                    }
	                    dimString += ';\n';
	                    dimString += '}) })\n';
	                    return eval(dimString);
	                };
	                // set the dimension into the settings object for this viz
	                model.dataObjects[identifiers.key].settings.dimension = compileDim(model.dataObjects[identifiers.key].settings.grouping);
	                // compile the actual dimension in crossfilter
	                model.dataObjects[identifiers.key].dimension = model.dataObjects[identifiers.key].settings.dimension(model.dataObjects[identifiers.key].cf);
	                // generate grouping
	                var compileGroup = function compileGroup(initial) {
	                    var groupString = '(function (dimension) { return dimension.group().reduce(\n';
	                    groupString += 'function(p, v) { \n';
	                    groupString += 'if (v.time > p.time) {\n';
	                    groupString += '    p.time = v.time;\n'; // always take newest time
	                    groupString += '} else {\n';
	                    groupString += '    v.time = p.time\n';
	                    groupString += '}\n';
	
	                    for (var g in initial) {
	                        if (g === 'time' || typeof initial[g] !== 'number' || dontReduceOn.indexOf(g) !== -1) {
	                            groupString += 'p.' + g + ' = v.' + g + ';\n';
	                        } else {
	                            groupString += 'p.' + g + ' += v.' + g + ';\n';
	                        }
	                    }
	
	                    groupString += 'p.visible = true;\n';
	                    groupString += 'return p\n';
	                    groupString += '},\n';
	                    groupString += 'function(p, v) { \n';
	                    for (var _g in initial) {
	                        if (_g === 'time' || typeof initial[_g] !== 'number' || dontReduceOn.indexOf(_g) !== -1) {
	                            groupString += 'p.' + _g + ' = v.' + _g + ';\n';
	                        } else {
	                            groupString += 'p.' + _g + ' -= v.' + _g + ';\n';
	                        }
	                    }
	                    groupString += 'if (v.time > p.time) {\n';
	                    groupString += '    p.time = v.time;\n'; // always take newest time
	                    groupString += '}\n';
	                    groupString += 'p.visible = true;\n';
	                    groupString += 'return p\n';
	                    groupString += '},\n';
	                    groupString += 'function(p) { \n';
	                    // groupString += 'if (typeof p === "undefined") { return {} } \n';
	                    groupString += 'return ' + JSON.stringify(initial) + ';\n';
	                    groupString += '}) })\n';
	                    return eval(groupString);
	                };
	                // compile the grouping function
	                model.dataObjects[identifiers.key].settings.group = compileGroup(initialData);
	                // set column spec for refrence when doing searches
	                model.dataObjects[identifiers.key].settings.columnSpec = initialData;
	                // insert grouping tinto crossfilter
	                model.dataObjects[identifiers.key].group = model.dataObjects[identifiers.key].settings.group(model.dataObjects[identifiers.key].dimension);
	                // SPEED / REDRAW SETTINGS for items (mostly tables) that only have id as group
	                if (model.dataObjects[identifiers.key].settings.grouping[0] === 'id' && model.dataObjects[identifiers.key].settings.grouping.length === 1) {
	                    model.dataObjects[identifiers.key].settings.render = { once: true, has: false };
	                }
	                return callback();
	            };
	
	            // set it as launched.. do it right away in case notify comes back sooner and runs this twice
	            model.dataObjects[identifiers.key].launched = true;
	
	            run(function () {
	                return deferred.resolve();
	            });
	        }
	        return deferred.promise;
	    };
	    // updates the data in a visual using the main url in settings and also takes a param for specific time
	    var updateData = function updateData(time, options) {
	        var deferred = $q.defer();
	        function build(callback) {
	            // compile the function list for each data element
	            var funString = '';
	            for (var d in model.dataObjects) {
	                if (!model.dataObjects[d].settings) {
	                    continue;
	                } // continue if settings are null
	                var call = model.dataObjects[d].settings.get.call;
	                var params = false; // no parameters by default
	                // check for manual options defined
	                if (!options) {
	                    // if (!model.dataObjects[d].launched) { continue }
	                    // skip if not a manual call + is not set to refresh
	                    if (!model.dataObjects[d].settings.refresh) {
	                        continue;
	                    }
	                } else if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	                    // otherwise use the options in our query
	                    if (options.hasOwnProperty('call')) {
	                        call = options.call;
	                    }
	                    if (options.hasOwnProperty('params')) {
	                        params = JSON.stringify(options.params);
	                    }
	                } else {
	                    continue; // failsafe is to do nothing
	                }
	                var tt = void 0;
	                var id = model.dataObjects[d].settings.id;
	                var key = model.vizDictionary[id];
	                if (model.dataObjects[d].time.max) {
	                    tt = {}; // set tt as an object
	                    tt.start = model.dataObjects[key].time.max;
	                    tt.end = time.end;
	                    tt = JSON.stringify(tt);
	                } else {
	                    tt = JSON.stringify(time);
	                }
	                var fun = '(function () {\n'; // make an empty string for each individaul data obj
	                // check to see if a max exists.. and then earch from there instead (if time is rolling)
	                fun += '    new fetchStream("' + call + '", model.dataObjects["' + key + '"].settings.get.socket, ' + params + ', ' + tt + ')\n';
	                fun += '    .then(function (result) {\n';
	                fun += '        runFilters();\n';
	                fun += '    },\n';
	                fun += '    function (err) {\n';
	
	                fun += '    },\n';
	                fun += '    function (result) {\n';
	                fun += '        model.dataObjects["' + key + '"].cf.add(result.rows);\n';
	                // if unlaunched, check for dim/ group in settings and build if they dont exist (they will already be built in the controller if the settings exist)
	                fun += '        if (!model.dataObjects["' + key + '"].launched) {\n';
	                fun += '            if ((!model.dataObjects["' + key + '"].settings.hasOwnProperty("group")) && (!model.dataObjects["' + key + '"].settings.hasOwnProperty("dimension"))) {\n';
	                // with our first data return, we can build dimensions and groups for our data
	                fun += '                model.buildDimGroup(result.rows, { id: "' + id + '", key: "' + key + '" }).then(function () {\n';
	                // initalize rows
	                fun += '                    $scope.$broadcast("init", { id: "' + id + '", key: "' + key + '" });\n';
	                fun += '                }, function (err) {\n';
	                fun += '                    console.log("error")\n';
	                fun += '                    console.log(err)\n';
	                fun += '                })\n';
	                fun += '            }\n';
	                fun += '        }\n';
	                // fun += '            runFilters();\n';
	                // fun += '            if (result.rows.length > 0) {\n';
	                fun += '        $scope.$broadcast("updatedData", "' + id + '");\n';
	                // fun += '            }\n';
	                fun += '        \n';
	                fun += '    });\n';
	                fun += '})();\n';
	                // add our completed function string to the total to be executed
	                funString += fun;
	                funString += '\n'; // add new line for shits
	            }
	            var updateFunctionBlock = eval(funString);
	        }
	        build(function () {
	            return deferred.resolve();
	        });
	        return deferred.promise;
	    };
	    // begin timer on load to tell child controller when to update
	    model.timer = false; // this isnt the same as the timer variable. this holds the timer
	    // start refresh timer on load
	    var setTimer = function setTimer() {
	        model.timer = setInterval(function () {
	            // figure out and set time difference
	            model.rollTime(updateInterval).then(function (timeReturn) {
	                // filter out old data
	                for (var m in model.dataObjects) {
	                    if (!model.dataObjects[m].launched) {
	                        continue;
	                    }
	                    if (!model.dataObjects[m].settings.refresh) {
	                        continue;
	                    }
	                    // set last max.. this becomes our new start time if it exists
	                    var topArr = [];
	                    if (model.dataObjects[m].time.dimension) {
	                        topArr = model.dataObjects[m].time.dimension.top(1);
	                    }
	                    if (topArr.length > 0) {
	                        // this sets our max time only if there is data
	                        if (topArr[0].hasOwnProperty('time')) {
	                            // make sure the object contains time
	                            model.dataObjects[m].time.max = parseInt(topArr[0].time) + 1; // NOTE: +1 is assed here so we dont get any old records
	                        }
	                    }
	                }
	                runFilters(); // update filters from filterstores
	                return model.clearOldData(timeReturn.current);
	            }).then(function (time) {
	                // fetch new data and stuff it
	                return updateData(time);
	            }).then(function () {
	                // console.log('done refresh')
	            });
	        }, updateInterval);
	    };
	    // pass it current time and it will filter out items that are passed
	    model.clearOldData = function (time) {
	        var deferred = $q.defer();
	        function loop(time, callback) {
	            for (var m in model.dataObjects) {
	                if (!model.dataObjects[m].launched) {
	                    continue;
	                }
	                if (!model.dataObjects[m].settings.refresh) {
	                    continue;
	                }
	                model.dataObjects[m].searchDimension.filterAll(); // clear the search dimension
	                // refilter down to what needs to be removed
	                model.dataObjects[m].searchDimension.filter(function (d, i) {
	                    return d.time < time.start; // isolate time less than our current start
	                });
	                // delete the data that has been filtered
	                model.dataObjects[m].cf.remove();
	                // clear the filter again
	                model.dataObjects[m].searchDimension.filterAll();
	            }
	            return callback(time);
	        }
	        loop(time, function (time) {
	            return deferred.resolve(time);
	        });
	        return deferred.promise;
	    };
	    model.manualQuery = function (time, options) {
	        return updateData(time, options);
	    };
	    // fired when manually changing date range
	    model.manualUpdateTime = function (time) {
	        // kill timer
	        if (model.timer) {
	            clearInterval(model.timer);
	        }
	        // set time object'
	        model.setTime(time).then(function (time) {
	            for (var m in model.dataObjects) {
	                if (!model.dataObjects[m].launched) {
	                    continue;
	                }
	                // if (!model.dataObjects[m].settings.refresh) { continue }
	                // reset the maxTime value
	                model.dataObjects[m].time.max = false;
	                model.dataObjects[m].searchDimension.filterAll(); // clear the search dimension
	                // delete the data that has been filtered
	                model.dataObjects[m].cf.remove();
	                $scope.$broadcast("redraw", model.dataObjects[m].settings.id);
	            }
	            // get our data now
	            return updateData(time);
	        });
	    };
	    model.resetTimer = function () {
	        if (model.timer) {
	            clearInterval(model.timer);
	        }
	        if (!$location.$$search.hasOwnProperty('start') && !$location.$$search.hasOwnProperty('end')) {
	            setTimer();
	        }
	    };
	    model.resetTimer();
	    //////////////////////////////
	    /////// DATA MANAGMENT ///////
	    //////////////////////////////
	    var active = 0;
	    model.vizDictionary = {}, model.dataObjects = {
	        d0: {
	            cf: new crossfilter([]),
	            dimension: false,
	            searchDimension: false,
	            group: false,
	            filters: {
	                include: [],
	                exclude: []
	            },
	            settings: null,
	            launched: false,
	            time: {
	                max: false,
	                dimension: false
	            }
	        },
	        d1: {
	            cf: new crossfilter([]),
	            dimension: false,
	            searchDimension: false,
	            group: false,
	            filters: {
	                include: [],
	                exclude: []
	            },
	            settings: null,
	            launched: false,
	            time: {
	                max: false,
	                dimension: false
	            }
	        },
	        d2: {
	            cf: new crossfilter([]),
	            dimension: false,
	            searchDimension: false,
	            group: false,
	            filters: {
	                include: [],
	                exclude: []
	            },
	            settings: null,
	            launched: false,
	            time: {
	                max: false,
	                dimension: false
	            }
	        },
	        d3: {
	            cf: new crossfilter([]),
	            dimension: false,
	            searchDimension: false,
	            group: false,
	            filters: {
	                include: [],
	                exclude: []
	            },
	            settings: null,
	            launched: false,
	            time: {
	                max: false,
	                dimension: false
	            }
	        }
	    };
	    var increaseActive = function increaseActive() {
	        active++;
	    };
	    model.registerVisual = function (settings) {
	        return $q(function (resolve) {
	            // genrate unique id
	            var id = generateId();
	            var s = 'd' + active; // get next key name (e.g. 'd3')
	            // create new data object if we dont have enough
	            if (active >= 4) {
	                // if nothing is in the 'slot', create new object
	                if (typeof model.dataObjects[s] === 'undefined') {
	                    model.dataObjects[s] = { cf: new crossfilter([]), dimension: false, searchDimension: false, group: false, filters: { include: [], exclude: [] }, settings: null, launched: false, time: { max: false, dimension: false } };
	                }
	            }
	            model.dataObjects[s].settings = settings; // set settings in the data object for access later
	            model.dataObjects[s].settings.id = id; // save the id in the set for other 'main' functions (i.e. filtering)
	            model.vizDictionary[id] = s; // record the data key with the unique id for lookup in child controller
	            // add search categories to main search categories object if it exists in this visual's settings
	            if (typeof settings.searchCategories !== 'undefined' && typeof settings.searchCategories !== false) {
	                for (var i in settings.searchCategories) {
	                    // push unique search categories to the searchCategories object
	                    if (!model.searchCategories.hasOwnProperty(i)) {
	                        model.searchCategories[i] = settings.searchCategories[i];
	                    }
	                }
	            }
	            // add search dimension for every searchable visual
	            model.dataObjects[s].searchDimension = model.dataObjects[s].cf.dimension(function (d) {
	                return d;
	            }); // this'll be also used for data streaming, so its outside the rule below
	            if (typeof settings.searchable !== 'undefined' && typeof settings.searchable !== false) {
	                model.dataObjects[s].time.dimension = model.dataObjects[s].cf.dimension(function (d) {
	                    return +d.time;
	                });
	                model.dataObjects[s].uniqueItems = function (key) {
	                    return $q(function (resolve) {
	                        var dim = model.dataObjects[s].cf.dimension(function (d) {
	                            return d[key];
	                        });
	                        var group = dim.group();
	                        var all = group.all().map(function (d) {
	                            return d.key;
	                        });
	                        group.dispose(); // destory the group we just created
	                        dim.dispose();
	                        resolve(all);
	                    });
	                };
	            }
	            // setup streaming group reduce
	            increaseActive(); // increase active # for next register
	            resolve({ id: id, 'key': s, settings: settings });
	        });
	    };
	    var unregisterVisuals = function unregisterVisuals() {
	        var deffer = $q.defer();
	        function run(callback) {
	            var current = 0;
	            // clear or delete used data objects
	            for (var i in model.dataObjects) {
	                if (!model.dataObjects[i].settings) {
	                    continue;
	                } // skip any item item without settings
	                if (!model.vizDictionary.hasOwnProperty(model.dataObjects[i].settings.id)) {
	                    continue;
	                } // skip any items not in our viz dictionary
	                if (current <= 3) {
	                    if (model.dataObjects[i].dimension) {
	                        model.dataObjects[i].dimension.filterAll(); // clear all filters
	                        // model.dataObjects[i].dimension.dispose();
	                    }
	                    model.dataObjects[i].dimension = false; // destroy dimension
	                    model.dataObjects[i].group = false; // destroy group
	                    model.dataObjects[i].filters = { include: [], exclude: [] }; // destroy filters
	                    model.dataObjects[i].settings = null; // destroy settings
	                    model.dataObjects[i].launched = false; // reset launched status
	                    // clear time related dimensions
	                    if (model.dataObjects[i].time.dimension) {
	                        model.dataObjects[i].time.dimension.dispose(); // no need to filterAll since the dimension clearing above takes care of that
	                    }
	                    model.dataObjects[i].time = { max: false, dimension: false }; // reset launched status
	                    model.dataObjects[i].cf.remove(); // remove records
	                    model.dataObjects[i].cf = new crossfilter([]); // replace cf
	                } else {
	                    // if the are more crossfilter objects than our limit
	                    delete model.dataObjects[i]; // remove it
	                }
	                current++;
	            }
	            // runFilters();
	            model.vizDictionary = {}; // clear lookup dictionary
	            active = 0; // clear active visuals
	            setTimeout(function () {
	                return callback();
	            }, 0);
	        }
	        run(function () {
	            return deffer.resolve();
	        });
	        return deffer.promise;
	    };
	
	    //////////////////////////////
	    ////////// FILTERING /////////
	    //////////////////////////////
	    // controller should be listening for individual filter events, but here should be where the dimension objects are looped through
	    model.filterItem = function (key, value, action, title) {
	        model.updateFilterStore(key, value, action, true, title); // update existing filters
	    };
	    // controller should be listening for individual filter events, but here should be where the dimension objects are looped through
	    model.filterItemByTime = function (filterTime) {
	        var _loop = function _loop(i) {
	            if (!model.dataObjects[i].launched || model.dataObjects[i].settings.get.call === "linechart" || model.dataObjects[i].settings.get.call === "barchart") {
	                return 'continue';
	            }
	            if (model.dataObjects[i].settings.complete) {
	                model.dataObjects[i].settings.complete = 0;
	            }
	            if (typeof $scope.main.dataObjects[i].settings.render !== "undefined") {
	                $scope.main.dataObjects[i].settings.render.has = false;
	            }
	
	            // let callLength = model.dataObjects[i].settings.get.call.length;
	            // clear all filters
	            model.dataObjects[i].searchDimension.filterAll();
	            model.dataObjects[i].cf.remove();
	            function getdataByTime(time, render) {
	                if (_typeof(model.dataObjects[i].settings.get.call) === "object") {
	                    for (var c in model.dataObjects[i].settings.get.call) {
	                        requeryData(model.dataObjects[i].settings.get.call[c], model.dataObjects[i].settings.get.socket, time, model.dataObjects[i].settings.id);
	                    }
	                } else {
	                    requeryData(model.dataObjects[i].settings.get.call, model.dataObjects[i].settings.get.socket, time, model.dataObjects[i].settings.id);
	                }
	            };
	            function requeryData(call, socket, time, id) {
	                new fetchStream(call, socket, time).then(function (result) {
	                    model.dataObjects[i].settings.complete++;
	                    if (call === "table" || call === "outbound" || call === "inbound" || call === "lateral") {
	                        $scope.$broadcast('updatedData', id, { complete: true });
	                    }
	                }, function (err) {}, function (result) {
	                    // add rows
	                    model.dataObjects[i].cf.add(result.rows);
	                    runFilters();
	                    if (result.min) {
	                        if (call === "outbound" || call === "inbound" || call === "lateral") {
	                            $scope.$broadcast('updateLoad', result.min, true);
	                        } else if (call === "table") {
	                            $scope.$broadcast('updateLoad', result.min);
	                        }
	                    }
	                });
	            }
	            if (filterTime.start !== filterTime.end) {
	                getdataByTime(filterTime, true);
	            } else {
	                getdataByTime(model.getTime(), false);
	            }
	        };
	
	        for (var i in model.dataObjects) {
	            var _ret = _loop(i);
	
	            if (_ret === 'continue') continue;
	        }
	    };
	    function runFilters() {
	        function searchDim(filters, obj, index) {
	            var dictionary = {};
	            var includeRulesToSatisfy = _.size(filters.include),
	                included = 0,
	                result = false;
	            for (var i = 0, len = filters.include.length; i < len; i++) {
	                var key = Object.keys(filters.include[i])[0];
	                if (key === 'all') {
	                    for (var o in obj) {
	                        if (!obj[o]) {
	                            continue;
	                        } // ignore if null or false
	                        var toSearch = obj[o].toString().toLowerCase();
	                        if (toSearch.indexOf(filters.include[i][key]) > -1) {
	                            included++;
	                            if (included > includeRulesToSatisfy) {
	                                includeRulesToSatisfy++;
	                            }
	                            // stop the loop once one item is matched in the all obj
	                            break;
	                        }
	                    }
	                } else {
	                    if (obj[key]) {
	                        // if not null
	                        if (obj[key].toString().toLowerCase().indexOf(filters.include[i][key]) > -1) {
	                            included++;
	                        }
	                    }
	                }
	            }
	            if (included === includeRulesToSatisfy) {
	                result = true;
	            }
	            // excluded iems
	            for (var _i = 0, _len = filters.exclude.length; _i < _len; _i++) {
	                var _key = Object.keys(filters.exclude[_i])[0];
	                if (_key === 'all') {
	                    for (var _o in obj) {
	                        if (!obj[_o]) {
	                            continue;
	                        } // ignore if null or false
	                        if (obj[_o].toString().toLowerCase().indexOf(filters.exclude[_i].all) > -1) {
	                            result = false;
	                        }
	                    }
	                } else {
	                    if (obj[_key]) {
	                        // if not null
	                        if (obj[_key].toString().toLowerCase().indexOf(filters.exclude[_i][_key]) > -1) {
	                            result = false;
	                        }
	                    }
	                }
	            }
	            return result;
	        }
	        for (var i in model.dataObjects) {
	            if (!model.dataObjects[i].launched) {
	                continue;
	            }
	            if (!model.dataObjects[i].settings.refresh) {
	                continue;
	            }
	            // if ((typeof model.dataObjects[i].searchable === 'undefined') || (typeof model.dataObjects[i].searchable === false)) { continue } // skip if not searchable
	            // clear all filters
	            model.dataObjects[i].searchDimension.filterAll();
	            model.dataObjects[i].dimension.filterAll();
	            // build array of keys to exclude
	            var excludedKeys = [];
	            for (var ex = 0, len = model.dataObjects[i].filters.exclude.length; ex < len; ex++) {
	                // get key
	                var key = Object.keys(model.dataObjects[i].filters.exclude[ex])[0];
	                // check to see if its already pushed
	                if (excludedKeys.indexOf(key) === -1) {
	                    // push if not in array
	                    excludedKeys.push(key);
	                }
	            }
	            model.dataObjects[i].searchDimension.filterFunction(searchDim.bind(null, model.dataObjects[i].filters));
	            // send update signal
	            $scope.$broadcast('updatedData', model.dataObjects[i].settings.id);
	        }
	    }
	    // expose the external runFilters function to other functions that may use it
	    // such as the searchbar
	    model.runFilters = function () {
	        return runFilters();
	    };
	    model.runLatFilters = function (filterList) {
	        $scope.$broadcast('runLatSearch', filterList);
	        return;
	    };
	
	    // function sumply for adding filters
	    model.addFilter = function (key, nonLowerCaseValue, action, external, title) {
	        if (nonLowerCaseValue === null) {
	            return;
	        } // dont execute if value is null
	        var value = nonLowerCaseValue.toString().toLowerCase(),
	            include = [],
	            exclude = [],
	            child = void 0;
	        // ser the child directory to either include or exclude, so code isnt repeated
	        switch (action) {
	            case 'exclude':
	                child = 'exclude';
	                break;
	            case 'include': // there is no break here on purpose
	            default:
	                child = 'include';
	        }
	        // find data objects that can be filtered on these values
	        for (var i in model.dataObjects) {
	            // skip unlaunched visuals
	            // if (!model.dataObjects[i].launched) { continue }
	            if (_typeof(model.dataObjects[i].searchDimension) !== 'object') {
	                continue;
	            }
	            if (model.dataObjects[i].settings === null) {
	                continue;
	            }
	            // only add filters that are located in that visuals search categories
	            // check for existing filters (if there is a match, remove.:. add otherwise)
	            var obj = {}; // temp object
	            obj[key] = value;
	            model.dataObjects[i].filters[child].push(obj);
	            // if NOT manual search, set the run once 'ran' object to false
	            if (!model.manualSearch) {
	                // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
	                if (typeof model.dataObjects[i].settings.render !== 'undefined') {
	                    if (model.dataObjects[i].settings.render.once && model.dataObjects[i].settings.render.has) {
	                        model.dataObjects[i].settings.render.has = false;
	                    }
	                }
	            }
	        }
	        // send boradcasts based on what external events happened
	        if (external) {
	            $scope.$broadcast('addSearchBarItem', key, nonLowerCaseValue, action, title);
	        }
	    };
	
	    model.removeFilter = function (key, nonLowerCaseValue, action, external, title) {
	        if (nonLowerCaseValue === null) {
	            return;
	        } // dont execute if value is null
	        var itemToRemove = false; // we'lll use this to tell us if a searchbar item was added or removed
	        var value = nonLowerCaseValue.toString().toLowerCase(),
	            include = [],
	            exclude = [],
	            child = void 0;
	        // ser the child directory to either include or exclude, so code isnt repeated
	        switch (action) {
	            case 'exclude':
	                child = 'exclude';
	                break;
	            case 'include': // there is no break here on purpose
	            default:
	                child = 'include';
	        }
	        // find data objects that can be filtered on these values
	        for (var i in model.dataObjects) {
	            // skip unlaunched visuals
	            // if (!model.dataObjects[i].launched) { continue }
	            if (_typeof(model.dataObjects[i].searchDimension) !== 'object') {
	                continue;
	            }
	            if (model.dataObjects[i].settings === null) {
	                continue;
	            }
	            // only add filters that are located in that visuals search categories
	            // set the local filters varaible
	            // check for existing filters (if there is a match, remove.:. add otherwise)
	            var filterIndex = -1;
	            for (var f = 0, len = model.dataObjects[i].filters[child].length; f < len; f++) {
	                if (model.dataObjects[i].filters[child][f].hasOwnProperty(key)) {
	                    if (model.dataObjects[i].filters[child][f][key] === value) {
	                        // there is a filter that matches
	                        filterIndex = f; // set the value to the index
	                    }
	                }
	            }
	            if (filterIndex > -1) {
	                model.dataObjects[i].filters[child].splice(filterIndex, 1);
	                itemToRemove = true;
	            }
	            // if NOT manual search, set the run once 'ran' object to false
	            if (!model.manualSearch) {
	                // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
	                if (typeof model.dataObjects[i].settings.render !== 'undefined') {
	                    if (model.dataObjects[i].settings.render.once && model.dataObjects[i].settings.render.has) {
	                        model.dataObjects[i].settings.render.has = false;
	                    }
	                }
	            }
	        }
	        // send boradcasts based on what external events happened
	        if (external && itemToRemove) {
	            $scope.$broadcast('removeSearchBarItem', key, nonLowerCaseValue, action, title);
	        }
	    };
	
	    model.clearFilters = function () {
	        $scope.$broadcast('clearAllFilters');
	    };
	
	    // this function can add filters to the individual datasets filter store AND
	    //.. remove them if it is presented with an identical value
	    model.updateFilterStore = function (key, nonLowerCaseValue, action, external, title) {
	        if (nonLowerCaseValue === null) {
	            return;
	        } // dont execute if value is null
	        var whatHappened = false; // we'lll use this to tell us if a searchbar item was added or removed
	        var value = nonLowerCaseValue.toString().toLowerCase(),
	            include = [],
	            exclude = [],
	            child = void 0;
	        // ser the child directory to either include or exclude, so code isnt repeated
	        switch (action) {
	            case 'exclude':
	                child = 'exclude';
	                break;
	            case 'include': // there is no break here on purpose
	            default:
	                child = 'include';
	        }
	        // find data objects that can be filtered on these values
	        for (var i in model.dataObjects) {
	            // skip unlaunched visuals
	            // if (!model.dataObjects[i].launched) { continue }
	            if (_typeof(model.dataObjects[i].searchDimension) !== 'object') {
	                continue;
	            }
	            if (model.dataObjects[i].settings === null) {
	                continue;
	            }
	            // only add filters that are located in that visuals search categories
	            // set the local filters varaible
	            // check for existing filters (if there is a match, remove.:. add otherwise)
	            var filterIndex = -1;
	            for (var f = 0, len = model.dataObjects[i].filters[child].length; f < len; f++) {
	                if (model.dataObjects[i].filters[child][f].hasOwnProperty(key)) {
	                    if (model.dataObjects[i].filters[child][f][key] === value) {
	                        // there is a filter that matches
	                        filterIndex = f; // set the value to the index
	                    }
	                }
	            }
	            if (filterIndex > -1) {
	                model.dataObjects[i].filters[child].splice(filterIndex, 1);
	                whatHappened = 'itemsRemoved';
	            } else {
	                var obj = {}; // temp object
	                obj[key] = value;
	                model.dataObjects[i].filters[child].push(obj);
	                whatHappened = 'itemsAdded';
	            }
	            // if NOT manual search, set the run once 'ran' object to false
	            if (!model.manualSearch) {
	                // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
	                if (typeof model.dataObjects[i].settings.render !== 'undefined') {
	                    if (model.dataObjects[i].settings.render.once && model.dataObjects[i].settings.render.has) {
	                        model.dataObjects[i].settings.render.has = false;
	                    }
	                }
	            }
	        }
	        // send boradcasts based on what external events happened
	        if (external && whatHappened === 'itemsAdded') {
	            $scope.$broadcast('addSearchBarItem', key, nonLowerCaseValue, action, title);
	        } else if (external && whatHappened === 'itemsRemoved') {
	            $scope.$broadcast('removeSearchBarItem', key, nonLowerCaseValue, action, title);
	        }
	        // stop here if the page's search is manual
	        if (model.manualSearch) {
	            $scope.$broadcast('runSearch');return;
	        }
	        // apply filters
	        runFilters();
	    };
	    model.runManualSearch = function () {
	        // change manual search id (blocking all notify data)
	        model.manualSearchId = generateId();
	        var functions = '';
	        // make query
	        for (var i in model.dataObjects) {
	            // if (!model.dataObjects[i].launched) { continue }
	            if (_typeof(model.dataObjects[i].searchDimension) !== 'object') {
	                continue;
	            }
	            if (model.dataObjects[i].settings === null) {
	                continue;
	            }
	            var id = model.dataObjects[i].settings.id;
	
	            // for now we'll delete the current data. in the future we'll just temporarily move it somewhere
	            model.dataObjects[i].searchDimension.filterAll();
	            model.dataObjects[i].cf.remove();
	            // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
	            if (typeof model.dataObjects[i].settings.render !== 'undefined') {
	                if (model.dataObjects[i].settings.render.once && model.dataObjects[i].settings.render.has) {
	                    model.dataObjects[i].settings.render.has = false;
	                }
	            }
	            // redraw
	            $scope.$broadcast("updatedData", id); // this will clear the tables on search
	            // reset the single draw settings again - TODO: MAKE THIS A FUNCTION
	            if (typeof model.dataObjects[i].settings.render !== 'undefined') {
	                if (model.dataObjects[i].settings.render.once && model.dataObjects[i].settings.render.has) {
	                    model.dataObjects[i].settings.render.has = false;
	                }
	            }
	
	            // include sanatize
	            var ilen = model.dataObjects[i].filters.include.length,
	                include = [],
	                isAll = false;
	            if (ilen > 0) {
	                for (var f = 0; f < ilen; f++) {
	                    var keys = Object.keys(model.dataObjects[i].filters.include[f]);
	                    var _key2 = keys[0];
	                    if (model.dataObjects[i].settings.searchCategories.hasOwnProperty(_key2) || _key2 === 'all') {
	                        var item = {};
	                        item[_key2] = model.dataObjects[i].filters.include[f][_key2];
	                        include.push(item);
	                    }
	                    // set all mode if a an item in 'all' exists
	                    if (_key2 === 'all') {
	                        isAll = true;
	                    }
	                }
	            }
	            // excluded items sanatize
	            var elen = model.dataObjects[i].filters.exclude.length,
	                exclude = [];
	            if (elen > 0) {
	                for (var _f = 0; _f < elen; _f++) {
	                    var _keys = Object.keys(model.dataObjects[i].filters.exclude[_f]);
	                    var _key3 = _keys[0];
	                    if (model.dataObjects[i].settings.searchCategories.hasOwnProperty(_key3)) {
	                        var _item = {};
	                        _item[_key3] = model.dataObjects[i].filters.exclude[_f][_key3];
	                        exclude.push(_item);
	                    }
	                }
	            }
	            // 'ALL' SEARCH
	            if (isAll && typeof model.dataObjects[i].settings.columnSpec !== 'undefined') {
	                // if there are 'all' params, loop through searchCategories and generate an array of columns
	                isAll = [];
	                for (var _f2 in model.dataObjects[i].settings.searchCategories) {
	                    if (model.dataObjects[i].settings.columnSpec[_f2] === null) {
	                        // this takes from initalData in the dim/group builder - we only want strings - numbers are 0
	                        isAll.push(_f2);
	                    }
	                }
	            }
	
	            // PARAMS
	            // stringify our params for the
	            var time = model.getTime();
	            var tt = JSON.stringify(time);
	            var key = model.vizDictionary[id];
	            var params = JSON.stringify({
	                include: include,
	                exclude: exclude,
	                type: model.dataObjects[i].settings.type,
	                reqId: model.manualSearchId,
	                // if the loop above finds an 'all' search item in the includes, this will become an array of searchable fields
	                allSearch: isAll
	            });
	
	            var fun = '(function () {\n'; // make an empty string for each individaul data obj
	            // check to see if a max exists.. and then earch from there instead (if time is rolling)
	            fun += '    new fetchStream("' + model.dataObjects[key].settings.get.call + '", model.dataObjects["' + key + '"].settings.get.socket, ' + params + ', ' + tt + ')\n';
	            fun += '    .then(function (result) {\n';
	            fun += '        runFilters();\n';
	            // fun += '        if (!model.dataObjects["'+key+'"].launched) {\n';
	            //                     // after table is set to 'launched', add any items in the killchain to the searchbar and global filters
	            //                     // note: we only have includes from kill chain
	            // fun += '            model.emptyResponseTryNext(model.currentMode);\n';
	            // fun += '        }\n';
	            fun += '    },\n';
	            fun += '    function (err) {\n';
	
	            fun += '    },\n';
	            fun += '    function (result) {\n';
	            fun += '        if (result.reqId !== "' + model.manualSearchId + '") { return }\n';
	            // return if any of the filter selects are not part of the return i.e. searching remote_country in DHCP should return nothing
	            for (var inc = 0, incLen = model.dataObjects[i].filters.include.length; inc < incLen; inc++) {
	                var _key4 = Object.keys(model.dataObjects[i].filters.include[inc])[0];
	                if (_key4 !== 'all') {
	                    fun += 'if (Object.keys(result.rows[0]).indexOf("' + _key4 + '") === -1) { console.log("no exist"); return }\n';
	                }
	            }
	            fun += '        model.dataObjects["' + key + '"].cf.add(result.rows);\n';
	            fun += '        if (!model.dataObjects["' + key + '"].launched) {\n';
	            // with our first data return, we can build dimensions and groups for our data
	            fun += '            model.buildDimGroup(result.rows, { id: "' + id + '", key: "' + key + '" }).then(function () {\n';
	            // initalize rows
	            fun += '                $scope.$broadcast("init", { id: "' + id + '", key: "' + key + '" });\n';
	            fun += '            }, function (err) {\n';
	            fun += '                console.log("error")\n';
	            fun += '            })\n';
	            fun += '        } else if (result.rows.length > 0) {\n';
	            fun += '            $scope.$broadcast("updatedData", "' + id + '");\n';
	            fun += '        }\n';
	            fun += '        \n';
	            fun += '    });\n';
	            fun += '})();\n';
	            functions += fun;
	            $scope.$broadcast("manualSearchFired", { key: key, id: id });
	        }
	        eval(functions);
	    };
	    // function to set and unset manual search mode
	    model.setManualSearch = function (status) {
	        model.manualSearch = status;
	    };
	
	    //////////////////////////////
	    /////////// SEARCH ///////////
	    //////////////////////////////
	    // main object
	    // when a modifier is selected it runs this function that finds the data objects containing data with the same field for the autocomplete
	    model.getVals = function (value) {
	        if (model.manualSearch) {
	            return;
	        } // dont populate value list if manual search is turned on
	        var select = void 0;
	        if (typeof value.select === "undefined") {
	            select = value;
	        } else {
	            select = value.select;
	        }
	        var deferred = $q.defer();
	        var recordsToSearch = [];
	        for (var i in model.dataObjects) {
	            if (model.dataObjects[i].settings === null) {
	                continue;
	            }
	            if (typeof model.dataObjects[i].settings.searchCategories === 'undefined') {
	                continue;
	            }
	            for (var s in model.dataObjects[i].settings.searchCategories) {
	                if (select === s) {
	                    recordsToSearch.push(i);
	                }
	            }
	        }
	        var uniqueValues = [],
	            d = {};
	
	        var _loop2 = function _loop2(rlen, _i2) {
	            model.dataObjects[recordsToSearch[_i2]].uniqueItems(select).then(function (vals) {
	                for (var v = 0, len = vals.length; v < len; v++) {
	                    if (d.hasOwnProperty(vals[v])) {
	                        continue;
	                    }
	                    uniqueValues.push(vals[v]);
	                    d[vals[v]] = 1;
	                }
	                if (_i2 === 1) {
	                    // send an inital return
	                    deferred.resolve(uniqueValues);
	                } else {
	                    // keep sending updates
	                    deferred.notify(uniqueValues);
	                }
	            });
	        };
	
	        for (var _i2 = 0, rlen = recordsToSearch.length; _i2 < rlen; _i2++) {
	            _loop2(rlen, _i2);
	        }
	        return deferred.promise;
	    };
	
	    var cleanupSearch = function cleanupSearch() {
	        model.searchCategories = {};
	    };
	    // CLEANUP
	    model.cleanup = function () {
	        var deffer = $q.defer();
	        function c(callback) {
	            // recycle crossfilter objects
	            unregisterVisuals().then(function () {
	                // clear active viz object
	                cleanupSearch();
	                $scope.$broadcast('directiveCleanup');
	                model.resetTimer();
	                return callback();
	            });
	        }
	        c(function () {
	            return deffer.resolve();
	        });
	        return deffer.promise;
	    };
	}
	
	ctrl.$inject = ['$scope', 'generateId', '$q', '$http', 'fetchStream', '$stateParams', '$location', '$window'];
	module.exports = ctrl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(677)))

/***/ },
/* 677 */,
/* 678 */,
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // L7_APP
	    ngModule.controller('appByl7Controller', __webpack_require__(680));
	    ngModule.controller('appByl7RespController', __webpack_require__(684));
	    ngModule.controller('appByl7RespOrigController', __webpack_require__(685));
	
	    // DNS
	    ngModule.controller('dnsByTypeController', __webpack_require__(686));
	    ngModule.controller('dnsByTypeRespController', __webpack_require__(687));
	    ngModule.controller('dnsByTypeRespOrigController', __webpack_require__(688));
	    ngModule.controller('dnsByResolverController', __webpack_require__(689));
	    ngModule.controller('dnsByResolverTypeController', __webpack_require__(690));
	
	    // HTTP
	    ngModule.controller('httpByDomainController', __webpack_require__(691));
	    ngModule.controller('httpByDomainSubController', __webpack_require__(692));
	    ngModule.controller('httpByDomainUriController', __webpack_require__(693));
	
	    // SSL
	    ngModule.controller('sslByServerController', __webpack_require__(694));
	    ngModule.controller('sslByServerNameController', __webpack_require__(695));
	    ngModule.controller('sslByServerNameOrigController', __webpack_require__(696));
	
	    // FTP
	    ngModule.controller('ftpRespController', __webpack_require__(697));
	    ngModule.controller('ftpRespOrigController', __webpack_require__(698));
	
	    // SSH
	    ngModule.controller('sshStatusController', __webpack_require__(699));
	    ngModule.controller('sshStatusRespController', __webpack_require__(700));
	    ngModule.controller('sshStatusRespOrigController', __webpack_require__(701));
	};

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/app_by_l7').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['l7_app'],
	                    filter_column: 'l7_app',
	                    searchCategories: {
	                        'l7_app': 'Application'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.l7_app;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                    };
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'l7_app'],
	                    searchCategories: {
	                        'time': 'Time',
	                        'l7_app': 'Layer 7 Application'
	                    },
	                    type: 'linechart',
	                    settings: {
	                        type: 'bandwidth',
	                        // hide_legend: true,
	                        use_color: true,
	                        toggleValues: true,
	                        xAxis: '',
	                        yAxis: '# MB / Hour'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.l7_app)) {
	                                p[v.l7_app] += v.bytes_orig + v.bytes_resp;
	                            } else {
	                                p['Other'] += v.bytes_orig + v.bytes_resp;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.l7_app)) {
	                                p[v.l7_app] -= v.bytes_orig + v.bytes_resp;
	                            } else {
	                                p['Other'] -= v.bytes_orig + v.bytes_resp;
	                            }
	                            return p;
	                        }, function (d, v) {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['l7_app'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            // div: 'table',
	            title: 'Layer 7 Applications',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'app_by_l7_resp',
	                    val: ['l7_app'],
	                    crumb: false
	                }
	            }, {
	                title: 'Layer 7 App',
	                select: 'l7_app',
	                dView: true
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'l7_app': 'Layer 7 App'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module, setImmediate, process) {(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (factory((global.async = global.async || {})));
	}(this, (function (exports) { 'use strict';
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	var genTag = '[object GeneratorFunction]';
	var proxyTag = '[object Proxy]';
	
	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto$1.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag || tag == proxyTag;
	}
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/** Used for built-in method references. */
	var funcProto$1 = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString$1 = funcProto$1.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString$1.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 500;
	var HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest$1(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	var initialParams = function (fn) {
	    return baseRest$1(function (args /*..., callback*/) {
	        var callback = args.pop();
	        fn.call(this, args, callback);
	    });
	};
	
	function applyEach$1(eachfn) {
	    return baseRest$1(function (fns, args) {
	        var go = initialParams(function (args, callback) {
	            var that = this;
	            return eachfn(fns, function (fn, cb) {
	                fn.apply(that, args.concat([cb]));
	            }, callback);
	        });
	        if (args.length) {
	            return go.apply(this, args);
	        } else {
	            return go;
	        }
	    });
	}
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	function once(fn) {
	    return function () {
	        if (fn === null) return;
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	var iteratorSymbol = typeof Symbol === 'function' && Symbol.iterator;
	
	var getIterator = function (coll) {
	    return iteratorSymbol && coll[iteratorSymbol] && coll[iteratorSymbol]();
	};
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto$4 = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString$1 = objectProto$4.toString;
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && objectToString$1.call(value) == argsTag;
	}
	
	/** Used for built-in method references. */
	var objectProto$3 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty$2.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER$1 : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/** `Object#toString` result references. */
	var argsTag$1 = '[object Arguments]';
	var arrayTag = '[object Array]';
	var boolTag = '[object Boolean]';
	var dateTag = '[object Date]';
	var errorTag = '[object Error]';
	var funcTag$1 = '[object Function]';
	var mapTag = '[object Map]';
	var numberTag = '[object Number]';
	var objectTag = '[object Object]';
	var regexpTag = '[object RegExp]';
	var setTag = '[object Set]';
	var stringTag = '[object String]';
	var weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]';
	var dataViewTag = '[object DataView]';
	var float32Tag = '[object Float32Array]';
	var float64Tag = '[object Float64Array]';
	var int8Tag = '[object Int8Array]';
	var int16Tag = '[object Int16Array]';
	var int32Tag = '[object Int32Array]';
	var uint8Tag = '[object Uint8Array]';
	var uint8ClampedTag = '[object Uint8ClampedArray]';
	var uint16Tag = '[object Uint16Array]';
	var uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto$5 = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString$2 = objectProto$5.toString;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString$2.call(value)];
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/** Detect free variable `exports`. */
	var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports$1 && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/** Used for built-in method references. */
	var objectProto$2 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty$1.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto$7 = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$7;
	
	  return value === proto;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/** Used for built-in method references. */
	var objectProto$6 = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$3 = objectProto$6.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty$3.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	function createArrayIterator(coll) {
	    var i = -1;
	    var len = coll.length;
	    return function next() {
	        return ++i < len ? { value: coll[i], key: i } : null;
	    };
	}
	
	function createES2015Iterator(iterator) {
	    var i = -1;
	    return function next() {
	        var item = iterator.next();
	        if (item.done) return null;
	        i++;
	        return { value: item.value, key: i };
	    };
	}
	
	function createObjectIterator(obj) {
	    var okeys = keys(obj);
	    var i = -1;
	    var len = okeys.length;
	    return function next() {
	        var key = okeys[++i];
	        return i < len ? { value: obj[key], key: key } : null;
	    };
	}
	
	function iterator(coll) {
	    if (isArrayLike(coll)) {
	        return createArrayIterator(coll);
	    }
	
	    var iterator = getIterator(coll);
	    return iterator ? createES2015Iterator(iterator) : createObjectIterator(coll);
	}
	
	function onlyOnce(fn) {
	    return function () {
	        if (fn === null) throw new Error("Callback was already called.");
	        var callFn = fn;
	        fn = null;
	        callFn.apply(this, arguments);
	    };
	}
	
	// A temporary value used to identify if the loop should be broken.
	// See #1064, #1293
	var breakLoop = {};
	
	function _eachOfLimit(limit) {
	    return function (obj, iteratee, callback) {
	        callback = once(callback || noop);
	        if (limit <= 0 || !obj) {
	            return callback(null);
	        }
	        var nextElem = iterator(obj);
	        var done = false;
	        var running = 0;
	
	        function iterateeCallback(err, value) {
	            running -= 1;
	            if (err) {
	                done = true;
	                callback(err);
	            } else if (value === breakLoop || done && running <= 0) {
	                done = true;
	                return callback(null);
	            } else {
	                replenish();
	            }
	        }
	
	        function replenish() {
	            while (running < limit && !done) {
	                var elem = nextElem();
	                if (elem === null) {
	                    done = true;
	                    if (running <= 0) {
	                        callback(null);
	                    }
	                    return;
	                }
	                running += 1;
	                iteratee(elem.value, elem.key, onlyOnce(iterateeCallback));
	            }
	        }
	
	        replenish();
	    };
	}
	
	/**
	 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name eachOfLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.eachOf]{@link module:Collections.eachOf}
	 * @alias forEachOfLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A function to apply to each
	 * item in `coll`. The `key` is the item's key, or index in the case of an
	 * array. The iteratee is passed a `callback(err)` which must be called once it
	 * has completed. If no error has occurred, the callback should be run without
	 * arguments or with an explicit `null` argument. Invoked with
	 * (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachOfLimit(coll, limit, iteratee, callback) {
	  _eachOfLimit(limit)(coll, iteratee, callback);
	}
	
	function doLimit(fn, limit) {
	    return function (iterable, iteratee, callback) {
	        return fn(iterable, limit, iteratee, callback);
	    };
	}
	
	// eachOf implementation optimized for array-likes
	function eachOfArrayLike(coll, iteratee, callback) {
	    callback = once(callback || noop);
	    var index = 0,
	        completed = 0,
	        length = coll.length;
	    if (length === 0) {
	        callback(null);
	    }
	
	    function iteratorCallback(err) {
	        if (err) {
	            callback(err);
	        } else if (++completed === length) {
	            callback(null);
	        }
	    }
	
	    for (; index < length; index++) {
	        iteratee(coll[index], index, onlyOnce(iteratorCallback));
	    }
	}
	
	// a generic version of eachOf which can handle array, object, and iterator cases.
	var eachOfGeneric = doLimit(eachOfLimit, Infinity);
	
	/**
	 * Like [`each`]{@link module:Collections.each}, except that it passes the key (or index) as the second argument
	 * to the iteratee.
	 *
	 * @name eachOf
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias forEachOf
	 * @category Collection
	 * @see [async.each]{@link module:Collections.each}
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each
	 * item in `coll`. The `key` is the item's key, or index in the case of an
	 * array. The iteratee is passed a `callback(err)` which must be called once it
	 * has completed. If no error has occurred, the callback should be run without
	 * arguments or with an explicit `null` argument. Invoked with
	 * (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 * @example
	 *
	 * var obj = {dev: "/dev.json", test: "/test.json", prod: "/prod.json"};
	 * var configs = {};
	 *
	 * async.forEachOf(obj, function (value, key, callback) {
	 *     fs.readFile(__dirname + value, "utf8", function (err, data) {
	 *         if (err) return callback(err);
	 *         try {
	 *             configs[key] = JSON.parse(data);
	 *         } catch (e) {
	 *             return callback(e);
	 *         }
	 *         callback();
	 *     });
	 * }, function (err) {
	 *     if (err) console.error(err.message);
	 *     // configs is now a map of JSON data
	 *     doSomethingWith(configs);
	 * });
	 */
	var eachOf = function (coll, iteratee, callback) {
	    var eachOfImplementation = isArrayLike(coll) ? eachOfArrayLike : eachOfGeneric;
	    eachOfImplementation(coll, iteratee, callback);
	};
	
	function doParallel(fn) {
	    return function (obj, iteratee, callback) {
	        return fn(eachOf, obj, iteratee, callback);
	    };
	}
	
	function _asyncMap(eachfn, arr, iteratee, callback) {
	    callback = once(callback || noop);
	    arr = arr || [];
	    var results = [];
	    var counter = 0;
	
	    eachfn(arr, function (value, _, callback) {
	        var index = counter++;
	        iteratee(value, function (err, v) {
	            results[index] = v;
	            callback(err);
	        });
	    }, function (err) {
	        callback(err, results);
	    });
	}
	
	/**
	 * Produces a new collection of values by mapping each value in `coll` through
	 * the `iteratee` function. The `iteratee` is called with an item from `coll`
	 * and a callback for when it has finished processing. Each of these callback
	 * takes 2 arguments: an `error`, and the transformed item from `coll`. If
	 * `iteratee` passes an error to its callback, the main `callback` (for the
	 * `map` function) is immediately called with the error.
	 *
	 * Note, that since this function applies the `iteratee` to each item in
	 * parallel, there is no guarantee that the `iteratee` functions will complete
	 * in order. However, the results array will be in the same order as the
	 * original `coll`.
	 *
	 * If `map` is passed an Object, the results will be an Array.  The results
	 * will roughly be in the order of the original Objects' keys (but this can
	 * vary across JavaScript engines)
	 *
	 * @name map
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, transformed)` which must be called
	 * once it has completed with an error (which can be `null`) and a
	 * transformed item. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an Array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 * @example
	 *
	 * async.map(['file1','file2','file3'], fs.stat, function(err, results) {
	 *     // results is now an array of stats for each file
	 * });
	 */
	var map = doParallel(_asyncMap);
	
	/**
	 * Applies the provided arguments to each function in the array, calling
	 * `callback` after all functions have completed. If you only provide the first
	 * argument, `fns`, then it will return a function which lets you pass in the
	 * arguments as if it were a single function call. If more arguments are
	 * provided, `callback` is required while `args` is still optional.
	 *
	 * @name applyEach
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} fns - A collection of asynchronous functions
	 * to all call with the same arguments
	 * @param {...*} [args] - any number of separate arguments to pass to the
	 * function.
	 * @param {Function} [callback] - the final argument should be the callback,
	 * called when all functions have completed processing.
	 * @returns {Function} - If only the first argument, `fns`, is provided, it will
	 * return a function which lets you pass in the arguments as if it were a single
	 * function call. The signature is `(..args, callback)`. If invoked with any
	 * arguments, `callback` is required.
	 * @example
	 *
	 * async.applyEach([enableSearch, updateSchema], 'bucket', callback);
	 *
	 * // partial application example:
	 * async.each(
	 *     buckets,
	 *     async.applyEach([enableSearch, updateSchema]),
	 *     callback
	 * );
	 */
	var applyEach = applyEach$1(map);
	
	function doParallelLimit(fn) {
	    return function (obj, limit, iteratee, callback) {
	        return fn(_eachOfLimit(limit), obj, iteratee, callback);
	    };
	}
	
	/**
	 * The same as [`map`]{@link module:Collections.map} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name mapLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A function to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, transformed)` which must be called
	 * once it has completed with an error (which can be `null`) and a transformed
	 * item. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 */
	var mapLimit = doParallelLimit(_asyncMap);
	
	/**
	 * The same as [`map`]{@link module:Collections.map} but runs only a single async operation at a time.
	 *
	 * @name mapSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, transformed)` which must be called
	 * once it has completed with an error (which can be `null`) and a
	 * transformed item. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Results is an array of the
	 * transformed items from the `coll`. Invoked with (err, results).
	 */
	var mapSeries = doLimit(mapLimit, 1);
	
	/**
	 * The same as [`applyEach`]{@link module:ControlFlow.applyEach} but runs only a single async operation at a time.
	 *
	 * @name applyEachSeries
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.applyEach]{@link module:ControlFlow.applyEach}
	 * @category Control Flow
	 * @param {Array|Iterable|Object} fns - A collection of asynchronous functions to all
	 * call with the same arguments
	 * @param {...*} [args] - any number of separate arguments to pass to the
	 * function.
	 * @param {Function} [callback] - the final argument should be the callback,
	 * called when all functions have completed processing.
	 * @returns {Function} - If only the first argument is provided, it will return
	 * a function which lets you pass in the arguments as if it were a single
	 * function call.
	 */
	var applyEachSeries = applyEach$1(mapSeries);
	
	/**
	 * Creates a continuation function with some arguments already applied.
	 *
	 * Useful as a shorthand when combined with other control flow functions. Any
	 * arguments passed to the returned function are added to the arguments
	 * originally passed to apply.
	 *
	 * @name apply
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} function - The function you want to eventually apply all
	 * arguments to. Invokes with (arguments...).
	 * @param {...*} arguments... - Any number of arguments to automatically apply
	 * when the continuation is called.
	 * @example
	 *
	 * // using apply
	 * async.parallel([
	 *     async.apply(fs.writeFile, 'testfile1', 'test1'),
	 *     async.apply(fs.writeFile, 'testfile2', 'test2')
	 * ]);
	 *
	 *
	 * // the same process without using apply
	 * async.parallel([
	 *     function(callback) {
	 *         fs.writeFile('testfile1', 'test1', callback);
	 *     },
	 *     function(callback) {
	 *         fs.writeFile('testfile2', 'test2', callback);
	 *     }
	 * ]);
	 *
	 * // It's possible to pass any number of additional arguments when calling the
	 * // continuation:
	 *
	 * node> var fn = async.apply(sys.puts, 'one');
	 * node> fn('two', 'three');
	 * one
	 * two
	 * three
	 */
	var apply$2 = baseRest$1(function (fn, args) {
	    return baseRest$1(function (callArgs) {
	        return fn.apply(null, args.concat(callArgs));
	    });
	});
	
	/**
	 * Take a sync function and make it async, passing its return value to a
	 * callback. This is useful for plugging sync functions into a waterfall,
	 * series, or other async functions. Any arguments passed to the generated
	 * function will be passed to the wrapped function (except for the final
	 * callback argument). Errors thrown will be passed to the callback.
	 *
	 * If the function passed to `asyncify` returns a Promise, that promises's
	 * resolved/rejected state will be used to call the callback, rather than simply
	 * the synchronous return value.
	 *
	 * This also means you can asyncify ES2016 `async` functions.
	 *
	 * @name asyncify
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @alias wrapSync
	 * @category Util
	 * @param {Function} func - The synchronous function to convert to an
	 * asynchronous function.
	 * @returns {Function} An asynchronous wrapper of the `func`. To be invoked with
	 * (callback).
	 * @example
	 *
	 * // passing a regular synchronous function
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(JSON.parse),
	 *     function (data, next) {
	 *         // data is the result of parsing the text.
	 *         // If there was a parsing error, it would have been caught.
	 *     }
	 * ], callback);
	 *
	 * // passing a function returning a promise
	 * async.waterfall([
	 *     async.apply(fs.readFile, filename, "utf8"),
	 *     async.asyncify(function (contents) {
	 *         return db.model.create(contents);
	 *     }),
	 *     function (model, next) {
	 *         // `model` is the instantiated model object.
	 *         // If there was an error, this function would be skipped.
	 *     }
	 * ], callback);
	 *
	 * // es6 example
	 * var q = async.queue(async.asyncify(async function(file) {
	 *     var intermediateStep = await processFile(file);
	 *     return await somePromise(intermediateStep)
	 * }));
	 *
	 * q.push(files);
	 */
	function asyncify(func) {
	    return initialParams(function (args, callback) {
	        var result;
	        try {
	            result = func.apply(this, args);
	        } catch (e) {
	            return callback(e);
	        }
	        // if result is Promise object
	        if (isObject(result) && typeof result.then === 'function') {
	            result.then(function (value) {
	                callback(null, value);
	            }, function (err) {
	                callback(err.message ? err : new Error(err));
	            });
	        } else {
	            callback(null, result);
	        }
	    });
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	/**
	 * Determines the best order for running the functions in `tasks`, based on
	 * their requirements. Each function can optionally depend on other functions
	 * being completed first, and each function is run as soon as its requirements
	 * are satisfied.
	 *
	 * If any of the functions pass an error to their callback, the `auto` sequence
	 * will stop. Further tasks will not execute (so any other functions depending
	 * on it will not run), and the main `callback` is immediately called with the
	 * error.
	 *
	 * Functions also receive an object containing the results of functions which
	 * have completed so far as the first argument, if they have dependencies. If a
	 * task function has no dependencies, it will only be passed a callback.
	 *
	 * @name auto
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Object} tasks - An object. Each of its properties is either a
	 * function or an array of requirements, with the function itself the last item
	 * in the array. The object's key of a property serves as the name of the task
	 * defined by that property, i.e. can be used when specifying requirements for
	 * other tasks. The function receives one or two arguments:
	 * * a `results` object, containing the results of the previously executed
	 *   functions, only passed if the task has any dependencies,
	 * * a `callback(err, result)` function, which must be called when finished,
	 *   passing an `error` (which can be `null`) and the result of the function's
	 *   execution.
	 * @param {number} [concurrency=Infinity] - An optional `integer` for
	 * determining the maximum number of tasks that can be run in parallel. By
	 * default, as many as possible.
	 * @param {Function} [callback] - An optional callback which is called when all
	 * the tasks have been completed. It receives the `err` argument if any `tasks`
	 * pass an error to their callback. Results are always returned; however, if an
	 * error occurs, no further `tasks` will be performed, and the results object
	 * will only contain partial results. Invoked with (err, results).
	 * @returns undefined
	 * @example
	 *
	 * async.auto({
	 *     // this function will just be passed a callback
	 *     readData: async.apply(fs.readFile, 'data.txt', 'utf-8'),
	 *     showData: ['readData', function(results, cb) {
	 *         // results.readData is the file's contents
	 *         // ...
	 *     }]
	 * }, callback);
	 *
	 * async.auto({
	 *     get_data: function(callback) {
	 *         console.log('in get_data');
	 *         // async code to get some data
	 *         callback(null, 'data', 'converted to array');
	 *     },
	 *     make_folder: function(callback) {
	 *         console.log('in make_folder');
	 *         // async code to create a directory to store a file in
	 *         // this is run at the same time as getting the data
	 *         callback(null, 'folder');
	 *     },
	 *     write_file: ['get_data', 'make_folder', function(results, callback) {
	 *         console.log('in write_file', JSON.stringify(results));
	 *         // once there is some data and the directory exists,
	 *         // write the data to a file in the directory
	 *         callback(null, 'filename');
	 *     }],
	 *     email_link: ['write_file', function(results, callback) {
	 *         console.log('in email_link', JSON.stringify(results));
	 *         // once the file is written let's email a link to it...
	 *         // results.write_file contains the filename returned by write_file.
	 *         callback(null, {'file':results.write_file, 'email':'user@example.com'});
	 *     }]
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('results = ', results);
	 * });
	 */
	var auto = function (tasks, concurrency, callback) {
	    if (typeof concurrency === 'function') {
	        // concurrency is optional, shift the args.
	        callback = concurrency;
	        concurrency = null;
	    }
	    callback = once(callback || noop);
	    var keys$$1 = keys(tasks);
	    var numTasks = keys$$1.length;
	    if (!numTasks) {
	        return callback(null);
	    }
	    if (!concurrency) {
	        concurrency = numTasks;
	    }
	
	    var results = {};
	    var runningTasks = 0;
	    var hasError = false;
	
	    var listeners = {};
	
	    var readyTasks = [];
	
	    // for cycle detection:
	    var readyToCheck = []; // tasks that have been identified as reachable
	    // without the possibility of returning to an ancestor task
	    var uncheckedDependencies = {};
	
	    baseForOwn(tasks, function (task, key) {
	        if (!isArray(task)) {
	            // no dependencies
	            enqueueTask(key, [task]);
	            readyToCheck.push(key);
	            return;
	        }
	
	        var dependencies = task.slice(0, task.length - 1);
	        var remainingDependencies = dependencies.length;
	        if (remainingDependencies === 0) {
	            enqueueTask(key, task);
	            readyToCheck.push(key);
	            return;
	        }
	        uncheckedDependencies[key] = remainingDependencies;
	
	        arrayEach(dependencies, function (dependencyName) {
	            if (!tasks[dependencyName]) {
	                throw new Error('async.auto task `' + key + '` has a non-existent dependency in ' + dependencies.join(', '));
	            }
	            addListener(dependencyName, function () {
	                remainingDependencies--;
	                if (remainingDependencies === 0) {
	                    enqueueTask(key, task);
	                }
	            });
	        });
	    });
	
	    checkForDeadlocks();
	    processQueue();
	
	    function enqueueTask(key, task) {
	        readyTasks.push(function () {
	            runTask(key, task);
	        });
	    }
	
	    function processQueue() {
	        if (readyTasks.length === 0 && runningTasks === 0) {
	            return callback(null, results);
	        }
	        while (readyTasks.length && runningTasks < concurrency) {
	            var run = readyTasks.shift();
	            run();
	        }
	    }
	
	    function addListener(taskName, fn) {
	        var taskListeners = listeners[taskName];
	        if (!taskListeners) {
	            taskListeners = listeners[taskName] = [];
	        }
	
	        taskListeners.push(fn);
	    }
	
	    function taskComplete(taskName) {
	        var taskListeners = listeners[taskName] || [];
	        arrayEach(taskListeners, function (fn) {
	            fn();
	        });
	        processQueue();
	    }
	
	    function runTask(key, task) {
	        if (hasError) return;
	
	        var taskCallback = onlyOnce(baseRest$1(function (err, args) {
	            runningTasks--;
	            if (args.length <= 1) {
	                args = args[0];
	            }
	            if (err) {
	                var safeResults = {};
	                baseForOwn(results, function (val, rkey) {
	                    safeResults[rkey] = val;
	                });
	                safeResults[key] = args;
	                hasError = true;
	                listeners = [];
	
	                callback(err, safeResults);
	            } else {
	                results[key] = args;
	                taskComplete(key);
	            }
	        }));
	
	        runningTasks++;
	        var taskFn = task[task.length - 1];
	        if (task.length > 1) {
	            taskFn(results, taskCallback);
	        } else {
	            taskFn(taskCallback);
	        }
	    }
	
	    function checkForDeadlocks() {
	        // Kahn's algorithm
	        // https://en.wikipedia.org/wiki/Topological_sorting#Kahn.27s_algorithm
	        // http://connalle.blogspot.com/2013/10/topological-sortingkahn-algorithm.html
	        var currentTask;
	        var counter = 0;
	        while (readyToCheck.length) {
	            currentTask = readyToCheck.pop();
	            counter++;
	            arrayEach(getDependents(currentTask), function (dependent) {
	                if (--uncheckedDependencies[dependent] === 0) {
	                    readyToCheck.push(dependent);
	                }
	            });
	        }
	
	        if (counter !== numTasks) {
	            throw new Error('async.auto cannot execute tasks due to a recursive dependency');
	        }
	    }
	
	    function getDependents(taskName) {
	        var result = [];
	        baseForOwn(tasks, function (task, key) {
	            if (isArray(task) && baseIndexOf(task, taskName, 0) >= 0) {
	                result.push(key);
	            }
	        });
	        return result;
	    }
	};
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/** Built-in value references. */
	var Symbol$1 = root.Symbol;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString$3 = objectProto$8.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString$3.call(value) == symbolTag);
	}
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
	var symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff';
	var rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23';
	var rsComboSymbolsRange = '\\u20d0-\\u20f0';
	var rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	/** Used to compose unicode character classes. */
	var rsAstralRange$1 = '\\ud800-\\udfff';
	var rsComboMarksRange$1 = '\\u0300-\\u036f\\ufe20-\\ufe23';
	var rsComboSymbolsRange$1 = '\\u20d0-\\u20f0';
	var rsVarRange$1 = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange$1 + ']';
	var rsCombo = '[' + rsComboMarksRange$1 + rsComboSymbolsRange$1 + ']';
	var rsFitz = '\\ud83c[\\udffb-\\udfff]';
	var rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')';
	var rsNonAstral = '[^' + rsAstralRange$1 + ']';
	var rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}';
	var rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]';
	var rsZWJ$1 = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?';
	var rsOptVar = '[' + rsVarRange$1 + ']?';
	var rsOptJoin = '(?:' + rsZWJ$1 + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*';
	var rsSeq = rsOptVar + reOptMod + rsOptJoin;
	var rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	var FN_ARGS = /^(function)?\s*[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /(=.+)?(\s*)$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	
	function parseParams(func) {
	    func = func.toString().replace(STRIP_COMMENTS, '');
	    func = func.match(FN_ARGS)[2].replace(' ', '');
	    func = func ? func.split(FN_ARG_SPLIT) : [];
	    func = func.map(function (arg) {
	        return trim(arg.replace(FN_ARG, ''));
	    });
	    return func;
	}
	
	/**
	 * A dependency-injected version of the [async.auto]{@link module:ControlFlow.auto} function. Dependent
	 * tasks are specified as parameters to the function, after the usual callback
	 * parameter, with the parameter names matching the names of the tasks it
	 * depends on. This can provide even more readable task graphs which can be
	 * easier to maintain.
	 *
	 * If a final callback is specified, the task results are similarly injected,
	 * specified as named parameters after the initial error parameter.
	 *
	 * The autoInject function is purely syntactic sugar and its semantics are
	 * otherwise equivalent to [async.auto]{@link module:ControlFlow.auto}.
	 *
	 * @name autoInject
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.auto]{@link module:ControlFlow.auto}
	 * @category Control Flow
	 * @param {Object} tasks - An object, each of whose properties is a function of
	 * the form 'func([dependencies...], callback). The object's key of a property
	 * serves as the name of the task defined by that property, i.e. can be used
	 * when specifying requirements for other tasks.
	 * * The `callback` parameter is a `callback(err, result)` which must be called
	 *   when finished, passing an `error` (which can be `null`) and the result of
	 *   the function's execution. The remaining parameters name other tasks on
	 *   which the task is dependent, and the results from those tasks are the
	 *   arguments of those parameters.
	 * @param {Function} [callback] - An optional callback which is called when all
	 * the tasks have been completed. It receives the `err` argument if any `tasks`
	 * pass an error to their callback, and a `results` object with any completed
	 * task results, similar to `auto`.
	 * @example
	 *
	 * //  The example from `auto` can be rewritten as follows:
	 * async.autoInject({
	 *     get_data: function(callback) {
	 *         // async code to get some data
	 *         callback(null, 'data', 'converted to array');
	 *     },
	 *     make_folder: function(callback) {
	 *         // async code to create a directory to store a file in
	 *         // this is run at the same time as getting the data
	 *         callback(null, 'folder');
	 *     },
	 *     write_file: function(get_data, make_folder, callback) {
	 *         // once there is some data and the directory exists,
	 *         // write the data to a file in the directory
	 *         callback(null, 'filename');
	 *     },
	 *     email_link: function(write_file, callback) {
	 *         // once the file is written let's email a link to it...
	 *         // write_file contains the filename returned by write_file.
	 *         callback(null, {'file':write_file, 'email':'user@example.com'});
	 *     }
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('email_link = ', results.email_link);
	 * });
	 *
	 * // If you are using a JS minifier that mangles parameter names, `autoInject`
	 * // will not work with plain functions, since the parameter names will be
	 * // collapsed to a single letter identifier.  To work around this, you can
	 * // explicitly specify the names of the parameters your task function needs
	 * // in an array, similar to Angular.js dependency injection.
	 *
	 * // This still has an advantage over plain `auto`, since the results a task
	 * // depends on are still spread into arguments.
	 * async.autoInject({
	 *     //...
	 *     write_file: ['get_data', 'make_folder', function(get_data, make_folder, callback) {
	 *         callback(null, 'filename');
	 *     }],
	 *     email_link: ['write_file', function(write_file, callback) {
	 *         callback(null, {'file':write_file, 'email':'user@example.com'});
	 *     }]
	 *     //...
	 * }, function(err, results) {
	 *     console.log('err = ', err);
	 *     console.log('email_link = ', results.email_link);
	 * });
	 */
	function autoInject(tasks, callback) {
	    var newTasks = {};
	
	    baseForOwn(tasks, function (taskFn, key) {
	        var params;
	
	        if (isArray(taskFn)) {
	            params = copyArray(taskFn);
	            taskFn = params.pop();
	
	            newTasks[key] = params.concat(params.length > 0 ? newTask : taskFn);
	        } else if (taskFn.length === 1) {
	            // no dependencies, use the function as-is
	            newTasks[key] = taskFn;
	        } else {
	            params = parseParams(taskFn);
	            if (taskFn.length === 0 && params.length === 0) {
	                throw new Error("autoInject task functions require explicit parameters.");
	            }
	
	            params.pop();
	
	            newTasks[key] = params.concat(newTask);
	        }
	
	        function newTask(results, taskCb) {
	            var newArgs = arrayMap(params, function (name) {
	                return results[name];
	            });
	            newArgs.push(taskCb);
	            taskFn.apply(null, newArgs);
	        }
	    });
	
	    auto(newTasks, callback);
	}
	
	var hasSetImmediate = typeof setImmediate === 'function' && setImmediate;
	var hasNextTick = typeof process === 'object' && typeof process.nextTick === 'function';
	
	function fallback(fn) {
	    setTimeout(fn, 0);
	}
	
	function wrap(defer) {
	    return baseRest$1(function (fn, args) {
	        defer(function () {
	            fn.apply(null, args);
	        });
	    });
	}
	
	var _defer;
	
	if (hasSetImmediate) {
	    _defer = setImmediate;
	} else if (hasNextTick) {
	    _defer = process.nextTick;
	} else {
	    _defer = fallback;
	}
	
	var setImmediate$1 = wrap(_defer);
	
	// Simple doubly linked list (https://en.wikipedia.org/wiki/Doubly_linked_list) implementation
	// used for queues. This implementation assumes that the node provided by the user can be modified
	// to adjust the next and last properties. We implement only the minimal functionality
	// for queue support.
	function DLL() {
	    this.head = this.tail = null;
	    this.length = 0;
	}
	
	function setInitial(dll, node) {
	    dll.length = 1;
	    dll.head = dll.tail = node;
	}
	
	DLL.prototype.removeLink = function (node) {
	    if (node.prev) node.prev.next = node.next;else this.head = node.next;
	    if (node.next) node.next.prev = node.prev;else this.tail = node.prev;
	
	    node.prev = node.next = null;
	    this.length -= 1;
	    return node;
	};
	
	DLL.prototype.empty = DLL;
	
	DLL.prototype.insertAfter = function (node, newNode) {
	    newNode.prev = node;
	    newNode.next = node.next;
	    if (node.next) node.next.prev = newNode;else this.tail = newNode;
	    node.next = newNode;
	    this.length += 1;
	};
	
	DLL.prototype.insertBefore = function (node, newNode) {
	    newNode.prev = node.prev;
	    newNode.next = node;
	    if (node.prev) node.prev.next = newNode;else this.head = newNode;
	    node.prev = newNode;
	    this.length += 1;
	};
	
	DLL.prototype.unshift = function (node) {
	    if (this.head) this.insertBefore(this.head, node);else setInitial(this, node);
	};
	
	DLL.prototype.push = function (node) {
	    if (this.tail) this.insertAfter(this.tail, node);else setInitial(this, node);
	};
	
	DLL.prototype.shift = function () {
	    return this.head && this.removeLink(this.head);
	};
	
	DLL.prototype.pop = function () {
	    return this.tail && this.removeLink(this.tail);
	};
	
	function queue(worker, concurrency, payload) {
	    if (concurrency == null) {
	        concurrency = 1;
	    } else if (concurrency === 0) {
	        throw new Error('Concurrency must not be zero');
	    }
	
	    function _insert(data, insertAtFront, callback) {
	        if (callback != null && typeof callback !== 'function') {
	            throw new Error('task callback must be a function');
	        }
	        q.started = true;
	        if (!isArray(data)) {
	            data = [data];
	        }
	        if (data.length === 0 && q.idle()) {
	            // call drain immediately if there are no tasks
	            return setImmediate$1(function () {
	                q.drain();
	            });
	        }
	
	        for (var i = 0, l = data.length; i < l; i++) {
	            var item = {
	                data: data[i],
	                callback: callback || noop
	            };
	
	            if (insertAtFront) {
	                q._tasks.unshift(item);
	            } else {
	                q._tasks.push(item);
	            }
	        }
	        setImmediate$1(q.process);
	    }
	
	    function _next(tasks) {
	        return baseRest$1(function (args) {
	            workers -= 1;
	
	            for (var i = 0, l = tasks.length; i < l; i++) {
	                var task = tasks[i];
	                var index = baseIndexOf(workersList, task, 0);
	                if (index >= 0) {
	                    workersList.splice(index);
	                }
	
	                task.callback.apply(task, args);
	
	                if (args[0] != null) {
	                    q.error(args[0], task.data);
	                }
	            }
	
	            if (workers <= q.concurrency - q.buffer) {
	                q.unsaturated();
	            }
	
	            if (q.idle()) {
	                q.drain();
	            }
	            q.process();
	        });
	    }
	
	    var workers = 0;
	    var workersList = [];
	    var q = {
	        _tasks: new DLL(),
	        concurrency: concurrency,
	        payload: payload,
	        saturated: noop,
	        unsaturated: noop,
	        buffer: concurrency / 4,
	        empty: noop,
	        drain: noop,
	        error: noop,
	        started: false,
	        paused: false,
	        push: function (data, callback) {
	            _insert(data, false, callback);
	        },
	        kill: function () {
	            q.drain = noop;
	            q._tasks.empty();
	        },
	        unshift: function (data, callback) {
	            _insert(data, true, callback);
	        },
	        process: function () {
	            while (!q.paused && workers < q.concurrency && q._tasks.length) {
	                var tasks = [],
	                    data = [];
	                var l = q._tasks.length;
	                if (q.payload) l = Math.min(l, q.payload);
	                for (var i = 0; i < l; i++) {
	                    var node = q._tasks.shift();
	                    tasks.push(node);
	                    data.push(node.data);
	                }
	
	                if (q._tasks.length === 0) {
	                    q.empty();
	                }
	                workers += 1;
	                workersList.push(tasks[0]);
	
	                if (workers === q.concurrency) {
	                    q.saturated();
	                }
	
	                var cb = onlyOnce(_next(tasks));
	                worker(data, cb);
	            }
	        },
	        length: function () {
	            return q._tasks.length;
	        },
	        running: function () {
	            return workers;
	        },
	        workersList: function () {
	            return workersList;
	        },
	        idle: function () {
	            return q._tasks.length + workers === 0;
	        },
	        pause: function () {
	            q.paused = true;
	        },
	        resume: function () {
	            if (q.paused === false) {
	                return;
	            }
	            q.paused = false;
	            var resumeCount = Math.min(q.concurrency, q._tasks.length);
	            // Need to call q.process once per concurrent
	            // worker to preserve full concurrency after pause
	            for (var w = 1; w <= resumeCount; w++) {
	                setImmediate$1(q.process);
	            }
	        }
	    };
	    return q;
	}
	
	/**
	 * A cargo of tasks for the worker function to complete. Cargo inherits all of
	 * the same methods and event callbacks as [`queue`]{@link module:ControlFlow.queue}.
	 * @typedef {Object} CargoObject
	 * @memberOf module:ControlFlow
	 * @property {Function} length - A function returning the number of items
	 * waiting to be processed. Invoke like `cargo.length()`.
	 * @property {number} payload - An `integer` for determining how many tasks
	 * should be process per round. This property can be changed after a `cargo` is
	 * created to alter the payload on-the-fly.
	 * @property {Function} push - Adds `task` to the `queue`. The callback is
	 * called once the `worker` has finished processing the task. Instead of a
	 * single task, an array of `tasks` can be submitted. The respective callback is
	 * used for every task in the list. Invoke like `cargo.push(task, [callback])`.
	 * @property {Function} saturated - A callback that is called when the
	 * `queue.length()` hits the concurrency and further tasks will be queued.
	 * @property {Function} empty - A callback that is called when the last item
	 * from the `queue` is given to a `worker`.
	 * @property {Function} drain - A callback that is called when the last item
	 * from the `queue` has returned from the `worker`.
	 * @property {Function} idle - a function returning false if there are items
	 * waiting or being processed, or true if not. Invoke like `cargo.idle()`.
	 * @property {Function} pause - a function that pauses the processing of tasks
	 * until `resume()` is called. Invoke like `cargo.pause()`.
	 * @property {Function} resume - a function that resumes the processing of
	 * queued tasks when the queue is paused. Invoke like `cargo.resume()`.
	 * @property {Function} kill - a function that removes the `drain` callback and
	 * empties remaining tasks from the queue forcing it to go idle. Invoke like `cargo.kill()`.
	 */
	
	/**
	 * Creates a `cargo` object with the specified payload. Tasks added to the
	 * cargo will be processed altogether (up to the `payload` limit). If the
	 * `worker` is in progress, the task is queued until it becomes available. Once
	 * the `worker` has completed some tasks, each callback of those tasks is
	 * called. Check out [these](https://camo.githubusercontent.com/6bbd36f4cf5b35a0f11a96dcd2e97711ffc2fb37/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130382f62626330636662302d356632392d313165322d393734662d3333393763363464633835382e676966) [animations](https://camo.githubusercontent.com/f4810e00e1c5f5f8addbe3e9f49064fd5d102699/68747470733a2f2f662e636c6f75642e6769746875622e636f6d2f6173736574732f313637363837312f36383130312f38346339323036362d356632392d313165322d383134662d3964336430323431336266642e676966)
	 * for how `cargo` and `queue` work.
	 *
	 * While [`queue`]{@link module:ControlFlow.queue} passes only one task to one of a group of workers
	 * at a time, cargo passes an array of tasks to a single worker, repeating
	 * when the worker is finished.
	 *
	 * @name cargo
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.queue]{@link module:ControlFlow.queue}
	 * @category Control Flow
	 * @param {Function} worker - An asynchronous function for processing an array
	 * of queued tasks, which must call its `callback(err)` argument when finished,
	 * with an optional `err` argument. Invoked with `(tasks, callback)`.
	 * @param {number} [payload=Infinity] - An optional `integer` for determining
	 * how many tasks should be processed per round; if omitted, the default is
	 * unlimited.
	 * @returns {module:ControlFlow.CargoObject} A cargo object to manage the tasks. Callbacks can
	 * attached as certain properties to listen for specific events during the
	 * lifecycle of the cargo and inner queue.
	 * @example
	 *
	 * // create a cargo object with payload 2
	 * var cargo = async.cargo(function(tasks, callback) {
	 *     for (var i=0; i<tasks.length; i++) {
	 *         console.log('hello ' + tasks[i].name);
	 *     }
	 *     callback();
	 * }, 2);
	 *
	 * // add some items
	 * cargo.push({name: 'foo'}, function(err) {
	 *     console.log('finished processing foo');
	 * });
	 * cargo.push({name: 'bar'}, function(err) {
	 *     console.log('finished processing bar');
	 * });
	 * cargo.push({name: 'baz'}, function(err) {
	 *     console.log('finished processing baz');
	 * });
	 */
	function cargo(worker, payload) {
	  return queue(worker, 1, payload);
	}
	
	/**
	 * The same as [`eachOf`]{@link module:Collections.eachOf} but runs only a single async operation at a time.
	 *
	 * @name eachOfSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.eachOf]{@link module:Collections.eachOf}
	 * @alias forEachOfSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each item in `coll`. The
	 * `key` is the item's key, or index in the case of an array. The iteratee is
	 * passed a `callback(err)` which must be called once it has completed. If no
	 * error has occurred, the callback should be run without arguments or with an
	 * explicit `null` argument. Invoked with (item, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. Invoked with (err).
	 */
	var eachOfSeries = doLimit(eachOfLimit, 1);
	
	/**
	 * Reduces `coll` into a single value using an async `iteratee` to return each
	 * successive step. `memo` is the initial state of the reduction. This function
	 * only operates in series.
	 *
	 * For performance reasons, it may make sense to split a call to this function
	 * into a parallel map, and then use the normal `Array.prototype.reduce` on the
	 * results. This function is for situations where each step in the reduction
	 * needs to be async; if you can get the data before reducing it, then it's
	 * probably a good idea to do so.
	 *
	 * @name reduce
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias inject
	 * @alias foldl
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {*} memo - The initial state of the reduction.
	 * @param {Function} iteratee - A function applied to each item in the
	 * array to produce the next step in the reduction. The `iteratee` is passed a
	 * `callback(err, reduction)` which accepts an optional error as its first
	 * argument, and the state of the reduction as the second. If an error is
	 * passed to the callback, the reduction is stopped and the main `callback` is
	 * immediately called with the error. Invoked with (memo, item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the reduced value. Invoked with
	 * (err, result).
	 * @example
	 *
	 * async.reduce([1,2,3], 0, function(memo, item, callback) {
	 *     // pointless async:
	 *     process.nextTick(function() {
	 *         callback(null, memo + item)
	 *     });
	 * }, function(err, result) {
	 *     // result is now equal to the last value of memo, which is 6
	 * });
	 */
	function reduce(coll, memo, iteratee, callback) {
	    callback = once(callback || noop);
	    eachOfSeries(coll, function (x, i, callback) {
	        iteratee(memo, x, function (err, v) {
	            memo = v;
	            callback(err);
	        });
	    }, function (err) {
	        callback(err, memo);
	    });
	}
	
	/**
	 * Version of the compose function that is more natural to read. Each function
	 * consumes the return value of the previous function. It is the equivalent of
	 * [compose]{@link module:ControlFlow.compose} with the arguments reversed.
	 *
	 * Each function is executed with the `this` binding of the composed function.
	 *
	 * @name seq
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.compose]{@link module:ControlFlow.compose}
	 * @category Control Flow
	 * @param {...Function} functions - the asynchronous functions to compose
	 * @returns {Function} a function that composes the `functions` in order
	 * @example
	 *
	 * // Requires lodash (or underscore), express3 and dresende's orm2.
	 * // Part of an app, that fetches cats of the logged user.
	 * // This example uses `seq` function to avoid overnesting and error
	 * // handling clutter.
	 * app.get('/cats', function(request, response) {
	 *     var User = request.models.User;
	 *     async.seq(
	 *         _.bind(User.get, User),  // 'User.get' has signature (id, callback(err, data))
	 *         function(user, fn) {
	 *             user.getCats(fn);      // 'getCats' has signature (callback(err, data))
	 *         }
	 *     )(req.session.user_id, function (err, cats) {
	 *         if (err) {
	 *             console.error(err);
	 *             response.json({ status: 'error', message: err.message });
	 *         } else {
	 *             response.json({ status: 'ok', message: 'Cats found', data: cats });
	 *         }
	 *     });
	 * });
	 */
	var seq$1 = baseRest$1(function seq(functions) {
	    return baseRest$1(function (args) {
	        var that = this;
	
	        var cb = args[args.length - 1];
	        if (typeof cb == 'function') {
	            args.pop();
	        } else {
	            cb = noop;
	        }
	
	        reduce(functions, args, function (newargs, fn, cb) {
	            fn.apply(that, newargs.concat([baseRest$1(function (err, nextargs) {
	                cb(err, nextargs);
	            })]));
	        }, function (err, results) {
	            cb.apply(that, [err].concat(results));
	        });
	    });
	});
	
	/**
	 * Creates a function which is a composition of the passed asynchronous
	 * functions. Each function consumes the return value of the function that
	 * follows. Composing functions `f()`, `g()`, and `h()` would produce the result
	 * of `f(g(h()))`, only this version uses callbacks to obtain the return values.
	 *
	 * Each function is executed with the `this` binding of the composed function.
	 *
	 * @name compose
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {...Function} functions - the asynchronous functions to compose
	 * @returns {Function} an asynchronous function that is the composed
	 * asynchronous `functions`
	 * @example
	 *
	 * function add1(n, callback) {
	 *     setTimeout(function () {
	 *         callback(null, n + 1);
	 *     }, 10);
	 * }
	 *
	 * function mul3(n, callback) {
	 *     setTimeout(function () {
	 *         callback(null, n * 3);
	 *     }, 10);
	 * }
	 *
	 * var add1mul3 = async.compose(mul3, add1);
	 * add1mul3(4, function (err, result) {
	 *     // result now equals 15
	 * });
	 */
	var compose = baseRest$1(function (args) {
	  return seq$1.apply(null, args.reverse());
	});
	
	function concat$1(eachfn, arr, fn, callback) {
	    var result = [];
	    eachfn(arr, function (x, index, cb) {
	        fn(x, function (err, y) {
	            result = result.concat(y || []);
	            cb(err);
	        });
	    }, function (err) {
	        callback(err, result);
	    });
	}
	
	/**
	 * Applies `iteratee` to each item in `coll`, concatenating the results. Returns
	 * the concatenated list. The `iteratee`s are called in parallel, and the
	 * results are concatenated as they return. There is no guarantee that the
	 * results array will be returned in the original order of `coll` passed to the
	 * `iteratee` function.
	 *
	 * @name concat
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, results)` which must be called once
	 * it has completed with an error (which can be `null`) and an array of results.
	 * Invoked with (item, callback).
	 * @param {Function} [callback(err)] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 * @example
	 *
	 * async.concat(['dir1','dir2','dir3'], fs.readdir, function(err, files) {
	 *     // files is now a list of filenames that exist in the 3 directories
	 * });
	 */
	var concat = doParallel(concat$1);
	
	function doSeries(fn) {
	    return function (obj, iteratee, callback) {
	        return fn(eachOfSeries, obj, iteratee, callback);
	    };
	}
	
	/**
	 * The same as [`concat`]{@link module:Collections.concat} but runs only a single async operation at a time.
	 *
	 * @name concatSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.concat]{@link module:Collections.concat}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, results)` which must be called once
	 * it has completed with an error (which can be `null`) and an array of results.
	 * Invoked with (item, callback).
	 * @param {Function} [callback(err)] - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is an array
	 * containing the concatenated results of the `iteratee` function. Invoked with
	 * (err, results).
	 */
	var concatSeries = doSeries(concat$1);
	
	/**
	 * Returns a function that when called, calls-back with the values provided.
	 * Useful as the first function in a [`waterfall`]{@link module:ControlFlow.waterfall}, or for plugging values in to
	 * [`auto`]{@link module:ControlFlow.auto}.
	 *
	 * @name constant
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {...*} arguments... - Any number of arguments to automatically invoke
	 * callback with.
	 * @returns {Function} Returns a function that when invoked, automatically
	 * invokes the callback with the previous given arguments.
	 * @example
	 *
	 * async.waterfall([
	 *     async.constant(42),
	 *     function (value, next) {
	 *         // value === 42
	 *     },
	 *     //...
	 * ], callback);
	 *
	 * async.waterfall([
	 *     async.constant(filename, "utf8"),
	 *     fs.readFile,
	 *     function (fileData, next) {
	 *         //...
	 *     }
	 *     //...
	 * ], callback);
	 *
	 * async.auto({
	 *     hostname: async.constant("https://server.net/"),
	 *     port: findFreePort,
	 *     launchServer: ["hostname", "port", function (options, cb) {
	 *         startServer(options, cb);
	 *     }],
	 *     //...
	 * }, callback);
	 */
	var constant$2 = baseRest$1(function (values) {
	    var args = [null].concat(values);
	    return initialParams(function (ignoredArgs, callback) {
	        return callback.apply(this, args);
	    });
	});
	
	function _createTester(eachfn, check, getResult) {
	    return function (arr, limit, iteratee, cb) {
	        function done() {
	            if (cb) {
	                cb(null, getResult(false));
	            }
	        }
	        function wrappedIteratee(x, _, callback) {
	            if (!cb) return callback();
	            iteratee(x, function (err, v) {
	                // Check cb as another iteratee may have resolved with a
	                // value or error since we started this iteratee
	                if (cb && (err || check(v))) {
	                    if (err) cb(err);else cb(err, getResult(true, x));
	                    cb = iteratee = false;
	                    callback(err, breakLoop);
	                } else {
	                    callback();
	                }
	            });
	        }
	        if (arguments.length > 3) {
	            cb = cb || noop;
	            eachfn(arr, limit, wrappedIteratee, done);
	        } else {
	            cb = iteratee;
	            cb = cb || noop;
	            iteratee = limit;
	            eachfn(arr, wrappedIteratee, done);
	        }
	    };
	}
	
	function _findGetResult(v, x) {
	    return x;
	}
	
	/**
	 * Returns the first value in `coll` that passes an async truth test. The
	 * `iteratee` is applied in parallel, meaning the first iteratee to return
	 * `true` will fire the detect `callback` with that result. That means the
	 * result might not be the first item in the original `coll` (in terms of order)
	 * that passes the test.
	
	 * If order within the original `coll` is important, then look at
	 * [`detectSeries`]{@link module:Collections.detectSeries}.
	 *
	 * @name detect
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias find
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, truthValue)` which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 * @example
	 *
	 * async.detect(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // result now equals the first file in the list that exists
	 * });
	 */
	var detect = _createTester(eachOf, identity, _findGetResult);
	
	/**
	 * The same as [`detect`]{@link module:Collections.detect} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name detectLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.detect]{@link module:Collections.detect}
	 * @alias findLimit
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, truthValue)` which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 */
	var detectLimit = _createTester(eachOfLimit, identity, _findGetResult);
	
	/**
	 * The same as [`detect`]{@link module:Collections.detect} but runs only a single async operation at a time.
	 *
	 * @name detectSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.detect]{@link module:Collections.detect}
	 * @alias findSeries
	 * @category Collections
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, truthValue)` which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the `iteratee` functions have finished.
	 * Result will be the first item in the array that passes the truth test
	 * (iteratee) or the value `undefined` if none passed. Invoked with
	 * (err, result).
	 */
	var detectSeries = _createTester(eachOfSeries, identity, _findGetResult);
	
	function consoleFunc(name) {
	    return baseRest$1(function (fn, args) {
	        fn.apply(null, args.concat([baseRest$1(function (err, args) {
	            if (typeof console === 'object') {
	                if (err) {
	                    if (console.error) {
	                        console.error(err);
	                    }
	                } else if (console[name]) {
	                    arrayEach(args, function (x) {
	                        console[name](x);
	                    });
	                }
	            }
	        })]));
	    });
	}
	
	/**
	 * Logs the result of an `async` function to the `console` using `console.dir`
	 * to display the properties of the resulting object. Only works in Node.js or
	 * in browsers that support `console.dir` and `console.error` (such as FF and
	 * Chrome). If multiple arguments are returned from the async function,
	 * `console.dir` is called on each argument in order.
	 *
	 * @name dir
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} function - The function you want to eventually apply all
	 * arguments to.
	 * @param {...*} arguments... - Any number of arguments to apply to the function.
	 * @example
	 *
	 * // in a module
	 * var hello = function(name, callback) {
	 *     setTimeout(function() {
	 *         callback(null, {hello: name});
	 *     }, 1000);
	 * };
	 *
	 * // in the node repl
	 * node> async.dir(hello, 'world');
	 * {hello: 'world'}
	 */
	var dir = consoleFunc('dir');
	
	/**
	 * The post-check version of [`during`]{@link module:ControlFlow.during}. To reflect the difference in
	 * the order of operations, the arguments `test` and `fn` are switched.
	 *
	 * Also a version of [`doWhilst`]{@link module:ControlFlow.doWhilst} with asynchronous `test` function.
	 * @name doDuring
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.during]{@link module:ControlFlow.during}
	 * @category Control Flow
	 * @param {Function} fn - A function which is called each time `test` passes.
	 * The function is passed a `callback(err)`, which must be called once it has
	 * completed with an optional `err` argument. Invoked with (callback).
	 * @param {Function} test - asynchronous truth test to perform before each
	 * execution of `fn`. Invoked with (...args, callback), where `...args` are the
	 * non-error args from the previous callback of `fn`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error if one occured, otherwise `null`.
	 */
	function doDuring(fn, test, callback) {
	    callback = onlyOnce(callback || noop);
	
	    var next = baseRest$1(function (err, args) {
	        if (err) return callback(err);
	        args.push(check);
	        test.apply(this, args);
	    });
	
	    function check(err, truth) {
	        if (err) return callback(err);
	        if (!truth) return callback(null);
	        fn(next);
	    }
	
	    check(null, true);
	}
	
	/**
	 * The post-check version of [`whilst`]{@link module:ControlFlow.whilst}. To reflect the difference in
	 * the order of operations, the arguments `test` and `iteratee` are switched.
	 *
	 * `doWhilst` is to `whilst` as `do while` is to `while` in plain JavaScript.
	 *
	 * @name doWhilst
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {Function} iteratee - A function which is called each time `test`
	 * passes. The function is passed a `callback(err)`, which must be called once
	 * it has completed with an optional `err` argument. Invoked with (callback).
	 * @param {Function} test - synchronous truth test to perform after each
	 * execution of `iteratee`. Invoked with the non-error callback results of 
	 * `iteratee`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `iteratee` has stopped.
	 * `callback` will be passed an error and any arguments passed to the final
	 * `iteratee`'s callback. Invoked with (err, [results]);
	 */
	function doWhilst(iteratee, test, callback) {
	    callback = onlyOnce(callback || noop);
	    var next = baseRest$1(function (err, args) {
	        if (err) return callback(err);
	        if (test.apply(this, args)) return iteratee(next);
	        callback.apply(null, [null].concat(args));
	    });
	    iteratee(next);
	}
	
	/**
	 * Like ['doWhilst']{@link module:ControlFlow.doWhilst}, except the `test` is inverted. Note the
	 * argument ordering differs from `until`.
	 *
	 * @name doUntil
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.doWhilst]{@link module:ControlFlow.doWhilst}
	 * @category Control Flow
	 * @param {Function} fn - A function which is called each time `test` fails.
	 * The function is passed a `callback(err)`, which must be called once it has
	 * completed with an optional `err` argument. Invoked with (callback).
	 * @param {Function} test - synchronous truth test to perform after each
	 * execution of `fn`. Invoked with the non-error callback results of `fn`.
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has passed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `fn`'s
	 * callback. Invoked with (err, [results]);
	 */
	function doUntil(fn, test, callback) {
	    doWhilst(fn, function () {
	        return !test.apply(this, arguments);
	    }, callback);
	}
	
	/**
	 * Like [`whilst`]{@link module:ControlFlow.whilst}, except the `test` is an asynchronous function that
	 * is passed a callback in the form of `function (err, truth)`. If error is
	 * passed to `test` or `fn`, the main callback is immediately called with the
	 * value of the error.
	 *
	 * @name during
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {Function} test - asynchronous truth test to perform before each
	 * execution of `fn`. Invoked with (callback).
	 * @param {Function} fn - A function which is called each time `test` passes.
	 * The function is passed a `callback(err)`, which must be called once it has
	 * completed with an optional `err` argument. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error, if one occured, otherwise `null`.
	 * @example
	 *
	 * var count = 0;
	 *
	 * async.during(
	 *     function (callback) {
	 *         return callback(null, count < 5);
	 *     },
	 *     function (callback) {
	 *         count++;
	 *         setTimeout(callback, 1000);
	 *     },
	 *     function (err) {
	 *         // 5 seconds have passed
	 *     }
	 * );
	 */
	function during(test, fn, callback) {
	    callback = onlyOnce(callback || noop);
	
	    function next(err) {
	        if (err) return callback(err);
	        test(check);
	    }
	
	    function check(err, truth) {
	        if (err) return callback(err);
	        if (!truth) return callback(null);
	        fn(next);
	    }
	
	    test(check);
	}
	
	function _withoutIndex(iteratee) {
	    return function (value, index, callback) {
	        return iteratee(value, callback);
	    };
	}
	
	/**
	 * Applies the function `iteratee` to each item in `coll`, in parallel.
	 * The `iteratee` is called with an item from the list, and a callback for when
	 * it has finished. If the `iteratee` passes an error to its `callback`, the
	 * main `callback` (for the `each` function) is immediately called with the
	 * error.
	 *
	 * Note, that since this function applies `iteratee` to each item in parallel,
	 * there is no guarantee that the iteratee functions will complete in order.
	 *
	 * @name each
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias forEach
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each item
	 * in `coll`. The iteratee is passed a `callback(err)` which must be called once
	 * it has completed. If no error has occurred, the `callback` should be run
	 * without arguments or with an explicit `null` argument. The array index is not
	 * passed to the iteratee. Invoked with (item, callback). If you need the index,
	 * use `eachOf`.
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 * @example
	 *
	 * // assuming openFiles is an array of file names and saveFile is a function
	 * // to save the modified contents of that file:
	 *
	 * async.each(openFiles, saveFile, function(err){
	 *   // if any of the saves produced an error, err would equal that error
	 * });
	 *
	 * // assuming openFiles is an array of file names
	 * async.each(openFiles, function(file, callback) {
	 *
	 *     // Perform operation on file here.
	 *     console.log('Processing file ' + file);
	 *
	 *     if( file.length > 32 ) {
	 *       console.log('This file name is too long');
	 *       callback('File name too long');
	 *     } else {
	 *       // Do work to process file here
	 *       console.log('File processed');
	 *       callback();
	 *     }
	 * }, function(err) {
	 *     // if any of the file processing produced an error, err would equal that error
	 *     if( err ) {
	 *       // One of the iterations produced an error.
	 *       // All processing will now stop.
	 *       console.log('A file failed to process');
	 *     } else {
	 *       console.log('All files have been processed successfully');
	 *     }
	 * });
	 */
	function eachLimit(coll, iteratee, callback) {
	  eachOf(coll, _withoutIndex(iteratee), callback);
	}
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name eachLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A function to apply to each item in `coll`. The
	 * iteratee is passed a `callback(err)` which must be called once it has
	 * completed. If no error has occurred, the `callback` should be run without
	 * arguments or with an explicit `null` argument. The array index is not passed
	 * to the iteratee. Invoked with (item, callback). If you need the index, use
	 * `eachOfLimit`.
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	function eachLimit$1(coll, limit, iteratee, callback) {
	  _eachOfLimit(limit)(coll, _withoutIndex(iteratee), callback);
	}
	
	/**
	 * The same as [`each`]{@link module:Collections.each} but runs only a single async operation at a time.
	 *
	 * @name eachSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.each]{@link module:Collections.each}
	 * @alias forEachSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each
	 * item in `coll`. The iteratee is passed a `callback(err)` which must be called
	 * once it has completed. If no error has occurred, the `callback` should be run
	 * without arguments or with an explicit `null` argument. The array index is
	 * not passed to the iteratee. Invoked with (item, callback). If you need the
	 * index, use `eachOfSeries`.
	 * @param {Function} [callback] - A callback which is called when all
	 * `iteratee` functions have finished, or an error occurs. Invoked with (err).
	 */
	var eachSeries = doLimit(eachLimit$1, 1);
	
	/**
	 * Wrap an async function and ensure it calls its callback on a later tick of
	 * the event loop.  If the function already calls its callback on a next tick,
	 * no extra deferral is added. This is useful for preventing stack overflows
	 * (`RangeError: Maximum call stack size exceeded`) and generally keeping
	 * [Zalgo](http://blog.izs.me/post/59142742143/designing-apis-for-asynchrony)
	 * contained.
	 *
	 * @name ensureAsync
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} fn - an async function, one that expects a node-style
	 * callback as its last argument.
	 * @returns {Function} Returns a wrapped function with the exact same call
	 * signature as the function passed in.
	 * @example
	 *
	 * function sometimesAsync(arg, callback) {
	 *     if (cache[arg]) {
	 *         return callback(null, cache[arg]); // this would be synchronous!!
	 *     } else {
	 *         doSomeIO(arg, callback); // this IO would be asynchronous
	 *     }
	 * }
	 *
	 * // this has a risk of stack overflows if many results are cached in a row
	 * async.mapSeries(args, sometimesAsync, done);
	 *
	 * // this will defer sometimesAsync's callback if necessary,
	 * // preventing stack overflows
	 * async.mapSeries(args, async.ensureAsync(sometimesAsync), done);
	 */
	function ensureAsync(fn) {
	    return initialParams(function (args, callback) {
	        var sync = true;
	        args.push(function () {
	            var innerArgs = arguments;
	            if (sync) {
	                setImmediate$1(function () {
	                    callback.apply(null, innerArgs);
	                });
	            } else {
	                callback.apply(null, innerArgs);
	            }
	        });
	        fn.apply(this, args);
	        sync = false;
	    });
	}
	
	function notId(v) {
	    return !v;
	}
	
	/**
	 * Returns `true` if every element in `coll` satisfies an async test. If any
	 * iteratee call returns `false`, the main `callback` is immediately called.
	 *
	 * @name every
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias all
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in the
	 * collection in parallel. The iteratee is passed a `callback(err, truthValue)`
	 * which must be called with a  boolean argument once it has completed. Invoked
	 * with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 * @example
	 *
	 * async.every(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // if result is true then every file exists
	 * });
	 */
	var every = _createTester(eachOf, notId, notId);
	
	/**
	 * The same as [`every`]{@link module:Collections.every} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name everyLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.every]{@link module:Collections.every}
	 * @alias allLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A truth test to apply to each item in the
	 * collection in parallel. The iteratee is passed a `callback(err, truthValue)`
	 * which must be called with a  boolean argument once it has completed. Invoked
	 * with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 */
	var everyLimit = _createTester(eachOfLimit, notId, notId);
	
	/**
	 * The same as [`every`]{@link module:Collections.every} but runs only a single async operation at a time.
	 *
	 * @name everySeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.every]{@link module:Collections.every}
	 * @alias allSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in the
	 * collection in parallel. The iteratee is passed a `callback(err, truthValue)`
	 * which must be called with a  boolean argument once it has completed. Invoked
	 * with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result will be either `true` or `false`
	 * depending on the values of the async tests. Invoked with (err, result).
	 */
	var everySeries = doLimit(everyLimit, 1);
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	function _filter(eachfn, arr, iteratee, callback) {
	    callback = once(callback || noop);
	    var results = [];
	    eachfn(arr, function (x, index, callback) {
	        iteratee(x, function (err, v) {
	            if (err) {
	                callback(err);
	            } else {
	                if (v) {
	                    results.push({ index: index, value: x });
	                }
	                callback();
	            }
	        });
	    }, function (err) {
	        if (err) {
	            callback(err);
	        } else {
	            callback(null, arrayMap(results.sort(function (a, b) {
	                return a.index - b.index;
	            }), baseProperty('value')));
	        }
	    });
	}
	
	/**
	 * Returns a new array of all the values in `coll` which pass an async truth
	 * test. This operation is performed in parallel, but the results array will be
	 * in the same order as the original.
	 *
	 * @name filter
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias select
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 * @example
	 *
	 * async.filter(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, results) {
	 *     // results now equals an array of the existing files
	 * });
	 */
	var filter = doParallel(_filter);
	
	/**
	 * The same as [`filter`]{@link module:Collections.filter} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name filterLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @alias selectLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var filterLimit = doParallelLimit(_filter);
	
	/**
	 * The same as [`filter`]{@link module:Collections.filter} but runs only a single async operation at a time.
	 *
	 * @name filterSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @alias selectSeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results)
	 */
	var filterSeries = doLimit(filterLimit, 1);
	
	/**
	 * Calls the asynchronous function `fn` with a callback parameter that allows it
	 * to call itself again, in series, indefinitely.
	
	 * If an error is passed to the
	 * callback then `errback` is called with the error, and execution stops,
	 * otherwise it will never be called.
	 *
	 * @name forever
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Function} fn - a function to call repeatedly. Invoked with (next).
	 * @param {Function} [errback] - when `fn` passes an error to it's callback,
	 * this function will be called, and execution stops. Invoked with (err).
	 * @example
	 *
	 * async.forever(
	 *     function(next) {
	 *         // next is suitable for passing to things that need a callback(err [, whatever]);
	 *         // it will result in this function being called again.
	 *     },
	 *     function(err) {
	 *         // if next is called with a value in its first parameter, it will appear
	 *         // in here as 'err', and execution will stop.
	 *     }
	 * );
	 */
	function forever(fn, errback) {
	    var done = onlyOnce(errback || noop);
	    var task = ensureAsync(fn);
	
	    function next(err) {
	        if (err) return done(err);
	        task(next);
	    }
	    next();
	}
	
	/**
	 * Logs the result of an `async` function to the `console`. Only works in
	 * Node.js or in browsers that support `console.log` and `console.error` (such
	 * as FF and Chrome). If multiple arguments are returned from the async
	 * function, `console.log` is called on each argument in order.
	 *
	 * @name log
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} function - The function you want to eventually apply all
	 * arguments to.
	 * @param {...*} arguments... - Any number of arguments to apply to the function.
	 * @example
	 *
	 * // in a module
	 * var hello = function(name, callback) {
	 *     setTimeout(function() {
	 *         callback(null, 'hello ' + name);
	 *     }, 1000);
	 * };
	 *
	 * // in the node repl
	 * node> async.log(hello, 'world');
	 * 'hello world'
	 */
	var log = consoleFunc('log');
	
	/**
	 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name mapValuesLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.mapValues]{@link module:Collections.mapValues}
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A function to apply to each value in `obj`.
	 * The iteratee is passed a `callback(err, transformed)` which must be called
	 * once it has completed with an error (which can be `null`) and a
	 * transformed value. Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 */
	function mapValuesLimit(obj, limit, iteratee, callback) {
	    callback = once(callback || noop);
	    var newObj = {};
	    eachOfLimit(obj, limit, function (val, key, next) {
	        iteratee(val, key, function (err, result) {
	            if (err) return next(err);
	            newObj[key] = result;
	            next();
	        });
	    }, function (err) {
	        callback(err, newObj);
	    });
	}
	
	/**
	 * A relative of [`map`]{@link module:Collections.map}, designed for use with objects.
	 *
	 * Produces a new Object by mapping each value of `obj` through the `iteratee`
	 * function. The `iteratee` is called each `value` and `key` from `obj` and a
	 * callback for when it has finished processing. Each of these callbacks takes
	 * two arguments: an `error`, and the transformed item from `obj`. If `iteratee`
	 * passes an error to its callback, the main `callback` (for the `mapValues`
	 * function) is immediately called with the error.
	 *
	 * Note, the order of the keys in the result is not guaranteed.  The keys will
	 * be roughly in the order they complete, (but this is very engine-specific)
	 *
	 * @name mapValues
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each value and key in
	 * `coll`. The iteratee is passed a `callback(err, transformed)` which must be
	 * called once it has completed with an error (which can be `null`) and a
	 * transformed value. Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 * @example
	 *
	 * async.mapValues({
	 *     f1: 'file1',
	 *     f2: 'file2',
	 *     f3: 'file3'
	 * }, function (file, key, callback) {
	 *   fs.stat(file, callback);
	 * }, function(err, result) {
	 *     // result is now a map of stats for each file, e.g.
	 *     // {
	 *     //     f1: [stats for file1],
	 *     //     f2: [stats for file2],
	 *     //     f3: [stats for file3]
	 *     // }
	 * });
	 */
	
	var mapValues = doLimit(mapValuesLimit, Infinity);
	
	/**
	 * The same as [`mapValues`]{@link module:Collections.mapValues} but runs only a single async operation at a time.
	 *
	 * @name mapValuesSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.mapValues]{@link module:Collections.mapValues}
	 * @category Collection
	 * @param {Object} obj - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each value in `obj`.
	 * The iteratee is passed a `callback(err, transformed)` which must be called
	 * once it has completed with an error (which can be `null`) and a
	 * transformed value. Invoked with (value, key, callback).
	 * @param {Function} [callback] - A callback which is called when all `iteratee`
	 * functions have finished, or an error occurs. `result` is a new object consisting
	 * of each key from `obj`, with each transformed value on the right-hand side.
	 * Invoked with (err, result).
	 */
	var mapValuesSeries = doLimit(mapValuesLimit, 1);
	
	function has(obj, key) {
	    return key in obj;
	}
	
	/**
	 * Caches the results of an `async` function. When creating a hash to store
	 * function results against, the callback is omitted from the hash and an
	 * optional hash function can be used.
	 *
	 * If no hash function is specified, the first argument is used as a hash key,
	 * which may work reasonably if it is a string or a data type that converts to a
	 * distinct string. Note that objects and arrays will not behave reasonably.
	 * Neither will cases where the other arguments are significant. In such cases,
	 * specify your own hash function.
	 *
	 * The cache of results is exposed as the `memo` property of the function
	 * returned by `memoize`.
	 *
	 * @name memoize
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} fn - The function to proxy and cache results from.
	 * @param {Function} hasher - An optional function for generating a custom hash
	 * for storing results. It has all the arguments applied to it apart from the
	 * callback, and must be synchronous.
	 * @returns {Function} a memoized version of `fn`
	 * @example
	 *
	 * var slow_fn = function(name, callback) {
	 *     // do something
	 *     callback(null, result);
	 * };
	 * var fn = async.memoize(slow_fn);
	 *
	 * // fn can now be used as if it were slow_fn
	 * fn('some name', function() {
	 *     // callback
	 * });
	 */
	function memoize(fn, hasher) {
	    var memo = Object.create(null);
	    var queues = Object.create(null);
	    hasher = hasher || identity;
	    var memoized = initialParams(function memoized(args, callback) {
	        var key = hasher.apply(null, args);
	        if (has(memo, key)) {
	            setImmediate$1(function () {
	                callback.apply(null, memo[key]);
	            });
	        } else if (has(queues, key)) {
	            queues[key].push(callback);
	        } else {
	            queues[key] = [callback];
	            fn.apply(null, args.concat([baseRest$1(function (args) {
	                memo[key] = args;
	                var q = queues[key];
	                delete queues[key];
	                for (var i = 0, l = q.length; i < l; i++) {
	                    q[i].apply(null, args);
	                }
	            })]));
	        }
	    });
	    memoized.memo = memo;
	    memoized.unmemoized = fn;
	    return memoized;
	}
	
	/**
	 * Calls `callback` on a later loop around the event loop. In Node.js this just
	 * calls `setImmediate`.  In the browser it will use `setImmediate` if
	 * available, otherwise `setTimeout(callback, 0)`, which means other higher
	 * priority events may precede the execution of `callback`.
	 *
	 * This is used internally for browser-compatibility purposes.
	 *
	 * @name nextTick
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @alias setImmediate
	 * @category Util
	 * @param {Function} callback - The function to call on a later loop around
	 * the event loop. Invoked with (args...).
	 * @param {...*} args... - any number of additional arguments to pass to the
	 * callback on the next tick.
	 * @example
	 *
	 * var call_order = [];
	 * async.nextTick(function() {
	 *     call_order.push('two');
	 *     // call_order now equals ['one','two']
	 * });
	 * call_order.push('one');
	 *
	 * async.setImmediate(function (a, b, c) {
	 *     // a, b, and c equal 1, 2, and 3
	 * }, 1, 2, 3);
	 */
	var _defer$1;
	
	if (hasNextTick) {
	    _defer$1 = process.nextTick;
	} else if (hasSetImmediate) {
	    _defer$1 = setImmediate;
	} else {
	    _defer$1 = fallback;
	}
	
	var nextTick = wrap(_defer$1);
	
	function _parallel(eachfn, tasks, callback) {
	    callback = callback || noop;
	    var results = isArrayLike(tasks) ? [] : {};
	
	    eachfn(tasks, function (task, key, callback) {
	        task(baseRest$1(function (err, args) {
	            if (args.length <= 1) {
	                args = args[0];
	            }
	            results[key] = args;
	            callback(err);
	        }));
	    }, function (err) {
	        callback(err, results);
	    });
	}
	
	/**
	 * Run the `tasks` collection of functions in parallel, without waiting until
	 * the previous function has completed. If any of the functions pass an error to
	 * its callback, the main `callback` is immediately called with the value of the
	 * error. Once the `tasks` have completed, the results are passed to the final
	 * `callback` as an array.
	 *
	 * **Note:** `parallel` is about kicking-off I/O tasks in parallel, not about
	 * parallel execution of code.  If your tasks do not use any timers or perform
	 * any I/O, they will actually be executed in series.  Any synchronous setup
	 * sections for each task will happen one after the other.  JavaScript remains
	 * single-threaded.
	 *
	 * It is also possible to use an object instead of an array. Each property will
	 * be run as a function and the results will be passed to the final `callback`
	 * as an object instead of an array. This can be a more readable way of handling
	 * results from {@link async.parallel}.
	 *
	 * @name parallel
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection containing functions to run.
	 * Each function is passed a `callback(err, result)` which it must call on
	 * completion with an error `err` (which can be `null`) and an optional `result`
	 * value.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed successfully. This function gets a results array
	 * (or object) containing all the result arguments passed to the task callbacks.
	 * Invoked with (err, results).
	 * @example
	 * async.parallel([
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // the results array will equal ['one','two'] even though
	 *     // the second function had a shorter timeout.
	 * });
	 *
	 * // an example using an object instead of an array
	 * async.parallel({
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 1);
	 *         }, 200);
	 *     },
	 *     two: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 2);
	 *         }, 100);
	 *     }
	 * }, function(err, results) {
	 *     // results is now equals to: {one: 1, two: 2}
	 * });
	 */
	function parallelLimit(tasks, callback) {
	  _parallel(eachOf, tasks, callback);
	}
	
	/**
	 * The same as [`parallel`]{@link module:ControlFlow.parallel} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name parallelLimit
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.parallel]{@link module:ControlFlow.parallel}
	 * @category Control Flow
	 * @param {Array|Collection} tasks - A collection containing functions to run.
	 * Each function is passed a `callback(err, result)` which it must call on
	 * completion with an error `err` (which can be `null`) and an optional `result`
	 * value.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed successfully. This function gets a results array
	 * (or object) containing all the result arguments passed to the task callbacks.
	 * Invoked with (err, results).
	 */
	function parallelLimit$1(tasks, limit, callback) {
	  _parallel(_eachOfLimit(limit), tasks, callback);
	}
	
	/**
	 * A queue of tasks for the worker function to complete.
	 * @typedef {Object} QueueObject
	 * @memberOf module:ControlFlow
	 * @property {Function} length - a function returning the number of items
	 * waiting to be processed. Invoke with `queue.length()`.
	 * @property {boolean} started - a boolean indicating whether or not any
	 * items have been pushed and processed by the queue.
	 * @property {Function} running - a function returning the number of items
	 * currently being processed. Invoke with `queue.running()`.
	 * @property {Function} workersList - a function returning the array of items
	 * currently being processed. Invoke with `queue.workersList()`.
	 * @property {Function} idle - a function returning false if there are items
	 * waiting or being processed, or true if not. Invoke with `queue.idle()`.
	 * @property {number} concurrency - an integer for determining how many `worker`
	 * functions should be run in parallel. This property can be changed after a
	 * `queue` is created to alter the concurrency on-the-fly.
	 * @property {Function} push - add a new task to the `queue`. Calls `callback`
	 * once the `worker` has finished processing the task. Instead of a single task,
	 * a `tasks` array can be submitted. The respective callback is used for every
	 * task in the list. Invoke with `queue.push(task, [callback])`,
	 * @property {Function} unshift - add a new task to the front of the `queue`.
	 * Invoke with `queue.unshift(task, [callback])`.
	 * @property {Function} saturated - a callback that is called when the number of
	 * running workers hits the `concurrency` limit, and further tasks will be
	 * queued.
	 * @property {Function} unsaturated - a callback that is called when the number
	 * of running workers is less than the `concurrency` & `buffer` limits, and
	 * further tasks will not be queued.
	 * @property {number} buffer - A minimum threshold buffer in order to say that
	 * the `queue` is `unsaturated`.
	 * @property {Function} empty - a callback that is called when the last item
	 * from the `queue` is given to a `worker`.
	 * @property {Function} drain - a callback that is called when the last item
	 * from the `queue` has returned from the `worker`.
	 * @property {Function} error - a callback that is called when a task errors.
	 * Has the signature `function(error, task)`.
	 * @property {boolean} paused - a boolean for determining whether the queue is
	 * in a paused state.
	 * @property {Function} pause - a function that pauses the processing of tasks
	 * until `resume()` is called. Invoke with `queue.pause()`.
	 * @property {Function} resume - a function that resumes the processing of
	 * queued tasks when the queue is paused. Invoke with `queue.resume()`.
	 * @property {Function} kill - a function that removes the `drain` callback and
	 * empties remaining tasks from the queue forcing it to go idle. Invoke with `queue.kill()`.
	 */
	
	/**
	 * Creates a `queue` object with the specified `concurrency`. Tasks added to the
	 * `queue` are processed in parallel (up to the `concurrency` limit). If all
	 * `worker`s are in progress, the task is queued until one becomes available.
	 * Once a `worker` completes a `task`, that `task`'s callback is called.
	 *
	 * @name queue
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Function} worker - An asynchronous function for processing a queued
	 * task, which must call its `callback(err)` argument when finished, with an
	 * optional `error` as an argument.  If you want to handle errors from an
	 * individual task, pass a callback to `q.push()`. Invoked with
	 * (task, callback).
	 * @param {number} [concurrency=1] - An `integer` for determining how many
	 * `worker` functions should be run in parallel.  If omitted, the concurrency
	 * defaults to `1`.  If the concurrency is `0`, an error is thrown.
	 * @returns {module:ControlFlow.QueueObject} A queue object to manage the tasks. Callbacks can
	 * attached as certain properties to listen for specific events during the
	 * lifecycle of the queue.
	 * @example
	 *
	 * // create a queue object with concurrency 2
	 * var q = async.queue(function(task, callback) {
	 *     console.log('hello ' + task.name);
	 *     callback();
	 * }, 2);
	 *
	 * // assign a callback
	 * q.drain = function() {
	 *     console.log('all items have been processed');
	 * };
	 *
	 * // add some items to the queue
	 * q.push({name: 'foo'}, function(err) {
	 *     console.log('finished processing foo');
	 * });
	 * q.push({name: 'bar'}, function (err) {
	 *     console.log('finished processing bar');
	 * });
	 *
	 * // add some items to the queue (batch-wise)
	 * q.push([{name: 'baz'},{name: 'bay'},{name: 'bax'}], function(err) {
	 *     console.log('finished processing item');
	 * });
	 *
	 * // add some items to the front of the queue
	 * q.unshift({name: 'bar'}, function (err) {
	 *     console.log('finished processing bar');
	 * });
	 */
	var queue$1 = function (worker, concurrency) {
	  return queue(function (items, cb) {
	    worker(items[0], cb);
	  }, concurrency, 1);
	};
	
	/**
	 * The same as [async.queue]{@link module:ControlFlow.queue} only tasks are assigned a priority and
	 * completed in ascending priority order.
	 *
	 * @name priorityQueue
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.queue]{@link module:ControlFlow.queue}
	 * @category Control Flow
	 * @param {Function} worker - An asynchronous function for processing a queued
	 * task, which must call its `callback(err)` argument when finished, with an
	 * optional `error` as an argument.  If you want to handle errors from an
	 * individual task, pass a callback to `q.push()`. Invoked with
	 * (task, callback).
	 * @param {number} concurrency - An `integer` for determining how many `worker`
	 * functions should be run in parallel.  If omitted, the concurrency defaults to
	 * `1`.  If the concurrency is `0`, an error is thrown.
	 * @returns {module:ControlFlow.QueueObject} A priorityQueue object to manage the tasks. There are two
	 * differences between `queue` and `priorityQueue` objects:
	 * * `push(task, priority, [callback])` - `priority` should be a number. If an
	 *   array of `tasks` is given, all tasks will be assigned the same priority.
	 * * The `unshift` method was removed.
	 */
	var priorityQueue = function (worker, concurrency) {
	    // Start with a normal queue
	    var q = queue$1(worker, concurrency);
	
	    // Override push to accept second parameter representing priority
	    q.push = function (data, priority, callback) {
	        if (callback == null) callback = noop;
	        if (typeof callback !== 'function') {
	            throw new Error('task callback must be a function');
	        }
	        q.started = true;
	        if (!isArray(data)) {
	            data = [data];
	        }
	        if (data.length === 0) {
	            // call drain immediately if there are no tasks
	            return setImmediate$1(function () {
	                q.drain();
	            });
	        }
	
	        priority = priority || 0;
	        var nextNode = q._tasks.head;
	        while (nextNode && priority >= nextNode.priority) {
	            nextNode = nextNode.next;
	        }
	
	        for (var i = 0, l = data.length; i < l; i++) {
	            var item = {
	                data: data[i],
	                priority: priority,
	                callback: callback
	            };
	
	            if (nextNode) {
	                q._tasks.insertBefore(nextNode, item);
	            } else {
	                q._tasks.push(item);
	            }
	        }
	        setImmediate$1(q.process);
	    };
	
	    // Remove unshift function
	    delete q.unshift;
	
	    return q;
	};
	
	/**
	 * Runs the `tasks` array of functions in parallel, without waiting until the
	 * previous function has completed. Once any of the `tasks` complete or pass an
	 * error to its callback, the main `callback` is immediately called. It's
	 * equivalent to `Promise.race()`.
	 *
	 * @name race
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array} tasks - An array containing functions to run. Each function
	 * is passed a `callback(err, result)` which it must call on completion with an
	 * error `err` (which can be `null`) and an optional `result` value.
	 * @param {Function} callback - A callback to run once any of the functions have
	 * completed. This function gets an error or result from the first function that
	 * completed. Invoked with (err, result).
	 * @returns undefined
	 * @example
	 *
	 * async.race([
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ],
	 * // main callback
	 * function(err, result) {
	 *     // the result will be equal to 'two' as it finishes earlier
	 * });
	 */
	function race(tasks, callback) {
	    callback = once(callback || noop);
	    if (!isArray(tasks)) return callback(new TypeError('First argument to race must be an array of functions'));
	    if (!tasks.length) return callback();
	    for (var i = 0, l = tasks.length; i < l; i++) {
	        tasks[i](callback);
	    }
	}
	
	var slice = Array.prototype.slice;
	
	/**
	 * Same as [`reduce`]{@link module:Collections.reduce}, only operates on `array` in reverse order.
	 *
	 * @name reduceRight
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reduce]{@link module:Collections.reduce}
	 * @alias foldr
	 * @category Collection
	 * @param {Array} array - A collection to iterate over.
	 * @param {*} memo - The initial state of the reduction.
	 * @param {Function} iteratee - A function applied to each item in the
	 * array to produce the next step in the reduction. The `iteratee` is passed a
	 * `callback(err, reduction)` which accepts an optional error as its first
	 * argument, and the state of the reduction as the second. If an error is
	 * passed to the callback, the reduction is stopped and the main `callback` is
	 * immediately called with the error. Invoked with (memo, item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the reduced value. Invoked with
	 * (err, result).
	 */
	function reduceRight(array, memo, iteratee, callback) {
	  var reversed = slice.call(array).reverse();
	  reduce(reversed, memo, iteratee, callback);
	}
	
	/**
	 * Wraps the function in another function that always returns data even when it
	 * errors.
	 *
	 * The object returned has either the property `error` or `value`.
	 *
	 * @name reflect
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} fn - The function you want to wrap
	 * @returns {Function} - A function that always passes null to it's callback as
	 * the error. The second argument to the callback will be an `object` with
	 * either an `error` or a `value` property.
	 * @example
	 *
	 * async.parallel([
	 *     async.reflect(function(callback) {
	 *         // do some stuff ...
	 *         callback(null, 'one');
	 *     }),
	 *     async.reflect(function(callback) {
	 *         // do some more stuff but error ...
	 *         callback('bad stuff happened');
	 *     }),
	 *     async.reflect(function(callback) {
	 *         // do some more stuff ...
	 *         callback(null, 'two');
	 *     })
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results[0].value = 'one'
	 *     // results[1].error = 'bad stuff happened'
	 *     // results[2].value = 'two'
	 * });
	 */
	function reflect(fn) {
	    return initialParams(function reflectOn(args, reflectCallback) {
	        args.push(baseRest$1(function callback(err, cbArgs) {
	            if (err) {
	                reflectCallback(null, {
	                    error: err
	                });
	            } else {
	                var value = null;
	                if (cbArgs.length === 1) {
	                    value = cbArgs[0];
	                } else if (cbArgs.length > 1) {
	                    value = cbArgs;
	                }
	                reflectCallback(null, {
	                    value: value
	                });
	            }
	        }));
	
	        return fn.apply(this, args);
	    });
	}
	
	function reject$1(eachfn, arr, iteratee, callback) {
	    _filter(eachfn, arr, function (value, cb) {
	        iteratee(value, function (err, v) {
	            if (err) {
	                cb(err);
	            } else {
	                cb(null, !v);
	            }
	        });
	    }, callback);
	}
	
	/**
	 * The opposite of [`filter`]{@link module:Collections.filter}. Removes values that pass an `async` truth test.
	 *
	 * @name reject
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.filter]{@link module:Collections.filter}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 * @example
	 *
	 * async.reject(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, results) {
	 *     // results now equals an array of missing files
	 *     createFiles(results);
	 * });
	 */
	var reject = doParallel(reject$1);
	
	/**
	 * A helper function that wraps an array or an object of functions with reflect.
	 *
	 * @name reflectAll
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.reflect]{@link module:Utils.reflect}
	 * @category Util
	 * @param {Array} tasks - The array of functions to wrap in `async.reflect`.
	 * @returns {Array} Returns an array of functions, each function wrapped in
	 * `async.reflect`
	 * @example
	 *
	 * let tasks = [
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     function(callback) {
	 *         // do some more stuff but error ...
	 *         callback(new Error('bad stuff happened'));
	 *     },
	 *     function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'two');
	 *         }, 100);
	 *     }
	 * ];
	 *
	 * async.parallel(async.reflectAll(tasks),
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results[0].value = 'one'
	 *     // results[1].error = Error('bad stuff happened')
	 *     // results[2].value = 'two'
	 * });
	 *
	 * // an example using an object instead of an array
	 * let tasks = {
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'one');
	 *         }, 200);
	 *     },
	 *     two: function(callback) {
	 *         callback('two');
	 *     },
	 *     three: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 'three');
	 *         }, 100);
	 *     }
	 * };
	 *
	 * async.parallel(async.reflectAll(tasks),
	 * // optional callback
	 * function(err, results) {
	 *     // values
	 *     // results.one.value = 'one'
	 *     // results.two.error = 'two'
	 *     // results.three.value = 'three'
	 * });
	 */
	function reflectAll(tasks) {
	    var results;
	    if (isArray(tasks)) {
	        results = arrayMap(tasks, reflect);
	    } else {
	        results = {};
	        baseForOwn(tasks, function (task, key) {
	            results[key] = reflect.call(this, task);
	        });
	    }
	    return results;
	}
	
	/**
	 * The same as [`reject`]{@link module:Collections.reject} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name rejectLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reject]{@link module:Collections.reject}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var rejectLimit = doParallelLimit(reject$1);
	
	/**
	 * The same as [`reject`]{@link module:Collections.reject} but runs only a single async operation at a time.
	 *
	 * @name rejectSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.reject]{@link module:Collections.reject}
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in `coll`.
	 * The `iteratee` is passed a `callback(err, truthValue)`, which must be called
	 * with a boolean argument once it has completed. Invoked with (item, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Invoked with (err, results).
	 */
	var rejectSeries = doLimit(rejectLimit, 1);
	
	/**
	 * Attempts to get a successful response from `task` no more than `times` times
	 * before returning an error. If the task is successful, the `callback` will be
	 * passed the result of the successful task. If all attempts fail, the callback
	 * will be passed the error and result (if any) of the final attempt.
	 *
	 * @name retry
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - Can be either an
	 * object with `times` and `interval` or a number.
	 * * `times` - The number of attempts to make before giving up.  The default
	 *   is `5`.
	 * * `interval` - The time to wait between retries, in milliseconds.  The
	 *   default is `0`. The interval may also be specified as a function of the
	 *   retry count (see example).
	 * * `errorFilter` - An optional synchronous function that is invoked on
	 *   erroneous result. If it returns `true` the retry attempts will continue;
	 *   if the function returns `false` the retry flow is aborted with the current
	 *   attempt's error and result being returned to the final callback.
	 *   Invoked with (err).
	 * * If `opts` is a number, the number specifies the number of times to retry,
	 *   with the default interval of `0`.
	 * @param {Function} task - A function which receives two arguments: (1) a
	 * `callback(err, result)` which must be called when finished, passing `err`
	 * (which can be `null`) and the `result` of the function's execution, and (2)
	 * a `results` object, containing the results of the previously executed
	 * functions (if nested inside another control flow). Invoked with
	 * (callback, results).
	 * @param {Function} [callback] - An optional callback which is called when the
	 * task has succeeded, or after the final failed attempt. It receives the `err`
	 * and `result` arguments of the last attempt at completing the `task`. Invoked
	 * with (err, results).
	 * @example
	 *
	 * // The `retry` function can be used as a stand-alone control flow by passing
	 * // a callback, as shown below:
	 *
	 * // try calling apiMethod 3 times
	 * async.retry(3, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod 3 times, waiting 200 ms between each retry
	 * async.retry({times: 3, interval: 200}, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod 10 times with exponential backoff
	 * // (i.e. intervals of 100, 200, 400, 800, 1600, ... milliseconds)
	 * async.retry({
	 *   times: 10,
	 *   interval: function(retryCount) {
	 *     return 50 * Math.pow(2, retryCount);
	 *   }
	 * }, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod the default 5 times no delay between each retry
	 * async.retry(apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // try calling apiMethod only when error condition satisfies, all other
	 * // errors will abort the retry control flow and return to final callback
	 * async.retry({
	 *   errorFilter: function(err) {
	 *     return err.message === 'Temporary error'; // only retry on a specific error
	 *   }
	 * }, apiMethod, function(err, result) {
	 *     // do something with the result
	 * });
	 *
	 * // It can also be embedded within other control flow functions to retry
	 * // individual methods that are not as reliable, like this:
	 * async.auto({
	 *     users: api.getUsers.bind(api),
	 *     payments: async.retry(3, api.getPayments.bind(api))
	 * }, function(err, results) {
	 *     // do something with the results
	 * });
	 *
	 */
	function retry(opts, task, callback) {
	    var DEFAULT_TIMES = 5;
	    var DEFAULT_INTERVAL = 0;
	
	    var options = {
	        times: DEFAULT_TIMES,
	        intervalFunc: constant(DEFAULT_INTERVAL)
	    };
	
	    function parseTimes(acc, t) {
	        if (typeof t === 'object') {
	            acc.times = +t.times || DEFAULT_TIMES;
	
	            acc.intervalFunc = typeof t.interval === 'function' ? t.interval : constant(+t.interval || DEFAULT_INTERVAL);
	
	            acc.errorFilter = t.errorFilter;
	        } else if (typeof t === 'number' || typeof t === 'string') {
	            acc.times = +t || DEFAULT_TIMES;
	        } else {
	            throw new Error("Invalid arguments for async.retry");
	        }
	    }
	
	    if (arguments.length < 3 && typeof opts === 'function') {
	        callback = task || noop;
	        task = opts;
	    } else {
	        parseTimes(options, opts);
	        callback = callback || noop;
	    }
	
	    if (typeof task !== 'function') {
	        throw new Error("Invalid arguments for async.retry");
	    }
	
	    var attempt = 1;
	    function retryAttempt() {
	        task(function (err) {
	            if (err && attempt++ < options.times && (typeof options.errorFilter != 'function' || options.errorFilter(err))) {
	                setTimeout(retryAttempt, options.intervalFunc(attempt));
	            } else {
	                callback.apply(null, arguments);
	            }
	        });
	    }
	
	    retryAttempt();
	}
	
	/**
	 * A close relative of [`retry`]{@link module:ControlFlow.retry}.  This method wraps a task and makes it
	 * retryable, rather than immediately calling it with retries.
	 *
	 * @name retryable
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.retry]{@link module:ControlFlow.retry}
	 * @category Control Flow
	 * @param {Object|number} [opts = {times: 5, interval: 0}| 5] - optional
	 * options, exactly the same as from `retry`
	 * @param {Function} task - the asynchronous function to wrap
	 * @returns {Functions} The wrapped function, which when invoked, will retry on
	 * an error, based on the parameters specified in `opts`.
	 * @example
	 *
	 * async.auto({
	 *     dep1: async.retryable(3, getFromFlakyService),
	 *     process: ["dep1", async.retryable(3, function (results, cb) {
	 *         maybeProcessData(results.dep1, cb);
	 *     })]
	 * }, callback);
	 */
	var retryable = function (opts, task) {
	    if (!task) {
	        task = opts;
	        opts = null;
	    }
	    return initialParams(function (args, callback) {
	        function taskFn(cb) {
	            task.apply(null, args.concat([cb]));
	        }
	
	        if (opts) retry(opts, taskFn, callback);else retry(taskFn, callback);
	    });
	};
	
	/**
	 * Run the functions in the `tasks` collection in series, each one running once
	 * the previous function has completed. If any functions in the series pass an
	 * error to its callback, no more functions are run, and `callback` is
	 * immediately called with the value of the error. Otherwise, `callback`
	 * receives an array of results when `tasks` have completed.
	 *
	 * It is also possible to use an object instead of an array. Each property will
	 * be run as a function, and the results will be passed to the final `callback`
	 * as an object instead of an array. This can be a more readable way of handling
	 *  results from {@link async.series}.
	 *
	 * **Note** that while many implementations preserve the order of object
	 * properties, the [ECMAScript Language Specification](http://www.ecma-international.org/ecma-262/5.1/#sec-8.6)
	 * explicitly states that
	 *
	 * > The mechanics and order of enumerating the properties is not specified.
	 *
	 * So if you rely on the order in which your series of functions are executed,
	 * and want this to work on all platforms, consider using an array.
	 *
	 * @name series
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array|Iterable|Object} tasks - A collection containing functions to run, each
	 * function is passed a `callback(err, result)` it must call on completion with
	 * an error `err` (which can be `null`) and an optional `result` value.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed. This function gets a results array (or object)
	 * containing all the result arguments passed to the `task` callbacks. Invoked
	 * with (err, result).
	 * @example
	 * async.series([
	 *     function(callback) {
	 *         // do some stuff ...
	 *         callback(null, 'one');
	 *     },
	 *     function(callback) {
	 *         // do some more stuff ...
	 *         callback(null, 'two');
	 *     }
	 * ],
	 * // optional callback
	 * function(err, results) {
	 *     // results is now equal to ['one', 'two']
	 * });
	 *
	 * async.series({
	 *     one: function(callback) {
	 *         setTimeout(function() {
	 *             callback(null, 1);
	 *         }, 200);
	 *     },
	 *     two: function(callback){
	 *         setTimeout(function() {
	 *             callback(null, 2);
	 *         }, 100);
	 *     }
	 * }, function(err, results) {
	 *     // results is now equal to: {one: 1, two: 2}
	 * });
	 */
	function series(tasks, callback) {
	  _parallel(eachOfSeries, tasks, callback);
	}
	
	/**
	 * Returns `true` if at least one element in the `coll` satisfies an async test.
	 * If any iteratee call returns `true`, the main `callback` is immediately
	 * called.
	 *
	 * @name some
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @alias any
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in the array
	 * in parallel. The iteratee is passed a `callback(err, truthValue)` which must
	 * be called with a boolean argument once it has completed. Invoked with
	 * (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 * @example
	 *
	 * async.some(['file1','file2','file3'], function(filePath, callback) {
	 *     fs.access(filePath, function(err) {
	 *         callback(null, !err)
	 *     });
	 * }, function(err, result) {
	 *     // if result is true then at least one of the files exists
	 * });
	 */
	var some = _createTester(eachOf, Boolean, identity);
	
	/**
	 * The same as [`some`]{@link module:Collections.some} but runs a maximum of `limit` async operations at a time.
	 *
	 * @name someLimit
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.some]{@link module:Collections.some}
	 * @alias anyLimit
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - A truth test to apply to each item in the array
	 * in parallel. The iteratee is passed a `callback(err, truthValue)` which must
	 * be called with a boolean argument once it has completed. Invoked with
	 * (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 */
	var someLimit = _createTester(eachOfLimit, Boolean, identity);
	
	/**
	 * The same as [`some`]{@link module:Collections.some} but runs only a single async operation at a time.
	 *
	 * @name someSeries
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @see [async.some]{@link module:Collections.some}
	 * @alias anySeries
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A truth test to apply to each item in the array
	 * in parallel. The iteratee is passed a `callback(err, truthValue)` which must
	 * be called with a boolean argument once it has completed. Invoked with
	 * (item, callback).
	 * @param {Function} [callback] - A callback which is called as soon as any
	 * iteratee returns `true`, or after all the iteratee functions have finished.
	 * Result will be either `true` or `false` depending on the values of the async
	 * tests. Invoked with (err, result).
	 */
	var someSeries = doLimit(someLimit, 1);
	
	/**
	 * Sorts a list by the results of running each `coll` value through an async
	 * `iteratee`.
	 *
	 * @name sortBy
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {Function} iteratee - A function to apply to each item in `coll`.
	 * The iteratee is passed a `callback(err, sortValue)` which must be called once
	 * it has completed with an error (which can be `null`) and a value to use as
	 * the sort criteria. Invoked with (item, callback).
	 * @param {Function} callback - A callback which is called after all the
	 * `iteratee` functions have finished, or an error occurs. Results is the items
	 * from the original `coll` sorted by the values returned by the `iteratee`
	 * calls. Invoked with (err, results).
	 * @example
	 *
	 * async.sortBy(['file1','file2','file3'], function(file, callback) {
	 *     fs.stat(file, function(err, stats) {
	 *         callback(err, stats.mtime);
	 *     });
	 * }, function(err, results) {
	 *     // results is now the original array of files sorted by
	 *     // modified date
	 * });
	 *
	 * // By modifying the callback parameter the
	 * // sorting order can be influenced:
	 *
	 * // ascending order
	 * async.sortBy([1,9,3,5], function(x, callback) {
	 *     callback(null, x);
	 * }, function(err,result) {
	 *     // result callback
	 * });
	 *
	 * // descending order
	 * async.sortBy([1,9,3,5], function(x, callback) {
	 *     callback(null, x*-1);    //<- x*-1 instead of x, turns the order around
	 * }, function(err,result) {
	 *     // result callback
	 * });
	 */
	function sortBy(coll, iteratee, callback) {
	    map(coll, function (x, callback) {
	        iteratee(x, function (err, criteria) {
	            if (err) return callback(err);
	            callback(null, { value: x, criteria: criteria });
	        });
	    }, function (err, results) {
	        if (err) return callback(err);
	        callback(null, arrayMap(results.sort(comparator), baseProperty('value')));
	    });
	
	    function comparator(left, right) {
	        var a = left.criteria,
	            b = right.criteria;
	        return a < b ? -1 : a > b ? 1 : 0;
	    }
	}
	
	/**
	 * Sets a time limit on an asynchronous function. If the function does not call
	 * its callback within the specified milliseconds, it will be called with a
	 * timeout error. The code property for the error object will be `'ETIMEDOUT'`.
	 *
	 * @name timeout
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @category Util
	 * @param {Function} asyncFn - The asynchronous function you want to set the
	 * time limit.
	 * @param {number} milliseconds - The specified time limit.
	 * @param {*} [info] - Any variable you want attached (`string`, `object`, etc)
	 * to timeout Error for more information..
	 * @returns {Function} Returns a wrapped function that can be used with any of
	 * the control flow functions. Invoke this function with the same
	 * parameters as you would `asyncFunc`.
	 * @example
	 *
	 * function myFunction(foo, callback) {
	 *     doAsyncTask(foo, function(err, data) {
	 *         // handle errors
	 *         if (err) return callback(err);
	 *
	 *         // do some stuff ...
	 *
	 *         // return processed data
	 *         return callback(null, data);
	 *     });
	 * }
	 *
	 * var wrapped = async.timeout(myFunction, 1000);
	 *
	 * // call `wrapped` as you would `myFunction`
	 * wrapped({ bar: 'bar' }, function(err, data) {
	 *     // if `myFunction` takes < 1000 ms to execute, `err`
	 *     // and `data` will have their expected values
	 *
	 *     // else `err` will be an Error with the code 'ETIMEDOUT'
	 * });
	 */
	function timeout(asyncFn, milliseconds, info) {
	    var originalCallback, timer;
	    var timedOut = false;
	
	    function injectedCallback() {
	        if (!timedOut) {
	            originalCallback.apply(null, arguments);
	            clearTimeout(timer);
	        }
	    }
	
	    function timeoutCallback() {
	        var name = asyncFn.name || 'anonymous';
	        var error = new Error('Callback function "' + name + '" timed out.');
	        error.code = 'ETIMEDOUT';
	        if (info) {
	            error.info = info;
	        }
	        timedOut = true;
	        originalCallback(error);
	    }
	
	    return initialParams(function (args, origCallback) {
	        originalCallback = origCallback;
	        // setup timer and call original function
	        timer = setTimeout(timeoutCallback, milliseconds);
	        asyncFn.apply(null, args.concat(injectedCallback));
	    });
	}
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil;
	var nativeMax$1 = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax$1(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	/**
	 * The same as [times]{@link module:ControlFlow.times} but runs a maximum of `limit` async operations at a
	 * time.
	 *
	 * @name timesLimit
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.times]{@link module:ControlFlow.times}
	 * @category Control Flow
	 * @param {number} count - The number of times to run the function.
	 * @param {number} limit - The maximum number of async operations at a time.
	 * @param {Function} iteratee - The function to call `n` times. Invoked with the
	 * iteration index and a callback (n, next).
	 * @param {Function} callback - see [async.map]{@link module:Collections.map}.
	 */
	function timeLimit(count, limit, iteratee, callback) {
	  mapLimit(baseRange(0, count, 1), limit, iteratee, callback);
	}
	
	/**
	 * Calls the `iteratee` function `n` times, and accumulates results in the same
	 * manner you would use with [map]{@link module:Collections.map}.
	 *
	 * @name times
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.map]{@link module:Collections.map}
	 * @category Control Flow
	 * @param {number} n - The number of times to run the function.
	 * @param {Function} iteratee - The function to call `n` times. Invoked with the
	 * iteration index and a callback (n, next).
	 * @param {Function} callback - see {@link module:Collections.map}.
	 * @example
	 *
	 * // Pretend this is some complicated async factory
	 * var createUser = function(id, callback) {
	 *     callback(null, {
	 *         id: 'user' + id
	 *     });
	 * };
	 *
	 * // generate 5 users
	 * async.times(5, function(n, next) {
	 *     createUser(n, function(err, user) {
	 *         next(err, user);
	 *     });
	 * }, function(err, users) {
	 *     // we should now have 5 users
	 * });
	 */
	var times = doLimit(timeLimit, Infinity);
	
	/**
	 * The same as [times]{@link module:ControlFlow.times} but runs only a single async operation at a time.
	 *
	 * @name timesSeries
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.times]{@link module:ControlFlow.times}
	 * @category Control Flow
	 * @param {number} n - The number of times to run the function.
	 * @param {Function} iteratee - The function to call `n` times. Invoked with the
	 * iteration index and a callback (n, next).
	 * @param {Function} callback - see {@link module:Collections.map}.
	 */
	var timesSeries = doLimit(timeLimit, 1);
	
	/**
	 * A relative of `reduce`.  Takes an Object or Array, and iterates over each
	 * element in series, each step potentially mutating an `accumulator` value.
	 * The type of the accumulator defaults to the type of collection passed in.
	 *
	 * @name transform
	 * @static
	 * @memberOf module:Collections
	 * @method
	 * @category Collection
	 * @param {Array|Iterable|Object} coll - A collection to iterate over.
	 * @param {*} [accumulator] - The initial state of the transform.  If omitted,
	 * it will default to an empty Object or Array, depending on the type of `coll`
	 * @param {Function} iteratee - A function applied to each item in the
	 * collection that potentially modifies the accumulator. The `iteratee` is
	 * passed a `callback(err)` which accepts an optional error as its first
	 * argument. If an error is passed to the callback, the transform is stopped
	 * and the main `callback` is immediately called with the error.
	 * Invoked with (accumulator, item, key, callback).
	 * @param {Function} [callback] - A callback which is called after all the
	 * `iteratee` functions have finished. Result is the transformed accumulator.
	 * Invoked with (err, result).
	 * @example
	 *
	 * async.transform([1,2,3], function(acc, item, index, callback) {
	 *     // pointless async:
	 *     process.nextTick(function() {
	 *         acc.push(item * 2)
	 *         callback(null)
	 *     });
	 * }, function(err, result) {
	 *     // result is now equal to [2, 4, 6]
	 * });
	 *
	 * @example
	 *
	 * async.transform({a: 1, b: 2, c: 3}, function (obj, val, key, callback) {
	 *     setImmediate(function () {
	 *         obj[key] = val * 2;
	 *         callback();
	 *     })
	 * }, function (err, result) {
	 *     // result is equal to {a: 2, b: 4, c: 6}
	 * })
	 */
	function transform(coll, accumulator, iteratee, callback) {
	    if (arguments.length === 3) {
	        callback = iteratee;
	        iteratee = accumulator;
	        accumulator = isArray(coll) ? [] : {};
	    }
	    callback = once(callback || noop);
	
	    eachOf(coll, function (v, k, cb) {
	        iteratee(accumulator, v, k, cb);
	    }, function (err) {
	        callback(err, accumulator);
	    });
	}
	
	/**
	 * Undoes a [memoize]{@link module:Utils.memoize}d function, reverting it to the original,
	 * unmemoized form. Handy for testing.
	 *
	 * @name unmemoize
	 * @static
	 * @memberOf module:Utils
	 * @method
	 * @see [async.memoize]{@link module:Utils.memoize}
	 * @category Util
	 * @param {Function} fn - the memoized function
	 * @returns {Function} a function that calls the original unmemoized function
	 */
	function unmemoize(fn) {
	    return function () {
	        return (fn.unmemoized || fn).apply(null, arguments);
	    };
	}
	
	/**
	 * Repeatedly call `iteratee`, while `test` returns `true`. Calls `callback` when
	 * stopped, or an error occurs.
	 *
	 * @name whilst
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Function} test - synchronous truth test to perform before each
	 * execution of `iteratee`. Invoked with ().
	 * @param {Function} iteratee - A function which is called each time `test` passes.
	 * The function is passed a `callback(err)`, which must be called once it has
	 * completed with an optional `err` argument. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has failed and repeated execution of `iteratee` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `iteratee`'s
	 * callback. Invoked with (err, [results]);
	 * @returns undefined
	 * @example
	 *
	 * var count = 0;
	 * async.whilst(
	 *     function() { return count < 5; },
	 *     function(callback) {
	 *         count++;
	 *         setTimeout(function() {
	 *             callback(null, count);
	 *         }, 1000);
	 *     },
	 *     function (err, n) {
	 *         // 5 seconds have passed, n = 5
	 *     }
	 * );
	 */
	function whilst(test, iteratee, callback) {
	    callback = onlyOnce(callback || noop);
	    if (!test()) return callback(null);
	    var next = baseRest$1(function (err, args) {
	        if (err) return callback(err);
	        if (test()) return iteratee(next);
	        callback.apply(null, [null].concat(args));
	    });
	    iteratee(next);
	}
	
	/**
	 * Repeatedly call `fn` until `test` returns `true`. Calls `callback` when
	 * stopped, or an error occurs. `callback` will be passed an error and any
	 * arguments passed to the final `fn`'s callback.
	 *
	 * The inverse of [whilst]{@link module:ControlFlow.whilst}.
	 *
	 * @name until
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @see [async.whilst]{@link module:ControlFlow.whilst}
	 * @category Control Flow
	 * @param {Function} test - synchronous truth test to perform before each
	 * execution of `fn`. Invoked with ().
	 * @param {Function} fn - A function which is called each time `test` fails.
	 * The function is passed a `callback(err)`, which must be called once it has
	 * completed with an optional `err` argument. Invoked with (callback).
	 * @param {Function} [callback] - A callback which is called after the test
	 * function has passed and repeated execution of `fn` has stopped. `callback`
	 * will be passed an error and any arguments passed to the final `fn`'s
	 * callback. Invoked with (err, [results]);
	 */
	function until(test, fn, callback) {
	    whilst(function () {
	        return !test.apply(this, arguments);
	    }, fn, callback);
	}
	
	/**
	 * Runs the `tasks` array of functions in series, each passing their results to
	 * the next in the array. However, if any of the `tasks` pass an error to their
	 * own callback, the next function is not executed, and the main `callback` is
	 * immediately called with the error.
	 *
	 * @name waterfall
	 * @static
	 * @memberOf module:ControlFlow
	 * @method
	 * @category Control Flow
	 * @param {Array} tasks - An array of functions to run, each function is passed
	 * a `callback(err, result1, result2, ...)` it must call on completion. The
	 * first argument is an error (which can be `null`) and any further arguments
	 * will be passed as arguments in order to the next task.
	 * @param {Function} [callback] - An optional callback to run once all the
	 * functions have completed. This will be passed the results of the last task's
	 * callback. Invoked with (err, [results]).
	 * @returns undefined
	 * @example
	 *
	 * async.waterfall([
	 *     function(callback) {
	 *         callback(null, 'one', 'two');
	 *     },
	 *     function(arg1, arg2, callback) {
	 *         // arg1 now equals 'one' and arg2 now equals 'two'
	 *         callback(null, 'three');
	 *     },
	 *     function(arg1, callback) {
	 *         // arg1 now equals 'three'
	 *         callback(null, 'done');
	 *     }
	 * ], function (err, result) {
	 *     // result now equals 'done'
	 * });
	 *
	 * // Or, with named functions:
	 * async.waterfall([
	 *     myFirstFunction,
	 *     mySecondFunction,
	 *     myLastFunction,
	 * ], function (err, result) {
	 *     // result now equals 'done'
	 * });
	 * function myFirstFunction(callback) {
	 *     callback(null, 'one', 'two');
	 * }
	 * function mySecondFunction(arg1, arg2, callback) {
	 *     // arg1 now equals 'one' and arg2 now equals 'two'
	 *     callback(null, 'three');
	 * }
	 * function myLastFunction(arg1, callback) {
	 *     // arg1 now equals 'three'
	 *     callback(null, 'done');
	 * }
	 */
	var waterfall = function (tasks, callback) {
	    callback = once(callback || noop);
	    if (!isArray(tasks)) return callback(new Error('First argument to waterfall must be an array of functions'));
	    if (!tasks.length) return callback();
	    var taskIndex = 0;
	
	    function nextTask(args) {
	        if (taskIndex === tasks.length) {
	            return callback.apply(null, [null].concat(args));
	        }
	
	        var taskCallback = onlyOnce(baseRest$1(function (err, args) {
	            if (err) {
	                return callback.apply(null, [err].concat(args));
	            }
	            nextTask(args);
	        }));
	
	        args.push(taskCallback);
	
	        var task = tasks[taskIndex++];
	        task.apply(null, args);
	    }
	
	    nextTask([]);
	};
	
	/**
	 * Async is a utility module which provides straight-forward, powerful functions
	 * for working with asynchronous JavaScript. Although originally designed for
	 * use with [Node.js](http://nodejs.org) and installable via
	 * `npm install --save async`, it can also be used directly in the browser.
	 * @module async
	 */
	
	/**
	 * A collection of `async` functions for manipulating collections, such as
	 * arrays and objects.
	 * @module Collections
	 */
	
	/**
	 * A collection of `async` functions for controlling the flow through a script.
	 * @module ControlFlow
	 */
	
	/**
	 * A collection of `async` utility functions.
	 * @module Utils
	 */
	var index = {
	  applyEach: applyEach,
	  applyEachSeries: applyEachSeries,
	  apply: apply$2,
	  asyncify: asyncify,
	  auto: auto,
	  autoInject: autoInject,
	  cargo: cargo,
	  compose: compose,
	  concat: concat,
	  concatSeries: concatSeries,
	  constant: constant$2,
	  detect: detect,
	  detectLimit: detectLimit,
	  detectSeries: detectSeries,
	  dir: dir,
	  doDuring: doDuring,
	  doUntil: doUntil,
	  doWhilst: doWhilst,
	  during: during,
	  each: eachLimit,
	  eachLimit: eachLimit$1,
	  eachOf: eachOf,
	  eachOfLimit: eachOfLimit,
	  eachOfSeries: eachOfSeries,
	  eachSeries: eachSeries,
	  ensureAsync: ensureAsync,
	  every: every,
	  everyLimit: everyLimit,
	  everySeries: everySeries,
	  filter: filter,
	  filterLimit: filterLimit,
	  filterSeries: filterSeries,
	  forever: forever,
	  log: log,
	  map: map,
	  mapLimit: mapLimit,
	  mapSeries: mapSeries,
	  mapValues: mapValues,
	  mapValuesLimit: mapValuesLimit,
	  mapValuesSeries: mapValuesSeries,
	  memoize: memoize,
	  nextTick: nextTick,
	  parallel: parallelLimit,
	  parallelLimit: parallelLimit$1,
	  priorityQueue: priorityQueue,
	  queue: queue$1,
	  race: race,
	  reduce: reduce,
	  reduceRight: reduceRight,
	  reflect: reflect,
	  reflectAll: reflectAll,
	  reject: reject,
	  rejectLimit: rejectLimit,
	  rejectSeries: rejectSeries,
	  retry: retry,
	  retryable: retryable,
	  seq: seq$1,
	  series: series,
	  setImmediate: setImmediate$1,
	  some: some,
	  someLimit: someLimit,
	  someSeries: someSeries,
	  sortBy: sortBy,
	  timeout: timeout,
	  times: times,
	  timesLimit: timeLimit,
	  timesSeries: timesSeries,
	  transform: transform,
	  unmemoize: unmemoize,
	  until: until,
	  waterfall: waterfall,
	  whilst: whilst,
	
	  // aliases
	  all: every,
	  any: some,
	  forEach: eachLimit,
	  forEachSeries: eachSeries,
	  forEachLimit: eachLimit$1,
	  forEachOf: eachOf,
	  forEachOfSeries: eachOfSeries,
	  forEachOfLimit: eachOfLimit,
	  inject: reduce,
	  foldl: reduce,
	  foldr: reduceRight,
	  select: filter,
	  selectLimit: filterLimit,
	  selectSeries: filterSeries,
	  wrapSync: asyncify
	};
	
	exports['default'] = index;
	exports.applyEach = applyEach;
	exports.applyEachSeries = applyEachSeries;
	exports.apply = apply$2;
	exports.asyncify = asyncify;
	exports.auto = auto;
	exports.autoInject = autoInject;
	exports.cargo = cargo;
	exports.compose = compose;
	exports.concat = concat;
	exports.concatSeries = concatSeries;
	exports.constant = constant$2;
	exports.detect = detect;
	exports.detectLimit = detectLimit;
	exports.detectSeries = detectSeries;
	exports.dir = dir;
	exports.doDuring = doDuring;
	exports.doUntil = doUntil;
	exports.doWhilst = doWhilst;
	exports.during = during;
	exports.each = eachLimit;
	exports.eachLimit = eachLimit$1;
	exports.eachOf = eachOf;
	exports.eachOfLimit = eachOfLimit;
	exports.eachOfSeries = eachOfSeries;
	exports.eachSeries = eachSeries;
	exports.ensureAsync = ensureAsync;
	exports.every = every;
	exports.everyLimit = everyLimit;
	exports.everySeries = everySeries;
	exports.filter = filter;
	exports.filterLimit = filterLimit;
	exports.filterSeries = filterSeries;
	exports.forever = forever;
	exports.log = log;
	exports.map = map;
	exports.mapLimit = mapLimit;
	exports.mapSeries = mapSeries;
	exports.mapValues = mapValues;
	exports.mapValuesLimit = mapValuesLimit;
	exports.mapValuesSeries = mapValuesSeries;
	exports.memoize = memoize;
	exports.nextTick = nextTick;
	exports.parallel = parallelLimit;
	exports.parallelLimit = parallelLimit$1;
	exports.priorityQueue = priorityQueue;
	exports.queue = queue$1;
	exports.race = race;
	exports.reduce = reduce;
	exports.reduceRight = reduceRight;
	exports.reflect = reflect;
	exports.reflectAll = reflectAll;
	exports.reject = reject;
	exports.rejectLimit = rejectLimit;
	exports.rejectSeries = rejectSeries;
	exports.retry = retry;
	exports.retryable = retryable;
	exports.seq = seq$1;
	exports.series = series;
	exports.setImmediate = setImmediate$1;
	exports.some = some;
	exports.someLimit = someLimit;
	exports.someSeries = someSeries;
	exports.sortBy = sortBy;
	exports.timeout = timeout;
	exports.times = times;
	exports.timesLimit = timeLimit;
	exports.timesSeries = timesSeries;
	exports.transform = transform;
	exports.unmemoize = unmemoize;
	exports.until = until;
	exports.waterfall = waterfall;
	exports.whilst = whilst;
	exports.all = every;
	exports.allLimit = everyLimit;
	exports.allSeries = everySeries;
	exports.any = some;
	exports.anyLimit = someLimit;
	exports.anySeries = someSeries;
	exports.find = detect;
	exports.findLimit = detectLimit;
	exports.findSeries = detectSeries;
	exports.forEach = eachLimit;
	exports.forEachSeries = eachSeries;
	exports.forEachLimit = eachLimit$1;
	exports.forEachOf = eachOf;
	exports.forEachOfSeries = eachOfSeries;
	exports.forEachOfLimit = eachOfLimit;
	exports.inject = reduce;
	exports.foldl = reduce;
	exports.foldr = reduceRight;
	exports.select = filter;
	exports.selectLimit = filterLimit;
	exports.selectSeries = filterSeries;
	exports.wrapSync = asyncify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(39)(module), __webpack_require__(682).setImmediate, __webpack_require__(683)))

/***/ },
/* 682 */,
/* 683 */,
/* 684 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/app_by_l7_resp').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['l7_app', 'proto', 'service', 'resp_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Layer 7 Applications by Responder',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'app_by_l7_resp_orig',
	                    val: ['l7_app', 'proto', 'service', 'resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Layer 7 App',
	                select: 'l7_app',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Service',
	                select: 'service',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'IOC Events',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'l7_app': 'Layer 7 App',
	                'proto': 'Protocol',
	                'service': 'Service',
	                'resp_ip': 'Responder IP',
	                'resp_cc': 'Flag',
	                'resp_country': 'Responder Country'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 685 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/app_by_l7_resp_orig').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['l7_app', 'proto', 'service', 'resp_ip', 'orig_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Layer 7 Applications by Responder',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['l7_app', 'proto', 'service', 'resp_ip', 'orig_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Layer 7 App',
	                select: 'l7_app',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Service',
	                select: 'service',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'l7_app': 'Layer 7 App',
	                'proto': 'Protocol',
	                'service': 'Service',
	                'resp_ip': 'Responder IP',
	                'orig_ip': 'Origin IP'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.color = d3.scale.category10();
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/dns_by_type').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['qtype_name'],
	                    filter_column: 'qtype_name',
	                    searchCategories: {
	                        'qtype_name': 'Query Type'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.qtype_name;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'qtype_name'],
	                    type: 'linechart',
	                    settings: {
	                        type: 'bar',
	                        // hide_legend: true,
	                        use_color: true,
	                        xAxis: '',
	                        yAxis: '# DNS Queries / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'qtype_name': 'Query Type'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.qtype_name)) {
	                                p[v.qtype_name] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.qtype_name)) {
	                                p[v.qtype_name] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['qtype_name'],
	            hideToggleBytes: true,
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'DNS by Query Type',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'dns_by_type_resp',
	                    val: ['qtype_name'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Query Type',
	                select: 'qtype_name',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'qtype_name': 'Query Type'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 687 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/dns_by_type_resp').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_hostname', 'resp_ip', 'qtype_name'],
	            hideToggleBytes: true,
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Responder DNS by Query Type',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'dns_by_type_resp_orig',
	                    table_name: 'dns',
	                    val: ['resp_hostname', 'resp_ip', 'qtype_name'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Query Type',
	                select: 'qtype_name',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'resp_stealth': 'Responder Stealth',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_ip': 'Responder IP',
	                'qtype_name': 'Query Type'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 688 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/dns_by_type_resp_orig').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_hostname', 'resp_ip', 'orig_hostname', 'orig_ip'],
	            hideToggleBytes: true,
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Responder / Origin DNS by Query Type',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    table_name: 'dns',
	                    val: ['resp_hostname', 'resp_ip', 'orig_hostname', 'orig_ip', 'qtype_name'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Query Type',
	                select: 'qtype_name',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'resp_stealth': 'Responder Stealth',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_ip': 'Responder IP',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'qtype_name': 'Query Type'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.showHide = true;
	    model.toggleView = function (tog) {
	        if (tog !== undefined) {
	            model.showHide = tog;
	        } else {
	            if (model.showHide) {
	                model.showHide = false;
	            } else {
	                model.showHide = true;
	            }
	        }
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/dns_by_resolver').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['resp_ip', 'resp_hostname'],
	                    filter_column: 'resp_ip',
	                    searchCategories: {
	                        'resp_ip': 'Responder IP'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.resp_ip;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'resp_ip'],
	                    type: 'linechart',
	                    settings: {
	                        type: 'bar',
	                        // hide_legend: true,
	                        use_color: true,
	                        xAxis: '',
	                        yAxis: '# DNS Queries / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'resp_ip': 'Responder IP'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.resp_ip)) {
	                                p[v.resp_ip] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.resp_ip)) {
	                                p[v.resp_ip] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['resp_country', 'resp_ip'],
	            searchCategories: {
	                'resp_country': 'Responder Country',
	                'resp_ip': 'Responder IP'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip', 'resp_hostname'],
	            hideToggleBytes: true,
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'DNS by Responder IP',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'dns_by_resolver_type',
	                    val: ['resp_ip', 'resp_hostname'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }],
	            searchCategories: _defineProperty({
	                'ioc_count': "IOC Count",
	                'resp_ip': 'Responder IP',
	                'resp_hostname': 'Responder Hostname',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag'
	            }, 'ioc_count', 'IOC Count')
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 690 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/dns_by_resolver_type').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_hostname', 'resp_ip', 'qtype_name'],
	            hideToggleBytes: true,
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            // div: 'table',
	            title: 'DNS Resolver by Query Type',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'dns_by_type_resp_orig',
	                    table_name: 'dns',
	                    val: ['resp_hostname', 'resp_ip', 'qtype_name'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Query Type',
	                select: 'qtype_name',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'resp_stealth': 'Responder Stealth',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_ip': 'Responder IP',
	                'qtype_name': 'Query Type'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/http_by_domain').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['top_domain'],
	                    filter_column: 'top_domain',
	                    searchCategories: {
	                        'top_domain': 'Domain'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d, i) {
	                            return d.top_domain;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'top_domain'],
	                    type: 'linechart',
	                    settings: {
	                        type: 'bandwidth',
	                        use_color: true,
	                        xAxis: '',
	                        yAxis: '# MB / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'top_domain': 'Domain'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.top_domain)) {
	                                p[v.top_domain] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.top_domain)) {
	                                p[v.top_domain] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function (d, v) {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['top_domain'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'HTTP by Domain',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'http_by_domain_sub',
	                    val: ['top_domain'], // val: the pre-evaluated values from the query above
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Domain',
	                select: 'top_domain',
	                dView: true
	            }],
	            searchCategories: {
	                'top_domain': 'Domain'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/http_by_domain_sub').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['host'],
	                    filter_column: 'host',
	                    searchCategories: {
	                        'host': 'Subdomain'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.host;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'host'],
	                    type: 'linechart',
	                    settings: {
	                        type: 'bandwidth',
	                        use_color: true,
	                        xAxis: '',
	                        yAxis: '# MB / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'host': 'Subdomain'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.host)) {
	                                p[v.host] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.host)) {
	                                p[v.host] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function (d, v) {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['host'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'HTTP by Subdomain',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'http_by_domain_uri',
	                    val: ['top_domain', 'host'], // val: the pre-evaluated values from the query above
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Domain',
	                select: 'top_domain',
	                dView: true
	            }, {
	                title: 'Subdomain',
	                select: 'host',
	                dView: true
	            }],
	            searchCategories: {
	                'top_domain': 'Domain',
	                'host': 'Subdomain'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 693 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/http_by_domain_uri').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['host', 'uri'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'HTTP by Domain',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['host', 'uri', 'top_domain'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Domain',
	                select: 'top_domain',
	                dView: true
	            }, {
	                title: 'Subdomain',
	                select: 'host',
	                dView: true
	            }, {
	                title: 'URI',
	                select: 'uri',
	                dView: true
	            }],
	            searchCategories: {
	                'top_domain': 'Domain',
	                'host': 'Subdomain',
	                'uri': 'URI'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/ssl_by_server').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['top_server'],
	                    filter_column: 'top_server',
	                    searchCategories: {
	                        'top_server': 'Top Level Server Name'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.top_server;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'top_server'],
	                    hideToggleBytes: true,
	                    type: 'linechart',
	                    settings: {
	                        use_color: true,
	                        type: 'bar',
	                        xAxis: '',
	                        yAxis: 'SSH Connections / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'top_server': 'Top Level Server Name'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.top_server)) {
	                                p[v.top_server] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.top_server)) {
	                                p[v.top_server] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['top_server'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'SSL by Top Level Server Name',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ssl_by_server_name',
	                    val: ['top_server'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Top Level Server Name',
	                select: 'top_server',
	                dView: true
	            }],
	            searchCategories: {
	                'top_server': 'Top Level Server Name'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/ssl_by_server_name').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['server_name'],
	                    filter_column: 'server_name',
	                    searchCategories: {
	                        'top_server': 'Top Level Server Name',
	                        'server_name': 'Server Name'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.server_name;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'server_name'],
	                    hideToggleBytes: true,
	                    type: 'linechart',
	                    settings: {
	                        use_color: true,
	                        type: 'bar',
	                        xAxis: '',
	                        yAxis: 'SSH Connections / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'top_server': 'Top Level Server Name',
	                        'server_name': 'Server Name'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.server_name)) {
	                                p[v.server_name] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.server_name)) {
	                                p[v.server_name] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['top_server', 'server_name'],
	            sort: {
	                direction: '-', // '-'=desc, '+'=asc
	                col: 'time'
	            },
	            title: 'SSL by Top Level Server Name',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ssl_by_server_name_orig',
	                    val: ['top_server', 'server_name'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Top Level Server Name',
	                select: 'top_server',
	                dView: true
	            }, {
	                title: 'Server Name',
	                select: 'server_name',
	                dView: true
	            }],
	            searchCategories: {
	                'top_server': 'Top Level Server Name',
	                'server_name': 'Server Name'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/ssl_by_server_name_orig').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['top_server', 'server_name', 'orig_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'SSL by Top Level Server Name',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['top_server', 'server_name', 'orig_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Top Level Server Name',
	                select: 'top_server',
	                dView: true
	            }, {
	                title: 'Server Name',
	                select: 'server_name',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }],
	            searchCategories: {
	                'top_server': 'Top Level Server Name',
	                'server_name': 'Server Name',
	                'orig_ip': 'Origin IP'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 697 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/ftp_resp').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'FTP By Responder',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ftp_resp_orig',
	                    val: ['resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }],
	            searchCategories: {
	                'resp_ip': 'Responder IP'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 698 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/ftp_resp_orig').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip', 'orig_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'FTP By Responder to Origin',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['resp_ip', 'orig_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }],
	            searchCategories: {
	                'resp_ip': 'Responder IP',
	                'orig_ip': 'Origin IP'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/applications/ssh_status').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['status'],
	                    filter_column: 'status',
	                    searchCategories: {
	                        'status': 'Status Code'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.status;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'status'],
	                    hideToggleBytes: true,
	                    type: 'linechart',
	                    settings: {
	                        use_color: true,
	                        type: 'bar',
	                        xAxis: '',
	                        yAxis: 'SSH Connections / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'status': 'Status Code'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.status)) {
	                                p[v.status] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.status)) {
	                                p[v.status] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['status'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'SSH Status',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ssh_status_resp',
	                    val: ['status'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Status',
	                select: 'status',
	                dView: true
	            }],
	            searchCategories: {
	                'status': 'Status Code'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/ssh_status_resp').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['status', 'resp_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'SSH Status',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ssh_status_resp_orig',
	                    val: ['status', 'resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Status',
	                select: 'status',
	                dView: true
	            }],
	            searchCategories: {
	                'resp_ip': 'Responder IP',
	                'status': 'Status Code'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 701 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/applications/ssh_status_resp_orig').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['status', 'resp_ip', 'orig_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'SSH Status',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['status', 'resp_ip', 'orig_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Status',
	                select: 'status',
	                dView: true
	            }],
	            searchCategories: {
	                'resp_ip': 'Responder IP',
	                'orig_ip': 'Origin IP',
	                'status': 'Status Code'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('filesByMimeController', __webpack_require__(703));
	    ngModule.controller('filesByMimeTypeController', __webpack_require__(704));
	    ngModule.controller('filesByFileNameController', __webpack_require__(705));
	};

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/files/files_by_mime').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['mimegeneric'],
	                    filter_column: 'mimegeneric',
	                    searchCategories: {
	                        'mimegeneric': 'Genereic MIME'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.mimegeneric;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'mimegeneric'],
	                    type: 'linechart',
	                    settings: {
	                        use_color: true,
	                        type: 'bar',
	                        xAxis: '',
	                        yAxis: 'Extracted Files / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'mimegeneric': 'Genereic MIME'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.mimegeneric)) {
	                                p[v.mimegeneric] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.mimegeneric)) {
	                                p[v.mimegeneric] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['mime', 'mimegeneric'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'File By MIME',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'files_by_mime_type',
	                    val: ['mimegeneric'],
	                    crumb: false
	                }
	            }, {
	                title: 'Generic MIME',
	                select: 'mimegeneric',
	                dView: true
	            }, {
	                title: 'Extracted Files',
	                select: 'count',
	                dView: true
	            }],
	            searchCategories: {
	                'count': 'Extracted Files',
	                'mimegeneric': 'Generic MIME'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/files/files_by_mime_type').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['mimegeneric', 'mime'],
	                    filter_column: 'mime',
	                    searchCategories: {
	                        'mime': 'Mime',
	                        'mimegeneric': 'Genereic MIME'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.mime;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'mime', 'mimegeneric'],
	                    type: 'linechart',
	                    settings: {
	                        use_color: true,
	                        type: 'bar',
	                        xAxis: '',
	                        yAxis: 'Extracted Files / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'mime': 'Mime',
	                        'mimegeneric': 'Genereic MIME'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.mime)) {
	                                p[v.mime] += v.count;
	                            } else {
	                                p['Other'] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.mime)) {
	                                p[v.mime] -= v.count;
	                            } else {
	                                p['Other'] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['mime', 'mimegeneric'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Files By MIME Type',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'files_by_mime_type_filename',
	                    val: ['mime', 'mimegeneric'],
	                    crumb: false
	                }
	            }, {
	                title: 'Genereic MIME',
	                select: 'mimegeneric',
	                dView: true
	            }, {
	                title: 'MIME Type',
	                select: 'mime',
	                dView: true
	            }, {
	                title: 'Extracted Files',
	                select: 'count',
	                dView: true
	            }],
	            searchCategories: {
	                'count': 'Extracted Files',
	                'mime': 'MIME Type',
	                'mimegeneric': 'Genereic MIME'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/files/files_by_mime_type_filename').then(function (socket) {
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['mime', 'mimegeneric', 'name'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Files By File Name',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['mime', 'name'], // mimegeneric (not in files table)
	                    crumb: false
	                }
	            }, {
	                title: 'Genereic MIME',
	                select: 'mimegeneric',
	                dView: true
	            }, {
	                title: 'MIME Type',
	                select: 'mime',
	                dView: true
	            }, {
	                title: 'File Name',
	                select: 'name',
	                dView: true
	            }, {
	                title: 'Extracted Files',
	                select: 'count',
	                dView: true
	            }],
	            searchCategories: {
	                'count': 'Extracted Files',
	                'mime': 'MIME Type',
	                'name': 'File Name',
	                'mimegeneric': 'Genereic MIME'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('newDnsQueriesController', __webpack_require__(707));
	    ngModule.controller('newFtpRemoteController', __webpack_require__(708));
	    ngModule.controller('newHttpDomainsController', __webpack_require__(709));
	    ngModule.controller('newRemoteController', __webpack_require__(710));
	    // ngModule.controller('newLocalIpController', require('./new_local_ip'));
	    // ngModule.controller('newLocalMacController', require('./new_local_mac'));
	    ngModule.controller('newSshRemoteController', __webpack_require__(711));
	    ngModule.controller('newSslHostsController', __webpack_require__(712));
	};

/***/ },
/* 707 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/first_seen/new_dns_queries').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'resp_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bar',
	                xAxis: '',
	                yAxis: '# New DNS Queries / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.count) {
	                        p.queries += v.count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.count) {
	                        p.queries -= v.count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        queries: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            type: 'geochart',
	            searchCategories: {
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); // might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'New DNS Queries Detected',
	            columns: [{
	                title: 'First Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Query Type',
	                select: 'qtype_name',
	                dView: true
	            }, {
	                title: 'Query Class',
	                select: 'qclass_name',
	                dView: false
	            }, {
	                title: 'Response Code',
	                select: 'rcode_name',
	                dView: false
	            }, {
	                title: 'DNS Query',
	                select: 'query',
	                dView: true
	            }, {
	                title: 'Answers',
	                select: 'answers',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }],
	            searchCategories: {
	                'qtype_name': 'Query Type',
	                'qclass_name': 'Query Class',
	                'rcode_name': 'Response Code',
	                'query': 'DNS Query',
	                'answer': 'Answer',
	                'proto': 'Protocol',
	                'orig_ip': 'Origin IP',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'resp_ip': 'DNS Server',
	                'resp_port': 'Responder Port',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag',
	                'resp_asn_name': 'Responder ASN',
	                'answers': 'Answers'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 708 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/first_seen/new_ftp_remote').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'resp_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bar',
	                xAxis: '',
	                yAxis: '# New IP / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    d.hour = Number(d.hour * 1000);
	                    return d.hour;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.count) {
	                        p.ip += v.count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.count) {
	                        p.ip -= v.count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        ip: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            type: 'geochart',
	            searchCategories: {
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            },
	            outgoingFilter: { // Optional and ingests an array of KEYS for other visuals not of this type to match
	                'table': 'resp_country'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'New Responder FTP Detected',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'FTP User',
	                select: 'user',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'orig_port': 'Origin Port',
	                'resp_ip': 'Responder IP',
	                'resp_port': 'Responder Port',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag',
	                'resp_asn_name': 'Responder ASN',
	                'user': 'FTP User'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 709 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/first_seen/new_http_domains').then(function (socket) {
	
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'resp_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bar',
	                xAxis: '',
	                yAxis: '# New Domains / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.count) {
	                        p.domains += v.count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.count) {
	                        p.domains -= v.count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        domains: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            type: 'geochart',
	            searchCategories: {
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'New HTTP Domains Detected',
	            columns: [{
	                title: 'First Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Origin Stealth',
	                select: 'orig_stealth',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: true
	            }, {
	                title: 'HTTP Domain',
	                select: 'host',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'resp_ip': 'Responder IP',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag',
	                'resp_asn_name': 'Responder ASN',
	                'ftp_orig_user': 'FTP User',
	                'orig_stealth': 'Origin Stealth',
	                'proxy_blocked': 'Blocked by Proxy',
	                'host': 'HTTP Domain'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 710 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/first_seen/new_remote').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'resp_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bar',
	                xAxis: '',
	                yAxis: '# New IP / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.count) {
	                        p.ip += v.count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.count) {
	                        p.ip -= v.count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        ip: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            type: 'geochart',
	            searchCategories: {
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['id'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'New Responder IP Addresses Detected',
	            hideToggleBytes: true,
	            columns: [{
	                title: 'First Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'resp_ip': 'Responder IP',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag',
	                'resp_asn_name': 'Responder ASN'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 711 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/first_seen/new_ssh_remote').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'resp_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bar',
	                xAxis: '',
	                yAxis: '# New IP / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.count) {
	                        p.ip += v.count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.count) {
	                        p.ip -= v.count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        ip: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            type: 'geochart',
	            searchCategories: {
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            },
	            outgoingFilter: { // Optional and ingests an array of KEYS for other visuals not of this type to match
	                'table': 'resp_country'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'New Responder SSH Detected',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'SSH Client',
	                select: 'client',
	                dView: true
	            }, {
	                title: 'SSH Server',
	                select: 'server',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'resp_ip': 'Responder IP',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag',
	                'resp_asn_name': 'Responder ASN',
	                'client': 'SSH Client',
	                'server': 'SSH Server'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 712 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/first_seen/new_ssl_hosts').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'resp_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bar',
	                xAxis: '',
	                yAxis: '# New IP / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.count) {
	                        p.ip += v.count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.count) {
	                        p.ip -= v.count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        ip: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            type: 'geochart',
	            searchCategories: {
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['id'],
	            hideToggleBytes: true,
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'New SSL Server Names Detected',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Origin Stealth',
	                select: 'orig_stealth',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: true
	            }, {
	                title: 'Server Name',
	                select: 'server_name',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'resp_ip': 'Responder IP',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag',
	                'resp_asn_name': 'Responder ASN',
	                'orig_stealth': 'Origin Stealth',
	                'proxy_blocked': 'Blocked by Proxy',
	                'server_name': 'Server Name'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('inboundRespController', __webpack_require__(714));
	    ngModule.controller('inboundOrigCountryController', __webpack_require__(715));
	    ngModule.controller('inboundOrigController', __webpack_require__(716));
	    ngModule.controller('outboundRespCountryController', __webpack_require__(717));
	    ngModule.controller('outboundRespController', __webpack_require__(718));
	    ngModule.controller('outboundOrigController', __webpack_require__(719));
	    ngModule.controller('lateralRespController', __webpack_require__(720));
	    ngModule.controller('lateralOrigController', __webpack_require__(721));
	    ngModule.controller('lateralMapController', __webpack_require__(722));
	    ngModule.controller('networkAssetsController', __webpack_require__(723));
	    ngModule.controller('servicesController', __webpack_require__(724));
	    ngModule.controller('topJA3Controller', __webpack_require__(725));
	};

/***/ },
/* 714 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.complete = false;
	
	    socketIo('/api/general_network/inbound_resp').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['sensor', 'resp_hostname', 'resp_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Inbound Responder IP Traffic',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'inbound_orig_country',
	                    val: ['resp_hostname', 'resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: false
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'resp_local': 'Responder Local',
	                'resp_stealth': 'Responder Stealth',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_ip': 'Responder IP',
	                'sensor': 'Sensor',
	                'vector': 'Vector'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 715 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/inbound_orig_country').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'orig_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'orig_country': 'Origin Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    d.hour = Number(d.hour * 1000);
	                    return d.hour;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['orig_country'],
	            searchCategories: {
	                'orig_country': 'Origin Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.orig_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['sensor', 'orig_country'],
	            sort: {
	                direction: '-',
	                col: 'time'
	            }, // '-'=desc, '+'=asc
	            title: 'Inbound Origin Country / Responder IP Traffic',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'inbound_orig',
	                    val: ['orig_country', 'resp_hostname', 'resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: true
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Origin Local',
	                select: 'orig_local',
	                dView: true
	            }, {
	                title: 'Origin Country',
	                select: 'orig_country',
	                dView: true
	            }, {
	                title: 'Origin Flag',
	                select: 'orig_cc',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: false
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'vector': 'Vector',
	                'sensor': 'Sensor',
	                'orig_cc': 'Origin Flag',
	                'orig_country': 'Origin Country',
	                'orig_local': 'Origin Local',
	                'resp_local': 'Responder Local',
	                'resp_stealth': 'Responder Stealth',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_ip': 'Responder IP',
	                'proxy_blocked': 'Blocked by Proxy'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 716 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/inbound_orig').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['sensor', 'orig_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Inbound Origin / Responder Traffic',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    table_name: 'conn',
	                    val: ['orig_ip', 'resp_hostname', 'resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: true
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Origin Local',
	                select: 'orig_local',
	                dView: false
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Country',
	                select: 'orig_country',
	                dView: true
	            }, {
	                title: 'Origin Flag',
	                select: 'orig_cc',
	                dView: true
	            }, {
	                title: 'Origin ASN',
	                select: 'orig_asn_name',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: false
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'sensor': 'Sensor',
	                'ioc_count': "IOC Count",
	                'proxy_blocked': 'Blocked by Proxy',
	                'orig_local': 'Origin Local',
	                'orig_ip': 'Origin IP',
	                'orig_country': 'Origin Country',
	                'orig_cc': 'Origin Flag',
	                'orig_asn_name': 'Origin ASN',
	                'resp_local': 'Responder Local',
	                'resp_ip': 'Responder IP',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_stealth': 'Responder Stealth'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 717 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/outbound_resp_country').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: false, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'resp_country'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['resp_country'],
	            searchCategories: {
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['sensor', 'resp_country'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Outbound Responder Countries',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'outbound_resp',
	                    val: ['resp_country'],
	                    crumb: false
	                }
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: false
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: false
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Responder Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: false
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'sensor': 'Sensor',
	                'vector': 'Vector',
	                'resp_local': 'Responder Local',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Responder Flag',
	                'proxy_blocked': 'Blocked by Proxy'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                        $scope.$broadcast('updateLoad', model.loadStart);
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                    $scope.$broadcast('updateLoad', model.loadStart);
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 718 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/outbound_resp').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['sensor', 'resp_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Outgoing Responder IP Traffic',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'outbound_orig',
	                    val: ['resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: false
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Responder Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: false
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': 'IOC Count',
	                'resp_local': 'Responder Local',
	                'resp_ip': 'Responder IP',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Responder Flag',
	                'resp_asn_name': 'Responder ASN',
	                'proxy_blocked': 'Blocked by Proxy'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 719 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/outbound_orig').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['sensor', 'orig_ip', 'orig_hostname'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Outbound Origin / Responder IP Traffic',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    table_name: 'conn',
	                    val: ['orig_ip', 'orig_hostname', 'resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Origin Local',
	                select: 'orig_local',
	                dView: false
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin Stealth',
	                select: 'orig_stealth',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: false
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Responder Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': 'IOC Count',
	                'orig_local': 'Origin Local',
	                'orig_ip': 'Origin IP',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_stealth': 'Origin Stealth',
	                'resp_local': 'Responder Local',
	                'resp_ip': 'Responder IP',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Responder Flag',
	                'resp_asn_name': 'Responder ASN',
	                'proxy_blocked': 'Blocked by Proxy'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 720 */
/***/ function(module, exports) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.complete = false;
	
	    socketIo('/api/general_network/lateral_resp').then(function (socket) {
	        var _searchCategories;
	
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip', 'resp_hostname'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Lateral Responder IP Traffic',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'lateral_orig',
	                    val: ['resp_ip', 'resp_hostname'],
	                    crumb: false
	                }
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: false
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: false
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: false
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: (_searchCategories = {
	                'ioc_count': "IOC Count",
	                'sensor': 'Sensor',
	                'vector': 'Vector'
	            }, _defineProperty(_searchCategories, 'ioc_count', 'IOC Count'), _defineProperty(_searchCategories, 'resp_local', 'Responder Local'), _defineProperty(_searchCategories, 'resp_ip', 'Responder IP'), _defineProperty(_searchCategories, 'resp_hostname', 'Responder Hostname'), _defineProperty(_searchCategories, 'resp_user', 'Responder User'), _defineProperty(_searchCategories, 'proxy_blocked', 'Blocked by Proxy'), _defineProperty(_searchCategories, 'resp_stealth', 'Responder Stealth'), _searchCategories)
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 721 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/lateral_orig').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['orig_ip', 'orig_hostname'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Lateral Origin / Responder IP Traffic',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    table_name: 'conn',
	                    val: ['orig_ip', 'orig_hostname', 'resp_ip', 'resp_hostname'],
	                    crumb: false
	                }
	            }, {
	                title: 'Connections',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Origin Local',
	                select: 'orig_local',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin Stealth',
	                select: 'orig_stealth',
	                dView: true
	            }, {
	                title: 'Responder Local',
	                select: 'resp_local',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'Blocked by Proxy',
	                select: 'proxy_blocked',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'sensor': 'Sensor',
	                'vector': 'Vector',
	                'proxy_blocked': 'Blocked by Proxy',
	                'orig_local': 'Origin Local',
	                'orig_ip': 'Origin IP',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_stealth': 'Origin Stealth',
	                'resp_local': 'Responder Local',
	                'resp_ip': 'Responder IP',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_stealth': 'Responder Stealth'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(io) {'use strict';
	
	function ctrl($scope, Global, timeFormat, $location, getData, fetchStream, socketIo, $http, settings, $window) {
	    var _this = this;
	
	    $scope.global = Global;
	    this.settings = settings;
	
	    // connect to socket
	    var socketConnect = function socketConnect() {
	        _this.socket = io.connect(("https://api-demo.mantix4.com") + '/api/general_network/lateral_map', {
	            secure: true,
	            query: 'token=' + $window.sessionStorage.token,
	            forceNew: true
	        });
	
	        var time = {};
	        if ($location.$$search.start) {
	            time.start = $location.$$search.start;
	        }
	        if ($location.$$search.end) {
	            time.end = $location.$$search.end;
	        }
	        _this.socket.emit('lateral_nodes', []);
	        _this.socket.emit('lateral_connections', time);
	    };
	    socketConnect();
	
	    // saves the group and type of the node
	    this.saveNodeInfo = function (type, group, update_list, new_nodes) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/general_network/lateral_map/save_node_info',
	            data: {
	                type: type,
	                group: group,
	                update_list: update_list,
	                new_nodes: new_nodes
	            }
	        }).success(function () {}).error(function () {
	            console.log("error");
	        });
	    };
	
	    // saves the ALL the associated nodes once an already created group is edited or deleted
	    this.editAssociatedGroups = function (nodes, group) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/general_network/lateral_map/edit_associated_groups',
	            data: {
	                nodes: nodes,
	                group: group
	            }
	        }).success(function () {}).error(function () {
	            console.log("error");
	        });
	    };
	
	    // create/edit group (name, color)
	    this.createEditGroup = function (group, callback) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/general_network/lateral_map/create_edit_group',
	            data: {
	                id: group.id,
	                color: group.color,
	                name: group.name
	            }
	        }).success(function (data) {
	            callback(data);
	        }).error(function () {
	            console.log("error");
	        });
	    };
	
	    // delete group
	    this.deleteGroup = function (id) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/general_network/lateral_map/delete_group',
	            data: {
	                id: id
	            }
	        }).success(function () {}).error(function () {
	            console.log("error");
	        });
	    };
	
	    // get all group
	    this.getGroups = function () {
	        $http({
	            method: 'GET',
	            url: ("https://api-demo.mantix4.com") + '/api/general_network/lateral_map/get_groups'
	        }).success(function (data) {
	            _this.setGroups(data);
	        }).error(function (error) {
	            console.log("error");
	        });
	    };
	    this.getGroups();
	
	    $scope.$on('$destroy', function () {
	        if (_this.socket) {
	            _this.socket.disconnect();
	        }
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$location', 'getData', 'fetchStream', 'socketIo', '$http', 'settings', '$window'];
	module.exports = ctrl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(391)))

/***/ },
/* 723 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	    //set up user settings inside the page scope
	    var pathname = String(window.location.pathname).replace('/', '');
	    if (typeof $scope.global.user.settings_local[pathname] === 'undefined') {
	        $scope.global.user.settings_local[pathname] = {};
	    }
	
	    // make local scope instances of the user objects
	    $scope.settings = $scope.global.user.settings_local[pathname];
	
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/network_assets').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            updateTable: '/api/general_network/network_assets/updateTable',
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'last_seen'
	            }, // '-'=desc, '+'=asc
	            title: 'List of Assets',
	            columns: [{
	                title: 'First Seen',
	                select: 'first_seen',
	                dView: true
	            }, {
	                title: 'Last Seen',
	                select: 'last_seen',
	                dView: true
	            }, {
	                title: 'IP',
	                select: 'ip',
	                dView: true
	            }, {
	                title: 'Hostname',
	                select: 'hostname',
	                dView: true,
	                editTable: true
	            }, {
	                title: 'MAC Address',
	                select: 'mac',
	                dView: true
	            }, {
	                title: 'Vendor',
	                select: 'vendor',
	                dView: true
	            }, {
	                title: 'OS',
	                select: 'os',
	                dView: true
	            }, {
	                title: 'Type',
	                select: 'type',
	                dView: true,
	                editTable: true
	            }],
	            searchCategories: {
	                'ip': 'IP',
	                'hostname': 'Hostname',
	                'mac': 'MAC Address',
	                'vendor': 'Vendor',
	                'os': 'OS',
	                'type': 'Type'
	                // 'group': 'Group',
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 724 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, $http, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.complete = false;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.servicesIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/services').then(function (socket) {
	
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: false, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'service', 'vector', 'proto', 'resp_country', 'resp_hostname', 'resp_ip'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600 && typeof d.hour === 'string') {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                $scope.$broadcast('updatedSlider', model.lineChartIdentifiers.id);
	            }
	        });
	
	        ////////////////
	        /// SERVICES ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: ['outbound', 'inbound', 'lateral'],
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            complete: 0,
	            grouping: ['service', 'proto', 'l7_app'],
	            type: 'services',
	            searchCategories: {
	                'ioc_count': "IOC Count",
	                'proto': 'Protocol',
	                'service': 'Service',
	                'proto_service': 'Protocol Service',
	                'name': 'Name',
	                'resp_ip': 'Responder IP',
	                'resp_hostname': 'Responder Hostname',
	                'orig_ip': 'Origin IP',
	                'orig_hostname': 'Origin Hostname',
	                'resp_24': 'Subnet 24',
	                'resp_16': 'Subnet 16',
	                'vector': 'Vector',
	                'l7_app': 'l7 Protocol',
	                'resp_country': 'Responder Country',
	                'orig_country': 'Origin Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.proto_service;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.orig_ip) {
	                        if (!p.clients[v.orig_ip]) {
	                            p.clients[v.orig_ip] = {
	                                name: v.orig_ip + ' (' + v.orig_hostname + ')',
	                                ip: v.orig_ip,
	                                hostname: v.orig_hostname,
	                                resp_24: v.orig_24,
	                                resp_16: v.orig_16,
	                                count: v.count,
	                                ioc_count: v.ioc_count,
	                                bytes_orig: v.bytes_orig,
	                                bytes_resp: v.bytes_resp,
	                                visible: true,
	                                type: 'orig_internal',
	                                total_bytes: v.bytes_orig + v.bytes_resp
	                            };
	                        } else {
	                            if (p.clients[v.orig_ip].hostname === 'N/A' && v.orig_hostname !== 'N/A') {
	                                p.clients[v.orig_ip].name = v.orig_ip + ' (' + v.orig_hostname + ')';
	                                p.clients[v.orig_ip].hostname = v.orig_hostname;
	                            }
	                            p.clients[v.orig_ip].ioc_count += v.ioc_count;
	                            p.clients[v.orig_ip].count += v.count;
	                            p.clients[v.orig_ip].bytes_orig += v.bytes_orig;
	                            p.clients[v.orig_ip].bytes_resp += v.bytes_resp;
	                            p.clients[v.orig_ip].total_bytes += v.bytes_orig + v.bytes_resp;
	                        }
	                    } else if (v.orig_country) {
	                        if (!p.clients[v.orig_country]) {
	                            p.clients[v.orig_country] = {
	                                name: String(v.orig_cc).toLowerCase(),
	                                name_toggle: v.orig_country,
	                                count: v.count,
	                                ioc_count: v.ioc_count,
	                                bytes_orig: v.bytes_orig,
	                                bytes_resp: v.bytes_resp,
	                                visible: true,
	                                type: 'orig_external',
	                                total_bytes: v.bytes_orig + v.bytes_resp
	                            };
	                        } else {
	                            p.clients[v.orig_country].ioc_count += v.ioc_count;
	                            p.clients[v.orig_country].count += v.count;
	                            p.clients[v.orig_country].bytes_orig += v.bytes_orig;
	                            p.clients[v.orig_country].bytes_resp += v.bytes_resp;
	                            p.clients[v.orig_country].total_bytes += v.bytes_orig + v.bytes_resp;
	                        }
	                    } else if (v.resp_country) {
	                        if (!p.servers[v.resp_country]) {
	                            p.servers[v.resp_country] = {
	                                name: String(v.resp_cc).toLowerCase(),
	                                name_toggle: v.resp_country,
	                                count: v.count,
	                                ioc_count: v.ioc_count,
	                                bytes_orig: v.bytes_orig,
	                                bytes_resp: v.bytes_resp,
	                                visible: true,
	                                type: 'external',
	                                total_bytes: v.bytes_orig + v.bytes_resp
	                            };
	                        } else {
	                            p.servers[v.resp_country].ioc_count += v.ioc_count;
	                            p.servers[v.resp_country].count += v.count;
	                            p.servers[v.resp_country].bytes_orig += v.bytes_orig;
	                            p.servers[v.resp_country].bytes_resp += v.bytes_resp;
	                            p.servers[v.resp_country].total_bytes += v.bytes_orig + v.bytes_resp;
	                        }
	                    } else if (v.resp_ip) {
	                        if (!p.servers[v.resp_ip]) {
	                            p.servers[v.resp_ip] = {
	                                name: v.resp_ip + ' (' + v.resp_hostname + ')',
	                                ip: v.resp_ip,
	                                hostname: v.resp_hostname,
	                                resp_24: v.resp_24,
	                                resp_16: v.resp_16,
	                                count: v.count,
	                                ioc_count: v.ioc_count,
	                                bytes_orig: v.bytes_orig,
	                                bytes_resp: v.bytes_resp,
	                                visible: true,
	                                type: 'internal',
	                                total_bytes: v.bytes_orig + v.bytes_resp
	                            };
	                        } else {
	                            if (p.servers[v.resp_ip].hostname === 'N/A' && v.resp_hostname !== 'N/A') {
	                                p.servers[v.resp_ip].name = v.resp_ip + ' (' + v.resp_hostname + ')';
	                                p.servers[v.resp_ip].hostname = v.resp_hostname;
	                            }
	                            p.servers[v.resp_ip].ioc_count += v.ioc_count;
	                            p.servers[v.resp_ip].count += v.count;
	                            p.servers[v.resp_ip].bytes_orig += v.bytes_orig;
	                            p.servers[v.resp_ip].bytes_resp += v.bytes_resp;
	                            p.servers[v.resp_ip].total_bytes += v.bytes_orig + v.bytes_resp;
	                        }
	                    }
	                    if (v.l7_app) {
	                        if (!p.l7_apps[v.l7_app]) {
	                            p.l7_apps[v.l7_app] = {
	                                name: v.l7_app,
	                                count: v.count,
	                                ioc_count: v.ioc_count,
	                                type: 'application',
	                                visible: true,
	                                service: v.service,
	                                proto: v.proto,
	                                clients: {},
	                                servers: {},
	                                bytes_orig: v.bytes_orig,
	                                bytes_resp: v.bytes_resp,
	                                total_bytes: v.bytes_orig + v.bytes_resp
	                            };
	                        } else {
	                            p.l7_apps[v.l7_app].ioc_count += v.ioc_count;
	                            p.l7_apps[v.l7_app].count += v.count;
	                            p.l7_apps[v.l7_app].bytes_orig += v.bytes_orig;
	                            p.l7_apps[v.l7_app].bytes_resp += v.bytes_resp;
	                            p.l7_apps[v.l7_app].total_bytes += v.bytes_orig + v.bytes_resp;
	                        }
	                        if (v.orig_ip) {
	                            if (p.l7_apps[v.l7_app].clients[v.orig_ip]) {
	                                p.l7_apps[v.l7_app].clients[v.orig_ip].ioc_count += v.ioc_count;
	                                p.l7_apps[v.l7_app].clients[v.orig_ip].value += 1;
	                            } else {
	                                p.l7_apps[v.l7_app].clients[v.orig_ip] = {};
	                                p.l7_apps[v.l7_app].clients[v.orig_ip].name = v.orig_ip + ' (' + v.orig_hostname + ')';
	                                p.l7_apps[v.l7_app].clients[v.orig_ip].ioc_count = v.ioc_count;
	                                p.l7_apps[v.l7_app].clients[v.orig_ip].value = 1;
	                            }
	                        } else if (v.orig_country) {
	                            if (p.l7_apps[v.l7_app].clients[v.orig_country]) {
	                                p.l7_apps[v.l7_app].clients[v.orig_country].ioc_count += v.ioc_count;
	                                p.l7_apps[v.l7_app].clients[v.orig_country].value += 1;
	                            } else {
	                                p.l7_apps[v.l7_app].clients[v.orig_country] = {};
	                                p.l7_apps[v.l7_app].clients[v.orig_country].name = String(v.orig_cc).toLowerCase();
	                                p.l7_apps[v.l7_app].clients[v.orig_country].ioc_count = v.ioc_count;
	                                p.l7_apps[v.l7_app].clients[v.orig_country].value = 1;
	                            }
	                        } else if (v.resp_country) {
	                            if (p.l7_apps[v.l7_app].servers[v.resp_country]) {
	                                p.l7_apps[v.l7_app].servers[v.resp_country].ioc_count += v.ioc_count;
	                                p.l7_apps[v.l7_app].servers[v.resp_country].value += 1;
	                            } else {
	                                p.l7_apps[v.l7_app].servers[v.resp_country] = {};
	                                p.l7_apps[v.l7_app].servers[v.resp_country].name = String(v.resp_cc).toLowerCase();
	                                p.l7_apps[v.l7_app].servers[v.resp_country].ioc_count = v.ioc_count;
	                                p.l7_apps[v.l7_app].servers[v.resp_country].value = 1;
	                            }
	                        } else if (v.resp_ip) {
	                            if (p.l7_apps[v.l7_app].servers[v.resp_ip]) {
	                                p.l7_apps[v.l7_app].servers[v.resp_ip].ioc_count += v.ioc_count;
	                                p.l7_apps[v.l7_app].servers[v.resp_ip].value += 1;
	                            } else {
	                                p.l7_apps[v.l7_app].servers[v.resp_ip] = {};
	                                p.l7_apps[v.l7_app].servers[v.resp_ip].ioc_count = v.ioc_count;
	                                p.l7_apps[v.l7_app].servers[v.resp_ip].name = v.resp_ip + ' (' + v.resp_hostname + ')';
	                                p.l7_apps[v.l7_app].servers[v.resp_ip].value = 1;
	                            }
	                        }
	                    }
	                    p.proto = v.proto;
	                    p.service = v.service;
	                    p.proto_service = v.proto_service;
	                    p.name = v.proto_service;
	                    p.type = 'services';
	                    p.ioc_count += v.ioc_count;
	                    p.tot_count += v.count;
	                    p.tot_bytes_orig += v.bytes_orig;
	                    p.tot_bytes_resp += v.bytes_resp;
	                    p.tot_total_bytes += v.bytes_orig + v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    if (v.orig_ip) {
	                        if (p.clients[v.orig_ip]) {
	                            p.clients[v.orig_ip].ioc_count -= v.ioc_count;
	                            p.clients[v.orig_ip].count -= v.count;
	                            p.clients[v.orig_ip].bytes_orig -= v.bytes_orig;
	                            p.clients[v.orig_ip].bytes_resp -= v.bytes_resp;
	                            p.clients[v.orig_ip].total_bytes -= v.bytes_orig + v.bytes_resp;
	                        }
	                    } else if (v.orig_country) {
	                        if (p.clients[v.orig_country]) {
	                            p.clients[v.orig_country].ioc_count -= v.ioc_count;
	                            p.clients[v.orig_country].count -= v.count;
	                            p.clients[v.orig_country].bytes_orig -= v.bytes_orig;
	                            p.clients[v.orig_country].bytes_resp -= v.bytes_resp;
	                            p.clients[v.orig_country].total_bytes -= v.bytes_orig + v.bytes_resp;
	                        }
	                    } else if (v.resp_country) {
	                        if (p.servers[v.resp_country]) {
	                            p.servers[v.resp_country].ioc_count -= v.ioc_count;
	                            p.servers[v.resp_country].count -= v.count;
	                            p.servers[v.resp_country].bytes_orig -= v.bytes_orig;
	                            p.servers[v.resp_country].bytes_resp -= v.bytes_resp;
	                            p.servers[v.resp_country].total_bytes -= v.bytes_orig + v.bytes_resp;
	                        }
	                    } else if (v.resp_ip) {
	                        if (p.servers[v.resp_ip]) {
	                            p.servers[v.resp_ip].ioc_count -= v.ioc_count;
	                            p.servers[v.resp_ip].count -= v.count;
	                            p.servers[v.resp_ip].bytes_orig -= v.bytes_orig;
	                            p.servers[v.resp_ip].bytes_resp -= v.bytes_resp;
	                            p.servers[v.resp_ip].total_bytes -= v.bytes_orig + v.bytes_resp;
	                        }
	                    }
	                    if (v.l7_app) {
	                        if (p.l7_apps[v.l7_app]) {
	                            if (v.orig_ip) {
	                                if (p.l7_apps[v.l7_app].clients[v.orig_ip]) {
	                                    p.l7_apps[v.l7_app].clients[v.orig_ip].value -= 1;
	                                    p.l7_apps[v.l7_app].clients[v.orig_ip].ioc_count -= v.ioc_count;
	                                }
	                            } else if (v.orig_country) {
	                                if (p.l7_apps[v.l7_app].clients[v.orig_country]) {
	                                    p.l7_apps[v.l7_app].clients[v.orig_country].value -= 1;
	                                    p.l7_apps[v.l7_app].clients[v.orig_country].ioc_count -= v.ioc_count;
	                                }
	                            } else if (v.resp_country) {
	                                if (p.l7_apps[v.l7_app].servers[v.resp_country]) {
	                                    p.l7_apps[v.l7_app].servers[v.resp_country].value -= 1;
	                                    p.l7_apps[v.l7_app].servers[v.resp_country].ioc_count -= v.ioc_count;
	                                }
	                            } else if (v.resp_ip) {
	                                if (p.l7_apps[v.l7_app].servers[v.resp_ip]) {
	                                    p.l7_apps[v.l7_app].servers[v.resp_ip].value -= 1;
	                                    p.l7_apps[v.l7_app].servers[v.resp_ip].ioc_count -= v.ioc_count;
	                                }
	                            }
	                            p.l7_apps[v.l7_app].ioc_count -= v.ioc_count;
	                            p.l7_apps[v.l7_app].count -= v.count;
	                            p.l7_apps[v.l7_app].bytes_orig -= v.bytes_orig;
	                            p.l7_apps[v.l7_app].bytes_resp -= v.bytes_resp;
	                            p.l7_apps[v.l7_app].total_bytes -= v.bytes_orig + v.bytes_resp;
	                        }
	                    }
	                    p.ioc_count -= v.ioc_count;
	                    p.tot_count -= v.count;
	                    p.tot_bytes_orig -= v.bytes_orig;
	                    p.tot_bytes_resp -= v.bytes_resp;
	                    p.tot_total_bytes -= v.bytes_orig + v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        proto: '',
	                        service: '',
	                        proto_service: '',
	                        name: '',
	                        visible: true,
	                        servers: {},
	                        l7_apps: {},
	                        clients: {},
	                        ioc_count: 0,
	                        tot_count: 0,
	                        tot_bytes_orig: 0,
	                        tot_bytes_resp: 0,
	                        tot_total_bytes: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (res) {
	            model.servicesIdentifiers = {
	                id: res.id,
	                key: res.key
	            };
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	
	            $scope.main.dataObjects[model.servicesIdentifiers.key].dimension = $scope.main.dataObjects[model.servicesIdentifiers.key].settings.dimension($scope.main.dataObjects[model.servicesIdentifiers.key].cf);
	            $scope.main.dataObjects[model.servicesIdentifiers.key].group = $scope.main.dataObjects[model.servicesIdentifiers.key].settings.group($scope.main.dataObjects[model.servicesIdentifiers.key].dimension);
	
	            var _loop = function _loop(i, len) {
	                new fetchStream(res.settings.get.call[i], res.settings.get.socket).then(function (resu) {
	                    if ($scope.main.dataObjects[model.servicesIdentifiers.key].group) {
	                        $scope.main.dataObjects[model.servicesIdentifiers.key].settings.complete++;
	                        if ($scope.main.dataObjects[model.servicesIdentifiers.key].settings.complete >= len) {
	                            model.complete = true;
	                            usSpinnerService.stop('spinner-' + model.servicesIdentifiers.id);
	                        }
	                    }
	                }, function (err) {}, function (result) {
	                    if ($scope.main.dataObjects[model.servicesIdentifiers.key].group) {
	                        $scope.main.dataObjects[model.servicesIdentifiers.key].cf.add(result.rows);
	                        if (!$scope.main.dataObjects[model.servicesIdentifiers.key].launched) {
	                            $scope.$broadcast('init', model.servicesIdentifiers);
	                        } else {
	                            $scope.$broadcast('updatedData', model.servicesIdentifiers.id, true);
	                        }
	                        if (result.min) {
	                            model.loadStart = Math.min(model.loadStart, result.min);
	                            $scope.$broadcast('updateLoad', model.loadStart);
	                        }
	                    }
	                });
	            };
	
	            for (var i = 0, len = res.settings.get.call.length; i < len; i++) {
	                _loop(i, len);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	            model = null;
	            socket = null;
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$http', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 725 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	    //set up user settings inside the page scope
	    var pathname = String(window.location.pathname).replace('/', '');
	    if (typeof $scope.global.user.settings_local[pathname] === 'undefined') {
	        $scope.global.user.settings_local[pathname] = {};
	    }
	
	    // make local scope instances of the user objects
	    $scope.settings = $scope.global.user.settings_local[pathname];
	
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/general_network/top_ja3').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            updateTable: '/api/general_network/top_ja3/updateTable',
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'count'
	            }, // '-'=desc, '+'=asc
	            title: 'TOP JA3 hashes',
	            columns: [{
	                title: 'JA3',
	                select: 'ja3',
	                dView: true
	            }, {
	                title: 'Count',
	                select: 'count',
	                dView: true
	            }],
	            searchCategories: {
	                'ja3': 'JA3'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	// import { ctrl as outbound_ioc } from "./outbound_ioc";
	"use strict";
	module.exports = function (ngModule) {
	    ngModule.controller('customIOCController', __webpack_require__(727));
	    ngModule.controller('iocEventsDrilldownController', __webpack_require__(728));
	    ngModule.controller('inboundIocController', __webpack_require__(731));
	    ngModule.controller('outboundIocController', __webpack_require__(732));
	    ngModule.controller('lateralIocController', __webpack_require__(733));
	    ngModule.controller('iocFeedsController', __webpack_require__(734));
	    ngModule.controller('archiveController', __webpack_require__(735));
	    ngModule.controller('whitelistController', __webpack_require__(736));
	    ngModule.controller('adEventsController', __webpack_require__(737));
	    ngModule.controller('adEventsDrillController', __webpack_require__(738));
	    ngModule.controller('cyr3conController', __webpack_require__(739));
	};


/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService, $http) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.tableIdentifiers = { key: false, id: false };
	    var appList = document.getElementsByClassName("applicationResults");
	    var input = document.getElementsByClassName("iocRuleInput");
	
	    var obj = { rule: "", type: "" };
	
	    if ($stateParams.include) {
	        switch ($stateParams.include[0].column) {
	            case 'resp_ip':
	            case 'orig_ip':
	            case 'ip':
	                obj.type = "IPType";
	                break;
	            case 'filename':
	            case 'file_name':
	            case 'file':
	                obj.type = "FileType";
	                break;
	            case 'md5':
	            case 'sha1':
	            case 'sha256':
	                obj.type = "HashType";
	                break;
	            case 'top_domain':
	            case 'domain':
	            case 'host':
	            case 'subdomain':
	                obj.type = "HTTPType";
	                break;
	            default:
	                obj.type = '';
	                break;
	        }
	        obj.rule = $stateParams.include[0].value;
	    }
	
	    model.formFields = angular.copy({
	        ioc_alert: 1,
	        active_defense: 1,
	        ioc_severity: "1",
	        ioc_attribute: [obj],
	        zone: "N/A"
	    });
	
	    var appIndex = -1;
	
	    model.appNotEqual = false;
	
	    var keys = {
	        up: 38,
	        down: 40,
	        left: 37,
	        right: 39,
	        esc: 27,
	        back: 8,
	        enter: 13
	    };
	
	    model.applications = ['AFP', 'Aimini', 'Amazon', 'Apple', 'AppleiCloud', 'AppleiTunes', 'AppleJuice', 'Armagetron', 'AVI', 'Ayiya', 'BattleField', 'BGP', 'BitTorrent', 'CiscoSkinny', 'CiscoVPN', 'Citrix', 'Citrix_Online', 'CNN', 'Collectd', 'Corba', 'Crossfire', 'DCE_RPC', 'DHCP', 'DHCPV6', 'Direct_Download_Link', 'DirectConnect', 'DNS', 'Dofus', 'DropBox', 'eBay', 'eDonkey', 'EGP', 'EPP', 'Facebook', 'FacebookChat', 'FastTrack', 'Fiesta', 'Filetopia', 'Flash', 'Florensia', 'FTP_CONTROL', 'FTP_DATA', 'GMail', 'Gnutella', 'Google', 'GoogleMaps', 'GRE', 'GrooveShark', 'GTP', 'Guildwars', 'H323', 'HalfLife2', 'HTTP', 'HTTP_Application_ActiveSync', 'HTTP_APPLICATION_VEOHTV', 'HTTP_Connect', 'HTTP_Proxy', 'IAX', 'IceCast', 'ICMP', 'ICMPV6', 'IGMP', 'IMAP', 'IMAPS', 'iMESH', 'IP_in_IP', 'IPP', 'IPsec', 'IRC', 'Kerberos', 'Kontiki', 'LastFM', 'LDAP', 'LLMNR', 'LotusNotes', 'MapleStory', 'MDNS', 'Meebo', 'Megaco', 'MGCP', 'MMS', 'Move', 'MPEG', 'MSN', 'MsSQL', 'MySQL', 'NetBIOS', 'NetFlix', 'NetFlow', 'NFS', 'NOE', 'NTP', 'OggVorbis', 'OpenFT', 'OpenVPN', 'Oracle', 'Oscar', 'OSPF', 'Pando_Media_Booster', 'PcAnywhere', 'POP3', 'POPS', 'PostgreSQL', 'PPLive', 'PPStream', 'PPTP', 'QQ', 'QQLive', 'Quake', 'QuickTime', 'Radius', 'RDP', 'RealMedia', 'Redis', 'RemoteScan', 'RSYNC', 'RTCP', 'RTMP', 'RTP', 'RTSP', 'SAP', 'SCTP', 'sFlow', 'ShoutCast', 'SIP', 'SkyFile_PostPaid', 'SkyFile_PrePaid', 'SkyFile_Rudics', 'Skype', 'SMB', 'SMTP', 'SMTPS', 'SNMP', 'SOCKS4', 'SOCKS5', 'Socrates', 'Sopcast', 'Soulseek', 'Spotify', 'SSDP', 'SSH', 'SSL', 'SSL_No_Cert', 'Stealthnet', 'Steam', 'STUN', 'Syslog', 'TDS', 'TeamSpeak', 'TeamViewer', 'Telegram', 'Telnet', 'TFTP', 'Thunder', 'TOR', 'TruPhone', 'Tuenti', 'Tvants', 'TVUplayer', 'Twitter', 'UbuntuONE', 'Unencryped_Jabber', 'Unknown', 'UPnP', 'Usenet', 'VHUA', 'Viber', 'VMware', 'VNC', 'VRRP', 'Warcraft3', 'Webex', 'WebM', 'WhatsApp', 'Whois-DAS', 'Wikipedia', 'WindowsMedia', 'WindowsUpdate', 'WinMX', 'WorldOfKungFu', 'WorldOfWarcraft', 'Xbox', 'XDMCP', 'Yahoo', 'YouTube', 'Zattoo', 'ZeroMQ'];
	    model.filteredApps = {};
	    model.applications.sort();
	
	    model.checkApps = function (index, type) {
	        for (var i = 0; i < appList.length; i++) {
	            appList[i].className = "applicationResults term-list hidden";
	        }
	
	        model.filteredApps[index] = model.applications.filter(function (d) {
	            if (model.formFields.ioc_attribute[index].rule) {
	                if (d.toLowerCase().indexOf(model.formFields.ioc_attribute[index].rule.toLowerCase()) > -1) {
	                    return d;
	                }
	            }
	        });
	        if (model.formFields.ioc_attribute[index].type === "l7proto") {
	            if (model.filteredApps[index].length === 1 && model.filteredApps[index][0].toLowerCase() === model.formFields.ioc_attribute[index].rule.toLowerCase()) {
	                model.formFields.ioc_attribute[index].rule = model.filteredApps[index][0];
	                appList[index].className = "applicationResults term-list hidden";
	            } else if (model.filteredApps[index].length > 0) {
	                appList[index].className = "applicationResults term-list";
	            } else {
	                appList[index].className = "applicationResults term-list hidden";
	            }
	
	            input[index].onkeydown = function (e) {
	                if (appList[index]) {
	                    var list = appList[index].querySelectorAll('.customIocApp');
	                    e = e || window.event;
	                    var charcode = typeof e.which == "number" ? e.which : e.keyCode;
	                    if (charcode === keys.down) {
	                        if (appIndex < model.filteredApps[index].length - 1) {
	                            if (appList[index].className.indexOf("hidden") === -1) {
	                                appIndex++;
	                            } else {
	                                appList[index].className = "applicationResults term-list";
	                            }
	                        }
	                    } else if (charcode === keys.up) {
	                        if (appIndex > 0) {
	                            if (appList[index].className.indexOf("hidden") === -1) {
	                                appIndex--;
	                            }
	                        }
	                    } else if (charcode === keys.esc) {
	                        appList[index].className = "applicationResults term-list hidden";
	                        appIndex = -1;
	                    } else if (charcode === keys.back) {
	                        appIndex = 0;
	                    } else if (charcode === keys.enter) {
	                        if (appIndex > -1) {
	                            $scope.$apply(function () {
	                                model.formFields.ioc_attribute[index].rule = list[appIndex].innerHTML;
	                            });
	                            appList[index].className = "applicationResults term-list hidden";
	                            appIndex = -1;
	                        }
	                    }
	                    for (var _i = 0, len = list.length; _i < len; _i++) {
	                        list[_i].className = "customIocApp";
	                    }
	                    if (list.length > appIndex && appIndex > -1) {
	                        list[appIndex].className = "customIocApp customIocAppSelect";
	                    }
	                }
	            };
	        } else {
	            appList[index].className = "applicationResults term-list hidden";
	        }
	    };
	    window.onkeydown = function (e) {
	        e = e || window.event;
	        var charcode = typeof e.which == "number" ? e.which : e.keyCode;
	        if (charcode === keys.enter) {
	            e.preventDefault();
	        }
	    };
	
	    model.setRule = function (index, value) {
	        model.formFields.ioc_attribute[index].rule = value;
	        for (var i = 0; i < appList.length; i++) {
	            appList[i].className = "applicationResults term-list hidden";
	        }
	        model.filteredApps = {};
	    };
	
	    // inital setup of form variable
	    model.setForm = function (form) {
	        model.formFields = model.formFields;
	    };
	
	    model.addAttribute = function () {
	        if (model.formFields.ioc_attribute.length < 11) {
	            model.formFields.ioc_attribute.push({ rule: "", type: "IPType" });
	        }
	    };
	
	    model.removeAttribute = function (index) {
	        if (model.formFields.ioc_attribute.length > 1) {
	            model.formFields.ioc_attribute.splice(index, 1);
	        }
	    };
	
	    model.handleInsert = function (data) {
	        model.appNotEqual = true;
	        model.hasL7 = false;
	        for (var i = 0, len = data.ioc_attribute.length; i < len; i++) {
	            if (data.ioc_attribute[i].type === "l7proto") {
	                model.hasL7 = true;
	                model.appNotEqual = true;
	                for (var j = 0, applen = model.applications.length; j < applen; j++) {
	                    if (model.applications[j].toLowerCase() === data.ioc_attribute[i].rule.toLowerCase()) {
	                        data.ioc_attribute[i].rule = model.applications[j];
	                        model.appNotEqual = false;
	                    }
	                }
	                if (model.appNotEqual) {
	                    return;
	                }
	            }
	        }
	        if (model.hasL7) {
	            if (!model.appNotEqual) {
	                model.insert(data);
	            }
	        } else {
	            model.insert(data);
	        }
	    };
	
	    model.insert = function (data) {
	        data.ioc_attribute = angular.copy(data.ioc_attribute);
	        if (typeof data.ioc_attribute === "string") {
	            data.ioc_attribute = JSON.parse(array[a].ioc_attribute);
	        }
	        data.custom_type = [];
	        data.custom_rule = [];
	        for (var i in data.ioc_attribute) {
	            data.custom_type.push(data.ioc_attribute[i].type);
	            data.custom_rule.push(data.ioc_attribute[i].rule);
	        }
	        data.ioc_attribute = JSON.stringify(data.ioc_attribute);
	        var time = angular.copy($scope.main.getTime());
	        data.email = $scope.global.user.email;
	        data.time = Math.round(new Date().getTime() / 1000);
	        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
	            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
	        }
	        // $scope.main.manualQuery(time, { call:'insert', params: angular.copy(data) });
	
	        var newIOC = angular.copy(data);
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/ioc_notifications/custom_ioc/insert',
	            data: {
	                id: newIOC.id,
	                email: newIOC.email,
	                ioc_class: newIOC.ioc_class,
	                ioc_severity: newIOC.ioc_severity,
	                ioc_alert: newIOC.ioc_alert,
	                active_defense: newIOC.active_defense,
	                ioc_attribute: newIOC.ioc_attribute,
	                time: newIOC.time,
	                zone: newIOC.zone
	            }
	        }).success(function (result) {
	            result[0].custom_type = JSON.stringify(newIOC.custom_type);
	            result[0].custom_rule = JSON.stringify(newIOC.custom_rule);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                $scope.main.buildDimGroup(result, model.tableIdentifiers).then(function () {
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                });
	            }
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
	                return d.id == result[0].id;
	            });
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result);
	            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	        });
	
	        model.formFields = angular.copy({
	            ioc_alert: 1,
	            active_defense: 1,
	            ioc_severity: "1",
	            ioc_attribute: [{ rule: "", type: "IPType" }],
	            zone: "N/A"
	        });
	        model.filteredApps = {};
	        for (var _i2 = 0; _i2 < appList.length; _i2++) {
	            appList[_i2].className = "applicationResults term-list hidden";
	        }
	        delete model.editMode;
	        model.customIOCForm.$setPristine();
	        model.setForm();
	        model.appNotEqual = false;
	        appList.className = "term-list hidden";
	        appIndex = -1;
	    };
	
	    // DELETE ROW FROM TABLE
	    model.deleteTarget = function (data) {
	        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
	            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
	        }
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/ioc_notifications/custom_ioc/delete',
	            data: {
	                id: data.id
	            }
	        }).success(function () {
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
	                return d.id == data.id;
	            });
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
	            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	        });
	    };
	
	    model.editTarget = function (call, data) {
	        if (data.ioc_alert !== 0) {
	            data.ioc_alert = 1;
	        }
	        if (data.active_defense !== 0) {
	            data.active_defense = 1;
	        }
	        if (typeof data.ioc_attribute === "string") {
	            data.ioc_attribute = JSON.parse(data.ioc_attribute);
	        }
	        // ioc_attribute
	        model.formFields = data;
	        model.editMode = {
	            call: call,
	            id: data.id,
	            value: true
	        };
	    };
	
	    function convertRuleType(array) {
	        for (var _a in array) {
	            if (typeof array[_a].ioc_attribute === "string") {
	                array[_a].ioc_attribute = JSON.parse(array[_a].ioc_attribute);
	            }
	            array[_a].custom_type = [];
	            array[_a].custom_rule = [];
	            for (var i in array[_a].ioc_attribute) {
	                array[_a].custom_type.push(array[_a].ioc_attribute[i].type);
	                array[_a].custom_rule.push(array[_a].ioc_attribute[i].rule);
	            }
	        }
	        return array;
	    }
	
	    socketIo('/api/ioc_notifications/custom_ioc').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['id'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            hideToggleBytes: true,
	            title: 'Indicators of Compromise (IOC) Notifications',
	            columns: [{ title: 'Created', select: 'time', dView: true }, { title: 'Created By', select: 'email', dView: true }, { title: 'IOC Class', select: 'ioc_class', dView: true }, { title: 'IOC Severity', select: 'ioc_severity', dView: true }, { title: 'IOC Alert', select: 'ioc_alert', dView: true }, { title: 'Active Defense', select: 'active_defense', dView: true }, { title: 'IOC Type', select: 'custom_type', dView: true }, { title: 'IOC Rule', select: 'custom_rule', dView: true }, {
	                title: 'Delete',
	                select: "Delete",
	                dView: true,
	                link: {
	                    type: 'Delete',
	                    call: 'delete'
	                }
	            }, {
	                title: 'Edit',
	                select: 'Edit',
	                dView: true,
	                link: {
	                    type: 'Edit',
	                    call: 'insert'
	                }
	            }],
	            searchCategories: {
	                'email': 'Email',
	                'ioc_class': 'IOC Class',
	                'active_defense': 'Active Defense',
	                'ioc_attribute': 'IOC Attribute',
	                'custom_type': 'IOC Type',
	                'custom_rule': 'IOC Rule',
	                'ioc_severity': 'IOC Severity'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            result.rows = convertRuleType(result.rows);
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService', '$http'];
	module.exports = ctrl;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(crossfilter) {'use strict';
	
	function ctrl($scope, $location, Global, $http, timeFormat, fetchStream, socketIo, settings, usSpinnerService, ngDialog) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    $scope.data = {};
	    $scope.infoData = {};
	
	    socketIo('/api/ioc_notifications/ioc_events_drilldown').then(function (socket) {
	        var host = {
	            ip: "",
	            hostname: ""
	        };
	        if ($location.$$search.vector === "outbound") {
	            host.ip = $location.$$search.orig_ip;
	            host.hostname = $location.$$search.orig_hostname;
	        } else {
	            host.ip = $location.$$search.resp_ip;
	            host.hostname = $location.$$search.resp_hostname;
	        }
	        /////////////////
	        /// USER INFO ///
	        /////////////////
	        new fetchStream('user_info', socket, host).then(function (result) {}, function (err) {}, function (result) {
	            if (result.rows[0]) {
	                $scope.infoData = result.rows[0];
	                $scope.infoData.last = timeFormat($scope.infoData.time, "tables");
	                host.sensor = $scope.infoData.sensor;
	                if ($location.$$search.resp_hostname) {
	                    $scope.infoData.resp_hostname = $location.$$search.resp_hostname;
	                }
	                if ($location.$$search.orig_hostname) {
	                    $scope.infoData.orig_hostname = $location.$$search.orig_hostname;
	                }
	                new fetchStream('ioc_desc', socket, host).then(function (result) {}, function (err) {}, function (result) {
	                    if (result.rows.length > 0) {
	                        $scope.infoData.desc = result.rows[0].description;
	                    }
	                });
	                new fetchStream('ioc_info', socket, host).then(function (result) {}, function (err) {}, function (result) {
	                    $scope.child_ioc = result;
	                });
	            }
	        });
	
	        var id = 0;
	        model.drillDownComplete = false;
	        model.iocSwimlane = false;
	        var finished = 0;
	        $scope.crossfilterData = new crossfilter();
	        // $scope.lanes = ['IOC', 'IOC Severity', 'Conn', 'Applications', 'DNS', 'HTTP', 'SSL', 'Email', 'File', 'Endpoint'];
	        // let lanes = ['ioc', 'ioc_severity', 'conn', 'application', 'dns', 'http', 'ssl', 'email', 'file', 'endpoint'];
	        // let lanes_drill = ['ioc', 'ioc_severity', 'conn_drill', 'application_drill', 'dns_drill', 'http_drill', 'ssl_drill', 'email_drill', 'file_drill', 'endpoint_drill'];
	        $scope.lanes = ['IOC', 'IOC Severity', 'Conn', 'Applications', 'DNS', 'HTTP', 'SSL', 'File'];
	        var lanes = ['ioc', 'ioc_severity', 'conn', 'application', 'dns', 'http', 'ssl', 'file'];
	        var lanes_drill = ['ioc', 'ioc_severity', 'conn_drill', 'application_drill', 'dns_drill', 'http_drill', 'ssl_drill', 'file_drill'];
	
	        $scope.$broadcast('startSpinner');
	        // $scope.$broadcast('stopSpinner');
	        for (var i = 0, len = lanes.length; i < len; i++) {
	            new fetchStream(lanes[i], socket, host).then(function (result) {
	                finished++;
	                if (finished >= lanes.length) {
	                    $scope.$broadcast('stopSpinner');
	                }
	            }, function (err) {}, function (result) {
	                result.rows.forEach(function (child) {
	                    child.dd = timeFormat(child.time, 'strdDateObj');
	                    child.id = id;
	                    id++;
	                    child.deep = false; // important for our filtering of deep items
	                });
	                $scope.crossfilterData.add(result.rows);
	
	                if (typeof $scope.crossfilterData.launched === "undefined") {
	                    $scope.$broadcast('laneGraph');
	                } else {
	                    $scope.updatedSwimLaneData(result.rows);
	                }
	            });
	        }
	
	        $scope.getDrillDown = function (params, time) {
	            finished = 0;
	            if (!params) {
	                params = host;
	            } else {
	                params.ip = host.ip;
	                params.hostname = host.hostname;
	            }
	            $scope.$broadcast('startSpinner');
	            for (var j = 0, leng = lanes_drill.length; j < leng; j++) {
	                new fetchStream(lanes_drill[j], socket, params, time).then(function (result) {
	                    finished++;
	                    if (finished >= lanes_drill.length) {
	                        $scope.$broadcast('stopSpinner');
	                    }
	                }, function (err) {}, function (result) {
	                    result.rows.forEach(function (child) {
	                        child.dd = timeFormat(child.time, 'strdDateObj');
	                        child.id = id;
	                        id++;
	                        child.deep = true; // important for our filtering of deep items
	                    });
	                    $scope.crossfilterData.add(result.rows);
	                    $scope.updatedSwimLaneData(result.rows, true);
	                });
	            }
	        };
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	
	    $scope.description = function (d, e) {
	        var that = this;
	        // data
	        var sentences = d.split(". ");
	        if (e) {
	            $scope.mTitle;
	        } else {
	            return $location.$$search.ioc;
	        }
	        that.data = sentences;
	        that.title = e;
	        ngDialog.open({
	            template: __webpack_require__(729),
	            plain: true,
	            appendTo: '.page-content',
	            scope: that
	        });
	    };
	
	    $scope.getChildIOC = function () {
	        var that = this;
	        that.data = $scope.child_ioc;
	        that.title = "Child ID Information";
	        ngDialog.open({
	            template: __webpack_require__(730),
	            plain: true,
	            appendTo: '.page-content',
	            scope: that
	        });
	    };
	
	    var descInstanceCtrl = function descInstanceCtrl($scope, $modalInstance, data, ioc) {
	        $scope.ok = function () {
	            $modalInstance.close();
	        };
	        $scope.data = data;
	        $scope.iocc = ioc;
	    };
	
	    $scope.showHide1 = false;
	    $scope.showHide2 = true;
	    $scope.toggleView = function (tog1, tog2) {
	        $scope.showHide1 = tog1;
	        $scope.showHide2 = tog2;
	    };
	};
	
	ctrl.$inject = ['$scope', '$location', 'Global', '$http', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService', 'ngDialog'];
	module.exports = ctrl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(677)))

/***/ },
/* 729 */
/***/ function(module, exports) {

	module.exports = "<div class=\"tableModal\">\n    <div class=\"modal-header\">\n        <h3>{{title}}</h3>\n    </div>\n    <div>\n        <p ng-repeat=\"i in data\">{{i}}</p>\n    </div>\n</div>";

/***/ },
/* 730 */
/***/ function(module, exports) {

	module.exports = "<div class=\"tableModal\">\n    <div class=\"modal-header\">\n        <h3>{{title}}</h3>\n    </div>\n    <div class=\"tab-inner\" id=\"descModalID\">\n        <table id=\"pageTwoInfoTable\">\n            <tr><th ng-repeat=\"title in data.columns\">{{title.name}}</th></tr>\n            <tr ng-repeat=\"row in data.rows\"><td ng-repeat=\"col in row\">{{col}}</td></tr>\n        </table>\n    </div>\n</div>";

/***/ },
/* 731 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.rowChartIdentifiers = { key: false, id: false };
	    model.geoChartIdentifiers = { key: false, id: false };
	    model.sevLevIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    socketIo('/api/ioc_notifications/inbound_ioc').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            },
	            grouping: ['hour', 'orig_country', 'ioc_severity', 'ioc_class'],
	            type: 'linechart',
	            settings: {
	                type: 'severity',
	                xAxis: '',
	                yAxis: '# IOC / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'ioc_severity': 'IOC Severity',
	                'ioc_class': 'IOC',
	                'orig_country': 'Origin Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = d.hour * 1000;return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe += v.ioc_count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe -= v.ioc_count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        severe: 0,
	                        high: 0,
	                        elevated: 0,
	                        guarded: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// ROWCHART ///
	        ////////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            run: function run(data) {
	                // optional run function to run after data has been fetched (takes an array of data)
	                for (var i = 0, len = data.length; i < len; i++) {
	                    data[i].dd = timeFormat(data[i].time, 'strdDateObj');
	                    data[i].hour = d3.time.hour(data[i].dd);
	                    data[i].count = +data[i].count;
	                }
	            },
	            get: {
	                call: 'rowchart',
	                socket: socket
	            },
	            grouping: ['ioc_severity', 'ioc_class'],
	            searchCategories: {
	                'ioc_class': 'IOC',
	                'ioc_severity': 'IOC Severity',
	                'orig_country': 'Origin Country'
	            },
	            type: 'rowchart', // required
	            settings: {
	                type: 'ioc_family'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.ioc_class + d.ioc_severity;
	                });
	            }, // required
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }).reduce(function (d, v) {
	                    if (v.ioc_severity > 0) {
	                        d.severity = v.ioc_severity;
	                        d.count += v.ioc_count;
	                    }
	                    return d;
	                },
	                // callback for when data is removed from the current filter results
	                function (d, v) {
	                    if (v.ioc_severity > 0) {
	                        d.severity = v.ioc_severity;
	                        d.count -= v.ioc_count;
	                    }
	                    return d;
	                },
	                /* initialize d */
	                function (d, v) {
	                    return {
	                        count: 0,
	                        severity: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.rowChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.rowChartIdentifiers.key].dimension = $scope.main.dataObjects[model.rowChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.rowChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.rowChartIdentifiers.key].group = $scope.main.dataObjects[model.rowChartIdentifiers.key].settings.group($scope.main.dataObjects[model.rowChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.rowChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.rowChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.rowChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.rowChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.rowChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.rowChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.rowChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            },
	            grouping: ['orig_country', 'ioc_severity', 'ioc_class'],
	            searchCategories: {
	                'orig_country': 'Origin Country',
	                'ioc_severity': 'IOC Severity',
	                'ioc_class': 'IOC'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.orig_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        ///////////////////////
	        /// SEVERITY LEVELS ///
	        ///////////////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'sevlevels',
	                socket: socket
	            },
	            grouping: ['ioc_severity', 'ioc_class', 'orig_country'],
	            searchCategories: {
	                'ioc_severity': 'IOC Severity',
	                'ioc_class': 'IOC',
	                'orig_country': 'Origin Country'
	            },
	            type: 'severityLevels', // required
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.ioc_class + d.ioc_severity;
	                });
	            }, // required
	            group: function group(dimension) {
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }).reduce(function (d, v) {
	                    d.severity = v.ioc_severity;
	                    d.count += v.ioc_count;
	                    return d;
	                },
	                // callback for when data is removed from the current filter results
	                function (d, v) {
	                    d.severity = v.ioc_severity;
	                    d.count -= v.ioc_count;
	                    return d;
	                },
	                /* initialize d */
	                function (d, v) {
	                    return {
	                        count: 0,
	                        severity: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.sevLevIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.sevLevIdentifiers.key].dimension = $scope.main.dataObjects[model.sevLevIdentifiers.key].settings.dimension($scope.main.dataObjects[model.sevLevIdentifiers.key].cf);
	            $scope.main.dataObjects[model.sevLevIdentifiers.key].group = $scope.main.dataObjects[model.sevLevIdentifiers.key].settings.group($scope.main.dataObjects[model.sevLevIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {}, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.sevLevIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.sevLevIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.sevLevIdentifiers);
	            } else {
	                $scope.$broadcast('updatedData', model.sevLevIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip', 'resp_hostname', 'orig_ip', 'ioc_class'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            title: 'Inbound Indicators of Compromise (IOC) Notifications',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ioc_events_drilldown',
	                    val: ['resp_ip', 'orig_ip', 'resp_hostname', 'ioc_class', 'ioc_child', 'vector'],
	                    crumb: false
	                }
	            }, { title: 'Responder Stealth', select: 'resp_stealth', dView: true }, { title: 'Blocked by Proxy', select: 'proxy_blocked', dView: true }, { title: 'Severity', select: 'ioc_severity', dView: true }, { title: 'IOC Count', select: 'ioc_count', dView: true }, { title: 'IOC', select: 'ioc_class', dView: true }, { title: 'IOC Type', select: 'ioc_type', dView: true },
	            // { title: 'IOC Stage', select: 'ioc_stage', dView: true },
	            { title: 'IOC Rule', select: 'ioc_rule', dView: true }, { title: 'Responder Hostname', select: 'resp_hostname', dView: true }, { title: 'Responder User', select: 'resp_user', dView: true }, { title: 'Responder IP', select: 'resp_ip', dView: true }, { title: 'Origin IP', select: 'orig_ip', dView: true }, { title: 'Origin Country', select: 'orig_country', dView: true }, { title: 'Flag', select: 'orig_cc', dView: true }, { title: 'Origin ASN', select: 'orig_asn_name', dView: true }, { title: 'Payload Ratio', select: 'breakdown', dView: true }, { title: 'Origin Payload', select: 'bytes_orig', dView: true }, { title: 'Responder Payload', select: 'bytes_resp', dView: true }],
	            searchCategories: {
	                'resp_stealth': 'Responder Stealth',
	                'proxy_blocked': 'Blocked by Proxy',
	                'ioc_severity': 'Severity',
	                'ioc_count': 'IOC Count',
	                'ioc_class': 'IOC',
	                'ioc_type': 'IOC Type',
	                // 'ioc_stage': 'IOC Stage',
	                'ioc_rule': 'IOC Rule',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_ip': 'Responder IP',
	                'orig_ip': 'Origin IP',
	                'orig_country': 'Origin Country',
	                'orig_cc': 'Flag',
	                'orig_asn_name': 'Origin ASN'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 732 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.rowChartIdentifiers = { key: false, id: false };
	    model.geoChartIdentifiers = { key: false, id: false };
	    model.sevLevIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    socketIo('/api/ioc_notifications/outbound_ioc').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	        // register data object
	
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            },
	            grouping: ['hour', 'resp_country', 'ioc_severity', 'ioc_class'],
	            type: 'linechart',
	            settings: {
	                type: 'severity',
	                xAxis: '',
	                yAxis: '# IOC / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'ioc_severity': 'IOC Severity',
	                'ioc_class': 'IOC',
	                'resp_country': 'Responder Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.hour !== 0) {
	                        d.hour = d.hour * 1000;
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe += v.ioc_count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe -= v.ioc_count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        severe: 0,
	                        high: 0,
	                        elevated: 0,
	                        guarded: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// ROWCHART ///
	        ////////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            run: function run(data) {
	                // optional run function to run after data has been fetched (takes an array of data)
	                for (var i = 0, len = data.length; i < len; i++) {
	                    data[i].dd = timeFormat(data[i].time, 'strdDateObj');
	                    data[i].hour = d3.time.hour(data[i].dd);
	                    data[i].count = +data[i].count;
	                }
	            },
	            get: {
	                call: 'rowchart',
	                socket: socket
	            },
	            grouping: ['ioc_severity', 'ioc_class'],
	            searchCategories: {
	                'ioc_class': 'IOC',
	                'ioc_severity': 'IOC Severity',
	                'resp_country': 'Responder Country'
	            },
	            type: 'rowchart', // required
	            settings: {
	                type: 'ioc_family'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.ioc_class + d.ioc_severity;
	                });
	            }, // required
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }).reduce(function (d, v) {
	                    if (v.ioc_severity > 0) {
	                        d.severity = v.ioc_severity;
	                        d.count += v.ioc_count;
	                    }
	                    return d;
	                },
	                // callback for when data is removed from the current filter results
	                function (d, v) {
	                    if (v.ioc_severity > 0) {
	                        d.severity = v.ioc_severity;
	                        d.count -= v.ioc_count;
	                    }
	                    return d;
	                },
	                /* initialize d */
	                function (d, v) {
	                    return {
	                        count: 0,
	                        severity: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.rowChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.rowChartIdentifiers.key].dimension = $scope.main.dataObjects[model.rowChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.rowChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.rowChartIdentifiers.key].group = $scope.main.dataObjects[model.rowChartIdentifiers.key].settings.group($scope.main.dataObjects[model.rowChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.rowChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.rowChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.rowChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.rowChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.rowChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.rowChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.rowChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            },
	            grouping: ['resp_country', 'ioc_severity', 'ioc_class'],
	            searchCategories: {
	                'resp_country': 'Responder Country',
	                'ioc_severity': 'IOC Severity',
	                'ioc_class': 'IOC'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.resp_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        ///////////////////////
	        /// SEVERITY LEVELS ///
	        ///////////////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'sevlevels',
	                socket: socket
	            },
	            grouping: ['ioc_severity', 'ioc_class', 'resp_country'],
	            searchCategories: {
	                'ioc_severity': 'IOC Severity',
	                'ioc_class': 'IOC',
	                'resp_country': 'Responder Country'
	            },
	            type: 'severityLevels', // required
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.ioc_class + d.ioc_severity;
	                });
	            }, // required
	            group: function group(dimension) {
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }).reduce(function (d, v) {
	                    d.severity = v.ioc_severity;
	                    d.count += v.ioc_count;
	                    return d;
	                },
	                // callback for when data is removed from the current filter results
	                function (d, v) {
	                    d.severity = v.ioc_severity;
	                    d.count -= v.ioc_count;
	                    return d;
	                },
	                // initialize d
	                function (d, v) {
	                    return { count: 0, severity: 0 };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.sevLevIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.sevLevIdentifiers.key].dimension = $scope.main.dataObjects[model.sevLevIdentifiers.key].settings.dimension($scope.main.dataObjects[model.sevLevIdentifiers.key].cf);
	            $scope.main.dataObjects[model.sevLevIdentifiers.key].group = $scope.main.dataObjects[model.sevLevIdentifiers.key].settings.group($scope.main.dataObjects[model.sevLevIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {}, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.sevLevIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.sevLevIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.sevLevIdentifiers);
	            } else {
	                $scope.$broadcast('updatedData', model.sevLevIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['orig_ip', 'orig_hostname', 'resp_ip', 'ioc_class'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            title: 'Outbound Indicators of Compromise (IOC) Notifications',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ioc_events_drilldown',
	                    val: ['orig_ip', 'resp_ip', 'orig_hostname', 'ioc_class', 'ioc_child', 'vector'],
	                    crumb: false
	                }
	            }, { title: 'Blocked by Proxy', select: 'proxy_blocked', dView: true }, { title: 'Severity', select: 'ioc_severity', dView: true }, { title: 'IOC Count', select: 'ioc_count', dView: true }, { title: 'IOC', select: 'ioc_class', dView: true }, { title: 'IOC Type', select: 'ioc_type', dView: true },
	            // { title: 'IOC Stage', select: 'ioc_stage', dView: true },
	            { title: 'IOC Rule', select: 'ioc_rule', dView: true }, { title: 'Origin Hostname', select: 'orig_hostname', dView: true }, { title: 'Origin User', select: 'orig_user', dView: true }, { title: 'Origin IP', select: 'orig_ip', dView: true }, { title: 'Responder IP', select: 'resp_ip', dView: true }, { title: 'Responder Country', select: 'resp_country', dView: true }, { title: 'Flag', select: 'resp_cc', dView: true }, { title: 'Responder ASN', select: 'resp_asn_name', dView: true }, { title: 'Payload Ratio', select: 'breakdown', dView: true }, { title: 'Origin Payload', select: 'bytes_orig', dView: true }, { title: 'Responder Payload', select: 'bytes_resp', dView: true }],
	            searchCategories: {
	                'proxy_blocked': 'Blocked by Proxy',
	                'ioc_severity': 'Severity',
	                'ioc_count': 'IOC Count',
	                'ioc_class': 'IOC',
	                'ioc_type': 'IOC Type',
	                // 'ioc_stage': 'IOC Stage',
	                'ioc_rule': 'IOC Rule',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'resp_ip': 'Responder IP',
	                'resp_country': 'Responder Country',
	                'resp_cc': 'Flag',
	                'resp_asn_name': 'Responder ASN'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            result.rows.forEach(function (row) {
	                row.ioc_severity = 3;
	            });
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 733 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.rowChartIdentifiers = { key: false, id: false };
	    model.geoChartIdentifiers = { key: false, id: false };
	    model.sevLevIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    socketIo('/api/ioc_notifications/lateral_ioc').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            },
	            grouping: ['hour', 'orig_country', 'ioc_severity', 'ioc_class'],
	            type: 'linechart',
	            settings: {
	                type: 'severity',
	                xAxis: '',
	                yAxis: '# IOC / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'ioc_severity': 'IOC Severity',
	                'ioc_class': 'IOC',
	                'orig_country': 'Origin Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = d.hour * 1000;return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe += v.ioc_count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe -= v.ioc_count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        severe: 0,
	                        high: 0,
	                        elevated: 0,
	                        guarded: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip', 'resp_hostname', 'orig_ip', 'ioc_class'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            title: 'Lateral Indicators of Compromise (IOC) Notifications',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ioc_events_drilldown',
	                    val: ['resp_ip', 'resp_hostname', 'orig_ip', 'orig_hostname', 'ioc_class', 'ioc_child', 'vector'],
	                    crumb: false
	                }
	            }, { title: 'Responder Stealth', select: 'resp_stealth', dView: true }, { title: 'Severity', select: 'ioc_severity', dView: true }, { title: 'IOC Count', select: 'ioc_count', dView: true }, { title: 'IOC', select: 'ioc_class', dView: true }, { title: 'IOC Type', select: 'ioc_type', dView: true }, { title: 'IOC Rule', select: 'ioc_rule', dView: true }, { title: 'Responder Hostname', select: 'resp_hostname', dView: true }, { title: 'Responder IP', select: 'resp_ip', dView: true }, { title: 'Responder User', select: 'resp_user', dView: true }, { title: 'Origin Hostname', select: 'orig_hostname', dView: true }, { title: 'Origin IP', select: 'orig_ip', dView: true }, { title: 'Origin User', select: 'orig_user', dView: true }, { title: 'Payload Ratio', select: 'breakdown', dView: true }, { title: 'Origin Payload', select: 'bytes_orig', dView: true }, { title: 'Responder Payload', select: 'bytes_resp', dView: true }],
	            searchCategories: {
	                'resp_stealth': 'Stealth',
	                'ioc_severity': 'Severity',
	                'ioc_count': 'IOC Count',
	                'ioc_class': 'IOC',
	                'ioc_type': 'IOC Type',
	                'ioc_rule': 'IOC Rule',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_ip': 'Responder IP',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_ip': 'Origin IP',
	                'orig_country': 'Origin Country'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, $http, fetchStream, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.tableIdentifiers = { key: false, id: false };
	
	    // Save active toggle
	    model.toggleActive = function (data) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/ioc_notifications/ioc_feeds/active',
	            data: {
	                feed: data.feed,
	                active: data.active
	            }
	        }).success(function () {});
	    };
	
	    socketIo('/api/ioc_notifications/ioc_feeds').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            // allSearchDimensionOverride: true,
	            refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'tablecount',
	                socket: socket
	            },
	            grouping: ['feed'],
	            sort: { direction: "-", col: "last_run" }, // "-"=desc, "+"=asc
	            title: "Custom IOCs",
	            hideToggleBytes: true,
	            columns: [{ title: 'Feed', select: 'feed', dView: true }, { title: 'IOC Count', select: 'ioc_count', dView: true }, { title: 'Class', select: 'class', dView: true }, { title: 'Last Run', select: 'last_run', dView: true }, {
	                title: 'Active',
	                select: 'active',
	                dView: true,
	                link: {
	                    url: '/api/ioc_notifications/ioc_feeds/toggleActive'
	                }
	            }],
	            searchCategories: {
	                'feed': 'Feed',
	                'class': 'Class',
	                'ioc_count': 'IOC Count'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.feed;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.feed = v.feed;
	                    if (v.hasOwnProperty("ioc_count")) {
	                        p.ioc_count += Number(v.ioc_count);
	                    }
	                    if (v.hasOwnProperty("last_run")) {
	                        p.last_run = v.last_run;
	                    }
	                    if (v.hasOwnProperty("active")) {
	                        p.active = v.active;
	                    }
	                    if (v.hasOwnProperty("class")) {
	                        p.class = v.class;
	                    }
	                    p.visible = true;
	                    return p;
	                }, function (p, v) {
	                    p.feed = v.feed;
	                    if (v.hasOwnProperty("ioc_count")) {
	                        p.ioc_count -= Number(v.ioc_count);
	                    }
	                    if (v.hasOwnProperty("last_run")) {
	                        p.last_run = v.last_run;
	                    }
	                    if (v.hasOwnProperty("active")) {
	                        p.active = v.active;
	                    }
	                    if (v.hasOwnProperty("class")) {
	                        p.class = v.class;
	                    }
	                    p.visible = true;
	                    return p;
	                }, function () {
	                    return {
	                        feed: "",
	                        ioc_count: 0,
	                        last_run: "",
	                        active: 1
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // set dimension & group
	            $scope.main.dataObjects[model.tableIdentifiers.key].dimension = $scope.main.dataObjects[model.tableIdentifiers.key].settings.dimension($scope.main.dataObjects[model.tableIdentifiers.key].cf);
	            $scope.main.dataObjects[model.tableIdentifiers.key].group = $scope.main.dataObjects[model.tableIdentifiers.key].settings.group($scope.main.dataObjects[model.tableIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                $scope.main.dataObjects[model.tableIdentifiers.key].launched = true;
	                // dont start the spinner if the table loads faster than building group dim
	                if (!model.complete) {
	                    // start table spinner right before init, but after build
	                    usSpinnerService.spin(model.tableIdentifiers.id);
	                }
	                // initalize rows
	                $scope.$broadcast('init', model.tableIdentifiers);
	
	                new fetchStream("table", $scope.main.dataObjects[model.tableIdentifiers.key].settings.get.socket).then(function (result) {}, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	                });
	
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$http', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, $location, $http, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.geoChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/archive').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour', 'remote_country'],
	            type: 'linechart',
	            settings: {
	                type: 'severity',
	                xAxis: '',
	                yAxis: '# IOC / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	                'remote_country': 'Remote Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded += v.count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated += v.count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high += v.count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe += v.count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded -= v.count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated -= v.count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high -= v.count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe -= v.count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        guarded: 0,
	                        elevated: 0,
	                        high: 0,
	                        severe: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        ////////////////
	        /// GEOCHART ///
	        ////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'geomap',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['remote_country'],
	            searchCategories: {
	                'remote_country': 'Remote Country'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    return d.remote_country;
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduceSum(function (d) {
	                    return d.count;
	                }); //Might have to Math.ceil or round
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.geoChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.geoChartIdentifiers.key].dimension = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.geoChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].group = $scope.main.dataObjects[model.geoChartIdentifiers.key].settings.group($scope.main.dataObjects[model.geoChartIdentifiers.key].dimension);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            // stop spinner on complete or no data
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.geoChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.geoChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.geoChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.geoChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.geoChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['local_ip', 'local_hostname', 'remote_ip', 'ioc_class'],
	            sort: {
	                direction: "-",
	                col: "time"
	            }, // "-"=desc, "+"=asc
	            title: 'Archived Indicators of Compromise (IOC) Notifications',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ioc_drill',
	                    val: ['local_ip', 'local_hostname', 'remote_ip', 'ioc_class'],
	                    crumb: false
	                }
	            }, {
	                title: 'Severity',
	                select: 'ioc_severity',
	                dView: true
	            }, {
	                title: 'IOC Events',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'IOC',
	                select: 'ioc_class',
	                dView: true
	            }, {
	                title: 'IOC Type',
	                select: 'ioc_type',
	                dView: true
	            }, {
	                title: 'IOC Stage',
	                select: 'ioc_stage',
	                dView: true
	            }, {
	                title: 'IOC Rule',
	                select: 'ioc_rule',
	                dView: true
	            }, {
	                title: 'Local IP',
	                select: 'local_ip',
	                dView: true
	            }, {
	                title: 'Local Hostname',
	                select: 'local_hostname',
	                dView: true
	            }, {
	                title: 'Remote IP',
	                select: 'remote_ip',
	                dView: true
	            }, {
	                title: 'Remote ASN',
	                select: 'remote_asn_name',
	                dView: true
	            }, {
	                title: 'Remote Country',
	                select: 'remote_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'remote_cc',
	                dView: true
	            }, {
	                title: 'Packets to Remote',
	                select: 'in_packets',
	                dView: true
	            }, {
	                title: 'Packets from Remote',
	                select: 'out_packets',
	                dView: true
	            }, {
	                title: 'Bandwidth to Remote',
	                select: 'bytes_in',
	                dView: false
	            }, {
	                title: 'Bandwidth from Remote',
	                select: 'bytes_out',
	                dView: false
	            }],
	            searchCategories: {
	                'ioc_severity': 'Severity',
	                'ioc_count': 'IOC Events',
	                'ioc_class': 'IOC',
	                'ioc_type': 'IOC Type',
	                'ioc_stage': 'IOC Stage',
	                'ioc_rule': 'IOC Rule',
	                'local_hostname': 'Local Hostname',
	                'local_user': 'Local User',
	                'local_ip': 'Local IP',
	                'remote_ip': 'Remote IP',
	                'remote_country': 'Remote Country',
	                'remote_cc': 'Flag',
	                'remote_asn_name': 'Remote ASN',
	                'bytes_in': 'Bandwidth to Remote',
	                'bytes_out': 'Bandwidth from Remote',
	                'in_packets': 'Packets to Remote',
	                'out_packets': 'Packets from Remote'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	
	    $scope.rootpage = true;
	    $scope.archiveBtn = true;
	    $scope.emptyarchive = function () {
	        var r = confirm("Are you sure?");
	        if (r === true) {
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/actions/clear'
	            }).success(function (data, status, headers, config) {
	                // $route.reload();
	                $location.path('/');
	            }).error(function (data, status, headers, config) {
	                alert('There was an error clearing Archive. Please try again in a couple minutes.');
	            });
	        }
	    };
	    $scope.rootpage = true;
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$location', '$http', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService, $http) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.tableIdentifiers = { key: false, id: false };
	
	    model.formFields = {
	        zone: "N/A",
	        ioc_type: '',
	        radio: ''
	    };
	
	    if ($stateParams.include) {
	        model.formFields.ioc_rule = $stateParams.include[0].value;
	    }
	
	    model.radio = 0;
	
	    // inital setup of form variable
	    model.setForm = function (form) {
	        model.formFields = model.formFields;
	    };
	
	    model.handleInsert = function (data) {
	        var time = angular.copy($scope.main.getTime());
	        data.email = $scope.global.user.email;
	        data.time = Math.round(new Date().getTime() / 1000);
	        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
	            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
	        }
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/ioc_notifications/whitelist/insert',
	            data: {
	                id: data.id,
	                email: data.email,
	                ioc_rule: data.ioc_rule,
	                ioc_type: data.ioc_type,
	                time: data.time,
	                zone: data.zone
	            }
	        }).success(function (result) {
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                $scope.main.buildDimGroup(result, model.tableIdentifiers).then(function () {
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                });
	            }
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
	                return d.id == result[0].id;
	            });
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result);
	            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	        });
	        model.formFields = {
	            zone: "N/A",
	            ioc_type: '',
	            radio: ''
	        };
	        delete model.editMode;
	        model.customIOCForm.$setPristine();
	        model.setForm();
	    };
	
	    // DELETE ROW FROM TABLE
	    model.deleteTarget = function (data) {
	        if (typeof $scope.main.dataObjects[model.tableIdentifiers.key].settings.render !== "undefined") {
	            $scope.main.dataObjects[model.tableIdentifiers.key].settings.render.has = false;
	        }
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/ioc_notifications/whitelist/delete',
	            data: {
	                id: data.id
	            }
	        }).success(function () {
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filter(function (d) {
	                return d.id == data.id;
	            });
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove();
	            $scope.main.dataObjects[model.tableIdentifiers.key].searchDimension.filterAll();
	            $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	        });
	    };
	
	    model.editTarget = function (call, data) {
	        model.formFields = data;
	        model.editMode = {
	            call: call,
	            id: data.id,
	            value: true
	        };
	        model.isSelected();
	    };
	
	    model.isSelected = function (val) {
	        if (val) {
	            model.formFields.radio = val;
	            if (model.formFields.ioc_rule) {
	                model.formFields.ioc_rule = model.formFields.ioc_rule.replace(/([*])/g, "");
	                if (val === "before") {
	                    model.formFields.ioc_rule = "*" + model.formFields.ioc_rule;
	                } else if (val === "after") {
	                    model.formFields.ioc_rule = model.formFields.ioc_rule + "*";
	                } else {
	                    model.formFields.ioc_rule = "*" + model.formFields.ioc_rule + "*";
	                }
	            } else {
	                model.formFields.radio = "";
	            }
	        } else {
	            if (model.formFields.ioc_rule) {
	                if (model.formFields.ioc_rule.indexOf("*") > -1) {
	                    if (model.formFields.ioc_rule) {
	                        if (model.formFields.ioc_rule.startsWith('*') && model.formFields.ioc_rule.length > 1 && model.formFields.ioc_rule.endsWith('*')) {
	                            model.formFields.radio = "contains";
	                        } else if (model.formFields.ioc_rule.startsWith('*')) {
	                            model.formFields.radio = "before";
	                        } else if (model.formFields.ioc_rule.endsWith('*')) {
	                            model.formFields.radio = "after";
	                        }
	                    }
	                    model.formFields.ioc_rule = model.formFields.ioc_rule.replace(/([*])/g, "");
	                    if (model.formFields.radio === "before") {
	                        model.formFields.ioc_rule = "*" + model.formFields.ioc_rule;
	                    } else if (model.formFields.radio === "after") {
	                        model.formFields.ioc_rule = model.formFields.ioc_rule + "*";
	                    } else if (model.formFields.radio === "contains") {
	                        model.formFields.ioc_rule = "*" + model.formFields.ioc_rule + "*";
	                    }
	                } else {
	                    model.formFields.radio = "";
	                }
	            }
	        }
	    };
	
	    socketIo('/api/ioc_notifications/whitelist').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['id'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            hideToggleBytes: true,
	            title: 'Indicators of Compromise (IOC) Notifications',
	            columns: [{ title: 'Created', select: 'time', dView: true }, { title: 'Created By', select: 'email', dView: true }, { title: 'IOC Type', select: 'ioc_type', dView: true }, { title: 'IOC Rule', select: 'ioc_rule', dView: true }, {
	                title: 'Delete',
	                select: "Delete",
	                dView: true,
	                link: {
	                    type: 'Delete',
	                    call: 'delete'
	                }
	            }, {
	                title: 'Edit',
	                select: 'Edit',
	                dView: true,
	                link: {
	                    type: 'Edit',
	                    call: 'insert'
	                }
	            }],
	            searchCategories: {
	                'email': 'Email',
	                'ioc_type': 'IOC Type',
	                'ioc_rule': 'IOC Rule'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService', '$http'];
	module.exports = ctrl;

/***/ },
/* 737 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/ioc_notifications/ad_events').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['local_ip', 'remote_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            hideToggleBytes: true,
	            title: 'Active Defense Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'ad_events_drill',
	                    val: ['local_ip', 'remote_ip'],
	                    crumb: false
	                }
	            },
	            // { title: '# of Connections', select: 'count', dView: true },
	            {
	                title: 'Local IP',
	                select: 'local_ip',
	                dView: true
	            }, {
	                title: 'Remote IP',
	                select: 'remote_ip',
	                dView: true
	            }],
	            searchCategories: {
	                // 'count': '# of Connections',
	                'local_ip': 'Local IP',
	                'remote_ip': 'Remote IP'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 738 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/ioc_notifications/ad_events_drill').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['id'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Active Defense Events Full',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Local IP',
	                select: 'local_ip',
	                dView: true
	            }, {
	                title: 'Local Zone',
	                select: 'local_zone',
	                dView: true
	            }, {
	                title: 'Local Stealth',
	                select: 'local_stealth',
	                dView: true
	            }, {
	                title: 'Local Machine',
	                select: 'local_hostname',
	                dView: true
	            }, {
	                title: 'Local User',
	                select: 'local_user',
	                dView: true
	            }, {
	                title: 'Local Port',
	                select: 'local_port',
	                dView: true
	            }, {
	                title: 'Remote IP',
	                select: 'remote_ip',
	                dView: true
	            }, {
	                title: 'Remote Stealth',
	                select: 'remote_stealth',
	                dView: true
	            }, {
	                title: 'Remote Machine',
	                select: 'remote_machine',
	                dView: true
	            }, {
	                title: 'Remote User',
	                select: 'remote_user',
	                dView: true
	            }, {
	                title: 'Remote Port',
	                select: 'remote_port',
	                dView: true
	            }, {
	                title: 'Type',
	                select: 'ad_type',
	                dView: true
	            }, {
	                title: 'Rule',
	                select: 'ad_rule',
	                dView: true
	            }, {
	                title: 'Details',
	                select: 'ad_detail',
	                dView: true
	            }, {
	                title: 'ID',
	                select: 'ad_id',
	                dView: true
	            }, {
	                title: 'Level',
	                select: 'ad_level',
	                dView: true
	            }],
	            searchCategories: {
	                'local_stealth': 'Local Stealth',
	                'local_hostname': 'Local Hostname',
	                'local_user': 'Local User',
	                'local_ip': 'Local IP',
	                'local_zone': 'Local Zone',
	                'local_port': 'Local Port',
	                'remote_stealth': 'Remote Stealth',
	                'remote_machine': 'Remote Hostname',
	                'remote_user': 'Remote User',
	                'remote_ip': 'Remote IP',
	                'remote_zone': 'Remote Zone',
	                'remote_port': 'Remote Port',
	                'ad_type': 'Type',
	                'ad_rule': 'Rule',
	                'ad_detail': 'Details',
	                'ad_id': 'ID',
	                'ad_level': 'Level'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 739 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, $sce) {
	    var model = this;
	    $scope.global = Global;
	
	    model.url = $sce.trustAsResourceUrl('https://cyr3con.mantix4.com/vulnerability-info');
	}
	
	ctrl.$inject = ['$scope', 'Global', '$sce'];
	module.exports = ctrl;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('searchController', __webpack_require__(741));
	};

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(crossfilter) {'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function ctrl($scope, Global, $http, timeFormat, fetchStream, $window, $location, socketIo, generateId, settings, usSpinnerService, $state, $stateParams) {
	    var _searchCategories;
	
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.sidebarIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    // LIST OF UNIQUE COLUMNS IN DISPLAYED TABLES:
	
	    // fetch counts for various types.
	    // fetch records for default types.
	    // disable searchbar in header
	    // duplicate table stuffing (include exclude)
	    // based on what is clicked and active
	    // fire counting function
	
	    // set current time into the url if it exists in the stateParams
	    if ($stateParams.time) {
	        $location.search($stateParams.time); // add the time back to the url
	    }
	
	    // local access to identifiers
	
	    // page sidebar
	    (function setSidebarItems() {
	        model.sidebarItems = [//{
	        //title: 'Bacnet',
	        //select: 'bacnet',
	        //count: 0,
	        //doneLoading: false,
	        //}, {
	        {
	            title: 'Connections',
	            select: 'conn',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'DHCP',
	            select: 'dhcp',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'DPD',
	            select: 'dpd',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'DNS',
	            select: 'dns',
	            count: 0,
	            doneLoading: false
	        }, // {
	        //  title: 'DNP3',
	        //  select: 'dnp3',
	        //  count: 0,
	        //  doneLoading: false,
	        //}, {
	        //  title: 'Enip',
	        //  select: 'enip',
	        //  count: 0,
	        //  doneLoading: false,
	        //}, {
	        {
	            title: 'Events',
	            select: 'events',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Files',
	            select: 'files',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'FTP',
	            select: 'ftp',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'HTTP',
	            select: 'http',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Intel',
	            select: 'intel',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'IRC',
	            select: 'irc',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Kerberos',
	            select: 'kerberos',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Known Services',
	            select: 'known_services',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Known Certs',
	            select: 'known_certs',
	            count: 0,
	            doneLoading: false
	        }, //{
	        // title: 'Modbus',
	        // select: 'modbus',
	        // count: 0,
	        // doneLoading: false,
	        //}, {
	        {
	            title: 'MySQL',
	            select: 'mysql',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Notice',
	            select: 'notice',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'NTLM',
	            select: 'ntlm',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Portable Executable',
	            select: 'pe',
	            count: 0,
	            doneLoading: false
	        }, // {
	        //  title: 'Profinet',
	        //  select: 'profinet',
	        //  count: 0,
	        //  doneLoading: false,
	        //}, {
	        {
	            title: 'RDP',
	            select: 'rdp',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'SMTP',
	            select: 'smtp',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'SSH',
	            select: 'ssh',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'SSL',
	            select: 'ssl',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'SIP',
	            select: 'sip',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'SNMP',
	            select: 'snmp',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Syslog',
	            select: 'syslog',
	            count: 0,
	            doneLoading: false
	        }, //{
	        // title: 'S7Comm',
	        // select: 's7comm',
	        // count: 0,
	        // doneLoading: false,
	        //}, {
	        {
	            title: 'Traceroute',
	            select: 'traceroute',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Tunnel',
	            select: 'tunnel',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'Weird',
	            select: 'weird',
	            count: 0,
	            doneLoading: false
	        }, {
	            title: 'x509',
	            select: 'x509',
	            count: 0,
	            doneLoading: false
	        }];
	    })();
	
	    // set inital mode and run inital query
	    var tableSettings = {
	        ntlm: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'ID',
	                select: 'uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'User name',
	                select: 'username',
	                dView: true
	            }, {
	                title: 'Host name',
	                select: 'hostname',
	                dView: true
	            }, {
	                title: 'Domain name',
	                select: 'domainname',
	                dView: true
	            }, {
	                title: 'NetBios name',
	                select: 'server_nb_computer_name',
	                dView: true
	            }, {
	                title: 'DNS name',
	                select: 'server_dns_computer_name',
	                dView: true
	            }, {
	                title: 'Tree name',
	                select: 'server_tree_name',
	                dView: true
	            }, {
	                title: 'Success',
	                select: 'success',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port'
	            },
	            title: 'NTLM',
	            sort: {
	                direction: '-',
	                col: 'time'
	            },
	            grouping: ['uid']
	        },
	        bacnet: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'uid',
	                dView: true
	            }, {
	                title: 'BVLC Function',
	                select: 'bvlc_function',
	                dView: true
	            }, {
	                title: 'BVLC Length',
	                select: 'bvlc_len',
	                dView: true
	            }, {
	                title: 'APDU Type',
	                select: 'apdu_type',
	                dView: true
	            }, {
	                title: 'Service Choice',
	                select: 'service_choice',
	                dView: true
	            }, {
	                title: 'Data',
	                select: 'data',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'id_orig_h',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'id_orig_p',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'id_resp_h',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'id_resp_p',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }],
	            searchCategories: {
	                'bvlc_function': 'BVLC Function',
	                'bvlc_len': 'BVLC Length',
	                'apdu_type': 'APDU Type',
	                'id_orig_h': 'Orig IP',
	                'time': 'Time',
	                'orig_hostname': 'Orig Hostname',
	                'id_orig_p': 'Orig Port',
	                'orig_user': 'Orig User',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'id_resp_h': 'Resp IP',
	                'id_resp_p': 'Resp Port'
	            },
	            title: 'Bacnet',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        conn: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Duration',
	                select: 'duration',
	                dView: false
	            },
	            // { title: 'Connection State', select: 'conn_state', dView: true },
	            {
	                title: 'Vector',
	                select: 'vector',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Stealth',
	                select: 'orig_stealth',
	                dView: false
	            }, {
	                title: 'Orig Country',
	                select: 'orig_country',
	                dView: true
	            }, {
	                title: 'Orig CC',
	                select: 'orig_cc',
	                dView: false
	            }, {
	                title: 'Orig City',
	                select: 'orig_city',
	                dView: false
	            }, {
	                title: 'Orig ASN Name',
	                select: 'orig_asn_name',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Resp User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Resp Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp CC',
	                select: 'resp_cc',
	                dView: false
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: false
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }, {
	                title: 'Origin Packets',
	                select: 'packets_orig',
	                dView: true
	            }, {
	                title: 'Responder Packets',
	                select: 'packets_resp',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Service',
	                select: 'service',
	                dView: true
	            }, {
	                title: 'Layer 7 App',
	                select: 'l7_app',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'IOC Class',
	                select: 'ioc_class',
	                dView: true
	            }, {
	                title: 'IOC Rule',
	                select: 'ioc_rule',
	                dView: true
	            }, {
	                title: 'IOC Type',
	                select: 'ioc_type',
	                dView: true
	            }, {
	                title: 'IOC Stage',
	                select: 'ioc_stage',
	                dView: false
	            }, {
	                title: 'IOC Severity',
	                select: 'ioc_severity',
	                dView: true
	            }, {
	                title: 'IOC Confidence',
	                select: 'ioc_confidence',
	                dView: true
	            }, {
	                title: 'IOC ID',
	                select: 'ioc_id',
	                dView: true
	            }, {
	                title: 'Proxy Rule',
	                select: 'proxy_rule',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'conn_uid': 'Connection UID',
	                // 'conn_state': 'Connection State',
	                'orig_ip': 'Orig IP',
	                'orig_port': 'Orig Port',
	                'orig_hostname': 'Orig Hostname',
	                'orig_user': 'Orig User',
	                'orig_asn_name': 'Orig ASN Name',
	                'orig_cc': 'Orig Flag',
	                'orig_city': 'Orig City',
	                'orig_country': 'Orig Country',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'resp_hostname': 'Resp Hostname',
	                'resp_user': 'Resp User',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'proto': 'Protocol',
	                'service': 'Service',
	                'l7_app': 'Layer 7 App',
	                'ioc_class': 'IOC Class',
	                // 'ioc_count' : "IOC Count",
	                'ioc_id': 'IOC ID',
	                'ioc_severity': 'IOC Severity',
	                'ioc_rule': 'IOC Rules',
	                'ioc_stage': 'IOC Stage',
	                'ioc_type': 'IOC Type',
	                'proxy_rule': 'Proxy Rule',
	                'sensor': 'Sensor'
	            },
	            title: 'Connections',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        dhcp: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig Mac',
	                select: 'orig_mac',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Assigned IP',
	                select: 'assigned_ip',
	                dView: true
	            }, {
	                title: 'Trans ID',
	                select: 'trans_id',
	                dView: true
	            }, {
	                title: 'Lease Time',
	                select: 'lease_time',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'assigned_ip': 'Assigned IP',
	                'conn_uid': 'Connection UID',
	                'orig_mac': 'Orig MAC',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor'
	            },
	            title: 'DHCP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        dns: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Answers',
	                select: 'answers',
	                dView: true
	            }, {
	                title: 'AA',
	                select: 'aa',
	                dView: true
	            }, {
	                title: 'Query Class',
	                select: 'qclass',
	                dView: true
	            }, {
	                title: 'Query Class Name',
	                select: 'qclass_name',
	                dView: true
	            }, {
	                title: 'Query Type',
	                select: 'qtype',
	                dView: true
	            }, {
	                title: 'Query Type Name',
	                select: 'qtype_name',
	                dView: true
	            }, {
	                title: 'Query',
	                select: 'query',
	                dView: true
	            }, {
	                title: 'RA',
	                select: 'ra',
	                dView: true
	            }, {
	                title: 'Return Code',
	                select: 'rcode',
	                dView: true
	            }, {
	                title: 'Return Code Name',
	                select: 'rcode_name',
	                dView: true
	            }, {
	                title: 'RD',
	                select: 'rd',
	                dView: true
	            }, {
	                title: 'Rejected',
	                select: 'rejected',
	                dView: true
	            }, {
	                title: 'TC',
	                select: 'tc',
	                dView: true
	            }, {
	                title: 'Trans ID',
	                select: 'trans_id',
	                dView: true
	            }, {
	                title: 'TTLs',
	                select: 'ttls',
	                dView: true
	            }, {
	                title: 'Z',
	                select: 'z',
	                dView: true
	            }, {
	                title: 'IOC Severity',
	                select: 'ioc_severity',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'IOC Class',
	                select: 'ioc_class',
	                dView: true
	            }, {
	                title: 'IOC Confidence',
	                select: 'ioc_confidence',
	                dView: true
	            }, {
	                title: 'IOC ID',
	                select: 'ioc_id',
	                dView: true
	            }, {
	                title: 'IOC Rule',
	                select: 'ioc_rule',
	                dView: true
	            }, {
	                title: 'IOC Stage',
	                select: 'ioc_stage',
	                dView: true
	            }, {
	                title: 'IOC Type',
	                select: 'ioc_type',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'aa': 'AA',
	                'answers': 'Answers',
	                'conn_uid': 'Connection UID',
	                'ioc_class': 'IOC Class',
	                // 'ioc_count' : "IOC Count",
	                'ioc_id': 'IOC ID',
	                'ioc_severity': 'IOC Severity',
	                'ioc_rule': 'IOC Rules',
	                'ioc_stage': 'IOC Stage',
	                'ioc_type': 'IOC Type',
	                'orig_hostname': 'Orig Hostname',
	                'orig_port': 'Orig Port',
	                'orig_user': 'Orig User',
	                'proto': 'Protocol',
	                'qclass': 'Query Class',
	                'qclass_name': 'Query Class Name',
	                'qtype': 'Query Type',
	                'qtype_name': 'Query Type Name',
	                'query': 'Query',
	                'ra': 'RA',
	                'rcode': 'Return Code',
	                'rcode_name': 'Return Code Name',
	                'rd': 'RD',
	                'rejected': 'Rejected',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'tc': 'TC',
	                'trans_id': 'Trans ID',
	                'ttls': 'TTLs',
	                'z': 'Z'
	            },
	            title: 'DNS',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        dpd: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Analyzer',
	                select: 'analyzer',
	                dView: true
	            }, {
	                title: 'Failure Reason',
	                select: 'failure_reason',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'analyzer': 'Analyzer',
	                'conn_uid': 'Connection UID',
	                'failure_reason': 'Failure Reason',
	                'orig_port': 'Orig Port',
	                'proto': 'Protocol',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor'
	            },
	            title: 'DPD',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        dnp3: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'id_orig_h',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'id_orig_p',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'id_resp_h',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'id_resp_p',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Fc Request',
	                select: 'fc_request',
	                dView: true
	            }, {
	                title: 'Fc Reply',
	                select: 'fc_reply',
	                dView: true
	            }, {
	                title: 'Iin',
	                select: 'iin',
	                dView: true
	            }],
	            searchCategories: {
	                'fc_request': 'Fc Request',
	                'fc_reply': 'Fc Reply',
	                'inn': 'Inn',
	                'id_orig_h': 'Orig IP',
	                'time': 'Time',
	                'orig_hostname': 'Orig Hostname',
	                'id_orig_p': 'Orig Port',
	                'orig_user': 'Orig User',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'id_resp_h': 'Resp IP',
	                'id_resp_p': 'Resp Port'
	            },
	            title: 'DNP3',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        enip: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'uid',
	                dView: true
	            }, {
	                title: 'Command',
	                select: 'command',
	                dView: true
	            }, {
	                title: 'Length',
	                select: 'length',
	                dView: true
	            }, {
	                title: 'Session Handle',
	                select: 'session_handle',
	                dView: true
	            }, {
	                title: 'Sender Context',
	                select: 'sender_context',
	                dView: true
	            }, {
	                title: 'Status',
	                select: 'status',
	                dView: true
	            }, {
	                title: 'Options',
	                select: 'options',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'id_orig_h',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'id_orig_p',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'id_resp_h',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'id_resp_p',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }],
	            searchCategories: {
	                'command': 'Command',
	                'session_handle': 'Session Handle',
	                'status': 'Status',
	                'sender_context': 'Sender Context',
	                'id_orig_h': 'Orig IP',
	                'time': 'Time',
	                'orig_hostname': 'Orig Hostname',
	                'id_orig_p': 'Orig Port',
	                'orig_user': 'Orig User',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'id_resp_h': 'Resp IP',
	                'id_resp_p': 'Resp Port'
	            },
	            title: 'enip',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        events: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Event Full',
	                select: 'event_full',
	                dView: true
	            }, {
	                title: 'Event ID',
	                select: 'event_id',
	                dView: true
	            }, {
	                title: 'Event Level',
	                select: 'event_level',
	                dView: true
	            }, {
	                title: 'Event Source',
	                select: 'event_src',
	                dView: true
	            }, {
	                title: 'Event Type',
	                select: 'event_type',
	                dView: true
	            }, {
	                title: 'Event User',
	                select: 'event_user',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'event_full': 'Event Full',
	                'event_id': 'Event ID',
	                'event_src': 'Event Source',
	                'event_type': 'Event Type',
	                'event_user': 'Event User',
	                'orig_hostname': 'Orig Hostname',
	                'orig_user': 'Orig User',
	                'sensor': 'Sensor'
	            },
	            title: 'Events',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        files: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Source',
	                select: 'source',
	                dView: true
	            }, {
	                title: 'Connection UIDs',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'File UID',
	                select: 'file_uid',
	                dView: true
	            }, {
	                title: 'TX IP',
	                select: 'tx_hosts',
	                dView: true
	            }, {
	                title: 'RX IP',
	                select: 'rx_hosts',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'MIME',
	                select: 'mime',
	                dView: true
	            }, {
	                title: 'Size',
	                select: 'size',
	                dView: true
	            }, {
	                title: 'MD5',
	                select: 'md5',
	                dView: true
	            }, {
	                title: 'Extracted File',
	                select: 'extracted_file',
	                dView: true
	            }, {
	                title: 'Name',
	                select: 'name',
	                dView: true
	            }, {
	                title: 'SHA1',
	                select: 'sha1',
	                dView: true
	            }, {
	                title: 'SHA256',
	                select: 'sha256',
	                dView: true
	            }, {
	                title: 'HTTP Host',
	                select: 'http_host',
	                dView: true
	            }, {
	                title: 'HTTP Referrer',
	                select: 'http_referrer',
	                dView: true
	            }, {
	                title: 'HTTP URI',
	                select: 'http_uri',
	                dView: true
	            }, {
	                title: 'HTTP User Agent',
	                select: 'http_user_agent',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'IOC Class',
	                select: 'ioc_class',
	                dView: true
	            }, {
	                title: 'IOC Confidence',
	                select: 'ioc_confidence',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'IOC ID',
	                select: 'ioc_id',
	                dView: true
	            }, {
	                title: 'IOC Rule',
	                select: 'ioc_rule',
	                dView: true
	            }, {
	                title: 'IOC Severity',
	                select: 'ioc_severity',
	                dView: true
	            }, {
	                title: 'IOC Stage',
	                select: 'ioc_stage',
	                dView: true
	            }, {
	                title: 'IOC Type',
	                select: 'ioc_type',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Duration',
	                select: 'duration',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'source': 'Source',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'conn_uid': 'Connection UID',
	                'extracted_file': 'Extracted File',
	                'file_uid': 'File UIDs',
	                'http_host': 'HTTP Host',
	                'http_referrer': 'HTTP Referrer',
	                'http_uri': 'HTTP URI',
	                'http_user_agent': 'HTTP User Agent',
	                'ioc_class': 'IOC Class',
	                // 'ioc_count' : "IOC Count",
	                'ioc_id': 'IOC ID',
	                'ioc_severity': 'IOC Severity',
	                'ioc_rule': 'IOC Rules',
	                'ioc_stage': 'IOC Stage',
	                'ioc_type': 'IOC Type',
	                'orig_hostname': 'Orig Hostname',
	                'orig_user': 'Orig User',
	                'md5': 'MD5',
	                'mime': 'MIME',
	                'name': 'Name',
	                'proto': 'Protocol',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'resp_ip': 'Resp IP',
	                'sensor': 'sensor',
	                'sha1': 'SHA1',
	                'sha256': 'SHA256',
	                'tx_hosts': 'TX IP',
	                'rx_hosts': 'RX IP'
	            },
	            title: 'File',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        ftp: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Argument',
	                select: 'arg',
	                dView: true
	            }, {
	                title: 'MIME Type',
	                select: 'mime_type',
	                dView: true
	            }, {
	                title: 'Password',
	                select: 'password',
	                dView: true
	            }, {
	                title: 'Command',
	                select: 'command',
	                dView: true
	            }, {
	                title: 'DC Orig IP',
	                select: 'dc_orig_h',
	                dView: true
	            }, {
	                title: 'DC Passive',
	                select: 'dc_passive',
	                dView: true
	            }, {
	                title: 'DC Resp IP',
	                select: 'dc_resp_h',
	                dView: true
	            }, {
	                title: 'DC Resp Port',
	                select: 'dc_resp_p',
	                dView: true
	            }, {
	                title: 'File Size',
	                select: 'file_size',
	                dView: true
	            }, {
	                title: 'FTP LAN User',
	                select: 'user',
	                dView: true
	            }, {
	                title: 'File UID',
	                select: 'fuid',
	                dView: true
	            }, {
	                title: 'Reply Code',
	                select: 'reply_code',
	                dView: true
	            }, {
	                title: 'Reply Message',
	                select: 'reply_msg',
	                dView: true
	            }, {
	                title: 'sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'arg': 'Argument',
	                'command': 'Command',
	                'conn_uid': 'Connection UID',
	                'dc_orig_h': 'DC Orig IP',
	                'dc_passive': 'DC Passive',
	                'dc_resp_h': 'DC Resp IP',
	                'dc_resp_p': 'DC Resp Port',
	                'user': 'FTP LAN User',
	                'fuid': 'File UID',
	                'orig_hostname': 'Orig Hostname',
	                'orig_port': 'Orig Port',
	                'orig_user': 'Orig User',
	                'mime_type': 'MIME Type',
	                'password': 'Password',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'resp_ip': 'Resp IP',
	                'reply_code': 'Reply Code',
	                'reply_msg': 'Reply Message',
	                'sensor': 'Sensor'
	            },
	            title: 'FTP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        http: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Depth',
	                select: 'depth',
	                dView: true
	            }, {
	                title: 'File Name',
	                select: 'filename',
	                dView: true
	            }, {
	                title: 'Domain',
	                select: 'top_domain',
	                dView: true
	            }, {
	                title: 'Subdomain',
	                select: 'host',
	                dView: true
	            }, {
	                title: 'Tags',
	                select: 'tags',
	                dView: true
	            }, {
	                title: 'URI',
	                select: 'uri',
	                dView: true
	            }, {
	                title: 'URL',
	                select: 'url',
	                dView: true
	            }, {
	                title: 'Request Body Length',
	                select: 'request_body_len',
	                dView: true
	            }, {
	                title: 'Response Body Length',
	                select: 'response_body_len',
	                dView: true
	            }, {
	                title: 'Method',
	                select: 'method',
	                dView: true
	            }, {
	                title: 'Proxied',
	                select: 'proxied',
	                dView: false
	            }, {
	                title: 'Proxy Rule',
	                select: 'proxy_rule',
	                dView: false
	            }, {
	                title: 'Referrer',
	                select: 'referrer',
	                dView: true
	            }, {
	                title: 'Status Code',
	                select: 'status_code',
	                dView: true
	            }, {
	                title: 'Status Message',
	                select: 'status_msg',
	                dView: true
	            }, {
	                title: 'User Agent',
	                select: 'user_agent',
	                dView: true
	            }, {
	                title: 'Info Code',
	                select: 'info_code',
	                dView: true
	            }, {
	                title: 'Info Message',
	                select: 'info_msg',
	                dView: true
	            }, {
	                title: 'IOC Class',
	                select: 'ioc_class',
	                dView: true
	            }, {
	                title: 'IOC Confidence',
	                select: 'ioc_confidence',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'IOC ID',
	                select: 'ioc_id',
	                dView: true
	            }, {
	                title: 'IOC Rule',
	                select: 'ioc_rule',
	                dView: true
	            }, {
	                title: 'IOC Severity',
	                select: 'ioc_severity',
	                dView: true
	            }, {
	                title: 'IOC Stage',
	                select: 'ioc_stage',
	                dView: true
	            }, {
	                title: 'IOC Type',
	                select: 'ioc_type',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'conn_uid': 'Connection UID',
	                'depth': 'Depth',
	                'filename': 'File Name',
	                'top_domain': 'Domain',
	                'host': 'Subdomain',
	                'info_code': 'Info Code',
	                'info_msg': 'Info Message',
	                'ioc_class': 'IOC Class',
	                // 'ioc_count' : "IOC Count",
	                'ioc_id': 'IOC ID',
	                'ioc_severity': 'IOC Severity',
	                'ioc_rule': 'IOC Rules',
	                'ioc_stage': 'IOC Stage',
	                'ioc_type': 'IOC Type',
	                'orig_hostname': 'Orig Hostname',
	                'orig_port': 'Orig Port',
	                'orig_user': 'Orig User',
	                'method': 'Method',
	                'referrer': 'Referrer',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'status_code': 'Status Code',
	                'status_msg': 'Status Message',
	                'tags': 'Tags',
	                'uri': 'URI',
	                'url': 'URL',
	                'user_agent': 'User Agent'
	            },
	            title: 'HTTP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        intel: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Cyrin Class',
	                select: 'cyrin_class',
	                dView: true
	            }, {
	                title: 'Cyrin Confidence',
	                select: 'cyrin_confidence',
	                dView: true
	            }, {
	                title: 'Cyrin ID',
	                select: 'cyrin_id',
	                dView: true
	            }, {
	                title: 'Cyrin Severity',
	                select: 'cyrin_severity',
	                dView: true
	            }, {
	                title: 'File Description',
	                select: 'file_desc',
	                dView: true
	            }, {
	                title: 'File MIME Type',
	                select: 'file_mime_type',
	                dView: true
	            }, {
	                title: 'File UID',
	                select: 'fuid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Local',
	                select: 'orig_local',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Local',
	                select: 'resp_local',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Seen Indicator',
	                select: 'seen_indicator',
	                dView: true
	            }, {
	                title: 'Seen Indicator Type',
	                select: 'seen_indicator_type',
	                dView: true
	            }, {
	                title: 'Seen Node',
	                select: 'seen_node',
	                dView: true
	            }, {
	                title: 'Seen Where',
	                select: 'seen_where',
	                dView: true
	            }, {
	                title: 'Sources',
	                select: 'sources',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'time': 'Time',
	                'conn_uid': 'Connection UID',
	                'cyrin_class': 'Cyrin Class',
	                'cyrin_confidence': 'Cyrin Confidence',
	                'cyrin_id': 'Cyrin ID',
	                'cyrin_severity': 'Cyrin Severity',
	                'file_desc': 'File Description',
	                'file_mime_type': 'File MIME Type',
	                'fuid': 'File UID',
	                'orig_ip': 'Orig IP',
	                'orig_local': 'Orig Local',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_local': 'Resp Local',
	                'resp_port': 'Resp Port',
	                'seen_indicator': 'Seen Indicator',
	                'seen_indicator_type': 'Seen Indicator Type',
	                'seen_node': 'Seen Node',
	                'seen_where': 'Seen Where',
	                'sensor': 'Sensor',
	                'sources': 'Sources'
	            },
	            title: 'Intel',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        irc: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'User',
	                select: 'user',
	                dView: true
	            }, {
	                title: 'Nick',
	                select: 'nick',
	                dView: true
	            }, {
	                title: 'Command',
	                select: 'command',
	                dView: true
	            }, {
	                title: 'Value',
	                select: 'value',
	                dView: true
	            }, {
	                title: 'DCC File Name',
	                select: 'dcc_file_name',
	                dView: true
	            }, {
	                title: 'DCC File Size',
	                select: 'dcc_file_size',
	                dView: true
	            }, {
	                title: 'DCC MIME Type',
	                select: 'dcc_mime_type',
	                dView: true
	            }, {
	                title: 'File UID',
	                select: 'fuid',
	                dView: true
	            }, {
	                title: 'Additional Data',
	                select: 'addl',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'addl': 'Additional Data',
	                'command': 'Command',
	                'conn_uid': 'Connection UID',
	                'dcc_file_name': 'DCC File Name',
	                'dcc_file_size': 'DCC File Size',
	                'dcc_mime_type': 'DCC MIME Type',
	                'fuid': 'File UID',
	                'orig_hostname': 'Orig Hostname',
	                'orig_port': 'Orig Port',
	                'orig_user': 'Orig User',
	                'nick': 'Nick',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'user': 'User',
	                'value': 'Value'
	            },
	            title: 'IRC',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        kerberos: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Request Type',
	                select: 'request_type',
	                dView: true
	            }, {
	                title: 'Client',
	                select: 'client',
	                dView: true
	            }, {
	                title: 'Service',
	                select: 'service',
	                dView: true
	            }, {
	                title: 'Success',
	                select: 'success',
	                dView: true
	            }, {
	                title: 'Error Msg',
	                select: 'error_msg',
	                dView: true
	            }, {
	                title: 'From',
	                select: 'from',
	                dView: true
	            }, {
	                title: 'Till',
	                select: 'till',
	                dView: true
	            }, {
	                title: 'Cipher',
	                select: 'cipher',
	                dView: true
	            }, {
	                title: 'Forwardable',
	                select: 'forwardable',
	                dView: true
	            }, {
	                title: 'Renewable',
	                select: 'renewable',
	                dView: true
	            }, {
	                title: 'Client Cert FUID',
	                select: 'client_cert_fuid',
	                dView: true
	            }, {
	                title: 'Client Cert Subject',
	                select: 'client_cert_subject',
	                dView: true
	            }, {
	                title: 'Server Cert FUID',
	                select: 'server_cert_fuid',
	                dView: true
	            }, {
	                title: 'Server Cert Subject',
	                select: 'server_cert_subject',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'time': 'Time',
	                'conn_uid': 'Connection UID',
	                'orig_ip': 'Orig IP',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'request_type': 'Request Type',
	                'client': 'Client',
	                'service': 'Service',
	                'success': 'Success',
	                'error_msg': 'Error Msg',
	                'from': 'From',
	                'till': 'Till',
	                'cipher': 'Cipher',
	                'forwardable': 'Forwardable',
	                'renewable': 'Renewable',
	                'client_cert_fuid': 'Client Cert FUID',
	                'client_cert_subject': 'Client Cert Subject',
	                'server_cert_fuid': 'Server Cert FUID',
	                'server_cert_subject': 'Server Cert Subject',
	                'sensor': 'Sensor'
	            },
	            title: 'Kerberos',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        known_services: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Service',
	                select: 'service',
	                dView: true
	            }, {
	                title: 'Host',
	                select: 'host',
	                dView: true
	            }, {
	                title: 'Port Number',
	                select: 'port_num',
	                dView: true
	            }, {
	                title: 'Port Protocol',
	                select: 'port_proto',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'host': 'Host',
	                'port_num': 'Port Number',
	                'port_proto': 'Port Protocol',
	                'sensor': 'Sensor',
	                'service': 'Service'
	            },
	            title: 'Known Services',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        known_certs: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Host',
	                select: 'host',
	                dView: true
	            }, {
	                title: 'Issuer Subject',
	                select: 'issuer_subject',
	                dView: true
	            }, {
	                title: 'Port Number',
	                select: 'port_num',
	                dView: true
	            }, {
	                title: 'Serial',
	                select: 'serial',
	                dView: true
	            }, {
	                title: 'Subject',
	                select: 'subject',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'host': 'Host',
	                'issuer_subject': 'Issuer Subject',
	                'port_num': 'Port Number',
	                'serial': 'Serial',
	                'subject': 'Subject',
	                'sensor': 'Sensor'
	            },
	            title: 'Known Certs',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        mysql: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Argument',
	                select: 'arg',
	                dView: true
	            }, {
	                title: 'Command',
	                select: 'cmd',
	                dView: true
	            }, {
	                title: 'Response',
	                select: 'response',
	                dView: true
	            }, {
	                title: 'Rows',
	                select: 'rows',
	                dView: true
	            }, {
	                title: 'Success',
	                select: 'success',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'arg': 'Argument',
	                'cmd': 'Command',
	                'conn_uid': 'Connection UID',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'response': 'Response',
	                'rows': 'Rows',
	                'sensor': 'Sensor',
	                'success': 'Success'
	            },
	            title: 'MySQL',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        modbus: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'uid',
	                dView: true
	            }, {
	                title: 'Func',
	                select: 'func',
	                dView: true
	            }, {
	                title: 'Exception',
	                select: 'exception',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'id_orig_h',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'id_orig_p',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'id_resp_h',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'id_resp_p',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }],
	            searchCategories: {
	                'func': 'Func',
	                'exception': 'Exception',
	                'id_orig_h': 'Orig IP',
	                'time': 'Time',
	                'orig_hostname': 'Orig Hostname',
	                'id_orig_p': 'Orig Port',
	                'orig_user': 'Orig User',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'id_resp_h': 'Resp IP',
	                'id_resp_p': 'Resp Port'
	            },
	            title: 'Modbus',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        notice: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Actions',
	                select: 'actions',
	                dView: true
	            }, {
	                title: 'Dropped',
	                select: 'dropped',
	                dView: true
	            }, {
	                title: 'Destination',
	                select: 'dst',
	                dView: true
	            }, {
	                title: 'File Description',
	                select: 'file_desc',
	                dView: true
	            }, {
	                title: 'File MIME Type',
	                select: 'file_mime_type',
	                dView: true
	            }, {
	                title: 'File UID',
	                select: 'fuid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Message',
	                select: 'msg',
	                dView: true
	            }, {
	                title: 'N',
	                select: 'n',
	                dView: true
	            }, {
	                title: 'Note',
	                select: 'note',
	                dView: true
	            }, {
	                title: 'P',
	                select: 'p',
	                dView: true
	            }, {
	                title: 'Peer Description',
	                select: 'peer_descr',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Resp Location City',
	                select: 'resp_location_city',
	                dView: true
	            }, {
	                title: 'Resp Location Country Code',
	                select: 'resp_location_country_code',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Source',
	                select: 'src',
	                dView: true
	            }, {
	                title: 'Sub',
	                select: 'sub',
	                dView: true
	            }, {
	                title: 'Suppress For',
	                select: 'suppress_for',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'actions': 'Actions',
	                'conn_uid': 'Connection UID',
	                'dropped': 'Dropped',
	                'file_desc': 'File Description',
	                'file_mime_type': 'File MIME Type',
	                'fuid': 'File UID',
	                'orig_ip': 'ID Orig IP',
	                'orig_port': 'ID Orig Port',
	                'resp_ip': 'ID Resp IP',
	                'resp_port': 'ID Resp Port',
	                'msg': 'Message',
	                'n': 'N',
	                'note': 'Note',
	                'p': 'P',
	                'peer_descr': 'Peer Description',
	                'proto': 'Protocol',
	                'resp_location_city': 'Resp Location City',
	                'resp_location_country_code': 'Resp Location Country Code',
	                'sensor': 'Sensor',
	                'src': 'Source',
	                'sub': 'Sub',
	                'suppress_for': 'Suppress For'
	            },
	            title: 'Notice',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        pe: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Compile Time',
	                select: 'compile_ts',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Cert Table',
	                select: 'has_cert_table',
	                dView: true
	            }, {
	                title: 'Debug Data',
	                select: 'has_debug_data',
	                dView: true
	            }, {
	                title: 'Export Table',
	                select: 'has_export_table',
	                dView: true
	            }, {
	                title: 'Import Table',
	                select: 'has_import_table',
	                dView: true
	            }, {
	                title: 'Is 64-bit',
	                select: 'is_64bit',
	                dView: true
	            }, {
	                title: 'Is exe',
	                select: 'is_exe',
	                dView: true
	            }, {
	                title: 'Machine',
	                select: 'machine',
	                dView: true
	            }, {
	                title: 'OS',
	                select: 'os',
	                dView: true
	            }, {
	                title: 'Section Names',
	                select: 'section_names',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Sub System',
	                select: 'subsystem',
	                dView: true
	            }, {
	                title: 'ASLR',
	                select: 'uses_aslr',
	                dView: true
	            }, {
	                title: 'Code Integrity',
	                select: 'uses_code_integrity',
	                dView: true
	            }, {
	                title: 'Dep',
	                select: 'uses_dep',
	                dView: true
	            }, {
	                title: 'Seh',
	                select: 'uses_seh',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'compile_ts': 'Compile Time',
	                'conn_uid': 'Connection UID',
	                'has_cert_table': 'Cert Table',
	                'has_debug_data': 'Debug Data',
	                'has_export_table': 'Export Table',
	                'has_import_table': 'Import Table',
	                'is_64bit': 'Is 64-bit',
	                'is_exe': 'Is exe',
	                'machine': 'Machine',
	                'os': 'OS',
	                'section_names': 'Section Names',
	                'sensor': 'Sensor',
	                'subsystem': 'Sub System',
	                'uses_aslr': 'ASLR',
	                'uses_code_integrity': 'Code Integrity',
	                'uses_dep': 'Dep',
	                'uses_seh': 'Seh'
	            },
	            title: 'RDP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        profinet: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'uid',
	                dView: true
	            }, {
	                title: 'Operation Type',
	                select: 'operation_type',
	                dView: true
	            }, {
	                title: 'Block Version',
	                select: 'block_version',
	                dView: true
	            }, {
	                title: 'Slot Number',
	                select: 'slot_number',
	                dView: true
	            }, {
	                title: 'Subslot Number',
	                select: 'subslot_number',
	                dView: true
	            }, {
	                title: 'Index',
	                select: 'index',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'id_orig_h',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'id_orig_p',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'id_resp_h',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'id_resp_p',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }],
	            searchCategories: {
	                'operation_type': 'Operation Type',
	                'block_version': 'Block Version',
	                'index': 'Index',
	                'id_orig_h': 'Orig IP',
	                'time': 'Time',
	                'orig_hostname': 'Orig Hostname',
	                'id_orig_p': 'Orig Port',
	                'orig_user': 'Orig User',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'id_resp_h': 'Resp IP',
	                'id_resp_p': 'Resp Port'
	            },
	            title: 'Profinet',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        rdp: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Cert Count',
	                select: 'cert_count',
	                dView: true
	            }, {
	                title: 'Cert Permanent',
	                select: 'cert_permanent',
	                dView: true
	            }, {
	                title: 'Cert Type',
	                select: 'cert_type',
	                dView: true
	            }, {
	                title: 'Client Build',
	                select: 'client_build',
	                dView: true
	            }, {
	                title: 'Client Dig Product ID',
	                select: 'client_dig_product_id',
	                dView: true
	            }, {
	                title: 'Client Name',
	                select: 'client_name',
	                dView: true
	            }, {
	                title: 'Cookie',
	                select: 'cookie',
	                dView: true
	            }, {
	                title: 'Desktop Height',
	                select: 'desktop_height',
	                dView: true
	            }, {
	                title: 'Desktop Width',
	                select: 'desktop_width',
	                dView: true
	            }, {
	                title: 'Encryption Level',
	                select: 'encryption_level',
	                dView: true
	            }, {
	                title: 'Encryption Method',
	                select: 'encryption_method',
	                dView: true
	            }, {
	                title: 'Keyboard Layout',
	                select: 'keyboard_layout',
	                dView: true
	            }, {
	                title: 'Requesed Color Depth',
	                select: 'requested_color_depth',
	                dView: true
	            }, {
	                title: 'Result',
	                select: 'result',
	                dView: true
	            }, {
	                title: 'Security Protocol',
	                select: 'security_protocol',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'cert_count': 'Cert Count',
	                'cert_permanent': 'Cert Permanent',
	                'cert_type': 'Cert Type',
	                'client_build': 'Client Build',
	                'client_dig_product_id': 'Client Dig Product ID',
	                'client_name': 'Client Name',
	                'conn_uid': 'Connection UID',
	                'cookie': 'Cookie',
	                'desktop_height': 'Desktop Height',
	                'desktop_width': 'Desktop Width',
	                'encryption_level': 'Encryption Level',
	                'encryption_method': 'Encryption Method',
	                'keyboard_layout': 'Keyboard Layout',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'requested_color_depth': 'Requesed Color Depth',
	                'result': 'Result',
	                'security_protocol': 'Security Protocol',
	                'sensor': 'Sensor'
	            },
	            title: 'RDP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        sip: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Call ID',
	                select: 'call_id',
	                dView: true
	            }, {
	                title: 'Content Type',
	                select: 'content_type',
	                dView: true
	            }, {
	                title: 'Date',
	                select: 'date',
	                dView: true
	            }, {
	                title: 'Method',
	                select: 'method',
	                dView: true
	            }, {
	                title: 'Sequence',
	                select: 'seq',
	                dView: true
	            }, {
	                title: 'Status Code',
	                select: 'status_code',
	                dView: true
	            }, {
	                title: 'Status Message',
	                select: 'status_msg',
	                dView: true
	            }, {
	                title: 'Subject',
	                select: 'subject',
	                dView: true
	            }, {
	                title: 'Trans Depth',
	                select: 'trans_depth',
	                dView: true
	            }, {
	                title: 'URI',
	                select: 'uri',
	                dView: true
	            }, {
	                title: 'Warning',
	                select: 'warning',
	                dView: true
	            }, {
	                title: 'Reply To',
	                select: 'reply_to',
	                dView: true
	            }, {
	                title: 'Request Body Length',
	                select: 'request_body_len',
	                dView: true
	            }, {
	                title: 'Request From',
	                select: 'request_from',
	                dView: true
	            }, {
	                title: 'Request Path',
	                select: 'request_path',
	                dView: true
	            }, {
	                title: 'Request To',
	                select: 'request_to',
	                dView: true
	            }, {
	                title: 'Response Body Length',
	                select: 'response_body_len',
	                dView: true
	            }, {
	                title: 'Response From',
	                select: 'response_from',
	                dView: true
	            }, {
	                title: 'Response Path',
	                select: 'response_path',
	                dView: true
	            }, {
	                title: 'Response To',
	                select: 'response_to',
	                dView: true
	            }, {
	                title: 'User Agent',
	                select: 'user_agent',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'time': 'Time',
	                'call_id': 'Call ID',
	                'content_type': 'Content Type',
	                'date': 'Date',
	                'method': 'Method',
	                'seq': 'Sequence',
	                'status_code': 'Status Code',
	                'status_msg': 'Status Message',
	                'subject': 'Subject',
	                'trans_depth': 'Trans Depth',
	                'uri': 'URI',
	                'warning': 'Warning',
	                'orig_ip': 'Orig IP',
	                'orig_port': 'Orig Port',
	                'reply_to': 'Reply To',
	                'request_body_len': 'Request Body Length',
	                'request_from': 'Request From',
	                'request_path': 'Request Path',
	                'request_to': 'Request To',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'response_body_len': 'Response Body Length',
	                'response_from': 'Response From',
	                'response_path': 'Response Path',
	                'response_to': 'Response To',
	                'user_agent': 'User Agent',
	                'sensor': 'Sensor',
	                'conn_uid': 'Connection UID'
	
	            },
	            title: 'SIP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        snmp: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Community',
	                select: 'community',
	                dView: true
	            }, {
	                title: 'Display String',
	                select: 'display_string',
	                dView: true
	            }, {
	                title: 'Duration',
	                select: 'duration',
	                dView: true
	            }, {
	                title: 'Get Bulk Requests',
	                select: 'get_bulk_requests',
	                dView: true
	            }, {
	                title: 'Get Requests',
	                select: 'get_requests',
	                dView: true
	            }, {
	                title: 'Get Responses',
	                select: 'get_responses',
	                dView: true
	            }, {
	                title: 'Set Requests',
	                select: 'set_requests',
	                dView: true
	            }, {
	                title: 'Up Since',
	                select: 'up_since',
	                dView: true
	            }, {
	                title: 'Version',
	                select: 'version',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'community': 'Community',
	                'conn_uid': 'Connection UID',
	                'display_string': 'Display String',
	                'duration': 'Duration',
	                'get_bulk_requests': 'Get Bulk Requests',
	                'get_requests': 'Get Requests',
	                'get_responses': 'Get Responses',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'set_requests': 'Set Requests',
	                'up_since': 'Up Since',
	                'version': 'Version'
	            },
	            title: 'SNMP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        smtp: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'SMTP From',
	                select: 'smtp_from',
	                dView: true
	            }, {
	                title: 'SMTP To',
	                select: 'smtp_to',
	                dView: true
	            }, {
	                title: 'Subject',
	                select: 'subject',
	                dView: true
	            }, {
	                title: 'TLS',
	                select: 'tls',
	                dView: true
	            }, {
	                title: 'Trans Depth',
	                select: 'trans_depth',
	                dView: true
	            }, {
	                title: 'User Agent',
	                select: 'user_agent',
	                dView: true
	            }, {
	                title: 'Date',
	                select: 'date',
	                dView: true
	            }, {
	                title: 'First Received',
	                select: 'first_rcvd',
	                dView: true
	            }, {
	                title: 'File UIDs',
	                select: 'fuids',
	                dView: true
	            }, {
	                title: 'Helo Header',
	                select: 'helo',
	                dView: true
	            }, {
	                title: 'In Reply To',
	                select: 'in_reply_to',
	                dView: true
	            }, {
	                title: 'Info Code',
	                select: 'info_code',
	                dView: true
	            }, {
	                title: 'Info Message',
	                select: 'info_msg',
	                dView: true
	            }, {
	                title: 'Is Webmail',
	                select: 'is_webmail',
	                dView: true
	            }, {
	                title: 'Second Received',
	                select: 'second_rcvd',
	                dView: true
	            }, {
	                title: 'Reply To',
	                select: 'reply_to',
	                dView: true
	            }, {
	                title: 'Mail From',
	                select: 'mailfrom',
	                dView: true
	            }, {
	                title: 'Message ID',
	                select: 'msg_id',
	                dView: true
	            }, {
	                title: 'Originating IP Header',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Path',
	                select: 'path',
	                dView: true
	            }, {
	                title: 'Receipt To',
	                select: 'receiptto',
	                dView: true
	            }, {
	                title: 'Last Reply',
	                select: 'last_reply',
	                dView: true
	            }, {
	                title: 'IOC Class',
	                select: 'ioc_class',
	                dView: true
	            }, {
	                title: 'IOC Confidence',
	                select: 'ioc_confidence',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'IOC ID',
	                select: 'ioc_id',
	                dView: true
	            }, {
	                title: 'IOC Rule',
	                select: 'ioc_rule',
	                dView: true
	            }, {
	                title: 'IOC Severity',
	                select: 'ioc_severity',
	                dView: true
	            }, {
	                title: 'IOC Stage',
	                select: 'ioc_stage',
	                dView: true
	            }, {
	                title: 'IOC Type',
	                select: 'ioc_type',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: (_searchCategories = {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'conn_uid': 'Connection UID',
	                'date': 'Date',
	                'first_rcvd': 'First Received',
	                'fuids': 'File UIDs',
	                'helo': 'Helo Header',
	                'in_reply_to': 'In Reply To',
	                'ioc_class': 'IOC Class',
	                // 'ioc_count' : "IOC Count",
	                'ioc_id': 'IOC ID',
	                'ioc_severity': 'IOC Severity',
	                'ioc_rule': 'IOC Rules',
	                'ioc_stage': 'IOC Stage',
	                'ioc_type': 'IOC Type',
	                'is_webmail': 'Is Webmail',
	                'last_reply': 'Last Reply',
	                'orig_hostname': 'Orig Hostname',
	                'orig_port': 'Orig Port',
	                'orig_user': 'Orig User',
	                'mailfrom': 'Mail From',
	                'msg_id': 'Message ID'
	            }, _defineProperty(_searchCategories, 'orig_ip', 'Originating IP Header'), _defineProperty(_searchCategories, 'path', 'Path'), _defineProperty(_searchCategories, 'receiptto', 'Receipt To'), _defineProperty(_searchCategories, 'resp_asn_name', 'Resp ASN Name'), _defineProperty(_searchCategories, 'resp_cc', 'Resp Flag'), _defineProperty(_searchCategories, 'resp_city', 'Resp City'), _defineProperty(_searchCategories, 'resp_country', 'Resp Country'), _defineProperty(_searchCategories, 'resp_hostname', 'Resp Hostname'), _defineProperty(_searchCategories, 'resp_ip', 'Resp IP'), _defineProperty(_searchCategories, 'resp_port', 'Resp Port'), _defineProperty(_searchCategories, 'reply_to', 'Reply To'), _defineProperty(_searchCategories, 'second_rcvd', 'Second Received'), _defineProperty(_searchCategories, 'sensor', 'Sensor'), _defineProperty(_searchCategories, 'smtp_from', 'SMTP From'), _defineProperty(_searchCategories, 'smtp_to', 'SMTP To'), _defineProperty(_searchCategories, 'subject', 'Subject'), _defineProperty(_searchCategories, 'tls', 'TLS'), _defineProperty(_searchCategories, 'trans_depth', 'Trans Depth'), _defineProperty(_searchCategories, 'user_agent', 'User Agent'), _searchCategories),
	            title: 'SMTP',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        ssh: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Authentication Success',
	                select: 'auth_success',
	                dView: true
	            }, {
	                title: 'Cipher Algorithm',
	                select: 'cipher_alg',
	                dView: true
	            }, {
	                title: 'Client',
	                select: 'client',
	                dView: true
	            }, {
	                title: 'Compression Algorithm',
	                select: 'compression_alg',
	                dView: true
	            }, {
	                title: 'Direction',
	                select: 'direction',
	                dView: true
	            }, {
	                title: 'Host Key',
	                select: 'host_key',
	                dView: true
	            }, {
	                title: 'Host Key Algorithm',
	                select: 'host_key_alg',
	                dView: true
	            }, {
	                title: 'MAC Algorithm',
	                select: 'mac_alg',
	                dView: true
	            }, {
	                title: 'Server',
	                select: 'server',
	                dView: true
	            }, {
	                title: 'Status',
	                select: 'status',
	                dView: true
	            }, {
	                title: 'Version',
	                select: 'version',
	                dView: true
	            }, {
	                title: 'Key Exchange Algorithm',
	                select: 'kex_alg',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'auth_success': 'Authentication Success',
	                'cipher_alg': 'Cipher Algorithm',
	                'client': 'Client',
	                'compression_alg': 'Compression Algorithm',
	                'conn_uid': 'Connection UID',
	                'direction': 'Direction',
	                'host_key': 'Host Key',
	                'host_key_alg': 'Host Key Algorithm',
	                'kex_alg': 'Key Exchange Algorithm',
	                'orig_hostname': 'Orig Hostname',
	                'orig_port': 'Orig Port',
	                'orig_user': 'Orig User',
	                'mac_alg': 'MAC Algorithm',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'server': 'Server',
	                'status': 'Status',
	                'version': 'Version'
	            },
	            title: 'SSH',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        ssl: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'JA3',
	                select: 'ja3',
	                dView: true
	            }, {
	                title: 'JA3s',
	                select: 'ja3s',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Top Level Server Name',
	                select: 'top_server',
	                dView: true
	            }, {
	                title: 'Server Name',
	                select: 'server_name',
	                dView: true
	            }, {
	                title: 'Subject',
	                select: 'subject',
	                dView: true
	            }, {
	                title: 'Cipher',
	                select: 'cipher',
	                dView: true
	            }, {
	                title: 'Issuer',
	                select: 'issuer',
	                dView: true
	            }, {
	                title: 'Client Issuer',
	                select: 'client_issuer',
	                dView: true
	            }, {
	                title: 'Client Subject',
	                select: 'client_subject',
	                dView: true
	            }, {
	                title: 'Curve',
	                select: 'curve',
	                dView: true
	            }, {
	                title: 'Resumed',
	                select: 'resumed',
	                dView: true
	            }, {
	                title: 'Next Protocol',
	                select: 'next_protocol',
	                dView: true
	            }, {
	                title: 'Established',
	                select: 'established',
	                dView: true
	            }, {
	                title: 'Cert Chain File UIDs',
	                select: 'cert_chain_fuids',
	                dView: true
	            }, {
	                title: 'Client Cert Chain File UIDs',
	                select: 'client_cert_chain_fuids',
	                dView: true
	            }, {
	                title: 'Validation Status',
	                select: 'validation_status',
	                dView: true
	            }, {
	                title: 'Notary First Seen',
	                select: 'notary_first_seen',
	                dView: true
	            }, {
	                title: 'Notary Last Seen',
	                select: 'notary_last_seen',
	                dView: true
	            }, {
	                title: 'Notary Times Seen',
	                select: 'notary_times_seen',
	                dView: true
	            }, {
	                title: 'Notary Valid',
	                select: 'notary_valid',
	                dView: true
	            }, {
	                title: 'Version',
	                select: 'version',
	                dView: true
	            }, {
	                title: 'Proxy Rule',
	                select: 'proxy_rule',
	                dView: true
	            }, {
	                title: 'Last Alert',
	                select: 'last_alert',
	                dView: true
	            }, {
	                title: 'IOC Class',
	                select: 'ioc_class',
	                dView: true
	            }, {
	                title: 'IOC Confidence',
	                select: 'ioc_confidence',
	                dView: true
	            }, {
	                title: 'IOC Count',
	                select: 'ioc_count',
	                dView: true
	            }, {
	                title: 'IOC ID',
	                select: 'ioc_id',
	                dView: true
	            }, {
	                title: 'IOC Rule',
	                select: 'ioc_rule',
	                dView: true
	            }, {
	                title: 'IOC Severity',
	                select: 'ioc_severity',
	                dView: true
	            }, {
	                title: 'IOC Stage',
	                select: 'ioc_stage',
	                dView: true
	            }, {
	                title: 'IOC Type',
	                select: 'ioc_type',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'cipher': 'Cipher',
	                'client_subject': 'Client Subject',
	                'conn_uid': 'Connection UID',
	                'ioc_class': 'IOC Class',
	                // 'ioc_count' : "IOC Count",
	                'ioc_id': 'IOC ID',
	                'ioc_severity': 'IOC Severity',
	                'ioc_rule': 'IOC Rules',
	                'ioc_stage': 'IOC Stage',
	                'ioc_type': 'IOC Type',
	                'last_alert': 'Last Alert',
	                'orig_hostname': 'Orig Hostname',
	                'orig_port': 'Orig Port',
	                'orig_user': 'Orig User',
	                'proxy_rule': 'Proxy Rule',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'top_server': 'Top Level Server Name',
	                'server_name': 'Server Name',
	                'session_id': 'Session ID',
	                'subject': 'Subject',
	                'version': 'Version',
	                'curve': 'Curve',
	                'issuer': 'Issuer',
	                'resumed': 'Resumed',
	                'next_protocol': 'Next Protocol',
	                'established': 'Established',
	                'cert_chain_fuids': 'Cert Chain File UIDs',
	                'client_cert_chain_fuids': 'Client Cert Chain File UIDs',
	                'client_issuer': 'Client Issuer',
	                'validation_status': 'Validation Status',
	                'notary_first_seen': 'Notary First Seen',
	                'notary_last_seen': 'Notary Last Seen',
	                'notary_times_seen': 'Notary Times Seen',
	                'notary_valid': 'Notary Valid',
	                'ja3': 'JA3',
	                'ja3s': 'JA3s'
	            },
	            title: 'SSL',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        syslog: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Severity',
	                select: 'severity',
	                dView: true
	            }, {
	                title: 'Facility',
	                select: 'facility',
	                dView: true
	            }, {
	                title: 'Message',
	                select: 'message',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'conn_uid': 'Connection UID',
	                'facility': 'Facility',
	                'orig_port': 'Orig Port',
	                'message': 'Message',
	                'proto': 'Resp Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'severity': 'Severity'
	            },
	            title: 'Syslog',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        s7comm: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'uid',
	                dView: true
	            }, {
	                title: 'Rosctr',
	                select: 'rosctr',
	                dView: true
	            }, {
	                title: 'Parameter',
	                select: 'parameter',
	                dView: true
	            }, {
	                title: 'Item Count',
	                select: 'item_count',
	                dView: true
	            }, {
	                title: 'Data Info',
	                select: 'data_info',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'id_orig_h',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'id_orig_p',
	                dView: true
	            }, {
	                title: 'Orig User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Orig Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'id_resp_h',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'id_resp_p',
	                dView: true
	            }, {
	                title: 'Resp ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Resp Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Resp City',
	                select: 'resp_city',
	                dView: true
	            }, {
	                title: 'Resp Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Resp Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }],
	            searchCategories: {
	                'rosctr': 'Rosctr',
	                'parameter': 'Parameter',
	                'data_info': 'Data Info',
	                'id_orig_h': 'Orig IP',
	                'time': 'Time',
	                'orig_hostname': 'Orig Hostname',
	                'id_orig_p': 'Orig Port',
	                'orig_user': 'Orig User',
	                'resp_asn_name': 'Resp ASN Name',
	                'resp_cc': 'Resp Flag',
	                'resp_city': 'Resp City',
	                'resp_country': 'Resp Country',
	                'resp_hostname': 'Resp Hostname',
	                'id_resp_h': 'Resp IP',
	                'id_resp_p': 'Resp Port'
	            },
	            title: 'S7comm',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        traceroute: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'proto': 'Resp Port',
	                'resp_ip': 'Resp IP',
	                'sensor': 'Sensor'
	            },
	            title: 'Traceroute',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        tunnel: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Action',
	                select: 'action',
	                dView: true
	            }, {
	                title: 'Tunnel Type',
	                select: 'tunnel_type',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'action': 'Action',
	                'conn_uid': 'Connection UID',
	                'orig_port': 'Orig Port',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor',
	                'tunnel_type': 'Tunnel Type'
	            },
	            title: 'Tunnel',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        weird: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Connection UID',
	                select: 'conn_uid',
	                dView: true
	            }, {
	                title: 'Orig IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Orig Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Resp IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Resp Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Name',
	                select: 'name',
	                dView: true
	            }, {
	                title: 'Notice',
	                select: 'notice',
	                dView: true
	            }, {
	                title: 'Peer',
	                select: 'peer',
	                dView: true
	            }, {
	                title: 'Additional Data',
	                select: 'addl',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'vector': 'Vector',
	                'orig_ip': 'Orig IP',
	                'time': 'Time',
	                'addl': 'Additional Data',
	                'conn_uid': 'Connection UID',
	                'orig_port': 'Orig Port',
	                'name': 'Name',
	                'notice': 'Notice',
	                'peer': 'Peer',
	                'resp_ip': 'Resp IP',
	                'resp_port': 'Resp Port',
	                'sensor': 'Sensor'
	            },
	            title: 'Weird',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        },
	        x509: {
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'File UID',
	                select: 'fuid',
	                dView: true
	            }, {
	                title: 'Basic Constraints CA',
	                select: 'basic_constraints_ca',
	                dView: true
	            }, {
	                title: 'Basic Constraints Path Length',
	                select: 'basic_constraints_path_len',
	                dView: true
	            }, {
	                title: 'Certificate Curve',
	                select: 'certificate_curve',
	                dView: true
	            }, {
	                title: 'Certificate Exponent',
	                select: 'certificate_exponent',
	                dView: true
	            }, {
	                title: 'Certificate Issuer',
	                select: 'certificate_issuer',
	                dView: true
	            }, {
	                title: 'Certificate Key Algorithm',
	                select: 'certificate_key_alg',
	                dView: true
	            }, {
	                title: 'Certificate Key Length',
	                select: 'certificate_key_length',
	                dView: true
	            }, {
	                title: 'Certificate Key Type',
	                select: 'certificate_key_type',
	                dView: true
	            }, {
	                title: 'Certificate Not Valid After',
	                select: 'certificate_not_valid_after',
	                dView: true
	            }, {
	                title: 'Certificate Not Valid Before',
	                select: 'certificate_not_valid_before',
	                dView: true
	            }, {
	                title: 'Certificate Serial',
	                select: 'certificate_serial',
	                dView: true
	            }, {
	                title: 'Certificate Signiture Algorithm',
	                select: 'certificate_sig_alg',
	                dView: true
	            }, {
	                title: 'Certificate Subject',
	                select: 'certificate_subject',
	                dView: true
	            }, {
	                title: 'Certificate Version',
	                select: 'certificate_version',
	                dView: true
	            }, {
	                title: 'SAN DNS',
	                select: 'san_dns',
	                dView: true
	            }, {
	                title: 'SAN Email',
	                select: 'san_email',
	                dView: true
	            }, {
	                title: 'SAN IP',
	                select: 'san_ip',
	                dView: true
	            }, {
	                title: 'SAN URI',
	                select: 'san_uri',
	                dView: true
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'basic_constraints_ca': 'Basic Constraints CA',
	                'basic_constraints_path_len': 'Basic Constraints Path Length',
	                'certificate_curve': 'Certificate Curve',
	                'certificate_exponent': 'Certificate Exponent',
	                'certificate_issuer': 'Certificate Issuer',
	                'certificate_key_alg': 'Certificate Key Algorithm',
	                'certificate_key_length': 'Certificate Key length',
	                'certificate_key_type': 'Certificate Key Type',
	                'certificate_not_valid_after': 'Certificate Not Valid After',
	                'certificate_not_valid_before': 'Certificate Not Valid Before',
	                'certificate_serial': 'Certificate Serial',
	                'certificate_sig_alg': 'Certificate Signiture Algorithm',
	                'certificate_subject': 'Certificate Subject',
	                'certificate_version': 'Certificate Version',
	                'fuid': 'File UID`',
	                'san_dns': 'SAN DNS',
	                'san_email': 'SAN Email',
	                'san_ip': 'SAN IP',
	                'san_uri': 'SAN URI',
	                'sensor': 'Sensor'
	            },
	            title: 'x509',
	            sort: {
	                direction: '-',
	                col: 'time'
	            }
	        }
	        // set inital mode
	    };$scope.main.currentMode = 'conn';
	    // set inital reqId value
	    $scope.main.manualSearchId = generateId();
	
	    // set devault killchain variable when first land on page
	    var killChain = {
	        'include': [],
	        'exclude': []
	    };
	    // if 'include' exists in the state params, push it tot the killchain
	    if ($stateParams.include) {
	        killChain.include = $stateParams.include.map(function (d) {
	            var obj = {};
	            obj[d.from] = d.value;
	            return obj;
	        });
	    }
	    // if 'exclude' exists in the state params, push it tot the killchain
	    if ($stateParams.exclude) {
	        killChain.exclude = $stateParams.exclude.map(function (d) {
	            var obj = {};
	            obj[d.from] = d.value;
	            return obj;
	        });
	    }
	    // set the mode if the incomming is defined
	    if ($stateParams.mode) {
	        $scope.main.currentMode = $stateParams.mode;
	    }
	
	    var paramsSanitize = function paramsSanitize(params, mode) {
	        var modeRelevantParams = {
	            include: [],
	            exclude: []
	        },
	            isAll = false;
	        // included items
	        var ilen = params.include.length;
	        if (ilen > 0) {
	            for (var i = 0; i < ilen; i++) {
	                var keys = Object.keys(params.include[i]);
	                var key = keys[0];
	                if (tableSettings[mode].searchCategories.hasOwnProperty(key) || key === 'all') {
	                    var item = {};
	                    item[key] = params.include[i][key];
	                    modeRelevantParams.include.push(item);
	                }
	                // set all mode if a an item in 'all' exists
	                if (key === 'all') {
	                    isAll = true;
	                }
	            }
	        }
	        // excluded items
	        var elen = params.exclude.length;
	        if (elen > 0) {
	            for (var _i = 0; _i < elen; _i++) {
	                var _keys = Object.keys(params.exclude[_i]);
	                var _key = _keys[0];
	                if (tableSettings[mode].searchCategories.hasOwnProperty(_key) || _key === 'all') {
	                    var _item = {};
	                    _item[_key] = params.exclude[_i][_key];
	                    modeRelevantParams.exclude.push(_item);
	                }
	                // set all mode if a an item in 'all' exists
	                if (_key === 'all') {
	                    isAll = true;
	                }
	            }
	        }
	        // 'ALL' SEARCH
	        if (isAll) {
	            // if there are 'all' params, loop through searchCategories and generate an array of columns
	            isAll = [];
	            var dontSearch = ['time', 'ioc_severity', 'session_id', 'notary_valid']; // these dont have mappers yet
	            for (var f in tableSettings[mode].searchCategories) {
	                if (dontSearch.indexOf(f) === -1) {
	                    // this takes from initalData in the dim/group builder - we only want strings - numbers are 0
	                    isAll.push(f);
	                }
	            }
	        }
	        modeRelevantParams.reqId = generateId();
	        modeRelevantParams.allSearch = isAll;
	        // set type/mode to params
	        modeRelevantParams.type = mode;
	        return modeRelevantParams;
	    };
	
	    var getdata = function getdata(time) {
	        if (!time) {
	            // if no time amd start, fetch it
	            time = angular.copy($scope.main.getTime());
	            // get end
	            var endTime = $scope.main.dataObjects[model.tableIdentifiers.key].time.dimension.bottom(1);
	            if (endTime.length > 0) {
	                time.end = endTime[0].time;
	            }
	        }
	        // set start value to the end (since we get the last/latest data first) - this is reduced per data notify/return
	        model.loadStart = time.end;
	        // get specific/relevant params for this table
	        var modeRelevantParams = paramsSanitize(angular.copy($scope.main.dataObjects[model.tableIdentifiers.key].filters), $scope.main.currentMode);
	        // also assign surrent mode to the tables settings (for doing searches on)
	        $scope.main.dataObjects[model.tableIdentifiers.key].settings.type = $scope.main.currentMode;
	        // assign the reassigned req id (set in changetable)
	        modeRelevantParams.reqId = $scope.main.manualSearchId;
	        // reset launched status - to trigger table dimension group rebuild
	        $scope.main.dataObjects[model.tableIdentifiers.key].launched = false;
	        // return a new fetchstream obj
	        return new fetchStream($scope.main.dataObjects[model.tableIdentifiers.key].settings.get.call, $scope.main.dataObjects[model.tableIdentifiers.key].settings.get.socket, modeRelevantParams, time).then(function (type) {
	            if (type !== $scope.main.currentMode) {
	                return;
	            }
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	            // if table finishes without being launched
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                $scope.main.emptyResponseTryNext($scope.main.currentMode);
	            }
	        }, function (err) {
	            // console.log(err)
	            // var r = confirm('An Error has occured, please click ok to refresh the page or try again in a few minutes\n'+err.message);
	            // if (r == true) {
	            //     x = 'Reloading page now';
	            //     $window.location.reload();
	            // } else {
	            //     x = 'Please reload the page in a few minutes';
	            // }
	        }, function (result) {
	            if (result.type !== $scope.main.currentMode) {
	                return;
	            }
	            if (result.reqId !== $scope.main.manualSearchId) {
	                return;
	            }
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	    };
	
	    $scope.main.emptyResponseTryNext = function (previousType) {
	        var pIndex = -1,
	            t = false;
	        for (var i = 0, len = model.sidebarItems.length; i < len; i++) {
	            // loop through sidebar items and find our current mode and mark the index as pIndex
	            if (model.sidebarItems[i].select === previousType) {
	                pIndex = i;
	            }
	            // if pindex is set (not -1) and i is at least one index in front of our current with a count > 0, assign the type as the next to go to
	            if (i > pIndex && pIndex !== -1 && model.sidebarItems[i].count > 0) {
	                t = model.sidebarItems[i].select;
	                break;
	            }
	        }
	        // if there is another type with a count > 0
	        if (t) {
	            // go to the new table
	            model.changeTable(t, true);
	        }
	    };
	
	    model.changeTable = function (type, emptyInital, requery) {
	        $scope.main.dataObjects[model.tableIdentifiers.key].settings.render = {
	            once: true,
	            has: false
	            // emptyInital tells us that the inital set of data was empty and not 'launched'
	        };if (typeof emptyInital === 'undefined') {
	            emptyInital = false;
	        }
	        // set table incomplete status - triggering spinner
	        model.complete = false;
	        // switch page mode
	        $scope.main.currentMode = type;
	        // get a query id
	        $scope.main.manualSearchId = generateId();
	        // push new settings to settigns obj
	        for (var s in tableSettings[$scope.main.currentMode]) {
	            $scope.main.dataObjects[model.tableIdentifiers.key].settings[s] = tableSettings[$scope.main.currentMode][s];
	        }
	        // reset the single draw rule ALSO SET IN BUILDGROUP for when the chart updates
	        if ($scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	            // clear data in table
	            $scope.main.dataObjects[model.tableIdentifiers.key].dimension.filterAll(); // clear all filters
	            // clear time related dimensions
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.remove(); // remove records
	        }
	        $scope.main.dataObjects[model.tableIdentifiers.key].cf = new crossfilter([]); // replace cf
	        // build a new table instance
	        $scope.$broadcast('table-build', model.tableIdentifiers);
	        // dont start the spinner if the table loads faster than building group dim
	        if (!model.complete) {
	            // start table spinner right before init, but after build
	            setTimeout(function () {
	                usSpinnerService.spin(model.tableIdentifiers.id);
	            });
	        }
	        // run data fetch / notify function
	        if (!requery) {
	            getdata(false);
	        }
	    };
	
	    function getProperCurrentMode(callback) {
	        for (var s in model.sidebarItems) {
	            var modeRelevantParams = paramsSanitize(killChain, model.sidebarItems[s].select);
	            if (modeRelevantParams.include.length === killChain.include.length && modeRelevantParams.exclude.length === killChain.exclude.length) {
	                model.changeTable(model.sidebarItems[s].select, false, true);
	                return modeRelevantParams;
	                break;
	            }
	        }
	
	        return false;
	    }
	
	    socketIo('/api/search').then(function (socket) {
	        // first register our data object
	        var registerSettings = {
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            grouping: ['id'],
	            get: {
	                call: 'search',
	                socket: socket
	            },
	            searchCategories: {
	                'vector': 'Vector'
	            }
	            // push new settings to settigns obj
	        };for (var s in tableSettings[$scope.main.currentMode]) {
	            // ignore search categories. below well send all search categories to populate the dropdown
	            if (s !== 'searchCategories') {
	                registerSettings[s] = tableSettings[$scope.main.currentMode][s];
	            }
	        }
	        // find any and all search categoies and put them in settings pre register
	        for (var se in tableSettings) {
	            for (var v in tableSettings[se].searchCategories) {
	                if (!registerSettings.searchCategories.hasOwnProperty(v)) {
	                    registerSettings.searchCategories[v] = tableSettings[se].searchCategories[v];
	                }
	            }
	        }
	        $scope.main.registerVisual(registerSettings)
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // put the the modified (above) settings back after register
	            };for (var _s in tableSettings[$scope.main.currentMode]) {
	                $scope.main.dataObjects[model.tableIdentifiers.key].settings[_s] = tableSettings[$scope.main.currentMode][_s];
	            }
	            // build table
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	            // get and set time
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // only send paramaters that this mode can filter on to avoid cassandra errors
	            // note: we can only include items (since if there are any at this point, they are from a killchain link)
	            var modeRelevantParams = paramsSanitize(killChain, $scope.main.currentMode);
	            if (modeRelevantParams.include.length !== killChain.include.length || modeRelevantParams.exclude.length !== killChain.exclude.length) {
	                modeRelevantParams = getProperCurrentMode();
	            }
	            var includedLen = killChain.include.length;
	            var excludedLen = killChain.exclude.length;
	            if (includedLen > 0) {
	                for (var i = 0; i < includedLen; i++) {
	                    var keys = Object.keys(killChain.include[i]);
	                    var key = keys[0];
	                    $scope.main.addFilter(key, killChain.include[i][key], 'include', true, key);
	                    // $scope.main.updateFilterStore(key, killChain.include[i][key], 'include', true, key);
	                }
	            }
	            if (excludedLen > 0) {
	                for (var _i2 = 0; _i2 < excludedLen; _i2++) {
	                    var _keys2 = Object.keys(killChain.exclude[_i2]);
	                    var _key2 = _keys2[0];
	                    $scope.main.addFilter(_key2, killChain.exclude[_i2][_key2], 'exclude', true, _key2);
	                    // $scope.main.updateFilterStore(key, killChain.exclude[i][key], 'exclude', true, key);
	                }
	            }
	
	            // dont start the spinner if the table loads faster than building group dim
	            if (!model.complete) {
	                // start table spinner right before init, but after build
	                setTimeout(function () {
	                    usSpinnerService.spin(model.tableIdentifiers.id);
	                });
	            }
	            if (modeRelevantParams) {
	                // also assign surrent mode to the tables settings (for doing searches on)
	                $scope.main.dataObjects[model.tableIdentifiers.key].settings.type = $scope.main.currentMode;
	                // assign this isntance of the id to the request
	                modeRelevantParams.reqId = $scope.main.manualSearchId;
	                // set ALL killchain items into filter store / search bar
	                return new fetchStream(result.settings.get.call, result.settings.get.socket, modeRelevantParams);
	            }
	        })
	        // run the extra params and stuff crossfilter
	        .then(function (type) {
	            if (type !== $scope.main.currentMode) {
	                return;
	            }
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	            // if table finishes without being launched
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // after table is set to 'launched', add any items in the killchain to the searchbar and global filters
	                // note: we only have includes from kill chain
	                $scope.main.emptyResponseTryNext($scope.main.currentMode);
	            }
	        }, function (err) {
	            // console.log(err)
	            // var r = confirm('An Error has occured, please click ok to refresh the page or try again in a few minutes\n'+err.message);
	            // if (r == true) {
	            //     x = 'Reloading page now';
	            //     $window.location.reload();
	            // } else {
	            //     x = 'Please reload the page in a few minutes';
	            // }
	        }, function (result) {
	            if (result.type !== $scope.main.currentMode) {
	                return;
	            }
	            if (result.reqId !== $scope.main.manualSearchId) {
	                return;
	            }
	            // add data to the new crossfilter object
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        // let includedLen = killChain.include.length;
	        // let excludedLen = killChain.exclude.length;
	
	        // COUNTS
	        var getcount = function getcount(killChain, index) {
	            var stream = new fetchStream(killChain.type, socket, killChain).then(function (result) {
	                model.sidebarItems[index].doneLoading = true;
	                stream = null;
	            }, function (err) {
	                // console.log(err)
	                // var r = confirm('An Error has occured, please click ok to refresh the page or try again in a few minutes\n'+err.message);
	                // if (r == true) {
	                //     x = 'Reloading page now';
	                //     $window.location.reload();
	                // } else {
	                //     x = 'Please reload the page in a few minutes';
	                // }
	            }, function (result) {
	                // if (result.reqId !== $scope.main.manualSearchId) { return }
	                model.sidebarItems[index].count = result;
	            });
	        };
	        // on load, if there are items in the killchain, do a count for each table item
	        if (killChain.include.length > 0 || killChain.exclude.length > 0) {
	            for (var i = 0, len = model.sidebarItems.length; i < len; i++) {
	                var modeRelevantParams = paramsSanitize(killChain, model.sidebarItems[i].select);
	                model.sidebarItems[i].count = 0; // set item to 0
	                if (modeRelevantParams.include.length === killChain.include.length && modeRelevantParams.exclude.length === killChain.exclude.length) {
	                    // if any relavent params, get the count
	                    getcount(modeRelevantParams, i);
	                } else {
	                    // otherwise set spinner to false / done to true
	                    model.sidebarItems[i].count = 0;
	                    model.sidebarItems[i].doneLoading = true;
	                }
	            }
	        } else {
	            // otherwise for every sidebar item, get default counts
	            for (var _i3 = 0, _len = model.sidebarItems.length; _i3 < _len; _i3++) {
	                var _modeRelevantParams = paramsSanitize(killChain, model.sidebarItems[_i3].select);
	                model.sidebarItems[_i3].count = 0; // set item to 0
	                model.sidebarItems[_i3].doneLoading = false; // emable spinner
	                getcount(_modeRelevantParams, _i3);
	            }
	        }
	
	        $scope.$on('manualSearchFired', function (event, identifiers) {
	            if (identifiers.key !== model.tableIdentifiers.key) {
	                return;
	            }
	            for (var index = 0, _len2 = model.sidebarItems.length; index < _len2; index++) {
	                model.sidebarItems[index].count = 0; // set each count in sidebar to 0
	                // get relavent params for each mode
	                var _modeRelevantParams2 = paramsSanitize(angular.copy($scope.main.dataObjects[model.tableIdentifiers.key].filters), model.sidebarItems[index].select);
	                // if no filters exist AND no relavent filters, get all the counts
	                if (_modeRelevantParams2.include.length === 0 && _modeRelevantParams2.exclude.length === 0 && $scope.main.dataObjects[model.tableIdentifiers.key].filters.include.length === 0 && $scope.main.dataObjects[model.tableIdentifiers.key].filters.exclude.length === 0) {
	                    model.sidebarItems[index].doneLoading = false; // set spinner - getcount will turn it off when finished
	                    getcount(_modeRelevantParams2, index);
	                } else if (_modeRelevantParams2.include.length > 0 || _modeRelevantParams2.exclude.length > 0) {
	                    // otherwise if any relevant params exist in either exclude or exlcude, get the data
	                    model.sidebarItems[index].doneLoading = false; // set spinner - getcount will turn it off when finished
	                    getcount(_modeRelevantParams2, index);
	                } else {
	                    // otherwise remove the spinner
	                    model.sidebarItems[index].doneLoading = true; // remove existing spinner
	                }
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', '$http', 'timeFormat', 'fetchStream', '$window', '$location', 'socketIo', 'generateId', 'settings', 'usSpinnerService', '$state', '$stateParams'];
	module.exports = ctrl;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(677)))

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('stealthDeployConfigController', __webpack_require__(743));
	
	    ngModule.controller('stealthOpViewController', __webpack_require__(744));
	
	    ngModule.controller('stealthConnController', __webpack_require__(745));
	    ngModule.controller('stealthConnOrigController', __webpack_require__(746));
	
	    ngModule.controller('stealthEventsController', __webpack_require__(747));
	    ngModule.controller('stealthEventsOrigController', __webpack_require__(748));
	};

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, $location, settings, $http, usSpinnerService) {
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	
	    $http({ method: 'GET', url: ("https://api-demo.mantix4.com") + '/api/stealth/stealth_deploy_config/forcestealth' }).success(function (data) {
	        $scope.$broadcast('stealthForceChart', data);
	        usSpinnerService.stop('spinner-stealth_deploy_config');
	    });
	
	    model.save_coordinates = function (node) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/stealth/stealth_deploy_config/save_coordinates',
	            data: {
	                x: node.x,
	                y: node.y,
	                name: node.name,
	                type: node.type
	            }
	        });
	    };
	}
	
	ctrl.$inject = ['$scope', 'Global', '$location', 'settings', '$http', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, $location, settings, $http, usSpinnerService) {
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	
	    $http({
	        method: 'GET',
	        url: ("https://api-demo.mantix4.com") + '/api/stealth/stealth_op_view/coi_chart'
	    }).success(function (data) {
	        $scope.forcedata = data;
	        $scope.$broadcast('forceChart', data);
	        usSpinnerService.stop('spinner-stealth_op_view');
	    });
	
	    model.save_coordinates = function (node) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/stealth/stealth_op_view/save_coordinates',
	            data: {
	                x: node.x,
	                y: node.y,
	                type: node.group,
	                name: node.name
	            }
	        });
	    };
	
	    $scope.onloadInfo = function () {
	        var nodeInfo = [];
	        var nodeName = [];
	        for (var i in $scope.forcedata.uniqueNodes) {
	            var nodeAppend = [];
	            $scope.forcedata.nodes.filter(function (d) {
	                if (i === d.name) {
	                    nodeAppend['Name'] = d.name;
	                    nodeAppend['User Count'] = d.count;
	                    nodeAppend['index'] = d.index;
	                }
	            });
	            nodeAppend['Blocked'] = 0;
	            $scope.forcedata.links.filter(function (d) {
	                if (d.class !== undefined && (d.target.index === nodeAppend['index'] || d.source.index === nodeAppend['index'])) {
	                    if (d.allowed === 'authorized') {
	                        // nodeAppend['allowed']++;
	                    } else if (d.allowed === 'blocked') {
	                        nodeAppend['Blocked']++;
	                    }
	                }
	            });
	            nodeInfo.push(nodeAppend);
	        }
	        $scope.pageLoadInfo(nodeInfo, 'onload');
	    };
	    $scope.requery = function (data, button) {
	        var results = [];
	        switch (button) {
	            case 'rules':
	                $scope.appendInfo(data, 'rules');
	                break;
	            case 'authorized':
	                // get children hanging off of parent nodes
	                var rTargets = $scope.forcedata.links.filter(function (d) {
	                    if (d.class !== undefined && d.source.index === data.index && d.source.value.allowed === 'authorized') {
	                        return true;
	                    }
	                });
	                var rSource = $scope.forcedata.links.filter(function (d) {
	                    if (d.class !== undefined && d.target.index === data.index && d.source.value.allowed === 'authorized') {
	                        return true;
	                    }
	                });
	                for (var i in rTargets) {
	                    results.push($scope.forcedata.nodes[rTargets[i].target.index].value);
	                }
	                for (var i in rSource) {
	                    results.push($scope.forcedata.nodes[rSource[i].source.index].value);
	                }
	                $scope.appendInfo(results, 'authorized');
	                break;
	            case 'blocked':
	                // get children hanging off of parent nodes
	                var rTargets = $scope.forcedata.links.filter(function (d) {
	                    if (d.class !== undefined && d.source.index === data.index && d.target.value.allowed === 'blocked') {
	                        return true;
	                    }
	                });
	                var rSource = $scope.forcedata.links.filter(function (d) {
	                    if (d.class !== undefined && d.target.index === data.index && d.source.value.allowed === 'blocked') {
	                        return true;
	                    }
	                });
	                for (var i in rTargets) {
	                    results.push($scope.forcedata.nodes[rTargets[i].target.index].value);
	                }
	                for (var i in rSource) {
	                    results.push($scope.forcedata.nodes[rSource[i].source.index].value);
	                }
	                $scope.appendInfo(results, 'blocked');
	                break;
	            case 'users':
	                var thisObj = $scope.forcedata.uniqueNodes['' + data.name];
	                for (var i in thisObj) {
	                    var obj = {};
	                    obj[i] = Object.keys($scope.forcedata.uniqueUsers[i]);
	                    results.push(obj);
	                }
	                $scope.appendInfo(results, 'users');
	                break;
	            case 'top':
	                // clear the div (replace with loading thing later)
	                query += '&type=top';
	                $http({
	                    method: 'GET',
	                    url: ("https://api-demo.mantix4.com") + query
	                }).success(function (data) {
	                    if (data.force === null) {
	                        $scope.$broadcast('loadError');
	                    }
	                });
	                $scope.appendInfo(results, 'top');
	                break;
	        }
	    };
	}
	
	ctrl.$inject = ['$scope', 'Global', '$location', 'settings', '$http', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 745 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.complete = false;
	
	    socketIo('/api/stealth/stealth_conn').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'linechart',
	                socket: socket
	            }, // no get default to main url, strings will replace the default (otherwise /[from root])
	            grouping: ['hour'],
	            type: 'linechart',
	            settings: {
	                type: 'bandwidth',
	                toggleValues: true,
	                xAxis: '',
	                yAxis: '# MB / Hour'
	            },
	            searchCategories: {
	                'time': 'Time'
	            },
	            dimension: function dimension(cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.time - d.hour < 3600) {
	                        d.hour = Number(d.hour * 1000);
	                        return d.hour;
	                    }
	                });
	            },
	            group: function group(dimension) {
	                // groups are optional and should default to a reduce if undefined
	                return dimension.group().reduce(function (p, v) {
	                    p.bytes_to += v.bytes_orig;
	                    p.bytes_from += v.bytes_resp;
	                    return p;
	                }, function (p, v) {
	                    p.bytes_to -= v.bytes_orig;
	                    p.bytes_from -= v.bytes_resp;
	                    return p;
	                }, function () {
	                    return {
	                        bytes_to: 0,
	                        bytes_from: 0
	                    };
	                });
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	                // set dimension & group
	            };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {}, function (result) {
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            } else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Stealth User Connections',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'stealth_conn_orig',
	                    val: ['resp_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'sensor': 'Sensor',
	                'resp_ip': 'Responder IP',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_stealth': 'Responder Stealth'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 746 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.complete = false;
	
	    socketIo('/api/stealth/stealth_conn_config').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['resp_ip'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Stealth Origin User Connections',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    val: ['resp_ip', 'orig_ip'],
	                    crumb: false
	                }
	            }, {
	                title: 'Sensor',
	                select: 'sensor',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder Stealth',
	                select: 'resp_stealth',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin Stealth',
	                select: 'orig_stealth',
	                dView: true
	            }, {
	                title: 'Payload Ratio',
	                select: 'breakdown',
	                dView: true
	            }, {
	                title: 'Origin Payload',
	                select: 'bytes_orig',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'sensor': 'Sensor',
	                'resp_ip': 'Responder IP',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_stealth': 'Responder Stealth',
	                'orig_ip': 'Origin IP',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_stealth': 'Origin Stealth'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/stealth/stealth_events').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the 'top 10' categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['event_type'],
	                    filter_column: 'event_type',
	                    searchCategories: {
	                        'event_type': 'Event Type'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.event_type;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.event_count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                    };
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj['Other'] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'event_type'],
	                    searchCategories: {
	                        'time': 'Time',
	                        'event_type': 'Event Type'
	                    },
	                    type: 'linechart',
	                    settings: {
	                        type: 'bandwidth',
	                        // hide_legend: true,
	                        use_color: true,
	                        toggleValues: true,
	                        xAxis: '',
	                        yAxis: '# MB / Hour'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.event_type)) {
	                                p[v.event_type] += v.event_count;
	                            } else {
	                                p['Other'] += v.event_count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.event_type)) {
	                                p[v.event_type] -= v.event_count;
	                            } else {
	                                p['Other'] -= v.event_count;
	                            }
	                            return p;
	                        }, function (d, v) {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: { one: 1, two: 2 }
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['event_type'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Stealth Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'stealth_events_orig',
	                    val: ['event_type'],
	                    crumb: false
	                }
	            }, {
	                title: 'Count',
	                select: 'event_count',
	                dView: true
	            }, {
	                title: 'Event ID',
	                select: 'event_id',
	                dView: true
	            }, {
	                title: 'Event Type',
	                select: 'event_type',
	                dView: true
	            }, {
	                title: 'Event Level',
	                select: 'event_level',
	                dView: true
	            }, {
	                title: 'Event Source',
	                select: 'event_src',
	                dView: true
	            }, {
	                title: 'Event User',
	                select: 'event_user',
	                dView: false
	            }],
	            searchCategories: {
	                'event_count': 'Count',
	                'event_id': 'Event ID',
	                'event_type': 'Event Type',
	                'event_level': 'Event Level',
	                'event_src': 'Event Source',
	                'event_user': 'Event User'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 748 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var model = this;
	    model.settings = settings;
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    socketIo('/api/stealth/stealth_events_orig').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['event_type'],
	            sort: {
	                direction: '-', // '-' == desc, '+' == asc
	                col: 'time'
	            },
	            title: 'Stealth Events Origin',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'stealth_events_orig',
	                    val: ['event_type'],
	                    crumb: false
	                }
	            }, {
	                title: 'Count',
	                select: 'event_count',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin Stealth',
	                select: 'orig_stealth',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Event Info',
	                select: 'event_full',
	                dView: true
	            }, {
	                title: 'Event ID',
	                select: 'event_id',
	                dView: true
	            }, {
	                title: 'Event Type',
	                select: 'event_type',
	                dView: true
	            }, {
	                title: 'Event Level',
	                select: 'event_level',
	                dView: true
	            }, {
	                title: 'Event Source',
	                select: 'event_src',
	                dView: true
	            }, {
	                title: 'Event User',
	                select: 'event_user',
	                dView: false
	            }],
	            searchCategories: {
	                'event_count': 'Count',
	                'orig_ip': 'Origin IP',
	                'orig_hostname': 'Origin Hostname',
	                'orig_stealth': 'Origin Stealth',
	                'orig_user': 'Origin User',
	                'event_id': 'Event ID',
	                'event_type': 'Event Type',
	                'event_level': 'Event Level',
	                'event_src': 'Event Source',
	                'event_user': 'Event User'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('surveyController', __webpack_require__(750));
	};

/***/ },
/* 750 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, $window) {
	    $scope.global = Global;
	
	    $scope.iFrameWidth = $window.innerWidth - 40;
	    $scope.iFrameHeight = $window.innerHeight - 30;
	}
	
	ctrl.$inject = ['$scope', 'Global', '$window'];
	module.exports = ctrl;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('endpointTypeUserController', __webpack_require__(752));
	    ngModule.controller('endpointTypeController', __webpack_require__(753));
	    ngModule.controller('endpointUserTypeController', __webpack_require__(754));
	    ngModule.controller('endpointUserController', __webpack_require__(755));
	    ngModule.controller('endpointEventsSharepointDrillController', __webpack_require__(756));
	    ngModule.controller('endpointEventsSharepointController', __webpack_require__(757));
	};

/***/ },
/* 752 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.tableIdentifiers = { key: false, id: false };
	
	    socketIo('/api/system_events/endpoint_by_type_and_user').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['local_user'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            title: 'Local Endpoints Triggering Event',
	            hideToggleBytes: true,
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    table_name: 'events',
	                    val: ['local_hostname', 'local_ip', 'event_type'],
	                    crumb: false
	                }
	            }, { title: 'Events', select: 'count', dView: true },
	            //{ title: 'Stealth', select: 'local_stealth', dView: true },
	            { title: 'Local Hostname', select: 'local_hostname', dView: true }, { title: 'Local User', select: 'local_user', dView: true }, { title: 'Local IP', select: 'local_ip', dView: true }, { title: 'Event Type', select: 'event_type', dView: true }, { title: 'Event Details', select: 'event_detail', dView: true }, { title: 'Event Source', select: 'event_src', dView: true }, { title: 'Event ID', select: 'event_id', dView: true }],
	            searchCategories: {
	                'count': 'Events',
	                'local_stealth': 'Stealth',
	                'local_hostname': 'Local Hostname',
	                'local_user': 'Local User',
	                'local_ip': 'Local IP',
	                'event_type': 'Event Type',
	                'event_detail': 'Event Details',
	                'event_src': 'Event Source',
	                'event_id': 'Event ID'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', ' fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/system_events/endpoint_by_type').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the "top 10" categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['event_type'],
	                    filter_column: 'event_type',
	                    searchCategories: {
	                        'event_type': 'Event Type'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.event_type;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj["Other"] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'event_type'],
	                    type: 'linechart',
	                    settings: {
	                        use_color: true,
	                        type: 'bar',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'event_type': 'Event Type'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.event_type)) {
	                                p[v.event_type] += v.count;
	                            } else {
	                                p["Other"] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.event_type)) {
	                                p[v.event_type] -= v.count;
	                            } else {
	                                p["Other"] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['event_type'],
	            sort: {
	                direction: "-",
	                col: "time"
	            }, // "-"=desc, "+"=asc
	            title: 'Local Endpoint Events',
	            hideToggleBytes: true,
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'endpoint_by_type_and_user',
	                    val: ['event_type'], // val: the pre-evaluated values from the query above
	                    crumb: false
	                }
	            }, {
	                title: 'Events',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Event Type',
	                select: 'event_type',
	                dView: true
	            }, {
	                title: 'Event Source',
	                select: 'event_src',
	                dView: true
	            }],
	            searchCategories: {
	                'count': 'Events',
	                'event_type': 'Event Type',
	                'event_src': 'Event Source'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 754 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.tableIdentifiers = { key: false, id: false };
	
	    socketIo('/api/system_events/endpoint_by_user_and_type').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['event_type'],
	            hideToggleBytes: true,
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            title: 'Local Endpoints Triggering Event',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    table_name: 'events',
	                    val: ['local_hostname', 'local_ip', 'event_type'],
	                    crumb: false
	                }
	            }, { title: 'Events', select: 'count', dView: true },
	            //{ title: 'Stealth', select: 'local_stealth', dView: true },
	            { title: 'Local Hostname', select: 'local_hostname', dView: true }, { title: 'Local User', select: 'local_user', dView: true }, { title: 'Local IP', select: 'local_ip', dView: true }, { title: 'Event Type', select: 'event_type', dView: true }, { title: 'Event Details', select: 'event_detail', dView: true }, { title: 'Event Source', select: 'event_src', dView: true }, { title: 'Event ID', select: 'event_id', dView: true }],
	            searchCategories: {
	                'count': 'Events',
	                'local_stealth': 'Stealth',
	                'local_hostname': 'Local Hostname',
	                'local_user': 'Local User',
	                'local_ip': 'Local IP',
	                'event_type': 'Event Type',
	                'event_detail': 'Event Details',
	                'event_src': 'Event Source',
	                'event_id': 'Event ID'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 755 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    socketIo('/api/system_events/endpoint_by_user').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['local_hostname', 'local_ip'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            title: 'Local Endpoint Events',
	            hideToggleBytes: true,
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'endpoint_by_user_and_type',
	                    val: ['local_hostname', 'local_ip'], // the pre-evaluated values from the query above
	                    crumb: false
	                }
	            }, { title: 'Events', select: 'count', dView: true },
	            //{ title: 'Stealth', select: 'local_stealth', dView: true },
	            { title: 'Local Hostname', select: 'local_hostname', dView: true }, { title: 'Local User', select: 'local_user', dView: true }, { title: 'Local IP', select: 'local_ip', dView: true }, {
	                title: '',
	                select: null,
	                dView: true,
	                link: {
	                    type: 'Upload Image'
	                }
	            }],
	            searchCategories: {
	                'count': 'Events',
	                // 'local_stealth': 'Stealth',
	                'local_hostname': 'Local Hostname',
	                'local_user': 'Local User',
	                'local_ip': 'Local IP'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 756 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	
	    model.tableIdentifiers = { key: false, id: false };
	
	    socketIo('/api/system_events/endpoint_events_sharepoint_drill').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['local_hostname', 'local_ip'],
	            sort: { direction: "-", col: "time" }, // "-"=desc, "+"=asc
	            title: 'Full Endpoint Event Logs',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'search',
	                    table_name: 'events',
	                    val: ['local_hostname', 'local_ip', 'event_type'], // pre-evaluated values from the query above
	                    crumb: false
	                }
	            }, { title: 'Events', select: 'count', dView: true }, { title: 'Local Hostname', select: 'local_hostname', dView: true }, { title: 'Local User', select: 'local_user', dView: true }, { title: 'Local IP', select: 'local_ip', dView: true }, { title: 'Event Type', select: 'event_type', dView: true }, { title: 'Event Details', select: 'event_detail', dView: true }, { title: 'Event Source', select: 'event_src', dView: true }, { title: 'Event ID', select: 'event_id', dView: true }],
	            searchCategories: {
	                'count': 'Events',
	                'local_stealth': 'Stealth',
	                'local_hostname': 'Local Hostname',
	                'local_user': 'Local User',
	                'local_ip': 'Local IP',
	                'event_type': 'Event Type',
	                'event_detail': 'Event Details',
	                'event_src': 'Event Source',
	                'event_id': 'Event ID'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    $scope.global = Global;
	
	    var async = __webpack_require__(681);
	
	    var model = this;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	    model.lineChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.pieChartIdentifiers = {
	        key: false,
	        id: false
	    };
	    model.tableIdentifiers = {
	        key: false,
	        id: false
	    };
	
	    var obj = {};
	    var temp;
	
	    socketIo('/api/system_events/endpoint_events_sharepoint').then(function (socket) {
	        async.series({ // Pie chart has to run before the line chart so it can group the "top 10" categories
	            one: function one(callback) {
	                ////////////////
	                /// PIECHART ///
	                ////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'piechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['event_type'],
	                    filter_column: 'event_type',
	                    searchCategories: {
	                        'event_type': 'Event Type'
	                    },
	                    type: 'piechart',
	                    settings: {
	                        type: 'application',
	                        xAxis: '',
	                        yAxis: ''
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            return d.event_type;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduceSum(function (d) {
	                            return d.count;
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.pieChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // initalize table with column information so it can compile the directive
	                    };return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete or no data
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    }
	                    obj = {};
	                    if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        var top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	                        for (var i = 0, len = top.length; i < len; i++) {
	                            obj[top[i].key] = 0;
	                        }
	                        if (top.length >= 9) {
	                            obj["Other"] = 0;
	                        }
	                        model.setGroupObj(obj);
	                    };
	                    callback(null, 'one');
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched) {
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	                        $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	
	                        $scope.$broadcast('init', model.pieChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	                    }
	                });
	            },
	            two: function two(callback) {
	                /////////////////
	                /// LINECHART ///
	                /////////////////
	
	                // register data object
	                $scope.main.registerVisual({
	                    // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	                    refresh: true, // if a number is placed here, it will overwrite the current 1min default
	                    searchable: true, // optional search param.. no if undefined
	                    get: {
	                        call: 'linechart',
	                        socket: socket
	                    }, // no get default to main url, strings will replace the default (otherwise /[from root])
	                    grouping: ['hour', 'event_type'],
	                    type: 'linechart',
	                    settings: {
	                        type: 'bar',
	                        xAxis: '',
	                        use_color: true,
	                        yAxis: 'MS Events / Hour'
	                    },
	                    searchCategories: {
	                        'time': 'Time',
	                        'event_type': 'Event Type'
	                    },
	                    dimension: function dimension(cfObj) {
	                        return cfObj.dimension(function (d) {
	                            d.hour = Number(d.hour * 1000);
	                            return d.hour;
	                        });
	                    },
	                    group: function group(dimension) {
	                        // groups are optional and should default to a reduce if undefined
	                        return dimension.group().reduce(function (p, v) {
	                            if (obj.hasOwnProperty(v.event_type)) {
	                                p[v.event_type] += v.count;
	                            } else {
	                                p["Other"] += v.count;
	                            }
	                            return p;
	                        }, function (p, v) {
	                            if (obj.hasOwnProperty(v.event_type)) {
	                                p[v.event_type] -= v.count;
	                            } else {
	                                p["Other"] -= v.count;
	                            }
	                            return p;
	                        }, function () {
	                            return angular.copy(obj);
	                        });
	                    }
	                })
	                // fetch the data when the object is registered
	                .then(function (result) {
	                    model.lineChartIdentifiers = {
	                        id: result.id,
	                        key: result.key
	                        // set dimension & group
	                    };$scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	                    // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                    return new fetchStream(result.settings.get.call, result.settings.get.socket);
	                }).then(function (result) {
	                    // stop spinner on complete
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    }
	                }, function (err) {}, function (result) {
	                    $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	                    if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                        $scope.$broadcast('init', model.lineChartIdentifiers);
	                        // stop spinner on inital data
	                        usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	                    } else {
	                        $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	                    }
	                });
	                callback(null, 'two');
	            }
	        }, function (err, results) {
	            // results is now equal to: {one: 1, two: 2}
	        });
	
	        /////////////
	        /// TABLE ///
	        /////////////
	
	        // register data object
	        $scope.main.registerVisual({
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // optional search param.. no if undefined
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['event_type'],
	            hideToggleBytes: true,
	            sort: {
	                direction: "-", // "-" == desc, "+" == asc
	                col: "time"
	            },
	            title: 'Sharepoint Events by Type',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true,
	                link: {
	                    type: 'endpoint_events_sharepoint_drill',
	                    val: ['event_type'],
	                    crumb: false
	                }
	            }, {
	                title: 'Events',
	                select: 'count',
	                dView: true
	            }, {
	                title: 'Event Type',
	                select: 'event_type',
	                dView: true
	            }, {
	                title: 'Event Source',
	                select: 'event_src',
	                dView: true
	            }],
	            searchCategories: {
	                'count': 'Events',
	                'event_type': 'Event Type',
	                'event_src': 'Event Source'
	            }
	        })
	        // fetch the data when the object is registered
	        .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	                // initalize table with column information so it can compile the directive
	            };$scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {}, function (result) {
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	};
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('manageUserController', __webpack_require__(759));
	};

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, $http, timeFormat, settings, usSpinnerService, Global, $window, $location) {
	    var model = this;
	    model.settings = settings;
	    $scope.global = Global;
	    if ($scope.global.user.user_level != "superadmin") {
	        $location.url('/live');
	    }
	    // defaults
	    model.access = {};
	    model.editPane = false;
	    model.formMode = false;
	    model.historyShow = false;
	    model.reset = function (form) {
	        if (form) {
	            form.$setPristine();
	            form.$setUntouched();
	        }
	        model.user = {
	            access: angular.copy(model.access)
	        };
	    };
	    model.reset();
	    // user_level dropdown labeling
	    model.userLevelDisplay = function (user) {
	        var level = void 0;
	        if (user.user_level === 'superadmin') {
	            level = 'Super Admin';
	        } else if (user.user_level === 'admin') {
	            level = 'Admin';
	        } else {
	            level = 'User';
	        }
	        return level;
	    };
	
	    // list users
	    $http({
	        method: 'GET',
	        url: ("https://api-demo.mantix4.com") + '/api/users/listusers'
	    }).success(function (data) {
	        model.users = data.users;
	        // collapse the clients if it is returned in data (meaning this user is a superadmin)
	        if (data.clients && _.isArray(data.clients)) {
	            var c = {};
	            data.clients.forEach(function (d) {
	                if (!c.hasOwnProperty(d.client)) {
	                    c[d.client] = {
	                        sites: {},
	                        map: {
	                            offsetx: 0,
	                            offsety: 0,
	                            scale: 1
	                        }
	                    };
	                }
	                c[d.client].sites[d.keyspace] = {
	                    name: d.site,
	                    checked: false,
	                    x: 0,
	                    y: 0
	                };
	            });
	            model.access = c;
	        } else {
	            //othwise just take from the user's current set
	            var access = angular.copy($scope.global.user.access);
	            for (var _c in access) {
	                for (var s in access[_c].sites) {
	                    access[_c].sites[s] = {
	                        name: access[_c].sites[s],
	                        checked: false,
	                        x: 0,
	                        y: 0
	                    };
	                }
	                access[_c].map = {
	                    offsetx: 0,
	                    offsety: 0,
	                    scale: 1
	                };
	            }
	            model.access = access;
	        }
	        // With the collapsed access definitions, lets mark the users as checked or unchecked.
	        model.users.map(function (user_settings) {
	            // Copy all available access points for the requesting user to modify.
	            var global_settings = angular.copy(model.access);
	
	            for (var user_sensor in user_settings.access) {
	                for (var user_site in user_settings.access[user_sensor].sites) {
	                    if (global_settings.hasOwnProperty(user_sensor)) {
	                        // Set every one in the selected user to checked.
	                        global_settings[user_sensor].sites[user_site].checked = true;
	                        // Set every one in the selected user to checked.
	                        if (user_settings.access[user_sensor].sites[user_site].hasOwnProperty("x")) {
	                            global_settings[user_sensor].sites[user_site].x = user_settings.access[user_sensor].sites[user_site].x;
	                        }
	                        // Set every one in the selected user to checked.
	                        if (user_settings.access[user_sensor].sites[user_site].hasOwnProperty("y")) {
	                            global_settings[user_sensor].sites[user_site].y = user_settings.access[user_sensor].sites[user_site].y;
	                        }
	                    }
	                }
	
	                if (user_settings.access[user_sensor].hasOwnProperty("map") && global_settings.hasOwnProperty(user_sensor)) {
	                    global_settings[user_sensor].map = user_settings.access[user_sensor].map;
	                }
	            }
	
	            user_settings.access = global_settings;
	
	            return user_settings;
	        });
	    });
	
	    // loop through user access to see if anything is checked
	    model.siteNotSelected = function (user) {
	        var selected = true;
	        for (var i in user.access) {
	            for (var s in user.access[i].sites) {
	                if (user.access[i].sites[s].checked) {
	                    selected = false;
	                    break;
	                }
	            }
	        }
	        return selected;
	    };
	
	    // reset all modes and fields
	    model.cancel = function (form) {
	        model.editPane = false;
	        model.formMode = false;
	        model.reset(form);
	    };
	
	    // button starting the process of creating a user
	    model.createUser = function () {
	        model.editPane = true;
	        model.formMode = 'create';
	        model.reset(model.form);
	        model.doneBtn = function (user, form) {
	            // do nothing if the form isn't valid
	            if (form.$invalid || model.siteNotSelected(user)) {
	                return;
	            }
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/users/create',
	                data: {
	                    user: user
	                }
	            }).success(function (data) {
	                data.user.access = user.access;
	                data.user.settings_global = data.settings;
	                model.users.push(data.user);
	                model.cancel(form);
	            });
	        };
	    };
	
	    // our edit mode is set here
	    model.editUser = function (user, index) {
	        model.editPane = true;
	        model.formMode = 'edit';
	        model.user = angular.copy(user);
	        model.saveBtn = function (user, form) {
	            // do nothing if there isnt more than one site selected
	            if (model.siteNotSelected(user)) {
	                return;
	            }
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/users/edit',
	                data: {
	                    user: user
	                }
	            }).success(function (token) {
	                model.users[index] = user;
	                model.cancel(form);
	                // update the access object when editing ourselves
	                if (token) {
	                    // delete old token
	                    delete $window.sessionStorage.token;
	                    // set new token
	                    $window.sessionStorage.token = token;
	                    // also update available access points
	                    $scope.global.user.access = user.access;
	                    $scope.global.user.settings_global = user.settings_global;
	                    model.access = user.access;
	                }
	            });
	        };
	    };
	
	    model.viewHistory = function (user) {
	        model.historyShow = true;
	        $http({
	            method: 'GET',
	            url: ("https://api-demo.mantix4.com") + '/api/users/gethistory?email=' + user.email
	        }).success(function (data) {
	            for (var d = 0, len = data.length; d < len; d++) {
	                data[d].time = timeFormat(data[d].time, 'tables');
	            }
	            model.history = data;
	        });
	    };
	
	    model.hideHistory = function () {
	        model.historyShow = false;
	        delete model.history;
	    };
	
	    // deleting users
	    model.delete = function (user, index) {
	        var c = confirm('Are you sure you\'d like to delete ' + user.email + '???');
	        if (c) {
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/users/delete',
	                data: {
	                    user: user
	                }
	            }).success(function (data) {
	                model.users.splice(index, 1);
	            });
	        }
	    };
	}
	
	ctrl.$inject = ['$scope', '$http', 'timeFormat', 'settings', 'usSpinnerService', 'Global', '$window', '$location'];
	module.exports = ctrl;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('manageFeedController', __webpack_require__(761));
	};

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _require = __webpack_require__(762),
	    find = _require.find;
	
	function ctrl($scope, $http, Global, settings, $location) {
	    $scope.global = Global;
	    $scope.global.operations = { success: "Success", warning: "Warning", error: "Error" };
	    alertify.defaults.theme.ok = "button-success pure-button";
	    alertify.defaults.theme.cancel = "pure-button";
	    alertify.set('notifier', 'position', 'bottom-center');
	    if ($scope.global.user.user_level != "superadmin") {
	        $location.url('/live');
	    }
	    var model = this;
	    model.settings = settings;
	    model.feeds = [];
	    model.regexs = [];
	    model.feeds_per_sensor = [];
	    model.light_feeds = [];
	    model.modal_regexs = [];
	    model.sensors = [];
	    model.help_test = '';
	    model.btnSensorFeeds = false;
	    model.btnFeeds = false;
	
	    //Get all feeds
	    model.getFeeds = function () {
	        $http({
	            method: 'GET',
	            url: ("https://api-demo.mantix4.com") + '/api/feeds/getAll'
	        }).success(function (data) {
	            //tmpname is used to avoid visual confusion if name is edited
	            for (var i = 0; i <= data.length - 1; i++) {
	                data[i].tmpname = data[i].name;
	                data[i].ioc_severity = data[i].ioc_severity.toString();
	                if (data[i].last_run != 0) {
	                    data[i].last_run = timeConverter(data[i].last_run);
	                } else {
	                    data[i].last_run = "Someday";
	                }
	            }
	            model.feeds = data;
	        });
	    };
	
	    model.getFeeds();
	    // Load all the sensors
	    model.loadSensors = function () {
	        $http({
	            method: 'GET',
	            url: ("https://api-demo.mantix4.com") + '/api/landing/getSensors'
	        }).success(function (data) {
	            model.sensors = data;
	        });
	    };
	
	    // As the sensor tab is the first to show, it should be ready on page load
	    model.loadSensors();
	
	    // This is for store the relation between sensors and the feeds that the should use
	    model.saveSensorFeeds = function (sensor_id) {
	        model.btnSensorFeeds = true;
	        var feedsSelected = [];
	        for (var i = 0; i <= model.feeds.length - 1; i++) {
	            console.log(i, document.getElementById(sensor_id + 'rememberMe' + i));
	            if (document.getElementById(sensor_id + 'rememberMe' + i).checked) {
	                feedsSelected.push({ sensor_id: sensor_id, feed_id: model.feeds[i].id });
	            }
	        }
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/feeds_sensor/save',
	            data: {
	                sensor_id: sensor_id,
	                feeds: feedsSelected
	            }
	        }).success(function () {
	            showMsg($scope.global.operations.success, "Data has been successfully saved!");
	            model.btnSensorFeeds = false;
	        }).error(function (error) {
	            alertError(error);model.btnSensorFeeds = false;
	        });
	    };
	    // This weill load the feeds that were selected before and check the checkboxes
	    model.loadFeedsPerSensor = function (sensor_id) {
	        $http({
	            method: 'POST',
	            url: ("https://api-demo.mantix4.com") + '/api/feeds_sensor/getPerSensor',
	            data: {
	                sensor_id: sensor_id
	            }
	        }).success(function (data) {
	            data.forEach(function (element) {
	                var index = model.feeds.findIndex(function (ele) {
	                    return ele.id === element.feed_id;
	                });
	                document.getElementById(sensor_id + 'rememberMe' + index).checked = true;
	            });
	        });
	    };
	
	    //Get all the regexs
	    model.getRegexes = function () {
	        $http({
	            method: 'GET',
	            url: ("https://api-demo.mantix4.com") + '/api/regex/getAll'
	        }).success(function (data) {
	            model.regexs = data;
	            model.modal_regexs = angular.copy(data);
	        });
	    };
	    model.getRegexes();
	
	    model.addFeed = function () {
	        if (model.feeds.some(function (ele) {
	            return ele.tmpname === "New feed";
	        })) {
	            showMsg($scope.global.operations.warning, "A new feed is being created already, please save it before creating a new one!");
	            return;
	        }
	        model.feeds.push({ tmpname: "New feed", ioc_type: "", frequency: "" });
	    };
	
	    // This function is for the buttons with the sensor name on Sensors tab 
	    model.openSensor = function (index, sensor_id) {
	        var i = void 0,
	            tabContent = void 0,
	            tabLinks = void 0;
	        tabContent = document.getElementsByName("sensorContent");
	        for (i = 0; i < tabContent.length; i++) {
	            tabContent[i].style.display = "none";
	        }
	        tabLinks = document.getElementsByName("sensorLink");
	        for (i = 0; i < tabContent.length - 1; i++) {
	            tabLinks[i].className = tabLinks[i].className.replace(" active", "");
	        }
	        document.getElementById(sensor_id).style.display = "block";
	        tabLinks[index].classList.add('active');
	        model.loadFeedsPerSensor(sensor_id);
	    };
	
	    // This function is for the buttons with the feed name on Feeds tab 
	    model.openFeed = function (index, feed) {
	        var i = void 0,
	            tabContent = void 0,
	            tabLinks = void 0;
	        tabContent = document.getElementsByName("feed");
	        for (i = 0; i < tabContent.length; i++) {
	            tabContent[i].style.display = "none";
	        }
	        tabLinks = document.getElementsByName("feedlink");
	        for (i = 0; i < tabContent.length - 1; i++) {
	            tabLinks[i].className = tabLinks[i].className.replace(" active", "");
	        }
	        document.getElementById(feed.tmpname).style.display = "block";
	        tabLinks[index].classList.add('active');
	    };
	
	    model.saveFeed = function (feed) {
	        model.btnFeeds = true;
	        if (feed.helper === undefined) {
	            feed.helper = "";
	        }
	        var count = 0;
	        model.feeds.map(function (e) {
	            return e.name;
	        }).forEach(function (e) {
	            return e == feed.name ? count++ : '';
	        });
	        if (count > 1) {
	            showMsg($scope.global.operations.error, "There cannot be two feeds with the same name!");
	            return;
	        }
	        if (feed.id !== undefined) {
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/feeds/update',
	                data: {
	                    feed: feed
	                }
	            }).success(function () {
	                feed.tmpname = feed.name;
	                model.getFeeds();
	                model.btnFeeds = false;
	                showMsg($scope.global.operations.success, "Data has been successfully updated!");
	            }).error(function (error) {
	                alertError(error);model.btnFeeds = false;
	            });
	        } else {
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/feeds/save',
	                data: {
	                    feed: feed
	                }
	            }).success(function () {
	                feed.tmpname = feed.name;
	                model.getFeeds();
	                //document.getElementsByName("feed")[0].style.display="";
	                showMsg($scope.global.operations.success, "Data has been successfully saved!");
	                model.btnFeeds = false;
	            }).error(function (error) {
	                alertError(error);model.btnFeeds = false;
	            });
	        }
	    };
	
	    model.saveRegexs = function () {
	        var updatedFeeds = model.modal_regexs.filter(function (newReg, index) {
	            if (model.regexs[index] !== undefined && (model.regexs[index].regex !== newReg.regex || model.regexs[index].name !== newReg.name)) {
	                newReg.oldName = model.regexs[index].name;
	                return newReg;
	            }
	        });
	        if (updatedFeeds.length > 0) {
	            var used = model.feeds.filter(function (feed) {
	                var found = updatedFeeds.find(function (regex) {
	                    return feed.regex === regex.oldName ? regex.oldName : "";
	                });
	                if (found !== undefined) {
	                    return feed.regex === found.oldName;
	                }
	            });
	            var usedNames = used.map(function (ele) {
	                return ele.name;
	            });
	            alertify.confirm('Update confirmation', "It looks like the modified regex(s) are being used by " + usedNames + ". This might cause a miss behaviour, are you sure you want to continue?", function () {
	                $http({
	                    method: 'POST',
	                    url: ("https://api-demo.mantix4.com") + '/api/regex/save',
	                    data: {
	                        values: model.modal_regexs
	                    }
	                }).success(function () {
	                    showMsg($scope.global.operations.success, "Data has been successfully saved!");
	                }).error(function (error) {
	                    return alertError(error);
	                });
	            }, {});
	        } else {
	            $http({
	                method: 'POST',
	                url: ("https://api-demo.mantix4.com") + '/api/regex/save',
	                data: {
	                    values: model.modal_regexs
	                }
	            }).success(function () {
	                showMsg($scope.global.operations.success, "Data has been successfully saved!");
	            }).error(function (error) {
	                return alertError(error);
	            });
	        }
	    };
	
	    model.deleteFeed = function (feed, index) {
	        var conf = feed.id !== undefined ? 'Are you sure? If the feed is associated with a sensor, the relation will be also deleted.' : 'Do you want to cancel this ';
	        alertify.confirm('Delete confirmation', conf, function () {
	            if (feed.id !== undefined) {
	                $http({
	                    method: 'POST',
	                    url: ("https://api-demo.mantix4.com") + '/api/feeds/delete',
	                    data: {
	                        feed: feed
	                    }
	                }).success(function (data) {
	                    model.feeds.splice(index, 1);
	                    showMsg($scope.global.operations.success, "Data has been successfully deleted!");
	                    document.getElementById('emptyFeed').style.display = "block";
	                }).error(function (error) {
	                    return alertError(error);
	                });
	            } else {
	                model.feeds.splice(index, 1);
	                showMsg($scope.global.operations.success, "Data has been successfully deleted!");
	                document.getElementById('emptyFeed').style.display = "block";
	            }
	        }, {});
	    };
	
	    model.loadRegexs = function () {
	        //model.modal_regexs = angular.copy(model.regexs);
	        model.modal_regexs.forEach(function (element) {
	            return element.repeatedN = false;
	        });
	        model.modal_regexs.forEach(function (element) {
	            return element.repeatedR = false;
	        });
	        model.cleanRegex();
	        model.validateRegex({ name: '', regex: '' });;
	    };
	
	    model.tryRegex = function () {
	        var regExp = /.*/g,
	            regHelp = /^.*/;
	        if (model.regex_test === 'regex_demo') {
	            regExp = new RegExp(/^.*\,([0-9.]*)\,/, 'gm');
	            model.regPre = '2021-02-09 09:34:40,119.45.183.69,8880\n' + '2021-02-09 08:35:12,139.28.235.223,8808\n' + '2021-02-08 20:04:37,179.43.166.30,4782\n' + '2021-02-08 18:03:27,185.140.53.137,4723\n';
	            model.regOut = getRegexs(model.regPre, regExp);
	            model.help_test = '';
	            model.helpOut = '';
	            document.getElementById('help_out').style.display = "none";
	        } else if (model.regex_test === 'regex_helper' || model.help_test === 'helper_demo') {
	            model.regex_test = 'regex_helper';
	            model.help_test = 'helper_demo';
	            model.regPre = 'alert tcp $HOME_NET any -> [103.110.53.174,103.150.68.124,103.244.206.74,103.40.116.68,103.41.110.115,103.61.101.11,103.69.216.154,103.86.49.11,103.89.252.130,103.91.244.102,103.91.244.50,103.93.220.182,103.94.7.43,104.131.123.136] any (msg:"ET CNC Feodo Tracker Reported CnC Server TCP group 1"; flags:S; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404300; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signature_severity Major, created_at 2014_11_04, updated_at 2021_02_09;)\n' + 'alert udp $HOME_NET any -> [103.110.53.174,103.150.68.124,103.244.206.74,103.40.116.68,103.41.110.115,103.61.101.11,103.69.216.154,103.86.49.11,103.89.252.130,103.91.244.102,103.91.244.50,103.93.220.182,103.94.7.43,104.131.123.136] any (msg:"ET CNC Feodo Tracker Reported CnC Server UDP group 1"; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404301; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signature_severity Major, created_at 2014_11_04, updated_at 2021_02_09;)\n' + 'alert tcp $HOME_NET any -> [104.131.164.93,104.131.44.150,104.161.32.108,104.236.52.89,105.209.235.113,107.172.188.113,107.172.29.108,109.101.137.162,109.116.245.80,110.142.236.207,110.145.11.73,110.172.180.180,110.37.224.243,110.39.160.38] any (msg:"ET CNC Feodo Tracker Reported CnC Server TCP group 2"; flags:S; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404302; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signature_severity Major, created_at 2014_11_04, updated_at 2021_02_09;)\n' + 'alert udp $HOME_NET any -> [104.131.164.93,104.131.44.150,104.161.32.108,104.236.52.89,105.209.235.113,107.172.188.113,107.172.29.108,109.101.137.162,109.116.245.80,110.142.236.207,110.145.11.73,110.172.180.180,110.37.224.243,110.39.160.38] any (msg:"ET CNC Feodo Tracker Reported CnC Server UDP group 2"; reference:url,doc.emergingthreats.net/bin/view/Main/BotCC; reference:url,feodotracker.abuse.ch; threshold: type limit, track by_src, seconds 3600, count 1; classtype:trojan-activity; flowbits:set,ET.Evil; flowbits:set,ET.BotccIP; sid:2404303; rev:6004; metadata:affected_product Windows_XP_Vista_7_8_10_Server_32_64_Bit, attack_target Client_Endpoint, deployment Perimeter, tag Banking_Trojan, signa';
	            regExp = new RegExp(/^.*\[([0-9.,]*)\]/, 'gm');
	            regHelp = new RegExp(/([^,]*)/, 'gm');
	            document.getElementById('help_out').style.display = "block";
	            model.helpOut = getRegexs(model.regPre, regHelp);
	            model.regOut = getRegexs(model.helpOut.toString(), regExp);
	        } else {
	            if (model.help_test === '') {
	                document.getElementById('help_out').style.display = "none";
	                model.regOut = getRegexs(model.regPre, new RegExp(model.regex_test, 'gm'));
	            } else {
	                document.getElementById('help_out').style.display = "block";
	                model.helpOut = getRegexs(model.regPre, new RegExp(model.help_test, 'gm'));
	                model.regOut = getRegexs(model.helpOut.toString(), new RegExp(model.regex_test, 'gm'));
	            }
	        }
	        //Hack to adjust window size
	        model.collapse();
	        model.collapse();
	    };
	
	    model.collapse = function () {
	        var ele = document.getElementById('modalCollapse');
	        ele.classList.toggle('active');
	        var content = ele.nextElementSibling;
	        if (content.style.maxHeight) {
	            content.style.maxHeight = null;
	        } else {
	            content.style.maxHeight = content.scrollHeight + "px";
	        }
	    };
	
	    model.addRegex = function () {
	        model.modal_regexs.push({ namHolder: "Example", name: "", regex: "", regHolder: "/*.*/", repeatedN: false, repeatedR: false });
	        model.validateRegex({ name: '', regex: '' });
	    };
	
	    model.removeRegex = function (index) {
	        var msg = "Are you sure you'd like to delete \"" + model.modal_regexs[index].name + "\"? After clicking OK the regex no longer will be available.";
	        alertify.confirm('Delete confirmation', msg, function () {
	            if (model.modal_regexs[index].id !== undefined) {
	                $http({
	                    method: 'POST',
	                    url: ("https://api-demo.mantix4.com") + '/api/regex/delete',
	                    data: {
	                        reg: model.modal_regexs[index]
	                    }
	                }).success(function () {
	                    showMsg($scope.global.operations.success, "Data has been successfully deleted!");
	                    if (model.modal_regexs.length > 1) {
	                        model.modal_regexs.splice(index, 1);
	                    }
	                    return;
	                }).error(function (error) {
	                    alertError(error);
	                    return;
	                });
	            } else {
	                if (model.modal_regexs.length > 1) {
	                    model.modal_regexs.splice(index, 1);
	                }
	            }
	        }, {});
	    };
	
	    model.validateRegex = function (reg) {
	        var tmpUniq = [];
	        model.modal_regexs.forEach(function (element) {
	            if (tmpUniq.indexOf(element.regex) == -1) {
	                tmpUniq.push(element.regex);
	                element.repeatedR = false;
	            } else element.repeatedR = true;
	        });
	        if (reg.regex === '' || model.modal_regexs.some(function (element) {
	            return element.regex === '';
	        }) || model.modal_regexs.some(function (element) {
	            return element.repeatedR == true;
	        })) {
	            document.getElementById('saveFeed').disabled = true;
	            return;
	        } else {
	            document.getElementById('saveFeed').disabled = false;
	        }
	        tmpUniq = [];
	        model.modal_regexs.forEach(function (element) {
	            if (tmpUniq.indexOf(element.name) == -1) {
	                tmpUniq.push(element.name);
	                element.repeatedN = false;
	            } else element.repeatedN = true;
	        });
	        if (reg.name === '' || model.modal_regexs.find(function (element) {
	            return element.name === "";
	        }) || model.modal_regexs.find(function (element) {
	            return element.repeatedN == true;
	        })) {
	            document.getElementById('saveFeed').disabled = true;
	            return;
	        } else {
	            document.getElementById('saveFeed').disabled = false;
	        }
	    };
	
	    model.selectAll = function (sensor_id) {
	        if (document.getElementById(sensor_id + 'selectAll').checked) {
	            model.feeds.forEach(function (ele, index) {
	                document.getElementById(sensor_id + 'rememberMe' + index).checked = true;
	            });
	        } else {
	            model.feeds.forEach(function (ele, index) {
	                document.getElementById(sensor_id + 'rememberMe' + index).checked = false;
	            });
	        }
	    };
	
	    model.cleanRegex = function () {
	        model.regex_test = '';model.help_test = '';model.regPre = '';model.helpOut = '';model.regOut = '';
	    };
	}
	
	var timeConverter = function timeConverter(UNIX_timestamp) {
	    var a = new Date(UNIX_timestamp * 1000);
	    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    var year = a.getFullYear();
	    var month = months[a.getMonth()];
	    var date = a.getDate();
	    var hour = a.getHours();
	    var min = a.getMinutes();
	    var sec = a.getSeconds();
	    var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
	    return time;
	};
	
	var getRegexs = function getRegexs(text, reg) {
	    var arr = [].concat(_toConsumableArray(text.matchAll(reg)));
	    return arr.map(function (key) {
	        return key[1];
	    });
	};
	
	var showMsg = function showMsg(op, msg) {
	    switch (op) {
	        case "Success":
	            alertify.success(msg);
	            break;
	        case "Warning":
	            alertify.warning(msg);
	            break;
	        case "Error":
	            alertify.error(msg);
	            break;
	    }
	};
	var alertError = function alertError(error) {
	    return alertify.dialog('alert').set({ transition: 'zoom', message: error, title: 'Error!' }).show();
	};
	
	ctrl.$inject = ['$scope', '$http', 'Global', 'settings', '$location'];
	module.exports = ctrl;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * lodash <https://lodash.com/>
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.16.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://github.com/es-shims.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for function metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 500,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', ARY_FLAG],
	    ['bind', BIND_FLAG],
	    ['bindKey', BIND_KEY_FLAG],
	    ['curry', CURRY_FLAG],
	    ['curryRight', CURRY_RIGHT_FLAG],
	    ['flip', FLIP_FLAG],
	    ['partial', PARTIAL_FLAG],
	    ['partialRight', PARTIAL_RIGHT_FLAG],
	    ['rearg', REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
	    rsUpper + '+' + rsOptUpperContr,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array ? array.length : 0;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array ? array.length : 0;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array ? array.length : 0;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array ? array.length : 0;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        iteratorSymbol = Symbol ? Symbol.iterator : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array of at least `200` elements
	     * and any iteratees accept only one argument. The heuristic for whether a
	     * section qualifies for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries ? entries.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {boolean} [isFull] Specify a clone including symbols.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var props = isArr ? undefined : (isFull ? getAllKeys : keys)(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      return objectToString.call(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = castPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[toKey(path)];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && objectToString.call(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        objTag = objTag == argsTag ? objectTag : objTag;
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        othTag = othTag == argsTag ? objectTag : othTag;
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	          : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	      }
	      if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return basePickBy(object, props, function(value, key) {
	        return key in object;
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property identifiers to pick from.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, props, predicate) {
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (predicate(value, key)) {
	          baseAssignValue(result, key, value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = castPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[toKey(last(path))];
	            }
	          }
	          else {
	            delete array[toKey(index)];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path] : castPath(path);
	      object = parent(object, path);
	
	      var key = toKey(last(path));
	      return !(object != null && hasOwnProperty.call(object, key)) || delete object[key];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     *   512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, customizer, bitmask, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= UNORDERED_COMPARE_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	     *  for more details.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	    /**
	     * Creates an array of the own and inherited enumerable symbol properties
	     * of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : undefined;
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object ? object.length : 0;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      string = toString(string);
	
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to process.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array ? array.length : 0,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array ? array.length : 0;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity]
	     *  The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, false, true);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, true, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, true, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return value != null && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed array and other constructors.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || objectToString.call(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable string keyed properties of `object` that are
	     * not omitted.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(props, toKey);
	      return basePick(object, baseDifference(getAllKeysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property identifiers to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, props) {
	      return object == null ? {} : basePick(object, arrayMap(props, toKey));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getAllKeysIn(object), getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = isKey(path, object) ? [path] : castPath(path);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        object = undefined;
	        length = 1;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(39)(module)))

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // Failed SSL Certificate Validation
	    ngModule.controller('sslCertsController', __webpack_require__(764));
	    // DNS Exfiltration (UDP Tunneling)
	    ngModule.controller('dnsExfilTunnelsController', __webpack_require__(765));
	    // DNS Exfiltration (Subdomains on a Top Level Domain)
	    ngModule.controller('dnsExfilSubdomainsController', __webpack_require__(766));
	    // DNS Exfiltration (DNS Queries)
	    //ngModule.controller('dnsExfilQueriesController', require('./dns_exfil_queries'));
	    // Kaminsky DNS Attack (Duplicate DNS Source Ports)
	    ngModule.controller('dnsPoisoning', __webpack_require__(767));
	    // DNS Tunnel (DNScat2)
	    ngModule.controller('dnsTunnelDnscat2', __webpack_require__(768));
	    // DNS Tunnel (Iodine-1)
	    ngModule.controller('dnsTunnelIodine1', __webpack_require__(769));
	    // DNS Tunnel (Iodine-2)
	    ngModule.controller('dnsTunnelIodine2', __webpack_require__(770));
	    // Suspicious Subdomains
	    ngModule.controller('suspiciousSubdomains', __webpack_require__(771));
	    // Long Duration Connections
	    ngModule.controller('longDurationConns', __webpack_require__(772));
	    // Large HTTP Responses (More than 1KB)
	    ngModule.controller('largeHttpResponses', __webpack_require__(773));
	    // Non-Standard HTTP
	    ngModule.controller('nonStandardHttp', __webpack_require__(774));
	    // Services Breakdown
	    ngModule.controller('servicesBreakdown', __webpack_require__(775));
	    // User-Agents (HTTP)
	    ngModule.controller('userAgents', __webpack_require__(776));
	    // Top Responder Ports
	    ngModule.controller('topResponderPorts', __webpack_require__(777));
	    // Top Internal Producers
	    ngModule.controller('topInternalProducers', __webpack_require__(778));
	    // Top Referred Hosts
	    ngModule.controller('topReferredHosts', __webpack_require__(779));
	    // Most Popular Sites
	    ngModule.controller('mostPopularSites', __webpack_require__(780));
	    // HTTP Beacons
	    ngModule.controller('httpBeacons', __webpack_require__(781));
	    // DNS Beacons
	    ngModule.controller('dnsBeacons', __webpack_require__(782));
	};

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/ssl_certs').then(function (socket) {
	        // async.series(
	        // { // Pie chart has to run before the line chart so it can group the 'top 10' categories
	        //     one: function(callback)
	        //     {
	        //         /* -----------*/
	        //         /*  PIECHART  */
	        //         /* -----------*/
	        //
	        //         // register data object
	        //         $scope.main.registerVisual(
	        //         {
	        //             // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
	        //             searchable: true, // optional search param.. no if undefined
	        //             get: {
	        //                 call: 'piechart',
	        //                 socket: socket
	        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
	        //             grouping: ['sub'],
	        //             filter_column: 'sub',
	        //             searchCategories:
	        //             {
	        //                 'sub': 'Subject',
	        //             },
	        //             type: 'piechart',
	        //             settings:
	        //             {
	        //                 type: 'application',
	        //                 xAxis: '',
	        //                 yAxis: ''
	        //             },
	        //             dimension: function(cfObj)
	        //             {
	        //                 return cfObj.dimension(function(d)
	        //                 {
	        //                     return d.top_server;
	        //                 });
	        //             },
	        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
	        //             {
	        //                 return dimension.group().reduceSum(function(d)
	        //                 {
	        //                     return d.count;
	        //                 });
	        //             },
	        //         })
	        //         // fetch the data when the object is registered
	        //         .then(function(result)
	        //         {
	        //             model.pieChartIdentifiers = { id: result.id, key: result.key };
	        //             // initalize table with column information so it can compile the directive
	        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //         })
	        //         .then(function(result)
	        //         {
	        //             // stop spinner on complete or no data
	        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	        //
	        //             obj = {};
	        //
	        //             if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //             {
	        //                 let top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	        //
	        //                 for (var i = 0, len = top.length; i < len; i++)
	        //                     obj[top[i].key] = 0;
	        //
	        //                 if (top.length >= 9)
	        //                     obj['Other'] = 0;
	        //
	        //                 model.setGroupObj(obj);
	        //             };
	        //
	        //             callback(null, 'one');
	        //         },
	        //         function(err)
	        //         {
	        //
	        //         },
	        //         function(result)
	        //         {
	        //             $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	        //
	        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //             {
	        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	        //
	        //                 $scope.$broadcast('init', model.pieChartIdentifiers);
	        //                 // stop spinner on inital data
	        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	        //             }
	        //
	        //             else
	        //                 $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	        //         })
	        //     },
	        //     two: function(callback)
	        //     {
	        //         /* ------------*/
	        //         /*  LINECHART  */
	        //         /* ------------*/
	        //
	        //         // register data object
	        //         $scope.main.registerVisual(
	        //         {
	        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
	        //             searchable: true, // optional search param.. no if undefined
	        //             get:
	        //             {
	        //                 call: 'linechart',
	        //                 socket: socket
	        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
	        //             grouping: ['hour', 'sub'],
	        //             hideToggleBytes: true,
	        //             type: 'linechart',
	        //             settings:
	        //             {
	        //                 use_color: true,
	        //                 type: 'bar',
	        //                 xAxis: '',
	        //                 yAxis: 'Subject Appearance / Hour'
	        //             },
	        //             searchCategories:
	        //             {
	        //                 'time': 'Time',
	        //                 'sub': 'Subject',
	        //             },
	        //             dimension: function(cfObj)
	        //             {
	        //                 return cfObj.dimension(function(d)
	        //                 {
	        //                     d.hour = Number(d.hour * 1000);
	        //
	        //                     return d.hour;
	        //                 });
	        //             },
	        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
	        //             {
	        //                 return dimension.group().reduce(
	        //                     function(p, v)
	        //                     {
	        //                         if (obj.hasOwnProperty(v.top_server))
	        //                             p[v.top_server] += v.count;
	        //
	        //                         else
	        //                             p['Other'] += v.count;
	        //
	        //                         return p;
	        //                     },
	        //                     function(p, v)
	        //                     {
	        //                         if (obj.hasOwnProperty(v.top_server))
	        //                             p[v.top_server] -= v.count;
	        //
	        //                         else
	        //                             p['Other'] -= v.count;
	        //
	        //                         return p;
	        //                     },
	        //                     function()
	        //                     {
	        //                         return angular.copy(obj);
	        //                     }
	        //                 );
	        //             },
	        //         })
	        //         // fetch the data when the object is registered
	        //         .then(function(result)
	        //         {
	        //             model.lineChartIdentifiers = { id: result.id, key: result.key };
	        //             // set dimension & group
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	        //             // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //         })
	        //         .then(function(result)
	        //         {
	        //             // stop spinner on complete
	        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
	        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	        //         },
	        //         function(err)
	        //         {
	        //
	        //         },
	        //         function(result)
	        //         {
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	        //
	        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
	        //             {
	        //                 $scope.$broadcast('init', model.lineChartIdentifiers);
	        //                 // stop spinner on inital data
	        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	        //             }
	        //
	        //             else
	        //                 $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	        //         });
	        //
	        //         callback(null, 'two');
	        //     }
	        // },
	        // function(err, results)
	        // {
	        //     // results is now equal to: {one: 1, two: 2}
	        // });
	
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'vector'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Fail due',
	                select: 'failed_ssl',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Certificate Attributes',
	                select: 'sub',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: true,
	                editTable: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'failed_ssl': 'Fail due',
	                'orig_ip': 'Origin IP',
	                'orig_port': 'Origin Port',
	                'resp_ip': 'Responder IP',
	                'resp port': 'Responder Port',
	                'proto': 'Protocol',
	                'sub': 'Certificate Attributes',
	                'vector': 'Vector'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService, $http) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/dns_exfil_udp_tunnels').then(function (socket) {
	        // async.series(
	        // { // Pie chart has to run before the line chart so it can group the 'top 10' categories
	        //     one: function(callback)
	        //     {
	        //         /* -----------*/
	        //         /*  PIECHART  */
	        //         /* -----------*/
	        //
	        //         // register data object
	        //         $scope.main.registerVisual(
	        //         {
	        //             // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
	        //             searchable: true, // optional search param.. no if undefined
	        //             get: {
	        //                 call: 'piechart',
	        //                 socket: socket
	        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
	        //             grouping: ['sub'],
	        //             filter_column: 'sub',
	        //             searchCategories:
	        //             {
	        //                 'sub': 'Subject',
	        //             },
	        //             type: 'piechart',
	        //             settings:
	        //             {
	        //                 type: 'application',
	        //                 xAxis: '',
	        //                 yAxis: ''
	        //             },
	        //             dimension: function(cfObj)
	        //             {
	        //                 return cfObj.dimension(function(d)
	        //                 {
	        //                     return d.top_server;
	        //                 });
	        //             },
	        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
	        //             {
	        //                 return dimension.group().reduceSum(function(d)
	        //                 {
	        //                     return d.count;
	        //                 });
	        //             },
	        //         })
	        //         // fetch the data when the object is registered
	        //         .then(function(result)
	        //         {
	        //             model.pieChartIdentifiers = { id: result.id, key: result.key };
	        //             // initalize table with column information so it can compile the directive
	        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //         })
	        //         .then(function(result)
	        //         {
	        //             // stop spinner on complete or no data
	        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	        //
	        //             obj = {};
	        //
	        //             if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //             {
	        //                 let top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	        //
	        //                 for (var i = 0, len = top.length; i < len; i++)
	        //                     obj[top[i].key] = 0;
	        //
	        //                 if (top.length >= 9)
	        //                     obj['Other'] = 0;
	        //
	        //                 model.setGroupObj(obj);
	        //             };
	        //
	        //             callback(null, 'one');
	        //         },
	        //         function(err)
	        //         {
	        //
	        //         },
	        //         function(result)
	        //         {
	        //             $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	        //
	        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //             {
	        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	        //
	        //                 $scope.$broadcast('init', model.pieChartIdentifiers);
	        //                 // stop spinner on inital data
	        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	        //             }
	        //
	        //             else
	        //                 $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	        //         })
	        //     },
	        //     two: function(callback)
	        //     {
	        //         /* ------------*/
	        //         /*  LINECHART  */
	        //         /* ------------*/
	        //
	        //         // register data object
	        //         $scope.main.registerVisual(
	        //         {
	        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
	        //             searchable: true, // optional search param.. no if undefined
	        //             get:
	        //             {
	        //                 call: 'linechart',
	        //                 socket: socket
	        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
	        //             grouping: ['hour', 'sub'],
	        //             hideToggleBytes: true,
	        //             type: 'linechart',
	        //             settings:
	        //             {
	        //                 use_color: true,
	        //                 type: 'bar',
	        //                 xAxis: '',
	        //                 yAxis: 'Subject Appearance / Hour'
	        //             },
	        //             searchCategories:
	        //             {
	        //                 'time': 'Time',
	        //                 'sub': 'Subject',
	        //             },
	        //             dimension: function(cfObj)
	        //             {
	        //                 return cfObj.dimension(function(d)
	        //                 {
	        //                     d.hour = Number(d.hour * 1000);
	        //
	        //                     return d.hour;
	        //                 });
	        //             },
	        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
	        //             {
	        //                 return dimension.group().reduce(
	        //                     function(p, v)
	        //                     {
	        //                         if (obj.hasOwnProperty(v.top_server))
	        //                             p[v.top_server] += v.count;
	        //
	        //                         else
	        //                             p['Other'] += v.count;
	        //
	        //                         return p;
	        //                     },
	        //                     function(p, v)
	        //                     {
	        //                         if (obj.hasOwnProperty(v.top_server))
	        //                             p[v.top_server] -= v.count;
	        //
	        //                         else
	        //                             p['Other'] -= v.count;
	        //
	        //                         return p;
	        //                     },
	        //                     function()
	        //                     {
	        //                         return angular.copy(obj);
	        //                     }
	        //                 );
	        //             },
	        //         })
	        //         // fetch the data when the object is registered
	        //         .then(function(result)
	        //         {
	        //             model.lineChartIdentifiers = { id: result.id, key: result.key };
	        //             // set dimension & group
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	        //             // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //         })
	        //         .then(function(result)
	        //         {
	        //             // stop spinner on complete
	        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
	        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	        //         },
	        //         function(err)
	        //         {
	        //
	        //         },
	        //         function(result)
	        //         {
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	        //
	        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
	        //             {
	        //                 $scope.$broadcast('init', model.lineChartIdentifiers);
	        //                 // stop spinner on inital data
	        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	        //             }
	        //
	        //             else
	        //                 $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	        //         });
	        //
	        //         callback(null, 'two');
	        //     }
	        // },
	        // function(err, results)
	        // {
	        //     // results is now equal to: {one: 1, two: 2}
	        // });
	
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'duration'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Duration (seconds)',
	                select: 'duration',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Origin Hostname',
	                select: 'orig_hostname',
	                dView: true
	            }, {
	                title: 'Origin User',
	                select: 'orig_user',
	                dView: true
	            }, {
	                title: 'Origin ASN Name',
	                select: 'orig_asn_name',
	                dView: true
	            }, {
	                title: 'Origin Country',
	                select: 'orig_country',
	                dView: true
	            }, {
	                title: 'Origin Packets',
	                select: 'packets_orig',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Responder Hostname',
	                select: 'resp_hostname',
	                dView: true
	            }, {
	                title: 'Responder User',
	                select: 'resp_user',
	                dView: true
	            }, {
	                title: 'Responder ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Responder Packets',
	                select: 'packets_resp',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: true,
	                editTable: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'duration': 'Duration',
	                'orig_ip': 'Origin IP',
	                'orig_port': 'Origin Port',
	                'orig_hostname': 'Origin Hostname',
	                'orig_user': 'Origin User',
	                'orig_asn_name': 'Origin ASN Name',
	                'orig_country': 'Origin Country',
	                'packets_orig': 'Origin Packets',
	                'resp_ip': 'Responder IP',
	                'resp_port': 'Responder Port',
	                'resp_hostname': 'Responder Hostname',
	                'resp_user': 'Responder User',
	                'resp_asn_name': 'Responder ASN Name',
	                'resp_country': 'Responder Country',
	                'packets_resp': 'Responder Packets',
	                'proto': 'Protocol',
	                'vector': 'Vector'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService', '$http'];
	module.exports = ctrl;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService, $http) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/dns_exfil_subdomains').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ["domain"],
	            sort: {
	                direction: '-',
	                col: 'subdomain_total'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            },
	            // {
	            //     title: 'Subdomain List',
	            //     select: 'subdomain_list',
	            //     dView: true
	            // },
	            {
	                title: 'Top Level Domain',
	                select: 'domain',
	                dView: true
	            }, {
	                title: 'Unique Subdomains',
	                select: 'subdomain_total',
	                dView: true
	            }, {
	                title: 'Total Queries',
	                select: 'subdomain_queries',
	                dView: true
	            }, {
	                title: 'Ratio (Unique/Total)',
	                select: 'subdomain_breakdown',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'domain': 'Top Level Domain'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService', '$http'];
	module.exports = ctrl;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/dns_poisoning').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	        // Time,
	        // id.resp_p | id.orig_h | id.orig_p
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['orig_ip'],
	            sort: {
	                direction: '-',
	                col: 'time'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true /*,
	                            {
	                               title: 'Origin Port',
	                               select: 'orig_port',
	                               dView: true
	                            },
	                            {
	                               title: 'Total Duplicates',
	                               select: 'duplicates_total',
	                               dView: true
	                            }*/
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'orig_ip': 'Origin IP',
	                'orig_port': 'Origin Port'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/user_agents').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['user_agent'],
	            sort: {
	                direction: '-',
	                col: 'time'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'User Agent',
	                select: 'user_agent',
	                dView: true
	            }],
	            searchCategories: {
	                'msg': 'Time',
	                'user_agent': 'User Agent'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/dns_tunnel_iodine_1').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'time'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Responder ASN',
	                select: 'resp_asn',
	                dView: true
	            }, {
	                title: 'Responder ASN Name',
	                select: 'resp_asn_name',
	                dView: true
	            }, {
	                title: 'Responder Country',
	                select: 'resp_country',
	                dView: true
	            }, {
	                title: 'Flag',
	                select: 'resp_cc',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Protocol',
	                select: 'proto',
	                dView: true
	            }, {
	                title: 'Query Type Name',
	                select: 'qtype_name',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'orig_ip': 'Origin IP',
	                'orig_port': 'Origin Port',
	                'resp_ip': 'Responder IP',
	                'resp_port': 'Responder Port',
	                'resp_asn': 'Responder ASN',
	                'resp_asn_name': 'Responder ASN Name',
	                'resp_country': 'Responder Country',
	                'qtype_name': 'Query Type Name',
	                'proto': 'Protocol',
	                'vector': 'Vector'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/dns_tunnel_iodine_2').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['domain'],
	            sort: {
	                direction: '-',
	                col: 'entries'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Domain',
	                select: 'domain',
	                dView: true
	            }, {
	                title: 'Total',
	                select: 'entries',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'domain': 'Domain'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/ssl_certs').then(function (socket) {
	        // async.series(
	        // { // Pie chart has to run before the line chart so it can group the 'top 10' categories
	        //     one: function(callback)
	        //     {
	        //         /* -----------*/
	        //         /*  PIECHART  */
	        //         /* -----------*/
	        //
	        //         // register data object
	        //         $scope.main.registerVisual(
	        //         {
	        //             // key: 'crossfilter', // bound to the response, wrap entire source if undefined
	        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
	        //             searchable: true, // optional search param.. no if undefined
	        //             get: {
	        //                 call: 'piechart',
	        //                 socket: socket
	        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
	        //             grouping: ['sub'],
	        //             filter_column: 'sub',
	        //             searchCategories:
	        //             {
	        //                 'sub': 'Subject',
	        //             },
	        //             type: 'piechart',
	        //             settings:
	        //             {
	        //                 type: 'application',
	        //                 xAxis: '',
	        //                 yAxis: ''
	        //             },
	        //             dimension: function(cfObj)
	        //             {
	        //                 return cfObj.dimension(function(d)
	        //                 {
	        //                     return d.top_server;
	        //                 });
	        //             },
	        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
	        //             {
	        //                 return dimension.group().reduceSum(function(d)
	        //                 {
	        //                     return d.count;
	        //                 });
	        //             },
	        //         })
	        //         // fetch the data when the object is registered
	        //         .then(function(result)
	        //         {
	        //             model.pieChartIdentifiers = { id: result.id, key: result.key };
	        //             // initalize table with column information so it can compile the directive
	        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //         })
	        //         .then(function(result)
	        //         {
	        //             // stop spinner on complete or no data
	        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	        //
	        //             obj = {};
	        //
	        //             if ($scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //             {
	        //                 let top = $scope.main.dataObjects[model.pieChartIdentifiers.key].group.top(9);
	        //
	        //                 for (var i = 0, len = top.length; i < len; i++)
	        //                     obj[top[i].key] = 0;
	        //
	        //                 if (top.length >= 9)
	        //                     obj['Other'] = 0;
	        //
	        //                 model.setGroupObj(obj);
	        //             };
	        //
	        //             callback(null, 'one');
	        //         },
	        //         function(err)
	        //         {
	        //
	        //         },
	        //         function(result)
	        //         {
	        //             $scope.main.dataObjects[model.pieChartIdentifiers.key].cf.add(result.rows);
	        //
	        //             if (!$scope.main.dataObjects[model.pieChartIdentifiers.key].launched)
	        //             {
	        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].dimension = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.pieChartIdentifiers.key].cf);
	        //                 $scope.main.dataObjects[model.pieChartIdentifiers.key].group = $scope.main.dataObjects[model.pieChartIdentifiers.key].settings.group($scope.main.dataObjects[model.pieChartIdentifiers.key].dimension);
	        //
	        //                 $scope.$broadcast('init', model.pieChartIdentifiers);
	        //                 // stop spinner on inital data
	        //                 usSpinnerService.stop('spinner-' + model.pieChartIdentifiers.id);
	        //             }
	        //
	        //             else
	        //                 $scope.$broadcast('updatedData', model.pieChartIdentifiers.id, true);
	        //         })
	        //     },
	        //     two: function(callback)
	        //     {
	        //         /* ------------*/
	        //         /*  LINECHART  */
	        //         /* ------------*/
	        //
	        //         // register data object
	        //         $scope.main.registerVisual(
	        //         {
	        //             refresh: true, // if a number is placed here, it will overwrite the current 1min default
	        //             searchable: true, // optional search param.. no if undefined
	        //             get:
	        //             {
	        //                 call: 'linechart',
	        //                 socket: socket
	        //             }, // no get default to main url, strings will replace the default (otherwise /[from root])
	        //             grouping: ['hour', 'sub'],
	        //             hideToggleBytes: true,
	        //             type: 'linechart',
	        //             settings:
	        //             {
	        //                 use_color: true,
	        //                 type: 'bar',
	        //                 xAxis: '',
	        //                 yAxis: 'Subject Appearance / Hour'
	        //             },
	        //             searchCategories:
	        //             {
	        //                 'time': 'Time',
	        //                 'sub': 'Subject',
	        //             },
	        //             dimension: function(cfObj)
	        //             {
	        //                 return cfObj.dimension(function(d)
	        //                 {
	        //                     d.hour = Number(d.hour * 1000);
	        //
	        //                     return d.hour;
	        //                 });
	        //             },
	        //             group: function(dimension) // groups are optional and should default to a reduce if undefined
	        //             {
	        //                 return dimension.group().reduce(
	        //                     function(p, v)
	        //                     {
	        //                         if (obj.hasOwnProperty(v.top_server))
	        //                             p[v.top_server] += v.count;
	        //
	        //                         else
	        //                             p['Other'] += v.count;
	        //
	        //                         return p;
	        //                     },
	        //                     function(p, v)
	        //                     {
	        //                         if (obj.hasOwnProperty(v.top_server))
	        //                             p[v.top_server] -= v.count;
	        //
	        //                         else
	        //                             p['Other'] -= v.count;
	        //
	        //                         return p;
	        //                     },
	        //                     function()
	        //                     {
	        //                         return angular.copy(obj);
	        //                     }
	        //                 );
	        //             },
	        //         })
	        //         // fetch the data when the object is registered
	        //         .then(function(result)
	        //         {
	        //             model.lineChartIdentifiers = { id: result.id, key: result.key };
	        //             // set dimension & group
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	        //             // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //             return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        //         })
	        //         .then(function(result)
	        //         {
	        //             // stop spinner on complete
	        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
	        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	        //         },
	        //         function(err)
	        //         {
	        //
	        //         },
	        //         function(result)
	        //         {
	        //             $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	        //
	        //             if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched)
	        //             {
	        //                 $scope.$broadcast('init', model.lineChartIdentifiers);
	        //                 // stop spinner on inital data
	        //                 usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	        //             }
	        //
	        //             else
	        //                 $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	        //         });
	        //
	        //         callback(null, 'two');
	        //     }
	        // },
	        // function(err, results)
	        // {
	        //     // results is now equal to: {one: 1, two: 2}
	        // });
	
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'vector'
	            },
	            title: '    Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Fail due',
	                select: 'msg',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: true,
	                editTable: true
	            }],
	            searchCategories: {
	                'msg': 'Fail due',
	                'orig_ip': 'Origin IP',
	                'vector': 'Vector'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/long_duration_conns').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'duration'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Duration (seconds)',
	                select: 'duration',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Origin Port',
	                select: 'orig_port',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Vector',
	                select: 'vector',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'orig_ip': 'Origin IP',
	                'orig_port': 'Origin Port',
	                'resp_ip': 'Responder IP',
	                'resp_port': 'Responder  Port',
	                'vector': 'Vector'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/large_http_responses').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: false,
	            grouping: ['id'],
	            sort: {
	                direction: '-',
	                col: 'resp_bytes'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Payload',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'resp_ip': 'Responder IP',
	                'resp_bytes': 'Responder Payload'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/non_standard_http').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['resp_ip'],
	            sort: {
	                direction: '-',
	                col: 'time'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Time',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Responder IP',
	                select: 'resp_ip',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Time',
	                'resp_ip': 'Responder IP',
	                'resp_port': 'Responder Port'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/services_breakdown').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['service'],
	            sort: {
	                direction: '-',
	                col: 'entries'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Service',
	                select: 'service',
	                dView: true
	            }, {
	                title: 'Total',
	                select: 'entries',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'service': 'Service'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 776 */
768,
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/top_responder_ports').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['resp_port'],
	            sort: {
	                direction: '-',
	                col: 'entries'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Responder Port',
	                select: 'resp_port',
	                dView: true
	            }, {
	                title: 'Total',
	                select: 'entries',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'resp_port': 'Responder Port'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/top_internal_producers').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            searchable: true, // Optional search param... no if undefined.
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['orig_ip'],
	            sort: {
	                direction: '-',
	                col: 'bytes_resp'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Origin IP',
	                select: 'orig_ip',
	                dView: true
	            }, {
	                title: 'Total (KB)',
	                select: 'bytes_resp',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'orig_ip': 'Origin IP',
	                'bytes_resp': 'Total (KB)'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/top_referred_hosts').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['host'],
	            sort: {
	                direction: '-',
	                col: 'entries'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Host',
	                select: 'host',
	                dView: true
	            }, {
	                title: 'Total',
	                select: 'entries',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'host': 'Host'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, Global, timeFormat, fetchStream, socketIo, settings, usSpinnerService) {
	    var async = __webpack_require__(681);
	    var model = this;
	
	    $scope.global = Global;
	    model.settings = settings;
	    model.color = d3.scale.category10();
	
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.pieChartIdentifiers = { key: false, id: false };
	    model.tableIdentifiers = { key: false, id: false };
	
	    var obj = {};
	
	    socketIo('/api/hunting/most_popular_sites').then(function (socket) {
	        /* --------*/
	        /*  TABLE  */
	        /* --------*/
	
	        // Register data object.
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
	            searchable: true, // Optional search param... no if undefined.
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            hideToggleBytes: true,
	            grouping: ['host'],
	            sort: {
	                direction: '-',
	                col: 'entries'
	            },
	            title: 'Events',
	            columns: [{
	                title: 'Last Seen',
	                select: 'time',
	                dView: true
	            }, {
	                title: 'Site',
	                select: 'host',
	                dView: true
	            }, {
	                title: 'Total',
	                select: 'entries',
	                dView: true
	            }],
	            searchCategories: {
	                'time': 'Last Seen',
	                'host': 'Site'
	            }
	        }).then(function (result) // Fetch the data when the object is registered.
	        {
	            model.tableIdentifiers = { id: result.id, key: result.key };
	            // Initialize table with column information so it can compile the directive.
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	
	            var time = angular.copy($scope.main.getTime());
	
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // Return promise to build dimensions and groups for table.
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        }).then(function (result) {
	            model.complete = true;
	            // Stop the table spinner as soon as the resolve comes in.
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            // Nothing to do here.
	        }, function (result) {
	            // Add rows.
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // With our first data return, we can build dimensions and groups for our data.
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // Don't start the spinner if the table loads faster than building group dim.
	                    // Start table spinner right before init, but after build.
	                    if (!model.complete) usSpinnerService.spin(model.tableIdentifiers.id);
	                    // Initialize rows.
	                    $scope.$broadcast('init', model.tableIdentifiers);
	
	                    if (result.min) model.loadStart = result.min;
	                }, function (err) {
	                    console.log('error');
	                    console.log(err);
	                });
	            } else {
	                if (result.min) model.loadStart = result.min;
	
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;

/***/ },
/* 781 */
768,
/* 782 */
768,
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	// import { ctrl as outbound_ioc } from "./outbound_ioc";
	"use strict";
	module.exports = function (ngModule) {
	    ngModule.controller('hybridAlertsSummary', __webpack_require__(784));
	    ngModule.controller('hybridAlertsNtaDetails', __webpack_require__(785));
	    ngModule.controller('hybridAlertsUebaDetails', __webpack_require__(786));
	};


/***/ },
/* 784 */
/***/ function(module, exports) {

	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.rowChartIdentifiers = { key: false, id: false };
	    model.geoChartIdentifiers = { key: false, id: false };
	    model.sevLevIdentifiers = { key: false, id: false };
	    model.tableIdentifiers =
	        { key: false, id: false };
	    socketIo('/api/hybrid_alerts/summary').then(function (socket) {
	        /////////////////
	        /// LINECHART ///
	        /////////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true,
	            searchable: true,
	            get: {
	                call: 'linechart',
	                socket: socket
	            },
	            grouping: ['hour'],
	            type: 'linechart',
	            settings: {
	                type: 'severity',
	                xAxis: '',
	                yAxis: '# Alerts / Hour'
	            },
	            searchCategories: {
	                'time': 'Time',
	            },
	            dimension: function (cfObj) {
	                return cfObj.dimension(function (d) {
	                    if (d.hour !== 0) {
	                        d.hour = d.hour * 1000;
	                        return d.hour;
	                    }
	                });
	            },
	            group: function (dimension) {
	                return dimension.group().reduce(function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high += v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe += v.ioc_count;
	                    }
	                    return p;
	                }, function (p, v) {
	                    if (v.ioc_severity === 1) {
	                        p.guarded -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 2) {
	                        p.elevated -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 3) {
	                        p.high -= v.ioc_count;
	                    }
	                    if (v.ioc_severity === 4) {
	                        p.severe -= v.ioc_count;
	                    }
	                    return p;
	                }, function () {
	                    return {
	                        severe: 0,
	                        high: 0,
	                        elevated: 0,
	                        guarded: 0
	                    };
	                });
	            },
	        })
	            .then(function (result) {
	            model.lineChartIdentifiers = {
	                id: result.id,
	                key: result.key
	            };
	            // set dimension & group
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].dimension = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.dimension($scope.main.dataObjects[model.lineChartIdentifiers.key].cf);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].group = $scope.main.dataObjects[model.lineChartIdentifiers.key].settings.group($scope.main.dataObjects[model.lineChartIdentifiers.key].dimension);
	            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	            .then(function (result) {
	            // stop spinner on complete
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	        }, function (err) {
	            console.log('chart error', err);
	        }, function (result) {
	            //console.log('chart result', result);
	            $scope.main.dataObjects[model.lineChartIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.lineChartIdentifiers.key].launched) {
	                $scope.$broadcast('init', model.lineChartIdentifiers);
	                // stop spinner on inital data
	                usSpinnerService.stop('spinner-' + model.lineChartIdentifiers.id);
	            }
	            else {
	                $scope.$broadcast('updatedData', model.lineChartIdentifiers.id, true);
	            }
	        });
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true,
	            searchable: true,
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['time', 'ipv4'],
	            sort: { direction: "-", col: "ipv4" },
	            title: 'Alerts',
	            columns: [
	                { title: 'IPv4', select: 'ipv4', dView: true },
	                { title: 'Total', select: 'total', dView: true },
	                { title: 'NTA', select: 'nta', dView: true,
	                    link: {
	                        type: 'hybrid_alerts/nta_details',
	                        val: ['ipv4'],
	                        crumb: false
	                    },
	                },
	                { title: 'UEBA', select: 'ueba', dView: true,
	                    link: {
	                        type: 'hybrid_alerts/ueba_details',
	                        val: ['ipv4'],
	                        crumb: false
	                    },
	                },
	            ],
	            searchCategories: {}
	        })
	            .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	            };
	            // initalize table with column information so it can compile the directive
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	            .then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            console.log('table error', err);
	        }, function (result) {
	            //console.log('table result', result.rows)
	            // add rows
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error', err);
	                });
	            }
	            else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	;
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;


/***/ },
/* 785 */
/***/ function(module, exports) {

	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.rowChartIdentifiers = { key: false, id: false };
	    model.geoChartIdentifiers = { key: false, id: false };
	    model.sevLevIdentifiers = { key: false, id: false };
	    model.tableIdentifiers =
	        { key: false, id: false };
	    socketIo('/api/hybrid_alerts/nta_details').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true,
	            searchable: true,
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['id'],
	            sort: { direction: "-orig", col: "time" },
	            title: 'NTA Details',
	            columns: [
	                { title: 'Date', select: 'time', dView: true },
	                { title: 'Source', select: 'orig', dView: true },
	                { title: 'Destination', select: 'resp', dView: true },
	                { title: 'File UID', select: 'fuid', dView: false },
	                { title: 'File MIME Type', select: 'file_mime_type', dView: false },
	                { title: 'File description', select: 'file_desc', dView: false },
	                { title: 'Protocol', select: 'proto', dView: true },
	                { title: 'Note', select: 'note', dView: true },
	                { title: 'Message', select: 'msg', dView: false },
	                { title: 'sub', select: 'sub', dView: false },
	                { title: 'src', select: 'src', dView: false },
	                { title: 'dst', select: 'dst', dView: false },
	                { title: 'p', select: 'p', dView: false },
	                { title: 'n', select: 'n', dView: false },
	                { title: 'peer_descr', select: 'peer_descr', dView: true },
	                { title: 'Actions', select: 'actions', dView: true },
	                { title: 'suppress_for', select: 'suppress_for', dView: false },
	                { title: 'remote_location_country_code', select: 'remote_location_country_code', dView: false },
	                { title: 'remote_location_region', select: 'remote_location_region', dView: false },
	                { title: 'remote_location_city', select: 'remote_location_city', dView: false },
	                { title: 'remote_location_latitude', select: 'remote_location_latitude', dView: false },
	                { title: 'remote_location_longitude', select: 'remote_location_longitude', dView: false },
	            ],
	            searchCategories: {}
	        })
	            .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	            };
	            // initalize table with column information so it can compile the directive
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	            .then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            console.log('table error', err);
	        }, function (result) {
	            console.log('table result', result.rows);
	            // add rows
	            console.log($scope.main.dataObjects[model.tableIdentifiers.key]);
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error', err);
	                });
	            }
	            else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	;
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;


/***/ },
/* 786 */
/***/ function(module, exports) {

	function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
	    var model = this;
	    $scope.global = Global;
	    model.settings = settings;
	    model.lineChartIdentifiers = { key: false, id: false };
	    model.rowChartIdentifiers = { key: false, id: false };
	    model.geoChartIdentifiers = { key: false, id: false };
	    model.sevLevIdentifiers = { key: false, id: false };
	    model.tableIdentifiers =
	        { key: false, id: false };
	    socketIo('/api/hybrid_alerts/ueba_details').then(function (socket) {
	        /////////////
	        /// TABLE ///
	        /////////////
	        // register data object
	        $scope.main.registerVisual({
	            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
	            refresh: true,
	            searchable: true,
	            get: {
	                call: 'table',
	                socket: socket
	            },
	            grouping: ['id'],
	            sort: { direction: "-", col: "time" },
	            title: 'UEBA Details',
	            columns: [
	                { title: 'Date', select: 'time', dView: true },
	                { title: 'IPv4', select: 'ipv4', dView: true },
	                { title: 'MAC Address', select: 'mac', dView: true },
	                { title: 'Hostname', select: 'hostname', dView: true },
	                { title: 'OS name', select: 'os_name', dView: false },
	                { title: 'OS version', select: 'os_version', dView: false },
	                { title: 'OS build', select: 'os_build', dView: false },
	                { title: 'Platform', select: 'platform', dView: false },
	                { title: 'MITRE name', select: 'mitre_name', dView: true },
	                { title: 'MITRE technique', select: 'mitre_tech', dView: true },
	                { title: 'MITRE subtechnique', select: 'mitre_subtech', dView: true },
	                { title: 'MITRE tactic', select: 'mitre_tactic', dView: true },
	                { title: 'MITRE info', select: 'mitre_info', dView: true },
	                { title: 'events', select: 'events', dView: false },
	            ],
	            searchCategories: {}
	        })
	            .then(function (result) {
	            model.tableIdentifiers = {
	                id: result.id,
	                key: result.key
	            };
	            // initalize table with column information so it can compile the directive
	            $scope.$broadcast('table-build', model.tableIdentifiers);
	            var time = angular.copy($scope.main.getTime());
	            model.loadStart = time.end;
	            model.loadEnd = time.end;
	            // return promise to build dimensions and groups for table
	            return new fetchStream(result.settings.get.call, result.settings.get.socket);
	        })
	            .then(function (result) {
	            model.complete = true;
	            // stop the table spinner as soon as the resolve comes in
	            usSpinnerService.stop(model.tableIdentifiers.id);
	        }, function (err) {
	            console.log('table error', err);
	        }, function (result) {
	            console.log('table result', result.rows);
	            // add rows
	            console.log($scope.main.dataObjects[model.tableIdentifiers.key]);
	            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
	            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
	                // with our first data return, we can build dimensions and groups for our data
	                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
	                    // dont start the spinner if the table loads faster than building group dim
	                    if (!model.complete) {
	                        // start table spinner right before init, but after build
	                        usSpinnerService.spin(model.tableIdentifiers.id);
	                    }
	                    // initalize rows
	                    $scope.$broadcast('init', model.tableIdentifiers);
	                    if (result.min) {
	                        model.loadStart = result.min;
	                    }
	                }, function (err) {
	                    console.log('error', err);
	                });
	            }
	            else {
	                if (result.min) {
	                    model.loadStart = result.min;
	                }
	                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
	            }
	        });
	        $scope.$on('$destroy', function () {
	            socket.disconnect();
	        });
	    });
	}
	;
	ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
	module.exports = ctrl;


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    __webpack_require__(788)(ngModule);
	    __webpack_require__(790)(ngModule);
	};

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.filter('orderObjectBy', __webpack_require__(789));
	};

/***/ },
/* 789 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
	    return function (items, field, reverse) {
	        var filtered = [];
	        angular.forEach(items, function (item) {
	            filtered.push(item);
	        });
	        filtered.sort(function (a, b) {
	            return a[field] > b[field] ? 1 : -1;
	        });
	        if (reverse) filtered.reverse();
	        return filtered;
	    };
	};

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.filter('makeRange', __webpack_require__(791));
	};

/***/ },
/* 791 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function () {
	    return function (input) {
	        var lowBound, highBound;
	        switch (input.length) {
	            case 1:
	                lowBound = 0;
	                highBound = parseInt(input[0]) - 1;
	                break;
	            case 2:
	                lowBound = parseInt(input[0]);
	                highBound = parseInt(input[1]);
	                break;
	            default:
	                return input;
	        }
	        var result = [];
	        for (var i = lowBound; i <= highBound; i++) {
	            result.push(i);
	        }return result;
	    };
	};

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    __webpack_require__(793)(ngModule);
	    __webpack_require__(796)(ngModule);
	    __webpack_require__(798)(ngModule);
	    // require('./chordchart')(ngModule);
	    __webpack_require__(800)(ngModule);
	    __webpack_require__(802)(ngModule);
	    __webpack_require__(804)(ngModule);
	    __webpack_require__(807)(ngModule);
	    __webpack_require__(809)(ngModule); // import dc
	    __webpack_require__(815)(ngModule);
	    __webpack_require__(817)(ngModule);
	    __webpack_require__(826)(ngModule);
	    __webpack_require__(828)(ngModule);
	    __webpack_require__(830)(ngModule);
	    __webpack_require__(833)(ngModule);
	    __webpack_require__(835)(ngModule);
	    __webpack_require__(837)(ngModule);
	    __webpack_require__(839)(ngModule);
	    __webpack_require__(841)(ngModule); // import dc
	    __webpack_require__(843)(ngModule);
	    __webpack_require__(846)(ngModule);
	    __webpack_require__(848)(ngModule);
	    __webpack_require__(851)(ngModule);
	    __webpack_require__(853)(ngModule);
	    __webpack_require__(856)(ngModule);
	    __webpack_require__(858)(ngModule);
	    __webpack_require__(862)(ngModule);
	    __webpack_require__(864)(ngModule);
	};

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('qrCode', __webpack_require__(794));
	};

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function directive(Global, $compile) {
	    return {
	        transclude: true,
	        template: '<div class="qr-inner"></div>',
	        link: function link($scope, element, attr) {
	            // import renderer
	            var qr = __webpack_require__(795);
	            attr.$observe('code', function (value) {
	                // create a new instance just in case the plugin keeps state
	                var q = Object.create(qr);
	                // do nothing if code attrib not defined
	                if (!attr.hasOwnProperty('code')) {
	                    return;
	                }
	                // do nothing if code is empty
	                if (attr.code === '') {
	                    return;
	                }
	                // clear existing html data
	                element.html('');
	                // append new html data
	                element.append($compile(q.generateHTML(value, { modulesize: 4 }))($scope));
	            });
	        }
	    };
	}
	
	directive.$inject = ['Global', '$compile'];
	module.exports = directive;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* qr.js -- QR code generator in Javascript (revision 2011-01-19)
	 * Written by Kang Seonghoon <public+qrjs@mearie.org>.
	 *
	 * This source code is in the public domain; if your jurisdiction does not
	 * recognize the public domain the terms of Creative Commons CC0 license
	 * apply. In the other words, you can always do what you want.
	 */
	(function (root, name, definition) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	        module.exports = definition();
	    } else {
	        root[name] = definition();
	    }
	})(undefined, 'QRCode', function () {
	    /* Quick overview: QR code composed of 2D array of modules (a rectangular
	     * area that conveys one bit of information); some modules are fixed to help
	     * the recognition of the code, and remaining data modules are further divided
	     * into 8-bit code words which are augumented by Reed-Solomon error correcting
	     * codes (ECC). There could be multiple ECCs, in the case the code is so large
	     * that it is helpful to split the raw data into several chunks.
	     *
	     * The number of modules is determined by the code's "version", ranging from 1
	     * (21x21) to 40 (177x177). How many ECC bits are used is determined by the
	     * ECC level (L/M/Q/H). The number and size (and thus the order of generator
	     * polynomial) of ECCs depend to the version and ECC level.
	     */
	
	    // per-version information (cf. JIS X 0510:2004 pp. 30--36, 71)
	    //
	    // [0]: the degree of generator polynomial by ECC levels
	    // [1]: # of code blocks by ECC levels
	    // [2]: left-top positions of alignment patterns
	    //
	    // the number in this table (in particular, [0]) does not exactly match with
	    // the numbers in the specficiation. see augumenteccs below for the reason.
	    var VERSIONS = [null, [[10, 7, 17, 13], [1, 1, 1, 1], []], [[16, 10, 28, 22], [1, 1, 1, 1], [4, 16]], [[26, 15, 22, 18], [1, 1, 2, 2], [4, 20]], [[18, 20, 16, 26], [2, 1, 4, 2], [4, 24]], [[24, 26, 22, 18], [2, 1, 4, 4], [4, 28]], [[16, 18, 28, 24], [4, 2, 4, 4], [4, 32]], [[18, 20, 26, 18], [4, 2, 5, 6], [4, 20, 36]], [[22, 24, 26, 22], [4, 2, 6, 6], [4, 22, 40]], [[22, 30, 24, 20], [5, 2, 8, 8], [4, 24, 44]], [[26, 18, 28, 24], [5, 4, 8, 8], [4, 26, 48]], [[30, 20, 24, 28], [5, 4, 11, 8], [4, 28, 52]], [[22, 24, 28, 26], [8, 4, 11, 10], [4, 30, 56]], [[22, 26, 22, 24], [9, 4, 16, 12], [4, 32, 60]], [[24, 30, 24, 20], [9, 4, 16, 16], [4, 24, 44, 64]], [[24, 22, 24, 30], [10, 6, 18, 12], [4, 24, 46, 68]], [[28, 24, 30, 24], [10, 6, 16, 17], [4, 24, 48, 72]], [[28, 28, 28, 28], [11, 6, 19, 16], [4, 28, 52, 76]], [[26, 30, 28, 28], [13, 6, 21, 18], [4, 28, 54, 80]], [[26, 28, 26, 26], [14, 7, 25, 21], [4, 28, 56, 84]], [[26, 28, 28, 30], [16, 8, 25, 20], [4, 32, 60, 88]], [[26, 28, 30, 28], [17, 8, 25, 23], [4, 26, 48, 70, 92]], [[28, 28, 24, 30], [17, 9, 34, 23], [4, 24, 48, 72, 96]], [[28, 30, 30, 30], [18, 9, 30, 25], [4, 28, 52, 76, 100]], [[28, 30, 30, 30], [20, 10, 32, 27], [4, 26, 52, 78, 104]], [[28, 26, 30, 30], [21, 12, 35, 29], [4, 30, 56, 82, 108]], [[28, 28, 30, 28], [23, 12, 37, 34], [4, 28, 56, 84, 112]], [[28, 30, 30, 30], [25, 12, 40, 34], [4, 32, 60, 88, 116]], [[28, 30, 30, 30], [26, 13, 42, 35], [4, 24, 48, 72, 96, 120]], [[28, 30, 30, 30], [28, 14, 45, 38], [4, 28, 52, 76, 100, 124]], [[28, 30, 30, 30], [29, 15, 48, 40], [4, 24, 50, 76, 102, 128]], [[28, 30, 30, 30], [31, 16, 51, 43], [4, 28, 54, 80, 106, 132]], [[28, 30, 30, 30], [33, 17, 54, 45], [4, 32, 58, 84, 110, 136]], [[28, 30, 30, 30], [35, 18, 57, 48], [4, 28, 56, 84, 112, 140]], [[28, 30, 30, 30], [37, 19, 60, 51], [4, 32, 60, 88, 116, 144]], [[28, 30, 30, 30], [38, 19, 63, 53], [4, 28, 52, 76, 100, 124, 148]], [[28, 30, 30, 30], [40, 20, 66, 56], [4, 22, 48, 74, 100, 126, 152]], [[28, 30, 30, 30], [43, 21, 70, 59], [4, 26, 52, 78, 104, 130, 156]], [[28, 30, 30, 30], [45, 22, 74, 62], [4, 30, 56, 82, 108, 134, 160]], [[28, 30, 30, 30], [47, 24, 77, 65], [4, 24, 52, 80, 108, 136, 164]], [[28, 30, 30, 30], [49, 25, 81, 68], [4, 28, 56, 84, 112, 140, 168]]];
	
	    // mode constants (cf. Table 2 in JIS X 0510:2004 p. 16)
	    var MODE_TERMINATOR = 0;
	    var MODE_NUMERIC = 1,
	        MODE_ALPHANUMERIC = 2,
	        MODE_OCTET = 4,
	        MODE_KANJI = 8;
	
	    // validation regexps
	    var NUMERIC_REGEXP = /^\d*$/;
	    var ALPHANUMERIC_REGEXP = /^[A-Za-z0-9 $%*+\-./:]*$/;
	    var ALPHANUMERIC_OUT_REGEXP = /^[A-Z0-9 $%*+\-./:]*$/;
	
	    // ECC levels (cf. Table 22 in JIS X 0510:2004 p. 45)
	    var ECCLEVEL_L = 1,
	        ECCLEVEL_M = 0,
	        ECCLEVEL_Q = 3,
	        ECCLEVEL_H = 2;
	
	    // GF(2^8)-to-integer mapping with a reducing polynomial x^8+x^4+x^3+x^2+1
	    // invariant: GF256_MAP[GF256_INVMAP[i]] == i for all i in [1,256)
	    var GF256_MAP = [],
	        GF256_INVMAP = [-1];
	    for (var i = 0, v = 1; i < 255; ++i) {
	        GF256_MAP.push(v);
	        GF256_INVMAP[v] = i;
	        v = v * 2 ^ (v >= 128 ? 0x11d : 0);
	    }
	
	    // generator polynomials up to degree 30
	    // (should match with polynomials in JIS X 0510:2004 Appendix A)
	    //
	    // generator polynomial of degree K is product of (x-\alpha^0), (x-\alpha^1),
	    // ..., (x-\alpha^(K-1)). by convention, we omit the K-th coefficient (always 1)
	    // from the result; also other coefficients are written in terms of the exponent
	    // to \alpha to avoid the redundant calculation. (see also calculateecc below.)
	    var GF256_GENPOLY = [[]];
	    for (var i = 0; i < 30; ++i) {
	        var prevpoly = GF256_GENPOLY[i],
	            poly = [];
	        for (var j = 0; j <= i; ++j) {
	            var a = j < i ? GF256_MAP[prevpoly[j]] : 0;
	            var b = GF256_MAP[(i + (prevpoly[j - 1] || 0)) % 255];
	            poly.push(GF256_INVMAP[a ^ b]);
	        }
	        GF256_GENPOLY.push(poly);
	    }
	
	    // alphanumeric character mapping (cf. Table 5 in JIS X 0510:2004 p. 19)
	    var ALPHANUMERIC_MAP = {};
	    for (var i = 0; i < 45; ++i) {
	        ALPHANUMERIC_MAP['0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:'.charAt(i)] = i;
	    }
	
	    // mask functions in terms of row # and column #
	    // (cf. Table 20 in JIS X 0510:2004 p. 42)
	    var MASKFUNCS = [function (i, j) {
	        return (i + j) % 2 == 0;
	    }, function (i, j) {
	        return i % 2 == 0;
	    }, function (i, j) {
	        return j % 3 == 0;
	    }, function (i, j) {
	        return (i + j) % 3 == 0;
	    }, function (i, j) {
	        return ((i / 2 | 0) + (j / 3 | 0)) % 2 == 0;
	    }, function (i, j) {
	        return i * j % 2 + i * j % 3 == 0;
	    }, function (i, j) {
	        return (i * j % 2 + i * j % 3) % 2 == 0;
	    }, function (i, j) {
	        return ((i + j) % 2 + i * j % 3) % 2 == 0;
	    }];
	
	    // returns true when the version information has to be embeded.
	    var needsverinfo = function needsverinfo(ver) {
	        return ver > 6;
	    };
	
	    // returns the size of entire QR code for given version.
	    var getsizebyver = function getsizebyver(ver) {
	        return 4 * ver + 17;
	    };
	
	    // returns the number of bits available for code words in this version.
	    var nfullbits = function nfullbits(ver) {
	        /*
	         * |<--------------- n --------------->|
	         * |        |<----- n-17 ---->|        |
	         * +-------+                ///+-------+ ----
	         * |       |                ///|       |    ^
	         * |  9x9  |       @@@@@    ///|  9x8  |    |
	         * |       | # # # @5x5@ # # # |       |    |
	         * +-------+       @@@@@       +-------+    |
	         *       #                               ---|
	         *                                        ^ |
	         *       #                                |
	         *     @@@@@       @@@@@       @@@@@      | n
	         *     @5x5@       @5x5@       @5x5@   n-17
	         *     @@@@@       @@@@@       @@@@@      | |
	         *       #                                | |
	         * //////                                 v |
	         * //////#                               ---|
	         * +-------+       @@@@@       @@@@@        |
	         * |       |       @5x5@       @5x5@        |
	         * |  8x9  |       @@@@@       @@@@@        |
	         * |       |                                v
	         * +-------+                             ----
	         *
	         * when the entire code has n^2 modules and there are m^2-3 alignment
	         * patterns, we have:
	         * - 225 (= 9x9 + 9x8 + 8x9) modules for finder patterns and
	         *   format information;
	         * - 2n-34 (= 2(n-17)) modules for timing patterns;
	         * - 36 (= 3x6 + 6x3) modules for version information, if any;
	         * - 25m^2-75 (= (m^2-3)(5x5)) modules for alignment patterns
	         *   if any, but 10m-20 (= 2(m-2)x5) of them overlaps with
	         *   timing patterns.
	         */
	        var v = VERSIONS[ver];
	        var nbits = 16 * ver * ver + 128 * ver + 64; // finder, timing and format info.
	        if (needsverinfo(ver)) nbits -= 36; // version information
	        if (v[2].length) {
	            // alignment patterns
	            nbits -= 25 * v[2].length * v[2].length - 10 * v[2].length - 55;
	        }
	        return nbits;
	    };
	
	    // returns the number of bits available for data portions (i.e. excludes ECC
	    // bits but includes mode and length bits) in this version and ECC level.
	    var ndatabits = function ndatabits(ver, ecclevel) {
	        var nbits = nfullbits(ver) & ~7; // no sub-octet code words
	        var v = VERSIONS[ver];
	        nbits -= 8 * v[0][ecclevel] * v[1][ecclevel]; // ecc bits
	        return nbits;
	    };
	
	    // returns the number of bits required for the length of data.
	    // (cf. Table 3 in JIS X 0510:2004 p. 16)
	    var ndatalenbits = function ndatalenbits(ver, mode) {
	        switch (mode) {
	            case MODE_NUMERIC:
	                return ver < 10 ? 10 : ver < 27 ? 12 : 14;
	            case MODE_ALPHANUMERIC:
	                return ver < 10 ? 9 : ver < 27 ? 11 : 13;
	            case MODE_OCTET:
	                return ver < 10 ? 8 : 16;
	            case MODE_KANJI:
	                return ver < 10 ? 8 : ver < 27 ? 10 : 12;
	        }
	    };
	
	    // returns the maximum length of data possible in given configuration.
	    var getmaxdatalen = function getmaxdatalen(ver, mode, ecclevel) {
	        var nbits = ndatabits(ver, ecclevel) - 4 - ndatalenbits(ver, mode); // 4 for mode bits
	        switch (mode) {
	            case MODE_NUMERIC:
	                return (nbits / 10 | 0) * 3 + (nbits % 10 < 4 ? 0 : nbits % 10 < 7 ? 1 : 2);
	            case MODE_ALPHANUMERIC:
	                return (nbits / 11 | 0) * 2 + (nbits % 11 < 6 ? 0 : 1);
	            case MODE_OCTET:
	                return nbits / 8 | 0;
	            case MODE_KANJI:
	                return nbits / 13 | 0;
	        }
	    };
	
	    // checks if the given data can be encoded in given mode, and returns
	    // the converted data for the further processing if possible. otherwise
	    // returns null.
	    //
	    // this function does not check the length of data; it is a duty of
	    // encode function below (as it depends on the version and ECC level too).
	    var validatedata = function validatedata(mode, data) {
	        switch (mode) {
	            case MODE_NUMERIC:
	                if (!data.match(NUMERIC_REGEXP)) return null;
	                return data;
	
	            case MODE_ALPHANUMERIC:
	                if (!data.match(ALPHANUMERIC_REGEXP)) return null;
	                return data.toUpperCase();
	
	            case MODE_OCTET:
	                if (typeof data === 'string') {
	                    // encode as utf-8 string
	                    var newdata = [];
	                    for (var i = 0; i < data.length; ++i) {
	                        var ch = data.charCodeAt(i);
	                        if (ch < 0x80) {
	                            newdata.push(ch);
	                        } else if (ch < 0x800) {
	                            newdata.push(0xc0 | ch >> 6, 0x80 | ch & 0x3f);
	                        } else if (ch < 0x10000) {
	                            newdata.push(0xe0 | ch >> 12, 0x80 | ch >> 6 & 0x3f, 0x80 | ch & 0x3f);
	                        } else {
	                            newdata.push(0xf0 | ch >> 18, 0x80 | ch >> 12 & 0x3f, 0x80 | ch >> 6 & 0x3f, 0x80 | ch & 0x3f);
	                        }
	                    }
	                    return newdata;
	                } else {
	                    return data;
	                }
	        }
	    };
	
	    // returns the code words (sans ECC bits) for given data and configurations.
	    // requires data to be preprocessed by validatedata. no length check is
	    // performed, and everything has to be checked before calling this function.
	    var encode = function encode(ver, mode, data, maxbuflen) {
	        var buf = [];
	        var bits = 0,
	            remaining = 8;
	        var datalen = data.length;
	
	        // this function is intentionally no-op when n=0.
	        var pack = function pack(x, n) {
	            if (n >= remaining) {
	                buf.push(bits | x >> (n -= remaining));
	                while (n >= 8) {
	                    buf.push(x >> (n -= 8) & 255);
	                }bits = 0;
	                remaining = 8;
	            }
	            if (n > 0) bits |= (x & (1 << n) - 1) << (remaining -= n);
	        };
	
	        var nlenbits = ndatalenbits(ver, mode);
	        pack(mode, 4);
	        pack(datalen, nlenbits);
	
	        switch (mode) {
	            case MODE_NUMERIC:
	                for (var i = 2; i < datalen; i += 3) {
	                    pack(parseInt(data.substring(i - 2, i + 1), 10), 10);
	                }
	                pack(parseInt(data.substring(i - 2), 10), [0, 4, 7][datalen % 3]);
	                break;
	
	            case MODE_ALPHANUMERIC:
	                for (var i = 1; i < datalen; i += 2) {
	                    pack(ALPHANUMERIC_MAP[data.charAt(i - 1)] * 45 + ALPHANUMERIC_MAP[data.charAt(i)], 11);
	                }
	                if (datalen % 2 == 1) {
	                    pack(ALPHANUMERIC_MAP[data.charAt(i - 1)], 6);
	                }
	                break;
	
	            case MODE_OCTET:
	                for (var i = 0; i < datalen; ++i) {
	                    pack(data[i], 8);
	                }
	                break;
	        };
	
	        // final bits. it is possible that adding terminator causes the buffer
	        // to overflow, but then the buffer truncated to the maximum size will
	        // be valid as the truncated terminator mode bits and padding is
	        // identical in appearance (cf. JIS X 0510:2004 sec 8.4.8).
	        pack(MODE_TERMINATOR, 4);
	        if (remaining < 8) buf.push(bits);
	
	        // the padding to fill up the remaining space. we should not add any
	        // words when the overflow already occurred.
	        while (buf.length + 1 < maxbuflen) {
	            buf.push(0xec, 0x11);
	        }if (buf.length < maxbuflen) buf.push(0xec);
	        return buf;
	    };
	
	    // calculates ECC code words for given code words and generator polynomial.
	    //
	    // this is quite similar to CRC calculation as both Reed-Solomon and CRC use
	    // the certain kind of cyclic codes, which is effectively the division of
	    // zero-augumented polynomial by the generator polynomial. the only difference
	    // is that Reed-Solomon uses GF(2^8), instead of CRC's GF(2), and Reed-Solomon
	    // uses the different generator polynomial than CRC's.
	    var calculateecc = function calculateecc(poly, genpoly) {
	        var modulus = poly.slice(0);
	        var polylen = poly.length,
	            genpolylen = genpoly.length;
	        for (var i = 0; i < genpolylen; ++i) {
	            modulus.push(0);
	        }for (var i = 0; i < polylen;) {
	            var quotient = GF256_INVMAP[modulus[i++]];
	            if (quotient >= 0) {
	                for (var j = 0; j < genpolylen; ++j) {
	                    modulus[i + j] ^= GF256_MAP[(quotient + genpoly[j]) % 255];
	                }
	            }
	        }
	        return modulus.slice(polylen);
	    };
	
	    // auguments ECC code words to given code words. the resulting words are
	    // ready to be encoded in the matrix.
	    //
	    // the much of actual augumenting procedure follows JIS X 0510:2004 sec 8.7.
	    // the code is simplified using the fact that the size of each code & ECC
	    // blocks is almost same; for example, when we have 4 blocks and 46 data words
	    // the number of code words in those blocks are 11, 11, 12, 12 respectively.
	    var augumenteccs = function augumenteccs(poly, nblocks, genpoly) {
	        var subsizes = [];
	        var subsize = poly.length / nblocks | 0,
	            subsize0 = 0;
	        var pivot = nblocks - poly.length % nblocks;
	        for (var i = 0; i < pivot; ++i) {
	            subsizes.push(subsize0);
	            subsize0 += subsize;
	        }
	        for (var i = pivot; i < nblocks; ++i) {
	            subsizes.push(subsize0);
	            subsize0 += subsize + 1;
	        }
	        subsizes.push(subsize0);
	
	        var eccs = [];
	        for (var i = 0; i < nblocks; ++i) {
	            eccs.push(calculateecc(poly.slice(subsizes[i], subsizes[i + 1]), genpoly));
	        }
	
	        var result = [];
	        var nitemsperblock = poly.length / nblocks | 0;
	        for (var i = 0; i < nitemsperblock; ++i) {
	            for (var j = 0; j < nblocks; ++j) {
	                result.push(poly[subsizes[j] + i]);
	            }
	        }
	        for (var j = pivot; j < nblocks; ++j) {
	            result.push(poly[subsizes[j + 1] - 1]);
	        }
	        for (var i = 0; i < genpoly.length; ++i) {
	            for (var j = 0; j < nblocks; ++j) {
	                result.push(eccs[j][i]);
	            }
	        }
	        return result;
	    };
	
	    // auguments BCH(p+q,q) code to the polynomial over GF(2), given the proper
	    // genpoly. the both input and output are in binary numbers, and unlike
	    // calculateecc genpoly should include the 1 bit for the highest degree.
	    //
	    // actual polynomials used for this procedure are as follows:
	    // - p=10, q=5, genpoly=x^10+x^8+x^5+x^4+x^2+x+1 (JIS X 0510:2004 Appendix C)
	    // - p=18, q=6, genpoly=x^12+x^11+x^10+x^9+x^8+x^5+x^2+1 (ibid. Appendix D)
	    var augumentbch = function augumentbch(poly, p, genpoly, q) {
	        var modulus = poly << q;
	        for (var i = p - 1; i >= 0; --i) {
	            if (modulus >> q + i & 1) modulus ^= genpoly << i;
	        }
	        return poly << q | modulus;
	    };
	
	    // creates the base matrix for given version. it returns two matrices, one of
	    // them is the actual one and the another represents the "reserved" portion
	    // (e.g. finder and timing patterns) of the matrix.
	    //
	    // some entries in the matrix may be undefined, rather than 0 or 1. this is
	    // intentional (no initialization needed!), and putdata below will fill
	    // the remaining ones.
	    var makebasematrix = function makebasematrix(ver) {
	        var v = VERSIONS[ver],
	            n = getsizebyver(ver);
	        var matrix = [],
	            reserved = [];
	        for (var i = 0; i < n; ++i) {
	            matrix.push([]);
	            reserved.push([]);
	        }
	
	        var blit = function blit(y, x, h, w, bits) {
	            for (var i = 0; i < h; ++i) {
	                for (var j = 0; j < w; ++j) {
	                    matrix[y + i][x + j] = bits[i] >> j & 1;
	                    reserved[y + i][x + j] = 1;
	                }
	            }
	        };
	
	        // finder patterns and a part of timing patterns
	        // will also mark the format information area (not yet written) as reserved.
	        blit(0, 0, 9, 9, [0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x17f, 0x00, 0x40]);
	        blit(n - 8, 0, 8, 9, [0x100, 0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x7f]);
	        blit(0, n - 8, 9, 8, [0xfe, 0x82, 0xba, 0xba, 0xba, 0x82, 0xfe, 0x00, 0x00]);
	
	        // the rest of timing patterns
	        for (var i = 9; i < n - 8; ++i) {
	            matrix[6][i] = matrix[i][6] = ~i & 1;
	            reserved[6][i] = reserved[i][6] = 1;
	        }
	
	        // alignment patterns
	        var aligns = v[2],
	            m = aligns.length;
	        for (var i = 0; i < m; ++i) {
	            var minj = i == 0 || i == m - 1 ? 1 : 0,
	                maxj = i == 0 ? m - 1 : m;
	            for (var j = minj; j < maxj; ++j) {
	                blit(aligns[i], aligns[j], 5, 5, [0x1f, 0x11, 0x15, 0x11, 0x1f]);
	            }
	        }
	
	        // version information
	        if (needsverinfo(ver)) {
	            var code = augumentbch(ver, 6, 0x1f25, 12);
	            var k = 0;
	            for (var i = 0; i < 6; ++i) {
	                for (var j = 0; j < 3; ++j) {
	                    matrix[i][n - 11 + j] = matrix[n - 11 + j][i] = code >> k++ & 1;
	                    reserved[i][n - 11 + j] = reserved[n - 11 + j][i] = 1;
	                }
	            }
	        }
	
	        return {
	            matrix: matrix,
	            reserved: reserved
	        };
	    };
	
	    // fills the data portion (i.e. unmarked in reserved) of the matrix with given
	    // code words. the size of code words should be no more than available bits,
	    // and remaining bits are padded to 0 (cf. JIS X 0510:2004 sec 8.7.3).
	    var putdata = function putdata(matrix, reserved, buf) {
	        var n = matrix.length;
	        var k = 0,
	            dir = -1;
	        for (var i = n - 1; i >= 0; i -= 2) {
	            if (i == 6) --i; // skip the entire timing pattern column
	            var jj = dir < 0 ? n - 1 : 0;
	            for (var j = 0; j < n; ++j) {
	                for (var ii = i; ii > i - 2; --ii) {
	                    if (!reserved[jj][ii]) {
	                        // may overflow, but (undefined >> x)
	                        // is 0 so it will auto-pad to zero.
	                        matrix[jj][ii] = buf[k >> 3] >> (~k & 7) & 1;
	                        ++k;
	                    }
	                }
	                jj += dir;
	            }
	            dir = -dir;
	        }
	        return matrix;
	    };
	
	    // XOR-masks the data portion of the matrix. repeating the call with the same
	    // arguments will revert the prior call (convenient in the matrix evaluation).
	    var maskdata = function maskdata(matrix, reserved, mask) {
	        var maskf = MASKFUNCS[mask];
	        var n = matrix.length;
	        for (var i = 0; i < n; ++i) {
	            for (var j = 0; j < n; ++j) {
	                if (!reserved[i][j]) matrix[i][j] ^= maskf(i, j);
	            }
	        }
	        return matrix;
	    };
	
	    // puts the format information.
	    var putformatinfo = function putformatinfo(matrix, reserved, ecclevel, mask) {
	        var n = matrix.length;
	        var code = augumentbch(ecclevel << 3 | mask, 5, 0x537, 10) ^ 0x5412;
	        for (var i = 0; i < 15; ++i) {
	            var r = [0, 1, 2, 3, 4, 5, 7, 8, n - 7, n - 6, n - 5, n - 4, n - 3, n - 2, n - 1][i];
	            var c = [n - 1, n - 2, n - 3, n - 4, n - 5, n - 6, n - 7, n - 8, 7, 5, 4, 3, 2, 1, 0][i];
	            matrix[r][8] = matrix[8][c] = code >> i & 1;
	            // we don't have to mark those bits reserved; always done
	            // in makebasematrix above.
	        }
	        return matrix;
	    };
	
	    // evaluates the resulting matrix and returns the score (lower is better).
	    // (cf. JIS X 0510:2004 sec 8.8.2)
	    //
	    // the evaluation procedure tries to avoid the problematic patterns naturally
	    // occuring from the original matrix. for example, it penaltizes the patterns
	    // which just look like the finder pattern which will confuse the decoder.
	    // we choose the mask which results in the lowest score among 8 possible ones.
	    //
	    // note: zxing seems to use the same procedure and in many cases its choice
	    // agrees to ours, but sometimes it does not. practically it doesn't matter.
	    var evaluatematrix = function evaluatematrix(matrix) {
	        // N1+(k-5) points for each consecutive row of k same-colored modules,
	        // where k >= 5. no overlapping row counts.
	        var PENALTY_CONSECUTIVE = 3;
	        // N2 points for each 2x2 block of same-colored modules.
	        // overlapping block does count.
	        var PENALTY_TWOBYTWO = 3;
	        // N3 points for each pattern with >4W:1B:1W:3B:1W:1B or
	        // 1B:1W:3B:1W:1B:>4W, or their multiples (e.g. highly unlikely,
	        // but 13W:3B:3W:9B:3W:3B counts).
	        var PENALTY_FINDERLIKE = 40;
	        // N4*k points for every (5*k)% deviation from 50% black density.
	        // i.e. k=1 for 55~60% and 40~45%, k=2 for 60~65% and 35~40%, etc.
	        var PENALTY_DENSITY = 10;
	
	        var evaluategroup = function evaluategroup(groups) {
	            // assumes [W,B,W,B,W,...,B,W]
	            var score = 0;
	            for (var i = 0; i < groups.length; ++i) {
	                if (groups[i] >= 5) score += PENALTY_CONSECUTIVE + (groups[i] - 5);
	            }
	            for (var i = 5; i < groups.length; i += 2) {
	                var p = groups[i];
	                if (groups[i - 1] == p && groups[i - 2] == 3 * p && groups[i - 3] == p && groups[i - 4] == p && (groups[i - 5] >= 4 * p || groups[i + 1] >= 4 * p)) {
	                    // this part differs from zxing...
	                    score += PENALTY_FINDERLIKE;
	                }
	            }
	            return score;
	        };
	
	        var n = matrix.length;
	        var score = 0,
	            nblacks = 0;
	        for (var i = 0; i < n; ++i) {
	            var row = matrix[i];
	            var groups;
	
	            // evaluate the current row
	            groups = [0]; // the first empty group of white
	            for (var j = 0; j < n;) {
	                var k;
	                for (k = 0; j < n && row[j]; ++k) {
	                    ++j;
	                }groups.push(k);
	                for (k = 0; j < n && !row[j]; ++k) {
	                    ++j;
	                }groups.push(k);
	            }
	            score += evaluategroup(groups);
	
	            // evaluate the current column
	            groups = [0];
	            for (var j = 0; j < n;) {
	                var k;
	                for (k = 0; j < n && matrix[j][i]; ++k) {
	                    ++j;
	                }groups.push(k);
	                for (k = 0; j < n && !matrix[j][i]; ++k) {
	                    ++j;
	                }groups.push(k);
	            }
	            score += evaluategroup(groups);
	
	            // check the 2x2 box and calculate the density
	            var nextrow = matrix[i + 1] || [];
	            nblacks += row[0];
	            for (var j = 1; j < n; ++j) {
	                var p = row[j];
	                nblacks += p;
	                // at least comparison with next row should be strict...
	                if (row[j - 1] == p && nextrow[j] === p && nextrow[j - 1] === p) {
	                    score += PENALTY_TWOBYTWO;
	                }
	            }
	        }
	
	        score += PENALTY_DENSITY * (Math.abs(nblacks / n / n - 0.5) / 0.05 | 0);
	        return score;
	    };
	
	    // returns the fully encoded QR code matrix which contains given data.
	    // it also chooses the best mask automatically when mask is -1.
	    var _generate = function _generate(data, ver, mode, ecclevel, mask) {
	        var v = VERSIONS[ver];
	        var buf = encode(ver, mode, data, ndatabits(ver, ecclevel) >> 3);
	        buf = augumenteccs(buf, v[1][ecclevel], GF256_GENPOLY[v[0][ecclevel]]);
	
	        var result = makebasematrix(ver);
	        var matrix = result.matrix,
	            reserved = result.reserved;
	        putdata(matrix, reserved, buf);
	
	        if (mask < 0) {
	            // find the best mask
	            maskdata(matrix, reserved, 0);
	            putformatinfo(matrix, reserved, ecclevel, 0);
	            var bestmask = 0,
	                bestscore = evaluatematrix(matrix);
	            maskdata(matrix, reserved, 0);
	            for (mask = 1; mask < 8; ++mask) {
	                maskdata(matrix, reserved, mask);
	                putformatinfo(matrix, reserved, ecclevel, mask);
	                var score = evaluatematrix(matrix);
	                if (bestscore > score) {
	                    bestscore = score;
	                    bestmask = mask;
	                }
	                maskdata(matrix, reserved, mask);
	            }
	            mask = bestmask;
	        }
	
	        maskdata(matrix, reserved, mask);
	        putformatinfo(matrix, reserved, ecclevel, mask);
	        return matrix;
	    };
	
	    // the public interface is trivial; the options available are as follows:
	    //
	    // - version: an integer in [1,40]. when omitted (or -1) the smallest possible
	    //   version is chosen.
	    // - mode: one of 'numeric', 'alphanumeric', 'octet'. when omitted the smallest
	    //   possible mode is chosen.
	    // - ecclevel: one of 'L', 'M', 'Q', 'H'. defaults to 'L'.
	    // - mask: an integer in [0,7]. when omitted (or -1) the best mask is chosen.
	    //
	    // for generate{HTML,PNG}:
	    //
	    // - modulesize: a number. this is a size of each modules in pixels, and
	    //   defaults to 5px.
	    // - margin: a number. this is a size of margin in *modules*, and defaults to
	    //   4 (white modules). the specficiation mandates the margin no less than 4
	    //   modules, so it is better not to alter this value unless you know what
	    //   you're doing.
	    var QRCode = {
	        'generate': function generate(data, options) {
	            var MODES = { 'numeric': MODE_NUMERIC, 'alphanumeric': MODE_ALPHANUMERIC,
	                'octet': MODE_OCTET };
	            var ECCLEVELS = { 'L': ECCLEVEL_L, 'M': ECCLEVEL_M, 'Q': ECCLEVEL_Q,
	                'H': ECCLEVEL_H };
	
	            options = options || {};
	            var ver = options.version || -1;
	            var ecclevel = ECCLEVELS[(options.ecclevel || 'L').toUpperCase()];
	            var mode = options.mode ? MODES[options.mode.toLowerCase()] : -1;
	            var mask = 'mask' in options ? options.mask : -1;
	
	            if (mode < 0) {
	                if (typeof data === 'string') {
	                    if (data.match(NUMERIC_REGEXP)) {
	                        mode = MODE_NUMERIC;
	                    } else if (data.match(ALPHANUMERIC_OUT_REGEXP)) {
	                        // while encode supports case-insensitive
	                        // encoding, we restrict the data to be
	                        // uppercased when auto-selecting the mode.
	                        mode = MODE_ALPHANUMERIC;
	                    } else {
	                        mode = MODE_OCTET;
	                    }
	                } else {
	                    mode = MODE_OCTET;
	                }
	            } else if (!(mode == MODE_NUMERIC || mode == MODE_ALPHANUMERIC || mode == MODE_OCTET)) {
	                throw 'invalid or unsupported mode';
	            }
	
	            data = validatedata(mode, data);
	            if (data === null) throw 'invalid data format';
	
	            if (ecclevel < 0 || ecclevel > 3) throw 'invalid ECC level';
	
	            if (ver < 0) {
	                for (ver = 1; ver <= 40; ++ver) {
	                    if (data.length <= getmaxdatalen(ver, mode, ecclevel)) break;
	                }
	                if (ver > 40) throw 'too large data';
	            } else if (ver < 1 || ver > 40) {
	                throw 'invalid version';
	            }
	
	            if (mask != -1 && (mask < 0 || mask > 8)) throw 'invalid mask';
	
	            return _generate(data, ver, mode, ecclevel, mask);
	        },
	
	        'generateHTML': function generateHTML(data, options) {
	            options = options || {};
	            var matrix = QRCode['generate'](data, options);
	            var modsize = Math.max(options.modulesize || 5, 0.5);
	            var margin = Math.max(options.margin !== null ? options.margin : 4, 0.0);
	
	            var e = document.createElement('div');
	            var n = matrix.length;
	            var html = ['<table border="0" cellspacing="0" cellpadding="0" style="border:' + modsize * margin + 'px solid #fff;background:#fff">'];
	            for (var i = 0; i < n; ++i) {
	                html.push('<tr>');
	                for (var j = 0; j < n; ++j) {
	                    html.push('<td style="width:' + modsize + 'px;height:' + modsize + 'px' + (matrix[i][j] ? ';background:#000' : '') + '"></td>');
	                }
	                html.push('</tr>');
	            }
	            e.className = 'qrcode';
	            e.innerHTML = html.join('') + '</table>';
	            return e;
	        },
	
	        'generateSVG': function generateSVG(data, options) {
	            options = options || {};
	            var matrix = QRCode['generate'](data, options);
	            var n = matrix.length;
	            var modsize = Math.max(options.modulesize || 5, 0.5);
	            var margin = Math.max(options.margin ? options.margin : 4, 0.0);
	            var size = modsize * (n + 2 * margin);
	
	            var common = ' class= "fg"' + ' width="' + modsize + '" height="' + modsize + '"/>';
	
	            var e = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	            e.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
	            e.setAttribute('style', 'shape-rendering:crispEdges');
	
	            var svg = ['<style scoped>.bg{fill:#FFF}.fg{fill:#000}</style>', '<rect class="bg" x="0" y="0"', 'width="' + size + '" height="' + size + '"/>'];
	
	            var yo = margin * modsize;
	            for (var y = 0; y < n; ++y) {
	                var xo = margin * modsize;
	                for (var x = 0; x < n; ++x) {
	                    if (matrix[y][x]) svg.push('<rect x="' + xo + '" y="' + yo + '"', common);
	                    xo += modsize;
	                }
	                yo += modsize;
	            }
	            e.innerHTML = svg.join('');
	            return e;
	        },
	
	        'generatePNG': function generatePNG(data, options) {
	            options = options || {};
	            var matrix = QRCode['generate'](data, options);
	            var modsize = Math.max(options.modulesize || 5, 0.5);
	            var margin = Math.max(options.margin !== null ? options.margin : 4, 0.0);
	            var n = matrix.length;
	            var size = modsize * (n + 2 * margin);
	
	            var canvas = document.createElement('canvas'),
	                context;
	            canvas.width = canvas.height = size;
	            context = canvas.getContext('2d');
	            if (!context) throw 'canvas support is needed for PNG output';
	
	            context.fillStyle = '#fff';
	            context.fillRect(0, 0, size, size);
	            context.fillStyle = '#000';
	            for (var i = 0; i < n; ++i) {
	                for (var j = 0; j < n; ++j) {
	                    if (matrix[i][j]) {
	                        context.fillRect(modsize * (margin + j), modsize * (margin + i), modsize, modsize);
	                    }
	                }
	            }
	            return canvas.toDataURL();
	        }
	    };
	
	    return QRCode;
	});

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('alertMessage', __webpack_require__(797));
	};

/***/ },
/* 797 */
/***/ function(module, exports) {

	'use strict';
	
	function directive(Global) {
	    return {
	        transclude: false,
	        link: function link($scope, element) {}
	    };
	}
	
	directive.$inject = ['Global'];
	module.exports = directive;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('appReplace', __webpack_require__(799));
	};

/***/ },
/* 799 */
/***/ function(module, exports) {

	'use strict';
	
	function directive() {
	    return {
	        link: function link($scope, element, attrs) {
	            var app = attrs.name.toLowerCase();
	
	            var elm = d3.select(element[0]).append('svg').attr('x', 0).attr('y', 0).attr('width', '42.795px').attr('height', '42.795px').attr('viewBox', '0 0 42.795 42.795').attr('enable-background', 'new 0 0 42.795 42.795').attr('xml:space', 'preserve');
	
	            var tip = d3Tip().attr('class', 'hoverRules').offset([35, -(app.length * 2.5 + 45)]).html(function (d) {
	                d3.selectAll(".hoverRules").style("opacity", "0");
	                return app;
	            });
	
	            var em = elm.append('g');
	            var bg = em.append('circle').attr('cx', 21.398).attr('cy', 21.398).attr('r', 21.398);
	            var em2 = elm.append('g');
	            var bg2 = em2.append('circle').attr('cx', 21.398).attr('cy', 21.398).attr('r', 21.398).attr('fill', 'transparent');
	            bg2.call(tip);
	            bg2.on('mouseover', tip.show).on('mouseout', tip.hide);
	
	            bg.style('fill', '#dddddd');
	            em.append('path').style('fill', '#c2c2c2').attr('d', 'M21.378,42.795c10.232,0,18.773-7.187,20.884-16.785h-0.793v-1.613h-1.748v5.251h-1.746v-2.003h-1.748v4.3' + 'h-1.746v1.411h-1.748v-1.411h-1.746v4.371h-1.748v-1.589h-1.746v-4.411h-1.748v1.7h-1.746v-3.997h-1.748v2.749h-1.747v3.613h-1.747' + 'v1.297H17.01v4.612h-1.747V37.04h-1.747v-3.996h-1.747v-1.301h-1.747v4.781H8.274v-2.702H6.527v-3.388H4.78v-3.489H3.033v1.411' + 'H1.286V28.7C4.274,36.917,12.129,42.795,21.378,42.795z');
	            // switch between text
	            switch (app) {
	                case 'http':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 8 22)').style('fill', '#f2bc5d').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('http');
	                    return;
	                case 'http_connect':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 8 22)').style('fill', '#f2bc5d').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('http');
	                    return;
	                case 'ssl':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 11 22)').style('fill', '#D97373').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('SSL');
	                    return;
	                case 'ssl_no_cert':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 8 22)').style('fill', '#D97373').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('SSL*');
	                    return;
	                case 'unknown':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 16 22)').style('fill', '#D8464A').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 20).text('?');
	                    return;
	                case 'google':
	                    em.append('path').style('fill', '#0C75BC').attr('d', 'M10.785,22.308l-1.771,0.409c-0.719,0.111-1.363,0.21-2.045,0.21' + 'c-3.42,0-4.721-2.515-4.721-4.485c0-2.403,1.847-4.634,5.006-4.634c0.67,0,1.314,0.1,1.896,0.261' + 'c0.929,0.26,1.363,0.582,1.635,0.769l-1.028,0.979l-0.433,0.099l0.309-0.495c-0.421-0.409-1.189-1.164-2.65-1.164' + 'c-1.959,0-3.434,1.486-3.434,3.654c0,2.329,1.686,4.522,4.387,4.522c0.793,0,1.202-0.161,1.574-0.31v-1.995l-1.871,0.099' + 'l0.99-0.532h2.627l-0.321,0.311c-0.087,0.073-0.1,0.099-0.124,0.197c-0.013,0.111-0.025,0.471-0.025,0.595V22.308L10.785,22.308z');
	                    em.append('path').style('fill', '#EF4035').attr('d', 'M14.851,22.769c-2.102,0-3.226-1.639-3.226-3.119' + 'c0-1.73,1.415-3.211,3.424-3.211c1.942,0,3.158,1.52,3.158,3.119C18.207,21.116,17.005,22.769,14.851,22.769L14.851,22.769z' + 'M16.502,21.698c0.318-0.423,0.396-0.951,0.396-1.467c0-1.163-0.555-3.383-2.193-3.383c-0.436,0-0.872,0.172-1.189,0.449' + 'C13,17.76,12.908,18.341,12.908,18.91c0,1.308,0.646,3.462,2.246,3.462C15.67,22.372,16.199,22.121,16.502,21.698L16.502,21.698z');
	                    em.append('path').style('fill', '#F9A600').attr('d', 'M21.881,22.769c-2.101,0-3.225-1.639-3.225-3.119' + 'c0-1.73,1.415-3.211,3.424-3.211c1.943,0,3.158,1.52,3.158,3.119C25.239,21.116,24.036,22.769,21.881,22.769L21.881,22.769z' + ' M23.534,21.698c0.316-0.423,0.396-0.951,0.396-1.467c0-1.163-0.555-3.383-2.193-3.383c-0.436,0-0.874,0.172-1.19,0.449' + 'c-0.516,0.462-0.607,1.043-0.607,1.612c0,1.308,0.646,3.462,2.247,3.462C22.702,22.372,23.229,22.121,23.534,21.698L23.534,21.698z');
	                    em.append('path').style('fill', '#0C75BC').attr('d', 'M30.077,17.086c0.303,0.251,0.937,0.779,0.937,1.784' + 'c0,0.979-0.554,1.44-1.108,1.877c-0.172,0.171-0.371,0.357-0.371,0.647c0,0.291,0.199,0.449,0.344,0.568l0.477,0.37' + 'c0.581,0.488,1.108,0.938,1.108,1.85c0,1.243-1.202,2.498-3.476,2.498c-1.916,0-2.84-0.912-2.84-1.89' + 'c0-0.477,0.236-1.149,1.018-1.613c0.818-0.501,1.93-0.567,2.523-0.607c-0.186-0.237-0.396-0.488-0.396-0.898' + 'c0-0.225,0.066-0.356,0.133-0.516c-0.146,0.014-0.291,0.027-0.424,0.027c-1.4,0-2.193-1.045-2.193-2.075' + 'c0-0.608,0.277-1.282,0.846-1.771c0.754-0.621,1.652-0.727,2.365-0.727h2.722l-0.846,0.476H30.077L30.077,17.086z M29.137,22.954' + 'c-0.105-0.014-0.172-0.014-0.303-0.014c-0.119,0-0.834,0.026-1.389,0.211c-0.291,0.106-1.137,0.424-1.137,1.362' + 's0.912,1.612,2.326,1.612c1.27,0,1.942-0.608,1.942-1.428C30.578,24.024,30.143,23.667,29.137,22.954L29.137,22.954z' + ' M29.522,20.443c0.303-0.305,0.33-0.728,0.33-0.966c0-0.951-0.568-2.432-1.666-2.432c-0.344,0-0.713,0.172-0.926,0.437' + 'c-0.225,0.277-0.291,0.635-0.291,0.979c0,0.885,0.516,2.352,1.652,2.352C28.952,20.812,29.309,20.654,29.522,20.443L29.522,20.443z');
	                    em.append('path').style('fill', '#2FB357').attr('d', 'M34.41,22.597h-2.338c0.303-0.396,0.355-0.436,0.355-0.699v-2.155' + 'c0-1.03,0.014-2.498,0.053-3.872c0.014-0.674,0.066-1.52,0.08-2.128h-1.031l0.992-0.476h1.889' + 'c-0.408,0.238-0.541,0.317-0.594,0.779c-0.105,1.018-0.119,2.63-0.119,4.507v3.053c0,0.516,0.092,0.596,0.529,0.635' + 'c0.225,0.026,0.449,0.04,0.674,0.066L34.41,22.597L34.41,22.597z');
	                    em.append('path').style('fill', '#EF4035').attr('d', 'M39.552,22.307c-0.146,0.079-0.291,0.171-0.438,0.238' + 'c-0.436,0.197-0.885,0.25-1.281,0.25c-0.424,0-1.084-0.026-1.758-0.515c-0.938-0.661-1.348-1.798-1.348-2.789' + 'c0-2.049,1.664-3.053,3.025-3.053c0.477,0,0.965,0.119,1.361,0.37c0.662,0.436,0.834,1.004,0.926,1.309l-3.105,1.255l-1.018,0.079' + 'c0.33,1.679,1.467,2.657,2.723,2.657c0.674,0,1.162-0.238,1.611-0.463L39.552,22.307L39.552,22.307z M38.31,18.368' + 'c0.25-0.093,0.383-0.172,0.383-0.357c0-0.528-0.596-1.137-1.309-1.137c-0.529,0-1.52,0.41-1.52,1.838' + 'c0,0.224,0.025,0.462,0.039,0.7L38.31,18.368L38.31,18.368z');
	                    return;
	                case 'bittorrent':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 8 20)').style('fill', '#F68D55').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 13).text('BiTor');
	                    return;
	                case 'apple':
	                    em.append('path').style('fill', '#727272').attr('d', 'M28.5,13.481c-0.915-1.139-2.196-1.798-3.407-1.798' + 'c-1.602,0-2.278,0.76-3.389,0.76c-1.145,0-2.016-0.759-3.401-0.759c-1.36,0-2.807,0.826-3.724,2.238' + 'c-1.291,1.987-1.072,5.725,1.021,8.909c0.748,1.139,1.748,2.419,3.055,2.431c1.162,0.011,1.49-0.741,3.066-0.749' + 'c1.576-0.01,1.874,0.758,3.035,0.747c1.308-0.013,2.361-1.431,3.11-2.57c0.536-0.815,0.735-1.228,1.151-2.15' + 'C25.992,19.397,25.505,15.122,28.5,13.481z');
	                    em.append('path').style('fill', '#727272').attr('d', 'M23.878,10.41c0.582-0.747,1.023-1.801,0.863-2.878' + 'c-0.951,0.065-2.062,0.67-2.711,1.458c-0.589,0.715-1.075,1.776-0.886,2.808C22.182,11.83,23.255,11.21,23.878,10.41z');
	                    return;
	                case 'facebook':
	                    em.append('path').style('fill', '#3C5A98').attr('d', 'M30.697,24.701V8.094c0-0.469-0.379-0.85-0.848-0.85h-1.514H14.459h-1.514' + 'c-0.467,0-0.846,0.379-0.848,0.846v15.098v1.516c0,0.467,0.38,0.848,0.848,0.848h9.388v-7.35H19.91v-2.533h2.423v-2.75' + 'c0-1.646,1.494-2.754,2.699-2.754h2.713v2.305h-1.251c-0.617,0-1.439,0.5-1.439,1.115v2.084H27.5v2.533h-2.445v7.35h3.281h1.514' + 'C30.318,25.551,30.697,25.17,30.697,24.701z');
	                    return;
	                case 'dns':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 7 22)').style('fill', '#A0BB71').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('DNS');
	                    return;
	                case 'llmnr':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 4.7 22)').style('fill', '#8C8C8C').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 11).text('LLMNR');
	                    return;
	                case 'youtube':
	                    em.append('path').style('fill', '#EB2629').attr('d', 'M38.016,21.517c0,1.798-1.458,3.257-3.258,3.257H21.867c-1.799,0-3.258-1.459-3.258-3.257v-6.292' + 'c0-1.801,1.459-3.259,3.258-3.259h12.891c1.8,0,3.258,1.458,3.258,3.259V21.517z');
	                    em.append('path').style('fill', '#FFFFFF').attr('d', 'M21.848,22.183v-6.802h-1.346v-1.343h3.856v1.343h-1.346v6.802H21.848z');
	                    em.append('path').style('fill', '#FFFFFF').attr('d', 'M28.004,16.065v6.118h-1.069v-0.609c-0.225,0.514-0.555,0.771-0.99,0.771' + 'c-0.698,0-1.048-0.491-1.048-1.476v-4.804h1.052v3.995c0,0.33,0.019,0.564,0.055,0.705c0.068,0.244,0.203,0.366,0.406,0.366' + 'c0.218,0,0.364-0.132,0.438-0.397c0.04-0.152,0.061-0.404,0.061-0.761v-3.907H28.004z');
	                    em.append('path').style('fill', '#FFFFFF').attr('d', 'M28.942,22.183v-8.146h1.091v2.545c0.181-0.454,0.49-0.681,0.924-0.681c0.553,0,0.917,0.395,1.087,1.184' + 'c0.088,0.399,0.13,1.087,0.13,2.066c0,0.952-0.047,1.632-0.141,2.041c-0.18,0.767-0.547,1.152-1.1,1.152' + 'c-0.461,0-0.779-0.268-0.955-0.8v0.639H28.942z M30.569,17.09c-0.297,0-0.481,0.315-0.549,0.941' + 'C30.008,18.159,30,18.607,30,19.379c0,0.597,0.013,0.968,0.037,1.116c0.071,0.456,0.248,0.683,0.532,0.683' + 'c0.266,0,0.427-0.28,0.483-0.836c0.015-0.117,0.021-0.516,0.021-1.2c0-0.708-0.006-1.113-0.017-1.21' + 'C30.999,17.37,30.838,17.09,30.569,17.09z');
	                    em.append('path').style('fill', '#FFFFFF').attr('d', 'M35.067,20.082h1.023c0,0.029,0.002,0.07,0.005,0.121c0.002,0.051,0.004,0.089,0.004,0.119' + 'c0,0.703-0.13,1.215-0.39,1.539c-0.26,0.322-0.664,0.484-1.214,0.484c-0.566,0-0.973-0.195-1.224-0.588' + 'c-0.198-0.31-0.322-0.762-0.379-1.358c-0.024-0.26-0.037-0.752-0.037-1.473c0-0.582,0.013-0.996,0.037-1.243' + 'c0.05-0.5,0.157-0.88,0.322-1.14c0.272-0.427,0.708-0.641,1.31-0.641c0.58,0,1.005,0.23,1.272,0.692' + 'c0.218,0.371,0.325,1.125,0.325,2.26v0.463h-2.139c-0.008,0.069-0.012,0.199-0.012,0.393c0,0.454,0.019,0.78,0.058,0.974' + 'c0.078,0.399,0.241,0.597,0.488,0.597C34.883,21.281,35.067,20.882,35.067,20.082z M33.975,18.349h1.055v-0.26' + 'c0-0.352-0.024-0.601-0.073-0.75c-0.075-0.234-0.229-0.353-0.46-0.353c-0.191,0-0.329,0.081-0.409,0.243' + 'c-0.098,0.201-0.14,0.487-0.123,0.86l0.006,0.084C33.973,18.232,33.975,18.292,33.975,18.349z');
	                    em.append('path').style('fill', '#595A5C').attr('d', 'M6.736,22.229v-3.474l-1.652-4.718h1.299l0.954,3.08l0.94-3.08h1.265l-1.623,4.718v3.474H6.736z');
	                    em.append('path').style('fill', '#595A5C').attr('d', 'M9.946,19.154c0-1.058,0.08-1.81,0.241-2.254c0.24-0.657,0.714-0.988,1.424-0.988' + 'c0.709,0,1.185,0.331,1.426,0.988c0.161,0.441,0.242,1.193,0.242,2.254c0,1.063-0.081,1.815-0.242,2.253' + 'c-0.241,0.657-0.717,0.984-1.426,0.984c-0.71,0-1.184-0.329-1.424-0.988C10.026,20.964,9.946,20.214,9.946,19.154z M11.07,19.235' + 'c0,0.761,0.003,1.175,0.013,1.243c0.057,0.549,0.23,0.825,0.52,0.825c0.291,0,0.469-0.238,0.532-0.708' + 'c0.015-0.103,0.021-0.487,0.021-1.153v-0.598c0-0.624-0.008-1.001-0.023-1.127c-0.068-0.468-0.242-0.701-0.521-0.701' + 'c-0.271,0-0.44,0.205-0.509,0.615c-0.021,0.132-0.032,0.478-0.032,1.038V19.235z');
	                    em.append('path').style('fill', '#595A5C').attr('d', 'M17.206,16.076v6.153h-1.072v-0.613c-0.227,0.518-0.559,0.776-0.995,0.776' + 'c-0.705,0-1.057-0.494-1.057-1.482v-4.833h1.058v4.021c0,0.33,0.021,0.564,0.057,0.707c0.068,0.245,0.205,0.366,0.408,0.366' + 'c0.22,0,0.366-0.132,0.441-0.399c0.038-0.15,0.061-0.406,0.061-0.765v-3.929H17.206z');
	                    return;
	                case 'yahoo':
	                    em.append('path').style('fill', '#5D499E').attr('d', 'M39.635,14.437L39.635,14.437L39.635,14.437c0,0-0.071-0.01-0.121-0.01c-0.276,0-0.552,0.163-0.552,0.579' + 'c-0.164,2.086-0.336,4.18-0.618,6.171l-0.001,0h0.001l0,0h0.001c0.171-0.029,0.303,0.015,0.432,0.067l-0.001-0.001' + 'c0.319-2.023,1.079-5.052,1.274-5.909c0.027-0.121,0.069-0.264,0.069-0.365C40.119,14.663,39.925,14.485,39.635,14.437z');
	                    em.append('path').style('fill', '#5D499E').attr('d', 'M19.545,15.26c0.057,1.078,0.086,2.156,0.091,3.236c-1.294,0.029-2.587,0.032-3.877,0h-0.001' + 'c0.006-1.08,0.035-2.159,0.091-3.236c-0.379,0.091-0.764,0.094-1.156,0c0.102,2.315,0.092,4.626,0,6.934' + 'c0.376-0.09,0.761-0.094,1.155,0l-0.003-0.001l0.004,0.001c-0.057-1.077-0.086-2.151-0.091-3.226l0.001,0' + 'c1.292-0.019,2.584-0.019,3.877-0.001c-0.005,1.074-0.034,2.149-0.091,3.226l0.004-0.001l-0.002,0.001' + 'c0.395-0.094,0.778-0.09,1.153,0c-0.092-2.308-0.101-4.618,0-6.934C20.31,15.354,19.923,15.352,19.545,15.26z');
	                    em.append('path').style('fill', '#5D499E').attr('d', 'M11.302,15.258L11.302,15.258L11.302,15.258c-0.288,0.1-0.521,0.094-0.806,0v0' + 'c-0.932,2.335-2.004,4.971-2.967,6.937l0,0l-0.001,0.001l0.004-0.001l-0.003,0l0.007-0.003l-0.004,0.002' + 'c0.441-0.11,0.861-0.076,1.141,0c-0.002,0-0.003-0.001-0.003-0.001h0.003c0.245-0.62,0.524-1.324,0.806-2.033l0.001,0.001' + 'c0.947-0.027,1.896-0.031,2.842,0l0,0c0.271,0.678,0.541,1.356,0.803,2.034v0c0.424-0.11,0.843-0.08,1.154-0.002h-0.001' + 'C13.582,20.895,12.188,17.5,11.302,15.258z M10.897,16.453c0.383,1.068,0.806,2.145,1.232,3.224l-0.002-0.001' + 'c-0.819,0.028-1.64,0.028-2.459,0H9.668C10.17,18.404,10.646,17.177,10.897,16.453z');
	                    em.append('path').style('fill', '#5D499E').attr('d', 'M9.202,14.335L9.202,14.335L9.202,14.335c-0.417,0.094-0.793,0.098-1.166,0' + 'c-0.328,0.612-1.538,2.592-2.311,3.86c-0.781-1.295-1.708-2.791-2.311-3.86c-0.479,0.102-0.679,0.108-1.156,0' + 'c0.947,1.428,2.465,4.146,2.981,5.039l-0.069,3.721c0,0,0.333-0.055,0.556-0.055c0.247,0,0.554,0.055,0.554,0.055l-0.069-3.721' + 'C7.175,17.684,8.766,14.926,9.202,14.335z');
	                    em.append('path').style('fill', '#5D499E').attr('d', 'M24.771,15.167c-2.451,0-3.737,1.555-3.737,3.569c0,2.206,1.404,3.551,3.734,3.551' + 'c2.519,0,3.75-1.517,3.75-3.528C28.519,16.516,27.048,15.167,24.771,15.167z M24.779,21.894c-1.634,0-2.595-1.171-2.595-3.146' + 'c0-2.234,1.184-3.133,2.527-3.161c0.021,0,0.043,0,0.064,0c1.499,0,2.6,1.021,2.6,3.155C27.376,20.873,26.276,21.894,24.779,21.894z');
	                    em.append('path').style('fill', '#5D499E').attr('d', 'M33.235,14.749c-2.441,0-4.308,1.386-4.308,3.963c0,2.125,1.241,3.994,4.328,3.994' + 'c2.612,0,4.319-1.438,4.319-3.956C37.575,16.375,35.983,14.749,33.235,14.749z M30.082,18.697c0-2.714,1.669-3.517,3.156-3.517' + 'c1.834,0,3.184,1.114,3.184,3.57c0,2.67-1.634,3.537-3.181,3.537C31.588,22.287,30.082,21.316,30.082,18.697z');
	                    em.append('path').style('fill', '#5D499E').attr('d', 'M38.309,22.014c-0.364,0-0.546,0.278-0.546,0.577c0,0.352,0.282,0.531,0.629,0.531' + 'c0.251,0,0.525-0.152,0.525-0.566C38.917,22.223,38.656,22.014,38.309,22.014z');
	                    return;
	                case 'appleitunes':
	                    em.append('circle').style('fill', '#3A7DC0').attr('cx', 21.433).attr('cy', 16.194).attr('r', 9.683);
	                    em.append('path').style('fill', '#DFDFDE').attr('d', 'M19.175,18.717v-7.776c0,0,1.59-0.672,3.131-0.955c1.543-0.283,3.869-0.413,3.869-0.413v9.564' + 'c0,0-0.238,1.595-2.168,1.543c-1.927-0.051-2.45-2.108-1.113-2.982s2.281-0.283,2.281-0.283v-4.321c0,0-3,0.155-5,0.978' + 'c0,0,0,5.631,0,6.376s-1.095,1.646-2.509,1.594c-1.414-0.051-2.019-1.363-1.35-2.494C16.983,18.418,18.175,18.527,19.175,18.717z');
	                    return;
	                case 'gmail':
	                    em.append('path').style('fill', '#2BACE2').attr('d', 'M34.036,16.171h-1.469v6.42h1.469V16.171L34.036,16.171z M33.229,15.292c-0.469,0-0.85-0.38-0.85-0.85' + 'c0-0.473,0.381-0.854,0.85-0.854c0.473,0,0.854,0.38,0.854,0.854C34.083,14.913,33.702,15.292,33.229,15.292z');
	                    em.append('path').style('fill', '#F79421').attr('d', 'M26.568,16.709c0.079,0.27,0.157,0.539,0.236,0.809' + 'c1.001-0.662,2.73-0.598,2.73,0.878c0,0.339-1.271,0.294-1.6,0.371c-0.596,0.14-1.24,0.488-1.533,1.046' + 'c-0.687,1.306,0.046,3.052,1.674,2.872c0.479-0.053,0.91-0.271,1.221-0.644c0.129-0.155,0.344-0.337,0.398-0.007' + 'c0.036,0.221-0.024,0.52,0.227,0.52c0.324,0,0.647,0,0.972,0c-0.251-1.708,0.346-3.656-0.365-5.271' + 'C29.905,15.869,27.65,16.04,26.568,16.709L26.568,16.709z M27.939,19.704c0.41-0.257,0.911-0.303,1.385-0.293' + 'c0.465,0.01,0.3,0.72,0.262,1.067c-0.056,0.505-0.253,0.95-0.74,1.176C27.528,22.268,26.771,20.344,27.939,19.704z');
	                    em.append('path').style('fill', '#2BACE2').attr('d', 'M13.045,13.833c0.417-0.413,0.833-0.825,1.249-1.237' + 'c-2.212-1.775-6.159-1.8-8.328,0.025c-2.654,2.233-2.805,6.55-0.203,8.914c1.48,1.346,3.631,1.398,5.504,1.155' + 'c0.501-0.064,0.986-0.165,1.478-0.282c0.545-0.129,1.549-0.069,1.549-0.702c0-0.681-0.036-1.375,0.012-2.055' + 'c0.034-0.487,0.208-0.57,0.566-0.915c-0.846,0-1.691,0-2.537,0c-0.779,0-1.183,0.29-1.879,0.672' + 'c0.761-0.042,1.523-0.085,2.284-0.127c0,0.583,0,1.166,0,1.748c0,0.54,0.102,0.631-0.287,0.872' + 'c-0.343,0.213-0.888,0.262-1.284,0.287c-1.521,0.096-3.086-0.457-4.099-1.616c-2.26-2.586-2.272-8.053,1.933-8.67' + 'c0.87-0.127,1.775-0.039,2.56,0.37c0.35,0.182,0.684,0.417,0.975,0.683c0.45,0.414,0.295,0.474-0.022,1.004' + 'C12.691,13.917,12.868,13.875,13.045,13.833z');
	                    em.append('rect').style('fill', '#08A650').attr('x', 35.6).attr('y', 12.9).attr('width', 1.3).attr('height', 9.68);
	                    em.append('polygon').style('fill', '#EC2227').attr('points', '22.926,16.321 20.339,18.913 17.725,16.311 16.12,16.316 ' + '16.12,22.629 17.428,22.629 17.432,17.672 20.37,20.168 23.363,17.631 23.363,22.629 24.576,22.629 24.576,16.316 ');
	                    return;
	                case 'amazon':
	                    em.append('path').style('fill', '#F8991D').attr('d', 'M25.484,23.57c-2.128,1.571-5.212,2.405-7.868,2.405' + 'c-3.723,0-7.075-1.375-9.611-3.667c-0.199-0.18-0.022-0.426,0.218-0.286c2.736,1.593,6.121,2.551,9.616,2.551' + 'c2.358,0,4.951-0.489,7.335-1.501C25.535,22.921,25.836,23.312,25.484,23.57z' + 'M26.369,22.56c-0.271-0.349-1.798-0.165-2.483-0.082' + 'c-0.208,0.024-0.24-0.157-0.053-0.289c1.217-0.855,3.213-0.608,3.444-0.322c0.233,0.289-0.061,2.29-1.202,3.245' + 'c-0.176,0.147-0.344,0.068-0.265-0.126C26.067,24.345,26.641,22.909,26.369,22.56z');
	                    em.append('path').style('fill', '#010101').attr('d', 'M23.932,16.146v-0.831c0.001-0.127,0.097-0.211,0.211-0.211' + 'l3.726,0c0.12,0,0.215,0.087,0.216,0.209l-0.001,0.713c-0.001,0.12-0.102,0.275-0.28,0.523l-1.93,2.755' + 'c0.716-0.016,1.475,0.091,2.125,0.457c0.146,0.083,0.187,0.205,0.197,0.325v0.887c0,0.122-0.134,0.263-0.274,0.189' + 'c-1.146-0.601-2.668-0.666-3.937,0.007c-0.129,0.069-0.264-0.07-0.264-0.193v-0.843c0-0.135,0.002-0.366,0.138-0.571l2.235-3.207' + 'l-1.945,0C24.03,16.355,23.933,16.271,23.932,16.146z' + 'M10.344,21.337H9.21c-0.107-0.007-0.194-0.088-0.203-0.191' + 'l0.001-5.817c0-0.117,0.098-0.21,0.219-0.21l1.055,0c0.11,0.006,0.199,0.09,0.207,0.197v0.759h0.021' + 'c0.275-0.734,0.793-1.077,1.491-1.077c0.709,0,1.153,0.343,1.471,1.077c0.274-0.734,0.899-1.077,1.565-1.077' + 'c0.476,0,0.995,0.195,1.312,0.637c0.36,0.49,0.286,1.199,0.286,1.824l-0.001,3.67c0,0.116-0.098,0.209-0.219,0.209h-1.131' + 'c-0.114-0.007-0.204-0.098-0.204-0.208l0-3.084c0-0.245,0.021-0.856-0.031-1.089c-0.085-0.391-0.338-0.501-0.667-0.501' + 'c-0.275,0-0.561,0.184-0.677,0.478s-0.106,0.784-0.106,1.113v3.083c0,0.116-0.098,0.209-0.218,0.209h-1.132' + 'c-0.114-0.007-0.203-0.098-0.203-0.208l-0.001-3.084c0-0.648,0.105-1.604-0.699-1.604c-0.814,0-0.783,0.931-0.783,1.604l0,3.083' + 'C10.562,21.244,10.465,21.337,10.344,21.337z' + 'M31.291,14.997c1.683,0,2.592,1.444,2.592,3.281' + 'c0,1.774-1.005,3.182-2.592,3.182c-1.65,0-2.55-1.444-2.55-3.243C28.741,16.405,29.651,14.997,31.291,14.997z M31.301,16.184' + 'c-0.836,0-0.889,1.139-0.889,1.848c0,0.71-0.011,2.228,0.878,2.228c0.879,0,0.921-1.224,0.921-1.971' + 'c0-0.49-0.021-1.077-0.169-1.542C31.916,16.344,31.661,16.184,31.301,16.184z' + 'M36.064,21.337h-1.129c-0.113-0.007-0.203-0.098-0.203-0.208' + 'L34.73,15.31c0.009-0.106,0.104-0.19,0.217-0.19l1.052,0c0.1,0.006,0.182,0.074,0.201,0.163v0.89h0.021' + 'c0.317-0.795,0.762-1.175,1.545-1.175c0.507,0,1.005,0.184,1.322,0.685c0.296,0.466,0.296,1.249,0.296,1.812v3.66' + 'c-0.012,0.104-0.104,0.184-0.217,0.184h-1.137c-0.104-0.006-0.188-0.084-0.201-0.184v-3.158c0-0.637,0.074-1.567-0.709-1.567' + 'c-0.274,0-0.529,0.183-0.655,0.465c-0.158,0.355-0.181,0.71-0.181,1.102v3.132C36.282,21.244,36.186,21.337,36.064,21.337z' + 'M20.963,18.56c0,0.441,0.011,0.81-0.211,1.202' + 'c-0.181,0.319-0.467,0.516-0.785,0.516c-0.434,0-0.689-0.331-0.689-0.822c0-0.965,0.867-1.141,1.686-1.141V18.56z M22.106,21.323' + 'c-0.075,0.068-0.183,0.072-0.268,0.026c-0.376-0.312-0.443-0.457-0.65-0.755c-0.622,0.634-1.062,0.824-1.868,0.824' + 'c-0.954,0-1.696-0.589-1.696-1.767c0-0.919,0.499-1.545,1.208-1.853c0.616-0.27,1.475-0.319,2.131-0.393v-0.147' + 'c0-0.27,0.021-0.589-0.137-0.822c-0.138-0.209-0.403-0.295-0.637-0.295c-0.432,0-0.816,0.222-0.911,0.681' + 'c-0.02,0.103-0.094,0.204-0.197,0.208l-1.098-0.119c-0.093-0.021-0.195-0.096-0.169-0.237c0.252-1.333,1.456-1.735,2.535-1.735' + 'c0.551,0,1.271,0.147,1.707,0.564c0.551,0.515,0.498,1.203,0.498,1.951v1.766c0,0.532,0.221,0.764,0.428,1.05' + 'c0.072,0.103,0.089,0.226-0.004,0.301c-0.23,0.194-0.643,0.552-0.868,0.752L22.106,21.323z' + 'M6.105,18.56c0,0.441,0.011,0.81-0.211,1.202' + 'c-0.181,0.319-0.466,0.516-0.784,0.516c-0.435,0-0.689-0.331-0.689-0.822c0-0.965,0.866-1.141,1.685-1.141V18.56z M7.249,21.323' + 'c-0.075,0.068-0.184,0.072-0.268,0.026c-0.376-0.312-0.444-0.457-0.649-0.755c-0.623,0.634-1.063,0.824-1.869,0.824' + 'c-0.954,0-1.696-0.589-1.696-1.767c0-0.919,0.498-1.545,1.208-1.853c0.615-0.27,1.474-0.319,2.13-0.393v-0.147' + 'c0-0.27,0.021-0.589-0.137-0.822c-0.138-0.209-0.403-0.295-0.636-0.295c-0.432,0-0.816,0.222-0.911,0.681' + 'c-0.02,0.103-0.095,0.204-0.197,0.208l-1.099-0.119c-0.093-0.021-0.196-0.096-0.169-0.237c0.252-1.333,1.456-1.735,2.534-1.735' + 'c0.551,0,1.272,0.147,1.708,0.564c0.551,0.515,0.498,1.203,0.498,1.951v1.766c0,0.532,0.221,0.764,0.428,1.05' + 'c0.073,0.103,0.088,0.226-0.004,0.301c-0.231,0.194-0.643,0.552-0.869,0.752L7.249,21.323z');
	                    return;
	                case 'skype':
	                    em.append('path').style('fill', '#33A7DF').attr('d', 'M29.863,17.329c0.129-0.592,0.197-1.205,0.197-1.836c0-4.732-3.836-8.566-8.567-8.566' + 'c-0.5,0-0.989,0.041-1.465,0.123c-0.766-0.48-1.672-0.762-2.645-0.762c-2.744,0-4.969,2.227-4.969,4.969' + 'c0,0.918,0.25,1.777,0.684,2.514c-0.113,0.555-0.173,1.133-0.173,1.723c0,4.73,3.836,8.566,8.567,8.566' + 'c0.536,0,1.061-0.049,1.569-0.143c0.699,0.375,1.5,0.59,2.35,0.59c2.744,0,4.969-2.227,4.969-4.971' + 'C30.38,18.745,30.193,17.995,29.863,17.329z');
	                    em.append('path').style('fill', '#F9F9FA').attr('d', 'M18.876,9.862c-2.751,1.006-2.982,4.511-0.219,5.68c0.858,0.365,6.875,1.208,4.66,3.266' + 'c-0.771,0.715-2.263,0.853-3.201,0.41c-1.157-0.546-1.201-2.661-2.727-2.403c-1.553,0.262-0.916,2.113-0.255,2.92' + 'c0.88,1.076,2.229,1.516,3.574,1.617c2.315,0.174,5.486-0.585,5.72-3.379c0.264-3.149-3.175-3.608-5.485-4.187' + 'c-0.917-0.23-2.617-1.143-1.202-2.071c0.955-0.629,2.593-0.541,3.331,0.371c0.588,0.727,1.375,2.249,2.482,1.086' + 'c1.128-1.166-0.498-2.732-1.53-3.204C22.487,9.265,20.451,9.278,18.876,9.862z');
	                    return;
	                case 'dropbox':
	                    em.append('polygon').style('fill', '#397ABE').attr('points', '21.397,19.972 17.047,23.173 14.833,21.833 14.833,22.849 21.382,27.224 28.08,22.878 28.08,21.833 ' + '25.794,23.298 ');
	                    em.append('path').style('fill', '#397ABE').attr('d', 'M32.64,10.535l-6.637-4.239l-4.562,3.825l-4.459-3.825l-6.828,4.447l4.702,3.577l-4.702,3.577l6.828,4.045' + 'l4.459-3.423l4.458,3.423l6.74-4.045l-4.354-3.732L32.64,10.535z M21.397,18.326l-6.459-4.069l6.518-3.938l6.44,3.7L21.397,18.326z');
	                    return;
	                case 'viber':
	                    em.append('path').style('fill', '#7D539D').attr('d', 'M24.729,22.746c-0.356-0.023-0.549,0.285-0.754,0.514' + 'c-0.875,0.982-1.752,1.959-2.64,2.93c-0.14,0.154-0.271,0.434-0.523,0.33c-0.251-0.105-0.143-0.395-0.145-0.605' + 'c-0.009-0.82-0.04-1.641,0.008-2.457c0.038-0.639-0.119-0.926-0.831-0.943c-0.889-0.025-1.787-0.137-2.655-0.326' + 'c-3.063-0.672-5.081-2.346-5.368-5.762c-0.125-1.488-0.214-2.971,0.02-4.449c0.49-3.088,2.269-4.84,5.337-5.346' + 'c4.206-0.691,6.849-0.307,9.083,0.164c2.68,0.566,4.514,2.627,4.739,5.416c0.129,1.604,0.158,3.223-0.083,4.826' + 'c-0.321,2.139-1.132,4.285-3.151,5.025C26.391,22.566,25.323,22.773,24.729,22.746z M23.393,20.332' + 'c0.799,0.008,1.736-0.763,2.006-1.527c0.262-0.737-0.289-1.029-0.725-1.378c-0.32-0.26-0.663-0.491-1.001-0.727' + 'c-0.673-0.474-1.288-0.51-1.79,0.251c-0.281,0.427-0.677,0.446-1.089,0.257c-1.137-0.515-2.016-1.31-2.53-2.465' + 'c-0.228-0.512-0.225-0.969,0.308-1.333c0.282-0.191,0.565-0.417,0.543-0.834c-0.03-0.547-1.353-2.367-1.875-2.56' + 'c-0.218-0.079-0.432-0.075-0.652,0c-1.226,0.414-1.733,1.419-1.247,2.613c1.45,3.561,4.003,6.04,7.515,7.551' + 'C23.056,20.265,23.281,20.302,23.393,20.332z M21.072,8.179c-0.269,0.04-0.823-0.182-0.859,0.42C20.191,9,20.658,8.935,20.964,8.981' + 'c3.699,0.571,5.403,2.327,5.874,6.052c0.044,0.342-0.084,0.861,0.406,0.871c0.512,0.013,0.389-0.5,0.393-0.846' + 'C27.683,11.552,24.625,8.302,21.072,8.179z M25.816,14.432c0.017-2.175-1.847-4.154-4.127-4.429' + 'c-0.357-0.043-0.826-0.21-0.909,0.284c-0.087,0.518,0.436,0.463,0.773,0.54c2.284,0.51,3.08,1.343,3.454,3.608' + 'c0.056,0.331-0.054,0.842,0.508,0.759C25.928,15.129,25.78,14.691,25.816,14.432z M24.08,14.021c0.017-1.052-1.168-2.265-2.183-2.24' + 'c-0.237,0.006-0.47,0.031-0.559,0.287c-0.129,0.38,0.146,0.469,0.427,0.513c0.937,0.152,1.431,0.704,1.522,1.639' + 'c0.027,0.253,0.188,0.459,0.432,0.429C24.059,14.607,24.089,14.309,24.08,14.021z');
	                    return;
	                case 'h323':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 6 21)').style('fill', '#6FBF9B').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 13).text('H323');
	                    return;
	                case 'netbios':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 6.5 21)').style('fill', '#67AAB5').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 12).text('NBios');
	                    return;
	                case 'smtp':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 4.5 22)').style('fill', '#67AAB5').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('smtp');
	                    return;
	                case 'smtps':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 4.5 22)').style('fill', '#67AAB5').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('smtp');
	                    return;
	                case 'ntp':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 9 21)').style('fill', '#F3BD5D').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('NTP');
	                    return;
	                case 'twitter':
	                    em.append('path').style('fill', '#2BA9E0').attr('d', 'M30.872,10.52c-0.697,0.31-1.445,0.52-2.232,0.612c0.803-0.479,1.42-1.243,1.709-2.15' + 'c-0.75,0.445-1.582,0.769-2.469,0.943c-0.709-0.756-1.719-1.228-2.838-1.228c-2.146,0-3.886,1.741-3.886,3.887' + 'c0,0.306,0.033,0.602,0.1,0.887c-3.23-0.162-6.096-1.71-8.013-4.062c-0.335,0.575-0.526,1.243-0.526,1.955' + 'c0,1.349,0.687,2.539,1.729,3.236c-0.637-0.02-1.237-0.195-1.761-0.487c0,0.017,0,0.034,0,0.049c0,1.885,1.34,3.455,3.118,3.812' + 'c-0.326,0.09-0.669,0.138-1.024,0.138c-0.25,0-0.494-0.025-0.731-0.07c0.495,1.544,1.931,2.669,3.632,2.699' + 'c-1.33,1.042-3.008,1.664-4.828,1.664c-0.314,0-0.623-0.019-0.928-0.053c1.721,1.103,3.764,1.745,5.959,1.745' + 'c7.152,0,11.062-5.924,11.062-11.061c0-0.168-0.004-0.336-0.012-0.503C29.692,11.984,30.35,11.301,30.872,10.52z');
	                    return;
	                case 'ftp_data':
	                    em.append('path').style('fill', '#9fba70').attr('d', 'M31.184,10.75H20.405v-0.524c0-1.021-0.821-1.848-1.834-1.848' + 'h-6.96c-1.012,0-1.835,0.826-1.835,1.848v12.344c0,1.021,0.823,1.848,1.835,1.848h19.574c1.013,0,1.836-0.826,1.836-1.848v-9.973' + 'C33.02,11.577,32.197,10.75,31.184,10.75z M20.397,17.885l-2.563-1.531v4.605h-1.993v-4.605l-2.563,1.531v-2.257l3.56-2.126' + 'l3.56,2.126V17.885z M29.624,18.989l-3.56,2.126l-3.56-2.126v-2.257l2.611,1.56v-4.654h1.994v4.596l2.514-1.501V18.989z');
	                    return;
	                case 'ftp_control':
	                    em.append('path').style('fill', '#efa986').attr('d', 'M31.184,10.75H20.405v-0.524c0-1.021-0.821-1.848-1.834-1.848' + 'h-6.96c-1.012,0-1.835,0.826-1.835,1.848v12.344c0,1.021,0.823,1.848,1.835,1.848h19.574c1.013,0,1.836-0.826,1.836-1.848v-9.973' + 'C33.02,11.577,32.197,10.75,31.184,10.75z M20.397,17.885l-2.563-1.531v4.605h-1.993v-4.605l-2.563,1.531v-2.257l3.56-2.126' + 'l3.56,2.126V17.885z M29.624,18.989l-3.56,2.126l-3.56-2.126v-2.257l2.611,1.56v-4.654h1.994v4.596l2.514-1.501V18.989z');
	                    return;
	                case 'mdns':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 3.5 22)').style('fill', '#708EBC').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 12).text('MDNS');
	                    return;
	                case 'wikipedia':
	                    em.append('path').style('fill', '#096497').attr('d', 'M21.058,2.153c0.016-0.003,0.018,0.007,0.018,0.02' + 'c0.851,1.418,1.688,2.824,2.49,4.314c0.264,0.488,0.572,0.988,0.666,1.559c-0.264-0.108-0.412-0.345-0.646-0.494' + 'c-0.23-0.147-0.499-0.244-0.875-0.266c0.193,1.215,0.936,1.826,1.863,2.261c0.924,0.435,1.948,0.788,2.812,1.351' + 'c1.595,1.036,2.814,2.842,3.384,4.923c0.677,2.471,0.161,5.151-0.778,6.9c-0.967,1.797-2.436,3.152-4.277,4.029' + 'c-0.961,0.458-2.045,0.777-3.308,0.854c-1.327,0.083-2.561-0.096-3.65-0.475c-1.985-0.69-3.625-2.027-4.694-3.612' + 'c-1.104-1.634-1.863-3.947-1.502-6.614c0.32-2.36,1.474-4.08,2.871-5.436c0.682,0.619,1.467,1.448,2.186,2.167' + 'c0.048,0.047,0.284,0.303,0.304,0.304c0.079,0.003,0.329-0.312,0.362-0.343c0.146-0.134,0.218-0.23,0.361-0.322' + 'c0.217,0.86,0.458,1.697,0.685,2.547c-0.843-0.229-1.689-0.452-2.528-0.685c-0.025-0.056,0.064-0.116,0.115-0.171' + 'c0.052-0.056,0.111-0.111,0.171-0.17c0.072-0.073,0.341-0.289,0.341-0.362c0-0.057-0.262-0.278-0.304-0.323' + 'c-0.12-0.127-0.196-0.212-0.304-0.305c-0.921,1.019-1.591,2.286-1.71,4.106c0.247,0.044,0.576,0.006,0.855,0.019' + 'c0.052-0.29,0.04-0.644,0.057-0.969c0.763,0.435,1.52,0.876,2.281,1.312c-0.746,0.464-1.511,0.909-2.299,1.331' + 'c0-0.318,0-0.635,0-0.951c-0.261-0.044-0.602-0.007-0.894-0.02c0.1,1.834,0.799,3.066,1.673,4.125' + 'c0.246-0.172,0.417-0.419,0.646-0.608c-0.194-0.261-0.455-0.457-0.646-0.722c0.852-0.226,1.693-0.46,2.547-0.685' + 'c-0.229,0.842-0.444,1.698-0.685,2.528c-0.054,0.027-0.12-0.067-0.171-0.114c-0.163-0.149-0.375-0.354-0.532-0.513' + 'c-0.167,0.146-0.298,0.287-0.476,0.475c-0.028,0.029-0.153,0.124-0.152,0.152c0.002,0.051,0.328,0.287,0.399,0.342' + 'c0.931,0.712,2.23,1.291,3.707,1.368c0.044-0.26,0.007-0.601,0.019-0.893c-0.336,0.013-0.614-0.031-0.951-0.02' + 'c-0.01-0.091,0.068-0.186,0.114-0.266c0.372-0.645,0.798-1.365,1.16-2.033c0.467,0.729,0.932,1.563,1.331,2.299' + 'c-0.338-0.013-0.615,0.031-0.951,0.02c-0.044,0.253-0.006,0.589-0.019,0.874c1.79-0.072,3.104-0.786,4.124-1.691' + 'c-0.191-0.22-0.416-0.407-0.607-0.627c-0.246,0.197-0.496,0.492-0.723,0.646c-0.232-0.845-0.457-1.697-0.684-2.548' + 'c0.852,0.225,1.695,0.459,2.547,0.685c-0.194,0.257-0.436,0.465-0.646,0.703c0.201,0.217,0.41,0.425,0.627,0.627' + 'c0.898-1.034,1.578-2.287,1.691-4.105c-0.253-0.045-0.588-0.006-0.873-0.02c-0.045,0.286-0.007,0.652-0.02,0.971' + 'c-0.792-0.412-1.529-0.879-2.301-1.312c0.729-0.469,1.523-0.871,2.262-1.33c0.051,0.292,0.033,0.651,0.059,0.969' + 'c0.291,0,0.582,0,0.873,0c-0.105-1.832-0.797-3.08-1.691-4.125c-0.22,0.192-0.407,0.417-0.627,0.608' + 'c0.185,0.261,0.504,0.483,0.646,0.723c-0.855,0.222-1.695,0.46-2.547,0.685c0.227-0.85,0.467-1.688,0.684-2.547' + 'c0.18,0.133,0.342,0.306,0.532,0.493c0.021,0.021,0.165,0.172,0.171,0.172c0.098,0.004,0.244-0.259,0.305-0.323' + 'c0.119-0.131,0.222-0.186,0.304-0.305c-1.13-0.878-2.702-1.176-3.858-1.977c-1.175-0.812-1.878-1.945-2.262-3.555' + 'c-0.612,0.148-1.113,0.511-1.768,0.552c0.058-0.274,0.281-0.456,0.437-0.665C19.869,6.2,20.43,4.12,21.058,2.153');
	                    em.append('path').style('fill', '#961A1E').attr('d', 'M18.719,17.663c0.169-0.812,0.661-1.487,1.236-1.9' + 'c0.54-0.389,1.489-0.725,2.452-0.531c0.812,0.163,1.475,0.627,1.901,1.216c0.43,0.595,0.708,1.562,0.531,2.451' + 'c-0.164,0.833-0.599,1.451-1.217,1.901c-0.575,0.422-1.438,0.745-2.432,0.551c-0.797-0.153-1.494-0.61-1.92-1.197' + 'C18.864,19.594,18.502,18.705,18.719,17.663');
	                    return;
	                case 'ebay':
	                    em.append('path').style('fill', '#EF3C40').attr('d', 'M8.631,13.584c-4.307,0-4.474,3.353-4.452,4.223c0,0-0.21,3.919,4.347,3.919' + 'c3.916,0,4.108-2.459,4.108-2.459l-1.802,0.003c0,0-0.351,1.355-2.3,1.318c-2.505-0.046-2.602-2.474-2.602-2.474h6.94' + 'C12.871,18.114,13.397,13.585,8.631,13.584z M5.988,16.926c0,0,0.123-2.194,2.6-2.195c2.468,0,2.468,2.195,2.468,2.195H5.988z');
	                    em.append('path').style('fill', '#0668B2').attr('d', 'M17.691,13.584c-2.166-0.012-3.097,1.283-3.097,1.283v-4.331h-1.735l0.029,9.153c0,0-0.01,1.064-0.076,1.77' + 'h1.686l0.073-1.028c0,0,0.787,1.295,3.084,1.295c2.299,0,4.114-1.416,4.162-4.04C21.864,15.06,19.856,13.597,17.691,13.584z' + ' M17.293,20.555c-2.735,0.035-2.69-2.899-2.69-2.899s-0.099-2.825,2.686-2.897c2.785-0.072,2.694,2.958,2.694,2.958' + 'S20.027,20.521,17.293,20.555z');
	                    em.append('path').style('fill', '#F8AC1C').attr('d', 'M29.836,19.652c0.004-1.184,0.038-2.24,0-2.987c-0.047-0.864,0.035-2.95-3.702-3.105' + 'c0,0-3.584-0.325-3.956,2.341h1.834c0,0,0.143-1.222,2.002-1.186c1.76,0.032,2.08,0.896,2.071,1.957c0,0-1.51,0.004-2.013,0.007' + 'c-0.907,0.005-4.082,0.105-4.378,2.038c-0.353,2.3,1.699,3.018,3.306,3.009s2.521-0.489,3.203-1.352l0.072,1.07l1.596-0.01' + 'C29.872,21.435,29.832,20.837,29.836,19.652z M25.299,20.618c0,0-1.739,0.003-1.842-1.388c-0.108-1.483,2.677-1.394,2.677-1.394' + 'l1.967-0.003C28.101,17.834,28.42,20.66,25.299,20.618z');
	                    em.append('polygon').style('fill', '#6BB845').attr('points', '28.886,13.875 30.901,13.875 33.845,19.747 36.797,13.875 38.619,13.875 33.29,24.345 31.341,24.345 32.884,21.435 ');
	                    return;
	                case 'googlemaps':
	                    em.append('polygon').style('fill', '#C9C9C9').attr('points', '23.968,5.673 17.475,4.549 10.607,5.208 10.607,23.683 17.475,25.45 23.968,23.169 31.639,24.932 31.639,4.788 ');
	                    em.append('polygon').style('fill', '#A2C064').attr('points', '11.184,23.831 17.535,18.057 23.897,10.118 29.411,5.045 23.968,5.673 17.475,4.549 10.607,5.208 10.607,23.683 12.765,24.238 12.765,24.238 ');
	                    em.append('polygon').style('fill', '#6886C4').attr('points', '20.361,18.246 17.589,21.104 13.704,24.479 12.044,24.053 12.043,24.053 17.475,25.45 ' + '23.968,23.169 31.639,24.932 31.639,23.65 23.897,19.299 ');
	                    em.append('polygon').style('fill', '#EEE959').attr('points', '31.639,20.64 23.897,16.741 21.818,15.838 23.897,13.352 31.639,6.574 31.639,4.788 29.411,5.045 ' + '23.897,10.118 17.535,18.057 11.184,23.831 13.704,24.479 17.589,21.104 20.361,18.246 23.897,19.299 31.639,23.65 ');
	                    em.append('path').style('fill', '#D62F28').attr('d', 'M30.735,10.193L30.735,10.193c-0.079-1.804-1.544-3.247-3.356-3.291c-1.813,0.044-3.278,1.487-3.357,3.291' + 'l0,0c-0.003,0.051-0.004,0.102-0.004,0.153c0,1.383,1.133,2.211,2.003,3.344c1.01,1.315,1.358,3.718,1.358,3.718' + 's0.348-2.402,1.357-3.718c0.87-1.133,2.003-1.961,2.003-3.344C30.739,10.295,30.737,10.244,30.735,10.193z');
	                    em.append('circle').style('fill', '#2A1A1D').attr('cx', 27.378).attr('cy', 10.211).attr('r', 1.018);
	                    em.append('path').style('fill', '#FFFEFE').attr('d', 'M21.818,7.268h-5.71c-1.497,0-3.383,0.222-4.963,1.524' + 'c-0.198,0.171-0.374,0.355-0.538,0.545v6.188c0.783,0.799,1.918,1.334,3.366,1.334c0.277,0,0.582-0.027,0.888-0.055' + 'c-0.14,0.332-0.278,0.609-0.278,1.082c0,0.858,0.443,1.385,0.831,1.884c-1.133,0.075-3.156,0.205-4.807,1.017v2.094' + 'c0.457-1.226,1.706-1.711,2.201-1.891c1.165-0.389,2.662-0.443,2.911-0.443c0.277,0,0.416,0,0.638,0.026' + 'c2.107,1.497,3.022,2.246,3.022,3.66c0,0.196-0.023,0.385-0.06,0.568l1.784-0.627c0.086-0.338,0.133-0.681,0.133-1.023' + 'c0-1.912-1.108-2.854-2.328-3.881l-0.998-0.775c-0.305-0.25-0.721-0.583-0.721-1.192c0-0.61,0.416-0.998,0.775-1.358' + 'c1.165-0.915,2.33-1.886,2.33-3.938c0-2.106-1.332-3.216-1.969-3.742h1.719L21.818,7.268z M17.162,15.308' + 'c-0.444,0.443-1.193,0.775-1.886,0.775c-2.385,0-3.466-3.077-3.466-4.935c0-0.72,0.139-1.469,0.61-2.051' + 'c0.444-0.555,1.22-0.915,1.941-0.915c2.301,0,3.492,3.104,3.492,5.101C17.854,13.782,17.798,14.669,17.162,15.308z');
	                    return;
	                case 'ssh':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 9.5 20.5)').style('fill', '#708EBC').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('SSH');
	                    return;
	                case 'ssdp':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 6.3 21.6)').style('fill', '#6FBF9B').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 13).text('SSDP');
	                    return;
	                case 'appleicloud':
	                    em.append('path').style('fill', '#64A2D8').attr('d', 'M31.191,22.593c0,1.831-1.484,3.316-3.316,3.316H14.66c-1.832,0-3.316-1.485-3.316-3.316V9.379' + 'c0-1.832,1.485-3.316,3.316-3.316h13.214c1.832,0,3.316,1.484,3.316,3.316V22.593z');
	                    em.append('path').style('fill', '#FFFFFF').attr('d', 'M16.154,20.95c-1.95,0-3.536-1.586-3.536-3.536c0-1.402,0.848-2.666,2.093-3.228' + 'c0.047-1.331,1.145-2.4,2.488-2.4c0.41,0,0.805,0.1,1.156,0.284c0.843-1.395,2.358-2.273,4.048-2.273' + 'c2.486,0,4.531,1.927,4.721,4.367c0.201,0.044,0.398,0.106,0.592,0.188c1.316,0.443,2.199,1.668,2.199,3.062' + 'c0,0.657-0.195,1.288-0.566,1.827c-0.418,0.717-1.689,1.709-2.381,1.702C24.277,20.916,16.154,20.95,16.154,20.95z');
	                    em.append('path').style('fill', '#64A2D8').attr('d', 'M28.687,18.823c0.281-0.398,0.447-0.884,0.447-1.409c0-1.09-0.711-2.014-1.695-2.331' + 'c-0.324-0.141-0.682-0.22-1.059-0.22c-0.014,0-0.027,0.001-0.039,0.001c0.01-0.11,0.016-0.221,0.016-0.332' + 'c0-2.185-1.77-3.954-3.953-3.954c-1.77,0-3.269,1.163-3.772,2.767c-0.305-0.468-0.832-0.777-1.432-0.777' + 'c-0.944,0-1.709,0.766-1.709,1.709c0,0.155,0.022,0.307,0.062,0.449C14.32,15,13.399,16.1,13.399,17.414' + 'c0,1.521,1.233,2.755,2.755,2.755h7.602h1.174h1.785v-0.021C27.562,20.041,28.285,19.534,28.687,18.823z');
	                    return;
	                case 'imaps':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 5.5 22)').style('fill', '#7E9E7B').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 13).text('iMAP');
	                    return;
	                case 'imap':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 5.5 22)').style('fill', '#7E9E7B').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 13).text('iMAP');
	                    return;
	                case 'openvpn':
	                    em.append('path').style('fill', '#F58220').attr('d', 'M26.288,24.972l-0.68-4.351c0.944-1.022,1.521-2.389,1.521-3.89' + 'c0-3.167-2.565-5.733-5.732-5.733s-5.733,2.566-5.733,5.733c0,1.501,0.579,2.867,1.523,3.89l-0.602,4.396' + 'c-2.852-1.66-4.771-4.748-4.771-8.286c0-5.294,4.29-9.583,9.583-9.583s9.583,4.289,9.583,9.583' + 'C30.98,20.236,29.096,23.302,26.288,24.972z');
	                    em.append('path').style('fill', '#1B3867').attr('d', 'M22.408,19.297l1.149,6.35h-4.32l1.176-6.34' + 'c-1.148-0.406-1.971-1.502-1.971-2.788c0-1.633,1.324-2.955,2.956-2.955s2.957,1.322,2.957,2.955' + 'C24.354,17.797,23.542,18.885,22.408,19.297z');
	                    return;
	                case 'pop3':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 6 22)').style('fill', '#D97373').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 12).text('POP3');
	                    return;
	                case 'dhcp':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 5 22)').style('fill', '#A0BB71').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 12).text('DHCP');
	                    return;
	                case 'dhcpv6':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 5 22)').style('fill', '#A0BB71').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 12).text('DHCP');
	                    return;
	                case 'irc':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 11 21)').style('fill', '#B572AB').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('IRC');
	                    return;
	                case 'unencryped_jabber':
	                    em.append('path').style('fill', '#FCB415').attr('d', 'M26.334,16.472c0-0.284-0.053-0.595-0.219-0.834c-0.332-0.479-1.043-0.631-1.539-0.329' + 'c-0.25,0.152-0.391,0.419-0.469,0.692c-0.156,0.543-0.084,1.163,0.025,1.708c0.035,0.175,0.07,0.35,0.119,0.521' + 'c0.018,0.062,0.025,0.151,0.066,0.203c0.07,0.09,0.24,0.116,0.346,0.099c0.314-0.054,0.236-0.572,0.227-0.793' + 'c-0.025-0.516-0.178-1.018-0.029-1.531c0.062-0.218,0.182-0.462,0.402-0.557c0.197-0.085,0.398,0.02,0.477,0.213' + 'c0.127,0.313,0.096,0.676,0.174,1.002c0.027,0.11,0.057,0.22,0.107,0.323c0.014,0.03,0.035,0.093,0.076,0.089' + 'c0.102-0.01,0.248-0.18,0.324-0.243c0.246-0.204,0.5-0.423,0.785-0.574c0.135-0.071,0.354-0.186,0.49-0.064' + 'c0.035,0.03,0.064,0.067,0.088,0.106c0.162,0.251,0.002,0.447-0.104,0.687c-0.135,0.31-0.273,0.617-0.469,0.895' + 'c-0.168,0.237-0.398,0.446-0.533,0.706c-0.088,0.168-0.137,0.352-0.1,0.54c0.029,0.153,0.146,0.245,0.303,0.21' + 'c0.117-0.027,0.195-0.127,0.262-0.219c0.119-0.166,0.229-0.336,0.348-0.502c0.227-0.318,0.496-0.618,0.688-0.962' + 'c0.232-0.414,0.344-0.883,0.342-1.354c0-0.387-0.139-0.975-0.588-1.057c-0.084-0.014-0.182-0.006-0.266,0.009' + 'c-0.104,0.018-0.209,0.052-0.305,0.099c-0.254,0.123-0.475,0.307-0.666,0.517c-0.117,0.132-0.225,0.296-0.365,0.402');
	                    em.append('path').style('fill', '#CB2026').attr('d', 'M25.91,6.934c-0.354,0.046-0.713,0.041-1.068,0.096c-0.682,0.106-1.336,0.317-1.975,0.573' + 'c-0.232,0.093-0.461,0.196-0.687,0.306c-0.084,0.041-0.212,0.072-0.279,0.139C21.866,8.08,21.87,8.16,21.866,8.205' + 'c-0.013,0.128-0.028,0.255-0.04,0.383c-0.048,0.493-0.082,1.001-0.012,1.493c0.023,0.159,0.072,0.447,0.268,0.478' + 'c0.301,0.047,0.534-0.322,0.682-0.527c0.346-0.477,0.736-0.921,1.303-1.134c0.664-0.252,1.426-0.311,2.129-0.359' + 'c1.975-0.135,4.133,0.226,5.588,1.681c0.207,0.206,0.402,0.426,0.568,0.667c0.65,0.943,0.996,2.016,1.162,3.142' + 'c0.078,0.529,0.131,1.063,0.01,1.591c-0.209,0.913-0.758,1.708-1.389,2.386c-0.432,0.463-0.916,0.883-1.424,1.263' + 'c-0.281,0.213-0.598,0.393-0.863,0.625c-0.305,0.268-0.559,0.603-0.752,0.959c-0.52,0.962-0.66,2.118-0.506,3.192' + 'c0.029,0.219,0.059,0.439,0.109,0.657c0.014,0.064,0.016,0.176,0.059,0.229c0.078,0.099,0.293,0.153,0.412,0.159' + 'c0.125,0.006,0.209-0.09,0.24-0.202c0.053-0.192,0.021-0.405-0.01-0.6c-0.062-0.396-0.119-0.795-0.102-1.197' + 'c0.033-0.743,0.32-1.435,0.834-1.974c0.523-0.548,1.23-0.863,1.826-1.321c1.199-0.925,2.273-2.173,2.686-3.656' + 'c0.148-0.531,0.197-1.094,0.129-1.64c-0.084-0.691-0.338-1.381-0.576-2.032c-0.725-1.984-1.969-3.871-3.947-4.779' + 'c-0.783-0.359-1.604-0.523-2.453-0.642C27.398,6.99,27,6.956,26.598,6.938C26.375,6.93,26.133,6.904,25.91,6.934');
	                    em.append('path').style('fill', '#CB2026').attr('d', 'M22.818,19.775c-0.385,0.056-0.498,0.364-0.426,0.713c0.092,0.445,0.441,0.785,0.789,1.054' + 'c0.891,0.687,2.041,1.058,3.162,1.008c0.438-0.019,0.914-0.091,1.314-0.277c0.215-0.1,0.441-0.457,0.148-0.611' + 'c-0.041-0.021-0.094-0.034-0.139-0.04c-0.127-0.022-0.271,0.032-0.393,0.067c-0.215,0.062-0.428,0.124-0.648,0.16' + 'c-0.656,0.105-1.369-0.045-1.914-0.436c-0.439-0.314-0.797-0.73-1.133-1.151C23.375,20.005,23.189,19.723,22.818,19.775');
	                    em.append('path').style('fill', '#CB2026').attr('d', 'M22.318,21.955c-0.099,0.013-0.211,0.009-0.295,0.07c-0.175,0.129,0.019,0.388,0.11,0.505' + 'c0.267,0.339,0.619,0.621,0.97,0.869c0.979,0.692,2.086,1.092,3.279,1.174c0.342,0.023,0.691-0.001,1.031-0.058' + 'c0.123-0.021,0.277-0.03,0.393-0.083c0.324-0.152,0.23-0.765-0.061-0.9c-0.125-0.06-0.328,0.02-0.461,0.037' + 'c-0.312,0.044-0.627,0.048-0.941,0.041c-0.826-0.021-1.707-0.275-2.426-0.677c-0.283-0.158-0.543-0.35-0.785-0.563' + 'c-0.148-0.13-0.299-0.343-0.492-0.408C22.553,21.931,22.41,21.942,22.318,21.955');
	                    em.append('path').style('fill', '#CB2026').attr('d', 'M22.514,23.791c-0.139,0.016-0.245,0.089-0.336,0.191c-0.063,0.072-0.123,0.137-0.159,0.227' + 'c-0.2,0.495,0.333,0.963,0.703,1.197c0.41,0.261,0.859,0.453,1.314,0.616c1.031,0.367,2.24,0.601,3.309,0.273' + 'c0.318-0.098,0.633-0.275,0.865-0.517c0.129-0.135,0.219-0.341-0.02-0.428c-0.143-0.051-0.314,0.08-0.441,0.132' + 'c-0.305,0.122-0.617,0.215-0.943,0.254c-0.43,0.053-0.814-0.043-1.227-0.146c-0.354-0.088-0.711-0.177-1.051-0.304' + 'c-0.291-0.108-0.58-0.237-0.836-0.417c-0.074-0.055-0.166-0.102-0.229-0.172c-0.203-0.229-0.357-0.498-0.576-0.717' + 'C22.793,23.889,22.658,23.774,22.514,23.791');
	                    em.append('path').style('fill', '#D97373').attr('d', 'M10.398,16.795v-1.558c0-0.002,0-0.004,0-0.006' + 'c0-1.677,0.942-3.209,2.992-3.209c2.008,0,3.039,1.532,3.039,3.209c0,0.002,0,0.004,0,0.006l1.665-0.17c0-0.002,0-0.004,0-0.006' + 'c0-2.626-2.113-4.755-4.723-4.755c-2.607,0-4.722,2.129-4.722,4.755c0,0.002,0,0.004,0,0.006v1.728H7.683v7.598h11.413v-7.598' + 'H10.398z');
	                    return;
	                case 'edonkey':
	                    em.append('circle').style('fill', '#74AA64').attr('cx', 25).attr('cy', 23).attr('r', 0.86);
	                    em.append('circle').style('fill', '#74AA64').attr('cx', 18).attr('cy', 23).attr('r', 0.86);
	                    em.append('polygon').style('fill', '#74AA64').attr('points', '24.658,7.511 26.215,9.664 31.838,9.664 36.146,8.707 30.283,8.169 ');
	                    em.append('polygon').style('fill', '#74AA64').attr('points', '18.137,7.511 16.581,9.664 10.958,9.664 6.649,8.707 12.513,8.169 ');
	                    em.append('polygon').style('fill', '#74AA64').attr('points', '15.146,13.674 17.792,14.212 21.487,14.393 25.047,14.212 27.59,13.674 23.582,7.584 21.368,7.032 19.154,7.619 ');
	                    em.append('path').style('fill', '#D1A047').attr('d', 'M20.28,6.253L20.25,6.294l1.109-0.295l1.187,0.297l-0.031-0.043l5.729,0.671' + 'c-1.848-1.59-4.248-2.555-6.876-2.555c-2.633,0-5.037,0.97-6.887,2.563L20.28,6.253z');
	                    em.append('path').style('fill', '#D1A047').attr('d', 'M26.807,10.664l2.426,3.685l-1.402,0.297l0.256,1.484v0.086c0,2.234-0.494,4.408-1.383,6.156' + 'c0.131,0.255,0.211,0.539,0.211,0.845c0,0.296-0.074,0.571-0.197,0.819c3.119-1.834,5.211-5.227,5.211-9.106' + 'c0-1.522-0.338-2.959-0.916-4.266H26.807z');
	                    em.append('path').style('fill', '#D1A047').attr('d', 'M16.18,23.217c0-0.207,0.042-0.403,0.104-0.589c-0.97-1.793-1.506-4.066-1.506-6.412v-0.075L15,14.665' + 'l-1.507-0.307l2.446-3.694h-4.215c-0.579,1.307-0.917,2.743-0.917,4.266c0,4.093,2.333,7.632,5.736,9.384' + 'C16.317,24.005,16.18,23.628,16.18,23.217z');
	                    em.append('path').style('fill', '#74AA64').attr('d', 'M26.812,14.882l-1.508,0.255l-3.818,0.343l-4.139-0.361l-1.331-0.236l-0.239,1.334' + 'c0,2.074,0.451,3.963,1.181,5.489c0.307-0.222,0.681-0.356,1.088-0.356c1.03,0,1.868,0.838,1.868,1.868' + 'c0,0.548-0.242,1.037-0.62,1.38c0.66,0.432,1.378,0.684,2.137,0.684c0.808,0,1.572-0.285,2.269-0.776' + 'c-0.32-0.335-0.521-0.787-0.521-1.287c0-1.03,0.838-1.868,1.867-1.868c0.332,0,0.641,0.094,0.91,0.247' + 'c0.699-1.508,1.129-3.356,1.129-5.38L26.812,14.882z');
	                    return;
	                case 'steam':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 2.6 22)').style('fill', '#ffffff').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 12).text('Steam');
	                    return;
	                case 'socks5':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 2.82 22.24)').style('fill', '#EFAA86').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 11).text('Socks5');
	                    return;
	                case 'ssdp':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 5.5 20.5)').style('fill', '#B572AB').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 14).text('ssdp');
	                    return;
	                case 'cnn':
	                    em.append('path').style('fill', '#CA2027').attr('d', 'M32.661,22.437c-0.805,0-1.549-0.401-1.992-1.072l-3.289-5.188c-0.019-0.029-0.051-0.046-0.084-0.046' + 'c-0.01,0-0.02,0.001-0.028,0.004c-0.043,0.012-0.072,0.051-0.072,0.096l0.001,3.819c0,1.315-1.071,2.387-2.388,2.387' + 'c-0.804,0-1.548-0.401-1.991-1.072l-3.29-5.188c-0.019-0.029-0.051-0.046-0.084-0.046c-0.009,0-0.019,0.001-0.028,0.004' + 'c-0.043,0.012-0.072,0.051-0.072,0.096l-0.003,4.137c0,1.135-0.926,2.059-2.064,2.059l-4.76,0.004c-3.686,0-6.685-2.999-6.685-6.685' + 'c0-3.687,2.999-6.686,6.685-6.686c0,0,2.319-0.002,2.431-0.001v1.493l-2.431,0.002c-2.862,0-5.191,2.329-5.191,5.191' + 's2.329,5.19,5.191,5.19l4.76,0.003c0.315,0,0.571-0.256,0.571-0.571l0.001-8.928c0-0.11,0.09-0.2,0.2-0.2' + 'c0.065,0,0.127,0.033,0.165,0.088l5.854,9.22c0.168,0.249,0.444,0.396,0.741,0.396c0.493,0,0.894-0.4,0.894-0.893l-0.002-8.61' + 'c0-0.11,0.09-0.2,0.2-0.2c0.065,0,0.128,0.033,0.165,0.088l5.854,9.22c0.168,0.249,0.444,0.396,0.742,0.396' + 'c0.492,0,0.893-0.4,0.893-0.893V9.054h1.493l0.001,10.996C35.047,21.365,33.976,22.437,32.661,22.437z' + 'M12.516,20.258c-2.48,0-4.498-2.024-4.498-4.513s2.018-4.514,4.498-4.514c0,0,2.32-0.004,2.431-0.003v1.514' + 'l-2.431-0.002c-1.657,0-3.005,1.348-3.005,3.005c0,1.665,1.348,3.02,3.005,3.02l2.804-0.004c0.188,0,0.341-0.152,0.341-0.341l0-6.98' + 'c0-1.315,1.071-2.387,2.387-2.387c0.807,0,1.554,0.403,1.998,1.079l3.277,5.143c0.02,0.029,0.051,0.046,0.084,0.046' + 'c0.01,0,0.02-0.001,0.028-0.004c0.043-0.012,0.072-0.051,0.072-0.096l0.006-3.781c0-1.315,1.071-2.387,2.387-2.387' + 'c0.808,0,1.554,0.403,1.997,1.079l3.277,5.143c0.02,0.029,0.051,0.046,0.085,0.046c0.009,0,0.019-0.001,0.028-0.004' + 'c0.043-0.012,0.072-0.051,0.072-0.096V9.054h1.504L32.86,20.05c0,0.11-0.09,0.2-0.199,0.2c-0.064,0-0.122-0.029-0.16-0.081' + 'l-5.858-9.227c-0.169-0.249-0.445-0.396-0.742-0.396c-0.493,0-0.894,0.4-0.894,0.893l0.002,8.61c0,0.11-0.09,0.2-0.2,0.2' + 'c-0.063,0-0.122-0.029-0.159-0.081l-5.859-9.227c-0.167-0.249-0.444-0.396-0.742-0.396c-0.493,0-0.894,0.4-0.894,0.893l0.004,8.678' + 'c0,0.078-0.063,0.143-0.141,0.143l0,0L12.516,20.258z');
	                    return;
	                case 'windowsupdate':
	                    em.append('polygon').style('fill', '#29ABE2').attr('points', '22.263,8.218 22.263,3.622 20.269,3.622 20.269,8.276 17.658,6.717 17.658,8.974 21.217,11.1 24.776,8.974 24.776,6.717 ');
	                    em.append('polygon').style('fill', '#29ABE2').attr('points', '20.824,19.116 20.824,13.749 28.4,12.644 28.4,19.116 ');
	                    em.append('polygon').style('fill', '#29ABE2').attr('points', '14.311,19.116 14.311,14.7 19.648,13.92 19.648,19.116');
	                    em.append('polygon').style('fill', '#29ABE2').attr('points', '14.311,24.771 14.311,20.291 19.648,20.291 19.648,25.559 ');
	                    em.append('polygon').style('fill', '#29ABE2').attr('points', '20.824,25.732 20.824,20.291 28.4,20.291 28.4,26.85');
	                    return;
	                case 'msn':
	                    em.append('path').style('fill', '#1A9FDA').attr('d', 'M10.416,9.304c-0.364,0.211-0.276,0.898,0.125,1.796' + 'c1.406,3.142,3.354,5.711,5.837,7.645c-0.252-1.248-0.172-2.277,0.263-3.182c0.423-0.893,1.201-1.499,2.323-1.797l-0.138-0.858' + 'c-1.934-1.762-4.149-3.109-6.648-3.775C11.638,8.988,11.002,8.962,10.416,9.304L10.416,9.304z');
	                    em.append('path').style('fill', '#F3A656').attr('d', 'M20.165,13.331c0.893,1.511,1.499,2.918,1.842,4.303l0.046,0.252' + 'l0.081,0.264c1.121,0.469,2.276,0.686,3.479,0.549c1.247-0.172,2.151-0.687,2.7-1.579l0.652-1.511' + 'c-0.824-1.499-2.197-2.448-4.12-2.792C23.208,12.564,21.664,12.736,20.165,13.331L20.165,13.331z');
	                    em.append('path').style('fill', '#055DA7').attr('d', 'M22.006,17.634c-0.343-1.385-0.949-2.792-1.842-4.303l-0.092-0.125' + 'l-0.469-0.733c-0.218-0.297-0.366-0.363-0.561-0.277c-0.204,0.09-0.298,0.243-0.218,0.587v0.125l0.138,0.858l0.034,0.298' + 'l1.545,4.257l0.171,0.344c0.516,0.812,1.076,1.499,1.637,2.014l-0.217-2.403l-0.081-0.389L22.006,17.634L22.006,17.634z');
	                    em.append('path').style('fill', '#EB5B2F').attr('d', 'M20.165,13.331c1.499-0.595,3.044-0.767,4.68-0.515' + 'c1.923,0.344,3.296,1.293,4.12,2.792c1.235-3.307,1.421-6.099,0.297-8.285c-0.198-0.387-0.509-0.723-0.857-0.983' + 'c-0.682-0.511-1.493-0.423-2.357,0c-3.438,1.683-5.539,3.776-6.271,6.305l0.297,0.562L20.165,13.331L20.165,13.331z');
	                    em.append('path').style('fill', '#08A84E').attr('d', 'M18.998,14.063l-0.034-0.298c-1.122,0.298-1.9,0.904-2.323,1.797' + 'c-0.435,0.904-0.515,1.934-0.263,3.182l0.903,0.606c0.905,0.275,1.802,0.425,2.667,0.126l0.766-0.812l-0.171-0.344L18.998,14.063' + 'L18.998,14.063z');
	                    em.append('path').style('fill', '#70BF54').attr('d', 'M17.281,19.351l-0.903-0.606c0.903,2.323,2.221,4.103,4.13,5.023' + 'c0.282,0.137,0.641,0.141,0.938,0.046c0.193-0.062,0.303-0.286,0.39-0.47c0.298-0.632,0.423-1.51,0.515-2.666' + 'c-0.561-0.515-1.121-1.201-1.637-2.014l-0.766,0.812C19.131,19.785,18.22,19.616,17.281,19.351L17.281,19.351z');
	                    em.append('path').style('fill', '#FFCB24').attr('d', 'M25.703,22.863c0.342,0.037,0.621-0.148,0.858-0.344' + 'c0.965-0.79,1.691-1.754,2.141-2.963c0.489-1.32,0.56-2.609,0.263-3.948l-0.652,1.511c-0.549,0.893-1.453,1.407-2.7,1.579' + 'c-1.202,0.137-2.357-0.08-3.479-0.549v0.125l0.217,2.403c0.767,0.812,1.706,1.522,2.792,2.014' + 'C25.321,22.772,25.508,22.843,25.703,22.863L25.703,22.863z');
	                    return;
	                case 'flash':
	                    em.append('path').style('fill', '#D91F26').attr('d', 'M27.738,6.285l-0.121,3.553c0,0-4.175,0.83-4.295,3.904h2.383l0.125,3.551l-4.178-0.117' + 'c0,0-1.792,7.338-8.477,7.221l-0.119-3.312c0,0,3.581,0.234,5.492-6.158C18.548,14.926,20.573,6.406,27.738,6.285z');
	                    return;
	                case 'stun':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 7.8 20.5)').style('fill', '#EFAA86').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 13).text('stun');
	                    return;
	                case 'rtmp':
	                    em.append('text').attr('transform', 'matrix(1 0 0 1 8 20.5)').style('fill', '#AE6498').attr('font-family', 'ITCAvantGardeStd-Bk').attr('font-size', 12).text('rtmp');
	                    return;
	                case 'ipsec':
	                    em.append('path').style('fill', '#2AAAE2').attr('d', 'M21.4,4c0,0-2.5,3.7-8.7,3.7c0,6.2,1.2,10.3,3.8,14.3c0.2,0.2,1.7,3.2,4.9,3.2c3.3,0,4.7-2.9,5.1-3.4' + 'c2.9-4.4,3.6-9.3,3.6-14.1C24.4,7.8,21.4,4,21.4,4z M21.8,22.9c0-4,0-15.1,0-15.1s2,2.2,6.7,2.2C28.4,13.5,24.8,22.9,21.8,22.9z');
	                    return;
	                case 'netflix':
	                    em.append('path').style('fill', '#E41E26').attr('d', 'M31.2,23.5c0.5,0,1,0.1,1.5,0.1v-8.9h-1.5V23.5z M6.8,20.2l-2-5.5H3.4v9.7c0.5-0.1,1-0.1,1.5-0.2' + 'v-5.3l1.8,5c0.6-0.1,1.1-0.1,1.7-0.2v-9.1H6.8V20.2z M9.8,23.6c1.4-0.1,2.8-0.2,4.2-0.3v-1.5c-0.9,0.1-1.8,0.1-2.7,0.2v-2.3' + 'c0.6,0,1.4,0,2,0v-1.5c-0.5,0-1.4,0-2,0v-2H14v-1.5H9.8V23.6z M14.9,16.2h1.6v7c0.5,0,1,0,1.5,0v-6.9h1.6v-1.5h-4.7V16.2z' + 'M20.6,23.1h1.5v-3.5h2.1v-1.5h-2.1v-2h2.7v-1.5h-4.2V23.1z M39.4,14.7h-1.7l-1.1,2.5l-1-2.5H34l1.8,4.6l-1.9,4.5' + 'c0.5,0.1,1.1,0.1,1.6,0.2l1.1-2.6l1.1,2.9c0.6,0.1,1.2,0.2,1.7,0.2l0,0l-2-5.1L39.4,14.7z M27.3,14.7h-1.5v8.5' + 'c1.4,0,2.8,0.1,4.1,0.2v-1.5c-0.9-0.1-1.7-0.1-2.6-0.1V14.7z');
	                    return;
	                case 'ldap':
	                    em.append('path').style('fill', '#21409A').attr('d', 'M8.7,12.7h1v8H13v0.9H8.7V12.7z M14,12.7h2.7c1.3,0,2.6,0.3,3.5,1.3c0.7,0.8,1.1,1.8,1.1,3.1c0,2.7-1.5,4.4-4.5,4.4H14V12.7z' + 'M15,20.7h1.8c2.3,0,3.5-1.4,3.5-3.5c0-1-0.3-1.9-0.9-2.6c-0.6-0.6-1.4-1-2.6-1H15V20.7z' + 'M22.3,21.6h-1.1l3.7-8.9h1l3.7,8.9h-1.1l-1-2.5h-4.1L22.3,21.6z M25.4,13.8l-1.8,4.4h3.5L25.4,13.8z' + 'M32.8,12.7c1.2,0,1.8,0.1,2.4,0.6c0.6,0.5,0.9,1.3,0.9,2.1c0,0.8-0.4,1.7-0.9,2.1' + 'c-0.6,0.5-1.2,0.6-2.3,0.6h-1.4v3.5h-1v-8.9H32.8z M31.5,17.2h1.4c0.7,0,1.2-0.1,1.6-0.4c0.4-0.3,0.7-0.8,0.7-1.4' + 'c0-0.6-0.3-1.2-0.7-1.5c-0.4-0.3-0.9-0.4-1.7-0.4h-1.4V17.2z');
	                    return;
	                case 'rtp':
	                    em.append('path').style('fill', '#58595B').attr('d', 'M10.9,11.5h2.9c1.7,0,2.5,0.2,3.1,0.6c0.9,0.5,1.5,1.7,1.5,3c0,0.8-0.2,1.5-0.7,2.2' + 'c-0.7,0.9-1.5,1.1-2.5,1.2l2.8,4.2h-1.4l-3.1-4.8h0.4c0.8,0,1.9,0,2.5-0.6c0.6-0.6,0.8-1.2,0.8-2c0-0.8-0.4-1.7-1.1-2.1' + 'c-0.6-0.4-1.2-0.4-2.2-0.4h-1.7v10h-1.2V11.5z' + 'M21.7,12.6h-2.7v-1.1h6.7v1.1h-2.7v10h-1.2V12.6z' + 'M29.8,11.5c1.6,0,2.3,0.2,3,0.7c0.7,0.6,1.2,1.6,1.2,2.6c0,1.1-0.5,2.1-1.1,2.6' + 'c-0.7,0.6-1.5,0.8-2.9,0.8h-1.8v4.4h-1.2V11.5H29.8z M28.2,17.1h1.8c0.9,0,1.5-0.1,2.1-0.5c0.5-0.3,0.8-1,0.8-1.8' + 'c0-0.8-0.3-1.5-0.8-1.8c-0.6-0.4-1.1-0.5-2.1-0.5h-1.7V17.1z');
	                    return;
	                case 'snmp':
	                    em.append('path').style('fill', '#A43D8C').attr('d', 'M9.4,15.8c0-0.7-0.5-1.1-1.1-1.1c-0.7,0-1.1,0.5-1.1,1c0,0.6,0.5,0.9,1.3,1.1c0.9,0.3,2,0.5,2,1.9' + 'c0,1.2-0.9,2.1-2.1,2.1c-1,0-2.2-0.7-2.2-2H7c0,0.9,0.7,1.3,1.3,1.3c0.7,0,1.3-0.6,1.2-1.2c0-0.7-0.5-1-1.6-1.4' + 'c-0.9-0.3-1.6-0.6-1.7-1.7c0-1.2,0.9-1.8,2-1.8c0.9,0,1.9,0.5,2,1.8H9.4z' + 'M11.9,14.2h0.8c0,0.4,0,0.7,0,1.2c0.4-0.8,1.2-1.4,2.4-1.3c2,0,2.7,1.4,2.7,3v3.7H17v-3.5' + 'c0-1.4-0.6-2.3-2.1-2.3c-1.3,0-2.1,0.8-2.1,2.2v3.6h-0.9V14.2z' + 'M19.6,14.2h0.8v1c0.4-0.8,1.3-1.2,2-1.2c0.7,0,1.3,0.2,1.8,0.7c0.2,0.2,0.4,0.6,0.4,0.7' + 'c0.1-0.2,0.2-0.4,0.5-0.7c0.4-0.4,1.1-0.7,1.8-0.7c0.7,0,1.3,0.2,1.7,0.6c0.6,0.6,0.7,1.3,0.7,2.4v3.6h-0.9v-3.5' + 'c0-0.7-0.1-1.3-0.5-1.7c-0.3-0.3-0.7-0.5-1.3-0.5c-0.6,0-1.1,0.2-1.4,0.7c-0.3,0.5-0.4,0.8-0.4,1.5v3.6H24v-3.6' + 'c0-0.7-0.1-1.1-0.3-1.5c-0.3-0.4-0.8-0.7-1.4-0.7c-0.6,0-1.1,0.3-1.4,0.7c-0.3,0.4-0.4,0.9-0.4,1.5v3.6h-0.9V14.2z' + 'M31.1,14.2h0.8v1.3c0.5-0.9,1.5-1.5,2.7-1.5c2.2,0,3.3,1.8,3.3,3.4c0,1.8-1.3,3.4-3.3,3.4' + 'c-1.4,0-2.4-0.8-2.7-1.5v1.3v2.4h-0.9V14.2z M37,17.4c0-1.2-0.9-2.6-2.6-2.6c-0.7,0-1.4,0.3-1.8,0.8c-0.4,0.5-0.7,1.1-0.7,1.8' + 'c0,0.7,0.3,1.4,0.7,1.8c0.5,0.5,1.1,0.7,1.8,0.7C35.9,20,37,18.9,37,17.4L37,17.4z');
	                    return;
	                case 'ciscovpn':
	                    em.append('path').style('fill', '#C82027').attr('d', 'M17.4,22l0,1.3l0.1,0c0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.5,0,0.8,0c0.3,0,0.5-0.1,0.7-0.1' + 'c0.3-0.1,0.5-0.2,0.8-0.4c0.2-0.2,0.4-0.4,0.4-0.6c0.2-0.4,0.2-0.9,0-1.3c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.3-0.6-0.3' + 'l-1-0.4c-0.1,0-0.2-0.1-0.3-0.3c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1-0.1,0.2-0.1,0.3-0.1' + 'c0.2,0,0.4,0,0.6,0c0.2,0,0.5,0.1,0.7,0.1l0.1,0v-1.2l-0.1,0c-0.2-0.1-0.5-0.1-0.7-0.1c-0.3,0-0.6,0-1,0c-0.4,0-0.8,0.2-1.1,0.4' + 'c-0.2,0.2-0.4,0.4-0.5,0.7c-0.1,0.4-0.1,0.8,0,1.2c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.1,0.3,0.2,0.4,0.3c0.2,0.1,0.4,0.2,0.7,0.3' + 'c0.1,0,0.2,0,0.2,0.1l0.1,0c0,0,0,0,0,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.2,0.3' + 'c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5-0.1-0.8-0.1C17.7,22.1,17.6,22.1,17.4,22L17.4,22' + 'M12.1,23.3v-1.5l0,0C11.7,21.9,11.3,22,11,22c-0.4,0-0.8-0.1-1.1-0.3c-0.2-0.2-0.4-0.4-0.5-0.7' + 'c-0.1-0.3-0.1-0.6,0-0.9c0.1-0.3,0.2-0.6,0.5-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.5-0.1,1,0,1.4,0.3l0,0v-1.5l-0.1,0' + 'c-0.4-0.1-0.9-0.2-1.4-0.2c-0.4,0-0.8,0.1-1.2,0.3c-0.4,0.2-0.7,0.4-1,0.8c-0.8,1.1-0.9,2.6-0.1,3.7c0.4,0.5,1,0.9,1.6,1' + 'c0.7,0.2,1.4,0.1,2-0.1L12.1,23.3' + 'M26.9,23.3v-1.5l0,0c-0.3,0.2-0.7,0.3-1.1,0.3c-0.4,0-0.8-0.1-1.1-0.3c-0.2-0.2-0.4-0.4-0.5-0.7' + 'c-0.1-0.3-0.1-0.6,0-0.9c0.1-0.3,0.2-0.6,0.5-0.8c0.2-0.2,0.5-0.3,0.8-0.3c0.5-0.1,1,0,1.4,0.3l0,0v-1.5l-0.1,0' + 'c-0.4-0.1-0.9-0.2-1.4-0.2c-0.4,0-0.8,0.1-1.2,0.3c-0.4,0.2-0.7,0.4-1,0.8c-0.8,1.1-0.9,2.6-0.1,3.7c0.4,0.5,1,0.9,1.6,1' + 'c0.7,0.2,1.4,0.1,2-0.1L26.9,23.3' + 'M28.4,20.5c0,0.9,0.4,1.7,1.1,2.3c0.7,0.6,1.6,0.8,2.5,0.6c1.2-0.2,2.1-1.2,2.3-2.3' + 'c0.2-1.2-0.3-2.4-1.4-3c-0.9-0.6-2.1-0.6-3-0.1C29,18.5,28.4,19.5,28.4,20.5 M30.5,19.4c0.3-0.2,0.7-0.4,1.1-0.3' + 'c0.4,0,0.7,0.2,1,0.5c0.2,0.3,0.4,0.7,0.3,1.1c0,0.4-0.2,0.7-0.5,1s-0.7,0.4-1.1,0.3c-0.4,0-0.7-0.2-1-0.5' + 'c-0.2-0.3-0.4-0.7-0.3-1.1C30,20,30.2,19.6,30.5,19.4');
	                    em.append('polygon').style('fill', '#C82027').attr('points', '15.5,23.4 15.5,17.7 14,17.7 14,23.4 15.5,23.4');
	                    em.append('path').style('fill', '#12393D').attr('d', 'M4.9,13.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2' + 'c0.1-0.1,0.2-0.3,0.2-0.5v-1.6c0-0.2-0.1-0.4-0.2-0.5C5.9,11,5.8,11,5.6,11c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5V13.2' + 'M8.8,13.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2' + 'c0.1-0.1,0.2-0.3,0.2-0.5V9.7c0-0.2-0.1-0.4-0.2-0.5C9.8,9.1,9.6,9,9.5,9C9.3,9,9.1,9.1,9,9.2C8.8,9.4,8.8,9.5,8.8,9.7V13.2' + 'M12.6,14.6c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2s0.2-0.3,0.2-0.5V7' + 'c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2S13,6.4,12.8,6.6c-0.1,0.1-0.2,0.3-0.2,0.5V14.6' + 'M16.5,13.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2' + 'c0.1-0.1,0.2-0.3,0.2-0.5V9.7c0-0.2-0.1-0.4-0.2-0.5C17.6,9.1,17.4,9,17.2,9c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5V13.2' + 'M20.4,13.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2' + 'c0.1-0.1,0.2-0.3,0.2-0.5v-1.6c0-0.2-0.1-0.4-0.2-0.5C21.4,11,21.3,11,21.1,11c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5' + 'V13.2' + 'M24.3,13.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5' + 'V9.7c0-0.2-0.1-0.4-0.2-0.5C25.3,9.1,25.1,9,25,9c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5V13.2' + 'M28.1,14.6c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5' + 'V7c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2s-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5V14.6' + 'M32,13.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2' + 'c0.1-0.1,0.2-0.3,0.2-0.5V9.7c0-0.2-0.1-0.4-0.2-0.5C33.1,9.1,32.9,9,32.7,9c-0.2,0-0.4,0.1-0.5,0.2C32.1,9.4,32,9.5,32,9.7V13.2' + 'M35.9,13.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2s0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5' + 'v-1.6c0-0.2-0.1-0.4-0.2-0.5C36.9,11,36.8,11,36.6,11s-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5V13.2' + 'M11.3,28h1.1l1.9,5.4l1.9-5.4h1.1l-2.5,6.7h-1.1L11.3,28z' + 'M20.7,28c1,0,1.5,0.1,1.9,0.4c0.5,0.4,0.7,1,0.7,1.6c0,0.6-0.3,1.3-0.7,1.6' + 'c-0.5,0.4-0.9,0.5-1.8,0.5h-0.9v2.4h-1.1V28H20.7z M19.8,31.3h0.9c0.4,0,0.7,0,1-0.2c0.3-0.2,0.5-0.5,0.5-1s-0.2-0.8-0.5-1' + 'c-0.3-0.2-0.6-0.2-1.1-0.2h-0.9V31.3z' + 'M29.2,33.1l0-5.1h1v6.7h-1l-3.5-5.1l0,5.1h-1V28h1L29.2,33.1z');
	                    return;
	                case 'http_proxy':
	                    em.append('path').style('fill', '#db8109').attr('d', 'M10.2,10.5h1.2v2.2v1c0.4-0.8,1.3-1.1,2.1-1.1c1,0,1.7,0.3,2.1,0.9c0.4,0.6,0.6,1.3,0.6,2.2v3.6' + 'h-1.3v-3.5c0-0.6-0.1-1.1-0.4-1.5c-0.3-0.4-0.7-0.6-1.4-0.6c-0.7,0-1.1,0.3-1.4,0.6c-0.3,0.3-0.4,0.8-0.4,1.3v3.7h-1.2V10.5z' + 'M18.4,13.8h-1.2v-1h1.2v-2.4h1.2v2.4h1.3v1h-1.3v5.6h-1.2V13.8z' + 'M22.4,13.8h-1.2v-1h1.2v-2.4h1.2v2.4h1.3v1h-1.3v5.6h-1.2V13.8z' + 'M26,12.9h1.2V14c0.5-0.8,1.3-1.3,2.5-1.3c2.2,0,3.3,1.9,3.3,3.5c0,1.8-1.3,3.4-3.3,3.4' + 'c-1.4,0-2.2-0.7-2.4-1.3v1.1v2.4H26V12.9z M31.7,16.1c0-1.1-0.8-2.3-2.3-2.3c-0.6,0-1.2,0.3-1.6,0.7c-0.4,0.4-0.6,1-0.6,1.6' + 'c0,0.6,0.2,1.2,0.6,1.6c0.4,0.4,1,0.7,1.6,0.7C30.8,18.4,31.7,17.4,31.7,16.1L31.7,16.1z' + 'M9.8,24.5c0.9,0,1.3,0.1,1.7,0.4c0.4,0.3,0.7,0.9,0.7,1.5c0,0.6-0.2,1.2-0.6,1.5' + 'c-0.4,0.3-0.8,0.4-1.6,0.4H9v2.2H8.1v-5.9H9.8z M9,27.4h0.8c0.4,0,0.7,0,0.9-0.2c0.2-0.1,0.4-0.4,0.4-0.8c0-0.4-0.2-0.7-0.4-0.8' + 'c-0.3-0.2-0.6-0.2-0.9-0.2H9V27.4z' + 'M13.1,24.5h1.7c0.9,0,1.4,0.1,1.7,0.3c0.5,0.3,0.8,0.9,0.8,1.6c0,0.4-0.1,0.8-0.3,1.1' + 'c-0.3,0.4-0.7,0.6-1.1,0.6l1.4,2.2h-1l-1.6-2.7h0.2c0.4,0,0.9,0,1.2-0.3c0.3-0.2,0.4-0.6,0.4-1c0-0.4-0.2-0.8-0.5-1' + 'c-0.3-0.2-0.6-0.2-1-0.2h-0.8v5.1h-0.9V24.5z' + 'M18.1,27.5c0-1.9,1.4-3.1,3.1-3.1c1.8,0,3.1,1.4,3.1,3.1s-1.3,3.1-3.1,3.1' + 'C19.5,30.5,18.1,29.1,18.1,27.5L18.1,27.5z M19.1,27.4c0,1.2,0.9,2.2,2.2,2.2c1.3,0,2.1-1.1,2.1-2.2c0-1.2-0.9-2.2-2.2-2.2' + 'C20,25.2,19.1,26.2,19.1,27.4L19.1,27.4z' + 'M26.8,27.3l-1.9-2.8H26l1.4,2.1l1.4-2.1h1.1l-1.9,2.8l2,3.1h-1.1L27.3,28l-1.5,2.4h-1L26.8,27.3z' + 'M32.4,28.3l-1.9-3.8h1l1.3,2.9l1.3-2.9h1l-1.9,3.8v2.1h-0.9V28.3z');
	                    return;
	                case 'nfs':
	                    em.append('path').style('fill', '#514033').attr('d', 'M22.5,20.7v-3.4h7.7l0-9.6l-7.7,0l-1.8-2.4h-7.2v12h7.1v3.4' + 'C19.6,21.1,19,22,19,23c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5C24,22,23.4,21.1,22.5,20.7z');
	                    em.append('rect').style('fill', '#514033').attr('x', 5.7).attr('y', 22).attr('width', 11.5).attr('height', 2);
	                    em.append('rect').style('fill', '#514033').attr('x', 25.8).attr('y', 22).attr('width', 11.5).attr('height', 2);
	                    return;
	                case 'syslog':
	                    em.append('path').style('fill', '#58595B').attr('d', 'M9.9,11c0.4-0.2,2-1,2.3-1.2c1.6,0.6,3.6,1.4,5.7,1.8' + 'c0.2-0.8,1.1-5.2,1.1-5.2L21.4,5l2.4,1.3c0,0,0.9,5.2,1.1,5.2c2.2-0.3,5.4-1.8,5.4-1.8l2.6,1.3c0,0,0,1.6,0,2.4c0,0.1-3.4,2.3-4.8,4' + 'c0.5,0.6,3.5,3.2,4.8,3.9c0,0.8,0,2.4,0,2.4l-2.6,1.3c0,0-4.2-1.5-5.4-1.8c-0.2,0-1.1,4.6-1.1,5.2c0,0.1-2.3,1.3-2.3,1.3' + 'S19,28.7,19,28.7c0-0.3-0.9-5.2-1.1-5.2c-1.4,0.2-5.5,1.8-5.5,1.8L9.9,24v-2.7c0,0,4.1-3.2,4.8-3.9c-1-1.1-4.2-3.5-4.8-3.8' + 'C9.9,12.8,9.9,11.9,9.9,11z M21.4,17.4l-10.7-5.6c0,0,0,1.1,0,1.5c4.8,2.8,8.6,7.6,9.1,15c0.2,0.1,1.6,0.8,1.6,0.8L21.4,17.4z' + ' M32,11.5c0,0-1.6-0.8-1.6-0.8c-5,2.1-11.2,2.7-18-0.1C12,10.7,11,11.2,11,11.2l10.5,5.6L32,11.5z M21.4,7.6c0,0,0.8,4.3,0.8,4.3' + 'l1.7-0.2l-1-4.9l-1.6-0.9l-1.5,0.9l-0.9,4.8l1.6,0.2C20.5,11.9,21.4,7.6,21.4,7.6z M10.8,23.4l1.5,0.8l0.1-1.7l3.8-2.9l-1-1.3' + 'l-4.5,3.5L10.8,23.4z M27.5,18.3l-0.9,1.2l3.8,3.1c0,0,0.9-0.5,1.4-0.7C31.9,21.8,27.5,18.3,27.5,18.3z');
	                    return;
	                case 'sip':
	                    em.append('path').style('fill', '#F26522').attr('d', 'M19,20.4c0,1.4-1,2.7-2.9,2.7c-1.8,0-2.9-1.1-2.9-2.8h1.4c0.1,1.3,1,1.6,1.5,1.6' + 'c0.8,0,1.5-0.6,1.5-1.4c0-1-0.8-1.2-2-1.6c-0.7-0.2-2.2-0.7-2.2-2.4c0-1.7,1.4-2.6,2.8-2.6c1.1,0,2.6,0.6,2.7,2.4h-1.4' + 'c-0.1-0.5-0.3-1.2-1.3-1.2c-0.7,0-1.3,0.5-1.3,1.2c0,0.9,0.7,1.1,2.1,1.6C17.9,18.4,19,18.9,19,20.4z M21.9,14h-1.4v8.9h1.4V14z' + ' M29,19c-0.6,0.5-1.2,0.7-2.4,0.7h-1.2v3.2h-1.4V14h2.5c1.4,0,2,0.2,2.5,0.6c0.6,0.5,1,1.3,1,2.2S29.5,18.5,29,19z M28.5,16.8' + 'c0-0.6-0.3-1.1-0.6-1.3c-0.4-0.2-0.8-0.3-1.4-0.3h-1.2v3.1h1.2c0.6,0,1-0.1,1.4-0.3C28.3,17.9,28.5,17.4,28.5,16.8z M20.7,7.9h1.4' + 'v-5h-1.4V7.9z M9.4,28.7l1,1l3.7-3.7l-1-1L9.4,28.7z M31.7,17.7v1.4h5v-1.4L31.7,17.7z M28.9,26.1l3.5,3.5l1-1l-3.5-3.5L28.9,26.1z' + ' M33.8,8.2l-1-1l-3.2,3.2l1,1L33.8,8.2z M10.5,17.7l-5,0v1.4h5V17.7z M20.7,33.9h1.4v-5h-1.4V33.9z M13.6,10.3L10.3,7l-1,1l3.3,3.3' + 'L13.6,10.3z');
	                    return;
	                case 'lastfm':
	                    em.append('path').style('fill', '#E11F26').attr('d', 'M11.5,22.4l-0.4-1.1c0,0-0.7,0.8-1.7,0.8c-0.9,0-1.6-0.8-1.6-2.1c0-1.6,0.8-2.2,1.6-2.2' + 'c1.2,0,1.5,0.8,1.9,1.7l0.4,1.3c0.4,1.3,1.2,2.3,3.5,2.3c1.6,0,2.7-0.5,2.7-1.8c0-1.1-0.6-1.6-1.7-1.9l-0.8-0.2' + 'c-0.6-0.1-0.8-0.4-0.8-0.8c0-0.4,0.4-0.7,0.9-0.7c0.6,0,1,0.2,1,0.8l1.3-0.2c-0.1-1.2-0.9-1.7-2.3-1.7c-1.2,0-2.4,0.4-2.4,1.9' + 'c0,0.9,0.4,1.5,1.5,1.7l0.9,0.2c0.7,0.2,0.9,0.4,0.9,0.8c0,0.5-0.5,0.7-1.4,0.7c-1.3,0-1.9-0.7-2.2-1.7l-0.4-1.3' + 'c-0.6-1.7-1.4-2.4-3.2-2.4c-1.9,0-3,1.2-3,3.3c0,2,1,3.1,2.9,3.1C10.8,23.1,11.5,22.4,11.5,22.4L11.5,22.4z' + 'M5.8,21.8c-0.1,0-0.3,0.1-0.4,0.1c-0.3,0-0.5-0.1-0.5-0.5v-7.2H3.5v7.5c0,1,0.7,1.4,1.5,1.4' + 'c0.3,0,0.5,0,0.8-0.1L5.8,21.8L5.8,21.8z' + 'M22.5,21.6c-0.3,0.2-0.6,0.4-1,0.4c-0.5,0-0.8-0.3-0.8-0.9v-3.1h1.8v-1.1h-1.8v-1.5l-1.4,0.2v1.3' + 'h-0.9v1.1h0.9v3.4c0,1.2,0.7,1.8,1.8,1.8c0.6,0,1.2-0.1,1.6-0.4L22.5,21.6L22.5,21.6z' + 'M23.7,22.1c0,0.5,0.4,1,1,1c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1C24.2,21.1,23.7,21.5,23.7,22.1' + 'L23.7,22.1z' + 'M27.1,17.9v5h1.4v-5h1.6v-1.1h-1.6v-0.6c0-0.8,0.4-1.1,0.9-1.1c0.4,0,0.7,0.1,1,0.3l0.2-1.2' + 'c-0.4-0.2-0.8-0.3-1.3-0.3c-1.2,0-2.2,0.6-2.2,2.2v0.6h-0.9v1.1H27.1L27.1,17.9z' + 'M35.6,18c-0.2-1-0.8-1.3-1.7-1.3c-0.8,0-1.6,0.4-1.9,1.3l-0.2-1.2h-1.1V23h1.4v-3.5' + 'c0-1.2,0.6-1.6,1.3-1.6c0.7,0,1,0.4,1,1.2V23h1.4v-3.5c0-1.2,0.6-1.6,1.3-1.6c0.7,0,0.9,0.4,0.9,1.2V23h1.4v-4.4' + 'c0-1.3-0.8-1.9-1.8-1.9C36.7,16.7,35.9,17.1,35.6,18L35.6,18z');
	                    return;
	                case 'pops':
	                    em.append('path').style('fill', '#B6545A').attr('d', 'M13.4,21.5c1.3,0,1.8,0.2,2.3,0.5c0.6,0.4,0.9,1.2,0.9,2s-0.3,1.6-0.8,2c-0.6,0.4-1.1,0.6-2.2,0.6' + 'h-1.1v3h-1.3v-8.1H13.4z M12.4,25.5h1.1c0.5,0,0.9-0.1,1.3-0.3c0.3-0.2,0.6-0.6,0.6-1.2s-0.3-1-0.6-1.2c-0.4-0.2-0.8-0.3-1.3-0.3' + 'h-1.1V25.5z' + 'M17.1,25.6c0-2.6,2-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.2c0,2.3-1.8,4.2-4.3,4.2' + 'C18.9,29.8,17.1,27.9,17.1,25.6L17.1,25.6z M18.4,25.6c0,1.7,1.3,3.1,3,3.1c1.8,0,2.9-1.5,2.9-3.1c0-1.6-1.2-3.1-3-3.1' + 'C19.6,22.5,18.4,24,18.4,25.6L18.4,25.6z' + 'M29.1,21.5c1.3,0,1.8,0.2,2.3,0.5c0.6,0.4,0.9,1.2,0.9,2s-0.3,1.6-0.8,2c-0.6,0.4-1.1,0.6-2.2,0.6' + 'h-1.1v3h-1.3v-8.1H29.1z M28.1,25.5h1.1c0.5,0,0.9-0.1,1.3-0.3c0.3-0.2,0.6-0.6,0.6-1.2s-0.3-1-0.6-1.2c-0.4-0.2-0.8-0.3-1.3-0.3' + 'h-1.1V25.5z' + 'M28.4,6.4l-7,5.4l-7-5.4H28.4z M29.2,16.4H13.6v-9l7.8,5.6l7.8-5.6V16.4z');
	                    return;
	                case 'smb':
	                    em.append('path').style('fill', '#0C8E81').attr('d', 'M10.1,30.2c0.1,1.4,1.1,1.6,1.5,1.6c0.8,0,1.5-0.6,1.5-1.5c0-1-0.9-1.2-2-1.7' + 'c-0.7-0.2-2.3-0.8-2.3-2.5c0-1.7,1.4-2.6,2.9-2.6c1.2,0,2.7,0.6,2.8,2.5h-1.4c-0.1-0.5-0.3-1.3-1.4-1.3c-0.7,0-1.4,0.5-1.4,1.3' + 'c0,0.9,0.7,1.1,2.2,1.7c1.1,0.5,2.2,1.1,2.2,2.6c0,1.5-1,2.8-3,2.8c-1.8,0-3-1.1-3-2.9H10.1z M16.2,32.9v-9.2h2l2.8,7.1l2.8-7.1h2' + 'v9.2h-1.4l0-7.7l-3,7.7h-1l-3-7.7l0,7.7H16.2z M28,23.7h2.7c0.9,0,1.5,0.2,1.9,0.5c0.7,0.4,0.9,1.1,0.9,1.9c0,1-0.5,1.6-1.2,1.9' + 'c1.6,0.5,1.7,1.9,1.7,2.3c0,0.9-0.4,1.7-1.1,2.1c-0.6,0.4-1.2,0.5-2.3,0.5H28V23.7z M29.4,27.5h1.2c0.3,0,0.7,0,0.9-0.1' + 'c0.5-0.2,0.6-0.6,0.6-1.1c0-0.6-0.3-0.9-0.6-1.1c-0.2-0.1-0.5-0.2-1-0.2h-1.2V27.5z M29.4,31.6h1.5c0.3,0,0.7,0,1-0.1' + 'c0.4-0.2,0.8-0.6,0.8-1.3c0-0.6-0.3-1.1-0.8-1.3c-0.4-0.1-0.7-0.2-1.1-0.2h-1.4V31.6z M22,21.6v-4.9h6.8l0-8.5l-6.9,0l-1.6-2.1H14' + 'v10.6h6.3v4.9H22z M34.1,19.5H8.7v1h25.4V19.5z');
	                    return;
	                case 'vmware':
	                    em.append('path').style('fill', '#414042').attr('d', 'M5.1,20.2c0.2-0.6,1-2.4,1.2-2.8C7,16,8.6,15.9,9.6,16.9' + 'c0,0,0.1,0.1,0.1,0.1c0.5-0.4,1.1-0.8,1.8-0.8c0.7,0,1.3,0.2,1.7,0.7c0.4-0.2,0.7-0.4,1.1-0.6c1-0.3,2.1,0,2.5,0.9' + 'c0.1,0.3,0.2,0.6,0.2,0.9c0,1.1,0,2.2,0,3.3c0,0.6-0.4,0.9-0.9,0.9c-0.4,0-0.8-0.4-0.8-0.9c0-0.9,0-1.9,0-2.8c0-0.4-0.1-0.6-0.5-0.8' + 'c-0.3-0.2-0.7-0.1-1,0.1c-0.3,0.2-0.3,0.5-0.3,0.8c0,0.9,0,2.9-0.1,3c-0.1,0.4-0.4,0.6-0.9,0.5c-0.4,0-0.6-0.3-0.7-0.7' + 'c0-0.1,0-2.1,0-3c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.2-0.7-0.2-1,0c-0.3,0.2-0.4,0.5-0.4,0.8c0,0.9,0,1.8,0,2.8c0,0.6-0.6,1-1.2,0.8' + 'c-0.3-0.1-0.5-0.5-0.5-0.9c0-1.1,0-2.1,0-3.2c0,0-0.1-0.4-0.2-0.4c-0.1-0.1-0.2,0-0.3,0.2c-0.2,0.5-1.3,2.8-1.6,3.4' + 'c-0.1,0.2-0.2,0.3-0.3,0.5c-0.4,0.6-1.3,0.6-1.7,0c-0.2-0.2-1.5-3.2-2.1-4.5c-0.2-0.4-0.1-0.7,0.2-1c0.3-0.2,0.7-0.3,1,0' + 'c0.1,0.1,0.2,0.2,0.3,0.4C4.1,17.8,5.1,20.1,5.1,20.2z M18.2,16.7c-0.1-0.3-0.3-0.4-0.6-0.3c-0.2,0.1-0.3,0.3-0.2,0.6' + 'c0.6,1.6,1.2,3.3,1.8,4.9c0.1,0.3,0.3,0.4,0.5,0.4c0.3,0,0.4-0.2,0.5-0.4c0.2-0.6,1.2-3.3,1.4-4.1c0,0.1,1.2,3.4,1.4,4.1' + 'c0.1,0.2,0.2,0.4,0.5,0.4c0.2,0,0.4-0.1,0.5-0.3c0,0,1.7-4.8,1.8-5c0.1-0.3-0.1-0.5-0.5-0.5c-0.2,0-0.3,0.2-0.4,0.4' + 'c-0.3,0.8-1.2,3.6-1.4,4.1c0-0.1-1-2.9-1.4-4.1c-0.1-0.3-0.2-0.4-0.5-0.4c-0.2,0-0.4,0.1-0.5,0.4c-0.1,0.3-1.1,3.1-1.4,4.1' + 'C19.6,20.5,18.6,17.8,18.2,16.7z M30,21.7c0,0.3,0.1,0.5,0.4,0.5c0.3,0,0.4-0.2,0.4-0.5c0-0.4,0-2.7,0-3.5c0-0.9-0.6-1.5-1.4-1.7' + 'c-0.9-0.2-1.8-0.2-2.7,0.2c-0.2,0.1-0.3,0.3-0.3,0.5c0.1,0.2,0.3,0.3,0.5,0.2c0.5-0.2,1-0.3,1.6-0.2c0.9,0,1.5,0.8,1.4,1.7' + 'c0,0-1.3-0.2-1.9-0.2c-0.5,0-1,0.1-1.4,0.4c-0.8,0.5-1.1,1.6-0.5,2.4c0.4,0.6,1,0.8,1.7,0.9c0.9,0,1.6-0.2,2.2-1' + 'C30,21.5,30,21.6,30,21.7z M29.8,19.5c0.1,0,0.2,0.1,0.2,0.2c0,0.2,0,0.5-0.1,0.7c-0.2,0.7-0.7,1-1.4,1.2c-0.5,0.1-1,0.1-1.4-0.3' + 'c-0.6-0.4-0.6-1.3,0-1.7c0.3-0.2,0.7-0.2,1.3-0.3C28.9,19.4,29.4,19.4,29.8,19.5z M39.9,19.6c0.3,0,0.4-0.1,0.4-0.4' + 'c0-0.3,0-0.5-0.1-0.8c-0.5-2.2-2.8-2.5-4.1-1.5c-0.8,0.6-1.1,1.4-1.2,2.4c0,0.8,0.2,1.5,0.7,2.1c0.7,0.8,1.7,1.1,2.8,0.9' + 'c0.6-0.1,1.1-0.4,1.5-0.8c0.2-0.2,0.2-0.4,0-0.5c-0.1-0.2-0.4-0.2-0.5,0c0,0-0.1,0.1-0.1,0.1c-0.6,0.5-1.3,0.7-2,0.5' + 'c-0.9-0.2-1.4-1-1.5-1.8C36,19.6,39.7,19.6,39.9,19.6z M35.9,19c0.1-0.7,0.3-1.2,0.9-1.6c0.6-0.4,1.2-0.4,1.8-0.1' + 'c0.7,0.4,0.9,1,1,1.7C38.3,19,37.1,19,35.9,19z M32.7,16.8c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4c0,1.7,0,3.4,0,5' + 'c0,0.1,0.1,0.3,0.2,0.4c0.3,0.2,0.6,0,0.6-0.4c0-0.7,0-1.3,0-2c0-0.7,0.2-1.4,0.7-1.9c0.4-0.4,0.8-0.5,1.3-0.6' + 'c0.3,0,0.4-0.2,0.4-0.5c0-0.2-0.2-0.4-0.5-0.4c-0.4,0-0.8,0.1-1.1,0.4c-0.3,0.3-0.6,0.6-0.8,0.8C32.7,17.3,32.7,17,32.7,16.8z');
	                    return;
	                case 'kerberos':
	                    em.append('path').style('fill', '#58595B').attr('d', 'M39.8,15c-0.2,0.2-1.2,1.2-1.7,1.2c-0.1,0-4.4-1.1-4.7-1' + 'c-0.6,0-1.2,2.1-1.1,2.4c0.4-0.1,4.2-0.9,5.7-0.3c0.2,0.1-0.2,1-0.3,1c-0.5-0.2-3.7,0.5-4.1,0.6c-0.8,0.2-1.5,0.1-2.3-0.1' + 'c-1.6-0.4-4.4,0.9-4.4,0.9c-0.3-0.4-5.4-4.8-5.3-4.9c1-1,2-2,3.3-2.7c0.9-0.4,1.3-1.1,1.2-2.1c-0.1-0.6-0.1-1.2-0.2-1.8' + 'c0,0,0-0.1,0-0.2c2.4,0,2.8,2.3,2.8,3.1c1.5-0.2,3,0.1,4.3,0.7c0.3,0.1,3,1.8,4.2,2.2C38,14.3,39.8,14.9,39.8,15z M31.3,12.9' + 'c-0.1,0.3-0.1,0.5,0.1,0.8c0.2,0.1,0.4,0.2,0.6,0.1c0.3-0.1,0.4-0.4,0.3-0.7c0.2,0,1,0.1,1-0.3c-0.6-0.1-2.8-0.5-3.3-0.7' + 'C29.9,12.3,30.9,12.7,31.3,12.9z M18.9,5.3c-0.1,0.7-0.2,1.3-0.2,2c-0.1,0.7,0.1,1.3,0.7,1.8c0,0,3.8,2.8,3.9,2.9' + 'c-0.9,0.6-1.8,1.3-2.3,1.9c0,0,0.2-1.4,0.2-1.8c0-0.3-0.6-0.5-1-0.5c-1.9,0-3.3,1.8-3.3,3c-2.2,0-3.4,0.3-4.9,1.4' + 'c-0.2,0.1-1.7-0.3-2.2-0.6c-0.5-0.2-2.3-0.1-2.7,0c-0.2,0.1-0.6-0.9-0.2-1.1c1.8-0.7,5.5,0.3,5.7,0.3c0-0.4-0.7-2.6-1.6-2.4' + 'c-0.5,0.1-3.9,1.3-4.1,1.1c0,0-1.4-0.8-1.9-1.4c0.5-0.2,5.3-2.1,5.7-2.4c1.6-1.2,3.4-1.6,5.4-1.4c0-0.3,0-0.6,0.1-0.9' + 'C16.4,5.3,18.8,5.3,18.9,5.3z M11.4,10c0.1,0.4,0.8,0.4,1,0.3c0,0.5,0.2,0.8,0.6,0.7c0.4,0,0.6-0.3,0.5-0.9c0.4-0.1,1.4-0.5,1.2-0.9' + 'C13.8,9.8,12.6,10,11.4,10z M20.4,12.7c-0.1,0.5-0.1,1-0.2,1.5c-0.1,0.6-0.1,1.3,0.3,1.9c0.2,0.3,0.4,0.5,0.7,0.6' + 'c0.9,0.4,1.7,1,2.5,1.7c1.9,1.8,5,6.9,5.2,7.4c0,0,0,0,0,0c0.1,0.4,0,0.5-0.4,0.7c-2.2,0.8-6.7,2.5-6.8,2.6c0.1-0.6,0-1.1-0.2-1.6' + 'c-0.6-1.8-1.6-3.1-3.3-3.8c-1.1-0.5-2.2-0.5-3.4-0.2c-1.1,0.3-4-0.8-4.5-0.8c-0.6-0.1-1.2,0.1-1.8,0.3c-0.2,0.1-0.6-0.9-0.2-1' + 'c1.8-0.7,5.7,0.3,5.7,0.3c0.1-0.6-0.6-2.4-1.1-2.4c-0.5,0-4.8,1.1-4.9,1c-0.3-0.1-1.3-0.9-1.7-1.2c0.5-0.2,5.3-2,5.8-2.4' + 'c1-0.8,2.2-1.2,3.5-1.3c0.6-0.1,1.2,0,1.8,0c0-1,0.2-1.8,1-2.4C19,13,19.8,12.7,20.4,12.7z M15.2,17.4c0.4-0.1,1.5-0.7,1.3-0.9' + 'c-1.1,0.6-2.3,0.8-3.5,0.8c0,0.3,0.8,0.4,1,0.4c0,0.6,0.3,0.8,0.7,0.7C15.1,18.3,15.3,17.9,15.2,17.4z');
	                    return;
	                case 'icmp':
	                    em.append('path').style('fill', '#3D6B8E').attr('d', 'M5.7,11H7v1.4H5.7V11z M5.7,13.6H7v7.1H5.7V13.6z M15.9,18.2c-0.4,1.5-1.8,2.7-3.6,2.7' + 'c-2.3,0-3.8-1.8-3.8-3.7c0-2.1,1.6-3.7,3.7-3.7c1.7,0,3.2,1,3.7,2.7h-1.4c-0.4-0.9-1.2-1.5-2.2-1.5c-0.7,0-1.2,0.2-1.7,0.7' + 'c-0.4,0.4-0.7,1.1-0.7,1.8c0,1.5,1.1,2.5,2.4,2.5c1.2,0,1.9-0.7,2.2-1.4H15.9z M17.3,13.6h1.3v1c0.3-0.6,1.1-1.2,2.1-1.2' + 'c0.6,0,1.3,0.2,1.8,0.8c0.2,0.2,0.4,0.6,0.5,0.7c0.1-0.2,0.3-0.5,0.5-0.7c0.5-0.5,1.1-0.7,1.9-0.7c0.6,0,1.4,0.2,1.9,0.7' + 'c0.6,0.6,0.8,1.3,0.8,2.7v3.9h-1.4v-3.8c0-0.6-0.1-1.2-0.4-1.6c-0.2-0.4-0.6-0.6-1.3-0.6c-0.6,0-1.1,0.2-1.4,0.7' + 'c-0.3,0.4-0.3,0.8-0.3,1.4v3.9H22v-3.9c0-0.6-0.1-1-0.3-1.4c-0.3-0.4-0.7-0.7-1.3-0.7c-0.6,0-1.1,0.3-1.3,0.7' + 'c-0.3,0.4-0.4,0.9-0.4,1.4v3.9h-1.4V13.6z M29.9,13.6h1.3v1.2c0.5-0.8,1.4-1.4,2.7-1.4c2.4,0,3.6,2,3.6,3.8c0,2-1.4,3.7-3.6,3.7' + 'c-1.5,0-2.3-0.8-2.7-1.4v1.2v2.6h-1.4V13.6z M36.1,17.1c0-1.2-0.8-2.5-2.5-2.5c-0.7,0-1.3,0.3-1.8,0.7c-0.4,0.4-0.7,1.1-0.7,1.8' + 'c0,0.7,0.3,1.3,0.7,1.8s1.1,0.7,1.8,0.7C35.1,19.6,36.1,18.5,36.1,17.1L36.1,17.1z');
	                    return;
	                case 'tds':
	                    em.append('path').style('fill', '#4378BC').attr('d', 'M13.8,16h-1.8v-1.4h5.1V16h-1.7v6.7h-1.6V16z M18.4,14.5H21c1,0,2.5,0.1,3.5,1.4' + 'c0.6,0.7,0.8,1.7,0.8,2.7c0,2.3-1.2,4.1-4.2,4.1h-2.7V14.5z M20,21.2h1.2c1.8,0,2.4-1.2,2.4-2.6c0-0.6-0.2-1.3-0.5-1.8' + 'c-0.3-0.4-0.9-0.8-1.9-0.8H20V21.2z M27.9,20.1c0.1,1.1,0.8,1.3,1.1,1.3c0.6,0,1.1-0.5,1.1-1.1c0-0.7-0.6-0.9-1.7-1.3' + 'c-0.6-0.2-2-0.7-2-2.3c0-1.6,1.4-2.4,2.7-2.4c1.1,0,2.5,0.6,2.6,2.4H30c-0.1-0.4-0.2-1-1-1c-0.5,0-1,0.4-1,0.9' + 'c0,0.6,0.4,0.8,1.8,1.3c1.2,0.5,1.9,1.1,1.9,2.3c0,1.3-0.8,2.5-2.7,2.5c-1.8,0-2.8-1.1-2.8-2.7H27.9z M19.6,12.3l16,0.9l-1.7,5.7' + 'l5.3-6l-8.6-4.7l4.8,4L19.6,12.3z M7.9,24.1l1.8-4l-5.6,4.7l9.3,6l-5.7-5.7l16-0.9L7.9,24.1z');
	                    return;
	                case 'sflow':
	                    em.append('path').style('fill', '#4378BC').attr('d', 'M16.4,13.3c0,0.4-0.2,0.5-0.6,0.5h-3.2v3.3h2.9c0.4,0,0.6,0.2,0.6,0.6c0,0.2-0.1,0.3-0.2,0.4' + 'c-0.1,0.1-0.2,0.2-0.4,0.2h-3v3.8c0,0.4-0.2,0.7-0.7,0.7c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5v-8.8c0-0.2,0-0.3,0.1-0.5' + 'c0.1-0.2,0.3-0.2,0.4-0.2h4.1C16.2,12.7,16.4,12.9,16.4,13.3z');
	                    elm.append('circle').attr('r', 1).attr('cx', 21.3).attr('cy', 12.8).style('fill', '#2D5FD2').attr('fill-opacity', 1);
	                    elm.append('circle').attr('r', 0.9).attr('cx', 24.8).attr('cy', 12.8).style('fill', '#2D5FD2').attr('fill-opacity', 1);
	                    elm.append('circle').attr('r', 0.8).attr('cx', 27.9).attr('cy', 12.8).style('fill', '#2D5FD2').attr('fill-opacity', 1);
	                    elm.append('circle').attr('r', 0.6).attr('cx', 31.1).attr('cy', 12.8).style('fill', '#2D5FD2').attr('fill-opacity', 1);
	                    elm.append('circle').attr('r', 0.4).attr('cx', 34.6).attr('cy', 12.8).style('fill', '#2D5FD2').attr('fill-opacity', 1);
	                    elm.append('circle').attr('r', 0.2).attr('cx', 21.3).attr('cy', 12.8).style('fill', '#2D5FD2').attr('fill-opacity', 1);
	                    em.append('path').style('fill', '#404041').attr('d', 'M9.9,20.6c0,0.4-0.1,0.7-0.4,1.1c-0.2,0.3-0.6,0.6-1,0.8c-0.5,0.2-1,0.3-1.7,0.3' + 'c-1.1,0-2-0.3-2.7-0.8c-0.2-0.1-0.3-0.3-0.4-0.6c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.5,0.1,0.9,0.4' + 'c0.2,0.1,0.3,0.2,0.4,0.2c0.3,0.2,0.7,0.3,1.1,0.3c0.4,0,0.8-0.1,1.2-0.2c0.3-0.2,0.5-0.4,0.5-0.8c0-0.3-0.2-0.6-0.6-0.8' + 'c-0.3-0.1-0.7-0.3-1.2-0.5c-0.6-0.2-1-0.4-1.2-0.4c-0.4-0.2-0.8-0.4-1-0.7s-0.4-0.6-0.4-1c0-0.8,0.4-1.4,1.3-1.8' + 'c0.4-0.2,0.9-0.3,1.4-0.3c0.5,0,1,0.1,1.5,0.2c0.5,0.2,0.8,0.3,1,0.5c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1-0.1,0.3-0.2,0.4' + 'C9.3,16.9,9.2,17,9,17c-0.2,0-0.4-0.1-0.7-0.3c-0.4-0.2-0.7-0.4-0.7-0.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.5,0-0.8,0.1-1.1,0.3' + 'c-0.3,0.2-0.4,0.4-0.4,0.7c0.1,0.4,0.4,0.7,1,1c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.5,0.2,0.7,0.3c0.6,0.2,1.1,0.5,1.3,0.8' + 'C9.7,19.8,9.9,20.1,9.9,20.6z M18.7,22.1c0,0.4-0.2,0.7-0.7,0.7c-0.4,0-0.7-0.2-0.7-0.7v-9.6c0-0.4,0.2-0.6,0.7-0.6' + 'c0.5,0,0.7,0.2,0.7,0.6V22.1z M27.4,18.9c0,1.5-0.6,2.6-1.7,3.3c-0.5,0.3-1.2,0.5-1.9,0.5c-1.5,0-2.5-0.6-3.2-1.9' + 'c-0.3-0.6-0.4-1.2-0.4-1.9c0-1.5,0.6-2.6,1.8-3.3c0.6-0.3,1.2-0.5,1.9-0.5c0.7,0,1.3,0.2,1.9,0.5c0.5,0.3,1,0.8,1.3,1.4' + 'C27.2,17.6,27.4,18.3,27.4,18.9z M26,18.9c0-0.5-0.1-0.9-0.3-1.4c-0.4-0.9-1-1.4-2-1.4c-1,0-1.6,0.4-2,1.3c-0.2,0.4-0.3,0.9-0.3,1.4' + 'c0,0.7,0.2,1.4,0.5,1.8c0.4,0.6,1,0.9,1.7,0.9c1,0,1.7-0.5,2-1.4C25.9,19.9,26,19.4,26,18.9z M39.2,15.7c0,0.1,0,0.2-0.1,0.3' + 'l-2.3,6.1c-0.2,0.4-0.4,0.6-0.8,0.6c-0.4,0-0.6-0.2-0.8-0.7l-1.7-5l0,0l-1.7,4.9c-0.1,0.3-0.2,0.5-0.3,0.6c-0.1,0.1-0.3,0.2-0.5,0.2' + 'c-0.4,0-0.6-0.2-0.8-0.7l-2.3-6c0-0.1,0-0.2-0.1-0.3c0-0.4,0.2-0.5,0.7-0.5c0.4,0,0.6,0.1,0.7,0.4l1.8,5.3l1.8-5.2' + 'c0.1-0.4,0.4-0.6,0.7-0.6c0.3,0,0.6,0.2,0.7,0.6l1.8,5.2l0,0l1.8-5.2c0.1-0.4,0.4-0.5,0.7-0.5C39,15.1,39.2,15.3,39.2,15.7z');
	                    return;
	                case 'vhua':
	                    em.append('path').style('fill', '#009345').attr('d', 'M5.5,11.8H7l2.6,7.1l2.6-7.1h1.5l-3.3,8.9H8.9L5.5,11.8z M14.7,20.7v-8.9h1.4v3.7H20v-3.7h1.4v8.9H20' + 'v-3.9h-3.8v3.9H14.7z M24.6,11.8v5.5c0,0.6,0,1,0.3,1.5c0.3,0.4,0.8,0.7,1.4,0.7s1.1-0.3,1.3-0.7c0.3-0.5,0.3-1,0.3-1.6v-5.5h1.4' + 'v5.5c0,1.2-0.2,2.1-1,2.7c-0.5,0.5-1.2,0.8-2.1,0.8c-0.6,0-1.5-0.2-2.1-0.8c-0.9-0.8-1-1.7-1-2.7v-5.5H24.6z M31.6,20.7H30l3.6-8.9' + 'H35l3.6,8.9H37l-0.8-2.1h-3.8L31.6,20.7z M34.3,13.4l-1.5,4h3L34.3,13.4z');
	                    return;
	                case 'whois-das':
	                    em.append('path').style('fill', '#e87a24').attr('d', 'M30.9,11.8h1.2v1.3h-1.2V11.8z M30.9,14.1h1.2v6.5h-1.2V14.1z M36.7,15.8c0-0.5-0.3-0.9-0.9-0.9' + 'c-0.6,0-0.9,0.4-0.9,0.8c0,0.5,0.5,0.8,1.2,0.9c1,0.3,2.1,0.6,2.1,2c0,1.3-1,2.1-2.3,2.1c-1,0-2.3-0.6-2.4-2.1h1.2' + 'c0,0.8,0.7,1.1,1.2,1.1c0.6,0,1.1-0.4,1.1-1c0-0.6-0.5-0.9-1.7-1.2c-0.9-0.3-1.6-0.7-1.6-1.7c0-1.2,1-2,2.2-2c0.9,0,2.1,0.4,2.2,1.9' + 'H36.7z');
	                    em.append('path').style('fill', '#d73026').attr('d', 'M3.6,11.8h1.4l1.8,6.9l1.7-6.9h1.1l1.8,7l1.7-7h1.4l-2.4,8.9h-1.3l-1.7-6.7l-1.7,6.7H6L3.6,11.8z' + ' M15.4,11.8h1.2V14v1c0.4-0.8,1.3-1.1,2.1-1.1c1,0,1.7,0.3,2.1,0.9c0.4,0.6,0.6,1.3,0.6,2.2v3.6h-1.3v-3.5c0-0.6-0.1-1.1-0.4-1.5' + 'c-0.3-0.4-0.7-0.6-1.4-0.6c-0.7,0-1.1,0.3-1.4,0.6c-0.3,0.3-0.4,0.8-0.4,1.3v3.7h-1.2V11.8z M22.7,17.4c0-1.7,1.3-3.4,3.5-3.4' + 'c2.2,0,3.5,1.7,3.5,3.5s-1.3,3.4-3.5,3.4C24,20.8,22.7,19.1,22.7,17.4L22.7,17.4z M24,17.4c0,1.3,1,2.3,2.2,2.3s2.2-1,2.2-2.3' + 's-1-2.3-2.2-2.3S24,16.1,24,17.4L24,17.4z M18.9,31.7h-0.7v-1.1c-0.4,0.7-1.1,1.3-2.2,1.3c-1.7,0-2.8-1.3-2.8-2.8' + 'c0-1.6,1.2-2.8,2.8-2.8c1.2,0,2,0.7,2.2,1.2v-1.1v-2h0.7V31.7z M14,29c0,1.1,0.8,2.1,2.2,2.1c0.6,0,1.1-0.2,1.5-0.6' + 'c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.5-0.6C14.9,26.8,14,27.8,14,29L14,29z M25.9,31.7h-0.7v-1.1' + 'c-0.4,0.8-1.2,1.3-2.2,1.3c-1.7,0-2.8-1.4-2.8-2.8c0-1.6,1.1-2.8,2.8-2.8c1.1,0,1.9,0.7,2.2,1.3v-1.1h0.7V31.7z M20.9,29' + 'c0,1,0.7,2.1,2.2,2.1c0.9,0,1.6-0.5,1.9-1.3c0.1-0.3,0.2-0.6,0.2-0.8c0-0.3,0-0.6-0.2-0.9c-0.3-0.7-1-1.3-2-1.3' + 'C21.8,26.8,20.9,27.8,20.9,29L20.9,29z M29.9,27.6c0-0.6-0.4-0.9-0.9-0.9c-0.6,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.7,1.1,0.9' + 'c0.8,0.2,1.6,0.4,1.7,1.6c0,1-0.8,1.7-1.8,1.7c-0.9,0-1.8-0.5-1.8-1.7h0.7c0,0.7,0.6,1.1,1.1,1.1c0.6,0,1-0.5,1-1' + 'c0-0.6-0.4-0.9-1.3-1.1c-0.8-0.2-1.4-0.5-1.4-1.4c0-1,0.8-1.5,1.7-1.5c0.7,0,1.6,0.4,1.6,1.5H29.9z');
	                    return;
	                case 'gtp':
	                    em.append('path').style('fill', '#704A4B').attr('d', 'M16.9,21.2c-0.6,0.2-1.9,0.6-3.3,0.6c-1.7,0-3-0.4-4-1.4c-0.9-0.9-1.4-2.2-1.4-3.7' + 'c0-3.2,2.3-5.2,5.6-5.2c1.2,0,2.2,0.3,2.7,0.5l-0.4,1.5c-0.6-0.2-1.2-0.4-2.3-0.4c-2.2,0-3.7,1.3-3.7,3.6c0,2.3,1.4,3.7,3.5,3.7' + 'c0.7,0,1.2-0.1,1.4-0.2v-2.5h-1.8v-1.5h3.6V21.2z M21.1,13.1h-2.9v-1.5h7.6v1.5h-2.9v8.6h-1.8V13.1z M27.4,11.7' + 'c0.7-0.1,1.6-0.2,2.8-0.2c1.3,0,2.3,0.3,3,0.8c0.6,0.5,1,1.3,1,2.2c0,1-0.3,1.8-0.9,2.3c-0.7,0.7-1.9,1.1-3.2,1.1' + 'c-0.3,0-0.7,0-0.9-0.1v3.8h-1.8V11.7z M29.2,16.4c0.2,0.1,0.5,0.1,0.9,0.1c1.4,0,2.2-0.7,2.2-1.9c0-1.1-0.8-1.7-2.1-1.7' + 'c-0.5,0-0.9,0-1.1,0.1V16.4z');
	                    return;
	                case 'dce_rpc':
	                    em.append('path').style('fill', '#1C75BC').attr('d', 'M11.9,8.7c0.6-0.1,1.4-0.2,2.2-0.2c1.4,0,2.3,0.3,3,0.8c0.8,0.6,1.3,1.6,1.3,3.1' + 'c0,1.6-0.5,2.7-1.3,3.3c-0.8,0.7-1.9,1-3.3,1c-0.8,0-1.4-0.1-1.8-0.1V8.7z M13.6,15.3c0.1,0,0.3,0,0.5,0c1.4,0,2.3-0.9,2.3-2.9' + 'c0-1.7-0.8-2.6-2.2-2.6c-0.3,0-0.5,0-0.7,0.1V15.3z M25,16.5c-0.3,0.1-1,0.3-1.8,0.3c-2.6,0-3.9-1.7-3.9-4c0-2.8,1.9-4.3,4.1-4.3' + 'c0.8,0,1.5,0.2,1.7,0.3l-0.3,1.4C24.4,10,24,9.9,23.4,9.9c-1.3,0-2.3,0.9-2.3,2.7c0,1.7,0.9,2.7,2.3,2.7c0.5,0,1-0.1,1.3-0.2' + 'L25,16.5z M30.6,13.2h-2.6v2h3v1.5h-4.7V8.6h4.5V10h-2.8v1.7h2.6V13.2z M12.1,22.7c0.6-0.1,1.4-0.2,2.2-0.2c1.1,0,1.9,0.2,2.5,0.6' + 'c0.5,0.4,0.7,1,0.7,1.7c0,1-0.6,1.7-1.4,2v0c0.6,0.2,0.9,0.8,1.1,1.5c0.2,0.9,0.5,1.9,0.6,2.2H16c-0.1-0.2-0.3-0.9-0.5-1.9' + 'c-0.2-1-0.5-1.3-1.2-1.3h-0.5v3.2h-1.7V22.7z M13.8,26.2h0.6c0.8,0,1.3-0.5,1.3-1.2c0-0.7-0.4-1.2-1.2-1.2c-0.3,0-0.6,0-0.7,0.1' + 'V26.2z M18.9,22.7c0.5-0.1,1.3-0.2,2.2-0.2c1.1,0,1.9,0.2,2.4,0.6c0.5,0.4,0.8,1.1,0.8,1.8c0,0.8-0.3,1.5-0.7,1.9' + 'c-0.6,0.6-1.5,0.8-2.4,0.8c-0.2,0-0.4,0-0.5,0v2.9h-1.7V22.7z M20.6,26.4c0.1,0,0.3,0,0.5,0c0.9,0,1.4-0.5,1.4-1.3' + 'c0-0.7-0.4-1.2-1.3-1.2c-0.3,0-0.5,0-0.6,0.1V26.4z M30.8,30.5c-0.3,0.1-1,0.3-1.8,0.3c-2.6,0-3.9-1.7-3.9-4c0-2.8,1.9-4.3,4.1-4.3' + 'c0.8,0,1.5,0.2,1.7,0.3l-0.3,1.4c-0.3-0.1-0.7-0.3-1.3-0.3c-1.3,0-2.3,0.9-2.3,2.7c0,1.7,0.9,2.7,2.3,2.7c0.5,0,1-0.1,1.3-0.2' + 'L30.8,30.5z');
	                    return;
	                case 'collectd':
	                    em.append('path').style('fill', '#58595B').attr('d', 'M34.3,12.7c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0.1l-3.9,0.7c-0.6-2-2-3.7-3.9-4.7l1.6-2.9' + 'c0.1,0,0.2,0,0.3,0c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1,0-1.8,0.8-1.8,1.8c0,0.6,0.3,1.1,0.8,1.5L24,10.2' + 'c-1-0.4-2-0.6-3.1-0.6c-1.1,0-2.2,0.2-3.2,0.7l-1.3-3C16.8,6.9,17,6.5,17,5.9c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8' + 'c0,1,0.8,1.8,1.8,1.8c0.2,0,0.3,0,0.5-0.1l1.3,2.9c-1.9,1-3.3,2.8-3.8,4.8l-2.9-0.4c0-0.1,0-0.1,0-0.2c0-1-0.8-1.8-1.8-1.8' + 's-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c0.6,0,1.2-0.3,1.5-0.9l2.9,0.4c-0.1,0.5-0.1,0.9-0.1,1.4c0,1.7,0.5,3.3,1.5,4.6l-2.2,2' + 'c-0.3-0.2-0.7-0.4-1.1-0.4c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8c0-0.3-0.1-0.6-0.2-0.8l2.2-1.9' + 'c1.4,1.6,3.4,2.7,5.7,2.8l0,3.6c-0.8,0.2-1.4,0.9-1.4,1.8c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8c0-0.8-0.6-1.5-1.3-1.7l0-3.6' + 'c2.2-0.1,4.1-1.1,5.5-2.6l2.6,1.9c-0.1,0.2-0.2,0.5-0.2,0.7c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8' + 'c-0.4,0-0.8,0.2-1.1,0.4l-2.6-1.9c1-1.3,1.6-3,1.6-4.8c0-0.6-0.1-1.1-0.2-1.6l3.9-0.7c0.3,0.6,0.9,1,1.6,1c1,0,1.8-0.8,1.8-1.8' + 'S35.3,12.7,34.3,12.7z M25.3,5.9c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3C25.9,7.2,25.3,6.6,25.3,5.9z' + ' M14,5.9c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3C14.5,7.2,14,6.6,14,5.9z M8.5,16.2' + 'c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3S9.2,16.2,8.5,16.2z M11.1,26.9c-0.7,0-1.3-0.6-1.3-1.3' + 'c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C12.4,26.4,11.8,26.9,11.1,26.9z M32.4,25.7c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3' + 'c0-0.7,0.6-1.3,1.3-1.3S32.4,25,32.4,25.7z M22.2,31c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3' + 'S22.2,30.3,22.2,31z M20.9,23.7c-3.4,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1C27,21,24.3,23.7,20.9,23.7z' + ' M34.3,15.7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3c0.7,0,1.3,0.6,1.3,1.3C35.5,15.2,35,15.7,34.3,15.7z');
	                    return;
	                case 'upnp':
	                    em.append('path').style('fill', '#E77B25').attr('d', 'M5.1,14.4h1.9c0,0,0,4.1,0,5.8c0,0.5-0.1,2.5,1.9,2.5' + 'c2.3,0,2.1-2.4,2.1-3c0-1.6,0-5.3,0-5.3h1.9c0,0,0,4.3,0,6.3c0,1.1-0.3,2.1-1.2,2.8c-0.6,0.5-1.4,0.7-2.1,0.7c-1,0.1-2,0-3-0.4' + 'c-1-0.5-1.6-1.4-1.6-2.5C5.1,19.1,5.1,14.4,5.1,14.4z M34.4,20.4c0.6-0.1,1.1-0.2,1.7-0.3c1.2-0.4,1.8-1.4,1.8-2.8' + 'c0-1.3-0.7-2.2-1.9-2.6c-0.5-0.2-1.1-0.3-1.7-0.3c-1,0-2,0-3,0c0,3.3,0,9.7,0,9.7h1.9c0,0,0-2.4,0-3.7C33.7,20.4,34,20.5,34.4,20.4z' + ' M34.9,16.1c0.6,0.2,0.9,0.7,0.9,1.4c0,0.6-0.3,1.1-1,1.2c-0.5,0.1-1,0.1-1.5,0.2c0-1.1,0-2,0-3.1C33.8,15.9,34.4,15.9,34.9,16.1z' + ' M15.1,24.1c0.7,0,1.3,0,2,0c0-1.2,0-2.5,0-3.7c0.7,0,1.3-0.1,1.9-0.1c1.6-0.2,2.5-1.2,2.6-2.7c0.1-1.7-0.6-2.8-2.3-3' + 'c-1.4-0.2-2.8-0.2-4.2-0.3C15.1,17.7,15.1,20.9,15.1,24.1z M18.7,16.1c0.6,0.2,0.9,0.7,0.9,1.4c0,0.7-0.3,1.1-1,1.3' + 'c-0.5,0.1-1,0.1-1.5,0.2c0-1.1,0-2,0-3.1C17.6,15.9,18.2,15.9,18.7,16.1z M29.4,19.2c0-1.2-0.7-2.1-1.8-2.3c-1-0.2-2,0-2.8,0.8' + 'c-0.1,0.1-0.1,0.1-0.3,0.2c0-0.3,0-0.6,0-0.9c-0.6,0-1.2,0-1.7,0c0,2.4,0,7.2,0,7.2h1.8c0,0,0-2.4,0-3.4c0-0.6,0.2-1.2,0.4-1.7' + 'c0.2-0.6,0.9-0.9,1.5-0.8c0.6,0.1,0.9,0.4,1,1.2c0.1,1.4,0.1,4.7,0.1,4.7h1.9C29.4,24.2,29.4,20.8,29.4,19.2z M25.9,11.2' + 'c1.9-0.4,3.8-0.6,5.7-0.1c1.3,0.3,2.5,0.9,3.1,2.2c0.1,0.2,0.2,0.4,0.3,0.7c0.4-1.5-0.2-2.9-1.5-3.6c-0.8-0.4-1.6-0.6-2.5-0.6' + 'c-2.5-0.1-4.8,0.5-7.1,1.4c-1.7,0.7-3.4,1.5-5,2.2C18.8,13.4,23.6,11.7,25.9,11.2z M18.9,26.4c-2.6,0.8-5.2,1.4-8,1' + 'C9.7,27.3,8.5,27,7.6,26c-0.4-0.4-0.6-1-0.9-1.5c-0.1,1-0.1,2,0.6,2.8c0.8,0.9,1.9,1.2,3.1,1.3c1.7,0.1,3.3-0.1,5-0.5' + 'c2.6-0.7,5.1-1.8,7.5-3.1C22.8,25,20.2,26.1,18.9,26.4z');
	                    return;
	                case 'rdp':
	                    em.append('path').style('fill', '#0082ED').attr('d', 'M25,12H9c-1.1,0-2,0.9-2,2v11c0,1.1,0.9,2,2,2h6v2h-2v2h8v-2h-2v-2h6c1.1,0,2-0.9,2-2V14C27,12.9,26.1,12,25,12' + 'z M25,25H9V14h16V25z M36,10v9c0,1.1-0.9,2-2,2h-3v2h-2.7v-4H34v-9H18c0-1.1,0.9-2,2-2h14C35.1,8,36,8.9,36,10z M14,20' + 'c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C13.6,19,14,19.4,14,20z M18,20c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1' + 'C17.6,19,18,19.4,18,20z M22,20c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C21.6,19,22,19.4,22,20z M31.7,15c0,0.6-0.4,1-1,1' + 'c-0.6,0-1-0.4-1-1s0.4-1,1-1C31.2,14,31.7,14.4,31.7,15z');
	                    return;
	                case 'teamviewer':
	                    em.append('path').style('fill', '#42A7D8').attr('d', 'M31.5,7.3H11.3c-1,0-1.9,0.8-1.9,1.9v20.5c0,1,0.8,1.9,1.9,1.9h20.2c1,0,1.9-0.8,1.9-1.9V9.2' + 'C33.4,8.1,32.6,7.3,31.5,7.3z M21.4,29.7c-5.7,0-10.3-4.6-10.3-10.3S15.7,9.2,21.4,9.2c5.7,0,10.3,4.6,10.3,10.3' + 'S27.1,29.7,21.4,29.7z M24.4,23.3v-2.6h-5.5v2.6l-5.7-4.1l5.7-4.1v2.6h5.5v-2.6l5.7,4.1L24.4,23.3z');
	                    return;
	                default:
	                    return;
	            }
	            $scope.$on('$destroy', function () {
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('makeCoiChart', __webpack_require__(801));
	};

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function directive($http) {
	    return {
	        link: function link($scope, element) {
	            $scope.$on('forceChart', function (event, data) {
	                var width = $("#forcechart").parent().width(),
	                    height = width / 1.5;
	
	                var value_offset = 120;
	                var tCount = [];
	                data.links.forEach(function (d) {
	                    tCount.push(d.value);
	                });
	                var maxNum = Math.max.apply(Math, tCount);
	                var palette = {
	                    "lightgray": "#819090",
	                    "gray": "#708284",
	                    "mediumgray": "#536870",
	                    "darkgray": "#3a3a3a",
	                    "darkblue": "#0A2933",
	                    "darkerblue": "#042029",
	                    "paleryellow": "#FCF4DC",
	                    "paleyellow": "#EAE3CB",
	                    "yellow": "#A57706",
	                    "orange": "#BD3613",
	                    "red": "#D11C24",
	                    "pink": "#C61C6F",
	                    "purple": "#595AB7",
	                    "blue": "#2176C7",
	                    "green": "#259286",
	                    "yellowgreen": "#738A05"
	                };
	                var count = function count(size) {
	                    if (size === undefined) {
	                        size = 1;
	                    }
	                    return size;
	                };
	
	                function logslider(x) {
	                    if (x === undefined) {
	                        return 110;
	                    }
	                    // position will be between 0 and 100
	                    // if (x > 50) {
	                    //  x = appendInfo50;
	                    // }
	                    var minp = 0;
	                    var maxp = maxNum;
	                    // the result should be between 100 an 10000000
	                    var minv = Math.log(5);
	                    var maxv = Math.log(40);
	                    // calculate adjustment factor
	                    var scale = (maxv - minv) / (maxp - minp);
	                    return Math.exp(minv + scale * (x - minp));
	                }
	
	                // define the zoomListener which calls the zoom function on the "zoom" event constrained within the scaleExtents
	                var zoomListener = d3.behavior.zoom().scaleExtent([0.7, 3]).on("zoom", zoom);
	
	                var outVis = d3.select("#forcechart").append('svg').attr("width", width).attr("height", height).call(zoomListener);
	                var vis = outVis.append("svg").attr("class", "stage").append("g");
	
	                function zoom() {
	                    vis.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
	                }
	
	                var force = d3.layout.force().nodes(data.nodes).links(data.links).gravity(function (d) {
	                    if (d.class === 'child') {
	                        return 0.2;
	                    } else {
	                        return 0;
	                    }
	                }).linkDistance(function (d) {
	                    if (d.class === 'child') {
	                        return 130;
	                    } else {
	                        var w;
	                        if (width / 2 > 400) {
	                            w = 400;
	                        } else {
	                            w = width / 2;
	                        }
	                        return w;
	                    }
	                }).charge(-30).size([width - 50, height]);
	
	                var link = vis.selectAll(".link").data(data.links).enter().append('g').attr('class', 'linkgroup').append("line").attr("class", "link").style("display", function (d) {
	                    if (d.allowed === "authorized") {
	                        return 'none';
	                    } else {
	                        return 'inline-block';
	                    }
	                }).style('stroke', function (d) {
	                    if (d.class === 'child') {
	                        if (d.allowed === "authorized") {
	                            return '#00FF00';
	                        } else {
	                            return '#CC0000';
	                        }
	                    } else {
	                        return '#259286';
	                    }
	                }).style('stroke-opacity', function (d) {
	                    if (d.class === 'child') {
	                        return '.7';
	                    } else {
	                        return '1';
	                    }
	                }).attr('stroke-width', function (d) {
	                    if (d.class === 'child') {
	                        return '3';
	                    } else {
	                        return '50';
	                    }
	                });
	
	                var node_drag = d3.behavior.drag().on("dragstart", dragstart).on("drag", dragmove).on("dragend", dragend);
	
	                var node = vis.selectAll("circle.node").data(data.nodes).enter().append("g").attr("class", "node").call(node_drag);
	                //.call(force.drag);
	
	                var draggin = false;
	                function dragstart(d) {
	                    d3.event.sourceEvent.stopPropagation();
	                    d.fixed = true;
	                    force.stop();
	                    draggin = false;
	                }
	
	                function dragmove(d) {
	                    draggin = true;
	                    d.px += d3.event.dx;
	                    if (d.px >= value_offset && d.px <= width - value_offset) {
	                        d.x += d3.event.dx;
	                    }
	                    d.py += d3.event.dy;
	                    if (d.py >= value_offset && d.py <= height - value_offset) {
	                        d.y += d3.event.dy;
	                    }
	                    tick();
	                }
	
	                function dragend(d) {
	                    if (draggin) {
	                        d.fixed = true;
	                        d.px = d.x;
	                        d.py = d.y;
	                        $scope.page.save_coordinates(d);
	                    }
	                    tick();
	                    force.resume();
	                }
	
	                var infoDiv = d3.select('#forcechartinfo').append('table');
	
	                node.each(function (d) {
	                    var elm = d3.select(this).append('g').attr('transform', 'scale(0.7)');
	                    if (d.group === 'child') {} else {
	                        d.fixed = true;
	                    }
	                    switch (d.group) {
	                        case 'coi':
	                            // CIRCLE
	                            elm.append('svg:circle').attr('r', function (d) {
	                                return logslider(d["width"]);
	                            }).attr('fill', '#fff').style('stroke-width', "14px").style('stroke', function (d) {
	                                if (d.name === 'QuarantineCOI') {
	                                    return '#ff0000';
	                                } else {
	                                    return '#259286';
	                                }
	                            });
	
	                            // TEXT appends name
	                            elm.append("text").text(function (d) {
	                                return d.name;
	                            }).on('mouseover', function () {
	                                d3.select(this).style('cursor', 'pointer');
	                            }).on('click', function (d) {
	                                $scope.requery(d, 'blocked');
	                            }).attr("x", 0).attr("y", 10).attr("font-family", "Helvetica Neue, Arial").attr("fill", '#c61c6f').style("font-size", '2em').attr("text-anchor", 'middle');
	
	                            // TEXT appends count
	                            var text = elm.append("g").attr('transform', 'translate(0, 90)');
	
	                            text.append('text').html(function (d) {
	                                return d.count;
	                            }).attr("fill", '#000').style("font-size", '4em').attr("text-anchor", 'middle');
	
	                            // append a rectangle on top for click events
	                            text.append('rect').attr('x', -34).attr('y', -45).style('fill-opacity', '0.4').style('fill', '#fff').attr('width', 70).attr('height', 50).on('mouseover', function () {
	                                d3.select(this).style('cursor', 'pointer').style('fill-opacity', '0');
	                            }).on('click', function (d) {
	                                $scope.requery(d, 'users');
	                            }).on('mouseout', function () {
	                                d3.select(this).style('fill-opacity', '0.4');
	                            });
	
	                            // ICONS
	                            // right button red x
	                            // elm.append('g')
	                            //     .attr('transform', 'scale(.8)')
	                            //     .append('g')
	                            //     .attr('transform', 'translate(113, -15)')
	                            //     .append('path')
	                            //     .attr('d', 'M0,29.9c0-0.6,11.3-12,11.8-12.6c0.5-0.5-3.3-13-3.3-14.6C8.4,1.5,10.7,0,11.2,0'+
	                            //     'c2.1,0,9.4,9.1,9.4,9.1s11-8.2,12.3-7.8c2.5,0.8,3.5,3,2,4.4c-2.3,2.5-11,11.8-11,13.9c0,1,5.3,8.7,4.7,9.5l-3.1,4.5'+
	                            //     'c-0.6,0.9-10-7.7-10-7.7S5.3,35.8,4.9,35.8C4.5,35.8,0,30.5,0,29.9z')
	                            //     .attr('style', 'fill:#f60000;fill-opacity:1;stroke:none;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1');
	
	                            // elm.append("svg:circle")
	                            //     .attr("cx", 92)
	                            //     .attr("cy", 0)
	                            //     .attr("r", 24)
	                            //     .attr("fill", '#fff')
	                            //     .style('fill-opacity', '0.3')
	                            //     .on('mouseover', function () {
	                            //         d3.select(this).style('cursor', 'pointer')
	                            //         .style('fill-opacity', '0');
	                            //     })
	                            //     .on('click', function (d) {
	                            //         $scope.requery(d, 'blocked');
	                            //     })
	                            //     .on('mouseout', function () {d3.select(this)
	                            //     .style('fill-opacity', '0.3');
	                            //     });
	
	                            // // left button check mark
	                            // elm.append('g')
	                            //     .attr('transform', 'scale(.9)')
	                            //     .append('g')
	                            //     .attr('transform', 'translate(-315,-525)')
	                            //     .append('path')
	                            //         .style('fill', '#000000')
	                            //         .attr('d', 'M193.6,542.1c-0.5,0-8.8-14.6-8.8-14.6l8-3.6l1.6,8.4c0,0,19.9-22.3,21.7-23.9l4.3-0.2'+
	                            //         'C220.3,508.2,194.1,542.1,193.6,542.1z')
	                            //     .on('mouseover', function () {
	                            //         d3.select(this).style('cursor', 'pointer');
	                            //     })
	                            //     .on('click', function (d) {
	                            //         $scope.requery(d, 'right');
	                            //     });
	
	                            // elm.append("svg:circle")
	                            //     .attr("cx", -90)
	                            //     .attr("cy", 0)
	                            //     .attr("r", 24)
	                            //     .attr("fill", '#fff')
	                            //     .style('fill-opacity', '0.3')
	                            //     .on('mouseover', function () {
	                            //         d3.select(this).style('cursor', 'pointer')
	                            //         .style('fill-opacity', '0');
	                            //     })
	                            //     .on('click', function (d) {
	                            //         $scope.requery(d, 'authorized');
	                            //     })
	                            //     .on('mouseout', function () {d3.select(this)
	                            //     .style('fill-opacity', '0.3');
	                            //     });
	
	                            switch (d.name) {
	                                case 'ClearTextCOI':
	                                    elm.append('path').style('fill', palette.gray).attr('d', 'M36.8,12.2L19.6,15l4.4-12L36.8,0V12.2z M3.8,20.8l9.2-3.7l5.4-11.4L3.8,20.8z M36.8,16.5l-18.6,3.8' + 'L17.5,37h19.3V16.5z M12.2,21.6l-9.8,3.6L0,37h10.3L12.2,21.6z M42.8,12.2L59.9,15l-4.6-12L42.8,0V12.2z M60.4,5.8l5.4,11.4l9.2,3.7' + 'L60.4,5.8z M42.8,37h20.4L61,20.3l-18.2-3.8V37z M68.6,37h10.3l-2.4-11.8l-9.8-3.6L68.6,37z M36.8,67.2l-17.3-2.8l4.4,12l12.8,3.1' + 'V67.2z M18.5,73.6l-5.4-11.4l-9.2-3.7L18.5,73.6z M36.8,42H17.5l0.7,16.8l18.6,2.1V42z M10.3,42H0l2.4,11.9l9.8,3.7L10.3,42z' + ' M42.8,79.4l12.4-3.1l4.6-12l-17.1,2.8V79.4z M75.1,58.6l-9.2,3.7l-5.4,11.4L75.1,58.6z M42.8,60.9L61,58.8L63.2,42H42.8V60.9z' + ' M66.7,57.5l9.8-3.7L78.9,42H68.6L66.7,57.5z').attr('transform', 'translate(-25,-95) scale(0.7)');
	
	                                    elm.append("svg:circle").attr("cx", 2).attr("cy", -60).attr("r", 32).attr("fill", '#fff').style('fill-opacity', '0.3').on('mouseover', function () {
	                                        d3.select(this).style('cursor', 'pointer').style('fill-opacity', '0');
	                                    }).on('click', function (d) {
	                                        $scope.requery(d, 'rules');
	                                    }).on('mouseout', function () {
	                                        d3.select(this).style('fill-opacity', '0.3');
	                                    });
	                                    break;
	                                case 'QuarantineCOI':
	                                    elm.append('path').style('fill', '#ff0000').attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0' + 'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7' + 'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9' + 'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z').attr('transform', 'translate(-21,-70) scale(0.5)');
	
	                                    elm.append('path').style('fill', '#ff0000').attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0' + 'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7' + 'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9' + 'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z').attr('transform', 'rotate(120,33,-39) scale(0.5)');
	
	                                    elm.append('path').style('fill', '#ff0000').attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0' + 'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7' + 'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9' + 'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z').attr('transform', 'rotate(240,-6.5,-27) scale(0.5)');
	
	                                    elm.append("svg:circle").attr("cx", 2).attr("cy", -60).attr("r", 32).attr("fill", '#fff').style('fill-opacity', '0.3').on('mouseover', function () {
	                                        d3.select(this).style('cursor', 'pointer').style('fill-opacity', '0');
	                                    }).on('click', function (d) {
	                                        $scope.requery(d, 'rules');
	                                    }).on('mouseout', function () {
	                                        d3.select(this).style('fill-opacity', '0.3');
	                                    });
	                                    break;
	                                default:
	                                    elm.append('polygon').style('fill', '#515151').attr('points', '53,18 53,10 60,10 60,0 44,0 44,10 51,10 51,16 31,16 31,10 38,10 38,0 22,0 22,10 29,10 ' + '29,16 9,16 9,10 16,10 16,0 0,0 0,10 7,10 7,18 29,18 29,26 7,26 7,35 0,35 0,45 16,45 16,35 9,35 9,28 29,28 29,35 22,35 22,45 ' + '38,45 38,35 31,35 31,28 51,28 51,35 44,35 44,45 60,45 60,35 53,35 53,26 31,26 31,18 ').attr('transform', 'translate(-25,-90) scale(0.9)');
	
	                                    elm.append("svg:circle").attr("cx", 2).attr("cy", -60).attr("r", 40).attr("fill", '#fff').style('fill-opacity', '0.3').on('mouseover', function () {
	                                        d3.select(this).style('cursor', 'pointer').style('fill-opacity', '0');
	                                    }).on('click', function (d) {
	                                        $scope.requery(d, 'rules');
	                                    }).on('mouseout', function () {
	                                        d3.select(this).style('fill-opacity', '0.3');
	                                    });
	                                    break;
	                            }
	                            break;
	                        case 'child':
	                            if (d.value.type === 'Stealth COI Mismatch') {
	                                elm.append("path").attr('d', 'M14,3.1C9.4,3.3,7,0,7,0c0,0-2,3.1-7,3.1C-0.4,8.3,2.7,18,7,18C11.2,18,14.4,7.2,14,3.1z').attr('transform', 'translate(-25,-115) scale(0.7)').style('fill', "#000").style('border', "solid 1px #000").attr('transform', 'translate(-8,-8) scale(1.1)');
	                            } else if (d.value.type === 'Stealth COI Mismatch v3') {
	                                elm.append("path").attr('d', 'M14,3.1C9.4,3.3,7,0,7,0c0,0-2,3.1-7,3.1C-0.4,8.3,2.7,18,7,18C11.2,18,14.4,7.2,14,3.1z').attr('transform', 'translate(-25,-115) scale(0.7)').style('fill', "#666").style('border', "solid 1px #666").attr('transform', 'translate(-8,-8) scale(1.1)');
	                            } else if (d.value.type === 'Non-Stealth Internal Attack') {
	                                elm.append('rect').attr('x', function (d) {
	                                    return d.x;
	                                }).attr('y', function (d) {
	                                    return d.y;
	                                }).attr('height', 14).attr('width', 14).style('fill', "#002E7F").attr('transform', 'translate(-8,-8)').style('fill-opacity', '1');
	                            } else if (d.value.type === 'outside') {
	                                elm.append("circle").attr("cx", function (d) {
	                                    return d.x;
	                                }).attr("cy", function (d) {
	                                    return d.y;
	                                }).attr("r", 8).attr("fill", "#000").style('border', "solid 1px #000");
	                            } else {
	                                elm.append("path").attr('d', 'M14,3.1C9.4,3.3,7,0,7,0c0,0-2,3.1-7,3.1C-0.4,8.3,2.7,18,7,18C11.2,18,14.4,7.2,14,3.1z').attr('transform', 'translate(-25,-115) scale(0.7)').style('fill', "#000").style('border', "solid 1px #000").attr('transform', 'translate(-8,-8) scale(1.1)');
	                            }
	                            break;
	                    }
	                });
	
	                $scope.appendInfo = function (data, type) {
	                    infoDiv.selectAll('tr').remove();
	                    var divInfo = '';
	                    if (type === "linkBetween") {
	                        var uniqueNodes = $scope.forcedata.uniqueNodes;
	                        var uniqueUsers = $scope.forcedata.uniqueUsers;
	                        var unique = [];
	                        var source = data.source.name;
	                        var target = data.target.name;
	
	                        for (var i in uniqueNodes[source]) {
	                            for (var j in uniqueNodes[target]) {
	                                if (i === j) {
	                                    unique.push(i);
	                                }
	                            }
	                        }
	                        for (var x = 0; x < unique.length; x++) {
	                            divInfo = '';
	                            divInfo += '<div><strong>' + unique[x] + ': </strong>';
	                            for (var k in uniqueUsers) {
	                                if (k === unique[x]) {
	                                    for (var z = 0; z < Object.keys(uniqueUsers[k]).length; z++) {
	                                        divInfo += Object.keys(uniqueUsers[k])[z];
	                                        if (z < Object.keys(uniqueUsers[k]).length - 1) {
	                                            divInfo += ", ";
	                                        }
	                                    }
	                                }
	                            }
	                            divInfo += '</div>';
	                            var row = infoDiv.append('tr');
	                            row.append('td').html(divInfo);
	                        }
	                    } else if (type === "rules") {
	                        divInfo += '<div><strong>Rules: </strong><br />';
	                        var rules = "";
	                        for (var i = 0; i < data.rules.length; i++) {
	                            if (data.rules[i].rule !== "-") {
	                                var ruleString = data.rules[i].rule.replace(/Except/g, "<br />Except");
	                                divInfo += data.rules[i].order + "<br />" + " " + ruleString + "<br />";
	                            } else {
	                                divInfo += "none <br />";
	                            }
	                        }
	                        var row = infoDiv.append('tr');
	                        row.append('td').html(divInfo);
	                    } else {
	                        for (var i in data) {
	                            if (_typeof(data[i]) === 'object') {
	                                divInfo = "";
	                                for (var e in data[i]) {
	                                    divInfo += '<div><strong>' + e + ': </strong>' + data[i][e] + '</div>';
	                                }
	                                var row = infoDiv.append('tr');
	                                row.append('td').html(divInfo);
	                            } else {
	                                var row = infoDiv.append('tr');
	                                row.append('td').html('<strong>' + dictionary(i) + '</strong>');
	                                row.append('td').text(data[i]);
	                            }
	                        }
	                    }
	                };
	
	                $scope.pageLoadInfo = function (data) {
	                    for (var i in data) {
	                        if (_typeof(data[i]) === 'object') {
	                            var divInfo = '';
	                            for (var e in data[i]) {
	                                if (e !== "index") {
	                                    divInfo += '<div><strong>' + e + ': </strong>' + data[i][e] + '</div>';
	                                }
	                            }
	                            var row = infoDiv.append('tr');
	                            row.append('td').html(divInfo);
	                        } else {
	                            var row = infoDiv.append('tr');
	                            row.append('td').html('<strong>' + dictionary(i) + '</strong>');
	                            row.append('td').text(data[i]);
	                        }
	                    }
	                };
	
	                var linktext = d3.selectAll('.linkgroup');
	                var text = linktext.append('text').attr("fill", '#fff').style('font-size', '2.5em').style('cursor', 'pointer').attr('text-anchor', 'middle').text(function (d) {
	                    return d.value;
	                }).on('click', function (d) {
	                    $scope.appendInfo(d, 'linkBetween');
	                });
	
	                function tick() {
	                    node[0].x = width;
	                    node[0].y = height;
	
	                    node.attr("cx", function (d) {
	                        if (d.group === "child") {
	                            value_offset = 0;
	                        } else {
	                            value_offset = 120;
	                        }
	                        return d.x = Math.max(value_offset, Math.min(width - value_offset, d.x));
	                    }).attr("cy", function (d) {
	                        if (d.group === "child") {
	                            value_offset = 0;
	                        } else {
	                            value_offset = 120;
	                        }
	                        return d.y = Math.max(value_offset, Math.min(height - value_offset, d.y));
	                    });
	
	                    link.attr("x1", function (d) {
	                        return d.source.x;
	                    }).attr("y1", function (d) {
	                        return d.source.y;
	                    }).attr("x2", function (d) {
	                        return d.target.x;
	                    }).attr("y2", function (d) {
	                        return d.target.y;
	                    });
	
	                    text.attr("transform", function (d) {
	                        var x1 = d.source.x;
	                        var x2 = d.target.x;
	                        var y1 = d.source.y;
	                        var y2 = d.target.y;
	                        var x = (x1 + x2) / 2;
	                        var y = (y1 + y2) * 1.027 / 2;
	                        return "translate(" + x + "," + y + ")";
	                    });
	
	                    node.attr("transform", function (d) {
	                        return "translate(" + d.x + "," + d.y + ")";
	                    });
	                }
	                force.on("tick", tick);
	                force.start();
	                $scope.onloadInfo();
	
	                function isColor(data) {
	                    if (data === "Stealth COIs" || data === "User with Shared Access") {
	                        return "#259286";
	                    } else if (data === "Stealth COIs" || data === "User with Shared Access") {
	                        return "#1F5E76";
	                    }
	                    return "#1F5E76";
	                }
	
	                // LEGEND
	                var standard_legend = outVis.selectAll(".standard_legend").data(["Standard"]).enter().append("g").attr("class", "standard_legend").attr("transform", function (d, i) {
	                    return "translate(0," + i * 30 + ")";
	                });
	                standard_legend.append('svg:polygon').attr('transform', 'translate(0,0) scale(0.5)').style('fill', palette.gray).attr('points', '53,18 53,10 60,10 60,0 44,0 44,10 51,10 51,16 31,16 31,10 38,10 38,0 22,0 22,10 29,10 ' + '29,16 9,16 9,10 16,10 16,0 0,0 0,10 7,10 7,18 29,18 29,26 7,26 7,35 0,35 0,45 16,45 16,35 9,35 9,28 29,28 29,35 22,35 22,45 ' + '38,45 38,35 31,35 31,28 51,28 51,35 44,35 44,45 60,45 60,35 53,35 53,26 31,26 31,18');
	                standard_legend.append("text").attr("x", 38).attr("y", 13).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                // var ct_legend = outVis.selectAll(".ct_legend")
	                //     .data(["ClearText"])
	                //     .enter().append("g")
	                //     .attr("class", "ct_legend")
	                //     .attr("transform", function (d, i) { return "translate(0," + i * 30 + ")"; });
	                // ct_legend.append('svg:path')
	                //     .attr('transform', 'translate(0,30) scale(0.4)')
	                //     .style('fill', palette.gray)
	                //     .attr('d', 'M36.8,12.2L19.6,15l4.4-12L36.8,0V12.2z M3.8,20.8l9.2-3.7l5.4-11.4L3.8,20.8z M36.8,16.5l-18.6,3.8'+
	                //     'L17.5,37h19.3V16.5z M12.2,21.6l-9.8,3.6L0,37h10.3L12.2,21.6z M42.8,12.2L59.9,15l-4.6-12L42.8,0V12.2z M60.4,5.8l5.4,11.4l9.2,3.7'+
	                //     'L60.4,5.8z M42.8,37h20.4L61,20.3l-18.2-3.8V37z M68.6,37h10.3l-2.4-11.8l-9.8-3.6L68.6,37z M36.8,67.2l-17.3-2.8l4.4,12l12.8,3.1'+
	                //     'V67.2z M18.5,73.6l-5.4-11.4l-9.2-3.7L18.5,73.6z M36.8,42H17.5l0.7,16.8l18.6,2.1V42z M10.3,42H0l2.4,11.9l9.8,3.7L10.3,42z'+
	                //     ' M42.8,79.4l12.4-3.1l4.6-12l-17.1,2.8V79.4z M75.1,58.6l-9.2,3.7l-5.4,11.4L75.1,58.6z M42.8,60.9L61,58.8L63.2,42H42.8V60.9z'+
	                //     ' M66.7,57.5l9.8-3.7L78.9,42H68.6L66.7,57.5z');
	                // ct_legend.append("text")
	                //     .attr("x", 38)
	                //     .attr("y", 47)
	                //     .attr("dy", ".35em")
	                //     .text(function (d) { return d; });
	
	                var quar_legend = outVis.selectAll(".quar_legend").data(["Quarantine"]).enter().append("g").attr("class", "quar_legend").attr("transform", function (d, i) {
	                    return "translate(0, -37)";
	                });
	                quar_legend.append('svg:path').attr('transform', 'translate(5,82) scale(0.25)').style('fill', '#ff0000').attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0' + 'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7' + 'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9' + 'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z');
	                quar_legend.append('svg:path').attr('transform', 'rotate(120,-9.25,43.25) scale(0.25)').style('fill', '#ff0000').attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0' + 'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7' + 'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9' + 'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z');
	                quar_legend.append('svg:path').attr('transform', 'rotate(240,38,40.5) scale(0.25)').style('fill', '#ff0000').attr('d', 'M36.6,32.1c1.4-2.2,2.4-4.7,2.9-7.3c-8.1-3.3-13.8-11.2-13.8-20.5c0-1.1,0.1-2.1,0.2-3.1 C23.7,0.4,21.3,0,18.8,0c-0.2,0-0.4,0-0.6,0' + 'c-0.2,1.4-0.3,2.9-0.3,4.3C17.9,16.9,25.6,27.7,36.6,32.1z M94.3,36.2c-4.3,5-10.6,8.1-17.7,8.1c-12.9,0-23.4-10.4-23.4-23.3c0-3.8,0.9-7.5,2.6-10.7' + 'l-2.8-1.6 c-1.2,1.4-3.1,2.4-5.1,2.4c-2.1,0-3.9-0.9-5.1-2.4l-3,1.8c1.6,3.2,2.5,6.8,2.5,10.6c0,12.9-10.5,23.3-23.4,23.3 c-7,0-13.3-3.1-17.6-7.9' + 'L0,37.1c6.2,8,15.9,13.1,26.7,13.1c8,0,15.3-2.8,21.1-7.4c5.8,4.6,13.1,7.4,21.1,7.4 c10.9,0,20.6-5.2,26.7-13.1L94.3,36.2z');
	                quar_legend.append("text").attr("x", 38).attr("y", 81).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                // var checkmark_legend = outVis.selectAll(".checkmark_legend")
	                //     .data(["Allowed Connections"])
	                //     .enter().append("g")
	                //     .attr("class", "checkmark_legend")
	                //     .attr("transform", function (d, i) { return "translate(0," + i * 30 + ")"; });
	                // checkmark_legend
	                //     .append('svg:path')
	                //     .attr('transform', 'translate(-85, -150) scale(0.5)')
	                //     .attr('d', 'M193.6,542.1c-0.5,0-8.8-14.6-8.8-14.6l8-3.6l1.6,8.4c0,0,19.9-22.3,21.7-23.9l4.3-0.2'+
	                //     'C220.3,508.2,194.1,542.1,193.6,542.1z')
	                //     .style('fill', '#000000');
	                // checkmark_legend.append("text")
	                //     .attr("x", 38)
	                //     .attr("y", 112)
	                //     .attr("dy", ".35em")
	                //     .text(function (d) { return d; });
	
	                // var redx_legend = outVis.selectAll(".redx_legend")
	                //     .data(["Dropped Connections"])
	                //     .enter().append("g")
	                //         .attr("class", "redx_legend")
	                //         .attr("transform", function (d, i) { return "translate(0," + i * 30 + ")"; });
	                // redx_legend.append('svg:path')
	                //     .attr('transform', 'translate(7,130) scale(0.5)')
	                //     .attr('d', 'M0,29.9c0-0.6,11.3-12,11.8-12.6c0.5-0.5-3.3-13-3.3-14.6C8.4,1.5,10.7,0,11.2,0'+
	                //     'c2.1,0,9.4,9.1,9.4,9.1s11-8.2,12.3-7.8c2.5,0.8,3.5,3,2,4.4c-2.3,2.5-11,11.8-11,13.9c0,1,5.3,8.7,4.7,9.5l-3.1,4.5'+
	                //     'c-0.6,0.9-10-7.7-10-7.7S5.3,35.8,4.9,35.8C4.5,35.8,0,30.5,0,29.9z')
	                //     .attr('style', 'fill:#f60000;fill-opacity:1;stroke:none;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1');
	                // redx_legend.append("text")
	                // .attr("x", 38)
	                // .attr("y", 139)
	                // .attr("dy", ".35em")
	                // .text(function (d) { return d; });
	
	                var nameCirlcle = [];
	                var nameLink = [];
	                nameCirlcle.push("Stealth COIs");
	                nameLink.push("User with Shared Access");
	
	                var circle_legend = outVis.selectAll(".circle_legend").data(nameCirlcle).enter().append("g").attr("class", "circle_legend").attr("transform", function (d, i) {
	                    return "translate(0, -39)";
	                });
	                circle_legend.append('svg:circle').attr('transform', 'translate(15,119) scale(0.5)').attr('r', 25).style('fill', '#fff').style("stroke-width", "8px").style("stroke", function (d) {
	                    return isColor(d);
	                });
	                circle_legend.append("text").attr("x", 38).attr("y", 119).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                var link_legend = outVis.selectAll(".link_legend").data(nameLink).enter().append("g").attr("class", "link_legend").attr("transform", function (d, i) {
	                    return "translate(0, -36)";
	                });
	                link_legend.append('svg:rect').attr('transform', 'translate(0,' + 139 + ')').style('fill', function (d) {
	                    return isColor(d);
	                }).attr('width', 30).attr('height', 20);
	                link_legend.append("text").attr("x", 38).attr("y", 149).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                $scope.$on('$destroy', function () {
	                    element.remove();
	                });
	            });
	        }
	    };
	}
	
	directive.$inject = ['$http'];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('copyright', __webpack_require__(803));
	};

/***/ },
/* 803 */
/***/ function(module, exports) {

	'use strict';
	
	function directive(Global) {
	    return {
	        restrict: 'A',
	        transclude: false,
	        link: function link($scope, element) {
	            var d = new Date().getFullYear();
	            var version = Global.version;
	            var html = '&copy; ' + d + ' Mantix4 <br /> version: ' + version;
	            element.replaceWith(html);
	        }
	    };
	}
	
	directive.$inject = ['Global'];
	module.exports = directive;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('datePicker', __webpack_require__(805));
	};

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _moment = __webpack_require__(459);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function directive($interval, $location, $state, $window) {
	    return {
	        link: function link($scope, element, attrs) {
	            // moved this section from the controller
	            var model = this;
	            if (!$state.current.data.daterange) {
	                return;
	            } // do nothing if time already exists
	            // we'll have to poll the main controller to check for updated times
	            var timer = void 0;
	            model.setDisplayValues = function (unixTimeObject) {
	                $scope.dateRangeStart = _moment2.default.unix(unixTimeObject.start).format('MMMM D, YYYY h:mm A');
	                $scope.dateRangeEnd = _moment2.default.unix(unixTimeObject.end).format('MMMM D, YYYY h:mm A');
	            };
	            model.setDisplayTimer = function () {
	                if (!$location.$$search.hasOwnProperty('start') && !$location.$$search.hasOwnProperty('end')) {
	                    timer = $interval(function () {
	                        var time = $scope.main.getTime();
	                        model.setDisplayValues(time);
	                    }, 1000);
	                } else {
	                    if (angular.isDefined(timer)) {
	                        $interval.cancel(timer);
	                        timer = undefined;
	                    }
	                }
	            };
	            // get inital times from main function
	            var time = $scope.main.getTime();
	            // apply them to visual
	            model.setDisplayValues(time);
	            // start timer if applicable
	            model.setDisplayTimer();
	            // kill all timers on state destroy
	            $scope.$on('$destroy', function () {
	                if (angular.isDefined(timer)) {
	                    $interval.cancel(timer);
	                    timer = undefined;
	                }
	            });
	
	            var daterangepicker = __webpack_require__(806);
	            // run nothing else if daterange is false or undefined
	            if (!$state.current.data.daterange) {
	                return;
	            }
	            $('#daterange').daterangepicker({
	                ranges: {
	                    'Today': [(0, _moment2.default)().startOf('day'), (0, _moment2.default)()],
	                    'Yesterday': [(0, _moment2.default)().subtract(1, 'days').startOf('day'), (0, _moment2.default)().subtract(1, 'days').endOf('day')],
	                    'Last 7 Days': [(0, _moment2.default)().subtract(6, 'days'), (0, _moment2.default)()],
	                    'Last 30 Days': [(0, _moment2.default)().subtract(29, 'days'), (0, _moment2.default)()],
	                    'This Month': [(0, _moment2.default)().startOf('month'), (0, _moment2.default)().endOf('month')],
	                    'Last Month': [(0, _moment2.default)().subtract(1, 'month').startOf('month'), (0, _moment2.default)().subtract(1, 'month').endOf('month')]
	                },
	                format: 'MMMM D, YYYY h:mm A',
	                timePicker: true,
	                timePickerIncrement: 5
	            }, function (start, end) {
	                // update the time in main
	                $scope.main.setTime({
	                    start: (0, _moment2.default)(start).unix(),
	                    end: (0, _moment2.default)(end).unix()
	                }).then(function (time) {
	                    // then set the url to our new time
	                    var search = $location.$$search;
	                    search.start = time.start;
	                    search.end = time.end;
	                    $location.search(search);
	                    // tell timer to check for updates to url
	                    $scope.main.resetTimer();
	                    // run display check function
	                    model.setDisplayTimer();
	                    // assign the time value to our visual
	                    model.setDisplayValues(time);
	                    // update data
	
	                    // let current = $state.current.name;
	                    // $state.go($state.current, angular.copy({start: search.start, end:search.end}), { reload: false, inherit: false, notify: true });
	                    setTimeout(function () {
	                        $window.location.reload();
	                    }, 1000);
	                });
	            });
	            $scope.$on('$destroy', function () {
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = ['$interval', '$location', '$state', '$window'];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	* @version: 2.1.24
	* @author: Dan Grossman http://www.dangrossman.info/
	* @copyright: Copyright (c) 2012-2016 Dan Grossman. All rights reserved.
	* @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
	* @website: https://www.improvely.com/
	*/
	// Follow the UMD template https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
	(function (root, factory) {
	    if (true) {
	        // AMD. Make globaly available as well
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(459), __webpack_require__(457)], __WEBPACK_AMD_DEFINE_RESULT__ = function (moment, jquery) {
	            return (root.daterangepicker = factory(moment, jquery));
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node / Browserify
	        //isomorphic issue
	        var jQuery = (typeof window != 'undefined') ? window.jQuery : undefined;
	        if (!jQuery) {
	            jQuery = require('jquery');
	            if (!jQuery.fn) jQuery.fn = {};
	        }
	        module.exports = factory(require('moment'), jQuery);
	    } else {
	        // Browser globals
	        root.daterangepicker = factory(root.moment, root.jQuery);
	    }
	}(this, function(moment, $) {
	    var DateRangePicker = function(element, options, cb) {
	
	        //default settings for options
	        this.parentEl = 'body';
	        this.element = $(element);
	        this.startDate = moment().startOf('day');
	        this.endDate = moment().endOf('day');
	        this.minDate = false;
	        this.maxDate = false;
	        this.dateLimit = false;
	        this.autoApply = false;
	        this.singleDatePicker = false;
	        this.showDropdowns = false;
	        this.showWeekNumbers = false;
	        this.showISOWeekNumbers = false;
	        this.showCustomRangeLabel = true;
	        this.timePicker = false;
	        this.timePicker24Hour = false;
	        this.timePickerIncrement = 1;
	        this.timePickerSeconds = false;
	        this.linkedCalendars = true;
	        this.autoUpdateInput = true;
	        this.alwaysShowCalendars = false;
	        this.ranges = {};
	
	        this.opens = 'right';
	        if (this.element.hasClass('pull-right'))
	            this.opens = 'left';
	
	        this.drops = 'down';
	        if (this.element.hasClass('dropup'))
	            this.drops = 'up';
	
	        this.buttonClasses = 'btn btn-sm';
	        this.applyClass = 'btn-success';
	        this.cancelClass = 'btn-default';
	
	        this.locale = {
	            direction: 'ltr',
	            format: 'MM/DD/YYYY',
	            separator: ' - ',
	            applyLabel: 'Apply',
	            cancelLabel: 'Cancel',
	            weekLabel: 'W',
	            customRangeLabel: 'Custom Range',
	            daysOfWeek: moment.weekdaysMin(),
	            monthNames: moment.monthsShort(),
	            firstDay: moment.localeData().firstDayOfWeek()
	        };
	
	        this.callback = function() { };
	
	        //some state information
	        this.isShowing = false;
	        this.leftCalendar = {};
	        this.rightCalendar = {};
	
	        //custom options from user
	        if (typeof options !== 'object' || options === null)
	            options = {};
	
	        //allow setting options with data attributes
	        //data-api options will be overwritten with custom javascript options
	        options = $.extend(this.element.data(), options);
	
	        //html template for the picker UI
	        if (typeof options.template !== 'string' && !(options.template instanceof $))
	            options.template = '<div class="daterangepicker dropdown-menu">' +
	                '<div class="calendar left">' +
	                    '<div class="daterangepicker_input">' +
	                      '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
	                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	                      '<div class="calendar-time">' +
	                        '<div></div>' +
	                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	                      '</div>' +
	                    '</div>' +
	                    '<div class="calendar-table"></div>' +
	                '</div>' +
	                '<div class="calendar right">' +
	                    '<div class="daterangepicker_input">' +
	                      '<input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />' +
	                      '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	                      '<div class="calendar-time">' +
	                        '<div></div>' +
	                        '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	                      '</div>' +
	                    '</div>' +
	                    '<div class="calendar-table"></div>' +
	                '</div>' +
	                '<div class="ranges">' +
	                    '<div class="range_inputs">' +
	                        '<button class="applyBtn" disabled="disabled" type="button"></button> ' +
	                        '<button class="cancelBtn" type="button"></button>' +
	                    '</div>' +
	                '</div>' +
	            '</div>';
	
	        this.parentEl = (options.parentEl && $(options.parentEl).length) ? $(options.parentEl) : $(this.parentEl);
	        this.container = $(options.template).appendTo(this.parentEl);
	
	        //
	        // handle all the possible options overriding defaults
	        //
	
	        if (typeof options.locale === 'object') {
	
	            if (typeof options.locale.direction === 'string')
	                this.locale.direction = options.locale.direction;
	
	            if (typeof options.locale.format === 'string')
	                this.locale.format = options.locale.format;
	
	            if (typeof options.locale.separator === 'string')
	                this.locale.separator = options.locale.separator;
	
	            if (typeof options.locale.daysOfWeek === 'object')
	                this.locale.daysOfWeek = options.locale.daysOfWeek.slice();
	
	            if (typeof options.locale.monthNames === 'object')
	              this.locale.monthNames = options.locale.monthNames.slice();
	
	            if (typeof options.locale.firstDay === 'number')
	              this.locale.firstDay = options.locale.firstDay;
	
	            if (typeof options.locale.applyLabel === 'string')
	              this.locale.applyLabel = options.locale.applyLabel;
	
	            if (typeof options.locale.cancelLabel === 'string')
	              this.locale.cancelLabel = options.locale.cancelLabel;
	
	            if (typeof options.locale.weekLabel === 'string')
	              this.locale.weekLabel = options.locale.weekLabel;
	
	            if (typeof options.locale.customRangeLabel === 'string')
	              this.locale.customRangeLabel = options.locale.customRangeLabel;
	
	        }
	        this.container.addClass(this.locale.direction);
	
	        if (typeof options.startDate === 'string')
	            this.startDate = moment(options.startDate, this.locale.format);
	
	        if (typeof options.endDate === 'string')
	            this.endDate = moment(options.endDate, this.locale.format);
	
	        if (typeof options.minDate === 'string')
	            this.minDate = moment(options.minDate, this.locale.format);
	
	        if (typeof options.maxDate === 'string')
	            this.maxDate = moment(options.maxDate, this.locale.format);
	
	        if (typeof options.startDate === 'object')
	            this.startDate = moment(options.startDate);
	
	        if (typeof options.endDate === 'object')
	            this.endDate = moment(options.endDate);
	
	        if (typeof options.minDate === 'object')
	            this.minDate = moment(options.minDate);
	
	        if (typeof options.maxDate === 'object')
	            this.maxDate = moment(options.maxDate);
	
	        // sanity check for bad options
	        if (this.minDate && this.startDate.isBefore(this.minDate))
	            this.startDate = this.minDate.clone();
	
	        // sanity check for bad options
	        if (this.maxDate && this.endDate.isAfter(this.maxDate))
	            this.endDate = this.maxDate.clone();
	
	        if (typeof options.applyClass === 'string')
	            this.applyClass = options.applyClass;
	
	        if (typeof options.cancelClass === 'string')
	            this.cancelClass = options.cancelClass;
	
	        if (typeof options.dateLimit === 'object')
	            this.dateLimit = options.dateLimit;
	
	        if (typeof options.opens === 'string')
	            this.opens = options.opens;
	
	        if (typeof options.drops === 'string')
	            this.drops = options.drops;
	
	        if (typeof options.showWeekNumbers === 'boolean')
	            this.showWeekNumbers = options.showWeekNumbers;
	
	        if (typeof options.showISOWeekNumbers === 'boolean')
	            this.showISOWeekNumbers = options.showISOWeekNumbers;
	
	        if (typeof options.buttonClasses === 'string')
	            this.buttonClasses = options.buttonClasses;
	
	        if (typeof options.buttonClasses === 'object')
	            this.buttonClasses = options.buttonClasses.join(' ');
	
	        if (typeof options.showDropdowns === 'boolean')
	            this.showDropdowns = options.showDropdowns;
	
	        if (typeof options.showCustomRangeLabel === 'boolean')
	            this.showCustomRangeLabel = options.showCustomRangeLabel;
	
	        if (typeof options.singleDatePicker === 'boolean') {
	            this.singleDatePicker = options.singleDatePicker;
	            if (this.singleDatePicker)
	                this.endDate = this.startDate.clone();
	        }
	
	        if (typeof options.timePicker === 'boolean')
	            this.timePicker = options.timePicker;
	
	        if (typeof options.timePickerSeconds === 'boolean')
	            this.timePickerSeconds = options.timePickerSeconds;
	
	        if (typeof options.timePickerIncrement === 'number')
	            this.timePickerIncrement = options.timePickerIncrement;
	
	        if (typeof options.timePicker24Hour === 'boolean')
	            this.timePicker24Hour = options.timePicker24Hour;
	
	        if (typeof options.autoApply === 'boolean')
	            this.autoApply = options.autoApply;
	
	        if (typeof options.autoUpdateInput === 'boolean')
	            this.autoUpdateInput = options.autoUpdateInput;
	
	        if (typeof options.linkedCalendars === 'boolean')
	            this.linkedCalendars = options.linkedCalendars;
	
	        if (typeof options.isInvalidDate === 'function')
	            this.isInvalidDate = options.isInvalidDate;
	
	        if (typeof options.isCustomDate === 'function')
	            this.isCustomDate = options.isCustomDate;
	
	        if (typeof options.alwaysShowCalendars === 'boolean')
	            this.alwaysShowCalendars = options.alwaysShowCalendars;
	
	        // update day names order to firstDay
	        if (this.locale.firstDay != 0) {
	            var iterator = this.locale.firstDay;
	            while (iterator > 0) {
	                this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
	                iterator--;
	            }
	        }
	
	        var start, end, range;
	
	        //if no start/end dates set, check if an input element contains initial values
	        if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
	            if ($(this.element).is('input[type=text]')) {
	                var val = $(this.element).val(),
	                    split = val.split(this.locale.separator);
	
	                start = end = null;
	
	                if (split.length == 2) {
	                    start = moment(split[0], this.locale.format);
	                    end = moment(split[1], this.locale.format);
	                } else if (this.singleDatePicker && val !== "") {
	                    start = moment(val, this.locale.format);
	                    end = moment(val, this.locale.format);
	                }
	                if (start !== null && end !== null) {
	                    this.setStartDate(start);
	                    this.setEndDate(end);
	                }
	            }
	        }
	
	        if (typeof options.ranges === 'object') {
	            for (range in options.ranges) {
	
	                if (typeof options.ranges[range][0] === 'string')
	                    start = moment(options.ranges[range][0], this.locale.format);
	                else
	                    start = moment(options.ranges[range][0]);
	
	                if (typeof options.ranges[range][1] === 'string')
	                    end = moment(options.ranges[range][1], this.locale.format);
	                else
	                    end = moment(options.ranges[range][1]);
	
	                // If the start or end date exceed those allowed by the minDate or dateLimit
	                // options, shorten the range to the allowable period.
	                if (this.minDate && start.isBefore(this.minDate))
	                    start = this.minDate.clone();
	
	                var maxDate = this.maxDate;
	                if (this.dateLimit && maxDate && start.clone().add(this.dateLimit).isAfter(maxDate))
	                    maxDate = start.clone().add(this.dateLimit);
	                if (maxDate && end.isAfter(maxDate))
	                    end = maxDate.clone();
	
	                // If the end of the range is before the minimum or the start of the range is
	                // after the maximum, don't display this range option at all.
	                if ((this.minDate && end.isBefore(this.minDate, this.timepicker ? 'minute' : 'day')) 
	                  || (maxDate && start.isAfter(maxDate, this.timepicker ? 'minute' : 'day')))
	                    continue;
	
	                //Support unicode chars in the range names.
	                var elem = document.createElement('textarea');
	                elem.innerHTML = range;
	                var rangeHtml = elem.value;
	
	                this.ranges[rangeHtml] = [start, end];
	            }
	
	            var list = '<ul>';
	            for (range in this.ranges) {
	                list += '<li data-range-key="' + range + '">' + range + '</li>';
	            }
	            if (this.showCustomRangeLabel) {
	                list += '<li data-range-key="' + this.locale.customRangeLabel + '">' + this.locale.customRangeLabel + '</li>';
	            }
	            list += '</ul>';
	            this.container.find('.ranges').prepend(list);
	        }
	
	        if (typeof cb === 'function') {
	            this.callback = cb;
	        }
	
	        if (!this.timePicker) {
	            this.startDate = this.startDate.startOf('day');
	            this.endDate = this.endDate.endOf('day');
	            this.container.find('.calendar-time').hide();
	        }
	
	        //can't be used together for now
	        if (this.timePicker && this.autoApply)
	            this.autoApply = false;
	
	        if (this.autoApply && typeof options.ranges !== 'object') {
	            this.container.find('.ranges').hide();
	        } else if (this.autoApply) {
	            this.container.find('.applyBtn, .cancelBtn').addClass('hide');
	        }
	
	        if (this.singleDatePicker) {
	            this.container.addClass('single');
	            this.container.find('.calendar.left').addClass('single');
	            this.container.find('.calendar.left').show();
	            this.container.find('.calendar.right').hide();
	            this.container.find('.daterangepicker_input input, .daterangepicker_input > i').hide();
	            if (this.timePicker) {
	                this.container.find('.ranges ul').hide();
	            } else {
	                this.container.find('.ranges').hide();
	            }
	        }
	
	        if ((typeof options.ranges === 'undefined' && !this.singleDatePicker) || this.alwaysShowCalendars) {
	            this.container.addClass('show-calendar');
	        }
	
	        this.container.addClass('opens' + this.opens);
	
	        //swap the position of the predefined ranges if opens right
	        if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
	            this.container.find('.ranges').prependTo( this.container.find('.calendar.left').parent() );
	        }
	
	        //apply CSS classes and labels to buttons
	        this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
	        if (this.applyClass.length)
	            this.container.find('.applyBtn').addClass(this.applyClass);
	        if (this.cancelClass.length)
	            this.container.find('.cancelBtn').addClass(this.cancelClass);
	        this.container.find('.applyBtn').html(this.locale.applyLabel);
	        this.container.find('.cancelBtn').html(this.locale.cancelLabel);
	
	        //
	        // event listeners
	        //
	
	        this.container.find('.calendar')
	            .on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this))
	            .on('click.daterangepicker', '.next', $.proxy(this.clickNext, this))
	            .on('mousedown.daterangepicker', 'td.available', $.proxy(this.clickDate, this))
	            .on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this))
	            .on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this))
	            .on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this))
	            .on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this))
	            .on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this))
	            .on('focus.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsFocused, this))
	            .on('blur.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsBlurred, this))
	            .on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this));
	
	        this.container.find('.ranges')
	            .on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this))
	            .on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this))
	            .on('click.daterangepicker', 'li', $.proxy(this.clickRange, this))
	            .on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this))
	            .on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));
	
	        if (this.element.is('input') || this.element.is('button')) {
	            this.element.on({
	                'click.daterangepicker': $.proxy(this.show, this),
	                'focus.daterangepicker': $.proxy(this.show, this),
	                'keyup.daterangepicker': $.proxy(this.elementChanged, this),
	                'keydown.daterangepicker': $.proxy(this.keydown, this)
	            });
	        } else {
	            this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
	        }
	
	        //
	        // if attached to a text input, set the initial value
	        //
	
	        if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	            this.element.trigger('change');
	        } else if (this.element.is('input') && this.autoUpdateInput) {
	            this.element.val(this.startDate.format(this.locale.format));
	            this.element.trigger('change');
	        }
	
	    };
	
	    DateRangePicker.prototype = {
	
	        constructor: DateRangePicker,
	
	        setStartDate: function(startDate) {
	            if (typeof startDate === 'string')
	                this.startDate = moment(startDate, this.locale.format);
	
	            if (typeof startDate === 'object')
	                this.startDate = moment(startDate);
	
	            if (!this.timePicker)
	                this.startDate = this.startDate.startOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.minDate && this.startDate.isBefore(this.minDate)) {
	                this.startDate = this.minDate;
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (this.maxDate && this.startDate.isAfter(this.maxDate)) {
	                this.startDate = this.maxDate;
	                if (this.timePicker && this.timePickerIncrement)
	                    this.startDate.minute(Math.floor(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	            }
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        setEndDate: function(endDate) {
	            if (typeof endDate === 'string')
	                this.endDate = moment(endDate, this.locale.format);
	
	            if (typeof endDate === 'object')
	                this.endDate = moment(endDate);
	
	            if (!this.timePicker)
	                this.endDate = this.endDate.endOf('day');
	
	            if (this.timePicker && this.timePickerIncrement)
	                this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);
	
	            if (this.endDate.isBefore(this.startDate))
	                this.endDate = this.startDate.clone();
	
	            if (this.maxDate && this.endDate.isAfter(this.maxDate))
	                this.endDate = this.maxDate;
	
	            if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate))
	                this.endDate = this.startDate.clone().add(this.dateLimit);
	
	            this.previousRightTime = this.endDate.clone();
	
	            if (!this.isShowing)
	                this.updateElement();
	
	            this.updateMonthsInView();
	        },
	
	        isInvalidDate: function() {
	            return false;
	        },
	
	        isCustomDate: function() {
	            return false;
	        },
	
	        updateView: function() {
	            if (this.timePicker) {
	                this.renderTimePicker('left');
	                this.renderTimePicker('right');
	                if (!this.endDate) {
	                    this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
	                } else {
	                    this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
	                }
	            }
	            if (this.endDate) {
	                this.container.find('input[name="daterangepicker_end"]').removeClass('active');
	                this.container.find('input[name="daterangepicker_start"]').addClass('active');
	            } else {
	                this.container.find('input[name="daterangepicker_end"]').addClass('active');
	                this.container.find('input[name="daterangepicker_start"]').removeClass('active');
	            }
	            this.updateMonthsInView();
	            this.updateCalendars();
	            this.updateFormInputs();
	        },
	
	        updateMonthsInView: function() {
	            if (this.endDate) {
	
	                //if both dates are visible already, do nothing
	                if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month &&
	                    (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    &&
	                    (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))
	                    ) {
	                    return;
	                }
	
	                this.leftCalendar.month = this.startDate.clone().date(2);
	                if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
	                    this.rightCalendar.month = this.endDate.clone().date(2);
	                } else {
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	
	            } else {
	                if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
	                    this.leftCalendar.month = this.startDate.clone().date(2);
	                    this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
	                }
	            }
	            if (this.maxDate && this.linkedCalendars && !this.singleDatePicker && this.rightCalendar.month > this.maxDate) {
	              this.rightCalendar.month = this.maxDate.clone().date(2);
	              this.leftCalendar.month = this.maxDate.clone().date(2).subtract(1, 'month');
	            }
	        },
	
	        updateCalendars: function() {
	
	            if (this.timePicker) {
	                var hour, minute, second;
	                if (this.endDate) {
	                    hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                } else {
	                    hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                }
	                this.leftCalendar.month.hour(hour).minute(minute).second(second);
	                this.rightCalendar.month.hour(hour).minute(minute).second(second);
	            }
	
	            this.renderCalendar('left');
	            this.renderCalendar('right');
	
	            //highlight any predefined range matching the current start and end dates
	            this.container.find('.ranges li').removeClass('active');
	            if (this.endDate == null) return;
	
	            this.calculateChosenLabel();
	        },
	
	        renderCalendar: function(side) {
	
	            //
	            // Build the matrix of dates that will populate the calendar
	            //
	
	            var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
	            var month = calendar.month.month();
	            var year = calendar.month.year();
	            var hour = calendar.month.hour();
	            var minute = calendar.month.minute();
	            var second = calendar.month.second();
	            var daysInMonth = moment([year, month]).daysInMonth();
	            var firstDay = moment([year, month, 1]);
	            var lastDay = moment([year, month, daysInMonth]);
	            var lastMonth = moment(firstDay).subtract(1, 'month').month();
	            var lastYear = moment(firstDay).subtract(1, 'month').year();
	            var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
	            var dayOfWeek = firstDay.day();
	
	            //initialize a 6 rows x 7 columns array for the calendar
	            var calendar = [];
	            calendar.firstDay = firstDay;
	            calendar.lastDay = lastDay;
	
	            for (var i = 0; i < 6; i++) {
	                calendar[i] = [];
	            }
	
	            //populate the calendar with date objects
	            var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
	            if (startDay > daysInLastMonth)
	                startDay -= 7;
	
	            if (dayOfWeek == this.locale.firstDay)
	                startDay = daysInLastMonth - 6;
	
	            var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);
	
	            var col, row;
	            for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
	                if (i > 0 && col % 7 === 0) {
	                    col = 0;
	                    row++;
	                }
	                calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
	                curDate.hour(12);
	
	                if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
	                    calendar[row][col] = this.minDate.clone();
	                }
	
	                if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
	                    calendar[row][col] = this.maxDate.clone();
	                }
	
	            }
	
	            //make the calendar object available to hoverDate/clickDate
	            if (side == 'left') {
	                this.leftCalendar.calendar = calendar;
	            } else {
	                this.rightCalendar.calendar = calendar;
	            }
	
	            //
	            // Display the calendar
	            //
	
	            var minDate = side == 'left' ? this.minDate : this.startDate;
	            var maxDate = this.maxDate;
	            var selected = side == 'left' ? this.startDate : this.endDate;
	            var arrow = this.locale.direction == 'ltr' ? {left: 'chevron-left', right: 'chevron-right'} : {left: 'chevron-right', right: 'chevron-left'};
	
	            var html = '<table class="table-condensed">';
	            html += '<thead>';
	            html += '<tr>';
	
	            // add empty cell for week number
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th></th>';
	
	            if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
	                html += '<th class="prev available"><i class="fa fa-' + arrow.left + ' glyphicon glyphicon-' + arrow.left + '"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");
	
	            if (this.showDropdowns) {
	                var currentMonth = calendar[1][1].month();
	                var currentYear = calendar[1][1].year();
	                var maxYear = (maxDate && maxDate.year()) || (currentYear + 5);
	                var minYear = (minDate && minDate.year()) || (currentYear - 50);
	                var inMinYear = currentYear == minYear;
	                var inMaxYear = currentYear == maxYear;
	
	                var monthHtml = '<select class="monthselect">';
	                for (var m = 0; m < 12; m++) {
	                    if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            ">" + this.locale.monthNames[m] + "</option>";
	                    } else {
	                        monthHtml += "<option value='" + m + "'" +
	                            (m === currentMonth ? " selected='selected'" : "") +
	                            " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
	                    }
	                }
	                monthHtml += "</select>";
	
	                var yearHtml = '<select class="yearselect">';
	                for (var y = minYear; y <= maxYear; y++) {
	                    yearHtml += '<option value="' + y + '"' +
	                        (y === currentYear ? ' selected="selected"' : '') +
	                        '>' + y + '</option>';
	                }
	                yearHtml += '</select>';
	
	                dateHtml = monthHtml + yearHtml;
	            }
	
	            html += '<th colspan="5" class="month">' + dateHtml + '</th>';
	            if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
	                html += '<th class="next available"><i class="fa fa-' + arrow.right + ' glyphicon glyphicon-' + arrow.right + '"></i></th>';
	            } else {
	                html += '<th></th>';
	            }
	
	            html += '</tr>';
	            html += '<tr>';
	
	            // add week number label
	            if (this.showWeekNumbers || this.showISOWeekNumbers)
	                html += '<th class="week">' + this.locale.weekLabel + '</th>';
	
	            $.each(this.locale.daysOfWeek, function(index, dayOfWeek) {
	                html += '<th>' + dayOfWeek + '</th>';
	            });
	
	            html += '</tr>';
	            html += '</thead>';
	            html += '<tbody>';
	
	            //adjust maxDate to reflect the dateLimit setting in order to
	            //grey out end dates beyond the dateLimit
	            if (this.endDate == null && this.dateLimit) {
	                var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
	                if (!maxDate || maxLimit.isBefore(maxDate)) {
	                    maxDate = maxLimit;
	                }
	            }
	
	            for (var row = 0; row < 6; row++) {
	                html += '<tr>';
	
	                // add week number
	                if (this.showWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].week() + '</td>';
	                else if (this.showISOWeekNumbers)
	                    html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';
	
	                for (var col = 0; col < 7; col++) {
	
	                    var classes = [];
	
	                    //highlight today's date
	                    if (calendar[row][col].isSame(new Date(), "day"))
	                        classes.push('today');
	
	                    //highlight weekends
	                    if (calendar[row][col].isoWeekday() > 5)
	                        classes.push('weekend');
	
	                    //grey out the dates in other months displayed at beginning and end of this calendar
	                    if (calendar[row][col].month() != calendar[1][1].month())
	                        classes.push('off');
	
	                    //don't allow selection of dates before the minimum date
	                    if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of dates after the maximum date
	                    if (maxDate && calendar[row][col].isAfter(maxDate, 'day'))
	                        classes.push('off', 'disabled');
	
	                    //don't allow selection of date if a custom function decides it's invalid
	                    if (this.isInvalidDate(calendar[row][col]))
	                        classes.push('off', 'disabled');
	
	                    //highlight the currently selected start date
	                    if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'start-date');
	
	                    //highlight the currently selected end date
	                    if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD'))
	                        classes.push('active', 'end-date');
	
	                    //highlight dates in-between the selected dates
	                    if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate)
	                        classes.push('in-range');
	
	                    //apply custom classes for this date
	                    var isCustom = this.isCustomDate(calendar[row][col]);
	                    if (isCustom !== false) {
	                        if (typeof isCustom === 'string')
	                            classes.push(isCustom);
	                        else
	                            Array.prototype.push.apply(classes, isCustom);
	                    }
	
	                    var cname = '', disabled = false;
	                    for (var i = 0; i < classes.length; i++) {
	                        cname += classes[i] + ' ';
	                        if (classes[i] == 'disabled')
	                            disabled = true;
	                    }
	                    if (!disabled)
	                        cname += 'available';
	
	                    html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
	
	                }
	                html += '</tr>';
	            }
	
	            html += '</tbody>';
	            html += '</table>';
	
	            this.container.find('.calendar.' + side + ' .calendar-table').html(html);
	
	        },
	
	        renderTimePicker: function(side) {
	
	            // Don't bother updating the time picker if it's currently disabled
	            // because an end date hasn't been clicked yet
	            if (side == 'right' && !this.endDate) return;
	
	            var html, selected, minDate, maxDate = this.maxDate;
	
	            if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate)))
	                maxDate = this.startDate.clone().add(this.dateLimit);
	
	            if (side == 'left') {
	                selected = this.startDate.clone();
	                minDate = this.minDate;
	            } else if (side == 'right') {
	                selected = this.endDate.clone();
	                minDate = this.startDate;
	
	                //Preserve the time already selected
	                var timeSelector = this.container.find('.calendar.right .calendar-time div');
	                if (!this.endDate && timeSelector.html() != '') {
	
	                    selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
	                    selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
	                    selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());
	
	                    if (!this.timePicker24Hour) {
	                        var ampm = timeSelector.find('.ampmselect option:selected').val();
	                        if (ampm === 'PM' && selected.hour() < 12)
	                            selected.hour(selected.hour() + 12);
	                        if (ampm === 'AM' && selected.hour() === 12)
	                            selected.hour(0);
	                    }
	
	                }
	
	                if (selected.isBefore(this.startDate))
	                    selected = this.startDate.clone();
	
	                if (maxDate && selected.isAfter(maxDate))
	                    selected = maxDate.clone();
	
	            }
	
	            //
	            // hours
	            //
	
	            html = '<select class="hourselect">';
	
	            var start = this.timePicker24Hour ? 0 : 1;
	            var end = this.timePicker24Hour ? 23 : 12;
	
	            for (var i = start; i <= end; i++) {
	                var i_in_24 = i;
	                if (!this.timePicker24Hour)
	                    i_in_24 = selected.hour() >= 12 ? (i == 12 ? 12 : i + 12) : (i == 12 ? 0 : i);
	
	                var time = selected.clone().hour(i_in_24);
	                var disabled = false;
	                if (minDate && time.minute(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.minute(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (i_in_24 == selected.hour() && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + i + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + i + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // minutes
	            //
	
	            html += ': <select class="minuteselect">';
	
	            for (var i = 0; i < 60; i += this.timePickerIncrement) {
	                var padded = i < 10 ? '0' + i : i;
	                var time = selected.clone().minute(i);
	
	                var disabled = false;
	                if (minDate && time.second(59).isBefore(minDate))
	                    disabled = true;
	                if (maxDate && time.second(0).isAfter(maxDate))
	                    disabled = true;
	
	                if (selected.minute() == i && !disabled) {
	                    html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                } else if (disabled) {
	                    html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                } else {
	                    html += '<option value="' + i + '">' + padded + '</option>';
	                }
	            }
	
	            html += '</select> ';
	
	            //
	            // seconds
	            //
	
	            if (this.timePickerSeconds) {
	                html += ': <select class="secondselect">';
	
	                for (var i = 0; i < 60; i++) {
	                    var padded = i < 10 ? '0' + i : i;
	                    var time = selected.clone().second(i);
	
	                    var disabled = false;
	                    if (minDate && time.isBefore(minDate))
	                        disabled = true;
	                    if (maxDate && time.isAfter(maxDate))
	                        disabled = true;
	
	                    if (selected.second() == i && !disabled) {
	                        html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
	                    } else if (disabled) {
	                        html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
	                    } else {
	                        html += '<option value="' + i + '">' + padded + '</option>';
	                    }
	                }
	
	                html += '</select> ';
	            }
	
	            //
	            // AM/PM
	            //
	
	            if (!this.timePicker24Hour) {
	                html += '<select class="ampmselect">';
	
	                var am_html = '';
	                var pm_html = '';
	
	                if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate))
	                    am_html = ' disabled="disabled" class="disabled"';
	
	                if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate))
	                    pm_html = ' disabled="disabled" class="disabled"';
	
	                if (selected.hour() >= 12) {
	                    html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
	                } else {
	                    html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
	                }
	
	                html += '</select>';
	            }
	
	            this.container.find('.calendar.' + side + ' .calendar-time div').html(html);
	
	        },
	
	        updateFormInputs: function() {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	                return;
	
	            this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
	            if (this.endDate)
	                this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));
	
	            if (this.singleDatePicker || (this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate)))) {
	                this.container.find('button.applyBtn').removeAttr('disabled');
	            } else {
	                this.container.find('button.applyBtn').attr('disabled', 'disabled');
	            }
	
	        },
	
	        move: function() {
	            var parentOffset = { top: 0, left: 0 },
	                containerTop;
	            var parentRightEdge = $(window).width();
	            if (!this.parentEl.is('body')) {
	                parentOffset = {
	                    top: this.parentEl.offset().top - this.parentEl.scrollTop(),
	                    left: this.parentEl.offset().left - this.parentEl.scrollLeft()
	                };
	                parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
	            }
	
	            if (this.drops == 'up')
	                containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;
	            else
	                containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
	            this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');
	
	            if (this.opens == 'left') {
	                this.container.css({
	                    top: containerTop,
	                    right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
	                    left: 'auto'
	                });
	                if (this.container.offset().left < 0) {
	                    this.container.css({
	                        right: 'auto',
	                        left: 9
	                    });
	                }
	            } else if (this.opens == 'center') {
	                this.container.css({
	                    top: containerTop,
	                    left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2
	                            - this.container.outerWidth() / 2,
	                    right: 'auto'
	                });
	                if (this.container.offset().left < 0) {
	                    this.container.css({
	                        right: 'auto',
	                        left: 9
	                    });
	                }
	            } else {
	                this.container.css({
	                    top: containerTop,
	                    left: this.element.offset().left - parentOffset.left,
	                    right: 'auto'
	                });
	                if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
	                    this.container.css({
	                        left: 'auto',
	                        right: 0
	                    });
	                }
	            }
	        },
	
	        show: function(e) {
	            if (this.isShowing) return;
	
	            // Create a click proxy that is private to this instance of datepicker, for unbinding
	            this._outsideClickProxy = $.proxy(function(e) { this.outsideClick(e); }, this);
	
	            // Bind global datepicker mousedown for hiding and
	            $(document)
	              .on('mousedown.daterangepicker', this._outsideClickProxy)
	              // also support mobile devices
	              .on('touchend.daterangepicker', this._outsideClickProxy)
	              // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
	              .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
	              // and also close when focus changes to outside the picker (eg. tabbing between controls)
	              .on('focusin.daterangepicker', this._outsideClickProxy);
	
	            // Reposition the picker if the window is resized while it's open
	            $(window).on('resize.daterangepicker', $.proxy(function(e) { this.move(e); }, this));
	
	            this.oldStartDate = this.startDate.clone();
	            this.oldEndDate = this.endDate.clone();
	            this.previousRightTime = this.endDate.clone();
	
	            this.updateView();
	            this.container.show();
	            this.move();
	            this.element.trigger('show.daterangepicker', this);
	            this.isShowing = true;
	        },
	
	        hide: function(e) {
	            if (!this.isShowing) return;
	
	            //incomplete date selection, revert to last values
	            if (!this.endDate) {
	                this.startDate = this.oldStartDate.clone();
	                this.endDate = this.oldEndDate.clone();
	            }
	
	            //if a new date range was selected, invoke the user callback function
	            if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
	                this.callback(this.startDate, this.endDate, this.chosenLabel);
	
	            //if picker is attached to a text input, update it
	            this.updateElement();
	
	            $(document).off('.daterangepicker');
	            $(window).off('.daterangepicker');
	            this.container.hide();
	            this.element.trigger('hide.daterangepicker', this);
	            this.isShowing = false;
	        },
	
	        toggle: function(e) {
	            if (this.isShowing) {
	                this.hide();
	            } else {
	                this.show();
	            }
	        },
	
	        outsideClick: function(e) {
	            var target = $(e.target);
	            // if the page is clicked anywhere except within the daterangerpicker/button
	            // itself then call this.hide()
	            if (
	                // ie modal dialog fix
	                e.type == "focusin" ||
	                target.closest(this.element).length ||
	                target.closest(this.container).length ||
	                target.closest('.calendar-table').length
	                ) return;
	            this.hide();
	            this.element.trigger('outsideClick.daterangepicker', this);
	        },
	
	        showCalendars: function() {
	            this.container.addClass('show-calendar');
	            this.move();
	            this.element.trigger('showCalendar.daterangepicker', this);
	        },
	
	        hideCalendars: function() {
	            this.container.removeClass('show-calendar');
	            this.element.trigger('hideCalendar.daterangepicker', this);
	        },
	
	        hoverRange: function(e) {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	                return;
	
	            var label = e.target.getAttribute('data-range-key');
	
	            if (label == this.locale.customRangeLabel) {
	                this.updateView();
	            } else {
	                var dates = this.ranges[label];
	                this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
	                this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
	            }
	
	        },
	
	        clickRange: function(e) {
	            var label = e.target.getAttribute('data-range-key');
	            this.chosenLabel = label;
	            if (label == this.locale.customRangeLabel) {
	                this.showCalendars();
	            } else {
	                var dates = this.ranges[label];
	                this.startDate = dates[0];
	                this.endDate = dates[1];
	
	                if (!this.timePicker) {
	                    this.startDate.startOf('day');
	                    this.endDate.endOf('day');
	                }
	
	                if (!this.alwaysShowCalendars)
	                    this.hideCalendars();
	                this.clickApply();
	            }
	        },
	
	        clickPrev: function(e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.subtract(1, 'month');
	                if (this.linkedCalendars)
	                    this.rightCalendar.month.subtract(1, 'month');
	            } else {
	                this.rightCalendar.month.subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        clickNext: function(e) {
	            var cal = $(e.target).parents('.calendar');
	            if (cal.hasClass('left')) {
	                this.leftCalendar.month.add(1, 'month');
	            } else {
	                this.rightCalendar.month.add(1, 'month');
	                if (this.linkedCalendars)
	                    this.leftCalendar.month.add(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        hoverDate: function(e) {
	
	            //ignore mouse movements while an above-calendar text input has focus
	            //if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus"))
	            //    return;
	
	            //ignore dates that can't be selected
	            if (!$(e.target).hasClass('available')) return;
	
	            //have the text inputs above calendars reflect the date being hovered over
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            if (this.endDate && !this.container.find('input[name=daterangepicker_start]').is(":focus")) {
	                this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
	            } else if (!this.endDate && !this.container.find('input[name=daterangepicker_end]').is(":focus")) {
	                this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
	            }
	
	            //highlight the dates between the start date and the date being hovered as a potential end date
	            var leftCalendar = this.leftCalendar;
	            var rightCalendar = this.rightCalendar;
	            var startDate = this.startDate;
	            if (!this.endDate) {
	                this.container.find('.calendar td').each(function(index, el) {
	
	                    //skip week numbers, only look at dates
	                    if ($(el).hasClass('week')) return;
	
	                    var title = $(el).attr('data-title');
	                    var row = title.substr(1, 1);
	                    var col = title.substr(3, 1);
	                    var cal = $(el).parents('.calendar');
	                    var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];
	
	                    if ((dt.isAfter(startDate) && dt.isBefore(date)) || dt.isSame(date, 'day')) {
	                        $(el).addClass('in-range');
	                    } else {
	                        $(el).removeClass('in-range');
	                    }
	
	                });
	            }
	
	        },
	
	        clickDate: function(e) {
	
	            if (!$(e.target).hasClass('available')) return;
	
	            var title = $(e.target).attr('data-title');
	            var row = title.substr(1, 1);
	            var col = title.substr(3, 1);
	            var cal = $(e.target).parents('.calendar');
	            var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];
	
	            //
	            // this function needs to do a few things:
	            // * alternate between selecting a start and end date for the range,
	            // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
	            // * if autoapply is enabled, and an end date was chosen, apply the selection
	            // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
	            // * if one of the inputs above the calendars was focused, cancel that manual input
	            //
	
	            if (this.endDate || date.isBefore(this.startDate, 'day')) { //picking start
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.left .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.endDate = null;
	                this.setStartDate(date.clone());
	            } else if (!this.endDate && date.isBefore(this.startDate)) {
	                //special case: clicking the same date for start/end,
	                //but the time of the end date is before the start date
	                this.setEndDate(this.startDate.clone());
	            } else { // picking end
	                if (this.timePicker) {
	                    var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
	                    if (!this.timePicker24Hour) {
	                        var ampm = this.container.find('.right .ampmselect').val();
	                        if (ampm === 'PM' && hour < 12)
	                            hour += 12;
	                        if (ampm === 'AM' && hour === 12)
	                            hour = 0;
	                    }
	                    var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
	                    var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
	                    date = date.clone().hour(hour).minute(minute).second(second);
	                }
	                this.setEndDate(date.clone());
	                if (this.autoApply) {
	                  this.calculateChosenLabel();
	                  this.clickApply();
	                }
	            }
	
	            if (this.singleDatePicker) {
	                this.setEndDate(this.startDate);
	                if (!this.timePicker)
	                    this.clickApply();
	            }
	
	            this.updateView();
	
	            //This is to cancel the blur event handler if the mouse was in one of the inputs
	            e.stopPropagation();
	
	        },
	
	        calculateChosenLabel: function() {
	          var customRange = true;
	          var i = 0;
	          for (var range in this.ranges) {
	              if (this.timePicker) {
	                  if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
	                      customRange = false;
	                      this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                      break;
	                  }
	              } else {
	                  //ignore times when comparing dates if time picker is not enabled
	                  if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
	                      customRange = false;
	                      this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
	                      break;
	                  }
	              }
	              i++;
	          }
	          if (customRange && this.showCustomRangeLabel) {
	              this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
	              this.showCalendars();
	          }
	        },
	
	        clickApply: function(e) {
	            this.hide();
	            this.element.trigger('apply.daterangepicker', this);
	        },
	
	        clickCancel: function(e) {
	            this.startDate = this.oldStartDate;
	            this.endDate = this.oldEndDate;
	            this.hide();
	            this.element.trigger('cancel.daterangepicker', this);
	        },
	
	        monthOrYearChanged: function(e) {
	            var isLeft = $(e.target).closest('.calendar').hasClass('left'),
	                leftOrRight = isLeft ? 'left' : 'right',
	                cal = this.container.find('.calendar.'+leftOrRight);
	
	            // Month must be Number for new moment versions
	            var month = parseInt(cal.find('.monthselect').val(), 10);
	            var year = cal.find('.yearselect').val();
	
	            if (!isLeft) {
	                if (year < this.startDate.year() || (year == this.startDate.year() && month < this.startDate.month())) {
	                    month = this.startDate.month();
	                    year = this.startDate.year();
	                }
	            }
	
	            if (this.minDate) {
	                if (year < this.minDate.year() || (year == this.minDate.year() && month < this.minDate.month())) {
	                    month = this.minDate.month();
	                    year = this.minDate.year();
	                }
	            }
	
	            if (this.maxDate) {
	                if (year > this.maxDate.year() || (year == this.maxDate.year() && month > this.maxDate.month())) {
	                    month = this.maxDate.month();
	                    year = this.maxDate.year();
	                }
	            }
	
	            if (isLeft) {
	                this.leftCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
	            } else {
	                this.rightCalendar.month.month(month).year(year);
	                if (this.linkedCalendars)
	                    this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
	            }
	            this.updateCalendars();
	        },
	
	        timeChanged: function(e) {
	
	            var cal = $(e.target).closest('.calendar'),
	                isLeft = cal.hasClass('left');
	
	            var hour = parseInt(cal.find('.hourselect').val(), 10);
	            var minute = parseInt(cal.find('.minuteselect').val(), 10);
	            var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;
	
	            if (!this.timePicker24Hour) {
	                var ampm = cal.find('.ampmselect').val();
	                if (ampm === 'PM' && hour < 12)
	                    hour += 12;
	                if (ampm === 'AM' && hour === 12)
	                    hour = 0;
	            }
	
	            if (isLeft) {
	                var start = this.startDate.clone();
	                start.hour(hour);
	                start.minute(minute);
	                start.second(second);
	                this.setStartDate(start);
	                if (this.singleDatePicker) {
	                    this.endDate = this.startDate.clone();
	                } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
	                    this.setEndDate(start.clone());
	                }
	            } else if (this.endDate) {
	                var end = this.endDate.clone();
	                end.hour(hour);
	                end.minute(minute);
	                end.second(second);
	                this.setEndDate(end);
	            }
	
	            //update the calendars so all clickable dates reflect the new time component
	            this.updateCalendars();
	
	            //update the form inputs above the calendars with the new time
	            this.updateFormInputs();
	
	            //re-render the time pickers because changing one selection can affect what's enabled in another
	            this.renderTimePicker('left');
	            this.renderTimePicker('right');
	
	        },
	
	        formInputsChanged: function(e) {
	            var isRight = $(e.target).closest('.calendar').hasClass('right');
	            var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
	            var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);
	
	            if (start.isValid() && end.isValid()) {
	
	                if (isRight && end.isBefore(start))
	                    start = end.clone();
	
	                this.setStartDate(start);
	                this.setEndDate(end);
	
	                if (isRight) {
	                    this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
	                } else {
	                    this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
	                }
	
	            }
	
	            this.updateView();
	        },
	
	        formInputsFocused: function(e) {
	
	            // Highlight the focused input
	            this.container.find('input[name="daterangepicker_start"], input[name="daterangepicker_end"]').removeClass('active');
	            $(e.target).addClass('active');
	
	            // Set the state such that if the user goes back to using a mouse, 
	            // the calendars are aware we're selecting the end of the range, not
	            // the start. This allows someone to edit the end of a date range without
	            // re-selecting the beginning, by clicking on the end date input then
	            // using the calendar.
	            var isRight = $(e.target).closest('.calendar').hasClass('right');
	            if (isRight) {
	                this.endDate = null;
	                this.setStartDate(this.startDate.clone());
	                this.updateView();
	            }
	
	        },
	
	        formInputsBlurred: function(e) {
	
	            // this function has one purpose right now: if you tab from the first
	            // text input to the second in the UI, the endDate is nulled so that
	            // you can click another, but if you tab out without clicking anything
	            // or changing the input value, the old endDate should be retained
	
	            if (!this.endDate) {
	                var val = this.container.find('input[name="daterangepicker_end"]').val();
	                var end = moment(val, this.locale.format);
	                if (end.isValid()) {
	                    this.setEndDate(end);
	                    this.updateView();
	                }
	            }
	
	        },
	
	        elementChanged: function() {
	            if (!this.element.is('input')) return;
	            if (!this.element.val().length) return;
	            if (this.element.val().length < this.locale.format.length) return;
	
	            var dateString = this.element.val().split(this.locale.separator),
	                start = null,
	                end = null;
	
	            if (dateString.length === 2) {
	                start = moment(dateString[0], this.locale.format);
	                end = moment(dateString[1], this.locale.format);
	            }
	
	            if (this.singleDatePicker || start === null || end === null) {
	                start = moment(this.element.val(), this.locale.format);
	                end = start;
	            }
	
	            if (!start.isValid() || !end.isValid()) return;
	
	            this.setStartDate(start);
	            this.setEndDate(end);
	            this.updateView();
	        },
	
	        keydown: function(e) {
	            //hide on tab or enter
	            if ((e.keyCode === 9) || (e.keyCode === 13)) {
	                this.hide();
	            }
	        },
	
	        updateElement: function() {
	            if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
	                this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
	                this.element.trigger('change');
	            } else if (this.element.is('input') && this.autoUpdateInput) {
	                this.element.val(this.startDate.format(this.locale.format));
	                this.element.trigger('change');
	            }
	        },
	
	        remove: function() {
	            this.container.remove();
	            this.element.off('.daterangepicker');
	            this.element.removeData();
	        }
	
	    };
	
	    $.fn.daterangepicker = function(options, callback) {
	        this.each(function() {
	            var el = $(this);
	            if (el.data('daterangepicker'))
	                el.data('daterangepicker').remove();
	            el.data('daterangepicker', new DateRangePicker(el, options, callback));
	        });
	        return this;
	    };
	
	    return DateRangePicker;
	
	}));


/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('makeStealthForceChart', __webpack_require__(808));
	};

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	function directive($http) {
	    return {
	        link: function link($scope, element) {
	            $scope.$on('stealthForceChart', function (event, data) {
	                var value_offset = 40;
	                var trig = d3.select("#stealthforcechart").append("div");
	
	                // var trigger_leggend = trig.selectAll(".trigger_leggend")
	                //     .data([''])
	                //     .enter().append("button")
	                //     .text("Upload")
	                //     .style("display","block")
	                //     .attr("class", "btnRestore2015")
	                //     .style("fill", "#000");
	
	                // $('.sUpload').on('click',function() {
	                //     // $scope.triggerScript();
	                //     $scope.uploadBtn();
	                // });
	
	                var width = $('#stealthforcechart').width();
	                var height = width / 1.5;
	                var tCount = [],
	                    link,
	                    node;
	                var square_width = 30;
	                data.links.forEach(function (d) {
	                    tCount.push(d.value);
	                });
	                var maxNum = Math.max.apply(Math, tCount);
	
	                var palette = {
	                    "lightgray": "#A4A4A4",
	                    "gray": "#708284",
	                    "mediumgray": "#536870",
	                    "darkgray": "#475B62",
	                    "darkblue": "#0A2933",
	                    "darkerblue": "#042029",
	                    "paleryellow": "#FCF4DC",
	                    "paleyellow": "#EAE3CB",
	                    "yellow": "#E9D805",
	                    "orange": "#FFA500",
	                    "red": "#D11C24",
	                    "pink": "#C61C6F",
	                    "darkpink": "#C61C3A",
	                    "purple": "#6364A6",
	                    "darkpurple": "#9F5AB7",
	                    "blue": "#4273C7",
	                    "darkgreen": "#1F5E76",
	                    "green": "#259286",
	                    "yellowgreen": "#738A05"
	                };
	                var color = function color(group, type) {
	                    if (group === 0) {
	                        // stealth role/group/coi node
	                        if (type === "role") {
	                            return palette.green;
	                        } else if (type === "group") {
	                            return palette.purple;
	                        } else if (type === "coi") {
	                            return palette.blue;
	                        }
	                    } else if (group === 1) {
	                        // IP node with 1 COI group
	                        return palette.lightgray;
	                    } else if (group >= 2) {
	                        // IP node with 2 COI groups
	                        return palette.gray;
	                    } else {
	                        return palette.red;
	                    }
	                };
	                function logslider(x) {
	                    if (x === undefined) {
	                        return 18;
	                    }
	                    var minp = 0;
	                    var maxp = maxNum;
	                    // the result should be between 100 an 10000000
	                    var minv = Math.log(5);
	                    var maxv = Math.log(50);
	                    // calculate adjustment factor
	                    var scale = (maxv - minv) / (maxp - minp);
	                    return Math.exp(minv + scale * (x - minp));
	                }
	
	                var circleWidth = 5;
	
	                var outVis = d3.select("#stealthforcechart").append('svg').attr("width", width).attr("height", height).call(d3.behavior.zoom().scaleExtent([0.5, 4]).on("zoom", zoom));
	
	                var vis = outVis.append("svg").attr("class", "stage").attr("width", width).attr("height", height).append('g');
	
	                function zoom() {
	                    vis.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
	                }
	
	                // // add tooltip
	                // $scope.tip = d3.tip()
	                //     .attr('class', 't-tip')
	                //     .offset([0, -100])
	                //     .html(function (d) {
	                //         var title = "<strong>Rules </strong> <br />";
	                //         var rules = "";
	                //         for (var i = 0; i < d.rules.length; i++) {
	                //             if (d.rules[i].rule !== "-") {
	                //                 rules += "&nbsp&nbsp&nbsp" + d.rules[i].order + " " + d.rules[i].rule + "<br />";
	                //             }
	                //         }
	                //         if (rules === "") {
	                //             return "<div class='hoverRules'>" + title + "None" + "</div>";
	                //         }
	                //         else {
	                //             return "<div class='hoverRules'>" + title + rules + "</div>";
	                //         }
	                //     });
	                //     vis.call($scope.tip);
	
	                var force = d3.layout.force().on("tick", tick).gravity(0.05).linkDistance(20).charge(-1500).size([width - 50, height]);
	
	                function dragstart(d) {
	                    d3.event.sourceEvent.stopPropagation();
	                    d.fixed = true;
	                    force.stop();
	                }
	
	                function dragmove(d) {
	                    d.fixed = true;
	                    d.px += d3.event.dx;
	                    if (d.px >= value_offset && d.px <= width - value_offset) {
	                        d.x += d3.event.dx;
	                    }
	                    d.py += d3.event.dy;
	                    if (d.py >= value_offset && d.py <= height - value_offset) {
	                        d.y += d3.event.dy;
	                    }
	                    tick();
	                }
	
	                function dragend(d) {
	                    d.fixed = true;
	                    d.px = d.x;
	                    d.py = d.y;
	                    $scope.page.save_coordinates(d);
	                    tick();
	                    force.resume();
	                }
	
	                $scope.update = function () {
	                    force.nodes(data.nodes).links(data.links).start();
	
	                    link = vis.selectAll(".link").data(data.links);
	                    link.enter().append("line").attr("class", "link").attr("stroke", "#CCC").attr("fill", "#000").style("stroke-width", "5");
	                    link.exit().remove();
	
	                    var node_drag = d3.behavior.drag().on("dragstart", dragstart).on("drag", dragmove).on("dragend", dragend);
	
	                    node = vis.selectAll(".node").data(data.nodes);
	                    node.enter().append("g").attr("class", "node").call(node_drag);
	
	                    // CIRCLE
	                    node.each(function (d) {
	                        if (d.type === "role" || d.type === "group") {
	                            d.fixed = true;
	                        }
	                        var elm = d3.select(this);
	                        if (d.hide !== "true") {
	                            if (d.gateway === 1) {
	                                elm.append('svg:path').attr('transform', 'translate(-18,-18)').attr('d', 'M18,0C8.059,0,0,8.06,0,18.001C0,27.941,8.059,36,18,36c9.94,0,18-8.059,18-17.999C36,8.06,27.94,0,18,0z').attr('fill', '#67AAB5');
	                                elm.append('svg:path').attr('transform', 'translate(-18,-18)').attr('d', 'M24.715,19.976l-2.057-1.122l-1.384-0.479l-1.051,0.857l-1.613-0.857l0.076-0.867l-1.062-0.325l0.31-1.146' + 'l-1.692,0.593l-0.724-1.616l0.896-1.049l1.108,0.082l0.918-0.511l0.806,1.629l0.447,0.087l-0.326-1.965l0.855-0.556l0.496-1.458' + 'l1.395-1.011l1.412-0.155l-0.729-0.7L22.06,9.039l1.984-0.283l0.727-0.568L22.871,6.41l-0.912,0.226L21.63,6.109l-1.406-0.352' + 'l-0.406,0.596l0.436,0.957l-0.485,1.201L18.636,7.33l-2.203-0.934l1.97-1.563L17.16,3.705l-2.325,0.627L8.91,3.678L6.39,6.285' + 'l2.064,1.242l1.479,1.567l0.307,2.399l1.009,1.316l1.694,2.576l0.223,0.177l-0.69-1.864l1.58,2.279l0.869,1.03' + 'c0,0,1.737,0.646,1.767,0.569c0.027-0.07,1.964,1.598,1.964,1.598l1.084,0.52L19.456,21.1l-0.307,1.775l1.17,1.996l0.997,1.242' + 'l-0.151,2.002L20.294,32.5l0.025,2.111l1.312-0.626c0,0,2.245-3.793,2.368-3.554c0.122,0.238,2.129-2.76,2.129-2.76l1.666-1.26' + 'l0.959-3.195l-2.882-1.775L24.715,19.976z').attr('fill', '#595A5C');
	                            } else if (d.type === "user") {
	                                elm.attr('height', '23').attr('width', '23').append('svg:path').attr('transform', 'translate(-11,-11)').attr('d', 'M22,22.5h-3.4c0,0,0-3.5,0-3.5c0-0.5-0.4-1.1-0.9-1.1' + 'c-0.5,0-1,0.5-1,1.1c0,0,0,3.5,0,3.5H5.3c0,0,0-3.3,0-3.5c0-0.5-0.4-1.1-1-1.1c-0.5,0-1,0.5-1,1.1c0,0.1,0,3.5,0,3.5H0' + 'c0,0,0-5.3,0-6.2c0-2.7,2.2-4.8,4.9-4.8c0.2,0,12,0,12.2,0c2.6,0,4.7,1.9,4.9,4.4L22,22.5z M11.1,0C8.4,0,6.2,2.2,6.2,4.9' + 's2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9S13.8,0,11.1,0z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', function (d) {
	                                    return color(d.group, d.type);
	                                });
	                            } else if (d.type === "coi") {
	                                elm.append('svg:path').attr('fill', palette.blue).attr('transform', 'translate(-20,-20)').attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828' + 'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439' + 'C28.014,15.545,26.676,21.468,23.587,26.751z');
	                            } else if (d.type === "role") {
	                                elm.append("svg:rect").attr("x", -(square_width / 2)).attr("y", -(square_width / 2)).attr("width", square_width).attr("height", square_width).attr("fill", function (d) {
	                                    return color(d.group, d.type, d.stealth_version);
	                                });
	                            } else {
	                                elm.append("svg:circle").attr("r", function (d) {
	                                    return logslider(d["width"]);
	                                }).attr("fill", function (d) {
	                                    return color(d.group, d.type, d.stealth_version);
	                                });
	                            }
	                        }
	                        elm.on('mouseover', function () {
	                            elm.style('cursor', 'pointer');
	                        });
	                    });
	                    // TEXT
	                    node.append("text").text(function (d) {
	                        return d.name;
	                    }).attr("x", function () {
	                        return circleWidth + 5;
	                    }).attr("y", function () {
	                        return circleWidth;
	                    }).attr("font-size", function () {
	                        return "1em";
	                    }).attr("text-anchor", function () {
	                        return "beginning";
	                    });
	
	                    node.append("title").html(function (d) {
	                        if (d.type === "coi") {
	                            var title = "<strong>Rules </strong> <br />";
	                            var rules = "";
	                            for (var i = 0; i < d.rules.length; i++) {
	                                if (d.rules[i].rule !== "-") {
	                                    rules += "&nbsp&nbsp&nbsp" + d.rules[i].order + " " + d.rules[i].rule + "<br />";
	                                }
	                            }
	                            if (rules === "") {
	                                rules = "None";
	                            }
	                            return rules;
	                        }
	                        return null;
	                    });
	                    node.exit().remove();
	                };
	                $scope.update();
	
	                function tick() {
	                    node[0].x = width;
	                    node[0].y = height;
	
	                    node.attr("cx", function (d) {
	                        return d.x = Math.max(value_offset, Math.min(width - value_offset, d.x));
	                    }).attr("cy", function (d) {
	                        return d.y = Math.max(value_offset, Math.min(height - value_offset * 5.6, d.y));
	                    });
	
	                    link.attr("x1", function (d) {
	                        return d.source.x;
	                    }).attr("y1", function (d) {
	                        return d.source.y;
	                    }).attr("x2", function (d) {
	                        return d.target.x;
	                    }).attr("y2", function (d) {
	                        return d.target.y;
	                    });
	
	                    node.attr("transform", function (d) {
	                        return "translate(" + d.x + "," + d.y + ")";
	                    });
	                }
	
	                // LEGEND
	                var legend_color = function legend_color(legend_item) {
	                    if (legend_item === "Stealth Role") {
	                        return palette.green;
	                    } else if (legend_item === "AD Group") {
	                        return palette.purple;
	                    } else if (legend_item === "Stealth COI") {
	                        return palette.blue;
	                    } else if (legend_item === "User with single COI") {
	                        // IP node with 1 COI group
	                        return palette.lightgray;
	                    } else if (legend_item === "User with multiple COIs") {
	                        // IP node with 2 COI groups
	                        return palette.gray;
	                    } else if (legend_item === "Users") {
	                        // IP node with 2 COI groups
	                        return '#000';
	                    } else {
	                        return palette.red;
	                    }
	                };
	                var circle_legend_data = ["AD Group"];
	                var square_legend_data = ["Stealth Role"];
	
	                var circle_legend = outVis.selectAll(".circle_legend").data(circle_legend_data).enter().append("g").attr("class", "circle_legend").attr("transform", function (d, i) {
	                    return "translate(11," + (i + 2.2) * 24 + ")";
	                });
	                circle_legend.append("circle").attr("r", function (d) {
	                    return logslider(d["width"]) - 7;
	                }).style("fill", function (d) {
	                    return legend_color(d);
	                });
	                circle_legend.append("text").attr("x", 15).attr("y", 0).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                var square_legend = outVis.selectAll(".square_legend").data(square_legend_data).enter().append("g").attr("class", "square_legend").attr("transform", function (d, i) {
	                    return "translate(11," + (i + circle_legend_data.length + 2.3) * 24 + ")";
	                });
	                square_legend.append("rect").attr("x", -((square_width - 8) / 2)).attr("y", -((square_width - 8) / 2)).attr("width", square_width - 8).attr("height", square_width - 8).style("fill", function (d) {
	                    return legend_color(d);
	                });
	                square_legend.append("text").attr("x", 15).attr("y", 0).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                var legendShield = outVis.selectAll(".legendShield").data(["Stealth COI"]).enter().append("g").attr("class", "legendShield").attr("transform", "translate(-7,88)");
	                legendShield.append('svg:path').attr('fill', palette.blue).attr('transform', 'translate(0,0)').attr('d', 'M23.587,26.751c-0.403,0.593-1.921,4.108-5.432,4.108c-3.421,0-5.099-3.525-5.27-3.828' + 'c-2.738-4.846-4.571-9.9-4.032-17.301c6.646,0,9.282-4.444,9.291-4.439c0.008-0.005,3.179,4.629,9.313,4.439' + 'C28.014,15.545,26.676,21.468,23.587,26.751z');
	                legendShield.append("text").attr("x", 32).attr("y", 19).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                var legend_data = ["Users"];
	
	                var legend = outVis.selectAll(".legend").data(legend_data).enter().append("g").attr("class", "legend").attr("transform", function (d, i) {
	                    return "translate(11," + (i + 1) * 26 + ")";
	                });
	                legend.attr('height', '23').attr('width', '23').append('svg:path').attr('transform', 'translate(-11,-11)').attr('d', 'M22,22.5h-3.4c0,0,0-3.5,0-3.5c0-0.5-0.4-1.1-0.9-1.1' + 'c-0.5,0-1,0.5-1,1.1c0,0,0,3.5,0,3.5H5.3c0,0,0-3.3,0-3.5c0-0.5-0.4-1.1-1-1.1c-0.5,0-1,0.5-1,1.1c0,0.1,0,3.5,0,3.5H0' + 'c0,0,0-5.3,0-6.2c0-2.7,2.2-4.8,4.9-4.8c0.2,0,12,0,12.2,0c2.6,0,4.7,1.9,4.9,4.4L22,22.5z M11.1,0C8.4,0,6.2,2.2,6.2,4.9' + 's2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9S13.8,0,11.1,0z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', function (d) {
	                    return legend_color(d);
	                });
	
	                legend.append("text").attr("x", 13).attr("y", 3).attr("dy", ".35em").text(function (d) {
	                    return d;
	                });
	
	                // var gateway_legend = outVis.selectAll(".gateway_legend")
	                //     .data(["Cleartext COI"])
	                //     .enter().append("g")
	                //     .attr("class", "gateway_legend");
	
	                // gateway_legend
	                //     .attr("transform", "translate(0," + (21) + ")" )
	                //     .append('svg:path')
	                //         .attr('transform', 'translate(0,126)')
	                //         .attr('d', 'M18,0C8.059,0,0,8.06,0,18.001C0,27.941,8.059,36,18,36c9.94,0,18-8.059,18-17.999C36,8.06,27.94,0,18,0z')
	                //         .attr('fill', '#67AAB5');
	                // gateway_legend.append('svg:path')
	                //     .attr('transform', 'translate(0,126)')
	                //     .attr('d', 'M24.715,19.976l-2.057-1.122l-1.384-0.479l-1.051,0.857l-1.613-0.857l0.076-0.867l-1.062-0.325l0.31-1.146'+
	                //         'l-1.692,0.593l-0.724-1.616l0.896-1.049l1.108,0.082l0.918-0.511l0.806,1.629l0.447,0.087l-0.326-1.965l0.855-0.556l0.496-1.458'+
	                //         'l1.395-1.011l1.412-0.155l-0.729-0.7L22.06,9.039l1.984-0.283l0.727-0.568L22.871,6.41l-0.912,0.226L21.63,6.109l-1.406-0.352'+
	                //         'l-0.406,0.596l0.436,0.957l-0.485,1.201L18.636,7.33l-2.203-0.934l1.97-1.563L17.16,3.705l-2.325,0.627L8.91,3.678L6.39,6.285'+
	                //         'l2.064,1.242l1.479,1.567l0.307,2.399l1.009,1.316l1.694,2.576l0.223,0.177l-0.69-1.864l1.58,2.279l0.869,1.03'+
	                //         'c0,0,1.737,0.646,1.767,0.569c0.027-0.07,1.964,1.598,1.964,1.598l1.084,0.52L19.456,21.1l-0.307,1.775l1.17,1.996l0.997,1.242'+
	                //         'l-0.151,2.002L20.294,32.5l0.025,2.111l1.312-0.626c0,0,2.245-3.793,2.368-3.554c0.122,0.238,2.129-2.76,2.129-2.76l1.666-1.26'+
	                //         'l0.959-3.195l-2.882-1.775L24.715,19.976z')
	                //     .attr('fill', '#595A5C');
	
	                // gateway_legend.append("text")
	                //     .attr("x", 40)
	                //     .attr("y", 144)
	                //     .attr("dy", ".35em")
	                //     .text(function (d) { return d; });
	
	                $scope.$on('$destroy', function () {
	                    element.remove();
	                });
	            });
	        }
	    };
	}
	
	directive.$inject = ['$http'];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('makeGeoChart', __webpack_require__(810));
	};

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _dc = __webpack_require__(811);
	
	var _dc2 = _interopRequireDefault(_dc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function directive(getSize, generateId, $window) {
	    var worldJSON = __webpack_require__(813);
	    return {
	        link: function link($scope, element, attrs) {
	            var size = getSize(element, 'geoChart');
	            var width = size.width;
	            var height = size.height;
	            $scope.page.w = angular.element($window);
	            var geom = void 0;
	            // element[0].insertAdjacentHTML('beforebegin', spinnerHTML); // start spinner
	            // element[0].parentNode.querySelector('.loader').setAttribute('style', 'height:'+(height/2)+'px; position:relative; margin:'+(height/2)+"px 0px -"+(height)+"px 0px;zoom:0.5; -moz-transform: scale(0.5);");
	
	            var chartUid = false,
	                uid,
	                key; // because there is one instances of this directive per view, we can assign a uid directly to it
	            var dimension,
	                group,
	                div = "#geochart",
	                searchCategories; // set our default vairables
	            $scope.$on('init', function (event, chart) {
	                if (chart.id !== attrs.uid) {
	                    return;
	                }
	                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') {
	                    return;
	                } // if its not in our dc object, ignore
	                $scope.main.dataObjects[chart.key].launched = true;
	                uid = chart.id;
	                key = chart.key;
	
	                dimension = $scope.main.dataObjects[key].dimension;
	                group = $scope.main.dataObjects[key].group;
	                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
	                if (typeof $scope.main.dataObjects[key].div !== 'undefined') {
	                    div = "#" + $scope.main.dataObjects[key].div;
	                }
	                chartUid = generateId();
	                geom = _dc2.default.geoChoroplethChart(div);
	
	                var filter = true;
	                var numberFormat = d3.format(".2f");
	                //var dimension = crossfilterData.dimension(function (d) { return d.remote_country;});
	                var cc = [];
	                var domain = [];
	                var Rainbow = __webpack_require__(814);
	                var rainbow = new Rainbow();
	                var numberOfItems;
	                function doColor() {
	                    domain = [];
	                    cc = [];
	                    numberOfItems = 1;
	                    var count = group.top(Infinity).length;
	                    if (count > 0) {
	                        var top = group.orderNatural(function (p) {
	                            return p.count;
	                        }).top(1);
	                        numberOfItems = top[0].value + 1;
	                    }
	                    rainbow.setNumberRange(0, numberOfItems);
	                    rainbow.setSpectrum("#FF0000", "#CC0000", "#990000", "#660000", "#360000"); //red gradient version
	                    // rainbow.setSpectrum("#808080", "#737373", "#666666", "#595959", "#4C4C4C"); //pure gray
	                    for (var i = 1; i <= numberOfItems; i++) {
	                        domain.push(i);
	                        var hexColour = rainbow.colourAt(i);
	                        cc.push('#' + hexColour);
	                    }
	                }
	                doColor();
	
	                function zoomed() {
	                    d3.select(element[0]).select('svg g').attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
	                }
	
	                var projection = d3.geo.mercator().precision(0.1).scale(width / 2.6 / Math.PI).translate([width / 2, height / 1.4]);
	                // var projection = d3.geo.mercator().precision(0.1).scale(width / 2.6 / Math.PI).translate([width / 2.1, width / 3.7]);
	                var zoom = d3.behavior.zoom().translate([0, 0]).scale(1).scaleExtent([0.75, 3]).on("zoom", zoomed);
	                var svg = d3.select(div).attr("width", width).attr("height", height).call(zoom);
	                geom.dimension(dimension).group(group).projection(projection).width(width).height(height).colors(d3.scale.ordinal().domain(domain).range(cc)).colorCalculator(function (d) {
	                    return d ? geom.colors()(d) : '#ccc';
	                }).overlayGeoJson(worldJSON.features, "country", function (d) {
	                    return d.properties.name;
	                }).title(function (d) {
	                    if (typeof d.value === "undefined") {
	                        return d.key + ": " + "0";
	                    }return d.key + ": " + Math.round(d.value * 100) / 100;
	                });
	                geom.render();
	
	                if (filter == true) {
	                    geom.on("filtered", function (chart, value) {
	                        var column, title;
	                        for (var s in searchCategories) {
	                            column = s;
	                            title = searchCategories[s];
	                            break;
	                        }
	                        $scope.main.filterItem(column, value, "include", title);
	                    });
	                }
	
	                // set update functions
	                $scope.$on('updatedData', function (event, id) {
	                    if (id !== uid) {
	                        return;
	                    } // only run when it sees its id has filteres
	
	                    geom.filterAll();
	                    doColor(); // sets the correct colors depending on new number of items
	                    geom.dimension(dimension).group(group).colors(d3.scale.ordinal().domain(domain).range(cc)).colorCalculator(function (d) {
	                        return d ? geom.colors()(d) : '#ccc';
	                    });
	
	                    // redraw geomap with new data
	                    geom.redraw();
	                });
	
	                // var projection = d3.geo.mercator().precision(0.1).scale(width / 2.1 / Math.PI).translate([width / 2, width / 3]);
	                // // var projection = d3.geo.mercator().precision(0.1).scale(width / 2.6 / Math.PI).translate([width / 2.1, width / 3.7]);
	                // var zoom = d3.behavior.zoom()
	                //     .translate([0,0])
	                //     .scale(1)
	                //     .scaleExtent([0.75, 3])
	                //     .on("zoom", zoomed);
	                // var svg = d3.select(div)
	                //     .attr("width", width)
	                //     .attr("height", height)
	                //     .call(zoom);
	                // geom
	                //     .dimension(dimension)
	                //     .group(group)
	                //     .projection(projection)
	                //     .width(width)
	                //     .height(height)
	
	                var resizeTimeout = void 0;
	                $scope.page.w.bind('resize', function () {
	                    if (!resizeTimeout) {
	                        if (typeof geom !== "undefined") {
	                            resizeTimeout = setTimeout(function () {
	                                resizeTimeout = null;
	                                size = getSize(element, 'geoChart');
	                                width = size.width;
	                                height = size.height;
	                                projection = d3.geo.mercator().precision(0.1).scale(width / 2 / Math.PI).translate([width / 2, width / 3]);
	                                geom.width(width).height(height).projection(projection);
	                                d3.select(element[0]).select('svg').attr('width', width).attr('height', height);
	                                geom.redraw();
	                            }, 250);
	                        }
	                    }
	                });
	            });
	            $scope.$on('$destroy', function () {
	                element.remove();
	                geom = undefined;
	                $scope.page.w = null;
	            });
	        }
	    };
	}
	
	directive.$inject = ['getSize', 'generateId', '$window'];
	module.exports = directive;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 *  dc 2.0.0-beta.32
	 *  http://dc-js.github.io/dc.js/
	 *  Copyright 2012-2016 Nick Zhu & the dc.js Developers
	 *  https://github.com/dc-js/dc.js/blob/master/AUTHORS
	 *
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	(function() { function _dc(d3, crossfilter) {
	'use strict';
	
	/**
	 * The entire dc.js library is scoped under the **dc** name space. It does not introduce
	 * anything else into the global name space.
	 *
	 * Most `dc` functions are designed to allow function chaining, meaning they return the current chart
	 * instance whenever it is appropriate.  The getter forms of functions do not participate in function
	 * chaining because they return values that are not the chart, although some,
	 * such as {@link dc.baseMixin#svg .svg} and {@link dc.coordinateGridMixin#xAxis .xAxis},
	 * return values that are themselves chainable d3 objects.
	 * @namespace dc
	 * @version 2.0.0-beta.32
	 * @example
	 * // Example chaining
	 * chart.width(300)
	 *      .height(300)
	 *      .filter('sunday');
	 */
	/*jshint -W079*/
	var dc = {
	    version: '2.0.0-beta.32',
	    constants: {
	        CHART_CLASS: 'dc-chart',
	        DEBUG_GROUP_CLASS: 'debug',
	        STACK_CLASS: 'stack',
	        DESELECTED_CLASS: 'deselected',
	        SELECTED_CLASS: 'selected',
	        NODE_INDEX_NAME: '__index__',
	        GROUP_INDEX_NAME: '__group_index__',
	        DEFAULT_CHART_GROUP: '__default_chart_group__',
	        EVENT_DELAY: 40,
	        NEGLIGIBLE_NUMBER: 1e-10
	    },
	    _renderlet: null
	};
	/*jshint +W079*/
	
	/**
	 * The dc.chartRegistry object maintains sets of all instantiated dc.js charts under named groups
	 * and the default group.
	 *
	 * A chart group often corresponds to a crossfilter instance. It specifies
	 * the set of charts which should be updated when a filter changes on one of the charts or when the
	 * global functions {@link dc.filterAll dc.filterAll}, {@link dc.refocusAll dc.refocusAll},
	 * {@link dc.renderAll dc.renderAll}, {@link dc.redrawAll dc.redrawAll}, or chart functions
	 * {@link dc.baseMixin#renderGroup baseMixin.renderGroup},
	 * {@link dc.baseMixin#redrawGroup baseMixin.redrawGroup} are called.
	 *
	 * @namespace chartRegistry
	 * @memberof dc
	 * @type {{has, register, deregister, clear, list}}
	 */
	dc.chartRegistry = (function () {
	    // chartGroup:string => charts:array
	    var _chartMap = {};
	
	    function initializeChartGroup (group) {
	        if (!group) {
	            group = dc.constants.DEFAULT_CHART_GROUP;
	        }
	
	        if (!_chartMap[group]) {
	            _chartMap[group] = [];
	        }
	
	        return group;
	    }
	
	    return {
	        /**
	         * Determine if a given chart instance resides in any group in the registry.
	         * @method has
	         * @memberof dc.chartRegistry
	         * @param {Object} chart dc.js chart instance
	         * @returns {Boolean}
	         */
	        has: function (chart) {
	            for (var e in _chartMap) {
	                if (_chartMap[e].indexOf(chart) >= 0) {
	                    return true;
	                }
	            }
	            return false;
	        },
	
	        /**
	         * Add given chart instance to the given group, creating the group if necessary.
	         * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	         * @method register
	         * @memberof dc.chartRegistry
	         * @param {Object} chart dc.js chart instance
	         * @param {String} [group] Group name
	         */
	        register: function (chart, group) {
	            group = initializeChartGroup(group);
	            _chartMap[group].push(chart);
	        },
	
	        /**
	         * Remove given chart instance from the given group, creating the group if necessary.
	         * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	         * @method deregister
	         * @memberof dc.chartRegistry
	         * @param {Object} chart dc.js chart instance
	         * @param {String} [group] Group name
	         */
	        deregister: function (chart, group) {
	            group = initializeChartGroup(group);
	            for (var i = 0; i < _chartMap[group].length; i++) {
	                if (_chartMap[group][i].anchorName() === chart.anchorName()) {
	                    _chartMap[group].splice(i, 1);
	                    break;
	                }
	            }
	        },
	
	        /**
	         * Clear given group if one is provided, otherwise clears all groups.
	         * @method clear
	         * @memberof dc.chartRegistry
	         * @param {String} group Group name
	         */
	        clear: function (group) {
	            if (group) {
	                delete _chartMap[group];
	            } else {
	                _chartMap = {};
	            }
	        },
	
	        /**
	         * Get an array of each chart instance in the given group.
	         * If no group is provided, the charts in the default group are returned.
	         * @method list
	         * @memberof dc.chartRegistry
	         * @param {String} [group] Group name
	         * @returns {Array<Object>}
	         */
	        list: function (group) {
	            group = initializeChartGroup(group);
	            return _chartMap[group];
	        }
	    };
	})();
	
	/**
	 * Add given chart instance to the given group, creating the group if necessary.
	 * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	 * @memberof dc
	 * @method registerChart
	 * @param {Object} chart dc.js chart instance
	 * @param {String} [group] Group name
	 */
	dc.registerChart = function (chart, group) {
	    dc.chartRegistry.register(chart, group);
	};
	
	/**
	 * Remove given chart instance from the given group, creating the group if necessary.
	 * If no group is provided, the default group `dc.constants.DEFAULT_CHART_GROUP` will be used.
	 * @memberof dc
	 * @method deregisterChart
	 * @param {Object} chart dc.js chart instance
	 * @param {String} [group] Group name
	 */
	dc.deregisterChart = function (chart, group) {
	    dc.chartRegistry.deregister(chart, group);
	};
	
	/**
	 * Determine if a given chart instance resides in any group in the registry.
	 * @memberof dc
	 * @method hasChart
	 * @param {Object} chart dc.js chart instance
	 * @returns {Boolean}
	 */
	dc.hasChart = function (chart) {
	    return dc.chartRegistry.has(chart);
	};
	
	/**
	 * Clear given group if one is provided, otherwise clears all groups.
	 * @memberof dc
	 * @method deregisterAllCharts
	 * @param {String} group Group name
	 */
	dc.deregisterAllCharts = function (group) {
	    dc.chartRegistry.clear(group);
	};
	
	/**
	 * Clear all filters on all charts within the given chart group. If the chart group is not given then
	 * only charts that belong to the default chart group will be reset.
	 * @memberof dc
	 * @method filterAll
	 * @param {String} [group]
	 */
	dc.filterAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].filterAll();
	    }
	};
	
	/**
	 * Reset zoom level / focus on all charts that belong to the given chart group. If the chart group is
	 * not given then only charts that belong to the default chart group will be reset.
	 * @memberof dc
	 * @method refocusAll
	 * @param {String} [group]
	 */
	dc.refocusAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        if (charts[i].focus) {
	            charts[i].focus();
	        }
	    }
	};
	
	/**
	 * Re-render all charts belong to the given chart group. If the chart group is not given then only
	 * charts that belong to the default chart group will be re-rendered.
	 * @memberof dc
	 * @method renderAll
	 * @param {String} [group]
	 */
	dc.renderAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].render();
	    }
	
	    if (dc._renderlet !== null) {
	        dc._renderlet(group);
	    }
	};
	
	/**
	 * Redraw all charts belong to the given chart group. If the chart group is not given then only charts
	 * that belong to the default chart group will be re-drawn. Redraw is different from re-render since
	 * when redrawing dc tries to update the graphic incrementally, using transitions, instead of starting
	 * from scratch.
	 * @memberof dc
	 * @method redrawAll
	 * @param {String} [group]
	 */
	dc.redrawAll = function (group) {
	    var charts = dc.chartRegistry.list(group);
	    for (var i = 0; i < charts.length; ++i) {
	        charts[i].redraw();
	    }
	
	    if (dc._renderlet !== null) {
	        dc._renderlet(group);
	    }
	};
	
	/**
	 * If this boolean is set truthy, all transitions will be disabled, and changes to the charts will happen
	 * immediately
	 * @memberof dc
	 * @method disableTransitions
	 * @type {Boolean}
	 * @default false
	 */
	dc.disableTransitions = false;
	
	dc.transition = function (selections, duration, callback, name) {
	    if (duration <= 0 || duration === undefined || dc.disableTransitions) {
	        return selections;
	    }
	
	    var s = selections
	        .transition(name)
	        .duration(duration);
	
	    if (typeof(callback) === 'function') {
	        callback(s);
	    }
	
	    return s;
	};
	
	/* somewhat silly, but to avoid duplicating logic */
	dc.optionalTransition = function (enable, duration, callback, name) {
	    if (enable) {
	        return function (selection) {
	            return dc.transition(selection, duration, callback, name);
	        };
	    } else {
	        return function (selection) {
	            return selection;
	        };
	    }
	};
	
	// See http://stackoverflow.com/a/20773846
	dc.afterTransition = function (transition, callback) {
	    if (transition.empty() || !transition.duration) {
	        callback.call(transition);
	    } else {
	        var n = 0;
	        transition
	            .each(function () { ++n; })
	            .each('end', function () {
	                if (!--n) {
	                    callback.call(transition);
	                }
	            });
	    }
	};
	
	/**
	 * @namespace units
	 * @memberof dc
	 * @type {{}}
	 */
	dc.units = {};
	
	/**
	 * The default value for {@link dc.coordinateGridMixin#xUnits .xUnits} for the
	 * {@link dc.coordinateGridMixin Coordinate Grid Chart} and should
	 * be used when the x values are a sequence of integers.
	 * It is a function that counts the number of integers in the range supplied in its start and end parameters.
	 * @method integers
	 * @memberof dc.units
	 * @see {@link dc.coordinateGridMixin#xUnits coordinateGridMixin.xUnits}
	 * @example
	 * chart.xUnits(dc.units.integers) // already the default
	 * @param {Number} start
	 * @param {Number} end
	 * @return {Number}
	 */
	dc.units.integers = function (start, end) {
	    return Math.abs(end - start);
	};
	
	/**
	 * This argument can be passed to the {@link dc.coordinateGridMixin#xUnits .xUnits} function of the to
	 * specify ordinal units for the x axis. Usually this parameter is used in combination with passing
	 * {@link https://github.com/mbostock/d3/wiki/Ordinal-Scales d3.scale.ordinal} to
	 * {@link dc.coordinateGridMixin#x .x}.
	 * It just returns the domain passed to it, which for ordinal charts is an array of all values.
	 * @method ordinal
	 * @memberof dc.units
	 * @see {@link https://github.com/mbostock/d3/wiki/Ordinal-Scales d3.scale.ordinal}
	 * @see {@link dc.coordinateGridMixin#xUnits coordinateGridMixin.xUnits}
	 * @see {@link dc.coordinateGridMixin#x coordinateGridMixin.x}
	 * @example
	 * chart.xUnits(dc.units.ordinal)
	 *      .x(d3.scale.ordinal())
	 * @param {*} start
	 * @param {*} end
	 * @param {Array<String>} domain
	 * @return {Array<String>}
	 */
	dc.units.ordinal = function (start, end, domain) {
	    return domain;
	};
	
	/**
	 * @namespace fp
	 * @memberof dc.units
	 * @type {{}}
	 */
	dc.units.fp = {};
	/**
	 * This function generates an argument for the {@link dc.coordinateGridMixin Coordinate Grid Chart}
	 * {@link dc.coordinateGridMixin#xUnits .xUnits} function specifying that the x values are floating-point
	 * numbers with the given precision.
	 * The returned function determines how many values at the given precision will fit into the range
	 * supplied in its start and end parameters.
	 * @method precision
	 * @memberof dc.units.fp
	 * @see {@link dc.coordinateGridMixin#xUnits coordinateGridMixin.xUnits}
	 * @example
	 * // specify values (and ticks) every 0.1 units
	 * chart.xUnits(dc.units.fp.precision(0.1)
	 * // there are 500 units between 0.5 and 1 if the precision is 0.001
	 * var thousandths = dc.units.fp.precision(0.001);
	 * thousandths(0.5, 1.0) // returns 500
	 * @param {Number} precision
	 * @return {Function} start-end unit function
	 */
	dc.units.fp.precision = function (precision) {
	    var _f = function (s, e) {
	        var d = Math.abs((e - s) / _f.resolution);
	        if (dc.utils.isNegligible(d - Math.floor(d))) {
	            return Math.floor(d);
	        } else {
	            return Math.ceil(d);
	        }
	    };
	    _f.resolution = precision;
	    return _f;
	};
	
	dc.round = {};
	dc.round.floor = function (n) {
	    return Math.floor(n);
	};
	dc.round.ceil = function (n) {
	    return Math.ceil(n);
	};
	dc.round.round = function (n) {
	    return Math.round(n);
	};
	
	dc.override = function (obj, functionName, newFunction) {
	    var existingFunction = obj[functionName];
	    obj['_' + functionName] = existingFunction;
	    obj[functionName] = newFunction;
	};
	
	dc.renderlet = function (_) {
	    if (!arguments.length) {
	        return dc._renderlet;
	    }
	    dc._renderlet = _;
	    return dc;
	};
	
	dc.instanceOfChart = function (o) {
	    return o instanceof Object && o.__dcFlag__ && true;
	};
	
	dc.errors = {};
	
	dc.errors.Exception = function (msg) {
	    var _msg = msg || 'Unexpected internal error';
	
	    this.message = _msg;
	
	    this.toString = function () {
	        return _msg;
	    };
	    this.stack = (new Error()).stack;
	};
	dc.errors.Exception.prototype = Object.create(Error.prototype);
	dc.errors.Exception.prototype.constructor = dc.errors.Exception;
	
	dc.errors.InvalidStateException = function () {
	    dc.errors.Exception.apply(this, arguments);
	};
	
	dc.errors.InvalidStateException.prototype = Object.create(dc.errors.Exception.prototype);
	dc.errors.InvalidStateException.prototype.constructor = dc.errors.InvalidStateException;
	
	dc.errors.BadArgumentException = function () {
	    dc.errors.Exception.apply(this, arguments);
	};
	
	dc.errors.BadArgumentException.prototype = Object.create(dc.errors.Exception.prototype);
	dc.errors.BadArgumentException.prototype.constructor = dc.errors.BadArgumentException;
	
	/**
	 * The default date format for dc.js
	 * @name dateFormat
	 * @memberof dc
	 * @type {Function}
	 * @default d3.time.format('%m/%d/%Y')
	 */
	dc.dateFormat = d3.time.format('%m/%d/%Y');
	
	/**
	 * @namespace printers
	 * @memberof dc
	 * @type {{}}
	 */
	dc.printers = {};
	
	/**
	 * Converts a list of filters into a readable string
	 * @method filters
	 * @memberof dc.printers
	 * @param {Array<dc.filters|any>} filters
	 * @returns {String}
	 */
	dc.printers.filters = function (filters) {
	    var s = '';
	
	    for (var i = 0; i < filters.length; ++i) {
	        if (i > 0) {
	            s += ', ';
	        }
	        s += dc.printers.filter(filters[i]);
	    }
	
	    return s;
	};
	
	/**
	 * Converts a filter into a readable string
	 * @method filter
	 * @memberof dc.printers
	 * @param {dc.filters|any|Array<any>} filter
	 * @returns {String}
	 */
	dc.printers.filter = function (filter) {
	    var s = '';
	
	    if (typeof filter !== 'undefined' && filter !== null) {
	        if (filter instanceof Array) {
	            if (filter.length >= 2) {
	                s = '[' + dc.utils.printSingleValue(filter[0]) + ' -> ' + dc.utils.printSingleValue(filter[1]) + ']';
	            } else if (filter.length >= 1) {
	                s = dc.utils.printSingleValue(filter[0]);
	            }
	        } else {
	            s = dc.utils.printSingleValue(filter);
	        }
	    }
	
	    return s;
	};
	
	/**
	 * Returns a function that given a string property name, can be used to pluck the property off an object.  A function
	 * can be passed as the second argument to also alter the data being returned.  This can be a useful shorthand method to create
	 * accessor functions.
	 * @method pluck
	 * @memberof dc
	 * @example
	 * var xPluck = dc.pluck('x');
	 * var objA = {x: 1};
	 * xPluck(objA) // 1
	 * @example
	 * var xPosition = dc.pluck('x', function (x, i) {
	 *     // `this` is the original datum,
	 *     // `x` is the x property of the datum,
	 *     // `i` is the position in the array
	 *     return this.radius + x;
	 * });
	 * dc.selectAll('.circle').data(...).x(xPosition);
	 * @param {String} n
	 * @param {Function} [f]
	 * @returns {Function}
	 */
	dc.pluck = function (n, f) {
	    if (!f) {
	        return function (d) { return d[n]; };
	    }
	    return function (d, i) { return f.call(d, d[n], i); };
	};
	
	/**
	 * @namespace utils
	 * @memberof dc
	 * @type {{}}
	 */
	dc.utils = {};
	
	/**
	 * Print a single value filter
	 * @method printSingleValue
	 * @memberof dc.utils
	 * @param {any} filter
	 * @returns {String}
	 */
	dc.utils.printSingleValue = function (filter) {
	    var s = '' + filter;
	
	    if (filter instanceof Date) {
	        s = dc.dateFormat(filter);
	    } else if (typeof(filter) === 'string') {
	        s = filter;
	    } else if (dc.utils.isFloat(filter)) {
	        s = dc.utils.printSingleValue.fformat(filter);
	    } else if (dc.utils.isInteger(filter)) {
	        s = Math.round(filter);
	    }
	
	    return s;
	};
	dc.utils.printSingleValue.fformat = d3.format('.2f');
	
	/**
	 * Arbitrary add one value to another.
	 * @method add
	 * @memberof dc.utils
	 * @todo
	 * These assume than any string r is a percentage (whether or not it includes %).
	 * They also generate strange results if l is a string.
	 * @param {String|Date|Number} l
	 * @param {Number} r
	 * @returns {String|Date|Number}
	 */
	dc.utils.add = function (l, r) {
	    if (typeof r === 'string') {
	        r = r.replace('%', '');
	    }
	
	    if (l instanceof Date) {
	        if (typeof r === 'string') {
	            r = +r;
	        }
	        var d = new Date();
	        d.setTime(l.getTime());
	        d.setDate(l.getDate() + r);
	        return d;
	    } else if (typeof r === 'string') {
	        var percentage = (+r / 100);
	        return l > 0 ? l * (1 + percentage) : l * (1 - percentage);
	    } else {
	        return l + r;
	    }
	};
	
	/**
	 * Arbitrary subtract one value from another.
	 * @method subtract
	 * @memberof dc.utils
	 * @todo
	 * These assume than any string r is a percentage (whether or not it includes %).
	 * They also generate strange results if l is a string.
	 * @param {String|Date|Number} l
	 * @param {Number} r
	 * @returns {String|Date|Number}
	 */
	dc.utils.subtract = function (l, r) {
	    if (typeof r === 'string') {
	        r = r.replace('%', '');
	    }
	
	    if (l instanceof Date) {
	        if (typeof r === 'string') {
	            r = +r;
	        }
	        var d = new Date();
	        d.setTime(l.getTime());
	        d.setDate(l.getDate() - r);
	        return d;
	    } else if (typeof r === 'string') {
	        var percentage = (+r / 100);
	        return l < 0 ? l * (1 + percentage) : l * (1 - percentage);
	    } else {
	        return l - r;
	    }
	};
	
	/**
	 * Is the value a number?
	 * @method isNumber
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isNumber = function (n) {
	    return n === +n;
	};
	
	/**
	 * Is the value a float?
	 * @method isFloat
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isFloat = function (n) {
	    return n === +n && n !== (n | 0);
	};
	
	/**
	 * Is the value an integer?
	 * @method isInteger
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isInteger = function (n) {
	    return n === +n && n === (n | 0);
	};
	
	/**
	 * Is the value very close to zero?
	 * @method isNegligible
	 * @memberof dc.utils
	 * @param {any} n
	 * @returns {Boolean}
	 */
	dc.utils.isNegligible = function (n) {
	    return !dc.utils.isNumber(n) || (n < dc.constants.NEGLIGIBLE_NUMBER && n > -dc.constants.NEGLIGIBLE_NUMBER);
	};
	
	/**
	 * Ensure the value is no greater or less than the min/max values.  If it is return the boundary value.
	 * @method clamp
	 * @memberof dc.utils
	 * @param {any} val
	 * @param {any} min
	 * @param {any} max
	 * @returns {any}
	 */
	dc.utils.clamp = function (val, min, max) {
	    return val < min ? min : (val > max ? max : val);
	};
	
	/**
	 * Using a simple static counter, provide a unique integer id.
	 * @method uniqueId
	 * @memberof dc.utils
	 * @returns {Number}
	 */
	var _idCounter = 0;
	dc.utils.uniqueId = function () {
	    return ++_idCounter;
	};
	
	/**
	 * Convert a name to an ID.
	 * @method nameToId
	 * @memberof dc.utils
	 * @param {String} name
	 * @returns {String}
	 */
	dc.utils.nameToId = function (name) {
	    return name.toLowerCase().replace(/[\s]/g, '_').replace(/[\.']/g, '');
	};
	
	/**
	 * Append or select an item on a parent element
	 * @method appendOrSelect
	 * @memberof dc.utils
	 * @param {d3.selection} parent
	 * @param {String} selector
	 * @param {String} tag
	 * @returns {d3.selection}
	 */
	dc.utils.appendOrSelect = function (parent, selector, tag) {
	    tag = tag || selector;
	    var element = parent.select(selector);
	    if (element.empty()) {
	        element = parent.append(tag);
	    }
	    return element;
	};
	
	/**
	 * Return the number if the value is a number; else 0.
	 * @method safeNumber
	 * @memberof dc.utils
	 * @param {Number|any} n
	 * @returns {Number}
	 */
	dc.utils.safeNumber = function (n) { return dc.utils.isNumber(+n) ? +n : 0;};
	
	dc.logger = {};
	
	dc.logger.enableDebugLog = false;
	
	dc.logger.warn = function (msg) {
	    if (console) {
	        if (console.warn) {
	            console.warn(msg);
	        } else if (console.log) {
	            console.log(msg);
	        }
	    }
	
	    return dc.logger;
	};
	
	dc.logger.debug = function (msg) {
	    if (dc.logger.enableDebugLog && console) {
	        if (console.debug) {
	            console.debug(msg);
	        } else if (console.log) {
	            console.log(msg);
	        }
	    }
	
	    return dc.logger;
	};
	
	dc.logger.deprecate = function (fn, msg) {
	    // Allow logging of deprecation
	    var warned = false;
	    function deprecated () {
	        if (!warned) {
	            dc.logger.warn(msg);
	            warned = true;
	        }
	        return fn.apply(this, arguments);
	    }
	    return deprecated;
	};
	
	dc.events = {
	    current: null
	};
	
	/**
	 * This function triggers a throttled event function with a specified delay (in milli-seconds).  Events
	 * that are triggered repetitively due to user interaction such brush dragging might flood the library
	 * and invoke more renders than can be executed in time. Using this function to wrap your event
	 * function allows the library to smooth out the rendering by throttling events and only responding to
	 * the most recent event.
	 * @name events.trigger
	 * @memberof dc
	 * @example
	 * chart.on('renderlet', function(chart) {
	 *     // smooth the rendering through event throttling
	 *     dc.events.trigger(function(){
	 *         // focus some other chart to the range selected by user on this chart
	 *         someOtherChart.focus(chart.filter());
	 *     });
	 * })
	 * @param {Function} closure
	 * @param {Number} [delay]
	 */
	dc.events.trigger = function (closure, delay) {
	    if (!delay) {
	        closure();
	        return;
	    }
	
	    dc.events.current = closure;
	
	    setTimeout(function () {
	        if (closure === dc.events.current) {
	            closure();
	        }
	    }, delay);
	};
	
	/**
	 * The dc.js filters are functions which are passed into crossfilter to chose which records will be
	 * accumulated to produce values for the charts.  In the crossfilter model, any filters applied on one
	 * dimension will affect all the other dimensions but not that one.  dc always applies a filter
	 * function to the dimension; the function combines multiple filters and if any of them accept a
	 * record, it is filtered in.
	 *
	 * These filter constructors are used as appropriate by the various charts to implement brushing.  We
	 * mention below which chart uses which filter.  In some cases, many instances of a filter will be added.
	 *
	 * Each of the dc.js filters is an object with the following properties:
	 * * `isFiltered` - a function that returns true if a value is within the filter
	 * * `filterType` - a string identifying the filter, here the name of the constructor
	 *
	 * Currently these filter objects are also arrays, but this is not a requirement. Custom filters
	 * can be used as long as they have the properties above.
	 * @namespace filters
	 * @memberof dc
	 * @type {{}}
	 */
	dc.filters = {};
	
	/**
	 * RangedFilter is a filter which accepts keys between `low` and `high`.  It is used to implement X
	 * axis brushing for the {@link dc.coordinateGridMixin coordinate grid charts}.
	 *
	 * Its `filterType` is 'RangedFilter'
	 * @name RangedFilter
	 * @memberof dc.filters
	 * @param {Number} low
	 * @param {Number} high
	 * @return {Array<Number>}
	 * @constructor
	 */
	dc.filters.RangedFilter = function (low, high) {
	    var range = new Array(low, high);
	    range.isFiltered = function (value) {
	        return value >= this[0] && value < this[1];
	    };
	    range.filterType = 'RangedFilter';
	
	    return range;
	};
	
	/**
	 * TwoDimensionalFilter is a filter which accepts a single two-dimensional value.  It is used by the
	 * {@link dc.heatMap heat map chart} to include particular cells as they are clicked.  (Rows and columns are
	 * filtered by filtering all the cells in the row or column.)
	 *
	 * Its `filterType` is 'TwoDimensionalFilter'
	 * @name TwoDimensionalFilter
	 * @memberof dc.filters
	 * @param {Array<Number>} filter
	 * @return {Array<Number>}
	 * @constructor
	 */
	dc.filters.TwoDimensionalFilter = function (filter) {
	    if (filter === null) { return null; }
	
	    var f = filter;
	    f.isFiltered = function (value) {
	        return value.length && value.length === f.length &&
	               value[0] === f[0] && value[1] === f[1];
	    };
	    f.filterType = 'TwoDimensionalFilter';
	
	    return f;
	};
	
	/**
	 * The RangedTwoDimensionalFilter allows filtering all values which fit within a rectangular
	 * region. It is used by the {@link dc.scatterPlot scatter plot} to implement rectangular brushing.
	 *
	 * It takes two two-dimensional points in the form `[[x1,y1],[x2,y2]]`, and normalizes them so that
	 * `x1 <= x2` and `y1 <= y2`. It then returns a filter which accepts any points which are in the
	 * rectangular range including the lower values but excluding the higher values.
	 *
	 * If an array of two values are given to the RangedTwoDimensionalFilter, it interprets the values as
	 * two x coordinates `x1` and `x2` and returns a filter which accepts any points for which `x1 <= x <
	 * x2`.
	 *
	 * Its `filterType` is 'RangedTwoDimensionalFilter'
	 * @name RangedTwoDimensionalFilter
	 * @memberof dc.filters
	 * @param {Array<Array<Number>>} filter
	 * @return {Array<Array<Number>>}
	 * @constructor
	 */
	dc.filters.RangedTwoDimensionalFilter = function (filter) {
	    if (filter === null) { return null; }
	
	    var f = filter;
	    var fromBottomLeft;
	
	    if (f[0] instanceof Array) {
	        fromBottomLeft = [
	            [Math.min(filter[0][0], filter[1][0]), Math.min(filter[0][1], filter[1][1])],
	            [Math.max(filter[0][0], filter[1][0]), Math.max(filter[0][1], filter[1][1])]
	        ];
	    } else {
	        fromBottomLeft = [[filter[0], -Infinity], [filter[1], Infinity]];
	    }
	
	    f.isFiltered = function (value) {
	        var x, y;
	
	        if (value instanceof Array) {
	            if (value.length !== 2) {
	                return false;
	            }
	            x = value[0];
	            y = value[1];
	        } else {
	            x = value;
	            y = fromBottomLeft[0][1];
	        }
	
	        return x >= fromBottomLeft[0][0] && x < fromBottomLeft[1][0] &&
	               y >= fromBottomLeft[0][1] && y < fromBottomLeft[1][1];
	    };
	    f.filterType = 'RangedTwoDimensionalFilter';
	
	    return f;
	};
	
	/**
	 * `dc.baseMixin` is an abstract functional object representing a basic `dc` chart object
	 * for all chart and widget implementations. Methods from the {@link #dc.baseMixin dc.baseMixin} are inherited
	 * and available on all chart implementations in the `dc` library.
	 * @name baseMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.baseMixin}
	 */
	dc.baseMixin = function (_chart) {
	    _chart.__dcFlag__ = dc.utils.uniqueId();
	
	    var _dimension;
	    var _group;
	
	    var _anchor;
	    var _root;
	    var _svg;
	    var _isChild;
	
	    var _minWidth = 200;
	    var _defaultWidthCalc = function (element) {
	        var width = element && element.getBoundingClientRect && element.getBoundingClientRect().width;
	        return (width && width > _minWidth) ? width : _minWidth;
	    };
	    var _widthCalc = _defaultWidthCalc;
	
	    var _minHeight = 200;
	    var _defaultHeightCalc = function (element) {
	        var height = element && element.getBoundingClientRect && element.getBoundingClientRect().height;
	        return (height && height > _minHeight) ? height : _minHeight;
	    };
	    var _heightCalc = _defaultHeightCalc;
	    var _width, _height;
	
	    var _keyAccessor = dc.pluck('key');
	    var _valueAccessor = dc.pluck('value');
	    var _label = dc.pluck('key');
	
	    var _ordering = dc.pluck('key');
	    var _orderSort;
	
	    var _renderLabel = false;
	
	    var _title = function (d) {
	        return _chart.keyAccessor()(d) + ': ' + _chart.valueAccessor()(d);
	    };
	    var _renderTitle = true;
	    var _controlsUseVisibility = false;
	
	    var _transitionDuration = 750;
	
	    var _filterPrinter = dc.printers.filters;
	
	    var _mandatoryAttributes = ['dimension', 'group'];
	
	    var _chartGroup = dc.constants.DEFAULT_CHART_GROUP;
	
	    var _listeners = d3.dispatch(
	        'preRender',
	        'postRender',
	        'preRedraw',
	        'postRedraw',
	        'filtered',
	        'zoomed',
	        'renderlet',
	        'pretransition');
	
	    var _legend;
	    var _commitHandler;
	
	    var _filters = [];
	    var _filterHandler = function (dimension, filters) {
	        if (filters.length === 0) {
	            dimension.filter(null);
	        } else if (filters.length === 1 && !filters[0].isFiltered) {
	            // single value and not a function-based filter
	            dimension.filterExact(filters[0]);
	        } else if (filters.length === 1 && filters[0].filterType === 'RangedFilter') {
	            // single range-based filter
	            dimension.filterRange(filters[0]);
	        } else {
	            dimension.filterFunction(function (d) {
	                for (var i = 0; i < filters.length; i++) {
	                    var filter = filters[i];
	                    if (filter.isFiltered && filter.isFiltered(d)) {
	                        return true;
	                    } else if (filter <= d && filter >= d) {
	                        return true;
	                    }
	                }
	                return false;
	            });
	        }
	        return filters;
	    };
	
	    var _data = function (group) {
	        return group.all();
	    };
	
	    /**
	     * Set or get the height attribute of a chart. The height is applied to the SVGElement generated by
	     * the chart when rendered (or re-rendered). If a value is given, then it will be used to calculate
	     * the new height and the chart returned for method chaining.  The value can either be a numeric, a
	     * function, or falsy. If no value is specified then the value of the current height attribute will
	     * be returned.
	     *
	     * By default, without an explicit height being given, the chart will select the width of its
	     * anchor element. If that isn't possible it defaults to 200 (provided by the
	     * {@link dc.baseMixin#minHeight minHeight} property). Setting the value falsy will return
	     * the chart to the default behavior.
	     * @method height
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#minHeight minHeight}
	     * @example
	     * // Default height
	     * chart.height(function (element) {
	     *     var height = element && element.getBoundingClientRect && element.getBoundingClientRect().height;
	     *     return (height && height > chart.minHeight()) ? height : chart.minHeight();
	     * });
	     *
	     * chart.height(250); // Set the chart's height to 250px;
	     * chart.height(function(anchor) { return doSomethingWith(anchor); }); // set the chart's height with a function
	     * chart.height(null); // reset the height to the default auto calculation
	     * @param {Number|Function} [height]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.height = function (height) {
	        if (!arguments.length) {
	            if (!dc.utils.isNumber(_height)) {
	                // only calculate once
	                _height = _heightCalc(_root.node());
	            }
	            return _height;
	        }
	        _heightCalc = d3.functor(height || _defaultHeightCalc);
	        _height = undefined;
	        return _chart;
	    };
	
	    /**
	     * Set or get the width attribute of a chart.
	     * @method width
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#height height}
	     * @see {@link dc.baseMixin#minWidth minWidth}
	     * @example
	     * // Default width
	     * chart.width(function (element) {
	     *     var width = element && element.getBoundingClientRect && element.getBoundingClientRect().width;
	     *     return (width && width > chart.minWidth()) ? width : chart.minWidth();
	     * });
	     * @param {Number|Function} [width]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.width = function (width) {
	        if (!arguments.length) {
	            if (!dc.utils.isNumber(_width)) {
	                // only calculate once
	                _width = _widthCalc(_root.node());
	            }
	            return _width;
	        }
	        _widthCalc = d3.functor(width || _defaultWidthCalc);
	        _width = undefined;
	        return _chart;
	    };
	
	    /**
	     * Set or get the minimum width attribute of a chart. This only has effect when used with the default
	     * {@link dc.baseMixin#width width} function.
	     * @method minWidth
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#width width}
	     * @param {Number} [minWidth=200]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.minWidth = function (minWidth) {
	        if (!arguments.length) {
	            return _minWidth;
	        }
	        _minWidth = minWidth;
	        return _chart;
	    };
	
	    /**
	     * Set or get the minimum height attribute of a chart. This only has effect when used with the default
	     * {@link dc.baseMixin#height height} function.
	     * @method minHeight
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#height height}
	     * @param {Number} [minHeight=200]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.minHeight = function (minHeight) {
	        if (!arguments.length) {
	            return _minHeight;
	        }
	        _minHeight = minHeight;
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Set or get the dimension attribute of a chart. In `dc`, a dimension can be any valid [crossfilter
	     * dimension](https://github.com/square/crossfilter/wiki/API-Reference#wiki-dimension).
	     *
	     * If a value is given, then it will be used as the new dimension. If no value is specified then
	     * the current dimension will be returned.
	     * @method dimension
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#dimension crossfilter.dimension}
	     * @example
	     * var index = crossfilter([]);
	     * var dimension = index.dimension(dc.pluck('key'));
	     * chart.dimension(dimension);
	     * @param {crossfilter.dimension} [dimension]
	     * @return {crossfilter.dimension}
	     * @return {dc.baseMixin}
	     */
	    _chart.dimension = function (dimension) {
	        if (!arguments.length) {
	            return _dimension;
	        }
	        _dimension = dimension;
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * Set the data callback or retrieve the chart's data set. The data callback is passed the chart's
	     * group and by default will return
	     * {@link https://github.com/square/crossfilter/wiki/API-Reference#group_all group.all}.
	     * This behavior may be modified to, for instance, return only the top 5 groups.
	     * @method data
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // Default data function
	     * chart.data(function (group) { return group.all(); });
	     *
	     * chart.data(function (group) { return group.top(5); });
	     * @param {Function} [callback]
	     * @return {*}
	     * @return {dc.baseMixin}
	     */
	    _chart.data = function (callback) {
	        if (!arguments.length) {
	            return _data.call(_chart, _group);
	        }
	        _data = d3.functor(callback);
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Set or get the group attribute of a chart. In `dc` a group is a
	     * {@link https://github.com/square/crossfilter/wiki/API-Reference#group-map-reduce crossfilter group}.
	     * Usually the group should be created from the particular dimension associated with the same chart. If a value is
	     * given, then it will be used as the new group.
	     *
	     * If no value specified then the current group will be returned.
	     * If `name` is specified then it will be used to generate legend label.
	     * @method group
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#group-map-reduce crossfilter.group}
	     * @example
	     * var index = crossfilter([]);
	     * var dimension = index.dimension(dc.pluck('key'));
	     * chart.dimension(dimension);
	     * chart.group(dimension.group(crossfilter.reduceSum()));
	     * @param {crossfilter.group} [group]
	     * @param {String} [name]
	     * @return {crossfilter.group}
	     * @return {dc.baseMixin}
	     */
	    _chart.group = function (group, name) {
	        if (!arguments.length) {
	            return _group;
	        }
	        _group = group;
	        _chart._groupName = name;
	        _chart.expireCache();
	        return _chart;
	    };
	
	    /**
	     * Get or set an accessor to order ordinal dimensions.  The chart uses
	     * {@link https://github.com/square/crossfilter/wiki/API-Reference#quicksort_by crossfilter.quicksort.by}
	     * to sort elements; this accessor returns the value to order on.
	     * @method ordering
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#quicksort_by crossfilter.quicksort.by}
	     * @example
	     * // Default ordering accessor
	     * _chart.ordering(dc.pluck('key'));
	     * @param {Function} [orderFunction]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.ordering = function (orderFunction) {
	        if (!arguments.length) {
	            return _ordering;
	        }
	        _ordering = orderFunction;
	        _orderSort = crossfilter.quicksort.by(_ordering);
	        _chart.expireCache();
	        return _chart;
	    };
	
	    _chart._computeOrderedGroups = function (data) {
	        var dataCopy = data.slice(0);
	
	        if (dataCopy.length <= 1) {
	            return dataCopy;
	        }
	
	        if (!_orderSort) {
	            _orderSort = crossfilter.quicksort.by(_ordering);
	        }
	
	        return _orderSort(dataCopy, 0, dataCopy.length);
	    };
	
	    /**
	     * Clear all filters associated with this chart
	     *
	     * The same can be achieved by calling {@link dc.baseMixin#filter chart.filter(null)}.
	     * @method filterAll
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.filterAll = function () {
	        return _chart.filter(null);
	    };
	
	    /**
	     * Execute d3 single selection in the chart's scope using the given selector and return the d3
	     * selection.
	     *
	     * This function is **not chainable** since it does not return a chart instance; however the d3
	     * selection result can be chained to d3 function calls.
	     * @method select
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Selections d3.selection}
	     * @example
	     * // Similar to:
	     * d3.select('#chart-id').select(selector);
	     * @return {d3.selection}
	     */
	    _chart.select = function (s) {
	        return _root.select(s);
	    };
	
	    /**
	     * Execute in scope d3 selectAll using the given selector and return d3 selection result.
	     *
	     * This function is **not chainable** since it does not return a chart instance; however the d3
	     * selection result can be chained to d3 function calls.
	     * @method selectAll
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Selections d3.selection}
	     * @example
	     * // Similar to:
	     * d3.select('#chart-id').selectAll(selector);
	     * @return {d3.selection}
	     */
	    _chart.selectAll = function (s) {
	        return _root ? _root.selectAll(s) : null;
	    };
	
	    /**
	     * Set the root SVGElement to either be an existing chart's root; or any valid [d3 single
	     * selector](https://github.com/mbostock/d3/wiki/Selections#selecting-elements) specifying a dom
	     * block element such as a div; or a dom element or d3 selection. Optionally registers the chart
	     * within the chartGroup. This class is called internally on chart initialization, but be called
	     * again to relocate the chart. However, it will orphan any previously created SVGElements.
	     * @method anchor
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {anchorChart|anchorSelector|anchorNode} [parent]
	     * @param {String} [chartGroup]
	     * @return {String|node|d3.selection}
	     * @return {dc.baseMixin}
	     */
	    _chart.anchor = function (parent, chartGroup) {
	        if (!arguments.length) {
	            return _anchor;
	        }
	        if (dc.instanceOfChart(parent)) {
	            _anchor = parent.anchor();
	            _root = parent.root();
	            _isChild = true;
	        } else if (parent) {
	            if (parent.select && parent.classed) { // detect d3 selection
	                _anchor = parent.node();
	            } else {
	                _anchor = parent;
	            }
	            _root = d3.select(_anchor);
	            _root.classed(dc.constants.CHART_CLASS, true);
	            dc.registerChart(_chart, chartGroup);
	            _isChild = false;
	        } else {
	            throw new dc.errors.BadArgumentException('parent must be defined');
	        }
	        _chartGroup = chartGroup;
	        return _chart;
	    };
	
	    /**
	     * Returns the DOM id for the chart's anchored location.
	     * @method anchorName
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {String}
	     */
	    _chart.anchorName = function () {
	        var a = _chart.anchor();
	        if (a && a.id) {
	            return a.id;
	        }
	        if (a && a.replace) {
	            return a.replace('#', '');
	        }
	        return 'dc-chart' + _chart.chartID();
	    };
	
	    /**
	     * Returns the root element where a chart resides. Usually it will be the parent div element where
	     * the SVGElement was created. You can also pass in a new root element however this is usually handled by
	     * dc internally. Resetting the root element on a chart outside of dc internals may have
	     * unexpected consequences.
	     * @method root
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement HTMLElement}
	     * @param {HTMLElement} [rootElement]
	     * @return {HTMLElement}
	     * @return {dc.baseMixin}
	     */
	    _chart.root = function (rootElement) {
	        if (!arguments.length) {
	            return _root;
	        }
	        _root = rootElement;
	        return _chart;
	    };
	
	    /**
	     * Returns the top SVGElement for this specific chart. You can also pass in a new SVGElement,
	     * however this is usually handled by dc internally. Resetting the SVGElement on a chart outside
	     * of dc internals may have unexpected consequences.
	     * @method svg
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/SVGElement SVGElement}
	     * @param {SVGElement|d3.selection} [svgElement]
	     * @return {SVGElement|d3.selection}
	     * @return {dc.baseMixin}
	     */
	    _chart.svg = function (svgElement) {
	        if (!arguments.length) {
	            return _svg;
	        }
	        _svg = svgElement;
	        return _chart;
	    };
	
	    /**
	     * Remove the chart's SVGElements from the dom and recreate the container SVGElement.
	     * @method resetSvg
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/SVGElement SVGElement}
	     * @return {SVGElement}
	     */
	    _chart.resetSvg = function () {
	        _chart.select('svg').remove();
	        return generateSvg();
	    };
	
	    function sizeSvg () {
	        if (_svg) {
	            _svg
	                .attr('width', _chart.width())
	                .attr('height', _chart.height());
	        }
	    }
	
	    function generateSvg () {
	        _svg = _chart.root().append('svg');
	        sizeSvg();
	        return _svg;
	    }
	
	    /**
	     * Set or get the filter printer function. The filter printer function is used to generate human
	     * friendly text for filter value(s) associated with the chart instance. By default dc charts use a
	     * default filter printer `dc.printers.filter` that provides simple printing support for both
	     * single value and ranged filters.
	     * @method filterPrinter
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Function} [filterPrinterFunction=dc.printers.filter]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.filterPrinter = function (filterPrinterFunction) {
	        if (!arguments.length) {
	            return _filterPrinter;
	        }
	        _filterPrinter = filterPrinterFunction;
	        return _chart;
	    };
	
	    /**
	     * If set, use the `visibility` attribute instead of the `display` attribute for showing/hiding
	     * chart reset and filter controls, for less disruption to the layout.
	     * @method controlsUseVisibility
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [controlsUseVisibility=false]
	     * @return {Boolean}
	     * @return {dc.baseMixin}
	     **/
	    _chart.controlsUseVisibility = function (_) {
	        if (!arguments.length) {
	            return _controlsUseVisibility;
	        }
	        _controlsUseVisibility = _;
	        return _chart;
	    };
	
	    /**
	     * Turn on optional control elements within the root element. dc currently supports the
	     * following html control elements.
	     * * root.selectAll('.reset') - elements are turned on if the chart has an active filter. This type
	     * of control element is usually used to store a reset link to allow user to reset filter on a
	     * certain chart. This element will be turned off automatically if the filter is cleared.
	     * * root.selectAll('.filter') elements are turned on if the chart has an active filter. The text
	     * content of this element is then replaced with the current filter value using the filter printer
	     * function. This type of element will be turned off automatically if the filter is cleared.
	     * @method turnOnControls
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.turnOnControls = function () {
	        if (_root) {
	            var attribute = _chart.controlsUseVisibility() ? 'visibility' : 'display';
	            _chart.selectAll('.reset').style(attribute, null);
	            _chart.selectAll('.filter').text(_filterPrinter(_chart.filters())).style(attribute, null);
	        }
	        return _chart;
	    };
	
	    /**
	     * Turn off optional control elements within the root element.
	     * @method turnOffControls
	     * @memberof dc.baseMixin
	     * @see {@link dc.baseMixin#turnOnControls turnOnControls}
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.turnOffControls = function () {
	        if (_root) {
	            var attribute = _chart.controlsUseVisibility() ? 'visibility' : 'display';
	            var value = _chart.controlsUseVisibility() ? 'hidden' : 'none';
	            _chart.selectAll('.reset').style(attribute, value);
	            _chart.selectAll('.filter').style(attribute, value).text(_chart.filter());
	        }
	        return _chart;
	    };
	
	    /**
	     * Set or get the animation transition duration (in milliseconds) for this chart instance.
	     * @method transitionDuration
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Number} [duration=750]
	     * @return {Number}
	     * @return {dc.baseMixin}
	     */
	    _chart.transitionDuration = function (duration) {
	        if (!arguments.length) {
	            return _transitionDuration;
	        }
	        _transitionDuration = duration;
	        return _chart;
	    };
	
	    _chart._mandatoryAttributes = function (_) {
	        if (!arguments.length) {
	            return _mandatoryAttributes;
	        }
	        _mandatoryAttributes = _;
	        return _chart;
	    };
	
	    function checkForMandatoryAttributes (a) {
	        if (!_chart[a] || !_chart[a]()) {
	            throw new dc.errors.InvalidStateException('Mandatory attribute chart.' + a +
	                ' is missing on chart[#' + _chart.anchorName() + ']');
	        }
	    }
	
	    /**
	     * Invoking this method will force the chart to re-render everything from scratch. Generally it
	     * should only be used to render the chart for the first time on the page or if you want to make
	     * sure everything is redrawn from scratch instead of relying on the default incremental redrawing
	     * behaviour.
	     * @method render
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.render = function () {
	        _height = _width = undefined; // force recalculate
	        _listeners.preRender(_chart);
	
	        if (_mandatoryAttributes) {
	            _mandatoryAttributes.forEach(checkForMandatoryAttributes);
	        }
	
	        var result = _chart._doRender();
	
	        if (_legend) {
	            _legend.render();
	        }
	
	        _chart._activateRenderlets('postRender');
	
	        return result;
	    };
	
	    _chart._activateRenderlets = function (event) {
	        _listeners.pretransition(_chart);
	        if (_chart.transitionDuration() > 0 && _svg) {
	            _svg.transition().duration(_chart.transitionDuration())
	                .each('end', function () {
	                    _listeners.renderlet(_chart);
	                    if (event) {
	                        _listeners[event](_chart);
	                    }
	                });
	        } else {
	            _listeners.renderlet(_chart);
	            if (event) {
	                _listeners[event](_chart);
	            }
	        }
	    };
	
	    /**
	     * Calling redraw will cause the chart to re-render data changes incrementally. If there is no
	     * change in the underlying data dimension then calling this method will have no effect on the
	     * chart. Most chart interaction in dc will automatically trigger this method through internal
	     * events (in particular {@link dc.redrawAll dc.redrawAll}); therefore, you only need to
	     * manually invoke this function if data is manipulated outside of dc's control (for example if
	     * data is loaded in the background using
	     * {@link https://github.com/square/crossfilter/wiki/API-Reference#crossfilter_add crossfilter.add}.
	     * @method redraw
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.redraw = function () {
	        sizeSvg();
	        _listeners.preRedraw(_chart);
	
	        var result = _chart._doRedraw();
	
	        if (_legend) {
	            _legend.render();
	        }
	
	        _chart._activateRenderlets('postRedraw');
	
	        return result;
	    };
	
	    /**
	     * Gets/sets the commit handler. If the chart has a commit handler, the handler will be called when
	     * the chart's filters have changed, in order to send the filter data asynchronously to a server.
	     *
	     * Unlike other functions in dc.js, the commit handler is asynchronous. It takes two arguments:
	     * a flag indicating whether this is a render (true) or a redraw (false), and a callback to be
	     * triggered once the commit is filtered. The callback has the standard node.js continuation signature
	     * with error first and result second.
	     * @method commitHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.commitHandler = function (commitHandler) {
	        if (!arguments.length) {
	            return _commitHandler;
	        }
	        _commitHandler = commitHandler;
	        return _chart;
	    };
	
	    /**
	     * Redraws all charts in the same group as this chart, typically in reaction to a filter
	     * change. If the chart has a {@link dc.baseMixin.commitFilter commitHandler}, it will
	     * be executed and waited for.
	     * @method redrawGroup
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.redrawGroup = function () {
	        if (_commitHandler) {
	            _commitHandler(false, function (error, result) {
	                if (error) {
	                    console.log(error);
	                } else {
	                    dc.redrawAll(_chart.chartGroup());
	                }
	            });
	        } else {
	            dc.redrawAll(_chart.chartGroup());
	        }
	        return _chart;
	    };
	
	    /**
	     * Renders all charts in the same group as this chart. If the chart has a
	     * {@link dc.baseMixin.commitFilter commitHandler}, it will be executed and waited for
	     * @method renderGroup
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.renderGroup = function () {
	        if (_commitHandler) {
	            _commitHandler(false, function (error, result) {
	                if (error) {
	                    console.log(error);
	                } else {
	                    dc.renderAll(_chart.chartGroup());
	                }
	            });
	        } else {
	            dc.renderAll(_chart.chartGroup());
	        }
	        return _chart;
	    };
	
	    _chart._invokeFilteredListener = function (f) {
	        if (f !== undefined) {
	            _listeners.filtered(_chart, f);
	        }
	    };
	
	    _chart._invokeZoomedListener = function () {
	        _listeners.zoomed(_chart);
	    };
	
	    var _hasFilterHandler = function (filters, filter) {
	        if (filter === null || typeof(filter) === 'undefined') {
	            return filters.length > 0;
	        }
	        return filters.some(function (f) {
	            return filter <= f && filter >= f;
	        });
	    };
	
	    /**
	     * Set or get the has filter handler. The has filter handler is a function that checks to see if
	     * the chart's current filters include a specific filter.  Using a custom has filter handler allows
	     * you to change the way filters are checked for and replaced.
	     * @method hasFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default has filter handler
	     * chart.hasFilterHandler(function (filters, filter) {
	     *     if (filter === null || typeof(filter) === 'undefined') {
	     *         return filters.length > 0;
	     *     }
	     *     return filters.some(function (f) {
	     *         return filter <= f && filter >= f;
	     *     });
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.hasFilterHandler(function(filters, filter) {
	     *     return false;
	     * });
	     * @param {Function} [hasFilterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.hasFilterHandler = function (hasFilterHandler) {
	        if (!arguments.length) {
	            return _hasFilterHandler;
	        }
	        _hasFilterHandler = hasFilterHandler;
	        return _chart;
	    };
	
	    /**
	     * Check whether any active filter or a specific filter is associated with particular chart instance.
	     * This function is **not chainable**.
	     * @method hasFilter
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#hasFilterHandler hasFilterHandler}
	     * @param {*} [filter]
	     * @return {Boolean}
	     */
	    _chart.hasFilter = function (filter) {
	        return _hasFilterHandler(_filters, filter);
	    };
	
	    var _removeFilterHandler = function (filters, filter) {
	        for (var i = 0; i < filters.length; i++) {
	            if (filters[i] <= filter && filters[i] >= filter) {
	                filters.splice(i, 1);
	                break;
	            }
	        }
	        return filters;
	    };
	
	    /**
	     * Set or get the remove filter handler. The remove filter handler is a function that removes a
	     * filter from the chart's current filters. Using a custom remove filter handler allows you to
	     * change how filters are removed or perform additional work when removing a filter, e.g. when
	     * using a filter server other than crossfilter.
	     *
	     * Any changes should modify the `filters` array argument and return that array.
	     * @method removeFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default remove filter handler
	     * chart.removeFilterHandler(function (filters, filter) {
	     *     for (var i = 0; i < filters.length; i++) {
	     *         if (filters[i] <= filter && filters[i] >= filter) {
	     *             filters.splice(i, 1);
	     *             break;
	     *         }
	     *     }
	     *     return filters;
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.removeFilterHandler(function(filters, filter) {
	     *     return filters;
	     * });
	     * @param {Function} [removeFilterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.removeFilterHandler = function (removeFilterHandler) {
	        if (!arguments.length) {
	            return _removeFilterHandler;
	        }
	        _removeFilterHandler = removeFilterHandler;
	        return _chart;
	    };
	
	    var _addFilterHandler = function (filters, filter) {
	        filters.push(filter);
	        return filters;
	    };
	
	    /**
	     * Set or get the add filter handler. The add filter handler is a function that adds a filter to
	     * the chart's filter list. Using a custom add filter handler allows you to change the way filters
	     * are added or perform additional work when adding a filter, e.g. when using a filter server other
	     * than crossfilter.
	     *
	     * Any changes should modify the `filters` array argument and return that array.
	     * @method addFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default add filter handler
	     * chart.addFilterHandler(function (filters, filter) {
	     *     filters.push(filter);
	     *     return filters;
	     * });
	     *
	     * // custom filter handler (no-op)
	     * chart.addFilterHandler(function(filters, filter) {
	     *     return filters;
	     * });
	     * @param {Function} [addFilterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.addFilterHandler = function (addFilterHandler) {
	        if (!arguments.length) {
	            return _addFilterHandler;
	        }
	        _addFilterHandler = addFilterHandler;
	        return _chart;
	    };
	
	    var _resetFilterHandler = function (filters) {
	        return [];
	    };
	
	    /**
	     * Set or get the reset filter handler. The reset filter handler is a function that resets the
	     * chart's filter list by returning a new list. Using a custom reset filter handler allows you to
	     * change the way filters are reset, or perform additional work when resetting the filters,
	     * e.g. when using a filter server other than crossfilter.
	     *
	     * This function should return an array.
	     * @method resetFilterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default remove filter handler
	     * function (filters) {
	     *     return [];
	     * }
	     *
	     * // custom filter handler (no-op)
	     * chart.resetFilterHandler(function(filters) {
	     *     return filters;
	     * });
	     * @param {Function} [resetFilterHandler]
	     * @return {dc.baseMixin}
	     */
	    _chart.resetFilterHandler = function (resetFilterHandler) {
	        if (!arguments.length) {
	            return _resetFilterHandler;
	        }
	        _resetFilterHandler = resetFilterHandler;
	        return _chart;
	    };
	
	    function applyFilters () {
	        if (_chart.dimension() && _chart.dimension().filter) {
	            var fs = _filterHandler(_chart.dimension(), _filters);
	            _filters = fs ? fs : _filters;
	        }
	    }
	
	    /**
	     * Replace the chart filter. This is equivalent to calling `chart.filter(null).filter(filter)`
	     *
	     * @method replaceFilter
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {*} [filter]
	     * @return {dc.baseMixin}
	     **/
	    _chart.replaceFilter = function (filter) {
	        _filters = _resetFilterHandler(_filters);
	        _chart.filter(filter);
	    };
	
	    /**
	     * Filter the chart by the given parameter, or return the current filter if no input parameter
	     * is given.
	     *
	     * The filter parameter can take one of these forms:
	     * * A single value: the value will be toggled (added if it is not present in the current
	     * filters, removed if it is present)
	     * * An array containing a single array of values (`[[value,value,value]]`): each value is
	     * toggled
	     * * When appropriate for the chart, a {@link dc.filters dc filter object} such as
	     *   * {@link dc.filters.RangedFilter `dc.filters.RangedFilter`} for the
	     * {@link dc.coordinateGridMixin dc.coordinateGridMixin} charts
	     *   * {@link dc.filters.TwoDimensionalFilter `dc.filters.TwoDimensionalFilter`} for the
	     * {@link dc.heatMap heat map}
	     *   * {@link dc.filters.RangedTwoDimensionalFilter `dc.filters.RangedTwoDimensionalFilter`}
	     * for the {@link dc.scatterPlot scatter plot}
	     * * `null`: the filter will be reset using the
	     * {@link dc.baseMixin#resetFilterHandler resetFilterHandler}
	     *
	     * Note that this is always a toggle (even when it doesn't make sense for the filter type). If
	     * you wish to replace the current filter, either call `chart.filter(null)` first, or
	     * equivalently, call {@link dc.baseMixin#replaceFilter `chart.replaceFilter(filter)`} instead.
	     *
	     * Each toggle is executed by checking if the value is already present using the
	     * {@link dc.baseMixin#hasFilterHandler hasFilterHandler}; if it is not present, it is added
	     * using the {@link dc.baseMixin#addFilterHandler addFilterHandler}; if it is already present,
	     * it is removed using the {@link dc.baseMixin#removeFilterHandler removeFilterHandler}.
	     *
	     * Once the filters array has been updated, the filters are applied to the
	     * crossfilter dimension, using the {@link dc.baseMixin#filterHandler filterHandler}.
	     *
	     * Once you have set the filters, call {@link dc.baseMixin#redrawGroup `chart.redrawGroup()`}
	     * (or {@link dc.redrawAll `dc.redrawAll()`}) to redraw the chart's group.
	     * @method filter
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link dc.baseMixin#addFilterHandler addFilterHandler}
	     * @see {@link dc.baseMixin#removeFilterHandler removeFilterHandler}
	     * @see {@link dc.baseMixin#resetFilterHandler resetFilterHandler}
	     * @see {@link dc.baseMixin#filterHandler filterHandler}
	     * @example
	     * // filter by a single string
	     * chart.filter('Sunday');
	     * // filter by a single age
	     * chart.filter(18);
	     * // filter by a set of states
	     * chart.filter([['MA', 'TX', 'ND', 'WA']]);
	     * // filter by range -- note the use of dc.filters.RangedFilter, which is different
	     * // from the syntax for filtering a crossfilter dimension directly, dimension.filter([15,20])
	     * chart.filter(dc.filters.RangedFilter(15,20));
	     * @param {*} [filter]
	     * @return {dc.baseMixin}
	     */
	    _chart.filter = function (filter) {
	        if (!arguments.length) {
	            return _filters.length > 0 ? _filters[0] : null;
	        }
	        if (filter instanceof Array && filter[0] instanceof Array && !filter.isFiltered) {
	            filter[0].forEach(function (d) {
	                if (_chart.hasFilter(d)) {
	                    _removeFilterHandler(_filters, d);
	                } else {
	                    _addFilterHandler(_filters, d);
	                }
	            });
	        } else if (filter === null) {
	            _filters = _resetFilterHandler(_filters);
	        } else {
	            if (_chart.hasFilter(filter)) {
	                _removeFilterHandler(_filters, filter);
	            } else {
	                _addFilterHandler(_filters, filter);
	            }
	        }
	        applyFilters();
	        _chart._invokeFilteredListener(filter);
	
	        if (_root !== null && _chart.hasFilter()) {
	            _chart.turnOnControls();
	        } else {
	            _chart.turnOffControls();
	        }
	
	        return _chart;
	    };
	
	    /**
	     * Returns all current filters. This method does not perform defensive cloning of the internal
	     * filter array before returning, therefore any modification of the returned array will effect the
	     * chart's internal filter storage.
	     * @method filters
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {Array<*>}
	     */
	    _chart.filters = function () {
	        return _filters;
	    };
	
	    _chart.highlightSelected = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, true);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, false);
	    };
	
	    _chart.fadeDeselected = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, false);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, true);
	    };
	
	    _chart.resetHighlight = function (e) {
	        d3.select(e).classed(dc.constants.SELECTED_CLASS, false);
	        d3.select(e).classed(dc.constants.DESELECTED_CLASS, false);
	    };
	
	    /**
	     * This function is passed to d3 as the onClick handler for each chart. The default behavior is to
	     * filter on the clicked datum (passed to the callback) and redraw the chart group.
	     * @method onClick
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {*} datum
	     */
	    _chart.onClick = function (datum) {
	        var filter = _chart.keyAccessor()(datum);
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    /**
	     * Set or get the filter handler. The filter handler is a function that performs the filter action
	     * on a specific dimension. Using a custom filter handler allows you to perform additional logic
	     * before or after filtering.
	     * @method filterHandler
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#dimension_filter crossfilter.dimension.filter}
	     * @example
	     * // default filter handler
	     * chart.filterHandler(function (dimension, filters) {
	     *     dimension.filter(null);
	     *     if (filters.length === 0) {
	     *         dimension.filter(null);
	     *     } else {
	     *         dimension.filterFunction(function (d) {
	     *             for (var i = 0; i < filters.length; i++) {
	     *                 var filter = filters[i];
	     *                 if (filter.isFiltered && filter.isFiltered(d)) {
	     *                     return true;
	     *                 } else if (filter <= d && filter >= d) {
	     *                     return true;
	     *                 }
	     *             }
	     *             return false;
	     *         });
	     *     }
	     *     return filters;
	     * });
	     *
	     * // custom filter handler
	     * chart.filterHandler(function(dimension, filter){
	     *     var newFilter = filter + 10;
	     *     dimension.filter(newFilter);
	     *     return newFilter; // set the actual filter value to the new value
	     * });
	     * @param {Function} [filterHandler]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.filterHandler = function (filterHandler) {
	        if (!arguments.length) {
	            return _filterHandler;
	        }
	        _filterHandler = filterHandler;
	        return _chart;
	    };
	
	    // abstract function stub
	    _chart._doRender = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    _chart.legendables = function () {
	        // do nothing in base, should be overridden by sub-function
	        return [];
	    };
	
	    _chart.legendHighlight = function () {
	        // do nothing in base, should be overridden by sub-function
	    };
	
	    _chart.legendReset = function () {
	        // do nothing in base, should be overridden by sub-function
	    };
	
	    _chart.legendToggle = function () {
	        // do nothing in base, should be overriden by sub-function
	    };
	
	    _chart.isLegendableHidden = function () {
	        // do nothing in base, should be overridden by sub-function
	        return false;
	    };
	
	    /**
	     * Set or get the key accessor function. The key accessor function is used to retrieve the key
	     * value from the crossfilter group. Key values are used differently in different charts, for
	     * example keys correspond to slices in a pie chart and x axis positions in a grid coordinate chart.
	     * @method keyAccessor
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default key accessor
	     * chart.keyAccessor(function(d) { return d.key; });
	     * // custom key accessor for a multi-value crossfilter reduction
	     * chart.keyAccessor(function(p) { return p.value.absGain; });
	     * @param {Function} [keyAccessor]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.keyAccessor = function (keyAccessor) {
	        if (!arguments.length) {
	            return _keyAccessor;
	        }
	        _keyAccessor = keyAccessor;
	        return _chart;
	    };
	
	    /**
	     * Set or get the value accessor function. The value accessor function is used to retrieve the
	     * value from the crossfilter group. Group values are used differently in different charts, for
	     * example values correspond to slice sizes in a pie chart and y axis positions in a grid
	     * coordinate chart.
	     * @method valueAccessor
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default value accessor
	     * chart.valueAccessor(function(d) { return d.value; });
	     * // custom value accessor for a multi-value crossfilter reduction
	     * chart.valueAccessor(function(p) { return p.value.percentageGain; });
	     * @param {Function} [valueAccessor]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.valueAccessor = function (valueAccessor) {
	        if (!arguments.length) {
	            return _valueAccessor;
	        }
	        _valueAccessor = valueAccessor;
	        return _chart;
	    };
	
	    /**
	     * Set or get the label function. The chart class will use this function to render labels for each
	     * child element in the chart, e.g. slices in a pie chart or bubbles in a bubble chart. Not every
	     * chart supports the label function, for example line chart does not use this function
	     * at all. By default, enables labels; pass false for the second parameter if this is not desired.
	     * @method label
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default label function just return the key
	     * chart.label(function(d) { return d.key; });
	     * // label function has access to the standard d3 data binding and can get quite complicated
	     * chart.label(function(d) { return d.data.key + '(' + Math.floor(d.data.value / all.value() * 100) + '%)'; });
	     * @param {Function} [labelFunction]
	     * @param {Boolean} [enableLabels=true]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.label = function (labelFunction, enableLabels) {
	        if (!arguments.length) {
	            return _label;
	        }
	        _label = labelFunction;
	        if ((enableLabels === undefined) || enableLabels) {
	            _renderLabel = true;
	        }
	        return _chart;
	    };
	
	    /**
	     * Turn on/off label rendering
	     * @method renderLabel
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [renderLabel=false]
	     * @return {Boolean}
	     * @return {dc.baseMixin}
	     */
	    _chart.renderLabel = function (renderLabel) {
	        if (!arguments.length) {
	            return _renderLabel;
	        }
	        _renderLabel = renderLabel;
	        return _chart;
	    };
	
	    /**
	     * Set or get the title function. The chart class will use this function to render the SVGElement title
	     * (usually interpreted by browser as tooltips) for each child element in the chart, e.g. a slice
	     * in a pie chart or a bubble in a bubble chart. Almost every chart supports the title function;
	     * however in grid coordinate charts you need to turn off the brush in order to see titles, because
	     * otherwise the brush layer will block tooltip triggering.
	     * @method title
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * // default title function shows "key: value"
	     * chart.title(function(d) { return d.key + ': ' + d.value; });
	     * // title function has access to the standard d3 data binding and can get quite complicated
	     * chart.title(function(p) {
	     *    return p.key.getFullYear()
	     *        + '\n'
	     *        + 'Index Gain: ' + numberFormat(p.value.absGain) + '\n'
	     *        + 'Index Gain in Percentage: ' + numberFormat(p.value.percentageGain) + '%\n'
	     *        + 'Fluctuation / Index Ratio: ' + numberFormat(p.value.fluctuationPercentage) + '%';
	     * });
	     * @param {Function} [titleFunction]
	     * @return {Function}
	     * @return {dc.baseMixin}
	     */
	    _chart.title = function (titleFunction) {
	        if (!arguments.length) {
	            return _title;
	        }
	        _title = titleFunction;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off title rendering, or return the state of the render title flag if no arguments are
	     * given.
	     * @method renderTitle
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {Boolean} [renderTitle=true]
	     * @return {Boolean}
	     * @return {dc.baseMixin}
	     */
	    _chart.renderTitle = function (renderTitle) {
	        if (!arguments.length) {
	            return _renderTitle;
	        }
	        _renderTitle = renderTitle;
	        return _chart;
	    };
	
	    /**
	     * A renderlet is similar to an event listener on rendering event. Multiple renderlets can be added
	     * to an individual chart.  Each time a chart is rerendered or redrawn the renderlets are invoked
	     * right after the chart finishes its transitions, giving you a way to modify the SVGElements.
	     * Renderlet functions take the chart instance as the only input parameter and you can
	     * use the dc API or use raw d3 to achieve pretty much any effect.
	     *
	     * Use {@link dc.baseMixin#on on} with a 'renderlet' prefix.
	     * Generates a random key for the renderlet, which makes it hard to remove.
	     * @method renderlet
	     * @memberof dc.baseMixin
	     * @instance
	     * @deprecated
	     * @example
	     * // do this instead of .renderlet(function(chart) { ... })
	     * chart.on("renderlet", function(chart){
	     *     // mix of dc API and d3 manipulation
	     *     chart.select('g.y').style('display', 'none');
	     *     // its a closure so you can also access other chart variable available in the closure scope
	     *     moveChart.filter(chart.filter());
	     * });
	     * @param {Function} renderletFunction
	     * @return {dc.baseMixin}
	     */
	    _chart.renderlet = dc.logger.deprecate(function (renderletFunction) {
	        _chart.on('renderlet.' + dc.utils.uniqueId(), renderletFunction);
	        return _chart;
	    }, 'chart.renderlet has been deprecated.  Please use chart.on("renderlet.<renderletKey>", renderletFunction)');
	
	    /**
	     * Get or set the chart group to which this chart belongs. Chart groups are rendered or redrawn
	     * together since it is expected they share the same underlying crossfilter data set.
	     * @method chartGroup
	     * @memberof dc.baseMixin
	     * @instance
	     * @param {String} [chartGroup]
	     * @return {String}
	     * @return {dc.baseMixin}
	     */
	    _chart.chartGroup = function (chartGroup) {
	        if (!arguments.length) {
	            return _chartGroup;
	        }
	        if (!_isChild) {
	            dc.deregisterChart(_chart, _chartGroup);
	        }
	        _chartGroup = chartGroup;
	        if (!_isChild) {
	            dc.registerChart(_chart, _chartGroup);
	        }
	        return _chart;
	    };
	
	    /**
	     * Expire the internal chart cache. dc charts cache some data internally on a per chart basis to
	     * speed up rendering and avoid unnecessary calculation; however it might be useful to clear the
	     * cache if you have changed state which will affect rendering.  For example if you invoke the
	     * {@link https://github.com/square/crossfilter/wiki/API-Reference#crossfilter_add crossfilter.add}
	     * function or reset group or dimension after rendering it is a good idea to
	     * clear the cache to make sure charts are rendered properly.
	     * @method expireCache
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {dc.baseMixin}
	     */
	    _chart.expireCache = function () {
	        // do nothing in base, should be overridden by sub-function
	        return _chart;
	    };
	
	    /**
	     * Attach a dc.legend widget to this chart. The legend widget will automatically draw legend labels
	     * based on the color setting and names associated with each group.
	     * @method legend
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * chart.legend(dc.legend().x(400).y(10).itemHeight(13).gap(5))
	     * @param {dc.legend} [legend]
	     * @return {dc.legend}
	     * @return {dc.baseMixin}
	     */
	    _chart.legend = function (legend) {
	        if (!arguments.length) {
	            return _legend;
	        }
	        _legend = legend;
	        _legend.parent(_chart);
	        return _chart;
	    };
	
	    /**
	     * Returns the internal numeric ID of the chart.
	     * @method chartID
	     * @memberof dc.baseMixin
	     * @instance
	     * @return {String}
	     */
	    _chart.chartID = function () {
	        return _chart.__dcFlag__;
	    };
	
	    /**
	     * Set chart options using a configuration object. Each key in the object will cause the method of
	     * the same name to be called with the value to set that attribute for the chart.
	     * @method options
	     * @memberof dc.baseMixin
	     * @instance
	     * @example
	     * chart.options({dimension: myDimension, group: myGroup});
	     * @param {{}} opts
	     * @return {dc.baseMixin}
	     */
	    _chart.options = function (opts) {
	        var applyOptions = [
	            'anchor',
	            'group',
	            'xAxisLabel',
	            'yAxisLabel',
	            'stack',
	            'title',
	            'point',
	            'getColor',
	            'overlayGeoJson'
	        ];
	
	        for (var o in opts) {
	            if (typeof(_chart[o]) === 'function') {
	                if (opts[o] instanceof Array && applyOptions.indexOf(o) !== -1) {
	                    _chart[o].apply(_chart, opts[o]);
	                } else {
	                    _chart[o].call(_chart, opts[o]);
	                }
	            } else {
	                dc.logger.debug('Not a valid option setter name: ' + o);
	            }
	        }
	        return _chart;
	    };
	
	    /**
	     * All dc chart instance supports the following listeners.
	     * Supports the following events:
	     * * `renderlet` - This listener function will be invoked after transitions after redraw and render. Replaces the
	     * deprecated {@link dc.baseMixin#renderlet renderlet} method.
	     * * `pretransition` - Like `.on('renderlet', ...)` but the event is fired before transitions start.
	     * * `preRender` - This listener function will be invoked before chart rendering.
	     * * `postRender` - This listener function will be invoked after chart finish rendering including
	     * all renderlets' logic.
	     * * `preRedraw` - This listener function will be invoked before chart redrawing.
	     * * `postRedraw` - This listener function will be invoked after chart finish redrawing
	     * including all renderlets' logic.
	     * * `filtered` - This listener function will be invoked after a filter is applied, added or removed.
	     * * `zoomed` - This listener function will be invoked after a zoom is triggered.
	     * @method on
	     * @memberof dc.baseMixin
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Internals#dispatch_on d3.dispatch.on}
	     * @example
	     * .on('renderlet', function(chart, filter){...})
	     * .on('pretransition', function(chart, filter){...})
	     * .on('preRender', function(chart){...})
	     * .on('postRender', function(chart){...})
	     * .on('preRedraw', function(chart){...})
	     * .on('postRedraw', function(chart){...})
	     * .on('filtered', function(chart, filter){...})
	     * .on('zoomed', function(chart, filter){...})
	     * @param {String} event
	     * @param {Function} listener
	     * @return {dc.baseMixin}
	     */
	    _chart.on = function (event, listener) {
	        _listeners.on(event, listener);
	        return _chart;
	    };
	
	    return _chart;
	};
	
	/**
	 * Margin is a mixin that provides margin utility functions for both the Row Chart and Coordinate Grid
	 * Charts.
	 * @name marginMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.marginMixin}
	 */
	dc.marginMixin = function (_chart) {
	    var _margin = {top: 10, right: 50, bottom: 30, left: 30};
	
	    /**
	     * Get or set the margins for a particular coordinate grid chart instance. The margins is stored as
	     * an associative Javascript array.
	     * @method margins
	     * @memberof dc.marginMixin
	     * @instance
	     * @example
	     * var leftMargin = chart.margins().left; // 30 by default
	     * chart.margins().left = 50;
	     * leftMargin = chart.margins().left; // now 50
	     * @param {{top: Number, right: Number, left: Number, bottom: Number}} [margins={top: 10, right: 50, bottom: 30, left: 30}]
	     * @return {{top: Number, right: Number, left: Number, bottom: Number}}
	     * @return {dc.marginMixin}
	     */
	    _chart.margins = function (margins) {
	        if (!arguments.length) {
	            return _margin;
	        }
	        _margin = margins;
	        return _chart;
	    };
	
	    _chart.effectiveWidth = function () {
	        return _chart.width() - _chart.margins().left - _chart.margins().right;
	    };
	
	    _chart.effectiveHeight = function () {
	        return _chart.height() - _chart.margins().top - _chart.margins().bottom;
	    };
	
	    return _chart;
	};
	
	/**
	 * The Color Mixin is an abstract chart functional class providing universal coloring support
	 * as a mix-in for any concrete chart implementation.
	 * @name colorMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.colorMixin}
	 */
	dc.colorMixin = function (_chart) {
	    var _colors = d3.scale.category20c();
	    var _defaultAccessor = true;
	
	    var _colorAccessor = function (d) { return _chart.keyAccessor()(d); };
	
	    /**
	     * Retrieve current color scale or set a new color scale. This methods accepts any function that
	     * operates like a d3 scale.
	     * @method colors
	     * @memberof dc.colorMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @example
	     * // alternate categorical scale
	     * chart.colors(d3.scale.category20b());
	     * // ordinal scale
	     * chart.colors(d3.scale.ordinal().range(['red','green','blue']));
	     * // convenience method, the same as above
	     * chart.ordinalColors(['red','green','blue']);
	     * // set a linear scale
	     * chart.linearColors(["#4575b4", "#ffffbf", "#a50026"]);
	     * @param {d3.scale} [colorScale=d3.scale.category20c()]
	     * @return {d3.scale}
	     * @return {dc.colorMixin}
	     */
	    _chart.colors = function (colorScale) {
	        if (!arguments.length) {
	            return _colors;
	        }
	        if (colorScale instanceof Array) {
	            _colors = d3.scale.quantize().range(colorScale); // deprecated legacy support, note: this fails for ordinal domains
	        } else {
	            _colors = d3.functor(colorScale);
	        }
	        return _chart;
	    };
	
	    /**
	     * Convenience method to set the color scale to
	     * {@link https://github.com/mbostock/d3/wiki/Ordinal-Scales#ordinal d3.scale.ordinal} with
	     * range `r`.
	     * @method ordinalColors
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<String>} r
	     * @return {dc.colorMixin}
	     */
	    _chart.ordinalColors = function (r) {
	        return _chart.colors(d3.scale.ordinal().range(r));
	    };
	
	    /**
	     * Convenience method to set the color scale to an Hcl interpolated linear scale with range `r`.
	     * @method linearColors
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<Number>} r
	     * @return {dc.colorMixin}
	     */
	    _chart.linearColors = function (r) {
	        return _chart.colors(d3.scale.linear()
	                             .range(r)
	                             .interpolate(d3.interpolateHcl));
	    };
	
	    /**
	     * Set or the get color accessor function. This function will be used to map a data point in a
	     * crossfilter group to a color value on the color scale. The default function uses the key
	     * accessor.
	     * @method colorAccessor
	     * @memberof dc.colorMixin
	     * @instance
	     * @example
	     * // default index based color accessor
	     * .colorAccessor(function (d, i){return i;})
	     * // color accessor for a multi-value crossfilter reduction
	     * .colorAccessor(function (d){return d.value.absGain;})
	     * @param {Function} [colorAccessor]
	     * @return {Function}
	     * @return {dc.colorMixin}
	     */
	    _chart.colorAccessor = function (colorAccessor) {
	        if (!arguments.length) {
	            return _colorAccessor;
	        }
	        _colorAccessor = colorAccessor;
	        _defaultAccessor = false;
	        return _chart;
	    };
	
	    // what is this?
	    _chart.defaultColorAccessor = function () {
	        return _defaultAccessor;
	    };
	
	    /**
	     * Set or get the current domain for the color mapping function. The domain must be supplied as an
	     * array.
	     *
	     * Note: previously this method accepted a callback function. Instead you may use a custom scale
	     * set by {@link dc.colorMixin#colors .colors}.
	     * @method colorDomain
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {Array<String>} [domain]
	     * @return {Array<String>}
	     * @return {dc.colorMixin}
	     */
	    _chart.colorDomain = function (domain) {
	        if (!arguments.length) {
	            return _colors.domain();
	        }
	        _colors.domain(domain);
	        return _chart;
	    };
	
	    /**
	     * Set the domain by determining the min and max values as retrieved by
	     * {@link dc.colorMixin#colorAccessor .colorAccessor} over the chart's dataset.
	     * @method calculateColorDomain
	     * @memberof dc.colorMixin
	     * @instance
	     * @return {dc.colorMixin}
	     */
	    _chart.calculateColorDomain = function () {
	        var newDomain = [d3.min(_chart.data(), _chart.colorAccessor()),
	                         d3.max(_chart.data(), _chart.colorAccessor())];
	        _colors.domain(newDomain);
	        return _chart;
	    };
	
	    /**
	     * Get the color for the datum d and counter i. This is used internally by charts to retrieve a color.
	     * @method getColor
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {*} d
	     * @param {Number} [i]
	     * @return {String}
	     */
	    _chart.getColor = function (d, i) {
	        return _colors(_colorAccessor.call(this, d, i));
	    };
	
	    /**
	     * Get the color for the datum d and counter i. This is used internally by charts to retrieve a color.
	     * @method colorCalculator
	     * @memberof dc.colorMixin
	     * @instance
	     * @param {*} [colorCalculator]
	     * @return {*}
	     */
	    _chart.colorCalculator = function (colorCalculator) {
	        if (!arguments.length) {
	            return _chart.getColor;
	        }
	        _chart.getColor = colorCalculator;
	        return _chart;
	    };
	
	    return _chart;
	};
	
	/**
	 * Coordinate Grid is an abstract base chart designed to support a number of coordinate grid based
	 * concrete chart types, e.g. bar chart, line chart, and bubble chart.
	 * @name coordinateGridMixin
	 * @memberof dc
	 * @mixin
	 * @mixes dc.colorMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.baseMixin
	 * @param {Object} _chart
	 * @return {dc.coordinateGridMixin}
	 */
	dc.coordinateGridMixin = function (_chart) {
	    var GRID_LINE_CLASS = 'grid-line';
	    var HORIZONTAL_CLASS = 'horizontal';
	    var VERTICAL_CLASS = 'vertical';
	    var Y_AXIS_LABEL_CLASS = 'y-axis-label';
	    var X_AXIS_LABEL_CLASS = 'x-axis-label';
	    var DEFAULT_AXIS_LABEL_PADDING = 12;
	
	    _chart = dc.colorMixin(dc.marginMixin(dc.baseMixin(_chart)));
	
	    _chart.colors(d3.scale.category10());
	    _chart._mandatoryAttributes().push('x');
	
	    function zoomHandler () {
	        _refocused = true;
	        if (_zoomOutRestrict) {
	            _chart.x().domain(constrainRange(_chart.x().domain(), _xOriginalDomain));
	            if (_rangeChart) {
	                _chart.x().domain(constrainRange(_chart.x().domain(), _rangeChart.x().domain()));
	            }
	        }
	
	        var domain = _chart.x().domain();
	        var domFilter = dc.filters.RangedFilter(domain[0], domain[1]);
	
	        _chart.replaceFilter(domFilter);
	        _chart.rescale();
	        _chart.redraw();
	
	        if (_rangeChart && !rangesEqual(_chart.filter(), _rangeChart.filter())) {
	            dc.events.trigger(function () {
	                _rangeChart.replaceFilter(domFilter);
	                _rangeChart.redraw();
	            });
	        }
	
	        _chart._invokeZoomedListener();
	
	        dc.events.trigger(function () {
	            _chart.redrawGroup();
	        }, dc.constants.EVENT_DELAY);
	
	        _refocused = !rangesEqual(domain, _xOriginalDomain);
	    }
	
	    var _parent;
	    var _g;
	    var _chartBodyG;
	
	    var _x;
	    var _xOriginalDomain;
	    var _xAxis = d3.svg.axis().orient('bottom');
	    var _xUnits = dc.units.integers;
	    var _xAxisPadding = 0;
	    var _xElasticity = false;
	    var _xAxisLabel;
	    var _xAxisLabelPadding = 0;
	    var _lastXDomain;
	
	    var _y;
	    var _yAxis = d3.svg.axis().orient('left');
	    var _yAxisPadding = 0;
	    var _yElasticity = false;
	    var _yAxisLabel;
	    var _yAxisLabelPadding = 0;
	
	    var _brush = d3.svg.brush();
	    var _brushOn = true;
	    var _round;
	
	    var _renderHorizontalGridLine = false;
	    var _renderVerticalGridLine = false;
	
	    var _refocused = false, _resizing = false;
	    var _unitCount;
	
	    var _zoomScale = [1, Infinity];
	    var _zoomOutRestrict = true;
	
	    var _zoom = d3.behavior.zoom().on('zoom', zoomHandler);
	    var _nullZoom = d3.behavior.zoom().on('zoom', null);
	    var _hasBeenMouseZoomable = false;
	
	    var _rangeChart;
	    var _focusChart;
	
	    var _mouseZoomable = false;
	    var _clipPadding = 0;
	
	    var _outerRangeBandPadding = 0.5;
	    var _rangeBandPadding = 0;
	
	    var _useRightYAxis = false;
	
	    /**
	     * When changing the domain of the x or y scale, it is necessary to tell the chart to recalculate
	     * and redraw the axes. (`.rescale()` is called automatically when the x or y scale is replaced
	     * with {@link dc.coordinateGridMixin+x .x()} or {@link dc.coordinateGridMixin#y .y()}, and has
	     * no effect on elastic scales.)
	     * @method rescale
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.rescale = function () {
	        _unitCount = undefined;
	        _resizing = true;
	        return _chart;
	    };
	
	    _chart.resizing = function () {
	        return _resizing;
	    };
	
	    /**
	     * Get or set the range selection chart associated with this instance. Setting the range selection
	     * chart using this function will automatically update its selection brush when the current chart
	     * zooms in. In return the given range chart will also automatically attach this chart as its focus
	     * chart hence zoom in when range brush updates.
	     *
	     * Usually the range and focus charts will share a dimension. The range chart will set the zoom
	     * boundaries for the focus chart, so its dimension values must be compatible with the domain of
	     * the focus chart.
	     *
	     * See the [Nasdaq 100 Index](http://dc-js.github.com/dc.js/) example for this effect in action.
	     * @method rangeChart
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {dc.coordinateGridMixin} [rangeChart]
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.rangeChart = function (rangeChart) {
	        if (!arguments.length) {
	            return _rangeChart;
	        }
	        _rangeChart = rangeChart;
	        _rangeChart.focusChart(_chart);
	        return _chart;
	    };
	
	    /**
	     * Get or set the scale extent for mouse zooms.
	     * @method zoomScale
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Array<Number|Date>} [extent=[1, Infinity]]
	     * @return {Array<Number|Date>}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.zoomScale = function (extent) {
	        if (!arguments.length) {
	            return _zoomScale;
	        }
	        _zoomScale = extent;
	        return _chart;
	    };
	
	    /**
	     * Get or set the zoom restriction for the chart. If true limits the zoom to origional domain of the chart.
	     * @method zoomOutRestrict
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [zoomOutRestrict=true]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.zoomOutRestrict = function (zoomOutRestrict) {
	        if (!arguments.length) {
	            return _zoomOutRestrict;
	        }
	        _zoomScale[0] = zoomOutRestrict ? 1 : 0;
	        _zoomOutRestrict = zoomOutRestrict;
	        return _chart;
	    };
	
	    _chart._generateG = function (parent) {
	        if (parent === undefined) {
	            _parent = _chart.svg();
	        } else {
	            _parent = parent;
	        }
	
	        var href = window.location.href.split('#')[0];
	
	        _g = _parent.append('g');
	
	        _chartBodyG = _g.append('g').attr('class', 'chart-body')
	            .attr('transform', 'translate(' + _chart.margins().left + ', ' + _chart.margins().top + ')')
	            .attr('clip-path', 'url(' + href + '#' + getClipPathId() + ')');
	
	        return _g;
	    };
	
	    /**
	     * Get or set the root g element. This method is usually used to retrieve the g element in order to
	     * overlay custom svg drawing programatically. **Caution**: The root g element is usually generated
	     * by dc.js internals, and resetting it might produce unpredictable result.
	     * @method g
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {SVGElement} [gElement]
	     * @return {SVGElement}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.g = function (gElement) {
	        if (!arguments.length) {
	            return _g;
	        }
	        _g = gElement;
	        return _chart;
	    };
	
	    /**
	     * Set or get mouse zoom capability flag (default: false). When turned on the chart will be
	     * zoomable using the mouse wheel. If the range selector chart is attached zooming will also update
	     * the range selection brush on the associated range selector chart.
	     * @method mouseZoomable
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [mouseZoomable=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.mouseZoomable = function (mouseZoomable) {
	        if (!arguments.length) {
	            return _mouseZoomable;
	        }
	        _mouseZoomable = mouseZoomable;
	        return _chart;
	    };
	
	    /**
	     * Retrieve the svg group for the chart body.
	     * @method chartBodyG
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {SVGElement} [chartBodyG]
	     * @return {SVGElement}
	     */
	    _chart.chartBodyG = function (chartBodyG) {
	        if (!arguments.length) {
	            return _chartBodyG;
	        }
	        _chartBodyG = chartBodyG;
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Get or set the x scale. The x scale can be any d3
	     * {@link https://github.com/mbostock/d3/wiki/Quantitative-Scales quantitive scale} or
	     * {@link https://github.com/mbostock/d3/wiki/Ordinal-Scales ordinal scale}.
	     * @method x
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @example
	     * // set x to a linear scale
	     * chart.x(d3.scale.linear().domain([-2500, 2500]))
	     * // set x to a time scale to generate histogram
	     * chart.x(d3.time.scale().domain([new Date(1985, 0, 1), new Date(2012, 11, 31)]))
	     * @param {d3.scale} [xScale]
	     * @return {d3.scale}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.x = function (xScale) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = xScale;
	        _xOriginalDomain = _x.domain();
	        _chart.rescale();
	        return _chart;
	    };
	
	    _chart.xOriginalDomain = function () {
	        return _xOriginalDomain;
	    };
	
	    /**
	     * Set or get the xUnits function. The coordinate grid chart uses the xUnits function to calculate
	     * the number of data projections on x axis such as the number of bars for a bar chart or the
	     * number of dots for a line chart. This function is expected to return a Javascript array of all
	     * data points on x axis, or the number of points on the axis. [d3 time range functions
	     * d3.time.days, d3.time.months, and
	     * d3.time.years](https://github.com/mbostock/d3/wiki/Time-Intervals#aliases) are all valid xUnits
	     * function. dc.js also provides a few units function, see the {@link dc.utils Utilities} section for
	     * a list of built-in units functions. The default xUnits function is dc.units.integers.
	     * @method xUnits
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @todo Add docs for utilities
	     * @example
	     * // set x units to count days
	     * chart.xUnits(d3.time.days);
	     * // set x units to count months
	     * chart.xUnits(d3.time.months);
	     *
	     * // A custom xUnits function can be used as long as it follows the following interface:
	     * // units in integer
	     * function(start, end, xDomain) {
	     *      // simply calculates how many integers in the domain
	     *      return Math.abs(end - start);
	     * };
	     *
	     * // fixed units
	     * function(start, end, xDomain) {
	     *      // be aware using fixed units will disable the focus/zoom ability on the chart
	     *      return 1000;
	     * @param {Function} [xUnits]
	     * @return {Function}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.xUnits = function (xUnits) {
	        if (!arguments.length) {
	            return _xUnits;
	        }
	        _xUnits = xUnits;
	        return _chart;
	    };
	
	    /**
	     * Set or get the x axis used by a particular coordinate grid chart instance. This function is most
	     * useful when x axis customization is required. The x axis in dc.js is an instance of a [d3
	     * axis object](https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-axis); therefore it supports any
	     * valid d3 axis manipulation. **Caution**: The x axis is usually generated internally by dc;
	     * resetting it may cause unexpected results.
	     * @method xAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/SVG-Axes d3.svg.axis}
	     * @example
	     * // customize x axis tick format
	     * chart.xAxis().tickFormat(function(v) {return v + '%';});
	     * // customize x axis tick values
	     * chart.xAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [xAxis=d3.svg.axis().orient('bottom')]
	     * @return {d3.svg.axis}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.xAxis = function (xAxis) {
	        if (!arguments.length) {
	            return _xAxis;
	        }
	        _xAxis = xAxis;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off elastic x axis behavior. If x axis elasticity is turned on, then the grid chart will
	     * attempt to recalculate the x axis range whenever a redraw event is triggered.
	     * @method elasticX
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [elasticX=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.elasticX = function (elasticX) {
	        if (!arguments.length) {
	            return _xElasticity;
	        }
	        _xElasticity = elasticX;
	        return _chart;
	    };
	
	    /**
	     * Set or get x axis padding for the elastic x axis. The padding will be added to both end of the x
	     * axis if elasticX is turned on; otherwise it is ignored.
	     *
	     * padding can be an integer or percentage in string (e.g. '10%'). Padding can be applied to
	     * number or date x axes.  When padding a date axis, an integer represents number of days being padded
	     * and a percentage string will be treated the same as an integer.
	     * @method xAxisPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number|String} [padding=0]
	     * @return {Number|String}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.xAxisPadding = function (padding) {
	        if (!arguments.length) {
	            return _xAxisPadding;
	        }
	        _xAxisPadding = padding;
	        return _chart;
	    };
	
	    /**
	     * Returns the number of units displayed on the x axis using the unit measure configured by
	     * .xUnits.
	     * @method xUnitCount
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {Number}
	     */
	    _chart.xUnitCount = function () {
	        if (_unitCount === undefined) {
	            var units = _chart.xUnits()(_chart.x().domain()[0], _chart.x().domain()[1], _chart.x().domain());
	
	            if (units instanceof Array) {
	                _unitCount = units.length;
	            } else {
	                _unitCount = units;
	            }
	        }
	
	        return _unitCount;
	    };
	
	    /**
	     * Gets or sets whether the chart should be drawn with a right axis instead of a left axis. When
	     * used with a chart in a composite chart, allows both left and right Y axes to be shown on a
	     * chart.
	     * @method useRightYAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [useRightYAxis=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.useRightYAxis = function (useRightYAxis) {
	        if (!arguments.length) {
	            return _useRightYAxis;
	        }
	        _useRightYAxis = useRightYAxis;
	        return _chart;
	    };
	
	    /**
	     * Returns true if the chart is using ordinal xUnits ({@link dc.units.ordinal dc.units.ordinal}, or false
	     * otherwise. Most charts behave differently with ordinal data and use the result of this method to
	     * trigger the appropriate logic.
	     * @method isOrdinal
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {Boolean}
	     */
	    _chart.isOrdinal = function () {
	        return _chart.xUnits() === dc.units.ordinal;
	    };
	
	    _chart._useOuterPadding = function () {
	        return true;
	    };
	
	    _chart._ordinalXDomain = function () {
	        var groups = _chart._computeOrderedGroups(_chart.data());
	        return groups.map(_chart.keyAccessor());
	    };
	
	    function compareDomains (d1, d2) {
	        return !d1 || !d2 || d1.length !== d2.length ||
	            d1.some(function (elem, i) { return (elem && d2[i]) ? elem.toString() !== d2[i].toString() : elem === d2[i]; });
	    }
	
	    function prepareXAxis (g, render) {
	        if (!_chart.isOrdinal()) {
	            if (_chart.elasticX()) {
	                _x.domain([_chart.xAxisMin(), _chart.xAxisMax()]);
	            }
	        } else { // _chart.isOrdinal()
	            if (_chart.elasticX() || _x.domain().length === 0) {
	                _x.domain(_chart._ordinalXDomain());
	            }
	        }
	
	        // has the domain changed?
	        var xdom = _x.domain();
	        if (render || compareDomains(_lastXDomain, xdom)) {
	            _chart.rescale();
	        }
	        _lastXDomain = xdom;
	
	        // please can't we always use rangeBands for bar charts?
	        if (_chart.isOrdinal()) {
	            _x.rangeBands([0, _chart.xAxisLength()], _rangeBandPadding,
	                          _chart._useOuterPadding() ? _outerRangeBandPadding : 0);
	        } else {
	            _x.range([0, _chart.xAxisLength()]);
	        }
	
	        _xAxis = _xAxis.scale(_chart.x());
	
	        renderVerticalGridLines(g);
	    }
	
	    _chart.renderXAxis = function (g) {
	        var axisXG = g.selectAll('g.x');
	
	        if (axisXG.empty()) {
	            axisXG = g.append('g')
	                .attr('class', 'axis x')
	                .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart._xAxisY() + ')');
	        }
	
	        var axisXLab = g.selectAll('text.' + X_AXIS_LABEL_CLASS);
	        if (axisXLab.empty() && _chart.xAxisLabel()) {
	            axisXLab = g.append('text')
	                .attr('class', X_AXIS_LABEL_CLASS)
	                .attr('transform', 'translate(' + (_chart.margins().left + _chart.xAxisLength() / 2) + ',' +
	                      (_chart.height() - _xAxisLabelPadding) + ')')
	                .attr('text-anchor', 'middle');
	        }
	        if (_chart.xAxisLabel() && axisXLab.text() !== _chart.xAxisLabel()) {
	            axisXLab.text(_chart.xAxisLabel());
	        }
	
	        dc.transition(axisXG, _chart.transitionDuration())
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart._xAxisY() + ')')
	            .call(_xAxis);
	        dc.transition(axisXLab, _chart.transitionDuration())
	            .attr('transform', 'translate(' + (_chart.margins().left + _chart.xAxisLength() / 2) + ',' +
	                  (_chart.height() - _xAxisLabelPadding) + ')');
	    };
	
	    function renderVerticalGridLines (g) {
	        var gridLineG = g.selectAll('g.' + VERTICAL_CLASS);
	
	        if (_renderVerticalGridLine) {
	            if (gridLineG.empty()) {
	                gridLineG = g.insert('g', ':first-child')
	                    .attr('class', GRID_LINE_CLASS + ' ' + VERTICAL_CLASS)
	                    .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	            }
	
	            var ticks = _xAxis.tickValues() ? _xAxis.tickValues() :
	                    (typeof _x.ticks === 'function' ? _x.ticks(_xAxis.ticks()[0]) : _x.domain());
	
	            var lines = gridLineG.selectAll('line')
	                .data(ticks);
	
	            // enter
	            var linesGEnter = lines.enter()
	                .append('line')
	                .attr('x1', function (d) {
	                    return _x(d);
	                })
	                .attr('y1', _chart._xAxisY() - _chart.margins().top)
	                .attr('x2', function (d) {
	                    return _x(d);
	                })
	                .attr('y2', 0)
	                .attr('opacity', 0);
	            dc.transition(linesGEnter, _chart.transitionDuration())
	                .attr('opacity', 1);
	
	            // update
	            dc.transition(lines, _chart.transitionDuration())
	                .attr('x1', function (d) {
	                    return _x(d);
	                })
	                .attr('y1', _chart._xAxisY() - _chart.margins().top)
	                .attr('x2', function (d) {
	                    return _x(d);
	                })
	                .attr('y2', 0);
	
	            // exit
	            lines.exit().remove();
	        } else {
	            gridLineG.selectAll('line').remove();
	        }
	    }
	
	    _chart._xAxisY = function () {
	        return (_chart.height() - _chart.margins().bottom);
	    };
	
	    _chart.xAxisLength = function () {
	        return _chart.effectiveWidth();
	    };
	
	    /**
	     * Set or get the x axis label. If setting the label, you may optionally include additional padding to
	     * the margin to make room for the label. By default the padded is set to 12 to accomodate the text height.
	     * @method xAxisLabel
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {String} [labelText]
	     * @param {Number} [padding=12]
	     * @return {String}
	     */
	    _chart.xAxisLabel = function (labelText, padding) {
	        if (!arguments.length) {
	            return _xAxisLabel;
	        }
	        _xAxisLabel = labelText;
	        _chart.margins().bottom -= _xAxisLabelPadding;
	        _xAxisLabelPadding = (padding === undefined) ? DEFAULT_AXIS_LABEL_PADDING : padding;
	        _chart.margins().bottom += _xAxisLabelPadding;
	        return _chart;
	    };
	
	    _chart._prepareYAxis = function (g) {
	        if (_y === undefined || _chart.elasticY()) {
	            if (_y === undefined) {
	                _y = d3.scale.linear();
	            }
	            var min = _chart.yAxisMin() || 0,
	                max = _chart.yAxisMax() || 0;
	            _y.domain([min, max]).rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _y.range([_chart.yAxisHeight(), 0]);
	        _yAxis = _yAxis.scale(_y);
	
	        if (_useRightYAxis) {
	            _yAxis.orient('right');
	        }
	
	        _chart._renderHorizontalGridLinesForAxis(g, _y, _yAxis);
	    };
	
	    _chart.renderYAxisLabel = function (axisClass, text, rotation, labelXPosition) {
	        labelXPosition = labelXPosition || _yAxisLabelPadding;
	
	        var axisYLab = _chart.g().selectAll('text.' + Y_AXIS_LABEL_CLASS + '.' + axisClass + '-label');
	        var labelYPosition = (_chart.margins().top + _chart.yAxisHeight() / 2);
	        if (axisYLab.empty() && text) {
	            axisYLab = _chart.g().append('text')
	                .attr('transform', 'translate(' + labelXPosition + ',' + labelYPosition + '),rotate(' + rotation + ')')
	                .attr('class', Y_AXIS_LABEL_CLASS + ' ' + axisClass + '-label')
	                .attr('text-anchor', 'middle')
	                .text(text);
	        }
	        if (text && axisYLab.text() !== text) {
	            axisYLab.text(text);
	        }
	        dc.transition(axisYLab, _chart.transitionDuration())
	            .attr('transform', 'translate(' + labelXPosition + ',' + labelYPosition + '),rotate(' + rotation + ')');
	    };
	
	    _chart.renderYAxisAt = function (axisClass, axis, position) {
	        var axisYG = _chart.g().selectAll('g.' + axisClass);
	        if (axisYG.empty()) {
	            axisYG = _chart.g().append('g')
	                .attr('class', 'axis ' + axisClass)
	                .attr('transform', 'translate(' + position + ',' + _chart.margins().top + ')');
	        }
	
	        dc.transition(axisYG, _chart.transitionDuration())
	            .attr('transform', 'translate(' + position + ',' + _chart.margins().top + ')')
	            .call(axis);
	    };
	
	    _chart.renderYAxis = function () {
	        var axisPosition = _useRightYAxis ? (_chart.width() - _chart.margins().right) : _chart._yAxisX();
	        _chart.renderYAxisAt('y', _yAxis, axisPosition);
	        var labelPosition = _useRightYAxis ? (_chart.width() - _yAxisLabelPadding) : _yAxisLabelPadding;
	        var rotation = _useRightYAxis ? 90 : -90;
	        _chart.renderYAxisLabel('y', _chart.yAxisLabel(), rotation, labelPosition);
	    };
	
	    _chart._renderHorizontalGridLinesForAxis = function (g, scale, axis) {
	        var gridLineG = g.selectAll('g.' + HORIZONTAL_CLASS);
	
	        if (_renderHorizontalGridLine) {
	            var ticks = axis.tickValues() ? axis.tickValues() : scale.ticks(axis.ticks()[0]);
	
	            if (gridLineG.empty()) {
	                gridLineG = g.insert('g', ':first-child')
	                    .attr('class', GRID_LINE_CLASS + ' ' + HORIZONTAL_CLASS)
	                    .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	            }
	
	            var lines = gridLineG.selectAll('line')
	                .data(ticks);
	
	            // enter
	            var linesGEnter = lines.enter()
	                .append('line')
	                .attr('x1', 1)
	                .attr('y1', function (d) {
	                    return scale(d);
	                })
	                .attr('x2', _chart.xAxisLength())
	                .attr('y2', function (d) {
	                    return scale(d);
	                })
	                .attr('opacity', 0);
	            dc.transition(linesGEnter, _chart.transitionDuration())
	                .attr('opacity', 1);
	
	            // update
	            dc.transition(lines, _chart.transitionDuration())
	                .attr('x1', 1)
	                .attr('y1', function (d) {
	                    return scale(d);
	                })
	                .attr('x2', _chart.xAxisLength())
	                .attr('y2', function (d) {
	                    return scale(d);
	                });
	
	            // exit
	            lines.exit().remove();
	        } else {
	            gridLineG.selectAll('line').remove();
	        }
	    };
	
	    _chart._yAxisX = function () {
	        return _chart.useRightYAxis() ? _chart.width() - _chart.margins().right : _chart.margins().left;
	    };
	
	    /**
	     * Set or get the y axis label. If setting the label, you may optionally include additional padding
	     * to the margin to make room for the label. By default the padded is set to 12 to accomodate the
	     * text height.
	     * @method yAxisLabel
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {String} [labelText]
	     * @param {Number} [padding=12]
	     * @return {String}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.yAxisLabel = function (labelText, padding) {
	        if (!arguments.length) {
	            return _yAxisLabel;
	        }
	        _yAxisLabel = labelText;
	        _chart.margins().left -= _yAxisLabelPadding;
	        _yAxisLabelPadding = (padding === undefined) ? DEFAULT_AXIS_LABEL_PADDING : padding;
	        _chart.margins().left += _yAxisLabelPadding;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y scale. The y scale is typically automatically determined by the chart implementation.
	     * @method y
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @param {d3.scale} [yScale]
	     * @return {d3.scale}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.y = function (yScale) {
	        if (!arguments.length) {
	            return _y;
	        }
	        _y = yScale;
	        _chart.rescale();
	        return _chart;
	    };
	
	    /**
	     * Set or get the y axis used by the coordinate grid chart instance. This function is most useful
	     * when y axis customization is required. The y axis in dc.js is simply an instance of a [d3 axis
	     * object](https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-_axis); therefore it supports any
	     * valid d3 axis manipulation. **Caution**: The y axis is usually generated internally by dc;
	     * resetting it may cause unexpected results.
	     * @method yAxis
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/SVG-Axes d3.svg.axis}
	     * @example
	     * // customize y axis tick format
	     * chart.yAxis().tickFormat(function(v) {return v + '%';});
	     * // customize y axis tick values
	     * chart.yAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [yAxis=d3.svg.axis().orient('left')]
	     * @return {d3.svg.axis}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.yAxis = function (yAxis) {
	        if (!arguments.length) {
	            return _yAxis;
	        }
	        _yAxis = yAxis;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off elastic y axis behavior. If y axis elasticity is turned on, then the grid chart will
	     * attempt to recalculate the y axis range whenever a redraw event is triggered.
	     * @method elasticY
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [elasticY=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.elasticY = function (elasticY) {
	        if (!arguments.length) {
	            return _yElasticity;
	        }
	        _yElasticity = elasticY;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off horizontal grid lines.
	     * @method renderHorizontalGridLines
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [renderHorizontalGridLines=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.renderHorizontalGridLines = function (renderHorizontalGridLines) {
	        if (!arguments.length) {
	            return _renderHorizontalGridLine;
	        }
	        _renderHorizontalGridLine = renderHorizontalGridLines;
	        return _chart;
	    };
	
	    /**
	     * Turn on/off vertical grid lines.
	     * @method renderVerticalGridLines
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [renderVerticalGridLines=false]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.renderVerticalGridLines = function (renderVerticalGridLines) {
	        if (!arguments.length) {
	            return _renderVerticalGridLine;
	        }
	        _renderVerticalGridLine = renderVerticalGridLines;
	        return _chart;
	    };
	
	    /**
	     * Calculates the minimum x value to display in the chart. Includes xAxisPadding if set.
	     * @method xAxisMin
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.xAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.keyAccessor()(e);
	        });
	        return dc.utils.subtract(min, _xAxisPadding);
	    };
	
	    /**
	     * Calculates the maximum x value to display in the chart. Includes xAxisPadding if set.
	     * @method xAxisMax
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.xAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.keyAccessor()(e);
	        });
	        return dc.utils.add(max, _xAxisPadding);
	    };
	
	    /**
	     * Calculates the minimum y value to display in the chart. Includes yAxisPadding if set.
	     * @method yAxisMin
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.yAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.valueAccessor()(e);
	        });
	        return dc.utils.subtract(min, _yAxisPadding);
	    };
	
	    /**
	     * Calculates the maximum y value to display in the chart. Includes yAxisPadding if set.
	     * @method yAxisMax
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @return {*}
	     */
	    _chart.yAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.valueAccessor()(e);
	        });
	        return dc.utils.add(max, _yAxisPadding);
	    };
	
	    /**
	     * Set or get y axis padding for the elastic y axis. The padding will be added to the top and
	     * bottom of the y axis if elasticY is turned on; otherwise it is ignored.
	     *
	     * Padding can be an integer or percentage in string (e.g. '10%'). Padding can be applied to
	     * number or date axes. When padding a date axis, an integer represents number of days being padded
	     * and a percentage string will be treated the same as an integer.
	     * @method yAxisPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number|String} [padding=0]
	     * @return {Number}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.yAxisPadding = function (padding) {
	        if (!arguments.length) {
	            return _yAxisPadding;
	        }
	        _yAxisPadding = padding;
	        return _chart;
	    };
	
	    _chart.yAxisHeight = function () {
	        return _chart.effectiveHeight();
	    };
	
	    /**
	     * Set or get the rounding function used to quantize the selection when brushing is enabled.
	     * @method round
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @example
	     * // set x unit round to by month, this will make sure range selection brush will
	     * // select whole months
	     * chart.round(d3.time.month.round);
	     * @param {Function} [round]
	     * @return {Function}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.round = function (round) {
	        if (!arguments.length) {
	            return _round;
	        }
	        _round = round;
	        return _chart;
	    };
	
	    _chart._rangeBandPadding = function (_) {
	        if (!arguments.length) {
	            return _rangeBandPadding;
	        }
	        _rangeBandPadding = _;
	        return _chart;
	    };
	
	    _chart._outerRangeBandPadding = function (_) {
	        if (!arguments.length) {
	            return _outerRangeBandPadding;
	        }
	        _outerRangeBandPadding = _;
	        return _chart;
	    };
	
	    dc.override(_chart, 'filter', function (_) {
	        if (!arguments.length) {
	            return _chart._filter();
	        }
	
	        _chart._filter(_);
	
	        if (_) {
	            _chart.brush().extent(_);
	        } else {
	            _chart.brush().clear();
	        }
	
	        return _chart;
	    });
	
	    _chart.brush = function (_) {
	        if (!arguments.length) {
	            return _brush;
	        }
	        _brush = _;
	        return _chart;
	    };
	
	    function brushHeight () {
	        return _chart._xAxisY() - _chart.margins().top;
	    }
	
	    _chart.renderBrush = function (g) {
	        if (_brushOn) {
	            _brush.on('brush', _chart._brushing);
	            _brush.on('brushstart', _chart._disableMouseZoom);
	            _brush.on('brushend', configureMouseZoom);
	
	            var gBrush = g.append('g')
	                .attr('class', 'brush')
	                .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')')
	                .call(_brush.x(_chart.x()));
	            _chart.setBrushY(gBrush, false);
	            _chart.setHandlePaths(gBrush);
	
	            if (_chart.hasFilter()) {
	                _chart.redrawBrush(g, false);
	            }
	        }
	    };
	
	    _chart.setHandlePaths = function (gBrush) {
	        gBrush.selectAll('.resize').append('path').attr('d', _chart.resizeHandlePath);
	    };
	
	    _chart.setBrushY = function (gBrush) {
	        gBrush.selectAll('rect')
	            .attr('height', brushHeight());
	        gBrush.selectAll('.resize path')
	            .attr('d', _chart.resizeHandlePath);
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _brush.extent();
	        if (_chart.round()) {
	            extent[0] = extent.map(_chart.round())[0];
	            extent[1] = extent.map(_chart.round())[1];
	
	            _g.select('.brush')
	                .call(_brush.extent(extent));
	        }
	        return extent;
	    };
	
	    _chart.brushIsEmpty = function (extent) {
	        return _brush.empty() || !extent || extent[1] <= extent[0];
	    };
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	
	        _chart.redrawBrush(_g, false);
	
	        if (_chart.brushIsEmpty(extent)) {
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	        } else {
	            var rangedFilter = dc.filters.RangedFilter(extent[0], extent[1]);
	
	            dc.events.trigger(function () {
	                _chart.replaceFilter(rangedFilter);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	        }
	    };
	
	    _chart.redrawBrush = function (g, doTransition) {
	        if (_brushOn) {
	            if (_chart.filter() && _chart.brush().empty()) {
	                _chart.brush().extent(_chart.filter());
	            }
	
	            var gBrush = dc.optionalTransition(doTransition, _chart.transitionDuration())(g.select('g.brush'));
	            _chart.setBrushY(gBrush);
	            gBrush.call(_chart.brush()
	                      .x(_chart.x())
	                      .extent(_chart.brush().extent()));
	        }
	
	        _chart.fadeDeselectedArea();
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        // do nothing, sub-chart should override this function
	    };
	
	    // borrowed from Crossfilter example
	    _chart.resizeHandlePath = function (d) {
	        var e = +(d === 'e'), x = e ? 1 : -1, y = brushHeight() / 3;
	        return 'M' + (0.5 * x) + ',' + y +
	            'A6,6 0 0 ' + e + ' ' + (6.5 * x) + ',' + (y + 6) +
	            'V' + (2 * y - 6) +
	            'A6,6 0 0 ' + e + ' ' + (0.5 * x) + ',' + (2 * y) +
	            'Z' +
	            'M' + (2.5 * x) + ',' + (y + 8) +
	            'V' + (2 * y - 8) +
	            'M' + (4.5 * x) + ',' + (y + 8) +
	            'V' + (2 * y - 8);
	    };
	
	    function getClipPathId () {
	        return _chart.anchorName().replace(/[ .#=\[\]]/g, '-') + '-clip';
	    }
	
	    /**
	     * Get or set the padding in pixels for the clip path. Once set padding will be applied evenly to
	     * the top, left, right, and bottom when the clip path is generated. If set to zero, the clip area
	     * will be exactly the chart body area minus the margins.
	     * @method clipPadding
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Number} [padding=5]
	     * @return {Number}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.clipPadding = function (padding) {
	        if (!arguments.length) {
	            return _clipPadding;
	        }
	        _clipPadding = padding;
	        return _chart;
	    };
	
	    function generateClipPath () {
	        var defs = dc.utils.appendOrSelect(_parent, 'defs');
	        // cannot select <clippath> elements; bug in WebKit, must select by id
	        // https://groups.google.com/forum/#!topic/d3-js/6EpAzQ2gU9I
	        var id = getClipPathId();
	        var chartBodyClip = dc.utils.appendOrSelect(defs, '#' + id, 'clipPath').attr('id', id);
	
	        var padding = _clipPadding * 2;
	
	        dc.utils.appendOrSelect(chartBodyClip, 'rect')
	            .attr('width', _chart.xAxisLength() + padding)
	            .attr('height', _chart.yAxisHeight() + padding)
	            .attr('transform', 'translate(-' + _clipPadding + ', -' + _clipPadding + ')');
	    }
	
	    _chart._preprocessData = function () {};
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _chart._preprocessData();
	
	        _chart._generateG();
	        generateClipPath();
	
	        drawChart(true);
	
	        configureMouseZoom();
	
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        _chart._preprocessData();
	
	        drawChart(false);
	        generateClipPath();
	
	        return _chart;
	    };
	
	    function drawChart (render) {
	        if (_chart.isOrdinal()) {
	            _brushOn = false;
	        }
	
	        prepareXAxis(_chart.g(), render);
	        _chart._prepareYAxis(_chart.g());
	
	        _chart.plotData();
	
	        if (_chart.elasticX() || _resizing || render) {
	            _chart.renderXAxis(_chart.g());
	        }
	
	        if (_chart.elasticY() || _resizing || render) {
	            _chart.renderYAxis(_chart.g());
	        }
	
	        if (render) {
	            _chart.renderBrush(_chart.g(), false);
	        } else {
	            _chart.redrawBrush(_chart.g(), _resizing);
	        }
	        _chart.fadeDeselectedArea();
	        _resizing = false;
	    }
	
	    function configureMouseZoom () {
	        if (_mouseZoomable) {
	            _chart._enableMouseZoom();
	        } else if (_hasBeenMouseZoomable) {
	            _chart._disableMouseZoom();
	        }
	    }
	
	    _chart._enableMouseZoom = function () {
	        _hasBeenMouseZoomable = true;
	        _zoom.x(_chart.x())
	            .scaleExtent(_zoomScale)
	            .size([_chart.width(), _chart.height()])
	            .duration(_chart.transitionDuration());
	        _chart.root().call(_zoom);
	    };
	
	    _chart._disableMouseZoom = function () {
	        _chart.root().call(_nullZoom);
	    };
	
	    function constrainRange (range, constraint) {
	        var constrainedRange = [];
	        constrainedRange[0] = d3.max([range[0], constraint[0]]);
	        constrainedRange[1] = d3.min([range[1], constraint[1]]);
	        return constrainedRange;
	    }
	
	    /**
	     * Zoom this chart to focus on the given range. The given range should be an array containing only
	     * 2 elements (`[start, end]`) defining a range in the x domain. If the range is not given or set
	     * to null, then the zoom will be reset. _For focus to work elasticX has to be turned off;
	     * otherwise focus will be ignored.
	     * @method focus
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @example
	     * chart.on('renderlet', function(chart) {
	     *     // smooth the rendering through event throttling
	     *     dc.events.trigger(function(){
	     *          // focus some other chart to the range selected by user on this chart
	     *          someOtherChart.focus(chart.filter());
	     *     });
	     * })
	     * @param {Array<Number>} [range]
	     */
	    _chart.focus = function (range) {
	        if (hasRangeSelected(range)) {
	            _chart.x().domain(range);
	        } else {
	            _chart.x().domain(_xOriginalDomain);
	        }
	
	        _zoom.x(_chart.x());
	        zoomHandler();
	    };
	
	    _chart.refocused = function () {
	        return _refocused;
	    };
	
	    _chart.focusChart = function (c) {
	        if (!arguments.length) {
	            return _focusChart;
	        }
	        _focusChart = c;
	        _chart.on('filtered', function (chart) {
	            if (!chart.filter()) {
	                dc.events.trigger(function () {
	                    _focusChart.x().domain(_focusChart.xOriginalDomain());
	                });
	            } else if (!rangesEqual(chart.filter(), _focusChart.filter())) {
	                dc.events.trigger(function () {
	                    _focusChart.focus(chart.filter());
	                });
	            }
	        });
	        return _chart;
	    };
	
	    function rangesEqual (range1, range2) {
	        if (!range1 && !range2) {
	            return true;
	        } else if (!range1 || !range2) {
	            return false;
	        } else if (range1.length === 0 && range2.length === 0) {
	            return true;
	        } else if (range1[0].valueOf() === range2[0].valueOf() &&
	            range1[1].valueOf() === range2[1].valueOf()) {
	            return true;
	        }
	        return false;
	    }
	
	    /**
	     * Turn on/off the brush-based range filter. When brushing is on then user can drag the mouse
	     * across a chart with a quantitative scale to perform range filtering based on the extent of the
	     * brush, or click on the bars of an ordinal bar chart or slices of a pie chart to filter and
	     * un-filter them. However turning on the brush filter will disable other interactive elements on
	     * the chart such as highlighting, tool tips, and reference lines. Zooming will still be possible
	     * if enabled, but only via scrolling (panning will be disabled.)
	     * @method brushOn
	     * @memberof dc.coordinateGridMixin
	     * @instance
	     * @param {Boolean} [brushOn=true]
	     * @return {Boolean}
	     * @return {dc.coordinateGridMixin}
	     */
	    _chart.brushOn = function (brushOn) {
	        if (!arguments.length) {
	            return _brushOn;
	        }
	        _brushOn = brushOn;
	        return _chart;
	    };
	
	    function hasRangeSelected (range) {
	        return range instanceof Array && range.length > 1;
	    }
	
	    return _chart;
	};
	
	/**
	 * Stack Mixin is an mixin that provides cross-chart support of stackability using d3.layout.stack.
	 * @name stackMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.stackMixin}
	 */
	dc.stackMixin = function (_chart) {
	
	    function prepareValues (layer, layerIdx) {
	        var valAccessor = layer.accessor || _chart.valueAccessor();
	        layer.name = String(layer.name || layerIdx);
	        layer.values = layer.group.all().map(function (d, i) {
	            return {
	                x: _chart.keyAccessor()(d, i),
	                y: layer.hidden ? null : valAccessor(d, i),
	                data: d,
	                layer: layer.name,
	                hidden: layer.hidden
	            };
	        });
	
	        layer.values = layer.values.filter(domainFilter());
	        return layer.values;
	    }
	
	    var _stackLayout = d3.layout.stack()
	        .values(prepareValues);
	
	    var _stack = [];
	    var _titles = {};
	
	    var _hidableStacks = false;
	
	    function domainFilter () {
	        if (!_chart.x()) {
	            return d3.functor(true);
	        }
	        var xDomain = _chart.x().domain();
	        if (_chart.isOrdinal()) {
	            // TODO #416
	            //var domainSet = d3.set(xDomain);
	            return function () {
	                return true; //domainSet.has(p.x);
	            };
	        }
	        if (_chart.elasticX()) {
	            return function () { return true; };
	        }
	        return function (p) {
	            //return true;
	            return p.x >= xDomain[0] && p.x <= xDomain[xDomain.length - 1];
	        };
	    }
	
	    /**
	     * Stack a new crossfilter group onto this chart with an optional custom value accessor. All stacks
	     * in the same chart will share the same key accessor and therefore the same set of keys.
	     *
	     * For example, in a stacked bar chart, the bars of each stack will be positioned using the same set
	     * of keys on the x axis, while stacked vertically. If name is specified then it will be used to
	     * generate the legend label.
	     * @method stack
	     * @memberof dc.stackMixin
	     * @instance
	     * @see {@link https://github.com/square/crossfilter/wiki/API-Reference#group-map-reduce crossfilter.group}
	     * @example
	     * // stack group using default accessor
	     * chart.stack(valueSumGroup)
	     * // stack group using custom accessor
	     * .stack(avgByDayGroup, function(d){return d.value.avgByDay;});
	     * @param {crossfilter.group} group
	     * @param {String} [name]
	     * @param {Function} [accessor]
	     * @return {Array<{group: crossfilter.group, name: String, accessor: Function}>}
	     * @return {dc.stackMixin}
	     */
	    _chart.stack = function (group, name, accessor) {
	        if (!arguments.length) {
	            return _stack;
	        }
	
	        if (arguments.length <= 2) {
	            accessor = name;
	        }
	
	        var layer = {group: group};
	        if (typeof name === 'string') {
	            layer.name = name;
	        }
	        if (typeof accessor === 'function') {
	            layer.accessor = accessor;
	        }
	        _stack.push(layer);
	
	        return _chart;
	    };
	
	    dc.override(_chart, 'group', function (g, n, f) {
	        if (!arguments.length) {
	            return _chart._group();
	        }
	        _stack = [];
	        _titles = {};
	        _chart.stack(g, n);
	        if (f) {
	            _chart.valueAccessor(f);
	        }
	        return _chart._group(g, n);
	    });
	
	    /**
	     * Allow named stacks to be hidden or shown by clicking on legend items.
	     * This does not affect the behavior of hideStack or showStack.
	     * @method hidableStacks
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {Boolean} [hidableStacks=false]
	     * @return {Boolean}
	     * @return {dc.stackMixin}
	     */
	    _chart.hidableStacks = function (hidableStacks) {
	        if (!arguments.length) {
	            return _hidableStacks;
	        }
	        _hidableStacks = hidableStacks;
	        return _chart;
	    };
	
	    function findLayerByName (n) {
	        var i = _stack.map(dc.pluck('name')).indexOf(n);
	        return _stack[i];
	    }
	
	    /**
	     * Hide all stacks on the chart with the given name.
	     * The chart must be re-rendered for this change to appear.
	     * @method hideStack
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {String} stackName
	     * @return {dc.stackMixin}
	     */
	    _chart.hideStack = function (stackName) {
	        var layer = findLayerByName(stackName);
	        if (layer) {
	            layer.hidden = true;
	        }
	        return _chart;
	    };
	
	    /**
	     * Show all stacks on the chart with the given name.
	     * The chart must be re-rendered for this change to appear.
	     * @method showStack
	     * @memberof dc.stackMixin
	     * @instance
	     * @param {String} stackName
	     * @return {dc.stackMixin}
	     */
	    _chart.showStack = function (stackName) {
	        var layer = findLayerByName(stackName);
	        if (layer) {
	            layer.hidden = false;
	        }
	        return _chart;
	    };
	
	    _chart.getValueAccessorByIndex = function (index) {
	        return _stack[index].accessor || _chart.valueAccessor();
	    };
	
	    _chart.yAxisMin = function () {
	        var min = d3.min(flattenStack(), function (p) {
	            return (p.y < 0) ? (p.y + p.y0) : p.y0;
	        });
	
	        return dc.utils.subtract(min, _chart.yAxisPadding());
	
	    };
	
	    _chart.yAxisMax = function () {
	        var max = d3.max(flattenStack(), function (p) {
	            return (p.y > 0) ? (p.y + p.y0) : p.y0;
	        });
	
	        return dc.utils.add(max, _chart.yAxisPadding());
	    };
	
	    function flattenStack () {
	        var valueses = _chart.data().map(function (layer) { return layer.values; });
	        return Array.prototype.concat.apply([], valueses);
	    }
	
	    _chart.xAxisMin = function () {
	        var min = d3.min(flattenStack(), dc.pluck('x'));
	        return dc.utils.subtract(min, _chart.xAxisPadding());
	    };
	
	    _chart.xAxisMax = function () {
	        var max = d3.max(flattenStack(), dc.pluck('x'));
	        return dc.utils.add(max, _chart.xAxisPadding());
	    };
	
	    /**
	     * Set or get the title function. Chart class will use this function to render svg title (usually interpreted by
	     * browser as tooltips) for each child element in the chart, i.e. a slice in a pie chart or a bubble in a bubble chart.
	     * Almost every chart supports title function however in grid coordinate chart you need to turn off brush in order to
	     * use title otherwise the brush layer will block tooltip trigger.
	     *
	     * If the first argument is a stack name, the title function will get or set the title for that stack. If stackName
	     * is not provided, the first stack is implied.
	     * @method title
	     * @memberof dc.stackMixin
	     * @instance
	     * @example
	     * // set a title function on 'first stack'
	     * chart.title('first stack', function(d) { return d.key + ': ' + d.value; });
	     * // get a title function from 'second stack'
	     * var secondTitleFunction = chart.title('second stack');
	     * @param {String} [stackName]
	     * @param {Function} [titleAccessor]
	     * @return {String}
	     * @return {dc.stackMixin}
	     */
	    dc.override(_chart, 'title', function (stackName, titleAccessor) {
	        if (!stackName) {
	            return _chart._title();
	        }
	
	        if (typeof stackName === 'function') {
	            return _chart._title(stackName);
	        }
	        if (stackName === _chart._groupName && typeof titleAccessor === 'function') {
	            return _chart._title(titleAccessor);
	        }
	
	        if (typeof titleAccessor !== 'function') {
	            return _titles[stackName] || _chart._title();
	        }
	
	        _titles[stackName] = titleAccessor;
	
	        return _chart;
	    });
	
	    /**
	     * Gets or sets the stack layout algorithm, which computes a baseline for each stack and
	     * propagates it to the next
	     * @method stackLayout
	     * @memberof dc.stackMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Stack-Layout d3.layout.stack}
	     * @param {Function} [stack=d3.layout.stack]
	     * @return {Function}
	     * @return {dc.stackMixin}
	     */
	    _chart.stackLayout = function (stack) {
	        if (!arguments.length) {
	            return _stackLayout;
	        }
	        _stackLayout = stack;
	        if (_stackLayout.values() === d3.layout.stack().values()) {
	            _stackLayout.values(prepareValues);
	        }
	        return _chart;
	    };
	
	    function visability (l) {
	        return !l.hidden;
	    }
	
	    _chart.data(function () {
	        var layers = _stack.filter(visability);
	        return layers.length ? _chart.stackLayout()(layers) : [];
	    });
	
	    _chart._ordinalXDomain = function () {
	        var flat = flattenStack().map(dc.pluck('data'));
	        var ordered = _chart._computeOrderedGroups(flat);
	        return ordered.map(_chart.keyAccessor());
	    };
	
	    _chart.colorAccessor(function (d) {
	        var layer = this.layer || this.name || d.name || d.layer;
	        return layer;
	    });
	
	    _chart.legendables = function () {
	        return _stack.map(function (layer, i) {
	            return {
	                chart: _chart,
	                name: layer.name,
	                hidden: layer.hidden || false,
	                color: _chart.getColor.call(layer, layer.values, i)
	            };
	        });
	    };
	
	    _chart.isLegendableHidden = function (d) {
	        var layer = findLayerByName(d.name);
	        return layer ? layer.hidden : false;
	    };
	
	    _chart.legendToggle = function (d) {
	        if (_hidableStacks) {
	            if (_chart.isLegendableHidden(d)) {
	                _chart.showStack(d.name);
	            } else {
	                _chart.hideStack(d.name);
	            }
	            //_chart.redraw();
	            _chart.renderGroup();
	        }
	    };
	
	    return _chart;
	};
	
	/**
	 * Cap is a mixin that groups small data elements below a _cap_ into an *others* grouping for both the
	 * Row and Pie Charts.
	 *
	 * The top ordered elements in the group up to the cap amount will be kept in the chart, and the rest
	 * will be replaced with an *others* element, with value equal to the sum of the replaced values. The
	 * keys of the elements below the cap limit are recorded in order to filter by those keys when the
	 * others* element is clicked.
	 * @name capMixin
	 * @memberof dc
	 * @mixin
	 * @param {Object} _chart
	 * @return {dc.capMixin}
	 */
	dc.capMixin = function (_chart) {
	
	    var _cap = Infinity;
	
	    var _othersLabel = 'Others';
	
	    var _othersGrouper = function (topRows) {
	        var topRowsSum = d3.sum(topRows, _chart.valueAccessor()),
	            allRows = _chart.group().all(),
	            allRowsSum = d3.sum(allRows, _chart.valueAccessor()),
	            topKeys = topRows.map(_chart.keyAccessor()),
	            allKeys = allRows.map(_chart.keyAccessor()),
	            topSet = d3.set(topKeys),
	            others = allKeys.filter(function (d) {return !topSet.has(d);});
	        if (allRowsSum > topRowsSum) {
	            return topRows.concat([{'others': others, 'key': _othersLabel, 'value': allRowsSum - topRowsSum}]);
	        }
	        return topRows;
	    };
	
	    _chart.cappedKeyAccessor = function (d, i) {
	        if (d.others) {
	            return d.key;
	        }
	        return _chart.keyAccessor()(d, i);
	    };
	
	    _chart.cappedValueAccessor = function (d, i) {
	        if (d.others) {
	            return d.value;
	        }
	        return _chart.valueAccessor()(d, i);
	    };
	
	    _chart.data(function (group) {
	        if (_cap === Infinity) {
	            return _chart._computeOrderedGroups(group.all());
	        } else {
	            var topRows = group.top(_cap); // ordered by crossfilter group order (default value)
	            topRows = _chart._computeOrderedGroups(topRows); // re-order using ordering (default key)
	            if (_othersGrouper) {
	                return _othersGrouper(topRows);
	            }
	            return topRows;
	        }
	    });
	
	    /**
	     * Get or set the count of elements to that will be included in the cap.
	     * @method cap
	     * @memberof dc.capMixin
	     * @instance
	     * @param {Number} [count=Infinity]
	     * @return {Number}
	     * @return {dc.capMixin}
	     */
	    _chart.cap = function (count) {
	        if (!arguments.length) {
	            return _cap;
	        }
	        _cap = count;
	        return _chart;
	    };
	
	    /**
	     * Get or set the label for *Others* slice when slices cap is specified
	     * @method othersLabel
	     * @memberof dc.capMixin
	     * @instance
	     * @param {String} [label="Others"]
	     * @return {String}
	     * @return {dc.capMixin}
	     */
	    _chart.othersLabel = function (label) {
	        if (!arguments.length) {
	            return _othersLabel;
	        }
	        _othersLabel = label;
	        return _chart;
	    };
	
	    /**
	     * Get or set the grouper function that will perform the insertion of data for the *Others* slice
	     * if the slices cap is specified. If set to a falsy value, no others will be added. By default the
	     * grouper function computes the sum of all values below the cap.
	     * @method othersGrouper
	     * @memberof dc.capMixin
	     * @instance
	     * @example
	     * // Default others grouper
	     * chart.othersGrouper(function (topRows) {
	     *    var topRowsSum = d3.sum(topRows, _chart.valueAccessor()),
	     *        allRows = _chart.group().all(),
	     *        allRowsSum = d3.sum(allRows, _chart.valueAccessor()),
	     *        topKeys = topRows.map(_chart.keyAccessor()),
	     *        allKeys = allRows.map(_chart.keyAccessor()),
	     *        topSet = d3.set(topKeys),
	     *        others = allKeys.filter(function (d) {return !topSet.has(d);});
	     *    if (allRowsSum > topRowsSum) {
	     *        return topRows.concat([{'others': others, 'key': _othersLabel, 'value': allRowsSum - topRowsSum}]);
	     *    }
	     *    return topRows;
	     * });
	     * // Custom others grouper
	     * chart.othersGrouper(function (data) {
	     *     // compute the value for others, presumably the sum of all values below the cap
	     *     var othersSum  = yourComputeOthersValueLogic(data)
	     *
	     *     // the keys are needed to properly filter when the others element is clicked
	     *     var othersKeys = yourComputeOthersKeysArrayLogic(data);
	     *
	     *     // add the others row to the dataset
	     *     data.push({'key': 'Others', 'value': othersSum, 'others': othersKeys });
	     *
	     *     return data;
	     * });
	     * @param {Function} [grouperFunction]
	     * @return {Function}
	     * @return {dc.capMixin}
	     */
	    _chart.othersGrouper = function (grouperFunction) {
	        if (!arguments.length) {
	            return _othersGrouper;
	        }
	        _othersGrouper = grouperFunction;
	        return _chart;
	    };
	
	    dc.override(_chart, 'onClick', function (d) {
	        if (d.others) {
	            _chart.filter([d.others]);
	        }
	        _chart._onClick(d);
	    });
	
	    return _chart;
	};
	
	/**
	 * This Mixin provides reusable functionalities for any chart that needs to visualize data using bubbles.
	 * @name bubbleMixin
	 * @memberof dc
	 * @mixin
	 * @mixes dc.colorMixin
	 * @param {Object} _chart
	 * @return {dc.bubbleMixin}
	 */
	dc.bubbleMixin = function (_chart) {
	    var _maxBubbleRelativeSize = 0.3;
	    var _minRadiusWithLabel = 10;
	
	    _chart.BUBBLE_NODE_CLASS = 'node';
	    _chart.BUBBLE_CLASS = 'bubble';
	    _chart.MIN_RADIUS = 10;
	
	    _chart = dc.colorMixin(_chart);
	
	    _chart.renderLabel(true);
	
	    _chart.data(function (group) {
	        return group.top(Infinity);
	    });
	
	    var _r = d3.scale.linear().domain([0, 100]);
	
	    var _rValueAccessor = function (d) {
	        return d.r;
	    };
	
	    /**
	     * Get or set the bubble radius scale. By default the bubble chart uses
	     * {@link https://github.com/mbostock/d3/wiki/Quantitative-Scales#linear d3.scale.linear().domain([0, 100])}
	     * as its radius scale.
	     * @method r
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @see {@link http://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @param {d3.scale} [bubbleRadiusScale=d3.scale.linear().domain([0, 100])]
	     * @return {d3.scale}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.r = function (bubbleRadiusScale) {
	        if (!arguments.length) {
	            return _r;
	        }
	        _r = bubbleRadiusScale;
	        return _chart;
	    };
	
	    /**
	     * Get or set the radius value accessor function. If set, the radius value accessor function will
	     * be used to retrieve a data value for each bubble. The data retrieved then will be mapped using
	     * the r scale to the actual bubble radius. This allows you to encode a data dimension using bubble
	     * size.
	     * @method radiusValueAccessor
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Function} [radiusValueAccessor]
	     * @return {Function}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.radiusValueAccessor = function (radiusValueAccessor) {
	        if (!arguments.length) {
	            return _rValueAccessor;
	        }
	        _rValueAccessor = radiusValueAccessor;
	        return _chart;
	    };
	
	    _chart.rMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return _chart.radiusValueAccessor()(e);
	        });
	        return min;
	    };
	
	    _chart.rMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return _chart.radiusValueAccessor()(e);
	        });
	        return max;
	    };
	
	    _chart.bubbleR = function (d) {
	        var value = _chart.radiusValueAccessor()(d);
	        var r = _chart.r()(value);
	        if (isNaN(r) || value <= 0) {
	            r = 0;
	        }
	        return r;
	    };
	
	    var labelFunction = function (d) {
	        return _chart.label()(d);
	    };
	
	    var shouldLabel = function (d) {
	        return (_chart.bubbleR(d) > _minRadiusWithLabel);
	    };
	
	    var labelOpacity = function (d) {
	        return shouldLabel(d) ? 1 : 0;
	    };
	
	    var labelPointerEvent = function (d) {
	        return shouldLabel(d) ? 'all' : 'none';
	    };
	
	    _chart._doRenderLabel = function (bubbleGEnter) {
	        if (_chart.renderLabel()) {
	            var label = bubbleGEnter.select('text');
	
	            if (label.empty()) {
	                label = bubbleGEnter.append('text')
	                    .attr('text-anchor', 'middle')
	                    .attr('dy', '.3em')
	                    .on('click', _chart.onClick);
	            }
	
	            label
	                .attr('opacity', 0)
	                .attr('pointer-events', labelPointerEvent)
	                .text(labelFunction);
	            dc.transition(label, _chart.transitionDuration())
	                .attr('opacity', labelOpacity);
	        }
	    };
	
	    _chart.doUpdateLabels = function (bubbleGEnter) {
	        if (_chart.renderLabel()) {
	            var labels = bubbleGEnter.selectAll('text')
	                .attr('pointer-events', labelPointerEvent)
	                .text(labelFunction);
	            dc.transition(labels, _chart.transitionDuration())
	                .attr('opacity', labelOpacity);
	        }
	    };
	
	    var titleFunction = function (d) {
	        return _chart.title()(d);
	    };
	
	    _chart._doRenderTitles = function (g) {
	        if (_chart.renderTitle()) {
	            var title = g.select('title');
	
	            if (title.empty()) {
	                g.append('title').text(titleFunction);
	            }
	        }
	    };
	
	    _chart.doUpdateTitles = function (g) {
	        if (_chart.renderTitle()) {
	            g.selectAll('title').text(titleFunction);
	        }
	    };
	
	    /**
	     * Get or set the minimum radius. This will be used to initialize the radius scale's range.
	     * @method minRadius
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [radius=10]
	     * @return {Number}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.minRadius = function (radius) {
	        if (!arguments.length) {
	            return _chart.MIN_RADIUS;
	        }
	        _chart.MIN_RADIUS = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the minimum radius for label rendering. If a bubble's radius is less than this value
	     * then no label will be rendered.
	     * @method minRadiusWithLabel
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [radius=10]
	     * @return {Number}
	     * @return {dc.bubbleMixin}
	     */
	
	    _chart.minRadiusWithLabel = function (radius) {
	        if (!arguments.length) {
	            return _minRadiusWithLabel;
	        }
	        _minRadiusWithLabel = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the maximum relative size of a bubble to the length of x axis. This value is useful
	     * when the difference in radius between bubbles is too great.
	     * @method maxBubbleRelativeSize
	     * @memberof dc.bubbleMixin
	     * @instance
	     * @param {Number} [relativeSize=0.3]
	     * @return {Number}
	     * @return {dc.bubbleMixin}
	     */
	    _chart.maxBubbleRelativeSize = function (relativeSize) {
	        if (!arguments.length) {
	            return _maxBubbleRelativeSize;
	        }
	        _maxBubbleRelativeSize = relativeSize;
	        return _chart;
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.' + _chart.BUBBLE_NODE_CLASS).each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.' + _chart.BUBBLE_NODE_CLASS).each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    _chart.onClick = function (d) {
	        var filter = d.key;
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    return _chart;
	};
	
	/**
	 * The pie chart implementation is usually used to visualize a small categorical distribution.  The pie
	 * chart uses keyAccessor to determine the slices, and valueAccessor to calculate the size of each
	 * slice relative to the sum of all values. Slices are ordered by {@link dc.baseMixin#ordering ordering}
	 * which defaults to sorting by key.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * @class pieChart
	 * @memberof dc
	 * @mixes dc.capMixin
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a pie chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.pieChart('#chart-container1');
	 * // create a pie chart under #chart-container2 element using chart group A
	 * var chart2 = dc.pieChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.pieChart}
	 */
	dc.pieChart = function (parent, chartGroup) {
	    var DEFAULT_MIN_ANGLE_FOR_LABEL = 0.5;
	
	    var _sliceCssClass = 'pie-slice';
	    var _labelCssClass = 'pie-label';
	    var _sliceGroupCssClass = 'pie-slice-group';
	    var _labelGroupCssClass = 'pie-label-group';
	    var _emptyCssClass = 'empty-chart';
	    var _emptyTitle = 'empty';
	
	    var _radius,
	        _givenRadius, // specified radius, if any
	        _innerRadius = 0,
	        _externalRadiusPadding = 0;
	
	    var _g;
	    var _cx;
	    var _cy;
	    var _minAngleForLabel = DEFAULT_MIN_ANGLE_FOR_LABEL;
	    var _externalLabelRadius;
	    var _drawPaths = false;
	    var _chart = dc.capMixin(dc.colorMixin(dc.baseMixin({})));
	
	    _chart.colorAccessor(_chart.cappedKeyAccessor);
	
	    _chart.title(function (d) {
	        return _chart.cappedKeyAccessor(d) + ': ' + _chart.cappedValueAccessor(d);
	    });
	
	    /**
	     * Get or set the maximum number of slices the pie chart will generate. The top slices are determined by
	     * value from high to low. Other slices exeeding the cap will be rolled up into one single *Others* slice.
	     * @method slicesCap
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cap]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.slicesCap = _chart.cap;
	
	    _chart.label(_chart.cappedKeyAccessor);
	    _chart.renderLabel(true);
	
	    _chart.transitionDuration(350);
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _g = _chart.svg()
	            .append('g')
	            .attr('transform', 'translate(' + _chart.cx() + ',' + _chart.cy() + ')');
	
	        _g.append('g').attr('class', _sliceGroupCssClass);
	        _g.append('g').attr('class', _labelGroupCssClass);
	
	        drawChart();
	
	        return _chart;
	    };
	
	    function drawChart () {
	        // set radius on basis of chart dimension if missing
	        _radius = _givenRadius ? _givenRadius : d3.min([_chart.width(), _chart.height()]) / 2;
	
	        var arc = buildArcs();
	
	        var pie = pieLayout();
	        var pieData;
	        // if we have data...
	        if (d3.sum(_chart.data(), _chart.valueAccessor())) {
	            pieData = pie(_chart.data());
	            _g.classed(_emptyCssClass, false);
	        } else {
	            // otherwise we'd be getting NaNs, so override
	            // note: abuse others for its ignoring the value accessor
	            pieData = pie([{key: _emptyTitle, value: 1, others: [_emptyTitle]}]);
	            _g.classed(_emptyCssClass, true);
	        }
	
	        if (_g) {
	            var slices = _g.select('g.' + _sliceGroupCssClass)
	                .selectAll('g.' + _sliceCssClass)
	                .data(pieData);
	
	            var labels = _g.select('g.' + _labelGroupCssClass)
	                .selectAll('text.' + _labelCssClass)
	                .data(pieData);
	
	            createElements(slices, labels, arc, pieData);
	
	            updateElements(pieData, arc);
	
	            removeElements(slices, labels);
	
	            highlightFilter();
	
	            dc.transition(_g, _chart.transitionDuration())
	                .attr('transform', 'translate(' + _chart.cx() + ',' + _chart.cy() + ')');
	        }
	    }
	
	    function createElements (slices, labels, arc, pieData) {
	        var slicesEnter = createSliceNodes(slices);
	
	        createSlicePath(slicesEnter, arc);
	
	        createTitles(slicesEnter);
	
	        createLabels(labels, pieData, arc);
	    }
	
	    function createSliceNodes (slices) {
	        var slicesEnter = slices
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return _sliceCssClass + ' _' + i;
	            });
	        return slicesEnter;
	    }
	
	    function createSlicePath (slicesEnter, arc) {
	        var slicePath = slicesEnter.append('path')
	            .attr('fill', fill)
	            .on('click', onClick)
	            .attr('d', function (d, i) {
	                return safeArc(d, i, arc);
	            });
	
	        dc.transition(slicePath, _chart.transitionDuration(), function (s) {
	            s.attrTween('d', tweenPie);
	        });
	    }
	
	    function createTitles (slicesEnter) {
	        if (_chart.renderTitle()) {
	            slicesEnter.append('title').text(function (d) {
	                return _chart.title()(d.data);
	            });
	        }
	    }
	
	    _chart._applyLabelText = function (labels) {
	        labels
	            .text(function (d) {
	                var data = d.data;
	                if ((sliceHasNoData(data) || sliceTooSmall(d)) && !isSelectedSlice(d)) {
	                    return '';
	                }
	                return _chart.label()(d.data);
	            });
	    };
	
	    function positionLabels (labels, arc) {
	        _chart._applyLabelText(labels);
	        dc.transition(labels, _chart.transitionDuration())
	            .attr('transform', function (d) {
	                return labelPosition(d, arc);
	            })
	            .attr('text-anchor', 'middle');
	    }
	
	    function highlightSlice (i, whether) {
	        _chart.select('g.pie-slice._' + i)
	            .classed('highlight', whether);
	    }
	
	    function createLabels (labels, pieData, arc) {
	        if (_chart.renderLabel()) {
	            var labelsEnter = labels
	                .enter()
	                .append('text')
	                .attr('class', function (d, i) {
	                    var classes = _sliceCssClass + ' ' + _labelCssClass + ' _' + i;
	                    if (_externalLabelRadius) {
	                        classes += ' external';
	                    }
	                    return classes;
	                })
	                .on('click', onClick)
	                .on('mouseover', function (d, i) {
	                    highlightSlice(i, true);
	                })
	                .on('mouseout', function (d, i) {
	                    highlightSlice(i, false);
	                });
	            positionLabels(labelsEnter, arc);
	            if (_externalLabelRadius && _drawPaths) {
	                updateLabelPaths(pieData, arc);
	            }
	        }
	    }
	
	    function updateLabelPaths (pieData, arc) {
	        var polyline = _g.selectAll('polyline.' + _sliceCssClass)
	                .data(pieData);
	
	        polyline
	                .enter()
	                .append('polyline')
	                .attr('class', function (d, i) {
	                    return 'pie-path _' + i + ' ' + _sliceCssClass;
	                })
	                .on('click', onClick)
	                .on('mouseover', function (d, i) {
	                    highlightSlice(i, true);
	                })
	                .on('mouseout', function (d, i) {
	                    highlightSlice(i, false);
	                });
	
	        polyline.exit().remove();
	        var arc2 = d3.svg.arc()
	                .outerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .innerRadius(_radius - _externalRadiusPadding);
	        var transition = dc.transition(polyline, _chart.transitionDuration());
	        // this is one rare case where d3.selection differs from d3.transition
	        if (transition.attrTween) {
	            transition
	                .attrTween('points', function (d) {
	                    this._current = this._current || d;
	                    var interpolate = d3.interpolate(this._current, d);
	                    this._current = interpolate(0);
	                    return function (t) {
	                        var d2 = interpolate(t);
	                        return [arc.centroid(d2), arc2.centroid(d2)];
	                    };
	                });
	        } else {
	            transition.attr('points', function (d) {
	                return [arc.centroid(d), arc2.centroid(d)];
	            });
	        }
	        transition.style('visibility', function (d) {
	            return d.endAngle - d.startAngle < 0.0001 ? 'hidden' : 'visible';
	        });
	
	    }
	
	    function updateElements (pieData, arc) {
	        updateSlicePaths(pieData, arc);
	        updateLabels(pieData, arc);
	        updateTitles(pieData);
	    }
	
	    function updateSlicePaths (pieData, arc) {
	        var slicePaths = _g.selectAll('g.' + _sliceCssClass)
	            .data(pieData)
	            .select('path')
	            .attr('d', function (d, i) {
	                return safeArc(d, i, arc);
	            });
	        dc.transition(slicePaths, _chart.transitionDuration(),
	            function (s) {
	                s.attrTween('d', tweenPie);
	            }).attr('fill', fill);
	    }
	
	    function updateLabels (pieData, arc) {
	        if (_chart.renderLabel()) {
	            var labels = _g.selectAll('text.' + _labelCssClass)
	                .data(pieData);
	            positionLabels(labels, arc);
	            if (_externalLabelRadius && _drawPaths) {
	                updateLabelPaths(pieData, arc);
	            }
	        }
	    }
	
	    function updateTitles (pieData) {
	        if (_chart.renderTitle()) {
	            _g.selectAll('g.' + _sliceCssClass)
	                .data(pieData)
	                .select('title')
	                .text(function (d) {
	                    return _chart.title()(d.data);
	                });
	        }
	    }
	
	    function removeElements (slices, labels) {
	        slices.exit().remove();
	        labels.exit().remove();
	    }
	
	    function highlightFilter () {
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.' + _sliceCssClass).each(function (d) {
	                if (isSelectedSlice(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.' + _sliceCssClass).each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    }
	
	    /**
	     * Get or set the external radius padding of the pie chart. This will force the radius of the
	     * pie chart to become smaller or larger depending on the value.
	     * @method externalRadiusPadding
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [externalRadiusPadding=0]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.externalRadiusPadding = function (externalRadiusPadding) {
	        if (!arguments.length) {
	            return _externalRadiusPadding;
	        }
	        _externalRadiusPadding = externalRadiusPadding;
	        return _chart;
	    };
	
	    /**
	     * Get or set the inner radius of the pie chart. If the inner radius is greater than 0px then the
	     * pie chart will be rendered as a doughnut chart.
	     * @method innerRadius
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [innerRadius=0]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.innerRadius = function (innerRadius) {
	        if (!arguments.length) {
	            return _innerRadius;
	        }
	        _innerRadius = innerRadius;
	        return _chart;
	    };
	
	    /**
	     * Get or set the outer radius. If the radius is not set, it will be half of the minimum of the
	     * chart width and height.
	     * @method radius
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [radius]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.radius = function (radius) {
	        if (!arguments.length) {
	            return _givenRadius;
	        }
	        _givenRadius = radius;
	        return _chart;
	    };
	
	    /**
	     * Get or set center x coordinate position. Default is center of svg.
	     * @method cx
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cx]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.cx = function (cx) {
	        if (!arguments.length) {
	            return (_cx ||  _chart.width() / 2);
	        }
	        _cx = cx;
	        return _chart;
	    };
	
	    /**
	     * Get or set center y coordinate position. Default is center of svg.
	     * @method cy
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [cy]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.cy = function (cy) {
	        if (!arguments.length) {
	            return (_cy ||  _chart.height() / 2);
	        }
	        _cy = cy;
	        return _chart;
	    };
	
	    function buildArcs () {
	        return d3.svg.arc()
	            .outerRadius(_radius - _externalRadiusPadding)
	            .innerRadius(_innerRadius);
	    }
	
	    function isSelectedSlice (d) {
	        return _chart.hasFilter(_chart.cappedKeyAccessor(d.data));
	    }
	
	    _chart._doRedraw = function () {
	        drawChart();
	        return _chart;
	    };
	
	    /**
	     * Get or set the minimal slice angle for label rendering. Any slice with a smaller angle will not
	     * display a slice label.
	     * @method minAngleForLabel
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [minAngleForLabel=0.5]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.minAngleForLabel = function (minAngleForLabel) {
	        if (!arguments.length) {
	            return _minAngleForLabel;
	        }
	        _minAngleForLabel = minAngleForLabel;
	        return _chart;
	    };
	
	    function pieLayout () {
	        return d3.layout.pie().sort(null).value(_chart.cappedValueAccessor);
	    }
	
	    function sliceTooSmall (d) {
	        var angle = (d.endAngle - d.startAngle);
	        return isNaN(angle) || angle < _minAngleForLabel;
	    }
	
	    function sliceHasNoData (d) {
	        return _chart.cappedValueAccessor(d) === 0;
	    }
	
	    function tweenPie (b) {
	        b.innerRadius = _innerRadius;
	        var current = this._current;
	        if (isOffCanvas(current)) {
	            current = {startAngle: 0, endAngle: 0};
	        } else {
	            // only interpolate startAngle & endAngle, not the whole data object
	            current = {startAngle: current.startAngle, endAngle: current.endAngle};
	        }
	        var i = d3.interpolate(current, b);
	        this._current = i(0);
	        return function (t) {
	            return safeArc(i(t), 0, buildArcs());
	        };
	    }
	
	    function isOffCanvas (current) {
	        return !current || isNaN(current.startAngle) || isNaN(current.endAngle);
	    }
	
	    function fill (d, i) {
	        return _chart.getColor(d.data, i);
	    }
	
	    function onClick (d, i) {
	        if (_g.attr('class') !== _emptyCssClass) {
	            _chart.onClick(d.data, i);
	        }
	    }
	
	    function safeArc (d, i, arc) {
	        var path = arc(d, i);
	        if (path.indexOf('NaN') >= 0) {
	            path = 'M0,0';
	        }
	        return path;
	    }
	
	    /**
	     * Title to use for the only slice when there is no data.
	     * @method emptyTitle
	     * @memberof dc.pieChart
	     * @instance
	     * @param {String} [title]
	     * @return {String}
	     * @return {dc.pieChart}
	     */
	    _chart.emptyTitle = function (title) {
	        if (arguments.length === 0) {
	            return _emptyTitle;
	        }
	        _emptyTitle = title;
	        return _chart;
	    };
	
	    /**
	     * Position slice labels offset from the outer edge of the chart
	     *
	     * The given argument sets the radial offset.
	     * @method externalLabels
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Number} [externalLabelRadius]
	     * @return {Number}
	     * @return {dc.pieChart}
	     */
	    _chart.externalLabels = function (externalLabelRadius) {
	        if (arguments.length === 0) {
	            return _externalLabelRadius;
	        } else if (externalLabelRadius) {
	            _externalLabelRadius = externalLabelRadius;
	        } else {
	            _externalLabelRadius = undefined;
	        }
	
	        return _chart;
	    };
	
	    /**
	     * Get or set whether to draw lines from pie slices to their labels.
	     *
	     * @method drawPaths
	     * @memberof dc.pieChart
	     * @instance
	     * @param {Boolean} [drawPaths]
	     * @return {Boolean}
	     * @return {dc.pieChart}
	     */
	    _chart.drawPaths = function (drawPaths) {
	        if (arguments.length === 0) {
	            return _drawPaths;
	        }
	        _drawPaths = drawPaths;
	        return _chart;
	    };
	
	    function labelPosition (d, arc) {
	        var centroid;
	        if (_externalLabelRadius) {
	            centroid = d3.svg.arc()
	                .outerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .innerRadius(_radius - _externalRadiusPadding + _externalLabelRadius)
	                .centroid(d);
	        } else {
	            centroid = arc.centroid(d);
	        }
	        if (isNaN(centroid[0]) || isNaN(centroid[1])) {
	            return 'translate(0,0)';
	        } else {
	            return 'translate(' + centroid + ')';
	        }
	    }
	
	    _chart.legendables = function () {
	        return _chart.data().map(function (d, i) {
	            var legendable = {name: d.key, data: d.value, others: d.others, chart: _chart};
	            legendable.color = _chart.getColor(d, i);
	            return legendable;
	        });
	    };
	
	    _chart.legendHighlight = function (d) {
	        highlightSliceFromLegendable(d, true);
	    };
	
	    _chart.legendReset = function (d) {
	        highlightSliceFromLegendable(d, false);
	    };
	
	    _chart.legendToggle = function (d) {
	        _chart.onClick({key: d.name, others: d.others});
	    };
	
	    function highlightSliceFromLegendable (legendable, highlighted) {
	        _chart.selectAll('g.pie-slice').each(function (d) {
	            if (legendable.name === d.data.key) {
	                d3.select(this).classed('highlight', highlighted);
	            }
	        });
	    }
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Concrete bar chart/histogram implementation.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class barChart
	 * @memberof dc
	 * @mixes dc.stackMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a bar chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.barChart('#chart-container1');
	 * // create a bar chart under #chart-container2 element using chart group A
	 * var chart2 = dc.barChart('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.barChart(compositeChart);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector}
	 * specifying a dom block element such as a div; or a dom element or d3 selection.  If the bar
	 * chart is a sub-chart in a {@link dc.compositeChart Composite Chart} then pass in the parent
	 * composite chart instance instead.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.barChart}
	 */
	dc.barChart = function (parent, chartGroup) {
	    var MIN_BAR_WIDTH = 1;
	    var DEFAULT_GAP_BETWEEN_BARS = 2;
	    var LABEL_PADDING = 3;
	
	    var _chart = dc.stackMixin(dc.coordinateGridMixin({}));
	
	    var _gap = DEFAULT_GAP_BETWEEN_BARS;
	    var _centerBar = false;
	    var _alwaysUseRounding = false;
	
	    var _barWidth;
	
	    dc.override(_chart, 'rescale', function () {
	        _chart._rescale();
	        _barWidth = undefined;
	        return _chart;
	    });
	
	    dc.override(_chart, 'render', function () {
	        if (_chart.round() && _centerBar && !_alwaysUseRounding) {
	            dc.logger.warn('By default, brush rounding is disabled if bars are centered. ' +
	                         'See dc.js bar chart API documentation for details.');
	        }
	
	        return _chart._render();
	    });
	
	    _chart.label(function (d) {
	        return dc.utils.printSingleValue(d.y0 + d.y);
	    }, false);
	
	    _chart.plotData = function () {
	        var layers = _chart.chartBodyG().selectAll('g.stack')
	            .data(_chart.data());
	
	        calculateBarWidth();
	
	        layers
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return 'stack ' + '_' + i;
	            });
	
	        var last = layers.size() - 1;
	        layers.each(function (d, i) {
	            var layer = d3.select(this);
	
	            renderBars(layer, i, d);
	
	            if (_chart.renderLabel() && last === i) {
	                renderLabels(layer, i, d);
	            }
	        });
	    };
	
	    function barHeight (d) {
	        return dc.utils.safeNumber(Math.abs(_chart.y()(d.y + d.y0) - _chart.y()(d.y0)));
	    }
	
	    function renderLabels (layer, layerIndex, d) {
	        var labels = layer.selectAll('text.barLabel')
	            .data(d.values, dc.pluck('x'));
	
	        labels.enter()
	            .append('text')
	            .attr('class', 'barLabel')
	            .attr('text-anchor', 'middle');
	
	        if (_chart.isOrdinal()) {
	            labels.on('click', _chart.onClick);
	            labels.attr('cursor', 'pointer');
	        }
	
	        dc.transition(labels, _chart.transitionDuration())
	            .attr('x', function (d) {
	                var x = _chart.x()(d.x);
	                if (!_centerBar) {
	                    x += _barWidth / 2;
	                }
	                return dc.utils.safeNumber(x);
	            })
	            .attr('y', function (d) {
	                var y = _chart.y()(d.y + d.y0);
	
	                if (d.y < 0) {
	                    y -= barHeight(d);
	                }
	
	                return dc.utils.safeNumber(y - LABEL_PADDING);
	            })
	            .text(function (d) {
	                return _chart.label()(d);
	            });
	
	        dc.transition(labels.exit(), _chart.transitionDuration())
	            .attr('height', 0)
	            .remove();
	    }
	
	    function renderBars (layer, layerIndex, d) {
	        var bars = layer.selectAll('rect.bar')
	            .data(d.values, dc.pluck('x'));
	
	        var enter = bars.enter()
	            .append('rect')
	            .attr('class', 'bar')
	            .attr('fill', dc.pluck('data', _chart.getColor))
	            .attr('y', _chart.yAxisHeight())
	            .attr('height', 0);
	
	        if (_chart.renderTitle()) {
	            enter.append('title').text(dc.pluck('data', _chart.title(d.name)));
	        }
	
	        if (_chart.isOrdinal()) {
	            bars.on('click', _chart.onClick);
	        }
	
	        dc.transition(bars, _chart.transitionDuration())
	            .attr('x', function (d) {
	                var x = _chart.x()(d.x);
	                if (_centerBar) {
	                    x -= _barWidth / 2;
	                }
	                if (_chart.isOrdinal() && _gap !== undefined) {
	                    x += _gap / 2;
	                }
	                return dc.utils.safeNumber(x);
	            })
	            .attr('y', function (d) {
	                var y = _chart.y()(d.y + d.y0);
	
	                if (d.y < 0) {
	                    y -= barHeight(d);
	                }
	
	                return dc.utils.safeNumber(y);
	            })
	            .attr('width', _barWidth)
	            .attr('height', function (d) {
	                return barHeight(d);
	            })
	            .attr('fill', dc.pluck('data', _chart.getColor))
	            .select('title').text(dc.pluck('data', _chart.title(d.name)));
	
	        dc.transition(bars.exit(), _chart.transitionDuration())
	            .attr('x', function (d) { return _chart.x()(d.x); })
	            .attr('width', _barWidth * 0.9)
	            .remove();
	    }
	
	    function calculateBarWidth () {
	        if (_barWidth === undefined) {
	            var numberOfBars = _chart.xUnitCount();
	
	            // please can't we always use rangeBands for bar charts?
	            if (_chart.isOrdinal() && _gap === undefined) {
	                _barWidth = Math.floor(_chart.x().rangeBand());
	            } else if (_gap) {
	                _barWidth = Math.floor((_chart.xAxisLength() - (numberOfBars - 1) * _gap) / numberOfBars);
	            } else {
	                _barWidth = Math.floor(_chart.xAxisLength() / (1 + _chart.barPadding()) / numberOfBars);
	            }
	
	            if (_barWidth === Infinity || isNaN(_barWidth) || _barWidth < MIN_BAR_WIDTH) {
	                _barWidth = MIN_BAR_WIDTH;
	            }
	        }
	    }
	
	    _chart.fadeDeselectedArea = function () {
	        var bars = _chart.chartBodyG().selectAll('rect.bar');
	        var extent = _chart.brush().extent();
	
	        if (_chart.isOrdinal()) {
	            if (_chart.hasFilter()) {
	                bars.classed(dc.constants.SELECTED_CLASS, function (d) {
	                    return _chart.hasFilter(d.x);
	                });
	                bars.classed(dc.constants.DESELECTED_CLASS, function (d) {
	                    return !_chart.hasFilter(d.x);
	                });
	            } else {
	                bars.classed(dc.constants.SELECTED_CLASS, false);
	                bars.classed(dc.constants.DESELECTED_CLASS, false);
	            }
	        } else {
	            if (!_chart.brushIsEmpty(extent)) {
	                var start = extent[0];
	                var end = extent[1];
	
	                bars.classed(dc.constants.DESELECTED_CLASS, function (d) {
	                    return d.x < start || d.x >= end;
	                });
	            } else {
	                bars.classed(dc.constants.DESELECTED_CLASS, false);
	            }
	        }
	    };
	
	    /**
	     * Whether the bar chart will render each bar centered around the data position on the x-axis.
	     * @method centerBar
	     * @memberof dc.barChart
	     * @instance
	     * @param {Boolean} [centerBar=false]
	     * @return {Boolean}
	     * @return {dc.barChart}
	     */
	    _chart.centerBar = function (centerBar) {
	        if (!arguments.length) {
	            return _centerBar;
	        }
	        _centerBar = centerBar;
	        return _chart;
	    };
	
	    dc.override(_chart, 'onClick', function (d) {
	        _chart._onClick(d.data);
	    });
	
	    /**
	     * Get or set the spacing between bars as a fraction of bar size. Valid values are between 0-1.
	     * Setting this value will also remove any previously set {@link dc.barChart#gap gap}. See the
	     * {@link https://github.com/mbostock/d3/wiki/Ordinal-Scales#wiki-ordinal_rangeBands d3 docs}
	     * for a visual description of how the padding is applied.
	     * @method barPadding
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [barPadding=0]
	     * @return {Number}
	     * @return {dc.barChart}
	     */
	    _chart.barPadding = function (barPadding) {
	        if (!arguments.length) {
	            return _chart._rangeBandPadding();
	        }
	        _chart._rangeBandPadding(barPadding);
	        _gap = undefined;
	        return _chart;
	    };
	
	    _chart._useOuterPadding = function () {
	        return _gap === undefined;
	    };
	
	    /**
	     * Get or set the outer padding on an ordinal bar chart. This setting has no effect on non-ordinal charts.
	     * Will pad the width by `padding * barWidth` on each side of the chart.
	     * @method outerPadding
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [padding=0.5]
	     * @return {Number}
	     * @return {dc.barChart}
	     */
	    _chart.outerPadding = _chart._outerRangeBandPadding;
	
	    /**
	     * Manually set fixed gap (in px) between bars instead of relying on the default auto-generated
	     * gap.  By default the bar chart implementation will calculate and set the gap automatically
	     * based on the number of data points and the length of the x axis.
	     * @method gap
	     * @memberof dc.barChart
	     * @instance
	     * @param {Number} [gap=2]
	     * @return {Number}
	     * @return {dc.barChart}
	     */
	    _chart.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _chart;
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _chart.brush().extent();
	        if (_chart.round() && (!_centerBar || _alwaysUseRounding)) {
	            extent[0] = extent.map(_chart.round())[0];
	            extent[1] = extent.map(_chart.round())[1];
	
	            _chart.chartBodyG().select('.brush')
	                .call(_chart.brush().extent(extent));
	        }
	
	        return extent;
	    };
	
	    /**
	     * Set or get whether rounding is enabled when bars are centered. If false, using
	     * rounding with centered bars will result in a warning and rounding will be ignored.  This flag
	     * has no effect if bars are not {@link dc.barChart#centerBar centered}.
	     * When using standard d3.js rounding methods, the brush often doesn't align correctly with
	     * centered bars since the bars are offset.  The rounding function must add an offset to
	     * compensate, such as in the following example.
	     * @method alwaysUseRounding
	     * @memberof dc.barChart
	     * @instance
	     * @example
	     * chart.round(function(n) { return Math.floor(n) + 0.5; });
	     * @param {Boolean} [alwaysUseRounding=false]
	     * @return {Boolean}
	     * @return {dc.barChart}
	     */
	    _chart.alwaysUseRounding = function (alwaysUseRounding) {
	        if (!arguments.length) {
	            return _alwaysUseRounding;
	        }
	        _alwaysUseRounding = alwaysUseRounding;
	        return _chart;
	    };
	
	    function colorFilter (color, inv) {
	        return function () {
	            var item = d3.select(this);
	            var match = item.attr('fill') === color;
	            return inv ? !match : match;
	        };
	    }
	
	    _chart.legendHighlight = function (d) {
	        if (!_chart.isLegendableHidden(d)) {
	            _chart.g().selectAll('rect.bar')
	                .classed('highlight', colorFilter(d.color))
	                .classed('fadeout', colorFilter(d.color, true));
	        }
	    };
	
	    _chart.legendReset = function () {
	        _chart.g().selectAll('rect.bar')
	            .classed('highlight', false)
	            .classed('fadeout', false);
	    };
	
	    dc.override(_chart, 'xAxisMax', function () {
	        var max = this._xAxisMax();
	        if ('resolution' in _chart.xUnits()) {
	            var res = _chart.xUnits().resolution;
	            max += res;
	        }
	        return max;
	    });
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Concrete line/area chart implementation.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class lineChart
	 * @memberof dc
	 * @mixes dc.stackMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a line chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.lineChart('#chart-container1');
	 * // create a line chart under #chart-container2 element using chart group A
	 * var chart2 = dc.lineChart('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.lineChart(compositeChart);
	 * @param {String|node|d3.selection|dc.compositeChart} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector}
	 * specifying a dom block element such as a div; or a dom element or d3 selection.  If the line
	 * chart is a sub-chart in a {@link dc.compositeChart Composite Chart} then pass in the parent
	 * composite chart instance instead.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.lineChart}
	 */
	dc.lineChart = function (parent, chartGroup) {
	    var DEFAULT_DOT_RADIUS = 5;
	    var TOOLTIP_G_CLASS = 'dc-tooltip';
	    var DOT_CIRCLE_CLASS = 'dot';
	    var Y_AXIS_REF_LINE_CLASS = 'yRef';
	    var X_AXIS_REF_LINE_CLASS = 'xRef';
	    var DEFAULT_DOT_OPACITY = 1e-6;
	    var LABEL_PADDING = 3;
	
	    var _chart = dc.stackMixin(dc.coordinateGridMixin({}));
	    var _renderArea = false;
	    var _dotRadius = DEFAULT_DOT_RADIUS;
	    var _dataPointRadius = null;
	    var _dataPointFillOpacity = DEFAULT_DOT_OPACITY;
	    var _dataPointStrokeOpacity = DEFAULT_DOT_OPACITY;
	    var _interpolate = 'linear';
	    var _tension = 0.7;
	    var _defined;
	    var _dashStyle;
	    var _xyTipsOn = true;
	
	    _chart.transitionDuration(500);
	    _chart._rangeBandPadding(1);
	
	    _chart.plotData = function () {
	        var chartBody = _chart.chartBodyG();
	        var layersList = chartBody.selectAll('g.stack-list');
	
	        if (layersList.empty()) {
	            layersList = chartBody.append('g').attr('class', 'stack-list');
	        }
	
	        var layers = layersList.selectAll('g.stack').data(_chart.data());
	
	        var layersEnter = layers
	            .enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return 'stack ' + '_' + i;
	            });
	
	        drawLine(layersEnter, layers);
	
	        drawArea(layersEnter, layers);
	
	        drawDots(chartBody, layers);
	
	        if (_chart.renderLabel()) {
	            drawLabels(layers);
	        }
	    };
	
	    /**
	     * Gets or sets the interpolator to use for lines drawn, by string name, allowing e.g. step
	     * functions, splines, and cubic interpolation.  This is passed to
	     * {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#line_interpolate d3.svg.line.interpolate} and
	     * {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#area_interpolate d3.svg.area.interpolate},
	     * where you can find a complete list of valid arguments
	     * @method interpolate
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#line_interpolate d3.svg.line.interpolate}
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#area_interpolate d3.svg.area.interpolate}
	     * @param  {String} [interpolate='linear']
	     * @return {String}
	     * @return {dc.lineChart}
	     */
	    _chart.interpolate = function (interpolate) {
	        if (!arguments.length) {
	            return _interpolate;
	        }
	        _interpolate = interpolate;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the tension to use for lines drawn, in the range 0 to 1.
	     * This parameter further customizes the interpolation behavior.  It is passed to
	     * {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#line_tension d3.svg.line.tension} and
	     * {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#area_tension d3.svg.area.tension}.
	     * @method tension
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#line_interpolate d3.svg.line.interpolate}
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#area_interpolate d3.svg.area.interpolate}
	     * @param  {Number} [tension=0.7]
	     * @return {Number}
	     * @return {dc.lineChart}
	     */
	    _chart.tension = function (tension) {
	        if (!arguments.length) {
	            return _tension;
	        }
	        _tension = tension;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets a function that will determine discontinuities in the line which should be
	     * skipped: the path will be broken into separate subpaths if some points are undefined.
	     * This function is passed to
	     * {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#line_defined d3.svg.line.defined}
	     *
	     * Note: crossfilter will sometimes coerce nulls to 0, so you may need to carefully write
	     * custom reduce functions to get this to work, depending on your data. See
	     * https://github.com/dc-js/dc.js/issues/615#issuecomment-49089248
	     * @method defined
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#line_defined d3.svg.line.defined}
	     * @param  {Function} [defined]
	     * @return {Function}
	     * @return {dc.lineChart}
	     */
	    _chart.defined = function (defined) {
	        if (!arguments.length) {
	            return _defined;
	        }
	        _defined = defined;
	        return _chart;
	    };
	
	    /**
	     * Set the line's d3 dashstyle. This value becomes the 'stroke-dasharray' of line. Defaults to empty
	     * array (solid line).
	     * @method dashStyle
	     * @memberof dc.lineChart
	     * @instance
	     * @see {@link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-dasharray stroke-dasharray}
	     * @example
	     * // create a Dash Dot Dot Dot
	     * chart.dashStyle([3,1,1,1]);
	     * @param  {Array<Number>} [dashStyle=[]]
	     * @return {Array<Number>}
	     * @return {dc.lineChart}
	     */
	    _chart.dashStyle = function (dashStyle) {
	        if (!arguments.length) {
	            return _dashStyle;
	        }
	        _dashStyle = dashStyle;
	        return _chart;
	    };
	
	    /**
	     * Get or set render area flag. If the flag is set to true then the chart will render the area
	     * beneath each line and the line chart effectively becomes an area chart.
	     * @method renderArea
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Boolean} [renderArea=false]
	     * @return {Boolean}
	     * @return {dc.lineChart}
	     */
	    _chart.renderArea = function (renderArea) {
	        if (!arguments.length) {
	            return _renderArea;
	        }
	        _renderArea = renderArea;
	        return _chart;
	    };
	
	    function colors (d, i) {
	        return _chart.getColor.call(d, d.values, i);
	    }
	
	    function drawLine (layersEnter, layers) {
	        var line = d3.svg.line()
	            .x(function (d) {
	                return _chart.x()(d.x);
	            })
	            .y(function (d) {
	                return _chart.y()(d.y + d.y0);
	            })
	            .interpolate(_interpolate)
	            .tension(_tension);
	        if (_defined) {
	            line.defined(_defined);
	        }
	
	        var path = layersEnter.append('path')
	            .attr('class', 'line')
	            .attr('stroke', colors);
	        if (_dashStyle) {
	            path.attr('stroke-dasharray', _dashStyle);
	        }
	
	        dc.transition(layers.select('path.line'), _chart.transitionDuration())
	            //.ease('linear')
	            .attr('stroke', colors)
	            .attr('d', function (d) {
	                return safeD(line(d.values));
	            });
	    }
	
	    function drawArea (layersEnter, layers) {
	        if (_renderArea) {
	            var area = d3.svg.area()
	                .x(function (d) {
	                    return _chart.x()(d.x);
	                })
	                .y(function (d) {
	                    return _chart.y()(d.y + d.y0);
	                })
	                .y0(function (d) {
	                    return _chart.y()(d.y0);
	                })
	                .interpolate(_interpolate)
	                .tension(_tension);
	            if (_defined) {
	                area.defined(_defined);
	            }
	
	            layersEnter.append('path')
	                .attr('class', 'area')
	                .attr('fill', colors)
	                .attr('d', function (d) {
	                    return safeD(area(d.values));
	                });
	
	            dc.transition(layers.select('path.area'), _chart.transitionDuration())
	                //.ease('linear')
	                .attr('fill', colors)
	                .attr('d', function (d) {
	                    return safeD(area(d.values));
	                });
	        }
	    }
	
	    function safeD (d) {
	        return (!d || d.indexOf('NaN') >= 0) ? 'M0,0' : d;
	    }
	
	    function drawDots (chartBody, layers) {
	        if (!_chart.brushOn() && _chart.xyTipsOn()) {
	            var tooltipListClass = TOOLTIP_G_CLASS + '-list';
	            var tooltips = chartBody.select('g.' + tooltipListClass);
	
	            if (tooltips.empty()) {
	                tooltips = chartBody.append('g').attr('class', tooltipListClass);
	            }
	
	            layers.each(function (d, layerIndex) {
	                var points = d.values;
	                if (_defined) {
	                    points = points.filter(_defined);
	                }
	
	                var g = tooltips.select('g.' + TOOLTIP_G_CLASS + '._' + layerIndex);
	                if (g.empty()) {
	                    g = tooltips.append('g').attr('class', TOOLTIP_G_CLASS + ' _' + layerIndex);
	                }
	
	                createRefLines(g);
	
	                var dots = g.selectAll('circle.' + DOT_CIRCLE_CLASS)
	                    .data(points, dc.pluck('x'));
	
	                dots.enter()
	                    .append('circle')
	                    .attr('class', DOT_CIRCLE_CLASS)
	                    .attr('r', getDotRadius())
	                    .style('fill-opacity', _dataPointFillOpacity)
	                    .style('stroke-opacity', _dataPointStrokeOpacity)
	                    .attr('fill', _chart.getColor)
	                    .on('mousemove', function () {
	                        var dot = d3.select(this);
	                        showDot(dot);
	                        showRefLines(dot, g);
	                    })
	                    .on('mouseout', function () {
	                        var dot = d3.select(this);
	                        hideDot(dot);
	                        hideRefLines(g);
	                    });
	
	                dots.call(renderTitle, d);
	
	                dc.transition(dots, _chart.transitionDuration())
	                    .attr('cx', function (d) {
	                        return dc.utils.safeNumber(_chart.x()(d.x));
	                    })
	                    .attr('cy', function (d) {
	                        return dc.utils.safeNumber(_chart.y()(d.y + d.y0));
	                    })
	                    .attr('fill', _chart.getColor);
	
	                dots.exit().remove();
	            });
	        }
	    }
	
	    _chart.label(function (d) {
	        return dc.utils.printSingleValue(d.y0 + d.y);
	    }, false);
	
	    function drawLabels (layers) {
	        layers.each(function (d, layerIndex) {
	            var layer = d3.select(this);
	            var labels = layer.selectAll('text.lineLabel')
	                .data(d.values, dc.pluck('x'));
	
	            labels.enter()
	                .append('text')
	                .attr('class', 'lineLabel')
	                .attr('text-anchor', 'middle');
	
	            dc.transition(labels, _chart.transitionDuration())
	                .attr('x', function (d) {
	                    return dc.utils.safeNumber(_chart.x()(d.x));
	                })
	                .attr('y', function (d) {
	                    var y = _chart.y()(d.y + d.y0) - LABEL_PADDING;
	                    return dc.utils.safeNumber(y);
	                })
	                .text(function (d) {
	                    return _chart.label()(d);
	                });
	
	            dc.transition(labels.exit(), _chart.transitionDuration())
	                .attr('height', 0)
	                .remove();
	        });
	    }
	
	    function createRefLines (g) {
	        var yRefLine = g.select('path.' + Y_AXIS_REF_LINE_CLASS).empty() ?
	            g.append('path').attr('class', Y_AXIS_REF_LINE_CLASS) : g.select('path.' + Y_AXIS_REF_LINE_CLASS);
	        yRefLine.style('display', 'none').attr('stroke-dasharray', '5,5');
	
	        var xRefLine = g.select('path.' + X_AXIS_REF_LINE_CLASS).empty() ?
	            g.append('path').attr('class', X_AXIS_REF_LINE_CLASS) : g.select('path.' + X_AXIS_REF_LINE_CLASS);
	        xRefLine.style('display', 'none').attr('stroke-dasharray', '5,5');
	    }
	
	    function showDot (dot) {
	        dot.style('fill-opacity', 0.8);
	        dot.style('stroke-opacity', 0.8);
	        dot.attr('r', _dotRadius);
	        return dot;
	    }
	
	    function showRefLines (dot, g) {
	        var x = dot.attr('cx');
	        var y = dot.attr('cy');
	        var yAxisX = (_chart._yAxisX() - _chart.margins().left);
	        var yAxisRefPathD = 'M' + yAxisX + ' ' + y + 'L' + (x) + ' ' + (y);
	        var xAxisRefPathD = 'M' + x + ' ' + _chart.yAxisHeight() + 'L' + x + ' ' + y;
	        g.select('path.' + Y_AXIS_REF_LINE_CLASS).style('display', '').attr('d', yAxisRefPathD);
	        g.select('path.' + X_AXIS_REF_LINE_CLASS).style('display', '').attr('d', xAxisRefPathD);
	    }
	
	    function getDotRadius () {
	        return _dataPointRadius || _dotRadius;
	    }
	
	    function hideDot (dot) {
	        dot.style('fill-opacity', _dataPointFillOpacity)
	            .style('stroke-opacity', _dataPointStrokeOpacity)
	            .attr('r', getDotRadius());
	    }
	
	    function hideRefLines (g) {
	        g.select('path.' + Y_AXIS_REF_LINE_CLASS).style('display', 'none');
	        g.select('path.' + X_AXIS_REF_LINE_CLASS).style('display', 'none');
	    }
	
	    function renderTitle (dot, d) {
	        if (_chart.renderTitle()) {
	            dot.selectAll('title').remove();
	            dot.append('title').text(dc.pluck('data', _chart.title(d.name)));
	        }
	    }
	
	    /**
	     * Turn on/off the mouseover behavior of an individual data point which renders a circle and x/y axis
	     * dashed lines back to each respective axis.  This is ignored if the chart
	     * {@link dc.coordinateGridMixin#brushOn brush} is on
	     * @method xyTipsOn
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Boolean} [xyTipsOn=false]
	     * @return {Boolean}
	     * @return {dc.lineChart}
	     */
	    _chart.xyTipsOn = function (xyTipsOn) {
	        if (!arguments.length) {
	            return _xyTipsOn;
	        }
	        _xyTipsOn = xyTipsOn;
	        return _chart;
	    };
	
	    /**
	     * Get or set the radius (in px) for dots displayed on the data points.
	     * @method dotRadius
	     * @memberof dc.lineChart
	     * @instance
	     * @param  {Number} [dotRadius=5]
	     * @return {Number}
	     * @return {dc.lineChart}
	     */
	    _chart.dotRadius = function (dotRadius) {
	        if (!arguments.length) {
	            return _dotRadius;
	        }
	        _dotRadius = dotRadius;
	        return _chart;
	    };
	
	    /**
	     * Always show individual dots for each datapoint.
	     * If `options` is falsy, it disables data point rendering.
	     *
	     * If no `options` are provided, the current `options` values are instead returned.
	     * @method renderDataPoints
	     * @memberof dc.lineChart
	     * @instance
	     * @example
	     * chart.renderDataPoints({radius: 2, fillOpacity: 0.8, strokeOpacity: 0.8})
	     * @param  {{fillOpacity: Number, strokeOpacity: Number, radius: Number}} [options={fillOpacity: 0.8, strokeOpacity: 0.8, radius: 2}]
	     * @return {{fillOpacity: Number, strokeOpacity: Number, radius: Number}}
	     * @return {dc.lineChart}
	     */
	    _chart.renderDataPoints = function (options) {
	        if (!arguments.length) {
	            return {
	                fillOpacity: _dataPointFillOpacity,
	                strokeOpacity: _dataPointStrokeOpacity,
	                radius: _dataPointRadius
	            };
	        } else if (!options) {
	            _dataPointFillOpacity = DEFAULT_DOT_OPACITY;
	            _dataPointStrokeOpacity = DEFAULT_DOT_OPACITY;
	            _dataPointRadius = null;
	        } else {
	            _dataPointFillOpacity = options.fillOpacity || 0.8;
	            _dataPointStrokeOpacity = options.strokeOpacity || 0.8;
	            _dataPointRadius = options.radius || 2;
	        }
	        return _chart;
	    };
	
	    function colorFilter (color, dashstyle, inv) {
	        return function () {
	            var item = d3.select(this);
	            var match = (item.attr('stroke') === color &&
	                item.attr('stroke-dasharray') === ((dashstyle instanceof Array) ?
	                    dashstyle.join(',') : null)) || item.attr('fill') === color;
	            return inv ? !match : match;
	        };
	    }
	
	    _chart.legendHighlight = function (d) {
	        if (!_chart.isLegendableHidden(d)) {
	            _chart.g().selectAll('path.line, path.area')
	                .classed('highlight', colorFilter(d.color, d.dashstyle))
	                .classed('fadeout', colorFilter(d.color, d.dashstyle, true));
	        }
	    };
	
	    _chart.legendReset = function () {
	        _chart.g().selectAll('path.line, path.area')
	            .classed('highlight', false)
	            .classed('fadeout', false);
	    };
	
	    dc.override(_chart, 'legendables', function () {
	        var legendables = _chart._legendables();
	        if (!_dashStyle) {
	            return legendables;
	        }
	        return legendables.map(function (l) {
	            l.dashstyle = _dashStyle;
	            return l;
	        });
	    });
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The data count widget is a simple widget designed to display the number of records selected by the
	 * current filters out of the total number of records in the data set. Once created the data count widget
	 * will automatically update the text content of the following elements under the parent element.
	 *
	 * Note: this widget works best for the specific case of showing the number of records out of a
	 * total. If you want a more general-purpose numeric display, please use the
	 * {@link dc.numberDisplay} widget instead.
	 *
	 * '.total-count' - total number of records
	 * '.filter-count' - number of records matched by the current filters
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * @class dataCount
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @example
	 * var ndx = crossfilter(data);
	 * var all = ndx.groupAll();
	 *
	 * dc.dataCount('.dc-data-count')
	 *     .dimension(ndx)
	 *     .group(all);
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.dataCount}
	 */
	dc.dataCount = function (parent, chartGroup) {
	    var _formatNumber = d3.format(',d');
	    var _chart = dc.baseMixin({});
	    var _html = {some: '', all: ''};
	
	    /**
	     * Gets or sets an optional object specifying HTML templates to use depending how many items are
	     * selected. The text `%total-count` will replaced with the total number of records, and the text
	     * `%filter-count` will be replaced with the number of selected records.
	     * - all: HTML template to use if all items are selected
	     * - some: HTML template to use if not all items are selected
	     * @method html
	     * @memberof dc.dataCount
	     * @instance
	     * @example
	     * counter.html({
	     *      some: '%filter-count out of %total-count records selected',
	     *      all: 'All records selected. Click on charts to apply filters'
	     * })
	     * @param {{some:String, all: String}} [options]
	     * @return {{some:String, all: String}}
	     * @return {dc.dataCount}
	     */
	    _chart.html = function (options) {
	        if (!arguments.length) {
	            return _html;
	        }
	        if (options.all) {
	            _html.all = options.all;
	        }
	        if (options.some) {
	            _html.some = options.some;
	        }
	        return _chart;
	    };
	
	    /**
	     * Gets or sets an optional function to format the filter count and total count.
	     * @method formatNumber
	     * @memberof dc.dataCount
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Formatting d3.format}
	     * @example
	     * counter.formatNumber(d3.format('.2g'))
	     * @param {Function} [formatter=d3.format('.2g')]
	     * @return {Function}
	     * @return {dc.dataCount}
	     */
	    _chart.formatNumber = function (formatter) {
	        if (!arguments.length) {
	            return _formatNumber;
	        }
	        _formatNumber = formatter;
	        return _chart;
	    };
	
	    _chart._doRender = function () {
	        var tot = _chart.dimension().size(),
	            val = _chart.group().value();
	        var all = _formatNumber(tot);
	        var selected = _formatNumber(val);
	
	        if ((tot === val) && (_html.all !== '')) {
	            _chart.root().html(_html.all.replace('%total-count', all).replace('%filter-count', selected));
	        } else if (_html.some !== '') {
	            _chart.root().html(_html.some.replace('%total-count', all).replace('%filter-count', selected));
	        } else {
	            _chart.selectAll('.total-count').text(all);
	            _chart.selectAll('.filter-count').text(selected);
	        }
	        return _chart;
	    };
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The data table is a simple widget designed to list crossfilter focused data set (rows being
	 * filtered) in a good old tabular fashion.
	 *
	 * Note: Unlike other charts, the data table (and data grid chart) use the group attribute as a
	 * keying function for {@link https://github.com/mbostock/d3/wiki/Arrays#-nest nesting} the data
	 * together in groups.  Do not pass in a crossfilter group as this will not work.
	 *
	 * Another interesting feature of the data table is that you can pass a crossfilter group to the `dimension`, as
	 * long as you specify the {@link dc.dataTable#order order} as `d3.descending`, since the data
	 * table will use `dimension.top()` to fetch the data in that case, and the method is equally
	 * supported on the crossfilter group as the crossfilter dimension.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.io/dc.js/examples/table-on-aggregated-data.html dataTable on a crossfilter group}
	 * ({@link https://github.com/dc-js/dc.js/blob/develop/web/examples/table-on-aggregated-data.html source})
	 * @class dataTable
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.dataTable}
	 */
	dc.dataTable = function (parent, chartGroup) {
	    var LABEL_CSS_CLASS = 'dc-table-label';
	    var ROW_CSS_CLASS = 'dc-table-row';
	    var COLUMN_CSS_CLASS = 'dc-table-column';
	    var GROUP_CSS_CLASS = 'dc-table-group';
	    var HEAD_CSS_CLASS = 'dc-table-head';
	
	    var _chart = dc.baseMixin({});
	
	    var _size = 25;
	    var _columns = [];
	    var _sortBy = function (d) {
	        return d;
	    };
	    var _order = d3.ascending;
	    var _beginSlice = 0;
	    var _endSlice;
	    var _showGroups = true;
	
	    _chart._doRender = function () {
	        _chart.selectAll('tbody').remove();
	
	        renderRows(renderGroups());
	
	        return _chart;
	    };
	
	    _chart._doColumnValueFormat = function (v, d) {
	        return ((typeof v === 'function') ?
	                v(d) :                          // v as function
	                ((typeof v === 'string') ?
	                 d[v] :                         // v is field name string
	                 v.format(d)                        // v is Object, use fn (element 2)
	                )
	               );
	    };
	
	    _chart._doColumnHeaderFormat = function (d) {
	        // if 'function', convert to string representation
	        // show a string capitalized
	        // if an object then display its label string as-is.
	        return (typeof d === 'function') ?
	                _chart._doColumnHeaderFnToString(d) :
	                ((typeof d === 'string') ?
	                 _chart._doColumnHeaderCapitalize(d) : String(d.label));
	    };
	
	    _chart._doColumnHeaderCapitalize = function (s) {
	        // capitalize
	        return s.charAt(0).toUpperCase() + s.slice(1);
	    };
	
	    _chart._doColumnHeaderFnToString = function (f) {
	        // columnString(f) {
	        var s = String(f);
	        var i1 = s.indexOf('return ');
	        if (i1 >= 0) {
	            var i2 = s.lastIndexOf(';');
	            if (i2 >= 0) {
	                s = s.substring(i1 + 7, i2);
	                var i3 = s.indexOf('numberFormat');
	                if (i3 >= 0) {
	                    s = s.replace('numberFormat', '');
	                }
	            }
	        }
	        return s;
	    };
	
	    function renderGroups () {
	        // The 'original' example uses all 'functions'.
	        // If all 'functions' are used, then don't remove/add a header, and leave
	        // the html alone. This preserves the functionality of earlier releases.
	        // A 2nd option is a string representing a field in the data.
	        // A third option is to supply an Object such as an array of 'information', and
	        // supply your own _doColumnHeaderFormat and _doColumnValueFormat functions to
	        // create what you need.
	        var bAllFunctions = true;
	        _columns.forEach(function (f) {
	            bAllFunctions = bAllFunctions & (typeof f === 'function');
	        });
	
	        if (!bAllFunctions) {
	            // ensure one thead
	            var thead = _chart.selectAll('thead').data([0]);
	            thead.enter().append('thead');
	            thead.exit().remove();
	
	            // with one tr
	            var headrow = thead.selectAll('tr').data([0]);
	            headrow.enter().append('tr');
	            headrow.exit().remove();
	
	            // with a th for each column
	            var headcols = headrow.selectAll('th')
	                .data(_columns);
	            headcols.enter().append('th');
	            headcols.exit().remove();
	
	            headcols
	                .attr('class', HEAD_CSS_CLASS)
	                    .html(function (d) {
	                        return (_chart._doColumnHeaderFormat(d));
	
	                    });
	        }
	
	        var groups = _chart.root().selectAll('tbody')
	            .data(nestEntries(), function (d) {
	                return _chart.keyAccessor()(d);
	            });
	
	        var rowGroup = groups
	            .enter()
	            .append('tbody');
	
	        if (_showGroups === true) {
	            rowGroup
	                .append('tr')
	                .attr('class', GROUP_CSS_CLASS)
	                    .append('td')
	                    .attr('class', LABEL_CSS_CLASS)
	                    .attr('colspan', _columns.length)
	                    .html(function (d) {
	                        return _chart.keyAccessor()(d);
	                    });
	        }
	
	        groups.exit().remove();
	
	        return rowGroup;
	    }
	
	    function nestEntries () {
	        var entries;
	        if (_order === d3.ascending) {
	            entries = _chart.dimension().bottom(_size);
	        } else {
	            entries = _chart.dimension().top(_size);
	        }
	
	        return d3.nest()
	            .key(_chart.group())
	            .sortKeys(_order)
	            .entries(entries.sort(function (a, b) {
	                return _order(_sortBy(a), _sortBy(b));
	            }).slice(_beginSlice, _endSlice));
	    }
	
	    function renderRows (groups) {
	        var rows = groups.order()
	            .selectAll('tr.' + ROW_CSS_CLASS)
	            .data(function (d) {
	                return d.values;
	            });
	
	        var rowEnter = rows.enter()
	            .append('tr')
	            .attr('class', ROW_CSS_CLASS);
	
	        _columns.forEach(function (v, i) {
	            rowEnter.append('td')
	                .attr('class', COLUMN_CSS_CLASS + ' _' + i)
	                .html(function (d) {
	                    return _chart._doColumnValueFormat(v, d);
	                });
	        });
	
	        rows.exit().remove();
	
	        return rows;
	    }
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set the table size which determines the number of rows displayed by the widget.
	     * @method size
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Number} [size=25]
	     * @return {Number}
	     * @return {dc.dataTable}
	     */
	    _chart.size = function (size) {
	        if (!arguments.length) {
	            return _size;
	        }
	        _size = size;
	        return _chart;
	    };
	
	    /**
	     * Get or set the index of the beginning slice which determines which entries get displayed
	     * by the widget. Useful when implementing pagination.
	     *
	     * Note: the sortBy function will determine how the rows are ordered for pagination purposes.
	
	     * See the {@link http://dc-js.github.io/dc.js/examples/table-pagination.html table pagination example}
	     * to see how to implement the pagination user interface using `beginSlice` and `endSlice`.
	     * @method beginSlice
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Number} [beginSlice=0]
	     * @return {Number}
	     * @return {dc.dataTable}
	     */
	    _chart.beginSlice = function (beginSlice) {
	        if (!arguments.length) {
	            return _beginSlice;
	        }
	        _beginSlice = beginSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the index of the end slice which determines which entries get displayed by the
	     * widget. Useful when implementing pagination. See {@link dc.dataTable#beginSlice `beginSlice`} for more information.
	     * @method endSlice
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Number|undefined} [endSlice=undefined]
	     * @return {Number}
	     * @return {dc.dataTable}
	     */
	    _chart.endSlice = function (endSlice) {
	        if (!arguments.length) {
	            return _endSlice;
	        }
	        _endSlice = endSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set column functions. The data table widget supports several methods of specifying the
	     * columns to display.
	     *
	     * The original method uses an array of functions to generate dynamic columns. Column functions
	     * are simple javascript functions with only one input argument `d` which represents a row in
	     * the data set. The return value of these functions will be used to generate the content for
	     * each cell. However, this method requires the HTML for the table to have a fixed set of column
	     * headers.
	     *
	     * <pre><code>chart.columns([
	     *     function(d) { return d.date; },
	     *     function(d) { return d.open; },
	     *     function(d) { return d.close; },
	     *     function(d) { return numberFormat(d.close - d.open); },
	     *     function(d) { return d.volume; }
	     * ]);
	     * </code></pre>
	     *
	     * In the second method, you can list the columns to read from the data without specifying it as
	     * a function, except where necessary (ie, computed columns).  Note the data element name is
	     * capitalized when displayed in the table header. You can also mix in functions as necessary,
	     * using the third `{label, format}` form, as shown below.
	     *
	     * <pre><code>chart.columns([
	     *     "date",    // d["date"], ie, a field accessor; capitalized automatically
	     *     "open",    // ...
	     *     "close",   // ...
	     *     {
	     *         label: "Change",
	     *         format: function (d) {
	     *             return numberFormat(d.close - d.open);
	     *         }
	     *     },
	     *     "volume"   // d["volume"], ie, a field accessor; capitalized automatically
	     * ]);
	     * </code></pre>
	     *
	     * In the third example, we specify all fields using the `{label, format}` method:
	     * <pre><code>chart.columns([
	     *     {
	     *         label: "Date",
	     *         format: function (d) { return d.date; }
	     *     },
	     *     {
	     *         label: "Open",
	     *         format: function (d) { return numberFormat(d.open); }
	     *     },
	     *     {
	     *         label: "Close",
	     *         format: function (d) { return numberFormat(d.close); }
	     *     },
	     *     {
	     *         label: "Change",
	     *         format: function (d) { return numberFormat(d.close - d.open); }
	     *     },
	     *     {
	     *         label: "Volume",
	     *         format: function (d) { return d.volume; }
	     *     }
	     * ]);
	     * </code></pre>
	     *
	     * You may wish to override the dataTable functions `_doColumnHeaderCapitalize` and
	     * `_doColumnHeaderFnToString`, which are used internally to translate the column information or
	     * function into a displayed header. The first one is used on the "string" column specifier; the
	     * second is used to transform a stringified function into something displayable. For the Stock
	     * example, the function for Change becomes the table header **d.close - d.open**.
	     *
	     * Finally, you can even specify a completely different form of column definition. To do this,
	     * override `_chart._doColumnHeaderFormat` and `_chart._doColumnValueFormat` Be aware that
	     * fields without numberFormat specification will be displayed just as they are stored in the
	     * data, unformatted.
	     * @method columns
	     * @memberof dc.dataTable
	     * @instance
	     * @param {Array<Function>} [columns=[]]
	     * @return {Array<Function>}}
	     * @return {dc.dataTable}
	     */
	    _chart.columns = function (columns) {
	        if (!arguments.length) {
	            return _columns;
	        }
	        _columns = columns;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort-by function. This function works as a value accessor at row level and returns a
	     * particular field to be sorted by. Default value: identity function
	     * @method sortBy
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart.sortBy(function(d) {
	     *     return d.date;
	     * });
	     * @param {Function} [sortBy]
	     * @return {Function}
	     * @return {dc.dataTable}
	     */
	    _chart.sortBy = function (sortBy) {
	        if (!arguments.length) {
	            return _sortBy;
	        }
	        _sortBy = sortBy;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort order. If the order is `d3.ascending`, the data table will use
	     * `dimension().bottom()` to fetch the data; otherwise it will use `dimension().top()`
	     * @method order
	     * @memberof dc.dataTable
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_ascending d3.ascending}
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_descending d3.descending}
	     * @example
	     * chart.order(d3.descending);
	     * @param {Function} [order=d3.ascending]
	     * @return {Function}
	     * @return {dc.dataTable}
	     */
	    _chart.order = function (order) {
	        if (!arguments.length) {
	            return _order;
	        }
	        _order = order;
	        return _chart;
	    };
	
	    /**
	     * Get or set if group rows will be shown.
	     *
	     * The .group() getter-setter must be provided in either case.
	     * @method showGroups
	     * @memberof dc.dataTable
	     * @instance
	     * @example
	     * chart
	     *     .group([value], [name])
	     *     .showGroups(true|false);
	     * @param {Boolean} [showGroups=true]
	     * @return {Boolean}
	     * @return {dc.dataTable}
	     */
	    _chart.showGroups = function (showGroups) {
	        if (!arguments.length) {
	            return _showGroups;
	        }
	        _showGroups = showGroups;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Data grid is a simple widget designed to list the filtered records, providing
	 * a simple way to define how the items are displayed.
	 *
	 * Note: Unlike other charts, the data grid chart (and data table) use the group attribute as a keying function
	 * for {@link https://github.com/mbostock/d3/wiki/Arrays#-nest nesting} the data together in groups.
	 * Do not pass in a crossfilter group as this will not work.
	 *
	 * Examples:
	 * - {@link http://europarl.me/dc.js/web/ep/index.html List of members of the european parliament}
	 * @class dataGrid
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.dataGrid}
	 */
	dc.dataGrid = function (parent, chartGroup) {
	    var LABEL_CSS_CLASS = 'dc-grid-label';
	    var ITEM_CSS_CLASS = 'dc-grid-item';
	    var GROUP_CSS_CLASS = 'dc-grid-group';
	    var GRID_CSS_CLASS = 'dc-grid-top';
	
	    var _chart = dc.baseMixin({});
	
	    var _size = 999; // shouldn't be needed, but you might
	    var _html = function (d) { return 'you need to provide an html() handling param:  ' + JSON.stringify(d); };
	    var _sortBy = function (d) {
	        return d;
	    };
	    var _order = d3.ascending;
	    var _beginSlice = 0, _endSlice;
	
	    var _htmlGroup = function (d) {
	        return '<div class=\'' + GROUP_CSS_CLASS + '\'><h1 class=\'' + LABEL_CSS_CLASS + '\'>' +
	            _chart.keyAccessor()(d) + '</h1></div>';
	    };
	
	    _chart._doRender = function () {
	        _chart.selectAll('div.' + GRID_CSS_CLASS).remove();
	
	        renderItems(renderGroups());
	
	        return _chart;
	    };
	
	    function renderGroups () {
	        var groups = _chart.root().selectAll('div.' + GRID_CSS_CLASS)
	                .data(nestEntries(), function (d) {
	                    return _chart.keyAccessor()(d);
	                });
	
	        var itemGroup = groups
	                .enter()
	                .append('div')
	                .attr('class', GRID_CSS_CLASS);
	
	        if (_htmlGroup) {
	            itemGroup
	                .html(function (d) {
	                    return _htmlGroup(d);
	                });
	        }
	
	        groups.exit().remove();
	        return itemGroup;
	    }
	
	    function nestEntries () {
	        var entries = _chart.dimension().top(_size);
	
	        return d3.nest()
	            .key(_chart.group())
	            .sortKeys(_order)
	            .entries(entries.sort(function (a, b) {
	                return _order(_sortBy(a), _sortBy(b));
	            }).slice(_beginSlice, _endSlice));
	    }
	
	    function renderItems (groups) {
	        var items = groups.order()
	                .selectAll('div.' + ITEM_CSS_CLASS)
	                .data(function (d) {
	                    return d.values;
	                });
	
	        items.enter()
	            .append('div')
	            .attr('class', ITEM_CSS_CLASS)
	            .html(function (d) {
	                return _html(d);
	            });
	
	        items.exit().remove();
	
	        return items;
	    }
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set the index of the beginning slice which determines which entries get displayed by the widget.
	     * Useful when implementing pagination.
	     * @method beginSlice
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [beginSlice=0]
	     * @return {Number}
	     * @return {dc.dataGrid}
	     */
	    _chart.beginSlice = function (beginSlice) {
	        if (!arguments.length) {
	            return _beginSlice;
	        }
	        _beginSlice = beginSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the index of the end slice which determines which entries get displayed by the widget
	     * Useful when implementing pagination.
	     * @method endSlice
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [endSlice]
	     * @return {Number}
	     * @return {dc.dataGrid}
	     */
	    _chart.endSlice = function (endSlice) {
	        if (!arguments.length) {
	            return _endSlice;
	        }
	        _endSlice = endSlice;
	        return _chart;
	    };
	
	    /**
	     * Get or set the grid size which determines the number of items displayed by the widget.
	     * @method size
	     * @memberof dc.dataGrid
	     * @instance
	     * @param {Number} [size=999]
	     * @return {Number}
	     * @return {dc.dataGrid}
	     */
	    _chart.size = function (size) {
	        if (!arguments.length) {
	            return _size;
	        }
	        _size = size;
	        return _chart;
	    };
	
	    /**
	     * Get or set the function that formats an item. The data grid widget uses a
	     * function to generate dynamic html. Use your favourite templating engine or
	     * generate the string directly.
	     * @method html
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.html(function (d) { return '<div class='item '+data.exampleCategory+''>'+data.exampleString+'</div>';});
	     * @param {Function} [html]
	     * @return {Function}
	     * @return {dc.dataGrid}
	     */
	    _chart.html = function (html) {
	        if (!arguments.length) {
	            return _html;
	        }
	        _html = html;
	        return _chart;
	    };
	
	    /**
	     * Get or set the function that formats a group label.
	     * @method htmlGroup
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.htmlGroup (function (d) { return '<h2>'.d.key . 'with ' . d.values.length .' items</h2>'});
	     * @param {Function} [htmlGroup]
	     * @return {Function}
	     * @return {dc.dataGrid}
	     */
	    _chart.htmlGroup = function (htmlGroup) {
	        if (!arguments.length) {
	            return _htmlGroup;
	        }
	        _htmlGroup = htmlGroup;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort-by function. This function works as a value accessor at the item
	     * level and returns a particular field to be sorted.
	     * @method sortBy
	     * @memberof dc.dataGrid
	     * @instance
	     * @example
	     * chart.sortBy(function(d) {
	     *     return d.date;
	     * });
	     * @param {Function} [sortByFunction]
	     * @return {Function}
	     * @return {dc.dataGrid}
	     */
	    _chart.sortBy = function (sortByFunction) {
	        if (!arguments.length) {
	            return _sortBy;
	        }
	        _sortBy = sortByFunction;
	        return _chart;
	    };
	
	    /**
	     * Get or set sort order function.
	     * @method order
	     * @memberof dc.dataGrid
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_ascending d3.ascending}
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_descending d3.descending}
	     * @example
	     * chart.order(d3.descending);
	     * @param {Function} [order=d3.ascending]
	     * @return {Function}
	     * @return {dc.dataGrid}
	     */
	    _chart.order = function (order) {
	        if (!arguments.length) {
	            return _order;
	        }
	        _order = order;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A concrete implementation of a general purpose bubble chart that allows data visualization using the
	 * following dimensions:
	 * - x axis position
	 * - y axis position
	 * - bubble radius
	 * - color
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/vc/index.html US Venture Capital Landscape 2011}
	 * @class bubbleChart
	 * @memberof dc
	 * @mixes dc.bubbleMixin
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a bubble chart under #chart-container1 element using the default global chart group
	 * var bubbleChart1 = dc.bubbleChart('#chart-container1');
	 * // create a bubble chart under #chart-container2 element using chart group A
	 * var bubbleChart2 = dc.bubbleChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.bubbleChart}
	 */
	dc.bubbleChart = function (parent, chartGroup) {
	    var _chart = dc.bubbleMixin(dc.coordinateGridMixin({}));
	
	    var _elasticRadius = false;
	    var _sortBubbleSize = false;
	
	    _chart.transitionDuration(750);
	
	    var bubbleLocator = function (d) {
	        return 'translate(' + (bubbleX(d)) + ',' + (bubbleY(d)) + ')';
	    };
	
	    /**
	     * Turn on or off the elastic bubble radius feature, or return the value of the flag. If this
	     * feature is turned on, then bubble radii will be automatically rescaled to fit the chart better.
	     * @method elasticRadius
	     * @memberof dc.bubbleChart
	     * @instance
	     * @param {Boolean} [elasticRadius=false]
	     * @return {Boolean}
	     * @return {dc.bubbleChart}
	     */
	    _chart.elasticRadius = function (elasticRadius) {
	        if (!arguments.length) {
	            return _elasticRadius;
	        }
	        _elasticRadius = elasticRadius;
	        return _chart;
	    };
	
	    /**
	     * Turn on or off the bubble sorting feature, or return the value of the flag. If enabled,
	     * bubbles will be sorted by their radius, with smaller bubbles in front.
	     * @method sortBubbleSize
	     * @memberof dc.bubbleChart
	     * @instance
	     * @param {Boolean} [sortBubbleSize=false]
	     * @return {Boolean}
	     * @return {dc.bubbleChart}
	     */
	    _chart.sortBubbleSize = function (sortBubbleSize) {
	        if (!arguments.length) {
	            return _sortBubbleSize;
	        }
	        _sortBubbleSize = sortBubbleSize;
	        return _chart;
	    };
	
	    _chart.plotData = function () {
	        if (_elasticRadius) {
	            _chart.r().domain([_chart.rMin(), _chart.rMax()]);
	        }
	
	        _chart.r().range([_chart.MIN_RADIUS, _chart.xAxisLength() * _chart.maxBubbleRelativeSize()]);
	
	        var data = _chart.data();
	        if (_sortBubbleSize) {
	            // sort descending so smaller bubbles are on top
	            var radiusAccessor = _chart.radiusValueAccessor();
	            data.sort(function (a, b) { return d3.descending(radiusAccessor(a), radiusAccessor(b)); });
	        }
	        var bubbleG = _chart.chartBodyG().selectAll('g.' + _chart.BUBBLE_NODE_CLASS)
	                .data(data, function (d) { return d.key; });
	        if (_sortBubbleSize) {
	            // Call order here to update dom order based on sort
	            bubbleG.order();
	        }
	
	        renderNodes(bubbleG);
	
	        updateNodes(bubbleG);
	
	        removeNodes(bubbleG);
	
	        _chart.fadeDeselectedArea();
	    };
	
	    function renderNodes (bubbleG) {
	        var bubbleGEnter = bubbleG.enter().append('g');
	
	        bubbleGEnter
	            .attr('class', _chart.BUBBLE_NODE_CLASS)
	            .attr('transform', bubbleLocator)
	            .append('circle').attr('class', function (d, i) {
	                return _chart.BUBBLE_CLASS + ' _' + i;
	            })
	            .on('click', _chart.onClick)
	            .attr('fill', _chart.getColor)
	            .attr('r', 0);
	        dc.transition(bubbleG, _chart.transitionDuration())
	            .selectAll('circle.' + _chart.BUBBLE_CLASS)
	            .attr('r', function (d) {
	                return _chart.bubbleR(d);
	            })
	            .attr('opacity', function (d) {
	                return (_chart.bubbleR(d) > 0) ? 1 : 0;
	            });
	
	        _chart._doRenderLabel(bubbleGEnter);
	
	        _chart._doRenderTitles(bubbleGEnter);
	    }
	
	    function updateNodes (bubbleG) {
	        dc.transition(bubbleG, _chart.transitionDuration())
	            .attr('transform', bubbleLocator)
	            .selectAll('circle.' + _chart.BUBBLE_CLASS)
	            .attr('fill', _chart.getColor)
	            .attr('r', function (d) {
	                return _chart.bubbleR(d);
	            })
	            .attr('opacity', function (d) {
	                return (_chart.bubbleR(d) > 0) ? 1 : 0;
	            });
	
	        _chart.doUpdateLabels(bubbleG);
	        _chart.doUpdateTitles(bubbleG);
	    }
	
	    function removeNodes (bubbleG) {
	        bubbleG.exit().remove();
	    }
	
	    function bubbleX (d) {
	        var x = _chart.x()(_chart.keyAccessor()(d));
	        if (isNaN(x)) {
	            x = 0;
	        }
	        return x;
	    }
	
	    function bubbleY (d) {
	        var y = _chart.y()(_chart.valueAccessor()(d));
	        if (isNaN(y)) {
	            y = 0;
	        }
	        return y;
	    }
	
	    _chart.renderBrush = function () {
	        // override default x axis brush from parent chart
	    };
	
	    _chart.redrawBrush = function () {
	        // override default x axis brush from parent chart
	        _chart.fadeDeselectedArea();
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Composite charts are a special kind of chart that render multiple charts on the same Coordinate
	 * Grid. You can overlay (compose) different bar/line/area charts in a single composite chart to
	 * achieve some quite flexible charting effects.
	 * @class compositeChart
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a composite chart under #chart-container1 element using the default global chart group
	 * var compositeChart1 = dc.compositeChart('#chart-container1');
	 * // create a composite chart under #chart-container2 element using chart group A
	 * var compositeChart2 = dc.compositeChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.compositeChart}
	 */
	dc.compositeChart = function (parent, chartGroup) {
	
	    var SUB_CHART_CLASS = 'sub';
	    var DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING = 12;
	
	    var _chart = dc.coordinateGridMixin({});
	    var _children = [];
	
	    var _childOptions = {};
	
	    var _shareColors = false,
	        _shareTitle = true,
	        _alignYAxes = false;
	
	    var _rightYAxis = d3.svg.axis(),
	        _rightYAxisLabel = 0,
	        _rightYAxisLabelPadding = DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING,
	        _rightY,
	        _rightAxisGridLines = false;
	
	    _chart._mandatoryAttributes([]);
	    _chart.transitionDuration(500);
	
	    dc.override(_chart, '_generateG', function () {
	        var g = this.__generateG();
	
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	
	            generateChildG(child, i);
	
	            if (!child.dimension()) {
	                child.dimension(_chart.dimension());
	            }
	            if (!child.group()) {
	                child.group(_chart.group());
	            }
	
	            child.chartGroup(_chart.chartGroup());
	            child.svg(_chart.svg());
	            child.xUnits(_chart.xUnits());
	            child.transitionDuration(_chart.transitionDuration());
	            child.brushOn(_chart.brushOn());
	            child.renderTitle(_chart.renderTitle());
	            child.elasticX(_chart.elasticX());
	        }
	
	        return g;
	    });
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	        var brushIsEmpty = _chart.brushIsEmpty(extent);
	
	        for (var i = 0; i < _children.length; ++i) {
	            _children[i].replaceFilter(brushIsEmpty ? null : extent);
	        }
	    };
	
	    _chart._prepareYAxis = function () {
	        var left = (leftYAxisChildren().length !== 0);
	        var right = (rightYAxisChildren().length !== 0);
	        var ranges = calculateYAxisRanges(left, right);
	
	        if (left) { prepareLeftYAxis(ranges); }
	        if (right) { prepareRightYAxis(ranges); }
	
	        if (leftYAxisChildren().length > 0 && !_rightAxisGridLines) {
	            _chart._renderHorizontalGridLinesForAxis(_chart.g(), _chart.y(), _chart.yAxis());
	        } else if (rightYAxisChildren().length > 0) {
	            _chart._renderHorizontalGridLinesForAxis(_chart.g(), _rightY, _rightYAxis);
	        }
	    };
	
	    _chart.renderYAxis = function () {
	        if (leftYAxisChildren().length !== 0) {
	            _chart.renderYAxisAt('y', _chart.yAxis(), _chart.margins().left);
	            _chart.renderYAxisLabel('y', _chart.yAxisLabel(), -90);
	        }
	
	        if (rightYAxisChildren().length !== 0) {
	            _chart.renderYAxisAt('yr', _chart.rightYAxis(), _chart.width() - _chart.margins().right);
	            _chart.renderYAxisLabel('yr', _chart.rightYAxisLabel(), 90, _chart.width() - _rightYAxisLabelPadding);
	        }
	    };
	
	    function calculateYAxisRanges (left, right) {
	        var lyAxisMin, lyAxisMax, ryAxisMin, ryAxisMax;
	        var ranges;
	
	        if (left) {
	            lyAxisMin = yAxisMin();
	            lyAxisMax = yAxisMax();
	        }
	
	        if (right) {
	            ryAxisMin = rightYAxisMin();
	            ryAxisMax = rightYAxisMax();
	        }
	
	        if (_chart.alignYAxes() && left && right) {
	            ranges = alignYAxisRanges(lyAxisMin, lyAxisMax, ryAxisMin, ryAxisMax);
	        }
	
	        return ranges || {
	            lyAxisMin: lyAxisMin,
	            lyAxisMax: lyAxisMax,
	            ryAxisMin: ryAxisMin,
	            ryAxisMax: ryAxisMax
	        };
	    }
	
	    function alignYAxisRanges (lyAxisMin, lyAxisMax, ryAxisMin, ryAxisMax) {
	        // since the two series will share a zero, each Y is just a multiple
	        // of the other. and the ratio should be the ratio of the ranges of the
	        // input data, so that they come out the same height. so we just min/max
	
	        // note: both ranges already include zero due to the stack mixin (#667)
	        // if #667 changes, we can reconsider whether we want data height or
	        // height from zero to be equal. and it will be possible for the axes
	        // to be aligned but not visible.
	        var extentRatio = (ryAxisMax - ryAxisMin) / (lyAxisMax - lyAxisMin);
	
	        return {
	            lyAxisMin: Math.min(lyAxisMin, ryAxisMin / extentRatio),
	            lyAxisMax: Math.max(lyAxisMax, ryAxisMax / extentRatio),
	            ryAxisMin: Math.min(ryAxisMin, lyAxisMin * extentRatio),
	            ryAxisMax: Math.max(ryAxisMax, lyAxisMax * extentRatio)
	        };
	    }
	
	    function prepareRightYAxis (ranges) {
	        var needDomain = _chart.rightY() === undefined || _chart.elasticY(),
	            needRange = needDomain || _chart.resizing();
	        if (_chart.rightY() === undefined) {
	            _chart.rightY(d3.scale.linear());
	        }
	        if (needDomain) {
	            _chart.rightY().domain([ranges.ryAxisMin, ranges.ryAxisMax]);
	        }
	        if (needRange) {
	            _chart.rightY().rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _chart.rightY().range([_chart.yAxisHeight(), 0]);
	        _chart.rightYAxis(_chart.rightYAxis().scale(_chart.rightY()));
	
	        _chart.rightYAxis().orient('right');
	    }
	
	    function prepareLeftYAxis (ranges) {
	        var needDomain = _chart.y() === undefined || _chart.elasticY(),
	            needRange = needDomain || _chart.resizing();
	        if (_chart.y() === undefined) {
	            _chart.y(d3.scale.linear());
	        }
	        if (needDomain) {
	            _chart.y().domain([ranges.lyAxisMin, ranges.lyAxisMax]);
	        }
	        if (needRange) {
	            _chart.y().rangeRound([_chart.yAxisHeight(), 0]);
	        }
	
	        _chart.y().range([_chart.yAxisHeight(), 0]);
	        _chart.yAxis(_chart.yAxis().scale(_chart.y()));
	
	        _chart.yAxis().orient('left');
	    }
	
	    function generateChildG (child, i) {
	        child._generateG(_chart.g());
	        child.g().attr('class', SUB_CHART_CLASS + ' _' + i);
	    }
	
	    _chart.plotData = function () {
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	
	            if (!child.g()) {
	                generateChildG(child, i);
	            }
	
	            if (_shareColors) {
	                child.colors(_chart.colors());
	            }
	
	            child.x(_chart.x());
	
	            child.xAxis(_chart.xAxis());
	
	            if (child.useRightYAxis()) {
	                child.y(_chart.rightY());
	                child.yAxis(_chart.rightYAxis());
	            } else {
	                child.y(_chart.y());
	                child.yAxis(_chart.yAxis());
	            }
	
	            child.plotData();
	
	            child._activateRenderlets();
	        }
	    };
	
	    /**
	     * Get or set whether to draw gridlines from the right y axis.  Drawing from the left y axis is the
	     * default behavior. This option is only respected when subcharts with both left and right y-axes
	     * are present.
	     * @method useRightAxisGridLines
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [useRightAxisGridLines=false]
	     * @return {Boolean}
	     * @return {dc.compositeChart}
	     */
	    _chart.useRightAxisGridLines = function (useRightAxisGridLines) {
	        if (!arguments) {
	            return _rightAxisGridLines;
	        }
	
	        _rightAxisGridLines = useRightAxisGridLines;
	        return _chart;
	    };
	
	    /**
	     * Get or set chart-specific options for all child charts. This is equivalent to calling
	     * {@link dc.baseMixin#options .options} on each child chart.
	     * @method childOptions
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Object} [childOptions]
	     * @return {Object}
	     * @return {dc.compositeChart}
	     */
	    _chart.childOptions = function (childOptions) {
	        if (!arguments.length) {
	            return _childOptions;
	        }
	        _childOptions = childOptions;
	        _children.forEach(function (child) {
	            child.options(_childOptions);
	        });
	        return _chart;
	    };
	
	    _chart.fadeDeselectedArea = function () {
	        for (var i = 0; i < _children.length; ++i) {
	            var child = _children[i];
	            child.brush(_chart.brush());
	            child.fadeDeselectedArea();
	        }
	    };
	
	    /**
	     * Set or get the right y axis label.
	     * @method rightYAxisLabel
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {String} [rightYAxisLabel]
	     * @param {Number} [padding]
	     * @return {String}
	     * @return {dc.compositeChart}
	     */
	    _chart.rightYAxisLabel = function (rightYAxisLabel, padding) {
	        if (!arguments.length) {
	            return _rightYAxisLabel;
	        }
	        _rightYAxisLabel = rightYAxisLabel;
	        _chart.margins().right -= _rightYAxisLabelPadding;
	        _rightYAxisLabelPadding = (padding === undefined) ? DEFAULT_RIGHT_Y_AXIS_LABEL_PADDING : padding;
	        _chart.margins().right += _rightYAxisLabelPadding;
	        return _chart;
	    };
	
	    /**
	     * Combine the given charts into one single composite coordinate grid chart.
	     * @method compose
	     * @memberof dc.compositeChart
	     * @instance
	     * @example
	     * moveChart.compose([
	     *     // when creating sub-chart you need to pass in the parent chart
	     *     dc.lineChart(moveChart)
	     *         .group(indexAvgByMonthGroup) // if group is missing then parent's group will be used
	     *         .valueAccessor(function (d){return d.value.avg;})
	     *         // most of the normal functions will continue to work in a composed chart
	     *         .renderArea(true)
	     *         .stack(monthlyMoveGroup, function (d){return d.value;})
	     *         .title(function (d){
	     *             var value = d.value.avg?d.value.avg:d.value;
	     *             if(isNaN(value)) value = 0;
	     *             return dateFormat(d.key) + '\n' + numberFormat(value);
	     *         }),
	     *     dc.barChart(moveChart)
	     *         .group(volumeByMonthGroup)
	     *         .centerBar(true)
	     * ]);
	     * @param {Array<Chart>} [subChartArray]
	     * @return {dc.compositeChart}
	     */
	    _chart.compose = function (subChartArray) {
	        _children = subChartArray;
	        _children.forEach(function (child) {
	            child.height(_chart.height());
	            child.width(_chart.width());
	            child.margins(_chart.margins());
	
	            if (_shareTitle) {
	                child.title(_chart.title());
	            }
	
	            child.options(_childOptions);
	        });
	        return _chart;
	    };
	
	    /**
	     * Returns the child charts which are composed into the composite chart.
	     * @method children
	     * @memberof dc.compositeChart
	     * @instance
	     * @return {Array<dc.baseMixin>}
	     */
	    _chart.children = function () {
	        return _children;
	    };
	
	    /**
	     * Get or set color sharing for the chart. If set, the {@link dc.colorMixin#colors .colors()} value from this chart
	     * will be shared with composed children. Additionally if the child chart implements
	     * Stackable and has not set a custom .colorAccessor, then it will generate a color
	     * specific to its order in the composition.
	     * @method shareColors
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [shareColors=false]
	     * @return {Boolean}
	     * @return {dc.compositeChart}
	     */
	    _chart.shareColors = function (shareColors) {
	        if (!arguments.length) {
	            return _shareColors;
	        }
	        _shareColors = shareColors;
	        return _chart;
	    };
	
	    /**
	     * Get or set title sharing for the chart. If set, the {@link dc.baseMixin#title .title()} value from
	     * this chart will be shared with composed children.
	     * @method shareTitle
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [shareTitle=true]
	     * @return {Boolean}
	     * @return {dc.compositeChart}
	     */
	    _chart.shareTitle = function (shareTitle) {
	        if (!arguments.length) {
	            return _shareTitle;
	        }
	        _shareTitle = shareTitle;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y scale for the right axis. The right y scale is typically automatically
	     * generated by the chart implementation.
	     * @method rightY
	     * @memberof dc.compositeChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Scales d3.scale}
	     * @param {d3.scale} [yScale]
	     * @return {d3.scale}
	     * @return {dc.compositeChart}
	     */
	    _chart.rightY = function (yScale) {
	        if (!arguments.length) {
	            return _rightY;
	        }
	        _rightY = yScale;
	        _chart.rescale();
	        return _chart;
	    };
	
	    /**
	     * Get or set alignment between left and right y axes. A line connecting '0' on both y axis
	     * will be parallel to x axis. This only has effect when {@link #dc.coordinateGridMixin+elasticY elasticY} is true.
	     * @method alignYAxes
	     * @memberof dc.compositeChart
	     * @instance
	     * @param {Boolean} [alignYAxes=false]
	     * @return {Chart}
	     */
	    _chart.alignYAxes = function (alignYAxes) {
	        if (!arguments.length) {
	            return _alignYAxes;
	        }
	        _alignYAxes = alignYAxes;
	        _chart.rescale();
	        return _chart;
	    };
	
	    function leftYAxisChildren () {
	        return _children.filter(function (child) {
	            return !child.useRightYAxis();
	        });
	    }
	
	    function rightYAxisChildren () {
	        return _children.filter(function (child) {
	            return child.useRightYAxis();
	        });
	    }
	
	    function getYAxisMin (charts) {
	        return charts.map(function (c) {
	            return c.yAxisMin();
	        });
	    }
	
	    delete _chart.yAxisMin;
	    function yAxisMin () {
	        return d3.min(getYAxisMin(leftYAxisChildren()));
	    }
	
	    function rightYAxisMin () {
	        return d3.min(getYAxisMin(rightYAxisChildren()));
	    }
	
	    function getYAxisMax (charts) {
	        return charts.map(function (c) {
	            return c.yAxisMax();
	        });
	    }
	
	    delete _chart.yAxisMax;
	    function yAxisMax () {
	        return dc.utils.add(d3.max(getYAxisMax(leftYAxisChildren())), _chart.yAxisPadding());
	    }
	
	    function rightYAxisMax () {
	        return dc.utils.add(d3.max(getYAxisMax(rightYAxisChildren())), _chart.yAxisPadding());
	    }
	
	    function getAllXAxisMinFromChildCharts () {
	        return _children.map(function (c) {
	            return c.xAxisMin();
	        });
	    }
	
	    dc.override(_chart, 'xAxisMin', function () {
	        return dc.utils.subtract(d3.min(getAllXAxisMinFromChildCharts()), _chart.xAxisPadding());
	    });
	
	    function getAllXAxisMaxFromChildCharts () {
	        return _children.map(function (c) {
	            return c.xAxisMax();
	        });
	    }
	
	    dc.override(_chart, 'xAxisMax', function () {
	        return dc.utils.add(d3.max(getAllXAxisMaxFromChildCharts()), _chart.xAxisPadding());
	    });
	
	    _chart.legendables = function () {
	        return _children.reduce(function (items, child) {
	            if (_shareColors) {
	                child.colors(_chart.colors());
	            }
	            items.push.apply(items, child.legendables());
	            return items;
	        }, []);
	    };
	
	    _chart.legendHighlight = function (d) {
	        for (var j = 0; j < _children.length; ++j) {
	            var child = _children[j];
	            child.legendHighlight(d);
	        }
	    };
	
	    _chart.legendReset = function (d) {
	        for (var j = 0; j < _children.length; ++j) {
	            var child = _children[j];
	            child.legendReset(d);
	        }
	    };
	
	    _chart.legendToggle = function () {
	        console.log('composite should not be getting legendToggle itself');
	    };
	
	    /**
	     * Set or get the right y axis used by the composite chart. This function is most useful when y
	     * axis customization is required. The y axis in dc.js is an instance of a [d3 axis
	     * object](https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-_axis) therefore it supports any valid
	     * d3 axis manipulation. **Caution**: The y axis is usually generated internally by dc;
	     * resetting it may cause unexpected results.
	     * @method rightYAxis
	     * @memberof dc.compositeChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Axes d3.svg.axis}
	     * @example
	     * // customize y axis tick format
	     * chart.rightYAxis().tickFormat(function (v) {return v + '%';});
	     * // customize y axis tick values
	     * chart.rightYAxis().tickValues([0, 100, 200, 300]);
	     * @param {d3.svg.axis} [rightYAxis]
	     * @return {d3.svg.axis}
	     * @return {dc.compositeChart}
	     */
	    _chart.rightYAxis = function (rightYAxis) {
	        if (!arguments.length) {
	            return _rightYAxis;
	        }
	        _rightYAxis = rightYAxis;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A series chart is a chart that shows multiple series of data overlaid on one chart, where the
	 * series is specified in the data. It is a specialization of Composite Chart and inherits all
	 * composite features other than recomposing the chart.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.io/dc.js/examples/series.html Series Chart}
	 * @class seriesChart
	 * @memberof dc
	 * @mixes dc.compositeChart
	 * @example
	 * // create a series chart under #chart-container1 element using the default global chart group
	 * var seriesChart1 = dc.seriesChart("#chart-container1");
	 * // create a series chart under #chart-container2 element using chart group A
	 * var seriesChart2 = dc.seriesChart("#chart-container2", "chartGroupA");
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.seriesChart}
	 */
	dc.seriesChart = function (parent, chartGroup) {
	    var _chart = dc.compositeChart(parent, chartGroup);
	
	    function keySort (a, b) {
	        return d3.ascending(_chart.keyAccessor()(a), _chart.keyAccessor()(b));
	    }
	
	    var _charts = {};
	    var _chartFunction = dc.lineChart;
	    var _seriesAccessor;
	    var _seriesSort = d3.ascending;
	    var _valueSort = keySort;
	
	    _chart._mandatoryAttributes().push('seriesAccessor', 'chart');
	    _chart.shareColors(true);
	
	    _chart._preprocessData = function () {
	        var keep = [];
	        var childrenChanged;
	        var nester = d3.nest().key(_seriesAccessor);
	        if (_seriesSort) {
	            nester.sortKeys(_seriesSort);
	        }
	        if (_valueSort) {
	            nester.sortValues(_valueSort);
	        }
	        var nesting = nester.entries(_chart.data());
	        var children =
	            nesting.map(function (sub, i) {
	                var subChart = _charts[sub.key] || _chartFunction.call(_chart, _chart, chartGroup, sub.key, i);
	                if (!_charts[sub.key]) {
	                    childrenChanged = true;
	                }
	                _charts[sub.key] = subChart;
	                keep.push(sub.key);
	                return subChart
	                    .dimension(_chart.dimension())
	                    .group({all: d3.functor(sub.values)}, sub.key)
	                    .keyAccessor(_chart.keyAccessor())
	                    .valueAccessor(_chart.valueAccessor())
	                    .brushOn(_chart.brushOn());
	            });
	        // this works around the fact compositeChart doesn't really
	        // have a removal interface
	        Object.keys(_charts)
	            .filter(function (c) {return keep.indexOf(c) === -1;})
	            .forEach(function (c) {
	                clearChart(c);
	                childrenChanged = true;
	            });
	        _chart._compose(children);
	        if (childrenChanged && _chart.legend()) {
	            _chart.legend().render();
	        }
	    };
	
	    function clearChart (c) {
	        if (_charts[c].g()) {
	            _charts[c].g().remove();
	        }
	        delete _charts[c];
	    }
	
	    function resetChildren () {
	        Object.keys(_charts).map(clearChart);
	        _charts = {};
	    }
	
	    /**
	     * Get or set the chart function, which generates the child charts.
	     * @method chart
	     * @memberof dc.seriesChart
	     * @instance
	     * @example
	     * // put interpolation on the line charts used for the series
	     * chart.chart(function(c) { return dc.lineChart(c).interpolate('basis'); })
	     * // do a scatter series chart
	     * chart.chart(dc.scatterPlot)
	     * @param {Function} [chartFunction=dc.lineChart]
	     * @return {Function}
	     * @return {dc.seriesChart}
	     */
	    _chart.chart = function (chartFunction) {
	        if (!arguments.length) {
	            return _chartFunction;
	        }
	        _chartFunction = chartFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Get or set accessor function for the displayed series. Given a datum, this function
	     * should return the series that datum belongs to.
	     * @method seriesAccessor
	     * @memberof dc.seriesChart
	     * @instance
	     * @example
	     * // simple series accessor
	     * chart.seriesAccessor(function(d) { return "Expt: " + d.key[0]; })
	     * @param {Function} [accessor]
	     * @return {Function}
	     * @return {dc.seriesChart}
	     */
	    _chart.seriesAccessor = function (accessor) {
	        if (!arguments.length) {
	            return _seriesAccessor;
	        }
	        _seriesAccessor = accessor;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * Get or set a function to sort the list of series by, given series values.
	     * @method seriesSort
	     * @memberof dc.seriesChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_ascending d3.ascending}
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_descending d3.descending}
	     * @example
	     * chart.seriesSort(d3.descending);
	     * @param {Function} [sortFunction=d3.ascending]
	     * @return {Function}
	     * @return {dc.seriesChart}
	     */
	    _chart.seriesSort = function (sortFunction) {
	        if (!arguments.length) {
	            return _seriesSort;
	        }
	        _seriesSort = sortFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    /**
	     * Get or set a function to sort each series values by. By default this is the key accessor which,
	     * for example, will ensure a lineChart series connects its points in increasing key/x order,
	     * rather than haphazardly.
	     * @method valueSort
	     * @memberof dc.seriesChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_ascending d3.ascending}
	     * @see {@link https://github.com/mbostock/d3/wiki/Arrays#d3_descending d3.descending}
	     * @example
	     * // Default value sort
	     * _chart.valueSort(function keySort (a, b) {
	     *     return d3.ascending(_chart.keyAccessor()(a), _chart.keyAccessor()(b));
	     * });
	     * @param {Function} [sortFunction]
	     * @return {Function}
	     * @return {dc.seriesChart}
	     */
	    _chart.valueSort = function (sortFunction) {
	        if (!arguments.length) {
	            return _valueSort;
	        }
	        _valueSort = sortFunction;
	        resetChildren();
	        return _chart;
	    };
	
	    // make compose private
	    _chart._compose = _chart.compose;
	    delete _chart.compose;
	
	    return _chart;
	};
	
	/**
	 * The geo choropleth chart is designed as an easy way to create a crossfilter driven choropleth map
	 * from GeoJson data. This chart implementation was inspired by
	 * {@link http://bl.ocks.org/4060606 the great d3 choropleth example}.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/vc/index.html US Venture Capital Landscape 2011}
	 * @class geoChoroplethChart
	 * @memberof dc
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a choropleth chart under '#us-chart' element using the default global chart group
	 * var chart1 = dc.geoChoroplethChart('#us-chart');
	 * // create a choropleth chart under '#us-chart2' element using chart group A
	 * var chart2 = dc.compositeChart('#us-chart2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.geoChoroplethChart}
	 */
	dc.geoChoroplethChart = function (parent, chartGroup) {
	    var _chart = dc.colorMixin(dc.baseMixin({}));
	
	    _chart.colorAccessor(function (d) {
	        return d || 0;
	    });
	
	    var _geoPath = d3.geo.path();
	    var _projectionFlag;
	
	    var _geoJsons = [];
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	        for (var layerIndex = 0; layerIndex < _geoJsons.length; ++layerIndex) {
	            var states = _chart.svg().append('g')
	                .attr('class', 'layer' + layerIndex);
	
	            var regionG = states.selectAll('g.' + geoJson(layerIndex).name)
	                .data(geoJson(layerIndex).data)
	                .enter()
	                .append('g')
	                .attr('class', geoJson(layerIndex).name);
	
	            regionG
	                .append('path')
	                .attr('fill', 'white')
	                .attr('d', _geoPath);
	
	            regionG.append('title');
	
	            plotData(layerIndex);
	        }
	        _projectionFlag = false;
	    };
	
	    function plotData (layerIndex) {
	        var data = generateLayeredData();
	
	        if (isDataLayer(layerIndex)) {
	            var regionG = renderRegionG(layerIndex);
	
	            renderPaths(regionG, layerIndex, data);
	
	            renderTitle(regionG, layerIndex, data);
	        }
	    }
	
	    function generateLayeredData () {
	        var data = {};
	        var groupAll = _chart.data();
	        for (var i = 0; i < groupAll.length; ++i) {
	            data[_chart.keyAccessor()(groupAll[i])] = _chart.valueAccessor()(groupAll[i]);
	        }
	        return data;
	    }
	
	    function isDataLayer (layerIndex) {
	        return geoJson(layerIndex).keyAccessor;
	    }
	
	    function renderRegionG (layerIndex) {
	        var regionG = _chart.svg()
	            .selectAll(layerSelector(layerIndex))
	            .classed('selected', function (d) {
	                return isSelected(layerIndex, d);
	            })
	            .classed('deselected', function (d) {
	                return isDeselected(layerIndex, d);
	            })
	            .attr('class', function (d) {
	                var layerNameClass = geoJson(layerIndex).name;
	                var regionClass = dc.utils.nameToId(geoJson(layerIndex).keyAccessor(d));
	                var baseClasses = layerNameClass + ' ' + regionClass;
	                if (isSelected(layerIndex, d)) {
	                    baseClasses += ' selected';
	                }
	                if (isDeselected(layerIndex, d)) {
	                    baseClasses += ' deselected';
	                }
	                return baseClasses;
	            });
	        return regionG;
	    }
	
	    function layerSelector (layerIndex) {
	        return 'g.layer' + layerIndex + ' g.' + geoJson(layerIndex).name;
	    }
	
	    function isSelected (layerIndex, d) {
	        return _chart.hasFilter() && _chart.hasFilter(getKey(layerIndex, d));
	    }
	
	    function isDeselected (layerIndex, d) {
	        return _chart.hasFilter() && !_chart.hasFilter(getKey(layerIndex, d));
	    }
	
	    function getKey (layerIndex, d) {
	        return geoJson(layerIndex).keyAccessor(d);
	    }
	
	    function geoJson (index) {
	        return _geoJsons[index];
	    }
	
	    function renderPaths (regionG, layerIndex, data) {
	        var paths = regionG
	            .select('path')
	            .attr('fill', function () {
	                var currentFill = d3.select(this).attr('fill');
	                if (currentFill) {
	                    return currentFill;
	                }
	                return 'none';
	            })
	            .on('click', function (d) {
	                return _chart.onClick(d, layerIndex);
	            });
	
	        dc.transition(paths, _chart.transitionDuration()).attr('fill', function (d, i) {
	            return _chart.getColor(data[geoJson(layerIndex).keyAccessor(d)], i);
	        });
	    }
	
	    _chart.onClick = function (d, layerIndex) {
	        var selectedRegion = geoJson(layerIndex).keyAccessor(d);
	        dc.events.trigger(function () {
	            _chart.filter(selectedRegion);
	            _chart.redrawGroup();
	        });
	    };
	
	    function renderTitle (regionG, layerIndex, data) {
	        if (_chart.renderTitle()) {
	            regionG.selectAll('title').text(function (d) {
	                var key = getKey(layerIndex, d);
	                var value = data[key];
	                return _chart.title()({key: key, value: value});
	            });
	        }
	    }
	
	    _chart._doRedraw = function () {
	        for (var layerIndex = 0; layerIndex < _geoJsons.length; ++layerIndex) {
	            plotData(layerIndex);
	            if (_projectionFlag) {
	                _chart.svg().selectAll('g.' + geoJson(layerIndex).name + ' path').attr('d', _geoPath);
	            }
	        }
	        _projectionFlag = false;
	    };
	
	    /**
	     * **mandatory**
	     *
	     * Use this function to insert a new GeoJson map layer. This function can be invoked multiple times
	     * if you have multiple GeoJson data layers to render on top of each other. If you overlay multiple
	     * layers with the same name the new overlay will override the existing one.
	     * @method overlayGeoJson
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @see {@link http://geojson.org/ GeoJSON}
	     * @see {@link https://github.com/mbostock/topojson/wiki TopoJSON}
	     * @see {@link https://github.com/mbostock/topojson/wiki/API-Reference#feature topojson.feature}
	     * @example
	     * // insert a layer for rendering US states
	     * chart.overlayGeoJson(statesJson.features, 'state', function(d) {
	     *      return d.properties.name;
	     * });
	     * @param {geoJson} json - a geojson feed
	     * @param {String} name - name of the layer
	     * @param {Function} keyAccessor - accessor function used to extract 'key' from the GeoJson data. The key extracted by
	     * this function should match the keys returned by the crossfilter groups.
	     * @return {dc.geoChoroplethChart}
	     */
	    _chart.overlayGeoJson = function (json, name, keyAccessor) {
	        for (var i = 0; i < _geoJsons.length; ++i) {
	            if (_geoJsons[i].name === name) {
	                _geoJsons[i].data = json;
	                _geoJsons[i].keyAccessor = keyAccessor;
	                return _chart;
	            }
	        }
	        _geoJsons.push({name: name, data: json, keyAccessor: keyAccessor});
	        return _chart;
	    };
	
	    /**
	     * Set custom geo projection function. See the available [d3 geo projection
	     * functions](https://github.com/mbostock/d3/wiki/Geo-Projections).
	     * @method projection
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Geo-Projections d3.geo.projection}
	     * @see {@link https://github.com/d3/d3-geo-projection Extended d3.geo.projection}
	     * @param {d3.projection} [projection=d3.geo.albersUsa()]
	     * @return {dc.geoChoroplethChart}
	     */
	    _chart.projection = function (projection) {
	        _geoPath.projection(projection);
	        _projectionFlag = true;
	        return _chart;
	    };
	
	    /**
	     * Returns all GeoJson layers currently registered with this chart. The returned array is a
	     * reference to this chart's internal data structure, so any modification to this array will also
	     * modify this chart's internal registration.
	     * @method geoJsons
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @return {Array<{name:String, data: Object, accessor: Function}>}
	     */
	    _chart.geoJsons = function () {
	        return _geoJsons;
	    };
	
	    /**
	     * Returns the {@link https://github.com/mbostock/d3/wiki/Geo-Paths#path d3.geo.path} object used to
	     * render the projection and features.  Can be useful for figuring out the bounding box of the
	     * feature set and thus a way to calculate scale and translation for the projection.
	     * @method geoPath
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Geo-Paths#path d3.geo.path}
	     * @return {d3.geo.path}
	     */
	    _chart.geoPath = function () {
	        return _geoPath;
	    };
	
	    /**
	     * Remove a GeoJson layer from this chart by name
	     * @method removeGeoJson
	     * @memberof dc.geoChoroplethChart
	     * @instance
	     * @param {String} name
	     * @return {dc.geoChoroplethChart}
	     */
	    _chart.removeGeoJson = function (name) {
	        var geoJsons = [];
	
	        for (var i = 0; i < _geoJsons.length; ++i) {
	            var layer = _geoJsons[i];
	            if (layer.name !== name) {
	                geoJsons.push(layer);
	            }
	        }
	
	        _geoJsons = geoJsons;
	
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * The bubble overlay chart is quite different from the typical bubble chart. With the bubble overlay
	 * chart you can arbitrarily place bubbles on an existing svg or bitmap image, thus changing the
	 * typical x and y positioning while retaining the capability to visualize data using bubble radius
	 * and coloring.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class bubbleOverlay
	 * @memberof dc
	 * @mixes dc.bubbleMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a bubble overlay chart on top of the '#chart-container1 svg' element using the default global chart group
	 * var bubbleChart1 = dc.bubbleOverlayChart('#chart-container1').svg(d3.select('#chart-container1 svg'));
	 * // create a bubble overlay chart on top of the '#chart-container2 svg' element using chart group A
	 * var bubbleChart2 = dc.compositeChart('#chart-container2', 'chartGroupA').svg(d3.select('#chart-container2 svg'));
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.bubbleOverlay}
	 */
	dc.bubbleOverlay = function (parent, chartGroup) {
	    var BUBBLE_OVERLAY_CLASS = 'bubble-overlay';
	    var BUBBLE_NODE_CLASS = 'node';
	    var BUBBLE_CLASS = 'bubble';
	
	    /**
	     * **mandatory**
	     *
	     * Set the underlying svg image element. Unlike other dc charts this chart will not generate a svg
	     * element; therefore the bubble overlay chart will not work if this function is not invoked. If the
	     * underlying image is a bitmap, then an empty svg will need to be created on top of the image.
	     * @method svg
	     * @memberof dc.bubbleOverlay
	     * @instance
	     * @example
	     * // set up underlying svg element
	     * chart.svg(d3.select('#chart svg'));
	     * @param {SVGElement|d3.selection} [imageElement]
	     * @return {dc.bubbleOverlay}
	     */
	    var _chart = dc.bubbleMixin(dc.baseMixin({}));
	    var _g;
	    var _points = [];
	
	    _chart.transitionDuration(750);
	
	    _chart.radiusValueAccessor(function (d) {
	        return d.value;
	    });
	
	    /**
	     * **mandatory**
	     *
	     * Set up a data point on the overlay. The name of a data point should match a specific 'key' among
	     * data groups generated using keyAccessor.  If a match is found (point name <-> data group key)
	     * then a bubble will be generated at the position specified by the function. x and y
	     * value specified here are relative to the underlying svg.
	     * @method point
	     * @memberof dc.bubbleOverlay
	     * @instance
	     * @param {String} name
	     * @param {Number} x
	     * @param {Number} y
	     * @return {dc.bubbleOverlay}
	     */
	    _chart.point = function (name, x, y) {
	        _points.push({name: name, x: x, y: y});
	        return _chart;
	    };
	
	    _chart._doRender = function () {
	        _g = initOverlayG();
	
	        _chart.r().range([_chart.MIN_RADIUS, _chart.width() * _chart.maxBubbleRelativeSize()]);
	
	        initializeBubbles();
	
	        _chart.fadeDeselectedArea();
	
	        return _chart;
	    };
	
	    function initOverlayG () {
	        _g = _chart.select('g.' + BUBBLE_OVERLAY_CLASS);
	        if (_g.empty()) {
	            _g = _chart.svg().append('g').attr('class', BUBBLE_OVERLAY_CLASS);
	        }
	        return _g;
	    }
	
	    function initializeBubbles () {
	        var data = mapData();
	
	        _points.forEach(function (point) {
	            var nodeG = getNodeG(point, data);
	
	            var circle = nodeG.select('circle.' + BUBBLE_CLASS);
	
	            if (circle.empty()) {
	                circle = nodeG.append('circle')
	                    .attr('class', BUBBLE_CLASS)
	                    .attr('r', 0)
	                    .attr('fill', _chart.getColor)
	                    .on('click', _chart.onClick);
	            }
	
	            dc.transition(circle, _chart.transitionDuration())
	                .attr('r', function (d) {
	                    return _chart.bubbleR(d);
	                });
	
	            _chart._doRenderLabel(nodeG);
	
	            _chart._doRenderTitles(nodeG);
	        });
	    }
	
	    function mapData () {
	        var data = {};
	        _chart.data().forEach(function (datum) {
	            data[_chart.keyAccessor()(datum)] = datum;
	        });
	        return data;
	    }
	
	    function getNodeG (point, data) {
	        var bubbleNodeClass = BUBBLE_NODE_CLASS + ' ' + dc.utils.nameToId(point.name);
	
	        var nodeG = _g.select('g.' + dc.utils.nameToId(point.name));
	
	        if (nodeG.empty()) {
	            nodeG = _g.append('g')
	                .attr('class', bubbleNodeClass)
	                .attr('transform', 'translate(' + point.x + ',' + point.y + ')');
	        }
	
	        nodeG.datum(data[point.name]);
	
	        return nodeG;
	    }
	
	    _chart._doRedraw = function () {
	        updateBubbles();
	
	        _chart.fadeDeselectedArea();
	
	        return _chart;
	    };
	
	    function updateBubbles () {
	        var data = mapData();
	
	        _points.forEach(function (point) {
	            var nodeG = getNodeG(point, data);
	
	            var circle = nodeG.select('circle.' + BUBBLE_CLASS);
	
	            dc.transition(circle, _chart.transitionDuration())
	                .attr('r', function (d) {
	                    return _chart.bubbleR(d);
	                })
	                .attr('fill', _chart.getColor);
	
	            _chart.doUpdateLabels(nodeG);
	
	            _chart.doUpdateTitles(nodeG);
	        });
	    }
	
	    _chart.debug = function (flag) {
	        if (flag) {
	            var debugG = _chart.select('g.' + dc.constants.DEBUG_GROUP_CLASS);
	
	            if (debugG.empty()) {
	                debugG = _chart.svg()
	                    .append('g')
	                    .attr('class', dc.constants.DEBUG_GROUP_CLASS);
	            }
	
	            var debugText = debugG.append('text')
	                .attr('x', 10)
	                .attr('y', 20);
	
	            debugG
	                .append('rect')
	                .attr('width', _chart.width())
	                .attr('height', _chart.height())
	                .on('mousemove', function () {
	                    var position = d3.mouse(debugG.node());
	                    var msg = position[0] + ', ' + position[1];
	                    debugText.text(msg);
	                });
	        } else {
	            _chart.selectAll('.debug').remove();
	        }
	
	        return _chart;
	    };
	
	    _chart.anchor(parent, chartGroup);
	
	    return _chart;
	};
	
	/**
	 * Concrete row chart implementation.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * @class rowChart
	 * @memberof dc
	 * @mixes dc.capMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.colorMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a row chart under #chart-container1 element using the default global chart group
	 * var chart1 = dc.rowChart('#chart-container1');
	 * // create a row chart under #chart-container2 element using chart group A
	 * var chart2 = dc.rowChart('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.rowChart}
	 */
	dc.rowChart = function (parent, chartGroup) {
	
	    var _g;
	
	    var _labelOffsetX = 10;
	    var _labelOffsetY = 15;
	    var _hasLabelOffsetY = false;
	    var _dyOffset = '0.35em';  // this helps center labels https://github.com/mbostock/d3/wiki/SVG-Shapes#svg_text
	    var _titleLabelOffsetX = 2;
	
	    var _gap = 5;
	
	    var _fixedBarHeight = false;
	    var _rowCssClass = 'row';
	    var _titleRowCssClass = 'titlerow';
	    var _renderTitleLabel = false;
	
	    var _chart = dc.capMixin(dc.marginMixin(dc.colorMixin(dc.baseMixin({}))));
	
	    var _x;
	
	    var _elasticX;
	
	    var _xAxis = d3.svg.axis().orient('bottom');
	
	    var _rowData;
	
	    _chart.rowsCap = _chart.cap;
	
	    function calculateAxisScale () {
	        if (!_x || _elasticX) {
	            var extent = d3.extent(_rowData, _chart.cappedValueAccessor);
	            if (extent[0] > 0) {
	                extent[0] = 0;
	            }
	            if (extent[1] < 0) {
	                extent[1] = 0;
	            }
	            _x = d3.scale.linear().domain(extent)
	                .range([0, _chart.effectiveWidth()]);
	        }
	        _xAxis.scale(_x);
	    }
	
	    function drawAxis () {
	        var axisG = _g.select('g.axis');
	
	        calculateAxisScale();
	
	        if (axisG.empty()) {
	            axisG = _g.append('g').attr('class', 'axis');
	        }
	        axisG.attr('transform', 'translate(0, ' + _chart.effectiveHeight() + ')');
	
	        dc.transition(axisG, _chart.transitionDuration())
	            .call(_xAxis);
	    }
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _g = _chart.svg()
	            .append('g')
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	
	        drawChart();
	
	        return _chart;
	    };
	
	    _chart.title(function (d) {
	        return _chart.cappedKeyAccessor(d) + ': ' + _chart.cappedValueAccessor(d);
	    });
	
	    _chart.label(_chart.cappedKeyAccessor);
	
	    /**
	     * Gets or sets the x scale. The x scale can be any d3
	     * {@link https://github.com/mbostock/d3/wiki/Quantitative-Scales quantitive scale}
	     * @method x
	     * @memberof dc.rowChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Quantitative-Scales quantitive scale}
	     * @param {d3.scale} [scale]
	     * @return {d3.scale}
	     * @return {dc.rowChart}
	     */
	    _chart.x = function (scale) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = scale;
	        return _chart;
	    };
	
	    function drawGridLines () {
	        _g.selectAll('g.tick')
	            .select('line.grid-line')
	            .remove();
	
	        _g.selectAll('g.tick')
	            .append('line')
	            .attr('class', 'grid-line')
	            .attr('x1', 0)
	            .attr('y1', 0)
	            .attr('x2', 0)
	            .attr('y2', function () {
	                return -_chart.effectiveHeight();
	            });
	    }
	
	    function drawChart () {
	        _rowData = _chart.data();
	
	        drawAxis();
	        drawGridLines();
	
	        var rows = _g.selectAll('g.' + _rowCssClass)
	            .data(_rowData);
	
	        createElements(rows);
	        removeElements(rows);
	        updateElements(rows);
	    }
	
	    function createElements (rows) {
	        var rowEnter = rows.enter()
	            .append('g')
	            .attr('class', function (d, i) {
	                return _rowCssClass + ' _' + i;
	            });
	
	        rowEnter.append('rect').attr('width', 0);
	
	        createLabels(rowEnter);
	    }
	
	    function removeElements (rows) {
	        rows.exit().remove();
	    }
	
	    function rootValue () {
	        var root = _x(0);
	        return (root === -Infinity || root !== root) ? _x(1) : root;
	    }
	
	    function updateElements (rows) {
	        var n = _rowData.length;
	
	        var height;
	        if (!_fixedBarHeight) {
	            height = (_chart.effectiveHeight() - (n + 1) * _gap) / n;
	        } else {
	            height = _fixedBarHeight;
	        }
	
	        // vertically align label in center unless they override the value via property setter
	        if (!_hasLabelOffsetY) {
	            _labelOffsetY = height / 2;
	        }
	
	        var rect = rows.attr('transform', function (d, i) {
	                return 'translate(0,' + ((i + 1) * _gap + i * height) + ')';
	            }).select('rect')
	            .attr('height', height)
	            .attr('fill', _chart.getColor)
	            .on('click', onClick)
	            .classed('deselected', function (d) {
	                return (_chart.hasFilter()) ? !isSelectedRow(d) : false;
	            })
	            .classed('selected', function (d) {
	                return (_chart.hasFilter()) ? isSelectedRow(d) : false;
	            });
	
	        dc.transition(rect, _chart.transitionDuration())
	            .attr('width', function (d) {
	                return Math.abs(rootValue() - _x(_chart.valueAccessor()(d)));
	            })
	            .attr('transform', translateX);
	
	        createTitles(rows);
	        updateLabels(rows);
	    }
	
	    function createTitles (rows) {
	        if (_chart.renderTitle()) {
	            rows.selectAll('title').remove();
	            rows.append('title').text(_chart.title());
	        }
	    }
	
	    function createLabels (rowEnter) {
	        if (_chart.renderLabel()) {
	            rowEnter.append('text')
	                .on('click', onClick);
	        }
	        if (_chart.renderTitleLabel()) {
	            rowEnter.append('text')
	                .attr('class', _titleRowCssClass)
	                .on('click', onClick);
	        }
	    }
	
	    function updateLabels (rows) {
	        if (_chart.renderLabel()) {
	            var lab = rows.select('text')
	                .attr('x', _labelOffsetX)
	                .attr('y', _labelOffsetY)
	                .attr('dy', _dyOffset)
	                .on('click', onClick)
	                .attr('class', function (d, i) {
	                    return _rowCssClass + ' _' + i;
	                })
	                .text(function (d) {
	                    return _chart.label()(d);
	                });
	            dc.transition(lab, _chart.transitionDuration())
	                .attr('transform', translateX);
	        }
	        if (_chart.renderTitleLabel()) {
	            var titlelab = rows.select('.' + _titleRowCssClass)
	                    .attr('x', _chart.effectiveWidth() - _titleLabelOffsetX)
	                    .attr('y', _labelOffsetY)
	                    .attr('dy', _dyOffset)
	                    .attr('text-anchor', 'end')
	                    .on('click', onClick)
	                    .attr('class', function (d, i) {
	                        return _titleRowCssClass + ' _' + i ;
	                    })
	                    .text(function (d) {
	                        return _chart.title()(d);
	                    });
	            dc.transition(titlelab, _chart.transitionDuration())
	                .attr('transform', translateX);
	        }
	    }
	
	    /**
	     * Turn on/off Title label rendering (values) using SVG style of text-anchor 'end'
	     * @method renderTitleLabel
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Boolean} [renderTitleLabel=false]
	     * @return {Boolean}
	     * @return {dc.rowChart}
	     */
	    _chart.renderTitleLabel = function (renderTitleLabel) {
	        if (!arguments.length) {
	            return _renderTitleLabel;
	        }
	        _renderTitleLabel = renderTitleLabel;
	        return _chart;
	    };
	
	    function onClick (d) {
	        _chart.onClick(d);
	    }
	
	    function translateX (d) {
	        var x = _x(_chart.cappedValueAccessor(d)),
	            x0 = rootValue(),
	            s = x > x0 ? x0 : x;
	        return 'translate(' + s + ',0)';
	    }
	
	    _chart._doRedraw = function () {
	        drawChart();
	        return _chart;
	    };
	
	    /**
	     * Get the x axis for the row chart instance.  Note: not settable for row charts.
	     * See the {@link https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-axis d3 axis object}
	     * documention for more information.
	     * @method xAxis
	     * @memberof dc.rowChart
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Axes#wiki-axis d3.svg.axis}
	     * @example
	     * // customize x axis tick format
	     * chart.xAxis().tickFormat(function (v) {return v + '%';});
	     * // customize x axis tick values
	     * chart.xAxis().tickValues([0, 100, 200, 300]);
	     * @return {d3.svg.axis}
	     */
	    _chart.xAxis = function () {
	        return _xAxis;
	    };
	
	    /**
	     * Get or set the fixed bar height. Default is [false] which will auto-scale bars.
	     * For example, if you want to fix the height for a specific number of bars (useful in TopN charts)
	     * you could fix height as follows (where count = total number of bars in your TopN and gap is
	     * your vertical gap space).
	     * @method fixedBarHeight
	     * @memberof dc.rowChart
	     * @instance
	     * @example
	     * chart.fixedBarHeight( chartheight - (count + 1) * gap / count);
	     * @param {Boolean|Number} [fixedBarHeight=false]
	     * @return {Boolean|Number}
	     * @return {dc.rowChart}
	     */
	    _chart.fixedBarHeight = function (fixedBarHeight) {
	        if (!arguments.length) {
	            return _fixedBarHeight;
	        }
	        _fixedBarHeight = fixedBarHeight;
	        return _chart;
	    };
	
	    /**
	     * Get or set the vertical gap space between rows on a particular row chart instance
	     * @method gap
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [gap=5]
	     * @return {Number}
	     * @return {dc.rowChart}
	     */
	    _chart.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _chart;
	    };
	
	    /**
	     * Get or set the elasticity on x axis. If this attribute is set to true, then the x axis will rescle to auto-fit the
	     * data range when filtered.
	     * @method elasticX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Boolean} [elasticX]
	     * @return {Boolean}
	     * @return {dc.rowChart}
	     */
	    _chart.elasticX = function (elasticX) {
	        if (!arguments.length) {
	            return _elasticX;
	        }
	        _elasticX = elasticX;
	        return _chart;
	    };
	
	    /**
	     * Get or set the x offset (horizontal space to the top left corner of a row) for labels on a particular row chart.
	     * @method labelOffsetX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [labelOffsetX=10]
	     * @return {Number}
	     * @return {dc.rowChart}
	     */
	    _chart.labelOffsetX = function (labelOffsetX) {
	        if (!arguments.length) {
	            return _labelOffsetX;
	        }
	        _labelOffsetX = labelOffsetX;
	        return _chart;
	    };
	
	    /**
	     * Get or set the y offset (vertical space to the top left corner of a row) for labels on a particular row chart.
	     * @method labelOffsetY
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [labelOffsety=15]
	     * @return {Number}
	     * @return {dc.rowChart}
	     */
	    _chart.labelOffsetY = function (labelOffsety) {
	        if (!arguments.length) {
	            return _labelOffsetY;
	        }
	        _labelOffsetY = labelOffsety;
	        _hasLabelOffsetY = true;
	        return _chart;
	    };
	
	    /**
	     * Get of set the x offset (horizontal space between right edge of row and right edge or text.
	     * @method titleLabelOffsetX
	     * @memberof dc.rowChart
	     * @instance
	     * @param {Number} [titleLabelOffsetX=2]
	     * @return {Number}
	     * @return {dc.rowChart}
	     */
	    _chart.titleLabelOffsetX = function (titleLabelOffsetX) {
	        if (!arguments.length) {
	            return _titleLabelOffsetX;
	        }
	        _titleLabelOffsetX = titleLabelOffsetX;
	        return _chart;
	    };
	
	    function isSelectedRow (d) {
	        return _chart.hasFilter(_chart.cappedKeyAccessor(d));
	    }
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * Legend is a attachable widget that can be added to other dc charts to render horizontal legend
	 * labels.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.com/dc.js/ Nasdaq 100 Index}
	 * - {@link http://dc-js.github.com/dc.js/crime/index.html Canadian City Crime Stats}
	 * @class legend
	 * @memberof dc
	 * @example
	 * chart.legend(dc.legend().x(400).y(10).itemHeight(13).gap(5))
	 * @return {dc.legend}
	 */
	dc.legend = function () {
	    var LABEL_GAP = 2;
	
	    var _legend = {},
	        _parent,
	        _x = 0,
	        _y = 0,
	        _itemHeight = 12,
	        _gap = 5,
	        _horizontal = false,
	        _legendWidth = 560,
	        _itemWidth = 70,
	        _autoItemWidth = false,
	        _legendText = dc.pluck('name');
	
	    var _g;
	
	    _legend.parent = function (p) {
	        if (!arguments.length) {
	            return _parent;
	        }
	        _parent = p;
	        return _legend;
	    };
	
	    _legend.render = function () {
	        _parent.svg().select('g.dc-legend').remove();
	        _g = _parent.svg().append('g')
	            .attr('class', 'dc-legend')
	            .attr('transform', 'translate(' + _x + ',' + _y + ')');
	        var legendables = _parent.legendables();
	
	        var itemEnter = _g.selectAll('g.dc-legend-item')
	            .data(legendables)
	            .enter()
	            .append('g')
	            .attr('class', 'dc-legend-item')
	            .on('mouseover', function (d) {
	                _parent.legendHighlight(d);
	            })
	            .on('mouseout', function (d) {
	                _parent.legendReset(d);
	            })
	            .on('click', function (d) {
	                d.chart.legendToggle(d);
	            });
	
	        _g.selectAll('g.dc-legend-item')
	            .classed('fadeout', function (d) {
	                return d.chart.isLegendableHidden(d);
	            });
	
	        if (legendables.some(dc.pluck('dashstyle'))) {
	            itemEnter
	                .append('line')
	                .attr('x1', 0)
	                .attr('y1', _itemHeight / 2)
	                .attr('x2', _itemHeight)
	                .attr('y2', _itemHeight / 2)
	                .attr('stroke-width', 2)
	                .attr('stroke-dasharray', dc.pluck('dashstyle'))
	                .attr('stroke', dc.pluck('color'));
	        } else {
	            itemEnter
	                .append('rect')
	                .attr('width', _itemHeight)
	                .attr('height', _itemHeight)
	                .attr('fill', function (d) {return d ? d.color : 'blue';});
	        }
	
	        itemEnter.append('text')
	                .text(_legendText)
	                .attr('x', _itemHeight + LABEL_GAP)
	                .attr('y', function () {
	                    return _itemHeight / 2 + (this.clientHeight ? this.clientHeight : 13) / 2 - 2;
	                });
	
	        var _cumulativeLegendTextWidth = 0;
	        var row = 0;
	        itemEnter.attr('transform', function (d, i) {
	            if (_horizontal) {
	                var translateBy = 'translate(' + _cumulativeLegendTextWidth + ',' + row * legendItemHeight() + ')';
	                var itemWidth   = _autoItemWidth === true ? this.getBBox().width + _gap : _itemWidth;
	
	                if ((_cumulativeLegendTextWidth + itemWidth) >= _legendWidth) {
	                    ++row ;
	                    _cumulativeLegendTextWidth = 0 ;
	                } else {
	                    _cumulativeLegendTextWidth += itemWidth;
	                }
	                return translateBy;
	            } else {
	                return 'translate(0,' + i * legendItemHeight() + ')';
	            }
	        });
	    };
	
	    function legendItemHeight () {
	        return _gap + _itemHeight;
	    }
	
	    /**
	     * Set or get x coordinate for legend widget.
	     * @method x
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [x=0]
	     * @return {Number}
	     * @return {dc.legend}
	     */
	    _legend.x = function (x) {
	        if (!arguments.length) {
	            return _x;
	        }
	        _x = x;
	        return _legend;
	    };
	
	    /**
	     * Set or get y coordinate for legend widget.
	     * @method y
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [y=0]
	     * @return {Number}
	     * @return {dc.legend}
	     */
	    _legend.y = function (y) {
	        if (!arguments.length) {
	            return _y;
	        }
	        _y = y;
	        return _legend;
	    };
	
	    /**
	     * Set or get gap between legend items.
	     * @method gap
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [gap=5]
	     * @return {Number}
	     * @return {dc.legend}
	     */
	    _legend.gap = function (gap) {
	        if (!arguments.length) {
	            return _gap;
	        }
	        _gap = gap;
	        return _legend;
	    };
	
	    /**
	     * Set or get legend item height.
	     * @method itemHeight
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [itemHeight=12]
	     * @return {Number}
	     * @return {dc.legend}
	     */
	    _legend.itemHeight = function (itemHeight) {
	        if (!arguments.length) {
	            return _itemHeight;
	        }
	        _itemHeight = itemHeight;
	        return _legend;
	    };
	
	    /**
	     * Position legend horizontally instead of vertically.
	     * @method horizontal
	     * @memberof dc.legend
	     * @instance
	     * @param  {Boolean} [horizontal=false]
	     * @return {Boolean}
	     * @return {dc.legend}
	     */
	    _legend.horizontal = function (horizontal) {
	        if (!arguments.length) {
	            return _horizontal;
	        }
	        _horizontal = horizontal;
	        return _legend;
	    };
	
	    /**
	     * Maximum width for horizontal legend.
	     * @method legendWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [legendWidth=500]
	     * @return {Number}
	     * @return {dc.legend}
	     */
	    _legend.legendWidth = function (legendWidth) {
	        if (!arguments.length) {
	            return _legendWidth;
	        }
	        _legendWidth = legendWidth;
	        return _legend;
	    };
	
	    /**
	     * legendItem width for horizontal legend.
	     * @method itemWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Number} [itemWidth=70]
	     * @return {Number}
	     * @return {dc.legend}
	     */
	    _legend.itemWidth = function (itemWidth) {
	        if (!arguments.length) {
	            return _itemWidth;
	        }
	        _itemWidth = itemWidth;
	        return _legend;
	    };
	
	    /**
	     * Turn automatic width for legend items on or off. If true, {@link dc.legend#itemWidth itemWidth} is ignored.
	     * This setting takes into account {@link dc.legend#gap gap}.
	     * @method autoItemWidth
	     * @memberof dc.legend
	     * @instance
	     * @param  {Boolean} [autoItemWidth=false]
	     * @return {Boolean}
	     * @return {dc.legend}
	     */
	    _legend.autoItemWidth = function (autoItemWidth) {
	        if (!arguments.length) {
	            return _autoItemWidth;
	        }
	        _autoItemWidth = autoItemWidth;
	        return _legend;
	    };
	
	    /**
	     * Set or get the legend text function. The legend widget uses this function to render the legend
	     * text for each item. If no function is specified the legend widget will display the names
	     * associated with each group.
	     * @method legendText
	     * @memberof dc.legend
	     * @instance
	     * @param  {Function} [legendText]
	     * @return {Function}
	     * @return {dc.legend}
	     * @example
	     * // default legendText
	     * legend.legendText(dc.pluck('name'))
	     *
	     * // create numbered legend items
	     * chart.legend(dc.legend().legendText(function(d, i) { return i + '. ' + d.name; }))
	     *
	     * // create legend displaying group counts
	     * chart.legend(dc.legend().legendText(function(d) { return d.name + ': ' d.data; }))
	     **/
	    _legend.legendText = function (legendText) {
	        if (!arguments.length) {
	            return _legendText;
	        }
	        _legendText = legendText;
	        return _legend;
	    };
	
	    return _legend;
	};
	
	/**
	 * A scatter plot chart
	 *
	 * Examples:
	 * - {@link http://dc-js.github.io/dc.js/examples/scatter.html Scatter Chart}
	 * - {@link http://dc-js.github.io/dc.js/examples/multi-scatter.html Multi-Scatter Chart}
	 * @class scatterPlot
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a scatter plot under #chart-container1 element using the default global chart group
	 * var chart1 = dc.scatterPlot('#chart-container1');
	 * // create a scatter plot under #chart-container2 element using chart group A
	 * var chart2 = dc.scatterPlot('#chart-container2', 'chartGroupA');
	 * // create a sub-chart under a composite parent chart
	 * var chart3 = dc.scatterPlot(compositeChart);
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.scatterPlot}
	 */
	dc.scatterPlot = function (parent, chartGroup) {
	    var _chart = dc.coordinateGridMixin({});
	    var _symbol = d3.svg.symbol();
	
	    var _existenceAccessor = function (d) { return d.value; };
	
	    var originalKeyAccessor = _chart.keyAccessor();
	    _chart.keyAccessor(function (d) { return originalKeyAccessor(d)[0]; });
	    _chart.valueAccessor(function (d) { return originalKeyAccessor(d)[1]; });
	    _chart.colorAccessor(function () { return _chart._groupName; });
	
	    var _locator = function (d) {
	        return 'translate(' + _chart.x()(_chart.keyAccessor()(d)) + ',' +
	            _chart.y()(_chart.valueAccessor()(d)) + ')';
	    };
	
	    var _highlightedSize = 7;
	    var _symbolSize = 5;
	    var _excludedSize = 3;
	    var _excludedColor = null;
	    var _excludedOpacity = 1.0;
	    var _emptySize = 0;
	    var _filtered = [];
	
	    _symbol.size(function (d, i) {
	        if (!_existenceAccessor(d)) {
	            return _emptySize;
	        } else if (_filtered[i]) {
	            return Math.pow(_symbolSize, 2);
	        } else {
	            return Math.pow(_excludedSize, 2);
	        }
	    });
	
	    dc.override(_chart, '_filter', function (filter) {
	        if (!arguments.length) {
	            return _chart.__filter();
	        }
	
	        return _chart.__filter(dc.filters.RangedTwoDimensionalFilter(filter));
	    });
	
	    _chart.plotData = function () {
	        var symbols = _chart.chartBodyG().selectAll('path.symbol')
	                .data(_chart.data());
	
	        symbols
	            .enter()
	            .append('path')
	            .attr('class', 'symbol')
	            .attr('opacity', 0)
	            .attr('fill', _chart.getColor)
	            .attr('transform', _locator);
	
	        symbols.each(function (d, i) {
	            _filtered[i] = !_chart.filter() || _chart.filter().isFiltered([d.key[0], d.key[1]]);
	        });
	
	        dc.transition(symbols, _chart.transitionDuration())
	            .attr('opacity', function (d, i) {
	                return !_existenceAccessor(d) ? 0 :
	                    _filtered[i] ? 1 : _chart.excludedOpacity();
	            })
	            .attr('fill', function (d, i) {
	                return _chart.excludedColor() && !_filtered[i] ?
	                    _chart.excludedColor() :
	                    _chart.getColor(d);
	            })
	            .attr('transform', _locator)
	            .attr('d', _symbol);
	
	        dc.transition(symbols.exit(), _chart.transitionDuration())
	            .attr('opacity', 0).remove();
	    };
	
	    /**
	     * Get or set the existence accessor.  If a point exists, it is drawn with
	     * {@link dc.scatterPlot#symbolSize symbolSize} radius and
	     * opacity 1; if it does not exist, it is drawn with
	     * {@link dc.scatterPlot#emptySize emptySize} radius and opacity 0. By default,
	     * the existence accessor checks if the reduced value is truthy.
	     * @method existenceAccessor
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link dc.scatterPlot#symbolSize symbolSize}
	     * @see {@link dc.scatterPlot#emptySize emptySize}
	     * @example
	     * // default accessor
	     * chart.existenceAccessor(function (d) { return d.value; });
	     * @param {Function} [accessor]
	     * @return {Function}
	     * @return {dc.scatterPlot}
	     */
	    _chart.existenceAccessor = function (accessor) {
	        if (!arguments.length) {
	            return _existenceAccessor;
	        }
	        _existenceAccessor = accessor;
	        return this;
	    };
	
	    /**
	     * Get or set the symbol type used for each point. By default the symbol is a circle.
	     * Type can be a constant or an accessor.
	     * @method symbol
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#symbol_type d3.svg.symbol().type()}
	     * @example
	     * // Circle type
	     * chart.symbol('circle');
	     * // Square type
	     * chart.symbol('square');
	     * @param {String|Function} [type='circle']
	     * @return {String|Function}
	     * @return {dc.scatterPlot}
	     */
	    _chart.symbol = function (type) {
	        if (!arguments.length) {
	            return _symbol.type();
	        }
	        _symbol.type(type);
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for symbols.
	     * @method symbolSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#symbol_size d3.svg.symbol().size()}
	     * @param {Number} [symbolSize=3]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.symbolSize = function (symbolSize) {
	        if (!arguments.length) {
	            return _symbolSize;
	        }
	        _symbolSize = symbolSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for highlighted symbols.
	     * @method highlightedSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#symbol_size d3.svg.symbol().size()}
	     * @param {Number} [highlightedSize=5]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.highlightedSize = function (highlightedSize) {
	        if (!arguments.length) {
	            return _highlightedSize;
	        }
	        _highlightedSize = highlightedSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get size for symbols excluded from this chart's filter. If null, no
	     * special size is applied for symbols based on their filter status
	     * @method excludedSize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#symbol_size d3.svg.symbol().size()}
	     * @param {Number} [excludedSize=null]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.excludedSize = function (excludedSize) {
	        if (!arguments.length) {
	            return _excludedSize;
	        }
	        _excludedSize = excludedSize;
	        return _chart;
	    };
	
	    /**
	     * Set or get color for symbols excluded from this chart's filter. If null, no
	     * special color is applied for symbols based on their filter status
	     * @method excludedColor
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#symbol_size d3.svg.symbol().size()}
	     * @param {Number} [excludedColor=null]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.excludedColor = function (excludedColor) {
	        if (!arguments.length) {
	            return _excludedColor;
	        }
	        _excludedColor = excludedColor;
	        return _chart;
	    };
	
	    /**
	     * Set or get opacity for symbols excluded from this chart's filter.
	     * @method excludedOpacity
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#symbol_size d3.svg.symbol().size()}
	     * @param {Number} [excludedOpacity=1.0]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.excludedOpacity = function (excludedOpacity) {
	        if (!arguments.length) {
	            return _excludedOpacity;
	        }
	        _excludedOpacity = excludedOpacity;
	        return _chart;
	    };
	
	    /**
	     * Set or get radius for symbols when the group is empty.
	     * @method emptySize
	     * @memberof dc.scatterPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/SVG-Shapes#symbol_size d3.svg.symbol().size()}
	     * @param {Number} [emptySize=0]
	     * @return {Number}
	     * @return {dc.scatterPlot}
	     */
	    _chart.hiddenSize = _chart.emptySize = function (emptySize) {
	        if (!arguments.length) {
	            return _emptySize;
	        }
	        _emptySize = emptySize;
	        return _chart;
	    };
	
	    _chart.legendables = function () {
	        return [{chart: _chart, name: _chart._groupName, color: _chart.getColor()}];
	    };
	
	    _chart.legendHighlight = function (d) {
	        resizeSymbolsWhere(function (symbol) {
	            return symbol.attr('fill') === d.color;
	        }, _highlightedSize);
	        _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return d3.select(this).attr('fill') !== d.color;
	        }).classed('fadeout', true);
	    };
	
	    _chart.legendReset = function (d) {
	        resizeSymbolsWhere(function (symbol) {
	            return symbol.attr('fill') === d.color;
	        }, _symbolSize);
	        _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return d3.select(this).attr('fill') !== d.color;
	        }).classed('fadeout', false);
	    };
	
	    function resizeSymbolsWhere (condition, size) {
	        var symbols = _chart.selectAll('.chart-body path.symbol').filter(function () {
	            return condition(d3.select(this));
	        });
	        var oldSize = _symbol.size();
	        _symbol.size(Math.pow(size, 2));
	        dc.transition(symbols, _chart.transitionDuration()).attr('d', _symbol);
	        _symbol.size(oldSize);
	    }
	
	    _chart.setHandlePaths = function () {
	        // no handle paths for poly-brushes
	    };
	
	    _chart.extendBrush = function () {
	        var extent = _chart.brush().extent();
	        if (_chart.round()) {
	            extent[0] = extent[0].map(_chart.round());
	            extent[1] = extent[1].map(_chart.round());
	
	            _chart.g().select('.brush')
	                .call(_chart.brush().extent(extent));
	        }
	        return extent;
	    };
	
	    _chart.brushIsEmpty = function (extent) {
	        return _chart.brush().empty() || !extent || extent[0][0] >= extent[1][0] || extent[0][1] >= extent[1][1];
	    };
	
	    _chart._brushing = function () {
	        var extent = _chart.extendBrush();
	
	        _chart.redrawBrush(_chart.g());
	
	        if (_chart.brushIsEmpty(extent)) {
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.redrawGroup();
	            });
	
	        } else {
	            var ranged2DFilter = dc.filters.RangedTwoDimensionalFilter(extent);
	            dc.events.trigger(function () {
	                _chart.filter(null);
	                _chart.filter(ranged2DFilter);
	                _chart.redrawGroup();
	            }, dc.constants.EVENT_DELAY);
	
	        }
	    };
	
	    _chart.setBrushY = function (gBrush) {
	        gBrush.call(_chart.brush().y(_chart.y()));
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A display of a single numeric value.
	 * Unlike other charts, you do not need to set a dimension. Instead a group object must be provided and
	 * a valueAccessor that returns a single value.
	 * @class numberDisplay
	 * @memberof dc
	 * @mixes dc.baseMixin
	 * @example
	 * // create a number display under #chart-container1 element using the default global chart group
	 * var display1 = dc.numberDisplay('#chart-container1');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.numberDisplay}
	 */
	dc.numberDisplay = function (parent, chartGroup) {
	    var SPAN_CLASS = 'number-display';
	    var _formatNumber = d3.format('.2s');
	    var _chart = dc.baseMixin({});
	    var _html = {one: '', some: '', none: ''};
	    var _lastValue;
	
	    // dimension not required
	    _chart._mandatoryAttributes(['group']);
	
	    /**
	     * Gets or sets an optional object specifying HTML templates to use depending on the number
	     * displayed.  The text `%number` will be replaced with the current value.
	     * - one: HTML template to use if the number is 1
	     * - zero: HTML template to use if the number is 0
	     * - some: HTML template to use otherwise
	     * @method html
	     * @memberof dc.numberDisplay
	     * @instance
	     * @example
	     * numberWidget.html({
	     *      one:'%number record',
	     *      some:'%number records',
	     *      none:'no records'})
	     * @param {{one:String, some:String, none:String}} [html={one: '', some: '', none: ''}]
	     * @return {{one:String, some:String, none:String}}
	     * @return {dc.numberDisplay}
	     */
	    _chart.html = function (html) {
	        if (!arguments.length) {
	            return _html;
	        }
	        if (html.none) {
	            _html.none = html.none;//if none available
	        } else if (html.one) {
	            _html.none = html.one;//if none not available use one
	        } else if (html.some) {
	            _html.none = html.some;//if none and one not available use some
	        }
	        if (html.one) {
	            _html.one = html.one;//if one available
	        } else if (html.some) {
	            _html.one = html.some;//if one not available use some
	        }
	        if (html.some) {
	            _html.some = html.some;//if some available
	        } else if (html.one) {
	            _html.some = html.one;//if some not available use one
	        }
	        return _chart;
	    };
	
	    /**
	     * Calculate and return the underlying value of the display
	     * @method value
	     * @memberof dc.numberDisplay
	     * @instance
	     * @return {Number}
	     */
	    _chart.value = function () {
	        return _chart.data();
	    };
	
	    _chart.data(function (group) {
	        var valObj = group.value ? group.value() : group.top(1)[0];
	        return _chart.valueAccessor()(valObj);
	    });
	
	    _chart.transitionDuration(250); // good default
	
	    _chart._doRender = function () {
	        var newValue = _chart.value(),
	            span = _chart.selectAll('.' + SPAN_CLASS);
	
	        if (span.empty()) {
	            span = span.data([0])
	                .enter()
	                .append('span')
	                .attr('class', SPAN_CLASS);
	        }
	
	        span.transition()
	            .duration(_chart.transitionDuration())
	            .ease('quad-out-in')
	            .tween('text', function () {
	                // [XA] don't try and interpolate from Infinity, else this breaks.
	                var interpStart = isFinite(_lastValue) ? _lastValue : 0;
	                var interp = d3.interpolateNumber(interpStart || 0, newValue);
	                _lastValue = newValue;
	                return function (t) {
	                    var html = null, num = _chart.formatNumber()(interp(t));
	                    if (newValue === 0 && (_html.none !== '')) {
	                        html = _html.none;
	                    } else if (newValue === 1 && (_html.one !== '')) {
	                        html = _html.one;
	                    } else if (_html.some !== '') {
	                        html = _html.some;
	                    }
	                    this.innerHTML = html ? html.replace('%number', num) : num;
	                };
	            });
	    };
	
	    _chart._doRedraw = function () {
	        return _chart._doRender();
	    };
	
	    /**
	     * Get or set a function to format the value for the display.
	     * @method formatNumber
	     * @memberof dc.numberDisplay
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Formatting d3.format}
	     * @param {Function} [formatter=d3.format('.2s')]
	     * @return {Function}
	     * @return {dc.numberDisplay}
	     */
	    _chart.formatNumber = function (formatter) {
	        if (!arguments.length) {
	            return _formatNumber;
	        }
	        _formatNumber = formatter;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	/**
	 * A heat map is matrix that represents the values of two dimensions of data using colors.
	 * @class heatMap
	 * @memberof dc
	 * @mixes dc.colorMixin
	 * @mixes dc.marginMixin
	 * @mixes dc.baseMixin
	 * @example
	 * // create a heat map under #chart-container1 element using the default global chart group
	 * var heatMap1 = dc.heatMap('#chart-container1');
	 * // create a heat map under #chart-container2 element using chart group A
	 * var heatMap2 = dc.heatMap('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.heatMap}
	 */
	dc.heatMap = function (parent, chartGroup) {
	
	    var DEFAULT_BORDER_RADIUS = 6.75;
	
	    var _chartBody;
	
	    var _cols;
	    var _rows;
	    var _xBorderRadius = DEFAULT_BORDER_RADIUS;
	    var _yBorderRadius = DEFAULT_BORDER_RADIUS;
	
	    var _chart = dc.colorMixin(dc.marginMixin(dc.baseMixin({})));
	    _chart._mandatoryAttributes(['group']);
	    _chart.title(_chart.colorAccessor());
	
	    var _colsLabel = function (d) {
	        return d;
	    };
	    var _rowsLabel = function (d) {
	        return d;
	    };
	
	    /**
	     * Set or get the column label function. The chart class uses this function to render
	     * column labels on the X axis. It is passed the column name.
	     * @method colsLabel
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // the default label function just returns the name
	     * chart.colsLabel(function(d) { return d; });
	     * @param  {Function} [labelFunction=function(d) { return d; }]
	     * @return {Function}
	     * @return {dc.heatMap}
	     */
	    _chart.colsLabel = function (labelFunction) {
	        if (!arguments.length) {
	            return _colsLabel;
	        }
	        _colsLabel = labelFunction;
	        return _chart;
	    };
	
	    /**
	     * Set or get the row label function. The chart class uses this function to render
	     * row labels on the Y axis. It is passed the row name.
	     * @method rowsLabel
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // the default label function just returns the name
	     * chart.rowsLabel(function(d) { return d; });
	     * @param  {Function} [labelFunction=function(d) { return d; }]
	     * @return {Function}
	     * @return {dc.heatMap}
	     */
	    _chart.rowsLabel = function (labelFunction) {
	        if (!arguments.length) {
	            return _rowsLabel;
	        }
	        _rowsLabel = labelFunction;
	        return _chart;
	    };
	
	    var _xAxisOnClick = function (d) { filterAxis(0, d); };
	    var _yAxisOnClick = function (d) { filterAxis(1, d); };
	    var _boxOnClick = function (d) {
	        var filter = d.key;
	        dc.events.trigger(function () {
	            _chart.filter(filter);
	            _chart.redrawGroup();
	        });
	    };
	
	    function filterAxis (axis, value) {
	        var cellsOnAxis = _chart.selectAll('.box-group').filter(function (d) {
	            return d.key[axis] === value;
	        });
	        var unfilteredCellsOnAxis = cellsOnAxis.filter(function (d) {
	            return !_chart.hasFilter(d.key);
	        });
	        dc.events.trigger(function () {
	            if (unfilteredCellsOnAxis.empty()) {
	                cellsOnAxis.each(function (d) {
	                    _chart.filter(d.key);
	                });
	            } else {
	                unfilteredCellsOnAxis.each(function (d) {
	                    _chart.filter(d.key);
	                });
	            }
	            _chart.redrawGroup();
	        });
	    }
	
	    dc.override(_chart, 'filter', function (filter) {
	        if (!arguments.length) {
	            return _chart._filter();
	        }
	
	        return _chart._filter(dc.filters.TwoDimensionalFilter(filter));
	    });
	
	    function uniq (d, i, a) {
	        return !i || a[i - 1] !== d;
	    }
	
	    /**
	     * Gets or sets the values used to create the rows of the heatmap, as an array. By default, all
	     * the values will be fetched from the data using the value accessor, and they will be sorted in
	     * ascending order.
	     * @method rows
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Array<String|Number>} [rows]
	     * @return {Array<String|Number>}
	     * @return {dc.heatMap}
	     */
	    _chart.rows = function (rows) {
	        if (arguments.length) {
	            _rows = rows;
	            return _chart;
	        }
	        if (_rows) {
	            return _rows;
	        }
	        var rowValues = _chart.data().map(_chart.valueAccessor());
	        rowValues.sort(d3.ascending);
	        return d3.scale.ordinal().domain(rowValues.filter(uniq));
	    };
	
	    /**
	     * Gets or sets the keys used to create the columns of the heatmap, as an array. By default, all
	     * the values will be fetched from the data using the key accessor, and they will be sorted in
	     * ascending order.
	     * @method cols
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Array<String|Number>} [cols]
	     * @return {Array<String|Number>}
	     * @return {dc.heatMap}
	     */
	    _chart.cols = function (cols) {
	        if (arguments.length) {
	            _cols = cols;
	            return _chart;
	        }
	        if (_cols) {
	            return _cols;
	        }
	        var colValues = _chart.data().map(_chart.keyAccessor());
	        colValues.sort(d3.ascending);
	        return d3.scale.ordinal().domain(colValues.filter(uniq));
	    };
	
	    _chart._doRender = function () {
	        _chart.resetSvg();
	
	        _chartBody = _chart.svg()
	            .append('g')
	            .attr('class', 'heatmap')
	            .attr('transform', 'translate(' + _chart.margins().left + ',' + _chart.margins().top + ')');
	
	        return _chart._doRedraw();
	    };
	
	    _chart._doRedraw = function () {
	        var rows = _chart.rows(),
	            cols = _chart.cols(),
	            rowCount = rows.domain().length,
	            colCount = cols.domain().length,
	            boxWidth = Math.floor(_chart.effectiveWidth() / colCount),
	            boxHeight = Math.floor(_chart.effectiveHeight() / rowCount);
	
	        cols.rangeRoundBands([0, _chart.effectiveWidth()]);
	        rows.rangeRoundBands([_chart.effectiveHeight(), 0]);
	
	        var boxes = _chartBody.selectAll('g.box-group').data(_chart.data(), function (d, i) {
	            return _chart.keyAccessor()(d, i) + '\0' + _chart.valueAccessor()(d, i);
	        });
	        var gEnter = boxes.enter().append('g')
	            .attr('class', 'box-group');
	
	        gEnter.append('rect')
	            .attr('class', 'heat-box')
	            .attr('fill', 'white')
	            .on('click', _chart.boxOnClick());
	
	        if (_chart.renderTitle()) {
	            gEnter.append('title');
	            boxes.selectAll('title').text(_chart.title());
	        }
	
	        dc.transition(boxes.selectAll('rect'), _chart.transitionDuration())
	            .attr('x', function (d, i) { return cols(_chart.keyAccessor()(d, i)); })
	            .attr('y', function (d, i) { return rows(_chart.valueAccessor()(d, i)); })
	            .attr('rx', _xBorderRadius)
	            .attr('ry', _yBorderRadius)
	            .attr('fill', _chart.getColor)
	            .attr('width', boxWidth)
	            .attr('height', boxHeight);
	
	        boxes.exit().remove();
	
	        var gCols = _chartBody.selectAll('g.cols');
	        if (gCols.empty()) {
	            gCols = _chartBody.append('g').attr('class', 'cols axis');
	        }
	        var gColsText = gCols.selectAll('text').data(cols.domain());
	        gColsText.enter().append('text')
	              .attr('x', function (d) { return cols(d) + boxWidth / 2; })
	              .style('text-anchor', 'middle')
	              .attr('y', _chart.effectiveHeight())
	              .attr('dy', 12)
	              .on('click', _chart.xAxisOnClick())
	              .text(_chart.colsLabel());
	        dc.transition(gColsText, _chart.transitionDuration())
	               .text(_chart.colsLabel())
	               .attr('x', function (d) { return cols(d) + boxWidth / 2; })
	               .attr('y', _chart.effectiveHeight());
	        gColsText.exit().remove();
	        var gRows = _chartBody.selectAll('g.rows');
	        if (gRows.empty()) {
	            gRows = _chartBody.append('g').attr('class', 'rows axis');
	        }
	        var gRowsText = gRows.selectAll('text').data(rows.domain());
	        gRowsText.enter().append('text')
	              .attr('dy', 6)
	              .style('text-anchor', 'end')
	              .attr('x', 0)
	              .attr('dx', -2)
	              .on('click', _chart.yAxisOnClick())
	              .text(_chart.rowsLabel());
	        dc.transition(gRowsText, _chart.transitionDuration())
	              .text(_chart.rowsLabel())
	              .attr('y', function (d) { return rows(d) + boxHeight / 2; });
	        gRowsText.exit().remove();
	
	        if (_chart.hasFilter()) {
	            _chart.selectAll('g.box-group').each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.selectAll('g.box-group').each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when an individual cell is clicked in the heatmap.
	     * By default, filtering of the cell will be toggled.
	     * @method boxOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @example
	     * // default box on click handler
	     * chart.boxOnClick(function (d) {
	     *     var filter = d.key;
	     *     dc.events.trigger(function () {
	     *         _chart.filter(filter);
	     *         _chart.redrawGroup();
	     *     });
	     * });
	     * @param  {Function} [handler]
	     * @return {Function}
	     * @return {dc.heatMap}
	     */
	    _chart.boxOnClick = function (handler) {
	        if (!arguments.length) {
	            return _boxOnClick;
	        }
	        _boxOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when a column tick is clicked in the x axis.
	     * By default, if any cells in the column are unselected, the whole column will be selected,
	     * otherwise the whole column will be unselected.
	     * @method xAxisOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Function} [handler]
	     * @return {Function}
	     * @return {dc.heatMap}
	     */
	    _chart.xAxisOnClick = function (handler) {
	        if (!arguments.length) {
	            return _xAxisOnClick;
	        }
	        _xAxisOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the handler that fires when a row tick is clicked in the y axis.
	     * By default, if any cells in the row are unselected, the whole row will be selected,
	     * otherwise the whole row will be unselected.
	     * @method yAxisOnClick
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Function} [handler]
	     * @return {Function}
	     * @return {dc.heatMap}
	     */
	    _chart.yAxisOnClick = function (handler) {
	        if (!arguments.length) {
	            return _yAxisOnClick;
	        }
	        _yAxisOnClick = handler;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the X border radius.  Set to 0 to get full rectangles.
	     * @method xBorderRadius
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Number} [xBorderRadius=6.75]
	     * @return {Number}
	     * @return {dc.heatMap}
	     */
	    _chart.xBorderRadius = function (xBorderRadius) {
	        if (!arguments.length) {
	            return _xBorderRadius;
	        }
	        _xBorderRadius = xBorderRadius;
	        return _chart;
	    };
	
	    /**
	     * Gets or sets the Y border radius.  Set to 0 to get full rectangles.
	     * @method yBorderRadius
	     * @memberof dc.heatMap
	     * @instance
	     * @param  {Number} [yBorderRadius=6.75]
	     * @return {Number}
	     * @return {dc.heatMap}
	     */
	    _chart.yBorderRadius = function (yBorderRadius) {
	        if (!arguments.length) {
	            return _yBorderRadius;
	        }
	        _yBorderRadius = yBorderRadius;
	        return _chart;
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	// https://github.com/d3/d3-plugins/blob/master/box/box.js
	(function () {
	
	    // Inspired by http://informationandvisualization.de/blog/box-plot
	    d3.box = function () {
	        var width = 1,
	            height = 1,
	            duration = 0,
	            domain = null,
	            value = Number,
	            whiskers = boxWhiskers,
	            quartiles = boxQuartiles,
	            tickFormat = null;
	
	        // For each small multiple…
	        function box (g) {
	            g.each(function (d, i) {
	                d = d.map(value).sort(d3.ascending);
	                var g = d3.select(this),
	                    n = d.length,
	                    min = d[0],
	                    max = d[n - 1];
	
	                // Compute quartiles. Must return exactly 3 elements.
	                var quartileData = d.quartiles = quartiles(d);
	
	                // Compute whiskers. Must return exactly 2 elements, or null.
	                var whiskerIndices = whiskers && whiskers.call(this, d, i),
	                    whiskerData = whiskerIndices && whiskerIndices.map(function (i) { return d[i]; });
	
	                // Compute outliers. If no whiskers are specified, all data are 'outliers'.
	                // We compute the outliers as indices, so that we can join across transitions!
	                var outlierIndices = whiskerIndices ?
	                    d3.range(0, whiskerIndices[0]).concat(d3.range(whiskerIndices[1] + 1, n)) : d3.range(n);
	
	                // Compute the new x-scale.
	                var x1 = d3.scale.linear()
	                    .domain(domain && domain.call(this, d, i) || [min, max])
	                    .range([height, 0]);
	
	                // Retrieve the old x-scale, if this is an update.
	                var x0 = this.__chart__ || d3.scale.linear()
	                    .domain([0, Infinity])
	                    .range(x1.range());
	
	                // Stash the new scale.
	                this.__chart__ = x1;
	
	                // Note: the box, median, and box tick elements are fixed in number,
	                // so we only have to handle enter and update. In contrast, the outliers
	                // and other elements are variable, so we need to exit them! Variable
	                // elements also fade in and out.
	
	                // Update center line: the vertical line spanning the whiskers.
	                var center = g.selectAll('line.center')
	                    .data(whiskerData ? [whiskerData] : []);
	
	                center.enter().insert('line', 'rect')
	                    .attr('class', 'center')
	                    .attr('x1', width / 2)
	                    .attr('y1', function (d) { return x0(d[0]); })
	                    .attr('x2', width / 2)
	                    .attr('y2', function (d) { return x0(d[1]); })
	                    .style('opacity', 1e-6)
	                  .transition()
	                    .duration(duration)
	                    .style('opacity', 1)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); });
	
	                center.transition()
	                    .duration(duration)
	                    .style('opacity', 1)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); });
	
	                center.exit().transition()
	                    .duration(duration)
	                    .style('opacity', 1e-6)
	                    .attr('y1', function (d) { return x1(d[0]); })
	                    .attr('y2', function (d) { return x1(d[1]); })
	                    .remove();
	
	                // Update innerquartile box.
	                var box = g.selectAll('rect.box')
	                    .data([quartileData]);
	
	                box.enter().append('rect')
	                    .attr('class', 'box')
	                    .attr('x', 0)
	                    .attr('y', function (d) { return x0(d[2]); })
	                    .attr('width', width)
	                    .attr('height', function (d) { return x0(d[0]) - x0(d[2]); })
	                  .transition()
	                    .duration(duration)
	                    .attr('y', function (d) { return x1(d[2]); })
	                    .attr('height', function (d) { return x1(d[0]) - x1(d[2]); });
	
	                box.transition()
	                    .duration(duration)
	                    .attr('y', function (d) { return x1(d[2]); })
	                    .attr('height', function (d) { return x1(d[0]) - x1(d[2]); });
	
	                // Update median line.
	                var medianLine = g.selectAll('line.median')
	                    .data([quartileData[1]]);
	
	                medianLine.enter().append('line')
	                    .attr('class', 'median')
	                    .attr('x1', 0)
	                    .attr('y1', x0)
	                    .attr('x2', width)
	                    .attr('y2', x0)
	                    .transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1);
	
	                medianLine.transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1);
	
	                // Update whiskers.
	                var whisker = g.selectAll('line.whisker')
	                    .data(whiskerData || []);
	
	                whisker.enter().insert('line', 'circle, text')
	                    .attr('class', 'whisker')
	                    .attr('x1', 0)
	                    .attr('y1', x0)
	                    .attr('x2', width)
	                    .attr('y2', x0)
	                    .style('opacity', 1e-6)
	                  .transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1);
	
	                whisker.transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1);
	
	                whisker.exit().transition()
	                    .duration(duration)
	                    .attr('y1', x1)
	                    .attr('y2', x1)
	                    .style('opacity', 1e-6)
	                    .remove();
	
	                // Update outliers.
	                var outlier = g.selectAll('circle.outlier')
	                    .data(outlierIndices, Number);
	
	                outlier.enter().insert('circle', 'text')
	                    .attr('class', 'outlier')
	                    .attr('r', 5)
	                    .attr('cx', width / 2)
	                    .attr('cy', function (i) { return x0(d[i]); })
	                    .style('opacity', 1e-6)
	                    .transition()
	                    .duration(duration)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1);
	
	                outlier.transition()
	                    .duration(duration)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1);
	
	                outlier.exit().transition()
	                    .duration(duration)
	                    .attr('cy', function (i) { return x1(d[i]); })
	                    .style('opacity', 1e-6)
	                    .remove();
	
	                // Compute the tick format.
	                var format = tickFormat || x1.tickFormat(8);
	
	                // Update box ticks.
	                var boxTick = g.selectAll('text.box')
	                    .data(quartileData);
	
	                boxTick.enter().append('text')
	                    .attr('class', 'box')
	                    .attr('dy', '.3em')
	                    .attr('dx', function (d, i) { return i & 1 ? 6 : -6; })
	                    .attr('x', function (d, i) { return i & 1 ? width : 0; })
	                    .attr('y', x0)
	                    .attr('text-anchor', function (d, i) { return i & 1 ? 'start' : 'end'; })
	                    .text(format)
	                    .transition()
	                    .duration(duration)
	                    .attr('y', x1);
	
	                boxTick.transition()
	                    .duration(duration)
	                    .text(format)
	                    .attr('y', x1);
	
	                // Update whisker ticks. These are handled separately from the box
	                // ticks because they may or may not exist, and we want don't want
	                // to join box ticks pre-transition with whisker ticks post-.
	                var whiskerTick = g.selectAll('text.whisker')
	                    .data(whiskerData || []);
	
	                whiskerTick.enter().append('text')
	                    .attr('class', 'whisker')
	                    .attr('dy', '.3em')
	                    .attr('dx', 6)
	                    .attr('x', width)
	                    .attr('y', x0)
	                    .text(format)
	                    .style('opacity', 1e-6)
	                    .transition()
	                    .duration(duration)
	                    .attr('y', x1)
	                    .style('opacity', 1);
	
	                whiskerTick.transition()
	                    .duration(duration)
	                    .text(format)
	                    .attr('y', x1)
	                    .style('opacity', 1);
	
	                whiskerTick.exit().transition()
	                    .duration(duration)
	                    .attr('y', x1)
	                    .style('opacity', 1e-6)
	                    .remove();
	            });
	            d3.timer.flush();
	        }
	
	        box.width = function (x) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = x;
	            return box;
	        };
	
	        box.height = function (x) {
	            if (!arguments.length) {
	                return height;
	            }
	            height = x;
	            return box;
	        };
	
	        box.tickFormat = function (x) {
	            if (!arguments.length) {
	                return tickFormat;
	            }
	            tickFormat = x;
	            return box;
	        };
	
	        box.duration = function (x) {
	            if (!arguments.length) {
	                return duration;
	            }
	            duration = x;
	            return box;
	        };
	
	        box.domain = function (x) {
	            if (!arguments.length) {
	                return domain;
	            }
	            domain = x === null ? x : d3.functor(x);
	            return box;
	        };
	
	        box.value = function (x) {
	            if (!arguments.length) {
	                return value;
	            }
	            value = x;
	            return box;
	        };
	
	        box.whiskers = function (x) {
	            if (!arguments.length) {
	                return whiskers;
	            }
	            whiskers = x;
	            return box;
	        };
	
	        box.quartiles = function (x) {
	            if (!arguments.length) {
	                return quartiles;
	            }
	            quartiles = x;
	            return box;
	        };
	
	        return box;
	    };
	
	    function boxWhiskers (d) {
	        return [0, d.length - 1];
	    }
	
	    function boxQuartiles (d) {
	        return [
	            d3.quantile(d, 0.25),
	            d3.quantile(d, 0.5),
	            d3.quantile(d, 0.75)
	        ];
	    }
	
	})();
	
	/**
	 * A box plot is a chart that depicts numerical data via their quartile ranges.
	 *
	 * Examples:
	 * - {@link http://dc-js.github.io/dc.js/examples/box-plot-time.html Box plot time example}
	 * - {@link http://dc-js.github.io/dc.js/examples/box-plot.html Box plot example}
	 * @class boxPlot
	 * @memberof dc
	 * @mixes dc.coordinateGridMixin
	 * @example
	 * // create a box plot under #chart-container1 element using the default global chart group
	 * var boxPlot1 = dc.boxPlot('#chart-container1');
	 * // create a box plot under #chart-container2 element using chart group A
	 * var boxPlot2 = dc.boxPlot('#chart-container2', 'chartGroupA');
	 * @param {String|node|d3.selection} parent - Any valid
	 * {@link https://github.com/mbostock/d3/wiki/Selections#selecting-elements d3 single selector} specifying
	 * a dom block element such as a div; or a dom element or d3 selection.
	 * @param {String} [chartGroup] - The name of the chart group this chart instance should be placed in.
	 * Interaction with a chart will only trigger events and redraws within the chart's group.
	 * @return {dc.boxPlot}
	 */
	dc.boxPlot = function (parent, chartGroup) {
	    var _chart = dc.coordinateGridMixin({});
	
	    // Returns a function to compute the interquartile range.
	    function DEFAULT_WHISKERS_IQR (k) {
	        return function (d) {
	            var q1 = d.quartiles[0],
	                q3 = d.quartiles[2],
	                iqr = (q3 - q1) * k,
	                i = -1,
	                j = d.length;
	            do { ++i; } while (d[i] < q1 - iqr);
	            do { --j; } while (d[j] > q3 + iqr);
	            return [i, j];
	        };
	    }
	
	    var _whiskerIqrFactor = 1.5;
	    var _whiskersIqr = DEFAULT_WHISKERS_IQR;
	    var _whiskers = _whiskersIqr(_whiskerIqrFactor);
	
	    var _box = d3.box();
	    var _tickFormat = null;
	
	    var _boxWidth = function (innerChartWidth, xUnits) {
	        if (_chart.isOrdinal()) {
	            return _chart.x().rangeBand();
	        } else {
	            return innerChartWidth / (1 + _chart.boxPadding()) / xUnits;
	        }
	    };
	
	    // default padding to handle min/max whisker text
	    _chart.yAxisPadding(12);
	
	    // default to ordinal
	    _chart.x(d3.scale.ordinal());
	    _chart.xUnits(dc.units.ordinal);
	
	    // valueAccessor should return an array of values that can be coerced into numbers
	    // or if data is overloaded for a static array of arrays, it should be `Number`.
	    // Empty arrays are not included.
	    _chart.data(function (group) {
	        return group.all().map(function (d) {
	            d.map = function (accessor) { return accessor.call(d, d); };
	            return d;
	        }).filter(function (d) {
	            var values = _chart.valueAccessor()(d);
	            return values.length !== 0;
	        });
	    });
	
	    /**
	     * Get or set the spacing between boxes as a fraction of box size. Valid values are within 0-1.
	     * See the {@link https://github.com/mbostock/d3/wiki/Ordinal-Scales#wiki-ordinal_rangeBands d3 docs}
	     * for a visual description of how the padding is applied.
	     * @method boxPadding
	     * @memberof dc.boxPlot
	     * @instance
	     * @see {@link https://github.com/mbostock/d3/wiki/Ordinal-Scales#wiki-ordinal_rangeBands d3.scale.ordinal.rangeBands}
	     * @param {Number} [padding=0.8]
	     * @return {Number}
	     * @return {dc.boxPlot}
	     */
	    _chart.boxPadding = _chart._rangeBandPadding;
	    _chart.boxPadding(0.8);
	
	    /**
	     * Get or set the outer padding on an ordinal box chart. This setting has no effect on non-ordinal charts
	     * or on charts with a custom {@link dc.boxPlot#boxWidth .boxWidth}. Will pad the width by
	     * `padding * barWidth` on each side of the chart.
	     * @method outerPadding
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Number} [padding=0.5]
	     * @return {Number}
	     * @return {dc.boxPlot}
	     */
	    _chart.outerPadding = _chart._outerRangeBandPadding;
	    _chart.outerPadding(0.5);
	
	    /**
	     * Get or set the numerical width of the boxplot box. The width may also be a function taking as
	     * parameters the chart width excluding the right and left margins, as well as the number of x
	     * units.
	     * @example
	     * // Using numerical parameter
	     * chart.boxWidth(10);
	     * // Using function
	     * chart.boxWidth((innerChartWidth, xUnits) { ... });
	     * @method boxWidth
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Number|Function} [boxWidth=0.5]
	     * @return {Number|Function}
	     * @return {dc.boxPlot}
	     */
	    _chart.boxWidth = function (boxWidth) {
	        if (!arguments.length) {
	            return _boxWidth;
	        }
	        _boxWidth = d3.functor(boxWidth);
	        return _chart;
	    };
	
	    var boxTransform = function (d, i) {
	        var xOffset = _chart.x()(_chart.keyAccessor()(d, i));
	        return 'translate(' + xOffset + ', 0)';
	    };
	
	    _chart._preprocessData = function () {
	        if (_chart.elasticX()) {
	            _chart.x().domain([]);
	        }
	    };
	
	    _chart.plotData = function () {
	        var _calculatedBoxWidth = _boxWidth(_chart.effectiveWidth(), _chart.xUnitCount());
	
	        _box.whiskers(_whiskers)
	            .width(_calculatedBoxWidth)
	            .height(_chart.effectiveHeight())
	            .value(_chart.valueAccessor())
	            .domain(_chart.y().domain())
	            .duration(_chart.transitionDuration())
	            .tickFormat(_tickFormat);
	
	        var boxesG = _chart.chartBodyG().selectAll('g.box').data(_chart.data(), function (d) { return d.key; });
	
	        renderBoxes(boxesG);
	        updateBoxes(boxesG);
	        removeBoxes(boxesG);
	
	        _chart.fadeDeselectedArea();
	    };
	
	    function renderBoxes (boxesG) {
	        var boxesGEnter = boxesG.enter().append('g');
	
	        boxesGEnter
	            .attr('class', 'box')
	            .attr('transform', boxTransform)
	            .call(_box)
	            .on('click', function (d) {
	                _chart.filter(d.key);
	                _chart.redrawGroup();
	            });
	    }
	
	    function updateBoxes (boxesG) {
	        dc.transition(boxesG, _chart.transitionDuration())
	            .attr('transform', boxTransform)
	            .call(_box)
	            .each(function () {
	                d3.select(this).select('rect.box').attr('fill', _chart.getColor);
	            });
	    }
	
	    function removeBoxes (boxesG) {
	        boxesG.exit().remove().call(_box);
	    }
	
	    _chart.fadeDeselectedArea = function () {
	        if (_chart.hasFilter()) {
	            _chart.g().selectAll('g.box').each(function (d) {
	                if (_chart.isSelectedNode(d)) {
	                    _chart.highlightSelected(this);
	                } else {
	                    _chart.fadeDeselected(this);
	                }
	            });
	        } else {
	            _chart.g().selectAll('g.box').each(function () {
	                _chart.resetHighlight(this);
	            });
	        }
	    };
	
	    _chart.isSelectedNode = function (d) {
	        return _chart.hasFilter(d.key);
	    };
	
	    _chart.yAxisMin = function () {
	        var min = d3.min(_chart.data(), function (e) {
	            return d3.min(_chart.valueAccessor()(e));
	        });
	        return dc.utils.subtract(min, _chart.yAxisPadding());
	    };
	
	    _chart.yAxisMax = function () {
	        var max = d3.max(_chart.data(), function (e) {
	            return d3.max(_chart.valueAccessor()(e));
	        });
	        return dc.utils.add(max, _chart.yAxisPadding());
	    };
	
	    /**
	     * Set the numerical format of the boxplot median, whiskers and quartile labels. Defaults to
	     * integer formatting.
	     * @example
	     * // format ticks to 2 decimal places
	     * chart.tickFormat(d3.format('.2f'));
	     * @method tickFormat
	     * @memberof dc.boxPlot
	     * @instance
	     * @param {Function} [tickFormat]
	     * @return {Number|Function}
	     * @return {dc.boxPlot}
	     */
	    _chart.tickFormat = function (tickFormat) {
	        if (!arguments.length) {
	            return _tickFormat;
	        }
	        _tickFormat = tickFormat;
	        return _chart;
	    };
	
	    return _chart.anchor(parent, chartGroup);
	};
	
	// Renamed functions
	
	dc.abstractBubbleChart = dc.bubbleMixin;
	dc.baseChart = dc.baseMixin;
	dc.capped = dc.capMixin;
	dc.colorChart = dc.colorMixin;
	dc.coordinateGridChart = dc.coordinateGridMixin;
	dc.marginable = dc.marginMixin;
	dc.stackableChart = dc.stackMixin;
	
	// Expose d3 and crossfilter, so that clients in browserify
	// case can obtain them if they need them.
	dc.d3 = d3;
	dc.crossfilter = crossfilter;
	
	return dc;}
	    if(true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(812), __webpack_require__(677)], __WEBPACK_AMD_DEFINE_FACTORY__ = (_dc), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if(typeof module === "object" && module.exports) {
	        var _d3 = require('d3');
	        var _crossfilter = require('crossfilter2');
	        // When using npm + browserify, 'crossfilter' is a function,
	        // since package.json specifies index.js as main function, and it
	        // does special handling. When using bower + browserify,
	        // there's no main in bower.json (in fact, there's no bower.json),
	        // so we need to fix it.
	        if (typeof _crossfilter !== "function") {
	            _crossfilter = _crossfilter.crossfilter;
	        }
	        module.exports = _dc(_d3, _crossfilter);
	    } else {
	        this.dc = _dc(d3, crossfilter);
	    }
	}
	)();
	
	//# sourceMappingURL=dc.js.map

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 813 */
/***/ function(module, exports) {

	module.exports = {
		"type": "FeatureCollection",
		"features": [
			{
				"type": "Feature",
				"properties": {
					"name": "Afghanistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								61.210817,
								35.650072
							],
							[
								62.230651,
								35.270664
							],
							[
								62.984662,
								35.404041
							],
							[
								63.193538,
								35.857166
							],
							[
								63.982896,
								36.007957
							],
							[
								64.546479,
								36.312073
							],
							[
								64.746105,
								37.111818
							],
							[
								65.588948,
								37.305217
							],
							[
								65.745631,
								37.661164
							],
							[
								66.217385,
								37.39379
							],
							[
								66.518607,
								37.362784
							],
							[
								67.075782,
								37.356144
							],
							[
								67.83,
								37.144994
							],
							[
								68.135562,
								37.023115
							],
							[
								68.859446,
								37.344336
							],
							[
								69.196273,
								37.151144
							],
							[
								69.518785,
								37.608997
							],
							[
								70.116578,
								37.588223
							],
							[
								70.270574,
								37.735165
							],
							[
								70.376304,
								38.138396
							],
							[
								70.806821,
								38.486282
							],
							[
								71.348131,
								38.258905
							],
							[
								71.239404,
								37.953265
							],
							[
								71.541918,
								37.905774
							],
							[
								71.448693,
								37.065645
							],
							[
								71.844638,
								36.738171
							],
							[
								72.193041,
								36.948288
							],
							[
								72.63689,
								37.047558
							],
							[
								73.260056,
								37.495257
							],
							[
								73.948696,
								37.421566
							],
							[
								74.980002,
								37.41999
							],
							[
								75.158028,
								37.133031
							],
							[
								74.575893,
								37.020841
							],
							[
								74.067552,
								36.836176
							],
							[
								72.920025,
								36.720007
							],
							[
								71.846292,
								36.509942
							],
							[
								71.262348,
								36.074388
							],
							[
								71.498768,
								35.650563
							],
							[
								71.613076,
								35.153203
							],
							[
								71.115019,
								34.733126
							],
							[
								71.156773,
								34.348911
							],
							[
								70.881803,
								33.988856
							],
							[
								69.930543,
								34.02012
							],
							[
								70.323594,
								33.358533
							],
							[
								69.687147,
								33.105499
							],
							[
								69.262522,
								32.501944
							],
							[
								69.317764,
								31.901412
							],
							[
								68.926677,
								31.620189
							],
							[
								68.556932,
								31.71331
							],
							[
								67.792689,
								31.58293
							],
							[
								67.683394,
								31.303154
							],
							[
								66.938891,
								31.304911
							],
							[
								66.381458,
								30.738899
							],
							[
								66.346473,
								29.887943
							],
							[
								65.046862,
								29.472181
							],
							[
								64.350419,
								29.560031
							],
							[
								64.148002,
								29.340819
							],
							[
								63.550261,
								29.468331
							],
							[
								62.549857,
								29.318572
							],
							[
								60.874248,
								29.829239
							],
							[
								61.781222,
								30.73585
							],
							[
								61.699314,
								31.379506
							],
							[
								60.941945,
								31.548075
							],
							[
								60.863655,
								32.18292
							],
							[
								60.536078,
								32.981269
							],
							[
								60.9637,
								33.528832
							],
							[
								60.52843,
								33.676446
							],
							[
								60.803193,
								34.404102
							],
							[
								61.210817,
								35.650072
							]
						]
					]
				},
				"id": "AFG"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Angola"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									16.326528,
									-5.87747
								],
								[
									16.57318,
									-6.622645
								],
								[
									16.860191,
									-7.222298
								],
								[
									17.089996,
									-7.545689
								],
								[
									17.47297,
									-8.068551
								],
								[
									18.134222,
									-7.987678
								],
								[
									18.464176,
									-7.847014
								],
								[
									19.016752,
									-7.988246
								],
								[
									19.166613,
									-7.738184
								],
								[
									19.417502,
									-7.155429
								],
								[
									20.037723,
									-7.116361
								],
								[
									20.091622,
									-6.94309
								],
								[
									20.601823,
									-6.939318
								],
								[
									20.514748,
									-7.299606
								],
								[
									21.728111,
									-7.290872
								],
								[
									21.746456,
									-7.920085
								],
								[
									21.949131,
									-8.305901
								],
								[
									21.801801,
									-8.908707
								],
								[
									21.875182,
									-9.523708
								],
								[
									22.208753,
									-9.894796
								],
								[
									22.155268,
									-11.084801
								],
								[
									22.402798,
									-10.993075
								],
								[
									22.837345,
									-11.017622
								],
								[
									23.456791,
									-10.867863
								],
								[
									23.912215,
									-10.926826
								],
								[
									24.017894,
									-11.237298
								],
								[
									23.904154,
									-11.722282
								],
								[
									24.079905,
									-12.191297
								],
								[
									23.930922,
									-12.565848
								],
								[
									24.016137,
									-12.911046
								],
								[
									21.933886,
									-12.898437
								],
								[
									21.887843,
									-16.08031
								],
								[
									22.562478,
									-16.898451
								],
								[
									23.215048,
									-17.523116
								],
								[
									21.377176,
									-17.930636
								],
								[
									18.956187,
									-17.789095
								],
								[
									18.263309,
									-17.309951
								],
								[
									14.209707,
									-17.353101
								],
								[
									14.058501,
									-17.423381
								],
								[
									13.462362,
									-16.971212
								],
								[
									12.814081,
									-16.941343
								],
								[
									12.215461,
									-17.111668
								],
								[
									11.734199,
									-17.301889
								],
								[
									11.640096,
									-16.673142
								],
								[
									11.778537,
									-15.793816
								],
								[
									12.123581,
									-14.878316
								],
								[
									12.175619,
									-14.449144
								],
								[
									12.500095,
									-13.5477
								],
								[
									12.738479,
									-13.137906
								],
								[
									13.312914,
									-12.48363
								],
								[
									13.633721,
									-12.038645
								],
								[
									13.738728,
									-11.297863
								],
								[
									13.686379,
									-10.731076
								],
								[
									13.387328,
									-10.373578
								],
								[
									13.120988,
									-9.766897
								],
								[
									12.87537,
									-9.166934
								],
								[
									12.929061,
									-8.959091
								],
								[
									13.236433,
									-8.562629
								],
								[
									12.93304,
									-7.596539
								],
								[
									12.728298,
									-6.927122
								],
								[
									12.227347,
									-6.294448
								],
								[
									12.322432,
									-6.100092
								],
								[
									12.735171,
									-5.965682
								],
								[
									13.024869,
									-5.984389
								],
								[
									13.375597,
									-5.864241
								],
								[
									16.326528,
									-5.87747
								]
							]
						],
						[
							[
								[
									12.436688,
									-5.684304
								],
								[
									12.182337,
									-5.789931
								],
								[
									11.914963,
									-5.037987
								],
								[
									12.318608,
									-4.60623
								],
								[
									12.62076,
									-4.438023
								],
								[
									12.995517,
									-4.781103
								],
								[
									12.631612,
									-4.991271
								],
								[
									12.468004,
									-5.248362
								],
								[
									12.436688,
									-5.684304
								]
							]
						]
					]
				},
				"id": "AGO"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Albania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.590247,
								41.855404
							],
							[
								20.463175,
								41.515089
							],
							[
								20.605182,
								41.086226
							],
							[
								21.02004,
								40.842727
							],
							[
								20.99999,
								40.580004
							],
							[
								20.674997,
								40.435
							],
							[
								20.615,
								40.110007
							],
							[
								20.150016,
								39.624998
							],
							[
								19.98,
								39.694993
							],
							[
								19.960002,
								39.915006
							],
							[
								19.406082,
								40.250773
							],
							[
								19.319059,
								40.72723
							],
							[
								19.40355,
								41.409566
							],
							[
								19.540027,
								41.719986
							],
							[
								19.371769,
								41.877548
							],
							[
								19.304486,
								42.195745
							],
							[
								19.738051,
								42.688247
							],
							[
								19.801613,
								42.500093
							],
							[
								20.0707,
								42.58863
							],
							[
								20.283755,
								42.32026
							],
							[
								20.52295,
								42.21787
							],
							[
								20.590247,
								41.855404
							]
						]
					]
				},
				"id": "ALB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "United Arab Emirates"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								51.579519,
								24.245497
							],
							[
								51.757441,
								24.294073
							],
							[
								51.794389,
								24.019826
							],
							[
								52.577081,
								24.177439
							],
							[
								53.404007,
								24.151317
							],
							[
								54.008001,
								24.121758
							],
							[
								54.693024,
								24.797892
							],
							[
								55.439025,
								25.439145
							],
							[
								56.070821,
								26.055464
							],
							[
								56.261042,
								25.714606
							],
							[
								56.396847,
								24.924732
							],
							[
								55.886233,
								24.920831
							],
							[
								55.804119,
								24.269604
							],
							[
								55.981214,
								24.130543
							],
							[
								55.528632,
								23.933604
							],
							[
								55.525841,
								23.524869
							],
							[
								55.234489,
								23.110993
							],
							[
								55.208341,
								22.70833
							],
							[
								55.006803,
								22.496948
							],
							[
								52.000733,
								23.001154
							],
							[
								51.617708,
								24.014219
							],
							[
								51.579519,
								24.245497
							]
						]
					]
				},
				"id": "ARE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Argentina"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-65.5,
									-55.2
								],
								[
									-66.45,
									-55.25
								],
								[
									-66.95992,
									-54.89681
								],
								[
									-67.56244,
									-54.87001
								],
								[
									-68.63335,
									-54.8695
								],
								[
									-68.63401,
									-52.63637
								],
								[
									-68.25,
									-53.1
								],
								[
									-67.75,
									-53.85
								],
								[
									-66.45,
									-54.45
								],
								[
									-65.05,
									-54.7
								],
								[
									-65.5,
									-55.2
								]
							]
						],
						[
							[
								[
									-64.964892,
									-22.075862
								],
								[
									-64.377021,
									-22.798091
								],
								[
									-63.986838,
									-21.993644
								],
								[
									-62.846468,
									-22.034985
								],
								[
									-62.685057,
									-22.249029
								],
								[
									-60.846565,
									-23.880713
								],
								[
									-60.028966,
									-24.032796
								],
								[
									-58.807128,
									-24.771459
								],
								[
									-57.777217,
									-25.16234
								],
								[
									-57.63366,
									-25.603657
								],
								[
									-58.618174,
									-27.123719
								],
								[
									-57.60976,
									-27.395899
								],
								[
									-56.486702,
									-27.548499
								],
								[
									-55.695846,
									-27.387837
								],
								[
									-54.788795,
									-26.621786
								],
								[
									-54.625291,
									-25.739255
								],
								[
									-54.13005,
									-25.547639
								],
								[
									-53.628349,
									-26.124865
								],
								[
									-53.648735,
									-26.923473
								],
								[
									-54.490725,
									-27.474757
								],
								[
									-55.162286,
									-27.881915
								],
								[
									-56.2909,
									-28.852761
								],
								[
									-57.625133,
									-30.216295
								],
								[
									-57.874937,
									-31.016556
								],
								[
									-58.14244,
									-32.044504
								],
								[
									-58.132648,
									-33.040567
								],
								[
									-58.349611,
									-33.263189
								],
								[
									-58.427074,
									-33.909454
								],
								[
									-58.495442,
									-34.43149
								],
								[
									-57.22583,
									-35.288027
								],
								[
									-57.362359,
									-35.97739
								],
								[
									-56.737487,
									-36.413126
								],
								[
									-56.788285,
									-36.901572
								],
								[
									-57.749157,
									-38.183871
								],
								[
									-59.231857,
									-38.72022
								],
								[
									-61.237445,
									-38.928425
								],
								[
									-62.335957,
									-38.827707
								],
								[
									-62.125763,
									-39.424105
								],
								[
									-62.330531,
									-40.172586
								],
								[
									-62.145994,
									-40.676897
								],
								[
									-62.745803,
									-41.028761
								],
								[
									-63.770495,
									-41.166789
								],
								[
									-64.73209,
									-40.802677
								],
								[
									-65.118035,
									-41.064315
								],
								[
									-64.978561,
									-42.058001
								],
								[
									-64.303408,
									-42.359016
								],
								[
									-63.755948,
									-42.043687
								],
								[
									-63.458059,
									-42.563138
								],
								[
									-64.378804,
									-42.873558
								],
								[
									-65.181804,
									-43.495381
								],
								[
									-65.328823,
									-44.501366
								],
								[
									-65.565269,
									-45.036786
								],
								[
									-66.509966,
									-45.039628
								],
								[
									-67.293794,
									-45.551896
								],
								[
									-67.580546,
									-46.301773
								],
								[
									-66.597066,
									-47.033925
								],
								[
									-65.641027,
									-47.236135
								],
								[
									-65.985088,
									-48.133289
								],
								[
									-67.166179,
									-48.697337
								],
								[
									-67.816088,
									-49.869669
								],
								[
									-68.728745,
									-50.264218
								],
								[
									-69.138539,
									-50.73251
								],
								[
									-68.815561,
									-51.771104
								],
								[
									-68.149995,
									-52.349983
								],
								[
									-68.571545,
									-52.299444
								],
								[
									-69.498362,
									-52.142761
								],
								[
									-71.914804,
									-52.009022
								],
								[
									-72.329404,
									-51.425956
								],
								[
									-72.309974,
									-50.67701
								],
								[
									-72.975747,
									-50.74145
								],
								[
									-73.328051,
									-50.378785
								],
								[
									-73.415436,
									-49.318436
								],
								[
									-72.648247,
									-48.878618
								],
								[
									-72.331161,
									-48.244238
								],
								[
									-72.447355,
									-47.738533
								],
								[
									-71.917258,
									-46.884838
								],
								[
									-71.552009,
									-45.560733
								],
								[
									-71.659316,
									-44.973689
								],
								[
									-71.222779,
									-44.784243
								],
								[
									-71.329801,
									-44.407522
								],
								[
									-71.793623,
									-44.207172
								],
								[
									-71.464056,
									-43.787611
								],
								[
									-71.915424,
									-43.408565
								],
								[
									-72.148898,
									-42.254888
								],
								[
									-71.746804,
									-42.051386
								],
								[
									-71.915734,
									-40.832339
								],
								[
									-71.680761,
									-39.808164
								],
								[
									-71.413517,
									-38.916022
								],
								[
									-70.814664,
									-38.552995
								],
								[
									-71.118625,
									-37.576827
								],
								[
									-71.121881,
									-36.658124
								],
								[
									-70.364769,
									-36.005089
								],
								[
									-70.388049,
									-35.169688
								],
								[
									-69.817309,
									-34.193571
								],
								[
									-69.814777,
									-33.273886
								],
								[
									-70.074399,
									-33.09121
								],
								[
									-70.535069,
									-31.36501
								],
								[
									-69.919008,
									-30.336339
								],
								[
									-70.01355,
									-29.367923
								],
								[
									-69.65613,
									-28.459141
								],
								[
									-69.001235,
									-27.521214
								],
								[
									-68.295542,
									-26.89934
								],
								[
									-68.5948,
									-26.506909
								],
								[
									-68.386001,
									-26.185016
								],
								[
									-68.417653,
									-24.518555
								],
								[
									-67.328443,
									-24.025303
								],
								[
									-66.985234,
									-22.986349
								],
								[
									-67.106674,
									-22.735925
								],
								[
									-66.273339,
									-21.83231
								],
								[
									-64.964892,
									-22.075862
								]
							]
						]
					]
				},
				"id": "ARG"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Armenia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								43.582746,
								41.092143
							],
							[
								44.97248,
								41.248129
							],
							[
								45.179496,
								40.985354
							],
							[
								45.560351,
								40.81229
							],
							[
								45.359175,
								40.561504
							],
							[
								45.891907,
								40.218476
							],
							[
								45.610012,
								39.899994
							],
							[
								46.034534,
								39.628021
							],
							[
								46.483499,
								39.464155
							],
							[
								46.50572,
								38.770605
							],
							[
								46.143623,
								38.741201
							],
							[
								45.735379,
								39.319719
							],
							[
								45.739978,
								39.473999
							],
							[
								45.298145,
								39.471751
							],
							[
								45.001987,
								39.740004
							],
							[
								44.79399,
								39.713003
							],
							[
								44.400009,
								40.005
							],
							[
								43.656436,
								40.253564
							],
							[
								43.752658,
								40.740201
							],
							[
								43.582746,
								41.092143
							]
						]
					]
				},
				"id": "ARM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "French Southern and Antarctic Lands"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								68.935,
								-48.625
							],
							[
								69.58,
								-48.94
							],
							[
								70.525,
								-49.065
							],
							[
								70.56,
								-49.255
							],
							[
								70.28,
								-49.71
							],
							[
								68.745,
								-49.775
							],
							[
								68.72,
								-49.2425
							],
							[
								68.8675,
								-48.83
							],
							[
								68.935,
								-48.625
							]
						]
					]
				},
				"id": "ATF"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Australia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									145.397978,
									-40.792549
								],
								[
									146.364121,
									-41.137695
								],
								[
									146.908584,
									-41.000546
								],
								[
									147.689259,
									-40.808258
								],
								[
									148.289068,
									-40.875438
								],
								[
									148.359865,
									-42.062445
								],
								[
									148.017301,
									-42.407024
								],
								[
									147.914052,
									-43.211522
								],
								[
									147.564564,
									-42.937689
								],
								[
									146.870343,
									-43.634597
								],
								[
									146.663327,
									-43.580854
								],
								[
									146.048378,
									-43.549745
								],
								[
									145.43193,
									-42.693776
								],
								[
									145.29509,
									-42.03361
								],
								[
									144.718071,
									-41.162552
								],
								[
									144.743755,
									-40.703975
								],
								[
									145.397978,
									-40.792549
								]
							]
						],
						[
							[
								[
									143.561811,
									-13.763656
								],
								[
									143.922099,
									-14.548311
								],
								[
									144.563714,
									-14.171176
								],
								[
									144.894908,
									-14.594458
								],
								[
									145.374724,
									-14.984976
								],
								[
									145.271991,
									-15.428205
								],
								[
									145.48526,
									-16.285672
								],
								[
									145.637033,
									-16.784918
								],
								[
									145.888904,
									-16.906926
								],
								[
									146.160309,
									-17.761655
								],
								[
									146.063674,
									-18.280073
								],
								[
									146.387478,
									-18.958274
								],
								[
									147.471082,
									-19.480723
								],
								[
									148.177602,
									-19.955939
								],
								[
									148.848414,
									-20.39121
								],
								[
									148.717465,
									-20.633469
								],
								[
									149.28942,
									-21.260511
								],
								[
									149.678337,
									-22.342512
								],
								[
									150.077382,
									-22.122784
								],
								[
									150.482939,
									-22.556142
								],
								[
									150.727265,
									-22.402405
								],
								[
									150.899554,
									-23.462237
								],
								[
									151.609175,
									-24.076256
								],
								[
									152.07354,
									-24.457887
								],
								[
									152.855197,
									-25.267501
								],
								[
									153.136162,
									-26.071173
								],
								[
									153.161949,
									-26.641319
								],
								[
									153.092909,
									-27.2603
								],
								[
									153.569469,
									-28.110067
								],
								[
									153.512108,
									-28.995077
								],
								[
									153.339095,
									-29.458202
								],
								[
									153.069241,
									-30.35024
								],
								[
									153.089602,
									-30.923642
								],
								[
									152.891578,
									-31.640446
								],
								[
									152.450002,
									-32.550003
								],
								[
									151.709117,
									-33.041342
								],
								[
									151.343972,
									-33.816023
								],
								[
									151.010555,
									-34.31036
								],
								[
									150.714139,
									-35.17346
								],
								[
									150.32822,
									-35.671879
								],
								[
									150.075212,
									-36.420206
								],
								[
									149.946124,
									-37.109052
								],
								[
									149.997284,
									-37.425261
								],
								[
									149.423882,
									-37.772681
								],
								[
									148.304622,
									-37.809061
								],
								[
									147.381733,
									-38.219217
								],
								[
									146.922123,
									-38.606532
								],
								[
									146.317922,
									-39.035757
								],
								[
									145.489652,
									-38.593768
								],
								[
									144.876976,
									-38.417448
								],
								[
									145.032212,
									-37.896188
								],
								[
									144.485682,
									-38.085324
								],
								[
									143.609974,
									-38.809465
								],
								[
									142.745427,
									-38.538268
								],
								[
									142.17833,
									-38.380034
								],
								[
									141.606582,
									-38.308514
								],
								[
									140.638579,
									-38.019333
								],
								[
									139.992158,
									-37.402936
								],
								[
									139.806588,
									-36.643603
								],
								[
									139.574148,
									-36.138362
								],
								[
									139.082808,
									-35.732754
								],
								[
									138.120748,
									-35.612296
								],
								[
									138.449462,
									-35.127261
								],
								[
									138.207564,
									-34.384723
								],
								[
									137.71917,
									-35.076825
								],
								[
									136.829406,
									-35.260535
								],
								[
									137.352371,
									-34.707339
								],
								[
									137.503886,
									-34.130268
								],
								[
									137.890116,
									-33.640479
								],
								[
									137.810328,
									-32.900007
								],
								[
									136.996837,
									-33.752771
								],
								[
									136.372069,
									-34.094766
								],
								[
									135.989043,
									-34.890118
								],
								[
									135.208213,
									-34.47867
								],
								[
									135.239218,
									-33.947953
								],
								[
									134.613417,
									-33.222778
								],
								[
									134.085904,
									-32.848072
								],
								[
									134.273903,
									-32.617234
								],
								[
									132.990777,
									-32.011224
								],
								[
									132.288081,
									-31.982647
								],
								[
									131.326331,
									-31.495803
								],
								[
									129.535794,
									-31.590423
								],
								[
									128.240938,
									-31.948489
								],
								[
									127.102867,
									-32.282267
								],
								[
									126.148714,
									-32.215966
								],
								[
									125.088623,
									-32.728751
								],
								[
									124.221648,
									-32.959487
								],
								[
									124.028947,
									-33.483847
								],
								[
									123.659667,
									-33.890179
								],
								[
									122.811036,
									-33.914467
								],
								[
									122.183064,
									-34.003402
								],
								[
									121.299191,
									-33.821036
								],
								[
									120.580268,
									-33.930177
								],
								[
									119.893695,
									-33.976065
								],
								[
									119.298899,
									-34.509366
								],
								[
									119.007341,
									-34.464149
								],
								[
									118.505718,
									-34.746819
								],
								[
									118.024972,
									-35.064733
								],
								[
									117.295507,
									-35.025459
								],
								[
									116.625109,
									-35.025097
								],
								[
									115.564347,
									-34.386428
								],
								[
									115.026809,
									-34.196517
								],
								[
									115.048616,
									-33.623425
								],
								[
									115.545123,
									-33.487258
								],
								[
									115.714674,
									-33.259572
								],
								[
									115.679379,
									-32.900369
								],
								[
									115.801645,
									-32.205062
								],
								[
									115.689611,
									-31.612437
								],
								[
									115.160909,
									-30.601594
								],
								[
									114.997043,
									-30.030725
								],
								[
									115.040038,
									-29.461095
								],
								[
									114.641974,
									-28.810231
								],
								[
									114.616498,
									-28.516399
								],
								[
									114.173579,
									-28.118077
								],
								[
									114.048884,
									-27.334765
								],
								[
									113.477498,
									-26.543134
								],
								[
									113.338953,
									-26.116545
								],
								[
									113.778358,
									-26.549025
								],
								[
									113.440962,
									-25.621278
								],
								[
									113.936901,
									-25.911235
								],
								[
									114.232852,
									-26.298446
								],
								[
									114.216161,
									-25.786281
								],
								[
									113.721255,
									-24.998939
								],
								[
									113.625344,
									-24.683971
								],
								[
									113.393523,
									-24.384764
								],
								[
									113.502044,
									-23.80635
								],
								[
									113.706993,
									-23.560215
								],
								[
									113.843418,
									-23.059987
								],
								[
									113.736552,
									-22.475475
								],
								[
									114.149756,
									-21.755881
								],
								[
									114.225307,
									-22.517488
								],
								[
									114.647762,
									-21.82952
								],
								[
									115.460167,
									-21.495173
								],
								[
									115.947373,
									-21.068688
								],
								[
									116.711615,
									-20.701682
								],
								[
									117.166316,
									-20.623599
								],
								[
									117.441545,
									-20.746899
								],
								[
									118.229559,
									-20.374208
								],
								[
									118.836085,
									-20.263311
								],
								[
									118.987807,
									-20.044203
								],
								[
									119.252494,
									-19.952942
								],
								[
									119.805225,
									-19.976506
								],
								[
									120.85622,
									-19.683708
								],
								[
									121.399856,
									-19.239756
								],
								[
									121.655138,
									-18.705318
								],
								[
									122.241665,
									-18.197649
								],
								[
									122.286624,
									-17.798603
								],
								[
									122.312772,
									-17.254967
								],
								[
									123.012574,
									-16.4052
								],
								[
									123.433789,
									-17.268558
								],
								[
									123.859345,
									-17.069035
								],
								[
									123.503242,
									-16.596506
								],
								[
									123.817073,
									-16.111316
								],
								[
									124.258287,
									-16.327944
								],
								[
									124.379726,
									-15.56706
								],
								[
									124.926153,
									-15.0751
								],
								[
									125.167275,
									-14.680396
								],
								[
									125.670087,
									-14.51007
								],
								[
									125.685796,
									-14.230656
								],
								[
									126.125149,
									-14.347341
								],
								[
									126.142823,
									-14.095987
								],
								[
									126.582589,
									-13.952791
								],
								[
									127.065867,
									-13.817968
								],
								[
									127.804633,
									-14.276906
								],
								[
									128.35969,
									-14.86917
								],
								[
									128.985543,
									-14.875991
								],
								[
									129.621473,
									-14.969784
								],
								[
									129.4096,
									-14.42067
								],
								[
									129.888641,
									-13.618703
								],
								[
									130.339466,
									-13.357376
								],
								[
									130.183506,
									-13.10752
								],
								[
									130.617795,
									-12.536392
								],
								[
									131.223495,
									-12.183649
								],
								[
									131.735091,
									-12.302453
								],
								[
									132.575298,
									-12.114041
								],
								[
									132.557212,
									-11.603012
								],
								[
									131.824698,
									-11.273782
								],
								[
									132.357224,
									-11.128519
								],
								[
									133.019561,
									-11.376411
								],
								[
									133.550846,
									-11.786515
								],
								[
									134.393068,
									-12.042365
								],
								[
									134.678632,
									-11.941183
								],
								[
									135.298491,
									-12.248606
								],
								[
									135.882693,
									-11.962267
								],
								[
									136.258381,
									-12.049342
								],
								[
									136.492475,
									-11.857209
								],
								[
									136.95162,
									-12.351959
								],
								[
									136.685125,
									-12.887223
								],
								[
									136.305407,
									-13.29123
								],
								[
									135.961758,
									-13.324509
								],
								[
									136.077617,
									-13.724278
								],
								[
									135.783836,
									-14.223989
								],
								[
									135.428664,
									-14.715432
								],
								[
									135.500184,
									-14.997741
								],
								[
									136.295175,
									-15.550265
								],
								[
									137.06536,
									-15.870762
								],
								[
									137.580471,
									-16.215082
								],
								[
									138.303217,
									-16.807604
								],
								[
									138.585164,
									-16.806622
								],
								[
									139.108543,
									-17.062679
								],
								[
									139.260575,
									-17.371601
								],
								[
									140.215245,
									-17.710805
								],
								[
									140.875463,
									-17.369069
								],
								[
									141.07111,
									-16.832047
								],
								[
									141.274095,
									-16.38887
								],
								[
									141.398222,
									-15.840532
								],
								[
									141.702183,
									-15.044921
								],
								[
									141.56338,
									-14.561333
								],
								[
									141.63552,
									-14.270395
								],
								[
									141.519869,
									-13.698078
								],
								[
									141.65092,
									-12.944688
								],
								[
									141.842691,
									-12.741548
								],
								[
									141.68699,
									-12.407614
								],
								[
									141.928629,
									-11.877466
								],
								[
									142.118488,
									-11.328042
								],
								[
									142.143706,
									-11.042737
								],
								[
									142.51526,
									-10.668186
								],
								[
									142.79731,
									-11.157355
								],
								[
									142.866763,
									-11.784707
								],
								[
									143.115947,
									-11.90563
								],
								[
									143.158632,
									-12.325656
								],
								[
									143.522124,
									-12.834358
								],
								[
									143.597158,
									-13.400422
								],
								[
									143.561811,
									-13.763656
								]
							]
						]
					]
				},
				"id": "AUS"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Austria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.979667,
								48.123497
							],
							[
								16.903754,
								47.714866
							],
							[
								16.340584,
								47.712902
							],
							[
								16.534268,
								47.496171
							],
							[
								16.202298,
								46.852386
							],
							[
								16.011664,
								46.683611
							],
							[
								15.137092,
								46.658703
							],
							[
								14.632472,
								46.431817
							],
							[
								13.806475,
								46.509306
							],
							[
								12.376485,
								46.767559
							],
							[
								12.153088,
								47.115393
							],
							[
								11.164828,
								46.941579
							],
							[
								11.048556,
								46.751359
							],
							[
								10.442701,
								46.893546
							],
							[
								9.932448,
								46.920728
							],
							[
								9.47997,
								47.10281
							],
							[
								9.632932,
								47.347601
							],
							[
								9.594226,
								47.525058
							],
							[
								9.896068,
								47.580197
							],
							[
								10.402084,
								47.302488
							],
							[
								10.544504,
								47.566399
							],
							[
								11.426414,
								47.523766
							],
							[
								12.141357,
								47.703083
							],
							[
								12.62076,
								47.672388
							],
							[
								12.932627,
								47.467646
							],
							[
								13.025851,
								47.637584
							],
							[
								12.884103,
								48.289146
							],
							[
								13.243357,
								48.416115
							],
							[
								13.595946,
								48.877172
							],
							[
								14.338898,
								48.555305
							],
							[
								14.901447,
								48.964402
							],
							[
								15.253416,
								49.039074
							],
							[
								16.029647,
								48.733899
							],
							[
								16.499283,
								48.785808
							],
							[
								16.960288,
								48.596982
							],
							[
								16.879983,
								48.470013
							],
							[
								16.979667,
								48.123497
							]
						]
					]
				},
				"id": "AUT"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Azerbaijan"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									45.001987,
									39.740004
								],
								[
									45.298145,
									39.471751
								],
								[
									45.739978,
									39.473999
								],
								[
									45.735379,
									39.319719
								],
								[
									46.143623,
									38.741201
								],
								[
									45.457722,
									38.874139
								],
								[
									44.952688,
									39.335765
								],
								[
									44.79399,
									39.713003
								],
								[
									45.001987,
									39.740004
								]
							]
						],
						[
							[
								[
									47.373315,
									41.219732
								],
								[
									47.815666,
									41.151416
								],
								[
									47.987283,
									41.405819
								],
								[
									48.584353,
									41.80887
								],
								[
									49.110264,
									41.282287
								],
								[
									49.618915,
									40.572924
								],
								[
									50.08483,
									40.526157
								],
								[
									50.392821,
									40.256561
								],
								[
									49.569202,
									40.176101
								],
								[
									49.395259,
									39.399482
								],
								[
									49.223228,
									39.049219
								],
								[
									48.856532,
									38.815486
								],
								[
									48.883249,
									38.320245
								],
								[
									48.634375,
									38.270378
								],
								[
									48.010744,
									38.794015
								],
								[
									48.355529,
									39.288765
								],
								[
									48.060095,
									39.582235
								],
								[
									47.685079,
									39.508364
								],
								[
									46.50572,
									38.770605
								],
								[
									46.483499,
									39.464155
								],
								[
									46.034534,
									39.628021
								],
								[
									45.610012,
									39.899994
								],
								[
									45.891907,
									40.218476
								],
								[
									45.359175,
									40.561504
								],
								[
									45.560351,
									40.81229
								],
								[
									45.179496,
									40.985354
								],
								[
									44.97248,
									41.248129
								],
								[
									45.217426,
									41.411452
								],
								[
									45.962601,
									41.123873
								],
								[
									46.501637,
									41.064445
								],
								[
									46.637908,
									41.181673
								],
								[
									46.145432,
									41.722802
								],
								[
									46.404951,
									41.860675
								],
								[
									46.686071,
									41.827137
								],
								[
									47.373315,
									41.219732
								]
							]
						]
					]
				},
				"id": "AZE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Burundi"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								29.339998,
								-4.499983
							],
							[
								29.276384,
								-3.293907
							],
							[
								29.024926,
								-2.839258
							],
							[
								29.632176,
								-2.917858
							],
							[
								29.938359,
								-2.348487
							],
							[
								30.469696,
								-2.413858
							],
							[
								30.527677,
								-2.807632
							],
							[
								30.743013,
								-3.034285
							],
							[
								30.752263,
								-3.35933
							],
							[
								30.50556,
								-3.568567
							],
							[
								30.116333,
								-4.090138
							],
							[
								29.753512,
								-4.452389
							],
							[
								29.339998,
								-4.499983
							]
						]
					]
				},
				"id": "BDI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Belgium"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3.314971,
								51.345781
							],
							[
								4.047071,
								51.267259
							],
							[
								4.973991,
								51.475024
							],
							[
								5.606976,
								51.037298
							],
							[
								6.156658,
								50.803721
							],
							[
								6.043073,
								50.128052
							],
							[
								5.782417,
								50.090328
							],
							[
								5.674052,
								49.529484
							],
							[
								4.799222,
								49.985373
							],
							[
								4.286023,
								49.907497
							],
							[
								3.588184,
								50.378992
							],
							[
								3.123252,
								50.780363
							],
							[
								2.658422,
								50.796848
							],
							[
								2.513573,
								51.148506
							],
							[
								3.314971,
								51.345781
							]
						]
					]
				},
				"id": "BEL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Benin"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2.691702,
								6.258817
							],
							[
								1.865241,
								6.142158
							],
							[
								1.618951,
								6.832038
							],
							[
								1.664478,
								9.12859
							],
							[
								1.463043,
								9.334624
							],
							[
								1.425061,
								9.825395
							],
							[
								1.077795,
								10.175607
							],
							[
								0.772336,
								10.470808
							],
							[
								0.899563,
								10.997339
							],
							[
								1.24347,
								11.110511
							],
							[
								1.447178,
								11.547719
							],
							[
								1.935986,
								11.64115
							],
							[
								2.154474,
								11.94015
							],
							[
								2.490164,
								12.233052
							],
							[
								2.848643,
								12.235636
							],
							[
								3.61118,
								11.660167
							],
							[
								3.572216,
								11.327939
							],
							[
								3.797112,
								10.734746
							],
							[
								3.60007,
								10.332186
							],
							[
								3.705438,
								10.06321
							],
							[
								3.220352,
								9.444153
							],
							[
								2.912308,
								9.137608
							],
							[
								2.723793,
								8.506845
							],
							[
								2.749063,
								7.870734
							],
							[
								2.691702,
								6.258817
							]
						]
					]
				},
				"id": "BEN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Burkina Faso"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-2.827496,
								9.642461
							],
							[
								-3.511899,
								9.900326
							],
							[
								-3.980449,
								9.862344
							],
							[
								-4.330247,
								9.610835
							],
							[
								-4.779884,
								9.821985
							],
							[
								-4.954653,
								10.152714
							],
							[
								-5.404342,
								10.370737
							],
							[
								-5.470565,
								10.95127
							],
							[
								-5.197843,
								11.375146
							],
							[
								-5.220942,
								11.713859
							],
							[
								-4.427166,
								12.542646
							],
							[
								-4.280405,
								13.228444
							],
							[
								-4.006391,
								13.472485
							],
							[
								-3.522803,
								13.337662
							],
							[
								-3.103707,
								13.541267
							],
							[
								-2.967694,
								13.79815
							],
							[
								-2.191825,
								14.246418
							],
							[
								-2.001035,
								14.559008
							],
							[
								-1.066363,
								14.973815
							],
							[
								-0.515854,
								15.116158
							],
							[
								-0.266257,
								14.924309
							],
							[
								0.374892,
								14.928908
							],
							[
								0.295646,
								14.444235
							],
							[
								0.429928,
								13.988733
							],
							[
								0.993046,
								13.33575
							],
							[
								1.024103,
								12.851826
							],
							[
								2.177108,
								12.625018
							],
							[
								2.154474,
								11.94015
							],
							[
								1.935986,
								11.64115
							],
							[
								1.447178,
								11.547719
							],
							[
								1.24347,
								11.110511
							],
							[
								0.899563,
								10.997339
							],
							[
								0.023803,
								11.018682
							],
							[
								-0.438702,
								11.098341
							],
							[
								-0.761576,
								10.93693
							],
							[
								-1.203358,
								11.009819
							],
							[
								-2.940409,
								10.96269
							],
							[
								-2.963896,
								10.395335
							],
							[
								-2.827496,
								9.642461
							]
						]
					]
				},
				"id": "BFA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Bangladesh"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								92.672721,
								22.041239
							],
							[
								92.652257,
								21.324048
							],
							[
								92.303234,
								21.475485
							],
							[
								92.368554,
								20.670883
							],
							[
								92.082886,
								21.192195
							],
							[
								92.025215,
								21.70157
							],
							[
								91.834891,
								22.182936
							],
							[
								91.417087,
								22.765019
							],
							[
								90.496006,
								22.805017
							],
							[
								90.586957,
								22.392794
							],
							[
								90.272971,
								21.836368
							],
							[
								89.847467,
								22.039146
							],
							[
								89.70205,
								21.857116
							],
							[
								89.418863,
								21.966179
							],
							[
								89.031961,
								22.055708
							],
							[
								88.876312,
								22.879146
							],
							[
								88.52977,
								23.631142
							],
							[
								88.69994,
								24.233715
							],
							[
								88.084422,
								24.501657
							],
							[
								88.306373,
								24.866079
							],
							[
								88.931554,
								25.238692
							],
							[
								88.209789,
								25.768066
							],
							[
								88.563049,
								26.446526
							],
							[
								89.355094,
								26.014407
							],
							[
								89.832481,
								25.965082
							],
							[
								89.920693,
								25.26975
							],
							[
								90.872211,
								25.132601
							],
							[
								91.799596,
								25.147432
							],
							[
								92.376202,
								24.976693
							],
							[
								91.915093,
								24.130414
							],
							[
								91.46773,
								24.072639
							],
							[
								91.158963,
								23.503527
							],
							[
								91.706475,
								22.985264
							],
							[
								91.869928,
								23.624346
							],
							[
								92.146035,
								23.627499
							],
							[
								92.672721,
								22.041239
							]
						]
					]
				},
				"id": "BGD"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Bulgaria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								22.65715,
								44.234923
							],
							[
								22.944832,
								43.823785
							],
							[
								23.332302,
								43.897011
							],
							[
								24.100679,
								43.741051
							],
							[
								25.569272,
								43.688445
							],
							[
								26.065159,
								43.943494
							],
							[
								27.2424,
								44.175986
							],
							[
								27.970107,
								43.812468
							],
							[
								28.558081,
								43.707462
							],
							[
								28.039095,
								43.293172
							],
							[
								27.673898,
								42.577892
							],
							[
								27.99672,
								42.007359
							],
							[
								27.135739,
								42.141485
							],
							[
								26.117042,
								41.826905
							],
							[
								26.106138,
								41.328899
							],
							[
								25.197201,
								41.234486
							],
							[
								24.492645,
								41.583896
							],
							[
								23.692074,
								41.309081
							],
							[
								22.952377,
								41.337994
							],
							[
								22.881374,
								41.999297
							],
							[
								22.380526,
								42.32026
							],
							[
								22.545012,
								42.461362
							],
							[
								22.436595,
								42.580321
							],
							[
								22.604801,
								42.898519
							],
							[
								22.986019,
								43.211161
							],
							[
								22.500157,
								43.642814
							],
							[
								22.410446,
								44.008063
							],
							[
								22.65715,
								44.234923
							]
						]
					]
				},
				"id": "BGR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "The Bahamas"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-77.53466,
									23.75975
								],
								[
									-77.78,
									23.71
								],
								[
									-78.03405,
									24.28615
								],
								[
									-78.40848,
									24.57564
								],
								[
									-78.19087,
									25.2103
								],
								[
									-77.89,
									25.17
								],
								[
									-77.54,
									24.34
								],
								[
									-77.53466,
									23.75975
								]
							]
						],
						[
							[
								[
									-77.82,
									26.58
								],
								[
									-78.91,
									26.42
								],
								[
									-78.98,
									26.79
								],
								[
									-78.51,
									26.87
								],
								[
									-77.85,
									26.84
								],
								[
									-77.82,
									26.58
								]
							]
						],
						[
							[
								[
									-77,
									26.59
								],
								[
									-77.17255,
									25.87918
								],
								[
									-77.35641,
									26.00735
								],
								[
									-77.34,
									26.53
								],
								[
									-77.78802,
									26.92516
								],
								[
									-77.79,
									27.04
								],
								[
									-77,
									26.59
								]
							]
						]
					]
				},
				"id": "BHS"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Bosnia and Herzegovina"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								19.005486,
								44.860234
							],
							[
								19.36803,
								44.863
							],
							[
								19.11761,
								44.42307
							],
							[
								19.59976,
								44.03847
							],
							[
								19.454,
								43.5681
							],
							[
								19.21852,
								43.52384
							],
							[
								19.03165,
								43.43253
							],
							[
								18.70648,
								43.20011
							],
							[
								18.56,
								42.65
							],
							[
								17.674922,
								43.028563
							],
							[
								17.297373,
								43.446341
							],
							[
								16.916156,
								43.667722
							],
							[
								16.456443,
								44.04124
							],
							[
								16.23966,
								44.351143
							],
							[
								15.750026,
								44.818712
							],
							[
								15.959367,
								45.233777
							],
							[
								16.318157,
								45.004127
							],
							[
								16.534939,
								45.211608
							],
							[
								17.002146,
								45.233777
							],
							[
								17.861783,
								45.06774
							],
							[
								18.553214,
								45.08159
							],
							[
								19.005486,
								44.860234
							]
						]
					]
				},
				"id": "BIH"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Belarus"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								23.484128,
								53.912498
							],
							[
								24.450684,
								53.905702
							],
							[
								25.536354,
								54.282423
							],
							[
								25.768433,
								54.846963
							],
							[
								26.588279,
								55.167176
							],
							[
								26.494331,
								55.615107
							],
							[
								27.10246,
								55.783314
							],
							[
								28.176709,
								56.16913
							],
							[
								29.229513,
								55.918344
							],
							[
								29.371572,
								55.670091
							],
							[
								29.896294,
								55.789463
							],
							[
								30.873909,
								55.550976
							],
							[
								30.971836,
								55.081548
							],
							[
								30.757534,
								54.811771
							],
							[
								31.384472,
								54.157056
							],
							[
								31.791424,
								53.974639
							],
							[
								31.731273,
								53.794029
							],
							[
								32.405599,
								53.618045
							],
							[
								32.693643,
								53.351421
							],
							[
								32.304519,
								53.132726
							],
							[
								31.497644,
								53.167427
							],
							[
								31.305201,
								53.073996
							],
							[
								31.540018,
								52.742052
							],
							[
								31.785998,
								52.101678
							],
							[
								30.927549,
								52.042353
							],
							[
								30.619454,
								51.822806
							],
							[
								30.555117,
								51.319503
							],
							[
								30.157364,
								51.416138
							],
							[
								29.254938,
								51.368234
							],
							[
								28.992835,
								51.602044
							],
							[
								28.617613,
								51.427714
							],
							[
								28.241615,
								51.572227
							],
							[
								27.454066,
								51.592303
							],
							[
								26.337959,
								51.832289
							],
							[
								25.327788,
								51.910656
							],
							[
								24.553106,
								51.888461
							],
							[
								24.005078,
								51.617444
							],
							[
								23.527071,
								51.578454
							],
							[
								23.508002,
								52.023647
							],
							[
								23.199494,
								52.486977
							],
							[
								23.799199,
								52.691099
							],
							[
								23.804935,
								53.089731
							],
							[
								23.527536,
								53.470122
							],
							[
								23.484128,
								53.912498
							]
						]
					]
				},
				"id": "BLR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Belize"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-89.14308,
								17.808319
							],
							[
								-89.150909,
								17.955468
							],
							[
								-89.029857,
								18.001511
							],
							[
								-88.848344,
								17.883198
							],
							[
								-88.490123,
								18.486831
							],
							[
								-88.300031,
								18.499982
							],
							[
								-88.296336,
								18.353273
							],
							[
								-88.106813,
								18.348674
							],
							[
								-88.123479,
								18.076675
							],
							[
								-88.285355,
								17.644143
							],
							[
								-88.197867,
								17.489475
							],
							[
								-88.302641,
								17.131694
							],
							[
								-88.239518,
								17.036066
							],
							[
								-88.355428,
								16.530774
							],
							[
								-88.551825,
								16.265467
							],
							[
								-88.732434,
								16.233635
							],
							[
								-88.930613,
								15.887273
							],
							[
								-89.229122,
								15.886938
							],
							[
								-89.150806,
								17.015577
							],
							[
								-89.14308,
								17.808319
							]
						]
					]
				},
				"id": "BLZ"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Bolivia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-62.846468,
								-22.034985
							],
							[
								-63.986838,
								-21.993644
							],
							[
								-64.377021,
								-22.798091
							],
							[
								-64.964892,
								-22.075862
							],
							[
								-66.273339,
								-21.83231
							],
							[
								-67.106674,
								-22.735925
							],
							[
								-67.82818,
								-22.872919
							],
							[
								-68.219913,
								-21.494347
							],
							[
								-68.757167,
								-20.372658
							],
							[
								-68.442225,
								-19.405068
							],
							[
								-68.966818,
								-18.981683
							],
							[
								-69.100247,
								-18.260125
							],
							[
								-69.590424,
								-17.580012
							],
							[
								-68.959635,
								-16.500698
							],
							[
								-69.389764,
								-15.660129
							],
							[
								-69.160347,
								-15.323974
							],
							[
								-69.339535,
								-14.953195
							],
							[
								-68.948887,
								-14.453639
							],
							[
								-68.929224,
								-13.602684
							],
							[
								-68.88008,
								-12.899729
							],
							[
								-68.66508,
								-12.5613
							],
							[
								-69.529678,
								-10.951734
							],
							[
								-68.786158,
								-11.03638
							],
							[
								-68.271254,
								-11.014521
							],
							[
								-68.048192,
								-10.712059
							],
							[
								-67.173801,
								-10.306812
							],
							[
								-66.646908,
								-9.931331
							],
							[
								-65.338435,
								-9.761988
							],
							[
								-65.444837,
								-10.511451
							],
							[
								-65.321899,
								-10.895872
							],
							[
								-65.402281,
								-11.56627
							],
							[
								-64.316353,
								-12.461978
							],
							[
								-63.196499,
								-12.627033
							],
							[
								-62.80306,
								-13.000653
							],
							[
								-62.127081,
								-13.198781
							],
							[
								-61.713204,
								-13.489202
							],
							[
								-61.084121,
								-13.479384
							],
							[
								-60.503304,
								-13.775955
							],
							[
								-60.459198,
								-14.354007
							],
							[
								-60.264326,
								-14.645979
							],
							[
								-60.251149,
								-15.077219
							],
							[
								-60.542966,
								-15.09391
							],
							[
								-60.15839,
								-16.258284
							],
							[
								-58.24122,
								-16.299573
							],
							[
								-58.388058,
								-16.877109
							],
							[
								-58.280804,
								-17.27171
							],
							[
								-57.734558,
								-17.552468
							],
							[
								-57.498371,
								-18.174188
							],
							[
								-57.676009,
								-18.96184
							],
							[
								-57.949997,
								-19.400004
							],
							[
								-57.853802,
								-19.969995
							],
							[
								-58.166392,
								-20.176701
							],
							[
								-58.183471,
								-19.868399
							],
							[
								-59.115042,
								-19.356906
							],
							[
								-60.043565,
								-19.342747
							],
							[
								-61.786326,
								-19.633737
							],
							[
								-62.265961,
								-20.513735
							],
							[
								-62.291179,
								-21.051635
							],
							[
								-62.685057,
								-22.249029
							],
							[
								-62.846468,
								-22.034985
							]
						]
					]
				},
				"id": "BOL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Brazil"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-57.625133,
								-30.216295
							],
							[
								-56.2909,
								-28.852761
							],
							[
								-55.162286,
								-27.881915
							],
							[
								-54.490725,
								-27.474757
							],
							[
								-53.648735,
								-26.923473
							],
							[
								-53.628349,
								-26.124865
							],
							[
								-54.13005,
								-25.547639
							],
							[
								-54.625291,
								-25.739255
							],
							[
								-54.428946,
								-25.162185
							],
							[
								-54.293476,
								-24.5708
							],
							[
								-54.29296,
								-24.021014
							],
							[
								-54.652834,
								-23.839578
							],
							[
								-55.027902,
								-24.001274
							],
							[
								-55.400747,
								-23.956935
							],
							[
								-55.517639,
								-23.571998
							],
							[
								-55.610683,
								-22.655619
							],
							[
								-55.797958,
								-22.35693
							],
							[
								-56.473317,
								-22.0863
							],
							[
								-56.88151,
								-22.282154
							],
							[
								-57.937156,
								-22.090176
							],
							[
								-57.870674,
								-20.732688
							],
							[
								-58.166392,
								-20.176701
							],
							[
								-57.853802,
								-19.969995
							],
							[
								-57.949997,
								-19.400004
							],
							[
								-57.676009,
								-18.96184
							],
							[
								-57.498371,
								-18.174188
							],
							[
								-57.734558,
								-17.552468
							],
							[
								-58.280804,
								-17.27171
							],
							[
								-58.388058,
								-16.877109
							],
							[
								-58.24122,
								-16.299573
							],
							[
								-60.15839,
								-16.258284
							],
							[
								-60.542966,
								-15.09391
							],
							[
								-60.251149,
								-15.077219
							],
							[
								-60.264326,
								-14.645979
							],
							[
								-60.459198,
								-14.354007
							],
							[
								-60.503304,
								-13.775955
							],
							[
								-61.084121,
								-13.479384
							],
							[
								-61.713204,
								-13.489202
							],
							[
								-62.127081,
								-13.198781
							],
							[
								-62.80306,
								-13.000653
							],
							[
								-63.196499,
								-12.627033
							],
							[
								-64.316353,
								-12.461978
							],
							[
								-65.402281,
								-11.56627
							],
							[
								-65.321899,
								-10.895872
							],
							[
								-65.444837,
								-10.511451
							],
							[
								-65.338435,
								-9.761988
							],
							[
								-66.646908,
								-9.931331
							],
							[
								-67.173801,
								-10.306812
							],
							[
								-68.048192,
								-10.712059
							],
							[
								-68.271254,
								-11.014521
							],
							[
								-68.786158,
								-11.03638
							],
							[
								-69.529678,
								-10.951734
							],
							[
								-70.093752,
								-11.123972
							],
							[
								-70.548686,
								-11.009147
							],
							[
								-70.481894,
								-9.490118
							],
							[
								-71.302412,
								-10.079436
							],
							[
								-72.184891,
								-10.053598
							],
							[
								-72.563033,
								-9.520194
							],
							[
								-73.226713,
								-9.462213
							],
							[
								-73.015383,
								-9.032833
							],
							[
								-73.571059,
								-8.424447
							],
							[
								-73.987235,
								-7.52383
							],
							[
								-73.723401,
								-7.340999
							],
							[
								-73.724487,
								-6.918595
							],
							[
								-73.120027,
								-6.629931
							],
							[
								-73.219711,
								-6.089189
							],
							[
								-72.964507,
								-5.741251
							],
							[
								-72.891928,
								-5.274561
							],
							[
								-71.748406,
								-4.593983
							],
							[
								-70.928843,
								-4.401591
							],
							[
								-70.794769,
								-4.251265
							],
							[
								-69.893635,
								-4.298187
							],
							[
								-69.444102,
								-1.556287
							],
							[
								-69.420486,
								-1.122619
							],
							[
								-69.577065,
								-0.549992
							],
							[
								-70.020656,
								-0.185156
							],
							[
								-70.015566,
								0.541414
							],
							[
								-69.452396,
								0.706159
							],
							[
								-69.252434,
								0.602651
							],
							[
								-69.218638,
								0.985677
							],
							[
								-69.804597,
								1.089081
							],
							[
								-69.816973,
								1.714805
							],
							[
								-67.868565,
								1.692455
							],
							[
								-67.53781,
								2.037163
							],
							[
								-67.259998,
								1.719999
							],
							[
								-67.065048,
								1.130112
							],
							[
								-66.876326,
								1.253361
							],
							[
								-66.325765,
								0.724452
							],
							[
								-65.548267,
								0.789254
							],
							[
								-65.354713,
								1.095282
							],
							[
								-64.611012,
								1.328731
							],
							[
								-64.199306,
								1.492855
							],
							[
								-64.083085,
								1.916369
							],
							[
								-63.368788,
								2.2009
							],
							[
								-63.422867,
								2.411068
							],
							[
								-64.269999,
								2.497006
							],
							[
								-64.408828,
								3.126786
							],
							[
								-64.368494,
								3.79721
							],
							[
								-64.816064,
								4.056445
							],
							[
								-64.628659,
								4.148481
							],
							[
								-63.888343,
								4.02053
							],
							[
								-63.093198,
								3.770571
							],
							[
								-62.804533,
								4.006965
							],
							[
								-62.08543,
								4.162124
							],
							[
								-60.966893,
								4.536468
							],
							[
								-60.601179,
								4.918098
							],
							[
								-60.733574,
								5.200277
							],
							[
								-60.213683,
								5.244486
							],
							[
								-59.980959,
								5.014061
							],
							[
								-60.111002,
								4.574967
							],
							[
								-59.767406,
								4.423503
							],
							[
								-59.53804,
								3.958803
							],
							[
								-59.815413,
								3.606499
							],
							[
								-59.974525,
								2.755233
							],
							[
								-59.718546,
								2.24963
							],
							[
								-59.646044,
								1.786894
							],
							[
								-59.030862,
								1.317698
							],
							[
								-58.540013,
								1.268088
							],
							[
								-58.429477,
								1.463942
							],
							[
								-58.11345,
								1.507195
							],
							[
								-57.660971,
								1.682585
							],
							[
								-57.335823,
								1.948538
							],
							[
								-56.782704,
								1.863711
							],
							[
								-56.539386,
								1.899523
							],
							[
								-55.995698,
								1.817667
							],
							[
								-55.9056,
								2.021996
							],
							[
								-56.073342,
								2.220795
							],
							[
								-55.973322,
								2.510364
							],
							[
								-55.569755,
								2.421506
							],
							[
								-55.097587,
								2.523748
							],
							[
								-54.524754,
								2.311849
							],
							[
								-54.088063,
								2.105557
							],
							[
								-53.778521,
								2.376703
							],
							[
								-53.554839,
								2.334897
							],
							[
								-53.418465,
								2.053389
							],
							[
								-52.939657,
								2.124858
							],
							[
								-52.556425,
								2.504705
							],
							[
								-52.249338,
								3.241094
							],
							[
								-51.657797,
								4.156232
							],
							[
								-51.317146,
								4.203491
							],
							[
								-51.069771,
								3.650398
							],
							[
								-50.508875,
								1.901564
							],
							[
								-49.974076,
								1.736483
							],
							[
								-49.947101,
								1.04619
							],
							[
								-50.699251,
								0.222984
							],
							[
								-50.388211,
								-0.078445
							],
							[
								-48.620567,
								-0.235489
							],
							[
								-48.584497,
								-1.237805
							],
							[
								-47.824956,
								-0.581618
							],
							[
								-46.566584,
								-0.941028
							],
							[
								-44.905703,
								-1.55174
							],
							[
								-44.417619,
								-2.13775
							],
							[
								-44.581589,
								-2.691308
							],
							[
								-43.418791,
								-2.38311
							],
							[
								-41.472657,
								-2.912018
							],
							[
								-39.978665,
								-2.873054
							],
							[
								-38.500383,
								-3.700652
							],
							[
								-37.223252,
								-4.820946
							],
							[
								-36.452937,
								-5.109404
							],
							[
								-35.597796,
								-5.149504
							],
							[
								-35.235389,
								-5.464937
							],
							[
								-34.89603,
								-6.738193
							],
							[
								-34.729993,
								-7.343221
							],
							[
								-35.128212,
								-8.996401
							],
							[
								-35.636967,
								-9.649282
							],
							[
								-37.046519,
								-11.040721
							],
							[
								-37.683612,
								-12.171195
							],
							[
								-38.423877,
								-13.038119
							],
							[
								-38.673887,
								-13.057652
							],
							[
								-38.953276,
								-13.79337
							],
							[
								-38.882298,
								-15.667054
							],
							[
								-39.161092,
								-17.208407
							],
							[
								-39.267339,
								-17.867746
							],
							[
								-39.583521,
								-18.262296
							],
							[
								-39.760823,
								-19.599113
							],
							[
								-40.774741,
								-20.904512
							],
							[
								-40.944756,
								-21.937317
							],
							[
								-41.754164,
								-22.370676
							],
							[
								-41.988284,
								-22.97007
							],
							[
								-43.074704,
								-22.967693
							],
							[
								-44.647812,
								-23.351959
							],
							[
								-45.352136,
								-23.796842
							],
							[
								-46.472093,
								-24.088969
							],
							[
								-47.648972,
								-24.885199
							],
							[
								-48.495458,
								-25.877025
							],
							[
								-48.641005,
								-26.623698
							],
							[
								-48.474736,
								-27.175912
							],
							[
								-48.66152,
								-28.186135
							],
							[
								-48.888457,
								-28.674115
							],
							[
								-49.587329,
								-29.224469
							],
							[
								-50.696874,
								-30.984465
							],
							[
								-51.576226,
								-31.777698
							],
							[
								-52.256081,
								-32.24537
							],
							[
								-52.7121,
								-33.196578
							],
							[
								-53.373662,
								-33.768378
							],
							[
								-53.650544,
								-33.202004
							],
							[
								-53.209589,
								-32.727666
							],
							[
								-53.787952,
								-32.047243
							],
							[
								-54.572452,
								-31.494511
							],
							[
								-55.60151,
								-30.853879
							],
							[
								-55.973245,
								-30.883076
							],
							[
								-56.976026,
								-30.109686
							],
							[
								-57.625133,
								-30.216295
							]
						]
					]
				},
				"id": "BRA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Brunei"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								114.204017,
								4.525874
							],
							[
								114.599961,
								4.900011
							],
							[
								115.45071,
								5.44773
							],
							[
								115.4057,
								4.955228
							],
							[
								115.347461,
								4.316636
							],
							[
								114.869557,
								4.348314
							],
							[
								114.659596,
								4.007637
							],
							[
								114.204017,
								4.525874
							]
						]
					]
				},
				"id": "BRN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Bhutan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								91.696657,
								27.771742
							],
							[
								92.103712,
								27.452614
							],
							[
								92.033484,
								26.83831
							],
							[
								91.217513,
								26.808648
							],
							[
								90.373275,
								26.875724
							],
							[
								89.744528,
								26.719403
							],
							[
								88.835643,
								27.098966
							],
							[
								88.814248,
								27.299316
							],
							[
								89.47581,
								28.042759
							],
							[
								90.015829,
								28.296439
							],
							[
								90.730514,
								28.064954
							],
							[
								91.258854,
								28.040614
							],
							[
								91.696657,
								27.771742
							]
						]
					]
				},
				"id": "BTN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Botswana"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								25.649163,
								-18.536026
							],
							[
								25.850391,
								-18.714413
							],
							[
								26.164791,
								-19.293086
							],
							[
								27.296505,
								-20.39152
							],
							[
								27.724747,
								-20.499059
							],
							[
								27.727228,
								-20.851802
							],
							[
								28.02137,
								-21.485975
							],
							[
								28.794656,
								-21.639454
							],
							[
								29.432188,
								-22.091313
							],
							[
								28.017236,
								-22.827754
							],
							[
								27.11941,
								-23.574323
							],
							[
								26.786407,
								-24.240691
							],
							[
								26.485753,
								-24.616327
							],
							[
								25.941652,
								-24.696373
							],
							[
								25.765849,
								-25.174845
							],
							[
								25.664666,
								-25.486816
							],
							[
								25.025171,
								-25.71967
							],
							[
								24.211267,
								-25.670216
							],
							[
								23.73357,
								-25.390129
							],
							[
								23.312097,
								-25.26869
							],
							[
								22.824271,
								-25.500459
							],
							[
								22.579532,
								-25.979448
							],
							[
								22.105969,
								-26.280256
							],
							[
								21.605896,
								-26.726534
							],
							[
								20.889609,
								-26.828543
							],
							[
								20.66647,
								-26.477453
							],
							[
								20.758609,
								-25.868136
							],
							[
								20.165726,
								-24.917962
							],
							[
								19.895768,
								-24.76779
							],
							[
								19.895458,
								-21.849157
							],
							[
								20.881134,
								-21.814327
							],
							[
								20.910641,
								-18.252219
							],
							[
								21.65504,
								-18.219146
							],
							[
								23.196858,
								-17.869038
							],
							[
								23.579006,
								-18.281261
							],
							[
								24.217365,
								-17.889347
							],
							[
								24.520705,
								-17.887125
							],
							[
								25.084443,
								-17.661816
							],
							[
								25.264226,
								-17.73654
							],
							[
								25.649163,
								-18.536026
							]
						]
					]
				},
				"id": "BWA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Central African Republic"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								15.27946,
								7.421925
							],
							[
								16.106232,
								7.497088
							],
							[
								16.290562,
								7.754307
							],
							[
								16.456185,
								7.734774
							],
							[
								16.705988,
								7.508328
							],
							[
								17.96493,
								7.890914
							],
							[
								18.389555,
								8.281304
							],
							[
								18.911022,
								8.630895
							],
							[
								18.81201,
								8.982915
							],
							[
								19.094008,
								9.074847
							],
							[
								20.059685,
								9.012706
							],
							[
								21.000868,
								9.475985
							],
							[
								21.723822,
								10.567056
							],
							[
								22.231129,
								10.971889
							],
							[
								22.864165,
								11.142395
							],
							[
								22.977544,
								10.714463
							],
							[
								23.554304,
								10.089255
							],
							[
								23.55725,
								9.681218
							],
							[
								23.394779,
								9.265068
							],
							[
								23.459013,
								8.954286
							],
							[
								23.805813,
								8.666319
							],
							[
								24.567369,
								8.229188
							],
							[
								25.114932,
								7.825104
							],
							[
								25.124131,
								7.500085
							],
							[
								25.796648,
								6.979316
							],
							[
								26.213418,
								6.546603
							],
							[
								26.465909,
								5.946717
							],
							[
								27.213409,
								5.550953
							],
							[
								27.374226,
								5.233944
							],
							[
								27.044065,
								5.127853
							],
							[
								26.402761,
								5.150875
							],
							[
								25.650455,
								5.256088
							],
							[
								25.278798,
								5.170408
							],
							[
								25.128833,
								4.927245
							],
							[
								24.805029,
								4.897247
							],
							[
								24.410531,
								5.108784
							],
							[
								23.297214,
								4.609693
							],
							[
								22.84148,
								4.710126
							],
							[
								22.704124,
								4.633051
							],
							[
								22.405124,
								4.02916
							],
							[
								21.659123,
								4.224342
							],
							[
								20.927591,
								4.322786
							],
							[
								20.290679,
								4.691678
							],
							[
								19.467784,
								5.031528
							],
							[
								18.932312,
								4.709506
							],
							[
								18.542982,
								4.201785
							],
							[
								18.453065,
								3.504386
							],
							[
								17.8099,
								3.560196
							],
							[
								17.133042,
								3.728197
							],
							[
								16.537058,
								3.198255
							],
							[
								16.012852,
								2.26764
							],
							[
								15.907381,
								2.557389
							],
							[
								15.862732,
								3.013537
							],
							[
								15.405396,
								3.335301
							],
							[
								15.03622,
								3.851367
							],
							[
								14.950953,
								4.210389
							],
							[
								14.478372,
								4.732605
							],
							[
								14.558936,
								5.030598
							],
							[
								14.459407,
								5.451761
							],
							[
								14.53656,
								6.226959
							],
							[
								14.776545,
								6.408498
							],
							[
								15.27946,
								7.421925
							]
						]
					]
				},
				"id": "CAF"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Canada"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-63.6645,
									46.55001
								],
								[
									-62.9393,
									46.41587
								],
								[
									-62.01208,
									46.44314
								],
								[
									-62.50391,
									46.03339
								],
								[
									-62.87433,
									45.96818
								],
								[
									-64.1428,
									46.39265
								],
								[
									-64.39261,
									46.72747
								],
								[
									-64.01486,
									47.03601
								],
								[
									-63.6645,
									46.55001
								]
							]
						],
						[
							[
								[
									-61.806305,
									49.10506
								],
								[
									-62.29318,
									49.08717
								],
								[
									-63.58926,
									49.40069
								],
								[
									-64.51912,
									49.87304
								],
								[
									-64.17322,
									49.95718
								],
								[
									-62.85829,
									49.70641
								],
								[
									-61.835585,
									49.28855
								],
								[
									-61.806305,
									49.10506
								]
							]
						],
						[
							[
								[
									-123.510002,
									48.510011
								],
								[
									-124.012891,
									48.370846
								],
								[
									-125.655013,
									48.825005
								],
								[
									-125.954994,
									49.179996
								],
								[
									-126.850004,
									49.53
								],
								[
									-127.029993,
									49.814996
								],
								[
									-128.059336,
									49.994959
								],
								[
									-128.444584,
									50.539138
								],
								[
									-128.358414,
									50.770648
								],
								[
									-127.308581,
									50.552574
								],
								[
									-126.695001,
									50.400903
								],
								[
									-125.755007,
									50.295018
								],
								[
									-125.415002,
									49.950001
								],
								[
									-124.920768,
									49.475275
								],
								[
									-123.922509,
									49.062484
								],
								[
									-123.510002,
									48.510011
								]
							]
						],
						[
							[
								[
									-56.134036,
									50.68701
								],
								[
									-56.795882,
									49.812309
								],
								[
									-56.143105,
									50.150117
								],
								[
									-55.471492,
									49.935815
								],
								[
									-55.822401,
									49.587129
								],
								[
									-54.935143,
									49.313011
								],
								[
									-54.473775,
									49.556691
								],
								[
									-53.476549,
									49.249139
								],
								[
									-53.786014,
									48.516781
								],
								[
									-53.086134,
									48.687804
								],
								[
									-52.958648,
									48.157164
								],
								[
									-52.648099,
									47.535548
								],
								[
									-53.069158,
									46.655499
								],
								[
									-53.521456,
									46.618292
								],
								[
									-54.178936,
									46.807066
								],
								[
									-53.961869,
									47.625207
								],
								[
									-54.240482,
									47.752279
								],
								[
									-55.400773,
									46.884994
								],
								[
									-55.997481,
									46.91972
								],
								[
									-55.291219,
									47.389562
								],
								[
									-56.250799,
									47.632545
								],
								[
									-57.325229,
									47.572807
								],
								[
									-59.266015,
									47.603348
								],
								[
									-59.419494,
									47.899454
								],
								[
									-58.796586,
									48.251525
								],
								[
									-59.231625,
									48.523188
								],
								[
									-58.391805,
									49.125581
								],
								[
									-57.35869,
									50.718274
								],
								[
									-56.73865,
									51.287438
								],
								[
									-55.870977,
									51.632094
								],
								[
									-55.406974,
									51.588273
								],
								[
									-55.600218,
									51.317075
								],
								[
									-56.134036,
									50.68701
								]
							]
						],
						[
							[
								[
									-132.710008,
									54.040009
								],
								[
									-132.710009,
									54.040009
								],
								[
									-132.710008,
									54.040009
								],
								[
									-132.710008,
									54.040009
								],
								[
									-131.74999,
									54.120004
								],
								[
									-132.04948,
									52.984621
								],
								[
									-131.179043,
									52.180433
								],
								[
									-131.57783,
									52.182371
								],
								[
									-132.180428,
									52.639707
								],
								[
									-132.549992,
									53.100015
								],
								[
									-133.054611,
									53.411469
								],
								[
									-133.239664,
									53.85108
								],
								[
									-133.180004,
									54.169975
								],
								[
									-132.710008,
									54.040009
								]
							]
						],
						[
							[
								[
									-79.26582,
									62.158675
								],
								[
									-79.65752,
									61.63308
								],
								[
									-80.09956,
									61.7181
								],
								[
									-80.36215,
									62.01649
								],
								[
									-80.315395,
									62.085565
								],
								[
									-79.92939,
									62.3856
								],
								[
									-79.52002,
									62.36371
								],
								[
									-79.26582,
									62.158675
								]
							]
						],
						[
							[
								[
									-81.89825,
									62.7108
								],
								[
									-83.06857,
									62.15922
								],
								[
									-83.77462,
									62.18231
								],
								[
									-83.99367,
									62.4528
								],
								[
									-83.25048,
									62.91409
								],
								[
									-81.87699,
									62.90458
								],
								[
									-81.89825,
									62.7108
								]
							]
						],
						[
							[
								[
									-85.161308,
									65.657285
								],
								[
									-84.975764,
									65.217518
								],
								[
									-84.464012,
									65.371772
								],
								[
									-83.882626,
									65.109618
								],
								[
									-82.787577,
									64.766693
								],
								[
									-81.642014,
									64.455136
								],
								[
									-81.55344,
									63.979609
								],
								[
									-80.817361,
									64.057486
								],
								[
									-80.103451,
									63.725981
								],
								[
									-80.99102,
									63.411246
								],
								[
									-82.547178,
									63.651722
								],
								[
									-83.108798,
									64.101876
								],
								[
									-84.100417,
									63.569712
								],
								[
									-85.523405,
									63.052379
								],
								[
									-85.866769,
									63.637253
								],
								[
									-87.221983,
									63.541238
								],
								[
									-86.35276,
									64.035833
								],
								[
									-86.224886,
									64.822917
								],
								[
									-85.883848,
									65.738778
								],
								[
									-85.161308,
									65.657285
								]
							]
						],
						[
							[
								[
									-75.86588,
									67.14886
								],
								[
									-76.98687,
									67.09873
								],
								[
									-77.2364,
									67.58809
								],
								[
									-76.81166,
									68.14856
								],
								[
									-75.89521,
									68.28721
								],
								[
									-75.1145,
									68.01036
								],
								[
									-75.10333,
									67.58202
								],
								[
									-75.21597,
									67.44425
								],
								[
									-75.86588,
									67.14886
								]
							]
						],
						[
							[
								[
									-95.647681,
									69.10769
								],
								[
									-96.269521,
									68.75704
								],
								[
									-97.617401,
									69.06003
								],
								[
									-98.431801,
									68.9507
								],
								[
									-99.797401,
									69.40003
								],
								[
									-98.917401,
									69.71003
								],
								[
									-98.218261,
									70.14354
								],
								[
									-97.157401,
									69.86003
								],
								[
									-96.557401,
									69.68003
								],
								[
									-96.257401,
									69.49003
								],
								[
									-95.647681,
									69.10769
								]
							]
						],
						[
							[
								[
									-90.5471,
									69.49766
								],
								[
									-90.55151,
									68.47499
								],
								[
									-89.21515,
									69.25873
								],
								[
									-88.01966,
									68.61508
								],
								[
									-88.31749,
									67.87338
								],
								[
									-87.35017,
									67.19872
								],
								[
									-86.30607,
									67.92146
								],
								[
									-85.57664,
									68.78456
								],
								[
									-85.52197,
									69.88211
								],
								[
									-84.10081,
									69.80539
								],
								[
									-82.62258,
									69.65826
								],
								[
									-81.28043,
									69.16202
								],
								[
									-81.2202,
									68.66567
								],
								[
									-81.96436,
									68.13253
								],
								[
									-81.25928,
									67.59716
								],
								[
									-81.38653,
									67.11078
								],
								[
									-83.34456,
									66.41154
								],
								[
									-84.73542,
									66.2573
								],
								[
									-85.76943,
									66.55833
								],
								[
									-86.0676,
									66.05625
								],
								[
									-87.03143,
									65.21297
								],
								[
									-87.32324,
									64.77563
								],
								[
									-88.48296,
									64.09897
								],
								[
									-89.91444,
									64.03273
								],
								[
									-90.70398,
									63.61017
								],
								[
									-90.77004,
									62.96021
								],
								[
									-91.93342,
									62.83508
								],
								[
									-93.15698,
									62.02469
								],
								[
									-94.24153,
									60.89865
								],
								[
									-94.62931,
									60.11021
								],
								[
									-94.6846,
									58.94882
								],
								[
									-93.21502,
									58.78212
								],
								[
									-92.76462,
									57.84571
								],
								[
									-92.29703,
									57.08709
								],
								[
									-90.89769,
									57.28468
								],
								[
									-89.03953,
									56.85172
								],
								[
									-88.03978,
									56.47162
								],
								[
									-87.32421,
									55.99914
								],
								[
									-86.07121,
									55.72383
								],
								[
									-85.01181,
									55.3026
								],
								[
									-83.36055,
									55.24489
								],
								[
									-82.27285,
									55.14832
								],
								[
									-82.4362,
									54.28227
								],
								[
									-82.12502,
									53.27703
								],
								[
									-81.40075,
									52.15788
								],
								[
									-79.91289,
									51.20842
								],
								[
									-79.14301,
									51.53393
								],
								[
									-78.60191,
									52.56208
								],
								[
									-79.12421,
									54.14145
								],
								[
									-79.82958,
									54.66772
								],
								[
									-78.22874,
									55.13645
								],
								[
									-77.0956,
									55.83741
								],
								[
									-76.54137,
									56.53423
								],
								[
									-76.62319,
									57.20263
								],
								[
									-77.30226,
									58.05209
								],
								[
									-78.51688,
									58.80458
								],
								[
									-77.33676,
									59.85261
								],
								[
									-77.77272,
									60.75788
								],
								[
									-78.10687,
									62.31964
								],
								[
									-77.41067,
									62.55053
								],
								[
									-75.69621,
									62.2784
								],
								[
									-74.6682,
									62.18111
								],
								[
									-73.83988,
									62.4438
								],
								[
									-72.90853,
									62.10507
								],
								[
									-71.67708,
									61.52535
								],
								[
									-71.37369,
									61.13717
								],
								[
									-69.59042,
									61.06141
								],
								[
									-69.62033,
									60.22125
								],
								[
									-69.2879,
									58.95736
								],
								[
									-68.37455,
									58.80106
								],
								[
									-67.64976,
									58.21206
								],
								[
									-66.20178,
									58.76731
								],
								[
									-65.24517,
									59.87071
								],
								[
									-64.58352,
									60.33558
								],
								[
									-63.80475,
									59.4426
								],
								[
									-62.50236,
									58.16708
								],
								[
									-61.39655,
									56.96745
								],
								[
									-61.79866,
									56.33945
								],
								[
									-60.46853,
									55.77548
								],
								[
									-59.56962,
									55.20407
								],
								[
									-57.97508,
									54.94549
								],
								[
									-57.3332,
									54.6265
								],
								[
									-56.93689,
									53.78032
								],
								[
									-56.15811,
									53.64749
								],
								[
									-55.75632,
									53.27036
								],
								[
									-55.68338,
									52.14664
								],
								[
									-56.40916,
									51.7707
								],
								[
									-57.12691,
									51.41972
								],
								[
									-58.77482,
									51.0643
								],
								[
									-60.03309,
									50.24277
								],
								[
									-61.72366,
									50.08046
								],
								[
									-63.86251,
									50.29099
								],
								[
									-65.36331,
									50.2982
								],
								[
									-66.39905,
									50.22897
								],
								[
									-67.23631,
									49.51156
								],
								[
									-68.51114,
									49.06836
								],
								[
									-69.95362,
									47.74488
								],
								[
									-71.10458,
									46.82171
								],
								[
									-70.25522,
									46.98606
								],
								[
									-68.65,
									48.3
								],
								[
									-66.55243,
									49.1331
								],
								[
									-65.05626,
									49.23278
								],
								[
									-64.17099,
									48.74248
								],
								[
									-65.11545,
									48.07085
								],
								[
									-64.79854,
									46.99297
								],
								[
									-64.47219,
									46.23849
								],
								[
									-63.17329,
									45.73902
								],
								[
									-61.52072,
									45.88377
								],
								[
									-60.51815,
									47.00793
								],
								[
									-60.4486,
									46.28264
								],
								[
									-59.80287,
									45.9204
								],
								[
									-61.03988,
									45.26525
								],
								[
									-63.25471,
									44.67014
								],
								[
									-64.24656,
									44.26553
								],
								[
									-65.36406,
									43.54523
								],
								[
									-66.1234,
									43.61867
								],
								[
									-66.16173,
									44.46512
								],
								[
									-64.42549,
									45.29204
								],
								[
									-66.02605,
									45.25931
								],
								[
									-67.13741,
									45.13753
								],
								[
									-67.79134,
									45.70281
								],
								[
									-67.79046,
									47.06636
								],
								[
									-68.23444,
									47.35486
								],
								[
									-68.905,
									47.185
								],
								[
									-69.237216,
									47.447781
								],
								[
									-69.99997,
									46.69307
								],
								[
									-70.305,
									45.915
								],
								[
									-70.66,
									45.46
								],
								[
									-71.08482,
									45.30524
								],
								[
									-71.405,
									45.255
								],
								[
									-71.50506,
									45.0082
								],
								[
									-73.34783,
									45.00738
								],
								[
									-74.867,
									45.00048
								],
								[
									-75.31821,
									44.81645
								],
								[
									-76.375,
									44.09631
								],
								[
									-76.5,
									44.018459
								],
								[
									-76.820034,
									43.628784
								],
								[
									-77.737885,
									43.629056
								],
								[
									-78.72028,
									43.625089
								],
								[
									-79.171674,
									43.466339
								],
								[
									-79.01,
									43.27
								],
								[
									-78.92,
									42.965
								],
								[
									-78.939362,
									42.863611
								],
								[
									-80.247448,
									42.3662
								],
								[
									-81.277747,
									42.209026
								],
								[
									-82.439278,
									41.675105
								],
								[
									-82.690089,
									41.675105
								],
								[
									-83.02981,
									41.832796
								],
								[
									-83.142,
									41.975681
								],
								[
									-83.12,
									42.08
								],
								[
									-82.9,
									42.43
								],
								[
									-82.43,
									42.98
								],
								[
									-82.137642,
									43.571088
								],
								[
									-82.337763,
									44.44
								],
								[
									-82.550925,
									45.347517
								],
								[
									-83.592851,
									45.816894
								],
								[
									-83.469551,
									45.994686
								],
								[
									-83.616131,
									46.116927
								],
								[
									-83.890765,
									46.116927
								],
								[
									-84.091851,
									46.275419
								],
								[
									-84.14212,
									46.512226
								],
								[
									-84.3367,
									46.40877
								],
								[
									-84.6049,
									46.4396
								],
								[
									-84.543749,
									46.538684
								],
								[
									-84.779238,
									46.637102
								],
								[
									-84.87608,
									46.900083
								],
								[
									-85.652363,
									47.220219
								],
								[
									-86.461991,
									47.553338
								],
								[
									-87.439793,
									47.94
								],
								[
									-88.378114,
									48.302918
								],
								[
									-89.272917,
									48.019808
								],
								[
									-89.6,
									48.01
								],
								[
									-90.83,
									48.27
								],
								[
									-91.64,
									48.14
								],
								[
									-92.61,
									48.45
								],
								[
									-93.63087,
									48.60926
								],
								[
									-94.32914,
									48.67074
								],
								[
									-94.64,
									48.84
								],
								[
									-94.81758,
									49.38905
								],
								[
									-95.15609,
									49.38425
								],
								[
									-95.15907,
									49
								],
								[
									-97.22872,
									49.0007
								],
								[
									-100.65,
									49
								],
								[
									-104.04826,
									48.99986
								],
								[
									-107.05,
									49
								],
								[
									-110.05,
									49
								],
								[
									-113,
									49
								],
								[
									-116.04818,
									49
								],
								[
									-117.03121,
									49
								],
								[
									-120,
									49
								],
								[
									-122.84,
									49
								],
								[
									-122.97421,
									49.002538
								],
								[
									-124.91024,
									49.98456
								],
								[
									-125.62461,
									50.41656
								],
								[
									-127.43561,
									50.83061
								],
								[
									-127.99276,
									51.71583
								],
								[
									-127.85032,
									52.32961
								],
								[
									-129.12979,
									52.75538
								],
								[
									-129.30523,
									53.56159
								],
								[
									-130.51497,
									54.28757
								],
								[
									-130.53611,
									54.80278
								],
								[
									-129.98,
									55.285
								],
								[
									-130.00778,
									55.91583
								],
								[
									-131.70781,
									56.55212
								],
								[
									-132.73042,
									57.69289
								],
								[
									-133.35556,
									58.41028
								],
								[
									-134.27111,
									58.86111
								],
								[
									-134.945,
									59.27056
								],
								[
									-135.47583,
									59.78778
								],
								[
									-136.47972,
									59.46389
								],
								[
									-137.4525,
									58.905
								],
								[
									-138.34089,
									59.56211
								],
								[
									-139.039,
									60
								],
								[
									-140.013,
									60.27682
								],
								[
									-140.99778,
									60.30639
								],
								[
									-140.9925,
									66.00003
								],
								[
									-140.986,
									69.712
								],
								[
									-139.12052,
									69.47102
								],
								[
									-137.54636,
									68.99002
								],
								[
									-136.50358,
									68.89804
								],
								[
									-135.62576,
									69.31512
								],
								[
									-134.41464,
									69.62743
								],
								[
									-132.92925,
									69.50534
								],
								[
									-131.43136,
									69.94451
								],
								[
									-129.79471,
									70.19369
								],
								[
									-129.10773,
									69.77927
								],
								[
									-128.36156,
									70.01286
								],
								[
									-128.13817,
									70.48384
								],
								[
									-127.44712,
									70.37721
								],
								[
									-125.75632,
									69.48058
								],
								[
									-124.42483,
									70.1584
								],
								[
									-124.28968,
									69.39969
								],
								[
									-123.06108,
									69.56372
								],
								[
									-122.6835,
									69.85553
								],
								[
									-121.47226,
									69.79778
								],
								[
									-119.94288,
									69.37786
								],
								[
									-117.60268,
									69.01128
								],
								[
									-116.22643,
									68.84151
								],
								[
									-115.2469,
									68.90591
								],
								[
									-113.89794,
									68.3989
								],
								[
									-115.30489,
									67.90261
								],
								[
									-113.49727,
									67.68815
								],
								[
									-110.798,
									67.80612
								],
								[
									-109.94619,
									67.98104
								],
								[
									-108.8802,
									67.38144
								],
								[
									-107.79239,
									67.88736
								],
								[
									-108.81299,
									68.31164
								],
								[
									-108.16721,
									68.65392
								],
								[
									-106.95,
									68.7
								],
								[
									-106.15,
									68.8
								],
								[
									-105.34282,
									68.56122
								],
								[
									-104.33791,
									68.018
								],
								[
									-103.22115,
									68.09775
								],
								[
									-101.45433,
									67.64689
								],
								[
									-99.90195,
									67.80566
								],
								[
									-98.4432,
									67.78165
								],
								[
									-98.5586,
									68.40394
								],
								[
									-97.66948,
									68.57864
								],
								[
									-96.11991,
									68.23939
								],
								[
									-96.12588,
									67.29338
								],
								[
									-95.48943,
									68.0907
								],
								[
									-94.685,
									68.06383
								],
								[
									-94.23282,
									69.06903
								],
								[
									-95.30408,
									69.68571
								],
								[
									-96.47131,
									70.08976
								],
								[
									-96.39115,
									71.19482
								],
								[
									-95.2088,
									71.92053
								],
								[
									-93.88997,
									71.76015
								],
								[
									-92.87818,
									71.31869
								],
								[
									-91.51964,
									70.19129
								],
								[
									-92.40692,
									69.69997
								],
								[
									-90.5471,
									69.49766
								]
							]
						],
						[
							[
								[
									-114.16717,
									73.12145
								],
								[
									-114.66634,
									72.65277
								],
								[
									-112.44102,
									72.9554
								],
								[
									-111.05039,
									72.4504
								],
								[
									-109.92035,
									72.96113
								],
								[
									-109.00654,
									72.63335
								],
								[
									-108.18835,
									71.65089
								],
								[
									-107.68599,
									72.06548
								],
								[
									-108.39639,
									73.08953
								],
								[
									-107.51645,
									73.23598
								],
								[
									-106.52259,
									73.07601
								],
								[
									-105.40246,
									72.67259
								],
								[
									-104.77484,
									71.6984
								],
								[
									-104.46476,
									70.99297
								],
								[
									-102.78537,
									70.49776
								],
								[
									-100.98078,
									70.02432
								],
								[
									-101.08929,
									69.58447
								],
								[
									-102.73116,
									69.50402
								],
								[
									-102.09329,
									69.11962
								],
								[
									-102.43024,
									68.75282
								],
								[
									-104.24,
									68.91
								],
								[
									-105.96,
									69.18
								],
								[
									-107.12254,
									69.11922
								],
								[
									-109,
									68.78
								],
								[
									-111.534149,
									68.630059
								],
								[
									-113.3132,
									68.53554
								],
								[
									-113.85496,
									69.00744
								],
								[
									-115.22,
									69.28
								],
								[
									-116.10794,
									69.16821
								],
								[
									-117.34,
									69.96
								],
								[
									-116.67473,
									70.06655
								],
								[
									-115.13112,
									70.2373
								],
								[
									-113.72141,
									70.19237
								],
								[
									-112.4161,
									70.36638
								],
								[
									-114.35,
									70.6
								],
								[
									-116.48684,
									70.52045
								],
								[
									-117.9048,
									70.54056
								],
								[
									-118.43238,
									70.9092
								],
								[
									-116.11311,
									71.30918
								],
								[
									-117.65568,
									71.2952
								],
								[
									-119.40199,
									71.55859
								],
								[
									-118.56267,
									72.30785
								],
								[
									-117.86642,
									72.70594
								],
								[
									-115.18909,
									73.31459
								],
								[
									-114.16717,
									73.12145
								]
							]
						],
						[
							[
								[
									-104.5,
									73.42
								],
								[
									-105.38,
									72.76
								],
								[
									-106.94,
									73.46
								],
								[
									-106.6,
									73.6
								],
								[
									-105.26,
									73.64
								],
								[
									-104.5,
									73.42
								]
							]
						],
						[
							[
								[
									-76.34,
									73.102685
								],
								[
									-76.251404,
									72.826385
								],
								[
									-77.314438,
									72.855545
								],
								[
									-78.39167,
									72.876656
								],
								[
									-79.486252,
									72.742203
								],
								[
									-79.775833,
									72.802902
								],
								[
									-80.876099,
									73.333183
								],
								[
									-80.833885,
									73.693184
								],
								[
									-80.353058,
									73.75972
								],
								[
									-78.064438,
									73.651932
								],
								[
									-76.34,
									73.102685
								]
							]
						],
						[
							[
								[
									-86.562179,
									73.157447
								],
								[
									-85.774371,
									72.534126
								],
								[
									-84.850112,
									73.340278
								],
								[
									-82.31559,
									73.750951
								],
								[
									-80.600088,
									72.716544
								],
								[
									-80.748942,
									72.061907
								],
								[
									-78.770639,
									72.352173
								],
								[
									-77.824624,
									72.749617
								],
								[
									-75.605845,
									72.243678
								],
								[
									-74.228616,
									71.767144
								],
								[
									-74.099141,
									71.33084
								],
								[
									-72.242226,
									71.556925
								],
								[
									-71.200015,
									70.920013
								],
								[
									-68.786054,
									70.525024
								],
								[
									-67.91497,
									70.121948
								],
								[
									-66.969033,
									69.186087
								],
								[
									-68.805123,
									68.720198
								],
								[
									-66.449866,
									68.067163
								],
								[
									-64.862314,
									67.847539
								],
								[
									-63.424934,
									66.928473
								],
								[
									-61.851981,
									66.862121
								],
								[
									-62.163177,
									66.160251
								],
								[
									-63.918444,
									64.998669
								],
								[
									-65.14886,
									65.426033
								],
								[
									-66.721219,
									66.388041
								],
								[
									-68.015016,
									66.262726
								],
								[
									-68.141287,
									65.689789
								],
								[
									-67.089646,
									65.108455
								],
								[
									-65.73208,
									64.648406
								],
								[
									-65.320168,
									64.382737
								],
								[
									-64.669406,
									63.392927
								],
								[
									-65.013804,
									62.674185
								],
								[
									-66.275045,
									62.945099
								],
								[
									-68.783186,
									63.74567
								],
								[
									-67.369681,
									62.883966
								],
								[
									-66.328297,
									62.280075
								],
								[
									-66.165568,
									61.930897
								],
								[
									-68.877367,
									62.330149
								],
								[
									-71.023437,
									62.910708
								],
								[
									-72.235379,
									63.397836
								],
								[
									-71.886278,
									63.679989
								],
								[
									-73.378306,
									64.193963
								],
								[
									-74.834419,
									64.679076
								],
								[
									-74.818503,
									64.389093
								],
								[
									-77.70998,
									64.229542
								],
								[
									-78.555949,
									64.572906
								],
								[
									-77.897281,
									65.309192
								],
								[
									-76.018274,
									65.326969
								],
								[
									-73.959795,
									65.454765
								],
								[
									-74.293883,
									65.811771
								],
								[
									-73.944912,
									66.310578
								],
								[
									-72.651167,
									67.284576
								],
								[
									-72.92606,
									67.726926
								],
								[
									-73.311618,
									68.069437
								],
								[
									-74.843307,
									68.554627
								],
								[
									-76.869101,
									68.894736
								],
								[
									-76.228649,
									69.147769
								],
								[
									-77.28737,
									69.76954
								],
								[
									-78.168634,
									69.826488
								],
								[
									-78.957242,
									70.16688
								],
								[
									-79.492455,
									69.871808
								],
								[
									-81.305471,
									69.743185
								],
								[
									-84.944706,
									69.966634
								],
								[
									-87.060003,
									70.260001
								],
								[
									-88.681713,
									70.410741
								],
								[
									-89.51342,
									70.762038
								],
								[
									-88.467721,
									71.218186
								],
								[
									-89.888151,
									71.222552
								],
								[
									-90.20516,
									72.235074
								],
								[
									-89.436577,
									73.129464
								],
								[
									-88.408242,
									73.537889
								],
								[
									-85.826151,
									73.803816
								],
								[
									-86.562179,
									73.157447
								]
							]
						],
						[
							[
								[
									-100.35642,
									73.84389
								],
								[
									-99.16387,
									73.63339
								],
								[
									-97.38,
									73.76
								],
								[
									-97.12,
									73.47
								],
								[
									-98.05359,
									72.99052
								],
								[
									-96.54,
									72.56
								],
								[
									-96.72,
									71.66
								],
								[
									-98.35966,
									71.27285
								],
								[
									-99.32286,
									71.35639
								],
								[
									-100.01482,
									71.73827
								],
								[
									-102.5,
									72.51
								],
								[
									-102.48,
									72.83
								],
								[
									-100.43836,
									72.70588
								],
								[
									-101.54,
									73.36
								],
								[
									-100.35642,
									73.84389
								]
							]
						],
						[
							[
								[
									-93.196296,
									72.771992
								],
								[
									-94.269047,
									72.024596
								],
								[
									-95.409856,
									72.061881
								],
								[
									-96.033745,
									72.940277
								],
								[
									-96.018268,
									73.43743
								],
								[
									-95.495793,
									73.862417
								],
								[
									-94.503658,
									74.134907
								],
								[
									-92.420012,
									74.100025
								],
								[
									-90.509793,
									73.856732
								],
								[
									-92.003965,
									72.966244
								],
								[
									-93.196296,
									72.771992
								]
							]
						],
						[
							[
								[
									-120.46,
									71.383602
								],
								[
									-123.09219,
									70.90164
								],
								[
									-123.62,
									71.34
								],
								[
									-125.928949,
									71.868688
								],
								[
									-125.5,
									72.292261
								],
								[
									-124.80729,
									73.02256
								],
								[
									-123.94,
									73.68
								],
								[
									-124.91775,
									74.29275
								],
								[
									-121.53788,
									74.44893
								],
								[
									-120.10978,
									74.24135
								],
								[
									-117.55564,
									74.18577
								],
								[
									-116.58442,
									73.89607
								],
								[
									-115.51081,
									73.47519
								],
								[
									-116.76794,
									73.22292
								],
								[
									-119.22,
									72.52
								],
								[
									-120.46,
									71.82
								],
								[
									-120.46,
									71.383602
								]
							]
						],
						[
							[
								[
									-93.612756,
									74.979997
								],
								[
									-94.156909,
									74.592347
								],
								[
									-95.608681,
									74.666864
								],
								[
									-96.820932,
									74.927623
								],
								[
									-96.288587,
									75.377828
								],
								[
									-94.85082,
									75.647218
								],
								[
									-93.977747,
									75.29649
								],
								[
									-93.612756,
									74.979997
								]
							]
						],
						[
							[
								[
									-98.5,
									76.72
								],
								[
									-97.735585,
									76.25656
								],
								[
									-97.704415,
									75.74344
								],
								[
									-98.16,
									75
								],
								[
									-99.80874,
									74.89744
								],
								[
									-100.88366,
									75.05736
								],
								[
									-100.86292,
									75.64075
								],
								[
									-102.50209,
									75.5638
								],
								[
									-102.56552,
									76.3366
								],
								[
									-101.48973,
									76.30537
								],
								[
									-99.98349,
									76.64634
								],
								[
									-98.57699,
									76.58859
								],
								[
									-98.5,
									76.72
								]
							]
						],
						[
							[
								[
									-108.21141,
									76.20168
								],
								[
									-107.81943,
									75.84552
								],
								[
									-106.92893,
									76.01282
								],
								[
									-105.881,
									75.9694
								],
								[
									-105.70498,
									75.47951
								],
								[
									-106.31347,
									75.00527
								],
								[
									-109.7,
									74.85
								],
								[
									-112.22307,
									74.41696
								],
								[
									-113.74381,
									74.39427
								],
								[
									-113.87135,
									74.72029
								],
								[
									-111.79421,
									75.1625
								],
								[
									-116.31221,
									75.04343
								],
								[
									-117.7104,
									75.2222
								],
								[
									-116.34602,
									76.19903
								],
								[
									-115.40487,
									76.47887
								],
								[
									-112.59056,
									76.14134
								],
								[
									-110.81422,
									75.54919
								],
								[
									-109.0671,
									75.47321
								],
								[
									-110.49726,
									76.42982
								],
								[
									-109.5811,
									76.79417
								],
								[
									-108.54859,
									76.67832
								],
								[
									-108.21141,
									76.20168
								]
							]
						],
						[
							[
								[
									-94.684086,
									77.097878
								],
								[
									-93.573921,
									76.776296
								],
								[
									-91.605023,
									76.778518
								],
								[
									-90.741846,
									76.449597
								],
								[
									-90.969661,
									76.074013
								],
								[
									-89.822238,
									75.847774
								],
								[
									-89.187083,
									75.610166
								],
								[
									-87.838276,
									75.566189
								],
								[
									-86.379192,
									75.482421
								],
								[
									-84.789625,
									75.699204
								],
								[
									-82.753445,
									75.784315
								],
								[
									-81.128531,
									75.713983
								],
								[
									-80.057511,
									75.336849
								],
								[
									-79.833933,
									74.923127
								],
								[
									-80.457771,
									74.657304
								],
								[
									-81.948843,
									74.442459
								],
								[
									-83.228894,
									74.564028
								],
								[
									-86.097452,
									74.410032
								],
								[
									-88.15035,
									74.392307
								],
								[
									-89.764722,
									74.515555
								],
								[
									-92.422441,
									74.837758
								],
								[
									-92.768285,
									75.38682
								],
								[
									-92.889906,
									75.882655
								],
								[
									-93.893824,
									76.319244
								],
								[
									-95.962457,
									76.441381
								],
								[
									-97.121379,
									76.751078
								],
								[
									-96.745123,
									77.161389
								],
								[
									-94.684086,
									77.097878
								]
							]
						],
						[
							[
								[
									-116.198587,
									77.645287
								],
								[
									-116.335813,
									76.876962
								],
								[
									-117.106051,
									76.530032
								],
								[
									-118.040412,
									76.481172
								],
								[
									-119.899318,
									76.053213
								],
								[
									-121.499995,
									75.900019
								],
								[
									-122.854924,
									76.116543
								],
								[
									-122.854925,
									76.116543
								],
								[
									-121.157535,
									76.864508
								],
								[
									-119.103939,
									77.51222
								],
								[
									-117.570131,
									77.498319
								],
								[
									-116.198587,
									77.645287
								]
							]
						],
						[
							[
								[
									-93.840003,
									77.519997
								],
								[
									-94.295608,
									77.491343
								],
								[
									-96.169654,
									77.555111
								],
								[
									-96.436304,
									77.834629
								],
								[
									-94.422577,
									77.820005
								],
								[
									-93.720656,
									77.634331
								],
								[
									-93.840003,
									77.519997
								]
							]
						],
						[
							[
								[
									-110.186938,
									77.697015
								],
								[
									-112.051191,
									77.409229
								],
								[
									-113.534279,
									77.732207
								],
								[
									-112.724587,
									78.05105
								],
								[
									-111.264443,
									78.152956
								],
								[
									-109.854452,
									77.996325
								],
								[
									-110.186938,
									77.697015
								]
							]
						],
						[
							[
								[
									-109.663146,
									78.601973
								],
								[
									-110.881314,
									78.40692
								],
								[
									-112.542091,
									78.407902
								],
								[
									-112.525891,
									78.550555
								],
								[
									-111.50001,
									78.849994
								],
								[
									-110.963661,
									78.804441
								],
								[
									-109.663146,
									78.601973
								]
							]
						],
						[
							[
								[
									-95.830295,
									78.056941
								],
								[
									-97.309843,
									77.850597
								],
								[
									-98.124289,
									78.082857
								],
								[
									-98.552868,
									78.458105
								],
								[
									-98.631984,
									78.87193
								],
								[
									-97.337231,
									78.831984
								],
								[
									-96.754399,
									78.765813
								],
								[
									-95.559278,
									78.418315
								],
								[
									-95.830295,
									78.056941
								]
							]
						],
						[
							[
								[
									-100.060192,
									78.324754
								],
								[
									-99.670939,
									77.907545
								],
								[
									-101.30394,
									78.018985
								],
								[
									-102.949809,
									78.343229
								],
								[
									-105.176133,
									78.380332
								],
								[
									-104.210429,
									78.67742
								],
								[
									-105.41958,
									78.918336
								],
								[
									-105.492289,
									79.301594
								],
								[
									-103.529282,
									79.165349
								],
								[
									-100.825158,
									78.800462
								],
								[
									-100.060192,
									78.324754
								]
							]
						],
						[
							[
								[
									-87.02,
									79.66
								],
								[
									-85.81435,
									79.3369
								],
								[
									-87.18756,
									79.0393
								],
								[
									-89.03535,
									78.28723
								],
								[
									-90.80436,
									78.21533
								],
								[
									-92.87669,
									78.34333
								],
								[
									-93.95116,
									78.75099
								],
								[
									-93.93574,
									79.11373
								],
								[
									-93.14524,
									79.3801
								],
								[
									-94.974,
									79.37248
								],
								[
									-96.07614,
									79.70502
								],
								[
									-96.70972,
									80.15777
								],
								[
									-96.01644,
									80.60233
								],
								[
									-95.32345,
									80.90729
								],
								[
									-94.29843,
									80.97727
								],
								[
									-94.73542,
									81.20646
								],
								[
									-92.40984,
									81.25739
								],
								[
									-91.13289,
									80.72345
								],
								[
									-89.45,
									80.509322
								],
								[
									-87.81,
									80.32
								],
								[
									-87.02,
									79.66
								]
							]
						],
						[
							[
								[
									-68.5,
									83.106322
								],
								[
									-65.82735,
									83.02801
								],
								[
									-63.68,
									82.9
								],
								[
									-61.85,
									82.6286
								],
								[
									-61.89388,
									82.36165
								],
								[
									-64.334,
									81.92775
								],
								[
									-66.75342,
									81.72527
								],
								[
									-67.65755,
									81.50141
								],
								[
									-65.48031,
									81.50657
								],
								[
									-67.84,
									80.9
								],
								[
									-69.4697,
									80.61683
								],
								[
									-71.18,
									79.8
								],
								[
									-73.2428,
									79.63415
								],
								[
									-73.88,
									79.430162
								],
								[
									-76.90773,
									79.32309
								],
								[
									-75.52924,
									79.19766
								],
								[
									-76.22046,
									79.01907
								],
								[
									-75.39345,
									78.52581
								],
								[
									-76.34354,
									78.18296
								],
								[
									-77.88851,
									77.89991
								],
								[
									-78.36269,
									77.50859
								],
								[
									-79.75951,
									77.20968
								],
								[
									-79.61965,
									76.98336
								],
								[
									-77.91089,
									77.022045
								],
								[
									-77.88911,
									76.777955
								],
								[
									-80.56125,
									76.17812
								],
								[
									-83.17439,
									76.45403
								],
								[
									-86.11184,
									76.29901
								],
								[
									-87.6,
									76.42
								],
								[
									-89.49068,
									76.47239
								],
								[
									-89.6161,
									76.95213
								],
								[
									-87.76739,
									77.17833
								],
								[
									-88.26,
									77.9
								],
								[
									-87.65,
									77.970222
								],
								[
									-84.97634,
									77.53873
								],
								[
									-86.34,
									78.18
								],
								[
									-87.96192,
									78.37181
								],
								[
									-87.15198,
									78.75867
								],
								[
									-85.37868,
									78.9969
								],
								[
									-85.09495,
									79.34543
								],
								[
									-86.50734,
									79.73624
								],
								[
									-86.93179,
									80.25145
								],
								[
									-84.19844,
									80.20836
								],
								[
									-83.408696,
									80.1
								],
								[
									-81.84823,
									80.46442
								],
								[
									-84.1,
									80.58
								],
								[
									-87.59895,
									80.51627
								],
								[
									-89.36663,
									80.85569
								],
								[
									-90.2,
									81.26
								],
								[
									-91.36786,
									81.5531
								],
								[
									-91.58702,
									81.89429
								],
								[
									-90.1,
									82.085
								],
								[
									-88.93227,
									82.11751
								],
								[
									-86.97024,
									82.27961
								],
								[
									-85.5,
									82.652273
								],
								[
									-84.260005,
									82.6
								],
								[
									-83.18,
									82.32
								],
								[
									-82.42,
									82.86
								],
								[
									-81.1,
									83.02
								],
								[
									-79.30664,
									83.13056
								],
								[
									-76.25,
									83.172059
								],
								[
									-75.71878,
									83.06404
								],
								[
									-72.83153,
									83.23324
								],
								[
									-70.665765,
									83.169781
								],
								[
									-68.5,
									83.106322
								]
							]
						]
					]
				},
				"id": "CAN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Switzerland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.594226,
								47.525058
							],
							[
								9.632932,
								47.347601
							],
							[
								9.47997,
								47.10281
							],
							[
								9.932448,
								46.920728
							],
							[
								10.442701,
								46.893546
							],
							[
								10.363378,
								46.483571
							],
							[
								9.922837,
								46.314899
							],
							[
								9.182882,
								46.440215
							],
							[
								8.966306,
								46.036932
							],
							[
								8.489952,
								46.005151
							],
							[
								8.31663,
								46.163642
							],
							[
								7.755992,
								45.82449
							],
							[
								7.273851,
								45.776948
							],
							[
								6.843593,
								45.991147
							],
							[
								6.5001,
								46.429673
							],
							[
								6.022609,
								46.27299
							],
							[
								6.037389,
								46.725779
							],
							[
								6.768714,
								47.287708
							],
							[
								6.736571,
								47.541801
							],
							[
								7.192202,
								47.449766
							],
							[
								7.466759,
								47.620582
							],
							[
								8.317301,
								47.61358
							],
							[
								8.522612,
								47.830828
							],
							[
								9.594226,
								47.525058
							]
						]
					]
				},
				"id": "CHE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Chile"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-68.63401,
									-52.63637
								],
								[
									-68.63335,
									-54.8695
								],
								[
									-67.56244,
									-54.87001
								],
								[
									-66.95992,
									-54.89681
								],
								[
									-67.29103,
									-55.30124
								],
								[
									-68.14863,
									-55.61183
								],
								[
									-68.639991,
									-55.580018
								],
								[
									-69.2321,
									-55.49906
								],
								[
									-69.95809,
									-55.19843
								],
								[
									-71.00568,
									-55.05383
								],
								[
									-72.2639,
									-54.49514
								],
								[
									-73.2852,
									-53.95752
								],
								[
									-74.66253,
									-52.83749
								],
								[
									-73.8381,
									-53.04743
								],
								[
									-72.43418,
									-53.7154
								],
								[
									-71.10773,
									-54.07433
								],
								[
									-70.59178,
									-53.61583
								],
								[
									-70.26748,
									-52.93123
								],
								[
									-69.34565,
									-52.5183
								],
								[
									-68.63401,
									-52.63637
								]
							]
						],
						[
							[
								[
									-68.219913,
									-21.494347
								],
								[
									-67.82818,
									-22.872919
								],
								[
									-67.106674,
									-22.735925
								],
								[
									-66.985234,
									-22.986349
								],
								[
									-67.328443,
									-24.025303
								],
								[
									-68.417653,
									-24.518555
								],
								[
									-68.386001,
									-26.185016
								],
								[
									-68.5948,
									-26.506909
								],
								[
									-68.295542,
									-26.89934
								],
								[
									-69.001235,
									-27.521214
								],
								[
									-69.65613,
									-28.459141
								],
								[
									-70.01355,
									-29.367923
								],
								[
									-69.919008,
									-30.336339
								],
								[
									-70.535069,
									-31.36501
								],
								[
									-70.074399,
									-33.09121
								],
								[
									-69.814777,
									-33.273886
								],
								[
									-69.817309,
									-34.193571
								],
								[
									-70.388049,
									-35.169688
								],
								[
									-70.364769,
									-36.005089
								],
								[
									-71.121881,
									-36.658124
								],
								[
									-71.118625,
									-37.576827
								],
								[
									-70.814664,
									-38.552995
								],
								[
									-71.413517,
									-38.916022
								],
								[
									-71.680761,
									-39.808164
								],
								[
									-71.915734,
									-40.832339
								],
								[
									-71.746804,
									-42.051386
								],
								[
									-72.148898,
									-42.254888
								],
								[
									-71.915424,
									-43.408565
								],
								[
									-71.464056,
									-43.787611
								],
								[
									-71.793623,
									-44.207172
								],
								[
									-71.329801,
									-44.407522
								],
								[
									-71.222779,
									-44.784243
								],
								[
									-71.659316,
									-44.973689
								],
								[
									-71.552009,
									-45.560733
								],
								[
									-71.917258,
									-46.884838
								],
								[
									-72.447355,
									-47.738533
								],
								[
									-72.331161,
									-48.244238
								],
								[
									-72.648247,
									-48.878618
								],
								[
									-73.415436,
									-49.318436
								],
								[
									-73.328051,
									-50.378785
								],
								[
									-72.975747,
									-50.74145
								],
								[
									-72.309974,
									-50.67701
								],
								[
									-72.329404,
									-51.425956
								],
								[
									-71.914804,
									-52.009022
								],
								[
									-69.498362,
									-52.142761
								],
								[
									-68.571545,
									-52.299444
								],
								[
									-69.461284,
									-52.291951
								],
								[
									-69.94278,
									-52.537931
								],
								[
									-70.845102,
									-52.899201
								],
								[
									-71.006332,
									-53.833252
								],
								[
									-71.429795,
									-53.856455
								],
								[
									-72.557943,
									-53.53141
								],
								[
									-73.702757,
									-52.835069
								],
								[
									-73.702757,
									-52.83507
								],
								[
									-74.946763,
									-52.262754
								],
								[
									-75.260026,
									-51.629355
								],
								[
									-74.976632,
									-51.043396
								],
								[
									-75.479754,
									-50.378372
								],
								[
									-75.608015,
									-48.673773
								],
								[
									-75.18277,
									-47.711919
								],
								[
									-74.126581,
									-46.939253
								],
								[
									-75.644395,
									-46.647643
								],
								[
									-74.692154,
									-45.763976
								],
								[
									-74.351709,
									-44.103044
								],
								[
									-73.240356,
									-44.454961
								],
								[
									-72.717804,
									-42.383356
								],
								[
									-73.3889,
									-42.117532
								],
								[
									-73.701336,
									-43.365776
								],
								[
									-74.331943,
									-43.224958
								],
								[
									-74.017957,
									-41.794813
								],
								[
									-73.677099,
									-39.942213
								],
								[
									-73.217593,
									-39.258689
								],
								[
									-73.505559,
									-38.282883
								],
								[
									-73.588061,
									-37.156285
								],
								[
									-73.166717,
									-37.12378
								],
								[
									-72.553137,
									-35.50884
								],
								[
									-71.861732,
									-33.909093
								],
								[
									-71.43845,
									-32.418899
								],
								[
									-71.668721,
									-30.920645
								],
								[
									-71.370083,
									-30.095682
								],
								[
									-71.489894,
									-28.861442
								],
								[
									-70.905124,
									-27.64038
								],
								[
									-70.724954,
									-25.705924
								],
								[
									-70.403966,
									-23.628997
								],
								[
									-70.091246,
									-21.393319
								],
								[
									-70.16442,
									-19.756468
								],
								[
									-70.372572,
									-18.347975
								],
								[
									-69.858444,
									-18.092694
								],
								[
									-69.590424,
									-17.580012
								],
								[
									-69.100247,
									-18.260125
								],
								[
									-68.966818,
									-18.981683
								],
								[
									-68.442225,
									-19.405068
								],
								[
									-68.757167,
									-20.372658
								],
								[
									-68.219913,
									-21.494347
								]
							]
						]
					]
				},
				"id": "CHL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "China"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									110.339188,
									18.678395
								],
								[
									109.47521,
									18.197701
								],
								[
									108.655208,
									18.507682
								],
								[
									108.626217,
									19.367888
								],
								[
									109.119056,
									19.821039
								],
								[
									110.211599,
									20.101254
								],
								[
									110.786551,
									20.077534
								],
								[
									111.010051,
									19.69593
								],
								[
									110.570647,
									19.255879
								],
								[
									110.339188,
									18.678395
								]
							]
						],
						[
							[
								[
									127.657407,
									49.76027
								],
								[
									129.397818,
									49.4406
								],
								[
									130.582293,
									48.729687
								],
								[
									130.987282,
									47.790132
								],
								[
									132.506672,
									47.78897
								],
								[
									133.373596,
									48.183442
								],
								[
									135.026311,
									48.47823
								],
								[
									134.500814,
									47.57844
								],
								[
									134.112362,
									47.212467
								],
								[
									133.769644,
									46.116927
								],
								[
									133.097127,
									45.144066
								],
								[
									131.883454,
									45.321162
								],
								[
									131.025212,
									44.967953
								],
								[
									131.288555,
									44.11152
								],
								[
									131.144688,
									42.92999
								],
								[
									130.633866,
									42.903015
								],
								[
									130.640016,
									42.395009
								],
								[
									129.994267,
									42.985387
								],
								[
									129.596669,
									42.424982
								],
								[
									128.052215,
									41.994285
								],
								[
									128.208433,
									41.466772
								],
								[
									127.343783,
									41.503152
								],
								[
									126.869083,
									41.816569
								],
								[
									126.182045,
									41.107336
								],
								[
									125.079942,
									40.569824
								],
								[
									124.265625,
									39.928493
								],
								[
									122.86757,
									39.637788
								],
								[
									122.131388,
									39.170452
								],
								[
									121.054554,
									38.897471
								],
								[
									121.585995,
									39.360854
								],
								[
									121.376757,
									39.750261
								],
								[
									122.168595,
									40.422443
								],
								[
									121.640359,
									40.94639
								],
								[
									120.768629,
									40.593388
								],
								[
									119.639602,
									39.898056
								],
								[
									119.023464,
									39.252333
								],
								[
									118.042749,
									39.204274
								],
								[
									117.532702,
									38.737636
								],
								[
									118.059699,
									38.061476
								],
								[
									118.87815,
									37.897325
								],
								[
									118.911636,
									37.448464
								],
								[
									119.702802,
									37.156389
								],
								[
									120.823457,
									37.870428
								],
								[
									121.711259,
									37.481123
								],
								[
									122.357937,
									37.454484
								],
								[
									122.519995,
									36.930614
								],
								[
									121.104164,
									36.651329
								],
								[
									120.637009,
									36.11144
								],
								[
									119.664562,
									35.609791
								],
								[
									119.151208,
									34.909859
								],
								[
									120.227525,
									34.360332
								],
								[
									120.620369,
									33.376723
								],
								[
									121.229014,
									32.460319
								],
								[
									121.908146,
									31.692174
								],
								[
									121.891919,
									30.949352
								],
								[
									121.264257,
									30.676267
								],
								[
									121.503519,
									30.142915
								],
								[
									122.092114,
									29.83252
								],
								[
									121.938428,
									29.018022
								],
								[
									121.684439,
									28.225513
								],
								[
									121.125661,
									28.135673
								],
								[
									120.395473,
									27.053207
								],
								[
									119.585497,
									25.740781
								],
								[
									118.656871,
									24.547391
								],
								[
									117.281606,
									23.624501
								],
								[
									115.890735,
									22.782873
								],
								[
									114.763827,
									22.668074
								],
								[
									114.152547,
									22.22376
								],
								[
									113.80678,
									22.54834
								],
								[
									113.241078,
									22.051367
								],
								[
									111.843592,
									21.550494
								],
								[
									110.785466,
									21.397144
								],
								[
									110.444039,
									20.341033
								],
								[
									109.889861,
									20.282457
								],
								[
									109.627655,
									21.008227
								],
								[
									109.864488,
									21.395051
								],
								[
									108.522813,
									21.715212
								],
								[
									108.05018,
									21.55238
								],
								[
									107.04342,
									21.811899
								],
								[
									106.567273,
									22.218205
								],
								[
									106.725403,
									22.794268
								],
								[
									105.811247,
									22.976892
								],
								[
									105.329209,
									23.352063
								],
								[
									104.476858,
									22.81915
								],
								[
									103.504515,
									22.703757
								],
								[
									102.706992,
									22.708795
								],
								[
									102.170436,
									22.464753
								],
								[
									101.652018,
									22.318199
								],
								[
									101.80312,
									21.174367
								],
								[
									101.270026,
									21.201652
								],
								[
									101.180005,
									21.436573
								],
								[
									101.150033,
									21.849984
								],
								[
									100.416538,
									21.558839
								],
								[
									99.983489,
									21.742937
								],
								[
									99.240899,
									22.118314
								],
								[
									99.531992,
									22.949039
								],
								[
									98.898749,
									23.142722
								],
								[
									98.660262,
									24.063286
								],
								[
									97.60472,
									23.897405
								],
								[
									97.724609,
									25.083637
								],
								[
									98.671838,
									25.918703
								],
								[
									98.712094,
									26.743536
								],
								[
									98.68269,
									27.508812
								],
								[
									98.246231,
									27.747221
								],
								[
									97.911988,
									28.335945
								],
								[
									97.327114,
									28.261583
								],
								[
									96.248833,
									28.411031
								],
								[
									96.586591,
									28.83098
								],
								[
									96.117679,
									29.452802
								],
								[
									95.404802,
									29.031717
								],
								[
									94.56599,
									29.277438
								],
								[
									93.413348,
									28.640629
								],
								[
									92.503119,
									27.896876
								],
								[
									91.696657,
									27.771742
								],
								[
									91.258854,
									28.040614
								],
								[
									90.730514,
									28.064954
								],
								[
									90.015829,
									28.296439
								],
								[
									89.47581,
									28.042759
								],
								[
									88.814248,
									27.299316
								],
								[
									88.730326,
									28.086865
								],
								[
									88.120441,
									27.876542
								],
								[
									86.954517,
									27.974262
								],
								[
									85.82332,
									28.203576
								],
								[
									85.011638,
									28.642774
								],
								[
									84.23458,
									28.839894
								],
								[
									83.898993,
									29.320226
								],
								[
									83.337115,
									29.463732
								],
								[
									82.327513,
									30.115268
								],
								[
									81.525804,
									30.422717
								],
								[
									81.111256,
									30.183481
								],
								[
									79.721367,
									30.882715
								],
								[
									78.738894,
									31.515906
								],
								[
									78.458446,
									32.618164
								],
								[
									79.176129,
									32.48378
								],
								[
									79.208892,
									32.994395
								],
								[
									78.811086,
									33.506198
								],
								[
									78.912269,
									34.321936
								],
								[
									77.837451,
									35.49401
								],
								[
									76.192848,
									35.898403
								],
								[
									75.896897,
									36.666806
								],
								[
									75.158028,
									37.133031
								],
								[
									74.980002,
									37.41999
								],
								[
									74.829986,
									37.990007
								],
								[
									74.864816,
									38.378846
								],
								[
									74.257514,
									38.606507
								],
								[
									73.928852,
									38.505815
								],
								[
									73.675379,
									39.431237
								],
								[
									73.960013,
									39.660008
								],
								[
									73.822244,
									39.893973
								],
								[
									74.776862,
									40.366425
								],
								[
									75.467828,
									40.562072
								],
								[
									76.526368,
									40.427946
								],
								[
									76.904484,
									41.066486
								],
								[
									78.187197,
									41.185316
								],
								[
									78.543661,
									41.582243
								],
								[
									80.11943,
									42.123941
								],
								[
									80.25999,
									42.349999
								],
								[
									80.18015,
									42.920068
								],
								[
									80.866206,
									43.180362
								],
								[
									79.966106,
									44.917517
								],
								[
									81.947071,
									45.317027
								],
								[
									82.458926,
									45.53965
								],
								[
									83.180484,
									47.330031
								],
								[
									85.16429,
									47.000956
								],
								[
									85.720484,
									47.452969
								],
								[
									85.768233,
									48.455751
								],
								[
									86.598776,
									48.549182
								],
								[
									87.35997,
									49.214981
								],
								[
									87.751264,
									49.297198
								],
								[
									88.013832,
									48.599463
								],
								[
									88.854298,
									48.069082
								],
								[
									90.280826,
									47.693549
								],
								[
									90.970809,
									46.888146
								],
								[
									90.585768,
									45.719716
								],
								[
									90.94554,
									45.286073
								],
								[
									92.133891,
									45.115076
								],
								[
									93.480734,
									44.975472
								],
								[
									94.688929,
									44.352332
								],
								[
									95.306875,
									44.241331
								],
								[
									95.762455,
									43.319449
								],
								[
									96.349396,
									42.725635
								],
								[
									97.451757,
									42.74889
								],
								[
									99.515817,
									42.524691
								],
								[
									100.845866,
									42.663804
								],
								[
									101.83304,
									42.514873
								],
								[
									103.312278,
									41.907468
								],
								[
									104.522282,
									41.908347
								],
								[
									104.964994,
									41.59741
								],
								[
									106.129316,
									42.134328
								],
								[
									107.744773,
									42.481516
								],
								[
									109.243596,
									42.519446
								],
								[
									110.412103,
									42.871234
								],
								[
									111.129682,
									43.406834
								],
								[
									111.829588,
									43.743118
								],
								[
									111.667737,
									44.073176
								],
								[
									111.348377,
									44.457442
								],
								[
									111.873306,
									45.102079
								],
								[
									112.436062,
									45.011646
								],
								[
									113.463907,
									44.808893
								],
								[
									114.460332,
									45.339817
								],
								[
									115.985096,
									45.727235
								],
								[
									116.717868,
									46.388202
								],
								[
									117.421701,
									46.672733
								],
								[
									118.874326,
									46.805412
								],
								[
									119.66327,
									46.69268
								],
								[
									119.772824,
									47.048059
								],
								[
									118.866574,
									47.74706
								],
								[
									118.064143,
									48.06673
								],
								[
									117.295507,
									47.697709
								],
								[
									116.308953,
									47.85341
								],
								[
									115.742837,
									47.726545
								],
								[
									115.485282,
									48.135383
								],
								[
									116.191802,
									49.134598
								],
								[
									116.678801,
									49.888531
								],
								[
									117.879244,
									49.510983
								],
								[
									119.288461,
									50.142883
								],
								[
									119.279366,
									50.582908
								],
								[
									120.18205,
									51.643566
								],
								[
									120.738191,
									51.964115
								],
								[
									120.725789,
									52.516226
								],
								[
									120.177089,
									52.753886
								],
								[
									121.003085,
									53.251401
								],
								[
									122.245748,
									53.431726
								],
								[
									123.571507,
									53.458804
								],
								[
									125.068211,
									53.161045
								],
								[
									125.946349,
									52.792799
								],
								[
									126.564399,
									51.784255
								],
								[
									126.939157,
									51.353894
								],
								[
									127.287456,
									50.739797
								],
								[
									127.657407,
									49.76027
								]
							]
						]
					]
				},
				"id": "CHN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Ivory Coast"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-2.856125,
								4.994476
							],
							[
								-3.311084,
								4.984296
							],
							[
								-4.00882,
								5.179813
							],
							[
								-4.649917,
								5.168264
							],
							[
								-5.834496,
								4.993701
							],
							[
								-6.528769,
								4.705088
							],
							[
								-7.518941,
								4.338288
							],
							[
								-7.712159,
								4.364566
							],
							[
								-7.635368,
								5.188159
							],
							[
								-7.539715,
								5.313345
							],
							[
								-7.570153,
								5.707352
							],
							[
								-7.993693,
								6.12619
							],
							[
								-8.311348,
								6.193033
							],
							[
								-8.60288,
								6.467564
							],
							[
								-8.385452,
								6.911801
							],
							[
								-8.485446,
								7.395208
							],
							[
								-8.439298,
								7.686043
							],
							[
								-8.280703,
								7.68718
							],
							[
								-8.221792,
								8.123329
							],
							[
								-8.299049,
								8.316444
							],
							[
								-8.203499,
								8.455453
							],
							[
								-7.8321,
								8.575704
							],
							[
								-8.079114,
								9.376224
							],
							[
								-8.309616,
								9.789532
							],
							[
								-8.229337,
								10.12902
							],
							[
								-8.029944,
								10.206535
							],
							[
								-7.89959,
								10.297382
							],
							[
								-7.622759,
								10.147236
							],
							[
								-6.850507,
								10.138994
							],
							[
								-6.666461,
								10.430811
							],
							[
								-6.493965,
								10.411303
							],
							[
								-6.205223,
								10.524061
							],
							[
								-6.050452,
								10.096361
							],
							[
								-5.816926,
								10.222555
							],
							[
								-5.404342,
								10.370737
							],
							[
								-4.954653,
								10.152714
							],
							[
								-4.779884,
								9.821985
							],
							[
								-4.330247,
								9.610835
							],
							[
								-3.980449,
								9.862344
							],
							[
								-3.511899,
								9.900326
							],
							[
								-2.827496,
								9.642461
							],
							[
								-2.56219,
								8.219628
							],
							[
								-2.983585,
								7.379705
							],
							[
								-3.24437,
								6.250472
							],
							[
								-2.810701,
								5.389051
							],
							[
								-2.856125,
								4.994476
							]
						]
					]
				},
				"id": "CIV"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Cameroon"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								13.075822,
								2.267097
							],
							[
								12.951334,
								2.321616
							],
							[
								12.35938,
								2.192812
							],
							[
								11.751665,
								2.326758
							],
							[
								11.276449,
								2.261051
							],
							[
								9.649158,
								2.283866
							],
							[
								9.795196,
								3.073404
							],
							[
								9.404367,
								3.734527
							],
							[
								8.948116,
								3.904129
							],
							[
								8.744924,
								4.352215
							],
							[
								8.488816,
								4.495617
							],
							[
								8.500288,
								4.771983
							],
							[
								8.757533,
								5.479666
							],
							[
								9.233163,
								6.444491
							],
							[
								9.522706,
								6.453482
							],
							[
								10.118277,
								7.03877
							],
							[
								10.497375,
								7.055358
							],
							[
								11.058788,
								6.644427
							],
							[
								11.745774,
								6.981383
							],
							[
								11.839309,
								7.397042
							],
							[
								12.063946,
								7.799808
							],
							[
								12.218872,
								8.305824
							],
							[
								12.753672,
								8.717763
							],
							[
								12.955468,
								9.417772
							],
							[
								13.1676,
								9.640626
							],
							[
								13.308676,
								10.160362
							],
							[
								13.57295,
								10.798566
							],
							[
								14.415379,
								11.572369
							],
							[
								14.468192,
								11.904752
							],
							[
								14.577178,
								12.085361
							],
							[
								14.181336,
								12.483657
							],
							[
								14.213531,
								12.802035
							],
							[
								14.495787,
								12.859396
							],
							[
								14.893386,
								12.219048
							],
							[
								14.960152,
								11.555574
							],
							[
								14.923565,
								10.891325
							],
							[
								15.467873,
								9.982337
							],
							[
								14.909354,
								9.992129
							],
							[
								14.627201,
								9.920919
							],
							[
								14.171466,
								10.021378
							],
							[
								13.954218,
								9.549495
							],
							[
								14.544467,
								8.965861
							],
							[
								14.979996,
								8.796104
							],
							[
								15.120866,
								8.38215
							],
							[
								15.436092,
								7.692812
							],
							[
								15.27946,
								7.421925
							],
							[
								14.776545,
								6.408498
							],
							[
								14.53656,
								6.226959
							],
							[
								14.459407,
								5.451761
							],
							[
								14.558936,
								5.030598
							],
							[
								14.478372,
								4.732605
							],
							[
								14.950953,
								4.210389
							],
							[
								15.03622,
								3.851367
							],
							[
								15.405396,
								3.335301
							],
							[
								15.862732,
								3.013537
							],
							[
								15.907381,
								2.557389
							],
							[
								16.012852,
								2.26764
							],
							[
								15.940919,
								1.727673
							],
							[
								15.146342,
								1.964015
							],
							[
								14.337813,
								2.227875
							],
							[
								13.075822,
								2.267097
							]
						]
					]
				},
				"id": "CMR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Democratic Republic of the Congo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								30.83386,
								3.509166
							],
							[
								30.773347,
								2.339883
							],
							[
								31.174149,
								2.204465
							],
							[
								30.85267,
								1.849396
							],
							[
								30.468508,
								1.583805
							],
							[
								30.086154,
								1.062313
							],
							[
								29.875779,
								0.59738
							],
							[
								29.819503,
								-0.20531
							],
							[
								29.587838,
								-0.587406
							],
							[
								29.579466,
								-1.341313
							],
							[
								29.291887,
								-1.620056
							],
							[
								29.254835,
								-2.21511
							],
							[
								29.117479,
								-2.292211
							],
							[
								29.024926,
								-2.839258
							],
							[
								29.276384,
								-3.293907
							],
							[
								29.339998,
								-4.499983
							],
							[
								29.519987,
								-5.419979
							],
							[
								29.419993,
								-5.939999
							],
							[
								29.620032,
								-6.520015
							],
							[
								30.199997,
								-7.079981
							],
							[
								30.740015,
								-8.340007
							],
							[
								30.346086,
								-8.238257
							],
							[
								29.002912,
								-8.407032
							],
							[
								28.734867,
								-8.526559
							],
							[
								28.449871,
								-9.164918
							],
							[
								28.673682,
								-9.605925
							],
							[
								28.49607,
								-10.789884
							],
							[
								28.372253,
								-11.793647
							],
							[
								28.642417,
								-11.971569
							],
							[
								29.341548,
								-12.360744
							],
							[
								29.616001,
								-12.178895
							],
							[
								29.699614,
								-13.257227
							],
							[
								28.934286,
								-13.248958
							],
							[
								28.523562,
								-12.698604
							],
							[
								28.155109,
								-12.272481
							],
							[
								27.388799,
								-12.132747
							],
							[
								27.16442,
								-11.608748
							],
							[
								26.553088,
								-11.92444
							],
							[
								25.75231,
								-11.784965
							],
							[
								25.418118,
								-11.330936
							],
							[
								24.78317,
								-11.238694
							],
							[
								24.314516,
								-11.262826
							],
							[
								24.257155,
								-10.951993
							],
							[
								23.912215,
								-10.926826
							],
							[
								23.456791,
								-10.867863
							],
							[
								22.837345,
								-11.017622
							],
							[
								22.402798,
								-10.993075
							],
							[
								22.155268,
								-11.084801
							],
							[
								22.208753,
								-9.894796
							],
							[
								21.875182,
								-9.523708
							],
							[
								21.801801,
								-8.908707
							],
							[
								21.949131,
								-8.305901
							],
							[
								21.746456,
								-7.920085
							],
							[
								21.728111,
								-7.290872
							],
							[
								20.514748,
								-7.299606
							],
							[
								20.601823,
								-6.939318
							],
							[
								20.091622,
								-6.94309
							],
							[
								20.037723,
								-7.116361
							],
							[
								19.417502,
								-7.155429
							],
							[
								19.166613,
								-7.738184
							],
							[
								19.016752,
								-7.988246
							],
							[
								18.464176,
								-7.847014
							],
							[
								18.134222,
								-7.987678
							],
							[
								17.47297,
								-8.068551
							],
							[
								17.089996,
								-7.545689
							],
							[
								16.860191,
								-7.222298
							],
							[
								16.57318,
								-6.622645
							],
							[
								16.326528,
								-5.87747
							],
							[
								13.375597,
								-5.864241
							],
							[
								13.024869,
								-5.984389
							],
							[
								12.735171,
								-5.965682
							],
							[
								12.322432,
								-6.100092
							],
							[
								12.182337,
								-5.789931
							],
							[
								12.436688,
								-5.684304
							],
							[
								12.468004,
								-5.248362
							],
							[
								12.631612,
								-4.991271
							],
							[
								12.995517,
								-4.781103
							],
							[
								13.25824,
								-4.882957
							],
							[
								13.600235,
								-4.500138
							],
							[
								14.144956,
								-4.510009
							],
							[
								14.209035,
								-4.793092
							],
							[
								14.582604,
								-4.970239
							],
							[
								15.170992,
								-4.343507
							],
							[
								15.75354,
								-3.855165
							],
							[
								16.00629,
								-3.535133
							],
							[
								15.972803,
								-2.712392
							],
							[
								16.407092,
								-1.740927
							],
							[
								16.865307,
								-1.225816
							],
							[
								17.523716,
								-0.74383
							],
							[
								17.638645,
								-0.424832
							],
							[
								17.663553,
								-0.058084
							],
							[
								17.82654,
								0.288923
							],
							[
								17.774192,
								0.855659
							],
							[
								17.898835,
								1.741832
							],
							[
								18.094276,
								2.365722
							],
							[
								18.393792,
								2.900443
							],
							[
								18.453065,
								3.504386
							],
							[
								18.542982,
								4.201785
							],
							[
								18.932312,
								4.709506
							],
							[
								19.467784,
								5.031528
							],
							[
								20.290679,
								4.691678
							],
							[
								20.927591,
								4.322786
							],
							[
								21.659123,
								4.224342
							],
							[
								22.405124,
								4.02916
							],
							[
								22.704124,
								4.633051
							],
							[
								22.84148,
								4.710126
							],
							[
								23.297214,
								4.609693
							],
							[
								24.410531,
								5.108784
							],
							[
								24.805029,
								4.897247
							],
							[
								25.128833,
								4.927245
							],
							[
								25.278798,
								5.170408
							],
							[
								25.650455,
								5.256088
							],
							[
								26.402761,
								5.150875
							],
							[
								27.044065,
								5.127853
							],
							[
								27.374226,
								5.233944
							],
							[
								27.979977,
								4.408413
							],
							[
								28.428994,
								4.287155
							],
							[
								28.696678,
								4.455077
							],
							[
								29.159078,
								4.389267
							],
							[
								29.715995,
								4.600805
							],
							[
								29.9535,
								4.173699
							],
							[
								30.83386,
								3.509166
							]
						]
					]
				},
				"id": "COD"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Republic of the Congo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								12.995517,
								-4.781103
							],
							[
								12.62076,
								-4.438023
							],
							[
								12.318608,
								-4.60623
							],
							[
								11.914963,
								-5.037987
							],
							[
								11.093773,
								-3.978827
							],
							[
								11.855122,
								-3.426871
							],
							[
								11.478039,
								-2.765619
							],
							[
								11.820964,
								-2.514161
							],
							[
								12.495703,
								-2.391688
							],
							[
								12.575284,
								-1.948511
							],
							[
								13.109619,
								-2.42874
							],
							[
								13.992407,
								-2.470805
							],
							[
								14.29921,
								-1.998276
							],
							[
								14.425456,
								-1.333407
							],
							[
								14.316418,
								-0.552627
							],
							[
								13.843321,
								0.038758
							],
							[
								14.276266,
								1.19693
							],
							[
								14.026669,
								1.395677
							],
							[
								13.282631,
								1.314184
							],
							[
								13.003114,
								1.830896
							],
							[
								13.075822,
								2.267097
							],
							[
								14.337813,
								2.227875
							],
							[
								15.146342,
								1.964015
							],
							[
								15.940919,
								1.727673
							],
							[
								16.012852,
								2.26764
							],
							[
								16.537058,
								3.198255
							],
							[
								17.133042,
								3.728197
							],
							[
								17.8099,
								3.560196
							],
							[
								18.453065,
								3.504386
							],
							[
								18.393792,
								2.900443
							],
							[
								18.094276,
								2.365722
							],
							[
								17.898835,
								1.741832
							],
							[
								17.774192,
								0.855659
							],
							[
								17.82654,
								0.288923
							],
							[
								17.663553,
								-0.058084
							],
							[
								17.638645,
								-0.424832
							],
							[
								17.523716,
								-0.74383
							],
							[
								16.865307,
								-1.225816
							],
							[
								16.407092,
								-1.740927
							],
							[
								15.972803,
								-2.712392
							],
							[
								16.00629,
								-3.535133
							],
							[
								15.75354,
								-3.855165
							],
							[
								15.170992,
								-4.343507
							],
							[
								14.582604,
								-4.970239
							],
							[
								14.209035,
								-4.793092
							],
							[
								14.144956,
								-4.510009
							],
							[
								13.600235,
								-4.500138
							],
							[
								13.25824,
								-4.882957
							],
							[
								12.995517,
								-4.781103
							]
						]
					]
				},
				"id": "COG"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Colombia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-75.373223,
								-0.152032
							],
							[
								-75.801466,
								0.084801
							],
							[
								-76.292314,
								0.416047
							],
							[
								-76.57638,
								0.256936
							],
							[
								-77.424984,
								0.395687
							],
							[
								-77.668613,
								0.825893
							],
							[
								-77.855061,
								0.809925
							],
							[
								-78.855259,
								1.380924
							],
							[
								-78.990935,
								1.69137
							],
							[
								-78.617831,
								1.766404
							],
							[
								-78.662118,
								2.267355
							],
							[
								-78.42761,
								2.629556
							],
							[
								-77.931543,
								2.696606
							],
							[
								-77.510431,
								3.325017
							],
							[
								-77.12769,
								3.849636
							],
							[
								-77.496272,
								4.087606
							],
							[
								-77.307601,
								4.667984
							],
							[
								-77.533221,
								5.582812
							],
							[
								-77.318815,
								5.845354
							],
							[
								-77.476661,
								6.691116
							],
							[
								-77.881571,
								7.223771
							],
							[
								-77.753414,
								7.70984
							],
							[
								-77.431108,
								7.638061
							],
							[
								-77.242566,
								7.935278
							],
							[
								-77.474723,
								8.524286
							],
							[
								-77.353361,
								8.670505
							],
							[
								-76.836674,
								8.638749
							],
							[
								-76.086384,
								9.336821
							],
							[
								-75.6746,
								9.443248
							],
							[
								-75.664704,
								9.774003
							],
							[
								-75.480426,
								10.61899
							],
							[
								-74.906895,
								11.083045
							],
							[
								-74.276753,
								11.102036
							],
							[
								-74.197223,
								11.310473
							],
							[
								-73.414764,
								11.227015
							],
							[
								-72.627835,
								11.731972
							],
							[
								-72.238195,
								11.95555
							],
							[
								-71.75409,
								12.437303
							],
							[
								-71.399822,
								12.376041
							],
							[
								-71.137461,
								12.112982
							],
							[
								-71.331584,
								11.776284
							],
							[
								-71.973922,
								11.608672
							],
							[
								-72.227575,
								11.108702
							],
							[
								-72.614658,
								10.821975
							],
							[
								-72.905286,
								10.450344
							],
							[
								-73.027604,
								9.73677
							],
							[
								-73.304952,
								9.152
							],
							[
								-72.78873,
								9.085027
							],
							[
								-72.660495,
								8.625288
							],
							[
								-72.439862,
								8.405275
							],
							[
								-72.360901,
								8.002638
							],
							[
								-72.479679,
								7.632506
							],
							[
								-72.444487,
								7.423785
							],
							[
								-72.198352,
								7.340431
							],
							[
								-71.960176,
								6.991615
							],
							[
								-70.674234,
								7.087785
							],
							[
								-70.093313,
								6.960376
							],
							[
								-69.38948,
								6.099861
							],
							[
								-68.985319,
								6.206805
							],
							[
								-68.265052,
								6.153268
							],
							[
								-67.695087,
								6.267318
							],
							[
								-67.34144,
								6.095468
							],
							[
								-67.521532,
								5.55687
							],
							[
								-67.744697,
								5.221129
							],
							[
								-67.823012,
								4.503937
							],
							[
								-67.621836,
								3.839482
							],
							[
								-67.337564,
								3.542342
							],
							[
								-67.303173,
								3.318454
							],
							[
								-67.809938,
								2.820655
							],
							[
								-67.447092,
								2.600281
							],
							[
								-67.181294,
								2.250638
							],
							[
								-66.876326,
								1.253361
							],
							[
								-67.065048,
								1.130112
							],
							[
								-67.259998,
								1.719999
							],
							[
								-67.53781,
								2.037163
							],
							[
								-67.868565,
								1.692455
							],
							[
								-69.816973,
								1.714805
							],
							[
								-69.804597,
								1.089081
							],
							[
								-69.218638,
								0.985677
							],
							[
								-69.252434,
								0.602651
							],
							[
								-69.452396,
								0.706159
							],
							[
								-70.015566,
								0.541414
							],
							[
								-70.020656,
								-0.185156
							],
							[
								-69.577065,
								-0.549992
							],
							[
								-69.420486,
								-1.122619
							],
							[
								-69.444102,
								-1.556287
							],
							[
								-69.893635,
								-4.298187
							],
							[
								-70.394044,
								-3.766591
							],
							[
								-70.692682,
								-3.742872
							],
							[
								-70.047709,
								-2.725156
							],
							[
								-70.813476,
								-2.256865
							],
							[
								-71.413646,
								-2.342802
							],
							[
								-71.774761,
								-2.16979
							],
							[
								-72.325787,
								-2.434218
							],
							[
								-73.070392,
								-2.308954
							],
							[
								-73.659504,
								-1.260491
							],
							[
								-74.122395,
								-1.002833
							],
							[
								-74.441601,
								-0.53082
							],
							[
								-75.106625,
								-0.057205
							],
							[
								-75.373223,
								-0.152032
							]
						]
					]
				},
				"id": "COL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Costa Rica"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-82.965783,
								8.225028
							],
							[
								-83.508437,
								8.446927
							],
							[
								-83.711474,
								8.656836
							],
							[
								-83.596313,
								8.830443
							],
							[
								-83.632642,
								9.051386
							],
							[
								-83.909886,
								9.290803
							],
							[
								-84.303402,
								9.487354
							],
							[
								-84.647644,
								9.615537
							],
							[
								-84.713351,
								9.908052
							],
							[
								-84.97566,
								10.086723
							],
							[
								-84.911375,
								9.795992
							],
							[
								-85.110923,
								9.55704
							],
							[
								-85.339488,
								9.834542
							],
							[
								-85.660787,
								9.933347
							],
							[
								-85.797445,
								10.134886
							],
							[
								-85.791709,
								10.439337
							],
							[
								-85.659314,
								10.754331
							],
							[
								-85.941725,
								10.895278
							],
							[
								-85.71254,
								11.088445
							],
							[
								-85.561852,
								11.217119
							],
							[
								-84.903003,
								10.952303
							],
							[
								-84.673069,
								11.082657
							],
							[
								-84.355931,
								10.999226
							],
							[
								-84.190179,
								10.79345
							],
							[
								-83.895054,
								10.726839
							],
							[
								-83.655612,
								10.938764
							],
							[
								-83.40232,
								10.395438
							],
							[
								-83.015677,
								9.992982
							],
							[
								-82.546196,
								9.566135
							],
							[
								-82.932891,
								9.476812
							],
							[
								-82.927155,
								9.07433
							],
							[
								-82.719183,
								8.925709
							],
							[
								-82.868657,
								8.807266
							],
							[
								-82.829771,
								8.626295
							],
							[
								-82.913176,
								8.423517
							],
							[
								-82.965783,
								8.225028
							]
						]
					]
				},
				"id": "CRI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Cuba"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-82.268151,
								23.188611
							],
							[
								-81.404457,
								23.117271
							],
							[
								-80.618769,
								23.10598
							],
							[
								-79.679524,
								22.765303
							],
							[
								-79.281486,
								22.399202
							],
							[
								-78.347434,
								22.512166
							],
							[
								-77.993296,
								22.277194
							],
							[
								-77.146422,
								21.657851
							],
							[
								-76.523825,
								21.20682
							],
							[
								-76.19462,
								21.220565
							],
							[
								-75.598222,
								21.016624
							],
							[
								-75.67106,
								20.735091
							],
							[
								-74.933896,
								20.693905
							],
							[
								-74.178025,
								20.284628
							],
							[
								-74.296648,
								20.050379
							],
							[
								-74.961595,
								19.923435
							],
							[
								-75.63468,
								19.873774
							],
							[
								-76.323656,
								19.952891
							],
							[
								-77.755481,
								19.855481
							],
							[
								-77.085108,
								20.413354
							],
							[
								-77.492655,
								20.673105
							],
							[
								-78.137292,
								20.739949
							],
							[
								-78.482827,
								21.028613
							],
							[
								-78.719867,
								21.598114
							],
							[
								-79.285,
								21.559175
							],
							[
								-80.217475,
								21.827324
							],
							[
								-80.517535,
								22.037079
							],
							[
								-81.820943,
								22.192057
							],
							[
								-82.169992,
								22.387109
							],
							[
								-81.795002,
								22.636965
							],
							[
								-82.775898,
								22.68815
							],
							[
								-83.494459,
								22.168518
							],
							[
								-83.9088,
								22.154565
							],
							[
								-84.052151,
								21.910575
							],
							[
								-84.54703,
								21.801228
							],
							[
								-84.974911,
								21.896028
							],
							[
								-84.447062,
								22.20495
							],
							[
								-84.230357,
								22.565755
							],
							[
								-83.77824,
								22.788118
							],
							[
								-83.267548,
								22.983042
							],
							[
								-82.510436,
								23.078747
							],
							[
								-82.268151,
								23.188611
							]
						]
					]
				},
				"id": "CUB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Northern Cyprus"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								32.73178,
								35.140026
							],
							[
								32.802474,
								35.145504
							],
							[
								32.946961,
								35.386703
							],
							[
								33.667227,
								35.373216
							],
							[
								34.576474,
								35.671596
							],
							[
								33.900804,
								35.245756
							],
							[
								33.973617,
								35.058506
							],
							[
								33.86644,
								35.093595
							],
							[
								33.675392,
								35.017863
							],
							[
								33.525685,
								35.038688
							],
							[
								33.475817,
								35.000345
							],
							[
								33.455922,
								35.101424
							],
							[
								33.383833,
								35.162712
							],
							[
								33.190977,
								35.173125
							],
							[
								32.919572,
								35.087833
							],
							[
								32.73178,
								35.140026
							]
						]
					]
				},
				"id": "-99"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Cyprus"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.973617,
								35.058506
							],
							[
								34.004881,
								34.978098
							],
							[
								32.979827,
								34.571869
							],
							[
								32.490296,
								34.701655
							],
							[
								32.256667,
								35.103232
							],
							[
								32.73178,
								35.140026
							],
							[
								32.919572,
								35.087833
							],
							[
								33.190977,
								35.173125
							],
							[
								33.383833,
								35.162712
							],
							[
								33.455922,
								35.101424
							],
							[
								33.475817,
								35.000345
							],
							[
								33.525685,
								35.038688
							],
							[
								33.675392,
								35.017863
							],
							[
								33.86644,
								35.093595
							],
							[
								33.973617,
								35.058506
							]
						]
					]
				},
				"id": "CYP"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Czech Republic"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.960288,
								48.596982
							],
							[
								16.499283,
								48.785808
							],
							[
								16.029647,
								48.733899
							],
							[
								15.253416,
								49.039074
							],
							[
								14.901447,
								48.964402
							],
							[
								14.338898,
								48.555305
							],
							[
								13.595946,
								48.877172
							],
							[
								13.031329,
								49.307068
							],
							[
								12.521024,
								49.547415
							],
							[
								12.415191,
								49.969121
							],
							[
								12.240111,
								50.266338
							],
							[
								12.966837,
								50.484076
							],
							[
								13.338132,
								50.733234
							],
							[
								14.056228,
								50.926918
							],
							[
								14.307013,
								51.117268
							],
							[
								14.570718,
								51.002339
							],
							[
								15.016996,
								51.106674
							],
							[
								15.490972,
								50.78473
							],
							[
								16.238627,
								50.697733
							],
							[
								16.176253,
								50.422607
							],
							[
								16.719476,
								50.215747
							],
							[
								16.868769,
								50.473974
							],
							[
								17.554567,
								50.362146
							],
							[
								17.649445,
								50.049038
							],
							[
								18.392914,
								49.988629
							],
							[
								18.853144,
								49.49623
							],
							[
								18.554971,
								49.495015
							],
							[
								18.399994,
								49.315001
							],
							[
								18.170498,
								49.271515
							],
							[
								18.104973,
								49.043983
							],
							[
								17.913512,
								48.996493
							],
							[
								17.886485,
								48.903475
							],
							[
								17.545007,
								48.800019
							],
							[
								17.101985,
								48.816969
							],
							[
								16.960288,
								48.596982
							]
						]
					]
				},
				"id": "CZE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Germany"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.921906,
								54.983104
							],
							[
								9.93958,
								54.596642
							],
							[
								10.950112,
								54.363607
							],
							[
								10.939467,
								54.008693
							],
							[
								11.956252,
								54.196486
							],
							[
								12.51844,
								54.470371
							],
							[
								13.647467,
								54.075511
							],
							[
								14.119686,
								53.757029
							],
							[
								14.353315,
								53.248171
							],
							[
								14.074521,
								52.981263
							],
							[
								14.4376,
								52.62485
							],
							[
								14.685026,
								52.089947
							],
							[
								14.607098,
								51.745188
							],
							[
								15.016996,
								51.106674
							],
							[
								14.570718,
								51.002339
							],
							[
								14.307013,
								51.117268
							],
							[
								14.056228,
								50.926918
							],
							[
								13.338132,
								50.733234
							],
							[
								12.966837,
								50.484076
							],
							[
								12.240111,
								50.266338
							],
							[
								12.415191,
								49.969121
							],
							[
								12.521024,
								49.547415
							],
							[
								13.031329,
								49.307068
							],
							[
								13.595946,
								48.877172
							],
							[
								13.243357,
								48.416115
							],
							[
								12.884103,
								48.289146
							],
							[
								13.025851,
								47.637584
							],
							[
								12.932627,
								47.467646
							],
							[
								12.62076,
								47.672388
							],
							[
								12.141357,
								47.703083
							],
							[
								11.426414,
								47.523766
							],
							[
								10.544504,
								47.566399
							],
							[
								10.402084,
								47.302488
							],
							[
								9.896068,
								47.580197
							],
							[
								9.594226,
								47.525058
							],
							[
								8.522612,
								47.830828
							],
							[
								8.317301,
								47.61358
							],
							[
								7.466759,
								47.620582
							],
							[
								7.593676,
								48.333019
							],
							[
								8.099279,
								49.017784
							],
							[
								6.65823,
								49.201958
							],
							[
								6.18632,
								49.463803
							],
							[
								6.242751,
								49.902226
							],
							[
								6.043073,
								50.128052
							],
							[
								6.156658,
								50.803721
							],
							[
								5.988658,
								51.851616
							],
							[
								6.589397,
								51.852029
							],
							[
								6.84287,
								52.22844
							],
							[
								7.092053,
								53.144043
							],
							[
								6.90514,
								53.482162
							],
							[
								7.100425,
								53.693932
							],
							[
								7.936239,
								53.748296
							],
							[
								8.121706,
								53.527792
							],
							[
								8.800734,
								54.020786
							],
							[
								8.572118,
								54.395646
							],
							[
								8.526229,
								54.962744
							],
							[
								9.282049,
								54.830865
							],
							[
								9.921906,
								54.983104
							]
						]
					]
				},
				"id": "DEU"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Djibouti"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								43.081226,
								12.699639
							],
							[
								43.317852,
								12.390148
							],
							[
								43.286381,
								11.974928
							],
							[
								42.715874,
								11.735641
							],
							[
								43.145305,
								11.46204
							],
							[
								42.776852,
								10.926879
							],
							[
								42.55493,
								11.10511
							],
							[
								42.31414,
								11.0342
							],
							[
								41.75557,
								11.05091
							],
							[
								41.73959,
								11.35511
							],
							[
								41.66176,
								11.6312
							],
							[
								42,
								12.1
							],
							[
								42.35156,
								12.54223
							],
							[
								42.779642,
								12.455416
							],
							[
								43.081226,
								12.699639
							]
						]
					]
				},
				"id": "DJI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Denmark"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									12.690006,
									55.609991
								],
								[
									12.089991,
									54.800015
								],
								[
									11.043543,
									55.364864
								],
								[
									10.903914,
									55.779955
								],
								[
									12.370904,
									56.111407
								],
								[
									12.690006,
									55.609991
								]
							]
						],
						[
							[
								[
									10.912182,
									56.458621
								],
								[
									10.667804,
									56.081383
								],
								[
									10.369993,
									56.190007
								],
								[
									9.649985,
									55.469999
								],
								[
									9.921906,
									54.983104
								],
								[
									9.282049,
									54.830865
								],
								[
									8.526229,
									54.962744
								],
								[
									8.120311,
									55.517723
								],
								[
									8.089977,
									56.540012
								],
								[
									8.256582,
									56.809969
								],
								[
									8.543438,
									57.110003
								],
								[
									9.424469,
									57.172066
								],
								[
									9.775559,
									57.447941
								],
								[
									10.580006,
									57.730017
								],
								[
									10.546106,
									57.215733
								],
								[
									10.25,
									56.890016
								],
								[
									10.369993,
									56.609982
								],
								[
									10.912182,
									56.458621
								]
							]
						]
					]
				},
				"id": "DNK"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Dominican Republic"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-71.712361,
								19.714456
							],
							[
								-71.587304,
								19.884911
							],
							[
								-70.806706,
								19.880286
							],
							[
								-70.214365,
								19.622885
							],
							[
								-69.950815,
								19.648
							],
							[
								-69.76925,
								19.293267
							],
							[
								-69.222126,
								19.313214
							],
							[
								-69.254346,
								19.015196
							],
							[
								-68.809412,
								18.979074
							],
							[
								-68.317943,
								18.612198
							],
							[
								-68.689316,
								18.205142
							],
							[
								-69.164946,
								18.422648
							],
							[
								-69.623988,
								18.380713
							],
							[
								-69.952934,
								18.428307
							],
							[
								-70.133233,
								18.245915
							],
							[
								-70.517137,
								18.184291
							],
							[
								-70.669298,
								18.426886
							],
							[
								-70.99995,
								18.283329
							],
							[
								-71.40021,
								17.598564
							],
							[
								-71.657662,
								17.757573
							],
							[
								-71.708305,
								18.044997
							],
							[
								-71.687738,
								18.31666
							],
							[
								-71.945112,
								18.6169
							],
							[
								-71.701303,
								18.785417
							],
							[
								-71.624873,
								19.169838
							],
							[
								-71.712361,
								19.714456
							]
						]
					]
				},
				"id": "DOM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Algeria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								11.999506,
								23.471668
							],
							[
								8.572893,
								21.565661
							],
							[
								5.677566,
								19.601207
							],
							[
								4.267419,
								19.155265
							],
							[
								3.158133,
								19.057364
							],
							[
								3.146661,
								19.693579
							],
							[
								2.683588,
								19.85623
							],
							[
								2.060991,
								20.142233
							],
							[
								1.823228,
								20.610809
							],
							[
								-1.550055,
								22.792666
							],
							[
								-4.923337,
								24.974574
							],
							[
								-8.6844,
								27.395744
							],
							[
								-8.665124,
								27.589479
							],
							[
								-8.66559,
								27.656426
							],
							[
								-8.674116,
								28.841289
							],
							[
								-7.059228,
								29.579228
							],
							[
								-6.060632,
								29.7317
							],
							[
								-5.242129,
								30.000443
							],
							[
								-4.859646,
								30.501188
							],
							[
								-3.690441,
								30.896952
							],
							[
								-3.647498,
								31.637294
							],
							[
								-3.06898,
								31.724498
							],
							[
								-2.616605,
								32.094346
							],
							[
								-1.307899,
								32.262889
							],
							[
								-1.124551,
								32.651522
							],
							[
								-1.388049,
								32.864015
							],
							[
								-1.733455,
								33.919713
							],
							[
								-1.792986,
								34.527919
							],
							[
								-2.169914,
								35.168396
							],
							[
								-1.208603,
								35.714849
							],
							[
								-0.127454,
								35.888662
							],
							[
								0.503877,
								36.301273
							],
							[
								1.466919,
								36.605647
							],
							[
								3.161699,
								36.783905
							],
							[
								4.815758,
								36.865037
							],
							[
								5.32012,
								36.716519
							],
							[
								6.26182,
								37.110655
							],
							[
								7.330385,
								37.118381
							],
							[
								7.737078,
								36.885708
							],
							[
								8.420964,
								36.946427
							],
							[
								8.217824,
								36.433177
							],
							[
								8.376368,
								35.479876
							],
							[
								8.140981,
								34.655146
							],
							[
								7.524482,
								34.097376
							],
							[
								7.612642,
								33.344115
							],
							[
								8.430473,
								32.748337
							],
							[
								8.439103,
								32.506285
							],
							[
								9.055603,
								32.102692
							],
							[
								9.48214,
								30.307556
							],
							[
								9.805634,
								29.424638
							],
							[
								9.859998,
								28.95999
							],
							[
								9.683885,
								28.144174
							],
							[
								9.756128,
								27.688259
							],
							[
								9.629056,
								27.140953
							],
							[
								9.716286,
								26.512206
							],
							[
								9.319411,
								26.094325
							],
							[
								9.910693,
								25.365455
							],
							[
								9.948261,
								24.936954
							],
							[
								10.303847,
								24.379313
							],
							[
								10.771364,
								24.562532
							],
							[
								11.560669,
								24.097909
							],
							[
								11.999506,
								23.471668
							]
						]
					]
				},
				"id": "DZA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Ecuador"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-80.302561,
								-3.404856
							],
							[
								-79.770293,
								-2.657512
							],
							[
								-79.986559,
								-2.220794
							],
							[
								-80.368784,
								-2.685159
							],
							[
								-80.967765,
								-2.246943
							],
							[
								-80.764806,
								-1.965048
							],
							[
								-80.933659,
								-1.057455
							],
							[
								-80.58337,
								-0.906663
							],
							[
								-80.399325,
								-0.283703
							],
							[
								-80.020898,
								0.36034
							],
							[
								-80.09061,
								0.768429
							],
							[
								-79.542762,
								0.982938
							],
							[
								-78.855259,
								1.380924
							],
							[
								-77.855061,
								0.809925
							],
							[
								-77.668613,
								0.825893
							],
							[
								-77.424984,
								0.395687
							],
							[
								-76.57638,
								0.256936
							],
							[
								-76.292314,
								0.416047
							],
							[
								-75.801466,
								0.084801
							],
							[
								-75.373223,
								-0.152032
							],
							[
								-75.233723,
								-0.911417
							],
							[
								-75.544996,
								-1.56161
							],
							[
								-76.635394,
								-2.608678
							],
							[
								-77.837905,
								-3.003021
							],
							[
								-78.450684,
								-3.873097
							],
							[
								-78.639897,
								-4.547784
							],
							[
								-79.205289,
								-4.959129
							],
							[
								-79.624979,
								-4.454198
							],
							[
								-80.028908,
								-4.346091
							],
							[
								-80.442242,
								-4.425724
							],
							[
								-80.469295,
								-4.059287
							],
							[
								-80.184015,
								-3.821162
							],
							[
								-80.302561,
								-3.404856
							]
						]
					]
				},
				"id": "ECU"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Egypt"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								34.9226,
								29.50133
							],
							[
								34.64174,
								29.09942
							],
							[
								34.42655,
								28.34399
							],
							[
								34.15451,
								27.8233
							],
							[
								33.92136,
								27.6487
							],
							[
								33.58811,
								27.97136
							],
							[
								33.13676,
								28.41765
							],
							[
								32.42323,
								29.85108
							],
							[
								32.32046,
								29.76043
							],
							[
								32.73482,
								28.70523
							],
							[
								33.34876,
								27.69989
							],
							[
								34.10455,
								26.14227
							],
							[
								34.47387,
								25.59856
							],
							[
								34.79507,
								25.03375
							],
							[
								35.69241,
								23.92671
							],
							[
								35.49372,
								23.75237
							],
							[
								35.52598,
								23.10244
							],
							[
								36.69069,
								22.20485
							],
							[
								36.86623,
								22
							],
							[
								32.9,
								22
							],
							[
								29.02,
								22
							],
							[
								25,
								22
							],
							[
								25,
								25.6825
							],
							[
								25,
								29.238655
							],
							[
								24.70007,
								30.04419
							],
							[
								24.95762,
								30.6616
							],
							[
								24.80287,
								31.08929
							],
							[
								25.16482,
								31.56915
							],
							[
								26.49533,
								31.58568
							],
							[
								27.45762,
								31.32126
							],
							[
								28.45048,
								31.02577
							],
							[
								28.91353,
								30.87005
							],
							[
								29.68342,
								31.18686
							],
							[
								30.09503,
								31.4734
							],
							[
								30.97693,
								31.55586
							],
							[
								31.68796,
								31.4296
							],
							[
								31.96041,
								30.9336
							],
							[
								32.19247,
								31.26034
							],
							[
								32.99392,
								31.02407
							],
							[
								33.7734,
								30.96746
							],
							[
								34.26544,
								31.21936
							],
							[
								34.9226,
								29.50133
							]
						]
					]
				},
				"id": "EGY"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Eritrea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								42.35156,
								12.54223
							],
							[
								42.00975,
								12.86582
							],
							[
								41.59856,
								13.45209
							],
							[
								41.155194,
								13.77332
							],
							[
								40.8966,
								14.11864
							],
							[
								40.026219,
								14.519579
							],
							[
								39.34061,
								14.53155
							],
							[
								39.0994,
								14.74064
							],
							[
								38.51295,
								14.50547
							],
							[
								37.90607,
								14.95943
							],
							[
								37.59377,
								14.2131
							],
							[
								36.42951,
								14.42211
							],
							[
								36.323189,
								14.822481
							],
							[
								36.75386,
								16.291874
							],
							[
								36.85253,
								16.95655
							],
							[
								37.16747,
								17.26314
							],
							[
								37.904,
								17.42754
							],
							[
								38.41009,
								17.998307
							],
							[
								38.990623,
								16.840626
							],
							[
								39.26611,
								15.922723
							],
							[
								39.814294,
								15.435647
							],
							[
								41.179275,
								14.49108
							],
							[
								41.734952,
								13.921037
							],
							[
								42.276831,
								13.343992
							],
							[
								42.589576,
								13.000421
							],
							[
								43.081226,
								12.699639
							],
							[
								42.779642,
								12.455416
							],
							[
								42.35156,
								12.54223
							]
						]
					]
				},
				"id": "ERI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Spain"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-9.034818,
								41.880571
							],
							[
								-8.984433,
								42.592775
							],
							[
								-9.392884,
								43.026625
							],
							[
								-7.97819,
								43.748338
							],
							[
								-6.754492,
								43.567909
							],
							[
								-5.411886,
								43.57424
							],
							[
								-4.347843,
								43.403449
							],
							[
								-3.517532,
								43.455901
							],
							[
								-1.901351,
								43.422802
							],
							[
								-1.502771,
								43.034014
							],
							[
								0.338047,
								42.579546
							],
							[
								0.701591,
								42.795734
							],
							[
								1.826793,
								42.343385
							],
							[
								2.985999,
								42.473015
							],
							[
								3.039484,
								41.89212
							],
							[
								2.091842,
								41.226089
							],
							[
								0.810525,
								41.014732
							],
							[
								0.721331,
								40.678318
							],
							[
								0.106692,
								40.123934
							],
							[
								-0.278711,
								39.309978
							],
							[
								0.111291,
								38.738514
							],
							[
								-0.467124,
								38.292366
							],
							[
								-0.683389,
								37.642354
							],
							[
								-1.438382,
								37.443064
							],
							[
								-2.146453,
								36.674144
							],
							[
								-3.415781,
								36.6589
							],
							[
								-4.368901,
								36.677839
							],
							[
								-4.995219,
								36.324708
							],
							[
								-5.37716,
								35.94685
							],
							[
								-5.866432,
								36.029817
							],
							[
								-6.236694,
								36.367677
							],
							[
								-6.520191,
								36.942913
							],
							[
								-7.453726,
								37.097788
							],
							[
								-7.537105,
								37.428904
							],
							[
								-7.166508,
								37.803894
							],
							[
								-7.029281,
								38.075764
							],
							[
								-7.374092,
								38.373059
							],
							[
								-7.098037,
								39.030073
							],
							[
								-7.498632,
								39.629571
							],
							[
								-7.066592,
								39.711892
							],
							[
								-7.026413,
								40.184524
							],
							[
								-6.86402,
								40.330872
							],
							[
								-6.851127,
								41.111083
							],
							[
								-6.389088,
								41.381815
							],
							[
								-6.668606,
								41.883387
							],
							[
								-7.251309,
								41.918346
							],
							[
								-7.422513,
								41.792075
							],
							[
								-8.013175,
								41.790886
							],
							[
								-8.263857,
								42.280469
							],
							[
								-8.671946,
								42.134689
							],
							[
								-9.034818,
								41.880571
							]
						]
					]
				},
				"id": "ESP"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Estonia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								24.312863,
								57.793424
							],
							[
								24.428928,
								58.383413
							],
							[
								24.061198,
								58.257375
							],
							[
								23.42656,
								58.612753
							],
							[
								23.339795,
								59.18724
							],
							[
								24.604214,
								59.465854
							],
							[
								25.864189,
								59.61109
							],
							[
								26.949136,
								59.445803
							],
							[
								27.981114,
								59.475388
							],
							[
								28.131699,
								59.300825
							],
							[
								27.420166,
								58.724581
							],
							[
								27.716686,
								57.791899
							],
							[
								27.288185,
								57.474528
							],
							[
								26.463532,
								57.476389
							],
							[
								25.60281,
								57.847529
							],
							[
								25.164594,
								57.970157
							],
							[
								24.312863,
								57.793424
							]
						]
					]
				},
				"id": "EST"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Ethiopia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								37.90607,
								14.95943
							],
							[
								38.51295,
								14.50547
							],
							[
								39.0994,
								14.74064
							],
							[
								39.34061,
								14.53155
							],
							[
								40.02625,
								14.51959
							],
							[
								40.8966,
								14.11864
							],
							[
								41.1552,
								13.77333
							],
							[
								41.59856,
								13.45209
							],
							[
								42.00975,
								12.86582
							],
							[
								42.35156,
								12.54223
							],
							[
								42,
								12.1
							],
							[
								41.66176,
								11.6312
							],
							[
								41.73959,
								11.35511
							],
							[
								41.75557,
								11.05091
							],
							[
								42.31414,
								11.0342
							],
							[
								42.55493,
								11.10511
							],
							[
								42.776852,
								10.926879
							],
							[
								42.55876,
								10.57258
							],
							[
								42.92812,
								10.02194
							],
							[
								43.29699,
								9.54048
							],
							[
								43.67875,
								9.18358
							],
							[
								46.94834,
								7.99688
							],
							[
								47.78942,
								8.003
							],
							[
								44.9636,
								5.00162
							],
							[
								43.66087,
								4.95755
							],
							[
								42.76967,
								4.25259
							],
							[
								42.12861,
								4.23413
							],
							[
								41.855083,
								3.918912
							],
							[
								41.1718,
								3.91909
							],
							[
								40.76848,
								4.25702
							],
							[
								39.85494,
								3.83879
							],
							[
								39.559384,
								3.42206
							],
							[
								38.89251,
								3.50074
							],
							[
								38.67114,
								3.61607
							],
							[
								38.43697,
								3.58851
							],
							[
								38.120915,
								3.598605
							],
							[
								36.855093,
								4.447864
							],
							[
								36.159079,
								4.447864
							],
							[
								35.817448,
								4.776966
							],
							[
								35.817448,
								5.338232
							],
							[
								35.298007,
								5.506
							],
							[
								34.70702,
								6.59422
							],
							[
								34.25032,
								6.82607
							],
							[
								34.0751,
								7.22595
							],
							[
								33.56829,
								7.71334
							],
							[
								32.95418,
								7.78497
							],
							[
								33.2948,
								8.35458
							],
							[
								33.8255,
								8.37916
							],
							[
								33.97498,
								8.68456
							],
							[
								33.96162,
								9.58358
							],
							[
								34.25745,
								10.63009
							],
							[
								34.73115,
								10.91017
							],
							[
								34.83163,
								11.31896
							],
							[
								35.26049,
								12.08286
							],
							[
								35.86363,
								12.57828
							],
							[
								36.27022,
								13.56333
							],
							[
								36.42951,
								14.42211
							],
							[
								37.59377,
								14.2131
							],
							[
								37.90607,
								14.95943
							]
						]
					]
				},
				"id": "ETH"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Finland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								28.59193,
								69.064777
							],
							[
								28.445944,
								68.364613
							],
							[
								29.977426,
								67.698297
							],
							[
								29.054589,
								66.944286
							],
							[
								30.21765,
								65.80598
							],
							[
								29.54443,
								64.948672
							],
							[
								30.444685,
								64.204453
							],
							[
								30.035872,
								63.552814
							],
							[
								31.516092,
								62.867687
							],
							[
								31.139991,
								62.357693
							],
							[
								30.211107,
								61.780028
							],
							[
								28.069998,
								60.503517
							],
							[
								26.255173,
								60.423961
							],
							[
								24.496624,
								60.057316
							],
							[
								22.869695,
								59.846373
							],
							[
								22.290764,
								60.391921
							],
							[
								21.322244,
								60.72017
							],
							[
								21.544866,
								61.705329
							],
							[
								21.059211,
								62.607393
							],
							[
								21.536029,
								63.189735
							],
							[
								22.442744,
								63.81781
							],
							[
								24.730512,
								64.902344
							],
							[
								25.398068,
								65.111427
							],
							[
								25.294043,
								65.534346
							],
							[
								23.903379,
								66.006927
							],
							[
								23.56588,
								66.396051
							],
							[
								23.539473,
								67.936009
							],
							[
								21.978535,
								68.616846
							],
							[
								20.645593,
								69.106247
							],
							[
								21.244936,
								69.370443
							],
							[
								22.356238,
								68.841741
							],
							[
								23.66205,
								68.891247
							],
							[
								24.735679,
								68.649557
							],
							[
								25.689213,
								69.092114
							],
							[
								26.179622,
								69.825299
							],
							[
								27.732292,
								70.164193
							],
							[
								29.015573,
								69.766491
							],
							[
								28.59193,
								69.064777
							]
						]
					]
				},
				"id": "FIN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Fiji"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									178.3736,
									-17.33992
								],
								[
									178.71806,
									-17.62846
								],
								[
									178.55271,
									-18.15059
								],
								[
									177.93266,
									-18.28799
								],
								[
									177.38146,
									-18.16432
								],
								[
									177.28504,
									-17.72465
								],
								[
									177.67087,
									-17.38114
								],
								[
									178.12557,
									-17.50481
								],
								[
									178.3736,
									-17.33992
								]
							]
						],
						[
							[
								[
									179.364143,
									-16.801354
								],
								[
									178.725059,
									-17.012042
								],
								[
									178.596839,
									-16.63915
								],
								[
									179.096609,
									-16.433984
								],
								[
									179.413509,
									-16.379054
								],
								[
									180,
									-16.067133
								],
								[
									180,
									-16.555217
								],
								[
									179.364143,
									-16.801354
								]
							]
						],
						[
							[
								[
									-179.917369,
									-16.501783
								],
								[
									-180,
									-16.555217
								],
								[
									-180,
									-16.067133
								],
								[
									-179.79332,
									-16.020882
								],
								[
									-179.917369,
									-16.501783
								]
							]
						]
					]
				},
				"id": "FJI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Falkland Islands"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-61.2,
								-51.85
							],
							[
								-60,
								-51.25
							],
							[
								-59.15,
								-51.5
							],
							[
								-58.55,
								-51.1
							],
							[
								-57.75,
								-51.55
							],
							[
								-58.05,
								-51.9
							],
							[
								-59.4,
								-52.2
							],
							[
								-59.85,
								-51.85
							],
							[
								-60.7,
								-52.3
							],
							[
								-61.2,
								-51.85
							]
						]
					]
				},
				"id": "FLK"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "France"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-52.556425,
									2.504705
								],
								[
									-52.939657,
									2.124858
								],
								[
									-53.418465,
									2.053389
								],
								[
									-53.554839,
									2.334897
								],
								[
									-53.778521,
									2.376703
								],
								[
									-54.088063,
									2.105557
								],
								[
									-54.524754,
									2.311849
								],
								[
									-54.27123,
									2.738748
								],
								[
									-54.184284,
									3.194172
								],
								[
									-54.011504,
									3.62257
								],
								[
									-54.399542,
									4.212611
								],
								[
									-54.478633,
									4.896756
								],
								[
									-53.958045,
									5.756548
								],
								[
									-53.618453,
									5.646529
								],
								[
									-52.882141,
									5.409851
								],
								[
									-51.823343,
									4.565768
								],
								[
									-51.657797,
									4.156232
								],
								[
									-52.249338,
									3.241094
								],
								[
									-52.556425,
									2.504705
								]
							]
						],
						[
							[
								[
									9.560016,
									42.152492
								],
								[
									9.229752,
									41.380007
								],
								[
									8.775723,
									41.583612
								],
								[
									8.544213,
									42.256517
								],
								[
									8.746009,
									42.628122
								],
								[
									9.390001,
									43.009985
								],
								[
									9.560016,
									42.152492
								]
							]
						],
						[
							[
								[
									3.588184,
									50.378992
								],
								[
									4.286023,
									49.907497
								],
								[
									4.799222,
									49.985373
								],
								[
									5.674052,
									49.529484
								],
								[
									5.897759,
									49.442667
								],
								[
									6.18632,
									49.463803
								],
								[
									6.65823,
									49.201958
								],
								[
									8.099279,
									49.017784
								],
								[
									7.593676,
									48.333019
								],
								[
									7.466759,
									47.620582
								],
								[
									7.192202,
									47.449766
								],
								[
									6.736571,
									47.541801
								],
								[
									6.768714,
									47.287708
								],
								[
									6.037389,
									46.725779
								],
								[
									6.022609,
									46.27299
								],
								[
									6.5001,
									46.429673
								],
								[
									6.843593,
									45.991147
								],
								[
									6.802355,
									45.70858
								],
								[
									7.096652,
									45.333099
								],
								[
									6.749955,
									45.028518
								],
								[
									7.007562,
									44.254767
								],
								[
									7.549596,
									44.127901
								],
								[
									7.435185,
									43.693845
								],
								[
									6.529245,
									43.128892
								],
								[
									4.556963,
									43.399651
								],
								[
									3.100411,
									43.075201
								],
								[
									2.985999,
									42.473015
								],
								[
									1.826793,
									42.343385
								],
								[
									0.701591,
									42.795734
								],
								[
									0.338047,
									42.579546
								],
								[
									-1.502771,
									43.034014
								],
								[
									-1.901351,
									43.422802
								],
								[
									-1.384225,
									44.02261
								],
								[
									-1.193798,
									46.014918
								],
								[
									-2.225724,
									47.064363
								],
								[
									-2.963276,
									47.570327
								],
								[
									-4.491555,
									47.954954
								],
								[
									-4.59235,
									48.68416
								],
								[
									-3.295814,
									48.901692
								],
								[
									-1.616511,
									48.644421
								],
								[
									-1.933494,
									49.776342
								],
								[
									-0.989469,
									49.347376
								],
								[
									1.338761,
									50.127173
								],
								[
									1.639001,
									50.946606
								],
								[
									2.513573,
									51.148506
								],
								[
									2.658422,
									50.796848
								],
								[
									3.123252,
									50.780363
								],
								[
									3.588184,
									50.378992
								]
							]
						]
					]
				},
				"id": "FRA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Gabon"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								11.093773,
								-3.978827
							],
							[
								10.066135,
								-2.969483
							],
							[
								9.405245,
								-2.144313
							],
							[
								8.797996,
								-1.111301
							],
							[
								8.830087,
								-0.779074
							],
							[
								9.04842,
								-0.459351
							],
							[
								9.291351,
								0.268666
							],
							[
								9.492889,
								1.01012
							],
							[
								9.830284,
								1.067894
							],
							[
								11.285079,
								1.057662
							],
							[
								11.276449,
								2.261051
							],
							[
								11.751665,
								2.326758
							],
							[
								12.35938,
								2.192812
							],
							[
								12.951334,
								2.321616
							],
							[
								13.075822,
								2.267097
							],
							[
								13.003114,
								1.830896
							],
							[
								13.282631,
								1.314184
							],
							[
								14.026669,
								1.395677
							],
							[
								14.276266,
								1.19693
							],
							[
								13.843321,
								0.038758
							],
							[
								14.316418,
								-0.552627
							],
							[
								14.425456,
								-1.333407
							],
							[
								14.29921,
								-1.998276
							],
							[
								13.992407,
								-2.470805
							],
							[
								13.109619,
								-2.42874
							],
							[
								12.575284,
								-1.948511
							],
							[
								12.495703,
								-2.391688
							],
							[
								11.820964,
								-2.514161
							],
							[
								11.478039,
								-2.765619
							],
							[
								11.855122,
								-3.426871
							],
							[
								11.093773,
								-3.978827
							]
						]
					]
				},
				"id": "GAB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "United Kingdom"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-5.661949,
									54.554603
								],
								[
									-6.197885,
									53.867565
								],
								[
									-6.95373,
									54.073702
								],
								[
									-7.572168,
									54.059956
								],
								[
									-7.366031,
									54.595841
								],
								[
									-7.572168,
									55.131622
								],
								[
									-6.733847,
									55.17286
								],
								[
									-5.661949,
									54.554603
								]
							]
						],
						[
							[
								[
									-3.005005,
									58.635
								],
								[
									-4.073828,
									57.553025
								],
								[
									-3.055002,
									57.690019
								],
								[
									-1.959281,
									57.6848
								],
								[
									-2.219988,
									56.870017
								],
								[
									-3.119003,
									55.973793
								],
								[
									-2.085009,
									55.909998
								],
								[
									-2.005676,
									55.804903
								],
								[
									-1.114991,
									54.624986
								],
								[
									-0.430485,
									54.464376
								],
								[
									0.184981,
									53.325014
								],
								[
									0.469977,
									52.929999
								],
								[
									1.681531,
									52.73952
								],
								[
									1.559988,
									52.099998
								],
								[
									1.050562,
									51.806761
								],
								[
									1.449865,
									51.289428
								],
								[
									0.550334,
									50.765739
								],
								[
									-0.787517,
									50.774989
								],
								[
									-2.489998,
									50.500019
								],
								[
									-2.956274,
									50.69688
								],
								[
									-3.617448,
									50.228356
								],
								[
									-4.542508,
									50.341837
								],
								[
									-5.245023,
									49.96
								],
								[
									-5.776567,
									50.159678
								],
								[
									-4.30999,
									51.210001
								],
								[
									-3.414851,
									51.426009
								],
								[
									-3.422719,
									51.426848
								],
								[
									-4.984367,
									51.593466
								],
								[
									-5.267296,
									51.9914
								],
								[
									-4.222347,
									52.301356
								],
								[
									-4.770013,
									52.840005
								],
								[
									-4.579999,
									53.495004
								],
								[
									-3.093831,
									53.404547
								],
								[
									-3.09208,
									53.404441
								],
								[
									-2.945009,
									53.985
								],
								[
									-3.614701,
									54.600937
								],
								[
									-3.630005,
									54.615013
								],
								[
									-4.844169,
									54.790971
								],
								[
									-5.082527,
									55.061601
								],
								[
									-4.719112,
									55.508473
								],
								[
									-5.047981,
									55.783986
								],
								[
									-5.586398,
									55.311146
								],
								[
									-5.644999,
									56.275015
								],
								[
									-6.149981,
									56.78501
								],
								[
									-5.786825,
									57.818848
								],
								[
									-5.009999,
									58.630013
								],
								[
									-4.211495,
									58.550845
								],
								[
									-3.005005,
									58.635
								]
							]
						]
					]
				},
				"id": "GBR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Georgia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								41.554084,
								41.535656
							],
							[
								41.703171,
								41.962943
							],
							[
								41.45347,
								42.645123
							],
							[
								40.875469,
								43.013628
							],
							[
								40.321394,
								43.128634
							],
							[
								39.955009,
								43.434998
							],
							[
								40.076965,
								43.553104
							],
							[
								40.922185,
								43.382159
							],
							[
								42.394395,
								43.220308
							],
							[
								43.756017,
								42.740828
							],
							[
								43.9312,
								42.554974
							],
							[
								44.537623,
								42.711993
							],
							[
								45.470279,
								42.502781
							],
							[
								45.77641,
								42.092444
							],
							[
								46.404951,
								41.860675
							],
							[
								46.145432,
								41.722802
							],
							[
								46.637908,
								41.181673
							],
							[
								46.501637,
								41.064445
							],
							[
								45.962601,
								41.123873
							],
							[
								45.217426,
								41.411452
							],
							[
								44.97248,
								41.248129
							],
							[
								43.582746,
								41.092143
							],
							[
								42.619549,
								41.583173
							],
							[
								41.554084,
								41.535656
							]
						]
					]
				},
				"id": "GEO"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Ghana"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								1.060122,
								5.928837
							],
							[
								-0.507638,
								5.343473
							],
							[
								-1.063625,
								5.000548
							],
							[
								-1.964707,
								4.710462
							],
							[
								-2.856125,
								4.994476
							],
							[
								-2.810701,
								5.389051
							],
							[
								-3.24437,
								6.250472
							],
							[
								-2.983585,
								7.379705
							],
							[
								-2.56219,
								8.219628
							],
							[
								-2.827496,
								9.642461
							],
							[
								-2.963896,
								10.395335
							],
							[
								-2.940409,
								10.96269
							],
							[
								-1.203358,
								11.009819
							],
							[
								-0.761576,
								10.93693
							],
							[
								-0.438702,
								11.098341
							],
							[
								0.023803,
								11.018682
							],
							[
								-0.049785,
								10.706918
							],
							[
								0.36758,
								10.191213
							],
							[
								0.365901,
								9.465004
							],
							[
								0.461192,
								8.677223
							],
							[
								0.712029,
								8.312465
							],
							[
								0.490957,
								7.411744
							],
							[
								0.570384,
								6.914359
							],
							[
								0.836931,
								6.279979
							],
							[
								1.060122,
								5.928837
							]
						]
					]
				},
				"id": "GHA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Guinea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-8.439298,
								7.686043
							],
							[
								-8.722124,
								7.711674
							],
							[
								-8.926065,
								7.309037
							],
							[
								-9.208786,
								7.313921
							],
							[
								-9.403348,
								7.526905
							],
							[
								-9.33728,
								7.928534
							],
							[
								-9.755342,
								8.541055
							],
							[
								-10.016567,
								8.428504
							],
							[
								-10.230094,
								8.406206
							],
							[
								-10.505477,
								8.348896
							],
							[
								-10.494315,
								8.715541
							],
							[
								-10.65477,
								8.977178
							],
							[
								-10.622395,
								9.26791
							],
							[
								-10.839152,
								9.688246
							],
							[
								-11.117481,
								10.045873
							],
							[
								-11.917277,
								10.046984
							],
							[
								-12.150338,
								9.858572
							],
							[
								-12.425929,
								9.835834
							],
							[
								-12.596719,
								9.620188
							],
							[
								-12.711958,
								9.342712
							],
							[
								-13.24655,
								8.903049
							],
							[
								-13.685154,
								9.494744
							],
							[
								-14.074045,
								9.886167
							],
							[
								-14.330076,
								10.01572
							],
							[
								-14.579699,
								10.214467
							],
							[
								-14.693232,
								10.656301
							],
							[
								-14.839554,
								10.876572
							],
							[
								-15.130311,
								11.040412
							],
							[
								-14.685687,
								11.527824
							],
							[
								-14.382192,
								11.509272
							],
							[
								-14.121406,
								11.677117
							],
							[
								-13.9008,
								11.678719
							],
							[
								-13.743161,
								11.811269
							],
							[
								-13.828272,
								12.142644
							],
							[
								-13.718744,
								12.247186
							],
							[
								-13.700476,
								12.586183
							],
							[
								-13.217818,
								12.575874
							],
							[
								-12.499051,
								12.33209
							],
							[
								-12.278599,
								12.35444
							],
							[
								-12.203565,
								12.465648
							],
							[
								-11.658301,
								12.386583
							],
							[
								-11.513943,
								12.442988
							],
							[
								-11.456169,
								12.076834
							],
							[
								-11.297574,
								12.077971
							],
							[
								-11.036556,
								12.211245
							],
							[
								-10.87083,
								12.177887
							],
							[
								-10.593224,
								11.923975
							],
							[
								-10.165214,
								11.844084
							],
							[
								-9.890993,
								12.060479
							],
							[
								-9.567912,
								12.194243
							],
							[
								-9.327616,
								12.334286
							],
							[
								-9.127474,
								12.30806
							],
							[
								-8.905265,
								12.088358
							],
							[
								-8.786099,
								11.812561
							],
							[
								-8.376305,
								11.393646
							],
							[
								-8.581305,
								11.136246
							],
							[
								-8.620321,
								10.810891
							],
							[
								-8.407311,
								10.909257
							],
							[
								-8.282357,
								10.792597
							],
							[
								-8.335377,
								10.494812
							],
							[
								-8.029944,
								10.206535
							],
							[
								-8.229337,
								10.12902
							],
							[
								-8.309616,
								9.789532
							],
							[
								-8.079114,
								9.376224
							],
							[
								-7.8321,
								8.575704
							],
							[
								-8.203499,
								8.455453
							],
							[
								-8.299049,
								8.316444
							],
							[
								-8.221792,
								8.123329
							],
							[
								-8.280703,
								7.68718
							],
							[
								-8.439298,
								7.686043
							]
						]
					]
				},
				"id": "GIN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Gambia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-16.841525,
								13.151394
							],
							[
								-16.713729,
								13.594959
							],
							[
								-15.624596,
								13.623587
							],
							[
								-15.39877,
								13.860369
							],
							[
								-15.081735,
								13.876492
							],
							[
								-14.687031,
								13.630357
							],
							[
								-14.376714,
								13.62568
							],
							[
								-14.046992,
								13.794068
							],
							[
								-13.844963,
								13.505042
							],
							[
								-14.277702,
								13.280585
							],
							[
								-14.712197,
								13.298207
							],
							[
								-15.141163,
								13.509512
							],
							[
								-15.511813,
								13.27857
							],
							[
								-15.691001,
								13.270353
							],
							[
								-15.931296,
								13.130284
							],
							[
								-16.841525,
								13.151394
							]
						]
					]
				},
				"id": "GMB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Guinea Bissau"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-15.130311,
								11.040412
							],
							[
								-15.66418,
								11.458474
							],
							[
								-16.085214,
								11.524594
							],
							[
								-16.314787,
								11.806515
							],
							[
								-16.308947,
								11.958702
							],
							[
								-16.613838,
								12.170911
							],
							[
								-16.677452,
								12.384852
							],
							[
								-16.147717,
								12.547762
							],
							[
								-15.816574,
								12.515567
							],
							[
								-15.548477,
								12.62817
							],
							[
								-13.700476,
								12.586183
							],
							[
								-13.718744,
								12.247186
							],
							[
								-13.828272,
								12.142644
							],
							[
								-13.743161,
								11.811269
							],
							[
								-13.9008,
								11.678719
							],
							[
								-14.121406,
								11.677117
							],
							[
								-14.382192,
								11.509272
							],
							[
								-14.685687,
								11.527824
							],
							[
								-15.130311,
								11.040412
							]
						]
					]
				},
				"id": "GNB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Equatorial Guinea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.492889,
								1.01012
							],
							[
								9.305613,
								1.160911
							],
							[
								9.649158,
								2.283866
							],
							[
								11.276449,
								2.261051
							],
							[
								11.285079,
								1.057662
							],
							[
								9.830284,
								1.067894
							],
							[
								9.492889,
								1.01012
							]
						]
					]
				},
				"id": "GNQ"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Greece"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									23.69998,
									35.705004
								],
								[
									24.246665,
									35.368022
								],
								[
									25.025015,
									35.424996
								],
								[
									25.769208,
									35.354018
								],
								[
									25.745023,
									35.179998
								],
								[
									26.290003,
									35.29999
								],
								[
									26.164998,
									35.004995
								],
								[
									24.724982,
									34.919988
								],
								[
									24.735007,
									35.084991
								],
								[
									23.514978,
									35.279992
								],
								[
									23.69998,
									35.705004
								]
							]
						],
						[
							[
								[
									26.604196,
									41.562115
								],
								[
									26.294602,
									40.936261
								],
								[
									26.056942,
									40.824123
								],
								[
									25.447677,
									40.852545
								],
								[
									24.925848,
									40.947062
								],
								[
									23.714811,
									40.687129
								],
								[
									24.407999,
									40.124993
								],
								[
									23.899968,
									39.962006
								],
								[
									23.342999,
									39.960998
								],
								[
									22.813988,
									40.476005
								],
								[
									22.626299,
									40.256561
								],
								[
									22.849748,
									39.659311
								],
								[
									23.350027,
									39.190011
								],
								[
									22.973099,
									38.970903
								],
								[
									23.530016,
									38.510001
								],
								[
									24.025025,
									38.219993
								],
								[
									24.040011,
									37.655015
								],
								[
									23.115003,
									37.920011
								],
								[
									23.409972,
									37.409991
								],
								[
									22.774972,
									37.30501
								],
								[
									23.154225,
									36.422506
								],
								[
									22.490028,
									36.41
								],
								[
									21.670026,
									36.844986
								],
								[
									21.295011,
									37.644989
								],
								[
									21.120034,
									38.310323
								],
								[
									20.730032,
									38.769985
								],
								[
									20.217712,
									39.340235
								],
								[
									20.150016,
									39.624998
								],
								[
									20.615,
									40.110007
								],
								[
									20.674997,
									40.435
								],
								[
									20.99999,
									40.580004
								],
								[
									21.02004,
									40.842727
								],
								[
									21.674161,
									40.931275
								],
								[
									22.055378,
									41.149866
								],
								[
									22.597308,
									41.130487
								],
								[
									22.76177,
									41.3048
								],
								[
									22.952377,
									41.337994
								],
								[
									23.692074,
									41.309081
								],
								[
									24.492645,
									41.583896
								],
								[
									25.197201,
									41.234486
								],
								[
									26.106138,
									41.328899
								],
								[
									26.117042,
									41.826905
								],
								[
									26.604196,
									41.562115
								]
							]
						]
					]
				},
				"id": "GRC"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Greenland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-46.76379,
								82.62796
							],
							[
								-43.40644,
								83.22516
							],
							[
								-39.89753,
								83.18018
							],
							[
								-38.62214,
								83.54905
							],
							[
								-35.08787,
								83.64513
							],
							[
								-27.10046,
								83.51966
							],
							[
								-20.84539,
								82.72669
							],
							[
								-22.69182,
								82.34165
							],
							[
								-26.51753,
								82.29765
							],
							[
								-31.9,
								82.2
							],
							[
								-31.39646,
								82.02154
							],
							[
								-27.85666,
								82.13178
							],
							[
								-24.84448,
								81.78697
							],
							[
								-22.90328,
								82.09317
							],
							[
								-22.07175,
								81.73449
							],
							[
								-23.16961,
								81.15271
							],
							[
								-20.62363,
								81.52462
							],
							[
								-15.76818,
								81.91245
							],
							[
								-12.77018,
								81.71885
							],
							[
								-12.20855,
								81.29154
							],
							[
								-16.28533,
								80.58004
							],
							[
								-16.85,
								80.35
							],
							[
								-20.04624,
								80.17708
							],
							[
								-17.73035,
								80.12912
							],
							[
								-18.9,
								79.4
							],
							[
								-19.70499,
								78.75128
							],
							[
								-19.67353,
								77.63859
							],
							[
								-18.47285,
								76.98565
							],
							[
								-20.03503,
								76.94434
							],
							[
								-21.67944,
								76.62795
							],
							[
								-19.83407,
								76.09808
							],
							[
								-19.59896,
								75.24838
							],
							[
								-20.66818,
								75.15585
							],
							[
								-19.37281,
								74.29561
							],
							[
								-21.59422,
								74.22382
							],
							[
								-20.43454,
								73.81713
							],
							[
								-20.76234,
								73.46436
							],
							[
								-22.17221,
								73.30955
							],
							[
								-23.56593,
								73.30663
							],
							[
								-22.31311,
								72.62928
							],
							[
								-22.29954,
								72.18409
							],
							[
								-24.27834,
								72.59788
							],
							[
								-24.79296,
								72.3302
							],
							[
								-23.44296,
								72.08016
							],
							[
								-22.13281,
								71.46898
							],
							[
								-21.75356,
								70.66369
							],
							[
								-23.53603,
								70.471
							],
							[
								-24.30702,
								70.85649
							],
							[
								-25.54341,
								71.43094
							],
							[
								-25.20135,
								70.75226
							],
							[
								-26.36276,
								70.22646
							],
							[
								-23.72742,
								70.18401
							],
							[
								-22.34902,
								70.12946
							],
							[
								-25.02927,
								69.2588
							],
							[
								-27.74737,
								68.47046
							],
							[
								-30.67371,
								68.12503
							],
							[
								-31.77665,
								68.12078
							],
							[
								-32.81105,
								67.73547
							],
							[
								-34.20196,
								66.67974
							],
							[
								-36.35284,
								65.9789
							],
							[
								-37.04378,
								65.93768
							],
							[
								-38.37505,
								65.69213
							],
							[
								-39.81222,
								65.45848
							],
							[
								-40.66899,
								64.83997
							],
							[
								-40.68281,
								64.13902
							],
							[
								-41.1887,
								63.48246
							],
							[
								-42.81938,
								62.68233
							],
							[
								-42.41666,
								61.90093
							],
							[
								-42.86619,
								61.07404
							],
							[
								-43.3784,
								60.09772
							],
							[
								-44.7875,
								60.03676
							],
							[
								-46.26364,
								60.85328
							],
							[
								-48.26294,
								60.85843
							],
							[
								-49.23308,
								61.40681
							],
							[
								-49.90039,
								62.38336
							],
							[
								-51.63325,
								63.62691
							],
							[
								-52.14014,
								64.27842
							],
							[
								-52.27659,
								65.1767
							],
							[
								-53.66166,
								66.09957
							],
							[
								-53.30161,
								66.8365
							],
							[
								-53.96911,
								67.18899
							],
							[
								-52.9804,
								68.35759
							],
							[
								-51.47536,
								68.72958
							],
							[
								-51.08041,
								69.14781
							],
							[
								-50.87122,
								69.9291
							],
							[
								-52.013585,
								69.574925
							],
							[
								-52.55792,
								69.42616
							],
							[
								-53.45629,
								69.283625
							],
							[
								-54.68336,
								69.61003
							],
							[
								-54.75001,
								70.28932
							],
							[
								-54.35884,
								70.821315
							],
							[
								-53.431315,
								70.835755
							],
							[
								-51.39014,
								70.56978
							],
							[
								-53.10937,
								71.20485
							],
							[
								-54.00422,
								71.54719
							],
							[
								-55,
								71.406537
							],
							[
								-55.83468,
								71.65444
							],
							[
								-54.71819,
								72.58625
							],
							[
								-55.32634,
								72.95861
							],
							[
								-56.12003,
								73.64977
							],
							[
								-57.32363,
								74.71026
							],
							[
								-58.59679,
								75.09861
							],
							[
								-58.58516,
								75.51727
							],
							[
								-61.26861,
								76.10238
							],
							[
								-63.39165,
								76.1752
							],
							[
								-66.06427,
								76.13486
							],
							[
								-68.50438,
								76.06141
							],
							[
								-69.66485,
								76.37975
							],
							[
								-71.40257,
								77.00857
							],
							[
								-68.77671,
								77.32312
							],
							[
								-66.76397,
								77.37595
							],
							[
								-71.04293,
								77.63595
							],
							[
								-73.297,
								78.04419
							],
							[
								-73.15938,
								78.43271
							],
							[
								-69.37345,
								78.91388
							],
							[
								-65.7107,
								79.39436
							],
							[
								-65.3239,
								79.75814
							],
							[
								-68.02298,
								80.11721
							],
							[
								-67.15129,
								80.51582
							],
							[
								-63.68925,
								81.21396
							],
							[
								-62.23444,
								81.3211
							],
							[
								-62.65116,
								81.77042
							],
							[
								-60.28249,
								82.03363
							],
							[
								-57.20744,
								82.19074
							],
							[
								-54.13442,
								82.19962
							],
							[
								-53.04328,
								81.88833
							],
							[
								-50.39061,
								82.43883
							],
							[
								-48.00386,
								82.06481
							],
							[
								-46.59984,
								81.985945
							],
							[
								-44.523,
								81.6607
							],
							[
								-46.9007,
								82.19979
							],
							[
								-46.76379,
								82.62796
							]
						]
					]
				},
				"id": "GRL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Guatemala"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-90.095555,
								13.735338
							],
							[
								-90.608624,
								13.909771
							],
							[
								-91.23241,
								13.927832
							],
							[
								-91.689747,
								14.126218
							],
							[
								-92.22775,
								14.538829
							],
							[
								-92.20323,
								14.830103
							],
							[
								-92.087216,
								15.064585
							],
							[
								-92.229249,
								15.251447
							],
							[
								-91.74796,
								16.066565
							],
							[
								-90.464473,
								16.069562
							],
							[
								-90.438867,
								16.41011
							],
							[
								-90.600847,
								16.470778
							],
							[
								-90.711822,
								16.687483
							],
							[
								-91.08167,
								16.918477
							],
							[
								-91.453921,
								17.252177
							],
							[
								-91.002269,
								17.254658
							],
							[
								-91.00152,
								17.817595
							],
							[
								-90.067934,
								17.819326
							],
							[
								-89.14308,
								17.808319
							],
							[
								-89.150806,
								17.015577
							],
							[
								-89.229122,
								15.886938
							],
							[
								-88.930613,
								15.887273
							],
							[
								-88.604586,
								15.70638
							],
							[
								-88.518364,
								15.855389
							],
							[
								-88.225023,
								15.727722
							],
							[
								-88.68068,
								15.346247
							],
							[
								-89.154811,
								15.066419
							],
							[
								-89.22522,
								14.874286
							],
							[
								-89.145535,
								14.678019
							],
							[
								-89.353326,
								14.424133
							],
							[
								-89.587343,
								14.362586
							],
							[
								-89.534219,
								14.244816
							],
							[
								-89.721934,
								14.134228
							],
							[
								-90.064678,
								13.88197
							],
							[
								-90.095555,
								13.735338
							]
						]
					]
				},
				"id": "GTM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Guyana"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-59.758285,
								8.367035
							],
							[
								-59.101684,
								7.999202
							],
							[
								-58.482962,
								7.347691
							],
							[
								-58.454876,
								6.832787
							],
							[
								-58.078103,
								6.809094
							],
							[
								-57.542219,
								6.321268
							],
							[
								-57.147436,
								5.97315
							],
							[
								-57.307246,
								5.073567
							],
							[
								-57.914289,
								4.812626
							],
							[
								-57.86021,
								4.576801
							],
							[
								-58.044694,
								4.060864
							],
							[
								-57.601569,
								3.334655
							],
							[
								-57.281433,
								3.333492
							],
							[
								-57.150098,
								2.768927
							],
							[
								-56.539386,
								1.899523
							],
							[
								-56.782704,
								1.863711
							],
							[
								-57.335823,
								1.948538
							],
							[
								-57.660971,
								1.682585
							],
							[
								-58.11345,
								1.507195
							],
							[
								-58.429477,
								1.463942
							],
							[
								-58.540013,
								1.268088
							],
							[
								-59.030862,
								1.317698
							],
							[
								-59.646044,
								1.786894
							],
							[
								-59.718546,
								2.24963
							],
							[
								-59.974525,
								2.755233
							],
							[
								-59.815413,
								3.606499
							],
							[
								-59.53804,
								3.958803
							],
							[
								-59.767406,
								4.423503
							],
							[
								-60.111002,
								4.574967
							],
							[
								-59.980959,
								5.014061
							],
							[
								-60.213683,
								5.244486
							],
							[
								-60.733574,
								5.200277
							],
							[
								-61.410303,
								5.959068
							],
							[
								-61.139415,
								6.234297
							],
							[
								-61.159336,
								6.696077
							],
							[
								-60.543999,
								6.856584
							],
							[
								-60.295668,
								7.043911
							],
							[
								-60.637973,
								7.415
							],
							[
								-60.550588,
								7.779603
							],
							[
								-59.758285,
								8.367035
							]
						]
					]
				},
				"id": "GUY"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Honduras"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-87.316654,
								12.984686
							],
							[
								-87.489409,
								13.297535
							],
							[
								-87.793111,
								13.38448
							],
							[
								-87.723503,
								13.78505
							],
							[
								-87.859515,
								13.893312
							],
							[
								-88.065343,
								13.964626
							],
							[
								-88.503998,
								13.845486
							],
							[
								-88.541231,
								13.980155
							],
							[
								-88.843073,
								14.140507
							],
							[
								-89.058512,
								14.340029
							],
							[
								-89.353326,
								14.424133
							],
							[
								-89.145535,
								14.678019
							],
							[
								-89.22522,
								14.874286
							],
							[
								-89.154811,
								15.066419
							],
							[
								-88.68068,
								15.346247
							],
							[
								-88.225023,
								15.727722
							],
							[
								-88.121153,
								15.688655
							],
							[
								-87.901813,
								15.864458
							],
							[
								-87.61568,
								15.878799
							],
							[
								-87.522921,
								15.797279
							],
							[
								-87.367762,
								15.84694
							],
							[
								-86.903191,
								15.756713
							],
							[
								-86.440946,
								15.782835
							],
							[
								-86.119234,
								15.893449
							],
							[
								-86.001954,
								16.005406
							],
							[
								-85.683317,
								15.953652
							],
							[
								-85.444004,
								15.885749
							],
							[
								-85.182444,
								15.909158
							],
							[
								-84.983722,
								15.995923
							],
							[
								-84.52698,
								15.857224
							],
							[
								-84.368256,
								15.835158
							],
							[
								-84.063055,
								15.648244
							],
							[
								-83.773977,
								15.424072
							],
							[
								-83.410381,
								15.270903
							],
							[
								-83.147219,
								14.995829
							],
							[
								-83.489989,
								15.016267
							],
							[
								-83.628585,
								14.880074
							],
							[
								-83.975721,
								14.749436
							],
							[
								-84.228342,
								14.748764
							],
							[
								-84.449336,
								14.621614
							],
							[
								-84.649582,
								14.666805
							],
							[
								-84.820037,
								14.819587
							],
							[
								-84.924501,
								14.790493
							],
							[
								-85.052787,
								14.551541
							],
							[
								-85.148751,
								14.560197
							],
							[
								-85.165365,
								14.35437
							],
							[
								-85.514413,
								14.079012
							],
							[
								-85.698665,
								13.960078
							],
							[
								-85.801295,
								13.836055
							],
							[
								-86.096264,
								14.038187
							],
							[
								-86.312142,
								13.771356
							],
							[
								-86.520708,
								13.778487
							],
							[
								-86.755087,
								13.754845
							],
							[
								-86.733822,
								13.263093
							],
							[
								-86.880557,
								13.254204
							],
							[
								-87.005769,
								13.025794
							],
							[
								-87.316654,
								12.984686
							]
						]
					]
				},
				"id": "HND"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Croatia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								18.829838,
								45.908878
							],
							[
								19.072769,
								45.521511
							],
							[
								19.390476,
								45.236516
							],
							[
								19.005486,
								44.860234
							],
							[
								18.553214,
								45.08159
							],
							[
								17.861783,
								45.06774
							],
							[
								17.002146,
								45.233777
							],
							[
								16.534939,
								45.211608
							],
							[
								16.318157,
								45.004127
							],
							[
								15.959367,
								45.233777
							],
							[
								15.750026,
								44.818712
							],
							[
								16.23966,
								44.351143
							],
							[
								16.456443,
								44.04124
							],
							[
								16.916156,
								43.667722
							],
							[
								17.297373,
								43.446341
							],
							[
								17.674922,
								43.028563
							],
							[
								18.56,
								42.65
							],
							[
								18.450016,
								42.479991
							],
							[
								17.50997,
								42.849995
							],
							[
								16.930006,
								43.209998
							],
							[
								16.015385,
								43.507215
							],
							[
								15.174454,
								44.243191
							],
							[
								15.37625,
								44.317915
							],
							[
								14.920309,
								44.738484
							],
							[
								14.901602,
								45.07606
							],
							[
								14.258748,
								45.233777
							],
							[
								13.952255,
								44.802124
							],
							[
								13.656976,
								45.136935
							],
							[
								13.679403,
								45.484149
							],
							[
								13.71506,
								45.500324
							],
							[
								14.411968,
								45.466166
							],
							[
								14.595109,
								45.634941
							],
							[
								14.935244,
								45.471695
							],
							[
								15.327675,
								45.452316
							],
							[
								15.323954,
								45.731783
							],
							[
								15.67153,
								45.834154
							],
							[
								15.768733,
								46.238108
							],
							[
								16.564808,
								46.503751
							],
							[
								16.882515,
								46.380632
							],
							[
								17.630066,
								45.951769
							],
							[
								18.456062,
								45.759481
							],
							[
								18.829838,
								45.908878
							]
						]
					]
				},
				"id": "HRV"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Haiti"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-73.189791,
								19.915684
							],
							[
								-72.579673,
								19.871501
							],
							[
								-71.712361,
								19.714456
							],
							[
								-71.624873,
								19.169838
							],
							[
								-71.701303,
								18.785417
							],
							[
								-71.945112,
								18.6169
							],
							[
								-71.687738,
								18.31666
							],
							[
								-71.708305,
								18.044997
							],
							[
								-72.372476,
								18.214961
							],
							[
								-72.844411,
								18.145611
							],
							[
								-73.454555,
								18.217906
							],
							[
								-73.922433,
								18.030993
							],
							[
								-74.458034,
								18.34255
							],
							[
								-74.369925,
								18.664908
							],
							[
								-73.449542,
								18.526053
							],
							[
								-72.694937,
								18.445799
							],
							[
								-72.334882,
								18.668422
							],
							[
								-72.79165,
								19.101625
							],
							[
								-72.784105,
								19.483591
							],
							[
								-73.415022,
								19.639551
							],
							[
								-73.189791,
								19.915684
							]
						]
					]
				},
				"id": "HTI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Hungary"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.202298,
								46.852386
							],
							[
								16.534268,
								47.496171
							],
							[
								16.340584,
								47.712902
							],
							[
								16.903754,
								47.714866
							],
							[
								16.979667,
								48.123497
							],
							[
								17.488473,
								47.867466
							],
							[
								17.857133,
								47.758429
							],
							[
								18.696513,
								47.880954
							],
							[
								18.777025,
								48.081768
							],
							[
								19.174365,
								48.111379
							],
							[
								19.661364,
								48.266615
							],
							[
								19.769471,
								48.202691
							],
							[
								20.239054,
								48.327567
							],
							[
								20.473562,
								48.56285
							],
							[
								20.801294,
								48.623854
							],
							[
								21.872236,
								48.319971
							],
							[
								22.085608,
								48.422264
							],
							[
								22.64082,
								48.15024
							],
							[
								22.710531,
								47.882194
							],
							[
								22.099768,
								47.672439
							],
							[
								21.626515,
								46.994238
							],
							[
								21.021952,
								46.316088
							],
							[
								20.220192,
								46.127469
							],
							[
								19.596045,
								46.17173
							],
							[
								18.829838,
								45.908878
							],
							[
								18.456062,
								45.759481
							],
							[
								17.630066,
								45.951769
							],
							[
								16.882515,
								46.380632
							],
							[
								16.564808,
								46.503751
							],
							[
								16.370505,
								46.841327
							],
							[
								16.202298,
								46.852386
							]
						]
					]
				},
				"id": "HUN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Indonesia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									120.715609,
									-10.239581
								],
								[
									120.295014,
									-10.25865
								],
								[
									118.967808,
									-9.557969
								],
								[
									119.90031,
									-9.36134
								],
								[
									120.425756,
									-9.665921
								],
								[
									120.775502,
									-9.969675
								],
								[
									120.715609,
									-10.239581
								]
							]
						],
						[
							[
								[
									124.43595,
									-10.140001
								],
								[
									123.579982,
									-10.359987
								],
								[
									123.459989,
									-10.239995
								],
								[
									123.550009,
									-9.900016
								],
								[
									123.980009,
									-9.290027
								],
								[
									124.968682,
									-8.89279
								],
								[
									125.07002,
									-9.089987
								],
								[
									125.08852,
									-9.393173
								],
								[
									124.43595,
									-10.140001
								]
							]
						],
						[
							[
								[
									117.900018,
									-8.095681
								],
								[
									118.260616,
									-8.362383
								],
								[
									118.87846,
									-8.280683
								],
								[
									119.126507,
									-8.705825
								],
								[
									117.970402,
									-8.906639
								],
								[
									117.277731,
									-9.040895
								],
								[
									116.740141,
									-9.032937
								],
								[
									117.083737,
									-8.457158
								],
								[
									117.632024,
									-8.449303
								],
								[
									117.900018,
									-8.095681
								]
							]
						],
						[
							[
								[
									122.903537,
									-8.094234
								],
								[
									122.756983,
									-8.649808
								],
								[
									121.254491,
									-8.933666
								],
								[
									119.924391,
									-8.810418
								],
								[
									119.920929,
									-8.444859
								],
								[
									120.715092,
									-8.236965
								],
								[
									121.341669,
									-8.53674
								],
								[
									122.007365,
									-8.46062
								],
								[
									122.903537,
									-8.094234
								]
							]
						],
						[
							[
								[
									108.623479,
									-6.777674
								],
								[
									110.539227,
									-6.877358
								],
								[
									110.759576,
									-6.465186
								],
								[
									112.614811,
									-6.946036
								],
								[
									112.978768,
									-7.594213
								],
								[
									114.478935,
									-7.776528
								],
								[
									115.705527,
									-8.370807
								],
								[
									114.564511,
									-8.751817
								],
								[
									113.464734,
									-8.348947
								],
								[
									112.559672,
									-8.376181
								],
								[
									111.522061,
									-8.302129
								],
								[
									110.58615,
									-8.122605
								],
								[
									109.427667,
									-7.740664
								],
								[
									108.693655,
									-7.6416
								],
								[
									108.277763,
									-7.766657
								],
								[
									106.454102,
									-7.3549
								],
								[
									106.280624,
									-6.9249
								],
								[
									105.365486,
									-6.851416
								],
								[
									106.051646,
									-5.895919
								],
								[
									107.265009,
									-5.954985
								],
								[
									108.072091,
									-6.345762
								],
								[
									108.486846,
									-6.421985
								],
								[
									108.623479,
									-6.777674
								]
							]
						],
						[
							[
								[
									134.724624,
									-6.214401
								],
								[
									134.210134,
									-6.895238
								],
								[
									134.112776,
									-6.142467
								],
								[
									134.290336,
									-5.783058
								],
								[
									134.499625,
									-5.445042
								],
								[
									134.727002,
									-5.737582
								],
								[
									134.724624,
									-6.214401
								]
							]
						],
						[
							[
								[
									127.249215,
									-3.459065
								],
								[
									126.874923,
									-3.790983
								],
								[
									126.183802,
									-3.607376
								],
								[
									125.989034,
									-3.177273
								],
								[
									127.000651,
									-3.129318
								],
								[
									127.249215,
									-3.459065
								]
							]
						],
						[
							[
								[
									130.471344,
									-3.093764
								],
								[
									130.834836,
									-3.858472
								],
								[
									129.990547,
									-3.446301
								],
								[
									129.155249,
									-3.362637
								],
								[
									128.590684,
									-3.428679
								],
								[
									127.898891,
									-3.393436
								],
								[
									128.135879,
									-2.84365
								],
								[
									129.370998,
									-2.802154
								],
								[
									130.471344,
									-3.093764
								]
							]
						],
						[
							[
								[
									134.143368,
									-1.151867
								],
								[
									134.422627,
									-2.769185
								],
								[
									135.457603,
									-3.367753
								],
								[
									136.293314,
									-2.307042
								],
								[
									137.440738,
									-1.703513
								],
								[
									138.329727,
									-1.702686
								],
								[
									139.184921,
									-2.051296
								],
								[
									139.926684,
									-2.409052
								],
								[
									141.00021,
									-2.600151
								],
								[
									141.017057,
									-5.859022
								],
								[
									141.033852,
									-9.117893
								],
								[
									140.143415,
									-8.297168
								],
								[
									139.127767,
									-8.096043
								],
								[
									138.881477,
									-8.380935
								],
								[
									137.614474,
									-8.411683
								],
								[
									138.039099,
									-7.597882
								],
								[
									138.668621,
									-7.320225
								],
								[
									138.407914,
									-6.232849
								],
								[
									137.92784,
									-5.393366
								],
								[
									135.98925,
									-4.546544
								],
								[
									135.164598,
									-4.462931
								],
								[
									133.66288,
									-3.538853
								],
								[
									133.367705,
									-4.024819
								],
								[
									132.983956,
									-4.112979
								],
								[
									132.756941,
									-3.746283
								],
								[
									132.753789,
									-3.311787
								],
								[
									131.989804,
									-2.820551
								],
								[
									133.066845,
									-2.460418
								],
								[
									133.780031,
									-2.479848
								],
								[
									133.696212,
									-2.214542
								],
								[
									132.232373,
									-2.212526
								],
								[
									131.836222,
									-1.617162
								],
								[
									130.94284,
									-1.432522
								],
								[
									130.519558,
									-0.93772
								],
								[
									131.867538,
									-0.695461
								],
								[
									132.380116,
									-0.369538
								],
								[
									133.985548,
									-0.78021
								],
								[
									134.143368,
									-1.151867
								]
							]
						],
						[
							[
								[
									125.240501,
									1.419836
								],
								[
									124.437035,
									0.427881
								],
								[
									123.685505,
									0.235593
								],
								[
									122.723083,
									0.431137
								],
								[
									121.056725,
									0.381217
								],
								[
									120.183083,
									0.237247
								],
								[
									120.04087,
									-0.519658
								],
								[
									120.935905,
									-1.408906
								],
								[
									121.475821,
									-0.955962
								],
								[
									123.340565,
									-0.615673
								],
								[
									123.258399,
									-1.076213
								],
								[
									122.822715,
									-0.930951
								],
								[
									122.38853,
									-1.516858
								],
								[
									121.508274,
									-1.904483
								],
								[
									122.454572,
									-3.186058
								],
								[
									122.271896,
									-3.5295
								],
								[
									123.170963,
									-4.683693
								],
								[
									123.162333,
									-5.340604
								],
								[
									122.628515,
									-5.634591
								],
								[
									122.236394,
									-5.282933
								],
								[
									122.719569,
									-4.464172
								],
								[
									121.738234,
									-4.851331
								],
								[
									121.489463,
									-4.574553
								],
								[
									121.619171,
									-4.188478
								],
								[
									120.898182,
									-3.602105
								],
								[
									120.972389,
									-2.627643
								],
								[
									120.305453,
									-2.931604
								],
								[
									120.390047,
									-4.097579
								],
								[
									120.430717,
									-5.528241
								],
								[
									119.796543,
									-5.6734
								],
								[
									119.366906,
									-5.379878
								],
								[
									119.653606,
									-4.459417
								],
								[
									119.498835,
									-3.494412
								],
								[
									119.078344,
									-3.487022
								],
								[
									118.767769,
									-2.801999
								],
								[
									119.180974,
									-2.147104
								],
								[
									119.323394,
									-1.353147
								],
								[
									119.825999,
									0.154254
								],
								[
									120.035702,
									0.566477
								],
								[
									120.885779,
									1.309223
								],
								[
									121.666817,
									1.013944
								],
								[
									122.927567,
									0.875192
								],
								[
									124.077522,
									0.917102
								],
								[
									125.065989,
									1.643259
								],
								[
									125.240501,
									1.419836
								]
							]
						],
						[
							[
								[
									128.688249,
									1.132386
								],
								[
									128.635952,
									0.258486
								],
								[
									128.12017,
									0.356413
								],
								[
									127.968034,
									-0.252077
								],
								[
									128.379999,
									-0.780004
								],
								[
									128.100016,
									-0.899996
								],
								[
									127.696475,
									-0.266598
								],
								[
									127.39949,
									1.011722
								],
								[
									127.600512,
									1.810691
								],
								[
									127.932378,
									2.174596
								],
								[
									128.004156,
									1.628531
								],
								[
									128.594559,
									1.540811
								],
								[
									128.688249,
									1.132386
								]
							]
						],
						[
							[
								[
									117.875627,
									1.827641
								],
								[
									118.996747,
									0.902219
								],
								[
									117.811858,
									0.784242
								],
								[
									117.478339,
									0.102475
								],
								[
									117.521644,
									-0.803723
								],
								[
									116.560048,
									-1.487661
								],
								[
									116.533797,
									-2.483517
								],
								[
									116.148084,
									-4.012726
								],
								[
									116.000858,
									-3.657037
								],
								[
									114.864803,
									-4.106984
								],
								[
									114.468652,
									-3.495704
								],
								[
									113.755672,
									-3.43917
								],
								[
									113.256994,
									-3.118776
								],
								[
									112.068126,
									-3.478392
								],
								[
									111.703291,
									-2.994442
								],
								[
									111.04824,
									-3.049426
								],
								[
									110.223846,
									-2.934032
								],
								[
									110.070936,
									-1.592874
								],
								[
									109.571948,
									-1.314907
								],
								[
									109.091874,
									-0.459507
								],
								[
									108.952658,
									0.415375
								],
								[
									109.069136,
									1.341934
								],
								[
									109.66326,
									2.006467
								],
								[
									109.830227,
									1.338136
								],
								[
									110.514061,
									0.773131
								],
								[
									111.159138,
									0.976478
								],
								[
									111.797548,
									0.904441
								],
								[
									112.380252,
									1.410121
								],
								[
									112.859809,
									1.49779
								],
								[
									113.80585,
									1.217549
								],
								[
									114.621355,
									1.430688
								],
								[
									115.134037,
									2.821482
								],
								[
									115.519078,
									3.169238
								],
								[
									115.865517,
									4.306559
								],
								[
									117.015214,
									4.306094
								],
								[
									117.882035,
									4.137551
								],
								[
									117.313232,
									3.234428
								],
								[
									118.04833,
									2.28769
								],
								[
									117.875627,
									1.827641
								]
							]
						],
						[
							[
								[
									105.817655,
									-5.852356
								],
								[
									104.710384,
									-5.873285
								],
								[
									103.868213,
									-5.037315
								],
								[
									102.584261,
									-4.220259
								],
								[
									102.156173,
									-3.614146
								],
								[
									101.399113,
									-2.799777
								],
								[
									100.902503,
									-2.050262
								],
								[
									100.141981,
									-0.650348
								],
								[
									99.26374,
									0.183142
								],
								[
									98.970011,
									1.042882
								],
								[
									98.601351,
									1.823507
								],
								[
									97.699598,
									2.453184
								],
								[
									97.176942,
									3.308791
								],
								[
									96.424017,
									3.86886
								],
								[
									95.380876,
									4.970782
								],
								[
									95.293026,
									5.479821
								],
								[
									95.936863,
									5.439513
								],
								[
									97.484882,
									5.246321
								],
								[
									98.369169,
									4.26837
								],
								[
									99.142559,
									3.59035
								],
								[
									99.693998,
									3.174329
								],
								[
									100.641434,
									2.099381
								],
								[
									101.658012,
									2.083697
								],
								[
									102.498271,
									1.3987
								],
								[
									103.07684,
									0.561361
								],
								[
									103.838396,
									0.104542
								],
								[
									103.437645,
									-0.711946
								],
								[
									104.010789,
									-1.059212
								],
								[
									104.369991,
									-1.084843
								],
								[
									104.53949,
									-1.782372
								],
								[
									104.887893,
									-2.340425
								],
								[
									105.622111,
									-2.428844
								],
								[
									106.108593,
									-3.061777
								],
								[
									105.857446,
									-4.305525
								],
								[
									105.817655,
									-5.852356
								]
							]
						]
					]
				},
				"id": "IDN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "India"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								77.837451,
								35.49401
							],
							[
								78.912269,
								34.321936
							],
							[
								78.811086,
								33.506198
							],
							[
								79.208892,
								32.994395
							],
							[
								79.176129,
								32.48378
							],
							[
								78.458446,
								32.618164
							],
							[
								78.738894,
								31.515906
							],
							[
								79.721367,
								30.882715
							],
							[
								81.111256,
								30.183481
							],
							[
								80.476721,
								29.729865
							],
							[
								80.088425,
								28.79447
							],
							[
								81.057203,
								28.416095
							],
							[
								81.999987,
								27.925479
							],
							[
								83.304249,
								27.364506
							],
							[
								84.675018,
								27.234901
							],
							[
								85.251779,
								26.726198
							],
							[
								86.024393,
								26.630985
							],
							[
								87.227472,
								26.397898
							],
							[
								88.060238,
								26.414615
							],
							[
								88.174804,
								26.810405
							],
							[
								88.043133,
								27.445819
							],
							[
								88.120441,
								27.876542
							],
							[
								88.730326,
								28.086865
							],
							[
								88.814248,
								27.299316
							],
							[
								88.835643,
								27.098966
							],
							[
								89.744528,
								26.719403
							],
							[
								90.373275,
								26.875724
							],
							[
								91.217513,
								26.808648
							],
							[
								92.033484,
								26.83831
							],
							[
								92.103712,
								27.452614
							],
							[
								91.696657,
								27.771742
							],
							[
								92.503119,
								27.896876
							],
							[
								93.413348,
								28.640629
							],
							[
								94.56599,
								29.277438
							],
							[
								95.404802,
								29.031717
							],
							[
								96.117679,
								29.452802
							],
							[
								96.586591,
								28.83098
							],
							[
								96.248833,
								28.411031
							],
							[
								97.327114,
								28.261583
							],
							[
								97.402561,
								27.882536
							],
							[
								97.051989,
								27.699059
							],
							[
								97.133999,
								27.083774
							],
							[
								96.419366,
								27.264589
							],
							[
								95.124768,
								26.573572
							],
							[
								95.155153,
								26.001307
							],
							[
								94.603249,
								25.162495
							],
							[
								94.552658,
								24.675238
							],
							[
								94.106742,
								23.850741
							],
							[
								93.325188,
								24.078556
							],
							[
								93.286327,
								23.043658
							],
							[
								93.060294,
								22.703111
							],
							[
								93.166128,
								22.27846
							],
							[
								92.672721,
								22.041239
							],
							[
								92.146035,
								23.627499
							],
							[
								91.869928,
								23.624346
							],
							[
								91.706475,
								22.985264
							],
							[
								91.158963,
								23.503527
							],
							[
								91.46773,
								24.072639
							],
							[
								91.915093,
								24.130414
							],
							[
								92.376202,
								24.976693
							],
							[
								91.799596,
								25.147432
							],
							[
								90.872211,
								25.132601
							],
							[
								89.920693,
								25.26975
							],
							[
								89.832481,
								25.965082
							],
							[
								89.355094,
								26.014407
							],
							[
								88.563049,
								26.446526
							],
							[
								88.209789,
								25.768066
							],
							[
								88.931554,
								25.238692
							],
							[
								88.306373,
								24.866079
							],
							[
								88.084422,
								24.501657
							],
							[
								88.69994,
								24.233715
							],
							[
								88.52977,
								23.631142
							],
							[
								88.876312,
								22.879146
							],
							[
								89.031961,
								22.055708
							],
							[
								88.888766,
								21.690588
							],
							[
								88.208497,
								21.703172
							],
							[
								86.975704,
								21.495562
							],
							[
								87.033169,
								20.743308
							],
							[
								86.499351,
								20.151638
							],
							[
								85.060266,
								19.478579
							],
							[
								83.941006,
								18.30201
							],
							[
								83.189217,
								17.671221
							],
							[
								82.192792,
								17.016636
							],
							[
								82.191242,
								16.556664
							],
							[
								81.692719,
								16.310219
							],
							[
								80.791999,
								15.951972
							],
							[
								80.324896,
								15.899185
							],
							[
								80.025069,
								15.136415
							],
							[
								80.233274,
								13.835771
							],
							[
								80.286294,
								13.006261
							],
							[
								79.862547,
								12.056215
							],
							[
								79.857999,
								10.357275
							],
							[
								79.340512,
								10.308854
							],
							[
								78.885345,
								9.546136
							],
							[
								79.18972,
								9.216544
							],
							[
								78.277941,
								8.933047
							],
							[
								77.941165,
								8.252959
							],
							[
								77.539898,
								7.965535
							],
							[
								76.592979,
								8.899276
							],
							[
								76.130061,
								10.29963
							],
							[
								75.746467,
								11.308251
							],
							[
								75.396101,
								11.781245
							],
							[
								74.864816,
								12.741936
							],
							[
								74.616717,
								13.992583
							],
							[
								74.443859,
								14.617222
							],
							[
								73.534199,
								15.990652
							],
							[
								73.119909,
								17.92857
							],
							[
								72.820909,
								19.208234
							],
							[
								72.824475,
								20.419503
							],
							[
								72.630533,
								21.356009
							],
							[
								71.175273,
								20.757441
							],
							[
								70.470459,
								20.877331
							],
							[
								69.16413,
								22.089298
							],
							[
								69.644928,
								22.450775
							],
							[
								69.349597,
								22.84318
							],
							[
								68.176645,
								23.691965
							],
							[
								68.842599,
								24.359134
							],
							[
								71.04324,
								24.356524
							],
							[
								70.844699,
								25.215102
							],
							[
								70.282873,
								25.722229
							],
							[
								70.168927,
								26.491872
							],
							[
								69.514393,
								26.940966
							],
							[
								70.616496,
								27.989196
							],
							[
								71.777666,
								27.91318
							],
							[
								72.823752,
								28.961592
							],
							[
								73.450638,
								29.976413
							],
							[
								74.42138,
								30.979815
							],
							[
								74.405929,
								31.692639
							],
							[
								75.258642,
								32.271105
							],
							[
								74.451559,
								32.7649
							],
							[
								74.104294,
								33.441473
							],
							[
								73.749948,
								34.317699
							],
							[
								74.240203,
								34.748887
							],
							[
								75.757061,
								34.504923
							],
							[
								76.871722,
								34.653544
							],
							[
								77.837451,
								35.49401
							]
						]
					]
				},
				"id": "IND"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Ireland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-6.197885,
								53.867565
							],
							[
								-6.032985,
								53.153164
							],
							[
								-6.788857,
								52.260118
							],
							[
								-8.561617,
								51.669301
							],
							[
								-9.977086,
								51.820455
							],
							[
								-9.166283,
								52.864629
							],
							[
								-9.688525,
								53.881363
							],
							[
								-8.327987,
								54.664519
							],
							[
								-7.572168,
								55.131622
							],
							[
								-7.366031,
								54.595841
							],
							[
								-7.572168,
								54.059956
							],
							[
								-6.95373,
								54.073702
							],
							[
								-6.197885,
								53.867565
							]
						]
					]
				},
				"id": "IRL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Iran"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								53.921598,
								37.198918
							],
							[
								54.800304,
								37.392421
							],
							[
								55.511578,
								37.964117
							],
							[
								56.180375,
								37.935127
							],
							[
								56.619366,
								38.121394
							],
							[
								57.330434,
								38.029229
							],
							[
								58.436154,
								37.522309
							],
							[
								59.234762,
								37.412988
							],
							[
								60.377638,
								36.527383
							],
							[
								61.123071,
								36.491597
							],
							[
								61.210817,
								35.650072
							],
							[
								60.803193,
								34.404102
							],
							[
								60.52843,
								33.676446
							],
							[
								60.9637,
								33.528832
							],
							[
								60.536078,
								32.981269
							],
							[
								60.863655,
								32.18292
							],
							[
								60.941945,
								31.548075
							],
							[
								61.699314,
								31.379506
							],
							[
								61.781222,
								30.73585
							],
							[
								60.874248,
								29.829239
							],
							[
								61.369309,
								29.303276
							],
							[
								61.771868,
								28.699334
							],
							[
								62.72783,
								28.259645
							],
							[
								62.755426,
								27.378923
							],
							[
								63.233898,
								27.217047
							],
							[
								63.316632,
								26.756532
							],
							[
								61.874187,
								26.239975
							],
							[
								61.497363,
								25.078237
							],
							[
								59.616134,
								25.380157
							],
							[
								58.525761,
								25.609962
							],
							[
								57.397251,
								25.739902
							],
							[
								56.970766,
								26.966106
							],
							[
								56.492139,
								27.143305
							],
							[
								55.72371,
								26.964633
							],
							[
								54.71509,
								26.480658
							],
							[
								53.493097,
								26.812369
							],
							[
								52.483598,
								27.580849
							],
							[
								51.520763,
								27.86569
							],
							[
								50.852948,
								28.814521
							],
							[
								50.115009,
								30.147773
							],
							[
								49.57685,
								29.985715
							],
							[
								48.941333,
								30.31709
							],
							[
								48.567971,
								29.926778
							],
							[
								48.014568,
								30.452457
							],
							[
								48.004698,
								30.985137
							],
							[
								47.685286,
								30.984853
							],
							[
								47.849204,
								31.709176
							],
							[
								47.334661,
								32.469155
							],
							[
								46.109362,
								33.017287
							],
							[
								45.416691,
								33.967798
							],
							[
								45.64846,
								34.748138
							],
							[
								46.151788,
								35.093259
							],
							[
								46.07634,
								35.677383
							],
							[
								45.420618,
								35.977546
							],
							[
								44.77267,
								37.17045
							],
							[
								44.225756,
								37.971584
							],
							[
								44.421403,
								38.281281
							],
							[
								44.109225,
								39.428136
							],
							[
								44.79399,
								39.713003
							],
							[
								44.952688,
								39.335765
							],
							[
								45.457722,
								38.874139
							],
							[
								46.143623,
								38.741201
							],
							[
								46.50572,
								38.770605
							],
							[
								47.685079,
								39.508364
							],
							[
								48.060095,
								39.582235
							],
							[
								48.355529,
								39.288765
							],
							[
								48.010744,
								38.794015
							],
							[
								48.634375,
								38.270378
							],
							[
								48.883249,
								38.320245
							],
							[
								49.199612,
								37.582874
							],
							[
								50.147771,
								37.374567
							],
							[
								50.842354,
								36.872814
							],
							[
								52.264025,
								36.700422
							],
							[
								53.82579,
								36.965031
							],
							[
								53.921598,
								37.198918
							]
						]
					]
				},
				"id": "IRN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Iraq"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								45.420618,
								35.977546
							],
							[
								46.07634,
								35.677383
							],
							[
								46.151788,
								35.093259
							],
							[
								45.64846,
								34.748138
							],
							[
								45.416691,
								33.967798
							],
							[
								46.109362,
								33.017287
							],
							[
								47.334661,
								32.469155
							],
							[
								47.849204,
								31.709176
							],
							[
								47.685286,
								30.984853
							],
							[
								48.004698,
								30.985137
							],
							[
								48.014568,
								30.452457
							],
							[
								48.567971,
								29.926778
							],
							[
								47.974519,
								29.975819
							],
							[
								47.302622,
								30.05907
							],
							[
								46.568713,
								29.099025
							],
							[
								44.709499,
								29.178891
							],
							[
								41.889981,
								31.190009
							],
							[
								40.399994,
								31.889992
							],
							[
								39.195468,
								32.161009
							],
							[
								38.792341,
								33.378686
							],
							[
								41.006159,
								34.419372
							],
							[
								41.383965,
								35.628317
							],
							[
								41.289707,
								36.358815
							],
							[
								41.837064,
								36.605854
							],
							[
								42.349591,
								37.229873
							],
							[
								42.779126,
								37.385264
							],
							[
								43.942259,
								37.256228
							],
							[
								44.293452,
								37.001514
							],
							[
								44.772699,
								37.170445
							],
							[
								45.420618,
								35.977546
							]
						]
					]
				},
				"id": "IRQ"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Iceland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-14.508695,
								66.455892
							],
							[
								-14.739637,
								65.808748
							],
							[
								-13.609732,
								65.126671
							],
							[
								-14.909834,
								64.364082
							],
							[
								-17.794438,
								63.678749
							],
							[
								-18.656246,
								63.496383
							],
							[
								-19.972755,
								63.643635
							],
							[
								-22.762972,
								63.960179
							],
							[
								-21.778484,
								64.402116
							],
							[
								-23.955044,
								64.89113
							],
							[
								-22.184403,
								65.084968
							],
							[
								-22.227423,
								65.378594
							],
							[
								-24.326184,
								65.611189
							],
							[
								-23.650515,
								66.262519
							],
							[
								-22.134922,
								66.410469
							],
							[
								-20.576284,
								65.732112
							],
							[
								-19.056842,
								66.276601
							],
							[
								-17.798624,
								65.993853
							],
							[
								-16.167819,
								66.526792
							],
							[
								-14.508695,
								66.455892
							]
						]
					]
				},
				"id": "ISL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Israel"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.719918,
								32.709192
							],
							[
								35.545665,
								32.393992
							],
							[
								35.18393,
								32.532511
							],
							[
								34.974641,
								31.866582
							],
							[
								35.225892,
								31.754341
							],
							[
								34.970507,
								31.616778
							],
							[
								34.927408,
								31.353435
							],
							[
								35.397561,
								31.489086
							],
							[
								35.420918,
								31.100066
							],
							[
								34.922603,
								29.501326
							],
							[
								34.265433,
								31.219361
							],
							[
								34.556372,
								31.548824
							],
							[
								34.488107,
								31.605539
							],
							[
								34.752587,
								32.072926
							],
							[
								34.955417,
								32.827376
							],
							[
								35.098457,
								33.080539
							],
							[
								35.126053,
								33.0909
							],
							[
								35.460709,
								33.08904
							],
							[
								35.552797,
								33.264275
							],
							[
								35.821101,
								33.277426
							],
							[
								35.836397,
								32.868123
							],
							[
								35.700798,
								32.716014
							],
							[
								35.719918,
								32.709192
							]
						]
					]
				},
				"id": "ISR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Italy"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									15.520376,
									38.231155
								],
								[
									15.160243,
									37.444046
								],
								[
									15.309898,
									37.134219
								],
								[
									15.099988,
									36.619987
								],
								[
									14.335229,
									36.996631
								],
								[
									13.826733,
									37.104531
								],
								[
									12.431004,
									37.61295
								],
								[
									12.570944,
									38.126381
								],
								[
									13.741156,
									38.034966
								],
								[
									14.761249,
									38.143874
								],
								[
									15.520376,
									38.231155
								]
							]
						],
						[
							[
								[
									9.210012,
									41.209991
								],
								[
									9.809975,
									40.500009
								],
								[
									9.669519,
									39.177376
								],
								[
									9.214818,
									39.240473
								],
								[
									8.806936,
									38.906618
								],
								[
									8.428302,
									39.171847
								],
								[
									8.388253,
									40.378311
								],
								[
									8.159998,
									40.950007
								],
								[
									8.709991,
									40.899984
								],
								[
									9.210012,
									41.209991
								]
							]
						],
						[
							[
								[
									12.376485,
									46.767559
								],
								[
									13.806475,
									46.509306
								],
								[
									13.69811,
									46.016778
								],
								[
									13.93763,
									45.591016
								],
								[
									13.141606,
									45.736692
								],
								[
									12.328581,
									45.381778
								],
								[
									12.383875,
									44.885374
								],
								[
									12.261453,
									44.600482
								],
								[
									12.589237,
									44.091366
								],
								[
									13.526906,
									43.587727
								],
								[
									14.029821,
									42.761008
								],
								[
									15.14257,
									41.95514
								],
								[
									15.926191,
									41.961315
								],
								[
									16.169897,
									41.740295
								],
								[
									15.889346,
									41.541082
								],
								[
									16.785002,
									41.179606
								],
								[
									17.519169,
									40.877143
								],
								[
									18.376687,
									40.355625
								],
								[
									18.480247,
									40.168866
								],
								[
									18.293385,
									39.810774
								],
								[
									17.73838,
									40.277671
								],
								[
									16.869596,
									40.442235
								],
								[
									16.448743,
									39.795401
								],
								[
									17.17149,
									39.4247
								],
								[
									17.052841,
									38.902871
								],
								[
									16.635088,
									38.843572
								],
								[
									16.100961,
									37.985899
								],
								[
									15.684087,
									37.908849
								],
								[
									15.687963,
									38.214593
								],
								[
									15.891981,
									38.750942
								],
								[
									16.109332,
									38.964547
								],
								[
									15.718814,
									39.544072
								],
								[
									15.413613,
									40.048357
								],
								[
									14.998496,
									40.172949
								],
								[
									14.703268,
									40.60455
								],
								[
									14.060672,
									40.786348
								],
								[
									13.627985,
									41.188287
								],
								[
									12.888082,
									41.25309
								],
								[
									12.106683,
									41.704535
								],
								[
									11.191906,
									42.355425
								],
								[
									10.511948,
									42.931463
								],
								[
									10.200029,
									43.920007
								],
								[
									9.702488,
									44.036279
								],
								[
									8.888946,
									44.366336
								],
								[
									8.428561,
									44.231228
								],
								[
									7.850767,
									43.767148
								],
								[
									7.435185,
									43.693845
								],
								[
									7.549596,
									44.127901
								],
								[
									7.007562,
									44.254767
								],
								[
									6.749955,
									45.028518
								],
								[
									7.096652,
									45.333099
								],
								[
									6.802355,
									45.70858
								],
								[
									6.843593,
									45.991147
								],
								[
									7.273851,
									45.776948
								],
								[
									7.755992,
									45.82449
								],
								[
									8.31663,
									46.163642
								],
								[
									8.489952,
									46.005151
								],
								[
									8.966306,
									46.036932
								],
								[
									9.182882,
									46.440215
								],
								[
									9.922837,
									46.314899
								],
								[
									10.363378,
									46.483571
								],
								[
									10.442701,
									46.893546
								],
								[
									11.048556,
									46.751359
								],
								[
									11.164828,
									46.941579
								],
								[
									12.153088,
									47.115393
								],
								[
									12.376485,
									46.767559
								]
							]
						]
					]
				},
				"id": "ITA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Jamaica"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-77.569601,
								18.490525
							],
							[
								-76.896619,
								18.400867
							],
							[
								-76.365359,
								18.160701
							],
							[
								-76.199659,
								17.886867
							],
							[
								-76.902561,
								17.868238
							],
							[
								-77.206341,
								17.701116
							],
							[
								-77.766023,
								17.861597
							],
							[
								-78.337719,
								18.225968
							],
							[
								-78.217727,
								18.454533
							],
							[
								-77.797365,
								18.524218
							],
							[
								-77.569601,
								18.490525
							]
						]
					]
				},
				"id": "JAM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Jordan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.545665,
								32.393992
							],
							[
								35.719918,
								32.709192
							],
							[
								36.834062,
								32.312938
							],
							[
								38.792341,
								33.378686
							],
							[
								39.195468,
								32.161009
							],
							[
								39.004886,
								32.010217
							],
							[
								37.002166,
								31.508413
							],
							[
								37.998849,
								30.5085
							],
							[
								37.66812,
								30.338665
							],
							[
								37.503582,
								30.003776
							],
							[
								36.740528,
								29.865283
							],
							[
								36.501214,
								29.505254
							],
							[
								36.068941,
								29.197495
							],
							[
								34.956037,
								29.356555
							],
							[
								34.922603,
								29.501326
							],
							[
								35.420918,
								31.100066
							],
							[
								35.397561,
								31.489086
							],
							[
								35.545252,
								31.782505
							],
							[
								35.545665,
								32.393992
							]
						]
					]
				},
				"id": "JOR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Japan"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									134.638428,
									34.149234
								],
								[
									134.766379,
									33.806335
								],
								[
									134.203416,
									33.201178
								],
								[
									133.79295,
									33.521985
								],
								[
									133.280268,
									33.28957
								],
								[
									133.014858,
									32.704567
								],
								[
									132.363115,
									32.989382
								],
								[
									132.371176,
									33.463642
								],
								[
									132.924373,
									34.060299
								],
								[
									133.492968,
									33.944621
								],
								[
									133.904106,
									34.364931
								],
								[
									134.638428,
									34.149234
								]
							]
						],
						[
							[
								[
									140.976388,
									37.142074
								],
								[
									140.59977,
									36.343983
								],
								[
									140.774074,
									35.842877
								],
								[
									140.253279,
									35.138114
								],
								[
									138.975528,
									34.6676
								],
								[
									137.217599,
									34.606286
								],
								[
									135.792983,
									33.464805
								],
								[
									135.120983,
									33.849071
								],
								[
									135.079435,
									34.596545
								],
								[
									133.340316,
									34.375938
								],
								[
									132.156771,
									33.904933
								],
								[
									130.986145,
									33.885761
								],
								[
									132.000036,
									33.149992
								],
								[
									131.33279,
									31.450355
								],
								[
									130.686318,
									31.029579
								],
								[
									130.20242,
									31.418238
								],
								[
									130.447676,
									32.319475
								],
								[
									129.814692,
									32.61031
								],
								[
									129.408463,
									33.296056
								],
								[
									130.353935,
									33.604151
								],
								[
									130.878451,
									34.232743
								],
								[
									131.884229,
									34.749714
								],
								[
									132.617673,
									35.433393
								],
								[
									134.608301,
									35.731618
								],
								[
									135.677538,
									35.527134
								],
								[
									136.723831,
									37.304984
								],
								[
									137.390612,
									36.827391
								],
								[
									138.857602,
									37.827485
								],
								[
									139.426405,
									38.215962
								],
								[
									140.05479,
									39.438807
								],
								[
									139.883379,
									40.563312
								],
								[
									140.305783,
									41.195005
								],
								[
									141.368973,
									41.37856
								],
								[
									141.914263,
									39.991616
								],
								[
									141.884601,
									39.180865
								],
								[
									140.959489,
									38.174001
								],
								[
									140.976388,
									37.142074
								]
							]
						],
						[
							[
								[
									143.910162,
									44.1741
								],
								[
									144.613427,
									43.960883
								],
								[
									145.320825,
									44.384733
								],
								[
									145.543137,
									43.262088
								],
								[
									144.059662,
									42.988358
								],
								[
									143.18385,
									41.995215
								],
								[
									141.611491,
									42.678791
								],
								[
									141.067286,
									41.584594
								],
								[
									139.955106,
									41.569556
								],
								[
									139.817544,
									42.563759
								],
								[
									140.312087,
									43.333273
								],
								[
									141.380549,
									43.388825
								],
								[
									141.671952,
									44.772125
								],
								[
									141.967645,
									45.551483
								],
								[
									143.14287,
									44.510358
								],
								[
									143.910162,
									44.1741
								]
							]
						]
					]
				},
				"id": "JPN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Kazakhstan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								70.962315,
								42.266154
							],
							[
								70.388965,
								42.081308
							],
							[
								69.070027,
								41.384244
							],
							[
								68.632483,
								40.668681
							],
							[
								68.259896,
								40.662325
							],
							[
								67.985856,
								41.135991
							],
							[
								66.714047,
								41.168444
							],
							[
								66.510649,
								41.987644
							],
							[
								66.023392,
								41.994646
							],
							[
								66.098012,
								42.99766
							],
							[
								64.900824,
								43.728081
							],
							[
								63.185787,
								43.650075
							],
							[
								62.0133,
								43.504477
							],
							[
								61.05832,
								44.405817
							],
							[
								60.239972,
								44.784037
							],
							[
								58.689989,
								45.500014
							],
							[
								58.503127,
								45.586804
							],
							[
								55.928917,
								44.995858
							],
							[
								55.968191,
								41.308642
							],
							[
								55.455251,
								41.259859
							],
							[
								54.755345,
								42.043971
							],
							[
								54.079418,
								42.324109
							],
							[
								52.944293,
								42.116034
							],
							[
								52.50246,
								41.783316
							],
							[
								52.446339,
								42.027151
							],
							[
								52.692112,
								42.443895
							],
							[
								52.501426,
								42.792298
							],
							[
								51.342427,
								43.132975
							],
							[
								50.891292,
								44.031034
							],
							[
								50.339129,
								44.284016
							],
							[
								50.305643,
								44.609836
							],
							[
								51.278503,
								44.514854
							],
							[
								51.316899,
								45.245998
							],
							[
								52.16739,
								45.408391
							],
							[
								53.040876,
								45.259047
							],
							[
								53.220866,
								46.234646
							],
							[
								53.042737,
								46.853006
							],
							[
								52.042023,
								46.804637
							],
							[
								51.191945,
								47.048705
							],
							[
								50.034083,
								46.60899
							],
							[
								49.10116,
								46.39933
							],
							[
								48.593241,
								46.561034
							],
							[
								48.694734,
								47.075628
							],
							[
								48.057253,
								47.743753
							],
							[
								47.315231,
								47.715847
							],
							[
								46.466446,
								48.394152
							],
							[
								47.043672,
								49.152039
							],
							[
								46.751596,
								49.356006
							],
							[
								47.54948,
								50.454698
							],
							[
								48.577841,
								49.87476
							],
							[
								48.702382,
								50.605128
							],
							[
								50.766648,
								51.692762
							],
							[
								52.328724,
								51.718652
							],
							[
								54.532878,
								51.02624
							],
							[
								55.716941,
								50.621717
							],
							[
								56.777961,
								51.043551
							],
							[
								58.363291,
								51.063653
							],
							[
								59.642282,
								50.545442
							],
							[
								59.932807,
								50.842194
							],
							[
								61.337424,
								50.79907
							],
							[
								61.588003,
								51.272659
							],
							[
								59.967534,
								51.96042
							],
							[
								60.927269,
								52.447548
							],
							[
								60.739993,
								52.719986
							],
							[
								61.699986,
								52.979996
							],
							[
								60.978066,
								53.664993
							],
							[
								61.436591,
								54.006265
							],
							[
								65.178534,
								54.354228
							],
							[
								65.666876,
								54.601267
							],
							[
								68.1691,
								54.970392
							],
							[
								69.068167,
								55.38525
							],
							[
								70.865267,
								55.169734
							],
							[
								71.180131,
								54.133285
							],
							[
								72.22415,
								54.376655
							],
							[
								73.508516,
								54.035617
							],
							[
								73.425679,
								53.48981
							],
							[
								74.384845,
								53.546861
							],
							[
								76.8911,
								54.490524
							],
							[
								76.525179,
								54.177003
							],
							[
								77.800916,
								53.404415
							],
							[
								80.03556,
								50.864751
							],
							[
								80.568447,
								51.388336
							],
							[
								81.945986,
								50.812196
							],
							[
								83.383004,
								51.069183
							],
							[
								83.935115,
								50.889246
							],
							[
								84.416377,
								50.3114
							],
							[
								85.11556,
								50.117303
							],
							[
								85.54127,
								49.692859
							],
							[
								86.829357,
								49.826675
							],
							[
								87.35997,
								49.214981
							],
							[
								86.598776,
								48.549182
							],
							[
								85.768233,
								48.455751
							],
							[
								85.720484,
								47.452969
							],
							[
								85.16429,
								47.000956
							],
							[
								83.180484,
								47.330031
							],
							[
								82.458926,
								45.53965
							],
							[
								81.947071,
								45.317027
							],
							[
								79.966106,
								44.917517
							],
							[
								80.866206,
								43.180362
							],
							[
								80.18015,
								42.920068
							],
							[
								80.25999,
								42.349999
							],
							[
								79.643645,
								42.496683
							],
							[
								79.142177,
								42.856092
							],
							[
								77.658392,
								42.960686
							],
							[
								76.000354,
								42.988022
							],
							[
								75.636965,
								42.8779
							],
							[
								74.212866,
								43.298339
							],
							[
								73.645304,
								43.091272
							],
							[
								73.489758,
								42.500894
							],
							[
								71.844638,
								42.845395
							],
							[
								71.186281,
								42.704293
							],
							[
								70.962315,
								42.266154
							]
						]
					]
				},
				"id": "KAZ"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Kenya"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								40.993,
								-0.85829
							],
							[
								41.58513,
								-1.68325
							],
							[
								40.88477,
								-2.08255
							],
							[
								40.63785,
								-2.49979
							],
							[
								40.26304,
								-2.57309
							],
							[
								40.12119,
								-3.27768
							],
							[
								39.80006,
								-3.68116
							],
							[
								39.60489,
								-4.34653
							],
							[
								39.20222,
								-4.67677
							],
							[
								37.7669,
								-3.67712
							],
							[
								37.69869,
								-3.09699
							],
							[
								34.07262,
								-1.05982
							],
							[
								33.903711,
								-0.95
							],
							[
								33.893569,
								0.109814
							],
							[
								34.18,
								0.515
							],
							[
								34.6721,
								1.17694
							],
							[
								35.03599,
								1.90584
							],
							[
								34.59607,
								3.05374
							],
							[
								34.47913,
								3.5556
							],
							[
								34.005,
								4.249885
							],
							[
								34.620196,
								4.847123
							],
							[
								35.298007,
								5.506
							],
							[
								35.817448,
								5.338232
							],
							[
								35.817448,
								4.776966
							],
							[
								36.159079,
								4.447864
							],
							[
								36.855093,
								4.447864
							],
							[
								38.120915,
								3.598605
							],
							[
								38.43697,
								3.58851
							],
							[
								38.67114,
								3.61607
							],
							[
								38.89251,
								3.50074
							],
							[
								39.559384,
								3.42206
							],
							[
								39.85494,
								3.83879
							],
							[
								40.76848,
								4.25702
							],
							[
								41.1718,
								3.91909
							],
							[
								41.855083,
								3.918912
							],
							[
								40.98105,
								2.78452
							],
							[
								40.993,
								-0.85829
							]
						]
					]
				},
				"id": "KEN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Kyrgyzstan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								70.962315,
								42.266154
							],
							[
								71.186281,
								42.704293
							],
							[
								71.844638,
								42.845395
							],
							[
								73.489758,
								42.500894
							],
							[
								73.645304,
								43.091272
							],
							[
								74.212866,
								43.298339
							],
							[
								75.636965,
								42.8779
							],
							[
								76.000354,
								42.988022
							],
							[
								77.658392,
								42.960686
							],
							[
								79.142177,
								42.856092
							],
							[
								79.643645,
								42.496683
							],
							[
								80.25999,
								42.349999
							],
							[
								80.11943,
								42.123941
							],
							[
								78.543661,
								41.582243
							],
							[
								78.187197,
								41.185316
							],
							[
								76.904484,
								41.066486
							],
							[
								76.526368,
								40.427946
							],
							[
								75.467828,
								40.562072
							],
							[
								74.776862,
								40.366425
							],
							[
								73.822244,
								39.893973
							],
							[
								73.960013,
								39.660008
							],
							[
								73.675379,
								39.431237
							],
							[
								71.784694,
								39.279463
							],
							[
								70.549162,
								39.604198
							],
							[
								69.464887,
								39.526683
							],
							[
								69.55961,
								40.103211
							],
							[
								70.648019,
								39.935754
							],
							[
								71.014198,
								40.244366
							],
							[
								71.774875,
								40.145844
							],
							[
								73.055417,
								40.866033
							],
							[
								71.870115,
								41.3929
							],
							[
								71.157859,
								41.143587
							],
							[
								70.420022,
								41.519998
							],
							[
								71.259248,
								42.167711
							],
							[
								70.962315,
								42.266154
							]
						]
					]
				},
				"id": "KGZ"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Cambodia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								103.49728,
								10.632555
							],
							[
								103.09069,
								11.153661
							],
							[
								102.584932,
								12.186595
							],
							[
								102.348099,
								13.394247
							],
							[
								102.988422,
								14.225721
							],
							[
								104.281418,
								14.416743
							],
							[
								105.218777,
								14.273212
							],
							[
								106.043946,
								13.881091
							],
							[
								106.496373,
								14.570584
							],
							[
								107.382727,
								14.202441
							],
							[
								107.614548,
								13.535531
							],
							[
								107.491403,
								12.337206
							],
							[
								105.810524,
								11.567615
							],
							[
								106.24967,
								10.961812
							],
							[
								105.199915,
								10.88931
							],
							[
								104.334335,
								10.486544
							],
							[
								103.49728,
								10.632555
							]
						]
					]
				},
				"id": "KHM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "South Korea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								128.349716,
								38.612243
							],
							[
								129.21292,
								37.432392
							],
							[
								129.46045,
								36.784189
							],
							[
								129.468304,
								35.632141
							],
							[
								129.091377,
								35.082484
							],
							[
								128.18585,
								34.890377
							],
							[
								127.386519,
								34.475674
							],
							[
								126.485748,
								34.390046
							],
							[
								126.37392,
								34.93456
							],
							[
								126.559231,
								35.684541
							],
							[
								126.117398,
								36.725485
							],
							[
								126.860143,
								36.893924
							],
							[
								126.174759,
								37.749686
							],
							[
								126.237339,
								37.840378
							],
							[
								126.68372,
								37.804773
							],
							[
								127.073309,
								38.256115
							],
							[
								127.780035,
								38.304536
							],
							[
								128.205746,
								38.370397
							],
							[
								128.349716,
								38.612243
							]
						]
					]
				},
				"id": "KOR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Kosovo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.76216,
								42.05186
							],
							[
								20.71731,
								41.84711
							],
							[
								20.59023,
								41.85541
							],
							[
								20.52295,
								42.21787
							],
							[
								20.28374,
								42.32025
							],
							[
								20.0707,
								42.58863
							],
							[
								20.25758,
								42.81275
							],
							[
								20.49679,
								42.88469
							],
							[
								20.63508,
								43.21671
							],
							[
								20.81448,
								43.27205
							],
							[
								20.95651,
								43.13094
							],
							[
								21.143395,
								43.068685
							],
							[
								21.27421,
								42.90959
							],
							[
								21.43866,
								42.86255
							],
							[
								21.63302,
								42.67717
							],
							[
								21.77505,
								42.6827
							],
							[
								21.66292,
								42.43922
							],
							[
								21.54332,
								42.32025
							],
							[
								21.576636,
								42.245224
							],
							[
								21.3527,
								42.2068
							],
							[
								20.76216,
								42.05186
							]
						]
					]
				},
				"id": "-99"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Kuwait"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								47.974519,
								29.975819
							],
							[
								48.183189,
								29.534477
							],
							[
								48.093943,
								29.306299
							],
							[
								48.416094,
								28.552004
							],
							[
								47.708851,
								28.526063
							],
							[
								47.459822,
								29.002519
							],
							[
								46.568713,
								29.099025
							],
							[
								47.302622,
								30.05907
							],
							[
								47.974519,
								29.975819
							]
						]
					]
				},
				"id": "KWT"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Laos"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								105.218777,
								14.273212
							],
							[
								105.544338,
								14.723934
							],
							[
								105.589039,
								15.570316
							],
							[
								104.779321,
								16.441865
							],
							[
								104.716947,
								17.428859
							],
							[
								103.956477,
								18.240954
							],
							[
								103.200192,
								18.309632
							],
							[
								102.998706,
								17.961695
							],
							[
								102.413005,
								17.932782
							],
							[
								102.113592,
								18.109102
							],
							[
								101.059548,
								17.512497
							],
							[
								101.035931,
								18.408928
							],
							[
								101.282015,
								19.462585
							],
							[
								100.606294,
								19.508344
							],
							[
								100.548881,
								20.109238
							],
							[
								100.115988,
								20.41785
							],
							[
								100.329101,
								20.786122
							],
							[
								101.180005,
								21.436573
							],
							[
								101.270026,
								21.201652
							],
							[
								101.80312,
								21.174367
							],
							[
								101.652018,
								22.318199
							],
							[
								102.170436,
								22.464753
							],
							[
								102.754896,
								21.675137
							],
							[
								103.203861,
								20.766562
							],
							[
								104.435,
								20.758733
							],
							[
								104.822574,
								19.886642
							],
							[
								104.183388,
								19.624668
							],
							[
								103.896532,
								19.265181
							],
							[
								105.094598,
								18.666975
							],
							[
								105.925762,
								17.485315
							],
							[
								106.556008,
								16.604284
							],
							[
								107.312706,
								15.908538
							],
							[
								107.564525,
								15.202173
							],
							[
								107.382727,
								14.202441
							],
							[
								106.496373,
								14.570584
							],
							[
								106.043946,
								13.881091
							],
							[
								105.218777,
								14.273212
							]
						]
					]
				},
				"id": "LAO"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Lebanon"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.821101,
								33.277426
							],
							[
								35.552797,
								33.264275
							],
							[
								35.460709,
								33.08904
							],
							[
								35.126053,
								33.0909
							],
							[
								35.482207,
								33.90545
							],
							[
								35.979592,
								34.610058
							],
							[
								35.998403,
								34.644914
							],
							[
								36.448194,
								34.593935
							],
							[
								36.61175,
								34.201789
							],
							[
								36.06646,
								33.824912
							],
							[
								35.821101,
								33.277426
							]
						]
					]
				},
				"id": "LBN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Liberia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-7.712159,
								4.364566
							],
							[
								-7.974107,
								4.355755
							],
							[
								-9.004794,
								4.832419
							],
							[
								-9.91342,
								5.593561
							],
							[
								-10.765384,
								6.140711
							],
							[
								-11.438779,
								6.785917
							],
							[
								-11.199802,
								7.105846
							],
							[
								-11.146704,
								7.396706
							],
							[
								-10.695595,
								7.939464
							],
							[
								-10.230094,
								8.406206
							],
							[
								-10.016567,
								8.428504
							],
							[
								-9.755342,
								8.541055
							],
							[
								-9.33728,
								7.928534
							],
							[
								-9.403348,
								7.526905
							],
							[
								-9.208786,
								7.313921
							],
							[
								-8.926065,
								7.309037
							],
							[
								-8.722124,
								7.711674
							],
							[
								-8.439298,
								7.686043
							],
							[
								-8.485446,
								7.395208
							],
							[
								-8.385452,
								6.911801
							],
							[
								-8.60288,
								6.467564
							],
							[
								-8.311348,
								6.193033
							],
							[
								-7.993693,
								6.12619
							],
							[
								-7.570153,
								5.707352
							],
							[
								-7.539715,
								5.313345
							],
							[
								-7.635368,
								5.188159
							],
							[
								-7.712159,
								4.364566
							]
						]
					]
				},
				"id": "LBR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Libya"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								14.8513,
								22.86295
							],
							[
								14.143871,
								22.491289
							],
							[
								13.581425,
								23.040506
							],
							[
								11.999506,
								23.471668
							],
							[
								11.560669,
								24.097909
							],
							[
								10.771364,
								24.562532
							],
							[
								10.303847,
								24.379313
							],
							[
								9.948261,
								24.936954
							],
							[
								9.910693,
								25.365455
							],
							[
								9.319411,
								26.094325
							],
							[
								9.716286,
								26.512206
							],
							[
								9.629056,
								27.140953
							],
							[
								9.756128,
								27.688259
							],
							[
								9.683885,
								28.144174
							],
							[
								9.859998,
								28.95999
							],
							[
								9.805634,
								29.424638
							],
							[
								9.48214,
								30.307556
							],
							[
								9.970017,
								30.539325
							],
							[
								10.056575,
								30.961831
							],
							[
								9.950225,
								31.37607
							],
							[
								10.636901,
								31.761421
							],
							[
								10.94479,
								32.081815
							],
							[
								11.432253,
								32.368903
							],
							[
								11.488787,
								33.136996
							],
							[
								12.66331,
								32.79278
							],
							[
								13.08326,
								32.87882
							],
							[
								13.91868,
								32.71196
							],
							[
								15.24563,
								32.26508
							],
							[
								15.71394,
								31.37626
							],
							[
								16.61162,
								31.18218
							],
							[
								18.02109,
								30.76357
							],
							[
								19.08641,
								30.26639
							],
							[
								19.57404,
								30.52582
							],
							[
								20.05335,
								30.98576
							],
							[
								19.82033,
								31.75179
							],
							[
								20.13397,
								32.2382
							],
							[
								20.85452,
								32.7068
							],
							[
								21.54298,
								32.8432
							],
							[
								22.89576,
								32.63858
							],
							[
								23.2368,
								32.19149
							],
							[
								23.60913,
								32.18726
							],
							[
								23.9275,
								32.01667
							],
							[
								24.92114,
								31.89936
							],
							[
								25.16482,
								31.56915
							],
							[
								24.80287,
								31.08929
							],
							[
								24.95762,
								30.6616
							],
							[
								24.70007,
								30.04419
							],
							[
								25,
								29.238655
							],
							[
								25,
								25.6825
							],
							[
								25,
								22
							],
							[
								25,
								20.00304
							],
							[
								23.85,
								20
							],
							[
								23.83766,
								19.58047
							],
							[
								19.84926,
								21.49509
							],
							[
								15.86085,
								23.40972
							],
							[
								14.8513,
								22.86295
							]
						]
					]
				},
				"id": "LBY"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Sri Lanka"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								81.787959,
								7.523055
							],
							[
								81.637322,
								6.481775
							],
							[
								81.21802,
								6.197141
							],
							[
								80.348357,
								5.96837
							],
							[
								79.872469,
								6.763463
							],
							[
								79.695167,
								8.200843
							],
							[
								80.147801,
								9.824078
							],
							[
								80.838818,
								9.268427
							],
							[
								81.304319,
								8.564206
							],
							[
								81.787959,
								7.523055
							]
						]
					]
				},
				"id": "LKA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Lesotho"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								28.978263,
								-28.955597
							],
							[
								29.325166,
								-29.257387
							],
							[
								29.018415,
								-29.743766
							],
							[
								28.8484,
								-30.070051
							],
							[
								28.291069,
								-30.226217
							],
							[
								28.107205,
								-30.545732
							],
							[
								27.749397,
								-30.645106
							],
							[
								26.999262,
								-29.875954
							],
							[
								27.532511,
								-29.242711
							],
							[
								28.074338,
								-28.851469
							],
							[
								28.5417,
								-28.647502
							],
							[
								28.978263,
								-28.955597
							]
						]
					]
				},
				"id": "LSO"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Republic of Lithuania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								22.731099,
								54.327537
							],
							[
								22.651052,
								54.582741
							],
							[
								22.757764,
								54.856574
							],
							[
								22.315724,
								55.015299
							],
							[
								21.268449,
								55.190482
							],
							[
								21.0558,
								56.031076
							],
							[
								22.201157,
								56.337802
							],
							[
								23.878264,
								56.273671
							],
							[
								24.860684,
								56.372528
							],
							[
								25.000934,
								56.164531
							],
							[
								25.533047,
								56.100297
							],
							[
								26.494331,
								55.615107
							],
							[
								26.588279,
								55.167176
							],
							[
								25.768433,
								54.846963
							],
							[
								25.536354,
								54.282423
							],
							[
								24.450684,
								53.905702
							],
							[
								23.484128,
								53.912498
							],
							[
								23.243987,
								54.220567
							],
							[
								22.731099,
								54.327537
							]
						]
					]
				},
				"id": "LTU"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Luxembourg"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6.043073,
								50.128052
							],
							[
								6.242751,
								49.902226
							],
							[
								6.18632,
								49.463803
							],
							[
								5.897759,
								49.442667
							],
							[
								5.674052,
								49.529484
							],
							[
								5.782417,
								50.090328
							],
							[
								6.043073,
								50.128052
							]
						]
					]
				},
				"id": "LUX"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Latvia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								21.0558,
								56.031076
							],
							[
								21.090424,
								56.783873
							],
							[
								21.581866,
								57.411871
							],
							[
								22.524341,
								57.753374
							],
							[
								23.318453,
								57.006236
							],
							[
								24.12073,
								57.025693
							],
							[
								24.312863,
								57.793424
							],
							[
								25.164594,
								57.970157
							],
							[
								25.60281,
								57.847529
							],
							[
								26.463532,
								57.476389
							],
							[
								27.288185,
								57.474528
							],
							[
								27.770016,
								57.244258
							],
							[
								27.855282,
								56.759326
							],
							[
								28.176709,
								56.16913
							],
							[
								27.10246,
								55.783314
							],
							[
								26.494331,
								55.615107
							],
							[
								25.533047,
								56.100297
							],
							[
								25.000934,
								56.164531
							],
							[
								24.860684,
								56.372528
							],
							[
								23.878264,
								56.273671
							],
							[
								22.201157,
								56.337802
							],
							[
								21.0558,
								56.031076
							]
						]
					]
				},
				"id": "LVA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Morocco"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-5.193863,
								35.755182
							],
							[
								-4.591006,
								35.330712
							],
							[
								-3.640057,
								35.399855
							],
							[
								-2.604306,
								35.179093
							],
							[
								-2.169914,
								35.168396
							],
							[
								-1.792986,
								34.527919
							],
							[
								-1.733455,
								33.919713
							],
							[
								-1.388049,
								32.864015
							],
							[
								-1.124551,
								32.651522
							],
							[
								-1.307899,
								32.262889
							],
							[
								-2.616605,
								32.094346
							],
							[
								-3.06898,
								31.724498
							],
							[
								-3.647498,
								31.637294
							],
							[
								-3.690441,
								30.896952
							],
							[
								-4.859646,
								30.501188
							],
							[
								-5.242129,
								30.000443
							],
							[
								-6.060632,
								29.7317
							],
							[
								-7.059228,
								29.579228
							],
							[
								-8.674116,
								28.841289
							],
							[
								-8.66559,
								27.656426
							],
							[
								-8.817809,
								27.656426
							],
							[
								-8.817828,
								27.656426
							],
							[
								-8.794884,
								27.120696
							],
							[
								-9.413037,
								27.088476
							],
							[
								-9.735343,
								26.860945
							],
							[
								-10.189424,
								26.860945
							],
							[
								-10.551263,
								26.990808
							],
							[
								-11.392555,
								26.883424
							],
							[
								-11.71822,
								26.104092
							],
							[
								-12.030759,
								26.030866
							],
							[
								-12.500963,
								24.770116
							],
							[
								-13.89111,
								23.691009
							],
							[
								-14.221168,
								22.310163
							],
							[
								-14.630833,
								21.86094
							],
							[
								-14.750955,
								21.5006
							],
							[
								-17.002962,
								21.420734
							],
							[
								-17.020428,
								21.42231
							],
							[
								-16.973248,
								21.885745
							],
							[
								-16.589137,
								22.158234
							],
							[
								-16.261922,
								22.67934
							],
							[
								-16.326414,
								23.017768
							],
							[
								-15.982611,
								23.723358
							],
							[
								-15.426004,
								24.359134
							],
							[
								-15.089332,
								24.520261
							],
							[
								-14.824645,
								25.103533
							],
							[
								-14.800926,
								25.636265
							],
							[
								-14.43994,
								26.254418
							],
							[
								-13.773805,
								26.618892
							],
							[
								-13.139942,
								27.640148
							],
							[
								-13.121613,
								27.654148
							],
							[
								-12.618837,
								28.038186
							],
							[
								-11.688919,
								28.148644
							],
							[
								-10.900957,
								28.832142
							],
							[
								-10.399592,
								29.098586
							],
							[
								-9.564811,
								29.933574
							],
							[
								-9.814718,
								31.177736
							],
							[
								-9.434793,
								32.038096
							],
							[
								-9.300693,
								32.564679
							],
							[
								-8.657476,
								33.240245
							],
							[
								-7.654178,
								33.697065
							],
							[
								-6.912544,
								34.110476
							],
							[
								-6.244342,
								35.145865
							],
							[
								-5.929994,
								35.759988
							],
							[
								-5.193863,
								35.755182
							]
						]
					]
				},
				"id": "MAR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Moldova"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								26.619337,
								48.220726
							],
							[
								26.857824,
								48.368211
							],
							[
								27.522537,
								48.467119
							],
							[
								28.259547,
								48.155562
							],
							[
								28.670891,
								48.118149
							],
							[
								29.122698,
								47.849095
							],
							[
								29.050868,
								47.510227
							],
							[
								29.415135,
								47.346645
							],
							[
								29.559674,
								46.928583
							],
							[
								29.908852,
								46.674361
							],
							[
								29.83821,
								46.525326
							],
							[
								30.024659,
								46.423937
							],
							[
								29.759972,
								46.349988
							],
							[
								29.170654,
								46.379262
							],
							[
								29.072107,
								46.517678
							],
							[
								28.862972,
								46.437889
							],
							[
								28.933717,
								46.25883
							],
							[
								28.659987,
								45.939987
							],
							[
								28.485269,
								45.596907
							],
							[
								28.233554,
								45.488283
							],
							[
								28.054443,
								45.944586
							],
							[
								28.160018,
								46.371563
							],
							[
								28.12803,
								46.810476
							],
							[
								27.551166,
								47.405117
							],
							[
								27.233873,
								47.826771
							],
							[
								26.924176,
								48.123264
							],
							[
								26.619337,
								48.220726
							]
						]
					]
				},
				"id": "MDA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Madagascar"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								49.543519,
								-12.469833
							],
							[
								49.808981,
								-12.895285
							],
							[
								50.056511,
								-13.555761
							],
							[
								50.217431,
								-14.758789
							],
							[
								50.476537,
								-15.226512
							],
							[
								50.377111,
								-15.706069
							],
							[
								50.200275,
								-16.000263
							],
							[
								49.860606,
								-15.414253
							],
							[
								49.672607,
								-15.710204
							],
							[
								49.863344,
								-16.451037
							],
							[
								49.774564,
								-16.875042
							],
							[
								49.498612,
								-17.106036
							],
							[
								49.435619,
								-17.953064
							],
							[
								49.041792,
								-19.118781
							],
							[
								48.548541,
								-20.496888
							],
							[
								47.930749,
								-22.391501
							],
							[
								47.547723,
								-23.781959
							],
							[
								47.095761,
								-24.94163
							],
							[
								46.282478,
								-25.178463
							],
							[
								45.409508,
								-25.601434
							],
							[
								44.833574,
								-25.346101
							],
							[
								44.03972,
								-24.988345
							],
							[
								43.763768,
								-24.460677
							],
							[
								43.697778,
								-23.574116
							],
							[
								43.345654,
								-22.776904
							],
							[
								43.254187,
								-22.057413
							],
							[
								43.433298,
								-21.336475
							],
							[
								43.893683,
								-21.163307
							],
							[
								43.89637,
								-20.830459
							],
							[
								44.374325,
								-20.072366
							],
							[
								44.464397,
								-19.435454
							],
							[
								44.232422,
								-18.961995
							],
							[
								44.042976,
								-18.331387
							],
							[
								43.963084,
								-17.409945
							],
							[
								44.312469,
								-16.850496
							],
							[
								44.446517,
								-16.216219
							],
							[
								44.944937,
								-16.179374
							],
							[
								45.502732,
								-15.974373
							],
							[
								45.872994,
								-15.793454
							],
							[
								46.312243,
								-15.780018
							],
							[
								46.882183,
								-15.210182
							],
							[
								47.70513,
								-14.594303
							],
							[
								48.005215,
								-14.091233
							],
							[
								47.869047,
								-13.663869
							],
							[
								48.293828,
								-13.784068
							],
							[
								48.84506,
								-13.089175
							],
							[
								48.863509,
								-12.487868
							],
							[
								49.194651,
								-12.040557
							],
							[
								49.543519,
								-12.469833
							]
						]
					]
				},
				"id": "MDG"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Mexico"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-97.140008,
								25.869997
							],
							[
								-97.528072,
								24.992144
							],
							[
								-97.702946,
								24.272343
							],
							[
								-97.776042,
								22.93258
							],
							[
								-97.872367,
								22.444212
							],
							[
								-97.699044,
								21.898689
							],
							[
								-97.38896,
								21.411019
							],
							[
								-97.189333,
								20.635433
							],
							[
								-96.525576,
								19.890931
							],
							[
								-96.292127,
								19.320371
							],
							[
								-95.900885,
								18.828024
							],
							[
								-94.839063,
								18.562717
							],
							[
								-94.42573,
								18.144371
							],
							[
								-93.548651,
								18.423837
							],
							[
								-92.786114,
								18.524839
							],
							[
								-92.037348,
								18.704569
							],
							[
								-91.407903,
								18.876083
							],
							[
								-90.77187,
								19.28412
							],
							[
								-90.53359,
								19.867418
							],
							[
								-90.451476,
								20.707522
							],
							[
								-90.278618,
								20.999855
							],
							[
								-89.601321,
								21.261726
							],
							[
								-88.543866,
								21.493675
							],
							[
								-87.658417,
								21.458846
							],
							[
								-87.05189,
								21.543543
							],
							[
								-86.811982,
								21.331515
							],
							[
								-86.845908,
								20.849865
							],
							[
								-87.383291,
								20.255405
							],
							[
								-87.621054,
								19.646553
							],
							[
								-87.43675,
								19.472403
							],
							[
								-87.58656,
								19.04013
							],
							[
								-87.837191,
								18.259816
							],
							[
								-88.090664,
								18.516648
							],
							[
								-88.300031,
								18.499982
							],
							[
								-88.490123,
								18.486831
							],
							[
								-88.848344,
								17.883198
							],
							[
								-89.029857,
								18.001511
							],
							[
								-89.150909,
								17.955468
							],
							[
								-89.14308,
								17.808319
							],
							[
								-90.067934,
								17.819326
							],
							[
								-91.00152,
								17.817595
							],
							[
								-91.002269,
								17.254658
							],
							[
								-91.453921,
								17.252177
							],
							[
								-91.08167,
								16.918477
							],
							[
								-90.711822,
								16.687483
							],
							[
								-90.600847,
								16.470778
							],
							[
								-90.438867,
								16.41011
							],
							[
								-90.464473,
								16.069562
							],
							[
								-91.74796,
								16.066565
							],
							[
								-92.229249,
								15.251447
							],
							[
								-92.087216,
								15.064585
							],
							[
								-92.20323,
								14.830103
							],
							[
								-92.22775,
								14.538829
							],
							[
								-93.359464,
								15.61543
							],
							[
								-93.875169,
								15.940164
							],
							[
								-94.691656,
								16.200975
							],
							[
								-95.250227,
								16.128318
							],
							[
								-96.053382,
								15.752088
							],
							[
								-96.557434,
								15.653515
							],
							[
								-97.263592,
								15.917065
							],
							[
								-98.01303,
								16.107312
							],
							[
								-98.947676,
								16.566043
							],
							[
								-99.697397,
								16.706164
							],
							[
								-100.829499,
								17.171071
							],
							[
								-101.666089,
								17.649026
							],
							[
								-101.918528,
								17.91609
							],
							[
								-102.478132,
								17.975751
							],
							[
								-103.50099,
								18.292295
							],
							[
								-103.917527,
								18.748572
							],
							[
								-104.99201,
								19.316134
							],
							[
								-105.493038,
								19.946767
							],
							[
								-105.731396,
								20.434102
							],
							[
								-105.397773,
								20.531719
							],
							[
								-105.500661,
								20.816895
							],
							[
								-105.270752,
								21.076285
							],
							[
								-105.265817,
								21.422104
							],
							[
								-105.603161,
								21.871146
							],
							[
								-105.693414,
								22.26908
							],
							[
								-106.028716,
								22.773752
							],
							[
								-106.90998,
								23.767774
							],
							[
								-107.915449,
								24.548915
							],
							[
								-108.401905,
								25.172314
							],
							[
								-109.260199,
								25.580609
							],
							[
								-109.444089,
								25.824884
							],
							[
								-109.291644,
								26.442934
							],
							[
								-109.801458,
								26.676176
							],
							[
								-110.391732,
								27.162115
							],
							[
								-110.641019,
								27.859876
							],
							[
								-111.178919,
								27.941241
							],
							[
								-111.759607,
								28.467953
							],
							[
								-112.228235,
								28.954409
							],
							[
								-112.271824,
								29.266844
							],
							[
								-112.809594,
								30.021114
							],
							[
								-113.163811,
								30.786881
							],
							[
								-113.148669,
								31.170966
							],
							[
								-113.871881,
								31.567608
							],
							[
								-114.205737,
								31.524045
							],
							[
								-114.776451,
								31.799532
							],
							[
								-114.9367,
								31.393485
							],
							[
								-114.771232,
								30.913617
							],
							[
								-114.673899,
								30.162681
							],
							[
								-114.330974,
								29.750432
							],
							[
								-113.588875,
								29.061611
							],
							[
								-113.424053,
								28.826174
							],
							[
								-113.271969,
								28.754783
							],
							[
								-113.140039,
								28.411289
							],
							[
								-112.962298,
								28.42519
							],
							[
								-112.761587,
								27.780217
							],
							[
								-112.457911,
								27.525814
							],
							[
								-112.244952,
								27.171727
							],
							[
								-111.616489,
								26.662817
							],
							[
								-111.284675,
								25.73259
							],
							[
								-110.987819,
								25.294606
							],
							[
								-110.710007,
								24.826004
							],
							[
								-110.655049,
								24.298595
							],
							[
								-110.172856,
								24.265548
							],
							[
								-109.771847,
								23.811183
							],
							[
								-109.409104,
								23.364672
							],
							[
								-109.433392,
								23.185588
							],
							[
								-109.854219,
								22.818272
							],
							[
								-110.031392,
								22.823078
							],
							[
								-110.295071,
								23.430973
							],
							[
								-110.949501,
								24.000964
							],
							[
								-111.670568,
								24.484423
							],
							[
								-112.182036,
								24.738413
							],
							[
								-112.148989,
								25.470125
							],
							[
								-112.300711,
								26.012004
							],
							[
								-112.777297,
								26.32196
							],
							[
								-113.464671,
								26.768186
							],
							[
								-113.59673,
								26.63946
							],
							[
								-113.848937,
								26.900064
							],
							[
								-114.465747,
								27.14209
							],
							[
								-115.055142,
								27.722727
							],
							[
								-114.982253,
								27.7982
							],
							[
								-114.570366,
								27.741485
							],
							[
								-114.199329,
								28.115003
							],
							[
								-114.162018,
								28.566112
							],
							[
								-114.931842,
								29.279479
							],
							[
								-115.518654,
								29.556362
							],
							[
								-115.887365,
								30.180794
							],
							[
								-116.25835,
								30.836464
							],
							[
								-116.721526,
								31.635744
							],
							[
								-117.12776,
								32.53534
							],
							[
								-115.99135,
								32.61239
							],
							[
								-114.72139,
								32.72083
							],
							[
								-114.815,
								32.52528
							],
							[
								-113.30498,
								32.03914
							],
							[
								-111.02361,
								31.33472
							],
							[
								-109.035,
								31.34194
							],
							[
								-108.24194,
								31.34222
							],
							[
								-108.24,
								31.754854
							],
							[
								-106.50759,
								31.75452
							],
							[
								-106.1429,
								31.39995
							],
							[
								-105.63159,
								31.08383
							],
							[
								-105.03737,
								30.64402
							],
							[
								-104.70575,
								30.12173
							],
							[
								-104.45697,
								29.57196
							],
							[
								-103.94,
								29.27
							],
							[
								-103.11,
								28.97
							],
							[
								-102.48,
								29.76
							],
							[
								-101.6624,
								29.7793
							],
							[
								-100.9576,
								29.38071
							],
							[
								-100.45584,
								28.69612
							],
							[
								-100.11,
								28.11
							],
							[
								-99.52,
								27.54
							],
							[
								-99.3,
								26.84
							],
							[
								-99.02,
								26.37
							],
							[
								-98.24,
								26.06
							],
							[
								-97.53,
								25.84
							],
							[
								-97.140008,
								25.869997
							]
						]
					]
				},
				"id": "MEX"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Macedonia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.59023,
								41.85541
							],
							[
								20.71731,
								41.84711
							],
							[
								20.76216,
								42.05186
							],
							[
								21.3527,
								42.2068
							],
							[
								21.576636,
								42.245224
							],
							[
								21.91708,
								42.30364
							],
							[
								22.380526,
								42.32026
							],
							[
								22.881374,
								41.999297
							],
							[
								22.952377,
								41.337994
							],
							[
								22.76177,
								41.3048
							],
							[
								22.597308,
								41.130487
							],
							[
								22.055378,
								41.149866
							],
							[
								21.674161,
								40.931275
							],
							[
								21.02004,
								40.842727
							],
							[
								20.60518,
								41.08622
							],
							[
								20.46315,
								41.51509
							],
							[
								20.59023,
								41.85541
							]
						]
					]
				},
				"id": "MKD"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Mali"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-12.17075,
								14.616834
							],
							[
								-11.834208,
								14.799097
							],
							[
								-11.666078,
								15.388208
							],
							[
								-11.349095,
								15.411256
							],
							[
								-10.650791,
								15.132746
							],
							[
								-10.086846,
								15.330486
							],
							[
								-9.700255,
								15.264107
							],
							[
								-9.550238,
								15.486497
							],
							[
								-5.537744,
								15.50169
							],
							[
								-5.315277,
								16.201854
							],
							[
								-5.488523,
								16.325102
							],
							[
								-5.971129,
								20.640833
							],
							[
								-6.453787,
								24.956591
							],
							[
								-4.923337,
								24.974574
							],
							[
								-1.550055,
								22.792666
							],
							[
								1.823228,
								20.610809
							],
							[
								2.060991,
								20.142233
							],
							[
								2.683588,
								19.85623
							],
							[
								3.146661,
								19.693579
							],
							[
								3.158133,
								19.057364
							],
							[
								4.267419,
								19.155265
							],
							[
								4.27021,
								16.852227
							],
							[
								3.723422,
								16.184284
							],
							[
								3.638259,
								15.56812
							],
							[
								2.749993,
								15.409525
							],
							[
								1.385528,
								15.323561
							],
							[
								1.015783,
								14.968182
							],
							[
								0.374892,
								14.928908
							],
							[
								-0.266257,
								14.924309
							],
							[
								-0.515854,
								15.116158
							],
							[
								-1.066363,
								14.973815
							],
							[
								-2.001035,
								14.559008
							],
							[
								-2.191825,
								14.246418
							],
							[
								-2.967694,
								13.79815
							],
							[
								-3.103707,
								13.541267
							],
							[
								-3.522803,
								13.337662
							],
							[
								-4.006391,
								13.472485
							],
							[
								-4.280405,
								13.228444
							],
							[
								-4.427166,
								12.542646
							],
							[
								-5.220942,
								11.713859
							],
							[
								-5.197843,
								11.375146
							],
							[
								-5.470565,
								10.95127
							],
							[
								-5.404342,
								10.370737
							],
							[
								-5.816926,
								10.222555
							],
							[
								-6.050452,
								10.096361
							],
							[
								-6.205223,
								10.524061
							],
							[
								-6.493965,
								10.411303
							],
							[
								-6.666461,
								10.430811
							],
							[
								-6.850507,
								10.138994
							],
							[
								-7.622759,
								10.147236
							],
							[
								-7.89959,
								10.297382
							],
							[
								-8.029944,
								10.206535
							],
							[
								-8.335377,
								10.494812
							],
							[
								-8.282357,
								10.792597
							],
							[
								-8.407311,
								10.909257
							],
							[
								-8.620321,
								10.810891
							],
							[
								-8.581305,
								11.136246
							],
							[
								-8.376305,
								11.393646
							],
							[
								-8.786099,
								11.812561
							],
							[
								-8.905265,
								12.088358
							],
							[
								-9.127474,
								12.30806
							],
							[
								-9.327616,
								12.334286
							],
							[
								-9.567912,
								12.194243
							],
							[
								-9.890993,
								12.060479
							],
							[
								-10.165214,
								11.844084
							],
							[
								-10.593224,
								11.923975
							],
							[
								-10.87083,
								12.177887
							],
							[
								-11.036556,
								12.211245
							],
							[
								-11.297574,
								12.077971
							],
							[
								-11.456169,
								12.076834
							],
							[
								-11.513943,
								12.442988
							],
							[
								-11.467899,
								12.754519
							],
							[
								-11.553398,
								13.141214
							],
							[
								-11.927716,
								13.422075
							],
							[
								-12.124887,
								13.994727
							],
							[
								-12.17075,
								14.616834
							]
						]
					]
				},
				"id": "MLI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Myanmar"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								99.543309,
								20.186598
							],
							[
								98.959676,
								19.752981
							],
							[
								98.253724,
								19.708203
							],
							[
								97.797783,
								18.62708
							],
							[
								97.375896,
								18.445438
							],
							[
								97.859123,
								17.567946
							],
							[
								98.493761,
								16.837836
							],
							[
								98.903348,
								16.177824
							],
							[
								98.537376,
								15.308497
							],
							[
								98.192074,
								15.123703
							],
							[
								98.430819,
								14.622028
							],
							[
								99.097755,
								13.827503
							],
							[
								99.212012,
								13.269294
							],
							[
								99.196354,
								12.804748
							],
							[
								99.587286,
								11.892763
							],
							[
								99.038121,
								10.960546
							],
							[
								98.553551,
								9.93296
							],
							[
								98.457174,
								10.675266
							],
							[
								98.764546,
								11.441292
							],
							[
								98.428339,
								12.032987
							],
							[
								98.509574,
								13.122378
							],
							[
								98.103604,
								13.64046
							],
							[
								97.777732,
								14.837286
							],
							[
								97.597072,
								16.100568
							],
							[
								97.16454,
								16.928734
							],
							[
								96.505769,
								16.427241
							],
							[
								95.369352,
								15.71439
							],
							[
								94.808405,
								15.803454
							],
							[
								94.188804,
								16.037936
							],
							[
								94.533486,
								17.27724
							],
							[
								94.324817,
								18.213514
							],
							[
								93.540988,
								19.366493
							],
							[
								93.663255,
								19.726962
							],
							[
								93.078278,
								19.855145
							],
							[
								92.368554,
								20.670883
							],
							[
								92.303234,
								21.475485
							],
							[
								92.652257,
								21.324048
							],
							[
								92.672721,
								22.041239
							],
							[
								93.166128,
								22.27846
							],
							[
								93.060294,
								22.703111
							],
							[
								93.286327,
								23.043658
							],
							[
								93.325188,
								24.078556
							],
							[
								94.106742,
								23.850741
							],
							[
								94.552658,
								24.675238
							],
							[
								94.603249,
								25.162495
							],
							[
								95.155153,
								26.001307
							],
							[
								95.124768,
								26.573572
							],
							[
								96.419366,
								27.264589
							],
							[
								97.133999,
								27.083774
							],
							[
								97.051989,
								27.699059
							],
							[
								97.402561,
								27.882536
							],
							[
								97.327114,
								28.261583
							],
							[
								97.911988,
								28.335945
							],
							[
								98.246231,
								27.747221
							],
							[
								98.68269,
								27.508812
							],
							[
								98.712094,
								26.743536
							],
							[
								98.671838,
								25.918703
							],
							[
								97.724609,
								25.083637
							],
							[
								97.60472,
								23.897405
							],
							[
								98.660262,
								24.063286
							],
							[
								98.898749,
								23.142722
							],
							[
								99.531992,
								22.949039
							],
							[
								99.240899,
								22.118314
							],
							[
								99.983489,
								21.742937
							],
							[
								100.416538,
								21.558839
							],
							[
								101.150033,
								21.849984
							],
							[
								101.180005,
								21.436573
							],
							[
								100.329101,
								20.786122
							],
							[
								100.115988,
								20.41785
							],
							[
								99.543309,
								20.186598
							]
						]
					]
				},
				"id": "MMR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Montenegro"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								19.801613,
								42.500093
							],
							[
								19.738051,
								42.688247
							],
							[
								19.30449,
								42.19574
							],
							[
								19.37177,
								41.87755
							],
							[
								19.16246,
								41.95502
							],
							[
								18.88214,
								42.28151
							],
							[
								18.45,
								42.48
							],
							[
								18.56,
								42.65
							],
							[
								18.70648,
								43.20011
							],
							[
								19.03165,
								43.43253
							],
							[
								19.21852,
								43.52384
							],
							[
								19.48389,
								43.35229
							],
							[
								19.63,
								43.21378
							],
							[
								19.95857,
								43.10604
							],
							[
								20.3398,
								42.89852
							],
							[
								20.25758,
								42.81275
							],
							[
								20.0707,
								42.58863
							],
							[
								19.801613,
								42.500093
							]
						]
					]
				},
				"id": "MNE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Mongolia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								87.751264,
								49.297198
							],
							[
								88.805567,
								49.470521
							],
							[
								90.713667,
								50.331812
							],
							[
								92.234712,
								50.802171
							],
							[
								93.104219,
								50.49529
							],
							[
								94.147566,
								50.480537
							],
							[
								94.815949,
								50.013433
							],
							[
								95.814028,
								49.977467
							],
							[
								97.259728,
								49.726061
							],
							[
								98.231762,
								50.422401
							],
							[
								97.82574,
								51.010995
							],
							[
								98.861491,
								52.047366
							],
							[
								99.981732,
								51.634006
							],
							[
								100.88948,
								51.516856
							],
							[
								102.065223,
								51.259921
							],
							[
								102.255909,
								50.510561
							],
							[
								103.676545,
								50.089966
							],
							[
								104.621552,
								50.275329
							],
							[
								105.886591,
								50.406019
							],
							[
								106.888804,
								50.274296
							],
							[
								107.868176,
								49.793705
							],
							[
								108.475167,
								49.282548
							],
							[
								109.402449,
								49.292961
							],
							[
								110.662011,
								49.130128
							],
							[
								111.581231,
								49.377968
							],
							[
								112.89774,
								49.543565
							],
							[
								114.362456,
								50.248303
							],
							[
								114.96211,
								50.140247
							],
							[
								115.485695,
								49.805177
							],
							[
								116.678801,
								49.888531
							],
							[
								116.191802,
								49.134598
							],
							[
								115.485282,
								48.135383
							],
							[
								115.742837,
								47.726545
							],
							[
								116.308953,
								47.85341
							],
							[
								117.295507,
								47.697709
							],
							[
								118.064143,
								48.06673
							],
							[
								118.866574,
								47.74706
							],
							[
								119.772824,
								47.048059
							],
							[
								119.66327,
								46.69268
							],
							[
								118.874326,
								46.805412
							],
							[
								117.421701,
								46.672733
							],
							[
								116.717868,
								46.388202
							],
							[
								115.985096,
								45.727235
							],
							[
								114.460332,
								45.339817
							],
							[
								113.463907,
								44.808893
							],
							[
								112.436062,
								45.011646
							],
							[
								111.873306,
								45.102079
							],
							[
								111.348377,
								44.457442
							],
							[
								111.667737,
								44.073176
							],
							[
								111.829588,
								43.743118
							],
							[
								111.129682,
								43.406834
							],
							[
								110.412103,
								42.871234
							],
							[
								109.243596,
								42.519446
							],
							[
								107.744773,
								42.481516
							],
							[
								106.129316,
								42.134328
							],
							[
								104.964994,
								41.59741
							],
							[
								104.522282,
								41.908347
							],
							[
								103.312278,
								41.907468
							],
							[
								101.83304,
								42.514873
							],
							[
								100.845866,
								42.663804
							],
							[
								99.515817,
								42.524691
							],
							[
								97.451757,
								42.74889
							],
							[
								96.349396,
								42.725635
							],
							[
								95.762455,
								43.319449
							],
							[
								95.306875,
								44.241331
							],
							[
								94.688929,
								44.352332
							],
							[
								93.480734,
								44.975472
							],
							[
								92.133891,
								45.115076
							],
							[
								90.94554,
								45.286073
							],
							[
								90.585768,
								45.719716
							],
							[
								90.970809,
								46.888146
							],
							[
								90.280826,
								47.693549
							],
							[
								88.854298,
								48.069082
							],
							[
								88.013832,
								48.599463
							],
							[
								87.751264,
								49.297198
							]
						]
					]
				},
				"id": "MNG"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Mozambique"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								34.559989,
								-11.52002
							],
							[
								35.312398,
								-11.439146
							],
							[
								36.514082,
								-11.720938
							],
							[
								36.775151,
								-11.594537
							],
							[
								37.471284,
								-11.568751
							],
							[
								37.827645,
								-11.268769
							],
							[
								38.427557,
								-11.285202
							],
							[
								39.52103,
								-10.896854
							],
							[
								40.316589,
								-10.317096
							],
							[
								40.478387,
								-10.765441
							],
							[
								40.437253,
								-11.761711
							],
							[
								40.560811,
								-12.639177
							],
							[
								40.59962,
								-14.201975
							],
							[
								40.775475,
								-14.691764
							],
							[
								40.477251,
								-15.406294
							],
							[
								40.089264,
								-16.100774
							],
							[
								39.452559,
								-16.720891
							],
							[
								38.538351,
								-17.101023
							],
							[
								37.411133,
								-17.586368
							],
							[
								36.281279,
								-18.659688
							],
							[
								35.896497,
								-18.84226
							],
							[
								35.1984,
								-19.552811
							],
							[
								34.786383,
								-19.784012
							],
							[
								34.701893,
								-20.497043
							],
							[
								35.176127,
								-21.254361
							],
							[
								35.373428,
								-21.840837
							],
							[
								35.385848,
								-22.14
							],
							[
								35.562546,
								-22.09
							],
							[
								35.533935,
								-23.070788
							],
							[
								35.371774,
								-23.535359
							],
							[
								35.60747,
								-23.706563
							],
							[
								35.458746,
								-24.12261
							],
							[
								35.040735,
								-24.478351
							],
							[
								34.215824,
								-24.816314
							],
							[
								33.01321,
								-25.357573
							],
							[
								32.574632,
								-25.727318
							],
							[
								32.660363,
								-26.148584
							],
							[
								32.915955,
								-26.215867
							],
							[
								32.83012,
								-26.742192
							],
							[
								32.071665,
								-26.73382
							],
							[
								31.985779,
								-26.29178
							],
							[
								31.837778,
								-25.843332
							],
							[
								31.752408,
								-25.484284
							],
							[
								31.930589,
								-24.369417
							],
							[
								31.670398,
								-23.658969
							],
							[
								31.191409,
								-22.25151
							],
							[
								32.244988,
								-21.116489
							],
							[
								32.508693,
								-20.395292
							],
							[
								32.659743,
								-20.30429
							],
							[
								32.772708,
								-19.715592
							],
							[
								32.611994,
								-19.419383
							],
							[
								32.654886,
								-18.67209
							],
							[
								32.849861,
								-17.979057
							],
							[
								32.847639,
								-16.713398
							],
							[
								32.328239,
								-16.392074
							],
							[
								31.852041,
								-16.319417
							],
							[
								31.636498,
								-16.07199
							],
							[
								31.173064,
								-15.860944
							],
							[
								30.338955,
								-15.880839
							],
							[
								30.274256,
								-15.507787
							],
							[
								30.179481,
								-14.796099
							],
							[
								33.214025,
								-13.97186
							],
							[
								33.7897,
								-14.451831
							],
							[
								34.064825,
								-14.35995
							],
							[
								34.459633,
								-14.61301
							],
							[
								34.517666,
								-15.013709
							],
							[
								34.307291,
								-15.478641
							],
							[
								34.381292,
								-16.18356
							],
							[
								35.03381,
								-16.8013
							],
							[
								35.339063,
								-16.10744
							],
							[
								35.771905,
								-15.896859
							],
							[
								35.686845,
								-14.611046
							],
							[
								35.267956,
								-13.887834
							],
							[
								34.907151,
								-13.565425
							],
							[
								34.559989,
								-13.579998
							],
							[
								34.280006,
								-12.280025
							],
							[
								34.559989,
								-11.52002
							]
						]
					]
				},
				"id": "MOZ"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Mauritania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-12.17075,
								14.616834
							],
							[
								-12.830658,
								15.303692
							],
							[
								-13.435738,
								16.039383
							],
							[
								-14.099521,
								16.304302
							],
							[
								-14.577348,
								16.598264
							],
							[
								-15.135737,
								16.587282
							],
							[
								-15.623666,
								16.369337
							],
							[
								-16.12069,
								16.455663
							],
							[
								-16.463098,
								16.135036
							],
							[
								-16.549708,
								16.673892
							],
							[
								-16.270552,
								17.166963
							],
							[
								-16.146347,
								18.108482
							],
							[
								-16.256883,
								19.096716
							],
							[
								-16.377651,
								19.593817
							],
							[
								-16.277838,
								20.092521
							],
							[
								-16.536324,
								20.567866
							],
							[
								-17.063423,
								20.999752
							],
							[
								-16.845194,
								21.333323
							],
							[
								-12.929102,
								21.327071
							],
							[
								-13.118754,
								22.77122
							],
							[
								-12.874222,
								23.284832
							],
							[
								-11.937224,
								23.374594
							],
							[
								-11.969419,
								25.933353
							],
							[
								-8.687294,
								25.881056
							],
							[
								-8.6844,
								27.395744
							],
							[
								-4.923337,
								24.974574
							],
							[
								-6.453787,
								24.956591
							],
							[
								-5.971129,
								20.640833
							],
							[
								-5.488523,
								16.325102
							],
							[
								-5.315277,
								16.201854
							],
							[
								-5.537744,
								15.50169
							],
							[
								-9.550238,
								15.486497
							],
							[
								-9.700255,
								15.264107
							],
							[
								-10.086846,
								15.330486
							],
							[
								-10.650791,
								15.132746
							],
							[
								-11.349095,
								15.411256
							],
							[
								-11.666078,
								15.388208
							],
							[
								-11.834208,
								14.799097
							],
							[
								-12.17075,
								14.616834
							]
						]
					]
				},
				"id": "MRT"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Malawi"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								34.559989,
								-11.52002
							],
							[
								34.280006,
								-12.280025
							],
							[
								34.559989,
								-13.579998
							],
							[
								34.907151,
								-13.565425
							],
							[
								35.267956,
								-13.887834
							],
							[
								35.686845,
								-14.611046
							],
							[
								35.771905,
								-15.896859
							],
							[
								35.339063,
								-16.10744
							],
							[
								35.03381,
								-16.8013
							],
							[
								34.381292,
								-16.18356
							],
							[
								34.307291,
								-15.478641
							],
							[
								34.517666,
								-15.013709
							],
							[
								34.459633,
								-14.61301
							],
							[
								34.064825,
								-14.35995
							],
							[
								33.7897,
								-14.451831
							],
							[
								33.214025,
								-13.97186
							],
							[
								32.688165,
								-13.712858
							],
							[
								32.991764,
								-12.783871
							],
							[
								33.306422,
								-12.435778
							],
							[
								33.114289,
								-11.607198
							],
							[
								33.31531,
								-10.79655
							],
							[
								33.485688,
								-10.525559
							],
							[
								33.231388,
								-9.676722
							],
							[
								32.759375,
								-9.230599
							],
							[
								33.739729,
								-9.417151
							],
							[
								33.940838,
								-9.693674
							],
							[
								34.280006,
								-10.16
							],
							[
								34.559989,
								-11.52002
							]
						]
					]
				},
				"id": "MWI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Malaysia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									101.075516,
									6.204867
								],
								[
									101.154219,
									5.691384
								],
								[
									101.814282,
									5.810808
								],
								[
									102.141187,
									6.221636
								],
								[
									102.371147,
									6.128205
								],
								[
									102.961705,
									5.524495
								],
								[
									103.381215,
									4.855001
								],
								[
									103.438575,
									4.181606
								],
								[
									103.332122,
									3.726698
								],
								[
									103.429429,
									3.382869
								],
								[
									103.502448,
									2.791019
								],
								[
									103.854674,
									2.515454
								],
								[
									104.247932,
									1.631141
								],
								[
									104.228811,
									1.293048
								],
								[
									103.519707,
									1.226334
								],
								[
									102.573615,
									1.967115
								],
								[
									101.390638,
									2.760814
								],
								[
									101.27354,
									3.270292
								],
								[
									100.695435,
									3.93914
								],
								[
									100.557408,
									4.76728
								],
								[
									100.196706,
									5.312493
								],
								[
									100.30626,
									6.040562
								],
								[
									100.085757,
									6.464489
								],
								[
									100.259596,
									6.642825
								],
								[
									101.075516,
									6.204867
								]
							]
						],
						[
							[
								[
									118.618321,
									4.478202
								],
								[
									117.882035,
									4.137551
								],
								[
									117.015214,
									4.306094
								],
								[
									115.865517,
									4.306559
								],
								[
									115.519078,
									3.169238
								],
								[
									115.134037,
									2.821482
								],
								[
									114.621355,
									1.430688
								],
								[
									113.80585,
									1.217549
								],
								[
									112.859809,
									1.49779
								],
								[
									112.380252,
									1.410121
								],
								[
									111.797548,
									0.904441
								],
								[
									111.159138,
									0.976478
								],
								[
									110.514061,
									0.773131
								],
								[
									109.830227,
									1.338136
								],
								[
									109.66326,
									2.006467
								],
								[
									110.396135,
									1.663775
								],
								[
									111.168853,
									1.850637
								],
								[
									111.370081,
									2.697303
								],
								[
									111.796928,
									2.885897
								],
								[
									112.995615,
									3.102395
								],
								[
									113.712935,
									3.893509
								],
								[
									114.204017,
									4.525874
								],
								[
									114.659596,
									4.007637
								],
								[
									114.869557,
									4.348314
								],
								[
									115.347461,
									4.316636
								],
								[
									115.4057,
									4.955228
								],
								[
									115.45071,
									5.44773
								],
								[
									116.220741,
									6.143191
								],
								[
									116.725103,
									6.924771
								],
								[
									117.129626,
									6.928053
								],
								[
									117.643393,
									6.422166
								],
								[
									117.689075,
									5.98749
								],
								[
									118.347691,
									5.708696
								],
								[
									119.181904,
									5.407836
								],
								[
									119.110694,
									5.016128
								],
								[
									118.439727,
									4.966519
								],
								[
									118.618321,
									4.478202
								]
							]
						]
					]
				},
				"id": "MYS"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Namibia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.344977,
								-28.576705
							],
							[
								15.601818,
								-27.821247
							],
							[
								15.210472,
								-27.090956
							],
							[
								14.989711,
								-26.117372
							],
							[
								14.743214,
								-25.39292
							],
							[
								14.408144,
								-23.853014
							],
							[
								14.385717,
								-22.656653
							],
							[
								14.257714,
								-22.111208
							],
							[
								13.868642,
								-21.699037
							],
							[
								13.352498,
								-20.872834
							],
							[
								12.826845,
								-19.673166
							],
							[
								12.608564,
								-19.045349
							],
							[
								11.794919,
								-18.069129
							],
							[
								11.734199,
								-17.301889
							],
							[
								12.215461,
								-17.111668
							],
							[
								12.814081,
								-16.941343
							],
							[
								13.462362,
								-16.971212
							],
							[
								14.058501,
								-17.423381
							],
							[
								14.209707,
								-17.353101
							],
							[
								18.263309,
								-17.309951
							],
							[
								18.956187,
								-17.789095
							],
							[
								21.377176,
								-17.930636
							],
							[
								23.215048,
								-17.523116
							],
							[
								24.033862,
								-17.295843
							],
							[
								24.682349,
								-17.353411
							],
							[
								25.07695,
								-17.578823
							],
							[
								25.084443,
								-17.661816
							],
							[
								24.520705,
								-17.887125
							],
							[
								24.217365,
								-17.889347
							],
							[
								23.579006,
								-18.281261
							],
							[
								23.196858,
								-17.869038
							],
							[
								21.65504,
								-18.219146
							],
							[
								20.910641,
								-18.252219
							],
							[
								20.881134,
								-21.814327
							],
							[
								19.895458,
								-21.849157
							],
							[
								19.895768,
								-24.76779
							],
							[
								19.894734,
								-28.461105
							],
							[
								19.002127,
								-28.972443
							],
							[
								18.464899,
								-29.045462
							],
							[
								17.836152,
								-28.856378
							],
							[
								17.387497,
								-28.783514
							],
							[
								17.218929,
								-28.355943
							],
							[
								16.824017,
								-28.082162
							],
							[
								16.344977,
								-28.576705
							]
						]
					]
				},
				"id": "NAM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "New Caledonia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								165.77999,
								-21.080005
							],
							[
								166.599991,
								-21.700019
							],
							[
								167.120011,
								-22.159991
							],
							[
								166.740035,
								-22.399976
							],
							[
								166.189732,
								-22.129708
							],
							[
								165.474375,
								-21.679607
							],
							[
								164.829815,
								-21.14982
							],
							[
								164.167995,
								-20.444747
							],
							[
								164.029606,
								-20.105646
							],
							[
								164.459967,
								-20.120012
							],
							[
								165.020036,
								-20.459991
							],
							[
								165.460009,
								-20.800022
							],
							[
								165.77999,
								-21.080005
							]
						]
					]
				},
				"id": "NCL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Niger"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2.154474,
								11.94015
							],
							[
								2.177108,
								12.625018
							],
							[
								1.024103,
								12.851826
							],
							[
								0.993046,
								13.33575
							],
							[
								0.429928,
								13.988733
							],
							[
								0.295646,
								14.444235
							],
							[
								0.374892,
								14.928908
							],
							[
								1.015783,
								14.968182
							],
							[
								1.385528,
								15.323561
							],
							[
								2.749993,
								15.409525
							],
							[
								3.638259,
								15.56812
							],
							[
								3.723422,
								16.184284
							],
							[
								4.27021,
								16.852227
							],
							[
								4.267419,
								19.155265
							],
							[
								5.677566,
								19.601207
							],
							[
								8.572893,
								21.565661
							],
							[
								11.999506,
								23.471668
							],
							[
								13.581425,
								23.040506
							],
							[
								14.143871,
								22.491289
							],
							[
								14.8513,
								22.86295
							],
							[
								15.096888,
								21.308519
							],
							[
								15.471077,
								21.048457
							],
							[
								15.487148,
								20.730415
							],
							[
								15.903247,
								20.387619
							],
							[
								15.685741,
								19.95718
							],
							[
								15.300441,
								17.92795
							],
							[
								15.247731,
								16.627306
							],
							[
								13.972202,
								15.684366
							],
							[
								13.540394,
								14.367134
							],
							[
								13.956699,
								13.996691
							],
							[
								13.954477,
								13.353449
							],
							[
								14.595781,
								13.330427
							],
							[
								14.495787,
								12.859396
							],
							[
								14.213531,
								12.802035
							],
							[
								14.181336,
								12.483657
							],
							[
								13.995353,
								12.461565
							],
							[
								13.318702,
								13.556356
							],
							[
								13.083987,
								13.596147
							],
							[
								12.302071,
								13.037189
							],
							[
								11.527803,
								13.32898
							],
							[
								10.989593,
								13.387323
							],
							[
								10.701032,
								13.246918
							],
							[
								10.114814,
								13.277252
							],
							[
								9.524928,
								12.851102
							],
							[
								9.014933,
								12.826659
							],
							[
								7.804671,
								13.343527
							],
							[
								7.330747,
								13.098038
							],
							[
								6.820442,
								13.115091
							],
							[
								6.445426,
								13.492768
							],
							[
								5.443058,
								13.865924
							],
							[
								4.368344,
								13.747482
							],
							[
								4.107946,
								13.531216
							],
							[
								3.967283,
								12.956109
							],
							[
								3.680634,
								12.552903
							],
							[
								3.61118,
								11.660167
							],
							[
								2.848643,
								12.235636
							],
							[
								2.490164,
								12.233052
							],
							[
								2.154474,
								11.94015
							]
						]
					]
				},
				"id": "NER"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Nigeria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8.500288,
								4.771983
							],
							[
								7.462108,
								4.412108
							],
							[
								7.082596,
								4.464689
							],
							[
								6.698072,
								4.240594
							],
							[
								5.898173,
								4.262453
							],
							[
								5.362805,
								4.887971
							],
							[
								5.033574,
								5.611802
							],
							[
								4.325607,
								6.270651
							],
							[
								3.57418,
								6.2583
							],
							[
								2.691702,
								6.258817
							],
							[
								2.749063,
								7.870734
							],
							[
								2.723793,
								8.506845
							],
							[
								2.912308,
								9.137608
							],
							[
								3.220352,
								9.444153
							],
							[
								3.705438,
								10.06321
							],
							[
								3.60007,
								10.332186
							],
							[
								3.797112,
								10.734746
							],
							[
								3.572216,
								11.327939
							],
							[
								3.61118,
								11.660167
							],
							[
								3.680634,
								12.552903
							],
							[
								3.967283,
								12.956109
							],
							[
								4.107946,
								13.531216
							],
							[
								4.368344,
								13.747482
							],
							[
								5.443058,
								13.865924
							],
							[
								6.445426,
								13.492768
							],
							[
								6.820442,
								13.115091
							],
							[
								7.330747,
								13.098038
							],
							[
								7.804671,
								13.343527
							],
							[
								9.014933,
								12.826659
							],
							[
								9.524928,
								12.851102
							],
							[
								10.114814,
								13.277252
							],
							[
								10.701032,
								13.246918
							],
							[
								10.989593,
								13.387323
							],
							[
								11.527803,
								13.32898
							],
							[
								12.302071,
								13.037189
							],
							[
								13.083987,
								13.596147
							],
							[
								13.318702,
								13.556356
							],
							[
								13.995353,
								12.461565
							],
							[
								14.181336,
								12.483657
							],
							[
								14.577178,
								12.085361
							],
							[
								14.468192,
								11.904752
							],
							[
								14.415379,
								11.572369
							],
							[
								13.57295,
								10.798566
							],
							[
								13.308676,
								10.160362
							],
							[
								13.1676,
								9.640626
							],
							[
								12.955468,
								9.417772
							],
							[
								12.753672,
								8.717763
							],
							[
								12.218872,
								8.305824
							],
							[
								12.063946,
								7.799808
							],
							[
								11.839309,
								7.397042
							],
							[
								11.745774,
								6.981383
							],
							[
								11.058788,
								6.644427
							],
							[
								10.497375,
								7.055358
							],
							[
								10.118277,
								7.03877
							],
							[
								9.522706,
								6.453482
							],
							[
								9.233163,
								6.444491
							],
							[
								8.757533,
								5.479666
							],
							[
								8.500288,
								4.771983
							]
						]
					]
				},
				"id": "NGA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Nicaragua"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-85.71254,
								11.088445
							],
							[
								-86.058488,
								11.403439
							],
							[
								-86.52585,
								11.806877
							],
							[
								-86.745992,
								12.143962
							],
							[
								-87.167516,
								12.458258
							],
							[
								-87.668493,
								12.90991
							],
							[
								-87.557467,
								13.064552
							],
							[
								-87.392386,
								12.914018
							],
							[
								-87.316654,
								12.984686
							],
							[
								-87.005769,
								13.025794
							],
							[
								-86.880557,
								13.254204
							],
							[
								-86.733822,
								13.263093
							],
							[
								-86.755087,
								13.754845
							],
							[
								-86.520708,
								13.778487
							],
							[
								-86.312142,
								13.771356
							],
							[
								-86.096264,
								14.038187
							],
							[
								-85.801295,
								13.836055
							],
							[
								-85.698665,
								13.960078
							],
							[
								-85.514413,
								14.079012
							],
							[
								-85.165365,
								14.35437
							],
							[
								-85.148751,
								14.560197
							],
							[
								-85.052787,
								14.551541
							],
							[
								-84.924501,
								14.790493
							],
							[
								-84.820037,
								14.819587
							],
							[
								-84.649582,
								14.666805
							],
							[
								-84.449336,
								14.621614
							],
							[
								-84.228342,
								14.748764
							],
							[
								-83.975721,
								14.749436
							],
							[
								-83.628585,
								14.880074
							],
							[
								-83.489989,
								15.016267
							],
							[
								-83.147219,
								14.995829
							],
							[
								-83.233234,
								14.899866
							],
							[
								-83.284162,
								14.676624
							],
							[
								-83.182126,
								14.310703
							],
							[
								-83.4125,
								13.970078
							],
							[
								-83.519832,
								13.567699
							],
							[
								-83.552207,
								13.127054
							],
							[
								-83.498515,
								12.869292
							],
							[
								-83.473323,
								12.419087
							],
							[
								-83.626104,
								12.32085
							],
							[
								-83.719613,
								11.893124
							],
							[
								-83.650858,
								11.629032
							],
							[
								-83.85547,
								11.373311
							],
							[
								-83.808936,
								11.103044
							],
							[
								-83.655612,
								10.938764
							],
							[
								-83.895054,
								10.726839
							],
							[
								-84.190179,
								10.79345
							],
							[
								-84.355931,
								10.999226
							],
							[
								-84.673069,
								11.082657
							],
							[
								-84.903003,
								10.952303
							],
							[
								-85.561852,
								11.217119
							],
							[
								-85.71254,
								11.088445
							]
						]
					]
				},
				"id": "NIC"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Netherlands"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6.074183,
								53.510403
							],
							[
								6.90514,
								53.482162
							],
							[
								7.092053,
								53.144043
							],
							[
								6.84287,
								52.22844
							],
							[
								6.589397,
								51.852029
							],
							[
								5.988658,
								51.851616
							],
							[
								6.156658,
								50.803721
							],
							[
								5.606976,
								51.037298
							],
							[
								4.973991,
								51.475024
							],
							[
								4.047071,
								51.267259
							],
							[
								3.314971,
								51.345755
							],
							[
								3.830289,
								51.620545
							],
							[
								4.705997,
								53.091798
							],
							[
								6.074183,
								53.510403
							]
						]
					]
				},
				"id": "NLD"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Norway"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									28.165547,
									71.185474
								],
								[
									31.293418,
									70.453788
								],
								[
									30.005435,
									70.186259
								],
								[
									31.101079,
									69.55808
								],
								[
									29.399581,
									69.156916
								],
								[
									28.59193,
									69.064777
								],
								[
									29.015573,
									69.766491
								],
								[
									27.732292,
									70.164193
								],
								[
									26.179622,
									69.825299
								],
								[
									25.689213,
									69.092114
								],
								[
									24.735679,
									68.649557
								],
								[
									23.66205,
									68.891247
								],
								[
									22.356238,
									68.841741
								],
								[
									21.244936,
									69.370443
								],
								[
									20.645593,
									69.106247
								],
								[
									20.025269,
									69.065139
								],
								[
									19.87856,
									68.407194
								],
								[
									17.993868,
									68.567391
								],
								[
									17.729182,
									68.010552
								],
								[
									16.768879,
									68.013937
								],
								[
									16.108712,
									67.302456
								],
								[
									15.108411,
									66.193867
								],
								[
									13.55569,
									64.787028
								],
								[
									13.919905,
									64.445421
								],
								[
									13.571916,
									64.049114
								],
								[
									12.579935,
									64.066219
								],
								[
									11.930569,
									63.128318
								],
								[
									11.992064,
									61.800362
								],
								[
									12.631147,
									61.293572
								],
								[
									12.300366,
									60.117933
								],
								[
									11.468272,
									59.432393
								],
								[
									11.027369,
									58.856149
								],
								[
									10.356557,
									59.469807
								],
								[
									8.382,
									58.313288
								],
								[
									7.048748,
									58.078884
								],
								[
									5.665835,
									58.588155
								],
								[
									5.308234,
									59.663232
								],
								[
									4.992078,
									61.970998
								],
								[
									5.9129,
									62.614473
								],
								[
									8.553411,
									63.454008
								],
								[
									10.527709,
									64.486038
								],
								[
									12.358347,
									65.879726
								],
								[
									14.761146,
									67.810642
								],
								[
									16.435927,
									68.563205
								],
								[
									19.184028,
									69.817444
								],
								[
									21.378416,
									70.255169
								],
								[
									23.023742,
									70.202072
								],
								[
									24.546543,
									71.030497
								],
								[
									26.37005,
									70.986262
								],
								[
									28.165547,
									71.185474
								]
							]
						],
						[
							[
								[
									24.72412,
									77.85385
								],
								[
									22.49032,
									77.44493
								],
								[
									20.72601,
									77.67704
								],
								[
									21.41611,
									77.93504
								],
								[
									20.8119,
									78.25463
								],
								[
									22.88426,
									78.45494
								],
								[
									23.28134,
									78.07954
								],
								[
									24.72412,
									77.85385
								]
							]
						],
						[
							[
								[
									18.25183,
									79.70175
								],
								[
									21.54383,
									78.95611
								],
								[
									19.02737,
									78.5626
								],
								[
									18.47172,
									77.82669
								],
								[
									17.59441,
									77.63796
								],
								[
									17.1182,
									76.80941
								],
								[
									15.91315,
									76.77045
								],
								[
									13.76259,
									77.38035
								],
								[
									14.66956,
									77.73565
								],
								[
									13.1706,
									78.02493
								],
								[
									11.22231,
									78.8693
								],
								[
									10.44453,
									79.65239
								],
								[
									13.17077,
									80.01046
								],
								[
									13.71852,
									79.66039
								],
								[
									15.14282,
									79.67431
								],
								[
									15.52255,
									80.01608
								],
								[
									16.99085,
									80.05086
								],
								[
									18.25183,
									79.70175
								]
							]
						],
						[
							[
								[
									25.447625,
									80.40734
								],
								[
									27.407506,
									80.056406
								],
								[
									25.924651,
									79.517834
								],
								[
									23.024466,
									79.400012
								],
								[
									20.075188,
									79.566823
								],
								[
									19.897266,
									79.842362
								],
								[
									18.462264,
									79.85988
								],
								[
									17.368015,
									80.318896
								],
								[
									20.455992,
									80.598156
								],
								[
									21.907945,
									80.357679
								],
								[
									22.919253,
									80.657144
								],
								[
									25.447625,
									80.40734
								]
							]
						]
					]
				},
				"id": "NOR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Nepal"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								88.120441,
								27.876542
							],
							[
								88.043133,
								27.445819
							],
							[
								88.174804,
								26.810405
							],
							[
								88.060238,
								26.414615
							],
							[
								87.227472,
								26.397898
							],
							[
								86.024393,
								26.630985
							],
							[
								85.251779,
								26.726198
							],
							[
								84.675018,
								27.234901
							],
							[
								83.304249,
								27.364506
							],
							[
								81.999987,
								27.925479
							],
							[
								81.057203,
								28.416095
							],
							[
								80.088425,
								28.79447
							],
							[
								80.476721,
								29.729865
							],
							[
								81.111256,
								30.183481
							],
							[
								81.525804,
								30.422717
							],
							[
								82.327513,
								30.115268
							],
							[
								83.337115,
								29.463732
							],
							[
								83.898993,
								29.320226
							],
							[
								84.23458,
								28.839894
							],
							[
								85.011638,
								28.642774
							],
							[
								85.82332,
								28.203576
							],
							[
								86.954517,
								27.974262
							],
							[
								88.120441,
								27.876542
							]
						]
					]
				},
				"id": "NPL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "New Zealand"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									173.020375,
									-40.919052
								],
								[
									173.247234,
									-41.331999
								],
								[
									173.958405,
									-40.926701
								],
								[
									174.247587,
									-41.349155
								],
								[
									174.248517,
									-41.770008
								],
								[
									173.876447,
									-42.233184
								],
								[
									173.22274,
									-42.970038
								],
								[
									172.711246,
									-43.372288
								],
								[
									173.080113,
									-43.853344
								],
								[
									172.308584,
									-43.865694
								],
								[
									171.452925,
									-44.242519
								],
								[
									171.185138,
									-44.897104
								],
								[
									170.616697,
									-45.908929
								],
								[
									169.831422,
									-46.355775
								],
								[
									169.332331,
									-46.641235
								],
								[
									168.411354,
									-46.619945
								],
								[
									167.763745,
									-46.290197
								],
								[
									166.676886,
									-46.219917
								],
								[
									166.509144,
									-45.852705
								],
								[
									167.046424,
									-45.110941
								],
								[
									168.303763,
									-44.123973
								],
								[
									168.949409,
									-43.935819
								],
								[
									169.667815,
									-43.555326
								],
								[
									170.52492,
									-43.031688
								],
								[
									171.12509,
									-42.512754
								],
								[
									171.569714,
									-41.767424
								],
								[
									171.948709,
									-41.514417
								],
								[
									172.097227,
									-40.956104
								],
								[
									172.79858,
									-40.493962
								],
								[
									173.020375,
									-40.919052
								]
							]
						],
						[
							[
								[
									174.612009,
									-36.156397
								],
								[
									175.336616,
									-37.209098
								],
								[
									175.357596,
									-36.526194
								],
								[
									175.808887,
									-36.798942
								],
								[
									175.95849,
									-37.555382
								],
								[
									176.763195,
									-37.881253
								],
								[
									177.438813,
									-37.961248
								],
								[
									178.010354,
									-37.579825
								],
								[
									178.517094,
									-37.695373
								],
								[
									178.274731,
									-38.582813
								],
								[
									177.97046,
									-39.166343
								],
								[
									177.206993,
									-39.145776
								],
								[
									176.939981,
									-39.449736
								],
								[
									177.032946,
									-39.879943
								],
								[
									176.885824,
									-40.065978
								],
								[
									176.508017,
									-40.604808
								],
								[
									176.01244,
									-41.289624
								],
								[
									175.239567,
									-41.688308
								],
								[
									175.067898,
									-41.425895
								],
								[
									174.650973,
									-41.281821
								],
								[
									175.22763,
									-40.459236
								],
								[
									174.900157,
									-39.908933
								],
								[
									173.824047,
									-39.508854
								],
								[
									173.852262,
									-39.146602
								],
								[
									174.574802,
									-38.797683
								],
								[
									174.743474,
									-38.027808
								],
								[
									174.697017,
									-37.381129
								],
								[
									174.292028,
									-36.711092
								],
								[
									174.319004,
									-36.534824
								],
								[
									173.840997,
									-36.121981
								],
								[
									173.054171,
									-35.237125
								],
								[
									172.636005,
									-34.529107
								],
								[
									173.007042,
									-34.450662
								],
								[
									173.551298,
									-35.006183
								],
								[
									174.32939,
									-35.265496
								],
								[
									174.612009,
									-36.156397
								]
							]
						]
					]
				},
				"id": "NZL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Oman"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									58.861141,
									21.114035
								],
								[
									58.487986,
									20.428986
								],
								[
									58.034318,
									20.481437
								],
								[
									57.826373,
									20.243002
								],
								[
									57.665762,
									19.736005
								],
								[
									57.7887,
									19.06757
								],
								[
									57.694391,
									18.94471
								],
								[
									57.234264,
									18.947991
								],
								[
									56.609651,
									18.574267
								],
								[
									56.512189,
									18.087113
								],
								[
									56.283521,
									17.876067
								],
								[
									55.661492,
									17.884128
								],
								[
									55.269939,
									17.632309
								],
								[
									55.2749,
									17.228354
								],
								[
									54.791002,
									16.950697
								],
								[
									54.239253,
									17.044981
								],
								[
									53.570508,
									16.707663
								],
								[
									53.108573,
									16.651051
								],
								[
									52.782184,
									17.349742
								],
								[
									52.00001,
									19.000003
								],
								[
									54.999982,
									19.999994
								],
								[
									55.666659,
									22.000001
								],
								[
									55.208341,
									22.70833
								],
								[
									55.234489,
									23.110993
								],
								[
									55.525841,
									23.524869
								],
								[
									55.528632,
									23.933604
								],
								[
									55.981214,
									24.130543
								],
								[
									55.804119,
									24.269604
								],
								[
									55.886233,
									24.920831
								],
								[
									56.396847,
									24.924732
								],
								[
									56.84514,
									24.241673
								],
								[
									57.403453,
									23.878594
								],
								[
									58.136948,
									23.747931
								],
								[
									58.729211,
									23.565668
								],
								[
									59.180502,
									22.992395
								],
								[
									59.450098,
									22.660271
								],
								[
									59.80806,
									22.533612
								],
								[
									59.806148,
									22.310525
								],
								[
									59.442191,
									21.714541
								],
								[
									59.282408,
									21.433886
								],
								[
									58.861141,
									21.114035
								]
							]
						],
						[
							[
								[
									56.391421,
									25.895991
								],
								[
									56.261042,
									25.714606
								],
								[
									56.070821,
									26.055464
								],
								[
									56.362017,
									26.395934
								],
								[
									56.485679,
									26.309118
								],
								[
									56.391421,
									25.895991
								]
							]
						]
					]
				},
				"id": "OMN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Pakistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								75.158028,
								37.133031
							],
							[
								75.896897,
								36.666806
							],
							[
								76.192848,
								35.898403
							],
							[
								77.837451,
								35.49401
							],
							[
								76.871722,
								34.653544
							],
							[
								75.757061,
								34.504923
							],
							[
								74.240203,
								34.748887
							],
							[
								73.749948,
								34.317699
							],
							[
								74.104294,
								33.441473
							],
							[
								74.451559,
								32.7649
							],
							[
								75.258642,
								32.271105
							],
							[
								74.405929,
								31.692639
							],
							[
								74.42138,
								30.979815
							],
							[
								73.450638,
								29.976413
							],
							[
								72.823752,
								28.961592
							],
							[
								71.777666,
								27.91318
							],
							[
								70.616496,
								27.989196
							],
							[
								69.514393,
								26.940966
							],
							[
								70.168927,
								26.491872
							],
							[
								70.282873,
								25.722229
							],
							[
								70.844699,
								25.215102
							],
							[
								71.04324,
								24.356524
							],
							[
								68.842599,
								24.359134
							],
							[
								68.176645,
								23.691965
							],
							[
								67.443667,
								23.944844
							],
							[
								67.145442,
								24.663611
							],
							[
								66.372828,
								25.425141
							],
							[
								64.530408,
								25.237039
							],
							[
								62.905701,
								25.218409
							],
							[
								61.497363,
								25.078237
							],
							[
								61.874187,
								26.239975
							],
							[
								63.316632,
								26.756532
							],
							[
								63.233898,
								27.217047
							],
							[
								62.755426,
								27.378923
							],
							[
								62.72783,
								28.259645
							],
							[
								61.771868,
								28.699334
							],
							[
								61.369309,
								29.303276
							],
							[
								60.874248,
								29.829239
							],
							[
								62.549857,
								29.318572
							],
							[
								63.550261,
								29.468331
							],
							[
								64.148002,
								29.340819
							],
							[
								64.350419,
								29.560031
							],
							[
								65.046862,
								29.472181
							],
							[
								66.346473,
								29.887943
							],
							[
								66.381458,
								30.738899
							],
							[
								66.938891,
								31.304911
							],
							[
								67.683394,
								31.303154
							],
							[
								67.792689,
								31.58293
							],
							[
								68.556932,
								31.71331
							],
							[
								68.926677,
								31.620189
							],
							[
								69.317764,
								31.901412
							],
							[
								69.262522,
								32.501944
							],
							[
								69.687147,
								33.105499
							],
							[
								70.323594,
								33.358533
							],
							[
								69.930543,
								34.02012
							],
							[
								70.881803,
								33.988856
							],
							[
								71.156773,
								34.348911
							],
							[
								71.115019,
								34.733126
							],
							[
								71.613076,
								35.153203
							],
							[
								71.498768,
								35.650563
							],
							[
								71.262348,
								36.074388
							],
							[
								71.846292,
								36.509942
							],
							[
								72.920025,
								36.720007
							],
							[
								74.067552,
								36.836176
							],
							[
								74.575893,
								37.020841
							],
							[
								75.158028,
								37.133031
							]
						]
					]
				},
				"id": "PAK"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Panama"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-77.881571,
								7.223771
							],
							[
								-78.214936,
								7.512255
							],
							[
								-78.429161,
								8.052041
							],
							[
								-78.182096,
								8.319182
							],
							[
								-78.435465,
								8.387705
							],
							[
								-78.622121,
								8.718124
							],
							[
								-79.120307,
								8.996092
							],
							[
								-79.557877,
								8.932375
							],
							[
								-79.760578,
								8.584515
							],
							[
								-80.164481,
								8.333316
							],
							[
								-80.382659,
								8.298409
							],
							[
								-80.480689,
								8.090308
							],
							[
								-80.00369,
								7.547524
							],
							[
								-80.276671,
								7.419754
							],
							[
								-80.421158,
								7.271572
							],
							[
								-80.886401,
								7.220541
							],
							[
								-81.059543,
								7.817921
							],
							[
								-81.189716,
								7.647906
							],
							[
								-81.519515,
								7.70661
							],
							[
								-81.721311,
								8.108963
							],
							[
								-82.131441,
								8.175393
							],
							[
								-82.390934,
								8.292362
							],
							[
								-82.820081,
								8.290864
							],
							[
								-82.850958,
								8.073823
							],
							[
								-82.965783,
								8.225028
							],
							[
								-82.913176,
								8.423517
							],
							[
								-82.829771,
								8.626295
							],
							[
								-82.868657,
								8.807266
							],
							[
								-82.719183,
								8.925709
							],
							[
								-82.927155,
								9.07433
							],
							[
								-82.932891,
								9.476812
							],
							[
								-82.546196,
								9.566135
							],
							[
								-82.187123,
								9.207449
							],
							[
								-82.207586,
								8.995575
							],
							[
								-81.808567,
								8.950617
							],
							[
								-81.714154,
								9.031955
							],
							[
								-81.439287,
								8.786234
							],
							[
								-80.947302,
								8.858504
							],
							[
								-80.521901,
								9.111072
							],
							[
								-79.9146,
								9.312765
							],
							[
								-79.573303,
								9.61161
							],
							[
								-79.021192,
								9.552931
							],
							[
								-79.05845,
								9.454565
							],
							[
								-78.500888,
								9.420459
							],
							[
								-78.055928,
								9.24773
							],
							[
								-77.729514,
								8.946844
							],
							[
								-77.353361,
								8.670505
							],
							[
								-77.474723,
								8.524286
							],
							[
								-77.242566,
								7.935278
							],
							[
								-77.431108,
								7.638061
							],
							[
								-77.753414,
								7.70984
							],
							[
								-77.881571,
								7.223771
							]
						]
					]
				},
				"id": "PAN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Peru"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-69.590424,
								-17.580012
							],
							[
								-69.858444,
								-18.092694
							],
							[
								-70.372572,
								-18.347975
							],
							[
								-71.37525,
								-17.773799
							],
							[
								-71.462041,
								-17.363488
							],
							[
								-73.44453,
								-16.359363
							],
							[
								-75.237883,
								-15.265683
							],
							[
								-76.009205,
								-14.649286
							],
							[
								-76.423469,
								-13.823187
							],
							[
								-76.259242,
								-13.535039
							],
							[
								-77.106192,
								-12.222716
							],
							[
								-78.092153,
								-10.377712
							],
							[
								-79.036953,
								-8.386568
							],
							[
								-79.44592,
								-7.930833
							],
							[
								-79.760578,
								-7.194341
							],
							[
								-80.537482,
								-6.541668
							],
							[
								-81.249996,
								-6.136834
							],
							[
								-80.926347,
								-5.690557
							],
							[
								-81.410943,
								-4.736765
							],
							[
								-81.09967,
								-4.036394
							],
							[
								-80.302561,
								-3.404856
							],
							[
								-80.184015,
								-3.821162
							],
							[
								-80.469295,
								-4.059287
							],
							[
								-80.442242,
								-4.425724
							],
							[
								-80.028908,
								-4.346091
							],
							[
								-79.624979,
								-4.454198
							],
							[
								-79.205289,
								-4.959129
							],
							[
								-78.639897,
								-4.547784
							],
							[
								-78.450684,
								-3.873097
							],
							[
								-77.837905,
								-3.003021
							],
							[
								-76.635394,
								-2.608678
							],
							[
								-75.544996,
								-1.56161
							],
							[
								-75.233723,
								-0.911417
							],
							[
								-75.373223,
								-0.152032
							],
							[
								-75.106625,
								-0.057205
							],
							[
								-74.441601,
								-0.53082
							],
							[
								-74.122395,
								-1.002833
							],
							[
								-73.659504,
								-1.260491
							],
							[
								-73.070392,
								-2.308954
							],
							[
								-72.325787,
								-2.434218
							],
							[
								-71.774761,
								-2.16979
							],
							[
								-71.413646,
								-2.342802
							],
							[
								-70.813476,
								-2.256865
							],
							[
								-70.047709,
								-2.725156
							],
							[
								-70.692682,
								-3.742872
							],
							[
								-70.394044,
								-3.766591
							],
							[
								-69.893635,
								-4.298187
							],
							[
								-70.794769,
								-4.251265
							],
							[
								-70.928843,
								-4.401591
							],
							[
								-71.748406,
								-4.593983
							],
							[
								-72.891928,
								-5.274561
							],
							[
								-72.964507,
								-5.741251
							],
							[
								-73.219711,
								-6.089189
							],
							[
								-73.120027,
								-6.629931
							],
							[
								-73.724487,
								-6.918595
							],
							[
								-73.723401,
								-7.340999
							],
							[
								-73.987235,
								-7.52383
							],
							[
								-73.571059,
								-8.424447
							],
							[
								-73.015383,
								-9.032833
							],
							[
								-73.226713,
								-9.462213
							],
							[
								-72.563033,
								-9.520194
							],
							[
								-72.184891,
								-10.053598
							],
							[
								-71.302412,
								-10.079436
							],
							[
								-70.481894,
								-9.490118
							],
							[
								-70.548686,
								-11.009147
							],
							[
								-70.093752,
								-11.123972
							],
							[
								-69.529678,
								-10.951734
							],
							[
								-68.66508,
								-12.5613
							],
							[
								-68.88008,
								-12.899729
							],
							[
								-68.929224,
								-13.602684
							],
							[
								-68.948887,
								-14.453639
							],
							[
								-69.339535,
								-14.953195
							],
							[
								-69.160347,
								-15.323974
							],
							[
								-69.389764,
								-15.660129
							],
							[
								-68.959635,
								-16.500698
							],
							[
								-69.590424,
								-17.580012
							]
						]
					]
				},
				"id": "PER"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Philippines"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									126.376814,
									8.414706
								],
								[
									126.478513,
									7.750354
								],
								[
									126.537424,
									7.189381
								],
								[
									126.196773,
									6.274294
								],
								[
									125.831421,
									7.293715
								],
								[
									125.363852,
									6.786485
								],
								[
									125.683161,
									6.049657
								],
								[
									125.396512,
									5.581003
								],
								[
									124.219788,
									6.161355
								],
								[
									123.93872,
									6.885136
								],
								[
									124.243662,
									7.36061
								],
								[
									123.610212,
									7.833527
								],
								[
									123.296071,
									7.418876
								],
								[
									122.825506,
									7.457375
								],
								[
									122.085499,
									6.899424
								],
								[
									121.919928,
									7.192119
								],
								[
									122.312359,
									8.034962
								],
								[
									122.942398,
									8.316237
								],
								[
									123.487688,
									8.69301
								],
								[
									123.841154,
									8.240324
								],
								[
									124.60147,
									8.514158
								],
								[
									124.764612,
									8.960409
								],
								[
									125.471391,
									8.986997
								],
								[
									125.412118,
									9.760335
								],
								[
									126.222714,
									9.286074
								],
								[
									126.306637,
									8.782487
								],
								[
									126.376814,
									8.414706
								]
							]
						],
						[
							[
								[
									123.982438,
									10.278779
								],
								[
									123.623183,
									9.950091
								],
								[
									123.309921,
									9.318269
								],
								[
									122.995883,
									9.022189
								],
								[
									122.380055,
									9.713361
								],
								[
									122.586089,
									9.981045
								],
								[
									122.837081,
									10.261157
								],
								[
									122.947411,
									10.881868
								],
								[
									123.49885,
									10.940624
								],
								[
									123.337774,
									10.267384
								],
								[
									124.077936,
									11.232726
								],
								[
									123.982438,
									10.278779
								]
							]
						],
						[
							[
								[
									118.504581,
									9.316383
								],
								[
									117.174275,
									8.3675
								],
								[
									117.664477,
									9.066889
								],
								[
									118.386914,
									9.6845
								],
								[
									118.987342,
									10.376292
								],
								[
									119.511496,
									11.369668
								],
								[
									119.689677,
									10.554291
								],
								[
									119.029458,
									10.003653
								],
								[
									118.504581,
									9.316383
								]
							]
						],
						[
							[
								[
									121.883548,
									11.891755
								],
								[
									122.483821,
									11.582187
								],
								[
									123.120217,
									11.58366
								],
								[
									123.100838,
									11.165934
								],
								[
									122.637714,
									10.741308
								],
								[
									122.00261,
									10.441017
								],
								[
									121.967367,
									10.905691
								],
								[
									122.03837,
									11.415841
								],
								[
									121.883548,
									11.891755
								]
							]
						],
						[
							[
								[
									125.502552,
									12.162695
								],
								[
									125.783465,
									11.046122
								],
								[
									125.011884,
									11.311455
								],
								[
									125.032761,
									10.975816
								],
								[
									125.277449,
									10.358722
								],
								[
									124.801819,
									10.134679
								],
								[
									124.760168,
									10.837995
								],
								[
									124.459101,
									10.88993
								],
								[
									124.302522,
									11.495371
								],
								[
									124.891013,
									11.415583
								],
								[
									124.87799,
									11.79419
								],
								[
									124.266762,
									12.557761
								],
								[
									125.227116,
									12.535721
								],
								[
									125.502552,
									12.162695
								]
							]
						],
						[
							[
								[
									121.527394,
									13.06959
								],
								[
									121.26219,
									12.20556
								],
								[
									120.833896,
									12.704496
								],
								[
									120.323436,
									13.466413
								],
								[
									121.180128,
									13.429697
								],
								[
									121.527394,
									13.06959
								]
							]
						],
						[
							[
								[
									121.321308,
									18.504065
								],
								[
									121.937601,
									18.218552
								],
								[
									122.246006,
									18.47895
								],
								[
									122.336957,
									18.224883
								],
								[
									122.174279,
									17.810283
								],
								[
									122.515654,
									17.093505
								],
								[
									122.252311,
									16.262444
								],
								[
									121.662786,
									15.931018
								],
								[
									121.50507,
									15.124814
								],
								[
									121.728829,
									14.328376
								],
								[
									122.258925,
									14.218202
								],
								[
									122.701276,
									14.336541
								],
								[
									123.950295,
									13.782131
								],
								[
									123.855107,
									13.237771
								],
								[
									124.181289,
									12.997527
								],
								[
									124.077419,
									12.536677
								],
								[
									123.298035,
									13.027526
								],
								[
									122.928652,
									13.55292
								],
								[
									122.671355,
									13.185836
								],
								[
									122.03465,
									13.784482
								],
								[
									121.126385,
									13.636687
								],
								[
									120.628637,
									13.857656
								],
								[
									120.679384,
									14.271016
								],
								[
									120.991819,
									14.525393
								],
								[
									120.693336,
									14.756671
								],
								[
									120.564145,
									14.396279
								],
								[
									120.070429,
									14.970869
								],
								[
									119.920929,
									15.406347
								],
								[
									119.883773,
									16.363704
								],
								[
									120.286488,
									16.034629
								],
								[
									120.390047,
									17.599081
								],
								[
									120.715867,
									18.505227
								],
								[
									121.321308,
									18.504065
								]
							]
						]
					]
				},
				"id": "PHL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Papua New Guinea"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									155.880026,
									-6.819997
								],
								[
									155.599991,
									-6.919991
								],
								[
									155.166994,
									-6.535931
								],
								[
									154.729192,
									-5.900828
								],
								[
									154.514114,
									-5.139118
								],
								[
									154.652504,
									-5.042431
								],
								[
									154.759991,
									-5.339984
								],
								[
									155.062918,
									-5.566792
								],
								[
									155.547746,
									-6.200655
								],
								[
									156.019965,
									-6.540014
								],
								[
									155.880026,
									-6.819997
								]
							]
						],
						[
							[
								[
									151.982796,
									-5.478063
								],
								[
									151.459107,
									-5.56028
								],
								[
									151.30139,
									-5.840728
								],
								[
									150.754447,
									-6.083763
								],
								[
									150.241197,
									-6.317754
								],
								[
									149.709963,
									-6.316513
								],
								[
									148.890065,
									-6.02604
								],
								[
									148.318937,
									-5.747142
								],
								[
									148.401826,
									-5.437756
								],
								[
									149.298412,
									-5.583742
								],
								[
									149.845562,
									-5.505503
								],
								[
									149.99625,
									-5.026101
								],
								[
									150.139756,
									-5.001348
								],
								[
									150.236908,
									-5.53222
								],
								[
									150.807467,
									-5.455842
								],
								[
									151.089672,
									-5.113693
								],
								[
									151.647881,
									-4.757074
								],
								[
									151.537862,
									-4.167807
								],
								[
									152.136792,
									-4.14879
								],
								[
									152.338743,
									-4.312966
								],
								[
									152.318693,
									-4.867661
								],
								[
									151.982796,
									-5.478063
								]
							]
						],
						[
							[
								[
									147.191874,
									-7.388024
								],
								[
									148.084636,
									-8.044108
								],
								[
									148.734105,
									-9.104664
								],
								[
									149.306835,
									-9.071436
								],
								[
									149.266631,
									-9.514406
								],
								[
									150.038728,
									-9.684318
								],
								[
									149.738798,
									-9.872937
								],
								[
									150.801628,
									-10.293687
								],
								[
									150.690575,
									-10.582713
								],
								[
									150.028393,
									-10.652476
								],
								[
									149.78231,
									-10.393267
								],
								[
									148.923138,
									-10.280923
								],
								[
									147.913018,
									-10.130441
								],
								[
									147.135443,
									-9.492444
								],
								[
									146.567881,
									-8.942555
								],
								[
									146.048481,
									-8.067414
								],
								[
									144.744168,
									-7.630128
								],
								[
									143.897088,
									-7.91533
								],
								[
									143.286376,
									-8.245491
								],
								[
									143.413913,
									-8.983069
								],
								[
									142.628431,
									-9.326821
								],
								[
									142.068259,
									-9.159596
								],
								[
									141.033852,
									-9.117893
								],
								[
									141.017057,
									-5.859022
								],
								[
									141.00021,
									-2.600151
								],
								[
									142.735247,
									-3.289153
								],
								[
									144.583971,
									-3.861418
								],
								[
									145.27318,
									-4.373738
								],
								[
									145.829786,
									-4.876498
								],
								[
									145.981922,
									-5.465609
								],
								[
									147.648073,
									-6.083659
								],
								[
									147.891108,
									-6.614015
								],
								[
									146.970905,
									-6.721657
								],
								[
									147.191874,
									-7.388024
								]
							]
						],
						[
							[
								[
									153.140038,
									-4.499983
								],
								[
									152.827292,
									-4.766427
								],
								[
									152.638673,
									-4.176127
								],
								[
									152.406026,
									-3.789743
								],
								[
									151.953237,
									-3.462062
								],
								[
									151.384279,
									-3.035422
								],
								[
									150.66205,
									-2.741486
								],
								[
									150.939965,
									-2.500002
								],
								[
									151.479984,
									-2.779985
								],
								[
									151.820015,
									-2.999972
								],
								[
									152.239989,
									-3.240009
								],
								[
									152.640017,
									-3.659983
								],
								[
									153.019994,
									-3.980015
								],
								[
									153.140038,
									-4.499983
								]
							]
						]
					]
				},
				"id": "PNG"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Poland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								15.016996,
								51.106674
							],
							[
								14.607098,
								51.745188
							],
							[
								14.685026,
								52.089947
							],
							[
								14.4376,
								52.62485
							],
							[
								14.074521,
								52.981263
							],
							[
								14.353315,
								53.248171
							],
							[
								14.119686,
								53.757029
							],
							[
								14.8029,
								54.050706
							],
							[
								16.363477,
								54.513159
							],
							[
								17.622832,
								54.851536
							],
							[
								18.620859,
								54.682606
							],
							[
								18.696255,
								54.438719
							],
							[
								19.66064,
								54.426084
							],
							[
								20.892245,
								54.312525
							],
							[
								22.731099,
								54.327537
							],
							[
								23.243987,
								54.220567
							],
							[
								23.484128,
								53.912498
							],
							[
								23.527536,
								53.470122
							],
							[
								23.804935,
								53.089731
							],
							[
								23.799199,
								52.691099
							],
							[
								23.199494,
								52.486977
							],
							[
								23.508002,
								52.023647
							],
							[
								23.527071,
								51.578454
							],
							[
								24.029986,
								50.705407
							],
							[
								23.922757,
								50.424881
							],
							[
								23.426508,
								50.308506
							],
							[
								22.51845,
								49.476774
							],
							[
								22.776419,
								49.027395
							],
							[
								22.558138,
								49.085738
							],
							[
								21.607808,
								49.470107
							],
							[
								20.887955,
								49.328772
							],
							[
								20.415839,
								49.431453
							],
							[
								19.825023,
								49.217125
							],
							[
								19.320713,
								49.571574
							],
							[
								18.909575,
								49.435846
							],
							[
								18.853144,
								49.49623
							],
							[
								18.392914,
								49.988629
							],
							[
								17.649445,
								50.049038
							],
							[
								17.554567,
								50.362146
							],
							[
								16.868769,
								50.473974
							],
							[
								16.719476,
								50.215747
							],
							[
								16.176253,
								50.422607
							],
							[
								16.238627,
								50.697733
							],
							[
								15.490972,
								50.78473
							],
							[
								15.016996,
								51.106674
							]
						]
					]
				},
				"id": "POL"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Puerto Rico"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-66.282434,
								18.514762
							],
							[
								-65.771303,
								18.426679
							],
							[
								-65.591004,
								18.228035
							],
							[
								-65.847164,
								17.975906
							],
							[
								-66.599934,
								17.981823
							],
							[
								-67.184162,
								17.946553
							],
							[
								-67.242428,
								18.37446
							],
							[
								-67.100679,
								18.520601
							],
							[
								-66.282434,
								18.514762
							]
						]
					]
				},
				"id": "PRI"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "North Korea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								130.640016,
								42.395009
							],
							[
								130.780007,
								42.220007
							],
							[
								130.400031,
								42.280004
							],
							[
								129.965949,
								41.941368
							],
							[
								129.667362,
								41.601104
							],
							[
								129.705189,
								40.882828
							],
							[
								129.188115,
								40.661808
							],
							[
								129.0104,
								40.485436
							],
							[
								128.633368,
								40.189847
							],
							[
								127.967414,
								40.025413
							],
							[
								127.533436,
								39.75685
							],
							[
								127.50212,
								39.323931
							],
							[
								127.385434,
								39.213472
							],
							[
								127.783343,
								39.050898
							],
							[
								128.349716,
								38.612243
							],
							[
								128.205746,
								38.370397
							],
							[
								127.780035,
								38.304536
							],
							[
								127.073309,
								38.256115
							],
							[
								126.68372,
								37.804773
							],
							[
								126.237339,
								37.840378
							],
							[
								126.174759,
								37.749686
							],
							[
								125.689104,
								37.94001
							],
							[
								125.568439,
								37.752089
							],
							[
								125.27533,
								37.669071
							],
							[
								125.240087,
								37.857224
							],
							[
								124.981033,
								37.948821
							],
							[
								124.712161,
								38.108346
							],
							[
								124.985994,
								38.548474
							],
							[
								125.221949,
								38.665857
							],
							[
								125.132859,
								38.848559
							],
							[
								125.38659,
								39.387958
							],
							[
								125.321116,
								39.551385
							],
							[
								124.737482,
								39.660344
							],
							[
								124.265625,
								39.928493
							],
							[
								125.079942,
								40.569824
							],
							[
								126.182045,
								41.107336
							],
							[
								126.869083,
								41.816569
							],
							[
								127.343783,
								41.503152
							],
							[
								128.208433,
								41.466772
							],
							[
								128.052215,
								41.994285
							],
							[
								129.596669,
								42.424982
							],
							[
								129.994267,
								42.985387
							],
							[
								130.640016,
								42.395009
							]
						]
					]
				},
				"id": "PRK"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Portugal"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-9.034818,
								41.880571
							],
							[
								-8.671946,
								42.134689
							],
							[
								-8.263857,
								42.280469
							],
							[
								-8.013175,
								41.790886
							],
							[
								-7.422513,
								41.792075
							],
							[
								-7.251309,
								41.918346
							],
							[
								-6.668606,
								41.883387
							],
							[
								-6.389088,
								41.381815
							],
							[
								-6.851127,
								41.111083
							],
							[
								-6.86402,
								40.330872
							],
							[
								-7.026413,
								40.184524
							],
							[
								-7.066592,
								39.711892
							],
							[
								-7.498632,
								39.629571
							],
							[
								-7.098037,
								39.030073
							],
							[
								-7.374092,
								38.373059
							],
							[
								-7.029281,
								38.075764
							],
							[
								-7.166508,
								37.803894
							],
							[
								-7.537105,
								37.428904
							],
							[
								-7.453726,
								37.097788
							],
							[
								-7.855613,
								36.838269
							],
							[
								-8.382816,
								36.97888
							],
							[
								-8.898857,
								36.868809
							],
							[
								-8.746101,
								37.651346
							],
							[
								-8.839998,
								38.266243
							],
							[
								-9.287464,
								38.358486
							],
							[
								-9.526571,
								38.737429
							],
							[
								-9.446989,
								39.392066
							],
							[
								-9.048305,
								39.755093
							],
							[
								-8.977353,
								40.159306
							],
							[
								-8.768684,
								40.760639
							],
							[
								-8.790853,
								41.184334
							],
							[
								-8.990789,
								41.543459
							],
							[
								-9.034818,
								41.880571
							]
						]
					]
				},
				"id": "PRT"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Paraguay"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-62.685057,
								-22.249029
							],
							[
								-62.291179,
								-21.051635
							],
							[
								-62.265961,
								-20.513735
							],
							[
								-61.786326,
								-19.633737
							],
							[
								-60.043565,
								-19.342747
							],
							[
								-59.115042,
								-19.356906
							],
							[
								-58.183471,
								-19.868399
							],
							[
								-58.166392,
								-20.176701
							],
							[
								-57.870674,
								-20.732688
							],
							[
								-57.937156,
								-22.090176
							],
							[
								-56.88151,
								-22.282154
							],
							[
								-56.473317,
								-22.0863
							],
							[
								-55.797958,
								-22.35693
							],
							[
								-55.610683,
								-22.655619
							],
							[
								-55.517639,
								-23.571998
							],
							[
								-55.400747,
								-23.956935
							],
							[
								-55.027902,
								-24.001274
							],
							[
								-54.652834,
								-23.839578
							],
							[
								-54.29296,
								-24.021014
							],
							[
								-54.293476,
								-24.5708
							],
							[
								-54.428946,
								-25.162185
							],
							[
								-54.625291,
								-25.739255
							],
							[
								-54.788795,
								-26.621786
							],
							[
								-55.695846,
								-27.387837
							],
							[
								-56.486702,
								-27.548499
							],
							[
								-57.60976,
								-27.395899
							],
							[
								-58.618174,
								-27.123719
							],
							[
								-57.63366,
								-25.603657
							],
							[
								-57.777217,
								-25.16234
							],
							[
								-58.807128,
								-24.771459
							],
							[
								-60.028966,
								-24.032796
							],
							[
								-60.846565,
								-23.880713
							],
							[
								-62.685057,
								-22.249029
							]
						]
					]
				},
				"id": "PRY"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Qatar"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								50.810108,
								24.754743
							],
							[
								50.743911,
								25.482424
							],
							[
								51.013352,
								26.006992
							],
							[
								51.286462,
								26.114582
							],
							[
								51.589079,
								25.801113
							],
							[
								51.6067,
								25.21567
							],
							[
								51.389608,
								24.627386
							],
							[
								51.112415,
								24.556331
							],
							[
								50.810108,
								24.754743
							]
						]
					]
				},
				"id": "QAT"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Romania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								22.710531,
								47.882194
							],
							[
								23.142236,
								48.096341
							],
							[
								23.760958,
								47.985598
							],
							[
								24.402056,
								47.981878
							],
							[
								24.866317,
								47.737526
							],
							[
								25.207743,
								47.891056
							],
							[
								25.945941,
								47.987149
							],
							[
								26.19745,
								48.220881
							],
							[
								26.619337,
								48.220726
							],
							[
								26.924176,
								48.123264
							],
							[
								27.233873,
								47.826771
							],
							[
								27.551166,
								47.405117
							],
							[
								28.12803,
								46.810476
							],
							[
								28.160018,
								46.371563
							],
							[
								28.054443,
								45.944586
							],
							[
								28.233554,
								45.488283
							],
							[
								28.679779,
								45.304031
							],
							[
								29.149725,
								45.464925
							],
							[
								29.603289,
								45.293308
							],
							[
								29.626543,
								45.035391
							],
							[
								29.141612,
								44.82021
							],
							[
								28.837858,
								44.913874
							],
							[
								28.558081,
								43.707462
							],
							[
								27.970107,
								43.812468
							],
							[
								27.2424,
								44.175986
							],
							[
								26.065159,
								43.943494
							],
							[
								25.569272,
								43.688445
							],
							[
								24.100679,
								43.741051
							],
							[
								23.332302,
								43.897011
							],
							[
								22.944832,
								43.823785
							],
							[
								22.65715,
								44.234923
							],
							[
								22.474008,
								44.409228
							],
							[
								22.705726,
								44.578003
							],
							[
								22.459022,
								44.702517
							],
							[
								22.145088,
								44.478422
							],
							[
								21.562023,
								44.768947
							],
							[
								21.483526,
								45.18117
							],
							[
								20.874313,
								45.416375
							],
							[
								20.762175,
								45.734573
							],
							[
								20.220192,
								46.127469
							],
							[
								21.021952,
								46.316088
							],
							[
								21.626515,
								46.994238
							],
							[
								22.099768,
								47.672439
							],
							[
								22.710531,
								47.882194
							]
						]
					]
				},
				"id": "ROU"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Russia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									143.648007,
									50.7476
								],
								[
									144.654148,
									48.976391
								],
								[
									143.173928,
									49.306551
								],
								[
									142.558668,
									47.861575
								],
								[
									143.533492,
									46.836728
								],
								[
									143.505277,
									46.137908
								],
								[
									142.747701,
									46.740765
								],
								[
									142.09203,
									45.966755
								],
								[
									141.906925,
									46.805929
								],
								[
									142.018443,
									47.780133
								],
								[
									141.904445,
									48.859189
								],
								[
									142.1358,
									49.615163
								],
								[
									142.179983,
									50.952342
								],
								[
									141.594076,
									51.935435
								],
								[
									141.682546,
									53.301966
								],
								[
									142.606934,
									53.762145
								],
								[
									142.209749,
									54.225476
								],
								[
									142.654786,
									54.365881
								],
								[
									142.914616,
									53.704578
								],
								[
									143.260848,
									52.74076
								],
								[
									143.235268,
									51.75666
								],
								[
									143.648007,
									50.7476
								]
							]
						],
						[
							[
								[
									22.731099,
									54.327537
								],
								[
									20.892245,
									54.312525
								],
								[
									19.66064,
									54.426084
								],
								[
									19.888481,
									54.86616
								],
								[
									21.268449,
									55.190482
								],
								[
									22.315724,
									55.015299
								],
								[
									22.757764,
									54.856574
								],
								[
									22.651052,
									54.582741
								],
								[
									22.731099,
									54.327537
								]
							]
						],
						[
							[
								[
									-175.01425,
									66.58435
								],
								[
									-174.33983,
									66.33556
								],
								[
									-174.57182,
									67.06219
								],
								[
									-171.85731,
									66.91308
								],
								[
									-169.89958,
									65.97724
								],
								[
									-170.89107,
									65.54139
								],
								[
									-172.53025,
									65.43791
								],
								[
									-172.555,
									64.46079
								],
								[
									-172.95533,
									64.25269
								],
								[
									-173.89184,
									64.2826
								],
								[
									-174.65392,
									64.63125
								],
								[
									-175.98353,
									64.92288
								],
								[
									-176.20716,
									65.35667
								],
								[
									-177.22266,
									65.52024
								],
								[
									-178.35993,
									65.39052
								],
								[
									-178.90332,
									65.74044
								],
								[
									-178.68611,
									66.11211
								],
								[
									-179.88377,
									65.87456
								],
								[
									-179.43268,
									65.40411
								],
								[
									-180,
									64.979709
								],
								[
									-180,
									68.963636
								],
								[
									-177.55,
									68.2
								],
								[
									-174.92825,
									67.20589
								],
								[
									-175.01425,
									66.58435
								]
							]
						],
						[
							[
								[
									180,
									70.832199
								],
								[
									178.903425,
									70.78114
								],
								[
									178.7253,
									71.0988
								],
								[
									180,
									71.515714
								],
								[
									180,
									70.832199
								]
							]
						],
						[
							[
								[
									-178.69378,
									70.89302
								],
								[
									-180,
									70.832199
								],
								[
									-180,
									71.515714
								],
								[
									-179.871875,
									71.55762
								],
								[
									-179.02433,
									71.55553
								],
								[
									-177.577945,
									71.26948
								],
								[
									-177.663575,
									71.13277
								],
								[
									-178.69378,
									70.89302
								]
							]
						],
						[
							[
								[
									143.60385,
									73.21244
								],
								[
									142.08763,
									73.20544
								],
								[
									140.038155,
									73.31692
								],
								[
									139.86312,
									73.36983
								],
								[
									140.81171,
									73.76506
								],
								[
									142.06207,
									73.85758
								],
								[
									143.48283,
									73.47525
								],
								[
									143.60385,
									73.21244
								]
							]
						],
						[
							[
								[
									150.73167,
									75.08406
								],
								[
									149.575925,
									74.68892
								],
								[
									147.977465,
									74.778355
								],
								[
									146.11919,
									75.17298
								],
								[
									146.358485,
									75.49682
								],
								[
									148.22223,
									75.345845
								],
								[
									150.73167,
									75.08406
								]
							]
						],
						[
							[
								[
									145.086285,
									75.562625
								],
								[
									144.3,
									74.82
								],
								[
									140.61381,
									74.84768
								],
								[
									138.95544,
									74.61148
								],
								[
									136.97439,
									75.26167
								],
								[
									137.51176,
									75.94917
								],
								[
									138.831075,
									76.13676
								],
								[
									141.471615,
									76.09289
								],
								[
									145.086285,
									75.562625
								]
							]
						],
						[
							[
								[
									57.535693,
									70.720464
								],
								[
									56.944979,
									70.632743
								],
								[
									53.677375,
									70.762658
								],
								[
									53.412017,
									71.206662
								],
								[
									51.601895,
									71.474759
								],
								[
									51.455754,
									72.014881
								],
								[
									52.478275,
									72.229442
								],
								[
									52.444169,
									72.774731
								],
								[
									54.427614,
									73.627548
								],
								[
									53.50829,
									73.749814
								],
								[
									55.902459,
									74.627486
								],
								[
									55.631933,
									75.081412
								],
								[
									57.868644,
									75.60939
								],
								[
									61.170044,
									76.251883
								],
								[
									64.498368,
									76.439055
								],
								[
									66.210977,
									76.809782
								],
								[
									68.15706,
									76.939697
								],
								[
									68.852211,
									76.544811
								],
								[
									68.180573,
									76.233642
								],
								[
									64.637326,
									75.737755
								],
								[
									61.583508,
									75.260885
								],
								[
									58.477082,
									74.309056
								],
								[
									56.986786,
									73.333044
								],
								[
									55.419336,
									72.371268
								],
								[
									55.622838,
									71.540595
								],
								[
									57.535693,
									70.720464
								]
							]
						],
						[
							[
								[
									106.97013,
									76.97419
								],
								[
									107.24,
									76.48
								],
								[
									108.1538,
									76.72335
								],
								[
									111.07726,
									76.71
								],
								[
									113.33151,
									76.22224
								],
								[
									114.13417,
									75.84764
								],
								[
									113.88539,
									75.32779
								],
								[
									112.77918,
									75.03186
								],
								[
									110.15125,
									74.47673
								],
								[
									109.4,
									74.18
								],
								[
									110.64,
									74.04
								],
								[
									112.11919,
									73.78774
								],
								[
									113.01954,
									73.97693
								],
								[
									113.52958,
									73.33505
								],
								[
									113.96881,
									73.59488
								],
								[
									115.56782,
									73.75285
								],
								[
									118.77633,
									73.58772
								],
								[
									119.02,
									73.12
								],
								[
									123.20066,
									72.97122
								],
								[
									123.25777,
									73.73503
								],
								[
									125.38,
									73.56
								],
								[
									126.97644,
									73.56549
								],
								[
									128.59126,
									73.03871
								],
								[
									129.05157,
									72.39872
								],
								[
									128.46,
									71.98
								],
								[
									129.71599,
									71.19304
								],
								[
									131.28858,
									70.78699
								],
								[
									132.2535,
									71.8363
								],
								[
									133.85766,
									71.38642
								],
								[
									135.56193,
									71.65525
								],
								[
									137.49755,
									71.34763
								],
								[
									138.23409,
									71.62803
								],
								[
									139.86983,
									71.48783
								],
								[
									139.14791,
									72.41619
								],
								[
									140.46817,
									72.84941
								],
								[
									149.5,
									72.2
								],
								[
									150.35118,
									71.60643
								],
								[
									152.9689,
									70.84222
								],
								[
									157.00688,
									71.03141
								],
								[
									158.99779,
									70.86672
								],
								[
									159.83031,
									70.45324
								],
								[
									159.70866,
									69.72198
								],
								[
									160.94053,
									69.43728
								],
								[
									162.27907,
									69.64204
								],
								[
									164.05248,
									69.66823
								],
								[
									165.94037,
									69.47199
								],
								[
									167.83567,
									69.58269
								],
								[
									169.57763,
									68.6938
								],
								[
									170.81688,
									69.01363
								],
								[
									170.0082,
									69.65276
								],
								[
									170.45345,
									70.09703
								],
								[
									173.64391,
									69.81743
								],
								[
									175.72403,
									69.87725
								],
								[
									178.6,
									69.4
								],
								[
									180,
									68.963636
								],
								[
									180,
									64.979709
								],
								[
									179.99281,
									64.97433
								],
								[
									178.7072,
									64.53493
								],
								[
									177.41128,
									64.60821
								],
								[
									178.313,
									64.07593
								],
								[
									178.90825,
									63.25197
								],
								[
									179.37034,
									62.98262
								],
								[
									179.48636,
									62.56894
								],
								[
									179.22825,
									62.3041
								],
								[
									177.3643,
									62.5219
								],
								[
									174.56929,
									61.76915
								],
								[
									173.68013,
									61.65261
								],
								[
									172.15,
									60.95
								],
								[
									170.6985,
									60.33618
								],
								[
									170.33085,
									59.88177
								],
								[
									168.90046,
									60.57355
								],
								[
									166.29498,
									59.78855
								],
								[
									165.84,
									60.16
								],
								[
									164.87674,
									59.7316
								],
								[
									163.53929,
									59.86871
								],
								[
									163.21711,
									59.21101
								],
								[
									162.01733,
									58.24328
								],
								[
									162.05297,
									57.83912
								],
								[
									163.19191,
									57.61503
								],
								[
									163.05794,
									56.15924
								],
								[
									162.12958,
									56.12219
								],
								[
									161.70146,
									55.28568
								],
								[
									162.11749,
									54.85514
								],
								[
									160.36877,
									54.34433
								],
								[
									160.02173,
									53.20257
								],
								[
									158.53094,
									52.95868
								],
								[
									158.23118,
									51.94269
								],
								[
									156.78979,
									51.01105
								],
								[
									156.42,
									51.7
								],
								[
									155.99182,
									53.15895
								],
								[
									155.43366,
									55.38103
								],
								[
									155.91442,
									56.76792
								],
								[
									156.75815,
									57.3647
								],
								[
									156.81035,
									57.83204
								],
								[
									158.36433,
									58.05575
								],
								[
									160.15064,
									59.31477
								],
								[
									161.87204,
									60.343
								],
								[
									163.66969,
									61.1409
								],
								[
									164.47355,
									62.55061
								],
								[
									163.25842,
									62.46627
								],
								[
									162.65791,
									61.6425
								],
								[
									160.12148,
									60.54423
								],
								[
									159.30232,
									61.77396
								],
								[
									156.72068,
									61.43442
								],
								[
									154.21806,
									59.75818
								],
								[
									155.04375,
									59.14495
								],
								[
									152.81185,
									58.88385
								],
								[
									151.26573,
									58.78089
								],
								[
									151.33815,
									59.50396
								],
								[
									149.78371,
									59.65573
								],
								[
									148.54481,
									59.16448
								],
								[
									145.48722,
									59.33637
								],
								[
									142.19782,
									59.03998
								],
								[
									138.95848,
									57.08805
								],
								[
									135.12619,
									54.72959
								],
								[
									136.70171,
									54.60355
								],
								[
									137.19342,
									53.97732
								],
								[
									138.1647,
									53.75501
								],
								[
									138.80463,
									54.25455
								],
								[
									139.90151,
									54.18968
								],
								[
									141.34531,
									53.08957
								],
								[
									141.37923,
									52.23877
								],
								[
									140.59742,
									51.23967
								],
								[
									140.51308,
									50.04553
								],
								[
									140.06193,
									48.44671
								],
								[
									138.55472,
									46.99965
								],
								[
									138.21971,
									46.30795
								],
								[
									136.86232,
									45.1435
								],
								[
									135.51535,
									43.989
								],
								[
									134.86939,
									43.39821
								],
								[
									133.53687,
									42.81147
								],
								[
									132.90627,
									42.79849
								],
								[
									132.27807,
									43.28456
								],
								[
									130.93587,
									42.55274
								],
								[
									130.78,
									42.22
								],
								[
									130.64,
									42.395
								],
								[
									130.633866,
									42.903015
								],
								[
									131.144688,
									42.92999
								],
								[
									131.288555,
									44.11152
								],
								[
									131.02519,
									44.96796
								],
								[
									131.883454,
									45.321162
								],
								[
									133.09712,
									45.14409
								],
								[
									133.769644,
									46.116927
								],
								[
									134.11235,
									47.21248
								],
								[
									134.50081,
									47.57845
								],
								[
									135.026311,
									48.47823
								],
								[
									133.373596,
									48.183442
								],
								[
									132.50669,
									47.78896
								],
								[
									130.98726,
									47.79013
								],
								[
									130.582293,
									48.729687
								],
								[
									129.397818,
									49.4406
								],
								[
									127.6574,
									49.76027
								],
								[
									127.287456,
									50.739797
								],
								[
									126.939157,
									51.353894
								],
								[
									126.564399,
									51.784255
								],
								[
									125.946349,
									52.792799
								],
								[
									125.068211,
									53.161045
								],
								[
									123.57147,
									53.4588
								],
								[
									122.245748,
									53.431726
								],
								[
									121.003085,
									53.251401
								],
								[
									120.177089,
									52.753886
								],
								[
									120.725789,
									52.516226
								],
								[
									120.7382,
									51.96411
								],
								[
									120.18208,
									51.64355
								],
								[
									119.27939,
									50.58292
								],
								[
									119.288461,
									50.142883
								],
								[
									117.879244,
									49.510983
								],
								[
									116.678801,
									49.888531
								],
								[
									115.485695,
									49.805177
								],
								[
									114.96211,
									50.140247
								],
								[
									114.362456,
									50.248303
								],
								[
									112.89774,
									49.543565
								],
								[
									111.581231,
									49.377968
								],
								[
									110.662011,
									49.130128
								],
								[
									109.402449,
									49.292961
								],
								[
									108.475167,
									49.282548
								],
								[
									107.868176,
									49.793705
								],
								[
									106.888804,
									50.274296
								],
								[
									105.886591,
									50.406019
								],
								[
									104.62158,
									50.27532
								],
								[
									103.676545,
									50.089966
								],
								[
									102.25589,
									50.51056
								],
								[
									102.06521,
									51.25991
								],
								[
									100.88948,
									51.516856
								],
								[
									99.981732,
									51.634006
								],
								[
									98.861491,
									52.047366
								],
								[
									97.82574,
									51.010995
								],
								[
									98.231762,
									50.422401
								],
								[
									97.25976,
									49.72605
								],
								[
									95.81402,
									49.97746
								],
								[
									94.815949,
									50.013433
								],
								[
									94.147566,
									50.480537
								],
								[
									93.10421,
									50.49529
								],
								[
									92.234712,
									50.802171
								],
								[
									90.713667,
									50.331812
								],
								[
									88.805567,
									49.470521
								],
								[
									87.751264,
									49.297198
								],
								[
									87.35997,
									49.214981
								],
								[
									86.829357,
									49.826675
								],
								[
									85.54127,
									49.692859
								],
								[
									85.11556,
									50.117303
								],
								[
									84.416377,
									50.3114
								],
								[
									83.935115,
									50.889246
								],
								[
									83.383004,
									51.069183
								],
								[
									81.945986,
									50.812196
								],
								[
									80.568447,
									51.388336
								],
								[
									80.03556,
									50.864751
								],
								[
									77.800916,
									53.404415
								],
								[
									76.525179,
									54.177003
								],
								[
									76.8911,
									54.490524
								],
								[
									74.38482,
									53.54685
								],
								[
									73.425679,
									53.48981
								],
								[
									73.508516,
									54.035617
								],
								[
									72.22415,
									54.376655
								],
								[
									71.180131,
									54.133285
								],
								[
									70.865267,
									55.169734
								],
								[
									69.068167,
									55.38525
								],
								[
									68.1691,
									54.970392
								],
								[
									65.66687,
									54.60125
								],
								[
									65.178534,
									54.354228
								],
								[
									61.4366,
									54.00625
								],
								[
									60.978066,
									53.664993
								],
								[
									61.699986,
									52.979996
								],
								[
									60.739993,
									52.719986
								],
								[
									60.927269,
									52.447548
								],
								[
									59.967534,
									51.96042
								],
								[
									61.588003,
									51.272659
								],
								[
									61.337424,
									50.79907
								],
								[
									59.932807,
									50.842194
								],
								[
									59.642282,
									50.545442
								],
								[
									58.36332,
									51.06364
								],
								[
									56.77798,
									51.04355
								],
								[
									55.71694,
									50.62171
								],
								[
									54.532878,
									51.02624
								],
								[
									52.328724,
									51.718652
								],
								[
									50.766648,
									51.692762
								],
								[
									48.702382,
									50.605128
								],
								[
									48.577841,
									49.87476
								],
								[
									47.54948,
									50.454698
								],
								[
									46.751596,
									49.356006
								],
								[
									47.043672,
									49.152039
								],
								[
									46.466446,
									48.394152
								],
								[
									47.31524,
									47.71585
								],
								[
									48.05725,
									47.74377
								],
								[
									48.694734,
									47.075628
								],
								[
									48.59325,
									46.56104
								],
								[
									49.10116,
									46.39933
								],
								[
									48.64541,
									45.80629
								],
								[
									47.67591,
									45.64149
								],
								[
									46.68201,
									44.6092
								],
								[
									47.59094,
									43.66016
								],
								[
									47.49252,
									42.98658
								],
								[
									48.58437,
									41.80888
								],
								[
									47.987283,
									41.405819
								],
								[
									47.815666,
									41.151416
								],
								[
									47.373315,
									41.219732
								],
								[
									46.686071,
									41.827137
								],
								[
									46.404951,
									41.860675
								],
								[
									45.7764,
									42.09244
								],
								[
									45.470279,
									42.502781
								],
								[
									44.537623,
									42.711993
								],
								[
									43.93121,
									42.55496
								],
								[
									43.75599,
									42.74083
								],
								[
									42.3944,
									43.2203
								],
								[
									40.92219,
									43.38215
								],
								[
									40.076965,
									43.553104
								],
								[
									39.955009,
									43.434998
								],
								[
									38.68,
									44.28
								],
								[
									37.53912,
									44.65721
								],
								[
									36.67546,
									45.24469
								],
								[
									37.40317,
									45.40451
								],
								[
									38.23295,
									46.24087
								],
								[
									37.67372,
									46.63657
								],
								[
									39.14767,
									47.04475
								],
								[
									39.1212,
									47.26336
								],
								[
									38.223538,
									47.10219
								],
								[
									38.255112,
									47.5464
								],
								[
									38.77057,
									47.82562
								],
								[
									39.738278,
									47.898937
								],
								[
									39.89562,
									48.23241
								],
								[
									39.67465,
									48.78382
								],
								[
									40.080789,
									49.30743
								],
								[
									40.06904,
									49.60105
								],
								[
									38.594988,
									49.926462
								],
								[
									38.010631,
									49.915662
								],
								[
									37.39346,
									50.383953
								],
								[
									36.626168,
									50.225591
								],
								[
									35.356116,
									50.577197
								],
								[
									35.37791,
									50.77394
								],
								[
									35.022183,
									51.207572
								],
								[
									34.224816,
									51.255993
								],
								[
									34.141978,
									51.566413
								],
								[
									34.391731,
									51.768882
								],
								[
									33.7527,
									52.335075
								],
								[
									32.715761,
									52.238465
								],
								[
									32.412058,
									52.288695
								],
								[
									32.15944,
									52.06125
								],
								[
									31.78597,
									52.10168
								],
								[
									31.540018,
									52.742052
								],
								[
									31.305201,
									53.073996
								],
								[
									31.49764,
									53.16743
								],
								[
									32.304519,
									53.132726
								],
								[
									32.693643,
									53.351421
								],
								[
									32.405599,
									53.618045
								],
								[
									31.731273,
									53.794029
								],
								[
									31.791424,
									53.974639
								],
								[
									31.384472,
									54.157056
								],
								[
									30.757534,
									54.811771
								],
								[
									30.971836,
									55.081548
								],
								[
									30.873909,
									55.550976
								],
								[
									29.896294,
									55.789463
								],
								[
									29.371572,
									55.670091
								],
								[
									29.229513,
									55.918344
								],
								[
									28.176709,
									56.16913
								],
								[
									27.855282,
									56.759326
								],
								[
									27.770016,
									57.244258
								],
								[
									27.288185,
									57.474528
								],
								[
									27.716686,
									57.791899
								],
								[
									27.42015,
									58.72457
								],
								[
									28.131699,
									59.300825
								],
								[
									27.98112,
									59.47537
								],
								[
									29.1177,
									60.02805
								],
								[
									28.07,
									60.50352
								],
								[
									30.211107,
									61.780028
								],
								[
									31.139991,
									62.357693
								],
								[
									31.516092,
									62.867687
								],
								[
									30.035872,
									63.552814
								],
								[
									30.444685,
									64.204453
								],
								[
									29.54443,
									64.948672
								],
								[
									30.21765,
									65.80598
								],
								[
									29.054589,
									66.944286
								],
								[
									29.977426,
									67.698297
								],
								[
									28.445944,
									68.364613
								],
								[
									28.59193,
									69.064777
								],
								[
									29.39955,
									69.15692
								],
								[
									31.10108,
									69.55811
								],
								[
									32.13272,
									69.90595
								],
								[
									33.77547,
									69.30142
								],
								[
									36.51396,
									69.06342
								],
								[
									40.29234,
									67.9324
								],
								[
									41.05987,
									67.45713
								],
								[
									41.12595,
									66.79158
								],
								[
									40.01583,
									66.26618
								],
								[
									38.38295,
									65.99953
								],
								[
									33.91871,
									66.75961
								],
								[
									33.18444,
									66.63253
								],
								[
									34.81477,
									65.90015
								],
								[
									34.878574,
									65.436213
								],
								[
									34.94391,
									64.41437
								],
								[
									36.23129,
									64.10945
								],
								[
									37.01273,
									63.84983
								],
								[
									37.14197,
									64.33471
								],
								[
									36.539579,
									64.76446
								],
								[
									37.17604,
									65.14322
								],
								[
									39.59345,
									64.52079
								],
								[
									40.4356,
									64.76446
								],
								[
									39.7626,
									65.49682
								],
								[
									42.09309,
									66.47623
								],
								[
									43.01604,
									66.41858
								],
								[
									43.94975,
									66.06908
								],
								[
									44.53226,
									66.75634
								],
								[
									43.69839,
									67.35245
								],
								[
									44.18795,
									67.95051
								],
								[
									43.45282,
									68.57079
								],
								[
									46.25,
									68.25
								],
								[
									46.82134,
									67.68997
								],
								[
									45.55517,
									67.56652
								],
								[
									45.56202,
									67.01005
								],
								[
									46.34915,
									66.66767
								],
								[
									47.89416,
									66.88455
								],
								[
									48.13876,
									67.52238
								],
								[
									50.22766,
									67.99867
								],
								[
									53.71743,
									68.85738
								],
								[
									54.47171,
									68.80815
								],
								[
									53.48582,
									68.20131
								],
								[
									54.72628,
									68.09702
								],
								[
									55.44268,
									68.43866
								],
								[
									57.31702,
									68.46628
								],
								[
									58.802,
									68.88082
								],
								[
									59.94142,
									68.27844
								],
								[
									61.07784,
									68.94069
								],
								[
									60.03,
									69.52
								],
								[
									60.55,
									69.85
								],
								[
									63.504,
									69.54739
								],
								[
									64.888115,
									69.234835
								],
								[
									68.51216,
									68.09233
								],
								[
									69.18068,
									68.61563
								],
								[
									68.16444,
									69.14436
								],
								[
									68.13522,
									69.35649
								],
								[
									66.93008,
									69.45461
								],
								[
									67.25976,
									69.92873
								],
								[
									66.72492,
									70.70889
								],
								[
									66.69466,
									71.02897
								],
								[
									68.54006,
									71.9345
								],
								[
									69.19636,
									72.84336
								],
								[
									69.94,
									73.04
								],
								[
									72.58754,
									72.77629
								],
								[
									72.79603,
									72.22006
								],
								[
									71.84811,
									71.40898
								],
								[
									72.47011,
									71.09019
								],
								[
									72.79188,
									70.39114
								],
								[
									72.5647,
									69.02085
								],
								[
									73.66787,
									68.4079
								],
								[
									73.2387,
									67.7404
								],
								[
									71.28,
									66.32
								],
								[
									72.42301,
									66.17267
								],
								[
									72.82077,
									66.53267
								],
								[
									73.92099,
									66.78946
								],
								[
									74.18651,
									67.28429
								],
								[
									75.052,
									67.76047
								],
								[
									74.46926,
									68.32899
								],
								[
									74.93584,
									68.98918
								],
								[
									73.84236,
									69.07146
								],
								[
									73.60187,
									69.62763
								],
								[
									74.3998,
									70.63175
								],
								[
									73.1011,
									71.44717
								],
								[
									74.89082,
									72.12119
								],
								[
									74.65926,
									72.83227
								],
								[
									75.15801,
									72.85497
								],
								[
									75.68351,
									72.30056
								],
								[
									75.28898,
									71.33556
								],
								[
									76.35911,
									71.15287
								],
								[
									75.90313,
									71.87401
								],
								[
									77.57665,
									72.26717
								],
								[
									79.65202,
									72.32011
								],
								[
									81.5,
									71.75
								],
								[
									80.61071,
									72.58285
								],
								[
									80.51109,
									73.6482
								],
								[
									82.25,
									73.85
								],
								[
									84.65526,
									73.80591
								],
								[
									86.8223,
									73.93688
								],
								[
									86.00956,
									74.45967
								],
								[
									87.16682,
									75.11643
								],
								[
									88.31571,
									75.14393
								],
								[
									90.26,
									75.64
								],
								[
									92.90058,
									75.77333
								],
								[
									93.23421,
									76.0472
								],
								[
									95.86,
									76.14
								],
								[
									96.67821,
									75.91548
								],
								[
									98.92254,
									76.44689
								],
								[
									100.75967,
									76.43028
								],
								[
									101.03532,
									76.86189
								],
								[
									101.99084,
									77.28754
								],
								[
									104.3516,
									77.69792
								],
								[
									106.06664,
									77.37389
								],
								[
									104.705,
									77.1274
								],
								[
									106.97013,
									76.97419
								]
							]
						],
						[
							[
								[
									105.07547,
									78.30689
								],
								[
									99.43814,
									77.921
								],
								[
									101.2649,
									79.23399
								],
								[
									102.08635,
									79.34641
								],
								[
									102.837815,
									79.28129
								],
								[
									105.37243,
									78.71334
								],
								[
									105.07547,
									78.30689
								]
							]
						],
						[
							[
								[
									51.136187,
									80.54728
								],
								[
									49.793685,
									80.415428
								],
								[
									48.894411,
									80.339567
								],
								[
									48.754937,
									80.175468
								],
								[
									47.586119,
									80.010181
								],
								[
									46.502826,
									80.247247
								],
								[
									47.072455,
									80.559424
								],
								[
									44.846958,
									80.58981
								],
								[
									46.799139,
									80.771918
								],
								[
									48.318477,
									80.78401
								],
								[
									48.522806,
									80.514569
								],
								[
									49.09719,
									80.753986
								],
								[
									50.039768,
									80.918885
								],
								[
									51.522933,
									80.699726
								],
								[
									51.136187,
									80.54728
								]
							]
						],
						[
							[
								[
									99.93976,
									78.88094
								],
								[
									97.75794,
									78.7562
								],
								[
									94.97259,
									79.044745
								],
								[
									93.31288,
									79.4265
								],
								[
									92.5454,
									80.14379
								],
								[
									91.18107,
									80.34146
								],
								[
									93.77766,
									81.0246
								],
								[
									95.940895,
									81.2504
								],
								[
									97.88385,
									80.746975
								],
								[
									100.186655,
									79.780135
								],
								[
									99.93976,
									78.88094
								]
							]
						]
					]
				},
				"id": "RUS"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Rwanda"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								30.419105,
								-1.134659
							],
							[
								30.816135,
								-1.698914
							],
							[
								30.758309,
								-2.28725
							],
							[
								30.469696,
								-2.413858
							],
							[
								29.938359,
								-2.348487
							],
							[
								29.632176,
								-2.917858
							],
							[
								29.024926,
								-2.839258
							],
							[
								29.117479,
								-2.292211
							],
							[
								29.254835,
								-2.21511
							],
							[
								29.291887,
								-1.620056
							],
							[
								29.579466,
								-1.341313
							],
							[
								29.821519,
								-1.443322
							],
							[
								30.419105,
								-1.134659
							]
						]
					]
				},
				"id": "RWA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Western Sahara"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-8.794884,
								27.120696
							],
							[
								-8.817828,
								27.656426
							],
							[
								-8.66559,
								27.656426
							],
							[
								-8.665124,
								27.589479
							],
							[
								-8.6844,
								27.395744
							],
							[
								-8.687294,
								25.881056
							],
							[
								-11.969419,
								25.933353
							],
							[
								-11.937224,
								23.374594
							],
							[
								-12.874222,
								23.284832
							],
							[
								-13.118754,
								22.77122
							],
							[
								-12.929102,
								21.327071
							],
							[
								-16.845194,
								21.333323
							],
							[
								-17.063423,
								20.999752
							],
							[
								-17.020428,
								21.42231
							],
							[
								-17.002962,
								21.420734
							],
							[
								-14.750955,
								21.5006
							],
							[
								-14.630833,
								21.86094
							],
							[
								-14.221168,
								22.310163
							],
							[
								-13.89111,
								23.691009
							],
							[
								-12.500963,
								24.770116
							],
							[
								-12.030759,
								26.030866
							],
							[
								-11.71822,
								26.104092
							],
							[
								-11.392555,
								26.883424
							],
							[
								-10.551263,
								26.990808
							],
							[
								-10.189424,
								26.860945
							],
							[
								-9.735343,
								26.860945
							],
							[
								-9.413037,
								27.088476
							],
							[
								-8.794884,
								27.120696
							]
						]
					]
				},
				"id": "-99"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Saudi Arabia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								42.779332,
								16.347891
							],
							[
								42.649573,
								16.774635
							],
							[
								42.347989,
								17.075806
							],
							[
								42.270888,
								17.474722
							],
							[
								41.754382,
								17.833046
							],
							[
								41.221391,
								18.6716
							],
							[
								40.939341,
								19.486485
							],
							[
								40.247652,
								20.174635
							],
							[
								39.801685,
								20.338862
							],
							[
								39.139399,
								21.291905
							],
							[
								39.023696,
								21.986875
							],
							[
								39.066329,
								22.579656
							],
							[
								38.492772,
								23.688451
							],
							[
								38.02386,
								24.078686
							],
							[
								37.483635,
								24.285495
							],
							[
								37.154818,
								24.858483
							],
							[
								37.209491,
								25.084542
							],
							[
								36.931627,
								25.602959
							],
							[
								36.639604,
								25.826228
							],
							[
								36.249137,
								26.570136
							],
							[
								35.640182,
								27.37652
							],
							[
								35.130187,
								28.063352
							],
							[
								34.632336,
								28.058546
							],
							[
								34.787779,
								28.607427
							],
							[
								34.83222,
								28.957483
							],
							[
								34.956037,
								29.356555
							],
							[
								36.068941,
								29.197495
							],
							[
								36.501214,
								29.505254
							],
							[
								36.740528,
								29.865283
							],
							[
								37.503582,
								30.003776
							],
							[
								37.66812,
								30.338665
							],
							[
								37.998849,
								30.5085
							],
							[
								37.002166,
								31.508413
							],
							[
								39.004886,
								32.010217
							],
							[
								39.195468,
								32.161009
							],
							[
								40.399994,
								31.889992
							],
							[
								41.889981,
								31.190009
							],
							[
								44.709499,
								29.178891
							],
							[
								46.568713,
								29.099025
							],
							[
								47.459822,
								29.002519
							],
							[
								47.708851,
								28.526063
							],
							[
								48.416094,
								28.552004
							],
							[
								48.807595,
								27.689628
							],
							[
								49.299554,
								27.461218
							],
							[
								49.470914,
								27.109999
							],
							[
								50.152422,
								26.689663
							],
							[
								50.212935,
								26.277027
							],
							[
								50.113303,
								25.943972
							],
							[
								50.239859,
								25.60805
							],
							[
								50.527387,
								25.327808
							],
							[
								50.660557,
								24.999896
							],
							[
								50.810108,
								24.754743
							],
							[
								51.112415,
								24.556331
							],
							[
								51.389608,
								24.627386
							],
							[
								51.579519,
								24.245497
							],
							[
								51.617708,
								24.014219
							],
							[
								52.000733,
								23.001154
							],
							[
								55.006803,
								22.496948
							],
							[
								55.208341,
								22.70833
							],
							[
								55.666659,
								22.000001
							],
							[
								54.999982,
								19.999994
							],
							[
								52.00001,
								19.000003
							],
							[
								49.116672,
								18.616668
							],
							[
								48.183344,
								18.166669
							],
							[
								47.466695,
								17.116682
							],
							[
								47.000005,
								16.949999
							],
							[
								46.749994,
								17.283338
							],
							[
								46.366659,
								17.233315
							],
							[
								45.399999,
								17.333335
							],
							[
								45.216651,
								17.433329
							],
							[
								44.062613,
								17.410359
							],
							[
								43.791519,
								17.319977
							],
							[
								43.380794,
								17.579987
							],
							[
								43.115798,
								17.08844
							],
							[
								43.218375,
								16.66689
							],
							[
								42.779332,
								16.347891
							]
						]
					]
				},
				"id": "SAU"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Sudan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.963393,
								9.464285
							],
							[
								33.824963,
								9.484061
							],
							[
								33.842131,
								9.981915
							],
							[
								33.721959,
								10.325262
							],
							[
								33.206938,
								10.720112
							],
							[
								33.086766,
								11.441141
							],
							[
								33.206938,
								12.179338
							],
							[
								32.743419,
								12.248008
							],
							[
								32.67475,
								12.024832
							],
							[
								32.073892,
								11.97333
							],
							[
								32.314235,
								11.681484
							],
							[
								32.400072,
								11.080626
							],
							[
								31.850716,
								10.531271
							],
							[
								31.352862,
								9.810241
							],
							[
								30.837841,
								9.707237
							],
							[
								29.996639,
								10.290927
							],
							[
								29.618957,
								10.084919
							],
							[
								29.515953,
								9.793074
							],
							[
								29.000932,
								9.604232
							],
							[
								28.966597,
								9.398224
							],
							[
								27.97089,
								9.398224
							],
							[
								27.833551,
								9.604232
							],
							[
								27.112521,
								9.638567
							],
							[
								26.752006,
								9.466893
							],
							[
								26.477328,
								9.55273
							],
							[
								25.962307,
								10.136421
							],
							[
								25.790633,
								10.411099
							],
							[
								25.069604,
								10.27376
							],
							[
								24.794926,
								9.810241
							],
							[
								24.537415,
								8.917538
							],
							[
								24.194068,
								8.728696
							],
							[
								23.88698,
								8.61973
							],
							[
								23.805813,
								8.666319
							],
							[
								23.459013,
								8.954286
							],
							[
								23.394779,
								9.265068
							],
							[
								23.55725,
								9.681218
							],
							[
								23.554304,
								10.089255
							],
							[
								22.977544,
								10.714463
							],
							[
								22.864165,
								11.142395
							],
							[
								22.87622,
								11.38461
							],
							[
								22.50869,
								11.67936
							],
							[
								22.49762,
								12.26024
							],
							[
								22.28801,
								12.64605
							],
							[
								21.93681,
								12.58818
							],
							[
								22.03759,
								12.95546
							],
							[
								22.29658,
								13.37232
							],
							[
								22.18329,
								13.78648
							],
							[
								22.51202,
								14.09318
							],
							[
								22.30351,
								14.32682
							],
							[
								22.56795,
								14.94429
							],
							[
								23.02459,
								15.68072
							],
							[
								23.88689,
								15.61084
							],
							[
								23.83766,
								19.58047
							],
							[
								23.85,
								20
							],
							[
								25,
								20.00304
							],
							[
								25,
								22
							],
							[
								29.02,
								22
							],
							[
								32.9,
								22
							],
							[
								36.86623,
								22
							],
							[
								37.18872,
								21.01885
							],
							[
								36.96941,
								20.83744
							],
							[
								37.1147,
								19.80796
							],
							[
								37.48179,
								18.61409
							],
							[
								37.86276,
								18.36786
							],
							[
								38.41009,
								17.998307
							],
							[
								37.904,
								17.42754
							],
							[
								37.16747,
								17.26314
							],
							[
								36.85253,
								16.95655
							],
							[
								36.75389,
								16.29186
							],
							[
								36.32322,
								14.82249
							],
							[
								36.42951,
								14.42211
							],
							[
								36.27022,
								13.56333
							],
							[
								35.86363,
								12.57828
							],
							[
								35.26049,
								12.08286
							],
							[
								34.83163,
								11.31896
							],
							[
								34.73115,
								10.91017
							],
							[
								34.25745,
								10.63009
							],
							[
								33.96162,
								9.58358
							],
							[
								33.963393,
								9.464285
							]
						]
					]
				},
				"id": "SDN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "South Sudan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.963393,
								9.464285
							],
							[
								33.97498,
								8.68456
							],
							[
								33.8255,
								8.37916
							],
							[
								33.2948,
								8.35458
							],
							[
								32.95418,
								7.78497
							],
							[
								33.56829,
								7.71334
							],
							[
								34.0751,
								7.22595
							],
							[
								34.25032,
								6.82607
							],
							[
								34.70702,
								6.59422
							],
							[
								35.298007,
								5.506
							],
							[
								34.620196,
								4.847123
							],
							[
								34.005,
								4.249885
							],
							[
								33.39,
								3.79
							],
							[
								32.68642,
								3.79232
							],
							[
								31.88145,
								3.55827
							],
							[
								31.24556,
								3.7819
							],
							[
								30.83385,
								3.50917
							],
							[
								29.95349,
								4.1737
							],
							[
								29.715995,
								4.600805
							],
							[
								29.159078,
								4.389267
							],
							[
								28.696678,
								4.455077
							],
							[
								28.428994,
								4.287155
							],
							[
								27.979977,
								4.408413
							],
							[
								27.374226,
								5.233944
							],
							[
								27.213409,
								5.550953
							],
							[
								26.465909,
								5.946717
							],
							[
								26.213418,
								6.546603
							],
							[
								25.796648,
								6.979316
							],
							[
								25.124131,
								7.500085
							],
							[
								25.114932,
								7.825104
							],
							[
								24.567369,
								8.229188
							],
							[
								23.88698,
								8.61973
							],
							[
								24.194068,
								8.728696
							],
							[
								24.537415,
								8.917538
							],
							[
								24.794926,
								9.810241
							],
							[
								25.069604,
								10.27376
							],
							[
								25.790633,
								10.411099
							],
							[
								25.962307,
								10.136421
							],
							[
								26.477328,
								9.55273
							],
							[
								26.752006,
								9.466893
							],
							[
								27.112521,
								9.638567
							],
							[
								27.833551,
								9.604232
							],
							[
								27.97089,
								9.398224
							],
							[
								28.966597,
								9.398224
							],
							[
								29.000932,
								9.604232
							],
							[
								29.515953,
								9.793074
							],
							[
								29.618957,
								10.084919
							],
							[
								29.996639,
								10.290927
							],
							[
								30.837841,
								9.707237
							],
							[
								31.352862,
								9.810241
							],
							[
								31.850716,
								10.531271
							],
							[
								32.400072,
								11.080626
							],
							[
								32.314235,
								11.681484
							],
							[
								32.073892,
								11.97333
							],
							[
								32.67475,
								12.024832
							],
							[
								32.743419,
								12.248008
							],
							[
								33.206938,
								12.179338
							],
							[
								33.086766,
								11.441141
							],
							[
								33.206938,
								10.720112
							],
							[
								33.721959,
								10.325262
							],
							[
								33.842131,
								9.981915
							],
							[
								33.824963,
								9.484061
							],
							[
								33.963393,
								9.464285
							]
						]
					]
				},
				"id": "SDS"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Senegal"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-16.713729,
								13.594959
							],
							[
								-17.126107,
								14.373516
							],
							[
								-17.625043,
								14.729541
							],
							[
								-17.185173,
								14.919477
							],
							[
								-16.700706,
								15.621527
							],
							[
								-16.463098,
								16.135036
							],
							[
								-16.12069,
								16.455663
							],
							[
								-15.623666,
								16.369337
							],
							[
								-15.135737,
								16.587282
							],
							[
								-14.577348,
								16.598264
							],
							[
								-14.099521,
								16.304302
							],
							[
								-13.435738,
								16.039383
							],
							[
								-12.830658,
								15.303692
							],
							[
								-12.17075,
								14.616834
							],
							[
								-12.124887,
								13.994727
							],
							[
								-11.927716,
								13.422075
							],
							[
								-11.553398,
								13.141214
							],
							[
								-11.467899,
								12.754519
							],
							[
								-11.513943,
								12.442988
							],
							[
								-11.658301,
								12.386583
							],
							[
								-12.203565,
								12.465648
							],
							[
								-12.278599,
								12.35444
							],
							[
								-12.499051,
								12.33209
							],
							[
								-13.217818,
								12.575874
							],
							[
								-13.700476,
								12.586183
							],
							[
								-15.548477,
								12.62817
							],
							[
								-15.816574,
								12.515567
							],
							[
								-16.147717,
								12.547762
							],
							[
								-16.677452,
								12.384852
							],
							[
								-16.841525,
								13.151394
							],
							[
								-15.931296,
								13.130284
							],
							[
								-15.691001,
								13.270353
							],
							[
								-15.511813,
								13.27857
							],
							[
								-15.141163,
								13.509512
							],
							[
								-14.712197,
								13.298207
							],
							[
								-14.277702,
								13.280585
							],
							[
								-13.844963,
								13.505042
							],
							[
								-14.046992,
								13.794068
							],
							[
								-14.376714,
								13.62568
							],
							[
								-14.687031,
								13.630357
							],
							[
								-15.081735,
								13.876492
							],
							[
								-15.39877,
								13.860369
							],
							[
								-15.624596,
								13.623587
							],
							[
								-16.713729,
								13.594959
							]
						]
					]
				},
				"id": "SEN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Solomon Islands"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									162.119025,
									-10.482719
								],
								[
									162.398646,
									-10.826367
								],
								[
									161.700032,
									-10.820011
								],
								[
									161.319797,
									-10.204751
								],
								[
									161.917383,
									-10.446701
								],
								[
									162.119025,
									-10.482719
								]
							]
						],
						[
							[
								[
									160.852229,
									-9.872937
								],
								[
									160.462588,
									-9.89521
								],
								[
									159.849447,
									-9.794027
								],
								[
									159.640003,
									-9.63998
								],
								[
									159.702945,
									-9.24295
								],
								[
									160.362956,
									-9.400304
								],
								[
									160.688518,
									-9.610162
								],
								[
									160.852229,
									-9.872937
								]
							]
						],
						[
							[
								[
									161.679982,
									-9.599982
								],
								[
									161.529397,
									-9.784312
								],
								[
									160.788253,
									-8.917543
								],
								[
									160.579997,
									-8.320009
								],
								[
									160.920028,
									-8.320009
								],
								[
									161.280006,
									-9.120011
								],
								[
									161.679982,
									-9.599982
								]
							]
						],
						[
							[
								[
									159.875027,
									-8.33732
								],
								[
									159.917402,
									-8.53829
								],
								[
									159.133677,
									-8.114181
								],
								[
									158.586114,
									-7.754824
								],
								[
									158.21115,
									-7.421872
								],
								[
									158.359978,
									-7.320018
								],
								[
									158.820001,
									-7.560003
								],
								[
									159.640003,
									-8.020027
								],
								[
									159.875027,
									-8.33732
								]
							]
						],
						[
							[
								[
									157.538426,
									-7.34782
								],
								[
									157.33942,
									-7.404767
								],
								[
									156.90203,
									-7.176874
								],
								[
									156.491358,
									-6.765943
								],
								[
									156.542828,
									-6.599338
								],
								[
									157.14,
									-7.021638
								],
								[
									157.538426,
									-7.34782
								]
							]
						]
					]
				},
				"id": "SLB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Sierra Leone"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-11.438779,
								6.785917
							],
							[
								-11.708195,
								6.860098
							],
							[
								-12.428099,
								7.262942
							],
							[
								-12.949049,
								7.798646
							],
							[
								-13.124025,
								8.163946
							],
							[
								-13.24655,
								8.903049
							],
							[
								-12.711958,
								9.342712
							],
							[
								-12.596719,
								9.620188
							],
							[
								-12.425929,
								9.835834
							],
							[
								-12.150338,
								9.858572
							],
							[
								-11.917277,
								10.046984
							],
							[
								-11.117481,
								10.045873
							],
							[
								-10.839152,
								9.688246
							],
							[
								-10.622395,
								9.26791
							],
							[
								-10.65477,
								8.977178
							],
							[
								-10.494315,
								8.715541
							],
							[
								-10.505477,
								8.348896
							],
							[
								-10.230094,
								8.406206
							],
							[
								-10.695595,
								7.939464
							],
							[
								-11.146704,
								7.396706
							],
							[
								-11.199802,
								7.105846
							],
							[
								-11.438779,
								6.785917
							]
						]
					]
				},
				"id": "SLE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "El Salvador"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-87.793111,
								13.38448
							],
							[
								-87.904112,
								13.149017
							],
							[
								-88.483302,
								13.163951
							],
							[
								-88.843228,
								13.259734
							],
							[
								-89.256743,
								13.458533
							],
							[
								-89.812394,
								13.520622
							],
							[
								-90.095555,
								13.735338
							],
							[
								-90.064678,
								13.88197
							],
							[
								-89.721934,
								14.134228
							],
							[
								-89.534219,
								14.244816
							],
							[
								-89.587343,
								14.362586
							],
							[
								-89.353326,
								14.424133
							],
							[
								-89.058512,
								14.340029
							],
							[
								-88.843073,
								14.140507
							],
							[
								-88.541231,
								13.980155
							],
							[
								-88.503998,
								13.845486
							],
							[
								-88.065343,
								13.964626
							],
							[
								-87.859515,
								13.893312
							],
							[
								-87.723503,
								13.78505
							],
							[
								-87.793111,
								13.38448
							]
						]
					]
				},
				"id": "SLV"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Somaliland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								48.93813,
								9.451749
							],
							[
								48.486736,
								8.837626
							],
							[
								47.78942,
								8.003
							],
							[
								46.948328,
								7.996877
							],
							[
								43.67875,
								9.18358
							],
							[
								43.296975,
								9.540477
							],
							[
								42.92812,
								10.02194
							],
							[
								42.55876,
								10.57258
							],
							[
								42.776852,
								10.926879
							],
							[
								43.145305,
								11.46204
							],
							[
								43.47066,
								11.27771
							],
							[
								43.666668,
								10.864169
							],
							[
								44.117804,
								10.445538
							],
							[
								44.614259,
								10.442205
							],
							[
								45.556941,
								10.698029
							],
							[
								46.645401,
								10.816549
							],
							[
								47.525658,
								11.127228
							],
							[
								48.021596,
								11.193064
							],
							[
								48.378784,
								11.375482
							],
							[
								48.948206,
								11.410622
							],
							[
								48.942005,
								11.394266
							],
							[
								48.938491,
								10.982327
							],
							[
								48.938233,
								9.9735
							],
							[
								48.93813,
								9.451749
							]
						]
					]
				},
				"id": "-99"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Somalia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								49.72862,
								11.5789
							],
							[
								50.25878,
								11.67957
							],
							[
								50.73202,
								12.0219
							],
							[
								51.1112,
								12.02464
							],
							[
								51.13387,
								11.74815
							],
							[
								51.04153,
								11.16651
							],
							[
								51.04531,
								10.6409
							],
							[
								50.83418,
								10.27972
							],
							[
								50.55239,
								9.19874
							],
							[
								50.07092,
								8.08173
							],
							[
								49.4527,
								6.80466
							],
							[
								48.59455,
								5.33911
							],
							[
								47.74079,
								4.2194
							],
							[
								46.56476,
								2.85529
							],
							[
								45.56399,
								2.04576
							],
							[
								44.06815,
								1.05283
							],
							[
								43.13597,
								0.2922
							],
							[
								42.04157,
								-0.91916
							],
							[
								41.81095,
								-1.44647
							],
							[
								41.58513,
								-1.68325
							],
							[
								40.993,
								-0.85829
							],
							[
								40.98105,
								2.78452
							],
							[
								41.855083,
								3.918912
							],
							[
								42.12861,
								4.23413
							],
							[
								42.76967,
								4.25259
							],
							[
								43.66087,
								4.95755
							],
							[
								44.9636,
								5.00162
							],
							[
								47.78942,
								8.003
							],
							[
								48.486736,
								8.837626
							],
							[
								48.93813,
								9.451749
							],
							[
								48.938233,
								9.9735
							],
							[
								48.938491,
								10.982327
							],
							[
								48.942005,
								11.394266
							],
							[
								48.948205,
								11.410617
							],
							[
								49.26776,
								11.43033
							],
							[
								49.72862,
								11.5789
							]
						]
					]
				},
				"id": "SOM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Republic of Serbia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.874313,
								45.416375
							],
							[
								21.483526,
								45.18117
							],
							[
								21.562023,
								44.768947
							],
							[
								22.145088,
								44.478422
							],
							[
								22.459022,
								44.702517
							],
							[
								22.705726,
								44.578003
							],
							[
								22.474008,
								44.409228
							],
							[
								22.65715,
								44.234923
							],
							[
								22.410446,
								44.008063
							],
							[
								22.500157,
								43.642814
							],
							[
								22.986019,
								43.211161
							],
							[
								22.604801,
								42.898519
							],
							[
								22.436595,
								42.580321
							],
							[
								22.545012,
								42.461362
							],
							[
								22.380526,
								42.32026
							],
							[
								21.91708,
								42.30364
							],
							[
								21.576636,
								42.245224
							],
							[
								21.54332,
								42.32025
							],
							[
								21.66292,
								42.43922
							],
							[
								21.77505,
								42.6827
							],
							[
								21.63302,
								42.67717
							],
							[
								21.43866,
								42.86255
							],
							[
								21.27421,
								42.90959
							],
							[
								21.143395,
								43.068685
							],
							[
								20.95651,
								43.13094
							],
							[
								20.81448,
								43.27205
							],
							[
								20.63508,
								43.21671
							],
							[
								20.49679,
								42.88469
							],
							[
								20.25758,
								42.81275
							],
							[
								20.3398,
								42.89852
							],
							[
								19.95857,
								43.10604
							],
							[
								19.63,
								43.21378
							],
							[
								19.48389,
								43.35229
							],
							[
								19.21852,
								43.52384
							],
							[
								19.454,
								43.5681
							],
							[
								19.59976,
								44.03847
							],
							[
								19.11761,
								44.42307
							],
							[
								19.36803,
								44.863
							],
							[
								19.00548,
								44.86023
							],
							[
								19.390476,
								45.236516
							],
							[
								19.072769,
								45.521511
							],
							[
								18.82982,
								45.90888
							],
							[
								19.596045,
								46.17173
							],
							[
								20.220192,
								46.127469
							],
							[
								20.762175,
								45.734573
							],
							[
								20.874313,
								45.416375
							]
						]
					]
				},
				"id": "SRB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Suriname"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-57.147436,
								5.97315
							],
							[
								-55.949318,
								5.772878
							],
							[
								-55.84178,
								5.953125
							],
							[
								-55.03325,
								6.025291
							],
							[
								-53.958045,
								5.756548
							],
							[
								-54.478633,
								4.896756
							],
							[
								-54.399542,
								4.212611
							],
							[
								-54.006931,
								3.620038
							],
							[
								-54.181726,
								3.18978
							],
							[
								-54.269705,
								2.732392
							],
							[
								-54.524754,
								2.311849
							],
							[
								-55.097587,
								2.523748
							],
							[
								-55.569755,
								2.421506
							],
							[
								-55.973322,
								2.510364
							],
							[
								-56.073342,
								2.220795
							],
							[
								-55.9056,
								2.021996
							],
							[
								-55.995698,
								1.817667
							],
							[
								-56.539386,
								1.899523
							],
							[
								-57.150098,
								2.768927
							],
							[
								-57.281433,
								3.333492
							],
							[
								-57.601569,
								3.334655
							],
							[
								-58.044694,
								4.060864
							],
							[
								-57.86021,
								4.576801
							],
							[
								-57.914289,
								4.812626
							],
							[
								-57.307246,
								5.073567
							],
							[
								-57.147436,
								5.97315
							]
						]
					]
				},
				"id": "SUR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Slovakia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								18.853144,
								49.49623
							],
							[
								18.909575,
								49.435846
							],
							[
								19.320713,
								49.571574
							],
							[
								19.825023,
								49.217125
							],
							[
								20.415839,
								49.431453
							],
							[
								20.887955,
								49.328772
							],
							[
								21.607808,
								49.470107
							],
							[
								22.558138,
								49.085738
							],
							[
								22.280842,
								48.825392
							],
							[
								22.085608,
								48.422264
							],
							[
								21.872236,
								48.319971
							],
							[
								20.801294,
								48.623854
							],
							[
								20.473562,
								48.56285
							],
							[
								20.239054,
								48.327567
							],
							[
								19.769471,
								48.202691
							],
							[
								19.661364,
								48.266615
							],
							[
								19.174365,
								48.111379
							],
							[
								18.777025,
								48.081768
							],
							[
								18.696513,
								47.880954
							],
							[
								17.857133,
								47.758429
							],
							[
								17.488473,
								47.867466
							],
							[
								16.979667,
								48.123497
							],
							[
								16.879983,
								48.470013
							],
							[
								16.960288,
								48.596982
							],
							[
								17.101985,
								48.816969
							],
							[
								17.545007,
								48.800019
							],
							[
								17.886485,
								48.903475
							],
							[
								17.913512,
								48.996493
							],
							[
								18.104973,
								49.043983
							],
							[
								18.170498,
								49.271515
							],
							[
								18.399994,
								49.315001
							],
							[
								18.554971,
								49.495015
							],
							[
								18.853144,
								49.49623
							]
						]
					]
				},
				"id": "SVK"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Slovenia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								13.806475,
								46.509306
							],
							[
								14.632472,
								46.431817
							],
							[
								15.137092,
								46.658703
							],
							[
								16.011664,
								46.683611
							],
							[
								16.202298,
								46.852386
							],
							[
								16.370505,
								46.841327
							],
							[
								16.564808,
								46.503751
							],
							[
								15.768733,
								46.238108
							],
							[
								15.67153,
								45.834154
							],
							[
								15.323954,
								45.731783
							],
							[
								15.327675,
								45.452316
							],
							[
								14.935244,
								45.471695
							],
							[
								14.595109,
								45.634941
							],
							[
								14.411968,
								45.466166
							],
							[
								13.71506,
								45.500324
							],
							[
								13.93763,
								45.591016
							],
							[
								13.69811,
								46.016778
							],
							[
								13.806475,
								46.509306
							]
						]
					]
				},
				"id": "SVN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Sweden"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								22.183173,
								65.723741
							],
							[
								21.213517,
								65.026005
							],
							[
								21.369631,
								64.413588
							],
							[
								19.778876,
								63.609554
							],
							[
								17.847779,
								62.7494
							],
							[
								17.119555,
								61.341166
							],
							[
								17.831346,
								60.636583
							],
							[
								18.787722,
								60.081914
							],
							[
								17.869225,
								58.953766
							],
							[
								16.829185,
								58.719827
							],
							[
								16.44771,
								57.041118
							],
							[
								15.879786,
								56.104302
							],
							[
								14.666681,
								56.200885
							],
							[
								14.100721,
								55.407781
							],
							[
								12.942911,
								55.361737
							],
							[
								12.625101,
								56.30708
							],
							[
								11.787942,
								57.441817
							],
							[
								11.027369,
								58.856149
							],
							[
								11.468272,
								59.432393
							],
							[
								12.300366,
								60.117933
							],
							[
								12.631147,
								61.293572
							],
							[
								11.992064,
								61.800362
							],
							[
								11.930569,
								63.128318
							],
							[
								12.579935,
								64.066219
							],
							[
								13.571916,
								64.049114
							],
							[
								13.919905,
								64.445421
							],
							[
								13.55569,
								64.787028
							],
							[
								15.108411,
								66.193867
							],
							[
								16.108712,
								67.302456
							],
							[
								16.768879,
								68.013937
							],
							[
								17.729182,
								68.010552
							],
							[
								17.993868,
								68.567391
							],
							[
								19.87856,
								68.407194
							],
							[
								20.025269,
								69.065139
							],
							[
								20.645593,
								69.106247
							],
							[
								21.978535,
								68.616846
							],
							[
								23.539473,
								67.936009
							],
							[
								23.56588,
								66.396051
							],
							[
								23.903379,
								66.006927
							],
							[
								22.183173,
								65.723741
							]
						]
					]
				},
				"id": "SWE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Swaziland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								32.071665,
								-26.73382
							],
							[
								31.86806,
								-27.177927
							],
							[
								31.282773,
								-27.285879
							],
							[
								30.685962,
								-26.743845
							],
							[
								30.676609,
								-26.398078
							],
							[
								30.949667,
								-26.022649
							],
							[
								31.04408,
								-25.731452
							],
							[
								31.333158,
								-25.660191
							],
							[
								31.837778,
								-25.843332
							],
							[
								31.985779,
								-26.29178
							],
							[
								32.071665,
								-26.73382
							]
						]
					]
				},
				"id": "SWZ"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Syria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								38.792341,
								33.378686
							],
							[
								36.834062,
								32.312938
							],
							[
								35.719918,
								32.709192
							],
							[
								35.700798,
								32.716014
							],
							[
								35.836397,
								32.868123
							],
							[
								35.821101,
								33.277426
							],
							[
								36.06646,
								33.824912
							],
							[
								36.61175,
								34.201789
							],
							[
								36.448194,
								34.593935
							],
							[
								35.998403,
								34.644914
							],
							[
								35.905023,
								35.410009
							],
							[
								36.149763,
								35.821535
							],
							[
								36.41755,
								36.040617
							],
							[
								36.685389,
								36.259699
							],
							[
								36.739494,
								36.81752
							],
							[
								37.066761,
								36.623036
							],
							[
								38.167727,
								36.90121
							],
							[
								38.699891,
								36.712927
							],
							[
								39.52258,
								36.716054
							],
							[
								40.673259,
								37.091276
							],
							[
								41.212089,
								37.074352
							],
							[
								42.349591,
								37.229873
							],
							[
								41.837064,
								36.605854
							],
							[
								41.289707,
								36.358815
							],
							[
								41.383965,
								35.628317
							],
							[
								41.006159,
								34.419372
							],
							[
								38.792341,
								33.378686
							]
						]
					]
				},
				"id": "SYR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Chad"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								14.495787,
								12.859396
							],
							[
								14.595781,
								13.330427
							],
							[
								13.954477,
								13.353449
							],
							[
								13.956699,
								13.996691
							],
							[
								13.540394,
								14.367134
							],
							[
								13.97217,
								15.68437
							],
							[
								15.247731,
								16.627306
							],
							[
								15.300441,
								17.92795
							],
							[
								15.685741,
								19.95718
							],
							[
								15.903247,
								20.387619
							],
							[
								15.487148,
								20.730415
							],
							[
								15.47106,
								21.04845
							],
							[
								15.096888,
								21.308519
							],
							[
								14.8513,
								22.86295
							],
							[
								15.86085,
								23.40972
							],
							[
								19.84926,
								21.49509
							],
							[
								23.83766,
								19.58047
							],
							[
								23.88689,
								15.61084
							],
							[
								23.02459,
								15.68072
							],
							[
								22.56795,
								14.94429
							],
							[
								22.30351,
								14.32682
							],
							[
								22.51202,
								14.09318
							],
							[
								22.18329,
								13.78648
							],
							[
								22.29658,
								13.37232
							],
							[
								22.03759,
								12.95546
							],
							[
								21.93681,
								12.58818
							],
							[
								22.28801,
								12.64605
							],
							[
								22.49762,
								12.26024
							],
							[
								22.50869,
								11.67936
							],
							[
								22.87622,
								11.38461
							],
							[
								22.864165,
								11.142395
							],
							[
								22.231129,
								10.971889
							],
							[
								21.723822,
								10.567056
							],
							[
								21.000868,
								9.475985
							],
							[
								20.059685,
								9.012706
							],
							[
								19.094008,
								9.074847
							],
							[
								18.81201,
								8.982915
							],
							[
								18.911022,
								8.630895
							],
							[
								18.389555,
								8.281304
							],
							[
								17.96493,
								7.890914
							],
							[
								16.705988,
								7.508328
							],
							[
								16.456185,
								7.734774
							],
							[
								16.290562,
								7.754307
							],
							[
								16.106232,
								7.497088
							],
							[
								15.27946,
								7.421925
							],
							[
								15.436092,
								7.692812
							],
							[
								15.120866,
								8.38215
							],
							[
								14.979996,
								8.796104
							],
							[
								14.544467,
								8.965861
							],
							[
								13.954218,
								9.549495
							],
							[
								14.171466,
								10.021378
							],
							[
								14.627201,
								9.920919
							],
							[
								14.909354,
								9.992129
							],
							[
								15.467873,
								9.982337
							],
							[
								14.923565,
								10.891325
							],
							[
								14.960152,
								11.555574
							],
							[
								14.89336,
								12.21905
							],
							[
								14.495787,
								12.859396
							]
						]
					]
				},
				"id": "TCD"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Togo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								1.865241,
								6.142158
							],
							[
								1.060122,
								5.928837
							],
							[
								0.836931,
								6.279979
							],
							[
								0.570384,
								6.914359
							],
							[
								0.490957,
								7.411744
							],
							[
								0.712029,
								8.312465
							],
							[
								0.461192,
								8.677223
							],
							[
								0.365901,
								9.465004
							],
							[
								0.36758,
								10.191213
							],
							[
								-0.049785,
								10.706918
							],
							[
								0.023803,
								11.018682
							],
							[
								0.899563,
								10.997339
							],
							[
								0.772336,
								10.470808
							],
							[
								1.077795,
								10.175607
							],
							[
								1.425061,
								9.825395
							],
							[
								1.463043,
								9.334624
							],
							[
								1.664478,
								9.12859
							],
							[
								1.618951,
								6.832038
							],
							[
								1.865241,
								6.142158
							]
						]
					]
				},
				"id": "TGO"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Thailand"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								102.584932,
								12.186595
							],
							[
								101.687158,
								12.64574
							],
							[
								100.83181,
								12.627085
							],
							[
								100.978467,
								13.412722
							],
							[
								100.097797,
								13.406856
							],
							[
								100.018733,
								12.307001
							],
							[
								99.478921,
								10.846367
							],
							[
								99.153772,
								9.963061
							],
							[
								99.222399,
								9.239255
							],
							[
								99.873832,
								9.207862
							],
							[
								100.279647,
								8.295153
							],
							[
								100.459274,
								7.429573
							],
							[
								101.017328,
								6.856869
							],
							[
								101.623079,
								6.740622
							],
							[
								102.141187,
								6.221636
							],
							[
								101.814282,
								5.810808
							],
							[
								101.154219,
								5.691384
							],
							[
								101.075516,
								6.204867
							],
							[
								100.259596,
								6.642825
							],
							[
								100.085757,
								6.464489
							],
							[
								99.690691,
								6.848213
							],
							[
								99.519642,
								7.343454
							],
							[
								98.988253,
								7.907993
							],
							[
								98.503786,
								8.382305
							],
							[
								98.339662,
								7.794512
							],
							[
								98.150009,
								8.350007
							],
							[
								98.25915,
								8.973923
							],
							[
								98.553551,
								9.93296
							],
							[
								99.038121,
								10.960546
							],
							[
								99.587286,
								11.892763
							],
							[
								99.196354,
								12.804748
							],
							[
								99.212012,
								13.269294
							],
							[
								99.097755,
								13.827503
							],
							[
								98.430819,
								14.622028
							],
							[
								98.192074,
								15.123703
							],
							[
								98.537376,
								15.308497
							],
							[
								98.903348,
								16.177824
							],
							[
								98.493761,
								16.837836
							],
							[
								97.859123,
								17.567946
							],
							[
								97.375896,
								18.445438
							],
							[
								97.797783,
								18.62708
							],
							[
								98.253724,
								19.708203
							],
							[
								98.959676,
								19.752981
							],
							[
								99.543309,
								20.186598
							],
							[
								100.115988,
								20.41785
							],
							[
								100.548881,
								20.109238
							],
							[
								100.606294,
								19.508344
							],
							[
								101.282015,
								19.462585
							],
							[
								101.035931,
								18.408928
							],
							[
								101.059548,
								17.512497
							],
							[
								102.113592,
								18.109102
							],
							[
								102.413005,
								17.932782
							],
							[
								102.998706,
								17.961695
							],
							[
								103.200192,
								18.309632
							],
							[
								103.956477,
								18.240954
							],
							[
								104.716947,
								17.428859
							],
							[
								104.779321,
								16.441865
							],
							[
								105.589039,
								15.570316
							],
							[
								105.544338,
								14.723934
							],
							[
								105.218777,
								14.273212
							],
							[
								104.281418,
								14.416743
							],
							[
								102.988422,
								14.225721
							],
							[
								102.348099,
								13.394247
							],
							[
								102.584932,
								12.186595
							]
						]
					]
				},
				"id": "THA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Tajikistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								71.014198,
								40.244366
							],
							[
								70.648019,
								39.935754
							],
							[
								69.55961,
								40.103211
							],
							[
								69.464887,
								39.526683
							],
							[
								70.549162,
								39.604198
							],
							[
								71.784694,
								39.279463
							],
							[
								73.675379,
								39.431237
							],
							[
								73.928852,
								38.505815
							],
							[
								74.257514,
								38.606507
							],
							[
								74.864816,
								38.378846
							],
							[
								74.829986,
								37.990007
							],
							[
								74.980002,
								37.41999
							],
							[
								73.948696,
								37.421566
							],
							[
								73.260056,
								37.495257
							],
							[
								72.63689,
								37.047558
							],
							[
								72.193041,
								36.948288
							],
							[
								71.844638,
								36.738171
							],
							[
								71.448693,
								37.065645
							],
							[
								71.541918,
								37.905774
							],
							[
								71.239404,
								37.953265
							],
							[
								71.348131,
								38.258905
							],
							[
								70.806821,
								38.486282
							],
							[
								70.376304,
								38.138396
							],
							[
								70.270574,
								37.735165
							],
							[
								70.116578,
								37.588223
							],
							[
								69.518785,
								37.608997
							],
							[
								69.196273,
								37.151144
							],
							[
								68.859446,
								37.344336
							],
							[
								68.135562,
								37.023115
							],
							[
								67.83,
								37.144994
							],
							[
								68.392033,
								38.157025
							],
							[
								68.176025,
								38.901553
							],
							[
								67.44222,
								39.140144
							],
							[
								67.701429,
								39.580478
							],
							[
								68.536416,
								39.533453
							],
							[
								69.011633,
								40.086158
							],
							[
								69.329495,
								40.727824
							],
							[
								70.666622,
								40.960213
							],
							[
								70.45816,
								40.496495
							],
							[
								70.601407,
								40.218527
							],
							[
								71.014198,
								40.244366
							]
						]
					]
				},
				"id": "TJK"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Turkmenistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								61.210817,
								35.650072
							],
							[
								61.123071,
								36.491597
							],
							[
								60.377638,
								36.527383
							],
							[
								59.234762,
								37.412988
							],
							[
								58.436154,
								37.522309
							],
							[
								57.330434,
								38.029229
							],
							[
								56.619366,
								38.121394
							],
							[
								56.180375,
								37.935127
							],
							[
								55.511578,
								37.964117
							],
							[
								54.800304,
								37.392421
							],
							[
								53.921598,
								37.198918
							],
							[
								53.735511,
								37.906136
							],
							[
								53.880929,
								38.952093
							],
							[
								53.101028,
								39.290574
							],
							[
								53.357808,
								39.975286
							],
							[
								52.693973,
								40.033629
							],
							[
								52.915251,
								40.876523
							],
							[
								53.858139,
								40.631034
							],
							[
								54.736845,
								40.951015
							],
							[
								54.008311,
								41.551211
							],
							[
								53.721713,
								42.123191
							],
							[
								52.91675,
								41.868117
							],
							[
								52.814689,
								41.135371
							],
							[
								52.50246,
								41.783316
							],
							[
								52.944293,
								42.116034
							],
							[
								54.079418,
								42.324109
							],
							[
								54.755345,
								42.043971
							],
							[
								55.455251,
								41.259859
							],
							[
								55.968191,
								41.308642
							],
							[
								57.096391,
								41.32231
							],
							[
								56.932215,
								41.826026
							],
							[
								57.78653,
								42.170553
							],
							[
								58.629011,
								42.751551
							],
							[
								59.976422,
								42.223082
							],
							[
								60.083341,
								41.425146
							],
							[
								60.465953,
								41.220327
							],
							[
								61.547179,
								41.26637
							],
							[
								61.882714,
								41.084857
							],
							[
								62.37426,
								40.053886
							],
							[
								63.518015,
								39.363257
							],
							[
								64.170223,
								38.892407
							],
							[
								65.215999,
								38.402695
							],
							[
								66.54615,
								37.974685
							],
							[
								66.518607,
								37.362784
							],
							[
								66.217385,
								37.39379
							],
							[
								65.745631,
								37.661164
							],
							[
								65.588948,
								37.305217
							],
							[
								64.746105,
								37.111818
							],
							[
								64.546479,
								36.312073
							],
							[
								63.982896,
								36.007957
							],
							[
								63.193538,
								35.857166
							],
							[
								62.984662,
								35.404041
							],
							[
								62.230651,
								35.270664
							],
							[
								61.210817,
								35.650072
							]
						]
					]
				},
				"id": "TKM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "East Timor"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								124.968682,
								-8.89279
							],
							[
								125.086246,
								-8.656887
							],
							[
								125.947072,
								-8.432095
							],
							[
								126.644704,
								-8.398247
							],
							[
								126.957243,
								-8.273345
							],
							[
								127.335928,
								-8.397317
							],
							[
								126.967992,
								-8.668256
							],
							[
								125.925885,
								-9.106007
							],
							[
								125.08852,
								-9.393173
							],
							[
								125.07002,
								-9.089987
							],
							[
								124.968682,
								-8.89279
							]
						]
					]
				},
				"id": "TLS"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Trinidad and Tobago"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-61.68,
								10.76
							],
							[
								-61.105,
								10.89
							],
							[
								-60.895,
								10.855
							],
							[
								-60.935,
								10.11
							],
							[
								-61.77,
								10
							],
							[
								-61.95,
								10.09
							],
							[
								-61.66,
								10.365
							],
							[
								-61.68,
								10.76
							]
						]
					]
				},
				"id": "TTO"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Tunisia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.48214,
								30.307556
							],
							[
								9.055603,
								32.102692
							],
							[
								8.439103,
								32.506285
							],
							[
								8.430473,
								32.748337
							],
							[
								7.612642,
								33.344115
							],
							[
								7.524482,
								34.097376
							],
							[
								8.140981,
								34.655146
							],
							[
								8.376368,
								35.479876
							],
							[
								8.217824,
								36.433177
							],
							[
								8.420964,
								36.946427
							],
							[
								9.509994,
								37.349994
							],
							[
								10.210002,
								37.230002
							],
							[
								10.18065,
								36.724038
							],
							[
								11.028867,
								37.092103
							],
							[
								11.100026,
								36.899996
							],
							[
								10.600005,
								36.41
							],
							[
								10.593287,
								35.947444
							],
							[
								10.939519,
								35.698984
							],
							[
								10.807847,
								34.833507
							],
							[
								10.149593,
								34.330773
							],
							[
								10.339659,
								33.785742
							],
							[
								10.856836,
								33.76874
							],
							[
								11.108501,
								33.293343
							],
							[
								11.488787,
								33.136996
							],
							[
								11.432253,
								32.368903
							],
							[
								10.94479,
								32.081815
							],
							[
								10.636901,
								31.761421
							],
							[
								9.950225,
								31.37607
							],
							[
								10.056575,
								30.961831
							],
							[
								9.970017,
								30.539325
							],
							[
								9.48214,
								30.307556
							]
						]
					]
				},
				"id": "TUN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Turkey"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									36.913127,
									41.335358
								],
								[
									38.347665,
									40.948586
								],
								[
									39.512607,
									41.102763
								],
								[
									40.373433,
									41.013673
								],
								[
									41.554084,
									41.535656
								],
								[
									42.619549,
									41.583173
								],
								[
									43.582746,
									41.092143
								],
								[
									43.752658,
									40.740201
								],
								[
									43.656436,
									40.253564
								],
								[
									44.400009,
									40.005
								],
								[
									44.79399,
									39.713003
								],
								[
									44.109225,
									39.428136
								],
								[
									44.421403,
									38.281281
								],
								[
									44.225756,
									37.971584
								],
								[
									44.772699,
									37.170445
								],
								[
									44.293452,
									37.001514
								],
								[
									43.942259,
									37.256228
								],
								[
									42.779126,
									37.385264
								],
								[
									42.349591,
									37.229873
								],
								[
									41.212089,
									37.074352
								],
								[
									40.673259,
									37.091276
								],
								[
									39.52258,
									36.716054
								],
								[
									38.699891,
									36.712927
								],
								[
									38.167727,
									36.90121
								],
								[
									37.066761,
									36.623036
								],
								[
									36.739494,
									36.81752
								],
								[
									36.685389,
									36.259699
								],
								[
									36.41755,
									36.040617
								],
								[
									36.149763,
									35.821535
								],
								[
									35.782085,
									36.274995
								],
								[
									36.160822,
									36.650606
								],
								[
									35.550936,
									36.565443
								],
								[
									34.714553,
									36.795532
								],
								[
									34.026895,
									36.21996
								],
								[
									32.509158,
									36.107564
								],
								[
									31.699595,
									36.644275
								],
								[
									30.621625,
									36.677865
								],
								[
									30.391096,
									36.262981
								],
								[
									29.699976,
									36.144357
								],
								[
									28.732903,
									36.676831
								],
								[
									27.641187,
									36.658822
								],
								[
									27.048768,
									37.653361
								],
								[
									26.318218,
									38.208133
								],
								[
									26.8047,
									38.98576
								],
								[
									26.170785,
									39.463612
								],
								[
									27.28002,
									40.420014
								],
								[
									28.819978,
									40.460011
								],
								[
									29.240004,
									41.219991
								],
								[
									31.145934,
									41.087622
								],
								[
									32.347979,
									41.736264
								],
								[
									33.513283,
									42.01896
								],
								[
									35.167704,
									42.040225
								],
								[
									36.913127,
									41.335358
								]
							]
						],
						[
							[
								[
									27.192377,
									40.690566
								],
								[
									26.358009,
									40.151994
								],
								[
									26.043351,
									40.617754
								],
								[
									26.056942,
									40.824123
								],
								[
									26.294602,
									40.936261
								],
								[
									26.604196,
									41.562115
								],
								[
									26.117042,
									41.826905
								],
								[
									27.135739,
									42.141485
								],
								[
									27.99672,
									42.007359
								],
								[
									28.115525,
									41.622886
								],
								[
									28.988443,
									41.299934
								],
								[
									28.806438,
									41.054962
								],
								[
									27.619017,
									40.999823
								],
								[
									27.192377,
									40.690566
								]
							]
						]
					]
				},
				"id": "TUR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Taiwan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								121.777818,
								24.394274
							],
							[
								121.175632,
								22.790857
							],
							[
								120.74708,
								21.970571
							],
							[
								120.220083,
								22.814861
							],
							[
								120.106189,
								23.556263
							],
							[
								120.69468,
								24.538451
							],
							[
								121.495044,
								25.295459
							],
							[
								121.951244,
								24.997596
							],
							[
								121.777818,
								24.394274
							]
						]
					]
				},
				"id": "TWN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "United Republic of Tanzania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.903711,
								-0.95
							],
							[
								34.07262,
								-1.05982
							],
							[
								37.69869,
								-3.09699
							],
							[
								37.7669,
								-3.67712
							],
							[
								39.20222,
								-4.67677
							],
							[
								38.74054,
								-5.90895
							],
							[
								38.79977,
								-6.47566
							],
							[
								39.44,
								-6.84
							],
							[
								39.47,
								-7.1
							],
							[
								39.19469,
								-7.7039
							],
							[
								39.25203,
								-8.00781
							],
							[
								39.18652,
								-8.48551
							],
							[
								39.53574,
								-9.11237
							],
							[
								39.9496,
								-10.0984
							],
							[
								40.31659,
								-10.3171
							],
							[
								39.521,
								-10.89688
							],
							[
								38.427557,
								-11.285202
							],
							[
								37.82764,
								-11.26879
							],
							[
								37.47129,
								-11.56876
							],
							[
								36.775151,
								-11.594537
							],
							[
								36.514082,
								-11.720938
							],
							[
								35.312398,
								-11.439146
							],
							[
								34.559989,
								-11.52002
							],
							[
								34.28,
								-10.16
							],
							[
								33.940838,
								-9.693674
							],
							[
								33.73972,
								-9.41715
							],
							[
								32.759375,
								-9.230599
							],
							[
								32.191865,
								-8.930359
							],
							[
								31.556348,
								-8.762049
							],
							[
								31.157751,
								-8.594579
							],
							[
								30.74,
								-8.34
							],
							[
								30.2,
								-7.08
							],
							[
								29.62,
								-6.52
							],
							[
								29.419993,
								-5.939999
							],
							[
								29.519987,
								-5.419979
							],
							[
								29.339998,
								-4.499983
							],
							[
								29.753512,
								-4.452389
							],
							[
								30.11632,
								-4.09012
							],
							[
								30.50554,
								-3.56858
							],
							[
								30.75224,
								-3.35931
							],
							[
								30.74301,
								-3.03431
							],
							[
								30.52766,
								-2.80762
							],
							[
								30.46967,
								-2.41383
							],
							[
								30.758309,
								-2.28725
							],
							[
								30.816135,
								-1.698914
							],
							[
								30.419105,
								-1.134659
							],
							[
								30.76986,
								-1.01455
							],
							[
								31.86617,
								-1.02736
							],
							[
								33.903711,
								-0.95
							]
						]
					]
				},
				"id": "TZA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Uganda"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.86617,
								-1.02736
							],
							[
								30.76986,
								-1.01455
							],
							[
								30.419105,
								-1.134659
							],
							[
								29.821519,
								-1.443322
							],
							[
								29.579466,
								-1.341313
							],
							[
								29.587838,
								-0.587406
							],
							[
								29.8195,
								-0.2053
							],
							[
								29.875779,
								0.59738
							],
							[
								30.086154,
								1.062313
							],
							[
								30.468508,
								1.583805
							],
							[
								30.85267,
								1.849396
							],
							[
								31.174149,
								2.204465
							],
							[
								30.77332,
								2.33989
							],
							[
								30.83385,
								3.50917
							],
							[
								31.24556,
								3.7819
							],
							[
								31.88145,
								3.55827
							],
							[
								32.68642,
								3.79232
							],
							[
								33.39,
								3.79
							],
							[
								34.005,
								4.249885
							],
							[
								34.47913,
								3.5556
							],
							[
								34.59607,
								3.05374
							],
							[
								35.03599,
								1.90584
							],
							[
								34.6721,
								1.17694
							],
							[
								34.18,
								0.515
							],
							[
								33.893569,
								0.109814
							],
							[
								33.903711,
								-0.95
							],
							[
								31.86617,
								-1.02736
							]
						]
					]
				},
				"id": "UGA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Ukraine"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.785998,
								52.101678
							],
							[
								32.159412,
								52.061267
							],
							[
								32.412058,
								52.288695
							],
							[
								32.715761,
								52.238465
							],
							[
								33.7527,
								52.335075
							],
							[
								34.391731,
								51.768882
							],
							[
								34.141978,
								51.566413
							],
							[
								34.224816,
								51.255993
							],
							[
								35.022183,
								51.207572
							],
							[
								35.377924,
								50.773955
							],
							[
								35.356116,
								50.577197
							],
							[
								36.626168,
								50.225591
							],
							[
								37.39346,
								50.383953
							],
							[
								38.010631,
								49.915662
							],
							[
								38.594988,
								49.926462
							],
							[
								40.069058,
								49.601055
							],
							[
								40.080789,
								49.30743
							],
							[
								39.674664,
								48.783818
							],
							[
								39.895632,
								48.232405
							],
							[
								39.738278,
								47.898937
							],
							[
								38.770585,
								47.825608
							],
							[
								38.255112,
								47.5464
							],
							[
								38.223538,
								47.10219
							],
							[
								37.425137,
								47.022221
							],
							[
								36.759855,
								46.6987
							],
							[
								35.823685,
								46.645964
							],
							[
								34.962342,
								46.273197
							],
							[
								35.020788,
								45.651219
							],
							[
								35.510009,
								45.409993
							],
							[
								36.529998,
								45.46999
							],
							[
								36.334713,
								45.113216
							],
							[
								35.239999,
								44.939996
							],
							[
								33.882511,
								44.361479
							],
							[
								33.326421,
								44.564877
							],
							[
								33.546924,
								45.034771
							],
							[
								32.454174,
								45.327466
							],
							[
								32.630804,
								45.519186
							],
							[
								33.588162,
								45.851569
							],
							[
								33.298567,
								46.080598
							],
							[
								31.74414,
								46.333348
							],
							[
								31.675307,
								46.706245
							],
							[
								30.748749,
								46.5831
							],
							[
								30.377609,
								46.03241
							],
							[
								29.603289,
								45.293308
							],
							[
								29.149725,
								45.464925
							],
							[
								28.679779,
								45.304031
							],
							[
								28.233554,
								45.488283
							],
							[
								28.485269,
								45.596907
							],
							[
								28.659987,
								45.939987
							],
							[
								28.933717,
								46.25883
							],
							[
								28.862972,
								46.437889
							],
							[
								29.072107,
								46.517678
							],
							[
								29.170654,
								46.379262
							],
							[
								29.759972,
								46.349988
							],
							[
								30.024659,
								46.423937
							],
							[
								29.83821,
								46.525326
							],
							[
								29.908852,
								46.674361
							],
							[
								29.559674,
								46.928583
							],
							[
								29.415135,
								47.346645
							],
							[
								29.050868,
								47.510227
							],
							[
								29.122698,
								47.849095
							],
							[
								28.670891,
								48.118149
							],
							[
								28.259547,
								48.155562
							],
							[
								27.522537,
								48.467119
							],
							[
								26.857824,
								48.368211
							],
							[
								26.619337,
								48.220726
							],
							[
								26.19745,
								48.220881
							],
							[
								25.945941,
								47.987149
							],
							[
								25.207743,
								47.891056
							],
							[
								24.866317,
								47.737526
							],
							[
								24.402056,
								47.981878
							],
							[
								23.760958,
								47.985598
							],
							[
								23.142236,
								48.096341
							],
							[
								22.710531,
								47.882194
							],
							[
								22.64082,
								48.15024
							],
							[
								22.085608,
								48.422264
							],
							[
								22.280842,
								48.825392
							],
							[
								22.558138,
								49.085738
							],
							[
								22.776419,
								49.027395
							],
							[
								22.51845,
								49.476774
							],
							[
								23.426508,
								50.308506
							],
							[
								23.922757,
								50.424881
							],
							[
								24.029986,
								50.705407
							],
							[
								23.527071,
								51.578454
							],
							[
								24.005078,
								51.617444
							],
							[
								24.553106,
								51.888461
							],
							[
								25.327788,
								51.910656
							],
							[
								26.337959,
								51.832289
							],
							[
								27.454066,
								51.592303
							],
							[
								28.241615,
								51.572227
							],
							[
								28.617613,
								51.427714
							],
							[
								28.992835,
								51.602044
							],
							[
								29.254938,
								51.368234
							],
							[
								30.157364,
								51.416138
							],
							[
								30.555117,
								51.319503
							],
							[
								30.619454,
								51.822806
							],
							[
								30.927549,
								52.042353
							],
							[
								31.785998,
								52.101678
							]
						]
					]
				},
				"id": "UKR"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Uruguay"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-57.625133,
								-30.216295
							],
							[
								-56.976026,
								-30.109686
							],
							[
								-55.973245,
								-30.883076
							],
							[
								-55.60151,
								-30.853879
							],
							[
								-54.572452,
								-31.494511
							],
							[
								-53.787952,
								-32.047243
							],
							[
								-53.209589,
								-32.727666
							],
							[
								-53.650544,
								-33.202004
							],
							[
								-53.373662,
								-33.768378
							],
							[
								-53.806426,
								-34.396815
							],
							[
								-54.935866,
								-34.952647
							],
							[
								-55.67409,
								-34.752659
							],
							[
								-56.215297,
								-34.859836
							],
							[
								-57.139685,
								-34.430456
							],
							[
								-57.817861,
								-34.462547
							],
							[
								-58.427074,
								-33.909454
							],
							[
								-58.349611,
								-33.263189
							],
							[
								-58.132648,
								-33.040567
							],
							[
								-58.14244,
								-32.044504
							],
							[
								-57.874937,
								-31.016556
							],
							[
								-57.625133,
								-30.216295
							]
						]
					]
				},
				"id": "URY"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "United States"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-155.54211,
									19.08348
								],
								[
									-155.68817,
									18.91619
								],
								[
									-155.93665,
									19.05939
								],
								[
									-155.90806,
									19.33888
								],
								[
									-156.07347,
									19.70294
								],
								[
									-156.02368,
									19.81422
								],
								[
									-155.85008,
									19.97729
								],
								[
									-155.91907,
									20.17395
								],
								[
									-155.86108,
									20.26721
								],
								[
									-155.78505,
									20.2487
								],
								[
									-155.40214,
									20.07975
								],
								[
									-155.22452,
									19.99302
								],
								[
									-155.06226,
									19.8591
								],
								[
									-154.80741,
									19.50871
								],
								[
									-154.83147,
									19.45328
								],
								[
									-155.22217,
									19.23972
								],
								[
									-155.54211,
									19.08348
								]
							]
						],
						[
							[
								[
									-156.07926,
									20.64397
								],
								[
									-156.41445,
									20.57241
								],
								[
									-156.58673,
									20.783
								],
								[
									-156.70167,
									20.8643
								],
								[
									-156.71055,
									20.92676
								],
								[
									-156.61258,
									21.01249
								],
								[
									-156.25711,
									20.91745
								],
								[
									-155.99566,
									20.76404
								],
								[
									-156.07926,
									20.64397
								]
							]
						],
						[
							[
								[
									-156.75824,
									21.17684
								],
								[
									-156.78933,
									21.06873
								],
								[
									-157.32521,
									21.09777
								],
								[
									-157.25027,
									21.21958
								],
								[
									-156.75824,
									21.17684
								]
							]
						],
						[
							[
								[
									-157.65283,
									21.32217
								],
								[
									-157.70703,
									21.26442
								],
								[
									-157.7786,
									21.27729
								],
								[
									-158.12667,
									21.31244
								],
								[
									-158.2538,
									21.53919
								],
								[
									-158.29265,
									21.57912
								],
								[
									-158.0252,
									21.71696
								],
								[
									-157.94161,
									21.65272
								],
								[
									-157.65283,
									21.32217
								]
							]
						],
						[
							[
								[
									-159.34512,
									21.982
								],
								[
									-159.46372,
									21.88299
								],
								[
									-159.80051,
									22.06533
								],
								[
									-159.74877,
									22.1382
								],
								[
									-159.5962,
									22.23618
								],
								[
									-159.36569,
									22.21494
								],
								[
									-159.34512,
									21.982
								]
							]
						],
						[
							[
								[
									-94.81758,
									49.38905
								],
								[
									-94.64,
									48.84
								],
								[
									-94.32914,
									48.67074
								],
								[
									-93.63087,
									48.60926
								],
								[
									-92.61,
									48.45
								],
								[
									-91.64,
									48.14
								],
								[
									-90.83,
									48.27
								],
								[
									-89.6,
									48.01
								],
								[
									-89.272917,
									48.019808
								],
								[
									-88.378114,
									48.302918
								],
								[
									-87.439793,
									47.94
								],
								[
									-86.461991,
									47.553338
								],
								[
									-85.652363,
									47.220219
								],
								[
									-84.87608,
									46.900083
								],
								[
									-84.779238,
									46.637102
								],
								[
									-84.543749,
									46.538684
								],
								[
									-84.6049,
									46.4396
								],
								[
									-84.3367,
									46.40877
								],
								[
									-84.14212,
									46.512226
								],
								[
									-84.091851,
									46.275419
								],
								[
									-83.890765,
									46.116927
								],
								[
									-83.616131,
									46.116927
								],
								[
									-83.469551,
									45.994686
								],
								[
									-83.592851,
									45.816894
								],
								[
									-82.550925,
									45.347517
								],
								[
									-82.337763,
									44.44
								],
								[
									-82.137642,
									43.571088
								],
								[
									-82.43,
									42.98
								],
								[
									-82.9,
									42.43
								],
								[
									-83.12,
									42.08
								],
								[
									-83.142,
									41.975681
								],
								[
									-83.02981,
									41.832796
								],
								[
									-82.690089,
									41.675105
								],
								[
									-82.439278,
									41.675105
								],
								[
									-81.277747,
									42.209026
								],
								[
									-80.247448,
									42.3662
								],
								[
									-78.939362,
									42.863611
								],
								[
									-78.92,
									42.965
								],
								[
									-79.01,
									43.27
								],
								[
									-79.171674,
									43.466339
								],
								[
									-78.72028,
									43.625089
								],
								[
									-77.737885,
									43.629056
								],
								[
									-76.820034,
									43.628784
								],
								[
									-76.5,
									44.018459
								],
								[
									-76.375,
									44.09631
								],
								[
									-75.31821,
									44.81645
								],
								[
									-74.867,
									45.00048
								],
								[
									-73.34783,
									45.00738
								],
								[
									-71.50506,
									45.0082
								],
								[
									-71.405,
									45.255
								],
								[
									-71.08482,
									45.30524
								],
								[
									-70.66,
									45.46
								],
								[
									-70.305,
									45.915
								],
								[
									-69.99997,
									46.69307
								],
								[
									-69.237216,
									47.447781
								],
								[
									-68.905,
									47.185
								],
								[
									-68.23444,
									47.35486
								],
								[
									-67.79046,
									47.06636
								],
								[
									-67.79134,
									45.70281
								],
								[
									-67.13741,
									45.13753
								],
								[
									-66.96466,
									44.8097
								],
								[
									-68.03252,
									44.3252
								],
								[
									-69.06,
									43.98
								],
								[
									-70.11617,
									43.68405
								],
								[
									-70.645476,
									43.090238
								],
								[
									-70.81489,
									42.8653
								],
								[
									-70.825,
									42.335
								],
								[
									-70.495,
									41.805
								],
								[
									-70.08,
									41.78
								],
								[
									-70.185,
									42.145
								],
								[
									-69.88497,
									41.92283
								],
								[
									-69.96503,
									41.63717
								],
								[
									-70.64,
									41.475
								],
								[
									-71.12039,
									41.49445
								],
								[
									-71.86,
									41.32
								],
								[
									-72.295,
									41.27
								],
								[
									-72.87643,
									41.22065
								],
								[
									-73.71,
									40.931102
								],
								[
									-72.24126,
									41.11948
								],
								[
									-71.945,
									40.93
								],
								[
									-73.345,
									40.63
								],
								[
									-73.982,
									40.628
								],
								[
									-73.952325,
									40.75075
								],
								[
									-74.25671,
									40.47351
								],
								[
									-73.96244,
									40.42763
								],
								[
									-74.17838,
									39.70926
								],
								[
									-74.90604,
									38.93954
								],
								[
									-74.98041,
									39.1964
								],
								[
									-75.20002,
									39.24845
								],
								[
									-75.52805,
									39.4985
								],
								[
									-75.32,
									38.96
								],
								[
									-75.071835,
									38.782032
								],
								[
									-75.05673,
									38.40412
								],
								[
									-75.37747,
									38.01551
								],
								[
									-75.94023,
									37.21689
								],
								[
									-76.03127,
									37.2566
								],
								[
									-75.72205,
									37.93705
								],
								[
									-76.23287,
									38.319215
								],
								[
									-76.35,
									39.15
								],
								[
									-76.542725,
									38.717615
								],
								[
									-76.32933,
									38.08326
								],
								[
									-76.989998,
									38.239992
								],
								[
									-76.30162,
									37.917945
								],
								[
									-76.25874,
									36.9664
								],
								[
									-75.9718,
									36.89726
								],
								[
									-75.86804,
									36.55125
								],
								[
									-75.72749,
									35.55074
								],
								[
									-76.36318,
									34.80854
								],
								[
									-77.397635,
									34.51201
								],
								[
									-78.05496,
									33.92547
								],
								[
									-78.55435,
									33.86133
								],
								[
									-79.06067,
									33.49395
								],
								[
									-79.20357,
									33.15839
								],
								[
									-80.301325,
									32.509355
								],
								[
									-80.86498,
									32.0333
								],
								[
									-81.33629,
									31.44049
								],
								[
									-81.49042,
									30.72999
								],
								[
									-81.31371,
									30.03552
								],
								[
									-80.98,
									29.18
								],
								[
									-80.535585,
									28.47213
								],
								[
									-80.53,
									28.04
								],
								[
									-80.056539,
									26.88
								],
								[
									-80.088015,
									26.205765
								],
								[
									-80.13156,
									25.816775
								],
								[
									-80.38103,
									25.20616
								],
								[
									-80.68,
									25.08
								],
								[
									-81.17213,
									25.20126
								],
								[
									-81.33,
									25.64
								],
								[
									-81.71,
									25.87
								],
								[
									-82.24,
									26.73
								],
								[
									-82.70515,
									27.49504
								],
								[
									-82.85526,
									27.88624
								],
								[
									-82.65,
									28.55
								],
								[
									-82.93,
									29.1
								],
								[
									-83.70959,
									29.93656
								],
								[
									-84.1,
									30.09
								],
								[
									-85.10882,
									29.63615
								],
								[
									-85.28784,
									29.68612
								],
								[
									-85.7731,
									30.15261
								],
								[
									-86.4,
									30.4
								],
								[
									-87.53036,
									30.27433
								],
								[
									-88.41782,
									30.3849
								],
								[
									-89.18049,
									30.31598
								],
								[
									-89.593831,
									30.159994
								],
								[
									-89.413735,
									29.89419
								],
								[
									-89.43,
									29.48864
								],
								[
									-89.21767,
									29.29108
								],
								[
									-89.40823,
									29.15961
								],
								[
									-89.77928,
									29.30714
								],
								[
									-90.15463,
									29.11743
								],
								[
									-90.880225,
									29.148535
								],
								[
									-91.626785,
									29.677
								],
								[
									-92.49906,
									29.5523
								],
								[
									-93.22637,
									29.78375
								],
								[
									-93.84842,
									29.71363
								],
								[
									-94.69,
									29.48
								],
								[
									-95.60026,
									28.73863
								],
								[
									-96.59404,
									28.30748
								],
								[
									-97.14,
									27.83
								],
								[
									-97.37,
									27.38
								],
								[
									-97.38,
									26.69
								],
								[
									-97.33,
									26.21
								],
								[
									-97.14,
									25.87
								],
								[
									-97.53,
									25.84
								],
								[
									-98.24,
									26.06
								],
								[
									-99.02,
									26.37
								],
								[
									-99.3,
									26.84
								],
								[
									-99.52,
									27.54
								],
								[
									-100.11,
									28.11
								],
								[
									-100.45584,
									28.69612
								],
								[
									-100.9576,
									29.38071
								],
								[
									-101.6624,
									29.7793
								],
								[
									-102.48,
									29.76
								],
								[
									-103.11,
									28.97
								],
								[
									-103.94,
									29.27
								],
								[
									-104.45697,
									29.57196
								],
								[
									-104.70575,
									30.12173
								],
								[
									-105.03737,
									30.64402
								],
								[
									-105.63159,
									31.08383
								],
								[
									-106.1429,
									31.39995
								],
								[
									-106.50759,
									31.75452
								],
								[
									-108.24,
									31.754854
								],
								[
									-108.24194,
									31.34222
								],
								[
									-109.035,
									31.34194
								],
								[
									-111.02361,
									31.33472
								],
								[
									-113.30498,
									32.03914
								],
								[
									-114.815,
									32.52528
								],
								[
									-114.72139,
									32.72083
								],
								[
									-115.99135,
									32.61239
								],
								[
									-117.12776,
									32.53534
								],
								[
									-117.295938,
									33.046225
								],
								[
									-117.944,
									33.621236
								],
								[
									-118.410602,
									33.740909
								],
								[
									-118.519895,
									34.027782
								],
								[
									-119.081,
									34.078
								],
								[
									-119.438841,
									34.348477
								],
								[
									-120.36778,
									34.44711
								],
								[
									-120.62286,
									34.60855
								],
								[
									-120.74433,
									35.15686
								],
								[
									-121.71457,
									36.16153
								],
								[
									-122.54747,
									37.55176
								],
								[
									-122.51201,
									37.78339
								],
								[
									-122.95319,
									38.11371
								],
								[
									-123.7272,
									38.95166
								],
								[
									-123.86517,
									39.76699
								],
								[
									-124.39807,
									40.3132
								],
								[
									-124.17886,
									41.14202
								],
								[
									-124.2137,
									41.99964
								],
								[
									-124.53284,
									42.76599
								],
								[
									-124.14214,
									43.70838
								],
								[
									-124.020535,
									44.615895
								],
								[
									-123.89893,
									45.52341
								],
								[
									-124.079635,
									46.86475
								],
								[
									-124.39567,
									47.72017
								],
								[
									-124.68721,
									48.184433
								],
								[
									-124.566101,
									48.379715
								],
								[
									-123.12,
									48.04
								],
								[
									-122.58736,
									47.096
								],
								[
									-122.34,
									47.36
								],
								[
									-122.5,
									48.18
								],
								[
									-122.84,
									49
								],
								[
									-120,
									49
								],
								[
									-117.03121,
									49
								],
								[
									-116.04818,
									49
								],
								[
									-113,
									49
								],
								[
									-110.05,
									49
								],
								[
									-107.05,
									49
								],
								[
									-104.04826,
									48.99986
								],
								[
									-100.65,
									49
								],
								[
									-97.22872,
									49.0007
								],
								[
									-95.15907,
									49
								],
								[
									-95.15609,
									49.38425
								],
								[
									-94.81758,
									49.38905
								]
							]
						],
						[
							[
								[
									-153.006314,
									57.115842
								],
								[
									-154.00509,
									56.734677
								],
								[
									-154.516403,
									56.992749
								],
								[
									-154.670993,
									57.461196
								],
								[
									-153.76278,
									57.816575
								],
								[
									-153.228729,
									57.968968
								],
								[
									-152.564791,
									57.901427
								],
								[
									-152.141147,
									57.591059
								],
								[
									-153.006314,
									57.115842
								]
							]
						],
						[
							[
								[
									-165.579164,
									59.909987
								],
								[
									-166.19277,
									59.754441
								],
								[
									-166.848337,
									59.941406
								],
								[
									-167.455277,
									60.213069
								],
								[
									-166.467792,
									60.38417
								],
								[
									-165.67443,
									60.293607
								],
								[
									-165.579164,
									59.909987
								]
							]
						],
						[
							[
								[
									-171.731657,
									63.782515
								],
								[
									-171.114434,
									63.592191
								],
								[
									-170.491112,
									63.694975
								],
								[
									-169.682505,
									63.431116
								],
								[
									-168.689439,
									63.297506
								],
								[
									-168.771941,
									63.188598
								],
								[
									-169.52944,
									62.976931
								],
								[
									-170.290556,
									63.194438
								],
								[
									-170.671386,
									63.375822
								],
								[
									-171.553063,
									63.317789
								],
								[
									-171.791111,
									63.405846
								],
								[
									-171.731657,
									63.782515
								]
							]
						],
						[
							[
								[
									-155.06779,
									71.147776
								],
								[
									-154.344165,
									70.696409
								],
								[
									-153.900006,
									70.889989
								],
								[
									-152.210006,
									70.829992
								],
								[
									-152.270002,
									70.600006
								],
								[
									-150.739992,
									70.430017
								],
								[
									-149.720003,
									70.53001
								],
								[
									-147.613362,
									70.214035
								],
								[
									-145.68999,
									70.12001
								],
								[
									-144.920011,
									69.989992
								],
								[
									-143.589446,
									70.152514
								],
								[
									-142.07251,
									69.851938
								],
								[
									-140.985988,
									69.711998
								],
								[
									-140.985988,
									69.711998
								],
								[
									-140.992499,
									66.000029
								],
								[
									-140.99777,
									60.306397
								],
								[
									-140.012998,
									60.276838
								],
								[
									-139.039,
									60.000007
								],
								[
									-138.34089,
									59.56211
								],
								[
									-137.4525,
									58.905
								],
								[
									-136.47972,
									59.46389
								],
								[
									-135.47583,
									59.78778
								],
								[
									-134.945,
									59.27056
								],
								[
									-134.27111,
									58.86111
								],
								[
									-133.355549,
									58.410285
								],
								[
									-132.73042,
									57.69289
								],
								[
									-131.70781,
									56.55212
								],
								[
									-130.00778,
									55.91583
								],
								[
									-129.979994,
									55.284998
								],
								[
									-130.53611,
									54.802753
								],
								[
									-131.085818,
									55.178906
								],
								[
									-131.967211,
									55.497776
								],
								[
									-132.250011,
									56.369996
								],
								[
									-133.539181,
									57.178887
								],
								[
									-134.078063,
									58.123068
								],
								[
									-135.038211,
									58.187715
								],
								[
									-136.628062,
									58.212209
								],
								[
									-137.800006,
									58.499995
								],
								[
									-139.867787,
									59.537762
								],
								[
									-140.825274,
									59.727517
								],
								[
									-142.574444,
									60.084447
								],
								[
									-143.958881,
									59.99918
								],
								[
									-145.925557,
									60.45861
								],
								[
									-147.114374,
									60.884656
								],
								[
									-148.224306,
									60.672989
								],
								[
									-148.018066,
									59.978329
								],
								[
									-148.570823,
									59.914173
								],
								[
									-149.727858,
									59.705658
								],
								[
									-150.608243,
									59.368211
								],
								[
									-151.716393,
									59.155821
								],
								[
									-151.859433,
									59.744984
								],
								[
									-151.409719,
									60.725803
								],
								[
									-150.346941,
									61.033588
								],
								[
									-150.621111,
									61.284425
								],
								[
									-151.895839,
									60.727198
								],
								[
									-152.57833,
									60.061657
								],
								[
									-154.019172,
									59.350279
								],
								[
									-153.287511,
									58.864728
								],
								[
									-154.232492,
									58.146374
								],
								[
									-155.307491,
									57.727795
								],
								[
									-156.308335,
									57.422774
								],
								[
									-156.556097,
									56.979985
								],
								[
									-158.117217,
									56.463608
								],
								[
									-158.433321,
									55.994154
								],
								[
									-159.603327,
									55.566686
								],
								[
									-160.28972,
									55.643581
								],
								[
									-161.223048,
									55.364735
								],
								[
									-162.237766,
									55.024187
								],
								[
									-163.069447,
									54.689737
								],
								[
									-164.785569,
									54.404173
								],
								[
									-164.942226,
									54.572225
								],
								[
									-163.84834,
									55.039431
								],
								[
									-162.870001,
									55.348043
								],
								[
									-161.804175,
									55.894986
								],
								[
									-160.563605,
									56.008055
								],
								[
									-160.07056,
									56.418055
								],
								[
									-158.684443,
									57.016675
								],
								[
									-158.461097,
									57.216921
								],
								[
									-157.72277,
									57.570001
								],
								[
									-157.550274,
									58.328326
								],
								[
									-157.041675,
									58.918885
								],
								[
									-158.194731,
									58.615802
								],
								[
									-158.517218,
									58.787781
								],
								[
									-159.058606,
									58.424186
								],
								[
									-159.711667,
									58.93139
								],
								[
									-159.981289,
									58.572549
								],
								[
									-160.355271,
									59.071123
								],
								[
									-161.355003,
									58.670838
								],
								[
									-161.968894,
									58.671665
								],
								[
									-162.054987,
									59.266925
								],
								[
									-161.874171,
									59.633621
								],
								[
									-162.518059,
									59.989724
								],
								[
									-163.818341,
									59.798056
								],
								[
									-164.662218,
									60.267484
								],
								[
									-165.346388,
									60.507496
								],
								[
									-165.350832,
									61.073895
								],
								[
									-166.121379,
									61.500019
								],
								[
									-165.734452,
									62.074997
								],
								[
									-164.919179,
									62.633076
								],
								[
									-164.562508,
									63.146378
								],
								[
									-163.753332,
									63.219449
								],
								[
									-163.067224,
									63.059459
								],
								[
									-162.260555,
									63.541936
								],
								[
									-161.53445,
									63.455817
								],
								[
									-160.772507,
									63.766108
								],
								[
									-160.958335,
									64.222799
								],
								[
									-161.518068,
									64.402788
								],
								[
									-160.777778,
									64.788604
								],
								[
									-161.391926,
									64.777235
								],
								[
									-162.45305,
									64.559445
								],
								[
									-162.757786,
									64.338605
								],
								[
									-163.546394,
									64.55916
								],
								[
									-164.96083,
									64.446945
								],
								[
									-166.425288,
									64.686672
								],
								[
									-166.845004,
									65.088896
								],
								[
									-168.11056,
									65.669997
								],
								[
									-166.705271,
									66.088318
								],
								[
									-164.47471,
									66.57666
								],
								[
									-163.652512,
									66.57666
								],
								[
									-163.788602,
									66.077207
								],
								[
									-161.677774,
									66.11612
								],
								[
									-162.489715,
									66.735565
								],
								[
									-163.719717,
									67.116395
								],
								[
									-164.430991,
									67.616338
								],
								[
									-165.390287,
									68.042772
								],
								[
									-166.764441,
									68.358877
								],
								[
									-166.204707,
									68.883031
								],
								[
									-164.430811,
									68.915535
								],
								[
									-163.168614,
									69.371115
								],
								[
									-162.930566,
									69.858062
								],
								[
									-161.908897,
									70.33333
								],
								[
									-160.934797,
									70.44769
								],
								[
									-159.039176,
									70.891642
								],
								[
									-158.119723,
									70.824721
								],
								[
									-156.580825,
									71.357764
								],
								[
									-155.06779,
									71.147776
								]
							]
						]
					]
				},
				"id": "USA"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Uzbekistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								66.518607,
								37.362784
							],
							[
								66.54615,
								37.974685
							],
							[
								65.215999,
								38.402695
							],
							[
								64.170223,
								38.892407
							],
							[
								63.518015,
								39.363257
							],
							[
								62.37426,
								40.053886
							],
							[
								61.882714,
								41.084857
							],
							[
								61.547179,
								41.26637
							],
							[
								60.465953,
								41.220327
							],
							[
								60.083341,
								41.425146
							],
							[
								59.976422,
								42.223082
							],
							[
								58.629011,
								42.751551
							],
							[
								57.78653,
								42.170553
							],
							[
								56.932215,
								41.826026
							],
							[
								57.096391,
								41.32231
							],
							[
								55.968191,
								41.308642
							],
							[
								55.928917,
								44.995858
							],
							[
								58.503127,
								45.586804
							],
							[
								58.689989,
								45.500014
							],
							[
								60.239972,
								44.784037
							],
							[
								61.05832,
								44.405817
							],
							[
								62.0133,
								43.504477
							],
							[
								63.185787,
								43.650075
							],
							[
								64.900824,
								43.728081
							],
							[
								66.098012,
								42.99766
							],
							[
								66.023392,
								41.994646
							],
							[
								66.510649,
								41.987644
							],
							[
								66.714047,
								41.168444
							],
							[
								67.985856,
								41.135991
							],
							[
								68.259896,
								40.662325
							],
							[
								68.632483,
								40.668681
							],
							[
								69.070027,
								41.384244
							],
							[
								70.388965,
								42.081308
							],
							[
								70.962315,
								42.266154
							],
							[
								71.259248,
								42.167711
							],
							[
								70.420022,
								41.519998
							],
							[
								71.157859,
								41.143587
							],
							[
								71.870115,
								41.3929
							],
							[
								73.055417,
								40.866033
							],
							[
								71.774875,
								40.145844
							],
							[
								71.014198,
								40.244366
							],
							[
								70.601407,
								40.218527
							],
							[
								70.45816,
								40.496495
							],
							[
								70.666622,
								40.960213
							],
							[
								69.329495,
								40.727824
							],
							[
								69.011633,
								40.086158
							],
							[
								68.536416,
								39.533453
							],
							[
								67.701429,
								39.580478
							],
							[
								67.44222,
								39.140144
							],
							[
								68.176025,
								38.901553
							],
							[
								68.392033,
								38.157025
							],
							[
								67.83,
								37.144994
							],
							[
								67.075782,
								37.356144
							],
							[
								66.518607,
								37.362784
							]
						]
					]
				},
				"id": "UZB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Venezuela"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-71.331584,
								11.776284
							],
							[
								-71.360006,
								11.539994
							],
							[
								-71.94705,
								11.423282
							],
							[
								-71.620868,
								10.96946
							],
							[
								-71.633064,
								10.446494
							],
							[
								-72.074174,
								9.865651
							],
							[
								-71.695644,
								9.072263
							],
							[
								-71.264559,
								9.137195
							],
							[
								-71.039999,
								9.859993
							],
							[
								-71.350084,
								10.211935
							],
							[
								-71.400623,
								10.968969
							],
							[
								-70.155299,
								11.375482
							],
							[
								-70.293843,
								11.846822
							],
							[
								-69.943245,
								12.162307
							],
							[
								-69.5843,
								11.459611
							],
							[
								-68.882999,
								11.443385
							],
							[
								-68.233271,
								10.885744
							],
							[
								-68.194127,
								10.554653
							],
							[
								-67.296249,
								10.545868
							],
							[
								-66.227864,
								10.648627
							],
							[
								-65.655238,
								10.200799
							],
							[
								-64.890452,
								10.077215
							],
							[
								-64.329479,
								10.389599
							],
							[
								-64.318007,
								10.641418
							],
							[
								-63.079322,
								10.701724
							],
							[
								-61.880946,
								10.715625
							],
							[
								-62.730119,
								10.420269
							],
							[
								-62.388512,
								9.948204
							],
							[
								-61.588767,
								9.873067
							],
							[
								-60.830597,
								9.38134
							],
							[
								-60.671252,
								8.580174
							],
							[
								-60.150096,
								8.602757
							],
							[
								-59.758285,
								8.367035
							],
							[
								-60.550588,
								7.779603
							],
							[
								-60.637973,
								7.415
							],
							[
								-60.295668,
								7.043911
							],
							[
								-60.543999,
								6.856584
							],
							[
								-61.159336,
								6.696077
							],
							[
								-61.139415,
								6.234297
							],
							[
								-61.410303,
								5.959068
							],
							[
								-60.733574,
								5.200277
							],
							[
								-60.601179,
								4.918098
							],
							[
								-60.966893,
								4.536468
							],
							[
								-62.08543,
								4.162124
							],
							[
								-62.804533,
								4.006965
							],
							[
								-63.093198,
								3.770571
							],
							[
								-63.888343,
								4.02053
							],
							[
								-64.628659,
								4.148481
							],
							[
								-64.816064,
								4.056445
							],
							[
								-64.368494,
								3.79721
							],
							[
								-64.408828,
								3.126786
							],
							[
								-64.269999,
								2.497006
							],
							[
								-63.422867,
								2.411068
							],
							[
								-63.368788,
								2.2009
							],
							[
								-64.083085,
								1.916369
							],
							[
								-64.199306,
								1.492855
							],
							[
								-64.611012,
								1.328731
							],
							[
								-65.354713,
								1.095282
							],
							[
								-65.548267,
								0.789254
							],
							[
								-66.325765,
								0.724452
							],
							[
								-66.876326,
								1.253361
							],
							[
								-67.181294,
								2.250638
							],
							[
								-67.447092,
								2.600281
							],
							[
								-67.809938,
								2.820655
							],
							[
								-67.303173,
								3.318454
							],
							[
								-67.337564,
								3.542342
							],
							[
								-67.621836,
								3.839482
							],
							[
								-67.823012,
								4.503937
							],
							[
								-67.744697,
								5.221129
							],
							[
								-67.521532,
								5.55687
							],
							[
								-67.34144,
								6.095468
							],
							[
								-67.695087,
								6.267318
							],
							[
								-68.265052,
								6.153268
							],
							[
								-68.985319,
								6.206805
							],
							[
								-69.38948,
								6.099861
							],
							[
								-70.093313,
								6.960376
							],
							[
								-70.674234,
								7.087785
							],
							[
								-71.960176,
								6.991615
							],
							[
								-72.198352,
								7.340431
							],
							[
								-72.444487,
								7.423785
							],
							[
								-72.479679,
								7.632506
							],
							[
								-72.360901,
								8.002638
							],
							[
								-72.439862,
								8.405275
							],
							[
								-72.660495,
								8.625288
							],
							[
								-72.78873,
								9.085027
							],
							[
								-73.304952,
								9.152
							],
							[
								-73.027604,
								9.73677
							],
							[
								-72.905286,
								10.450344
							],
							[
								-72.614658,
								10.821975
							],
							[
								-72.227575,
								11.108702
							],
							[
								-71.973922,
								11.608672
							],
							[
								-71.331584,
								11.776284
							]
						]
					]
				},
				"id": "VEN"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Vietnam"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								108.05018,
								21.55238
							],
							[
								106.715068,
								20.696851
							],
							[
								105.881682,
								19.75205
							],
							[
								105.662006,
								19.058165
							],
							[
								106.426817,
								18.004121
							],
							[
								107.361954,
								16.697457
							],
							[
								108.269495,
								16.079742
							],
							[
								108.877107,
								15.276691
							],
							[
								109.33527,
								13.426028
							],
							[
								109.200136,
								11.666859
							],
							[
								108.36613,
								11.008321
							],
							[
								107.220929,
								10.364484
							],
							[
								106.405113,
								9.53084
							],
							[
								105.158264,
								8.59976
							],
							[
								104.795185,
								9.241038
							],
							[
								105.076202,
								9.918491
							],
							[
								104.334335,
								10.486544
							],
							[
								105.199915,
								10.88931
							],
							[
								106.24967,
								10.961812
							],
							[
								105.810524,
								11.567615
							],
							[
								107.491403,
								12.337206
							],
							[
								107.614548,
								13.535531
							],
							[
								107.382727,
								14.202441
							],
							[
								107.564525,
								15.202173
							],
							[
								107.312706,
								15.908538
							],
							[
								106.556008,
								16.604284
							],
							[
								105.925762,
								17.485315
							],
							[
								105.094598,
								18.666975
							],
							[
								103.896532,
								19.265181
							],
							[
								104.183388,
								19.624668
							],
							[
								104.822574,
								19.886642
							],
							[
								104.435,
								20.758733
							],
							[
								103.203861,
								20.766562
							],
							[
								102.754896,
								21.675137
							],
							[
								102.170436,
								22.464753
							],
							[
								102.706992,
								22.708795
							],
							[
								103.504515,
								22.703757
							],
							[
								104.476858,
								22.81915
							],
							[
								105.329209,
								23.352063
							],
							[
								105.811247,
								22.976892
							],
							[
								106.725403,
								22.794268
							],
							[
								106.567273,
								22.218205
							],
							[
								107.04342,
								21.811899
							],
							[
								108.05018,
								21.55238
							]
						]
					]
				},
				"id": "VNM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Vanuatu"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									167.844877,
									-16.466333
								],
								[
									167.515181,
									-16.59785
								],
								[
									167.180008,
									-16.159995
								],
								[
									167.216801,
									-15.891846
								],
								[
									167.844877,
									-16.466333
								]
							]
						],
						[
							[
								[
									167.107712,
									-14.93392
								],
								[
									167.270028,
									-15.740021
								],
								[
									167.001207,
									-15.614602
								],
								[
									166.793158,
									-15.668811
								],
								[
									166.649859,
									-15.392704
								],
								[
									166.629137,
									-14.626497
								],
								[
									167.107712,
									-14.93392
								]
							]
						]
					]
				},
				"id": "VUT"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "West Bank"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.545665,
								32.393992
							],
							[
								35.545252,
								31.782505
							],
							[
								35.397561,
								31.489086
							],
							[
								34.927408,
								31.353435
							],
							[
								34.970507,
								31.616778
							],
							[
								35.225892,
								31.754341
							],
							[
								34.974641,
								31.866582
							],
							[
								35.18393,
								32.532511
							],
							[
								35.545665,
								32.393992
							]
						]
					]
				},
				"id": "PSE"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Yemen"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								53.108573,
								16.651051
							],
							[
								52.385206,
								16.382411
							],
							[
								52.191729,
								15.938433
							],
							[
								52.168165,
								15.59742
							],
							[
								51.172515,
								15.17525
							],
							[
								49.574576,
								14.708767
							],
							[
								48.679231,
								14.003202
							],
							[
								48.238947,
								13.94809
							],
							[
								47.938914,
								14.007233
							],
							[
								47.354454,
								13.59222
							],
							[
								46.717076,
								13.399699
							],
							[
								45.877593,
								13.347764
							],
							[
								45.62505,
								13.290946
							],
							[
								45.406459,
								13.026905
							],
							[
								45.144356,
								12.953938
							],
							[
								44.989533,
								12.699587
							],
							[
								44.494576,
								12.721653
							],
							[
								44.175113,
								12.58595
							],
							[
								43.482959,
								12.6368
							],
							[
								43.222871,
								13.22095
							],
							[
								43.251448,
								13.767584
							],
							[
								43.087944,
								14.06263
							],
							[
								42.892245,
								14.802249
							],
							[
								42.604873,
								15.213335
							],
							[
								42.805015,
								15.261963
							],
							[
								42.702438,
								15.718886
							],
							[
								42.823671,
								15.911742
							],
							[
								42.779332,
								16.347891
							],
							[
								43.218375,
								16.66689
							],
							[
								43.115798,
								17.08844
							],
							[
								43.380794,
								17.579987
							],
							[
								43.791519,
								17.319977
							],
							[
								44.062613,
								17.410359
							],
							[
								45.216651,
								17.433329
							],
							[
								45.399999,
								17.333335
							],
							[
								46.366659,
								17.233315
							],
							[
								46.749994,
								17.283338
							],
							[
								47.000005,
								16.949999
							],
							[
								47.466695,
								17.116682
							],
							[
								48.183344,
								18.166669
							],
							[
								49.116672,
								18.616668
							],
							[
								52.00001,
								19.000003
							],
							[
								52.782184,
								17.349742
							],
							[
								53.108573,
								16.651051
							]
						]
					]
				},
				"id": "YEM"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "South Africa"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.521001,
								-29.257387
							],
							[
								31.325561,
								-29.401978
							],
							[
								30.901763,
								-29.909957
							],
							[
								30.622813,
								-30.423776
							],
							[
								30.055716,
								-31.140269
							],
							[
								28.925553,
								-32.172041
							],
							[
								28.219756,
								-32.771953
							],
							[
								27.464608,
								-33.226964
							],
							[
								26.419452,
								-33.61495
							],
							[
								25.909664,
								-33.66704
							],
							[
								25.780628,
								-33.944646
							],
							[
								25.172862,
								-33.796851
							],
							[
								24.677853,
								-33.987176
							],
							[
								23.594043,
								-33.794474
							],
							[
								22.988189,
								-33.916431
							],
							[
								22.574157,
								-33.864083
							],
							[
								21.542799,
								-34.258839
							],
							[
								20.689053,
								-34.417175
							],
							[
								20.071261,
								-34.795137
							],
							[
								19.616405,
								-34.819166
							],
							[
								19.193278,
								-34.462599
							],
							[
								18.855315,
								-34.444306
							],
							[
								18.424643,
								-33.997873
							],
							[
								18.377411,
								-34.136521
							],
							[
								18.244499,
								-33.867752
							],
							[
								18.25008,
								-33.281431
							],
							[
								17.92519,
								-32.611291
							],
							[
								18.24791,
								-32.429131
							],
							[
								18.221762,
								-31.661633
							],
							[
								17.566918,
								-30.725721
							],
							[
								17.064416,
								-29.878641
							],
							[
								17.062918,
								-29.875954
							],
							[
								16.344977,
								-28.576705
							],
							[
								16.824017,
								-28.082162
							],
							[
								17.218929,
								-28.355943
							],
							[
								17.387497,
								-28.783514
							],
							[
								17.836152,
								-28.856378
							],
							[
								18.464899,
								-29.045462
							],
							[
								19.002127,
								-28.972443
							],
							[
								19.894734,
								-28.461105
							],
							[
								19.895768,
								-24.76779
							],
							[
								20.165726,
								-24.917962
							],
							[
								20.758609,
								-25.868136
							],
							[
								20.66647,
								-26.477453
							],
							[
								20.889609,
								-26.828543
							],
							[
								21.605896,
								-26.726534
							],
							[
								22.105969,
								-26.280256
							],
							[
								22.579532,
								-25.979448
							],
							[
								22.824271,
								-25.500459
							],
							[
								23.312097,
								-25.26869
							],
							[
								23.73357,
								-25.390129
							],
							[
								24.211267,
								-25.670216
							],
							[
								25.025171,
								-25.71967
							],
							[
								25.664666,
								-25.486816
							],
							[
								25.765849,
								-25.174845
							],
							[
								25.941652,
								-24.696373
							],
							[
								26.485753,
								-24.616327
							],
							[
								26.786407,
								-24.240691
							],
							[
								27.11941,
								-23.574323
							],
							[
								28.017236,
								-22.827754
							],
							[
								29.432188,
								-22.091313
							],
							[
								29.839037,
								-22.102216
							],
							[
								30.322883,
								-22.271612
							],
							[
								30.659865,
								-22.151567
							],
							[
								31.191409,
								-22.25151
							],
							[
								31.670398,
								-23.658969
							],
							[
								31.930589,
								-24.369417
							],
							[
								31.752408,
								-25.484284
							],
							[
								31.837778,
								-25.843332
							],
							[
								31.333158,
								-25.660191
							],
							[
								31.04408,
								-25.731452
							],
							[
								30.949667,
								-26.022649
							],
							[
								30.676609,
								-26.398078
							],
							[
								30.685962,
								-26.743845
							],
							[
								31.282773,
								-27.285879
							],
							[
								31.86806,
								-27.177927
							],
							[
								32.071665,
								-26.73382
							],
							[
								32.83012,
								-26.742192
							],
							[
								32.580265,
								-27.470158
							],
							[
								32.462133,
								-28.301011
							],
							[
								32.203389,
								-28.752405
							],
							[
								31.521001,
								-29.257387
							]
						],
						[
							[
								28.978263,
								-28.955597
							],
							[
								28.5417,
								-28.647502
							],
							[
								28.074338,
								-28.851469
							],
							[
								27.532511,
								-29.242711
							],
							[
								26.999262,
								-29.875954
							],
							[
								27.749397,
								-30.645106
							],
							[
								28.107205,
								-30.545732
							],
							[
								28.291069,
								-30.226217
							],
							[
								28.8484,
								-30.070051
							],
							[
								29.018415,
								-29.743766
							],
							[
								29.325166,
								-29.257387
							],
							[
								28.978263,
								-28.955597
							]
						]
					]
				},
				"id": "ZAF"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Zambia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								32.759375,
								-9.230599
							],
							[
								33.231388,
								-9.676722
							],
							[
								33.485688,
								-10.525559
							],
							[
								33.31531,
								-10.79655
							],
							[
								33.114289,
								-11.607198
							],
							[
								33.306422,
								-12.435778
							],
							[
								32.991764,
								-12.783871
							],
							[
								32.688165,
								-13.712858
							],
							[
								33.214025,
								-13.97186
							],
							[
								30.179481,
								-14.796099
							],
							[
								30.274256,
								-15.507787
							],
							[
								29.516834,
								-15.644678
							],
							[
								28.947463,
								-16.043051
							],
							[
								28.825869,
								-16.389749
							],
							[
								28.467906,
								-16.4684
							],
							[
								27.598243,
								-17.290831
							],
							[
								27.044427,
								-17.938026
							],
							[
								26.706773,
								-17.961229
							],
							[
								26.381935,
								-17.846042
							],
							[
								25.264226,
								-17.73654
							],
							[
								25.084443,
								-17.661816
							],
							[
								25.07695,
								-17.578823
							],
							[
								24.682349,
								-17.353411
							],
							[
								24.033862,
								-17.295843
							],
							[
								23.215048,
								-17.523116
							],
							[
								22.562478,
								-16.898451
							],
							[
								21.887843,
								-16.08031
							],
							[
								21.933886,
								-12.898437
							],
							[
								24.016137,
								-12.911046
							],
							[
								23.930922,
								-12.565848
							],
							[
								24.079905,
								-12.191297
							],
							[
								23.904154,
								-11.722282
							],
							[
								24.017894,
								-11.237298
							],
							[
								23.912215,
								-10.926826
							],
							[
								24.257155,
								-10.951993
							],
							[
								24.314516,
								-11.262826
							],
							[
								24.78317,
								-11.238694
							],
							[
								25.418118,
								-11.330936
							],
							[
								25.75231,
								-11.784965
							],
							[
								26.553088,
								-11.92444
							],
							[
								27.16442,
								-11.608748
							],
							[
								27.388799,
								-12.132747
							],
							[
								28.155109,
								-12.272481
							],
							[
								28.523562,
								-12.698604
							],
							[
								28.934286,
								-13.248958
							],
							[
								29.699614,
								-13.257227
							],
							[
								29.616001,
								-12.178895
							],
							[
								29.341548,
								-12.360744
							],
							[
								28.642417,
								-11.971569
							],
							[
								28.372253,
								-11.793647
							],
							[
								28.49607,
								-10.789884
							],
							[
								28.673682,
								-9.605925
							],
							[
								28.449871,
								-9.164918
							],
							[
								28.734867,
								-8.526559
							],
							[
								29.002912,
								-8.407032
							],
							[
								30.346086,
								-8.238257
							],
							[
								30.740015,
								-8.340007
							],
							[
								31.157751,
								-8.594579
							],
							[
								31.556348,
								-8.762049
							],
							[
								32.191865,
								-8.930359
							],
							[
								32.759375,
								-9.230599
							]
						]
					]
				},
				"id": "ZMB"
			},
			{
				"type": "Feature",
				"properties": {
					"name": "Zimbabwe"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.191409,
								-22.25151
							],
							[
								30.659865,
								-22.151567
							],
							[
								30.322883,
								-22.271612
							],
							[
								29.839037,
								-22.102216
							],
							[
								29.432188,
								-22.091313
							],
							[
								28.794656,
								-21.639454
							],
							[
								28.02137,
								-21.485975
							],
							[
								27.727228,
								-20.851802
							],
							[
								27.724747,
								-20.499059
							],
							[
								27.296505,
								-20.39152
							],
							[
								26.164791,
								-19.293086
							],
							[
								25.850391,
								-18.714413
							],
							[
								25.649163,
								-18.536026
							],
							[
								25.264226,
								-17.73654
							],
							[
								26.381935,
								-17.846042
							],
							[
								26.706773,
								-17.961229
							],
							[
								27.044427,
								-17.938026
							],
							[
								27.598243,
								-17.290831
							],
							[
								28.467906,
								-16.4684
							],
							[
								28.825869,
								-16.389749
							],
							[
								28.947463,
								-16.043051
							],
							[
								29.516834,
								-15.644678
							],
							[
								30.274256,
								-15.507787
							],
							[
								30.338955,
								-15.880839
							],
							[
								31.173064,
								-15.860944
							],
							[
								31.636498,
								-16.07199
							],
							[
								31.852041,
								-16.319417
							],
							[
								32.328239,
								-16.392074
							],
							[
								32.847639,
								-16.713398
							],
							[
								32.849861,
								-17.979057
							],
							[
								32.654886,
								-18.67209
							],
							[
								32.611994,
								-19.419383
							],
							[
								32.772708,
								-19.715592
							],
							[
								32.659743,
								-20.30429
							],
							[
								32.508693,
								-20.395292
							],
							[
								32.244988,
								-21.116489
							],
							[
								31.191409,
								-22.25151
							]
						]
					]
				},
				"id": "ZWE"
			}
		]
	};

/***/ },
/* 814 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	RainbowVis-JS
	Released under MIT License
	*/
	
	function Rainbow() {
	    var gradients = null;
	    var minNum = 0;
	    var maxNum = 100;
	    var colours = ['ff0000', 'ffff00', '00ff00', '0000ff'];
	    setColours(colours);
	
	    function setColours(spectrum) {
	        if (spectrum.length < 2) {
	            throw new Error('Rainbow must have two or more colours.');
	        } else {
	            var increment = (maxNum - minNum) / (spectrum.length - 1);
	            var firstGradient = new ColourGradient();
	            firstGradient.setGradient(spectrum[0], spectrum[1]);
	            firstGradient.setNumberRange(minNum, minNum + increment);
	            gradients = [firstGradient];
	
	            for (var i = 1; i < spectrum.length - 1; i++) {
	                var colourGradient = new ColourGradient();
	                colourGradient.setGradient(spectrum[i], spectrum[i + 1]);
	                colourGradient.setNumberRange(minNum + increment * i, minNum + increment * (i + 1));
	                gradients[i] = colourGradient;
	            }
	
	            colours = spectrum;
	            return this;
	        }
	    }
	
	    this.setColors = this.setColours;
	
	    this.setSpectrum = function () {
	        setColours(arguments);
	        return this;
	    };
	
	    this.setSpectrumByArray = function (array) {
	        setColours(array);
	        return this;
	    };
	
	    this.colourAt = function (number) {
	        if (isNaN(number)) {
	            throw new TypeError(number + ' is not a number');
	        } else if (gradients.length === 1) {
	            return gradients[0].colourAt(number);
	        } else {
	            var segment = (maxNum - minNum) / gradients.length;
	            var index = Math.min(Math.floor((Math.max(number, minNum) - minNum) / segment), gradients.length - 1);
	            return gradients[index].colourAt(number);
	        }
	    };
	
	    this.colorAt = this.colourAt;
	
	    this.setNumberRange = function (minNumber, maxNumber) {
	        if (maxNumber > minNumber) {
	            minNum = minNumber;
	            maxNum = maxNumber;
	            setColours(colours);
	        } else {
	            throw new RangeError('maxNumber (' + maxNumber + ') is not greater than minNumber (' + minNumber + ')');
	        }
	        return this;
	    };
	}
	
	function ColourGradient() {
	    var startColour = 'ff0000';
	    var endColour = '0000ff';
	    var minNum = 0;
	    var maxNum = 100;
	
	    this.setGradient = function (colourStart, colourEnd) {
	        startColour = getHexColour(colourStart);
	        endColour = getHexColour(colourEnd);
	    };
	
	    this.setNumberRange = function (minNumber, maxNumber) {
	        if (maxNumber > minNumber) {
	            minNum = minNumber;
	            maxNum = maxNumber;
	        } else {
	            throw new RangeError('maxNumber (' + maxNumber + ') is not greater than minNumber (' + minNumber + ')');
	        };
	    };
	
	    this.colourAt = function (number) {
	        return calcHex(number, startColour.substring(0, 2), endColour.substring(0, 2)) + calcHex(number, startColour.substring(2, 4), endColour.substring(2, 4)) + calcHex(number, startColour.substring(4, 6), endColour.substring(4, 6));
	    };
	
	    function calcHex(number, channelStart_Base16, channelEnd_Base16) {
	        var num = number;
	        if (num < minNum) {
	            num = minNum;
	        };
	        if (num > maxNum) {
	            num = maxNum;
	        };
	        var numRange = maxNum - minNum;
	        var cStart_Base10 = parseInt(channelStart_Base16, 16);
	        var cEnd_Base10 = parseInt(channelEnd_Base16, 16);
	        var cPerUnit = (cEnd_Base10 - cStart_Base10) / numRange;
	        var c_Base10 = Math.round(cPerUnit * (num - minNum) + cStart_Base10);
	        return formatHex(c_Base10.toString(16));
	    };
	
	    var formatHex = function formatHex(hex) {
	        if (hex.length === 1) {
	            return '0' + hex;
	        } else {
	            return hex;
	        }
	    };
	
	    function isHexColour(string) {
	        var regex = /^#?[0-9a-fA-F]{6}$/i;
	        return regex.test(string);
	    };
	
	    function getHexColour(string) {
	        if (isHexColour(string)) {
	            return string.substring(string.length - 6, string.length);
	        } else {
	            var colourNames = [['red', 'ff0000'], ['lime', '00ff00'], ['blue', '0000ff'], ['yellow', 'ffff00'], ['orange', 'ff8000'], ['aqua', '00ffff'], ['fuchsia', 'ff00ff'], ['white', 'ffffff'], ['black', '000000'], ['gray', '808080'], ['grey', '808080'], ['silver', 'c0c0c0'], ['maroon', '800000'], ['olive', '808000'], ['green', '008000'], ['teal', '008080'], ['navy', '000080'], ['purple', '800080']];
	            for (var i = 0; i < colourNames.length; i++) {
	                if (string.toLowerCase() === colourNames[i][0]) {
	                    return colourNames[i][1];
	                };
	            };
	            throw new Error(string + ' is not a valid colour.');
	        };
	    };
	};
	
	module.exports = Rainbow;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('head', __webpack_require__(816));
	};

/***/ },
/* 816 */
/***/ function(module, exports) {

	'use strict';
	
	function directive($state, $location, $window) {
	    // this appends the page head (title and calendar) to all pages, so they can have their own controller
	    return {
	        // restrict: 'E',
	        link: function link($scope) {
	            $scope.title = $state.current.data.title;
	            $scope.daterange = $state.current.data.daterange;
	
	            // subheading display
	            $scope.subtitle = [];
	            if (typeof $state.current.data.subtitleElm !== 'undefined') {
	                $scope.subtitleElm = $state.current.data.subtitleElm;
	                for (var i in $scope.subtitleElm) {
	                    $scope.subtitle.push({
	                        title: i,
	                        value: $location.$$search[$scope.subtitleElm[i]]
	                    });
	                }
	            }
	            $window.scroll(0, 0);
	        },
	        template: '<section ng-show="title">\n                <div class="row-fluid">\n                    <div class="span7">\n                        <h1>{{ title }}</h1>\n                    </div>\n                    <div class="span5">\n                        <div date-picker class="datepicker2015">\n                            <div ng-show="daterange" id="daterange" class="pull-right dashboard-date-range tooltips no-tooltip-on-touch-device responsive" data-tablet="" data-desktop="tooltips" data-placement="top" data-original-title="Change dashboard date range">\n                                 <i class="fa fa-calendar"></i>\n                                 <span>{{dateRangeStart}} - {{dateRangeEnd}}</span>\n                                 <i class="fa fa-angle-down"></i>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </section>'
	        // transclude : true
	    };
	}
	
	directive.$inject = ['$state', '$location', '$window'];
	module.exports = directive;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	'uss strict';
	
	var component = {
	    transclude: true,
	    bindings: {
	        main: '=',
	        socket: '=',
	        settings: '=',
	        saveNodeInfo: '=',
	        editAssociatedGroups: '=',
	        createEditGroup: '=',
	        deleteGroup: '=',
	        getGroups: '=',
	        setGroups: '='
	    },
	    scope: true,
	    template: __webpack_require__(818),
	    controller: function controller($scope) {
	        __webpack_require__(819);
	
	        // Force Chart Default Values
	        this.gravity = 0.05; // how much the nodes are attracted to each other (between 0 & 1)
	        this.charge = -10; // repulse (basically opposite of gravity) (smaller than zero can go in the 1000s) (our max is -2000)
	        this.link_distance = 80; // distance of a link between nodes
	        this.link_strength = 0.5; // link flexibility (if set to 1, every link will be the link distance, 0 the link distance is basically ignored)
	        this.friction = 0.6; // how much friction the chart has when a node moves (how fast for it to slow down) (between 0 & 1)
	        this.alpha = 0.05; // radius of the nodes
	        this.padding = 1; // padding for the node collisions (how much space between nodes)
	        this.maxRadius = 10; // radius of the nodes
	
	        this.shiftKey = false; // used to know when the "shift" button is pressed
	        this.already_collapsed_ips = []; // ips that are currently in a cluster
	        this.links = []; // array of links
	        this.nodes = []; // arra of nodes
	        this.allNodes = {}; // Every single node possible from the network assets table, (all network assets and new nodes) even if it does not show up on map
	        this.nodeArray = {}; // object of all the known nodes, key = IP, value = node object (for easy access) and to show all the IPs connected to it
	        this.allLinks = {}; // list of all the possible links already existed (used so you dont get duplicate links)
	        this.l7_between_nodes = {}; // object of all the possible L7 betweem IPs for easy access in the sidebnar
	        this.nodes_object = {};
	
	        // when resizing the window, this is used so it does not fire for every pixel (can put a ms between)
	        this.waitForFinalEvent = function () {
	            var timers = {};
	            return function (callback, ms, uniqueId) {
	                if (!uniqueId) {
	                    uniqueId = "slider"; // don't call this twice without a uniqueId
	                }
	                if (timers[uniqueId]) {
	                    clearTimeout(timers[uniqueId]);
	                }
	                timers[uniqueId] = setTimeout(callback, ms);
	            };
	        }();
	
	        // returns the path for the SVG depending on the node type
	        this.svgType = function (type) {
	            switch (type) {
	                case 'Gateway':
	                    return 'M10,21.41H4.59V16h2v1.86L10,14.59,11.41,16,7.86,19.41H10v2ZM16,6.59v-2h5.41V10h-2V8.14L16,11.41,14.59,10l3.56-3.41H16Zm1.4,14.14h-2V15.31h5.41v2H19l3.27,3.41-1.41,' + '1.41L17.4,18.59v2.14ZM8.61,5.23h2v5.41H5.19v-2H7.05L3.78,5.23,5.19,3.81,8.61,7.37V5.23Z';
	                case 'Server':
	                    return 'M18,22h7v2H18V22ZM1,24H8V22H1v2Zm0-9H25v5H14.19v1h3.05v4H8.82V21H12.1V20H1V15Zm2.09,3H5.17V16H3.09v2ZM1,8H25v5H1V8Zm2.09,3H5.17V9H3.09v2ZM25,1V6H1V1H25ZM5.17,2H3.09V4H5.17V2Z';
	                case 'DNS Server':
	                    return 'M14,21h3v4H9V21h3V20h2v1Zm4,3h7V22H18v2ZM1,24H8V22H1v2ZM6,7H3V3H6V1H1V9H6V7ZM20,1V3h3V7H20V9h5V1H20ZM12,7H8V9h4V7Zm0-6H8V3h4V1Zm6,6H14V9h4V7Zm0-6H14V3h4V1ZM6,6H8V4H6V6ZM6,17H3V13H6V11H1v8H6V17Zm14-4' + 'h3v4H20v2h5V11H20v2Zm-8,4H8v2h4V17ZM8,13h4V11H8v2Zm10,4H14v2h4V17Zm0-6H14v2h4V11ZM6,16H8V14H6v2Z';
	                case 'Web Server':
	                    return 'M5.06,21A4,4,0,0,1,1,16.64a4.09,4.09,0,0,1,3.4-4.31S4.93,9.25,6.68,9.25A2.76,2.76,0,0,1,9,10.41s1.21-4.94,5.79-4.94c5.71,0,5.87,7.16,5.87,7.16s4.36,0.64,4.36,4C25,21,21.24,21,21.24,21H5.06Z';
	                case 'File Server':
	                    return 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z';
	                case 'DHCP Server':
	                    return 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z';
	                case 'Database':
	                    return 'M384 960C171.969 960 0 902.625 0 832c0-38.625 0-80.875 0-128 0-11.125 5.562-21.688 13.562-32C56.375 727.125 205.25 768 384 768s327.625-40.875 370.438-96c8 10.312 13.562 20.875 13.562 32 0 37.062 0 76' + '.375 0 128C768 902.625 596 960 384 960zM384 704C171.969 704 0 646.625 0 576c0-38.656 0-80.844 0-128 0-6.781 2.562-13.375 6-19.906l0 0C7.938 424 10.5 419.969 13.562 416 56.375 471.094 205.25 512 384 512s32' + '7.625-40.906 370.438-96c3.062 3.969 5.625 8 7.562 12.094l0 0c3.438 6.531 6 13.125 6 19.906 0 37.062 0 76.344 0 128C768 646.625 596 704 384 704zM384 448C171.969 448 0 390.656 0 320c0-20.219 0-41.594 0-64 0-2' + '0.344 0-41.469 0-64C0 121.34400000000005 171.969 64 384 64c212 0 384 57.344 384 128 0 19.969 0 41.156 0 64 0 19.594 0 40.25 0 64C768 390.656 596 448 384 448zM384 128c-141.375 0-256 28.594-256 64s114.625 64 25' + '6 64 256-28.594 256-64S525.375 128 384 128z';
	                case 'Mobile':
	                    return 'M18,1.77H8a2,2,0,0,0-2,2v18a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2v-18A2,2,0,0,0,18,1.77Zm0,18H8v-14H18v14Z';
	                case 'Laptop':
	                    return 'M21.67,19.5a2.17,2.17,0,0,0,2.17-2.17V6.5a2.17,2.17,0,0,0-2.17-2.17H4.33A2.17,2.17,0,0,0,2.17,6.5V17.33A2.17,2.17,0,0,0,4.33,19.5H0v2.17H26V19.5H21.67ZM4.33,6.5H21.67V17.33H4.33V6.5Z';
	                case 'Desktop':
	                    return 'M26,2.34H0v17H9l-1.32,5H18.81l-1.48-5H26v-17Zm-11.5,16h-2v-2h2v2Z';
	                case 'Endpoint':
	                    return 'M18.25,7.75A5.25,5.25,0,1,1,13,2.5,5.25,5.25,0,0,1,18.25,7.75ZM23.5,19.66a15.68,15.68,0,0,0-21,0V23.5h21V19.66Z';
	                case 'Printer':
	                    return 'M20,9H6a3,3,0,0,0-3,3v6H7v4H19V18h4V12A3,3,0,0,0,20,9ZM17,20H9V15h8v5Zm3-7a1,1,0,1,1,1-1A1,1,0,0,1,20,13ZM19,4H7V8H19V4Z';
	                case 'Access Point':
	                    return 'M15.9,18.55a2.71,2.71,0,1,1-2.71-2.67A2.69,2.69,0,0,1,15.9,18.55ZM3.25,11.83a12.18,12.18,0,0,1,19.88,0l1.56-1.12a14.13,14.13,0,0,0-23,0ZM6.2,14a8.49,8.49,0,0,1,14,0l1.6-1.15a10.49,10.49,0,0,0-17.18,0Zm3,' + '2.14a4.77,4.77,0,0,1,8.05,0l1.64-1.18a6.83,6.83,0,0,0-11.34,0Z';
	                case 'Domain Controller':
	                    return 'M67.998,0H21.473c-1.968,0-3.579,1.61-3.579,3.579v82.314c0,1.968,1.61,3.579,3.579,3.579h46.525c1.968,0,3.579-1.61,3.579-3.579V3.579C71.577,1.61,69.967,0,67.998,0z M44.736,65.811c-2.963,0-5.368-2.409-5.368-5.36' + '8c0-2.963,2.405-5.368,5.368-5.368c2.963,0,5.368,2.405,5.368,5.368C50.104,63.403,47.699,65.811,44.736,65.811z M64.419,39.704H25.052v-1.789h39.367V39.704z M64.419,28.967H25.052v-1.789h39.367V28.967z M64.419,17.336H25.0' + '52V6.599h39.367V17.336z';
	                case 'Phone':
	                    return 'M7.81,11.79a15.15,15.15,0,0,0,6.59,6.59l2.2-2.2a1,1,0,0,1,1-.24,11.41,11.41,0,0,0,3.57.57,1,1,0,0,1,1,1V21a1,1,0,0,1-1,1,17,17,0,0,1-17-17,1,1,0,0,1,1-1h3.5a1,1,0,0,1,1,1,11.36,11.36,0,0,0,.57,3.57,1,1,0,0,1-.25,1Z';
	                case 'Switch':
	                    return 'M12,20.76H6.57l1.55,1.55-1.6,1.6L2.17,19.57l4.34-4.34,1.6,1.6L6.57,18.49H12v2.27ZM12,10H6.57L8.12,11.5l-1.6,1.6L2.17,8.76,6.51,4.42,8.12,6,6.57,7.68H12V10Zm7.77,11.' + '74-1.6-1.6,1.55-1.55H14.28V16.27H19.7l-1.55-1.66,1.6-1.6,4.34,4.34Zm0-11-1.6-1.6L19.7,7.53H14.28V5.27H19.7L18.15,3.6,19.76,2,24.1,6.34Z';
	                case 'type':
	                    return 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1' + '.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.' + '78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z';
	                case 'group':
	                    return 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.' + '5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z';
	                case 'cluster':
	                    return 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02' + '-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.' + '36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z';
	                case 'selected':
	                    return 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.9' + '4V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z';
	                case 'connecting':
	                    return 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z';
	                case 'ioc':
	                    return 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z';
	                case 'new':
	                    return 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z';
	                default:
	                    return 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z';
	
	            }
	        };
	
	        // returns the group color from its ID
	        this.getGroupColor = function (id) {
	            var g = void 0;
	            for (g in $scope.groups) {
	                if (id === g) {
	                    return $scope.groups[g].color;
	                }
	            }
	            return false;
	        };
	
	        // returns a color from an ID or IOC severity
	        this.color = function (id) {
	            if (this.getGroupColor(id)) {
	                return this.getGroupColor(id);
	            } else if (typeof id === "number") {
	                switch (id) {
	                    case 4:
	                        return "#ff3131";
	                    case 3:
	                        return "#f88b12";
	                    case 2:
	                        return "#f5d800";
	                    case 1:
	                        return "#377fc7";
	                    case 0:
	                    default:
	                        return "#999";
	                }
	            } else {
	                return "#000000";
	            }
	        };
	    }
	};
	
	component.$inject = ['$scope'];
	
	module.exports = function (ngModule) {
	    ngModule.component('lateralmap', component);
	    ngModule.directive('lmForcechart', __webpack_require__(821));
	    // ngModule.directive('lmForcechart', require('./lm_test.js'));
	    ngModule.directive('lmSidebar', __webpack_require__(824));
	};

/***/ },
/* 818 */
/***/ function(module, exports) {

	module.exports = "<div lm-sidebar></div>\n<div lm-forcechart></div>";

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(820);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=/app/node_modules/compass-mixins/lib!./lateral_map.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=/app/node_modules/compass-mixins/lib!./lateral_map.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".linkSlider{display:inline-block;-webkit-user-select:none;-moz-user-select:none;user-select:none}.linkSlider .domain{fill:none;stroke:#2a6acc;opacity:.8;stroke-width:12px;stroke-linecap:round;padding:1px 0 0}.linkSlider .slider .handle{cursor:pointer;fill:#2a6acc;stroke:#fff;stroke-opacity:1;stroke-width:3px}.linkSlider .axis .tick{width:20px!important}.slider_buttons{opacity:.8;cursor:pointer}.slider_buttons:hover{opacity:1}.slider_text{text-transform:capitalize;margin:0;padding:0}.domain{height:30px!important}.unselect{float:left}.unselect:hover{cursor:pointer;text-decoration:underline}.l7_table{overflow-y:auto;max-height:222px}.l7_table table.node_l7{width:90%;margin-left:5%;overflow:hidden;overflow-y:auto;font-size:11px}.l7_table table.node_l7 tr{width:100%}.l7_table table.node_l7 tr th{width:auto}.l7_table table.node_l7 tr td{cursor:pointer}.l7_table table.node_l7 tr td,.l7_table table.node_l7 tr td:first-child{word-break:break-all;word-wrap:break-word;vertical-align:top;text-align:center;padding:0;margin:0}.l7_table table.node_l7 tr:hover{font-weight:700}.node_list,.node_list_title{width:100%;height:30px;min-height:30px;max-height:30px;overflow:hidden;font-size:11px;cursor:pointer}.node_list .nl_conn_count,.node_list .nl_hostname,.node_list .nl_ip,.node_list .nl_type,.node_list_title .nl_conn_count,.node_list_title .nl_hostname,.node_list_title .nl_ip,.node_list_title .nl_type{word-break:break-all!important;display:inline-block;height:100%;min-height:100%;max-height:100%;line-height:30px;vertical-align:top;text-align:center;margin:0;padding:0;width:auto;overflow:hidden}.node_list .nl_type,.node_list_title .nl_type{width:30px}.node_list .nl_ip,.node_list_title .nl_ip{width:33%;margin:0 1%}.node_list .nl_hostname,.node_list_title .nl_hostname{width:40%}.node_list .nl_conn_count,.node_list_title .nl_conn_count{float:right;width:auto;margin:0 3% 0 0}.node_list{margin:0 0 0 2px;background:#fff;border-radius:5px;margin:4px 0;box-shadow:0 0 1px 0 #474747}.node_list:hover{box-shadow:inset 0 0 1px .5px #474747}.node_list_title{font-weight:700}.node_list_title span:hover{text-decoration:underline}.hover_text rect{fill:#fff;stroke:#ddd;stroke-width:2}#edit_area{margin:1% 0}#sidebar_svg{margin:0 0 -15px;padding:0;stroke:none;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}#lateral_map,#sidebar{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;vertical-align:top;border-radius:8px;background:#fff}#lateral_map,#sidebar{display:inline-block}#lateral_map .circle{cursor:pointer;overflow:hidden;position:absolute}#lateral_map .circle:active{cursor:move}#sidebar{padding:0;margin:0 0 0 1%;float:right}#sidebar .sidebar_label{margin:0 0 2px 3px;padding:0}#sidebar_content{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;width:100%;padding:0 15px;overflow-y:auto}#sidebar_content select{width:98%}#sidebar_content input[type=color],#sidebar_content input[type=text]{width:94%}#sidebar_content::-webkit-scrollbar-track,#sidebar_content ::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);border-radius:10px;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}#sidebar_content::-webkit-scrollbar,#sidebar_content ::-webkit-scrollbar{width:8px}#sidebar_content::-webkit-scrollbar-thumb,#sidebar_content ::-webkit-scrollbar-thumb{border-radius:10px;background:rgba(255,0,0,.8);-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.5)}#sidebar_content::-webkit-scrollbar-thumb:window-inactive,#sidebar_content ::-webkit-scrollbar-thumb:window-inactive{background:rgba(255,0,0,.4)}#sidebar_toggle{padding:0 0 0 15px;margin:-20px 0 -1px!important}#big_slider{display:block;padding:5px;margin:0;width:100%;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;vertical-align:top}#big_slider .slider .handle{stroke:#f5f5f5}.hide_section{display:none!important}.sidebar_title{display:block;padding:15px 0;opacity:.8;cursor:pointer}.sidebar_title .arrow_title,.sidebar_title .svg_title{display:inline-block;vertical-align:top;height:24px;padding:0;margin:0}.sidebar_title .arrow_title{float:right}.sidebar_title h3{margin:0 0 0 10px;padding:0;display:inline-block;height:24px;line-height:24px}.sidebar_title.selected,.sidebar_title:hover{opacity:1}#node_info_rows{max-height:342px;overflow-y:auto}#node_info_rows .node_sidebar{width:98%;padding:0 0 0 1px}#collapse_info_content,#filter_info_content,#group_info_content,#map_settings_content,#node_info_content,#node_type_content{padding:0 0 15px}#filter_info,#group_info,#map_settings,#node_info,#node_type{vertical-align:top;width:100%;padding:0;margin:0}#node_info{border-top:1px solid #ddd}#collapse_info,#filter_info,#group_info,#node_info,#node_type{border-bottom:1px solid #ddd}#selected_node{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:8px;border:1px solid #aaa;border-radius:8px;overflow:hidden}#selected_node .selected_scroll{overflow-y:auto;max-height:300px}#selected_node table{width:100%}#selected_node table tr{display:block;width:100%}#selected_node table tr td{display:inline-block;word-break:break-all;word-wrap:break-word;vertical-align:top;text-align:left;padding:0;width:50%;min-width:50%;max-width:50%;width:45%;min-width:45%;max-width:45%;margin:0;line-height:15px}#selected_node table tr td:first-child{font-weight:700;text-align:right;padding:0 5% 0 0;margin:0;word-break:break-all;word-wrap:break-word}#selected_node .list_l7_table{overflow-y:auto;max-height:150px}#selected_node .list_l7_table table{width:100%}#selected_node .list_l7_table table tr{display:block;width:100%}#selected_node .list_l7_table table tr td{font-weight:400;display:inline-block;vertical-align:top;text-align:center;padding:0;width:33%;min-width:33%;max-width:33%;margin:0;line-height:13px}#selected_node .list_l7{border-top:1px solid #ddd;margin:5px 0 0;padding:0}#selected_node .list_l7 .l7_title{text-align:center;width:100%;display:block;font-size:14px;font-weight:700;margin:5px 0;padding:0}#selected_node .list_l7 .l7_th{display:inline-block;vertical-align:top;text-align:center;padding:0;width:33%;min-width:33%;max-width:33%;margin:0;line-height:13px;font-weight:700}#sidebar_toggle h3{padding:0;opacity:.8}#sidebar_toggle h3,.close_sidebar{display:inline-block;margin:0;vertical-align:top;line-height:50px}.close_sidebar{padding:0;padding:7px 0 0 12px;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;width:50px;height:50px;float:right;border-radius:8px;cursor:pointer;background:#fff}.close_sidebar:hover{background:#ddd}#collapse_info_content .collapse_svg,#collapse_info_content .select_circles{cursor:pointer}#collapse_info_content .collapse_svg:hover,#collapse_info_content .select_circles:hover{opacity:1}#collapse_info_content .select_circles circle{stroke:none;fill:#eee}#collapse_info_content .select_circles.selected circle,#collapse_info_content .select_circles:hover circle{fill:#83b152;box-shadow:0 0 4px #333}#collapse_info_content .select_circles.selected circle{stroke:#333;stroke-width:2px}#collapse_info_content .collapse_svg{opacity:.8}#collapse_info_content .collapse_svg:hover path{fill:#83b152}#collapse_info_content .collapse_svg path{fill:#333}#collapse_info_content .slider_line{fill:none;stroke:#eee;opacity:.8;stroke-width:16px;stroke-linecap:round;padding:1px 0 0}#collapse_info_content .slider_collapse_text{text-anchor:middle;margin:0;padding:0}#collapse_info_content .toggle-button{background-color:#fff;margin:5px 0;border-radius:20px;border:2px solid #d0d0d0;height:24px;cursor:pointer;width:50px;position:relative;display:inline-block;user-select:none;-webkit-user-select:none;-ms-user-select:none;-moz-user-select:none}#collapse_info_content .toggle-button button{cursor:pointer;outline:0;display:block;position:absolute;left:0;top:0;border-radius:100%;min-width:24px;width:30px;height:30px;background-color:#fff;float:left;margin:-3px 0 0 -3px;border:2px solid #d0d0d0;transition:left .3s}#collapse_info_content .toggle-button-selected{background-color:#83b152;border:2px solid #7da652}#collapse_info_content .toggle-button-selected button{left:26px;top:0;margin:0;border:none;width:24px;height:24px;box-shadow:0 0 4px rgba(0,0,0,.1)}#collapse_info_content .center{text-align:center}#help_button{float:right;margin-right:10px}#click_popup{fill:#666;cursor:pointer}#click_popup:hover{fill:#333}.overlay{position:absolute;z-index:9999;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,.7);visibility:visible;opacity:1}.overlay .guarded{color:#377fc7}.overlay .elevated{color:#f5d800}.overlay .high{color:#f88b12}.overlay .severe{color:#ff3131}.overlay.hidden{transition:opacity .5s;visibility:hidden;opacity:0}.popup{margin:70px auto;padding:20px;background:#fff;border-radius:5px;width:60%;position:relative;transition:all 5s ease-in-out}.popup h2{margin-top:0;color:#333;font-family:Tahoma,Arial,sans-serif}.popup .close{position:absolute;top:20px;right:30px;transition:all .2s;font-size:30px;font-weight:700;text-decoration:none;color:#333}.popup .close:hover{color:orange}.popup .content{max-height:600px;overflow-y:auto;margin:0}.popup .content::-webkit-scrollbar-track,.popup .content ::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);border-radius:10px;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}.popup .content::-webkit-scrollbar,.popup .content ::-webkit-scrollbar{width:8px}.popup .content::-webkit-scrollbar-thumb,.popup .content ::-webkit-scrollbar-thumb{border-radius:10px;background:rgba(255,0,0,.8);-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.5)}.popup .content::-webkit-scrollbar-thumb:window-inactive,.popup .content ::-webkit-scrollbar-thumb:window-inactive{background:rgba(255,0,0,.4)}.popup .content .type_columns{width:24%;display:inline-block;vertical-align:top;margin:10px 0}.popup .content h3{font-size:20px;margin:20px 0 10px;padding:0}.popup .content h4{font-size:16px;margin:15px 0 5px;padding:0}.popup .content h5{font-size:14px;margin:15px 0 5px;padding:0}.node_ip{cursor:pointer}.node_ip:hover{text-decoration:underline}", ""]);
	
	// exports


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var d3_1 = __webpack_require__(822);
	var _ = __webpack_require__(762);
	function directive($window, timeFormat, $state, $stateParams) {
	    return {
	        transclude: true,
	        require: '^lateralmap',
	        // template: '<svg id="lateral_map"></svg>',
	        template: __webpack_require__(823),
	        link: function ($scope, element, attrs, lmCtrl) {
	            /////////////////
	            /// VARIABLES ///
	            ///////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------
	            // nodes_object get turned into this array (shows all the visible nodes) (d3 needs an array for it can  .data(x).enter())
	            var visible_nodes, visible_links;
	            // FORCE CHART
	            var load_complete = 0; // if = 2, inital load is complete (2 different table calls)
	            var new_lat_nodes = false; // whenever a new nodes affects the nodes_object from network assets table, it is then set to true so it can call redraw()
	            var new_lat_conns = false; // whenever a new nodes affects the nodes_object from lateral connections, it is then set to true so it can call redraw()
	            var distanceMin = 1, distanceMax = Infinity;
	            var text_padding = 4; // padding about the hover text
	            // Scale for the map (zoom and movements)
	            var scale = 1;
	            var translate = [0, 0];
	            if (lmCtrl.settings.get('translateX')) {
	                translate[0] = lmCtrl.settings.get('translateX');
	            }
	            if (lmCtrl.settings.get('translateY')) {
	                translate[1] = lmCtrl.settings.get('translateY');
	            }
	            if (lmCtrl.settings.get('scale')) {
	                scale = lmCtrl.settings.get('scale');
	            }
	            // used for sorting the sidear node info (what columns and direction)
	            var temp_sort = "weight";
	            var desc = true;
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	            ////////////////////////////
	            /// CUSTOM FORCE CLASSES ///
	            //////////////////////////// -------------------------------------------------------------------------------------------------------------------------------------------------
	            /*
	                - This is the d3_force_chart ripped out, modified and put into a class.
	                - So what happens is that you have 2 set of arrays, one is the array of nodes, the other is array of links between the nodes.
	                - Each node is an object, there is a seperate Object of objects mapped by IPs for easy access and pass by reference
	                - The links array are objects that have the source Ip and target IP.
	                - On force.start, the target IP and source IP is replaced by the actual node object (with the matching IP) from nodes_object (links.source = nodes_object[links.source] (if links.source = IP))
	                - Once start is called, it calls resume, which changes the alpha value. Inside force.tick it will gradualy lower alpha until it reachs the specified alpha value which while simultaneously adjusting the node
	                    and link positions (until the alpha has reached its limit) which stops the graph from drawing.
	            */
	            var CustomForce = (function () {
	                function CustomForce(id) {
	                    var _this = this;
	                    this.canvas = document.getElementById(id);
	                    this.canvas.height = lmCtrl.height;
	                    this.canvas.width = lmCtrl.width;
	                    this.ctx = this.canvas.getContext("2d");
	                    this.nodes = [];
	                    this.links = [];
	                    ;
	                    // this.ctx = canvas.getContext('2d');
	                    this.valid = false; // when set to false, the canvas will redraw everything
	                    this.dragging = false; // Keep track of when we are dragging a node
	                    this.canvas_clicked = false; // Keep track of when we are dragging the canvas
	                    // the current selected object. In the future we could turn this into an array for multiple selection
	                    this.selection = null;
	                    this.offsetX = 0;
	                    this.offsetY = 0;
	                    this.scale = 1;
	                    this.originx = 0;
	                    this.originy = 0;
	                    this.resize_zoom();
	                    this.event = d3_1.dispatch("start", "tick", "end"),
	                        this.timer = null;
	                    this.size = [1, 1];
	                    this.alpha = null;
	                    this.chargeDistance = Infinity;
	                    this.theta = 0.64;
	                    // d3.rebind(this, this.event, "on");
	                    // this.event.on("start", this.start);
	                    // this.event.on("tick", this.tick);
	                    // this.event.on("end", this.end);
	                    //fixes a problem where double clicking causes text to get selected on the canvas
	                    this.canvas.addEventListener('selectstart', function (e) { e.preventDefault(); return false; }, false);
	                    // Up, down, and move are for dragging
	                    this.canvas.addEventListener('mousedown', function (e) {
	                        _this.mousedown(e);
	                    }, true);
	                    this.canvas.addEventListener('mousemove', function (e) {
	                        _this.mousemove(e);
	                    }, true);
	                    this.canvas.addEventListener('mousewheel', function (e) {
	                        _this.mousewheel(e);
	                    }, true);
	                    this.canvas.addEventListener('mouseup', function (e) {
	                        _this.mouseup(e);
	                    }, true);
	                    this.canvas.addEventListener('dblclick', function (e) {
	                        _this.dblclick(e);
	                    }, true);
	                }
	                // nodes/links positioning & movement
	                // makes sure all the nodes have a weight
	                // also makes sure that all the links have actual nodes attached at each end
	                // calls this.resume() which stats the movements of the nodes
	                CustomForce.prototype.start = function () {
	                    var current_index, nodes_length = this.nodes.length, links_length = this.links.length;
	                    var width = this.size[0], height = this.size[1];
	                    for (current_index = 0; current_index < nodes_length; ++current_index) {
	                        this.nodes[current_index].index = current_index;
	                        this.nodes[current_index].weight = 0;
	                    }
	                    for (current_index = 0; current_index < links_length; ++current_index) {
	                        // if (typeof this.links[current_index].source == "string") {
	                        //     this.links[current_index].setSource(lmCtrl.nodes_object[this.links[current_index].source]);
	                        // }
	                        // if (typeof this.links[current_index].target == "string") {
	                        //     this.links[current_index].setTarget(lmCtrl.nodes_object[this.links[current_index].target]);
	                        // }
	                        ++this.links[current_index].source.weight;
	                        ++this.links[current_index].target.weight;
	                    }
	                    return this.resume();
	                };
	                // this is the function that makes the nodes and links move and stops the chart from moving once the alpha reachs its limit
	                // it also perferms certain operations depending on the force chart attributes (gravity, charge, etc) can calls draw which draws all the nodes and links
	                CustomForce.prototype.tick = function () {
	                    var _this = this;
	                    if ((this.alpha *= 0.99) < 0.009) {
	                        // this.valid = true;
	                        if (this.timer) {
	                            this.timer.stop();
	                        }
	                        this.timer = null;
	                        this.event.call("end", { type: "end" }, this.alpha = 0);
	                        return true;
	                    }
	                    if (!this.dragging) {
	                        var nodes_length = this.nodes.length, links_length = this.links.length;
	                        var qt = void 0, current_index = void 0, current_link = void 0, current_node = void 0, current_source = void 0, current_target = void 0, current_distance = void 0, current_force = void 0, x_distance = void 0, y_distance = void 0;
	                        // gauss-seidel relaxation for links
	                        for (current_index = 0; current_index < links_length; ++current_index) {
	                            current_link = this.links[current_index];
	                            current_source = current_link.source;
	                            current_target = current_link.target;
	                            x_distance = current_target.x - current_source.x;
	                            y_distance = current_target.y - current_source.y;
	                            if (current_distance = (x_distance * x_distance + y_distance * y_distance)) {
	                                current_distance = this.alpha * lmCtrl.link_strength * ((current_distance = Math.sqrt(current_distance)) - lmCtrl.link_distance) / current_distance;
	                                x_distance *= current_distance;
	                                y_distance *= current_distance;
	                                current_target.x -= x_distance * (current_force = (current_source.weight + current_target.weight ? current_source.weight / (current_source.weight + current_target.weight) : 0.5));
	                                current_target.y -= y_distance * current_force;
	                                current_source.x += x_distance * (current_force = 1 - current_force);
	                                current_source.y += y_distance * current_force;
	                            }
	                        }
	                        // apply gravity forces
	                        if (current_force = this.alpha * lmCtrl.gravity) {
	                            x_distance = this.size[0] / 2;
	                            y_distance = this.size[1] / 2;
	                            current_index = -1;
	                            if (current_force)
	                                while (++current_index < nodes_length) {
	                                    current_node = this.nodes[current_index];
	                                    current_node.x += (x_distance - current_node.x) * current_force;
	                                    current_node.y += (y_distance - current_node.y) * current_force;
	                                }
	                        }
	                        // compute quadtree center of mass and apply charge forces
	                        if (lmCtrl.charge) {
	                            var i, n = this.nodes.length, node, tree;
	                            tree = d3_1.quadtree(this.nodes, doX, doY).visitAfter(this.forceAccumulate);
	                            for (i = 0; i < n; ++i) {
	                                this.node = this.nodes[i];
	                                if (!this.node.fixed) {
	                                    tree.visit(function (quad, x0, y0, x1, y1) {
	                                        _this.repulse(quad, x0, _, x1);
	                                        _this.xi = _this.node.x + _this.node.px;
	                                        _this.yi = _this.node.y + _this.node.py;
	                                        _this.collide(quad, x0, y0, x1, y1);
	                                    });
	                                }
	                            }
	                        }
	                        // position verlet integration
	                        current_index = -1;
	                        while (++current_index < nodes_length) {
	                            current_node = this.nodes[current_index];
	                            if (current_node.fixed) {
	                                current_node.x = current_node.px;
	                                current_node.y = current_node.py;
	                            }
	                            else {
	                                current_node.x -= (current_node.px - (current_node.px = current_node.x)) * lmCtrl.friction;
	                                current_node.y -= (current_node.py - (current_node.py = current_node.y)) * lmCtrl.friction;
	                            }
	                        }
	                    }
	                    this.draw();
	                    this.event.call("tick", { type: "tick" }, this.alpha);
	                };
	                CustomForce.prototype.forceAccumulate = function (quad, alpha) {
	                    var strength = 0, q, c, x, y, i;
	                    // For internal nodes, accumulate forces from child quadrants.
	                    if (quad.length) {
	                        for (x = y = i = 0; i < 4; ++i) {
	                            if ((q = quad[i]) && (c = q.value)) {
	                                strength += c, x += c * q.x, y += c * q.y;
	                            }
	                        }
	                        quad.x = x / strength;
	                        quad.y = y / strength;
	                    }
	                    else {
	                        q = quad;
	                        q.x = q.data.x;
	                        q.y = q.data.y;
	                        do
	                            strength += 1;
	                        while (q = q.next);
	                    }
	                    quad.value = strength;
	                };
	                // if there is charge, repulse is used
	                // this function is basically the opposite of gravity, all the nodes want to gravitate towards the middle, this will make sure they spread out a bit.
	                // repulse(node: Node) {
	                CustomForce.prototype.repulse = function (quad, x1, _, x2) {
	                    var x = quad.x - this.node.x, y = quad.y - this.node.y, w = x2 - x1, l = x * x + y * y, k = this.alpha * lmCtrl.charge;
	                    // Apply the Barnes-Hut approximation if possible.
	                    // Limit forces for very close nodes; randomize direction if coincident.
	                    if (w * w / this.theta < l) {
	                        if (l < distanceMax) {
	                            if (x === 0)
	                                x = (Math.random() - 0.5), l += x * x;
	                            if (y === 0)
	                                y = (Math.random() - 0.5), l += y * y;
	                            if (l < distanceMin)
	                                l = Math.sqrt(l);
	                            // if (l > k) {
	                            if (((x * k / l) < 3) || ((x * k / l) > -3)) {
	                                this.node.px -= x * k / l;
	                                this.node.py -= y * k / l;
	                            }
	                        }
	                        return true;
	                    }
	                    else if (quad.length || l >= distanceMax)
	                        return;
	                    // Limit forces for very close nodes; randomize direction if coincident.
	                    if (quad.data !== this.node || quad.next) {
	                        if (x === 0)
	                            x = (Math.random() - 0.5), l += x * x;
	                        if (y === 0)
	                            y = (Math.random() - 0.5), l += y * y;
	                        if (l < distanceMin)
	                            l = Math.sqrt(l);
	                    }
	                    do
	                        if (quad.data !== this.node) {
	                            // if ((l > k) && (l > Math.abs(lmCtrl.charge)*2)) {
	                            if (((x * k / l) < 3) || ((x * k / l) > -3)) {
	                                this.node.px -= x * k / l;
	                                this.node.py -= y * k / l;
	                            }
	                        }
	                    while (quad = quad.next);
	                };
	                CustomForce.prototype.collide = function (quad, x0, y0, x1, y1) {
	                    var data = quad.data, rj = lmCtrl.maxRadius, r = (lmCtrl.maxRadius * lmCtrl.padding) + lmCtrl.maxRadius;
	                    if (data) {
	                        if (data.ip !== this.node.ip) {
	                            r = data.radius + lmCtrl.maxRadius + (lmCtrl.maxRadius * lmCtrl.padding);
	                            rj = data.radius;
	                            var x = this.xi - data.x - data.px, y = this.yi - data.y - data.py, l = x * x + y * y;
	                            if (l < r * r) {
	                                if (x === 0)
	                                    x = (Math.random() - 0.5), l += x * x;
	                                if (y === 0)
	                                    y = (Math.random() - 0.5), l += y * y;
	                                l = (r - (l = Math.sqrt(l))) / l * this.alpha;
	                                this.node.px -= (x *= l) * (r = (rj *= rj) / ((lmCtrl.maxRadius * lmCtrl.maxRadius) + rj));
	                                this.node.py -= (y *= l) * r;
	                                if (!data.fixed) {
	                                    data.px += x * (r = 1 - r);
	                                    data.py += y * r;
	                                }
	                            }
	                        }
	                        return;
	                    }
	                    return x0 > this.xi + r || x1 < this.xi - r || y0 > this.yi + r || y1 < this.yi - r;
	                };
	                // starts the movement of the map
	                CustomForce.prototype.resume = function () {
	                    return this.set_alpha(0.1);
	                };
	                // stops the movement of the map
	                CustomForce.prototype.stop = function () {
	                    return this.set_alpha(0);
	                };
	                // editing values for custom force chart
	                CustomForce.prototype.set_nodes = function (x) {
	                    if (!arguments.length)
	                        return this.nodes;
	                    this.nodes = x;
	                    this.valid = false;
	                };
	                CustomForce.prototype.set_links = function (x) {
	                    if (!arguments.length)
	                        return this.links;
	                    this.links = x;
	                    this.valid = false;
	                };
	                CustomForce.prototype.set_size = function (x) {
	                    if (!arguments.length)
	                        return this.size;
	                    this.size = x;
	                };
	                CustomForce.prototype.set_theta = function (x) {
	                    if (!arguments.length)
	                        return Math.sqrt(this.theta);
	                    this.theta = x * x;
	                };
	                // starts the d3 timer, also is when alpha is greater than a cetain value (0.009) all the nodes move, else the map stops
	                CustomForce.prototype.set_alpha = function (x) {
	                    if (!arguments.length)
	                        return this.alpha;
	                    x = +x;
	                    if (this.alpha) {
	                        if (x > 0) {
	                            this.alpha = x;
	                        }
	                        else {
	                            if (this.timer) {
	                                this.timer.stop();
	                            }
	                            this.timer = null;
	                            this.event.call("end", { type: "end" }, this.alpha = 0);
	                        }
	                    }
	                    else if (x > 0) {
	                        this.event.call("start", { type: "start" }, this.alpha = x);
	                        this.timer = d3_1.timer(this.tick.bind(this));
	                    }
	                };
	                // canvas drawing
	                CustomForce.prototype.clear = function () {
	                    this.ctx.clearRect(this.originx, this.originy, (lmCtrl.width / this.scale) * 2, (lmCtrl.height / this.scale) * 2);
	                };
	                CustomForce.prototype.draw = function () {
	                    if (!this.valid) {
	                        var ctx = this.ctx;
	                        var nodes = this.nodes;
	                        var links = this.links;
	                        this.clear();
	                        // this.set_zoom();
	                        // this.ctx.fillStyle = "#999";
	                        // this.ctx.fillRect(this.originx, this.originy, (lmCtrl.width/this.scale), (lmCtrl.height/this.scale))
	                        // ** Add stuff you want drawn in the background all the time here **
	                        // draw all nodes
	                        var i = void 0, l = links.length;
	                        for (i = 0; i < l; i++) {
	                            // this.valid = true;
	                            links[i].draw(ctx);
	                        }
	                        // ** Add stuff you want drawn in the background all the time here **
	                        // draw all nodes
	                        var x = void 0, n = nodes.length;
	                        for (x = 0; x < n; x++) {
	                            var node = nodes[x];
	                            // We can skip the drawing of elements that have moved off the screen:
	                            // if (node.x - node.r > (lmCtrl.width/this.scale)
	                            //     || node.y - node.radius > (lmCtrl.height/this.scale)
	                            //     || node.x + node.radius < (0+this.originx)
	                            //     || node.y + node.radius < (0+this.originy)) continue;
	                            node.draw(ctx);
	                        }
	                        for (x = 0; x < n; x++) {
	                            if (nodes[x].hover)
	                                nodes[x].drawHover(ctx);
	                        }
	                    }
	                };
	                // needs to be called on load and or when the window size changes
	                CustomForce.prototype.resize_zoom = function () {
	                    // this.ctx.restore();
	                    this.valid = false;
	                    this.ctx.translate(0, 0);
	                    this.scale = scale;
	                    this.originx = translate[0];
	                    this.originy = translate[1];
	                    this.ctx.scale(this.scale, this.scale);
	                    this.ctx.translate(-this.originx, -this.originy);
	                    // this.ctx.save();
	                };
	                // action from the sidebar
	                CustomForce.prototype.reset_zoom = function () {
	                    this.valid = false;
	                    this.ctx.translate(this.originx, this.originy);
	                    scale = 1 / scale;
	                    translate = [0, 0];
	                    this.scale = scale;
	                    this.originx = translate[0];
	                    this.originy = translate[1];
	                    this.ctx.scale(this.scale, this.scale);
	                    this.ctx.translate(-this.originx, -this.originy);
	                    this.scale = scale = 1;
	                    this.draw();
	                };
	                // mouse events
	                // returns the mouse coordinates
	                CustomForce.prototype.getMouse = function (e) {
	                    var element = this.canvas, offsetX = 0, offsetY = 0, mx, my;
	                    // Compute the total offset
	                    if (element.offsetParent !== undefined) {
	                        do {
	                            offsetX += element.offsetLeft;
	                            offsetY += element.offsetTop;
	                        } while ((element = element.offsetParent));
	                    }
	                    mx = e.pageX - offsetX;
	                    my = e.pageY - offsetY;
	                    // We return a simple javascript object (a hash) with x and y defined
	                    return { x: mx, y: my };
	                };
	                // all the things that happen when you click (mousedown) on the canvas:
	                // check to see if a node, link or nothing is clicked and depending;
	                CustomForce.prototype.mousedown = function (e) {
	                    this.resume();
	                    this.canvas_clicked = true;
	                    var mouse = this.getMouse(e);
	                    var mx = mouse.x;
	                    var my = mouse.y;
	                    var nodes = this.nodes;
	                    var n = nodes.length;
	                    var i;
	                    var isNodeSelected = false;
	                    var links = this.links;
	                    var l = links.length;
	                    var linkClicked = false;
	                    var mySel;
	                    for (i = n - 1; i >= 0; i--) {
	                        if (nodes[i].contains(mx, my)) {
	                            mySel = nodes[i];
	                            isNodeSelected = mySel.selected;
	                            this.canvas_clicked = false;
	                            break;
	                        }
	                    }
	                    for (i = l - 1; i >= 0; i--) {
	                        if (links[i].contains(mouse)) {
	                            linkClicked = true;
	                            this.canvas_clicked = false;
	                            break;
	                        }
	                    }
	                    if (mySel) {
	                        if (!lmCtrl.ctrlKey) {
	                            nodes.map(function (d) { d.selected = false; });
	                        }
	                        if (isNodeSelected) {
	                            mySel.selected = false;
	                        }
	                        else {
	                            mySel.selected = true;
	                        }
	                        // Keep track of where in the object we clicked
	                        // so we can move it smoothly (see mousemove)
	                        this.offsetX = (mx / this.scale - mySel.x);
	                        this.offsetY = (my / this.scale - mySel.y);
	                        this.dragging = true;
	                        this.selection = mySel;
	                        this.valid = false;
	                        lmCtrl.nodeClicked(mySel);
	                        return;
	                    }
	                    // havent returned means we have failed to select anything.
	                    // If there was an object selected, we deselect it
	                    if (this.selection) {
	                        this.selection = null;
	                        this.valid = false; // Need to clear the old selection border
	                    }
	                    if (!linkClicked) {
	                        $scope.unselect();
	                    }
	                };
	                // this is constantly beingc called if your mouse is over the canvas,
	                // depending on your actions or mouse placement will affect what happens
	                CustomForce.prototype.mousemove = function (e) {
	                    if (this.dragging) {
	                        e.target.style.cursor = 'move';
	                        this.selection.selected = true;
	                        this.set_alpha(0.1);
	                        var mouse = this.getMouse(e);
	                        // We don't want to drag the object by its top-left corner, we want to drag it
	                        // from where we clicked. Thats why we saved the offset and use it here
	                        this.selection.x = (mouse.x / this.scale - this.offsetX);
	                        this.selection.y = (mouse.y / this.scale - this.offsetY);
	                        this.valid = false; // Something's dragging so we must redraw
	                    }
	                    else if (this.canvas_clicked) {
	                        this.valid = false;
	                        this.clear();
	                        this.ctx.translate(this.originx, this.originy);
	                        this.originx -= (e.movementX / this.scale);
	                        this.originy -= (e.movementY / this.scale);
	                        this.ctx.translate(-this.originx, -this.originy);
	                        translate = [this.originx, this.originy];
	                        this.draw();
	                        lmCtrl.waitForFinalEvent(function () {
	                            zoom_chart_end();
	                        }, 250, "lateral_map_zoom");
	                    }
	                    else {
	                        e.target.style.cursor = 'default';
	                        var nodes = this.nodes;
	                        var links = this.links;
	                        nodes.map(function (d) { d.hover = false; });
	                        links.map(function (d) { d.hover = false; });
	                        var mouse = this.getMouse(e);
	                        var n = nodes.length;
	                        for (var i = n - 1; i >= 0; i--) {
	                            if (nodes[i].contains(mouse.x, mouse.y)) {
	                                nodes[i].hover = true;
	                                e.target.style.cursor = 'pointer';
	                                this.draw();
	                                return;
	                            }
	                        }
	                        var l = links.length;
	                        for (var i = l - 1; i >= 0; i--) {
	                            if (links[i].contains(mouse)) {
	                                links[i].hover = true;
	                                this.draw();
	                                return;
	                            }
	                        }
	                    }
	                    this.draw();
	                };
	                // when you release the mouse click
	                CustomForce.prototype.mouseup = function (e) {
	                    e.target.style.cursor = 'default';
	                    if (this.selection) {
	                        this.selection.fixed = true;
	                        this.selection.px = this.selection.x;
	                        this.selection.py = this.selection.y;
	                    }
	                    this.dragging = false;
	                    this.canvas_clicked = false;
	                };
	                // zooming of the canvas with your mouse wheel
	                CustomForce.prototype.mousewheel = function (e) {
	                    e.preventDefault();
	                    var mousex = e.clientX - this.canvas.offsetLeft;
	                    var mousey = e.clientY - this.canvas.offsetTop;
	                    var wheel = e.wheelDelta / 120; //n or -n
	                    var zoom = 1 + wheel / 4;
	                    if ((this.scale * zoom > 0.25) && (this.scale * zoom < 3)) {
	                        this.valid = false;
	                        this.clear();
	                        this.ctx.translate(this.originx, this.originy);
	                        this.ctx.scale(zoom, zoom);
	                        this.originx = (mousex / this.scale + this.originx - mousex / (this.scale * zoom));
	                        this.originy = (mousey / this.scale + this.originy - mousey / (this.scale * zoom));
	                        this.ctx.translate(-this.originx, -this.originy);
	                        this.scale *= zoom;
	                        translate = [this.originx, this.originy];
	                        scale = this.scale;
	                        this.draw();
	                        lmCtrl.waitForFinalEvent(function () {
	                            zoom_chart_end();
	                        }, 250, "lateral_map_zoom");
	                    }
	                };
	                // action that happens when you double click on the canvas
	                CustomForce.prototype.dblclick = function (e) {
	                    e.preventDefault();
	                    var mouse = this.getMouse(e);
	                    var nodes = this.nodes;
	                    var l = nodes.length;
	                    for (var i = l - 1; i >= 0; i--) {
	                        if (nodes[i].contains(mouse.x, mouse.y)) {
	                            nodes[i].fixed = false;
	                            nodes[i].selected = false;
	                            this.selection = null;
	                            if (nodes[i].collapse) {
	                                lmCtrl.expand_collapsed(nodes[i]);
	                            }
	                            return;
	                        }
	                    }
	                };
	                return CustomForce;
	            }());
	            function doX(d) {
	                return d.x;
	            }
	            function doY(d) {
	                return d.y;
	            }
	            // Node class contains:
	            // Node attributes
	            // drawing on canvas
	            // drawing of hover on nodes
	            var Node = (function () {
	                function Node(node) {
	                    this.id = false; // (boolean | string) = false
	                    this.ip = ""; // (string | string[]) = "";
	                    this.hostname = "N/A"; // (string | string[]) = "N/A";
	                    this.mac = "N/A"; //  (string | string[]) = "N/A"
	                    this.os = "N/A"; // (string | string[]) = "N/A"
	                    this.type = "new"; // (string | string[] | boolean) = "N/A"
	                    this.vendor = "N/A"; // (string | string[]) = "N/A";
	                    this.group = "N/A"; // (string | number | string[]) = "N/A";
	                    this.collapse = false;
	                    this.action = false; //
	                    this.resp_l7 = [];
	                    this.orig_l7 = [];
	                    this.ioc = 0;
	                    this.weight = 0;
	                    this.index = 0;
	                    this.first_seen = 0;
	                    this.last_seen = 0;
	                    this.selected = false;
	                    this.hover = false;
	                    this.fixed = false;
	                    this.grey = false;
	                    this.visible = true;
	                    this.radius = lmCtrl.maxRadius;
	                    this.x = (lmCtrl.width / 2) + (Math.random() * lmCtrl.maxRadius);
	                    this.y = (lmCtrl.height / 2) + (Math.random() * lmCtrl.maxRadius);
	                    this.px = this.x;
	                    this.py = this.y;
	                    if (node) {
	                        this.editNode(node);
	                    }
	                }
	                Node.prototype.editNode = function (node) {
	                    var n;
	                    for (n in node) {
	                        if ((n === "ioc_severity") || (n === "ioc")) {
	                            this["ioc"] = Math.max(this.ioc, node[n]);
	                        }
	                        else {
	                            this[n] = node[n];
	                        }
	                    }
	                };
	                Node.prototype.returnObject = function () {
	                    return {
	                        id: this.id,
	                        ip: this.ip,
	                        hostname: this.hostname,
	                        mac: this.mac,
	                        os: this.os,
	                        type: this.type,
	                        vendor: this.vendor,
	                        group: this.group,
	                        collapse: this.collapse,
	                        action: this.action,
	                        resp_l7: this.resp_l7,
	                        orig_l7: this.orig_l7,
	                        ioc: this.ioc,
	                        weight: this.weight,
	                        first_seen: this.first_seen,
	                        last_seen: this.last_seen,
	                        selected: this.selected,
	                        hover: this.hover,
	                        fixed: this.fixed,
	                        grey: this.grey,
	                        visible: this.visible,
	                        radius: this.radius,
	                        x: this.x,
	                        y: this.y,
	                        px: this.px,
	                        py: this.py,
	                    };
	                };
	                Node.prototype.contains = function (mx, my) {
	                    return ((this.x - this.radius) <= (mx / scale) + translate[0]) &&
	                        ((this.x + this.radius) >= (mx / scale) + translate[0]) &&
	                        ((this.y - this.radius) <= (my / scale) + translate[1]) &&
	                        ((this.y + this.radius) >= (my / scale) + translate[1]);
	                };
	                // draws the node on the canvas
	                Node.prototype.draw = function (ctx) {
	                    if (this.grey) {
	                        ctx.globalAlpha = 0.5;
	                    }
	                    else {
	                        ctx.globalAlpha = 1;
	                    }
	                    ctx.save();
	                    ctx.translate(this.x, this.y);
	                    ctx.beginPath();
	                    ctx.moveTo(0, 0);
	                    var icon = this.type;
	                    var group = this.group;
	                    if (this.collapse) {
	                        icon = this.action;
	                        group = "#333";
	                        if (this.group.length === 1)
	                            group = this.group[0];
	                        if (this.action === "ioc")
	                            group = this.ioc;
	                    }
	                    var isSel = 1;
	                    var bigger = 0;
	                    if (this.selected) {
	                        isSel = 1.5;
	                        bigger = 1;
	                    }
	                    ctx.fillStyle = lmCtrl.color(group);
	                    ctx.arc(0, 0, this.radius * isSel, 0, 2 * Math.PI);
	                    ctx.fill();
	                    ctx.closePath();
	                    ctx.fillStyle = "#fff";
	                    ctx.translate(svg_translate(icon, bigger)[0], svg_translate(icon, bigger)[1]);
	                    ctx.scale(svg_scale(icon, bigger), svg_scale(icon, bigger));
	                    ctx.beginPath();
	                    ctx.moveTo(0, 0);
	                    ctx.strokeStyle = "#fff";
	                    var img = new Path2D(lmCtrl.svgType(icon));
	                    ctx.stroke(img);
	                    ctx.fill(img);
	                    ctx.closePath();
	                    ctx.restore();
	                };
	                // draws the hover rectangles of the nodes
	                Node.prototype.drawHover = function (ctx) {
	                    if (this.hover) {
	                        if (this.grey) {
	                            ctx.globalAlpha = 0.5;
	                        }
	                        else {
	                            ctx.globalAlpha = 1;
	                        }
	                        var isSel = 1;
	                        if (this.selected) {
	                            isSel = 1.5;
	                        }
	                        var temp_string = "";
	                        if (this.collapse) {
	                            temp_string = ((this.ip.length === 1) ? "1 Node" : this.ip.length + " Nodes");
	                        }
	                        else {
	                            if ($scope.display_ip === "true") {
	                                temp_string += this.ip;
	                            }
	                            if ($scope.display_hostname) {
	                                if (($scope.display_ip === "true") && (this.hostname !== "N/A")) {
	                                    temp_string += " - ";
	                                }
	                                temp_string += this.hostname.replace("N/A", "");
	                            }
	                        }
	                        ctx.save();
	                        ctx.font = "12px Helvetica,sans-serif";
	                        if (ctx.measureText(temp_string).width > 0) {
	                            ctx.translate(this.x, this.y);
	                            ctx.beginPath();
	                            ctx.moveTo(0, 0);
	                            ctx.beginPath();
	                            ctx.scale(1, 1);
	                            ctx.strokeStyle = "#ccc";
	                            ctx.fillStyle = "#fff";
	                            ctx.lineWidth = 2;
	                            roundRect(ctx, (this.radius * isSel * 1.6), -10, (ctx.measureText(temp_string).width + 12), 20, 6, true, true);
	                            ctx.fillStyle = "#000";
	                            ctx.fillText(temp_string, (this.radius * isSel * 1.6) + 6, 4);
	                            ctx.closePath();
	                        }
	                        ctx.restore();
	                    }
	                };
	                return Node;
	            }());
	            // function for creating rounded rectangles for the hover of nodes and links
	            function roundRect(ctx, x, y, width, height, rdis, fill, stroke) {
	                if (typeof stroke == 'undefined') {
	                    stroke = true;
	                }
	                if (typeof rdis === 'undefined') {
	                    rdis = 5;
	                }
	                var radius = { tl: rdis, tr: rdis, br: rdis, bl: rdis };
	                ctx.beginPath();
	                ctx.moveTo(x + radius.tl, y);
	                ctx.lineTo(x + width - radius.tr, y);
	                ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
	                ctx.lineTo(x + width, y + height - radius.br);
	                ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
	                ctx.lineTo(x + radius.bl, y + height);
	                ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
	                ctx.lineTo(x, y + radius.tl);
	                ctx.quadraticCurveTo(x, y, x + radius.tl, y);
	                ctx.closePath();
	                if (fill) {
	                    ctx.fill();
	                }
	                if (stroke) {
	                    ctx.stroke();
	                }
	            }
	            // Link class contains a source and target which are both nodes
	            var Link = (function () {
	                function Link(source, target) {
	                    this.hover = false;
	                    this.source = source;
	                    this.target = target;
	                }
	                // draws the links
	                Link.prototype.draw = function (ctx) {
	                    if ((this.source.selected) || (this.target.selected)) {
	                        ctx.globalAlpha = 1;
	                    }
	                    else {
	                        ctx.globalAlpha = 0.5;
	                    }
	                    ctx.save();
	                    ctx.beginPath();
	                    ctx.moveTo(this.source.x, this.source.y);
	                    ctx.lineTo(this.target.x, this.target.y);
	                    ctx.lineWidth = 1;
	                    if (this.hover) {
	                        this.source.hover = true;
	                        this.target.hover = true;
	                        ctx.lineWidth = 5;
	                    }
	                    if (this.source.ioc > 0 && this.target.ioc > 0) {
	                        ctx.strokeStyle = lmCtrl.color(Math.max(this.source.ioc, this.target.ioc));
	                    }
	                    else {
	                        ctx.strokeStyle = "#aaa";
	                    }
	                    ctx.stroke();
	                    ctx.closePath();
	                    ctx.restore();
	                };
	                Link.prototype.setSource = function (source) {
	                    this.source = source;
	                };
	                Link.prototype.setTarget = function (target) {
	                    this.target = target;
	                };
	                // this is used to check is the values given are over the link (mouse events such as hover)
	                Link.prototype.contains = function (m) {
	                    return Math.abs((distance(this.source, m, true) + distance(this.target, m, true)) - distance(this.source, this.target, false)) <= 1;
	                };
	                return Link;
	            }());
	            // function is used to see if a link has been clicked on or hovered over
	            function distance(a, b, zoom) {
	                if (zoom) {
	                    return Math.sqrt((Math.pow((a.x - ((b.x / scale) + translate[0])), 2) + Math.pow((a.y - ((b.y / scale) + translate[1])), 2)));
	                }
	                return Math.sqrt((Math.pow((a.x - b.x), 2) + Math.pow((a.y - b.y), 2)));
	            }
	            // decleration of a new Custom Force
	            var customForce = new CustomForce("lateral_map");
	            customForce.set_size([lmCtrl.width, lmCtrl.height]);
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	            ////////////////
	            /// NEW DATA ///
	            //////////////// -----------------------------------------------------------------------------------------------------------------------------------------------------------
	            // Every single node (by IP) recorded on the network (from network assets)
	            // the latest lateral connections between two IPs
	            lmCtrl.socket.on('lateral_connections', function (data) {
	                if (data === 'done') {
	                    load_complete++;
	                    lmCtrl.socket.removeListener('lateral_connections');
	                    return;
	                }
	                // console.log(data)
	                if (data.rows.length > 0) {
	                    new_lat_conns = false;
	                    handleLinks(data.rows);
	                    if (new_lat_conns)
	                        lmCtrl.redraw();
	                }
	            });
	            lmCtrl.socket.on('lateral_nodes', function (data) {
	                if (data === 'done') {
	                    load_complete++;
	                    lmCtrl.socket.removeListener('lateral_nodes');
	                    return;
	                }
	                // console.log(data)
	                if (data.rows.length > 0) {
	                    new_lat_nodes = false;
	                    handleNodes(data.rows);
	                    if (new_lat_nodes)
	                        lmCtrl.redraw();
	                }
	            });
	            // functions created for the sidebar collapse section
	            lmCtrl.newNode = function (newNode) {
	                return new Node(newNode);
	            };
	            lmCtrl.newLink = function (source, target) {
	                return new Link(source, target);
	            };
	            // Creates an object with all the L7, proto, service between Resp and orig IPs for quick easy access in the sidebar (do not need to make query like before)
	            // Also it the key is all with the resp IP making it easy to tell who is resp & who is orig between the two, and for sending it to the search page
	            // TODO: replace all the if exist with just a add to object (if possible)
	            function handle_l7(conn) {
	                if (lmCtrl.l7_between_nodes[conn.resp_ip]) {
	                    if (lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip]) {
	                        if (lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app + conn.proto + conn.service]) {
	                            lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app + conn.proto + conn.service].bytes += conn.bytes_orig + conn.bytes_resp;
	                        }
	                        else {
	                            lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app + conn.proto + conn.service] = {
	                                l7: conn.l7_app,
	                                proto: conn.proto,
	                                service: conn.service,
	                                bytes: conn.bytes_orig + conn.bytes_resp,
	                            };
	                        }
	                    }
	                    else {
	                        lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip] = {};
	                        lmCtrl.l7_between_nodes[conn.resp_ip].resp[conn.orig_ip][conn.l7_app + conn.proto + conn.service] = {
	                            l7: conn.l7_app,
	                            proto: conn.proto,
	                            service: conn.service,
	                            bytes: conn.bytes_orig + conn.bytes_resp,
	                        };
	                    }
	                }
	                else {
	                    lmCtrl.l7_between_nodes[conn.resp_ip] = {};
	                    lmCtrl.l7_between_nodes[conn.resp_ip].resp = (_a = {},
	                        _a[conn.orig_ip] = (_b = {},
	                            _b[conn.l7_app + conn.proto + conn.service] = {
	                                l7: conn.l7_app,
	                                proto: conn.proto,
	                                service: conn.service,
	                                bytes: conn.bytes_orig + conn.bytes_resp,
	                            },
	                            _b
	                        ),
	                        _a
	                    );
	                }
	                var _a, _b;
	            }
	            // gets the node from network assets, since objects are pass by reference, if node already exists in nodes_object, it is then overriden with the proper values
	            // also appends every node to allNodes
	            function handleNodes(conn) {
	                var c, len;
	                for (c = 0, len = conn.length; c < len; c++) {
	                    if ((lmCtrl.nodes_object[conn[c].ip]) && (!lmCtrl.nodes_object[conn[c].ip].id)) {
	                        lmCtrl.nodes_object[conn[c].ip].editNode(conn[c]);
	                        lmCtrl.allNodes[conn[c].ip] = lmCtrl.nodes_object[conn[c].ip];
	                        new_lat_nodes = true;
	                    }
	                    else {
	                        conn[c].radius = lmCtrl.maxRadius;
	                        conn[c].grey = false;
	                        conn[c].selected = false;
	                        conn[c].visible = true;
	                        conn[c].x = lmCtrl.width / 2;
	                        conn[c].y = lmCtrl.height / 2;
	                        conn[c].px = lmCtrl.width / 2;
	                        conn[c].py = lmCtrl.height / 2;
	                        conn[c].orig_l7 = [];
	                        conn[c].resp_l7 = [];
	                        lmCtrl.allNodes[conn[c].ip] = conn[c];
	                    }
	                }
	            }
	            /*
	                - This can probably be the most confusing function to follow (good luck)
	                - This function has ALOT of checking to do
	                    - So first of, There is 2 calls from the back end simultaneously, one is getting all the nodes possible in the network, while the other is getting the latest lateral connections.
	                        - Therefore, a connection can return and the node (connected by IPs) is not yet created, so we have to create a temporary object (or potentially can be a new node in the network).
	                            - so we append to the links object the source and target IP of the node (since we are using the IPs for a key in the nodes_object) (only append link if unique)
	                        - If a node already exist in allNodes it copies node and is appended to nodes_object. and we still append to the links object the source and target IP of the node. (only append link if unique)
	                        - If node does NOT exist in allNodes, a temp node is used until it is overriten. if never overritten, it means that the current IP is not yet recorded in the network assets table and is a new node to
	                        the network and will be represented with a '?' icon.
	                        - If the node already exists in nodes_object, it checks to see if there is an IOC and appends the l7 applications to the object;
	                    - every connection calls handle_l7
	                    - Also while doing all of this it has to check for orig_ip and resp_ip and just look at it as Ip basically doing all the above explained twice.
	            */
	            function handleLinks(conn) {
	                var i, len = conn.length;
	                for (i = 0; i < len; i++) {
	                    handle_l7(conn[i]);
	                    // check if node exists (IP) with the resp_ip, if not created it
	                    if (!lmCtrl.nodes_object[conn[i].resp_ip]) {
	                        new_lat_conns = true;
	                        if (lmCtrl.allNodes[conn[i].resp_ip]) {
	                            lmCtrl.allNodes[conn[i].resp_ip].ioc = (Math.max(lmCtrl.allNodes[conn[i].resp_ip].ioc, conn[i].ioc_severity) || 0);
	                            lmCtrl.allNodes[conn[i].resp_ip].resp_l7 = _.uniq(_.concat(lmCtrl.allNodes[conn[i].resp_ip].resp_l7, conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service));
	                            lmCtrl.nodes_object[conn[i].resp_ip] = new Node(lmCtrl.allNodes[conn[i].resp_ip]);
	                        }
	                        else {
	                            var newNode = new Node({});
	                            newNode.ip = conn[i].resp_ip;
	                            newNode.resp_l7 = _.uniq(_.concat(newNode.resp_l7, conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service));
	                            newNode.ioc = Math.max(newNode.ioc, conn[i].ioc_severity);
	                            newNode.first_seen = lmCtrl.main.getTime().end;
	                            newNode.last_seen = lmCtrl.main.getTime().end;
	                            lmCtrl.nodes_object[conn[i].resp_ip] = new Node(newNode);
	                        }
	                        lmCtrl.nodes_object[conn[i].resp_ip].connections = [conn[i].orig_ip];
	                    }
	                    else {
	                        lmCtrl.nodes_object[conn[i].resp_ip].ioc = (Math.max(lmCtrl.nodes_object[conn[i].resp_ip].ioc, conn[i].ioc_severity) || 0);
	                        lmCtrl.nodes_object[conn[i].resp_ip].resp_l7 = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].resp_ip].resp_l7, conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service));
	                        lmCtrl.nodes_object[conn[i].resp_ip].connections = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].resp_ip].connections, conn[i].orig_ip));
	                    }
	                    // check if node exists (IP) with the orig_ip, if not created it
	                    if (!lmCtrl.nodes_object[conn[i].orig_ip]) {
	                        new_lat_conns = true;
	                        if (lmCtrl.allNodes[conn[i].orig_ip]) {
	                            lmCtrl.allNodes[conn[i].orig_ip].ioc = (Math.max(lmCtrl.allNodes[conn[i].orig_ip].ioc, conn[i].ioc_severity) || 0);
	                            lmCtrl.allNodes[conn[i].orig_ip].orig_l7 = _.uniq(_.concat(lmCtrl.allNodes[conn[i].orig_ip].orig_l7, conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service));
	                            lmCtrl.nodes_object[conn[i].orig_ip] = new Node(lmCtrl.allNodes[conn[i].orig_ip]);
	                        }
	                        else {
	                            var newNode = new Node({});
	                            newNode.ip = conn[i].orig_ip;
	                            newNode.orig_l7 = _.uniq(_.concat(newNode.orig_l7, conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service));
	                            newNode.ioc = Math.max(newNode.ioc, conn[i].ioc_severity);
	                            newNode.first_seen = lmCtrl.main.getTime().end;
	                            newNode.last_seen = lmCtrl.main.getTime().end;
	                            lmCtrl.nodes_object[conn[i].orig_ip] = new Node(newNode);
	                        }
	                        lmCtrl.nodes_object[conn[i].orig_ip].connections = [conn[i].resp_ip];
	                    }
	                    else {
	                        lmCtrl.nodes_object[conn[i].orig_ip].ioc = (Math.max(lmCtrl.nodes_object[conn[i].orig_ip].ioc, conn[i].ioc_severity) || 0);
	                        lmCtrl.nodes_object[conn[i].orig_ip].orig_l7 = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].orig_ip].orig_l7, conn[i].l7_app + "%" + conn[i].proto + "%" + conn[i].service));
	                        lmCtrl.nodes_object[conn[i].orig_ip].connections = _.uniq(_.concat(lmCtrl.nodes_object[conn[i].orig_ip].connections, conn[i].resp_ip));
	                    }
	                    // check if link already exist, if not created it
	                    if ((!lmCtrl.allLinks[conn[i].resp_ip + "-" + conn[i].orig_ip]) && (!lmCtrl.allLinks[conn[i].orig_ip + "-" + conn[i].resp_ip])) {
	                        new_lat_conns = true;
	                        lmCtrl.allLinks[conn[i].resp_ip + "-" + conn[i].orig_ip] = true;
	                        lmCtrl.links.push(new Link(lmCtrl.nodes_object[conn[i].resp_ip], lmCtrl.nodes_object[conn[i].orig_ip]));
	                    }
	                }
	            }
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	            ///////////////////
	            /// LATERAL MAP ///
	            /////////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
	            // initializes the custom force chart, whenever a new node is added it has to "restart" to convert the nodes
	            // TODO: make it once it is created you can just add to the list
	            lmCtrl.resetInternalMap = function () {
	                lmCtrl.nodes = _.values(lmCtrl.nodes_object);
	                visible_nodes = lmCtrl.nodes.filter(function (d, i) { return d.visible; });
	                visible_links = lmCtrl.links.filter(function (d) {
	                    if (_.isString(d.source) || _.isString(d.target))
	                        return true;
	                    return (d.target.visible && d.source.visible);
	                });
	                customForce.set_nodes(visible_nodes);
	                customForce.set_links(visible_links);
	                customForce.start();
	            };
	            // TODO: look at the way these are both used, can probably combine them
	            lmCtrl.redraw = function () {
	                lmCtrl.resetInternalMap();
	            };
	            lmCtrl.redrawing = function () {
	                lmCtrl.drawSidebar();
	                customForce.resume();
	            };
	            // // once map is done moving and zooming, it is saved to the local settings
	            function zoom_chart_end() {
	                // if wanting to set more than 1 local setting, it seems like you cannot just fire them all at once, you have to wait until the return before the next one is sent
	                lmCtrl.settings.set('translateX', translate[0]).then(function () {
	                    return lmCtrl.settings.set('translateY', translate[1]);
	                }).then(function () {
	                    lmCtrl.settings.set('scale', scale);
	                });
	            }
	            // called from the sidebar, this function re aligns the map to the center
	            lmCtrl.realign_map = function () {
	                customForce.reset_zoom();
	                lmCtrl.waitForFinalEvent(function () {
	                    zoom_chart_end();
	                }, 250, "lateral_map_zoom");
	            };
	            // returns the trasition for the SVGs on the nodes
	            function svg_translate(type, bigger) {
	                var offset;
	                switch (type) {
	                    case 'connecting':
	                    case 'ioc':
	                        offset = 18;
	                        break;
	                    case 'type':
	                    case 'group':
	                        offset = 17;
	                        break;
	                    case 'cluster':
	                        offset = 16;
	                        break;
	                    case 'selected':
	                        offset = 15;
	                        break;
	                    case 'Gateway':
	                    case 'new':
	                        offset = 8.5;
	                        break;
	                    case 'Printer':
	                    case 'Switch':
	                    case 'Phone':
	                    case 'Web Server':
	                        offset = 8;
	                        break;
	                    case 'Access Point':
	                        offset = 7.9;
	                        break;
	                    case 'Mobile':
	                        offset = 7;
	                        break;
	                    case 'Server':
	                    case 'DNS Server':
	                    case 'DCHP Server':
	                    case 'Laptop':
	                    case 'Desktop':
	                    case 'Endpoint':
	                        offset = 6;
	                        break;
	                    case 'File Server':
	                    case 'Domain Controller':
	                        offset = 6.5;
	                        break;
	                    case 'Database':
	                        offset = 5.35;
	                        break;
	                    default:
	                        offset = 7;
	                        break;
	                }
	                if (type === "Database") {
	                    return [(-offset - ((offset / 2) * bigger)), (-(offset * 1.25) - (((offset * 1.25) / 2) * bigger))];
	                }
	                return [(-offset - ((offset / 2) * bigger)), (-offset - ((offset / 2) * bigger))];
	            }
	            // returns the trasition for the SVGs on the nodes
	            function svg_scale(type, bigger) {
	                var scale;
	                switch (type) {
	                    case 'connecting':
	                    case 'ioc':
	                        scale = 1.5;
	                        break;
	                    case 'type':
	                        scale = 1.45;
	                        break;
	                    case 'group':
	                        scale = 1.4;
	                        break;
	                    case 'cluster':
	                        scale = 1.3;
	                        break;
	                    case 'selected':
	                        scale = 1.25;
	                        break;
	                    case 'new':
	                        scale = 0.7;
	                        break;
	                    case 'Gateway':
	                        scale = 0.66;
	                        break;
	                    case 'Printer':
	                        scale = 0.625;
	                        break;
	                    case 'Switch':
	                        scale = 0.615;
	                        break;
	                    case 'Phone':
	                    case 'Web Server':
	                    case 'Access Point':
	                        scale = 0.6;
	                        break;
	                    case 'Mobile':
	                    case 'File Server':
	                        scale = 0.55;
	                        break;
	                    case 'Server':
	                    case 'DNS Server':
	                    case 'DCHP Server':
	                    case 'Laptop':
	                    case 'Desktop':
	                    case 'Endpoint':
	                        scale = 0.475;
	                        break;
	                    case 'Domain Controller':
	                        scale = 0.145;
	                        break;
	                    case 'Database':
	                        scale = 0.014;
	                        break;
	                    default:
	                        scale = 0.6;
	                        break;
	                }
	                return (scale + ((scale / 2) * bigger));
	            }
	            $scope.unselect = function () {
	                unselectAllNodes();
	                lmCtrl.greyOut();
	                $scope.current.node = { type: "N/A", group: "N/A" };
	                lmCtrl.redrawing();
	                lmCtrl.main.clearFilters();
	            };
	            // When you click on a node this function is called
	            // It handles the selected nodes, and shift is pressed, and calls lmCtrl.greyOut
	            lmCtrl.nodeClicked = function (node) {
	                var isNodeSelected = node.selected; // need to add this because when we call unselectAllNodes() it does a pass by reference and is always false;
	                lmCtrl.greyOut();
	                if ($scope.selected_nodes.length === 1) {
	                    $scope.$apply(function () {
	                        $scope.current.node = angular.copy($scope.selected_nodes[0]);
	                        if (typeof $scope.current.node.type == 'object') {
	                            $scope.current.node.type = "false";
	                        }
	                        if (typeof $scope.current.node.group == 'object') {
	                            $scope.current.node.group = "false";
	                        }
	                    });
	                }
	                else if ($scope.selected_nodes.length > 1) {
	                    $scope.$apply(function () {
	                        $scope.current.node.type = "false";
	                        $scope.current.node.group = "false";
	                    });
	                }
	                else {
	                    clearCurrentNode();
	                }
	                lmCtrl.redrawing();
	                lmCtrl.main.clearFilters();
	            };
	            // returns an array of all the selected and visible nodes
	            lmCtrl.getSelectedNodes = function () {
	                return lmCtrl.nodes.filter(function (d) { return (d.selected && d.visible); });
	            };
	            // grey's out all the NONE connecting nodes
	            lmCtrl.greyOut = function () {
	                $scope.selected_nodes = lmCtrl.getSelectedNodes();
	                var n = $scope.selected_nodes.length;
	                var selected_ips = [];
	                while (n--) {
	                    if ($scope.selected_nodes[n].collapse) {
	                        selected_ips = _.uniq(_.concat(selected_ips, $scope.selected_nodes[n].ip));
	                    }
	                    if (selected_ips.indexOf($scope.selected_nodes[n].ip) === -1) {
	                        selected_ips.push($scope.selected_nodes[n].ip);
	                    }
	                }
	                // could do this by nodes_object (either way works)
	                if (selected_ips.length > 0) {
	                    lmCtrl.nodes.map(function (d) {
	                        if (d.collapse) {
	                            d.grey = true;
	                            var i = void 0, len = d.ip.length;
	                            for (i = 0; i < len; i++) {
	                                if (_.intersection(lmCtrl.nodes_object[d.ip[i]].connections, selected_ips).length > 0) {
	                                    d.grey = false;
	                                }
	                            }
	                        }
	                        else {
	                            d.grey = (!((_.intersection(lmCtrl.nodes_object[d.ip].connections, selected_ips).length > 0) || (selected_ips.includes(d.ip))));
	                        }
	                    });
	                }
	                else {
	                    lmCtrl.nodes.map(function (d) { return d.grey = false; });
	                }
	            };
	            lmCtrl.expand_collapsed = function (node) {
	                var i, len = node.ip.length;
	                for (i = 0; i < len; i++) {
	                    lmCtrl.nodes_object[node.ip[i]].selected = false;
	                    lmCtrl.nodes_object[node.ip[i]].visible = true;
	                    lmCtrl.nodes_object[node.ip[i]].grey = false;
	                    lmCtrl.nodes_object[node.ip[i]].fixed = false;
	                    lmCtrl.already_collapsed_ips = _.remove(lmCtrl.already_collapsed_ips, node.ip[i]);
	                }
	                for (var l in lmCtrl.links) {
	                    if ((lmCtrl.links[l].source.id == node.id) || (lmCtrl.links[l].target.id == node.id)) {
	                        delete lmCtrl.links[l];
	                    }
	                }
	                delete lmCtrl.nodes_object[node.id];
	                lmCtrl.redraw();
	            };
	            // clears the current node type and group in the side bar
	            function clearCurrentNode() {
	                $scope.$apply(function () {
	                    $scope.current.node = {
	                        type: "N/A",
	                        group: "N/A"
	                    };
	                });
	            }
	            // Unselected all the nodes
	            function unselectAllNodes() {
	                var n;
	                for (n in lmCtrl.nodes_object) {
	                    lmCtrl.nodes_object[n].selected = false;
	                }
	            }
	            // this is used to see of the shift key is pressed for multiple selections
	            d3_1.selection().on('keydown', function () { lmCtrl.ctrlKey = d3_1.event.ctrlKey; }).on('keyup', function () { lmCtrl.ctrlKey = false; }); // Keys recorded in D3, But not in other elements
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	            //////////////
	            /// SEARCH ///
	            ////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
	            function filterNodes(filters, node) {
	                var includes = 0;
	                var excludes = true;
	                var n, m, i, e, incLen = filters.include.length, excLen = filters.exclude.length;
	                for (i = 0; i < incLen; i++) {
	                    for (n in node) {
	                        if ((n !== "id") && (n !== "first_seen") && (n !== "last_seen") && (n !== "radius") && (n !== "grey") && (n !== "selected") && (n !== "x") && (n !== "y") && (n !== "connections") && (n !== "weight") && (n !== "px") && (n !== "py") && (n !== "fixed")) {
	                            if ((n === "group") && ($scope.groups[node[n]])) {
	                                if (_.includes($scope.groups[node[n]].name.toLowerCase(), filters.include[i].value.toLowerCase())) {
	                                    includes++;
	                                    break;
	                                }
	                            }
	                            else {
	                                if (_.includes(String(node[n]).toLowerCase(), filters.include[i].value.toLowerCase())) {
	                                    includes++;
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                }
	                for (e = 0; e < excLen; e++) {
	                    for (m in node) {
	                        if ((m !== "id") && (m !== "first_seen") && (m !== "last_seen") && (m !== "radius") && (m !== "grey") && (m !== "selected") && (m !== "x") && (m !== "y") && (m !== "connections") && (m !== "weight") && (m !== "px") && (m !== "py") && (m !== "fixed")) {
	                            if ((m === "group") && ($scope.groups[node[m]])) {
	                                if (_.includes($scope.groups[node[m]].name.toLowerCase(), filters.exclude[e].value.toLowerCase())) {
	                                    excludes = false;
	                                    break;
	                                }
	                            }
	                            else {
	                                if (_.includes(String(node[m]).toLowerCase(), filters.exclude[e].value.toLowerCase())) {
	                                    excludes = false;
	                                    break;
	                                }
	                            }
	                        }
	                    }
	                }
	                if ($scope.hide_on_search) {
	                    if ((_.includes(lmCtrl.already_collapsed_ips, node.ip)) && (lmCtrl.already_collapsed_ips.length > 0)) {
	                        node.visible = false;
	                    }
	                    else {
	                        node.visible = ((includes >= incLen) && excludes);
	                    }
	                }
	                else {
	                    if ((incLen === 0) && (excLen === 0)) {
	                        node.selected = false;
	                    }
	                    else if ((_.includes(lmCtrl.already_collapsed_ips, node.ip)) && (lmCtrl.already_collapsed_ips.length > 0)) {
	                        node.selected = false;
	                    }
	                    else {
	                        node.selected = ((includes >= incLen) && excludes);
	                    }
	                }
	                return true;
	            }
	            $scope.$on('runLatSearch', function (event, filterList) {
	                // if ((filterList.include.length > 0) || (filterList.include.length > 0)) {
	                lmCtrl.nodes.filter(filterNodes.bind(null, filterList));
	                lmCtrl.greyOut();
	                lmCtrl.redraw();
	                lmCtrl.drawSidebar();
	                // }
	            });
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	            ///////////////////
	            /// RESIZE PAGE ///
	            /////////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
	            function resize_forcechart() {
	                lmCtrl.max_width = element[0].clientWidth, lmCtrl.height = angular.element($window)[0].innerHeight - 150;
	                lmCtrl.width = lmCtrl.max_width * 0.76;
	                if (d3_1.select("#sidebar").classed("hide_section")) {
	                    lmCtrl.width = lmCtrl.max_width - 80;
	                }
	                customForce.clear();
	                customForce.canvas.height = lmCtrl.height;
	                customForce.canvas.width = lmCtrl.width;
	                customForce.resize_zoom();
	                customForce.set_size([lmCtrl.width, lmCtrl.height]);
	                customForce.resume();
	            }
	            // called from the sidebar directive, when they toggle the hide show sidebar
	            lmCtrl.resize_map = function () {
	                resize_forcechart();
	            };
	            angular.element($window).bind('resize', function () {
	                // Event that happens whenever the window is resized
	                lmCtrl.waitForFinalEvent(function () {
	                    resize_forcechart();
	                }, 250, "forcechart_resize");
	            });
	            d3_1.select(".sidebar-toggler").on("click", function () {
	                lmCtrl.waitForFinalEvent(function () {
	                    resize_forcechart();
	                    lmCtrl.resize_sb();
	                }, 100, "forcechart_resize");
	            });
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	            // clear timers on scope destroy
	            $scope.$on('$destroy', function () {
	                element = null;
	                angular.element($window).unbind('resize');
	                customForce.canvas.removeEventListener('selectstart', function (e) { e.preventDefault(); return false; }, false);
	                customForce.canvas.removeEventListener('mousedown', function (e) { customForce.mousedown(e); }, false);
	                customForce.canvas.removeEventListener('mousemove', function (e) { customForce.mousemove(e); }, false);
	                customForce.canvas.removeEventListener('mousewheel', function (e) { customForce.mousewheel(e); }, false);
	                customForce.canvas.removeEventListener('mouseup', function (e) { customForce.mouseup(e); }, false);
	                customForce.canvas.removeEventListener('dblclick', function (e) { customForce.dblclick(e); }, false);
	                if (customForce.timer) {
	                    customForce.timer.stop();
	                    customForce.timer = null;
	                }
	                customForce = null;
	            });
	        }
	    };
	}
	directive.$inject = ['$window', 'timeFormat', '$state', '$stateParams'];
	module.exports = directive;


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org Version 4.2.6. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var version = "4.2.6";
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	}
	
	var variance = function(array, f) {
	  var n = array.length,
	      m = 0,
	      a,
	      d,
	      s = 0,
	      i = -1,
	      j = 0;
	
	  if (f == null) {
	    while (++i < n) {
	      if (!isNaN(a = number(array[i]))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(a = number(f(array[i], i, array)))) {
	        d = a - m;
	        m += d / ++j;
	        s += d * (a - m);
	      }
	    }
	  }
	
	  if (j > 1) return s / (j - 1);
	}
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	var extent = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b,
	      c;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = array[i]) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null) {
	      if (a > b) a = b;
	      if (c < b) c = b;
	    }
	  }
	
	  return [a, c];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant$1 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	var identity = function(x) {
	  return x;
	}
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var step = tickStep(start, stop, count);
	  return range(
	    Math.ceil(start / step) * step,
	    Math.floor(stop / step) * step + step / 2, // inclusive
	    step
	  );
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] >= x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant$1([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant$1(slice.call(_)) : constant$1(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	var threshold = function(array, p, f) {
	  if (f == null) f = number;
	  if (!(n = array.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	  if (p >= 1) return +f(array[n - 1], n - 1, array);
	  var n,
	      h = (n - 1) * p,
	      i = Math.floor(h),
	      a = +f(array[i], i, array),
	      b = +f(array[i + 1], i + 1, array);
	  return a + (b - a) * (h - i);
	}
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (threshold(values, 0.75) - threshold(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	var max = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	  }
	
	  return a;
	}
	
	var mean = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1,
	      j = n;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	  }
	
	  if (j) return s / j;
	}
	
	var median = function(array, f) {
	  var numbers = [],
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	  }
	
	  else {
	    while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	  }
	
	  return threshold(numbers.sort(ascending), 0.5);
	}
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	var min = function(array, f) {
	  var i = -1,
	      n = array.length,
	      a,
	      b;
	
	  if (f == null) {
	    while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	  }
	
	  else {
	    while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	    while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	  }
	
	  return a;
	}
	
	var pairs = function(array) {
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = [p, p = array[++i]];
	  return pairs;
	}
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	var scan = function(array, compare) {
	  if (!(n = array.length)) return;
	  var i = 0,
	      n,
	      j = 0,
	      xi,
	      xj = array[j];
	
	  if (!compare) compare = ascending;
	
	  while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	var sum = function(array, f) {
	  var s = 0,
	      n = array.length,
	      a,
	      i = -1;
	
	  if (f == null) {
	    while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	  }
	
	  else {
	    while (++i < n) if (a = +f(array[i], i, array)) s += a;
	  }
	
	  return s;
	}
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	}
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map$1.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map$1(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) return rollup != null
	        ? rollup(array) : (sortValues != null
	        ? array.sort(sortValues)
	        : array);
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map$1(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map, depth) {
	    if (++depth > keys.length) return map;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map.entries();
	    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map$1();
	}
	
	function setMap(map, key, value) {
	  map.set(key, value);
	}
	
	function Set() {}
	
	var proto = map$1.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	var uniform = function(min, max) {
	  min = min == null ? 0 : +min;
	  max = max == null ? 1 : +max;
	  if (arguments.length === 1) max = min, min = 0;
	  else max -= min;
	  return function() {
	    return Math.random() * max + min;
	  };
	}
	
	var normal = function(mu, sigma) {
	  var x, r;
	  mu = mu == null ? 0 : +mu;
	  sigma = sigma == null ? 1 : +sigma;
	  return function() {
	    var y;
	
	    // If available, use the second previously-generated uniform random.
	    if (x != null) y = x, x = null;
	
	    // Otherwise, generate a new x and y.
	    else do {
	      x = Math.random() * 2 - 1;
	      y = Math.random() * 2 - 1;
	      r = x * x + y * y;
	    } while (!r || r > 1);
	
	    return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
	  };
	}
	
	var logNormal = function() {
	  var randomNormal = normal.apply(this, arguments);
	  return function() {
	    return Math.exp(randomNormal());
	  };
	}
	
	var irwinHall = function(n) {
	  return function() {
	    for (var sum = 0, i = 0; i < n; ++i) sum += Math.random();
	    return sum;
	  };
	}
	
	var bates = function(n) {
	  var randomIrwinHall = irwinHall(n);
	  return function() {
	    return randomIrwinHall() / n;
	  };
	}
	
	var exponential = function(lambda) {
	  return function() {
	    return -Math.log(1 - Math.random()) / lambda;
	  };
	}
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI;
	var halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11;
	var b2 = 6 / 11;
	var b3 = 8 / 11;
	var b4 = 3 / 4;
	var b5 = 9 / 11;
	var b6 = 10 / 11;
	var b7 = 15 / 16;
	var b8 = 21 / 22;
	var b9 = 63 / 64;
	var b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI;
	var amplitude = 1;
	var period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	var area = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      a,
	      b = polygon[n - 1],
	      area = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    area += a[1] * b[0] - a[0] * b[1];
	  }
	
	  return area / 2;
	}
	
	var centroid = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      x = 0,
	      y = 0,
	      a,
	      b = polygon[n - 1],
	      c,
	      k = 0;
	
	  while (++i < n) {
	    a = b;
	    b = polygon[i];
	    k += c = a[0] * b[1] - b[0] * a[1];
	    x += (a[0] + b[0]) * c;
	    y += (a[1] + b[1]) * c;
	  }
	
	  return k *= 3, [x / k, y / k];
	}
	
	// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
	// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
	// right, +y is up). Returns a positive value if ABC is counter-clockwise,
	// negative if clockwise, and zero if the points are collinear.
	var cross = function(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	}
	
	function lexicographicOrder(a, b) {
	  return a[0] - b[0] || a[1] - b[1];
	}
	
	// Computes the upper convex hull per the monotone chain algorithm.
	// Assumes points.length >= 3, is sorted by x, unique in y.
	// Returns an array of indices into points in left-to-right order.
	function computeUpperHullIndexes(points) {
	  var n = points.length,
	      indexes = [0, 1],
	      size = 2;
	
	  for (var i = 2; i < n; ++i) {
	    while (size > 1 && cross(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0) --size;
	    indexes[size++] = i;
	  }
	
	  return indexes.slice(0, size); // remove popped points
	}
	
	var hull = function(points) {
	  if ((n = points.length) < 3) return null;
	
	  var i,
	      n,
	      sortedPoints = new Array(n),
	      flippedPoints = new Array(n);
	
	  for (i = 0; i < n; ++i) sortedPoints[i] = [+points[i][0], +points[i][1], i];
	  sortedPoints.sort(lexicographicOrder);
	  for (i = 0; i < n; ++i) flippedPoints[i] = [sortedPoints[i][0], -sortedPoints[i][1]];
	
	  var upperIndexes = computeUpperHullIndexes(sortedPoints),
	      lowerIndexes = computeUpperHullIndexes(flippedPoints);
	
	  // Construct the hull polygon, removing possible duplicate endpoints.
	  var skipLeft = lowerIndexes[0] === upperIndexes[0],
	      skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1],
	      hull = [];
	
	  // Add upper hull in right-to-l order.
	  // Then add lower hull in left-to-right order.
	  for (i = upperIndexes.length - 1; i >= 0; --i) hull.push(points[sortedPoints[upperIndexes[i]][2]]);
	  for (i = +skipLeft; i < lowerIndexes.length - skipRight; ++i) hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
	
	  return hull;
	}
	
	var contains = function(polygon, point) {
	  var n = polygon.length,
	      p = polygon[n - 1],
	      x = point[0], y = point[1],
	      x0 = p[0], y0 = p[1],
	      x1, y1,
	      inside = false;
	
	  for (var i = 0; i < n; ++i) {
	    p = polygon[i], x1 = p[0], y1 = p[1];
	    if (((y1 > y) !== (y0 > y)) && (x < (x0 - x1) * (y - y1) / (y0 - y1) + x1)) inside = !inside;
	    x0 = x1, y0 = y1;
	  }
	
	  return inside;
	}
	
	var length$1 = function(polygon) {
	  var i = -1,
	      n = polygon.length,
	      b = polygon[n - 1],
	      xa,
	      ya,
	      xb = b[0],
	      yb = b[1],
	      perimeter = 0;
	
	  while (++i < n) {
	    xa = xb;
	    ya = yb;
	    b = polygon[i];
	    xb = b[0];
	    yb = b[1];
	    xa -= xb;
	    ya -= yb;
	    perimeter += Math.sqrt(xa * xa + ya * ya);
	  }
	
	  return perimeter;
	}
	
	var pi$1 = Math.PI;
	var tau$1 = 2 * pi$1;
	var epsilon = 1e-6;
	var tauEpsilon = tau$1 - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = [];
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._.push("M", this._x0 = this._x1 = +x, ",", this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._.push("Z");
	    }
	  },
	  lineTo: function(x, y) {
	    this._.push("L", this._x1 = +x, ",", this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._.push("Q", +x1, ",", +y1, ",", this._x1 = +x, ",", this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._.push("C", +x1, ",", +y1, ",", +x2, ",", +y2, ",", this._x1 = +x, ",", this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._.push(
	        "M", this._x1 = x1, ",", this._y1 = y1
	      );
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._.push(
	        "L", this._x1 = x1, ",", this._y1 = y1
	      );
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._.push(
	          "L", x1 + t01 * x01, ",", y1 + t01 * y01
	        );
	      }
	
	      this._.push(
	        "A", r, ",", r, ",0,0,", +(y01 * x20 > x01 * y20), ",", this._x1 = x1 + t21 * x21, ",", this._y1 = y1 + t21 * y21
	      );
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._.push(
	        "M", x0, ",", y0
	      );
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._.push(
	        "L", x0, ",", y0
	      );
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._.push(
	        "A", r, ",", r, ",0,1,", cw, ",", x - dx, ",", y - dy,
	        "A", r, ",", r, ",0,1,", cw, ",", this._x1 = x0, ",", this._y1 = y0
	      );
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      if (da < 0) da = da % tau$1 + tau$1;
	      this._.push(
	        "A", r, ",", r, ",0,", +(da >= pi$1), ",", cw, ",", this._x1 = x + r * Math.cos(a1), ",", this._y1 = y + r * Math.sin(a1)
	      );
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._.push("M", this._x0 = this._x1 = +x, ",", this._y0 = this._y1 = +y, "h", +w, "v", +h, "h", -w, "Z");
	  },
	  toString: function() {
	    return this._.join("");
	  }
	};
	
	var tree_add = function(d) {
	  var x = +this._x.call(null, d),
	      y = +this._y.call(null, d);
	  return add(this.cover(x, y), x, y, d);
	}
	
	function add(tree, x, y, d) {
	  if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
	
	  var parent,
	      node = tree._root,
	      leaf = {data: d},
	      x0 = tree._x0,
	      y0 = tree._y0,
	      x1 = tree._x1,
	      y1 = tree._y1,
	      xm,
	      ym,
	      xp,
	      yp,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return tree._root = leaf, tree;
	
	  // Find the existing leaf for the new point, or add it.
	  while (node.length) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
	  }
	
	  // Is the new point is exactly coincident with the existing point?
	  xp = +tree._x.call(null, node.data);
	  yp = +tree._y.call(null, node.data);
	  if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
	
	  // Otherwise, split the leaf node until the old and new point are separated.
	  do {
	    parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	  } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
	  return parent[j] = node, parent[i] = leaf, tree;
	}
	
	function addAll(data) {
	  var d, i, n = data.length,
	      x,
	      y,
	      xz = new Array(n),
	      yz = new Array(n),
	      x0 = Infinity,
	      y0 = Infinity,
	      x1 = -Infinity,
	      y1 = -Infinity;
	
	  // Compute the points and their extent.
	  for (i = 0; i < n; ++i) {
	    if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
	    xz[i] = x;
	    yz[i] = y;
	    if (x < x0) x0 = x;
	    if (x > x1) x1 = x;
	    if (y < y0) y0 = y;
	    if (y > y1) y1 = y;
	  }
	
	  // If there were no (valid) points, inherit the existing extent.
	  if (x1 < x0) x0 = this._x0, x1 = this._x1;
	  if (y1 < y0) y0 = this._y0, y1 = this._y1;
	
	  // Expand the tree to cover the new points.
	  this.cover(x0, y0).cover(x1, y1);
	
	  // Add the new points.
	  for (i = 0; i < n; ++i) {
	    add(this, xz[i], yz[i], data[i]);
	  }
	
	  return this;
	}
	
	var tree_cover = function(x, y) {
	  if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
	
	  var x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1;
	
	  // If the quadtree has no extent, initialize them.
	  // Integer extent are necessary so that if we later double the extent,
	  // the existing quadrant boundaries don’t change due to floating point error!
	  if (isNaN(x0)) {
	    x1 = (x0 = Math.floor(x)) + 1;
	    y1 = (y0 = Math.floor(y)) + 1;
	  }
	
	  // Otherwise, double repeatedly to cover.
	  else if (x0 > x || x > x1 || y0 > y || y > y1) {
	    var z = x1 - x0,
	        node = this._root,
	        parent,
	        i;
	
	    switch (i = (y < (y0 + y1) / 2) << 1 | (x < (x0 + x1) / 2)) {
	      case 0: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y1 = y0 + z, x > x1 || y > y1);
	        break;
	      }
	      case 1: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y1 = y0 + z, x0 > x || y > y1);
	        break;
	      }
	      case 2: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x1 = x0 + z, y0 = y1 - z, x > x1 || y0 > y);
	        break;
	      }
	      case 3: {
	        do parent = new Array(4), parent[i] = node, node = parent;
	        while (z *= 2, x0 = x1 - z, y0 = y1 - z, x0 > x || y0 > y);
	        break;
	      }
	    }
	
	    if (this._root && this._root.length) this._root = node;
	  }
	
	  // If the quadtree covers the point already, just return.
	  else return this;
	
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  return this;
	}
	
	var tree_data = function() {
	  var data = [];
	  this.visit(function(node) {
	    if (!node.length) do data.push(node.data); while (node = node.next)
	  });
	  return data;
	}
	
	var tree_extent = function(_) {
	  return arguments.length
	      ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
	      : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
	}
	
	var Quad = function(node, x0, y0, x1, y1) {
	  this.node = node;
	  this.x0 = x0;
	  this.y0 = y0;
	  this.x1 = x1;
	  this.y1 = y1;
	}
	
	var tree_find = function(x, y, radius) {
	  var data,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1,
	      y1,
	      x2,
	      y2,
	      x3 = this._x1,
	      y3 = this._y1,
	      quads = [],
	      node = this._root,
	      q,
	      i;
	
	  if (node) quads.push(new Quad(node, x0, y0, x3, y3));
	  if (radius == null) radius = Infinity;
	  else {
	    x0 = x - radius, y0 = y - radius;
	    x3 = x + radius, y3 = y + radius;
	    radius *= radius;
	  }
	
	  while (q = quads.pop()) {
	
	    // Stop searching if this quadrant can’t contain a closer node.
	    if (!(node = q.node)
	        || (x1 = q.x0) > x3
	        || (y1 = q.y0) > y3
	        || (x2 = q.x1) < x0
	        || (y2 = q.y1) < y0) continue;
	
	    // Bisect the current quadrant.
	    if (node.length) {
	      var xm = (x1 + x2) / 2,
	          ym = (y1 + y2) / 2;
	
	      quads.push(
	        new Quad(node[3], xm, ym, x2, y2),
	        new Quad(node[2], x1, ym, xm, y2),
	        new Quad(node[1], xm, y1, x2, ym),
	        new Quad(node[0], x1, y1, xm, ym)
	      );
	
	      // Visit the closest quadrant first.
	      if (i = (y >= ym) << 1 | (x >= xm)) {
	        q = quads[quads.length - 1];
	        quads[quads.length - 1] = quads[quads.length - 1 - i];
	        quads[quads.length - 1 - i] = q;
	      }
	    }
	
	    // Visit this point. (Visiting coincident points isn’t necessary!)
	    else {
	      var dx = x - +this._x.call(null, node.data),
	          dy = y - +this._y.call(null, node.data),
	          d2 = dx * dx + dy * dy;
	      if (d2 < radius) {
	        var d = Math.sqrt(radius = d2);
	        x0 = x - d, y0 = y - d;
	        x3 = x + d, y3 = y + d;
	        data = node.data;
	      }
	    }
	  }
	
	  return data;
	}
	
	var tree_remove = function(d) {
	  if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
	
	  var parent,
	      node = this._root,
	      retainer,
	      previous,
	      next,
	      x0 = this._x0,
	      y0 = this._y0,
	      x1 = this._x1,
	      y1 = this._y1,
	      x,
	      y,
	      xm,
	      ym,
	      right,
	      bottom,
	      i,
	      j;
	
	  // If the tree is empty, initialize the root as a leaf.
	  if (!node) return this;
	
	  // Find the leaf node for the point.
	  // While descending, also retain the deepest parent with a non-removed sibling.
	  if (node.length) while (true) {
	    if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
	    if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
	    if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
	    if (!node.length) break;
	    if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
	  }
	
	  // Find the point to remove.
	  while (node.data !== d) if (!(previous = node, node = node.next)) return this;
	  if (next = node.next) delete node.next;
	
	  // If there are multiple coincident points, remove just the point.
	  if (previous) return (next ? previous.next = next : delete previous.next), this;
	
	  // If this is the root point, remove it.
	  if (!parent) return this._root = next, this;
	
	  // Remove this leaf.
	  next ? parent[i] = next : delete parent[i];
	
	  // If the parent now contains exactly one leaf, collapse superfluous parents.
	  if ((node = parent[0] || parent[1] || parent[2] || parent[3])
	      && node === (parent[3] || parent[2] || parent[1] || parent[0])
	      && !node.length) {
	    if (retainer) retainer[j] = node;
	    else this._root = node;
	  }
	
	  return this;
	}
	
	function removeAll(data) {
	  for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
	  return this;
	}
	
	var tree_root = function() {
	  return this._root;
	}
	
	var tree_size = function() {
	  var size = 0;
	  this.visit(function(node) {
	    if (!node.length) do ++size; while (node = node.next)
	  });
	  return size;
	}
	
	var tree_visit = function(callback) {
	  var quads = [], q, node = this._root, child, x0, y0, x1, y1;
	  if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
	      var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	    }
	  }
	  return this;
	}
	
	var tree_visitAfter = function(callback) {
	  var quads = [], next = [], q;
	  if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
	  while (q = quads.pop()) {
	    var node = q.node;
	    if (node.length) {
	      var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
	      if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
	      if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
	      if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
	      if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
	    }
	    next.push(q);
	  }
	  while (q = next.pop()) {
	    callback(q.node, q.x0, q.y0, q.x1, q.y1);
	  }
	  return this;
	}
	
	function defaultX(d) {
	  return d[0];
	}
	
	var tree_x = function(_) {
	  return arguments.length ? (this._x = _, this) : this._x;
	}
	
	function defaultY(d) {
	  return d[1];
	}
	
	var tree_y = function(_) {
	  return arguments.length ? (this._y = _, this) : this._y;
	}
	
	function quadtree(nodes, x, y) {
	  var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
	  return nodes == null ? tree : tree.addAll(nodes);
	}
	
	function Quadtree(x, y, x0, y0, x1, y1) {
	  this._x = x;
	  this._y = y;
	  this._x0 = x0;
	  this._y0 = y0;
	  this._x1 = x1;
	  this._y1 = y1;
	  this._root = undefined;
	}
	
	function leaf_copy(leaf) {
	  var copy = {data: leaf.data}, next = copy;
	  while (leaf = leaf.next) next = next.next = {data: leaf.data};
	  return copy;
	}
	
	var treeProto = quadtree.prototype = Quadtree.prototype;
	
	treeProto.copy = function() {
	  var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
	      node = this._root,
	      nodes,
	      child;
	
	  if (!node) return copy;
	
	  if (!node.length) return copy._root = leaf_copy(node), copy;
	
	  nodes = [{source: node, target: copy._root = new Array(4)}];
	  while (node = nodes.pop()) {
	    for (var i = 0; i < 4; ++i) {
	      if (child = node.source[i]) {
	        if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
	        else node.target[i] = leaf_copy(child);
	      }
	    }
	  }
	
	  return copy;
	};
	
	treeProto.add = tree_add;
	treeProto.addAll = addAll;
	treeProto.cover = tree_cover;
	treeProto.data = tree_data;
	treeProto.extent = tree_extent;
	treeProto.find = tree_find;
	treeProto.remove = tree_remove;
	treeProto.removeAll = removeAll;
	treeProto.root = tree_root;
	treeProto.size = tree_size;
	treeProto.visit = tree_visit;
	treeProto.visitAfter = tree_visitAfter;
	treeProto.x = tree_x;
	treeProto.y = tree_y;
	
	var slice$1 = [].slice;
	
	var noabort = {};
	
	function Queue(size) {
	  if (!(size >= 1)) throw new Error;
	  this._size = size;
	  this._call =
	  this._error = null;
	  this._tasks = [];
	  this._data = [];
	  this._waiting =
	  this._active =
	  this._ended =
	  this._start = 0; // inside a synchronous task callback?
	}
	
	Queue.prototype = queue.prototype = {
	  constructor: Queue,
	  defer: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    if (this._error != null) return this;
	    var t = slice$1.call(arguments, 1);
	    t.push(callback);
	    ++this._waiting, this._tasks.push(t);
	    poke(this);
	    return this;
	  },
	  abort: function() {
	    if (this._error == null) abort(this, new Error("abort"));
	    return this;
	  },
	  await: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
	    maybeNotify(this);
	    return this;
	  },
	  awaitAll: function(callback) {
	    if (typeof callback !== "function" || this._call) throw new Error;
	    this._call = callback;
	    maybeNotify(this);
	    return this;
	  }
	};
	
	function poke(q) {
	  if (!q._start) {
	    try { start(q); } // let the current task complete
	    catch (e) {
	      if (q._tasks[q._ended + q._active - 1]) abort(q, e); // task errored synchronously
	      else if (!q._data) throw e; // await callback errored synchronously
	    }
	  }
	}
	
	function start(q) {
	  while (q._start = q._waiting && q._active < q._size) {
	    var i = q._ended + q._active,
	        t = q._tasks[i],
	        j = t.length - 1,
	        c = t[j];
	    t[j] = end(q, i);
	    --q._waiting, ++q._active;
	    t = c.apply(null, t);
	    if (!q._tasks[i]) continue; // task finished synchronously
	    q._tasks[i] = t || noabort;
	  }
	}
	
	function end(q, i) {
	  return function(e, r) {
	    if (!q._tasks[i]) return; // ignore multiple callbacks
	    --q._active, ++q._ended;
	    q._tasks[i] = null;
	    if (q._error != null) return; // ignore secondary errors
	    if (e != null) {
	      abort(q, e);
	    } else {
	      q._data[i] = r;
	      if (q._waiting) poke(q);
	      else maybeNotify(q);
	    }
	  };
	}
	
	function abort(q, e) {
	  var i = q._tasks.length, t;
	  q._error = e; // ignore active callbacks
	  q._data = undefined; // allow gc
	  q._waiting = NaN; // prevent starting
	
	  while (--i >= 0) {
	    if (t = q._tasks[i]) {
	      q._tasks[i] = null;
	      if (t.abort) {
	        try { t.abort(); }
	        catch (e) { /* ignore */ }
	      }
	    }
	  }
	
	  q._active = NaN; // allow notification
	  maybeNotify(q);
	}
	
	function maybeNotify(q) {
	  if (!q._active && q._call) {
	    var d = q._data;
	    q._data = undefined; // allow gc
	    q._call(q._error, d);
	  }
	}
	
	function queue(concurrency) {
	  return new Queue(arguments.length ? +concurrency : Infinity);
	}
	
	var constant$2 = function(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var epsilon$1 = 1e-12;
	var pi$2 = Math.PI;
	var halfPi$1 = pi$2 / 2;
	var tau$2 = 2 * pi$2;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi$1 : x <= -1 ? -halfPi$1 : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$2(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi$1,
	        a1 = endAngle.apply(this, arguments) - halfPi$1,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon$1)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau$2 - epsilon$1) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon$1) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon$1) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon$1) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon$1) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon$1) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon$1) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi$2) {
	          var oc = da0 > epsilon$1 ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon$1)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon$1) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon$1) || !(da0 > epsilon$1)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon$1) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$2 / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$2(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$2(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$2(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$2(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	var area$1 = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$2(0),
	      y1 = y,
	      defined = constant$2(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$2(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$2(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$2(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$2(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	var descending$1 = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	var identity$1 = function(d) {
	  return d;
	}
	
	var pie = function() {
	  var value = identity$1,
	      sortValues = descending$1,
	      sort = null,
	      startAngle = constant$2(0),
	      endAngle = constant$2(tau$2),
	      padAngle = constant$2(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau$2, Math.max(-tau$2, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$2(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	}
	
	var radialArea = function() {
	  var a = area$1().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi$2);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau$2);
	  }
	};
	
	var cross$1 = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi$2 / 10) / Math.sin(7 * pi$2 / 10);
	var kx = Math.sin(tau$2 / 10) * kr;
	var ky = -Math.cos(tau$2 / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau$2 * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross$1,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$2(circle),
	      size = constant$2(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$2(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$2(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	var noop = function() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon$1) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon$1) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	}
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice$2 = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$2([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$2(slice$2.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$2(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$2(slice$2.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	var ascending$1 = function(series) {
	  var sums = series.map(sum$1);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum$1(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$2 = function(series) {
	  return ascending$1(series).reverse();
	}
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum$1),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	}
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = /^rgb\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*\)$/;
	var reRgbPercent = /^rgb\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	var reRgbaInteger = /^rgba\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	var reRgbaPercent = /^rgba\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	var reHslPercent = /^hsl\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	var reHslaPercent = /^hsla\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	function basis$1(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$2 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis$1((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	var basisClosed$1 = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis$1((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	var constant$3 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear$1(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential$1(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$3(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential$1(a, b, y) : constant$3(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear$1(a, d) : constant$3(isNaN(a) ? b : a);
	}
	
	var interpolateRgb = (function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = rgb(start)).r, (end = rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = color$$1(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$2);
	var rgbBasisClosed = rgbSpline(basisClosed$1);
	
	var array$1 = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(nb),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	}
	
	var interpolateNumber = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	}
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = interpolate(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var interpolateString = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: interpolateNumber(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	var interpolate = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant$3(b)
	      : (t === "number" ? interpolateNumber
	      : t === "string" ? ((c = color(b)) ? (b = c, interpolateRgb) : interpolateString)
	      : b instanceof color ? interpolateRgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array$1
	      : isNaN(b) ? object
	      : interpolateNumber)(a, b);
	}
	
	var interpolateRound = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity$2 = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity$2;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity$2;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity$2;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: interpolateNumber(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: interpolateNumber(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: interpolateNumber(xa, xb)}, {i: i - 2, x: interpolateNumber(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var interpolateZoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    }
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    }
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hsl(start)).h, (end = hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = lab(start)).l, (end = lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = hcl(start)).h, (end = hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = cubehelix(start)).h, (end = cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	var noop$1 = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set$2(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set$2(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set$2(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop$1, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	var dsv = function(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n]"),
	      delimiterCode = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns;
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var EOL = {}, // sentinel value for end-of-line
	        EOF = {}, // sentinel value for end-of-file
	        rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // the current line number
	        t, // the current token
	        eol; // is the current token followed by EOL?
	
	    function token() {
	      if (I >= N) return EOF; // special case: end of file
	      if (eol) return eol = false, EOL; // special case: end of line
	
	      // special case: quotes
	      var j = I, c;
	      if (text.charCodeAt(j) === 34) {
	        var i = j;
	        while (i++ < N) {
	          if (text.charCodeAt(i) === 34) {
	            if (text.charCodeAt(i + 1) !== 34) break;
	            ++i;
	          }
	        }
	        I = i + 2;
	        c = text.charCodeAt(i + 1);
	        if (c === 13) {
	          eol = true;
	          if (text.charCodeAt(i + 2) === 10) ++I;
	        } else if (c === 10) {
	          eol = true;
	        }
	        return text.slice(j + 1, i).replace(/""/g, "\"");
	      }
	
	      // common case: find next delimiter or newline
	      while (I < N) {
	        var k = 1;
	        c = text.charCodeAt(I++);
	        if (c === 10) eol = true; // \n
	        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
	        else if (c !== delimiterCode) continue;
	        return text.slice(j, I - k);
	      }
	
	      // special case: last token before EOF
	      return text.slice(j);
	    }
	
	    while ((t = token()) !== EOF) {
	      var a = [];
	      while (t !== EOL && t !== EOF) {
	        a.push(t);
	        t = token();
	      }
	      if (f && (a = f(a, n++)) == null) continue;
	      rows.push(a);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	}
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	var request = function(url, callback) {
	  var request,
	      event = dispatch("beforesend", "progress", "load", "error"),
	      mimeType,
	      headers = map$1(),
	      xhr = new XMLHttpRequest,
	      user = null,
	      password = null,
	      response,
	      responseType,
	      timeout = 0;
	
	  // If IE does not support CORS, use XDomainRequest.
	  if (typeof XDomainRequest !== "undefined"
	      && !("withCredentials" in xhr)
	      && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
	
	  "onload" in xhr
	      ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
	      : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };
	
	  function respond(o) {
	    var status = xhr.status, result;
	    if (!status && hasResponse(xhr)
	        || status >= 200 && status < 300
	        || status === 304) {
	      if (response) {
	        try {
	          result = response.call(request, xhr);
	        } catch (e) {
	          event.call("error", request, e);
	          return;
	        }
	      } else {
	        result = xhr;
	      }
	      event.call("load", request, result);
	    } else {
	      event.call("error", request, o);
	    }
	  }
	
	  xhr.onprogress = function(e) {
	    event.call("progress", request, e);
	  };
	
	  request = {
	    header: function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers.get(name);
	      if (value == null) headers.remove(name);
	      else headers.set(name, value + "");
	      return request;
	    },
	
	    // If mimeType is non-null and no Accept header is set, a default is used.
	    mimeType: function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return request;
	    },
	
	    // Specifies what type the response value should take;
	    // for instance, arraybuffer, blob, document, or text.
	    responseType: function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return request;
	    },
	
	    timeout: function(value) {
	      if (!arguments.length) return timeout;
	      timeout = +value;
	      return request;
	    },
	
	    user: function(value) {
	      return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
	    },
	
	    password: function(value) {
	      return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
	    },
	
	    // Specify how to convert the response content to a specific type;
	    // changes the callback value on "load" events.
	    response: function(value) {
	      response = value;
	      return request;
	    },
	
	    // Alias for send("GET", …).
	    get: function(data, callback) {
	      return request.send("GET", data, callback);
	    },
	
	    // Alias for send("POST", …).
	    post: function(data, callback) {
	      return request.send("POST", data, callback);
	    },
	
	    // If callback is non-null, it will be used for error and load events.
	    send: function(method, data, callback) {
	      xhr.open(method, url, true, user, password);
	      if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
	      if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
	      if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
	      if (responseType != null) xhr.responseType = responseType;
	      if (timeout > 0) xhr.timeout = timeout;
	      if (callback == null && typeof data === "function") callback = data, data = null;
	      if (callback != null && callback.length === 1) callback = fixCallback(callback);
	      if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
	      event.call("beforesend", request, xhr);
	      xhr.send(data == null ? null : data);
	      return request;
	    },
	
	    abort: function() {
	      xhr.abort();
	      return request;
	    },
	
	    on: function() {
	      var value = event.on.apply(event, arguments);
	      return value === event ? request : value;
	    }
	  };
	
	  if (callback != null) {
	    if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    return request.get(callback);
	  }
	
	  return request;
	}
	
	function fixCallback(callback) {
	  return function(error, xhr) {
	    callback(error == null ? xhr : null);
	  };
	}
	
	function hasResponse(xhr) {
	  var type = xhr.responseType;
	  return type && type !== "text"
	      ? xhr.response // null on error
	      : xhr.responseText; // "" on error
	}
	
	var type = function(defaultMimeType, response) {
	  return function(url, callback) {
	    var r = request(url).mimeType(defaultMimeType).response(response);
	    if (callback != null) {
	      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      return r.get(callback);
	    }
	    return r;
	  };
	}
	
	var html = type("text/html", function(xhr) {
	  return document.createRange().createContextualFragment(xhr.responseText);
	});
	
	var json = type("application/json", function(xhr) {
	  return JSON.parse(xhr.responseText);
	});
	
	var text = type("text/plain", function(xhr) {
	  return xhr.responseText;
	});
	
	var xml = type("application/xml", function(xhr) {
	  var xml = xhr.responseXML;
	  if (!xml) throw new Error("parse error");
	  return xml;
	});
	
	var dsv$1 = function(defaultMimeType, parse) {
	  return function(url, row, callback) {
	    if (arguments.length < 3) callback = row, row = null;
	    var r = request(url).mimeType(defaultMimeType);
	    r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
	    r.row(row);
	    return callback ? r.get(callback) : r;
	  };
	}
	
	function responseOf(parse, row) {
	  return function(request$$1) {
	    return parse(request$$1.responseText, row);
	  };
	}
	
	var csv$1 = dsv$1("text/csv", csvParse);
	
	var tsv$1 = dsv$1("text/tab-separated-values", tsvParse);
	
	var frame = 0;
	var timeout = 0;
	var interval = 0;
	var pokeDelay = 1000;
	var taskHead;
	var taskTail;
	var clockLast = 0;
	var clockNow = 0;
	var clockSkew = 0;
	var clock = typeof performance === "object" && performance.now ? performance : Date;
	var setFrame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke$1() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow;
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, delay);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) interval = setInterval(poke$1, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	var timeout$1 = function(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	var interval$1 = function(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	var t0$1 = new Date;
	var t1$1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0$1.setTime(+start), t1$1.setTime(+end);
	      floori(t0$1), floori(t1$1);
	      return Math.floor(count(t0$1, t1$1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	var exponent$1 = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	}
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	}
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	var formatSpecifier = function(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var prefixes = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];
	
	function identity$3(x) {
	  return x;
	}
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity$3,
	      currency = locale.currency,
	      decimal = locale.decimal;
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Convert negative to positive, and compute the prefix.
	        // Note that -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	        // Perform the initial formatting.
	        value = formatType(value, precision);
	
	        // If the original value was negative, it may be rounded to zero during
	        // formatting; treat this as (positive) zero.
	        if (valueNegative) {
	          i = -1, n = value.length;
	          valueNegative = false;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), (48 < c && c < 58)
	                || (type === "x" && 96 < c && c < 103)
	                || (type === "X" && 64 < c && c < 71)) {
	              valueNegative = true;
	              break;
	            }
	          }
	        }
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": return valuePrefix + value + valueSuffix + padding;
	        case "=": return valuePrefix + padding + value + valueSuffix;
	        case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	      }
	      return padding + valuePrefix + value + valueSuffix;
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale$1;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale$1 = formatLocale(definition);
	  exports.format = locale$1.format;
	  exports.formatPrefix = locale$1.formatPrefix;
	  return locale$1;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent$1(Math.abs(step)));
	}
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
	}
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
	}
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale$1(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "S": formatSeconds,
	    "U": formatWeekNumberSunday,
	    "w": formatWeekdayNumber,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "S": formatUTCSeconds,
	    "U": formatUTCWeekNumberSunday,
	    "w": formatUTCWeekdayNumber,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "S": parseSeconds,
	    "U": parseWeekNumberSunday,
	    "w": parseWeekdayNumber,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0);
	      if (i != string.length) return null;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	        var day$$1 = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day$$1 + 5) % 7 : d.w + d.U * 7 - (day$$1 + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + day.count(year(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(sunday.count(year(d), d), p, 2);
	}
	
	function formatWeekdayNumber(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(monday.count(year(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + utcDay.count(utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(utcSunday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekdayNumber(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(utcMonday.count(utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	var locale$2;
	
	
	
	
	
	defaultLocale$1({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale$1(definition) {
	  locale$2 = formatLocale$1(definition);
	  exports.timeFormat = locale$2.format;
	  exports.timeParse = locale$2.parse;
	  exports.utcFormat = locale$2.utcFormat;
	  exports.utcParse = locale$2.utcParse;
	  return locale$2;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	var array$2 = Array.prototype;
	
	var map$3 = array$2.map;
	var slice$3 = array$2.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range) {
	  var index = map$1(),
	      domain = [],
	      unknown = implicit;
	
	  range = range == null ? [] : slice$3.call(range);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = map$1();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice$3.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point$4() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant$4 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	var number$1 = function(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant$4(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = bisectRight(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$1), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice$3.call(_), interpolate$$1 = interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
	      return exports.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return exports.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = tickStep(start, stop, n);
	
	    if (step) {
	      step = tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear$2() {
	  var scale = continuous(deinterpolateLinear, interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear$2());
	  };
	
	  return linearish(scale);
	}
	
	function identity$4() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$3.call(_, number$1), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity$4().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant$4(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = exports.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant$4(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = threshold(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[bisectRight(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize$1() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice$3.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize$1()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold$1() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[bisectRight(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice$3.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice$3.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond$1 = 1000;
	var durationMinute$1 = durationSecond$1 * 60;
	var durationHour$1 = durationMinute$1 * 60;
	var durationDay$1 = durationHour$1 * 24;
	var durationWeek$1 = durationDay$1 * 7;
	var durationMonth = durationDay$1 * 30;
	var durationYear = durationDay$1 * 365;
	
	function date$1(t) {
	  return new Date(t);
	}
	
	function number$2(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format) {
	  var scale = continuous(deinterpolateLinear, interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second$$1,  1,      durationSecond$1],
	    [second$$1,  5,  5 * durationSecond$1],
	    [second$$1, 15, 15 * durationSecond$1],
	    [second$$1, 30, 30 * durationSecond$1],
	    [minute$$1,  1,      durationMinute$1],
	    [minute$$1,  5,  5 * durationMinute$1],
	    [minute$$1, 15, 15 * durationMinute$1],
	    [minute$$1, 30, 30 * durationMinute$1],
	    [  hour$$1,  1,      durationHour$1  ],
	    [  hour$$1,  3,  3 * durationHour$1  ],
	    [  hour$$1,  6,  6 * durationHour$1  ],
	    [  hour$$1, 12, 12 * durationHour$1  ],
	    [   day$$1,  1,      durationDay$1   ],
	    [   day$$1,  2,  2 * durationDay$1   ],
	    [  week,  1,      durationWeek$1  ],
	    [ month$$1,  1,      durationMonth ],
	    [ month$$1,  3,  3 * durationMonth ],
	    [  year$$1,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second$$1(date) < date ? formatMillisecond
	        : minute$$1(date) < date ? formatSecond
	        : hour$$1(date) < date ? formatMinute
	        : day$$1(date) < date ? formatHour
	        : month$$1(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year$$1(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year$$1;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = tickStep(start, stop, interval);
	        interval = millisecond$$1;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$3.call(_, number$2)) : domain().map(date$1);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year$$1, month$$1, week, day$$1, hour$$1, minute$$1, second$$1, millisecond$$1, format));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(year, month, sunday, day, hour, minute, second, millisecond, exports.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	}
	
	var utcTime = function() {
	  return calendar(utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, millisecond, exports.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	}
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	}
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$3 = cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));
	
	var warm = cubehelixLong(cubehelix(-100, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var cool = cubehelixLong(cubehelix(260, 0.75, 0.35), cubehelix(80, 1.50, 0.8));
	
	var rainbow = cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	}
	
	function ramp(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	var xhtml = "http://www.w3.org/1999/xhtml";
	
	var namespaces = {
	  svg: "http://www.w3.org/2000/svg",
	  xhtml: xhtml,
	  xlink: "http://www.w3.org/1999/xlink",
	  xml: "http://www.w3.org/XML/1998/namespace",
	  xmlns: "http://www.w3.org/2000/xmlns/"
	};
	
	var namespace = function(name) {
	  var prefix = name += "", i = prefix.indexOf(":");
	  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	  return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	}
	
	function creatorInherit(name) {
	  return function() {
	    var document = this.ownerDocument,
	        uri = this.namespaceURI;
	    return uri === xhtml && document.documentElement.namespaceURI === xhtml
	        ? document.createElement(name)
	        : document.createElementNS(uri, name);
	  };
	}
	
	function creatorFixed(fullname) {
	  return function() {
	    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	  };
	}
	
	var creator = function(name) {
	  var fullname = namespace(name);
	  return (fullname.local
	      ? creatorFixed
	      : creatorInherit)(fullname);
	}
	
	var nextId = 0;
	
	function local() {
	  return new Local;
	}
	
	function Local() {
	  this._ = "@" + (++nextId).toString(36);
	}
	
	Local.prototype = local.prototype = {
	  constructor: Local,
	  get: function(node) {
	    var id = this._;
	    while (!(id in node)) if (!(node = node.parentNode)) return;
	    return node[id];
	  },
	  set: function(node, value) {
	    return node[this._] = value;
	  },
	  remove: function(node) {
	    return this._ in node && delete node[this._];
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	var matcher = function(selector) {
	  return function() {
	    return this.matches(selector);
	  };
	};
	
	if (typeof document !== "undefined") {
	  var element = document.documentElement;
	  if (!element.matches) {
	    var vendorMatches = element.webkitMatchesSelector
	        || element.msMatchesSelector
	        || element.mozMatchesSelector
	        || element.oMatchesSelector;
	    matcher = function(selector) {
	      return function() {
	        return vendorMatches.call(this, selector);
	      };
	    };
	  }
	}
	
	var matcher$1 = matcher;
	
	var filterEvents = {};
	
	exports.event = null;
	
	if (typeof document !== "undefined") {
	  var element$1 = document.documentElement;
	  if (!("onmouseenter" in element$1)) {
	    filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	  }
	}
	
	function filterContextListener(listener, index, group) {
	  listener = contextListener(listener, index, group);
	  return function(event) {
	    var related = event.relatedTarget;
	    if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	      listener.call(this, event);
	    }
	  };
	}
	
	function contextListener(listener, index, group) {
	  return function(event1) {
	    var event0 = exports.event; // Events can be reentrant (e.g., focus).
	    exports.event = event1;
	    try {
	      listener.call(this, this.__data__, index, group);
	    } finally {
	      exports.event = event0;
	    }
	  };
	}
	
	function parseTypenames$1(typenames) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    return {type: t, name: name};
	  });
	}
	
	function onRemove(typename) {
	  return function() {
	    var on = this.__on;
	    if (!on) return;
	    for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	      if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	      } else {
	        on[++i] = o;
	      }
	    }
	    if (++i) on.length = i;
	    else delete this.__on;
	  };
	}
	
	function onAdd(typename, value, capture) {
	  var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	  return function(d, i, group) {
	    var on = this.__on, o, listener = wrap(value, i, group);
	    if (on) for (var j = 0, m = on.length; j < m; ++j) {
	      if ((o = on[j]).type === typename.type && o.name === typename.name) {
	        this.removeEventListener(o.type, o.listener, o.capture);
	        this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	        o.value = value;
	        return;
	      }
	    }
	    this.addEventListener(typename.type, listener, capture);
	    o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	    if (!on) this.__on = [o];
	    else on.push(o);
	  };
	}
	
	var selection_on = function(typename, value, capture) {
	  var typenames = parseTypenames$1(typename + ""), i, n = typenames.length, t;
	
	  if (arguments.length < 2) {
	    var on = this.node().__on;
	    if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	      for (i = 0, o = on[j]; i < n; ++i) {
	        if ((t = typenames[i]).type === o.type && t.name === o.name) {
	          return o.value;
	        }
	      }
	    }
	    return;
	  }
	
	  on = value ? onAdd : onRemove;
	  if (capture == null) capture = false;
	  for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	  return this;
	}
	
	function customEvent(event1, listener, that, args) {
	  var event0 = exports.event;
	  event1.sourceEvent = exports.event;
	  exports.event = event1;
	  try {
	    return listener.apply(that, args);
	  } finally {
	    exports.event = event0;
	  }
	}
	
	var sourceEvent = function() {
	  var current = exports.event, source;
	  while (source = current.sourceEvent) current = source;
	  return current;
	}
	
	var point$5 = function(node, event) {
	  var svg = node.ownerSVGElement || node;
	
	  if (svg.createSVGPoint) {
	    var point = svg.createSVGPoint();
	    point.x = event.clientX, point.y = event.clientY;
	    point = point.matrixTransform(node.getScreenCTM().inverse());
	    return [point.x, point.y];
	  }
	
	  var rect = node.getBoundingClientRect();
	  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	}
	
	var mouse = function(node) {
	  var event = sourceEvent();
	  if (event.changedTouches) event = event.changedTouches[0];
	  return point$5(node, event);
	}
	
	function none$2() {}
	
	var selector = function(selector) {
	  return selector == null ? none$2 : function() {
	    return this.querySelector(selector);
	  };
	}
	
	var selection_select = function(select) {
	  if (typeof select !== "function") select = selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	function empty() {
	  return [];
	}
	
	var selectorAll = function(selector) {
	  return selector == null ? empty : function() {
	    return this.querySelectorAll(selector);
	  };
	}
	
	var selection_selectAll = function(select) {
	  if (typeof select !== "function") select = selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        subgroups.push(select.call(node, node.__data__, i, group));
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, parents);
	}
	
	var selection_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Selection(subgroups, this._parents);
	}
	
	var sparse = function(update) {
	  return new Array(update.length);
	}
	
	var selection_enter = function() {
	  return new Selection(this._enter || this._groups.map(sparse), this._parents);
	}
	
	function EnterNode(parent, datum) {
	  this.ownerDocument = parent.ownerDocument;
	  this.namespaceURI = parent.namespaceURI;
	  this._next = null;
	  this._parent = parent;
	  this.__data__ = datum;
	}
	
	EnterNode.prototype = {
	  constructor: EnterNode,
	  appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	  insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	  querySelector: function(selector) { return this._parent.querySelector(selector); },
	  querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	};
	
	var constant$5 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	function bindIndex(parent, group, enter, update, exit, data) {
	  var i = 0,
	      node,
	      groupLength = group.length,
	      dataLength = data.length;
	
	  // Put any non-null nodes that fit into update.
	  // Put any null nodes into enter.
	  // Put any remaining data into enter.
	  for (; i < dataLength; ++i) {
	    if (node = group[i]) {
	      node.__data__ = data[i];
	      update[i] = node;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Put any non-null nodes that don’t fit into exit.
	  for (; i < groupLength; ++i) {
	    if (node = group[i]) {
	      exit[i] = node;
	    }
	  }
	}
	
	function bindKey(parent, group, enter, update, exit, data, key) {
	  var i,
	      node,
	      nodeByKeyValue = {},
	      groupLength = group.length,
	      dataLength = data.length,
	      keyValues = new Array(groupLength),
	      keyValue;
	
	  // Compute the key for each node.
	  // If multiple nodes have the same key, the duplicates are added to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if (node = group[i]) {
	      keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	      if (keyValue in nodeByKeyValue) {
	        exit[i] = node;
	      } else {
	        nodeByKeyValue[keyValue] = node;
	      }
	    }
	  }
	
	  // Compute the key for each datum.
	  // If there a node associated with this key, join and add it to update.
	  // If there is not (or the key is a duplicate), add it to enter.
	  for (i = 0; i < dataLength; ++i) {
	    keyValue = keyPrefix + key.call(parent, data[i], i, data);
	    if (node = nodeByKeyValue[keyValue]) {
	      update[i] = node;
	      node.__data__ = data[i];
	      nodeByKeyValue[keyValue] = null;
	    } else {
	      enter[i] = new EnterNode(parent, data[i]);
	    }
	  }
	
	  // Add any remaining nodes that were not bound to data to exit.
	  for (i = 0; i < groupLength; ++i) {
	    if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	      exit[i] = node;
	    }
	  }
	}
	
	var selection_data = function(value, key) {
	  if (!value) {
	    data = new Array(this.size()), j = -1;
	    this.each(function(d) { data[++j] = d; });
	    return data;
	  }
	
	  var bind = key ? bindKey : bindIndex,
	      parents = this._parents,
	      groups = this._groups;
	
	  if (typeof value !== "function") value = constant$5(value);
	
	  for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	    var parent = parents[j],
	        group = groups[j],
	        groupLength = group.length,
	        data = value.call(parent, parent && parent.__data__, j, parents),
	        dataLength = data.length,
	        enterGroup = enter[j] = new Array(dataLength),
	        updateGroup = update[j] = new Array(dataLength),
	        exitGroup = exit[j] = new Array(groupLength);
	
	    bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	    // Now connect the enter nodes to their following update node, such that
	    // appendChild can insert the materialized enter node before this node,
	    // rather than at the end of the parent node.
	    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	      if (previous = enterGroup[i0]) {
	        if (i0 >= i1) i1 = i0 + 1;
	        while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	        previous._next = next || null;
	      }
	    }
	  }
	
	  update = new Selection(update, parents);
	  update._enter = enter;
	  update._exit = exit;
	  return update;
	}
	
	var selection_exit = function() {
	  return new Selection(this._exit || this._groups.map(sparse), this._parents);
	}
	
	var selection_merge = function(selection) {
	
	  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Selection(merges, this._parents);
	}
	
	var selection_order = function() {
	
	  for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	    for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	      if (node = group[i]) {
	        if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	        next = node;
	      }
	    }
	  }
	
	  return this;
	}
	
	var selection_sort = function(compare) {
	  if (!compare) compare = ascending$2;
	
	  function compareNode(a, b) {
	    return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	  }
	
	  for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        sortgroup[i] = node;
	      }
	    }
	    sortgroup.sort(compareNode);
	  }
	
	  return new Selection(sortgroups, this._parents).order();
	}
	
	function ascending$2(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	var selection_call = function() {
	  var callback = arguments[0];
	  arguments[0] = this;
	  callback.apply(null, arguments);
	  return this;
	}
	
	var selection_nodes = function() {
	  var nodes = new Array(this.size()), i = -1;
	  this.each(function() { nodes[++i] = this; });
	  return nodes;
	}
	
	var selection_node = function() {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	      var node = group[i];
	      if (node) return node;
	    }
	  }
	
	  return null;
	}
	
	var selection_size = function() {
	  var size = 0;
	  this.each(function() { ++size; });
	  return size;
	}
	
	var selection_empty = function() {
	  return !this.node();
	}
	
	var selection_each = function(callback) {
	
	  for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	    for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	      if (node = group[i]) callback.call(node, node.__data__, i, group);
	    }
	  }
	
	  return this;
	}
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, value) {
	  return function() {
	    this.setAttribute(name, value);
	  };
	}
	
	function attrConstantNS(fullname, value) {
	  return function() {
	    this.setAttributeNS(fullname.space, fullname.local, value);
	  };
	}
	
	function attrFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttribute(name);
	    else this.setAttribute(name, v);
	  };
	}
	
	function attrFunctionNS(fullname, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	    else this.setAttributeNS(fullname.space, fullname.local, v);
	  };
	}
	
	var selection_attr = function(name, value) {
	  var fullname = namespace(name);
	
	  if (arguments.length < 2) {
	    var node = this.node();
	    return fullname.local
	        ? node.getAttributeNS(fullname.space, fullname.local)
	        : node.getAttribute(fullname);
	  }
	
	  return this.each((value == null
	      ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)
	      : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	}
	
	var window = function(node) {
	  return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	      || (node.document && node) // node is a Window
	      || node.defaultView; // node is a Document
	}
	
	function styleRemove(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, value, priority) {
	  return function() {
	    this.style.setProperty(name, value, priority);
	  };
	}
	
	function styleFunction(name, value, priority) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) this.style.removeProperty(name);
	    else this.style.setProperty(name, v, priority);
	  };
	}
	
	var selection_style = function(name, value, priority) {
	  var node;
	  return arguments.length > 1
	      ? this.each((value == null
	            ? styleRemove : typeof value === "function"
	            ? styleFunction
	            : styleConstant)(name, value, priority == null ? "" : priority))
	      : window(node = this.node())
	          .getComputedStyle(node, null)
	          .getPropertyValue(name);
	}
	
	function propertyRemove(name) {
	  return function() {
	    delete this[name];
	  };
	}
	
	function propertyConstant(name, value) {
	  return function() {
	    this[name] = value;
	  };
	}
	
	function propertyFunction(name, value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    if (v == null) delete this[name];
	    else this[name] = v;
	  };
	}
	
	var selection_property = function(name, value) {
	  return arguments.length > 1
	      ? this.each((value == null
	          ? propertyRemove : typeof value === "function"
	          ? propertyFunction
	          : propertyConstant)(name, value))
	      : this.node()[name];
	}
	
	function classArray(string) {
	  return string.trim().split(/^|\s+/);
	}
	
	function classList(node) {
	  return node.classList || new ClassList(node);
	}
	
	function ClassList(node) {
	  this._node = node;
	  this._names = classArray(node.getAttribute("class") || "");
	}
	
	ClassList.prototype = {
	  add: function(name) {
	    var i = this._names.indexOf(name);
	    if (i < 0) {
	      this._names.push(name);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  remove: function(name) {
	    var i = this._names.indexOf(name);
	    if (i >= 0) {
	      this._names.splice(i, 1);
	      this._node.setAttribute("class", this._names.join(" "));
	    }
	  },
	  contains: function(name) {
	    return this._names.indexOf(name) >= 0;
	  }
	};
	
	function classedAdd(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.add(names[i]);
	}
	
	function classedRemove(node, names) {
	  var list = classList(node), i = -1, n = names.length;
	  while (++i < n) list.remove(names[i]);
	}
	
	function classedTrue(names) {
	  return function() {
	    classedAdd(this, names);
	  };
	}
	
	function classedFalse(names) {
	  return function() {
	    classedRemove(this, names);
	  };
	}
	
	function classedFunction(names, value) {
	  return function() {
	    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	  };
	}
	
	var selection_classed = function(name, value) {
	  var names = classArray(name + "");
	
	  if (arguments.length < 2) {
	    var list = classList(this.node()), i = -1, n = names.length;
	    while (++i < n) if (!list.contains(names[i])) return false;
	    return true;
	  }
	
	  return this.each((typeof value === "function"
	      ? classedFunction : value
	      ? classedTrue
	      : classedFalse)(names, value));
	}
	
	function textRemove() {
	  this.textContent = "";
	}
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.textContent = v == null ? "" : v;
	  };
	}
	
	var selection_text = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? textRemove : (typeof value === "function"
	          ? textFunction
	          : textConstant)(value))
	      : this.node().textContent;
	}
	
	function htmlRemove() {
	  this.innerHTML = "";
	}
	
	function htmlConstant(value) {
	  return function() {
	    this.innerHTML = value;
	  };
	}
	
	function htmlFunction(value) {
	  return function() {
	    var v = value.apply(this, arguments);
	    this.innerHTML = v == null ? "" : v;
	  };
	}
	
	var selection_html = function(value) {
	  return arguments.length
	      ? this.each(value == null
	          ? htmlRemove : (typeof value === "function"
	          ? htmlFunction
	          : htmlConstant)(value))
	      : this.node().innerHTML;
	}
	
	function raise$1() {
	  if (this.nextSibling) this.parentNode.appendChild(this);
	}
	
	var selection_raise = function() {
	  return this.each(raise$1);
	}
	
	function lower() {
	  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	}
	
	var selection_lower = function() {
	  return this.each(lower);
	}
	
	var selection_append = function(name) {
	  var create = typeof name === "function" ? name : creator(name);
	  return this.select(function() {
	    return this.appendChild(create.apply(this, arguments));
	  });
	}
	
	function constantNull() {
	  return null;
	}
	
	var selection_insert = function(name, before) {
	  var create = typeof name === "function" ? name : creator(name),
	      select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	  return this.select(function() {
	    return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	  });
	}
	
	function remove() {
	  var parent = this.parentNode;
	  if (parent) parent.removeChild(this);
	}
	
	var selection_remove = function() {
	  return this.each(remove);
	}
	
	var selection_datum = function(value) {
	  return arguments.length
	      ? this.property("__data__", value)
	      : this.node().__data__;
	}
	
	function dispatchEvent(node, type, params) {
	  var window$$1 = window(node),
	      event = window$$1.CustomEvent;
	
	  if (event) {
	    event = new event(type, params);
	  } else {
	    event = window$$1.document.createEvent("Event");
	    if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	    else event.initEvent(type, false, false);
	  }
	
	  node.dispatchEvent(event);
	}
	
	function dispatchConstant(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params);
	  };
	}
	
	function dispatchFunction(type, params) {
	  return function() {
	    return dispatchEvent(this, type, params.apply(this, arguments));
	  };
	}
	
	var selection_dispatch = function(type, params) {
	  return this.each((typeof params === "function"
	      ? dispatchFunction
	      : dispatchConstant)(type, params));
	}
	
	var root = [null];
	
	function Selection(groups, parents) {
	  this._groups = groups;
	  this._parents = parents;
	}
	
	function selection() {
	  return new Selection([[document.documentElement]], root);
	}
	
	Selection.prototype = selection.prototype = {
	  constructor: Selection,
	  select: selection_select,
	  selectAll: selection_selectAll,
	  filter: selection_filter,
	  data: selection_data,
	  enter: selection_enter,
	  exit: selection_exit,
	  merge: selection_merge,
	  order: selection_order,
	  sort: selection_sort,
	  call: selection_call,
	  nodes: selection_nodes,
	  node: selection_node,
	  size: selection_size,
	  empty: selection_empty,
	  each: selection_each,
	  attr: selection_attr,
	  style: selection_style,
	  property: selection_property,
	  classed: selection_classed,
	  text: selection_text,
	  html: selection_html,
	  raise: selection_raise,
	  lower: selection_lower,
	  append: selection_append,
	  insert: selection_insert,
	  remove: selection_remove,
	  datum: selection_datum,
	  on: selection_on,
	  dispatch: selection_dispatch
	};
	
	var select = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	      : new Selection([[selector]], root);
	}
	
	var selectAll = function(selector) {
	  return typeof selector === "string"
	      ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	      : new Selection([selector == null ? [] : selector], root);
	}
	
	var touch = function(node, touches, identifier) {
	  if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	  for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	    if ((touch = touches[i]).identifier === identifier) {
	      return point$5(node, touch);
	    }
	  }
	
	  return null;
	}
	
	var touches = function(node, touches) {
	  if (touches == null) touches = sourceEvent().touches;
	
	  for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	    points[i] = point$5(node, touches[i]);
	  }
	
	  return points;
	}
	
	var emptyOn = dispatch("start", "end", "interrupt");
	var emptyTween = [];
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	var schedule = function(node, name, id, index, group, timing) {
	  var schedules = node.__transition;
	  if (!schedules) node.__transition = {};
	  else if (id in schedules) return;
	  create(node, id, {
	    name: name,
	    index: index, // For context during callback.
	    group: group, // For context during callback.
	    on: emptyOn,
	    tween: emptyTween,
	    time: timing.time,
	    delay: timing.delay,
	    duration: timing.duration,
	    ease: timing.ease,
	    timer: null,
	    state: CREATED
	  });
	}
	
	function init(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
	  return schedule;
	}
	
	function set$3(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
	  return schedule;
	}
	
	function get$1(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
	  return schedule;
	}
	
	function create(node, id, self) {
	  var schedules = node.__transition,
	      tween;
	
	  // Initialize the self timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  schedules[id] = self;
	  self.timer = timer(schedule, 0, self.time);
	
	  function schedule(elapsed) {
	    self.state = SCHEDULED;
	    self.timer.restart(start, self.delay, self.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (self.delay <= elapsed) start(elapsed - self.delay);
	  }
	
	  function start(elapsed) {
	    var i, j, n, o;
	
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (self.state !== SCHEDULED) return stop();
	
	    for (i in schedules) {
	      o = schedules[i];
	      if (o.name !== self.name) continue;
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (o.state === STARTED) return timeout$1(start);
	
	      // Interrupt the active transition, if any.
	      // Dispatch the interrupt event.
	      if (o.state === RUNNING) {
	        o.state = ENDED;
	        o.timer.stop();
	        o.on.call("interrupt", node, node.__data__, o.index, o.group);
	        delete schedules[i];
	      }
	
	      // Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	      else if (+i < id) {
	        o.state = ENDED;
	        o.timer.stop();
	        delete schedules[i];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    timeout$1(function() {
	      if (self.state === STARTED) {
	        self.state = RUNNING;
	        self.timer.restart(tick, self.delay, self.time);
	        tick(elapsed);
	      }
	    });
	
	    // Dispatch the start event.
	    // Note this must be done before the tween are initialized.
	    self.state = STARTING;
	    self.on.call("start", node, node.__data__, self.index, self.group);
	    if (self.state !== STARTING) return; // interrupted
	    self.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    tween = new Array(n = self.tween.length);
	    for (i = 0, j = -1; i < n; ++i) {
	      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
	        tween[++j] = o;
	      }
	    }
	    tween.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
	        i = -1,
	        n = tween.length;
	
	    while (++i < n) {
	      tween[i].call(null, t);
	    }
	
	    // Dispatch the end event.
	    if (self.state === ENDING) {
	      self.on.call("end", node, node.__data__, self.index, self.group);
	      stop();
	    }
	  }
	
	  function stop() {
	    self.state = ENDED;
	    self.timer.stop();
	    delete schedules[id];
	    for (var i in schedules) return; // eslint-disable-line no-unused-vars
	    delete node.__transition;
	  }
	}
	
	var interrupt = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      active,
	      empty = true,
	      i;
	
	  if (!schedules) return;
	
	  name = name == null ? null : name + "";
	
	  for (i in schedules) {
	    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
	    active = schedule.state === STARTED;
	    schedule.state = ENDED;
	    schedule.timer.stop();
	    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
	    delete schedules[i];
	  }
	
	  if (empty) delete node.__transition;
	}
	
	var selection_interrupt = function(name) {
	  return this.each(function() {
	    interrupt(this, name);
	  });
	}
	
	function tweenRemove(id, name) {
	  var tween0, tween1;
	  return function() {
	    var schedule = set$3(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = tween0 = tween;
	      for (var i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1 = tween1.slice();
	          tween1.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	function tweenFunction(id, name, value) {
	  var tween0, tween1;
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    var schedule = set$3(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = (tween0 = tween).slice();
	      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1[i] = t;
	          break;
	        }
	      }
	      if (i === n) tween1.push(t);
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	var transition_tween = function(name, value) {
	  var id = this._id;
	
	  name += "";
	
	  if (arguments.length < 2) {
	    var tween = get$1(this.node(), id).tween;
	    for (var i = 0, n = tween.length, t; i < n; ++i) {
	      if ((t = tween[i]).name === name) {
	        return t.value;
	      }
	    }
	    return null;
	  }
	
	  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
	}
	
	function tweenValue(transition, name, value) {
	  var id = transition._id;
	
	  transition.each(function() {
	    var schedule = set$3(this, id);
	    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
	  });
	
	  return function(node) {
	    return get$1(node, id).value[name];
	  };
	}
	
	var interpolate$1 = function(a, b) {
	  var c;
	  return (typeof b === "number" ? interpolateNumber
	      : b instanceof color ? interpolateRgb
	      : (c = color(b)) ? (b = c, interpolateRgb)
	      : interpolateString)(a, b);
	}
	
	function attrRemove$1(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS$1(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrConstantNS$1(fullname, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttribute(name);
	    value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function attrFunctionNS$1(fullname, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
	    value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_attr = function(name, value) {
	  var fullname = namespace(name), i = fullname === "transform" ? interpolateTransformSvg : interpolate$1;
	  return this.attrTween(name, typeof value === "function"
	      ? (fullname.local ? attrFunctionNS$1 : attrFunction$1)(fullname, i, tweenValue(this, "attr." + name, value))
	      : value == null ? (fullname.local ? attrRemoveNS$1 : attrRemove$1)(fullname)
	      : (fullname.local ? attrConstantNS$1 : attrConstant$1)(fullname, i, value));
	}
	
	function attrTweenNS(fullname, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttributeNS(fullname.space, fullname.local, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	function attrTween(name, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttribute(name, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_attrTween = function(name, value) {
	  var key = "attr." + name;
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  var fullname = namespace(name);
	  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
	}
	
	function delayFunction(id, value) {
	  return function() {
	    init(this, id).delay = +value.apply(this, arguments);
	  };
	}
	
	function delayConstant(id, value) {
	  return value = +value, function() {
	    init(this, id).delay = value;
	  };
	}
	
	var transition_delay = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? delayFunction
	          : delayConstant)(id, value))
	      : get$1(this.node(), id).delay;
	}
	
	function durationFunction(id, value) {
	  return function() {
	    set$3(this, id).duration = +value.apply(this, arguments);
	  };
	}
	
	function durationConstant(id, value) {
	  return value = +value, function() {
	    set$3(this, id).duration = value;
	  };
	}
	
	var transition_duration = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? durationFunction
	          : durationConstant)(id, value))
	      : get$1(this.node(), id).duration;
	}
	
	function easeConstant(id, value) {
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    set$3(this, id).ease = value;
	  };
	}
	
	var transition_ease = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each(easeConstant(id, value))
	      : get$1(this.node(), id).ease;
	}
	
	var transition_filter = function(match) {
	  if (typeof match !== "function") match = matcher$1(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, this._name, this._id);
	}
	
	var transition_merge = function(transition) {
	  if (transition._id !== this._id) throw new Error;
	
	  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Transition(merges, this._parents, this._name, this._id);
	}
	
	function start$1(name) {
	  return (name + "").trim().split(/^|\s+/).every(function(t) {
	    var i = t.indexOf(".");
	    if (i >= 0) t = t.slice(0, i);
	    return !t || t === "start";
	  });
	}
	
	function onFunction(id, name, listener) {
	  var on0, on1, sit = start$1(name) ? init : set$3;
	  return function() {
	    var schedule = sit(this, id),
	        on = schedule.on;
	
	    // If this node shared a dispatch with the previous node,
	    // just assign the updated shared dispatch and we’re done!
	    // Otherwise, copy-on-write.
	    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
	
	    schedule.on = on1;
	  };
	}
	
	var transition_on = function(name, listener) {
	  var id = this._id;
	
	  return arguments.length < 2
	      ? get$1(this.node(), id).on.on(name)
	      : this.each(onFunction(id, name, listener));
	}
	
	function removeFunction(id) {
	  return function() {
	    var parent = this.parentNode;
	    for (var i in this.__transition) if (+i !== id) return;
	    if (parent) parent.removeChild(this);
	  };
	}
	
	var transition_remove = function() {
	  return this.on("end.remove", removeFunction(this._id));
	}
	
	var transition_select = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selector(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select$$1.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	        schedule(subgroup[i], name, id, i, subgroup, get$1(node, id));
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, name, id);
	}
	
	var transition_selectAll = function(select$$1) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select$$1 !== "function") select$$1 = selectorAll(select$$1);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        for (var children = select$$1.call(node, node.__data__, i, group), child, inherit = get$1(node, id), k = 0, l = children.length; k < l; ++k) {
	          if (child = children[k]) {
	            schedule(child, name, id, k, children, inherit);
	          }
	        }
	        subgroups.push(children);
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, parents, name, id);
	}
	
	var Selection$1 = selection.prototype.constructor;
	
	var transition_selection = function() {
	  return new Selection$1(this._groups, this._parents);
	}
	
	function styleRemove$1(name, interpolate$$1) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function styleRemoveEnd(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant$1(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = window(this).getComputedStyle(this, null).getPropertyValue(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function styleFunction$1(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = value(this);
	    if (value1 == null) value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_style = function(name, value, priority) {
	  var i = (name += "") === "transform" ? interpolateTransformCss : interpolate$1;
	  return value == null ? this
	          .styleTween(name, styleRemove$1(name, i))
	          .on("end.style." + name, styleRemoveEnd(name))
	      : this.styleTween(name, typeof value === "function"
	          ? styleFunction$1(name, i, tweenValue(this, "style." + name, value))
	          : styleConstant$1(name, i, value), priority);
	}
	
	function styleTween(name, value, priority) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.style.setProperty(name, i(t), priority);
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_styleTween = function(name, value, priority) {
	  var key = "style." + (name += "");
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
	}
	
	function textConstant$1(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction$1(value) {
	  return function() {
	    var value1 = value(this);
	    this.textContent = value1 == null ? "" : value1;
	  };
	}
	
	var transition_text = function(value) {
	  return this.tween("text", typeof value === "function"
	      ? textFunction$1(tweenValue(this, "text", value))
	      : textConstant$1(value == null ? "" : value + ""));
	}
	
	var transition_transition = function() {
	  var name = this._name,
	      id0 = this._id,
	      id1 = newId();
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        var inherit = get$1(node, id0);
	        schedule(node, name, id1, i, group, {
	          time: inherit.time + inherit.delay + inherit.duration,
	          delay: 0,
	          duration: inherit.duration,
	          ease: inherit.ease
	        });
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id1);
	}
	
	var id = 0;
	
	function Transition(groups, parents, name, id) {
	  this._groups = groups;
	  this._parents = parents;
	  this._name = name;
	  this._id = id;
	}
	
	function transition(name) {
	  return selection().transition(name);
	}
	
	function newId() {
	  return ++id;
	}
	
	var selection_prototype = selection.prototype;
	
	Transition.prototype = transition.prototype = {
	  constructor: Transition,
	  select: transition_select,
	  selectAll: transition_selectAll,
	  filter: transition_filter,
	  merge: transition_merge,
	  selection: transition_selection,
	  transition: transition_transition,
	  call: selection_prototype.call,
	  nodes: selection_prototype.nodes,
	  node: selection_prototype.node,
	  size: selection_prototype.size,
	  empty: selection_prototype.empty,
	  each: selection_prototype.each,
	  on: transition_on,
	  attr: transition_attr,
	  attrTween: transition_attrTween,
	  style: transition_style,
	  styleTween: transition_styleTween,
	  text: transition_text,
	  remove: transition_remove,
	  tween: transition_tween,
	  delay: transition_delay,
	  duration: transition_duration,
	  ease: transition_ease
	};
	
	var defaultTiming = {
	  time: null, // Set on use.
	  delay: 0,
	  duration: 250,
	  ease: cubicInOut
	};
	
	function inherit(node, id) {
	  var timing;
	  while (!(timing = node.__transition) || !(timing = timing[id])) {
	    if (!(node = node.parentNode)) {
	      return defaultTiming.time = now(), defaultTiming;
	    }
	  }
	  return timing;
	}
	
	var selection_transition = function(name) {
	  var id,
	      timing;
	
	  if (name instanceof Transition) {
	    id = name._id, name = name._name;
	  } else {
	    id = newId(), (timing = defaultTiming).time = now(), name = name == null ? null : name + "";
	  }
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        schedule(node, name, id, i, group, timing || inherit(node, id));
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id);
	}
	
	selection.prototype.interrupt = selection_interrupt;
	selection.prototype.transition = selection_transition;
	
	var root$1 = [null];
	
	var active = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      i;
	
	  if (schedules) {
	    name = name == null ? null : name + "";
	    for (i in schedules) {
	      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
	        return new Transition([[node]], root$1, name, +i);
	      }
	    }
	  }
	
	  return null;
	}
	
	var slice$4 = Array.prototype.slice;
	
	var identity$5 = function(x) {
	  return x;
	}
	
	var top = 1;
	var right = 2;
	var bottom = 3;
	var left = 4;
	var epsilon$2 = 1e-6;
	
	function translateX(scale0, scale1, d) {
	  var x = scale0(d);
	  return "translate(" + (isFinite(x) ? x : scale1(d)) + ",0)";
	}
	
	function translateY(scale0, scale1, d) {
	  var y = scale0(d);
	  return "translate(0," + (isFinite(y) ? y : scale1(d)) + ")";
	}
	
	function center(scale) {
	  var offset = scale.bandwidth() / 2;
	  if (scale.round()) offset = Math.round(offset);
	  return function(d) {
	    return scale(d) + offset;
	  };
	}
	
	function entering() {
	  return !this.__axis;
	}
	
	function axis(orient, scale) {
	  var tickArguments = [],
	      tickValues = null,
	      tickFormat = null,
	      tickSizeInner = 6,
	      tickSizeOuter = 6,
	      tickPadding = 3;
	
	  function axis(context) {
	    var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	        format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity$5) : tickFormat,
	        spacing = Math.max(tickSizeInner, 0) + tickPadding,
	        transform = orient === top || orient === bottom ? translateX : translateY,
	        range = scale.range(),
	        range0 = range[0] + 0.5,
	        range1 = range[range.length - 1] + 0.5,
	        position = (scale.bandwidth ? center : identity$5)(scale.copy()),
	        selection = context.selection ? context.selection() : context,
	        path = selection.selectAll(".domain").data([null]),
	        tick = selection.selectAll(".tick").data(values, scale).order(),
	        tickExit = tick.exit(),
	        tickEnter = tick.enter().append("g").attr("class", "tick"),
	        line = tick.select("line"),
	        text = tick.select("text"),
	        k = orient === top || orient === left ? -1 : 1,
	        x, y = orient === left || orient === right ? (x = "x", "y") : (x = "y", "x");
	
	    path = path.merge(path.enter().insert("path", ".tick")
	        .attr("class", "domain")
	        .attr("stroke", "#000"));
	
	    tick = tick.merge(tickEnter);
	
	    line = line.merge(tickEnter.append("line")
	        .attr("stroke", "#000")
	        .attr(x + "2", k * tickSizeInner)
	        .attr(y + "1", 0.5)
	        .attr(y + "2", 0.5));
	
	    text = text.merge(tickEnter.append("text")
	        .attr("fill", "#000")
	        .attr(x, k * spacing)
	        .attr(y, 0.5)
	        .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	    if (context !== selection) {
	      path = path.transition(context);
	      tick = tick.transition(context);
	      line = line.transition(context);
	      text = text.transition(context);
	
	      tickExit = tickExit.transition(context)
	          .attr("opacity", epsilon$2)
	          .attr("transform", function(d) { return transform(position, this.parentNode.__axis || position, d); });
	
	      tickEnter
	          .attr("opacity", epsilon$2)
	          .attr("transform", function(d) { return transform(this.parentNode.__axis || position, position, d); });
	    }
	
	    tickExit.remove();
	
	    path
	        .attr("d", orient === left || orient == right
	            ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	            : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	    tick
	        .attr("opacity", 1)
	        .attr("transform", function(d) { return transform(position, position, d); });
	
	    line
	        .attr(x + "2", k * tickSizeInner);
	
	    text
	        .attr(x, k * spacing)
	        .text(format);
	
	    selection.filter(entering)
	        .attr("fill", "none")
	        .attr("font-size", 10)
	        .attr("font-family", "sans-serif")
	        .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	    selection
	        .each(function() { this.__axis = position; });
	  }
	
	  axis.scale = function(_) {
	    return arguments.length ? (scale = _, axis) : scale;
	  };
	
	  axis.ticks = function() {
	    return tickArguments = slice$4.call(arguments), axis;
	  };
	
	  axis.tickArguments = function(_) {
	    return arguments.length ? (tickArguments = _ == null ? [] : slice$4.call(_), axis) : tickArguments.slice();
	  };
	
	  axis.tickValues = function(_) {
	    return arguments.length ? (tickValues = _ == null ? null : slice$4.call(_), axis) : tickValues && tickValues.slice();
	  };
	
	  axis.tickFormat = function(_) {
	    return arguments.length ? (tickFormat = _, axis) : tickFormat;
	  };
	
	  axis.tickSize = function(_) {
	    return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeInner = function(_) {
	    return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	  };
	
	  axis.tickSizeOuter = function(_) {
	    return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	  };
	
	  axis.tickPadding = function(_) {
	    return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	  };
	
	  return axis;
	}
	
	function axisTop(scale) {
	  return axis(top, scale);
	}
	
	function axisRight(scale) {
	  return axis(right, scale);
	}
	
	function axisBottom(scale) {
	  return axis(bottom, scale);
	}
	
	function axisLeft(scale) {
	  return axis(left, scale);
	}
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	}
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	}
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	}
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	}
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	}
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	}
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	}
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	}
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	}
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	}
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	}
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	function Node$2(value) {
	  this._ = value;
	  this.next = null;
	}
	
	var shuffle$1 = function(array) {
	  var i,
	      n = (array = array.slice()).length,
	      head = null,
	      node = head;
	
	  while (n) {
	    var next = new Node$2(array[n - 1]);
	    if (node) node = node.next = next;
	    else node = head = next;
	    array[i] = array[--n];
	  }
	
	  return {
	    head: head,
	    tail: node
	  };
	}
	
	var enclose = function(circles) {
	  return encloseN(shuffle$1(circles), []);
	}
	
	function encloses(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r - b.r;
	  return dr * dr + 1e-6 > dx * dx + dy * dy;
	}
	
	// Returns the smallest circle that contains circles L and intersects circles B.
	function encloseN(L, B) {
	  var circle,
	      l0 = null,
	      l1 = L.head,
	      l2,
	      p1;
	
	  switch (B.length) {
	    case 1: circle = enclose1(B[0]); break;
	    case 2: circle = enclose2(B[0], B[1]); break;
	    case 3: circle = enclose3(B[0], B[1], B[2]); break;
	  }
	
	  while (l1) {
	    p1 = l1._, l2 = l1.next;
	    if (!circle || !encloses(circle, p1)) {
	
	      // Temporarily truncate L before l1.
	      if (l0) L.tail = l0, l0.next = null;
	      else L.head = L.tail = null;
	
	      B.push(p1);
	      circle = encloseN(L, B); // Note: reorders L!
	      B.pop();
	
	      // Move l1 to the front of L and reconnect the truncated list L.
	      if (L.head) l1.next = L.head, L.head = l1;
	      else l1.next = null, L.head = L.tail = l1;
	      l0 = L.tail, l0.next = l2;
	
	    } else {
	      l0 = l1;
	    }
	    l1 = l2;
	  }
	
	  L.tail = l0;
	  return circle;
	}
	
	function enclose1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function enclose2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function enclose3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = 2 * (x1 - x2),
	      b2 = 2 * (y1 - y2),
	      c2 = 2 * (r2 - r1),
	      d2 = x1 * x1 + y1 * y1 - r1 * r1 - x2 * x2 - y2 * y2 + r2 * r2,
	      a3 = 2 * (x1 - x3),
	      b3 = 2 * (y1 - y3),
	      c3 = 2 * (r3 - r1),
	      d3 = x1 * x1 + y1 * y1 - r1 * r1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / ab - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / ab - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (xa * xb + ya * yb + r1),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = (-B - Math.sqrt(B * B - 4 * A * C)) / (2 * A);
	  return {
	    x: xa + xb * r + x1,
	    y: ya + yb * r + y1,
	    r: r
	  };
	}
	
	function place(a, b, c) {
	  var ax = a.x,
	      ay = a.y,
	      da = b.r + c.r,
	      db = a.r + c.r,
	      dx = b.x - ax,
	      dy = b.y - ay,
	      dc = dx * dx + dy * dy;
	  if (dc) {
	    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
	        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	    c.x = ax + x * dx + y * dy;
	    c.y = ay + x * dy - y * dx;
	  } else {
	    c.x = ax + db;
	    c.y = ay;
	  }
	}
	
	function intersects(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r + b.r;
	  return dr * dr > dx * dx + dy * dy;
	}
	
	function distance2(circle, x, y) {
	  var dx = circle.x - x,
	      dy = circle.y - y;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the weighted centroid.
	  var aa = a.r * a.r,
	      ba = b.r * b.r,
	      ca = c.r * c.r,
	      oa = aa + ba + ca,
	      ox = aa * a.x + ba * b.x + ca * c.x,
	      oy = aa * a.y + ba * b.y + ca * c.y,
	      cx, cy, i, j, k, sj, sk;
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // If there are only three elements in the front-chain…
	    if ((k = a.previous) === (j = b.next)) {
	      // If the new circle intersects the third circle,
	      // rotate the front chain to try the next position.
	      if (intersects(j._, c._)) {
	        a = b, b = j, --i;
	        continue pack;
	      }
	    }
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    else {
	      sj = j._.r, sk = k._.r;
	      do {
	        if (sj <= sk) {
	          if (intersects(j._, c._)) {
	            b = j, a.next = b, b.previous = a, --i;
	            continue pack;
	          }
	          j = j.next, sj += j._.r;
	        } else {
	          if (intersects(k._, c._)) {
	            a = k, a.next = b, b.previous = a, --i;
	            continue pack;
	          }
	          k = k.previous, sk += k._.r;
	        }
	      } while (j !== k.next);
	    }
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Update the weighted centroid.
	    oa += ca = c._.r * c._.r;
	    ox += ca * c._.x;
	    oy += ca * c._.y;
	
	    // Compute the new closest circle a to centroid.
	    aa = distance2(a._, cx = ox / oa, cy = oy / oa);
	    while ((c = c.next) !== b) {
	      if ((ca = distance2(c._, cx, cy)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	}
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant$6 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant$6(+x), pack) : padding;
	  };
	
	  return pack;
	}
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	}
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	}
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	}
	
	var keyPrefix$1 = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix$1 + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix$1 + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	}
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	}
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	}
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	    minValue = maxValue = sumValue = nodes[i0].value;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (i1 = i0 + 1; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = (function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	})(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant$6(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant$6(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant$6(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant$6(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant$6(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	}
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((y1 - y0) > (x1 - x0)) {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    } else {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    }
	  }
	}
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	}
	
	var resquarify = (function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	})(phi);
	
	var center$1 = function(x, y) {
	  var nodes;
	
	  if (x == null) x = 0;
	  if (y == null) y = 0;
	
	  function force() {
	    var i,
	        n = nodes.length,
	        node,
	        sx = 0,
	        sy = 0;
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], sx += node.x, sy += node.y;
	    }
	
	    for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
	      node = nodes[i], node.x -= sx, node.y -= sy;
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = +_, force) : x;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = +_, force) : y;
	  };
	
	  return force;
	}
	
	var constant$7 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	var jiggle = function() {
	  return (Math.random() - 0.5) * 1e-6;
	}
	
	function x$1(d) {
	  return d.x + d.vx;
	}
	
	function y$1(d) {
	  return d.y + d.vy;
	}
	
	var collide = function(radius) {
	  var nodes,
	      radii,
	      strength = 1,
	      iterations = 1;
	
	  if (typeof radius !== "function") radius = constant$7(radius == null ? 1 : +radius);
	
	  function force() {
	    var i, n = nodes.length,
	        tree,
	        node,
	        xi,
	        yi,
	        ri,
	        ri2;
	
	    for (var k = 0; k < iterations; ++k) {
	      tree = quadtree(nodes, x$1, y$1).visitAfter(prepare);
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        ri = radii[i], ri2 = ri * ri;
	        xi = node.x + node.vx;
	        yi = node.y + node.vy;
	        tree.visit(apply);
	      }
	    }
	
	    function apply(quad, x0, y0, x1, y1) {
	      var data = quad.data, rj = quad.r, r = ri + rj;
	      if (data) {
	        if (data.index > i) {
	          var x = xi - data.x - data.vx,
	              y = yi - data.y - data.vy,
	              l = x * x + y * y;
	          if (l < r * r) {
	            if (x === 0) x = jiggle(), l += x * x;
	            if (y === 0) y = jiggle(), l += y * y;
	            l = (r - (l = Math.sqrt(l))) / l * strength;
	            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
	            node.vy += (y *= l) * r;
	            data.vx -= x * (r = 1 - r);
	            data.vy -= y * r;
	          }
	        }
	        return;
	      }
	      return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
	    }
	  }
	
	  function prepare(quad) {
	    if (quad.data) return quad.r = radii[quad.data.index];
	    for (var i = quad.r = 0; i < 4; ++i) {
	      if (quad[i] && quad[i].r > quad.r) {
	        quad.r = quad[i].r;
	      }
	    }
	  }
	
	  force.initialize = function(_) {
	    var i, n = (nodes = _).length; radii = new Array(n);
	    for (i = 0; i < n; ++i) radii[i] = +radius(nodes[i], i, nodes);
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = +_, force) : strength;
	  };
	
	  force.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$7(+_), force) : radius;
	  };
	
	  return force;
	}
	
	function index$2(d, i) {
	  return i;
	}
	
	var link = function(links) {
	  var id = index$2,
	      strength = defaultStrength,
	      strengths,
	      distance = constant$7(30),
	      distances,
	      nodes,
	      count,
	      bias,
	      iterations = 1;
	
	  if (links == null) links = [];
	
	  function defaultStrength(link) {
	    return 1 / Math.min(count[link.source.index], count[link.target.index]);
	  }
	
	  function force(alpha) {
	    for (var k = 0, n = links.length; k < iterations; ++k) {
	      for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
	        link = links[i], source = link.source, target = link.target;
	        x = target.x + target.vx - source.x - source.vx || jiggle();
	        y = target.y + target.vy - source.y - source.vy || jiggle();
	        l = Math.sqrt(x * x + y * y);
	        l = (l - distances[i]) / l * alpha * strengths[i];
	        x *= l, y *= l;
	        target.vx -= x * (b = bias[i]);
	        target.vy -= y * b;
	        source.vx += x * (b = 1 - b);
	        source.vy += y * b;
	      }
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	
	    var i,
	        n = nodes.length,
	        m = links.length,
	        nodeById = map$1(nodes, id),
	        link;
	
	    for (i = 0, count = new Array(n); i < n; ++i) {
	      count[i] = 0;
	    }
	
	    for (i = 0; i < m; ++i) {
	      link = links[i], link.index = i;
	      if (typeof link.source !== "object") link.source = nodeById.get(link.source);
	      if (typeof link.target !== "object") link.target = nodeById.get(link.target);
	      ++count[link.source.index], ++count[link.target.index];
	    }
	
	    for (i = 0, bias = new Array(m); i < m; ++i) {
	      link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
	    }
	
	    strengths = new Array(m), initializeStrength();
	    distances = new Array(m), initializeDistance();
	  }
	
	  function initializeStrength() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      strengths[i] = +strength(links[i], i, links);
	    }
	  }
	
	  function initializeDistance() {
	    if (!nodes) return;
	
	    for (var i = 0, n = links.length; i < n; ++i) {
	      distances[i] = +distance(links[i], i, links);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.links = function(_) {
	    return arguments.length ? (links = _, initialize(), force) : links;
	  };
	
	  force.id = function(_) {
	    return arguments.length ? (id = _, force) : id;
	  };
	
	  force.iterations = function(_) {
	    return arguments.length ? (iterations = +_, force) : iterations;
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initializeStrength(), force) : strength;
	  };
	
	  force.distance = function(_) {
	    return arguments.length ? (distance = typeof _ === "function" ? _ : constant$7(+_), initializeDistance(), force) : distance;
	  };
	
	  return force;
	}
	
	function x$2(d) {
	  return d.x;
	}
	
	function y$2(d) {
	  return d.y;
	}
	
	var initialRadius = 10;
	var initialAngle = Math.PI * (3 - Math.sqrt(5));
	
	var simulation = function(nodes) {
	  var simulation,
	      alpha = 1,
	      alphaMin = 0.001,
	      alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
	      alphaTarget = 0,
	      velocityDecay = 0.6,
	      forces = map$1(),
	      stepper = timer(step),
	      event = dispatch("tick", "end");
	
	  if (nodes == null) nodes = [];
	
	  function step() {
	    tick();
	    event.call("tick", simulation);
	    if (alpha < alphaMin) {
	      stepper.stop();
	      event.call("end", simulation);
	    }
	  }
	
	  function tick() {
	    var i, n = nodes.length, node;
	
	    alpha += (alphaTarget - alpha) * alphaDecay;
	
	    forces.each(function(force) {
	      force(alpha);
	    });
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i];
	      if (node.fx == null) node.x += node.vx *= velocityDecay;
	      else node.x = node.fx, node.vx = 0;
	      if (node.fy == null) node.y += node.vy *= velocityDecay;
	      else node.y = node.fy, node.vy = 0;
	    }
	  }
	
	  function initializeNodes() {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.index = i;
	      if (isNaN(node.x) || isNaN(node.y)) {
	        var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
	        node.x = radius * Math.cos(angle);
	        node.y = radius * Math.sin(angle);
	      }
	      if (isNaN(node.vx) || isNaN(node.vy)) {
	        node.vx = node.vy = 0;
	      }
	    }
	  }
	
	  function initializeForce(force) {
	    if (force.initialize) force.initialize(nodes);
	    return force;
	  }
	
	  initializeNodes();
	
	  return simulation = {
	    tick: tick,
	
	    restart: function() {
	      return stepper.restart(step), simulation;
	    },
	
	    stop: function() {
	      return stepper.stop(), simulation;
	    },
	
	    nodes: function(_) {
	      return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
	    },
	
	    alpha: function(_) {
	      return arguments.length ? (alpha = +_, simulation) : alpha;
	    },
	
	    alphaMin: function(_) {
	      return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
	    },
	
	    alphaDecay: function(_) {
	      return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
	    },
	
	    alphaTarget: function(_) {
	      return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
	    },
	
	    velocityDecay: function(_) {
	      return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
	    },
	
	    force: function(name, _) {
	      return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
	    },
	
	    find: function(x, y, radius) {
	      var i = 0,
	          n = nodes.length,
	          dx,
	          dy,
	          d2,
	          node,
	          closest;
	
	      if (radius == null) radius = Infinity;
	      else radius *= radius;
	
	      for (i = 0; i < n; ++i) {
	        node = nodes[i];
	        dx = x - node.x;
	        dy = y - node.y;
	        d2 = dx * dx + dy * dy;
	        if (d2 < radius) closest = node, radius = d2;
	      }
	
	      return closest;
	    },
	
	    on: function(name, _) {
	      return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
	    }
	  };
	}
	
	var manyBody = function() {
	  var nodes,
	      node,
	      alpha,
	      strength = constant$7(-30),
	      strengths,
	      distanceMin2 = 1,
	      distanceMax2 = Infinity,
	      theta2 = 0.81;
	
	  function force(_) {
	    var i, n = nodes.length, tree = quadtree(nodes, x$2, y$2).visitAfter(accumulate);
	    for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    for (i = 0; i < n; ++i) strengths[i] = +strength(nodes[i], i, nodes);
	  }
	
	  function accumulate(quad) {
	    var strength = 0, q, c, x$$1, y$$1, i;
	
	    // For internal nodes, accumulate forces from child quadrants.
	    if (quad.length) {
	      for (x$$1 = y$$1 = i = 0; i < 4; ++i) {
	        if ((q = quad[i]) && (c = q.value)) {
	          strength += c, x$$1 += c * q.x, y$$1 += c * q.y;
	        }
	      }
	      quad.x = x$$1 / strength;
	      quad.y = y$$1 / strength;
	    }
	
	    // For leaf nodes, accumulate forces from coincident quadrants.
	    else {
	      q = quad;
	      q.x = q.data.x;
	      q.y = q.data.y;
	      do strength += strengths[q.data.index];
	      while (q = q.next);
	    }
	
	    quad.value = strength;
	  }
	
	  function apply(quad, x1, _, x2) {
	    if (!quad.value) return true;
	
	    var x$$1 = quad.x - node.x,
	        y$$1 = quad.y - node.y,
	        w = x2 - x1,
	        l = x$$1 * x$$1 + y$$1 * y$$1;
	
	    // Apply the Barnes-Hut approximation if possible.
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (w * w / theta2 < l) {
	      if (l < distanceMax2) {
	        if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
	        if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
	        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	        node.vx += x$$1 * quad.value * alpha / l;
	        node.vy += y$$1 * quad.value * alpha / l;
	      }
	      return true;
	    }
	
	    // Otherwise, process points directly.
	    else if (quad.length || l >= distanceMax2) return;
	
	    // Limit forces for very close nodes; randomize direction if coincident.
	    if (quad.data !== node || quad.next) {
	      if (x$$1 === 0) x$$1 = jiggle(), l += x$$1 * x$$1;
	      if (y$$1 === 0) y$$1 = jiggle(), l += y$$1 * y$$1;
	      if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
	    }
	
	    do if (quad.data !== node) {
	      w = strengths[quad.data.index] * alpha / l;
	      node.vx += x$$1 * w;
	      node.vy += y$$1 * w;
	    } while (quad = quad.next);
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.distanceMin = function(_) {
	    return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
	  };
	
	  force.distanceMax = function(_) {
	    return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
	  };
	
	  force.theta = function(_) {
	    return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
	  };
	
	  return force;
	}
	
	var x$3 = function(x) {
	  var strength = constant$7(0.1),
	      nodes,
	      strengths,
	      xz;
	
	  if (typeof x !== "function") x = constant$7(x == null ? 0 : +x);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    xz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : x;
	  };
	
	  return force;
	}
	
	var y$3 = function(y) {
	  var strength = constant$7(0.1),
	      nodes,
	      strengths,
	      yz;
	
	  if (typeof y !== "function") y = constant$7(y == null ? 0 : +y);
	
	  function force(alpha) {
	    for (var i = 0, n = nodes.length, node; i < n; ++i) {
	      node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
	    }
	  }
	
	  function initialize() {
	    if (!nodes) return;
	    var i, n = nodes.length;
	    strengths = new Array(n);
	    yz = new Array(n);
	    for (i = 0; i < n; ++i) {
	      strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
	    }
	  }
	
	  force.initialize = function(_) {
	    nodes = _;
	    initialize();
	  };
	
	  force.strength = function(_) {
	    return arguments.length ? (strength = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : strength;
	  };
	
	  force.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant$7(+_), initialize(), force) : y;
	  };
	
	  return force;
	}
	
	function nopropagation() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	}
	
	var dragDisable = function(view) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", noevent, true);
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", noevent, true);
	  } else {
	    root.__noselect = root.style.MozUserSelect;
	    root.style.MozUserSelect = "none";
	  }
	}
	
	function yesdrag(view, noclick) {
	  var root = view.document.documentElement,
	      selection$$1 = select(view).on("dragstart.drag", null);
	  if (noclick) {
	    selection$$1.on("click.drag", noevent, true);
	    setTimeout(function() { selection$$1.on("click.drag", null); }, 0);
	  }
	  if ("onselectstart" in root) {
	    selection$$1.on("selectstart.drag", null);
	  } else {
	    root.style.MozUserSelect = root.__noselect;
	    delete root.__noselect;
	  }
	}
	
	var constant$8 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
	  this.target = target;
	  this.type = type;
	  this.subject = subject;
	  this.identifier = id;
	  this.active = active;
	  this.x = x;
	  this.y = y;
	  this.dx = dx;
	  this.dy = dy;
	  this._ = dispatch;
	}
	
	DragEvent.prototype.on = function() {
	  var value = this._.on.apply(this._, arguments);
	  return value === this._ ? this : value;
	};
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter() {
	  return !exports.event.button;
	}
	
	function defaultContainer() {
	  return this.parentNode;
	}
	
	function defaultSubject(d) {
	  return d == null ? {x: exports.event.x, y: exports.event.y} : d;
	}
	
	var drag = function() {
	  var filter = defaultFilter,
	      container = defaultContainer,
	      subject = defaultSubject,
	      gestures = {},
	      listeners = dispatch("start", "drag", "end"),
	      active = 0,
	      mousemoving,
	      touchending;
	
	  function drag(selection$$1) {
	    selection$$1
	        .on("mousedown.drag", mousedowned)
	        .on("touchstart.drag", touchstarted)
	        .on("touchmove.drag", touchmoved)
	        .on("touchend.drag touchcancel.drag", touchended)
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var gesture = beforestart("mouse", container.apply(this, arguments), mouse, this, arguments);
	    if (!gesture) return;
	    select(exports.event.view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
	    dragDisable(exports.event.view);
	    nopropagation();
	    mousemoving = false;
	    gesture("start");
	  }
	
	  function mousemoved() {
	    noevent();
	    mousemoving = true;
	    gestures.mouse("drag");
	  }
	
	  function mouseupped() {
	    select(exports.event.view).on("mousemove.drag mouseup.drag", null);
	    yesdrag(exports.event.view, mousemoving);
	    noevent();
	    gestures.mouse("end");
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var touches$$1 = exports.event.changedTouches,
	        c = container.apply(this, arguments),
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = beforestart(touches$$1[i].identifier, c, touch, this, arguments)) {
	        nopropagation();
	        gesture("start");
	      }
	    }
	  }
	
	  function touchmoved() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        noevent();
	        gesture("drag");
	      }
	    }
	  }
	
	  function touchended() {
	    var touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, gesture;
	
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	    for (i = 0; i < n; ++i) {
	      if (gesture = gestures[touches$$1[i].identifier]) {
	        nopropagation();
	        gesture("end");
	      }
	    }
	  }
	
	  function beforestart(id, container, point, that, args) {
	    var p = point(container, id), s, dx, dy,
	        sublisteners = listeners.copy();
	
	    if (!customEvent(new DragEvent(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
	      if ((exports.event.subject = s = subject.apply(that, args)) == null) return false;
	      dx = s.x - p[0] || 0;
	      dy = s.y - p[1] || 0;
	      return true;
	    })) return;
	
	    return function gesture(type) {
	      var p0 = p, n;
	      switch (type) {
	        case "start": gestures[id] = gesture, n = active++; break;
	        case "end": delete gestures[id], --active; // nobreak
	        case "drag": p = point(container, id), n = active; break;
	      }
	      customEvent(new DragEvent(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [type, that, args]);
	    };
	  }
	
	  drag.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$8(!!_), drag) : filter;
	  };
	
	  drag.container = function(_) {
	    return arguments.length ? (container = typeof _ === "function" ? _ : constant$8(_), drag) : container;
	  };
	
	  drag.subject = function(_) {
	    return arguments.length ? (subject = typeof _ === "function" ? _ : constant$8(_), drag) : subject;
	  };
	
	  drag.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? drag : value;
	  };
	
	  return drag;
	}
	
	var constant$9 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	function x$4(d) {
	  return d[0];
	}
	
	function y$4(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon$3
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon$3)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon$3 || Math.abs(endY - startY) > epsilon$3) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon$3 && y1 - endY > epsilon$3 ? [x0, Math.abs(startX - x0) < epsilon$3 ? startY : y1]
	              : Math.abs(endY - y1) < epsilon$3 && x1 - endX > epsilon$3 ? [Math.abs(startY - y1) < epsilon$3 ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon$3 && endY - y0 > epsilon$3 ? [x1, Math.abs(startX - x1) < epsilon$3 ? startY : y0]
	              : Math.abs(endY - y0) < epsilon$3 && endX - x0 > epsilon$3 ? [Math.abs(startY - y0) < epsilon$3 ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2$1) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon$3
	      && Math.abs(y - lArc.circle.cy) < epsilon$3) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon$3
	      && Math.abs(y - rArc.circle.cy) < epsilon$3) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon$3) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon$3) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon$3) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon$3) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon$3 = 1e-6;
	var epsilon2$1 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      var site = cell.site,
	          halfedges = cell.halfedges,
	          j = -1,
	          m = halfedges.length,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  }
	}
	
	var voronoi = function() {
	  var x$$1 = x$4,
	      y$$1 = y$4,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon$3) * epsilon$3, Math.round(y$$1(d, i, data) / epsilon$3) * epsilon$3];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$9(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$9(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	}
	
	var constant$10 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	function ZoomEvent(target, type, transform) {
	  this.target = target;
	  this.type = type;
	  this.transform = transform;
	}
	
	function Transform(k, x, y) {
	  this.k = k;
	  this.x = x;
	  this.y = y;
	}
	
	Transform.prototype = {
	  constructor: Transform,
	  scale: function(k) {
	    return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
	  },
	  translate: function(x, y) {
	    return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
	  },
	  apply: function(point) {
	    return [point[0] * this.k + this.x, point[1] * this.k + this.y];
	  },
	  applyX: function(x) {
	    return x * this.k + this.x;
	  },
	  applyY: function(y) {
	    return y * this.k + this.y;
	  },
	  invert: function(location) {
	    return [(location[0] - this.x) / this.k, (location[1] - this.y) / this.k];
	  },
	  invertX: function(x) {
	    return (x - this.x) / this.k;
	  },
	  invertY: function(y) {
	    return (y - this.y) / this.k;
	  },
	  rescaleX: function(x) {
	    return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
	  },
	  rescaleY: function(y) {
	    return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
	  },
	  toString: function() {
	    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
	  }
	};
	
	var identity$6 = new Transform(1, 0, 0);
	
	transform.prototype = Transform.prototype;
	
	function transform(node) {
	  return node.__zoom || identity$6;
	}
	
	function nopropagation$1() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$1 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	}
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$1() {
	  return !exports.event.button;
	}
	
	function defaultExtent() {
	  var e = this, w, h;
	  if (e instanceof SVGElement) {
	    e = e.ownerSVGElement || e;
	    w = e.width.baseVal.value;
	    h = e.height.baseVal.value;
	  } else {
	    w = e.clientWidth;
	    h = e.clientHeight;
	  }
	  return [[0, 0], [w, h]];
	}
	
	function defaultTransform() {
	  return this.__zoom || identity$6;
	}
	
	var zoom = function() {
	  var filter = defaultFilter$1,
	      extent = defaultExtent,
	      k0 = 0,
	      k1 = Infinity,
	      x0 = -k1,
	      x1 = k1,
	      y0 = x0,
	      y1 = x1,
	      duration = 250,
	      gestures = [],
	      listeners = dispatch("start", "zoom", "end"),
	      touchstarting,
	      touchending,
	      touchDelay = 500,
	      wheelDelay = 150;
	
	  function zoom(selection$$1) {
	    selection$$1
	        .on("wheel.zoom", wheeled)
	        .on("mousedown.zoom", mousedowned)
	        .on("dblclick.zoom", dblclicked)
	        .on("touchstart.zoom", touchstarted)
	        .on("touchmove.zoom", touchmoved)
	        .on("touchend.zoom touchcancel.zoom", touchended)
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .property("__zoom", defaultTransform);
	  }
	
	  zoom.transform = function(collection, transform) {
	    var selection$$1 = collection.selection ? collection.selection() : collection;
	    selection$$1.property("__zoom", defaultTransform);
	    if (collection !== selection$$1) {
	      schedule(collection, transform);
	    } else {
	      selection$$1.interrupt().each(function() {
	        gesture(this, arguments)
	            .start()
	            .zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform)
	            .end();
	      });
	    }
	  };
	
	  zoom.scaleBy = function(selection$$1, k) {
	    zoom.scaleTo(selection$$1, function() {
	      var k0 = this.__zoom.k,
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return k0 * k1;
	    });
	  };
	
	  zoom.scaleTo = function(selection$$1, k) {
	    zoom.transform(selection$$1, function() {
	      var e = extent.apply(this, arguments),
	          t0 = this.__zoom,
	          p0 = centroid(e),
	          p1 = t0.invert(p0),
	          k1 = typeof k === "function" ? k.apply(this, arguments) : k;
	      return constrain(translate(scale(t0, k1), p0, p1), e);
	    });
	  };
	
	  zoom.translateBy = function(selection$$1, x, y) {
	    zoom.transform(selection$$1, function() {
	      return constrain(this.__zoom.translate(
	        typeof x === "function" ? x.apply(this, arguments) : x,
	        typeof y === "function" ? y.apply(this, arguments) : y
	      ), extent.apply(this, arguments));
	    });
	  };
	
	  function scale(transform, k) {
	    k = Math.max(k0, Math.min(k1, k));
	    return k === transform.k ? transform : new Transform(k, transform.x, transform.y);
	  }
	
	  function translate(transform, p0, p1) {
	    var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
	    return x === transform.x && y === transform.y ? transform : new Transform(transform.k, x, y);
	  }
	
	  function constrain(transform, extent) {
	    var dx = Math.min(0, transform.invertX(extent[0][0]) - x0) || Math.max(0, transform.invertX(extent[1][0]) - x1),
	        dy = Math.min(0, transform.invertY(extent[0][1]) - y0) || Math.max(0, transform.invertY(extent[1][1]) - y1);
	    return dx || dy ? transform.translate(dx, dy) : transform;
	  }
	
	  function centroid(extent) {
	    return [(+extent[0][0] + +extent[1][0]) / 2, (+extent[0][1] + +extent[1][1]) / 2];
	  }
	
	  function schedule(transition$$1, transform, center) {
	    transition$$1
	        .on("start.zoom", function() { gesture(this, arguments).start(); })
	        .on("interrupt.zoom end.zoom", function() { gesture(this, arguments).end(); })
	        .tween("zoom", function() {
	          var that = this,
	              args = arguments,
	              g = gesture(that, args),
	              e = extent.apply(that, args),
	              p = center || centroid(e),
	              w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]),
	              a = that.__zoom,
	              b = typeof transform === "function" ? transform.apply(that, args) : transform,
	              i = interpolateZoom(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
	          return function(t) {
	            if (t === 1) t = b; // Avoid rounding error on end.
	            else { var l = i(t), k = w / l[2]; t = new Transform(k, p[0] - l[0] * k, p[1] - l[1] * k); }
	            g.zoom(null, t);
	          };
	        });
	  }
	
	  function gesture(that, args) {
	    for (var i = 0, n = gestures.length, g; i < n; ++i) {
	      if ((g = gestures[i]).that === that) {
	        return g;
	      }
	    }
	    return new Gesture(that, args);
	  }
	
	  function Gesture(that, args) {
	    this.that = that;
	    this.args = args;
	    this.index = -1;
	    this.active = 0;
	    this.extent = extent.apply(that, args);
	  }
	
	  Gesture.prototype = {
	    start: function() {
	      if (++this.active === 1) {
	        this.index = gestures.push(this) - 1;
	        this.emit("start");
	      }
	      return this;
	    },
	    zoom: function(key, transform) {
	      if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
	      if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
	      if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
	      this.that.__zoom = transform;
	      this.emit("zoom");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) {
	        gestures.splice(this.index, 1);
	        this.index = -1;
	        this.emit("end");
	      }
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new ZoomEvent(zoom, type, this.that.__zoom), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function wheeled() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        t = this.__zoom,
	        k = Math.max(k0, Math.min(k1, t.k * Math.pow(2, -exports.event.deltaY * (exports.event.deltaMode ? 120 : 1) / 500))),
	        p = mouse(this);
	
	    // If the mouse is in the same location as before, reuse it.
	    // If there were recent wheel events, reset the wheel idle timeout.
	    if (g.wheel) {
	      if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) {
	        g.mouse[1] = t.invert(g.mouse[0] = p);
	      }
	      clearTimeout(g.wheel);
	    }
	
	    // If this wheel event won’t trigger a transform change, ignore it.
	    else if (t.k === k) return;
	
	    // Otherwise, capture the mouse point and location at the start.
	    else {
	      g.mouse = [p, t.invert(p)];
	      interrupt(this);
	      g.start();
	    }
	
	    noevent$1();
	    g.wheel = setTimeout(wheelidled, wheelDelay);
	    g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent));
	
	    function wheelidled() {
	      g.wheel = null;
	      g.end();
	    }
	  }
	
	  function mousedowned() {
	    if (touchending || !filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        v = select(exports.event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true),
	        p = mouse(this);
	
	    dragDisable(exports.event.view);
	    nopropagation$1();
	    g.mouse = [p, this.__zoom.invert(p)];
	    interrupt(this);
	    g.start();
	
	    function mousemoved() {
	      noevent$1();
	      g.moved = true;
	      g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = mouse(g.that), g.mouse[1]), g.extent));
	    }
	
	    function mouseupped() {
	      v.on("mousemove.zoom mouseup.zoom", null);
	      yesdrag(exports.event.view, g.moved);
	      noevent$1();
	      g.end();
	    }
	  }
	
	  function dblclicked() {
	    if (!filter.apply(this, arguments)) return;
	    var t0 = this.__zoom,
	        p0 = mouse(this),
	        p1 = t0.invert(p0),
	        k1 = t0.k * (exports.event.shiftKey ? 0.5 : 2),
	        t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments));
	
	    noevent$1();
	    if (duration > 0) select(this).transition().duration(duration).call(schedule, t1, p0);
	    else select(this).call(zoom.transform, t1);
	  }
	
	  function touchstarted() {
	    if (!filter.apply(this, arguments)) return;
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t, p;
	
	    nopropagation$1();
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      p = [p, this.__zoom.invert(p), t.identifier];
	      if (!g.touch0) g.touch0 = p;
	      else if (!g.touch1) g.touch1 = p;
	    }
	    if (touchstarting) {
	      touchstarting = clearTimeout(touchstarting);
	      if (!g.touch1) return g.end(), dblclicked.apply(this, arguments);
	    }
	    if (exports.event.touches.length === n) {
	      touchstarting = setTimeout(function() { touchstarting = null; }, touchDelay);
	      interrupt(this);
	      g.start();
	    }
	  }
	
	  function touchmoved() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t, p, l;
	
	    noevent$1();
	    if (touchstarting) touchstarting = clearTimeout(touchstarting);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i], p = touch(this, touches$$1, t.identifier);
	      if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
	      else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
	    }
	    t = g.that.__zoom;
	    if (g.touch1) {
	      var p0 = g.touch0[0], l0 = g.touch0[1],
	          p1 = g.touch1[0], l1 = g.touch1[1],
	          dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp,
	          dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
	      t = scale(t, Math.sqrt(dp / dl));
	      p = [(p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2];
	      l = [(l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2];
	    }
	    else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
	    else return;
	    g.zoom("touch", constrain(translate(t, p, l), g.extent));
	  }
	
	  function touchended() {
	    var g = gesture(this, arguments),
	        touches$$1 = exports.event.changedTouches,
	        n = touches$$1.length, i, t;
	
	    nopropagation$1();
	    if (touchending) clearTimeout(touchending);
	    touchending = setTimeout(function() { touchending = null; }, touchDelay);
	    for (i = 0; i < n; ++i) {
	      t = touches$$1[i];
	      if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
	      else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
	    }
	    if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
	    if (!g.touch0) g.end();
	  }
	
	  zoom.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$10(!!_), zoom) : filter;
	  };
	
	  zoom.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$10([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), zoom) : extent;
	  };
	
	  zoom.scaleExtent = function(_) {
	    return arguments.length ? (k0 = +_[0], k1 = +_[1], zoom) : [k0, k1];
	  };
	
	  zoom.translateExtent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], zoom) : [[x0, y0], [x1, y1]];
	  };
	
	  zoom.duration = function(_) {
	    return arguments.length ? (duration = +_, zoom) : duration;
	  };
	
	  zoom.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? zoom : value;
	  };
	
	  return zoom;
	}
	
	var constant$11 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	var BrushEvent = function(target, type, selection) {
	  this.target = target;
	  this.type = type;
	  this.selection = selection;
	}
	
	function nopropagation$2() {
	  exports.event.stopImmediatePropagation();
	}
	
	var noevent$2 = function() {
	  exports.event.preventDefault();
	  exports.event.stopImmediatePropagation();
	}
	
	var MODE_DRAG = {name: "drag"};
	var MODE_SPACE = {name: "space"};
	var MODE_HANDLE = {name: "handle"};
	var MODE_CENTER = {name: "center"};
	
	var X = {
	  name: "x",
	  handles: ["e", "w"].map(type$1),
	  input: function(x, e) { return x && [[x[0], e[0][1]], [x[1], e[1][1]]]; },
	  output: function(xy) { return xy && [xy[0][0], xy[1][0]]; }
	};
	
	var Y = {
	  name: "y",
	  handles: ["n", "s"].map(type$1),
	  input: function(y, e) { return y && [[e[0][0], y[0]], [e[1][0], y[1]]]; },
	  output: function(xy) { return xy && [xy[0][1], xy[1][1]]; }
	};
	
	var XY = {
	  name: "xy",
	  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type$1),
	  input: function(xy) { return xy; },
	  output: function(xy) { return xy; }
	};
	
	var cursors = {
	  overlay: "crosshair",
	  selection: "move",
	  n: "ns-resize",
	  e: "ew-resize",
	  s: "ns-resize",
	  w: "ew-resize",
	  nw: "nwse-resize",
	  ne: "nesw-resize",
	  se: "nwse-resize",
	  sw: "nesw-resize"
	};
	
	var flipX = {
	  e: "w",
	  w: "e",
	  nw: "ne",
	  ne: "nw",
	  se: "sw",
	  sw: "se"
	};
	
	var flipY = {
	  n: "s",
	  s: "n",
	  nw: "sw",
	  ne: "se",
	  se: "ne",
	  sw: "nw"
	};
	
	var signsX = {
	  overlay: +1,
	  selection: +1,
	  n: null,
	  e: +1,
	  s: null,
	  w: -1,
	  nw: -1,
	  ne: +1,
	  se: +1,
	  sw: -1
	};
	
	var signsY = {
	  overlay: +1,
	  selection: +1,
	  n: -1,
	  e: null,
	  s: +1,
	  w: null,
	  nw: -1,
	  ne: -1,
	  se: +1,
	  sw: +1
	};
	
	function type$1(t) {
	  return {type: t};
	}
	
	// Ignore right-click, since that should open the context menu.
	function defaultFilter$2() {
	  return !exports.event.button;
	}
	
	function defaultExtent$1() {
	  var svg = this.ownerSVGElement || this;
	  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
	}
	
	// Like d3.local, but with the name “__brush” rather than auto-generated.
	function local$1(node) {
	  while (!node.__brush) if (!(node = node.parentNode)) return;
	  return node.__brush;
	}
	
	function empty$1(extent) {
	  return extent[0][0] === extent[1][0]
	      || extent[0][1] === extent[1][1];
	}
	
	function brushSelection(node) {
	  var state = node.__brush;
	  return state ? state.dim.output(state.selection) : null;
	}
	
	function brushX() {
	  return brush$1(X);
	}
	
	function brushY() {
	  return brush$1(Y);
	}
	
	var brush = function() {
	  return brush$1(XY);
	}
	
	function brush$1(dim) {
	  var extent = defaultExtent$1,
	      filter = defaultFilter$2,
	      listeners = dispatch(brush, "start", "brush", "end"),
	      handleSize = 6,
	      touchending;
	
	  function brush(group) {
	    var overlay = group
	        .property("__brush", initialize)
	      .selectAll(".overlay")
	      .data([type$1("overlay")]);
	
	    overlay.enter().append("rect")
	        .attr("class", "overlay")
	        .attr("pointer-events", "all")
	        .attr("cursor", cursors.overlay)
	      .merge(overlay)
	        .each(function() {
	          var extent = local$1(this).extent;
	          select(this)
	              .attr("x", extent[0][0])
	              .attr("y", extent[0][1])
	              .attr("width", extent[1][0] - extent[0][0])
	              .attr("height", extent[1][1] - extent[0][1]);
	        });
	
	    group.selectAll(".selection")
	      .data([type$1("selection")])
	      .enter().append("rect")
	        .attr("class", "selection")
	        .attr("cursor", cursors.selection)
	        .attr("fill", "#777")
	        .attr("fill-opacity", 0.3)
	        .attr("stroke", "#fff")
	        .attr("shape-rendering", "crispEdges");
	
	    var handle = group.selectAll(".handle")
	      .data(dim.handles, function(d) { return d.type; });
	
	    handle.exit().remove();
	
	    handle.enter().append("rect")
	        .attr("class", function(d) { return "handle handle--" + d.type; })
	        .attr("cursor", function(d) { return cursors[d.type]; });
	
	    group
	        .each(redraw)
	        .attr("fill", "none")
	        .attr("pointer-events", "all")
	        .style("-webkit-tap-highlight-color", "rgba(0,0,0,0)")
	        .on("mousedown.brush touchstart.brush", started);
	  }
	
	  brush.move = function(group, selection$$1) {
	    if (group.selection) {
	      group
	          .on("start.brush", function() { emitter(this, arguments).beforestart().start(); })
	          .on("interrupt.brush end.brush", function() { emitter(this, arguments).end(); })
	          .tween("brush", function() {
	            var that = this,
	                state = that.__brush,
	                emit = emitter(that, arguments),
	                selection0 = state.selection,
	                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(this, arguments) : selection$$1, state.extent),
	                i = interpolate(selection0, selection1);
	
	            function tween(t) {
	              state.selection = t === 1 && empty$1(selection1) ? null : i(t);
	              redraw.call(that);
	              emit.brush();
	            }
	
	            return selection0 && selection1 ? tween : tween(1);
	          });
	    } else {
	      group
	          .each(function() {
	            var that = this,
	                args = arguments,
	                state = that.__brush,
	                selection1 = dim.input(typeof selection$$1 === "function" ? selection$$1.apply(that, args) : selection$$1, state.extent),
	                emit = emitter(that, args).beforestart();
	
	            interrupt(that);
	            state.selection = selection1 == null || empty$1(selection1) ? null : selection1;
	            redraw.call(that);
	            emit.start().brush().end();
	          });
	    }
	  };
	
	  function redraw() {
	    var group = select(this),
	        selection$$1 = local$1(this).selection;
	
	    if (selection$$1) {
	      group.selectAll(".selection")
	          .style("display", null)
	          .attr("x", selection$$1[0][0])
	          .attr("y", selection$$1[0][1])
	          .attr("width", selection$$1[1][0] - selection$$1[0][0])
	          .attr("height", selection$$1[1][1] - selection$$1[0][1]);
	
	      group.selectAll(".handle")
	          .style("display", null)
	          .attr("x", function(d) { return d.type[d.type.length - 1] === "e" ? selection$$1[1][0] - handleSize / 2 : selection$$1[0][0] - handleSize / 2; })
	          .attr("y", function(d) { return d.type[0] === "s" ? selection$$1[1][1] - handleSize / 2 : selection$$1[0][1] - handleSize / 2; })
	          .attr("width", function(d) { return d.type === "n" || d.type === "s" ? selection$$1[1][0] - selection$$1[0][0] + handleSize : handleSize; })
	          .attr("height", function(d) { return d.type === "e" || d.type === "w" ? selection$$1[1][1] - selection$$1[0][1] + handleSize : handleSize; });
	    }
	
	    else {
	      group.selectAll(".selection,.handle")
	          .style("display", "none")
	          .attr("x", null)
	          .attr("y", null)
	          .attr("width", null)
	          .attr("height", null);
	    }
	  }
	
	  function emitter(that, args) {
	    return that.__brush.emitter || new Emitter(that, args);
	  }
	
	  function Emitter(that, args) {
	    this.that = that;
	    this.args = args;
	    this.state = that.__brush;
	    this.active = 0;
	  }
	
	  Emitter.prototype = {
	    beforestart: function() {
	      if (++this.active === 1) this.state.emitter = this, this.starting = true;
	      return this;
	    },
	    start: function() {
	      if (this.starting) this.starting = false, this.emit("start");
	      return this;
	    },
	    brush: function() {
	      this.emit("brush");
	      return this;
	    },
	    end: function() {
	      if (--this.active === 0) delete this.state.emitter, this.emit("end");
	      return this;
	    },
	    emit: function(type) {
	      customEvent(new BrushEvent(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
	    }
	  };
	
	  function started() {
	    if (exports.event.touches) { if (exports.event.changedTouches.length < exports.event.touches.length) return noevent$2(); }
	    else if (touchending) return;
	    if (!filter.apply(this, arguments)) return;
	
	    var that = this,
	        type = exports.event.target.__data__.type,
	        mode = (exports.event.metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : (exports.event.altKey ? MODE_CENTER : MODE_HANDLE),
	        signX = dim === Y ? null : signsX[type],
	        signY = dim === X ? null : signsY[type],
	        state = local$1(that),
	        extent = state.extent,
	        selection$$1 = state.selection,
	        W = extent[0][0], w0, w1,
	        N = extent[0][1], n0, n1,
	        E = extent[1][0], e0, e1,
	        S = extent[1][1], s0, s1,
	        dx,
	        dy,
	        moving,
	        shifting = signX && signY && exports.event.shiftKey,
	        lockX,
	        lockY,
	        point0 = mouse(that),
	        point = point0,
	        emit = emitter(that, arguments).beforestart();
	
	    if (type === "overlay") {
	      state.selection = selection$$1 = [
	        [w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]],
	        [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]
	      ];
	    } else {
	      w0 = selection$$1[0][0];
	      n0 = selection$$1[0][1];
	      e0 = selection$$1[1][0];
	      s0 = selection$$1[1][1];
	    }
	
	    w1 = w0;
	    n1 = n0;
	    e1 = e0;
	    s1 = s0;
	
	    var group = select(that)
	        .attr("pointer-events", "none");
	
	    var overlay = group.selectAll(".overlay")
	        .attr("cursor", cursors[type]);
	
	    if (exports.event.touches) {
	      group
	          .on("touchmove.brush", moved, true)
	          .on("touchend.brush touchcancel.brush", ended, true);
	    } else {
	      var view = select(exports.event.view)
	          .on("keydown.brush", keydowned, true)
	          .on("keyup.brush", keyupped, true)
	          .on("mousemove.brush", moved, true)
	          .on("mouseup.brush", ended, true);
	
	      dragDisable(exports.event.view);
	    }
	
	    nopropagation$2();
	    interrupt(that);
	    redraw.call(that);
	    emit.start();
	
	    function moved() {
	      var point1 = mouse(that);
	      if (shifting && !lockX && !lockY) {
	        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
	        else lockX = true;
	      }
	      point = point1;
	      moving = true;
	      noevent$2();
	      move();
	    }
	
	    function move() {
	      var t;
	
	      dx = point[0] - point0[0];
	      dy = point[1] - point0[1];
	
	      switch (mode) {
	        case MODE_SPACE:
	        case MODE_DRAG: {
	          if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
	          if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
	          break;
	        }
	        case MODE_HANDLE: {
	          if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
	          else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
	          if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
	          else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
	          break;
	        }
	        case MODE_CENTER: {
	          if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
	          if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
	          break;
	        }
	      }
	
	      if (e1 < w1) {
	        signX *= -1;
	        t = w0, w0 = e0, e0 = t;
	        t = w1, w1 = e1, e1 = t;
	        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
	      }
	
	      if (s1 < n1) {
	        signY *= -1;
	        t = n0, n0 = s0, s0 = t;
	        t = n1, n1 = s1, s1 = t;
	        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
	      }
	
	      if (state.selection) selection$$1 = state.selection; // May be set by brush.move!
	      if (lockX) w1 = selection$$1[0][0], e1 = selection$$1[1][0];
	      if (lockY) n1 = selection$$1[0][1], s1 = selection$$1[1][1];
	
	      if (selection$$1[0][0] !== w1
	          || selection$$1[0][1] !== n1
	          || selection$$1[1][0] !== e1
	          || selection$$1[1][1] !== s1) {
	        state.selection = [[w1, n1], [e1, s1]];
	        redraw.call(that);
	        emit.brush();
	      }
	    }
	
	    function ended() {
	      nopropagation$2();
	      if (exports.event.touches) {
	        if (exports.event.touches.length) return;
	        if (touchending) clearTimeout(touchending);
	        touchending = setTimeout(function() { touchending = null; }, 500); // Ghost clicks are delayed!
	        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
	      } else {
	        yesdrag(exports.event.view, moving);
	        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
	      }
	      group.attr("pointer-events", "all");
	      overlay.attr("cursor", cursors.overlay);
	      if (state.selection) selection$$1 = state.selection; // May be set by brush.move (on start)!
	      if (empty$1(selection$$1)) state.selection = null, redraw.call(that);
	      emit.end();
	    }
	
	    function keydowned() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          shifting = signX && signY;
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_HANDLE) {
	            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	            mode = MODE_CENTER;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE; takes priority over ALT
	          if (mode === MODE_HANDLE || mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1 - dx; else if (signX > 0) w0 = w1 - dx;
	            if (signY < 0) s0 = s1 - dy; else if (signY > 0) n0 = n1 - dy;
	            mode = MODE_SPACE;
	            overlay.attr("cursor", cursors.selection);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$2();
	    }
	
	    function keyupped() {
	      switch (exports.event.keyCode) {
	        case 16: { // SHIFT
	          if (shifting) {
	            lockX = lockY = shifting = false;
	            move();
	          }
	          break;
	        }
	        case 18: { // ALT
	          if (mode === MODE_CENTER) {
	            if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	            if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	            mode = MODE_HANDLE;
	            move();
	          }
	          break;
	        }
	        case 32: { // SPACE
	          if (mode === MODE_SPACE) {
	            if (exports.event.altKey) {
	              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
	              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
	              mode = MODE_CENTER;
	            } else {
	              if (signX < 0) e0 = e1; else if (signX > 0) w0 = w1;
	              if (signY < 0) s0 = s1; else if (signY > 0) n0 = n1;
	              mode = MODE_HANDLE;
	            }
	            overlay.attr("cursor", cursors[type]);
	            move();
	          }
	          break;
	        }
	        default: return;
	      }
	      noevent$2();
	    }
	  }
	
	  function initialize() {
	    var state = this.__brush || {selection: null};
	    state.extent = extent.apply(this, arguments);
	    state.dim = dim;
	    return state;
	  }
	
	  brush.extent = function(_) {
	    return arguments.length ? (extent = typeof _ === "function" ? _ : constant$11([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
	  };
	
	  brush.filter = function(_) {
	    return arguments.length ? (filter = typeof _ === "function" ? _ : constant$11(!!_), brush) : filter;
	  };
	
	  brush.handleSize = function(_) {
	    return arguments.length ? (handleSize = +_, brush) : handleSize;
	  };
	
	  brush.on = function() {
	    var value = listeners.on.apply(listeners, arguments);
	    return value === listeners ? brush : value;
	  };
	
	  return brush;
	}
	
	var cos = Math.cos;
	var sin = Math.sin;
	var pi$3 = Math.PI;
	var halfPi$2 = pi$3 / 2;
	var tau$3 = pi$3 * 2;
	var max$1 = Math.max;
	
	function compareValue(compare) {
	  return function(a, b) {
	    return compare(
	      a.source.value + a.target.value,
	      b.source.value + b.target.value
	    );
	  };
	}
	
	var chord = function() {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = range(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1; while (++i < n) {
	      x = 0, j = -1; while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push(range(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function(a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
	      d.sort(function(a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = max$1(0, tau$3 - padAngle * n) / k;
	    dx = k ? padAngle : tau$3 / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1; while (++i < n) {
	      x0 = x, j = -1; while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1; while (++i < n) {
	      j = i - 1; while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value
	              ? {source: target, target: source}
	              : {source: source, target: target});
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function(_) {
	    return arguments.length ? (padAngle = max$1(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function(_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function(_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function(_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	}
	
	var slice$5 = Array.prototype.slice;
	
	var constant$12 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius$1(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}
	
	var ribbon = function() {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius$1,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = slice$5.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - halfPi$2,
	        sa1 = endAngle.apply(this, argv) - halfPi$2,
	        sx0 = sr * cos(sa0),
	        sy0 = sr * sin(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - halfPi$2,
	        ta1 = endAngle.apply(this, argv) - halfPi$2;
	
	    if (!context) context = buffer = path();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$12(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$12(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$12(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function(_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function(_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
	  };
	
	  return ribbon;
	}
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	}
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add$1(temp, y, this.t);
	    add$1(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add$1(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon$4 = 1e-6;
	var epsilon2$2 = 1e-12;
	var pi$4 = Math.PI;
	var halfPi$3 = pi$4 / 2;
	var quarterPi = pi$4 / 4;
	var tau$4 = pi$4 * 2;
	
	var degrees$1 = 180 / pi$4;
	var radians = pi$4 / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos$1 = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log$1 = Math.log;
	var pow$1 = Math.pow;
	var sin$1 = Math.sin;
	var sign$1 = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt$1 = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi$4 : Math.acos(x);
	}
	
	function asin$1(x) {
	  return x > 1 ? halfPi$3 : x < -1 ? -halfPi$3 : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin$1(x / 2)) * x;
	}
	
	function noop$2() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(feature, stream) {
	    streamGeometry(feature.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	}
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop$2,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau$4 + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop$2;
	  },
	  sphere: function() {
	    areaSum.add(tau$4);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos$1(phi = phi / 2 + quarterPi), sinPhi0 = sin$1(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos$1(phi),
	      sinPhi = sin$1(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos$1(adLambda),
	      v = k * sdLambda * sin$1(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area$2 = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	}
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin$1(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos$1(phi);
	  return [cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt$1(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon$4) phi1 = 90;
	    else if (deltaSum < -epsilon$4) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees$1 * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees$1;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees$1;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    boundsPoint(lambda, phi);
	  }
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon$4) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range, x) {
	  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	}
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop$2,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  centroidPointCartesian(cosPhi * cos$1(lambda), cosPhi * sin$1(lambda), sin$1(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      w = atan2(sqrt$1((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos$1(phi);
	  x0 = cosPhi * cos$1(lambda);
	  y0 = cosPhi * sin$1(lambda);
	  z0 = sin$1(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos$1(phi),
	      x = cosPhi * cos$1(lambda),
	      y = cosPhi * sin$1(lambda),
	      z = sin$1(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt$1(cx * cx + cy * cy + cz * cz),
	      u = x0 * x + y0 * y + z0 * z,
	      v = m && -acos(u) / m, // area weight
	      w = atan2(m, u); // line weight
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid$1 = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2$2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon$4) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2$2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees$1, asin$1(z / sqrt$1(m)) * degrees$1];
	}
	
	var constant$13 = function(x) {
	  return function() {
	    return x;
	  };
	}
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	}
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi$4 ? lambda - tau$4 : lambda < -pi$4 ? lambda + tau$4 : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau$4) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi$4 ? lambda - tau$4 : lambda < -pi$4 ? lambda + tau$4 : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos$1(deltaPhi),
	      sinDeltaPhi = sin$1(deltaPhi),
	      cosDeltaGamma = cos$1(deltaGamma),
	      sinDeltaGamma = sin$1(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin$1(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos$1(phi),
	        x = cos$1(lambda) * cosPhi,
	        y = sin$1(lambda) * cosPhi,
	        z = sin$1(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin$1(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees$1, coordinates[1] *= degrees$1, coordinates;
	  };
	
	  return forward;
	}
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos$1(radius),
	      sinRadius = sin$1(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau$4;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau$4;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos$1(t), -sinRadius * sin$1(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau$4 - epsilon$4) % tau$4;
	}
	
	var circle$1 = function() {
	  var center = constant$13([0, 0]),
	      radius = constant$13(90),
	      precision = constant$13(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees$1, x[1] *= degrees$1;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant$13([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant$13(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant$13(+_), circle) : precision;
	  };
	
	  return circle;
	}
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop$2,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	}
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	}
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon$4 && abs(a[1] - b[1]) < epsilon$4;
	}
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link$1(subject);
	  link$1(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	}
	
	function link$1(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon$4 ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon$4 ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon$4 ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent$1 = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	}
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop$2,
	  point: noop$2,
	  lineStart: lengthLineStart,
	  lineEnd: noop$2,
	  polygonStart: noop$2,
	  polygonEnd: noop$2
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop$2;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin$1(phi), cosPhi0$1 = cos$1(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin$1(phi),
	      cosPhi = cos$1(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos$1(delta),
	      sinDelta = sin$1(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt$1(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length$2 = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	}
	
	var coordinates = [null, null];
	var object$1 = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length$2(object$1);
	}
	
	function graticuleX(y0, y1, dy) {
	  var y = range(y0, y1 - epsilon$4, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = range(x0, x1 - epsilon$4, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	var graticule = function() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon$4; }).map(x))
	        .concat(range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon$4; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon$4], [180, 90 - epsilon$4]])
	      .extentMinor([[-180, -80 - epsilon$4], [180, 80 + epsilon$4]]);
	}
	
	var interpolate$2 = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos$1(y0),
	      sy0 = sin$1(y0),
	      cy1 = cos$1(y1),
	      sy1 = sin$1(y1),
	      kx0 = cy0 * cos$1(x0),
	      ky0 = cy0 * sin$1(x0),
	      kx1 = cy1 * cos$1(x1),
	      ky1 = cy1 * sin$1(x1),
	      d = 2 * asin$1(sqrt$1(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin$1(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin$1(t *= d) / k,
	        A = sin$1(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees$1,
	      atan2(z, sqrt$1(x * x + y * y)) * degrees$1
	    ];
	  } : function() {
	    return [x0 * degrees$1, y0 * degrees$1];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	}
	
	var identity$7 = function(x) {
	  return x;
	}
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop$2,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop$2;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop$2,
	  lineEnd: noop$2,
	  polygonStart: noop$2,
	  polygonEnd: noop$2,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt$1(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt$1(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau$4);
	        break;
	      }
	    }
	  },
	  result: noop$2
	};
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _circle: circle$2(4.5),
	  pointRadius: function(_) {
	    return this._circle = circle$2(_), this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    }
	  }
	};
	
	function circle$2(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index$3 = function() {
	  var pointRadius = 4.5,
	      projection,
	      projectionStream,
	      context,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = (projection = _) == null ? identity$7 : _.stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = (context = _) == null ? new PathString : new PathContext(_);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(null).context(null);
	}
	
	var sum$2 = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin$1(lambda), -cos$1(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum$2.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin$1(phi0),
	        cosPhi0 = cos$1(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin$1(phi1),
	          cosPhi1 = cos$1(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi$4,
	          k = sinPhi0 * sinPhi1;
	
	      sum$2.add(atan2(k * sign$$1 * sin$1(absDelta), cosPhi0 * cosPhi1 + k * cos$1(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau$4 : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin$1(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon$4 || angle < epsilon$4 && sum$2 < -epsilon$4) ^ (winding & 1);
	}
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	}
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi$3 - epsilon$4 : halfPi$3 - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi$3 - epsilon$4 : halfPi$3 - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi$4, -halfPi$3]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi$4 : -pi$4,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi$4) < epsilon$4) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi$3 : -halfPi$3);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi$4) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon$4) lambda0 -= sign0 * epsilon$4; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon$4) lambda1 -= sign1 * epsilon$4;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin$1(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon$4
	      ? atan((sin$1(phi0) * (cosPhi1 = cos$1(phi1)) * sin$1(lambda1)
	          - sin$1(phi1) * (cosPhi0 = cos$1(phi0)) * sin$1(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi$3;
	    stream.point(-pi$4, phi);
	    stream.point(0, phi);
	    stream.point(pi$4, phi);
	    stream.point(pi$4, 0);
	    stream.point(pi$4, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi$4, -phi);
	    stream.point(-pi$4, 0);
	    stream.point(-pi$4, phi);
	  } else if (abs(from[0] - to[0]) > epsilon$4) {
	    var lambda = from[0] < to[0] ? pi$4 : -pi$4;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos$1(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon$4; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos$1(lambda) * cos$1(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi$4 : -pi$4), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon$4;
	            point1[1] += epsilon$4;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt$1(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi$4) < epsilon$4,
	        meridian = polar || delta < epsilon$4;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon$4 ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi$4 ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi$4 - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi$4, radius - pi$4]);
	}
	
	var transform$1 = function(prototype) {
	  return {
	    stream: transform$2(prototype)
	  };
	}
	
	function transform$2(prototype) {
	  function T() {}
	  var p = T.prototype = Object.create(Transform$1.prototype);
	  for (var k in prototype) p[k] = prototype[k];
	  return function(stream) {
	    var t = new T;
	    t.stream = stream;
	    return t;
	  };
	}
	
	function Transform$1() {}
	
	Transform$1.prototype = {
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fit(project, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = project.clipExtent && project.clipExtent();
	
	  project
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) project.clipExtent(null);
	
	  geoStream(object, project.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) project.clipExtent(clip);
	
	  return project
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(project) {
	  return function(size, object) {
	    return fit(project, [[0, 0], size], object);
	  };
	}
	
	function fitExtent(project) {
	  return function(extent, object) {
	    return fit(project, extent, object);
	  };
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos$1(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	}
	
	function resampleNone(project) {
	  return transform$2({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt$1(a * a + b * b + c * c),
	          phi2 = asin$1(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon$4 || abs(lambda0 - lambda1) < epsilon$4 ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transform$2({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity$7, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees$1, point[1] * degrees$1];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees$1;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity$7) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees$1, phi * degrees$1];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt$1(delta2);
	  };
	
	  projection.fitExtent = fitExtent(projection);
	
	  projection.fitSize = fitSize(projection);
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi$4 / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees$1, phi1 * degrees$1];
	  };
	
	  return p;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin$1(y0),
	      n = (sy0 + sin$1(y1)) / 2,
	      c = 1 + sy0 * (2 * n - sy0),
	      r0 = sqrt$1(c) / n;
	
	  function project(x, y) {
	    var r = sqrt$1(c - 2 * n * sin$1(y)) / n;
	    return [r * sin$1(x *= n), r0 - r * cos$1(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, r0y) / n, asin$1((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	}
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	}
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon$4, y + 0.120 * k + epsilon$4], [x - 0.214 * k - epsilon$4, y + 0.234 * k - epsilon$4]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon$4, y + 0.166 * k + epsilon$4], [x - 0.115 * k - epsilon$4, y + 0.234 * k - epsilon$4]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = fitExtent(albersUsa);
	
	  albersUsa.fitSize = fitSize(albersUsa);
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	}
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos$1(x),
	        cy = cos$1(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin$1(x),
	      k * sin$1(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt$1(x * x + y * y),
	        c = angle(z),
	        sc = sin$1(c),
	        cc = cos$1(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin$1(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt$1(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin$1(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	}
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin$1(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	}
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log$1(tan((halfPi$3 + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi$3];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau$4);
	}
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      clipAuto;
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), clipAuto && m.clipExtent(null), m) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), clipAuto && m.clipExtent(null), m) : translate();
	  };
	
	  m.clipExtent = function(_) {
	    if (!arguments.length) return clipAuto ? null : clipExtent();
	    if (clipAuto = _ == null) {
	      var k = pi$4 * scale(),
	          t = translate();
	      _ = [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]];
	    }
	    clipExtent(_);
	    return m;
	  };
	
	  return m.clipExtent(null);
	}
	
	function tany(y) {
	  return tan((halfPi$3 + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : log$1(cy0 / cos$1(y1)) / log$1(tany(y1) / tany(y0)),
	      f = cy0 * pow$1(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi$3 + epsilon$4) y = -halfPi$3 + epsilon$4; }
	    else { if (y > halfPi$3 - epsilon$4) y = halfPi$3 - epsilon$4; }
	    var r = f / pow$1(tany(y), n);
	    return [r * sin$1(n * x), f - r * cos$1(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign$1(n) * sqrt$1(x * x + fy * fy);
	    return [atan2(x, fy) / n, 2 * atan(pow$1(f / r, 1 / n)) - halfPi$3];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	}
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	}
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos$1(y0),
	      n = y0 === y1 ? sin$1(y0) : (cy0 - cos$1(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon$4) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin$1(nx), g - gy * cos$1(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, gy) / n, g - sign$1(n) * sqrt$1(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	}
	
	function gnomonicRaw(x, y) {
	  var cy = cos$1(y), k = cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	}
	
	function orthographicRaw(x, y) {
	  return [cos$1(y) * sin$1(x), sin$1(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin$1);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon$4);
	}
	
	function stereographicRaw(x, y) {
	  var cy = cos$1(y), k = 1 + cos$1(x) * cy;
	  return [cy * sin$1(x) / k, sin$1(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	}
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log$1(tan((halfPi$3 + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi$3];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	}
	
	exports.version = version;
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = threshold;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	exports.entries = entries;
	exports.keys = keys;
	exports.values = values;
	exports.map = map$1;
	exports.set = set;
	exports.nest = nest;
	exports.randomUniform = uniform;
	exports.randomNormal = normal;
	exports.randomLogNormal = logNormal;
	exports.randomBates = bates;
	exports.randomIrwinHall = irwinHall;
	exports.randomExponential = exponential;
	exports.easeLinear = linear;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadOut = quadOut;
	exports.easeQuadInOut = quadInOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicOut = cubicOut;
	exports.easeCubicInOut = cubicInOut;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyOut = polyOut;
	exports.easePolyInOut = polyInOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinOut = sinOut;
	exports.easeSinInOut = sinInOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpOut = expOut;
	exports.easeExpInOut = expInOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleOut = circleOut;
	exports.easeCircleInOut = circleInOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceOut = bounceOut;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackOut = backOut;
	exports.easeBackInOut = backInOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticOut = elasticOut;
	exports.easeElasticInOut = elasticInOut;
	exports.polygonArea = area;
	exports.polygonCentroid = centroid;
	exports.polygonHull = hull;
	exports.polygonContains = contains;
	exports.polygonLength = length$1;
	exports.path = path;
	exports.quadtree = quadtree;
	exports.queue = queue;
	exports.arc = arc;
	exports.area = area$1;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross$1;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending$1;
	exports.stackOrderDescending = descending$2;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	exports.interpolate = interpolate;
	exports.interpolateArray = array$1;
	exports.interpolateDate = date;
	exports.interpolateNumber = interpolateNumber;
	exports.interpolateObject = object;
	exports.interpolateRound = interpolateRound;
	exports.interpolateString = interpolateString;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = interpolateZoom;
	exports.interpolateRgb = interpolateRgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateBasis = basis$2;
	exports.interpolateBasisClosed = basisClosed$1;
	exports.quantize = quantize;
	exports.dispatch = dispatch;
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	exports.request = request;
	exports.html = html;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.csv = csv$1;
	exports.tsv = tsv$1;
	exports.now = now;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	exports.timeout = timeout$1;
	exports.interval = interval$1;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	exports.formatLocale = formatLocale;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatLocale = formatLocale$1;
	exports.timeFormatDefaultLocale = defaultLocale$1;
	exports.scaleBand = band;
	exports.scalePoint = point$4;
	exports.scaleIdentity = identity$4;
	exports.scaleLinear = linear$2;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$$1;
	exports.scaleQuantize = quantize$1;
	exports.scaleThreshold = threshold$1;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.scaleSequential = sequential;
	exports.interpolateCubehelixDefault = cubehelix$3;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.creator = creator;
	exports.customEvent = customEvent;
	exports.local = local;
	exports.matcher = matcher$1;
	exports.mouse = mouse;
	exports.namespace = namespace;
	exports.namespaces = namespaces;
	exports.select = select;
	exports.selectAll = selectAll;
	exports.selection = selection;
	exports.selector = selector;
	exports.selectorAll = selectorAll;
	exports.touch = touch;
	exports.touches = touches;
	exports.window = window;
	exports.active = active;
	exports.interrupt = interrupt;
	exports.transition = transition;
	exports.axisTop = axisTop;
	exports.axisRight = axisRight;
	exports.axisBottom = axisBottom;
	exports.axisLeft = axisLeft;
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	exports.forceCenter = center$1;
	exports.forceCollide = collide;
	exports.forceLink = link;
	exports.forceManyBody = manyBody;
	exports.forceSimulation = simulation;
	exports.forceX = x$3;
	exports.forceY = y$3;
	exports.drag = drag;
	exports.dragDisable = dragDisable;
	exports.dragEnable = yesdrag;
	exports.voronoi = voronoi;
	exports.zoom = zoom;
	exports.zoomIdentity = identity$6;
	exports.zoomTransform = transform;
	exports.brush = brush;
	exports.brushX = brushX;
	exports.brushY = brushY;
	exports.brushSelection = brushSelection;
	exports.chord = chord;
	exports.ribbon = ribbon;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoArea = area$2;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid$1;
	exports.geoCircle = circle$1;
	exports.geoClipExtent = extent$1;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoDistance = distance;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoGraticule = graticule;
	exports.geoInterpolate = interpolate$2;
	exports.geoLength = length$2;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoPath = index$3;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoRotation = rotation;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoStream = geoStream;
	exports.geoTransform = transform$1;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 823 */
/***/ function(module, exports) {

	module.exports = "<canvas id=\"lateral_map\" height=\"300\" width=\"300\"></canvas>\n<div id=\"popup\" class=\"overlay hidden\">\n    <div class=\"popup\">\n        <h2>Lateral Map</h2>\n        <a id=\"popup_close\" class=\"close\">×</a>\n        <div class=\"content\">\n            <div class=\"help_section\">\n                The lateral map page can be confusing at first, but once you learn how to properly use all the available features, it is very easy to use. It is intended to me fully customizable and to fulfill any user's needs. The lateral map will display all the different lateral connections grouped by unique IPs within the time selection given at the top right of the page (default to the last 24hrs).\n            </div>\n            <div class=\"help_section\">\n                <h3>1) Canvas</h3>\n                <h4>1.1) Visual</h4>\n                The lateral map is a canvas with many Nodes being connected by multiple Links. There is no duplicate node or link shown on the map.\n                <h5>1.11) Links</h5>\n                <b>a)</b> The links are represented by a straight grey line between two nodes, it indicates there was some sort of communication between them. If you hover a link the line thickens for easier visual.<br/>\n                <b>b)</b> The links are not clickable, but they do contain important information. They contain all the different L7 Applications, protocols, services, IOCs (Indicator of Compromise) and bandwidth between two connecting nodes. When you select a node, the sidebar displays all the connecting nodes. Once you click a connecting node in the sidebar, the link information will be displayed.<br/>\n                <b>c)</b> Links will receive a different color if there is an IOC between the two nodes, it will always grab the highest severity color between the nodes. (the colors are the same colors as the rest of the webapp. (<span class=\"severe\">Severe</span>, <span class=\"high\">High</span>, <span class=\"elevated\">Elevated</span>, <span class=\"guarded\">Guarded</span>)<br/>\n                <h5>1.12) Nodes</h5>\n                The nodes are represented with circles, they can be assigned any color with a variety of icons in the middle.<br/>\n                <b>a)</b> The information that a Node contains: IP, Hostname, Group, Type, MAC, OS, Vendor, All the different L7 Applications, Services, Protocols and Number of connecting nodes<br/>\n                <b>b)</b> On your very first ever initial load, all the nodes will be black meaning they have not yet been assigned a group. All the nodes will also have a symbol <svg height=\"24\" width=\"24\"><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z\" fill=\"#333333\"/></svg> meaning that they have not yet been assigned a type.<br/>\n                <b>c)</b> Every node that has the <svg height=\"24\" width=\"24\"><path d=\"M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z\" fill=\"#333333\"/></svg> symbol means it is the first time the network has seen that IP (it has not yet been added to the network assets table).<br/>\n                <b>d)</b> Every node can be edited by changing the group or type. The group will affect the color, the type will affect the symbol inside the circle node. This can be done by selecting a node, and changing the group or/and type in the sidebar under the Edit Node section 2.2.<br/>\n\n                <h4>1.2) Loading data</h4>\n                On initial load, the lateral map continuously receives data until the limit has reached or there is no more data to be received. One call is being pulled from the network assets table, getting every individual node information from the whole network. The other is getting all the lateral connections between two IPs that each have a distinct MAC address.\n                <h4>1.3) Functionality</h4>\n                <b>a)</b> The lateral map has many features that can be applied to to make it look as clean and clear for the user. First off in the settings section of the sidebar (explained in section 2.5) makes it so you can manage different settings that will affect things such as the gravitational pull between nodes, or the length of the links, ..etc.<br/>\n                <b>b)</b> The map is zoomable and draggable to make sure it is always aligned properly. This is done by the mouse wheel, and dragging anywhere on the canvas that does not contain a node or link. Whenever you find the proper zoom level and position of the canvas, it automatically saves the coordinates and zoom level. Therefore, the next time you load the page it will be at the sale layout you left it. If you by chance end up losing your graph, don’t panic, there is a reset canvas position in the sidebar that defaults it to the initial coordinates. (See Section 2.5.2)<br/>\n                <b>d)</b> If you just click on a node and not drag it, the position is not fixed and the node becomes selected. Once a node is selected and you look at the Node Info section of the sidebar (2.1), it will show all the attributes of that node. A selected node can also be used to edit a node (see Section 2.2). Once a node is selected, the size of the circle increases and a black border appears around the circle. It also greys out all the non connecting nodes for easy visualization.<br/>\n                <b>c)</b> To drag a node, simply click and hold on a node, you can slide a node to whatever position you want. Once released, that node is fixed to that position (meaning it won't move) until you double mouse click on that fixed node, or reset the whole map (see Section 2.4.2). If the node is selected before the drag, it remains selected, if the node is not selected before the drag, it will also remain unselected after done dragging.<br/>\n                <b>e)</b> You can also multi select nodes by simply holding the CTRL key and clicking the node you want to select. Once a node is selected, it is NOT shown in the sidebar, and only the connecting nodes are visible. (Also, the attributes of a node are only shown if there is only ONE node selected). Saving a type or group when multiple nodes are selected will affect all the selected nodes.<br/>\n                <b>f)</b> If you hover over a node it displays the IP (can be changed to hostname, both or none). Also, if you hover over a link, it will display both connecting IPs.\n            </div>\n            <div class=\"help_section\">\n                <h3>2) Sidebar</h3>\n                The sidebar is used to display node information and to editing both nodes and lateral map. The sidebar sections are Node Info (2.1), Edit Node (2.2), Group Creation (2.3), Collapse (2.4), Settings (2.5). At first load all the different sidebar sections are closed, and you simply have to click on the section title to expand it, and same action if you want to close it again.\n                <h4>2.1) <svg height=\"24\" width=\"24\"><path d=\"M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z\" fill=\"#4DADB0\"/></svg>Node Info</h4>\n                <b>a)</b> On initial load, the Node Info section will list all the nodes. You can set how many nodes can be displayed in the Settings (see Section 2.5.4), the default is no limit.<br/>\n                <b>b)</b> The information being displayed in the list: Group & Type, IP, Hostname and number of connecting nodes. The list can be sorted by clicking on the titles of the list. (Note: the Group & Type column is sorted by Type)\n               <h5>2.1.1) Selected Node</h5>\n                <b>a)</b> Once you select a node, the information of the selected node is visible above the list. Furthermore, the only nodes that will be visible in the list are the connecting nodes and the non selected nodes (In other words, all the greyed out nodes and selected nodes will not be visible in the sidebar).<br/>\n                <b>b)</b> If you have multiple nodes selected, the selected node information is not visible anymore.<br/>\n                <b>c)</b> The information that is visible when a single node is selected: IP, Hostname, Group, Type, Mac, OS, Venter, Number of Connecting nodes and a list of all the Responder Layer 7 Applications of that node.<br/>\n                <b>d)</b> The information is slightly different when a selected node is a collapsed node (see section 2.4). First off a collapsed node combines all the requested nodes into one. It contains all unique combinations of information. In the sidebar, it displays all the unique IPs, unique Groups, unique Types, number of nodes in the collapsed node and what was the node collapsed on. It also combines all the Responder Layer 7 Applications and list them as well.<br/>\n                <b>e)</b> Once a single node is selected, you can click on a connected node in the sidebar to see all the different Layer 7 Applications between the nodes (link information). The rows containing “Resp” means that the selected node is the responder and the connecting node is the origin. Of course, if the row contains “Orig” then the connecting node is the responder and the selected node is the origin. You can then click on one of the L7 Apps listed under the connecting nodes to assign values to the search bar. (<b>warning: 1.</b> It does not filter the lateral map, it only assigns the values so it can be used to send to the search page. <b>2.</b> All the previously filtered items will be removed once you click on a L7 Application)\n\n                <h4>2.2) <svg height=\"24\" width=\"24\"><path d=\"M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z\" fill=\"#FF3D38\"/></svg>Edit Node</h4>\n                <b>a)</b> This section of the sidebar is to Edit a node, once a node has been edited, it is the saved for future reference. You can only change the group and type of a node. The group will display the different color nodes for easy visual effects, and the type will have different icons on the node to help identify the nodes responsibility.<br/>\n                <b>b)</b> You can assign any node to any group that a user has created. The different node types that a user can assign is as follows: <br/>\n                <div class=\"type_columns\">\n                    <svg height=\"24\" width=\"24\"><path d=\"M15.9,18.55a2.71,2.71,0,1,1-2.71-2.67A2.69,2.69,0,0,1,15.9,18.55ZM3.25,11.83a12.18,12.18,0,0,1,19.88,0l1.56-1.12a14.13,14.13,0,0,0-23,0ZM6.2,14a8.49,8.49,0,0,1,14,0l1.6-1.15a10.49,10.49,0,0,0-17.18,0Zm3,2.14a4.77,4.77,0,0,1,8.05,0l1.64-1.18a6.83,6.83,0,0,0-11.34,0Z\" fill=\"#999999\"/></svg> Access Point<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M384 960C171.969 960 0 902.625 0 832c0-38.625 0-80.875 0-128 0-11.125 5.562-21.688 13.562-32C56.375 727.125 205.25 768 384 768s327.625-40.875 370.438-96c8 10.312 13.562 20.875 13.562 32 0 37.062 0 76.375 0 128C768 902.625 596 960 384 960zM384 704C171.969 704 0 646.625 0 576c0-38.656 0-80.844 0-128 0-6.781 2.562-13.375 6-19.906l0 0C7.938 424 10.5 419.969 13.562 416 56.375 471.094 205.25 512 384 512s327.625-40.906 370.438-96c3.062 3.969 5.625 8 7.562 12.094l0 0c3.438 6.531 6 13.125 6 19.906 0 37.062 0 76.344 0 128C768 646.625 596 704 384 704zM384 448C171.969 448 0 390.656 0 320c0-20.219 0-41.594 0-64 0-20.344 0-41.469 0-64C0 121.34400000000005 171.969 64 384 64c212 0 384 57.344 384 128 0 19.969 0 41.156 0 64 0 19.594 0 40.25 0 64C768 390.656 596 448 384 448zM384 128c-141.375 0-256 28.594-256 64s114.625 64 256 64 256-28.594 256-64S525.375 128 384 128z\" fill=\"#999999\" transform=\"translate(3,0)scale(0.025)\"/></svg>Database<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M26,2.34H0v17H9l-1.32,5H18.81l-1.48-5H26v-17Zm-11.5,16h-2v-2h2v2Z\" fill=\"#999999\" transform=\"scale(0.9)\"/></svg> Desktop<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z\" fill=\"#999999\"/></svg> DHCP Server<br/>\n                </div>\n                <div class=\"type_columns\">\n                    <svg height=\"24\" width=\"24\"><path d=\"M14,21h3v4H9V21h3V20h2v1Zm4,3h7V22H18v2ZM1,24H8V22H1v2ZM6,7H3V3H6V1H1V9H6V7ZM20,1V3h3V7H20V9h5V1H20ZM12,7H8V9h4V7Zm0-6H8V3h4V1Zm6,6H14V9h4V7Zm0-6H14V3h4V1ZM6,6H8V4H6V6ZM6,17H3V13H6V11H1v8H6V17Zm14-4h3v4H20v2h5V11H20v2Zm-8,4H8v2h4V17ZM8,13h4V11H8v2Zm10,4H14v2h4V17Zm0-6H14v2h4V11ZM6,16H8V14H6v2Z\" fill=\"#999999\" transform=\"scale(0.9)\"/></svg> DNS Server<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M67.998,0H21.473c-1.968,0-3.579,1.61-3.579,3.579v82.314c0,1.968,1.61,3.579,3.579,3.579h46.525c1.968,0,3.579-1.61,3.579-3.579V3.579C71.577,1.61,69.967,0,67.998,0z M44.736,65.811c-2.963,0-5.368-2.409-5.368-5.368c0-2.963,2.405-5.368,5.368-5.368c2.963,0,5.368,2.405,5.368,5.368C50.104,63.403,47.699,65.811,44.736,65.811z M64.419,39.704H25.052v-1.789h39.367V39.704z M64.419,28.967H25.052v-1.789h39.367V28.967z M64.419,17.336H25.052V6.599h39.367V17.336z\" fill=\"#999999\" transform=\"translate(2,0)scale(0.25)\"/></svg> Domain Controller<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M18.25,7.75A5.25,5.25,0,1,1,13,2.5,5.25,5.25,0,0,1,18.25,7.75ZM23.5,19.66a15.68,15.68,0,0,0-21,0V23.5h21V19.66Z\" fill=\"#999999\"/></svg> Endpoint<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z\" fill=\"#999999\"/></svg> File Server<br/>\n                </div>\n                <div class=\"type_columns\">\n                    <svg height=\"24\" width=\"24\"><path d=\"M10,21.41H4.59V16h2v1.86L10,14.59,11.41,16,7.86,19.41H10v2ZM16,6.59v-2h5.41V10h-2V8.14L16,11.41,14.59,10l3.56-3.41H16Zm1.4,14.14h-2V15.31h5.41v2H19l3.27,3.41-1.41,1.41L17.4,18.59v2.14ZM8.61,5.23h2v5.41H5.19v-2H7.05L3.78,5.23,5.19,3.81,8.61,7.37V5.23Z\" fill=\"#999999\"/></svg> Gateway<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M21.67,19.5a2.17,2.17,0,0,0,2.17-2.17V6.5a2.17,2.17,0,0,0-2.17-2.17H4.33A2.17,2.17,0,0,0,2.17,6.5V17.33A2.17,2.17,0,0,0,4.33,19.5H0v2.17H26V19.5H21.67ZM4.33,6.5H21.67V17.33H4.33V6.5Z\" fill=\"#999999\"/></svg> Laptop<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M18,1.77H8a2,2,0,0,0-2,2v18a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2v-18A2,2,0,0,0,18,1.77Zm0,18H8v-14H18v14Z\" fill=\"#999999\"/></svg> Mobile<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M7.81,11.79a15.15,15.15,0,0,0,6.59,6.59l2.2-2.2a1,1,0,0,1,1-.24,11.41,11.41,0,0,0,3.57.57,1,1,0,0,1,1,1V21a1,1,0,0,1-1,1,17,17,0,0,1-17-17,1,1,0,0,1,1-1h3.5a1,1,0,0,1,1,1,11.36,11.36,0,0,0,.57,3.57,1,1,0,0,1-.25,1Z\" fill=\"#999999\"/></svg> Phone<br/>\n                </div>\n                <div class=\"type_columns\">\n                    <svg height=\"24\" width=\"24\"><path d=\"M20,9H6a3,3,0,0,0-3,3v6H7v4H19V18h4V12A3,3,0,0,0,20,9ZM17,20H9V15h8v5Zm3-7a1,1,0,1,1,1-1A1,1,0,0,1,20,13ZM19,4H7V8H19V4Z\" fill=\"#999999\"/></svg> Printer<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M18,22h7v2H18V22ZM1,24H8V22H1v2Zm0-9H25v5H14.19v1h3.05v4H8.82V21H12.1V20H1V15Zm2.09,3H5.17V16H3.09v2ZM1,8H25v5H1V8Zm2.09,3H5.17V9H3.09v2ZM25,1V6H1V1H25ZM5.17,2H3.09V4H5.17V2Z\" fill=\"#999999\" transform=\"scale(0.9)\"/></svg> Server<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M12,20.76H6.57l1.55,1.55-1.6,1.6L2.17,19.57l4.34-4.34,1.6,1.6L6.57,18.49H12v2.27ZM12,10H6.57L8.12,11.5l-1.6,1.6L2.17,8.76,6.51,4.42,8.12,6,6.57,7.68H12V10Zm7.77,11.74-1.6-1.6,1.55-1.55H14.28V16.27H19.7l-1.55-1.66,1.6-1.6,4.34,4.34Zm0-11-1.6-1.6L19.7,7.53H14.28V5.27H19.7L18.15,3.6,19.76,2,24.1,6.34Z\" fill=\"#999999\"/></svg> Switch<br/>\n                    <svg height=\"24\" width=\"24\"><path d=\"M5.06,21A4,4,0,0,1,1,16.64a4.09,4.09,0,0,1,3.4-4.31S4.93,9.25,6.68,9.25A2.76,2.76,0,0,1,9,10.41s1.21-4.94,5.79-4.94c5.71,0,5.87,7.16,5.87,7.16s4.36,0.64,4.36,4C25,21,21.24,21,21.24,21H5.06Z\" fill=\"#999999\" transform=\"scale(0.9)\"/></svg> Web Server</br/>\n                </div>\n                <br/>\n                ** If you wish to add more types please contact Mantix4 support. **<br/>\n                <b>c)</b> To edit nodes simply select one or multiple nodes. This can be done from either the lateral map, the sidebar or even from the search. The in the sidebar, select the type and/or group and click the save button. If you only wish to change one of the values, (EX: only group and not type, simply select “Do Not Change” from the dropdown.<br/>\n                <b>d)</b> If you edit a node with the <svg height=\"24\" width=\"24\"><path d=\"M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z\" fill=\"#333333\"/></svg> icon, it will also create a row in the network assets table. (the first seen of that IP will be from when you saved the node info).<br/>\n                <b>e)</b> The “Select All” button will select all the visible nodes displayed on the lateral map (greyed out nodes included). So if you have the “Hide Nodes on Search” selected (see Section 2.5.3) or hide nodes from the collpased section (see Section 2.4), all the remaining nodes can be selected with one click of the mouse.<br/>\n                <b>f)</b> The “Clear” button will remove the Type and Group of the selected nodes and will have the <svg height=\"24\" width=\"24\"><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z\" fill=\"#333333\"/></svg> icon with a black circle (just like an unassigned node)<br/>\n                <b>Side node:</b> If a collapsed node is selected, and you try to save it, it is IGNORED.<br/>\n\n                <h4>2.3) <svg height=\"24\" width=\"24\"><path d=\"M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z\" fill=\"#FF702C\"/></svg>Group Creation</h4>\n                <b>a)</b> This section is where you create, edit and delete groups. Groups can have the same name or color as other groups so be careful (or can be useful).<br/>\n                <b>b)</b> To create a group you simply type the group name in the text box, click on the color bar to select a color and click the “Save” button. You can then assign that group to any node.<br/>\n                <b>c)</b> To edit a group, simply selected a node (it will grab the group from the selected node) or pick one from the drop down, change the name or color and click the “save” button.<br/>\n                <b>d)</b> To delete a group, select a group (same way as edit) and click the “Delete” button. This will also make sure to remove the group from from all the matching IPs that was assigned to that group. All the nodes that was assigned that group will default back to the black.\n\n                <h4>2.4) <svg height=\"24\" width=\"24\"><path d=\"M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z\" fill=\"#328A15\"/></svg>Collapse</h4>\n                For this section to work, you must have at least one node selected or else the action gets ignored. (unless it’s the IOC or reset all button)\n                <h5>2.4.1) Different Actions</h5>\n                <b>a)</b> Different actions can be applied to the Lateral Map to make it look cleaner. You have four sections to toggle with: Select, Collapse, Hide and Show.<br/>\n                <b>b)</b> All these actions are used with the different categories listed below in (Section 2.4.2).<br/>\n                <b>Select:</b> Will select all the nodes that you want.<br/>\n                <b>Collapse:</b> Will collapse all the nodes you want into one collapsed node.<br/>\n                <b>Hide:</b> Will of course hide all the nodes you want to hide.<br/>\n                <b>Show:</b> Will ONLY show the certain nodes you want to show.<br/>\n                <h5>2.4.2) Categories</h5>\n                <b>a)</b> By selecting a node (or multiple nodes), you have the power to apply an action to it. These actions are implied on certain categories.<br/>\n                <b>b)</b> All the different actions listed above in section 2.4.1 can all be used with these categories:<br/>\n                <b><svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z\"/></svg> Type:</b>  is the Type of the node(s)<br/>\n                <b><svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z\"/></svg> Group:</b> is the Group of the node(s)<br/>\n                <b><svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z\"/></svg> Cluster:</b> is the whole cluster of nodes (if you have more than one cluster and just want to concentrate on one)<br/>\n                <b><svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z\"/></svg> Connecting:</b> is all the connecting nodes (and including) the selected node(s).<br/>\n                <b> <svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\"/></svg>Selected:</b> is to use the action on the already selected nodes<br/>\n                <b><svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"/></svg> IOC:</b> is to use the action only on nodes that have IOCs<br/>\n                <b>c)</b> The Reset All  <svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z\"/></svg> button will reset EVERYTHING back to the initial load of the page, removing all selected, collapsed, hidden and fixed nodes.\n\n                <h5>2.4.3) Couple different scenarios</h5>\n                <b>a) Questions</b><br/>\n                <b>Q:</b> What if you would like to put all the endpoints into one node?<br/>\n                <b>A:</b> You would select ANY of the endpoint nodes either from the map or sidebar, then click “Collapse”, the click “<svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z\"/></svg>Type” and that’s it!<br/>\n                <b>Q:</b> What if you only want to show a single node with all its connecting nodes?<br/>\n                <b>A:</b> You would select that single node, click on “Show”, then click on “<svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z\"/></svg>Connecting”? This will hide ALL the node except for that node and its connecting nodes.<br/>\n                <b>Q:</b> What if you want to hide all the nodes from two different groups?<br/>\n                <b>A:</b> You would select one node from each group, then click “Hide” then click “<svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z\"/></svg>Group”.<br/>\n                <b>Q:</b> What is you want to select all the nodes in one cluster?<br/>\n                <b>A:</b> You would select one single node from the cluster, click “Select” then click “<svg height=\"24\" width=\"24\"><path fill=\"#333333\" d=\"M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z\"/></svg>Cluster”.<br/>\n                <b>b) Things to note:</b><br/>\n                - If you have two nodes selected, both of them have different groups, you then collapse them on group. It will collapse all the nodes from BOTH those groups into ONE node.<br/>\n                - The IOC button does not use selected nodes. It simply uses the actions on all the nodes with an IOC. Therefore, if you only want to show the nodes with an IOC, or hide them, or select them and of course if you want to collapsed all the IOC nodes into one node.<br/>\n                - If a node is collapsed we’ll say by type, you can have multiple different groups in that node. You then want to collapse all the nodes from a group into one node. If there is a node with that is matching the group and is already in another collapsed node, it is IGNORED. And stays in the first collapsed node he was originally assigned to. That goes for ALL already collapsed nodes.\n\n               <h4>2.5) <svg height=\"24\" width=\"24\"><path d=\"M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z\" fill=\"#999999\"/></svg>Settings</h4>\n                This section of the sidebar is to make the lateral map as clean and clear as possible for future use. All actions that happen in the settings section will be saved, except for the freeze/unfreeze event. (see section 2.5.2 a)\n                <h5>2.5.1) Sliders</h5>\n                Having a variety of the number of nodes and links will affect the way the lateral map looks, theses sliders will change the lateral map settings to fit the user’s needs. All these can be adjusted at any time, and if you seem to have lost everything, don’t worry there is a reset to the original default settings.<br/>\n                <b>a) Gravity:</b> is the gravitational force between two nodes. The more connections a node contains, the greater gravity effect it will have. Gravity also likes to attract all the nodes the the center of the map.<br/>\n                <b>b) Charge:</b> Is what makes sure the nodes do not pile on top of each other, the greater the charge, the farther apart the nodes are going to want to be from each other. (can help to think of it as the opposite of gravity)<br/>\n                <b>c) Link Distance:</b> is pretty straight forward, it is the length of the links.<br/>\n                <b>d) Link Strength:</b> In most cases, the gravity and charge will always affect the link length, the link strength gives you the flexibility of how much they can affect the link length, maxing out the like strength is like saying ALL links will be at 99% of the link length.<br/>\n                <b>e) Padding:</b> Is the minimum space you want to have between nodes<br/>\n                <h5>2.5.2) Three Icons</h5>\n                <b>a) <svg height=\"24\" width=\"24\"><path fill=\"#4A95CF\" d=\"M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z\"/></svg>Freeze/Unfreeze:</b> This allows you to toggle between having all the nodes fixed (freeze) and not fixed (unfreeze). This can be useful when you don’t want nodes to move anymore. Or another scenario can be, if you created a few collapsed nodes, and draged multiple nodes around (making them fixed) and want to redraw the map without removing the collapsed nodes. You can quickly toggle to freeze unfreeze and they will all redraw nicely.<br/>\n                <b>b) <svg height=\"24\" width=\"24\"><path fill=\"#CF2974\" d=\"M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z\"/></svg>Reset settings:</b> This will reset the settings to the default original settings. (be careful, it is not a reset nodes button, it is a reset settings button!)<br/>\n                <b>c) <svg height=\"24\" width=\"24\"><path fill=\"#422069\" d=\"M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z\"/></svg>Reset Coordinates:</b> this purple button is used to reset the coordinates to 0,0 with a zoom level of 1 (in case you lose your map)<br/>\n                <h5>2.5.3) Toggles</h5>\n                <b>a)</b> The three toggles are pretty straightforward, the two first toggles are to display the IP or Hostname on hover.<br/>\n                <b>b)</b> The third is a toggle for the search bar action. On default, the search bar selects all the nodes that return true from the search. You can also have the search to hide all the nodes that do not match the search.<br/>\n                <h5>2.5.4) Dropdowns</h5>\n                <b>a)</b> The first dropdown is to set the maximum number of rows to be displayed in the sidebar info section (2.1)<br/><b>The different values are:</b> 0, 5, 20, 50, 100, 1000, No Limit<br/>\n                <b>b)</b> The second dropdown is for the bandwidh units you want to use in the connecting nodes layer 7 list (Section 2.1.1 e).<br/><b>The different values are:</b> Bytes, KiloBytes, MegaBytes, GigaBytes, TeraBytes.<br/>\n            </div>\n\n            <div class=\"help_section\">\n                <h3>3) Searchbar</h3>\n                <h5>3.1) Possible Outcomes</h5>\n                There are two possible outcomes when it comes to using the searchbar.<br/>\n                <b>a) Default:</b>  By default, you can search on values, and have it select whatever nodes are true, greying out all none connecting nodes making it easy to find nodes.<br/>\n                <b>b) Hide:</b> Or as mentioned in section 2.5.3, you can toggle the seach to hide nodes that don't match your search, to then hide un wanted nodes. You can also use it for easy node editing. <br/>\n                Scenario, I want to group all the nodes that have used HTTP, do a quick search for 'http', click \"Select All\" in the Edit Node section (2.2) and choose the group you want them to be in.<br/>\n                <h5>3.2) Values</h5>\n                <b>a)</b> All the possible values a user can search on: IP, Hostname, Type, Group, MAC, OS, Vendor, Layer 7 Appplications (both responder and origin)<br/>\n            </div>\n        </div>\n    </div>\n</div>\n\n\n\n\n\n\n";

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _d = __webpack_require__(822);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _lodash = __webpack_require__(762);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function directive($window, timeFormat, $state, $stateParams) {
	    return {
	        transclude: true,
	        require: '^lateralmap',
	        template: __webpack_require__(825),
	        link: function link($scope, element, attrs, lmCtrl) {
	            /////////////////
	            /// VARIABLES ///
	            ///////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------
	            // Window Dimensions
	            lmCtrl.max_width = element[0].clientWidth, lmCtrl.height = angular.element($window)[0].innerHeight - 150, lmCtrl.width = lmCtrl.max_width * 0.76, lmCtrl.sidebar_width = lmCtrl.max_width * 0.22, lmCtrl.tempWidth = lmCtrl.width;
	
	            // local settings saved if a user changed it
	            if (lmCtrl.settings.get('lateral_chart_settings')) {
	                if (lmCtrl.settings.get('lateral_chart_settings')[0]) {
	                    lmCtrl.gravity = lmCtrl.settings.get('lateral_chart_settings')[0];
	                }
	                if (lmCtrl.settings.get('lateral_chart_settings')[1]) {
	                    lmCtrl.charge = lmCtrl.settings.get('lateral_chart_settings')[1];
	                }
	                if (lmCtrl.settings.get('lateral_chart_settings')[2]) {
	                    lmCtrl.link_distance = lmCtrl.settings.get('lateral_chart_settings')[2];
	                }
	                if (lmCtrl.settings.get('lateral_chart_settings')[3]) {
	                    lmCtrl.link_strength = lmCtrl.settings.get('lateral_chart_settings')[3];
	                }
	                if (lmCtrl.settings.get('lateral_chart_settings')[4]) {
	                    lmCtrl.friction = lmCtrl.settings.get('lateral_chart_settings')[4];
	                }
	                if (lmCtrl.settings.get('lateral_chart_settings')[5]) {
	                    lmCtrl.padding = lmCtrl.settings.get('lateral_chart_settings')[5];
	                }
	            }
	            // lmCtrl.alpha = lmCtrl.settings.get('lateral_chart_settings')[5];
	            // lmCtrl.maxRadius = lmCtrl.settings.get('lateral_chart_settings')[6];
	
	            // SLIDER SETTINGS
	            // slider settings for the 'settings' section in the sidebar
	            var offsetX = 15,
	                offsetY = 40,
	                slider_radius = 10,
	                slider_height = 15;
	            // need to specify width for sidebar SVGs
	            var max_x = lmCtrl.sidebar_width - offsetX * 4,
	                old_max_x = void 0;
	            // array of sliders
	            var sliders = [{ name: "gravity", min: 0.0001, max: 1, x: 0, y: 0, default: lmCtrl.gravity }, { name: "charge", min: -5000, max: -1, x: 0, y: 0, default: lmCtrl.charge }, { name: "link_distance", min: 1, max: 500, x: 0, y: 0, default: lmCtrl.link_distance }, { name: "link_strength", min: 0.0001, max: 1, x: 0, y: 0, default: lmCtrl.link_strength }, { name: "friction", min: 0.0001, max: 1, x: 0, y: 0, default: lmCtrl.friction }, { name: "padding", min: 2, max: 50, x: 0, y: 0, default: lmCtrl.padding }];
	
	            // COLLAPSE
	            // collision section (4 circles to select)
	            var collapse_hide = 0; // 0 = select, 1 = collapse, 2 = hide, 3 = only show
	            var background_radius = 18;
	            // array of different type of collapse (grouping)
	            var circles_collapse = [{ value: 0, name: "Select", offsetX: background_radius + 2 }, { value: 1, name: "Collapse", offsetX: max_x / 3 + background_radius }, { value: 2, name: "Hide", offsetX: max_x * 2 / 3 + background_radius / 2 }, { value: 3, name: "Show", offsetX: max_x }];
	
	            // When a Collpased node is created, this is the default blank object
	            var defaultCollapsedNode = {
	                id: false,
	                ip: [],
	                hostname: [],
	                connections: [],
	                mac: [],
	                os: [],
	                vendor: [],
	                group: [],
	                group_name: [],
	                type: [],
	                resp_l7: [],
	                orig_l7: [],
	                collapse: true,
	                action: false,
	                ioc: 0,
	                weight: 0,
	                selected: false,
	                grey: false,
	                visible: true,
	                radius: lmCtrl.maxRadius * 2,
	                x: lmCtrl.width / 2,
	                y: lmCtrl.height / 2,
	                px: lmCtrl.width / 2,
	                py: lmCtrl.height / 2
	
	                // used for sorting the sidear node info (what columns and direction)
	            };var temp_sort = "weight";
	            var desc = true;
	
	            // $SCOPE VARIABLES (so they can interact with angular)
	            $scope.groups = {}; // object of all the possible groups available
	            // $scope.show_info = true; // display the node info titles (when zero hide title)
	
	            // Array of all the possible Node Types
	            $scope.types = ['Access Point', 'Database', 'Desktop', 'DHCP Server', 'DNS Server', 'Domain Controller', 'Endpoint', 'File Server', 'Gateway', 'Laptop', 'Mobile', 'Phone', 'Printer', 'Server', 'Switch', 'Web Server'];
	            // The current group and node group & type used for sidebar
	            $scope.current = {
	                node: {
	                    ip: "",
	                    type: "N/A",
	                    group: "N/A"
	                },
	                group: {
	                    id: false,
	                    name: "",
	                    color: "#000000"
	                }
	            };
	            $scope.showSelectAll = true;
	            $scope.selected_nodes = [];
	            // object for the bandwidth dropdown in the settings section of the sidebar
	            $scope.diff_bandwidth = {
	                b: { select: "b", value: 1, text: "Bytes", acronym: "B" },
	                kb: { select: "kb", value: 1024, text: "Kilobytes", acronym: "KB" },
	                mb: { select: "mb", value: 1048576, text: "Megabytes", acronym: "MB" },
	                gb: { select: "gb", value: 1073741824, text: "Gigabyte", acronym: "GB" },
	                tb: { select: "tb", value: 1099511627776, text: "Terabyte", acronym: "TB" }
	                // the current bandwidth selected
	            };$scope.bandwidth = "mb";
	            if (lmCtrl.settings.get('lateral_chart_bandwidth')) {
	                $scope.bandwidth = lmCtrl.settings.get('lateral_chart_bandwidth');
	            }
	            // Object for the node info limit (max number of nodes to be displayed)
	            $scope.sidebar_limits = [{ value: 0, text: "0" }, { value: 5, text: "5" }, { value: 20, text: "20" }, { value: 50, text: "50" }, { value: 100, text: "100" }, { value: 1000, text: "1000" }, { value: false, text: "No Limit" }];
	            // the selected node info limit
	            $scope.max_rows = "false";
	            if (lmCtrl.settings.get('lateral_chart_max_rows')) {
	                $scope.max_rows = lmCtrl.settings.get('lateral_chart_max_rows');
	            }
	            $scope.display_ip = "true";
	            if (lmCtrl.settings.get('display_ip')) {
	                $scope.display_ip = lmCtrl.settings.get('display_ip');
	            }
	            $scope.display_hostname = false;
	            if (lmCtrl.settings.get('display_hostname')) {
	                $scope.display_hostname = lmCtrl.settings.get('display_hostname');
	            }
	            $scope.hide_on_search = false;
	            if (lmCtrl.settings.get('hide_on_search')) {
	                $scope.hide_on_search = lmCtrl.settings.get('hide_on_search');
	            }
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	
	            //////////////
	            /// EVENTS ///
	            ////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------
	            // Gets all the groups from the controller
	            // Once group is saved in the back end, it then has to save it for the current page
	            lmCtrl.setGroups = function (groups) {
	                var g = void 0;
	                for (g in groups) {
	                    $scope.groups[groups[g].id] = groups[g];
	                }
	            };
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	
	            ///////////////
	            /// SIDEBAR ///
	            /////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
	            // SIDEBAR TOGGLE
	            // Sidebar SVGs and toggle for show / hide sidebar
	            var sidebar = d3.select("#sidebar").style("max-width", lmCtrl.sidebar_width + "px");
	            var sidebar_svg = d3.select("#sidebar #sidebr_svg").attr("height", "0").attr("width", lmCtrl.sidebar_width).attr("stroke-width", "0");
	            var sidebar_content = d3.select("#sidebar_content").style("max-height", lmCtrl.height - 50 + "px");
	
	            var arrow_title = d3.selectAll(".arrow_title").append("svg").attr("height", "24").attr("width", "24").attr("fill", "#333333").append("path").attr('d', "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z");
	
	            $scope.toggleShow = function (divID) {
	                if (d3.select("#" + divID + "_content").classed("hide_section")) {
	                    d3.select("#" + divID + "_content").classed("hide_section", false);
	                    d3.select("#" + divID + " .sidebar_title").classed("selected", true);
	                    d3.select("#" + divID + " .arrow_title svg path").attr('d', "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z");
	                } else {
	                    d3.select("#" + divID + "_content").classed("hide_section", true);
	                    d3.select("#" + divID + " .sidebar_title").classed("selected", false);
	                    d3.select("#" + divID + " .arrow_title svg path").attr('d', "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z");
	                }
	                lmCtrl.drawSidebar();
	            };
	
	            $scope.toggleSidebar = function (divID) {
	                if (d3.select("#" + divID).classed("hide_section")) {
	                    d3.select("#" + divID).classed("hide_section", false);
	                    d3.select("#sidebar_collapse").classed("hide_section", true);
	                } else {
	                    d3.select("#sidebar_collapse").classed("hide_section", false);
	                    d3.select("#" + divID).classed("hide_section", true);
	                }
	                lmCtrl.resize_map();
	            };
	
	            // NODE INFO - list all nodes, shows L7 between nodes, shows selected node (if only 1 node selected)
	            var node_info = d3.select("#node_info_rows");
	
	            function sortBy(a, b) {
	                if (desc) {
	                    if (a[temp_sort] !== "N/A" && b[temp_sort] === "N/A") return 1;
	                    if (a[temp_sort] > b[temp_sort]) return -1;
	                    if (a[temp_sort] < b[temp_sort]) return 1;
	                } else {
	                    if (a[temp_sort] !== "N/A" && b[temp_sort] === "N/A") return -1;
	                    if (a[temp_sort] < b[temp_sort]) return -1;
	                    if (a[temp_sort] > b[temp_sort]) return 1;
	                }
	                return 0;
	            }
	            // sorts the sidebar depending on the column that is selected
	            $scope.sortBy = function (by) {
	                temp_sort = by;
	                lmCtrl.nodes.sort(sortBy);
	                if (desc) {
	                    desc = false;
	                } else {
	                    desc = true;
	                }
	                lmCtrl.drawSidebar();
	            };
	
	            // this function is to display the L7s between two IPs, and if no node is selected to just seleted the node
	            function between_two(elm, node) {
	                var obj = { resp: {}, orig: {} },
	                    sel_ip = void 0,
	                    temp_sel_ip = [],
	                    temp_node_ip = [];
	                // creating the the L7 resp and orig to be able to tell the difference
	                if ($scope.selected_nodes.length === 1) {
	                    sel_ip = $scope.selected_nodes[0].ip;
	                    node = angular.copy(node);
	                    if (typeof sel_ip === "string") {
	                        temp_sel_ip.push(sel_ip);
	                    } else {
	                        temp_sel_ip = sel_ip;
	                        sel_ip = false;
	                    }
	                    if (typeof node.ip === "string") {
	                        temp_node_ip.push(node.ip);
	                    } else {
	                        temp_node_ip = node.ip;
	                        node.ip = false;
	                    }
	                    for (var i in temp_node_ip) {
	                        for (var si in temp_sel_ip) {
	                            if (lmCtrl.l7_between_nodes[temp_sel_ip[si]] && lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]]) {
	                                for (var l7_resp in lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]]) {
	                                    if (obj.resp[l7_resp]) {
	                                        obj.resp[l7_resp].bytes += lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]][l7_resp].bytes;
	                                    } else {
	                                        obj.resp[l7_resp] = lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]][l7_resp];
	                                    }
	                                }
	                            }
	                            if (lmCtrl.l7_between_nodes[temp_node_ip[i]] && lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]]) {
	                                for (var l7_orig in lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]]) {
	                                    if (obj.orig[l7_orig]) {
	                                        obj.orig[l7_orig].bytes += lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]][l7_orig].bytes;
	                                    } else {
	                                        obj.orig[l7_orig] = lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]][l7_orig];
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                // TODO: REFACTOR THIS SHIT!
	                var arr_resp = _.values(obj.resp);
	                var arr_orig = _.values(obj.orig);
	                node_info.selectAll('.node_l7').remove();
	                if (d3.select(elm).classed("expand")) {
	                    d3.selectAll(".node_sidebar").classed("expand", null);
	                } else if (arr_resp.length > 0 || arr_orig.length > 0) {
	                    d3.selectAll(".node_sidebar").classed("expand", null);
	                    d3.select(elm).classed("expand", true);
	                    var l7_table = d3.select(elm).append("div").classed("l7_table", true).append("table").classed("node_l7", true);
	                    var l7_table_title = l7_table.append("tr").on("click", d3.event.stopPropagation());
	                    l7_table_title.append("th").text("Dir");
	                    l7_table_title.append("th").text("L7 App");
	                    l7_table_title.append("th").text("Proto");
	                    l7_table_title.append("th").text("Service");
	                    l7_table_title.append("th").text("BW");
	                    append_l7("Resp", l7_table, arr_resp, sel_ip, node.ip);
	                    append_l7("Orig", l7_table, arr_orig, node.ip, sel_ip);
	                } else {
	                    lmCtrl.nodeClicked(node);
	                }
	            }
	
	            function append_l7(type, elm, arr, resp_ip, orig_ip) {
	                var append_l7 = elm.selectAll('.l7_rows').data(arr).enter().append("tr").classed('l7_rows', true).on("click", function (d) {
	                    d3.event.stopPropagation();
	                    addAllToFilter(d.l7, d.proto, d.service, resp_ip, orig_ip);
	                });
	                append_l7.append("td").text(type);
	                append_l7.append("td").text(function (d) {
	                    return d.l7 === "N/A" ? "-" : d.l7;
	                });
	                append_l7.append("td").text(function (d) {
	                    return d.proto === "N/A" ? "-" : d.proto;
	                });
	                append_l7.append("td").text(function (d) {
	                    return d.service === "N/A" ? "-" : d.service;
	                });
	                append_l7.append("td").text(function (d) {
	                    return Math.round(d.bytes / $scope.diff_bandwidth[$scope.bandwidth].value * 1000) / 1000 + " " + $scope.diff_bandwidth[$scope.bandwidth].acronym;
	                });
	            }
	
	            function addAllToFilter(l7, proto, service, resp_ip, orig_ip) {
	                lmCtrl.main.clearFilters();
	                $scope.$apply(function () {
	                    if (l7) {
	                        addToFilterList("include", l7, 'l7_app', "Layer 7 Application");
	                    }
	                    if (proto) {
	                        addToFilterList("include", proto, 'proto', "Protocol");
	                    }
	                    if (service) {
	                        addToFilterList("include", service, 'service', "Service");
	                    }
	                    if (resp_ip) {
	                        addToFilterList("include", resp_ip, 'resp_ip', "Responder IP");
	                    }
	                    if (orig_ip) {
	                        addToFilterList("include", orig_ip, 'orig_ip', "Origin IP");
	                    }
	                });
	            }
	
	            // adds L7 filters to the search bar to be used to send to the search page (does not actually filter on nodes)
	            function addToFilterList(action, value, column, columnTitle) {
	                lmCtrl.main.addFilter(column, value, action, true, columnTitle);
	            }
	
	            // draws the sidebar info list, only shows number of max rows, and connecting node once selected
	            lmCtrl.drawSidebar = function () {
	                var count = 0;
	                var sidebar_nodes = lmCtrl.nodes;
	                sidebar_nodes = lmCtrl.nodes.filter(function (d) {
	                    if ($scope.max_rows !== "false" && count >= $scope.max_rows) return false;
	                    if (d.visible && !d.grey) {
	                        count++;
	                        return !d.selected;
	                    }
	                });
	                node_info.selectAll('.node_sidebar').remove();
	                var node_sidebar = node_info.selectAll('.node_sidebar').data(sidebar_nodes);
	                node_sidebar = node_sidebar.enter().append("div").classed('node_sidebar', true).on("click", function (d) {
	                    if ($scope.selected_nodes.length == 1 && !lmCtrl.ctrlKey) {
	                        between_two(this, d);
	                    } else {
	                        d.selected = true;
	                        lmCtrl.nodeClicked(d);
	                    }
	                });
	                var node_list = node_sidebar.append("div").classed('node_list', true);
	                node_list.append("span").classed("nl_type", true)
	                // .style("opacity", d => (d.grey) ? "0.25" : "1") dont need this since we hide non-connecting nodes
	                .style("background-color", function (d) {
	                    return "none";
	                    // if (d.collapse) {
	                    //     if (d.action === "ioc") return lmCtrl.color(d.ioc)
	                    //     if (d.group.length === 1) return lmCtrl.color(d.group[0])
	                    //     return "#333"
	                    // }
	                    // return lmCtrl.color(d.group)
	                }).append("svg").attr("width", "25px").attr("height", "25px").attr('transform', "translate(0,0)scale(1)").append('path').attr('transform', function (d) {
	                    if (d.collapse) return svg_translate_sidebar(d.action);
	                    return svg_translate_sidebar(d.type);
	                }).attr('d', function (d) {
	                    if (d.collapse) return lmCtrl.svgType(d.action);
	                    return lmCtrl.svgType(d.type);
	                }).attr('fill', function (d) {
	                    if (d.collapse) {
	                        if (d.action === "ioc") return lmCtrl.color(d.ioc);
	                        if (d.group.length === 1) return lmCtrl.color(d.group[0]);
	                        return "#333";
	                    }
	                    return lmCtrl.color(d.group);
	                });
	                node_list.append("span").classed("nl_ip", true).text(function (d) {
	                    if (d.collapse) return d.ip.length === 1 ? "1 Node" : d.ip.length + " Nodes";
	                    return d.ip;
	                });
	                node_list.append("span").classed("nl_hostname", true).text(function (d) {
	                    if (d.collapse) return "Collapsed Node";
	                    return d.hostname == 'N/A' ? "-" : d.hostname;
	                });
	                node_list.append("span").classed("nl_conn_count", true).text(function (d) {
	                    if (!d.collapse) return d.weight;
	                });
	            };
	            // SVGs in the node info list all need different transition
	            function svg_translate_sidebar(type) {
	                switch (type) {
	                    case 'Switch':
	                        return 'translate(1,4)scale(0.9)';
	                    case 'Server':
	                    case 'DNS Server':
	                        return 'translate(3,5)scale(0.75)';
	                    case 'Domain Controller':
	                        return 'translate(4,5)scale(0.2)';
	                    case 'File Server':
	                        return 'translate(2,5)scale(0.85)';
	                    case 'Database':
	                        return 'translate(5,5)scale(0.02)';
	                    case 'Web Server':
	                        return 'translate(2,4)scale(0.85)';
	                    case 'Mobile':
	                        return 'translate(2,5)scale(0.8)';
	                    case 'Laptop':
	                        return 'translate(3,4)scale(0.8)';
	                    case 'Desktop':
	                        return 'translate(3,5)scale(0.75)';
	                    case 'DHCP Server':
	                        return 'translate(4,5)scale(0.85)';
	                    case 'Endpoint':
	                        return 'translate(1,4)scale(0.8)';
	                    case 'type':
	                    case 'cluster':
	                    case 'new':
	                    case 'Domain Controller':
	                        return 'translate(1,3)scale(1)';
	                    case 'Gateway':
	                        return 'translate(0.5,2)scale(1)';
	                    case 'Phone':
	                        return 'translate(0,3)scale(1)';
	                    case 'selected':
	                    case 'connecting':
	                        return 'translate(1,4)scale(1)';
	                    case 'Printer':
	                    case 'group':
	                    case 'ioc':
	                    case 'Access Point':
	                        return 'translate(1,2)scale(1)';
	                    default:
	                        return 'translate(3,5)scale(0.8)';
	                }
	            }
	            // adds the IP to the search bar
	            $scope.addIpToSearch = function (ip) {
	                lmCtrl.main.clearFilters();
	                addToFilterList("include", ip, 'all', "All");
	            };
	
	            // EDIT NODE - able to save node types and groups
	            // Saves the node info (group/type) depending what is set in the sidebar.
	            // It saves all the nodes that are selected
	            $scope.save_node = function (clear) {
	                var type = $scope.current.node.type;
	                var group = $scope.current.node.group;
	                if (clear) {
	                    type = "N/A";
	                    group = "N/A";
	                }
	                if (type === "new") {
	                    type = "N/A";
	                }
	
	                if (type == "false" && group == "false") {
	                    alert('You need to at least select a type or group');
	                } else {
	                    var selected_ips = [];
	                    var already_exist = "(";
	                    var new_nodes = $scope.selected_nodes.filter(function (d) {
	                        if (d.collapse) {
	                            return false;
	                        }
	                        if (selected_ips.indexOf(d.ip) === -1) {
	                            selected_ips.push(d.ip);
	                        }
	                        if (!d.id) {
	                            if (type == "false") d.type = "N/A";
	                            if (group == "false") d.group = "N/A";
	                            return true;
	                        } else {
	                            already_exist += "'" + d.ip + "',";
	                        }
	                    });
	                    already_exist = _.trimEnd(already_exist, ",");
	                    already_exist += ")";
	
	                    var i = void 0;
	                    for (i in lmCtrl.nodes_object) {
	                        lmCtrl.nodes_object[i].selected = false;
	                        lmCtrl.nodes_object[i].grey = false;
	                        if (_.indexOf(selected_ips, lmCtrl.nodes_object[i].ip) > -1 && lmCtrl.nodes_object[i].visible && !lmCtrl.nodes_object[i].collapsed) {
	                            if (!lmCtrl.nodes_object[i].id) lmCtrl.nodes_object[i].id = true;
	                            if (type != "false") lmCtrl.nodes_object[i].type = type;
	                            if (group != "false") lmCtrl.nodes_object[i].group = group;
	                        }
	                    }
	                    if (already_exist !== "()" || new_nodes.length > 0) {
	                        lmCtrl.saveNodeInfo(type, group, already_exist, new_nodes);
	                        $scope.current.node = {
	                            type: "false",
	                            group: "false"
	                        };
	                        lmCtrl.redraw();
	                        $scope.selected_nodes = lmCtrl.getSelectedNodes();
	                    }
	                }
	            };
	            // selects all the visible ndoes (etc. used for after a search)
	            $scope.selectAll = function () {
	                if ($scope.showSelectAll) {
	                    $scope.showSelectAll = false;
	                } else {
	                    $scope.showSelectAll = true;
	                }
	                var n = void 0;
	                for (n in lmCtrl.nodes_object) {
	                    if (lmCtrl.nodes_object[n].visible) {
	                        lmCtrl.nodes_object[n].selected = true;
	                        lmCtrl.nodes_object[n].grey = false;
	                    } else {
	                        lmCtrl.nodes_object[n].selected = false;
	                        lmCtrl.nodes_object[n].grey = false;
	                    }
	                }
	                $scope.selected_nodes = lmCtrl.getSelectedNodes();
	                $scope.current.node.type = "false";
	                $scope.current.node.group = "false";
	                lmCtrl.redrawing();
	            };
	            $scope.unselectAll = function () {
	                if ($scope.showSelectAll) {
	                    $scope.showSelectAll = false;
	                } else {
	                    $scope.showSelectAll = true;
	                }
	                var n = void 0;
	                for (n in lmCtrl.nodes_object) {
	                    lmCtrl.nodes_object[n].selected = false;
	                    lmCtrl.nodes_object[n].grey = false;
	                }
	                $scope.selected_nodes = lmCtrl.getSelectedNodes();
	                $scope.current.node.type = "N/A";
	                $scope.current.node.group = "N/A";
	                lmCtrl.redrawing();
	            };
	
	            // GROUP CREATION - able to create/edit/delete groups
	            // sets the selected group
	            $scope.group_selected = function (d) {
	                var group = angular.copy($scope.groups[$scope.current.selected]);
	                $scope.current.group.id = group.id;
	                $scope.current.group.name = group.name;
	                $scope.current.group.color = group.color;
	            };
	
	            // Obviously clears the group (used if you selected a group then decide you want to create a new one)
	            $scope.clear_group = function () {
	                clear_group();
	            };
	            function clear_group() {
	                $scope.current.selected = "";
	                $scope.current.group.id = false;
	                $scope.current.group.name = "";
	                $scope.current.group.color = "#000000";
	            }
	
	            // This is used to create/edit a group, if it is editing a group, it will re save all the nodes that is part of that group
	            // TODO: if save by ID can remove the associated ones (gotta figure out is saving by ID or name)
	            $scope.create_group = function () {
	                if ($scope.current.group.name !== "") {
	                    var associated_nodes = nodes_associated();
	                    if (associated_nodes) {
	                        lmCtrl.editAssociatedGroups(associated_nodes, $scope.current.group.id);
	                    }
	                    lmCtrl.createEditGroup($scope.current.group, function (id) {
	                        if (id) {
	                            $scope.groups[id] = angular.copy($scope.current.group);
	                            $scope.groups[id].id = id;
	                        } else {
	                            $scope.groups[$scope.current.group.id] = angular.copy($scope.current.group);
	                        }
	                        clear_group();
	                        lmCtrl.redraw();
	                    });
	                }
	            };
	            // this will delete a group, and if that group is assigned to a node it will remove (set it to null)
	            $scope.delete_group = function () {
	                var associated_nodes = nodes_associated();
	                if (associated_nodes) {
	                    lmCtrl.editAssociatedGroups(associated_nodes, null);
	                }
	                lmCtrl.deleteGroup($scope.current.group.id);
	                delete $scope.groups[$scope.current.group.id];
	                clear_group();
	                lmCtrl.redraw();
	            };
	            // returns a string array of all the associated IPs to a group, used cassandra string (ex: where ip in ('nodes_associated'))
	            function nodes_associated() {
	                if (!$scope.current.group.id) {
	                    return false;
	                }
	                var allGroupNodes = "(";
	                var a = void 0,
	                    match = false;
	                for (a in lmCtrl.allNodes) {
	                    if (lmCtrl.allNodes[a].group === $scope.current.group.id) {
	                        match = true;
	                        allGroupNodes += "'" + lmCtrl.allNodes[a].ip + "',";
	                    }
	                }
	                if (!match) {
	                    return false;
	                }
	                allGroupNodes = _.trimEnd(allGroupNodes, ",");
	                return allGroupNodes += ")";
	            }
	
	            // FILTER
	            // TODO: for future
	
	            // COLLAPSE - able to select, collapse, hide, show nodes depending on what you chose (IOC, type, group, cluster, selected, or connecting nodes)
	            var collapse_toggle = d3.select("#collapse_toggle").attr('transform', 'translate(0, 0)').attr("width", lmCtrl.sidebar_width - background_radius * 2).attr("height", "65");
	
	            var collapse_line = collapse_toggle.append("path").classed("slider_line", true).attr("transform", "translate(5, 0)").attr("d", "M5 20 l" + max_x + " 0");
	
	            var collapse_select = collapse_toggle.selectAll('.select_circles').data(circles_collapse).enter().append("g").classed("select_circles", true).classed("selected", function (d) {
	                if (collapse_hide === d.value) return true;
	                return null;
	            }).attr('transform', function (d) {
	                return 'translate(' + d.offsetX + ', ' + (background_radius + 2) + ')';
	            }).on("click", function (d) {
	                collapse_toggle.selectAll('.select_circles').classed("selected", null);
	                collapse_hide = d.value;
	                d3.select(this).classed("selected", true);
	            });
	
	            collapse_select.append("circle").attr("r", background_radius);
	
	            collapse_select.append("text").classed("slider_collapse_text", true).attr('transform', 'translate(0, 0)').attr("y", background_radius * 2 - 3).text(function (d) {
	                return d.name;
	            });
	            // select, collapse, hide, show all IOCs
	            $scope.show_hide_ioc = function (action) {
	                var n = void 0,
	                    arr = [];
	                for (n in lmCtrl.nodes_object) {
	                    if (lmCtrl.nodes_object[n].visible) {
	                        if (lmCtrl.nodes_object[n].ioc > 0) {
	                            arr = _.uniq(_.concat(arr, lmCtrl.nodes_object[n].ip));
	                        }
	                    }
	                }
	                if (arr.length === 0) {
	                    alert("There are no IOCs");
	                    return;
	                }
	                switch (collapse_hide) {
	                    case 3:
	                        showOnlyIOC(arr);
	                        break;
	                    case 2:
	                        hideIOC(arr);
	                        break;
	                    case 1:
	                        var newNode = angular.copy(defaultCollapsedNode);
	                        newNode.action = "ioc";
	                        newNode.id = guid();
	                        newNode = lmCtrl.newNode(newNode);
	                        lmCtrl.nodes_object[newNode.id] = newNode;
	                        var _n = void 0;
	                        for (_n in lmCtrl.nodes_object) {
	                            if (!lmCtrl.nodes_object[_n].collapse) {
	                                if (lmCtrl.nodes_object[_n].ioc > 0 && _.indexOf(lmCtrl.already_collapsed_ips, lmCtrl.nodes_object[_n].ip) === -1) {
	                                    collapse_to_node(newNode, _n);
	                                }
	                            }
	                        }
	                        break;
	                    default:
	                        selectIOC(arr);
	                        break;
	                }
	                lmCtrl.redraw();
	            };
	            // select, collapse, hide, show all selected IPs depending and what is clicked
	            // It can be 'grouped' on type, group, cluster, selected, connecting
	            $scope.collapse = function (action) {
	                $scope.selected_nodes = lmCtrl.getSelectedNodes();
	                var n = $scope.selected_nodes.length,
	                    arr = [],
	                    by = "";;
	                if (n === 0) {
	                    return;
	                }
	                switch (action) {
	                    case "selected":
	                        by = 'ip';
	                        break;
	                    case "type":
	                        by = 'type';
	                        break;
	                    case "group":
	                        by = 'group';
	                        break;
	                    case "cluster":
	                        by = 'ip';
	                        break;
	                    case "connecting":
	                        by = 'ip';
	                        break;
	                }
	
	                while (n--) {
	                    if (!$scope.selected_nodes[n].collapse) {
	                        if (action === "connecting") {
	                            arr = _.uniq(_.concat(arr, $scope.selected_nodes[n].ip));
	                            arr = _.uniq(_.concat(arr, lmCtrl.nodes_object[$scope.selected_nodes[n][by]].connections));
	                        } else if (action === "cluster") {
	                            arr = _.uniq(_.concat(arr, $scope.selected_nodes[n][by]));
	                            arr = goDownTree($scope.selected_nodes[n][by], arr);
	                        } else {
	                            arr = _.uniq(_.concat(arr, $scope.selected_nodes[n][by]));
	                        }
	                    }
	                }
	                if (_.includes(arr, "N/A")) {
	                    arr = _.uniq(_.concat(arr, null));
	                }
	                if (_.includes(arr, null)) {
	                    arr = _.uniq(_.concat(arr, "N/A"));
	                }
	
	                switch (collapse_hide) {
	                    case 3:
	                        showOnly(by, arr);
	                        break;
	                    case 2:
	                        hide(by, arr);
	                        break;
	                    case 1:
	                        collapse(by, arr, action);
	                        break;
	                    default:
	                        select(by, arr);
	                        break;
	                }
	                $scope.selected_nodes = lmCtrl.getSelectedNodes();
	                $scope.current.node = {
	                    type: "false",
	                    group: "false"
	                };
	                lmCtrl.redraw();
	            };
	            // recursive function that and array for all the nodes in a cluster
	            function goDownTree(ip, arr) {
	                var a;
	                for (a in lmCtrl.nodes_object[ip].connections) {
	                    if (arr.indexOf(lmCtrl.nodes_object[ip].connections[a]) === -1) {
	                        arr.push(lmCtrl.nodes_object[ip].connections[a]);
	                        goDownTree(lmCtrl.nodes_object[ip].connections[a], arr);
	                    }
	                }
	                return arr;
	            }
	            // genereates a random ID for the collapsed node to use as key in the nodes_object
	            function guid() {
	                function s4() {
	                    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	                }
	                return s4() + s4() + s4();
	            }
	            // collapses all the nodes associated to the collapsed node (also hides it when it is 'put' in the collapsed node)
	            function collapse_to_node(newNode, n) {
	                lmCtrl.nodes_object[n].visible = false;
	                lmCtrl.already_collapsed_ips = _.uniq(_.concat(lmCtrl.already_collapsed_ips, n));
	                newNode.ip = _.uniq(_.concat(newNode.ip, n));
	                newNode.connections = _.uniq(_.concat(newNode.connections, lmCtrl.nodes_object[n].connections));
	                newNode.resp_l7 = _.uniq(_.concat(newNode.resp_l7, lmCtrl.nodes_object[n].resp_l7));
	                newNode.orig_l7 = _.uniq(_.concat(newNode.orig_l7, lmCtrl.nodes_object[n].orig_l7));
	                newNode.group = _.uniq(_.concat(newNode.group, lmCtrl.nodes_object[n].group));
	                newNode.type = _.uniq(_.concat(newNode.type, lmCtrl.nodes_object[n].type));
	                newNode.hostname = _.uniq(_.concat(newNode.hostname, lmCtrl.nodes_object[n].hostname));
	                newNode.mac = _.uniq(_.concat(newNode.mac, lmCtrl.nodes_object[n].mac));
	                newNode.os = _.uniq(_.concat(newNode.os, lmCtrl.nodes_object[n].os));
	                newNode.vendor = _.uniq(_.concat(newNode.vendor, lmCtrl.nodes_object[n].vendor));
	                newNode.ioc = Math.max(newNode.ioc, lmCtrl.nodes_object[n].ioc);
	                if ($scope.groups[lmCtrl.nodes_object[n].group]) {
	                    newNode.group_name = _.uniq(_.concat(newNode.group_name, $scope.groups[lmCtrl.nodes_object[n].group].name));
	                } else {
	                    newNode.group_name = _.uniq(_.concat(newNode.group_name, "N/A"));
	                }
	                // ADD COLLAPSED NODE TO CONNECTIONS
	                for (var a in lmCtrl.nodes_object[n].connections) {
	                    if (lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]].visible) {
	                        if (!lmCtrl.allLinks[newNode.id + "-" + lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]].ip]) {
	                            lmCtrl.allLinks[newNode.id + "-" + lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]].ip] = true;
	                            var newLink = lmCtrl.newLink(newNode, lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]]);
	                            lmCtrl.links.push(newLink);
	                        }
	                    }
	                }
	            }
	            // once an array is made, all the nodes in that array will be hidden and all the information will be passed to this new collapsed node
	            function collapse(by, arr, action) {
	                if (arr.length > 0) {
	                    var newNode = angular.copy(defaultCollapsedNode);
	                    newNode.action = action;
	                    newNode.id = guid();
	                    newNode = lmCtrl.newNode(newNode);
	                    lmCtrl.nodes_object[newNode.id] = newNode;
	                    var n = void 0;
	                    for (n in lmCtrl.nodes_object) {
	                        lmCtrl.nodes_object[n].selected = false;
	                        lmCtrl.nodes_object[n].grey = false;
	                        if (!lmCtrl.nodes_object[n].collapse) {
	                            if (_.indexOf(arr, lmCtrl.nodes_object[n][by]) > -1 && _.indexOf(lmCtrl.already_collapsed_ips, n) === -1) {
	                                collapse_to_node(newNode, n);
	                            }
	                        } else {
	                            // if collapsed node
	                            if (lmCtrl.nodes_object[n].visible && newNode.visible) {
	                                if (_.intersection(lmCtrl.nodes_object[n].connections, newNode.ip).length > 0) {
	                                    if (!lmCtrl.allLinks[newNode.id + "-" + lmCtrl.nodes_object[n].ip]) {
	                                        lmCtrl.allLinks[newNode.id + "-" + lmCtrl.nodes_object[n].ip] = true;
	                                        var newLink = lmCtrl.newLink(newNode, lmCtrl.nodes_object[n]);
	                                        lmCtrl.links.push(newLink);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            // once an array is made, only the nodes in that array will be shown, hidding the rest
	            function showOnlyIOC(arr) {
	                var n = void 0;
	                for (n in lmCtrl.nodes_object) {
	                    if (lmCtrl.nodes_object[n].visible) {
	                        if (_.indexOf(arr, lmCtrl.nodes_object[n].ip) > -1) {
	                            lmCtrl.nodes_object[n].visible = true;
	                        } else {
	                            lmCtrl.nodes_object[n].visible = false;
	                        }
	                    }
	                }
	            }
	            // once an array is made, all the nodes in that array will be hidden, showing the rest of the nodes
	            function hideIOC(arr) {
	                var n = void 0;
	                for (n in lmCtrl.nodes_object) {
	                    if (lmCtrl.nodes_object[n].visible) {
	                        if (_.indexOf(arr, lmCtrl.nodes_object[n].ip) > -1) {
	                            lmCtrl.nodes_object[n].visible = false;
	                        }
	                    }
	                }
	            }
	            // once an array is made, all the nodes in that array will be selected, unselecting the rest
	            function selectIOC(arr) {
	                var n = void 0;
	                for (n in lmCtrl.nodes_object) {
	                    if (lmCtrl.nodes_object[n].visible) {
	                        if (_.indexOf(arr, lmCtrl.nodes_object[n].ip) > -1) {
	                            if (lmCtrl.nodes_object[n].ioc > 0) {
	                                lmCtrl.nodes_object[n].selected = true;
	                            } else {
	                                lmCtrl.nodes_object[n].selected = false;
	                            }
	                        } else {
	                            lmCtrl.nodes_object[n].selected = false;
	                        }
	                    }
	                }
	                lmCtrl.greyOut();
	            }
	            // once an array is made, only the nodes in that array will be shown, hidding the rest
	            function showOnly(by, arr) {
	                if (arr.length > 0) {
	                    var n = void 0;
	                    for (n in lmCtrl.nodes_object) {
	                        lmCtrl.nodes_object[n].selected = false;
	                        lmCtrl.nodes_object[n].grey = false;
	                        if (_.indexOf(arr, lmCtrl.nodes_object[n][by]) === -1) {
	                            lmCtrl.nodes_object[n].visible = false;
	                        }
	                    }
	                }
	            }
	            // once an array is made, all the nodes in that array will be hidden, showing the rest of the nodes
	            function hide(by, arr) {
	                if (arr.length > 0) {
	                    var n = void 0;
	                    for (n in lmCtrl.nodes_object) {
	                        lmCtrl.nodes_object[n].selected = false;
	                        lmCtrl.nodes_object[n].grey = false;
	                        if (_.indexOf(arr, lmCtrl.nodes_object[n][by]) > -1) {
	                            lmCtrl.nodes_object[n].visible = false;
	                        }
	                    }
	                }
	            }
	            // once an array is made, all the nodes in that array will be selected, unselecting the rest
	            function select(by, arr) {
	                if (arr.length > 0) {
	                    var n = void 0;
	                    for (n in lmCtrl.nodes_object) {
	                        if (lmCtrl.nodes_object[n].visible) {
	                            if (_.indexOf(arr, lmCtrl.nodes_object[n][by]) > -1) {
	                                lmCtrl.nodes_object[n].selected = true;
	                            }
	                        }
	                    }
	                }
	                lmCtrl.greyOut();
	            }
	            // resets the nodes back to when it had its original load
	            $scope.reset = function () {
	                lmCtrl.nodes = lmCtrl.nodes.filter(function (d) {
	                    return _typeof(d.ip) !== "object";
	                });
	                lmCtrl.links = lmCtrl.links.filter(function (d) {
	                    return _typeof(d.source.ip) !== "object" && _typeof(d.target.ip) !== "object";
	                });
	                resetAllNodes();
	                lmCtrl.main.clearFilters();
	                $scope.selected_nodes = lmCtrl.getSelectedNodes();
	                $scope.current.node = {
	                    type: "N/A",
	                    group: "N/A"
	                };
	            };
	
	            // resets all the nodes to its original nodes array, removing any collapsed node, making all visible, none grey, not selected and not fixed
	            function resetAllNodes() {
	                lmCtrl.already_collapsed_ips = [];
	                var no = void 0;
	                for (no in lmCtrl.nodes_object) {
	                    if (lmCtrl.nodes_object[no].collapse) {
	                        delete lmCtrl.nodes_object[no];
	                    } else {
	                        lmCtrl.nodes_object[no].selected = false;
	                        lmCtrl.nodes_object[no].visible = true;
	                        lmCtrl.nodes_object[no].grey = false;
	                        lmCtrl.nodes_object[no].fixed = false;
	                    }
	                }
	                lmCtrl.redraw();
	            }
	
	            // SETTINGS - Able to change the forcechart settings depending on what structure your node tree looks like, every network can have different settings
	            // all the following can be changed and saved as local settings for the next time that KEYSPACE uses the page
	            // - gravity, charge, link distance, link strength, friction, sidebar node info limit, what units L7 bandwidth to be shown
	            // can also freeze / unfreeze the chart
	            // can also reset the original default settings
	            var slider_drag = d3.drag().subject(Object).on("drag", drag_slider).on('end', drag_slider_end);
	
	            var slider_settings = d3.select("#slider_settings").attr('transform', 'translate(0, 0)').attr('width', lmCtrl.sidebar_width - offsetX * 2).attr('height', 49 * sliders.length);
	
	            // creates all the sliders from the sliders array
	            var slider = slider_settings.selectAll('.linkSlider').data(sliders).enter().append("g").classed("linkSlider", true).attr('transform', function (d, i) {
	                return 'translate(' + slider_radius + ', ' + (offsetY * i + slider_height) + ')';
	            });
	
	            var slider_text = slider.append("text").classed("slider_text", true).attr('transform', 'translate(0, 0)').text(function (d) {
	                return d.name.replace("_", " ");
	            });
	
	            var slider_line = slider.append("path").classed("domain", true).attr('transform', 'translate(0, ' + slider_height + ')').attr("d", "M0,0V0H" + max_x + "V0");
	
	            var slider_circle = slider.append("g").classed("slider", true).attr('transform', 'translate(0,' + slider_height + ')').append("circle").attr("class", function (d) {
	                return "handle " + d.name;
	            }).attr("r", slider_radius).attr("cy", "0").attr("cx", function (d) {
	                if (d.name === "charge") {
	                    d.x = max_x * d.default / d.min;
	                } else {
	                    d.x = max_x * d.default / d.max;
	                }
	                return d.x;
	            }).call(slider_drag);
	
	            // once you drag a slider, is has to change its X value, and set/save the new settings
	            function drag_slider(d) {
	                d.x = Math.max(0, Math.min(lmCtrl.sidebar_width - offsetX * 4, d3.event.x));
	                // if (d.name !== "charge") {
	                //     if (d.x === 0) {
	                //         d.x = d.min;
	                //     }
	                // }
	                set_setting(d);
	                d3.select(this).attr("cx", d.x);
	            }
	            // sets the new settings to the force chart
	            function set_setting(setting) {
	                switch (setting.name) {
	                    case 'gravity':
	                        lmCtrl.gravity = setting.x / max_x * setting.max + setting.min;
	                        break;
	                    case 'charge':
	                        lmCtrl.charge = setting.x / max_x * setting.min + setting.max;
	                        break;
	                    case 'link_distance':
	                        lmCtrl.link_distance = setting.x / max_x * setting.max + setting.min;
	                        break;
	                    case 'link_strength':
	                        lmCtrl.link_strength = setting.x / max_x * setting.max + setting.min;
	                        break;
	                    case 'friction':
	                        lmCtrl.friction = setting.x / max_x * setting.max + setting.min;
	                        break;
	                    case 'padding':
	                        lmCtrl.padding = setting.x / max_x * setting.max + setting.min;
	                        break;
	                    // case 'alpha':
	                    //     lmCtrl.alpha = setting.x/max_x*setting.max;
	                    //     break;
	                    // case 'radius':
	                    //     lmCtrl.maxRadius = setting.x/max_x*setting.max;
	                    //     break;
	                    default:
	                        return;
	                }
	                lmCtrl.resetInternalMap();
	            }
	            // onces released it saves the new settings localy
	            function drag_slider_end(d) {
	                lmCtrl.settings.set('lateral_chart_settings', [lmCtrl.gravity, lmCtrl.charge, lmCtrl.link_distance, lmCtrl.link_strength, lmCtrl.friction, lmCtrl.padding]); //,lmCtrl.alpha,lmCtrl.maxRadius
	            }
	
	            var freeze = slider_settings.append("g").classed("slider_buttons", true).attr('transform', 'translate(' + 40 * 0 + ', ' + 42 * sliders.length + ')scale(1.5)');
	            freeze.append("path").attr("fill", "#4A95CF").attr("d", "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v" + "2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z");
	            freeze.append("rect").classed("unfreeze", true).classed("hide_section", null).attr("fill", "#C4150D").attr("x", -1.14).attr("y", 11).attr("width", 26.28).attr("height", 2).attr("transform", "translate(-5, 15)rotate(-55)");
	
	            freeze.append("rect").attr("fill", "transparent").attr("width", 30).attr("height", 30).on("click", function () {
	                if (d3.select(".unfreeze").classed("hide_section")) {
	                    d3.select(".unfreeze").classed("hide_section", null);
	                    d3.select(this).select('title').html("Unreeze Graph");
	                    freeze_graph(false);
	                } else {
	                    d3.select(".unfreeze").classed("hide_section", true);
	                    d3.select(this).select('title').html("Freeze Graph");
	                    freeze_graph(true);
	                }
	            }).append('title').html("Unfreeze Graph");
	            function freeze_graph(val) {
	                var n = void 0,
	                    len = void 0;
	                for (n in lmCtrl.nodes_object) {
	                    lmCtrl.nodes_object[n].fixed = val;
	                }
	                lmCtrl.redraw();
	            }
	
	            var reset_chart = slider_settings.append("g").classed("slider_buttons", true).attr('transform', 'translate(' + 40 * 1 + ', ' + 42 * sliders.length + ')scale(1.5)');
	            reset_chart.append("path").attr("fill", "#CF2974").attr("d", "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z");
	            reset_chart.append("rect").attr("fill", "transparent").attr("width", 30).attr("height", 30).on("click", function () {
	                freeze_graph(false);
	                reset_graph();
	                lmCtrl.settings.set('lateral_chart_settings', false);
	            }).append('title').html("Reset Settings");
	            // resets the chart to the default original settings, and also draws the sliders accordingly
	            function reset_graph() {
	                lmCtrl.gravity = 0.05, lmCtrl.charge = -10, lmCtrl.link_distance = 80, lmCtrl.link_strength = 0.5, lmCtrl.friction = 0.6;
	                lmCtrl.padding = 2;
	                var obj = {
	                    gravity: lmCtrl.gravity,
	                    charge: lmCtrl.charge,
	                    link_distance: lmCtrl.link_distance,
	                    link_strength: lmCtrl.link_strength,
	                    friction: lmCtrl.friction,
	                    padding: lmCtrl.padding
	                    // lmCtrl.resetInternalMap();
	                };d3.select(".unfreeze").classed("hide_section", null);
	                lmCtrl.redraw();
	                slider_circle.attr("cx", function (d) {
	                    if (d.name === "charge") {
	                        d.x = max_x * obj[d.name] / d.min;
	                    } else {
	                        d.x = max_x * obj[d.name] / d.max;
	                    }
	                    return d.x;
	                });
	            }
	
	            var realign_map = slider_settings.append("g").classed("slider_buttons", true).attr('transform', 'translate(' + 40 * 2 + ', ' + 42 * sliders.length + ')scale(1.5)');
	            realign_map.append("path").attr("fill", "#422069").attr("d", "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z");
	            realign_map.append("rect").attr("fill", "transparent").attr("width", 30).attr("height", 30).on("click", function () {
	                lmCtrl.realign_map();
	            }).append('title').html("Realign Map");
	
	            // when you pick the max rows for sidebar node info, it then saves it localy
	            $scope.max_row_selected = function () {
	                if ($scope.max_rows === "false") {
	                    lmCtrl.settings.set('lateral_chart_max_rows', false);
	                } else {
	                    lmCtrl.settings.set('lateral_chart_max_rows', $scope.max_rows);
	                }
	                lmCtrl.drawSidebar();
	            };
	
	            // when you pick the bandwidth units for L7 sidebar node info, it then saves it localy
	            $scope.bandwidth_selected = function () {
	                if ($scope.bandwidth === "b") {
	                    lmCtrl.settings.set('lateral_chart_bandwidth', false);
	                } else {
	                    lmCtrl.settings.set('lateral_chart_bandwidth', $scope.bandwidth);
	                }
	                lmCtrl.drawSidebar();
	            };
	            // when you pick the bandwidth units for L7 sidebar node info, it then saves it localy
	            $scope.display_text = function (val) {
	                if (val === "ip") {
	                    if ($scope.display_ip === "true") {
	                        lmCtrl.settings.set('display_ip', false);
	                    } else {
	                        lmCtrl.settings.set('display_ip', $scope.display_ip);
	                    }
	                } else if (val === "hostname") {
	                    if ($scope.display_hostname) {
	                        lmCtrl.settings.set('display_hostname', $scope.display_hostname);
	                    } else {
	                        lmCtrl.settings.set('display_hostname', false);
	                    }
	                } else if (val === "search") {
	                    if ($scope.hide_on_search) {
	                        lmCtrl.settings.set('hide_on_search', $scope.hide_on_search);
	                    } else {
	                        lmCtrl.settings.set('hide_on_search', false);
	                    }
	                    $scope.reset();
	                }
	            };
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	
	            //////////////////
	            /// POPUP INFO ///
	            //////////////////
	            var popup_click = d3.select("#click_popup");
	            var popup = d3.select("#popup");
	            var overlay = d3.select(".overlay");
	            var popup_stop = d3.select(".popup");
	            var popup_close = d3.select("#popup_close");
	
	            popup_stop.on("click", function (d) {
	                d3.event.stopPropagation();
	            });
	            popup_click.on("click", popup_func);
	            popup_close.on("click", popup_func);
	            overlay.on("click", popup_func);
	
	            function popup_func() {
	                if (popup.classed("hidden")) {
	                    popup.classed("hidden", null);
	                } else {
	                    popup.classed("hidden", true);
	                }
	            }
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	
	            ///////////////////
	            /// RESIZE PAGE ///
	            /////////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
	            function resize_sidebar() {
	                lmCtrl.max_width = element[0].clientWidth, lmCtrl.height = angular.element($window)[0].innerHeight - 150;
	                lmCtrl.width = lmCtrl.max_width * 0.76;
	                lmCtrl.sidebar_width = lmCtrl.max_width * 0.22;
	                lmCtrl.tempWidth = lmCtrl.width;
	                old_max_x = max_x;
	                max_x = lmCtrl.sidebar_width - offsetX * 4;
	                circles_collapse = [// have to re-position the circles for the collapsed section
	                { value: 0, name: "Select", offsetX: background_radius + 2 }, { value: 1, name: "Collapse", offsetX: max_x / 3 + background_radius }, { value: 2, name: "Hide", offsetX: max_x * 2 / 3 + background_radius / 2 }, { value: 3, name: "Show", offsetX: max_x }];
	                slider_settings.attr('width', lmCtrl.sidebar_width - offsetX * 2);
	                sidebar.style("max-width", lmCtrl.sidebar_width + "px");
	                sidebar_svg.attr("width", lmCtrl.sidebar_width);
	                slider_line.attr("d", "M0,0V0H" + max_x + "V0");
	                collapse_toggle.attr("width", lmCtrl.sidebar_width - background_radius * 2);
	                collapse_line.attr("d", "M5 20 l" + max_x + " 0");
	                collapse_toggle.selectAll('.select_circles').data(circles_collapse).attr('transform', function (d) {
	                    return 'translate(' + d.offsetX + ', ' + (background_radius + 2) + ')';
	                });
	                slider_circle.attr("cx", function (d) {
	                    return d.x = max_x / old_max_x * d.x;
	                });
	                sidebar_content.style("max-height", lmCtrl.height - 50 + "px");
	                if (sidebar.classed("hide_section")) {
	                    lmCtrl.width = lmCtrl.max_width - 80;
	                } else {
	                    lmCtrl.width = lmCtrl.tempWidth;
	                }
	            }
	            lmCtrl.resize_sb = function () {
	                resize_sidebar();
	            };
	
	            angular.element($window).bind('resize', function () {
	                // Event that happens whenever the window is resized
	                lmCtrl.waitForFinalEvent(function () {
	                    resize_sidebar();
	                }, 250, "sidebar_resize");
	            });
	            angular.element(document).ready(function () {
	                console.log($window.innerWidth);
	                if ($window.innerWidth <= 1360) $scope.toggleSidebar('sidebar');
	            });
	            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
	
	            // clear timers on scope destroy
	            $scope.$on('$destroy', function () {
	                element = null;
	                angular.element($window).unbind('resize');
	            });
	        }
	    };
	}
	
	directive.$inject = ['$window', 'timeFormat', '$state', '$stateParams'];
	module.exports = directive;

/***/ },
/* 825 */
/***/ function(module, exports) {

	module.exports = "<div id=\"sidebar\">\n    <svg id=sidebr_svg></svg>\n    <div id=\"sidebar_toggle\">\n        <h3>SIDEBAR</h3>\n        <div class=\"close_sidebar\" ng-click=\"toggleSidebar('sidebar')\">\n            <svg height=\"24\" width=\"24\">\n                <path d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\" fill=\"#333333\"/>\n            </svg>\n        </div>\n    </div>\n    <div id=\"sidebar_content\">\n        <div id=\"node_info\">\n            <div class=\"sidebar_title\" ng-click=\"toggleShow('node_info')\">\n                <div class=\"svg_title\">\n                    <svg fill=\"#4DADB0\" height=\"24\" width=\"24\">\n                        <path d=\"M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z\"/>\n                    </svg>\n                </div>\n                <h3>Node Info</h3>\n                <div class=\"arrow_title\"></div>\n            </div>\n            <div id=\"node_info_content\" class=\"hide_section\">\n                <div id=\"selected_node\" ng-if=\"(selected_nodes.length == 1)\">\n                    <div class=\"selected_scroll\">\n                        <table ng-if=\"(!selected_nodes[0].collapse)\">\n                            <tr><td><span class=\"unselect\" ng-click=\"unselect(selected_nodes[0])\">Unselect</span>IP</td><td class=\"node_ip\"><span ng-click=\"addIpToSearch(selected_nodes[0].ip)\">{{(selected_nodes[0].ip == 'N/A') ? \"-\" : selected_nodes[0].ip}}</span></td></tr>\n                            <tr><td>Hostname</td><td>{{(selected_nodes[0].hostname == 'N/A') ? \"-\" : selected_nodes[0].hostname}}</td></tr>\n                            <tr><td>Group</td><td>{{((groups[selected_nodes[0].group].name == 'N/A') || (selected_nodes[0].group == 'N/A') || (selected_nodes[0].group == null)) ? \"-\" : groups[selected_nodes[0].group].name}}</td></tr>\n                            <tr><td>Type</td><td>{{((selected_nodes[0].type == 'N/A') || (selected_nodes[0].type == null))  ? \"-\" : selected_nodes[0].type}}</td></tr>\n                            <tr><td>MAC</td><td>{{(selected_nodes[0].mac == 'N/A') ? \"-\" : selected_nodes[0].mac}}</td></tr>\n                            <tr><td>OS</td><td>{{(selected_nodes[0].os == 'N/A') ? \"-\" : selected_nodes[0].os}}</td></tr>\n                            <tr><td>Vendor</td><td>{{(selected_nodes[0].vendor == 'N/A') ? \"-\" : selected_nodes[0].vendor}}</td></tr>\n                            <tr><td>Connecting Nodes</td><td>{{(selected_nodes[0].weight == 'N/A') ? \"-\" : selected_nodes[0].weight}}</td></tr>\n                        </table>\n                        <table ng-if=\"selected_nodes[0].collapse\">\n                            <tr ng-repeat=\"ip in selected_nodes[0].ip\">\n                                <td><span class=\"unselect\" ng-click=\"unselect(selected_nodes[0])\" ng-if=\"$first\">Unselect</span>{{$first ? \"Unique IPs\" : \"\"}}</td>\n                                <td>{{(ip == 'N/A') ? \"-\" : ip}}</td>\n                            </tr>\n                            <tr ng-repeat=\"group_name in selected_nodes[0].group_name\"><td>{{$first ? \"Unique Groups\" : \"\"}}</td><td>{{(group_name == 'N/A') ? \"-\" : group_name}}</td></tr>\n                            <tr ng-repeat=\"type in selected_nodes[0].type\"><td>{{$first ? \"Unique Types\" : \"\"}}</td><td>{{((type == 'N/A') || (type == null)) ? \"-\" : type}}</td></tr>\n                            <tr><td># of Nodes</td><td>{{selected_nodes[0].ip.length}}</td></tr>\n                            <tr><td>Collapsed by</td><td>{{selected_nodes[0].action}}</td></tr>\n                        </table>\n                    </div>\n                    <div class=\"list_l7\" ng-if=\"(selected_nodes[0].resp_l7.length > 0)\">\n                        <div class=\"l7_title\">Responder Layer 7 App</div>\n                        <span class=\"l7_th\">L7</span><span class=\"l7_th\">Proto</span><span class=\"l7_th\">Service</span>\n                        <div class=\"list_l7_table\">\n                            <table>\n                                <tr ng-repeat=\"l7 in selected_nodes[0].resp_l7\">\n                                    <td>{{(l7.split('%')[0] == 'N/A') ? \"-\" : l7.split('%')[0]}}</td><td>{{(l7.split('%')[1] == 'N/A') ? \"-\" : l7.split('%')[1]}}</td><td>{{(l7.split('%')[2] == 'N/A') ? \"-\" : l7.split('%')[2]}}</td>\n                                </tr>\n                            </table>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"node_list_title\" ng-show=\"((max_rows > 0) || (max_rows == 'false'))\">\n                    <span class=\"nl_type\" ng-click=\"sortBy('type')\">Type</span>\n                    <span class=\"nl_ip\" ng-click=\"sortBy('ip')\">IP</span>\n                    <span class=\"nl_hostname\" ng-click=\"sortBy('hostname')\">Hostname</span>\n                    <span class=\"nl_conn_count\" ng-click=\"sortBy('weight')\">#</span>\n                </div>\n                <div id=\"node_info_rows\"></div>\n            </div>\n        </div>\n        <div id=\"node_type\">\n            <div class=\"sidebar_title\" ng-click=\"toggleShow('node_type')\">\n                <div class=\"svg_title\">\n                    <svg fill=\"#FF3D38\" height=\"24\" width=\"24\">\n                       <path d=\"M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z\"/>\n                    </svg>\n                </div>\n                <h3>Edit Node {{(selected_nodes.length) ? \"(\"+selected_nodes.length+\")\" : \"\"}}</h3>\n                <div class=\"arrow_title\"></div>\n            </div>\n            <div id=\"node_type_content\" class=\"hide_section\">\n                <form>\n                    <select ng-model=\"current.node.type\"> <!-- ng-init to make it selected ng-init=\"formFields.ioc_severity = formFields.ioc_severity || '*value*'\" -->\n                        <option value=\"N/A\" disabled selected>Select a Type</option>\n                        <option value=\"\" disabled ng-show=\"false\">Select a Type</option>\n                        <option value=\"new\" disabled ng-show=\"false\">Select a Type</option>\n                        <option value=\"false\">Do Not Change</option>\n                        <option value=\"{{type}}\" ng-repeat=\"type in types\">{{type}}</option>\n                    </select><br />\n                    <select ng-model=\"current.node.group\">\n                        <option value=\"N/A\" disabled selected>Select a Group</option>\n                        <option value=\"\" disabled ng-show=\"false\">Select a Group</option>\n                        <option value=\"false\">Do Not Change</option>\n                        <option value=\"{{group.id}}\" style=\"color:{{group.color}}\" ng-repeat=\"group in groups\">{{group.name}}</option>\n                    </select><br />\n                    <button ng-click=\"save_node()\" class=\"button-success pure-button\" ng-disabled=\"(selected_nodes.length == 0)\">Save</button>\n                    <button ng-click=\"selectAll()\" ng-show=\"showSelectAll\" class=\"pure-button\">Select All</button>\n                    <button ng-click=\"unselectAll()\" ng-show=\"!showSelectAll\" class=\"pure-button\">Unselect All</button>\n                    <button ng-click=\"save_node('clear')\" class=\"pure-button\" ng-disabled=\"(selected_nodes.length == 0)\">Clear</button>\n                </form>\n            </div>\n        </div>\n        <div id=\"group_info\">\n            <div class=\"sidebar_title\" ng-click=\"toggleShow('group_info')\">\n                <div class=\"svg_title\">\n                    <svg fill=\"#FF702C\" height=\"24\" width=\"24\">\n                        <path d=\"M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z\"/>\n                    </svg>\n                </div>\n                <h3>Group Creation</h3>\n                <div class=\"arrow_title\"></div>\n            </div>\n            <div id=\"group_info_content\" class=\"hide_section\">\n                <form>\n                    <select ng-model=\"current.selected\" ng-change=\"group_selected()\">\n                        <option value=\"\" disabled selected>Select a Group</option>\n                        <option value=\"{{group.id}}\" style=\"color:{{group.color}}\" ng-repeat=\"group in groups\">{{group.name}}</option>\n                    </select><br />\n                    <input type=\"text\" ng-model=\"current.group.name\" placeholder=\"My Group Name\"><br />\n                    <input type=\"color\" ng-model=\"current.group.color\"><br />\n\n                    <button ng-click=\"create_group()\" class=\"button-success pure-button\" ng-disabled=\"(current.group.name == '')\">Save</button>\n                    <button ng-click=\"delete_group()\"ng-disabled=\"!current.group.id\" class=\"button-error pure-button\">Delete</button>\n                    <button ng-click=\"clear_group()\" class=\"pure-button\">Clear</button>\n                </form>\n            </div>\n        </div>\n       <!--  <div id=\"filter_info\">\n            <div class=\"sidebar_title\" ng-click=\"toggleShow('filter_info')\">\n                <div class=\"svg_title\">\n                    <svg fill=\"#a500ff\" height=\"24\" width=\"24\">\n                        <path d=\"M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z\"/>\n                    </svg>\n                </div>\n                <h3>Filter</h3>\n                <div class=\"arrow_title\"></div>\n            </div>\n            <div id=\"filter_info_content\" class=\"hide_section\">\n            Coming Soon\n            </div>\n        </div> -->\n        <div id=\"collapse_info\">\n            <div class=\"sidebar_title\" ng-click=\"toggleShow('collapse_info')\">\n                <div class=\"svg_title\">\n                    <svg fill=\"#328A15\" height=\"24\" width=\"24\">\n                        <path d=\"M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z\"/>\n                    </svg>\n                </div>\n                <h3>Collapse</h3>\n                <div class=\"arrow_title\"></div>\n            </div>\n            <div id=\"collapse_info_content\" class=\"hide_section\">\n                <div id=\"coll_hide\">\n                    <svg id=\"collapse_toggle\"></svg>\n                </div>\n                <svg class=\"collapse_svg\" ng-click=\"collapse('type')\" height=\"50\" width=\"70\">\n                    <path transform=\"translate(23, 0)\" d=\"M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z\"/>\n                    <text text-anchor=\"middle\" x=\"35\" y=\"35\">Type</text>\n                </svg>\n                <svg class=\"collapse_svg\" ng-click=\"collapse('group')\" height=\"50\" width=\"70\">\n                    <path transform=\"translate(23, 0)\" d=\"M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z\"/>\n                    <text text-anchor=\"middle\" x=\"35\" y=\"35\">Group</text>\n                </svg>\n                <svg class=\"collapse_svg\" ng-click=\"collapse('cluster')\" height=\"50\" width=\"70\">\n                    <path transform=\"translate(23, 0)\" d=\"M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z\"/>\n                    <text text-anchor=\"middle\" x=\"35\" y=\"35\">Cluster</text>\n                </svg>\n                <svg class=\"collapse_svg\" ng-click=\"collapse('connecting')\" height=\"50\" width=\"70\">\n                    <path transform=\"translate(23, 0)\" d=\"M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z\"/>\n                    <text text-anchor=\"middle\" x=\"35\" y=\"35\">Connecting</text>\n                </svg>\n                <svg class=\"collapse_svg\" ng-click=\"collapse('selected')\" height=\"50\" width=\"70\">\n                    <path transform=\"translate(23, 0)\" d=\"M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z\"/>\n                    <text text-anchor=\"middle\" x=\"35\" y=\"35\">Selected</text>\n                </svg>\n                <svg class=\"collapse_svg\" ng-click=\"show_hide_ioc('ioc')\" height=\"50\" width=\"70\">\n                    <path transform=\"translate(23, 0)\" d=\"M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\"/>\n                    <text text-anchor=\"middle\" x=\"35\" y=\"35\">IOC</text>\n                </svg>\n                <svg class=\"collapse_svg\" ng-click=\"reset()\" height=\"50\" width=\"70\">\n                    <path transform=\"translate(23, 0)\" d=\"M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z\"/>\n                    <text text-anchor=\"middle\" x=\"35\" y=\"35\">Reset All</text>\n                </svg>\n            </div>\n        </div>\n        <div id=\"map_settings\">\n            <div class=\"sidebar_title\" ng-click=\"toggleShow('map_settings')\">\n                <div class=\"svg_title\">\n                    <svg fill=\"#999999\" height=\"24\" width=\"24\">\n                        <path d=\"M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z\"/>\n                    </svg>\n                </div>\n                <h3>Settings</h3>\n                <div class=\"arrow_title\"></div>\n            </div>\n            <div id=\"map_settings_content\" class=\"hide_section\">\n                <svg id=\"slider_settings\"></svg>\n                <div>\n                    <span><input type=\"checkbox\" name=\"ip\" ng-model=\"display_ip\" ng-true-value=\"'true'\" ng-false-value=\"'false'\" ng-change=\"display_text('ip')\"> Display IP on Hover</span><br />\n                    <span><input type=\"checkbox\" name=\"hostname\" ng-model=\"display_hostname\" ng-change=\"display_text('hostname')\"> Display Hostname on Hover</span><br />\n                    <span><input type=\"checkbox\" name=\"on_search\" ng-model=\"hide_on_search\" ng-change=\"display_text('search')\"> Hide Nodes on Search</span>\n                </div>\n                <div class=\"sidebar_label\">Sidebar Row Limit</div>\n                <select ng-model=\"max_rows\" ng-change=\"max_row_selected()\">\n                    <option value=\"{{limit.value}}\" ng-repeat=\"limit in sidebar_limits\">{{limit.text}}</option>\n                </select>\n                <div class=\"sidebar_label\">L7 Bandwidth</div>\n                <select ng-model=\"bandwidth\" ng-change=\"bandwidth_selected()\">\n                    <option value=\"{{bw.select}}\" ng-repeat=\"bw in diff_bandwidth\">{{bw.text}}</option>\n                </select>\n                <div id=\"help_button\">\n                    <svg id=\"click_popup\" height=\"24\" width=\"24\">\n                        <path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z\"><title>Help</title></path>\n                    </svg>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"sidebar_collapse\" class=\"close_sidebar hide_section\" ng-click=\"toggleSidebar('sidebar')\">\n    <svg height=\"24\" width=\"24\">\n        <path d=\"M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z\" fill=\"#333333\"/>\n    </svg>\n</div>";

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('iocDesc', __webpack_require__(827));
	};

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	function directive() {
	    return {
	        link: function link($scope, element) {
	            $scope.$on('iocDesc', function (event, description) {
	                if (!description) {
	                    return;
	                }
	                var maxLength = 160;
	                // if the string is less then our max length..
	                if (description.length < maxLength) {
	                    $(element).html(description);
	                    // otherwise, trim and add link to modal
	                    // NOTE: MODAL SETTINGS ARE CUSTOM IN EACH CONTROLLER
	                } else {
	                    var subString = description.substring(0, maxLength);
	                    $(element).html(subString + '... <a href="javascript:void(0);"><strong>Read More</strong></a>');
	                    $(element).on('click', function () {
	                        $scope.description(description);
	                    });
	                }
	            });
	            $scope.$on('$destroy', function () {
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('iocAttribute', __webpack_require__(829));
	};

/***/ },
/* 829 */
/***/ function(module, exports) {

	"use strict";
	
	function directive() {
	    return {
	        link: function link($scope, element, attrs) {
	            var ioc_att = JSON.parse(attrs.name);
	            var div = d3.select(element[0]);
	            var type = {
	                IPType: "IP Address",
	                IPSubType: "IP Subnet",
	                l7proto: "Layer 7 Protocol",
	                FileType: "File Name",
	                HashType: "File Hash",
	                HTTPType: "HTTP Domain",
	                country: "Country"
	            };
	            var html = "";
	
	            if (attrs.type === "type") {
	                for (var i = 0, len = ioc_att.length; i < len; i++) {
	                    html += "<hr class='ioc_atts'>" + type[ioc_att[i]] + "</hr>";
	                }
	            } else {
	                for (var _i = 0, _len = ioc_att.length; _i < _len; _i++) {
	                    html += "<hr class='ioc_atts'>" + ioc_att[_i] + "</hr>";
	                }
	            }
	            div.html(html);
	
	            $scope.$on('$destroy', function () {
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('laneGraph', __webpack_require__(831));
	};

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _moment = __webpack_require__(459);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function directive($timeout, $location, timeFormat, $http, laneRowSymbols, $state) {
	    return {
	        template: __webpack_require__(832),
	        transclude: true,
	        link: function link($scope, element, attrs, dcCrtl) {
	            $scope.$on('laneGraph', function () {
	                $scope.$broadcast('spinnerHide');
	                $.fn.scrollTo = function (target, options, callback) {
	                    if (typeof options == 'function' && arguments.length == 2) {
	                        callback = options;
	                        options = target;
	                    }
	                    var settings = $.extend({
	                        scrollTarget: target,
	                        offsetTop: 0,
	                        duration: 0,
	                        easing: 'swing'
	                    }, options);
	                    return this.each(function () {
	                        var scrollPane = $(this);
	                        var scrollTarget = typeof settings.scrollTarget == 'number' ? settings.scrollTarget : $(settings.scrollTarget);
	                        var scrollY = typeof scrollTarget == 'number' ? scrollTarget + scrollPane.scrollTop() : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
	                        scrollPane.animate({
	                            scrollTop: scrollY
	                        }, parseInt(settings.duration), settings.easing, function () {
	                            if (typeof callback == 'function') {
	                                callback.call(this);
	                            }
	                        });
	                    });
	                };
	
	                var laneTypes = ['ioc', 'ioc_severity', 'conn', 'application', 'dns', 'http', 'ssl', 'file']; // endpoint
	                var firstOfRow = new Map();
	                var firstOfRowMax = new Map();
	                var ioc_initialized = false;
	                var offsetTime = 60;
	                ///////////////////////
	                /////  VARIABLES  /////
	                ///////////////////////
	                var itemsDimension = $scope.crossfilterData.dimension(function (d) {
	                    return d.dd;
	                });
	                var searchDimension = $scope.crossfilterData.dimension(function (d) {
	                    setFOR(d);
	                    return d;
	                });
	                var typeDimension = $scope.crossfilterData.dimension(function (d) {
	                    return d.type;
	                });
	                var deepDimension = $scope.crossfilterData.dimension(function (d) {
	                    return d.deep;
	                });
	                var laneNodeIndex = {};
	                $scope.crossfilterData.launched = true;
	
	                // set start on header load
	                if (typeof $location.$$search.start !== 'undefined') {
	                    $scope.start = Number($location.$$search.start);
	                } else {
	                    $scope.start = Number($scope.main.time.start);
	                }
	
	                // set end on header load
	                if (typeof $location.$$search.end !== 'undefined') {
	                    $scope.end = Number($location.$$search.end);
	                } else {
	                    $scope.end = Number($scope.main.time.end);
	                }
	
	                var nodeType;
	                var initial_ioc;
	
	                function setFOR(node) {
	                    nodeType = node.type;
	                    if (!firstOfRow.has(nodeType)) {
	                        firstOfRow.set(nodeType, node.id);
	                    } else {
	                        firstOfRowMax.set(nodeType, node.id);
	                    }
	                    if (node.type === 'Conn_ioc' && typeof initial_ioc === 'undefined') {
	                        initial_ioc = node;
	                        ioc_initialized = true;
	                    }
	                }
	
	                var topBytes, total_bytes, laneGraphGroup;
	                var maxID = 0;
	                var uniqueIds = []; // this is so we do not add duplicate items into our crossfitler
	
	                // set our in-to-deep variable
	                $scope.inTooDeep = {
	                    areWe: false,
	                    min: null,
	                    max: null
	                };
	
	                var filteredLabel = false;
	                $scope.highlightedPoint = false;
	                // toggle for turning on/off unit multiselecting
	                $scope.pattern;
	                $scope.rePattern;
	
	                // we put the pattern in a function because it's easier to clear later without redefining things
	                function setPatternObj() {
	                    $scope.pattern = {
	                        searching: false,
	                        order: 0,
	                        selected: {
	                            length: 0
	                        },
	                        // last elm clicked, for throwing in object after an item is clicked when and our button is toggled
	                        last: null
	                    };
	                }
	
	                setPatternObj();
	                var queryThreshhold = 3600; // one hour in seconds
	                var navArray = [],
	                    currentNavPos = 0;
	                var addRemBtnDimensions = [32, 18];
	
	                ///////////////////////
	                /////  DIV SETUP  /////
	                ///////////////////////
	                var graphRow = d3.select(element[0]).append('div').attr('class', 'row-fluid');
	
	                var leftSide = graphRow.append('div').attr('class', 'span8').append('div').attr('id', 'box').append('div').attr('class', 'box-content');
	
	                var rightSide = graphRow.append('div').attr('class', 'span4').append('div').attr('id', 'box').append('div').attr('class', 'box-content');
	
	                var laneLength = $scope.lanes.length;
	                var lWidth = leftSide.node().offsetWidth;
	                var m = [5, 15, 15, 130],
	                    //top right bottom left
	                w = lWidth - m[1] - m[3],
	                    h = 420 - m[0] - m[2],
	                    miniHeight = 0,
	                    mainHeight = h - miniHeight - 50;
	
	                // put it in scope for use in view
	                $scope.height = h;
	
	                // right side header
	                rightSide.append('div').classed('lanegraphtitle', true).append('form').html('Auto Expand').attr('action', null).attr('id', 'autoExpand').append('input').attr('type', 'checkbox').attr('id', 'autoexpand').attr('name', 'autoexpand').attr('value', 'autoexpand').attr('checked', true);
	                var infoHeight = h;
	                var infoDiv = rightSide.append('div').classed('divScroll', true).style('height', infoHeight + 'px').style('overflow', 'auto');
	
	                // current time div
	                var currentTimeSlice = leftSide.append('div').attr('class', 'timeslice');
	
	                var currentTime = currentTimeSlice.append('div').style('float', 'left');
	
	                var loadingSpinner = currentTimeSlice.append('div').attr('id', 'spinner').style('margin', '0px 0px -4px 0px');
	
	                var notInitialLoad = false;
	
	                $scope.$on('stopSpinner', function () {
	                    loadingSpinner.style('display', 'none');
	                    if (notInitialLoad) {
	                        buttons.attr('disabled', null);
	                    }
	                    notInitialLoad = true;
	                    allButton.attr('disabled', null);
	                });
	
	                $scope.$on('startSpinner', function () {
	                    loadingSpinner.style('display', 'inline-block');
	                    if (notInitialLoad) {
	                        buttons.attr('disabled', 'disabled');
	                    }
	                });
	
	                // enhanced view alert
	                $scope.alert = currentTimeSlice.append('div').attr('class', 'laneAlert').html('Enhanced drill-down view');
	
	                //////////////////////////
	                /////  D3 VIZ SETUP  /////
	                //////////////////////////
	                var x1 = d3.time.scale().domain([new Date($scope.start * 1000), new Date($scope.end * 1000)]).range([0, w - 15]);
	
	                var y1 = d3.scale.linear().domain([0, laneLength]).range([30, mainHeight]);
	
	                var chart = leftSide.append('svg').attr('width', w + m[1] + m[3]).attr('height', h).on('dblclick', function () {
	                    currentNavPos = 0;
	                    navCrtl('reset');
	                }).attr('class', 'chart');
	
	                var main = chart.append('g').attr('transform', 'translate(' + m[3] + ',' + m[0] + ')').attr('width', w).attr('height', mainHeight).attr('class', 'main');
	
	                var xAxis = d3.svg.axis().scale(x1).orient('bottom').tickSize(0).tickPadding(8);
	
	                var xAxisBrush = chart.append('g').attr('class', 'x axis').attr('transform', 'translate(' + m[3] + ',' + (mainHeight + 9) + ')').call(xAxis);
	
	                // main lanes and texts
	                var laneLines = main.append('g').selectAll('.laneLines').data($scope.lanes).enter().append('line').attr('stroke-width', '1').attr('stroke-opacity', '0.7').attr('x1', 0).attr('y1', function (d, i) {
	                    return y1(i);
	                }).attr('x2', w).attr('y2', function (d, i) {
	                    return y1(i);
	                }).attr('stroke', function (d) {
	                    return rowColors(d);
	                });
	
	                laneLines.each(function (d) {
	                    if (d === '') {
	                        d3.select(this).remove();
	                    }
	                });
	
	                main.append('g').selectAll('.laneText').data($scope.lanes).enter().append('text').text(function (d) {
	                    return d;
	                }).style('cursor', 'pointer').on('click', function (d) {
	                    filterType(d, 'click', this);
	                }).attr('x', -m[1] * 3).attr('y', function (d, i) {
	                    return y1(i);
	                }).attr('dy', '.5ex').attr('text-anchor', 'end');
	
	                // icons to the left of lanes, this is our icon placeholder group
	                var iconBox = main.selectAll('.laneLines').data($scope.lanes).enter().append('g').attr('class', function (d) {
	                    return 'lane_icon ' + d.toLowerCase().replace(' ', '_');
	                }).style('cursor', 'pointer').on('click', function (d) {
	                    filterType(d, 'click', this);
	                }).attr('transform', function (d, i) {
	                    return 'translate(' + -m[1] * 2.4 + ',' + (y1(i) - m[1]) + ') scale(0.8)';
	                });
	
	                // placing the row icons
	                var rowIcons = iconBox.each(function (d) {
	                    var color1 = rowColors(d);
	                    var color2 = '#3f3f3f';
	                    var elm = d3.select(this);
	                    if (d === 'IOC') {
	                        elm.append('polygon').attr('points', '7,15 14,6 0,6').attr('transform', 'translate(8,4) scale(1.6)').attr('fill', '#aaa');
	                    };
	                    laneRowSymbols(d, elm, color1, color2);
	                });
	
	                var lineStory = main.append('svg').attr('width', w).attr('height', mainHeight).append('g').attr('class', 'storyLine');
	
	                var clickLine = main.append('g').attr('class', 'clickLine');
	
	                // GRAPH BLUR FILTER
	                var blurFilter = chart.append('filter').attr('id', 'blur-effect-1').append('feGaussianBlur');
	
	                var blur = blurFilter.attr('class', 'graphBlur').attr('stdDeviation', 0);
	
	                var load = chart.append('g').style('display', 'none').attr('transform', 'translate(' + (lWidth / 2 - 20) + ',' + (infoHeight / 2 - 80) + ')');
	
	                // loading svg
	                load.append('svg').attr('version', 1.1).attr('id', 'loader-1').attr('x', '0px').attr('y', '0px').attr('width', '40px').attr('height', '40px').attr('viewBox', '0 0 50 50').attr('style', 'enable-background:new 0 0 50 50;').attr('xml:space', 'preserve');
	
	                // spinner
	                load.append('path').attr('fill', '#FF6700').attr('d', 'M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z').append('animateTransform').attr('attributeType', 'xml').attr('attributeName', 'transform').attr('type', 'rotate').attr('from', '0 25 25').attr('to', '360 25 25').attr('dur', '0.6s').attr('repeatCount', 'indefinite');
	
	                var brush = d3.svg.brush().x(x1).on('brushend', navCrtl);
	
	                main.append('g').attr('class', 'x brush').call(brush).selectAll('rect').attr('y', 1).attr('height', mainHeight);
	
	                var itemRects = main.append('svg').attr('width', w).attr('height', mainHeight).append('g').attr('clip-path', 'url(#clip)');
	
	                // nav
	                var buttonHolder = leftSide.append('div').attr('class', 'buttonHolder');
	
	                var resetBtn = buttonHolder.append('button').html('Reset').attr('class', 'resetButton').on('click', function () {
	                    currentNavPos = 0;
	                    navCrtl('reset');
	                });
	
	                var prevButton = buttonHolder.append('button').html('Previous').attr('class', 'prevButton').on('click', function () {
	                    if (currentNavPos > 0) {
	                        nextButton.attr('disabled', null);
	                        currentNavPos--;
	                        navCrtl('nav');
	                    }
	                });
	
	                var nextButton = buttonHolder.append('button').html('Next').attr('class', 'prevButton').on('click', function () {
	                    if (currentNavPos < navArray.length - 1) {
	                        prevButton.attr('disabled', null);
	                        currentNavPos++;
	                        navCrtl('nav');
	                    }
	                });
	
	                /*  var qMarkButton = buttonHolder
	                        .append('button')
	                        .html('?')
	                        .attr('class', 'qMarkButton')
	                        .on('click', function () {
	                            $scope.description(
	                                'This chart represents discrete events deemed significant to the IOC being examined '+
	                                '(for example, it is related to the 3-tuple which includes local, remote and IOC information).'+
	                                'Discrete event categories available are: IOC - describing the indicator, conn - the '+
	                                'raw IP connection information, applications that were used by the use, DNS queries, '+
	                                'HTTP queries, SSL connections, File metadata, and Endpoint events).'+
	                                'To view details of any event, click the icon in the chart and details will be '+
	                                'highlighted in the table to the left.  Further information will be displayed by '+
	                                'clicking the \'+\' sign for each record.'+
	                                'To view ALL event data in the chart, left mouse click and drag over the area to zoom.'+
	                                'If the zoom area covers a time slice less than 60 minutes, an \'Enhanced View\' will '+
	                                'be displayed on the screen, showing every event triggered by the local endpoint within'+
	                                'the time slice.  This query can take a few seconds to display, depending on the amount'+
	                                'of information.  Once the enhanced view data is presented, you can continue to zoom as '+
	                                'needed.',
	                                'Event Timeline Navigation');
	                        });
	                */
	
	                var saveToggle = buttonHolder.append('button').html('Create Kill-Chain').attr('class', 'saveToggle').on('click', function () {
	                    if ($scope.pattern.searching === false) {
	                        d3.select(this).html('Analyze Kill-Chain');
	                        // set searching to true
	                        $scope.pattern.searching = true;
	                        // change class (so we know its on)
	                    } else {
	                        d3.select(this).html('Create Kill-Chain');
	                        // make a call to save restults
	                        // clear our object & set it back to false
	                        // var thisIsAnObject = {foo:'bar'};
	                        var killChain = angular.copy($scope.pattern.selected);
	                        var kc = {
	                            include: [],
	                            time: null
	                        };
	                        var obj = {
	                            from: '',
	                            title: '',
	                            value: ''
	                        };
	                        if (typeof killChain !== 'undefined') {
	                            for (var k in killChain) {
	                                if (_typeof(killChain[k]) === 'object') {
	                                    for (var s in killChain[k].search) {
	                                        if (_typeof(killChain[k].search[s]) === 'object') {
	                                            obj.from = killChain[k].search[s].select;
	                                            obj.title = s;
	                                            obj.value = killChain[k].search[s].value;
	                                            kc.include.push(angular.copy(obj));
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                        if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
	                            kc.time = {
	                                start: $location.$$search.start,
	                                end: $location.$$search.end
	                            };
	                        }
	                        $state.go('pages.main.search', kc);
	                    }
	                    if ($scope.pattern.last !== null) {
	                        laneInfoAppend($scope.pattern.last.data, $scope.pattern.last.element);
	                    }
	                });
	
	                var allButton = buttonHolder.append('button').html('View All').attr('class', 'qMarkButton').on('click', function () {
	                    viewAll();
	                });
	
	                allButton.attr('disabled', 'disabled');
	
	                document.onkeydown = checkKey;
	
	                var buttons = d3.selectAll('button');
	
	                var nextNodeType = '';
	
	                function checkKey(e) {
	                    function containsID(nodeArray, id) {
	                        for (var i = 0, len = nodeArray.length; i < len; i++) {
	                            if (nodeArray[i].id === id) {
	                                return true;
	                            }
	                        }
	                        return false;
	                    }
	                    e = e || window.event;
	                    var id = -1;
	                    var updown;
	                    var laneValue = [];
	                    var indexValue = [];
	                    var index;
	                    var lane;
	
	                    var laneObject = [];
	
	                    d3.select('.eventFocus').each(function (d) {
	                        id = d.id;
	                        lane = d.lane;
	                        nodeType = d.type;
	                        laneValue.push(d.type);
	                        laneObject.push(d);
	                    });
	
	                    d3.selectAll('.hover-active').each(function (d) {
	                        if (laneValue.indexOf(d.type) === -1) {
	                            laneValue.push(d.type);
	                            laneObject.push(d);
	                        }
	                    });
	
	                    function reorder(a, b) {
	                        if ($scope.lanes.indexOf(a.type) < $scope.lanes.indexOf(b.type)) return 1;
	                        if ($scope.lanes.indexOf(a.type) > $scope.lanes.indexOf(b.type)) return -1;
	                        return 0;
	                    }
	
	                    laneObject.sort(reorder);
	                    for (var l in laneObject) {
	                        indexValue.push(laneObject[l].id);
	                    }
	                    switch (e.keyCode) {
	                        case 39:
	                            // right
	                            updown = false;
	                            if (laneNodeIndex[nodeType].indexOf(id) === 0) {
	                                id = laneNodeIndex[nodeType][laneNodeIndex[nodeType].length - 1];
	                            } else {
	                                id = laneNodeIndex[nodeType][laneNodeIndex[nodeType].indexOf(id) - 1];
	                            }
	                            break;
	
	                        case 37:
	                            // left
	                            updown = false;
	                            if (laneNodeIndex[nodeType].indexOf(id) === laneNodeIndex[nodeType].length - 1) {
	                                id = laneNodeIndex[nodeType][0];
	                            } else {
	                                id = laneNodeIndex[nodeType][laneNodeIndex[nodeType].indexOf(id) + 1];
	                            }
	                            break;
	
	                        case 38:
	                            // up
	                            updown = true;
	                            d3.select('.node-' + indexValue[indexValue.indexOf(id) + 1]).each(function (d) {
	                                nextNodeType = d.type;
	                            });
	                            if (indexValue.indexOf(id) === indexValue.length - 1) {
	                                id = indexValue[0];
	                            } else {
	                                id = indexValue[indexValue.indexOf(id) + 1];
	                            }
	                            break;
	
	                        case 40:
	                            // down
	                            updown = true;
	                            d3.select('.node-' + indexValue[indexValue.indexOf(id) - 1]).each(function (d) {
	                                nextNodeType = d.type;
	                            });
	                            if (indexValue.indexOf(id) === 0) {
	                                id = indexValue[indexValue.length - 1];
	                            } else {
	                                id = indexValue[indexValue.indexOf(id) - 1];
	                            }
	                            break;
	
	                        default:
	                            return; // exit this handler for other keys
	                    }
	                    if (updown) {
	                        d3.selectAll('.hover-active').each(function (d) {
	                            if (d.id === id) {
	                                if (d3.select(this)[0][0].classList[0] !== 'eventSquare') {
	                                    openScrollSide2(d);
	                                    clearVerticalLine();
	                                    appendVerticalLine(d);
	                                    changeIcon(d3.select(this), d);
	                                }
	                            }
	                        });
	                    } else {
	                        d3.select('.node-' + id).each(function (d) {
	                            openScrollSide2(d);
	                            clearVerticalLine();
	                            appendVerticalLine(d);
	                            changeIcon(d3.select(this), d);
	                        });
	                    }
	                    e.preventDefault(); // prevent the default action (scroll / move caret)
	                }
	
	                ///////////////////////////////
	                /////  GENERAL FUNCTIONS  /////
	                ///////////////////////////////
	
	                // loading actions
	                function loading(action) {
	                    if (action === 'start') {
	                        load.style('display', 'block');
	                        main.select('.brush').style('display', 'none');
	                        blurFilter.transition().duration(500).attr('stdDeviation', 3);
	                        main.style('filter', 'url(#blur-effect-1)');
	                    } else {
	                        load.style('display', 'none');
	                        main.select('.brush').style('display', 'block');
	                        blurFilter.transition().duration(2000).attr('stdDeviation', 0);
	                        main.style('filter', null);
	                    }
	                }
	
	                function rowColors(type) {
	                    switch (type) {
	                        case 'IOC':
	                            return '#CCCCCC';
	                        case 'IOC Severity':
	                            return '#FF172F';
	                        case 'Conn':
	                            return '#CF4E77';
	                        case 'Stealth':
	                            return '#0080CE';
	                        case 'Stealth_drop':
	                            return '#FF172F';
	                        case 'Applications':
	                            return '#B77A33';
	                        case 'DNS':
	                            return '#A39D39';
	                        case 'HTTP':
	                            return '#8CC63F';
	                        case 'SSL':
	                            return '#6BD36D';
	                        case 'Email':
	                            return '#49E19B';
	                        case 'File':
	                            return '#28D4B1';
	                        case 'Endpoint':
	                            return '#00C6C7';
	                        case 'Active Defense':
	                            return '#047CA1';
	                        default:
	                            return '#666';
	                    }
	                }
	
	                function hoverPoint(elm, action, type) {
	                    if (type.search('Conn_ioc') !== -1) {
	                        var nElm = elm.select('.hover-ioc');
	                        if (action === 'mouseover') {
	                            elm.classed('hover-active', true);
	                            nElm.attr('transform', 'scale(2.4) translate(-4, -5)');
	                        } else if (action === 'mouseout') {
	                            elm.classed('hover-active', false);
	                            nElm.attr('transform', 'scale(1)');
	                        }
	                    } else {
	                        if (elm !== undefined) {
	                            var nElm = elm.select('.hover-square');
	                            if (action === 'mouseover') {
	                                elm.classed('hover-active', true);
	                                nElm.attr('transform', 'scale(2.4) translate(-3, -5) ').attr('stroke', '#fff').attr('stroke-width', '1');
	                            } else if (action === 'mouseout') {
	                                elm.classed('hover-active', false);
	                                nElm.transition().duration(550).attr('transform', 'scale(1)').attr('stroke', 'none').attr('stroke-width', '0');
	                            }
	                        }
	                    }
	                    return;
	                }
	
	                function clearNodes() {
	                    clearVerticalLine();
	                    itemRects.selectAll('.node-active').each(function (d) {
	                        hoverPoint(d3.select(this), 'mouseout', d.type);
	                        d3.select(this).classed('node-active', false);
	                    });
	                    itemRects.selectAll('.hover-active').each(function (d) {
	                        hoverPoint(d3.select(this), 'mouseout', d.type);
	                        d3.select(this).classed('hover-active', false);
	                    });
	                    itemRects.selectAll('.eventFocus').remove();
	                }
	
	                function clearVerticalLine() {
	                    clickLine.selectAll('line').remove();
	                }
	
	                function appendVerticalLine(d) {
	                    clickLine.append('line').attr('x1', x1(d.dd) + 7).attr('y1', m[0]).attr('x2', x1(d.dd) + 7).attr('y2', mainHeight).attr('stroke-width', '1').attr('stroke', '#FFF');
	                }
	
	                function drawLinkConnections() {
	                    lineStory.selectAll('line').remove();
	                    // return immediately if search is not enabled
	                    if (!$scope.pattern.searching || $scope.pattern.selected.length <= 1) {
	                        return;
	                    }
	                    var sortArr = [];
	
	                    function reorder(a, b) {
	                        if (a.order < b.order) return -1;
	                        if (a.order > b.order) return 1;
	                        return 0;
	                    }
	                    // draw line links
	                    for (var i in $scope.pattern.selected) {
	                        sortArr.push($scope.pattern.selected[i]);
	                    }
	                    // sort array based on object order
	                    sortArr.sort(reorder);
	                    // loop through our sorted array and begin drawing lines
	                    for (var i = 1; i < sortArr.length - 1; i++) {
	                        if (typeof sortArr[i] != 'number') {
	                            lineStory.append('line').attr('x1', x1(sortArr[i].point.dd) + 7).attr('y1', y1(sortArr[i].point.lane)).attr('x2', x1(sortArr[i + 1].point.dd) + 7).attr('y2', y1(sortArr[i + 1].point.lane)).attr('stroke-width', 1).attr('stroke', '#fff');
	                        }
	                    }
	                }
	
	                function changeIcon(element, data) {
	                    var color, select;
	                    // set the current highlighted point
	                    $scope.highlightedPoint = data;
	                    // select previous sctive node and deselect it
	                    var prevElm = itemRects.select('g .node-active');
	                    prevElm.select('.eventFocus').remove();
	                    prevElm.classed('node-active', false);
	                    // set this new element as active
	                    element.classed('node-active', true);
	                    // deselect any nodes that do not match our conn_uid
	                    itemRects.selectAll('.hover-active').each(function (d) {
	                        var elm = d3.select(this);
	                        if (d.conn_uid !== data.conn_uid) {
	                            hoverPoint(elm, 'mouseout', d.type);
	                        }
	                    });
	                    if (data.conn_uid + '-' + data.type in $scope.pattern.selected) {
	                        // if id is in our select object, retain select status
	                        select = true;
	                    } else {
	                        // otherwise remove it
	                        select = false;
	                    }
	                    element.classed('node-' + data.id, true);
	                    element = element.append('g');
	                    element.attr('transform', 'translate(-11, -9)');
	                    if ($('.node-' + data.id + ' .eventStory')[0]) {
	                        element.classed('active-pattern', false);
	                        $('.node-' + data.id + ' .eventStory')[0].remove();
	                    }
	                    if ($('.node-' + data.id + ' .eventFocus')[0]) {
	                        $('.node-' + data.id + ' .eventFocus')[0].remove();
	                    }
	                    if (select) {
	                        element.classed('eventStory', true);
	                        element.classed('active-pattern', true);
	                    } else if (!(data.conn_uid + '-' + data.type in $scope.pattern.selected)) {
	                        element.classed('eventFocus', true);
	                    }
	                    if (data.type.search('ioc') !== -1) {
	                        element.classed('IOC', true);
	                        element.append('svg:polygon').attr('transform', 'scale(2) translate(2, 0)').attr('points', '7,15 14,6 0,6').attr('fill', rowColors('IOC'));
	                        element.append('svg:polygon').attr('transform', 'translate(0, 2)').attr('points', '19.037,21.038 19.626,12.029 15.888,12.029 16.477,21.038 ').attr('fill', '#595A5C');
	                        element.append('rect').attr('transform', 'translate(0, 2)').attr('x', 16.376).attr('y', 22.045).attr('fill', '#595A5C').attr('width', 2.838).attr('height', 2.448);
	                        // return;
	                    } else {
	                        var color, color1, color2;
	                        element.append('rect').attr('x', 0).attr('y', 0).attr('stroke-width', 1).attr('stroke', '#fff').attr('fill', function (d) {
	                            if (data.type === 'IOC Severity') {
	                                switch (d.ioc_severity) {
	                                    case 1:
	                                        color = '#377FC7';
	                                        break;
	                                    case 2:
	                                        color = '#F5D800';
	                                        break;
	                                    case 3:
	                                        color = '#F88B12';
	                                        break;
	                                    case 4:
	                                        color = '#DD122A';
	                                        break;
	                                    default:
	                                        color = '#6FBF9B';
	                                }
	                            } else {
	                                color = rowColors(data.type);
	                            }
	                            color2 = '#3f3f3f';
	                            color1 = color;
	                            if (select) {
	                                color1 = '#3f3f3f';
	                                color2 = color;
	                            }
	                            return color2;
	                        }).attr('width', 36).attr('height', 36);
	                        laneRowSymbols(data.type, element, color1, color2);
	                    }
	                    // a few functions may not want to highight same nodes on brush, so its set as a parameter
	                    setTimeout(function () {
	                        // this is a temporary fix to an unknown issue reguarding this firing too soon
	                        // highlight all nodes matching the uid
	                        itemRects.selectAll('g').each(function (d) {
	                            if (d.conn_uid === undefined) {
	                                return;
	                            }
	                            // select nodes that match
	                            var elm = d3.select(this);
	
	                            if (d.conn_uid === data.conn_uid && d.id !== data.id) {
	                                if (data.conn_uid + '-' + data.type in $scope.pattern.selected) {
	                                    return;
	                                }
	                                hoverPoint(elm, 'mouseover', d.type);
	                            }
	                        });
	                    }, 10);
	                    // draw link nodes
	                    drawLinkConnections();
	                }
	
	                function addSearch(point, data) {
	                    var thisNode = itemRects.select('.node-' + point.id);
	                    if (!(point.conn_uid + '-' + point.type in $scope.pattern.selected)) {
	                        // add empty obect with point id in search
	                        $scope.pattern.selected[point.conn_uid + '-' + point.type] = {};
	                        $scope.pattern.selected.length++;
	                        // insert point information (for redrawing later)
	                        $scope.pattern.selected[point.conn_uid + '-' + point.type].point = point;
	                        // count up order in which items were selected
	                        $scope.pattern.selected[point.conn_uid + '-' + point.type].order = $scope.pattern.order;
	                        $scope.pattern.order++;
	                        // create search object for our selected data
	                        $scope.pattern.selected[point.conn_uid + '-' + point.type].search = {
	                            length: 0
	                        };
	                        // insert our selected data with name as key
	                        $scope.pattern.selected[point.conn_uid + '-' + point.type].search[data.name] = data;
	                        $scope.pattern.selected[point.conn_uid + '-' + point.type].search.length++;
	                        // add class to point
	                        changeIcon(thisNode, point);
	                    } else {
	                        // if data is not in point object, add it
	                        if (!(data.name in $scope.pattern.selected[point.conn_uid + '-' + point.type].search)) {
	                            $scope.pattern.selected[point.conn_uid + '-' + point.type].search[data.name] = data;
	                            $scope.pattern.selected[point.conn_uid + '-' + point.type].search.length++;
	                        } else {
	                            // remove data if it already exists
	                            delete $scope.pattern.selected[point.conn_uid + '-' + point.type].search[data.name];
	                            $scope.pattern.selected[point.conn_uid + '-' + point.type].search.length--;
	                        }
	                        // remove point if its empty after changes
	                        if ($scope.pattern.selected[point.conn_uid + '-' + point.type].search.length === 0) {
	                            delete $scope.pattern.selected[point.conn_uid + '-' + point.type];
	                            $scope.pattern.selected.length--;
	                        }
	                    }
	                    // update style of point if there is no selected data in it
	                    if (!(point.conn_uid + '-' + point.type in $scope.pattern.selected)) {
	                        changeIcon(thisNode, point);
	                    }
	                }
	
	                // logic for add/remove buttons in sidebar (when patterns are on)
	                function addRemoveBtn(row, data, elm) {
	                    elm.select('svg').empty(); // this will redraw all on every click (not very efficient, but we'll fix this later)
	                    function addBtn() {
	                        elm.append('rect').attr('width', addRemBtnDimensions[0]).attr('height', addRemBtnDimensions[1]).style('fill', '#AAAAAA');
	                        elm.append('path').attr('d', 'M5.7,0v4.4H10v1.2H5.7V10H4.3V5.6H0V4.4h4.3V0H5.7z').style('fill', '#fff').attr('transform', 'translate(10,4)');
	                    }
	
	                    function removeBtn() {
	                        elm.append('rect').attr('width', addRemBtnDimensions[0]).attr('height', addRemBtnDimensions[1]).style('fill', '#8cc63f');
	                        elm.append('polygon').attr('points', '5.7,0 5.7,4.4 10,4.4 10,5.6 5.7,5.6 5.7,10 4.3,10 4.3,5.6 0,5.6 0,4.4 4.3,4.4 4.3,0 ').style('fill', '#fff').attr('transform', 'rotate(45, 5, 18)');
	                    }
	                    if (!row.pattern) {
	                        return;
	                    };
	                    if (data.conn_uid + '-' + data.type in $scope.pattern.selected) {
	                        if (row.name in $scope.pattern.selected[data.conn_uid + '-' + data.type].search) {
	                            return removeBtn();
	                        } else {
	                            return addBtn();
	                        }
	                    } else {
	                        return addBtn();
	                    }
	                }
	
	                // logic for appending row information in sidebar
	                function laneInfoAppend(data, element) {
	                    element.select('.infoDivExpanded').selectAll('li').remove();
	                    var line = element.select('.infoDivExpanded').selectAll('li').data(data.expand).enter().append('li').style('line-height', 2.4).html(function (d) {
	                        if (d.name === 'Time') {
	                            return '<strong>' + d.name + ':</strong> ' + timeFormat(d.value, 'laneGraphExpanded') + '';
	                        } else {
	                            return '<strong>' + d.name + ':</strong> ' + String(d.value).replace('N/A', '-') + '';
	                        }
	                    });
	                    if ($scope.pattern.searching) {
	                        line.each(function (d) {
	                            var elm = d3.select(this).append('div').style('float', 'right').append('svg').attr('width', addRemBtnDimensions[0]).attr('height', addRemBtnDimensions[1]);
	                            addRemoveBtn(d, data, elm);
	                            elm.on('click', function (d) {
	                                addSearch(data, d);
	                                addRemoveBtn(d, data, elm);
	                            });
	                        });
	                    }
	                }
	
	                function draw() {
	                    // reset navagation array
	                    navArray = [];
	                    // set current position in nav array
	                    currentNavPos = 0;
	                    // disable all nav buttons
	                    prevButton.attr('disabled', 'disabled');
	                    nextButton.attr('disabled', 'disabled');
	                    resetBtn.attr('disabled', 'disabled');
	                    $scope.alert.style('display', 'none');
	                    $scope.highlightedPoint = false;
	                    clearVerticalLine();
	                    // push current time position to nav array
	                    navArray.push({
	                        'min': new Date($scope.start * 1000),
	                        'max': new Date($scope.end * 1000),
	                        'isViewAll': false
	                    });
	                    // push time slice heading t odiv
	                    currentTime.html('Current Time Slice: <strong>' + $scope.start * 1000 + '</strong> - <strong>' + $scope.end * 1000 + '</strong>');
	                    // convert min and max to date object and send to plot function
	                    var min = $scope.start * 1000;
	                    var max = $scope.end * 1000;
	                    clearAllFilters();
	                    plot(itemsDimension, min, max);
	                }
	
	                // this function finds what's clicked on brush and adds flag to values for redraw highlighting
	                function reHighlightPoints(timeObj) {
	                    itemRects.select('g .eventFocus').node(function (d) {
	                        // if the point sits within the time space add flag for highlight (or add to external object for refrence later)
	                        if (d.time > timeObj.min && d.time < timeObj.max) {
	                            $scope.highlightedPoint = d;
	                        }
	                    });
	                    // compare against time interval and highlight if any points fall within
	                    // 'turn on' points that are in our pattern object that fall within the time slice (if paterns are turned on)
	                }
	
	                function viewAll() {
	                    // initial_ioc = undefined;
	                    ioc_initialized = false;
	                    laneNodeIndex = {};
	                    var selectedNode = d3.select('.node-active').data()[0];
	                    // viewAll = true;
	                    if (selectedNode) {
	                        clearDeepData();
	                        $scope.inTooDeep.areWe = false;
	                        var minUnix = selectedNode.time - offsetTime;
	                        var maxUnix = selectedNode.time + offsetTime;
	                        clearVerticalLine();
	                        clearAllFilters();
	                        // step up nav array pos and push new values in;
	                        currentNavPos++;
	                        // $scope.inTooDeep.areWe = true;
	                        navArray.push({
	                            'min': new Date(minUnix * 1000),
	                            'max': new Date(maxUnix * 1000),
	                            'isViewAll': true
	                        });
	                        navArray = navArray.slice(0, currentNavPos + 1);
	                        prevButton.attr('disabled', null);
	                        resetBtn.attr('disabled', null);
	                        reHighlightPoints({
	                            min: minUnix,
	                            max: maxUnix
	                        });
	                        loading('start');
	                        requery(minUnix, maxUnix, function (data) {
	                            loading('end');
	                            plot(data, selectedNode.time - offsetTime, selectedNode.time + offsetTime);
	                            reapplyAllFilters();
	                        });
	                    }
	                }
	
	                function navCrtl(action, time) {
	                    // clear all lines drawn
	                    clearVerticalLine();
	                    clearAllFilters();
	                    laneNodeIndex = {};
	                    // remove lines before doing anything
	                    lineStory.selectAll('line').remove();
	                    // set variables
	                    var rects, labels, minExtent, maxExtent, visItems, isViewAll;
	                    // if a nav button is pressed
	                    if (action === 'nav') {
	                        // get max and min (date objects) from mav array
	                        minExtent = navArray[currentNavPos].min;
	                        maxExtent = navArray[currentNavPos].max;
	                        isViewAll = navArray[currentNavPos].isViewAll;
	                        // disable previous button if all the way back
	                        if (currentNavPos === 0) {
	                            resetBtn.attr('disabled', 'disabled');
	                            prevButton.attr('disabled', 'disabled');
	                            // or disable next button if all the way forward
	                        } else if (currentNavPos === navArray.length - 1) {
	                            nextButton.attr('disabled', 'disabled');
	                        } else {
	                            // otherwise keep reset button open
	                            resetBtn.attr('disabled', null);
	                        }
	                        // otherwise if item brushed
	                    } else if (action === 'reset') {
	                        ioc_initialized = true;
	                        filteredLabel = false;
	                        clearDeepData();
	                        $scope.$broadcast('clearSearch');
	                        // get max and min (date objects) from mav array
	                        minExtent = navArray[currentNavPos].min;
	                        maxExtent = navArray[currentNavPos].max;
	                        isViewAll = navArray[currentNavPos].isViewAll;
	                        // disable previous button if all the way back
	                        resetBtn.attr('disabled', 'disabled');
	                        prevButton.attr('disabled', 'disabled');
	                        nextButton.attr('disabled', 'disabled');
	                        navArray = [navArray[0]];
	                    } else if (action === 'time') {
	                        if (time) {
	                            // get max and min from click/drag
	                            minExtent = time[0];
	                            maxExtent = time[1];
	                            isViewAll = false;
	                            // step up nav array pos and push new values in;
	                            currentNavPos++;
	                            navArray.push({
	                                'min': minExtent,
	                                'max': maxExtent
	                            });
	                            prevButton.attr('disabled', null);
	                            resetBtn.attr('disabled', null);
	                        }
	                    } else {
	                        if (Number(brush.extent()[0]) !== Number(brush.extent()[1])) {
	                            currentNavPos++;
	                            // get max and min from click/drag
	                            minExtent = brush.extent()[0];
	                            maxExtent = brush.extent()[1];
	                            isViewAll = navArray[currentNavPos - 1].isViewAll;
	                            // step up nav array pos and push new values in;
	                            navArray.push({
	                                'min': minExtent,
	                                'max': maxExtent,
	                                'isViewAll': isViewAll
	                            });
	                            navArray = navArray.slice(0, currentNavPos + 1);
	                            prevButton.attr('disabled', null);
	                        } else {
	                            return;
	                        }
	                    }
	                    // convert times returned to unix
	                    var minUnix = (0, _moment2.default)(minExtent).unix();
	                    var maxUnix = (0, _moment2.default)(maxExtent).unix();
	                    // call the rehightlight function
	                    reHighlightPoints({
	                        min: minUnix,
	                        max: maxUnix
	                    });
	                    // should it requery?
	                    var msDifference = maxUnix - minUnix;
	                    // if difference is less than threshhold or is not a single time select (resulting in difference being 0)
	                    if (isViewAll) {
	                        $scope.alert.style('display', 'block');
	                        $scope.inTooDeep.areWe = true;
	                        var data = deepDimension.filter(function (d) {
	                            return d;
	                        });
	                        loading('end');
	                        plot(data, minExtent, maxExtent);
	                        reapplyAllFilters();
	                    } else {
	                        // clear all the filters
	                        // reset if not within threshold
	                        $scope.inTooDeep.areWe = false;
	                        deepDimension.filter(function (d) {
	                            return !d;
	                        });
	                        var data = itemsDimension.filter(function (d) {
	                            return d < maxExtent && d > minExtent;
	                        });
	                        $scope.alert.style('display', 'none');
	                        plot(data, minExtent, maxExtent);
	                        reapplyAllFilters();
	                        // reset filters to what they previously were
	                    }
	                }
	
	                $scope.$on('outFilter', function (event, type, time) {
	                    navCrtl(type, time);
	                });
	
	                function clearDeepData() {
	                    searchDimension.filterAll(); // clear the search dimension
	                    deepDimension.filter(function (d, i) {
	                        return d;
	                    }); // refilter down to what needs to be removed
	                    $scope.crossfilterData.remove(); // delete the data that has been filtered
	                    searchDimension.filterAll(); // clear the filter again
	                }
	
	                function clearAllFilters() {
	                    typeDimension.filterAll();
	                    deepDimension.filterAll();
	                    searchDimension.filterAll();
	                }
	
	                function filterType(label, action, elm) {
	                    var classString = elm;
	                    if (d3.select(elm)[0][0] && d3.select(elm)[0][0].textContent.toLowerCase() !== '') {
	                        classString = '.' + d3.select(elm)[0][0].textContent.toLowerCase().replace(' ', '_');
	                    }
	
	                    d3.select('.main').selectAll('.lane_icon').style('stroke', function (d) {
	                        if (d !== 'IOC') {
	                            return 'none';
	                        }
	                        return 'auto';
	                    }).style('stroke-width', function (d) {
	                        if (d !== 'IOC') {
	                            return '0';
	                        }
	                        return 'auto';
	                    });
	                    if (label === filteredLabel && action === 'click') {
	                        if (filteredLabel === 'IOC') {
	                            d3.select(classString).style('stroke', '#fff').style('stroke-width', '0');
	                        }
	                        searchDimension.filter(function (d) {
	                            return d;
	                        });
	                        var data = typeDimension.filter(function (d) {
	                            return d;
	                        });
	                        filteredLabel = false;
	                        grayOutIcons(data);
	                    } else if (label === 'IOC') {
	                        var iocTime = [];
	                        typeDimension.filter(function (d) {
	                            return d;
	                        });
	                        searchDimension.filter(function (d) {
	                            if (d.type === 'Conn_ioc') {
	                                iocTime.push(d.conn_uid);
	                            }
	                            return d;
	                        });
	                        var data = searchDimension.filter(function (d) {
	                            return iocTime.indexOf(d.conn_uid) !== -1;
	                        });
	                        plot(data, navArray[currentNavPos].min, navArray[currentNavPos].max);
	                        filteredLabel = label;
	                        d3.select(classString).style('stroke', '#fff').style('stroke-width', '1.5');
	                    } else {
	                        var data = typeDimension.filter(function (d) {
	                            return d === label || d === label + '_drop';
	                        });
	                        grayOutIcons(data);
	                        filteredLabel = label;
	                        d3.select(classString).style('stroke', '#fff').style('stroke-width', '1.5');
	                    }
	                    $scope.alert.style('display', 'none');
	                    redrawInfo(data, navArray[currentNavPos].min, navArray[currentNavPos].max);
	                    // grayOutIcons(data);
	                }
	
	                function filterSearch() {
	                    var data = searchDimension.filter(function (data) {
	                        for (var d in data) {
	                            if (String(data[d]).toLowerCase().indexOf($scope.search) !== -1) {
	                                return data;
	                            }
	                        }
	                    });
	                    $scope.alert.style('display', 'none');
	                    redrawInfo(data, navArray[currentNavPos].min, navArray[currentNavPos].max);
	                }
	
	                function reapplyAllFilters(min, max) {
	                    if (filteredLabel) {
	                        filterType(filteredLabel);
	                    }
	
	                    if ($scope.search !== '') {
	                        // filterSearch();
	                    }
	                }
	
	                function grayOutIcons(dimension) {
	                    var data = dimension.top(Infinity);
	                    var dataLen = data.length;
	                    var hasID = true;
	                    if (itemRects.selectAll('.eventSquare rect')[0].length > data.length) {
	                        itemRects.selectAll('.eventSquare rect').each(function (d) {
	                            hasID = true;
	                            for (var i = 0; i < dataLen; i++) {
	                                if (d.id === data[i].id) {
	                                    hasID = false;
	                                }
	                            }
	                            if (hasID) {
	                                d3.select(this).attr('fill', '#999');
	                            } else {
	                                d3.select(this).attr('fill', function (d) {
	                                    var color;
	                                    if (d.type === 'IOC Severity') {
	                                        if (d.ioc_severity === 1) {
	                                            color = '#377FC7';
	                                        } else if (d.ioc_severity === 2) {
	                                            color = '#F5D800';
	                                        } else if (d.ioc_severity === 3) {
	                                            color = '#F88B12';
	                                        } else if (d.ioc_severity === 4) {
	                                            color = '#DD122A';
	                                        } else {
	                                            color = '#6FBF9B';
	                                        }
	                                    } else {
	                                        color = rowColors(d.type);
	                                    }
	                                    return color;
	                                });
	                            }
	                        });
	                    } else {
	                        plot(dimension, navArray[currentNavPos].min, navArray[currentNavPos].max);
	                    }
	                }
	
	                function scrollSide(id) {
	                    var elm = $('li#' + id);
	                    if (elm.length !== 0) {
	                        var ept = elm.position().top;
	                        var eppt = elm.parent().position().top;
	                        var offset = ept - eppt;
	                        var totalHeight = $('.divScroll')[0].scrollHeight;
	                        var windowHeight = $('.divScroll').height();
	                        if (offset > totalHeight - windowHeight) {
	                            offset = totalHeight - windowHeight;
	                        }
	                        $('.divScroll').scrollTo(offset);
	                    }
	                }
	
	                function uidsMatch(data) {
	                    // compares 2 objects 2 ids - current use is to determine if a point should be zommed out if moused over
	                    if ($scope.highlightedPoint.conn_uid === data.conn_uid) {
	                        return true;
	                    }
	                    return false;
	                }
	
	                function redrawInfo(dimension, min, max) {
	                    var isOpen = null,
	                        data = dimension.top(Infinity);
	
	                    if ((0, _moment2.default)(max).unix() !== (0, _moment2.default)(min).unix()) {
	                        ////////////////////
	                        /// SIDEBAR LIST ///
	                        ////////////////////
	                        infoDiv.selectAll('li').remove();
	                        infoDiv.selectAll('li').data(data).enter().append('li').each(function (d) {
	                            var elm = d3.select(this);
	                            elm
	                            // append id to li from data object
	                            .attr('id', function (d) {
	                                return d.id;
	                            }).attr('class', 'scroll-' + d.id + ' laneInfo').html(function (d) {
	                                return '<div class="lanegraphlist"><strong>' + timeFormat(d.time, 'laneGraphPreview') + ':</strong> ' + d.info + '</div>';
	                            }).on('click', function () {
	                                // do nothing if already active
	                                if (elm.classed('laneactive')) {
	                                    return;
	                                }
	                                // add lines
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                var thisNode = itemRects.select('.node-' + d.id);
	                                changeIcon(thisNode, d);
	                                // select any active pointunhighlight and collapse
	                                openScrollSide2(d);
	                                $scope.pattern.last = {
	                                    element: elm,
	                                    data: d
	                                };
	                            })
	                            // append expand buttons to list elements
	                            .append('div').on('click', function () {
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                var thisNode = itemRects.select('.node-' + d.id);
	                                // select any active pointunhighlight and collapse
	                                if (isOpen === d.id) {
	                                    elm.select('.infoDivExpanded').style('display', 'none');
	                                    isOpen = null;
	                                } else {
	                                    elm.select('.infoDivExpanded').style('display', 'block');
	                                    isOpen = d.id;
	                                    laneInfoAppend(d, elm);
	                                }
	                                scrollSide(d.id);
	                                changeIcon(thisNode, d);
	                            }).attr('class', 'infoDivExpandBtn').html('+');
	                            elm.append('div').style('display', 'none').attr('class', 'infoDivExpanded').attr('id', d.id);
	                            // SIDE NODE LOADING
	                            // if there is a point selected, scroll to it on sidebar
	                            if ($scope.highlightedPoint.conn_uid === d.conn_uid && $scope.highlightedPoint.type === d.type) {
	                                openScrollSide2(d);
	                            }
	                        });
	                    }
	                }
	
	                var isOpen;
	
	                function openScrollSide2(d) {
	                    var sideSelected = d3.select('.scroll-' + d.id);
	                    // set last object before otehr functions run
	                    $scope.pattern.last = {
	                        element: sideSelected,
	                        data: d
	                        // close previous bar
	                    };var lastbar = infoDiv.select('li.laneactive').classed('laneactive', false).classed('laneopen', false);
	                    lastbar.select('.infoDivExpanded').style('display', 'none');
	                    if ($('#autoexpand').is(':checked')) {
	                        sideSelected.classed('laneopen', true);
	                        sideSelected.select('.infoDivExpanded').style('display', 'block');
	                        isOpen = d.id;
	                        // append different info if searching is enabled (i.e. checkboxes)
	                        laneInfoAppend(d, sideSelected);
	                    }
	                    // set class for active description
	                    sideSelected.classed('laneactive', true);
	                    // scroll to position
	                    scrollSide(d.id);
	                }
	
	                function plot(dimension, min, max) {
	                    // bar selecting
	                    var isOpen = null,
	                        data = dimension.top(Infinity);
	
	                    function openScrollSide(d) {
	                        var sideSelected = d3.select('.scroll-' + d.id);
	                        // set last object before otehr functions run
	                        $scope.pattern.last = {
	                            element: sideSelected,
	                            data: d
	                            // close previous bar
	                        };var lastbar = infoDiv.select('li.laneactive').classed('laneactive', false).classed('laneopen', false);
	                        lastbar.select('.infoDivExpanded').style('display', 'none');
	                        if ($('#autoexpand').is(':checked')) {
	                            if (isOpen === d.id) {
	                                sideSelected.classed('laneopen', false);
	                                sideSelected.select('.infoDivExpanded').style('display', 'none');
	                                isOpen = null;
	                            } else {
	                                sideSelected.classed('laneopen', true);
	                                sideSelected.select('.infoDivExpanded').style('display', 'block');
	                                isOpen = d.id;
	                                // append different info if searching is enabled (i.e. checkboxes)
	                                laneInfoAppend(d, sideSelected);
	                            }
	                        }
	                        // set class for active description
	                        sideSelected.classed('laneactive', true);
	                        // scroll to position
	                        scrollSide(d.id);
	                    }
	
	                    // default squares and rectangles
	                    $scope.point = function (element, type, name, id) {
	                        element.classed('node-' + id, true);
	                        element.classed('node', true);
	                        element = element.append('g');
	                        element.classed('eventSquare', true);
	                        if (type.search('ioc') !== -1) {
	                            element.classed('IOC', true);
	                            element.append('svg:polygon').classed('hover-ioc', true).attr('points', '7,15 14,6 0,6').attr('fill', rowColors('IOC')).style('opacity', '0.4').on('mouseover', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                if (d.conn_uid === undefined) {
	                                    return;
	                                }
	                                hoverPoint(elm, 'mouseover', d.type);
	                            }).on('mouseout', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                if (!uidsMatch(d)) {
	                                    hoverPoint(elm, 'mouseout', d.type);
	                                }
	                            });
	                            return;
	                        } else {
	                            element.append('rect').classed('hover-square', true).attr('x', 0).attr('y', 3).attr('fill', function (d) {
	                                var color;
	                                if (type === 'IOC Severity') {
	                                    if (d.ioc_severity === 1) {
	                                        color = '#377FC7';
	                                    } else if (d.ioc_severity === 2) {
	                                        color = '#F5D800';
	                                    } else if (d.ioc_severity === 3) {
	                                        color = '#F88B12';
	                                    } else if (d.ioc_severity === 4) {
	                                        color = '#DD122A';
	                                    } else {
	                                        color = '#6FBF9B';
	                                    }
	                                } else {
	                                    color = rowColors(type);
	                                }
	                                return color;
	                            }).attr('width', 12).attr('height', 12).style('opacity', '0.6').on('mouseover', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                hoverPoint(elm, 'mouseover', d.type);
	                            }).on('mouseout', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                if (d.conn_uid === undefined) {
	                                    hoverPoint(elm, 'mouseout', d.type);
	                                }
	                                if (!uidsMatch(d)) {
	                                    hoverPoint(elm, 'mouseout', d.type);
	                                }
	                            });
	                        }
	                    };
	
	                    if ((0, _moment2.default)(max).unix() !== (0, _moment2.default)(min).unix()) {
	                        $scope.kcstart = (0, _moment2.default)(min).format('MMMM D, YYYY HH:mm A');
	                        $scope.kcend = (0, _moment2.default)(max).format('MMMM D, YYYY HH:mm A');
	                        //////////////////
	                        /// LANE NODES ///
	                        //////////////////
	                        // update time slice above chart
	                        currentTime.html('Current Time Slice: <strong>' + (0, _moment2.default)(min).format('MMMM D, YYYY HH:mm A') + '</strong> - <strong>' + (0, _moment2.default)(max).format('MMMM D, YYYY HH:mm A') + '</strong>');
	                        // create transition effect of slider
	                        main.select('g.brush .extent').transition().duration(150).attr('width', w).transition().duration(50).attr('width', 0);
	                        // set new domain and transition x-axis
	                        x1.domain([min, max]);
	                        xAxisBrush.transition().duration(500).call(xAxis);
	                        // remove existing elements (perhaps this is innificent and should be modified to just transition)
	                        itemRects.selectAll('g').remove();
	                        var icons = itemRects.selectAll('g').data(data);
	                        // re-enter an append nodes (innificent as well)
	                        icons.enter().append('g').each(function (d) {
	                            setLaneNodeIndexs(d);
	                            var elm = d3.select(this);
	                            elm.attr('transform', 'translate(' + x1(d.dd) + ',' + (y1(d.lane) - 10) + ')').on('click', function (d) {
	                                openScrollSide(d);
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                changeIcon(elm, d);
	                            });
	                            // LANE NODE LOADING
	                            // if there's anything in our highlightPoint variable, use the information to highlight data and then clear
	                            if ($scope.highlightedPoint.conn_uid === d.conn_uid && $scope.highlightedPoint.type === d.type) {
	                                isOpen = d.id;
	                                openScrollSide(d);
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                changeIcon(elm, d);
	                            }
	                            // change if node is in pattern
	                            if (d.conn_uid + '-' + d.type in $scope.pattern.selected) {
	                                changeIcon(elm, d);
	                            }
	                            drawLinkConnections();
	
	                            // generate points from point function
	                            if (d.type !== 'l7') {
	                                $scope.point(elm, d.type, null, d.id);
	                            } else {
	                                // push app name to point function if type is l7
	                                $scope.point(elm, d.type, d.l7_proto, d.id);
	                            }
	                        });
	                        icons.exit();
	
	                        ////////////////////
	                        /// SIDEBAR LIST ///
	                        ////////////////////
	                        infoDiv.selectAll('li').remove();
	                        infoDiv.selectAll('li').data(data).enter().append('li').each(function (d) {
	                            var elm = d3.select(this);
	                            maxID = Math.max(maxID, d.id);
	
	                            elm
	                            // append id to li from data object
	                            .attr('id', function (d) {
	                                return d.id;
	                            }).attr('class', 'scroll-' + d.id + ' laneInfo').html(function (d) {
	                                return '<div class="lanegraphlist"><strong>' + timeFormat(d.time, 'laneGraphPreview') + ':</strong> ' + d.info + '</div>';
	                            }).on('click', function () {
	                                // do nothing if already active
	                                if (elm.classed('laneactive')) {
	                                    return;
	                                }
	                                // add lines
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                var thisNode = itemRects.select('.node-' + d.id);
	                                changeIcon(thisNode, d);
	                                // select any active pointunhighlight and collapse
	                                openScrollSide(d);
	                                $scope.pattern.last = {
	                                    element: elm,
	                                    data: d
	                                };
	                                d3.selectAll('.infoDivExpandBtn').html(function (d) {
	                                    if (isOpen === d.id) {
	                                        return '-';
	                                    }
	                                    return '+';
	                                });
	                            })
	                            // append expand buttons to list elements
	                            .append('div').on('click', function () {
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                var thisNode = itemRects.select('.node-' + d.id);
	                                // select any active pointunhighlight and collapse
	                                if (isOpen === d.id) {
	                                    elm.select('.infoDivExpanded').style('display', 'none');
	                                    isOpen = null;
	                                } else {
	                                    elm.select('.infoDivExpanded').style('display', 'block');
	                                    isOpen = d.id;
	                                    laneInfoAppend(d, elm);
	                                }
	                                scrollSide(d.id);
	                                changeIcon(thisNode, d);
	                                d3.selectAll('.infoDivExpandBtn').html('+');
	                                d3.select(this).html(function (d) {
	                                    if (isOpen === d.id) {
	                                        return '-';
	                                    }
	                                    return '+';
	                                });
	                            }).attr('class', 'infoDivExpandBtn').html('+');
	                            elm.append('div').style('display', 'none').attr('class', 'infoDivExpanded').attr('id', d.id);
	                            // SIDE NODE LOADING
	                            // if there is a point selected, scroll to it on sidebar
	                            if ($scope.highlightedPoint.conn_uid === d.conn_uid && $scope.highlightedPoint.type === d.type) {
	                                openScrollSide(d);
	                            }
	                        });
	                    }
	
	                    if (ioc_initialized) {
	                        var drawInitialIOC = function drawInitialIOC(d) {
	                            var elm = d3.select('.node-' + d.id);
	                            openScrollSide2(d);
	                            clearVerticalLine();
	                            appendVerticalLine(d);
	                            changeIcon(elm, d);
	                        };
	
	                        drawInitialIOC(initial_ioc);
	                    }
	                    orderNodeIndex();
	                }
	
	                function setLaneNodeIndexs(node) {
	                    if (Object.keys(laneNodeIndex).indexOf(node.type) === -1) {
	                        laneNodeIndex[node.type] = [node.id];
	                    } else {
	                        if (laneNodeIndex[node.type].indexOf(node.id) === -1) {
	                            laneNodeIndex[node.type].push(node.id);
	                        }
	                    }
	                }
	
	                function redraw(data, min, max) {
	                    // default squares and rectangles
	                    function point(element, type, name, id) {
	                        element.classed('node-' + id, true);
	                        element.classed('node', true);
	                        element = element.append('g');
	                        if (type.search('ioc') !== -1) {
	                            element.classed('IOC', true);
	                            element.append('svg:polygon').classed('hover-ioc', true).attr('points', '7,15 14,6 0,6').attr('fill', rowColors('IOC')).style('opacity', '0.4').on('mouseover', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                if (d.conn_uid === undefined) {
	                                    return;
	                                }
	                                hoverPoint(elm, 'mouseover', d.type);
	                            }).on('mouseout', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                if (!uidsMatch(d)) {
	                                    hoverPoint(elm, 'mouseout', d.type);
	                                }
	                            });
	                            return;
	                        } else {
	                            element.append('rect').classed('hover-square', true).attr('x', 0).attr('y', 3).attr('fill', function (d) {
	                                var color;
	                                if (type === 'IOC Severity') {
	                                    if (d.ioc_severity === 1) {
	                                        color = '#377FC7';
	                                    } else if (d.ioc_severity === 2) {
	                                        color = '#F5D800';
	                                    } else if (d.ioc_severity === 3) {
	                                        color = '#F88B12';
	                                    } else if (d.ioc_severity === 4) {
	                                        color = '#DD122A';
	                                    } else {
	                                        color = '#6FBF9B';
	                                    }
	                                } else {
	                                    color = rowColors(type);
	                                }
	                                return color;
	                            }).attr('width', 12).attr('height', 12).style('opacity', '0.6').on('mouseover', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                hoverPoint(elm, 'mouseover', d.type);
	                            }).on('mouseout', function (d) {
	                                var elm = d3.select(this.parentNode);
	                                if (d.conn_uid === undefined) {
	                                    hoverPoint(elm, 'mouseout', d.type);
	                                }
	                                if (!uidsMatch(d)) {
	                                    hoverPoint(elm, 'mouseout', d.type);
	                                }
	                            });
	                        }
	                    }
	
	                    if ((0, _moment2.default)(max).unix() !== (0, _moment2.default)(min).unix()) {
	                        $scope.kcstart = (0, _moment2.default)(min).format('MMMM D, YYYY HH:mm A');
	                        $scope.kcend = (0, _moment2.default)(max).format('MMMM D, YYYY HH:mm A');
	                        //////////////////
	                        /// LANE NODES ///
	                        //////////////////
	                        // update time slice above chart
	                        currentTime.html('Current Time Slice: <strong>' + (0, _moment2.default)(min).format('MMMM D, YYYY HH:mm A') + '</strong> - <strong>' + (0, _moment2.default)(max).format('MMMM D, YYYY HH:mm A') + '</strong>');
	                        // remove existing elements (perhaps this is innificent and should be modified to just transition)
	                        itemRects.selectAll('.g').data(data).enter().append('g').each(function (d) {
	                            setLaneNodeIndexs(d);
	                            var elm = d3.select(this);
	                            elm.attr('transform', 'translate(' + x1(d.dd) + ',' + (y1(d.lane) - 10) + ')').on('click', function (d) {
	                                openScrollSide2(d);
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                changeIcon(elm, d);
	                            });
	                            // LANE NODE LOADING
	                            // if there's anything in our highlightPoint variable, use the information to highlight data and then clear
	                            if ($scope.highlightedPoint.conn_uid === d.conn_uid && $scope.highlightedPoint.type === d.type) {
	                                isOpen = d.id;
	                                openScrollSide2(d);
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                changeIcon(elm, d);
	                            }
	                            // change if node is in pattern
	                            if (d.conn_uid + '-' + d.type in $scope.pattern.selected) {
	                                changeIcon(elm, d);
	                            }
	                            drawLinkConnections();
	
	                            if (itemRects[0][0].querySelector('.node-' + d.id) !== null) {
	                                return;
	                            }
	                            // generate points from point function
	                            if (d.type !== 'l7') {
	                                point(elm, d.type, null, d.id);
	                            } else {
	                                // push app name to point function if type is l7
	                                point(elm, d.type, d.l7_proto, d.id);
	                            }
	                        });
	
	                        ////////////////////
	                        /// SIDEBAR LIST ///
	                        ////////////////////
	                        infoDiv.selectAll('.li').data(data).enter().append('li').each(function (d) {
	                            var elm = d3.select(this);
	                            maxID = Math.max(maxID, d.id);
	                            elm
	                            // append id to li from data object
	                            .attr('id', function (d) {
	                                return d.id;
	                            }).attr('class', 'scroll-' + d.id + ' laneInfo').html(function (d) {
	                                return '<div class="lanegraphlist"><strong>' + timeFormat(d.time, 'laneGraphPreview') + ':</strong> ' + d.info.replace('N/A', '-') + '</div>';
	                            }).on('click', function () {
	                                // do nothing if already active
	                                if (elm.classed('laneactive')) {
	                                    return;
	                                }
	                                // add lines
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                var thisNode = itemRects.select('.node-' + d.id);
	                                changeIcon(thisNode, d);
	                                // select any active pointunhighlight and collapse
	                                openScrollSide2(d);
	                                $scope.pattern.last = {
	                                    element: elm,
	                                    data: d
	                                };
	                                d3.selectAll('.infoDivExpandBtn').html(function (d) {
	                                    if (isOpen === d.id) {
	                                        return '-';
	                                    }
	                                    return '+';
	                                });
	                            })
	                            // append expand buttons to list elements
	                            .append('div').on('click', function () {
	                                clearVerticalLine();
	                                appendVerticalLine(d);
	                                var thisNode = itemRects.select('.node-' + d.id);
	                                // select any active pointunhighlight and collapse
	                                if (isOpen === d.id) {
	                                    elm.select('.infoDivExpanded').style('display', 'none');
	                                    isOpen = null;
	                                } else {
	                                    elm.select('.infoDivExpanded').style('display', 'block');
	                                    isOpen = d.id;
	                                    laneInfoAppend(d, elm);
	                                }
	                                scrollSide(d.id);
	                                changeIcon(thisNode, d);
	                                d3.selectAll('.infoDivExpandBtn').html('+');
	                                d3.select(this).html(function (d) {
	                                    if (isOpen === d.id) {
	                                        return '-';
	                                    }
	                                    return '+';
	                                });
	                            }).attr('class', 'infoDivExpandBtn').html('+');
	                            elm.append('div').style('display', 'none').attr('class', 'infoDivExpanded').attr('id', d.id);
	                            // SIDE NODE LOADING
	                            // if there is a point selected, scroll to it on sidebar
	                            if ($scope.highlightedPoint.conn_uid === d.conn_uid && $scope.highlightedPoint.type === d.type) {
	                                openScrollSide2(d);
	                            }
	                        });
	                    }
	
	                    if (ioc_initialized) {
	                        var drawInitialIOC = function drawInitialIOC(d) {
	                            var elm = d3.select('.node-' + d.id);
	                            openScrollSide2(d);
	                            clearVerticalLine();
	                            appendVerticalLine(d);
	                            changeIcon(elm, d);
	                        };
	
	                        drawInitialIOC(initial_ioc);
	                    }
	                    orderNodeIndex();
	                }
	
	                function orderID(a, b) {
	                    if (a > b) return 1;
	                    if (a < b) return -1;
	                    return 0;
	                }
	
	                function orderNodeIndex() {
	                    for (var l in laneNodeIndex) {
	                        laneNodeIndex[l].sort(orderID);
	                    }
	                }
	
	                function requery(min, max, callback) {
	                    $scope.$broadcast('startSpinner');
	                    itemRects.selectAll('g').remove();
	                    var minUnix = min;
	                    var maxUnix = max;
	                    if ((typeof min === 'undefined' ? 'undefined' : _typeof(min)) === 'object') {
	                        minUnix = (0, _moment2.default)(min).unix();
	                        maxUnix = (0, _moment2.default)(max).unix();
	                    }
	                    if ($scope.inTooDeep.areWe === true && minUnix >= $scope.inTooDeep.min && maxUnix <= $scope.inTooDeep.max) {
	                        callback(searchDimension.filterFunction(function (d) {
	                            return d.deep;
	                        }));
	                        $scope.alert.style('display', 'block');
	                        $scope.$broadcast('stopSpinner');
	                    } else {
	                        loading('start');
	                        //  set $scope.inTooDeep
	                        $scope.inTooDeep = {
	                            areWe: true,
	                            min: minUnix,
	                            max: maxUnix
	                        };
	                        $scope.alert.style('display', 'block');
	                        $scope.getDrillDown(null, {
	                            start: minUnix,
	                            end: maxUnix
	                        });
	                        callback(searchDimension.filterFunction(function (d) {
	                            return d.deep;
	                        }));
	                    }
	                }
	
	                ////////////////////
	                /////  SEARCH  /////
	                ////////////////////
	                $scope.$on('searchBoxFilter', function () {
	                    filterSearch();
	                });
	
	                $scope.updatedSwimLaneData = function (data, drill) {
	                    if (drill) {
	                        loading('end');
	                        var dt = searchDimension.filter(function (d) {
	                            return d.deep;
	                        });
	                        plot(dt, navArray[currentNavPos].min, navArray[currentNavPos].max);
	                    } else {
	                        redraw(data, navArray[currentNavPos].min, navArray[currentNavPos].max);
	                    }
	                    reapplyAllFilters();
	                };
	
	                ////////////////////////////////
	                /////  IN-SCOPE FUNCTIONS  /////
	                ////////////////////////////////
	                $scope.patternPane = false;
	
	                function compare(data) {
	                    var totalPoints = data.length;
	                    // return if there aren't enough points to compare
	                    if (totalPoints < 2) {
	                        return false;
	                    }
	
	                    function equals(object, object2) {
	                        // for the first loop, we only check for types
	                        for (var propName in object) {
	                            if (propName !== '$$hashKey') {
	                                // ignore angular's inserted id key
	                                // checks if they share the same keys/properties
	                                if (object.hasOwnProperty(propName) != object2.hasOwnProperty(propName)) {
	                                    return false;
	                                }
	                                // check instance type
	                                else if (_typeof(object[propName]) != _typeof(object2[propName])) {
	                                        return false;
	                                    }
	                            }
	                        }
	                        // now a deeper check using other objects property names
	                        for (var propName in object2) {
	                            if (propName !== '$$hashKey') {
	                                // ignore angular's inserted id key
	                                // we must check instances anyway, there may be a property that only exists in object2
	                                // I wonder, if remembering the checked values from the first loop would be faster or not
	                                if (object.hasOwnProperty(propName) != object2.hasOwnProperty(propName)) {
	                                    return false;
	                                } else if (_typeof(object[propName]) != _typeof(object2[propName])) {
	                                    return false;
	                                }
	                                // if the property is inherited, do not check any more (it must be equal if both objects inherit it)
	                                if (!object.hasOwnProperty(propName)) continue;
	                                // now the detail check and recursion
	                                // object returns the script back to the array comparing
	                                if (object[propName] instanceof Array && object2[propName] instanceof Array) {
	                                    // recurse into the nested arrays
	                                    if (!object[propName].equals(object2[propName])) return false;
	                                } else if (object[propName] instanceof Object && object2[propName] instanceof Object) {
	                                    // recurse into another objects
	                                    if (!object[propName].equals(object2[propName])) return false;
	                                }
	                                // normal value comparison for strings and numbers
	                                else if (object[propName] != object2[propName]) {
	                                        return false;
	                                    }
	                            }
	                        }
	                        // return true if everything passed
	                        return true;
	                    }
	
	                    function checkMatch(checkOne, checkTwo) {
	                        var matched = [];
	                        for (var r in checkOne) {
	                            var thisMatched = checkTwo.filter(function (d) {
	                                if (equals(checkOne[r], d)) {
	                                    return true;
	                                }
	                            });
	                            // push every item of each array returned to a single larger array of matched items
	                            for (var m in thisMatched) {
	                                matched.push(thisMatched[m]);
	                            }
	                        }
	                        if (matched.length > 0) {
	                            return matched;
	                        } else {
	                            return false;
	                        }
	                    }
	
	                    for (var i = 0; i < totalPoints; i++) {
	                        // each one of these is a seperate query / point with its own array of objects
	                        var matched = [];
	                        if (i === 0) {
	                            // run if first array
	                            var thisPoint = data[i].result;
	                            var nextPoint = data[i + 1].result;
	                            var check = checkMatch(thisPoint, nextPoint);
	                            if (check) {
	                                // set our matched results
	                                matched = check;
	                            } else {
	                                // return if the first check didn't return results
	                                return false;
	                            }
	                        } else if (matched.length > 0 && i !== 1) {
	                            // continue if the first loop matched, but skip the second 'i' since the we already tested it
	                            var thisPoint = data[i].result;
	                            var check = checkMatch(matched, thisPoint);
	                            if (check) {
	                                matched = check;
	                            } else {
	                                return false;
	                            }
	                        }
	                        if (matched.length > 0) {
	                            return matched;
	                        } else {
	                            return false;
	                        }
	                    }
	                }
	
	                function patternPane(data) {
	                    // loop through and add a checked flag for each point (for use in finding commonalities)
	                    data.forEach(function (d) {
	                        d.point.checked = true;
	                    });
	                    $scope.patternPane = true;
	                    $scope.points = data;
	                    if (data.length === 1) {
	                        $scope.matched = data[0].result;
	                    } else {
	                        $scope.matched = compare(data);
	                    }
	                }
	
	                $scope.checkboxChange = function () {
	                    // whenever a checkbox is checked, re-compare our existing points
	                    var points = $scope.points.filter(function (d) {
	                        return d.point.checked;
	                    });
	                    if (points.length === 1) {
	                        // if there is only one return, just display its results without comparing
	                        $scope.matched = points[0].result;
	                    } else {
	                        // otherwise just attempt to compare .. it will still return null if points.length is 0
	                        $scope.matched = compare(points);
	                    }
	                };
	
	                $scope.closePatternBox = function () {
	                    $scope.patternPane = false;
	                    $scope.highlightedPoint = false;
	                    setPatternObj();
	                };
	
	                // begin execution
	                draw();
	            });
	            $scope.$on('$destroy', function () {
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = ['$timeout', '$location', 'timeFormat', '$http', 'laneRowSymbols', '$state'];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 832 */
/***/ function(module, exports) {

	module.exports = "<div ng-show=\"patternPane\" class=\"patternPane\">\n    <div ng-click=\"closePatternBox()\" class=\"closeBtnContainer\">\n        <div class=\"closeBtn\">\n            x\n        </div>\n    </div>\n    <div class=\"container\">\n        <div class=\"span8 lanePatternInfoPane\" style=\"height:{{height}}px\">\n            <div class=\"row-fluid\">\n                <div class=\"span6\">\n                    <div id=\"killchainrange\" class=\"pull-left dashboard-date-range tooltips no-tooltip-on-touch-device responsive\" data-tablet=\"\" data-desktop=\"tooltips\" data-placement=\"top\" data-original-title=\"Change dashboard date range\">\n                            <i style=\"color:#fff\" class=\"fa fa-cis thaalendar\"></i>\n                            <span>{{kcstart}} - {{kcend}}</span>\n                            <i style=\"color:#fff\" class=\"fa fa-angle-down\"></i>\n                    </div>\n                </div>\n                <div class=\"span6\">\n                        <button ng-click=\"killChainCsv()\" class=\"btnRaised2015\" href=\"\">Export</button>\n                </div>\n            </div>\n            <div class=\"row-fluid title\">\n                <div class=\"span8\">\n                    Selected Events\n                </div>\n                <div class=\"span4\">\n                    Number of users matching these events\n                </div>\n            </div>\n            <div ng-repeat=\"(key, value) in points\">\n                <div ng-if=\"key != 'length'\">\n                    <div class=\"row-fluid\">\n                        <div class=\"span8 patternRow\">\n                            <div class=\"span6 pr-outer\">\n                                 <div class=\"pattern-row-container\">\n                                    <div class=\"squaredTwo\">\n                                        <input type=\"checkbox\" value=\"None\" id=\"pattern-check-{{value.point.id}}\" name=\"check\" ng-change=\"checkboxChange()\" ng-model=\"value.point.checked\"/>\n                                        <label for=\"pattern-check-{{value.point.id}}\"></label>\n                                    </div>\n                                    <div class=\"pattern-row-icon\" append-row-icon type=\"{{value.point.type}}\"></div>\n                                    <div class=\"pattern-row-type\">{{value.point.type}}</div>\n                                </div>\n                            </div>\n                            <div class=\"span6 pr-outer\">\n                                <div class=\"pattern-row-container\">\n                                    <div class=\"pattern-row-selected\">\n                                        <li ng-repeat=\"(selectedKey, selectedValue) in value.selected\">\n                                            <div ng-if=\"selectedKey != 'length'\">\n                                                {{selectedValue.name}}: {{selectedValue.value}}\n                                            </div>\n                                        </li>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"span4 patternRow\">\n                            <div class=\"pr-outer\">\n                                <div class=\"pattern-row-container\">\n                                    <div class=\"pattern-result-count\"><strong>{{value.result.length}}</strong></div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div style=\"height:{{height}}px\" style=\"overflow:scroll\" class=\"span4 patternInfoRight\">\n            <section ng-if=\"matched.length > 0\">\n                <div class=\"title\" style=\"padding-top:20px\">Common Users</div>\n                <li class=\"rightList\" ng-repeat=\"match in matched\">\n                    <div class=\"lanegraphlist\">\n                        <strong>{{match.local_user}}:</strong> {{match.local_ip}}\n                    </div>\n                </li>\n            </section>\n            <section ng-if=\"((!matched) || (matched.length == 0))\">\n                <div class=\"matchError\">\n                    Sorry, no common matches.\n                </div>\n            </section>\n        </div>\n    </div>\n</div>\n";

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('makeLineChart', __webpack_require__(834));
	};

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _moment = __webpack_require__(459);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function directive(getSize, $location, generateId, timeFormat, $window) {
	    return {
	        link: function link($scope, element, attrs, dcCrtl) {
	            // set hight and width ratios
	            var size = getSize(element, 'linechart');
	            var width = size.width;
	            var height = size.height;
	            if (attrs.type === "services") {
	                height = height / 2;
	            }
	
	            // bind the window object to the local w variable in scope
	            $scope.page.w = angular.element($window);
	
	            var dimension, group, toggleValues, networkmap; // set our default vairables
	            var lineChartOn = true;
	
	            // initalize
	            $scope.$on('init', function (event, lineChartIdentifiers) {
	                if (lineChartIdentifiers.id !== attrs.uid) {
	                    return;
	                }
	                if (typeof $scope.main.dataObjects[lineChartIdentifiers.key] === 'undefined') {
	                    return;
	                } // if its not in our dc object, ignore
	                $scope.main.dataObjects[lineChartIdentifiers.key].launched = true;
	                var uid = lineChartIdentifiers.id;
	                var key = lineChartIdentifiers.key;
	                var interval = 3600; // 3600 = hour, 600 = 10 mins
	                if ($scope.main.dataObjects[key].settings !== null) {
	                    if ($scope.main.dataObjects[key].settings.interval) {
	                        interval = $scope.main.dataObjects[key].settings.interval;
	                    }
	                    // set variables that are
	                    if (typeof $scope.main.dataObjects[key].settings.settings.toggleValues !== "undefined") {
	                        toggleValues = $scope.main.dataObjects[key].settings.settings.toggleValues;
	                    }
	                    if (typeof $scope.main.dataObjects[key].settings.settings.networkmap !== "undefined") {
	                        networkmap = $scope.main.dataObjects[key].settings.settings.networkmap;
	                    }
	                }
	                var toggleVal;
	                if (!$scope.page.settings.get('toggleVal')) {
	                    toggleVal = false;
	                    $scope.togVal = 1;
	                    $scope.byteOffset = 7;
	                } else {
	                    toggleVal = $scope.page.settings.get('toggleVal');
	                    $scope.byteOffset = 1;
	                    $scope.togVal = 1048576;
	                    if ($scope.page.settings.get('toggleVal') === "KB") {
	                        $scope.byteOffset = 2.5;
	                        $scope.togVal = 1024;
	                    }
	                }
	
	                // load saved variable
	                var stacked;
	                if (!$scope.page.settings.get('lineChartStacked')) {
	                    stacked = false;
	                } else {
	                    stacked = $scope.page.settings.get('lineChartStacked');
	                }
	
	                // load saved variable
	                var log;
	                if (!$scope.page.settings.get('toggleLog')) {
	                    log = false;
	                } else {
	                    log = $scope.page.settings.get('toggleLog');
	                }
	
	                var start = void 0,
	                    end = void 0,
	                    bstart = void 0,
	                    bend = void 0;
	
	                var margin = {
	                    top: 10,
	                    right: 15,
	                    bottom: 10,
	                    left: 40
	                };
	
	                var difference = 0,
	                    differenceOld = 0;
	                width = width - margin.left - margin.right, height = height - margin.top - margin.bottom;
	
	                var value = 0,
	                    x,
	                    y,
	                    hours;
	                var areas = [];
	                var lines = [];
	
	                var xAxis;
	                var yAxis;
	                var lc = [];
	                var data = [];
	                var blankData = {};
	
	                var lineCombinations = [];
	                var outterDiv = d3.select("#" + attrs.id).append("div");
	
	                var initialTime = $scope.main.getTime();
	                bstart = initialTime.start;
	                bend = initialTime.end;
	                function setupData() {
	                    var t = $scope.main.getTime();
	                    start = t.start;
	                    end = t.end;
	                    var newData;
	                    hours = (getHour(end) - getHour(start)) / interval / 1000 + 1;
	                    data = [];
	                    lineCombinations = [];
	                    if ($scope.main.dataObjects[key].group.top(Infinity).length === 0) {
	                        return;
	                    }
	                    data = angular.copy($scope.main.dataObjects[key].group.top(Infinity));
	                    for (var d in data[0].value) {
	                        lineCombinations.push(d);
	                        blankData[d] = 0;
	                    }
	                    data.sort(orderChart);
	
	                    for (var j = 0; j <= hours; j++) {
	                        if (data[j]) {
	                            if (Number(data[j].key) !== Number(getHour(Number(start) + j * interval))) {
	                                data.splice(j, 0, { key: getHour(Number(start) + j * interval), value: blankData });
	                            }
	                        } else {
	                            data.splice(j, 0, { key: getHour(Number(start) + j * interval), value: blankData });
	                        }
	                    }
	                }
	                if ($scope.main.dataObjects[key].group) {
	                    setupData();
	                }
	
	                // SETUP LOG / LINEAR button for linechart
	                var checklog = outterDiv.append("svg").attr("class", "toggleLog").attr("height", 24).attr("width", 24).on("click", function (d) {
	                    if (log) {
	                        log = false;
	                    } else {
	                        log = true;
	                    }
	                    // update settings
	                    $scope.page.settings.set('toggleLog', log).then(function () {
	                        setWidthHeight(width, height);
	                        redrawAxis();
	                        redraw();
	                        checkLogValue();
	                    });
	                }).append("text").attr("class", "checkboxLog").attr("y", "16").attr("font-size", "10").attr("fill", "#000").attr("font-family", "ubuntu").attr("font-weight", "bold");
	                checkLogValue();
	
	                var index;
	                // SETUP stacked or not stacked button for linechart
	                if (lineCombinations.length > 1) {
	                    var checkbox = outterDiv.append("svg").attr("class", "toggleStacked").attr("height", 24).attr("width", 24).on("click", function (d) {
	                        // save it if false
	                        if (stacked) {
	                            stacked = false;
	                        } else {
	                            // delete value if true
	                            stacked = true;
	                        }
	                        $scope.page.settings.set('lineChartStacked', stacked).then(function () {
	                            redrawAxis();
	                            redraw();
	                            d3.select(".checkboxStacked").attr("d", function () {
	                                if (stacked) {
	                                    return "M14,0l5.31,5.86-0.74.67L14.16,1.72,9.93,9.57,5.53,6.77,0.45,9.31,0,8.41,5.59,5.62l4,2.53Zm0.42,9.53,4.86,4.29-0.66.75-4.2-3.71-4.57,4L5.53,12.1,0.45,14.64,0,13.75,5.59,11,9.7,13.57Z";
	                                }
	                                return "M20.1,7.78l0.2,1-5.23,1L13.24,8.29,10.59,14,6.15,10.85,1.09,13.38l-0.45-.89,5.6-2.8,3.94,2.82,2.25-4.89L9.17,4.9,4.72,8,0,0.54,0.84,0,5,6.56,9.23,3.64l3.65,3L14.62,2.9,19.3,0.49l0.46,0.89L15.39,3.63,13.67,7.35l1.66,1.38Z";
	                            });
	                        });
	                    }).append("path").attr("class", "checkboxStacked").attr("fill", "#231F20").attr("transform", "translate(2,5)").attr("d", function () {
	                        if (stacked) {
	                            return "M14,0l5.31,5.86-0.74.67L14.16,1.72,9.93,9.57,5.53,6.77,0.45,9.31,0,8.41,5.59,5.62l4,2.53Zm0.42,9.53,4.86,4.29-0.66.75-4.2-3.71-4.57,4L5.53,12.1,0.45,14.64,0,13.75,5.59,11,9.7,13.57Z";
	                        }
	                        return "M20.1,7.78l0.2,1-5.23,1L13.24,8.29,10.59,14,6.15,10.85,1.09,13.38l-0.45-.89,5.6-2.8,3.94,2.82,2.25-4.89L9.17,4.9,4.72,8,0,0.54,0.84,0,5,6.56,9.23,3.64l3.65,3L14.62,2.9,19.3,0.49l0.46,0.89L15.39,3.63,13.67,7.35l1.66,1.38Z";
	                    });
	                }
	
	                // SETUP toggle button between bytes, KB, MB for linechart
	                if (toggleValues && typeof toggleValues !== "undefined") {
	                    var valueToggle = outterDiv.append("svg").attr("class", "toggleLineValue").attr("height", 24).attr("width", 24).on("click", function () {
	                        // save it if false
	                        var toggle = void 0;
	                        if ($scope.page.settings.get('toggleVal') === "KB") {
	                            toggle = "MB";
	                            $scope.togVal = 1048576;
	                            $scope.byteOffset = 1;
	                        } else if ($scope.page.settings.get('toggleVal') === "MB") {
	                            toggle = false;
	                            $scope.togVal = 1;
	                            $scope.byteOffset = 7;
	                        } else {
	                            toggle = "KB";
	                            $scope.togVal = 1024;
	                            $scope.byteOffset = 2.5;
	                        }
	                        // update settings
	                        $scope.page.settings.set('toggleVal', toggle).then(function () {
	                            setupData();
	                            redrawAxis();
	                            redraw();
	                            checkBoxValue();
	                        });
	                    }).append("text").attr("class", "checkboxValue").attr("y", "17").attr("font-size", "14").attr("fill", "#000").attr("font-family", "ubuntu").attr("font-weight", "bold");
	                    checkBoxValue();
	                }
	
	                function checkLogValue() {
	                    d3.select(".checkboxLog").attr("x", function () {
	                        if (log) {
	                            return 2;
	                        }
	                        return 4;
	                    }).text(function (d) {
	                        if (log) {
	                            return "LOG";
	                        }
	                        return "LIN";
	                    });
	                }
	
	                function checkBoxValue() {
	                    d3.select(".checkboxValue").attr("x", function (d) {
	                        return $scope.byteOffset;
	                    }).text(function (d) {
	                        if (!$scope.page.settings.get('toggleVal')) {
	                            return "B";
	                        } else {
	                            return $scope.page.settings.get('toggleVal');
	                        }
	                    });
	                }
	
	                var svg = outterDiv.append("svg");
	
	                function setWidthHeight(w, h) {
	                    svg.attr("width", w + margin.left + margin.right).attr("height", h + margin.top + margin.bottom + 20);
	                    x = d3.time.scale().range([0, w]);
	                    if (log) {
	                        y = d3.scale.log().clamp(true).range([h, 0]).nice();
	                    } else {
	                        y = d3.scale.linear().range([h, 0]).nice();
	                    }
	                }
	                setWidthHeight(width, height);
	
	                function orderChart(a, b) {
	                    if (a.key < b.key) {
	                        return -1;
	                    }
	                    if (a.key > b.key) {
	                        return 1;
	                    }
	                    return 0;
	                }
	
	                // var superscript = "⁰¹²³⁴⁵⁶⁷⁸⁹",
	                // formatPower = function (d) { return (d + "").split("").map(function (c) { return superscript[c]; }).join(""); };
	                var numberFormat = d3.format(",.2r");
	                var expFormat = d3.format(".1e");
	                function logFormat(d) {
	                    var x = Math.log(d) / Math.log(10) + 1e-6;
	                    if (d >= 1000) {
	                        if (d === max) {
	                            return expFormat(d);
	                        }
	                    }
	                    if (d === max) {
	                        return numberFormat(d);
	                    }
	                    if (d === 0.9) {
	                        return numberFormat(0);
	                    }
	                }
	                function regFormat(d) {
	                    if (d === max) {
	                        if (d >= 1000) {
	                            return expFormat(d);
	                        }
	                        return numberFormat(d);
	                    }
	                    if (d === 0) {
	                        return numberFormat(d);
	                    }
	                }
	
	                var brush = d3.svg.brush().x(x).on("brush", brushed);
	
	                function setUpXAxis() {
	                    x.domain([getHour(start), getHour(end, true)]);
	                    return d3.svg.axis().scale(x).tickSize(5).orient("bottom");
	                }
	                var max = 1;
	                function setUpYAxis() {
	                    var val = 0;
	                    var format = regFormat;
	                    if (log) {
	                        val = 0.9;
	                        format = logFormat;
	                    }
	                    max = d3.max(data, function (d) {
	                        value = 0;
	                        for (var i = lineCombinations.length - 1; i >= 0; i--) {
	                            if (typeof d.value[lineCombinations[i]] !== "undefined") {
	                                if (toggleValues && typeof toggleValues !== "undefined") {
	                                    if (stacked) {
	                                        value += d.value[lineCombinations[i]] / $scope.togVal;
	                                    } else {
	                                        if (value < d.value[lineCombinations[i]] / $scope.togVal) {
	                                            value = d.value[lineCombinations[i]] / $scope.togVal;
	                                        }
	                                    }
	                                } else {
	                                    if (stacked) {
	                                        value += d.value[lineCombinations[i]];
	                                    } else {
	                                        if (value < d.value[lineCombinations[i]]) {
	                                            value = d.value[lineCombinations[i]];
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                        return value + 1;
	                    });
	                    if (!max) {
	                        max = 1;
	                    }
	                    y.domain([val, max]);
	                    return d3.svg.axis().scale(y).tickSize(0).tickFormat(format).tickValues(y.ticks(10).concat(y.domain())).orient("left");
	                }
	
	                var color = function color(value) {
	                    if (value) {
	                        value = value.toLowerCase();
	                    }
	                    if (value === "guarded") {
	                        return "#377FC7";
	                    } else if (value === "elevated") {
	                        return "#F5D800";
	                    } else if (value === "high") {
	                        return "#F88B12";
	                    } else if (value === "severe") {
	                        return "#FF3131";
	                    } else if (value === "bytes_to" || value === "kb_to" || value === "mb_to" || value === "bytes_toV2" || value === "kb_toV2" || value === "mb_toV2") {
	                        return "#045859";
	                    } else if (value === "bytes_from" || value === "kb_from" || value === "mb_from" || value === "bytes_fromV2" || value === "kb_fromV2" || value === "mb_fromV2") {
	                        return "#08B5B8";
	                    } else if (value === "bytes_toV3" || value === "kb_toV3" || value === "mb_toV3") {
	                        return "#112F41";
	                    } else if (value === "bytes_fromV3" || value === "kb_fromV3" || value === "mb_fromV3") {
	                        return "#3FA8FF";
	                    } else if (value === "conn_in") {
	                        return "#34D4FF";
	                    } else if (value === "conn_out") {
	                        return "#009426";
	                    } else if (value === "stealth_in") {
	                        return "#C43C00";
	                    } else if (value === "stealth_out") {
	                        return "#C40600";
	                    } else if (value === "other") {
	                        return "#000";
	                    } else {
	                        return "#112F41";
	                    }
	                };
	
	                function redrawAxis() {
	                    xAxis = setUpXAxis();
	                    yAxis = setUpYAxis();
	                    svg.selectAll(".grid").remove();
	                    svg.selectAll(".axis").remove();
	                    svg.insert("g", ".lc").attr("class", "grid horizontal").attr("transform", "translate(" + margin.left + "," + (height + margin.top) + ")").call(setUpXAxis().tickSize(-height, 0, 0).ticks(24).tickFormat(""));
	
	                    svg.insert("g", ".lc").attr("class", "grid vertical").attr("transform", "translate(" + margin.left + "," + margin.top + ")").call(setUpYAxis().tickSize(-width, 0, 0).ticks(10).tickFormat(""));
	
	                    svg.insert("g", ".lc").attr("class", "x axis").attr("stroke-width", "1").attr("transform", "translate(" + margin.left + "," + (height + margin.top) + ")").call(xAxis);
	
	                    svg.insert("g", ".lc").attr("class", "y axis").attr("stroke-width", "1").attr("transform", "translate(" + margin.left + "," + margin.top + ")").call(yAxis);
	                }
	                redrawAxis();
	
	                var graph = svg.append("g").attr("class", "lc").attr("width", width).attr("transform", "translate(" + (margin.left + 1) + "," + (margin.top - 1) + ")");
	
	                var brushDiv = svg.append("g").attr("class", "brush").attr("transform", "translate(" + (margin.left + 1) + "," + margin.top + ")").call(brush);
	                var brushDivRects = brushDiv.selectAll("rect").attr("y", 0).attr("height", height);
	                var brushExtent = brushDiv.append('rect').attr("class", "timeBrush");
	
	                function findYValue(a, b, y1) {
	                    value = 0;
	                    if (toggleValues && typeof toggleValues !== "undefined") {
	                        if (stacked) {
	                            for (var j = 0; j <= b; j++) {
	                                if (_typeof(a.value[lineCombinations[j]]) !== undefined) {
	                                    value += a.value[lineCombinations[j]] / $scope.togVal;
	                                }
	                            }
	                        } else if (y1 === "y0") {
	                            value = a.value[lineCombinations[b + 1]] / $scope.togVal;
	                        } else if (y1 === "y") {
	                            value = a.value[lineCombinations[b]] / $scope.togVal;
	                        }
	                    } else {
	                        if (stacked) {
	                            for (var j = 0; j <= b; j++) {
	                                if (_typeof(a.value[lineCombinations[j]]) !== undefined) {
	                                    value += a.value[lineCombinations[j]];
	                                }
	                            }
	                        } else if (y1 === "y0") {
	                            value = a.value[lineCombinations[b + 1]];
	                        } else if (y1 === "y") {
	                            if (typeof a.value[lineCombinations[b]] === "undefined") {}
	                            value = a.value[lineCombinations[b]];
	                        }
	                    }
	                    return y(value);
	                }
	
	                var colors;
	                if (typeof $scope.page.color !== "undefined") {
	                    colors = $scope.page.color;
	                } else {
	                    colors = color;
	                }
	
	                function redraw() {
	                    areas = [];
	                    lines = [];
	                    for (var i = 0, len = lineCombinations.length; i < len; i++) {
	                        areas[i] = d3.svg.area().interpolate("linear").x(function (d) {
	                            if (isNaN(x(d.key))) {
	                                return 0;
	                            }return x(d.key);
	                        }).y0(function (d) {
	                            return findYValue(d, i - 1, "y0");
	                        }).y1(function (d) {
	                            return findYValue(d, i);
	                        });
	
	                        lines[i] = d3.svg.line().interpolate("linear").x(function (d) {
	                            if (isNaN(x(d.key))) {
	                                return 0;
	                            }return x(d.key);
	                        }).y(function (d) {
	                            return findYValue(d, i, "y");
	                        });
	                    }
	                    for (var i = 0, len = lineCombinations.length; i < len; i++) {
	                        if (typeof lc[i] === "undefined") {
	                            lc[i] = graph.append("g").attr("width", width).attr("class", 'lc' + lineCombinations[i].replace(/((?:\W))/g, ""));
	
	                            lc[i].append("path").attr("class", "area " + 'lc' + lineCombinations[i].replace(/((?:\W))/g, "")).attr("fill", colors(lineCombinations[i])).datum(data).attr("d", areas[i]).style("opacity", "0.3");
	
	                            lc[i].append("path").attr("class", "lineChartline " + 'lc' + lineCombinations[i].replace(/((?:\W))/g, "")).attr("stroke", colors(lineCombinations[i])).datum(data).attr("d", lines[i]);
	                        } else {
	                            if (d3.select(".area." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, ""))[0][0]) {
	                                d3.select(".area." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, "")).datum(data).attr("d", d3.select(".area." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, ""))[0][0].attributes.d.nodeValue).transition().duration(500).attr("d", areas[i]);
	                            } else {
	                                d3.select(".area." + lineCombinations[i]).datum(data).attr("d", areas[i]);
	                            }
	
	                            if (d3.select(".lineChartline." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, ""))[0][0]) {
	                                d3.select(".lineChartline." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, "")).datum(data).attr("d", d3.select(".lineChartline." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, ""))[0][0].attributes.d.nodeValue).transition().duration(500).attr("d", lines[i]);
	                            } else {
	                                d3.select(".lineChartline." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, "")).datum(data).attr("d", lines[i]);
	                            }
	
	                            for (var ld in d3.selectAll(".lineDots." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, "")).data(data)[0]) {
	                                d3.select(d3.selectAll(".lineDots." + 'lc' + lineCombinations[i].replace(/((?:\W))/g, "")).data(data)[0][ld]).transition().duration(500).attr("cx", function (d) {
	                                    if (typeof d !== "undefined") {
	                                        if (isNaN(x(d.key))) {
	                                            return 0;
	                                        }
	                                        return x(d.key);
	                                    }
	                                }).attr("cy", function (d) {
	                                    if (typeof d !== "undefined") {
	                                        return findYValue(d, i, "y");
	                                    }
	                                }).attr("r", function (d) {
	                                    if (typeof d !== "undefined") {
	                                        if (d.value[lineCombinations[i]] === 0) {
	                                            return 0;
	                                        }
	                                        return 2.5;
	                                    }
	                                });
	                            }
	                        }
	                    }
	                }
	                redraw();
	
	                function unhighlight() {
	                    for (var i = 0, len = lc.length; i < len; i++) {
	                        lc[i].select(".area").style("opacity", "0.3");
	                        lc[i].select(".lineChartline").style("stroke-width", "2");
	                        lc[i].selectAll(".lineDots").attr("r", 2.5);
	                    }
	                }
	
	                function highlight(value) {
	                    value = 'lc' + value.replace(/((?:\W))/g, "");
	                    for (var i = 0, len = lc.length; i < len; i++) {
	                        lc[i].select(".area").style("opacity", "0.1");
	                        lc[i].select(".lineChartline").style("stroke-width", "0");
	                        lc[i].selectAll(".lineDots").attr("r", 0);
	                    }
	                    for (var i = 0, len = lc.length; i < len; i++) {
	                        if (lc[i][0][0].className.animVal === value) {
	                            lc[i].select(".area").style("opacity", "1");
	                        }
	                    }
	                }
	
	                function getHour(time, last) {
	                    if (last) {
	                        return Math.ceil(time / interval) * interval * 1000;
	                    }
	                    return Math.floor(time / interval) * interval * 1000;
	                }
	
	                /////////////
	                /// HOVER ///
	                /////////////
	                var ext = element[0].querySelector(".brush .background");
	
	                var hoverBox, chv, hoverBoxText;
	                var pagex, pagey, pageyOld, offsetx, boxWidth;
	                var hoverValues, hoverChart;
	                var hoverText = "";
	                var divAtts = d3.select(element[0])[0][0];
	                var offX = 0;
	                var offXOld = 0;
	                setMouseEvents();
	
	                function setMouseEvents() {
	                    if ($scope.main.dataObjects[key].group) {
	                        divAtts = d3.select(element[0])[0][0];
	                        hoverValues = $scope.main.dataObjects[key].group.top(Infinity);
	                        d3.selectAll(".hoverChart").remove();
	                        hoverChart = d3.select(".brush").insert("rect", ".extent").classed("hoverChart", true).attr("x", ext.x.animVal.value).attr("height", ext.height.animVal.value).attr("width", ext.width.animVal.value).attr('fill', 'transparent');
	                        d3.select(".brush .extent").on('mouseenter', function (d) {
	                            removeHover();
	                        });
	
	                        var hoverTime = 50;
	                        var tempVal = void 0;
	                        hoverChart.on('mousemove', function (d) {
	                            hoverText = "";
	                            pagey = d3.event.layerY + 3;
	                            offsetx = d3.event.offsetX + 3;
	                            waitForFinalEvent(function () {
	                                setUpHover();
	                                var temp;
	                                for (var h = 0, len = hoverValues.length; h < len; h++) {
	                                    if ((0, _moment2.default)(hoverValues[h].key).unix() == (0, _moment2.default)(getHour(Number(start) + (end - start) * (offsetx / ext.width.animVal.value))).unix()) {
	                                        hoverText += "<strong class='hoverTitle'>Time: </strong>" + timeFormat(hoverValues[h].key, 'chartHover') + "<br/>";
	                                        if (toggleValues && typeof toggleValues !== "undefined") {
	                                            for (var v in hoverValues[h].value) {
	                                                if ($scope.page.settings.get('toggleVal') === "KB") {
	                                                    temp = String(v).replace("bytes", 'KB');
	                                                } else if ($scope.page.settings.get('toggleVal') === "MB") {
	                                                    temp = String(v).replace("bytes", 'MB');
	                                                } else {
	                                                    temp = v;
	                                                }
	                                                if (String(temp).split("(").length > 1) {
	                                                    temp = String(temp).split("(")[0] + "... ";
	                                                } else {
	                                                    temp = String(temp);
	                                                }
	                                                hoverText += "<span class='colorHover' style='background:" + colors(temp) + ";'></span>";
	                                                temp = String(temp).replace("_", ' ');
	                                                hoverText += "<strong class='hoverTitle'>" + temp.replace("N/A", "-") + " : </strong>" + Math.round(hoverValues[h].value[v] / $scope.togVal * 100) / 100 + "<br/>";
	                                            }
	                                        } else {
	                                            for (var v in hoverValues[h].value) {
	                                                if (v !== "other") {
	                                                    if (String(v).split("(").length > 1) {
	                                                        tempVal = String(v).split("(")[0] + "... ";
	                                                    } else {
	                                                        tempVal = String(v);
	                                                    }
	                                                    hoverText += "<span class='colorHover' style='background:" + colors(tempVal) + ";'></span><strong class='hoverTitle'>" + tempVal.replace("N/A", "-") + " : </strong>" + Math.round(hoverValues[h].value[v] * 100) / 100 + "<br/>";
	                                                }
	                                            }
	                                        }
	                                    }
	                                }
	                                if (hoverText !== "") {
	                                    offX = ext.width.animVal.value / hours * (((0, _moment2.default)(getHour(Number(start) + (end - start) * (offsetx / ext.width.animVal.value))).unix() - (0, _moment2.default)(getHour(Number(start))).unix()) / interval);
	                                    if (element[0].querySelector('.hoverNodes')) {
	                                        if (ext.width.animVal.value - offX < element[0].querySelector('.hoverNodes').clientWidth) {
	                                            boxWidth = divAtts.offsetLeft + margin.left - element[0].querySelector('.hoverNodes').clientWidth - 6;
	                                            boxWidth = divAtts.offsetLeft + margin.left - element[0].querySelector('.hoverNodes').clientWidth - 6;
	                                        } else {
	                                            boxWidth = divAtts.offsetLeft + margin.left + 3;
	                                            boxWidth = divAtts.offsetLeft + margin.left + 3;
	                                        }
	                                    }
	                                    chv.style("left", offX + divAtts.offsetLeft + margin.left + "px");
	                                    hoverBox.style("top", pageyOld + 3 + "px").style("left", offXOld + boxWidth + "px").transition().duration(250).style("top", pagey + 3 + "px").style("left", offX + boxWidth + "px");
	                                    hoverBoxText.html(hoverText);
	                                    offXOld = offX;
	                                    pageyOld = pagey;
	                                } else {
	                                    removeHover();
	                                }
	                            }, 50, "linecharthover");
	                        });
	                    }
	                }
	                d3.select(element[0]).on('mouseleave', function (d) {
	                    waitForFinalEvent(function () {
	                        removeHover();
	                    }, 100, "linecharthover");
	                });
	                function setUpHover() {
	                    removeHover(); // for when you highlight the hover info
	                    hoverBox = d3.select("#" + attrs.id).append("xhtml:div").attr("class", "hoverNodes linehover").style("left", "0px").style("top", "0px").style("min-width", "100px");
	                    chv = d3.select("#" + attrs.id).append("g").attr("class", "crosshair-v hair").style("left", "0px").style("top", divAtts.offsetTop + margin.top + "px").style("height", divAtts.offsetHeight - margin.top - margin.bottom + "px");
	                    hoverBoxText = hoverBox.append("div").attr("class", "hoverBoxText");
	                }
	                function removeHover() {
	                    d3.selectAll(".hair").remove();
	                    d3.selectAll(".hoverNodes").remove();
	                    d3.selectAll(".hoverBoxText").remove();
	                }
	
	                ext = element[0].querySelector(".brush .background");
	
	                function updateSlider(s, e) {
	                    s = Math.max(s, bstart);
	                    // e = Math.min(e,bend)
	                    if (e > s) {
	                        difference = (e - s) / (bend - bstart);
	                        if (difference !== differenceOld) {
	                            ext = element[0].querySelector(".brush .extent");
	                            if (ext) {
	                                if (ext.width.animVal.valueAsString === "0") {
	                                    ext = element[0].querySelector(".brush .background");
	                                    brushExtent.attr("x", ext.width.animVal.valueAsString - ext.width.animVal.valueAsString * differenceOld).attr("y", ext.height.animVal.valueAsString).attr("height", 5).attr("width", ext.width.animVal.valueAsString * differenceOld).attr("fill", "#000").attr("opacity", "0.5").transition().ease([0, 0]).duration(100).attr("x", ext.width.animVal.valueAsString - ext.width.animVal.valueAsString * difference).attr("width", ext.width.animVal.valueAsString * difference);
	                                } else {
	                                    var _x = Number(ext.x.animVal.valueAsString) + Number(ext.width.animVal.valueAsString);
	                                    brushExtent.attr("x", _x - ext.width.animVal.valueAsString * differenceOld).attr("y", ext.height.animVal.valueAsString - 5).attr("height", 5).attr("width", ext.width.animVal.valueAsString * differenceOld).attr("fill", "#000").attr("opacity", "0.5").transition().ease([0, 0]).duration(50).attr("x", _x - ext.width.animVal.valueAsString * difference).attr("width", ext.width.animVal.valueAsString * difference);
	                                }
	                            }
	                        }
	                        differenceOld = difference;
	                    }
	                }
	
	                var waitForFinalEvent = function () {
	                    var timers = {};
	                    return function (callback, ms, uniqueId) {
	                        if (!uniqueId) {
	                            uniqueId = "linechartWait"; // don't call this twice without a uniqueId
	                        }
	                        if (timers[uniqueId]) {
	                            clearTimeout(timers[uniqueId]);
	                        }
	                        timers[uniqueId] = setTimeout(callback, ms);
	                    };
	                }();
	
	                function brushed() {
	                    waitForFinalEvent(function () {
	                        brushExtent.remove();
	                        brushExtent = false;
	                        difference = 0, differenceOld = 0;
	                        brushExtent = brushDiv.append('rect').attr("class", "timeBrush");
	                        $scope.page.complete = false;
	                        var time = void 0;
	                        if (networkmap) {
	                            $scope.$broadcast('outFilter', 'time', brush.extent());
	                        } else {
	                            if (Number(brush.extent()[0]) === Number(brush.extent()[1])) {
	                                time = angular.copy($scope.main.getTime());
	                                $scope.page.loadEnd = Number(time.end);
	                                $scope.page.loadStart = Number(time.end);
	                                bend = Number(time.end);
	                                bstart = Number(time.start);
	                                difference = 0, differenceOld = 0;
	                            } else {
	                                time = {
	                                    start: Number(new Date(brush.extent()[0]) / 1000),
	                                    end: Number(new Date(brush.extent()[1]) / 1000)
	                                };
	                                $scope.page.loadEnd = Number(time.end);
	                                $scope.page.loadStart = Number(time.end);
	                                bend = Number(time.end);
	                                bstart = Number(time.start);
	                            }
	                            $scope.main.filterItemByTime(time);
	                        }
	                    }, 400, "linechartresize");
	                }
	
	                // set update functions
	                $scope.$on('updatedData', function (event, id, startLoad) {
	                    if ($scope.main.dataObjects[key].group) {
	                        if (id !== uid) {
	                            return;
	                        } // only run when it sees its id has filtered
	                        setupData();
	                        redrawAxis();
	                        checkBoxValue();
	                        redraw();
	                        setMouseEvents();
	                    }
	                });
	
	                $scope.$on('updateLoad', function (event, startLoad, minMultiple) {
	                    if ($scope.main.dataObjects[key].group) {
	                        if (minMultiple) {
	                            $scope.page.loadStart = Math.min($scope.page.loadStart, startLoad);
	                        } else {
	                            $scope.page.loadStart = startLoad;
	                        }
	                        if ($scope.page.loadStart !== $scope.main.getTime().end && brushExtent) {
	                            updateSlider($scope.page.loadStart, $scope.page.loadEnd);
	                        }
	                    }
	                });
	
	                var resizeTimeout = void 0;
	                $scope.page.w.bind('resize', function () {
	                    if (!resizeTimeout) {
	                        if (lineChartOn) {
	                            resizeTimeout = setTimeout(function () {
	                                resizeTimeout = null;
	                                size = getSize(element, 'linechart');
	                                width = size.width - margin.left - margin.right;
	                                height = size.height;
	                                if (attrs.type === "services") {
	                                    height = height / 2;
	                                }
	                                height = height - margin.top - margin.bottom;
	                                d3.select(".brush .extent").attr("width", 0);
	                                d3.select(".brush").attr("width", width);
	                                d3.select(".brush .background").attr("width", width);
	                                d3.select(".brush .hoverChart").attr("width", width);
	                                brushDivRects.attr("height", height);
	                                brushExtent.attr("height", height);
	                                setWidthHeight(width, height);
	                                redrawAxis();
	                                redraw();
	                                setMouseEvents();
	                            }, 250);
	                        }
	                    }
	                });
	
	                $scope.$on('$destroy', function () {
	                    lineChartOn = false;
	                    removeHover();
	                    element = null;
	                    $scope.page.w = null;
	                    resizeTimeout = true;
	                });
	            });
	        }
	    };
	}
	
	directive.$inject = ['getSize', '$location', 'generateId', 'timeFormat', '$window'];
	module.exports = directive;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('machIcon', __webpack_require__(836));
	};

/***/ },
/* 836 */
/***/ function(module, exports) {

	'use strict';
	
	function directive() {
	    return {
	        link: function link($scope, element) {
	            $scope.$on('display-machine-icon', function (event, osicon) {
	
	                var machIcon = d3.select(element[0]).append('svg').attr('x', 0).attr('y', 0).attr('width', '40px').attr('height', '30px').append('g').attr('transform', 'translate(0,8)scale(2)');
	
	                // switch between text
	                switch (osicon) {
	                    case 'win':
	                        machIcon.append('svg:path').attr('d', 'M6,0.6c1-0.4,3.1-1.2,5,0.4c-0.3,0.8-0.9,3.4-1.3,4.5c-1.6-1.2-3.8-0.9-5-0.3C5,4.2,6,0.6,6,0.6z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#D66C27');
	                        machIcon.append('svg:path').attr('d', 'M4.5,5.9c1-0.4,3.1-1.2,5,0.4C9.3,7,8.6,9.6,8.2,10.7c-1.6-1.2-3.8-0.9-5-0.2C3.5,9.4,4.5,5.9,4.5,5.9z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#0390C8');
	                        machIcon.append('svg:path').attr('d', 'M15.3,6.3c-1,0.4-3.1,1.2-5-0.4c0.3-0.8,0.9-3.4,1.3-4.5c1.6,1.2,3.8,0.9,5,0.2C16.3,2.7,15.3,6.3,15.3,6.3z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#87B340');
	                        machIcon.append('svg:path').attr('d', 'M13.9,11.4c-1,0.4-3.1,1.2-5-0.4c0.3-0.8,0.9-3.4,1.3-4.5c1.6,1.2,3.8,0.9,5,0.3C14.9,7.9,13.9,11.4,13.9,11.4z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#FCCE32');
	                        return;
	                    case 'os':
	                        machIcon.append('svg:path').attr('d', 'M11.7,1.9c0.4-0.5,0.7-1.2,0.6-1.9c-0.7,0-1.4,0.5-1.9,1C10,1.5,9.7,2.2,9.8,2.9C10.5,2.9,11.3,2.5,11.7,1.9z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#818385');
	                        machIcon.append('svg:path').attr('d', 'M13.7,5.4c0.2-0.6,0.6-1.1,1.2-1.4c-0.6-0.8-1.5-1.2-2.4-1.2c-1.1,0-1.6,0.5-2.3,0.5c-0.8,0-1.4-0.5-2.4-0.5c-0.9,0-1.9,0.6-2.6,1.5C5,4.7,4.9,5.1,4.8,5.6C4.6,7,4.9,8.8,6,10.4C6.5,11.1,7.2,12,8.1,12c0.8,0,1-0.5,2.1-0.5c1.1,0,1.3,0.5,2.1,0.5c0.9,0,1.6-1,2.2-1.7c0.4-0.6,0.5-0.8,0.8-1.5C13.8,8.3,13.2,6.7,13.7,5.4z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#818385');
	                        return;
	                    case 'linux':
	                        machIcon.append('svg:path').attr('d', 'M10.4,0c0.5,0,1.3,0.4,1.4,1c0.1,0.3,0,0.7,0,1.1c0,0.4,0,0.8,0,1.2c0.1,0.7,0.6,1.1,0.9,1.7c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.4,0.2,0.7,0.2,1.1c0.1,0.4,0.1,0.7,0.1,1.1c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.2,0.3c0.2,0,0.3,0,0.5,0c0.3,0,0.7,0.2,0.6,0.5c-0.4,0.5-0.8,1.2-1.3,1.6c-0.2,0.2-0.4,0.5-0.7,0.5c-0.3,0.1-0.7,0.1-0.9-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.1c-0.4,0-0.8,0-1.2,0c-0.4,0-0.7-0.1-1.1-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2,0.3-0.3,0.3c-0.1,0.2-0.3,0.5-0.6,0.5c-0.1,0-0.3,0-0.4,0c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3-0.2-0.6-0.4-0.9-0.6c-0.3-0.2-0.7-0.5-0.7-0.8c0.1-0.3,0.2-0.4,0.5-0.4c0.1,0,0.3,0,0.3-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3c0.1-0.3,0.5-0.1,0.7,0c0.1-0.1,0.2-0.2,0.2-0.3C7,8.4,7.1,8.4,7.1,8.2C6.9,6.7,7.8,5.3,8.5,4c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.1-0.4,0.1-0.6c0-0.5,0-1,0-1.4c0-0.4,0.1-0.7,0.4-1C9.6,0.2,10,0,10.4,0z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#231F20');
	                        machIcon.append('svg:path').attr('d', 'M11,3.4c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.4,0.3,0.7c0.2,0.5,0.5,0.9,0.6,1.4c0.2,0.5,0.3,0.9,0.2,1.4c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.1-0.1,0.1-0.1,0.1c-0.1,0.1-0.1,0.2-0.1,0.4c-0.2,0-0.3-0.2-0.5-0.1c-0.2,0-0.2,0.4-0.2,0.5c0,0.3,0,0.5,0,0.8c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.5,0.1-1,0.1-1.5,0c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.2-0.1-0.2-0.2c0-0.2-0.2-0.6-0.3-0.8c-0.2-0.5-0.4-1-0.6-1.6c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3c0.1-0.3,0.2-0.5,0.3-0.8C8,6,8.2,5.8,8.3,5.6c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.2-0.4,0.3-0.7C9,4,9.1,3.7,9.2,3.5c0.3,0.3,0.5,0.3,0.9,0.3c0.2,0,0.3-0.1,0.5-0.1C10.6,3.6,10.9,3.4,11,3.4z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#FFFFFF');
	                        machIcon.append('svg:path').attr('d', 'M8.9,1.2C8.9,1.2,8.9,1.2,8.9,1.2C8.9,1.2,8.9,1.2,8.9,1.2z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#C5C7C9');
	                        machIcon.append('svg:path').attr('d', 'M8.9,1.8C8.9,1.8,8.9,1.7,8.9,1.8C8.9,1.7,8.9,1.8,8.9,1.8z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#C5C7C9');
	                        machIcon.append('svg:path').attr('d', 'M8.9,3.4C8.9,3.4,8.9,3.4,8.9,3.4C8.9,3.4,8.9,3.4,8.9,3.4z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#C5C7C9');
	                        machIcon.append('svg:path').attr('d', 'M7.3,8.5c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.2,0.5,0.2,0.7C7.9,9.9,8,10.4,8,10.8c0,0.4-0.3,0.6-0.6,0.6c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.2-0.6-0.4c-0.3-0.2-0.8-0.5-0.9-0.9C5.2,9.8,5.4,9.6,5.6,9.6c0.2,0,0.3,0,0.4-0.2c0.1-0.1,0-0.3,0-0.4c0.1-0.2,0.3-0.1,0.5,0c0.1,0,0.1,0.1,0.2,0c0.1-0.1,0.1-0.2,0.2-0.3C7,8.6,7.3,8.3,7.3,8.5z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#F5C055');
	                        machIcon.append('svg:path').attr('d', 'M11.8,8.8c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0,0.2,0,0.3c0,0.2,0.3,0.3,0.5,0.4C12.9,9.7,13,9.3,13.2,9c0.1,0,0.1,0.3,0.1,0.4c0.1,0.2,0.3,0.1,0.4,0.1c0.3-0.1,0.9,0,0.7,0.5c-0.2,0.3-0.5,0.6-0.7,0.9c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.4-1,0.3c-0.5-0.1-0.5-0.6-0.6-1c-0.1-0.4-0.1-0.9-0.1-1.3c0-0.2,0-0.4,0.1-0.6C11.4,8.8,11.6,8.7,11.8,8.8z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#F5C055');
	                        machIcon.append('svg:ellipse').attr('cx', '10.9').attr('cy', '2.1').attr('rx', '0.4').attr('ry', '0.6').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#FFFFFF');
	                        machIcon.append('svg:ellipse').attr('cx', '9.3').attr('cy', '2.1').attr('rx', '0.4').attr('ry', '0.6').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#FFFFFF');
	                        machIcon.append('svg:path').attr('d', 'M10.1,2.5c0.2,0,0.3,0.2,0.4,0.2c0.2,0.1,0.4,0,0.4,0.2c0.1,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.3,0.2-0.6,0.2s-0.4,0-0.6-0.1C9.4,3.3,9.3,3.2,9.3,3c0-0.2,0.2-0.2,0.4-0.3C9.7,2.7,9.9,2.4,10.1,2.5z').style('fill-rule', '#evenodd').style('clip-rule', '#evenodd').style('fill', '#F5C055');
	                        return;
	                    default:
	                        return;
	                }
	            });
	            $scope.$on('$destroy', function () {
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('numbersOnly', __webpack_require__(838));
	};

/***/ },
/* 838 */
/***/ function(module, exports) {

	'use strict';
	
	function directive() {
	    return {
	        require: 'ngModel',
	        link: function link(scope, element, attrs, modelCtrl) {
	            modelCtrl.$parsers.push(function (inputValue) {
	                // this next if is necessary for when using ng-required on your input.
	                // In such cases, when a letter is typed first, this parser will be called
	                // again, and the 2nd time, the value will be undefined
	                if (inputValue == undefined) return '';
	                var transformedInput = inputValue.replace(/[^0-9+.]/g, '');
	                if (transformedInput != inputValue) {
	                    modelCtrl.$setViewValue(transformedInput);
	                    modelCtrl.$render();
	                }
	                return transformedInput;
	            });
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('makePieChart', __webpack_require__(840));
	};

/***/ },
/* 840 */
/***/ function(module, exports) {

	'use strict';
	
	function directive(getSize, getData, generateId, $interval, $window) {
	    return {
	        link: function link($scope, element, attrs, piCtrl) {
	            var size = getSize(element, 'pieChart');
	            var width = size.width;
	            var height = size.height;
	            var piechart = void 0;
	            $scope.page.w = angular.element($window);
	            var obj = {},
	                array = [];
	            // element[0].insertAdjacentHTML('beforebegin', spinnerHTML); // start spinner
	            // element[0].parentNode.querySelector('.loader').setAttribute('style', 'height:'+(height/2)+'px; position:relative; margin:'+(height/2)+"px 0px -"+(height)+"px 0px;zoom:0.5; -moz-transform: scale(0.5);");
	
	            var dimension,
	                group,
	                chartType,
	                settings,
	                cid,
	                chartUid,
	                filter,
	                div = "#piechart",
	                searchCategories,
	                filter_column,
	                filter_title; // set our default vairables
	            $scope.$on('init', function (event, chart) {
	                if (chart.id !== attrs.uid) {
	                    return;
	                }
	                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') {
	                    return;
	                } // if its not in our dc object, ignore
	                $scope.main.dataObjects[chart.key].launched = true;
	
	                var uid = chart.id;
	                var key = chart.key;
	
	                dimension = $scope.main.dataObjects[key].dimension;
	                group = $scope.main.dataObjects[key].group;
	                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
	                if (typeof $scope.main.dataObjects[key].div !== 'undefined') {
	                    div = "#" + $scope.main.dataObjects[key].div;
	                }
	
	                filter_column = $scope.main.dataObjects[key].settings.filter_column;
	                filter_title = searchCategories[filter_column];
	
	                cid = uid;
	                chartUid = generateId();
	                filter = true;
	
	                var colors;
	                if (typeof $scope.page.color !== "undefined") {
	                    colors = $scope.page.color;
	                } else {
	                    colors = d3.scale.category20();
	                }
	
	                var dataset = [];
	
	                var radius = Math.min(width, height) / 2;
	                var topGroup = [];
	
	                var enterAntiClockwise = {
	                    startAngle: Math.PI * 2,
	                    endAngle: Math.PI * 2
	                };
	
	                var pie = d3.layout.pie().value(function (d) {
	                    return d.value;
	                }).sort(null);
	
	                var arc = d3.svg.arc().innerRadius(radius - radius * 0.6).outerRadius(radius - radius * 0.15);
	
	                var outterDiv = d3.select(div).append("svg").attr("width", width).attr("height", height);
	                var svg = outterDiv.append("g").attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
	                var legend = outterDiv.append("g").attr("class", "legend").attr("transform", "translate(0,0)");
	
	                // draws the pie chart TODO: translation
	                function redraw() {
	                    topGroup = getTop();
	                    svg.selectAll("g.arc").remove();
	                    // set up groups
	                    var arcsCont = svg.selectAll("g.arc").data(pie(topGroup));
	                    var arcs = arcsCont.enter().append("g").attr("class", "arc").attr("transform", "translate(" + 0 + "," + 0 + ")").on("click", function (d) {
	                        handleFilter(d);
	                    });
	                    // draw arc paths
	                    var path = arcs.append("path").attr("fill", function (d, i) {
	                        return colors(d.data.key);
	                    }).attr("d", arc).each(function (d) {
	                        this._current = d;
	                    });
	                    doLegend();
	                }
	                // gets the top 9 grouping of the piechart data
	                function getTopData() {
	                    dataset = [];
	                    for (var g in group.top(9)) {
	                        dataset.push(group.top(9)[g].value);
	                    }
	                }
	                // get the top groups then set the rest to "Other"
	                function getTop() {
	                    array = [];
	                    if (obj.hasOwnProperty('Other')) {
	                        obj["Other"] = { key: "Other", value: 0 };
	                    }
	                    group.top(Infinity).map(function (d) {
	                        if (obj.hasOwnProperty(d.key)) {
	                            obj[d.key] = d;
	                        } else if (Object.keys(obj).length < 9) {
	                            obj[d.key] = d;
	                        } else {
	                            if (!obj.hasOwnProperty('Other')) {
	                                obj["Other"] = { key: "Other", value: 0 };
	                            }
	                            obj["Other"].value += d.value;
	                        }
	                    });
	                    for (var o in obj) {
	                        array.push(obj[o]);
	                    }
	                    return array;
	                }
	                // handles the filtering, only difference is when its 'other' it excludes the other top groupings
	                function handleFilter(node) {
	                    var action = 'include';
	                    var filters = [];
	                    if (node.data.key === "Other") {
	                        action = 'exclude';
	                        for (var t in topGroup) {
	                            if (topGroup[t].key !== "Other") {
	                                filters.push(topGroup[t].key);
	                            }
	                        }
	                    } else {
	                        filters.push(node.data.key);
	                    }
	                    for (var i = 0, len = filters.length; i < len; i++) {
	                        $scope.main.filterItem(filter_column, filters[i], action, filter_title, false);
	                    }
	                }
	
	                //////////////
	                /// LEGEND ///
	                //////////////
	                var legendLines;
	                function doLegend() {
	                    legend.selectAll(".legendLines").remove();
	                    legendLines = legend.selectAll(".legendLines").data(pie(topGroup)).enter().append("g")
	                    // .attr("class", "legendLines")
	                    .attr("class", function (d, i) {
	                        if (d.value > 0) {
	                            return "legendLines";
	                        }
	                        return "legendLines grey";
	                    }).attr("transform", function (d, i) {
	                        return "translate(11," + i * 15 + ")";
	                    }).on("click", function (d) {
	                        if (d.value > 0) {
	                            handleFilter(d);
	                        }
	                    });
	                    legendLines.append("rect").attr("x", 0).attr("height", 10).attr("width", 10).style("fill", function (d, i) {
	                        if (d.value > 0) {
	                            return colors(d.data.key);
	                        }
	                        return "#ddd";
	                    });
	                    legendLines.append("text").attr("x", 14).attr("y", 5).attr("dy", ".35em").text(function (d) {
	                        return d.data.key.replace("N/A", "-");
	                    });
	                }
	
	                // once piechart is finished getting its data, it then creates an object with the proper most popular groupings
	                $scope.page.setGroupObj = function (object) {
	                    obj = angular.copy(object);
	                    getTopData();
	                    redraw();
	                };
	                // set update functions
	                $scope.$on('updatedData', function (event, id, initial) {
	                    if (id !== uid) {
	                        return;
	                    } // only run when it sees its id has filtered
	                    getTopData();
	                    redraw();
	                });
	            });
	            $scope.$on('$destroy', function () {
	                element.remove();
	                piechart = undefined;
	                $scope.page.w = null;
	            });
	        }
	    };
	}
	
	directive.$inject = ['getSize', 'getData', 'generateId', '$interval', '$window'];
	module.exports = directive;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('makeRowChart', __webpack_require__(842));
	};

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _dc = __webpack_require__(811);
	
	var _dc2 = _interopRequireDefault(_dc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function directive(getSize, $window) {
	    return {
	        link: function link($scope, element, attrs, dcCrtl) {
	            var uid = false; // because there is one instances of this directive per view, we can assign a uid directly to it
	            var hHeight, lOffset;
	            var size = getSize(element, 'rowchart');
	            var width = size.width;
	            var dimension,
	                group,
	                uid,
	                key,
	                searchCategories,
	                div = "#rowchart",
	                outFilter,
	                rowDomain; // set our default vairables
	            $scope.page.w = angular.element($window);
	            var uid;
	            var rowchart = void 0;
	            var dictionary = {
	                'Guarded': '1',
	                'Elevated': '2',
	                'High': '3',
	                'Severe': '4'
	            };
	            var oldHeight = 0;
	            $scope.$on('init', function (event, chart) {
	                if (chart.id !== attrs.uid) {
	                    return;
	                }
	                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') {
	                    // if it's not in our dc object, ignore
	                    return;
	                }
	                $scope.main.dataObjects[chart.key].launched = true;
	                uid = chart.id;
	                key = chart.key;
	
	                dimension = $scope.main.dataObjects[key].dimension;
	                group = $scope.main.dataObjects[key].group;
	                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
	
	                rowchart = _dc2.default.rowChart(div);
	
	                var filter = true;
	                var numberFormat = d3.format(".2f");
	
	                var count = group.top(Infinity).length; // CHANGE THIS to count return rows
	
	                if (count < 7) {
	                    lOffset = 14;
	                    hHeight = (count + 1) * 33;
	                } else {
	                    lOffset = 12;
	                    hHeight = (count + 1) * 29;
	                }
	                oldHeight = hHeight;
	
	                // filter rules
	                rowchart.on("filtered", function (chart, value) {
	                    var column,
	                        title,
	                        cnt = 0;
	                    if ($scope.main.dataObjects[key].settings.settings.type === 'summary') {
	                        for (var s in searchCategories) {
	                            column = s;
	                            title = searchCategories[s];
	                            $scope.main.filterItem(column, dictionary[value], "include", title);
	                            break;
	                        }
	                    } else {
	                        var val = [];
	                        val.push(value.slice(0, value.length - 1));
	                        val.push(value.slice(value.length - 1, value.length));
	                        for (var _s in searchCategories) {
	                            column = _s;
	                            title = searchCategories[_s];
	                            $scope.main.filterItem(column, val[cnt], "include", title);
	                            cnt++;
	                            if (cnt > 1) {
	                                break;
	                            }
	                        }
	                    }
	                });
	
	                // CALCULATING DOMAIN
	                if ($scope.main.dataObjects[key].settings.settings.type === 'summary') {
	                    var tops = group.order(function (p) {
	                        if (typeof p !== "undefined") {
	                            return p;
	                        }
	                    }).top(1);
	                    if (tops.length === 0) {
	                        rowDomain = 0;
	                    } else {
	                        rowDomain = tops[0].value;
	                    }
	                    var orderDictionary = {
	                        'Guarded': 1,
	                        'Elevated': 2,
	                        'High': 3,
	                        'Severe': 4
	                    };
	                    // set value accessor
	                    rowchart.valueAccessor(function (d) {
	                        if (d.key === "") {
	                            return;
	                        }
	                        if (d.value === 0) {
	                            return 0.1;
	                        } else {
	                            return d.value;
	                        }
	                    }).ordering(function (d) {
	                        return -orderDictionary[d.key];
	                    }).colors(d3.scale.ordinal().domain(['Guarded', 'Elevated', 'High', 'Severe']).range(["#377FC7", "#F5D800", "#F88B12", "#FF3131"])) //["#377FC7","#FF3131","#F88B12", "#F5D800"]))
	                    .colorAccessor(function (d) {
	                        return d.key;
	                    }).label(function (d) {
	                        return d.key + " (" + d.value + ")";
	                    });
	                } else {
	                    var tops = group.order(function (p) {
	                        if (typeof p !== "undefined" && p.severity > 0) {
	                            return p.count;
	                        }
	                    }).top(1);
	                    if (count > 0) {
	                        rowDomain = tops[0].value.count + 1.1;
	                    } else {
	                        rowDomain = 50;
	                    }
	                    rowchart.valueAccessor(function (d) {
	                        if (d.value.severity > 0) {
	                            if (d.key === "") {
	                                return;
	                            }
	                            if (d.value.count === 0) {
	                                return 0.1;
	                            } else {
	                                return d.value.count;
	                            }
	                        } else {
	                            return null;
	                        }
	                    }).ordering(function (d) {
	                        return -d.value.severity;
	                    }).colors(d3.scale.ordinal().domain([1, 2, 3, 4]).range(["#377FC7", "#F5D800", "#F88B12", "#FF3131"])) // ["#377FC7","#FF3131","#F88B12", "#F5D800"]))
	                    .colorAccessor(function (d) {
	                        if (d.value.severity > 0) {
	                            return d.value.severity;
	                        } else {
	                            return null;
	                        }
	                    }).renderLabel(true).margins({
	                        top: 5,
	                        left: 0,
	                        right: 0,
	                        bottom: 20
	                    }).label(function (d) {
	                        if (d.value.severity > 0) {
	                            if (d.key === "") {
	                                return "";
	                            }
	                            return d.key.substring(0, d.key.length - 1) + ' (' + d.value.count + ')';
	                        } else {
	                            return null;
	                        }
	                    }).labelOffsetY(lOffset);
	                }
	                // AXIS FORMATTING
	                var numberFormat = d3.format(",f");
	                function logFormat(d) {
	                    var x = Math.log(d) / Math.log(10) + 1e-6;
	                    return Math.abs(x - Math.floor(x)) < 0.3 ? numberFormat(d) : "";
	                }
	                rowchart.width(width).height(hHeight).group(group).dimension(dimension).elasticX(false).x(d3.scale.log().clamp(true).domain([0.9, rowDomain]).range([0, width])) // 500 ->width
	                .xAxis().scale(rowchart.x()).tickFormat(logFormat);
	
	                d3.select(div + ' svg').attr('width', width).attr('height', hHeight);
	                $(element).height(hHeight);
	                rowchart.render();
	            });
	            // set update functions
	            $scope.$on('updatedData', function (event, id) {
	                if (id !== uid) {
	                    // only run when it sees its id has filtered
	                    return;
	                }
	                if ($scope.main.dataObjects[key].settings.settings.type === 'summary') {
	                    var tops = group.order(function (p) {
	                        if (typeof p !== "undefined") {
	                            return p;
	                        } else {
	                            return 0;
	                        }
	                    }).top(1);
	                    if (tops.length === 0) {
	                        rowDomain = 0;
	                    } else {
	                        rowDomain = tops[0].value;
	                    }
	                } else {
	                    var count = group.top(Infinity).length; // CHANGE THIS to count return rows
	                    var tops = group.order(function (p) {
	                        if (typeof p !== "undefined") {
	                            return p.count;
	                        } else {
	                            return 0;
	                        }
	                    }).top(1);
	                    if (count > 0) {
	                        rowDomain = tops[0].value.count + 1.1;
	                    } else {
	                        rowDomain = 50;
	                    }
	                }
	                if (count < 7) {
	                    lOffset = 14;
	                    hHeight = (count + 1) * 33;
	                } else {
	                    lOffset = 12;
	                    hHeight = (count + 1) * 29;
	                }
	                rowchart.height(hHeight).x(d3.scale.log().clamp(true).domain([0.9, rowDomain]).range([0, width])).labelOffsetY(lOffset);;
	                d3.select(element[0]).select('svg').attr('width', width).attr('height', hHeight);
	                $(element).height(hHeight);
	                if (oldHeight !== hHeight) {
	                    rowchart.render();
	                    oldHeight = hHeight;
	                } else {
	                    rowchart.redraw();
	                }
	            });
	
	            var resizeTimeout = void 0;
	            $scope.page.w.bind('resize', function () {
	                if (!resizeTimeout) {
	                    if (typeof rowchart !== "undefined") {
	                        resizeTimeout = setTimeout(function () {
	                            resizeTimeout = null;
	                            size = getSize(element, 'rowchart');
	                            width = size.width;
	                            rowchart.width(width).x(d3.scale.log().clamp(true).domain([0.9, rowDomain]).range([0, width]));
	                            d3.select(element[0]).select('svg').attr('width', width);
	                            rowchart.redraw();
	                        }, 250);
	                    }
	                }
	            });
	
	            $scope.$on('$destroy', function () {
	                element.remove();
	                rowchart = undefined;
	                $scope.page.w = null;
	            });
	        }
	    };
	}
	
	directive.$inject = ['getSize', '$window'];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('searchbar', __webpack_require__(844));
	};

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function directive(generateId, $stateParams, $rootScope, $location, usSpinnerService, $state) {
	    return {
	        replace: true,
	        restrict: "EA",
	        scope: true,
	        template: __webpack_require__(845),
	        link: function link($scope, element, attrs, ctrl) {
	            // select elements
	            var elem = element[0],
	                input = elem.querySelector('input'),
	                hintMenu = elem.querySelector('.hint-menu-container'),
	                filtersMenu = elem.querySelector('.filters-container'),
	                buttons = elem.querySelector('.filter-controls');
	
	            // filter management
	            var filterDropdownBtn = buttons.querySelector('.count');
	
	            // DEFINITIONS
	            var keys = {
	                up: 38,
	                down: 40,
	                left: 37,
	                right: 39,
	                esc: 27,
	                back: 8,
	                enter: 13,
	                shift: 16,
	                ctrl: 17,
	                alt: 18,
	                space: 32,
	                tab: 9
	
	                // arrow navigation on the dropdown items
	            };function modHighlightPosition(arr, command, callback) {
	                function checkNext(a, i) {
	                    if (a.length - 1 === i) {
	                        // we're at the end of the array, nothing here
	                        return false;
	                    } else {
	                        return true;
	                    }
	                }
	                function checkPrev(a, i) {
	                    if (i === 0) {
	                        // there's nothing before the 0
	                        return false;
	                    } else {
	                        return true;
	                    }
	                }
	                var selected = void 0,
	                    result = void 0;
	                // loop through all the list items and children to see if anything has been selected as active yet
	                for (var p = 0, plen = arr.length; p < plen; p++) {
	                    for (var v = 0, vlen = arr[p].value.length; v < vlen; v++) {
	                        if (arr[p].value[v].selected) {
	                            selected = [p, v];
	                        }
	                        if (selected) {
	                            break; // stop loop if found something selected
	                        }
	                    }
	                    if (selected) {
	                        break; // stop parent loop if found something selected
	                    }
	                }
	                // if selected, change active status
	                if (selected) {
	                    $scope.hintList[selected[0]].value[selected[1]].selected = false;
	                }
	                if (command === 'up') {
	                    if (selected) {
	                        var _p = selected[0];
	                        var _v = selected[1];
	                        // check for previous value
	                        if (checkPrev(arr[_p].value, _v)) {
	                            // there is previous value
	                            result = [_p, _v - 1];
	                        } else {
	                            // there is not a previous value. check for previous parent
	                            if (checkPrev(arr, _p)) {
	                                // there is a previous parent
	                                result = [_p - 1, arr[_p - 1].value.length - 1];
	                            } else {
	                                // there is not a previous parent
	                                // go to bottom of everything
	                                result = [arr.length - 1, arr[arr.length - 1].value.length - 1];
	                            }
	                        }
	                    } else {
	                        // go to bottom of the chart
	                        var _p2 = arr.length - 1;
	                        var _v2 = arr[arr.length - 1].value.length - 1;
	                        result = [_p2, _v2];
	                    }
	                } else {
	                    // command === 'down'
	                    if (selected) {
	                        var _p3 = selected[0];
	                        var _v3 = selected[1];
	                        // check for next value
	                        if (checkNext(arr[_p3].value, _v3)) {
	                            // there is a previous value
	                            result = [_p3, _v3 + 1];
	                        } else {
	                            // there is no next value. check for next parent
	                            if (checkNext(arr, _p3)) {
	                                // there is another parent
	                                result = [_p3 + 1, 0];
	                            } else {
	                                // there is not another parent
	                                // go to top
	                                result = [0, 0];
	                            }
	                        }
	                    } else {
	                        // just go to the first item in the list
	                        result = [0, 0];
	                    }
	                }
	                // set the current selected item
	                $scope.hintList[result[0]].value[result[1]].selected = true;
	                return callback(result);
	            }
	            function getSelectedListItem() {
	                var selected = false;
	                // loop through all the list items and children to see if anything has been selected as active yet
	                for (var p = 0, plen = $scope.hintList.length; p < plen; p++) {
	                    for (var v = 0, vlen = $scope.hintList[p].value.length; v < vlen; v++) {
	                        if ($scope.hintList[p].value[v].selected) {
	                            selected = [p, v];
	                        }
	                        if (selected) {
	                            break; // stop loop if found something selected
	                        }
	                    }
	                    if (selected) {
	                        break; // stop parent loop if found something selected
	                    }
	                }
	                if (selected) {
	                    selected = {
	                        item: $scope.hintList[selected[0]].value[selected[1]],
	                        parent: $scope.hintList[selected[0]]
	                    };
	                }
	                return selected;
	            }
	            function deselectSelectedListItems() {
	                var selected = void 0;
	                for (var p = 0, plen = $scope.hintList.length; p < plen; p++) {
	                    for (var v = 0, vlen = $scope.hintList[p].value.length; v < vlen; v++) {
	                        if ($scope.hintList[p].value[v].selected) {
	                            selected = [p, v];
	                        }
	                        if (selected) {
	                            break; // stop loop if found something selected
	                        }
	                    }
	                    if (selected) {
	                        break; // stop parent loop if found something selected
	                    }
	                }
	                if (selected) {
	                    $scope.hintList[selected[0]].value[selected[1]].selected = false;
	                }
	            }
	            function resetDefaultFilterList() {
	                $scope.filterListCount = 0;
	                $scope.filterList = {
	                    include: [],
	                    exclude: []
	                };
	            }
	            resetDefaultFilterList();
	            // set previous input tokens for change refrence later
	            var pInput = false,
	                pTokens = [];
	            function resetDefaultSearchInputs() {
	                input.value = '';
	                pInput = false, pTokens = [];
	                $scope.inputChain = [];
	                $scope.autocomplete = {
	                    value: '',
	                    title: ''
	                };
	                $scope.hintList = false;
	            }
	            resetDefaultSearchInputs();
	
	            // function to display modifiers in the search bar
	            $scope.modifierDisplay = function (item) {
	                var itemClass = void 0;
	                if (item.type === 'text') {
	                    itemClass = '';
	                } else if (item.completed) {
	                    itemClass = 'modifier';
	                } else {
	                    itemClass = 'modifier incomplete';
	                }
	                return itemClass;
	            };
	
	            // function to display prefix's in the search bar
	            $scope.addSpace = function (item, index) {
	                if (!pInput) {
	                    return '';
	                } // do nothing if pInput is false
	                // do nothing if the the item is at the end of the chain
	                if (pInput[pInput.length - 1].value === '') {
	                    return ' ';
	                } else if (index === pInput.length - 1) {
	                    return '';
	                } else if (item.type === 'text' || item.completed) {
	                    // add space if there is no type defined or item is completed
	                    return ' ';
	                } else {
	                    return '';
	                }
	            };
	
	            // these can only be used once
	            var availableModifiers = [{
	                key: 'include',
	                value: 'is:',
	                tip: 'a value'
	            }, {
	                key: 'exclude',
	                value: 'not:',
	                tip: 'a value'
	            }, {
	                key: 'include',
	                value: 'include:',
	                tip: 'a value'
	            }, {
	                key: 'exclude',
	                value: 'exclude:',
	                tip: 'a value'
	            }];
	            var optionalModifiers = [{
	                key: 'from',
	                value: 'from:',
	                tip: 'a category or column'
	            }];
	
	            var allModifiers = _.concat(availableModifiers, optionalModifiers); // since nothing is set yet, lets concat the available modifiers with optional ones
	
	            // ELEMENT HELPERS
	            // stop up, down, and tab from acting on input box
	            input.addEventListener('keydown', function (e) {
	                switch (e.keyCode) {
	                    case keys.up:
	                    case keys.down:
	                    case keys.tab:
	                        e.preventDefault();
	                        break;
	                }
	            });
	            function hasClass(el, name, callback) {
	                var result = false;
	                if (el.classList) {
	                    result = el.classList.contains(name);
	                } else {
	                    result = new RegExp('(^| )' + name + '( |$)', 'gi').test(el.className);
	                }
	                return callback(result);
	            }
	            function addClass(el, name) {
	                if (el.classList) {
	                    el.classList.add(name);
	                } else {
	                    el.className += ' ' + name;
	                }
	                return;
	            }
	            function removeClass(el, name) {
	                if (el.classList) {
	                    el.classList.remove(name);
	                } else {
	                    el.className = el.className.replace(new RegExp('(^|\\b)' + name.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	                }
	            }
	
	            function checkIfModifier(string) {
	                var modifier = false;
	                // loop through modifier list to see if the string starts with any of its values
	                for (var m = 0, mlen = allModifiers.length; m < mlen; m++) {
	                    if (_.startsWith(string.toLowerCase(), allModifiers[m].value)) {
	                        modifier = allModifiers[m];
	                        break; // stop loop if found a match
	                    }
	                }
	                return modifier;
	            }
	
	            function injectIntoArray(arr, index, obj) {
	                // take section in front of index
	                var leftSide = _.take(arr, index);
	                var rightSide = _.takeRight(arr, arr.length - index);
	                // push new obj to the end of the left side
	                if (_.isArray(obj)) {
	                    for (var o = 0, olen = obj.length; o < olen; o++) {
	                        leftSide.push(obj[o]);
	                    }
	                } else {
	                    leftSide.push(obj);
	                }
	                // concat sides
	                return _.concat(leftSide, rightSide);
	            }
	
	            function removeFromArray(arr, start, end) {
	                var leftSide = _.take(arr, start);
	                var rightSide = _.takeRight(arr, arr.length - (end + 1));
	                return _.concat(leftSide, rightSide);
	            }
	
	            /////////////////////////////
	            /// FILTER LIST MODIFIERS ///
	            /////////////////////////////
	            function addToFilterList(action, value, column, columnTitle) {
	                // clear the pInput
	                resetDefaultSearchInputs();
	                // check to see if the fitler already exists in the chain
	                var matching = $scope.filterList[action].filter(function (f) {
	                    return f.value === value && f.from === column;
	                });
	                if (matching.length > 0) {
	                    return;
	                } // do nothing if there are identical items
	                $scope.filterListCount++;
	                if (action === 'exclude') {
	                    $scope.filterList.exclude.push({ value: value, from: column, title: columnTitle });
	                } else {
	                    $scope.filterList.include.push({ value: value, from: column, title: columnTitle });
	                }
	                $scope.main.addFilter(column, value, action, false, columnTitle);
	                $scope.main.runFilters();
	                if ($state.current.name === 'pages.main.search') {
	                    $scope.$broadcast('runSearch');
	                } else if ($state.current.name === 'pages.main.lateral_map') {
	                    $scope.main.runLatFilters($scope.filterList);
	                }
	            }
	            $scope.removeFilter = function (action, index) {
	                var item = angular.copy($scope.filterList[action][index]);
	                $scope.main.removeFilter(item.from, item.value, action, false, item.columnTitle);
	                // remove item from the filter list when X is clicked in dropdown
	                $scope.filterList[action].splice(index, 1);
	                $scope.filterListCount--;
	                $scope.main.runFilters();
	                if ($state.current.name === 'pages.main.search') {
	                    $scope.$broadcast('runSearch');
	                } else if ($state.current.name === 'pages.main.lateral_map') {
	                    $scope.main.runLatFilters($scope.filterList);
	                }
	            };
	            function addToFIlterListFromChain(chain) {
	                var queryString = "",
	                    modifier = 'include',
	                    column = 'all',
	                    columnTitle = void 0; // set defaults for filter insert
	                var obj = {};
	                chain.forEach(function (c) {
	                    if (!obj.hasOwnProperty(c.type)) {
	                        obj[c.type] = '';
	                    }
	                    obj[c.type] += c.value + ' ';
	                });
	                for (var i in obj) {
	                    switch (i) {
	                        case 'from':
	                            // strip the 'from:' from the value
	                            var col = _.trimStart(obj[i].toLowerCase(), 'from:');
	                            col = _.trim(col); // remove any spaces in begining or end
	                            // loop through columns and find a match
	                            for (var s in $scope.main.searchCategories) {
	                                if ($scope.main.searchCategories[s].toLowerCase() === col) {
	                                    column = s;
	                                    columnTitle = $scope.main.searchCategories[s];
	                                    break;
	                                }
	                            }
	                            break;
	                        case 'include':
	                            if (_.startsWith(obj[i].toLowerCase(), 'is:')) {
	                                obj[i] = obj[i].substring('is:'.length);
	                            }
	                            if (_.startsWith(obj[i].toLowerCase(), 'include:')) {
	                                obj[i] = obj[i].substring('include:'.length);
	                            }
	                            obj[i] = _.trim(obj[i]); // trim any white space
	                            queryString = obj[i];
	                            modifier = 'include';
	                            break;
	                        case 'exclude':
	                            if (_.startsWith(obj[i].toLowerCase(), 'not:')) {
	                                obj[i] = obj[i].substring('not:'.length);
	                            }
	                            if (_.startsWith(obj[i].toLowerCase(), 'exclude:')) {
	                                obj[i] = obj[i].substring('exclude:'.length);
	                            }
	                            obj[i] = _.trim(obj[i]); // trim any white space
	                            queryString = obj[i];
	                            modifier = 'exclude';
	                            break;
	                        case 'text':
	                            obj[i] = _.trim(obj[i]); // trim any white space
	                            queryString = obj[i];
	                            break;
	                    }
	                }
	                addToFilterList(modifier, queryString, column, columnTitle);
	            }
	
	            // listen for incoming filter events from main controller
	            $scope.$on('addSearchBarItem', function (event, column, value, action, columnTitle) {
	                // note this is a call coming externally. the item has already been added to the data model
	                // we just need to add it to our dropdown
	                $scope.filterListCount++; // increase the count
	                $scope.filterList[action].push({ value: value, from: column, title: columnTitle }); // push to filter list
	            });
	
	            $scope.$on('removeSearchBarItem', function (event, column, value, action, columnTitle) {
	                // addToFilterList(action, value, column, columnTitle);
	                // we have to check if the value exists in our filter list by looping through
	                for (var f = 0, flen = $scope.filterList[action].length; f < flen; f++) {
	                    if ($scope.filterList[action][f].from === column && $scope.filterList[action][f].value.toLowerCase() === value.toLowerCase()) {
	                        $scope.removeFilter(action, f);
	                        break; // stop loop
	                    }
	                }
	            });
	
	            $scope.$on('clearAllFilters', function () {
	                $scope.removeAllFilters();
	            });
	
	            // helper for converting our pInput array to the format read by the hightlight loop in the view
	            function convertTokensToChain(inputs) {
	                var arr = []; // this is going to act as our new list
	                for (var i = 0, len = inputs.length; i < len; i++) {
	                    var _input = inputs[i];
	                    if (_input.type === 'text') {
	                        arr.push({
	                            type: _input.type,
	                            completed: _input.completed,
	                            value: _input.value
	                        });
	                    } else {
	                        if (arr.length > 0) {
	                            // if it shares the same type as the incomplete one stored before..
	                            // check if it has the same type AND completedness of the item before
	                            if (arr[arr.length - 1].type === _input.type && arr[arr.length - 1].completed === _input.completed) {
	                                arr[arr.length - 1].value = arr[arr.length - 1].value + ' ' + _input.value; // append the value to the previous
	                            } else {
	                                // this shouldent ever run
	                                arr.push({
	                                    type: _input.type,
	                                    completed: _input.completed,
	                                    value: _input.value
	                                });
	                            }
	                        } else {
	                            // this is the first incomplete item in the chain.. just push it as so
	                            arr.push({
	                                type: _input.type,
	                                completed: _input.completed,
	                                value: _input.value
	                            });
	                        }
	                    }
	                }
	                return arr;
	            }
	            // this function takes an array and displays the items in the dropdown below the search
	            function displayDropdown(arr) {
	                // as we filter, some categories' values will become empty arrays.. dont push those
	                var list = arr.filter(function (d) {
	                    return d.value.length > 0;
	                });
	                $scope.hintList = list; // assign the list to the dropdown
	                // if there is nothing in the list, hide the dropdown
	                if (list.length === 0) {
	                    addClass(hintMenu, 'hidden');
	                } else {
	                    removeClass(hintMenu, 'hidden');
	                }
	                return;
	            }
	
	            // taking in a string, item array and the input field. this function should return
	            // the index of what item is currently being modified
	            function getCurrentWordIndex(arr, string, input) {
	                /*
	                ** Returns the caret (cursor) position of the specified text field.
	                ** Return value range is 0-oField.value.length.
	                */
	                function doGetCaretPosition(oField) {
	                    // Initialize
	                    var iCaretPos = 0;
	                    // IE Support
	                    if (document.selection) {
	                        // Set focus on the element
	                        oField.focus();
	                        // To get cursor position, get empty selection range
	                        var oSel = document.selection.createRange();
	                        // Move selection start to 0 position
	                        oSel.moveStart('character', -oField.value.length);
	                        // The caret position is selection length
	                        iCaretPos = oSel.text.length;
	                    }
	                    // Firefox support
	                    else if (oField.selectionStart || oField.selectionStart == '0') {
	                            iCaretPos = oField.selectionStart;
	                        }
	                    // Return results
	                    return iCaretPos;
	                }
	                var inputPosition = doGetCaretPosition(input); // get input position
	                var s = string.substring(0, inputPosition); // truncate the string into our new variable s
	                // s = _.trimEnd(s); // remove any space at the end of the string that may insterfere with the split below
	                var a = s.split(' '); // split our string into an array seperated by spaces
	                // because the pInput array is 1:1 the length of the individual words in the input box...
	                // the last position in the a array should tell us which pInput item is being modified.
	                // the index to return should be the last item (?)
	                return a.length - 1;
	            }
	
	            function autocomplete(typed, list, tokens) {
	                function setAutocompleteValue(value, title) {
	                    if (!value) {
	                        $scope.autocomplete.title = '';
	                        $scope.autocomplete.value = '';
	                    } else {
	                        $scope.autocomplete.value = value;
	                        $scope.autocomplete.title = title; // this value is so we know what the title looks like (where the caps are) if the user tab-completes
	                    }
	                }
	                if (!typed) {
	                    setAutocompleteValue(false);
	                } else if (list.length > 0) {
	                    if (list[0].value.length > 0) {
	                        var match = list[0].value[0];
	                        if (_.startsWith(match.value.toLowerCase(), typed.toLowerCase())) {
	                            var count = typed.length;
	                            // if the last items in tokens array is an empty string, there is a space present
	                            if (tokens[tokens.length - 1] === '') {
	                                setAutocompleteValue(_.trimStart(match.value.substr(count, match.value.length - 1), match.value));
	                            } else {
	                                setAutocompleteValue(match.value.substr(count, match.value.length - 1), match.value);
	                            }
	                        } else {
	                            setAutocompleteValue(false);
	                        }
	                    } else {
	                        setAutocompleteValue(false);
	                    }
	                } else {
	                    setAutocompleteValue(false);
	                }
	            }
	
	            function getMatchingTextString(arr, indexes) {
	                // assuming the index's are in ascending order. start a loop at the begining
	                var string = '';
	                for (var i = indexes[0]; i <= indexes[indexes.length - 1]; i++) {
	                    string += arr[i].value;
	                    if (i !== indexes.length - 1) {
	                        string += ' '; // attach space to every word until the end
	                    }
	                }
	                // take the string and strip any modifiers off the front if they exist
	                allModifiers.forEach(function (m) {
	                    if (_.startsWith(string, m.value)) {
	                        // if the string starts with any of the modifier values, trim it off and strip any spaces
	                        string = _.trimStart(string, m.value);
	                        // now trim any whitespace
	                        string = _.trimStart(string);
	                    }
	                });
	                return string;
	            }
	
	            // input pInout array and current obj and get back array of matching group items
	            function getMatchingGroupIndexs(arr, current, index, callback) {
	                var left = [],
	                    right = [];
	                for (var i = index; i >= 0; i--) {
	                    if (typeof arr[i] === 'undefined') {
	                        continue;
	                    } // do noghting if there is a miscount of indexes
	                    if (current.completed === arr[i].completed && current.type === arr[i].type) {
	                        left.push(i);
	                    } else {
	                        break; // end loop if the next item does not match
	                    }
	                }
	                left = _.reverse(left);
	                for (var _i = index + 1, len = arr.length; _i < len; _i++) {
	                    if (typeof arr[_i] === 'undefined') {
	                        continue;
	                    } // do noghting if there is a miscount of indexes
	                    if (current.completed === arr[_i].completed && current.type === arr[_i].type) {
	                        // note: there shouldent be a modifier here because we are moving somewhere after the first defining value
	                        right.push(_i);
	                    } else {
	                        break; // end the loop
	                    }
	                }
	                var concat = _.concat(left, right); // bring left and right sides together
	                return callback(concat);
	            }
	
	            /*
	             * This accepts pInput, modifies values and returns new pInput array to be saved
	             * @param  {Array}  arr      [Original pInput array]
	             * @param  {Array}  indexes  [Array of indexes to change in pInput - ASCENDING]
	             * @param  {Array}  toChange [Array of objects containing keys with new values to change]
	             * @return {Array}  callback [New array to replace the pInput that was originally inserted]
	             */
	            function changeGroupStatus(arr, indexes, toChange, callback) {
	                // loop through the indexes to change
	                for (var i = indexes[0]; i <= indexes[indexes.length - 1]; i++) {
	                    // loop through the list of changes to make
	                    for (var c = 0, clen = toChange.length; c < clen; c++) {
	                        arr[i][toChange[c].key] = toChange[c].value;
	                    }
	                }
	                return callback(arr);
	            }
	
	            // check what element of pInput does not match tokens. return the index and value of the changed item
	            function isChanged(arr, tokens, callback) {
	                var changed = false;
	                for (var p = 0, plen = arr.length; p < plen; p++) {
	                    if (arr[p].value !== tokens[p] && typeof tokens[p] !== 'undefined') {
	                        changed = {
	                            index: p,
	                            value: tokens[p]
	                        };
	                        break;
	                    }
	                }
	                return callback(changed);
	            }
	
	            ////////////////////
	            ///// INPUT BOX ////
	            ////////////////////
	            function inputRun(event) {
	                var list = [];
	                function sendToList(arr, title, key) {
	                    // sort columns before sending it
	                    arr.sort(function (a, b) {
	                        if (a.title < b.title) return -1;
	                        if (a.title > b.title) return 1;
	                        return 0;
	                    });
	                    if (arr.length > 0) {
	                        list.push({
	                            key: key,
	                            title: title,
	                            value: arr
	                        });
	                    }
	                }
	                function dropdownFilter(type, term) {
	                    var arr = void 0;
	                    switch (type) {
	                        case '+':
	                            var followingText = _.trimStart(term, '+'); // trim '+' from the start of the input string
	                            arr = allModifiers.filter(function (item, index) {
	                                var result = false;
	                                if (followingText === '') {
	                                    result = true;
	                                } else if (item.value.indexOf(followingText.toLowerCase()) !== -1) {
	                                    result = true;
	                                } else {
	                                    result = false;
	                                }
	                                return result;
	                            });
	                            sendToList(arr, 'Modifiers', 'modifiers'); // push modifiers to list
	                        case 'modifiers':
	                            if (!term) {
	                                arr = allModifiers;
	                            } else {
	                                arr = allModifiers.filter(function (item, index) {
	                                    var result = false;
	                                    if (item.value.indexOf(term.toLowerCase()) !== -1) {
	                                        result = true;
	                                    }
	                                    return result;
	                                });
	                            }
	                            return sendToList(arr, 'Modifiers', 'modifiers'); // push modifiers to list
	                            break;
	                        case 'columns':
	                            arr = [];
	                            // loop through available categories and push the matching ones
	                            for (var c in $scope.main.searchCategories) {
	                                if (!term) {
	                                    arr.push({
	                                        key: c,
	                                        value: $scope.main.searchCategories[c],
	                                        selected: false // value for highlighting style upon arrow up/down
	                                    });
	                                } else {
	                                    if ($scope.main.searchCategories[c].toLowerCase().indexOf(term.toLowerCase()) !== -1) {
	                                        arr.push({
	                                            key: c,
	                                            value: $scope.main.searchCategories[c],
	                                            selected: false // value for highlighting style upon arrow up/down
	                                        });
	                                    }
	                                }
	                            }
	                            return sendToList(arr, 'Columns', 'columns'); // send it to the list
	                            break;
	                    }
	                }
	                function handleModifierDropdown(changed, type, list) {
	                    switch (type) {
	                        case 'from':
	                            if (changed.value === 'from:') {
	                                // loop through available categories and push the matching one
	                                dropdownFilter('columns', false);
	                            } else {
	                                // get matching indexes of changed item
	                                getMatchingGroupIndexs(pInput, pInput[changed.index], changed.index, function (matchingIndexes) {
	                                    // with the matching index(s) get the full string match
	                                    var fullString = getMatchingTextString(pInput, matchingIndexes);
	                                    dropdownFilter('columns', fullString);
	                                    autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
	                                });
	                            }
	                            break;
	                    }
	                    displayDropdown(list);
	                }
	
	                // default variables
	                var text = input.value;
	                var tokens = _.split(text, ' ');
	                // capture inputs
	                var key = event.keyCode;
	
	                // do nothing if shift, alt, or control were pressed on the keyboard
	                if (key === keys.ctrl || key === keys.shift || key === keys.shift || key === keys.alt) {
	                    return;
	                }
	                // NOTHING SET
	                if (text === '') {
	                    //if no text
	                    $scope.hintList = false; // reset the hint list
	                    pInput = false;
	                    $scope.inputChain = convertTokensToChain(pInput);
	                    autocomplete(false);
	                    return; // stop analysis here
	                }
	
	                switch (key) {
	                    case keys.tab:
	                        var cIndex = getCurrentWordIndex(pInput, text, input);
	                        var curr = pInput[cIndex]; // current item in the pInput
	                        // if theres no autocomplete value, set the
	                        if ($scope.autocomplete.value === '' && !curr.completed) {
	                            getMatchingGroupIndexs(pInput, curr, cIndex, function (matchingIndexes) {
	                                // update all matching items in local group to completed
	                                changeGroupStatus(pInput, matchingIndexes, [{ key: 'completed', value: true }], function (newInputArray) {
	                                    // update pInput to the new returned array
	                                    pInput = newInputArray;
	                                });
	                            });
	                        } else {
	                            // check to see if the autocompleted value is a match to any modifiers
	                            var modifierMatch = false;
	                            for (var m = 0, mlen = allModifiers.length; m < mlen; m++) {
	                                if (angular.copy($scope.autocomplete.title) === allModifiers[m].value) {
	                                    // it is a modifier. set current group to the type
	                                    modifierMatch = allModifiers[m]; // replace our match variable with the matched modifier
	                                    break; // stop loop
	                                }
	                            }
	                            if (modifierMatch) {
	                                getMatchingGroupIndexs(pInput, curr, cIndex, function (matchingIndexes) {
	                                    // update all matching items in local group to completed
	                                    changeGroupStatus(pInput, matchingIndexes, [{ key: 'completed', value: false }, { key: 'type', value: modifierMatch.key }], function (newInputArray) {
	                                        pInput = newInputArray; // replace pInput
	                                        // still have to update token list
	                                        // INPUT TEXT
	                                        tokens[matchingIndexes[0]] = modifierMatch.value;
	                                        input.value = _.join(tokens, ' '); // update input text
	                                        // PINPUT SETTING
	                                        pInput[matchingIndexes[0]].value = modifierMatch.value;
	                                        autocomplete(false);
	                                    });
	                                });
	                            } else {
	                                // get the indexes of all indexs in this current grouping
	                                getMatchingGroupIndexs(pInput, curr, cIndex, function (matchingIndexes) {
	                                    var toInjectString = '',
	                                        toInjectArr = [],
	                                        index = matchingIndexes[0]; // set up string to be injected into the input box
	                                    if (curr.type === 'from') {
	                                        toInjectString = 'from: ' + angular.copy($scope.autocomplete.title);
	                                        var a = toInjectString.split(' ');
	                                        for (var v = 0, vlen = a.length; v < vlen; v++) {
	                                            toInjectArr.push({
	                                                completed: true,
	                                                type: 'from',
	                                                value: a[v]
	                                            });
	                                            index++;
	                                        }
	                                    } else {
	                                        toInjectString = angular.copy($scope.autocomplete.title);
	                                        var _a = toInjectString.split(' ');
	                                        for (var _v4 = 0, _vlen = _a.length; _v4 < _vlen; _v4++) {
	                                            toInjectArr.push({
	                                                completed: true,
	                                                type: 'text',
	                                                value: _a[_v4]
	                                            });
	                                            index++;
	                                        }
	                                    }
	                                    // INPUT TEXT
	                                    tokens = removeFromArray(tokens, matchingIndexes[0], matchingIndexes[matchingIndexes.length - 1]); // remove the edited block
	                                    tokens = injectIntoArray(tokens, matchingIndexes[0], toInjectString); // split our new value and inject it
	                                    var t = _.join(tokens, ' ');
	                                    input.value = t;
	                                    // pInput
	                                    var p = removeFromArray(pInput, matchingIndexes[0], matchingIndexes[matchingIndexes.length - 1]);
	                                    pInput = injectIntoArray(p, matchingIndexes[0], toInjectArr); // split our new value and inject it
	
	                                    // clear autocomplete
	                                    deselectSelectedListItems();
	                                    autocomplete(false);
	                                });
	                            }
	                        }
	                        break;
	                    case keys.down:
	                        if (!$scope.hintList) {
	                            return;
	                        } // do nothing if dropdown does not exist
	                        if ($scope.hintList.length === 0) {
	                            return;
	                        } // do nothing if dropdown is empty
	                        modHighlightPosition($scope.hintList, 'down', function (result) {
	                            // set autocomplete to false
	                            autocomplete(false);
	                        });
	                        break;
	                    case keys.up:
	                        if (!$scope.hintList) {
	                            return;
	                        } // do nothing if dropdown does not exist
	                        if ($scope.hintList.length === 0) {
	                            return;
	                        } // do nothing if dropdown is empty
	                        modHighlightPosition($scope.hintList, 'up', function (result) {
	                            // set autocomplete to false
	                            autocomplete(false);
	                        });
	                        break;
	                    case keys.esc:
	                        if (getSelectedListItem()) {
	                            // if there are any selected items.. deselect them
	                            deselectSelectedListItems();
	                        } else {
	                            addClass(hintMenu, 'hidden'); // close menu
	                        }
	                        break;
	                    case keys.enter:
	                        if (!pInput) {
	                            // theres no previous record so lets create one
	                            var item = {
	                                type: 'text',
	                                value: text,
	                                completed: null
	                            };
	                            pInput = [];
	                            pInput.push(item);
	                        }
	                        var selected = getSelectedListItem();
	                        var currentIndex = getCurrentWordIndex(pInput, text, input);
	                        var current = pInput[currentIndex]; // current item in the pInput
	                        if (!current) {
	                            return;
	                        } // if all spaces are entered, current will appear undefined, sos do nothing
	                        // if there is a selected item, replace current grouping with the completed block
	                        if (!selected) {
	                            // if nothing is selected
	                            if (current.completed || current.type === 'text') {
	                                // if item is completed or is text
	                                // do nothing if the pInput does not contain a string item
	                                var containsString = false;
	                                for (var i = 0, len = pInput.length; i < len; i++) {
	                                    if (pInput[i].type !== 'from') {
	                                        // if the item is not from
	                                        var v = _.trim(pInput[i].value);
	                                        if (v !== '') {
	                                            // if the value is not an empty space
	                                            containsString = true; // mark 'containsString' true and stop loop
	                                            break;
	                                        }
	                                    }
	                                }
	                                if (!containsString) {
	                                    return;
	                                } // do nothing if pInput doesnt contain a string
	                                addToFIlterListFromChain(pInput); // send to filter list conversion function to process the chain
	                            } else {
	                                // nothing needs to be replaced or modified except the pInputs of what i'm currenty on
	                                if (current.type === 'text') {
	                                    return;
	                                } // do nothing if the type is just text
	                                getMatchingGroupIndexs(pInput, current, currentIndex, function (matchingIndexes) {
	                                    // update all matching items in local group to completed
	                                    changeGroupStatus(pInput, matchingIndexes, [{ key: 'completed', value: true }], function (newInputArray) {
	                                        // update pInput to the new returned array
	                                        pInput = newInputArray;
	                                        autocomplete(false); // remove autocomplete if something was selected
	                                    });
	                                });
	                            }
	                        } else {
	                            getMatchingGroupIndexs(pInput, current, currentIndex, function (matchingIndexes) {
	                                // we should have a grouping array of items that are to be replaced
	                                // break apart the selected value into an array to inject
	                                var pInputInject = void 0,
	                                    injectString = void 0,
	                                    injectIndex = matchingIndexes[0]; // note the index is the first item in our replaced items
	                                switch (selected.parent.key) {
	                                    case 'columns':
	                                        // columns always have the 'from:' prefix
	                                        pInputInject = [];
	                                        // set and push values to replace
	                                        injectString = 'from: ' + selected.item.value;
	                                        var a = selected.item.value.split(' ');
	                                        pInputInject.push({
	                                            completed: true,
	                                            type: 'from',
	                                            value: 'from:'
	                                        });
	                                        injectIndex++;
	                                        for (var _v5 = 0, vlen = a.length; _v5 < vlen; _v5++) {
	                                            pInputInject.push({
	                                                completed: true,
	                                                type: 'from',
	                                                value: a[_v5]
	                                            });
	                                            injectIndex++;
	                                        }
	                                        break;
	                                    case 'modifiers':
	                                        // modifiers will have varying prefix's
	                                        injectString = selected.item.value;
	                                        pInputInject = {
	                                            completed: false,
	                                            type: selected.item.key,
	                                            value: selected.item.value
	                                        };
	                                        break;
	                                }
	                                // set the placeholders
	                                // INPUT TEXT
	                                tokens = removeFromArray(tokens, matchingIndexes[0], matchingIndexes[matchingIndexes.length - 1]); // remove the edited block
	                                tokens = injectIntoArray(tokens, matchingIndexes[0], injectString); // split our new value and inject it
	                                input.value = _.join(tokens, ' '); // update input text
	                                // PINPUT SETTING
	                                var pi = removeFromArray(pInput, matchingIndexes[0], matchingIndexes[matchingIndexes.length - 1]);
	                                pInput = injectIntoArray(pi, matchingIndexes[0], pInputInject); // split our new value and inject it
	
	                                // set ptokens length to monitor for changes
	                                // clear autocomplete
	                                deselectSelectedListItems();
	                                autocomplete(false);
	                            });
	                        }
	                        break;
	                    // NOTE: THERE IS NO BREAK AFTER THIS CASE ON PURPOSE
	                    case keys.back:
	                        var ci = getCurrentWordIndex(pInput, text, input);
	                        var c = pInput[ci]; // current item in the pInput
	                        getMatchingGroupIndexs(pInput, c, ci, function (matchingIndexes) {
	                            // if current item is complete change its group to incomplete status
	                            if (c.completed) {
	                                changeGroupStatus(pInput, matchingIndexes, [{ key: 'completed', value: false }], function (newInputArray) {
	                                    // update pInput to the new returned array
	                                    pInput = newInputArray;
	                                });
	                            } else if (c.type !== 'text') {
	                                // if the type is not text and incomplete, check the pInput of the first index to make sure
	                                // the modifier is still complete. if not change the group type to text
	                                var match = false;
	                                for (var _m = 0, _mlen = allModifiers.length; _m < _mlen; _m++) {
	                                    if (_.startsWith(pInput[matchingIndexes[0]].value.toLowerCase(), allModifiers[_m].value)) {
	                                        match = true;
	                                        break;
	                                    }
	                                }
	                                // if there is no match.. change the type for all matching pInput items
	                                // also make completed status null
	                                if (!match) {
	                                    changeGroupStatus(pInput, matchingIndexes, [{
	                                        key: 'type',
	                                        value: 'text'
	                                    }, {
	                                        key: 'completed',
	                                        value: null
	                                    }], function (newInputArray) {
	                                        // update pInput to the new returned array
	                                        pInput = newInputArray;
	                                    });
	                                }
	                            }
	                        });
	                    default:
	                        if (!pInput) {
	                            // theres no previous record so lets create one
	                            var _item = {
	                                type: 'text',
	                                value: text,
	                                completed: null
	                            };
	                            pInput = [];
	                            pInput.push(_item);
	                            // show modifier dropdown if + is typed
	                            if (text === '+') {
	                                // now construct list with matching items
	                                sendToList(allModifiers, 'Modifiers', 'modifiers'); // push all modifiers to list
	                                displayDropdown(list);
	                            } else {
	                                dropdownFilter('modifiers', text);
	                                dropdownFilter('columns', text);
	                                displayDropdown(list);
	                            }
	                        } else {
	                            if (tokens.length > pTokens) {
	                                // there has been a new word added into the tokens array
	                                // find its location and inject it into the pTokens
	                                isChanged(pInput, tokens, function (changed) {
	                                    if (changed) {
	                                        // this means that a value was not added at the end
	                                        // we have the index of the new value
	                                        // extract the other settings from the items in front to determine its settings
	                                        var _item2 = {
	                                            type: pInput[changed.index].type,
	                                            value: changed.value,
	                                            completed: pInput[changed.index].completed
	                                            // if there is a value in front of this (and there MAY OR MAY NOT BE)
	                                            // we need to subrtact our new character(s) from the previous and next depending where the space was placed
	                                        };if (typeof pInput[changed.index] !== 'undefined') {
	                                            // this is the spot currently before we push new data in
	                                            if (_.startsWith(pInput[changed.index].value, changed.value)) {
	                                                pInput[changed.index].value = _.trimStart(pInput[changed.index].value, changed.value);
	                                            }
	                                        }
	                                        // if the new item is not at the begining so we need to inherit some new values from the previous record
	                                        var previous = pInput[changed.index - 1];
	                                        if (typeof previous !== 'undefined') {
	                                            if (typeof pInput[previous.index] !== 'undefined') {
	                                                // this is the spot currently before we push new data in
	                                                if (_.endsWith(pInput[previous.index].value, changed.value)) {
	                                                    pInput[previous.index].value = _.trimEnd(pInput[previous.index].value, changed.value);
	                                                }
	                                            }
	                                        }
	                                        // now push the new value in
	                                        pInput = injectIntoArray(pInput, changed.index, _item2);
	                                    } else {
	                                        // value added at the end
	                                        // we have to check the context of the previous to see what to do
	                                        var changedIndex = pInput.length - 1,
	                                            _item3 = void 0;
	                                        if (pInput[changedIndex].completed) {
	                                            _item3 = {
	                                                type: 'text',
	                                                value: tokens[tokens.length - 1],
	                                                completed: false
	                                            };
	                                        } else {
	                                            _item3 = {
	                                                type: pInput[changedIndex].type,
	                                                value: tokens[tokens.length - 1],
	                                                completed: pInput[changedIndex].completed
	                                            };
	                                        }
	                                        // if there is a value in front of this (and there MAY OR MAY NOT BE)
	                                        // we need to subrtact our new character(s) from the previous and next depending where the space was placed
	                                        if (typeof pInput[changedIndex] !== 'undefined') {
	                                            // this is the spot currently before we push new data in
	                                            if (_.endsWith(pInput[changedIndex].value, tokens[tokens.length - 1])) {
	                                                pInput[changedIndex].value = _.trimEnd(pInput[changedIndex].value, tokens[tokens.length - 1]);
	                                            }
	                                        }
	                                        pInput.push(_item3); // simply push the new record in
	                                        autocomplete(false);
	                                        // add autocomplete to the added item
	                                        getMatchingGroupIndexs(pInput, _item3, tokens.length - 1, function (matchingIndexes) {
	                                            // with the matching index(s) get the full string match
	                                            var fullString = getMatchingTextString(pInput, matchingIndexes);
	                                            if (_item3.type === 'from') {
	                                                dropdownFilter('columns', fullString);
	                                            }
	                                            autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
	                                        });
	                                    }
	                                });
	                            } else if (tokens.length < pTokens) {
	                                // item has been removed (probably from backspacing)
	                                // token count is not a match
	                                // find change and remove it
	                                isChanged(pInput, tokens, function (changed) {
	                                    if (changed) {
	                                        // something was removed from within the chain and not the end
	                                        pInput.splice(changed.index, 1);
	                                    } else {
	                                        // something was removed from the end of the chain
	                                        pInput.splice(pInput.length - 1, 1);
	                                    }
	                                });
	                            } else {
	                                // something has been modified - BY ADDING TEXT
	                                // look for item that does not match
	                                isChanged(pInput, tokens, function (changed) {
	                                    if (!changed) {
	                                        return;
	                                    } // do nothing if nothing changed
	                                    // destroy the autocomplete if it exists
	                                    autocomplete(false);
	                                    pInput[changed.index].value = changed.value;
	                                    // TODO !!! - set the all param
	                                    // determine what to set with the settings
	                                    // check to see what modifier (if any has been applied)
	                                    var isModifier = checkIfModifier(changed.value);
	                                    if (isModifier) {
	                                        pInput[changed.index].type = isModifier.key;
	                                        pInput[changed.index].completed = false;
	                                        handleModifierDropdown(changed, isModifier.key, list);
	                                    } else if (_.startsWith(changed.value, '+')) {
	                                        dropdownFilter('+', changed.value);
	                                        displayDropdown(list);
	                                    } else {
	                                        var _current = pInput[changed.index];
	                                        // filter down search here
	                                        if (_current.type === 'text') {
	                                            // get matching indexes of current item
	                                            getMatchingGroupIndexs(pInput, _current, changed.index, function (matchingIndexes) {
	                                                // get full text string from matching indexes
	                                                var fullString = getMatchingTextString(pInput, matchingIndexes);
	                                                dropdownFilter('modifiers', fullString);
	                                                dropdownFilter('columns', fullString);
	                                                autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
	                                            });
	                                        } else if (!_current.completed) {
	                                            // get matching indexes of changed item
	                                            getMatchingGroupIndexs(pInput, _current, changed.index, function (matchingIndexes) {
	                                                // with the matching index(s) get the full string match
	                                                var fullString = getMatchingTextString(pInput, matchingIndexes);
	                                                // now that we have our string. begin to filter down optional modifiers
	                                                if (_current.type === 'from') {
	                                                    dropdownFilter('columns', fullString);
	                                                    autocomplete(fullString, list, tokens); // send it and the current text to the autocomplete function
	                                                }
	                                            });
	                                        }
	                                        displayDropdown(list);
	                                    }
	                                });
	                            }
	                        }
	                        break; // end default block
	                }
	                // set the pTokens count to keep track of what changed
	                pTokens = tokens.length;
	                $scope.inputChain = convertTokensToChain(pInput); // update input chain
	            }
	            // upon input focus check for mode and
	            $scope.inputFocus = function (evt) {
	                addClass(filtersMenu, 'hidden');
	                // remove hidden class on hintMenu
	                removeClass(hintMenu, 'hidden');
	            };
	            // actions to perform on input deselect
	            $scope.inputBlur = function (evt) {
	                // close hintMenu on blur
	                addClass(hintMenu, 'hidden');
	            };
	            // TYPING ACTIONS
	            $scope.inputChange = function (event) {
	                inputRun(event);
	            };
	            // Removes ALL the filters
	            $scope.removeAllFilters = function () {
	                if ($state.current.name === 'pages.main.search') {
	                    resetDefaultSearchInputs();
	                    resetDefaultFilterList();
	                    $scope.$broadcast('runSearch');
	                } else if ($state.current.name === 'pages.main.lateral_map') {
	                    resetDefaultSearchInputs();
	                    resetDefaultFilterList();
	                    // $scope.main.runLatFilters($scope.filterList);
	                } else {
	                    var params = angular.copy($scope.filterList);
	                    for (var i = 0, flen = $scope.filterList["include"].length; i < flen; i++) {
	                        $scope.main.removeFilter(params["include"][i].from, params["include"][i].value, "include", false, params["include"][i].title);
	                    }
	                    for (var e = 0, _flen = $scope.filterList["exclude"].length; e < _flen; e++) {
	                        $scope.main.removeFilter(params["exclude"][e].from, params["exclude"][e].value, "exclude", false, params["exclude"][e].title);
	                    }
	                    $scope.main.runFilters();
	                    resetDefaultSearchInputs();
	                    resetDefaultFilterList();
	                }
	            };
	
	            ///////////////////////////
	            ///// FILTER DROPDOWN /////
	            ///////////////////////////
	            // filter dropdown click
	            $scope.filterDropdownClick = function (evt) {
	                hasClass(filtersMenu, 'hidden', function (exists) {
	                    if (exists) {
	                        removeClass(filtersMenu, 'hidden');
	                    } else {
	                        addClass(filtersMenu, 'hidden');
	                    }
	                });
	            };
	            $scope.searchBtnMouseover = function (evt) {
	                // hide filter dropdown
	                hasClass(filtersMenu, 'hidden', function (exists) {
	                    if (!exists) {
	                        addClass(filtersMenu, 'hidden');
	                    }
	                });
	            };
	            // filter dropdown deselecting
	            document.addEventListener('mouseup', function (event) {
	                // dont close if it has the class 'hint-menu'
	                hasClass(event.target, 'hint-menu', function (exists) {
	                    if (!exists) {
	                        addClass(filtersMenu, 'hidden');
	                    }
	                });
	                // dont close if it has the class 'remove_item'
	                hasClass(event.target, 'remove_item', function (exists) {
	                    if (exists) {
	                        removeClass(filtersMenu, 'hidden');
	                    }
	                });
	            });
	
	            ///////////////////////
	            /// SEARCH FUNCTION ///
	            ///////////////////////
	
	            $scope.runSearch = function () {
	                // if we're on the search page already
	                // if ($state.current.name === 'pages.main.search') {
	                //     // not sure what to do here
	                // } else {
	                // otherwise lets transition to the search page
	                // let params = angular.copy($scope.filterList); // current filter params get sent to the params obj
	                // params.time = null;
	                // if (($location.$$search.hasOwnProperty('start')) && ($location.$$search.hasOwnProperty('end'))) {
	                //     params.time = {
	                //         start: $location.$$search.start,
	                //         end: $location.$$search.end
	                //     }
	                // }
	                // $state.go('pages.main.search', params);
	                // }
	                $scope.$broadcast('runSearch');
	            };
	
	            // made it broadcast so it can be called from main
	            $scope.$on('runSearch', function (event, toState) {
	                var params = angular.copy($scope.filterList); // current filter params get sent to the params obj
	                params.time = null;
	                if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
	                    params.time = {
	                        start: $location.$$search.start,
	                        end: $location.$$search.end
	                    };
	                }
	                $state.go('pages.main.search', params);
	            });
	
	            // set filter name for styling of filter button depending on current page
	            $scope.statename = angular.copy($state.current.name);
	            // cleanup when pages are changed
	            $rootScope.$on('$stateChangeStart', function (event, toState) {
	                $scope.statename = toState.name; // change statename with state change
	                resetDefaultFilterList();
	                resetDefaultSearchInputs();
	            });
	        }
	    };
	}
	
	directive.$inject = ['generateId', '$stateParams', '$rootScope', '$location', 'usSpinnerService', '$state'];
	module.exports = directive;

/***/ },
/* 845 */
/***/ function(module, exports) {

	module.exports = "<div class=\"searchbar\">\n    <div class=\"search-input\">\n        <input id=\"ember317\" ng-blur=\"inputBlur($event)\" ng-focus=\"inputFocus($event)\" ng-keyup=\"inputChange($event)\" maxlength=\"250\" placeholder=\"Search...\" spellcheck=\"false\" autocomplete=\"off\" type=\"text\" class=\"main-input\" />\n        <div class=\"background-container\"><span ng-repeat=\"item in inputChain\"><span ng-class=\"modifierDisplay(item)\">{{item.value}}</span>{{addSpace(item, $index)}}</span><span class=\"hint-value\">{{autocomplete.value}}</div>\n        <div class=\"hint-menu-container hidden\">\n            <span ng-if=\"!hintList\" class=\"arrow\"></span>\n            <span ng-if=\"!hintList\" class=\"arrow-border\"></span>\n            <div ng-if=\"!hintList\" class=\"hint-menu with-help\">\n                <div class=\"help-title\">\n                    Search with Filters\n                </div>\n                <span class=\"help-text\">Narrow your search using filter <span class=\"modifier\">is:</span>, <span class=\"modifier\">not:</span> or <span class=\"modifier\">from:</span>. Or press plus key <span class=\"modifier\">+</span> to get all available filters</span>\n            </div>\n            <div ng-if=\"hintList.length > 0\" class=\"hint-menu with-help\">\n                <div ng-repeat=\"parentItem in hintList\">\n                    <div class=\"section-header\"><hr>\n                        <span class=\"header-label\">{{parentItem.title}}</span>\n                    </div>\n                    <ul class=\"search-input-list\">\n                        <li ng-class=\"(item.selected) ? 'selected' : ''\" ng-if=\"parentItem.key == 'modifiers'\" ng-repeat=\"item in parentItem.value\" class=\"\">\n                            <b>{{item.value}}</b> <span class=\"modifier-value\">{{item.tip}}</span>\n                        </li>\n                        <li ng-class=\"(item.selected) ? 'selected' : ''\" ng-if=\"parentItem.key == 'columns'\" ng-repeat=\"item in parentItem.value\" class=\"\">\n                            <b>from: </b> {{item.value}}\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"filter-controls\">\n        <div ng-click=\"filterDropdownClick($event)\" class=\"count\" class=\"value\" ng-class=\"{ 'green' : (filterListCount > 0)}\">\n            <span ng-if=\"(filterListCount == 0 || filterListCount > 1)\" class=\"value\" ng-class=\"{ 'white' : (filterListCount > 0)}\"> {{filterListCount}} Filters </span>\n            <span ng-if=\"filterListCount == 1\" class=\"value\" ng-class=\"{ 'white' : (filterListCount > 0)}\"> {{filterListCount}} Filter </span>\n            <span><i class=\"fa fa-caret-down\"></i></span>\n        </div>\n        <!-- <div ng-if=\"statename != 'pages.main.search'\" class=\"search\" ng-mouseover=\"searchBtnMouseover($event)\">\n            <div class=\"filter-block\">\n                <span ng-click=\"main.runFilters()\" class=\"filter-text\">Filter Page</span>\n            </div>\n            <div class=\"divider\" ng-hide=\"location.$$url.indexOf('search') !== -1\"></div>\n            <div class=\"search-block\">\n                <span><i class=\"fa fa-search\"></i></span>\n                <span ng-click=\"runSearch()\" class=\"search-text\">Search</span>\n            </div>\n        </div> -->\n        <div ng-if=\"statename != 'pages.main.search'\" class=\"search-static\" ng-click=\"runSearch()\">\n            <span><i class=\"fa fa-search\"></i></span>\n            <span class=\"search-text\"></span>\n        </div>\n    </div>\n    <div class=\"filters-container hidden\">\n        <span ng-if=\"filterListCount > 0\" class=\"arrow\"></span>\n        <span ng-if=\"filterListCount > 0\" class=\"arrow-border\"></span>\n        <div ng-if=\"filterListCount > 0\" class=\"hint-menu\">\n            <!-- INCLUDE -->\n            <div ng-if=\"filterList.include.length > 0\">\n                <div class=\"section-header\">\n                    <hr>\n                    <span class=\"header-label\">Include</span>\n                </div>\n                <ul class=\"search-input-list\">\n                    <li ng-repeat=\"item in filterList.include\" class=\"\">\n                        <i ng-click=\"removeFilter('include', $index)\" class=\"pull-left fa remove_item fa-times\"></i><strong>{{item.value}}</strong> <span ng-if=\"item.from != 'all'\" class=\"modifier-value\">from: {{item.title}}</span>\n                    </li>\n                </ul>\n            </div>\n            <!-- EXCLUDE -->\n            <div ng-if=\"filterList.exclude.length > 0\">\n                <div class=\"section-header\"><hr>\n                    <span class=\"header-label\">Exclude</span>\n                </div>\n                <ul class=\"search-input-list\">\n                    <li ng-repeat=\"item in filterList.exclude\" class=\"\">\n                       <i ng-click=\"removeFilter('exclude', $index)\" class=\"pull-left fa remove_item fa-times\"></i> <strong>{{item.value}}</strong> <span ng-if=\"item.from != 'all'\" class=\"modifier-value\">from: {{item.title}}</span> \n                    </li>\n                </ul>\n            </div>\n            <div>\n                <div class=\"section-header\">\n                    <hr>\n                </div>\n                <div class=\"clear_search\"><i  ng-click=\"removeAllFilters()\" class=\"pull-left fa remove_item fa-times\"></i> Remove All</div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('services', __webpack_require__(847));
	};

/***/ },
/* 847 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function directive($location, $window, fetchStream, generateId, usSpinnerService) {
	    return {
	        link: function link($scope, element, attrs) {
	            $scope.page.w = angular.element($window);
	            var group = void 0,
	                searchCategories = void 0,
	                uid = void 0,
	                key = void 0;
	            var width = element[0].clientWidth - 20;
	            var height = $scope.page.w[0].innerHeight + 50;
	            $scope.$on('init', function (event, chart) {
	                if (chart.id !== attrs.uid) {
	                    return;
	                }
	                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') {
	                    return;
	                } // if its not in our dc object, ignore
	                $scope.main.dataObjects[chart.key].launched = true;
	                uid = chart.id;
	                key = chart.key;
	
	                group = $scope.main.dataObjects[key].group;
	                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
	                var socket = $scope.main.dataObjects[key].settings.get.socket;
	                var tableCalls = $scope.main.dataObjects[key].settings.get.call;
	                var selectedModifiers = document.getElementById("selectedModifiers");
	
	                var outterDiv = d3.select(element[0]).append("div").attr("id", "services");
	                var svg = outterDiv.append("svg");
	                svg.attr("width", width).attr("height", height);
	                svg.on('dblclick', function () {
	                    $scope.$apply(function () {
	                        clearFilters("all");
	                    });
	                });
	                var linksSVG = svg.append("g").attr("class", "links");
	                var serviceSVG = svg.append("g").attr("class", "services");
	                var serverSVG = svg.append("g").attr("class", "servers");
	                var clientSVG = svg.append("g").attr("class", "clients");
	
	                var services = {},
	                    servers = {},
	                    clients = {},
	                    apps = {},
	                    selectedMap = {},
	                    allMap = {};
	                var filtersObj = {
	                    server: {},
	                    service: {}
	                };
	
	                var boxWidth = 200,
	                    boxHeight = 20,
	                    boxSpace = 1.5,
	                    padding_bottom = 45,
	                    circleRadius = 6,
	                    circleStroke = 2,
	                    bounceTime = 1000,
	                    oldY = 0;
	
	                var transitionEffect = "elastic",
	                    highlightColor = "#0da4d3",
	                    iocColor = "#D60A04",
	                    highlightIOCColor = "#410069",
	                    servicesColor = "#000",
	                    appsColor = "#2E7A1C",
	                    linechartKey = "",
	                    linechartID = "";
	                var filter_vector = "";
	                var toggleFlag = true,
	                    lineChartReq = false;
	                var filtersOn = {},
	                    points = [];
	
	                var hideLineChart = d3.select('#hideLineChart');
	
	                var buttonContainer = document.getElementById("buttonContainer");
	                var allButton = document.createElement("div");
	                allButton.className = "vectors current";
	                allButton.innerHTML = "All";
	
	                var inButton = document.createElement("div");
	                inButton.className = "vectors";
	                inButton.innerHTML = "Inbound";
	
	                var latButton = document.createElement("div");
	                latButton.className = "vectors";
	                latButton.innerHTML = "Lateral";
	
	                var outButton = document.createElement("div");
	                outButton.className = "vectors";
	                outButton.innerHTML = "Outbound";
	
	                var vectors = document.getElementsByClassName("vectors");
	                allButton.onclick = function () {
	                    handleVectors("vector", "all");
	                };
	                inButton.onclick = function () {
	                    handleVectors("all", "inbound");
	                };
	                latButton.onclick = function () {
	                    handleVectors("all", "lateral");
	                };
	                outButton.onclick = function () {
	                    handleVectors("all", "outbound");
	                };
	
	                function handleVectors(clear, value) {
	                    clearFilters(clear);
	                    if (value !== "all") {
	                        $scope.$apply(function () {
	                            $scope.main.filterItem("vector", value, "include", "Vector", false);
	                        });
	                    }
	                    for (var i = 0; i < vectors.length; i++) {
	                        vectors[i].className = "vectors";
	                    }
	                    if (value === "inbound") {
	                        inButton.className = "vectors current";
	                    } else if (value === "lateral") {
	                        latButton.className = "vectors current";
	                    } else if (value === "outbound") {
	                        outButton.className = "vectors current";
	                    } else {
	                        allButton.className = "vectors current";
	                    }
	                }
	                buttonContainer.appendChild(allButton);
	                buttonContainer.appendChild(inButton);
	                buttonContainer.appendChild(latButton);
	                buttonContainer.appendChild(outButton);
	
	                var servicesLineChart = d3.select('.servicesLineChart');
	                var lineChartHeight = void 0;
	                if (servicesLineChart[0][0]) {
	                    lineChartHeight = servicesLineChart[0][0].clientHeight;
	                    if ($scope.page.settings.get("hideLineChart")) {
	                        servicesLineChart.classed("hlcHide", true);
	                        hideLineChart[0][0].innerHTML = "+";
	                    } else {
	                        hideLineChart[0][0].innerHTML = "-";
	                    }
	                    hideLineChart.on('click', function () {
	                        if (this.innerHTML === "-") {
	                            this.innerHTML = "+";
	                            servicesLineChart.classed("hlcHide", true);
	                            $scope.page.settings.set('hideLineChart', true);
	                        } else if (this.innerHTML === "+") {
	                            this.innerHTML = "-";
	                            servicesLineChart.classed("hlcHide", false);
	                            $scope.page.settings.set('hideLineChart', false);
	                        }
	                    });
	                }
	
	                var diagonal = d3.svg.diagonal().source(function (d) {
	                    if (d.type === "server") {
	                        return {
	                            "x": d.source.y + boxHeight / 2,
	                            "y": d.source.xr
	                        };
	                    }
	                    return {
	                        "x": d.source.y + boxHeight / 2,
	                        "y": d.source.x + boxHeight / 2
	                    };
	                }).target(function (d) {
	                    if (d.type === "server") {
	                        return {
	                            "x": d.target.y + (circleRadius + circleStroke),
	                            "y": d.target.xr + (circleRadius + circleStroke)
	                        };
	                    }
	                    return {
	                        "x": d.target.y + (circleRadius + circleStroke),
	                        "y": d.target.x + (circleRadius + circleStroke)
	                    };
	                }).projection(function (d) {
	                    return [d.y, d.x];
	                });
	
	                // ---------- Small General Functions ----------
	                function setHeight() {
	                    svg.attr("height", height + 30);
	                }
	                var sort_by = function sort_by(field, reverse, primer) {
	                    var key = primer ? function (x) {
	                        return primer(x[field]);
	                    } : function (x) {
	                        return x[field];
	                    };
	                    reverse = !reverse ? 1 : -1;
	                    return function (a, b) {
	                        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
	                    };
	                };
	                function getName(X) {
	                    return X.name;
	                }
	                function serverContains(arr, val) {
	                    for (var a in arr) {
	                        if (arr[a].name === val.name) {
	                            return true;
	                        }
	                    }
	                    return false;
	                }
	                function checkSelect(X, item, Z) {
	                    return selectedMap[X.name] ? Z : item;
	                }
	
	                // ---------- Functions to populate chart ----------
	                function setServices() {
	                    var servGroup = $scope.main.dataObjects[key].group.all();
	                    for (var g in servGroup) {
	                        if (servGroup[g].key === servGroup[g].value.name) {
	                            if (!services[servGroup[g].value.name]) {
	                                services[servGroup[g].value.name] = servGroup[g].value;
	                            }
	                            services[servGroup[g].value.name].visible = true;
	                        } else {
	                            delete services[servGroup[g].key];
	                        }
	                    }
	                }
	                function makeServicesArray() {
	                    var servArray = [];
	                    for (var s in services) {
	                        if (services[s].tot_count > 0 || services[s].tot_total_bytes > 0) {
	                            servArray.push(services[s]);
	                        }
	                    }
	                    servArray.sort(sort_by("service", false, String));
	                    return servArray;
	                }
	                function servicesLength() {
	                    var count = 0;
	                    for (var s in services) {
	                        if (services[s].visible && (services[s].tot_count > 0 || services[s].tot_total_bytes > 0)) {
	                            count++;
	                        }
	                    }
	                    return count;
	                }
	                function setServers() {
	                    servers = {};
	                    for (var s in services) {
	                        for (var e in services[s].servers) {
	                            if (!servers[services[s].servers[e].name]) {
	                                servers[services[s].servers[e].name] = services[s].servers[e];
	                            }
	                        }
	                    }
	                }
	                function makeServersArray() {
	                    var serverArray = [];
	                    for (var e in servers) {
	                        serverArray.push(servers[e]);
	                    }
	                    serverArray.sort(sort_by("name", true, String));
	                    return serverArray;
	                }
	                function getClients() {
	                    var alreadyFiltered = $scope.main.dataObjects[key].filters.include;
	                    var proto = false,
	                        service = false,
	                        server = false;
	                    for (var af in alreadyFiltered) {
	                        if (alreadyFiltered[af].resp_ip || alreadyFiltered[af].resp_country) {
	                            server = true;
	                        } else if (alreadyFiltered[af].proto) {
	                            proto = true;
	                        } else if (alreadyFiltered[af].service) {
	                            service = true;
	                        }
	                    }
	                    if (!proto || !service || !server) {
	                        return;
	                    }
	                    var table = [];
	                    filtersObj = {};
	
	                    var serversArr = makeServersArray();
	
	                    if (serversArr[0].type === "internal") {
	                        table.push("orig_int_int");
	                        table.push("orig_int_ext");
	                        filtersObj.resp_ip = serversArr[0].ip;
	                        filtersObj.resp_hostname = serversArr[0].hostname;
	                        $scope.main.dataObjects[key].settings.complete = $scope.main.dataObjects[key].settings.complete - 2;
	                    } else if (serversArr[0].type === "external") {
	                        table.push("orig_ext_int");
	                        filtersObj.resp_country = serversArr[0].name_toggle;
	                        $scope.main.dataObjects[key].settings.complete--;
	                    }
	
	                    var servicesArr = makeServicesArray();
	                    filtersObj.service = servicesArr[0].service;
	                    filtersObj.proto = servicesArr[0].proto;
	
	                    $scope.page.complete = false;
	                    usSpinnerService.spin("spinner-" + uid);
	                    for (var t in table) {
	                        new fetchStream(table[t], socket, filtersObj).then(function (result) {
	                            $scope.main.dataObjects[key].settings.complete++;
	                            if ($scope.main.dataObjects[key].settings.complete >= tableCalls.length) {
	                                $scope.page.complete = true;
	                                usSpinnerService.stop("spinner-" + uid);
	                            }
	                        }, function (err) {}, function (result) {
	                            $scope.main.dataObjects[key].cf.add(result.rows);
	                            setClients();
	                            drawClients();
	                            setApplications();
	                            drawApplications();
	                            setHeight();
	                            setLinks();
	                            drawLinks();
	                        });
	                    }
	                    if (!lineChartReq) {
	                        requeryLineChart(filtersObj);
	                    }
	                }
	                function setClients() {
	                    clients = {};
	                    for (var s in services) {
	                        for (var c in services[s].clients) {
	                            if (!clients[services[s].clients[c].name]) {
	                                clients[services[s].clients[c].name] = services[s].clients[c];
	                            }
	                        }
	                    }
	                }
	                function makeClientsArray() {
	                    var clientArray = [];
	                    for (var c in clients) {
	                        clientArray.push(clients[c]);
	                    }
	                    clientArray.sort(sort_by("name", true, String));
	                    return clientArray;
	                }
	                function setApplications() {
	                    apps = {};
	                    for (var s in services) {
	                        for (var e in services[s].l7_apps) {
	                            if (!apps[services[s].l7_apps[e].name]) {
	                                apps[services[s].l7_apps[e].name] = services[s].l7_apps[e];
	                            }
	                        }
	                    }
	                }
	                function makeApplicationArray() {
	                    var appArray = [];
	                    for (var a in apps) {
	                        appArray.push(apps[a]);
	                    }
	                    appArray.sort(sort_by("name", false, String));
	                    return appArray;
	                }
	                function setLinks() {
	                    points = [];
	                    var val = false;
	                    if (Object.keys(apps).length > 0) {
	                        for (var a in apps) {
	                            if (allMap[apps[a].name + "application"]) {
	                                for (var i in apps[a].servers) {
	                                    if (allMap[apps[a].servers[i].name + "server"]) {
	                                        val = false;
	                                        if (apps[a].servers[i].ioc_count > 0 && apps[a].ioc_count > 0) {
	                                            val = true;
	                                        }
	                                        points.push({
	                                            name: apps[a].name + "-to-" + apps[a].servers[i].name,
	                                            type: "server",
	                                            source: allMap[apps[a].name + "application"],
	                                            target: allMap[apps[a].servers[i].name + "server"],
	                                            ioc: val
	                                        });
	                                    }
	                                }
	                                for (var c in apps[a].clients) {
	                                    if (allMap[apps[a].clients[c].name + "client"]) {
	                                        val = false;
	                                        if (apps[a].clients[c].ioc_count > 0 && apps[a].ioc_count > 0) {
	                                            val = true;
	                                        }
	                                        points.push({
	                                            name: apps[a].clients[c].name + "-to-" + apps[a].name,
	                                            type: "client",
	                                            source: allMap[apps[a].name + "application"],
	                                            target: allMap[apps[a].clients[c].name + "client"],
	                                            ioc: val
	                                        });
	                                    }
	                                }
	                            }
	                        }
	                    } else {
	                        for (var s in services) {
	                            if (allMap[services[s].name + "service"]) {
	                                for (var _i in services[s].servers) {
	                                    if (allMap[services[s].servers[_i].name + "server"]) {
	                                        val = false;
	                                        if (services[s].servers[_i].ioc_count > 0 && services[s].ioc_count > 0) {
	                                            val = true;
	                                        }
	                                        points.push({
	                                            name: services[s].name + "-to-" + services[s].servers[_i].name,
	                                            type: "server",
	                                            source: allMap[services[s].name + "service"],
	                                            target: allMap[services[s].servers[_i].name + "server"],
	                                            ioc: val
	                                        });
	                                    }
	                                }
	                                for (var _c in services[s].clients) {
	                                    if (allMap[services[s].clients[_c].name + "client"]) {
	                                        val = false;
	                                        if (services[s].clients[_c].ioc_count > 0 && services[s].ioc_count > 0) {
	                                            val = true;
	                                        }
	                                        points.push({
	                                            name: services[s].clients[_c].name + "-to-" + services[s].name,
	                                            type: "client",
	                                            source: allMap[services[s].name + "service"],
	                                            target: allMap[services[s].clients[_c].name + "client"],
	                                            ioc: val
	                                        });
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	
	                // ---------- Utility Functions ----------
	                function clearClients() {
	                    $scope.main.dataObjects[key].searchDimension.filterAll();
	                    $scope.main.dataObjects[key].searchDimension.filter(function (d) {
	                        return d.resp_ip && d.orig_ip || d.resp_country && d.orig_ip || d.resp_ip && d.orig_country;
	                    });
	                    $scope.main.dataObjects[key].cf.remove();
	                    $scope.main.dataObjects[key].searchDimension.filterAll();
	                    $scope.main.runFilters();
	                    clients = {};
	                }
	                function clearApps() {
	                    apps = {};
	                }
	                function addToFilterList(action, value, column, columnTitle) {
	                    // clear the pInput
	                    $scope.$apply(function () {
	                        $scope.main.addFilter(column, value, action, true, columnTitle);
	                    });
	                }
	                function clickEvent(node, index) {
	                    if ($scope.page.complete) {
	                        (function () {
	                            var title = [],
	                                filter = [],
	                                value = [],
	                                id = [];
	                            var alreadyFiltered = $scope.main.dataObjects[key].filters.include;
	                            var matching = alreadyFiltered.filter(function (f) {
	                                return f.orig_ip || f.orig_country;
	                            });
	                            if (matching.length > 0) {
	                                for (var m in matching) {
	                                    if (matching[m].orig_ip) {
	                                        $scope.main.removeFilter("orig_ip", matching[m].orig_ip, "include", true, searchCategories.orig_ip + ': ');
	                                    } else {
	                                        $scope.main.removeFilter("orig_country", matching[m].orig_country, "include", true, searchCategories.orig_country + ': ');
	                                    }
	                                }
	                            }
	                            if (node.type.indexOf("orig") !== -1) {
	                                var childNode = false;
	                                switch (node.type) {
	                                    case "orig_internal":
	                                        // id.push(generateId())
	                                        title.push(searchCategories.orig_ip + ': ');
	                                        value.push(node.ip);
	                                        filter.push("orig_ip");
	                                        break;
	                                    case "orig_external":
	                                        // id.push(generateId())
	                                        title.push(searchCategories.orig_country + ': ');
	                                        value.push(node.name_toggle);
	                                        filter.push("orig_country");
	                                        break;
	                                }
	                                for (var f in filter) {
	                                    addToFilterList("include", value[f], filter[f], title[f]);
	                                }
	                            } else {
	                                var proto = false,
	                                    service = false;
	                                switch (node.type) {
	                                    case "internal":
	                                        clearClients();
	                                        title.push(searchCategories.resp_ip);
	                                        value.push(node.ip);
	                                        filter.push("resp_ip");
	                                        break;
	                                    case "external":
	                                        clearClients();
	                                        title.push(searchCategories.resp_country);
	                                        value.push(node.name_toggle);
	                                        filter.push("resp_country");
	                                        break;
	                                    case "application":
	                                        title.push(searchCategories.l7_app);
	                                        value.push(node.name);
	                                        filter.push("l7_app");
	                                        break;
	                                    default:
	                                        clearClients();
	                                        for (var af in alreadyFiltered) {
	                                            if (alreadyFiltered[af].proto) {
	                                                proto = true;
	                                            } else if (alreadyFiltered[af].service) {
	                                                service = true;
	                                            }
	                                        }
	                                        if (proto && !service) {
	                                            title.push(searchCategories.service);
	                                            value.push(node.service);
	                                            filter.push("service");
	                                            node.show_applications = true;
	                                        } else if (!proto && service) {
	                                            title.push(searchCategories.proto);
	                                            value.push(node.proto);
	                                            filter.push("proto");
	                                            node.show_applications = true;
	                                        } else {
	                                            if (node.show_applications) {
	                                                node.show_applications = false;
	                                            } else {
	                                                node.show_applications = true;
	                                            }
	                                            title.push(searchCategories.service);
	                                            value.push(node.service);
	                                            filter.push("service");
	                                            title.push(searchCategories.proto);
	                                            value.push(node.proto);
	                                            filter.push("proto");
	                                        }
	                                        if (filtersOn.l7_app) {
	                                            clearFilters("l7_app", filtersOn);
	                                        }
	                                        break;
	                                }
	                                for (var v in value) {
	                                    if (filtersOn[filter[v]]) {
	                                        if (filtersOn[filter[v]] === value[v]) {
	                                            delete filtersOn[filter[v]];
	                                        } else {
	                                            filtersOn[filter[v]] = value[v];
	                                        }
	                                    } else {
	                                        filtersOn[filter[v]] = value[v];
	                                    }
	                                }
	
	                                if (alreadyFiltered.length > 0) {
	                                    var _loop = function _loop(_f) {
	                                        var _loop2 = function _loop2(_af) {
	                                            if (alreadyFiltered[_af][filter[_f]]) {
	                                                if (alreadyFiltered[_af][filter[_f]] !== value[_f].toLowerCase()) {
	                                                    $scope.$apply(function () {
	                                                        $scope.main.filterItem(filter[_f], alreadyFiltered[_af][filter[_f]], "include", title[_f]);
	                                                    });
	                                                }
	                                            }
	                                        };
	
	                                        for (var _af in alreadyFiltered) {
	                                            _loop2(_af);
	                                        }
	                                    };
	
	                                    for (var _f in filter) {
	                                        _loop(_f);
	                                    }
	                                }
	
	                                var _loop3 = function _loop3(_f2) {
	                                    $scope.$apply(function () {
	                                        $scope.main.filterItem(filter[_f2], value[_f2], "include", title[_f2], false);
	                                    });
	                                };
	
	                                for (var _f2 in filter) {
	                                    _loop3(_f2);
	                                }
	                                if ((filtersOn.resp_ip || filtersOn.resp_country) && filtersOn.service && filtersOn.proto && makeClientsArray().length === 0) {
	                                    getClients();
	                                }
	                            }
	                        })();
	                    }
	                }
	                function clearFilters(filter, values) {
	                    var alreadyFiltered = $scope.main.dataObjects[key].filters.include;
	                    var clearOn = [];
	                    if (filter === "all") {
	                        clearClients();
	                        // for (let sm in selectedModifiers.childNodes) {
	                        //     if (!isNaN(Number(sm))) {
	                        //         if ((selectedModifiers.childNodes[sm].getAttribute('modifierselect') === "orig_ip") || (selectedModifiers.childNodes[sm].getAttribute('modifierselect') === "orig_country")) {
	                        //             window.searchItemCloseClick(selectedModifiers.childNodes[sm].getAttribute('id'))
	                        //             break;
	                        //         }
	                        //     }
	                        // }
	                        for (var a in alreadyFiltered) {
	                            for (var f in alreadyFiltered[a]) {
	                                clearOn.push({ value: alreadyFiltered[a][f], filter: f, title: searchCategories[f] });
	                                delete filtersOn[f];
	                            }
	                        }
	                        for (var c in clearOn) {
	                            $scope.main.filterItem(clearOn[c].filter, clearOn[c].value, "include", clearOn[c].title);
	                        }
	                    } else {
	                        for (var _a in alreadyFiltered) {
	                            if (alreadyFiltered[_a][filter]) {
	                                $scope.main.filterItem(filter, alreadyFiltered[_a][filter], "include", searchCategories[filter]);
	                                delete filtersOn[filter];
	                                break;
	                            }
	                        }
	                    }
	                }
	                function insertModifier(title, filter, value, id, action, complete, searchState) {
	                    if (typeof complete === 'undefined') {
	                        complete = false;
	                    }
	                    if (!searchState) {
	                        searchState = "false";
	                    }
	                    var display = document.createElement("div");
	                    display.className = 'searchSelected';
	                    display.setAttribute('id', id);
	                    display.setAttribute('action', action);
	                    display.setAttribute('modifierselect', filter);
	                    display.setAttribute('searchState', searchState);
	                    display.setAttribute('value', value);
	                    display.innerHTML = "<i onclick='searchItemCloseClick(\"" + id + "\")' class='fa fa-times closeSearchObj'></i> " + title + value;
	                    selectedModifiers.appendChild(display);
	                }
	                function selectHighlights(cur) {
	                    selectedMap = {};
	                    points.forEach(function (Y) {
	                        if (Y.source.name === cur.name || Y.target.name === cur.name) {
	                            if (typeof selectedMap[Y.name] === "undefined") {
	                                selectedMap[Y.name] = true;
	                            }
	                            if (typeof selectedMap[Y.source.name] === "undefined") {
	                                selectedMap[Y.source.name] = true;
	                            }
	                            if (typeof selectedMap[Y.target.name] === "undefined") {
	                                selectedMap[Y.target.name] = true;
	                            }
	                        }
	                    });
	                    highlight();
	                }
	                function highlight() {
	                    serviceSVG.selectAll("rect").attr("fill", function (X) {
	                        if (X.type === "application") {
	                            return checkSelect(X, appsColor, highlightColor);
	                        }
	                        return checkSelect(X, servicesColor, highlightColor);
	                    });
	
	                    serverSVG.selectAll("circle").attr("fill", function (X) {
	                        return checkSelect(X, "#fff", highlightColor);
	                    }).selectAll("text").attr("fill", function (X) {
	                        return checkSelect(X, "#000", highlightColor);
	                    });
	
	                    clientSVG.selectAll("circle").attr("fill", function (X) {
	                        return checkSelect(X, "#fff", highlightColor);
	                    }).selectAll("text").attr("fill", function (X) {
	                        return checkSelect(X, "#000", highlightColor);
	                    });
	
	                    linksSVG.selectAll("path").attr("stroke", function (X) {
	                        if (X.ioc) {
	                            return checkSelect(X, iocColor, highlightIOCColor);
	                        }
	                        return checkSelect(X, "#aaa", highlightColor);
	                    }).attr("stroke-width", function (X) {
	                        return checkSelect(X, "1.5px", "2.5px");
	                    }).attr("opacity", function (X) {
	                        return checkSelect(X, 0.4, 0.75);
	                    });
	                }
	                function doHover(elm, data) {
	                    var e = d3.select(elm);
	                    e.attr("fill", "#049CCC");
	                    data.hover = true;
	                }
	                function requeryLineChart(filtersObj) {
	                    if (linechartKey === "" || linechartID === "") {
	                        linechartKey = $scope.page.lineChartIdentifiers.key;
	                        linechartID = $scope.page.lineChartIdentifiers.id;
	                    }
	                    var crossLineChart = {};
	                    if (filtersObj.resp_country) {
	                        crossLineChart.resp_country = filtersObj.resp_country;
	                        crossLineChart.proto = filtersObj.proto;
	                        crossLineChart.service = filtersObj.service;
	                        lineChartReq = true;
	                    } else if (filtersObj.resp_hostname && filtersObj.resp_ip) {
	                        crossLineChart.resp_hostname = filtersObj.resp_hostname;
	                        crossLineChart.resp_ip = filtersObj.resp_ip;
	                        crossLineChart.proto = filtersObj.proto;
	                        crossLineChart.service = filtersObj.service;
	                        lineChartReq = true;
	                    } else {
	                        lineChartReq = false;
	                    }
	                    $scope.page.complete = false;
	
	                    $scope.main.dataObjects[linechartKey].searchDimension.filterAll(); // clear the search dimension
	                    $scope.main.dataObjects[linechartKey].searchDimension.filter(function (d, i) {
	                        return true;
	                    }); // refilter down to what needs to be removed
	                    $scope.main.dataObjects[linechartKey].cf.remove(); // delete the data that has been filtered
	                    $scope.main.dataObjects[linechartKey].searchDimension.filterAll(); // clear the filter again
	
	
	                    usSpinnerService.spin("spinner-" + linechartID);
	                    $scope.page.complete = false;
	                    new fetchStream("linechart", socket, crossLineChart).then(function (result) {
	                        $scope.page.complete = true;
	                        usSpinnerService.stop("spinner-" + linechartID);
	                    }, function (err) {}, function (result) {
	                        $scope.main.dataObjects[linechartKey].cf.add(result.rows);
	                        $scope.$broadcast('updatedData', linechartID, true);
	                    });
	                }
	                function checkFilter(node) {
	                    return node.visible;
	                }
	
	                // ---------- Drawing Functions ----------
	                function drawServices() {
	                    var services = makeServicesArray();
	                    oldY = 0;
	                    serviceSVG.selectAll('.service').remove();
	                    var servi = serviceSVG.selectAll(".service").data(services.filter(function (d) {
	                        return checkFilter(d);
	                    }));
	                    var serviceRect = servi.enter().append("g").attr("class", function (d) {
	                        return "service service-" + d.name;
	                    });
	                    serviceRect.each(function (d, i) {
	                        var elm = d3.select(this);
	                        oldY = 0;
	                        if (d.y) {
	                            oldY = d.y;
	                        }
	                        d.x = width / 2 - boxWidth / 2;
	                        d.xr = width / 2 + boxWidth / 2;
	                        d.y = boxHeight * i;
	                        // if (d.type === "application") {
	                        //     allMap[d.name+"application"] = d;
	                        // } else if (d.type === "alphabet") {
	                        //     allMap[d.name+"alphabet"] = d;
	                        // } else {
	                        allMap[d.name + "service"] = d;
	                        // }
	                        if (height < d.y + padding_bottom) {
	                            height = d.y + padding_bottom;
	                        }
	                        // elm.attr("transform", "translate("+d.x+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.x+","+d.y+")")
	                        elm.attr("transform", "translate(" + d.x + "," + d.y + ")");
	                        elm.attr("width", boxWidth + 20).attr("height", boxHeight).on('mouseover', function () {
	                            selectHighlights(d);
	                        }).on('click', function () {
	                            clickEvent(d, i);
	                        }).on('dblclick', function () {
	                            d3.event.stopPropagation();
	                        });
	                        elm.append("rect").attr("x", 0).attr("y", 0).attr("stroke", "#fff").attr("stroke-width", boxSpace + "px").attr("fill", servicesColor).attr("width", boxWidth).attr("height", boxHeight);
	
	                        if ((filtersOn.resp_ip || filtersOn.resp_country) && !filtersOn.service && !filtersOn.proto) {
	                            elm.append("text").text("+").attr("x", boxWidth + 5).attr("y", boxHeight / 1.5).attr("font-size", "1.3em").attr("text-anchor", "middle").attr("fill", "#000");
	                        }
	                    });
	                    servi.append("text").text(function (d) {
	                        return String(d.name).replace("N/A", "-");
	                    }).attr("x", boxWidth / 2).attr("y", boxHeight / 1.6).attr("font-size", "1.1em").attr("text-anchor", "middle").attr("fill", "#fff");
	                    servi.append;
	                    servi.exit();
	                }
	                function drawServers() {
	                    var servers = makeServersArray();
	                    var oldY = 0;
	                    serverSVG.selectAll('.server').remove();
	                    var serv = serverSVG.selectAll(".server").data(servers.filter(function (d) {
	                        return checkFilter(d);
	                    }));
	                    var serverCircle = serv.enter().append("g").attr("class", function (d) {
	                        return "server server-" + d.name;
	                    });
	                    serverCircle.each(function (d, i) {
	
	                        var elm = d3.select(this);
	                        oldY = 0;
	                        if (height < d.y + padding_bottom) {
	                            height = d.y + padding_bottom;
	                        }
	                        d.xr = width / 1.3333;
	                        d.y = (circleRadius + circleStroke) * 3 * i;
	                        if (height < d.y) {
	                            height = d.y;
	                        }
	                        allMap[d.name + "server"] = d;
	                        // elm.attr("transform", "translate("+d.xr+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.xr+","+d.y+")")
	                        elm.attr("transform", "translate(" + d.xr + "," + d.y + ")");
	                        elm.attr("width", boxWidth).attr("height", (circleRadius + circleStroke) * 2).on('mouseover', function () {
	                            selectHighlights(d);
	                        }).on('click', function () {
	                            clickEvent(d);
	                        }).on('dblclick', function () {
	                            d3.event.stopPropagation();
	                        });
	                        elm.append("circle").attr("cx", circleRadius + circleStroke).attr("cy", circleRadius + circleStroke).attr("r", circleRadius).attr("stroke", "#000").attr("stroke-width", 2).attr("fill", function (d) {
	                            return "#fff";
	                        });
	
	                        if (!filtersOn.resp_ip && !filtersOn.resp_country && filtersOn.service && filtersOn.proto) {
	                            elm.append("text").text("+").attr("x", -(circleRadius + circleStroke)).attr("y", boxHeight / 1.5).attr("font-size", "1.3em").attr("text-anchor", "middle").attr("fill", "#000");
	                        }
	                    });
	                    serv.append("text").text(function (d) {
	                        if (d.type === "external") {
	                            return d.name_toggle.replace("N/A", "");
	                        }
	                        return d.name.replace("(N/A)", "");
	                    }).attr("x", function (d) {
	                        if (d.type === "external") {
	                            return 38 + (circleRadius + circleStroke);
	                        }
	                        return (circleRadius + circleStroke) * 2.1;
	                    }).attr("y", (circleRadius + circleStroke) * 1.5).attr("font-size", "1.1em").attr("text-anchor", "start").attr("fill", function (d) {
	                        return "#000";
	                    });
	
	                    serv.append("g:foreignObject").attr('height', "28px").attr('width', "32px").attr('class', "serviceFlags").attr("transform", "translate(17,-" + circleRadius + ")scale(0.75)").append("xhtml:g").classed("f32", true).append("g").attr("class", function (d) {
	                        if (d.type === "external") {
	                            if (d.name === "n/a") {
	                                return "flag iana";
	                            }
	                            return toggleFlag ? "flag " + d.name : "";
	                        }
	                        return "flag " + d.name;
	                    });
	                    serv.exit();
	                }
	                function drawClients() {
	                    var oldY = 0;
	                    var clients = makeClientsArray();
	                    clientSVG.selectAll('.client').remove();
	                    var cli = clientSVG.selectAll(".client").data(clients.filter(function (d) {
	                        return checkFilter(d);
	                    }));
	                    var clientCircle = cli.enter().append("g").attr("class", function (d) {
	                        return "client client-" + d.name;
	                    });
	                    clientCircle.each(function (d, i) {
	                        var elm = d3.select(this);
	                        oldY = 0;
	                        if (d.y) {
	                            oldY = d.y;
	                        }
	                        d.x = width / 4;
	                        d.y = (circleRadius + circleStroke) * 3 * i;
	                        allMap[d.name + "client"] = d;
	                        if (height < d.y + padding_bottom) {
	                            height = d.y + padding_bottom;
	                        }
	                        // elm.attr("transform", "translate("+d.x+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.x+","+d.y+")")
	                        elm.attr("transform", "translate(" + d.x + "," + d.y + ")");
	                        elm.attr("width", boxWidth + 20).attr("height", (circleRadius + circleStroke) * 2).on('mouseover', function () {
	                            selectHighlights(d);
	                        }).on('click', function () {
	                            clickEvent(d);
	                        }).on('dblclick', function () {
	                            d3.event.stopPropagation();
	                        });
	                        elm.append("circle").attr("cx", circleRadius + circleStroke).attr("cy", circleRadius + circleStroke).attr("r", circleRadius).attr("stroke", "#000").attr("stroke-width", 2).attr("fill", function (d) {
	                            return "#fff";
	                        });
	                    });
	                    cli.append("text").text(function (d) {
	                        if (d.type === "orig_external") {
	                            return d.name_toggle.replace("N/A", "");
	                        }
	                        return d.name.replace("(N/A)", "");
	                    }).attr("x", function (d) {
	                        if (d.type === "orig_external") {
	                            return -(28 + (circleRadius + circleStroke));
	                        }
	                        return -((circleRadius + circleStroke) / 2);
	                    }).attr("y", (circleRadius + circleStroke) * 1.5).attr("font-size", "1.1em").attr("text-anchor", "end").attr("fill", function (d) {
	                        return "#000";
	                    });
	                    cli.append("g:foreignObject").attr('height', "28px").attr('width', "32px").attr('class', "serviceFlags").attr("transform", "translate(-28,-" + circleRadius + ")scale(0.75)").append("xhtml:g").classed("f32", true).append("g").attr("class", function (d) {
	                        if (d.type === "orig_external") {
	                            if (d.name === "n/a") {
	                                return "flag iana";
	                            }
	                            return toggleFlag ? "flag " + d.name : "";
	                        }
	                        return "flag " + d.name;
	                    });
	                    cli.exit();
	                }
	                function drawApplications() {
	                    var apps = makeApplicationArray();
	                    serviceSVG.selectAll('.app').remove();
	                    var servi = serviceSVG.selectAll(".app").data(apps.filter(function (d) {
	                        return checkFilter(d);
	                    }));
	                    var serviceRect = servi.enter().append("g").attr("class", function (d) {
	                        return "app app-" + d.name;
	                    });
	                    serviceRect.each(function (d, i) {
	                        var elm = d3.select(this);
	                        // oldY = 0;
	                        if (d.y) {
	                            oldY = d.y;
	                        }
	                        d.x = width / 2 - boxWidth / 2;
	                        d.xr = width / 2 + boxWidth / 2;
	                        d.y = boxHeight * (i + 1);
	
	                        allMap[d.name + "application"] = d;
	
	                        if (height < d.y + padding_bottom) {
	                            height = d.y + padding_bottom;
	                        }
	                        // elm.attr("transform", "translate("+d.x+","+oldY+")").transition().duration(bounceTime).ease(transitionEffect).attr("transform", "translate("+d.x+","+d.y+")")
	                        elm.attr("transform", "translate(" + d.x + "," + d.y + ")");
	                        elm.attr("width", boxWidth).attr("height", boxHeight).on('mouseover', function () {
	                            selectHighlights(d);
	                        }).on('click', function () {
	                            clickEvent(d, i);
	                        }).on('dblclick', function () {
	                            d3.event.stopPropagation();
	                        });
	                        elm.append("rect").attr("x", 0).attr("y", 0).attr("stroke", "#fff").attr("stroke-width", boxSpace + "px").attr("fill", appsColor).attr("width", boxWidth).attr("height", boxHeight);
	                    });
	                    servi.append("text").text(function (d) {
	                        return String(d.name).replace("N/A", "-");
	                    }).attr("x", boxWidth / 2).attr("y", boxHeight / 1.6).attr("font-size", "1.1em").attr("text-anchor", "middle").attr("fill", "#fff");
	                    servi.exit();
	                }
	                function drawLinks() {
	                    linksSVG.selectAll("path").remove();
	                    var X = linksSVG.selectAll("path").data(points, getName);
	                    X.enter().append("path").attr("d", function (Z) {
	                        var S = Z.source ? {
	                            x: Z.source.xr,
	                            y: Z.source.y
	                        } : {
	                            x: 0,
	                            y: 0
	                        };
	                        return diagonal({
	                            source: S,
	                            target: S
	                        });
	                    }).attr("class", "link").attr("fill", "none").attr("stroke", function (d) {
	                        if (d.ioc) {
	                            return iocColor;
	                        }
	                        return "#aaa";
	                    }).attr("stroke-width", "1.5px").attr("opacity", 0.4);
	                    X.exit().remove();
	                    linksSVG.selectAll("path").attr("d", diagonal);
	                }
	
	                // ---------- Redraw Function ----------
	                function redraw() {
	                    if (servicesLength() > 1) {
	                        clearApps();
	                    } else {
	                        setApplications();
	                    }
	                    if ((filtersOn.resp_ip || filtersOn.resp_country) && filtersOn.service && filtersOn.proto) {
	                        setClients();
	                    } else {
	                        if (lineChartReq) {
	                            requeryLineChart({});
	                        }
	                    }
	                    allMap = {};
	                    drawServices();
	                    drawApplications();
	                    drawServers();
	                    drawClients();
	                    setHeight();
	                    setLinks();
	                    drawLinks();
	                }
	
	                setServices();
	                setServers();
	                redraw();
	
	                // set update functions
	                $scope.$on('updatedData', function (event, id, initialLoad) {
	                    if ($scope.main.dataObjects[key].group) {
	                        if (id !== uid) {
	                            return;
	                        }
	                        if ((typeof initialLoad === 'undefined' ? 'undefined' : _typeof(initialLoad)) === "object") {
	                            if ($scope.main.dataObjects[key].settings.complete >= tableCalls.length) {
	                                usSpinnerService.stop("spinner-" + uid);
	                                $scope.page.complete = true;
	                            }
	                        } else {
	                            if (typeof initialLoad === "undefined") {
	                                $scope.main.dataObjects[key].dimension.dispose();
	                                $scope.main.dataObjects[key].dimension = $scope.main.dataObjects[key].settings.dimension($scope.main.dataObjects[key].cf);
	                                $scope.main.dataObjects[key].group = $scope.main.dataObjects[key].settings.group($scope.main.dataObjects[key].dimension);
	                            }
	                        }
	                        services = {};
	                        setServices();
	                        setServers();
	                        redraw();
	                    }
	                });
	
	                window.onresize = function () {
	                    if ($scope.page.w) {
	                        width = element[0].clientWidth - 20;
	                        height = $scope.page.w[0].innerHeight + 50;
	                        svg.attr("width", width).attr("height", height);
	                        redraw();
	                    }
	                };
	
	                $scope.$on('$destroy', function () {
	                    element = null;
	                    $scope.page.w = null;
	                    window.onresize = null;
	                });
	            });
	        }
	    };
	}
	
	directive.$inject = ['$location', '$window', 'fetchStream', 'generateId', 'usSpinnerService'];
	module.exports = directive;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('severityLevels', __webpack_require__(849));
	};

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function directive($timeout) {
	    return {
	        restrict: 'A',
	        template: __webpack_require__(850),
	        transclude: false,
	        link: function link($scope, element, attrs) {
	            var _dictionary;
	
	            var dimension,
	                group,
	                outFilter,
	                hHeight,
	                cid = false,
	                key,
	                uid,
	                searchCategories,
	                div = "#sevButtons"; // because there is one instances of this directive per view, we can assign a uid directly to it
	            var sevHeights;
	
	            var dictionary = (_dictionary = { 'guarded': '0' }, _defineProperty(_dictionary, 'guarded', '1'), _defineProperty(_dictionary, 'elevated', '2'), _defineProperty(_dictionary, 'high', '3'), _defineProperty(_dictionary, 'severe', '4'), _dictionary);
	            var dictionary2 = { 0: 'guarded', 1: 'guarded', 2: 'elevated', 3: 'high', 4: 'severe' };
	            var activeFilters = {};
	            // $scope.data.dc = {};
	            $scope.severityLevels = {};
	            $scope.clicked = function (type) {
	                var column, title;
	                for (var s in searchCategories) {
	                    column = s;
	                    title = searchCategories[s];
	                    break;
	                }
	                $scope.main.filterItem(column, dictionary[type], "include", title);
	            };
	
	            $scope.$on('init', function (event, chart) {
	                if (chart.id !== attrs.uid) {
	                    return;
	                }
	                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') {
	                    return;
	                } // if its not in our dc object, ignore
	                $scope.main.dataObjects[chart.key].launched = true;
	                uid = chart.id;
	                cid = uid;
	                key = chart.key;
	
	                dimension = $scope.main.dataObjects[key].dimension;
	                group = $scope.main.dataObjects[key].group;
	                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
	                if (typeof setHeight === "undefined") {
	                    setUpData();
	                    makeButtonHeights(uid);
	                    iconSetup();
	                }
	            });
	
	            function setUpData() {
	                $scope.severityLevels.levels = {
	                    guarded: {
	                        value: 0,
	                        active: true
	                    },
	                    elevated: {
	                        value: 0,
	                        active: true
	                    },
	                    high: {
	                        value: 0,
	                        active: true
	                    },
	                    severe: {
	                        value: 0,
	                        active: true
	                    }
	                };
	                var data = group.top(Infinity);
	                for (var i = 0, len = data.length; i < len; i++) {
	                    if (typeof $scope.severityLevels.levels[dictionary2[data[i].value.severity]] !== "undefined") {
	                        $scope.severityLevels.levels[dictionary2[data[i].value.severity]].value += data[i].value.count;
	                    }
	                }
	                // disable the buttons with 0
	                for (var i in $scope.severityLevels.levels) {
	                    if ($scope.severityLevels.levels[i].value === 0 || $scope.severityLevels.levels[i].value === "") {
	                        $scope.severityLevels.levels[i].active = false;
	                    }
	                }
	            }
	
	            function makeButtonHeights(uid) {
	                // if (typeof $scope.data.dc[uid].visuals.rowchart === 'undefined') { return }
	                sevHeights = [0, 0, 0, 0];
	
	                var count = 0,
	                    val;
	                group.top(Infinity).filter(function (d) {
	                    val = d.key.slice(d.key.length - 1, d.key.length) - 1;
	                    if ((d.key.slice(d.key.length - 1, d.key.length) === "0" || d.key.slice(d.key.length - 1, d.key.length) === 0) && val > 0) {
	                        val = d.key.slice(d.key.length - 1, d.key.length);
	                    }
	                    count++;
	                    sevHeights[val]++;
	                });
	
	                if (count < 7) {
	                    hHeight = 33;
	                } else {
	                    hHeight = 29;
	                }
	                d3.select("#severityButtons").style("margin", "8px 0px 0px 0px");
	                for (var i = 0; i < sevHeights.length; i++) {
	                    if (sevHeights[i] === 0) {
	                        d3.select('.alert' + (i + 1)).style("display", "none");
	                    } else {
	                        d3.select('.alert' + (i + 1)).style("display", "block");
	                        d3.select('.alert' + (i + 1)).style("height", sevHeights[i] * hHeight - 5 + "px");
	                    }
	                }
	            }
	
	            function iconSetup() {
	                d3.select('.alert1').selectAll('svg').remove();
	                d3.select('.alert2').selectAll('svg').remove();
	                d3.select('.alert3').selectAll('svg').remove();
	                d3.select('.alert4').selectAll('svg').remove();
	
	                d3.select('.alert1 .severitySvg2015').insert('svg').attr('width', 20).attr('height', 20).append('polygon').attr("class", "userColor").attr('points', '9,1 8,0 0,0 0,18 2,18 2,10 7,10 8,11 14,11 14,1 ').style('fill', '#333');
	
	                d3.select('.alert2 .severitySvg2015').insert('svg').attr('width', 20).attr('height', 20).append('polygon').attr("class", "userColor").attr('points', '3.6,0 3.6,2 12.4,2 0,14.4 1.4,15.8 13.6,3.6 13.6,12 15.6,12 15.6,0 ').style('fill', '#333');
	
	                d3.select('.alert3 .severitySvg2015').insert('svg').attr('width', 20).attr('height', 20).append('path').attr("class", "userColor").attr('d', 'M17.7,17H0c0.5-1.3,1.3-2.5,2.3-3.4V8h0c0.2-2.9,2.3-5.3,5.1-5.9C7.4,1.9,7.3,1.7,7.3,1.5C7.3,0.7,8,0,8.8,0' + 's1.5,0.7,1.5,1.5c0,0.2-0.1,0.4-0.2,0.6c2.8,0.6,4.9,3,5.1,5.9h0v5.6C16.3,14.5,17.1,15.7,17.7,17z M8.8,20c1.2,0,2.2-0.9,2.4-2H6.4' + 'C6.6,19.1,7.6,20,8.8,20z').style('fill', '#333');
	
	                d3.select('.alert4 .severitySvg2015').insert('svg').attr('width', 20).attr('height', 20).append('path').attr("class", "userColor").attr('d', 'M12.7,0H5.3L0,5.3v7.5L5.3,18h7.5l5.3-5.3V5.3L12.7,0z M10,14H8v-2h2V14z M10,10H8V4h2V10z').style('fill', '#333');
	            }
	
	            // set update functions
	            $scope.$on('updatedData', function (event, id, filteredOn) {
	                if (id !== uid) {
	                    return;
	                } // only run when it sees its id has filtered
	                setUpData();
	                makeButtonHeights(uid);
	                iconSetup();
	            });
	            $scope.$on('$destroy', function () {
	                // $timeout.cancel(iconTimeout);
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = ['$timeout'];
	module.exports = directive;

/***/ },
/* 850 */
/***/ function(module, exports) {

	module.exports = "<div ng-show=\"severityLevels\">\n    <div id=\"severityButtons\">\n        <div class=\"btnCircle2015\" ng-click=\"clicked('severe', severityLevels.params.uid)\" ng-class=\"(severityLevels.levels.severe.active) ? 'alert4' : 'alert4 severity-deselect'\">\n            <div class=\"severityHolder2015\">\n                <div class=\"severitySvg2015\"></div>\n                <div class=\"severityValues2015\" id=\"al4\"> {{severityLevels.levels.severe.value}}</div>\n            </div>\n        </div>\n        <div class=\"btnCircle2015\" ng-click=\"clicked('high', severityLevels.params.uid)\" ng-class=\"(severityLevels.levels.high.active) ? 'alert3' : 'alert3 severity-deselect'\">\n            <div class=\"severityHolder2015\">\n                <div class=\"severitySvg2015\"></div>\n                <div class=\"severityValues2015\" id=\"al3\"> {{severityLevels.levels.high.value}}</div>\n            </div>\n        </div>\n        <div class=\"btnCircle2015\" ng-click=\"clicked('elevated', severityLevels.params.uid)\" ng-class=\"(severityLevels.levels.elevated.active) ? 'alert2' : 'alert2 severity-deselect'\">\n            <div class=\"severityHolder2015\">\n                <div class=\"severitySvg2015\"></div>\n                <div class=\"severityValues2015\" id=\"al2\"> {{severityLevels.levels.elevated.value}}</div>\n            </div>\n        </div>\n        <div class=\"btnCircle2015\" ng-click=\"clicked('guarded', severityLevels.params.uid)\" ng-class=\"(severityLevels.levels.guarded.active) ? 'alert1' : 'alert1 severity-deselect'\">\n            <div class=\"severityHolder2015\">\n                <div class=\"severitySvg2015\"></div>\n                <div class=\"severityValues2015\" id=\"al1\"> {{severityLevels.levels.guarded.value}}</div>\n            </div>\n        </div>\n    </div>\n</div>";

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('sevReplace', __webpack_require__(852));
	};

/***/ },
/* 852 */
/***/ function(module, exports) {

	'use strict';
	
	function directive() {
	    return {
	        link: function link($scope, element, attrs) {
	            var sev = attrs.name;
	
	            var elm = d3.select(element[0]).append('svg').attr('x', 0).attr('y', 0).attr('width', '44px').attr('height', '44px')
	            // .attr('viewBox','0 0 42.795 42.795')
	            // .attr('enable-background','new 0 0 42.795 42.795')
	            .attr('xml:space', 'preserve');
	
	            // switch between icon
	            switch (sev) {
	                case '1':
	                    elm.append('circle').attr('cx', 24).attr('cy', 24).attr('r', 14).attr('stroke-width', 1).style('fill', '#377FC7');
	                    elm.append('polygon').attr('points', '9,1 8,0 0,0 0,18 2,18 2,10 7,10 8,11 14,11 14,1 ').style('fill', '#333').attr('transform', 'translate(19,17), scale(0.8)');
	                    return;
	                case '2':
	                    elm.append('circle').attr('cx', 24).attr('cy', 24).attr('r', 14).attr('stroke-width', 1).style('fill', '#F5D800');
	                    elm.append('polygon').attr('points', '3.6,0 3.6,2 12.4,2 0,14.4 1.4,15.8 13.6,3.6 13.6,12 15.6,12 15.6,0 ').style('fill', '#333').attr('transform', 'translate(18,18), scale(0.8)');
	                    return;
	                case '3':
	                    elm.append('circle').attr('cx', 24).attr('cy', 24).attr('r', 14).attr('stroke-width', 1).style('fill', '#F88B12');
	                    elm.append('path').attr('d', 'M17.7,17H0c0.5-1.3,1.3-2.5,2.3-3.4V8h0c0.2-2.9,2.3-5.3,5.1-5.9C7.4,1.9,7.3,1.7,7.3,1.5C7.3,0.7,8,0,8.8,0' + 's1.5,0.7,1.5,1.5c0,0.2-0.1,0.4-0.2,0.6c2.8,0.6,4.9,3,5.1,5.9h0v5.6C16.3,14.5,17.1,15.7,17.7,17z M8.8,20c1.2,0,2.2-0.9,2.4-2H6.4').style('fill', '#333').attr('transform', 'translate(17,16), scale(0.8)');
	                    return;
	                case '4':
	                    elm.append('circle').attr('cx', 24).attr('cy', 24).attr('r', 14).attr('stroke-width', 1).style('fill', '#FF3131');
	                    elm.append('path').attr('d', 'M12.7,0H5.3L0,5.3v7.5L5.3,18h7.5l5.3-5.3V5.3L12.7,0z M10,14H8v-2h2V14z M10,10H8V4h2V10z').style('fill', '#333').attr('transform', 'translate(17,17), scale(0.8)');
	                    return;
	                default:
	                    return;
	            }
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('sidebar', __webpack_require__(854));
	};

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	function directive() {
	    return {
	        link: function link($scope, element, attrs) {
	            var app = __webpack_require__(855);
	
	            var sidebar, body;
	            var floating_logo = function floating_logo() {
	                var viewPort = $(window).height();
	                var sidebarHeight = $('.page-sidebar').height() + 180;
	                if (viewPort < sidebarHeight) {
	                    $('#footimg').css({ display: 'none' });
	                } else {
	                    $('#footimg').css({ position: 'fixed', bottom: 30, display: '' });
	                }
	            };
	            floating_logo();
	            $('.page-sidebar-menu').css({ "max-height": "100%" });
	            // $(window).scroll(function () {
	            //     $('.page-sidebar').css({ position: 'fixed' });
	            // });
	            // BOTTOM LEFT LOGO VISIBILITY
	            $('.page-sidebar li a').click(function () {
	                setTimeout(function () {
	                    floating_logo();
	                }, 150);
	            });
	
	            $scope.$on('window-resize', function () {
	                floating_logo();
	            });
	            // sidebar memory
	            if (!localStorage.getItem('sidebar')) {
	                localStorage.setItem('sidebar', 1);
	            }
	            if (localStorage.getItem('sidebar') == 0) {
	                // keep sidebar consistent between pages
	                body = $('body');
	                sidebar = $('.page-sidebar');
	                $('.sidebar-search', sidebar).removeClass('open');
	                body.addClass('page-sidebar-closed');
	            } else {
	                body = $('body');
	                sidebar = $('.page-sidebar');
	                body.removeClass('page-sidebar-closed');
	                sidebar.css('width', '');
	            }
	            app.init();
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	/**
	Core script to handle the entire layout and base functions
	**/
	$.expr[':'].regex = function (elem, index, match) {
	    var matchParams = match[3].split(','),
	        validLabels = /^(data|css):/,
	        attr = {
	        method: matchParams[0].match(validLabels) ? matchParams[0].split(':')[0] : 'attr',
	        property: matchParams.shift().replace(validLabels, '')
	    },
	        regexFlags = 'ig',
	        regex = new RegExp(matchParams.join('').replace(/^\s+|\s+$/g, ''), regexFlags);
	    return regex.test($(elem)[attr.method](attr.property));
	};
	
	var App = function () {
	    // IE mode
	    var _isRTL = false;
	    var _isIE = false;
	    var isIE9 = false;
	    var isIE10 = false;
	    var sidebarWidth = 225;
	    var sidebarCollapsedWidth = 35;
	    var responsiveHandlers = [];
	    // theme layout color set
	    var handleInit = function handleInit() {
	        if ($('body').css('direction') === 'rtl') {
	            _isRTL = true;
	        }
	        _isIE = !!navigator.userAgent.match(/MSIE 8.0/);
	        isIE9 = !!navigator.userAgent.match(/MSIE 9.0/);
	        isIE10 = !!navigator.userAgent.match(/MSIE 10/);
	        if (isIE10) {
	            $('html').addClass('ie10'); // detect IE10 version
	        }
	    };
	    var handleDesktopTabletContents = function handleDesktopTabletContents() {
	        // loops all page elements with "responsive" class and applies classes for tablet mode
	        // For metornic  1280px or less set as tablet mode to display the content properly
	        if ($(window).width() <= 1280 || $('body').hasClass('page-boxed')) {
	            $('.responsive').each(function () {
	                var forTablet = $(this).attr('data-tablet');
	                var forDesktop = $(this).attr('data-desktop');
	                if (forTablet) {
	                    $(this).removeClass(forDesktop);
	                    $(this).addClass(forTablet);
	                }
	            });
	        }
	        // loops all page elements with "responsive" class and applied classes for desktop mode
	        // For metornic  higher 1280px set as desktop mode to display the content properly
	        if ($(window).width() > 1280 && $('body').hasClass('page-boxed') === false) {
	            $('.responsive').each(function () {
	                var forTablet = $(this).attr('data-tablet');
	                var forDesktop = $(this).attr('data-desktop');
	                if (forTablet) {
	                    $(this).removeClass(forTablet);
	                    $(this).addClass(forDesktop);
	                }
	            });
	        }
	    };
	    var handleSidebarState = function handleSidebarState() {
	        // remove sidebar toggler if window width smaller than 900(for table and phone mode)
	        if ($(window).width() < 980) {
	            // localStorage.setItem('sidebar', 0);
	            // sidebar_close(e);
	        }
	    };
	    var runResponsiveHandlers = function runResponsiveHandlers() {
	        // reinitialize other subscribed elements
	        for (var i in responsiveHandlers) {
	            var each = responsiveHandlers[i];
	            each.call();
	        }
	    };
	    var handleResponsive = function handleResponsive() {
	        handleTooltips();
	        handleSidebarState();
	        handleDesktopTabletContents();
	        handleSidebarAndContentHeight();
	        handleChoosenSelect();
	        runResponsiveHandlers();
	    };
	    var handleResponsiveOnInit = function handleResponsiveOnInit() {
	        handleSidebarState();
	        handleDesktopTabletContents();
	        handleSidebarAndContentHeight();
	    };
	    var handleResponsiveOnResize = function handleResponsiveOnResize() {
	        var resize;
	        if (_isIE) {
	            var currheight;
	            $(window).resize(function () {
	                if (currheight == document.documentElement.clientHeight) {
	                    return; //quite event since only body resized not window.
	                }
	                if (resize) {
	                    clearTimeout(resize);
	                }
	                resize = setTimeout(function () {
	                    handleResponsive();
	                }, 50); // wait 50ms until window resize finishes
	                currheight = document.documentElement.clientHeight; // store last body client height
	            });
	        } else {
	            $(window).resize(function () {
	                if (resize) {
	                    clearTimeout(resize);
	                }
	                resize = setTimeout(function () {
	                    handleResponsive();
	                }, 50); // wait 50ms until window resize finishes.
	            });
	        }
	    };
	    //* BEGIN:CORE HANDLERS *//
	    // this function handles responsive layout on screen size resize or mobile device rotate.
	    var handleSidebarAndContentHeight = function handleSidebarAndContentHeight() {
	        var content = $('.page-content');
	        var sidebar = $('.page-sidebar');
	        var body = $('body');
	        var height;
	        if (body.hasClass('page-footer-fixed') === true && body.hasClass('page-sidebar-fixed') === false) {
	            var available_height = $(window).height() - $('.footer').height();
	            if (content.height() < available_height) {
	                content.attr('style', 'min-height:' + available_height + 'px !important');
	            }
	        } else {
	            if (body.hasClass('page-sidebar-fixed')) {
	                height = _calculateFixedSidebarViewportHeight();
	            } else {
	                height = sidebar.height() + 20;
	            }
	            if (height >= content.height()) {
	                content.attr('style', 'min-height:' + height + 'px !important');
	            }
	        }
	    };
	    var handleSidebarMenu = function handleSidebarMenu() {
	        $('.page-sidebar').on('click', 'li > a', function (e) {
	            if ($(this).next().hasClass('sub-menu') === false) {
	                if ($('.btn-navbar').hasClass('collapsed') === false) {
	                    $('.btn-navbar').click();
	                }
	                return;
	            }
	            var parent = $(this).parent().parent();
	            parent.children('li.open').children('a').children('.arrow').removeClass('open');
	            parent.children('li.open').children('.sub-menu').slideUp(200);
	            parent.children('li.open').removeClass('open');
	            var sub = $(this).next();
	            if (sub.is(':visible')) {
	                $('.arrow', $(this)).removeClass('open');
	                $(this).parent().removeClass('open');
	                sub.slideUp(200, function () {
	                    handleSidebarAndContentHeight();
	                });
	            } else {
	                $('.arrow', $(this)).addClass('open');
	                $(this).parent().addClass('open');
	                sub.slideDown(200, function () {
	                    handleSidebarAndContentHeight();
	                });
	            }
	            e.preventDefault();
	        });
	        // handle ajax links
	        $('.page-sidebar').on('click', ' li > a.ajaxify', function (e) {
	            e.preventDefault();
	            App.scrollTop();
	            var url = $(this).attr('href');
	            var menuContainer = $('.page-sidebar ul');
	            var pageContent = $('.page-content');
	            var pageContentBody = $('.page-content .page-content-body');
	            menuContainer.children('li.active').removeClass('active');
	            menuContainer.children('arrow.open').removeClass('open');
	            $(this).parents('li').each(function () {
	                $(this).addClass('active');
	                $(this).children('a > span.arrow').addClass('open');
	            });
	            $(this).parents('li').addClass('active');
	            App.blockUI(pageContent, false);
	            $.post(url, {}, function (res) {
	                App.unblockUI(pageContent);
	                pageContentBody.html(res);
	                App.fixContentHeight(); // fix content height
	                App.initUniform(); // initialize uniform elements
	            });
	        });
	    };
	    var _calculateFixedSidebarViewportHeight = function _calculateFixedSidebarViewportHeight() {
	        var sidebarHeight = $(window).height() - $('.header').height() + 1;
	        if ($('body').hasClass('page-footer-fixed')) {
	            sidebarHeight = sidebarHeight - $('.footer').height();
	        }
	        return sidebarHeight;
	    };
	    // function sidebar_close(e) {
	    var sidebar_close = function sidebar_close(e) {
	        var body = $('body');
	        var sidebar = $('.page-sidebar');
	        $('.sidebar-search', sidebar).removeClass('open');
	        body.addClass('page-sidebar-closed');
	        runResponsiveHandlers();
	    };
	    var sidebar_open = function sidebar_open(e) {
	        var body = $('body');
	        var sidebar = $('.page-sidebar');
	        body.removeClass('page-sidebar-closed');
	        sidebar.css('width', '');
	        runResponsiveHandlers();
	    };
	    var handleSidebarToggler = function handleSidebarToggler() {
	        $('.page-sidebar').on('click', '.sidebar-toggler', function (e) {
	            if (localStorage.getItem('sidebar') == 0) {
	                localStorage.setItem('sidebar', 1);
	                sidebar_open(e);
	            } else {
	                localStorage.setItem('sidebar', 0);
	                sidebar_close(e);
	            }
	        });
	    };
	    var handleHorizontalMenu = function handleHorizontalMenu() {
	        //handle hor menu search form toggler click
	        $('.header').on('click', '.hor-menu .hor-menu-search-form-toggler', function (e) {
	            if ($(this).hasClass('hide')) {
	                $(this).removeClass('hide');
	                $('.header .hor-menu .search-form').hide();
	            } else {
	                $(this).addClass('hide');
	                $('.header .hor-menu .search-form').show();
	            }
	            e.preventDefault();
	        });
	        //handle hor menu search button click
	        $('.header').on('click', '.hor-menu .search-form .btn', function (e) {
	            window.location.href = 'extra_search.html';
	            e.preventDefault();
	        });
	        //handle hor menu search form on enter press
	        $('.header').on('keypress', '.hor-menu .search-form input', function (e) {
	            if (e.which == 13) {
	                window.location.href = 'extra_search.html';
	                return false;
	            }
	        });
	    };
	    var handleGoTop = function handleGoTop() {
	        /* set variables locally for increased performance */
	        $('.footer').on('click', '.go-top', function (e) {
	            App.scrollTo();
	            e.preventDefault();
	        });
	    };
	    var handleUniform = function handleUniform() {
	        if (!$().uniform) {
	            return;
	        }
	        var test = $("input[type=checkbox]:not(.toggle), input[type=radio]:not(.toggle, .star)");
	        if (test.size() > 0) {
	            test.each(function () {
	                if ($(this).parents('.checker').size() === 0) {
	                    $(this).show();
	                    $(this).uniform();
	                }
	            });
	        }
	    };
	    var handleAccordions = function handleAccordions() {
	        //$('.accordion').collapse().height('auto');
	        var lastClicked;
	        //add scrollable class name if you need scrollable panes
	        $('body').on('click', '.accordion.scrollable .accordion-toggle', function () {
	            lastClicked = $(this);
	        }); //move to faq section
	        $('body').on('shown', '.accordion.scrollable', function () {
	            $('html,body').animate({
	                scrollTop: lastClicked.offset().top - 150
	            }, 'slow');
	        });
	    };
	    var handleScrollers = function handleScrollers() {
	        $('.scroller').each(function () {
	            $(this).slimScroll({
	                size: '7px',
	                color: '#a1b2bd',
	                position: _isRTL ? 'left' : 'right',
	                height: $(this).attr("data-height"),
	                alwaysVisible: $(this).attr('data-always-visible') == "1" ? true : false,
	                railVisible: $(this).attr('data-rail-visible') == "1" ? true : false,
	                disableFadeOut: true
	            });
	        });
	    };
	    var handleTooltips = function handleTooltips() {
	        if (App.isTouchDevice()) {
	            // if touch device, some tooltips can be skipped in order to not conflict with click events
	            $('.tooltips:not(.no-tooltip-on-touch-device)').tooltip();
	        }
	        // else {
	        //  $('.tooltips').tooltip();
	        // }
	    };
	    var handleDropdowns = function handleDropdowns() {
	        $('body').on('click', '.dropdown-menu.hold-on-click', function (e) {
	            e.stopPropagation();
	        });
	    };
	    var handlePopovers = function handlePopovers() {
	        //$('.popovers').popover();
	    };
	    var handleChoosenSelect = function handleChoosenSelect() {
	        if (!$().chosen) {
	            return;
	        }
	        $('.chosen').each(function () {
	            $(this).chosen({
	                allow_single_deselect: $(this).attr('data-with-diselect') === "1" ? true : false
	            });
	        });
	    };
	    var handleFancybox = function handleFancybox() {
	        if (!$.fancybox) {
	            return;
	        }
	        if ($('.fancybox-button').size() > 0) {
	            $('.fancybox-button').fancybox({
	                groupAttr: 'data-rel',
	                prevEffect: 'none',
	                nextEffect: 'none',
	                closeBtn: true,
	                helpers: {
	                    title: {
	                        type: 'inside'
	                    }
	                }
	            });
	        }
	    };
	    var handleTheme = function handleTheme() {
	        var panel = $('.color-panel');
	        if ($('body').hasClass('page-boxed') === false) {
	            $('.layout-option', panel).val('fluid');
	        }
	        $('.sidebar-option', panel).val('default');
	        $('.header-option', panel).val('fixed');
	        $('.footer-option', panel).val('default');
	        //handle theme layout
	        var resetLayout = function resetLayout() {
	            $('body').removeClass('page-boxed').removeClass('page-footer-fixed').removeClass('page-sidebar-fixed').removeClass('page-header-fixed');
	            $('.header > .navbar-inner > .container').removeClass('container').addClass('container-fluid');
	            if ($('.page-container').parent('.container').size() === 1) {
	                $('.page-container').insertAfter('.header');
	            }
	            if ($('.footer > .container').size() === 1) {
	                $('.footer').html($('.footer > .container').html());
	            } else if ($('.footer').parent('.container').size() === 1) {
	                $('.footer').insertAfter('.page-container');
	            }
	            $('body > .container').remove();
	        };
	        var lastSelectedLayout = '';
	        var setLayout = function setLayout() {
	            var layoutOption = $('.layout-option', panel).val();
	            var sidebarOption = $('.sidebar-option', panel).val();
	            var headerOption = $('.header-option', panel).val();
	            var footerOption = $('.footer-option', panel).val();
	            if (sidebarOption == "fixed" && headerOption == "default") {
	                alert('Default Header with Fixed Sidebar option is not supported. Proceed with Default Header with Default Sidebar.');
	                $('.sidebar-option', panel).val("default");
	                sidebarOption = 'default';
	            }
	            resetLayout(); // reset layout to default state
	            if (layoutOption === "boxed") {
	                $("body").addClass("page-boxed");
	                // set header
	                $('.header > .navbar-inner > .container-fluid').removeClass("container-fluid").addClass("container");
	                var cont = $('.header').after('<div class="container"></div>');
	                // set content
	                $('.page-container').appendTo('body > .container');
	                // set footer
	                if (footerOption === 'fixed' || sidebarOption === 'default') {
	                    $('.footer').html('<div class="container">' + $('.footer').html() + '</div>');
	                } else {
	                    $('.footer').appendTo('body > .container');
	                }
	            }
	            if (lastSelectedLayout != layoutOption) {
	                //layout changed, run responsive handler:
	                runResponsiveHandlers();
	            }
	            lastSelectedLayout = layoutOption;
	            //header
	            if (headerOption === 'fixed') {
	                $("body").addClass("page-header-fixed");
	                $(".header").removeClass("navbar-static-top").addClass("navbar-fixed-top");
	            } else {
	                $("body").removeClass("page-header-fixed");
	                $(".header").removeClass("navbar-fixed-top").addClass("navbar-static-top");
	            }
	            //sidebar
	            if (sidebarOption === 'fixed') {
	                $("body").addClass("page-sidebar-fixed");
	            } else {
	                $("body").removeClass("page-sidebar-fixed");
	            }
	            //footer
	            if (footerOption === 'fixed') {
	                $("body").addClass("page-footer-fixed");
	            } else {
	                $("body").removeClass("page-footer-fixed");
	            }
	            handleSidebarAndContentHeight(); // fix content height
	            handleFixedSidebarHoverable(); // reinitialize fixed sidebar hover effect
	        };
	        // handle theme colors
	        var setColor = function setColor(color) {
	            $('#style_color').attr("href", "assets/css/themes/" + color + ".css");
	            $.cookie('style_color', color);
	        };
	        $('.icon-color', panel).click(function () {
	            $('.color-mode').show();
	            $('.icon-color-close').show();
	        });
	        $('.icon-color-close', panel).click(function () {
	            $('.color-mode').hide();
	            $('.icon-color-close').hide();
	        });
	        $('li', panel).click(function () {
	            var color = $(this).attr("data-style");
	            setColor(color);
	            $('.inline li', panel).removeClass("current");
	            $(this).addClass("current");
	        });
	        $('.layout-option, .header-option, .sidebar-option, .footer-option', panel).change(setLayout);
	    };
	    var handleFixInputPlaceholderForIE = function handleFixInputPlaceholderForIE() {
	        //fix html5 placeholder attribute for ie7 & ie8
	        if (_isIE || isIE9) {
	            // ie7&ie8
	            // this is html5 placeholder fix for inputs, inputs with placeholder-no-fix class will be skipped(e.g: we need this for password fields)
	            $('input[placeholder]:not(.placeholder-no-fix), textarea[placeholder]:not(.placeholder-no-fix)').each(function () {
	                var input = $(this);
	                if (input.val() == '' && input.attr('placeholder') != '') {
	                    input.addClass('placeholder').val(input.attr('placeholder'));
	                }
	                input.focus(function () {
	                    if (input.val() == input.attr('placeholder')) {
	                        input.val('');
	                    }
	                });
	                input.blur(function () {
	                    if (input.val() == '' || input.val() == input.attr('placeholder')) {
	                        input.val(input.attr('placeholder'));
	                    }
	                });
	            });
	        }
	    };
	    //* END:CORE HANDLERS *//
	    return {
	        //main function to initiate template pages
	        init: function init() {
	            //IMPORTANT!!!: Do not modify the core handlers call order.
	            //core handlers
	            handleInit();
	            handleResponsiveOnResize(); // set and handle responsive
	            handleUniform();
	            handleScrollers(); // handles slim scrolling contents
	            handleResponsiveOnInit(); // handler responsive elements on page load
	            //layout handlers
	            handleSidebarMenu(); // handles main menu
	            handleHorizontalMenu(); // handles horizontal menu
	            handleSidebarToggler(); // handles sidebar hide/show
	            handleFixInputPlaceholderForIE(); // fixes/enables html5 placeholder attribute for IE9, IE8
	            handleGoTop(); //handles scroll to top functionality in the footer
	            handleTheme(); // handles style customer tool
	            //ui component handlers
	            handleDropdowns(); // handle dropdowns
	            handleTooltips(); // handle bootstrap tooltips
	            handlePopovers(); // handles bootstrap popovers
	            handleAccordions(); //handles accordions
	            handleChoosenSelect(); // handles bootstrap chosen dropdowns
	            App.addResponsiveHandler(handleChoosenSelect); // reinitiate chosen dropdown on main content resize. disable this line if you don't really use chosen dropdowns.
	        },
	        fixContentHeight: function fixContentHeight() {
	            handleSidebarAndContentHeight();
	        },
	        addResponsiveHandler: function addResponsiveHandler(func) {
	            responsiveHandlers.push(func);
	        },
	        // useful function to make equal height for contacts stand side by side
	        setEqualHeight: function setEqualHeight(els) {
	            var tallestEl = 0;
	            els = $(els);
	            els.each(function () {
	                var currentHeight = $(this).height();
	                if (currentHeight > tallestEl) {
	                    tallestColumn = currentHeight;
	                }
	            });
	            els.height(tallestEl);
	        },
	        // wrapper function to scroll to an element
	        scrollTo: function scrollTo(el, offeset) {
	            pos = el ? el.offset().top : 0;
	            $('html,body').animate({
	                scrollTop: pos + (offeset ? offeset : 0)
	            }, 'slow');
	        },
	        scrollTop: function scrollTop() {
	            App.scrollTo();
	        },
	        // wrapper function to  block element(indicate loading)
	        blockUI: function blockUI(el, centerY) {
	            var el = $(el);
	            el.block({
	                message: '<img src="./assets/img/ajax-loading.gif" align=""/>',
	                centerY: centerY != undefined ? centerY : true,
	                css: {
	                    top: '10%',
	                    border: 'none',
	                    padding: '2px',
	                    backgroundColor: 'none'
	                },
	                overlayCSS: {
	                    backgroundColor: '#000',
	                    opacity: 0.05,
	                    cursor: 'wait'
	                }
	            });
	        },
	        // wrapper function to  un-block element(finish loading)
	        unblockUI: function unblockUI(el) {
	            $(el).unblock({
	                onUnblock: function onUnblock() {
	                    $(el).removeAttr('style');
	                }
	            });
	        },
	        // initializes uniform elements
	        initUniform: function initUniform(els) {
	            if (els) {
	                $(els).each(function () {
	                    if ($(this).parents('.checker').size() == 0) {
	                        $(this).show();
	                        $(this).uniform();
	                    }
	                });
	            } else {
	                handleUniform();
	            }
	        },
	        // initializes choosen dropdowns
	        initChosenSelect: function initChosenSelect(els) {
	            $(els).chosen({
	                allow_single_deselect: true
	            });
	        },
	        initFancybox: function initFancybox() {
	            handleFancybox();
	        },
	        getActualVal: function getActualVal(el) {
	            var el = $(el);
	            if (el.val() === el.attr('placeholder')) {
	                return '';
	            }
	            return el.val();
	        },
	        //getURLParameter: function (paramName) {
	        //var searchString = window.location.search.substring(1),
	        //i, val, params = searchString.split("&");
	        //for (i = 0; i < params.length; i++) {
	        //val = params[i].split("=");
	        //if (val[0] == paramName) {
	        //return unescape(val[1]);
	        //}
	        //}
	        //return null;
	        //},
	        // check for device touch support
	        isTouchDevice: function isTouchDevice() {
	            try {
	                document.createEvent('TouchEvent');
	                return true;
	            } catch (e) {
	                return false;
	            }
	        },
	        isIE8: function isIE8() {
	            return _isIE;
	        },
	        isRTL: function isRTL() {
	            return _isRTL;
	        }
	    };
	}();
	
	module.exports = App;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('sidebarIcon', __webpack_require__(857));
	};

/***/ },
/* 857 */
/***/ function(module, exports) {

	'use strict';
	
	function directive() {
	    return {
	        link: function link($scope, element, attrs) {
	            var icon = attrs.name;
	            var elm = d3.select(element[0]).append('svg').attr('x', 0).attr('y', 0).attr('width', '0').attr('height', '0');
	            var em = elm.append('g');
	            // switch between text
	            switch (icon) {
	                case 'fa-active-defense':
	                    elm.attr('width', '14').attr('height', '16');
	                    em.append('path').attr('transform', 'translate(0,0) scale(0.75)').style('fill', '#eeeeee').attr("d", "M9,0L0,4v6c0,5.4,3.6,10,8.5,11.5C13.4,20,17,15.4,17,10V4L9,0z M3.8,10h4L3.2,5.1h5.6l4,5.9h-3l4,6L3.8,10z");
	                    return;
	                case 'fa-network-ips':
	                    elm.attr('width', '14').attr('height', '16');
	                    em.append('path').attr('transform', 'translate(0,2) scale(0.75)').style('fill', '#eeeeee').attr("d", "M6,5H0V0h6V5z M15,0H8v5h7V0z M19,0h-2v5h2V0z M2,7H0v5h2V7z M11,7H4v5h7V7z M19,7h-6v5h6V7z M6,14H0v5h6V14z M15,14H8v5h7V14z M19,14h-2v5h2V14z");
	                    return;
	                case 'fa-target':
	                    elm.attr('width', '11').attr('height', '13');
	                    em.append('path').attr('transform', 'translate(0,2) scale(0.55)').style('fill', '#eeeeee').attr("d", "M10,0C4.5,0,0,4.5,0,10c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10C20,4.5,15.5,0,10,0z M10,18c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8C18,14.4,14.4,18,10,18z M10,4c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S13.3,4,10,4z M10,14c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S12.2,14,10,14z M12,10c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S12,8.9,12,10z");
	                    return;
	                case 'fa-blacklist':
	                    elm.attr('width', '16').attr('height', '13');
	                    em.append('path').attr('transform', 'translate(0,2) scale(0.7)').style('fill', 'none').style('stroke', '#fff').style('stroke-width', '1.5').attr("d", "M11,0C6.1,0,1.9,2.9,0,7c1.9,4.1,6.1,7,11,7c4.9,0,9.1-2.9,11-7C20.1,2.9,15.9,0,11,0z M11,12c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5S13.8,12,11,12z M14,7.1c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3C12.7,4.1,14,5.5,14,7.1z");
	                    return;
	                case 'fa-whitelist':
	                    elm.attr('width', '15').attr('height', '13');
	                    em.append('path').attr('transform', 'translate(0,2) scale(0.7)').style('fill', '#eeeeee').attr("d", "M11,0C6.1,0,1.9,2.9,0,7c1.9,4.1,6.1,7,11,7c4.9,0,9.1-2.9,11-7C20.1,2.9,15.9,0,11,0z M11,12c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5S13.8,12,11,12z M14,7.1c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3C12.7,4.1,14,5.5,14,7.1z");
	                    return;
	                case 'fa-wifi':
	                    elm.attr('width', '15').attr('height', '13');
	                    em.append('path').attr('transform', 'translate(0) scale(0.025)').style('fill', '#fff').attr("d", "M384 416c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm136.659-124.443c6.465-6.465 6.245-17.065-.564-23.167-113.793-101.985-286.526-101.869-400.19 0-6.809 6.102-7.029 16.702-.564 23.167l34.006 34.006c5.927 5.927 15.464 6.32 21.769.796 82.88-72.609 207.074-72.447 289.768 0 6.305 5.524 15.842 5.132 21.769-.796l34.006-34.006zm112.11-113.718c6.385-6.385 6.254-16.816-.35-22.973-175.768-163.86-449.134-163.8-624.837 0-6.604 6.157-6.735 16.589-.35 22.973l33.966 33.966c6.095 6.095 15.891 6.231 22.224.383 144.763-133.668 368.356-133.702 513.156 0 6.333 5.848 16.129 5.712 22.224-.383l33.967-33.966z");
	                    return;
	                case 'icon-broadcast':
	                    elm.attr('width', '15').attr('height', '15');
	                    em.append('path').attr('transform', 'translate(-1,0) scale(0.035)').style('fill', '#eee').attr("d", "M221.309,465.929V244.183c-9.616-6.411-16.026-17.483-16.026-30.013c0-19.814,16.026-35.841,35.841-35.841   s35.841,16.026,35.841,35.841c0,14.569-8.742,27.099-20.98,32.635v219.124c0,9.616-7.867,17.483-17.483,17.483   S221.309,475.545,221.309,465.929z M328.248,284.977c2.914,1.748,5.828,2.622,9.033,2.622c5.828,0,11.656-2.914,14.861-8.45   c13.112-21.563,19.523-46.331,18.357-71.681c-2.914-70.516-62.648-125.588-133.456-122.966   c-33.801,1.457-65.271,16.026-88.582,41.377c-23.311,25.059-35.258,57.986-33.801,92.079c0.874,20.106,6.119,39.337,15.735,56.821   c4.662,8.45,15.444,11.656,23.894,6.702c8.45-4.662,11.364-15.444,6.702-23.894c-6.993-12.821-10.781-26.516-11.656-41.377   c-0.874-24.768,7.867-48.662,24.477-67.019s40.212-28.556,64.979-29.722c51.284-2.04,94.992,37.88,97.032,89.456   c0.874,18.357-3.788,36.423-13.404,52.158C317.467,269.242,320.09,280.024,328.248,284.977z M379.533,352.288   c7.285,6.119,18.357,5.245,24.768-2.04c32.344-38.463,50.119-87.125,50.119-137.535C454.419,95.284,359.136,0,241.706,0   S28.993,95.284,28.993,212.713c0,53.324,19.814,104.025,55.655,143.363c3.497,3.788,8.159,5.828,12.821,5.828   c4.079,0,8.45-1.457,11.656-4.662c6.993-6.411,7.576-17.483,1.166-24.768c-29.722-32.635-46.331-75.178-46.331-119.76   c0-97.906,79.84-177.747,177.747-177.747s177.747,79.84,177.747,177.747c0,41.96-14.861,82.754-41.96,114.807   C371.082,334.805,371.957,345.877,379.533,352.288z");
	                    return;
	                default:
	                    return;
	            }
	            $scope.$on('$destroy', function () {
	                element.remove();
	            });
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('sevTable', __webpack_require__(859));
	    ngModule.directive('tableSearchSidebar', __webpack_require__(860));
	};

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function directive($compile, $location, $http, $state, getData, $interval, $window, ngDialog, timeFormat, usSpinnerService) {
	    return {
	        replace: true,
	        template: '<div id="sTable">',
	        link: function link($scope, elem, attrs) {
	            $scope.tableComplete = true;
	            // close dialog on open
	            ngDialog.close();
	            if (!$scope.page.settings.get('toggleVal')) {
	                $scope.togVal = 1;
	                $scope.byteOffset = 7;
	            } else {
	                $scope.byteOffset = 1;
	                $scope.togVal = 1048576;
	                if ($scope.page.settings.get('toggleVal') === "KB") {
	                    $scope.byteOffset = 2.5;
	                    $scope.togVal = 1024;
	                }
	            }
	            // connect local scope to the timeFormat service
	            $scope.timeFormat = timeFormat;
	            // Leave the following lists empty because views are not ready, keep the previous arrays just in case are needed in the future. 
	            // let custom_ioc_list = ['resp_ip', 'orig_ip', 'ip','filename', 'file_name', 'file', 'md5', 'sha1', 'sha256', 'top_domain', 'domain', 'host', 'subdomain'];
	            // let whitelist_list = ['ioc_rule', 'seen_indicator'];
	            var custom_ioc_list = [];
	            var whitelist_list = [];
	            var virustotal_list = ['ioc_rule'];
	            $scope.custom_ioc_click = false;
	            $scope.ioc_rule_click = false;
	            $scope.virustotal_click = false;
	
	            $scope.twoDecimal = function (num) {
	                return Math.round(num * 1000) / 1000;
	            };
	            $scope.breakdown = function (a, b) {
	                a = Number(a);
	                b = Number(b);
	                if (a === 0 && b === 0) {
	                    return 50;
	                }
	                return Math.round(a / (a + b) * 100);
	            };
	            $scope.floatBreakdown = function (a, b) {
	                var outputLeft = (a / (a + b) * 100).toFixed(2);
	                var outputRight = (100 - outputLeft).toFixed(2);
	
	                return a === 0 && b === 0 ? { left: 50.00, right: 50.00 } : { left: outputLeft, right: outputRight };
	            };
	
	            var tableItemLimit = 20;
	            if ($scope.page.settings.get('tableItemLimit')) {
	                tableItemLimit = $scope.page.settings.get('tableItemLimit');
	            }
	
	            // create a refrence object for settings to compare against - NOTE these are the default settings set in the controller
	            var columnRefrence = {};
	
	            // this function the returns styled, but stripped dowm version of the table's TDs to be used in the table modal
	            var nakedColumnItems = function nakedColumnItems(column) {
	                switch (column.select) {
	                    case 'time':
	                    case 'first_seen':
	                    case 'last_seen':
	                    case 'last_run':
	                    case 'compile_ts':
	                    case 'certificate_not_valid_after':
	                    case 'certificate_not_valid_before':
	                        return '{{timeFormat(row.value.' + column.select + ', \'tables\')}}';
	                    case 'feed':
	                        return '<div class="firstColumn"><span>{{::row.value.' + column.select + '}}</span></div>';
	                    case 'custom_type':
	                        return '<ioc-attribute type="type" name="{{::row.value.' + column.select + '}}"/>';
	                    case 'custom_rule':
	                        return '<ioc-attribute type="rule" name="{{::row.value.' + column.select + '}}"/>';
	                    case 'l7_proto':
	                        return '<div app-replace name="{{::row.value.' + column.select + '}}"></div>';
	                    case 'resp_cc':
	                    case 'server_cc':
	                    case 'orig_cc':
	                        return '<div style="min-width:50px"><div class="f32"><span class="flag {{row.value.' + column.select + ' === \'N/A\' ?  \'iana\' : row.value.' + column.select + '.toLowerCase()}}"></span></div></div>';
	                    case 'ioc_severity':
	                        return '<div ng-if="::row.value.' + column.select + ' != 0 && row.value.' + column.select + ' != \'-\' "><div sev-replace name="{{::row.value.' + column.select + '}}"></div></div><div ng-if="row.value.' + column.select + ' == 0 || row.value.' + column.select + ' == \'-\'">-</div>';
	                    case 'resp_asn_name':
	                    case 'orig_asn_name':
	                    case 'server_asn_name':
	                        return '<section ng-if="::row.value.' + column.select + ' === \'- (0)\' || row.value.' + column.select + ' === \'- (-)\'">-</section><section ng-if="::row.value.' + column.select + ' !== \'- (0)\' && row.value.' + column.select + ' !== \'- (-)\'">{{::row.value.' + column.select + '}}</section>';
	                    case 'file_size':
	                    case 'size':
	                    case 'bytes_orig':
	                    case 'bytes_resp':
	                        return '{{twoDecimal(row.value.' + column.select + '/togVal)}}';
	                    case 'orig_stealth':
	                    case 'resp_stealth':
	                        return '<section ng-if="::row.value.' + column.select + ' > 0"><span style="color:#000" class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i style="color:#f2f2f2" class="fa fa-shield fa-stack-1x fa-inverse"></i></span></section>';
	                    case 'proxy_blocked':
	                        return '<section ng-if="::row.value.proxy_blocked > 0"><span style="color:#E71010 " class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i style="color:#f2f2f2" class="fa fa-times fa-stack-1x fa-inverse"></i></span></section>';
	                    // (IF WE RE ADD PROXY === 0)
	                    // <section ng-if="::row.value.proxy_blocked <= 0"><span class="iconstroke fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i style="color:#f2f2f2" class="fa fa-check fa-stack-1x fa-inverse"></i></span></section>
	                    case 'breakdown':
	                        return '<span class="breakdown">' + '<span class="orig"  ng-class="{\'blank\': ((row.value.bytes_resp == 0) && (row.value.bytes_orig == 0))}" style="width:{{breakdown(row.value.bytes_orig,row.value.bytes_resp)}}%;">{{breakdown(row.value.bytes_orig,row.value.bytes_resp)}}%</span>' + '<span class="resp"  ng-class="{\'blank\': ((row.value.bytes_resp == 0) && (row.value.bytes_orig == 0))}" style="width:{{breakdown(row.value.bytes_resp,row.value.bytes_orig)}}%;">{{breakdown(row.value.bytes_resp,row.value.bytes_orig)}}%</span>' + '</span>';
	                    case 'subdomain_breakdown':
	                        return '<span class="breakdown">\n                                    <span class="orig"  ng-class="{\'blank\': ((row.value.subdomain_total == 0) && (row.value.subdomain_queries == 0))}" style="min-width: 1%; max-width: 99%; width:{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).left}}%;">{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).left}}%</span>\n                                    <span class="resp"  ng-class="{\'blank\': ((row.value.subdomain_total == 0) && (row.value.subdomain_queries == 0))}" style="min-width: 1%; max-width: 99%; width:{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).right}}%;">{{floatBreakdown(row.value.subdomain_total, row.value.subdomain_queries).right}}%</span>\n                                </span>';
	                    default:
	                        return column.value;
	                }
	            };
	            function constructTable(identifiers) {
	                // stuff refrence object for use below
	                for (var c = 0, len = $scope.main.dataObjects[identifiers.key].settings.columns.length; c < len; c++) {
	                    columnRefrence[$scope.main.dataObjects[identifiers.key].settings.columns[c].select] = $scope.main.dataObjects[identifiers.key].settings.columns[c];
	                }
	                // columns logic
	                $scope.columns = [];
	                var newColumns = [];
	                var prefix = '';
	                if ($state.current.name === 'pages.main.search') {
	                    prefix = angular.copy($scope.main.currentMode); // add mode to table prefix
	                }
	                // $scope.page.settings.set(prefix+'table-columnConfig', false)
	                var settingsColumns = $scope.page.settings.get(prefix + 'table-columnConfig');
	                if (settingsColumns) {
	                    // stuff any columns that are in our refrence AND are display true in the settings into our column obj
	                    var columnsInSettingsDictionary = {}; // create lookup to iterate over and see if any new columns to append to end
	                    settingsColumns.forEach(function (setting) {
	                        var key = Object.keys(setting)[0];
	                        if (setting[key] && columnRefrence.hasOwnProperty(key)) {
	                            $scope.columns.push(columnRefrence[key]);
	                        }
	                        columnsInSettingsDictionary[key] = true; // value doesn't matter here, just doing a key lookup below
	                    });
	                    for (var item in columnRefrence) {
	                        var key = columnRefrence[item].select;
	                        // if not in settings and default view is true, push it to new columns array
	                        if (!columnsInSettingsDictionary.hasOwnProperty(key) && columnRefrence[item].dView) {
	                            newColumns.push(columnRefrence[item]);
	                        }
	                    }
	                    // append any new columns to our existing column array
	                    $scope.columns.push.apply($scope.columns, newColumns);
	                } else {
	                    // if no settings exist, loop through and replace the empty columns array with the settings array already defined
	                    for (var _c = 0, _len = $scope.main.dataObjects[identifiers.key].settings.columns.length; _c < _len; _c++) {
	                        if ($scope.main.dataObjects[identifiers.key].settings.columns[_c].dView) {
	                            $scope.columns.push($scope.main.dataObjects[identifiers.key].settings.columns[_c]);
	                        }
	                    }
	                }
	
	                var tdWrapper = function tdWrapper(innerText, column) {
	                    var td = '<td class="noselect" ng-right-click="rightClicked($event, {value: row.value.' + column.select + ', key: \'' + column.select + '\', title: \'' + column.title + '\' }, row)">';
	                    td += innerText;
	                    td += '</td>';
	                    return td;
	                };
	                var cells = '';
	                for (var i = 0, _len2 = $scope.columns.length; i < _len2; i++) {
	                    // hide stealth if user is not authorized
	                    if (($scope.columns[i].select === 'orig_stealth' || $scope.columns[i].select === 'resp_stealth') && $scope.global.user.settings_global.stealth === false) {
	                        $scope.columns.splice(i, 1);
	                        _len2 = $scope.columns.length;
	                    }
	                    // hide proxy if user is not authorized
	                    if ($scope.columns[i].select === 'proxy_blocked' && $scope.global.user.settings_global.proxy_blocked === false) {
	                        $scope.columns.splice(i, 1);
	                        _len2 = $scope.columns.length;
	                    }
	                    // active defense if user is not authorized
	                    if ($scope.columns[i].select === 'active_defense' && $scope.global.user.settings_global.active_defense === false) {
	                        $scope.columns.splice(i, 1);
	                        _len2 = $scope.columns.length;
	                    }
	                    switch ($scope.columns[i].select) {
	                        case 'time':
	                        case 'first_seen':
	                            var tdTxt = '';
	                            if ($scope.columns[i].hasOwnProperty('link')) {
	                                tdTxt += '<button class="btnTableDate2015" ng-click=\'::generateLink(row, ' + i + ')\'>' + nakedColumnItems($scope.columns[i]) + '</button>';
	                            } else {
	                                tdTxt += '<div class=\'tableDate2015\'>' + nakedColumnItems($scope.columns[i]) + '</div>';
	                            }
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'last_seen':
	                        case 'last_run':
	                        case 'compile_ts':
	                        case 'certificate_not_valid_after':
	                        case 'certificate_not_valid_before':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'feed':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'l7_proto':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'resp_cc':
	                        case 'server_cc':
	                        case 'orig_cc':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'ioc_severity':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'resp_asn_name':
	                        case 'orig_asn_name':
	                        case 'server_asn_name':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'file_size':
	                        case 'size':
	                        case 'bytes_orig':
	                        case 'bytes_resp':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'subdomain_breakdown':
	                        case 'breakdown':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'ioc_count':
	                            var tdTxt = '';
	                            tdTxt += '<section ng-if="(row.value.ioc_count > 0) && checkSev()">';
	                            if ($scope.columns[i].hasOwnProperty('link')) {
	                                tdTxt += '<a class="cellioccount" ng-click="::generateLink(row, ' + i + ')"> {{::row.value.ioc_count}} </a>';
	                            } else {
	                                tdTxt += '<div class="cellioccount"> {{::row.value.ioc_count}} </div>';
	                            }
	                            tdTxt += '</section>' + '<section ng-if="(row.value.ioc_count > 0) && !(checkSev())">' + '{{::row.value.ioc_count}}' + '</section>' + '<section ng-if="row.value.ioc_count == 0">' + '{{::row.value.ioc_count}}' + '</section>';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'orig_stealth':
	                        case 'resp_stealth':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'group':
	                            var tdTxt = '{{(row.value.' + $scope.columns[i].select + ' === "N/A" || row.value.' + $scope.columns[i].select + ' == 0) ?  "-" : row.value.' + $scope.columns[i].select + '}}';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'proxy_blocked':
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'Archive':
	                            // ioc notifications pages
	                            var tdTxt = '';
	                            tdTxt += '<button class="btnArchive2015" ng-click="::generateButton(\'Archive\', row)">Archive</button>';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'Restore':
	                            // ioc archive page
	                            var tdTxt = '';
	                            tdTxt += '<button class="btnRestore2015" ng-click="::generateButton(\'Restore\', row, \'/api/actions/restore\')">Restore</button>';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'Delete':
	                            // custom ioc pages
	                            var tdTxt = '';
	                            tdTxt += '<button class="btnArchive2015" ng-click="::generateButton(\'Delete\', row, \'' + $scope.columns[i].link.call + '\')">Delete</button>';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'Edit':
	                            // custom ioc pages
	                            var tdTxt = '';
	                            tdTxt += '<div ng-click="::generateButton(\'Edit\', row, \'' + $scope.columns[i].link.call + '\')" style="cursor:pointer" id="editServices"><svg height="30" width="70"><path transform="translate(0,6)" style="fill:#555555;" d="M15.3,16c0.6,0,1.2,0.1,1.7,0.4c0.7-0.8,1.2-1.8,1.6-2.8c-1.4-0.6-2.3-2-2.3-3.6c0-1.6,1-3,2.3-3.6c-0.4-1-0.9-2-1.6-2.8C16.5,3.9,15.9,4,15.3,4c-2.1,0-3.9-1.7-4-3.8C10.7,0.1,10,0,9.3,0s-1.4,0.1-2,0.2C7.2,2.3,5.5,4,3.3,4C2.7,4,2.1,3.9,1.6,3.6C0.9,4.4,0.4,5.4,0,6.4C1.4,7,2.3,8.4,2.3,10c0,1.6-1,3-2.3,3.6c0.4,1,0.9,2,1.6,2.8C2.1,16.1,2.7,16,3.3,16c2.1,0,3.9,1.7,4,3.8c0.7,0.1,1.3,0.2,2,0.2s1.4-0.1,2-0.2C11.4,17.7,13.2,16,15.3,16zM5.3,10c0-2.2,1.8-4,4-4s4,1.8,4,4c0,2.2-1.8,4-4,4S5.3,12.2,5.3,10z"/></path></svg></div>';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'custom_type': // custom_ioc page
	                        case 'custom_rule':
	                            // custom_ioc page
	                            var tdTxt = nakedColumnItems($scope.columns[i]);
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'ioc_alert':
	                            // custom_ioc page
	                            var tdTxt = '';
	                            tdTxt += '{{row.value.' + $scope.columns[i].select + ' == 0 ? "No" : "Yes"}}';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'active_defense':
	                            // custom_ioc page
	                            var tdTxt = '';
	                            tdTxt += '{{row.value.' + $scope.columns[i].select + ' ? "Yes" : "No"}}';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        case 'active':
	                            // ioc_feeds page
	                            var tdTxt = '';
	                            tdTxt += '<div class="checkBox-slider">';
	                            tdTxt += '<label ng-class="{\'greenLabel\': row.value.active}"><input type="checkbox" name="switch" id="switch" ng-model="row.value.active" ng-checked="row.value.active != 0" ng-true-value="1" ng-false-value="0" ng-click="::generateButton(\'active\', row, \'' + $scope.columns[i].link.call + '\')" /><span>&nbsp;</span></label>';
	                            tdTxt += '</div>';
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                        default:
	                            var tdTxt = '';
	                            if ($scope.columns[i].hasOwnProperty('link')) {
	                                tdTxt += '<a ng-click="::generateLink(row, ' + i + ')" class="isLink">{{::row.value.' + $scope.columns[i].select + '}}</a>';
	                            } else if (typeof $scope.columns[i].linkcheck !== 'undefined') {
	                                tdTxt += '<a ng-click="::checkLink(row, ' + i + ')" class="isLink">{{::row.value.' + $scope.columns[i].select + '}}</a>';
	                            } else {
	                                tdTxt += '{{row.value.' + $scope.columns[i].select + ' === "N/A" ?  "-" : row.value.' + $scope.columns[i].select + '}}';
	                            }
	                            cells += tdWrapper(tdTxt, $scope.columns[i]); // add tdTxt string to the cells string
	                            break;
	                    }
	                    ///////////////////////
	                    /// LINK MANAGEMENT ///
	                    ///////////////////////
	                    $scope.generateLink = function (data, columnIndex) {
	                        var searchObj = {},
	                            type;
	                        // add url date params to new page if they exist
	                        if ($location.$$search.start && $location.$$search.end) {
	                            searchObj.start = $location.$$search.start;
	                            searchObj.end = $location.$$search.end;
	                        }
	                        // loop through defined links to genereate search object
	                        if ($scope.columns[columnIndex].link.val.length > 0) {
	                            for (var i in $scope.columns[columnIndex].link.val) {
	                                searchObj[$scope.columns[columnIndex].link.val[i]] = data.value[$scope.columns[columnIndex].link.val[i]];
	                            }
	                        }
	                        if ($scope.main.dataObjects[identifiers.key].settings.columns[columnIndex].link.table_name) {
	                            searchObj["table_name"] = $scope.main.dataObjects[identifiers.key].settings.columns[columnIndex].link.table_name;
	                        }
	                        type = angular.copy($scope.columns[columnIndex].link.type);
	                        if (type === "search") {
	                            // IF SENDING TO SEARCH PAGE!
	                            var params = { include: [], time: null };
	                            var obj = { from: "", title: "", value: "" };
	                            for (var _c2 in $scope.columns) {
	                                if (searchObj[$scope.columns[_c2].select]) {
	                                    obj.from = $scope.columns[_c2].select;
	                                    obj.title = $scope.columns[_c2].title;
	                                    obj.value = searchObj[$scope.columns[_c2].select];
	                                    params.include.push(angular.copy(obj));
	                                }
	                            }
	                            if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
	                                params.time = {
	                                    start: $location.$$search.start,
	                                    end: $location.$$search.end
	                                };
	                            }
	                            $state.go('pages.main.search', params);
	                        } else {
	                            $scope.main.cleanup().then(function () {
	                                // finally hit page being requested with search params
	                                $location.path(type).search(searchObj);
	                            });
	                        }
	                    };
	                }
	
	                var html = '\n                <div id="contextMenu" class="clearfix" style="position:absolute;display:none">\n                    <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu" style="display:block; margin-bottom:5px">\n                        <li role="menuitem"><a ng-click="contextClicked(\'include\')">Include</a></li>\n                        <li role="menuitem"><a ng-click="contextClicked(\'exclude\')">Exclude</a></li>\n                        <li role="menuitem"><a ng-click="contextClicked(\'search\')">Instant Search</a></li>\n                        <li role="menuitem" ng-show="custom_ioc_click"><a ng-click="contextClicked(\'custom_ioc\')">Custom IOC</a></li>\n                        <li role="menuitem" ng-show="ioc_rule_click"><a ng-click="contextClicked(\'whitelist\')">Whitelist</a></li>\n                        <li role="menuitem" ng-show="virustotal_click"><a ng-click="contextClicked(\'virustotal\')">VirusTotal Search</a></li>\n                    </ul>\n                </div>\n                <button ng-click="generateCsv()" ng-show="main.dataObjects[\'' + identifiers.key + '\'].settings.columns" class="btnRaised2015" href="">Export</button>\n                <div class="title2015">{{main.dataObjects[\'' + identifiers.key + '\'].settings.title}} - {{timeFormat(page.loadStart, \'tableMinMax\')}} - {{timeFormat(page.loadEnd, \'tableMinMax\')}}\n                    <span class="complete" ng-show="page.complete && tableComplete">\n                        <svg fill="none" stroke="none" height="20" width="20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="-293 385 24 24" xml:space="preserve">\n                        <path fill="none" stroke="none" d="M-293,385h24v24h-24V385z"/>\n                        <path fill="#00A800" d="M-281,387c-5.5,0-10,4.5-10,10s4.5,10,10,10s10-4.5,10-10S-275.5,387-281,387z M-283,402l-5-5l1.4-1.4l3.6,3.6l7.6-7.6l1.4,1.4L-283,402z"/></svg>\n                    </span>\n                    <span class="complete">\n                        <div class="spinner-table spinner" us-spinner spinner-key="spinner-' + identifiers.id + '" spinner-theme="table" spinner-start-active="true"></div>\n                    </span>\n                    <div ng-click="toggleBytes()" class="toggleValue" ng-hide="main.dataObjects[\'' + identifiers.key + '\'].settings.hideToggleBytes">{{(!page.settings.get(\'toggleVal\')) ? \'B\' : page.settings.get(\'toggleVal\')}}</div>\n                </div>\n                <table id="sevTable">\n                    <th ng-repeat="col in columns" ng-click="sortCol(col.select)" ng-class="{ \'firstTitleINVALID\': $first }" class="tableTitles2015">\n                        <a>{{::col.title}}</a>\n                    </th>\n                    <tr ng-if="row.value != false && row.value.failed_ssl !== \'Self signed certificate\'" ng-repeat="row in main.dataObjects[\'' + identifiers.key + '\'].settings.data" ng-click="openRow(row, $event)">\n                        ' + cells + '\n                    </tr>\n                    <tr ng-if="row.value != false && row.value.failed_ssl === \'Self signed certificate\'" ng-repeat="row in main.dataObjects[\'' + identifiers.key + '\'].settings.data" ng-click="openRow(row, $event)" style="background-color: #f88b1220; font-weight: bold;">\n                        ' + cells + '\n                    </tr>\n                </table>\n                <div class="table-paginator-container">\n                    <div class="table-paginator">\n                        <span ng-click="prevPage()">< Previous </span>  |\n                        <span ng-click="setPage(1)" ng-class="{\'active\': (main.dataObjects[\'' + identifiers.key + '\'].settings.currentPage === 1)}" >1</span>\n                        <span class="dots" ng-show="main.dataObjects[\'' + identifiers.key + '\'].settings.currentPage > 4"> ... </span>\n                        <span ng-click="setPage(a)" class="middlePages" ng-class="{\'active\': (main.dataObjects[\'' + identifiers.key + '\'].settings.currentPage === a)}" ng-repeat="a in range(5)">{{a}}</span>\n                        <span class="dots" ng-show="(main.dataObjects[\'' + identifiers.key + '\'].settings.totalPages - main.dataObjects[\'' + identifiers.key + '\'].settings.currentPage) > 4"> ... </span>\n                        <span ng-click="setPage(main.dataObjects[\'' + identifiers.key + '\'].settings.totalPages)" ng-hide="(main.dataObjects[\'' + identifiers.key + '\'].settings.totalPages === 1)" ng-class="{\'active\': (main.dataObjects[\'' + identifiers.key + '\'].settings.currentPage === main.dataObjects[\'' + identifiers.key + '\'].settings.totalPages)}">{{main.dataObjects[\'' + identifiers.key + '\'].settings.totalPages}}</span> |\n                        <span ng-click="nextPage()"> Next ></span>\n                        <br/>\n                        Displaying Rows\n                        {{(((main.dataObjects[\'' + identifiers.key + '\'].settings.currentPage - 1) * getTableLimit())+1) || 0}}\n                        to {{(getMin((main.dataObjects[\'' + identifiers.key + '\'].settings.currentPage * getTableLimit()), main.dataObjects[\'' + identifiers.key + '\'].settings.dataSize)) || 0}}\n                        <span class="plain-text" ng-if="getTableLimit() < main.dataObjects[\'' + identifiers.key + '\'].settings.dataSize">out of {{(main.dataObjects[\'' + identifiers.key + '\'].settings.dataSize) || 0}} </span>\n                        <br/>\n                        Items per page <span ng-class="{\'active\': (getTableLimit() === 20)}" ng-click="changeItemsPerPage(20)">20</span> |\n                        <span ng-class="{\'active\': (getTableLimit() === 50)}" ng-click="changeItemsPerPage(50)">50</span> |\n                        <span ng-class="{\'active\': (getTableLimit() === 100)}" ng-click="changeItemsPerPage(100)">100</span> |\n                        <span ng-class="{\'active\': (getTableLimit() === 200)}" ng-click="changeItemsPerPage(200)">200</span>\n                    </div>\n                </div>\n                </div>'; // this div opens at the top of the link function
	                return elem.append($compile(html)($scope));
	            }
	            // on table init begin drawing columns
	            $scope.$on('table-build', function (event, identifiers) {
	                // empty the element on build
	                elem.empty();
	                // set data array length to zero, just in case there are loading errors
	                $scope.main.dataObjects[identifiers.key].settings.data = [];
	                return constructTable(identifiers);
	            });
	            $scope.$on('init', function (event, identifiers) {
	                if (identifiers.id !== attrs.uid) {
	                    return;
	                }
	                //////////////////////////
	                /////// PAGINATION ///////
	                //////////////////////////
	                // this resets the total counts of data and total pages.
	                (function setTotals() {
	                    // this runs after any filter is added or removed
	                    $scope.main.dataObjects[identifiers.key].settings.dataSize = $scope.main.dataObjects[identifiers.key].group.size();
	                    $scope.main.dataObjects[identifiers.key].settings.totalPages = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
	                })();
	                function asc() {
	                    var x = $scope.main.dataObjects[identifiers.key].settings.dataSize - $scope.main.dataObjects[identifiers.key].settings.currentPage * tableItemLimit;
	                    var y = $scope.main.dataObjects[identifiers.key].settings.dataSize - $scope.main.dataObjects[identifiers.key].settings.currentPage * tableItemLimit + tableItemLimit;
	                    // cant have a negative value in the first arg of a slice, so set any negatives to 0
	                    if (x < 0) {
	                        x = 0;
	                    }
	                    updateData(x, y);
	                }
	                function desc() {
	                    updateData(($scope.main.dataObjects[identifiers.key].settings.currentPage - 1) * tableItemLimit, $scope.main.dataObjects[identifiers.key].settings.currentPage * tableItemLimit);
	                }
	
	                var generateTableRows = function generateTableRows(start, end) {
	                    return function () {
	                        return $scope.main.dataObjects[identifiers.key].group.order(function (p) {
	                            if (_.isArray($scope.main.dataObjects[identifiers.key].settings.sort.col)) {
	                                var arr = $scope.main.dataObjects[identifiers.key].settings.sort.col.map(function (i) {
	                                    var result = p[i];
	                                    if (i === "breakdown" || i === "subdomain_breakdown") {
	                                        // need to convert all to number because search page is raw table => strings
	                                        result = Number(Number(p.bytes_orig) / (Number(p.bytes_orig) + Number(p.bytes_resp)));
	                                        if (Number(p.bytes_orig) === 0 && Number(p.bytes_resp) === 0) {
	                                            result = Number(0.5);
	                                        }
	                                    } else {
	                                        if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('columnSpec')) {
	                                            if ($scope.main.dataObjects[identifiers.key].settings.columnSpec[i] === 0) {
	                                                result = Number(p[i]);
	                                            } else {
	                                                result = p[i];
	                                            }
	                                        }
	                                    }
	                                    return result;
	                                });
	                                return arr;
	                            } else {
	                                var result = p[$scope.main.dataObjects[identifiers.key].settings.sort.col];
	                                if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('columnSpec')) {
	                                    if ($scope.main.dataObjects[identifiers.key].settings.columnSpec[$scope.main.dataObjects[identifiers.key].settings.sort.col] === 0) {
	                                        result = Number(p[$scope.main.dataObjects[identifiers.key].settings.sort.col]);
	                                    } else {
	                                        result = p[$scope.main.dataObjects[identifiers.key].settings.sort.col];
	                                    }
	                                }
	                                return result;
	                            }
	                        }).top(Infinity).filter(function (obj) {
	                            if (obj.value.visible === true) {
	                                return true;
	                            }
	                        }).slice(start, end);
	                    }();
	                };
	                function updateData(start, end) {
	                    if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
	                        $scope.main.dataObjects[identifiers.key].settings.data = generateTableRows(start, end);
	                    } else {
	                        $scope.main.dataObjects[identifiers.key].settings.data = generateTableRows(start, end).reverse();
	                    }
	                }
	
	                $scope.setPage = function (pageNumber) {
	                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage !== pageNumber) {
	                        $scope.main.dataObjects[identifiers.key].settings.currentPage = pageNumber;
	                        if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
	                            desc();
	                        } else {
	                            asc();
	                        }
	                    }
	                };
	                $scope.range = function (n) {
	                    var arr = [];
	                    var diff = 0;
	                    if (!$scope.main.dataObjects[identifiers.key]) {
	                        return;
	                    }
	                    if (typeof $scope.main.dataObjects[identifiers.key].settings === 'undefined') {
	                        return;
	                    }
	                    if ($scope.main.dataObjects[identifiers.key].settings === null) {
	                        return;
	                    }
	                    var min = $scope.main.dataObjects[identifiers.key].settings.currentPage - 2;
	                    var max = $scope.main.dataObjects[identifiers.key].settings.currentPage + 2;
	
	                    if (min < 2) {
	                        diff = 2 - min;
	                        min = 2;
	                        max += diff;
	                        if (max > $scope.main.dataObjects[identifiers.key].settings.totalPages - 1) {
	                            max = $scope.main.dataObjects[identifiers.key].settings.totalPages - 1;
	                        }
	                    }
	                    if (max > $scope.main.dataObjects[identifiers.key].settings.totalPages) {
	                        diff = max - $scope.main.dataObjects[identifiers.key].settings.totalPages - 1;
	                        max = $scope.main.dataObjects[identifiers.key].settings.totalPages - 1;
	                        min -= diff + 1;
	                        if (min < 2) {
	                            min = 2;
	                        }
	                    }
	                    for (var i = min; i <= max; i++) {
	                        arr.push(i);
	                    }
	                    return arr;
	                };
	                $scope.changeItemsPerPage = function (number) {
	                    tableItemLimit = number;
	                    if (tableItemLimit === 20) {
	                        $scope.page.settings.set('tableItemLimit', false);
	                    } else {
	                        $scope.page.settings.set('tableItemLimit', tableItemLimit);
	                    }
	                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage > Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit)) {
	                        $scope.main.dataObjects[identifiers.key].settings.dataSize = $scope.main.dataObjects[identifiers.key].group.size();
	                        $scope.main.dataObjects[identifiers.key].settings.currentPage = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
	                    }
	                    $scope.main.dataObjects[identifiers.key].settings.totalPages = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
	                    if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
	                        desc();
	                    } else {
	                        asc();
	                    }
	                };
	                $scope.getMin = function (val1, val2) {
	                    return Math.min(val1, val2);
	                };
	                $scope.getTableLimit = function () {
	                    return tableItemLimit;
	                };
	                $scope.nextPage = function () {
	                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage !== $scope.main.dataObjects[identifiers.key].settings.totalPages) {
	                        $scope.main.dataObjects[identifiers.key].settings.currentPage++;
	                        if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
	                            desc();
	                        } else {
	                            asc();
	                        }
	                    }
	                };
	                $scope.prevPage = function () {
	                    if ($scope.main.dataObjects[identifiers.key].settings.currentPage !== 1) {
	                        $scope.main.dataObjects[identifiers.key].settings.currentPage--;
	                        if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
	                            desc();
	                        } else {
	                            asc();
	                        }
	                    }
	                };
	                // change filter direction and fire slicing function
	                $scope.sortCol = function (col) {
	                    $scope.main.dataObjects[identifiers.key].settings.render = { once: true, has: true
	                        // set the default sort value which is just a string with the column select
	                    };$scope.main.dataObjects[identifiers.key].settings.sort.col = col;
	                    // append time to the col IF:
	                    // - the clicked column isn't time
	                    // - time exists as a possible column
	                    if (col !== 'time') {
	                        // if clicked item is not time
	                        var timeExists = false; // assume time doesn't exist in the table
	                        $scope.main.dataObjects[identifiers.key].settings.columns.forEach(function (d) {
	                            if (d.select === 'time') {
	                                timeExists = true;
	                            }
	                        });
	                        // if we've found time in the table settings
	                        if (timeExists) {
	                            if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('columnSpec')) {
	                                // BUT only append time to sort if the column contains only numbers
	                                if (!_.isNumber($scope.main.dataObjects[identifiers.key].settings.columnSpec[col]) || col === 'ioc_severity') // NOTE: we want the time to be grouped on ioc severity, because it comes in as a nuimber
	                                    $scope.main.dataObjects[identifiers.key].settings.sort.col = [col, 'time']; // sort becomes an array with time in it
	                            }
	                        }
	                    }
	                    if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
	                        $scope.main.dataObjects[identifiers.key].settings.sort.direction = '+';
	                        asc();
	                    } else {
	                        $scope.main.dataObjects[identifiers.key].settings.sort.direction = '-';
	                        desc();
	                    }
	                };
	
	                //////////////////////////////
	                //////  TABLE BUTTONS   //////
	                //////////////////////////////
	                $scope.generateButton = function (type, data, call) {
	                    switch (type) {
	                        case 'active':
	                            $scope.page.toggleActive(data.value);
	                            break;
	                        case 'Delete':
	                            $scope.page.deleteTarget(data.value);
	                            break;
	                        case 'Edit':
	                            $scope.page.editTarget(call, data.value);
	                            break;
	                    }
	                };
	
	                ////////////////////////////////////////
	                /////// RIGHT CLICK CONTEXT MENU ///////
	                ////////////////////////////////////////
	                var $contextMenu = $("#contextMenu");
	                $scope.rightClicked = function (elm, data, row) {
	                    $contextMenu = $("#contextMenu");
	                    if (!$scope.main.dataObjects[identifiers.key].settings.searchCategories.hasOwnProperty(data.key)) {
	                        return;
	                    }
	                    $scope.virustotal_click = false;
	                    if (virustotal_list.indexOf(data.key) > -1) {
	                        if (row.value.ioc_type.toLowerCase().indexOf("domain") > -1) {
	                            $scope.virustotal_click = true;
	                        }
	                    }
	                    $scope.ioc_rule_click = false;
	                    if (whitelist_list.indexOf(data.key) > -1) {
	                        $scope.ioc_rule_click = true;
	                    }
	                    $scope.custom_ioc_click = false;
	                    if (custom_ioc_list.indexOf(data.key) > -1) {
	                        $scope.custom_ioc_click = true;
	                    }
	                    $contextMenu.css({
	                        display: "block",
	                        left: elm.pageX,
	                        top: elm.pageY
	                    });
	                    $scope.contextClicked = function (inex) {
	                        switch (inex) {
	                            case 'include':
	                                $scope.main.filterItem(data.key, data.value, 'include', data.title);
	                                break;
	                            case 'exclude':
	                                $scope.main.filterItem(data.key, data.value, 'exclude', data.title);
	                                break;
	                            case 'virustotal':
	                                // if (row.value.ioc_type.toLowerCase().indexOf("domain") > -1) {
	                                var win = window.open('https://www.virustotal.com/latest-scan/http://' + data.value, '_blank'); // opens new tab
	                                win.focus();
	                                // }
	                                break;
	                            case 'search':
	                            case 'custom_ioc':
	                            case 'whitelist':
	                                var params = {
	                                    include: [{
	                                        from: data.key,
	                                        title: data.title,
	                                        value: data.value
	                                    }],
	                                    time: null
	                                };
	                                if ($location.$$search.hasOwnProperty('start') && $location.$$search.hasOwnProperty('end')) {
	                                    params.time = {
	                                        start: $location.$$search.start,
	                                        end: $location.$$search.end
	                                    };
	                                }
	                                $state.go('pages.main.' + inex, params);
	                                break;
	                        }
	                    };
	                };
	                // close context menu on any click
	                $(document).on("click", function () {
	                    $contextMenu.hide();
	                });
	
	                /////////////////////////////
	                /////// CSV EXPORTING ///////
	                /////////////////////////////
	                $scope.generateCsv = function () {
	                    var csv = "",
	                        csvArray = [];
	                    //2d array sort for sorting data for csv print
	                    var sortFunction = function sortFunction(a, b) {
	                        var tableSort;
	                        if ($scope.sortIndex) {
	                            tableSort = [[$scope.sortIndex, $scope.sortDir]];
	                        } else {
	                            tableSort = $scope.data.table.settings.params.sort; //default
	                        }
	                        var index = tableSort.col;
	                        var direction = tableSort.direction;
	                        if (a[index] === b[index]) {
	                            return 0;
	                        } else {
	                            if (direction == "asc") {
	                                return a[index] < b[index] ? -1 : 1;
	                            } else {
	                                return a[index] > b[index] ? -1 : 1;
	                            }
	                        }
	                    };
	                    var download = function download(strData, strFileName, strMimeType) {
	                        var D = document,
	                            a = D.createElement("a");
	                        strMimeType = strMimeType;
	
	                        if (navigator.msSaveBlob) {
	                            // IE10
	                            return navigator.msSaveBlob(new Blob([strData], { type: strMimeType }), strFileName);
	                        }
	
	                        if ('download' in a) {
	                            //html5 A[download]
	                            var csvData = new Blob([strData], { type: strMimeType });
	                            var csvUrl = URL.createObjectURL(csvData);
	                            a.href = csvUrl;
	                            a.setAttribute("download", strFileName);
	                            a.innerHTML = "downloading...";
	                            D.body.appendChild(a);
	                            setTimeout(function () {
	                                a.click();
	                                D.body.removeChild(a);
	                            }, 66);
	                            return true;
	                        }
	
	                        //do iframe dataURL download (old ch+FF):
	                        var f = D.createElement("iframe");
	                        D.body.appendChild(f);
	                        f.src = "data:" + strMimeType + "," + encodeURIComponent(strData);
	                        setTimeout(function () {
	                            D.body.removeChild(f);
	                        }, 333);
	                        return true;
	                    };
	                    var dim = $scope.main.dataObjects[identifiers.key].dimension.top(Infinity);
	                    var col = $scope.main.dataObjects[identifiers.key].settings.columns;
	                    // Remove duplicated rows from the CSV
	                    // This is called here because it hasn't been found the reason why are the rows being duplicated
	                    dim = _.uniqWith(dim, _.isEqual);
	                    for (var c in col) {
	                        csv += '"' + col[c].title + '"' + ",";
	                    }
	                    csv += '\n';
	                    // csvArray.push(csvRow);
	                    // csvArray.push(" ");
	                    for (var i in dim) {
	                        for (var _c3 in col) {
	                            if (col[_c3].select === "time") {
	                                csv += '"' + timeFormat(dim[i][col[_c3].select], 'tables') + '"' + ",";
	                            } else {
	                                csv += '"' + dim[i][col[_c3].select] + '"' + ",";
	                            }
	                        }
	                        csv += '\n';
	                        // csvArray.push(csvRow);
	                    }
	                    var fileName = $location.path().replace("/", "");
	                    fileName += "_" + $scope.main.dataObjects[identifiers.key].settings.title;
	                    //create the download
	                    download(csv, fileName + "_CSV.csv", "text/csv");
	                };
	
	                ////////////////////////////////////
	                /////// BYTE TOGGLE SETTINGS ///////
	                ////////////////////////////////////
	                $scope.toggleBytes = function () {
	                    var toggle = void 0;
	                    if ($scope.page.settings.get('toggleVal') === "KB") {
	                        toggle = "MB";
	                        $scope.togVal = 1048576;
	                        $scope.byteOffset = 1;
	                    } else if ($scope.page.settings.get('toggleVal') === "MB") {
	                        toggle = false;
	                        $scope.togVal = 1;
	                        $scope.byteOffset = 7;
	                    } else {
	                        toggle = "KB";
	                        $scope.togVal = 1024;
	                        $scope.byteOffset = 2.5;
	                    }
	                    // update settings
	                    $scope.page.settings.set('toggleVal', toggle).then(function () {
	                        for (var m in $scope.main.dataObjects) {
	                            if (!$scope.main.dataObjects[m].launched) {
	                                continue;
	                            }
	                            // if (!$scope.main.dataObjects[m].settings.refresh) { continue }
	                            if ($scope.main.dataObjects[m].settings.get.call === "table") {
	                                continue;
	                            }
	                            $scope.$broadcast('updatedData', $scope.main.dataObjects[m].settings.id);
	                        }
	                    });
	                };
	                // set variables and init functions
	                $scope.main.dataObjects[identifiers.key].settings.currentPage = 1; // set current page
	                if ($scope.main.dataObjects[identifiers.key].settings.sort.direction === '-') {
	                    updateData(0, tableItemLimit); // just load the first values by default, no need to run the extra desc function
	                } else {
	                    asc();
	                }
	
	                ///////////////////////////////////////////
	                /////// VERTICAL TABLE POPUP CONFIG ///////
	                ///////////////////////////////////////////
	                $scope.openRow = function (row, el) {
	                    var clickedElem = el.target;
	                    if (clickedElem.tagName.toLowerCase() !== 'td') {
	                        return;
	                    }
	                    var model = this;
	                    model.editMode = false; // edit mode is false by default
	                    // this is a variable checking if ANY change was made while tables were open,
	                    // so we can use it later to potential saving
	                    var edited = false;
	                    var refrenceOrder = '';
	                    angular.copy($scope.columns).map(function (c) {
	                        refrenceOrder += c.select;
	                    });
	                    // sortable settings
	                    model.tableItemsConfig = {
	                        // group: 'foobar',
	                        animation: 150,
	                        onSort: function onSort(event) {
	                            model.makeChange(event.models);
	                        }
	                        // limit the row information to what is defined in the table columns spec (in the page controller)
	                        // add prefix for search mode so we can customize different tables
	                    };var prefix = '';
	                    if ($state.current.name === 'pages.main.search') {
	                        prefix = angular.copy($scope.main.currentMode); // add mode to table prefix
	                    }
	                    var cc = $scope.page.settings.get(prefix + 'table-columnConfig');
	                    model.info = [];
	                    if (cc) {
	                        // make title dictionary
	                        for (var l = 0, len = cc.length; l < len; l++) {
	                            var item = {};
	                            var key = Object.keys(cc[l])[0];
	                            // skip if the saved item isnt in the table config anymore
	                            if (key !== "breakdown" || key !== "subdomain_breakdown") {
	                                if (!row.value.hasOwnProperty(key)) {
	                                    continue;
	                                }
	                                if (!columnRefrence.hasOwnProperty(key)) {
	                                    continue;
	                                }
	                            }
	                            item.select = key;
	                            item.title = columnRefrence[key].title;
	                            item.value = row.value[key];
	                            item.active = cc[l][key];
	                            model.info.push(item);
	                        }
	                    } else {
	                        // IF COLUMNS ARE NOT DEFINED
	                        for (var c = 0, _len3 = $scope.main.dataObjects[identifiers.key].settings.columns.length; c < _len3; c++) {
	                            // extra safety to make sure the data we're asking for is actually in the row
	                            if (row.value.hasOwnProperty($scope.main.dataObjects[identifiers.key].settings.columns[c].select) || $scope.main.dataObjects[identifiers.key].settings.columns[c].select === "breakdown" || $scope.main.dataObjects[identifiers.key].settings.columns[c].select === "subdomain_breakdown") {
	                                (function () {
	                                    var item = {};
	                                    item.title = $scope.main.dataObjects[identifiers.key].settings.columns[c].title;
	                                    item.select = $scope.main.dataObjects[identifiers.key].settings.columns[c].select;
	                                    item.value = row.value[$scope.main.dataObjects[identifiers.key].settings.columns[c].select];
	                                    // check to see if the column is active
	                                    item.active = false;
	                                    $scope.columns.forEach(function (col) {
	                                        if (col.select === item.select) {
	                                            // mark active true if a matching item is found in $scope.columns (to get currently active)
	                                            item.active = true;
	                                        }
	                                    });
	                                    model.info.push(item);
	                                })();
	                            }
	                        }
	                    }
	                    // makeChange compares and sets $scope.columns according to any changes that have been made
	                    model.makeChange = function (list) {
	                        var listString = '';
	                        var arr = [];
	                        list.forEach(function (l) {
	                            if (l.active === true) {
	                                listString += l.select;
	                                arr.push(l);
	                            }
	                        });
	                        if (refrenceOrder !== listString) {
	                            edited = true;
	                        } else {
	                            edited = false;
	                        }
	                    };
	                    model.startEdit = function () {
	                        $scope.main.safeApply(function () {
	                            // the safe apply makes sure angular always sees the change
	                            model.editMode = true;
	                        });
	                    };
	                    model.doneEdit = function () {
	                        $scope.tableComplete = false;
	                        usSpinnerService.spin();
	                        model.editMode = false;
	                        if (edited) {
	                            var editedList = angular.copy(model.info);
	                            var settingsToSave = [];
	                            // reset the refrence order to the current settings
	                            refrenceOrder = '';
	                            editedList.forEach(function (l) {
	                                if (l.active) {
	                                    refrenceOrder += l.select;
	                                }
	                                // push to our save array in case we do save it below
	                                var obj = {};
	                                obj[l.select] = l.active;
	                                settingsToSave.push(obj);
	                            });
	                            // check original controller settings to see if we need to save new settings or just remove old ones
	                            var controllerColumnOrder = '';
	                            for (var _c4 = 0, _len4 = $scope.main.dataObjects[identifiers.key].settings.columns.length; _c4 < _len4; _c4++) {
	                                if ($scope.main.dataObjects[identifiers.key].settings.columns[_c4].dView) {
	                                    controllerColumnOrder += $scope.main.dataObjects[identifiers.key].settings.columns[_c4].select;
	                                }
	                            }
	                            var redrawTable = function redrawTable() {
	                                // empty the element on build
	                                elem.empty();
	                                constructTable(identifiers);
	                            };
	                            // add prefix for search mode so we can customize different tables
	                            var _prefix = '';
	                            if ($state.current.name === 'pages.main.search') {
	                                _prefix = angular.copy($scope.main.currentMode); // add mode to table prefix
	                            }
	                            if (controllerColumnOrder === refrenceOrder) {
	                                // remove the settings if the refrence matches our controller settings
	                                $scope.page.settings.set(_prefix + 'table-columnConfig', false).then(function () {
	                                    redrawTable();
	                                });
	                            } else {
	                                $scope.page.settings.set(_prefix + 'table-columnConfig', settingsToSave).then(function () {
	                                    redrawTable();
	                                    var spinner = document.getElementsByClassName('spinner-table spinner')[0];
	                                    if (spinner) {
	                                        usSpinnerService.stop();
	                                        $scope.tableComplete = true;
	                                    }
	                                });
	                            }
	                            // remove the edited status
	                            edited = false;
	                        }
	                    };
	
	                    // create string that the modal compiler will loop through on open to determine
	                    // what div rows should be drawn on compile
	                    var normalValueString = '',
	                        editValueString = '';
	                    model.info.forEach(function (item, index) {
	                        normalValueString += '<div class="span8" style="overflow-wrap: break-word" ng-if="(i.select == \'' + item.select + '\')">' + nakedColumnItems(item, item.value) + '</div>';
	                        editValueString += '<div class="span8" style="overflow-wrap: break-word" ng-if="(i.select == \'' + item.select + '\')">' + nakedColumnItems(item, item.value) + '</div>';
	                    });
	                    var template = '\n                        <div class="tableModal">\n                            <div class="tableContainer">\n                                <div class="tableHeader">\n                                    <a ng-click="startEdit()" ng-if="!editMode"> <i class="fa fa-cog"></i></a>\n                                    <a ng-click="doneEdit()" ng-if="editMode">Done <i class="fa fa-check"></i></a>\n                                </div>\n                                <div ng-if="editMode">\n                                    <li class="row-fluid title-row">\n                                        <div class="span1 drag-handle">Reorder</div>\n                                        <div class="span2">Title</div>\n                                        <div class="span8">Value</div>\n                                        <div class="span1 column-toggle">Display</div>\n                                    </li>\n                                    <ul ng-sortable="tableItemsConfig" class="table-items">\n                                        <li class="row-fluid" ng-repeat="i in info">\n                                            <div style="cursor: pointer" class="span1 drag-handle">\u2630</div>\n                                            <div class="span2">{{::i.title}}</div>\n                                            ' + editValueString + '\n                                            <div class="span1 column-toggle">\n                                                <div class="checkBox-slider">\n                                                    <input type="checkbox" name="switch" class="switch" ng-model="i.active" ng-checked="i.active" />\n                                                    <label for="switch" class="label"></label>\n                                                    <label ng-class="{\'greenLabel\': i.active}"><input type="checkbox" name="switch" id="switch" ng-model="i.active" ng-change="makeChange(info)" ng-checked="i.active" /><span>&nbsp;</span></label>\n                                                </div>\n                                            </div>\n                                        </li>\n                                    </ul>\n                                </div>\n                                <!-- NON EDIT MODE -->\n                                <div ng-show="!editMode">\n                                    <li class="row-fluid title-row">\n                                        <div class="span3">Title</div>\n                                        <div class="span9">Value</div>\n                                    </li>\n                                    <ul class="table-items">\n                                        <li class="row-fluid" ng-repeat="i in info">\n                                            <div class="span3">{{::i.title}}</div>\n                                            ' + normalValueString + '\n                                            <div class="span1"><i ng-show="!i.active" alt="Column not displayed in table on page." class="fa fa-eye-slash"></i></div>\n                                        </li>\n                                    </ul>\n                                </div>\n                            </div>\n                        </div>\n                    ';
	                    ngDialog.open({
	                        template: template,
	                        plain: true,
	                        appendTo: '.page-content',
	                        scope: model,
	                        preCloseCallback: function preCloseCallback() {
	                            // use the doneEdit function since it already checks for changes
	                            //model.doneEdit();
	                        }
	                    });
	                };
	
	                ////////////////////////////////
	                /////// UPDATE FUNCTIONS ///////
	                ////////////////////////////////
	                $scope.$on('updatedData', function (event, id, skipGroupRedraw) {
	                    if (id !== identifiers.id) {
	                        return;
	                    } // only run when it sees its id has filtered
	                    if (typeof skipGroupRedraw === 'undefined') {
	                        // rerun grouping
	                        $scope.main.dataObjects[identifiers.key].group = $scope.main.dataObjects[identifiers.key].settings.group($scope.main.dataObjects[identifiers.key].dimension);
	                    }
	                    if ((typeof skipGroupRedraw === 'undefined' ? 'undefined' : _typeof(skipGroupRedraw)) === "object") {
	                        $scope.main.dataObjects[identifiers.key].group = $scope.main.dataObjects[identifiers.key].settings.group($scope.main.dataObjects[identifiers.key].dimension);
	                        if (skipGroupRedraw.complete) {
	                            $scope.page.complete = true;
	                        }
	                    }
	                    $scope.main.dataObjects[identifiers.key].settings.dataSize = 50;
	                    // this is set to stop any redaw of the rows if there is no reduce happening
	                    var redrawRows = true;
	                    // set the angular data array
	                    $scope.main.safeApply(function () {
	                        // skip reduce/redraw on anything with grouping of only 'id'
	                        if ($scope.main.dataObjects[identifiers.key].settings.hasOwnProperty('render')) {
	                            if ($scope.main.dataObjects[identifiers.key].settings.data.length === tableItemLimit) {
	                                if ($scope.main.dataObjects[identifiers.key].settings.render.once && $scope.main.dataObjects[identifiers.key].settings.render.has === false) {
	                                    $scope.main.dataObjects[identifiers.key].settings.render.has = true;
	                                } else {
	                                    redrawRows = false;
	                                }
	                            }
	                        }
	                        if (redrawRows) {
	                            $scope.main.dataObjects[identifiers.key].settings.data = generateTableRows(0, tableItemLimit);
	                        }
	                        // update total data size
	                        $scope.main.dataObjects[identifiers.key].settings.dataSize = $scope.main.dataObjects[identifiers.key].group.all().filter(function (obj) {
	                            if (obj.value.visible === true) {
	                                return true;
	                            }
	                        }).length;
	                        $scope.main.dataObjects[identifiers.key].settings.totalPages = Math.ceil($scope.main.dataObjects[identifiers.key].settings.dataSize / tableItemLimit);
	                    });
	                    // append style to each of the td's with dropdowns a class
	                });
	            });
	        }
	    };
	}
	
	directive.$inject = ['$compile', '$location', '$http', '$state', 'getData', '$interval', '$window', 'ngDialog', 'timeFormat', 'usSpinnerService'];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function directive() {
	    return {
	        template: __webpack_require__(861),
	        scope: true,
	        replace: true,
	        controllerAs: 'searchtable',
	        link: function link($scope, element) {}
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;

/***/ },
/* 861 */
/***/ function(module, exports) {

	module.exports = "<div>\n    <div>\n        <h4>Tables</h4>\n    </div>\n    <ul>\n        <li ng-hide=\"((item.doneLoading) && (item.count === 0))\" ng-repeat=\"item in page.sidebarItems | orderBy: -item.title\" ng-class=\"main.currentMode == item.select ? 'selectedSearchMode' : ''\">\n            <a ng-click=\"page.changeTable(item.select)\"> {{item.title}}</a>\n        </li>\n    </ul>\n</div>";

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('makeTreeChart', __webpack_require__(863));
	};

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	function directive() {
	    return {
	        link: function link($scope, element) {
	            $scope.$on('treeChart', function (event, root, params) {
	                var width = $("#treechart").parent().width(),
	                    height = params["height"];
	                var duration = 750,
	                    circleRadius = 4.5;
	
	                var cluster = d3.layout.cluster().size([height, width - 230]);
	
	                var nodeColor = function nodeColor(severity) {
	                    switch (severity) {
	                        case 1:
	                            return "#377FC7";
	                            break;
	                        case 2:
	                            return "#F5D800";
	                            break;
	                        case 3:
	                            return "#F88B12";
	                            break;
	                        case 4:
	                            return "#DD122A";
	                            break;
	                        default:
	                            return "#377FC7";
	                    }
	                };
	
	                // toggle children on click.
	                function click(d) {
	                    if (d.children) {
	                        d._children = d.children;
	                        d.children = null;
	                    } else {
	                        d.children = d._children;
	                        d._children = null;
	                    }
	                    update(d);
	                }
	
	                var diagonal = d3.svg.diagonal().projection(function (d) {
	                    return [d.y, d.x];
	                });
	
	                var svgOutter = d3.select("#treechart").append("svg").attr("width", width).attr("height", height);
	                var svg = svgOutter.append("g").attr("transform", "translate(90,0)");
	
	                function update(source) {
	                    var divHeight;
	                    var nodes = cluster.nodes(root),
	                        links = cluster.links(nodes);
	
	                    var lastNode = 0;
	                    for (var n in nodes) {
	                        if (typeof nodes[n].children === "undefined") {
	                            lastNode++;
	                        }
	                    }
	
	                    if (lastNode >= 35) {
	                        divHeight = lastNode * 12;
	                    } else {
	                        divHeight = 420;
	                    }
	                    cluster.size([divHeight, width - 230]);
	
	                    nodes = cluster.nodes(root);
	                    links = cluster.links(nodes);
	
	                    var node = svg.selectAll(".conn").data(nodes, function (d, i) {
	                        return d.idd || (d.idd = ++i);
	                    });
	
	                    var nodeEnter = node.enter().append("g").attr("class", "conn").attr("transform", function (d) {
	                        return "translate(" + d.y + "," + d.x + ")";
	                    }).on("click", click);
	
	                    nodeEnter.append("circle").attr("fill", function (d) {
	                        return nodeColor(d.severity);
	                    }).attr("stroke", "#000").attr("stroke-width", "0.7px").attr("r", circleRadius);
	
	                    nodeEnter.append("text").attr("dx", function (d) {
	                        return d.children ? -8 : 8;
	                    }).attr("dy", 3).attr("font-weight", function (d) {
	                        return d.idRoute ? "bold" : 400;
	                    }).style("text-anchor", function (d) {
	                        return d.children ? "end" : "start";
	                    }).text(function (d) {
	                        return d.name;
	                    });
	
	                    // transition nodes to their new position.
	                    var nodeUpdate = node.transition().duration(duration).attr("transform", function (d) {
	                        return "translate(" + d.y + "," + d.x + ")";
	                    });
	
	                    nodeUpdate.select("circle").attr("fill", function (d) {
	                        return nodeColor(d.severity);
	                    }).attr("stroke", "#000").attr("stroke-width", "0.7px").attr("r", circleRadius);
	
	                    nodeUpdate.select("text").style("fill-opacity", 1);
	
	                    // transition exiting nodes to the parent's new position.
	                    var nodeExit = node.exit().transition().duration(duration).attr("transform", function () {
	                        return "translate(" + source.y + "," + source.x + ")";
	                    }).remove();
	
	                    nodeExit.select("circle").attr("fill", function (d) {
	                        return nodeColor(d.severity);
	                    }).attr("stroke", "#000").attr("stroke-width", "0.7px").attr("r", circleRadius);
	
	                    nodeExit.select("text").style("fill-opacity", "1");
	
	                    // update the links…
	                    var link = svg.selectAll(".conn_link").data(links, function (d) {
	                        return d.target.idd;
	                    });
	
	                    // enter any new links at the parent's previous position.
	                    link.enter().insert("path", "g").attr("d", diagonal).attr("class", "conn_link").attr("stroke-width", "1px");
	
	                    // transition links to their new position.
	                    link.transition().duration(duration).attr("stroke-width", "1px").attr("d", diagonal);
	
	                    // transition exiting nodes to the parent's new position.
	                    link.exit().transition().duration(duration).attr("d", function () {
	                        var o = {
	                            x: source.x,
	                            y: source.y
	                        };
	                        return diagonal({
	                            source: o,
	                            target: o
	                        });
	                    }).remove();
	
	                    // stash the old positions for transition.
	                    nodes.forEach(function (d) {
	                        d.x0 = d.x;
	                        d.y0 = d.y;
	                    });
	                    $scope.$broadcast('adjustHeight', divHeight);
	                }
	
	                // root.children.forEach(collapse);
	                update(root);
	                d3.select(self.frameElement).style("height", height + "px");
	
	                $scope.$on('adjustHeight', function (event, newHeight) {
	                    svgOutter.attr("height", height).transition().duration(duration).attr("height", newHeight);
	                    d3.select(self.frameElement).style("height", height + "px").transition().duration(duration).style("height", newHeight + "px");
	                    height = newHeight;
	                });
	
	                $scope.$on('$destroy', function () {
	                    element.remove();
	                });
	            });
	        }
	    };
	}
	
	directive.$inject = [];
	module.exports = directive;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(457)))

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('ngRightClick', __webpack_require__(865));
	};

/***/ },
/* 865 */
/***/ function(module, exports) {

	'use strict';
	
	function directive($parse) {
	    return function (scope, element, attrs) {
	        var fn = $parse(attrs.ngRightClick);
	        element.bind('contextmenu', function (event) {
	            scope.$apply(function () {
	                event.preventDefault();
	                fn(scope, { $event: event });
	            });
	        });
	    };
	}
	
	directive.$inject = ['$parse'];
	module.exports = directive;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // routes
	    __webpack_require__(867)(ngModule);
	    // controllers
	    __webpack_require__(874)(ngModule);
	};

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.config(__webpack_require__(868));
	};

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($stateProvider) {
	    $stateProvider.state('auth.login', {
	        url: '/login',
	        template: __webpack_require__(869),
	        controller: 'LoginCtrl',
	        controllerAs: 'login'
	    }).state('auth.twoStep', {
	        url: '/2step',
	        template: __webpack_require__(871),
	        controller: 'twoStep',
	        controllerAs: 'twostep'
	    }).state('auth.setpassword', {
	        url: '/setpass',
	        template: __webpack_require__(872),
	        controller: 'setPassword',
	        controllerAs: 'setpassword'
	    }).state('auth.forgot', {
	        url: '/forgot-pass',
	        template: __webpack_require__(873),
	        controller: 'forgotPass',
	        controllerAs: 'forgotpass'
	    });
	}
	
	ctrl.$inject = ['$stateProvider'];
	module.exports = ctrl;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"logo\">\n    <img src=\"" + __webpack_require__(870) + "\" alt=\"\"/>\n</div>\n<div class=\"content\">\n    <div id=\"login_form_body\">\n        <div class=\"LoginCtrl\">\n            <div class=\"alert alert-danger animated fadeIn\" ng-show=\"login.loginerror\">{{login.loginerror}}</div>\n            <form ng-submit=\"login.login()\" class=\"login-form\">\n                <div class=\"control-group\">\n                    <label class=\"control-label visible-ie8 visible-ie9\">Email</label>\n                    <div class=\"controls\">\n                        <div class=\"input-icon left\">\n                            <i class=\"fa fa-user\"></i>\n                            <input required id=\"email\" type=\"email\" name=\"email\" placeholder=\"Email\" class=\"m-wrap placeholder-no-fix\" ng-model=\"login.user.email\" autofocus=\"autofocus\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"control-group\">\n                    <label class=\"control-label visible-ie8 visible-ie9\">Password</label>\n                    <div class=\"controls\">\n                        <div class=\"input-icon left\">\n                            <i class=\"fa fa-lock\"></i>\n                             <input required id=\"password\" type=\"password\" name=\"password\" placeholder=\"Password\" class=\"m-wrap placeholder-no-fixcommon/auth\" ng-model=\"login.user.password\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"control-group\">\n                    <input class=\"btnLogin2015\" type=\"submit\" name=\"action\" value=\"Login\" id=\"login_button\"/>\n                </div>\n                <div><a ng-href=\"/forgot-pass\"> Forgot Password? </a></div>\n            </form>\n        </div>\n    </div>\n    <div class=\"copyright\">\n        <section copyright></section>\n    </div>\n</div>\n";

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c4e811dc81687327f0eeed4962851f74.png";

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"logo\">\n    <img src=\"" + __webpack_require__(870) + "\" alt=\"\"/>\n</div>\n<div class=\"content\">\n    <div id=\"login_form_body\">\n        <h1 style=\"color:#888888\">Login</h1>\n        <div class=\"twoStepCtrl\">\n            <div class=\"alert alert-danger animated fadeIn\" ng-show=\"twostep.loginerror\">{{twostep.loginerror}}</div>\n            <form ng-submit=\"twostep.login()\" class=\"login-form\">\n                <div class=\"control-group\">\n                    <label class=\"control-label visible-ie8 visible-ie9\">6-Digit Code (for two step authentication)</label>\n                    <div class=\"controls\">\n                        <div class=\"input-icon left twoFa\">\n                            <i class=\"fa fa-clock-o\"></i>\n                             <input required id=\"twostep\" name=\"twostep\" placeholder=\"6-Digit Code\" class=\"m-wrap placeholder-no-fix\" ng-minlength=\"6\" ng-maxlength=\"6\" ng-model=\"twostep.user.twoStepCode\" autofocus=\"autofocus\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"control-group center-item\">\n                    <input class=\"btnLogin2015\" type=\"submit\" name=\"action\" value=\"Login\" id=\"login_button\" />\n                <br/></div>\n            </form>\n        </div>\n    </div>\n    <div class=\"copyright\">\n        <section copyright></section>\n    </div>\n</div>\n";

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"logo\">\n    <img src=\"" + __webpack_require__(870) + "\" alt=\"\"/>\n</div>\n<div class=\"content\">\n    <div id=\"login_form_body\">\n        <h2 style=\"color:#888888\">Set password</h2>\n        <div class=\"setPassword\">\n            <div class=\"alert alert-danger animated fadeIn\" ng-show=\"setpassword.passworderror\">{{setpassword.passworderror}}</div>\n            <form name=\"passwordForm\" ng-submit=\"setpassword.setpass(passwordForm, user)\" class=\"password-form\">\n                <div class=\"control-group\">\n                    <div class=\"controls\">\n                        <div class=\"input-icon left\">\n                            <i class=\"fa fa-clock-o\"></i>\n                             <input required type=\"password\" id=\"password\" name=\"password\" placeholder=\"New password\" class=\"m-wrap placeholder-no-fix\" ng-minlength=\"10\" ng-model=\"setpassword.user.password1\" autofocus/>\n                        </div>\n                        <span ng-show=\"passwordForm.password.$error.minlength\" style=\"color: #00ba53\"> Please enter at least 10 characters</span>\n                        <br />\n                        <div class=\"input-icon left\">\n                            <i class=\"fa fa-clock-o\"></i>\n                             <input required type=\"password\" id=\"password2\" name=\"password2\" placeholder=\"Repeat new password\" class=\"m-wrap placeholder-no-fix\" ng-minlength=\"10\" ng-model=\"setpassword.user.password2\"/>\n                        </div>\n                        <span ng-show=\"passwordForm.password2.$error.minlength\" style=\"color: #00ba53\"> Please enter at least 10 characters</span>\n                    </div>\n                </div>\n                <div class=\"control-group center-item\">\n                    <input class=\"btnLogin2015\" type=\"submit\" name=\"action\" value=\"Submit\" id=\"login_button\" ng-disabled=\"passwordForm.disableSubmit\"/>\n                <br/></div>\n            </form>\n        </div>\n    </div>\n    <div class=\"copyright\">\n        <section copyright></section>\n    </div>\n</div>\n";

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"logo\">\n    <img src=\"" + __webpack_require__(870) + "\" alt=\"\"/>\n</div>\n<div class=\"content\">\n    <div id=\"login_form_body\">\n        <h2 style=\"color:#888888\">Forgot password?</h2>\n        <div class=\"setPassword\">\n            <div class=\"alert alert-danger animated fadeIn\" ng-show=\"forgotpass.emailresponse\">{{forgotpass.emailresponse}}</div>\n            <form name=\"emailForm\" ng-submit=\"forgotpass.email(emailForm, user)\" class=\"email-form\">\n                <div class=\"control-group\">\n                    <div class=\"controls\">\n                        <div class=\"input-icon left\">\n                            <i class=\"fa fa-envelope-o\"></i>\n                             <input required type=\"email\" id=\"email\" name=\"email\" placeholder=\"Enter your email\" class=\"m-wrap placeholder-no-fix\" ng-minlength=\"8\" ng-model=\"forgotpass.user.email\" autofocus=\"autofocus\"/>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"control-group center-item\">\n                    <input ng-disabled=\"forgotpass.disableSubmit\" class=\"btnLogin2015\" type=\"submit\" name=\"action\" value=\"Submit\" id=\"login_button\" />\n                <br/></div>\n            </form>\n        </div>\n    </div>\n    <div class=\"copyright\">\n        <section copyright></section>\n    </div>\n</div>\n";

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('LoginCtrl', __webpack_require__(875));
	    ngModule.controller('twoStep', __webpack_require__(876));
	    ngModule.controller('setPassword', __webpack_require__(877));
	    ngModule.controller('forgotPass', __webpack_require__(878));
	};

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, $http, $location, $window, $resource) {
	    var model = this;
	    // This object will be filled by the form
	    model.user = {};
	    // delete any tokens upon visit
	    delete $window.sessionStorage.token;
	    model.login = function () {
	        $http.post(("https://api-demo.mantix4.com") + '/auth/auth', model.user).success(function (user) {
	            $window.sessionStorage.token = user.token;
	            if (user.twoAuth) {
	                $location.url('/2step');
	            } else {
	                $location.url('/live');
	            }
	        }).error(function (err) {
	            console.log(err);
	            model.loginerror = 'Error: Invalid user or password';
	            // Erase the token if the user fails to log in
	            delete $window.sessionStorage.token;
	        });
	    };
	}
	
	ctrl.$inject = ['$scope', '$http', '$location', '$window', '$resource'];
	module.exports = ctrl;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, $http, $location, $window) {
	    var model = this;
	    var tries = 0,
	        maxtries = 3;
	    model.login = function () {
	        if (typeof model.user === 'undefined') {
	            return;
	        }
	        if (model.user.twoStepCode) {
	            //Validate if code is number
	            if (isNaN(model.user.twoStepCode)) {
	                model.loginerror = "Code is not a number.";return;
	            }
	            model.loginerror = false;
	            $http.post(("https://api-demo.mantix4.com") + '/auth/2factor/verify', model.user).success(function (user) {
	                // assign new token (by replacing old one)
	                $window.sessionStorage.token = user.token;
	                $location.url('/live');
	            }).error(function () {
	                tries++;
	                if (tries === maxtries) {
	                    delete $window.sessionStorage.token;
	                    $location.url('/login');
	                } else {
	                    model.loginerror = "Wrong passcode, please try again";
	                }
	            });
	        }
	    };
	}
	
	ctrl.$inject = ['$scope', '$http', '$location', '$window'];
	module.exports = ctrl;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, $http, $location, $window) {
	    var model = this;
	    model.user = {};
	    model.submitSetPass = false;
	    // get reset token on load
	    $http.post(("https://api-demo.mantix4.com") + '/auth/setpass', { key: $location.$$search.key }).success(function (token) {
	        $window.sessionStorage.token = token; // token is now set to the setPassWordToken
	        model.setpass = function (form, user) {
	            $http.post(("https://api-demo.mantix4.com") + '/auth/pass/setpass', {
	                key: $location.$$search.key,
	                password1: model.user.password1,
	                password2: model.user.password2
	            }).success(function () {
	                // redirect to login
	                model.disableSubmit = true;
	                $location.url('/login');
	            }).error(function (error) {
	                model.disableSubmit = false;
	                model.passworderror = 'Error setting password. ' + error.message;
	            });
	        };
	    }).error(function (err) {
	        console.log(err);
	        // redirect to login
	        $location.url('/login');
	    });
	}
	
	ctrl.$inject = ['$scope', '$http', '$location', '$window'];
	module.exports = ctrl;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($scope, $http, $location, $window, $timeout) {
	    var model = this;
	    // delete any user token on page visit
	    delete $window.sessionStorage.token;
	    // set up user scope object
	    model.user = {};
	    model.email = function (form, user) {
	        if (form.$valid) {
	            $http.post(("https://api-demo.mantix4.com") + '/auth/forgotpass', { email: model.user.email }).success(function (user) {
	                model.disableSubmit = true;
	                model.emailresponse = 'Reset link sent to ' + model.user.email + '. Redirecting in 10 seconds.';
	                model.tt = $timeout(function () {
	                    $location.url('/login');
	                }, 10000, true);
	                $scope.$on('$destroy', function () {
	                    $timeout.cancel(model.tt);
	                });
	            });
	        } else {
	            model.disableSubmit = false;
	            model.emailresponse = 'Email not valid.';
	        }
	    };
	}
	
	ctrl.$inject = ['$scope', '$http', '$location', '$window', '$timeout'];
	module.exports = ctrl;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // routes
	    __webpack_require__(880)(ngModule);
	    // controllers
	    __webpack_require__(883)(ngModule);
	    __webpack_require__(885)(ngModule);
	    __webpack_require__(903)(ngModule);
	};

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.config(__webpack_require__(881));
	};

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function ctrl($stateProvider) {
	    $stateProvider.state('landing.dash', {
	        views: {
	            "": {
	                template: __webpack_require__(882),
	                controller: 'live',
	                controllerAs: 'page'
	            },
	            "header": {
	                template: __webpack_require__(568),
	                controller: 'HeaderController',
	                controllerAs: 'header'
	            }
	        }
	    }).state('landing.dash.live', {
	        url: '/live',
	        // controllerAs: 'page',
	        data: {
	            title: 'Live Connections Dash',
	            daterange: false
	        }
	    });
	}
	
	ctrl.$inject = ['$stateProvider'];
	module.exports = ctrl;

/***/ },
/* 882 */
/***/ function(module, exports) {

	module.exports = "<div id=\"dashboard-container\" class=\"container\">\n    <fullscreen class=\"fullscreen-btn\" [select]=\"'dashboard-container'\"></fullscreen>\n    <div class=\"left\">\n        <dashboard></dashboard>\n    </div>\n</div>";

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('live', __webpack_require__(884));
	};

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	function ctrl($scope, Global, $location, timeFormat, fetchStream, socketIo, settings, $http, $window) {
	    $scope.global = Global;
	    this.api = ("https://api-demo.mantix4.com");
	}
	ctrl.$inject = ['$scope', 'Global', '$location', 'timeFormat', 'fetchStream', 'socketIo', 'settings', '$http', '$window'];
	module.exports = ctrl;


/***/ },
/* 885 */
[1589, 886],
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function () {
	    __webpack_require__(887);
	};

/***/ },
/* 887 */
[1590, 888],
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, "@font-face{font-family:Open Sans;src:url(" + __webpack_require__(889) + ")}@font-face{font-family:ITCAvantGardeStd-Bk;src:url(" + __webpack_require__(890) + ");src:url(" + __webpack_require__(891) + ") format(\"woff\"),url(" + __webpack_require__(892) + ") format(\"truetype\"),url(" + __webpack_require__(893) + ") format(\"svg\")}@font-face{font-family:ITCAvantGardeStd-Bold;src:url(" + __webpack_require__(894) + ");src:url(" + __webpack_require__(895) + ") format(\"woff\"),url(" + __webpack_require__(896) + ") format(\"truetype\"),url(" + __webpack_require__(897) + ") format(\"svg\")}@font-face{font-family:roboto-reg;src:url(" + __webpack_require__(898) + ")}@font-face{font-family:roboto-light;src:url(" + __webpack_require__(899) + ")}@font-face{font-family:roboto-medium;src:url(" + __webpack_require__(900) + ")}@font-face{font-family:roboto-bold;src:url(" + __webpack_require__(901) + ")}@font-face{font-family:roboto-reg-cond;src:url(" + __webpack_require__(902) + ")}.dashboard-container{float:none;background:#e8f6fe;width:auto;overflow:hidden}.dashboard-container .fullscreen-btn button{margin:74px 0 0 13px}.dashboard-container path.countries{fill:#000;fill-opacity:0}.dashboard-container .globe-container{position:fixed;bottom:0;right:0;width:300px;height:335px;line-height:30px;background:none}.dashboard-container .globe-container .toggles{float:left;width:100%;height:30px;margin-bottom:5px}.dashboard-container .globe-container .toggles div{background-color:#ccc;float:left;width:33.3%;line-height:25px;text-align:center;cursor:pointer}.dashboard-container .globe-container .toggles div:hover{background-color:#ddd}.dashboard-container .globe-container .toggles .all.active{background-color:#79cc2e}.dashboard-container .globe-container .toggles .inbound.active{background-color:#ff5d2a}.dashboard-container .globe-container .toggles .outbound.active{background-color:#3459ff}.dashboard-container .globe-container .toggles .active{color:#fff}.dashboard-container .globe-container span.config{position:absolute;margin-top:270px;float:right;margin-right:20px;margin-left:270px;font-size:20px;color:#ccc;cursor:pointer}.dashboard-container .container{margin-top:40px;height:auto;overflow:hidden}.dashboard-container .container:-webkit-full-screen{margin:0;width:100%;height:100%}.dashboard-container .site:hover{cursor:pointer}.dashboard-container .card-container{position:fixed;z-index:999;background:#fafafa;right:10px;top:55px;width:300px;height:auto;max-height:550px;border-radius:4px;padding:10px 0 35px;line-height:18px;box-shadow:0 0 5px 0 rgba(0,0,0,.75)}.dashboard-container .card-container:-webkit-full-screen{top:0}.dashboard-container .card-container .topbanner{padding:0 15px;min-height:40px;height:auto;width:275px;font-family:roboto-reg}.dashboard-container .card-container .topbanner p.sitename{margin:0;padding:0;text-align:left;font-size:1.5rem;position:relative;display:inline-block;line-height:40px;height:40px;width:210px;transform:translateY(-5px)}.dashboard-container .card-container .topbanner button{min-width:24px;min-height:24px;height:24px;margin:3px 0 0 5px;text-align:top;vertical-align:top;opacity:.8;float:right;outline:none}.dashboard-container .card-container .topbanner button:hover{opacity:1}.dashboard-container .card-container .row1{display:inline-block}.dashboard-container .card-container .leftCol{float:left;width:80px;padding-right:10px;margin-top:15px;font-family:roboto-reg-cond}.dashboard-container .card-container .leftCol p{text-align:right;color:#ababab}.dashboard-container .card-container .rightCol{float:right;width:190px;margin-top:15px;padding-right:20px;font-family:roboto-reg}.dashboard-container .card-container .rightCol p{text-align:left}.dashboard-container .card-container .inspectBttn{position:absolute;height:38px;width:300px;bottom:0;background-color:#79cc2e;font-family:roboto-light}.dashboard-container .card-container .inspectBttn p{font-size:1rem;text-align:center;position:relative;top:11px;margin:0;color:#000}.dashboard-container .card-container .inspectBttn:hover{background-color:#93db25;cursor:pointer}.dashboard-container .card-container .sensorname,.dashboard-container .card-container .sensorstatus{font-size:1.4rem;position:relative;transform:translateY(-3px)}.dashboard-container .card-container .sensorstatus{color:green}.dashboard-container .card-container .sensorstatus.red{color:red}.dashboard-container .card-container input{width:170px;height:17px}.dashboard-container .card-container button{margin:0;float:right;background:none;padding:0;box-shadow:none}.dashboard-container .card-container form textarea{border-radius:4px;max-width:185px;width:185px}.dashboard-container .legend-container{padding:10px;z-index:999;width:auto;bottom:0;position:fixed;background-color:#000;color:#d3d3d3}.dashboard-container .legend-container .legend div{float:left}.dashboard-container .legend-container .legend .circle{width:10px;height:10px;border-radius:5px;top:14px;position:relative}.dashboard-container .legend-container .legend .circle.outbound{background-color:#3459ff}.dashboard-container .legend-container .legend .circle.inbound{background-color:#ff5d2a}.dashboard-container .legend-container .legend .circle.lateral{background-color:#aa37b2}.dashboard-container .legend-container .legend .circle.all{background-color:#79cc2e}.dashboard-container .legend-container .legend .title{padding-left:10px;font-family:roboto-bold;color:#686868}.dashboard-container .legend-container .legend p{padding:10px 16px 10px 6px;margin:0}.dashboard-container .legend-image{background-color:#000;position:fixed;top:0;left:0;z-index:997;padding:12px 12px 12px 55px}", ""]);
	
	// exports


/***/ },
/* 889 */
369,
/* 890 */
370,
/* 891 */
371,
/* 892 */
372,
/* 893 */
373,
/* 894 */
374,
/* 895 */
375,
/* 896 */
376,
/* 897 */
377,
/* 898 */
378,
/* 899 */
379,
/* 900 */
380,
/* 901 */
381,
/* 902 */
382,
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var upgrade_adapter_1 = __webpack_require__(1);
	var dashboard_component_1 = __webpack_require__(904);
	var fullscreen_component_ts_1 = __webpack_require__(941);
	module.exports = function (ngModule) {
	    ngModule.directive('dashboard', upgrade_adapter_1.upgradeAdapter.downgradeNg2Component(dashboard_component_1.Dashboard));
	    ngModule.directive('fullscreen', upgrade_adapter_1.upgradeAdapter.downgradeNg2Component(fullscreen_component_ts_1.Fullscreen));
	};


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(io) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	var http_1 = __webpack_require__(905);
	var Observable_1 = __webpack_require__(37);
	var Subject_1 = __webpack_require__(36);
	var dashboard_main_component_1 = __webpack_require__(926);
	var dashboard_card_component_1 = __webpack_require__(938);
	var Dashboard = (function () {
	    function Dashboard(http, window, document, global, io) {
	        this.http = http;
	        this.window = window;
	        this.document = document;
	        this.global = global;
	        this.io = io;
	        this.currentSite = false;
	        // for now we'll pass the children an event emitter for when the client changes
	        // so they can cresubscribe to the streams
	        this.newStream = new Subject_1.Subject();
	    }
	    /////////////////////
	    // LIFESTYLE HOOKS //
	    /////////////////////
	    Dashboard.prototype.ngOnInit = function () {
	        var _this = this;
	        this.connectSocket();
	        // get sockets
	        this.socket.on('sites', function (sites) {
	            _this.sites = sites;
	        });
	    };
	    Dashboard.prototype.ngOnDestroy = function () {
	        if (this.socket) {
	            this.socket.off("disconnect");
	            this.socket.disconnect();
	        }
	        this.newStream.complete();
	    };
	    /////////////
	    // METHODS //
	    /////////////
	    // set current site for card to access
	    Dashboard.prototype.setCurrentSite = function (event) {
	        this.currentSite = event.site;
	        // this.newStream.complete();
	    };
	    Dashboard.prototype.fullscreenEnabled = function () {
	        try {
	            // FF provides nice flag, maybe others will add support for this later on?
	            if (this.window['fullScreen'] !== undefined) {
	                return this.window.fullScreen;
	            }
	            else if (this.document.fullscreenElement) {
	                return true;
	            }
	            else if (this.document.webkitFullscreenElement) {
	                return true;
	            }
	            else if (this.document.mozFullScreenElement) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	        catch (error) {
	            console.log(error);
	            console.log(error.stack);
	            console.log('Unable to check full screen mode.');
	            return false;
	        }
	    };
	    Dashboard.prototype.connectSocket = function () {
	        var self = this;
	        var WebSockets = {
	            isConnected: false,
	            interval: null,
	            connect: function () {
	                var _this = this;
	                self.socket = self.io.connect(self.global.api + '/api/landing/live', {
	                    secure: true,
	                    query: 'token=' + self.window.sessionStorage.token,
	                    forceNew: true,
	                    reconnection: false
	                });
	                self.socket.on('connect', function () {
	                    _this.isConnected = true;
	                });
	                self.socket.on('disconnect', function () {
	                    _this.isConnected = false;
	                    _this.interval = setInterval(function () {
	                        if (_this.isConnected) {
	                            clearInterval(_this.interval);
	                            _this.interval = null;
	                            return;
	                        }
	                        location.reload();
	                    }, 10000);
	                });
	            }
	        };
	        // Setup streams, skip when the window is not in view
	        this.inboundStream = self.incoming("inbound");
	        this.outboundStream = self.incoming("outbound");
	        this.lateralStream = self.incoming("lateral");
	        WebSockets.connect();
	    };
	    Dashboard.prototype.incoming = function (id) {
	        var _this = this;
	        var observable = new Observable_1.Observable(function (observer) {
	            _this.socket.on(id, function (data) {
	                observer.next(data);
	            });
	            // dispose the stream when the socket disconnects
	            _this.socket.on("disconnect", function () {
	                observer.complete();
	            });
	            // Return way to unsubscribe
	            return function () {
	                _this.socket.close();
	            };
	        });
	        return observable;
	    };
	    Dashboard.prototype.createAuthHeader = function (headers) {
	        headers.append('Authorization', 'Bearer ' + this.window.sessionStorage.token);
	    };
	    Dashboard.prototype.changeSite = function (sites) {
	        var _this = this;
	        // for now the sites are arrays of arrays
	        // but because we can only do live conns on one site at a time
	        // we will just take the first record for now
	        var site = sites[0];
	        this.currentSite = site;
	        // set the 'current' site to the one selected (if its not the one already current)
	        // then update connection so the redis subscription change
	        if (this.global.user.settings_global.current.name !== site.site) {
	            var headers = new http_1.Headers();
	            this.createAuthHeader(headers);
	            return this.http.post(this.global.api + '/api/users/change_site', { info: site }, { headers: headers })
	                .subscribe(function (result) {
	                var body = JSON.parse(result._body);
	                delete _this.window.sessionStorage.token;
	                _this.window.sessionStorage.token = body.token;
	                _this.global.user.settings_global.current = body.current;
	                _this.socket.disconnect();
	                _this.connectSocket();
	                _this.newStream.next();
	            }, function (error) {
	                alert('Unable to switch site.');
	            });
	        }
	    };
	    Dashboard = __decorate([
	        core_1.Component({
	            selector: 'dashboard',
	            template: __webpack_require__(939),
	            // encapsulation: ViewEncapsulation.Native,
	            styles: [],
	            directives: [
	                dashboard_card_component_1.DashboardCardComponent,
	                dashboard_main_component_1.DashboardMainComponent
	            ],
	            providers: [
	                http_1.HTTP_PROVIDERS,
	                { provide: 'Window', useValue: window },
	                { provide: 'Document', useValue: document },
	                { provide: 'Io', useValue: io }
	            ]
	        }),
	        __param(1, core_1.Inject('Window')),
	        __param(2, core_1.Inject('Document')),
	        __param(3, core_1.Inject('Global')),
	        __param(4, core_1.Inject('Io')), 
	        __metadata('design:paramtypes', [http_1.Http, Object, Object, Object, Object])
	    ], Dashboard);
	    return Dashboard;
	}());
	exports.Dashboard = Dashboard;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(391)))

/***/ },
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	// child directives
	var map_directive_1 = __webpack_require__(927);
	var globe_directive_1 = __webpack_require__(929);
	var DashboardMainComponent = (function () {
	    function DashboardMainComponent(window, document, d3, zone) {
	        this.window = window;
	        this.document = document;
	        this.d3 = d3;
	        this.zone = zone;
	        // listen for window visible events
	        this.visiblilityChanges = new core_1.EventEmitter();
	        this.windowIsHidden = false;
	        // site changing events
	        this.currentSiteIs = new core_1.EventEmitter();
	        this.changeSite = new core_1.EventEmitter();
	        this.modeChanged = new core_1.EventEmitter();
	        // timer helpers
	        this.currentTime = Date.now();
	        this.timerActive = true;
	    }
	    // note: this is tied to an observable so we can debounce the returns properly
	    DashboardMainComponent.prototype.onVisibilityChange = function (event) {
	        this.visiblilityChanges.next(event);
	    };
	    /////////////////////
	    // LIFESTYLE HOOKS //
	    /////////////////////
	    DashboardMainComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        // run the requestAnimationFrameSequence outside of angular
	        this.zone.runOutsideAngular(function () {
	            _this.window.requestAnimationFrame(_this.animate.bind(_this));
	        });
	        // check to see if the window is being viewed when the event fires
	        this.visiblilityChanges
	            .debounceTime(200)
	            .subscribe(function (event) {
	            _this.windowIsHidden = _this.isHiddenCheck();
	        });
	    };
	    DashboardMainComponent.prototype.ngOnDestroy = function () {
	        this.timerActive = false;
	    };
	    /////////////
	    // METHODS //
	    /////////////
	    DashboardMainComponent.prototype.easeInOutCubic = function (t, b, c, d) {
	        return c * ((t = t / d - 1) * t * t + 1) + b;
	    };
	    DashboardMainComponent.prototype.animate = function () {
	        if (!this.timerActive) {
	            return;
	        }
	        if (!this.windowIsHidden) {
	            // set up time stuff
	            var time = this.window.Date.now();
	            var diff = time - this.currentTime;
	            var t = diff / 1000;
	            t = (t > 1) ? 1 : t;
	            // clear canvas
	            this.map.context.clearRect(0, 0, this.map.width, this.map.height);
	            // since animations are put into the array in cronological order,
	            // we'll keep a drop count handy to wipe-left
	            var cDrop = 0;
	            for (var i = 0, len = this.map.animationsArray.length; i < len; i++) {
	                // set start time if its new to the queue (before assigning it to a variable)
	                if (this.map.animationsArray[i].start === 0) {
	                    this.map.animationsArray[i].start = time;
	                }
	                // remove any items who's elapsed is time past the duration
	                var item = this.map.animationsArray[i];
	                var timePassed = time - item.start;
	                // don't continue if timePassed is greater than duration and remove from array
	                if (timePassed >= item.duration) {
	                    cDrop++;
	                    var eObj = {
	                        radius: {
	                            start: 2,
	                            end: 40
	                        },
	                        opacity: 0.8,
	                        duration: 3500,
	                        start: time,
	                        color: item.color,
	                        x: item.x.end,
	                        y: item.y.end
	                    };
	                    this.map.addExplosion(eObj);
	                    continue;
	                }
	                var ct = timePassed / item.duration;
	                var cx = item.x.start + (ct * item.x.distance);
	                var cy = item.y.start + (ct * item.y.distance);
	                this.map.context.fillStyle = "rgba(" + item.color + ", 0.8)";
	                this.map.context.save();
	                this.map.context.translate(cx, cy);
	                this.map.context.rotate(item.rotation);
	                var scale = (ct < item.tmax) ? item.scale(ct) : 1;
	                this.map.context.scale(scale, scale);
	                this.map.context.beginPath();
	                this.map.context.moveTo(118, 3.1);
	                this.map.context.bezierCurveTo(100.4, 3.1, 42.9, 5, 3.5, 5);
	                this.map.context.bezierCurveTo(2.1, 5, 1, 4.1, 1, 3);
	                this.map.context.bezierCurveTo(1, 1.9000000000000004, 2.1, 1, 3.5, 1);
	                this.map.context.bezierCurveTo(43.9, 1, 100.5, 2.9, 118, 2.9);
	                this.map.context.lineTo(118, 3.1);
	                this.map.context.closePath();
	                this.map.context.fill();
	                this.map.context.restore();
	            }
	            // iterate and cDrop items that are expired
	            this.map.removeAnimations(cDrop);
	            var eDrop = 0;
	            // MAP EXPLODING CIRCLES
	            for (var e = 0, len = this.map.explosionsArray.length; e < len; e++) {
	                if (this.map.explosionsArray[e].start === 0) {
	                    this.map.explosionsArray[e].start = time;
	                }
	                var item = this.map.explosionsArray[e];
	                var timePassed = time - item.start;
	                var et = timePassed / item.duration;
	                // mark for deletion and stop if the item has reached its destination
	                if (timePassed >= item.duration) {
	                    eDrop++;
	                    continue;
	                }
	                // begin drawing connection
	                this.map.context.beginPath();
	                this.map.context.arc(item.x, item.y, this.easeInOutCubic(timePassed, 10, 40, item.duration), 0, 2 * this.window.Math.PI);
	                this.map.context.fillStyle = "rgba(" + item.color + ", " + this.easeInOutCubic(timePassed, item.opacity, -item.opacity, item.duration), +")";
	                this.map.context.fill();
	            }
	            this.map.removeExplosions(eDrop);
	            // GLOBE
	            // rotation
	            if (this.globe.isInactive) {
	                var dt = time - this.globe.rt;
	                // get the new position from modified projection function
	                this.globe.projection.rotate([this.globe.rotate[0] + this.globe.velocity[0] * dt, this.globe.rotate[1] + this.globe.velocity[1] * dt]);
	            }
	            // clear globe box
	            this.globe.context.clearRect(0, 0, this.globe.box.width, this.globe.box.height);
	            var radius = this.globe.radius < 1 ? 1 : this.globe.radius;
	            // add background circle for globe
	            this.globe.context.beginPath();
	            this.globe.context.arc(this.globe.box.width / 2, this.globe.box.height / 2, radius + 4, 0, 2 * this.window.Math.PI, true);
	            this.globe.context.fillStyle = this.globe.backgroundColor;
	            this.globe.context.fill();
	            this.globe.context.closePath();
	            // set colors
	            this.globe.context.fillStyle = this.globe.foregroundColor;
	            this.globe.context.strokeStyle = this.globe.strokeColor;
	            this.globe.context.beginPath();
	            this.globe.path(this.globe.land);
	            this.globe.context.fill();
	            // loop through active countries and color them
	            for (var h = 0, len = this.globe.heatmapArray.length; h < len; h++) {
	                this.globe.context.beginPath();
	                this.globe.context.fillStyle = this.r2h(this.interpolateColor(this.globe.heatmapArray[h].colors.start, this.globe.heatmapArray[h].colors.end, t));
	                this.globe.path(this.globe.heatmapArray[h].path);
	                this.globe.context.fill();
	                this.globe.context.closePath();
	            }
	            // globe constant was tweaked from window width that the circle on the globe
	            // roughly matches the viewport in the Leaflet map.
	            // Compute the size of the current viewport on the globe.
	            // Draws from formula found at
	            // http://wiki.openstreetmap.org/wiki/Zoom_levels
	            var currentViewRadius = this.globe.windowWidth * this.globe.box.height * this.globe.cosLat / (this.window.Math.pow(2, this.globe.zoom + 8));
	            // Stop the code from crashing with transient states that happen on page load.
	            currentViewRadius = currentViewRadius < 1 ? 1 : currentViewRadius;
	            this.globe.context.beginPath();
	            this.globe.context.arc(this.globe.box.width / 2, this.globe.box.height / 2, radius + 4, 0, 2 * this.window.Math.PI, true);
	            this.globe.context.lineWidth = 2.5;
	            this.globe.context.stroke();
	            // globe makes the circle invert whatever color is underneath it.
	            if (!this.globe.isInactive && (currentViewRadius < (this.globe.box.width / 2))) {
	                this.globe.context.save();
	                this.globe.context.globalCompositeOperation = "difference";
	                this.globe.context.strokeStyle = "white";
	                // Draw the circle that represents the current zoom and pan.
	                this.globe.context.beginPath();
	                this.globe.context.arc(this.globe.box.width / 2, this.globe.box.height / 2, currentViewRadius, 0, 2 * this.window.Math.PI, true);
	                this.globe.context.lineWidth = 2.5;
	                this.globe.context.stroke();
	                // globe is the inverse of this.globe.context.save(), it pops off the this.globe.context stack so
	                // we get back whatever the previous value was for
	                // globalCompositeOperation.
	                this.globe.context.restore();
	            }
	            // DATA handling stuff here
	            if (t === 1) {
	                this.currentTime = time;
	                this.globe.processData();
	                // check if globe is inactive
	                this.globe.checkInactive();
	            }
	        }
	        if (this.timerActive)
	            this.window.requestAnimationFrame(this.animate.bind(this));
	    };
	    DashboardMainComponent.prototype.h2r = function (hex) {
	        // Converts a #ffffff hex string into an [r,g,b] array
	        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	        return result ? [
	            this.window.parseInt(result[1], 16),
	            this.window.parseInt(result[2], 16),
	            this.window.parseInt(result[3], 16)
	        ] : null;
	    };
	    DashboardMainComponent.prototype.r2h = function (rgb) {
	        // Inverse of the above
	        return "#" + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
	    };
	    DashboardMainComponent.prototype.interpolateColor = function (color1, color2, factor) {
	        // Interpolates two [r,g,b] colors and returns an [r,g,b] of the result
	        color1 = this.h2r(color1);
	        color2 = this.h2r(color2);
	        if (arguments.length < 3) {
	            factor = 0.5;
	        }
	        var result = color1.slice();
	        for (var i = 0; i < 3; i++) {
	            result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));
	        }
	        return result;
	    };
	    // check to see if the page is hidden so we dont waste cpu resources
	    DashboardMainComponent.prototype.getHiddenProperites = function () {
	        var prefixes = ['webkit', 'moz', 'ms', 'o'];
	        // if 'hidden' is natively supported just return it
	        if ('hidden' in this.document)
	            return 'hidden';
	        // otherwise loop over all the known prefixes until we find one
	        for (var i = 0; i < prefixes.length; i++) {
	            if ((prefixes[i] + 'Hidden') in this.document)
	                return prefixes[i] + 'Hidden';
	        }
	        // otherwise it's not supported
	        return null;
	    };
	    DashboardMainComponent.prototype.isHiddenCheck = function () {
	        var prop = this.getHiddenProperites();
	        if (!prop)
	            return false;
	        return this.document[prop];
	    };
	    DashboardMainComponent.prototype.changeMode = function (newMode) {
	        this.mode = newMode.value;
	    };
	    __decorate([
	        core_1.ViewChild(map_directive_1.MapDirective), 
	        __metadata('design:type', map_directive_1.MapDirective)
	    ], DashboardMainComponent.prototype, "map", void 0);
	    __decorate([
	        core_1.ViewChild(globe_directive_1.GlobeDirective), 
	        __metadata('design:type', globe_directive_1.GlobeDirective)
	    ], DashboardMainComponent.prototype, "globe", void 0);
	    __decorate([
	        core_1.HostListener('window:visibilitychange', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], DashboardMainComponent.prototype, "onVisibilityChange", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "currentSiteIs", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "changeSite", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "newStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "parent", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "sites", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "fullscreenEnabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "inboundStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "outboundStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "lateralStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "mode", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], DashboardMainComponent.prototype, "modeChanged", void 0);
	    DashboardMainComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard-main',
	            template: "\n        <div map-container\n            [fullscreenEnabled]=\"fullscreenEnabled\"\n            [parent]=\"parent\"\n            [sites]=\"sites\"\n            [inboundStream]=\"inboundStream\"\n            [outboundStream]=\"outboundStream\"\n            [lateralStream]=\"lateralStream\"\n            [mode]=\"mode\"\n            [windowIsHidden]=\"windowIsHidden\"\n            (onMapDrag)=\"globe.onMapDrag($event)\"\n            (currentSiteIs)=\"currentSiteIs.emit($event)\"\n            (changeSite)=\"changeSite.emit($event)\"\n            [newStream]=\"newStream\"\n            class=\"map-container\"></div>\n        <div globe-container\n            [inboundStream]=\"inboundStream\"\n            [outboundStream]=\"outboundStream\"\n            [newStream]=\"newStream\"\n            [mode]=\"mode\"\n            [parent]=\"parent\"\n            (onGlobeDrag)=\"map.onGlobeDrag($event)\"\n            (modeChanged)=\"changeMode($event)\"\n            class=\"globe-container\">\n            <canvas></canvas>\n            <div class=\"toggles\">\n                <div (click)=\"globe.setGlobeMode('all')\" [ngClass]=\"{'active': ( globe.mode === 'all') }\" class=\"all\">\n                    All\n                </div>\n                <div (click)=\"globe.setGlobeMode('inbound')\" [ngClass]=\"{'active': ( globe.mode === 'inbound') }\" class=\"inbound\">\n                    Inbound\n                </div>\n                <div (click)=\"globe.setGlobeMode('outbound')\" [ngClass]=\"{'active': ( globe.mode === 'outbound') }\" class=\"outbound\">\n                    Outbound\n                </div>\n            </div>\n        </div>\n    ",
	            // encapsulation: ViewEncapsulation.Native,
	            styles: [
	                __webpack_require__(933)
	            ],
	            directives: [
	                map_directive_1.MapDirective,
	                globe_directive_1.GlobeDirective
	            ],
	            providers: [
	                { provide: 'D3', useValue: d3 }
	            ]
	        }),
	        __param(0, core_1.Inject('Window')),
	        __param(1, core_1.Inject('Document')),
	        __param(2, core_1.Inject('D3')), 
	        __metadata('design:paramtypes', [Object, Object, Object, core_1.NgZone])
	    ], DashboardMainComponent);
	    return DashboardMainComponent;
	}());
	exports.DashboardMainComponent = DashboardMainComponent;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	// add extra methods for the leaflet library
	// Generic  Canvas Overlay for leaflet BEFORE INPUT AS PROVIDER
	L.CanvasOverlay = L.Class.extend({
	    initialize: function (userDrawFunc, options) {
	        this._userDrawFunc = userDrawFunc;
	        L.setOptions(this, options);
	    },
	    drawing: function (userDrawFunc) {
	        this._userDrawFunc = userDrawFunc;
	        return this;
	    },
	    params: function (options) {
	        L.setOptions(this, options);
	        return this;
	    },
	    canvas: function () {
	        return this._canvas;
	    },
	    // redraw: function () {
	    //     if (!this._frame) {
	    //         this._frame = L.Util.requestAnimFrame(this._redraw, this);
	    //     }
	    //     return this;
	    // },
	    onAdd: function (map) {
	        this._map = map;
	        this._canvas = L.DomUtil.create('canvas', 'leaflet-heatmap-layer');
	        var size = this._map.getSize();
	        this._canvas.width = size.x;
	        this._canvas.height = size.y;
	        var animated = this._map.options.zoomAnimation && L.Browser.any3d;
	        L.DomUtil.addClass(this._canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'));
	        map._panes.overlayPane.appendChild(this._canvas);
	        map.on('moveend', this._reset, this);
	        map.on('resize', this._resize, this);
	        if (map.options.zoomAnimation && L.Browser.any3d) {
	            map.on('zoomanim', this._animateZoom, this);
	        }
	        this._reset();
	    },
	    onRemove: function (map) {
	        map.getPanes().overlayPane.removeChild(this._canvas);
	        map.off('moveend', this._reset, this);
	        map.off('resize', this._resize, this);
	        if (map.options.zoomAnimation) {
	            map.off('zoomanim', this._animateZoom, this);
	        }
	        // this_canvas = null;
	    },
	    addTo: function (map) {
	        map.addLayer(this);
	        return this;
	    },
	    _resize: function (resizeEvent) {
	        this._canvas.width = resizeEvent.newSize.x;
	        this._canvas.height = resizeEvent.newSize.y;
	    },
	    _reset: function () {
	        var topLeft = this._map.containerPointToLayerPoint([0, 0]);
	        L.DomUtil.setPosition(this._canvas, topLeft);
	        this._redraw();
	    },
	    _redraw: function () {
	        var size = this._map.getSize();
	        var bounds = this._map.getBounds();
	        var zoomScale = (size.x * 180) / (20037508.34 * (bounds.getEast() - bounds.getWest())); // resolution = 1/zoomScale
	        var zoom = this._map.getZoom();
	        // console.time('process');
	        if (this._userDrawFunc) {
	            this._userDrawFunc(this, {
	                canvas: this._canvas,
	                bounds: bounds,
	                size: size,
	                zoomScale: zoomScale,
	                zoom: zoom,
	                options: this.options
	            });
	        }
	        // console.timeEnd('process');
	        this._frame = null;
	    },
	    _animateZoom: function (e) {
	        var scale = this._map.getZoomScale(e.zoom), offset = this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos());
	        this._canvas.style[L.DomUtil.TRANSFORM] = L.DomUtil.getTranslateString(offset) + ' scale(' + scale + ')';
	    }
	});
	L.canvasOverlay = function (userDrawFunc, options) {
	    return new L.CanvasOverlay(userDrawFunc, options);
	};
	var MapDirective = (function () {
	    function MapDirective(el, renderer, leafletLib, window, document, d3, global) {
	        this.el = el;
	        this.renderer = renderer;
	        this.leafletLib = leafletLib;
	        this.window = window;
	        this.document = document;
	        this.d3 = d3;
	        this.global = global;
	        this.mapPaths = __webpack_require__(928);
	        this.center = [0, 0];
	        this.zoom = 3;
	        this.height = 0;
	        this.width = 0;
	        // data
	        this.animationsArray = [];
	        this.explosionsArray = [];
	        this.currentSiteIs = new core_1.EventEmitter();
	        this.changeSite = new core_1.EventEmitter();
	        this.onMapDrag = new core_1.EventEmitter();
	    }
	    /////////////////////
	    // LIFESTYLE HOOKS //
	    /////////////////////
	    MapDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        // When you zoom out all the way, this line makes the background black
	        // (by default it is gray).
	        this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', 'black');
	        // Instantiate the Leaflet map, see docs at
	        // http://leafletjs.com/reference.html#map-constructor
	        this.leaflet = this.leafletLib.map(this.el.nativeElement, {
	            // Turn off the "Leaflet" link in the lower right corner.
	            // Leaflet is properly attributed in the README.
	            attributionControl: false,
	            minZoom: 2,
	            worldCopyJump: true
	        })
	            .setView(this.center, this.zoom);
	        // Add the black & white style map layer.
	        // Found by browsing http://leaflet-extras.github.io/leaflet-providers/preview/
	        // TODO move this to configuration.
	        //this.leafletLib.tileLayer("https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png").addTo(this.leaflet);
	        this.leafletLib.tileLayer("https://watercolormaps.collection.cooperhewitt.org/tile/watercolor/{z}/{x}/{y}.jpg").addTo(this.leaflet);
	        this.resizeMapContainer();
	        // set append svg and canvas layers to the map
	        // canvas layer
	        this.canvasLayer = this.leafletLib.canvasOverlay()
	            .addTo(this.leaflet); // add this layer to leaflet map
	        this.canvas = this.canvasLayer.canvas();
	        this.context = this.canvas.getContext('2d');
	        // svg layer
	        // let svgLayer = this.renderer.createElement(this.leaflet.getPanes().overlayPane, 'svg');
	        // this.siteLayer = this.renderer.createElement(this.svgLayer, 'g');
	        this.svgLayer = this.d3.select(this.leaflet.getPanes().overlayPane).append("svg");
	        // this.defs = this.svg.append('svg:defs');
	        this.siteLayer = this.svgLayer.append("g");
	        // d3
	        var point = this.projectPoint();
	        this.transform = this.d3.geo.transform({ point: point });
	        this.path = this.d3.geo.path().projection(this.transform);
	        this.resizeSvgLayer();
	        // init drawing of things
	        var sites = this.reduceSites(this.sites);
	        var currentSite = this.global.user.settings_global.current.name;
	        for (var g = 0, glen = sites.length; g < glen; g++) {
	            for (var s = 0, slen = sites[g].length; s < slen; s++) {
	                if (currentSite === sites[g][s].site) {
	                    this.currentSite = sites[g][s];
	                    // emit site change for the parent compoenents
	                    this.currentSiteIs.emit({
	                        site: this.currentSite
	                    });
	                    break;
	                }
	            }
	        }
	        // do nothing if there isnt a site set by default (something is broken)
	        if (!this.currentSite) {
	            return;
	        }
	        this.drawSites(sites);
	        // set current site location
	        this.markCurrentSiteBlock(this.currentSite);
	        //sub to streams
	        this.setupStreams();
	        // listen for re-sub events when the site is changed
	        this.newStream
	            .asObservable()
	            .subscribe(function () {
	            _this.setupStreams();
	        });
	        // MAP EVENT LISTENERS
	        this.leaflet.on("move", function () {
	            _this.onMove();
	            _this.clearConnectionsOnMap();
	            // send events to globe
	            _this.onMapDrag.emit({
	                center: _this.center,
	                zoom: _this.zoom
	            });
	        });
	        // clear canvas items after map is finished moving
	        this.leaflet.on("moveend", function () {
	            _this.clearConnectionsOnMap();
	        });
	        this.leaflet.on("viewreset", function () {
	            // delete all points on the page
	            _this.wipeClean();
	            // reset svg heatmap layer
	            _this.resizeSvgLayer();
	            // this.movePoints();
	            var sites = _this.reduceSites(_this.sites);
	            // redraw the sites
	            _this.drawSites(sites);
	            // set current site location
	            _this.markCurrentSiteBlock(_this.currentSite);
	            // reset globe inactivity status and send some settings
	            _this.onMapDrag.emit({
	                center: _this.center,
	                zoom: _this.zoom
	            });
	        });
	    };
	    ////////////
	    // EVENTS //
	    ////////////
	    MapDirective.prototype.setupStreams = function () {
	        var _this = this;
	        // EVENT SUBSCRIPTIONS
	        this.inboundStream.subscribe(function (conn) {
	            if (_this.windowIsHidden) {
	                return;
	            }
	            if (_this.mode === "outbound") {
	                return;
	            }
	            _this.drawConnection([conn, _this.currentSite], '255, 93, 42', true); // #3459FF
	        });
	        this.outboundStream.subscribe(function (conn) {
	            if (_this.windowIsHidden) {
	                return;
	            }
	            if (_this.mode === "inbound") {
	                return;
	            }
	            _this.drawConnection([_this.currentSite, conn], '52, 89, 255', false); // #FF5D2A
	        });
	        this.lateralStream.subscribe(function (conn) {
	            if (_this.windowIsHidden) {
	                return;
	            }
	            if (_this.mode !== "all") {
	                return;
	            }
	            _this.explosion(_this.currentSite, '170, 55, 178'); // #AA37B2
	        });
	    };
	    MapDirective.prototype.onGlobeDrag = function (event) {
	        // set map center when globe is dragged
	        this.setCenter(event.value);
	    };
	    MapDirective.prototype.onWindowResize = function (event) {
	        this.resizeMapContainer();
	        // NOTE: because specific clients want the sites' size to change when we go into
	        // fullscreen mode, we now have to redraw the sites whenever the window size changes.
	        // this is probably really inifficent but large parts of the code would have to be re-written
	        // to accomodate this change efficiently
	        // delete all points on the page
	        this.wipeClean();
	        // reset svg heatmap layer
	        this.resizeSvgLayer();
	        // this.movePoints();
	        var sites = this.reduceSites(this.sites);
	        // redraw the sites
	        this.drawSites(sites);
	        // set current site location
	        this.markCurrentSiteBlock(this.currentSite);
	    };
	    /////////////
	    // METHODS //
	    /////////////
	    MapDirective.prototype.projectPoint = function () {
	        var leafletLib = this.leafletLib;
	        var map = this.leaflet;
	        return function (x, y) {
	            var point = map.latLngToLayerPoint(new leafletLib.LatLng(y, x));
	            this.stream.point(point.x, point.y);
	        };
	    };
	    MapDirective.prototype.getCenter = function () {
	        // Returns the current Leaflet map center
	        // in a format that D3 understands: [longitude, latitude]
	        var center = this.leaflet.getCenter();
	        return [center.lng, center.lat];
	    };
	    MapDirective.prototype.onMove = function () {
	        // _.throttle(function (){
	        this.center = this.getCenter();
	        this.zoom = this.leaflet.getZoom();
	        // let bounds = this.leaflet.getBounds();
	        // this.longitudeInterval = [bounds.getWest(), bounds.getEast()];
	        // }, 100);
	    };
	    MapDirective.prototype.setCenter = function (center) {
	        var _this = this;
	        // Sets the Leaflet map center to be the given center.
	        // Note that Leaflet will immediately trigger a "move"
	        // event
	        this.leaflet.off("move", function () { _this.onMove(); });
	        this.leaflet.panTo(this.leafletLib.latLng(center[1], center[0]), {
	            animate: false
	        });
	        this.leaflet.on("move", function () { _this.onMove(); });
	    };
	    MapDirective.prototype.mapBox = function (box) {
	        this.renderer.setElementStyle(this.el.nativeElement, 'width', box.width + 'px');
	        this.renderer.setElementStyle(this.el.nativeElement, 'height', box.height + 'px');
	        // Tell Leaflet that the size has changed so it updates.
	        this.leaflet.invalidateSize();
	    };
	    MapDirective.prototype.zoomTo = function (coordinates, zoom) {
	        this.leaflet.setView([coordinates.lat, coordinates.lng], zoom, { animate: true });
	    };
	    MapDirective.prototype.resizeMapContainer = function () {
	        if (!this.parent) {
	            console.log('Parent attribute not defined in map');
	            return;
	        }
	        var parent = this.document.getElementsByClassName(this.parent)[0];
	        var width = parent.clientWidth;
	        var height = this.window.innerHeight;
	        // setTimeout(() => {
	        // console.log(this.fullscreenEnabled())
	        if (this.fullscreenEnabled()) {
	            this.mapBox({ width: width, height: height });
	        }
	        else {
	            this.mapBox({ width: width, height: height - 40 });
	        }
	        // }, 100)
	    };
	    MapDirective.prototype.resizeSvgLayer = function () {
	        var bounds = this.path.bounds(this.mapPaths), topLeft = bounds[0], bottomRight = bounds[1];
	        // NOTE: leaving these here because i eventually want to replace the d3 selections with the this.renderer
	        // this.renderer.setElementAttribute(this.svgLayer, "width", bottomRight[0] - topLeft[0]);
	        // this.renderer.setElementAttribute(this.svgLayer, "height", bottomRight[1] - topLeft[1]);
	        // this.renderer.setElementStyle(this.svgLayer, "left", topLeft[0] + "px");
	        // this.renderer.setElementStyle(this.svgLayer, "top", topLeft[1] + "px");
	        // this.renderer.setElementAttribute(this.siteLayer, "transform", "translate(" + -topLeft[0] + "," + -topLeft[1] + ")");
	        this.svgLayer
	            .attr("width", bottomRight[0] - topLeft[0])
	            .attr("height", bottomRight[1] - topLeft[1])
	            .style("left", topLeft[0] + "px")
	            .style("top", topLeft[1] + "px");
	        this.height = bottomRight[1] - topLeft[1];
	        this.width = bottomRight[0] - topLeft[0];
	        this.siteLayer
	            .attr("transform", "translate(" + -topLeft[0] + "," + -topLeft[1] + ")");
	    };
	    // ANIMATION LAYERS
	    MapDirective.prototype.clearConnectionsOnMap = function () {
	        this.animationsArray = [];
	        this.explosionsArray = [];
	    };
	    MapDirective.prototype.reduceSites = function (sites) {
	        // TODO:
	        // - add animation to the break apart and collapse of zones
	        var radius = 7;
	        // set used index store and groups store
	        var usedIndexes = [], groups = [];
	        // loop through again
	        for (var i = 0, len = sites.length; i < len; i++) {
	            // do nothing if this item has been compared against others
	            if (usedIndexes.indexOf(i) !== -1) {
	                continue;
	            }
	            usedIndexes.push(i); // set this index as used
	            var current = sites[i]; // alias so things are easier to read
	            var matches = new Array(current); // create new array for this item/group
	            // loop through all the other items again
	            for (var g = 0, glen = sites.length; g < glen; g++) {
	                // do nothing if this item has been grouped already
	                if (usedIndexes.indexOf(g) !== -1) {
	                    continue;
	                }
	                var other = sites[g]; // set alias
	                // run comparison and push to group if they are close enough
	                if ((Math.abs(this.leaflet.latLngToLayerPoint(current.LatLng).x - this.leaflet.latLngToLayerPoint(other.LatLng).x) < radius * 2) &&
	                    (Math.abs(this.leaflet.latLngToLayerPoint(current.LatLng).y - this.leaflet.latLngToLayerPoint(other.LatLng).y) < radius * 2)) {
	                    matches.push(other);
	                    usedIndexes.push(g);
	                }
	            }
	            groups.push(matches);
	        }
	        return groups;
	    };
	    MapDirective.prototype.drawSites = function (siteGroups) {
	        var _this = this;
	        // some settings change if the page is in fullscreen mode or not
	        var sides = 20, groupYTranslate = 15;
	        if (this.fullscreenEnabled()) {
	            sides = 7, groupYTranslate = 5;
	        }
	        var group = this.siteLayer
	            .selectAll('g')
	            .data(siteGroups).enter();
	        var site = group.append('g')
	            .classed('site', true)
	            .attr("transform", function (d) {
	            // take the first value from the given array of sites (d[0])
	            var y = _this.leaflet.latLngToLayerPoint(d[0].LatLng).y - groupYTranslate;
	            return "translate(" + _this.leaflet.latLngToLayerPoint(d[0].LatLng).x + "," + y + ")";
	        })
	            .on('click', function (d) {
	            _this.currentSite = d[0];
	            // change the site everywhere
	            _this.changeSite.emit(d);
	            // temp fix for the marker not waiting for angular's dirty checking
	            _this.markCurrentSiteBlock(d);
	        });
	        // append border
	        site.append('rect')
	            .classed('site-border', true)
	            .attr('width', sides + 2)
	            .attr('height', sides + 2)
	            .attr('fill', '#7270cd')
	            .attr("transform", "translate(0, -1.5) rotate(45)");
	        // append rectangle
	        site.append('rect')
	            .classed('layer-1', true)
	            .attr('width', sides)
	            .attr('height', sides)
	            .attr('fill', '#7270cd')
	            .attr("transform", "rotate(45)"); // take the first value from the given array of sites (d[0])
	        // dont append text in full screen mode
	        if (this.fullscreenEnabled()) {
	            return;
	        }
	        // appendsite count
	        site.append("text")
	            .text(function (d) {
	            // return the number of sensors that may exist inside this group
	            return d.map(function (s) { return s.sensors.length; }).reduce(function (a, b) { return a + b; });
	        })
	            .style('font-family', 'lato')
	            .attr("x", 0)
	            .attr("y", 18)
	            .attr('fill', '#ffffff')
	            .attr("text-anchor", "middle");
	    };
	    MapDirective.prototype.siteExistsInGroup = function (siteName, group) {
	        var exists = false;
	        for (var s = 0, len = group.length; s < len; s++) {
	            if (siteName.site === group[s].site) {
	                exists = true;
	                break;
	            }
	        }
	        return exists;
	    };
	    MapDirective.prototype.markCurrentSiteBlock = function (site) {
	        var selected_size = 35, non_selected_size = 22, non_selected_translate = 1.5, selected_translate = 10; // change the size of selected site if in full screen mode
	        if (this.fullscreenEnabled()) {
	            selected_size = 10, non_selected_size = 9, non_selected_translate = 1.5, selected_translate = 2;
	        }
	        var group = this.siteLayer.selectAll("g.site");
	        // because of our .each() below we need to pull the SiteExists function into
	        // this scope, since 'this' is not available
	        var siteExistsFun = this.siteExistsInGroup;
	        var dashCurrentSite = this.currentSite;
	        var d3Local = this.d3;
	        // start with coloring the
	        group.select('rect.layer-1')
	            .attr('fill', function (d) {
	            if (siteExistsFun(dashCurrentSite, d)) {
	                return '#79CC2E';
	            }
	            else {
	                // return '#7270cd';
	                return '#000';
	            }
	        })
	            .each(function (d) {
	            if (!siteExistsFun(dashCurrentSite, d)) {
	                var el = d3Local.select(this.parentNode);
	                el.select('.site-border')
	                    .attr("transform", "translate(0, -" + non_selected_translate + ") rotate(45)")
	                    .attr('fill', '#79CC2E')
	                    .attr('height', non_selected_size)
	                    .attr('width', non_selected_size);
	            }
	            else {
	                // if current site is in this group, mark append the outer grey block
	                var el = d3Local.select(this.parentNode);
	                el.select('.site-border')
	                    .attr("transform", "translate(0, -" + selected_translate + ") rotate(45)")
	                    .attr('fill', '#000')
	                    .attr('height', selected_size)
	                    .attr('width', selected_size);
	            }
	        });
	        // change the text color
	        group.select('text')
	            .attr('fill', function (d) {
	            if (siteExistsFun(dashCurrentSite, d)) {
	                return '#000';
	            }
	            else {
	                return '#79CC2E';
	            }
	        });
	    };
	    // ANIMATION HELPERS
	    MapDirective.prototype.reverseFib = function (i, val) {
	        var result;
	        if (i === 1) {
	            result = val;
	        }
	        else {
	            for (; i >= 1; i--) {
	                val = val / 2;
	                if (i === 1) {
	                    result = val;
	                }
	            }
	        }
	        return result;
	    };
	    MapDirective.prototype.wipeClean = function () {
	        this.siteLayer.selectAll('g.site').remove();
	        // remove all virtual dom animations
	        this.animationsArray = [];
	        this.explosionsArray = [];
	    };
	    // conncection helper functions
	    MapDirective.prototype.calculateDistance = function (coordinates) {
	        var dis = Math.sqrt(Math.pow((this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).x - this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).x), 2) +
	            Math.pow((this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).y - this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).y), 2));
	        return dis;
	    };
	    MapDirective.prototype.calculateDirection = function (coordinates) {
	        var dir = Math.atan2(this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).y - this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).y, this.leaflet.latLngToLayerPoint(coordinates[0].LatLng).x - this.leaflet.latLngToLayerPoint(coordinates[1].LatLng).x);
	        return dir;
	    };
	    MapDirective.prototype.calculateScale = function (max) {
	        var scale = this.d3.scale.linear().domain([0, max]).range([0, 1]);
	        return scale;
	    };
	    MapDirective.prototype.calculateZoom = function () {
	        var zoom = (this.zoom === 0) ? 1 : this.zoom;
	        return zoom;
	    };
	    // main conn drawing function
	    MapDirective.prototype.drawConnection = function (coordinates, color, originExplosion) {
	        // let leafletLocal = this.map.leaflet;
	        // run explosion if originExplosion is set
	        // distance in pixels betweem too points on the page
	        var distance = this.calculateDistance(coordinates);
	        var radius = 100; // distince outside zone to grow the connection line
	        // figure out what value of t is at the radius mark of the overall distance
	        // this is the value of t where our scale should be at 1
	        var tmax = radius / distance;
	        var scale = this.calculateScale(tmax);
	        // get zoom level or default to 1
	        var zoom = this.calculateZoom();
	        // use reverse sequence to determine the original distance at zoom 1;
	        // const origDist = this.reverseFib(zoom, distance);
	        // get the direction to point the path
	        var rotation = this.calculateDirection(coordinates);
	        // const maxTime = 9000;
	        // const maxDistance = 500;
	        // const duration = ((origDist/maxDistance) * maxTime) * (zoom*0.6);
	        var duration = 600 * (zoom * 0.2);
	        var obj = {
	            x: {
	                start: this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).x,
	                end: this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).x,
	                distance: this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).x -
	                    this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).x
	            },
	            y: {
	                start: this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).y,
	                end: this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).y,
	                distance: this.leaflet.latLngToContainerPoint(coordinates[1].LatLng).y -
	                    this.leaflet.latLngToContainerPoint(coordinates[0].LatLng).y
	            },
	            dist: distance,
	            rotation: rotation,
	            duration: duration,
	            start: 0,
	            color: color,
	            tmax: tmax,
	            scale: this.d3.scale.linear().domain([0, tmax]).range([0, 1])
	        };
	        this.addAnimation(obj);
	        if (originExplosion) {
	            this.explosion(coordinates[0], color);
	        }
	    };
	    MapDirective.prototype.addAnimation = function (obj) {
	        this.animationsArray.push(obj);
	    };
	    MapDirective.prototype.removeAnimations = function (count) {
	        // iterate and drop items that are expired
	        this.animationsArray.splice(0, count);
	    };
	    MapDirective.prototype.explosion = function (coordinates, color) {
	        var obj = {
	            radius: {
	                start: 2,
	                end: 40
	            },
	            opacity: 0.8,
	            duration: 3500,
	            start: 0,
	            color: color,
	            x: this.leaflet.latLngToContainerPoint(coordinates.LatLng).x,
	            y: this.leaflet.latLngToContainerPoint(coordinates.LatLng).y
	        };
	        this.addExplosion(obj);
	    };
	    MapDirective.prototype.addExplosion = function (obj) {
	        this.explosionsArray.push(obj);
	    };
	    MapDirective.prototype.removeExplosions = function (count) {
	        // iterate and drop items that are expired
	        this.explosionsArray.splice(0, count);
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "currentSiteIs", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "changeSite", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "newStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "parent", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "fullscreenEnabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "sites", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "windowIsHidden", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "inboundStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "outboundStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "lateralStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "mode", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], MapDirective.prototype, "onMapDrag", void 0);
	    __decorate([
	        core_1.HostListener('window:resize', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], MapDirective.prototype, "onWindowResize", null);
	    MapDirective = __decorate([
	        core_1.Directive({
	            selector: '[map-container]',
	            providers: [
	                { provide: 'Leaflet', useValue: L }
	            ]
	        }),
	        __param(2, core_1.Inject('Leaflet')),
	        __param(3, core_1.Inject('Window')),
	        __param(4, core_1.Inject('Document')),
	        __param(5, core_1.Inject('D3')),
	        __param(6, core_1.Inject('Global')), 
	        __metadata('design:paramtypes', [core_1.ElementRef, core_1.Renderer, Object, Object, Document, Object, Object])
	    ], MapDirective);
	    return MapDirective;
	}());
	exports.MapDirective = MapDirective;


/***/ },
/* 928 */
/***/ function(module, exports) {

	module.exports = {
		"type": "FeatureCollection",
		"features": [
			{
				"type": "Feature",
				"id": "US.CA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.4,
					"hc-middle-y": 0.53,
					"hc-key": "us-ca",
					"hc-a2": "CA",
					"labelrank": "0",
					"hasc": "US.CA",
					"alt-name": "CA|Calif.",
					"woe-id": "2347563",
					"subregion": "Pacific",
					"fips": "US06",
					"postal-code": "CA",
					"name": "California",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-119.591",
					"woe-name": "California",
					"latitude": "36.7496",
					"woe-label": "California, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2142,
								2659
							],
							[
								2612,
								2520
							],
							[
								2490,
								2069
							],
							[
								2661,
								1814
							],
							[
								2799,
								1605
							],
							[
								2998,
								1308
							],
							[
								3014,
								1219
							],
							[
								3039,
								1185
							],
							[
								2978,
								1143
							],
							[
								2975,
								1109
							],
							[
								2936,
								1068
							],
							[
								2928,
								1017
							],
							[
								2954,
								996
							],
							[
								2913,
								961
							],
							[
								2596,
								1002
							],
							[
								2592,
								1096
							],
							[
								2576,
								1136
							],
							[
								2508,
								1222
							],
							[
								2477,
								1226
							],
							[
								2472,
								1275
							],
							[
								2437,
								1278
							],
							[
								2392,
								1314
							],
							[
								2364,
								1297
							],
							[
								2256,
								1326
							],
							[
								2301,
								1326
							],
							[
								2364,
								1298
							],
							[
								2389,
								1331
							],
							[
								2352,
								1368
							],
							[
								2246,
								1401
							],
							[
								2230,
								1427
							],
							[
								2254,
								1511
							],
							[
								2197,
								1612
							],
							[
								2153,
								1772
							],
							[
								2185,
								1800
							],
							[
								2129,
								1880
							],
							[
								2142,
								1971
							],
							[
								2184,
								1905
							],
							[
								2158,
								2020
							],
							[
								2142,
								1977
							],
							[
								2107,
								2022
							],
							[
								2100,
								2093
							],
							[
								2052,
								2184
							],
							[
								2080,
								2324
							],
							[
								2043,
								2406
							],
							[
								2046,
								2435
							],
							[
								2108,
								2513
							],
							[
								2132,
								2570
							],
							[
								2142,
								2659
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.OR",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.5,
					"hc-middle-y": 0.51,
					"hc-key": "us-or",
					"hc-a2": "OR",
					"labelrank": "0",
					"hasc": "US.OR",
					"alt-name": "OR|Ore.",
					"woe-id": "2347596",
					"subregion": "Pacific",
					"fips": "US41",
					"postal-code": "OR",
					"name": "Oregon",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-120.386",
					"woe-name": "Oregon",
					"latitude": "43.8333",
					"woe-label": "Oregon, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2612,
								2520
							],
							[
								2142,
								2659
							],
							[
								2134,
								2715
							],
							[
								2146,
								2796
							],
							[
								2239,
								2936
							],
							[
								2293,
								3074
							],
							[
								2346,
								3178
							],
							[
								2366,
								3277
							],
							[
								2450,
								3247
							],
							[
								2475,
								3228
							],
							[
								2472,
								3156
							],
							[
								2518,
								3126
							],
							[
								2575,
								3135
							],
							[
								2636,
								3102
							],
							[
								2740,
								3091
							],
							[
								2816,
								3100
							],
							[
								2881,
								3096
							],
							[
								3107,
								3041
							],
							[
								3136,
								2966
							],
							[
								3073,
								2874
							],
							[
								3017,
								2817
							],
							[
								3011,
								2789
							],
							[
								3040,
								2764
							],
							[
								3012,
								2706
							],
							[
								2949,
								2435
							],
							[
								2612,
								2520
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.ND",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.52,
					"hc-middle-y": 0.5,
					"hc-key": "us-nd",
					"hc-a2": "ND",
					"labelrank": "0",
					"hasc": "US.ND",
					"alt-name": "ND|N.D.",
					"woe-id": "2347593",
					"subregion": "West North Central",
					"fips": "US38",
					"postal-code": "ND",
					"name": "North Dakota",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-100.302",
					"woe-name": "North Dakota",
					"latitude": "47.4675",
					"woe-label": "North Dakota, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								4812,
								3267
							],
							[
								5228,
								3252
							],
							[
								5243,
								3252
							],
							[
								5256,
								3197
							],
							[
								5252,
								3122
							],
							[
								5280,
								3014
							],
							[
								5285,
								2880
							],
							[
								5306,
								2830
							],
							[
								5310,
								2770
							],
							[
								5183,
								2772
							],
							[
								4491,
								2809
							],
							[
								4494,
								2839
							],
							[
								4533,
								3288
							],
							[
								4793,
								3268
							],
							[
								4812,
								3267
							],
							[
								4812,
								3267
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.SK",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.59,
					"hc-middle-y": 0.5,
					"hc-key": "ca-sk",
					"hc-a2": "SK",
					"labelrank": "2",
					"hasc": "CA.SK",
					"alt-name": null,
					"woe-id": "2344925",
					"subregion": "Prairies",
					"fips": "CA11",
					"postal-code": "SK",
					"name": "Saskatchewan",
					"country": "Canada",
					"type-en": "Province",
					"region": "Western Canada",
					"longitude": "-105.682",
					"woe-name": "Saskatchewan",
					"latitude": "54.4965",
					"woe-label": "Saskatchewan, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								4812,
								3267
							],
							[
								4701,
								3274
							],
							[
								4533,
								3288
							],
							[
								3918,
								3363
							],
							[
								3918,
								3363
							],
							[
								3918,
								3364
							],
							[
								4193,
								5133
							],
							[
								4822,
								5062
							],
							[
								4864,
								5059
							],
							[
								4864,
								5059
							],
							[
								4818,
								4366
							],
							[
								4812,
								3267
							],
							[
								4812,
								3267
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.MT",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.48,
					"hc-middle-y": 0.55,
					"hc-key": "us-mt",
					"hc-a2": "MT",
					"labelrank": "0",
					"hasc": "US.MT",
					"alt-name": "MT|Mont.",
					"woe-id": "2347585",
					"subregion": "Mountain",
					"fips": "US30",
					"postal-code": "MT",
					"name": "Montana",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-110.044",
					"woe-name": "Montana",
					"latitude": "46.9965",
					"woe-label": "Montana, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3918,
								3363
							],
							[
								4533,
								3288
							],
							[
								4494,
								2839
							],
							[
								4491,
								2809
							],
							[
								4479,
								2662
							],
							[
								4477,
								2662
							],
							[
								3706,
								2760
							],
							[
								3693,
								2683
							],
							[
								3671,
								2724
							],
							[
								3645,
								2704
							],
							[
								3564,
								2716
							],
							[
								3548,
								2704
							],
							[
								3478,
								2715
							],
							[
								3451,
								2773
							],
							[
								3410,
								2925
							],
							[
								3363,
								2901
							],
							[
								3343,
								2919
							],
							[
								3369,
								2966
							],
							[
								3374,
								3025
							],
							[
								3397,
								3086
							],
							[
								3374,
								3085
							],
							[
								3313,
								3198
							],
							[
								3279,
								3233
							],
							[
								3288,
								3273
							],
							[
								3264,
								3328
							],
							[
								3299,
								3480
							],
							[
								3499,
								3438
							],
							[
								3501,
								3437
							],
							[
								3501,
								3437
							],
							[
								3905,
								3365
							],
							[
								3905,
								3365
							],
							[
								3918,
								3363
							],
							[
								3918,
								3363
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.AZ",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.5,
					"hc-middle-y": 0.49,
					"hc-key": "us-az",
					"hc-a2": "AZ",
					"labelrank": "0",
					"hasc": "US.AZ",
					"alt-name": "AZ|Ariz.",
					"woe-id": "2347561",
					"subregion": "Mountain",
					"fips": "US04",
					"postal-code": "AZ",
					"name": "Arizona",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-111.935",
					"woe-name": "Arizona",
					"latitude": "34.3046",
					"woe-label": "Arizona, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2998,
								1308
							],
							[
								3021,
								1477
							],
							[
								3094,
								1454
							],
							[
								3109,
								1479
							],
							[
								3133,
								1598
							],
							[
								3536,
								1525
							],
							[
								3748,
								1492
							],
							[
								3684,
								1055
							],
							[
								3621,
								615
							],
							[
								3360,
								656
							],
							[
								2893,
								931
							],
							[
								2913,
								960
							],
							[
								2954,
								996
							],
							[
								2928,
								1017
							],
							[
								2936,
								1068
							],
							[
								2975,
								1109
							],
							[
								2978,
								1143
							],
							[
								3039,
								1185
							],
							[
								3014,
								1219
							],
							[
								2998,
								1308
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.NV",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.47,
					"hc-middle-y": 0.35,
					"hc-key": "us-nv",
					"hc-a2": "NV",
					"labelrank": "0",
					"hasc": "US.NV",
					"alt-name": "NV|Nev.",
					"woe-id": "2347587",
					"subregion": "Mountain",
					"fips": "US32",
					"postal-code": "NV",
					"name": "Nevada",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-117.02",
					"woe-name": "Nevada",
					"latitude": "39.4299",
					"woe-label": "Nevada, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3133,
								1598
							],
							[
								3109,
								1479
							],
							[
								3094,
								1454
							],
							[
								3021,
								1477
							],
							[
								2998,
								1308
							],
							[
								2799,
								1605
							],
							[
								2661,
								1814
							],
							[
								2490,
								2069
							],
							[
								2612,
								2520
							],
							[
								2949,
								2435
							],
							[
								3181,
								2383
							],
							[
								3287,
								2361
							],
							[
								3200,
								1932
							],
							[
								3133,
								1598
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.AL",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.48,
					"hc-middle-y": 0.5,
					"hc-key": "us-al",
					"hc-a2": "AL",
					"labelrank": "0",
					"hasc": "US.AL",
					"alt-name": "AL|Ala.",
					"woe-id": "2347559",
					"subregion": "East South Central",
					"fips": "US01",
					"postal-code": "AL",
					"name": "Alabama",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-86.7184",
					"woe-name": "Alabama",
					"latitude": "32.8551",
					"woe-label": "Alabama, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6537,
								411
							],
							[
								6508,
								373
							],
							[
								6405,
								385
							],
							[
								6374,
								619
							],
							[
								6386,
								1091
							],
							[
								6373,
								1106
							],
							[
								6372,
								1108
							],
							[
								6702,
								1137
							],
							[
								6791,
								827
							],
							[
								6843,
								728
							],
							[
								6820,
								654
							],
							[
								6853,
								528
							],
							[
								6506,
								491
							],
							[
								6537,
								411
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.NM",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.51,
					"hc-middle-y": 0.54,
					"hc-key": "us-nm",
					"hc-a2": "NM",
					"labelrank": "0",
					"hasc": "US.NM",
					"alt-name": "NM|N.M.",
					"woe-id": "2347590",
					"subregion": "Mountain",
					"fips": "US35",
					"postal-code": "NM",
					"name": "New Mexico",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-106.024",
					"woe-name": "New Mexico",
					"latitude": "34.5002",
					"woe-label": "New Mexico, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3968,
								640
							],
							[
								3741,
								670
							],
							[
								3732,
								600
							],
							[
								3621,
								615
							],
							[
								3684,
								1055
							],
							[
								3748,
								1492
							],
							[
								4498,
								1409
							],
							[
								4493,
								1351
							],
							[
								4492,
								1331
							],
							[
								4486,
								1329
							],
							[
								4429,
								632
							],
							[
								3951,
								678
							],
							[
								3968,
								640
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.CO",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.51,
					"hc-middle-y": 0.5,
					"hc-key": "us-co",
					"hc-a2": "CO",
					"labelrank": "0",
					"hasc": "US.CO",
					"alt-name": "CO|Colo.",
					"woe-id": "2347564",
					"subregion": "Mountain",
					"fips": "US08",
					"postal-code": "CO",
					"name": "Colorado",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-105.543",
					"woe-name": "Colorado",
					"latitude": "38.9998",
					"woe-label": "Colorado, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								4498,
								1409
							],
							[
								3748,
								1492
							],
							[
								3823,
								2012
							],
							[
								3837,
								2108
							],
							[
								4422,
								2040
							],
							[
								4657,
								2021
							],
							[
								4647,
								1866
							],
							[
								4641,
								1764
							],
							[
								4617,
								1400
							],
							[
								4498,
								1409
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.WY",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.51,
					"hc-middle-y": 0.5,
					"hc-key": "us-wy",
					"hc-a2": "WY",
					"labelrank": "0",
					"hasc": "US.WY",
					"alt-name": "WY|Wyo.",
					"woe-id": "2347609",
					"subregion": "Mountain",
					"fips": "US56",
					"postal-code": "WY",
					"name": "Wyoming",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-107.552",
					"woe-name": "Wyoming",
					"latitude": "42.9999",
					"woe-label": "Wyoming, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								4422,
								2040
							],
							[
								3837,
								2108
							],
							[
								3603,
								2144
							],
							[
								3629,
								2298
							],
							[
								3649,
								2418
							],
							[
								3693,
								2683
							],
							[
								3706,
								2760
							],
							[
								4477,
								2662
							],
							[
								4455,
								2409
							],
							[
								4450,
								2350
							],
							[
								4444,
								2292
							],
							[
								4422,
								2040
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.WI",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.35,
					"hc-middle-y": 0.36,
					"hc-key": "us-wi",
					"hc-a2": "WI",
					"labelrank": "0",
					"hasc": "US.WI",
					"alt-name": "WI|Wis.",
					"woe-id": "2347608",
					"subregion": "East North Central",
					"fips": "US55",
					"postal-code": "WI",
					"name": "Wisconsin",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-89.5831",
					"woe-name": "Wisconsin",
					"latitude": "44.3709",
					"woe-label": "Wisconsin, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5791,
								2909
							],
							[
								5826,
								2900
							],
							[
								5913,
								2943
							],
							[
								5977,
								2890
							],
							[
								6011,
								2853
							],
							[
								6225,
								2809
							],
							[
								6271,
								2771
							],
							[
								6270,
								2719
							],
							[
								6302,
								2682
							],
							[
								6261,
								2594
							],
							[
								6321,
								2649
							],
							[
								6366,
								2718
							],
							[
								6336,
								2634
							],
							[
								6305,
								2497
							],
							[
								6311,
								2463
							],
							[
								6293,
								2392
							],
							[
								6316,
								2273
							],
							[
								6153,
								2261
							],
							[
								5989,
								2252
							],
							[
								5989,
								2252
							],
							[
								5941,
								2285
							],
							[
								5911,
								2402
							],
							[
								5902,
								2467
							],
							[
								5860,
								2489
							],
							[
								5808,
								2543
							],
							[
								5726,
								2591
							],
							[
								5739,
								2699
							],
							[
								5714,
								2718
							],
							[
								5732,
								2772
							],
							[
								5776,
								2800
							],
							[
								5772,
								2891
							],
							[
								5791,
								2909
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.KS",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.3,
					"hc-middle-y": 0.49,
					"hc-key": "us-ks",
					"hc-a2": "KS",
					"labelrank": "0",
					"hasc": "US.KS",
					"alt-name": "KS|Kans.",
					"woe-id": "2347575",
					"subregion": "West North Central",
					"fips": "US20",
					"postal-code": "KS",
					"name": "Kansas",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-98.3309",
					"woe-name": "Kansas",
					"latitude": "38.5",
					"woe-label": "Kansas, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								4647,
								1866
							],
							[
								5453,
								1842
							],
							[
								5505,
								1815
							],
							[
								5480,
								1769
							],
							[
								5539,
								1707
							],
							[
								5544,
								1376
							],
							[
								4617,
								1400
							],
							[
								4641,
								1764
							],
							[
								4647,
								1866
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.NE",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.41,
					"hc-middle-y": 0.51,
					"hc-key": "us-ne",
					"hc-a2": "NE",
					"labelrank": "0",
					"hasc": "US.NE",
					"alt-name": "NE|Nebr.",
					"woe-id": "2347586",
					"subregion": "West North Central",
					"fips": "US31",
					"postal-code": "NE",
					"name": "Nebraska",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-99.68550000000001",
					"woe-name": "Nebraska",
					"latitude": "41.5002",
					"woe-label": "Nebraska, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5453,
								1842
							],
							[
								4647,
								1866
							],
							[
								4657,
								2021
							],
							[
								4422,
								2040
							],
							[
								4444,
								2292
							],
							[
								4450,
								2350
							],
							[
								5086,
								2313
							],
							[
								5132,
								2281
							],
							[
								5222,
								2293
							],
							[
								5315,
								2234
							],
							[
								5364,
								2122
							],
							[
								5361,
								2083
							],
							[
								5386,
								2046
							],
							[
								5399,
								1938
							],
							[
								5399,
								1935
							],
							[
								5399,
								1935
							],
							[
								5399,
								1935
							],
							[
								5399,
								1935
							],
							[
								5415,
								1896
							],
							[
								5453,
								1842
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.OK",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.76,
					"hc-middle-y": 0.52,
					"hc-key": "us-ok",
					"hc-a2": "OK",
					"labelrank": "0",
					"hasc": "US.OK",
					"alt-name": "OK|Okla.",
					"woe-id": "2347595",
					"subregion": "West South Central",
					"fips": "US40",
					"postal-code": "OK",
					"name": "Oklahoma",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-97.1309",
					"woe-name": "Oklahoma",
					"latitude": "35.452",
					"woe-label": "Oklahoma, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								4617,
								1400
							],
							[
								5544,
								1376
							],
							[
								5544,
								1357
							],
							[
								5545,
								1299
							],
							[
								5570,
								1125
							],
							[
								5569,
								854
							],
							[
								5472,
								902
							],
							[
								5379,
								891
							],
							[
								5328,
								861
							],
							[
								5252,
								901
							],
							[
								5226,
								866
							],
							[
								5153,
								907
							],
							[
								5116,
								894
							],
							[
								5100,
								932
							],
							[
								5048,
								924
							],
							[
								4957,
								951
							],
							[
								4949,
								979
							],
							[
								4895,
								979
							],
							[
								4855,
								1009
							],
							[
								4868,
								1308
							],
							[
								4492,
								1331
							],
							[
								4493,
								1351
							],
							[
								4498,
								1409
							],
							[
								4617,
								1400
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.MI",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.74,
					"hc-middle-y": 0.74,
					"hc-key": "us-mi",
					"hc-a2": "MI",
					"labelrank": "0",
					"hasc": "US.MI",
					"alt-name": "MI|Mich.",
					"woe-id": "2347581",
					"subregion": "East North Central",
					"fips": "US26",
					"postal-code": "MI",
					"name": "Michigan",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-84.9479",
					"woe-name": "Michigan",
					"latitude": "43.4343",
					"woe-label": "Michigan, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									6254,
									3045
								],
								[
									6184,
									2990
								],
								[
									6180,
									3029
								],
								[
									6219,
									3050
								],
								[
									6254,
									3045
								]
							]
						],
						[
							[
								[
									6830,
									2213
								],
								[
									6733,
									2196
								],
								[
									6675,
									2187
								],
								[
									6674,
									2196
								],
								[
									6438,
									2170
								],
								[
									6484,
									2252
								],
								[
									6490,
									2364
								],
								[
									6442,
									2463
								],
								[
									6438,
									2534
								],
								[
									6461,
									2583
								],
								[
									6456,
									2632
								],
								[
									6516,
									2717
								],
								[
									6520,
									2665
								],
								[
									6545,
									2680
								],
								[
									6542,
									2726
								],
								[
									6585,
									2756
								],
								[
									6570,
									2793
								],
								[
									6600,
									2824
								],
								[
									6747,
									2773
								],
								[
									6775,
									2731
								],
								[
									6760,
									2718
								],
								[
									6786,
									2675
								],
								[
									6787,
									2616
								],
								[
									6766,
									2571
								],
								[
									6737,
									2555
								],
								[
									6739,
									2507
								],
								[
									6766,
									2499
								],
								[
									6807,
									2565
								],
								[
									6840,
									2583
								],
								[
									6870,
									2563
								],
								[
									6921,
									2428
								],
								[
									6919,
									2369
								],
								[
									6906,
									2353
								],
								[
									6884,
									2365
								],
								[
									6864,
									2307
								],
								[
									6862,
									2302
								],
								[
									6830,
									2213
								]
							]
						],
						[
							[
								[
									6618,
									2930
								],
								[
									6657,
									2946
								],
								[
									6662,
									2918
								],
								[
									6648,
									2895
								],
								[
									6729,
									2861
								],
								[
									6608,
									2865
								],
								[
									6603,
									2833
								],
								[
									6569,
									2855
								],
								[
									6513,
									2862
								],
								[
									6502,
									2842
								],
								[
									6436,
									2829
								],
								[
									6391,
									2780
								],
								[
									6403,
									2816
								],
								[
									6360,
									2784
								],
								[
									6356,
									2814
								],
								[
									6302,
									2682
								],
								[
									6270,
									2719
								],
								[
									6271,
									2771
								],
								[
									6225,
									2809
								],
								[
									6011,
									2853
								],
								[
									5977,
									2890
								],
								[
									6041,
									2932
								],
								[
									6083,
									2941
								],
								[
									6160,
									3006
								],
								[
									6184,
									2967
								],
								[
									6274,
									2951
								],
								[
									6308,
									2905
								],
								[
									6391,
									2905
								],
								[
									6435,
									2945
								],
								[
									6503,
									2952
								],
								[
									6562,
									2975
								],
								[
									6555,
									2934
								],
								[
									6618,
									2930
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.AK",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.66,
					"hc-middle-y": 0.29,
					"hc-key": "us-ak",
					"hc-a2": "AK",
					"labelrank": "0",
					"hasc": "US.AK",
					"alt-name": "AK|Alaska",
					"woe-id": "2347560",
					"subregion": "Pacific",
					"fips": "US02",
					"postal-code": "AK",
					"name": "Alaska",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-151.604",
					"woe-name": "Alaska",
					"latitude": "65.3609",
					"woe-label": "Alaska, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-949,
									6551
								],
								[
									-999,
									6575
								],
								[
									-889,
									6598
								],
								[
									-852,
									6586
								],
								[
									-862,
									6554
								],
								[
									-908,
									6568
								],
								[
									-949,
									6551
								]
							]
						],
						[
							[
								[
									-394,
									6479
								],
								[
									-400,
									6419
								],
								[
									-434,
									6417
								],
								[
									-468,
									6451
								],
								[
									-508,
									6446
								],
								[
									-539,
									6473
								],
								[
									-529,
									6499
								],
								[
									-468,
									6508
								],
								[
									-394,
									6479
								]
							]
						],
						[
							[
								[
									-122,
									6303
								],
								[
									-161,
									6288
								],
								[
									-183,
									6303
								],
								[
									-162,
									6331
								],
								[
									-122,
									6303
								]
							]
						],
						[
							[
								[
									2149,
									5059
								],
								[
									2152,
									5112
								],
								[
									2170,
									5051
								],
								[
									2120,
									5022
								],
								[
									2085,
									5114
								],
								[
									2103,
									5125
								],
								[
									2140,
									5091
								],
								[
									2149,
									5059
								]
							]
						],
						[
							[
								[
									743,
									6283
								],
								[
									769,
									6242
								],
								[
									745,
									6208
								],
								[
									664,
									6233
								],
								[
									644,
									6264
								],
								[
									686,
									6275
								],
								[
									712,
									6257
								],
								[
									743,
									6283
								]
							]
						],
						[
							[
								[
									1284,
									6275
								],
								[
									1318,
									6262
								],
								[
									1243,
									6234
								],
								[
									1200,
									6232
								],
								[
									1269,
									6257
								],
								[
									1284,
									6275
								]
							]
						],
						[
							[
								[
									2033,
									5311
								],
								[
									2037,
									5361
								],
								[
									2060,
									5444
								],
								[
									2109,
									5425
								],
								[
									2112,
									5364
								],
								[
									2075,
									5291
								],
								[
									2000,
									5271
								],
								[
									2033,
									5311
								]
							]
						],
						[
							[
								[
									2206,
									4993
								],
								[
									2167,
									4997
								],
								[
									2123,
									4947
								],
								[
									2113,
									4997
								],
								[
									2134,
									4997
								],
								[
									2176,
									5053
								],
								[
									2150,
									5132
								],
								[
									2155,
									5158
								],
								[
									2125,
									5245
								],
								[
									2098,
									5258
								],
								[
									2131,
									5285
								],
								[
									2118,
									5435
								],
								[
									2084,
									5458
								],
								[
									2096,
									5640
								],
								[
									2072,
									5590
								],
								[
									2056,
									5490
								],
								[
									1991,
									5526
								],
								[
									2006,
									5545
								],
								[
									2011,
									5607
								],
								[
									1993,
									5592
								],
								[
									1955,
									5665
								],
								[
									1955,
									5665
								],
								[
									1991,
									5668
								],
								[
									2043,
									5725
								],
								[
									2124,
									5724
								],
								[
									2142,
									5669
								],
								[
									2127,
									5653
								],
								[
									2157,
									5572
								],
								[
									2193,
									5438
								],
								[
									2214,
									5181
								],
								[
									2197,
									5158
								],
								[
									2205,
									5106
								],
								[
									2224,
									5100
								],
								[
									2318,
									4975
								],
								[
									2314,
									4942
								],
								[
									2292,
									4923
								],
								[
									2280,
									4846
								],
								[
									2224,
									4801
								],
								[
									2170,
									4805
								],
								[
									2182,
									4870
								],
								[
									2207,
									4885
								],
								[
									2228,
									4942
								],
								[
									2218,
									4991
								],
								[
									2210,
									4992
								],
								[
									2221,
									4943
								],
								[
									2201,
									4895
								],
								[
									2170,
									4872
								],
								[
									2156,
									4892
								],
								[
									2138,
									4828
								],
								[
									2122,
									4862
								],
								[
									2136,
									4914
								],
								[
									2169,
									4988
								],
								[
									2206,
									4993
								]
							]
						],
						[
							[
								[
									2051,
									5195
								],
								[
									1988,
									5129
								],
								[
									1969,
									5089
								],
								[
									2005,
									5238
								],
								[
									2041,
									5230
								],
								[
									2054,
									5208
								],
								[
									2065,
									5256
								],
								[
									2129,
									5200
								],
								[
									2111,
									5150
								],
								[
									2134,
									5174
								],
								[
									2145,
									5134
								],
								[
									2117,
									5127
								],
								[
									2092,
									5198
								],
								[
									2095,
									5143
								],
								[
									2042,
									5154
								],
								[
									2051,
									5195
								]
							]
						],
						[
							[
								[
									1949,
									5373
								],
								[
									1926,
									5375
								],
								[
									1934,
									5413
								],
								[
									1918,
									5471
								],
								[
									1913,
									5495
								],
								[
									1991,
									5506
								],
								[
									2044,
									5436
								],
								[
									2015,
									5350
								],
								[
									1995,
									5356
								],
								[
									1958,
									5427
								],
								[
									1954,
									5375
								],
								[
									1975,
									5381
								],
								[
									1998,
									5330
								],
								[
									1980,
									5229
								],
								[
									1940,
									5147
								],
								[
									1926,
									5272
								],
								[
									1957,
									5296
								],
								[
									1938,
									5339
								],
								[
									1917,
									5309
								],
								[
									1921,
									5364
								],
								[
									1949,
									5373
								]
							]
						],
						[
							[
								[
									1950,
									5665
								],
								[
									1952,
									5671
								],
								[
									1955,
									5665
								],
								[
									1955,
									5665
								],
								[
									1950,
									5665
								],
								[
									1950,
									5665
								],
								[
									1950,
									5665
								]
							]
						],
						[
							[
								[
									-39,
									7319
								],
								[
									64,
									7264
								],
								[
									78,
									7228
								],
								[
									43,
									7176
								],
								[
									-6,
									7199
								],
								[
									-30,
									7229
								],
								[
									-39,
									7319
								]
							]
						],
						[
							[
								[
									-871,
									6545
								],
								[
									-805,
									6517
								],
								[
									-740,
									6563
								],
								[
									-664,
									6512
								],
								[
									-639,
									6523
								],
								[
									-625,
									6490
								],
								[
									-738,
									6505
								],
								[
									-720,
									6481
								],
								[
									-842,
									6520
								],
								[
									-871,
									6545
								]
							]
						],
						[
							[
								[
									2098,
									4918
								],
								[
									2080,
									4840
								],
								[
									2056,
									4833
								],
								[
									2051,
									4909
								],
								[
									2015,
									4911
								],
								[
									2037,
									4943
								],
								[
									2013,
									4954
								],
								[
									1996,
									4858
								],
								[
									1990,
									4933
								],
								[
									2001,
									5000
								],
								[
									1965,
									4968
								],
								[
									1965,
									5006
								],
								[
									1993,
									5007
								],
								[
									2041,
									5050
								],
								[
									2052,
									5092
								],
								[
									2042,
									5073
								],
								[
									1982,
									5081
								],
								[
									2042,
									5098
								],
								[
									2038,
									5135
								],
								[
									2073,
									5117
								],
								[
									2065,
									5070
								],
								[
									2089,
									5050
								],
								[
									2098,
									4918
								]
							]
						],
						[
							[
								[
									452,
									6085
								],
								[
									401,
									6128
								],
								[
									451,
									6108
								],
								[
									467,
									6131
								],
								[
									527,
									6162
								],
								[
									501,
									6175
								],
								[
									471,
									6152
								],
								[
									459,
									6180
								],
								[
									488,
									6248
								],
								[
									549,
									6254
								],
								[
									560,
									6236
								],
								[
									631,
									6255
								],
								[
									673,
									6218
								],
								[
									650,
									6198
								],
								[
									700,
									6202
								],
								[
									660,
									6123
								],
								[
									623,
									6167
								],
								[
									624,
									6121
								],
								[
									591,
									6149
								],
								[
									523,
									6136
								],
								[
									464,
									6113
								],
								[
									452,
									6085
								]
							]
						],
						[
							[
								[
									185,
									7813
								],
								[
									172,
									7890
								],
								[
									154,
									7919
								],
								[
									123,
									7924
								],
								[
									127,
									7971
								],
								[
									168,
									7996
								],
								[
									157,
									7965
								],
								[
									175,
									7942
								],
								[
									232,
									7903
								],
								[
									216,
									7866
								],
								[
									229,
									7821
								],
								[
									268,
									7768
								],
								[
									245,
									7756
								],
								[
									222,
									7785
								],
								[
									168,
									7785
								],
								[
									185,
									7813
								]
							]
						],
						[
							[
								[
									1950,
									5665
								],
								[
									1942,
									5643
								],
								[
									1971,
									5621
								],
								[
									1986,
									5552
								],
								[
									1973,
									5526
								],
								[
									1935,
									5547
								],
								[
									1918,
									5532
								],
								[
									1870,
									5630
								],
								[
									1856,
									5721
								],
								[
									1772,
									5852
								],
								[
									1814,
									5862
								],
								[
									1816,
									5894
								],
								[
									1749,
									5893
								],
								[
									1680,
									5963
								],
								[
									1703,
									5977
								],
								[
									1664,
									5989
								],
								[
									1598,
									6055
								],
								[
									1507,
									6085
								],
								[
									1461,
									6170
								],
								[
									1505,
									6219
								],
								[
									1472,
									6209
								],
								[
									1439,
									6173
								],
								[
									1426,
									6222
								],
								[
									1391,
									6249
								],
								[
									1335,
									6238
								],
								[
									1352,
									6271
								],
								[
									1419,
									6255
								],
								[
									1419,
									6287
								],
								[
									1386,
									6295
								],
								[
									1388,
									6348
								],
								[
									1353,
									6374
								],
								[
									1291,
									6379
								],
								[
									1305,
									6432
								],
								[
									1267,
									6386
								],
								[
									1261,
									6335
								],
								[
									1215,
									6311
								],
								[
									1231,
									6278
								],
								[
									1178,
									6280
								],
								[
									1130,
									6323
								],
								[
									1086,
									6326
								],
								[
									960,
									6297
								],
								[
									857,
									6332
								],
								[
									867,
									6360
								],
								[
									919,
									6357
								],
								[
									981,
									6375
								],
								[
									934,
									6379
								],
								[
									920,
									6420
								],
								[
									988,
									6455
								],
								[
									1034,
									6495
								],
								[
									1043,
									6526
								],
								[
									1139,
									6525
								],
								[
									1156,
									6489
								],
								[
									1192,
									6481
								],
								[
									1157,
									6565
								],
								[
									1059,
									6572
								],
								[
									912,
									6516
								],
								[
									873,
									6479
								],
								[
									806,
									6471
								],
								[
									812,
									6498
								],
								[
									761,
									6468
								],
								[
									724,
									6478
								],
								[
									686,
									6434
								],
								[
									723,
									6414
								],
								[
									730,
									6362
								],
								[
									640,
									6356
								],
								[
									558,
									6319
								],
								[
									525,
									6343
								],
								[
									471,
									6323
								],
								[
									462,
									6343
								],
								[
									429,
									6319
								],
								[
									411,
									6338
								],
								[
									314,
									6289
								],
								[
									302,
									6310
								],
								[
									247,
									6299
								],
								[
									214,
									6313
								],
								[
									110,
									6319
								],
								[
									124,
									6294
								],
								[
									59,
									6280
								],
								[
									-21,
									6304
								],
								[
									-35,
									6334
								],
								[
									-136,
									6337
								],
								[
									-147,
									6359
								],
								[
									-190,
									6360
								],
								[
									-186,
									6413
								],
								[
									-262,
									6375
								],
								[
									-301,
									6378
								],
								[
									-286,
									6434
								],
								[
									-340,
									6402
								],
								[
									-340,
									6438
								],
								[
									-391,
									6422
								],
								[
									-360,
									6456
								],
								[
									-273,
									6438
								],
								[
									-267,
									6451
								],
								[
									-171,
									6458
								],
								[
									-73,
									6396
								],
								[
									-28,
									6419
								],
								[
									48,
									6420
								],
								[
									131,
									6407
								],
								[
									144,
									6380
								],
								[
									168,
									6415
								],
								[
									225,
									6431
								],
								[
									295,
									6429
								],
								[
									400,
									6534
								],
								[
									458,
									6544
								],
								[
									473,
									6567
								],
								[
									372,
									6589
								],
								[
									366,
									6639
								],
								[
									400,
									6666
								],
								[
									338,
									6652
								],
								[
									320,
									6611
								],
								[
									291,
									6615
								],
								[
									307,
									6706
								],
								[
									271,
									6706
								],
								[
									258,
									6733
								],
								[
									275,
									6770
								],
								[
									170,
									6745
								],
								[
									163,
									6775
								],
								[
									109,
									6820
								],
								[
									151,
									6808
								],
								[
									186,
									6891
								],
								[
									234,
									6901
								],
								[
									264,
									7012
								],
								[
									288,
									7052
								],
								[
									238,
									7010
								],
								[
									147,
									7047
								],
								[
									121,
									7079
								],
								[
									140,
									7101
								],
								[
									139,
									7169
								],
								[
									123,
									7244
								],
								[
									201,
									7234
								],
								[
									239,
									7188
								],
								[
									237,
									7148
								],
								[
									269,
									7156
								],
								[
									249,
									7199
								],
								[
									185,
									7273
								],
								[
									207,
									7274
								],
								[
									205,
									7321
								],
								[
									187,
									7305
								],
								[
									194,
									7376
								],
								[
									216,
									7382
								],
								[
									201,
									7416
								],
								[
									236,
									7403
								],
								[
									233,
									7438
								],
								[
									266,
									7414
								],
								[
									292,
									7452
								],
								[
									372,
									7470
								],
								[
									389,
									7460
								],
								[
									426,
									7498
								],
								[
									476,
									7518
								],
								[
									518,
									7511
								],
								[
									535,
									7486
								],
								[
									537,
									7439
								],
								[
									652,
									7429
								],
								[
									718,
									7388
								],
								[
									769,
									7399
								],
								[
									816,
									7475
								],
								[
									811,
									7522
								],
								[
									871,
									7519
								],
								[
									884,
									7577
								],
								[
									851,
									7567
								],
								[
									807,
									7593
								],
								[
									753,
									7592
								],
								[
									712,
									7606
								],
								[
									707,
									7646
								],
								[
									660,
									7691
								],
								[
									610,
									7709
								],
								[
									564,
									7787
								],
								[
									566,
									7821
								],
								[
									591,
									7838
								],
								[
									593,
									7900
								],
								[
									613,
									7875
								],
								[
									653,
									7874
								],
								[
									601,
									7954
								],
								[
									589,
									8014
								],
								[
									620,
									8024
								],
								[
									678,
									7997
								],
								[
									718,
									8006
								],
								[
									835,
									7982
								],
								[
									899,
									7960
								],
								[
									943,
									7924
								],
								[
									886,
									7880
								],
								[
									882,
									7852
								],
								[
									963,
									7778
								],
								[
									967,
									7751
								],
								[
									1017,
									7773
								],
								[
									1047,
									7744
								],
								[
									1038,
									7791
								],
								[
									1006,
									7802
								],
								[
									1028,
									7818
								],
								[
									1037,
									7911
								],
								[
									1061,
									7904
								],
								[
									1039,
									7853
								],
								[
									1039,
									7802
								],
								[
									1071,
									7793
								],
								[
									1074,
									7752
								],
								[
									1107,
									7730
								],
								[
									1124,
									7747
								],
								[
									1104,
									7797
								],
								[
									1055,
									7806
								],
								[
									1055,
									7848
								],
								[
									1099,
									7894
								],
								[
									1059,
									7914
								],
								[
									1007,
									7988
								],
								[
									1047,
									8080
								],
								[
									1038,
									8200
								],
								[
									1023,
									8233
								],
								[
									1022,
									8292
								],
								[
									1063,
									8305
								],
								[
									1104,
									8346
								],
								[
									1203,
									8266
								],
								[
									1262,
									8259
								],
								[
									1321,
									8274
								],
								[
									1353,
									8313
								],
								[
									1439,
									8349
								],
								[
									1443,
									8334
								],
								[
									1500,
									8355
								],
								[
									1497,
									8334
								],
								[
									1552,
									8311
								],
								[
									1666,
									8329
								],
								[
									1696,
									8297
								],
								[
									1749,
									8268
								],
								[
									1817,
									8271
								],
								[
									1866,
									8291
								],
								[
									1910,
									8226
								],
								[
									1863,
									8211
								],
								[
									1873,
									8173
								],
								[
									1923,
									8201
								],
								[
									1940,
									8159
								],
								[
									1918,
									8134
								],
								[
									1939,
									8109
								],
								[
									1997,
									8099
								],
								[
									2040,
									8042
								],
								[
									1990,
									8017
								],
								[
									2036,
									7984
								],
								[
									2011,
									7976
								],
								[
									2101,
									7925
								],
								[
									2090,
									7914
								],
								[
									2151,
									7897
								],
								[
									2205,
									7824
								],
								[
									2211,
									7792
								],
								[
									2241,
									7758
								],
								[
									2310,
									7716
								],
								[
									2325,
									7669
								],
								[
									2363,
									7642
								],
								[
									2402,
									7642
								],
								[
									2448,
									7622
								],
								[
									2477,
									7582
								],
								[
									2482,
									7546
								],
								[
									2505,
									7526
								],
								[
									2512,
									7485
								],
								[
									2536,
									7472
								],
								[
									1748,
									6013
								],
								[
									1810,
									5954
								],
								[
									1850,
									5961
								],
								[
									1891,
									5942
								],
								[
									1867,
									5889
								],
								[
									1920,
									5719
								],
								[
									1910,
									5662
								],
								[
									1950,
									5665
								],
								[
									1950,
									5665
								],
								[
									1950,
									5665
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.OH",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.53,
					"hc-middle-y": 0.53,
					"hc-key": "us-oh",
					"hc-a2": "OH",
					"labelrank": "0",
					"hasc": "US.OH",
					"alt-name": "OH|Ohio",
					"woe-id": "2347594",
					"subregion": "East North Central",
					"fips": "US39",
					"postal-code": "OH",
					"name": "Ohio",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-82.67189999999999",
					"woe-name": "Ohio",
					"latitude": "40.0924",
					"woe-label": "Ohio, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6830,
								2213
							],
							[
								6949,
								2177
							],
							[
								7042,
								2211
							],
							[
								7074,
								2249
							],
							[
								7163,
								2304
							],
							[
								7198,
								2099
							],
							[
								7183,
								1935
							],
							[
								7147,
								1893
							],
							[
								7117,
								1888
							],
							[
								7079,
								1800
							],
							[
								7057,
								1816
							],
							[
								7038,
								1725
							],
							[
								7007,
								1717
							],
							[
								7007,
								1717
							],
							[
								7007,
								1717
							],
							[
								7007,
								1717
							],
							[
								6964,
								1762
							],
							[
								6916,
								1732
							],
							[
								6804,
								1750
							],
							[
								6768,
								1791
							],
							[
								6723,
								1785
							],
							[
								6684,
								2124
							],
							[
								6675,
								2187
							],
							[
								6733,
								2196
							],
							[
								6830,
								2213
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.BC",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.53,
					"hc-middle-y": 0.49,
					"hc-key": "ca-bc",
					"hc-a2": "BC",
					"labelrank": "2",
					"hasc": "CA.BC",
					"alt-name": "Colombie britannique|New Caledonia",
					"woe-id": "2344916",
					"subregion": "British Columbia",
					"fips": "CA02",
					"postal-code": "BC",
					"name": "British Columbia",
					"country": "Canada",
					"type-en": "Province",
					"region": "Western Canada",
					"longitude": "-124.662",
					"woe-name": "British Columbia",
					"latitude": "54.6943",
					"woe-label": "British Columbia, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									1945,
									4613
								],
								[
									1916,
									4640
								],
								[
									1943,
									4655
								],
								[
									1909,
									4689
								],
								[
									1914,
									4733
								],
								[
									1949,
									4790
								],
								[
									2007,
									4751
								],
								[
									2008,
									4718
								],
								[
									2015,
									4730
								],
								[
									2064,
									4734
								],
								[
									2024,
									4686
								],
								[
									1994,
									4624
								],
								[
									1962,
									4610
								],
								[
									1997,
									4604
								],
								[
									2002,
									4566
								],
								[
									1978,
									4515
								],
								[
									1981,
									4442
								],
								[
									2003,
									4401
								],
								[
									1983,
									4393
								],
								[
									1932,
									4582
								],
								[
									1922,
									4617
								],
								[
									1945,
									4613
								]
							],
							[
								[
									2008,
									4718
								],
								[
									2003,
									4709
								],
								[
									2003,
									4709
								],
								[
									2003,
									4709
								],
								[
									1961,
									4699
								],
								[
									1986,
									4680
								],
								[
									2003,
									4709
								],
								[
									2003,
									4709
								],
								[
									2003,
									4709
								],
								[
									2008,
									4710
								],
								[
									2008,
									4718
								]
							]
						],
						[
							[
								[
									2284,
									4307
								],
								[
									2258,
									4259
								],
								[
									2252,
									4240
								],
								[
									2242,
									4333
								],
								[
									2284,
									4307
								]
							]
						],
						[
							[
								[
									2119,
									4594
								],
								[
									2137,
									4615
								],
								[
									2177,
									4557
								],
								[
									2171,
									4523
								],
								[
									2130,
									4603
								],
								[
									2119,
									4594
								]
							]
						],
						[
							[
								[
									3057,
									5399
								],
								[
									3366,
									5309
								],
								[
									3102,
									4332
								],
								[
									3106,
									4255
								],
								[
									3143,
									4209
								],
								[
									3187,
									4185
								],
								[
									3212,
									4105
								],
								[
									3209,
									4054
								],
								[
									3233,
									4068
								],
								[
									3260,
									4003
								],
								[
									3288,
									4002
								],
								[
									3307,
									3924
								],
								[
									3335,
									3932
								],
								[
									3403,
									3760
								],
								[
									3473,
									3664
								],
								[
									3469,
									3571
								],
								[
									3451,
									3543
								],
								[
									3501,
									3437
								],
								[
									3501,
									3437
								],
								[
									3499,
									3438
								],
								[
									3299,
									3480
								],
								[
									3198,
									3503
								],
								[
									2633,
									3655
								],
								[
									2623,
									3658
								],
								[
									2607,
									3678
								],
								[
									2595,
									3667
								],
								[
									2589,
									3668
								],
								[
									2589,
									3750
								],
								[
									2562,
									3743
								],
								[
									2524,
									3795
								],
								[
									2552,
									3822
								],
								[
									2475,
									3840
								],
								[
									2484,
									3887
								],
								[
									2450,
									3884
								],
								[
									2473,
									3924
								],
								[
									2443,
									3974
								],
								[
									2410,
									3969
								],
								[
									2320,
									4015
								],
								[
									2356,
									4048
								],
								[
									2356,
									4075
								],
								[
									2298,
									4071
								],
								[
									2259,
									4116
								],
								[
									2247,
									4159
								],
								[
									2263,
									4228
								],
								[
									2297,
									4305
								],
								[
									2290,
									4362
								],
								[
									2266,
									4339
								],
								[
									2308,
									4426
								],
								[
									2256,
									4351
								],
								[
									2283,
									4471
								],
								[
									2242,
									4519
								],
								[
									2256,
									4566
								],
								[
									2289,
									4569
								],
								[
									2327,
									4610
								],
								[
									2250,
									4570
								],
								[
									2227,
									4538
								],
								[
									2190,
									4647
								],
								[
									2179,
									4714
								],
								[
									2211,
									4771
								],
								[
									2198,
									4777
								],
								[
									2282,
									4843
								],
								[
									2288,
									4895
								],
								[
									2314,
									4942
								],
								[
									2318,
									4975
								],
								[
									2224,
									5100
								],
								[
									2205,
									5106
								],
								[
									2197,
									5158
								],
								[
									2214,
									5181
								],
								[
									2193,
									5438
								],
								[
									2157,
									5572
								],
								[
									2127,
									5653
								],
								[
									2142,
									5669
								],
								[
									2124,
									5724
								],
								[
									2043,
									5725
								],
								[
									1991,
									5668
								],
								[
									1955,
									5665
								],
								[
									1955,
									5665
								],
								[
									1955,
									5665
								],
								[
									1955,
									5665
								],
								[
									1950,
									5665
								],
								[
									1950,
									5665
								],
								[
									1950,
									5665
								],
								[
									1950,
									5665
								],
								[
									1910,
									5662
								],
								[
									1920,
									5719
								],
								[
									1867,
									5889
								],
								[
									1868,
									5888
								],
								[
									3057,
									5399
								]
							]
						],
						[
							[
								[
									2211,
									4429
								],
								[
									2225,
									4487
								],
								[
									2235,
									4520
								],
								[
									2277,
									4479
								],
								[
									2250,
									4365
								],
								[
									2222,
									4345
								],
								[
									2252,
									4445
								],
								[
									2205,
									4384
								],
								[
									2194,
									4458
								],
								[
									2211,
									4429
								]
							]
						],
						[
							[
								[
									2136,
									4643
								],
								[
									2157,
									4733
								],
								[
									2150,
									4677
								],
								[
									2177,
									4674
								],
								[
									2224,
									4532
								],
								[
									2207,
									4532
								],
								[
									2198,
									4480
								],
								[
									2181,
									4570
								],
								[
									2136,
									4643
								]
							]
						],
						[
							[
								[
									2456,
									3780
								],
								[
									2525,
									3723
								],
								[
									2560,
									3656
								],
								[
									2542,
									3603
								],
								[
									2511,
									3580
								],
								[
									2412,
									3655
								],
								[
									2372,
									3706
								],
								[
									2416,
									3728
								],
								[
									2362,
									3727
								],
								[
									2294,
									3812
								],
								[
									2280,
									3894
								],
								[
									2255,
									3885
								],
								[
									2221,
									3991
								],
								[
									2197,
									4012
								],
								[
									2163,
									4084
								],
								[
									2162,
									4112
								],
								[
									2220,
									4111
								],
								[
									2248,
									4068
								],
								[
									2333,
									4000
								],
								[
									2453,
									3944
								],
								[
									2429,
									3875
								],
								[
									2456,
									3780
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.NU",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.38,
					"hc-middle-y": 0.67,
					"hc-key": "ca-nu",
					"hc-a2": "NU",
					"labelrank": "2",
					"hasc": "CA.NU",
					"alt-name": null,
					"woe-id": "20069920",
					"subregion": null,
					"fips": "CA10",
					"postal-code": "NU",
					"name": "Nunavut",
					"country": "Canada",
					"type-en": "Territory",
					"region": "Northern Canada",
					"longitude": "-97.1443",
					"woe-name": "Nunavut",
					"latitude": "64.3853",
					"woe-label": "Nunavut, CA, Canada",
					"type": "Territoire"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									7730,
									6105
								],
								[
									7728,
									6098
								],
								[
									7767,
									6087
								],
								[
									7788,
									6022
								],
								[
									7766,
									6028
								],
								[
									7735,
									6074
								],
								[
									7729,
									6056
								],
								[
									7801,
									5964
								],
								[
									7748,
									5958
								],
								[
									7806,
									5900
								],
								[
									7840,
									5909
								],
								[
									7836,
									5877
								],
								[
									7808,
									5876
								],
								[
									7759,
									5911
								],
								[
									7763,
									5926
								],
								[
									7633,
									5937
								],
								[
									7524,
									6005
								],
								[
									7548,
									5966
								],
								[
									7449,
									6005
								],
								[
									7432,
									5993
								],
								[
									7516,
									5928
								],
								[
									7577,
									5911
								],
								[
									7698,
									5843
								],
								[
									7758,
									5761
								],
								[
									7737,
									5749
								],
								[
									7640,
									5768
								],
								[
									7541,
									5756
								],
								[
									7498,
									5766
								],
								[
									7442,
									5799
								],
								[
									7452,
									5819
								],
								[
									7387,
									5801
								],
								[
									7255,
									5840
								],
								[
									7246,
									5882
								],
								[
									7270,
									5914
								],
								[
									7243,
									5933
								],
								[
									7209,
									5917
								],
								[
									7180,
									5961
								],
								[
									7153,
									5935
								],
								[
									7121,
									5982
								],
								[
									7062,
									6033
								],
								[
									7013,
									6057
								],
								[
									6981,
									5986
								],
								[
									6889,
									6008
								],
								[
									6872,
									5947
								],
								[
									6787,
									5918
								],
								[
									6745,
									5932
								],
								[
									6710,
									5976
								],
								[
									6703,
									6030
								],
								[
									6755,
									6084
								],
								[
									6737,
									6128
								],
								[
									6794,
									6131
								],
								[
									6868,
									6111
								],
								[
									6874,
									6108
								],
								[
									6850,
									6127
								],
								[
									6906,
									6127
								],
								[
									6908,
									6153
								],
								[
									6947,
									6152
								],
								[
									6978,
									6197
								],
								[
									7023,
									6194
								],
								[
									6999,
									6235
								],
								[
									6922,
									6296
								],
								[
									6997,
									6432
								],
								[
									6999,
									6482
								],
								[
									7027,
									6503
								],
								[
									6977,
									6618
								],
								[
									6949,
									6636
								],
								[
									6931,
									6690
								],
								[
									6860,
									6706
								],
								[
									6865,
									6754
								],
								[
									6830,
									6759
								],
								[
									6858,
									6732
								],
								[
									6830,
									6700
								],
								[
									6791,
									6778
								],
								[
									6733,
									6792
								],
								[
									6731,
									6765
								],
								[
									6672,
									6713
								],
								[
									6658,
									6774
								],
								[
									6721,
									6802
								],
								[
									6709,
									6837
								],
								[
									6596,
									6882
								],
								[
									6611,
									6915
								],
								[
									6559,
									6908
								],
								[
									6545,
									6975
								],
								[
									6499,
									6972
								],
								[
									6444,
									7024
								],
								[
									6419,
									6991
								],
								[
									6459,
									6985
								],
								[
									6489,
									6931
								],
								[
									6479,
									6906
								],
								[
									6430,
									6888
								],
								[
									6411,
									6910
								],
								[
									6288,
									6917
								],
								[
									6328,
									6900
								],
								[
									6354,
									6849
								],
								[
									6303,
									6891
								],
								[
									6272,
									6857
								],
								[
									6209,
									6883
								],
								[
									6170,
									6865
								],
								[
									6030,
									6877
								],
								[
									6033,
									6858
								],
								[
									5981,
									6897
								],
								[
									5987,
									6851
								],
								[
									5949,
									6848
								],
								[
									5928,
									6868
								],
								[
									5978,
									6874
								],
								[
									5975,
									6920
								],
								[
									5949,
									6904
								],
								[
									5892,
									6905
								],
								[
									5838,
									6929
								],
								[
									5783,
									7010
								],
								[
									5774,
									7045
								],
								[
									5832,
									7042
								],
								[
									5853,
									7025
								],
								[
									5918,
									7041
								],
								[
									5865,
									7075
								],
								[
									5755,
									7089
								],
								[
									5742,
									7113
								],
								[
									5750,
									7174
								],
								[
									5730,
									7202
								],
								[
									5758,
									7253
								],
								[
									5734,
									7270
								],
								[
									5749,
									7377
								],
								[
									5767,
									7370
								],
								[
									5761,
									7429
								],
								[
									5773,
									7471
								],
								[
									5839,
									7571
								],
								[
									5896,
									7603
								],
								[
									5987,
									7606
								],
								[
									5999,
									7578
								],
								[
									5968,
									7542
								],
								[
									5946,
									7497
								],
								[
									5918,
									7397
								],
								[
									5922,
									7363
								],
								[
									5953,
									7316
								],
								[
									5945,
									7277
								],
								[
									5973,
									7200
								],
								[
									6018,
									7150
								],
								[
									6053,
									7137
								],
								[
									6063,
									7108
								],
								[
									5996,
									7081
								],
								[
									6066,
									7086
								],
								[
									6078,
									7149
								],
								[
									6062,
									7188
								],
								[
									6029,
									7181
								],
								[
									6004,
									7225
								],
								[
									5977,
									7247
								],
								[
									6005,
									7261
								],
								[
									6002,
									7296
								],
								[
									6029,
									7297
								],
								[
									6087,
									7259
								],
								[
									5995,
									7335
								],
								[
									5980,
									7367
								],
								[
									5982,
									7436
								],
								[
									6062,
									7410
								],
								[
									6003,
									7445
								],
								[
									5996,
									7489
								],
								[
									6023,
									7525
								],
								[
									6117,
									7608
								],
								[
									6191,
									7615
								],
								[
									6214,
									7582
								],
								[
									6229,
									7525
								],
								[
									6259,
									7514
								],
								[
									6268,
									7467
								],
								[
									6297,
									7433
								],
								[
									6294,
									7361
								],
								[
									6272,
									7322
								],
								[
									6312,
									7298
								],
								[
									6302,
									7322
								],
								[
									6330,
									7393
								],
								[
									6349,
									7363
								],
								[
									6389,
									7357
								],
								[
									6384,
									7296
								],
								[
									6416,
									7292
								],
								[
									6396,
									7349
								],
								[
									6409,
									7377
								],
								[
									6459,
									7365
								],
								[
									6408,
									7391
								],
								[
									6408,
									7423
								],
								[
									6450,
									7466
								],
								[
									6491,
									7472
								],
								[
									6510,
									7455
								],
								[
									6600,
									7447
								],
								[
									6626,
									7404
								],
								[
									6625,
									7377
								],
								[
									6676,
									7379
								],
								[
									6686,
									7330
								],
								[
									6642,
									7296
								],
								[
									6671,
									7293
								],
								[
									6728,
									7329
								],
								[
									6716,
									7271
								],
								[
									6767,
									7259
								],
								[
									6754,
									7289
								],
								[
									6774,
									7299
								],
								[
									6784,
									7323
								],
								[
									6860,
									7314
								],
								[
									6901,
									7276
								],
								[
									6891,
									7233
								],
								[
									6854,
									7226
								],
								[
									6854,
									7200
								],
								[
									6869,
									7225
								],
								[
									6900,
									7203
								],
								[
									6863,
									7176
								],
								[
									6854,
									7190
								],
								[
									6853,
									7160
								],
								[
									6908,
									7201
								],
								[
									6929,
									7252
								],
								[
									6954,
									7224
								],
								[
									6934,
									7140
								],
								[
									6945,
									7060
								],
								[
									6942,
									7160
								],
								[
									6994,
									7224
								],
								[
									6999,
									7196
								],
								[
									6974,
									7165
								],
								[
									7002,
									7170
								],
								[
									7019,
									7210
								],
								[
									7105,
									7198
								],
								[
									7109,
									7157
								],
								[
									7056,
									7116
								],
								[
									7025,
									7047
								],
								[
									7053,
									7061
								],
								[
									7048,
									7092
								],
								[
									7105,
									7123
								],
								[
									7112,
									7113
								],
								[
									7078,
									7038
								],
								[
									7141,
									7118
								],
								[
									7138,
									7157
								],
								[
									7211,
									7105
								],
								[
									7231,
									7068
								],
								[
									7189,
									7065
								],
								[
									7191,
									7002
								],
								[
									7213,
									7038
								],
								[
									7275,
									7005
								],
								[
									7291,
									6980
								],
								[
									7228,
									6958
								],
								[
									7187,
									6971
								],
								[
									7133,
									6964
								],
								[
									7197,
									6953
								],
								[
									7174,
									6946
								],
								[
									7232,
									6932
								],
								[
									7216,
									6914
								],
								[
									7244,
									6886
								],
								[
									7153,
									6867
								],
								[
									7232,
									6863
								],
								[
									7215,
									6841
								],
								[
									7322,
									6841
								],
								[
									7361,
									6778
								],
								[
									7375,
									6830
								],
								[
									7390,
									6775
								],
								[
									7405,
									6793
								],
								[
									7489,
									6813
								],
								[
									7472,
									6780
								],
								[
									7525,
									6784
								],
								[
									7580,
									6754
								],
								[
									7584,
									6713
								],
								[
									7532,
									6680
								],
								[
									7589,
									6694
								],
								[
									7602,
									6731
								],
								[
									7652,
									6724
								],
								[
									7648,
									6659
								],
								[
									7679,
									6700
								],
								[
									7728,
									6657
								],
								[
									7710,
									6712
								],
								[
									7743,
									6711
								],
								[
									7799,
									6676
								],
								[
									7808,
									6620
								],
								[
									7745,
									6567
								],
								[
									7799,
									6548
								],
								[
									7769,
									6529
								],
								[
									7786,
									6475
								],
								[
									7738,
									6451
								],
								[
									7717,
									6411
								],
								[
									7755,
									6379
								],
								[
									7761,
									6321
								],
								[
									7726,
									6357
								],
								[
									7696,
									6334
								],
								[
									7671,
									6368
								],
								[
									7677,
									6326
								],
								[
									7579,
									6402
								],
								[
									7565,
									6454
								],
								[
									7535,
									6438
								],
								[
									7519,
									6463
								],
								[
									7432,
									6515
								],
								[
									7396,
									6505
								],
								[
									7427,
									6471
								],
								[
									7367,
									6479
								],
								[
									7387,
									6446
								],
								[
									7440,
									6422
								],
								[
									7445,
									6404
								],
								[
									7394,
									6382
								],
								[
									7381,
									6412
								],
								[
									7336,
									6421
								],
								[
									7381,
									6358
								],
								[
									7412,
									6339
								],
								[
									7436,
									6359
								],
								[
									7449,
									6324
								],
								[
									7477,
									6327
								],
								[
									7506,
									6270
								],
								[
									7624,
									6244
								],
								[
									7629,
									6212
								],
								[
									7672,
									6215
								],
								[
									7653,
									6174
								],
								[
									7702,
									6143
								],
								[
									7737,
									6138
								],
								[
									7731,
									6110
								],
								[
									7749,
									6127
								],
								[
									7771,
									6112
								],
								[
									7804,
									6042
								],
								[
									7761,
									6099
								],
								[
									7730,
									6105
								]
							],
							[
								[
									6874,
									6108
								],
								[
									6895,
									6091
								],
								[
									6895,
									6091
								],
								[
									6888,
									6068
								],
								[
									6913,
									6033
								],
								[
									6905,
									6082
								],
								[
									6895,
									6091
								],
								[
									6895,
									6091
								],
								[
									6896,
									6093
								],
								[
									6874,
									6108
								]
							]
						],
						[
							[
								[
									6775,
									4040
								],
								[
									6805,
									4041
								],
								[
									6845,
									4006
								],
								[
									6859,
									3968
								],
								[
									6720,
									3998
								],
								[
									6733,
									4026
								],
								[
									6775,
									4040
								]
							]
						],
						[
							[
								[
									7663,
									5497
								],
								[
									7690,
									5483
								],
								[
									7687,
									5451
								],
								[
									7651,
									5435
								],
								[
									7663,
									5497
								]
							]
						],
						[
							[
								[
									7837,
									5767
								],
								[
									7867,
									5759
								],
								[
									7876,
									5702
								],
								[
									7812,
									5728
								],
								[
									7837,
									5767
								]
							]
						],
						[
							[
								[
									6689,
									5569
								],
								[
									6710,
									5504
								],
								[
									6689,
									5430
								],
								[
									6649,
									5456
								],
								[
									6635,
									5517
								],
								[
									6657,
									5568
								],
								[
									6689,
									5569
								]
							]
						],
						[
							[
								[
									7341,
									5803
								],
								[
									7400,
									5775
								],
								[
									7358,
									5757
								],
								[
									7307,
									5802
								],
								[
									7341,
									5803
								]
							]
						],
						[
							[
								[
									6733,
									5773
								],
								[
									6790,
									5775
								],
								[
									6809,
									5734
								],
								[
									6783,
									5711
								],
								[
									6727,
									5754
								],
								[
									6733,
									5773
								]
							]
						],
						[
							[
								[
									6823,
									5823
								],
								[
									6876,
									5798
								],
								[
									6845,
									5781
								],
								[
									6805,
									5805
								],
								[
									6823,
									5823
								]
							]
						],
						[
							[
								[
									6165,
									6141
								],
								[
									6211,
									6072
								],
								[
									6203,
									6056
								],
								[
									6169,
									6090
								],
								[
									6165,
									6141
								]
							]
						],
						[
							[
								[
									6283,
									6115
								],
								[
									6240,
									6099
								],
								[
									6238,
									6124
								],
								[
									6207,
									6162
								],
								[
									6283,
									6115
								]
							]
						],
						[
							[
								[
									6853,
									6640
								],
								[
									6916,
									6635
								],
								[
									6925,
									6601
								],
								[
									6858,
									6585
								],
								[
									6822,
									6630
								],
								[
									6853,
									6640
								]
							]
						],
						[
							[
								[
									6036,
									6471
								],
								[
									6024,
									6432
								],
								[
									5991,
									6491
								],
								[
									6007,
									6538
								],
								[
									6028,
									6521
								],
								[
									6036,
									6471
								]
							]
						],
						[
							[
								[
									6791,
									6715
								],
								[
									6807,
									6676
								],
								[
									6759,
									6702
								],
								[
									6762,
									6741
								],
								[
									6791,
									6715
								]
							]
						],
						[
							[
								[
									5092,
									6625
								],
								[
									5076,
									6588
								],
								[
									5059,
									6603
								],
								[
									5061,
									6640
								],
								[
									5092,
									6625
								]
							]
						],
						[
							[
								[
									6525,
									6680
								],
								[
									6552,
									6677
								],
								[
									6530,
									6622
								],
								[
									6510,
									6719
								],
								[
									6478,
									6721
								],
								[
									6516,
									6813
								],
								[
									6531,
									6788
								],
								[
									6515,
									6723
								],
								[
									6525,
									6680
								]
							]
						],
						[
							[
								[
									6615,
									6842
								],
								[
									6642,
									6842
								],
								[
									6612,
									6789
								],
								[
									6597,
									6838
								],
								[
									6615,
									6842
								]
							]
						],
						[
							[
								[
									5392,
									6748
								],
								[
									5412,
									6731
								],
								[
									5390,
									6693
								],
								[
									5389,
									6737
								],
								[
									5392,
									6748
								]
							]
						],
						[
							[
								[
									6546,
									6879
								],
								[
									6518,
									6835
								],
								[
									6495,
									6834
								],
								[
									6532,
									6888
								],
								[
									6546,
									6879
								]
							]
						],
						[
							[
								[
									6415,
									6799
								],
								[
									6366,
									6859
								],
								[
									6431,
									6883
								],
								[
									6458,
									6866
								],
								[
									6423,
									6840
								],
								[
									6415,
									6799
								]
							]
						],
						[
							[
								[
									5327,
									7428
								],
								[
									5338,
									7416
								],
								[
									5316,
									7390
								],
								[
									5304,
									7421
								],
								[
									5327,
									7428
								]
							]
						],
						[
							[
								[
									5279,
									7623
								],
								[
									5250,
									7584
								],
								[
									5204,
									7571
								],
								[
									5177,
									7592
								],
								[
									5216,
									7616
								],
								[
									5274,
									7633
								],
								[
									5279,
									7623
								]
							]
						],
						[
							[
								[
									4958,
									7891
								],
								[
									4965,
									7867
								],
								[
									4927,
									7838
								],
								[
									4893,
									7863
								],
								[
									4910,
									7908
								],
								[
									4941,
									7924
								],
								[
									4958,
									7891
								]
							]
						],
						[
							[
								[
									5356,
									7950
								],
								[
									5376,
									7931
								],
								[
									5325,
									7889
								],
								[
									5315,
									7919
								],
								[
									5356,
									7950
								]
							]
						],
						[
							[
								[
									5057,
									8029
								],
								[
									5020,
									7986
								],
								[
									4988,
									7987
								],
								[
									5006,
									8019
								],
								[
									5057,
									8029
								]
							]
						],
						[
							[
								[
									5045,
									8050
								],
								[
									5043,
									8039
								],
								[
									4972,
									8018
								],
								[
									4958,
									8031
								],
								[
									5045,
									8050
								]
							]
						],
						[
							[
								[
									6239,
									8133
								],
								[
									6238,
									8101
								],
								[
									6257,
									8077
								],
								[
									6213,
									8071
								],
								[
									6239,
									8133
								]
							]
						],
						[
							[
								[
									5032,
									8095
								],
								[
									5019,
									8055
								],
								[
									4968,
									8049
								],
								[
									4941,
									8061
								],
								[
									4946,
									8089
								],
								[
									5029,
									8105
								],
								[
									5032,
									8095
								]
							]
						],
						[
							[
								[
									4973,
									8176
								],
								[
									5014,
									8138
								],
								[
									4998,
									8111
								],
								[
									4945,
									8114
								],
								[
									4937,
									8175
								],
								[
									4973,
									8176
								]
							]
						],
						[
							[
								[
									5688,
									8147
								],
								[
									5671,
									8139
								],
								[
									5642,
									8187
								],
								[
									5670,
									8216
								],
								[
									5685,
									8198
								],
								[
									5688,
									8147
								]
							]
						],
						[
							[
								[
									5643,
									8388
								],
								[
									5674,
									8352
								],
								[
									5679,
									8323
								],
								[
									5659,
									8295
								],
								[
									5603,
									8337
								],
								[
									5602,
									8383
								],
								[
									5643,
									8388
								]
							]
						],
						[
							[
								[
									4936,
									8354
								],
								[
									4963,
									8328
								],
								[
									4942,
									8286
								],
								[
									4909,
									8332
								],
								[
									4893,
									8431
								],
								[
									4920,
									8424
								],
								[
									4940,
									8381
								],
								[
									4936,
									8354
								]
							]
						],
						[
							[
								[
									5137,
									8412
								],
								[
									5095,
									8400
								],
								[
									5065,
									8414
								],
								[
									5070,
									8449
								],
								[
									5105,
									8447
								],
								[
									5137,
									8412
								]
							]
						],
						[
							[
								[
									5228,
									8958
								],
								[
									5242,
									8962
								],
								[
									5258,
									8922
								],
								[
									5252,
									8852
								],
								[
									5220,
									8907
								],
								[
									5200,
									8903
								],
								[
									5196,
									8940
								],
								[
									5228,
									8958
								]
							]
						],
						[
							[
								[
									4864,
									5059
								],
								[
									4864,
									5059
								],
								[
									4912,
									5785
								],
								[
									4431,
									5925
								],
								[
									4379,
									5945
								],
								[
									4355,
									5970
								],
								[
									4287,
									6083
								],
								[
									4156,
									6106
								],
								[
									3690,
									6676
								],
								[
									3689,
									6680
								],
								[
									3766,
									6957
								],
								[
									3784,
									6923
								],
								[
									3878,
									6862
								],
								[
									3910,
									6816
								],
								[
									4036,
									6745
								],
								[
									4019,
									6775
								],
								[
									4046,
									6780
								],
								[
									4100,
									6743
								],
								[
									4128,
									6708
								],
								[
									4157,
									6641
								],
								[
									4145,
									6616
								],
								[
									4082,
									6635
								],
								[
									4060,
									6622
								],
								[
									4062,
									6589
								],
								[
									4030,
									6580
								],
								[
									4053,
									6551
								],
								[
									4233,
									6492
								],
								[
									4241,
									6503
								],
								[
									4330,
									6491
								],
								[
									4405,
									6534
								],
								[
									4420,
									6468
								],
								[
									4465,
									6462
								],
								[
									4472,
									6393
								],
								[
									4484,
									6435
								],
								[
									4528,
									6372
								],
								[
									4530,
									6329
								],
								[
									4508,
									6297
								],
								[
									4542,
									6244
								],
								[
									4534,
									6322
								],
								[
									4558,
									6283
								],
								[
									4562,
									6408
								],
								[
									4538,
									6446
								],
								[
									4532,
									6378
								],
								[
									4524,
									6418
								],
								[
									4555,
									6518
								],
								[
									4585,
									6505
								],
								[
									4632,
									6511
								],
								[
									4659,
									6554
								],
								[
									4708,
									6561
								],
								[
									4719,
									6601
								],
								[
									4657,
									6586
								],
								[
									4610,
									6545
								],
								[
									4584,
									6563
								],
								[
									4573,
									6529
								],
								[
									4526,
									6534
								],
								[
									4522,
									6564
								],
								[
									4496,
									6560
								],
								[
									4541,
									6619
								],
								[
									4609,
									6625
								],
								[
									4682,
									6655
								],
								[
									4716,
									6643
								],
								[
									4732,
									6615
								],
								[
									4722,
									6558
								],
								[
									4749,
									6529
								],
								[
									4783,
									6583
								],
								[
									4763,
									6520
								],
								[
									4787,
									6481
								],
								[
									4852,
									6482
								],
								[
									4932,
									6412
								],
								[
									4956,
									6423
								],
								[
									4986,
									6401
								],
								[
									5044,
									6428
								],
								[
									5133,
									6414
								],
								[
									5146,
									6399
								],
								[
									5207,
									6415
								],
								[
									5159,
									6462
								],
								[
									5194,
									6467
								],
								[
									5226,
									6405
								],
								[
									5262,
									6392
								],
								[
									5293,
									6408
								],
								[
									5254,
									6453
								],
								[
									5229,
									6434
								],
								[
									5206,
									6450
								],
								[
									5212,
									6481
								],
								[
									5185,
									6518
								],
								[
									5220,
									6506
								],
								[
									5252,
									6517
								],
								[
									5237,
									6550
								],
								[
									5285,
									6535
								],
								[
									5297,
									6497
								],
								[
									5337,
									6488
								],
								[
									5316,
									6453
								],
								[
									5378,
									6502
								],
								[
									5339,
									6351
								],
								[
									5366,
									6345
								],
								[
									5353,
									6310
								],
								[
									5390,
									6333
								],
								[
									5421,
									6248
								],
								[
									5429,
									6318
								],
								[
									5408,
									6382
								],
								[
									5392,
									6395
								],
								[
									5409,
									6461
								],
								[
									5450,
									6454
								],
								[
									5494,
									6518
								],
								[
									5547,
									6567
								],
								[
									5525,
									6563
								],
								[
									5534,
									6610
								],
								[
									5511,
									6634
								],
								[
									5499,
									6590
								],
								[
									5463,
									6588
								],
								[
									5465,
									6628
								],
								[
									5495,
									6646
								],
								[
									5488,
									6697
								],
								[
									5534,
									6718
								],
								[
									5532,
									6735
								],
								[
									5482,
									6719
								],
								[
									5461,
									6763
								],
								[
									5445,
									6741
								],
								[
									5358,
									6796
								],
								[
									5335,
									6881
								],
								[
									5359,
									6940
								],
								[
									5332,
									6979
								],
								[
									5347,
									7033
								],
								[
									5343,
									7070
								],
								[
									5372,
									7093
								],
								[
									5392,
									7069
								],
								[
									5404,
									7106
								],
								[
									5374,
									7120
								],
								[
									5418,
									7197
								],
								[
									5454,
									7207
								],
								[
									5423,
									7201
								],
								[
									5419,
									7310
								],
								[
									5388,
									7372
								],
								[
									5395,
									7438
								],
								[
									5387,
									7534
								],
								[
									5414,
									7558
								],
								[
									5413,
									7609
								],
								[
									5443,
									7628
								],
								[
									5501,
									7644
								],
								[
									5550,
									7637
								],
								[
									5581,
									7610
								],
								[
									5620,
									7620
								],
								[
									5699,
									7598
								],
								[
									5639,
									7455
								],
								[
									5615,
									7380
								],
								[
									5585,
									7352
								],
								[
									5524,
									7366
								],
								[
									5480,
									7361
								],
								[
									5522,
									7301
								],
								[
									5484,
									7213
								],
								[
									5459,
									7208
								],
								[
									5469,
									7142
								],
								[
									5480,
									7168
								],
								[
									5558,
									7085
								],
								[
									5567,
									7047
								],
								[
									5564,
									6981
								],
								[
									5599,
									6953
								],
								[
									5631,
									6876
								],
								[
									5644,
									6896
								],
								[
									5661,
									6859
								],
								[
									5616,
									6861
								],
								[
									5596,
									6840
								],
								[
									5634,
									6832
								],
								[
									5576,
									6769
								],
								[
									5616,
									6763
								],
								[
									5648,
									6731
								],
								[
									5664,
									6798
								],
								[
									5676,
									6745
								],
								[
									5723,
									6744
								],
								[
									5754,
									6727
								],
								[
									5727,
									6714
								],
								[
									5740,
									6688
								],
								[
									5686,
									6697
								],
								[
									5745,
									6620
								],
								[
									5739,
									6540
								],
								[
									5763,
									6505
								],
								[
									5796,
									6582
								],
								[
									5794,
									6656
								],
								[
									5814,
									6696
								],
								[
									5840,
									6695
								],
								[
									5908,
									6621
								],
								[
									5931,
									6534
								],
								[
									5890,
									6521
								],
								[
									5909,
									6429
								],
								[
									5979,
									6338
								],
								[
									6037,
									6369
								],
								[
									6030,
									6425
								],
								[
									6066,
									6496
								],
								[
									6067,
									6622
								],
								[
									6126,
									6631
								],
								[
									6100,
									6646
								],
								[
									6137,
									6686
								],
								[
									6079,
									6712
								],
								[
									6056,
									6795
								],
								[
									6066,
									6833
								],
								[
									6129,
									6844
								],
								[
									6176,
									6821
								],
								[
									6241,
									6825
								],
								[
									6287,
									6759
								],
								[
									6322,
									6755
								],
								[
									6351,
									6730
								],
								[
									6320,
									6691
								],
								[
									6363,
									6672
								],
								[
									6365,
									6647
								],
								[
									6320,
									6601
								],
								[
									6288,
									6606
								],
								[
									6305,
									6550
								],
								[
									6329,
									6546
								],
								[
									6331,
									6503
								],
								[
									6402,
									6433
								],
								[
									6395,
									6346
								],
								[
									6366,
									6338
								],
								[
									6329,
									6256
								],
								[
									6302,
									6250
								],
								[
									6290,
									6211
								],
								[
									6195,
									6297
								],
								[
									6161,
									6303
								],
								[
									6218,
									6263
								],
								[
									6261,
									6179
								],
								[
									6191,
									6197
								],
								[
									6213,
									6172
								],
								[
									6147,
									6182
								],
								[
									6130,
									6231
								],
								[
									6066,
									6221
								],
								[
									6035,
									6195
								],
								[
									6049,
									6176
								],
								[
									6107,
									6155
								],
								[
									6072,
									6104
								],
								[
									6070,
									6073
								],
								[
									6011,
									5995
								],
								[
									5970,
									5992
								],
								[
									5832,
									6091
								],
								[
									5807,
									6079
								],
								[
									5732,
									6081
								],
								[
									5814,
									6062
								],
								[
									5888,
									5984
								],
								[
									6037,
									5981
								],
								[
									6047,
									5965
								],
								[
									6007,
									5857
								],
								[
									5992,
									5849
								],
								[
									5984,
									5790
								],
								[
									5930,
									5747
								],
								[
									5885,
									5773
								],
								[
									5906,
									5741
								],
								[
									5865,
									5761
								],
								[
									5846,
									5790
								],
								[
									5847,
									5739
								],
								[
									5817,
									5675
								],
								[
									5792,
									5685
								],
								[
									5784,
									5645
								],
								[
									5747,
									5676
								],
								[
									5696,
									5688
								],
								[
									5732,
									5649
								],
								[
									5778,
									5636
								],
								[
									5792,
									5580
								],
								[
									5739,
									5530
								],
								[
									5677,
									5541
								],
								[
									5652,
									5525
								],
								[
									5691,
									5503
								],
								[
									5691,
									5481
								],
								[
									5633,
									5468
								],
								[
									5635,
									5435
								],
								[
									5606,
									5417
								],
								[
									5609,
									5357
								],
								[
									5536,
									5292
								],
								[
									5549,
									5270
								],
								[
									5508,
									5189
								],
								[
									5472,
									5043
								],
								[
									5434,
									5043
								],
								[
									4864,
									5059
								]
							]
						],
						[
							[
								[
									4538,
									7362
								],
								[
									4550,
									7358
								],
								[
									4540,
									7369
								],
								[
									4540,
									7375
								],
								[
									4553,
									7369
								],
								[
									4544,
									7395
								],
								[
									4546,
									7411
								],
								[
									4559,
									7413
								],
								[
									4547,
									7420
								],
								[
									4555,
									7465
								],
								[
									4622,
									7371
								],
								[
									4615,
									7331
								],
								[
									4632,
									7247
								],
								[
									4622,
									7218
								],
								[
									4652,
									7182
								],
								[
									4687,
									7232
								],
								[
									4662,
									7281
								],
								[
									4659,
									7356
								],
								[
									4667,
									7494
								],
								[
									4680,
									7522
								],
								[
									4724,
									7484
								],
								[
									4744,
									7506
								],
								[
									4797,
									7439
								],
								[
									4820,
									7392
								],
								[
									4817,
									7326
								],
								[
									4826,
									7257
								],
								[
									4856,
									7153
								],
								[
									4858,
									7106
								],
								[
									4831,
									7061
								],
								[
									4867,
									6987
								],
								[
									4916,
									6937
								],
								[
									4934,
									6936
								],
								[
									5014,
									6854
								],
								[
									5049,
									6861
								],
								[
									5053,
									6793
								],
								[
									5024,
									6753
								],
								[
									5015,
									6812
								],
								[
									4999,
									6766
								],
								[
									4969,
									6803
								],
								[
									4940,
									6788
								],
								[
									4924,
									6751
								],
								[
									4884,
									6786
								],
								[
									4878,
									6770
								],
								[
									4919,
									6723
								],
								[
									4972,
									6737
								],
								[
									4962,
									6713
								],
								[
									4988,
									6675
								],
								[
									4969,
									6614
								],
								[
									4986,
									6606
								],
								[
									4973,
									6566
								],
								[
									4942,
									6590
								],
								[
									4970,
									6641
								],
								[
									4899,
									6614
								],
								[
									4869,
									6614
								],
								[
									4805,
									6649
								],
								[
									4794,
									6635
								],
								[
									4750,
									6656
								],
								[
									4775,
									6671
								],
								[
									4679,
									6708
								],
								[
									4690,
									6748
								],
								[
									4674,
									6768
								],
								[
									4614,
									6685
								],
								[
									4532,
									6681
								],
								[
									4499,
									6647
								],
								[
									4452,
									6635
								],
								[
									4334,
									6644
								],
								[
									4237,
									6638
								],
								[
									4201,
									6669
								],
								[
									4188,
									6711
								],
								[
									4200,
									6784
								],
								[
									4158,
									6810
								],
								[
									4104,
									6813
								],
								[
									4056,
									6834
								],
								[
									4020,
									6874
								],
								[
									4014,
									6911
								],
								[
									4012,
									6980
								],
								[
									4280,
									6923
								],
								[
									4276,
									6892
								],
								[
									4303,
									6890
								],
								[
									4306,
									6918
								],
								[
									4466,
									6891
								],
								[
									4538,
									7362
								]
							]
						],
						[
							[
								[
									4647,
									8062
								],
								[
									4689,
									8096
								],
								[
									4657,
									8128
								],
								[
									4666,
									8183
								],
								[
									4718,
									8249
								],
								[
									4739,
									8256
								],
								[
									4749,
									8215
								],
								[
									4734,
									8208
								],
								[
									4757,
									8127
								],
								[
									4728,
									8077
								],
								[
									4762,
									8078
								],
								[
									4755,
									8044
								],
								[
									4799,
									8036
								],
								[
									4826,
									8070
								],
								[
									4867,
									8050
								],
								[
									4879,
									7978
								],
								[
									4856,
									7944
								],
								[
									4858,
									7915
								],
								[
									4833,
									7855
								],
								[
									4749,
									7841
								],
								[
									4743,
									7864
								],
								[
									4700,
									7842
								],
								[
									4683,
									7877
								],
								[
									4636,
									7839
								],
								[
									4613,
									7841
								],
								[
									4635,
									7985
								],
								[
									4691,
									7965
								],
								[
									4688,
									8021
								],
								[
									4646,
									8055
								],
								[
									4647,
									8062
								]
							]
						],
						[
							[
								[
									4721,
									8536
								],
								[
									4739,
									8523
								],
								[
									4715,
									8498
								],
								[
									4721,
									8536
								]
							]
						],
						[
							[
								[
									4741,
									8668
								],
								[
									4767,
									8611
								],
								[
									4754,
									8578
								],
								[
									4729,
									8587
								],
								[
									4741,
									8664
								],
								[
									4741,
									8668
								]
							]
						],
						[
							[
								[
									7960,
									5557
								],
								[
									7960,
									5549
								],
								[
									7925,
									5563
								],
								[
									7964,
									5560
								],
								[
									7960,
									5557
								]
							]
						],
						[
							[
								[
									6387,
									5601
								],
								[
									6463,
									5634
								],
								[
									6484,
									5595
								],
								[
									6402,
									5486
								],
								[
									6360,
									5475
								],
								[
									6333,
									5532
								],
								[
									6371,
									5613
								],
								[
									6387,
									5601
								]
							]
						],
						[
							[
								[
									6662,
									6527
								],
								[
									6684,
									6636
								],
								[
									6707,
									6655
								],
								[
									6755,
									6662
								],
								[
									6789,
									6655
								],
								[
									6822,
									6533
								],
								[
									6808,
									6494
								],
								[
									6778,
									6468
								],
								[
									6703,
									6449
								],
								[
									6662,
									6527
								]
							]
						],
						[
							[
								[
									4769,
									7583
								],
								[
									4851,
									7584
								],
								[
									4885,
									7542
								],
								[
									4875,
									7491
								],
								[
									4825,
									7404
								],
								[
									4767,
									7523
								],
								[
									4739,
									7541
								],
								[
									4769,
									7583
								]
							]
						],
						[
							[
								[
									6833,
									4490
								],
								[
									6865,
									4557
								],
								[
									6852,
									4632
								],
								[
									6833,
									4641
								],
								[
									6853,
									4641
								],
								[
									6869,
									4552
								],
								[
									6894,
									4609
								],
								[
									6933,
									4600
								],
								[
									6946,
									4558
								],
								[
									6907,
									4579
								],
								[
									6884,
									4496
								],
								[
									6867,
									4531
								],
								[
									6846,
									4480
								],
								[
									6833,
									4490
								]
							]
						],
						[
							[
								[
									6534,
									5730
								],
								[
									6446,
									5758
								],
								[
									6415,
									5753
								],
								[
									6404,
									5802
								],
								[
									6364,
									5793
								],
								[
									6362,
									5834
								],
								[
									6315,
									5796
								],
								[
									6324,
									5754
								],
								[
									6278,
									5723
								],
								[
									6262,
									5666
								],
								[
									6212,
									5627
								],
								[
									6182,
									5644
								],
								[
									6178,
									5708
								],
								[
									6160,
									5724
								],
								[
									6056,
									5690
								],
								[
									6072,
									5753
								],
								[
									6122,
									5788
								],
								[
									6096,
									5873
								],
								[
									6109,
									5935
								],
								[
									6101,
									5996
								],
								[
									6109,
									6083
								],
								[
									6139,
									6115
								],
								[
									6177,
									6064
								],
								[
									6159,
									6049
								],
								[
									6201,
									5995
								],
								[
									6215,
									6046
								],
								[
									6256,
									6001
								],
								[
									6310,
									5995
								],
								[
									6328,
									5964
								],
								[
									6396,
									5942
								],
								[
									6447,
									5904
								],
								[
									6473,
									5857
								],
								[
									6444,
									5814
								],
								[
									6489,
									5833
								],
								[
									6557,
									5826
								],
								[
									6587,
									5802
								],
								[
									6534,
									5730
								]
							]
						],
						[
							[
								[
									5384,
									6583
								],
								[
									5336,
									6530
								],
								[
									5271,
									6547
								],
								[
									5252,
									6569
								],
								[
									5201,
									6589
								],
								[
									5170,
									6628
								],
								[
									5157,
									6605
								],
								[
									5131,
									6641
								],
								[
									5212,
									6695
								],
								[
									5199,
									6719
								],
								[
									5226,
									6785
								],
								[
									5276,
									6803
								],
								[
									5312,
									6727
								],
								[
									5361,
									6739
								],
								[
									5350,
									6707
								],
								[
									5381,
									6613
								],
								[
									5424,
									6606
								],
								[
									5403,
									6573
								],
								[
									5384,
									6583
								]
							]
						],
						[
							[
								[
									6248,
									7535
								],
								[
									6232,
									7622
								],
								[
									6250,
									7636
								],
								[
									6311,
									7619
								],
								[
									6383,
									7640
								],
								[
									6441,
									7619
								],
								[
									6514,
									7549
								],
								[
									6521,
									7494
								],
								[
									6455,
									7493
								],
								[
									6411,
									7487
								],
								[
									6359,
									7448
								],
								[
									6311,
									7458
								],
								[
									6285,
									7532
								],
								[
									6248,
									7535
								]
							]
						],
						[
							[
								[
									5245,
									7117
								],
								[
									5202,
									7068
								],
								[
									5170,
									7084
								],
								[
									5135,
									7185
								],
								[
									5092,
									7251
								],
								[
									5058,
									7282
								],
								[
									5021,
									7283
								],
								[
									5016,
									7317
								],
								[
									4979,
									7352
								],
								[
									4973,
									7383
								],
								[
									4993,
									7427
								],
								[
									5019,
									7433
								],
								[
									5058,
									7358
								],
								[
									5108,
									7359
								],
								[
									5134,
									7403
								],
								[
									5125,
									7438
								],
								[
									5103,
									7442
								],
								[
									5120,
									7477
								],
								[
									5090,
									7465
								],
								[
									5048,
									7514
								],
								[
									5090,
									7534
								],
								[
									5094,
									7580
								],
								[
									5142,
									7565
								],
								[
									5133,
									7596
								],
								[
									5157,
									7599
								],
								[
									5188,
									7557
								],
								[
									5252,
									7572
								],
								[
									5263,
									7588
								],
								[
									5300,
									7579
								],
								[
									5314,
									7531
								],
								[
									5289,
									7513
								],
								[
									5305,
									7485
								],
								[
									5271,
									7468
								],
								[
									5234,
									7416
								],
								[
									5297,
									7398
								],
								[
									5311,
									7361
								],
								[
									5326,
									7385
								],
								[
									5353,
									7291
								],
								[
									5338,
									7259
								],
								[
									5337,
									7176
								],
								[
									5312,
									7170
								],
								[
									5281,
									7133
								],
								[
									5235,
									7142
								],
								[
									5245,
									7117
								]
							]
						],
						[
							[
								[
									5502,
									7743
								],
								[
									5441,
									7737
								],
								[
									5409,
									7773
								],
								[
									5398,
									7760
								],
								[
									5407,
									7709
								],
								[
									5378,
									7727
								],
								[
									5397,
									7775
								],
								[
									5377,
									7777
								],
								[
									5352,
									7815
								],
								[
									5346,
									7854
								],
								[
									5382,
									7919
								],
								[
									5429,
									7949
								],
								[
									5434,
									7979
								],
								[
									5427,
									8012
								],
								[
									5448,
									8024
								],
								[
									5459,
									7975
								],
								[
									5441,
									7971
								],
								[
									5504,
									7871
								],
								[
									5512,
									7792
								],
								[
									5502,
									7743
								]
							]
						],
						[
							[
								[
									5225,
									8161
								],
								[
									5287,
									8130
								],
								[
									5280,
									8095
								],
								[
									5294,
									8059
								],
								[
									5289,
									7996
								],
								[
									5270,
									7971
								],
								[
									5299,
									7957
								],
								[
									5256,
									7885
								],
								[
									5287,
									7846
								],
								[
									5261,
									7820
								],
								[
									5174,
									7812
								],
								[
									5137,
									7822
								],
								[
									5121,
									7912
								],
								[
									5157,
									7914
								],
								[
									5170,
									7956
								],
								[
									5085,
									7950
								],
								[
									5021,
									7931
								],
								[
									5021,
									7969
								],
								[
									5044,
									7977
								],
								[
									5046,
									8008
								],
								[
									5068,
									8014
								],
								[
									5091,
									7986
								],
								[
									5067,
									8053
								],
								[
									5096,
									8087
								],
								[
									5059,
									8082
								],
								[
									5077,
									8132
								],
								[
									5112,
									8105
								],
								[
									5110,
									8083
								],
								[
									5173,
									8018
								],
								[
									5142,
									8080
								],
								[
									5166,
									8095
								],
								[
									5134,
									8112
								],
								[
									5119,
									8140
								],
								[
									5133,
									8170
								],
								[
									5085,
									8160
								],
								[
									5123,
									8190
								],
								[
									5159,
									8189
								],
								[
									5188,
									8165
								],
								[
									5212,
									8125
								],
								[
									5225,
									8161
								]
							]
						],
						[
							[
								[
									5710,
									8076
								],
								[
									5615,
									8066
								],
								[
									5670,
									8049
								],
								[
									5624,
									8039
								],
								[
									5676,
									8021
								],
								[
									5685,
									8036
								],
								[
									5726,
									7994
								],
								[
									5725,
									7960
								],
								[
									5746,
									7918
								],
								[
									5760,
									7968
								],
								[
									5783,
									7931
								],
								[
									5824,
									7964
								],
								[
									5879,
									7931
								],
								[
									5945,
									7986
								],
								[
									5970,
									7982
								],
								[
									6008,
									8031
								],
								[
									6044,
									8017
								],
								[
									6080,
									8045
								],
								[
									6145,
									8041
								],
								[
									6140,
									8015
								],
								[
									6180,
									8022
								],
								[
									6232,
									7990
								],
								[
									6244,
									7930
								],
								[
									6206,
									7893
								],
								[
									6252,
									7897
								],
								[
									6268,
									7870
								],
								[
									6226,
									7838
								],
								[
									6236,
									7811
								],
								[
									6175,
									7788
								],
								[
									6153,
									7762
								],
								[
									6088,
									7772
								],
								[
									6069,
									7828
								],
								[
									6056,
									7773
								],
								[
									6017,
									7753
								],
								[
									5889,
									7731
								],
								[
									5783,
									7727
								],
								[
									5776,
									7809
								],
								[
									5761,
									7759
								],
								[
									5704,
									7728
								],
								[
									5643,
									7759
								],
								[
									5655,
									7798
								],
								[
									5617,
									7746
								],
								[
									5588,
									7772
								],
								[
									5580,
									7846
								],
								[
									5560,
									7862
								],
								[
									5566,
									7925
								],
								[
									5581,
									7944
								],
								[
									5569,
									8006
								],
								[
									5517,
									8106
								],
								[
									5470,
									8081
								],
								[
									5380,
									8110
								],
								[
									5347,
									8173
								],
								[
									5355,
									8199
								],
								[
									5331,
									8238
								],
								[
									5382,
									8258
								],
								[
									5485,
									8225
								],
								[
									5518,
									8162
								],
								[
									5537,
									8156
								],
								[
									5599,
									8180
								],
								[
									5644,
									8154
								],
								[
									5649,
									8134
								],
								[
									5604,
									8129
								],
								[
									5712,
									8102
								],
								[
									5710,
									8076
								]
							]
						],
						[
							[
								[
									5491,
									8345
								],
								[
									5372,
									8346
								],
								[
									5357,
									8372
								],
								[
									5376,
									8409
								],
								[
									5397,
									8421
								],
								[
									5484,
									8415
								],
								[
									5504,
									8403
								],
								[
									5491,
									8345
								]
							]
						],
						[
							[
								[
									5275,
									8651
								],
								[
									5306,
									8645
								],
								[
									5364,
									8605
								],
								[
									5425,
									8546
								],
								[
									5400,
									8519
								],
								[
									5423,
									8488
								],
								[
									5415,
									8457
								],
								[
									5319,
									8431
								],
								[
									5324,
									8446
								],
								[
									5288,
									8473
								],
								[
									5331,
									8494
								],
								[
									5286,
									8515
								],
								[
									5261,
									8577
								],
								[
									5275,
									8651
								]
							]
						],
						[
							[
								[
									4979,
									8614
								],
								[
									5030,
									8592
								],
								[
									5035,
									8657
								],
								[
									5002,
									8659
								],
								[
									5021,
									8680
								],
								[
									5013,
									8704
								],
								[
									4967,
									8672
								],
								[
									4987,
									8713
								],
								[
									4948,
									8720
								],
								[
									4963,
									8791
								],
								[
									4973,
									8782
								],
								[
									5036,
									8791
								],
								[
									5070,
									8758
								],
								[
									5087,
									8705
								],
								[
									5122,
									8718
								],
								[
									5149,
									8682
								],
								[
									5138,
									8657
								],
								[
									5174,
									8657
								],
								[
									5210,
									8602
								],
								[
									5194,
									8566
								],
								[
									5229,
									8484
								],
								[
									5229,
									8441
								],
								[
									5184,
									8418
								],
								[
									5153,
									8438
								],
								[
									5135,
									8516
								],
								[
									5087,
									8538
								],
								[
									5057,
									8528
								],
								[
									5062,
									8561
								],
								[
									4981,
									8543
								],
								[
									4959,
									8598
								],
								[
									4979,
									8614
								]
							]
						],
						[
							[
								[
									5435,
									9200
								],
								[
									5481,
									9199
								],
								[
									5478,
									9228
								],
								[
									5432,
									9239
								],
								[
									5440,
									9266
								],
								[
									5475,
									9268
								],
								[
									5532,
									9217
								],
								[
									5583,
									9072
								],
								[
									5640,
									9068
								],
								[
									5652,
									9052
								],
								[
									5647,
									9012
								],
								[
									5658,
									8986
								],
								[
									5696,
									8966
								],
								[
									5669,
									9010
								],
								[
									5676,
									9047
								],
								[
									5708,
									9043
								],
								[
									5718,
									8987
								],
								[
									5706,
									8959
								],
								[
									5735,
									8962
								],
								[
									5750,
									8925
								],
								[
									5749,
									8845
								],
								[
									5770,
									8866
								],
								[
									5817,
									8853
								],
								[
									5853,
									8790
								],
								[
									5831,
									8757
								],
								[
									5790,
									8730
								],
								[
									5753,
									8634
								],
								[
									5738,
									8637
								],
								[
									5727,
									8698
								],
								[
									5717,
									8696
								],
								[
									5725,
									8633
								],
								[
									5738,
									8605
								],
								[
									5727,
									8534
								],
								[
									5726,
									8583
								],
								[
									5698,
									8617
								],
								[
									5712,
									8575
								],
								[
									5706,
									8518
								],
								[
									5693,
									8516
								],
								[
									5642,
									8612
								],
								[
									5646,
									8572
								],
								[
									5675,
									8511
								],
								[
									5641,
									8545
								],
								[
									5633,
									8504
								],
								[
									5556,
									8515
								],
								[
									5527,
									8542
								],
								[
									5513,
									8581
								],
								[
									5565,
									8595
								],
								[
									5515,
									8611
								],
								[
									5497,
									8599
								],
								[
									5448,
									8685
								],
								[
									5493,
									8733
								],
								[
									5552,
									8734
								],
								[
									5616,
									8755
								],
								[
									5542,
									8743
								],
								[
									5521,
									8767
								],
								[
									5552,
									8776
								],
								[
									5518,
									8800
								],
								[
									5461,
									8753
								],
								[
									5465,
									8786
								],
								[
									5435,
									8772
								],
								[
									5382,
									8787
								],
								[
									5388,
									8823
								],
								[
									5425,
									8835
								],
								[
									5443,
									8871
								],
								[
									5405,
									8844
								],
								[
									5377,
									8845
								],
								[
									5345,
									8901
								],
								[
									5342,
									8964
								],
								[
									5370,
									8945
								],
								[
									5419,
									8939
								],
								[
									5450,
									8972
								],
								[
									5428,
									8982
								],
								[
									5396,
									8959
								],
								[
									5348,
									8995
								],
								[
									5373,
									9023
								],
								[
									5367,
									9048
								],
								[
									5386,
									9088
								],
								[
									5404,
									9099
								],
								[
									5430,
									9075
								],
								[
									5430,
									9105
								],
								[
									5391,
									9125
								],
								[
									5391,
									9150
								],
								[
									5415,
									9189
								],
								[
									5435,
									9167
								],
								[
									5435,
									9200
								]
							]
						],
						[
							[
								[
									6308,
									8614
								],
								[
									6261,
									8616
								],
								[
									6249,
									8602
								],
								[
									6314,
									8595
								],
								[
									6306,
									8557
								],
								[
									6289,
									8568
								],
								[
									6265,
									8536
								],
								[
									6202,
									8537
								],
								[
									6239,
									8461
								],
								[
									6223,
									8407
								],
								[
									6186,
									8381
								],
								[
									6106,
									8376
								],
								[
									6061,
									8410
								],
								[
									6056,
									8391
								],
								[
									6086,
									8370
								],
								[
									6056,
									8358
								],
								[
									6065,
									8332
								],
								[
									6092,
									8363
								],
								[
									6147,
									8351
								],
								[
									6174,
									8367
								],
								[
									6200,
									8342
								],
								[
									6189,
									8300
								],
								[
									6236,
									8328
								],
								[
									6258,
									8322
								],
								[
									6278,
									8259
								],
								[
									6251,
									8208
								],
								[
									6233,
									8231
								],
								[
									6215,
									8166
								],
								[
									6135,
									8115
								],
								[
									6139,
									8179
								],
								[
									6114,
									8193
								],
								[
									6079,
									8186
								],
								[
									6064,
									8163
								],
								[
									5993,
									8159
								],
								[
									5962,
									8196
								],
								[
									5965,
									8159
								],
								[
									5930,
									8149
								],
								[
									5960,
									8128
								],
								[
									5917,
									8125
								],
								[
									5857,
									8137
								],
								[
									5842,
									8123
								],
								[
									5806,
									8143
								],
								[
									5796,
									8116
								],
								[
									5756,
									8125
								],
								[
									5742,
									8216
								],
								[
									5730,
									8127
								],
								[
									5689,
									8159
								],
								[
									5692,
									8221
								],
								[
									5748,
									8287
								],
								[
									5782,
									8282
								],
								[
									5812,
									8322
								],
								[
									5773,
									8337
								],
								[
									5772,
									8367
								],
								[
									5744,
									8398
								],
								[
									5741,
									8434
								],
								[
									5785,
									8462
								],
								[
									5834,
									8441
								],
								[
									5861,
									8380
								],
								[
									5882,
									8359
								],
								[
									5930,
									8343
								],
								[
									5920,
									8360
								],
								[
									5976,
									8359
								],
								[
									5957,
									8384
								],
								[
									5974,
									8394
								],
								[
									6002,
									8501
								],
								[
									5988,
									8512
								],
								[
									5971,
									8417
								],
								[
									5951,
									8388
								],
								[
									5881,
									8401
								],
								[
									5883,
									8450
								],
								[
									5856,
									8479
								],
								[
									5881,
									8508
								],
								[
									5887,
									8573
								],
								[
									5859,
									8518
								],
								[
									5827,
									8502
								],
								[
									5809,
									8533
								],
								[
									5800,
									8512
								],
								[
									5767,
									8510
								],
								[
									5760,
									8584
								],
								[
									5791,
									8669
								],
								[
									5829,
									8679
								],
								[
									5849,
									8701
								],
								[
									5918,
									8691
								],
								[
									5965,
									8664
								],
								[
									5941,
									8697
								],
								[
									6004,
									8710
								],
								[
									6010,
									8754
								],
								[
									5970,
									8710
								],
								[
									5949,
									8720
								],
								[
									5891,
									8715
								],
								[
									5867,
									8732
								],
								[
									5875,
									8758
								],
								[
									5925,
									8737
								],
								[
									5881,
									8769
								],
								[
									5868,
									8820
								],
								[
									5839,
									8865
								],
								[
									5773,
									8894
								],
								[
									5775,
									8943
								],
								[
									5757,
									8985
								],
								[
									5761,
									9026
								],
								[
									5808,
									9019
								],
								[
									5871,
									9022
								],
								[
									5951,
									8941
								],
								[
									5983,
									8880
								],
								[
									6026,
									8889
								],
								[
									6058,
									8920
								],
								[
									6013,
									8899
								],
								[
									5984,
									8909
								],
								[
									5971,
									8953
								],
								[
									5893,
									9041
								],
								[
									5939,
									9070
								],
								[
									6001,
									9097
								],
								[
									6011,
									9112
								],
								[
									6088,
									9144
								],
								[
									6011,
									9133
								],
								[
									6059,
									9185
								],
								[
									6132,
									9216
								],
								[
									6128,
									9230
								],
								[
									6074,
									9219
								],
								[
									6043,
									9201
								],
								[
									6035,
									9239
								],
								[
									6068,
									9324
								],
								[
									6089,
									9363
								],
								[
									6047,
									9316
								],
								[
									6018,
									9233
								],
								[
									6015,
									9188
								],
								[
									5961,
									9129
								],
								[
									5897,
									9097
								],
								[
									5887,
									9124
								],
								[
									5920,
									9147
								],
								[
									5923,
									9175
								],
								[
									5876,
									9133
								],
								[
									5858,
									9143
								],
								[
									5860,
									9097
								],
								[
									5838,
									9082
								],
								[
									5769,
									9080
								],
								[
									5742,
									9094
								],
								[
									5770,
									9182
								],
								[
									5791,
									9204
								],
								[
									5882,
									9244
								],
								[
									5894,
									9259
								],
								[
									5783,
									9212
								],
								[
									5757,
									9192
								],
								[
									5720,
									9098
								],
								[
									5686,
									9107
								],
								[
									5631,
									9152
								],
								[
									5634,
									9171
								],
								[
									5667,
									9185
								],
								[
									5733,
									9193
								],
								[
									5801,
									9271
								],
								[
									5781,
									9272
								],
								[
									5737,
									9223
								],
								[
									5612,
									9184
								],
								[
									5589,
									9223
								],
								[
									5624,
									9245
								],
								[
									5602,
									9267
								],
								[
									5639,
									9310
								],
								[
									5673,
									9322
								],
								[
									5655,
									9333
								],
								[
									5580,
									9272
								],
								[
									5566,
									9295
								],
								[
									5610,
									9341
								],
								[
									5568,
									9350
								],
								[
									5543,
									9314
								],
								[
									5522,
									9336
								],
								[
									5554,
									9392
								],
								[
									5598,
									9415
								],
								[
									5615,
									9390
								],
								[
									5635,
									9454
								],
								[
									5658,
									9468
								],
								[
									5743,
									9446
								],
								[
									5778,
									9451
								],
								[
									5703,
									9481
								],
								[
									5696,
									9502
								],
								[
									5747,
									9526
								],
								[
									5727,
									9571
								],
								[
									5804,
									9549
								],
								[
									5838,
									9494
								],
								[
									5852,
									9488
								],
								[
									5830,
									9539
								],
								[
									5886,
									9500
								],
								[
									5949,
									9470
								],
								[
									5984,
									9437
								],
								[
									5952,
									9486
								],
								[
									5910,
									9500
								],
								[
									5836,
									9562
								],
								[
									5839,
									9597
								],
								[
									5874,
									9599
								],
								[
									5843,
									9618
								],
								[
									5847,
									9643
								],
								[
									5893,
									9612
								],
								[
									5902,
									9620
								],
								[
									5858,
									9676
								],
								[
									5901,
									9682
								],
								[
									5946,
									9658
								],
								[
									5966,
									9667
								],
								[
									5916,
									9679
								],
								[
									5899,
									9724
								],
								[
									5924,
									9739
								],
								[
									5941,
									9715
								],
								[
									5976,
									9735
								],
								[
									6002,
									9724
								],
								[
									6032,
									9677
								],
								[
									6059,
									9662
								],
								[
									6017,
									9731
								],
								[
									5987,
									9755
								],
								[
									6024,
									9781
								],
								[
									6090,
									9782
								],
								[
									6111,
									9749
								],
								[
									6163,
									9716
								],
								[
									6113,
									9766
								],
								[
									6125,
									9810
								],
								[
									6166,
									9830
								],
								[
									6178,
									9789
								],
								[
									6207,
									9780
								],
								[
									6176,
									9810
								],
								[
									6191,
									9839
								],
								[
									6226,
									9851
								],
								[
									6238,
									9818
								],
								[
									6284,
									9835
								],
								[
									6345,
									9839
								],
								[
									6350,
									9827
								],
								[
									6299,
									9735
								],
								[
									6335,
									9755
								],
								[
									6371,
									9819
								],
								[
									6390,
									9807
								],
								[
									6402,
									9849
								],
								[
									6423,
									9814
								],
								[
									6449,
									9842
								],
								[
									6453,
									9812
								],
								[
									6498,
									9772
								],
								[
									6541,
									9781
								],
								[
									6566,
									9760
								],
								[
									6579,
									9713
								],
								[
									6560,
									9689
								],
								[
									6564,
									9658
								],
								[
									6519,
									9558
								],
								[
									6480,
									9555
								],
								[
									6487,
									9535
								],
								[
									6396,
									9473
								],
								[
									6430,
									9486
								],
								[
									6457,
									9476
								],
								[
									6358,
									9355
								],
								[
									6379,
									9367
								],
								[
									6490,
									9485
								],
								[
									6528,
									9514
								],
								[
									6536,
									9474
								],
								[
									6503,
									9419
								],
								[
									6493,
									9366
								],
								[
									6455,
									9280
								],
								[
									6438,
									9217
								],
								[
									6439,
									9182
								],
								[
									6400,
									9157
								],
								[
									6425,
									9143
								],
								[
									6351,
									9071
								],
								[
									6406,
									9108
								],
								[
									6414,
									9072
								],
								[
									6399,
									9005
								],
								[
									6373,
									8979
								],
								[
									6342,
									8982
								],
								[
									6330,
									9004
								],
								[
									6277,
									9012
								],
								[
									6254,
									8995
								],
								[
									6319,
									8993
								],
								[
									6341,
									8941
								],
								[
									6311,
									8911
								],
								[
									6265,
									8911
								],
								[
									6273,
									8884
								],
								[
									6217,
									8900
								],
								[
									6237,
									8869
								],
								[
									6197,
									8862
								],
								[
									6168,
									8880
								],
								[
									6181,
									8838
								],
								[
									6304,
									8856
								],
								[
									6293,
									8845
								],
								[
									6314,
									8812
								],
								[
									6250,
									8814
								],
								[
									6237,
									8835
								],
								[
									6153,
									8811
								],
								[
									6239,
									8816
								],
								[
									6183,
									8780
								],
								[
									6165,
									8784
								],
								[
									6160,
									8722
								],
								[
									6178,
									8766
								],
								[
									6217,
									8790
								],
								[
									6261,
									8787
								],
								[
									6238,
									8756
								],
								[
									6287,
									8770
								],
								[
									6321,
									8742
								],
								[
									6324,
									8708
								],
								[
									6302,
									8686
								],
								[
									6251,
									8682
								],
								[
									6322,
									8658
								],
								[
									6308,
									8614
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.NT",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.44,
					"hc-middle-y": 0.73,
					"hc-key": "ca-nt",
					"hc-a2": "NT",
					"labelrank": "2",
					"hasc": "CA.NT",
					"alt-name": "Territoires du Nord-Ouest",
					"woe-id": "2344920",
					"subregion": null,
					"fips": "CA13",
					"postal-code": "NT",
					"name": "Northwest Territories",
					"country": "Canada",
					"type-en": "Territory",
					"region": "Northern Canada",
					"longitude": "-119.942",
					"woe-name": "Northwest Territories",
					"latitude": "64.0831",
					"woe-label": "Northwest Territories, CA, Canada",
					"type": "Territoire"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									4497,
									8301
								],
								[
									4493,
									8262
								],
								[
									4436,
									8287
								],
								[
									4463,
									8307
								],
								[
									4497,
									8301
								]
							]
						],
						[
							[
								[
									4519,
									8552
								],
								[
									4543,
									8501
								],
								[
									4512,
									8483
								],
								[
									4480,
									8548
								],
								[
									4519,
									8552
								]
							]
						],
						[
							[
								[
									4864,
									5059
								],
								[
									4193,
									5133
								],
								[
									3366,
									5309
								],
								[
									3057,
									5399
								],
								[
									3028,
									5530
								],
								[
									3045,
									5575
								],
								[
									2978,
									5565
								],
								[
									2939,
									5598
								],
								[
									2925,
									5586
								],
								[
									2855,
									5606
								],
								[
									2874,
									5723
								],
								[
									2823,
									5782
								],
								[
									2806,
									5868
								],
								[
									2761,
									5884
								],
								[
									2781,
									5943
								],
								[
									2760,
									6020
								],
								[
									2785,
									6052
								],
								[
									2763,
									6106
								],
								[
									2795,
									6123
								],
								[
									2795,
									6181
								],
								[
									2761,
									6230
								],
								[
									2762,
									6315
								],
								[
									2711,
									6327
								],
								[
									2731,
									6347
								],
								[
									2717,
									6386
								],
								[
									2686,
									6414
								],
								[
									2720,
									6449
								],
								[
									2703,
									6480
								],
								[
									2769,
									6535
								],
								[
									2761,
									6589
								],
								[
									2774,
									6619
								],
								[
									2710,
									6630
								],
								[
									2710,
									6702
								],
								[
									2743,
									6737
								],
								[
									2746,
									6820
								],
								[
									2610,
									6886
								],
								[
									2642,
									6946
								],
								[
									2648,
									7013
								],
								[
									2743,
									7211
								],
								[
									2764,
									7196
								],
								[
									2789,
									7141
								],
								[
									2784,
									7229
								],
								[
									2811,
									7261
								],
								[
									2888,
									7266
								],
								[
									2904,
									7247
								],
								[
									2935,
									7290
								],
								[
									2949,
									7236
								],
								[
									2901,
									7206
								],
								[
									2951,
									7216
								],
								[
									2977,
									7206
								],
								[
									3016,
									7242
								],
								[
									3087,
									7234
								],
								[
									3127,
									7257
								],
								[
									3130,
									7227
								],
								[
									3186,
									7270
								],
								[
									3227,
									7242
								],
								[
									3253,
									7270
								],
								[
									3259,
									7240
								],
								[
									3238,
									7219
								],
								[
									3126,
									7192
								],
								[
									3061,
									7197
								],
								[
									3041,
									7170
								],
								[
									3005,
									7171
								],
								[
									2925,
									7115
								],
								[
									2962,
									7088
								],
								[
									2972,
									7137
								],
								[
									3050,
									7151
								],
								[
									3077,
									7178
								],
								[
									3105,
									7124
								],
								[
									3173,
									7185
								],
								[
									3258,
									7184
								],
								[
									3254,
									7149
								],
								[
									3316,
									7189
								],
								[
									3353,
									7237
								],
								[
									3363,
									7305
								],
								[
									3405,
									7210
								],
								[
									3401,
									7113
								],
								[
									3426,
									7034
								],
								[
									3453,
									7006
								],
								[
									3461,
									7042
								],
								[
									3503,
									7074
								],
								[
									3521,
									7123
								],
								[
									3566,
									7135
								],
								[
									3536,
									7059
								],
								[
									3561,
									7052
								],
								[
									3518,
									6995
								],
								[
									3566,
									6978
								],
								[
									3605,
									6992
								],
								[
									3638,
									7050
								],
								[
									3729,
									7008
								],
								[
									3766,
									6957
								],
								[
									3689,
									6680
								],
								[
									3690,
									6676
								],
								[
									4156,
									6106
								],
								[
									4287,
									6083
								],
								[
									4355,
									5970
								],
								[
									4379,
									5945
								],
								[
									4431,
									5925
								],
								[
									4912,
									5785
								],
								[
									4864,
									5059
								],
								[
									4864,
									5059
								]
							]
						],
						[
							[
								[
									4540,
									7369
								],
								[
									4526,
									7384
								],
								[
									4540,
									7375
								],
								[
									4540,
									7369
								]
							]
						],
						[
							[
								[
									4546,
									7411
								],
								[
									4544,
									7395
								],
								[
									4539,
									7403
								],
								[
									4546,
									7411
								]
							]
						],
						[
							[
								[
									4547,
									7420
								],
								[
									4522,
									7441
								],
								[
									4515,
									7476
								],
								[
									4555,
									7465
								],
								[
									4547,
									7420
								]
							]
						],
						[
							[
								[
									4646,
									8055
								],
								[
									4644,
									8059
								],
								[
									4647,
									8062
								],
								[
									4646,
									8055
								]
							]
						],
						[
							[
								[
									4657,
									8128
								],
								[
									4645,
									8175
								],
								[
									4666,
									8183
								],
								[
									4657,
									8128
								]
							]
						],
						[
							[
								[
									4635,
									7985
								],
								[
									4613,
									7841
								],
								[
									4512,
									7784
								],
								[
									4434,
									7776
								],
								[
									4399,
									7793
								],
								[
									4369,
									7850
								],
								[
									4468,
									7894
								],
								[
									4535,
									7888
								],
								[
									4576,
									7932
								],
								[
									4497,
									7918
								],
								[
									4410,
									7924
								],
								[
									4430,
									7977
								],
								[
									4418,
									7985
								],
								[
									4385,
									7928
								],
								[
									4353,
									7914
								],
								[
									4348,
									7958
								],
								[
									4313,
									7923
								],
								[
									4289,
									7949
								],
								[
									4296,
									7978
								],
								[
									4270,
									7966
								],
								[
									4230,
									7991
								],
								[
									4235,
									8024
								],
								[
									4260,
									8045
								],
								[
									4320,
									8032
								],
								[
									4365,
									8047
								],
								[
									4381,
									8067
								],
								[
									4320,
									8052
								],
								[
									4264,
									8064
								],
								[
									4291,
									8104
								],
								[
									4397,
									8098
								],
								[
									4399,
									8107
								],
								[
									4329,
									8113
								],
								[
									4305,
									8125
								],
								[
									4313,
									8158
								],
								[
									4368,
									8185
								],
								[
									4366,
									8210
								],
								[
									4391,
									8228
								],
								[
									4456,
									8218
								],
								[
									4457,
									8156
								],
								[
									4509,
									8164
								],
								[
									4533,
									8137
								],
								[
									4531,
									8108
								],
								[
									4558,
									8084
								],
								[
									4533,
									8067
								],
								[
									4570,
									8059
								],
								[
									4569,
									7990
								],
								[
									4635,
									7985
								]
							]
						],
						[
							[
								[
									4721,
									8536
								],
								[
									4715,
									8498
								],
								[
									4674,
									8491
								],
								[
									4676,
									8467
								],
								[
									4704,
									8466
								],
								[
									4689,
									8406
								],
								[
									4593,
									8382
								],
								[
									4550,
									8435
								],
								[
									4564,
									8518
								],
								[
									4613,
									8534
								],
								[
									4688,
									8542
								],
								[
									4721,
									8536
								]
							]
						],
						[
							[
								[
									4741,
									8668
								],
								[
									4741,
									8664
								],
								[
									4729,
									8587
								],
								[
									4712,
									8580
								],
								[
									4679,
									8609
								],
								[
									4662,
									8585
								],
								[
									4632,
									8614
								],
								[
									4588,
									8599
								],
								[
									4586,
									8630
								],
								[
									4641,
									8655
								],
								[
									4655,
									8650
								],
								[
									4690,
									8679
								],
								[
									4725,
									8689
								],
								[
									4741,
									8668
								]
							]
						],
						[
							[
								[
									4210,
									8153
								],
								[
									4268,
									8183
								],
								[
									4276,
									8173
								],
								[
									4235,
									8107
								],
								[
									4188,
									8067
								],
								[
									4153,
									8098
								],
								[
									4210,
									8153
								]
							]
						],
						[
							[
								[
									4538,
									7362
								],
								[
									4466,
									6891
								],
								[
									4306,
									6918
								],
								[
									4303,
									6890
								],
								[
									4276,
									6892
								],
								[
									4280,
									6923
								],
								[
									4012,
									6980
								],
								[
									4014,
									6911
								],
								[
									3993,
									6939
								],
								[
									3991,
									6983
								],
								[
									4027,
									7002
								],
								[
									4090,
									7005
								],
								[
									4210,
									6998
								],
								[
									4307,
									6957
								],
								[
									4369,
									6967
								],
								[
									4345,
									7007
								],
								[
									4301,
									7024
								],
								[
									4267,
									7058
								],
								[
									4224,
									7064
								],
								[
									4053,
									7067
								],
								[
									4066,
									7086
								],
								[
									4027,
									7084
								],
								[
									3983,
									7152
								],
								[
									3980,
									7189
								],
								[
									4134,
									7223
								],
								[
									4158,
									7252
								],
								[
									4047,
									7243
								],
								[
									4006,
									7272
								],
								[
									4050,
									7282
								],
								[
									4029,
									7305
								],
								[
									3969,
									7313
								],
								[
									3984,
									7371
								],
								[
									4016,
									7405
								],
								[
									4052,
									7413
								],
								[
									4035,
									7459
								],
								[
									4068,
									7492
								],
								[
									4128,
									7536
								],
								[
									4307,
									7592
								],
								[
									4332,
									7533
								],
								[
									4316,
									7470
								],
								[
									4274,
									7440
								],
								[
									4325,
									7431
								],
								[
									4356,
									7485
								],
								[
									4382,
									7501
								],
								[
									4432,
									7468
								],
								[
									4476,
									7425
								],
								[
									4466,
									7395
								],
								[
									4427,
									7365
								],
								[
									4435,
									7345
								],
								[
									4499,
									7391
								],
								[
									4538,
									7362
								]
							]
						],
						[
							[
								[
									3818,
									7799
								],
								[
									3803,
									7822
								],
								[
									3802,
									7929
								],
								[
									3921,
									7916
								],
								[
									3982,
									7918
								],
								[
									4042,
									7842
								],
								[
									4093,
									7814
								],
								[
									4092,
									7771
								],
								[
									4116,
									7810
								],
								[
									4155,
									7813
								],
								[
									4188,
									7795
								],
								[
									4211,
									7759
								],
								[
									4270,
									7619
								],
								[
									4196,
									7590
								],
								[
									4012,
									7506
								],
								[
									3988,
									7454
								],
								[
									3956,
									7438
								],
								[
									3929,
									7448
								],
								[
									3904,
									7398
								],
								[
									3894,
									7348
								],
								[
									3868,
									7313
								],
								[
									3815,
									7305
								],
								[
									3803,
									7326
								],
								[
									3765,
									7296
								],
								[
									3698,
									7280
								],
								[
									3677,
									7412
								],
								[
									3624,
									7482
								],
								[
									3586,
									7496
								],
								[
									3654,
									7583
								],
								[
									3679,
									7591
								],
								[
									3692,
									7653
								],
								[
									3727,
									7650
								],
								[
									3716,
									7688
								],
								[
									3760,
									7744
								],
								[
									3818,
									7799
								]
							]
						],
						[
							[
								[
									4130,
									8341
								],
								[
									4173,
									8362
								],
								[
									4197,
									8399
								],
								[
									4277,
									8458
								],
								[
									4324,
									8453
								],
								[
									4348,
									8424
								],
								[
									4381,
									8440
								],
								[
									4361,
									8460
								],
								[
									4401,
									8474
								],
								[
									4436,
									8409
								],
								[
									4381,
									8380
								],
								[
									4403,
									8339
								],
								[
									4387,
									8328
								],
								[
									4384,
									8284
								],
								[
									4357,
									8264
								],
								[
									4317,
									8260
								],
								[
									4316,
									8223
								],
								[
									4290,
									8208
								],
								[
									4265,
									8245
								],
								[
									4298,
									8322
								],
								[
									4258,
									8318
								],
								[
									4259,
									8284
								],
								[
									4222,
									8276
								],
								[
									4235,
									8240
								],
								[
									4189,
									8201
								],
								[
									4190,
									8254
								],
								[
									4174,
									8239
								],
								[
									4172,
									8188
								],
								[
									4144,
									8157
								],
								[
									4112,
									8163
								],
								[
									4113,
									8240
								],
								[
									4093,
									8188
								],
								[
									4075,
									8187
								],
								[
									4056,
									8223
								],
								[
									4020,
									8208
								],
								[
									4019,
									8276
								],
								[
									4052,
									8305
								],
								[
									4094,
									8299
								],
								[
									4130,
									8341
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.AB",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.45,
					"hc-middle-y": 0.5,
					"hc-key": "ca-ab",
					"hc-a2": "AB",
					"labelrank": "2",
					"hasc": "CA.AB",
					"alt-name": null,
					"woe-id": "2344915",
					"subregion": "Prairies",
					"fips": "CA01",
					"postal-code": "AB",
					"name": "Alberta",
					"country": "Canada",
					"type-en": "Province",
					"region": "Western Canada",
					"longitude": "-115",
					"woe-name": "Alberta",
					"latitude": "55.2816",
					"woe-label": "Alberta, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3366,
								5309
							],
							[
								4193,
								5133
							],
							[
								3918,
								3364
							],
							[
								3918,
								3363
							],
							[
								3918,
								3363
							],
							[
								3905,
								3365
							],
							[
								3657,
								3407
							],
							[
								3501,
								3437
							],
							[
								3501,
								3437
							],
							[
								3451,
								3543
							],
							[
								3469,
								3571
							],
							[
								3473,
								3664
							],
							[
								3403,
								3760
							],
							[
								3335,
								3932
							],
							[
								3307,
								3924
							],
							[
								3288,
								4002
							],
							[
								3260,
								4003
							],
							[
								3233,
								4068
							],
							[
								3209,
								4054
							],
							[
								3212,
								4105
							],
							[
								3187,
								4185
							],
							[
								3143,
								4209
							],
							[
								3106,
								4255
							],
							[
								3102,
								4332
							],
							[
								3366,
								5309
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.MA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.73,
					"hc-middle-y": 0.5,
					"hc-key": "us-ma",
					"hc-a2": "MA",
					"labelrank": "0",
					"hasc": "US.MA",
					"alt-name": "Commonwealth of Massachusetts|MA|Mass.",
					"woe-id": "2347580",
					"subregion": "New England",
					"fips": "US25",
					"postal-code": "MA",
					"name": "Massachusetts",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-71.99930000000001",
					"woe-name": "Massachusetts",
					"latitude": "42.3739",
					"woe-label": "Massachusetts, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8234,
								2496
							],
							[
								8233,
								2503
							],
							[
								8227,
								2500
							],
							[
								8198,
								2541
							],
							[
								8152,
								2528
							],
							[
								8043,
								2502
							],
							[
								7961,
								2485
							],
							[
								7957,
								2488
							],
							[
								7959,
								2595
							],
							[
								7998,
								2605
							],
							[
								8048,
								2616
							],
							[
								8048,
								2616
							],
							[
								8178,
								2647
							],
							[
								8225,
								2688
							],
							[
								8260,
								2659
							],
							[
								8224,
								2596
							],
							[
								8264,
								2592
							],
							[
								8302,
								2538
							],
							[
								8375,
								2536
							],
							[
								8286,
								2475
							],
							[
								8292,
								2520
							],
							[
								8249,
								2474
							],
							[
								8241,
								2496
							],
							[
								8234,
								2496
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.VT",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.65,
					"hc-middle-y": 0.51,
					"hc-key": "us-vt",
					"hc-a2": "VT",
					"labelrank": "0",
					"hasc": "US.VT",
					"alt-name": "VT",
					"woe-id": "2347604",
					"subregion": "New England",
					"fips": "US50",
					"postal-code": "VT",
					"name": "Vermont",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-72.7317",
					"woe-name": "Vermont",
					"latitude": "44.0886",
					"woe-label": "Vermont, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								7998,
								2605
							],
							[
								7959,
								2595
							],
							[
								7929,
								2718
							],
							[
								7908,
								2719
							],
							[
								7889,
								2788
							],
							[
								7889,
								2855
							],
							[
								7862,
								2935
							],
							[
								7932,
								2954
							],
							[
								8060,
								2989
							],
							[
								8065,
								2898
							],
							[
								8032,
								2863
							],
							[
								8024,
								2739
							],
							[
								8032,
								2636
							],
							[
								8048,
								2616
							],
							[
								8048,
								2616
							],
							[
								7998,
								2605
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.MN",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.4,
					"hc-middle-y": 0.5,
					"hc-key": "us-mn",
					"hc-a2": "MN",
					"labelrank": "0",
					"hasc": "US.MN",
					"alt-name": "MN|Minn.",
					"woe-id": "2347582",
					"subregion": "West North Central",
					"fips": "US27",
					"postal-code": "MN",
					"name": "Minnesota",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-93.364",
					"woe-name": "Minnesota",
					"latitude": "46.0592",
					"woe-label": "Minnesota, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6050,
								3117
							],
							[
								5953,
								3066
							],
							[
								5904,
								3029
							],
							[
								5791,
								2909
							],
							[
								5772,
								2891
							],
							[
								5776,
								2800
							],
							[
								5732,
								2772
							],
							[
								5714,
								2718
							],
							[
								5739,
								2699
							],
							[
								5726,
								2591
							],
							[
								5808,
								2543
							],
							[
								5860,
								2489
							],
							[
								5902,
								2467
							],
							[
								5911,
								2402
							],
							[
								5726,
								2394
							],
							[
								5319,
								2388
							],
							[
								5321,
								2669
							],
							[
								5276,
								2717
							],
							[
								5310,
								2770
							],
							[
								5306,
								2830
							],
							[
								5285,
								2880
							],
							[
								5280,
								3014
							],
							[
								5252,
								3122
							],
							[
								5256,
								3197
							],
							[
								5243,
								3252
							],
							[
								5457,
								3251
							],
							[
								5458,
								3311
							],
							[
								5493,
								3299
							],
							[
								5506,
								3222
							],
							[
								5607,
								3178
							],
							[
								5658,
								3198
							],
							[
								5723,
								3185
							],
							[
								5752,
								3138
							],
							[
								5788,
								3156
							],
							[
								5855,
								3112
							],
							[
								5907,
								3145
							],
							[
								5922,
								3126
							],
							[
								5986,
								3132
							],
							[
								6050,
								3117
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.WA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.58,
					"hc-middle-y": 0.53,
					"hc-key": "us-wa",
					"hc-a2": "WA",
					"labelrank": "0",
					"hasc": "US.WA",
					"alt-name": "WA|Wash.",
					"woe-id": "2347606",
					"subregion": "Pacific",
					"fips": "US53",
					"postal-code": "WA",
					"name": "Washington",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-120.361",
					"woe-name": "Washington",
					"latitude": "47.4865",
					"woe-label": "Washington, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									2595,
									3667
								],
								[
									2589,
									3665
								],
								[
									2589,
									3668
								],
								[
									2595,
									3667
								]
							]
						],
						[
							[
								[
									2450,
									3247
								],
								[
									2380,
									3279
								],
								[
									2366,
									3303
								],
								[
									2402,
									3356
								],
								[
									2385,
									3384
								],
								[
									2396,
									3522
								],
								[
									2386,
									3597
								],
								[
									2411,
									3622
								],
								[
									2455,
									3576
								],
								[
									2582,
									3530
								],
								[
									2596,
									3487
								],
								[
									2575,
									3442
								],
								[
									2589,
									3403
								],
								[
									2542,
									3417
								],
								[
									2509,
									3384
								],
								[
									2548,
									3373
								],
								[
									2593,
									3403
								],
								[
									2616,
									3488
								],
								[
									2589,
									3546
								],
								[
									2607,
									3566
								],
								[
									2561,
									3598
								],
								[
									2623,
									3620
								],
								[
									2623,
									3658
								],
								[
									2633,
									3655
								],
								[
									3198,
									3503
								],
								[
									3103,
									3102
								],
								[
									3107,
									3041
								],
								[
									2881,
									3096
								],
								[
									2816,
									3100
								],
								[
									2740,
									3091
								],
								[
									2636,
									3102
								],
								[
									2575,
									3135
								],
								[
									2518,
									3126
								],
								[
									2472,
									3156
								],
								[
									2475,
									3228
								],
								[
									2450,
									3247
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.ID",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.5,
					"hc-middle-y": 0.79,
					"hc-key": "us-id",
					"hc-a2": "ID",
					"labelrank": "0",
					"hasc": "US.ID",
					"alt-name": "ID|Idaho",
					"woe-id": "2347571",
					"subregion": "Mountain",
					"fips": "US16",
					"postal-code": "ID",
					"name": "Idaho",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-114.133",
					"woe-name": "Idaho",
					"latitude": "43.7825",
					"woe-label": "Idaho, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3198,
								3503
							],
							[
								3299,
								3480
							],
							[
								3264,
								3328
							],
							[
								3288,
								3273
							],
							[
								3279,
								3233
							],
							[
								3313,
								3198
							],
							[
								3374,
								3085
							],
							[
								3397,
								3086
							],
							[
								3374,
								3025
							],
							[
								3369,
								2966
							],
							[
								3343,
								2919
							],
							[
								3363,
								2901
							],
							[
								3410,
								2925
							],
							[
								3451,
								2773
							],
							[
								3478,
								2715
							],
							[
								3548,
								2704
							],
							[
								3564,
								2716
							],
							[
								3645,
								2704
							],
							[
								3671,
								2724
							],
							[
								3693,
								2683
							],
							[
								3649,
								2418
							],
							[
								3629,
								2298
							],
							[
								3479,
								2324
							],
							[
								3287,
								2361
							],
							[
								3181,
								2383
							],
							[
								2949,
								2435
							],
							[
								3012,
								2706
							],
							[
								3040,
								2764
							],
							[
								3011,
								2789
							],
							[
								3017,
								2817
							],
							[
								3073,
								2874
							],
							[
								3136,
								2966
							],
							[
								3107,
								3041
							],
							[
								3103,
								3102
							],
							[
								3198,
								3503
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.AR",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.36,
					"hc-middle-y": 0.51,
					"hc-key": "us-ar",
					"hc-a2": "AR",
					"labelrank": "0",
					"hasc": "US.AR",
					"alt-name": "AR|Ark.",
					"woe-id": "2347562",
					"subregion": "West South Central",
					"fips": "US05",
					"postal-code": "AR",
					"name": "Arkansas",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-92.14279999999999",
					"woe-name": "Arkansas",
					"latitude": "34.7563",
					"woe-label": "Arkansas, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5629,
								756
							],
							[
								5626,
								841
							],
							[
								5569,
								854
							],
							[
								5570,
								1125
							],
							[
								5545,
								1299
							],
							[
								6104,
								1321
							],
							[
								6118,
								1289
							],
							[
								6083,
								1239
							],
							[
								6165,
								1247
							],
							[
								6123,
								1148
							],
							[
								6101,
								1086
							],
							[
								6067,
								1028
							],
							[
								6069,
								995
							],
							[
								6010,
								924
							],
							[
								5994,
								875
							],
							[
								6009,
								843
							],
							[
								6007,
								770
							],
							[
								5982,
								769
							],
							[
								5629,
								756
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.TX",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.67,
					"hc-middle-y": 0.55,
					"hc-key": "us-tx",
					"hc-a2": "TX",
					"labelrank": "0",
					"hasc": "US.TX",
					"alt-name": "TX|Tex.",
					"woe-id": "2347602",
					"subregion": "West South Central",
					"fips": "US48",
					"postal-code": "TX",
					"name": "Texas",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-98.7607",
					"woe-name": "Texas",
					"latitude": "31.131",
					"woe-label": "Texas, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5569,
								854
							],
							[
								5626,
								841
							],
							[
								5629,
								756
							],
							[
								5632,
								597
							],
							[
								5707,
								449
							],
							[
								5679,
								374
							],
							[
								5672,
								282
							],
							[
								5638,
								234
							],
							[
								5556,
								196
							],
							[
								5549,
								243
							],
							[
								5505,
								210
							],
							[
								5547,
								177
							],
							[
								5426,
								86
							],
							[
								5378,
								74
							],
							[
								5239,
								-36
							],
							[
								5174,
								-156
							],
							[
								5180,
								-230
							],
							[
								5207,
								-356
							],
							[
								5166,
								-373
							],
							[
								5112,
								-339
							],
							[
								5052,
								-336
							],
							[
								4971,
								-287
							],
							[
								4929,
								-279
							],
							[
								4921,
								-229
							],
							[
								4880,
								-174
							],
							[
								4876,
								-92
							],
							[
								4850,
								-78
							],
							[
								4772,
								27
							],
							[
								4725,
								158
							],
							[
								4629,
								268
							],
							[
								4533,
								278
							],
							[
								4505,
								294
							],
							[
								4454,
								274
							],
							[
								4381,
								160
							],
							[
								4260,
								226
							],
							[
								4200,
								284
							],
							[
								4187,
								368
							],
							[
								4150,
								448
							],
							[
								4105,
								480
							],
							[
								3968,
								640
							],
							[
								3951,
								678
							],
							[
								4429,
								632
							],
							[
								4486,
								1329
							],
							[
								4492,
								1331
							],
							[
								4868,
								1308
							],
							[
								4855,
								1009
							],
							[
								4895,
								979
							],
							[
								4949,
								979
							],
							[
								4957,
								951
							],
							[
								5048,
								924
							],
							[
								5100,
								932
							],
							[
								5116,
								894
							],
							[
								5153,
								907
							],
							[
								5226,
								866
							],
							[
								5252,
								901
							],
							[
								5328,
								861
							],
							[
								5379,
								891
							],
							[
								5472,
								902
							],
							[
								5569,
								854
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.RI",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.44,
					"hc-middle-y": 0.48,
					"hc-key": "us-ri",
					"hc-a2": "RI",
					"labelrank": "0",
					"hasc": "US.RI",
					"alt-name": "State of Rhode Island and Providence Plantations|RI|R.I.",
					"woe-id": "2347598",
					"subregion": "New England",
					"fips": "US44",
					"postal-code": "RI",
					"name": "Rhode Island",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-71.5082",
					"woe-name": "Rhode Island",
					"latitude": "41.6242",
					"woe-label": "Rhode Island, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									8249,
									2474
								],
								[
									8240,
									2470
								],
								[
									8234,
									2496
								],
								[
									8241,
									2496
								],
								[
									8249,
									2474
								]
							]
						],
						[
							[
								[
									8152,
									2528
								],
								[
									8198,
									2541
								],
								[
									8227,
									2500
								],
								[
									8237,
									2467
								],
								[
									8175,
									2421
								],
								[
									8172,
									2454
								],
								[
									8152,
									2528
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.FL",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.77,
					"hc-middle-y": 0.5,
					"hc-key": "us-fl",
					"hc-a2": "FL",
					"labelrank": "0",
					"hasc": "US.FL",
					"alt-name": "FL|Fla.",
					"woe-id": "2347568",
					"subregion": "South Atlantic",
					"fips": "US12",
					"postal-code": "FL",
					"name": "Florida",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-81.6228",
					"woe-name": "Florida",
					"latitude": "28.1568",
					"woe-label": "Florida, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6537,
								411
							],
							[
								6506,
								491
							],
							[
								6853,
								528
							],
							[
								6877,
								487
							],
							[
								7234,
								511
							],
							[
								7264,
								486
							],
							[
								7272,
								557
							],
							[
								7330,
								550
							],
							[
								7390,
								404
							],
							[
								7450,
								307
							],
							[
								7520,
								224
							],
							[
								7531,
								153
							],
							[
								7623,
								1
							],
							[
								7644,
								-169
							],
							[
								7617,
								-308
							],
							[
								7609,
								-280
							],
							[
								7530,
								-314
							],
							[
								7487,
								-227
							],
							[
								7416,
								-202
							],
							[
								7389,
								-128
							],
							[
								7352,
								-133
							],
							[
								7348,
								-62
							],
							[
								7312,
								-70
							],
							[
								7249,
								13
							],
							[
								7278,
								76
							],
							[
								7218,
								69
							],
							[
								7221,
								240
							],
							[
								7190,
								283
							],
							[
								7160,
								279
							],
							[
								7054,
								383
							],
							[
								7004,
								405
							],
							[
								6956,
								387
							],
							[
								6885,
								312
							],
							[
								6780,
								380
							],
							[
								6661,
								412
							],
							[
								6525,
								378
							],
							[
								6537,
								411
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.MS",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.49,
					"hc-middle-y": 0.5,
					"hc-key": "us-ms",
					"hc-a2": "MS",
					"labelrank": "0",
					"hasc": "US.MS",
					"alt-name": "MS|Miss.",
					"woe-id": "2347583",
					"subregion": "East South Central",
					"fips": "US28",
					"postal-code": "MS",
					"name": "Mississippi",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-89.71890000000001",
					"woe-name": "Mississippi",
					"latitude": "32.8657",
					"woe-label": "Mississippi, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6405,
								385
							],
							[
								6280,
								374
							],
							[
								6254,
								343
							],
							[
								6206,
								417
							],
							[
								6217,
								467
							],
							[
								5958,
								452
							],
							[
								5957,
								495
							],
							[
								5994,
								589
							],
							[
								6046,
								667
							],
							[
								6022,
								683
							],
							[
								6007,
								770
							],
							[
								6009,
								843
							],
							[
								5994,
								875
							],
							[
								6010,
								924
							],
							[
								6069,
								995
							],
							[
								6067,
								1028
							],
							[
								6101,
								1086
							],
							[
								6317,
								1102
							],
							[
								6373,
								1106
							],
							[
								6386,
								1091
							],
							[
								6374,
								619
							],
							[
								6405,
								385
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.UT",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.53,
					"hc-middle-y": 0.5,
					"hc-key": "us-ut",
					"hc-a2": "UT",
					"labelrank": "0",
					"hasc": "US.UT",
					"alt-name": "UT",
					"woe-id": "2347603",
					"subregion": "Mountain",
					"fips": "US49",
					"postal-code": "UT",
					"name": "Utah",
					"country": "United States of America",
					"type-en": "State",
					"region": "West",
					"longitude": "-111.544",
					"woe-name": "Utah",
					"latitude": "39.5007",
					"woe-label": "Utah, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3629,
								2298
							],
							[
								3603,
								2144
							],
							[
								3837,
								2108
							],
							[
								3823,
								2012
							],
							[
								3748,
								1492
							],
							[
								3536,
								1525
							],
							[
								3133,
								1598
							],
							[
								3200,
								1932
							],
							[
								3287,
								2361
							],
							[
								3479,
								2324
							],
							[
								3629,
								2298
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.NC",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.77,
					"hc-middle-y": 0.53,
					"hc-key": "us-nc",
					"hc-a2": "NC",
					"labelrank": "0",
					"hasc": "US.NC",
					"alt-name": "NC|N.C.",
					"woe-id": "2347592",
					"subregion": "South Atlantic",
					"fips": "US37",
					"postal-code": "NC",
					"name": "North Carolina",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-78.866",
					"woe-name": "North Carolina",
					"latitude": "35.6152",
					"woe-label": "North Carolina, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									7875,
									1583
								],
								[
									7877,
									1575
								],
								[
									7862,
									1580
								],
								[
									7862,
									1580
								],
								[
									7867,
									1581
								],
								[
									7868,
									1580
								],
								[
									7870,
									1582
								],
								[
									7872,
									1582
								],
								[
									7875,
									1583
								]
							]
						],
						[
							[
								[
									7018,
									1181
								],
								[
									6971,
									1173
								],
								[
									6865,
									1158
								],
								[
									6868,
									1200
								],
								[
									6923,
									1255
								],
								[
									6957,
									1262
								],
								[
									7056,
									1352
								],
								[
									7123,
									1369
								],
								[
									7164,
									1456
								],
								[
									7360,
									1478
								],
								[
									7859,
									1580
								],
								[
									7906,
									1515
								],
								[
									7869,
									1521
								],
								[
									7794,
									1469
								],
								[
									7901,
									1498
								],
								[
									7922,
									1479
								],
								[
									7895,
									1401
								],
								[
									7828,
									1405
								],
								[
									7842,
									1348
								],
								[
									7799,
									1316
								],
								[
									7877,
									1320
								],
								[
									7847,
									1280
								],
								[
									7784,
									1265
								],
								[
									7726,
									1205
								],
								[
									7704,
									1116
								],
								[
									7626,
									1106
								],
								[
									7462,
									1220
								],
								[
									7319,
									1200
								],
								[
									7273,
									1244
								],
								[
									7119,
									1228
								],
								[
									7018,
									1181
								]
							]
						],
						[
							[
								[
									7881,
									1584
								],
								[
									7914,
									1513
								],
								[
									7878,
									1584
								],
								[
									7880,
									1584
								],
								[
									7881,
									1584
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.GA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.54,
					"hc-middle-y": 0.5,
					"hc-key": "us-ga",
					"hc-a2": "GA",
					"labelrank": "0",
					"hasc": "US.GA",
					"alt-name": "GA|Ga.",
					"woe-id": "2347569",
					"subregion": "South Atlantic",
					"fips": "US13",
					"postal-code": "GA",
					"name": "Georgia",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-83.4078",
					"woe-name": "Georgia",
					"latitude": "32.8547",
					"woe-label": "Georgia, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6865,
								1158
							],
							[
								6971,
								1173
							],
							[
								7018,
								1181
							],
							[
								6994,
								1131
							],
							[
								7063,
								1102
							],
							[
								7111,
								1031
							],
							[
								7204,
								968
							],
							[
								7235,
								922
							],
							[
								7270,
								909
							],
							[
								7295,
								847
							],
							[
								7325,
								830
							],
							[
								7351,
								771
							],
							[
								7377,
								767
							],
							[
								7331,
								682
							],
							[
								7346,
								642
							],
							[
								7324,
								625
							],
							[
								7330,
								550
							],
							[
								7272,
								557
							],
							[
								7264,
								486
							],
							[
								7234,
								511
							],
							[
								6877,
								487
							],
							[
								6853,
								528
							],
							[
								6820,
								654
							],
							[
								6843,
								728
							],
							[
								6791,
								827
							],
							[
								6702,
								1137
							],
							[
								6795,
								1149
							],
							[
								6865,
								1158
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.VA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.66,
					"hc-middle-y": 0.57,
					"hc-key": "us-va",
					"hc-a2": "VA",
					"labelrank": "0",
					"hasc": "US.VA",
					"alt-name": "VA",
					"woe-id": "2347605",
					"subregion": "South Atlantic",
					"fips": "US51",
					"postal-code": "VA",
					"name": "Virginia",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-78.2431",
					"woe-name": "Virginia",
					"latitude": "37.7403",
					"woe-label": "Virginia, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									7870,
									1582
								],
								[
									7873,
									1587
								],
								[
									7875,
									1583
								],
								[
									7872,
									1582
								],
								[
									7870,
									1582
								]
							]
						],
						[
							[
								[
									7878,
									1584
								],
								[
									7863,
									1606
								],
								[
									7867,
									1581
								],
								[
									7862,
									1580
								],
								[
									7862,
									1580
								],
								[
									7857,
									1585
								],
								[
									7859,
									1580
								],
								[
									7360,
									1478
								],
								[
									7164,
									1456
								],
								[
									7128,
									1448
								],
								[
									6914,
									1418
								],
								[
									6977,
									1450
								],
								[
									7030,
									1523
								],
								[
									7104,
									1593
								],
								[
									7127,
									1557
								],
								[
									7202,
									1562
								],
								[
									7309,
									1622
								],
								[
									7305,
									1649
								],
								[
									7349,
									1751
								],
								[
									7359,
									1802
								],
								[
									7404,
									1784
								],
								[
									7429,
									1856
								],
								[
									7444,
									1849
								],
								[
									7488,
									1918
								],
								[
									7491,
									1963
								],
								[
									7558,
									1928
								],
								[
									7564,
									1959
								],
								[
									7595,
									1937
								],
								[
									7649,
									1914
								],
								[
									7653,
									1910
								],
								[
									7657,
									1910
								],
								[
									7639,
									1828
								],
								[
									7670,
									1833
								],
								[
									7676,
									1834
								],
								[
									7682,
									1828
								],
								[
									7702,
									1804
								],
								[
									7735,
									1807
								],
								[
									7788,
									1779
								],
								[
									7788,
									1735
								],
								[
									7704,
									1773
								],
								[
									7803,
									1710
								],
								[
									7782,
									1693
								],
								[
									7812,
									1643
								],
								[
									7852,
									1636
								],
								[
									7881,
									1584
								],
								[
									7880,
									1584
								],
								[
									7878,
									1584
								]
							]
						],
						[
							[
								[
									7904,
									1825
								],
								[
									7899,
									1803
								],
								[
									7902,
									1824
								],
								[
									7904,
									1825
								]
							]
						],
						[
							[
								[
									7888,
									1820
								],
								[
									7850,
									1706
								],
								[
									7822,
									1777
								],
								[
									7858,
									1805
								],
								[
									7860,
									1810
								],
								[
									7888,
									1820
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.TN",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.41,
					"hc-middle-y": 0.56,
					"hc-key": "us-tn",
					"hc-a2": "TN",
					"labelrank": "0",
					"hasc": "US.TN",
					"alt-name": "TN|Tenn.",
					"woe-id": "2347601",
					"subregion": "East South Central",
					"fips": "US47",
					"postal-code": "TN",
					"name": "Tennessee",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-86.3415",
					"woe-name": "Tennessee",
					"latitude": "35.7514",
					"woe-label": "Tennessee, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6914,
								1418
							],
							[
								7128,
								1448
							],
							[
								7164,
								1456
							],
							[
								7123,
								1369
							],
							[
								7056,
								1352
							],
							[
								6957,
								1262
							],
							[
								6923,
								1255
							],
							[
								6868,
								1200
							],
							[
								6865,
								1158
							],
							[
								6795,
								1149
							],
							[
								6702,
								1137
							],
							[
								6372,
								1108
							],
							[
								6373,
								1106
							],
							[
								6317,
								1102
							],
							[
								6101,
								1086
							],
							[
								6123,
								1148
							],
							[
								6165,
								1247
							],
							[
								6166,
								1285
							],
							[
								6180,
								1326
							],
							[
								6188,
								1327
							],
							[
								6191,
								1319
							],
							[
								6197,
								1327
							],
							[
								6370,
								1341
							],
							[
								6394,
								1366
							],
							[
								6554,
								1383
							],
							[
								6907,
								1414
							],
							[
								6914,
								1418
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.IA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.37,
					"hc-middle-y": 0.51,
					"hc-key": "us-ia",
					"hc-a2": "IA",
					"labelrank": "0",
					"hasc": "US.IA",
					"alt-name": "IA|Iowa",
					"woe-id": "2347574",
					"subregion": "West North Central",
					"fips": "US19",
					"postal-code": "IA",
					"name": "Iowa",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-93.3891",
					"woe-name": "Iowa",
					"latitude": "42.0423",
					"woe-label": "Iowa, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5399,
								1935
							],
							[
								5386,
								2046
							],
							[
								5361,
								2083
							],
							[
								5364,
								2122
							],
							[
								5315,
								2234
							],
							[
								5298,
								2271
							],
							[
								5319,
								2329
							],
							[
								5303,
								2388
							],
							[
								5319,
								2388
							],
							[
								5726,
								2394
							],
							[
								5911,
								2402
							],
							[
								5941,
								2285
							],
							[
								5989,
								2252
							],
							[
								5989,
								2252
							],
							[
								6047,
								2193
							],
							[
								6032,
								2113
							],
							[
								5958,
								2081
							],
							[
								5965,
								2006
							],
							[
								5914,
								1915
							],
							[
								5913,
								1915
							],
							[
								5913,
								1915
							],
							[
								5877,
								1950
							],
							[
								5552,
								1933
							],
							[
								5399,
								1935
							],
							[
								5399,
								1935
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.MD",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.5,
					"hc-middle-y": 0.44,
					"hc-key": "us-md",
					"hc-a2": "MD",
					"labelrank": "0",
					"hasc": "US.MD",
					"alt-name": "MD",
					"woe-id": "2347579",
					"subregion": "South Atlantic",
					"fips": "US24",
					"postal-code": "MD",
					"name": "Maryland",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-77.0454",
					"woe-name": "Maryland",
					"latitude": "39.3874",
					"woe-label": "Maryland, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									7902,
									1824
								],
								[
									7907,
									1838
								],
								[
									7904,
									1825
								],
								[
									7902,
									1824
								]
							]
						],
						[
							[
								[
									7913,
									1896
								],
								[
									7913,
									1877
								],
								[
									7911,
									1895
								],
								[
									7911,
									1895
								],
								[
									7913,
									1896
								]
							]
						],
						[
							[
								[
									7649,
									1914
								],
								[
									7595,
									1937
								],
								[
									7564,
									1959
								],
								[
									7542,
									1999
								],
								[
									7505,
									2006
								],
								[
									7471,
									1973
								],
								[
									7431,
									1981
								],
								[
									7359,
									1900
								],
								[
									7346,
									1979
								],
								[
									7550,
									2018
								],
								[
									7780,
									2068
								],
								[
									7835,
									1879
								],
								[
									7908,
									1895
								],
								[
									7907,
									1860
								],
								[
									7888,
									1820
								],
								[
									7860,
									1810
								],
								[
									7858,
									1805
								],
								[
									7835,
									1830
								],
								[
									7760,
									1864
								],
								[
									7793,
									1886
								],
								[
									7751,
									1908
								],
								[
									7772,
									1931
								],
								[
									7743,
									1968
								],
								[
									7767,
									2046
								],
								[
									7727,
									1980
								],
								[
									7720,
									1922
								],
								[
									7735,
									1867
								],
								[
									7771,
									1813
								],
								[
									7705,
									1818
								],
								[
									7682,
									1828
								],
								[
									7670,
									1833
								],
								[
									7646,
									1843
								],
								[
									7665,
									1896
								],
								[
									7676,
									1913
								],
								[
									7649,
									1914
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.DE",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.68,
					"hc-middle-y": 0.91,
					"hc-key": "us-de",
					"hc-a2": "DE",
					"labelrank": "0",
					"hasc": "US.DE",
					"alt-name": "DE|Del.",
					"woe-id": "2347566",
					"subregion": "South Atlantic",
					"fips": "US10",
					"postal-code": "DE",
					"name": "Delaware",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-75.41119999999999",
					"woe-name": "Delaware",
					"latitude": "38.8657",
					"woe-label": "Delaware, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								7911,
								1895
							],
							[
								7908,
								1896
							],
							[
								7908,
								1895
							],
							[
								7835,
								1879
							],
							[
								7780,
								2068
							],
							[
								7798,
								2090
							],
							[
								7820,
								2090
							],
							[
								7806,
								2057
							],
							[
								7850,
								1977
							],
							[
								7896,
								1946
							],
							[
								7913,
								1896
							],
							[
								7911,
								1895
							],
							[
								7911,
								1895
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.MO",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.52,
					"hc-middle-y": 0.49,
					"hc-key": "us-mo",
					"hc-a2": "MO",
					"labelrank": "0",
					"hasc": "US.MO",
					"alt-name": "MO",
					"woe-id": "2347584",
					"subregion": "West North Central",
					"fips": "US29",
					"postal-code": "MO",
					"name": "Missouri",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-92.446",
					"woe-name": "Missouri",
					"latitude": "38.5487",
					"woe-label": "Missouri, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5453,
								1842
							],
							[
								5415,
								1896
							],
							[
								5399,
								1935
							],
							[
								5399,
								1935
							],
							[
								5399,
								1935
							],
							[
								5552,
								1933
							],
							[
								5877,
								1950
							],
							[
								5913,
								1915
							],
							[
								5914,
								1915
							],
							[
								5914,
								1915
							],
							[
								5906,
								1882
							],
							[
								5929,
								1811
							],
							[
								5997,
								1754
							],
							[
								6029,
								1687
							],
							[
								6085,
								1683
							],
							[
								6060,
								1599
							],
							[
								6096,
								1557
							],
							[
								6168,
								1512
							],
							[
								6176,
								1445
							],
							[
								6229,
								1404
							],
							[
								6230,
								1366
							],
							[
								6197,
								1327
							],
							[
								6191,
								1319
							],
							[
								6188,
								1327
							],
							[
								6178,
								1335
							],
							[
								6180,
								1326
							],
							[
								6166,
								1285
							],
							[
								6165,
								1247
							],
							[
								6083,
								1239
							],
							[
								6118,
								1289
							],
							[
								6104,
								1321
							],
							[
								5545,
								1299
							],
							[
								5544,
								1357
							],
							[
								5544,
								1376
							],
							[
								5539,
								1707
							],
							[
								5480,
								1769
							],
							[
								5505,
								1815
							],
							[
								5453,
								1842
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.PA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.5,
					"hc-middle-y": 0.45,
					"hc-key": "us-pa",
					"hc-a2": "PA",
					"labelrank": "0",
					"hasc": "US.PA",
					"alt-name": "Commonwealth of Pennsylvania|PA",
					"woe-id": "2347597",
					"subregion": "Middle Atlantic",
					"fips": "US42",
					"postal-code": "PA",
					"name": "Pennsylvania",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-77.60939999999999",
					"woe-name": "Pennsylvania",
					"latitude": "40.8601",
					"woe-label": "Pennsylvania, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								7812,
								2276
							],
							[
								7833,
								2213
							],
							[
								7889,
								2163
							],
							[
								7860,
								2133
							],
							[
								7849,
								2112
							],
							[
								7830,
								2098
							],
							[
								7820,
								2090
							],
							[
								7798,
								2090
							],
							[
								7780,
								2068
							],
							[
								7550,
								2018
							],
							[
								7346,
								1979
							],
							[
								7223,
								1957
							],
							[
								7198,
								2098
							],
							[
								7198,
								2099
							],
							[
								7163,
								2304
							],
							[
								7178,
								2313
							],
							[
								7242,
								2363
							],
							[
								7249,
								2322
							],
							[
								7753,
								2425
							],
							[
								7798,
								2374
							],
							[
								7849,
								2345
							],
							[
								7849,
								2345
							],
							[
								7812,
								2276
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.NJ",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.5,
					"hc-middle-y": 0.5,
					"hc-key": "us-nj",
					"hc-a2": "NJ",
					"labelrank": "0",
					"hasc": "US.NJ",
					"alt-name": "NJ|N.J.",
					"woe-id": "2347589",
					"subregion": "Middle Atlantic",
					"fips": "US34",
					"postal-code": "NJ",
					"name": "New Jersey",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-74.4653",
					"woe-name": "New Jersey",
					"latitude": "40.0449",
					"woe-label": "New Jersey, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								7812,
								2276
							],
							[
								7849,
								2345
							],
							[
								7901,
								2328
							],
							[
								7953,
								2312
							],
							[
								7928,
								2226
							],
							[
								7970,
								2210
							],
							[
								7977,
								2115
							],
							[
								7915,
								1975
							],
							[
								7819,
								2038
							],
							[
								7819,
								2085
							],
							[
								7830,
								2098
							],
							[
								7860,
								2133
							],
							[
								7889,
								2163
							],
							[
								7833,
								2213
							],
							[
								7812,
								2276
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.NY",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.42,
					"hc-middle-y": 0.58,
					"hc-key": "us-ny",
					"hc-a2": "NY",
					"labelrank": "0",
					"hasc": "US.NY",
					"alt-name": "NY|N.Y.",
					"woe-id": "2347591",
					"subregion": "Middle Atlantic",
					"fips": "US36",
					"postal-code": "NY",
					"name": "New York",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-75.32420000000001",
					"woe-name": "New York",
					"latitude": "43.1988",
					"woe-label": "New York, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									7849,
									2345
								],
								[
									7798,
									2374
								],
								[
									7753,
									2425
								],
								[
									7249,
									2322
								],
								[
									7242,
									2363
								],
								[
									7303,
									2424
								],
								[
									7327,
									2470
								],
								[
									7316,
									2484
								],
								[
									7298,
									2505
								],
								[
									7297,
									2506
								],
								[
									7297,
									2516
								],
								[
									7293,
									2533
								],
								[
									7396,
									2571
								],
								[
									7464,
									2563
								],
								[
									7553,
									2595
								],
								[
									7603,
									2645
								],
								[
									7566,
									2724
								],
								[
									7616,
									2794
								],
								[
									7660,
									2863
								],
								[
									7715,
									2898
								],
								[
									7717,
									2898
								],
								[
									7862,
									2935
								],
								[
									7889,
									2855
								],
								[
									7889,
									2788
								],
								[
									7908,
									2719
								],
								[
									7929,
									2718
								],
								[
									7959,
									2595
								],
								[
									7957,
									2488
								],
								[
									7961,
									2485
								],
								[
									7983,
									2368
								],
								[
									7983,
									2321
								],
								[
									7951,
									2273
								],
								[
									7953,
									2312
								],
								[
									7901,
									2328
								],
								[
									7862,
									2341
								],
								[
									7849,
									2345
								],
								[
									7849,
									2345
								]
							]
						],
						[
							[
								[
									8003,
									2317
								],
								[
									8102,
									2350
								],
								[
									8126,
									2380
								],
								[
									8149,
									2365
								],
								[
									8156,
									2408
								],
								[
									8156,
									2368
								],
								[
									8064,
									2289
								],
								[
									7933,
									2228
								],
								[
									7960,
									2281
								],
								[
									8003,
									2317
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.LA",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.64,
					"hc-middle-y": 0.82,
					"hc-key": "us-la",
					"hc-a2": "LA",
					"labelrank": "0",
					"hasc": "US.LA",
					"alt-name": "LA",
					"woe-id": "2347577",
					"subregion": "West South Central",
					"fips": "US22",
					"postal-code": "LA",
					"name": "Louisiana",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-91.9991",
					"woe-name": "Louisiana",
					"latitude": "30.5274",
					"woe-label": "Louisiana, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5629,
								756
							],
							[
								5982,
								769
							],
							[
								6007,
								770
							],
							[
								6022,
								683
							],
							[
								6046,
								667
							],
							[
								5994,
								589
							],
							[
								5957,
								495
							],
							[
								5958,
								452
							],
							[
								6217,
								467
							],
							[
								6206,
								417
							],
							[
								6254,
								343
							],
							[
								6158,
								367
							],
							[
								6131,
								327
							],
							[
								6186,
								314
							],
							[
								6239,
								334
							],
							[
								6285,
								301
							],
							[
								6234,
								254
							],
							[
								6261,
								219
							],
							[
								6333,
								195
							],
							[
								6319,
								167
							],
							[
								6224,
								202
							],
							[
								6186,
								231
							],
							[
								6192,
								184
							],
							[
								6170,
								163
							],
							[
								6131,
								195
							],
							[
								6079,
								165
							],
							[
								6016,
								187
							],
							[
								6023,
								219
							],
							[
								5986,
								223
							],
							[
								5940,
								267
							],
							[
								5906,
								233
							],
							[
								5944,
								213
							],
							[
								5827,
								227
							],
							[
								5755,
								251
							],
							[
								5669,
								237
							],
							[
								5672,
								282
							],
							[
								5679,
								374
							],
							[
								5707,
								449
							],
							[
								5632,
								597
							],
							[
								5629,
								756
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.NH",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.45,
					"hc-middle-y": 0.7,
					"hc-key": "us-nh",
					"hc-a2": "NH",
					"labelrank": "0",
					"hasc": "US.NH",
					"alt-name": "NH|N.H.",
					"woe-id": "2347588",
					"subregion": "New England",
					"fips": "US33",
					"postal-code": "NH",
					"name": "New Hampshire",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-71.6301",
					"woe-name": "New Hampshire",
					"latitude": "43.5993",
					"woe-label": "New Hampshire, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8180,
								2787
							],
							[
								8224,
								2722
							],
							[
								8229,
								2720
							],
							[
								8225,
								2688
							],
							[
								8178,
								2647
							],
							[
								8048,
								2616
							],
							[
								8048,
								2616
							],
							[
								8032,
								2636
							],
							[
								8024,
								2739
							],
							[
								8032,
								2863
							],
							[
								8065,
								2898
							],
							[
								8060,
								2989
							],
							[
								8067,
								3036
							],
							[
								8092,
								3045
							],
							[
								8092,
								3045
							],
							[
								8180,
								2787
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.ME",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.47,
					"hc-middle-y": 0.55,
					"hc-key": "us-me",
					"hc-a2": "ME",
					"labelrank": "0",
					"hasc": "US.ME",
					"alt-name": "ME|Maine",
					"woe-id": "2347578",
					"subregion": "New England",
					"fips": "US23",
					"postal-code": "ME",
					"name": "Maine",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-69.1973",
					"woe-name": "Maine",
					"latitude": "45.148",
					"woe-label": "Maine, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8180,
								2787
							],
							[
								8092,
								3045
							],
							[
								8092,
								3045
							],
							[
								8114,
								3042
							],
							[
								8123,
								3098
							],
							[
								8146,
								3130
							],
							[
								8145,
								3289
							],
							[
								8188,
								3423
							],
							[
								8216,
								3407
							],
							[
								8237,
								3397
							],
							[
								8302,
								3442
							],
							[
								8357,
								3409
							],
							[
								8417,
								3218
							],
							[
								8441,
								3201
							],
							[
								8464,
								3207
							],
							[
								8476,
								3158
							],
							[
								8512,
								3153
							],
							[
								8556,
								3111
							],
							[
								8536,
								3072
							],
							[
								8447,
								3016
							],
							[
								8428,
								2962
							],
							[
								8412,
								3007
							],
							[
								8399,
								2972
							],
							[
								8356,
								2979
							],
							[
								8363,
								2920
							],
							[
								8297,
								2843
							],
							[
								8277,
								2862
							],
							[
								8224,
								2722
							],
							[
								8180,
								2787
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.SD",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.52,
					"hc-middle-y": 0.47,
					"hc-key": "us-sd",
					"hc-a2": "SD",
					"labelrank": "0",
					"hasc": "US.SD",
					"alt-name": "SD|S.D.",
					"woe-id": "2347600",
					"subregion": "West North Central",
					"fips": "US46",
					"postal-code": "SD",
					"name": "South Dakota",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-100.255",
					"woe-name": "South Dakota",
					"latitude": "44.4711",
					"woe-label": "South Dakota, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								5310,
								2770
							],
							[
								5276,
								2717
							],
							[
								5321,
								2669
							],
							[
								5319,
								2388
							],
							[
								5303,
								2388
							],
							[
								5319,
								2329
							],
							[
								5298,
								2271
							],
							[
								5315,
								2234
							],
							[
								5222,
								2293
							],
							[
								5132,
								2281
							],
							[
								5086,
								2313
							],
							[
								4450,
								2350
							],
							[
								4455,
								2409
							],
							[
								4477,
								2662
							],
							[
								4479,
								2662
							],
							[
								4491,
								2809
							],
							[
								5183,
								2772
							],
							[
								5310,
								2770
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.CT",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.94,
					"hc-middle-y": 0.39,
					"hc-key": "us-ct",
					"hc-a2": "CT",
					"labelrank": "0",
					"hasc": "US.CT",
					"alt-name": "CT|Conn.",
					"woe-id": "2347565",
					"subregion": "New England",
					"fips": "US09",
					"postal-code": "CT",
					"name": "Connecticut",
					"country": "United States of America",
					"type-en": "State",
					"region": "Northeast",
					"longitude": "-72.7594",
					"woe-name": "Connecticut",
					"latitude": "41.6486",
					"woe-label": "Connecticut, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8175,
								2421
							],
							[
								8059,
								2379
							],
							[
								7983,
								2321
							],
							[
								7983,
								2368
							],
							[
								7961,
								2485
							],
							[
								8043,
								2502
							],
							[
								8152,
								2528
							],
							[
								8172,
								2454
							],
							[
								8175,
								2421
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.IL",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.48,
					"hc-middle-y": 0.4,
					"hc-key": "us-il",
					"hc-a2": "IL",
					"labelrank": "0",
					"hasc": "US.IL",
					"alt-name": "IL|Ill.",
					"woe-id": "2347572",
					"subregion": "East North Central",
					"fips": "US17",
					"postal-code": "IL",
					"name": "Illinois",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-89.1991",
					"woe-name": "Illinois",
					"latitude": "39.946",
					"woe-label": "Illinois, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6316,
								2273
							],
							[
								6317,
								2240
							],
							[
								6360,
								2157
							],
							[
								6392,
								1790
							],
							[
								6380,
								1751
							],
							[
								6404,
								1698
							],
							[
								6350,
								1589
							],
							[
								6352,
								1544
							],
							[
								6347,
								1491
							],
							[
								6305,
								1477
							],
							[
								6307,
								1425
							],
							[
								6253,
								1444
							],
							[
								6229,
								1404
							],
							[
								6176,
								1445
							],
							[
								6168,
								1512
							],
							[
								6096,
								1557
							],
							[
								6060,
								1599
							],
							[
								6085,
								1683
							],
							[
								6029,
								1687
							],
							[
								5997,
								1754
							],
							[
								5929,
								1811
							],
							[
								5906,
								1882
							],
							[
								5914,
								1915
							],
							[
								5914,
								1915
							],
							[
								5914,
								1915
							],
							[
								5965,
								2006
							],
							[
								5958,
								2081
							],
							[
								6032,
								2113
							],
							[
								6047,
								2193
							],
							[
								5989,
								2252
							],
							[
								5989,
								2252
							],
							[
								6153,
								2261
							],
							[
								6316,
								2273
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.IN",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.44,
					"hc-middle-y": 0.5,
					"hc-key": "us-in",
					"hc-a2": "IN",
					"labelrank": "0",
					"hasc": "US.IN",
					"alt-name": "IN|Ind.",
					"woe-id": "2347573",
					"subregion": "East North Central",
					"fips": "US18",
					"postal-code": "IN",
					"name": "Indiana",
					"country": "United States of America",
					"type-en": "State",
					"region": "Midwest",
					"longitude": "-86.1396",
					"woe-name": "Indiana",
					"latitude": "39.8874",
					"woe-label": "Indiana, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6360,
								2157
							],
							[
								6388,
								2144
							],
							[
								6438,
								2170
							],
							[
								6674,
								2196
							],
							[
								6675,
								2187
							],
							[
								6684,
								2124
							],
							[
								6723,
								1785
							],
							[
								6729,
								1737
							],
							[
								6654,
								1718
							],
							[
								6660,
								1690
							],
							[
								6617,
								1646
							],
							[
								6594,
								1593
							],
							[
								6563,
								1617
							],
							[
								6511,
								1574
							],
							[
								6460,
								1560
							],
							[
								6370,
								1564
							],
							[
								6352,
								1544
							],
							[
								6350,
								1589
							],
							[
								6404,
								1698
							],
							[
								6380,
								1751
							],
							[
								6392,
								1790
							],
							[
								6360,
								2157
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.KY",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.7,
					"hc-middle-y": 0.41,
					"hc-key": "us-ky",
					"hc-a2": "KY",
					"labelrank": "0",
					"hasc": "US.KY",
					"alt-name": "Commonwealth of Kentucky|KY",
					"woe-id": "2347576",
					"subregion": "East South Central",
					"fips": "US21",
					"postal-code": "KY",
					"name": "Kentucky",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-85.5729",
					"woe-name": "Kentucky",
					"latitude": "37.3994",
					"woe-label": "Kentucky, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									6180,
									1326
								],
								[
									6178,
									1335
								],
								[
									6188,
									1327
								],
								[
									6180,
									1326
								]
							]
						],
						[
							[
								[
									6197,
									1327
								],
								[
									6230,
									1366
								],
								[
									6229,
									1404
								],
								[
									6253,
									1444
								],
								[
									6307,
									1425
								],
								[
									6305,
									1477
								],
								[
									6347,
									1491
								],
								[
									6352,
									1544
								],
								[
									6370,
									1564
								],
								[
									6460,
									1560
								],
								[
									6511,
									1574
								],
								[
									6563,
									1617
								],
								[
									6594,
									1593
								],
								[
									6617,
									1646
								],
								[
									6660,
									1690
								],
								[
									6654,
									1718
								],
								[
									6729,
									1737
								],
								[
									6723,
									1785
								],
								[
									6768,
									1791
								],
								[
									6804,
									1750
								],
								[
									6916,
									1732
								],
								[
									6964,
									1762
								],
								[
									7007,
									1717
								],
								[
									7007,
									1717
								],
								[
									7007,
									1717
								],
								[
									7007,
									1717
								],
								[
									7008,
									1675
								],
								[
									7059,
									1610
								],
								[
									7104,
									1593
								],
								[
									7030,
									1523
								],
								[
									6977,
									1450
								],
								[
									6914,
									1418
								],
								[
									6907,
									1414
								],
								[
									6554,
									1383
								],
								[
									6394,
									1366
								],
								[
									6370,
									1341
								],
								[
									6197,
									1327
								]
							]
						],
						[
							[
								[
									7007,
									1717
								],
								[
									7007,
									1717
								],
								[
									7007,
									1717
								],
								[
									7007,
									1717
								],
								[
									7007,
									1717
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.WV",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.48,
					"hc-middle-y": 0.53,
					"hc-key": "us-wv",
					"hc-a2": "WV",
					"labelrank": "0",
					"hasc": "US.WV",
					"alt-name": "WV|W.Va.",
					"woe-id": "2347607",
					"subregion": "South Atlantic",
					"fips": "US54",
					"postal-code": "WV",
					"name": "West Virginia",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-80.7128",
					"woe-name": "West Virginia",
					"latitude": "38.6422",
					"woe-label": "West Virginia, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								7007,
								1717
							],
							[
								7007,
								1717
							],
							[
								7038,
								1725
							],
							[
								7057,
								1816
							],
							[
								7079,
								1800
							],
							[
								7117,
								1888
							],
							[
								7147,
								1893
							],
							[
								7183,
								1935
							],
							[
								7198,
								2099
							],
							[
								7223,
								1957
							],
							[
								7346,
								1979
							],
							[
								7359,
								1900
							],
							[
								7431,
								1981
							],
							[
								7471,
								1973
							],
							[
								7505,
								2006
							],
							[
								7542,
								1999
							],
							[
								7564,
								1959
							],
							[
								7558,
								1928
							],
							[
								7491,
								1963
							],
							[
								7488,
								1918
							],
							[
								7444,
								1849
							],
							[
								7429,
								1856
							],
							[
								7404,
								1784
							],
							[
								7359,
								1802
							],
							[
								7349,
								1751
							],
							[
								7305,
								1649
							],
							[
								7309,
								1622
							],
							[
								7202,
								1562
							],
							[
								7127,
								1557
							],
							[
								7104,
								1593
							],
							[
								7059,
								1610
							],
							[
								7008,
								1675
							],
							[
								7007,
								1717
							],
							[
								7007,
								1717
							],
							[
								7007,
								1717
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.DC",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.57,
					"hc-middle-y": 0.14,
					"hc-key": "us-dc",
					"hc-a2": "DC",
					"labelrank": "9",
					"hasc": "US.DC",
					"alt-name": "DC|D.C.",
					"woe-id": "2347567",
					"subregion": "South Atlantic",
					"fips": "US11",
					"postal-code": "DC",
					"name": "District of Columbia",
					"country": "United States of America",
					"type-en": "Federal District",
					"region": "South",
					"longitude": "-77.01130000000001",
					"woe-name": "District of Columbia",
					"latitude": "38.8922",
					"woe-label": "District of Columbia, US, United States",
					"type": "Federal District"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								7665,
								1896
							],
							[
								7664,
								1904
							],
							[
								7657,
								1910
							],
							[
								7653,
								1910
							],
							[
								7649,
								1914
							],
							[
								7676,
								1913
							],
							[
								7665,
								1896
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.ON",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.28,
					"hc-middle-y": 0.33,
					"hc-key": "ca-on",
					"hc-a2": "ON",
					"labelrank": "2",
					"hasc": "CA.ON",
					"alt-name": "Upper Canada",
					"woe-id": "2344922",
					"subregion": "Ontario",
					"fips": "CA08",
					"postal-code": "ON",
					"name": "Ontario",
					"country": "Canada",
					"type-en": "Province",
					"region": "Eastern Canada",
					"longitude": "-84.79430000000001",
					"woe-name": "Ontario",
					"latitude": "50.5244",
					"woe-label": "Ontario, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									7022,
									3715
								],
								[
									6994,
									3747
								],
								[
									7008,
									3793
								],
								[
									7011,
									3777
								],
								[
									7022,
									3715
								]
							]
						],
						[
							[
								[
									7747,
									2941
								],
								[
									7732,
									2917
								],
								[
									7715,
									2898
								],
								[
									7660,
									2863
								],
								[
									7616,
									2794
								],
								[
									7574,
									2750
								],
								[
									7532,
									2734
								],
								[
									7497,
									2684
								],
								[
									7432,
									2682
								],
								[
									7274,
									2616
								],
								[
									7236,
									2581
								],
								[
									7211,
									2526
								],
								[
									7265,
									2513
								],
								[
									7293,
									2533
								],
								[
									7297,
									2516
								],
								[
									7297,
									2506
								],
								[
									7298,
									2505
								],
								[
									7317,
									2484
								],
								[
									7316,
									2484
								],
								[
									7179,
									2435
								],
								[
									7148,
									2395
								],
								[
									7050,
									2390
								],
								[
									7004,
									2324
								],
								[
									6920,
									2274
								],
								[
									6862,
									2271
								],
								[
									6862,
									2302
								],
								[
									6862,
									2307
								],
								[
									6864,
									2307
								],
								[
									6934,
									2323
								],
								[
									6906,
									2353
								],
								[
									6919,
									2369
								],
								[
									6921,
									2428
								],
								[
									6990,
									2497
								],
								[
									6971,
									2605
								],
								[
									7010,
									2694
								],
								[
									6993,
									2750
								],
								[
									6948,
									2788
								],
								[
									6991,
									2793
								],
								[
									7002,
									2755
								],
								[
									7036,
									2756
								],
								[
									7048,
									2698
								],
								[
									7064,
									2721
								],
								[
									7142,
									2695
								],
								[
									7176,
									2751
								],
								[
									7125,
									2797
								],
								[
									7127,
									2828
								],
								[
									7093,
									2831
								],
								[
									7033,
									2907
								],
								[
									6989,
									2901
								],
								[
									6934,
									2923
								],
								[
									6786,
									2908
								],
								[
									6662,
									2918
								],
								[
									6657,
									2946
								],
								[
									6618,
									2930
								],
								[
									6603,
									2995
								],
								[
									6577,
									3009
								],
								[
									6591,
									3061
								],
								[
									6539,
									3105
								],
								[
									6542,
									3161
								],
								[
									6456,
									3148
								],
								[
									6417,
									3177
								],
								[
									6370,
									3269
								],
								[
									6280,
									3260
								],
								[
									6176,
									3285
								],
								[
									6248,
									3255
								],
								[
									6208,
									3250
								],
								[
									6149,
									3203
								],
								[
									6172,
									3237
								],
								[
									6155,
									3260
								],
								[
									6136,
									3185
								],
								[
									6124,
									3214
								],
								[
									6084,
									3191
								],
								[
									6075,
									3139
								],
								[
									6050,
									3117
								],
								[
									5986,
									3132
								],
								[
									5922,
									3126
								],
								[
									5907,
									3145
								],
								[
									5855,
									3112
								],
								[
									5788,
									3156
								],
								[
									5752,
									3138
								],
								[
									5723,
									3185
								],
								[
									5658,
									3198
								],
								[
									5607,
									3178
								],
								[
									5506,
									3222
								],
								[
									5493,
									3299
								],
								[
									5458,
									3311
								],
								[
									5453,
									3862
								],
								[
									5588,
									4001
								],
								[
									5801,
									4277
								],
								[
									6007,
									4543
								],
								[
									6100,
									4483
								],
								[
									6142,
									4421
								],
								[
									6322,
									4367
								],
								[
									6349,
									4341
								],
								[
									6429,
									4321
								],
								[
									6491,
									4342
								],
								[
									6517,
									4333
								],
								[
									6650,
									4331
								],
								[
									6662,
									4286
								],
								[
									6655,
									4185
								],
								[
									6694,
									4123
								],
								[
									6708,
									4038
								],
								[
									6698,
									3986
								],
								[
									6782,
									3915
								],
								[
									6811,
									3863
								],
								[
									6850,
									3853
								],
								[
									6896,
									3813
								],
								[
									6922,
									3760
								],
								[
									6955,
									3756
								],
								[
									7023,
									3711
								],
								[
									7120,
									3184
								],
								[
									7143,
									3112
								],
								[
									7208,
									3035
								],
								[
									7243,
									3011
								],
								[
									7358,
									3009
								],
								[
									7445,
									2964
								],
								[
									7460,
									2981
								],
								[
									7486,
									2939
								],
								[
									7575,
									2930
								],
								[
									7633,
									2972
								],
								[
									7699,
									3000
								],
								[
									7729,
									2994
								],
								[
									7747,
									2941
								]
							]
						],
						[
							[
								[
									6818,
									2861
								],
								[
									6869,
									2896
								],
								[
									6902,
									2896
								],
								[
									6946,
									2865
								],
								[
									6927,
									2827
								],
								[
									6827,
									2854
								],
								[
									6738,
									2856
								],
								[
									6809,
									2882
								],
								[
									6818,
									2861
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.QC",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.32,
					"hc-middle-y": 0.47,
					"hc-key": "ca-qc",
					"hc-a2": "QC",
					"labelrank": "2",
					"hasc": "CA.QC",
					"alt-name": "Lower Canada",
					"woe-id": "2344924",
					"subregion": "Québec",
					"fips": "CA10",
					"postal-code": "QC",
					"name": "Québec",
					"country": "Canada",
					"type-en": "Province",
					"region": "Eastern Canada",
					"longitude": "-73.71680000000001",
					"woe-name": "Québec",
					"latitude": "52.2593",
					"woe-label": "Quebec, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									8267,
									4881
								],
								[
									8303,
									4812
								],
								[
									8340,
									4821
								],
								[
									8332,
									4786
								],
								[
									8345,
									4734
								],
								[
									8330,
									4704
								],
								[
									8316,
									4676
								],
								[
									8210,
									4695
								],
								[
									8170,
									4640
								],
								[
									8148,
									4663
								],
								[
									8055,
									4687
								],
								[
									8080,
									4613
								],
								[
									7998,
									4641
								],
								[
									8046,
									4600
								],
								[
									8042,
									4556
								],
								[
									8016,
									4567
								],
								[
									8002,
									4533
								],
								[
									8024,
									4500
								],
								[
									8016,
									4471
								],
								[
									8083,
									4413
								],
								[
									8131,
									4403
								],
								[
									8138,
									4349
								],
								[
									8101,
									4341
								],
								[
									8120,
									4307
								],
								[
									8171,
									4289
								],
								[
									8193,
									4360
								],
								[
									8243,
									4249
								],
								[
									8283,
									4225
								],
								[
									8327,
									4246
								],
								[
									8374,
									4208
								],
								[
									8413,
									4220
								],
								[
									8445,
									4202
								],
								[
									8461,
									4233
								],
								[
									8423,
									4387
								],
								[
									8465,
									4413
								],
								[
									8491,
									4404
								],
								[
									8439,
									4350
								],
								[
									8475,
									4340
								],
								[
									8497,
									4291
								],
								[
									9103,
									4541
								],
								[
									9142,
									4457
								],
								[
									9085,
									4441
								],
								[
									9041,
									4395
								],
								[
									8998,
									4321
								],
								[
									9010,
									4295
								],
								[
									8981,
									4254
								],
								[
									8938,
									4158
								],
								[
									8869,
									4137
								],
								[
									8795,
									4080
								],
								[
									8774,
									4094
								],
								[
									8583,
									4036
								],
								[
									8544,
									4014
								],
								[
									8444,
									3987
								],
								[
									8371,
									3939
								],
								[
									8336,
									3940
								],
								[
									8288,
									3851
								],
								[
									8288,
									3769
								],
								[
									8223,
									3741
								],
								[
									8219,
									3711
								],
								[
									8181,
									3688
								],
								[
									8148,
									3628
								],
								[
									8131,
									3547
								],
								[
									8109,
									3512
								],
								[
									8086,
									3402
								],
								[
									8063,
									3387
								],
								[
									8054,
									3330
								],
								[
									8006,
									3258
								],
								[
									8077,
									3320
								],
								[
									8109,
									3404
								],
								[
									8173,
									3549
								],
								[
									8239,
									3637
								],
								[
									8373,
									3761
								],
								[
									8470,
									3818
								],
								[
									8578,
									3828
								],
								[
									8634,
									3792
								],
								[
									8634,
									3733
								],
								[
									8549,
									3634
								],
								[
									8491,
									3651
								],
								[
									8477,
									3625
								],
								[
									8454,
									3611
								],
								[
									8407,
									3585
								],
								[
									8357,
									3548
								],
								[
									8330,
									3559
								],
								[
									8256,
									3524
								],
								[
									8273,
									3468
								],
								[
									8216,
									3407
								],
								[
									8188,
									3423
								],
								[
									8145,
									3289
								],
								[
									8146,
									3130
								],
								[
									8123,
									3098
								],
								[
									8114,
									3042
								],
								[
									8092,
									3045
								],
								[
									8092,
									3045
								],
								[
									8067,
									3036
								],
								[
									8060,
									2989
								],
								[
									7932,
									2954
								],
								[
									7862,
									2935
								],
								[
									7717,
									2898
								],
								[
									7715,
									2898
								],
								[
									7802,
									2983
								],
								[
									7747,
									2941
								],
								[
									7729,
									2994
								],
								[
									7699,
									3000
								],
								[
									7633,
									2972
								],
								[
									7575,
									2930
								],
								[
									7486,
									2939
								],
								[
									7460,
									2981
								],
								[
									7445,
									2964
								],
								[
									7358,
									3009
								],
								[
									7243,
									3011
								],
								[
									7208,
									3035
								],
								[
									7143,
									3112
								],
								[
									7120,
									3184
								],
								[
									7023,
									3711
								],
								[
									7045,
									3691
								],
								[
									7022,
									3715
								],
								[
									7011,
									3777
								],
								[
									7008,
									3793
								],
								[
									7020,
									3827
								],
								[
									7059,
									3801
								],
								[
									7074,
									3768
								],
								[
									7075,
									3829
								],
								[
									7046,
									3850
								],
								[
									7080,
									3911
								],
								[
									7081,
									3952
								],
								[
									7014,
									4049
								],
								[
									7007,
									4106
								],
								[
									6987,
									4123
								],
								[
									6985,
									4207
								],
								[
									6942,
									4227
								],
								[
									6893,
									4294
								],
								[
									7008,
									4378
								],
								[
									7056,
									4428
								],
								[
									7104,
									4505
								],
								[
									7131,
									4578
								],
								[
									7120,
									4695
								],
								[
									7095,
									4772
								],
								[
									7029,
									4874
								],
								[
									6973,
									4916
								],
								[
									6933,
									4927
								],
								[
									6877,
									4965
								],
								[
									6872,
									5003
								],
								[
									6921,
									5079
								],
								[
									6909,
									5144
								],
								[
									6948,
									5171
								],
								[
									6945,
									5206
								],
								[
									6889,
									5267
								],
								[
									6901,
									5291
								],
								[
									6840,
									5334
								],
								[
									6861,
									5376
								],
								[
									6851,
									5438
								],
								[
									6869,
									5447
								],
								[
									6812,
									5506
								],
								[
									6793,
									5574
								],
								[
									6835,
									5634
								],
								[
									6877,
									5635
								],
								[
									6995,
									5612
								],
								[
									7014,
									5625
								],
								[
									7064,
									5609
								],
								[
									7136,
									5684
								],
								[
									7196,
									5647
								],
								[
									7233,
									5644
								],
								[
									7241,
									5620
								],
								[
									7284,
									5614
								],
								[
									7282,
									5590
								],
								[
									7330,
									5587
								],
								[
									7320,
									5546
								],
								[
									7375,
									5511
								],
								[
									7453,
									5511
								],
								[
									7460,
									5526
								],
								[
									7503,
									5492
								],
								[
									7523,
									5541
								],
								[
									7549,
									5499
								],
								[
									7527,
									5444
								],
								[
									7560,
									5400
								],
								[
									7558,
									5355
								],
								[
									7580,
									5343
								],
								[
									7602,
									5252
								],
								[
									7637,
									5251
								],
								[
									7617,
									5225
								],
								[
									7636,
									5190
								],
								[
									7603,
									5160
								],
								[
									7622,
									5134
								],
								[
									7652,
									5196
								],
								[
									7690,
									5211
								],
								[
									7732,
									5200
								],
								[
									7758,
									5167
								],
								[
									7817,
									5162
								],
								[
									7819,
									5115
								],
								[
									7864,
									5192
								],
								[
									7884,
									5207
								],
								[
									7891,
									5264
								],
								[
									7918,
									5260
								],
								[
									7940,
									5320
								],
								[
									7921,
									5348
								],
								[
									7951,
									5360
								],
								[
									7911,
									5427
								],
								[
									7936,
									5479
								],
								[
									7931,
									5547
								],
								[
									7960,
									5547
								],
								[
									7960,
									5542
								],
								[
									7961,
									5536
								],
								[
									7963,
									5516
								],
								[
									7973,
									5419
								],
								[
									8014,
									5427
								],
								[
									8018,
									5385
								],
								[
									8045,
									5341
								],
								[
									8081,
									5313
								],
								[
									8107,
									5345
								],
								[
									8131,
									5327
								],
								[
									8094,
									5305
								],
								[
									8122,
									5281
								],
								[
									8092,
									5217
								],
								[
									8144,
									5162
								],
								[
									8180,
									5156
								],
								[
									8209,
									5031
								],
								[
									8199,
									4992
								],
								[
									8234,
									4963
								],
								[
									8212,
									4952
								],
								[
									8244,
									4900
								],
								[
									8295,
									4909
								],
								[
									8267,
									4881
								]
							],
							[
								[
									7846,
									3103
								],
								[
									7882,
									3130
								],
								[
									7955,
									3229
								],
								[
									7970,
									3228
								],
								[
									8000,
									3253
								],
								[
									7951,
									3232
								],
								[
									7891,
									3153
								],
								[
									7853,
									3128
								],
								[
									7846,
									3103
								]
							],
							[
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								]
							],
							[
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								]
							]
						],
						[
							[
								[
									8804,
									3908
								],
								[
									8656,
									3906
								],
								[
									8607,
									3936
								],
								[
									8552,
									3938
								],
								[
									8572,
									3970
								],
								[
									8652,
									3979
								],
								[
									8746,
									3976
								],
								[
									8823,
									3964
								],
								[
									8855,
									3933
								],
								[
									8804,
									3908
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.NB",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.5,
					"hc-middle-y": 0.41,
					"hc-key": "ca-nb",
					"hc-a2": "NB",
					"labelrank": "2",
					"hasc": "CA.NB",
					"alt-name": "Nouveau-Brunswick|Acadia",
					"woe-id": "2344918",
					"subregion": "Atlantic Canada",
					"fips": "CA04",
					"postal-code": "NB",
					"name": "New Brunswick",
					"country": "Canada",
					"type-en": "Province",
					"region": "Eastern Canada",
					"longitude": "-66.4558",
					"woe-name": "New Brunswick",
					"latitude": "46.5822",
					"woe-label": "New Brunswick, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8781,
								3355
							],
							[
								8751,
								3355
							],
							[
								8742,
								3306
							],
							[
								8644,
								3202
							],
							[
								8548,
								3145
							],
							[
								8512,
								3153
							],
							[
								8476,
								3158
							],
							[
								8464,
								3207
							],
							[
								8435,
								3208
							],
							[
								8417,
								3218
							],
							[
								8357,
								3409
							],
							[
								8302,
								3442
							],
							[
								8237,
								3397
							],
							[
								8216,
								3407
							],
							[
								8273,
								3468
							],
							[
								8256,
								3524
							],
							[
								8330,
								3559
							],
							[
								8357,
								3548
							],
							[
								8407,
								3585
							],
							[
								8449,
								3612
							],
							[
								8454,
								3611
							],
							[
								8515,
								3606
							],
							[
								8546,
								3577
							],
							[
								8581,
								3614
							],
							[
								8638,
								3629
							],
							[
								8622,
								3526
							],
							[
								8603,
								3500
							],
							[
								8658,
								3520
							],
							[
								8660,
								3487
							],
							[
								8735,
								3405
							],
							[
								8817,
								3415
							],
							[
								8796,
								3386
							],
							[
								8786,
								3378
							],
							[
								8781,
								3355
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.NS",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.43,
					"hc-middle-y": 0.5,
					"hc-key": "ca-ns",
					"hc-a2": "NS",
					"labelrank": "2",
					"hasc": "CA.NS",
					"alt-name": "Acadia|Nouvelle-Écosse",
					"woe-id": "2344921",
					"subregion": "Atlantic Canada",
					"fips": "CA07",
					"postal-code": "NS",
					"name": "Nova Scotia",
					"country": "Canada",
					"type-en": "Province",
					"region": "Eastern Canada",
					"longitude": "-62.8113",
					"woe-name": "Nova Scotia",
					"latitude": "45.2293",
					"woe-label": "Nova Scotia, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8781,
								3355
							],
							[
								8786,
								3378
							],
							[
								8796,
								3386
							],
							[
								8903,
								3396
							],
							[
								8979,
								3392
							],
							[
								9019,
								3454
							],
							[
								9033,
								3428
							],
							[
								9077,
								3442
							],
							[
								9095,
								3434
							],
							[
								9049,
								3491
							],
							[
								9070,
								3570
							],
							[
								9085,
								3674
							],
							[
								9108,
								3681
							],
							[
								9135,
								3624
							],
							[
								9124,
								3490
							],
							[
								9152,
								3474
							],
							[
								9167,
								3532
							],
							[
								9131,
								3510
							],
							[
								9159,
								3585
							],
							[
								9216,
								3582
							],
							[
								9229,
								3560
							],
							[
								9189,
								3481
							],
							[
								9141,
								3437
							],
							[
								9101,
								3431
							],
							[
								9146,
								3411
							],
							[
								9140,
								3388
							],
							[
								9083,
								3358
							],
							[
								9058,
								3315
							],
							[
								8970,
								3231
							],
							[
								8916,
								3209
							],
							[
								8930,
								3182
							],
							[
								8846,
								3166
							],
							[
								8857,
								3126
							],
							[
								8828,
								3038
							],
							[
								8786,
								2980
							],
							[
								8751,
								2957
							],
							[
								8714,
								2996
							],
							[
								8696,
								2977
							],
							[
								8669,
								3025
							],
							[
								8666,
								3105
							],
							[
								8757,
								3230
							],
							[
								8801,
								3276
							],
							[
								8810,
								3244
							],
							[
								8875,
								3316
							],
							[
								8737,
								3271
							],
							[
								8781,
								3355
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.NL",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.31,
					"hc-middle-y": 0.57,
					"hc-key": "ca-nl",
					"hc-a2": "NL",
					"labelrank": "2",
					"hasc": "CA.NF",
					"alt-name": "Newfoundland|Terre-Neuve|Terre-Neuve-et-Labrador",
					"woe-id": "2344919",
					"subregion": "Atlantic Canada",
					"fips": "CA05",
					"postal-code": "NL",
					"name": "Newfoundland and Labrador",
					"country": "Canada",
					"type-en": "Province",
					"region": "Eastern Canada",
					"longitude": "-56.2169",
					"woe-name": "Newfoundland and Labrador",
					"latitude": "48.6598",
					"woe-label": "Newfoundland and Labrador, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									7964,
									5560
								],
								[
									7962,
									5553
								],
								[
									7960,
									5549
								],
								[
									7960,
									5557
								],
								[
									7964,
									5560
								]
							]
						],
						[
							[
								[
									8345,
									4734
								],
								[
									8332,
									4786
								],
								[
									8340,
									4821
								],
								[
									8303,
									4812
								],
								[
									8289,
									4862
								],
								[
									8267,
									4881
								],
								[
									8295,
									4909
								],
								[
									8244,
									4900
								],
								[
									8212,
									4952
								],
								[
									8234,
									4963
								],
								[
									8199,
									4992
								],
								[
									8209,
									5031
								],
								[
									8180,
									5156
								],
								[
									8144,
									5162
								],
								[
									8092,
									5217
								],
								[
									8122,
									5281
								],
								[
									8094,
									5305
								],
								[
									8131,
									5327
								],
								[
									8107,
									5345
								],
								[
									8081,
									5313
								],
								[
									8045,
									5341
								],
								[
									8018,
									5385
								],
								[
									8014,
									5427
								],
								[
									7973,
									5419
								],
								[
									7965,
									5515
								],
								[
									7963,
									5516
								],
								[
									7937,
									5531
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7961,
									5536
								],
								[
									8009,
									5507
								],
								[
									8026,
									5459
								],
								[
									8053,
									5456
								],
								[
									8121,
									5390
								],
								[
									8191,
									5339
								],
								[
									8168,
									5295
								],
								[
									8222,
									5322
								],
								[
									8235,
									5268
								],
								[
									8253,
									5274
								],
								[
									8306,
									5235
								],
								[
									8326,
									5202
								],
								[
									8360,
									5199
								],
								[
									8343,
									5147
								],
								[
									8405,
									5147
								],
								[
									8415,
									5092
								],
								[
									8435,
									5071
								],
								[
									8381,
									5082
								],
								[
									8389,
									5051
								],
								[
									8460,
									5050
								],
								[
									8392,
									5034
								],
								[
									8388,
									5018
								],
								[
									8447,
									5033
								],
								[
									8413,
									4990
								],
								[
									8487,
									5012
								],
								[
									8509,
									4964
								],
								[
									8578,
									4976
								],
								[
									8570,
									4955
								],
								[
									8610,
									4929
								],
								[
									8595,
									4851
								],
								[
									8624,
									4911
								],
								[
									8652,
									4931
								],
								[
									8664,
									4897
								],
								[
									8727,
									4933
								],
								[
									8756,
									4891
								],
								[
									8856,
									4914
								],
								[
									8921,
									4902
								],
								[
									8895,
									4867
								],
								[
									8852,
									4845
								],
								[
									8835,
									4784
								],
								[
									8773,
									4717
								],
								[
									8724,
									4685
								],
								[
									8735,
									4604
								],
								[
									8760,
									4652
								],
								[
									8820,
									4717
								],
								[
									8821,
									4758
								],
								[
									8874,
									4809
								],
								[
									8856,
									4825
								],
								[
									8929,
									4848
								],
								[
									8985,
									4795
								],
								[
									8958,
									4763
								],
								[
									9038,
									4828
								],
								[
									9034,
									4807
								],
								[
									9121,
									4811
								],
								[
									9146,
									4764
								],
								[
									9129,
									4731
								],
								[
									9154,
									4728
								],
								[
									9181,
									4691
								],
								[
									9146,
									4656
								],
								[
									9203,
									4666
								],
								[
									9196,
									4642
								],
								[
									9223,
									4616
								],
								[
									9213,
									4579
								],
								[
									9142,
									4457
								],
								[
									9103,
									4541
								],
								[
									8497,
									4291
								],
								[
									8475,
									4340
								],
								[
									8439,
									4350
								],
								[
									8491,
									4404
								],
								[
									8465,
									4413
								],
								[
									8423,
									4387
								],
								[
									8461,
									4233
								],
								[
									8445,
									4202
								],
								[
									8413,
									4220
								],
								[
									8374,
									4208
								],
								[
									8327,
									4246
								],
								[
									8283,
									4225
								],
								[
									8243,
									4249
								],
								[
									8193,
									4360
								],
								[
									8171,
									4289
								],
								[
									8120,
									4307
								],
								[
									8101,
									4341
								],
								[
									8138,
									4349
								],
								[
									8131,
									4403
								],
								[
									8083,
									4413
								],
								[
									8016,
									4471
								],
								[
									8024,
									4500
								],
								[
									8002,
									4533
								],
								[
									8016,
									4567
								],
								[
									8042,
									4556
								],
								[
									8046,
									4600
								],
								[
									7998,
									4641
								],
								[
									8080,
									4613
								],
								[
									8055,
									4687
								],
								[
									8148,
									4663
								],
								[
									8170,
									4640
								],
								[
									8210,
									4695
								],
								[
									8316,
									4676
								],
								[
									8349,
									4691
								],
								[
									8330,
									4704
								],
								[
									8326,
									4706
								],
								[
									8345,
									4734
								]
							]
						],
						[
							[
								[
									7960,
									5547
								],
								[
									7975,
									5542
								],
								[
									7960,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7960,
									5547
								]
							]
						],
						[
							[
								[
									7953,
									5542
								],
								[
									7952,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								],
								[
									7953,
									5542
								]
							]
						],
						[
							[
								[
									9391,
									4309
								],
								[
									9352,
									4252
								],
								[
									9383,
									4235
								],
								[
									9451,
									4245
								],
								[
									9460,
									4217
								],
								[
									9498,
									4247
								],
								[
									9513,
									4303
								],
								[
									9529,
									4267
								],
								[
									9556,
									4312
								],
								[
									9627,
									4305
								],
								[
									9605,
									4248
								],
								[
									9633,
									4189
								],
								[
									9672,
									4195
								],
								[
									9717,
									4238
								],
								[
									9715,
									4193
								],
								[
									9690,
									4160
								],
								[
									9699,
									4070
								],
								[
									9739,
									4060
								],
								[
									9731,
									4141
								],
								[
									9761,
									4170
								],
								[
									9762,
									4087
								],
								[
									9780,
									4063
								],
								[
									9793,
									4132
								],
								[
									9829,
									4103
								],
								[
									9829,
									4059
								],
								[
									9851,
									3985
								],
								[
									9804,
									3931
								],
								[
									9764,
									4006
								],
								[
									9743,
									3933
								],
								[
									9723,
									3937
								],
								[
									9717,
									4023
								],
								[
									9676,
									4076
								],
								[
									9655,
									4078
								],
								[
									9657,
									4012
								],
								[
									9624,
									3982
								],
								[
									9619,
									3892
								],
								[
									9552,
									3858
								],
								[
									9548,
									3886
								],
								[
									9581,
									3913
								],
								[
									9585,
									3992
								],
								[
									9553,
									4003
								],
								[
									9563,
									3962
								],
								[
									9518,
									3938
								],
								[
									9525,
									3964
								],
								[
									9482,
									3953
								],
								[
									9422,
									3906
								],
								[
									9296,
									3878
								],
								[
									9200,
									3813
								],
								[
									9152,
									3847
								],
								[
									9210,
									3978
								],
								[
									9177,
									3974
								],
								[
									9129,
									3939
								],
								[
									9148,
									3978
								],
								[
									9176,
									3981
								],
								[
									9170,
									4071
								],
								[
									9211,
									4062
								],
								[
									9170,
									4124
								],
								[
									9195,
									4150
								],
								[
									9177,
									4173
								],
								[
									9170,
									4341
								],
								[
									9191,
									4391
								],
								[
									9183,
									4458
								],
								[
									9244,
									4540
								],
								[
									9246,
									4519
								],
								[
									9284,
									4551
								],
								[
									9284,
									4503
								],
								[
									9241,
									4496
								],
								[
									9307,
									4453
								],
								[
									9289,
									4463
								],
								[
									9268,
									4270
								],
								[
									9290,
									4198
								],
								[
									9314,
									4314
								],
								[
									9391,
									4309
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.MB",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.34,
					"hc-middle-y": 0.39,
					"hc-key": "ca-mb",
					"hc-a2": "MB",
					"labelrank": "2",
					"hasc": "CA.MB",
					"alt-name": null,
					"woe-id": "2344917",
					"subregion": "Prairies",
					"fips": "CA03",
					"postal-code": "MB",
					"name": "Manitoba",
					"country": "Canada",
					"type-en": "Province",
					"region": "Western Canada",
					"longitude": "-97.3828",
					"woe-name": "Manitoba",
					"latitude": "54.85",
					"woe-label": "Manitoba, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								4812,
								3267
							],
							[
								4812,
								3267
							],
							[
								4818,
								4366
							],
							[
								4864,
								5059
							],
							[
								5434,
								5043
							],
							[
								5472,
								5043
							],
							[
								5480,
								4933
							],
							[
								5474,
								4878
							],
							[
								5507,
								4829
							],
							[
								5527,
								4844
							],
							[
								5618,
								4835
							],
							[
								5621,
								4800
							],
							[
								5652,
								4725
							],
							[
								5691,
								4607
							],
							[
								5668,
								4540
							],
							[
								5816,
								4598
							],
							[
								5856,
								4595
							],
							[
								5926,
								4557
							],
							[
								6007,
								4543
							],
							[
								5801,
								4277
							],
							[
								5588,
								4001
							],
							[
								5453,
								3862
							],
							[
								5458,
								3311
							],
							[
								5457,
								3251
							],
							[
								5243,
								3252
							],
							[
								5228,
								3252
							],
							[
								4812,
								3267
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "US.SC",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.62,
					"hc-middle-y": 0.44,
					"hc-key": "us-sc",
					"hc-a2": "SC",
					"labelrank": "0",
					"hasc": "US.SC",
					"alt-name": "SC|S.C.",
					"woe-id": "2347599",
					"subregion": "South Atlantic",
					"fips": "US45",
					"postal-code": "SC",
					"name": "South Carolina",
					"country": "United States of America",
					"type-en": "State",
					"region": "South",
					"longitude": "-80.6471",
					"woe-name": "South Carolina",
					"latitude": "33.8578",
					"woe-label": "South Carolina, US, United States",
					"type": "State"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								7626,
								1106
							],
							[
								7587,
								1060
							],
							[
								7568,
								984
							],
							[
								7479,
								878
							],
							[
								7439,
								850
							],
							[
								7377,
								767
							],
							[
								7351,
								771
							],
							[
								7325,
								830
							],
							[
								7295,
								847
							],
							[
								7270,
								909
							],
							[
								7235,
								922
							],
							[
								7204,
								968
							],
							[
								7111,
								1031
							],
							[
								7063,
								1102
							],
							[
								6994,
								1131
							],
							[
								7018,
								1181
							],
							[
								7119,
								1228
							],
							[
								7273,
								1244
							],
							[
								7319,
								1200
							],
							[
								7462,
								1220
							],
							[
								7626,
								1106
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.YT",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.45,
					"hc-middle-y": 0.57,
					"hc-key": "ca-yt",
					"hc-a2": "YT",
					"labelrank": "2",
					"hasc": "CA.YT",
					"alt-name": "Yukon Territory|Territoire du Yukon|Yukon|Yuk¢n",
					"woe-id": "2344926",
					"subregion": null,
					"fips": "CA12",
					"postal-code": "YT",
					"name": "Yukon",
					"country": "Canada",
					"type-en": "Territory",
					"region": "Northern Canada",
					"longitude": "-135.7",
					"woe-name": "Yukon",
					"latitude": "63.6088",
					"woe-label": "Yukon Territory, CA, Canada",
					"type": "Territoire"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2743,
								7211
							],
							[
								2648,
								7013
							],
							[
								2642,
								6946
							],
							[
								2610,
								6886
							],
							[
								2746,
								6820
							],
							[
								2743,
								6737
							],
							[
								2710,
								6702
							],
							[
								2710,
								6630
							],
							[
								2774,
								6619
							],
							[
								2761,
								6589
							],
							[
								2769,
								6535
							],
							[
								2703,
								6480
							],
							[
								2720,
								6449
							],
							[
								2686,
								6414
							],
							[
								2717,
								6386
							],
							[
								2731,
								6347
							],
							[
								2711,
								6327
							],
							[
								2762,
								6315
							],
							[
								2761,
								6230
							],
							[
								2795,
								6181
							],
							[
								2795,
								6123
							],
							[
								2763,
								6106
							],
							[
								2785,
								6052
							],
							[
								2760,
								6020
							],
							[
								2781,
								5943
							],
							[
								2761,
								5884
							],
							[
								2806,
								5868
							],
							[
								2823,
								5782
							],
							[
								2874,
								5723
							],
							[
								2855,
								5606
							],
							[
								2925,
								5586
							],
							[
								2939,
								5598
							],
							[
								2978,
								5565
							],
							[
								3045,
								5575
							],
							[
								3028,
								5530
							],
							[
								3057,
								5399
							],
							[
								1868,
								5888
							],
							[
								1867,
								5889
							],
							[
								1891,
								5942
							],
							[
								1850,
								5961
							],
							[
								1810,
								5954
							],
							[
								1748,
								6013
							],
							[
								2536,
								7472
							],
							[
								2596,
								7434
							],
							[
								2632,
								7392
							],
							[
								2662,
								7298
							],
							[
								2701,
								7239
							],
							[
								2743,
								7211
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CA.PE",
				"properties": {
					"hc-group": "admin1",
					"hc-middle-x": 0.13,
					"hc-middle-y": 0.47,
					"hc-key": "ca-pe",
					"hc-a2": "PE",
					"labelrank": "2",
					"hasc": "CA.PE",
					"alt-name": "Île de Saint-Jean|Île du Prince-Édouard",
					"woe-id": "2344923",
					"subregion": "Atlantic Canada",
					"fips": "CA09",
					"postal-code": "PE",
					"name": "Prince Edward Island",
					"country": "Canada",
					"type-en": "Province",
					"region": "Eastern Canada",
					"longitude": "-63.3862",
					"woe-name": "Prince Edward Island",
					"latitude": "46.3417",
					"woe-label": "Prince Edward Island, CA, Canada",
					"type": "Province"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8856,
								3478
							],
							[
								8981,
								3534
							],
							[
								8948,
								3505
							],
							[
								8951,
								3441
							],
							[
								8920,
								3430
							],
							[
								8897,
								3458
							],
							[
								8826,
								3436
							],
							[
								8806,
								3457
							],
							[
								8765,
								3445
							],
							[
								8754,
								3473
							],
							[
								8721,
								3474
							],
							[
								8743,
								3547
							],
							[
								8748,
								3501
							],
							[
								8806,
								3468
							],
							[
								8806,
								3486
							],
							[
								8856,
								3478
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"properties": {
					"hc-group": "__border_lines__"
				},
				"geometry": {
					"type": "MultiLineString",
					"coordinates": [
						[
							[
								6254,
								3045
							],
							[
								6184,
								2990
							],
							[
								6180,
								3029
							],
							[
								6219,
								3050
							],
							[
								6254,
								3045
							]
						],
						[
							[
								-949,
								6551
							],
							[
								-999,
								6575
							],
							[
								-889,
								6598
							],
							[
								-852,
								6586
							],
							[
								-862,
								6554
							],
							[
								-908,
								6568
							],
							[
								-949,
								6551
							]
						],
						[
							[
								-394,
								6479
							],
							[
								-400,
								6419
							],
							[
								-434,
								6417
							],
							[
								-468,
								6451
							],
							[
								-508,
								6446
							],
							[
								-539,
								6473
							],
							[
								-529,
								6499
							],
							[
								-468,
								6508
							],
							[
								-394,
								6479
							]
						],
						[
							[
								-122,
								6303
							],
							[
								-161,
								6288
							],
							[
								-183,
								6303
							],
							[
								-162,
								6331
							],
							[
								-122,
								6303
							]
						],
						[
							[
								2149,
								5059
							],
							[
								2152,
								5112
							],
							[
								2170,
								5051
							],
							[
								2120,
								5022
							],
							[
								2085,
								5114
							],
							[
								2103,
								5125
							],
							[
								2140,
								5091
							],
							[
								2149,
								5059
							]
						],
						[
							[
								743,
								6283
							],
							[
								769,
								6242
							],
							[
								745,
								6208
							],
							[
								664,
								6233
							],
							[
								644,
								6264
							],
							[
								686,
								6275
							],
							[
								712,
								6257
							],
							[
								743,
								6283
							]
						],
						[
							[
								1284,
								6275
							],
							[
								1318,
								6262
							],
							[
								1243,
								6234
							],
							[
								1200,
								6232
							],
							[
								1269,
								6257
							],
							[
								1284,
								6275
							]
						],
						[
							[
								2033,
								5311
							],
							[
								2037,
								5361
							],
							[
								2060,
								5444
							],
							[
								2109,
								5425
							],
							[
								2112,
								5364
							],
							[
								2075,
								5291
							],
							[
								2000,
								5271
							],
							[
								2033,
								5311
							]
						],
						[
							[
								2051,
								5195
							],
							[
								1988,
								5129
							],
							[
								1969,
								5089
							],
							[
								2005,
								5238
							],
							[
								2041,
								5230
							],
							[
								2054,
								5208
							],
							[
								2065,
								5256
							],
							[
								2129,
								5200
							],
							[
								2111,
								5150
							],
							[
								2134,
								5174
							],
							[
								2145,
								5134
							],
							[
								2117,
								5127
							],
							[
								2092,
								5198
							],
							[
								2095,
								5143
							],
							[
								2042,
								5154
							],
							[
								2051,
								5195
							]
						],
						[
							[
								1949,
								5373
							],
							[
								1926,
								5375
							],
							[
								1934,
								5413
							],
							[
								1918,
								5471
							],
							[
								1913,
								5495
							],
							[
								1991,
								5506
							],
							[
								2044,
								5436
							],
							[
								2015,
								5350
							],
							[
								1995,
								5356
							],
							[
								1958,
								5427
							],
							[
								1954,
								5375
							],
							[
								1975,
								5381
							],
							[
								1998,
								5330
							],
							[
								1980,
								5229
							],
							[
								1940,
								5147
							],
							[
								1926,
								5272
							],
							[
								1957,
								5296
							],
							[
								1938,
								5339
							],
							[
								1917,
								5309
							],
							[
								1921,
								5364
							],
							[
								1949,
								5373
							]
						],
						[
							[
								-39,
								7319
							],
							[
								64,
								7264
							],
							[
								78,
								7228
							],
							[
								43,
								7176
							],
							[
								-6,
								7199
							],
							[
								-30,
								7229
							],
							[
								-39,
								7319
							]
						],
						[
							[
								-871,
								6545
							],
							[
								-805,
								6517
							],
							[
								-740,
								6563
							],
							[
								-664,
								6512
							],
							[
								-639,
								6523
							],
							[
								-625,
								6490
							],
							[
								-738,
								6505
							],
							[
								-720,
								6481
							],
							[
								-842,
								6520
							],
							[
								-871,
								6545
							]
						],
						[
							[
								2098,
								4918
							],
							[
								2080,
								4840
							],
							[
								2056,
								4833
							],
							[
								2051,
								4909
							],
							[
								2015,
								4911
							],
							[
								2037,
								4943
							],
							[
								2013,
								4954
							],
							[
								1996,
								4858
							],
							[
								1990,
								4933
							],
							[
								2001,
								5000
							],
							[
								1965,
								4968
							],
							[
								1965,
								5006
							],
							[
								1993,
								5007
							],
							[
								2041,
								5050
							],
							[
								2052,
								5092
							],
							[
								2042,
								5073
							],
							[
								1982,
								5081
							],
							[
								2042,
								5098
							],
							[
								2038,
								5135
							],
							[
								2073,
								5117
							],
							[
								2065,
								5070
							],
							[
								2089,
								5050
							],
							[
								2098,
								4918
							]
						],
						[
							[
								452,
								6085
							],
							[
								401,
								6128
							],
							[
								451,
								6108
							],
							[
								467,
								6131
							],
							[
								527,
								6162
							],
							[
								501,
								6175
							],
							[
								471,
								6152
							],
							[
								459,
								6180
							],
							[
								488,
								6248
							],
							[
								549,
								6254
							],
							[
								560,
								6236
							],
							[
								631,
								6255
							],
							[
								673,
								6218
							],
							[
								650,
								6198
							],
							[
								700,
								6202
							],
							[
								660,
								6123
							],
							[
								623,
								6167
							],
							[
								624,
								6121
							],
							[
								591,
								6149
							],
							[
								523,
								6136
							],
							[
								464,
								6113
							],
							[
								452,
								6085
							]
						],
						[
							[
								185,
								7813
							],
							[
								172,
								7890
							],
							[
								154,
								7919
							],
							[
								123,
								7924
							],
							[
								127,
								7971
							],
							[
								168,
								7996
							],
							[
								157,
								7965
							],
							[
								175,
								7942
							],
							[
								232,
								7903
							],
							[
								216,
								7866
							],
							[
								229,
								7821
							],
							[
								268,
								7768
							],
							[
								245,
								7756
							],
							[
								222,
								7785
							],
							[
								168,
								7785
							],
							[
								185,
								7813
							]
						],
						[
							[
								7904,
								1825
							],
							[
								7899,
								1803
							],
							[
								7902,
								1824
							],
							[
								7907,
								1838
							],
							[
								7904,
								1825
							]
						],
						[
							[
								8003,
								2317
							],
							[
								8102,
								2350
							],
							[
								8126,
								2380
							],
							[
								8149,
								2365
							],
							[
								8156,
								2408
							],
							[
								8156,
								2368
							],
							[
								8064,
								2289
							],
							[
								7933,
								2228
							],
							[
								7960,
								2281
							],
							[
								8003,
								2317
							]
						],
						[
							[
								1945,
								4613
							],
							[
								1916,
								4640
							],
							[
								1943,
								4655
							],
							[
								1909,
								4689
							],
							[
								1914,
								4733
							],
							[
								1949,
								4790
							],
							[
								2007,
								4751
							],
							[
								2008,
								4718
							],
							[
								2015,
								4730
							],
							[
								2064,
								4734
							],
							[
								2024,
								4686
							],
							[
								1994,
								4624
							],
							[
								1962,
								4610
							],
							[
								1997,
								4604
							],
							[
								2002,
								4566
							],
							[
								1978,
								4515
							],
							[
								1981,
								4442
							],
							[
								2003,
								4401
							],
							[
								1983,
								4393
							],
							[
								1932,
								4582
							],
							[
								1922,
								4617
							],
							[
								1945,
								4613
							]
						],
						[
							[
								7730,
								6105
							],
							[
								7728,
								6098
							],
							[
								7767,
								6087
							],
							[
								7788,
								6022
							],
							[
								7766,
								6028
							],
							[
								7735,
								6074
							],
							[
								7729,
								6056
							],
							[
								7801,
								5964
							],
							[
								7748,
								5958
							],
							[
								7806,
								5900
							],
							[
								7840,
								5909
							],
							[
								7836,
								5877
							],
							[
								7808,
								5876
							],
							[
								7759,
								5911
							],
							[
								7763,
								5926
							],
							[
								7633,
								5937
							],
							[
								7524,
								6005
							],
							[
								7548,
								5966
							],
							[
								7449,
								6005
							],
							[
								7432,
								5993
							],
							[
								7516,
								5928
							],
							[
								7577,
								5911
							],
							[
								7698,
								5843
							],
							[
								7758,
								5761
							],
							[
								7737,
								5749
							],
							[
								7640,
								5768
							],
							[
								7541,
								5756
							],
							[
								7498,
								5766
							],
							[
								7442,
								5799
							],
							[
								7452,
								5819
							],
							[
								7387,
								5801
							],
							[
								7255,
								5840
							],
							[
								7246,
								5882
							],
							[
								7270,
								5914
							],
							[
								7243,
								5933
							],
							[
								7209,
								5917
							],
							[
								7180,
								5961
							],
							[
								7153,
								5935
							],
							[
								7121,
								5982
							],
							[
								7062,
								6033
							],
							[
								7013,
								6057
							],
							[
								6981,
								5986
							],
							[
								6889,
								6008
							],
							[
								6872,
								5947
							],
							[
								6787,
								5918
							],
							[
								6745,
								5932
							],
							[
								6710,
								5976
							],
							[
								6703,
								6030
							],
							[
								6755,
								6084
							],
							[
								6737,
								6128
							],
							[
								6794,
								6131
							],
							[
								6868,
								6111
							],
							[
								6874,
								6108
							],
							[
								6850,
								6127
							],
							[
								6906,
								6127
							],
							[
								6908,
								6153
							],
							[
								6947,
								6152
							],
							[
								6978,
								6197
							],
							[
								7023,
								6194
							],
							[
								6999,
								6235
							],
							[
								6922,
								6296
							],
							[
								6997,
								6432
							],
							[
								6999,
								6482
							],
							[
								7027,
								6503
							],
							[
								6977,
								6618
							],
							[
								6949,
								6636
							],
							[
								6931,
								6690
							],
							[
								6860,
								6706
							],
							[
								6865,
								6754
							],
							[
								6830,
								6759
							],
							[
								6858,
								6732
							],
							[
								6830,
								6700
							],
							[
								6791,
								6778
							],
							[
								6733,
								6792
							],
							[
								6731,
								6765
							],
							[
								6672,
								6713
							],
							[
								6658,
								6774
							],
							[
								6721,
								6802
							],
							[
								6709,
								6837
							],
							[
								6596,
								6882
							],
							[
								6611,
								6915
							],
							[
								6559,
								6908
							],
							[
								6545,
								6975
							],
							[
								6499,
								6972
							],
							[
								6444,
								7024
							],
							[
								6419,
								6991
							],
							[
								6459,
								6985
							],
							[
								6489,
								6931
							],
							[
								6479,
								6906
							],
							[
								6430,
								6888
							],
							[
								6411,
								6910
							],
							[
								6288,
								6917
							],
							[
								6328,
								6900
							],
							[
								6354,
								6849
							],
							[
								6303,
								6891
							],
							[
								6272,
								6857
							],
							[
								6209,
								6883
							],
							[
								6170,
								6865
							],
							[
								6030,
								6877
							],
							[
								6033,
								6858
							],
							[
								5981,
								6897
							],
							[
								5987,
								6851
							],
							[
								5949,
								6848
							],
							[
								5928,
								6868
							],
							[
								5978,
								6874
							],
							[
								5975,
								6920
							],
							[
								5949,
								6904
							],
							[
								5892,
								6905
							],
							[
								5838,
								6929
							],
							[
								5783,
								7010
							],
							[
								5774,
								7045
							],
							[
								5832,
								7042
							],
							[
								5853,
								7025
							],
							[
								5918,
								7041
							],
							[
								5865,
								7075
							],
							[
								5755,
								7089
							],
							[
								5742,
								7113
							],
							[
								5750,
								7174
							],
							[
								5730,
								7202
							],
							[
								5758,
								7253
							],
							[
								5734,
								7270
							],
							[
								5749,
								7377
							],
							[
								5767,
								7370
							],
							[
								5761,
								7429
							],
							[
								5773,
								7471
							],
							[
								5839,
								7571
							],
							[
								5896,
								7603
							],
							[
								5987,
								7606
							],
							[
								5999,
								7578
							],
							[
								5968,
								7542
							],
							[
								5946,
								7497
							],
							[
								5918,
								7397
							],
							[
								5922,
								7363
							],
							[
								5953,
								7316
							],
							[
								5945,
								7277
							],
							[
								5973,
								7200
							],
							[
								6018,
								7150
							],
							[
								6053,
								7137
							],
							[
								6063,
								7108
							],
							[
								5996,
								7081
							],
							[
								6066,
								7086
							],
							[
								6078,
								7149
							],
							[
								6062,
								7188
							],
							[
								6029,
								7181
							],
							[
								6004,
								7225
							],
							[
								5977,
								7247
							],
							[
								6005,
								7261
							],
							[
								6002,
								7296
							],
							[
								6029,
								7297
							],
							[
								6087,
								7259
							],
							[
								5995,
								7335
							],
							[
								5980,
								7367
							],
							[
								5982,
								7436
							],
							[
								6062,
								7410
							],
							[
								6003,
								7445
							],
							[
								5996,
								7489
							],
							[
								6023,
								7525
							],
							[
								6117,
								7608
							],
							[
								6191,
								7615
							],
							[
								6214,
								7582
							],
							[
								6229,
								7525
							],
							[
								6259,
								7514
							],
							[
								6268,
								7467
							],
							[
								6297,
								7433
							],
							[
								6294,
								7361
							],
							[
								6272,
								7322
							],
							[
								6312,
								7298
							],
							[
								6302,
								7322
							],
							[
								6330,
								7393
							],
							[
								6349,
								7363
							],
							[
								6389,
								7357
							],
							[
								6384,
								7296
							],
							[
								6416,
								7292
							],
							[
								6396,
								7349
							],
							[
								6409,
								7377
							],
							[
								6459,
								7365
							],
							[
								6408,
								7391
							],
							[
								6408,
								7423
							],
							[
								6450,
								7466
							],
							[
								6491,
								7472
							],
							[
								6510,
								7455
							],
							[
								6600,
								7447
							],
							[
								6626,
								7404
							],
							[
								6625,
								7377
							],
							[
								6676,
								7379
							],
							[
								6686,
								7330
							],
							[
								6642,
								7296
							],
							[
								6671,
								7293
							],
							[
								6728,
								7329
							],
							[
								6716,
								7271
							],
							[
								6767,
								7259
							],
							[
								6754,
								7289
							],
							[
								6774,
								7299
							],
							[
								6784,
								7323
							],
							[
								6860,
								7314
							],
							[
								6901,
								7276
							],
							[
								6891,
								7233
							],
							[
								6854,
								7226
							],
							[
								6854,
								7200
							],
							[
								6869,
								7225
							],
							[
								6900,
								7203
							],
							[
								6863,
								7176
							],
							[
								6854,
								7190
							],
							[
								6853,
								7160
							],
							[
								6908,
								7201
							],
							[
								6929,
								7252
							],
							[
								6954,
								7224
							],
							[
								6934,
								7140
							],
							[
								6945,
								7060
							],
							[
								6942,
								7160
							],
							[
								6994,
								7224
							],
							[
								6999,
								7196
							],
							[
								6974,
								7165
							],
							[
								7002,
								7170
							],
							[
								7019,
								7210
							],
							[
								7105,
								7198
							],
							[
								7109,
								7157
							],
							[
								7056,
								7116
							],
							[
								7025,
								7047
							],
							[
								7053,
								7061
							],
							[
								7048,
								7092
							],
							[
								7105,
								7123
							],
							[
								7112,
								7113
							],
							[
								7078,
								7038
							],
							[
								7141,
								7118
							],
							[
								7138,
								7157
							],
							[
								7211,
								7105
							],
							[
								7231,
								7068
							],
							[
								7189,
								7065
							],
							[
								7191,
								7002
							],
							[
								7213,
								7038
							],
							[
								7275,
								7005
							],
							[
								7291,
								6980
							],
							[
								7228,
								6958
							],
							[
								7187,
								6971
							],
							[
								7133,
								6964
							],
							[
								7197,
								6953
							],
							[
								7174,
								6946
							],
							[
								7232,
								6932
							],
							[
								7216,
								6914
							],
							[
								7244,
								6886
							],
							[
								7153,
								6867
							],
							[
								7232,
								6863
							],
							[
								7215,
								6841
							],
							[
								7322,
								6841
							],
							[
								7361,
								6778
							],
							[
								7375,
								6830
							],
							[
								7390,
								6775
							],
							[
								7405,
								6793
							],
							[
								7489,
								6813
							],
							[
								7472,
								6780
							],
							[
								7525,
								6784
							],
							[
								7580,
								6754
							],
							[
								7584,
								6713
							],
							[
								7532,
								6680
							],
							[
								7589,
								6694
							],
							[
								7602,
								6731
							],
							[
								7652,
								6724
							],
							[
								7648,
								6659
							],
							[
								7679,
								6700
							],
							[
								7728,
								6657
							],
							[
								7710,
								6712
							],
							[
								7743,
								6711
							],
							[
								7799,
								6676
							],
							[
								7808,
								6620
							],
							[
								7745,
								6567
							],
							[
								7799,
								6548
							],
							[
								7769,
								6529
							],
							[
								7786,
								6475
							],
							[
								7738,
								6451
							],
							[
								7717,
								6411
							],
							[
								7755,
								6379
							],
							[
								7761,
								6321
							],
							[
								7726,
								6357
							],
							[
								7696,
								6334
							],
							[
								7671,
								6368
							],
							[
								7677,
								6326
							],
							[
								7579,
								6402
							],
							[
								7565,
								6454
							],
							[
								7535,
								6438
							],
							[
								7519,
								6463
							],
							[
								7432,
								6515
							],
							[
								7396,
								6505
							],
							[
								7427,
								6471
							],
							[
								7367,
								6479
							],
							[
								7387,
								6446
							],
							[
								7440,
								6422
							],
							[
								7445,
								6404
							],
							[
								7394,
								6382
							],
							[
								7381,
								6412
							],
							[
								7336,
								6421
							],
							[
								7381,
								6358
							],
							[
								7412,
								6339
							],
							[
								7436,
								6359
							],
							[
								7449,
								6324
							],
							[
								7477,
								6327
							],
							[
								7506,
								6270
							],
							[
								7624,
								6244
							],
							[
								7629,
								6212
							],
							[
								7672,
								6215
							],
							[
								7653,
								6174
							],
							[
								7702,
								6143
							],
							[
								7737,
								6138
							],
							[
								7731,
								6110
							],
							[
								7749,
								6127
							],
							[
								7771,
								6112
							],
							[
								7804,
								6042
							],
							[
								7761,
								6099
							],
							[
								7730,
								6105
							]
						],
						[
							[
								2284,
								4307
							],
							[
								2258,
								4259
							],
							[
								2252,
								4240
							],
							[
								2242,
								4333
							],
							[
								2284,
								4307
							]
						],
						[
							[
								2119,
								4594
							],
							[
								2137,
								4615
							],
							[
								2177,
								4557
							],
							[
								2171,
								4523
							],
							[
								2130,
								4603
							],
							[
								2119,
								4594
							]
						],
						[
							[
								2211,
								4429
							],
							[
								2225,
								4487
							],
							[
								2235,
								4520
							],
							[
								2277,
								4479
							],
							[
								2250,
								4365
							],
							[
								2222,
								4345
							],
							[
								2252,
								4445
							],
							[
								2205,
								4384
							],
							[
								2194,
								4458
							],
							[
								2211,
								4429
							]
						],
						[
							[
								2136,
								4643
							],
							[
								2157,
								4733
							],
							[
								2150,
								4677
							],
							[
								2177,
								4674
							],
							[
								2224,
								4532
							],
							[
								2207,
								4532
							],
							[
								2198,
								4480
							],
							[
								2181,
								4570
							],
							[
								2136,
								4643
							]
						],
						[
							[
								2456,
								3780
							],
							[
								2525,
								3723
							],
							[
								2560,
								3656
							],
							[
								2542,
								3603
							],
							[
								2511,
								3580
							],
							[
								2412,
								3655
							],
							[
								2372,
								3706
							],
							[
								2416,
								3728
							],
							[
								2362,
								3727
							],
							[
								2294,
								3812
							],
							[
								2280,
								3894
							],
							[
								2255,
								3885
							],
							[
								2221,
								3991
							],
							[
								2197,
								4012
							],
							[
								2163,
								4084
							],
							[
								2162,
								4112
							],
							[
								2220,
								4111
							],
							[
								2248,
								4068
							],
							[
								2333,
								4000
							],
							[
								2453,
								3944
							],
							[
								2429,
								3875
							],
							[
								2456,
								3780
							]
						],
						[
							[
								6775,
								4040
							],
							[
								6805,
								4041
							],
							[
								6845,
								4006
							],
							[
								6859,
								3968
							],
							[
								6720,
								3998
							],
							[
								6733,
								4026
							],
							[
								6775,
								4040
							]
						],
						[
							[
								7663,
								5497
							],
							[
								7690,
								5483
							],
							[
								7687,
								5451
							],
							[
								7651,
								5435
							],
							[
								7663,
								5497
							]
						],
						[
							[
								7837,
								5767
							],
							[
								7867,
								5759
							],
							[
								7876,
								5702
							],
							[
								7812,
								5728
							],
							[
								7837,
								5767
							]
						],
						[
							[
								6689,
								5569
							],
							[
								6710,
								5504
							],
							[
								6689,
								5430
							],
							[
								6649,
								5456
							],
							[
								6635,
								5517
							],
							[
								6657,
								5568
							],
							[
								6689,
								5569
							]
						],
						[
							[
								7341,
								5803
							],
							[
								7400,
								5775
							],
							[
								7358,
								5757
							],
							[
								7307,
								5802
							],
							[
								7341,
								5803
							]
						],
						[
							[
								6733,
								5773
							],
							[
								6790,
								5775
							],
							[
								6809,
								5734
							],
							[
								6783,
								5711
							],
							[
								6727,
								5754
							],
							[
								6733,
								5773
							]
						],
						[
							[
								6823,
								5823
							],
							[
								6876,
								5798
							],
							[
								6845,
								5781
							],
							[
								6805,
								5805
							],
							[
								6823,
								5823
							]
						],
						[
							[
								6165,
								6141
							],
							[
								6211,
								6072
							],
							[
								6203,
								6056
							],
							[
								6169,
								6090
							],
							[
								6165,
								6141
							]
						],
						[
							[
								6283,
								6115
							],
							[
								6240,
								6099
							],
							[
								6238,
								6124
							],
							[
								6207,
								6162
							],
							[
								6283,
								6115
							]
						],
						[
							[
								6853,
								6640
							],
							[
								6916,
								6635
							],
							[
								6925,
								6601
							],
							[
								6858,
								6585
							],
							[
								6822,
								6630
							],
							[
								6853,
								6640
							]
						],
						[
							[
								6036,
								6471
							],
							[
								6024,
								6432
							],
							[
								5991,
								6491
							],
							[
								6007,
								6538
							],
							[
								6028,
								6521
							],
							[
								6036,
								6471
							]
						],
						[
							[
								6791,
								6715
							],
							[
								6807,
								6676
							],
							[
								6759,
								6702
							],
							[
								6762,
								6741
							],
							[
								6791,
								6715
							]
						],
						[
							[
								5092,
								6625
							],
							[
								5076,
								6588
							],
							[
								5059,
								6603
							],
							[
								5061,
								6640
							],
							[
								5092,
								6625
							]
						],
						[
							[
								6525,
								6680
							],
							[
								6552,
								6677
							],
							[
								6530,
								6622
							],
							[
								6510,
								6719
							],
							[
								6478,
								6721
							],
							[
								6516,
								6813
							],
							[
								6531,
								6788
							],
							[
								6515,
								6723
							],
							[
								6525,
								6680
							]
						],
						[
							[
								6615,
								6842
							],
							[
								6642,
								6842
							],
							[
								6612,
								6789
							],
							[
								6597,
								6838
							],
							[
								6615,
								6842
							]
						],
						[
							[
								5392,
								6748
							],
							[
								5412,
								6731
							],
							[
								5390,
								6693
							],
							[
								5389,
								6737
							],
							[
								5392,
								6748
							]
						],
						[
							[
								6546,
								6879
							],
							[
								6518,
								6835
							],
							[
								6495,
								6834
							],
							[
								6532,
								6888
							],
							[
								6546,
								6879
							]
						],
						[
							[
								6415,
								6799
							],
							[
								6366,
								6859
							],
							[
								6431,
								6883
							],
							[
								6458,
								6866
							],
							[
								6423,
								6840
							],
							[
								6415,
								6799
							]
						],
						[
							[
								5327,
								7428
							],
							[
								5338,
								7416
							],
							[
								5316,
								7390
							],
							[
								5304,
								7421
							],
							[
								5327,
								7428
							]
						],
						[
							[
								5279,
								7623
							],
							[
								5250,
								7584
							],
							[
								5204,
								7571
							],
							[
								5177,
								7592
							],
							[
								5216,
								7616
							],
							[
								5274,
								7633
							],
							[
								5279,
								7623
							]
						],
						[
							[
								4958,
								7891
							],
							[
								4965,
								7867
							],
							[
								4927,
								7838
							],
							[
								4893,
								7863
							],
							[
								4910,
								7908
							],
							[
								4941,
								7924
							],
							[
								4958,
								7891
							]
						],
						[
							[
								5356,
								7950
							],
							[
								5376,
								7931
							],
							[
								5325,
								7889
							],
							[
								5315,
								7919
							],
							[
								5356,
								7950
							]
						],
						[
							[
								5057,
								8029
							],
							[
								5020,
								7986
							],
							[
								4988,
								7987
							],
							[
								5006,
								8019
							],
							[
								5057,
								8029
							]
						],
						[
							[
								5045,
								8050
							],
							[
								5043,
								8039
							],
							[
								4972,
								8018
							],
							[
								4958,
								8031
							],
							[
								5045,
								8050
							]
						],
						[
							[
								6239,
								8133
							],
							[
								6238,
								8101
							],
							[
								6257,
								8077
							],
							[
								6213,
								8071
							],
							[
								6239,
								8133
							]
						],
						[
							[
								5032,
								8095
							],
							[
								5019,
								8055
							],
							[
								4968,
								8049
							],
							[
								4941,
								8061
							],
							[
								4946,
								8089
							],
							[
								5029,
								8105
							],
							[
								5032,
								8095
							]
						],
						[
							[
								4973,
								8176
							],
							[
								5014,
								8138
							],
							[
								4998,
								8111
							],
							[
								4945,
								8114
							],
							[
								4937,
								8175
							],
							[
								4973,
								8176
							]
						],
						[
							[
								5688,
								8147
							],
							[
								5671,
								8139
							],
							[
								5642,
								8187
							],
							[
								5670,
								8216
							],
							[
								5685,
								8198
							],
							[
								5688,
								8147
							]
						],
						[
							[
								5643,
								8388
							],
							[
								5674,
								8352
							],
							[
								5679,
								8323
							],
							[
								5659,
								8295
							],
							[
								5603,
								8337
							],
							[
								5602,
								8383
							],
							[
								5643,
								8388
							]
						],
						[
							[
								4936,
								8354
							],
							[
								4963,
								8328
							],
							[
								4942,
								8286
							],
							[
								4909,
								8332
							],
							[
								4893,
								8431
							],
							[
								4920,
								8424
							],
							[
								4940,
								8381
							],
							[
								4936,
								8354
							]
						],
						[
							[
								5137,
								8412
							],
							[
								5095,
								8400
							],
							[
								5065,
								8414
							],
							[
								5070,
								8449
							],
							[
								5105,
								8447
							],
							[
								5137,
								8412
							]
						],
						[
							[
								5228,
								8958
							],
							[
								5242,
								8962
							],
							[
								5258,
								8922
							],
							[
								5252,
								8852
							],
							[
								5220,
								8907
							],
							[
								5200,
								8903
							],
							[
								5196,
								8940
							],
							[
								5228,
								8958
							]
						],
						[
							[
								4538,
								7362
							],
							[
								4550,
								7358
							],
							[
								4540,
								7369
							],
							[
								4526,
								7384
							],
							[
								4540,
								7375
							],
							[
								4553,
								7369
							],
							[
								4544,
								7395
							],
							[
								4539,
								7403
							],
							[
								4546,
								7411
							],
							[
								4559,
								7413
							],
							[
								4547,
								7420
							],
							[
								4522,
								7441
							],
							[
								4515,
								7476
							],
							[
								4555,
								7465
							],
							[
								4622,
								7371
							],
							[
								4615,
								7331
							],
							[
								4632,
								7247
							],
							[
								4622,
								7218
							],
							[
								4652,
								7182
							],
							[
								4687,
								7232
							],
							[
								4662,
								7281
							],
							[
								4659,
								7356
							],
							[
								4667,
								7494
							],
							[
								4680,
								7522
							],
							[
								4724,
								7484
							],
							[
								4744,
								7506
							],
							[
								4797,
								7439
							],
							[
								4820,
								7392
							],
							[
								4817,
								7326
							],
							[
								4826,
								7257
							],
							[
								4856,
								7153
							],
							[
								4858,
								7106
							],
							[
								4831,
								7061
							],
							[
								4867,
								6987
							],
							[
								4916,
								6937
							],
							[
								4934,
								6936
							],
							[
								5014,
								6854
							],
							[
								5049,
								6861
							],
							[
								5053,
								6793
							],
							[
								5024,
								6753
							],
							[
								5015,
								6812
							],
							[
								4999,
								6766
							],
							[
								4969,
								6803
							],
							[
								4940,
								6788
							],
							[
								4924,
								6751
							],
							[
								4884,
								6786
							],
							[
								4878,
								6770
							],
							[
								4919,
								6723
							],
							[
								4972,
								6737
							],
							[
								4962,
								6713
							],
							[
								4988,
								6675
							],
							[
								4969,
								6614
							],
							[
								4986,
								6606
							],
							[
								4973,
								6566
							],
							[
								4942,
								6590
							],
							[
								4970,
								6641
							],
							[
								4899,
								6614
							],
							[
								4869,
								6614
							],
							[
								4805,
								6649
							],
							[
								4794,
								6635
							],
							[
								4750,
								6656
							],
							[
								4775,
								6671
							],
							[
								4679,
								6708
							],
							[
								4690,
								6748
							],
							[
								4674,
								6768
							],
							[
								4614,
								6685
							],
							[
								4532,
								6681
							],
							[
								4499,
								6647
							],
							[
								4452,
								6635
							],
							[
								4334,
								6644
							],
							[
								4237,
								6638
							],
							[
								4201,
								6669
							],
							[
								4188,
								6711
							],
							[
								4200,
								6784
							],
							[
								4158,
								6810
							],
							[
								4104,
								6813
							],
							[
								4056,
								6834
							],
							[
								4020,
								6874
							],
							[
								4014,
								6911
							],
							[
								3993,
								6939
							],
							[
								3991,
								6983
							],
							[
								4027,
								7002
							],
							[
								4090,
								7005
							],
							[
								4210,
								6998
							],
							[
								4307,
								6957
							],
							[
								4369,
								6967
							],
							[
								4345,
								7007
							],
							[
								4301,
								7024
							],
							[
								4267,
								7058
							],
							[
								4224,
								7064
							],
							[
								4053,
								7067
							],
							[
								4066,
								7086
							],
							[
								4027,
								7084
							],
							[
								3983,
								7152
							],
							[
								3980,
								7189
							],
							[
								4134,
								7223
							],
							[
								4158,
								7252
							],
							[
								4047,
								7243
							],
							[
								4006,
								7272
							],
							[
								4050,
								7282
							],
							[
								4029,
								7305
							],
							[
								3969,
								7313
							],
							[
								3984,
								7371
							],
							[
								4016,
								7405
							],
							[
								4052,
								7413
							],
							[
								4035,
								7459
							],
							[
								4068,
								7492
							],
							[
								4128,
								7536
							],
							[
								4307,
								7592
							],
							[
								4332,
								7533
							],
							[
								4316,
								7470
							],
							[
								4274,
								7440
							],
							[
								4325,
								7431
							],
							[
								4356,
								7485
							],
							[
								4382,
								7501
							],
							[
								4432,
								7468
							],
							[
								4476,
								7425
							],
							[
								4466,
								7395
							],
							[
								4427,
								7365
							],
							[
								4435,
								7345
							],
							[
								4499,
								7391
							],
							[
								4538,
								7362
							]
						],
						[
							[
								4647,
								8062
							],
							[
								4689,
								8096
							],
							[
								4657,
								8128
							],
							[
								4645,
								8175
							],
							[
								4666,
								8183
							],
							[
								4718,
								8249
							],
							[
								4739,
								8256
							],
							[
								4749,
								8215
							],
							[
								4734,
								8208
							],
							[
								4757,
								8127
							],
							[
								4728,
								8077
							],
							[
								4762,
								8078
							],
							[
								4755,
								8044
							],
							[
								4799,
								8036
							],
							[
								4826,
								8070
							],
							[
								4867,
								8050
							],
							[
								4879,
								7978
							],
							[
								4856,
								7944
							],
							[
								4858,
								7915
							],
							[
								4833,
								7855
							],
							[
								4749,
								7841
							],
							[
								4743,
								7864
							],
							[
								4700,
								7842
							],
							[
								4683,
								7877
							],
							[
								4636,
								7839
							],
							[
								4613,
								7841
							],
							[
								4512,
								7784
							],
							[
								4434,
								7776
							],
							[
								4399,
								7793
							],
							[
								4369,
								7850
							],
							[
								4468,
								7894
							],
							[
								4535,
								7888
							],
							[
								4576,
								7932
							],
							[
								4497,
								7918
							],
							[
								4410,
								7924
							],
							[
								4430,
								7977
							],
							[
								4418,
								7985
							],
							[
								4385,
								7928
							],
							[
								4353,
								7914
							],
							[
								4348,
								7958
							],
							[
								4313,
								7923
							],
							[
								4289,
								7949
							],
							[
								4296,
								7978
							],
							[
								4270,
								7966
							],
							[
								4230,
								7991
							],
							[
								4235,
								8024
							],
							[
								4260,
								8045
							],
							[
								4320,
								8032
							],
							[
								4365,
								8047
							],
							[
								4381,
								8067
							],
							[
								4320,
								8052
							],
							[
								4264,
								8064
							],
							[
								4291,
								8104
							],
							[
								4397,
								8098
							],
							[
								4399,
								8107
							],
							[
								4329,
								8113
							],
							[
								4305,
								8125
							],
							[
								4313,
								8158
							],
							[
								4368,
								8185
							],
							[
								4366,
								8210
							],
							[
								4391,
								8228
							],
							[
								4456,
								8218
							],
							[
								4457,
								8156
							],
							[
								4509,
								8164
							],
							[
								4533,
								8137
							],
							[
								4531,
								8108
							],
							[
								4558,
								8084
							],
							[
								4533,
								8067
							],
							[
								4570,
								8059
							],
							[
								4569,
								7990
							],
							[
								4635,
								7985
							],
							[
								4691,
								7965
							],
							[
								4688,
								8021
							],
							[
								4646,
								8055
							],
							[
								4644,
								8059
							],
							[
								4647,
								8062
							]
						],
						[
							[
								4721,
								8536
							],
							[
								4739,
								8523
							],
							[
								4715,
								8498
							],
							[
								4674,
								8491
							],
							[
								4676,
								8467
							],
							[
								4704,
								8466
							],
							[
								4689,
								8406
							],
							[
								4593,
								8382
							],
							[
								4550,
								8435
							],
							[
								4564,
								8518
							],
							[
								4613,
								8534
							],
							[
								4688,
								8542
							],
							[
								4721,
								8536
							]
						],
						[
							[
								4741,
								8668
							],
							[
								4767,
								8611
							],
							[
								4754,
								8578
							],
							[
								4729,
								8587
							],
							[
								4712,
								8580
							],
							[
								4679,
								8609
							],
							[
								4662,
								8585
							],
							[
								4632,
								8614
							],
							[
								4588,
								8599
							],
							[
								4586,
								8630
							],
							[
								4641,
								8655
							],
							[
								4655,
								8650
							],
							[
								4690,
								8679
							],
							[
								4725,
								8689
							],
							[
								4741,
								8668
							]
						],
						[
							[
								7960,
								5557
							],
							[
								7960,
								5549
							],
							[
								7925,
								5563
							],
							[
								7964,
								5560
							],
							[
								7962,
								5553
							],
							[
								7960,
								5549
							],
							[
								7960,
								5557
							]
						],
						[
							[
								6387,
								5601
							],
							[
								6463,
								5634
							],
							[
								6484,
								5595
							],
							[
								6402,
								5486
							],
							[
								6360,
								5475
							],
							[
								6333,
								5532
							],
							[
								6371,
								5613
							],
							[
								6387,
								5601
							]
						],
						[
							[
								6662,
								6527
							],
							[
								6684,
								6636
							],
							[
								6707,
								6655
							],
							[
								6755,
								6662
							],
							[
								6789,
								6655
							],
							[
								6822,
								6533
							],
							[
								6808,
								6494
							],
							[
								6778,
								6468
							],
							[
								6703,
								6449
							],
							[
								6662,
								6527
							]
						],
						[
							[
								4769,
								7583
							],
							[
								4851,
								7584
							],
							[
								4885,
								7542
							],
							[
								4875,
								7491
							],
							[
								4825,
								7404
							],
							[
								4767,
								7523
							],
							[
								4739,
								7541
							],
							[
								4769,
								7583
							]
						],
						[
							[
								6833,
								4490
							],
							[
								6865,
								4557
							],
							[
								6852,
								4632
							],
							[
								6833,
								4641
							],
							[
								6853,
								4641
							],
							[
								6869,
								4552
							],
							[
								6894,
								4609
							],
							[
								6933,
								4600
							],
							[
								6946,
								4558
							],
							[
								6907,
								4579
							],
							[
								6884,
								4496
							],
							[
								6867,
								4531
							],
							[
								6846,
								4480
							],
							[
								6833,
								4490
							]
						],
						[
							[
								6534,
								5730
							],
							[
								6446,
								5758
							],
							[
								6415,
								5753
							],
							[
								6404,
								5802
							],
							[
								6364,
								5793
							],
							[
								6362,
								5834
							],
							[
								6315,
								5796
							],
							[
								6324,
								5754
							],
							[
								6278,
								5723
							],
							[
								6262,
								5666
							],
							[
								6212,
								5627
							],
							[
								6182,
								5644
							],
							[
								6178,
								5708
							],
							[
								6160,
								5724
							],
							[
								6056,
								5690
							],
							[
								6072,
								5753
							],
							[
								6122,
								5788
							],
							[
								6096,
								5873
							],
							[
								6109,
								5935
							],
							[
								6101,
								5996
							],
							[
								6109,
								6083
							],
							[
								6139,
								6115
							],
							[
								6177,
								6064
							],
							[
								6159,
								6049
							],
							[
								6201,
								5995
							],
							[
								6215,
								6046
							],
							[
								6256,
								6001
							],
							[
								6310,
								5995
							],
							[
								6328,
								5964
							],
							[
								6396,
								5942
							],
							[
								6447,
								5904
							],
							[
								6473,
								5857
							],
							[
								6444,
								5814
							],
							[
								6489,
								5833
							],
							[
								6557,
								5826
							],
							[
								6587,
								5802
							],
							[
								6534,
								5730
							]
						],
						[
							[
								5384,
								6583
							],
							[
								5336,
								6530
							],
							[
								5271,
								6547
							],
							[
								5252,
								6569
							],
							[
								5201,
								6589
							],
							[
								5170,
								6628
							],
							[
								5157,
								6605
							],
							[
								5131,
								6641
							],
							[
								5212,
								6695
							],
							[
								5199,
								6719
							],
							[
								5226,
								6785
							],
							[
								5276,
								6803
							],
							[
								5312,
								6727
							],
							[
								5361,
								6739
							],
							[
								5350,
								6707
							],
							[
								5381,
								6613
							],
							[
								5424,
								6606
							],
							[
								5403,
								6573
							],
							[
								5384,
								6583
							]
						],
						[
							[
								6248,
								7535
							],
							[
								6232,
								7622
							],
							[
								6250,
								7636
							],
							[
								6311,
								7619
							],
							[
								6383,
								7640
							],
							[
								6441,
								7619
							],
							[
								6514,
								7549
							],
							[
								6521,
								7494
							],
							[
								6455,
								7493
							],
							[
								6411,
								7487
							],
							[
								6359,
								7448
							],
							[
								6311,
								7458
							],
							[
								6285,
								7532
							],
							[
								6248,
								7535
							]
						],
						[
							[
								5245,
								7117
							],
							[
								5202,
								7068
							],
							[
								5170,
								7084
							],
							[
								5135,
								7185
							],
							[
								5092,
								7251
							],
							[
								5058,
								7282
							],
							[
								5021,
								7283
							],
							[
								5016,
								7317
							],
							[
								4979,
								7352
							],
							[
								4973,
								7383
							],
							[
								4993,
								7427
							],
							[
								5019,
								7433
							],
							[
								5058,
								7358
							],
							[
								5108,
								7359
							],
							[
								5134,
								7403
							],
							[
								5125,
								7438
							],
							[
								5103,
								7442
							],
							[
								5120,
								7477
							],
							[
								5090,
								7465
							],
							[
								5048,
								7514
							],
							[
								5090,
								7534
							],
							[
								5094,
								7580
							],
							[
								5142,
								7565
							],
							[
								5133,
								7596
							],
							[
								5157,
								7599
							],
							[
								5188,
								7557
							],
							[
								5252,
								7572
							],
							[
								5263,
								7588
							],
							[
								5300,
								7579
							],
							[
								5314,
								7531
							],
							[
								5289,
								7513
							],
							[
								5305,
								7485
							],
							[
								5271,
								7468
							],
							[
								5234,
								7416
							],
							[
								5297,
								7398
							],
							[
								5311,
								7361
							],
							[
								5326,
								7385
							],
							[
								5353,
								7291
							],
							[
								5338,
								7259
							],
							[
								5337,
								7176
							],
							[
								5312,
								7170
							],
							[
								5281,
								7133
							],
							[
								5235,
								7142
							],
							[
								5245,
								7117
							]
						],
						[
							[
								5502,
								7743
							],
							[
								5441,
								7737
							],
							[
								5409,
								7773
							],
							[
								5398,
								7760
							],
							[
								5407,
								7709
							],
							[
								5378,
								7727
							],
							[
								5397,
								7775
							],
							[
								5377,
								7777
							],
							[
								5352,
								7815
							],
							[
								5346,
								7854
							],
							[
								5382,
								7919
							],
							[
								5429,
								7949
							],
							[
								5434,
								7979
							],
							[
								5427,
								8012
							],
							[
								5448,
								8024
							],
							[
								5459,
								7975
							],
							[
								5441,
								7971
							],
							[
								5504,
								7871
							],
							[
								5512,
								7792
							],
							[
								5502,
								7743
							]
						],
						[
							[
								5225,
								8161
							],
							[
								5287,
								8130
							],
							[
								5280,
								8095
							],
							[
								5294,
								8059
							],
							[
								5289,
								7996
							],
							[
								5270,
								7971
							],
							[
								5299,
								7957
							],
							[
								5256,
								7885
							],
							[
								5287,
								7846
							],
							[
								5261,
								7820
							],
							[
								5174,
								7812
							],
							[
								5137,
								7822
							],
							[
								5121,
								7912
							],
							[
								5157,
								7914
							],
							[
								5170,
								7956
							],
							[
								5085,
								7950
							],
							[
								5021,
								7931
							],
							[
								5021,
								7969
							],
							[
								5044,
								7977
							],
							[
								5046,
								8008
							],
							[
								5068,
								8014
							],
							[
								5091,
								7986
							],
							[
								5067,
								8053
							],
							[
								5096,
								8087
							],
							[
								5059,
								8082
							],
							[
								5077,
								8132
							],
							[
								5112,
								8105
							],
							[
								5110,
								8083
							],
							[
								5173,
								8018
							],
							[
								5142,
								8080
							],
							[
								5166,
								8095
							],
							[
								5134,
								8112
							],
							[
								5119,
								8140
							],
							[
								5133,
								8170
							],
							[
								5085,
								8160
							],
							[
								5123,
								8190
							],
							[
								5159,
								8189
							],
							[
								5188,
								8165
							],
							[
								5212,
								8125
							],
							[
								5225,
								8161
							]
						],
						[
							[
								5710,
								8076
							],
							[
								5615,
								8066
							],
							[
								5670,
								8049
							],
							[
								5624,
								8039
							],
							[
								5676,
								8021
							],
							[
								5685,
								8036
							],
							[
								5726,
								7994
							],
							[
								5725,
								7960
							],
							[
								5746,
								7918
							],
							[
								5760,
								7968
							],
							[
								5783,
								7931
							],
							[
								5824,
								7964
							],
							[
								5879,
								7931
							],
							[
								5945,
								7986
							],
							[
								5970,
								7982
							],
							[
								6008,
								8031
							],
							[
								6044,
								8017
							],
							[
								6080,
								8045
							],
							[
								6145,
								8041
							],
							[
								6140,
								8015
							],
							[
								6180,
								8022
							],
							[
								6232,
								7990
							],
							[
								6244,
								7930
							],
							[
								6206,
								7893
							],
							[
								6252,
								7897
							],
							[
								6268,
								7870
							],
							[
								6226,
								7838
							],
							[
								6236,
								7811
							],
							[
								6175,
								7788
							],
							[
								6153,
								7762
							],
							[
								6088,
								7772
							],
							[
								6069,
								7828
							],
							[
								6056,
								7773
							],
							[
								6017,
								7753
							],
							[
								5889,
								7731
							],
							[
								5783,
								7727
							],
							[
								5776,
								7809
							],
							[
								5761,
								7759
							],
							[
								5704,
								7728
							],
							[
								5643,
								7759
							],
							[
								5655,
								7798
							],
							[
								5617,
								7746
							],
							[
								5588,
								7772
							],
							[
								5580,
								7846
							],
							[
								5560,
								7862
							],
							[
								5566,
								7925
							],
							[
								5581,
								7944
							],
							[
								5569,
								8006
							],
							[
								5517,
								8106
							],
							[
								5470,
								8081
							],
							[
								5380,
								8110
							],
							[
								5347,
								8173
							],
							[
								5355,
								8199
							],
							[
								5331,
								8238
							],
							[
								5382,
								8258
							],
							[
								5485,
								8225
							],
							[
								5518,
								8162
							],
							[
								5537,
								8156
							],
							[
								5599,
								8180
							],
							[
								5644,
								8154
							],
							[
								5649,
								8134
							],
							[
								5604,
								8129
							],
							[
								5712,
								8102
							],
							[
								5710,
								8076
							]
						],
						[
							[
								5491,
								8345
							],
							[
								5372,
								8346
							],
							[
								5357,
								8372
							],
							[
								5376,
								8409
							],
							[
								5397,
								8421
							],
							[
								5484,
								8415
							],
							[
								5504,
								8403
							],
							[
								5491,
								8345
							]
						],
						[
							[
								5275,
								8651
							],
							[
								5306,
								8645
							],
							[
								5364,
								8605
							],
							[
								5425,
								8546
							],
							[
								5400,
								8519
							],
							[
								5423,
								8488
							],
							[
								5415,
								8457
							],
							[
								5319,
								8431
							],
							[
								5324,
								8446
							],
							[
								5288,
								8473
							],
							[
								5331,
								8494
							],
							[
								5286,
								8515
							],
							[
								5261,
								8577
							],
							[
								5275,
								8651
							]
						],
						[
							[
								4979,
								8614
							],
							[
								5030,
								8592
							],
							[
								5035,
								8657
							],
							[
								5002,
								8659
							],
							[
								5021,
								8680
							],
							[
								5013,
								8704
							],
							[
								4967,
								8672
							],
							[
								4987,
								8713
							],
							[
								4948,
								8720
							],
							[
								4963,
								8791
							],
							[
								4973,
								8782
							],
							[
								5036,
								8791
							],
							[
								5070,
								8758
							],
							[
								5087,
								8705
							],
							[
								5122,
								8718
							],
							[
								5149,
								8682
							],
							[
								5138,
								8657
							],
							[
								5174,
								8657
							],
							[
								5210,
								8602
							],
							[
								5194,
								8566
							],
							[
								5229,
								8484
							],
							[
								5229,
								8441
							],
							[
								5184,
								8418
							],
							[
								5153,
								8438
							],
							[
								5135,
								8516
							],
							[
								5087,
								8538
							],
							[
								5057,
								8528
							],
							[
								5062,
								8561
							],
							[
								4981,
								8543
							],
							[
								4959,
								8598
							],
							[
								4979,
								8614
							]
						],
						[
							[
								5435,
								9200
							],
							[
								5481,
								9199
							],
							[
								5478,
								9228
							],
							[
								5432,
								9239
							],
							[
								5440,
								9266
							],
							[
								5475,
								9268
							],
							[
								5532,
								9217
							],
							[
								5583,
								9072
							],
							[
								5640,
								9068
							],
							[
								5652,
								9052
							],
							[
								5647,
								9012
							],
							[
								5658,
								8986
							],
							[
								5696,
								8966
							],
							[
								5669,
								9010
							],
							[
								5676,
								9047
							],
							[
								5708,
								9043
							],
							[
								5718,
								8987
							],
							[
								5706,
								8959
							],
							[
								5735,
								8962
							],
							[
								5750,
								8925
							],
							[
								5749,
								8845
							],
							[
								5770,
								8866
							],
							[
								5817,
								8853
							],
							[
								5853,
								8790
							],
							[
								5831,
								8757
							],
							[
								5790,
								8730
							],
							[
								5753,
								8634
							],
							[
								5738,
								8637
							],
							[
								5727,
								8698
							],
							[
								5717,
								8696
							],
							[
								5725,
								8633
							],
							[
								5738,
								8605
							],
							[
								5727,
								8534
							],
							[
								5726,
								8583
							],
							[
								5698,
								8617
							],
							[
								5712,
								8575
							],
							[
								5706,
								8518
							],
							[
								5693,
								8516
							],
							[
								5642,
								8612
							],
							[
								5646,
								8572
							],
							[
								5675,
								8511
							],
							[
								5641,
								8545
							],
							[
								5633,
								8504
							],
							[
								5556,
								8515
							],
							[
								5527,
								8542
							],
							[
								5513,
								8581
							],
							[
								5565,
								8595
							],
							[
								5515,
								8611
							],
							[
								5497,
								8599
							],
							[
								5448,
								8685
							],
							[
								5493,
								8733
							],
							[
								5552,
								8734
							],
							[
								5616,
								8755
							],
							[
								5542,
								8743
							],
							[
								5521,
								8767
							],
							[
								5552,
								8776
							],
							[
								5518,
								8800
							],
							[
								5461,
								8753
							],
							[
								5465,
								8786
							],
							[
								5435,
								8772
							],
							[
								5382,
								8787
							],
							[
								5388,
								8823
							],
							[
								5425,
								8835
							],
							[
								5443,
								8871
							],
							[
								5405,
								8844
							],
							[
								5377,
								8845
							],
							[
								5345,
								8901
							],
							[
								5342,
								8964
							],
							[
								5370,
								8945
							],
							[
								5419,
								8939
							],
							[
								5450,
								8972
							],
							[
								5428,
								8982
							],
							[
								5396,
								8959
							],
							[
								5348,
								8995
							],
							[
								5373,
								9023
							],
							[
								5367,
								9048
							],
							[
								5386,
								9088
							],
							[
								5404,
								9099
							],
							[
								5430,
								9075
							],
							[
								5430,
								9105
							],
							[
								5391,
								9125
							],
							[
								5391,
								9150
							],
							[
								5415,
								9189
							],
							[
								5435,
								9167
							],
							[
								5435,
								9200
							]
						],
						[
							[
								6308,
								8614
							],
							[
								6261,
								8616
							],
							[
								6249,
								8602
							],
							[
								6314,
								8595
							],
							[
								6306,
								8557
							],
							[
								6289,
								8568
							],
							[
								6265,
								8536
							],
							[
								6202,
								8537
							],
							[
								6239,
								8461
							],
							[
								6223,
								8407
							],
							[
								6186,
								8381
							],
							[
								6106,
								8376
							],
							[
								6061,
								8410
							],
							[
								6056,
								8391
							],
							[
								6086,
								8370
							],
							[
								6056,
								8358
							],
							[
								6065,
								8332
							],
							[
								6092,
								8363
							],
							[
								6147,
								8351
							],
							[
								6174,
								8367
							],
							[
								6200,
								8342
							],
							[
								6189,
								8300
							],
							[
								6236,
								8328
							],
							[
								6258,
								8322
							],
							[
								6278,
								8259
							],
							[
								6251,
								8208
							],
							[
								6233,
								8231
							],
							[
								6215,
								8166
							],
							[
								6135,
								8115
							],
							[
								6139,
								8179
							],
							[
								6114,
								8193
							],
							[
								6079,
								8186
							],
							[
								6064,
								8163
							],
							[
								5993,
								8159
							],
							[
								5962,
								8196
							],
							[
								5965,
								8159
							],
							[
								5930,
								8149
							],
							[
								5960,
								8128
							],
							[
								5917,
								8125
							],
							[
								5857,
								8137
							],
							[
								5842,
								8123
							],
							[
								5806,
								8143
							],
							[
								5796,
								8116
							],
							[
								5756,
								8125
							],
							[
								5742,
								8216
							],
							[
								5730,
								8127
							],
							[
								5689,
								8159
							],
							[
								5692,
								8221
							],
							[
								5748,
								8287
							],
							[
								5782,
								8282
							],
							[
								5812,
								8322
							],
							[
								5773,
								8337
							],
							[
								5772,
								8367
							],
							[
								5744,
								8398
							],
							[
								5741,
								8434
							],
							[
								5785,
								8462
							],
							[
								5834,
								8441
							],
							[
								5861,
								8380
							],
							[
								5882,
								8359
							],
							[
								5930,
								8343
							],
							[
								5920,
								8360
							],
							[
								5976,
								8359
							],
							[
								5957,
								8384
							],
							[
								5974,
								8394
							],
							[
								6002,
								8501
							],
							[
								5988,
								8512
							],
							[
								5971,
								8417
							],
							[
								5951,
								8388
							],
							[
								5881,
								8401
							],
							[
								5883,
								8450
							],
							[
								5856,
								8479
							],
							[
								5881,
								8508
							],
							[
								5887,
								8573
							],
							[
								5859,
								8518
							],
							[
								5827,
								8502
							],
							[
								5809,
								8533
							],
							[
								5800,
								8512
							],
							[
								5767,
								8510
							],
							[
								5760,
								8584
							],
							[
								5791,
								8669
							],
							[
								5829,
								8679
							],
							[
								5849,
								8701
							],
							[
								5918,
								8691
							],
							[
								5965,
								8664
							],
							[
								5941,
								8697
							],
							[
								6004,
								8710
							],
							[
								6010,
								8754
							],
							[
								5970,
								8710
							],
							[
								5949,
								8720
							],
							[
								5891,
								8715
							],
							[
								5867,
								8732
							],
							[
								5875,
								8758
							],
							[
								5925,
								8737
							],
							[
								5881,
								8769
							],
							[
								5868,
								8820
							],
							[
								5839,
								8865
							],
							[
								5773,
								8894
							],
							[
								5775,
								8943
							],
							[
								5757,
								8985
							],
							[
								5761,
								9026
							],
							[
								5808,
								9019
							],
							[
								5871,
								9022
							],
							[
								5951,
								8941
							],
							[
								5983,
								8880
							],
							[
								6026,
								8889
							],
							[
								6058,
								8920
							],
							[
								6013,
								8899
							],
							[
								5984,
								8909
							],
							[
								5971,
								8953
							],
							[
								5893,
								9041
							],
							[
								5939,
								9070
							],
							[
								6001,
								9097
							],
							[
								6011,
								9112
							],
							[
								6088,
								9144
							],
							[
								6011,
								9133
							],
							[
								6059,
								9185
							],
							[
								6132,
								9216
							],
							[
								6128,
								9230
							],
							[
								6074,
								9219
							],
							[
								6043,
								9201
							],
							[
								6035,
								9239
							],
							[
								6068,
								9324
							],
							[
								6089,
								9363
							],
							[
								6047,
								9316
							],
							[
								6018,
								9233
							],
							[
								6015,
								9188
							],
							[
								5961,
								9129
							],
							[
								5897,
								9097
							],
							[
								5887,
								9124
							],
							[
								5920,
								9147
							],
							[
								5923,
								9175
							],
							[
								5876,
								9133
							],
							[
								5858,
								9143
							],
							[
								5860,
								9097
							],
							[
								5838,
								9082
							],
							[
								5769,
								9080
							],
							[
								5742,
								9094
							],
							[
								5770,
								9182
							],
							[
								5791,
								9204
							],
							[
								5882,
								9244
							],
							[
								5894,
								9259
							],
							[
								5783,
								9212
							],
							[
								5757,
								9192
							],
							[
								5720,
								9098
							],
							[
								5686,
								9107
							],
							[
								5631,
								9152
							],
							[
								5634,
								9171
							],
							[
								5667,
								9185
							],
							[
								5733,
								9193
							],
							[
								5801,
								9271
							],
							[
								5781,
								9272
							],
							[
								5737,
								9223
							],
							[
								5612,
								9184
							],
							[
								5589,
								9223
							],
							[
								5624,
								9245
							],
							[
								5602,
								9267
							],
							[
								5639,
								9310
							],
							[
								5673,
								9322
							],
							[
								5655,
								9333
							],
							[
								5580,
								9272
							],
							[
								5566,
								9295
							],
							[
								5610,
								9341
							],
							[
								5568,
								9350
							],
							[
								5543,
								9314
							],
							[
								5522,
								9336
							],
							[
								5554,
								9392
							],
							[
								5598,
								9415
							],
							[
								5615,
								9390
							],
							[
								5635,
								9454
							],
							[
								5658,
								9468
							],
							[
								5743,
								9446
							],
							[
								5778,
								9451
							],
							[
								5703,
								9481
							],
							[
								5696,
								9502
							],
							[
								5747,
								9526
							],
							[
								5727,
								9571
							],
							[
								5804,
								9549
							],
							[
								5838,
								9494
							],
							[
								5852,
								9488
							],
							[
								5830,
								9539
							],
							[
								5886,
								9500
							],
							[
								5949,
								9470
							],
							[
								5984,
								9437
							],
							[
								5952,
								9486
							],
							[
								5910,
								9500
							],
							[
								5836,
								9562
							],
							[
								5839,
								9597
							],
							[
								5874,
								9599
							],
							[
								5843,
								9618
							],
							[
								5847,
								9643
							],
							[
								5893,
								9612
							],
							[
								5902,
								9620
							],
							[
								5858,
								9676
							],
							[
								5901,
								9682
							],
							[
								5946,
								9658
							],
							[
								5966,
								9667
							],
							[
								5916,
								9679
							],
							[
								5899,
								9724
							],
							[
								5924,
								9739
							],
							[
								5941,
								9715
							],
							[
								5976,
								9735
							],
							[
								6002,
								9724
							],
							[
								6032,
								9677
							],
							[
								6059,
								9662
							],
							[
								6017,
								9731
							],
							[
								5987,
								9755
							],
							[
								6024,
								9781
							],
							[
								6090,
								9782
							],
							[
								6111,
								9749
							],
							[
								6163,
								9716
							],
							[
								6113,
								9766
							],
							[
								6125,
								9810
							],
							[
								6166,
								9830
							],
							[
								6178,
								9789
							],
							[
								6207,
								9780
							],
							[
								6176,
								9810
							],
							[
								6191,
								9839
							],
							[
								6226,
								9851
							],
							[
								6238,
								9818
							],
							[
								6284,
								9835
							],
							[
								6345,
								9839
							],
							[
								6350,
								9827
							],
							[
								6299,
								9735
							],
							[
								6335,
								9755
							],
							[
								6371,
								9819
							],
							[
								6390,
								9807
							],
							[
								6402,
								9849
							],
							[
								6423,
								9814
							],
							[
								6449,
								9842
							],
							[
								6453,
								9812
							],
							[
								6498,
								9772
							],
							[
								6541,
								9781
							],
							[
								6566,
								9760
							],
							[
								6579,
								9713
							],
							[
								6560,
								9689
							],
							[
								6564,
								9658
							],
							[
								6519,
								9558
							],
							[
								6480,
								9555
							],
							[
								6487,
								9535
							],
							[
								6396,
								9473
							],
							[
								6430,
								9486
							],
							[
								6457,
								9476
							],
							[
								6358,
								9355
							],
							[
								6379,
								9367
							],
							[
								6490,
								9485
							],
							[
								6528,
								9514
							],
							[
								6536,
								9474
							],
							[
								6503,
								9419
							],
							[
								6493,
								9366
							],
							[
								6455,
								9280
							],
							[
								6438,
								9217
							],
							[
								6439,
								9182
							],
							[
								6400,
								9157
							],
							[
								6425,
								9143
							],
							[
								6351,
								9071
							],
							[
								6406,
								9108
							],
							[
								6414,
								9072
							],
							[
								6399,
								9005
							],
							[
								6373,
								8979
							],
							[
								6342,
								8982
							],
							[
								6330,
								9004
							],
							[
								6277,
								9012
							],
							[
								6254,
								8995
							],
							[
								6319,
								8993
							],
							[
								6341,
								8941
							],
							[
								6311,
								8911
							],
							[
								6265,
								8911
							],
							[
								6273,
								8884
							],
							[
								6217,
								8900
							],
							[
								6237,
								8869
							],
							[
								6197,
								8862
							],
							[
								6168,
								8880
							],
							[
								6181,
								8838
							],
							[
								6304,
								8856
							],
							[
								6293,
								8845
							],
							[
								6314,
								8812
							],
							[
								6250,
								8814
							],
							[
								6237,
								8835
							],
							[
								6153,
								8811
							],
							[
								6239,
								8816
							],
							[
								6183,
								8780
							],
							[
								6165,
								8784
							],
							[
								6160,
								8722
							],
							[
								6178,
								8766
							],
							[
								6217,
								8790
							],
							[
								6261,
								8787
							],
							[
								6238,
								8756
							],
							[
								6287,
								8770
							],
							[
								6321,
								8742
							],
							[
								6324,
								8708
							],
							[
								6302,
								8686
							],
							[
								6251,
								8682
							],
							[
								6322,
								8658
							],
							[
								6308,
								8614
							]
						],
						[
							[
								4497,
								8301
							],
							[
								4493,
								8262
							],
							[
								4436,
								8287
							],
							[
								4463,
								8307
							],
							[
								4497,
								8301
							]
						],
						[
							[
								4519,
								8552
							],
							[
								4543,
								8501
							],
							[
								4512,
								8483
							],
							[
								4480,
								8548
							],
							[
								4519,
								8552
							]
						],
						[
							[
								4210,
								8153
							],
							[
								4268,
								8183
							],
							[
								4276,
								8173
							],
							[
								4235,
								8107
							],
							[
								4188,
								8067
							],
							[
								4153,
								8098
							],
							[
								4210,
								8153
							]
						],
						[
							[
								3818,
								7799
							],
							[
								3803,
								7822
							],
							[
								3802,
								7929
							],
							[
								3921,
								7916
							],
							[
								3982,
								7918
							],
							[
								4042,
								7842
							],
							[
								4093,
								7814
							],
							[
								4092,
								7771
							],
							[
								4116,
								7810
							],
							[
								4155,
								7813
							],
							[
								4188,
								7795
							],
							[
								4211,
								7759
							],
							[
								4270,
								7619
							],
							[
								4196,
								7590
							],
							[
								4012,
								7506
							],
							[
								3988,
								7454
							],
							[
								3956,
								7438
							],
							[
								3929,
								7448
							],
							[
								3904,
								7398
							],
							[
								3894,
								7348
							],
							[
								3868,
								7313
							],
							[
								3815,
								7305
							],
							[
								3803,
								7326
							],
							[
								3765,
								7296
							],
							[
								3698,
								7280
							],
							[
								3677,
								7412
							],
							[
								3624,
								7482
							],
							[
								3586,
								7496
							],
							[
								3654,
								7583
							],
							[
								3679,
								7591
							],
							[
								3692,
								7653
							],
							[
								3727,
								7650
							],
							[
								3716,
								7688
							],
							[
								3760,
								7744
							],
							[
								3818,
								7799
							]
						],
						[
							[
								4130,
								8341
							],
							[
								4173,
								8362
							],
							[
								4197,
								8399
							],
							[
								4277,
								8458
							],
							[
								4324,
								8453
							],
							[
								4348,
								8424
							],
							[
								4381,
								8440
							],
							[
								4361,
								8460
							],
							[
								4401,
								8474
							],
							[
								4436,
								8409
							],
							[
								4381,
								8380
							],
							[
								4403,
								8339
							],
							[
								4387,
								8328
							],
							[
								4384,
								8284
							],
							[
								4357,
								8264
							],
							[
								4317,
								8260
							],
							[
								4316,
								8223
							],
							[
								4290,
								8208
							],
							[
								4265,
								8245
							],
							[
								4298,
								8322
							],
							[
								4258,
								8318
							],
							[
								4259,
								8284
							],
							[
								4222,
								8276
							],
							[
								4235,
								8240
							],
							[
								4189,
								8201
							],
							[
								4190,
								8254
							],
							[
								4174,
								8239
							],
							[
								4172,
								8188
							],
							[
								4144,
								8157
							],
							[
								4112,
								8163
							],
							[
								4113,
								8240
							],
							[
								4093,
								8188
							],
							[
								4075,
								8187
							],
							[
								4056,
								8223
							],
							[
								4020,
								8208
							],
							[
								4019,
								8276
							],
							[
								4052,
								8305
							],
							[
								4094,
								8299
							],
							[
								4130,
								8341
							]
						],
						[
							[
								6818,
								2861
							],
							[
								6869,
								2896
							],
							[
								6902,
								2896
							],
							[
								6946,
								2865
							],
							[
								6927,
								2827
							],
							[
								6827,
								2854
							],
							[
								6738,
								2856
							],
							[
								6809,
								2882
							],
							[
								6818,
								2861
							]
						],
						[
							[
								8804,
								3908
							],
							[
								8656,
								3906
							],
							[
								8607,
								3936
							],
							[
								8552,
								3938
							],
							[
								8572,
								3970
							],
							[
								8652,
								3979
							],
							[
								8746,
								3976
							],
							[
								8823,
								3964
							],
							[
								8855,
								3933
							],
							[
								8804,
								3908
							]
						],
						[
							[
								9391,
								4309
							],
							[
								9352,
								4252
							],
							[
								9383,
								4235
							],
							[
								9451,
								4245
							],
							[
								9460,
								4217
							],
							[
								9498,
								4247
							],
							[
								9513,
								4303
							],
							[
								9529,
								4267
							],
							[
								9556,
								4312
							],
							[
								9627,
								4305
							],
							[
								9605,
								4248
							],
							[
								9633,
								4189
							],
							[
								9672,
								4195
							],
							[
								9717,
								4238
							],
							[
								9715,
								4193
							],
							[
								9690,
								4160
							],
							[
								9699,
								4070
							],
							[
								9739,
								4060
							],
							[
								9731,
								4141
							],
							[
								9761,
								4170
							],
							[
								9762,
								4087
							],
							[
								9780,
								4063
							],
							[
								9793,
								4132
							],
							[
								9829,
								4103
							],
							[
								9829,
								4059
							],
							[
								9851,
								3985
							],
							[
								9804,
								3931
							],
							[
								9764,
								4006
							],
							[
								9743,
								3933
							],
							[
								9723,
								3937
							],
							[
								9717,
								4023
							],
							[
								9676,
								4076
							],
							[
								9655,
								4078
							],
							[
								9657,
								4012
							],
							[
								9624,
								3982
							],
							[
								9619,
								3892
							],
							[
								9552,
								3858
							],
							[
								9548,
								3886
							],
							[
								9581,
								3913
							],
							[
								9585,
								3992
							],
							[
								9553,
								4003
							],
							[
								9563,
								3962
							],
							[
								9518,
								3938
							],
							[
								9525,
								3964
							],
							[
								9482,
								3953
							],
							[
								9422,
								3906
							],
							[
								9296,
								3878
							],
							[
								9200,
								3813
							],
							[
								9152,
								3847
							],
							[
								9210,
								3978
							],
							[
								9177,
								3974
							],
							[
								9129,
								3939
							],
							[
								9148,
								3978
							],
							[
								9176,
								3981
							],
							[
								9170,
								4071
							],
							[
								9211,
								4062
							],
							[
								9170,
								4124
							],
							[
								9195,
								4150
							],
							[
								9177,
								4173
							],
							[
								9170,
								4341
							],
							[
								9191,
								4391
							],
							[
								9183,
								4458
							],
							[
								9244,
								4540
							],
							[
								9246,
								4519
							],
							[
								9284,
								4551
							],
							[
								9284,
								4503
							],
							[
								9241,
								4496
							],
							[
								9307,
								4453
							],
							[
								9289,
								4463
							],
							[
								9268,
								4270
							],
							[
								9290,
								4198
							],
							[
								9314,
								4314
							],
							[
								9391,
								4309
							]
						],
						[
							[
								8856,
								3478
							],
							[
								8981,
								3534
							],
							[
								8948,
								3505
							],
							[
								8951,
								3441
							],
							[
								8920,
								3430
							],
							[
								8897,
								3458
							],
							[
								8826,
								3436
							],
							[
								8806,
								3457
							],
							[
								8765,
								3445
							],
							[
								8754,
								3473
							],
							[
								8721,
								3474
							],
							[
								8743,
								3547
							],
							[
								8748,
								3501
							],
							[
								8806,
								3468
							],
							[
								8806,
								3486
							],
							[
								8856,
								3478
							]
						],
						[
							[
								3499,
								3438
							],
							[
								3501,
								3437
							],
							[
								3501,
								3437
							]
						],
						[
							[
								3501,
								3437
							],
							[
								3905,
								3365
							]
						],
						[
							[
								3905,
								3365
							],
							[
								3905,
								3365
							],
							[
								3905,
								3365
							]
						],
						[
							[
								3905,
								3365
							],
							[
								3918,
								3363
							],
							[
								3918,
								3363
							]
						],
						[
							[
								4533,
								3288
							],
							[
								4783,
								3269
							]
						],
						[
							[
								4783,
								3269
							],
							[
								4793,
								3268
							],
							[
								4805,
								3268
							]
						],
						[
							[
								4805,
								3268
							],
							[
								4812,
								3267
							],
							[
								4812,
								3267
							]
						],
						[
							[
								6050,
								3117
							],
							[
								5953,
								3066
							],
							[
								5904,
								3029
							],
							[
								5791,
								2909
							],
							[
								5826,
								2900
							],
							[
								5913,
								2943
							],
							[
								5977,
								2890
							],
							[
								6041,
								2932
							],
							[
								6083,
								2941
							],
							[
								6160,
								3006
							],
							[
								6184,
								2967
							],
							[
								6274,
								2951
							],
							[
								6308,
								2905
							],
							[
								6391,
								2905
							],
							[
								6435,
								2945
							],
							[
								6503,
								2952
							],
							[
								6562,
								2975
							],
							[
								6555,
								2934
							],
							[
								6618,
								2930
							]
						],
						[
							[
								6662,
								2918
							],
							[
								6648,
								2895
							],
							[
								6729,
								2861
							],
							[
								6608,
								2865
							],
							[
								6603,
								2833
							],
							[
								6569,
								2855
							],
							[
								6513,
								2862
							],
							[
								6502,
								2842
							],
							[
								6436,
								2829
							],
							[
								6391,
								2780
							],
							[
								6403,
								2816
							],
							[
								6360,
								2784
							],
							[
								6356,
								2814
							],
							[
								6302,
								2682
							],
							[
								6261,
								2594
							],
							[
								6321,
								2649
							],
							[
								6366,
								2718
							],
							[
								6336,
								2634
							],
							[
								6305,
								2497
							],
							[
								6311,
								2463
							],
							[
								6293,
								2392
							],
							[
								6316,
								2273
							],
							[
								6317,
								2240
							],
							[
								6360,
								2157
							],
							[
								6388,
								2144
							],
							[
								6438,
								2170
							],
							[
								6484,
								2252
							],
							[
								6490,
								2364
							],
							[
								6442,
								2463
							],
							[
								6438,
								2534
							],
							[
								6461,
								2583
							],
							[
								6456,
								2632
							],
							[
								6516,
								2717
							],
							[
								6520,
								2665
							],
							[
								6545,
								2680
							],
							[
								6542,
								2726
							],
							[
								6585,
								2756
							],
							[
								6570,
								2793
							],
							[
								6600,
								2824
							],
							[
								6747,
								2773
							],
							[
								6775,
								2731
							],
							[
								6760,
								2718
							],
							[
								6786,
								2675
							],
							[
								6787,
								2616
							],
							[
								6766,
								2571
							],
							[
								6737,
								2555
							],
							[
								6739,
								2507
							],
							[
								6766,
								2499
							],
							[
								6807,
								2565
							],
							[
								6840,
								2583
							],
							[
								6870,
								2563
							],
							[
								6921,
								2428
							]
						],
						[
							[
								6906,
								2353
							],
							[
								6884,
								2365
							],
							[
								6864,
								2307
							]
						],
						[
							[
								6864,
								2307
							],
							[
								6862,
								2302
							]
						],
						[
							[
								6862,
								2302
							],
							[
								6830,
								2213
							],
							[
								6949,
								2177
							],
							[
								7042,
								2211
							],
							[
								7074,
								2249
							],
							[
								7163,
								2304
							],
							[
								7178,
								2313
							],
							[
								7242,
								2363
							],
							[
								7303,
								2424
							],
							[
								7327,
								2470
							],
							[
								7316,
								2484
							]
						],
						[
							[
								7316,
								2484
							],
							[
								7298,
								2505
							]
						],
						[
							[
								7298,
								2505
							],
							[
								7297,
								2506
							],
							[
								7297,
								2516
							]
						],
						[
							[
								7297,
								2516
							],
							[
								7293,
								2533
							],
							[
								7396,
								2571
							],
							[
								7464,
								2563
							],
							[
								7553,
								2595
							],
							[
								7603,
								2645
							],
							[
								7566,
								2724
							],
							[
								7616,
								2794
							]
						],
						[
							[
								8417,
								3218
							],
							[
								8441,
								3201
							],
							[
								8464,
								3207
							]
						],
						[
							[
								8512,
								3153
							],
							[
								8556,
								3111
							],
							[
								8536,
								3072
							],
							[
								8447,
								3016
							],
							[
								8428,
								2962
							],
							[
								8412,
								3007
							],
							[
								8399,
								2972
							],
							[
								8356,
								2979
							],
							[
								8363,
								2920
							],
							[
								8297,
								2843
							],
							[
								8277,
								2862
							],
							[
								8224,
								2722
							],
							[
								8229,
								2720
							],
							[
								8225,
								2688
							],
							[
								8178,
								2647
							],
							[
								8225,
								2688
							],
							[
								8260,
								2659
							],
							[
								8224,
								2596
							],
							[
								8264,
								2592
							],
							[
								8302,
								2538
							],
							[
								8375,
								2536
							],
							[
								8286,
								2475
							],
							[
								8292,
								2520
							],
							[
								8249,
								2474
							],
							[
								8240,
								2470
							],
							[
								8234,
								2496
							],
							[
								8233,
								2503
							],
							[
								8227,
								2500
							],
							[
								8237,
								2467
							],
							[
								8175,
								2421
							],
							[
								8059,
								2379
							],
							[
								7983,
								2321
							],
							[
								7951,
								2273
							],
							[
								7953,
								2312
							],
							[
								7928,
								2226
							],
							[
								7970,
								2210
							],
							[
								7977,
								2115
							],
							[
								7915,
								1975
							],
							[
								7819,
								2038
							],
							[
								7819,
								2085
							],
							[
								7830,
								2098
							],
							[
								7820,
								2090
							],
							[
								7806,
								2057
							],
							[
								7850,
								1977
							],
							[
								7896,
								1946
							],
							[
								7913,
								1896
							],
							[
								7913,
								1877
							],
							[
								7911,
								1895
							],
							[
								7911,
								1895
							],
							[
								7908,
								1896
							],
							[
								7908,
								1895
							],
							[
								7907,
								1860
							],
							[
								7888,
								1820
							],
							[
								7850,
								1706
							],
							[
								7822,
								1777
							],
							[
								7858,
								1805
							],
							[
								7835,
								1830
							],
							[
								7760,
								1864
							],
							[
								7793,
								1886
							],
							[
								7751,
								1908
							],
							[
								7772,
								1931
							],
							[
								7743,
								1968
							],
							[
								7767,
								2046
							],
							[
								7727,
								1980
							],
							[
								7720,
								1922
							],
							[
								7735,
								1867
							],
							[
								7771,
								1813
							],
							[
								7705,
								1818
							],
							[
								7682,
								1828
							],
							[
								7702,
								1804
							],
							[
								7735,
								1807
							],
							[
								7788,
								1779
							],
							[
								7788,
								1735
							],
							[
								7704,
								1773
							],
							[
								7803,
								1710
							],
							[
								7782,
								1693
							],
							[
								7812,
								1643
							],
							[
								7852,
								1636
							],
							[
								7881,
								1584
							],
							[
								7914,
								1513
							],
							[
								7878,
								1584
							],
							[
								7863,
								1606
							],
							[
								7867,
								1581
							],
							[
								7868,
								1580
							],
							[
								7870,
								1582
							],
							[
								7873,
								1587
							],
							[
								7875,
								1583
							],
							[
								7877,
								1575
							],
							[
								7862,
								1580
							],
							[
								7857,
								1585
							],
							[
								7859,
								1580
							],
							[
								7360,
								1478
							],
							[
								7859,
								1580
							],
							[
								7906,
								1515
							],
							[
								7869,
								1521
							],
							[
								7794,
								1469
							],
							[
								7901,
								1498
							],
							[
								7922,
								1479
							],
							[
								7895,
								1401
							],
							[
								7828,
								1405
							],
							[
								7842,
								1348
							],
							[
								7799,
								1316
							],
							[
								7877,
								1320
							],
							[
								7847,
								1280
							],
							[
								7784,
								1265
							],
							[
								7726,
								1205
							],
							[
								7704,
								1116
							],
							[
								7626,
								1106
							],
							[
								7587,
								1060
							],
							[
								7568,
								984
							],
							[
								7479,
								878
							],
							[
								7439,
								850
							],
							[
								7377,
								767
							],
							[
								7351,
								771
							],
							[
								7377,
								767
							],
							[
								7331,
								682
							],
							[
								7346,
								642
							],
							[
								7324,
								625
							],
							[
								7330,
								550
							],
							[
								7272,
								557
							],
							[
								7330,
								550
							],
							[
								7390,
								404
							],
							[
								7450,
								307
							],
							[
								7520,
								224
							],
							[
								7531,
								153
							],
							[
								7623,
								1
							],
							[
								7644,
								-169
							],
							[
								7617,
								-308
							],
							[
								7609,
								-280
							],
							[
								7530,
								-314
							],
							[
								7487,
								-227
							],
							[
								7416,
								-202
							],
							[
								7389,
								-128
							],
							[
								7352,
								-133
							],
							[
								7348,
								-62
							],
							[
								7312,
								-70
							],
							[
								7249,
								13
							],
							[
								7278,
								76
							],
							[
								7218,
								69
							],
							[
								7221,
								240
							],
							[
								7190,
								283
							],
							[
								7160,
								279
							],
							[
								7054,
								383
							],
							[
								7004,
								405
							],
							[
								6956,
								387
							],
							[
								6885,
								312
							],
							[
								6780,
								380
							],
							[
								6661,
								412
							],
							[
								6525,
								378
							],
							[
								6537,
								411
							],
							[
								6508,
								373
							],
							[
								6405,
								385
							],
							[
								6280,
								374
							],
							[
								6254,
								343
							],
							[
								6158,
								367
							],
							[
								6131,
								327
							],
							[
								6186,
								314
							],
							[
								6239,
								334
							],
							[
								6285,
								301
							],
							[
								6234,
								254
							],
							[
								6261,
								219
							],
							[
								6333,
								195
							],
							[
								6319,
								167
							],
							[
								6224,
								202
							],
							[
								6186,
								231
							],
							[
								6192,
								184
							],
							[
								6170,
								163
							],
							[
								6131,
								195
							],
							[
								6079,
								165
							],
							[
								6016,
								187
							],
							[
								6023,
								219
							],
							[
								5986,
								223
							],
							[
								5940,
								267
							],
							[
								5906,
								233
							],
							[
								5944,
								213
							],
							[
								5827,
								227
							],
							[
								5755,
								251
							],
							[
								5669,
								237
							],
							[
								5672,
								282
							],
							[
								5638,
								234
							],
							[
								5556,
								196
							],
							[
								5549,
								243
							],
							[
								5505,
								210
							],
							[
								5547,
								177
							],
							[
								5426,
								86
							],
							[
								5378,
								74
							],
							[
								5239,
								-36
							],
							[
								5174,
								-156
							],
							[
								5180,
								-230
							],
							[
								5207,
								-356
							],
							[
								5166,
								-373
							],
							[
								5112,
								-339
							],
							[
								5052,
								-336
							],
							[
								4971,
								-287
							],
							[
								4929,
								-279
							],
							[
								4921,
								-229
							],
							[
								4880,
								-174
							],
							[
								4876,
								-92
							],
							[
								4850,
								-78
							],
							[
								4772,
								27
							],
							[
								4725,
								158
							],
							[
								4629,
								268
							],
							[
								4533,
								278
							],
							[
								4505,
								294
							],
							[
								4454,
								274
							],
							[
								4381,
								160
							],
							[
								4260,
								226
							],
							[
								4200,
								284
							],
							[
								4187,
								368
							],
							[
								4150,
								448
							],
							[
								4105,
								480
							],
							[
								3968,
								640
							],
							[
								3741,
								670
							],
							[
								3732,
								600
							],
							[
								3621,
								615
							],
							[
								3360,
								656
							],
							[
								2893,
								931
							],
							[
								2913,
								960
							],
							[
								2954,
								996
							],
							[
								2913,
								961
							],
							[
								2596,
								1002
							],
							[
								2592,
								1096
							],
							[
								2576,
								1136
							],
							[
								2508,
								1222
							],
							[
								2477,
								1226
							],
							[
								2472,
								1275
							],
							[
								2437,
								1278
							],
							[
								2392,
								1314
							],
							[
								2364,
								1297
							],
							[
								2256,
								1326
							],
							[
								2301,
								1326
							],
							[
								2364,
								1298
							],
							[
								2389,
								1331
							],
							[
								2352,
								1368
							],
							[
								2246,
								1401
							],
							[
								2230,
								1427
							],
							[
								2254,
								1511
							],
							[
								2197,
								1612
							],
							[
								2153,
								1772
							],
							[
								2185,
								1800
							],
							[
								2129,
								1880
							],
							[
								2142,
								1971
							],
							[
								2184,
								1905
							],
							[
								2158,
								2020
							],
							[
								2142,
								1977
							],
							[
								2107,
								2022
							],
							[
								2100,
								2093
							],
							[
								2052,
								2184
							],
							[
								2080,
								2324
							],
							[
								2043,
								2406
							],
							[
								2046,
								2435
							],
							[
								2108,
								2513
							],
							[
								2132,
								2570
							],
							[
								2142,
								2659
							],
							[
								2134,
								2715
							],
							[
								2146,
								2796
							],
							[
								2239,
								2936
							],
							[
								2293,
								3074
							],
							[
								2346,
								3178
							],
							[
								2366,
								3277
							],
							[
								2450,
								3247
							],
							[
								2380,
								3279
							],
							[
								2366,
								3303
							],
							[
								2402,
								3356
							],
							[
								2385,
								3384
							],
							[
								2396,
								3522
							],
							[
								2386,
								3597
							],
							[
								2411,
								3622
							],
							[
								2455,
								3576
							],
							[
								2582,
								3530
							],
							[
								2596,
								3487
							],
							[
								2575,
								3442
							],
							[
								2589,
								3403
							],
							[
								2542,
								3417
							],
							[
								2509,
								3384
							],
							[
								2548,
								3373
							],
							[
								2593,
								3403
							],
							[
								2616,
								3488
							],
							[
								2589,
								3546
							],
							[
								2607,
								3566
							],
							[
								2561,
								3598
							],
							[
								2623,
								3620
							],
							[
								2623,
								3658
							]
						],
						[
							[
								7022,
								3715
							],
							[
								6994,
								3747
							],
							[
								7008,
								3793
							],
							[
								7020,
								3827
							],
							[
								7059,
								3801
							],
							[
								7074,
								3768
							],
							[
								7075,
								3829
							],
							[
								7046,
								3850
							],
							[
								7080,
								3911
							],
							[
								7081,
								3952
							],
							[
								7014,
								4049
							],
							[
								7007,
								4106
							],
							[
								6987,
								4123
							],
							[
								6985,
								4207
							],
							[
								6942,
								4227
							],
							[
								6893,
								4294
							],
							[
								7008,
								4378
							],
							[
								7056,
								4428
							],
							[
								7104,
								4505
							],
							[
								7131,
								4578
							],
							[
								7120,
								4695
							],
							[
								7095,
								4772
							],
							[
								7029,
								4874
							],
							[
								6973,
								4916
							],
							[
								6933,
								4927
							],
							[
								6877,
								4965
							],
							[
								6872,
								5003
							],
							[
								6921,
								5079
							],
							[
								6909,
								5144
							],
							[
								6948,
								5171
							],
							[
								6945,
								5206
							],
							[
								6889,
								5267
							],
							[
								6901,
								5291
							],
							[
								6840,
								5334
							],
							[
								6861,
								5376
							],
							[
								6851,
								5438
							],
							[
								6869,
								5447
							],
							[
								6812,
								5506
							],
							[
								6793,
								5574
							],
							[
								6835,
								5634
							],
							[
								6877,
								5635
							],
							[
								6995,
								5612
							],
							[
								7014,
								5625
							],
							[
								7064,
								5609
							],
							[
								7136,
								5684
							],
							[
								7196,
								5647
							],
							[
								7233,
								5644
							],
							[
								7241,
								5620
							],
							[
								7284,
								5614
							],
							[
								7282,
								5590
							],
							[
								7330,
								5587
							],
							[
								7320,
								5546
							],
							[
								7375,
								5511
							],
							[
								7453,
								5511
							],
							[
								7460,
								5526
							],
							[
								7503,
								5492
							],
							[
								7523,
								5541
							],
							[
								7549,
								5499
							],
							[
								7527,
								5444
							],
							[
								7560,
								5400
							],
							[
								7558,
								5355
							],
							[
								7580,
								5343
							],
							[
								7602,
								5252
							],
							[
								7637,
								5251
							],
							[
								7617,
								5225
							],
							[
								7636,
								5190
							],
							[
								7603,
								5160
							],
							[
								7622,
								5134
							],
							[
								7652,
								5196
							],
							[
								7690,
								5211
							],
							[
								7732,
								5200
							],
							[
								7758,
								5167
							],
							[
								7817,
								5162
							],
							[
								7819,
								5115
							],
							[
								7864,
								5192
							],
							[
								7884,
								5207
							],
							[
								7891,
								5264
							],
							[
								7918,
								5260
							],
							[
								7940,
								5320
							],
							[
								7921,
								5348
							],
							[
								7951,
								5360
							],
							[
								7911,
								5427
							],
							[
								7936,
								5479
							],
							[
								7931,
								5547
							],
							[
								7960,
								5547
							],
							[
								7975,
								5542
							],
							[
								7960,
								5542
							],
							[
								7961,
								5536
							],
							[
								8009,
								5507
							],
							[
								8026,
								5459
							],
							[
								8053,
								5456
							],
							[
								8121,
								5390
							],
							[
								8191,
								5339
							],
							[
								8168,
								5295
							],
							[
								8222,
								5322
							],
							[
								8235,
								5268
							],
							[
								8253,
								5274
							],
							[
								8306,
								5235
							],
							[
								8326,
								5202
							],
							[
								8360,
								5199
							],
							[
								8343,
								5147
							],
							[
								8405,
								5147
							],
							[
								8415,
								5092
							],
							[
								8435,
								5071
							],
							[
								8381,
								5082
							],
							[
								8389,
								5051
							],
							[
								8460,
								5050
							],
							[
								8392,
								5034
							],
							[
								8388,
								5018
							],
							[
								8447,
								5033
							],
							[
								8413,
								4990
							],
							[
								8487,
								5012
							],
							[
								8509,
								4964
							],
							[
								8578,
								4976
							],
							[
								8570,
								4955
							],
							[
								8610,
								4929
							],
							[
								8595,
								4851
							],
							[
								8624,
								4911
							],
							[
								8652,
								4931
							],
							[
								8664,
								4897
							],
							[
								8727,
								4933
							],
							[
								8756,
								4891
							],
							[
								8856,
								4914
							],
							[
								8921,
								4902
							],
							[
								8895,
								4867
							],
							[
								8852,
								4845
							],
							[
								8835,
								4784
							],
							[
								8773,
								4717
							],
							[
								8724,
								4685
							],
							[
								8735,
								4604
							],
							[
								8760,
								4652
							],
							[
								8820,
								4717
							],
							[
								8821,
								4758
							],
							[
								8874,
								4809
							],
							[
								8856,
								4825
							],
							[
								8929,
								4848
							],
							[
								8985,
								4795
							],
							[
								8958,
								4763
							],
							[
								9038,
								4828
							],
							[
								9034,
								4807
							],
							[
								9121,
								4811
							],
							[
								9146,
								4764
							],
							[
								9129,
								4731
							],
							[
								9154,
								4728
							],
							[
								9181,
								4691
							],
							[
								9146,
								4656
							],
							[
								9203,
								4666
							],
							[
								9196,
								4642
							],
							[
								9223,
								4616
							],
							[
								9213,
								4579
							],
							[
								9142,
								4457
							],
							[
								9103,
								4541
							],
							[
								9142,
								4457
							],
							[
								9085,
								4441
							],
							[
								9041,
								4395
							],
							[
								8998,
								4321
							],
							[
								9010,
								4295
							],
							[
								8981,
								4254
							],
							[
								8938,
								4158
							],
							[
								8869,
								4137
							],
							[
								8795,
								4080
							],
							[
								8774,
								4094
							],
							[
								8583,
								4036
							],
							[
								8544,
								4014
							],
							[
								8444,
								3987
							],
							[
								8371,
								3939
							],
							[
								8336,
								3940
							],
							[
								8288,
								3851
							],
							[
								8288,
								3769
							],
							[
								8223,
								3741
							],
							[
								8219,
								3711
							],
							[
								8181,
								3688
							],
							[
								8148,
								3628
							],
							[
								8131,
								3547
							],
							[
								8109,
								3512
							],
							[
								8086,
								3402
							],
							[
								8063,
								3387
							],
							[
								8054,
								3330
							],
							[
								8006,
								3258
							],
							[
								8077,
								3320
							],
							[
								8109,
								3404
							],
							[
								8173,
								3549
							],
							[
								8239,
								3637
							],
							[
								8373,
								3761
							],
							[
								8470,
								3818
							],
							[
								8578,
								3828
							],
							[
								8634,
								3792
							],
							[
								8634,
								3733
							],
							[
								8549,
								3634
							],
							[
								8491,
								3651
							],
							[
								8477,
								3625
							],
							[
								8454,
								3611
							],
							[
								8515,
								3606
							],
							[
								8546,
								3577
							],
							[
								8581,
								3614
							],
							[
								8638,
								3629
							],
							[
								8622,
								3526
							],
							[
								8603,
								3500
							],
							[
								8658,
								3520
							],
							[
								8660,
								3487
							],
							[
								8735,
								3405
							],
							[
								8817,
								3415
							],
							[
								8796,
								3386
							],
							[
								8903,
								3396
							],
							[
								8979,
								3392
							],
							[
								9019,
								3454
							],
							[
								9033,
								3428
							],
							[
								9077,
								3442
							],
							[
								9095,
								3434
							],
							[
								9049,
								3491
							],
							[
								9070,
								3570
							],
							[
								9085,
								3674
							],
							[
								9108,
								3681
							],
							[
								9135,
								3624
							],
							[
								9124,
								3490
							],
							[
								9152,
								3474
							],
							[
								9167,
								3532
							],
							[
								9131,
								3510
							],
							[
								9159,
								3585
							],
							[
								9216,
								3582
							],
							[
								9229,
								3560
							],
							[
								9189,
								3481
							],
							[
								9141,
								3437
							],
							[
								9101,
								3431
							],
							[
								9146,
								3411
							],
							[
								9140,
								3388
							],
							[
								9083,
								3358
							],
							[
								9058,
								3315
							],
							[
								8970,
								3231
							],
							[
								8916,
								3209
							],
							[
								8930,
								3182
							],
							[
								8846,
								3166
							],
							[
								8857,
								3126
							],
							[
								8828,
								3038
							],
							[
								8786,
								2980
							],
							[
								8751,
								2957
							],
							[
								8714,
								2996
							],
							[
								8696,
								2977
							],
							[
								8669,
								3025
							],
							[
								8666,
								3105
							],
							[
								8757,
								3230
							],
							[
								8801,
								3276
							],
							[
								8810,
								3244
							],
							[
								8875,
								3316
							],
							[
								8737,
								3271
							],
							[
								8781,
								3355
							],
							[
								8751,
								3355
							],
							[
								8742,
								3306
							],
							[
								8644,
								3202
							],
							[
								8548,
								3145
							],
							[
								8512,
								3153
							]
						],
						[
							[
								8464,
								3207
							],
							[
								8435,
								3208
							],
							[
								8417,
								3218
							]
						],
						[
							[
								7616,
								2794
							],
							[
								7574,
								2750
							],
							[
								7532,
								2734
							],
							[
								7497,
								2684
							],
							[
								7432,
								2682
							],
							[
								7274,
								2616
							],
							[
								7236,
								2581
							],
							[
								7211,
								2526
							],
							[
								7265,
								2513
							],
							[
								7293,
								2533
							],
							[
								7297,
								2516
							]
						],
						[
							[
								7297,
								2516
							],
							[
								7297,
								2506
							],
							[
								7298,
								2505
							]
						],
						[
							[
								7298,
								2505
							],
							[
								7317,
								2484
							],
							[
								7316,
								2484
							]
						],
						[
							[
								7316,
								2484
							],
							[
								7179,
								2435
							],
							[
								7148,
								2395
							],
							[
								7050,
								2390
							],
							[
								7004,
								2324
							],
							[
								6920,
								2274
							],
							[
								6862,
								2271
							],
							[
								6862,
								2302
							]
						],
						[
							[
								6862,
								2302
							],
							[
								6862,
								2307
							],
							[
								6864,
								2307
							]
						],
						[
							[
								6864,
								2307
							],
							[
								6934,
								2323
							],
							[
								6906,
								2353
							]
						],
						[
							[
								6921,
								2428
							],
							[
								6990,
								2497
							],
							[
								6971,
								2605
							],
							[
								7010,
								2694
							],
							[
								6993,
								2750
							],
							[
								6948,
								2788
							],
							[
								6991,
								2793
							],
							[
								7002,
								2755
							],
							[
								7036,
								2756
							],
							[
								7048,
								2698
							],
							[
								7064,
								2721
							],
							[
								7142,
								2695
							],
							[
								7176,
								2751
							],
							[
								7125,
								2797
							],
							[
								7127,
								2828
							],
							[
								7093,
								2831
							],
							[
								7033,
								2907
							],
							[
								6989,
								2901
							],
							[
								6934,
								2923
							],
							[
								6786,
								2908
							],
							[
								6662,
								2918
							]
						],
						[
							[
								6618,
								2930
							],
							[
								6603,
								2995
							],
							[
								6577,
								3009
							],
							[
								6591,
								3061
							],
							[
								6539,
								3105
							],
							[
								6542,
								3161
							],
							[
								6456,
								3148
							],
							[
								6417,
								3177
							],
							[
								6370,
								3269
							],
							[
								6280,
								3260
							],
							[
								6176,
								3285
							],
							[
								6248,
								3255
							],
							[
								6208,
								3250
							],
							[
								6149,
								3203
							],
							[
								6172,
								3237
							],
							[
								6155,
								3260
							],
							[
								6136,
								3185
							],
							[
								6124,
								3214
							],
							[
								6084,
								3191
							],
							[
								6075,
								3139
							],
							[
								6050,
								3117
							]
						],
						[
							[
								4812,
								3267
							],
							[
								4805,
								3268
							]
						],
						[
							[
								4805,
								3268
							],
							[
								4783,
								3269
							]
						],
						[
							[
								4783,
								3269
							],
							[
								4701,
								3274
							],
							[
								4533,
								3288
							]
						],
						[
							[
								3918,
								3363
							],
							[
								3905,
								3365
							]
						],
						[
							[
								3905,
								3365
							],
							[
								3905,
								3365
							]
						],
						[
							[
								3905,
								3365
							],
							[
								3657,
								3407
							],
							[
								3501,
								3437
							]
						],
						[
							[
								3501,
								3437
							],
							[
								3499,
								3438
							]
						],
						[
							[
								2206,
								4993
							],
							[
								2167,
								4997
							],
							[
								2123,
								4947
							],
							[
								2113,
								4997
							],
							[
								2134,
								4997
							],
							[
								2176,
								5053
							],
							[
								2150,
								5132
							],
							[
								2155,
								5158
							],
							[
								2125,
								5245
							],
							[
								2098,
								5258
							],
							[
								2131,
								5285
							],
							[
								2118,
								5435
							],
							[
								2084,
								5458
							],
							[
								2096,
								5640
							],
							[
								2072,
								5590
							],
							[
								2056,
								5490
							],
							[
								1991,
								5526
							],
							[
								2006,
								5545
							],
							[
								2011,
								5607
							],
							[
								1993,
								5592
							],
							[
								1955,
								5665
							],
							[
								1955,
								5665
							]
						],
						[
							[
								2318,
								4975
							],
							[
								2314,
								4942
							],
							[
								2292,
								4923
							],
							[
								2280,
								4846
							],
							[
								2224,
								4801
							],
							[
								2170,
								4805
							],
							[
								2182,
								4870
							],
							[
								2207,
								4885
							],
							[
								2228,
								4942
							],
							[
								2218,
								4991
							],
							[
								2210,
								4992
							],
							[
								2221,
								4943
							],
							[
								2201,
								4895
							],
							[
								2170,
								4872
							],
							[
								2156,
								4892
							],
							[
								2138,
								4828
							],
							[
								2122,
								4862
							],
							[
								2136,
								4914
							],
							[
								2169,
								4988
							],
							[
								2206,
								4993
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1950,
								5665
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1952,
								5671
							],
							[
								1955,
								5665
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1950,
								5665
							]
						],
						[
							[
								1955,
								5665
							],
							[
								1955,
								5665
							],
							[
								1955,
								5665
							],
							[
								1955,
								5665
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1950,
								5665
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1942,
								5643
							],
							[
								1971,
								5621
							],
							[
								1986,
								5552
							],
							[
								1973,
								5526
							],
							[
								1935,
								5547
							],
							[
								1918,
								5532
							],
							[
								1870,
								5630
							],
							[
								1856,
								5721
							],
							[
								1772,
								5852
							],
							[
								1814,
								5862
							],
							[
								1816,
								5894
							],
							[
								1749,
								5893
							],
							[
								1680,
								5963
							],
							[
								1703,
								5977
							],
							[
								1664,
								5989
							],
							[
								1598,
								6055
							],
							[
								1507,
								6085
							],
							[
								1461,
								6170
							],
							[
								1505,
								6219
							],
							[
								1472,
								6209
							],
							[
								1439,
								6173
							],
							[
								1426,
								6222
							],
							[
								1391,
								6249
							],
							[
								1335,
								6238
							],
							[
								1352,
								6271
							],
							[
								1419,
								6255
							],
							[
								1419,
								6287
							],
							[
								1386,
								6295
							],
							[
								1388,
								6348
							],
							[
								1353,
								6374
							],
							[
								1291,
								6379
							],
							[
								1305,
								6432
							],
							[
								1267,
								6386
							],
							[
								1261,
								6335
							],
							[
								1215,
								6311
							],
							[
								1231,
								6278
							],
							[
								1178,
								6280
							],
							[
								1130,
								6323
							],
							[
								1086,
								6326
							],
							[
								960,
								6297
							],
							[
								857,
								6332
							],
							[
								867,
								6360
							],
							[
								919,
								6357
							],
							[
								981,
								6375
							],
							[
								934,
								6379
							],
							[
								920,
								6420
							],
							[
								988,
								6455
							],
							[
								1034,
								6495
							],
							[
								1043,
								6526
							],
							[
								1139,
								6525
							],
							[
								1156,
								6489
							],
							[
								1192,
								6481
							],
							[
								1157,
								6565
							],
							[
								1059,
								6572
							],
							[
								912,
								6516
							],
							[
								873,
								6479
							],
							[
								806,
								6471
							],
							[
								812,
								6498
							],
							[
								761,
								6468
							],
							[
								724,
								6478
							],
							[
								686,
								6434
							],
							[
								723,
								6414
							],
							[
								730,
								6362
							],
							[
								640,
								6356
							],
							[
								558,
								6319
							],
							[
								525,
								6343
							],
							[
								471,
								6323
							],
							[
								462,
								6343
							],
							[
								429,
								6319
							],
							[
								411,
								6338
							],
							[
								314,
								6289
							],
							[
								302,
								6310
							],
							[
								247,
								6299
							],
							[
								214,
								6313
							],
							[
								110,
								6319
							],
							[
								124,
								6294
							],
							[
								59,
								6280
							],
							[
								-21,
								6304
							],
							[
								-35,
								6334
							],
							[
								-136,
								6337
							],
							[
								-147,
								6359
							],
							[
								-190,
								6360
							],
							[
								-186,
								6413
							],
							[
								-262,
								6375
							],
							[
								-301,
								6378
							],
							[
								-286,
								6434
							],
							[
								-340,
								6402
							],
							[
								-340,
								6438
							],
							[
								-391,
								6422
							],
							[
								-360,
								6456
							],
							[
								-273,
								6438
							],
							[
								-267,
								6451
							],
							[
								-171,
								6458
							],
							[
								-73,
								6396
							],
							[
								-28,
								6419
							],
							[
								48,
								6420
							],
							[
								131,
								6407
							],
							[
								144,
								6380
							],
							[
								168,
								6415
							],
							[
								225,
								6431
							],
							[
								295,
								6429
							],
							[
								400,
								6534
							],
							[
								458,
								6544
							],
							[
								473,
								6567
							],
							[
								372,
								6589
							],
							[
								366,
								6639
							],
							[
								400,
								6666
							],
							[
								338,
								6652
							],
							[
								320,
								6611
							],
							[
								291,
								6615
							],
							[
								307,
								6706
							],
							[
								271,
								6706
							],
							[
								258,
								6733
							],
							[
								275,
								6770
							],
							[
								170,
								6745
							],
							[
								163,
								6775
							],
							[
								109,
								6820
							],
							[
								151,
								6808
							],
							[
								186,
								6891
							],
							[
								234,
								6901
							],
							[
								264,
								7012
							],
							[
								288,
								7052
							],
							[
								238,
								7010
							],
							[
								147,
								7047
							],
							[
								121,
								7079
							],
							[
								140,
								7101
							],
							[
								139,
								7169
							],
							[
								123,
								7244
							],
							[
								201,
								7234
							],
							[
								239,
								7188
							],
							[
								237,
								7148
							],
							[
								269,
								7156
							],
							[
								249,
								7199
							],
							[
								185,
								7273
							],
							[
								207,
								7274
							],
							[
								205,
								7321
							],
							[
								187,
								7305
							],
							[
								194,
								7376
							],
							[
								216,
								7382
							],
							[
								201,
								7416
							],
							[
								236,
								7403
							],
							[
								233,
								7438
							],
							[
								266,
								7414
							],
							[
								292,
								7452
							],
							[
								372,
								7470
							],
							[
								389,
								7460
							],
							[
								426,
								7498
							],
							[
								476,
								7518
							],
							[
								518,
								7511
							],
							[
								535,
								7486
							],
							[
								537,
								7439
							],
							[
								652,
								7429
							],
							[
								718,
								7388
							],
							[
								769,
								7399
							],
							[
								816,
								7475
							],
							[
								811,
								7522
							],
							[
								871,
								7519
							],
							[
								884,
								7577
							],
							[
								851,
								7567
							],
							[
								807,
								7593
							],
							[
								753,
								7592
							],
							[
								712,
								7606
							],
							[
								707,
								7646
							],
							[
								660,
								7691
							],
							[
								610,
								7709
							],
							[
								564,
								7787
							],
							[
								566,
								7821
							],
							[
								591,
								7838
							],
							[
								593,
								7900
							],
							[
								613,
								7875
							],
							[
								653,
								7874
							],
							[
								601,
								7954
							],
							[
								589,
								8014
							],
							[
								620,
								8024
							],
							[
								678,
								7997
							],
							[
								718,
								8006
							],
							[
								835,
								7982
							],
							[
								899,
								7960
							],
							[
								943,
								7924
							],
							[
								886,
								7880
							],
							[
								882,
								7852
							],
							[
								963,
								7778
							],
							[
								967,
								7751
							],
							[
								1017,
								7773
							],
							[
								1047,
								7744
							],
							[
								1038,
								7791
							],
							[
								1006,
								7802
							],
							[
								1028,
								7818
							],
							[
								1037,
								7911
							],
							[
								1061,
								7904
							],
							[
								1039,
								7853
							],
							[
								1039,
								7802
							],
							[
								1071,
								7793
							],
							[
								1074,
								7752
							],
							[
								1107,
								7730
							],
							[
								1124,
								7747
							],
							[
								1104,
								7797
							],
							[
								1055,
								7806
							],
							[
								1055,
								7848
							],
							[
								1099,
								7894
							],
							[
								1059,
								7914
							],
							[
								1007,
								7988
							],
							[
								1047,
								8080
							],
							[
								1038,
								8200
							],
							[
								1023,
								8233
							],
							[
								1022,
								8292
							],
							[
								1063,
								8305
							],
							[
								1104,
								8346
							],
							[
								1203,
								8266
							],
							[
								1262,
								8259
							],
							[
								1321,
								8274
							],
							[
								1353,
								8313
							],
							[
								1439,
								8349
							],
							[
								1443,
								8334
							],
							[
								1500,
								8355
							],
							[
								1497,
								8334
							],
							[
								1552,
								8311
							],
							[
								1666,
								8329
							],
							[
								1696,
								8297
							],
							[
								1749,
								8268
							],
							[
								1817,
								8271
							],
							[
								1866,
								8291
							],
							[
								1910,
								8226
							],
							[
								1863,
								8211
							],
							[
								1873,
								8173
							],
							[
								1923,
								8201
							],
							[
								1940,
								8159
							],
							[
								1918,
								8134
							],
							[
								1939,
								8109
							],
							[
								1997,
								8099
							],
							[
								2040,
								8042
							],
							[
								1990,
								8017
							],
							[
								2036,
								7984
							],
							[
								2011,
								7976
							],
							[
								2101,
								7925
							],
							[
								2090,
								7914
							],
							[
								2151,
								7897
							],
							[
								2205,
								7824
							],
							[
								2211,
								7792
							],
							[
								2241,
								7758
							],
							[
								2310,
								7716
							],
							[
								2325,
								7669
							],
							[
								2363,
								7642
							],
							[
								2402,
								7642
							],
							[
								2448,
								7622
							],
							[
								2477,
								7582
							],
							[
								2482,
								7546
							],
							[
								2505,
								7526
							],
							[
								2512,
								7485
							],
							[
								2536,
								7472
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1950,
								5665
							],
							[
								1950,
								5665
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1950,
								5665
							],
							[
								1950,
								5665
							]
						],
						[
							[
								2536,
								7472
							],
							[
								2596,
								7434
							],
							[
								2632,
								7392
							],
							[
								2662,
								7298
							],
							[
								2701,
								7239
							],
							[
								2743,
								7211
							],
							[
								2764,
								7196
							],
							[
								2789,
								7141
							],
							[
								2784,
								7229
							],
							[
								2811,
								7261
							],
							[
								2888,
								7266
							],
							[
								2904,
								7247
							],
							[
								2935,
								7290
							],
							[
								2949,
								7236
							],
							[
								2901,
								7206
							],
							[
								2951,
								7216
							],
							[
								2977,
								7206
							],
							[
								3016,
								7242
							],
							[
								3087,
								7234
							],
							[
								3127,
								7257
							],
							[
								3130,
								7227
							],
							[
								3186,
								7270
							],
							[
								3227,
								7242
							],
							[
								3253,
								7270
							],
							[
								3259,
								7240
							],
							[
								3238,
								7219
							],
							[
								3126,
								7192
							],
							[
								3061,
								7197
							],
							[
								3041,
								7170
							],
							[
								3005,
								7171
							],
							[
								2925,
								7115
							],
							[
								2962,
								7088
							],
							[
								2972,
								7137
							],
							[
								3050,
								7151
							],
							[
								3077,
								7178
							],
							[
								3105,
								7124
							],
							[
								3173,
								7185
							],
							[
								3258,
								7184
							],
							[
								3254,
								7149
							],
							[
								3316,
								7189
							],
							[
								3353,
								7237
							],
							[
								3363,
								7305
							],
							[
								3405,
								7210
							],
							[
								3401,
								7113
							],
							[
								3426,
								7034
							],
							[
								3453,
								7006
							],
							[
								3461,
								7042
							],
							[
								3503,
								7074
							],
							[
								3521,
								7123
							],
							[
								3566,
								7135
							],
							[
								3536,
								7059
							],
							[
								3561,
								7052
							],
							[
								3518,
								6995
							],
							[
								3566,
								6978
							],
							[
								3605,
								6992
							],
							[
								3638,
								7050
							],
							[
								3729,
								7008
							],
							[
								3766,
								6957
							],
							[
								3784,
								6923
							],
							[
								3878,
								6862
							],
							[
								3910,
								6816
							],
							[
								4036,
								6745
							],
							[
								4019,
								6775
							],
							[
								4046,
								6780
							],
							[
								4100,
								6743
							],
							[
								4128,
								6708
							],
							[
								4157,
								6641
							],
							[
								4145,
								6616
							],
							[
								4082,
								6635
							],
							[
								4060,
								6622
							],
							[
								4062,
								6589
							],
							[
								4030,
								6580
							],
							[
								4053,
								6551
							],
							[
								4233,
								6492
							],
							[
								4241,
								6503
							],
							[
								4330,
								6491
							],
							[
								4405,
								6534
							],
							[
								4420,
								6468
							],
							[
								4465,
								6462
							],
							[
								4472,
								6393
							],
							[
								4484,
								6435
							],
							[
								4528,
								6372
							],
							[
								4530,
								6329
							],
							[
								4508,
								6297
							],
							[
								4542,
								6244
							],
							[
								4534,
								6322
							],
							[
								4558,
								6283
							],
							[
								4562,
								6408
							],
							[
								4538,
								6446
							],
							[
								4532,
								6378
							],
							[
								4524,
								6418
							],
							[
								4555,
								6518
							],
							[
								4585,
								6505
							],
							[
								4632,
								6511
							],
							[
								4659,
								6554
							],
							[
								4708,
								6561
							],
							[
								4719,
								6601
							],
							[
								4657,
								6586
							],
							[
								4610,
								6545
							],
							[
								4584,
								6563
							],
							[
								4573,
								6529
							],
							[
								4526,
								6534
							],
							[
								4522,
								6564
							],
							[
								4496,
								6560
							],
							[
								4541,
								6619
							],
							[
								4609,
								6625
							],
							[
								4682,
								6655
							],
							[
								4716,
								6643
							],
							[
								4732,
								6615
							],
							[
								4722,
								6558
							],
							[
								4749,
								6529
							],
							[
								4783,
								6583
							],
							[
								4763,
								6520
							],
							[
								4787,
								6481
							],
							[
								4852,
								6482
							],
							[
								4932,
								6412
							],
							[
								4956,
								6423
							],
							[
								4986,
								6401
							],
							[
								5044,
								6428
							],
							[
								5133,
								6414
							],
							[
								5146,
								6399
							],
							[
								5207,
								6415
							],
							[
								5159,
								6462
							],
							[
								5194,
								6467
							],
							[
								5226,
								6405
							],
							[
								5262,
								6392
							],
							[
								5293,
								6408
							],
							[
								5254,
								6453
							],
							[
								5229,
								6434
							],
							[
								5206,
								6450
							],
							[
								5212,
								6481
							],
							[
								5185,
								6518
							],
							[
								5220,
								6506
							],
							[
								5252,
								6517
							],
							[
								5237,
								6550
							],
							[
								5285,
								6535
							],
							[
								5297,
								6497
							],
							[
								5337,
								6488
							],
							[
								5316,
								6453
							],
							[
								5378,
								6502
							],
							[
								5339,
								6351
							],
							[
								5366,
								6345
							],
							[
								5353,
								6310
							],
							[
								5390,
								6333
							],
							[
								5421,
								6248
							],
							[
								5429,
								6318
							],
							[
								5408,
								6382
							],
							[
								5392,
								6395
							],
							[
								5409,
								6461
							],
							[
								5450,
								6454
							],
							[
								5494,
								6518
							],
							[
								5547,
								6567
							],
							[
								5525,
								6563
							],
							[
								5534,
								6610
							],
							[
								5511,
								6634
							],
							[
								5499,
								6590
							],
							[
								5463,
								6588
							],
							[
								5465,
								6628
							],
							[
								5495,
								6646
							],
							[
								5488,
								6697
							],
							[
								5534,
								6718
							],
							[
								5532,
								6735
							],
							[
								5482,
								6719
							],
							[
								5461,
								6763
							],
							[
								5445,
								6741
							],
							[
								5358,
								6796
							],
							[
								5335,
								6881
							],
							[
								5359,
								6940
							],
							[
								5332,
								6979
							],
							[
								5347,
								7033
							],
							[
								5343,
								7070
							],
							[
								5372,
								7093
							],
							[
								5392,
								7069
							],
							[
								5404,
								7106
							],
							[
								5374,
								7120
							],
							[
								5418,
								7197
							],
							[
								5454,
								7207
							],
							[
								5423,
								7201
							],
							[
								5419,
								7310
							],
							[
								5388,
								7372
							],
							[
								5395,
								7438
							],
							[
								5387,
								7534
							],
							[
								5414,
								7558
							],
							[
								5413,
								7609
							],
							[
								5443,
								7628
							],
							[
								5501,
								7644
							],
							[
								5550,
								7637
							],
							[
								5581,
								7610
							],
							[
								5620,
								7620
							],
							[
								5699,
								7598
							],
							[
								5639,
								7455
							],
							[
								5615,
								7380
							],
							[
								5585,
								7352
							],
							[
								5524,
								7366
							],
							[
								5480,
								7361
							],
							[
								5522,
								7301
							],
							[
								5484,
								7213
							],
							[
								5459,
								7208
							],
							[
								5469,
								7142
							],
							[
								5480,
								7168
							],
							[
								5558,
								7085
							],
							[
								5567,
								7047
							],
							[
								5564,
								6981
							],
							[
								5599,
								6953
							],
							[
								5631,
								6876
							],
							[
								5644,
								6896
							],
							[
								5661,
								6859
							],
							[
								5616,
								6861
							],
							[
								5596,
								6840
							],
							[
								5634,
								6832
							],
							[
								5576,
								6769
							],
							[
								5616,
								6763
							],
							[
								5648,
								6731
							],
							[
								5664,
								6798
							],
							[
								5676,
								6745
							],
							[
								5723,
								6744
							],
							[
								5754,
								6727
							],
							[
								5727,
								6714
							],
							[
								5740,
								6688
							],
							[
								5686,
								6697
							],
							[
								5745,
								6620
							],
							[
								5739,
								6540
							],
							[
								5763,
								6505
							],
							[
								5796,
								6582
							],
							[
								5794,
								6656
							],
							[
								5814,
								6696
							],
							[
								5840,
								6695
							],
							[
								5908,
								6621
							],
							[
								5931,
								6534
							],
							[
								5890,
								6521
							],
							[
								5909,
								6429
							],
							[
								5979,
								6338
							],
							[
								6037,
								6369
							],
							[
								6030,
								6425
							],
							[
								6066,
								6496
							],
							[
								6067,
								6622
							],
							[
								6126,
								6631
							],
							[
								6100,
								6646
							],
							[
								6137,
								6686
							],
							[
								6079,
								6712
							],
							[
								6056,
								6795
							],
							[
								6066,
								6833
							],
							[
								6129,
								6844
							],
							[
								6176,
								6821
							],
							[
								6241,
								6825
							],
							[
								6287,
								6759
							],
							[
								6322,
								6755
							],
							[
								6351,
								6730
							],
							[
								6320,
								6691
							],
							[
								6363,
								6672
							],
							[
								6365,
								6647
							],
							[
								6320,
								6601
							],
							[
								6288,
								6606
							],
							[
								6305,
								6550
							],
							[
								6329,
								6546
							],
							[
								6331,
								6503
							],
							[
								6402,
								6433
							],
							[
								6395,
								6346
							],
							[
								6366,
								6338
							],
							[
								6329,
								6256
							],
							[
								6302,
								6250
							],
							[
								6290,
								6211
							],
							[
								6195,
								6297
							],
							[
								6161,
								6303
							],
							[
								6218,
								6263
							],
							[
								6261,
								6179
							],
							[
								6191,
								6197
							],
							[
								6213,
								6172
							],
							[
								6147,
								6182
							],
							[
								6130,
								6231
							],
							[
								6066,
								6221
							],
							[
								6035,
								6195
							],
							[
								6049,
								6176
							],
							[
								6107,
								6155
							],
							[
								6072,
								6104
							],
							[
								6070,
								6073
							],
							[
								6011,
								5995
							],
							[
								5970,
								5992
							],
							[
								5832,
								6091
							],
							[
								5807,
								6079
							],
							[
								5732,
								6081
							],
							[
								5814,
								6062
							],
							[
								5888,
								5984
							],
							[
								6037,
								5981
							],
							[
								6047,
								5965
							],
							[
								6007,
								5857
							],
							[
								5992,
								5849
							],
							[
								5984,
								5790
							],
							[
								5930,
								5747
							],
							[
								5885,
								5773
							],
							[
								5906,
								5741
							],
							[
								5865,
								5761
							],
							[
								5846,
								5790
							],
							[
								5847,
								5739
							],
							[
								5817,
								5675
							],
							[
								5792,
								5685
							],
							[
								5784,
								5645
							],
							[
								5747,
								5676
							],
							[
								5696,
								5688
							],
							[
								5732,
								5649
							],
							[
								5778,
								5636
							],
							[
								5792,
								5580
							],
							[
								5739,
								5530
							],
							[
								5677,
								5541
							],
							[
								5652,
								5525
							],
							[
								5691,
								5503
							],
							[
								5691,
								5481
							],
							[
								5633,
								5468
							],
							[
								5635,
								5435
							],
							[
								5606,
								5417
							],
							[
								5609,
								5357
							],
							[
								5536,
								5292
							],
							[
								5549,
								5270
							],
							[
								5508,
								5189
							],
							[
								5472,
								5043
							],
							[
								5480,
								4933
							],
							[
								5474,
								4878
							],
							[
								5507,
								4829
							],
							[
								5527,
								4844
							],
							[
								5618,
								4835
							],
							[
								5621,
								4800
							],
							[
								5652,
								4725
							],
							[
								5691,
								4607
							],
							[
								5668,
								4540
							],
							[
								5816,
								4598
							],
							[
								5856,
								4595
							],
							[
								5926,
								4557
							],
							[
								6007,
								4543
							],
							[
								6100,
								4483
							],
							[
								6142,
								4421
							],
							[
								6322,
								4367
							],
							[
								6349,
								4341
							],
							[
								6429,
								4321
							],
							[
								6491,
								4342
							],
							[
								6517,
								4333
							],
							[
								6650,
								4331
							],
							[
								6662,
								4286
							],
							[
								6655,
								4185
							],
							[
								6694,
								4123
							],
							[
								6708,
								4038
							],
							[
								6698,
								3986
							],
							[
								6782,
								3915
							],
							[
								6811,
								3863
							],
							[
								6850,
								3853
							],
							[
								6896,
								3813
							],
							[
								6922,
								3760
							],
							[
								6955,
								3756
							],
							[
								7023,
								3711
							],
							[
								7045,
								3691
							],
							[
								7022,
								3715
							]
						],
						[
							[
								2595,
								3667
							],
							[
								2589,
								3665
							],
							[
								2589,
								3668
							]
						],
						[
							[
								2623,
								3658
							],
							[
								2607,
								3678
							],
							[
								2595,
								3667
							]
						],
						[
							[
								2589,
								3668
							],
							[
								2589,
								3750
							],
							[
								2562,
								3743
							],
							[
								2524,
								3795
							],
							[
								2552,
								3822
							],
							[
								2475,
								3840
							],
							[
								2484,
								3887
							],
							[
								2450,
								3884
							],
							[
								2473,
								3924
							],
							[
								2443,
								3974
							],
							[
								2410,
								3969
							],
							[
								2320,
								4015
							],
							[
								2356,
								4048
							],
							[
								2356,
								4075
							],
							[
								2298,
								4071
							],
							[
								2259,
								4116
							],
							[
								2247,
								4159
							],
							[
								2263,
								4228
							],
							[
								2297,
								4305
							],
							[
								2290,
								4362
							],
							[
								2266,
								4339
							],
							[
								2308,
								4426
							],
							[
								2256,
								4351
							],
							[
								2283,
								4471
							],
							[
								2242,
								4519
							],
							[
								2256,
								4566
							],
							[
								2289,
								4569
							],
							[
								2327,
								4610
							],
							[
								2250,
								4570
							],
							[
								2227,
								4538
							],
							[
								2190,
								4647
							],
							[
								2179,
								4714
							],
							[
								2211,
								4771
							],
							[
								2198,
								4777
							],
							[
								2282,
								4843
							],
							[
								2288,
								4895
							],
							[
								2314,
								4942
							],
							[
								2318,
								4975
							]
						],
						[
							[
								3499,
								3438
							],
							[
								3299,
								3480
							]
						],
						[
							[
								3499,
								3438
							],
							[
								3299,
								3480
							]
						],
						[
							[
								4533,
								3288
							],
							[
								3918,
								3363
							]
						],
						[
							[
								4533,
								3288
							],
							[
								3918,
								3363
							]
						],
						[
							[
								6050,
								3117
							],
							[
								5986,
								3132
							],
							[
								5922,
								3126
							],
							[
								5907,
								3145
							],
							[
								5855,
								3112
							],
							[
								5788,
								3156
							],
							[
								5752,
								3138
							],
							[
								5723,
								3185
							],
							[
								5658,
								3198
							],
							[
								5607,
								3178
							],
							[
								5506,
								3222
							],
							[
								5493,
								3299
							],
							[
								5458,
								3311
							],
							[
								5457,
								3251
							],
							[
								5243,
								3252
							],
							[
								5228,
								3252
							],
							[
								4812,
								3267
							]
						],
						[
							[
								6050,
								3117
							],
							[
								5986,
								3132
							],
							[
								5922,
								3126
							],
							[
								5907,
								3145
							],
							[
								5855,
								3112
							],
							[
								5788,
								3156
							],
							[
								5752,
								3138
							],
							[
								5723,
								3185
							],
							[
								5658,
								3198
							],
							[
								5607,
								3178
							],
							[
								5506,
								3222
							],
							[
								5493,
								3299
							],
							[
								5458,
								3311
							],
							[
								5457,
								3251
							],
							[
								5243,
								3252
							],
							[
								5228,
								3252
							],
							[
								4812,
								3267
							]
						],
						[
							[
								6662,
								2918
							],
							[
								6657,
								2946
							],
							[
								6618,
								2930
							]
						],
						[
							[
								6662,
								2918
							],
							[
								6657,
								2946
							],
							[
								6618,
								2930
							]
						],
						[
							[
								6906,
								2353
							],
							[
								6919,
								2369
							],
							[
								6921,
								2428
							]
						],
						[
							[
								6906,
								2353
							],
							[
								6919,
								2369
							],
							[
								6921,
								2428
							]
						],
						[
							[
								8417,
								3218
							],
							[
								8357,
								3409
							],
							[
								8302,
								3442
							],
							[
								8237,
								3397
							],
							[
								8216,
								3407
							],
							[
								8188,
								3423
							],
							[
								8145,
								3289
							],
							[
								8146,
								3130
							],
							[
								8123,
								3098
							],
							[
								8114,
								3042
							],
							[
								8092,
								3045
							],
							[
								8092,
								3045
							],
							[
								8067,
								3036
							],
							[
								8060,
								2989
							],
							[
								7932,
								2954
							],
							[
								7862,
								2935
							],
							[
								7717,
								2898
							],
							[
								7715,
								2898
							],
							[
								7660,
								2863
							],
							[
								7616,
								2794
							]
						],
						[
							[
								8417,
								3218
							],
							[
								8357,
								3409
							],
							[
								8302,
								3442
							],
							[
								8237,
								3397
							],
							[
								8216,
								3407
							],
							[
								8188,
								3423
							],
							[
								8145,
								3289
							],
							[
								8146,
								3130
							],
							[
								8123,
								3098
							],
							[
								8114,
								3042
							],
							[
								8092,
								3045
							],
							[
								8092,
								3045
							],
							[
								8067,
								3036
							],
							[
								8060,
								2989
							],
							[
								7932,
								2954
							],
							[
								7862,
								2935
							],
							[
								7717,
								2898
							],
							[
								7715,
								2898
							],
							[
								7660,
								2863
							],
							[
								7616,
								2794
							]
						],
						[
							[
								8512,
								3153
							],
							[
								8476,
								3158
							],
							[
								8464,
								3207
							]
						],
						[
							[
								8512,
								3153
							],
							[
								8476,
								3158
							],
							[
								8464,
								3207
							]
						],
						[
							[
								3299,
								3480
							],
							[
								3198,
								3503
							],
							[
								2633,
								3655
							],
							[
								2623,
								3658
							]
						],
						[
							[
								3299,
								3480
							],
							[
								3198,
								3503
							],
							[
								2633,
								3655
							],
							[
								2623,
								3658
							]
						],
						[
							[
								2318,
								4975
							],
							[
								2224,
								5100
							],
							[
								2205,
								5106
							],
							[
								2197,
								5158
							],
							[
								2214,
								5181
							],
							[
								2193,
								5438
							],
							[
								2157,
								5572
							],
							[
								2127,
								5653
							],
							[
								2142,
								5669
							],
							[
								2124,
								5724
							],
							[
								2043,
								5725
							],
							[
								1991,
								5668
							],
							[
								1955,
								5665
							]
						],
						[
							[
								2318,
								4975
							],
							[
								2224,
								5100
							],
							[
								2205,
								5106
							],
							[
								2197,
								5158
							],
							[
								2214,
								5181
							],
							[
								2193,
								5438
							],
							[
								2157,
								5572
							],
							[
								2127,
								5653
							],
							[
								2142,
								5669
							],
							[
								2124,
								5724
							],
							[
								2043,
								5725
							],
							[
								1991,
								5668
							],
							[
								1955,
								5665
							]
						],
						[
							[
								1955,
								5665
							],
							[
								1955,
								5665
							]
						],
						[
							[
								1955,
								5665
							],
							[
								1955,
								5665
							]
						],
						[
							[
								1955,
								5665
							],
							[
								1950,
								5665
							],
							[
								1950,
								5665
							]
						],
						[
							[
								1955,
								5665
							],
							[
								1950,
								5665
							],
							[
								1950,
								5665
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1910,
								5662
							],
							[
								1920,
								5719
							],
							[
								1867,
								5889
							],
							[
								1891,
								5942
							],
							[
								1850,
								5961
							],
							[
								1810,
								5954
							],
							[
								1748,
								6013
							],
							[
								2536,
								7472
							]
						],
						[
							[
								1950,
								5665
							],
							[
								1910,
								5662
							],
							[
								1920,
								5719
							],
							[
								1867,
								5889
							],
							[
								1891,
								5942
							],
							[
								1850,
								5961
							],
							[
								1810,
								5954
							],
							[
								1748,
								6013
							],
							[
								2536,
								7472
							]
						],
						[
							[
								2595,
								3667
							],
							[
								2589,
								3668
							]
						],
						[
							[
								2595,
								3667
							],
							[
								2589,
								3668
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "AFG",
				"properties": {
					"name": "Afghanistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								61.210817,
								35.650072
							],
							[
								62.230651,
								35.270664
							],
							[
								62.984662,
								35.404041
							],
							[
								63.193538,
								35.857166
							],
							[
								63.982896,
								36.007957
							],
							[
								64.546479,
								36.312073
							],
							[
								64.746105,
								37.111818
							],
							[
								65.588948,
								37.305217
							],
							[
								65.745631,
								37.661164
							],
							[
								66.217385,
								37.39379
							],
							[
								66.518607,
								37.362784
							],
							[
								67.075782,
								37.356144
							],
							[
								67.83,
								37.144994
							],
							[
								68.135562,
								37.023115
							],
							[
								68.859446,
								37.344336
							],
							[
								69.196273,
								37.151144
							],
							[
								69.518785,
								37.608997
							],
							[
								70.116578,
								37.588223
							],
							[
								70.270574,
								37.735165
							],
							[
								70.376304,
								38.138396
							],
							[
								70.806821,
								38.486282
							],
							[
								71.348131,
								38.258905
							],
							[
								71.239404,
								37.953265
							],
							[
								71.541918,
								37.905774
							],
							[
								71.448693,
								37.065645
							],
							[
								71.844638,
								36.738171
							],
							[
								72.193041,
								36.948288
							],
							[
								72.63689,
								37.047558
							],
							[
								73.260056,
								37.495257
							],
							[
								73.948696,
								37.421566
							],
							[
								74.980002,
								37.41999
							],
							[
								75.158028,
								37.133031
							],
							[
								74.575893,
								37.020841
							],
							[
								74.067552,
								36.836176
							],
							[
								72.920025,
								36.720007
							],
							[
								71.846292,
								36.509942
							],
							[
								71.262348,
								36.074388
							],
							[
								71.498768,
								35.650563
							],
							[
								71.613076,
								35.153203
							],
							[
								71.115019,
								34.733126
							],
							[
								71.156773,
								34.348911
							],
							[
								70.881803,
								33.988856
							],
							[
								69.930543,
								34.02012
							],
							[
								70.323594,
								33.358533
							],
							[
								69.687147,
								33.105499
							],
							[
								69.262522,
								32.501944
							],
							[
								69.317764,
								31.901412
							],
							[
								68.926677,
								31.620189
							],
							[
								68.556932,
								31.71331
							],
							[
								67.792689,
								31.58293
							],
							[
								67.683394,
								31.303154
							],
							[
								66.938891,
								31.304911
							],
							[
								66.381458,
								30.738899
							],
							[
								66.346473,
								29.887943
							],
							[
								65.046862,
								29.472181
							],
							[
								64.350419,
								29.560031
							],
							[
								64.148002,
								29.340819
							],
							[
								63.550261,
								29.468331
							],
							[
								62.549857,
								29.318572
							],
							[
								60.874248,
								29.829239
							],
							[
								61.781222,
								30.73585
							],
							[
								61.699314,
								31.379506
							],
							[
								60.941945,
								31.548075
							],
							[
								60.863655,
								32.18292
							],
							[
								60.536078,
								32.981269
							],
							[
								60.9637,
								33.528832
							],
							[
								60.52843,
								33.676446
							],
							[
								60.803193,
								34.404102
							],
							[
								61.210817,
								35.650072
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "AGO",
				"properties": {
					"name": "Angola"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									16.326528,
									-5.87747
								],
								[
									16.57318,
									-6.622645
								],
								[
									16.860191,
									-7.222298
								],
								[
									17.089996,
									-7.545689
								],
								[
									17.47297,
									-8.068551
								],
								[
									18.134222,
									-7.987678
								],
								[
									18.464176,
									-7.847014
								],
								[
									19.016752,
									-7.988246
								],
								[
									19.166613,
									-7.738184
								],
								[
									19.417502,
									-7.155429
								],
								[
									20.037723,
									-7.116361
								],
								[
									20.091622,
									-6.94309
								],
								[
									20.601823,
									-6.939318
								],
								[
									20.514748,
									-7.299606
								],
								[
									21.728111,
									-7.290872
								],
								[
									21.746456,
									-7.920085
								],
								[
									21.949131,
									-8.305901
								],
								[
									21.801801,
									-8.908707
								],
								[
									21.875182,
									-9.523708
								],
								[
									22.208753,
									-9.894796
								],
								[
									22.155268,
									-11.084801
								],
								[
									22.402798,
									-10.993075
								],
								[
									22.837345,
									-11.017622
								],
								[
									23.456791,
									-10.867863
								],
								[
									23.912215,
									-10.926826
								],
								[
									24.017894,
									-11.237298
								],
								[
									23.904154,
									-11.722282
								],
								[
									24.079905,
									-12.191297
								],
								[
									23.930922,
									-12.565848
								],
								[
									24.016137,
									-12.911046
								],
								[
									21.933886,
									-12.898437
								],
								[
									21.887843,
									-16.08031
								],
								[
									22.562478,
									-16.898451
								],
								[
									23.215048,
									-17.523116
								],
								[
									21.377176,
									-17.930636
								],
								[
									18.956187,
									-17.789095
								],
								[
									18.263309,
									-17.309951
								],
								[
									14.209707,
									-17.353101
								],
								[
									14.058501,
									-17.423381
								],
								[
									13.462362,
									-16.971212
								],
								[
									12.814081,
									-16.941343
								],
								[
									12.215461,
									-17.111668
								],
								[
									11.734199,
									-17.301889
								],
								[
									11.640096,
									-16.673142
								],
								[
									11.778537,
									-15.793816
								],
								[
									12.123581,
									-14.878316
								],
								[
									12.175619,
									-14.449144
								],
								[
									12.500095,
									-13.5477
								],
								[
									12.738479,
									-13.137906
								],
								[
									13.312914,
									-12.48363
								],
								[
									13.633721,
									-12.038645
								],
								[
									13.738728,
									-11.297863
								],
								[
									13.686379,
									-10.731076
								],
								[
									13.387328,
									-10.373578
								],
								[
									13.120988,
									-9.766897
								],
								[
									12.87537,
									-9.166934
								],
								[
									12.929061,
									-8.959091
								],
								[
									13.236433,
									-8.562629
								],
								[
									12.93304,
									-7.596539
								],
								[
									12.728298,
									-6.927122
								],
								[
									12.227347,
									-6.294448
								],
								[
									12.322432,
									-6.100092
								],
								[
									12.735171,
									-5.965682
								],
								[
									13.024869,
									-5.984389
								],
								[
									13.375597,
									-5.864241
								],
								[
									16.326528,
									-5.87747
								]
							]
						],
						[
							[
								[
									12.436688,
									-5.684304
								],
								[
									12.182337,
									-5.789931
								],
								[
									11.914963,
									-5.037987
								],
								[
									12.318608,
									-4.60623
								],
								[
									12.62076,
									-4.438023
								],
								[
									12.995517,
									-4.781103
								],
								[
									12.631612,
									-4.991271
								],
								[
									12.468004,
									-5.248362
								],
								[
									12.436688,
									-5.684304
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ALB",
				"properties": {
					"name": "Albania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.590247,
								41.855404
							],
							[
								20.463175,
								41.515089
							],
							[
								20.605182,
								41.086226
							],
							[
								21.02004,
								40.842727
							],
							[
								20.99999,
								40.580004
							],
							[
								20.674997,
								40.435
							],
							[
								20.615,
								40.110007
							],
							[
								20.150016,
								39.624998
							],
							[
								19.98,
								39.694993
							],
							[
								19.960002,
								39.915006
							],
							[
								19.406082,
								40.250773
							],
							[
								19.319059,
								40.72723
							],
							[
								19.40355,
								41.409566
							],
							[
								19.540027,
								41.719986
							],
							[
								19.371769,
								41.877548
							],
							[
								19.304486,
								42.195745
							],
							[
								19.738051,
								42.688247
							],
							[
								19.801613,
								42.500093
							],
							[
								20.0707,
								42.58863
							],
							[
								20.283755,
								42.32026
							],
							[
								20.52295,
								42.21787
							],
							[
								20.590247,
								41.855404
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ARE",
				"properties": {
					"name": "United Arab Emirates"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								51.579519,
								24.245497
							],
							[
								51.757441,
								24.294073
							],
							[
								51.794389,
								24.019826
							],
							[
								52.577081,
								24.177439
							],
							[
								53.404007,
								24.151317
							],
							[
								54.008001,
								24.121758
							],
							[
								54.693024,
								24.797892
							],
							[
								55.439025,
								25.439145
							],
							[
								56.070821,
								26.055464
							],
							[
								56.261042,
								25.714606
							],
							[
								56.396847,
								24.924732
							],
							[
								55.886233,
								24.920831
							],
							[
								55.804119,
								24.269604
							],
							[
								55.981214,
								24.130543
							],
							[
								55.528632,
								23.933604
							],
							[
								55.525841,
								23.524869
							],
							[
								55.234489,
								23.110993
							],
							[
								55.208341,
								22.70833
							],
							[
								55.006803,
								22.496948
							],
							[
								52.000733,
								23.001154
							],
							[
								51.617708,
								24.014219
							],
							[
								51.579519,
								24.245497
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ARG",
				"properties": {
					"name": "Argentina"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-65.5,
									-55.2
								],
								[
									-66.45,
									-55.25
								],
								[
									-66.95992,
									-54.89681
								],
								[
									-67.56244,
									-54.87001
								],
								[
									-68.63335,
									-54.8695
								],
								[
									-68.63401,
									-52.63637
								],
								[
									-68.25,
									-53.1
								],
								[
									-67.75,
									-53.85
								],
								[
									-66.45,
									-54.45
								],
								[
									-65.05,
									-54.7
								],
								[
									-65.5,
									-55.2
								]
							]
						],
						[
							[
								[
									-64.964892,
									-22.075862
								],
								[
									-64.377021,
									-22.798091
								],
								[
									-63.986838,
									-21.993644
								],
								[
									-62.846468,
									-22.034985
								],
								[
									-62.685057,
									-22.249029
								],
								[
									-60.846565,
									-23.880713
								],
								[
									-60.028966,
									-24.032796
								],
								[
									-58.807128,
									-24.771459
								],
								[
									-57.777217,
									-25.16234
								],
								[
									-57.63366,
									-25.603657
								],
								[
									-58.618174,
									-27.123719
								],
								[
									-57.60976,
									-27.395899
								],
								[
									-56.486702,
									-27.548499
								],
								[
									-55.695846,
									-27.387837
								],
								[
									-54.788795,
									-26.621786
								],
								[
									-54.625291,
									-25.739255
								],
								[
									-54.13005,
									-25.547639
								],
								[
									-53.628349,
									-26.124865
								],
								[
									-53.648735,
									-26.923473
								],
								[
									-54.490725,
									-27.474757
								],
								[
									-55.162286,
									-27.881915
								],
								[
									-56.2909,
									-28.852761
								],
								[
									-57.625133,
									-30.216295
								],
								[
									-57.874937,
									-31.016556
								],
								[
									-58.14244,
									-32.044504
								],
								[
									-58.132648,
									-33.040567
								],
								[
									-58.349611,
									-33.263189
								],
								[
									-58.427074,
									-33.909454
								],
								[
									-58.495442,
									-34.43149
								],
								[
									-57.22583,
									-35.288027
								],
								[
									-57.362359,
									-35.97739
								],
								[
									-56.737487,
									-36.413126
								],
								[
									-56.788285,
									-36.901572
								],
								[
									-57.749157,
									-38.183871
								],
								[
									-59.231857,
									-38.72022
								],
								[
									-61.237445,
									-38.928425
								],
								[
									-62.335957,
									-38.827707
								],
								[
									-62.125763,
									-39.424105
								],
								[
									-62.330531,
									-40.172586
								],
								[
									-62.145994,
									-40.676897
								],
								[
									-62.745803,
									-41.028761
								],
								[
									-63.770495,
									-41.166789
								],
								[
									-64.73209,
									-40.802677
								],
								[
									-65.118035,
									-41.064315
								],
								[
									-64.978561,
									-42.058001
								],
								[
									-64.303408,
									-42.359016
								],
								[
									-63.755948,
									-42.043687
								],
								[
									-63.458059,
									-42.563138
								],
								[
									-64.378804,
									-42.873558
								],
								[
									-65.181804,
									-43.495381
								],
								[
									-65.328823,
									-44.501366
								],
								[
									-65.565269,
									-45.036786
								],
								[
									-66.509966,
									-45.039628
								],
								[
									-67.293794,
									-45.551896
								],
								[
									-67.580546,
									-46.301773
								],
								[
									-66.597066,
									-47.033925
								],
								[
									-65.641027,
									-47.236135
								],
								[
									-65.985088,
									-48.133289
								],
								[
									-67.166179,
									-48.697337
								],
								[
									-67.816088,
									-49.869669
								],
								[
									-68.728745,
									-50.264218
								],
								[
									-69.138539,
									-50.73251
								],
								[
									-68.815561,
									-51.771104
								],
								[
									-68.149995,
									-52.349983
								],
								[
									-68.571545,
									-52.299444
								],
								[
									-69.498362,
									-52.142761
								],
								[
									-71.914804,
									-52.009022
								],
								[
									-72.329404,
									-51.425956
								],
								[
									-72.309974,
									-50.67701
								],
								[
									-72.975747,
									-50.74145
								],
								[
									-73.328051,
									-50.378785
								],
								[
									-73.415436,
									-49.318436
								],
								[
									-72.648247,
									-48.878618
								],
								[
									-72.331161,
									-48.244238
								],
								[
									-72.447355,
									-47.738533
								],
								[
									-71.917258,
									-46.884838
								],
								[
									-71.552009,
									-45.560733
								],
								[
									-71.659316,
									-44.973689
								],
								[
									-71.222779,
									-44.784243
								],
								[
									-71.329801,
									-44.407522
								],
								[
									-71.793623,
									-44.207172
								],
								[
									-71.464056,
									-43.787611
								],
								[
									-71.915424,
									-43.408565
								],
								[
									-72.148898,
									-42.254888
								],
								[
									-71.746804,
									-42.051386
								],
								[
									-71.915734,
									-40.832339
								],
								[
									-71.680761,
									-39.808164
								],
								[
									-71.413517,
									-38.916022
								],
								[
									-70.814664,
									-38.552995
								],
								[
									-71.118625,
									-37.576827
								],
								[
									-71.121881,
									-36.658124
								],
								[
									-70.364769,
									-36.005089
								],
								[
									-70.388049,
									-35.169688
								],
								[
									-69.817309,
									-34.193571
								],
								[
									-69.814777,
									-33.273886
								],
								[
									-70.074399,
									-33.09121
								],
								[
									-70.535069,
									-31.36501
								],
								[
									-69.919008,
									-30.336339
								],
								[
									-70.01355,
									-29.367923
								],
								[
									-69.65613,
									-28.459141
								],
								[
									-69.001235,
									-27.521214
								],
								[
									-68.295542,
									-26.89934
								],
								[
									-68.5948,
									-26.506909
								],
								[
									-68.386001,
									-26.185016
								],
								[
									-68.417653,
									-24.518555
								],
								[
									-67.328443,
									-24.025303
								],
								[
									-66.985234,
									-22.986349
								],
								[
									-67.106674,
									-22.735925
								],
								[
									-66.273339,
									-21.83231
								],
								[
									-64.964892,
									-22.075862
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ARM",
				"properties": {
					"name": "Armenia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								43.582746,
								41.092143
							],
							[
								44.97248,
								41.248129
							],
							[
								45.179496,
								40.985354
							],
							[
								45.560351,
								40.81229
							],
							[
								45.359175,
								40.561504
							],
							[
								45.891907,
								40.218476
							],
							[
								45.610012,
								39.899994
							],
							[
								46.034534,
								39.628021
							],
							[
								46.483499,
								39.464155
							],
							[
								46.50572,
								38.770605
							],
							[
								46.143623,
								38.741201
							],
							[
								45.735379,
								39.319719
							],
							[
								45.739978,
								39.473999
							],
							[
								45.298145,
								39.471751
							],
							[
								45.001987,
								39.740004
							],
							[
								44.79399,
								39.713003
							],
							[
								44.400009,
								40.005
							],
							[
								43.656436,
								40.253564
							],
							[
								43.752658,
								40.740201
							],
							[
								43.582746,
								41.092143
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ATA",
				"properties": {
					"name": "Antarctica"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-59.572095,
									-80.040179
								],
								[
									-59.865849,
									-80.549657
								],
								[
									-60.159656,
									-81.000327
								],
								[
									-62.255393,
									-80.863178
								],
								[
									-64.488125,
									-80.921934
								],
								[
									-65.741666,
									-80.588827
								],
								[
									-65.741666,
									-80.549657
								],
								[
									-66.290031,
									-80.255773
								],
								[
									-64.037688,
									-80.294944
								],
								[
									-61.883246,
									-80.39287
								],
								[
									-61.138976,
									-79.981371
								],
								[
									-60.610119,
									-79.628679
								],
								[
									-59.572095,
									-80.040179
								]
							]
						],
						[
							[
								[
									-159.208184,
									-79.497059
								],
								[
									-161.127601,
									-79.634209
								],
								[
									-162.439847,
									-79.281465
								],
								[
									-163.027408,
									-78.928774
								],
								[
									-163.066604,
									-78.869966
								],
								[
									-163.712896,
									-78.595667
								],
								[
									-163.105801,
									-78.223338
								],
								[
									-161.245113,
									-78.380176
								],
								[
									-160.246208,
									-78.693645
								],
								[
									-159.482405,
									-79.046338
								],
								[
									-159.208184,
									-79.497059
								]
							]
						],
						[
							[
								[
									-45.154758,
									-78.04707
								],
								[
									-43.920828,
									-78.478103
								],
								[
									-43.48995,
									-79.08556
								],
								[
									-43.372438,
									-79.516645
								],
								[
									-43.333267,
									-80.026123
								],
								[
									-44.880537,
									-80.339644
								],
								[
									-46.506174,
									-80.594357
								],
								[
									-48.386421,
									-80.829485
								],
								[
									-50.482107,
									-81.025442
								],
								[
									-52.851988,
									-80.966685
								],
								[
									-54.164259,
									-80.633528
								],
								[
									-53.987991,
									-80.222028
								],
								[
									-51.853134,
									-79.94773
								],
								[
									-50.991326,
									-79.614623
								],
								[
									-50.364595,
									-79.183487
								],
								[
									-49.914131,
									-78.811209
								],
								[
									-49.306959,
									-78.458569
								],
								[
									-48.660616,
									-78.047018
								],
								[
									-48.660616,
									-78.047019
								],
								[
									-48.151396,
									-78.04707
								],
								[
									-46.662857,
									-77.831476
								],
								[
									-45.154758,
									-78.04707
								]
							]
						],
						[
							[
								[
									-121.211511,
									-73.50099
								],
								[
									-119.918851,
									-73.657725
								],
								[
									-118.724143,
									-73.481353
								],
								[
									-119.292119,
									-73.834097
								],
								[
									-120.232217,
									-74.08881
								],
								[
									-121.62283,
									-74.010468
								],
								[
									-122.621735,
									-73.657778
								],
								[
									-122.621735,
									-73.657777
								],
								[
									-122.406245,
									-73.324619
								],
								[
									-121.211511,
									-73.50099
								]
							]
						],
						[
							[
								[
									-125.559566,
									-73.481353
								],
								[
									-124.031882,
									-73.873268
								],
								[
									-124.619469,
									-73.834097
								],
								[
									-125.912181,
									-73.736118
								],
								[
									-127.28313,
									-73.461769
								],
								[
									-127.28313,
									-73.461768
								],
								[
									-126.558472,
									-73.246226
								],
								[
									-125.559566,
									-73.481353
								]
							]
						],
						[
							[
								[
									-98.98155,
									-71.933334
								],
								[
									-97.884743,
									-72.070535
								],
								[
									-96.787937,
									-71.952971
								],
								[
									-96.20035,
									-72.521205
								],
								[
									-96.983765,
									-72.442864
								],
								[
									-98.198083,
									-72.482035
								],
								[
									-99.432013,
									-72.442864
								],
								[
									-100.783455,
									-72.50162
								],
								[
									-101.801868,
									-72.305663
								],
								[
									-102.330725,
									-71.894164
								],
								[
									-101.703967,
									-71.717792
								],
								[
									-100.430919,
									-71.854993
								],
								[
									-98.98155,
									-71.933334
								]
							]
						],
						[
							[
								[
									-68.451346,
									-70.955823
								],
								[
									-68.333834,
									-71.406493
								],
								[
									-68.510128,
									-71.798407
								],
								[
									-68.784297,
									-72.170736
								],
								[
									-69.959471,
									-72.307885
								],
								[
									-71.075889,
									-72.503842
								],
								[
									-72.388134,
									-72.484257
								],
								[
									-71.8985,
									-72.092343
								],
								[
									-73.073622,
									-72.229492
								],
								[
									-74.19004,
									-72.366693
								],
								[
									-74.953895,
									-72.072757
								],
								[
									-75.012625,
									-71.661258
								],
								[
									-73.915819,
									-71.269345
								],
								[
									-73.915819,
									-71.269344
								],
								[
									-73.230331,
									-71.15178
								],
								[
									-72.074717,
									-71.190951
								],
								[
									-71.780962,
									-70.681473
								],
								[
									-71.72218,
									-70.309196
								],
								[
									-71.741791,
									-69.505782
								],
								[
									-71.173815,
									-69.035475
								],
								[
									-70.253252,
									-68.87874
								],
								[
									-69.724447,
									-69.251017
								],
								[
									-69.489422,
									-69.623346
								],
								[
									-69.058518,
									-70.074016
								],
								[
									-68.725541,
									-70.505153
								],
								[
									-68.451346,
									-70.955823
								]
							]
						],
						[
							[
								[
									-58.614143,
									-64.152467
								],
								[
									-59.045073,
									-64.36801
								],
								[
									-59.789342,
									-64.211223
								],
								[
									-60.611928,
									-64.309202
								],
								[
									-61.297416,
									-64.54433
								],
								[
									-62.0221,
									-64.799094
								],
								[
									-62.51176,
									-65.09303
								],
								[
									-62.648858,
									-65.484942
								],
								[
									-62.590128,
									-65.857219
								],
								[
									-62.120079,
									-66.190326
								],
								[
									-62.805567,
									-66.425505
								],
								[
									-63.74569,
									-66.503847
								],
								[
									-64.294106,
									-66.837004
								],
								[
									-64.881693,
									-67.150474
								],
								[
									-65.508425,
									-67.58161
								],
								[
									-65.665082,
									-67.953887
								],
								[
									-65.312545,
									-68.365335
								],
								[
									-64.783715,
									-68.678908
								],
								[
									-63.961103,
									-68.913984
								],
								[
									-63.1973,
									-69.227556
								],
								[
									-62.785955,
									-69.619419
								],
								[
									-62.570516,
									-69.991747
								],
								[
									-62.276736,
									-70.383661
								],
								[
									-61.806661,
									-70.716768
								],
								[
									-61.512906,
									-71.089045
								],
								[
									-61.375809,
									-72.010074
								],
								[
									-61.081977,
									-72.382351
								],
								[
									-61.003661,
									-72.774265
								],
								[
									-60.690269,
									-73.166179
								],
								[
									-60.827367,
									-73.695242
								],
								[
									-61.375809,
									-74.106742
								],
								[
									-61.96337,
									-74.439848
								],
								[
									-63.295201,
									-74.576997
								],
								[
									-63.74569,
									-74.92974
								],
								[
									-64.352836,
									-75.262847
								],
								[
									-65.860987,
									-75.635124
								],
								[
									-67.192818,
									-75.79191
								],
								[
									-68.446282,
									-76.007452
								],
								[
									-69.797724,
									-76.222995
								],
								[
									-70.600724,
									-76.634494
								],
								[
									-72.206776,
									-76.673665
								],
								[
									-73.969536,
									-76.634494
								],
								[
									-75.555977,
									-76.712887
								],
								[
									-77.24037,
									-76.712887
								],
								[
									-76.926979,
									-77.104802
								],
								[
									-75.399294,
									-77.28107
								],
								[
									-74.282876,
									-77.55542
								],
								[
									-73.656119,
									-77.908112
								],
								[
									-74.772536,
									-78.221633
								],
								[
									-76.4961,
									-78.123654
								],
								[
									-77.925858,
									-78.378419
								],
								[
									-77.984666,
									-78.789918
								],
								[
									-78.023785,
									-79.181833
								],
								[
									-76.848637,
									-79.514939
								],
								[
									-76.633224,
									-79.887216
								],
								[
									-75.360097,
									-80.259545
								],
								[
									-73.244852,
									-80.416331
								],
								[
									-71.442946,
									-80.69063
								],
								[
									-70.013163,
									-81.004151
								],
								[
									-68.191646,
									-81.317672
								],
								[
									-65.704279,
									-81.474458
								],
								[
									-63.25603,
									-81.748757
								],
								[
									-61.552026,
									-82.042692
								],
								[
									-59.691416,
									-82.37585
								],
								[
									-58.712121,
									-82.846106
								],
								[
									-58.222487,
									-83.218434
								],
								[
									-57.008117,
									-82.865691
								],
								[
									-55.362894,
									-82.571755
								],
								[
									-53.619771,
									-82.258235
								],
								[
									-51.543644,
									-82.003521
								],
								[
									-49.76135,
									-81.729171
								],
								[
									-47.273931,
									-81.709586
								],
								[
									-44.825708,
									-81.846735
								],
								[
									-42.808363,
									-82.081915
								],
								[
									-42.16202,
									-81.65083
								],
								[
									-40.771433,
									-81.356894
								],
								[
									-38.244818,
									-81.337309
								],
								[
									-36.26667,
									-81.121715
								],
								[
									-34.386397,
									-80.906172
								],
								[
									-32.310296,
									-80.769023
								],
								[
									-30.097098,
									-80.592651
								],
								[
									-28.549802,
									-80.337938
								],
								[
									-29.254901,
									-79.985195
								],
								[
									-29.685805,
									-79.632503
								],
								[
									-29.685805,
									-79.260226
								],
								[
									-31.624808,
									-79.299397
								],
								[
									-33.681324,
									-79.456132
								],
								[
									-35.639912,
									-79.456132
								],
								[
									-35.914107,
									-79.083855
								],
								[
									-35.77701,
									-78.339248
								],
								[
									-35.326546,
									-78.123654
								],
								[
									-33.896763,
									-77.888526
								],
								[
									-32.212369,
									-77.65345
								],
								[
									-30.998051,
									-77.359515
								],
								[
									-29.783732,
									-77.065579
								],
								[
									-28.882779,
									-76.673665
								],
								[
									-27.511752,
									-76.497345
								],
								[
									-26.160336,
									-76.360144
								],
								[
									-25.474822,
									-76.281803
								],
								[
									-23.927552,
									-76.24258
								],
								[
									-22.458598,
									-76.105431
								],
								[
									-21.224694,
									-75.909474
								],
								[
									-20.010375,
									-75.674346
								],
								[
									-18.913543,
									-75.439218
								],
								[
									-17.522982,
									-75.125698
								],
								[
									-16.641589,
									-74.79254
								],
								[
									-15.701491,
									-74.498604
								],
								[
									-15.40771,
									-74.106742
								],
								[
									-16.46532,
									-73.871614
								],
								[
									-16.112784,
									-73.460114
								],
								[
									-15.446855,
									-73.146542
								],
								[
									-14.408805,
									-72.950585
								],
								[
									-13.311973,
									-72.715457
								],
								[
									-12.293508,
									-72.401936
								],
								[
									-11.510067,
									-72.010074
								],
								[
									-11.020433,
									-71.539767
								],
								[
									-10.295774,
									-71.265416
								],
								[
									-9.101015,
									-71.324224
								],
								[
									-8.611381,
									-71.65733
								],
								[
									-7.416622,
									-71.696501
								],
								[
									-7.377451,
									-71.324224
								],
								[
									-6.868232,
									-70.93231
								],
								[
									-5.790985,
									-71.030289
								],
								[
									-5.536375,
									-71.402617
								],
								[
									-4.341667,
									-71.461373
								],
								[
									-3.048981,
									-71.285053
								],
								[
									-1.795492,
									-71.167438
								],
								[
									-0.659489,
									-71.226246
								],
								[
									-0.228637,
									-71.637745
								],
								[
									0.868195,
									-71.304639
								],
								[
									1.886686,
									-71.128267
								],
								[
									3.022638,
									-70.991118
								],
								[
									4.139055,
									-70.853917
								],
								[
									5.157546,
									-70.618789
								],
								[
									6.273912,
									-70.462055
								],
								[
									7.13572,
									-70.246512
								],
								[
									7.742866,
									-69.893769
								],
								[
									8.48711,
									-70.148534
								],
								[
									9.525135,
									-70.011333
								],
								[
									10.249845,
									-70.48164
								],
								[
									10.817821,
									-70.834332
								],
								[
									11.953824,
									-70.638375
								],
								[
									12.404287,
									-70.246512
								],
								[
									13.422778,
									-69.972162
								],
								[
									14.734998,
									-70.030918
								],
								[
									15.126757,
									-70.403247
								],
								[
									15.949342,
									-70.030918
								],
								[
									17.026589,
									-69.913354
								],
								[
									18.201711,
									-69.874183
								],
								[
									19.259373,
									-69.893769
								],
								[
									20.375739,
									-70.011333
								],
								[
									21.452985,
									-70.07014
								],
								[
									21.923034,
									-70.403247
								],
								[
									22.569403,
									-70.697182
								],
								[
									23.666184,
									-70.520811
								],
								[
									24.841357,
									-70.48164
								],
								[
									25.977309,
									-70.48164
								],
								[
									27.093726,
									-70.462055
								],
								[
									28.09258,
									-70.324854
								],
								[
									29.150242,
									-70.20729
								],
								[
									30.031583,
									-69.93294
								],
								[
									30.971733,
									-69.75662
								],
								[
									31.990172,
									-69.658641
								],
								[
									32.754053,
									-69.384291
								],
								[
									33.302443,
									-68.835642
								],
								[
									33.870419,
									-68.502588
								],
								[
									34.908495,
									-68.659271
								],
								[
									35.300202,
									-69.012014
								],
								[
									36.16201,
									-69.247142
								],
								[
									37.200035,
									-69.168748
								],
								[
									37.905108,
									-69.52144
								],
								[
									38.649404,
									-69.776205
								],
								[
									39.667894,
									-69.541077
								],
								[
									40.020431,
									-69.109941
								],
								[
									40.921358,
									-68.933621
								],
								[
									41.959434,
									-68.600514
								],
								[
									42.938702,
									-68.463313
								],
								[
									44.113876,
									-68.267408
								],
								[
									44.897291,
									-68.051866
								],
								[
									45.719928,
									-67.816738
								],
								[
									46.503343,
									-67.601196
								],
								[
									47.44344,
									-67.718759
								],
								[
									48.344419,
									-67.366068
								],
								[
									48.990736,
									-67.091718
								],
								[
									49.930885,
									-67.111303
								],
								[
									50.753471,
									-66.876175
								],
								[
									50.949325,
									-66.523484
								],
								[
									51.791547,
									-66.249133
								],
								[
									52.614133,
									-66.053176
								],
								[
									53.613038,
									-65.89639
								],
								[
									54.53355,
									-65.818049
								],
								[
									55.414943,
									-65.876805
								],
								[
									56.355041,
									-65.974783
								],
								[
									57.158093,
									-66.249133
								],
								[
									57.255968,
									-66.680218
								],
								[
									58.137361,
									-67.013324
								],
								[
									58.744508,
									-67.287675
								],
								[
									59.939318,
									-67.405239
								],
								[
									60.605221,
									-67.679589
								],
								[
									61.427806,
									-67.953887
								],
								[
									62.387489,
									-68.012695
								],
								[
									63.19049,
									-67.816738
								],
								[
									64.052349,
									-67.405239
								],
								[
									64.992447,
									-67.620729
								],
								[
									65.971715,
									-67.738345
								],
								[
									66.911864,
									-67.855909
								],
								[
									67.891133,
									-67.934302
								],
								[
									68.890038,
									-67.934302
								],
								[
									69.712624,
									-68.972791
								],
								[
									69.673453,
									-69.227556
								],
								[
									69.555941,
									-69.678226
								],
								[
									68.596258,
									-69.93294
								],
								[
									67.81274,
									-70.305268
								],
								[
									67.949889,
									-70.697182
								],
								[
									69.066307,
									-70.677545
								],
								[
									68.929157,
									-71.069459
								],
								[
									68.419989,
									-71.441788
								],
								[
									67.949889,
									-71.853287
								],
								[
									68.71377,
									-72.166808
								],
								[
									69.869307,
									-72.264787
								],
								[
									71.024895,
									-72.088415
								],
								[
									71.573285,
									-71.696501
								],
								[
									71.906288,
									-71.324224
								],
								[
									72.454627,
									-71.010703
								],
								[
									73.08141,
									-70.716768
								],
								[
									73.33602,
									-70.364024
								],
								[
									73.864877,
									-69.874183
								],
								[
									74.491557,
									-69.776205
								],
								[
									75.62756,
									-69.737034
								],
								[
									76.626465,
									-69.619419
								],
								[
									77.644904,
									-69.462684
								],
								[
									78.134539,
									-69.07077
								],
								[
									78.428371,
									-68.698441
								],
								[
									79.113859,
									-68.326216
								],
								[
									80.093127,
									-68.071503
								],
								[
									80.93535,
									-67.875546
								],
								[
									81.483792,
									-67.542388
								],
								[
									82.051767,
									-67.366068
								],
								[
									82.776426,
									-67.209282
								],
								[
									83.775331,
									-67.30726
								],
								[
									84.676206,
									-67.209282
								],
								[
									85.655527,
									-67.091718
								],
								[
									86.752359,
									-67.150474
								],
								[
									87.477017,
									-66.876175
								],
								[
									87.986289,
									-66.209911
								],
								[
									88.358411,
									-66.484261
								],
								[
									88.828408,
									-66.954568
								],
								[
									89.67063,
									-67.150474
								],
								[
									90.630365,
									-67.228867
								],
								[
									91.5901,
									-67.111303
								],
								[
									92.608539,
									-67.189696
								],
								[
									93.548637,
									-67.209282
								],
								[
									94.17542,
									-67.111303
								],
								[
									95.017591,
									-67.170111
								],
								[
									95.781472,
									-67.385653
								],
								[
									96.682399,
									-67.248504
								],
								[
									97.759646,
									-67.248504
								],
								[
									98.68021,
									-67.111303
								],
								[
									99.718182,
									-67.248504
								],
								[
									100.384188,
									-66.915346
								],
								[
									100.893356,
									-66.58224
								],
								[
									101.578896,
									-66.30789
								],
								[
									102.832411,
									-65.563284
								],
								[
									103.478676,
									-65.700485
								],
								[
									104.242557,
									-65.974783
								],
								[
									104.90846,
									-66.327527
								],
								[
									106.181561,
									-66.934931
								],
								[
									107.160881,
									-66.954568
								],
								[
									108.081393,
									-66.954568
								],
								[
									109.15864,
									-66.837004
								],
								[
									110.235835,
									-66.699804
								],
								[
									111.058472,
									-66.425505
								],
								[
									111.74396,
									-66.13157
								],
								[
									112.860378,
									-66.092347
								],
								[
									113.604673,
									-65.876805
								],
								[
									114.388088,
									-66.072762
								],
								[
									114.897308,
									-66.386283
								],
								[
									115.602381,
									-66.699804
								],
								[
									116.699161,
									-66.660633
								],
								[
									117.384701,
									-66.915346
								],
								[
									118.57946,
									-67.170111
								],
								[
									119.832924,
									-67.268089
								],
								[
									120.871,
									-67.189696
								],
								[
									121.654415,
									-66.876175
								],
								[
									122.320369,
									-66.562654
								],
								[
									123.221296,
									-66.484261
								],
								[
									124.122274,
									-66.621462
								],
								[
									125.160247,
									-66.719389
								],
								[
									126.100396,
									-66.562654
								],
								[
									127.001427,
									-66.562654
								],
								[
									127.882768,
									-66.660633
								],
								[
									128.80328,
									-66.758611
								],
								[
									129.704259,
									-66.58224
								],
								[
									130.781454,
									-66.425505
								],
								[
									131.799945,
									-66.386283
								],
								[
									132.935896,
									-66.386283
								],
								[
									133.85646,
									-66.288304
								],
								[
									134.757387,
									-66.209963
								],
								[
									135.031582,
									-65.72007
								],
								[
									135.070753,
									-65.308571
								],
								[
									135.697485,
									-65.582869
								],
								[
									135.873805,
									-66.033591
								],
								[
									136.206705,
									-66.44509
								],
								[
									136.618049,
									-66.778197
								],
								[
									137.460271,
									-66.954568
								],
								[
									138.596223,
									-66.895761
								],
								[
									139.908442,
									-66.876175
								],
								[
									140.809421,
									-66.817367
								],
								[
									142.121692,
									-66.817367
								],
								[
									143.061842,
									-66.797782
								],
								[
									144.374061,
									-66.837004
								],
								[
									145.490427,
									-66.915346
								],
								[
									146.195552,
									-67.228867
								],
								[
									145.999699,
									-67.601196
								],
								[
									146.646067,
									-67.895131
								],
								[
									147.723263,
									-68.130259
								],
								[
									148.839629,
									-68.385024
								],
								[
									150.132314,
									-68.561292
								],
								[
									151.483705,
									-68.71813
								],
								[
									152.502247,
									-68.874813
								],
								[
									153.638199,
									-68.894502
								],
								[
									154.284567,
									-68.561292
								],
								[
									155.165857,
									-68.835642
								],
								[
									155.92979,
									-69.149215
								],
								[
									156.811132,
									-69.384291
								],
								[
									158.025528,
									-69.482269
								],
								[
									159.181013,
									-69.599833
								],
								[
									159.670699,
									-69.991747
								],
								[
									160.80665,
									-70.226875
								],
								[
									161.570479,
									-70.579618
								],
								[
									162.686897,
									-70.736353
								],
								[
									163.842434,
									-70.716768
								],
								[
									164.919681,
									-70.775524
								],
								[
									166.11444,
									-70.755938
								],
								[
									167.309095,
									-70.834332
								],
								[
									168.425616,
									-70.971481
								],
								[
									169.463589,
									-71.20666
								],
								[
									170.501665,
									-71.402617
								],
								[
									171.20679,
									-71.696501
								],
								[
									171.089227,
									-72.088415
								],
								[
									170.560422,
									-72.441159
								],
								[
									170.109958,
									-72.891829
								],
								[
									169.75737,
									-73.24452
								],
								[
									169.287321,
									-73.65602
								],
								[
									167.975101,
									-73.812806
								],
								[
									167.387489,
									-74.165498
								],
								[
									166.094803,
									-74.38104
								],
								[
									165.644391,
									-74.772954
								],
								[
									164.958851,
									-75.145283
								],
								[
									164.234193,
									-75.458804
								],
								[
									163.822797,
									-75.870303
								],
								[
									163.568239,
									-76.24258
								],
								[
									163.47026,
									-76.693302
								],
								[
									163.489897,
									-77.065579
								],
								[
									164.057873,
									-77.457442
								],
								[
									164.273363,
									-77.82977
								],
								[
									164.743464,
									-78.182514
								],
								[
									166.604126,
									-78.319611
								],
								[
									166.995781,
									-78.750748
								],
								[
									165.193876,
									-78.907483
								],
								[
									163.666217,
									-79.123025
								],
								[
									161.766385,
									-79.162248
								],
								[
									160.924162,
									-79.730482
								],
								[
									160.747894,
									-80.200737
								],
								[
									160.316964,
									-80.573066
								],
								[
									159.788211,
									-80.945395
								],
								[
									161.120016,
									-81.278501
								],
								[
									161.629287,
									-81.690001
								],
								[
									162.490992,
									-82.062278
								],
								[
									163.705336,
									-82.395435
								],
								[
									165.095949,
									-82.708956
								],
								[
									166.604126,
									-83.022477
								],
								[
									168.895665,
									-83.335998
								],
								[
									169.404782,
									-83.825891
								],
								[
									172.283934,
									-84.041433
								],
								[
									172.477049,
									-84.117914
								],
								[
									173.224083,
									-84.41371
								],
								[
									175.985672,
									-84.158997
								],
								[
									178.277212,
									-84.472518
								],
								[
									180,
									-84.71338
								],
								[
									-179.942499,
									-84.721443
								],
								[
									-179.058677,
									-84.139412
								],
								[
									-177.256772,
									-84.452933
								],
								[
									-177.140807,
									-84.417941
								],
								[
									-176.084673,
									-84.099259
								],
								[
									-175.947235,
									-84.110449
								],
								[
									-175.829882,
									-84.117914
								],
								[
									-174.382503,
									-84.534323
								],
								[
									-173.116559,
									-84.117914
								],
								[
									-172.889106,
									-84.061019
								],
								[
									-169.951223,
									-83.884647
								],
								[
									-168.999989,
									-84.117914
								],
								[
									-168.530199,
									-84.23739
								],
								[
									-167.022099,
									-84.570497
								],
								[
									-164.182144,
									-84.82521
								],
								[
									-161.929775,
									-85.138731
								],
								[
									-158.07138,
									-85.37391
								],
								[
									-155.192253,
									-85.09956
								],
								[
									-150.942099,
									-85.295517
								],
								[
									-148.533073,
									-85.609038
								],
								[
									-145.888918,
									-85.315102
								],
								[
									-143.107718,
									-85.040752
								],
								[
									-142.892279,
									-84.570497
								],
								[
									-146.829068,
									-84.531274
								],
								[
									-150.060732,
									-84.296146
								],
								[
									-150.902928,
									-83.904232
								],
								[
									-153.586201,
									-83.68869
								],
								[
									-153.409907,
									-83.23802
								],
								[
									-153.037759,
									-82.82652
								],
								[
									-152.665637,
									-82.454192
								],
								[
									-152.861517,
									-82.042692
								],
								[
									-154.526299,
									-81.768394
								],
								[
									-155.29018,
									-81.41565
								],
								[
									-156.83745,
									-81.102129
								],
								[
									-154.408787,
									-81.160937
								],
								[
									-152.097662,
									-81.004151
								],
								[
									-150.648293,
									-81.337309
								],
								[
									-148.865998,
									-81.043373
								],
								[
									-147.22075,
									-80.671045
								],
								[
									-146.417749,
									-80.337938
								],
								[
									-146.770286,
									-79.926439
								],
								[
									-148.062947,
									-79.652089
								],
								[
									-149.531901,
									-79.358205
								],
								[
									-151.588416,
									-79.299397
								],
								[
									-153.390322,
									-79.162248
								],
								[
									-155.329376,
									-79.064269
								],
								[
									-155.975668,
									-78.69194
								],
								[
									-157.268302,
									-78.378419
								],
								[
									-158.051768,
									-78.025676
								],
								[
									-158.365134,
									-76.889207
								],
								[
									-157.875474,
									-76.987238
								],
								[
									-156.974573,
									-77.300759
								],
								[
									-155.329376,
									-77.202728
								],
								[
									-153.742832,
									-77.065579
								],
								[
									-152.920247,
									-77.496664
								],
								[
									-151.33378,
									-77.398737
								],
								[
									-150.00195,
									-77.183143
								],
								[
									-148.748486,
									-76.908845
								],
								[
									-147.612483,
									-76.575738
								],
								[
									-146.104409,
									-76.47776
								],
								[
									-146.143528,
									-76.105431
								],
								[
									-146.496091,
									-75.733154
								],
								[
									-146.20231,
									-75.380411
								],
								[
									-144.909624,
									-75.204039
								],
								[
									-144.322037,
									-75.537197
								],
								[
									-142.794353,
									-75.34124
								],
								[
									-141.638764,
									-75.086475
								],
								[
									-140.209007,
									-75.06689
								],
								[
									-138.85759,
									-74.968911
								],
								[
									-137.5062,
									-74.733783
								],
								[
									-136.428901,
									-74.518241
								],
								[
									-135.214583,
									-74.302699
								],
								[
									-134.431194,
									-74.361455
								],
								[
									-133.745654,
									-74.439848
								],
								[
									-132.257168,
									-74.302699
								],
								[
									-130.925311,
									-74.479019
								],
								[
									-129.554284,
									-74.459433
								],
								[
									-128.242038,
									-74.322284
								],
								[
									-126.890622,
									-74.420263
								],
								[
									-125.402082,
									-74.518241
								],
								[
									-124.011496,
									-74.479019
								],
								[
									-122.562152,
									-74.498604
								],
								[
									-121.073613,
									-74.518241
								],
								[
									-119.70256,
									-74.479019
								],
								[
									-118.684145,
									-74.185083
								],
								[
									-117.469801,
									-74.028348
								],
								[
									-116.216312,
									-74.243891
								],
								[
									-115.021552,
									-74.067519
								],
								[
									-113.944331,
									-73.714828
								],
								[
									-113.297988,
									-74.028348
								],
								[
									-112.945452,
									-74.38104
								],
								[
									-112.299083,
									-74.714198
								],
								[
									-111.261059,
									-74.420263
								],
								[
									-110.066325,
									-74.79254
								],
								[
									-108.714909,
									-74.910103
								],
								[
									-107.559346,
									-75.184454
								],
								[
									-106.149148,
									-75.125698
								],
								[
									-104.876074,
									-74.949326
								],
								[
									-103.367949,
									-74.988497
								],
								[
									-102.016507,
									-75.125698
								],
								[
									-100.645531,
									-75.302018
								],
								[
									-100.1167,
									-74.870933
								],
								[
									-100.763043,
									-74.537826
								],
								[
									-101.252703,
									-74.185083
								],
								[
									-102.545337,
									-74.106742
								],
								[
									-103.113313,
									-73.734413
								],
								[
									-103.328752,
									-73.362084
								],
								[
									-103.681289,
									-72.61753
								],
								[
									-102.917485,
									-72.754679
								],
								[
									-101.60524,
									-72.813436
								],
								[
									-100.312528,
									-72.754679
								],
								[
									-99.13738,
									-72.911414
								],
								[
									-98.118889,
									-73.20535
								],
								[
									-97.688037,
									-73.558041
								],
								[
									-96.336595,
									-73.616849
								],
								[
									-95.043961,
									-73.4797
								],
								[
									-93.672907,
									-73.283743
								],
								[
									-92.439003,
									-73.166179
								],
								[
									-91.420564,
									-73.401307
								],
								[
									-90.088733,
									-73.322914
								],
								[
									-89.226951,
									-72.558722
								],
								[
									-88.423951,
									-73.009393
								],
								[
									-87.268337,
									-73.185764
								],
								[
									-86.014822,
									-73.087786
								],
								[
									-85.192236,
									-73.4797
								],
								[
									-83.879991,
									-73.518871
								],
								[
									-82.665646,
									-73.636434
								],
								[
									-81.470913,
									-73.851977
								],
								[
									-80.687447,
									-73.4797
								],
								[
									-80.295791,
									-73.126956
								],
								[
									-79.296886,
									-73.518871
								],
								[
									-77.925858,
									-73.420892
								],
								[
									-76.907367,
									-73.636434
								],
								[
									-76.221879,
									-73.969541
								],
								[
									-74.890049,
									-73.871614
								],
								[
									-73.852024,
									-73.65602
								],
								[
									-72.833533,
									-73.401307
								],
								[
									-71.619215,
									-73.264157
								],
								[
									-70.209042,
									-73.146542
								],
								[
									-68.935916,
									-73.009393
								],
								[
									-67.956622,
									-72.79385
								],
								[
									-67.369061,
									-72.480329
								],
								[
									-67.134036,
									-72.049244
								],
								[
									-67.251548,
									-71.637745
								],
								[
									-67.56494,
									-71.245831
								],
								[
									-67.917477,
									-70.853917
								],
								[
									-68.230843,
									-70.462055
								],
								[
									-68.485452,
									-70.109311
								],
								[
									-68.544209,
									-69.717397
								],
								[
									-68.446282,
									-69.325535
								],
								[
									-67.976233,
									-68.953206
								],
								[
									-67.5845,
									-68.541707
								],
								[
									-67.427843,
									-68.149844
								],
								[
									-67.62367,
									-67.718759
								],
								[
									-67.741183,
									-67.326845
								],
								[
									-67.251548,
									-66.876175
								],
								[
									-66.703184,
									-66.58224
								],
								[
									-66.056815,
									-66.209963
								],
								[
									-65.371327,
									-65.89639
								],
								[
									-64.568276,
									-65.602506
								],
								[
									-64.176542,
									-65.171423
								],
								[
									-63.628152,
									-64.897073
								],
								[
									-63.001394,
									-64.642308
								],
								[
									-62.041686,
									-64.583552
								],
								[
									-61.414928,
									-64.270031
								],
								[
									-60.709855,
									-64.074074
								],
								[
									-59.887269,
									-63.95651
								],
								[
									-59.162585,
									-63.701745
								],
								[
									-58.594557,
									-63.388224
								],
								[
									-57.811143,
									-63.27066
								],
								[
									-57.223582,
									-63.525425
								],
								[
									-57.59573,
									-63.858532
								],
								[
									-58.614143,
									-64.152467
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ATF",
				"properties": {
					"name": "French Southern and Antarctic Lands"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								68.935,
								-48.625
							],
							[
								69.58,
								-48.94
							],
							[
								70.525,
								-49.065
							],
							[
								70.56,
								-49.255
							],
							[
								70.28,
								-49.71
							],
							[
								68.745,
								-49.775
							],
							[
								68.72,
								-49.2425
							],
							[
								68.8675,
								-48.83
							],
							[
								68.935,
								-48.625
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "AUS",
				"properties": {
					"name": "Australia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									145.397978,
									-40.792549
								],
								[
									146.364121,
									-41.137695
								],
								[
									146.908584,
									-41.000546
								],
								[
									147.689259,
									-40.808258
								],
								[
									148.289068,
									-40.875438
								],
								[
									148.359865,
									-42.062445
								],
								[
									148.017301,
									-42.407024
								],
								[
									147.914052,
									-43.211522
								],
								[
									147.564564,
									-42.937689
								],
								[
									146.870343,
									-43.634597
								],
								[
									146.663327,
									-43.580854
								],
								[
									146.048378,
									-43.549745
								],
								[
									145.43193,
									-42.693776
								],
								[
									145.29509,
									-42.03361
								],
								[
									144.718071,
									-41.162552
								],
								[
									144.743755,
									-40.703975
								],
								[
									145.397978,
									-40.792549
								]
							]
						],
						[
							[
								[
									143.561811,
									-13.763656
								],
								[
									143.922099,
									-14.548311
								],
								[
									144.563714,
									-14.171176
								],
								[
									144.894908,
									-14.594458
								],
								[
									145.374724,
									-14.984976
								],
								[
									145.271991,
									-15.428205
								],
								[
									145.48526,
									-16.285672
								],
								[
									145.637033,
									-16.784918
								],
								[
									145.888904,
									-16.906926
								],
								[
									146.160309,
									-17.761655
								],
								[
									146.063674,
									-18.280073
								],
								[
									146.387478,
									-18.958274
								],
								[
									147.471082,
									-19.480723
								],
								[
									148.177602,
									-19.955939
								],
								[
									148.848414,
									-20.39121
								],
								[
									148.717465,
									-20.633469
								],
								[
									149.28942,
									-21.260511
								],
								[
									149.678337,
									-22.342512
								],
								[
									150.077382,
									-22.122784
								],
								[
									150.482939,
									-22.556142
								],
								[
									150.727265,
									-22.402405
								],
								[
									150.899554,
									-23.462237
								],
								[
									151.609175,
									-24.076256
								],
								[
									152.07354,
									-24.457887
								],
								[
									152.855197,
									-25.267501
								],
								[
									153.136162,
									-26.071173
								],
								[
									153.161949,
									-26.641319
								],
								[
									153.092909,
									-27.2603
								],
								[
									153.569469,
									-28.110067
								],
								[
									153.512108,
									-28.995077
								],
								[
									153.339095,
									-29.458202
								],
								[
									153.069241,
									-30.35024
								],
								[
									153.089602,
									-30.923642
								],
								[
									152.891578,
									-31.640446
								],
								[
									152.450002,
									-32.550003
								],
								[
									151.709117,
									-33.041342
								],
								[
									151.343972,
									-33.816023
								],
								[
									151.010555,
									-34.31036
								],
								[
									150.714139,
									-35.17346
								],
								[
									150.32822,
									-35.671879
								],
								[
									150.075212,
									-36.420206
								],
								[
									149.946124,
									-37.109052
								],
								[
									149.997284,
									-37.425261
								],
								[
									149.423882,
									-37.772681
								],
								[
									148.304622,
									-37.809061
								],
								[
									147.381733,
									-38.219217
								],
								[
									146.922123,
									-38.606532
								],
								[
									146.317922,
									-39.035757
								],
								[
									145.489652,
									-38.593768
								],
								[
									144.876976,
									-38.417448
								],
								[
									145.032212,
									-37.896188
								],
								[
									144.485682,
									-38.085324
								],
								[
									143.609974,
									-38.809465
								],
								[
									142.745427,
									-38.538268
								],
								[
									142.17833,
									-38.380034
								],
								[
									141.606582,
									-38.308514
								],
								[
									140.638579,
									-38.019333
								],
								[
									139.992158,
									-37.402936
								],
								[
									139.806588,
									-36.643603
								],
								[
									139.574148,
									-36.138362
								],
								[
									139.082808,
									-35.732754
								],
								[
									138.120748,
									-35.612296
								],
								[
									138.449462,
									-35.127261
								],
								[
									138.207564,
									-34.384723
								],
								[
									137.71917,
									-35.076825
								],
								[
									136.829406,
									-35.260535
								],
								[
									137.352371,
									-34.707339
								],
								[
									137.503886,
									-34.130268
								],
								[
									137.890116,
									-33.640479
								],
								[
									137.810328,
									-32.900007
								],
								[
									136.996837,
									-33.752771
								],
								[
									136.372069,
									-34.094766
								],
								[
									135.989043,
									-34.890118
								],
								[
									135.208213,
									-34.47867
								],
								[
									135.239218,
									-33.947953
								],
								[
									134.613417,
									-33.222778
								],
								[
									134.085904,
									-32.848072
								],
								[
									134.273903,
									-32.617234
								],
								[
									132.990777,
									-32.011224
								],
								[
									132.288081,
									-31.982647
								],
								[
									131.326331,
									-31.495803
								],
								[
									129.535794,
									-31.590423
								],
								[
									128.240938,
									-31.948489
								],
								[
									127.102867,
									-32.282267
								],
								[
									126.148714,
									-32.215966
								],
								[
									125.088623,
									-32.728751
								],
								[
									124.221648,
									-32.959487
								],
								[
									124.028947,
									-33.483847
								],
								[
									123.659667,
									-33.890179
								],
								[
									122.811036,
									-33.914467
								],
								[
									122.183064,
									-34.003402
								],
								[
									121.299191,
									-33.821036
								],
								[
									120.580268,
									-33.930177
								],
								[
									119.893695,
									-33.976065
								],
								[
									119.298899,
									-34.509366
								],
								[
									119.007341,
									-34.464149
								],
								[
									118.505718,
									-34.746819
								],
								[
									118.024972,
									-35.064733
								],
								[
									117.295507,
									-35.025459
								],
								[
									116.625109,
									-35.025097
								],
								[
									115.564347,
									-34.386428
								],
								[
									115.026809,
									-34.196517
								],
								[
									115.048616,
									-33.623425
								],
								[
									115.545123,
									-33.487258
								],
								[
									115.714674,
									-33.259572
								],
								[
									115.679379,
									-32.900369
								],
								[
									115.801645,
									-32.205062
								],
								[
									115.689611,
									-31.612437
								],
								[
									115.160909,
									-30.601594
								],
								[
									114.997043,
									-30.030725
								],
								[
									115.040038,
									-29.461095
								],
								[
									114.641974,
									-28.810231
								],
								[
									114.616498,
									-28.516399
								],
								[
									114.173579,
									-28.118077
								],
								[
									114.048884,
									-27.334765
								],
								[
									113.477498,
									-26.543134
								],
								[
									113.338953,
									-26.116545
								],
								[
									113.778358,
									-26.549025
								],
								[
									113.440962,
									-25.621278
								],
								[
									113.936901,
									-25.911235
								],
								[
									114.232852,
									-26.298446
								],
								[
									114.216161,
									-25.786281
								],
								[
									113.721255,
									-24.998939
								],
								[
									113.625344,
									-24.683971
								],
								[
									113.393523,
									-24.384764
								],
								[
									113.502044,
									-23.80635
								],
								[
									113.706993,
									-23.560215
								],
								[
									113.843418,
									-23.059987
								],
								[
									113.736552,
									-22.475475
								],
								[
									114.149756,
									-21.755881
								],
								[
									114.225307,
									-22.517488
								],
								[
									114.647762,
									-21.82952
								],
								[
									115.460167,
									-21.495173
								],
								[
									115.947373,
									-21.068688
								],
								[
									116.711615,
									-20.701682
								],
								[
									117.166316,
									-20.623599
								],
								[
									117.441545,
									-20.746899
								],
								[
									118.229559,
									-20.374208
								],
								[
									118.836085,
									-20.263311
								],
								[
									118.987807,
									-20.044203
								],
								[
									119.252494,
									-19.952942
								],
								[
									119.805225,
									-19.976506
								],
								[
									120.85622,
									-19.683708
								],
								[
									121.399856,
									-19.239756
								],
								[
									121.655138,
									-18.705318
								],
								[
									122.241665,
									-18.197649
								],
								[
									122.286624,
									-17.798603
								],
								[
									122.312772,
									-17.254967
								],
								[
									123.012574,
									-16.4052
								],
								[
									123.433789,
									-17.268558
								],
								[
									123.859345,
									-17.069035
								],
								[
									123.503242,
									-16.596506
								],
								[
									123.817073,
									-16.111316
								],
								[
									124.258287,
									-16.327944
								],
								[
									124.379726,
									-15.56706
								],
								[
									124.926153,
									-15.0751
								],
								[
									125.167275,
									-14.680396
								],
								[
									125.670087,
									-14.51007
								],
								[
									125.685796,
									-14.230656
								],
								[
									126.125149,
									-14.347341
								],
								[
									126.142823,
									-14.095987
								],
								[
									126.582589,
									-13.952791
								],
								[
									127.065867,
									-13.817968
								],
								[
									127.804633,
									-14.276906
								],
								[
									128.35969,
									-14.86917
								],
								[
									128.985543,
									-14.875991
								],
								[
									129.621473,
									-14.969784
								],
								[
									129.4096,
									-14.42067
								],
								[
									129.888641,
									-13.618703
								],
								[
									130.339466,
									-13.357376
								],
								[
									130.183506,
									-13.10752
								],
								[
									130.617795,
									-12.536392
								],
								[
									131.223495,
									-12.183649
								],
								[
									131.735091,
									-12.302453
								],
								[
									132.575298,
									-12.114041
								],
								[
									132.557212,
									-11.603012
								],
								[
									131.824698,
									-11.273782
								],
								[
									132.357224,
									-11.128519
								],
								[
									133.019561,
									-11.376411
								],
								[
									133.550846,
									-11.786515
								],
								[
									134.393068,
									-12.042365
								],
								[
									134.678632,
									-11.941183
								],
								[
									135.298491,
									-12.248606
								],
								[
									135.882693,
									-11.962267
								],
								[
									136.258381,
									-12.049342
								],
								[
									136.492475,
									-11.857209
								],
								[
									136.95162,
									-12.351959
								],
								[
									136.685125,
									-12.887223
								],
								[
									136.305407,
									-13.29123
								],
								[
									135.961758,
									-13.324509
								],
								[
									136.077617,
									-13.724278
								],
								[
									135.783836,
									-14.223989
								],
								[
									135.428664,
									-14.715432
								],
								[
									135.500184,
									-14.997741
								],
								[
									136.295175,
									-15.550265
								],
								[
									137.06536,
									-15.870762
								],
								[
									137.580471,
									-16.215082
								],
								[
									138.303217,
									-16.807604
								],
								[
									138.585164,
									-16.806622
								],
								[
									139.108543,
									-17.062679
								],
								[
									139.260575,
									-17.371601
								],
								[
									140.215245,
									-17.710805
								],
								[
									140.875463,
									-17.369069
								],
								[
									141.07111,
									-16.832047
								],
								[
									141.274095,
									-16.38887
								],
								[
									141.398222,
									-15.840532
								],
								[
									141.702183,
									-15.044921
								],
								[
									141.56338,
									-14.561333
								],
								[
									141.63552,
									-14.270395
								],
								[
									141.519869,
									-13.698078
								],
								[
									141.65092,
									-12.944688
								],
								[
									141.842691,
									-12.741548
								],
								[
									141.68699,
									-12.407614
								],
								[
									141.928629,
									-11.877466
								],
								[
									142.118488,
									-11.328042
								],
								[
									142.143706,
									-11.042737
								],
								[
									142.51526,
									-10.668186
								],
								[
									142.79731,
									-11.157355
								],
								[
									142.866763,
									-11.784707
								],
								[
									143.115947,
									-11.90563
								],
								[
									143.158632,
									-12.325656
								],
								[
									143.522124,
									-12.834358
								],
								[
									143.597158,
									-13.400422
								],
								[
									143.561811,
									-13.763656
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "AUT",
				"properties": {
					"name": "Austria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.979667,
								48.123497
							],
							[
								16.903754,
								47.714866
							],
							[
								16.340584,
								47.712902
							],
							[
								16.534268,
								47.496171
							],
							[
								16.202298,
								46.852386
							],
							[
								16.011664,
								46.683611
							],
							[
								15.137092,
								46.658703
							],
							[
								14.632472,
								46.431817
							],
							[
								13.806475,
								46.509306
							],
							[
								12.376485,
								46.767559
							],
							[
								12.153088,
								47.115393
							],
							[
								11.164828,
								46.941579
							],
							[
								11.048556,
								46.751359
							],
							[
								10.442701,
								46.893546
							],
							[
								9.932448,
								46.920728
							],
							[
								9.47997,
								47.10281
							],
							[
								9.632932,
								47.347601
							],
							[
								9.594226,
								47.525058
							],
							[
								9.896068,
								47.580197
							],
							[
								10.402084,
								47.302488
							],
							[
								10.544504,
								47.566399
							],
							[
								11.426414,
								47.523766
							],
							[
								12.141357,
								47.703083
							],
							[
								12.62076,
								47.672388
							],
							[
								12.932627,
								47.467646
							],
							[
								13.025851,
								47.637584
							],
							[
								12.884103,
								48.289146
							],
							[
								13.243357,
								48.416115
							],
							[
								13.595946,
								48.877172
							],
							[
								14.338898,
								48.555305
							],
							[
								14.901447,
								48.964402
							],
							[
								15.253416,
								49.039074
							],
							[
								16.029647,
								48.733899
							],
							[
								16.499283,
								48.785808
							],
							[
								16.960288,
								48.596982
							],
							[
								16.879983,
								48.470013
							],
							[
								16.979667,
								48.123497
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "AZE",
				"properties": {
					"name": "Azerbaijan"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									45.001987,
									39.740004
								],
								[
									45.298145,
									39.471751
								],
								[
									45.739978,
									39.473999
								],
								[
									45.735379,
									39.319719
								],
								[
									46.143623,
									38.741201
								],
								[
									45.457722,
									38.874139
								],
								[
									44.952688,
									39.335765
								],
								[
									44.79399,
									39.713003
								],
								[
									45.001987,
									39.740004
								]
							]
						],
						[
							[
								[
									47.373315,
									41.219732
								],
								[
									47.815666,
									41.151416
								],
								[
									47.987283,
									41.405819
								],
								[
									48.584353,
									41.80887
								],
								[
									49.110264,
									41.282287
								],
								[
									49.618915,
									40.572924
								],
								[
									50.08483,
									40.526157
								],
								[
									50.392821,
									40.256561
								],
								[
									49.569202,
									40.176101
								],
								[
									49.395259,
									39.399482
								],
								[
									49.223228,
									39.049219
								],
								[
									48.856532,
									38.815486
								],
								[
									48.883249,
									38.320245
								],
								[
									48.634375,
									38.270378
								],
								[
									48.010744,
									38.794015
								],
								[
									48.355529,
									39.288765
								],
								[
									48.060095,
									39.582235
								],
								[
									47.685079,
									39.508364
								],
								[
									46.50572,
									38.770605
								],
								[
									46.483499,
									39.464155
								],
								[
									46.034534,
									39.628021
								],
								[
									45.610012,
									39.899994
								],
								[
									45.891907,
									40.218476
								],
								[
									45.359175,
									40.561504
								],
								[
									45.560351,
									40.81229
								],
								[
									45.179496,
									40.985354
								],
								[
									44.97248,
									41.248129
								],
								[
									45.217426,
									41.411452
								],
								[
									45.962601,
									41.123873
								],
								[
									46.501637,
									41.064445
								],
								[
									46.637908,
									41.181673
								],
								[
									46.145432,
									41.722802
								],
								[
									46.404951,
									41.860675
								],
								[
									46.686071,
									41.827137
								],
								[
									47.373315,
									41.219732
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BDI",
				"properties": {
					"name": "Burundi"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								29.339998,
								-4.499983
							],
							[
								29.276384,
								-3.293907
							],
							[
								29.024926,
								-2.839258
							],
							[
								29.632176,
								-2.917858
							],
							[
								29.938359,
								-2.348487
							],
							[
								30.469696,
								-2.413858
							],
							[
								30.527677,
								-2.807632
							],
							[
								30.743013,
								-3.034285
							],
							[
								30.752263,
								-3.35933
							],
							[
								30.50556,
								-3.568567
							],
							[
								30.116333,
								-4.090138
							],
							[
								29.753512,
								-4.452389
							],
							[
								29.339998,
								-4.499983
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BEL",
				"properties": {
					"name": "Belgium"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								3.314971,
								51.345781
							],
							[
								4.047071,
								51.267259
							],
							[
								4.973991,
								51.475024
							],
							[
								5.606976,
								51.037298
							],
							[
								6.156658,
								50.803721
							],
							[
								6.043073,
								50.128052
							],
							[
								5.782417,
								50.090328
							],
							[
								5.674052,
								49.529484
							],
							[
								4.799222,
								49.985373
							],
							[
								4.286023,
								49.907497
							],
							[
								3.588184,
								50.378992
							],
							[
								3.123252,
								50.780363
							],
							[
								2.658422,
								50.796848
							],
							[
								2.513573,
								51.148506
							],
							[
								3.314971,
								51.345781
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BEN",
				"properties": {
					"name": "Benin"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2.691702,
								6.258817
							],
							[
								1.865241,
								6.142158
							],
							[
								1.618951,
								6.832038
							],
							[
								1.664478,
								9.12859
							],
							[
								1.463043,
								9.334624
							],
							[
								1.425061,
								9.825395
							],
							[
								1.077795,
								10.175607
							],
							[
								0.772336,
								10.470808
							],
							[
								0.899563,
								10.997339
							],
							[
								1.24347,
								11.110511
							],
							[
								1.447178,
								11.547719
							],
							[
								1.935986,
								11.64115
							],
							[
								2.154474,
								11.94015
							],
							[
								2.490164,
								12.233052
							],
							[
								2.848643,
								12.235636
							],
							[
								3.61118,
								11.660167
							],
							[
								3.572216,
								11.327939
							],
							[
								3.797112,
								10.734746
							],
							[
								3.60007,
								10.332186
							],
							[
								3.705438,
								10.06321
							],
							[
								3.220352,
								9.444153
							],
							[
								2.912308,
								9.137608
							],
							[
								2.723793,
								8.506845
							],
							[
								2.749063,
								7.870734
							],
							[
								2.691702,
								6.258817
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BFA",
				"properties": {
					"name": "Burkina Faso"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-2.827496,
								9.642461
							],
							[
								-3.511899,
								9.900326
							],
							[
								-3.980449,
								9.862344
							],
							[
								-4.330247,
								9.610835
							],
							[
								-4.779884,
								9.821985
							],
							[
								-4.954653,
								10.152714
							],
							[
								-5.404342,
								10.370737
							],
							[
								-5.470565,
								10.95127
							],
							[
								-5.197843,
								11.375146
							],
							[
								-5.220942,
								11.713859
							],
							[
								-4.427166,
								12.542646
							],
							[
								-4.280405,
								13.228444
							],
							[
								-4.006391,
								13.472485
							],
							[
								-3.522803,
								13.337662
							],
							[
								-3.103707,
								13.541267
							],
							[
								-2.967694,
								13.79815
							],
							[
								-2.191825,
								14.246418
							],
							[
								-2.001035,
								14.559008
							],
							[
								-1.066363,
								14.973815
							],
							[
								-0.515854,
								15.116158
							],
							[
								-0.266257,
								14.924309
							],
							[
								0.374892,
								14.928908
							],
							[
								0.295646,
								14.444235
							],
							[
								0.429928,
								13.988733
							],
							[
								0.993046,
								13.33575
							],
							[
								1.024103,
								12.851826
							],
							[
								2.177108,
								12.625018
							],
							[
								2.154474,
								11.94015
							],
							[
								1.935986,
								11.64115
							],
							[
								1.447178,
								11.547719
							],
							[
								1.24347,
								11.110511
							],
							[
								0.899563,
								10.997339
							],
							[
								0.023803,
								11.018682
							],
							[
								-0.438702,
								11.098341
							],
							[
								-0.761576,
								10.93693
							],
							[
								-1.203358,
								11.009819
							],
							[
								-2.940409,
								10.96269
							],
							[
								-2.963896,
								10.395335
							],
							[
								-2.827496,
								9.642461
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BGD",
				"properties": {
					"name": "Bangladesh"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								92.672721,
								22.041239
							],
							[
								92.652257,
								21.324048
							],
							[
								92.303234,
								21.475485
							],
							[
								92.368554,
								20.670883
							],
							[
								92.082886,
								21.192195
							],
							[
								92.025215,
								21.70157
							],
							[
								91.834891,
								22.182936
							],
							[
								91.417087,
								22.765019
							],
							[
								90.496006,
								22.805017
							],
							[
								90.586957,
								22.392794
							],
							[
								90.272971,
								21.836368
							],
							[
								89.847467,
								22.039146
							],
							[
								89.70205,
								21.857116
							],
							[
								89.418863,
								21.966179
							],
							[
								89.031961,
								22.055708
							],
							[
								88.876312,
								22.879146
							],
							[
								88.52977,
								23.631142
							],
							[
								88.69994,
								24.233715
							],
							[
								88.084422,
								24.501657
							],
							[
								88.306373,
								24.866079
							],
							[
								88.931554,
								25.238692
							],
							[
								88.209789,
								25.768066
							],
							[
								88.563049,
								26.446526
							],
							[
								89.355094,
								26.014407
							],
							[
								89.832481,
								25.965082
							],
							[
								89.920693,
								25.26975
							],
							[
								90.872211,
								25.132601
							],
							[
								91.799596,
								25.147432
							],
							[
								92.376202,
								24.976693
							],
							[
								91.915093,
								24.130414
							],
							[
								91.46773,
								24.072639
							],
							[
								91.158963,
								23.503527
							],
							[
								91.706475,
								22.985264
							],
							[
								91.869928,
								23.624346
							],
							[
								92.146035,
								23.627499
							],
							[
								92.672721,
								22.041239
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BGR",
				"properties": {
					"name": "Bulgaria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								22.65715,
								44.234923
							],
							[
								22.944832,
								43.823785
							],
							[
								23.332302,
								43.897011
							],
							[
								24.100679,
								43.741051
							],
							[
								25.569272,
								43.688445
							],
							[
								26.065159,
								43.943494
							],
							[
								27.2424,
								44.175986
							],
							[
								27.970107,
								43.812468
							],
							[
								28.558081,
								43.707462
							],
							[
								28.039095,
								43.293172
							],
							[
								27.673898,
								42.577892
							],
							[
								27.99672,
								42.007359
							],
							[
								27.135739,
								42.141485
							],
							[
								26.117042,
								41.826905
							],
							[
								26.106138,
								41.328899
							],
							[
								25.197201,
								41.234486
							],
							[
								24.492645,
								41.583896
							],
							[
								23.692074,
								41.309081
							],
							[
								22.952377,
								41.337994
							],
							[
								22.881374,
								41.999297
							],
							[
								22.380526,
								42.32026
							],
							[
								22.545012,
								42.461362
							],
							[
								22.436595,
								42.580321
							],
							[
								22.604801,
								42.898519
							],
							[
								22.986019,
								43.211161
							],
							[
								22.500157,
								43.642814
							],
							[
								22.410446,
								44.008063
							],
							[
								22.65715,
								44.234923
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BHS",
				"properties": {
					"name": "The Bahamas"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-77.53466,
									23.75975
								],
								[
									-77.78,
									23.71
								],
								[
									-78.03405,
									24.28615
								],
								[
									-78.40848,
									24.57564
								],
								[
									-78.19087,
									25.2103
								],
								[
									-77.89,
									25.17
								],
								[
									-77.54,
									24.34
								],
								[
									-77.53466,
									23.75975
								]
							]
						],
						[
							[
								[
									-77.82,
									26.58
								],
								[
									-78.91,
									26.42
								],
								[
									-78.98,
									26.79
								],
								[
									-78.51,
									26.87
								],
								[
									-77.85,
									26.84
								],
								[
									-77.82,
									26.58
								]
							]
						],
						[
							[
								[
									-77,
									26.59
								],
								[
									-77.17255,
									25.87918
								],
								[
									-77.35641,
									26.00735
								],
								[
									-77.34,
									26.53
								],
								[
									-77.78802,
									26.92516
								],
								[
									-77.79,
									27.04
								],
								[
									-77,
									26.59
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BIH",
				"properties": {
					"name": "Bosnia and Herzegovina"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								19.005486,
								44.860234
							],
							[
								19.36803,
								44.863
							],
							[
								19.11761,
								44.42307
							],
							[
								19.59976,
								44.03847
							],
							[
								19.454,
								43.5681
							],
							[
								19.21852,
								43.52384
							],
							[
								19.03165,
								43.43253
							],
							[
								18.70648,
								43.20011
							],
							[
								18.56,
								42.65
							],
							[
								17.674922,
								43.028563
							],
							[
								17.297373,
								43.446341
							],
							[
								16.916156,
								43.667722
							],
							[
								16.456443,
								44.04124
							],
							[
								16.23966,
								44.351143
							],
							[
								15.750026,
								44.818712
							],
							[
								15.959367,
								45.233777
							],
							[
								16.318157,
								45.004127
							],
							[
								16.534939,
								45.211608
							],
							[
								17.002146,
								45.233777
							],
							[
								17.861783,
								45.06774
							],
							[
								18.553214,
								45.08159
							],
							[
								19.005486,
								44.860234
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BLR",
				"properties": {
					"name": "Belarus"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								23.484128,
								53.912498
							],
							[
								24.450684,
								53.905702
							],
							[
								25.536354,
								54.282423
							],
							[
								25.768433,
								54.846963
							],
							[
								26.588279,
								55.167176
							],
							[
								26.494331,
								55.615107
							],
							[
								27.10246,
								55.783314
							],
							[
								28.176709,
								56.16913
							],
							[
								29.229513,
								55.918344
							],
							[
								29.371572,
								55.670091
							],
							[
								29.896294,
								55.789463
							],
							[
								30.873909,
								55.550976
							],
							[
								30.971836,
								55.081548
							],
							[
								30.757534,
								54.811771
							],
							[
								31.384472,
								54.157056
							],
							[
								31.791424,
								53.974639
							],
							[
								31.731273,
								53.794029
							],
							[
								32.405599,
								53.618045
							],
							[
								32.693643,
								53.351421
							],
							[
								32.304519,
								53.132726
							],
							[
								31.497644,
								53.167427
							],
							[
								31.305201,
								53.073996
							],
							[
								31.540018,
								52.742052
							],
							[
								31.785998,
								52.101678
							],
							[
								30.927549,
								52.042353
							],
							[
								30.619454,
								51.822806
							],
							[
								30.555117,
								51.319503
							],
							[
								30.157364,
								51.416138
							],
							[
								29.254938,
								51.368234
							],
							[
								28.992835,
								51.602044
							],
							[
								28.617613,
								51.427714
							],
							[
								28.241615,
								51.572227
							],
							[
								27.454066,
								51.592303
							],
							[
								26.337959,
								51.832289
							],
							[
								25.327788,
								51.910656
							],
							[
								24.553106,
								51.888461
							],
							[
								24.005078,
								51.617444
							],
							[
								23.527071,
								51.578454
							],
							[
								23.508002,
								52.023647
							],
							[
								23.199494,
								52.486977
							],
							[
								23.799199,
								52.691099
							],
							[
								23.804935,
								53.089731
							],
							[
								23.527536,
								53.470122
							],
							[
								23.484128,
								53.912498
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BLZ",
				"properties": {
					"name": "Belize"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-89.14308,
								17.808319
							],
							[
								-89.150909,
								17.955468
							],
							[
								-89.029857,
								18.001511
							],
							[
								-88.848344,
								17.883198
							],
							[
								-88.490123,
								18.486831
							],
							[
								-88.300031,
								18.499982
							],
							[
								-88.296336,
								18.353273
							],
							[
								-88.106813,
								18.348674
							],
							[
								-88.123479,
								18.076675
							],
							[
								-88.285355,
								17.644143
							],
							[
								-88.197867,
								17.489475
							],
							[
								-88.302641,
								17.131694
							],
							[
								-88.239518,
								17.036066
							],
							[
								-88.355428,
								16.530774
							],
							[
								-88.551825,
								16.265467
							],
							[
								-88.732434,
								16.233635
							],
							[
								-88.930613,
								15.887273
							],
							[
								-89.229122,
								15.886938
							],
							[
								-89.150806,
								17.015577
							],
							[
								-89.14308,
								17.808319
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BMU",
				"properties": {
					"name": "Bermuda"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-64.7799734332998,
								32.3072000581802
							],
							[
								-64.7873319183061,
								32.3039237143428
							],
							[
								-64.7946942710173,
								32.3032682700388
							],
							[
								-64.8094297981283,
								32.3098175728414
							],
							[
								-64.8167896352437,
								32.3058845718466
							],
							[
								-64.8101968029642,
								32.3022833180511
							],
							[
								-64.7962291465484,
								32.2934409732427
							],
							[
								-64.7815086336978,
								32.2868973114514
							],
							[
								-64.7997025513437,
								32.2796896417328
							],
							[
								-64.8066707691087,
								32.2747767569465
							],
							[
								-64.8225587873683,
								32.2669111289395
							],
							[
								-64.8287548840306,
								32.2669075473817
							],
							[
								-64.8306732143498,
								32.2583944840235
							],
							[
								-64.8399924854972,
								32.254782282336
							],
							[
								-64.8566090462354,
								32.2547740387514
							],
							[
								-64.8682296789446,
								32.2616393614322
							],
							[
								-64.8628241459563,
								32.2724481933959
							],
							[
								-64.8748651338951,
								32.2757120264753
							],
							[
								-64.8717752856644,
								32.2819371582026
							],
							[
								-64.8671422127295,
								32.2930760547989
							],
							[
								-64.8559068764437,
								32.2960321186471
							],
							[
								-64.8597429072279,
								32.3015842021933
							],
							[
								-64.8439233486717,
								32.3140553852543
							],
							[
								-64.8350242329311,
								32.3242161760006
							],
							[
								-64.8338690593672,
								32.3294587561557
							],
							[
								-64.8520298651164,
								32.3110911879954
							],
							[
								-64.8635922932573,
								32.3048469433363
							],
							[
								-64.8686668994079,
								32.30910745083
							],
							[
								-64.8721354593415,
								32.3041908606301
							],
							[
								-64.8779667328485,
								32.3038632800462
							],
							[
								-64.8780046844321,
								32.2907757831692
							],
							[
								-64.8849776658292,
								32.2819261366004
							],
							[
								-64.8783230004629,
								32.2613001418681
							],
							[
								-64.863194968877,
								32.2465799485801
							],
							[
								-64.8519819555722,
								32.2485519134663
							],
							[
								-64.842311980074,
								32.2492123317296
							],
							[
								-64.8388242605209,
								32.2475773472534
							],
							[
								-64.8334002575532,
								32.2462714714698
							],
							[
								-64.8256389530584,
								32.2472637398594
							],
							[
								-64.8205697556026,
								32.2531698880328
							],
							[
								-64.8105087275579,
								32.2561208974156
							],
							[
								-64.7900177727338,
								32.2659446936992
							],
							[
								-64.7745415970416,
								32.2718413023427
							],
							[
								-64.7644742436426,
								32.2855931353214
							],
							[
								-64.7551803442276,
								32.2908326702531
							],
							[
								-64.7423982971436,
								32.2996734994024
							],
							[
								-64.7206991797682,
								32.3137542201258
							],
							[
								-64.7117851247134,
								32.3176823360806
							],
							[
								-64.6962778813133,
								32.3275029115532
							],
							[
								-64.6768921127452,
								32.3324095397555
							],
							[
								-64.6567136927777,
								32.3451776458469
							],
							[
								-64.6532168823499,
								32.3494356627941
							],
							[
								-64.6605720384429,
								32.3589423487763
							],
							[
								-64.65125819471,
								32.3615600906466
							],
							[
								-64.6462011670816,
								32.36975169749
							],
							[
								-64.6613227512832,
								32.3763135008721
							],
							[
								-64.6690666074397,
								32.388444543924
							],
							[
								-64.6834270548595,
								32.3854968316788
							],
							[
								-64.6954617672714,
								32.3763221285869
							],
							[
								-64.70438689565,
								32.3704254760469
							],
							[
								-64.7117569982798,
								32.368132600249
							],
							[
								-64.7061764744404,
								32.3600110593559
							],
							[
								-64.700531552697,
								32.3590601356818
							],
							[
								-64.6940348033967,
								32.3640708659835
							],
							[
								-64.6895164826082,
								32.3633598579866
							],
							[
								-64.6864150099255,
								32.3547797587266
							],
							[
								-64.6824635995504,
								32.3540628176846
							],
							[
								-64.6835876652835,
								32.3626447677968
							],
							[
								-64.6801998697415,
								32.3631199096979
							],
							[
								-64.6672170444687,
								32.3597751617473
							],
							[
								-64.6598811264978,
								32.3497625771755
							],
							[
								-64.6737331235384,
								32.3390281851635
							],
							[
								-64.6887090648183,
								32.3342439408053
							],
							[
								-64.706732854446,
								32.3429010723036
							],
							[
								-64.7149301576112,
								32.3552188753513
							],
							[
								-64.7185967666669,
								32.3552239212394
							],
							[
								-64.7214189847314,
								32.3518830231342
							],
							[
								-64.7270616067222,
								32.3466461715475
							],
							[
								-64.734962460882,
								32.3442819830499
							],
							[
								-64.7383521549094,
								32.3407216514918
							],
							[
								-64.7411729976333,
								32.3311790864627
							],
							[
								-64.7423019216485,
								32.323311561213
							],
							[
								-64.7462482354281,
								32.318538611581
							],
							[
								-64.7566773739613,
								32.3130509130175
							],
							[
								-64.768738200563,
								32.3088369816572
							],
							[
								-64.7799734332998,
								32.3072000581802
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BOL",
				"properties": {
					"name": "Bolivia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-62.846468,
								-22.034985
							],
							[
								-63.986838,
								-21.993644
							],
							[
								-64.377021,
								-22.798091
							],
							[
								-64.964892,
								-22.075862
							],
							[
								-66.273339,
								-21.83231
							],
							[
								-67.106674,
								-22.735925
							],
							[
								-67.82818,
								-22.872919
							],
							[
								-68.219913,
								-21.494347
							],
							[
								-68.757167,
								-20.372658
							],
							[
								-68.442225,
								-19.405068
							],
							[
								-68.966818,
								-18.981683
							],
							[
								-69.100247,
								-18.260125
							],
							[
								-69.590424,
								-17.580012
							],
							[
								-68.959635,
								-16.500698
							],
							[
								-69.389764,
								-15.660129
							],
							[
								-69.160347,
								-15.323974
							],
							[
								-69.339535,
								-14.953195
							],
							[
								-68.948887,
								-14.453639
							],
							[
								-68.929224,
								-13.602684
							],
							[
								-68.88008,
								-12.899729
							],
							[
								-68.66508,
								-12.5613
							],
							[
								-69.529678,
								-10.951734
							],
							[
								-68.786158,
								-11.03638
							],
							[
								-68.271254,
								-11.014521
							],
							[
								-68.048192,
								-10.712059
							],
							[
								-67.173801,
								-10.306812
							],
							[
								-66.646908,
								-9.931331
							],
							[
								-65.338435,
								-9.761988
							],
							[
								-65.444837,
								-10.511451
							],
							[
								-65.321899,
								-10.895872
							],
							[
								-65.402281,
								-11.56627
							],
							[
								-64.316353,
								-12.461978
							],
							[
								-63.196499,
								-12.627033
							],
							[
								-62.80306,
								-13.000653
							],
							[
								-62.127081,
								-13.198781
							],
							[
								-61.713204,
								-13.489202
							],
							[
								-61.084121,
								-13.479384
							],
							[
								-60.503304,
								-13.775955
							],
							[
								-60.459198,
								-14.354007
							],
							[
								-60.264326,
								-14.645979
							],
							[
								-60.251149,
								-15.077219
							],
							[
								-60.542966,
								-15.09391
							],
							[
								-60.15839,
								-16.258284
							],
							[
								-58.24122,
								-16.299573
							],
							[
								-58.388058,
								-16.877109
							],
							[
								-58.280804,
								-17.27171
							],
							[
								-57.734558,
								-17.552468
							],
							[
								-57.498371,
								-18.174188
							],
							[
								-57.676009,
								-18.96184
							],
							[
								-57.949997,
								-19.400004
							],
							[
								-57.853802,
								-19.969995
							],
							[
								-58.166392,
								-20.176701
							],
							[
								-58.183471,
								-19.868399
							],
							[
								-59.115042,
								-19.356906
							],
							[
								-60.043565,
								-19.342747
							],
							[
								-61.786326,
								-19.633737
							],
							[
								-62.265961,
								-20.513735
							],
							[
								-62.291179,
								-21.051635
							],
							[
								-62.685057,
								-22.249029
							],
							[
								-62.846468,
								-22.034985
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BRA",
				"properties": {
					"name": "Brazil"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-57.625133,
								-30.216295
							],
							[
								-56.2909,
								-28.852761
							],
							[
								-55.162286,
								-27.881915
							],
							[
								-54.490725,
								-27.474757
							],
							[
								-53.648735,
								-26.923473
							],
							[
								-53.628349,
								-26.124865
							],
							[
								-54.13005,
								-25.547639
							],
							[
								-54.625291,
								-25.739255
							],
							[
								-54.428946,
								-25.162185
							],
							[
								-54.293476,
								-24.5708
							],
							[
								-54.29296,
								-24.021014
							],
							[
								-54.652834,
								-23.839578
							],
							[
								-55.027902,
								-24.001274
							],
							[
								-55.400747,
								-23.956935
							],
							[
								-55.517639,
								-23.571998
							],
							[
								-55.610683,
								-22.655619
							],
							[
								-55.797958,
								-22.35693
							],
							[
								-56.473317,
								-22.0863
							],
							[
								-56.88151,
								-22.282154
							],
							[
								-57.937156,
								-22.090176
							],
							[
								-57.870674,
								-20.732688
							],
							[
								-58.166392,
								-20.176701
							],
							[
								-57.853802,
								-19.969995
							],
							[
								-57.949997,
								-19.400004
							],
							[
								-57.676009,
								-18.96184
							],
							[
								-57.498371,
								-18.174188
							],
							[
								-57.734558,
								-17.552468
							],
							[
								-58.280804,
								-17.27171
							],
							[
								-58.388058,
								-16.877109
							],
							[
								-58.24122,
								-16.299573
							],
							[
								-60.15839,
								-16.258284
							],
							[
								-60.542966,
								-15.09391
							],
							[
								-60.251149,
								-15.077219
							],
							[
								-60.264326,
								-14.645979
							],
							[
								-60.459198,
								-14.354007
							],
							[
								-60.503304,
								-13.775955
							],
							[
								-61.084121,
								-13.479384
							],
							[
								-61.713204,
								-13.489202
							],
							[
								-62.127081,
								-13.198781
							],
							[
								-62.80306,
								-13.000653
							],
							[
								-63.196499,
								-12.627033
							],
							[
								-64.316353,
								-12.461978
							],
							[
								-65.402281,
								-11.56627
							],
							[
								-65.321899,
								-10.895872
							],
							[
								-65.444837,
								-10.511451
							],
							[
								-65.338435,
								-9.761988
							],
							[
								-66.646908,
								-9.931331
							],
							[
								-67.173801,
								-10.306812
							],
							[
								-68.048192,
								-10.712059
							],
							[
								-68.271254,
								-11.014521
							],
							[
								-68.786158,
								-11.03638
							],
							[
								-69.529678,
								-10.951734
							],
							[
								-70.093752,
								-11.123972
							],
							[
								-70.548686,
								-11.009147
							],
							[
								-70.481894,
								-9.490118
							],
							[
								-71.302412,
								-10.079436
							],
							[
								-72.184891,
								-10.053598
							],
							[
								-72.563033,
								-9.520194
							],
							[
								-73.226713,
								-9.462213
							],
							[
								-73.015383,
								-9.032833
							],
							[
								-73.571059,
								-8.424447
							],
							[
								-73.987235,
								-7.52383
							],
							[
								-73.723401,
								-7.340999
							],
							[
								-73.724487,
								-6.918595
							],
							[
								-73.120027,
								-6.629931
							],
							[
								-73.219711,
								-6.089189
							],
							[
								-72.964507,
								-5.741251
							],
							[
								-72.891928,
								-5.274561
							],
							[
								-71.748406,
								-4.593983
							],
							[
								-70.928843,
								-4.401591
							],
							[
								-70.794769,
								-4.251265
							],
							[
								-69.893635,
								-4.298187
							],
							[
								-69.444102,
								-1.556287
							],
							[
								-69.420486,
								-1.122619
							],
							[
								-69.577065,
								-0.549992
							],
							[
								-70.020656,
								-0.185156
							],
							[
								-70.015566,
								0.541414
							],
							[
								-69.452396,
								0.706159
							],
							[
								-69.252434,
								0.602651
							],
							[
								-69.218638,
								0.985677
							],
							[
								-69.804597,
								1.089081
							],
							[
								-69.816973,
								1.714805
							],
							[
								-67.868565,
								1.692455
							],
							[
								-67.53781,
								2.037163
							],
							[
								-67.259998,
								1.719999
							],
							[
								-67.065048,
								1.130112
							],
							[
								-66.876326,
								1.253361
							],
							[
								-66.325765,
								0.724452
							],
							[
								-65.548267,
								0.789254
							],
							[
								-65.354713,
								1.095282
							],
							[
								-64.611012,
								1.328731
							],
							[
								-64.199306,
								1.492855
							],
							[
								-64.083085,
								1.916369
							],
							[
								-63.368788,
								2.2009
							],
							[
								-63.422867,
								2.411068
							],
							[
								-64.269999,
								2.497006
							],
							[
								-64.408828,
								3.126786
							],
							[
								-64.368494,
								3.79721
							],
							[
								-64.816064,
								4.056445
							],
							[
								-64.628659,
								4.148481
							],
							[
								-63.888343,
								4.02053
							],
							[
								-63.093198,
								3.770571
							],
							[
								-62.804533,
								4.006965
							],
							[
								-62.08543,
								4.162124
							],
							[
								-60.966893,
								4.536468
							],
							[
								-60.601179,
								4.918098
							],
							[
								-60.733574,
								5.200277
							],
							[
								-60.213683,
								5.244486
							],
							[
								-59.980959,
								5.014061
							],
							[
								-60.111002,
								4.574967
							],
							[
								-59.767406,
								4.423503
							],
							[
								-59.53804,
								3.958803
							],
							[
								-59.815413,
								3.606499
							],
							[
								-59.974525,
								2.755233
							],
							[
								-59.718546,
								2.24963
							],
							[
								-59.646044,
								1.786894
							],
							[
								-59.030862,
								1.317698
							],
							[
								-58.540013,
								1.268088
							],
							[
								-58.429477,
								1.463942
							],
							[
								-58.11345,
								1.507195
							],
							[
								-57.660971,
								1.682585
							],
							[
								-57.335823,
								1.948538
							],
							[
								-56.782704,
								1.863711
							],
							[
								-56.539386,
								1.899523
							],
							[
								-55.995698,
								1.817667
							],
							[
								-55.9056,
								2.021996
							],
							[
								-56.073342,
								2.220795
							],
							[
								-55.973322,
								2.510364
							],
							[
								-55.569755,
								2.421506
							],
							[
								-55.097587,
								2.523748
							],
							[
								-54.524754,
								2.311849
							],
							[
								-54.088063,
								2.105557
							],
							[
								-53.778521,
								2.376703
							],
							[
								-53.554839,
								2.334897
							],
							[
								-53.418465,
								2.053389
							],
							[
								-52.939657,
								2.124858
							],
							[
								-52.556425,
								2.504705
							],
							[
								-52.249338,
								3.241094
							],
							[
								-51.657797,
								4.156232
							],
							[
								-51.317146,
								4.203491
							],
							[
								-51.069771,
								3.650398
							],
							[
								-50.508875,
								1.901564
							],
							[
								-49.974076,
								1.736483
							],
							[
								-49.947101,
								1.04619
							],
							[
								-50.699251,
								0.222984
							],
							[
								-50.388211,
								-0.078445
							],
							[
								-48.620567,
								-0.235489
							],
							[
								-48.584497,
								-1.237805
							],
							[
								-47.824956,
								-0.581618
							],
							[
								-46.566584,
								-0.941028
							],
							[
								-44.905703,
								-1.55174
							],
							[
								-44.417619,
								-2.13775
							],
							[
								-44.581589,
								-2.691308
							],
							[
								-43.418791,
								-2.38311
							],
							[
								-41.472657,
								-2.912018
							],
							[
								-39.978665,
								-2.873054
							],
							[
								-38.500383,
								-3.700652
							],
							[
								-37.223252,
								-4.820946
							],
							[
								-36.452937,
								-5.109404
							],
							[
								-35.597796,
								-5.149504
							],
							[
								-35.235389,
								-5.464937
							],
							[
								-34.89603,
								-6.738193
							],
							[
								-34.729993,
								-7.343221
							],
							[
								-35.128212,
								-8.996401
							],
							[
								-35.636967,
								-9.649282
							],
							[
								-37.046519,
								-11.040721
							],
							[
								-37.683612,
								-12.171195
							],
							[
								-38.423877,
								-13.038119
							],
							[
								-38.673887,
								-13.057652
							],
							[
								-38.953276,
								-13.79337
							],
							[
								-38.882298,
								-15.667054
							],
							[
								-39.161092,
								-17.208407
							],
							[
								-39.267339,
								-17.867746
							],
							[
								-39.583521,
								-18.262296
							],
							[
								-39.760823,
								-19.599113
							],
							[
								-40.774741,
								-20.904512
							],
							[
								-40.944756,
								-21.937317
							],
							[
								-41.754164,
								-22.370676
							],
							[
								-41.988284,
								-22.97007
							],
							[
								-43.074704,
								-22.967693
							],
							[
								-44.647812,
								-23.351959
							],
							[
								-45.352136,
								-23.796842
							],
							[
								-46.472093,
								-24.088969
							],
							[
								-47.648972,
								-24.885199
							],
							[
								-48.495458,
								-25.877025
							],
							[
								-48.641005,
								-26.623698
							],
							[
								-48.474736,
								-27.175912
							],
							[
								-48.66152,
								-28.186135
							],
							[
								-48.888457,
								-28.674115
							],
							[
								-49.587329,
								-29.224469
							],
							[
								-50.696874,
								-30.984465
							],
							[
								-51.576226,
								-31.777698
							],
							[
								-52.256081,
								-32.24537
							],
							[
								-52.7121,
								-33.196578
							],
							[
								-53.373662,
								-33.768378
							],
							[
								-53.650544,
								-33.202004
							],
							[
								-53.209589,
								-32.727666
							],
							[
								-53.787952,
								-32.047243
							],
							[
								-54.572452,
								-31.494511
							],
							[
								-55.60151,
								-30.853879
							],
							[
								-55.973245,
								-30.883076
							],
							[
								-56.976026,
								-30.109686
							],
							[
								-57.625133,
								-30.216295
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BRN",
				"properties": {
					"name": "Brunei"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								114.204017,
								4.525874
							],
							[
								114.599961,
								4.900011
							],
							[
								115.45071,
								5.44773
							],
							[
								115.4057,
								4.955228
							],
							[
								115.347461,
								4.316636
							],
							[
								114.869557,
								4.348314
							],
							[
								114.659596,
								4.007637
							],
							[
								114.204017,
								4.525874
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BTN",
				"properties": {
					"name": "Bhutan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								91.696657,
								27.771742
							],
							[
								92.103712,
								27.452614
							],
							[
								92.033484,
								26.83831
							],
							[
								91.217513,
								26.808648
							],
							[
								90.373275,
								26.875724
							],
							[
								89.744528,
								26.719403
							],
							[
								88.835643,
								27.098966
							],
							[
								88.814248,
								27.299316
							],
							[
								89.47581,
								28.042759
							],
							[
								90.015829,
								28.296439
							],
							[
								90.730514,
								28.064954
							],
							[
								91.258854,
								28.040614
							],
							[
								91.696657,
								27.771742
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "BWA",
				"properties": {
					"name": "Botswana"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								25.649163,
								-18.536026
							],
							[
								25.850391,
								-18.714413
							],
							[
								26.164791,
								-19.293086
							],
							[
								27.296505,
								-20.39152
							],
							[
								27.724747,
								-20.499059
							],
							[
								27.727228,
								-20.851802
							],
							[
								28.02137,
								-21.485975
							],
							[
								28.794656,
								-21.639454
							],
							[
								29.432188,
								-22.091313
							],
							[
								28.017236,
								-22.827754
							],
							[
								27.11941,
								-23.574323
							],
							[
								26.786407,
								-24.240691
							],
							[
								26.485753,
								-24.616327
							],
							[
								25.941652,
								-24.696373
							],
							[
								25.765849,
								-25.174845
							],
							[
								25.664666,
								-25.486816
							],
							[
								25.025171,
								-25.71967
							],
							[
								24.211267,
								-25.670216
							],
							[
								23.73357,
								-25.390129
							],
							[
								23.312097,
								-25.26869
							],
							[
								22.824271,
								-25.500459
							],
							[
								22.579532,
								-25.979448
							],
							[
								22.105969,
								-26.280256
							],
							[
								21.605896,
								-26.726534
							],
							[
								20.889609,
								-26.828543
							],
							[
								20.66647,
								-26.477453
							],
							[
								20.758609,
								-25.868136
							],
							[
								20.165726,
								-24.917962
							],
							[
								19.895768,
								-24.76779
							],
							[
								19.895458,
								-21.849157
							],
							[
								20.881134,
								-21.814327
							],
							[
								20.910641,
								-18.252219
							],
							[
								21.65504,
								-18.219146
							],
							[
								23.196858,
								-17.869038
							],
							[
								23.579006,
								-18.281261
							],
							[
								24.217365,
								-17.889347
							],
							[
								24.520705,
								-17.887125
							],
							[
								25.084443,
								-17.661816
							],
							[
								25.264226,
								-17.73654
							],
							[
								25.649163,
								-18.536026
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CAF",
				"properties": {
					"name": "Central African Republic"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								15.27946,
								7.421925
							],
							[
								16.106232,
								7.497088
							],
							[
								16.290562,
								7.754307
							],
							[
								16.456185,
								7.734774
							],
							[
								16.705988,
								7.508328
							],
							[
								17.96493,
								7.890914
							],
							[
								18.389555,
								8.281304
							],
							[
								18.911022,
								8.630895
							],
							[
								18.81201,
								8.982915
							],
							[
								19.094008,
								9.074847
							],
							[
								20.059685,
								9.012706
							],
							[
								21.000868,
								9.475985
							],
							[
								21.723822,
								10.567056
							],
							[
								22.231129,
								10.971889
							],
							[
								22.864165,
								11.142395
							],
							[
								22.977544,
								10.714463
							],
							[
								23.554304,
								10.089255
							],
							[
								23.55725,
								9.681218
							],
							[
								23.394779,
								9.265068
							],
							[
								23.459013,
								8.954286
							],
							[
								23.805813,
								8.666319
							],
							[
								24.567369,
								8.229188
							],
							[
								25.114932,
								7.825104
							],
							[
								25.124131,
								7.500085
							],
							[
								25.796648,
								6.979316
							],
							[
								26.213418,
								6.546603
							],
							[
								26.465909,
								5.946717
							],
							[
								27.213409,
								5.550953
							],
							[
								27.374226,
								5.233944
							],
							[
								27.044065,
								5.127853
							],
							[
								26.402761,
								5.150875
							],
							[
								25.650455,
								5.256088
							],
							[
								25.278798,
								5.170408
							],
							[
								25.128833,
								4.927245
							],
							[
								24.805029,
								4.897247
							],
							[
								24.410531,
								5.108784
							],
							[
								23.297214,
								4.609693
							],
							[
								22.84148,
								4.710126
							],
							[
								22.704124,
								4.633051
							],
							[
								22.405124,
								4.02916
							],
							[
								21.659123,
								4.224342
							],
							[
								20.927591,
								4.322786
							],
							[
								20.290679,
								4.691678
							],
							[
								19.467784,
								5.031528
							],
							[
								18.932312,
								4.709506
							],
							[
								18.542982,
								4.201785
							],
							[
								18.453065,
								3.504386
							],
							[
								17.8099,
								3.560196
							],
							[
								17.133042,
								3.728197
							],
							[
								16.537058,
								3.198255
							],
							[
								16.012852,
								2.26764
							],
							[
								15.907381,
								2.557389
							],
							[
								15.862732,
								3.013537
							],
							[
								15.405396,
								3.335301
							],
							[
								15.03622,
								3.851367
							],
							[
								14.950953,
								4.210389
							],
							[
								14.478372,
								4.732605
							],
							[
								14.558936,
								5.030598
							],
							[
								14.459407,
								5.451761
							],
							[
								14.53656,
								6.226959
							],
							[
								14.776545,
								6.408498
							],
							[
								15.27946,
								7.421925
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CAN",
				"properties": {
					"name": "Canada"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-63.6645,
									46.55001
								],
								[
									-62.9393,
									46.41587
								],
								[
									-62.01208,
									46.44314
								],
								[
									-62.50391,
									46.03339
								],
								[
									-62.87433,
									45.96818
								],
								[
									-64.1428,
									46.39265
								],
								[
									-64.39261,
									46.72747
								],
								[
									-64.01486,
									47.03601
								],
								[
									-63.6645,
									46.55001
								]
							]
						],
						[
							[
								[
									-61.806305,
									49.10506
								],
								[
									-62.29318,
									49.08717
								],
								[
									-63.58926,
									49.40069
								],
								[
									-64.51912,
									49.87304
								],
								[
									-64.17322,
									49.95718
								],
								[
									-62.85829,
									49.70641
								],
								[
									-61.835585,
									49.28855
								],
								[
									-61.806305,
									49.10506
								]
							]
						],
						[
							[
								[
									-123.510002,
									48.510011
								],
								[
									-124.012891,
									48.370846
								],
								[
									-125.655013,
									48.825005
								],
								[
									-125.954994,
									49.179996
								],
								[
									-126.850004,
									49.53
								],
								[
									-127.029993,
									49.814996
								],
								[
									-128.059336,
									49.994959
								],
								[
									-128.444584,
									50.539138
								],
								[
									-128.358414,
									50.770648
								],
								[
									-127.308581,
									50.552574
								],
								[
									-126.695001,
									50.400903
								],
								[
									-125.755007,
									50.295018
								],
								[
									-125.415002,
									49.950001
								],
								[
									-124.920768,
									49.475275
								],
								[
									-123.922509,
									49.062484
								],
								[
									-123.510002,
									48.510011
								]
							]
						],
						[
							[
								[
									-56.134036,
									50.68701
								],
								[
									-56.795882,
									49.812309
								],
								[
									-56.143105,
									50.150117
								],
								[
									-55.471492,
									49.935815
								],
								[
									-55.822401,
									49.587129
								],
								[
									-54.935143,
									49.313011
								],
								[
									-54.473775,
									49.556691
								],
								[
									-53.476549,
									49.249139
								],
								[
									-53.786014,
									48.516781
								],
								[
									-53.086134,
									48.687804
								],
								[
									-52.958648,
									48.157164
								],
								[
									-52.648099,
									47.535548
								],
								[
									-53.069158,
									46.655499
								],
								[
									-53.521456,
									46.618292
								],
								[
									-54.178936,
									46.807066
								],
								[
									-53.961869,
									47.625207
								],
								[
									-54.240482,
									47.752279
								],
								[
									-55.400773,
									46.884994
								],
								[
									-55.997481,
									46.91972
								],
								[
									-55.291219,
									47.389562
								],
								[
									-56.250799,
									47.632545
								],
								[
									-57.325229,
									47.572807
								],
								[
									-59.266015,
									47.603348
								],
								[
									-59.419494,
									47.899454
								],
								[
									-58.796586,
									48.251525
								],
								[
									-59.231625,
									48.523188
								],
								[
									-58.391805,
									49.125581
								],
								[
									-57.35869,
									50.718274
								],
								[
									-56.73865,
									51.287438
								],
								[
									-55.870977,
									51.632094
								],
								[
									-55.406974,
									51.588273
								],
								[
									-55.600218,
									51.317075
								],
								[
									-56.134036,
									50.68701
								]
							]
						],
						[
							[
								[
									-132.710008,
									54.040009
								],
								[
									-131.74999,
									54.120004
								],
								[
									-132.04948,
									52.984621
								],
								[
									-131.179043,
									52.180433
								],
								[
									-131.57783,
									52.182371
								],
								[
									-132.180428,
									52.639707
								],
								[
									-132.549992,
									53.100015
								],
								[
									-133.054611,
									53.411469
								],
								[
									-133.239664,
									53.85108
								],
								[
									-133.180004,
									54.169975
								],
								[
									-132.710008,
									54.040009
								]
							]
						],
						[
							[
								[
									-79.26582,
									62.158675
								],
								[
									-79.65752,
									61.63308
								],
								[
									-80.09956,
									61.7181
								],
								[
									-80.36215,
									62.01649
								],
								[
									-80.315395,
									62.085565
								],
								[
									-79.92939,
									62.3856
								],
								[
									-79.52002,
									62.36371
								],
								[
									-79.26582,
									62.158675
								]
							]
						],
						[
							[
								[
									-81.89825,
									62.7108
								],
								[
									-83.06857,
									62.15922
								],
								[
									-83.77462,
									62.18231
								],
								[
									-83.99367,
									62.4528
								],
								[
									-83.25048,
									62.91409
								],
								[
									-81.87699,
									62.90458
								],
								[
									-81.89825,
									62.7108
								]
							]
						],
						[
							[
								[
									-85.161308,
									65.657285
								],
								[
									-84.975764,
									65.217518
								],
								[
									-84.464012,
									65.371772
								],
								[
									-83.882626,
									65.109618
								],
								[
									-82.787577,
									64.766693
								],
								[
									-81.642014,
									64.455136
								],
								[
									-81.55344,
									63.979609
								],
								[
									-80.817361,
									64.057486
								],
								[
									-80.103451,
									63.725981
								],
								[
									-80.99102,
									63.411246
								],
								[
									-82.547178,
									63.651722
								],
								[
									-83.108798,
									64.101876
								],
								[
									-84.100417,
									63.569712
								],
								[
									-85.523405,
									63.052379
								],
								[
									-85.866769,
									63.637253
								],
								[
									-87.221983,
									63.541238
								],
								[
									-86.35276,
									64.035833
								],
								[
									-86.224886,
									64.822917
								],
								[
									-85.883848,
									65.738778
								],
								[
									-85.161308,
									65.657285
								]
							]
						],
						[
							[
								[
									-75.86588,
									67.14886
								],
								[
									-76.98687,
									67.09873
								],
								[
									-77.2364,
									67.58809
								],
								[
									-76.81166,
									68.14856
								],
								[
									-75.89521,
									68.28721
								],
								[
									-75.1145,
									68.01036
								],
								[
									-75.10333,
									67.58202
								],
								[
									-75.21597,
									67.44425
								],
								[
									-75.86588,
									67.14886
								]
							]
						],
						[
							[
								[
									-95.647681,
									69.10769
								],
								[
									-96.269521,
									68.75704
								],
								[
									-97.617401,
									69.06003
								],
								[
									-98.431801,
									68.9507
								],
								[
									-99.797401,
									69.40003
								],
								[
									-98.917401,
									69.71003
								],
								[
									-98.218261,
									70.14354
								],
								[
									-97.157401,
									69.86003
								],
								[
									-96.557401,
									69.68003
								],
								[
									-96.257401,
									69.49003
								],
								[
									-95.647681,
									69.10769
								]
							]
						],
						[
							[
								[
									-90.5471,
									69.49766
								],
								[
									-90.55151,
									68.47499
								],
								[
									-89.21515,
									69.25873
								],
								[
									-88.01966,
									68.61508
								],
								[
									-88.31749,
									67.87338
								],
								[
									-87.35017,
									67.19872
								],
								[
									-86.30607,
									67.92146
								],
								[
									-85.57664,
									68.78456
								],
								[
									-85.52197,
									69.88211
								],
								[
									-84.10081,
									69.80539
								],
								[
									-82.62258,
									69.65826
								],
								[
									-81.28043,
									69.16202
								],
								[
									-81.2202,
									68.66567
								],
								[
									-81.96436,
									68.13253
								],
								[
									-81.25928,
									67.59716
								],
								[
									-81.38653,
									67.11078
								],
								[
									-83.34456,
									66.41154
								],
								[
									-84.73542,
									66.2573
								],
								[
									-85.76943,
									66.55833
								],
								[
									-86.0676,
									66.05625
								],
								[
									-87.03143,
									65.21297
								],
								[
									-87.32324,
									64.77563
								],
								[
									-88.48296,
									64.09897
								],
								[
									-89.91444,
									64.03273
								],
								[
									-90.70398,
									63.61017
								],
								[
									-90.77004,
									62.96021
								],
								[
									-91.93342,
									62.83508
								],
								[
									-93.15698,
									62.02469
								],
								[
									-94.24153,
									60.89865
								],
								[
									-94.62931,
									60.11021
								],
								[
									-94.6846,
									58.94882
								],
								[
									-93.21502,
									58.78212
								],
								[
									-92.76462,
									57.84571
								],
								[
									-92.29703,
									57.08709
								],
								[
									-90.89769,
									57.28468
								],
								[
									-89.03953,
									56.85172
								],
								[
									-88.03978,
									56.47162
								],
								[
									-87.32421,
									55.99914
								],
								[
									-86.07121,
									55.72383
								],
								[
									-85.01181,
									55.3026
								],
								[
									-83.36055,
									55.24489
								],
								[
									-82.27285,
									55.14832
								],
								[
									-82.4362,
									54.28227
								],
								[
									-82.12502,
									53.27703
								],
								[
									-81.40075,
									52.15788
								],
								[
									-79.91289,
									51.20842
								],
								[
									-79.14301,
									51.53393
								],
								[
									-78.60191,
									52.56208
								],
								[
									-79.12421,
									54.14145
								],
								[
									-79.82958,
									54.66772
								],
								[
									-78.22874,
									55.13645
								],
								[
									-77.0956,
									55.83741
								],
								[
									-76.54137,
									56.53423
								],
								[
									-76.62319,
									57.20263
								],
								[
									-77.30226,
									58.05209
								],
								[
									-78.51688,
									58.80458
								],
								[
									-77.33676,
									59.85261
								],
								[
									-77.77272,
									60.75788
								],
								[
									-78.10687,
									62.31964
								],
								[
									-77.41067,
									62.55053
								],
								[
									-75.69621,
									62.2784
								],
								[
									-74.6682,
									62.18111
								],
								[
									-73.83988,
									62.4438
								],
								[
									-72.90853,
									62.10507
								],
								[
									-71.67708,
									61.52535
								],
								[
									-71.37369,
									61.13717
								],
								[
									-69.59042,
									61.06141
								],
								[
									-69.62033,
									60.22125
								],
								[
									-69.2879,
									58.95736
								],
								[
									-68.37455,
									58.80106
								],
								[
									-67.64976,
									58.21206
								],
								[
									-66.20178,
									58.76731
								],
								[
									-65.24517,
									59.87071
								],
								[
									-64.58352,
									60.33558
								],
								[
									-63.80475,
									59.4426
								],
								[
									-62.50236,
									58.16708
								],
								[
									-61.39655,
									56.96745
								],
								[
									-61.79866,
									56.33945
								],
								[
									-60.46853,
									55.77548
								],
								[
									-59.56962,
									55.20407
								],
								[
									-57.97508,
									54.94549
								],
								[
									-57.3332,
									54.6265
								],
								[
									-56.93689,
									53.78032
								],
								[
									-56.15811,
									53.64749
								],
								[
									-55.75632,
									53.27036
								],
								[
									-55.68338,
									52.14664
								],
								[
									-56.40916,
									51.7707
								],
								[
									-57.12691,
									51.41972
								],
								[
									-58.77482,
									51.0643
								],
								[
									-60.03309,
									50.24277
								],
								[
									-61.72366,
									50.08046
								],
								[
									-63.86251,
									50.29099
								],
								[
									-65.36331,
									50.2982
								],
								[
									-66.39905,
									50.22897
								],
								[
									-67.23631,
									49.51156
								],
								[
									-68.51114,
									49.06836
								],
								[
									-69.95362,
									47.74488
								],
								[
									-71.10458,
									46.82171
								],
								[
									-70.25522,
									46.98606
								],
								[
									-68.65,
									48.3
								],
								[
									-66.55243,
									49.1331
								],
								[
									-65.05626,
									49.23278
								],
								[
									-64.17099,
									48.74248
								],
								[
									-65.11545,
									48.07085
								],
								[
									-64.79854,
									46.99297
								],
								[
									-64.47219,
									46.23849
								],
								[
									-63.17329,
									45.73902
								],
								[
									-61.52072,
									45.88377
								],
								[
									-60.51815,
									47.00793
								],
								[
									-60.4486,
									46.28264
								],
								[
									-59.80287,
									45.9204
								],
								[
									-61.03988,
									45.26525
								],
								[
									-63.25471,
									44.67014
								],
								[
									-64.24656,
									44.26553
								],
								[
									-65.36406,
									43.54523
								],
								[
									-66.1234,
									43.61867
								],
								[
									-66.16173,
									44.46512
								],
								[
									-64.42549,
									45.29204
								],
								[
									-66.02605,
									45.25931
								],
								[
									-67.13741,
									45.13753
								],
								[
									-67.79134,
									45.70281
								],
								[
									-67.79046,
									47.06636
								],
								[
									-68.23444,
									47.35486
								],
								[
									-68.905,
									47.185
								],
								[
									-69.237216,
									47.447781
								],
								[
									-69.99997,
									46.69307
								],
								[
									-70.305,
									45.915
								],
								[
									-70.66,
									45.46
								],
								[
									-71.08482,
									45.30524
								],
								[
									-71.405,
									45.255
								],
								[
									-71.50506,
									45.0082
								],
								[
									-73.34783,
									45.00738
								],
								[
									-74.867,
									45.00048
								],
								[
									-75.31821,
									44.81645
								],
								[
									-76.375,
									44.09631
								],
								[
									-76.5,
									44.018459
								],
								[
									-76.820034,
									43.628784
								],
								[
									-77.737885,
									43.629056
								],
								[
									-78.72028,
									43.625089
								],
								[
									-79.171674,
									43.466339
								],
								[
									-79.01,
									43.27
								],
								[
									-78.92,
									42.965
								],
								[
									-78.939362,
									42.863611
								],
								[
									-80.247448,
									42.3662
								],
								[
									-81.277747,
									42.209026
								],
								[
									-82.439278,
									41.675105
								],
								[
									-82.690089,
									41.675105
								],
								[
									-83.02981,
									41.832796
								],
								[
									-83.142,
									41.975681
								],
								[
									-83.12,
									42.08
								],
								[
									-82.9,
									42.43
								],
								[
									-82.43,
									42.98
								],
								[
									-82.137642,
									43.571088
								],
								[
									-82.337763,
									44.44
								],
								[
									-82.550925,
									45.347517
								],
								[
									-83.592851,
									45.816894
								],
								[
									-83.469551,
									45.994686
								],
								[
									-83.616131,
									46.116927
								],
								[
									-83.890765,
									46.116927
								],
								[
									-84.091851,
									46.275419
								],
								[
									-84.14212,
									46.512226
								],
								[
									-84.3367,
									46.40877
								],
								[
									-84.6049,
									46.4396
								],
								[
									-84.543749,
									46.538684
								],
								[
									-84.779238,
									46.637102
								],
								[
									-84.87608,
									46.900083
								],
								[
									-85.652363,
									47.220219
								],
								[
									-86.461991,
									47.553338
								],
								[
									-87.439793,
									47.94
								],
								[
									-88.378114,
									48.302918
								],
								[
									-89.272917,
									48.019808
								],
								[
									-89.6,
									48.01
								],
								[
									-90.83,
									48.27
								],
								[
									-91.64,
									48.14
								],
								[
									-92.61,
									48.45
								],
								[
									-93.63087,
									48.60926
								],
								[
									-94.32914,
									48.67074
								],
								[
									-94.64,
									48.84
								],
								[
									-94.81758,
									49.38905
								],
								[
									-95.15609,
									49.38425
								],
								[
									-95.15907,
									49
								],
								[
									-97.22872,
									49.0007
								],
								[
									-100.65,
									49
								],
								[
									-104.04826,
									48.99986
								],
								[
									-107.05,
									49
								],
								[
									-110.05,
									49
								],
								[
									-113,
									49
								],
								[
									-116.04818,
									49
								],
								[
									-117.03121,
									49
								],
								[
									-120,
									49
								],
								[
									-122.84,
									49
								],
								[
									-122.97421,
									49.002538
								],
								[
									-124.91024,
									49.98456
								],
								[
									-125.62461,
									50.41656
								],
								[
									-127.43561,
									50.83061
								],
								[
									-127.99276,
									51.71583
								],
								[
									-127.85032,
									52.32961
								],
								[
									-129.12979,
									52.75538
								],
								[
									-129.30523,
									53.56159
								],
								[
									-130.51497,
									54.28757
								],
								[
									-130.53611,
									54.80278
								],
								[
									-129.98,
									55.285
								],
								[
									-130.00778,
									55.91583
								],
								[
									-131.70781,
									56.55212
								],
								[
									-132.73042,
									57.69289
								],
								[
									-133.35556,
									58.41028
								],
								[
									-134.27111,
									58.86111
								],
								[
									-134.945,
									59.27056
								],
								[
									-135.47583,
									59.78778
								],
								[
									-136.47972,
									59.46389
								],
								[
									-137.4525,
									58.905
								],
								[
									-138.34089,
									59.56211
								],
								[
									-139.039,
									60
								],
								[
									-140.013,
									60.27682
								],
								[
									-140.99778,
									60.30639
								],
								[
									-140.9925,
									66.00003
								],
								[
									-140.986,
									69.712
								],
								[
									-139.12052,
									69.47102
								],
								[
									-137.54636,
									68.99002
								],
								[
									-136.50358,
									68.89804
								],
								[
									-135.62576,
									69.31512
								],
								[
									-134.41464,
									69.62743
								],
								[
									-132.92925,
									69.50534
								],
								[
									-131.43136,
									69.94451
								],
								[
									-129.79471,
									70.19369
								],
								[
									-129.10773,
									69.77927
								],
								[
									-128.36156,
									70.01286
								],
								[
									-128.13817,
									70.48384
								],
								[
									-127.44712,
									70.37721
								],
								[
									-125.75632,
									69.48058
								],
								[
									-124.42483,
									70.1584
								],
								[
									-124.28968,
									69.39969
								],
								[
									-123.06108,
									69.56372
								],
								[
									-122.6835,
									69.85553
								],
								[
									-121.47226,
									69.79778
								],
								[
									-119.94288,
									69.37786
								],
								[
									-117.60268,
									69.01128
								],
								[
									-116.22643,
									68.84151
								],
								[
									-115.2469,
									68.90591
								],
								[
									-113.89794,
									68.3989
								],
								[
									-115.30489,
									67.90261
								],
								[
									-113.49727,
									67.68815
								],
								[
									-110.798,
									67.80612
								],
								[
									-109.94619,
									67.98104
								],
								[
									-108.8802,
									67.38144
								],
								[
									-107.79239,
									67.88736
								],
								[
									-108.81299,
									68.31164
								],
								[
									-108.16721,
									68.65392
								],
								[
									-106.95,
									68.7
								],
								[
									-106.15,
									68.8
								],
								[
									-105.34282,
									68.56122
								],
								[
									-104.33791,
									68.018
								],
								[
									-103.22115,
									68.09775
								],
								[
									-101.45433,
									67.64689
								],
								[
									-99.90195,
									67.80566
								],
								[
									-98.4432,
									67.78165
								],
								[
									-98.5586,
									68.40394
								],
								[
									-97.66948,
									68.57864
								],
								[
									-96.11991,
									68.23939
								],
								[
									-96.12588,
									67.29338
								],
								[
									-95.48943,
									68.0907
								],
								[
									-94.685,
									68.06383
								],
								[
									-94.23282,
									69.06903
								],
								[
									-95.30408,
									69.68571
								],
								[
									-96.47131,
									70.08976
								],
								[
									-96.39115,
									71.19482
								],
								[
									-95.2088,
									71.92053
								],
								[
									-93.88997,
									71.76015
								],
								[
									-92.87818,
									71.31869
								],
								[
									-91.51964,
									70.19129
								],
								[
									-92.40692,
									69.69997
								],
								[
									-90.5471,
									69.49766
								]
							]
						],
						[
							[
								[
									-114.16717,
									73.12145
								],
								[
									-114.66634,
									72.65277
								],
								[
									-112.44102,
									72.9554
								],
								[
									-111.05039,
									72.4504
								],
								[
									-109.92035,
									72.96113
								],
								[
									-109.00654,
									72.63335
								],
								[
									-108.18835,
									71.65089
								],
								[
									-107.68599,
									72.06548
								],
								[
									-108.39639,
									73.08953
								],
								[
									-107.51645,
									73.23598
								],
								[
									-106.52259,
									73.07601
								],
								[
									-105.40246,
									72.67259
								],
								[
									-104.77484,
									71.6984
								],
								[
									-104.46476,
									70.99297
								],
								[
									-102.78537,
									70.49776
								],
								[
									-100.98078,
									70.02432
								],
								[
									-101.08929,
									69.58447
								],
								[
									-102.73116,
									69.50402
								],
								[
									-102.09329,
									69.11962
								],
								[
									-102.43024,
									68.75282
								],
								[
									-104.24,
									68.91
								],
								[
									-105.96,
									69.18
								],
								[
									-107.12254,
									69.11922
								],
								[
									-109,
									68.78
								],
								[
									-111.534149,
									68.630059
								],
								[
									-113.3132,
									68.53554
								],
								[
									-113.85496,
									69.00744
								],
								[
									-115.22,
									69.28
								],
								[
									-116.10794,
									69.16821
								],
								[
									-117.34,
									69.96
								],
								[
									-116.67473,
									70.06655
								],
								[
									-115.13112,
									70.2373
								],
								[
									-113.72141,
									70.19237
								],
								[
									-112.4161,
									70.36638
								],
								[
									-114.35,
									70.6
								],
								[
									-116.48684,
									70.52045
								],
								[
									-117.9048,
									70.54056
								],
								[
									-118.43238,
									70.9092
								],
								[
									-116.11311,
									71.30918
								],
								[
									-117.65568,
									71.2952
								],
								[
									-119.40199,
									71.55859
								],
								[
									-118.56267,
									72.30785
								],
								[
									-117.86642,
									72.70594
								],
								[
									-115.18909,
									73.31459
								],
								[
									-114.16717,
									73.12145
								]
							]
						],
						[
							[
								[
									-104.5,
									73.42
								],
								[
									-105.38,
									72.76
								],
								[
									-106.94,
									73.46
								],
								[
									-106.6,
									73.6
								],
								[
									-105.26,
									73.64
								],
								[
									-104.5,
									73.42
								]
							]
						],
						[
							[
								[
									-76.34,
									73.102685
								],
								[
									-76.251404,
									72.826385
								],
								[
									-77.314438,
									72.855545
								],
								[
									-78.39167,
									72.876656
								],
								[
									-79.486252,
									72.742203
								],
								[
									-79.775833,
									72.802902
								],
								[
									-80.876099,
									73.333183
								],
								[
									-80.833885,
									73.693184
								],
								[
									-80.353058,
									73.75972
								],
								[
									-78.064438,
									73.651932
								],
								[
									-76.34,
									73.102685
								]
							]
						],
						[
							[
								[
									-86.562179,
									73.157447
								],
								[
									-85.774371,
									72.534126
								],
								[
									-84.850112,
									73.340278
								],
								[
									-82.31559,
									73.750951
								],
								[
									-80.600088,
									72.716544
								],
								[
									-80.748942,
									72.061907
								],
								[
									-78.770639,
									72.352173
								],
								[
									-77.824624,
									72.749617
								],
								[
									-75.605845,
									72.243678
								],
								[
									-74.228616,
									71.767144
								],
								[
									-74.099141,
									71.33084
								],
								[
									-72.242226,
									71.556925
								],
								[
									-71.200015,
									70.920013
								],
								[
									-68.786054,
									70.525024
								],
								[
									-67.91497,
									70.121948
								],
								[
									-66.969033,
									69.186087
								],
								[
									-68.805123,
									68.720198
								],
								[
									-66.449866,
									68.067163
								],
								[
									-64.862314,
									67.847539
								],
								[
									-63.424934,
									66.928473
								],
								[
									-61.851981,
									66.862121
								],
								[
									-62.163177,
									66.160251
								],
								[
									-63.918444,
									64.998669
								],
								[
									-65.14886,
									65.426033
								],
								[
									-66.721219,
									66.388041
								],
								[
									-68.015016,
									66.262726
								],
								[
									-68.141287,
									65.689789
								],
								[
									-67.089646,
									65.108455
								],
								[
									-65.73208,
									64.648406
								],
								[
									-65.320168,
									64.382737
								],
								[
									-64.669406,
									63.392927
								],
								[
									-65.013804,
									62.674185
								],
								[
									-66.275045,
									62.945099
								],
								[
									-68.783186,
									63.74567
								],
								[
									-67.369681,
									62.883966
								],
								[
									-66.328297,
									62.280075
								],
								[
									-66.165568,
									61.930897
								],
								[
									-68.877367,
									62.330149
								],
								[
									-71.023437,
									62.910708
								],
								[
									-72.235379,
									63.397836
								],
								[
									-71.886278,
									63.679989
								],
								[
									-73.378306,
									64.193963
								],
								[
									-74.834419,
									64.679076
								],
								[
									-74.818503,
									64.389093
								],
								[
									-77.70998,
									64.229542
								],
								[
									-78.555949,
									64.572906
								],
								[
									-77.897281,
									65.309192
								],
								[
									-76.018274,
									65.326969
								],
								[
									-73.959795,
									65.454765
								],
								[
									-74.293883,
									65.811771
								],
								[
									-73.944912,
									66.310578
								],
								[
									-72.651167,
									67.284576
								],
								[
									-72.92606,
									67.726926
								],
								[
									-73.311618,
									68.069437
								],
								[
									-74.843307,
									68.554627
								],
								[
									-76.869101,
									68.894736
								],
								[
									-76.228649,
									69.147769
								],
								[
									-77.28737,
									69.76954
								],
								[
									-78.168634,
									69.826488
								],
								[
									-78.957242,
									70.16688
								],
								[
									-79.492455,
									69.871808
								],
								[
									-81.305471,
									69.743185
								],
								[
									-84.944706,
									69.966634
								],
								[
									-87.060003,
									70.260001
								],
								[
									-88.681713,
									70.410741
								],
								[
									-89.51342,
									70.762038
								],
								[
									-88.467721,
									71.218186
								],
								[
									-89.888151,
									71.222552
								],
								[
									-90.20516,
									72.235074
								],
								[
									-89.436577,
									73.129464
								],
								[
									-88.408242,
									73.537889
								],
								[
									-85.826151,
									73.803816
								],
								[
									-86.562179,
									73.157447
								]
							]
						],
						[
							[
								[
									-100.35642,
									73.84389
								],
								[
									-99.16387,
									73.63339
								],
								[
									-97.38,
									73.76
								],
								[
									-97.12,
									73.47
								],
								[
									-98.05359,
									72.99052
								],
								[
									-96.54,
									72.56
								],
								[
									-96.72,
									71.66
								],
								[
									-98.35966,
									71.27285
								],
								[
									-99.32286,
									71.35639
								],
								[
									-100.01482,
									71.73827
								],
								[
									-102.5,
									72.51
								],
								[
									-102.48,
									72.83
								],
								[
									-100.43836,
									72.70588
								],
								[
									-101.54,
									73.36
								],
								[
									-100.35642,
									73.84389
								]
							]
						],
						[
							[
								[
									-93.196296,
									72.771992
								],
								[
									-94.269047,
									72.024596
								],
								[
									-95.409856,
									72.061881
								],
								[
									-96.033745,
									72.940277
								],
								[
									-96.018268,
									73.43743
								],
								[
									-95.495793,
									73.862417
								],
								[
									-94.503658,
									74.134907
								],
								[
									-92.420012,
									74.100025
								],
								[
									-90.509793,
									73.856732
								],
								[
									-92.003965,
									72.966244
								],
								[
									-93.196296,
									72.771992
								]
							]
						],
						[
							[
								[
									-120.46,
									71.383602
								],
								[
									-123.09219,
									70.90164
								],
								[
									-123.62,
									71.34
								],
								[
									-125.928949,
									71.868688
								],
								[
									-125.5,
									72.292261
								],
								[
									-124.80729,
									73.02256
								],
								[
									-123.94,
									73.68
								],
								[
									-124.91775,
									74.29275
								],
								[
									-121.53788,
									74.44893
								],
								[
									-120.10978,
									74.24135
								],
								[
									-117.55564,
									74.18577
								],
								[
									-116.58442,
									73.89607
								],
								[
									-115.51081,
									73.47519
								],
								[
									-116.76794,
									73.22292
								],
								[
									-119.22,
									72.52
								],
								[
									-120.46,
									71.82
								],
								[
									-120.46,
									71.383602
								]
							]
						],
						[
							[
								[
									-93.612756,
									74.979997
								],
								[
									-94.156909,
									74.592347
								],
								[
									-95.608681,
									74.666864
								],
								[
									-96.820932,
									74.927623
								],
								[
									-96.288587,
									75.377828
								],
								[
									-94.85082,
									75.647218
								],
								[
									-93.977747,
									75.29649
								],
								[
									-93.612756,
									74.979997
								]
							]
						],
						[
							[
								[
									-98.5,
									76.72
								],
								[
									-97.735585,
									76.25656
								],
								[
									-97.704415,
									75.74344
								],
								[
									-98.16,
									75
								],
								[
									-99.80874,
									74.89744
								],
								[
									-100.88366,
									75.05736
								],
								[
									-100.86292,
									75.64075
								],
								[
									-102.50209,
									75.5638
								],
								[
									-102.56552,
									76.3366
								],
								[
									-101.48973,
									76.30537
								],
								[
									-99.98349,
									76.64634
								],
								[
									-98.57699,
									76.58859
								],
								[
									-98.5,
									76.72
								]
							]
						],
						[
							[
								[
									-108.21141,
									76.20168
								],
								[
									-107.81943,
									75.84552
								],
								[
									-106.92893,
									76.01282
								],
								[
									-105.881,
									75.9694
								],
								[
									-105.70498,
									75.47951
								],
								[
									-106.31347,
									75.00527
								],
								[
									-109.7,
									74.85
								],
								[
									-112.22307,
									74.41696
								],
								[
									-113.74381,
									74.39427
								],
								[
									-113.87135,
									74.72029
								],
								[
									-111.79421,
									75.1625
								],
								[
									-116.31221,
									75.04343
								],
								[
									-117.7104,
									75.2222
								],
								[
									-116.34602,
									76.19903
								],
								[
									-115.40487,
									76.47887
								],
								[
									-112.59056,
									76.14134
								],
								[
									-110.81422,
									75.54919
								],
								[
									-109.0671,
									75.47321
								],
								[
									-110.49726,
									76.42982
								],
								[
									-109.5811,
									76.79417
								],
								[
									-108.54859,
									76.67832
								],
								[
									-108.21141,
									76.20168
								]
							]
						],
						[
							[
								[
									-94.684086,
									77.097878
								],
								[
									-93.573921,
									76.776296
								],
								[
									-91.605023,
									76.778518
								],
								[
									-90.741846,
									76.449597
								],
								[
									-90.969661,
									76.074013
								],
								[
									-89.822238,
									75.847774
								],
								[
									-89.187083,
									75.610166
								],
								[
									-87.838276,
									75.566189
								],
								[
									-86.379192,
									75.482421
								],
								[
									-84.789625,
									75.699204
								],
								[
									-82.753445,
									75.784315
								],
								[
									-81.128531,
									75.713983
								],
								[
									-80.057511,
									75.336849
								],
								[
									-79.833933,
									74.923127
								],
								[
									-80.457771,
									74.657304
								],
								[
									-81.948843,
									74.442459
								],
								[
									-83.228894,
									74.564028
								],
								[
									-86.097452,
									74.410032
								],
								[
									-88.15035,
									74.392307
								],
								[
									-89.764722,
									74.515555
								],
								[
									-92.422441,
									74.837758
								],
								[
									-92.768285,
									75.38682
								],
								[
									-92.889906,
									75.882655
								],
								[
									-93.893824,
									76.319244
								],
								[
									-95.962457,
									76.441381
								],
								[
									-97.121379,
									76.751078
								],
								[
									-96.745123,
									77.161389
								],
								[
									-94.684086,
									77.097878
								]
							]
						],
						[
							[
								[
									-116.198587,
									77.645287
								],
								[
									-116.335813,
									76.876962
								],
								[
									-117.106051,
									76.530032
								],
								[
									-118.040412,
									76.481172
								],
								[
									-119.899318,
									76.053213
								],
								[
									-121.499995,
									75.900019
								],
								[
									-122.854924,
									76.116543
								],
								[
									-122.854925,
									76.116543
								],
								[
									-121.157535,
									76.864508
								],
								[
									-119.103939,
									77.51222
								],
								[
									-117.570131,
									77.498319
								],
								[
									-116.198587,
									77.645287
								]
							]
						],
						[
							[
								[
									-93.840003,
									77.519997
								],
								[
									-94.295608,
									77.491343
								],
								[
									-96.169654,
									77.555111
								],
								[
									-96.436304,
									77.834629
								],
								[
									-94.422577,
									77.820005
								],
								[
									-93.720656,
									77.634331
								],
								[
									-93.840003,
									77.519997
								]
							]
						],
						[
							[
								[
									-110.186938,
									77.697015
								],
								[
									-112.051191,
									77.409229
								],
								[
									-113.534279,
									77.732207
								],
								[
									-112.724587,
									78.05105
								],
								[
									-111.264443,
									78.152956
								],
								[
									-109.854452,
									77.996325
								],
								[
									-110.186938,
									77.697015
								]
							]
						],
						[
							[
								[
									-109.663146,
									78.601973
								],
								[
									-110.881314,
									78.40692
								],
								[
									-112.542091,
									78.407902
								],
								[
									-112.525891,
									78.550555
								],
								[
									-111.50001,
									78.849994
								],
								[
									-110.963661,
									78.804441
								],
								[
									-109.663146,
									78.601973
								]
							]
						],
						[
							[
								[
									-95.830295,
									78.056941
								],
								[
									-97.309843,
									77.850597
								],
								[
									-98.124289,
									78.082857
								],
								[
									-98.552868,
									78.458105
								],
								[
									-98.631984,
									78.87193
								],
								[
									-97.337231,
									78.831984
								],
								[
									-96.754399,
									78.765813
								],
								[
									-95.559278,
									78.418315
								],
								[
									-95.830295,
									78.056941
								]
							]
						],
						[
							[
								[
									-100.060192,
									78.324754
								],
								[
									-99.670939,
									77.907545
								],
								[
									-101.30394,
									78.018985
								],
								[
									-102.949809,
									78.343229
								],
								[
									-105.176133,
									78.380332
								],
								[
									-104.210429,
									78.67742
								],
								[
									-105.41958,
									78.918336
								],
								[
									-105.492289,
									79.301594
								],
								[
									-103.529282,
									79.165349
								],
								[
									-100.825158,
									78.800462
								],
								[
									-100.060192,
									78.324754
								]
							]
						],
						[
							[
								[
									-87.02,
									79.66
								],
								[
									-85.81435,
									79.3369
								],
								[
									-87.18756,
									79.0393
								],
								[
									-89.03535,
									78.28723
								],
								[
									-90.80436,
									78.21533
								],
								[
									-92.87669,
									78.34333
								],
								[
									-93.95116,
									78.75099
								],
								[
									-93.93574,
									79.11373
								],
								[
									-93.14524,
									79.3801
								],
								[
									-94.974,
									79.37248
								],
								[
									-96.07614,
									79.70502
								],
								[
									-96.70972,
									80.15777
								],
								[
									-96.01644,
									80.60233
								],
								[
									-95.32345,
									80.90729
								],
								[
									-94.29843,
									80.97727
								],
								[
									-94.73542,
									81.20646
								],
								[
									-92.40984,
									81.25739
								],
								[
									-91.13289,
									80.72345
								],
								[
									-89.45,
									80.509322
								],
								[
									-87.81,
									80.32
								],
								[
									-87.02,
									79.66
								]
							]
						],
						[
							[
								[
									-68.5,
									83.106322
								],
								[
									-65.82735,
									83.02801
								],
								[
									-63.68,
									82.9
								],
								[
									-61.85,
									82.6286
								],
								[
									-61.89388,
									82.36165
								],
								[
									-64.334,
									81.92775
								],
								[
									-66.75342,
									81.72527
								],
								[
									-67.65755,
									81.50141
								],
								[
									-65.48031,
									81.50657
								],
								[
									-67.84,
									80.9
								],
								[
									-69.4697,
									80.61683
								],
								[
									-71.18,
									79.8
								],
								[
									-73.2428,
									79.63415
								],
								[
									-73.88,
									79.430162
								],
								[
									-76.90773,
									79.32309
								],
								[
									-75.52924,
									79.19766
								],
								[
									-76.22046,
									79.01907
								],
								[
									-75.39345,
									78.52581
								],
								[
									-76.34354,
									78.18296
								],
								[
									-77.88851,
									77.89991
								],
								[
									-78.36269,
									77.50859
								],
								[
									-79.75951,
									77.20968
								],
								[
									-79.61965,
									76.98336
								],
								[
									-77.91089,
									77.022045
								],
								[
									-77.88911,
									76.777955
								],
								[
									-80.56125,
									76.17812
								],
								[
									-83.17439,
									76.45403
								],
								[
									-86.11184,
									76.29901
								],
								[
									-87.6,
									76.42
								],
								[
									-89.49068,
									76.47239
								],
								[
									-89.6161,
									76.95213
								],
								[
									-87.76739,
									77.17833
								],
								[
									-88.26,
									77.9
								],
								[
									-87.65,
									77.970222
								],
								[
									-84.97634,
									77.53873
								],
								[
									-86.34,
									78.18
								],
								[
									-87.96192,
									78.37181
								],
								[
									-87.15198,
									78.75867
								],
								[
									-85.37868,
									78.9969
								],
								[
									-85.09495,
									79.34543
								],
								[
									-86.50734,
									79.73624
								],
								[
									-86.93179,
									80.25145
								],
								[
									-84.19844,
									80.20836
								],
								[
									-83.408696,
									80.1
								],
								[
									-81.84823,
									80.46442
								],
								[
									-84.1,
									80.58
								],
								[
									-87.59895,
									80.51627
								],
								[
									-89.36663,
									80.85569
								],
								[
									-90.2,
									81.26
								],
								[
									-91.36786,
									81.5531
								],
								[
									-91.58702,
									81.89429
								],
								[
									-90.1,
									82.085
								],
								[
									-88.93227,
									82.11751
								],
								[
									-86.97024,
									82.27961
								],
								[
									-85.5,
									82.652273
								],
								[
									-84.260005,
									82.6
								],
								[
									-83.18,
									82.32
								],
								[
									-82.42,
									82.86
								],
								[
									-81.1,
									83.02
								],
								[
									-79.30664,
									83.13056
								],
								[
									-76.25,
									83.172059
								],
								[
									-75.71878,
									83.06404
								],
								[
									-72.83153,
									83.23324
								],
								[
									-70.665765,
									83.169781
								],
								[
									-68.5,
									83.106322
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CHE",
				"properties": {
					"name": "Switzerland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.594226,
								47.525058
							],
							[
								9.632932,
								47.347601
							],
							[
								9.47997,
								47.10281
							],
							[
								9.932448,
								46.920728
							],
							[
								10.442701,
								46.893546
							],
							[
								10.363378,
								46.483571
							],
							[
								9.922837,
								46.314899
							],
							[
								9.182882,
								46.440215
							],
							[
								8.966306,
								46.036932
							],
							[
								8.489952,
								46.005151
							],
							[
								8.31663,
								46.163642
							],
							[
								7.755992,
								45.82449
							],
							[
								7.273851,
								45.776948
							],
							[
								6.843593,
								45.991147
							],
							[
								6.5001,
								46.429673
							],
							[
								6.022609,
								46.27299
							],
							[
								6.037389,
								46.725779
							],
							[
								6.768714,
								47.287708
							],
							[
								6.736571,
								47.541801
							],
							[
								7.192202,
								47.449766
							],
							[
								7.466759,
								47.620582
							],
							[
								8.317301,
								47.61358
							],
							[
								8.522612,
								47.830828
							],
							[
								9.594226,
								47.525058
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CHL",
				"properties": {
					"name": "Chile"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-68.63401,
									-52.63637
								],
								[
									-68.63335,
									-54.8695
								],
								[
									-67.56244,
									-54.87001
								],
								[
									-66.95992,
									-54.89681
								],
								[
									-67.29103,
									-55.30124
								],
								[
									-68.14863,
									-55.61183
								],
								[
									-68.639991,
									-55.580018
								],
								[
									-69.2321,
									-55.49906
								],
								[
									-69.95809,
									-55.19843
								],
								[
									-71.00568,
									-55.05383
								],
								[
									-72.2639,
									-54.49514
								],
								[
									-73.2852,
									-53.95752
								],
								[
									-74.66253,
									-52.83749
								],
								[
									-73.8381,
									-53.04743
								],
								[
									-72.43418,
									-53.7154
								],
								[
									-71.10773,
									-54.07433
								],
								[
									-70.59178,
									-53.61583
								],
								[
									-70.26748,
									-52.93123
								],
								[
									-69.34565,
									-52.5183
								],
								[
									-68.63401,
									-52.63637
								]
							]
						],
						[
							[
								[
									-68.219913,
									-21.494347
								],
								[
									-67.82818,
									-22.872919
								],
								[
									-67.106674,
									-22.735925
								],
								[
									-66.985234,
									-22.986349
								],
								[
									-67.328443,
									-24.025303
								],
								[
									-68.417653,
									-24.518555
								],
								[
									-68.386001,
									-26.185016
								],
								[
									-68.5948,
									-26.506909
								],
								[
									-68.295542,
									-26.89934
								],
								[
									-69.001235,
									-27.521214
								],
								[
									-69.65613,
									-28.459141
								],
								[
									-70.01355,
									-29.367923
								],
								[
									-69.919008,
									-30.336339
								],
								[
									-70.535069,
									-31.36501
								],
								[
									-70.074399,
									-33.09121
								],
								[
									-69.814777,
									-33.273886
								],
								[
									-69.817309,
									-34.193571
								],
								[
									-70.388049,
									-35.169688
								],
								[
									-70.364769,
									-36.005089
								],
								[
									-71.121881,
									-36.658124
								],
								[
									-71.118625,
									-37.576827
								],
								[
									-70.814664,
									-38.552995
								],
								[
									-71.413517,
									-38.916022
								],
								[
									-71.680761,
									-39.808164
								],
								[
									-71.915734,
									-40.832339
								],
								[
									-71.746804,
									-42.051386
								],
								[
									-72.148898,
									-42.254888
								],
								[
									-71.915424,
									-43.408565
								],
								[
									-71.464056,
									-43.787611
								],
								[
									-71.793623,
									-44.207172
								],
								[
									-71.329801,
									-44.407522
								],
								[
									-71.222779,
									-44.784243
								],
								[
									-71.659316,
									-44.973689
								],
								[
									-71.552009,
									-45.560733
								],
								[
									-71.917258,
									-46.884838
								],
								[
									-72.447355,
									-47.738533
								],
								[
									-72.331161,
									-48.244238
								],
								[
									-72.648247,
									-48.878618
								],
								[
									-73.415436,
									-49.318436
								],
								[
									-73.328051,
									-50.378785
								],
								[
									-72.975747,
									-50.74145
								],
								[
									-72.309974,
									-50.67701
								],
								[
									-72.329404,
									-51.425956
								],
								[
									-71.914804,
									-52.009022
								],
								[
									-69.498362,
									-52.142761
								],
								[
									-68.571545,
									-52.299444
								],
								[
									-69.461284,
									-52.291951
								],
								[
									-69.94278,
									-52.537931
								],
								[
									-70.845102,
									-52.899201
								],
								[
									-71.006332,
									-53.833252
								],
								[
									-71.429795,
									-53.856455
								],
								[
									-72.557943,
									-53.53141
								],
								[
									-73.702757,
									-52.835069
								],
								[
									-73.702757,
									-52.83507
								],
								[
									-74.946763,
									-52.262754
								],
								[
									-75.260026,
									-51.629355
								],
								[
									-74.976632,
									-51.043396
								],
								[
									-75.479754,
									-50.378372
								],
								[
									-75.608015,
									-48.673773
								],
								[
									-75.18277,
									-47.711919
								],
								[
									-74.126581,
									-46.939253
								],
								[
									-75.644395,
									-46.647643
								],
								[
									-74.692154,
									-45.763976
								],
								[
									-74.351709,
									-44.103044
								],
								[
									-73.240356,
									-44.454961
								],
								[
									-72.717804,
									-42.383356
								],
								[
									-73.3889,
									-42.117532
								],
								[
									-73.701336,
									-43.365776
								],
								[
									-74.331943,
									-43.224958
								],
								[
									-74.017957,
									-41.794813
								],
								[
									-73.677099,
									-39.942213
								],
								[
									-73.217593,
									-39.258689
								],
								[
									-73.505559,
									-38.282883
								],
								[
									-73.588061,
									-37.156285
								],
								[
									-73.166717,
									-37.12378
								],
								[
									-72.553137,
									-35.50884
								],
								[
									-71.861732,
									-33.909093
								],
								[
									-71.43845,
									-32.418899
								],
								[
									-71.668721,
									-30.920645
								],
								[
									-71.370083,
									-30.095682
								],
								[
									-71.489894,
									-28.861442
								],
								[
									-70.905124,
									-27.64038
								],
								[
									-70.724954,
									-25.705924
								],
								[
									-70.403966,
									-23.628997
								],
								[
									-70.091246,
									-21.393319
								],
								[
									-70.16442,
									-19.756468
								],
								[
									-70.372572,
									-18.347975
								],
								[
									-69.858444,
									-18.092694
								],
								[
									-69.590424,
									-17.580012
								],
								[
									-69.100247,
									-18.260125
								],
								[
									-68.966818,
									-18.981683
								],
								[
									-68.442225,
									-19.405068
								],
								[
									-68.757167,
									-20.372658
								],
								[
									-68.219913,
									-21.494347
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CHN",
				"properties": {
					"name": "China"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									110.339188,
									18.678395
								],
								[
									109.47521,
									18.197701
								],
								[
									108.655208,
									18.507682
								],
								[
									108.626217,
									19.367888
								],
								[
									109.119056,
									19.821039
								],
								[
									110.211599,
									20.101254
								],
								[
									110.786551,
									20.077534
								],
								[
									111.010051,
									19.69593
								],
								[
									110.570647,
									19.255879
								],
								[
									110.339188,
									18.678395
								]
							]
						],
						[
							[
								[
									127.657407,
									49.76027
								],
								[
									129.397818,
									49.4406
								],
								[
									130.582293,
									48.729687
								],
								[
									130.987282,
									47.790132
								],
								[
									132.506672,
									47.78897
								],
								[
									133.373596,
									48.183442
								],
								[
									135.026311,
									48.47823
								],
								[
									134.500814,
									47.57844
								],
								[
									134.112362,
									47.212467
								],
								[
									133.769644,
									46.116927
								],
								[
									133.097127,
									45.144066
								],
								[
									131.883454,
									45.321162
								],
								[
									131.025212,
									44.967953
								],
								[
									131.288555,
									44.11152
								],
								[
									131.144688,
									42.92999
								],
								[
									130.633866,
									42.903015
								],
								[
									130.640016,
									42.395009
								],
								[
									129.994267,
									42.985387
								],
								[
									129.596669,
									42.424982
								],
								[
									128.052215,
									41.994285
								],
								[
									128.208433,
									41.466772
								],
								[
									127.343783,
									41.503152
								],
								[
									126.869083,
									41.816569
								],
								[
									126.182045,
									41.107336
								],
								[
									125.079942,
									40.569824
								],
								[
									124.265625,
									39.928493
								],
								[
									122.86757,
									39.637788
								],
								[
									122.131388,
									39.170452
								],
								[
									121.054554,
									38.897471
								],
								[
									121.585995,
									39.360854
								],
								[
									121.376757,
									39.750261
								],
								[
									122.168595,
									40.422443
								],
								[
									121.640359,
									40.94639
								],
								[
									120.768629,
									40.593388
								],
								[
									119.639602,
									39.898056
								],
								[
									119.023464,
									39.252333
								],
								[
									118.042749,
									39.204274
								],
								[
									117.532702,
									38.737636
								],
								[
									118.059699,
									38.061476
								],
								[
									118.87815,
									37.897325
								],
								[
									118.911636,
									37.448464
								],
								[
									119.702802,
									37.156389
								],
								[
									120.823457,
									37.870428
								],
								[
									121.711259,
									37.481123
								],
								[
									122.357937,
									37.454484
								],
								[
									122.519995,
									36.930614
								],
								[
									121.104164,
									36.651329
								],
								[
									120.637009,
									36.11144
								],
								[
									119.664562,
									35.609791
								],
								[
									119.151208,
									34.909859
								],
								[
									120.227525,
									34.360332
								],
								[
									120.620369,
									33.376723
								],
								[
									121.229014,
									32.460319
								],
								[
									121.908146,
									31.692174
								],
								[
									121.891919,
									30.949352
								],
								[
									121.264257,
									30.676267
								],
								[
									121.503519,
									30.142915
								],
								[
									122.092114,
									29.83252
								],
								[
									121.938428,
									29.018022
								],
								[
									121.684439,
									28.225513
								],
								[
									121.125661,
									28.135673
								],
								[
									120.395473,
									27.053207
								],
								[
									119.585497,
									25.740781
								],
								[
									118.656871,
									24.547391
								],
								[
									117.281606,
									23.624501
								],
								[
									115.890735,
									22.782873
								],
								[
									114.763827,
									22.668074
								],
								[
									114.152547,
									22.22376
								],
								[
									113.80678,
									22.54834
								],
								[
									113.241078,
									22.051367
								],
								[
									111.843592,
									21.550494
								],
								[
									110.785466,
									21.397144
								],
								[
									110.444039,
									20.341033
								],
								[
									109.889861,
									20.282457
								],
								[
									109.627655,
									21.008227
								],
								[
									109.864488,
									21.395051
								],
								[
									108.522813,
									21.715212
								],
								[
									108.05018,
									21.55238
								],
								[
									107.04342,
									21.811899
								],
								[
									106.567273,
									22.218205
								],
								[
									106.725403,
									22.794268
								],
								[
									105.811247,
									22.976892
								],
								[
									105.329209,
									23.352063
								],
								[
									104.476858,
									22.81915
								],
								[
									103.504515,
									22.703757
								],
								[
									102.706992,
									22.708795
								],
								[
									102.170436,
									22.464753
								],
								[
									101.652018,
									22.318199
								],
								[
									101.80312,
									21.174367
								],
								[
									101.270026,
									21.201652
								],
								[
									101.180005,
									21.436573
								],
								[
									101.150033,
									21.849984
								],
								[
									100.416538,
									21.558839
								],
								[
									99.983489,
									21.742937
								],
								[
									99.240899,
									22.118314
								],
								[
									99.531992,
									22.949039
								],
								[
									98.898749,
									23.142722
								],
								[
									98.660262,
									24.063286
								],
								[
									97.60472,
									23.897405
								],
								[
									97.724609,
									25.083637
								],
								[
									98.671838,
									25.918703
								],
								[
									98.712094,
									26.743536
								],
								[
									98.68269,
									27.508812
								],
								[
									98.246231,
									27.747221
								],
								[
									97.911988,
									28.335945
								],
								[
									97.327114,
									28.261583
								],
								[
									96.248833,
									28.411031
								],
								[
									96.586591,
									28.83098
								],
								[
									96.117679,
									29.452802
								],
								[
									95.404802,
									29.031717
								],
								[
									94.56599,
									29.277438
								],
								[
									93.413348,
									28.640629
								],
								[
									92.503119,
									27.896876
								],
								[
									91.696657,
									27.771742
								],
								[
									91.258854,
									28.040614
								],
								[
									90.730514,
									28.064954
								],
								[
									90.015829,
									28.296439
								],
								[
									89.47581,
									28.042759
								],
								[
									88.814248,
									27.299316
								],
								[
									88.730326,
									28.086865
								],
								[
									88.120441,
									27.876542
								],
								[
									86.954517,
									27.974262
								],
								[
									85.82332,
									28.203576
								],
								[
									85.011638,
									28.642774
								],
								[
									84.23458,
									28.839894
								],
								[
									83.898993,
									29.320226
								],
								[
									83.337115,
									29.463732
								],
								[
									82.327513,
									30.115268
								],
								[
									81.525804,
									30.422717
								],
								[
									81.111256,
									30.183481
								],
								[
									79.721367,
									30.882715
								],
								[
									78.738894,
									31.515906
								],
								[
									78.458446,
									32.618164
								],
								[
									79.176129,
									32.48378
								],
								[
									79.208892,
									32.994395
								],
								[
									78.811086,
									33.506198
								],
								[
									78.912269,
									34.321936
								],
								[
									77.837451,
									35.49401
								],
								[
									76.192848,
									35.898403
								],
								[
									75.896897,
									36.666806
								],
								[
									75.158028,
									37.133031
								],
								[
									74.980002,
									37.41999
								],
								[
									74.829986,
									37.990007
								],
								[
									74.864816,
									38.378846
								],
								[
									74.257514,
									38.606507
								],
								[
									73.928852,
									38.505815
								],
								[
									73.675379,
									39.431237
								],
								[
									73.960013,
									39.660008
								],
								[
									73.822244,
									39.893973
								],
								[
									74.776862,
									40.366425
								],
								[
									75.467828,
									40.562072
								],
								[
									76.526368,
									40.427946
								],
								[
									76.904484,
									41.066486
								],
								[
									78.187197,
									41.185316
								],
								[
									78.543661,
									41.582243
								],
								[
									80.11943,
									42.123941
								],
								[
									80.25999,
									42.349999
								],
								[
									80.18015,
									42.920068
								],
								[
									80.866206,
									43.180362
								],
								[
									79.966106,
									44.917517
								],
								[
									81.947071,
									45.317027
								],
								[
									82.458926,
									45.53965
								],
								[
									83.180484,
									47.330031
								],
								[
									85.16429,
									47.000956
								],
								[
									85.720484,
									47.452969
								],
								[
									85.768233,
									48.455751
								],
								[
									86.598776,
									48.549182
								],
								[
									87.35997,
									49.214981
								],
								[
									87.751264,
									49.297198
								],
								[
									88.013832,
									48.599463
								],
								[
									88.854298,
									48.069082
								],
								[
									90.280826,
									47.693549
								],
								[
									90.970809,
									46.888146
								],
								[
									90.585768,
									45.719716
								],
								[
									90.94554,
									45.286073
								],
								[
									92.133891,
									45.115076
								],
								[
									93.480734,
									44.975472
								],
								[
									94.688929,
									44.352332
								],
								[
									95.306875,
									44.241331
								],
								[
									95.762455,
									43.319449
								],
								[
									96.349396,
									42.725635
								],
								[
									97.451757,
									42.74889
								],
								[
									99.515817,
									42.524691
								],
								[
									100.845866,
									42.663804
								],
								[
									101.83304,
									42.514873
								],
								[
									103.312278,
									41.907468
								],
								[
									104.522282,
									41.908347
								],
								[
									104.964994,
									41.59741
								],
								[
									106.129316,
									42.134328
								],
								[
									107.744773,
									42.481516
								],
								[
									109.243596,
									42.519446
								],
								[
									110.412103,
									42.871234
								],
								[
									111.129682,
									43.406834
								],
								[
									111.829588,
									43.743118
								],
								[
									111.667737,
									44.073176
								],
								[
									111.348377,
									44.457442
								],
								[
									111.873306,
									45.102079
								],
								[
									112.436062,
									45.011646
								],
								[
									113.463907,
									44.808893
								],
								[
									114.460332,
									45.339817
								],
								[
									115.985096,
									45.727235
								],
								[
									116.717868,
									46.388202
								],
								[
									117.421701,
									46.672733
								],
								[
									118.874326,
									46.805412
								],
								[
									119.66327,
									46.69268
								],
								[
									119.772824,
									47.048059
								],
								[
									118.866574,
									47.74706
								],
								[
									118.064143,
									48.06673
								],
								[
									117.295507,
									47.697709
								],
								[
									116.308953,
									47.85341
								],
								[
									115.742837,
									47.726545
								],
								[
									115.485282,
									48.135383
								],
								[
									116.191802,
									49.134598
								],
								[
									116.678801,
									49.888531
								],
								[
									117.879244,
									49.510983
								],
								[
									119.288461,
									50.142883
								],
								[
									119.279366,
									50.582908
								],
								[
									120.18205,
									51.643566
								],
								[
									120.738191,
									51.964115
								],
								[
									120.725789,
									52.516226
								],
								[
									120.177089,
									52.753886
								],
								[
									121.003085,
									53.251401
								],
								[
									122.245748,
									53.431726
								],
								[
									123.571507,
									53.458804
								],
								[
									125.068211,
									53.161045
								],
								[
									125.946349,
									52.792799
								],
								[
									126.564399,
									51.784255
								],
								[
									126.939157,
									51.353894
								],
								[
									127.287456,
									50.739797
								],
								[
									127.657407,
									49.76027
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CIV",
				"properties": {
					"name": "Ivory Coast"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-2.856125,
								4.994476
							],
							[
								-3.311084,
								4.984296
							],
							[
								-4.00882,
								5.179813
							],
							[
								-4.649917,
								5.168264
							],
							[
								-5.834496,
								4.993701
							],
							[
								-6.528769,
								4.705088
							],
							[
								-7.518941,
								4.338288
							],
							[
								-7.712159,
								4.364566
							],
							[
								-7.635368,
								5.188159
							],
							[
								-7.539715,
								5.313345
							],
							[
								-7.570153,
								5.707352
							],
							[
								-7.993693,
								6.12619
							],
							[
								-8.311348,
								6.193033
							],
							[
								-8.60288,
								6.467564
							],
							[
								-8.385452,
								6.911801
							],
							[
								-8.485446,
								7.395208
							],
							[
								-8.439298,
								7.686043
							],
							[
								-8.280703,
								7.68718
							],
							[
								-8.221792,
								8.123329
							],
							[
								-8.299049,
								8.316444
							],
							[
								-8.203499,
								8.455453
							],
							[
								-7.8321,
								8.575704
							],
							[
								-8.079114,
								9.376224
							],
							[
								-8.309616,
								9.789532
							],
							[
								-8.229337,
								10.12902
							],
							[
								-8.029944,
								10.206535
							],
							[
								-7.89959,
								10.297382
							],
							[
								-7.622759,
								10.147236
							],
							[
								-6.850507,
								10.138994
							],
							[
								-6.666461,
								10.430811
							],
							[
								-6.493965,
								10.411303
							],
							[
								-6.205223,
								10.524061
							],
							[
								-6.050452,
								10.096361
							],
							[
								-5.816926,
								10.222555
							],
							[
								-5.404342,
								10.370737
							],
							[
								-4.954653,
								10.152714
							],
							[
								-4.779884,
								9.821985
							],
							[
								-4.330247,
								9.610835
							],
							[
								-3.980449,
								9.862344
							],
							[
								-3.511899,
								9.900326
							],
							[
								-2.827496,
								9.642461
							],
							[
								-2.56219,
								8.219628
							],
							[
								-2.983585,
								7.379705
							],
							[
								-3.24437,
								6.250472
							],
							[
								-2.810701,
								5.389051
							],
							[
								-2.856125,
								4.994476
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CMR",
				"properties": {
					"name": "Cameroon"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								13.075822,
								2.267097
							],
							[
								12.951334,
								2.321616
							],
							[
								12.35938,
								2.192812
							],
							[
								11.751665,
								2.326758
							],
							[
								11.276449,
								2.261051
							],
							[
								9.649158,
								2.283866
							],
							[
								9.795196,
								3.073404
							],
							[
								9.404367,
								3.734527
							],
							[
								8.948116,
								3.904129
							],
							[
								8.744924,
								4.352215
							],
							[
								8.488816,
								4.495617
							],
							[
								8.500288,
								4.771983
							],
							[
								8.757533,
								5.479666
							],
							[
								9.233163,
								6.444491
							],
							[
								9.522706,
								6.453482
							],
							[
								10.118277,
								7.03877
							],
							[
								10.497375,
								7.055358
							],
							[
								11.058788,
								6.644427
							],
							[
								11.745774,
								6.981383
							],
							[
								11.839309,
								7.397042
							],
							[
								12.063946,
								7.799808
							],
							[
								12.218872,
								8.305824
							],
							[
								12.753672,
								8.717763
							],
							[
								12.955468,
								9.417772
							],
							[
								13.1676,
								9.640626
							],
							[
								13.308676,
								10.160362
							],
							[
								13.57295,
								10.798566
							],
							[
								14.415379,
								11.572369
							],
							[
								14.468192,
								11.904752
							],
							[
								14.577178,
								12.085361
							],
							[
								14.181336,
								12.483657
							],
							[
								14.213531,
								12.802035
							],
							[
								14.495787,
								12.859396
							],
							[
								14.893386,
								12.219048
							],
							[
								14.960152,
								11.555574
							],
							[
								14.923565,
								10.891325
							],
							[
								15.467873,
								9.982337
							],
							[
								14.909354,
								9.992129
							],
							[
								14.627201,
								9.920919
							],
							[
								14.171466,
								10.021378
							],
							[
								13.954218,
								9.549495
							],
							[
								14.544467,
								8.965861
							],
							[
								14.979996,
								8.796104
							],
							[
								15.120866,
								8.38215
							],
							[
								15.436092,
								7.692812
							],
							[
								15.27946,
								7.421925
							],
							[
								14.776545,
								6.408498
							],
							[
								14.53656,
								6.226959
							],
							[
								14.459407,
								5.451761
							],
							[
								14.558936,
								5.030598
							],
							[
								14.478372,
								4.732605
							],
							[
								14.950953,
								4.210389
							],
							[
								15.03622,
								3.851367
							],
							[
								15.405396,
								3.335301
							],
							[
								15.862732,
								3.013537
							],
							[
								15.907381,
								2.557389
							],
							[
								16.012852,
								2.26764
							],
							[
								15.940919,
								1.727673
							],
							[
								15.146342,
								1.964015
							],
							[
								14.337813,
								2.227875
							],
							[
								13.075822,
								2.267097
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "COD",
				"properties": {
					"name": "Democratic Republic of the Congo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								30.83386,
								3.509166
							],
							[
								30.773347,
								2.339883
							],
							[
								31.174149,
								2.204465
							],
							[
								30.85267,
								1.849396
							],
							[
								30.468508,
								1.583805
							],
							[
								30.086154,
								1.062313
							],
							[
								29.875779,
								0.59738
							],
							[
								29.819503,
								-0.20531
							],
							[
								29.587838,
								-0.587406
							],
							[
								29.579466,
								-1.341313
							],
							[
								29.291887,
								-1.620056
							],
							[
								29.254835,
								-2.21511
							],
							[
								29.117479,
								-2.292211
							],
							[
								29.024926,
								-2.839258
							],
							[
								29.276384,
								-3.293907
							],
							[
								29.339998,
								-4.499983
							],
							[
								29.519987,
								-5.419979
							],
							[
								29.419993,
								-5.939999
							],
							[
								29.620032,
								-6.520015
							],
							[
								30.199997,
								-7.079981
							],
							[
								30.740015,
								-8.340007
							],
							[
								30.346086,
								-8.238257
							],
							[
								29.002912,
								-8.407032
							],
							[
								28.734867,
								-8.526559
							],
							[
								28.449871,
								-9.164918
							],
							[
								28.673682,
								-9.605925
							],
							[
								28.49607,
								-10.789884
							],
							[
								28.372253,
								-11.793647
							],
							[
								28.642417,
								-11.971569
							],
							[
								29.341548,
								-12.360744
							],
							[
								29.616001,
								-12.178895
							],
							[
								29.699614,
								-13.257227
							],
							[
								28.934286,
								-13.248958
							],
							[
								28.523562,
								-12.698604
							],
							[
								28.155109,
								-12.272481
							],
							[
								27.388799,
								-12.132747
							],
							[
								27.16442,
								-11.608748
							],
							[
								26.553088,
								-11.92444
							],
							[
								25.75231,
								-11.784965
							],
							[
								25.418118,
								-11.330936
							],
							[
								24.78317,
								-11.238694
							],
							[
								24.314516,
								-11.262826
							],
							[
								24.257155,
								-10.951993
							],
							[
								23.912215,
								-10.926826
							],
							[
								23.456791,
								-10.867863
							],
							[
								22.837345,
								-11.017622
							],
							[
								22.402798,
								-10.993075
							],
							[
								22.155268,
								-11.084801
							],
							[
								22.208753,
								-9.894796
							],
							[
								21.875182,
								-9.523708
							],
							[
								21.801801,
								-8.908707
							],
							[
								21.949131,
								-8.305901
							],
							[
								21.746456,
								-7.920085
							],
							[
								21.728111,
								-7.290872
							],
							[
								20.514748,
								-7.299606
							],
							[
								20.601823,
								-6.939318
							],
							[
								20.091622,
								-6.94309
							],
							[
								20.037723,
								-7.116361
							],
							[
								19.417502,
								-7.155429
							],
							[
								19.166613,
								-7.738184
							],
							[
								19.016752,
								-7.988246
							],
							[
								18.464176,
								-7.847014
							],
							[
								18.134222,
								-7.987678
							],
							[
								17.47297,
								-8.068551
							],
							[
								17.089996,
								-7.545689
							],
							[
								16.860191,
								-7.222298
							],
							[
								16.57318,
								-6.622645
							],
							[
								16.326528,
								-5.87747
							],
							[
								13.375597,
								-5.864241
							],
							[
								13.024869,
								-5.984389
							],
							[
								12.735171,
								-5.965682
							],
							[
								12.322432,
								-6.100092
							],
							[
								12.182337,
								-5.789931
							],
							[
								12.436688,
								-5.684304
							],
							[
								12.468004,
								-5.248362
							],
							[
								12.631612,
								-4.991271
							],
							[
								12.995517,
								-4.781103
							],
							[
								13.25824,
								-4.882957
							],
							[
								13.600235,
								-4.500138
							],
							[
								14.144956,
								-4.510009
							],
							[
								14.209035,
								-4.793092
							],
							[
								14.582604,
								-4.970239
							],
							[
								15.170992,
								-4.343507
							],
							[
								15.75354,
								-3.855165
							],
							[
								16.00629,
								-3.535133
							],
							[
								15.972803,
								-2.712392
							],
							[
								16.407092,
								-1.740927
							],
							[
								16.865307,
								-1.225816
							],
							[
								17.523716,
								-0.74383
							],
							[
								17.638645,
								-0.424832
							],
							[
								17.663553,
								-0.058084
							],
							[
								17.82654,
								0.288923
							],
							[
								17.774192,
								0.855659
							],
							[
								17.898835,
								1.741832
							],
							[
								18.094276,
								2.365722
							],
							[
								18.393792,
								2.900443
							],
							[
								18.453065,
								3.504386
							],
							[
								18.542982,
								4.201785
							],
							[
								18.932312,
								4.709506
							],
							[
								19.467784,
								5.031528
							],
							[
								20.290679,
								4.691678
							],
							[
								20.927591,
								4.322786
							],
							[
								21.659123,
								4.224342
							],
							[
								22.405124,
								4.02916
							],
							[
								22.704124,
								4.633051
							],
							[
								22.84148,
								4.710126
							],
							[
								23.297214,
								4.609693
							],
							[
								24.410531,
								5.108784
							],
							[
								24.805029,
								4.897247
							],
							[
								25.128833,
								4.927245
							],
							[
								25.278798,
								5.170408
							],
							[
								25.650455,
								5.256088
							],
							[
								26.402761,
								5.150875
							],
							[
								27.044065,
								5.127853
							],
							[
								27.374226,
								5.233944
							],
							[
								27.979977,
								4.408413
							],
							[
								28.428994,
								4.287155
							],
							[
								28.696678,
								4.455077
							],
							[
								29.159078,
								4.389267
							],
							[
								29.715995,
								4.600805
							],
							[
								29.9535,
								4.173699
							],
							[
								30.83386,
								3.509166
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "COG",
				"properties": {
					"name": "Republic of the Congo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								12.995517,
								-4.781103
							],
							[
								12.62076,
								-4.438023
							],
							[
								12.318608,
								-4.60623
							],
							[
								11.914963,
								-5.037987
							],
							[
								11.093773,
								-3.978827
							],
							[
								11.855122,
								-3.426871
							],
							[
								11.478039,
								-2.765619
							],
							[
								11.820964,
								-2.514161
							],
							[
								12.495703,
								-2.391688
							],
							[
								12.575284,
								-1.948511
							],
							[
								13.109619,
								-2.42874
							],
							[
								13.992407,
								-2.470805
							],
							[
								14.29921,
								-1.998276
							],
							[
								14.425456,
								-1.333407
							],
							[
								14.316418,
								-0.552627
							],
							[
								13.843321,
								0.038758
							],
							[
								14.276266,
								1.19693
							],
							[
								14.026669,
								1.395677
							],
							[
								13.282631,
								1.314184
							],
							[
								13.003114,
								1.830896
							],
							[
								13.075822,
								2.267097
							],
							[
								14.337813,
								2.227875
							],
							[
								15.146342,
								1.964015
							],
							[
								15.940919,
								1.727673
							],
							[
								16.012852,
								2.26764
							],
							[
								16.537058,
								3.198255
							],
							[
								17.133042,
								3.728197
							],
							[
								17.8099,
								3.560196
							],
							[
								18.453065,
								3.504386
							],
							[
								18.393792,
								2.900443
							],
							[
								18.094276,
								2.365722
							],
							[
								17.898835,
								1.741832
							],
							[
								17.774192,
								0.855659
							],
							[
								17.82654,
								0.288923
							],
							[
								17.663553,
								-0.058084
							],
							[
								17.638645,
								-0.424832
							],
							[
								17.523716,
								-0.74383
							],
							[
								16.865307,
								-1.225816
							],
							[
								16.407092,
								-1.740927
							],
							[
								15.972803,
								-2.712392
							],
							[
								16.00629,
								-3.535133
							],
							[
								15.75354,
								-3.855165
							],
							[
								15.170992,
								-4.343507
							],
							[
								14.582604,
								-4.970239
							],
							[
								14.209035,
								-4.793092
							],
							[
								14.144956,
								-4.510009
							],
							[
								13.600235,
								-4.500138
							],
							[
								13.25824,
								-4.882957
							],
							[
								12.995517,
								-4.781103
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "COL",
				"properties": {
					"name": "Colombia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-75.373223,
								-0.152032
							],
							[
								-75.801466,
								0.084801
							],
							[
								-76.292314,
								0.416047
							],
							[
								-76.57638,
								0.256936
							],
							[
								-77.424984,
								0.395687
							],
							[
								-77.668613,
								0.825893
							],
							[
								-77.855061,
								0.809925
							],
							[
								-78.855259,
								1.380924
							],
							[
								-78.990935,
								1.69137
							],
							[
								-78.617831,
								1.766404
							],
							[
								-78.662118,
								2.267355
							],
							[
								-78.42761,
								2.629556
							],
							[
								-77.931543,
								2.696606
							],
							[
								-77.510431,
								3.325017
							],
							[
								-77.12769,
								3.849636
							],
							[
								-77.496272,
								4.087606
							],
							[
								-77.307601,
								4.667984
							],
							[
								-77.533221,
								5.582812
							],
							[
								-77.318815,
								5.845354
							],
							[
								-77.476661,
								6.691116
							],
							[
								-77.881571,
								7.223771
							],
							[
								-77.753414,
								7.70984
							],
							[
								-77.431108,
								7.638061
							],
							[
								-77.242566,
								7.935278
							],
							[
								-77.474723,
								8.524286
							],
							[
								-77.353361,
								8.670505
							],
							[
								-76.836674,
								8.638749
							],
							[
								-76.086384,
								9.336821
							],
							[
								-75.6746,
								9.443248
							],
							[
								-75.664704,
								9.774003
							],
							[
								-75.480426,
								10.61899
							],
							[
								-74.906895,
								11.083045
							],
							[
								-74.276753,
								11.102036
							],
							[
								-74.197223,
								11.310473
							],
							[
								-73.414764,
								11.227015
							],
							[
								-72.627835,
								11.731972
							],
							[
								-72.238195,
								11.95555
							],
							[
								-71.75409,
								12.437303
							],
							[
								-71.399822,
								12.376041
							],
							[
								-71.137461,
								12.112982
							],
							[
								-71.331584,
								11.776284
							],
							[
								-71.973922,
								11.608672
							],
							[
								-72.227575,
								11.108702
							],
							[
								-72.614658,
								10.821975
							],
							[
								-72.905286,
								10.450344
							],
							[
								-73.027604,
								9.73677
							],
							[
								-73.304952,
								9.152
							],
							[
								-72.78873,
								9.085027
							],
							[
								-72.660495,
								8.625288
							],
							[
								-72.439862,
								8.405275
							],
							[
								-72.360901,
								8.002638
							],
							[
								-72.479679,
								7.632506
							],
							[
								-72.444487,
								7.423785
							],
							[
								-72.198352,
								7.340431
							],
							[
								-71.960176,
								6.991615
							],
							[
								-70.674234,
								7.087785
							],
							[
								-70.093313,
								6.960376
							],
							[
								-69.38948,
								6.099861
							],
							[
								-68.985319,
								6.206805
							],
							[
								-68.265052,
								6.153268
							],
							[
								-67.695087,
								6.267318
							],
							[
								-67.34144,
								6.095468
							],
							[
								-67.521532,
								5.55687
							],
							[
								-67.744697,
								5.221129
							],
							[
								-67.823012,
								4.503937
							],
							[
								-67.621836,
								3.839482
							],
							[
								-67.337564,
								3.542342
							],
							[
								-67.303173,
								3.318454
							],
							[
								-67.809938,
								2.820655
							],
							[
								-67.447092,
								2.600281
							],
							[
								-67.181294,
								2.250638
							],
							[
								-66.876326,
								1.253361
							],
							[
								-67.065048,
								1.130112
							],
							[
								-67.259998,
								1.719999
							],
							[
								-67.53781,
								2.037163
							],
							[
								-67.868565,
								1.692455
							],
							[
								-69.816973,
								1.714805
							],
							[
								-69.804597,
								1.089081
							],
							[
								-69.218638,
								0.985677
							],
							[
								-69.252434,
								0.602651
							],
							[
								-69.452396,
								0.706159
							],
							[
								-70.015566,
								0.541414
							],
							[
								-70.020656,
								-0.185156
							],
							[
								-69.577065,
								-0.549992
							],
							[
								-69.420486,
								-1.122619
							],
							[
								-69.444102,
								-1.556287
							],
							[
								-69.893635,
								-4.298187
							],
							[
								-70.394044,
								-3.766591
							],
							[
								-70.692682,
								-3.742872
							],
							[
								-70.047709,
								-2.725156
							],
							[
								-70.813476,
								-2.256865
							],
							[
								-71.413646,
								-2.342802
							],
							[
								-71.774761,
								-2.16979
							],
							[
								-72.325787,
								-2.434218
							],
							[
								-73.070392,
								-2.308954
							],
							[
								-73.659504,
								-1.260491
							],
							[
								-74.122395,
								-1.002833
							],
							[
								-74.441601,
								-0.53082
							],
							[
								-75.106625,
								-0.057205
							],
							[
								-75.373223,
								-0.152032
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CRI",
				"properties": {
					"name": "Costa Rica"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-82.965783,
								8.225028
							],
							[
								-83.508437,
								8.446927
							],
							[
								-83.711474,
								8.656836
							],
							[
								-83.596313,
								8.830443
							],
							[
								-83.632642,
								9.051386
							],
							[
								-83.909886,
								9.290803
							],
							[
								-84.303402,
								9.487354
							],
							[
								-84.647644,
								9.615537
							],
							[
								-84.713351,
								9.908052
							],
							[
								-84.97566,
								10.086723
							],
							[
								-84.911375,
								9.795992
							],
							[
								-85.110923,
								9.55704
							],
							[
								-85.339488,
								9.834542
							],
							[
								-85.660787,
								9.933347
							],
							[
								-85.797445,
								10.134886
							],
							[
								-85.791709,
								10.439337
							],
							[
								-85.659314,
								10.754331
							],
							[
								-85.941725,
								10.895278
							],
							[
								-85.71254,
								11.088445
							],
							[
								-85.561852,
								11.217119
							],
							[
								-84.903003,
								10.952303
							],
							[
								-84.673069,
								11.082657
							],
							[
								-84.355931,
								10.999226
							],
							[
								-84.190179,
								10.79345
							],
							[
								-83.895054,
								10.726839
							],
							[
								-83.655612,
								10.938764
							],
							[
								-83.40232,
								10.395438
							],
							[
								-83.015677,
								9.992982
							],
							[
								-82.546196,
								9.566135
							],
							[
								-82.932891,
								9.476812
							],
							[
								-82.927155,
								9.07433
							],
							[
								-82.719183,
								8.925709
							],
							[
								-82.868657,
								8.807266
							],
							[
								-82.829771,
								8.626295
							],
							[
								-82.913176,
								8.423517
							],
							[
								-82.965783,
								8.225028
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CUB",
				"properties": {
					"name": "Cuba"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-82.268151,
								23.188611
							],
							[
								-81.404457,
								23.117271
							],
							[
								-80.618769,
								23.10598
							],
							[
								-79.679524,
								22.765303
							],
							[
								-79.281486,
								22.399202
							],
							[
								-78.347434,
								22.512166
							],
							[
								-77.993296,
								22.277194
							],
							[
								-77.146422,
								21.657851
							],
							[
								-76.523825,
								21.20682
							],
							[
								-76.19462,
								21.220565
							],
							[
								-75.598222,
								21.016624
							],
							[
								-75.67106,
								20.735091
							],
							[
								-74.933896,
								20.693905
							],
							[
								-74.178025,
								20.284628
							],
							[
								-74.296648,
								20.050379
							],
							[
								-74.961595,
								19.923435
							],
							[
								-75.63468,
								19.873774
							],
							[
								-76.323656,
								19.952891
							],
							[
								-77.755481,
								19.855481
							],
							[
								-77.085108,
								20.413354
							],
							[
								-77.492655,
								20.673105
							],
							[
								-78.137292,
								20.739949
							],
							[
								-78.482827,
								21.028613
							],
							[
								-78.719867,
								21.598114
							],
							[
								-79.285,
								21.559175
							],
							[
								-80.217475,
								21.827324
							],
							[
								-80.517535,
								22.037079
							],
							[
								-81.820943,
								22.192057
							],
							[
								-82.169992,
								22.387109
							],
							[
								-81.795002,
								22.636965
							],
							[
								-82.775898,
								22.68815
							],
							[
								-83.494459,
								22.168518
							],
							[
								-83.9088,
								22.154565
							],
							[
								-84.052151,
								21.910575
							],
							[
								-84.54703,
								21.801228
							],
							[
								-84.974911,
								21.896028
							],
							[
								-84.447062,
								22.20495
							],
							[
								-84.230357,
								22.565755
							],
							[
								-83.77824,
								22.788118
							],
							[
								-83.267548,
								22.983042
							],
							[
								-82.510436,
								23.078747
							],
							[
								-82.268151,
								23.188611
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "-99",
				"properties": {
					"name": "Northern Cyprus"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								32.73178,
								35.140026
							],
							[
								32.802474,
								35.145504
							],
							[
								32.946961,
								35.386703
							],
							[
								33.667227,
								35.373216
							],
							[
								34.576474,
								35.671596
							],
							[
								33.900804,
								35.245756
							],
							[
								33.973617,
								35.058506
							],
							[
								33.86644,
								35.093595
							],
							[
								33.675392,
								35.017863
							],
							[
								33.525685,
								35.038688
							],
							[
								33.475817,
								35.000345
							],
							[
								33.455922,
								35.101424
							],
							[
								33.383833,
								35.162712
							],
							[
								33.190977,
								35.173125
							],
							[
								32.919572,
								35.087833
							],
							[
								32.73178,
								35.140026
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CYP",
				"properties": {
					"name": "Cyprus"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.973617,
								35.058506
							],
							[
								34.004881,
								34.978098
							],
							[
								32.979827,
								34.571869
							],
							[
								32.490296,
								34.701655
							],
							[
								32.256667,
								35.103232
							],
							[
								32.73178,
								35.140026
							],
							[
								32.919572,
								35.087833
							],
							[
								33.190977,
								35.173125
							],
							[
								33.383833,
								35.162712
							],
							[
								33.455922,
								35.101424
							],
							[
								33.475817,
								35.000345
							],
							[
								33.525685,
								35.038688
							],
							[
								33.675392,
								35.017863
							],
							[
								33.86644,
								35.093595
							],
							[
								33.973617,
								35.058506
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CZE",
				"properties": {
					"name": "Czech Republic"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.960288,
								48.596982
							],
							[
								16.499283,
								48.785808
							],
							[
								16.029647,
								48.733899
							],
							[
								15.253416,
								49.039074
							],
							[
								14.901447,
								48.964402
							],
							[
								14.338898,
								48.555305
							],
							[
								13.595946,
								48.877172
							],
							[
								13.031329,
								49.307068
							],
							[
								12.521024,
								49.547415
							],
							[
								12.415191,
								49.969121
							],
							[
								12.240111,
								50.266338
							],
							[
								12.966837,
								50.484076
							],
							[
								13.338132,
								50.733234
							],
							[
								14.056228,
								50.926918
							],
							[
								14.307013,
								51.117268
							],
							[
								14.570718,
								51.002339
							],
							[
								15.016996,
								51.106674
							],
							[
								15.490972,
								50.78473
							],
							[
								16.238627,
								50.697733
							],
							[
								16.176253,
								50.422607
							],
							[
								16.719476,
								50.215747
							],
							[
								16.868769,
								50.473974
							],
							[
								17.554567,
								50.362146
							],
							[
								17.649445,
								50.049038
							],
							[
								18.392914,
								49.988629
							],
							[
								18.853144,
								49.49623
							],
							[
								18.554971,
								49.495015
							],
							[
								18.399994,
								49.315001
							],
							[
								18.170498,
								49.271515
							],
							[
								18.104973,
								49.043983
							],
							[
								17.913512,
								48.996493
							],
							[
								17.886485,
								48.903475
							],
							[
								17.545007,
								48.800019
							],
							[
								17.101985,
								48.816969
							],
							[
								16.960288,
								48.596982
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "DEU",
				"properties": {
					"name": "Germany"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.921906,
								54.983104
							],
							[
								9.93958,
								54.596642
							],
							[
								10.950112,
								54.363607
							],
							[
								10.939467,
								54.008693
							],
							[
								11.956252,
								54.196486
							],
							[
								12.51844,
								54.470371
							],
							[
								13.647467,
								54.075511
							],
							[
								14.119686,
								53.757029
							],
							[
								14.353315,
								53.248171
							],
							[
								14.074521,
								52.981263
							],
							[
								14.4376,
								52.62485
							],
							[
								14.685026,
								52.089947
							],
							[
								14.607098,
								51.745188
							],
							[
								15.016996,
								51.106674
							],
							[
								14.570718,
								51.002339
							],
							[
								14.307013,
								51.117268
							],
							[
								14.056228,
								50.926918
							],
							[
								13.338132,
								50.733234
							],
							[
								12.966837,
								50.484076
							],
							[
								12.240111,
								50.266338
							],
							[
								12.415191,
								49.969121
							],
							[
								12.521024,
								49.547415
							],
							[
								13.031329,
								49.307068
							],
							[
								13.595946,
								48.877172
							],
							[
								13.243357,
								48.416115
							],
							[
								12.884103,
								48.289146
							],
							[
								13.025851,
								47.637584
							],
							[
								12.932627,
								47.467646
							],
							[
								12.62076,
								47.672388
							],
							[
								12.141357,
								47.703083
							],
							[
								11.426414,
								47.523766
							],
							[
								10.544504,
								47.566399
							],
							[
								10.402084,
								47.302488
							],
							[
								9.896068,
								47.580197
							],
							[
								9.594226,
								47.525058
							],
							[
								8.522612,
								47.830828
							],
							[
								8.317301,
								47.61358
							],
							[
								7.466759,
								47.620582
							],
							[
								7.593676,
								48.333019
							],
							[
								8.099279,
								49.017784
							],
							[
								6.65823,
								49.201958
							],
							[
								6.18632,
								49.463803
							],
							[
								6.242751,
								49.902226
							],
							[
								6.043073,
								50.128052
							],
							[
								6.156658,
								50.803721
							],
							[
								5.988658,
								51.851616
							],
							[
								6.589397,
								51.852029
							],
							[
								6.84287,
								52.22844
							],
							[
								7.092053,
								53.144043
							],
							[
								6.90514,
								53.482162
							],
							[
								7.100425,
								53.693932
							],
							[
								7.936239,
								53.748296
							],
							[
								8.121706,
								53.527792
							],
							[
								8.800734,
								54.020786
							],
							[
								8.572118,
								54.395646
							],
							[
								8.526229,
								54.962744
							],
							[
								9.282049,
								54.830865
							],
							[
								9.921906,
								54.983104
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "DJI",
				"properties": {
					"name": "Djibouti"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								43.081226,
								12.699639
							],
							[
								43.317852,
								12.390148
							],
							[
								43.286381,
								11.974928
							],
							[
								42.715874,
								11.735641
							],
							[
								43.145305,
								11.46204
							],
							[
								42.776852,
								10.926879
							],
							[
								42.55493,
								11.10511
							],
							[
								42.31414,
								11.0342
							],
							[
								41.75557,
								11.05091
							],
							[
								41.73959,
								11.35511
							],
							[
								41.66176,
								11.6312
							],
							[
								42,
								12.1
							],
							[
								42.35156,
								12.54223
							],
							[
								42.779642,
								12.455416
							],
							[
								43.081226,
								12.699639
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "DNK",
				"properties": {
					"name": "Denmark"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									12.690006,
									55.609991
								],
								[
									12.089991,
									54.800015
								],
								[
									11.043543,
									55.364864
								],
								[
									10.903914,
									55.779955
								],
								[
									12.370904,
									56.111407
								],
								[
									12.690006,
									55.609991
								]
							]
						],
						[
							[
								[
									10.912182,
									56.458621
								],
								[
									10.667804,
									56.081383
								],
								[
									10.369993,
									56.190007
								],
								[
									9.649985,
									55.469999
								],
								[
									9.921906,
									54.983104
								],
								[
									9.282049,
									54.830865
								],
								[
									8.526229,
									54.962744
								],
								[
									8.120311,
									55.517723
								],
								[
									8.089977,
									56.540012
								],
								[
									8.256582,
									56.809969
								],
								[
									8.543438,
									57.110003
								],
								[
									9.424469,
									57.172066
								],
								[
									9.775559,
									57.447941
								],
								[
									10.580006,
									57.730017
								],
								[
									10.546106,
									57.215733
								],
								[
									10.25,
									56.890016
								],
								[
									10.369993,
									56.609982
								],
								[
									10.912182,
									56.458621
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "DOM",
				"properties": {
					"name": "Dominican Republic"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-71.712361,
								19.714456
							],
							[
								-71.587304,
								19.884911
							],
							[
								-70.806706,
								19.880286
							],
							[
								-70.214365,
								19.622885
							],
							[
								-69.950815,
								19.648
							],
							[
								-69.76925,
								19.293267
							],
							[
								-69.222126,
								19.313214
							],
							[
								-69.254346,
								19.015196
							],
							[
								-68.809412,
								18.979074
							],
							[
								-68.317943,
								18.612198
							],
							[
								-68.689316,
								18.205142
							],
							[
								-69.164946,
								18.422648
							],
							[
								-69.623988,
								18.380713
							],
							[
								-69.952934,
								18.428307
							],
							[
								-70.133233,
								18.245915
							],
							[
								-70.517137,
								18.184291
							],
							[
								-70.669298,
								18.426886
							],
							[
								-70.99995,
								18.283329
							],
							[
								-71.40021,
								17.598564
							],
							[
								-71.657662,
								17.757573
							],
							[
								-71.708305,
								18.044997
							],
							[
								-71.687738,
								18.31666
							],
							[
								-71.945112,
								18.6169
							],
							[
								-71.701303,
								18.785417
							],
							[
								-71.624873,
								19.169838
							],
							[
								-71.712361,
								19.714456
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "DZA",
				"properties": {
					"name": "Algeria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								11.999506,
								23.471668
							],
							[
								8.572893,
								21.565661
							],
							[
								5.677566,
								19.601207
							],
							[
								4.267419,
								19.155265
							],
							[
								3.158133,
								19.057364
							],
							[
								3.146661,
								19.693579
							],
							[
								2.683588,
								19.85623
							],
							[
								2.060991,
								20.142233
							],
							[
								1.823228,
								20.610809
							],
							[
								-1.550055,
								22.792666
							],
							[
								-4.923337,
								24.974574
							],
							[
								-8.6844,
								27.395744
							],
							[
								-8.665124,
								27.589479
							],
							[
								-8.66559,
								27.656426
							],
							[
								-8.674116,
								28.841289
							],
							[
								-7.059228,
								29.579228
							],
							[
								-6.060632,
								29.7317
							],
							[
								-5.242129,
								30.000443
							],
							[
								-4.859646,
								30.501188
							],
							[
								-3.690441,
								30.896952
							],
							[
								-3.647498,
								31.637294
							],
							[
								-3.06898,
								31.724498
							],
							[
								-2.616605,
								32.094346
							],
							[
								-1.307899,
								32.262889
							],
							[
								-1.124551,
								32.651522
							],
							[
								-1.388049,
								32.864015
							],
							[
								-1.733455,
								33.919713
							],
							[
								-1.792986,
								34.527919
							],
							[
								-2.169914,
								35.168396
							],
							[
								-1.208603,
								35.714849
							],
							[
								-0.127454,
								35.888662
							],
							[
								0.503877,
								36.301273
							],
							[
								1.466919,
								36.605647
							],
							[
								3.161699,
								36.783905
							],
							[
								4.815758,
								36.865037
							],
							[
								5.32012,
								36.716519
							],
							[
								6.26182,
								37.110655
							],
							[
								7.330385,
								37.118381
							],
							[
								7.737078,
								36.885708
							],
							[
								8.420964,
								36.946427
							],
							[
								8.217824,
								36.433177
							],
							[
								8.376368,
								35.479876
							],
							[
								8.140981,
								34.655146
							],
							[
								7.524482,
								34.097376
							],
							[
								7.612642,
								33.344115
							],
							[
								8.430473,
								32.748337
							],
							[
								8.439103,
								32.506285
							],
							[
								9.055603,
								32.102692
							],
							[
								9.48214,
								30.307556
							],
							[
								9.805634,
								29.424638
							],
							[
								9.859998,
								28.95999
							],
							[
								9.683885,
								28.144174
							],
							[
								9.756128,
								27.688259
							],
							[
								9.629056,
								27.140953
							],
							[
								9.716286,
								26.512206
							],
							[
								9.319411,
								26.094325
							],
							[
								9.910693,
								25.365455
							],
							[
								9.948261,
								24.936954
							],
							[
								10.303847,
								24.379313
							],
							[
								10.771364,
								24.562532
							],
							[
								11.560669,
								24.097909
							],
							[
								11.999506,
								23.471668
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ECU",
				"properties": {
					"name": "Ecuador"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-80.302561,
								-3.404856
							],
							[
								-79.770293,
								-2.657512
							],
							[
								-79.986559,
								-2.220794
							],
							[
								-80.368784,
								-2.685159
							],
							[
								-80.967765,
								-2.246943
							],
							[
								-80.764806,
								-1.965048
							],
							[
								-80.933659,
								-1.057455
							],
							[
								-80.58337,
								-0.906663
							],
							[
								-80.399325,
								-0.283703
							],
							[
								-80.020898,
								0.36034
							],
							[
								-80.09061,
								0.768429
							],
							[
								-79.542762,
								0.982938
							],
							[
								-78.855259,
								1.380924
							],
							[
								-77.855061,
								0.809925
							],
							[
								-77.668613,
								0.825893
							],
							[
								-77.424984,
								0.395687
							],
							[
								-76.57638,
								0.256936
							],
							[
								-76.292314,
								0.416047
							],
							[
								-75.801466,
								0.084801
							],
							[
								-75.373223,
								-0.152032
							],
							[
								-75.233723,
								-0.911417
							],
							[
								-75.544996,
								-1.56161
							],
							[
								-76.635394,
								-2.608678
							],
							[
								-77.837905,
								-3.003021
							],
							[
								-78.450684,
								-3.873097
							],
							[
								-78.639897,
								-4.547784
							],
							[
								-79.205289,
								-4.959129
							],
							[
								-79.624979,
								-4.454198
							],
							[
								-80.028908,
								-4.346091
							],
							[
								-80.442242,
								-4.425724
							],
							[
								-80.469295,
								-4.059287
							],
							[
								-80.184015,
								-3.821162
							],
							[
								-80.302561,
								-3.404856
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "EGY",
				"properties": {
					"name": "Egypt"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								34.9226,
								29.50133
							],
							[
								34.64174,
								29.09942
							],
							[
								34.42655,
								28.34399
							],
							[
								34.15451,
								27.8233
							],
							[
								33.92136,
								27.6487
							],
							[
								33.58811,
								27.97136
							],
							[
								33.13676,
								28.41765
							],
							[
								32.42323,
								29.85108
							],
							[
								32.32046,
								29.76043
							],
							[
								32.73482,
								28.70523
							],
							[
								33.34876,
								27.69989
							],
							[
								34.10455,
								26.14227
							],
							[
								34.47387,
								25.59856
							],
							[
								34.79507,
								25.03375
							],
							[
								35.69241,
								23.92671
							],
							[
								35.49372,
								23.75237
							],
							[
								35.52598,
								23.10244
							],
							[
								36.69069,
								22.20485
							],
							[
								36.86623,
								22
							],
							[
								32.9,
								22
							],
							[
								29.02,
								22
							],
							[
								25,
								22
							],
							[
								25,
								25.6825
							],
							[
								25,
								29.238655
							],
							[
								24.70007,
								30.04419
							],
							[
								24.95762,
								30.6616
							],
							[
								24.80287,
								31.08929
							],
							[
								25.16482,
								31.56915
							],
							[
								26.49533,
								31.58568
							],
							[
								27.45762,
								31.32126
							],
							[
								28.45048,
								31.02577
							],
							[
								28.91353,
								30.87005
							],
							[
								29.68342,
								31.18686
							],
							[
								30.09503,
								31.4734
							],
							[
								30.97693,
								31.55586
							],
							[
								31.68796,
								31.4296
							],
							[
								31.96041,
								30.9336
							],
							[
								32.19247,
								31.26034
							],
							[
								32.99392,
								31.02407
							],
							[
								33.7734,
								30.96746
							],
							[
								34.26544,
								31.21936
							],
							[
								34.9226,
								29.50133
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ERI",
				"properties": {
					"name": "Eritrea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								42.35156,
								12.54223
							],
							[
								42.00975,
								12.86582
							],
							[
								41.59856,
								13.45209
							],
							[
								41.155194,
								13.77332
							],
							[
								40.8966,
								14.11864
							],
							[
								40.026219,
								14.519579
							],
							[
								39.34061,
								14.53155
							],
							[
								39.0994,
								14.74064
							],
							[
								38.51295,
								14.50547
							],
							[
								37.90607,
								14.95943
							],
							[
								37.59377,
								14.2131
							],
							[
								36.42951,
								14.42211
							],
							[
								36.323189,
								14.822481
							],
							[
								36.75386,
								16.291874
							],
							[
								36.85253,
								16.95655
							],
							[
								37.16747,
								17.26314
							],
							[
								37.904,
								17.42754
							],
							[
								38.41009,
								17.998307
							],
							[
								38.990623,
								16.840626
							],
							[
								39.26611,
								15.922723
							],
							[
								39.814294,
								15.435647
							],
							[
								41.179275,
								14.49108
							],
							[
								41.734952,
								13.921037
							],
							[
								42.276831,
								13.343992
							],
							[
								42.589576,
								13.000421
							],
							[
								43.081226,
								12.699639
							],
							[
								42.779642,
								12.455416
							],
							[
								42.35156,
								12.54223
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ESP",
				"properties": {
					"name": "Spain"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-9.034818,
								41.880571
							],
							[
								-8.984433,
								42.592775
							],
							[
								-9.392884,
								43.026625
							],
							[
								-7.97819,
								43.748338
							],
							[
								-6.754492,
								43.567909
							],
							[
								-5.411886,
								43.57424
							],
							[
								-4.347843,
								43.403449
							],
							[
								-3.517532,
								43.455901
							],
							[
								-1.901351,
								43.422802
							],
							[
								-1.502771,
								43.034014
							],
							[
								0.338047,
								42.579546
							],
							[
								0.701591,
								42.795734
							],
							[
								1.826793,
								42.343385
							],
							[
								2.985999,
								42.473015
							],
							[
								3.039484,
								41.89212
							],
							[
								2.091842,
								41.226089
							],
							[
								0.810525,
								41.014732
							],
							[
								0.721331,
								40.678318
							],
							[
								0.106692,
								40.123934
							],
							[
								-0.278711,
								39.309978
							],
							[
								0.111291,
								38.738514
							],
							[
								-0.467124,
								38.292366
							],
							[
								-0.683389,
								37.642354
							],
							[
								-1.438382,
								37.443064
							],
							[
								-2.146453,
								36.674144
							],
							[
								-3.415781,
								36.6589
							],
							[
								-4.368901,
								36.677839
							],
							[
								-4.995219,
								36.324708
							],
							[
								-5.37716,
								35.94685
							],
							[
								-5.866432,
								36.029817
							],
							[
								-6.236694,
								36.367677
							],
							[
								-6.520191,
								36.942913
							],
							[
								-7.453726,
								37.097788
							],
							[
								-7.537105,
								37.428904
							],
							[
								-7.166508,
								37.803894
							],
							[
								-7.029281,
								38.075764
							],
							[
								-7.374092,
								38.373059
							],
							[
								-7.098037,
								39.030073
							],
							[
								-7.498632,
								39.629571
							],
							[
								-7.066592,
								39.711892
							],
							[
								-7.026413,
								40.184524
							],
							[
								-6.86402,
								40.330872
							],
							[
								-6.851127,
								41.111083
							],
							[
								-6.389088,
								41.381815
							],
							[
								-6.668606,
								41.883387
							],
							[
								-7.251309,
								41.918346
							],
							[
								-7.422513,
								41.792075
							],
							[
								-8.013175,
								41.790886
							],
							[
								-8.263857,
								42.280469
							],
							[
								-8.671946,
								42.134689
							],
							[
								-9.034818,
								41.880571
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "EST",
				"properties": {
					"name": "Estonia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								24.312863,
								57.793424
							],
							[
								24.428928,
								58.383413
							],
							[
								24.061198,
								58.257375
							],
							[
								23.42656,
								58.612753
							],
							[
								23.339795,
								59.18724
							],
							[
								24.604214,
								59.465854
							],
							[
								25.864189,
								59.61109
							],
							[
								26.949136,
								59.445803
							],
							[
								27.981114,
								59.475388
							],
							[
								28.131699,
								59.300825
							],
							[
								27.420166,
								58.724581
							],
							[
								27.716686,
								57.791899
							],
							[
								27.288185,
								57.474528
							],
							[
								26.463532,
								57.476389
							],
							[
								25.60281,
								57.847529
							],
							[
								25.164594,
								57.970157
							],
							[
								24.312863,
								57.793424
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ETH",
				"properties": {
					"name": "Ethiopia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								37.90607,
								14.95943
							],
							[
								38.51295,
								14.50547
							],
							[
								39.0994,
								14.74064
							],
							[
								39.34061,
								14.53155
							],
							[
								40.02625,
								14.51959
							],
							[
								40.8966,
								14.11864
							],
							[
								41.1552,
								13.77333
							],
							[
								41.59856,
								13.45209
							],
							[
								42.00975,
								12.86582
							],
							[
								42.35156,
								12.54223
							],
							[
								42,
								12.1
							],
							[
								41.66176,
								11.6312
							],
							[
								41.73959,
								11.35511
							],
							[
								41.75557,
								11.05091
							],
							[
								42.31414,
								11.0342
							],
							[
								42.55493,
								11.10511
							],
							[
								42.776852,
								10.926879
							],
							[
								42.55876,
								10.57258
							],
							[
								42.92812,
								10.02194
							],
							[
								43.29699,
								9.54048
							],
							[
								43.67875,
								9.18358
							],
							[
								46.94834,
								7.99688
							],
							[
								47.78942,
								8.003
							],
							[
								44.9636,
								5.00162
							],
							[
								43.66087,
								4.95755
							],
							[
								42.76967,
								4.25259
							],
							[
								42.12861,
								4.23413
							],
							[
								41.855083,
								3.918912
							],
							[
								41.1718,
								3.91909
							],
							[
								40.76848,
								4.25702
							],
							[
								39.85494,
								3.83879
							],
							[
								39.559384,
								3.42206
							],
							[
								38.89251,
								3.50074
							],
							[
								38.67114,
								3.61607
							],
							[
								38.43697,
								3.58851
							],
							[
								38.120915,
								3.598605
							],
							[
								36.855093,
								4.447864
							],
							[
								36.159079,
								4.447864
							],
							[
								35.817448,
								4.776966
							],
							[
								35.817448,
								5.338232
							],
							[
								35.298007,
								5.506
							],
							[
								34.70702,
								6.59422
							],
							[
								34.25032,
								6.82607
							],
							[
								34.0751,
								7.22595
							],
							[
								33.56829,
								7.71334
							],
							[
								32.95418,
								7.78497
							],
							[
								33.2948,
								8.35458
							],
							[
								33.8255,
								8.37916
							],
							[
								33.97498,
								8.68456
							],
							[
								33.96162,
								9.58358
							],
							[
								34.25745,
								10.63009
							],
							[
								34.73115,
								10.91017
							],
							[
								34.83163,
								11.31896
							],
							[
								35.26049,
								12.08286
							],
							[
								35.86363,
								12.57828
							],
							[
								36.27022,
								13.56333
							],
							[
								36.42951,
								14.42211
							],
							[
								37.59377,
								14.2131
							],
							[
								37.90607,
								14.95943
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "FIN",
				"properties": {
					"name": "Finland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								28.59193,
								69.064777
							],
							[
								28.445944,
								68.364613
							],
							[
								29.977426,
								67.698297
							],
							[
								29.054589,
								66.944286
							],
							[
								30.21765,
								65.80598
							],
							[
								29.54443,
								64.948672
							],
							[
								30.444685,
								64.204453
							],
							[
								30.035872,
								63.552814
							],
							[
								31.516092,
								62.867687
							],
							[
								31.139991,
								62.357693
							],
							[
								30.211107,
								61.780028
							],
							[
								28.069998,
								60.503517
							],
							[
								26.255173,
								60.423961
							],
							[
								24.496624,
								60.057316
							],
							[
								22.869695,
								59.846373
							],
							[
								22.290764,
								60.391921
							],
							[
								21.322244,
								60.72017
							],
							[
								21.544866,
								61.705329
							],
							[
								21.059211,
								62.607393
							],
							[
								21.536029,
								63.189735
							],
							[
								22.442744,
								63.81781
							],
							[
								24.730512,
								64.902344
							],
							[
								25.398068,
								65.111427
							],
							[
								25.294043,
								65.534346
							],
							[
								23.903379,
								66.006927
							],
							[
								23.56588,
								66.396051
							],
							[
								23.539473,
								67.936009
							],
							[
								21.978535,
								68.616846
							],
							[
								20.645593,
								69.106247
							],
							[
								21.244936,
								69.370443
							],
							[
								22.356238,
								68.841741
							],
							[
								23.66205,
								68.891247
							],
							[
								24.735679,
								68.649557
							],
							[
								25.689213,
								69.092114
							],
							[
								26.179622,
								69.825299
							],
							[
								27.732292,
								70.164193
							],
							[
								29.015573,
								69.766491
							],
							[
								28.59193,
								69.064777
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "FJI",
				"properties": {
					"name": "Fiji"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									178.3736,
									-17.33992
								],
								[
									178.71806,
									-17.62846
								],
								[
									178.55271,
									-18.15059
								],
								[
									177.93266,
									-18.28799
								],
								[
									177.38146,
									-18.16432
								],
								[
									177.28504,
									-17.72465
								],
								[
									177.67087,
									-17.38114
								],
								[
									178.12557,
									-17.50481
								],
								[
									178.3736,
									-17.33992
								]
							]
						],
						[
							[
								[
									179.364143,
									-16.801354
								],
								[
									178.725059,
									-17.012042
								],
								[
									178.596839,
									-16.63915
								],
								[
									179.096609,
									-16.433984
								],
								[
									179.413509,
									-16.379054
								],
								[
									180,
									-16.067133
								],
								[
									180,
									-16.555217
								],
								[
									179.364143,
									-16.801354
								]
							]
						],
						[
							[
								[
									-179.917369,
									-16.501783
								],
								[
									-180,
									-16.555217
								],
								[
									-180,
									-16.067133
								],
								[
									-179.79332,
									-16.020882
								],
								[
									-179.917369,
									-16.501783
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "FLK",
				"properties": {
					"name": "Falkland Islands"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-61.2,
								-51.85
							],
							[
								-60,
								-51.25
							],
							[
								-59.15,
								-51.5
							],
							[
								-58.55,
								-51.1
							],
							[
								-57.75,
								-51.55
							],
							[
								-58.05,
								-51.9
							],
							[
								-59.4,
								-52.2
							],
							[
								-59.85,
								-51.85
							],
							[
								-60.7,
								-52.3
							],
							[
								-61.2,
								-51.85
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "FRA",
				"properties": {
					"name": "France"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									9.560016,
									42.152492
								],
								[
									9.229752,
									41.380007
								],
								[
									8.775723,
									41.583612
								],
								[
									8.544213,
									42.256517
								],
								[
									8.746009,
									42.628122
								],
								[
									9.390001,
									43.009985
								],
								[
									9.560016,
									42.152492
								]
							]
						],
						[
							[
								[
									3.588184,
									50.378992
								],
								[
									4.286023,
									49.907497
								],
								[
									4.799222,
									49.985373
								],
								[
									5.674052,
									49.529484
								],
								[
									5.897759,
									49.442667
								],
								[
									6.18632,
									49.463803
								],
								[
									6.65823,
									49.201958
								],
								[
									8.099279,
									49.017784
								],
								[
									7.593676,
									48.333019
								],
								[
									7.466759,
									47.620582
								],
								[
									7.192202,
									47.449766
								],
								[
									6.736571,
									47.541801
								],
								[
									6.768714,
									47.287708
								],
								[
									6.037389,
									46.725779
								],
								[
									6.022609,
									46.27299
								],
								[
									6.5001,
									46.429673
								],
								[
									6.843593,
									45.991147
								],
								[
									6.802355,
									45.70858
								],
								[
									7.096652,
									45.333099
								],
								[
									6.749955,
									45.028518
								],
								[
									7.007562,
									44.254767
								],
								[
									7.549596,
									44.127901
								],
								[
									7.435185,
									43.693845
								],
								[
									6.529245,
									43.128892
								],
								[
									4.556963,
									43.399651
								],
								[
									3.100411,
									43.075201
								],
								[
									2.985999,
									42.473015
								],
								[
									1.826793,
									42.343385
								],
								[
									0.701591,
									42.795734
								],
								[
									0.338047,
									42.579546
								],
								[
									-1.502771,
									43.034014
								],
								[
									-1.901351,
									43.422802
								],
								[
									-1.384225,
									44.02261
								],
								[
									-1.193798,
									46.014918
								],
								[
									-2.225724,
									47.064363
								],
								[
									-2.963276,
									47.570327
								],
								[
									-4.491555,
									47.954954
								],
								[
									-4.59235,
									48.68416
								],
								[
									-3.295814,
									48.901692
								],
								[
									-1.616511,
									48.644421
								],
								[
									-1.933494,
									49.776342
								],
								[
									-0.989469,
									49.347376
								],
								[
									1.338761,
									50.127173
								],
								[
									1.639001,
									50.946606
								],
								[
									2.513573,
									51.148506
								],
								[
									2.658422,
									50.796848
								],
								[
									3.123252,
									50.780363
								],
								[
									3.588184,
									50.378992
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GAB",
				"properties": {
					"name": "Gabon"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								11.093773,
								-3.978827
							],
							[
								10.066135,
								-2.969483
							],
							[
								9.405245,
								-2.144313
							],
							[
								8.797996,
								-1.111301
							],
							[
								8.830087,
								-0.779074
							],
							[
								9.04842,
								-0.459351
							],
							[
								9.291351,
								0.268666
							],
							[
								9.492889,
								1.01012
							],
							[
								9.830284,
								1.067894
							],
							[
								11.285079,
								1.057662
							],
							[
								11.276449,
								2.261051
							],
							[
								11.751665,
								2.326758
							],
							[
								12.35938,
								2.192812
							],
							[
								12.951334,
								2.321616
							],
							[
								13.075822,
								2.267097
							],
							[
								13.003114,
								1.830896
							],
							[
								13.282631,
								1.314184
							],
							[
								14.026669,
								1.395677
							],
							[
								14.276266,
								1.19693
							],
							[
								13.843321,
								0.038758
							],
							[
								14.316418,
								-0.552627
							],
							[
								14.425456,
								-1.333407
							],
							[
								14.29921,
								-1.998276
							],
							[
								13.992407,
								-2.470805
							],
							[
								13.109619,
								-2.42874
							],
							[
								12.575284,
								-1.948511
							],
							[
								12.495703,
								-2.391688
							],
							[
								11.820964,
								-2.514161
							],
							[
								11.478039,
								-2.765619
							],
							[
								11.855122,
								-3.426871
							],
							[
								11.093773,
								-3.978827
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GBR",
				"properties": {
					"name": "United Kingdom"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-5.661949,
									54.554603
								],
								[
									-6.197885,
									53.867565
								],
								[
									-6.95373,
									54.073702
								],
								[
									-7.572168,
									54.059956
								],
								[
									-7.366031,
									54.595841
								],
								[
									-7.572168,
									55.131622
								],
								[
									-6.733847,
									55.17286
								],
								[
									-5.661949,
									54.554603
								]
							]
						],
						[
							[
								[
									-3.005005,
									58.635
								],
								[
									-4.073828,
									57.553025
								],
								[
									-3.055002,
									57.690019
								],
								[
									-1.959281,
									57.6848
								],
								[
									-2.219988,
									56.870017
								],
								[
									-3.119003,
									55.973793
								],
								[
									-2.085009,
									55.909998
								],
								[
									-2.005676,
									55.804903
								],
								[
									-1.114991,
									54.624986
								],
								[
									-0.430485,
									54.464376
								],
								[
									0.184981,
									53.325014
								],
								[
									0.469977,
									52.929999
								],
								[
									1.681531,
									52.73952
								],
								[
									1.559988,
									52.099998
								],
								[
									1.050562,
									51.806761
								],
								[
									1.449865,
									51.289428
								],
								[
									0.550334,
									50.765739
								],
								[
									-0.787517,
									50.774989
								],
								[
									-2.489998,
									50.500019
								],
								[
									-2.956274,
									50.69688
								],
								[
									-3.617448,
									50.228356
								],
								[
									-4.542508,
									50.341837
								],
								[
									-5.245023,
									49.96
								],
								[
									-5.776567,
									50.159678
								],
								[
									-4.30999,
									51.210001
								],
								[
									-3.414851,
									51.426009
								],
								[
									-3.422719,
									51.426848
								],
								[
									-4.984367,
									51.593466
								],
								[
									-5.267296,
									51.9914
								],
								[
									-4.222347,
									52.301356
								],
								[
									-4.770013,
									52.840005
								],
								[
									-4.579999,
									53.495004
								],
								[
									-3.093831,
									53.404547
								],
								[
									-3.09208,
									53.404441
								],
								[
									-2.945009,
									53.985
								],
								[
									-3.614701,
									54.600937
								],
								[
									-3.630005,
									54.615013
								],
								[
									-4.844169,
									54.790971
								],
								[
									-5.082527,
									55.061601
								],
								[
									-4.719112,
									55.508473
								],
								[
									-5.047981,
									55.783986
								],
								[
									-5.586398,
									55.311146
								],
								[
									-5.644999,
									56.275015
								],
								[
									-6.149981,
									56.78501
								],
								[
									-5.786825,
									57.818848
								],
								[
									-5.009999,
									58.630013
								],
								[
									-4.211495,
									58.550845
								],
								[
									-3.005005,
									58.635
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GEO",
				"properties": {
					"name": "Georgia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								41.554084,
								41.535656
							],
							[
								41.703171,
								41.962943
							],
							[
								41.45347,
								42.645123
							],
							[
								40.875469,
								43.013628
							],
							[
								40.321394,
								43.128634
							],
							[
								39.955009,
								43.434998
							],
							[
								40.076965,
								43.553104
							],
							[
								40.922185,
								43.382159
							],
							[
								42.394395,
								43.220308
							],
							[
								43.756017,
								42.740828
							],
							[
								43.9312,
								42.554974
							],
							[
								44.537623,
								42.711993
							],
							[
								45.470279,
								42.502781
							],
							[
								45.77641,
								42.092444
							],
							[
								46.404951,
								41.860675
							],
							[
								46.145432,
								41.722802
							],
							[
								46.637908,
								41.181673
							],
							[
								46.501637,
								41.064445
							],
							[
								45.962601,
								41.123873
							],
							[
								45.217426,
								41.411452
							],
							[
								44.97248,
								41.248129
							],
							[
								43.582746,
								41.092143
							],
							[
								42.619549,
								41.583173
							],
							[
								41.554084,
								41.535656
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GHA",
				"properties": {
					"name": "Ghana"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								1.060122,
								5.928837
							],
							[
								-0.507638,
								5.343473
							],
							[
								-1.063625,
								5.000548
							],
							[
								-1.964707,
								4.710462
							],
							[
								-2.856125,
								4.994476
							],
							[
								-2.810701,
								5.389051
							],
							[
								-3.24437,
								6.250472
							],
							[
								-2.983585,
								7.379705
							],
							[
								-2.56219,
								8.219628
							],
							[
								-2.827496,
								9.642461
							],
							[
								-2.963896,
								10.395335
							],
							[
								-2.940409,
								10.96269
							],
							[
								-1.203358,
								11.009819
							],
							[
								-0.761576,
								10.93693
							],
							[
								-0.438702,
								11.098341
							],
							[
								0.023803,
								11.018682
							],
							[
								-0.049785,
								10.706918
							],
							[
								0.36758,
								10.191213
							],
							[
								0.365901,
								9.465004
							],
							[
								0.461192,
								8.677223
							],
							[
								0.712029,
								8.312465
							],
							[
								0.490957,
								7.411744
							],
							[
								0.570384,
								6.914359
							],
							[
								0.836931,
								6.279979
							],
							[
								1.060122,
								5.928837
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GIN",
				"properties": {
					"name": "Guinea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-8.439298,
								7.686043
							],
							[
								-8.722124,
								7.711674
							],
							[
								-8.926065,
								7.309037
							],
							[
								-9.208786,
								7.313921
							],
							[
								-9.403348,
								7.526905
							],
							[
								-9.33728,
								7.928534
							],
							[
								-9.755342,
								8.541055
							],
							[
								-10.016567,
								8.428504
							],
							[
								-10.230094,
								8.406206
							],
							[
								-10.505477,
								8.348896
							],
							[
								-10.494315,
								8.715541
							],
							[
								-10.65477,
								8.977178
							],
							[
								-10.622395,
								9.26791
							],
							[
								-10.839152,
								9.688246
							],
							[
								-11.117481,
								10.045873
							],
							[
								-11.917277,
								10.046984
							],
							[
								-12.150338,
								9.858572
							],
							[
								-12.425929,
								9.835834
							],
							[
								-12.596719,
								9.620188
							],
							[
								-12.711958,
								9.342712
							],
							[
								-13.24655,
								8.903049
							],
							[
								-13.685154,
								9.494744
							],
							[
								-14.074045,
								9.886167
							],
							[
								-14.330076,
								10.01572
							],
							[
								-14.579699,
								10.214467
							],
							[
								-14.693232,
								10.656301
							],
							[
								-14.839554,
								10.876572
							],
							[
								-15.130311,
								11.040412
							],
							[
								-14.685687,
								11.527824
							],
							[
								-14.382192,
								11.509272
							],
							[
								-14.121406,
								11.677117
							],
							[
								-13.9008,
								11.678719
							],
							[
								-13.743161,
								11.811269
							],
							[
								-13.828272,
								12.142644
							],
							[
								-13.718744,
								12.247186
							],
							[
								-13.700476,
								12.586183
							],
							[
								-13.217818,
								12.575874
							],
							[
								-12.499051,
								12.33209
							],
							[
								-12.278599,
								12.35444
							],
							[
								-12.203565,
								12.465648
							],
							[
								-11.658301,
								12.386583
							],
							[
								-11.513943,
								12.442988
							],
							[
								-11.456169,
								12.076834
							],
							[
								-11.297574,
								12.077971
							],
							[
								-11.036556,
								12.211245
							],
							[
								-10.87083,
								12.177887
							],
							[
								-10.593224,
								11.923975
							],
							[
								-10.165214,
								11.844084
							],
							[
								-9.890993,
								12.060479
							],
							[
								-9.567912,
								12.194243
							],
							[
								-9.327616,
								12.334286
							],
							[
								-9.127474,
								12.30806
							],
							[
								-8.905265,
								12.088358
							],
							[
								-8.786099,
								11.812561
							],
							[
								-8.376305,
								11.393646
							],
							[
								-8.581305,
								11.136246
							],
							[
								-8.620321,
								10.810891
							],
							[
								-8.407311,
								10.909257
							],
							[
								-8.282357,
								10.792597
							],
							[
								-8.335377,
								10.494812
							],
							[
								-8.029944,
								10.206535
							],
							[
								-8.229337,
								10.12902
							],
							[
								-8.309616,
								9.789532
							],
							[
								-8.079114,
								9.376224
							],
							[
								-7.8321,
								8.575704
							],
							[
								-8.203499,
								8.455453
							],
							[
								-8.299049,
								8.316444
							],
							[
								-8.221792,
								8.123329
							],
							[
								-8.280703,
								7.68718
							],
							[
								-8.439298,
								7.686043
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GMB",
				"properties": {
					"name": "Gambia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-16.841525,
								13.151394
							],
							[
								-16.713729,
								13.594959
							],
							[
								-15.624596,
								13.623587
							],
							[
								-15.39877,
								13.860369
							],
							[
								-15.081735,
								13.876492
							],
							[
								-14.687031,
								13.630357
							],
							[
								-14.376714,
								13.62568
							],
							[
								-14.046992,
								13.794068
							],
							[
								-13.844963,
								13.505042
							],
							[
								-14.277702,
								13.280585
							],
							[
								-14.712197,
								13.298207
							],
							[
								-15.141163,
								13.509512
							],
							[
								-15.511813,
								13.27857
							],
							[
								-15.691001,
								13.270353
							],
							[
								-15.931296,
								13.130284
							],
							[
								-16.841525,
								13.151394
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GNB",
				"properties": {
					"name": "Guinea Bissau"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-15.130311,
								11.040412
							],
							[
								-15.66418,
								11.458474
							],
							[
								-16.085214,
								11.524594
							],
							[
								-16.314787,
								11.806515
							],
							[
								-16.308947,
								11.958702
							],
							[
								-16.613838,
								12.170911
							],
							[
								-16.677452,
								12.384852
							],
							[
								-16.147717,
								12.547762
							],
							[
								-15.816574,
								12.515567
							],
							[
								-15.548477,
								12.62817
							],
							[
								-13.700476,
								12.586183
							],
							[
								-13.718744,
								12.247186
							],
							[
								-13.828272,
								12.142644
							],
							[
								-13.743161,
								11.811269
							],
							[
								-13.9008,
								11.678719
							],
							[
								-14.121406,
								11.677117
							],
							[
								-14.382192,
								11.509272
							],
							[
								-14.685687,
								11.527824
							],
							[
								-15.130311,
								11.040412
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GNQ",
				"properties": {
					"name": "Equatorial Guinea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.492889,
								1.01012
							],
							[
								9.305613,
								1.160911
							],
							[
								9.649158,
								2.283866
							],
							[
								11.276449,
								2.261051
							],
							[
								11.285079,
								1.057662
							],
							[
								9.830284,
								1.067894
							],
							[
								9.492889,
								1.01012
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GRC",
				"properties": {
					"name": "Greece"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									23.69998,
									35.705004
								],
								[
									24.246665,
									35.368022
								],
								[
									25.025015,
									35.424996
								],
								[
									25.769208,
									35.354018
								],
								[
									25.745023,
									35.179998
								],
								[
									26.290003,
									35.29999
								],
								[
									26.164998,
									35.004995
								],
								[
									24.724982,
									34.919988
								],
								[
									24.735007,
									35.084991
								],
								[
									23.514978,
									35.279992
								],
								[
									23.69998,
									35.705004
								]
							]
						],
						[
							[
								[
									26.604196,
									41.562115
								],
								[
									26.294602,
									40.936261
								],
								[
									26.056942,
									40.824123
								],
								[
									25.447677,
									40.852545
								],
								[
									24.925848,
									40.947062
								],
								[
									23.714811,
									40.687129
								],
								[
									24.407999,
									40.124993
								],
								[
									23.899968,
									39.962006
								],
								[
									23.342999,
									39.960998
								],
								[
									22.813988,
									40.476005
								],
								[
									22.626299,
									40.256561
								],
								[
									22.849748,
									39.659311
								],
								[
									23.350027,
									39.190011
								],
								[
									22.973099,
									38.970903
								],
								[
									23.530016,
									38.510001
								],
								[
									24.025025,
									38.219993
								],
								[
									24.040011,
									37.655015
								],
								[
									23.115003,
									37.920011
								],
								[
									23.409972,
									37.409991
								],
								[
									22.774972,
									37.30501
								],
								[
									23.154225,
									36.422506
								],
								[
									22.490028,
									36.41
								],
								[
									21.670026,
									36.844986
								],
								[
									21.295011,
									37.644989
								],
								[
									21.120034,
									38.310323
								],
								[
									20.730032,
									38.769985
								],
								[
									20.217712,
									39.340235
								],
								[
									20.150016,
									39.624998
								],
								[
									20.615,
									40.110007
								],
								[
									20.674997,
									40.435
								],
								[
									20.99999,
									40.580004
								],
								[
									21.02004,
									40.842727
								],
								[
									21.674161,
									40.931275
								],
								[
									22.055378,
									41.149866
								],
								[
									22.597308,
									41.130487
								],
								[
									22.76177,
									41.3048
								],
								[
									22.952377,
									41.337994
								],
								[
									23.692074,
									41.309081
								],
								[
									24.492645,
									41.583896
								],
								[
									25.197201,
									41.234486
								],
								[
									26.106138,
									41.328899
								],
								[
									26.117042,
									41.826905
								],
								[
									26.604196,
									41.562115
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GRL",
				"properties": {
					"name": "Greenland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-46.76379,
								82.62796
							],
							[
								-43.40644,
								83.22516
							],
							[
								-39.89753,
								83.18018
							],
							[
								-38.62214,
								83.54905
							],
							[
								-35.08787,
								83.64513
							],
							[
								-27.10046,
								83.51966
							],
							[
								-20.84539,
								82.72669
							],
							[
								-22.69182,
								82.34165
							],
							[
								-26.51753,
								82.29765
							],
							[
								-31.9,
								82.2
							],
							[
								-31.39646,
								82.02154
							],
							[
								-27.85666,
								82.13178
							],
							[
								-24.84448,
								81.78697
							],
							[
								-22.90328,
								82.09317
							],
							[
								-22.07175,
								81.73449
							],
							[
								-23.16961,
								81.15271
							],
							[
								-20.62363,
								81.52462
							],
							[
								-15.76818,
								81.91245
							],
							[
								-12.77018,
								81.71885
							],
							[
								-12.20855,
								81.29154
							],
							[
								-16.28533,
								80.58004
							],
							[
								-16.85,
								80.35
							],
							[
								-20.04624,
								80.17708
							],
							[
								-17.73035,
								80.12912
							],
							[
								-18.9,
								79.4
							],
							[
								-19.70499,
								78.75128
							],
							[
								-19.67353,
								77.63859
							],
							[
								-18.47285,
								76.98565
							],
							[
								-20.03503,
								76.94434
							],
							[
								-21.67944,
								76.62795
							],
							[
								-19.83407,
								76.09808
							],
							[
								-19.59896,
								75.24838
							],
							[
								-20.66818,
								75.15585
							],
							[
								-19.37281,
								74.29561
							],
							[
								-21.59422,
								74.22382
							],
							[
								-20.43454,
								73.81713
							],
							[
								-20.76234,
								73.46436
							],
							[
								-22.17221,
								73.30955
							],
							[
								-23.56593,
								73.30663
							],
							[
								-22.31311,
								72.62928
							],
							[
								-22.29954,
								72.18409
							],
							[
								-24.27834,
								72.59788
							],
							[
								-24.79296,
								72.3302
							],
							[
								-23.44296,
								72.08016
							],
							[
								-22.13281,
								71.46898
							],
							[
								-21.75356,
								70.66369
							],
							[
								-23.53603,
								70.471
							],
							[
								-24.30702,
								70.85649
							],
							[
								-25.54341,
								71.43094
							],
							[
								-25.20135,
								70.75226
							],
							[
								-26.36276,
								70.22646
							],
							[
								-23.72742,
								70.18401
							],
							[
								-22.34902,
								70.12946
							],
							[
								-25.02927,
								69.2588
							],
							[
								-27.74737,
								68.47046
							],
							[
								-30.67371,
								68.12503
							],
							[
								-31.77665,
								68.12078
							],
							[
								-32.81105,
								67.73547
							],
							[
								-34.20196,
								66.67974
							],
							[
								-36.35284,
								65.9789
							],
							[
								-37.04378,
								65.93768
							],
							[
								-38.37505,
								65.69213
							],
							[
								-39.81222,
								65.45848
							],
							[
								-40.66899,
								64.83997
							],
							[
								-40.68281,
								64.13902
							],
							[
								-41.1887,
								63.48246
							],
							[
								-42.81938,
								62.68233
							],
							[
								-42.41666,
								61.90093
							],
							[
								-42.86619,
								61.07404
							],
							[
								-43.3784,
								60.09772
							],
							[
								-44.7875,
								60.03676
							],
							[
								-46.26364,
								60.85328
							],
							[
								-48.26294,
								60.85843
							],
							[
								-49.23308,
								61.40681
							],
							[
								-49.90039,
								62.38336
							],
							[
								-51.63325,
								63.62691
							],
							[
								-52.14014,
								64.27842
							],
							[
								-52.27659,
								65.1767
							],
							[
								-53.66166,
								66.09957
							],
							[
								-53.30161,
								66.8365
							],
							[
								-53.96911,
								67.18899
							],
							[
								-52.9804,
								68.35759
							],
							[
								-51.47536,
								68.72958
							],
							[
								-51.08041,
								69.14781
							],
							[
								-50.87122,
								69.9291
							],
							[
								-52.013585,
								69.574925
							],
							[
								-52.55792,
								69.42616
							],
							[
								-53.45629,
								69.283625
							],
							[
								-54.68336,
								69.61003
							],
							[
								-54.75001,
								70.28932
							],
							[
								-54.35884,
								70.821315
							],
							[
								-53.431315,
								70.835755
							],
							[
								-51.39014,
								70.56978
							],
							[
								-53.10937,
								71.20485
							],
							[
								-54.00422,
								71.54719
							],
							[
								-55,
								71.406537
							],
							[
								-55.83468,
								71.65444
							],
							[
								-54.71819,
								72.58625
							],
							[
								-55.32634,
								72.95861
							],
							[
								-56.12003,
								73.64977
							],
							[
								-57.32363,
								74.71026
							],
							[
								-58.59679,
								75.09861
							],
							[
								-58.58516,
								75.51727
							],
							[
								-61.26861,
								76.10238
							],
							[
								-63.39165,
								76.1752
							],
							[
								-66.06427,
								76.13486
							],
							[
								-68.50438,
								76.06141
							],
							[
								-69.66485,
								76.37975
							],
							[
								-71.40257,
								77.00857
							],
							[
								-68.77671,
								77.32312
							],
							[
								-66.76397,
								77.37595
							],
							[
								-71.04293,
								77.63595
							],
							[
								-73.297,
								78.04419
							],
							[
								-73.15938,
								78.43271
							],
							[
								-69.37345,
								78.91388
							],
							[
								-65.7107,
								79.39436
							],
							[
								-65.3239,
								79.75814
							],
							[
								-68.02298,
								80.11721
							],
							[
								-67.15129,
								80.51582
							],
							[
								-63.68925,
								81.21396
							],
							[
								-62.23444,
								81.3211
							],
							[
								-62.65116,
								81.77042
							],
							[
								-60.28249,
								82.03363
							],
							[
								-57.20744,
								82.19074
							],
							[
								-54.13442,
								82.19962
							],
							[
								-53.04328,
								81.88833
							],
							[
								-50.39061,
								82.43883
							],
							[
								-48.00386,
								82.06481
							],
							[
								-46.59984,
								81.985945
							],
							[
								-44.523,
								81.6607
							],
							[
								-46.9007,
								82.19979
							],
							[
								-46.76379,
								82.62796
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GTM",
				"properties": {
					"name": "Guatemala"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-90.095555,
								13.735338
							],
							[
								-90.608624,
								13.909771
							],
							[
								-91.23241,
								13.927832
							],
							[
								-91.689747,
								14.126218
							],
							[
								-92.22775,
								14.538829
							],
							[
								-92.20323,
								14.830103
							],
							[
								-92.087216,
								15.064585
							],
							[
								-92.229249,
								15.251447
							],
							[
								-91.74796,
								16.066565
							],
							[
								-90.464473,
								16.069562
							],
							[
								-90.438867,
								16.41011
							],
							[
								-90.600847,
								16.470778
							],
							[
								-90.711822,
								16.687483
							],
							[
								-91.08167,
								16.918477
							],
							[
								-91.453921,
								17.252177
							],
							[
								-91.002269,
								17.254658
							],
							[
								-91.00152,
								17.817595
							],
							[
								-90.067934,
								17.819326
							],
							[
								-89.14308,
								17.808319
							],
							[
								-89.150806,
								17.015577
							],
							[
								-89.229122,
								15.886938
							],
							[
								-88.930613,
								15.887273
							],
							[
								-88.604586,
								15.70638
							],
							[
								-88.518364,
								15.855389
							],
							[
								-88.225023,
								15.727722
							],
							[
								-88.68068,
								15.346247
							],
							[
								-89.154811,
								15.066419
							],
							[
								-89.22522,
								14.874286
							],
							[
								-89.145535,
								14.678019
							],
							[
								-89.353326,
								14.424133
							],
							[
								-89.587343,
								14.362586
							],
							[
								-89.534219,
								14.244816
							],
							[
								-89.721934,
								14.134228
							],
							[
								-90.064678,
								13.88197
							],
							[
								-90.095555,
								13.735338
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GUF",
				"properties": {
					"name": "French Guiana"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-52.556425,
								2.504705
							],
							[
								-52.939657,
								2.124858
							],
							[
								-53.418465,
								2.053389
							],
							[
								-53.554839,
								2.334897
							],
							[
								-53.778521,
								2.376703
							],
							[
								-54.088063,
								2.105557
							],
							[
								-54.524754,
								2.311849
							],
							[
								-54.27123,
								2.738748
							],
							[
								-54.184284,
								3.194172
							],
							[
								-54.011504,
								3.62257
							],
							[
								-54.399542,
								4.212611
							],
							[
								-54.478633,
								4.896756
							],
							[
								-53.958045,
								5.756548
							],
							[
								-53.618453,
								5.646529
							],
							[
								-52.882141,
								5.409851
							],
							[
								-51.823343,
								4.565768
							],
							[
								-51.657797,
								4.156232
							],
							[
								-52.249338,
								3.241094
							],
							[
								-52.556425,
								2.504705
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "GUY",
				"properties": {
					"name": "Guyana"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-59.758285,
								8.367035
							],
							[
								-59.101684,
								7.999202
							],
							[
								-58.482962,
								7.347691
							],
							[
								-58.454876,
								6.832787
							],
							[
								-58.078103,
								6.809094
							],
							[
								-57.542219,
								6.321268
							],
							[
								-57.147436,
								5.97315
							],
							[
								-57.307246,
								5.073567
							],
							[
								-57.914289,
								4.812626
							],
							[
								-57.86021,
								4.576801
							],
							[
								-58.044694,
								4.060864
							],
							[
								-57.601569,
								3.334655
							],
							[
								-57.281433,
								3.333492
							],
							[
								-57.150098,
								2.768927
							],
							[
								-56.539386,
								1.899523
							],
							[
								-56.782704,
								1.863711
							],
							[
								-57.335823,
								1.948538
							],
							[
								-57.660971,
								1.682585
							],
							[
								-58.11345,
								1.507195
							],
							[
								-58.429477,
								1.463942
							],
							[
								-58.540013,
								1.268088
							],
							[
								-59.030862,
								1.317698
							],
							[
								-59.646044,
								1.786894
							],
							[
								-59.718546,
								2.24963
							],
							[
								-59.974525,
								2.755233
							],
							[
								-59.815413,
								3.606499
							],
							[
								-59.53804,
								3.958803
							],
							[
								-59.767406,
								4.423503
							],
							[
								-60.111002,
								4.574967
							],
							[
								-59.980959,
								5.014061
							],
							[
								-60.213683,
								5.244486
							],
							[
								-60.733574,
								5.200277
							],
							[
								-61.410303,
								5.959068
							],
							[
								-61.139415,
								6.234297
							],
							[
								-61.159336,
								6.696077
							],
							[
								-60.543999,
								6.856584
							],
							[
								-60.295668,
								7.043911
							],
							[
								-60.637973,
								7.415
							],
							[
								-60.550588,
								7.779603
							],
							[
								-59.758285,
								8.367035
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "HND",
				"properties": {
					"name": "Honduras"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-87.316654,
								12.984686
							],
							[
								-87.489409,
								13.297535
							],
							[
								-87.793111,
								13.38448
							],
							[
								-87.723503,
								13.78505
							],
							[
								-87.859515,
								13.893312
							],
							[
								-88.065343,
								13.964626
							],
							[
								-88.503998,
								13.845486
							],
							[
								-88.541231,
								13.980155
							],
							[
								-88.843073,
								14.140507
							],
							[
								-89.058512,
								14.340029
							],
							[
								-89.353326,
								14.424133
							],
							[
								-89.145535,
								14.678019
							],
							[
								-89.22522,
								14.874286
							],
							[
								-89.154811,
								15.066419
							],
							[
								-88.68068,
								15.346247
							],
							[
								-88.225023,
								15.727722
							],
							[
								-88.121153,
								15.688655
							],
							[
								-87.901813,
								15.864458
							],
							[
								-87.61568,
								15.878799
							],
							[
								-87.522921,
								15.797279
							],
							[
								-87.367762,
								15.84694
							],
							[
								-86.903191,
								15.756713
							],
							[
								-86.440946,
								15.782835
							],
							[
								-86.119234,
								15.893449
							],
							[
								-86.001954,
								16.005406
							],
							[
								-85.683317,
								15.953652
							],
							[
								-85.444004,
								15.885749
							],
							[
								-85.182444,
								15.909158
							],
							[
								-84.983722,
								15.995923
							],
							[
								-84.52698,
								15.857224
							],
							[
								-84.368256,
								15.835158
							],
							[
								-84.063055,
								15.648244
							],
							[
								-83.773977,
								15.424072
							],
							[
								-83.410381,
								15.270903
							],
							[
								-83.147219,
								14.995829
							],
							[
								-83.489989,
								15.016267
							],
							[
								-83.628585,
								14.880074
							],
							[
								-83.975721,
								14.749436
							],
							[
								-84.228342,
								14.748764
							],
							[
								-84.449336,
								14.621614
							],
							[
								-84.649582,
								14.666805
							],
							[
								-84.820037,
								14.819587
							],
							[
								-84.924501,
								14.790493
							],
							[
								-85.052787,
								14.551541
							],
							[
								-85.148751,
								14.560197
							],
							[
								-85.165365,
								14.35437
							],
							[
								-85.514413,
								14.079012
							],
							[
								-85.698665,
								13.960078
							],
							[
								-85.801295,
								13.836055
							],
							[
								-86.096264,
								14.038187
							],
							[
								-86.312142,
								13.771356
							],
							[
								-86.520708,
								13.778487
							],
							[
								-86.755087,
								13.754845
							],
							[
								-86.733822,
								13.263093
							],
							[
								-86.880557,
								13.254204
							],
							[
								-87.005769,
								13.025794
							],
							[
								-87.316654,
								12.984686
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "HRV",
				"properties": {
					"name": "Croatia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								18.829838,
								45.908878
							],
							[
								19.072769,
								45.521511
							],
							[
								19.390476,
								45.236516
							],
							[
								19.005486,
								44.860234
							],
							[
								18.553214,
								45.08159
							],
							[
								17.861783,
								45.06774
							],
							[
								17.002146,
								45.233777
							],
							[
								16.534939,
								45.211608
							],
							[
								16.318157,
								45.004127
							],
							[
								15.959367,
								45.233777
							],
							[
								15.750026,
								44.818712
							],
							[
								16.23966,
								44.351143
							],
							[
								16.456443,
								44.04124
							],
							[
								16.916156,
								43.667722
							],
							[
								17.297373,
								43.446341
							],
							[
								17.674922,
								43.028563
							],
							[
								18.56,
								42.65
							],
							[
								18.450016,
								42.479991
							],
							[
								17.50997,
								42.849995
							],
							[
								16.930006,
								43.209998
							],
							[
								16.015385,
								43.507215
							],
							[
								15.174454,
								44.243191
							],
							[
								15.37625,
								44.317915
							],
							[
								14.920309,
								44.738484
							],
							[
								14.901602,
								45.07606
							],
							[
								14.258748,
								45.233777
							],
							[
								13.952255,
								44.802124
							],
							[
								13.656976,
								45.136935
							],
							[
								13.679403,
								45.484149
							],
							[
								13.71506,
								45.500324
							],
							[
								14.411968,
								45.466166
							],
							[
								14.595109,
								45.634941
							],
							[
								14.935244,
								45.471695
							],
							[
								15.327675,
								45.452316
							],
							[
								15.323954,
								45.731783
							],
							[
								15.67153,
								45.834154
							],
							[
								15.768733,
								46.238108
							],
							[
								16.564808,
								46.503751
							],
							[
								16.882515,
								46.380632
							],
							[
								17.630066,
								45.951769
							],
							[
								18.456062,
								45.759481
							],
							[
								18.829838,
								45.908878
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "HTI",
				"properties": {
					"name": "Haiti"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-73.189791,
								19.915684
							],
							[
								-72.579673,
								19.871501
							],
							[
								-71.712361,
								19.714456
							],
							[
								-71.624873,
								19.169838
							],
							[
								-71.701303,
								18.785417
							],
							[
								-71.945112,
								18.6169
							],
							[
								-71.687738,
								18.31666
							],
							[
								-71.708305,
								18.044997
							],
							[
								-72.372476,
								18.214961
							],
							[
								-72.844411,
								18.145611
							],
							[
								-73.454555,
								18.217906
							],
							[
								-73.922433,
								18.030993
							],
							[
								-74.458034,
								18.34255
							],
							[
								-74.369925,
								18.664908
							],
							[
								-73.449542,
								18.526053
							],
							[
								-72.694937,
								18.445799
							],
							[
								-72.334882,
								18.668422
							],
							[
								-72.79165,
								19.101625
							],
							[
								-72.784105,
								19.483591
							],
							[
								-73.415022,
								19.639551
							],
							[
								-73.189791,
								19.915684
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "HUN",
				"properties": {
					"name": "Hungary"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.202298,
								46.852386
							],
							[
								16.534268,
								47.496171
							],
							[
								16.340584,
								47.712902
							],
							[
								16.903754,
								47.714866
							],
							[
								16.979667,
								48.123497
							],
							[
								17.488473,
								47.867466
							],
							[
								17.857133,
								47.758429
							],
							[
								18.696513,
								47.880954
							],
							[
								18.777025,
								48.081768
							],
							[
								19.174365,
								48.111379
							],
							[
								19.661364,
								48.266615
							],
							[
								19.769471,
								48.202691
							],
							[
								20.239054,
								48.327567
							],
							[
								20.473562,
								48.56285
							],
							[
								20.801294,
								48.623854
							],
							[
								21.872236,
								48.319971
							],
							[
								22.085608,
								48.422264
							],
							[
								22.64082,
								48.15024
							],
							[
								22.710531,
								47.882194
							],
							[
								22.099768,
								47.672439
							],
							[
								21.626515,
								46.994238
							],
							[
								21.021952,
								46.316088
							],
							[
								20.220192,
								46.127469
							],
							[
								19.596045,
								46.17173
							],
							[
								18.829838,
								45.908878
							],
							[
								18.456062,
								45.759481
							],
							[
								17.630066,
								45.951769
							],
							[
								16.882515,
								46.380632
							],
							[
								16.564808,
								46.503751
							],
							[
								16.370505,
								46.841327
							],
							[
								16.202298,
								46.852386
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "IDN",
				"properties": {
					"name": "Indonesia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									120.715609,
									-10.239581
								],
								[
									120.295014,
									-10.25865
								],
								[
									118.967808,
									-9.557969
								],
								[
									119.90031,
									-9.36134
								],
								[
									120.425756,
									-9.665921
								],
								[
									120.775502,
									-9.969675
								],
								[
									120.715609,
									-10.239581
								]
							]
						],
						[
							[
								[
									124.43595,
									-10.140001
								],
								[
									123.579982,
									-10.359987
								],
								[
									123.459989,
									-10.239995
								],
								[
									123.550009,
									-9.900016
								],
								[
									123.980009,
									-9.290027
								],
								[
									124.968682,
									-8.89279
								],
								[
									125.07002,
									-9.089987
								],
								[
									125.08852,
									-9.393173
								],
								[
									124.43595,
									-10.140001
								]
							]
						],
						[
							[
								[
									117.900018,
									-8.095681
								],
								[
									118.260616,
									-8.362383
								],
								[
									118.87846,
									-8.280683
								],
								[
									119.126507,
									-8.705825
								],
								[
									117.970402,
									-8.906639
								],
								[
									117.277731,
									-9.040895
								],
								[
									116.740141,
									-9.032937
								],
								[
									117.083737,
									-8.457158
								],
								[
									117.632024,
									-8.449303
								],
								[
									117.900018,
									-8.095681
								]
							]
						],
						[
							[
								[
									122.903537,
									-8.094234
								],
								[
									122.756983,
									-8.649808
								],
								[
									121.254491,
									-8.933666
								],
								[
									119.924391,
									-8.810418
								],
								[
									119.920929,
									-8.444859
								],
								[
									120.715092,
									-8.236965
								],
								[
									121.341669,
									-8.53674
								],
								[
									122.007365,
									-8.46062
								],
								[
									122.903537,
									-8.094234
								]
							]
						],
						[
							[
								[
									108.623479,
									-6.777674
								],
								[
									110.539227,
									-6.877358
								],
								[
									110.759576,
									-6.465186
								],
								[
									112.614811,
									-6.946036
								],
								[
									112.978768,
									-7.594213
								],
								[
									114.478935,
									-7.776528
								],
								[
									115.705527,
									-8.370807
								],
								[
									114.564511,
									-8.751817
								],
								[
									113.464734,
									-8.348947
								],
								[
									112.559672,
									-8.376181
								],
								[
									111.522061,
									-8.302129
								],
								[
									110.58615,
									-8.122605
								],
								[
									109.427667,
									-7.740664
								],
								[
									108.693655,
									-7.6416
								],
								[
									108.277763,
									-7.766657
								],
								[
									106.454102,
									-7.3549
								],
								[
									106.280624,
									-6.9249
								],
								[
									105.365486,
									-6.851416
								],
								[
									106.051646,
									-5.895919
								],
								[
									107.265009,
									-5.954985
								],
								[
									108.072091,
									-6.345762
								],
								[
									108.486846,
									-6.421985
								],
								[
									108.623479,
									-6.777674
								]
							]
						],
						[
							[
								[
									134.724624,
									-6.214401
								],
								[
									134.210134,
									-6.895238
								],
								[
									134.112776,
									-6.142467
								],
								[
									134.290336,
									-5.783058
								],
								[
									134.499625,
									-5.445042
								],
								[
									134.727002,
									-5.737582
								],
								[
									134.724624,
									-6.214401
								]
							]
						],
						[
							[
								[
									127.249215,
									-3.459065
								],
								[
									126.874923,
									-3.790983
								],
								[
									126.183802,
									-3.607376
								],
								[
									125.989034,
									-3.177273
								],
								[
									127.000651,
									-3.129318
								],
								[
									127.249215,
									-3.459065
								]
							]
						],
						[
							[
								[
									130.471344,
									-3.093764
								],
								[
									130.834836,
									-3.858472
								],
								[
									129.990547,
									-3.446301
								],
								[
									129.155249,
									-3.362637
								],
								[
									128.590684,
									-3.428679
								],
								[
									127.898891,
									-3.393436
								],
								[
									128.135879,
									-2.84365
								],
								[
									129.370998,
									-2.802154
								],
								[
									130.471344,
									-3.093764
								]
							]
						],
						[
							[
								[
									134.143368,
									-1.151867
								],
								[
									134.422627,
									-2.769185
								],
								[
									135.457603,
									-3.367753
								],
								[
									136.293314,
									-2.307042
								],
								[
									137.440738,
									-1.703513
								],
								[
									138.329727,
									-1.702686
								],
								[
									139.184921,
									-2.051296
								],
								[
									139.926684,
									-2.409052
								],
								[
									141.00021,
									-2.600151
								],
								[
									141.017057,
									-5.859022
								],
								[
									141.033852,
									-9.117893
								],
								[
									140.143415,
									-8.297168
								],
								[
									139.127767,
									-8.096043
								],
								[
									138.881477,
									-8.380935
								],
								[
									137.614474,
									-8.411683
								],
								[
									138.039099,
									-7.597882
								],
								[
									138.668621,
									-7.320225
								],
								[
									138.407914,
									-6.232849
								],
								[
									137.92784,
									-5.393366
								],
								[
									135.98925,
									-4.546544
								],
								[
									135.164598,
									-4.462931
								],
								[
									133.66288,
									-3.538853
								],
								[
									133.367705,
									-4.024819
								],
								[
									132.983956,
									-4.112979
								],
								[
									132.756941,
									-3.746283
								],
								[
									132.753789,
									-3.311787
								],
								[
									131.989804,
									-2.820551
								],
								[
									133.066845,
									-2.460418
								],
								[
									133.780031,
									-2.479848
								],
								[
									133.696212,
									-2.214542
								],
								[
									132.232373,
									-2.212526
								],
								[
									131.836222,
									-1.617162
								],
								[
									130.94284,
									-1.432522
								],
								[
									130.519558,
									-0.93772
								],
								[
									131.867538,
									-0.695461
								],
								[
									132.380116,
									-0.369538
								],
								[
									133.985548,
									-0.78021
								],
								[
									134.143368,
									-1.151867
								]
							]
						],
						[
							[
								[
									125.240501,
									1.419836
								],
								[
									124.437035,
									0.427881
								],
								[
									123.685505,
									0.235593
								],
								[
									122.723083,
									0.431137
								],
								[
									121.056725,
									0.381217
								],
								[
									120.183083,
									0.237247
								],
								[
									120.04087,
									-0.519658
								],
								[
									120.935905,
									-1.408906
								],
								[
									121.475821,
									-0.955962
								],
								[
									123.340565,
									-0.615673
								],
								[
									123.258399,
									-1.076213
								],
								[
									122.822715,
									-0.930951
								],
								[
									122.38853,
									-1.516858
								],
								[
									121.508274,
									-1.904483
								],
								[
									122.454572,
									-3.186058
								],
								[
									122.271896,
									-3.5295
								],
								[
									123.170963,
									-4.683693
								],
								[
									123.162333,
									-5.340604
								],
								[
									122.628515,
									-5.634591
								],
								[
									122.236394,
									-5.282933
								],
								[
									122.719569,
									-4.464172
								],
								[
									121.738234,
									-4.851331
								],
								[
									121.489463,
									-4.574553
								],
								[
									121.619171,
									-4.188478
								],
								[
									120.898182,
									-3.602105
								],
								[
									120.972389,
									-2.627643
								],
								[
									120.305453,
									-2.931604
								],
								[
									120.390047,
									-4.097579
								],
								[
									120.430717,
									-5.528241
								],
								[
									119.796543,
									-5.6734
								],
								[
									119.366906,
									-5.379878
								],
								[
									119.653606,
									-4.459417
								],
								[
									119.498835,
									-3.494412
								],
								[
									119.078344,
									-3.487022
								],
								[
									118.767769,
									-2.801999
								],
								[
									119.180974,
									-2.147104
								],
								[
									119.323394,
									-1.353147
								],
								[
									119.825999,
									0.154254
								],
								[
									120.035702,
									0.566477
								],
								[
									120.885779,
									1.309223
								],
								[
									121.666817,
									1.013944
								],
								[
									122.927567,
									0.875192
								],
								[
									124.077522,
									0.917102
								],
								[
									125.065989,
									1.643259
								],
								[
									125.240501,
									1.419836
								]
							]
						],
						[
							[
								[
									128.688249,
									1.132386
								],
								[
									128.635952,
									0.258486
								],
								[
									128.12017,
									0.356413
								],
								[
									127.968034,
									-0.252077
								],
								[
									128.379999,
									-0.780004
								],
								[
									128.100016,
									-0.899996
								],
								[
									127.696475,
									-0.266598
								],
								[
									127.39949,
									1.011722
								],
								[
									127.600512,
									1.810691
								],
								[
									127.932378,
									2.174596
								],
								[
									128.004156,
									1.628531
								],
								[
									128.594559,
									1.540811
								],
								[
									128.688249,
									1.132386
								]
							]
						],
						[
							[
								[
									117.875627,
									1.827641
								],
								[
									118.996747,
									0.902219
								],
								[
									117.811858,
									0.784242
								],
								[
									117.478339,
									0.102475
								],
								[
									117.521644,
									-0.803723
								],
								[
									116.560048,
									-1.487661
								],
								[
									116.533797,
									-2.483517
								],
								[
									116.148084,
									-4.012726
								],
								[
									116.000858,
									-3.657037
								],
								[
									114.864803,
									-4.106984
								],
								[
									114.468652,
									-3.495704
								],
								[
									113.755672,
									-3.43917
								],
								[
									113.256994,
									-3.118776
								],
								[
									112.068126,
									-3.478392
								],
								[
									111.703291,
									-2.994442
								],
								[
									111.04824,
									-3.049426
								],
								[
									110.223846,
									-2.934032
								],
								[
									110.070936,
									-1.592874
								],
								[
									109.571948,
									-1.314907
								],
								[
									109.091874,
									-0.459507
								],
								[
									108.952658,
									0.415375
								],
								[
									109.069136,
									1.341934
								],
								[
									109.66326,
									2.006467
								],
								[
									109.830227,
									1.338136
								],
								[
									110.514061,
									0.773131
								],
								[
									111.159138,
									0.976478
								],
								[
									111.797548,
									0.904441
								],
								[
									112.380252,
									1.410121
								],
								[
									112.859809,
									1.49779
								],
								[
									113.80585,
									1.217549
								],
								[
									114.621355,
									1.430688
								],
								[
									115.134037,
									2.821482
								],
								[
									115.519078,
									3.169238
								],
								[
									115.865517,
									4.306559
								],
								[
									117.015214,
									4.306094
								],
								[
									117.882035,
									4.137551
								],
								[
									117.313232,
									3.234428
								],
								[
									118.04833,
									2.28769
								],
								[
									117.875627,
									1.827641
								]
							]
						],
						[
							[
								[
									105.817655,
									-5.852356
								],
								[
									104.710384,
									-5.873285
								],
								[
									103.868213,
									-5.037315
								],
								[
									102.584261,
									-4.220259
								],
								[
									102.156173,
									-3.614146
								],
								[
									101.399113,
									-2.799777
								],
								[
									100.902503,
									-2.050262
								],
								[
									100.141981,
									-0.650348
								],
								[
									99.26374,
									0.183142
								],
								[
									98.970011,
									1.042882
								],
								[
									98.601351,
									1.823507
								],
								[
									97.699598,
									2.453184
								],
								[
									97.176942,
									3.308791
								],
								[
									96.424017,
									3.86886
								],
								[
									95.380876,
									4.970782
								],
								[
									95.293026,
									5.479821
								],
								[
									95.936863,
									5.439513
								],
								[
									97.484882,
									5.246321
								],
								[
									98.369169,
									4.26837
								],
								[
									99.142559,
									3.59035
								],
								[
									99.693998,
									3.174329
								],
								[
									100.641434,
									2.099381
								],
								[
									101.658012,
									2.083697
								],
								[
									102.498271,
									1.3987
								],
								[
									103.07684,
									0.561361
								],
								[
									103.838396,
									0.104542
								],
								[
									103.437645,
									-0.711946
								],
								[
									104.010789,
									-1.059212
								],
								[
									104.369991,
									-1.084843
								],
								[
									104.53949,
									-1.782372
								],
								[
									104.887893,
									-2.340425
								],
								[
									105.622111,
									-2.428844
								],
								[
									106.108593,
									-3.061777
								],
								[
									105.857446,
									-4.305525
								],
								[
									105.817655,
									-5.852356
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "IND",
				"properties": {
					"name": "India"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								77.837451,
								35.49401
							],
							[
								78.912269,
								34.321936
							],
							[
								78.811086,
								33.506198
							],
							[
								79.208892,
								32.994395
							],
							[
								79.176129,
								32.48378
							],
							[
								78.458446,
								32.618164
							],
							[
								78.738894,
								31.515906
							],
							[
								79.721367,
								30.882715
							],
							[
								81.111256,
								30.183481
							],
							[
								80.476721,
								29.729865
							],
							[
								80.088425,
								28.79447
							],
							[
								81.057203,
								28.416095
							],
							[
								81.999987,
								27.925479
							],
							[
								83.304249,
								27.364506
							],
							[
								84.675018,
								27.234901
							],
							[
								85.251779,
								26.726198
							],
							[
								86.024393,
								26.630985
							],
							[
								87.227472,
								26.397898
							],
							[
								88.060238,
								26.414615
							],
							[
								88.174804,
								26.810405
							],
							[
								88.043133,
								27.445819
							],
							[
								88.120441,
								27.876542
							],
							[
								88.730326,
								28.086865
							],
							[
								88.814248,
								27.299316
							],
							[
								88.835643,
								27.098966
							],
							[
								89.744528,
								26.719403
							],
							[
								90.373275,
								26.875724
							],
							[
								91.217513,
								26.808648
							],
							[
								92.033484,
								26.83831
							],
							[
								92.103712,
								27.452614
							],
							[
								91.696657,
								27.771742
							],
							[
								92.503119,
								27.896876
							],
							[
								93.413348,
								28.640629
							],
							[
								94.56599,
								29.277438
							],
							[
								95.404802,
								29.031717
							],
							[
								96.117679,
								29.452802
							],
							[
								96.586591,
								28.83098
							],
							[
								96.248833,
								28.411031
							],
							[
								97.327114,
								28.261583
							],
							[
								97.402561,
								27.882536
							],
							[
								97.051989,
								27.699059
							],
							[
								97.133999,
								27.083774
							],
							[
								96.419366,
								27.264589
							],
							[
								95.124768,
								26.573572
							],
							[
								95.155153,
								26.001307
							],
							[
								94.603249,
								25.162495
							],
							[
								94.552658,
								24.675238
							],
							[
								94.106742,
								23.850741
							],
							[
								93.325188,
								24.078556
							],
							[
								93.286327,
								23.043658
							],
							[
								93.060294,
								22.703111
							],
							[
								93.166128,
								22.27846
							],
							[
								92.672721,
								22.041239
							],
							[
								92.146035,
								23.627499
							],
							[
								91.869928,
								23.624346
							],
							[
								91.706475,
								22.985264
							],
							[
								91.158963,
								23.503527
							],
							[
								91.46773,
								24.072639
							],
							[
								91.915093,
								24.130414
							],
							[
								92.376202,
								24.976693
							],
							[
								91.799596,
								25.147432
							],
							[
								90.872211,
								25.132601
							],
							[
								89.920693,
								25.26975
							],
							[
								89.832481,
								25.965082
							],
							[
								89.355094,
								26.014407
							],
							[
								88.563049,
								26.446526
							],
							[
								88.209789,
								25.768066
							],
							[
								88.931554,
								25.238692
							],
							[
								88.306373,
								24.866079
							],
							[
								88.084422,
								24.501657
							],
							[
								88.69994,
								24.233715
							],
							[
								88.52977,
								23.631142
							],
							[
								88.876312,
								22.879146
							],
							[
								89.031961,
								22.055708
							],
							[
								88.888766,
								21.690588
							],
							[
								88.208497,
								21.703172
							],
							[
								86.975704,
								21.495562
							],
							[
								87.033169,
								20.743308
							],
							[
								86.499351,
								20.151638
							],
							[
								85.060266,
								19.478579
							],
							[
								83.941006,
								18.30201
							],
							[
								83.189217,
								17.671221
							],
							[
								82.192792,
								17.016636
							],
							[
								82.191242,
								16.556664
							],
							[
								81.692719,
								16.310219
							],
							[
								80.791999,
								15.951972
							],
							[
								80.324896,
								15.899185
							],
							[
								80.025069,
								15.136415
							],
							[
								80.233274,
								13.835771
							],
							[
								80.286294,
								13.006261
							],
							[
								79.862547,
								12.056215
							],
							[
								79.857999,
								10.357275
							],
							[
								79.340512,
								10.308854
							],
							[
								78.885345,
								9.546136
							],
							[
								79.18972,
								9.216544
							],
							[
								78.277941,
								8.933047
							],
							[
								77.941165,
								8.252959
							],
							[
								77.539898,
								7.965535
							],
							[
								76.592979,
								8.899276
							],
							[
								76.130061,
								10.29963
							],
							[
								75.746467,
								11.308251
							],
							[
								75.396101,
								11.781245
							],
							[
								74.864816,
								12.741936
							],
							[
								74.616717,
								13.992583
							],
							[
								74.443859,
								14.617222
							],
							[
								73.534199,
								15.990652
							],
							[
								73.119909,
								17.92857
							],
							[
								72.820909,
								19.208234
							],
							[
								72.824475,
								20.419503
							],
							[
								72.630533,
								21.356009
							],
							[
								71.175273,
								20.757441
							],
							[
								70.470459,
								20.877331
							],
							[
								69.16413,
								22.089298
							],
							[
								69.644928,
								22.450775
							],
							[
								69.349597,
								22.84318
							],
							[
								68.176645,
								23.691965
							],
							[
								68.842599,
								24.359134
							],
							[
								71.04324,
								24.356524
							],
							[
								70.844699,
								25.215102
							],
							[
								70.282873,
								25.722229
							],
							[
								70.168927,
								26.491872
							],
							[
								69.514393,
								26.940966
							],
							[
								70.616496,
								27.989196
							],
							[
								71.777666,
								27.91318
							],
							[
								72.823752,
								28.961592
							],
							[
								73.450638,
								29.976413
							],
							[
								74.42138,
								30.979815
							],
							[
								74.405929,
								31.692639
							],
							[
								75.258642,
								32.271105
							],
							[
								74.451559,
								32.7649
							],
							[
								74.104294,
								33.441473
							],
							[
								73.749948,
								34.317699
							],
							[
								74.240203,
								34.748887
							],
							[
								75.757061,
								34.504923
							],
							[
								76.871722,
								34.653544
							],
							[
								77.837451,
								35.49401
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "IRL",
				"properties": {
					"name": "Ireland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-6.197885,
								53.867565
							],
							[
								-6.032985,
								53.153164
							],
							[
								-6.788857,
								52.260118
							],
							[
								-8.561617,
								51.669301
							],
							[
								-9.977086,
								51.820455
							],
							[
								-9.166283,
								52.864629
							],
							[
								-9.688525,
								53.881363
							],
							[
								-8.327987,
								54.664519
							],
							[
								-7.572168,
								55.131622
							],
							[
								-7.366031,
								54.595841
							],
							[
								-7.572168,
								54.059956
							],
							[
								-6.95373,
								54.073702
							],
							[
								-6.197885,
								53.867565
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "IRN",
				"properties": {
					"name": "Iran"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								53.921598,
								37.198918
							],
							[
								54.800304,
								37.392421
							],
							[
								55.511578,
								37.964117
							],
							[
								56.180375,
								37.935127
							],
							[
								56.619366,
								38.121394
							],
							[
								57.330434,
								38.029229
							],
							[
								58.436154,
								37.522309
							],
							[
								59.234762,
								37.412988
							],
							[
								60.377638,
								36.527383
							],
							[
								61.123071,
								36.491597
							],
							[
								61.210817,
								35.650072
							],
							[
								60.803193,
								34.404102
							],
							[
								60.52843,
								33.676446
							],
							[
								60.9637,
								33.528832
							],
							[
								60.536078,
								32.981269
							],
							[
								60.863655,
								32.18292
							],
							[
								60.941945,
								31.548075
							],
							[
								61.699314,
								31.379506
							],
							[
								61.781222,
								30.73585
							],
							[
								60.874248,
								29.829239
							],
							[
								61.369309,
								29.303276
							],
							[
								61.771868,
								28.699334
							],
							[
								62.72783,
								28.259645
							],
							[
								62.755426,
								27.378923
							],
							[
								63.233898,
								27.217047
							],
							[
								63.316632,
								26.756532
							],
							[
								61.874187,
								26.239975
							],
							[
								61.497363,
								25.078237
							],
							[
								59.616134,
								25.380157
							],
							[
								58.525761,
								25.609962
							],
							[
								57.397251,
								25.739902
							],
							[
								56.970766,
								26.966106
							],
							[
								56.492139,
								27.143305
							],
							[
								55.72371,
								26.964633
							],
							[
								54.71509,
								26.480658
							],
							[
								53.493097,
								26.812369
							],
							[
								52.483598,
								27.580849
							],
							[
								51.520763,
								27.86569
							],
							[
								50.852948,
								28.814521
							],
							[
								50.115009,
								30.147773
							],
							[
								49.57685,
								29.985715
							],
							[
								48.941333,
								30.31709
							],
							[
								48.567971,
								29.926778
							],
							[
								48.014568,
								30.452457
							],
							[
								48.004698,
								30.985137
							],
							[
								47.685286,
								30.984853
							],
							[
								47.849204,
								31.709176
							],
							[
								47.334661,
								32.469155
							],
							[
								46.109362,
								33.017287
							],
							[
								45.416691,
								33.967798
							],
							[
								45.64846,
								34.748138
							],
							[
								46.151788,
								35.093259
							],
							[
								46.07634,
								35.677383
							],
							[
								45.420618,
								35.977546
							],
							[
								44.77267,
								37.17045
							],
							[
								44.225756,
								37.971584
							],
							[
								44.421403,
								38.281281
							],
							[
								44.109225,
								39.428136
							],
							[
								44.79399,
								39.713003
							],
							[
								44.952688,
								39.335765
							],
							[
								45.457722,
								38.874139
							],
							[
								46.143623,
								38.741201
							],
							[
								46.50572,
								38.770605
							],
							[
								47.685079,
								39.508364
							],
							[
								48.060095,
								39.582235
							],
							[
								48.355529,
								39.288765
							],
							[
								48.010744,
								38.794015
							],
							[
								48.634375,
								38.270378
							],
							[
								48.883249,
								38.320245
							],
							[
								49.199612,
								37.582874
							],
							[
								50.147771,
								37.374567
							],
							[
								50.842354,
								36.872814
							],
							[
								52.264025,
								36.700422
							],
							[
								53.82579,
								36.965031
							],
							[
								53.921598,
								37.198918
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "IRQ",
				"properties": {
					"name": "Iraq"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								45.420618,
								35.977546
							],
							[
								46.07634,
								35.677383
							],
							[
								46.151788,
								35.093259
							],
							[
								45.64846,
								34.748138
							],
							[
								45.416691,
								33.967798
							],
							[
								46.109362,
								33.017287
							],
							[
								47.334661,
								32.469155
							],
							[
								47.849204,
								31.709176
							],
							[
								47.685286,
								30.984853
							],
							[
								48.004698,
								30.985137
							],
							[
								48.014568,
								30.452457
							],
							[
								48.567971,
								29.926778
							],
							[
								47.974519,
								29.975819
							],
							[
								47.302622,
								30.05907
							],
							[
								46.568713,
								29.099025
							],
							[
								44.709499,
								29.178891
							],
							[
								41.889981,
								31.190009
							],
							[
								40.399994,
								31.889992
							],
							[
								39.195468,
								32.161009
							],
							[
								38.792341,
								33.378686
							],
							[
								41.006159,
								34.419372
							],
							[
								41.383965,
								35.628317
							],
							[
								41.289707,
								36.358815
							],
							[
								41.837064,
								36.605854
							],
							[
								42.349591,
								37.229873
							],
							[
								42.779126,
								37.385264
							],
							[
								43.942259,
								37.256228
							],
							[
								44.293452,
								37.001514
							],
							[
								44.772699,
								37.170445
							],
							[
								45.420618,
								35.977546
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ISL",
				"properties": {
					"name": "Iceland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-14.508695,
								66.455892
							],
							[
								-14.739637,
								65.808748
							],
							[
								-13.609732,
								65.126671
							],
							[
								-14.909834,
								64.364082
							],
							[
								-17.794438,
								63.678749
							],
							[
								-18.656246,
								63.496383
							],
							[
								-19.972755,
								63.643635
							],
							[
								-22.762972,
								63.960179
							],
							[
								-21.778484,
								64.402116
							],
							[
								-23.955044,
								64.89113
							],
							[
								-22.184403,
								65.084968
							],
							[
								-22.227423,
								65.378594
							],
							[
								-24.326184,
								65.611189
							],
							[
								-23.650515,
								66.262519
							],
							[
								-22.134922,
								66.410469
							],
							[
								-20.576284,
								65.732112
							],
							[
								-19.056842,
								66.276601
							],
							[
								-17.798624,
								65.993853
							],
							[
								-16.167819,
								66.526792
							],
							[
								-14.508695,
								66.455892
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ISR",
				"properties": {
					"name": "Israel"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.719918,
								32.709192
							],
							[
								35.545665,
								32.393992
							],
							[
								35.18393,
								32.532511
							],
							[
								34.974641,
								31.866582
							],
							[
								35.225892,
								31.754341
							],
							[
								34.970507,
								31.616778
							],
							[
								34.927408,
								31.353435
							],
							[
								35.397561,
								31.489086
							],
							[
								35.420918,
								31.100066
							],
							[
								34.922603,
								29.501326
							],
							[
								34.265433,
								31.219361
							],
							[
								34.556372,
								31.548824
							],
							[
								34.488107,
								31.605539
							],
							[
								34.752587,
								32.072926
							],
							[
								34.955417,
								32.827376
							],
							[
								35.098457,
								33.080539
							],
							[
								35.126053,
								33.0909
							],
							[
								35.460709,
								33.08904
							],
							[
								35.552797,
								33.264275
							],
							[
								35.821101,
								33.277426
							],
							[
								35.836397,
								32.868123
							],
							[
								35.700798,
								32.716014
							],
							[
								35.719918,
								32.709192
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ITA",
				"properties": {
					"name": "Italy"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									15.520376,
									38.231155
								],
								[
									15.160243,
									37.444046
								],
								[
									15.309898,
									37.134219
								],
								[
									15.099988,
									36.619987
								],
								[
									14.335229,
									36.996631
								],
								[
									13.826733,
									37.104531
								],
								[
									12.431004,
									37.61295
								],
								[
									12.570944,
									38.126381
								],
								[
									13.741156,
									38.034966
								],
								[
									14.761249,
									38.143874
								],
								[
									15.520376,
									38.231155
								]
							]
						],
						[
							[
								[
									9.210012,
									41.209991
								],
								[
									9.809975,
									40.500009
								],
								[
									9.669519,
									39.177376
								],
								[
									9.214818,
									39.240473
								],
								[
									8.806936,
									38.906618
								],
								[
									8.428302,
									39.171847
								],
								[
									8.388253,
									40.378311
								],
								[
									8.159998,
									40.950007
								],
								[
									8.709991,
									40.899984
								],
								[
									9.210012,
									41.209991
								]
							]
						],
						[
							[
								[
									12.376485,
									46.767559
								],
								[
									13.806475,
									46.509306
								],
								[
									13.69811,
									46.016778
								],
								[
									13.93763,
									45.591016
								],
								[
									13.141606,
									45.736692
								],
								[
									12.328581,
									45.381778
								],
								[
									12.383875,
									44.885374
								],
								[
									12.261453,
									44.600482
								],
								[
									12.589237,
									44.091366
								],
								[
									13.526906,
									43.587727
								],
								[
									14.029821,
									42.761008
								],
								[
									15.14257,
									41.95514
								],
								[
									15.926191,
									41.961315
								],
								[
									16.169897,
									41.740295
								],
								[
									15.889346,
									41.541082
								],
								[
									16.785002,
									41.179606
								],
								[
									17.519169,
									40.877143
								],
								[
									18.376687,
									40.355625
								],
								[
									18.480247,
									40.168866
								],
								[
									18.293385,
									39.810774
								],
								[
									17.73838,
									40.277671
								],
								[
									16.869596,
									40.442235
								],
								[
									16.448743,
									39.795401
								],
								[
									17.17149,
									39.4247
								],
								[
									17.052841,
									38.902871
								],
								[
									16.635088,
									38.843572
								],
								[
									16.100961,
									37.985899
								],
								[
									15.684087,
									37.908849
								],
								[
									15.687963,
									38.214593
								],
								[
									15.891981,
									38.750942
								],
								[
									16.109332,
									38.964547
								],
								[
									15.718814,
									39.544072
								],
								[
									15.413613,
									40.048357
								],
								[
									14.998496,
									40.172949
								],
								[
									14.703268,
									40.60455
								],
								[
									14.060672,
									40.786348
								],
								[
									13.627985,
									41.188287
								],
								[
									12.888082,
									41.25309
								],
								[
									12.106683,
									41.704535
								],
								[
									11.191906,
									42.355425
								],
								[
									10.511948,
									42.931463
								],
								[
									10.200029,
									43.920007
								],
								[
									9.702488,
									44.036279
								],
								[
									8.888946,
									44.366336
								],
								[
									8.428561,
									44.231228
								],
								[
									7.850767,
									43.767148
								],
								[
									7.435185,
									43.693845
								],
								[
									7.549596,
									44.127901
								],
								[
									7.007562,
									44.254767
								],
								[
									6.749955,
									45.028518
								],
								[
									7.096652,
									45.333099
								],
								[
									6.802355,
									45.70858
								],
								[
									6.843593,
									45.991147
								],
								[
									7.273851,
									45.776948
								],
								[
									7.755992,
									45.82449
								],
								[
									8.31663,
									46.163642
								],
								[
									8.489952,
									46.005151
								],
								[
									8.966306,
									46.036932
								],
								[
									9.182882,
									46.440215
								],
								[
									9.922837,
									46.314899
								],
								[
									10.363378,
									46.483571
								],
								[
									10.442701,
									46.893546
								],
								[
									11.048556,
									46.751359
								],
								[
									11.164828,
									46.941579
								],
								[
									12.153088,
									47.115393
								],
								[
									12.376485,
									46.767559
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "JAM",
				"properties": {
					"name": "Jamaica"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-77.569601,
								18.490525
							],
							[
								-76.896619,
								18.400867
							],
							[
								-76.365359,
								18.160701
							],
							[
								-76.199659,
								17.886867
							],
							[
								-76.902561,
								17.868238
							],
							[
								-77.206341,
								17.701116
							],
							[
								-77.766023,
								17.861597
							],
							[
								-78.337719,
								18.225968
							],
							[
								-78.217727,
								18.454533
							],
							[
								-77.797365,
								18.524218
							],
							[
								-77.569601,
								18.490525
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "JOR",
				"properties": {
					"name": "Jordan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.545665,
								32.393992
							],
							[
								35.719918,
								32.709192
							],
							[
								36.834062,
								32.312938
							],
							[
								38.792341,
								33.378686
							],
							[
								39.195468,
								32.161009
							],
							[
								39.004886,
								32.010217
							],
							[
								37.002166,
								31.508413
							],
							[
								37.998849,
								30.5085
							],
							[
								37.66812,
								30.338665
							],
							[
								37.503582,
								30.003776
							],
							[
								36.740528,
								29.865283
							],
							[
								36.501214,
								29.505254
							],
							[
								36.068941,
								29.197495
							],
							[
								34.956037,
								29.356555
							],
							[
								34.922603,
								29.501326
							],
							[
								35.420918,
								31.100066
							],
							[
								35.397561,
								31.489086
							],
							[
								35.545252,
								31.782505
							],
							[
								35.545665,
								32.393992
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "JPN",
				"properties": {
					"name": "Japan"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									134.638428,
									34.149234
								],
								[
									134.766379,
									33.806335
								],
								[
									134.203416,
									33.201178
								],
								[
									133.79295,
									33.521985
								],
								[
									133.280268,
									33.28957
								],
								[
									133.014858,
									32.704567
								],
								[
									132.363115,
									32.989382
								],
								[
									132.371176,
									33.463642
								],
								[
									132.924373,
									34.060299
								],
								[
									133.492968,
									33.944621
								],
								[
									133.904106,
									34.364931
								],
								[
									134.638428,
									34.149234
								]
							]
						],
						[
							[
								[
									140.976388,
									37.142074
								],
								[
									140.59977,
									36.343983
								],
								[
									140.774074,
									35.842877
								],
								[
									140.253279,
									35.138114
								],
								[
									138.975528,
									34.6676
								],
								[
									137.217599,
									34.606286
								],
								[
									135.792983,
									33.464805
								],
								[
									135.120983,
									33.849071
								],
								[
									135.079435,
									34.596545
								],
								[
									133.340316,
									34.375938
								],
								[
									132.156771,
									33.904933
								],
								[
									130.986145,
									33.885761
								],
								[
									132.000036,
									33.149992
								],
								[
									131.33279,
									31.450355
								],
								[
									130.686318,
									31.029579
								],
								[
									130.20242,
									31.418238
								],
								[
									130.447676,
									32.319475
								],
								[
									129.814692,
									32.61031
								],
								[
									129.408463,
									33.296056
								],
								[
									130.353935,
									33.604151
								],
								[
									130.878451,
									34.232743
								],
								[
									131.884229,
									34.749714
								],
								[
									132.617673,
									35.433393
								],
								[
									134.608301,
									35.731618
								],
								[
									135.677538,
									35.527134
								],
								[
									136.723831,
									37.304984
								],
								[
									137.390612,
									36.827391
								],
								[
									138.857602,
									37.827485
								],
								[
									139.426405,
									38.215962
								],
								[
									140.05479,
									39.438807
								],
								[
									139.883379,
									40.563312
								],
								[
									140.305783,
									41.195005
								],
								[
									141.368973,
									41.37856
								],
								[
									141.914263,
									39.991616
								],
								[
									141.884601,
									39.180865
								],
								[
									140.959489,
									38.174001
								],
								[
									140.976388,
									37.142074
								]
							]
						],
						[
							[
								[
									143.910162,
									44.1741
								],
								[
									144.613427,
									43.960883
								],
								[
									145.320825,
									44.384733
								],
								[
									145.543137,
									43.262088
								],
								[
									144.059662,
									42.988358
								],
								[
									143.18385,
									41.995215
								],
								[
									141.611491,
									42.678791
								],
								[
									141.067286,
									41.584594
								],
								[
									139.955106,
									41.569556
								],
								[
									139.817544,
									42.563759
								],
								[
									140.312087,
									43.333273
								],
								[
									141.380549,
									43.388825
								],
								[
									141.671952,
									44.772125
								],
								[
									141.967645,
									45.551483
								],
								[
									143.14287,
									44.510358
								],
								[
									143.910162,
									44.1741
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "KAZ",
				"properties": {
					"name": "Kazakhstan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								70.962315,
								42.266154
							],
							[
								70.388965,
								42.081308
							],
							[
								69.070027,
								41.384244
							],
							[
								68.632483,
								40.668681
							],
							[
								68.259896,
								40.662325
							],
							[
								67.985856,
								41.135991
							],
							[
								66.714047,
								41.168444
							],
							[
								66.510649,
								41.987644
							],
							[
								66.023392,
								41.994646
							],
							[
								66.098012,
								42.99766
							],
							[
								64.900824,
								43.728081
							],
							[
								63.185787,
								43.650075
							],
							[
								62.0133,
								43.504477
							],
							[
								61.05832,
								44.405817
							],
							[
								60.239972,
								44.784037
							],
							[
								58.689989,
								45.500014
							],
							[
								58.503127,
								45.586804
							],
							[
								55.928917,
								44.995858
							],
							[
								55.968191,
								41.308642
							],
							[
								55.455251,
								41.259859
							],
							[
								54.755345,
								42.043971
							],
							[
								54.079418,
								42.324109
							],
							[
								52.944293,
								42.116034
							],
							[
								52.50246,
								41.783316
							],
							[
								52.446339,
								42.027151
							],
							[
								52.692112,
								42.443895
							],
							[
								52.501426,
								42.792298
							],
							[
								51.342427,
								43.132975
							],
							[
								50.891292,
								44.031034
							],
							[
								50.339129,
								44.284016
							],
							[
								50.305643,
								44.609836
							],
							[
								51.278503,
								44.514854
							],
							[
								51.316899,
								45.245998
							],
							[
								52.16739,
								45.408391
							],
							[
								53.040876,
								45.259047
							],
							[
								53.220866,
								46.234646
							],
							[
								53.042737,
								46.853006
							],
							[
								52.042023,
								46.804637
							],
							[
								51.191945,
								47.048705
							],
							[
								50.034083,
								46.60899
							],
							[
								49.10116,
								46.39933
							],
							[
								48.593241,
								46.561034
							],
							[
								48.694734,
								47.075628
							],
							[
								48.057253,
								47.743753
							],
							[
								47.315231,
								47.715847
							],
							[
								46.466446,
								48.394152
							],
							[
								47.043672,
								49.152039
							],
							[
								46.751596,
								49.356006
							],
							[
								47.54948,
								50.454698
							],
							[
								48.577841,
								49.87476
							],
							[
								48.702382,
								50.605128
							],
							[
								50.766648,
								51.692762
							],
							[
								52.328724,
								51.718652
							],
							[
								54.532878,
								51.02624
							],
							[
								55.716941,
								50.621717
							],
							[
								56.777961,
								51.043551
							],
							[
								58.363291,
								51.063653
							],
							[
								59.642282,
								50.545442
							],
							[
								59.932807,
								50.842194
							],
							[
								61.337424,
								50.79907
							],
							[
								61.588003,
								51.272659
							],
							[
								59.967534,
								51.96042
							],
							[
								60.927269,
								52.447548
							],
							[
								60.739993,
								52.719986
							],
							[
								61.699986,
								52.979996
							],
							[
								60.978066,
								53.664993
							],
							[
								61.436591,
								54.006265
							],
							[
								65.178534,
								54.354228
							],
							[
								65.666876,
								54.601267
							],
							[
								68.1691,
								54.970392
							],
							[
								69.068167,
								55.38525
							],
							[
								70.865267,
								55.169734
							],
							[
								71.180131,
								54.133285
							],
							[
								72.22415,
								54.376655
							],
							[
								73.508516,
								54.035617
							],
							[
								73.425679,
								53.48981
							],
							[
								74.384845,
								53.546861
							],
							[
								76.8911,
								54.490524
							],
							[
								76.525179,
								54.177003
							],
							[
								77.800916,
								53.404415
							],
							[
								80.03556,
								50.864751
							],
							[
								80.568447,
								51.388336
							],
							[
								81.945986,
								50.812196
							],
							[
								83.383004,
								51.069183
							],
							[
								83.935115,
								50.889246
							],
							[
								84.416377,
								50.3114
							],
							[
								85.11556,
								50.117303
							],
							[
								85.54127,
								49.692859
							],
							[
								86.829357,
								49.826675
							],
							[
								87.35997,
								49.214981
							],
							[
								86.598776,
								48.549182
							],
							[
								85.768233,
								48.455751
							],
							[
								85.720484,
								47.452969
							],
							[
								85.16429,
								47.000956
							],
							[
								83.180484,
								47.330031
							],
							[
								82.458926,
								45.53965
							],
							[
								81.947071,
								45.317027
							],
							[
								79.966106,
								44.917517
							],
							[
								80.866206,
								43.180362
							],
							[
								80.18015,
								42.920068
							],
							[
								80.25999,
								42.349999
							],
							[
								79.643645,
								42.496683
							],
							[
								79.142177,
								42.856092
							],
							[
								77.658392,
								42.960686
							],
							[
								76.000354,
								42.988022
							],
							[
								75.636965,
								42.8779
							],
							[
								74.212866,
								43.298339
							],
							[
								73.645304,
								43.091272
							],
							[
								73.489758,
								42.500894
							],
							[
								71.844638,
								42.845395
							],
							[
								71.186281,
								42.704293
							],
							[
								70.962315,
								42.266154
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "KEN",
				"properties": {
					"name": "Kenya"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								40.993,
								-0.85829
							],
							[
								41.58513,
								-1.68325
							],
							[
								40.88477,
								-2.08255
							],
							[
								40.63785,
								-2.49979
							],
							[
								40.26304,
								-2.57309
							],
							[
								40.12119,
								-3.27768
							],
							[
								39.80006,
								-3.68116
							],
							[
								39.60489,
								-4.34653
							],
							[
								39.20222,
								-4.67677
							],
							[
								37.7669,
								-3.67712
							],
							[
								37.69869,
								-3.09699
							],
							[
								34.07262,
								-1.05982
							],
							[
								33.903711,
								-0.95
							],
							[
								33.893569,
								0.109814
							],
							[
								34.18,
								0.515
							],
							[
								34.6721,
								1.17694
							],
							[
								35.03599,
								1.90584
							],
							[
								34.59607,
								3.05374
							],
							[
								34.47913,
								3.5556
							],
							[
								34.005,
								4.249885
							],
							[
								34.620196,
								4.847123
							],
							[
								35.298007,
								5.506
							],
							[
								35.817448,
								5.338232
							],
							[
								35.817448,
								4.776966
							],
							[
								36.159079,
								4.447864
							],
							[
								36.855093,
								4.447864
							],
							[
								38.120915,
								3.598605
							],
							[
								38.43697,
								3.58851
							],
							[
								38.67114,
								3.61607
							],
							[
								38.89251,
								3.50074
							],
							[
								39.559384,
								3.42206
							],
							[
								39.85494,
								3.83879
							],
							[
								40.76848,
								4.25702
							],
							[
								41.1718,
								3.91909
							],
							[
								41.855083,
								3.918912
							],
							[
								40.98105,
								2.78452
							],
							[
								40.993,
								-0.85829
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "KGZ",
				"properties": {
					"name": "Kyrgyzstan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								70.962315,
								42.266154
							],
							[
								71.186281,
								42.704293
							],
							[
								71.844638,
								42.845395
							],
							[
								73.489758,
								42.500894
							],
							[
								73.645304,
								43.091272
							],
							[
								74.212866,
								43.298339
							],
							[
								75.636965,
								42.8779
							],
							[
								76.000354,
								42.988022
							],
							[
								77.658392,
								42.960686
							],
							[
								79.142177,
								42.856092
							],
							[
								79.643645,
								42.496683
							],
							[
								80.25999,
								42.349999
							],
							[
								80.11943,
								42.123941
							],
							[
								78.543661,
								41.582243
							],
							[
								78.187197,
								41.185316
							],
							[
								76.904484,
								41.066486
							],
							[
								76.526368,
								40.427946
							],
							[
								75.467828,
								40.562072
							],
							[
								74.776862,
								40.366425
							],
							[
								73.822244,
								39.893973
							],
							[
								73.960013,
								39.660008
							],
							[
								73.675379,
								39.431237
							],
							[
								71.784694,
								39.279463
							],
							[
								70.549162,
								39.604198
							],
							[
								69.464887,
								39.526683
							],
							[
								69.55961,
								40.103211
							],
							[
								70.648019,
								39.935754
							],
							[
								71.014198,
								40.244366
							],
							[
								71.774875,
								40.145844
							],
							[
								73.055417,
								40.866033
							],
							[
								71.870115,
								41.3929
							],
							[
								71.157859,
								41.143587
							],
							[
								70.420022,
								41.519998
							],
							[
								71.259248,
								42.167711
							],
							[
								70.962315,
								42.266154
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "KHM",
				"properties": {
					"name": "Cambodia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								103.49728,
								10.632555
							],
							[
								103.09069,
								11.153661
							],
							[
								102.584932,
								12.186595
							],
							[
								102.348099,
								13.394247
							],
							[
								102.988422,
								14.225721
							],
							[
								104.281418,
								14.416743
							],
							[
								105.218777,
								14.273212
							],
							[
								106.043946,
								13.881091
							],
							[
								106.496373,
								14.570584
							],
							[
								107.382727,
								14.202441
							],
							[
								107.614548,
								13.535531
							],
							[
								107.491403,
								12.337206
							],
							[
								105.810524,
								11.567615
							],
							[
								106.24967,
								10.961812
							],
							[
								105.199915,
								10.88931
							],
							[
								104.334335,
								10.486544
							],
							[
								103.49728,
								10.632555
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "KOR",
				"properties": {
					"name": "South Korea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								128.349716,
								38.612243
							],
							[
								129.21292,
								37.432392
							],
							[
								129.46045,
								36.784189
							],
							[
								129.468304,
								35.632141
							],
							[
								129.091377,
								35.082484
							],
							[
								128.18585,
								34.890377
							],
							[
								127.386519,
								34.475674
							],
							[
								126.485748,
								34.390046
							],
							[
								126.37392,
								34.93456
							],
							[
								126.559231,
								35.684541
							],
							[
								126.117398,
								36.725485
							],
							[
								126.860143,
								36.893924
							],
							[
								126.174759,
								37.749686
							],
							[
								126.237339,
								37.840378
							],
							[
								126.68372,
								37.804773
							],
							[
								127.073309,
								38.256115
							],
							[
								127.780035,
								38.304536
							],
							[
								128.205746,
								38.370397
							],
							[
								128.349716,
								38.612243
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "CS-KM",
				"properties": {
					"name": "Kosovo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.76216,
								42.05186
							],
							[
								20.71731,
								41.84711
							],
							[
								20.59023,
								41.85541
							],
							[
								20.52295,
								42.21787
							],
							[
								20.28374,
								42.32025
							],
							[
								20.0707,
								42.58863
							],
							[
								20.25758,
								42.81275
							],
							[
								20.49679,
								42.88469
							],
							[
								20.63508,
								43.21671
							],
							[
								20.81448,
								43.27205
							],
							[
								20.95651,
								43.13094
							],
							[
								21.143395,
								43.068685
							],
							[
								21.27421,
								42.90959
							],
							[
								21.43866,
								42.86255
							],
							[
								21.63302,
								42.67717
							],
							[
								21.77505,
								42.6827
							],
							[
								21.66292,
								42.43922
							],
							[
								21.54332,
								42.32025
							],
							[
								21.576636,
								42.245224
							],
							[
								21.3527,
								42.2068
							],
							[
								20.76216,
								42.05186
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "KWT",
				"properties": {
					"name": "Kuwait"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								47.974519,
								29.975819
							],
							[
								48.183189,
								29.534477
							],
							[
								48.093943,
								29.306299
							],
							[
								48.416094,
								28.552004
							],
							[
								47.708851,
								28.526063
							],
							[
								47.459822,
								29.002519
							],
							[
								46.568713,
								29.099025
							],
							[
								47.302622,
								30.05907
							],
							[
								47.974519,
								29.975819
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LAO",
				"properties": {
					"name": "Laos"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								105.218777,
								14.273212
							],
							[
								105.544338,
								14.723934
							],
							[
								105.589039,
								15.570316
							],
							[
								104.779321,
								16.441865
							],
							[
								104.716947,
								17.428859
							],
							[
								103.956477,
								18.240954
							],
							[
								103.200192,
								18.309632
							],
							[
								102.998706,
								17.961695
							],
							[
								102.413005,
								17.932782
							],
							[
								102.113592,
								18.109102
							],
							[
								101.059548,
								17.512497
							],
							[
								101.035931,
								18.408928
							],
							[
								101.282015,
								19.462585
							],
							[
								100.606294,
								19.508344
							],
							[
								100.548881,
								20.109238
							],
							[
								100.115988,
								20.41785
							],
							[
								100.329101,
								20.786122
							],
							[
								101.180005,
								21.436573
							],
							[
								101.270026,
								21.201652
							],
							[
								101.80312,
								21.174367
							],
							[
								101.652018,
								22.318199
							],
							[
								102.170436,
								22.464753
							],
							[
								102.754896,
								21.675137
							],
							[
								103.203861,
								20.766562
							],
							[
								104.435,
								20.758733
							],
							[
								104.822574,
								19.886642
							],
							[
								104.183388,
								19.624668
							],
							[
								103.896532,
								19.265181
							],
							[
								105.094598,
								18.666975
							],
							[
								105.925762,
								17.485315
							],
							[
								106.556008,
								16.604284
							],
							[
								107.312706,
								15.908538
							],
							[
								107.564525,
								15.202173
							],
							[
								107.382727,
								14.202441
							],
							[
								106.496373,
								14.570584
							],
							[
								106.043946,
								13.881091
							],
							[
								105.218777,
								14.273212
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LBN",
				"properties": {
					"name": "Lebanon"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.821101,
								33.277426
							],
							[
								35.552797,
								33.264275
							],
							[
								35.460709,
								33.08904
							],
							[
								35.126053,
								33.0909
							],
							[
								35.482207,
								33.90545
							],
							[
								35.979592,
								34.610058
							],
							[
								35.998403,
								34.644914
							],
							[
								36.448194,
								34.593935
							],
							[
								36.61175,
								34.201789
							],
							[
								36.06646,
								33.824912
							],
							[
								35.821101,
								33.277426
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LBR",
				"properties": {
					"name": "Liberia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-7.712159,
								4.364566
							],
							[
								-7.974107,
								4.355755
							],
							[
								-9.004794,
								4.832419
							],
							[
								-9.91342,
								5.593561
							],
							[
								-10.765384,
								6.140711
							],
							[
								-11.438779,
								6.785917
							],
							[
								-11.199802,
								7.105846
							],
							[
								-11.146704,
								7.396706
							],
							[
								-10.695595,
								7.939464
							],
							[
								-10.230094,
								8.406206
							],
							[
								-10.016567,
								8.428504
							],
							[
								-9.755342,
								8.541055
							],
							[
								-9.33728,
								7.928534
							],
							[
								-9.403348,
								7.526905
							],
							[
								-9.208786,
								7.313921
							],
							[
								-8.926065,
								7.309037
							],
							[
								-8.722124,
								7.711674
							],
							[
								-8.439298,
								7.686043
							],
							[
								-8.485446,
								7.395208
							],
							[
								-8.385452,
								6.911801
							],
							[
								-8.60288,
								6.467564
							],
							[
								-8.311348,
								6.193033
							],
							[
								-7.993693,
								6.12619
							],
							[
								-7.570153,
								5.707352
							],
							[
								-7.539715,
								5.313345
							],
							[
								-7.635368,
								5.188159
							],
							[
								-7.712159,
								4.364566
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LBY",
				"properties": {
					"name": "Libya"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								14.8513,
								22.86295
							],
							[
								14.143871,
								22.491289
							],
							[
								13.581425,
								23.040506
							],
							[
								11.999506,
								23.471668
							],
							[
								11.560669,
								24.097909
							],
							[
								10.771364,
								24.562532
							],
							[
								10.303847,
								24.379313
							],
							[
								9.948261,
								24.936954
							],
							[
								9.910693,
								25.365455
							],
							[
								9.319411,
								26.094325
							],
							[
								9.716286,
								26.512206
							],
							[
								9.629056,
								27.140953
							],
							[
								9.756128,
								27.688259
							],
							[
								9.683885,
								28.144174
							],
							[
								9.859998,
								28.95999
							],
							[
								9.805634,
								29.424638
							],
							[
								9.48214,
								30.307556
							],
							[
								9.970017,
								30.539325
							],
							[
								10.056575,
								30.961831
							],
							[
								9.950225,
								31.37607
							],
							[
								10.636901,
								31.761421
							],
							[
								10.94479,
								32.081815
							],
							[
								11.432253,
								32.368903
							],
							[
								11.488787,
								33.136996
							],
							[
								12.66331,
								32.79278
							],
							[
								13.08326,
								32.87882
							],
							[
								13.91868,
								32.71196
							],
							[
								15.24563,
								32.26508
							],
							[
								15.71394,
								31.37626
							],
							[
								16.61162,
								31.18218
							],
							[
								18.02109,
								30.76357
							],
							[
								19.08641,
								30.26639
							],
							[
								19.57404,
								30.52582
							],
							[
								20.05335,
								30.98576
							],
							[
								19.82033,
								31.75179
							],
							[
								20.13397,
								32.2382
							],
							[
								20.85452,
								32.7068
							],
							[
								21.54298,
								32.8432
							],
							[
								22.89576,
								32.63858
							],
							[
								23.2368,
								32.19149
							],
							[
								23.60913,
								32.18726
							],
							[
								23.9275,
								32.01667
							],
							[
								24.92114,
								31.89936
							],
							[
								25.16482,
								31.56915
							],
							[
								24.80287,
								31.08929
							],
							[
								24.95762,
								30.6616
							],
							[
								24.70007,
								30.04419
							],
							[
								25,
								29.238655
							],
							[
								25,
								25.6825
							],
							[
								25,
								22
							],
							[
								25,
								20.00304
							],
							[
								23.85,
								20
							],
							[
								23.83766,
								19.58047
							],
							[
								19.84926,
								21.49509
							],
							[
								15.86085,
								23.40972
							],
							[
								14.8513,
								22.86295
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LKA",
				"properties": {
					"name": "Sri Lanka"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								81.787959,
								7.523055
							],
							[
								81.637322,
								6.481775
							],
							[
								81.21802,
								6.197141
							],
							[
								80.348357,
								5.96837
							],
							[
								79.872469,
								6.763463
							],
							[
								79.695167,
								8.200843
							],
							[
								80.147801,
								9.824078
							],
							[
								80.838818,
								9.268427
							],
							[
								81.304319,
								8.564206
							],
							[
								81.787959,
								7.523055
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LSO",
				"properties": {
					"name": "Lesotho"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								28.978263,
								-28.955597
							],
							[
								29.325166,
								-29.257387
							],
							[
								29.018415,
								-29.743766
							],
							[
								28.8484,
								-30.070051
							],
							[
								28.291069,
								-30.226217
							],
							[
								28.107205,
								-30.545732
							],
							[
								27.749397,
								-30.645106
							],
							[
								26.999262,
								-29.875954
							],
							[
								27.532511,
								-29.242711
							],
							[
								28.074338,
								-28.851469
							],
							[
								28.5417,
								-28.647502
							],
							[
								28.978263,
								-28.955597
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LTU",
				"properties": {
					"name": "Lithuania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								22.731099,
								54.327537
							],
							[
								22.651052,
								54.582741
							],
							[
								22.757764,
								54.856574
							],
							[
								22.315724,
								55.015299
							],
							[
								21.268449,
								55.190482
							],
							[
								21.0558,
								56.031076
							],
							[
								22.201157,
								56.337802
							],
							[
								23.878264,
								56.273671
							],
							[
								24.860684,
								56.372528
							],
							[
								25.000934,
								56.164531
							],
							[
								25.533047,
								56.100297
							],
							[
								26.494331,
								55.615107
							],
							[
								26.588279,
								55.167176
							],
							[
								25.768433,
								54.846963
							],
							[
								25.536354,
								54.282423
							],
							[
								24.450684,
								53.905702
							],
							[
								23.484128,
								53.912498
							],
							[
								23.243987,
								54.220567
							],
							[
								22.731099,
								54.327537
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LUX",
				"properties": {
					"name": "Luxembourg"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6.043073,
								50.128052
							],
							[
								6.242751,
								49.902226
							],
							[
								6.18632,
								49.463803
							],
							[
								5.897759,
								49.442667
							],
							[
								5.674052,
								49.529484
							],
							[
								5.782417,
								50.090328
							],
							[
								6.043073,
								50.128052
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "LVA",
				"properties": {
					"name": "Latvia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								21.0558,
								56.031076
							],
							[
								21.090424,
								56.783873
							],
							[
								21.581866,
								57.411871
							],
							[
								22.524341,
								57.753374
							],
							[
								23.318453,
								57.006236
							],
							[
								24.12073,
								57.025693
							],
							[
								24.312863,
								57.793424
							],
							[
								25.164594,
								57.970157
							],
							[
								25.60281,
								57.847529
							],
							[
								26.463532,
								57.476389
							],
							[
								27.288185,
								57.474528
							],
							[
								27.770016,
								57.244258
							],
							[
								27.855282,
								56.759326
							],
							[
								28.176709,
								56.16913
							],
							[
								27.10246,
								55.783314
							],
							[
								26.494331,
								55.615107
							],
							[
								25.533047,
								56.100297
							],
							[
								25.000934,
								56.164531
							],
							[
								24.860684,
								56.372528
							],
							[
								23.878264,
								56.273671
							],
							[
								22.201157,
								56.337802
							],
							[
								21.0558,
								56.031076
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MAR",
				"properties": {
					"name": "Morocco"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-5.193863,
								35.755182
							],
							[
								-4.591006,
								35.330712
							],
							[
								-3.640057,
								35.399855
							],
							[
								-2.604306,
								35.179093
							],
							[
								-2.169914,
								35.168396
							],
							[
								-1.792986,
								34.527919
							],
							[
								-1.733455,
								33.919713
							],
							[
								-1.388049,
								32.864015
							],
							[
								-1.124551,
								32.651522
							],
							[
								-1.307899,
								32.262889
							],
							[
								-2.616605,
								32.094346
							],
							[
								-3.06898,
								31.724498
							],
							[
								-3.647498,
								31.637294
							],
							[
								-3.690441,
								30.896952
							],
							[
								-4.859646,
								30.501188
							],
							[
								-5.242129,
								30.000443
							],
							[
								-6.060632,
								29.7317
							],
							[
								-7.059228,
								29.579228
							],
							[
								-8.674116,
								28.841289
							],
							[
								-8.66559,
								27.656426
							],
							[
								-8.817809,
								27.656426
							],
							[
								-8.817828,
								27.656426
							],
							[
								-8.794884,
								27.120696
							],
							[
								-9.413037,
								27.088476
							],
							[
								-9.735343,
								26.860945
							],
							[
								-10.189424,
								26.860945
							],
							[
								-10.551263,
								26.990808
							],
							[
								-11.392555,
								26.883424
							],
							[
								-11.71822,
								26.104092
							],
							[
								-12.030759,
								26.030866
							],
							[
								-12.500963,
								24.770116
							],
							[
								-13.89111,
								23.691009
							],
							[
								-14.221168,
								22.310163
							],
							[
								-14.630833,
								21.86094
							],
							[
								-14.750955,
								21.5006
							],
							[
								-17.002962,
								21.420734
							],
							[
								-17.020428,
								21.42231
							],
							[
								-16.973248,
								21.885745
							],
							[
								-16.589137,
								22.158234
							],
							[
								-16.261922,
								22.67934
							],
							[
								-16.326414,
								23.017768
							],
							[
								-15.982611,
								23.723358
							],
							[
								-15.426004,
								24.359134
							],
							[
								-15.089332,
								24.520261
							],
							[
								-14.824645,
								25.103533
							],
							[
								-14.800926,
								25.636265
							],
							[
								-14.43994,
								26.254418
							],
							[
								-13.773805,
								26.618892
							],
							[
								-13.139942,
								27.640148
							],
							[
								-13.121613,
								27.654148
							],
							[
								-12.618837,
								28.038186
							],
							[
								-11.688919,
								28.148644
							],
							[
								-10.900957,
								28.832142
							],
							[
								-10.399592,
								29.098586
							],
							[
								-9.564811,
								29.933574
							],
							[
								-9.814718,
								31.177736
							],
							[
								-9.434793,
								32.038096
							],
							[
								-9.300693,
								32.564679
							],
							[
								-8.657476,
								33.240245
							],
							[
								-7.654178,
								33.697065
							],
							[
								-6.912544,
								34.110476
							],
							[
								-6.244342,
								35.145865
							],
							[
								-5.929994,
								35.759988
							],
							[
								-5.193863,
								35.755182
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MDA",
				"properties": {
					"name": "Moldova"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								26.619337,
								48.220726
							],
							[
								26.857824,
								48.368211
							],
							[
								27.522537,
								48.467119
							],
							[
								28.259547,
								48.155562
							],
							[
								28.670891,
								48.118149
							],
							[
								29.122698,
								47.849095
							],
							[
								29.050868,
								47.510227
							],
							[
								29.415135,
								47.346645
							],
							[
								29.559674,
								46.928583
							],
							[
								29.908852,
								46.674361
							],
							[
								29.83821,
								46.525326
							],
							[
								30.024659,
								46.423937
							],
							[
								29.759972,
								46.349988
							],
							[
								29.170654,
								46.379262
							],
							[
								29.072107,
								46.517678
							],
							[
								28.862972,
								46.437889
							],
							[
								28.933717,
								46.25883
							],
							[
								28.659987,
								45.939987
							],
							[
								28.485269,
								45.596907
							],
							[
								28.233554,
								45.488283
							],
							[
								28.054443,
								45.944586
							],
							[
								28.160018,
								46.371563
							],
							[
								28.12803,
								46.810476
							],
							[
								27.551166,
								47.405117
							],
							[
								27.233873,
								47.826771
							],
							[
								26.924176,
								48.123264
							],
							[
								26.619337,
								48.220726
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MDG",
				"properties": {
					"name": "Madagascar"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								49.543519,
								-12.469833
							],
							[
								49.808981,
								-12.895285
							],
							[
								50.056511,
								-13.555761
							],
							[
								50.217431,
								-14.758789
							],
							[
								50.476537,
								-15.226512
							],
							[
								50.377111,
								-15.706069
							],
							[
								50.200275,
								-16.000263
							],
							[
								49.860606,
								-15.414253
							],
							[
								49.672607,
								-15.710204
							],
							[
								49.863344,
								-16.451037
							],
							[
								49.774564,
								-16.875042
							],
							[
								49.498612,
								-17.106036
							],
							[
								49.435619,
								-17.953064
							],
							[
								49.041792,
								-19.118781
							],
							[
								48.548541,
								-20.496888
							],
							[
								47.930749,
								-22.391501
							],
							[
								47.547723,
								-23.781959
							],
							[
								47.095761,
								-24.94163
							],
							[
								46.282478,
								-25.178463
							],
							[
								45.409508,
								-25.601434
							],
							[
								44.833574,
								-25.346101
							],
							[
								44.03972,
								-24.988345
							],
							[
								43.763768,
								-24.460677
							],
							[
								43.697778,
								-23.574116
							],
							[
								43.345654,
								-22.776904
							],
							[
								43.254187,
								-22.057413
							],
							[
								43.433298,
								-21.336475
							],
							[
								43.893683,
								-21.163307
							],
							[
								43.89637,
								-20.830459
							],
							[
								44.374325,
								-20.072366
							],
							[
								44.464397,
								-19.435454
							],
							[
								44.232422,
								-18.961995
							],
							[
								44.042976,
								-18.331387
							],
							[
								43.963084,
								-17.409945
							],
							[
								44.312469,
								-16.850496
							],
							[
								44.446517,
								-16.216219
							],
							[
								44.944937,
								-16.179374
							],
							[
								45.502732,
								-15.974373
							],
							[
								45.872994,
								-15.793454
							],
							[
								46.312243,
								-15.780018
							],
							[
								46.882183,
								-15.210182
							],
							[
								47.70513,
								-14.594303
							],
							[
								48.005215,
								-14.091233
							],
							[
								47.869047,
								-13.663869
							],
							[
								48.293828,
								-13.784068
							],
							[
								48.84506,
								-13.089175
							],
							[
								48.863509,
								-12.487868
							],
							[
								49.194651,
								-12.040557
							],
							[
								49.543519,
								-12.469833
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MEX",
				"properties": {
					"name": "Mexico"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-97.140008,
								25.869997
							],
							[
								-97.528072,
								24.992144
							],
							[
								-97.702946,
								24.272343
							],
							[
								-97.776042,
								22.93258
							],
							[
								-97.872367,
								22.444212
							],
							[
								-97.699044,
								21.898689
							],
							[
								-97.38896,
								21.411019
							],
							[
								-97.189333,
								20.635433
							],
							[
								-96.525576,
								19.890931
							],
							[
								-96.292127,
								19.320371
							],
							[
								-95.900885,
								18.828024
							],
							[
								-94.839063,
								18.562717
							],
							[
								-94.42573,
								18.144371
							],
							[
								-93.548651,
								18.423837
							],
							[
								-92.786114,
								18.524839
							],
							[
								-92.037348,
								18.704569
							],
							[
								-91.407903,
								18.876083
							],
							[
								-90.77187,
								19.28412
							],
							[
								-90.53359,
								19.867418
							],
							[
								-90.451476,
								20.707522
							],
							[
								-90.278618,
								20.999855
							],
							[
								-89.601321,
								21.261726
							],
							[
								-88.543866,
								21.493675
							],
							[
								-87.658417,
								21.458846
							],
							[
								-87.05189,
								21.543543
							],
							[
								-86.811982,
								21.331515
							],
							[
								-86.845908,
								20.849865
							],
							[
								-87.383291,
								20.255405
							],
							[
								-87.621054,
								19.646553
							],
							[
								-87.43675,
								19.472403
							],
							[
								-87.58656,
								19.04013
							],
							[
								-87.837191,
								18.259816
							],
							[
								-88.090664,
								18.516648
							],
							[
								-88.300031,
								18.499982
							],
							[
								-88.490123,
								18.486831
							],
							[
								-88.848344,
								17.883198
							],
							[
								-89.029857,
								18.001511
							],
							[
								-89.150909,
								17.955468
							],
							[
								-89.14308,
								17.808319
							],
							[
								-90.067934,
								17.819326
							],
							[
								-91.00152,
								17.817595
							],
							[
								-91.002269,
								17.254658
							],
							[
								-91.453921,
								17.252177
							],
							[
								-91.08167,
								16.918477
							],
							[
								-90.711822,
								16.687483
							],
							[
								-90.600847,
								16.470778
							],
							[
								-90.438867,
								16.41011
							],
							[
								-90.464473,
								16.069562
							],
							[
								-91.74796,
								16.066565
							],
							[
								-92.229249,
								15.251447
							],
							[
								-92.087216,
								15.064585
							],
							[
								-92.20323,
								14.830103
							],
							[
								-92.22775,
								14.538829
							],
							[
								-93.359464,
								15.61543
							],
							[
								-93.875169,
								15.940164
							],
							[
								-94.691656,
								16.200975
							],
							[
								-95.250227,
								16.128318
							],
							[
								-96.053382,
								15.752088
							],
							[
								-96.557434,
								15.653515
							],
							[
								-97.263592,
								15.917065
							],
							[
								-98.01303,
								16.107312
							],
							[
								-98.947676,
								16.566043
							],
							[
								-99.697397,
								16.706164
							],
							[
								-100.829499,
								17.171071
							],
							[
								-101.666089,
								17.649026
							],
							[
								-101.918528,
								17.91609
							],
							[
								-102.478132,
								17.975751
							],
							[
								-103.50099,
								18.292295
							],
							[
								-103.917527,
								18.748572
							],
							[
								-104.99201,
								19.316134
							],
							[
								-105.493038,
								19.946767
							],
							[
								-105.731396,
								20.434102
							],
							[
								-105.397773,
								20.531719
							],
							[
								-105.500661,
								20.816895
							],
							[
								-105.270752,
								21.076285
							],
							[
								-105.265817,
								21.422104
							],
							[
								-105.603161,
								21.871146
							],
							[
								-105.693414,
								22.26908
							],
							[
								-106.028716,
								22.773752
							],
							[
								-106.90998,
								23.767774
							],
							[
								-107.915449,
								24.548915
							],
							[
								-108.401905,
								25.172314
							],
							[
								-109.260199,
								25.580609
							],
							[
								-109.444089,
								25.824884
							],
							[
								-109.291644,
								26.442934
							],
							[
								-109.801458,
								26.676176
							],
							[
								-110.391732,
								27.162115
							],
							[
								-110.641019,
								27.859876
							],
							[
								-111.178919,
								27.941241
							],
							[
								-111.759607,
								28.467953
							],
							[
								-112.228235,
								28.954409
							],
							[
								-112.271824,
								29.266844
							],
							[
								-112.809594,
								30.021114
							],
							[
								-113.163811,
								30.786881
							],
							[
								-113.148669,
								31.170966
							],
							[
								-113.871881,
								31.567608
							],
							[
								-114.205737,
								31.524045
							],
							[
								-114.776451,
								31.799532
							],
							[
								-114.9367,
								31.393485
							],
							[
								-114.771232,
								30.913617
							],
							[
								-114.673899,
								30.162681
							],
							[
								-114.330974,
								29.750432
							],
							[
								-113.588875,
								29.061611
							],
							[
								-113.424053,
								28.826174
							],
							[
								-113.271969,
								28.754783
							],
							[
								-113.140039,
								28.411289
							],
							[
								-112.962298,
								28.42519
							],
							[
								-112.761587,
								27.780217
							],
							[
								-112.457911,
								27.525814
							],
							[
								-112.244952,
								27.171727
							],
							[
								-111.616489,
								26.662817
							],
							[
								-111.284675,
								25.73259
							],
							[
								-110.987819,
								25.294606
							],
							[
								-110.710007,
								24.826004
							],
							[
								-110.655049,
								24.298595
							],
							[
								-110.172856,
								24.265548
							],
							[
								-109.771847,
								23.811183
							],
							[
								-109.409104,
								23.364672
							],
							[
								-109.433392,
								23.185588
							],
							[
								-109.854219,
								22.818272
							],
							[
								-110.031392,
								22.823078
							],
							[
								-110.295071,
								23.430973
							],
							[
								-110.949501,
								24.000964
							],
							[
								-111.670568,
								24.484423
							],
							[
								-112.182036,
								24.738413
							],
							[
								-112.148989,
								25.470125
							],
							[
								-112.300711,
								26.012004
							],
							[
								-112.777297,
								26.32196
							],
							[
								-113.464671,
								26.768186
							],
							[
								-113.59673,
								26.63946
							],
							[
								-113.848937,
								26.900064
							],
							[
								-114.465747,
								27.14209
							],
							[
								-115.055142,
								27.722727
							],
							[
								-114.982253,
								27.7982
							],
							[
								-114.570366,
								27.741485
							],
							[
								-114.199329,
								28.115003
							],
							[
								-114.162018,
								28.566112
							],
							[
								-114.931842,
								29.279479
							],
							[
								-115.518654,
								29.556362
							],
							[
								-115.887365,
								30.180794
							],
							[
								-116.25835,
								30.836464
							],
							[
								-116.721526,
								31.635744
							],
							[
								-117.12776,
								32.53534
							],
							[
								-115.99135,
								32.61239
							],
							[
								-114.72139,
								32.72083
							],
							[
								-114.815,
								32.52528
							],
							[
								-113.30498,
								32.03914
							],
							[
								-111.02361,
								31.33472
							],
							[
								-109.035,
								31.34194
							],
							[
								-108.24194,
								31.34222
							],
							[
								-108.24,
								31.754854
							],
							[
								-106.50759,
								31.75452
							],
							[
								-106.1429,
								31.39995
							],
							[
								-105.63159,
								31.08383
							],
							[
								-105.03737,
								30.64402
							],
							[
								-104.70575,
								30.12173
							],
							[
								-104.45697,
								29.57196
							],
							[
								-103.94,
								29.27
							],
							[
								-103.11,
								28.97
							],
							[
								-102.48,
								29.76
							],
							[
								-101.6624,
								29.7793
							],
							[
								-100.9576,
								29.38071
							],
							[
								-100.45584,
								28.69612
							],
							[
								-100.11,
								28.11
							],
							[
								-99.52,
								27.54
							],
							[
								-99.3,
								26.84
							],
							[
								-99.02,
								26.37
							],
							[
								-98.24,
								26.06
							],
							[
								-97.53,
								25.84
							],
							[
								-97.140008,
								25.869997
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MKD",
				"properties": {
					"name": "Macedonia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.59023,
								41.85541
							],
							[
								20.71731,
								41.84711
							],
							[
								20.76216,
								42.05186
							],
							[
								21.3527,
								42.2068
							],
							[
								21.576636,
								42.245224
							],
							[
								21.91708,
								42.30364
							],
							[
								22.380526,
								42.32026
							],
							[
								22.881374,
								41.999297
							],
							[
								22.952377,
								41.337994
							],
							[
								22.76177,
								41.3048
							],
							[
								22.597308,
								41.130487
							],
							[
								22.055378,
								41.149866
							],
							[
								21.674161,
								40.931275
							],
							[
								21.02004,
								40.842727
							],
							[
								20.60518,
								41.08622
							],
							[
								20.46315,
								41.51509
							],
							[
								20.59023,
								41.85541
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MLI",
				"properties": {
					"name": "Mali"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-12.17075,
								14.616834
							],
							[
								-11.834208,
								14.799097
							],
							[
								-11.666078,
								15.388208
							],
							[
								-11.349095,
								15.411256
							],
							[
								-10.650791,
								15.132746
							],
							[
								-10.086846,
								15.330486
							],
							[
								-9.700255,
								15.264107
							],
							[
								-9.550238,
								15.486497
							],
							[
								-5.537744,
								15.50169
							],
							[
								-5.315277,
								16.201854
							],
							[
								-5.488523,
								16.325102
							],
							[
								-5.971129,
								20.640833
							],
							[
								-6.453787,
								24.956591
							],
							[
								-4.923337,
								24.974574
							],
							[
								-1.550055,
								22.792666
							],
							[
								1.823228,
								20.610809
							],
							[
								2.060991,
								20.142233
							],
							[
								2.683588,
								19.85623
							],
							[
								3.146661,
								19.693579
							],
							[
								3.158133,
								19.057364
							],
							[
								4.267419,
								19.155265
							],
							[
								4.27021,
								16.852227
							],
							[
								3.723422,
								16.184284
							],
							[
								3.638259,
								15.56812
							],
							[
								2.749993,
								15.409525
							],
							[
								1.385528,
								15.323561
							],
							[
								1.015783,
								14.968182
							],
							[
								0.374892,
								14.928908
							],
							[
								-0.266257,
								14.924309
							],
							[
								-0.515854,
								15.116158
							],
							[
								-1.066363,
								14.973815
							],
							[
								-2.001035,
								14.559008
							],
							[
								-2.191825,
								14.246418
							],
							[
								-2.967694,
								13.79815
							],
							[
								-3.103707,
								13.541267
							],
							[
								-3.522803,
								13.337662
							],
							[
								-4.006391,
								13.472485
							],
							[
								-4.280405,
								13.228444
							],
							[
								-4.427166,
								12.542646
							],
							[
								-5.220942,
								11.713859
							],
							[
								-5.197843,
								11.375146
							],
							[
								-5.470565,
								10.95127
							],
							[
								-5.404342,
								10.370737
							],
							[
								-5.816926,
								10.222555
							],
							[
								-6.050452,
								10.096361
							],
							[
								-6.205223,
								10.524061
							],
							[
								-6.493965,
								10.411303
							],
							[
								-6.666461,
								10.430811
							],
							[
								-6.850507,
								10.138994
							],
							[
								-7.622759,
								10.147236
							],
							[
								-7.89959,
								10.297382
							],
							[
								-8.029944,
								10.206535
							],
							[
								-8.335377,
								10.494812
							],
							[
								-8.282357,
								10.792597
							],
							[
								-8.407311,
								10.909257
							],
							[
								-8.620321,
								10.810891
							],
							[
								-8.581305,
								11.136246
							],
							[
								-8.376305,
								11.393646
							],
							[
								-8.786099,
								11.812561
							],
							[
								-8.905265,
								12.088358
							],
							[
								-9.127474,
								12.30806
							],
							[
								-9.327616,
								12.334286
							],
							[
								-9.567912,
								12.194243
							],
							[
								-9.890993,
								12.060479
							],
							[
								-10.165214,
								11.844084
							],
							[
								-10.593224,
								11.923975
							],
							[
								-10.87083,
								12.177887
							],
							[
								-11.036556,
								12.211245
							],
							[
								-11.297574,
								12.077971
							],
							[
								-11.456169,
								12.076834
							],
							[
								-11.513943,
								12.442988
							],
							[
								-11.467899,
								12.754519
							],
							[
								-11.553398,
								13.141214
							],
							[
								-11.927716,
								13.422075
							],
							[
								-12.124887,
								13.994727
							],
							[
								-12.17075,
								14.616834
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MLT",
				"properties": {
					"name": "Malta"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									14.566171,
									35.852721
								],
								[
									14.532684,
									35.820191
								],
								[
									14.436463,
									35.821664
								],
								[
									14.352334,
									35.872281
								],
								[
									14.3513,
									35.978399
								],
								[
									14.448348,
									35.957444
								],
								[
									14.537025,
									35.886285
								],
								[
									14.566171,
									35.852721
								]
							]
						],
						[
							[
								[
									14.313473,
									36.027569
								],
								[
									14.253632,
									36.012143
								],
								[
									14.194204,
									36.042245
								],
								[
									14.180354,
									36.060383
								],
								[
									14.263243,
									36.075809
								],
								[
									14.303758,
									36.062295
								],
								[
									14.320914,
									36.03625
								],
								[
									14.313473,
									36.027569
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MMR",
				"properties": {
					"name": "Myanmar"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								99.543309,
								20.186598
							],
							[
								98.959676,
								19.752981
							],
							[
								98.253724,
								19.708203
							],
							[
								97.797783,
								18.62708
							],
							[
								97.375896,
								18.445438
							],
							[
								97.859123,
								17.567946
							],
							[
								98.493761,
								16.837836
							],
							[
								98.903348,
								16.177824
							],
							[
								98.537376,
								15.308497
							],
							[
								98.192074,
								15.123703
							],
							[
								98.430819,
								14.622028
							],
							[
								99.097755,
								13.827503
							],
							[
								99.212012,
								13.269294
							],
							[
								99.196354,
								12.804748
							],
							[
								99.587286,
								11.892763
							],
							[
								99.038121,
								10.960546
							],
							[
								98.553551,
								9.93296
							],
							[
								98.457174,
								10.675266
							],
							[
								98.764546,
								11.441292
							],
							[
								98.428339,
								12.032987
							],
							[
								98.509574,
								13.122378
							],
							[
								98.103604,
								13.64046
							],
							[
								97.777732,
								14.837286
							],
							[
								97.597072,
								16.100568
							],
							[
								97.16454,
								16.928734
							],
							[
								96.505769,
								16.427241
							],
							[
								95.369352,
								15.71439
							],
							[
								94.808405,
								15.803454
							],
							[
								94.188804,
								16.037936
							],
							[
								94.533486,
								17.27724
							],
							[
								94.324817,
								18.213514
							],
							[
								93.540988,
								19.366493
							],
							[
								93.663255,
								19.726962
							],
							[
								93.078278,
								19.855145
							],
							[
								92.368554,
								20.670883
							],
							[
								92.303234,
								21.475485
							],
							[
								92.652257,
								21.324048
							],
							[
								92.672721,
								22.041239
							],
							[
								93.166128,
								22.27846
							],
							[
								93.060294,
								22.703111
							],
							[
								93.286327,
								23.043658
							],
							[
								93.325188,
								24.078556
							],
							[
								94.106742,
								23.850741
							],
							[
								94.552658,
								24.675238
							],
							[
								94.603249,
								25.162495
							],
							[
								95.155153,
								26.001307
							],
							[
								95.124768,
								26.573572
							],
							[
								96.419366,
								27.264589
							],
							[
								97.133999,
								27.083774
							],
							[
								97.051989,
								27.699059
							],
							[
								97.402561,
								27.882536
							],
							[
								97.327114,
								28.261583
							],
							[
								97.911988,
								28.335945
							],
							[
								98.246231,
								27.747221
							],
							[
								98.68269,
								27.508812
							],
							[
								98.712094,
								26.743536
							],
							[
								98.671838,
								25.918703
							],
							[
								97.724609,
								25.083637
							],
							[
								97.60472,
								23.897405
							],
							[
								98.660262,
								24.063286
							],
							[
								98.898749,
								23.142722
							],
							[
								99.531992,
								22.949039
							],
							[
								99.240899,
								22.118314
							],
							[
								99.983489,
								21.742937
							],
							[
								100.416538,
								21.558839
							],
							[
								101.150033,
								21.849984
							],
							[
								101.180005,
								21.436573
							],
							[
								100.329101,
								20.786122
							],
							[
								100.115988,
								20.41785
							],
							[
								99.543309,
								20.186598
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MNE",
				"properties": {
					"name": "Montenegro"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								19.801613,
								42.500093
							],
							[
								19.738051,
								42.688247
							],
							[
								19.30449,
								42.19574
							],
							[
								19.37177,
								41.87755
							],
							[
								19.16246,
								41.95502
							],
							[
								18.88214,
								42.28151
							],
							[
								18.45,
								42.48
							],
							[
								18.56,
								42.65
							],
							[
								18.70648,
								43.20011
							],
							[
								19.03165,
								43.43253
							],
							[
								19.21852,
								43.52384
							],
							[
								19.48389,
								43.35229
							],
							[
								19.63,
								43.21378
							],
							[
								19.95857,
								43.10604
							],
							[
								20.3398,
								42.89852
							],
							[
								20.25758,
								42.81275
							],
							[
								20.0707,
								42.58863
							],
							[
								19.801613,
								42.500093
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MNG",
				"properties": {
					"name": "Mongolia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								87.751264,
								49.297198
							],
							[
								88.805567,
								49.470521
							],
							[
								90.713667,
								50.331812
							],
							[
								92.234712,
								50.802171
							],
							[
								93.104219,
								50.49529
							],
							[
								94.147566,
								50.480537
							],
							[
								94.815949,
								50.013433
							],
							[
								95.814028,
								49.977467
							],
							[
								97.259728,
								49.726061
							],
							[
								98.231762,
								50.422401
							],
							[
								97.82574,
								51.010995
							],
							[
								98.861491,
								52.047366
							],
							[
								99.981732,
								51.634006
							],
							[
								100.88948,
								51.516856
							],
							[
								102.065223,
								51.259921
							],
							[
								102.255909,
								50.510561
							],
							[
								103.676545,
								50.089966
							],
							[
								104.621552,
								50.275329
							],
							[
								105.886591,
								50.406019
							],
							[
								106.888804,
								50.274296
							],
							[
								107.868176,
								49.793705
							],
							[
								108.475167,
								49.282548
							],
							[
								109.402449,
								49.292961
							],
							[
								110.662011,
								49.130128
							],
							[
								111.581231,
								49.377968
							],
							[
								112.89774,
								49.543565
							],
							[
								114.362456,
								50.248303
							],
							[
								114.96211,
								50.140247
							],
							[
								115.485695,
								49.805177
							],
							[
								116.678801,
								49.888531
							],
							[
								116.191802,
								49.134598
							],
							[
								115.485282,
								48.135383
							],
							[
								115.742837,
								47.726545
							],
							[
								116.308953,
								47.85341
							],
							[
								117.295507,
								47.697709
							],
							[
								118.064143,
								48.06673
							],
							[
								118.866574,
								47.74706
							],
							[
								119.772824,
								47.048059
							],
							[
								119.66327,
								46.69268
							],
							[
								118.874326,
								46.805412
							],
							[
								117.421701,
								46.672733
							],
							[
								116.717868,
								46.388202
							],
							[
								115.985096,
								45.727235
							],
							[
								114.460332,
								45.339817
							],
							[
								113.463907,
								44.808893
							],
							[
								112.436062,
								45.011646
							],
							[
								111.873306,
								45.102079
							],
							[
								111.348377,
								44.457442
							],
							[
								111.667737,
								44.073176
							],
							[
								111.829588,
								43.743118
							],
							[
								111.129682,
								43.406834
							],
							[
								110.412103,
								42.871234
							],
							[
								109.243596,
								42.519446
							],
							[
								107.744773,
								42.481516
							],
							[
								106.129316,
								42.134328
							],
							[
								104.964994,
								41.59741
							],
							[
								104.522282,
								41.908347
							],
							[
								103.312278,
								41.907468
							],
							[
								101.83304,
								42.514873
							],
							[
								100.845866,
								42.663804
							],
							[
								99.515817,
								42.524691
							],
							[
								97.451757,
								42.74889
							],
							[
								96.349396,
								42.725635
							],
							[
								95.762455,
								43.319449
							],
							[
								95.306875,
								44.241331
							],
							[
								94.688929,
								44.352332
							],
							[
								93.480734,
								44.975472
							],
							[
								92.133891,
								45.115076
							],
							[
								90.94554,
								45.286073
							],
							[
								90.585768,
								45.719716
							],
							[
								90.970809,
								46.888146
							],
							[
								90.280826,
								47.693549
							],
							[
								88.854298,
								48.069082
							],
							[
								88.013832,
								48.599463
							],
							[
								87.751264,
								49.297198
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MOZ",
				"properties": {
					"name": "Mozambique"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								34.559989,
								-11.52002
							],
							[
								35.312398,
								-11.439146
							],
							[
								36.514082,
								-11.720938
							],
							[
								36.775151,
								-11.594537
							],
							[
								37.471284,
								-11.568751
							],
							[
								37.827645,
								-11.268769
							],
							[
								38.427557,
								-11.285202
							],
							[
								39.52103,
								-10.896854
							],
							[
								40.316589,
								-10.317096
							],
							[
								40.478387,
								-10.765441
							],
							[
								40.437253,
								-11.761711
							],
							[
								40.560811,
								-12.639177
							],
							[
								40.59962,
								-14.201975
							],
							[
								40.775475,
								-14.691764
							],
							[
								40.477251,
								-15.406294
							],
							[
								40.089264,
								-16.100774
							],
							[
								39.452559,
								-16.720891
							],
							[
								38.538351,
								-17.101023
							],
							[
								37.411133,
								-17.586368
							],
							[
								36.281279,
								-18.659688
							],
							[
								35.896497,
								-18.84226
							],
							[
								35.1984,
								-19.552811
							],
							[
								34.786383,
								-19.784012
							],
							[
								34.701893,
								-20.497043
							],
							[
								35.176127,
								-21.254361
							],
							[
								35.373428,
								-21.840837
							],
							[
								35.385848,
								-22.14
							],
							[
								35.562546,
								-22.09
							],
							[
								35.533935,
								-23.070788
							],
							[
								35.371774,
								-23.535359
							],
							[
								35.60747,
								-23.706563
							],
							[
								35.458746,
								-24.12261
							],
							[
								35.040735,
								-24.478351
							],
							[
								34.215824,
								-24.816314
							],
							[
								33.01321,
								-25.357573
							],
							[
								32.574632,
								-25.727318
							],
							[
								32.660363,
								-26.148584
							],
							[
								32.915955,
								-26.215867
							],
							[
								32.83012,
								-26.742192
							],
							[
								32.071665,
								-26.73382
							],
							[
								31.985779,
								-26.29178
							],
							[
								31.837778,
								-25.843332
							],
							[
								31.752408,
								-25.484284
							],
							[
								31.930589,
								-24.369417
							],
							[
								31.670398,
								-23.658969
							],
							[
								31.191409,
								-22.25151
							],
							[
								32.244988,
								-21.116489
							],
							[
								32.508693,
								-20.395292
							],
							[
								32.659743,
								-20.30429
							],
							[
								32.772708,
								-19.715592
							],
							[
								32.611994,
								-19.419383
							],
							[
								32.654886,
								-18.67209
							],
							[
								32.849861,
								-17.979057
							],
							[
								32.847639,
								-16.713398
							],
							[
								32.328239,
								-16.392074
							],
							[
								31.852041,
								-16.319417
							],
							[
								31.636498,
								-16.07199
							],
							[
								31.173064,
								-15.860944
							],
							[
								30.338955,
								-15.880839
							],
							[
								30.274256,
								-15.507787
							],
							[
								30.179481,
								-14.796099
							],
							[
								33.214025,
								-13.97186
							],
							[
								33.7897,
								-14.451831
							],
							[
								34.064825,
								-14.35995
							],
							[
								34.459633,
								-14.61301
							],
							[
								34.517666,
								-15.013709
							],
							[
								34.307291,
								-15.478641
							],
							[
								34.381292,
								-16.18356
							],
							[
								35.03381,
								-16.8013
							],
							[
								35.339063,
								-16.10744
							],
							[
								35.771905,
								-15.896859
							],
							[
								35.686845,
								-14.611046
							],
							[
								35.267956,
								-13.887834
							],
							[
								34.907151,
								-13.565425
							],
							[
								34.559989,
								-13.579998
							],
							[
								34.280006,
								-12.280025
							],
							[
								34.559989,
								-11.52002
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MRT",
				"properties": {
					"name": "Mauritania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-12.17075,
								14.616834
							],
							[
								-12.830658,
								15.303692
							],
							[
								-13.435738,
								16.039383
							],
							[
								-14.099521,
								16.304302
							],
							[
								-14.577348,
								16.598264
							],
							[
								-15.135737,
								16.587282
							],
							[
								-15.623666,
								16.369337
							],
							[
								-16.12069,
								16.455663
							],
							[
								-16.463098,
								16.135036
							],
							[
								-16.549708,
								16.673892
							],
							[
								-16.270552,
								17.166963
							],
							[
								-16.146347,
								18.108482
							],
							[
								-16.256883,
								19.096716
							],
							[
								-16.377651,
								19.593817
							],
							[
								-16.277838,
								20.092521
							],
							[
								-16.536324,
								20.567866
							],
							[
								-17.063423,
								20.999752
							],
							[
								-16.845194,
								21.333323
							],
							[
								-12.929102,
								21.327071
							],
							[
								-13.118754,
								22.77122
							],
							[
								-12.874222,
								23.284832
							],
							[
								-11.937224,
								23.374594
							],
							[
								-11.969419,
								25.933353
							],
							[
								-8.687294,
								25.881056
							],
							[
								-8.6844,
								27.395744
							],
							[
								-4.923337,
								24.974574
							],
							[
								-6.453787,
								24.956591
							],
							[
								-5.971129,
								20.640833
							],
							[
								-5.488523,
								16.325102
							],
							[
								-5.315277,
								16.201854
							],
							[
								-5.537744,
								15.50169
							],
							[
								-9.550238,
								15.486497
							],
							[
								-9.700255,
								15.264107
							],
							[
								-10.086846,
								15.330486
							],
							[
								-10.650791,
								15.132746
							],
							[
								-11.349095,
								15.411256
							],
							[
								-11.666078,
								15.388208
							],
							[
								-11.834208,
								14.799097
							],
							[
								-12.17075,
								14.616834
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MWI",
				"properties": {
					"name": "Malawi"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								34.559989,
								-11.52002
							],
							[
								34.280006,
								-12.280025
							],
							[
								34.559989,
								-13.579998
							],
							[
								34.907151,
								-13.565425
							],
							[
								35.267956,
								-13.887834
							],
							[
								35.686845,
								-14.611046
							],
							[
								35.771905,
								-15.896859
							],
							[
								35.339063,
								-16.10744
							],
							[
								35.03381,
								-16.8013
							],
							[
								34.381292,
								-16.18356
							],
							[
								34.307291,
								-15.478641
							],
							[
								34.517666,
								-15.013709
							],
							[
								34.459633,
								-14.61301
							],
							[
								34.064825,
								-14.35995
							],
							[
								33.7897,
								-14.451831
							],
							[
								33.214025,
								-13.97186
							],
							[
								32.688165,
								-13.712858
							],
							[
								32.991764,
								-12.783871
							],
							[
								33.306422,
								-12.435778
							],
							[
								33.114289,
								-11.607198
							],
							[
								33.31531,
								-10.79655
							],
							[
								33.485688,
								-10.525559
							],
							[
								33.231388,
								-9.676722
							],
							[
								32.759375,
								-9.230599
							],
							[
								33.739729,
								-9.417151
							],
							[
								33.940838,
								-9.693674
							],
							[
								34.280006,
								-10.16
							],
							[
								34.559989,
								-11.52002
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "MYS",
				"properties": {
					"name": "Malaysia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									101.075516,
									6.204867
								],
								[
									101.154219,
									5.691384
								],
								[
									101.814282,
									5.810808
								],
								[
									102.141187,
									6.221636
								],
								[
									102.371147,
									6.128205
								],
								[
									102.961705,
									5.524495
								],
								[
									103.381215,
									4.855001
								],
								[
									103.438575,
									4.181606
								],
								[
									103.332122,
									3.726698
								],
								[
									103.429429,
									3.382869
								],
								[
									103.502448,
									2.791019
								],
								[
									103.854674,
									2.515454
								],
								[
									104.247932,
									1.631141
								],
								[
									104.228811,
									1.293048
								],
								[
									103.519707,
									1.226334
								],
								[
									102.573615,
									1.967115
								],
								[
									101.390638,
									2.760814
								],
								[
									101.27354,
									3.270292
								],
								[
									100.695435,
									3.93914
								],
								[
									100.557408,
									4.76728
								],
								[
									100.196706,
									5.312493
								],
								[
									100.30626,
									6.040562
								],
								[
									100.085757,
									6.464489
								],
								[
									100.259596,
									6.642825
								],
								[
									101.075516,
									6.204867
								]
							]
						],
						[
							[
								[
									118.618321,
									4.478202
								],
								[
									117.882035,
									4.137551
								],
								[
									117.015214,
									4.306094
								],
								[
									115.865517,
									4.306559
								],
								[
									115.519078,
									3.169238
								],
								[
									115.134037,
									2.821482
								],
								[
									114.621355,
									1.430688
								],
								[
									113.80585,
									1.217549
								],
								[
									112.859809,
									1.49779
								],
								[
									112.380252,
									1.410121
								],
								[
									111.797548,
									0.904441
								],
								[
									111.159138,
									0.976478
								],
								[
									110.514061,
									0.773131
								],
								[
									109.830227,
									1.338136
								],
								[
									109.66326,
									2.006467
								],
								[
									110.396135,
									1.663775
								],
								[
									111.168853,
									1.850637
								],
								[
									111.370081,
									2.697303
								],
								[
									111.796928,
									2.885897
								],
								[
									112.995615,
									3.102395
								],
								[
									113.712935,
									3.893509
								],
								[
									114.204017,
									4.525874
								],
								[
									114.659596,
									4.007637
								],
								[
									114.869557,
									4.348314
								],
								[
									115.347461,
									4.316636
								],
								[
									115.4057,
									4.955228
								],
								[
									115.45071,
									5.44773
								],
								[
									116.220741,
									6.143191
								],
								[
									116.725103,
									6.924771
								],
								[
									117.129626,
									6.928053
								],
								[
									117.643393,
									6.422166
								],
								[
									117.689075,
									5.98749
								],
								[
									118.347691,
									5.708696
								],
								[
									119.181904,
									5.407836
								],
								[
									119.110694,
									5.016128
								],
								[
									118.439727,
									4.966519
								],
								[
									118.618321,
									4.478202
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NAM",
				"properties": {
					"name": "Namibia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								16.344977,
								-28.576705
							],
							[
								15.601818,
								-27.821247
							],
							[
								15.210472,
								-27.090956
							],
							[
								14.989711,
								-26.117372
							],
							[
								14.743214,
								-25.39292
							],
							[
								14.408144,
								-23.853014
							],
							[
								14.385717,
								-22.656653
							],
							[
								14.257714,
								-22.111208
							],
							[
								13.868642,
								-21.699037
							],
							[
								13.352498,
								-20.872834
							],
							[
								12.826845,
								-19.673166
							],
							[
								12.608564,
								-19.045349
							],
							[
								11.794919,
								-18.069129
							],
							[
								11.734199,
								-17.301889
							],
							[
								12.215461,
								-17.111668
							],
							[
								12.814081,
								-16.941343
							],
							[
								13.462362,
								-16.971212
							],
							[
								14.058501,
								-17.423381
							],
							[
								14.209707,
								-17.353101
							],
							[
								18.263309,
								-17.309951
							],
							[
								18.956187,
								-17.789095
							],
							[
								21.377176,
								-17.930636
							],
							[
								23.215048,
								-17.523116
							],
							[
								24.033862,
								-17.295843
							],
							[
								24.682349,
								-17.353411
							],
							[
								25.07695,
								-17.578823
							],
							[
								25.084443,
								-17.661816
							],
							[
								24.520705,
								-17.887125
							],
							[
								24.217365,
								-17.889347
							],
							[
								23.579006,
								-18.281261
							],
							[
								23.196858,
								-17.869038
							],
							[
								21.65504,
								-18.219146
							],
							[
								20.910641,
								-18.252219
							],
							[
								20.881134,
								-21.814327
							],
							[
								19.895458,
								-21.849157
							],
							[
								19.895768,
								-24.76779
							],
							[
								19.894734,
								-28.461105
							],
							[
								19.002127,
								-28.972443
							],
							[
								18.464899,
								-29.045462
							],
							[
								17.836152,
								-28.856378
							],
							[
								17.387497,
								-28.783514
							],
							[
								17.218929,
								-28.355943
							],
							[
								16.824017,
								-28.082162
							],
							[
								16.344977,
								-28.576705
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NCL",
				"properties": {
					"name": "New Caledonia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								165.77999,
								-21.080005
							],
							[
								166.599991,
								-21.700019
							],
							[
								167.120011,
								-22.159991
							],
							[
								166.740035,
								-22.399976
							],
							[
								166.189732,
								-22.129708
							],
							[
								165.474375,
								-21.679607
							],
							[
								164.829815,
								-21.14982
							],
							[
								164.167995,
								-20.444747
							],
							[
								164.029606,
								-20.105646
							],
							[
								164.459967,
								-20.120012
							],
							[
								165.020036,
								-20.459991
							],
							[
								165.460009,
								-20.800022
							],
							[
								165.77999,
								-21.080005
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NER",
				"properties": {
					"name": "Niger"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								2.154474,
								11.94015
							],
							[
								2.177108,
								12.625018
							],
							[
								1.024103,
								12.851826
							],
							[
								0.993046,
								13.33575
							],
							[
								0.429928,
								13.988733
							],
							[
								0.295646,
								14.444235
							],
							[
								0.374892,
								14.928908
							],
							[
								1.015783,
								14.968182
							],
							[
								1.385528,
								15.323561
							],
							[
								2.749993,
								15.409525
							],
							[
								3.638259,
								15.56812
							],
							[
								3.723422,
								16.184284
							],
							[
								4.27021,
								16.852227
							],
							[
								4.267419,
								19.155265
							],
							[
								5.677566,
								19.601207
							],
							[
								8.572893,
								21.565661
							],
							[
								11.999506,
								23.471668
							],
							[
								13.581425,
								23.040506
							],
							[
								14.143871,
								22.491289
							],
							[
								14.8513,
								22.86295
							],
							[
								15.096888,
								21.308519
							],
							[
								15.471077,
								21.048457
							],
							[
								15.487148,
								20.730415
							],
							[
								15.903247,
								20.387619
							],
							[
								15.685741,
								19.95718
							],
							[
								15.300441,
								17.92795
							],
							[
								15.247731,
								16.627306
							],
							[
								13.972202,
								15.684366
							],
							[
								13.540394,
								14.367134
							],
							[
								13.956699,
								13.996691
							],
							[
								13.954477,
								13.353449
							],
							[
								14.595781,
								13.330427
							],
							[
								14.495787,
								12.859396
							],
							[
								14.213531,
								12.802035
							],
							[
								14.181336,
								12.483657
							],
							[
								13.995353,
								12.461565
							],
							[
								13.318702,
								13.556356
							],
							[
								13.083987,
								13.596147
							],
							[
								12.302071,
								13.037189
							],
							[
								11.527803,
								13.32898
							],
							[
								10.989593,
								13.387323
							],
							[
								10.701032,
								13.246918
							],
							[
								10.114814,
								13.277252
							],
							[
								9.524928,
								12.851102
							],
							[
								9.014933,
								12.826659
							],
							[
								7.804671,
								13.343527
							],
							[
								7.330747,
								13.098038
							],
							[
								6.820442,
								13.115091
							],
							[
								6.445426,
								13.492768
							],
							[
								5.443058,
								13.865924
							],
							[
								4.368344,
								13.747482
							],
							[
								4.107946,
								13.531216
							],
							[
								3.967283,
								12.956109
							],
							[
								3.680634,
								12.552903
							],
							[
								3.61118,
								11.660167
							],
							[
								2.848643,
								12.235636
							],
							[
								2.490164,
								12.233052
							],
							[
								2.154474,
								11.94015
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NGA",
				"properties": {
					"name": "Nigeria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								8.500288,
								4.771983
							],
							[
								7.462108,
								4.412108
							],
							[
								7.082596,
								4.464689
							],
							[
								6.698072,
								4.240594
							],
							[
								5.898173,
								4.262453
							],
							[
								5.362805,
								4.887971
							],
							[
								5.033574,
								5.611802
							],
							[
								4.325607,
								6.270651
							],
							[
								3.57418,
								6.2583
							],
							[
								2.691702,
								6.258817
							],
							[
								2.749063,
								7.870734
							],
							[
								2.723793,
								8.506845
							],
							[
								2.912308,
								9.137608
							],
							[
								3.220352,
								9.444153
							],
							[
								3.705438,
								10.06321
							],
							[
								3.60007,
								10.332186
							],
							[
								3.797112,
								10.734746
							],
							[
								3.572216,
								11.327939
							],
							[
								3.61118,
								11.660167
							],
							[
								3.680634,
								12.552903
							],
							[
								3.967283,
								12.956109
							],
							[
								4.107946,
								13.531216
							],
							[
								4.368344,
								13.747482
							],
							[
								5.443058,
								13.865924
							],
							[
								6.445426,
								13.492768
							],
							[
								6.820442,
								13.115091
							],
							[
								7.330747,
								13.098038
							],
							[
								7.804671,
								13.343527
							],
							[
								9.014933,
								12.826659
							],
							[
								9.524928,
								12.851102
							],
							[
								10.114814,
								13.277252
							],
							[
								10.701032,
								13.246918
							],
							[
								10.989593,
								13.387323
							],
							[
								11.527803,
								13.32898
							],
							[
								12.302071,
								13.037189
							],
							[
								13.083987,
								13.596147
							],
							[
								13.318702,
								13.556356
							],
							[
								13.995353,
								12.461565
							],
							[
								14.181336,
								12.483657
							],
							[
								14.577178,
								12.085361
							],
							[
								14.468192,
								11.904752
							],
							[
								14.415379,
								11.572369
							],
							[
								13.57295,
								10.798566
							],
							[
								13.308676,
								10.160362
							],
							[
								13.1676,
								9.640626
							],
							[
								12.955468,
								9.417772
							],
							[
								12.753672,
								8.717763
							],
							[
								12.218872,
								8.305824
							],
							[
								12.063946,
								7.799808
							],
							[
								11.839309,
								7.397042
							],
							[
								11.745774,
								6.981383
							],
							[
								11.058788,
								6.644427
							],
							[
								10.497375,
								7.055358
							],
							[
								10.118277,
								7.03877
							],
							[
								9.522706,
								6.453482
							],
							[
								9.233163,
								6.444491
							],
							[
								8.757533,
								5.479666
							],
							[
								8.500288,
								4.771983
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NIC",
				"properties": {
					"name": "Nicaragua"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-85.71254,
								11.088445
							],
							[
								-86.058488,
								11.403439
							],
							[
								-86.52585,
								11.806877
							],
							[
								-86.745992,
								12.143962
							],
							[
								-87.167516,
								12.458258
							],
							[
								-87.668493,
								12.90991
							],
							[
								-87.557467,
								13.064552
							],
							[
								-87.392386,
								12.914018
							],
							[
								-87.316654,
								12.984686
							],
							[
								-87.005769,
								13.025794
							],
							[
								-86.880557,
								13.254204
							],
							[
								-86.733822,
								13.263093
							],
							[
								-86.755087,
								13.754845
							],
							[
								-86.520708,
								13.778487
							],
							[
								-86.312142,
								13.771356
							],
							[
								-86.096264,
								14.038187
							],
							[
								-85.801295,
								13.836055
							],
							[
								-85.698665,
								13.960078
							],
							[
								-85.514413,
								14.079012
							],
							[
								-85.165365,
								14.35437
							],
							[
								-85.148751,
								14.560197
							],
							[
								-85.052787,
								14.551541
							],
							[
								-84.924501,
								14.790493
							],
							[
								-84.820037,
								14.819587
							],
							[
								-84.649582,
								14.666805
							],
							[
								-84.449336,
								14.621614
							],
							[
								-84.228342,
								14.748764
							],
							[
								-83.975721,
								14.749436
							],
							[
								-83.628585,
								14.880074
							],
							[
								-83.489989,
								15.016267
							],
							[
								-83.147219,
								14.995829
							],
							[
								-83.233234,
								14.899866
							],
							[
								-83.284162,
								14.676624
							],
							[
								-83.182126,
								14.310703
							],
							[
								-83.4125,
								13.970078
							],
							[
								-83.519832,
								13.567699
							],
							[
								-83.552207,
								13.127054
							],
							[
								-83.498515,
								12.869292
							],
							[
								-83.473323,
								12.419087
							],
							[
								-83.626104,
								12.32085
							],
							[
								-83.719613,
								11.893124
							],
							[
								-83.650858,
								11.629032
							],
							[
								-83.85547,
								11.373311
							],
							[
								-83.808936,
								11.103044
							],
							[
								-83.655612,
								10.938764
							],
							[
								-83.895054,
								10.726839
							],
							[
								-84.190179,
								10.79345
							],
							[
								-84.355931,
								10.999226
							],
							[
								-84.673069,
								11.082657
							],
							[
								-84.903003,
								10.952303
							],
							[
								-85.561852,
								11.217119
							],
							[
								-85.71254,
								11.088445
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NLD",
				"properties": {
					"name": "Netherlands"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								6.074183,
								53.510403
							],
							[
								6.90514,
								53.482162
							],
							[
								7.092053,
								53.144043
							],
							[
								6.84287,
								52.22844
							],
							[
								6.589397,
								51.852029
							],
							[
								5.988658,
								51.851616
							],
							[
								6.156658,
								50.803721
							],
							[
								5.606976,
								51.037298
							],
							[
								4.973991,
								51.475024
							],
							[
								4.047071,
								51.267259
							],
							[
								3.314971,
								51.345755
							],
							[
								3.830289,
								51.620545
							],
							[
								4.705997,
								53.091798
							],
							[
								6.074183,
								53.510403
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NOR",
				"properties": {
					"name": "Norway"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									28.165547,
									71.185474
								],
								[
									31.293418,
									70.453788
								],
								[
									30.005435,
									70.186259
								],
								[
									31.101079,
									69.55808
								],
								[
									29.399581,
									69.156916
								],
								[
									28.59193,
									69.064777
								],
								[
									29.015573,
									69.766491
								],
								[
									27.732292,
									70.164193
								],
								[
									26.179622,
									69.825299
								],
								[
									25.689213,
									69.092114
								],
								[
									24.735679,
									68.649557
								],
								[
									23.66205,
									68.891247
								],
								[
									22.356238,
									68.841741
								],
								[
									21.244936,
									69.370443
								],
								[
									20.645593,
									69.106247
								],
								[
									20.025269,
									69.065139
								],
								[
									19.87856,
									68.407194
								],
								[
									17.993868,
									68.567391
								],
								[
									17.729182,
									68.010552
								],
								[
									16.768879,
									68.013937
								],
								[
									16.108712,
									67.302456
								],
								[
									15.108411,
									66.193867
								],
								[
									13.55569,
									64.787028
								],
								[
									13.919905,
									64.445421
								],
								[
									13.571916,
									64.049114
								],
								[
									12.579935,
									64.066219
								],
								[
									11.930569,
									63.128318
								],
								[
									11.992064,
									61.800362
								],
								[
									12.631147,
									61.293572
								],
								[
									12.300366,
									60.117933
								],
								[
									11.468272,
									59.432393
								],
								[
									11.027369,
									58.856149
								],
								[
									10.356557,
									59.469807
								],
								[
									8.382,
									58.313288
								],
								[
									7.048748,
									58.078884
								],
								[
									5.665835,
									58.588155
								],
								[
									5.308234,
									59.663232
								],
								[
									4.992078,
									61.970998
								],
								[
									5.9129,
									62.614473
								],
								[
									8.553411,
									63.454008
								],
								[
									10.527709,
									64.486038
								],
								[
									12.358347,
									65.879726
								],
								[
									14.761146,
									67.810642
								],
								[
									16.435927,
									68.563205
								],
								[
									19.184028,
									69.817444
								],
								[
									21.378416,
									70.255169
								],
								[
									23.023742,
									70.202072
								],
								[
									24.546543,
									71.030497
								],
								[
									26.37005,
									70.986262
								],
								[
									28.165547,
									71.185474
								]
							]
						],
						[
							[
								[
									24.72412,
									77.85385
								],
								[
									22.49032,
									77.44493
								],
								[
									20.72601,
									77.67704
								],
								[
									21.41611,
									77.93504
								],
								[
									20.8119,
									78.25463
								],
								[
									22.88426,
									78.45494
								],
								[
									23.28134,
									78.07954
								],
								[
									24.72412,
									77.85385
								]
							]
						],
						[
							[
								[
									18.25183,
									79.70175
								],
								[
									21.54383,
									78.95611
								],
								[
									19.02737,
									78.5626
								],
								[
									18.47172,
									77.82669
								],
								[
									17.59441,
									77.63796
								],
								[
									17.1182,
									76.80941
								],
								[
									15.91315,
									76.77045
								],
								[
									13.76259,
									77.38035
								],
								[
									14.66956,
									77.73565
								],
								[
									13.1706,
									78.02493
								],
								[
									11.22231,
									78.8693
								],
								[
									10.44453,
									79.65239
								],
								[
									13.17077,
									80.01046
								],
								[
									13.71852,
									79.66039
								],
								[
									15.14282,
									79.67431
								],
								[
									15.52255,
									80.01608
								],
								[
									16.99085,
									80.05086
								],
								[
									18.25183,
									79.70175
								]
							]
						],
						[
							[
								[
									25.447625,
									80.40734
								],
								[
									27.407506,
									80.056406
								],
								[
									25.924651,
									79.517834
								],
								[
									23.024466,
									79.400012
								],
								[
									20.075188,
									79.566823
								],
								[
									19.897266,
									79.842362
								],
								[
									18.462264,
									79.85988
								],
								[
									17.368015,
									80.318896
								],
								[
									20.455992,
									80.598156
								],
								[
									21.907945,
									80.357679
								],
								[
									22.919253,
									80.657144
								],
								[
									25.447625,
									80.40734
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NPL",
				"properties": {
					"name": "Nepal"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								88.120441,
								27.876542
							],
							[
								88.043133,
								27.445819
							],
							[
								88.174804,
								26.810405
							],
							[
								88.060238,
								26.414615
							],
							[
								87.227472,
								26.397898
							],
							[
								86.024393,
								26.630985
							],
							[
								85.251779,
								26.726198
							],
							[
								84.675018,
								27.234901
							],
							[
								83.304249,
								27.364506
							],
							[
								81.999987,
								27.925479
							],
							[
								81.057203,
								28.416095
							],
							[
								80.088425,
								28.79447
							],
							[
								80.476721,
								29.729865
							],
							[
								81.111256,
								30.183481
							],
							[
								81.525804,
								30.422717
							],
							[
								82.327513,
								30.115268
							],
							[
								83.337115,
								29.463732
							],
							[
								83.898993,
								29.320226
							],
							[
								84.23458,
								28.839894
							],
							[
								85.011638,
								28.642774
							],
							[
								85.82332,
								28.203576
							],
							[
								86.954517,
								27.974262
							],
							[
								88.120441,
								27.876542
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "NZL",
				"properties": {
					"name": "New Zealand"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									173.020375,
									-40.919052
								],
								[
									173.247234,
									-41.331999
								],
								[
									173.958405,
									-40.926701
								],
								[
									174.247587,
									-41.349155
								],
								[
									174.248517,
									-41.770008
								],
								[
									173.876447,
									-42.233184
								],
								[
									173.22274,
									-42.970038
								],
								[
									172.711246,
									-43.372288
								],
								[
									173.080113,
									-43.853344
								],
								[
									172.308584,
									-43.865694
								],
								[
									171.452925,
									-44.242519
								],
								[
									171.185138,
									-44.897104
								],
								[
									170.616697,
									-45.908929
								],
								[
									169.831422,
									-46.355775
								],
								[
									169.332331,
									-46.641235
								],
								[
									168.411354,
									-46.619945
								],
								[
									167.763745,
									-46.290197
								],
								[
									166.676886,
									-46.219917
								],
								[
									166.509144,
									-45.852705
								],
								[
									167.046424,
									-45.110941
								],
								[
									168.303763,
									-44.123973
								],
								[
									168.949409,
									-43.935819
								],
								[
									169.667815,
									-43.555326
								],
								[
									170.52492,
									-43.031688
								],
								[
									171.12509,
									-42.512754
								],
								[
									171.569714,
									-41.767424
								],
								[
									171.948709,
									-41.514417
								],
								[
									172.097227,
									-40.956104
								],
								[
									172.79858,
									-40.493962
								],
								[
									173.020375,
									-40.919052
								]
							]
						],
						[
							[
								[
									174.612009,
									-36.156397
								],
								[
									175.336616,
									-37.209098
								],
								[
									175.357596,
									-36.526194
								],
								[
									175.808887,
									-36.798942
								],
								[
									175.95849,
									-37.555382
								],
								[
									176.763195,
									-37.881253
								],
								[
									177.438813,
									-37.961248
								],
								[
									178.010354,
									-37.579825
								],
								[
									178.517094,
									-37.695373
								],
								[
									178.274731,
									-38.582813
								],
								[
									177.97046,
									-39.166343
								],
								[
									177.206993,
									-39.145776
								],
								[
									176.939981,
									-39.449736
								],
								[
									177.032946,
									-39.879943
								],
								[
									176.885824,
									-40.065978
								],
								[
									176.508017,
									-40.604808
								],
								[
									176.01244,
									-41.289624
								],
								[
									175.239567,
									-41.688308
								],
								[
									175.067898,
									-41.425895
								],
								[
									174.650973,
									-41.281821
								],
								[
									175.22763,
									-40.459236
								],
								[
									174.900157,
									-39.908933
								],
								[
									173.824047,
									-39.508854
								],
								[
									173.852262,
									-39.146602
								],
								[
									174.574802,
									-38.797683
								],
								[
									174.743474,
									-38.027808
								],
								[
									174.697017,
									-37.381129
								],
								[
									174.292028,
									-36.711092
								],
								[
									174.319004,
									-36.534824
								],
								[
									173.840997,
									-36.121981
								],
								[
									173.054171,
									-35.237125
								],
								[
									172.636005,
									-34.529107
								],
								[
									173.007042,
									-34.450662
								],
								[
									173.551298,
									-35.006183
								],
								[
									174.32939,
									-35.265496
								],
								[
									174.612009,
									-36.156397
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "OMN",
				"properties": {
					"name": "Oman"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									58.861141,
									21.114035
								],
								[
									58.487986,
									20.428986
								],
								[
									58.034318,
									20.481437
								],
								[
									57.826373,
									20.243002
								],
								[
									57.665762,
									19.736005
								],
								[
									57.7887,
									19.06757
								],
								[
									57.694391,
									18.94471
								],
								[
									57.234264,
									18.947991
								],
								[
									56.609651,
									18.574267
								],
								[
									56.512189,
									18.087113
								],
								[
									56.283521,
									17.876067
								],
								[
									55.661492,
									17.884128
								],
								[
									55.269939,
									17.632309
								],
								[
									55.2749,
									17.228354
								],
								[
									54.791002,
									16.950697
								],
								[
									54.239253,
									17.044981
								],
								[
									53.570508,
									16.707663
								],
								[
									53.108573,
									16.651051
								],
								[
									52.782184,
									17.349742
								],
								[
									52.00001,
									19.000003
								],
								[
									54.999982,
									19.999994
								],
								[
									55.666659,
									22.000001
								],
								[
									55.208341,
									22.70833
								],
								[
									55.234489,
									23.110993
								],
								[
									55.525841,
									23.524869
								],
								[
									55.528632,
									23.933604
								],
								[
									55.981214,
									24.130543
								],
								[
									55.804119,
									24.269604
								],
								[
									55.886233,
									24.920831
								],
								[
									56.396847,
									24.924732
								],
								[
									56.84514,
									24.241673
								],
								[
									57.403453,
									23.878594
								],
								[
									58.136948,
									23.747931
								],
								[
									58.729211,
									23.565668
								],
								[
									59.180502,
									22.992395
								],
								[
									59.450098,
									22.660271
								],
								[
									59.80806,
									22.533612
								],
								[
									59.806148,
									22.310525
								],
								[
									59.442191,
									21.714541
								],
								[
									59.282408,
									21.433886
								],
								[
									58.861141,
									21.114035
								]
							]
						],
						[
							[
								[
									56.391421,
									25.895991
								],
								[
									56.261042,
									25.714606
								],
								[
									56.070821,
									26.055464
								],
								[
									56.362017,
									26.395934
								],
								[
									56.485679,
									26.309118
								],
								[
									56.391421,
									25.895991
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PAK",
				"properties": {
					"name": "Pakistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								75.158028,
								37.133031
							],
							[
								75.896897,
								36.666806
							],
							[
								76.192848,
								35.898403
							],
							[
								77.837451,
								35.49401
							],
							[
								76.871722,
								34.653544
							],
							[
								75.757061,
								34.504923
							],
							[
								74.240203,
								34.748887
							],
							[
								73.749948,
								34.317699
							],
							[
								74.104294,
								33.441473
							],
							[
								74.451559,
								32.7649
							],
							[
								75.258642,
								32.271105
							],
							[
								74.405929,
								31.692639
							],
							[
								74.42138,
								30.979815
							],
							[
								73.450638,
								29.976413
							],
							[
								72.823752,
								28.961592
							],
							[
								71.777666,
								27.91318
							],
							[
								70.616496,
								27.989196
							],
							[
								69.514393,
								26.940966
							],
							[
								70.168927,
								26.491872
							],
							[
								70.282873,
								25.722229
							],
							[
								70.844699,
								25.215102
							],
							[
								71.04324,
								24.356524
							],
							[
								68.842599,
								24.359134
							],
							[
								68.176645,
								23.691965
							],
							[
								67.443667,
								23.944844
							],
							[
								67.145442,
								24.663611
							],
							[
								66.372828,
								25.425141
							],
							[
								64.530408,
								25.237039
							],
							[
								62.905701,
								25.218409
							],
							[
								61.497363,
								25.078237
							],
							[
								61.874187,
								26.239975
							],
							[
								63.316632,
								26.756532
							],
							[
								63.233898,
								27.217047
							],
							[
								62.755426,
								27.378923
							],
							[
								62.72783,
								28.259645
							],
							[
								61.771868,
								28.699334
							],
							[
								61.369309,
								29.303276
							],
							[
								60.874248,
								29.829239
							],
							[
								62.549857,
								29.318572
							],
							[
								63.550261,
								29.468331
							],
							[
								64.148002,
								29.340819
							],
							[
								64.350419,
								29.560031
							],
							[
								65.046862,
								29.472181
							],
							[
								66.346473,
								29.887943
							],
							[
								66.381458,
								30.738899
							],
							[
								66.938891,
								31.304911
							],
							[
								67.683394,
								31.303154
							],
							[
								67.792689,
								31.58293
							],
							[
								68.556932,
								31.71331
							],
							[
								68.926677,
								31.620189
							],
							[
								69.317764,
								31.901412
							],
							[
								69.262522,
								32.501944
							],
							[
								69.687147,
								33.105499
							],
							[
								70.323594,
								33.358533
							],
							[
								69.930543,
								34.02012
							],
							[
								70.881803,
								33.988856
							],
							[
								71.156773,
								34.348911
							],
							[
								71.115019,
								34.733126
							],
							[
								71.613076,
								35.153203
							],
							[
								71.498768,
								35.650563
							],
							[
								71.262348,
								36.074388
							],
							[
								71.846292,
								36.509942
							],
							[
								72.920025,
								36.720007
							],
							[
								74.067552,
								36.836176
							],
							[
								74.575893,
								37.020841
							],
							[
								75.158028,
								37.133031
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PAN",
				"properties": {
					"name": "Panama"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-77.881571,
								7.223771
							],
							[
								-78.214936,
								7.512255
							],
							[
								-78.429161,
								8.052041
							],
							[
								-78.182096,
								8.319182
							],
							[
								-78.435465,
								8.387705
							],
							[
								-78.622121,
								8.718124
							],
							[
								-79.120307,
								8.996092
							],
							[
								-79.557877,
								8.932375
							],
							[
								-79.760578,
								8.584515
							],
							[
								-80.164481,
								8.333316
							],
							[
								-80.382659,
								8.298409
							],
							[
								-80.480689,
								8.090308
							],
							[
								-80.00369,
								7.547524
							],
							[
								-80.276671,
								7.419754
							],
							[
								-80.421158,
								7.271572
							],
							[
								-80.886401,
								7.220541
							],
							[
								-81.059543,
								7.817921
							],
							[
								-81.189716,
								7.647906
							],
							[
								-81.519515,
								7.70661
							],
							[
								-81.721311,
								8.108963
							],
							[
								-82.131441,
								8.175393
							],
							[
								-82.390934,
								8.292362
							],
							[
								-82.820081,
								8.290864
							],
							[
								-82.850958,
								8.073823
							],
							[
								-82.965783,
								8.225028
							],
							[
								-82.913176,
								8.423517
							],
							[
								-82.829771,
								8.626295
							],
							[
								-82.868657,
								8.807266
							],
							[
								-82.719183,
								8.925709
							],
							[
								-82.927155,
								9.07433
							],
							[
								-82.932891,
								9.476812
							],
							[
								-82.546196,
								9.566135
							],
							[
								-82.187123,
								9.207449
							],
							[
								-82.207586,
								8.995575
							],
							[
								-81.808567,
								8.950617
							],
							[
								-81.714154,
								9.031955
							],
							[
								-81.439287,
								8.786234
							],
							[
								-80.947302,
								8.858504
							],
							[
								-80.521901,
								9.111072
							],
							[
								-79.9146,
								9.312765
							],
							[
								-79.573303,
								9.61161
							],
							[
								-79.021192,
								9.552931
							],
							[
								-79.05845,
								9.454565
							],
							[
								-78.500888,
								9.420459
							],
							[
								-78.055928,
								9.24773
							],
							[
								-77.729514,
								8.946844
							],
							[
								-77.353361,
								8.670505
							],
							[
								-77.474723,
								8.524286
							],
							[
								-77.242566,
								7.935278
							],
							[
								-77.431108,
								7.638061
							],
							[
								-77.753414,
								7.70984
							],
							[
								-77.881571,
								7.223771
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PER",
				"properties": {
					"name": "Peru"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-69.590424,
								-17.580012
							],
							[
								-69.858444,
								-18.092694
							],
							[
								-70.372572,
								-18.347975
							],
							[
								-71.37525,
								-17.773799
							],
							[
								-71.462041,
								-17.363488
							],
							[
								-73.44453,
								-16.359363
							],
							[
								-75.237883,
								-15.265683
							],
							[
								-76.009205,
								-14.649286
							],
							[
								-76.423469,
								-13.823187
							],
							[
								-76.259242,
								-13.535039
							],
							[
								-77.106192,
								-12.222716
							],
							[
								-78.092153,
								-10.377712
							],
							[
								-79.036953,
								-8.386568
							],
							[
								-79.44592,
								-7.930833
							],
							[
								-79.760578,
								-7.194341
							],
							[
								-80.537482,
								-6.541668
							],
							[
								-81.249996,
								-6.136834
							],
							[
								-80.926347,
								-5.690557
							],
							[
								-81.410943,
								-4.736765
							],
							[
								-81.09967,
								-4.036394
							],
							[
								-80.302561,
								-3.404856
							],
							[
								-80.184015,
								-3.821162
							],
							[
								-80.469295,
								-4.059287
							],
							[
								-80.442242,
								-4.425724
							],
							[
								-80.028908,
								-4.346091
							],
							[
								-79.624979,
								-4.454198
							],
							[
								-79.205289,
								-4.959129
							],
							[
								-78.639897,
								-4.547784
							],
							[
								-78.450684,
								-3.873097
							],
							[
								-77.837905,
								-3.003021
							],
							[
								-76.635394,
								-2.608678
							],
							[
								-75.544996,
								-1.56161
							],
							[
								-75.233723,
								-0.911417
							],
							[
								-75.373223,
								-0.152032
							],
							[
								-75.106625,
								-0.057205
							],
							[
								-74.441601,
								-0.53082
							],
							[
								-74.122395,
								-1.002833
							],
							[
								-73.659504,
								-1.260491
							],
							[
								-73.070392,
								-2.308954
							],
							[
								-72.325787,
								-2.434218
							],
							[
								-71.774761,
								-2.16979
							],
							[
								-71.413646,
								-2.342802
							],
							[
								-70.813476,
								-2.256865
							],
							[
								-70.047709,
								-2.725156
							],
							[
								-70.692682,
								-3.742872
							],
							[
								-70.394044,
								-3.766591
							],
							[
								-69.893635,
								-4.298187
							],
							[
								-70.794769,
								-4.251265
							],
							[
								-70.928843,
								-4.401591
							],
							[
								-71.748406,
								-4.593983
							],
							[
								-72.891928,
								-5.274561
							],
							[
								-72.964507,
								-5.741251
							],
							[
								-73.219711,
								-6.089189
							],
							[
								-73.120027,
								-6.629931
							],
							[
								-73.724487,
								-6.918595
							],
							[
								-73.723401,
								-7.340999
							],
							[
								-73.987235,
								-7.52383
							],
							[
								-73.571059,
								-8.424447
							],
							[
								-73.015383,
								-9.032833
							],
							[
								-73.226713,
								-9.462213
							],
							[
								-72.563033,
								-9.520194
							],
							[
								-72.184891,
								-10.053598
							],
							[
								-71.302412,
								-10.079436
							],
							[
								-70.481894,
								-9.490118
							],
							[
								-70.548686,
								-11.009147
							],
							[
								-70.093752,
								-11.123972
							],
							[
								-69.529678,
								-10.951734
							],
							[
								-68.66508,
								-12.5613
							],
							[
								-68.88008,
								-12.899729
							],
							[
								-68.929224,
								-13.602684
							],
							[
								-68.948887,
								-14.453639
							],
							[
								-69.339535,
								-14.953195
							],
							[
								-69.160347,
								-15.323974
							],
							[
								-69.389764,
								-15.660129
							],
							[
								-68.959635,
								-16.500698
							],
							[
								-69.590424,
								-17.580012
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PHL",
				"properties": {
					"name": "Philippines"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									126.376814,
									8.414706
								],
								[
									126.478513,
									7.750354
								],
								[
									126.537424,
									7.189381
								],
								[
									126.196773,
									6.274294
								],
								[
									125.831421,
									7.293715
								],
								[
									125.363852,
									6.786485
								],
								[
									125.683161,
									6.049657
								],
								[
									125.396512,
									5.581003
								],
								[
									124.219788,
									6.161355
								],
								[
									123.93872,
									6.885136
								],
								[
									124.243662,
									7.36061
								],
								[
									123.610212,
									7.833527
								],
								[
									123.296071,
									7.418876
								],
								[
									122.825506,
									7.457375
								],
								[
									122.085499,
									6.899424
								],
								[
									121.919928,
									7.192119
								],
								[
									122.312359,
									8.034962
								],
								[
									122.942398,
									8.316237
								],
								[
									123.487688,
									8.69301
								],
								[
									123.841154,
									8.240324
								],
								[
									124.60147,
									8.514158
								],
								[
									124.764612,
									8.960409
								],
								[
									125.471391,
									8.986997
								],
								[
									125.412118,
									9.760335
								],
								[
									126.222714,
									9.286074
								],
								[
									126.306637,
									8.782487
								],
								[
									126.376814,
									8.414706
								]
							]
						],
						[
							[
								[
									123.982438,
									10.278779
								],
								[
									123.623183,
									9.950091
								],
								[
									123.309921,
									9.318269
								],
								[
									122.995883,
									9.022189
								],
								[
									122.380055,
									9.713361
								],
								[
									122.586089,
									9.981045
								],
								[
									122.837081,
									10.261157
								],
								[
									122.947411,
									10.881868
								],
								[
									123.49885,
									10.940624
								],
								[
									123.337774,
									10.267384
								],
								[
									124.077936,
									11.232726
								],
								[
									123.982438,
									10.278779
								]
							]
						],
						[
							[
								[
									118.504581,
									9.316383
								],
								[
									117.174275,
									8.3675
								],
								[
									117.664477,
									9.066889
								],
								[
									118.386914,
									9.6845
								],
								[
									118.987342,
									10.376292
								],
								[
									119.511496,
									11.369668
								],
								[
									119.689677,
									10.554291
								],
								[
									119.029458,
									10.003653
								],
								[
									118.504581,
									9.316383
								]
							]
						],
						[
							[
								[
									121.883548,
									11.891755
								],
								[
									122.483821,
									11.582187
								],
								[
									123.120217,
									11.58366
								],
								[
									123.100838,
									11.165934
								],
								[
									122.637714,
									10.741308
								],
								[
									122.00261,
									10.441017
								],
								[
									121.967367,
									10.905691
								],
								[
									122.03837,
									11.415841
								],
								[
									121.883548,
									11.891755
								]
							]
						],
						[
							[
								[
									125.502552,
									12.162695
								],
								[
									125.783465,
									11.046122
								],
								[
									125.011884,
									11.311455
								],
								[
									125.032761,
									10.975816
								],
								[
									125.277449,
									10.358722
								],
								[
									124.801819,
									10.134679
								],
								[
									124.760168,
									10.837995
								],
								[
									124.459101,
									10.88993
								],
								[
									124.302522,
									11.495371
								],
								[
									124.891013,
									11.415583
								],
								[
									124.87799,
									11.79419
								],
								[
									124.266762,
									12.557761
								],
								[
									125.227116,
									12.535721
								],
								[
									125.502552,
									12.162695
								]
							]
						],
						[
							[
								[
									121.527394,
									13.06959
								],
								[
									121.26219,
									12.20556
								],
								[
									120.833896,
									12.704496
								],
								[
									120.323436,
									13.466413
								],
								[
									121.180128,
									13.429697
								],
								[
									121.527394,
									13.06959
								]
							]
						],
						[
							[
								[
									121.321308,
									18.504065
								],
								[
									121.937601,
									18.218552
								],
								[
									122.246006,
									18.47895
								],
								[
									122.336957,
									18.224883
								],
								[
									122.174279,
									17.810283
								],
								[
									122.515654,
									17.093505
								],
								[
									122.252311,
									16.262444
								],
								[
									121.662786,
									15.931018
								],
								[
									121.50507,
									15.124814
								],
								[
									121.728829,
									14.328376
								],
								[
									122.258925,
									14.218202
								],
								[
									122.701276,
									14.336541
								],
								[
									123.950295,
									13.782131
								],
								[
									123.855107,
									13.237771
								],
								[
									124.181289,
									12.997527
								],
								[
									124.077419,
									12.536677
								],
								[
									123.298035,
									13.027526
								],
								[
									122.928652,
									13.55292
								],
								[
									122.671355,
									13.185836
								],
								[
									122.03465,
									13.784482
								],
								[
									121.126385,
									13.636687
								],
								[
									120.628637,
									13.857656
								],
								[
									120.679384,
									14.271016
								],
								[
									120.991819,
									14.525393
								],
								[
									120.693336,
									14.756671
								],
								[
									120.564145,
									14.396279
								],
								[
									120.070429,
									14.970869
								],
								[
									119.920929,
									15.406347
								],
								[
									119.883773,
									16.363704
								],
								[
									120.286488,
									16.034629
								],
								[
									120.390047,
									17.599081
								],
								[
									120.715867,
									18.505227
								],
								[
									121.321308,
									18.504065
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PNG",
				"properties": {
					"name": "Papua New Guinea"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									155.880026,
									-6.819997
								],
								[
									155.599991,
									-6.919991
								],
								[
									155.166994,
									-6.535931
								],
								[
									154.729192,
									-5.900828
								],
								[
									154.514114,
									-5.139118
								],
								[
									154.652504,
									-5.042431
								],
								[
									154.759991,
									-5.339984
								],
								[
									155.062918,
									-5.566792
								],
								[
									155.547746,
									-6.200655
								],
								[
									156.019965,
									-6.540014
								],
								[
									155.880026,
									-6.819997
								]
							]
						],
						[
							[
								[
									151.982796,
									-5.478063
								],
								[
									151.459107,
									-5.56028
								],
								[
									151.30139,
									-5.840728
								],
								[
									150.754447,
									-6.083763
								],
								[
									150.241197,
									-6.317754
								],
								[
									149.709963,
									-6.316513
								],
								[
									148.890065,
									-6.02604
								],
								[
									148.318937,
									-5.747142
								],
								[
									148.401826,
									-5.437756
								],
								[
									149.298412,
									-5.583742
								],
								[
									149.845562,
									-5.505503
								],
								[
									149.99625,
									-5.026101
								],
								[
									150.139756,
									-5.001348
								],
								[
									150.236908,
									-5.53222
								],
								[
									150.807467,
									-5.455842
								],
								[
									151.089672,
									-5.113693
								],
								[
									151.647881,
									-4.757074
								],
								[
									151.537862,
									-4.167807
								],
								[
									152.136792,
									-4.14879
								],
								[
									152.338743,
									-4.312966
								],
								[
									152.318693,
									-4.867661
								],
								[
									151.982796,
									-5.478063
								]
							]
						],
						[
							[
								[
									147.191874,
									-7.388024
								],
								[
									148.084636,
									-8.044108
								],
								[
									148.734105,
									-9.104664
								],
								[
									149.306835,
									-9.071436
								],
								[
									149.266631,
									-9.514406
								],
								[
									150.038728,
									-9.684318
								],
								[
									149.738798,
									-9.872937
								],
								[
									150.801628,
									-10.293687
								],
								[
									150.690575,
									-10.582713
								],
								[
									150.028393,
									-10.652476
								],
								[
									149.78231,
									-10.393267
								],
								[
									148.923138,
									-10.280923
								],
								[
									147.913018,
									-10.130441
								],
								[
									147.135443,
									-9.492444
								],
								[
									146.567881,
									-8.942555
								],
								[
									146.048481,
									-8.067414
								],
								[
									144.744168,
									-7.630128
								],
								[
									143.897088,
									-7.91533
								],
								[
									143.286376,
									-8.245491
								],
								[
									143.413913,
									-8.983069
								],
								[
									142.628431,
									-9.326821
								],
								[
									142.068259,
									-9.159596
								],
								[
									141.033852,
									-9.117893
								],
								[
									141.017057,
									-5.859022
								],
								[
									141.00021,
									-2.600151
								],
								[
									142.735247,
									-3.289153
								],
								[
									144.583971,
									-3.861418
								],
								[
									145.27318,
									-4.373738
								],
								[
									145.829786,
									-4.876498
								],
								[
									145.981922,
									-5.465609
								],
								[
									147.648073,
									-6.083659
								],
								[
									147.891108,
									-6.614015
								],
								[
									146.970905,
									-6.721657
								],
								[
									147.191874,
									-7.388024
								]
							]
						],
						[
							[
								[
									153.140038,
									-4.499983
								],
								[
									152.827292,
									-4.766427
								],
								[
									152.638673,
									-4.176127
								],
								[
									152.406026,
									-3.789743
								],
								[
									151.953237,
									-3.462062
								],
								[
									151.384279,
									-3.035422
								],
								[
									150.66205,
									-2.741486
								],
								[
									150.939965,
									-2.500002
								],
								[
									151.479984,
									-2.779985
								],
								[
									151.820015,
									-2.999972
								],
								[
									152.239989,
									-3.240009
								],
								[
									152.640017,
									-3.659983
								],
								[
									153.019994,
									-3.980015
								],
								[
									153.140038,
									-4.499983
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "POL",
				"properties": {
					"name": "Poland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								15.016996,
								51.106674
							],
							[
								14.607098,
								51.745188
							],
							[
								14.685026,
								52.089947
							],
							[
								14.4376,
								52.62485
							],
							[
								14.074521,
								52.981263
							],
							[
								14.353315,
								53.248171
							],
							[
								14.119686,
								53.757029
							],
							[
								14.8029,
								54.050706
							],
							[
								16.363477,
								54.513159
							],
							[
								17.622832,
								54.851536
							],
							[
								18.620859,
								54.682606
							],
							[
								18.696255,
								54.438719
							],
							[
								19.66064,
								54.426084
							],
							[
								20.892245,
								54.312525
							],
							[
								22.731099,
								54.327537
							],
							[
								23.243987,
								54.220567
							],
							[
								23.484128,
								53.912498
							],
							[
								23.527536,
								53.470122
							],
							[
								23.804935,
								53.089731
							],
							[
								23.799199,
								52.691099
							],
							[
								23.199494,
								52.486977
							],
							[
								23.508002,
								52.023647
							],
							[
								23.527071,
								51.578454
							],
							[
								24.029986,
								50.705407
							],
							[
								23.922757,
								50.424881
							],
							[
								23.426508,
								50.308506
							],
							[
								22.51845,
								49.476774
							],
							[
								22.776419,
								49.027395
							],
							[
								22.558138,
								49.085738
							],
							[
								21.607808,
								49.470107
							],
							[
								20.887955,
								49.328772
							],
							[
								20.415839,
								49.431453
							],
							[
								19.825023,
								49.217125
							],
							[
								19.320713,
								49.571574
							],
							[
								18.909575,
								49.435846
							],
							[
								18.853144,
								49.49623
							],
							[
								18.392914,
								49.988629
							],
							[
								17.649445,
								50.049038
							],
							[
								17.554567,
								50.362146
							],
							[
								16.868769,
								50.473974
							],
							[
								16.719476,
								50.215747
							],
							[
								16.176253,
								50.422607
							],
							[
								16.238627,
								50.697733
							],
							[
								15.490972,
								50.78473
							],
							[
								15.016996,
								51.106674
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PRI",
				"properties": {
					"name": "Puerto Rico"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-66.282434,
								18.514762
							],
							[
								-65.771303,
								18.426679
							],
							[
								-65.591004,
								18.228035
							],
							[
								-65.847164,
								17.975906
							],
							[
								-66.599934,
								17.981823
							],
							[
								-67.184162,
								17.946553
							],
							[
								-67.242428,
								18.37446
							],
							[
								-67.100679,
								18.520601
							],
							[
								-66.282434,
								18.514762
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PRK",
				"properties": {
					"name": "North Korea"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								130.640016,
								42.395009
							],
							[
								130.780007,
								42.220007
							],
							[
								130.400031,
								42.280004
							],
							[
								129.965949,
								41.941368
							],
							[
								129.667362,
								41.601104
							],
							[
								129.705189,
								40.882828
							],
							[
								129.188115,
								40.661808
							],
							[
								129.0104,
								40.485436
							],
							[
								128.633368,
								40.189847
							],
							[
								127.967414,
								40.025413
							],
							[
								127.533436,
								39.75685
							],
							[
								127.50212,
								39.323931
							],
							[
								127.385434,
								39.213472
							],
							[
								127.783343,
								39.050898
							],
							[
								128.349716,
								38.612243
							],
							[
								128.205746,
								38.370397
							],
							[
								127.780035,
								38.304536
							],
							[
								127.073309,
								38.256115
							],
							[
								126.68372,
								37.804773
							],
							[
								126.237339,
								37.840378
							],
							[
								126.174759,
								37.749686
							],
							[
								125.689104,
								37.94001
							],
							[
								125.568439,
								37.752089
							],
							[
								125.27533,
								37.669071
							],
							[
								125.240087,
								37.857224
							],
							[
								124.981033,
								37.948821
							],
							[
								124.712161,
								38.108346
							],
							[
								124.985994,
								38.548474
							],
							[
								125.221949,
								38.665857
							],
							[
								125.132859,
								38.848559
							],
							[
								125.38659,
								39.387958
							],
							[
								125.321116,
								39.551385
							],
							[
								124.737482,
								39.660344
							],
							[
								124.265625,
								39.928493
							],
							[
								125.079942,
								40.569824
							],
							[
								126.182045,
								41.107336
							],
							[
								126.869083,
								41.816569
							],
							[
								127.343783,
								41.503152
							],
							[
								128.208433,
								41.466772
							],
							[
								128.052215,
								41.994285
							],
							[
								129.596669,
								42.424982
							],
							[
								129.994267,
								42.985387
							],
							[
								130.640016,
								42.395009
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PRT",
				"properties": {
					"name": "Portugal"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-9.034818,
								41.880571
							],
							[
								-8.671946,
								42.134689
							],
							[
								-8.263857,
								42.280469
							],
							[
								-8.013175,
								41.790886
							],
							[
								-7.422513,
								41.792075
							],
							[
								-7.251309,
								41.918346
							],
							[
								-6.668606,
								41.883387
							],
							[
								-6.389088,
								41.381815
							],
							[
								-6.851127,
								41.111083
							],
							[
								-6.86402,
								40.330872
							],
							[
								-7.026413,
								40.184524
							],
							[
								-7.066592,
								39.711892
							],
							[
								-7.498632,
								39.629571
							],
							[
								-7.098037,
								39.030073
							],
							[
								-7.374092,
								38.373059
							],
							[
								-7.029281,
								38.075764
							],
							[
								-7.166508,
								37.803894
							],
							[
								-7.537105,
								37.428904
							],
							[
								-7.453726,
								37.097788
							],
							[
								-7.855613,
								36.838269
							],
							[
								-8.382816,
								36.97888
							],
							[
								-8.898857,
								36.868809
							],
							[
								-8.746101,
								37.651346
							],
							[
								-8.839998,
								38.266243
							],
							[
								-9.287464,
								38.358486
							],
							[
								-9.526571,
								38.737429
							],
							[
								-9.446989,
								39.392066
							],
							[
								-9.048305,
								39.755093
							],
							[
								-8.977353,
								40.159306
							],
							[
								-8.768684,
								40.760639
							],
							[
								-8.790853,
								41.184334
							],
							[
								-8.990789,
								41.543459
							],
							[
								-9.034818,
								41.880571
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PRY",
				"properties": {
					"name": "Paraguay"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-62.685057,
								-22.249029
							],
							[
								-62.291179,
								-21.051635
							],
							[
								-62.265961,
								-20.513735
							],
							[
								-61.786326,
								-19.633737
							],
							[
								-60.043565,
								-19.342747
							],
							[
								-59.115042,
								-19.356906
							],
							[
								-58.183471,
								-19.868399
							],
							[
								-58.166392,
								-20.176701
							],
							[
								-57.870674,
								-20.732688
							],
							[
								-57.937156,
								-22.090176
							],
							[
								-56.88151,
								-22.282154
							],
							[
								-56.473317,
								-22.0863
							],
							[
								-55.797958,
								-22.35693
							],
							[
								-55.610683,
								-22.655619
							],
							[
								-55.517639,
								-23.571998
							],
							[
								-55.400747,
								-23.956935
							],
							[
								-55.027902,
								-24.001274
							],
							[
								-54.652834,
								-23.839578
							],
							[
								-54.29296,
								-24.021014
							],
							[
								-54.293476,
								-24.5708
							],
							[
								-54.428946,
								-25.162185
							],
							[
								-54.625291,
								-25.739255
							],
							[
								-54.788795,
								-26.621786
							],
							[
								-55.695846,
								-27.387837
							],
							[
								-56.486702,
								-27.548499
							],
							[
								-57.60976,
								-27.395899
							],
							[
								-58.618174,
								-27.123719
							],
							[
								-57.63366,
								-25.603657
							],
							[
								-57.777217,
								-25.16234
							],
							[
								-58.807128,
								-24.771459
							],
							[
								-60.028966,
								-24.032796
							],
							[
								-60.846565,
								-23.880713
							],
							[
								-62.685057,
								-22.249029
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "QAT",
				"properties": {
					"name": "Qatar"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								50.810108,
								24.754743
							],
							[
								50.743911,
								25.482424
							],
							[
								51.013352,
								26.006992
							],
							[
								51.286462,
								26.114582
							],
							[
								51.589079,
								25.801113
							],
							[
								51.6067,
								25.21567
							],
							[
								51.389608,
								24.627386
							],
							[
								51.112415,
								24.556331
							],
							[
								50.810108,
								24.754743
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ROU",
				"properties": {
					"name": "Romania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								22.710531,
								47.882194
							],
							[
								23.142236,
								48.096341
							],
							[
								23.760958,
								47.985598
							],
							[
								24.402056,
								47.981878
							],
							[
								24.866317,
								47.737526
							],
							[
								25.207743,
								47.891056
							],
							[
								25.945941,
								47.987149
							],
							[
								26.19745,
								48.220881
							],
							[
								26.619337,
								48.220726
							],
							[
								26.924176,
								48.123264
							],
							[
								27.233873,
								47.826771
							],
							[
								27.551166,
								47.405117
							],
							[
								28.12803,
								46.810476
							],
							[
								28.160018,
								46.371563
							],
							[
								28.054443,
								45.944586
							],
							[
								28.233554,
								45.488283
							],
							[
								28.679779,
								45.304031
							],
							[
								29.149725,
								45.464925
							],
							[
								29.603289,
								45.293308
							],
							[
								29.626543,
								45.035391
							],
							[
								29.141612,
								44.82021
							],
							[
								28.837858,
								44.913874
							],
							[
								28.558081,
								43.707462
							],
							[
								27.970107,
								43.812468
							],
							[
								27.2424,
								44.175986
							],
							[
								26.065159,
								43.943494
							],
							[
								25.569272,
								43.688445
							],
							[
								24.100679,
								43.741051
							],
							[
								23.332302,
								43.897011
							],
							[
								22.944832,
								43.823785
							],
							[
								22.65715,
								44.234923
							],
							[
								22.474008,
								44.409228
							],
							[
								22.705726,
								44.578003
							],
							[
								22.459022,
								44.702517
							],
							[
								22.145088,
								44.478422
							],
							[
								21.562023,
								44.768947
							],
							[
								21.483526,
								45.18117
							],
							[
								20.874313,
								45.416375
							],
							[
								20.762175,
								45.734573
							],
							[
								20.220192,
								46.127469
							],
							[
								21.021952,
								46.316088
							],
							[
								21.626515,
								46.994238
							],
							[
								22.099768,
								47.672439
							],
							[
								22.710531,
								47.882194
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "RUS",
				"properties": {
					"name": "Russia"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									143.648007,
									50.7476
								],
								[
									144.654148,
									48.976391
								],
								[
									143.173928,
									49.306551
								],
								[
									142.558668,
									47.861575
								],
								[
									143.533492,
									46.836728
								],
								[
									143.505277,
									46.137908
								],
								[
									142.747701,
									46.740765
								],
								[
									142.09203,
									45.966755
								],
								[
									141.906925,
									46.805929
								],
								[
									142.018443,
									47.780133
								],
								[
									141.904445,
									48.859189
								],
								[
									142.1358,
									49.615163
								],
								[
									142.179983,
									50.952342
								],
								[
									141.594076,
									51.935435
								],
								[
									141.682546,
									53.301966
								],
								[
									142.606934,
									53.762145
								],
								[
									142.209749,
									54.225476
								],
								[
									142.654786,
									54.365881
								],
								[
									142.914616,
									53.704578
								],
								[
									143.260848,
									52.74076
								],
								[
									143.235268,
									51.75666
								],
								[
									143.648007,
									50.7476
								]
							]
						],
						[
							[
								[
									22.731099,
									54.327537
								],
								[
									20.892245,
									54.312525
								],
								[
									19.66064,
									54.426084
								],
								[
									19.888481,
									54.86616
								],
								[
									21.268449,
									55.190482
								],
								[
									22.315724,
									55.015299
								],
								[
									22.757764,
									54.856574
								],
								[
									22.651052,
									54.582741
								],
								[
									22.731099,
									54.327537
								]
							]
						],
						[
							[
								[
									-175.01425,
									66.58435
								],
								[
									-174.33983,
									66.33556
								],
								[
									-174.57182,
									67.06219
								],
								[
									-171.85731,
									66.91308
								],
								[
									-169.89958,
									65.97724
								],
								[
									-170.89107,
									65.54139
								],
								[
									-172.53025,
									65.43791
								],
								[
									-172.555,
									64.46079
								],
								[
									-172.95533,
									64.25269
								],
								[
									-173.89184,
									64.2826
								],
								[
									-174.65392,
									64.63125
								],
								[
									-175.98353,
									64.92288
								],
								[
									-176.20716,
									65.35667
								],
								[
									-177.22266,
									65.52024
								],
								[
									-178.35993,
									65.39052
								],
								[
									-178.90332,
									65.74044
								],
								[
									-178.68611,
									66.11211
								],
								[
									-179.88377,
									65.87456
								],
								[
									-179.43268,
									65.40411
								],
								[
									-180,
									64.979709
								],
								[
									-180,
									68.963636
								],
								[
									-177.55,
									68.2
								],
								[
									-174.92825,
									67.20589
								],
								[
									-175.01425,
									66.58435
								]
							]
						],
						[
							[
								[
									180,
									70.832199
								],
								[
									178.903425,
									70.78114
								],
								[
									178.7253,
									71.0988
								],
								[
									180,
									71.515714
								],
								[
									180,
									70.832199
								]
							]
						],
						[
							[
								[
									-178.69378,
									70.89302
								],
								[
									-180,
									70.832199
								],
								[
									-180,
									71.515714
								],
								[
									-179.871875,
									71.55762
								],
								[
									-179.02433,
									71.55553
								],
								[
									-177.577945,
									71.26948
								],
								[
									-177.663575,
									71.13277
								],
								[
									-178.69378,
									70.89302
								]
							]
						],
						[
							[
								[
									143.60385,
									73.21244
								],
								[
									142.08763,
									73.20544
								],
								[
									140.038155,
									73.31692
								],
								[
									139.86312,
									73.36983
								],
								[
									140.81171,
									73.76506
								],
								[
									142.06207,
									73.85758
								],
								[
									143.48283,
									73.47525
								],
								[
									143.60385,
									73.21244
								]
							]
						],
						[
							[
								[
									150.73167,
									75.08406
								],
								[
									149.575925,
									74.68892
								],
								[
									147.977465,
									74.778355
								],
								[
									146.11919,
									75.17298
								],
								[
									146.358485,
									75.49682
								],
								[
									148.22223,
									75.345845
								],
								[
									150.73167,
									75.08406
								]
							]
						],
						[
							[
								[
									145.086285,
									75.562625
								],
								[
									144.3,
									74.82
								],
								[
									140.61381,
									74.84768
								],
								[
									138.95544,
									74.61148
								],
								[
									136.97439,
									75.26167
								],
								[
									137.51176,
									75.94917
								],
								[
									138.831075,
									76.13676
								],
								[
									141.471615,
									76.09289
								],
								[
									145.086285,
									75.562625
								]
							]
						],
						[
							[
								[
									57.535693,
									70.720464
								],
								[
									56.944979,
									70.632743
								],
								[
									53.677375,
									70.762658
								],
								[
									53.412017,
									71.206662
								],
								[
									51.601895,
									71.474759
								],
								[
									51.455754,
									72.014881
								],
								[
									52.478275,
									72.229442
								],
								[
									52.444169,
									72.774731
								],
								[
									54.427614,
									73.627548
								],
								[
									53.50829,
									73.749814
								],
								[
									55.902459,
									74.627486
								],
								[
									55.631933,
									75.081412
								],
								[
									57.868644,
									75.60939
								],
								[
									61.170044,
									76.251883
								],
								[
									64.498368,
									76.439055
								],
								[
									66.210977,
									76.809782
								],
								[
									68.15706,
									76.939697
								],
								[
									68.852211,
									76.544811
								],
								[
									68.180573,
									76.233642
								],
								[
									64.637326,
									75.737755
								],
								[
									61.583508,
									75.260885
								],
								[
									58.477082,
									74.309056
								],
								[
									56.986786,
									73.333044
								],
								[
									55.419336,
									72.371268
								],
								[
									55.622838,
									71.540595
								],
								[
									57.535693,
									70.720464
								]
							]
						],
						[
							[
								[
									106.97013,
									76.97419
								],
								[
									107.24,
									76.48
								],
								[
									108.1538,
									76.72335
								],
								[
									111.07726,
									76.71
								],
								[
									113.33151,
									76.22224
								],
								[
									114.13417,
									75.84764
								],
								[
									113.88539,
									75.32779
								],
								[
									112.77918,
									75.03186
								],
								[
									110.15125,
									74.47673
								],
								[
									109.4,
									74.18
								],
								[
									110.64,
									74.04
								],
								[
									112.11919,
									73.78774
								],
								[
									113.01954,
									73.97693
								],
								[
									113.52958,
									73.33505
								],
								[
									113.96881,
									73.59488
								],
								[
									115.56782,
									73.75285
								],
								[
									118.77633,
									73.58772
								],
								[
									119.02,
									73.12
								],
								[
									123.20066,
									72.97122
								],
								[
									123.25777,
									73.73503
								],
								[
									125.38,
									73.56
								],
								[
									126.97644,
									73.56549
								],
								[
									128.59126,
									73.03871
								],
								[
									129.05157,
									72.39872
								],
								[
									128.46,
									71.98
								],
								[
									129.71599,
									71.19304
								],
								[
									131.28858,
									70.78699
								],
								[
									132.2535,
									71.8363
								],
								[
									133.85766,
									71.38642
								],
								[
									135.56193,
									71.65525
								],
								[
									137.49755,
									71.34763
								],
								[
									138.23409,
									71.62803
								],
								[
									139.86983,
									71.48783
								],
								[
									139.14791,
									72.41619
								],
								[
									140.46817,
									72.84941
								],
								[
									149.5,
									72.2
								],
								[
									150.35118,
									71.60643
								],
								[
									152.9689,
									70.84222
								],
								[
									157.00688,
									71.03141
								],
								[
									158.99779,
									70.86672
								],
								[
									159.83031,
									70.45324
								],
								[
									159.70866,
									69.72198
								],
								[
									160.94053,
									69.43728
								],
								[
									162.27907,
									69.64204
								],
								[
									164.05248,
									69.66823
								],
								[
									165.94037,
									69.47199
								],
								[
									167.83567,
									69.58269
								],
								[
									169.57763,
									68.6938
								],
								[
									170.81688,
									69.01363
								],
								[
									170.0082,
									69.65276
								],
								[
									170.45345,
									70.09703
								],
								[
									173.64391,
									69.81743
								],
								[
									175.72403,
									69.87725
								],
								[
									178.6,
									69.4
								],
								[
									180,
									68.963636
								],
								[
									180,
									64.979709
								],
								[
									179.99281,
									64.97433
								],
								[
									178.7072,
									64.53493
								],
								[
									177.41128,
									64.60821
								],
								[
									178.313,
									64.07593
								],
								[
									178.90825,
									63.25197
								],
								[
									179.37034,
									62.98262
								],
								[
									179.48636,
									62.56894
								],
								[
									179.22825,
									62.3041
								],
								[
									177.3643,
									62.5219
								],
								[
									174.56929,
									61.76915
								],
								[
									173.68013,
									61.65261
								],
								[
									172.15,
									60.95
								],
								[
									170.6985,
									60.33618
								],
								[
									170.33085,
									59.88177
								],
								[
									168.90046,
									60.57355
								],
								[
									166.29498,
									59.78855
								],
								[
									165.84,
									60.16
								],
								[
									164.87674,
									59.7316
								],
								[
									163.53929,
									59.86871
								],
								[
									163.21711,
									59.21101
								],
								[
									162.01733,
									58.24328
								],
								[
									162.05297,
									57.83912
								],
								[
									163.19191,
									57.61503
								],
								[
									163.05794,
									56.15924
								],
								[
									162.12958,
									56.12219
								],
								[
									161.70146,
									55.28568
								],
								[
									162.11749,
									54.85514
								],
								[
									160.36877,
									54.34433
								],
								[
									160.02173,
									53.20257
								],
								[
									158.53094,
									52.95868
								],
								[
									158.23118,
									51.94269
								],
								[
									156.78979,
									51.01105
								],
								[
									156.42,
									51.7
								],
								[
									155.99182,
									53.15895
								],
								[
									155.43366,
									55.38103
								],
								[
									155.91442,
									56.76792
								],
								[
									156.75815,
									57.3647
								],
								[
									156.81035,
									57.83204
								],
								[
									158.36433,
									58.05575
								],
								[
									160.15064,
									59.31477
								],
								[
									161.87204,
									60.343
								],
								[
									163.66969,
									61.1409
								],
								[
									164.47355,
									62.55061
								],
								[
									163.25842,
									62.46627
								],
								[
									162.65791,
									61.6425
								],
								[
									160.12148,
									60.54423
								],
								[
									159.30232,
									61.77396
								],
								[
									156.72068,
									61.43442
								],
								[
									154.21806,
									59.75818
								],
								[
									155.04375,
									59.14495
								],
								[
									152.81185,
									58.88385
								],
								[
									151.26573,
									58.78089
								],
								[
									151.33815,
									59.50396
								],
								[
									149.78371,
									59.65573
								],
								[
									148.54481,
									59.16448
								],
								[
									145.48722,
									59.33637
								],
								[
									142.19782,
									59.03998
								],
								[
									138.95848,
									57.08805
								],
								[
									135.12619,
									54.72959
								],
								[
									136.70171,
									54.60355
								],
								[
									137.19342,
									53.97732
								],
								[
									138.1647,
									53.75501
								],
								[
									138.80463,
									54.25455
								],
								[
									139.90151,
									54.18968
								],
								[
									141.34531,
									53.08957
								],
								[
									141.37923,
									52.23877
								],
								[
									140.59742,
									51.23967
								],
								[
									140.51308,
									50.04553
								],
								[
									140.06193,
									48.44671
								],
								[
									138.55472,
									46.99965
								],
								[
									138.21971,
									46.30795
								],
								[
									136.86232,
									45.1435
								],
								[
									135.51535,
									43.989
								],
								[
									134.86939,
									43.39821
								],
								[
									133.53687,
									42.81147
								],
								[
									132.90627,
									42.79849
								],
								[
									132.27807,
									43.28456
								],
								[
									130.93587,
									42.55274
								],
								[
									130.78,
									42.22
								],
								[
									130.64,
									42.395
								],
								[
									130.633866,
									42.903015
								],
								[
									131.144688,
									42.92999
								],
								[
									131.288555,
									44.11152
								],
								[
									131.02519,
									44.96796
								],
								[
									131.883454,
									45.321162
								],
								[
									133.09712,
									45.14409
								],
								[
									133.769644,
									46.116927
								],
								[
									134.11235,
									47.21248
								],
								[
									134.50081,
									47.57845
								],
								[
									135.026311,
									48.47823
								],
								[
									133.373596,
									48.183442
								],
								[
									132.50669,
									47.78896
								],
								[
									130.98726,
									47.79013
								],
								[
									130.582293,
									48.729687
								],
								[
									129.397818,
									49.4406
								],
								[
									127.6574,
									49.76027
								],
								[
									127.287456,
									50.739797
								],
								[
									126.939157,
									51.353894
								],
								[
									126.564399,
									51.784255
								],
								[
									125.946349,
									52.792799
								],
								[
									125.068211,
									53.161045
								],
								[
									123.57147,
									53.4588
								],
								[
									122.245748,
									53.431726
								],
								[
									121.003085,
									53.251401
								],
								[
									120.177089,
									52.753886
								],
								[
									120.725789,
									52.516226
								],
								[
									120.7382,
									51.96411
								],
								[
									120.18208,
									51.64355
								],
								[
									119.27939,
									50.58292
								],
								[
									119.288461,
									50.142883
								],
								[
									117.879244,
									49.510983
								],
								[
									116.678801,
									49.888531
								],
								[
									115.485695,
									49.805177
								],
								[
									114.96211,
									50.140247
								],
								[
									114.362456,
									50.248303
								],
								[
									112.89774,
									49.543565
								],
								[
									111.581231,
									49.377968
								],
								[
									110.662011,
									49.130128
								],
								[
									109.402449,
									49.292961
								],
								[
									108.475167,
									49.282548
								],
								[
									107.868176,
									49.793705
								],
								[
									106.888804,
									50.274296
								],
								[
									105.886591,
									50.406019
								],
								[
									104.62158,
									50.27532
								],
								[
									103.676545,
									50.089966
								],
								[
									102.25589,
									50.51056
								],
								[
									102.06521,
									51.25991
								],
								[
									100.88948,
									51.516856
								],
								[
									99.981732,
									51.634006
								],
								[
									98.861491,
									52.047366
								],
								[
									97.82574,
									51.010995
								],
								[
									98.231762,
									50.422401
								],
								[
									97.25976,
									49.72605
								],
								[
									95.81402,
									49.97746
								],
								[
									94.815949,
									50.013433
								],
								[
									94.147566,
									50.480537
								],
								[
									93.10421,
									50.49529
								],
								[
									92.234712,
									50.802171
								],
								[
									90.713667,
									50.331812
								],
								[
									88.805567,
									49.470521
								],
								[
									87.751264,
									49.297198
								],
								[
									87.35997,
									49.214981
								],
								[
									86.829357,
									49.826675
								],
								[
									85.54127,
									49.692859
								],
								[
									85.11556,
									50.117303
								],
								[
									84.416377,
									50.3114
								],
								[
									83.935115,
									50.889246
								],
								[
									83.383004,
									51.069183
								],
								[
									81.945986,
									50.812196
								],
								[
									80.568447,
									51.388336
								],
								[
									80.03556,
									50.864751
								],
								[
									77.800916,
									53.404415
								],
								[
									76.525179,
									54.177003
								],
								[
									76.8911,
									54.490524
								],
								[
									74.38482,
									53.54685
								],
								[
									73.425679,
									53.48981
								],
								[
									73.508516,
									54.035617
								],
								[
									72.22415,
									54.376655
								],
								[
									71.180131,
									54.133285
								],
								[
									70.865267,
									55.169734
								],
								[
									69.068167,
									55.38525
								],
								[
									68.1691,
									54.970392
								],
								[
									65.66687,
									54.60125
								],
								[
									65.178534,
									54.354228
								],
								[
									61.4366,
									54.00625
								],
								[
									60.978066,
									53.664993
								],
								[
									61.699986,
									52.979996
								],
								[
									60.739993,
									52.719986
								],
								[
									60.927269,
									52.447548
								],
								[
									59.967534,
									51.96042
								],
								[
									61.588003,
									51.272659
								],
								[
									61.337424,
									50.79907
								],
								[
									59.932807,
									50.842194
								],
								[
									59.642282,
									50.545442
								],
								[
									58.36332,
									51.06364
								],
								[
									56.77798,
									51.04355
								],
								[
									55.71694,
									50.62171
								],
								[
									54.532878,
									51.02624
								],
								[
									52.328724,
									51.718652
								],
								[
									50.766648,
									51.692762
								],
								[
									48.702382,
									50.605128
								],
								[
									48.577841,
									49.87476
								],
								[
									47.54948,
									50.454698
								],
								[
									46.751596,
									49.356006
								],
								[
									47.043672,
									49.152039
								],
								[
									46.466446,
									48.394152
								],
								[
									47.31524,
									47.71585
								],
								[
									48.05725,
									47.74377
								],
								[
									48.694734,
									47.075628
								],
								[
									48.59325,
									46.56104
								],
								[
									49.10116,
									46.39933
								],
								[
									48.64541,
									45.80629
								],
								[
									47.67591,
									45.64149
								],
								[
									46.68201,
									44.6092
								],
								[
									47.59094,
									43.66016
								],
								[
									47.49252,
									42.98658
								],
								[
									48.58437,
									41.80888
								],
								[
									47.987283,
									41.405819
								],
								[
									47.815666,
									41.151416
								],
								[
									47.373315,
									41.219732
								],
								[
									46.686071,
									41.827137
								],
								[
									46.404951,
									41.860675
								],
								[
									45.7764,
									42.09244
								],
								[
									45.470279,
									42.502781
								],
								[
									44.537623,
									42.711993
								],
								[
									43.93121,
									42.55496
								],
								[
									43.75599,
									42.74083
								],
								[
									42.3944,
									43.2203
								],
								[
									40.92219,
									43.38215
								],
								[
									40.076965,
									43.553104
								],
								[
									39.955009,
									43.434998
								],
								[
									38.68,
									44.28
								],
								[
									37.53912,
									44.65721
								],
								[
									36.67546,
									45.24469
								],
								[
									37.40317,
									45.40451
								],
								[
									38.23295,
									46.24087
								],
								[
									37.67372,
									46.63657
								],
								[
									39.14767,
									47.04475
								],
								[
									39.1212,
									47.26336
								],
								[
									38.223538,
									47.10219
								],
								[
									38.255112,
									47.5464
								],
								[
									38.77057,
									47.82562
								],
								[
									39.738278,
									47.898937
								],
								[
									39.89562,
									48.23241
								],
								[
									39.67465,
									48.78382
								],
								[
									40.080789,
									49.30743
								],
								[
									40.06904,
									49.60105
								],
								[
									38.594988,
									49.926462
								],
								[
									38.010631,
									49.915662
								],
								[
									37.39346,
									50.383953
								],
								[
									36.626168,
									50.225591
								],
								[
									35.356116,
									50.577197
								],
								[
									35.37791,
									50.77394
								],
								[
									35.022183,
									51.207572
								],
								[
									34.224816,
									51.255993
								],
								[
									34.141978,
									51.566413
								],
								[
									34.391731,
									51.768882
								],
								[
									33.7527,
									52.335075
								],
								[
									32.715761,
									52.238465
								],
								[
									32.412058,
									52.288695
								],
								[
									32.15944,
									52.06125
								],
								[
									31.78597,
									52.10168
								],
								[
									31.540018,
									52.742052
								],
								[
									31.305201,
									53.073996
								],
								[
									31.49764,
									53.16743
								],
								[
									32.304519,
									53.132726
								],
								[
									32.693643,
									53.351421
								],
								[
									32.405599,
									53.618045
								],
								[
									31.731273,
									53.794029
								],
								[
									31.791424,
									53.974639
								],
								[
									31.384472,
									54.157056
								],
								[
									30.757534,
									54.811771
								],
								[
									30.971836,
									55.081548
								],
								[
									30.873909,
									55.550976
								],
								[
									29.896294,
									55.789463
								],
								[
									29.371572,
									55.670091
								],
								[
									29.229513,
									55.918344
								],
								[
									28.176709,
									56.16913
								],
								[
									27.855282,
									56.759326
								],
								[
									27.770016,
									57.244258
								],
								[
									27.288185,
									57.474528
								],
								[
									27.716686,
									57.791899
								],
								[
									27.42015,
									58.72457
								],
								[
									28.131699,
									59.300825
								],
								[
									27.98112,
									59.47537
								],
								[
									29.1177,
									60.02805
								],
								[
									28.07,
									60.50352
								],
								[
									30.211107,
									61.780028
								],
								[
									31.139991,
									62.357693
								],
								[
									31.516092,
									62.867687
								],
								[
									30.035872,
									63.552814
								],
								[
									30.444685,
									64.204453
								],
								[
									29.54443,
									64.948672
								],
								[
									30.21765,
									65.80598
								],
								[
									29.054589,
									66.944286
								],
								[
									29.977426,
									67.698297
								],
								[
									28.445944,
									68.364613
								],
								[
									28.59193,
									69.064777
								],
								[
									29.39955,
									69.15692
								],
								[
									31.10108,
									69.55811
								],
								[
									32.13272,
									69.90595
								],
								[
									33.77547,
									69.30142
								],
								[
									36.51396,
									69.06342
								],
								[
									40.29234,
									67.9324
								],
								[
									41.05987,
									67.45713
								],
								[
									41.12595,
									66.79158
								],
								[
									40.01583,
									66.26618
								],
								[
									38.38295,
									65.99953
								],
								[
									33.91871,
									66.75961
								],
								[
									33.18444,
									66.63253
								],
								[
									34.81477,
									65.90015
								],
								[
									34.878574,
									65.436213
								],
								[
									34.94391,
									64.41437
								],
								[
									36.23129,
									64.10945
								],
								[
									37.01273,
									63.84983
								],
								[
									37.14197,
									64.33471
								],
								[
									36.539579,
									64.76446
								],
								[
									37.17604,
									65.14322
								],
								[
									39.59345,
									64.52079
								],
								[
									40.4356,
									64.76446
								],
								[
									39.7626,
									65.49682
								],
								[
									42.09309,
									66.47623
								],
								[
									43.01604,
									66.41858
								],
								[
									43.94975,
									66.06908
								],
								[
									44.53226,
									66.75634
								],
								[
									43.69839,
									67.35245
								],
								[
									44.18795,
									67.95051
								],
								[
									43.45282,
									68.57079
								],
								[
									46.25,
									68.25
								],
								[
									46.82134,
									67.68997
								],
								[
									45.55517,
									67.56652
								],
								[
									45.56202,
									67.01005
								],
								[
									46.34915,
									66.66767
								],
								[
									47.89416,
									66.88455
								],
								[
									48.13876,
									67.52238
								],
								[
									50.22766,
									67.99867
								],
								[
									53.71743,
									68.85738
								],
								[
									54.47171,
									68.80815
								],
								[
									53.48582,
									68.20131
								],
								[
									54.72628,
									68.09702
								],
								[
									55.44268,
									68.43866
								],
								[
									57.31702,
									68.46628
								],
								[
									58.802,
									68.88082
								],
								[
									59.94142,
									68.27844
								],
								[
									61.07784,
									68.94069
								],
								[
									60.03,
									69.52
								],
								[
									60.55,
									69.85
								],
								[
									63.504,
									69.54739
								],
								[
									64.888115,
									69.234835
								],
								[
									68.51216,
									68.09233
								],
								[
									69.18068,
									68.61563
								],
								[
									68.16444,
									69.14436
								],
								[
									68.13522,
									69.35649
								],
								[
									66.93008,
									69.45461
								],
								[
									67.25976,
									69.92873
								],
								[
									66.72492,
									70.70889
								],
								[
									66.69466,
									71.02897
								],
								[
									68.54006,
									71.9345
								],
								[
									69.19636,
									72.84336
								],
								[
									69.94,
									73.04
								],
								[
									72.58754,
									72.77629
								],
								[
									72.79603,
									72.22006
								],
								[
									71.84811,
									71.40898
								],
								[
									72.47011,
									71.09019
								],
								[
									72.79188,
									70.39114
								],
								[
									72.5647,
									69.02085
								],
								[
									73.66787,
									68.4079
								],
								[
									73.2387,
									67.7404
								],
								[
									71.28,
									66.32
								],
								[
									72.42301,
									66.17267
								],
								[
									72.82077,
									66.53267
								],
								[
									73.92099,
									66.78946
								],
								[
									74.18651,
									67.28429
								],
								[
									75.052,
									67.76047
								],
								[
									74.46926,
									68.32899
								],
								[
									74.93584,
									68.98918
								],
								[
									73.84236,
									69.07146
								],
								[
									73.60187,
									69.62763
								],
								[
									74.3998,
									70.63175
								],
								[
									73.1011,
									71.44717
								],
								[
									74.89082,
									72.12119
								],
								[
									74.65926,
									72.83227
								],
								[
									75.15801,
									72.85497
								],
								[
									75.68351,
									72.30056
								],
								[
									75.28898,
									71.33556
								],
								[
									76.35911,
									71.15287
								],
								[
									75.90313,
									71.87401
								],
								[
									77.57665,
									72.26717
								],
								[
									79.65202,
									72.32011
								],
								[
									81.5,
									71.75
								],
								[
									80.61071,
									72.58285
								],
								[
									80.51109,
									73.6482
								],
								[
									82.25,
									73.85
								],
								[
									84.65526,
									73.80591
								],
								[
									86.8223,
									73.93688
								],
								[
									86.00956,
									74.45967
								],
								[
									87.16682,
									75.11643
								],
								[
									88.31571,
									75.14393
								],
								[
									90.26,
									75.64
								],
								[
									92.90058,
									75.77333
								],
								[
									93.23421,
									76.0472
								],
								[
									95.86,
									76.14
								],
								[
									96.67821,
									75.91548
								],
								[
									98.92254,
									76.44689
								],
								[
									100.75967,
									76.43028
								],
								[
									101.03532,
									76.86189
								],
								[
									101.99084,
									77.28754
								],
								[
									104.3516,
									77.69792
								],
								[
									106.06664,
									77.37389
								],
								[
									104.705,
									77.1274
								],
								[
									106.97013,
									76.97419
								]
							]
						],
						[
							[
								[
									105.07547,
									78.30689
								],
								[
									99.43814,
									77.921
								],
								[
									101.2649,
									79.23399
								],
								[
									102.08635,
									79.34641
								],
								[
									102.837815,
									79.28129
								],
								[
									105.37243,
									78.71334
								],
								[
									105.07547,
									78.30689
								]
							]
						],
						[
							[
								[
									51.136187,
									80.54728
								],
								[
									49.793685,
									80.415428
								],
								[
									48.894411,
									80.339567
								],
								[
									48.754937,
									80.175468
								],
								[
									47.586119,
									80.010181
								],
								[
									46.502826,
									80.247247
								],
								[
									47.072455,
									80.559424
								],
								[
									44.846958,
									80.58981
								],
								[
									46.799139,
									80.771918
								],
								[
									48.318477,
									80.78401
								],
								[
									48.522806,
									80.514569
								],
								[
									49.09719,
									80.753986
								],
								[
									50.039768,
									80.918885
								],
								[
									51.522933,
									80.699726
								],
								[
									51.136187,
									80.54728
								]
							]
						],
						[
							[
								[
									99.93976,
									78.88094
								],
								[
									97.75794,
									78.7562
								],
								[
									94.97259,
									79.044745
								],
								[
									93.31288,
									79.4265
								],
								[
									92.5454,
									80.14379
								],
								[
									91.18107,
									80.34146
								],
								[
									93.77766,
									81.0246
								],
								[
									95.940895,
									81.2504
								],
								[
									97.88385,
									80.746975
								],
								[
									100.186655,
									79.780135
								],
								[
									99.93976,
									78.88094
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "RWA",
				"properties": {
					"name": "Rwanda"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								30.419105,
								-1.134659
							],
							[
								30.816135,
								-1.698914
							],
							[
								30.758309,
								-2.28725
							],
							[
								30.469696,
								-2.413858
							],
							[
								29.938359,
								-2.348487
							],
							[
								29.632176,
								-2.917858
							],
							[
								29.024926,
								-2.839258
							],
							[
								29.117479,
								-2.292211
							],
							[
								29.254835,
								-2.21511
							],
							[
								29.291887,
								-1.620056
							],
							[
								29.579466,
								-1.341313
							],
							[
								29.821519,
								-1.443322
							],
							[
								30.419105,
								-1.134659
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ESH",
				"properties": {
					"name": "Western Sahara"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-8.794884,
								27.120696
							],
							[
								-8.817828,
								27.656426
							],
							[
								-8.66559,
								27.656426
							],
							[
								-8.665124,
								27.589479
							],
							[
								-8.6844,
								27.395744
							],
							[
								-8.687294,
								25.881056
							],
							[
								-11.969419,
								25.933353
							],
							[
								-11.937224,
								23.374594
							],
							[
								-12.874222,
								23.284832
							],
							[
								-13.118754,
								22.77122
							],
							[
								-12.929102,
								21.327071
							],
							[
								-16.845194,
								21.333323
							],
							[
								-17.063423,
								20.999752
							],
							[
								-17.020428,
								21.42231
							],
							[
								-17.002962,
								21.420734
							],
							[
								-14.750955,
								21.5006
							],
							[
								-14.630833,
								21.86094
							],
							[
								-14.221168,
								22.310163
							],
							[
								-13.89111,
								23.691009
							],
							[
								-12.500963,
								24.770116
							],
							[
								-12.030759,
								26.030866
							],
							[
								-11.71822,
								26.104092
							],
							[
								-11.392555,
								26.883424
							],
							[
								-10.551263,
								26.990808
							],
							[
								-10.189424,
								26.860945
							],
							[
								-9.735343,
								26.860945
							],
							[
								-9.413037,
								27.088476
							],
							[
								-8.794884,
								27.120696
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SAU",
				"properties": {
					"name": "Saudi Arabia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								42.779332,
								16.347891
							],
							[
								42.649573,
								16.774635
							],
							[
								42.347989,
								17.075806
							],
							[
								42.270888,
								17.474722
							],
							[
								41.754382,
								17.833046
							],
							[
								41.221391,
								18.6716
							],
							[
								40.939341,
								19.486485
							],
							[
								40.247652,
								20.174635
							],
							[
								39.801685,
								20.338862
							],
							[
								39.139399,
								21.291905
							],
							[
								39.023696,
								21.986875
							],
							[
								39.066329,
								22.579656
							],
							[
								38.492772,
								23.688451
							],
							[
								38.02386,
								24.078686
							],
							[
								37.483635,
								24.285495
							],
							[
								37.154818,
								24.858483
							],
							[
								37.209491,
								25.084542
							],
							[
								36.931627,
								25.602959
							],
							[
								36.639604,
								25.826228
							],
							[
								36.249137,
								26.570136
							],
							[
								35.640182,
								27.37652
							],
							[
								35.130187,
								28.063352
							],
							[
								34.632336,
								28.058546
							],
							[
								34.787779,
								28.607427
							],
							[
								34.83222,
								28.957483
							],
							[
								34.956037,
								29.356555
							],
							[
								36.068941,
								29.197495
							],
							[
								36.501214,
								29.505254
							],
							[
								36.740528,
								29.865283
							],
							[
								37.503582,
								30.003776
							],
							[
								37.66812,
								30.338665
							],
							[
								37.998849,
								30.5085
							],
							[
								37.002166,
								31.508413
							],
							[
								39.004886,
								32.010217
							],
							[
								39.195468,
								32.161009
							],
							[
								40.399994,
								31.889992
							],
							[
								41.889981,
								31.190009
							],
							[
								44.709499,
								29.178891
							],
							[
								46.568713,
								29.099025
							],
							[
								47.459822,
								29.002519
							],
							[
								47.708851,
								28.526063
							],
							[
								48.416094,
								28.552004
							],
							[
								48.807595,
								27.689628
							],
							[
								49.299554,
								27.461218
							],
							[
								49.470914,
								27.109999
							],
							[
								50.152422,
								26.689663
							],
							[
								50.212935,
								26.277027
							],
							[
								50.113303,
								25.943972
							],
							[
								50.239859,
								25.60805
							],
							[
								50.527387,
								25.327808
							],
							[
								50.660557,
								24.999896
							],
							[
								50.810108,
								24.754743
							],
							[
								51.112415,
								24.556331
							],
							[
								51.389608,
								24.627386
							],
							[
								51.579519,
								24.245497
							],
							[
								51.617708,
								24.014219
							],
							[
								52.000733,
								23.001154
							],
							[
								55.006803,
								22.496948
							],
							[
								55.208341,
								22.70833
							],
							[
								55.666659,
								22.000001
							],
							[
								54.999982,
								19.999994
							],
							[
								52.00001,
								19.000003
							],
							[
								49.116672,
								18.616668
							],
							[
								48.183344,
								18.166669
							],
							[
								47.466695,
								17.116682
							],
							[
								47.000005,
								16.949999
							],
							[
								46.749994,
								17.283338
							],
							[
								46.366659,
								17.233315
							],
							[
								45.399999,
								17.333335
							],
							[
								45.216651,
								17.433329
							],
							[
								44.062613,
								17.410359
							],
							[
								43.791519,
								17.319977
							],
							[
								43.380794,
								17.579987
							],
							[
								43.115798,
								17.08844
							],
							[
								43.218375,
								16.66689
							],
							[
								42.779332,
								16.347891
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SDN",
				"properties": {
					"name": "Sudan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.963393,
								9.464285
							],
							[
								33.824963,
								9.484061
							],
							[
								33.842131,
								9.981915
							],
							[
								33.721959,
								10.325262
							],
							[
								33.206938,
								10.720112
							],
							[
								33.086766,
								11.441141
							],
							[
								33.206938,
								12.179338
							],
							[
								32.743419,
								12.248008
							],
							[
								32.67475,
								12.024832
							],
							[
								32.073892,
								11.97333
							],
							[
								32.314235,
								11.681484
							],
							[
								32.400072,
								11.080626
							],
							[
								31.850716,
								10.531271
							],
							[
								31.352862,
								9.810241
							],
							[
								30.837841,
								9.707237
							],
							[
								29.996639,
								10.290927
							],
							[
								29.618957,
								10.084919
							],
							[
								29.515953,
								9.793074
							],
							[
								29.000932,
								9.604232
							],
							[
								28.966597,
								9.398224
							],
							[
								27.97089,
								9.398224
							],
							[
								27.833551,
								9.604232
							],
							[
								27.112521,
								9.638567
							],
							[
								26.752006,
								9.466893
							],
							[
								26.477328,
								9.55273
							],
							[
								25.962307,
								10.136421
							],
							[
								25.790633,
								10.411099
							],
							[
								25.069604,
								10.27376
							],
							[
								24.794926,
								9.810241
							],
							[
								24.537415,
								8.917538
							],
							[
								24.194068,
								8.728696
							],
							[
								23.88698,
								8.61973
							],
							[
								23.805813,
								8.666319
							],
							[
								23.459013,
								8.954286
							],
							[
								23.394779,
								9.265068
							],
							[
								23.55725,
								9.681218
							],
							[
								23.554304,
								10.089255
							],
							[
								22.977544,
								10.714463
							],
							[
								22.864165,
								11.142395
							],
							[
								22.87622,
								11.38461
							],
							[
								22.50869,
								11.67936
							],
							[
								22.49762,
								12.26024
							],
							[
								22.28801,
								12.64605
							],
							[
								21.93681,
								12.58818
							],
							[
								22.03759,
								12.95546
							],
							[
								22.29658,
								13.37232
							],
							[
								22.18329,
								13.78648
							],
							[
								22.51202,
								14.09318
							],
							[
								22.30351,
								14.32682
							],
							[
								22.56795,
								14.94429
							],
							[
								23.02459,
								15.68072
							],
							[
								23.88689,
								15.61084
							],
							[
								23.83766,
								19.58047
							],
							[
								23.85,
								20
							],
							[
								25,
								20.00304
							],
							[
								25,
								22
							],
							[
								29.02,
								22
							],
							[
								32.9,
								22
							],
							[
								36.86623,
								22
							],
							[
								37.18872,
								21.01885
							],
							[
								36.96941,
								20.83744
							],
							[
								37.1147,
								19.80796
							],
							[
								37.48179,
								18.61409
							],
							[
								37.86276,
								18.36786
							],
							[
								38.41009,
								17.998307
							],
							[
								37.904,
								17.42754
							],
							[
								37.16747,
								17.26314
							],
							[
								36.85253,
								16.95655
							],
							[
								36.75389,
								16.29186
							],
							[
								36.32322,
								14.82249
							],
							[
								36.42951,
								14.42211
							],
							[
								36.27022,
								13.56333
							],
							[
								35.86363,
								12.57828
							],
							[
								35.26049,
								12.08286
							],
							[
								34.83163,
								11.31896
							],
							[
								34.73115,
								10.91017
							],
							[
								34.25745,
								10.63009
							],
							[
								33.96162,
								9.58358
							],
							[
								33.963393,
								9.464285
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SSD",
				"properties": {
					"name": "South Sudan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.963393,
								9.464285
							],
							[
								33.97498,
								8.68456
							],
							[
								33.8255,
								8.37916
							],
							[
								33.2948,
								8.35458
							],
							[
								32.95418,
								7.78497
							],
							[
								33.56829,
								7.71334
							],
							[
								34.0751,
								7.22595
							],
							[
								34.25032,
								6.82607
							],
							[
								34.70702,
								6.59422
							],
							[
								35.298007,
								5.506
							],
							[
								34.620196,
								4.847123
							],
							[
								34.005,
								4.249885
							],
							[
								33.39,
								3.79
							],
							[
								32.68642,
								3.79232
							],
							[
								31.88145,
								3.55827
							],
							[
								31.24556,
								3.7819
							],
							[
								30.83385,
								3.50917
							],
							[
								29.95349,
								4.1737
							],
							[
								29.715995,
								4.600805
							],
							[
								29.159078,
								4.389267
							],
							[
								28.696678,
								4.455077
							],
							[
								28.428994,
								4.287155
							],
							[
								27.979977,
								4.408413
							],
							[
								27.374226,
								5.233944
							],
							[
								27.213409,
								5.550953
							],
							[
								26.465909,
								5.946717
							],
							[
								26.213418,
								6.546603
							],
							[
								25.796648,
								6.979316
							],
							[
								25.124131,
								7.500085
							],
							[
								25.114932,
								7.825104
							],
							[
								24.567369,
								8.229188
							],
							[
								23.88698,
								8.61973
							],
							[
								24.194068,
								8.728696
							],
							[
								24.537415,
								8.917538
							],
							[
								24.794926,
								9.810241
							],
							[
								25.069604,
								10.27376
							],
							[
								25.790633,
								10.411099
							],
							[
								25.962307,
								10.136421
							],
							[
								26.477328,
								9.55273
							],
							[
								26.752006,
								9.466893
							],
							[
								27.112521,
								9.638567
							],
							[
								27.833551,
								9.604232
							],
							[
								27.97089,
								9.398224
							],
							[
								28.966597,
								9.398224
							],
							[
								29.000932,
								9.604232
							],
							[
								29.515953,
								9.793074
							],
							[
								29.618957,
								10.084919
							],
							[
								29.996639,
								10.290927
							],
							[
								30.837841,
								9.707237
							],
							[
								31.352862,
								9.810241
							],
							[
								31.850716,
								10.531271
							],
							[
								32.400072,
								11.080626
							],
							[
								32.314235,
								11.681484
							],
							[
								32.073892,
								11.97333
							],
							[
								32.67475,
								12.024832
							],
							[
								32.743419,
								12.248008
							],
							[
								33.206938,
								12.179338
							],
							[
								33.086766,
								11.441141
							],
							[
								33.206938,
								10.720112
							],
							[
								33.721959,
								10.325262
							],
							[
								33.842131,
								9.981915
							],
							[
								33.824963,
								9.484061
							],
							[
								33.963393,
								9.464285
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SEN",
				"properties": {
					"name": "Senegal"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-16.713729,
								13.594959
							],
							[
								-17.126107,
								14.373516
							],
							[
								-17.625043,
								14.729541
							],
							[
								-17.185173,
								14.919477
							],
							[
								-16.700706,
								15.621527
							],
							[
								-16.463098,
								16.135036
							],
							[
								-16.12069,
								16.455663
							],
							[
								-15.623666,
								16.369337
							],
							[
								-15.135737,
								16.587282
							],
							[
								-14.577348,
								16.598264
							],
							[
								-14.099521,
								16.304302
							],
							[
								-13.435738,
								16.039383
							],
							[
								-12.830658,
								15.303692
							],
							[
								-12.17075,
								14.616834
							],
							[
								-12.124887,
								13.994727
							],
							[
								-11.927716,
								13.422075
							],
							[
								-11.553398,
								13.141214
							],
							[
								-11.467899,
								12.754519
							],
							[
								-11.513943,
								12.442988
							],
							[
								-11.658301,
								12.386583
							],
							[
								-12.203565,
								12.465648
							],
							[
								-12.278599,
								12.35444
							],
							[
								-12.499051,
								12.33209
							],
							[
								-13.217818,
								12.575874
							],
							[
								-13.700476,
								12.586183
							],
							[
								-15.548477,
								12.62817
							],
							[
								-15.816574,
								12.515567
							],
							[
								-16.147717,
								12.547762
							],
							[
								-16.677452,
								12.384852
							],
							[
								-16.841525,
								13.151394
							],
							[
								-15.931296,
								13.130284
							],
							[
								-15.691001,
								13.270353
							],
							[
								-15.511813,
								13.27857
							],
							[
								-15.141163,
								13.509512
							],
							[
								-14.712197,
								13.298207
							],
							[
								-14.277702,
								13.280585
							],
							[
								-13.844963,
								13.505042
							],
							[
								-14.046992,
								13.794068
							],
							[
								-14.376714,
								13.62568
							],
							[
								-14.687031,
								13.630357
							],
							[
								-15.081735,
								13.876492
							],
							[
								-15.39877,
								13.860369
							],
							[
								-15.624596,
								13.623587
							],
							[
								-16.713729,
								13.594959
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SLB",
				"properties": {
					"name": "Solomon Islands"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									162.119025,
									-10.482719
								],
								[
									162.398646,
									-10.826367
								],
								[
									161.700032,
									-10.820011
								],
								[
									161.319797,
									-10.204751
								],
								[
									161.917383,
									-10.446701
								],
								[
									162.119025,
									-10.482719
								]
							]
						],
						[
							[
								[
									160.852229,
									-9.872937
								],
								[
									160.462588,
									-9.89521
								],
								[
									159.849447,
									-9.794027
								],
								[
									159.640003,
									-9.63998
								],
								[
									159.702945,
									-9.24295
								],
								[
									160.362956,
									-9.400304
								],
								[
									160.688518,
									-9.610162
								],
								[
									160.852229,
									-9.872937
								]
							]
						],
						[
							[
								[
									161.679982,
									-9.599982
								],
								[
									161.529397,
									-9.784312
								],
								[
									160.788253,
									-8.917543
								],
								[
									160.579997,
									-8.320009
								],
								[
									160.920028,
									-8.320009
								],
								[
									161.280006,
									-9.120011
								],
								[
									161.679982,
									-9.599982
								]
							]
						],
						[
							[
								[
									159.875027,
									-8.33732
								],
								[
									159.917402,
									-8.53829
								],
								[
									159.133677,
									-8.114181
								],
								[
									158.586114,
									-7.754824
								],
								[
									158.21115,
									-7.421872
								],
								[
									158.359978,
									-7.320018
								],
								[
									158.820001,
									-7.560003
								],
								[
									159.640003,
									-8.020027
								],
								[
									159.875027,
									-8.33732
								]
							]
						],
						[
							[
								[
									157.538426,
									-7.34782
								],
								[
									157.33942,
									-7.404767
								],
								[
									156.90203,
									-7.176874
								],
								[
									156.491358,
									-6.765943
								],
								[
									156.542828,
									-6.599338
								],
								[
									157.14,
									-7.021638
								],
								[
									157.538426,
									-7.34782
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SLE",
				"properties": {
					"name": "Sierra Leone"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-11.438779,
								6.785917
							],
							[
								-11.708195,
								6.860098
							],
							[
								-12.428099,
								7.262942
							],
							[
								-12.949049,
								7.798646
							],
							[
								-13.124025,
								8.163946
							],
							[
								-13.24655,
								8.903049
							],
							[
								-12.711958,
								9.342712
							],
							[
								-12.596719,
								9.620188
							],
							[
								-12.425929,
								9.835834
							],
							[
								-12.150338,
								9.858572
							],
							[
								-11.917277,
								10.046984
							],
							[
								-11.117481,
								10.045873
							],
							[
								-10.839152,
								9.688246
							],
							[
								-10.622395,
								9.26791
							],
							[
								-10.65477,
								8.977178
							],
							[
								-10.494315,
								8.715541
							],
							[
								-10.505477,
								8.348896
							],
							[
								-10.230094,
								8.406206
							],
							[
								-10.695595,
								7.939464
							],
							[
								-11.146704,
								7.396706
							],
							[
								-11.199802,
								7.105846
							],
							[
								-11.438779,
								6.785917
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SLV",
				"properties": {
					"name": "El Salvador"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-87.793111,
								13.38448
							],
							[
								-87.904112,
								13.149017
							],
							[
								-88.483302,
								13.163951
							],
							[
								-88.843228,
								13.259734
							],
							[
								-89.256743,
								13.458533
							],
							[
								-89.812394,
								13.520622
							],
							[
								-90.095555,
								13.735338
							],
							[
								-90.064678,
								13.88197
							],
							[
								-89.721934,
								14.134228
							],
							[
								-89.534219,
								14.244816
							],
							[
								-89.587343,
								14.362586
							],
							[
								-89.353326,
								14.424133
							],
							[
								-89.058512,
								14.340029
							],
							[
								-88.843073,
								14.140507
							],
							[
								-88.541231,
								13.980155
							],
							[
								-88.503998,
								13.845486
							],
							[
								-88.065343,
								13.964626
							],
							[
								-87.859515,
								13.893312
							],
							[
								-87.723503,
								13.78505
							],
							[
								-87.793111,
								13.38448
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "-99",
				"properties": {
					"name": "Somaliland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								48.93813,
								9.451749
							],
							[
								48.486736,
								8.837626
							],
							[
								47.78942,
								8.003
							],
							[
								46.948328,
								7.996877
							],
							[
								43.67875,
								9.18358
							],
							[
								43.296975,
								9.540477
							],
							[
								42.92812,
								10.02194
							],
							[
								42.55876,
								10.57258
							],
							[
								42.776852,
								10.926879
							],
							[
								43.145305,
								11.46204
							],
							[
								43.47066,
								11.27771
							],
							[
								43.666668,
								10.864169
							],
							[
								44.117804,
								10.445538
							],
							[
								44.614259,
								10.442205
							],
							[
								45.556941,
								10.698029
							],
							[
								46.645401,
								10.816549
							],
							[
								47.525658,
								11.127228
							],
							[
								48.021596,
								11.193064
							],
							[
								48.378784,
								11.375482
							],
							[
								48.948206,
								11.410622
							],
							[
								48.942005,
								11.394266
							],
							[
								48.938491,
								10.982327
							],
							[
								48.938233,
								9.9735
							],
							[
								48.93813,
								9.451749
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SOM",
				"properties": {
					"name": "Somalia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								49.72862,
								11.5789
							],
							[
								50.25878,
								11.67957
							],
							[
								50.73202,
								12.0219
							],
							[
								51.1112,
								12.02464
							],
							[
								51.13387,
								11.74815
							],
							[
								51.04153,
								11.16651
							],
							[
								51.04531,
								10.6409
							],
							[
								50.83418,
								10.27972
							],
							[
								50.55239,
								9.19874
							],
							[
								50.07092,
								8.08173
							],
							[
								49.4527,
								6.80466
							],
							[
								48.59455,
								5.33911
							],
							[
								47.74079,
								4.2194
							],
							[
								46.56476,
								2.85529
							],
							[
								45.56399,
								2.04576
							],
							[
								44.06815,
								1.05283
							],
							[
								43.13597,
								0.2922
							],
							[
								42.04157,
								-0.91916
							],
							[
								41.81095,
								-1.44647
							],
							[
								41.58513,
								-1.68325
							],
							[
								40.993,
								-0.85829
							],
							[
								40.98105,
								2.78452
							],
							[
								41.855083,
								3.918912
							],
							[
								42.12861,
								4.23413
							],
							[
								42.76967,
								4.25259
							],
							[
								43.66087,
								4.95755
							],
							[
								44.9636,
								5.00162
							],
							[
								47.78942,
								8.003
							],
							[
								48.486736,
								8.837626
							],
							[
								48.93813,
								9.451749
							],
							[
								48.938233,
								9.9735
							],
							[
								48.938491,
								10.982327
							],
							[
								48.942005,
								11.394266
							],
							[
								48.948205,
								11.410617
							],
							[
								49.26776,
								11.43033
							],
							[
								49.72862,
								11.5789
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SRB",
				"properties": {
					"name": "Republic of Serbia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								20.874313,
								45.416375
							],
							[
								21.483526,
								45.18117
							],
							[
								21.562023,
								44.768947
							],
							[
								22.145088,
								44.478422
							],
							[
								22.459022,
								44.702517
							],
							[
								22.705726,
								44.578003
							],
							[
								22.474008,
								44.409228
							],
							[
								22.65715,
								44.234923
							],
							[
								22.410446,
								44.008063
							],
							[
								22.500157,
								43.642814
							],
							[
								22.986019,
								43.211161
							],
							[
								22.604801,
								42.898519
							],
							[
								22.436595,
								42.580321
							],
							[
								22.545012,
								42.461362
							],
							[
								22.380526,
								42.32026
							],
							[
								21.91708,
								42.30364
							],
							[
								21.576636,
								42.245224
							],
							[
								21.54332,
								42.32025
							],
							[
								21.66292,
								42.43922
							],
							[
								21.77505,
								42.6827
							],
							[
								21.63302,
								42.67717
							],
							[
								21.43866,
								42.86255
							],
							[
								21.27421,
								42.90959
							],
							[
								21.143395,
								43.068685
							],
							[
								20.95651,
								43.13094
							],
							[
								20.81448,
								43.27205
							],
							[
								20.63508,
								43.21671
							],
							[
								20.49679,
								42.88469
							],
							[
								20.25758,
								42.81275
							],
							[
								20.3398,
								42.89852
							],
							[
								19.95857,
								43.10604
							],
							[
								19.63,
								43.21378
							],
							[
								19.48389,
								43.35229
							],
							[
								19.21852,
								43.52384
							],
							[
								19.454,
								43.5681
							],
							[
								19.59976,
								44.03847
							],
							[
								19.11761,
								44.42307
							],
							[
								19.36803,
								44.863
							],
							[
								19.00548,
								44.86023
							],
							[
								19.390476,
								45.236516
							],
							[
								19.072769,
								45.521511
							],
							[
								18.82982,
								45.90888
							],
							[
								19.596045,
								46.17173
							],
							[
								20.220192,
								46.127469
							],
							[
								20.762175,
								45.734573
							],
							[
								20.874313,
								45.416375
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SUR",
				"properties": {
					"name": "Suriname"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-57.147436,
								5.97315
							],
							[
								-55.949318,
								5.772878
							],
							[
								-55.84178,
								5.953125
							],
							[
								-55.03325,
								6.025291
							],
							[
								-53.958045,
								5.756548
							],
							[
								-54.478633,
								4.896756
							],
							[
								-54.399542,
								4.212611
							],
							[
								-54.006931,
								3.620038
							],
							[
								-54.181726,
								3.18978
							],
							[
								-54.269705,
								2.732392
							],
							[
								-54.524754,
								2.311849
							],
							[
								-55.097587,
								2.523748
							],
							[
								-55.569755,
								2.421506
							],
							[
								-55.973322,
								2.510364
							],
							[
								-56.073342,
								2.220795
							],
							[
								-55.9056,
								2.021996
							],
							[
								-55.995698,
								1.817667
							],
							[
								-56.539386,
								1.899523
							],
							[
								-57.150098,
								2.768927
							],
							[
								-57.281433,
								3.333492
							],
							[
								-57.601569,
								3.334655
							],
							[
								-58.044694,
								4.060864
							],
							[
								-57.86021,
								4.576801
							],
							[
								-57.914289,
								4.812626
							],
							[
								-57.307246,
								5.073567
							],
							[
								-57.147436,
								5.97315
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SVK",
				"properties": {
					"name": "Slovakia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								18.853144,
								49.49623
							],
							[
								18.909575,
								49.435846
							],
							[
								19.320713,
								49.571574
							],
							[
								19.825023,
								49.217125
							],
							[
								20.415839,
								49.431453
							],
							[
								20.887955,
								49.328772
							],
							[
								21.607808,
								49.470107
							],
							[
								22.558138,
								49.085738
							],
							[
								22.280842,
								48.825392
							],
							[
								22.085608,
								48.422264
							],
							[
								21.872236,
								48.319971
							],
							[
								20.801294,
								48.623854
							],
							[
								20.473562,
								48.56285
							],
							[
								20.239054,
								48.327567
							],
							[
								19.769471,
								48.202691
							],
							[
								19.661364,
								48.266615
							],
							[
								19.174365,
								48.111379
							],
							[
								18.777025,
								48.081768
							],
							[
								18.696513,
								47.880954
							],
							[
								17.857133,
								47.758429
							],
							[
								17.488473,
								47.867466
							],
							[
								16.979667,
								48.123497
							],
							[
								16.879983,
								48.470013
							],
							[
								16.960288,
								48.596982
							],
							[
								17.101985,
								48.816969
							],
							[
								17.545007,
								48.800019
							],
							[
								17.886485,
								48.903475
							],
							[
								17.913512,
								48.996493
							],
							[
								18.104973,
								49.043983
							],
							[
								18.170498,
								49.271515
							],
							[
								18.399994,
								49.315001
							],
							[
								18.554971,
								49.495015
							],
							[
								18.853144,
								49.49623
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SVN",
				"properties": {
					"name": "Slovenia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								13.806475,
								46.509306
							],
							[
								14.632472,
								46.431817
							],
							[
								15.137092,
								46.658703
							],
							[
								16.011664,
								46.683611
							],
							[
								16.202298,
								46.852386
							],
							[
								16.370505,
								46.841327
							],
							[
								16.564808,
								46.503751
							],
							[
								15.768733,
								46.238108
							],
							[
								15.67153,
								45.834154
							],
							[
								15.323954,
								45.731783
							],
							[
								15.327675,
								45.452316
							],
							[
								14.935244,
								45.471695
							],
							[
								14.595109,
								45.634941
							],
							[
								14.411968,
								45.466166
							],
							[
								13.71506,
								45.500324
							],
							[
								13.93763,
								45.591016
							],
							[
								13.69811,
								46.016778
							],
							[
								13.806475,
								46.509306
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SWE",
				"properties": {
					"name": "Sweden"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									22.183173,
									65.723741
								],
								[
									21.213517,
									65.026005
								],
								[
									21.369631,
									64.413588
								],
								[
									19.778876,
									63.609554
								],
								[
									17.847779,
									62.7494
								],
								[
									17.119555,
									61.341166
								],
								[
									17.831346,
									60.636583
								],
								[
									18.787722,
									60.081914
								],
								[
									17.869225,
									58.953766
								],
								[
									16.829185,
									58.719827
								],
								[
									16.44771,
									57.041118
								],
								[
									15.879786,
									56.104302
								],
								[
									14.666681,
									56.200885
								],
								[
									14.100721,
									55.407781
								],
								[
									12.942911,
									55.361737
								],
								[
									12.625101,
									56.30708
								],
								[
									11.787942,
									57.441817
								],
								[
									11.027369,
									58.856149
								],
								[
									11.468272,
									59.432393
								],
								[
									12.300366,
									60.117933
								],
								[
									12.631147,
									61.293572
								],
								[
									11.992064,
									61.800362
								],
								[
									11.930569,
									63.128318
								],
								[
									12.579935,
									64.066219
								],
								[
									13.571916,
									64.049114
								],
								[
									13.919905,
									64.445421
								],
								[
									13.55569,
									64.787028
								],
								[
									15.108411,
									66.193867
								],
								[
									16.108712,
									67.302456
								],
								[
									16.768879,
									68.013937
								],
								[
									17.729182,
									68.010552
								],
								[
									17.993868,
									68.567391
								],
								[
									19.87856,
									68.407194
								],
								[
									20.025269,
									69.065139
								],
								[
									20.645593,
									69.106247
								],
								[
									21.978535,
									68.616846
								],
								[
									23.539473,
									67.936009
								],
								[
									23.56588,
									66.396051
								],
								[
									23.903379,
									66.006927
								],
								[
									22.183173,
									65.723741
								]
							],
							[
								[
									17.061767,
									57.385783
								],
								[
									17.210083,
									57.326521
								],
								[
									16.430053,
									56.179196
								],
								[
									16.364135,
									56.556455
								],
								[
									17.061767,
									57.385783
								]
							],
							[
								[
									19.35791,
									57.958588
								],
								[
									18.8031,
									57.651279
								],
								[
									18.825073,
									57.444949
								],
								[
									18.995361,
									57.441993
								],
								[
									18.951416,
									57.370976
								],
								[
									18.693237,
									57.305756
								],
								[
									18.709716,
									57.204734
								],
								[
									18.462524,
									57.127295
								],
								[
									18.319702,
									56.926992
								],
								[
									18.105468,
									56.891003
								],
								[
									18.187866,
									57.109402
								],
								[
									18.072509,
									57.267163
								],
								[
									18.154907,
									57.394664
								],
								[
									18.094482,
									57.545312
								],
								[
									18.660278,
									57.929434
								],
								[
									19.039306,
									57.941098
								],
								[
									19.105224,
									57.993543
								],
								[
									19.374389,
									57.996454
								],
								[
									19.35791,
									57.958588
								]
							],
							[
								[
									20.846557,
									63.82371
								],
								[
									21.066284,
									63.829768
								],
								[
									20.9729,
									63.71567
								],
								[
									20.824584,
									63.579121
								],
								[
									20.695495,
									63.59134
								],
								[
									20.819091,
									63.714454
								],
								[
									20.799865,
									63.780059
								],
								[
									20.846557,
									63.82371
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SWZ",
				"properties": {
					"name": "Swaziland"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								32.071665,
								-26.73382
							],
							[
								31.86806,
								-27.177927
							],
							[
								31.282773,
								-27.285879
							],
							[
								30.685962,
								-26.743845
							],
							[
								30.676609,
								-26.398078
							],
							[
								30.949667,
								-26.022649
							],
							[
								31.04408,
								-25.731452
							],
							[
								31.333158,
								-25.660191
							],
							[
								31.837778,
								-25.843332
							],
							[
								31.985779,
								-26.29178
							],
							[
								32.071665,
								-26.73382
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "SYR",
				"properties": {
					"name": "Syria"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								38.792341,
								33.378686
							],
							[
								36.834062,
								32.312938
							],
							[
								35.719918,
								32.709192
							],
							[
								35.700798,
								32.716014
							],
							[
								35.836397,
								32.868123
							],
							[
								35.821101,
								33.277426
							],
							[
								36.06646,
								33.824912
							],
							[
								36.61175,
								34.201789
							],
							[
								36.448194,
								34.593935
							],
							[
								35.998403,
								34.644914
							],
							[
								35.905023,
								35.410009
							],
							[
								36.149763,
								35.821535
							],
							[
								36.41755,
								36.040617
							],
							[
								36.685389,
								36.259699
							],
							[
								36.739494,
								36.81752
							],
							[
								37.066761,
								36.623036
							],
							[
								38.167727,
								36.90121
							],
							[
								38.699891,
								36.712927
							],
							[
								39.52258,
								36.716054
							],
							[
								40.673259,
								37.091276
							],
							[
								41.212089,
								37.074352
							],
							[
								42.349591,
								37.229873
							],
							[
								41.837064,
								36.605854
							],
							[
								41.289707,
								36.358815
							],
							[
								41.383965,
								35.628317
							],
							[
								41.006159,
								34.419372
							],
							[
								38.792341,
								33.378686
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TCD",
				"properties": {
					"name": "Chad"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								14.495787,
								12.859396
							],
							[
								14.595781,
								13.330427
							],
							[
								13.954477,
								13.353449
							],
							[
								13.956699,
								13.996691
							],
							[
								13.540394,
								14.367134
							],
							[
								13.97217,
								15.68437
							],
							[
								15.247731,
								16.627306
							],
							[
								15.300441,
								17.92795
							],
							[
								15.685741,
								19.95718
							],
							[
								15.903247,
								20.387619
							],
							[
								15.487148,
								20.730415
							],
							[
								15.47106,
								21.04845
							],
							[
								15.096888,
								21.308519
							],
							[
								14.8513,
								22.86295
							],
							[
								15.86085,
								23.40972
							],
							[
								19.84926,
								21.49509
							],
							[
								23.83766,
								19.58047
							],
							[
								23.88689,
								15.61084
							],
							[
								23.02459,
								15.68072
							],
							[
								22.56795,
								14.94429
							],
							[
								22.30351,
								14.32682
							],
							[
								22.51202,
								14.09318
							],
							[
								22.18329,
								13.78648
							],
							[
								22.29658,
								13.37232
							],
							[
								22.03759,
								12.95546
							],
							[
								21.93681,
								12.58818
							],
							[
								22.28801,
								12.64605
							],
							[
								22.49762,
								12.26024
							],
							[
								22.50869,
								11.67936
							],
							[
								22.87622,
								11.38461
							],
							[
								22.864165,
								11.142395
							],
							[
								22.231129,
								10.971889
							],
							[
								21.723822,
								10.567056
							],
							[
								21.000868,
								9.475985
							],
							[
								20.059685,
								9.012706
							],
							[
								19.094008,
								9.074847
							],
							[
								18.81201,
								8.982915
							],
							[
								18.911022,
								8.630895
							],
							[
								18.389555,
								8.281304
							],
							[
								17.96493,
								7.890914
							],
							[
								16.705988,
								7.508328
							],
							[
								16.456185,
								7.734774
							],
							[
								16.290562,
								7.754307
							],
							[
								16.106232,
								7.497088
							],
							[
								15.27946,
								7.421925
							],
							[
								15.436092,
								7.692812
							],
							[
								15.120866,
								8.38215
							],
							[
								14.979996,
								8.796104
							],
							[
								14.544467,
								8.965861
							],
							[
								13.954218,
								9.549495
							],
							[
								14.171466,
								10.021378
							],
							[
								14.627201,
								9.920919
							],
							[
								14.909354,
								9.992129
							],
							[
								15.467873,
								9.982337
							],
							[
								14.923565,
								10.891325
							],
							[
								14.960152,
								11.555574
							],
							[
								14.89336,
								12.21905
							],
							[
								14.495787,
								12.859396
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TGO",
				"properties": {
					"name": "Togo"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								1.865241,
								6.142158
							],
							[
								1.060122,
								5.928837
							],
							[
								0.836931,
								6.279979
							],
							[
								0.570384,
								6.914359
							],
							[
								0.490957,
								7.411744
							],
							[
								0.712029,
								8.312465
							],
							[
								0.461192,
								8.677223
							],
							[
								0.365901,
								9.465004
							],
							[
								0.36758,
								10.191213
							],
							[
								-0.049785,
								10.706918
							],
							[
								0.023803,
								11.018682
							],
							[
								0.899563,
								10.997339
							],
							[
								0.772336,
								10.470808
							],
							[
								1.077795,
								10.175607
							],
							[
								1.425061,
								9.825395
							],
							[
								1.463043,
								9.334624
							],
							[
								1.664478,
								9.12859
							],
							[
								1.618951,
								6.832038
							],
							[
								1.865241,
								6.142158
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "THA",
				"properties": {
					"name": "Thailand"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								102.584932,
								12.186595
							],
							[
								101.687158,
								12.64574
							],
							[
								100.83181,
								12.627085
							],
							[
								100.978467,
								13.412722
							],
							[
								100.097797,
								13.406856
							],
							[
								100.018733,
								12.307001
							],
							[
								99.478921,
								10.846367
							],
							[
								99.153772,
								9.963061
							],
							[
								99.222399,
								9.239255
							],
							[
								99.873832,
								9.207862
							],
							[
								100.279647,
								8.295153
							],
							[
								100.459274,
								7.429573
							],
							[
								101.017328,
								6.856869
							],
							[
								101.623079,
								6.740622
							],
							[
								102.141187,
								6.221636
							],
							[
								101.814282,
								5.810808
							],
							[
								101.154219,
								5.691384
							],
							[
								101.075516,
								6.204867
							],
							[
								100.259596,
								6.642825
							],
							[
								100.085757,
								6.464489
							],
							[
								99.690691,
								6.848213
							],
							[
								99.519642,
								7.343454
							],
							[
								98.988253,
								7.907993
							],
							[
								98.503786,
								8.382305
							],
							[
								98.339662,
								7.794512
							],
							[
								98.150009,
								8.350007
							],
							[
								98.25915,
								8.973923
							],
							[
								98.553551,
								9.93296
							],
							[
								99.038121,
								10.960546
							],
							[
								99.587286,
								11.892763
							],
							[
								99.196354,
								12.804748
							],
							[
								99.212012,
								13.269294
							],
							[
								99.097755,
								13.827503
							],
							[
								98.430819,
								14.622028
							],
							[
								98.192074,
								15.123703
							],
							[
								98.537376,
								15.308497
							],
							[
								98.903348,
								16.177824
							],
							[
								98.493761,
								16.837836
							],
							[
								97.859123,
								17.567946
							],
							[
								97.375896,
								18.445438
							],
							[
								97.797783,
								18.62708
							],
							[
								98.253724,
								19.708203
							],
							[
								98.959676,
								19.752981
							],
							[
								99.543309,
								20.186598
							],
							[
								100.115988,
								20.41785
							],
							[
								100.548881,
								20.109238
							],
							[
								100.606294,
								19.508344
							],
							[
								101.282015,
								19.462585
							],
							[
								101.035931,
								18.408928
							],
							[
								101.059548,
								17.512497
							],
							[
								102.113592,
								18.109102
							],
							[
								102.413005,
								17.932782
							],
							[
								102.998706,
								17.961695
							],
							[
								103.200192,
								18.309632
							],
							[
								103.956477,
								18.240954
							],
							[
								104.716947,
								17.428859
							],
							[
								104.779321,
								16.441865
							],
							[
								105.589039,
								15.570316
							],
							[
								105.544338,
								14.723934
							],
							[
								105.218777,
								14.273212
							],
							[
								104.281418,
								14.416743
							],
							[
								102.988422,
								14.225721
							],
							[
								102.348099,
								13.394247
							],
							[
								102.584932,
								12.186595
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TJK",
				"properties": {
					"name": "Tajikistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								71.014198,
								40.244366
							],
							[
								70.648019,
								39.935754
							],
							[
								69.55961,
								40.103211
							],
							[
								69.464887,
								39.526683
							],
							[
								70.549162,
								39.604198
							],
							[
								71.784694,
								39.279463
							],
							[
								73.675379,
								39.431237
							],
							[
								73.928852,
								38.505815
							],
							[
								74.257514,
								38.606507
							],
							[
								74.864816,
								38.378846
							],
							[
								74.829986,
								37.990007
							],
							[
								74.980002,
								37.41999
							],
							[
								73.948696,
								37.421566
							],
							[
								73.260056,
								37.495257
							],
							[
								72.63689,
								37.047558
							],
							[
								72.193041,
								36.948288
							],
							[
								71.844638,
								36.738171
							],
							[
								71.448693,
								37.065645
							],
							[
								71.541918,
								37.905774
							],
							[
								71.239404,
								37.953265
							],
							[
								71.348131,
								38.258905
							],
							[
								70.806821,
								38.486282
							],
							[
								70.376304,
								38.138396
							],
							[
								70.270574,
								37.735165
							],
							[
								70.116578,
								37.588223
							],
							[
								69.518785,
								37.608997
							],
							[
								69.196273,
								37.151144
							],
							[
								68.859446,
								37.344336
							],
							[
								68.135562,
								37.023115
							],
							[
								67.83,
								37.144994
							],
							[
								68.392033,
								38.157025
							],
							[
								68.176025,
								38.901553
							],
							[
								67.44222,
								39.140144
							],
							[
								67.701429,
								39.580478
							],
							[
								68.536416,
								39.533453
							],
							[
								69.011633,
								40.086158
							],
							[
								69.329495,
								40.727824
							],
							[
								70.666622,
								40.960213
							],
							[
								70.45816,
								40.496495
							],
							[
								70.601407,
								40.218527
							],
							[
								71.014198,
								40.244366
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TKM",
				"properties": {
					"name": "Turkmenistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								61.210817,
								35.650072
							],
							[
								61.123071,
								36.491597
							],
							[
								60.377638,
								36.527383
							],
							[
								59.234762,
								37.412988
							],
							[
								58.436154,
								37.522309
							],
							[
								57.330434,
								38.029229
							],
							[
								56.619366,
								38.121394
							],
							[
								56.180375,
								37.935127
							],
							[
								55.511578,
								37.964117
							],
							[
								54.800304,
								37.392421
							],
							[
								53.921598,
								37.198918
							],
							[
								53.735511,
								37.906136
							],
							[
								53.880929,
								38.952093
							],
							[
								53.101028,
								39.290574
							],
							[
								53.357808,
								39.975286
							],
							[
								52.693973,
								40.033629
							],
							[
								52.915251,
								40.876523
							],
							[
								53.858139,
								40.631034
							],
							[
								54.736845,
								40.951015
							],
							[
								54.008311,
								41.551211
							],
							[
								53.721713,
								42.123191
							],
							[
								52.91675,
								41.868117
							],
							[
								52.814689,
								41.135371
							],
							[
								52.50246,
								41.783316
							],
							[
								52.944293,
								42.116034
							],
							[
								54.079418,
								42.324109
							],
							[
								54.755345,
								42.043971
							],
							[
								55.455251,
								41.259859
							],
							[
								55.968191,
								41.308642
							],
							[
								57.096391,
								41.32231
							],
							[
								56.932215,
								41.826026
							],
							[
								57.78653,
								42.170553
							],
							[
								58.629011,
								42.751551
							],
							[
								59.976422,
								42.223082
							],
							[
								60.083341,
								41.425146
							],
							[
								60.465953,
								41.220327
							],
							[
								61.547179,
								41.26637
							],
							[
								61.882714,
								41.084857
							],
							[
								62.37426,
								40.053886
							],
							[
								63.518015,
								39.363257
							],
							[
								64.170223,
								38.892407
							],
							[
								65.215999,
								38.402695
							],
							[
								66.54615,
								37.974685
							],
							[
								66.518607,
								37.362784
							],
							[
								66.217385,
								37.39379
							],
							[
								65.745631,
								37.661164
							],
							[
								65.588948,
								37.305217
							],
							[
								64.746105,
								37.111818
							],
							[
								64.546479,
								36.312073
							],
							[
								63.982896,
								36.007957
							],
							[
								63.193538,
								35.857166
							],
							[
								62.984662,
								35.404041
							],
							[
								62.230651,
								35.270664
							],
							[
								61.210817,
								35.650072
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TLS",
				"properties": {
					"name": "East Timor"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								124.968682,
								-8.89279
							],
							[
								125.086246,
								-8.656887
							],
							[
								125.947072,
								-8.432095
							],
							[
								126.644704,
								-8.398247
							],
							[
								126.957243,
								-8.273345
							],
							[
								127.335928,
								-8.397317
							],
							[
								126.967992,
								-8.668256
							],
							[
								125.925885,
								-9.106007
							],
							[
								125.08852,
								-9.393173
							],
							[
								125.07002,
								-9.089987
							],
							[
								124.968682,
								-8.89279
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TTO",
				"properties": {
					"name": "Trinidad and Tobago"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-61.68,
								10.76
							],
							[
								-61.105,
								10.89
							],
							[
								-60.895,
								10.855
							],
							[
								-60.935,
								10.11
							],
							[
								-61.77,
								10
							],
							[
								-61.95,
								10.09
							],
							[
								-61.66,
								10.365
							],
							[
								-61.68,
								10.76
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TUN",
				"properties": {
					"name": "Tunisia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								9.48214,
								30.307556
							],
							[
								9.055603,
								32.102692
							],
							[
								8.439103,
								32.506285
							],
							[
								8.430473,
								32.748337
							],
							[
								7.612642,
								33.344115
							],
							[
								7.524482,
								34.097376
							],
							[
								8.140981,
								34.655146
							],
							[
								8.376368,
								35.479876
							],
							[
								8.217824,
								36.433177
							],
							[
								8.420964,
								36.946427
							],
							[
								9.509994,
								37.349994
							],
							[
								10.210002,
								37.230002
							],
							[
								10.18065,
								36.724038
							],
							[
								11.028867,
								37.092103
							],
							[
								11.100026,
								36.899996
							],
							[
								10.600005,
								36.41
							],
							[
								10.593287,
								35.947444
							],
							[
								10.939519,
								35.698984
							],
							[
								10.807847,
								34.833507
							],
							[
								10.149593,
								34.330773
							],
							[
								10.339659,
								33.785742
							],
							[
								10.856836,
								33.76874
							],
							[
								11.108501,
								33.293343
							],
							[
								11.488787,
								33.136996
							],
							[
								11.432253,
								32.368903
							],
							[
								10.94479,
								32.081815
							],
							[
								10.636901,
								31.761421
							],
							[
								9.950225,
								31.37607
							],
							[
								10.056575,
								30.961831
							],
							[
								9.970017,
								30.539325
							],
							[
								9.48214,
								30.307556
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TUR",
				"properties": {
					"name": "Turkey"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									36.913127,
									41.335358
								],
								[
									38.347665,
									40.948586
								],
								[
									39.512607,
									41.102763
								],
								[
									40.373433,
									41.013673
								],
								[
									41.554084,
									41.535656
								],
								[
									42.619549,
									41.583173
								],
								[
									43.582746,
									41.092143
								],
								[
									43.752658,
									40.740201
								],
								[
									43.656436,
									40.253564
								],
								[
									44.400009,
									40.005
								],
								[
									44.79399,
									39.713003
								],
								[
									44.109225,
									39.428136
								],
								[
									44.421403,
									38.281281
								],
								[
									44.225756,
									37.971584
								],
								[
									44.772699,
									37.170445
								],
								[
									44.293452,
									37.001514
								],
								[
									43.942259,
									37.256228
								],
								[
									42.779126,
									37.385264
								],
								[
									42.349591,
									37.229873
								],
								[
									41.212089,
									37.074352
								],
								[
									40.673259,
									37.091276
								],
								[
									39.52258,
									36.716054
								],
								[
									38.699891,
									36.712927
								],
								[
									38.167727,
									36.90121
								],
								[
									37.066761,
									36.623036
								],
								[
									36.739494,
									36.81752
								],
								[
									36.685389,
									36.259699
								],
								[
									36.41755,
									36.040617
								],
								[
									36.149763,
									35.821535
								],
								[
									35.782085,
									36.274995
								],
								[
									36.160822,
									36.650606
								],
								[
									35.550936,
									36.565443
								],
								[
									34.714553,
									36.795532
								],
								[
									34.026895,
									36.21996
								],
								[
									32.509158,
									36.107564
								],
								[
									31.699595,
									36.644275
								],
								[
									30.621625,
									36.677865
								],
								[
									30.391096,
									36.262981
								],
								[
									29.699976,
									36.144357
								],
								[
									28.732903,
									36.676831
								],
								[
									27.641187,
									36.658822
								],
								[
									27.048768,
									37.653361
								],
								[
									26.318218,
									38.208133
								],
								[
									26.8047,
									38.98576
								],
								[
									26.170785,
									39.463612
								],
								[
									27.28002,
									40.420014
								],
								[
									28.819978,
									40.460011
								],
								[
									29.240004,
									41.219991
								],
								[
									31.145934,
									41.087622
								],
								[
									32.347979,
									41.736264
								],
								[
									33.513283,
									42.01896
								],
								[
									35.167704,
									42.040225
								],
								[
									36.913127,
									41.335358
								]
							]
						],
						[
							[
								[
									27.192377,
									40.690566
								],
								[
									26.358009,
									40.151994
								],
								[
									26.043351,
									40.617754
								],
								[
									26.056942,
									40.824123
								],
								[
									26.294602,
									40.936261
								],
								[
									26.604196,
									41.562115
								],
								[
									26.117042,
									41.826905
								],
								[
									27.135739,
									42.141485
								],
								[
									27.99672,
									42.007359
								],
								[
									28.115525,
									41.622886
								],
								[
									28.988443,
									41.299934
								],
								[
									28.806438,
									41.054962
								],
								[
									27.619017,
									40.999823
								],
								[
									27.192377,
									40.690566
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TWN",
				"properties": {
					"name": "Taiwan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								121.777818,
								24.394274
							],
							[
								121.175632,
								22.790857
							],
							[
								120.74708,
								21.970571
							],
							[
								120.220083,
								22.814861
							],
							[
								120.106189,
								23.556263
							],
							[
								120.69468,
								24.538451
							],
							[
								121.495044,
								25.295459
							],
							[
								121.951244,
								24.997596
							],
							[
								121.777818,
								24.394274
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "TZA",
				"properties": {
					"name": "United Republic of Tanzania"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								33.903711,
								-0.95
							],
							[
								34.07262,
								-1.05982
							],
							[
								37.69869,
								-3.09699
							],
							[
								37.7669,
								-3.67712
							],
							[
								39.20222,
								-4.67677
							],
							[
								38.74054,
								-5.90895
							],
							[
								38.79977,
								-6.47566
							],
							[
								39.44,
								-6.84
							],
							[
								39.47,
								-7.1
							],
							[
								39.19469,
								-7.7039
							],
							[
								39.25203,
								-8.00781
							],
							[
								39.18652,
								-8.48551
							],
							[
								39.53574,
								-9.11237
							],
							[
								39.9496,
								-10.0984
							],
							[
								40.31659,
								-10.3171
							],
							[
								39.521,
								-10.89688
							],
							[
								38.427557,
								-11.285202
							],
							[
								37.82764,
								-11.26879
							],
							[
								37.47129,
								-11.56876
							],
							[
								36.775151,
								-11.594537
							],
							[
								36.514082,
								-11.720938
							],
							[
								35.312398,
								-11.439146
							],
							[
								34.559989,
								-11.52002
							],
							[
								34.28,
								-10.16
							],
							[
								33.940838,
								-9.693674
							],
							[
								33.73972,
								-9.41715
							],
							[
								32.759375,
								-9.230599
							],
							[
								32.191865,
								-8.930359
							],
							[
								31.556348,
								-8.762049
							],
							[
								31.157751,
								-8.594579
							],
							[
								30.74,
								-8.34
							],
							[
								30.2,
								-7.08
							],
							[
								29.62,
								-6.52
							],
							[
								29.419993,
								-5.939999
							],
							[
								29.519987,
								-5.419979
							],
							[
								29.339998,
								-4.499983
							],
							[
								29.753512,
								-4.452389
							],
							[
								30.11632,
								-4.09012
							],
							[
								30.50554,
								-3.56858
							],
							[
								30.75224,
								-3.35931
							],
							[
								30.74301,
								-3.03431
							],
							[
								30.52766,
								-2.80762
							],
							[
								30.46967,
								-2.41383
							],
							[
								30.758309,
								-2.28725
							],
							[
								30.816135,
								-1.698914
							],
							[
								30.419105,
								-1.134659
							],
							[
								30.76986,
								-1.01455
							],
							[
								31.86617,
								-1.02736
							],
							[
								33.903711,
								-0.95
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "UGA",
				"properties": {
					"name": "Uganda"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.86617,
								-1.02736
							],
							[
								30.76986,
								-1.01455
							],
							[
								30.419105,
								-1.134659
							],
							[
								29.821519,
								-1.443322
							],
							[
								29.579466,
								-1.341313
							],
							[
								29.587838,
								-0.587406
							],
							[
								29.8195,
								-0.2053
							],
							[
								29.875779,
								0.59738
							],
							[
								30.086154,
								1.062313
							],
							[
								30.468508,
								1.583805
							],
							[
								30.85267,
								1.849396
							],
							[
								31.174149,
								2.204465
							],
							[
								30.77332,
								2.33989
							],
							[
								30.83385,
								3.50917
							],
							[
								31.24556,
								3.7819
							],
							[
								31.88145,
								3.55827
							],
							[
								32.68642,
								3.79232
							],
							[
								33.39,
								3.79
							],
							[
								34.005,
								4.249885
							],
							[
								34.47913,
								3.5556
							],
							[
								34.59607,
								3.05374
							],
							[
								35.03599,
								1.90584
							],
							[
								34.6721,
								1.17694
							],
							[
								34.18,
								0.515
							],
							[
								33.893569,
								0.109814
							],
							[
								33.903711,
								-0.95
							],
							[
								31.86617,
								-1.02736
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "UKR",
				"properties": {
					"name": "Ukraine"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.785998,
								52.101678
							],
							[
								32.159412,
								52.061267
							],
							[
								32.412058,
								52.288695
							],
							[
								32.715761,
								52.238465
							],
							[
								33.7527,
								52.335075
							],
							[
								34.391731,
								51.768882
							],
							[
								34.141978,
								51.566413
							],
							[
								34.224816,
								51.255993
							],
							[
								35.022183,
								51.207572
							],
							[
								35.377924,
								50.773955
							],
							[
								35.356116,
								50.577197
							],
							[
								36.626168,
								50.225591
							],
							[
								37.39346,
								50.383953
							],
							[
								38.010631,
								49.915662
							],
							[
								38.594988,
								49.926462
							],
							[
								40.069058,
								49.601055
							],
							[
								40.080789,
								49.30743
							],
							[
								39.674664,
								48.783818
							],
							[
								39.895632,
								48.232405
							],
							[
								39.738278,
								47.898937
							],
							[
								38.770585,
								47.825608
							],
							[
								38.255112,
								47.5464
							],
							[
								38.223538,
								47.10219
							],
							[
								37.425137,
								47.022221
							],
							[
								36.759855,
								46.6987
							],
							[
								35.823685,
								46.645964
							],
							[
								34.962342,
								46.273197
							],
							[
								35.020788,
								45.651219
							],
							[
								35.510009,
								45.409993
							],
							[
								36.529998,
								45.46999
							],
							[
								36.334713,
								45.113216
							],
							[
								35.239999,
								44.939996
							],
							[
								33.882511,
								44.361479
							],
							[
								33.326421,
								44.564877
							],
							[
								33.546924,
								45.034771
							],
							[
								32.454174,
								45.327466
							],
							[
								32.630804,
								45.519186
							],
							[
								33.588162,
								45.851569
							],
							[
								33.298567,
								46.080598
							],
							[
								31.74414,
								46.333348
							],
							[
								31.675307,
								46.706245
							],
							[
								30.748749,
								46.5831
							],
							[
								30.377609,
								46.03241
							],
							[
								29.603289,
								45.293308
							],
							[
								29.149725,
								45.464925
							],
							[
								28.679779,
								45.304031
							],
							[
								28.233554,
								45.488283
							],
							[
								28.485269,
								45.596907
							],
							[
								28.659987,
								45.939987
							],
							[
								28.933717,
								46.25883
							],
							[
								28.862972,
								46.437889
							],
							[
								29.072107,
								46.517678
							],
							[
								29.170654,
								46.379262
							],
							[
								29.759972,
								46.349988
							],
							[
								30.024659,
								46.423937
							],
							[
								29.83821,
								46.525326
							],
							[
								29.908852,
								46.674361
							],
							[
								29.559674,
								46.928583
							],
							[
								29.415135,
								47.346645
							],
							[
								29.050868,
								47.510227
							],
							[
								29.122698,
								47.849095
							],
							[
								28.670891,
								48.118149
							],
							[
								28.259547,
								48.155562
							],
							[
								27.522537,
								48.467119
							],
							[
								26.857824,
								48.368211
							],
							[
								26.619337,
								48.220726
							],
							[
								26.19745,
								48.220881
							],
							[
								25.945941,
								47.987149
							],
							[
								25.207743,
								47.891056
							],
							[
								24.866317,
								47.737526
							],
							[
								24.402056,
								47.981878
							],
							[
								23.760958,
								47.985598
							],
							[
								23.142236,
								48.096341
							],
							[
								22.710531,
								47.882194
							],
							[
								22.64082,
								48.15024
							],
							[
								22.085608,
								48.422264
							],
							[
								22.280842,
								48.825392
							],
							[
								22.558138,
								49.085738
							],
							[
								22.776419,
								49.027395
							],
							[
								22.51845,
								49.476774
							],
							[
								23.426508,
								50.308506
							],
							[
								23.922757,
								50.424881
							],
							[
								24.029986,
								50.705407
							],
							[
								23.527071,
								51.578454
							],
							[
								24.005078,
								51.617444
							],
							[
								24.553106,
								51.888461
							],
							[
								25.327788,
								51.910656
							],
							[
								26.337959,
								51.832289
							],
							[
								27.454066,
								51.592303
							],
							[
								28.241615,
								51.572227
							],
							[
								28.617613,
								51.427714
							],
							[
								28.992835,
								51.602044
							],
							[
								29.254938,
								51.368234
							],
							[
								30.157364,
								51.416138
							],
							[
								30.555117,
								51.319503
							],
							[
								30.619454,
								51.822806
							],
							[
								30.927549,
								52.042353
							],
							[
								31.785998,
								52.101678
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "URY",
				"properties": {
					"name": "Uruguay"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-57.625133,
								-30.216295
							],
							[
								-56.976026,
								-30.109686
							],
							[
								-55.973245,
								-30.883076
							],
							[
								-55.60151,
								-30.853879
							],
							[
								-54.572452,
								-31.494511
							],
							[
								-53.787952,
								-32.047243
							],
							[
								-53.209589,
								-32.727666
							],
							[
								-53.650544,
								-33.202004
							],
							[
								-53.373662,
								-33.768378
							],
							[
								-53.806426,
								-34.396815
							],
							[
								-54.935866,
								-34.952647
							],
							[
								-55.67409,
								-34.752659
							],
							[
								-56.215297,
								-34.859836
							],
							[
								-57.139685,
								-34.430456
							],
							[
								-57.817861,
								-34.462547
							],
							[
								-58.427074,
								-33.909454
							],
							[
								-58.349611,
								-33.263189
							],
							[
								-58.132648,
								-33.040567
							],
							[
								-58.14244,
								-32.044504
							],
							[
								-57.874937,
								-31.016556
							],
							[
								-57.625133,
								-30.216295
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "USA",
				"properties": {
					"name": "United States of America"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									-155.54211,
									19.08348
								],
								[
									-155.68817,
									18.91619
								],
								[
									-155.93665,
									19.05939
								],
								[
									-155.90806,
									19.33888
								],
								[
									-156.07347,
									19.70294
								],
								[
									-156.02368,
									19.81422
								],
								[
									-155.85008,
									19.97729
								],
								[
									-155.91907,
									20.17395
								],
								[
									-155.86108,
									20.26721
								],
								[
									-155.78505,
									20.2487
								],
								[
									-155.40214,
									20.07975
								],
								[
									-155.22452,
									19.99302
								],
								[
									-155.06226,
									19.8591
								],
								[
									-154.80741,
									19.50871
								],
								[
									-154.83147,
									19.45328
								],
								[
									-155.22217,
									19.23972
								],
								[
									-155.54211,
									19.08348
								]
							]
						],
						[
							[
								[
									-156.07926,
									20.64397
								],
								[
									-156.41445,
									20.57241
								],
								[
									-156.58673,
									20.783
								],
								[
									-156.70167,
									20.8643
								],
								[
									-156.71055,
									20.92676
								],
								[
									-156.61258,
									21.01249
								],
								[
									-156.25711,
									20.91745
								],
								[
									-155.99566,
									20.76404
								],
								[
									-156.07926,
									20.64397
								]
							]
						],
						[
							[
								[
									-156.75824,
									21.17684
								],
								[
									-156.78933,
									21.06873
								],
								[
									-157.32521,
									21.09777
								],
								[
									-157.25027,
									21.21958
								],
								[
									-156.75824,
									21.17684
								]
							]
						],
						[
							[
								[
									-157.65283,
									21.32217
								],
								[
									-157.70703,
									21.26442
								],
								[
									-157.7786,
									21.27729
								],
								[
									-158.12667,
									21.31244
								],
								[
									-158.2538,
									21.53919
								],
								[
									-158.29265,
									21.57912
								],
								[
									-158.0252,
									21.71696
								],
								[
									-157.94161,
									21.65272
								],
								[
									-157.65283,
									21.32217
								]
							]
						],
						[
							[
								[
									-159.34512,
									21.982
								],
								[
									-159.46372,
									21.88299
								],
								[
									-159.80051,
									22.06533
								],
								[
									-159.74877,
									22.1382
								],
								[
									-159.5962,
									22.23618
								],
								[
									-159.36569,
									22.21494
								],
								[
									-159.34512,
									21.982
								]
							]
						],
						[
							[
								[
									-94.81758,
									49.38905
								],
								[
									-94.64,
									48.84
								],
								[
									-94.32914,
									48.67074
								],
								[
									-93.63087,
									48.60926
								],
								[
									-92.61,
									48.45
								],
								[
									-91.64,
									48.14
								],
								[
									-90.83,
									48.27
								],
								[
									-89.6,
									48.01
								],
								[
									-89.272917,
									48.019808
								],
								[
									-88.378114,
									48.302918
								],
								[
									-87.439793,
									47.94
								],
								[
									-86.461991,
									47.553338
								],
								[
									-85.652363,
									47.220219
								],
								[
									-84.87608,
									46.900083
								],
								[
									-84.779238,
									46.637102
								],
								[
									-84.543749,
									46.538684
								],
								[
									-84.6049,
									46.4396
								],
								[
									-84.3367,
									46.40877
								],
								[
									-84.14212,
									46.512226
								],
								[
									-84.091851,
									46.275419
								],
								[
									-83.890765,
									46.116927
								],
								[
									-83.616131,
									46.116927
								],
								[
									-83.469551,
									45.994686
								],
								[
									-83.592851,
									45.816894
								],
								[
									-82.550925,
									45.347517
								],
								[
									-82.337763,
									44.44
								],
								[
									-82.137642,
									43.571088
								],
								[
									-82.43,
									42.98
								],
								[
									-82.9,
									42.43
								],
								[
									-83.12,
									42.08
								],
								[
									-83.142,
									41.975681
								],
								[
									-83.02981,
									41.832796
								],
								[
									-82.690089,
									41.675105
								],
								[
									-82.439278,
									41.675105
								],
								[
									-81.277747,
									42.209026
								],
								[
									-80.247448,
									42.3662
								],
								[
									-78.939362,
									42.863611
								],
								[
									-78.92,
									42.965
								],
								[
									-79.01,
									43.27
								],
								[
									-79.171674,
									43.466339
								],
								[
									-78.72028,
									43.625089
								],
								[
									-77.737885,
									43.629056
								],
								[
									-76.820034,
									43.628784
								],
								[
									-76.5,
									44.018459
								],
								[
									-76.375,
									44.09631
								],
								[
									-75.31821,
									44.81645
								],
								[
									-74.867,
									45.00048
								],
								[
									-73.34783,
									45.00738
								],
								[
									-71.50506,
									45.0082
								],
								[
									-71.405,
									45.255
								],
								[
									-71.08482,
									45.30524
								],
								[
									-70.66,
									45.46
								],
								[
									-70.305,
									45.915
								],
								[
									-69.99997,
									46.69307
								],
								[
									-69.237216,
									47.447781
								],
								[
									-68.905,
									47.185
								],
								[
									-68.23444,
									47.35486
								],
								[
									-67.79046,
									47.06636
								],
								[
									-67.79134,
									45.70281
								],
								[
									-67.13741,
									45.13753
								],
								[
									-66.96466,
									44.8097
								],
								[
									-68.03252,
									44.3252
								],
								[
									-69.06,
									43.98
								],
								[
									-70.11617,
									43.68405
								],
								[
									-70.645476,
									43.090238
								],
								[
									-70.81489,
									42.8653
								],
								[
									-70.825,
									42.335
								],
								[
									-70.495,
									41.805
								],
								[
									-70.08,
									41.78
								],
								[
									-70.185,
									42.145
								],
								[
									-69.88497,
									41.92283
								],
								[
									-69.96503,
									41.63717
								],
								[
									-70.64,
									41.475
								],
								[
									-71.12039,
									41.49445
								],
								[
									-71.86,
									41.32
								],
								[
									-72.295,
									41.27
								],
								[
									-72.87643,
									41.22065
								],
								[
									-73.71,
									40.931102
								],
								[
									-72.24126,
									41.11948
								],
								[
									-71.945,
									40.93
								],
								[
									-73.345,
									40.63
								],
								[
									-73.982,
									40.628
								],
								[
									-73.952325,
									40.75075
								],
								[
									-74.25671,
									40.47351
								],
								[
									-73.96244,
									40.42763
								],
								[
									-74.17838,
									39.70926
								],
								[
									-74.90604,
									38.93954
								],
								[
									-74.98041,
									39.1964
								],
								[
									-75.20002,
									39.24845
								],
								[
									-75.52805,
									39.4985
								],
								[
									-75.32,
									38.96
								],
								[
									-75.071835,
									38.782032
								],
								[
									-75.05673,
									38.40412
								],
								[
									-75.37747,
									38.01551
								],
								[
									-75.94023,
									37.21689
								],
								[
									-76.03127,
									37.2566
								],
								[
									-75.72205,
									37.93705
								],
								[
									-76.23287,
									38.319215
								],
								[
									-76.35,
									39.15
								],
								[
									-76.542725,
									38.717615
								],
								[
									-76.32933,
									38.08326
								],
								[
									-76.989998,
									38.239992
								],
								[
									-76.30162,
									37.917945
								],
								[
									-76.25874,
									36.9664
								],
								[
									-75.9718,
									36.89726
								],
								[
									-75.86804,
									36.55125
								],
								[
									-75.72749,
									35.55074
								],
								[
									-76.36318,
									34.80854
								],
								[
									-77.397635,
									34.51201
								],
								[
									-78.05496,
									33.92547
								],
								[
									-78.55435,
									33.86133
								],
								[
									-79.06067,
									33.49395
								],
								[
									-79.20357,
									33.15839
								],
								[
									-80.301325,
									32.509355
								],
								[
									-80.86498,
									32.0333
								],
								[
									-81.33629,
									31.44049
								],
								[
									-81.49042,
									30.72999
								],
								[
									-81.31371,
									30.03552
								],
								[
									-80.98,
									29.18
								],
								[
									-80.535585,
									28.47213
								],
								[
									-80.53,
									28.04
								],
								[
									-80.056539,
									26.88
								],
								[
									-80.088015,
									26.205765
								],
								[
									-80.13156,
									25.816775
								],
								[
									-80.38103,
									25.20616
								],
								[
									-80.68,
									25.08
								],
								[
									-81.17213,
									25.20126
								],
								[
									-81.33,
									25.64
								],
								[
									-81.71,
									25.87
								],
								[
									-82.24,
									26.73
								],
								[
									-82.70515,
									27.49504
								],
								[
									-82.85526,
									27.88624
								],
								[
									-82.65,
									28.55
								],
								[
									-82.93,
									29.1
								],
								[
									-83.70959,
									29.93656
								],
								[
									-84.1,
									30.09
								],
								[
									-85.10882,
									29.63615
								],
								[
									-85.28784,
									29.68612
								],
								[
									-85.7731,
									30.15261
								],
								[
									-86.4,
									30.4
								],
								[
									-87.53036,
									30.27433
								],
								[
									-88.41782,
									30.3849
								],
								[
									-89.18049,
									30.31598
								],
								[
									-89.593831,
									30.159994
								],
								[
									-89.413735,
									29.89419
								],
								[
									-89.43,
									29.48864
								],
								[
									-89.21767,
									29.29108
								],
								[
									-89.40823,
									29.15961
								],
								[
									-89.77928,
									29.30714
								],
								[
									-90.15463,
									29.11743
								],
								[
									-90.880225,
									29.148535
								],
								[
									-91.626785,
									29.677
								],
								[
									-92.49906,
									29.5523
								],
								[
									-93.22637,
									29.78375
								],
								[
									-93.84842,
									29.71363
								],
								[
									-94.69,
									29.48
								],
								[
									-95.60026,
									28.73863
								],
								[
									-96.59404,
									28.30748
								],
								[
									-97.14,
									27.83
								],
								[
									-97.37,
									27.38
								],
								[
									-97.38,
									26.69
								],
								[
									-97.33,
									26.21
								],
								[
									-97.14,
									25.87
								],
								[
									-97.53,
									25.84
								],
								[
									-98.24,
									26.06
								],
								[
									-99.02,
									26.37
								],
								[
									-99.3,
									26.84
								],
								[
									-99.52,
									27.54
								],
								[
									-100.11,
									28.11
								],
								[
									-100.45584,
									28.69612
								],
								[
									-100.9576,
									29.38071
								],
								[
									-101.6624,
									29.7793
								],
								[
									-102.48,
									29.76
								],
								[
									-103.11,
									28.97
								],
								[
									-103.94,
									29.27
								],
								[
									-104.45697,
									29.57196
								],
								[
									-104.70575,
									30.12173
								],
								[
									-105.03737,
									30.64402
								],
								[
									-105.63159,
									31.08383
								],
								[
									-106.1429,
									31.39995
								],
								[
									-106.50759,
									31.75452
								],
								[
									-108.24,
									31.754854
								],
								[
									-108.24194,
									31.34222
								],
								[
									-109.035,
									31.34194
								],
								[
									-111.02361,
									31.33472
								],
								[
									-113.30498,
									32.03914
								],
								[
									-114.815,
									32.52528
								],
								[
									-114.72139,
									32.72083
								],
								[
									-115.99135,
									32.61239
								],
								[
									-117.12776,
									32.53534
								],
								[
									-117.295938,
									33.046225
								],
								[
									-117.944,
									33.621236
								],
								[
									-118.410602,
									33.740909
								],
								[
									-118.519895,
									34.027782
								],
								[
									-119.081,
									34.078
								],
								[
									-119.438841,
									34.348477
								],
								[
									-120.36778,
									34.44711
								],
								[
									-120.62286,
									34.60855
								],
								[
									-120.74433,
									35.15686
								],
								[
									-121.71457,
									36.16153
								],
								[
									-122.54747,
									37.55176
								],
								[
									-122.51201,
									37.78339
								],
								[
									-122.95319,
									38.11371
								],
								[
									-123.7272,
									38.95166
								],
								[
									-123.86517,
									39.76699
								],
								[
									-124.39807,
									40.3132
								],
								[
									-124.17886,
									41.14202
								],
								[
									-124.2137,
									41.99964
								],
								[
									-124.53284,
									42.76599
								],
								[
									-124.14214,
									43.70838
								],
								[
									-124.020535,
									44.615895
								],
								[
									-123.89893,
									45.52341
								],
								[
									-124.079635,
									46.86475
								],
								[
									-124.39567,
									47.72017
								],
								[
									-124.68721,
									48.184433
								],
								[
									-124.566101,
									48.379715
								],
								[
									-123.12,
									48.04
								],
								[
									-122.58736,
									47.096
								],
								[
									-122.34,
									47.36
								],
								[
									-122.5,
									48.18
								],
								[
									-122.84,
									49
								],
								[
									-120,
									49
								],
								[
									-117.03121,
									49
								],
								[
									-116.04818,
									49
								],
								[
									-113,
									49
								],
								[
									-110.05,
									49
								],
								[
									-107.05,
									49
								],
								[
									-104.04826,
									48.99986
								],
								[
									-100.65,
									49
								],
								[
									-97.22872,
									49.0007
								],
								[
									-95.15907,
									49
								],
								[
									-95.15609,
									49.38425
								],
								[
									-94.81758,
									49.38905
								]
							]
						],
						[
							[
								[
									-153.006314,
									57.115842
								],
								[
									-154.00509,
									56.734677
								],
								[
									-154.516403,
									56.992749
								],
								[
									-154.670993,
									57.461196
								],
								[
									-153.76278,
									57.816575
								],
								[
									-153.228729,
									57.968968
								],
								[
									-152.564791,
									57.901427
								],
								[
									-152.141147,
									57.591059
								],
								[
									-153.006314,
									57.115842
								]
							]
						],
						[
							[
								[
									-165.579164,
									59.909987
								],
								[
									-166.19277,
									59.754441
								],
								[
									-166.848337,
									59.941406
								],
								[
									-167.455277,
									60.213069
								],
								[
									-166.467792,
									60.38417
								],
								[
									-165.67443,
									60.293607
								],
								[
									-165.579164,
									59.909987
								]
							]
						],
						[
							[
								[
									-171.731657,
									63.782515
								],
								[
									-171.114434,
									63.592191
								],
								[
									-170.491112,
									63.694975
								],
								[
									-169.682505,
									63.431116
								],
								[
									-168.689439,
									63.297506
								],
								[
									-168.771941,
									63.188598
								],
								[
									-169.52944,
									62.976931
								],
								[
									-170.290556,
									63.194438
								],
								[
									-170.671386,
									63.375822
								],
								[
									-171.553063,
									63.317789
								],
								[
									-171.791111,
									63.405846
								],
								[
									-171.731657,
									63.782515
								]
							]
						],
						[
							[
								[
									-155.06779,
									71.147776
								],
								[
									-154.344165,
									70.696409
								],
								[
									-153.900006,
									70.889989
								],
								[
									-152.210006,
									70.829992
								],
								[
									-152.270002,
									70.600006
								],
								[
									-150.739992,
									70.430017
								],
								[
									-149.720003,
									70.53001
								],
								[
									-147.613362,
									70.214035
								],
								[
									-145.68999,
									70.12001
								],
								[
									-144.920011,
									69.989992
								],
								[
									-143.589446,
									70.152514
								],
								[
									-142.07251,
									69.851938
								],
								[
									-140.985988,
									69.711998
								],
								[
									-140.992499,
									66.000029
								],
								[
									-140.99777,
									60.306397
								],
								[
									-140.012998,
									60.276838
								],
								[
									-139.039,
									60.000007
								],
								[
									-138.34089,
									59.56211
								],
								[
									-137.4525,
									58.905
								],
								[
									-136.47972,
									59.46389
								],
								[
									-135.47583,
									59.78778
								],
								[
									-134.945,
									59.27056
								],
								[
									-134.27111,
									58.86111
								],
								[
									-133.355549,
									58.410285
								],
								[
									-132.73042,
									57.69289
								],
								[
									-131.70781,
									56.55212
								],
								[
									-130.00778,
									55.91583
								],
								[
									-129.979994,
									55.284998
								],
								[
									-130.53611,
									54.802753
								],
								[
									-131.085818,
									55.178906
								],
								[
									-131.967211,
									55.497776
								],
								[
									-132.250011,
									56.369996
								],
								[
									-133.539181,
									57.178887
								],
								[
									-134.078063,
									58.123068
								],
								[
									-135.038211,
									58.187715
								],
								[
									-136.628062,
									58.212209
								],
								[
									-137.800006,
									58.499995
								],
								[
									-139.867787,
									59.537762
								],
								[
									-140.825274,
									59.727517
								],
								[
									-142.574444,
									60.084447
								],
								[
									-143.958881,
									59.99918
								],
								[
									-145.925557,
									60.45861
								],
								[
									-147.114374,
									60.884656
								],
								[
									-148.224306,
									60.672989
								],
								[
									-148.018066,
									59.978329
								],
								[
									-148.570823,
									59.914173
								],
								[
									-149.727858,
									59.705658
								],
								[
									-150.608243,
									59.368211
								],
								[
									-151.716393,
									59.155821
								],
								[
									-151.859433,
									59.744984
								],
								[
									-151.409719,
									60.725803
								],
								[
									-150.346941,
									61.033588
								],
								[
									-150.621111,
									61.284425
								],
								[
									-151.895839,
									60.727198
								],
								[
									-152.57833,
									60.061657
								],
								[
									-154.019172,
									59.350279
								],
								[
									-153.287511,
									58.864728
								],
								[
									-154.232492,
									58.146374
								],
								[
									-155.307491,
									57.727795
								],
								[
									-156.308335,
									57.422774
								],
								[
									-156.556097,
									56.979985
								],
								[
									-158.117217,
									56.463608
								],
								[
									-158.433321,
									55.994154
								],
								[
									-159.603327,
									55.566686
								],
								[
									-160.28972,
									55.643581
								],
								[
									-161.223048,
									55.364735
								],
								[
									-162.237766,
									55.024187
								],
								[
									-163.069447,
									54.689737
								],
								[
									-164.785569,
									54.404173
								],
								[
									-164.942226,
									54.572225
								],
								[
									-163.84834,
									55.039431
								],
								[
									-162.870001,
									55.348043
								],
								[
									-161.804175,
									55.894986
								],
								[
									-160.563605,
									56.008055
								],
								[
									-160.07056,
									56.418055
								],
								[
									-158.684443,
									57.016675
								],
								[
									-158.461097,
									57.216921
								],
								[
									-157.72277,
									57.570001
								],
								[
									-157.550274,
									58.328326
								],
								[
									-157.041675,
									58.918885
								],
								[
									-158.194731,
									58.615802
								],
								[
									-158.517218,
									58.787781
								],
								[
									-159.058606,
									58.424186
								],
								[
									-159.711667,
									58.93139
								],
								[
									-159.981289,
									58.572549
								],
								[
									-160.355271,
									59.071123
								],
								[
									-161.355003,
									58.670838
								],
								[
									-161.968894,
									58.671665
								],
								[
									-162.054987,
									59.266925
								],
								[
									-161.874171,
									59.633621
								],
								[
									-162.518059,
									59.989724
								],
								[
									-163.818341,
									59.798056
								],
								[
									-164.662218,
									60.267484
								],
								[
									-165.346388,
									60.507496
								],
								[
									-165.350832,
									61.073895
								],
								[
									-166.121379,
									61.500019
								],
								[
									-165.734452,
									62.074997
								],
								[
									-164.919179,
									62.633076
								],
								[
									-164.562508,
									63.146378
								],
								[
									-163.753332,
									63.219449
								],
								[
									-163.067224,
									63.059459
								],
								[
									-162.260555,
									63.541936
								],
								[
									-161.53445,
									63.455817
								],
								[
									-160.772507,
									63.766108
								],
								[
									-160.958335,
									64.222799
								],
								[
									-161.518068,
									64.402788
								],
								[
									-160.777778,
									64.788604
								],
								[
									-161.391926,
									64.777235
								],
								[
									-162.45305,
									64.559445
								],
								[
									-162.757786,
									64.338605
								],
								[
									-163.546394,
									64.55916
								],
								[
									-164.96083,
									64.446945
								],
								[
									-166.425288,
									64.686672
								],
								[
									-166.845004,
									65.088896
								],
								[
									-168.11056,
									65.669997
								],
								[
									-166.705271,
									66.088318
								],
								[
									-164.47471,
									66.57666
								],
								[
									-163.652512,
									66.57666
								],
								[
									-163.788602,
									66.077207
								],
								[
									-161.677774,
									66.11612
								],
								[
									-162.489715,
									66.735565
								],
								[
									-163.719717,
									67.116395
								],
								[
									-164.430991,
									67.616338
								],
								[
									-165.390287,
									68.042772
								],
								[
									-166.764441,
									68.358877
								],
								[
									-166.204707,
									68.883031
								],
								[
									-164.430811,
									68.915535
								],
								[
									-163.168614,
									69.371115
								],
								[
									-162.930566,
									69.858062
								],
								[
									-161.908897,
									70.33333
								],
								[
									-160.934797,
									70.44769
								],
								[
									-159.039176,
									70.891642
								],
								[
									-158.119723,
									70.824721
								],
								[
									-156.580825,
									71.357764
								],
								[
									-155.06779,
									71.147776
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "UZB",
				"properties": {
					"name": "Uzbekistan"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								66.518607,
								37.362784
							],
							[
								66.54615,
								37.974685
							],
							[
								65.215999,
								38.402695
							],
							[
								64.170223,
								38.892407
							],
							[
								63.518015,
								39.363257
							],
							[
								62.37426,
								40.053886
							],
							[
								61.882714,
								41.084857
							],
							[
								61.547179,
								41.26637
							],
							[
								60.465953,
								41.220327
							],
							[
								60.083341,
								41.425146
							],
							[
								59.976422,
								42.223082
							],
							[
								58.629011,
								42.751551
							],
							[
								57.78653,
								42.170553
							],
							[
								56.932215,
								41.826026
							],
							[
								57.096391,
								41.32231
							],
							[
								55.968191,
								41.308642
							],
							[
								55.928917,
								44.995858
							],
							[
								58.503127,
								45.586804
							],
							[
								58.689989,
								45.500014
							],
							[
								60.239972,
								44.784037
							],
							[
								61.05832,
								44.405817
							],
							[
								62.0133,
								43.504477
							],
							[
								63.185787,
								43.650075
							],
							[
								64.900824,
								43.728081
							],
							[
								66.098012,
								42.99766
							],
							[
								66.023392,
								41.994646
							],
							[
								66.510649,
								41.987644
							],
							[
								66.714047,
								41.168444
							],
							[
								67.985856,
								41.135991
							],
							[
								68.259896,
								40.662325
							],
							[
								68.632483,
								40.668681
							],
							[
								69.070027,
								41.384244
							],
							[
								70.388965,
								42.081308
							],
							[
								70.962315,
								42.266154
							],
							[
								71.259248,
								42.167711
							],
							[
								70.420022,
								41.519998
							],
							[
								71.157859,
								41.143587
							],
							[
								71.870115,
								41.3929
							],
							[
								73.055417,
								40.866033
							],
							[
								71.774875,
								40.145844
							],
							[
								71.014198,
								40.244366
							],
							[
								70.601407,
								40.218527
							],
							[
								70.45816,
								40.496495
							],
							[
								70.666622,
								40.960213
							],
							[
								69.329495,
								40.727824
							],
							[
								69.011633,
								40.086158
							],
							[
								68.536416,
								39.533453
							],
							[
								67.701429,
								39.580478
							],
							[
								67.44222,
								39.140144
							],
							[
								68.176025,
								38.901553
							],
							[
								68.392033,
								38.157025
							],
							[
								67.83,
								37.144994
							],
							[
								67.075782,
								37.356144
							],
							[
								66.518607,
								37.362784
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "VEN",
				"properties": {
					"name": "Venezuela"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								-71.331584,
								11.776284
							],
							[
								-71.360006,
								11.539994
							],
							[
								-71.94705,
								11.423282
							],
							[
								-71.620868,
								10.96946
							],
							[
								-71.633064,
								10.446494
							],
							[
								-72.074174,
								9.865651
							],
							[
								-71.695644,
								9.072263
							],
							[
								-71.264559,
								9.137195
							],
							[
								-71.039999,
								9.859993
							],
							[
								-71.350084,
								10.211935
							],
							[
								-71.400623,
								10.968969
							],
							[
								-70.155299,
								11.375482
							],
							[
								-70.293843,
								11.846822
							],
							[
								-69.943245,
								12.162307
							],
							[
								-69.5843,
								11.459611
							],
							[
								-68.882999,
								11.443385
							],
							[
								-68.233271,
								10.885744
							],
							[
								-68.194127,
								10.554653
							],
							[
								-67.296249,
								10.545868
							],
							[
								-66.227864,
								10.648627
							],
							[
								-65.655238,
								10.200799
							],
							[
								-64.890452,
								10.077215
							],
							[
								-64.329479,
								10.389599
							],
							[
								-64.318007,
								10.641418
							],
							[
								-63.079322,
								10.701724
							],
							[
								-61.880946,
								10.715625
							],
							[
								-62.730119,
								10.420269
							],
							[
								-62.388512,
								9.948204
							],
							[
								-61.588767,
								9.873067
							],
							[
								-60.830597,
								9.38134
							],
							[
								-60.671252,
								8.580174
							],
							[
								-60.150096,
								8.602757
							],
							[
								-59.758285,
								8.367035
							],
							[
								-60.550588,
								7.779603
							],
							[
								-60.637973,
								7.415
							],
							[
								-60.295668,
								7.043911
							],
							[
								-60.543999,
								6.856584
							],
							[
								-61.159336,
								6.696077
							],
							[
								-61.139415,
								6.234297
							],
							[
								-61.410303,
								5.959068
							],
							[
								-60.733574,
								5.200277
							],
							[
								-60.601179,
								4.918098
							],
							[
								-60.966893,
								4.536468
							],
							[
								-62.08543,
								4.162124
							],
							[
								-62.804533,
								4.006965
							],
							[
								-63.093198,
								3.770571
							],
							[
								-63.888343,
								4.02053
							],
							[
								-64.628659,
								4.148481
							],
							[
								-64.816064,
								4.056445
							],
							[
								-64.368494,
								3.79721
							],
							[
								-64.408828,
								3.126786
							],
							[
								-64.269999,
								2.497006
							],
							[
								-63.422867,
								2.411068
							],
							[
								-63.368788,
								2.2009
							],
							[
								-64.083085,
								1.916369
							],
							[
								-64.199306,
								1.492855
							],
							[
								-64.611012,
								1.328731
							],
							[
								-65.354713,
								1.095282
							],
							[
								-65.548267,
								0.789254
							],
							[
								-66.325765,
								0.724452
							],
							[
								-66.876326,
								1.253361
							],
							[
								-67.181294,
								2.250638
							],
							[
								-67.447092,
								2.600281
							],
							[
								-67.809938,
								2.820655
							],
							[
								-67.303173,
								3.318454
							],
							[
								-67.337564,
								3.542342
							],
							[
								-67.621836,
								3.839482
							],
							[
								-67.823012,
								4.503937
							],
							[
								-67.744697,
								5.221129
							],
							[
								-67.521532,
								5.55687
							],
							[
								-67.34144,
								6.095468
							],
							[
								-67.695087,
								6.267318
							],
							[
								-68.265052,
								6.153268
							],
							[
								-68.985319,
								6.206805
							],
							[
								-69.38948,
								6.099861
							],
							[
								-70.093313,
								6.960376
							],
							[
								-70.674234,
								7.087785
							],
							[
								-71.960176,
								6.991615
							],
							[
								-72.198352,
								7.340431
							],
							[
								-72.444487,
								7.423785
							],
							[
								-72.479679,
								7.632506
							],
							[
								-72.360901,
								8.002638
							],
							[
								-72.439862,
								8.405275
							],
							[
								-72.660495,
								8.625288
							],
							[
								-72.78873,
								9.085027
							],
							[
								-73.304952,
								9.152
							],
							[
								-73.027604,
								9.73677
							],
							[
								-72.905286,
								10.450344
							],
							[
								-72.614658,
								10.821975
							],
							[
								-72.227575,
								11.108702
							],
							[
								-71.973922,
								11.608672
							],
							[
								-71.331584,
								11.776284
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "VNM",
				"properties": {
					"name": "Vietnam"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								108.05018,
								21.55238
							],
							[
								106.715068,
								20.696851
							],
							[
								105.881682,
								19.75205
							],
							[
								105.662006,
								19.058165
							],
							[
								106.426817,
								18.004121
							],
							[
								107.361954,
								16.697457
							],
							[
								108.269495,
								16.079742
							],
							[
								108.877107,
								15.276691
							],
							[
								109.33527,
								13.426028
							],
							[
								109.200136,
								11.666859
							],
							[
								108.36613,
								11.008321
							],
							[
								107.220929,
								10.364484
							],
							[
								106.405113,
								9.53084
							],
							[
								105.158264,
								8.59976
							],
							[
								104.795185,
								9.241038
							],
							[
								105.076202,
								9.918491
							],
							[
								104.334335,
								10.486544
							],
							[
								105.199915,
								10.88931
							],
							[
								106.24967,
								10.961812
							],
							[
								105.810524,
								11.567615
							],
							[
								107.491403,
								12.337206
							],
							[
								107.614548,
								13.535531
							],
							[
								107.382727,
								14.202441
							],
							[
								107.564525,
								15.202173
							],
							[
								107.312706,
								15.908538
							],
							[
								106.556008,
								16.604284
							],
							[
								105.925762,
								17.485315
							],
							[
								105.094598,
								18.666975
							],
							[
								103.896532,
								19.265181
							],
							[
								104.183388,
								19.624668
							],
							[
								104.822574,
								19.886642
							],
							[
								104.435,
								20.758733
							],
							[
								103.203861,
								20.766562
							],
							[
								102.754896,
								21.675137
							],
							[
								102.170436,
								22.464753
							],
							[
								102.706992,
								22.708795
							],
							[
								103.504515,
								22.703757
							],
							[
								104.476858,
								22.81915
							],
							[
								105.329209,
								23.352063
							],
							[
								105.811247,
								22.976892
							],
							[
								106.725403,
								22.794268
							],
							[
								106.567273,
								22.218205
							],
							[
								107.04342,
								21.811899
							],
							[
								108.05018,
								21.55238
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "VUT",
				"properties": {
					"name": "Vanuatu"
				},
				"geometry": {
					"type": "MultiPolygon",
					"coordinates": [
						[
							[
								[
									167.844877,
									-16.466333
								],
								[
									167.515181,
									-16.59785
								],
								[
									167.180008,
									-16.159995
								],
								[
									167.216801,
									-15.891846
								],
								[
									167.844877,
									-16.466333
								]
							]
						],
						[
							[
								[
									167.107712,
									-14.93392
								],
								[
									167.270028,
									-15.740021
								],
								[
									167.001207,
									-15.614602
								],
								[
									166.793158,
									-15.668811
								],
								[
									166.649859,
									-15.392704
								],
								[
									166.629137,
									-14.626497
								],
								[
									167.107712,
									-14.93392
								]
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "PSE",
				"properties": {
					"name": "West Bank"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								35.545665,
								32.393992
							],
							[
								35.545252,
								31.782505
							],
							[
								35.397561,
								31.489086
							],
							[
								34.927408,
								31.353435
							],
							[
								34.970507,
								31.616778
							],
							[
								35.225892,
								31.754341
							],
							[
								34.974641,
								31.866582
							],
							[
								35.18393,
								32.532511
							],
							[
								35.545665,
								32.393992
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "YEM",
				"properties": {
					"name": "Yemen"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								53.108573,
								16.651051
							],
							[
								52.385206,
								16.382411
							],
							[
								52.191729,
								15.938433
							],
							[
								52.168165,
								15.59742
							],
							[
								51.172515,
								15.17525
							],
							[
								49.574576,
								14.708767
							],
							[
								48.679231,
								14.003202
							],
							[
								48.238947,
								13.94809
							],
							[
								47.938914,
								14.007233
							],
							[
								47.354454,
								13.59222
							],
							[
								46.717076,
								13.399699
							],
							[
								45.877593,
								13.347764
							],
							[
								45.62505,
								13.290946
							],
							[
								45.406459,
								13.026905
							],
							[
								45.144356,
								12.953938
							],
							[
								44.989533,
								12.699587
							],
							[
								44.494576,
								12.721653
							],
							[
								44.175113,
								12.58595
							],
							[
								43.482959,
								12.6368
							],
							[
								43.222871,
								13.22095
							],
							[
								43.251448,
								13.767584
							],
							[
								43.087944,
								14.06263
							],
							[
								42.892245,
								14.802249
							],
							[
								42.604873,
								15.213335
							],
							[
								42.805015,
								15.261963
							],
							[
								42.702438,
								15.718886
							],
							[
								42.823671,
								15.911742
							],
							[
								42.779332,
								16.347891
							],
							[
								43.218375,
								16.66689
							],
							[
								43.115798,
								17.08844
							],
							[
								43.380794,
								17.579987
							],
							[
								43.791519,
								17.319977
							],
							[
								44.062613,
								17.410359
							],
							[
								45.216651,
								17.433329
							],
							[
								45.399999,
								17.333335
							],
							[
								46.366659,
								17.233315
							],
							[
								46.749994,
								17.283338
							],
							[
								47.000005,
								16.949999
							],
							[
								47.466695,
								17.116682
							],
							[
								48.183344,
								18.166669
							],
							[
								49.116672,
								18.616668
							],
							[
								52.00001,
								19.000003
							],
							[
								52.782184,
								17.349742
							],
							[
								53.108573,
								16.651051
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ZAF",
				"properties": {
					"name": "South Africa"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.521001,
								-29.257387
							],
							[
								31.325561,
								-29.401978
							],
							[
								30.901763,
								-29.909957
							],
							[
								30.622813,
								-30.423776
							],
							[
								30.055716,
								-31.140269
							],
							[
								28.925553,
								-32.172041
							],
							[
								28.219756,
								-32.771953
							],
							[
								27.464608,
								-33.226964
							],
							[
								26.419452,
								-33.61495
							],
							[
								25.909664,
								-33.66704
							],
							[
								25.780628,
								-33.944646
							],
							[
								25.172862,
								-33.796851
							],
							[
								24.677853,
								-33.987176
							],
							[
								23.594043,
								-33.794474
							],
							[
								22.988189,
								-33.916431
							],
							[
								22.574157,
								-33.864083
							],
							[
								21.542799,
								-34.258839
							],
							[
								20.689053,
								-34.417175
							],
							[
								20.071261,
								-34.795137
							],
							[
								19.616405,
								-34.819166
							],
							[
								19.193278,
								-34.462599
							],
							[
								18.855315,
								-34.444306
							],
							[
								18.424643,
								-33.997873
							],
							[
								18.377411,
								-34.136521
							],
							[
								18.244499,
								-33.867752
							],
							[
								18.25008,
								-33.281431
							],
							[
								17.92519,
								-32.611291
							],
							[
								18.24791,
								-32.429131
							],
							[
								18.221762,
								-31.661633
							],
							[
								17.566918,
								-30.725721
							],
							[
								17.064416,
								-29.878641
							],
							[
								17.062918,
								-29.875954
							],
							[
								16.344977,
								-28.576705
							],
							[
								16.824017,
								-28.082162
							],
							[
								17.218929,
								-28.355943
							],
							[
								17.387497,
								-28.783514
							],
							[
								17.836152,
								-28.856378
							],
							[
								18.464899,
								-29.045462
							],
							[
								19.002127,
								-28.972443
							],
							[
								19.894734,
								-28.461105
							],
							[
								19.895768,
								-24.76779
							],
							[
								20.165726,
								-24.917962
							],
							[
								20.758609,
								-25.868136
							],
							[
								20.66647,
								-26.477453
							],
							[
								20.889609,
								-26.828543
							],
							[
								21.605896,
								-26.726534
							],
							[
								22.105969,
								-26.280256
							],
							[
								22.579532,
								-25.979448
							],
							[
								22.824271,
								-25.500459
							],
							[
								23.312097,
								-25.26869
							],
							[
								23.73357,
								-25.390129
							],
							[
								24.211267,
								-25.670216
							],
							[
								25.025171,
								-25.71967
							],
							[
								25.664666,
								-25.486816
							],
							[
								25.765849,
								-25.174845
							],
							[
								25.941652,
								-24.696373
							],
							[
								26.485753,
								-24.616327
							],
							[
								26.786407,
								-24.240691
							],
							[
								27.11941,
								-23.574323
							],
							[
								28.017236,
								-22.827754
							],
							[
								29.432188,
								-22.091313
							],
							[
								29.839037,
								-22.102216
							],
							[
								30.322883,
								-22.271612
							],
							[
								30.659865,
								-22.151567
							],
							[
								31.191409,
								-22.25151
							],
							[
								31.670398,
								-23.658969
							],
							[
								31.930589,
								-24.369417
							],
							[
								31.752408,
								-25.484284
							],
							[
								31.837778,
								-25.843332
							],
							[
								31.333158,
								-25.660191
							],
							[
								31.04408,
								-25.731452
							],
							[
								30.949667,
								-26.022649
							],
							[
								30.676609,
								-26.398078
							],
							[
								30.685962,
								-26.743845
							],
							[
								31.282773,
								-27.285879
							],
							[
								31.86806,
								-27.177927
							],
							[
								32.071665,
								-26.73382
							],
							[
								32.83012,
								-26.742192
							],
							[
								32.580265,
								-27.470158
							],
							[
								32.462133,
								-28.301011
							],
							[
								32.203389,
								-28.752405
							],
							[
								31.521001,
								-29.257387
							]
						],
						[
							[
								28.978263,
								-28.955597
							],
							[
								28.5417,
								-28.647502
							],
							[
								28.074338,
								-28.851469
							],
							[
								27.532511,
								-29.242711
							],
							[
								26.999262,
								-29.875954
							],
							[
								27.749397,
								-30.645106
							],
							[
								28.107205,
								-30.545732
							],
							[
								28.291069,
								-30.226217
							],
							[
								28.8484,
								-30.070051
							],
							[
								29.018415,
								-29.743766
							],
							[
								29.325166,
								-29.257387
							],
							[
								28.978263,
								-28.955597
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ZMB",
				"properties": {
					"name": "Zambia"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								32.759375,
								-9.230599
							],
							[
								33.231388,
								-9.676722
							],
							[
								33.485688,
								-10.525559
							],
							[
								33.31531,
								-10.79655
							],
							[
								33.114289,
								-11.607198
							],
							[
								33.306422,
								-12.435778
							],
							[
								32.991764,
								-12.783871
							],
							[
								32.688165,
								-13.712858
							],
							[
								33.214025,
								-13.97186
							],
							[
								30.179481,
								-14.796099
							],
							[
								30.274256,
								-15.507787
							],
							[
								29.516834,
								-15.644678
							],
							[
								28.947463,
								-16.043051
							],
							[
								28.825869,
								-16.389749
							],
							[
								28.467906,
								-16.4684
							],
							[
								27.598243,
								-17.290831
							],
							[
								27.044427,
								-17.938026
							],
							[
								26.706773,
								-17.961229
							],
							[
								26.381935,
								-17.846042
							],
							[
								25.264226,
								-17.73654
							],
							[
								25.084443,
								-17.661816
							],
							[
								25.07695,
								-17.578823
							],
							[
								24.682349,
								-17.353411
							],
							[
								24.033862,
								-17.295843
							],
							[
								23.215048,
								-17.523116
							],
							[
								22.562478,
								-16.898451
							],
							[
								21.887843,
								-16.08031
							],
							[
								21.933886,
								-12.898437
							],
							[
								24.016137,
								-12.911046
							],
							[
								23.930922,
								-12.565848
							],
							[
								24.079905,
								-12.191297
							],
							[
								23.904154,
								-11.722282
							],
							[
								24.017894,
								-11.237298
							],
							[
								23.912215,
								-10.926826
							],
							[
								24.257155,
								-10.951993
							],
							[
								24.314516,
								-11.262826
							],
							[
								24.78317,
								-11.238694
							],
							[
								25.418118,
								-11.330936
							],
							[
								25.75231,
								-11.784965
							],
							[
								26.553088,
								-11.92444
							],
							[
								27.16442,
								-11.608748
							],
							[
								27.388799,
								-12.132747
							],
							[
								28.155109,
								-12.272481
							],
							[
								28.523562,
								-12.698604
							],
							[
								28.934286,
								-13.248958
							],
							[
								29.699614,
								-13.257227
							],
							[
								29.616001,
								-12.178895
							],
							[
								29.341548,
								-12.360744
							],
							[
								28.642417,
								-11.971569
							],
							[
								28.372253,
								-11.793647
							],
							[
								28.49607,
								-10.789884
							],
							[
								28.673682,
								-9.605925
							],
							[
								28.449871,
								-9.164918
							],
							[
								28.734867,
								-8.526559
							],
							[
								29.002912,
								-8.407032
							],
							[
								30.346086,
								-8.238257
							],
							[
								30.740015,
								-8.340007
							],
							[
								31.157751,
								-8.594579
							],
							[
								31.556348,
								-8.762049
							],
							[
								32.191865,
								-8.930359
							],
							[
								32.759375,
								-9.230599
							]
						]
					]
				}
			},
			{
				"type": "Feature",
				"id": "ZWE",
				"properties": {
					"name": "Zimbabwe"
				},
				"geometry": {
					"type": "Polygon",
					"coordinates": [
						[
							[
								31.191409,
								-22.25151
							],
							[
								30.659865,
								-22.151567
							],
							[
								30.322883,
								-22.271612
							],
							[
								29.839037,
								-22.102216
							],
							[
								29.432188,
								-22.091313
							],
							[
								28.794656,
								-21.639454
							],
							[
								28.02137,
								-21.485975
							],
							[
								27.727228,
								-20.851802
							],
							[
								27.724747,
								-20.499059
							],
							[
								27.296505,
								-20.39152
							],
							[
								26.164791,
								-19.293086
							],
							[
								25.850391,
								-18.714413
							],
							[
								25.649163,
								-18.536026
							],
							[
								25.264226,
								-17.73654
							],
							[
								26.381935,
								-17.846042
							],
							[
								26.706773,
								-17.961229
							],
							[
								27.044427,
								-17.938026
							],
							[
								27.598243,
								-17.290831
							],
							[
								28.467906,
								-16.4684
							],
							[
								28.825869,
								-16.389749
							],
							[
								28.947463,
								-16.043051
							],
							[
								29.516834,
								-15.644678
							],
							[
								30.274256,
								-15.507787
							],
							[
								30.338955,
								-15.880839
							],
							[
								31.173064,
								-15.860944
							],
							[
								31.636498,
								-16.07199
							],
							[
								31.852041,
								-16.319417
							],
							[
								32.328239,
								-16.392074
							],
							[
								32.847639,
								-16.713398
							],
							[
								32.849861,
								-17.979057
							],
							[
								32.654886,
								-18.67209
							],
							[
								32.611994,
								-19.419383
							],
							[
								32.772708,
								-19.715592
							],
							[
								32.659743,
								-20.30429
							],
							[
								32.508693,
								-20.395292
							],
							[
								32.244988,
								-21.116489
							],
							[
								31.191409,
								-22.25151
							]
						]
					]
				}
			}
		]
	};

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(topojson, crossfilter) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	var GlobeDirective = (function () {
	    function GlobeDirective(el, renderer, viewContainer, topojson, document, d3, window, crossfilter) {
	        this.el = el;
	        this.renderer = renderer;
	        this.viewContainer = viewContainer;
	        this.topojson = topojson;
	        this.document = document;
	        this.d3 = d3;
	        this.window = window;
	        this.crossfilter = crossfilter;
	        this.globePaths = __webpack_require__(931);
	        this.countryNames = __webpack_require__(932);
	        this.countryPathsByName = {};
	        this.heatmapArray = [];
	        // default draw settings
	        this.backgroundColor = "black";
	        this.foregroundColor = "white";
	        this.center = [0, 0];
	        this.zoom = 3;
	        this.sens = 0.25;
	        this.windowWidth = 0;
	        // public mode = 'all';
	        this.strokeColor = '#79CC2E';
	        // The following will all change at runtime, but they are set to some value to
	        // handle the case that the render function gets run before they are updated.
	        this.box = {
	            width: 300,
	            height: 300
	        };
	        this.radius = this.box.height / 2 - 5;
	        this.scale = this.radius;
	        this.cosLat = 1;
	        // set up variables for inactivity monitoring to activate spin
	        this.isInactive = true;
	        this.currentInactivity = 0;
	        this.inactivityTime = 5; // time in seconds of inactivity that the globe will start spinning
	        // public inactivityZoom = 3; // max zoom level that the globe will spin if inactive
	        this.rotate = [0, 0];
	        this.rt = Date.now();
	        this.velocity = [.015, -0];
	        this.mode = "outbound";
	        this.onGlobeDrag = new core_1.EventEmitter();
	        this.modeChanged = new core_1.EventEmitter();
	    }
	    /////////////////////
	    // LIFESTYLE HOOKS //
	    /////////////////////
	    GlobeDirective.prototype.ngOnInit = function () {
	        var _this = this;
	        // element setup
	        var el = this.viewContainer.element;
	        // this.canvas = this.renderer.createElement(el.nativeElement, 'canvas');
	        this.canvas = this.el.nativeElement.querySelector('canvas');
	        this.context = this.canvas.getContext("2d");
	        this.projection = this.d3.geo.orthographic()
	            .clipAngle(90);
	        this.path = this.d3.geo.path()
	            .projection(this.projection)
	            .context(this.context);
	        // heatmap linear scale
	        this.rainbowScale = this.d3.scale.linear();
	        // dragging
	        this.d3.select(this.canvas)
	            .call(this.d3.behavior.drag()
	            .origin(function () {
	            var r = _this.projection.rotate();
	            return {
	                x: r[0] / _this.sens,
	                y: -r[1] / _this.sens
	            };
	        })
	            .on("drag", function () {
	            var lng = -_this.window.d3.event.x * _this.sens;
	            var lat = _this.window.d3.event.y * _this.sens;
	            // Disallow rotation beyond the poles.
	            lat = lat > 89 ? 89 : lat < -89 ? -89 : lat;
	            _this.center = [lng, lat];
	            _this.setCenter(_this.center);
	            // emit events for other visuals
	            _this.onGlobeDrag.emit({
	                value: _this.center
	            });
	        }));
	        this.resize(this.box);
	        this.setWidth();
	        // define countries, paths and lookups
	        var countryById = {};
	        this.countries = this.topojson.feature(this.globePaths, this.globePaths.objects.countries).features;
	        for (var n = 0, len = this.countryNames.length; n < len; n++) {
	            countryById[this.countryNames[n].id] = this.countryNames[n].name;
	        }
	        for (var c = 0, len = this.countries.length; c < len; c++) {
	            this.countryPathsByName[countryById[this.countries[c].id]] = this.countries[c];
	        }
	        this.land = this.topojson.feature(this.globePaths, this.globePaths.objects.land);
	        // crossfilter setup
	        this.crossfilterData = new this.crossfilter();
	        this.timeDimension = this.crossfilterData.dimension(function (d) { return d.time; });
	        this.countryDimension = this.crossfilterData.dimension(function (d) {
	            switch (d.vector) {
	                case 'inbound':
	                    return d.orig_country;
	                case 'outbound':
	                    return d.resp_country;
	            }
	        });
	        this.countryGroup = this.countryDimension.group();
	        // setup globe mode
	        this.setGlobeMode(); // this will default to 'all'
	        //sub to streams
	        this.setupStreams();
	        // listen for re-sub events when the site is changed
	        this.newStream
	            .asObservable()
	            .subscribe(function () {
	            _this.setupStreams();
	        });
	    };
	    ////////////
	    // EVENTS //
	    ////////////
	    GlobeDirective.prototype.setupStreams = function () {
	        var _this = this;
	        // DATA SUBSCRIPTIONS
	        this.outboundStream.subscribe(function (conn) {
	            // if (visibility.isHidden) { return }
	            if (_this.mode === 'inbound') {
	                return;
	            } // do nothing if the globe's mode is set to inbound
	            _this.crossfilterData.add([conn]);
	        });
	        this.inboundStream.subscribe(function (conn) {
	            // if (visibility.isHidden) { return }
	            if (_this.mode === 'outbound') {
	                return;
	            } // do nothing if the globe's mode is set to outbound
	            _this.crossfilterData.add([conn]);
	        });
	    };
	    GlobeDirective.prototype.onMapDrag = function (event) {
	        this.setCenter(event.center);
	        this.zoom = event.zoom;
	        // reset globe inactivity status
	        this.resetInactivity();
	        // because this fires also when the window is resized
	        // lets also update the width so the zoom lines are proportional to the view
	        this.setWidth();
	    };
	    /////////////
	    // METHODS //
	    /////////////
	    GlobeDirective.prototype.checkInactive = function () {
	        if (this.isInactive) {
	            return;
	        }
	        // if (map.zoom > this.inactivityZoom) { return }
	        if (this.currentInactivity === this.inactivityTime) {
	            this.rt = Date.now();
	            this.isInactive = true;
	            return;
	        }
	        this.currentInactivity++;
	        return;
	    };
	    GlobeDirective.prototype.resetInactivity = function () {
	        this.currentInactivity = 0;
	        this.isInactive = false;
	    };
	    GlobeDirective.prototype.resize = function (box) {
	        this.canvas.width = box.width;
	        this.canvas.height = box.height;
	        this.projection.translate([box.width / 2, box.height / 2]);
	        this.radius = box.height / 2 - 5;
	    };
	    GlobeDirective.prototype.setCenter = function (center) {
	        var lat = center[1];
	        this.cosLat = Math.cos(this.toRadians(lat));
	        this.rotate = [-center[0], -center[1]];
	        this.rotateMap(this.rotate);
	    };
	    GlobeDirective.prototype.rotateMap = function (rotate) {
	        this.projection.rotate(rotate);
	    };
	    GlobeDirective.prototype.toRadians = function (deg) {
	        return deg / 180 * Math.PI;
	    };
	    GlobeDirective.prototype.getParentWidth = function () {
	        if (!this.parent) {
	            console.log('Parent attribute not defined in map');
	            return;
	        }
	        var parent = this.document.getElementsByClassName(this.parent)[0];
	        var width = parent.clientWidth;
	        return width;
	    };
	    GlobeDirective.prototype.setWidth = function () {
	        // this is so the globe is aware how wide the window is so it can set the view ring correctly
	        this.windowWidth = this.getParentWidth();
	    };
	    GlobeDirective.prototype.setGlobeMode = function (mode) {
	        switch (mode) {
	            case 'inbound':
	                this.mode = mode;
	                this.strokeColor = '#FF5D2A';
	                this.rainbowScale.range(['#FF5D2A', '#662510']);
	                this.timeDimension.filterAll();
	                this.crossfilterData.remove(); // remove everything
	                break;
	            case 'outbound':
	                this.mode = mode;
	                this.strokeColor = '#3459FF';
	                this.rainbowScale.range(['#3459FF', '#101F62']);
	                this.timeDimension.filterAll();
	                this.crossfilterData.remove(); // remove everything
	                break;
	            default:
	                this.mode = 'all';
	                this.strokeColor = '#79CC2E';
	                this.rainbowScale.range(['#79CC2E', '#3D6718']);
	        }
	        this.modeChanged.emit({
	            value: this.mode
	        });
	    };
	    // DATA HANDLING
	    GlobeDirective.prototype.filterCrossfilterByTime = function () {
	        var now = Date.now();
	        this.timeDimension.filter(function (d) { return d < (now - 4000); });
	        this.crossfilterData.remove(); // remove matches
	        this.timeDimension.filterAll();
	    };
	    GlobeDirective.prototype.processData = function () {
	        // filer out older items everting by time
	        this.filterCrossfilterByTime();
	        var max = 1, obj = {}; // set max number for rainow scale
	        var all = this.countryGroup.all().map(function (d) {
	            // since we're already iterating over the array, lets set the max
	            if (d.value > max) {
	                max = d.value;
	            }
	            return (_a = {}, _a[d.key] = d.value, _a);
	            var _a;
	        });
	        if (all.length > 0) {
	            obj = Object.assign.apply(Object, all);
	        }
	        this.rainbowScale.domain([1, max]);
	        // HEATMAP INTERPOLATION
	        var arr = [];
	        // loop thorugh existing countries first
	        for (var i = 0, len = this.heatmapArray.length; i < len; i++) {
	            var o = this.heatmapArray[i];
	            if (obj.hasOwnProperty(o.name)) {
	                o.colors.start = o.colors.end; // swap colors
	                o.colors.end = this.rainbowScale(obj[o.name]); // new color
	                // delete value in object
	                delete obj[o.name];
	                arr.push(o);
	            }
	            else if (o.colors.end !== '#ffffff') {
	                // don't push if the end is already white
	                o.colors.start = o.colors.end;
	                o.colors.end = '#ffffff';
	                arr.push(o);
	            }
	        }
	        // these are remaining values not previously
	        // in the heatmap array, so we make them compatible
	        for (var i in obj) {
	            var o = {
	                path: this.countryPathsByName[i],
	                name: i,
	                colors: {
	                    start: '#ffffff',
	                    end: '' // assigned below
	                }
	            };
	            o.colors.end = this.rainbowScale(obj[o.name]); // new value
	            arr.push(o);
	        }
	        // update the heatmap queue
	        this.heatmapArray = arr;
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], GlobeDirective.prototype, "inboundStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], GlobeDirective.prototype, "outboundStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], GlobeDirective.prototype, "newStream", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], GlobeDirective.prototype, "mode", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], GlobeDirective.prototype, "parent", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], GlobeDirective.prototype, "onGlobeDrag", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], GlobeDirective.prototype, "modeChanged", void 0);
	    GlobeDirective = __decorate([
	        core_1.Directive({
	            selector: '[globe-container]',
	            providers: [
	                { provide: 'Topojson', useValue: topojson },
	                { provide: 'Crossfilter', useValue: crossfilter }
	            ]
	        }),
	        __param(3, core_1.Inject('Topojson')),
	        __param(4, core_1.Inject('Document')),
	        __param(5, core_1.Inject('D3')),
	        __param(6, core_1.Inject('Window')),
	        __param(7, core_1.Inject('Crossfilter')), 
	        __metadata('design:paramtypes', [core_1.ElementRef, core_1.Renderer, core_1.ViewContainerRef, Object, Document, Object, Object, Object])
	    ], GlobeDirective);
	    return GlobeDirective;
	}());
	exports.GlobeDirective = GlobeDirective;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(930), __webpack_require__(677)))

/***/ },
/* 930 */,
/* 931 */
/***/ function(module, exports) {

	module.exports = {
		"type": "Topology",
		"objects": {
			"countries": {
				"type": "GeometryCollection",
				"bbox": [
					-179.99999999999997,
					-90.00000000000003,
					180.00000000000014,
					83.64513000000001
				],
				"geometries": [
					{
						"type": "Polygon",
						"id": 4,
						"arcs": [
							[
								0,
								1,
								2,
								3,
								4,
								5
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 24,
						"arcs": [
							[
								[
									6,
									7,
									8,
									9
								]
							],
							[
								[
									10,
									11,
									12
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 8,
						"arcs": [
							[
								13,
								14,
								15,
								16,
								17
							]
						]
					},
					{
						"type": "Polygon",
						"id": 784,
						"arcs": [
							[
								18,
								19,
								20,
								21,
								22
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 32,
						"arcs": [
							[
								[
									23,
									24
								]
							],
							[
								[
									25,
									26,
									27,
									28,
									29,
									30
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 51,
						"arcs": [
							[
								31,
								32,
								33,
								34,
								35
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 10,
						"arcs": [
							[
								[
									36
								]
							],
							[
								[
									37
								]
							],
							[
								[
									38
								]
							],
							[
								[
									39
								]
							],
							[
								[
									40
								]
							],
							[
								[
									41
								]
							],
							[
								[
									42
								]
							],
							[
								[
									43
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 260,
						"arcs": [
							[
								44
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 36,
						"arcs": [
							[
								[
									45
								]
							],
							[
								[
									46
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 40,
						"arcs": [
							[
								47,
								48,
								49,
								50,
								51,
								52,
								53
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 31,
						"arcs": [
							[
								[
									54,
									-35
								]
							],
							[
								[
									55,
									56,
									-33,
									57,
									58
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 108,
						"arcs": [
							[
								59,
								60,
								61
							]
						]
					},
					{
						"type": "Polygon",
						"id": 56,
						"arcs": [
							[
								62,
								63,
								64,
								65,
								66
							]
						]
					},
					{
						"type": "Polygon",
						"id": 204,
						"arcs": [
							[
								67,
								68,
								69,
								70,
								71
							]
						]
					},
					{
						"type": "Polygon",
						"id": 854,
						"arcs": [
							[
								72,
								73,
								74,
								-70,
								75,
								76
							]
						]
					},
					{
						"type": "Polygon",
						"id": 50,
						"arcs": [
							[
								77,
								78,
								79
							]
						]
					},
					{
						"type": "Polygon",
						"id": 100,
						"arcs": [
							[
								80,
								81,
								82,
								83,
								84,
								85
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 44,
						"arcs": [
							[
								[
									86
								]
							],
							[
								[
									87
								]
							],
							[
								[
									88
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 70,
						"arcs": [
							[
								89,
								90,
								91
							]
						]
					},
					{
						"type": "Polygon",
						"id": 112,
						"arcs": [
							[
								92,
								93,
								94,
								95,
								96
							]
						]
					},
					{
						"type": "Polygon",
						"id": 84,
						"arcs": [
							[
								97,
								98,
								99
							]
						]
					},
					{
						"type": "Polygon",
						"id": 68,
						"arcs": [
							[
								100,
								101,
								102,
								103,
								-31
							]
						]
					},
					{
						"type": "Polygon",
						"id": 76,
						"arcs": [
							[
								-27,
								104,
								-103,
								105,
								106,
								107,
								108,
								109,
								110,
								111,
								112
							]
						]
					},
					{
						"type": "Polygon",
						"id": 96,
						"arcs": [
							[
								113,
								114
							]
						]
					},
					{
						"type": "Polygon",
						"id": 64,
						"arcs": [
							[
								115,
								116
							]
						]
					},
					{
						"type": "Polygon",
						"id": 72,
						"arcs": [
							[
								117,
								118,
								119,
								120
							]
						]
					},
					{
						"type": "Polygon",
						"id": 140,
						"arcs": [
							[
								121,
								122,
								123,
								124,
								125,
								126,
								127
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 124,
						"arcs": [
							[
								[
									128
								]
							],
							[
								[
									129
								]
							],
							[
								[
									130
								]
							],
							[
								[
									131
								]
							],
							[
								[
									132
								]
							],
							[
								[
									133
								]
							],
							[
								[
									134
								]
							],
							[
								[
									135
								]
							],
							[
								[
									136
								]
							],
							[
								[
									137
								]
							],
							[
								[
									138,
									139,
									140,
									141
								]
							],
							[
								[
									142
								]
							],
							[
								[
									143
								]
							],
							[
								[
									144
								]
							],
							[
								[
									145
								]
							],
							[
								[
									146
								]
							],
							[
								[
									147
								]
							],
							[
								[
									148
								]
							],
							[
								[
									149
								]
							],
							[
								[
									150
								]
							],
							[
								[
									151
								]
							],
							[
								[
									152
								]
							],
							[
								[
									153
								]
							],
							[
								[
									154
								]
							],
							[
								[
									155
								]
							],
							[
								[
									156
								]
							],
							[
								[
									157
								]
							],
							[
								[
									158
								]
							],
							[
								[
									159
								]
							],
							[
								[
									160
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 756,
						"arcs": [
							[
								-51,
								161,
								162,
								163
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 152,
						"arcs": [
							[
								[
									-24,
									164
								]
							],
							[
								[
									-30,
									165,
									166,
									-101
								]
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 156,
						"arcs": [
							[
								[
									167
								]
							],
							[
								[
									168,
									169,
									170,
									171,
									172,
									173,
									-117,
									174,
									175,
									176,
									177,
									-4,
									178,
									179,
									180,
									181,
									182,
									183
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 384,
						"arcs": [
							[
								184,
								185,
								186,
								187,
								-73,
								188
							]
						]
					},
					{
						"type": "Polygon",
						"id": 120,
						"arcs": [
							[
								189,
								190,
								191,
								192,
								193,
								194,
								-128,
								195
							]
						]
					},
					{
						"type": "Polygon",
						"id": 180,
						"arcs": [
							[
								196,
								197,
								-60,
								198,
								199,
								-10,
								200,
								-13,
								201,
								-126,
								202
							]
						]
					},
					{
						"type": "Polygon",
						"id": 178,
						"arcs": [
							[
								-12,
								203,
								204,
								-196,
								-127,
								-202
							]
						]
					},
					{
						"type": "Polygon",
						"id": 170,
						"arcs": [
							[
								205,
								206,
								207,
								208,
								209,
								-107,
								210
							]
						]
					},
					{
						"type": "Polygon",
						"id": 188,
						"arcs": [
							[
								211,
								212,
								213,
								214
							]
						]
					},
					{
						"type": "Polygon",
						"id": 192,
						"arcs": [
							[
								215
							]
						]
					},
					{
						"type": "Polygon",
						"id": -99,
						"arcs": [
							[
								216,
								217
							]
						]
					},
					{
						"type": "Polygon",
						"id": 196,
						"arcs": [
							[
								218,
								-218
							]
						]
					},
					{
						"type": "Polygon",
						"id": 203,
						"arcs": [
							[
								-53,
								219,
								220,
								221
							]
						]
					},
					{
						"type": "Polygon",
						"id": 276,
						"arcs": [
							[
								222,
								223,
								-220,
								-52,
								-164,
								224,
								225,
								-64,
								226,
								227,
								228
							]
						]
					},
					{
						"type": "Polygon",
						"id": 262,
						"arcs": [
							[
								229,
								230,
								231,
								232
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 208,
						"arcs": [
							[
								[
									233
								]
							],
							[
								[
									-229,
									234
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 214,
						"arcs": [
							[
								235,
								236
							]
						]
					},
					{
						"type": "Polygon",
						"id": 12,
						"arcs": [
							[
								237,
								238,
								239,
								240,
								241,
								242,
								243,
								244
							]
						]
					},
					{
						"type": "Polygon",
						"id": 218,
						"arcs": [
							[
								245,
								-206,
								246
							]
						]
					},
					{
						"type": "Polygon",
						"id": 818,
						"arcs": [
							[
								247,
								248,
								249,
								250,
								251
							]
						]
					},
					{
						"type": "Polygon",
						"id": 232,
						"arcs": [
							[
								252,
								253,
								254,
								-233
							]
						]
					},
					{
						"type": "Polygon",
						"id": 724,
						"arcs": [
							[
								255,
								256,
								257,
								258
							]
						]
					},
					{
						"type": "Polygon",
						"id": 233,
						"arcs": [
							[
								259,
								260,
								261
							]
						]
					},
					{
						"type": "Polygon",
						"id": 231,
						"arcs": [
							[
								-232,
								262,
								263,
								264,
								265,
								266,
								267,
								-253
							]
						]
					},
					{
						"type": "Polygon",
						"id": 246,
						"arcs": [
							[
								268,
								269,
								270,
								271
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 242,
						"arcs": [
							[
								[
									272
								]
							],
							[
								[
									273
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 238,
						"arcs": [
							[
								274
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 250,
						"arcs": [
							[
								[
									275,
									276,
									277,
									-111
								]
							],
							[
								[
									278
								]
							],
							[
								[
									279,
									-225,
									-163,
									280,
									281,
									-257,
									282,
									-66
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 266,
						"arcs": [
							[
								283,
								284,
								-190,
								-205
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 826,
						"arcs": [
							[
								[
									285,
									286
								]
							],
							[
								[
									287
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 268,
						"arcs": [
							[
								288,
								289,
								-58,
								-32,
								290
							]
						]
					},
					{
						"type": "Polygon",
						"id": 288,
						"arcs": [
							[
								291,
								-189,
								-77,
								292
							]
						]
					},
					{
						"type": "Polygon",
						"id": 324,
						"arcs": [
							[
								293,
								294,
								295,
								296,
								297,
								298,
								-187
							]
						]
					},
					{
						"type": "Polygon",
						"id": 270,
						"arcs": [
							[
								299,
								300
							]
						]
					},
					{
						"type": "Polygon",
						"id": 624,
						"arcs": [
							[
								301,
								302,
								-297
							]
						]
					},
					{
						"type": "Polygon",
						"id": 226,
						"arcs": [
							[
								303,
								-191,
								-285
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 300,
						"arcs": [
							[
								[
									304
								]
							],
							[
								[
									305,
									-15,
									306,
									-84,
									307
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 304,
						"arcs": [
							[
								308
							]
						]
					},
					{
						"type": "Polygon",
						"id": 320,
						"arcs": [
							[
								309,
								310,
								-100,
								311,
								312,
								313
							]
						]
					},
					{
						"type": "Polygon",
						"id": 328,
						"arcs": [
							[
								314,
								315,
								-109,
								316
							]
						]
					},
					{
						"type": "Polygon",
						"id": 340,
						"arcs": [
							[
								317,
								318,
								-313,
								319,
								320
							]
						]
					},
					{
						"type": "Polygon",
						"id": 191,
						"arcs": [
							[
								321,
								-92,
								322,
								323,
								324,
								325
							]
						]
					},
					{
						"type": "Polygon",
						"id": 332,
						"arcs": [
							[
								-237,
								326
							]
						]
					},
					{
						"type": "Polygon",
						"id": 348,
						"arcs": [
							[
								-48,
								327,
								328,
								329,
								330,
								-326,
								331
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 360,
						"arcs": [
							[
								[
									332
								]
							],
							[
								[
									333,
									334
								]
							],
							[
								[
									335
								]
							],
							[
								[
									336
								]
							],
							[
								[
									337
								]
							],
							[
								[
									338
								]
							],
							[
								[
									339
								]
							],
							[
								[
									340
								]
							],
							[
								[
									341,
									342
								]
							],
							[
								[
									343
								]
							],
							[
								[
									344
								]
							],
							[
								[
									345,
									346
								]
							],
							[
								[
									347
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 356,
						"arcs": [
							[
								-177,
								348,
								-175,
								-116,
								-174,
								349,
								-80,
								350,
								351
							]
						]
					},
					{
						"type": "Polygon",
						"id": 372,
						"arcs": [
							[
								352,
								-286
							]
						]
					},
					{
						"type": "Polygon",
						"id": 364,
						"arcs": [
							[
								353,
								-6,
								354,
								355,
								356,
								357,
								-55,
								-34,
								-57,
								358
							]
						]
					},
					{
						"type": "Polygon",
						"id": 368,
						"arcs": [
							[
								359,
								360,
								361,
								362,
								363,
								364,
								-357
							]
						]
					},
					{
						"type": "Polygon",
						"id": 352,
						"arcs": [
							[
								365
							]
						]
					},
					{
						"type": "Polygon",
						"id": 376,
						"arcs": [
							[
								366,
								367,
								368,
								-252,
								369,
								370,
								371
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 380,
						"arcs": [
							[
								[
									372
								]
							],
							[
								[
									373
								]
							],
							[
								[
									374,
									375,
									-281,
									-162,
									-50
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 388,
						"arcs": [
							[
								376
							]
						]
					},
					{
						"type": "Polygon",
						"id": 400,
						"arcs": [
							[
								-367,
								377,
								-363,
								378,
								379,
								-369,
								380
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 392,
						"arcs": [
							[
								[
									381
								]
							],
							[
								[
									382
								]
							],
							[
								[
									383
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 398,
						"arcs": [
							[
								384,
								385,
								386,
								387,
								-181,
								388
							]
						]
					},
					{
						"type": "Polygon",
						"id": 404,
						"arcs": [
							[
								389,
								390,
								391,
								392,
								-265,
								393
							]
						]
					},
					{
						"type": "Polygon",
						"id": 417,
						"arcs": [
							[
								-389,
								-180,
								394,
								395
							]
						]
					},
					{
						"type": "Polygon",
						"id": 116,
						"arcs": [
							[
								396,
								397,
								398,
								399
							]
						]
					},
					{
						"type": "Polygon",
						"id": 410,
						"arcs": [
							[
								400,
								401
							]
						]
					},
					{
						"type": "Polygon",
						"id": -99,
						"arcs": [
							[
								-18,
								402,
								403,
								404
							]
						]
					},
					{
						"type": "Polygon",
						"id": 414,
						"arcs": [
							[
								405,
								406,
								-361
							]
						]
					},
					{
						"type": "Polygon",
						"id": 418,
						"arcs": [
							[
								407,
								408,
								-172,
								409,
								-398
							]
						]
					},
					{
						"type": "Polygon",
						"id": 422,
						"arcs": [
							[
								-371,
								410,
								411
							]
						]
					},
					{
						"type": "Polygon",
						"id": 430,
						"arcs": [
							[
								412,
								413,
								-294,
								-186
							]
						]
					},
					{
						"type": "Polygon",
						"id": 434,
						"arcs": [
							[
								414,
								-245,
								415,
								416,
								-250,
								417,
								418
							]
						]
					},
					{
						"type": "Polygon",
						"id": 144,
						"arcs": [
							[
								419
							]
						]
					},
					{
						"type": "Polygon",
						"id": 426,
						"arcs": [
							[
								420
							]
						]
					},
					{
						"type": "Polygon",
						"id": 440,
						"arcs": [
							[
								421,
								422,
								423,
								-93,
								424
							]
						]
					},
					{
						"type": "Polygon",
						"id": 442,
						"arcs": [
							[
								-226,
								-280,
								-65
							]
						]
					},
					{
						"type": "Polygon",
						"id": 428,
						"arcs": [
							[
								425,
								-262,
								426,
								-94,
								-424
							]
						]
					},
					{
						"type": "Polygon",
						"id": 504,
						"arcs": [
							[
								-242,
								427,
								428
							]
						]
					},
					{
						"type": "Polygon",
						"id": 498,
						"arcs": [
							[
								429,
								430
							]
						]
					},
					{
						"type": "Polygon",
						"id": 450,
						"arcs": [
							[
								431
							]
						]
					},
					{
						"type": "Polygon",
						"id": 484,
						"arcs": [
							[
								432,
								-98,
								-311,
								433,
								434
							]
						]
					},
					{
						"type": "Polygon",
						"id": 807,
						"arcs": [
							[
								-405,
								435,
								-85,
								-307,
								-14
							]
						]
					},
					{
						"type": "Polygon",
						"id": 466,
						"arcs": [
							[
								436,
								-239,
								437,
								-74,
								-188,
								-299,
								438
							]
						]
					},
					{
						"type": "Polygon",
						"id": 104,
						"arcs": [
							[
								439,
								-78,
								-350,
								-173,
								-409,
								440
							]
						]
					},
					{
						"type": "Polygon",
						"id": 499,
						"arcs": [
							[
								441,
								-323,
								-91,
								442,
								-403,
								-17
							]
						]
					},
					{
						"type": "Polygon",
						"id": 496,
						"arcs": [
							[
								443,
								-183
							]
						]
					},
					{
						"type": "Polygon",
						"id": 508,
						"arcs": [
							[
								444,
								445,
								446,
								447,
								448,
								449,
								450,
								451
							]
						]
					},
					{
						"type": "Polygon",
						"id": 478,
						"arcs": [
							[
								452,
								453,
								454,
								-240,
								-437
							]
						]
					},
					{
						"type": "Polygon",
						"id": 454,
						"arcs": [
							[
								-452,
								455,
								456
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 458,
						"arcs": [
							[
								[
									457,
									458
								]
							],
							[
								[
									-346,
									459,
									-115,
									460
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 516,
						"arcs": [
							[
								461,
								-8,
								462,
								-119,
								463
							]
						]
					},
					{
						"type": "Polygon",
						"id": 540,
						"arcs": [
							[
								464
							]
						]
					},
					{
						"type": "Polygon",
						"id": 562,
						"arcs": [
							[
								-75,
								-438,
								-238,
								-415,
								465,
								-194,
								466,
								-71
							]
						]
					},
					{
						"type": "Polygon",
						"id": 566,
						"arcs": [
							[
								467,
								-72,
								-467,
								-193
							]
						]
					},
					{
						"type": "Polygon",
						"id": 558,
						"arcs": [
							[
								468,
								-321,
								469,
								-213
							]
						]
					},
					{
						"type": "Polygon",
						"id": 528,
						"arcs": [
							[
								-227,
								-63,
								470
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 578,
						"arcs": [
							[
								[
									471,
									-272,
									472,
									473
								]
							],
							[
								[
									474
								]
							],
							[
								[
									475
								]
							],
							[
								[
									476
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 524,
						"arcs": [
							[
								-349,
								-176
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 554,
						"arcs": [
							[
								[
									477
								]
							],
							[
								[
									478
								]
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 512,
						"arcs": [
							[
								[
									479,
									480,
									-22,
									481
								]
							],
							[
								[
									-20,
									482
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 586,
						"arcs": [
							[
								-178,
								-352,
								483,
								-355,
								-5
							]
						]
					},
					{
						"type": "Polygon",
						"id": 591,
						"arcs": [
							[
								484,
								-215,
								485,
								-208
							]
						]
					},
					{
						"type": "Polygon",
						"id": 604,
						"arcs": [
							[
								-167,
								486,
								-247,
								-211,
								-106,
								-102
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 608,
						"arcs": [
							[
								[
									487
								]
							],
							[
								[
									488
								]
							],
							[
								[
									489
								]
							],
							[
								[
									490
								]
							],
							[
								[
									491
								]
							],
							[
								[
									492
								]
							],
							[
								[
									493
								]
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 598,
						"arcs": [
							[
								[
									494
								]
							],
							[
								[
									495
								]
							],
							[
								[
									-342,
									496
								]
							],
							[
								[
									497
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 616,
						"arcs": [
							[
								-224,
								498,
								499,
								-425,
								-97,
								500,
								501,
								-221
							]
						]
					},
					{
						"type": "Polygon",
						"id": 630,
						"arcs": [
							[
								502
							]
						]
					},
					{
						"type": "Polygon",
						"id": 408,
						"arcs": [
							[
								503,
								504,
								-402,
								505,
								-169
							]
						]
					},
					{
						"type": "Polygon",
						"id": 620,
						"arcs": [
							[
								-259,
								506
							]
						]
					},
					{
						"type": "Polygon",
						"id": 600,
						"arcs": [
							[
								-104,
								-105,
								-26
							]
						]
					},
					{
						"type": "Polygon",
						"id": 275,
						"arcs": [
							[
								-381,
								-368
							]
						]
					},
					{
						"type": "Polygon",
						"id": 634,
						"arcs": [
							[
								507,
								508
							]
						]
					},
					{
						"type": "Polygon",
						"id": 642,
						"arcs": [
							[
								509,
								-431,
								510,
								511,
								-81,
								512,
								-330
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 643,
						"arcs": [
							[
								[
									513
								]
							],
							[
								[
									-500,
									514,
									-422
								]
							],
							[
								[
									515
								]
							],
							[
								[
									516
								]
							],
							[
								[
									517
								]
							],
							[
								[
									518
								]
							],
							[
								[
									519
								]
							],
							[
								[
									-504,
									-184,
									-444,
									-182,
									-388,
									520,
									-59,
									-290,
									521,
									522,
									-95,
									-427,
									-261,
									523,
									-269,
									-472,
									524
								]
							],
							[
								[
									525
								]
							],
							[
								[
									526
								]
							],
							[
								[
									527
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 646,
						"arcs": [
							[
								528,
								-61,
								-198,
								529
							]
						]
					},
					{
						"type": "Polygon",
						"id": 732,
						"arcs": [
							[
								-241,
								-455,
								530,
								-428
							]
						]
					},
					{
						"type": "Polygon",
						"id": 682,
						"arcs": [
							[
								531,
								-379,
								-362,
								-407,
								532,
								-509,
								533,
								-23,
								-481,
								534
							]
						]
					},
					{
						"type": "Polygon",
						"id": 729,
						"arcs": [
							[
								535,
								536,
								-123,
								537,
								-418,
								-249,
								538,
								-254,
								-268,
								539
							]
						]
					},
					{
						"type": "Polygon",
						"id": 728,
						"arcs": [
							[
								540,
								-266,
								-393,
								541,
								-203,
								-125,
								542,
								-536
							]
						]
					},
					{
						"type": "Polygon",
						"id": 686,
						"arcs": [
							[
								543,
								-453,
								-439,
								-298,
								-303,
								544,
								-301
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 90,
						"arcs": [
							[
								[
									545
								]
							],
							[
								[
									546
								]
							],
							[
								[
									547
								]
							],
							[
								[
									548
								]
							],
							[
								[
									549
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 694,
						"arcs": [
							[
								550,
								-295,
								-414
							]
						]
					},
					{
						"type": "Polygon",
						"id": 222,
						"arcs": [
							[
								551,
								-314,
								-319
							]
						]
					},
					{
						"type": "Polygon",
						"id": -99,
						"arcs": [
							[
								-263,
								-231,
								552,
								553
							]
						]
					},
					{
						"type": "Polygon",
						"id": 706,
						"arcs": [
							[
								-394,
								-264,
								-554,
								554
							]
						]
					},
					{
						"type": "Polygon",
						"id": 688,
						"arcs": [
							[
								-86,
								-436,
								-404,
								-443,
								-90,
								-322,
								-331,
								-513
							]
						]
					},
					{
						"type": "Polygon",
						"id": 740,
						"arcs": [
							[
								555,
								-277,
								556,
								-110,
								-316
							]
						]
					},
					{
						"type": "Polygon",
						"id": 703,
						"arcs": [
							[
								-502,
								557,
								-328,
								-54,
								-222
							]
						]
					},
					{
						"type": "Polygon",
						"id": 705,
						"arcs": [
							[
								-49,
								-332,
								-325,
								558,
								-375
							]
						]
					},
					{
						"type": "Polygon",
						"id": 752,
						"arcs": [
							[
								-473,
								-271,
								559
							]
						]
					},
					{
						"type": "Polygon",
						"id": 748,
						"arcs": [
							[
								560,
								-448
							]
						]
					},
					{
						"type": "Polygon",
						"id": 760,
						"arcs": [
							[
								-378,
								-372,
								-412,
								561,
								562,
								-364
							]
						]
					},
					{
						"type": "Polygon",
						"id": 148,
						"arcs": [
							[
								-466,
								-419,
								-538,
								-122,
								-195
							]
						]
					},
					{
						"type": "Polygon",
						"id": 768,
						"arcs": [
							[
								563,
								-293,
								-76,
								-69
							]
						]
					},
					{
						"type": "Polygon",
						"id": 764,
						"arcs": [
							[
								564,
								-459,
								565,
								-441,
								-408,
								-397
							]
						]
					},
					{
						"type": "Polygon",
						"id": 762,
						"arcs": [
							[
								-395,
								-179,
								-3,
								566
							]
						]
					},
					{
						"type": "Polygon",
						"id": 795,
						"arcs": [
							[
								-354,
								567,
								-386,
								568,
								-1
							]
						]
					},
					{
						"type": "Polygon",
						"id": 626,
						"arcs": [
							[
								569,
								-334
							]
						]
					},
					{
						"type": "Polygon",
						"id": 780,
						"arcs": [
							[
								570
							]
						]
					},
					{
						"type": "Polygon",
						"id": 788,
						"arcs": [
							[
								-244,
								571,
								-416
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 792,
						"arcs": [
							[
								[
									-291,
									-36,
									-358,
									-365,
									-563,
									572
								]
							],
							[
								[
									-308,
									-83,
									573
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 158,
						"arcs": [
							[
								574
							]
						]
					},
					{
						"type": "Polygon",
						"id": 834,
						"arcs": [
							[
								-391,
								575,
								-445,
								-457,
								576,
								-199,
								-62,
								-529,
								577
							]
						]
					},
					{
						"type": "Polygon",
						"id": 800,
						"arcs": [
							[
								-530,
								-197,
								-542,
								-392,
								-578
							]
						]
					},
					{
						"type": "Polygon",
						"id": 804,
						"arcs": [
							[
								-523,
								578,
								-511,
								-430,
								-510,
								-329,
								-558,
								-501,
								-96
							]
						]
					},
					{
						"type": "Polygon",
						"id": 858,
						"arcs": [
							[
								-113,
								579,
								-28
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 840,
						"arcs": [
							[
								[
									580
								]
							],
							[
								[
									581
								]
							],
							[
								[
									582
								]
							],
							[
								[
									583
								]
							],
							[
								[
									584
								]
							],
							[
								[
									585,
									-435,
									586,
									-139
								]
							],
							[
								[
									587
								]
							],
							[
								[
									588
								]
							],
							[
								[
									589
								]
							],
							[
								[
									-141,
									590
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 860,
						"arcs": [
							[
								-569,
								-385,
								-396,
								-567,
								-2
							]
						]
					},
					{
						"type": "Polygon",
						"id": 862,
						"arcs": [
							[
								591,
								-317,
								-108,
								-210
							]
						]
					},
					{
						"type": "Polygon",
						"id": 704,
						"arcs": [
							[
								592,
								-399,
								-410,
								-171
							]
						]
					},
					{
						"type": "MultiPolygon",
						"id": 548,
						"arcs": [
							[
								[
									593
								]
							],
							[
								[
									594
								]
							]
						]
					},
					{
						"type": "Polygon",
						"id": 887,
						"arcs": [
							[
								595,
								-535,
								-480
							]
						]
					},
					{
						"type": "Polygon",
						"id": 710,
						"arcs": [
							[
								-464,
								-118,
								596,
								-449,
								-561,
								-447,
								597
							],
							[
								-421
							]
						]
					},
					{
						"type": "Polygon",
						"id": 894,
						"arcs": [
							[
								-456,
								-451,
								598,
								-120,
								-463,
								-7,
								-200,
								-577
							]
						]
					},
					{
						"type": "Polygon",
						"id": 716,
						"arcs": [
							[
								-597,
								-121,
								-599,
								-450
							]
						]
					}
				]
			},
			"land": {
				"type": "MultiPolygon",
				"arcs": [
					[
						[
							540,
							266,
							539
						],
						[
							123,
							542,
							536
						],
						[
							592,
							399,
							564,
							457,
							565,
							439,
							78,
							350,
							483,
							355,
							359,
							405,
							532,
							507,
							533,
							18,
							482,
							20,
							481,
							595,
							531,
							379,
							247,
							538,
							254,
							229,
							552,
							554,
							389,
							575,
							445,
							597,
							461,
							8,
							200,
							10,
							203,
							283,
							303,
							191,
							467,
							67,
							563,
							291,
							184,
							412,
							550,
							295,
							301,
							544,
							299,
							543,
							453,
							530,
							428,
							242,
							571,
							416,
							250,
							369,
							410,
							561,
							572,
							288,
							521,
							578,
							511,
							81,
							573,
							305,
							15,
							441,
							323,
							558,
							375,
							281,
							257,
							506,
							255,
							282,
							66,
							470,
							227,
							234,
							222,
							498,
							514,
							422,
							425,
							259,
							523,
							269,
							559,
							473,
							524,
							504,
							400,
							505,
							169
						],
						[
							386,
							520,
							55,
							358,
							567
						]
					],
					[
						[
							24,
							164
						]
					],
					[
						[
							556,
							275
						],
						[
							579,
							28,
							165,
							486,
							245,
							206,
							484,
							211,
							468,
							317,
							551,
							309,
							433,
							586,
							139,
							590,
							141,
							585,
							432,
							98,
							311,
							319,
							469,
							213,
							485,
							208,
							591,
							314,
							555,
							277,
							111
						]
					],
					[
						[
							36
						]
					],
					[
						[
							37
						]
					],
					[
						[
							38
						]
					],
					[
						[
							39
						]
					],
					[
						[
							40
						]
					],
					[
						[
							41
						]
					],
					[
						[
							42
						]
					],
					[
						[
							43
						]
					],
					[
						[
							44
						]
					],
					[
						[
							45
						]
					],
					[
						[
							46
						]
					],
					[
						[
							86
						]
					],
					[
						[
							87
						]
					],
					[
						[
							88
						]
					],
					[
						[
							459,
							113,
							460,
							346
						]
					],
					[
						[
							128
						]
					],
					[
						[
							129
						]
					],
					[
						[
							130
						]
					],
					[
						[
							131
						]
					],
					[
						[
							132
						]
					],
					[
						[
							133
						]
					],
					[
						[
							134
						]
					],
					[
						[
							135
						]
					],
					[
						[
							136
						]
					],
					[
						[
							137
						]
					],
					[
						[
							142
						]
					],
					[
						[
							143
						]
					],
					[
						[
							144
						]
					],
					[
						[
							145
						]
					],
					[
						[
							146
						]
					],
					[
						[
							147
						]
					],
					[
						[
							148
						]
					],
					[
						[
							149
						]
					],
					[
						[
							150
						]
					],
					[
						[
							151
						]
					],
					[
						[
							152
						]
					],
					[
						[
							153
						]
					],
					[
						[
							154
						]
					],
					[
						[
							155
						]
					],
					[
						[
							156
						]
					],
					[
						[
							157
						]
					],
					[
						[
							158
						]
					],
					[
						[
							159
						]
					],
					[
						[
							160
						]
					],
					[
						[
							167
						]
					],
					[
						[
							215
						]
					],
					[
						[
							216,
							218
						]
					],
					[
						[
							233
						]
					],
					[
						[
							235,
							326
						]
					],
					[
						[
							272
						]
					],
					[
						[
							273
						]
					],
					[
						[
							274
						]
					],
					[
						[
							278
						]
					],
					[
						[
							286,
							352
						]
					],
					[
						[
							287
						]
					],
					[
						[
							304
						]
					],
					[
						[
							308
						]
					],
					[
						[
							332
						]
					],
					[
						[
							334,
							569
						]
					],
					[
						[
							335
						]
					],
					[
						[
							336
						]
					],
					[
						[
							337
						]
					],
					[
						[
							338
						]
					],
					[
						[
							339
						]
					],
					[
						[
							340
						]
					],
					[
						[
							342,
							496
						]
					],
					[
						[
							343
						]
					],
					[
						[
							344
						]
					],
					[
						[
							347
						]
					],
					[
						[
							365
						]
					],
					[
						[
							372
						]
					],
					[
						[
							373
						]
					],
					[
						[
							376
						]
					],
					[
						[
							381
						]
					],
					[
						[
							382
						]
					],
					[
						[
							383
						]
					],
					[
						[
							419
						]
					],
					[
						[
							431
						]
					],
					[
						[
							464
						]
					],
					[
						[
							474
						]
					],
					[
						[
							475
						]
					],
					[
						[
							476
						]
					],
					[
						[
							477
						]
					],
					[
						[
							478
						]
					],
					[
						[
							487
						]
					],
					[
						[
							488
						]
					],
					[
						[
							489
						]
					],
					[
						[
							490
						]
					],
					[
						[
							491
						]
					],
					[
						[
							492
						]
					],
					[
						[
							493
						]
					],
					[
						[
							494
						]
					],
					[
						[
							495
						]
					],
					[
						[
							497
						]
					],
					[
						[
							502
						]
					],
					[
						[
							513
						]
					],
					[
						[
							515
						]
					],
					[
						[
							516
						]
					],
					[
						[
							517
						]
					],
					[
						[
							518
						]
					],
					[
						[
							519
						]
					],
					[
						[
							525
						]
					],
					[
						[
							526
						]
					],
					[
						[
							527
						]
					],
					[
						[
							545
						]
					],
					[
						[
							546
						]
					],
					[
						[
							547
						]
					],
					[
						[
							548
						]
					],
					[
						[
							549
						]
					],
					[
						[
							570
						]
					],
					[
						[
							574
						]
					],
					[
						[
							580
						]
					],
					[
						[
							581
						]
					],
					[
						[
							582
						]
					],
					[
						[
							583
						]
					],
					[
						[
							584
						]
					],
					[
						[
							587
						]
					],
					[
						[
							588
						]
					],
					[
						[
							589
						]
					],
					[
						[
							593
						]
					],
					[
						[
							594
						]
					]
				]
			}
		},
		"arcs": [
			[
				[
					67002,
					72360
				],
				[
					284,
					-219
				],
				[
					209,
					77
				],
				[
					58,
					261
				],
				[
					219,
					87
				],
				[
					157,
					175
				],
				[
					55,
					460
				],
				[
					234,
					112
				],
				[
					44,
					205
				],
				[
					131,
					-154
				],
				[
					84,
					-18
				]
			],
			[
				[
					68477,
					73346
				],
				[
					154,
					-4
				],
				[
					210,
					-122
				]
			],
			[
				[
					68841,
					73220
				],
				[
					85,
					-70
				],
				[
					201,
					185
				],
				[
					93,
					-111
				],
				[
					90,
					264
				],
				[
					166,
					-12
				],
				[
					43,
					84
				],
				[
					29,
					233
				],
				[
					120,
					200
				],
				[
					150,
					-131
				],
				[
					-30,
					-176
				],
				[
					84,
					-27
				],
				[
					-26,
					-484
				],
				[
					110,
					-189
				],
				[
					97,
					121
				],
				[
					123,
					57
				],
				[
					173,
					258
				],
				[
					192,
					-42
				],
				[
					286,
					-1
				]
			],
			[
				[
					70827,
					73379
				],
				[
					50,
					-165
				]
			],
			[
				[
					70877,
					73214
				],
				[
					-162,
					-65
				],
				[
					-141,
					-106
				],
				[
					-319,
					-67
				],
				[
					-298,
					-121
				],
				[
					-163,
					-251
				],
				[
					66,
					-244
				],
				[
					32,
					-287
				],
				[
					-139,
					-242
				],
				[
					12,
					-221
				],
				[
					-76,
					-207
				],
				[
					-265,
					18
				],
				[
					110,
					-381
				],
				[
					-177,
					-146
				],
				[
					-118,
					-347
				],
				[
					15,
					-346
				],
				[
					-108,
					-162
				],
				[
					-103,
					53
				],
				[
					-212,
					-75
				],
				[
					-31,
					-161
				],
				[
					-207,
					1
				],
				[
					-154,
					-326
				],
				[
					-10,
					-490
				],
				[
					-361,
					-239
				],
				[
					-194,
					50
				],
				[
					-56,
					-126
				],
				[
					-166,
					74
				],
				[
					-278,
					-87
				],
				[
					-465,
					294
				]
			],
			[
				[
					66909,
					69007
				],
				[
					252,
					523
				],
				[
					-23,
					370
				],
				[
					-210,
					97
				],
				[
					-22,
					366
				],
				[
					-91,
					460
				],
				[
					119,
					315
				],
				[
					-121,
					85
				],
				[
					76,
					419
				],
				[
					113,
					718
				]
			],
			[
				[
					56642,
					45537
				],
				[
					29,
					-179
				],
				[
					-32,
					-279
				],
				[
					49,
					-270
				],
				[
					-41,
					-216
				],
				[
					24,
					-199
				],
				[
					-579,
					7
				],
				[
					-13,
					-1832
				],
				[
					188,
					-471
				],
				[
					181,
					-360
				]
			],
			[
				[
					56448,
					41738
				],
				[
					-510,
					-235
				],
				[
					-673,
					82
				],
				[
					-192,
					276
				],
				[
					-1126,
					-25
				],
				[
					-42,
					-40
				],
				[
					-166,
					260
				],
				[
					-180,
					17
				],
				[
					-166,
					-98
				],
				[
					-134,
					-110
				]
			],
			[
				[
					53259,
					41865
				],
				[
					-26,
					363
				],
				[
					38,
					506
				],
				[
					96,
					527
				],
				[
					15,
					247
				],
				[
					90,
					519
				],
				[
					66,
					236
				],
				[
					159,
					377
				],
				[
					90,
					256
				],
				[
					29,
					427
				],
				[
					-15,
					326
				],
				[
					-83,
					206
				],
				[
					-74,
					350
				],
				[
					-68,
					345
				],
				[
					15,
					120
				],
				[
					85,
					228
				],
				[
					-84,
					557
				],
				[
					-57,
					385
				],
				[
					-139,
					364
				],
				[
					26,
					112
				]
			],
			[
				[
					53422,
					48316
				],
				[
					115,
					78
				],
				[
					80,
					-11
				],
				[
					98,
					69
				],
				[
					820,
					-7
				],
				[
					68,
					-430
				],
				[
					80,
					-345
				],
				[
					64,
					-186
				],
				[
					106,
					-301
				],
				[
					184,
					46
				],
				[
					91,
					81
				],
				[
					154,
					-81
				],
				[
					42,
					144
				],
				[
					69,
					336
				],
				[
					172,
					22
				],
				[
					15,
					100
				],
				[
					142,
					2
				],
				[
					-24,
					-207
				],
				[
					337,
					5
				],
				[
					5,
					-363
				],
				[
					56,
					-222
				],
				[
					-41,
					-347
				],
				[
					21,
					-354
				],
				[
					93,
					-214
				],
				[
					-15,
					-685
				],
				[
					68,
					53
				],
				[
					121,
					-15
				],
				[
					172,
					87
				],
				[
					127,
					-34
				]
			],
			[
				[
					53383,
					48495
				],
				[
					-74,
					433
				]
			],
			[
				[
					53309,
					48928
				],
				[
					112,
					249
				],
				[
					84,
					97
				],
				[
					104,
					-198
				]
			],
			[
				[
					53609,
					49076
				],
				[
					-101,
					-121
				],
				[
					-45,
					-148
				],
				[
					-9,
					-251
				],
				[
					-71,
					-61
				]
			],
			[
				[
					55719,
					75933
				],
				[
					-35,
					-196
				],
				[
					39,
					-247
				],
				[
					115,
					-140
				]
			],
			[
				[
					55838,
					75350
				],
				[
					-5,
					-151
				],
				[
					-91,
					-84
				],
				[
					-16,
					-187
				],
				[
					-129,
					-279
				]
			],
			[
				[
					55597,
					74649
				],
				[
					-48,
					40
				],
				[
					-5,
					127
				],
				[
					-154,
					193
				],
				[
					-24,
					274
				],
				[
					23,
					393
				],
				[
					38,
					179
				],
				[
					-47,
					91
				]
			],
			[
				[
					55380,
					75946
				],
				[
					-18,
					183
				],
				[
					120,
					284
				],
				[
					18,
					-109
				],
				[
					75,
					51
				]
			],
			[
				[
					55575,
					76355
				],
				[
					59,
					-154
				],
				[
					66,
					-59
				],
				[
					19,
					-209
				]
			],
			[
				[
					64327,
					65792
				],
				[
					49,
					28
				],
				[
					11,
					-158
				],
				[
					217,
					91
				],
				[
					230,
					-15
				],
				[
					168,
					-17
				],
				[
					190,
					389
				],
				[
					207,
					369
				],
				[
					176,
					355
				]
			],
			[
				[
					65575,
					66834
				],
				[
					52,
					-196
				]
			],
			[
				[
					65627,
					66638
				],
				[
					38,
					-455
				]
			],
			[
				[
					65665,
					66183
				],
				[
					-142,
					-2
				],
				[
					-23,
					-375
				],
				[
					50,
					-80
				],
				[
					-126,
					-114
				],
				[
					-1,
					-235
				],
				[
					-81,
					-238
				],
				[
					-7,
					-232
				]
			],
			[
				[
					65335,
					64907
				],
				[
					-56,
					-122
				],
				[
					-835,
					290
				],
				[
					-106,
					584
				],
				[
					-11,
					133
				]
			],
			[
				[
					31400,
					20215
				],
				[
					-168,
					16
				],
				[
					-297,
					0
				],
				[
					0,
					1286
				]
			],
			[
				[
					30935,
					21517
				],
				[
					106,
					-267
				],
				[
					139,
					-432
				],
				[
					361,
					-345
				],
				[
					389,
					-144
				],
				[
					-125,
					-288
				],
				[
					-264,
					-29
				],
				[
					-141,
					203
				]
			],
			[
				[
					32587,
					39017
				],
				[
					511,
					-940
				],
				[
					227,
					-88
				],
				[
					339,
					-425
				],
				[
					286,
					-225
				],
				[
					40,
					-254
				],
				[
					-273,
					-876
				],
				[
					280,
					-156
				],
				[
					312,
					-88
				],
				[
					220,
					92
				],
				[
					252,
					441
				],
				[
					45,
					509
				]
			],
			[
				[
					34826,
					37007
				],
				[
					138,
					110
				],
				[
					139,
					-332
				],
				[
					-6,
					-460
				],
				[
					-234,
					-318
				],
				[
					-186,
					-234
				],
				[
					-314,
					-559
				],
				[
					-370,
					-786
				]
			],
			[
				[
					33993,
					34428
				],
				[
					-70,
					-461
				],
				[
					-74,
					-592
				],
				[
					3,
					-573
				],
				[
					-61,
					-128
				],
				[
					-21,
					-372
				]
			],
			[
				[
					33770,
					32302
				],
				[
					-19,
					-301
				],
				[
					353,
					-493
				],
				[
					-38,
					-397
				],
				[
					173,
					-251
				],
				[
					-14,
					-282
				],
				[
					-267,
					-738
				],
				[
					-412,
					-309
				],
				[
					-557,
					-120
				],
				[
					-305,
					58
				],
				[
					59,
					-343
				],
				[
					-57,
					-431
				],
				[
					51,
					-291
				],
				[
					-167,
					-202
				],
				[
					-284,
					-80
				],
				[
					-267,
					210
				],
				[
					-108,
					-151
				],
				[
					39,
					-572
				],
				[
					188,
					-173
				],
				[
					152,
					181
				],
				[
					82,
					-299
				],
				[
					-255,
					-179
				],
				[
					-223,
					-358
				],
				[
					-41,
					-579
				],
				[
					-66,
					-309
				],
				[
					-262,
					-1
				],
				[
					-218,
					-295
				],
				[
					-80,
					-432
				],
				[
					273,
					-422
				],
				[
					266,
					-116
				],
				[
					-96,
					-517
				],
				[
					-328,
					-325
				],
				[
					-180,
					-675
				],
				[
					-254,
					-227
				],
				[
					-113,
					-270
				],
				[
					89,
					-598
				],
				[
					185,
					-333
				],
				[
					-117,
					29
				]
			],
			[
				[
					30952,
					21711
				],
				[
					-257,
					90
				],
				[
					-672,
					77
				],
				[
					-115,
					336
				],
				[
					6,
					431
				],
				[
					-185,
					-37
				],
				[
					-98,
					209
				],
				[
					-24,
					611
				],
				[
					213,
					253
				],
				[
					88,
					365
				],
				[
					-33,
					292
				],
				[
					148,
					491
				],
				[
					101,
					763
				],
				[
					-30,
					338
				],
				[
					122,
					109
				],
				[
					-30,
					217
				],
				[
					-129,
					115
				],
				[
					92,
					242
				],
				[
					-126,
					218
				],
				[
					-65,
					665
				],
				[
					112,
					117
				],
				[
					-47,
					702
				],
				[
					65,
					590
				],
				[
					75,
					513
				],
				[
					166,
					209
				],
				[
					-84,
					563
				],
				[
					-1,
					529
				],
				[
					210,
					376
				],
				[
					-7,
					481
				],
				[
					159,
					562
				],
				[
					1,
					530
				],
				[
					-72,
					105
				],
				[
					-128,
					994
				],
				[
					171,
					592
				],
				[
					-27,
					558
				],
				[
					100,
					523
				],
				[
					182,
					540
				],
				[
					196,
					358
				],
				[
					-83,
					226
				],
				[
					58,
					186
				],
				[
					-9,
					960
				],
				[
					302,
					284
				],
				[
					96,
					598
				],
				[
					-34,
					144
				]
			],
			[
				[
					31359,
					38736
				],
				[
					231,
					521
				],
				[
					364,
					-141
				],
				[
					163,
					-416
				],
				[
					109,
					464
				],
				[
					316,
					-24
				],
				[
					45,
					-123
				]
			],
			[
				[
					62106,
					75494
				],
				[
					386,
					89
				]
			],
			[
				[
					62492,
					75583
				],
				[
					57,
					-151
				],
				[
					106,
					-100
				],
				[
					-56,
					-144
				],
				[
					148,
					-198
				],
				[
					-78,
					-183
				],
				[
					118,
					-157
				],
				[
					124,
					-94
				],
				[
					7,
					-399
				]
			],
			[
				[
					62918,
					74157
				],
				[
					-101,
					-17
				]
			],
			[
				[
					62817,
					74140
				],
				[
					-113,
					333
				],
				[
					1,
					89
				],
				[
					-123,
					-2
				],
				[
					-82,
					155
				],
				[
					-58,
					-16
				]
			],
			[
				[
					62442,
					74699
				],
				[
					-109,
					168
				],
				[
					-207,
					144
				],
				[
					27,
					280
				],
				[
					-47,
					203
				]
			],
			[
				[
					33452,
					5736
				],
				[
					-82,
					-294
				],
				[
					-81,
					-259
				],
				[
					-582,
					79
				],
				[
					-621,
					-34
				],
				[
					-348,
					192
				],
				[
					0,
					22
				],
				[
					-152,
					170
				],
				[
					625,
					-23
				],
				[
					599,
					-56
				],
				[
					207,
					237
				],
				[
					147,
					203
				],
				[
					288,
					-237
				]
			],
			[
				[
					5775,
					6048
				],
				[
					-533,
					-79
				],
				[
					-364,
					204
				],
				[
					-163,
					203
				],
				[
					-11,
					34
				],
				[
					-180,
					158
				],
				[
					169,
					214
				],
				[
					517,
					-90
				],
				[
					277,
					-181
				],
				[
					212,
					-203
				],
				[
					76,
					-260
				]
			],
			[
				[
					37457,
					6883
				],
				[
					342,
					-248
				],
				[
					120,
					-350
				],
				[
					33,
					-248
				],
				[
					11,
					-293
				],
				[
					-430,
					-181
				],
				[
					-452,
					-146
				],
				[
					-522,
					-136
				],
				[
					-582,
					-113
				],
				[
					-658,
					34
				],
				[
					-365,
					192
				],
				[
					49,
					237
				],
				[
					593,
					158
				],
				[
					239,
					192
				],
				[
					174,
					248
				],
				[
					126,
					214
				],
				[
					168,
					203
				],
				[
					180,
					238
				],
				[
					0,
					-1
				],
				[
					141,
					0
				],
				[
					414,
					125
				],
				[
					419,
					-125
				]
			],
			[
				[
					16330,
					9501
				],
				[
					359,
					-90
				],
				[
					332,
					102
				],
				[
					-158,
					-203
				],
				[
					-261,
					-147
				],
				[
					-386,
					45
				],
				[
					-278,
					203
				],
				[
					60,
					192
				],
				[
					332,
					-102
				]
			],
			[
				[
					15122,
					9513
				],
				[
					425,
					-226
				],
				[
					-164,
					23
				],
				[
					-359,
					56
				],
				[
					-381,
					158
				],
				[
					202,
					124
				],
				[
					277,
					-135
				]
			],
			[
				[
					22505,
					10404
				],
				[
					305,
					-79
				],
				[
					304,
					68
				],
				[
					163,
					-327
				],
				[
					-217,
					45
				],
				[
					-337,
					-23
				],
				[
					-343,
					23
				],
				[
					-376,
					-34
				],
				[
					-283,
					113
				],
				[
					-146,
					237
				],
				[
					174,
					101
				],
				[
					353,
					-79
				],
				[
					403,
					-45
				]
			],
			[
				[
					30985,
					10967
				],
				[
					33,
					-259
				],
				[
					-49,
					-226
				],
				[
					-76,
					-214
				],
				[
					-326,
					-79
				],
				[
					-311,
					-113
				],
				[
					-364,
					11
				],
				[
					136,
					226
				],
				[
					-327,
					-79
				],
				[
					-310,
					-79
				],
				[
					-212,
					169
				],
				[
					-16,
					237
				],
				[
					305,
					226
				],
				[
					190,
					67
				],
				[
					321,
					-22
				],
				[
					82,
					293
				],
				[
					16,
					215
				],
				[
					-6,
					462
				],
				[
					158,
					271
				],
				[
					256,
					90
				],
				[
					147,
					-214
				],
				[
					65,
					-214
				],
				[
					120,
					-260
				],
				[
					92,
					-248
				],
				[
					76,
					-260
				]
			],
			[
				[
					0,
					3044
				],
				[
					16,
					-4
				],
				[
					245,
					335
				],
				[
					501,
					-181
				],
				[
					32,
					21
				],
				[
					294,
					183
				],
				[
					38,
					-6
				],
				[
					32,
					-5
				],
				[
					402,
					-239
				],
				[
					352,
					239
				],
				[
					63,
					33
				],
				[
					816,
					102
				],
				[
					265,
					-135
				],
				[
					130,
					-68
				],
				[
					419,
					-192
				],
				[
					789,
					-147
				],
				[
					625,
					-180
				],
				[
					1072,
					-136
				],
				[
					800,
					158
				],
				[
					1181,
					-113
				],
				[
					669,
					-180
				],
				[
					734,
					169
				],
				[
					773,
					158
				],
				[
					60,
					271
				],
				[
					-1094,
					22
				],
				[
					-898,
					136
				],
				[
					-234,
					225
				],
				[
					-745,
					125
				],
				[
					49,
					259
				],
				[
					103,
					237
				],
				[
					104,
					214
				],
				[
					-55,
					237
				],
				[
					-462,
					158
				],
				[
					-212,
					204
				],
				[
					-430,
					180
				],
				[
					675,
					-34
				],
				[
					642,
					91
				],
				[
					402,
					-192
				],
				[
					495,
					169
				],
				[
					457,
					214
				],
				[
					223,
					192
				],
				[
					-98,
					237
				],
				[
					-359,
					158
				],
				[
					-408,
					169
				],
				[
					-571,
					34
				],
				[
					-500,
					79
				],
				[
					-539,
					57
				],
				[
					-180,
					214
				],
				[
					-359,
					181
				],
				[
					-217,
					203
				],
				[
					-87,
					654
				],
				[
					136,
					-56
				],
				[
					250,
					-181
				],
				[
					457,
					57
				],
				[
					441,
					79
				],
				[
					228,
					-249
				],
				[
					441,
					57
				],
				[
					370,
					124
				],
				[
					348,
					158
				],
				[
					315,
					192
				],
				[
					419,
					56
				],
				[
					-11,
					215
				],
				[
					-97,
					214
				],
				[
					81,
					203
				],
				[
					359,
					102
				],
				[
					163,
					-192
				],
				[
					425,
					113
				],
				[
					321,
					146
				],
				[
					397,
					12
				],
				[
					375,
					56
				],
				[
					376,
					136
				],
				[
					299,
					124
				],
				[
					337,
					124
				],
				[
					218,
					-34
				],
				[
					190,
					-45
				],
				[
					414,
					79
				],
				[
					370,
					-102
				],
				[
					381,
					12
				],
				[
					364,
					79
				],
				[
					375,
					-57
				],
				[
					414,
					-56
				],
				[
					386,
					22
				],
				[
					403,
					-11
				],
				[
					413,
					-11
				],
				[
					381,
					22
				],
				[
					283,
					170
				],
				[
					337,
					90
				],
				[
					349,
					-124
				],
				[
					331,
					101
				],
				[
					300,
					203
				],
				[
					179,
					-180
				],
				[
					98,
					-203
				],
				[
					180,
					-192
				],
				[
					288,
					169
				],
				[
					332,
					-214
				],
				[
					375,
					-68
				],
				[
					321,
					-158
				],
				[
					392,
					34
				],
				[
					354,
					101
				],
				[
					418,
					-22
				],
				[
					376,
					-79
				],
				[
					381,
					-102
				],
				[
					147,
					249
				],
				[
					-180,
					191
				],
				[
					-136,
					204
				],
				[
					-359,
					45
				],
				[
					-158,
					214
				],
				[
					-60,
					214
				],
				[
					-98,
					429
				],
				[
					213,
					-79
				],
				[
					364,
					-34
				],
				[
					359,
					34
				],
				[
					327,
					-90
				],
				[
					283,
					-169
				],
				[
					119,
					-203
				],
				[
					376,
					-34
				],
				[
					359,
					79
				],
				[
					381,
					113
				],
				[
					342,
					67
				],
				[
					283,
					-135
				],
				[
					370,
					45
				],
				[
					239,
					440
				],
				[
					224,
					-259
				],
				[
					321,
					-102
				],
				[
					348,
					56
				],
				[
					228,
					-225
				],
				[
					365,
					-23
				],
				[
					337,
					-68
				],
				[
					332,
					-124
				],
				[
					218,
					215
				],
				[
					108,
					203
				],
				[
					278,
					-226
				],
				[
					381,
					57
				],
				[
					283,
					-125
				],
				[
					190,
					-191
				],
				[
					370,
					56
				],
				[
					288,
					124
				],
				[
					283,
					147
				],
				[
					337,
					79
				],
				[
					392,
					68
				],
				[
					354,
					79
				],
				[
					272,
					124
				],
				[
					163,
					180
				],
				[
					65,
					249
				],
				[
					-32,
					236
				],
				[
					-87,
					226
				],
				[
					-98,
					226
				],
				[
					-87,
					226
				],
				[
					-71,
					203
				],
				[
					-16,
					225
				],
				[
					27,
					226
				],
				[
					130,
					214
				],
				[
					109,
					237
				],
				[
					44,
					226
				],
				[
					-55,
					248
				],
				[
					-32,
					226
				],
				[
					136,
					260
				],
				[
					152,
					169
				],
				[
					180,
					214
				],
				[
					190,
					181
				],
				[
					223,
					169
				],
				[
					109,
					248
				],
				[
					152,
					158
				],
				[
					174,
					147
				],
				[
					267,
					34
				],
				[
					174,
					180
				],
				[
					196,
					113
				],
				[
					228,
					68
				],
				[
					202,
					147
				],
				[
					157,
					180
				],
				[
					218,
					68
				],
				[
					163,
					-147
				],
				[
					-103,
					-192
				],
				[
					-283,
					-169
				],
				[
					-120,
					-124
				],
				[
					-206,
					90
				],
				[
					-229,
					-56
				],
				[
					-190,
					-136
				],
				[
					-202,
					-146
				],
				[
					-136,
					-170
				],
				[
					-38,
					-225
				],
				[
					17,
					-215
				],
				[
					130,
					-191
				],
				[
					-190,
					-136
				],
				[
					-261,
					-45
				],
				[
					-153,
					-192
				],
				[
					-163,
					-180
				],
				[
					-174,
					-249
				],
				[
					-44,
					-214
				],
				[
					98,
					-237
				],
				[
					147,
					-181
				],
				[
					229,
					-135
				],
				[
					212,
					-181
				],
				[
					114,
					-225
				],
				[
					60,
					-215
				],
				[
					82,
					-225
				],
				[
					130,
					-192
				],
				[
					82,
					-215
				],
				[
					38,
					-530
				],
				[
					81,
					-214
				],
				[
					22,
					-226
				],
				[
					87,
					-226
				],
				[
					-38,
					-304
				],
				[
					-152,
					-237
				],
				[
					-163,
					-192
				],
				[
					-370,
					-79
				],
				[
					-125,
					-203
				],
				[
					-169,
					-192
				],
				[
					-419,
					-215
				],
				[
					-370,
					-90
				],
				[
					-348,
					-124
				],
				[
					-376,
					-124
				],
				[
					-223,
					-237
				],
				[
					-446,
					-23
				],
				[
					-489,
					23
				],
				[
					-441,
					-45
				],
				[
					-468,
					0
				],
				[
					87,
					-226
				],
				[
					424,
					-101
				],
				[
					311,
					-158
				],
				[
					174,
					-204
				],
				[
					-310,
					-180
				],
				[
					-479,
					56
				],
				[
					-397,
					-146
				],
				[
					-17,
					-237
				],
				[
					-11,
					-226
				],
				[
					327,
					-192
				],
				[
					60,
					-214
				],
				[
					353,
					-215
				],
				[
					588,
					-90
				],
				[
					500,
					-158
				],
				[
					398,
					-180
				],
				[
					506,
					-181
				],
				[
					690,
					-90
				],
				[
					681,
					-158
				],
				[
					473,
					-170
				],
				[
					517,
					-191
				],
				[
					272,
					-271
				],
				[
					136,
					-215
				],
				[
					337,
					204
				],
				[
					457,
					169
				],
				[
					484,
					180
				],
				[
					577,
					147
				],
				[
					495,
					158
				],
				[
					691,
					11
				],
				[
					680,
					-79
				],
				[
					560,
					-135
				],
				[
					180,
					248
				],
				[
					386,
					169
				],
				[
					702,
					12
				],
				[
					550,
					124
				],
				[
					522,
					124
				],
				[
					577,
					79
				],
				[
					614,
					102
				],
				[
					430,
					146
				],
				[
					-196,
					203
				],
				[
					-119,
					203
				],
				[
					0,
					215
				],
				[
					-539,
					-23
				],
				[
					-571,
					-90
				],
				[
					-544,
					0
				],
				[
					-77,
					214
				],
				[
					39,
					429
				],
				[
					125,
					124
				],
				[
					397,
					136
				],
				[
					468,
					135
				],
				[
					337,
					169
				],
				[
					337,
					170
				],
				[
					251,
					225
				],
				[
					380,
					102
				],
				[
					376,
					79
				],
				[
					190,
					45
				],
				[
					430,
					23
				],
				[
					408,
					79
				],
				[
					343,
					112
				],
				[
					337,
					136
				],
				[
					305,
					135
				],
				[
					386,
					181
				],
				[
					245,
					192
				],
				[
					261,
					169
				],
				[
					82,
					226
				],
				[
					-294,
					135
				],
				[
					98,
					237
				],
				[
					185,
					181
				],
				[
					288,
					112
				],
				[
					305,
					136
				],
				[
					283,
					180
				],
				[
					217,
					226
				],
				[
					136,
					271
				],
				[
					202,
					158
				],
				[
					331,
					-34
				],
				[
					136,
					-192
				],
				[
					332,
					-22
				],
				[
					11,
					214
				],
				[
					142,
					226
				],
				[
					299,
					-57
				],
				[
					71,
					-214
				],
				[
					331,
					-34
				],
				[
					360,
					102
				],
				[
					348,
					67
				],
				[
					315,
					-34
				],
				[
					120,
					-237
				],
				[
					305,
					192
				],
				[
					283,
					102
				],
				[
					315,
					79
				],
				[
					310,
					79
				],
				[
					283,
					135
				],
				[
					310,
					91
				],
				[
					240,
					124
				],
				[
					168,
					203
				],
				[
					207,
					-147
				],
				[
					288,
					79
				],
				[
					202,
					-271
				],
				[
					157,
					-203
				],
				[
					316,
					113
				],
				[
					125,
					226
				],
				[
					283,
					158
				],
				[
					365,
					-34
				],
				[
					108,
					-215
				],
				[
					229,
					215
				],
				[
					299,
					68
				],
				[
					326,
					22
				],
				[
					294,
					-11
				],
				[
					310,
					-68
				],
				[
					300,
					-34
				],
				[
					130,
					-192
				],
				[
					180,
					-169
				],
				[
					304,
					102
				],
				[
					327,
					22
				],
				[
					315,
					0
				],
				[
					310,
					12
				],
				[
					278,
					79
				],
				[
					294,
					67
				],
				[
					245,
					158
				],
				[
					261,
					102
				],
				[
					283,
					56
				],
				[
					212,
					158
				],
				[
					152,
					316
				],
				[
					158,
					192
				],
				[
					288,
					-90
				],
				[
					109,
					-203
				],
				[
					239,
					-136
				],
				[
					289,
					45
				],
				[
					196,
					-203
				],
				[
					206,
					-146
				],
				[
					283,
					135
				],
				[
					98,
					248
				],
				[
					250,
					102
				],
				[
					289,
					192
				],
				[
					272,
					79
				],
				[
					326,
					112
				],
				[
					218,
					125
				],
				[
					228,
					135
				],
				[
					218,
					124
				],
				[
					261,
					-68
				],
				[
					250,
					203
				],
				[
					180,
					158
				],
				[
					261,
					-11
				],
				[
					229,
					136
				],
				[
					54,
					203
				],
				[
					234,
					158
				],
				[
					228,
					113
				],
				[
					278,
					90
				],
				[
					256,
					45
				],
				[
					244,
					-34
				],
				[
					262,
					-56
				],
				[
					223,
					-158
				],
				[
					27,
					-249
				],
				[
					245,
					-191
				],
				[
					168,
					-158
				],
				[
					332,
					-68
				],
				[
					185,
					-158
				],
				[
					229,
					-158
				],
				[
					266,
					-34
				],
				[
					223,
					113
				],
				[
					240,
					237
				],
				[
					261,
					-124
				],
				[
					272,
					-68
				],
				[
					261,
					-68
				],
				[
					272,
					-45
				],
				[
					277,
					0
				],
				[
					229,
					-598
				],
				[
					-11,
					-147
				],
				[
					-33,
					-259
				],
				[
					-266,
					-147
				],
				[
					-218,
					-214
				],
				[
					38,
					-226
				],
				[
					310,
					11
				],
				[
					-38,
					-225
				],
				[
					-141,
					-215
				],
				[
					-131,
					-237
				],
				[
					212,
					-180
				],
				[
					321,
					-57
				],
				[
					321,
					102
				],
				[
					153,
					226
				],
				[
					92,
					214
				],
				[
					153,
					181
				],
				[
					174,
					169
				],
				[
					70,
					203
				],
				[
					147,
					282
				],
				[
					174,
					57
				],
				[
					316,
					22
				],
				[
					277,
					68
				],
				[
					283,
					90
				],
				[
					136,
					226
				],
				[
					82,
					214
				],
				[
					190,
					215
				],
				[
					272,
					146
				],
				[
					234,
					113
				],
				[
					153,
					192
				],
				[
					157,
					101
				],
				[
					202,
					91
				],
				[
					277,
					-57
				],
				[
					250,
					57
				],
				[
					272,
					67
				],
				[
					305,
					-33
				],
				[
					201,
					158
				],
				[
					142,
					383
				],
				[
					103,
					-158
				],
				[
					131,
					-271
				],
				[
					234,
					-112
				],
				[
					266,
					-46
				],
				[
					267,
					68
				],
				[
					283,
					-45
				],
				[
					261,
					-11
				],
				[
					174,
					56
				],
				[
					234,
					-34
				],
				[
					212,
					-124
				],
				[
					250,
					79
				],
				[
					300,
					0
				],
				[
					255,
					79
				],
				[
					289,
					-79
				],
				[
					185,
					192
				],
				[
					141,
					192
				],
				[
					191,
					158
				],
				[
					348,
					429
				],
				[
					179,
					-79
				],
				[
					212,
					-158
				],
				[
					185,
					-203
				],
				[
					354,
					-350
				],
				[
					272,
					-12
				],
				[
					256,
					0
				],
				[
					299,
					68
				],
				[
					299,
					79
				],
				[
					229,
					158
				],
				[
					190,
					169
				],
				[
					310,
					23
				],
				[
					207,
					124
				],
				[
					218,
					-113
				],
				[
					141,
					-180
				],
				[
					196,
					-181
				],
				[
					305,
					23
				],
				[
					190,
					-147
				],
				[
					332,
					-147
				],
				[
					348,
					-56
				],
				[
					288,
					45
				],
				[
					218,
					181
				],
				[
					185,
					180
				],
				[
					250,
					45
				],
				[
					251,
					-79
				],
				[
					288,
					-56
				],
				[
					261,
					90
				],
				[
					250,
					0
				],
				[
					245,
					-56
				],
				[
					256,
					-57
				],
				[
					250,
					102
				],
				[
					299,
					90
				],
				[
					283,
					23
				],
				[
					316,
					0
				],
				[
					255,
					56
				],
				[
					251,
					45
				],
				[
					76,
					282
				],
				[
					11,
					237
				],
				[
					174,
					-158
				],
				[
					49,
					-259
				],
				[
					92,
					-237
				],
				[
					115,
					-192
				],
				[
					234,
					-102
				],
				[
					315,
					34
				],
				[
					365,
					12
				],
				[
					250,
					33
				],
				[
					364,
					0
				],
				[
					262,
					12
				],
				[
					364,
					-23
				],
				[
					310,
					-45
				],
				[
					196,
					-181
				],
				[
					-54,
					-214
				],
				[
					179,
					-169
				],
				[
					299,
					-136
				],
				[
					310,
					-146
				],
				[
					360,
					-102
				],
				[
					375,
					-90
				],
				[
					283,
					-90
				],
				[
					315,
					-12
				],
				[
					180,
					192
				],
				[
					245,
					-158
				],
				[
					212,
					-180
				],
				[
					245,
					-136
				],
				[
					337,
					-56
				],
				[
					321,
					-68
				],
				[
					136,
					-226
				],
				[
					316,
					-135
				],
				[
					212,
					-203
				],
				[
					310,
					-90
				],
				[
					321,
					11
				],
				[
					299,
					-34
				],
				[
					332,
					11
				],
				[
					332,
					-45
				],
				[
					310,
					-79
				],
				[
					288,
					-135
				],
				[
					289,
					-113
				],
				[
					195,
					-169
				],
				[
					-32,
					-226
				],
				[
					-147,
					-203
				],
				[
					-125,
					-260
				],
				[
					-98,
					-203
				],
				[
					-131,
					-237
				],
				[
					-364,
					-90
				],
				[
					-163,
					-203
				],
				[
					-360,
					-124
				],
				[
					-125,
					-226
				],
				[
					-190,
					-214
				],
				[
					-201,
					-181
				],
				[
					-115,
					-237
				],
				[
					-70,
					-214
				],
				[
					-28,
					-260
				],
				[
					6,
					-214
				],
				[
					158,
					-226
				],
				[
					60,
					-214
				],
				[
					130,
					-204
				],
				[
					517,
					-78
				],
				[
					109,
					-249
				],
				[
					-501,
					-90
				],
				[
					-424,
					-124
				],
				[
					-528,
					-23
				],
				[
					-234,
					-327
				],
				[
					-49,
					-271
				],
				[
					-119,
					-214
				],
				[
					-147,
					-215
				],
				[
					370,
					-191
				],
				[
					141,
					-237
				],
				[
					239,
					-215
				],
				[
					338,
					-192
				],
				[
					386,
					-180
				],
				[
					419,
					-181
				],
				[
					636,
					-180
				],
				[
					142,
					-282
				],
				[
					800,
					-125
				],
				[
					53,
					-44
				],
				[
					208,
					-170
				],
				[
					767,
					147
				],
				[
					636,
					-181
				],
				[
					-99520,
					-139
				]
			],
			[
				[
					69148,
					23827
				],
				[
					179,
					-181
				],
				[
					263,
					-72
				],
				[
					9,
					-110
				],
				[
					-77,
					-262
				],
				[
					-427,
					-37
				],
				[
					-7,
					306
				],
				[
					41,
					238
				],
				[
					19,
					118
				]
			],
			[
				[
					90387,
					28338
				],
				[
					269,
					-199
				],
				[
					151,
					79
				],
				[
					217,
					111
				],
				[
					166,
					-39
				],
				[
					20,
					-684
				],
				[
					-95,
					-198
				],
				[
					-29,
					-463
				],
				[
					-97,
					157
				],
				[
					-193,
					-401
				],
				[
					-57,
					31
				],
				[
					-171,
					18
				],
				[
					-171,
					493
				],
				[
					-38,
					380
				],
				[
					-160,
					502
				],
				[
					7,
					264
				],
				[
					181,
					-51
				]
			],
			[
				[
					89877,
					43903
				],
				[
					100,
					-452
				],
				[
					179,
					217
				],
				[
					92,
					-243
				],
				[
					133,
					-225
				],
				[
					-29,
					-255
				],
				[
					60,
					-494
				],
				[
					42,
					-288
				],
				[
					70,
					-70
				],
				[
					75,
					-492
				],
				[
					-27,
					-299
				],
				[
					90,
					-390
				],
				[
					301,
					-301
				],
				[
					197,
					-274
				],
				[
					186,
					-251
				],
				[
					-37,
					-139
				],
				[
					159,
					-361
				],
				[
					108,
					-623
				],
				[
					111,
					126
				],
				[
					113,
					-249
				],
				[
					68,
					88
				],
				[
					48,
					-610
				],
				[
					197,
					-354
				],
				[
					129,
					-220
				],
				[
					217,
					-466
				],
				[
					78,
					-463
				],
				[
					7,
					-328
				],
				[
					-19,
					-356
				],
				[
					132,
					-490
				],
				[
					-16,
					-509
				],
				[
					-48,
					-267
				],
				[
					-75,
					-514
				],
				[
					6,
					-330
				],
				[
					-55,
					-413
				],
				[
					-123,
					-524
				],
				[
					-205,
					-283
				],
				[
					-102,
					-446
				],
				[
					-93,
					-284
				],
				[
					-82,
					-497
				],
				[
					-107,
					-287
				],
				[
					-70,
					-431
				],
				[
					-36,
					-397
				],
				[
					14,
					-182
				],
				[
					-159,
					-200
				],
				[
					-311,
					-21
				],
				[
					-257,
					-236
				],
				[
					-127,
					-223
				],
				[
					-168,
					-248
				],
				[
					-230,
					255
				],
				[
					-170,
					101
				],
				[
					43,
					301
				],
				[
					-152,
					-109
				],
				[
					-243,
					-417
				],
				[
					-240,
					156
				],
				[
					-158,
					91
				],
				[
					-159,
					41
				],
				[
					-269,
					167
				],
				[
					-179,
					355
				],
				[
					-52,
					437
				],
				[
					-64,
					291
				],
				[
					-137,
					233
				],
				[
					-267,
					70
				],
				[
					91,
					279
				],
				[
					-67,
					428
				],
				[
					-136,
					-399
				],
				[
					-247,
					-106
				],
				[
					146,
					319
				],
				[
					42,
					332
				],
				[
					107,
					282
				],
				[
					-22,
					427
				],
				[
					-226,
					-491
				],
				[
					-174,
					-197
				],
				[
					-106,
					-458
				],
				[
					-217,
					237
				],
				[
					9,
					305
				],
				[
					-174,
					418
				],
				[
					-147,
					216
				],
				[
					52,
					133
				],
				[
					-356,
					349
				],
				[
					-195,
					16
				],
				[
					-267,
					280
				],
				[
					-498,
					-54
				],
				[
					-359,
					-206
				],
				[
					-317,
					-192
				],
				[
					-265,
					38
				],
				[
					-294,
					-296
				],
				[
					-241,
					-132
				],
				[
					-53,
					-302
				],
				[
					-103,
					-234
				],
				[
					-236,
					-14
				],
				[
					-174,
					-52
				],
				[
					-246,
					105
				],
				[
					-199,
					-62
				],
				[
					-191,
					-27
				],
				[
					-165,
					-307
				],
				[
					-81,
					26
				],
				[
					-140,
					-163
				],
				[
					-133,
					-183
				],
				[
					-203,
					23
				],
				[
					-186,
					0
				],
				[
					-295,
					368
				],
				[
					-149,
					109
				],
				[
					6,
					330
				],
				[
					138,
					79
				],
				[
					47,
					131
				],
				[
					-10,
					207
				],
				[
					34,
					400
				],
				[
					-31,
					341
				],
				[
					-147,
					582
				],
				[
					-45,
					329
				],
				[
					12,
					328
				],
				[
					-111,
					375
				],
				[
					-7,
					169
				],
				[
					-123,
					230
				],
				[
					-35,
					451
				],
				[
					-158,
					456
				],
				[
					-39,
					245
				],
				[
					122,
					-249
				],
				[
					-93,
					535
				],
				[
					137,
					-167
				],
				[
					83,
					-223
				],
				[
					-5,
					294
				],
				[
					-138,
					454
				],
				[
					-26,
					181
				],
				[
					-65,
					173
				],
				[
					31,
					333
				],
				[
					56,
					141
				],
				[
					38,
					289
				],
				[
					-29,
					336
				],
				[
					114,
					415
				],
				[
					21,
					-439
				],
				[
					118,
					396
				],
				[
					225,
					193
				],
				[
					136,
					245
				],
				[
					212,
					212
				],
				[
					126,
					45
				],
				[
					77,
					-71
				],
				[
					219,
					214
				],
				[
					168,
					64
				],
				[
					42,
					126
				],
				[
					74,
					53
				],
				[
					153,
					-14
				],
				[
					292,
					169
				],
				[
					151,
					256
				],
				[
					71,
					307
				],
				[
					163,
					293
				],
				[
					13,
					229
				],
				[
					7,
					314
				],
				[
					194,
					489
				],
				[
					117,
					-497
				],
				[
					119,
					115
				],
				[
					-99,
					272
				],
				[
					87,
					279
				],
				[
					122,
					-125
				],
				[
					34,
					439
				],
				[
					152,
					283
				],
				[
					67,
					227
				],
				[
					140,
					98
				],
				[
					4,
					161
				],
				[
					122,
					-67
				],
				[
					5,
					145
				],
				[
					122,
					82
				],
				[
					134,
					78
				],
				[
					205,
					-264
				],
				[
					155,
					-342
				],
				[
					173,
					-3
				],
				[
					177,
					-54
				],
				[
					-59,
					316
				],
				[
					133,
					462
				],
				[
					126,
					150
				],
				[
					-44,
					144
				],
				[
					121,
					329
				],
				[
					168,
					203
				],
				[
					142,
					-68
				],
				[
					234,
					108
				],
				[
					-5,
					294
				],
				[
					-204,
					190
				],
				[
					148,
					84
				],
				[
					184,
					-143
				],
				[
					148,
					-236
				],
				[
					234,
					-148
				],
				[
					79,
					59
				],
				[
					172,
					-177
				],
				[
					162,
					164
				],
				[
					105,
					-50
				],
				[
					65,
					111
				],
				[
					127,
					-285
				],
				[
					-74,
					-308
				],
				[
					-105,
					-233
				],
				[
					-96,
					-19
				],
				[
					32,
					-230
				],
				[
					-81,
					-288
				],
				[
					-99,
					-283
				],
				[
					20,
					-163
				],
				[
					221,
					-318
				],
				[
					214,
					-184
				],
				[
					143,
					-199
				],
				[
					201,
					-341
				],
				[
					78,
					1
				],
				[
					145,
					-148
				],
				[
					43,
					-178
				],
				[
					265,
					-195
				],
				[
					183,
					197
				],
				[
					55,
					309
				],
				[
					56,
					255
				],
				[
					34,
					316
				],
				[
					85,
					458
				],
				[
					-39,
					279
				],
				[
					20,
					167
				],
				[
					-32,
					330
				],
				[
					37,
					434
				],
				[
					53,
					117
				],
				[
					-43,
					192
				],
				[
					67,
					305
				],
				[
					52,
					317
				],
				[
					7,
					164
				],
				[
					104,
					216
				],
				[
					78,
					-282
				],
				[
					19,
					-361
				],
				[
					70,
					-70
				],
				[
					11,
					-242
				],
				[
					101,
					-293
				],
				[
					21,
					-326
				],
				[
					-10,
					-209
				]
			],
			[
				[
					54716,
					79543
				],
				[
					-21,
					-236
				],
				[
					-156,
					-1
				],
				[
					53,
					-125
				],
				[
					-92,
					-370
				]
			],
			[
				[
					54500,
					78811
				],
				[
					-53,
					-97
				],
				[
					-243,
					-15
				],
				[
					-140,
					-130
				],
				[
					-229,
					44
				]
			],
			[
				[
					53835,
					78613
				],
				[
					-398,
					149
				],
				[
					-62,
					200
				],
				[
					-274,
					-100
				],
				[
					-32,
					-109
				],
				[
					-169,
					81
				]
			],
			[
				[
					52900,
					78834
				],
				[
					-142,
					16
				],
				[
					-125,
					105
				],
				[
					42,
					141
				],
				[
					-10,
					102
				]
			],
			[
				[
					52665,
					79198
				],
				[
					83,
					32
				],
				[
					141,
					-160
				],
				[
					39,
					152
				],
				[
					245,
					-25
				],
				[
					199,
					104
				],
				[
					133,
					-18
				],
				[
					87,
					-118
				],
				[
					26,
					98
				],
				[
					-40,
					375
				],
				[
					100,
					73
				],
				[
					98,
					266
				]
			],
			[
				[
					53776,
					79977
				],
				[
					206,
					-186
				],
				[
					157,
					236
				],
				[
					98,
					43
				],
				[
					215,
					-176
				],
				[
					131,
					30
				],
				[
					128,
					-109
				]
			],
			[
				[
					54711,
					79815
				],
				[
					-23,
					-73
				],
				[
					28,
					-199
				]
			],
			[
				[
					62817,
					74140
				],
				[
					-190,
					76
				],
				[
					-141,
					266
				],
				[
					-44,
					217
				]
			],
			[
				[
					63495,
					75906
				],
				[
					146,
					-303
				],
				[
					141,
					-408
				],
				[
					130,
					-27
				],
				[
					85,
					-156
				],
				[
					-228,
					-46
				],
				[
					-49,
					-447
				],
				[
					-48,
					-202
				],
				[
					-101,
					-135
				],
				[
					7,
					-285
				]
			],
			[
				[
					63578,
					73897
				],
				[
					-69,
					-28
				],
				[
					-173,
					301
				],
				[
					95,
					285
				],
				[
					-82,
					169
				],
				[
					-104,
					-43
				],
				[
					-327,
					-424
				]
			],
			[
				[
					62492,
					75583
				],
				[
					68,
					94
				],
				[
					207,
					-165
				],
				[
					149,
					-34
				],
				[
					38,
					67
				],
				[
					-136,
					312
				],
				[
					72,
					79
				]
			],
			[
				[
					62890,
					75936
				],
				[
					78,
					-19
				],
				[
					191,
					-350
				],
				[
					122,
					-39
				],
				[
					48,
					146
				],
				[
					166,
					232
				]
			],
			[
				[
					58149,
					49238
				],
				[
					-17,
					694
				],
				[
					-70,
					262
				]
			],
			[
				[
					58062,
					50194
				],
				[
					169,
					-45
				],
				[
					85,
					328
				],
				[
					147,
					-38
				]
			],
			[
				[
					58463,
					50439
				],
				[
					16,
					-227
				],
				[
					60,
					-130
				],
				[
					3,
					-187
				],
				[
					-69,
					-121
				],
				[
					-108,
					-300
				],
				[
					-101,
					-209
				],
				[
					-115,
					-27
				]
			],
			[
				[
					50920,
					81398
				],
				[
					204,
					-45
				],
				[
					257,
					120
				],
				[
					176,
					-252
				],
				[
					153,
					-135
				]
			],
			[
				[
					51710,
					81086
				],
				[
					-32,
					-389
				]
			],
			[
				[
					51678,
					80697
				],
				[
					-72,
					-22
				],
				[
					-30,
					-323
				]
			],
			[
				[
					51576,
					80352
				],
				[
					-243,
					263
				],
				[
					-143,
					-45
				],
				[
					-194,
					272
				],
				[
					-129,
					231
				],
				[
					-129,
					9
				],
				[
					-40,
					203
				]
			],
			[
				[
					50698,
					81285
				],
				[
					222,
					113
				]
			],
			[
				[
					50747,
					55434
				],
				[
					-229,
					-68
				]
			],
			[
				[
					50518,
					55366
				],
				[
					-69,
					398
				],
				[
					13,
					1322
				],
				[
					-56,
					119
				],
				[
					-11,
					283
				],
				[
					-96,
					201
				],
				[
					-85,
					170
				],
				[
					35,
					303
				]
			],
			[
				[
					50249,
					58162
				],
				[
					96,
					66
				],
				[
					56,
					251
				],
				[
					136,
					54
				],
				[
					61,
					172
				]
			],
			[
				[
					50598,
					58705
				],
				[
					93,
					169
				],
				[
					100,
					2
				],
				[
					212,
					-332
				]
			],
			[
				[
					51003,
					58544
				],
				[
					-11,
					-191
				],
				[
					62,
					-342
				],
				[
					-54,
					-232
				],
				[
					29,
					-154
				],
				[
					-135,
					-357
				],
				[
					-86,
					-176
				],
				[
					-52,
					-364
				],
				[
					7,
					-366
				],
				[
					-16,
					-928
				]
			],
			[
				[
					49214,
					57382
				],
				[
					-190,
					149
				],
				[
					-130,
					-22
				],
				[
					-97,
					-145
				],
				[
					-125,
					122
				],
				[
					-49,
					190
				],
				[
					-125,
					126
				]
			],
			[
				[
					48498,
					57802
				],
				[
					-18,
					334
				],
				[
					76,
					244
				],
				[
					-7,
					195
				],
				[
					221,
					477
				],
				[
					41,
					395
				],
				[
					76,
					141
				],
				[
					134,
					-78
				],
				[
					116,
					117
				],
				[
					38,
					148
				],
				[
					216,
					259
				],
				[
					53,
					180
				],
				[
					259,
					238
				],
				[
					153,
					82
				],
				[
					70,
					-110
				],
				[
					178,
					3
				]
			],
			[
				[
					50104,
					60427
				],
				[
					-22,
					-280
				],
				[
					37,
					-262
				],
				[
					156,
					-376
				],
				[
					9,
					-279
				],
				[
					320,
					-130
				],
				[
					-6,
					-395
				]
			],
			[
				[
					50249,
					58162
				],
				[
					-243,
					13
				]
			],
			[
				[
					50006,
					58175
				],
				[
					-128,
					46
				],
				[
					-90,
					-93
				],
				[
					-123,
					42
				],
				[
					-482,
					-27
				],
				[
					-7,
					-327
				],
				[
					38,
					-434
				]
			],
			[
				[
					75742,
					64522
				],
				[
					-6,
					-413
				],
				[
					-97,
					88
				],
				[
					18,
					-464
				]
			],
			[
				[
					75657,
					63733
				],
				[
					-79,
					301
				],
				[
					-16,
					293
				],
				[
					-53,
					277
				],
				[
					-116,
					335
				],
				[
					-256,
					23
				],
				[
					25,
					-237
				],
				[
					-87,
					-321
				],
				[
					-118,
					117
				],
				[
					-41,
					-105
				],
				[
					-78,
					63
				],
				[
					-108,
					52
				]
			],
			[
				[
					74730,
					64531
				],
				[
					-43,
					474
				],
				[
					-96,
					433
				],
				[
					47,
					347
				],
				[
					-171,
					154
				],
				[
					62,
					210
				],
				[
					173,
					215
				],
				[
					-200,
					305
				],
				[
					98,
					390
				],
				[
					220,
					-248
				],
				[
					133,
					-29
				],
				[
					24,
					-400
				],
				[
					265,
					-79
				],
				[
					257,
					8
				],
				[
					160,
					-98
				],
				[
					-128,
					-487
				],
				[
					-124,
					-34
				],
				[
					-86,
					-327
				],
				[
					152,
					-299
				],
				[
					46,
					368
				],
				[
					76,
					2
				],
				[
					147,
					-914
				]
			],
			[
				[
					56293,
					77303
				],
				[
					80,
					-236
				],
				[
					108,
					42
				],
				[
					213,
					-90
				],
				[
					408,
					-30
				],
				[
					138,
					147
				],
				[
					327,
					133
				],
				[
					202,
					-209
				],
				[
					163,
					-60
				]
			],
			[
				[
					57932,
					77000
				],
				[
					-144,
					-239
				],
				[
					-101,
					-412
				],
				[
					89,
					-328
				]
			],
			[
				[
					57776,
					76021
				],
				[
					-239,
					77
				],
				[
					-283,
					-181
				]
			],
			[
				[
					57254,
					75917
				],
				[
					-3,
					-287
				],
				[
					-252,
					-55
				],
				[
					-196,
					202
				],
				[
					-222,
					-159
				],
				[
					-206,
					17
				]
			],
			[
				[
					56375,
					75635
				],
				[
					-20,
					381
				],
				[
					-139,
					185
				]
			],
			[
				[
					56216,
					76201
				],
				[
					46,
					81
				],
				[
					-30,
					69
				],
				[
					47,
					183
				],
				[
					105,
					180
				],
				[
					-135,
					248
				],
				[
					-24,
					211
				],
				[
					68,
					130
				]
			],
			[
				[
					28462,
					65512
				],
				[
					-68,
					-29
				],
				[
					-70,
					332
				],
				[
					-104,
					167
				],
				[
					60,
					365
				],
				[
					84,
					-23
				],
				[
					97,
					-478
				],
				[
					1,
					-334
				]
			],
			[
				[
					28383,
					67136
				],
				[
					-303,
					-92
				],
				[
					-19,
					213
				],
				[
					130,
					46
				],
				[
					184,
					-17
				],
				[
					8,
					-150
				]
			],
			[
				[
					28611,
					67142
				],
				[
					-48,
					-409
				],
				[
					-51,
					73
				],
				[
					4,
					301
				],
				[
					-124,
					228
				],
				[
					-1,
					66
				],
				[
					220,
					-259
				]
			],
			[
				[
					55279,
					77663
				],
				[
					100,
					2
				],
				[
					-69,
					-253
				],
				[
					134,
					-222
				],
				[
					-41,
					-271
				],
				[
					-65,
					-25
				]
			],
			[
				[
					55338,
					76894
				],
				[
					-52,
					-53
				],
				[
					-90,
					-134
				],
				[
					-41,
					-316
				]
			],
			[
				[
					55155,
					76391
				],
				[
					-246,
					218
				],
				[
					-105,
					240
				],
				[
					-106,
					128
				],
				[
					-127,
					215
				],
				[
					-61,
					178
				],
				[
					-136,
					270
				],
				[
					59,
					239
				],
				[
					99,
					-133
				],
				[
					60,
					120
				],
				[
					130,
					13
				],
				[
					239,
					-96
				],
				[
					192,
					8
				],
				[
					126,
					-128
				]
			],
			[
				[
					56523,
					82877
				],
				[
					268,
					-4
				],
				[
					302,
					217
				],
				[
					64,
					325
				],
				[
					228,
					184
				],
				[
					-26,
					258
				]
			],
			[
				[
					57359,
					83857
				],
				[
					169,
					97
				],
				[
					298,
					222
				]
			],
			[
				[
					57826,
					84176
				],
				[
					293,
					-144
				],
				[
					39,
					-143
				],
				[
					146,
					68
				],
				[
					272,
					-137
				],
				[
					27,
					-270
				],
				[
					-60,
					-156
				],
				[
					174,
					-377
				],
				[
					113,
					-105
				],
				[
					-16,
					-104
				],
				[
					187,
					-101
				],
				[
					80,
					-154
				],
				[
					-108,
					-126
				],
				[
					-224,
					20
				],
				[
					-54,
					-53
				],
				[
					66,
					-192
				],
				[
					68,
					-368
				]
			],
			[
				[
					58829,
					81834
				],
				[
					-239,
					-34
				],
				[
					-85,
					-127
				],
				[
					-18,
					-290
				],
				[
					-111,
					56
				],
				[
					-250,
					-28
				],
				[
					-73,
					135
				],
				[
					-104,
					-100
				],
				[
					-105,
					83
				],
				[
					-218,
					11
				],
				[
					-310,
					139
				],
				[
					-281,
					45
				],
				[
					-215,
					-13
				],
				[
					-152,
					-156
				],
				[
					-133,
					-23
				]
			],
			[
				[
					56535,
					81532
				],
				[
					-6,
					257
				],
				[
					-85,
					267
				],
				[
					166,
					117
				],
				[
					2,
					230
				],
				[
					-77,
					219
				],
				[
					-12,
					255
				]
			],
			[
				[
					25238,
					62085
				],
				[
					-2,
					85
				],
				[
					33,
					26
				],
				[
					51,
					-68
				],
				[
					99,
					348
				],
				[
					53,
					7
				]
			],
			[
				[
					25472,
					62483
				],
				[
					1,
					-84
				],
				[
					53,
					-3
				],
				[
					-5,
					-157
				],
				[
					-45,
					-249
				],
				[
					24,
					-89
				],
				[
					-29,
					-206
				],
				[
					18,
					-55
				],
				[
					-32,
					-291
				],
				[
					-55,
					-153
				],
				[
					-50,
					-18
				],
				[
					-55,
					-199
				]
			],
			[
				[
					25297,
					60979
				],
				[
					-83,
					-1
				],
				[
					22,
					650
				],
				[
					2,
					457
				]
			],
			[
				[
					31359,
					38736
				],
				[
					-200,
					-79
				],
				[
					-109,
					794
				],
				[
					-150,
					646
				],
				[
					88,
					557
				],
				[
					-146,
					244
				],
				[
					-37,
					416
				],
				[
					-136,
					391
				]
			],
			[
				[
					30669,
					41705
				],
				[
					175,
					622
				],
				[
					-119,
					484
				],
				[
					63,
					194
				],
				[
					-49,
					213
				],
				[
					108,
					288
				],
				[
					6,
					490
				],
				[
					13,
					405
				],
				[
					60,
					195
				],
				[
					-240,
					926
				]
			],
			[
				[
					30686,
					45522
				],
				[
					206,
					-48
				],
				[
					143,
					12
				],
				[
					62,
					174
				],
				[
					243,
					234
				],
				[
					147,
					216
				],
				[
					363,
					98
				],
				[
					-29,
					-432
				],
				[
					34,
					-221
				],
				[
					-23,
					-386
				],
				[
					302,
					-516
				],
				[
					311,
					-95
				],
				[
					109,
					-216
				],
				[
					188,
					-114
				],
				[
					115,
					-167
				],
				[
					175,
					6
				],
				[
					161,
					-171
				],
				[
					12,
					-333
				],
				[
					55,
					-168
				],
				[
					3,
					-248
				],
				[
					-81,
					-10
				],
				[
					107,
					-671
				],
				[
					533,
					-23
				],
				[
					-41,
					-333
				],
				[
					30,
					-227
				],
				[
					151,
					-162
				],
				[
					66,
					-358
				],
				[
					-49,
					-453
				],
				[
					-77,
					-253
				],
				[
					27,
					-328
				],
				[
					-87,
					-119
				]
			],
			[
				[
					33842,
					40210
				],
				[
					-4,
					177
				],
				[
					-259,
					295
				],
				[
					-258,
					8
				],
				[
					-484,
					-167
				],
				[
					-133,
					-507
				],
				[
					-7,
					-310
				],
				[
					-110,
					-689
				]
			],
			[
				[
					34826,
					37007
				],
				[
					54,
					332
				],
				[
					38,
					340
				],
				[
					0,
					317
				],
				[
					-100,
					105
				],
				[
					-104,
					-94
				],
				[
					-103,
					26
				],
				[
					-33,
					222
				],
				[
					-26,
					527
				],
				[
					-52,
					172
				],
				[
					-187,
					156
				],
				[
					-114,
					-113
				],
				[
					-293,
					111
				],
				[
					18,
					782
				],
				[
					-82,
					320
				]
			],
			[
				[
					30686,
					45522
				],
				[
					-157,
					-99
				],
				[
					-126,
					66
				],
				[
					18,
					875
				],
				[
					-228,
					-339
				],
				[
					-245,
					15
				],
				[
					-105,
					307
				],
				[
					-184,
					33
				],
				[
					59,
					247
				],
				[
					-155,
					351
				],
				[
					-115,
					518
				],
				[
					73,
					106
				],
				[
					0,
					243
				],
				[
					168,
					166
				],
				[
					-28,
					312
				],
				[
					71,
					200
				],
				[
					20,
					269
				],
				[
					318,
					392
				],
				[
					227,
					111
				],
				[
					37,
					86
				],
				[
					251,
					-27
				]
			],
			[
				[
					30585,
					49354
				],
				[
					125,
					1579
				],
				[
					6,
					250
				],
				[
					-43,
					330
				],
				[
					-123,
					210
				],
				[
					1,
					418
				],
				[
					156,
					95
				],
				[
					56,
					-60
				],
				[
					9,
					221
				],
				[
					-162,
					60
				],
				[
					-4,
					360
				],
				[
					541,
					-13
				],
				[
					92,
					198
				],
				[
					77,
					-182
				],
				[
					55,
					-340
				],
				[
					52,
					71
				]
			],
			[
				[
					31423,
					52551
				],
				[
					153,
					-304
				],
				[
					216,
					37
				],
				[
					54,
					176
				],
				[
					206,
					135
				],
				[
					115,
					94
				],
				[
					32,
					244
				],
				[
					198,
					164
				],
				[
					-15,
					121
				],
				[
					-235,
					49
				],
				[
					-39,
					363
				],
				[
					12,
					386
				],
				[
					-125,
					149
				],
				[
					52,
					53
				],
				[
					206,
					-73
				],
				[
					221,
					-144
				],
				[
					80,
					136
				],
				[
					200,
					89
				],
				[
					310,
					216
				],
				[
					102,
					220
				],
				[
					-37,
					162
				]
			],
			[
				[
					33129,
					54824
				],
				[
					145,
					26
				],
				[
					64,
					-133
				],
				[
					-36,
					-253
				],
				[
					96,
					-87
				],
				[
					63,
					-268
				],
				[
					-77,
					-203
				],
				[
					-44,
					-490
				],
				[
					71,
					-291
				],
				[
					20,
					-267
				],
				[
					171,
					-270
				],
				[
					137,
					-28
				],
				[
					30,
					112
				],
				[
					88,
					25
				],
				[
					126,
					101
				],
				[
					90,
					153
				],
				[
					154,
					-48
				],
				[
					67,
					20
				]
			],
			[
				[
					34294,
					52923
				],
				[
					151,
					-47
				],
				[
					25,
					118
				],
				[
					-46,
					114
				],
				[
					28,
					167
				],
				[
					112,
					-51
				],
				[
					131,
					59
				],
				[
					159,
					-122
				]
			],
			[
				[
					34854,
					53161
				],
				[
					121,
					-119
				],
				[
					86,
					156
				],
				[
					62,
					-24
				],
				[
					38,
					-162
				],
				[
					133,
					41
				],
				[
					107,
					219
				],
				[
					85,
					424
				],
				[
					164,
					527
				]
			],
			[
				[
					35650,
					54223
				],
				[
					95,
					27
				],
				[
					69,
					-318
				],
				[
					155,
					-1008
				],
				[
					149,
					-95
				],
				[
					7,
					-397
				],
				[
					-208,
					-474
				],
				[
					86,
					-174
				],
				[
					491,
					-90
				],
				[
					10,
					-578
				],
				[
					211,
					378
				],
				[
					349,
					-207
				],
				[
					462,
					-351
				],
				[
					135,
					-338
				],
				[
					-45,
					-319
				],
				[
					323,
					178
				],
				[
					540,
					-305
				],
				[
					415,
					23
				],
				[
					411,
					-477
				],
				[
					355,
					-645
				],
				[
					214,
					-166
				],
				[
					237,
					-23
				],
				[
					101,
					-182
				],
				[
					94,
					-733
				],
				[
					46,
					-348
				],
				[
					-110,
					-953
				],
				[
					-142,
					-376
				],
				[
					-391,
					-801
				],
				[
					-177,
					-651
				],
				[
					-206,
					-499
				],
				[
					-69,
					-11
				],
				[
					-78,
					-424
				],
				[
					20,
					-1079
				],
				[
					-77,
					-888
				],
				[
					-30,
					-379
				],
				[
					-88,
					-228
				],
				[
					-49,
					-769
				],
				[
					-282,
					-752
				],
				[
					-47,
					-595
				],
				[
					-225,
					-250
				],
				[
					-65,
					-345
				],
				[
					-302,
					2
				],
				[
					-437,
					-222
				],
				[
					-195,
					-256
				],
				[
					-311,
					-168
				],
				[
					-327,
					-459
				],
				[
					-235,
					-571
				],
				[
					-41,
					-430
				],
				[
					46,
					-318
				],
				[
					-51,
					-582
				],
				[
					-63,
					-281
				],
				[
					-195,
					-317
				],
				[
					-308,
					-1013
				],
				[
					-244,
					-457
				],
				[
					-189,
					-269
				],
				[
					-127,
					-548
				],
				[
					-183,
					-329
				]
			],
			[
				[
					35174,
					32383
				],
				[
					-77,
					326
				],
				[
					122,
					273
				],
				[
					-160,
					392
				],
				[
					-218,
					318
				],
				[
					-286,
					369
				],
				[
					-103,
					-17
				],
				[
					-279,
					446
				],
				[
					-180,
					-62
				]
			],
			[
				[
					81723,
					54436
				],
				[
					110,
					215
				],
				[
					236,
					316
				]
			],
			[
				[
					82069,
					54967
				],
				[
					-13,
					-284
				],
				[
					-16,
					-368
				],
				[
					-133,
					18
				],
				[
					-58,
					-196
				],
				[
					-126,
					299
				]
			],
			[
				[
					75471,
					67823
				],
				[
					113,
					-184
				],
				[
					-20,
					-354
				],
				[
					-227,
					-17
				],
				[
					-234,
					39
				],
				[
					-175,
					-90
				],
				[
					-252,
					218
				],
				[
					-6,
					115
				]
			],
			[
				[
					74670,
					67550
				],
				[
					184,
					429
				],
				[
					150,
					146
				],
				[
					198,
					-134
				],
				[
					147,
					-14
				],
				[
					122,
					-154
				]
			],
			[
				[
					58175,
					39107
				],
				[
					-393,
					-424
				],
				[
					-249,
					-430
				],
				[
					-93,
					-383
				],
				[
					-83,
					-217
				],
				[
					-152,
					-46
				],
				[
					-48,
					-275
				],
				[
					-28,
					-180
				],
				[
					-178,
					-134
				],
				[
					-226,
					28
				],
				[
					-133,
					162
				],
				[
					-117,
					70
				],
				[
					-135,
					-134
				],
				[
					-68,
					-276
				],
				[
					-132,
					-173
				],
				[
					-139,
					-257
				],
				[
					-199,
					-59
				],
				[
					-62,
					202
				],
				[
					26,
					351
				],
				[
					-165,
					548
				],
				[
					-75,
					86
				]
			],
			[
				[
					55526,
					37566
				],
				[
					0,
					1681
				],
				[
					274,
					20
				],
				[
					8,
					2051
				],
				[
					207,
					19
				],
				[
					428,
					202
				],
				[
					106,
					-238
				],
				[
					177,
					226
				],
				[
					85,
					1
				],
				[
					156,
					130
				]
			],
			[
				[
					56967,
					41658
				],
				[
					50,
					-43
				]
			],
			[
				[
					57017,
					41615
				],
				[
					107,
					-460
				],
				[
					56,
					-103
				],
				[
					87,
					-333
				],
				[
					315,
					-633
				],
				[
					119,
					-62
				],
				[
					0,
					-203
				],
				[
					82,
					-365
				],
				[
					215,
					-88
				],
				[
					177,
					-261
				]
			],
			[
				[
					54244,
					56103
				],
				[
					229,
					44
				],
				[
					52,
					148
				],
				[
					46,
					-11
				],
				[
					69,
					-131
				],
				[
					350,
					221
				],
				[
					118,
					224
				],
				[
					145,
					202
				],
				[
					-28,
					202
				],
				[
					78,
					53
				],
				[
					269,
					-35
				],
				[
					261,
					266
				],
				[
					201,
					629
				],
				[
					141,
					233
				],
				[
					176,
					98
				]
			],
			[
				[
					56351,
					58246
				],
				[
					31,
					-246
				],
				[
					160,
					-360
				],
				[
					1,
					-235
				],
				[
					-45,
					-240
				],
				[
					18,
					-179
				],
				[
					96,
					-166
				]
			],
			[
				[
					56612,
					56820
				],
				[
					212,
					-252
				]
			],
			[
				[
					56824,
					56568
				],
				[
					152,
					-232
				],
				[
					2,
					-188
				],
				[
					187,
					-299
				],
				[
					116,
					-250
				],
				[
					70,
					-345
				],
				[
					208,
					-228
				],
				[
					44,
					-183
				]
			],
			[
				[
					57603,
					54843
				],
				[
					-91,
					-61
				],
				[
					-178,
					14
				],
				[
					-209,
					60
				],
				[
					-104,
					-49
				],
				[
					-41,
					-140
				],
				[
					-90,
					-17
				],
				[
					-110,
					121
				],
				[
					-309,
					-287
				],
				[
					-127,
					58
				],
				[
					-38,
					-45
				],
				[
					-83,
					-347
				],
				[
					-207,
					112
				],
				[
					-203,
					57
				],
				[
					-177,
					212
				],
				[
					-229,
					196
				],
				[
					-149,
					-186
				],
				[
					-108,
					-292
				],
				[
					-25,
					-402
				]
			],
			[
				[
					55125,
					53847
				],
				[
					-178,
					33
				],
				[
					-188,
					96
				],
				[
					-166,
					-305
				],
				[
					-146,
					-536
				]
			],
			[
				[
					54447,
					53135
				],
				[
					-29,
					167
				],
				[
					-12,
					263
				],
				[
					-127,
					185
				],
				[
					-103,
					297
				],
				[
					-23,
					207
				],
				[
					-132,
					301
				],
				[
					23,
					171
				],
				[
					-28,
					243
				],
				[
					21,
					446
				],
				[
					67,
					105
				],
				[
					140,
					583
				]
			],
			[
				[
					32315,
					78637
				],
				[
					202,
					-78
				],
				[
					257,
					16
				],
				[
					-137,
					-236
				],
				[
					-102,
					-37
				],
				[
					-353,
					244
				],
				[
					-69,
					193
				],
				[
					105,
					177
				],
				[
					97,
					-279
				]
			],
			[
				[
					32831,
					80108
				],
				[
					-135,
					-10
				],
				[
					-360,
					180
				],
				[
					-258,
					272
				],
				[
					96,
					49
				],
				[
					365,
					-145
				],
				[
					284,
					-240
				],
				[
					8,
					-106
				]
			],
			[
				[
					15692,
					79765
				],
				[
					-140,
					-80
				],
				[
					-456,
					262
				],
				[
					-84,
					204
				],
				[
					-248,
					202
				],
				[
					-50,
					164
				],
				[
					-286,
					103
				],
				[
					-107,
					314
				],
				[
					24,
					133
				],
				[
					291,
					-125
				],
				[
					171,
					-88
				],
				[
					261,
					-61
				],
				[
					94,
					-198
				],
				[
					138,
					-274
				],
				[
					277,
					-238
				],
				[
					115,
					-318
				]
			],
			[
				[
					34407,
					81019
				],
				[
					-184,
					-504
				],
				[
					181,
					195
				],
				[
					187,
					-124
				],
				[
					-98,
					-200
				],
				[
					247,
					-158
				],
				[
					128,
					140
				],
				[
					277,
					-177
				],
				[
					-86,
					-422
				],
				[
					194,
					99
				],
				[
					36,
					-306
				],
				[
					86,
					-358
				],
				[
					-117,
					-507
				],
				[
					-125,
					-21
				],
				[
					-183,
					109
				],
				[
					60,
					471
				],
				[
					-77,
					73
				],
				[
					-322,
					-499
				],
				[
					-166,
					20
				],
				[
					196,
					270
				],
				[
					-267,
					140
				],
				[
					-298,
					-34
				],
				[
					-539,
					17
				],
				[
					-43,
					171
				],
				[
					173,
					202
				],
				[
					-121,
					157
				],
				[
					234,
					347
				],
				[
					287,
					917
				],
				[
					172,
					328
				],
				[
					241,
					198
				],
				[
					129,
					-25
				],
				[
					-54,
					-156
				],
				[
					-148,
					-363
				]
			],
			[
				[
					13005,
					83025
				],
				[
					131,
					-75
				],
				[
					267,
					46
				],
				[
					-84,
					-654
				],
				[
					242,
					-463
				],
				[
					-111,
					1
				],
				[
					-167,
					264
				],
				[
					-103,
					265
				],
				[
					-140,
					179
				],
				[
					-51,
					253
				],
				[
					16,
					184
				]
			],
			[
				[
					27981,
					87625
				],
				[
					-108,
					-302
				],
				[
					-123,
					49
				],
				[
					-73,
					171
				],
				[
					13,
					40
				],
				[
					107,
					173
				],
				[
					114,
					-13
				],
				[
					70,
					-118
				]
			],
			[
				[
					27250,
					87943
				],
				[
					-325,
					-317
				],
				[
					-196,
					13
				],
				[
					-61,
					156
				],
				[
					207,
					265
				],
				[
					381,
					-5
				],
				[
					-6,
					-112
				]
			],
			[
				[
					26344,
					89640
				],
				[
					51,
					-253
				],
				[
					143,
					89
				],
				[
					161,
					-151
				],
				[
					304,
					-198
				],
				[
					318,
					-179
				],
				[
					25,
					-274
				],
				[
					204,
					45
				],
				[
					199,
					-191
				],
				[
					-247,
					-181
				],
				[
					-432,
					138
				],
				[
					-156,
					259
				],
				[
					-275,
					-306
				],
				[
					-396,
					-298
				],
				[
					-95,
					337
				],
				[
					-377,
					-55
				],
				[
					242,
					284
				],
				[
					35,
					454
				],
				[
					95,
					527
				],
				[
					201,
					-47
				]
			],
			[
				[
					28926,
					90499
				],
				[
					-312,
					-29
				],
				[
					-69,
					282
				],
				[
					118,
					323
				],
				[
					255,
					80
				],
				[
					217,
					-160
				],
				[
					3,
					-246
				],
				[
					-32,
					-80
				],
				[
					-180,
					-170
				]
			],
			[
				[
					23431,
					91627
				],
				[
					-173,
					-202
				],
				[
					-374,
					175
				],
				[
					-226,
					-63
				],
				[
					-380,
					259
				],
				[
					245,
					178
				],
				[
					194,
					250
				],
				[
					295,
					-164
				],
				[
					166,
					-103
				],
				[
					84,
					-110
				],
				[
					169,
					-220
				]
			],
			[
				[
					31350,
					77823
				],
				[
					-181,
					326
				],
				[
					0,
					785
				],
				[
					-123,
					166
				],
				[
					-187,
					-98
				],
				[
					-92,
					152
				],
				[
					-212,
					-435
				],
				[
					-84,
					-448
				],
				[
					-99,
					-262
				],
				[
					-118,
					-89
				],
				[
					-89,
					-29
				],
				[
					-28,
					-142
				],
				[
					-512,
					-1
				],
				[
					-422,
					-4
				],
				[
					-125,
					-106
				],
				[
					-294,
					-414
				],
				[
					-34,
					-45
				],
				[
					-89,
					-225
				],
				[
					-255,
					0
				],
				[
					-273,
					-2
				],
				[
					-125,
					-91
				],
				[
					44,
					-113
				],
				[
					25,
					-176
				],
				[
					-5,
					-58
				],
				[
					-363,
					-287
				],
				[
					-286,
					-90
				],
				[
					-323,
					-308
				],
				[
					-70,
					0
				],
				[
					-94,
					91
				],
				[
					-31,
					82
				],
				[
					6,
					60
				],
				[
					61,
					202
				],
				[
					131,
					317
				],
				[
					81,
					340
				],
				[
					-56,
					500
				],
				[
					-59,
					523
				],
				[
					-290,
					270
				],
				[
					35,
					103
				],
				[
					-41,
					70
				],
				[
					-76,
					0
				],
				[
					-56,
					91
				],
				[
					-14,
					137
				],
				[
					-54,
					-60
				],
				[
					-75,
					18
				],
				[
					17,
					57
				],
				[
					-65,
					57
				],
				[
					-27,
					151
				],
				[
					-216,
					185
				],
				[
					-224,
					191
				],
				[
					-272,
					223
				],
				[
					-261,
					209
				],
				[
					-248,
					-163
				],
				[
					-91,
					-6
				],
				[
					-342,
					150
				],
				[
					-225,
					-75
				],
				[
					-269,
					179
				],
				[
					-284,
					91
				],
				[
					-194,
					36
				],
				[
					-86,
					97
				],
				[
					-49,
					317
				],
				[
					-94,
					-3
				],
				[
					-1,
					-221
				],
				[
					-575,
					0
				],
				[
					-951,
					0
				],
				[
					-944,
					-1
				],
				[
					-833,
					1
				],
				[
					-834,
					0
				],
				[
					-819,
					0
				],
				[
					-847,
					0
				],
				[
					-273,
					0
				],
				[
					-825,
					0
				],
				[
					-788,
					0
				]
			],
			[
				[
					15878,
					80048
				],
				[
					-38,
					1
				],
				[
					-537,
					566
				],
				[
					-199,
					248
				],
				[
					-503,
					239
				],
				[
					-155,
					510
				],
				[
					40,
					353
				],
				[
					-356,
					245
				],
				[
					-48,
					464
				],
				[
					-336,
					419
				],
				[
					-6,
					296
				]
			],
			[
				[
					13740,
					83389
				],
				[
					154,
					278
				],
				[
					-7,
					363
				],
				[
					-473,
					367
				],
				[
					-284,
					657
				],
				[
					-173,
					413
				],
				[
					-255,
					259
				],
				[
					-187,
					236
				],
				[
					-147,
					298
				],
				[
					-279,
					-187
				],
				[
					-270,
					-321
				],
				[
					-247,
					378
				],
				[
					-194,
					252
				],
				[
					-271,
					160
				],
				[
					-273,
					17
				],
				[
					1,
					3279
				],
				[
					2,
					2137
				]
			],
			[
				[
					10837,
					91975
				],
				[
					518,
					-139
				],
				[
					438,
					-277
				],
				[
					289,
					-53
				],
				[
					244,
					241
				],
				[
					336,
					179
				],
				[
					413,
					-70
				],
				[
					416,
					253
				],
				[
					455,
					144
				],
				[
					191,
					-239
				],
				[
					207,
					134
				],
				[
					62,
					272
				],
				[
					192,
					-62
				],
				[
					470,
					-516
				],
				[
					369,
					390
				],
				[
					38,
					-437
				],
				[
					341,
					95
				],
				[
					105,
					168
				],
				[
					337,
					-33
				],
				[
					424,
					-242
				],
				[
					650,
					-211
				],
				[
					383,
					-98
				],
				[
					272,
					37
				],
				[
					374,
					-292
				],
				[
					-390,
					-286
				],
				[
					502,
					-123
				],
				[
					750,
					68
				],
				[
					236,
					100
				],
				[
					296,
					-345
				],
				[
					302,
					291
				],
				[
					-283,
					245
				],
				[
					179,
					197
				],
				[
					338,
					26
				],
				[
					223,
					58
				],
				[
					224,
					-138
				],
				[
					279,
					-312
				],
				[
					310,
					46
				],
				[
					491,
					-260
				],
				[
					431,
					91
				],
				[
					405,
					-13
				],
				[
					-32,
					358
				],
				[
					247,
					100
				],
				[
					431,
					-195
				],
				[
					-2,
					-545
				],
				[
					177,
					459
				],
				[
					223,
					-15
				],
				[
					126,
					579
				],
				[
					-298,
					355
				],
				[
					-324,
					233
				],
				[
					22,
					636
				],
				[
					329,
					418
				],
				[
					366,
					-92
				],
				[
					281,
					-255
				],
				[
					378,
					-649
				],
				[
					-247,
					-283
				],
				[
					517,
					-116
				],
				[
					-1,
					-589
				],
				[
					371,
					451
				],
				[
					332,
					-371
				],
				[
					-83,
					-427
				],
				[
					269,
					-388
				],
				[
					290,
					416
				],
				[
					202,
					497
				],
				[
					16,
					632
				],
				[
					394,
					-44
				],
				[
					411,
					-85
				],
				[
					373,
					-286
				],
				[
					17,
					-285
				],
				[
					-207,
					-307
				],
				[
					196,
					-309
				],
				[
					-36,
					-280
				],
				[
					-544,
					-403
				],
				[
					-386,
					-88
				],
				[
					-287,
					173
				],
				[
					-83,
					-289
				],
				[
					-268,
					-486
				],
				[
					-81,
					-252
				],
				[
					-322,
					-389
				],
				[
					-397,
					-38
				],
				[
					-220,
					-244
				],
				[
					-18,
					-374
				],
				[
					-323,
					-72
				],
				[
					-340,
					-467
				],
				[
					-301,
					-648
				],
				[
					-108,
					-454
				],
				[
					-16,
					-669
				],
				[
					409,
					-96
				],
				[
					125,
					-539
				],
				[
					130,
					-437
				],
				[
					388,
					114
				],
				[
					517,
					-250
				],
				[
					277,
					-219
				],
				[
					199,
					-272
				],
				[
					348,
					-158
				],
				[
					294,
					-243
				],
				[
					459,
					-33
				],
				[
					302,
					-56
				],
				[
					-45,
					-499
				],
				[
					86,
					-578
				],
				[
					201,
					-645
				],
				[
					414,
					-547
				],
				[
					214,
					188
				],
				[
					150,
					592
				],
				[
					-145,
					909
				],
				[
					-196,
					303
				],
				[
					445,
					270
				],
				[
					314,
					404
				],
				[
					154,
					401
				],
				[
					-23,
					385
				],
				[
					-188,
					489
				],
				[
					-338,
					434
				],
				[
					328,
					603
				],
				[
					-121,
					522
				],
				[
					-93,
					899
				],
				[
					194,
					133
				],
				[
					476,
					-157
				],
				[
					286,
					-56
				],
				[
					230,
					152
				],
				[
					258,
					-196
				],
				[
					342,
					-333
				],
				[
					85,
					-224
				],
				[
					495,
					-44
				],
				[
					-8,
					-483
				],
				[
					92,
					-728
				],
				[
					254,
					-90
				],
				[
					201,
					-339
				],
				[
					402,
					319
				],
				[
					266,
					636
				],
				[
					184,
					267
				],
				[
					216,
					-514
				],
				[
					362,
					-734
				],
				[
					307,
					-691
				],
				[
					-112,
					-362
				],
				[
					370,
					-325
				],
				[
					250,
					-329
				],
				[
					442,
					-149
				],
				[
					179,
					-183
				],
				[
					110,
					-488
				],
				[
					216,
					-76
				],
				[
					112,
					-217
				],
				[
					20,
					-647
				],
				[
					-202,
					-217
				],
				[
					-199,
					-202
				],
				[
					-458,
					-205
				],
				[
					-349,
					-473
				],
				[
					-470,
					-93
				],
				[
					-594,
					121
				],
				[
					-417,
					4
				],
				[
					-287,
					-40
				],
				[
					-233,
					-413
				],
				[
					-354,
					-255
				],
				[
					-401,
					-762
				],
				[
					-320,
					-532
				],
				[
					236,
					95
				],
				[
					446,
					756
				],
				[
					583,
					480
				],
				[
					415,
					58
				],
				[
					246,
					-283
				],
				[
					-262,
					-387
				],
				[
					88,
					-620
				],
				[
					91,
					-435
				],
				[
					361,
					-287
				],
				[
					459,
					83
				],
				[
					278,
					647
				],
				[
					19,
					-417
				],
				[
					180,
					-209
				],
				[
					-344,
					-377
				],
				[
					-615,
					-343
				],
				[
					-276,
					-233
				],
				[
					-310,
					-415
				],
				[
					-211,
					43
				],
				[
					-11,
					487
				],
				[
					483,
					476
				],
				[
					-445,
					-19
				],
				[
					-309,
					-70
				]
			],
			[
				[
					18287,
					93939
				],
				[
					-139,
					-270
				],
				[
					618,
					174
				],
				[
					386,
					-291
				],
				[
					314,
					294
				],
				[
					254,
					-188
				],
				[
					227,
					-566
				],
				[
					140,
					238
				],
				[
					-197,
					590
				],
				[
					244,
					85
				],
				[
					276,
					-93
				],
				[
					311,
					-232
				],
				[
					175,
					-561
				],
				[
					86,
					-406
				],
				[
					466,
					-285
				],
				[
					502,
					-273
				],
				[
					-31,
					-253
				],
				[
					-456,
					-47
				],
				[
					178,
					-221
				],
				[
					-94,
					-211
				],
				[
					-503,
					90
				],
				[
					-478,
					156
				],
				[
					-322,
					-35
				],
				[
					-522,
					-196
				],
				[
					-704,
					-86
				],
				[
					-494,
					-54
				],
				[
					-151,
					271
				],
				[
					-379,
					157
				],
				[
					-246,
					-64
				],
				[
					-343,
					456
				],
				[
					185,
					61
				],
				[
					429,
					99
				],
				[
					392,
					-26
				],
				[
					362,
					100
				],
				[
					-537,
					135
				],
				[
					-594,
					-46
				],
				[
					-394,
					11
				],
				[
					-146,
					213
				],
				[
					644,
					230
				],
				[
					-428,
					-8
				],
				[
					-485,
					152
				],
				[
					233,
					431
				],
				[
					193,
					229
				],
				[
					744,
					351
				],
				[
					284,
					-111
				]
			],
			[
				[
					20972,
					94111
				],
				[
					-244,
					-381
				],
				[
					-434,
					404
				],
				[
					95,
					80
				],
				[
					372,
					23
				],
				[
					211,
					-126
				]
			],
			[
				[
					28794,
					93928
				],
				[
					25,
					-159
				],
				[
					-296,
					16
				],
				[
					-299,
					13
				],
				[
					-304,
					-78
				],
				[
					-80,
					35
				],
				[
					-306,
					306
				],
				[
					12,
					207
				],
				[
					133,
					38
				],
				[
					636,
					-62
				],
				[
					479,
					-316
				]
			],
			[
				[
					25955,
					93959
				],
				[
					219,
					-359
				],
				[
					256,
					465
				],
				[
					704,
					236
				],
				[
					477,
					-596
				],
				[
					-42,
					-377
				],
				[
					550,
					168
				],
				[
					263,
					228
				],
				[
					616,
					-291
				],
				[
					383,
					-274
				],
				[
					36,
					-252
				],
				[
					515,
					131
				],
				[
					290,
					-367
				],
				[
					670,
					-228
				],
				[
					242,
					-232
				],
				[
					263,
					-539
				],
				[
					-510,
					-268
				],
				[
					654,
					-376
				],
				[
					441,
					-127
				],
				[
					400,
					-529
				],
				[
					437,
					-38
				],
				[
					-87,
					-404
				],
				[
					-487,
					-669
				],
				[
					-342,
					246
				],
				[
					-437,
					554
				],
				[
					-359,
					-72
				],
				[
					-35,
					-330
				],
				[
					292,
					-335
				],
				[
					377,
					-265
				],
				[
					114,
					-153
				],
				[
					181,
					-570
				],
				[
					-96,
					-414
				],
				[
					-350,
					156
				],
				[
					-697,
					461
				],
				[
					393,
					-496
				],
				[
					289,
					-348
				],
				[
					45,
					-201
				],
				[
					-753,
					230
				],
				[
					-596,
					334
				],
				[
					-337,
					281
				],
				[
					97,
					162
				],
				[
					-414,
					296
				],
				[
					-405,
					280
				],
				[
					5,
					-167
				],
				[
					-803,
					-92
				],
				[
					-235,
					198
				],
				[
					183,
					424
				],
				[
					522,
					10
				],
				[
					571,
					74
				],
				[
					-92,
					205
				],
				[
					96,
					287
				],
				[
					360,
					561
				],
				[
					-77,
					255
				],
				[
					-107,
					197
				],
				[
					-425,
					280
				],
				[
					-563,
					196
				],
				[
					178,
					145
				],
				[
					-294,
					358
				],
				[
					-245,
					33
				],
				[
					-219,
					196
				],
				[
					-149,
					-170
				],
				[
					-503,
					-74
				],
				[
					-1011,
					129
				],
				[
					-588,
					169
				],
				[
					-450,
					87
				],
				[
					-231,
					202
				],
				[
					290,
					263
				],
				[
					-394,
					2
				],
				[
					-88,
					583
				],
				[
					213,
					515
				],
				[
					286,
					235
				],
				[
					717,
					154
				],
				[
					-204,
					-373
				]
			],
			[
				[
					22123,
					94355
				],
				[
					331,
					-122
				],
				[
					496,
					73
				],
				[
					72,
					-167
				],
				[
					-259,
					-276
				],
				[
					420,
					-248
				],
				[
					-50,
					-518
				],
				[
					-455,
					-223
				],
				[
					-268,
					48
				],
				[
					-192,
					220
				],
				[
					-690,
					444
				],
				[
					5,
					185
				],
				[
					567,
					-72
				],
				[
					-306,
					377
				],
				[
					329,
					279
				]
			],
			[
				[
					24112,
					93737
				],
				[
					-298,
					-430
				],
				[
					-317,
					21
				],
				[
					-173,
					506
				],
				[
					4,
					287
				],
				[
					145,
					244
				],
				[
					276,
					157
				],
				[
					579,
					-20
				],
				[
					530,
					-140
				],
				[
					-415,
					-513
				],
				[
					-331,
					-112
				]
			],
			[
				[
					16539,
					92938
				],
				[
					-731,
					-278
				],
				[
					-147,
					253
				],
				[
					-641,
					304
				],
				[
					119,
					244
				],
				[
					192,
					421
				],
				[
					241,
					378
				],
				[
					-272,
					353
				],
				[
					939,
					90
				],
				[
					397,
					-119
				],
				[
					709,
					-32
				],
				[
					270,
					-167
				],
				[
					298,
					-243
				],
				[
					-349,
					-145
				],
				[
					-681,
					-405
				],
				[
					-344,
					-403
				],
				[
					0,
					-251
				]
			],
			[
				[
					23996,
					95009
				],
				[
					-151,
					-223
				],
				[
					-403,
					43
				],
				[
					-337,
					150
				],
				[
					148,
					259
				],
				[
					399,
					155
				],
				[
					243,
					-202
				],
				[
					101,
					-182
				]
			],
			[
				[
					22639,
					96011
				],
				[
					212,
					-267
				],
				[
					9,
					-295
				],
				[
					-127,
					-429
				],
				[
					-458,
					-59
				],
				[
					-298,
					92
				],
				[
					5,
					336
				],
				[
					-455,
					-44
				],
				[
					-18,
					445
				],
				[
					299,
					-18
				],
				[
					419,
					197
				],
				[
					390,
					-34
				],
				[
					22,
					76
				]
			],
			[
				[
					19941,
					95712
				],
				[
					109,
					-205
				],
				[
					247,
					97
				],
				[
					291,
					-25
				],
				[
					49,
					-282
				],
				[
					-169,
					-274
				],
				[
					-940,
					-89
				],
				[
					-701,
					-249
				],
				[
					-423,
					-13
				],
				[
					-35,
					187
				],
				[
					577,
					255
				],
				[
					-1255,
					-69
				],
				[
					-389,
					103
				],
				[
					379,
					563
				],
				[
					262,
					161
				],
				[
					782,
					-194
				],
				[
					493,
					-341
				],
				[
					485,
					-44
				],
				[
					-397,
					551
				],
				[
					255,
					210
				],
				[
					286,
					-67
				],
				[
					94,
					-275
				]
			],
			[
				[
					23699,
					96229
				],
				[
					308,
					-186
				],
				[
					547,
					2
				],
				[
					240,
					-190
				],
				[
					-64,
					-216
				],
				[
					319,
					-130
				],
				[
					177,
					-137
				],
				[
					374,
					-26
				],
				[
					406,
					-48
				],
				[
					441,
					125
				],
				[
					566,
					49
				],
				[
					451,
					-40
				],
				[
					298,
					-218
				],
				[
					62,
					-238
				],
				[
					-174,
					-153
				],
				[
					-414,
					-124
				],
				[
					-355,
					70
				],
				[
					-797,
					-88
				],
				[
					-570,
					-11
				],
				[
					-449,
					71
				],
				[
					-738,
					186
				],
				[
					-96,
					316
				],
				[
					-34,
					286
				],
				[
					-279,
					251
				],
				[
					-574,
					70
				],
				[
					-322,
					179
				],
				[
					104,
					236
				],
				[
					573,
					-36
				]
			],
			[
				[
					17722,
					96544
				],
				[
					-38,
					-443
				],
				[
					-214,
					-199
				],
				[
					-259,
					-29
				],
				[
					-517,
					-246
				],
				[
					-444,
					-88
				],
				[
					-377,
					124
				],
				[
					472,
					431
				],
				[
					570,
					373
				],
				[
					426,
					-8
				],
				[
					381,
					85
				]
			],
			[
				[
					23933,
					96472
				],
				[
					-126,
					-17
				],
				[
					-521,
					37
				],
				[
					-74,
					161
				],
				[
					559,
					-9
				],
				[
					195,
					-107
				],
				[
					-33,
					-65
				]
			],
			[
				[
					19392,
					96574
				],
				[
					-518,
					-166
				],
				[
					-411,
					186
				],
				[
					224,
					183
				],
				[
					406,
					59
				],
				[
					392,
					-90
				],
				[
					-93,
					-172
				]
			],
			[
				[
					19538,
					97095
				],
				[
					-339,
					-113
				],
				[
					-461,
					1
				],
				[
					5,
					82
				],
				[
					285,
					173
				],
				[
					149,
					-27
				],
				[
					361,
					-116
				]
			],
			[
				[
					23380,
					96781
				],
				[
					-411,
					-119
				],
				[
					-226,
					134
				],
				[
					-119,
					216
				],
				[
					-22,
					238
				],
				[
					360,
					-23
				],
				[
					162,
					-38
				],
				[
					332,
					-200
				],
				[
					-76,
					-208
				]
			],
			[
				[
					22205,
					96935
				],
				[
					108,
					-240
				],
				[
					-453,
					64
				],
				[
					-457,
					187
				],
				[
					-619,
					21
				],
				[
					268,
					171
				],
				[
					-335,
					139
				],
				[
					-21,
					221
				],
				[
					546,
					-79
				],
				[
					751,
					-210
				],
				[
					212,
					-274
				]
			],
			[
				[
					25828,
					97704
				],
				[
					334,
					-186
				],
				[
					-381,
					-171
				],
				[
					-513,
					-434
				],
				[
					-492,
					-41
				],
				[
					-575,
					74
				],
				[
					-299,
					235
				],
				[
					4,
					208
				],
				[
					220,
					154
				],
				[
					-508,
					-5
				],
				[
					-306,
					192
				],
				[
					-176,
					261
				],
				[
					193,
					256
				],
				[
					192,
					175
				],
				[
					285,
					41
				],
				[
					-122,
					132
				],
				[
					646,
					29
				],
				[
					355,
					-308
				],
				[
					468,
					-123
				],
				[
					455,
					-109
				],
				[
					220,
					-380
				]
			],
			[
				[
					30972,
					99689
				],
				[
					742,
					-45
				],
				[
					597,
					-74
				],
				[
					508,
					-156
				],
				[
					-12,
					-154
				],
				[
					-678,
					-250
				],
				[
					-672,
					-117
				],
				[
					-251,
					-129
				],
				[
					605,
					3
				],
				[
					-656,
					-349
				],
				[
					-452,
					-163
				],
				[
					-476,
					-470
				],
				[
					-573,
					-96
				],
				[
					-177,
					-117
				],
				[
					-841,
					-62
				],
				[
					383,
					-72
				],
				[
					-192,
					-103
				],
				[
					230,
					-284
				],
				[
					-264,
					-198
				],
				[
					-429,
					-163
				],
				[
					-132,
					-225
				],
				[
					-388,
					-172
				],
				[
					39,
					-130
				],
				[
					475,
					22
				],
				[
					6,
					-141
				],
				[
					-742,
					-345
				],
				[
					-726,
					159
				],
				[
					-816,
					-89
				],
				[
					-414,
					69
				],
				[
					-525,
					30
				],
				[
					-35,
					277
				],
				[
					514,
					130
				],
				[
					-137,
					415
				],
				[
					170,
					41
				],
				[
					742,
					-249
				],
				[
					-379,
					370
				],
				[
					-450,
					110
				],
				[
					225,
					223
				],
				[
					492,
					137
				],
				[
					79,
					201
				],
				[
					-392,
					225
				],
				[
					-118,
					297
				],
				[
					759,
					-25
				],
				[
					220,
					-63
				],
				[
					433,
					210
				],
				[
					-625,
					67
				],
				[
					-972,
					-37
				],
				[
					-491,
					196
				],
				[
					-232,
					232
				],
				[
					-324,
					169
				],
				[
					-61,
					197
				],
				[
					413,
					110
				],
				[
					324,
					18
				],
				[
					545,
					94
				],
				[
					409,
					214
				],
				[
					344,
					-30
				],
				[
					300,
					-161
				],
				[
					211,
					311
				],
				[
					367,
					92
				],
				[
					498,
					64
				],
				[
					849,
					24
				],
				[
					148,
					-63
				],
				[
					802,
					98
				],
				[
					601,
					-37
				],
				[
					602,
					-36
				]
			],
			[
				[
					52900,
					78834
				],
				[
					-22,
					-236
				],
				[
					-122,
					-97
				],
				[
					-206,
					72
				],
				[
					-60,
					-232
				],
				[
					-132,
					-18
				],
				[
					-48,
					91
				],
				[
					-156,
					-195
				],
				[
					-134,
					-28
				],
				[
					-120,
					124
				]
			],
			[
				[
					51900,
					78315
				],
				[
					-95,
					252
				],
				[
					-133,
					-90
				],
				[
					5,
					261
				],
				[
					203,
					323
				],
				[
					-9,
					147
				],
				[
					126,
					-53
				],
				[
					77,
					98
				]
			],
			[
				[
					52074,
					79253
				],
				[
					236,
					-4
				],
				[
					57,
					125
				],
				[
					298,
					-176
				]
			],
			[
				[
					31400,
					20215
				],
				[
					-92,
					-233
				],
				[
					-238,
					-178
				],
				[
					-137,
					18
				],
				[
					-164,
					46
				],
				[
					-202,
					174
				],
				[
					-291,
					83
				],
				[
					-350,
					322
				],
				[
					-283,
					309
				],
				[
					-383,
					645
				],
				[
					229,
					-121
				],
				[
					390,
					-384
				],
				[
					369,
					-207
				],
				[
					143,
					264
				],
				[
					90,
					394
				],
				[
					256,
					238
				],
				[
					198,
					-68
				]
			],
			[
				[
					30952,
					21711
				],
				[
					-247,
					4
				],
				[
					-134,
					-141
				],
				[
					-250,
					-208
				],
				[
					-45,
					-538
				],
				[
					-118,
					-14
				],
				[
					-313,
					188
				],
				[
					-318,
					401
				],
				[
					-346,
					329
				],
				[
					-87,
					365
				],
				[
					79,
					337
				],
				[
					-140,
					383
				],
				[
					-36,
					982
				],
				[
					119,
					554
				],
				[
					293,
					445
				],
				[
					-422,
					168
				],
				[
					265,
					509
				],
				[
					94,
					956
				],
				[
					309,
					-202
				],
				[
					145,
					1193
				],
				[
					-186,
					153
				],
				[
					-87,
					-719
				],
				[
					-175,
					81
				],
				[
					87,
					823
				],
				[
					95,
					1067
				],
				[
					127,
					394
				],
				[
					-80,
					562
				],
				[
					-22,
					649
				],
				[
					117,
					18
				],
				[
					170,
					930
				],
				[
					192,
					922
				],
				[
					118,
					858
				],
				[
					-64,
					863
				],
				[
					83,
					475
				],
				[
					-34,
					711
				],
				[
					163,
					703
				],
				[
					50,
					1114
				],
				[
					89,
					1196
				],
				[
					87,
					1287
				],
				[
					-20,
					943
				],
				[
					-58,
					811
				]
			],
			[
				[
					30452,
					41263
				],
				[
					143,
					147
				],
				[
					74,
					295
				]
			],
			[
				[
					80649,
					62586
				],
				[
					-240,
					-277
				],
				[
					-228,
					179
				],
				[
					-8,
					495
				],
				[
					137,
					261
				],
				[
					304,
					161
				],
				[
					159,
					-13
				],
				[
					62,
					-220
				],
				[
					-122,
					-254
				],
				[
					-64,
					-332
				]
			],
			[
				[
					86288,
					76244
				],
				[
					-179,
					340
				],
				[
					-111,
					-323
				],
				[
					-429,
					-248
				],
				[
					44,
					-304
				],
				[
					-241,
					21
				],
				[
					-131,
					181
				],
				[
					-191,
					-409
				],
				[
					-306,
					-309
				],
				[
					-227,
					-370
				]
			],
			[
				[
					84517,
					74823
				],
				[
					-388,
					-167
				],
				[
					-204,
					-269
				],
				[
					-300,
					-157
				],
				[
					148,
					267
				],
				[
					-58,
					224
				],
				[
					220,
					387
				],
				[
					-147,
					302
				],
				[
					-242,
					-204
				],
				[
					-314,
					-400
				],
				[
					-171,
					-372
				],
				[
					-272,
					-28
				],
				[
					-142,
					-268
				],
				[
					147,
					-390
				],
				[
					227,
					-94
				],
				[
					9,
					-259
				],
				[
					220,
					-168
				],
				[
					311,
					411
				],
				[
					247,
					-224
				],
				[
					179,
					-15
				],
				[
					45,
					-302
				],
				[
					-393,
					-161
				],
				[
					-130,
					-311
				],
				[
					-270,
					-289
				],
				[
					-142,
					-403
				],
				[
					299,
					-316
				],
				[
					109,
					-567
				],
				[
					169,
					-527
				],
				[
					189,
					-443
				],
				[
					-5,
					-428
				],
				[
					-174,
					-157
				],
				[
					66,
					-307
				],
				[
					164,
					-179
				],
				[
					-43,
					-469
				],
				[
					-71,
					-456
				],
				[
					-155,
					-52
				],
				[
					-203,
					-623
				],
				[
					-225,
					-756
				],
				[
					-258,
					-687
				],
				[
					-382,
					-532
				],
				[
					-386,
					-484
				],
				[
					-313,
					-67
				],
				[
					-170,
					-255
				],
				[
					-96,
					186
				],
				[
					-157,
					-286
				],
				[
					-388,
					-288
				],
				[
					-294,
					-88
				],
				[
					-95,
					-609
				],
				[
					-154,
					-33
				],
				[
					-73,
					418
				],
				[
					66,
					222
				],
				[
					-373,
					185
				],
				[
					-131,
					-94
				]
			],
			[
				[
					80013,
					64241
				],
				[
					-280,
					149
				],
				[
					-132,
					234
				],
				[
					44,
					332
				],
				[
					-254,
					105
				],
				[
					-134,
					216
				],
				[
					-236,
					-307
				],
				[
					-271,
					-66
				],
				[
					-221,
					3
				],
				[
					-149,
					-141
				]
			],
			[
				[
					78380,
					64766
				],
				[
					-144,
					-84
				],
				[
					42,
					-659
				],
				[
					-148,
					16
				],
				[
					-25,
					135
				]
			],
			[
				[
					78105,
					64174
				],
				[
					-9,
					238
				],
				[
					-203,
					-167
				],
				[
					-121,
					106
				],
				[
					-206,
					216
				],
				[
					81,
					478
				],
				[
					-176,
					112
				],
				[
					-66,
					530
				],
				[
					-293,
					-96
				],
				[
					33,
					684
				],
				[
					263,
					480
				],
				[
					11,
					475
				],
				[
					-8,
					441
				],
				[
					-121,
					137
				],
				[
					-93,
					339
				],
				[
					-162,
					-42
				]
			],
			[
				[
					77035,
					68105
				],
				[
					-300,
					86
				],
				[
					94,
					242
				],
				[
					-130,
					358
				],
				[
					-198,
					-243
				],
				[
					-233,
					142
				],
				[
					-321,
					-367
				],
				[
					-252,
					-428
				],
				[
					-224,
					-72
				]
			],
			[
				[
					74670,
					67550
				],
				[
					-23,
					454
				],
				[
					-170,
					-121
				]
			],
			[
				[
					74477,
					67883
				],
				[
					-324,
					56
				],
				[
					-314,
					132
				],
				[
					-225,
					253
				],
				[
					-216,
					114
				],
				[
					-93,
					276
				],
				[
					-157,
					83
				],
				[
					-280,
					375
				],
				[
					-223,
					177
				],
				[
					-115,
					-138
				]
			],
			[
				[
					72530,
					69211
				],
				[
					-386,
					403
				],
				[
					-273,
					365
				],
				[
					-78,
					635
				],
				[
					200,
					-78
				],
				[
					9,
					294
				],
				[
					-111,
					295
				],
				[
					28,
					470
				],
				[
					-298,
					675
				]
			],
			[
				[
					71621,
					72270
				],
				[
					-457,
					233
				],
				[
					-82,
					442
				],
				[
					-205,
					269
				]
			],
			[
				[
					70827,
					73379
				],
				[
					-42,
					328
				],
				[
					10,
					224
				],
				[
					-169,
					131
				],
				[
					-91,
					-58
				],
				[
					-70,
					533
				]
			],
			[
				[
					70465,
					74537
				],
				[
					79,
					132
				],
				[
					-39,
					135
				],
				[
					266,
					272
				],
				[
					192,
					112
				],
				[
					294,
					-77
				],
				[
					105,
					368
				],
				[
					356,
					68
				],
				[
					99,
					229
				],
				[
					438,
					312
				],
				[
					39,
					130
				]
			],
			[
				[
					72294,
					76218
				],
				[
					-22,
					328
				],
				[
					190,
					150
				],
				[
					-250,
					1000
				],
				[
					550,
					231
				],
				[
					143,
					128
				],
				[
					200,
					1031
				],
				[
					551,
					-190
				],
				[
					155,
					261
				],
				[
					13,
					577
				],
				[
					230,
					54
				],
				[
					212,
					383
				]
			],
			[
				[
					74266,
					80171
				],
				[
					109,
					48
				]
			],
			[
				[
					74375,
					80219
				],
				[
					73,
					-402
				],
				[
					233,
					-306
				],
				[
					396,
					-216
				],
				[
					192,
					-464
				],
				[
					-107,
					-673
				],
				[
					100,
					-249
				],
				[
					330,
					-99
				],
				[
					374,
					-80
				],
				[
					336,
					-359
				],
				[
					171,
					-64
				],
				[
					127,
					-531
				],
				[
					163,
					-342
				],
				[
					306,
					14
				],
				[
					574,
					-129
				],
				[
					369,
					80
				],
				[
					274,
					-86
				],
				[
					411,
					-350
				],
				[
					336,
					1
				],
				[
					123,
					-179
				],
				[
					324,
					309
				],
				[
					448,
					200
				],
				[
					417,
					21
				],
				[
					324,
					203
				],
				[
					200,
					309
				],
				[
					194,
					193
				],
				[
					-45,
					190
				],
				[
					-89,
					222
				],
				[
					146,
					371
				],
				[
					156,
					-52
				],
				[
					286,
					-117
				],
				[
					277,
					306
				],
				[
					423,
					223
				],
				[
					204,
					380
				],
				[
					195,
					164
				],
				[
					404,
					77
				],
				[
					219,
					-65
				],
				[
					30,
					204
				],
				[
					-251,
					403
				],
				[
					-223,
					184
				],
				[
					-214,
					-212
				],
				[
					-274,
					89
				],
				[
					-157,
					-73
				],
				[
					-72,
					236
				],
				[
					197,
					575
				],
				[
					135,
					434
				]
			],
			[
				[
					82410,
					80559
				],
				[
					333,
					-217
				],
				[
					392,
					364
				],
				[
					-3,
					253
				],
				[
					251,
					611
				],
				[
					155,
					184
				],
				[
					-4,
					318
				],
				[
					-152,
					137
				],
				[
					229,
					287
				],
				[
					345,
					104
				],
				[
					369,
					15
				],
				[
					415,
					-171
				],
				[
					244,
					-212
				],
				[
					172,
					-581
				],
				[
					104,
					-248
				],
				[
					97,
					-354
				],
				[
					103,
					-564
				],
				[
					483,
					-184
				],
				[
					329,
					-409
				],
				[
					112,
					-541
				],
				[
					423,
					-1
				],
				[
					240,
					227
				],
				[
					459,
					170
				],
				[
					-146,
					-518
				],
				[
					-107,
					-211
				],
				[
					-96,
					-631
				],
				[
					-186,
					-560
				],
				[
					-338,
					102
				],
				[
					-238,
					-203
				],
				[
					73,
					-494
				],
				[
					-40,
					-680
				],
				[
					-142,
					-16
				],
				[
					2,
					-292
				]
			],
			[
				[
					49206,
					54706
				],
				[
					-126,
					-6
				],
				[
					-194,
					112
				],
				[
					-178,
					-6
				],
				[
					-329,
					-101
				],
				[
					-193,
					-166
				],
				[
					-275,
					-211
				],
				[
					-54,
					15
				]
			],
			[
				[
					47857,
					54343
				],
				[
					22,
					474
				],
				[
					26,
					72
				],
				[
					-8,
					227
				],
				[
					-118,
					241
				],
				[
					-88,
					39
				],
				[
					-81,
					158
				],
				[
					60,
					256
				],
				[
					-28,
					278
				],
				[
					13,
					168
				]
			],
			[
				[
					47655,
					56256
				],
				[
					44,
					0
				],
				[
					17,
					251
				],
				[
					-22,
					112
				],
				[
					27,
					80
				],
				[
					103,
					69
				],
				[
					-69,
					461
				],
				[
					-64,
					238
				],
				[
					23,
					195
				],
				[
					55,
					45
				]
			],
			[
				[
					47769,
					57707
				],
				[
					36,
					52
				],
				[
					77,
					-86
				],
				[
					215,
					-5
				],
				[
					51,
					168
				],
				[
					48,
					-11
				],
				[
					80,
					65
				],
				[
					43,
					-246
				],
				[
					65,
					72
				],
				[
					114,
					86
				]
			],
			[
				[
					49214,
					57382
				],
				[
					74,
					-819
				],
				[
					-117,
					-484
				],
				[
					-73,
					-650
				],
				[
					121,
					-496
				],
				[
					-13,
					-227
				]
			],
			[
				[
					53632,
					53135
				],
				[
					-35,
					31
				],
				[
					-164,
					-74
				],
				[
					-169,
					77
				],
				[
					-132,
					-38
				]
			],
			[
				[
					53132,
					53131
				],
				[
					-452,
					14
				]
			],
			[
				[
					52680,
					53145
				],
				[
					40,
					454
				],
				[
					-108,
					381
				],
				[
					-127,
					98
				],
				[
					-56,
					258
				],
				[
					-72,
					82
				],
				[
					4,
					159
				]
			],
			[
				[
					52361,
					54577
				],
				[
					71,
					408
				],
				[
					132,
					556
				],
				[
					81,
					5
				],
				[
					165,
					337
				],
				[
					105,
					9
				],
				[
					156,
					-236
				],
				[
					191,
					194
				],
				[
					26,
					239
				],
				[
					63,
					232
				],
				[
					43,
					291
				],
				[
					148,
					238
				],
				[
					56,
					403
				],
				[
					59,
					128
				],
				[
					39,
					299
				],
				[
					74,
					368
				],
				[
					234,
					446
				],
				[
					14,
					191
				],
				[
					31,
					104
				],
				[
					-110,
					229
				]
			],
			[
				[
					53939,
					59018
				],
				[
					9,
					184
				],
				[
					78,
					33
				]
			],
			[
				[
					54026,
					59235
				],
				[
					111,
					-369
				],
				[
					18,
					-382
				],
				[
					-10,
					-383
				],
				[
					151,
					-523
				],
				[
					-155,
					6
				],
				[
					-78,
					-41
				],
				[
					-127,
					57
				],
				[
					-60,
					-271
				],
				[
					164,
					-336
				],
				[
					121,
					-98
				],
				[
					39,
					-239
				],
				[
					87,
					-397
				],
				[
					-43,
					-156
				]
			],
			[
				[
					54447,
					53135
				],
				[
					-20,
					-311
				],
				[
					-220,
					136
				],
				[
					-225,
					152
				],
				[
					-350,
					23
				]
			],
			[
				[
					58564,
					53850
				],
				[
					-16,
					-673
				],
				[
					111,
					-78
				],
				[
					-89,
					-205
				],
				[
					-107,
					-153
				],
				[
					-106,
					-300
				],
				[
					-59,
					-268
				],
				[
					-15,
					-462
				],
				[
					-65,
					-220
				],
				[
					-2,
					-434
				]
			],
			[
				[
					58216,
					51057
				],
				[
					-80,
					-161
				],
				[
					-10,
					-342
				],
				[
					-38,
					-45
				],
				[
					-26,
					-315
				]
			],
			[
				[
					58149,
					49238
				],
				[
					50,
					-530
				],
				[
					-27,
					-299
				],
				[
					55,
					-334
				],
				[
					161,
					-323
				],
				[
					150,
					-726
				]
			],
			[
				[
					58538,
					47026
				],
				[
					-109,
					59
				],
				[
					-373,
					-97
				],
				[
					-75,
					-69
				],
				[
					-79,
					-368
				],
				[
					62,
					-254
				],
				[
					-49,
					-681
				],
				[
					-34,
					-578
				],
				[
					75,
					-103
				],
				[
					194,
					-224
				],
				[
					76,
					105
				],
				[
					23,
					-621
				],
				[
					-212,
					4
				],
				[
					-114,
					317
				],
				[
					-103,
					246
				],
				[
					-213,
					80
				],
				[
					-62,
					302
				],
				[
					-170,
					-182
				],
				[
					-222,
					81
				],
				[
					-93,
					261
				],
				[
					-176,
					53
				],
				[
					-131,
					-14
				],
				[
					-15,
					179
				],
				[
					-96,
					15
				]
			],
			[
				[
					53422,
					48316
				],
				[
					-39,
					179
				]
			],
			[
				[
					53609,
					49076
				],
				[
					73,
					-59
				],
				[
					95,
					221
				],
				[
					152,
					-6
				],
				[
					17,
					-163
				],
				[
					104,
					-102
				],
				[
					164,
					361
				],
				[
					161,
					281
				],
				[
					71,
					185
				],
				[
					-10,
					473
				],
				[
					121,
					560
				],
				[
					127,
					296
				],
				[
					183,
					278
				],
				[
					32,
					184
				],
				[
					7,
					211
				],
				[
					45,
					200
				],
				[
					-14,
					326
				],
				[
					34,
					510
				],
				[
					55,
					360
				],
				[
					83,
					308
				],
				[
					16,
					347
				]
			],
			[
				[
					57603,
					54843
				],
				[
					169,
					-475
				],
				[
					124,
					-70
				],
				[
					75,
					97
				],
				[
					128,
					-38
				],
				[
					155,
					122
				],
				[
					66,
					-246
				],
				[
					244,
					-383
				]
			],
			[
				[
					53309,
					48928
				],
				[
					-228,
					610
				]
			],
			[
				[
					53081,
					49538
				],
				[
					212,
					318
				],
				[
					-105,
					381
				],
				[
					95,
					144
				],
				[
					187,
					71
				],
				[
					23,
					255
				],
				[
					148,
					-276
				],
				[
					245,
					-25
				],
				[
					85,
					273
				],
				[
					36,
					382
				],
				[
					-31,
					450
				],
				[
					-131,
					341
				],
				[
					120,
					667
				],
				[
					-69,
					114
				],
				[
					-207,
					-47
				],
				[
					-78,
					298
				],
				[
					21,
					251
				]
			],
			[
				[
					29063,
					51742
				],
				[
					-119,
					136
				],
				[
					-137,
					191
				],
				[
					-79,
					-92
				],
				[
					-235,
					80
				],
				[
					-68,
					248
				],
				[
					-52,
					-9
				],
				[
					-278,
					329
				]
			],
			[
				[
					28095,
					52625
				],
				[
					-37,
					178
				],
				[
					103,
					44
				],
				[
					-12,
					288
				],
				[
					65,
					209
				],
				[
					138,
					38
				],
				[
					117,
					362
				],
				[
					106,
					302
				],
				[
					-102,
					137
				],
				[
					52,
					335
				],
				[
					-62,
					526
				],
				[
					59,
					152
				],
				[
					-44,
					487
				],
				[
					-112,
					306
				]
			],
			[
				[
					28366,
					55989
				],
				[
					36,
					280
				],
				[
					89,
					-41
				],
				[
					52,
					171
				],
				[
					-64,
					339
				],
				[
					34,
					85
				]
			],
			[
				[
					28513,
					56823
				],
				[
					143,
					-19
				],
				[
					209,
					402
				],
				[
					114,
					62
				],
				[
					3,
					190
				],
				[
					51,
					487
				],
				[
					159,
					267
				],
				[
					175,
					11
				],
				[
					22,
					120
				],
				[
					218,
					-48
				],
				[
					218,
					291
				],
				[
					109,
					128
				],
				[
					134,
					278
				],
				[
					98,
					-36
				],
				[
					73,
					-151
				],
				[
					-54,
					-194
				]
			],
			[
				[
					30185,
					58611
				],
				[
					-178,
					-96
				],
				[
					-71,
					-288
				],
				[
					-107,
					-165
				],
				[
					-81,
					-215
				],
				[
					-34,
					-410
				],
				[
					-77,
					-337
				],
				[
					144,
					-39
				],
				[
					35,
					-265
				],
				[
					62,
					-126
				],
				[
					21,
					-232
				],
				[
					-33,
					-213
				],
				[
					10,
					-120
				],
				[
					69,
					-48
				],
				[
					66,
					-201
				],
				[
					357,
					55
				],
				[
					161,
					-73
				],
				[
					196,
					-496
				],
				[
					112,
					62
				],
				[
					200,
					-31
				],
				[
					158,
					66
				],
				[
					99,
					-99
				],
				[
					-50,
					-311
				],
				[
					-62,
					-193
				],
				[
					-22,
					-413
				],
				[
					56,
					-383
				],
				[
					79,
					-171
				],
				[
					9,
					-129
				],
				[
					-140,
					-286
				],
				[
					100,
					-127
				],
				[
					74,
					-202
				],
				[
					85,
					-574
				]
			],
			[
				[
					30585,
					49354
				],
				[
					-139,
					306
				],
				[
					-83,
					14
				],
				[
					179,
					586
				],
				[
					-213,
					270
				],
				[
					-166,
					-50
				],
				[
					-101,
					100
				],
				[
					-153,
					-152
				],
				[
					-207,
					72
				],
				[
					-163,
					603
				],
				[
					-129,
					149
				],
				[
					-89,
					272
				],
				[
					-184,
					272
				],
				[
					-74,
					-54
				]
			],
			[
				[
					26954,
					56566
				],
				[
					-151,
					128
				],
				[
					-56,
					121
				],
				[
					32,
					100
				],
				[
					-11,
					127
				],
				[
					-77,
					138
				],
				[
					-109,
					113
				],
				[
					-95,
					74
				],
				[
					-19,
					168
				],
				[
					-73,
					103
				],
				[
					18,
					-167
				],
				[
					-55,
					-138
				],
				[
					-64,
					160
				],
				[
					-89,
					57
				],
				[
					-38,
					116
				],
				[
					2,
					175
				],
				[
					36,
					182
				],
				[
					-78,
					81
				],
				[
					64,
					111
				]
			],
			[
				[
					26191,
					58215
				],
				[
					42,
					74
				],
				[
					183,
					-152
				],
				[
					63,
					75
				],
				[
					89,
					-48
				],
				[
					46,
					-119
				],
				[
					82,
					-38
				],
				[
					66,
					122
				]
			],
			[
				[
					26762,
					58129
				],
				[
					70,
					-313
				],
				[
					108,
					-232
				],
				[
					130,
					-246
				]
			],
			[
				[
					27070,
					57338
				],
				[
					-107,
					-51
				],
				[
					1,
					-232
				],
				[
					58,
					-86
				],
				[
					-41,
					-68
				],
				[
					10,
					-104
				],
				[
					-23,
					-117
				],
				[
					-14,
					-114
				]
			],
			[
				[
					27147,
					65183
				],
				[
					240,
					-41
				],
				[
					219,
					-6
				],
				[
					261,
					-197
				],
				[
					110,
					-210
				],
				[
					260,
					65
				],
				[
					98,
					-136
				],
				[
					235,
					-356
				],
				[
					173,
					-260
				],
				[
					92,
					8
				],
				[
					165,
					-118
				],
				[
					-20,
					-162
				],
				[
					205,
					-23
				],
				[
					210,
					-236
				],
				[
					-33,
					-135
				],
				[
					-185,
					-73
				],
				[
					-187,
					-29
				],
				[
					-191,
					46
				],
				[
					-398,
					-56
				],
				[
					186,
					321
				],
				[
					-113,
					150
				],
				[
					-179,
					38
				],
				[
					-96,
					166
				],
				[
					-66,
					328
				],
				[
					-157,
					-22
				],
				[
					-259,
					154
				],
				[
					-83,
					121
				],
				[
					-362,
					89
				],
				[
					-97,
					113
				],
				[
					104,
					144
				],
				[
					-273,
					29
				],
				[
					-199,
					-299
				],
				[
					-115,
					-8
				],
				[
					-40,
					-141
				],
				[
					-138,
					-63
				],
				[
					-118,
					55
				],
				[
					146,
					178
				],
				[
					60,
					208
				],
				[
					126,
					128
				],
				[
					142,
					112
				],
				[
					210,
					55
				],
				[
					67,
					63
				]
			],
			[
				[
					59092,
					72066
				],
				[
					19,
					3
				],
				[
					40,
					139
				],
				[
					200,
					-8
				],
				[
					253,
					172
				],
				[
					-188,
					-245
				],
				[
					21,
					-108
				]
			],
			[
				[
					59437,
					72019
				],
				[
					-30,
					20
				],
				[
					-53,
					-44
				],
				[
					-42,
					12
				],
				[
					-14,
					-22
				],
				[
					-5,
					59
				],
				[
					-20,
					35
				],
				[
					-54,
					6
				],
				[
					-75,
					-49
				],
				[
					-52,
					30
				]
			],
			[
				[
					59437,
					72019
				],
				[
					8,
					-46
				],
				[
					-285,
					-234
				],
				[
					-136,
					74
				],
				[
					-64,
					232
				],
				[
					132,
					21
				]
			],
			[
				[
					53776,
					79977
				],
				[
					-157,
					247
				],
				[
					-141,
					139
				],
				[
					-30,
					243
				],
				[
					-49,
					171
				],
				[
					202,
					125
				],
				[
					103,
					144
				],
				[
					200,
					111
				],
				[
					70,
					110
				],
				[
					73,
					-66
				],
				[
					124,
					60
				]
			],
			[
				[
					54171,
					81261
				],
				[
					132,
					-186
				],
				[
					207,
					-50
				],
				[
					-17,
					-158
				],
				[
					151,
					-119
				],
				[
					41,
					148
				],
				[
					191,
					-64
				],
				[
					26,
					-180
				],
				[
					207,
					-35
				],
				[
					127,
					-284
				]
			],
			[
				[
					55236,
					80333
				],
				[
					-82,
					0
				],
				[
					-43,
					-104
				],
				[
					-64,
					-25
				],
				[
					-18,
					-131
				],
				[
					-54,
					-28
				],
				[
					-7,
					-53
				],
				[
					-95,
					-60
				],
				[
					-123,
					10
				],
				[
					-39,
					-127
				]
			],
			[
				[
					52756,
					83493
				],
				[
					4,
					-222
				],
				[
					281,
					-135
				],
				[
					-3,
					-204
				],
				[
					283,
					108
				],
				[
					156,
					158
				],
				[
					313,
					-228
				],
				[
					132,
					-183
				]
			],
			[
				[
					53922,
					82787
				],
				[
					64,
					-293
				],
				[
					-77,
					-154
				],
				[
					101,
					-205
				],
				[
					69,
					-308
				],
				[
					-22,
					-199
				],
				[
					114,
					-367
				]
			],
			[
				[
					52074,
					79253
				],
				[
					35,
					410
				],
				[
					140,
					395
				],
				[
					-400,
					106
				],
				[
					-131,
					151
				]
			],
			[
				[
					51718,
					80315
				],
				[
					16,
					252
				],
				[
					-56,
					130
				]
			],
			[
				[
					51710,
					81086
				],
				[
					-47,
					604
				],
				[
					167,
					0
				],
				[
					70,
					217
				],
				[
					69,
					527
				],
				[
					-51,
					195
				]
			],
			[
				[
					51918,
					82629
				],
				[
					54,
					122
				],
				[
					232,
					31
				],
				[
					52,
					-127
				],
				[
					188,
					284
				],
				[
					-63,
					216
				],
				[
					-13,
					326
				]
			],
			[
				[
					52368,
					83481
				],
				[
					210,
					-76
				],
				[
					178,
					88
				]
			],
			[
				[
					61966,
					59143
				],
				[
					66,
					-178
				],
				[
					-9,
					-240
				],
				[
					-158,
					-137
				],
				[
					119,
					-158
				]
			],
			[
				[
					61984,
					58430
				],
				[
					-102,
					-308
				]
			],
			[
				[
					61882,
					58122
				],
				[
					-62,
					103
				],
				[
					-67,
					-41
				],
				[
					-155,
					9
				],
				[
					-4,
					176
				],
				[
					-22,
					159
				],
				[
					94,
					269
				],
				[
					98,
					255
				]
			],
			[
				[
					61764,
					59052
				],
				[
					119,
					-50
				],
				[
					83,
					141
				]
			],
			[
				[
					53524,
					83854
				],
				[
					-166,
					-466
				],
				[
					-291,
					325
				],
				[
					-39,
					239
				],
				[
					408,
					191
				],
				[
					88,
					-289
				]
			],
			[
				[
					52368,
					83481
				],
				[
					-113,
					320
				],
				[
					-8,
					589
				],
				[
					46,
					155
				],
				[
					80,
					173
				],
				[
					244,
					36
				],
				[
					98,
					159
				],
				[
					223,
					162
				],
				[
					-9,
					-296
				],
				[
					-82,
					-188
				],
				[
					33,
					-161
				],
				[
					151,
					-87
				],
				[
					-68,
					-217
				],
				[
					-83,
					62
				],
				[
					-200,
					-415
				],
				[
					76,
					-280
				]
			],
			[
				[
					30080,
					63183
				],
				[
					34,
					98
				],
				[
					217,
					-3
				],
				[
					165,
					-148
				],
				[
					73,
					14
				],
				[
					50,
					-204
				],
				[
					152,
					11
				],
				[
					-9,
					-171
				],
				[
					124,
					-21
				],
				[
					136,
					-211
				],
				[
					-103,
					-235
				],
				[
					-132,
					126
				],
				[
					-127,
					-25
				],
				[
					-92,
					28
				],
				[
					-50,
					-105
				],
				[
					-106,
					-36
				],
				[
					-43,
					140
				],
				[
					-92,
					-83
				],
				[
					-111,
					-394
				],
				[
					-71,
					92
				],
				[
					-14,
					165
				]
			],
			[
				[
					30081,
					62221
				],
				[
					5,
					157
				],
				[
					-71,
					172
				],
				[
					68,
					97
				],
				[
					21,
					222
				],
				[
					-24,
					314
				]
			],
			[
				[
					53333,
					65346
				],
				[
					-952,
					-1097
				],
				[
					-804,
					-1132
				],
				[
					-392,
					-257
				]
			],
			[
				[
					51185,
					62860
				],
				[
					-308,
					-56
				],
				[
					-3,
					366
				],
				[
					-129,
					94
				],
				[
					-173,
					165
				],
				[
					-66,
					270
				],
				[
					-937,
					1256
				],
				[
					-937,
					1257
				]
			],
			[
				[
					48632,
					66212
				],
				[
					-1045,
					1394
				]
			],
			[
				[
					47587,
					67606
				],
				[
					6,
					112
				],
				[
					-1,
					38
				]
			],
			[
				[
					47592,
					67756
				],
				[
					-2,
					682
				],
				[
					449,
					425
				],
				[
					277,
					88
				],
				[
					227,
					155
				],
				[
					107,
					288
				],
				[
					324,
					228
				],
				[
					12,
					427
				],
				[
					161,
					50
				],
				[
					126,
					213
				],
				[
					363,
					97
				],
				[
					51,
					224
				],
				[
					-73,
					122
				],
				[
					-96,
					608
				],
				[
					-17,
					350
				],
				[
					-104,
					369
				]
			],
			[
				[
					49397,
					72082
				],
				[
					267,
					315
				],
				[
					300,
					100
				],
				[
					175,
					238
				],
				[
					268,
					175
				],
				[
					471,
					102
				],
				[
					459,
					47
				],
				[
					140,
					-85
				],
				[
					262,
					227
				],
				[
					297,
					4
				],
				[
					113,
					-134
				],
				[
					190,
					35
				]
			],
			[
				[
					52339,
					73106
				],
				[
					-57,
					-295
				],
				[
					44,
					-549
				],
				[
					-65,
					-475
				],
				[
					-171,
					-322
				],
				[
					24,
					-433
				],
				[
					227,
					-344
				],
				[
					3,
					-139
				],
				[
					171,
					-232
				],
				[
					118,
					-1034
				]
			],
			[
				[
					52633,
					69283
				],
				[
					90,
					-509
				],
				[
					15,
					-267
				],
				[
					-49,
					-470
				],
				[
					21,
					-263
				],
				[
					-36,
					-315
				],
				[
					24,
					-362
				],
				[
					-110,
					-240
				],
				[
					164,
					-420
				],
				[
					11,
					-247
				],
				[
					99,
					-321
				],
				[
					130,
					105
				],
				[
					219,
					-267
				],
				[
					122,
					-361
				]
			],
			[
				[
					27693,
					49869
				],
				[
					148,
					430
				],
				[
					-60,
					251
				],
				[
					-106,
					-267
				],
				[
					-166,
					252
				],
				[
					56,
					163
				],
				[
					-47,
					522
				],
				[
					97,
					87
				],
				[
					52,
					359
				],
				[
					105,
					371
				],
				[
					-20,
					235
				],
				[
					153,
					123
				],
				[
					190,
					230
				]
			],
			[
				[
					29063,
					51742
				],
				[
					38,
					-438
				],
				[
					-86,
					-374
				],
				[
					-303,
					-603
				],
				[
					-334,
					-227
				],
				[
					-170,
					-501
				],
				[
					-53,
					-389
				],
				[
					-157,
					-237
				],
				[
					-116,
					291
				],
				[
					-113,
					62
				],
				[
					-114,
					-45
				],
				[
					-8,
					211
				],
				[
					79,
					137
				],
				[
					-33,
					240
				]
			],
			[
				[
					59700,
					68819
				],
				[
					-78,
					-232
				],
				[
					-60,
					-435
				],
				[
					-75,
					-300
				],
				[
					-65,
					-100
				],
				[
					-93,
					186
				],
				[
					-125,
					257
				],
				[
					-198,
					825
				],
				[
					-29,
					-52
				],
				[
					115,
					-608
				],
				[
					171,
					-579
				],
				[
					210,
					-897
				],
				[
					102,
					-313
				],
				[
					90,
					-325
				],
				[
					249,
					-638
				],
				[
					-55,
					-100
				],
				[
					9,
					-374
				],
				[
					323,
					-517
				],
				[
					49,
					-118
				]
			],
			[
				[
					60240,
					64499
				],
				[
					-1102,
					0
				],
				[
					-1077,
					0
				],
				[
					-1117,
					0
				]
			],
			[
				[
					56944,
					64499
				],
				[
					0,
					2120
				],
				[
					0,
					2048
				],
				[
					-83,
					464
				],
				[
					71,
					356
				],
				[
					-43,
					246
				],
				[
					101,
					276
				]
			],
			[
				[
					56990,
					70009
				],
				[
					369,
					10
				],
				[
					268,
					-152
				],
				[
					275,
					-171
				],
				[
					129,
					-89
				],
				[
					214,
					182
				],
				[
					114,
					165
				],
				[
					245,
					48
				],
				[
					198,
					-73
				],
				[
					75,
					-286
				],
				[
					65,
					189
				],
				[
					222,
					-136
				],
				[
					217,
					-33
				],
				[
					137,
					145
				]
			],
			[
				[
					59518,
					69808
				],
				[
					182,
					-989
				]
			],
			[
				[
					61764,
					59052
				],
				[
					-95,
					187
				],
				[
					-114,
					337
				],
				[
					-124,
					185
				],
				[
					-71,
					199
				],
				[
					-242,
					231
				],
				[
					-191,
					7
				],
				[
					-67,
					120
				],
				[
					-163,
					-135
				],
				[
					-168,
					261
				],
				[
					-87,
					-430
				],
				[
					-323,
					121
				]
			],
			[
				[
					60119,
					60135
				],
				[
					-30,
					230
				],
				[
					120,
					847
				],
				[
					27,
					382
				],
				[
					88,
					177
				],
				[
					204,
					95
				],
				[
					141,
					328
				]
			],
			[
				[
					60669,
					62194
				],
				[
					161,
					-666
				],
				[
					77,
					-529
				],
				[
					152,
					-281
				],
				[
					379,
					-544
				],
				[
					154,
					-328
				],
				[
					151,
					-332
				],
				[
					87,
					-198
				],
				[
					136,
					-173
				]
			],
			[
				[
					47490,
					75948
				],
				[
					14,
					410
				],
				[
					-114,
					250
				],
				[
					393,
					415
				],
				[
					340,
					-104
				],
				[
					373,
					4
				],
				[
					296,
					-98
				],
				[
					230,
					30
				],
				[
					449,
					-19
				]
			],
			[
				[
					49471,
					76836
				],
				[
					111,
					-224
				],
				[
					511,
					-262
				],
				[
					101,
					125
				],
				[
					313,
					-261
				],
				[
					322,
					75
				]
			],
			[
				[
					50829,
					76289
				],
				[
					15,
					-335
				],
				[
					-263,
					-383
				],
				[
					-356,
					-122
				],
				[
					-25,
					-194
				],
				[
					-171,
					-319
				],
				[
					-107,
					-469
				],
				[
					108,
					-329
				],
				[
					-160,
					-257
				],
				[
					-60,
					-374
				],
				[
					-210,
					-115
				],
				[
					-197,
					-443
				],
				[
					-352,
					-8
				],
				[
					-265,
					10
				],
				[
					-174,
					-203
				],
				[
					-106,
					-218
				],
				[
					-136,
					48
				],
				[
					-103,
					195
				],
				[
					-79,
					331
				],
				[
					-259,
					89
				]
			],
			[
				[
					47929,
					73193
				],
				[
					-23,
					191
				],
				[
					103,
					216
				],
				[
					38,
					156
				],
				[
					-96,
					172
				],
				[
					77,
					378
				],
				[
					-111,
					345
				],
				[
					120,
					48
				],
				[
					11,
					272
				],
				[
					45,
					84
				],
				[
					3,
					449
				],
				[
					129,
					156
				],
				[
					-78,
					289
				],
				[
					-162,
					20
				],
				[
					-47,
					-72
				],
				[
					-164,
					-1
				],
				[
					-70,
					282
				],
				[
					-113,
					-84
				],
				[
					-101,
					-146
				]
			],
			[
				[
					56753,
					85111
				],
				[
					32,
					340
				],
				[
					-102,
					-72
				],
				[
					-176,
					204
				],
				[
					-24,
					331
				],
				[
					351,
					161
				],
				[
					350,
					83
				],
				[
					301,
					-95
				],
				[
					287,
					17
				]
			],
			[
				[
					57772,
					86080
				],
				[
					42,
					-100
				],
				[
					-198,
					-332
				],
				[
					83,
					-537
				],
				[
					-120,
					-183
				]
			],
			[
				[
					57579,
					84928
				],
				[
					-229,
					1
				],
				[
					-239,
					214
				],
				[
					-121,
					70
				],
				[
					-237,
					-102
				]
			],
			[
				[
					61882,
					58122
				],
				[
					-61,
					-204
				],
				[
					103,
					-317
				],
				[
					102,
					-277
				],
				[
					106,
					-206
				],
				[
					909,
					-683
				],
				[
					233,
					3
				]
			],
			[
				[
					63274,
					56438
				],
				[
					-785,
					-1728
				],
				[
					-362,
					-26
				],
				[
					-247,
					-406
				],
				[
					-178,
					-10
				],
				[
					-76,
					-182
				]
			],
			[
				[
					61626,
					54086
				],
				[
					-190,
					0
				],
				[
					-112,
					195
				],
				[
					-254,
					-241
				],
				[
					-82,
					-240
				],
				[
					-185,
					45
				],
				[
					-62,
					67
				],
				[
					-65,
					-16
				],
				[
					-87,
					6
				],
				[
					-352,
					489
				],
				[
					-193,
					0
				],
				[
					-95,
					189
				],
				[
					0,
					324
				],
				[
					-145,
					96
				]
			],
			[
				[
					59804,
					55000
				],
				[
					-164,
					627
				],
				[
					-127,
					133
				],
				[
					-48,
					231
				],
				[
					-141,
					280
				],
				[
					-171,
					42
				],
				[
					95,
					328
				],
				[
					147,
					14
				],
				[
					42,
					176
				]
			],
			[
				[
					59437,
					56831
				],
				[
					-4,
					517
				]
			],
			[
				[
					59433,
					57348
				],
				[
					82,
					603
				],
				[
					132,
					161
				],
				[
					28,
					236
				],
				[
					119,
					440
				],
				[
					168,
					285
				],
				[
					112,
					567
				],
				[
					45,
					495
				]
			],
			[
				[
					57942,
					91602
				],
				[
					-41,
					-403
				],
				[
					425,
					-383
				],
				[
					-256,
					-435
				],
				[
					323,
					-655
				],
				[
					-187,
					-494
				],
				[
					250,
					-429
				],
				[
					-113,
					-375
				],
				[
					411,
					-394
				],
				[
					-105,
					-294
				],
				[
					-258,
					-333
				],
				[
					-594,
					-735
				]
			],
			[
				[
					57797,
					86672
				],
				[
					-504,
					-46
				],
				[
					-489,
					-211
				],
				[
					-452,
					-121
				],
				[
					-161,
					314
				],
				[
					-269,
					189
				],
				[
					62,
					567
				],
				[
					-135,
					520
				],
				[
					133,
					335
				],
				[
					252,
					362
				],
				[
					635,
					624
				],
				[
					185,
					121
				],
				[
					-28,
					243
				],
				[
					-387,
					272
				]
			],
			[
				[
					56639,
					89841
				],
				[
					-93,
					225
				],
				[
					-8,
					886
				],
				[
					-433,
					392
				],
				[
					-371,
					282
				]
			],
			[
				[
					55734,
					91626
				],
				[
					167,
					152
				],
				[
					309,
					-304
				],
				[
					362,
					29
				],
				[
					298,
					-140
				],
				[
					265,
					255
				],
				[
					137,
					422
				],
				[
					431,
					196
				],
				[
					356,
					-229
				],
				[
					-117,
					-405
				]
			],
			[
				[
					99547,
					41844
				],
				[
					96,
					-167
				],
				[
					-46,
					-300
				],
				[
					-172,
					-79
				],
				[
					-153,
					71
				],
				[
					-27,
					253
				],
				[
					107,
					198
				],
				[
					126,
					-71
				],
				[
					69,
					95
				]
			],
			[
				[
					0,
					42577
				],
				[
					57,
					26
				],
				[
					-34,
					-277
				],
				[
					-23,
					-31
				],
				[
					99822,
					-141
				],
				[
					-177,
					-122
				],
				[
					-36,
					215
				],
				[
					139,
					118
				],
				[
					88,
					32
				],
				[
					-99836,
					180
				]
			],
			[
				[
					33000,
					21970
				],
				[
					333,
					345
				],
				[
					236,
					-144
				],
				[
					167,
					231
				],
				[
					222,
					-259
				],
				[
					-83,
					-202
				],
				[
					-375,
					-173
				],
				[
					-125,
					202
				],
				[
					-236,
					-259
				],
				[
					-139,
					259
				]
			],
			[
				[
					34854,
					53161
				],
				[
					70,
					246
				],
				[
					24,
					262
				],
				[
					48,
					246
				],
				[
					-107,
					340
				]
			],
			[
				[
					34889,
					54255
				],
				[
					-22,
					394
				],
				[
					144,
					495
				]
			],
			[
				[
					35011,
					55144
				],
				[
					95,
					-63
				],
				[
					204,
					-136
				],
				[
					294,
					-486
				],
				[
					46,
					-236
				]
			],
			[
				[
					52655,
					76104
				],
				[
					-92,
					-445
				],
				[
					-126,
					118
				],
				[
					-64,
					387
				],
				[
					56,
					214
				],
				[
					179,
					220
				],
				[
					47,
					-494
				]
			],
			[
				[
					51576,
					80352
				],
				[
					62,
					-50
				],
				[
					80,
					13
				]
			],
			[
				[
					51900,
					78315
				],
				[
					-11,
					-163
				],
				[
					82,
					-216
				],
				[
					-97,
					-176
				],
				[
					72,
					-445
				],
				[
					151,
					-73
				],
				[
					-32,
					-250
				]
			],
			[
				[
					52065,
					76992
				],
				[
					-252,
					-326
				],
				[
					-548,
					156
				],
				[
					-404,
					-186
				],
				[
					-32,
					-347
				]
			],
			[
				[
					49471,
					76836
				],
				[
					144,
					345
				],
				[
					53,
					1147
				],
				[
					-287,
					605
				],
				[
					-205,
					291
				],
				[
					-424,
					222
				],
				[
					-28,
					420
				],
				[
					360,
					125
				],
				[
					466,
					-148
				],
				[
					-88,
					652
				],
				[
					263,
					-247
				],
				[
					646,
					449
				],
				[
					84,
					472
				],
				[
					243,
					116
				]
			],
			[
				[
					53081,
					49538
				],
				[
					-285,
					581
				],
				[
					-184,
					475
				],
				[
					-169,
					595
				],
				[
					9,
					192
				],
				[
					61,
					184
				],
				[
					67,
					419
				],
				[
					56,
					427
				]
			],
			[
				[
					52636,
					52411
				],
				[
					94,
					33
				],
				[
					404,
					-6
				],
				[
					-2,
					693
				]
			],
			[
				[
					48278,
					82851
				],
				[
					-210,
					118
				],
				[
					-172,
					-8
				],
				[
					57,
					309
				],
				[
					-57,
					309
				]
			],
			[
				[
					47896,
					83579
				],
				[
					233,
					23
				],
				[
					298,
					-356
				],
				[
					-149,
					-395
				]
			],
			[
				[
					49165,
					85596
				],
				[
					-297,
					-623
				],
				[
					283,
					79
				],
				[
					304,
					-3
				],
				[
					-72,
					-469
				],
				[
					-250,
					-516
				],
				[
					287,
					-37
				],
				[
					22,
					-61
				],
				[
					248,
					-679
				],
				[
					190,
					-93
				],
				[
					171,
					-656
				],
				[
					79,
					-227
				],
				[
					337,
					-110
				],
				[
					-34,
					-368
				],
				[
					-142,
					-169
				],
				[
					111,
					-298
				],
				[
					-250,
					-302
				],
				[
					-371,
					6
				],
				[
					-473,
					-159
				],
				[
					-130,
					114
				],
				[
					-183,
					-270
				],
				[
					-257,
					65
				],
				[
					-195,
					-220
				],
				[
					-148,
					115
				],
				[
					407,
					605
				],
				[
					249,
					125
				],
				[
					-2,
					0
				],
				[
					-434,
					96
				],
				[
					-79,
					229
				],
				[
					291,
					179
				],
				[
					-152,
					310
				],
				[
					52,
					377
				],
				[
					413,
					-52
				],
				[
					1,
					0
				],
				[
					40,
					334
				],
				[
					-186,
					355
				],
				[
					-4,
					8
				],
				[
					-337,
					101
				],
				[
					-66,
					156
				],
				[
					101,
					258
				],
				[
					-92,
					158
				],
				[
					-149,
					-272
				],
				[
					-17,
					555
				],
				[
					-140,
					294
				],
				[
					101,
					595
				],
				[
					216,
					467
				],
				[
					222,
					-45
				],
				[
					335,
					48
				]
			],
			[
				[
					61542,
					75749
				],
				[
					42,
					246
				],
				[
					-70,
					393
				],
				[
					-160,
					212
				],
				[
					-154,
					66
				],
				[
					-102,
					177
				]
			],
			[
				[
					61098,
					76843
				],
				[
					34,
					68
				],
				[
					235,
					-99
				],
				[
					409,
					-93
				],
				[
					378,
					-276
				],
				[
					48,
					-107
				],
				[
					169,
					90
				],
				[
					259,
					-120
				],
				[
					85,
					-236
				],
				[
					175,
					-134
				]
			],
			[
				[
					62106,
					75494
				],
				[
					-268,
					282
				],
				[
					-296,
					-27
				]
			],
			[
				[
					50294,
					55244
				],
				[
					-436,
					-337
				],
				[
					-154,
					-198
				],
				[
					-250,
					-167
				],
				[
					-248,
					164
				]
			],
			[
				[
					50006,
					58175
				],
				[
					-20,
					-180
				],
				[
					116,
					-297
				],
				[
					-1,
					-418
				],
				[
					27,
					-454
				],
				[
					69,
					-210
				],
				[
					-61,
					-518
				],
				[
					22,
					-287
				],
				[
					74,
					-365
				],
				[
					62,
					-202
				]
			],
			[
				[
					47655,
					56256
				],
				[
					-78,
					14
				],
				[
					-57,
					-232
				],
				[
					-78,
					3
				],
				[
					-55,
					123
				],
				[
					19,
					231
				],
				[
					-116,
					353
				],
				[
					-73,
					-65
				],
				[
					-59,
					-13
				]
			],
			[
				[
					47158,
					56670
				],
				[
					-77,
					-33
				],
				[
					3,
					211
				],
				[
					-44,
					151
				],
				[
					9,
					168
				],
				[
					-60,
					242
				],
				[
					-78,
					206
				],
				[
					-222,
					0
				],
				[
					-65,
					-108
				],
				[
					-76,
					-13
				],
				[
					-48,
					-125
				],
				[
					-32,
					-159
				],
				[
					-148,
					-254
				]
			],
			[
				[
					46320,
					56956
				],
				[
					-122,
					341
				],
				[
					-108,
					226
				],
				[
					-71,
					74
				],
				[
					-69,
					115
				],
				[
					-32,
					254
				],
				[
					-41,
					127
				],
				[
					-80,
					94
				]
			],
			[
				[
					45797,
					58187
				],
				[
					123,
					281
				],
				[
					84,
					-11
				],
				[
					73,
					97
				],
				[
					61,
					1
				],
				[
					44,
					76
				],
				[
					-24,
					191
				],
				[
					31,
					60
				],
				[
					5,
					195
				]
			],
			[
				[
					46194,
					59077
				],
				[
					134,
					-5
				],
				[
					200,
					-141
				],
				[
					61,
					13
				],
				[
					21,
					64
				],
				[
					151,
					-45
				],
				[
					40,
					32
				]
			],
			[
				[
					46801,
					58995
				],
				[
					16,
					-211
				],
				[
					44,
					1
				],
				[
					73,
					77
				],
				[
					46,
					-20
				],
				[
					77,
					-146
				],
				[
					119,
					-46
				],
				[
					76,
					125
				],
				[
					90,
					77
				],
				[
					67,
					80
				],
				[
					55,
					-15
				],
				[
					62,
					-126
				],
				[
					33,
					-159
				],
				[
					114,
					-241
				],
				[
					-57,
					-149
				],
				[
					-11,
					-187
				],
				[
					59,
					57
				],
				[
					35,
					-67
				],
				[
					-15,
					-172
				],
				[
					85,
					-166
				]
			],
			[
				[
					45321,
					59403
				],
				[
					36,
					255
				]
			],
			[
				[
					45357,
					59658
				],
				[
					302,
					17
				],
				[
					63,
					136
				],
				[
					88,
					10
				],
				[
					110,
					-142
				],
				[
					86,
					-3
				],
				[
					92,
					97
				],
				[
					56,
					-166
				],
				[
					-120,
					-130
				],
				[
					-121,
					11
				],
				[
					-119,
					121
				],
				[
					-103,
					-133
				],
				[
					-50,
					-5
				],
				[
					-67,
					-80
				],
				[
					-253,
					12
				]
			],
			[
				[
					45797,
					58187
				],
				[
					-149,
					241
				],
				[
					-117,
					38
				],
				[
					-63,
					162
				],
				[
					1,
					88
				],
				[
					-84,
					122
				],
				[
					-18,
					124
				]
			],
			[
				[
					45367,
					58962
				],
				[
					147,
					93
				],
				[
					92,
					-18
				],
				[
					75,
					65
				],
				[
					513,
					-25
				]
			],
			[
				[
					52636,
					52411
				],
				[
					-52,
					87
				],
				[
					96,
					647
				]
			],
			[
				[
					56583,
					72391
				],
				[
					152,
					-194
				],
				[
					216,
					33
				],
				[
					207,
					-41
				],
				[
					-7,
					-100
				],
				[
					151,
					69
				],
				[
					-35,
					-170
				],
				[
					-400,
					-49
				],
				[
					3,
					95
				],
				[
					-339,
					112
				],
				[
					52,
					245
				]
			],
			[
				[
					57237,
					75339
				],
				[
					-169,
					17
				],
				[
					-145,
					54
				],
				[
					-336,
					-150
				],
				[
					192,
					-323
				],
				[
					-141,
					-94
				],
				[
					-154,
					-1
				],
				[
					-147,
					297
				],
				[
					-52,
					-127
				],
				[
					62,
					-344
				],
				[
					139,
					-270
				],
				[
					-105,
					-126
				],
				[
					155,
					-265
				],
				[
					137,
					-167
				],
				[
					4,
					-326
				],
				[
					-257,
					153
				],
				[
					82,
					-294
				],
				[
					-176,
					-60
				],
				[
					105,
					-509
				],
				[
					-184,
					-7
				],
				[
					-228,
					251
				],
				[
					-104,
					460
				],
				[
					-49,
					384
				],
				[
					-108,
					264
				],
				[
					-143,
					329
				],
				[
					-18,
					164
				]
			],
			[
				[
					55838,
					75350
				],
				[
					182,
					51
				],
				[
					106,
					126
				],
				[
					150,
					-11
				],
				[
					46,
					100
				],
				[
					53,
					19
				]
			],
			[
				[
					57254,
					75917
				],
				[
					135,
					-153
				],
				[
					-86,
					-360
				],
				[
					-66,
					-65
				]
			],
			[
				[
					37010,
					99413
				],
				[
					932,
					344
				],
				[
					975,
					-26
				],
				[
					354,
					213
				],
				[
					982,
					55
				],
				[
					2219,
					-72
				],
				[
					1737,
					-457
				],
				[
					-513,
					-222
				],
				[
					-1062,
					-25
				],
				[
					-1496,
					-56
				],
				[
					140,
					-103
				],
				[
					984,
					63
				],
				[
					836,
					-198
				],
				[
					540,
					176
				],
				[
					231,
					-206
				],
				[
					-305,
					-335
				],
				[
					707,
					214
				],
				[
					1348,
					223
				],
				[
					833,
					-111
				],
				[
					156,
					-246
				],
				[
					-1132,
					-410
				],
				[
					-157,
					-133
				],
				[
					-888,
					-99
				],
				[
					643,
					-28
				],
				[
					-324,
					-420
				],
				[
					-224,
					-373
				],
				[
					9,
					-641
				],
				[
					333,
					-376
				],
				[
					-434,
					-24
				],
				[
					-457,
					-182
				],
				[
					513,
					-305
				],
				[
					65,
					-490
				],
				[
					-297,
					-53
				],
				[
					360,
					-495
				],
				[
					-617,
					-42
				],
				[
					322,
					-234
				],
				[
					-91,
					-203
				],
				[
					-391,
					-89
				],
				[
					-388,
					-2
				],
				[
					348,
					-390
				],
				[
					4,
					-256
				],
				[
					-549,
					238
				],
				[
					-143,
					-154
				],
				[
					375,
					-144
				],
				[
					364,
					-352
				],
				[
					105,
					-464
				],
				[
					-495,
					-111
				],
				[
					-214,
					222
				],
				[
					-344,
					331
				],
				[
					95,
					-391
				],
				[
					-322,
					-303
				],
				[
					732,
					-24
				],
				[
					383,
					-31
				],
				[
					-745,
					-502
				],
				[
					-755,
					-454
				],
				[
					-813,
					-199
				],
				[
					-306,
					-2
				],
				[
					-288,
					-222
				],
				[
					-386,
					-608
				],
				[
					-597,
					-404
				],
				[
					-192,
					-23
				],
				[
					-370,
					-142
				],
				[
					-399,
					-134
				],
				[
					-238,
					-357
				],
				[
					-4,
					-403
				],
				[
					-141,
					-378
				],
				[
					-453,
					-461
				],
				[
					112,
					-450
				],
				[
					-125,
					-476
				],
				[
					-142,
					-563
				],
				[
					-391,
					-35
				],
				[
					-410,
					471
				],
				[
					-556,
					3
				],
				[
					-269,
					315
				],
				[
					-186,
					563
				],
				[
					-481,
					716
				],
				[
					-141,
					375
				],
				[
					-38,
					517
				],
				[
					-384,
					532
				],
				[
					100,
					424
				],
				[
					-186,
					203
				],
				[
					275,
					673
				],
				[
					418,
					214
				],
				[
					110,
					241
				],
				[
					58,
					450
				],
				[
					-318,
					-204
				],
				[
					-151,
					-85
				],
				[
					-249,
					-83
				],
				[
					-341,
					188
				],
				[
					-19,
					392
				],
				[
					109,
					306
				],
				[
					258,
					8
				],
				[
					567,
					-153
				],
				[
					-478,
					366
				],
				[
					-249,
					197
				],
				[
					-276,
					-81
				],
				[
					-232,
					143
				],
				[
					310,
					536
				],
				[
					-169,
					215
				],
				[
					-220,
					398
				],
				[
					-335,
					611
				],
				[
					-353,
					223
				],
				[
					3,
					241
				],
				[
					-745,
					337
				],
				[
					-590,
					42
				],
				[
					-743,
					-23
				],
				[
					-677,
					-42
				],
				[
					-323,
					183
				],
				[
					-482,
					362
				],
				[
					729,
					181
				],
				[
					559,
					31
				],
				[
					-1188,
					149
				],
				[
					-627,
					236
				],
				[
					39,
					223
				],
				[
					1051,
					277
				],
				[
					1018,
					277
				],
				[
					107,
					210
				],
				[
					-750,
					206
				],
				[
					243,
					230
				],
				[
					961,
					402
				],
				[
					404,
					62
				],
				[
					-115,
					258
				],
				[
					658,
					152
				],
				[
					854,
					90
				],
				[
					853,
					6
				],
				[
					303,
					-180
				],
				[
					737,
					317
				],
				[
					663,
					-215
				],
				[
					390,
					-45
				],
				[
					577,
					-188
				],
				[
					-660,
					311
				],
				[
					38,
					246
				]
			],
			[
				[
					24973,
					59739
				],
				[
					-142,
					101
				],
				[
					-174,
					10
				],
				[
					-127,
					114
				],
				[
					-149,
					238
				]
			],
			[
				[
					24381,
					60202
				],
				[
					7,
					168
				],
				[
					32,
					135
				],
				[
					-39,
					107
				],
				[
					133,
					470
				],
				[
					357,
					1
				],
				[
					7,
					197
				],
				[
					-45,
					35
				],
				[
					-31,
					124
				],
				[
					-103,
					133
				],
				[
					-103,
					193
				],
				[
					125,
					1
				],
				[
					1,
					324
				],
				[
					259,
					1
				],
				[
					257,
					-6
				]
			],
			[
				[
					25297,
					60979
				],
				[
					90,
					-105
				],
				[
					24,
					86
				],
				[
					82,
					-73
				]
			],
			[
				[
					25493,
					60887
				],
				[
					-127,
					-220
				],
				[
					-131,
					-161
				],
				[
					-20,
					-111
				],
				[
					22,
					-113
				],
				[
					-58,
					-146
				]
			],
			[
				[
					25179,
					60136
				],
				[
					-65,
					-36
				],
				[
					15,
					-67
				],
				[
					-52,
					-64
				],
				[
					-95,
					-145
				],
				[
					-9,
					-85
				]
			],
			[
				[
					33400,
					56648
				],
				[
					183,
					-212
				],
				[
					171,
					-375
				],
				[
					8,
					-297
				],
				[
					105,
					-13
				],
				[
					149,
					-281
				],
				[
					109,
					-201
				]
			],
			[
				[
					34125,
					55269
				],
				[
					-44,
					-518
				],
				[
					-169,
					-150
				],
				[
					15,
					-136
				],
				[
					-51,
					-297
				],
				[
					123,
					-418
				],
				[
					89,
					-1
				],
				[
					37,
					-325
				],
				[
					169,
					-501
				]
			],
			[
				[
					33129,
					54824
				],
				[
					-188,
					437
				],
				[
					75,
					159
				],
				[
					-5,
					265
				],
				[
					171,
					93
				],
				[
					69,
					108
				],
				[
					-95,
					213
				],
				[
					24,
					210
				],
				[
					220,
					339
				]
			],
			[
				[
					25745,
					59307
				],
				[
					-48,
					180
				],
				[
					-84,
					50
				]
			],
			[
				[
					25613,
					59537
				],
				[
					19,
					231
				],
				[
					-38,
					62
				],
				[
					-57,
					41
				],
				[
					-122,
					-68
				],
				[
					-10,
					77
				],
				[
					-84,
					93
				],
				[
					-60,
					114
				],
				[
					-82,
					49
				]
			],
			[
				[
					25493,
					60887
				],
				[
					29,
					-23
				],
				[
					61,
					101
				],
				[
					79,
					9
				],
				[
					26,
					-47
				],
				[
					43,
					28
				],
				[
					129,
					-52
				],
				[
					128,
					15
				],
				[
					90,
					64
				],
				[
					32,
					65
				],
				[
					89,
					-30
				],
				[
					66,
					-39
				],
				[
					73,
					13
				],
				[
					55,
					50
				],
				[
					127,
					-80
				],
				[
					44,
					-13
				],
				[
					85,
					-107
				],
				[
					80,
					-129
				],
				[
					101,
					-88
				],
				[
					73,
					-159
				]
			],
			[
				[
					26903,
					60465
				],
				[
					-95,
					12
				],
				[
					-38,
					-79
				],
				[
					-97,
					-75
				],
				[
					-70,
					0
				],
				[
					-61,
					-73
				],
				[
					-56,
					26
				],
				[
					-47,
					88
				],
				[
					-29,
					-17
				],
				[
					-36,
					-138
				],
				[
					-27,
					5
				],
				[
					-4,
					-118
				],
				[
					-97,
					-159
				],
				[
					-51,
					-68
				],
				[
					-29,
					-72
				],
				[
					-82,
					117
				],
				[
					-60,
					-154
				],
				[
					-58,
					4
				],
				[
					-65,
					-14
				],
				[
					6,
					-283
				],
				[
					-41,
					-5
				],
				[
					-35,
					-131
				],
				[
					-86,
					-24
				]
			],
			[
				[
					55230,
					78267
				],
				[
					67,
					-223
				],
				[
					89,
					-164
				],
				[
					-107,
					-217
				]
			],
			[
				[
					55155,
					76391
				],
				[
					-31,
					-98
				]
			],
			[
				[
					55124,
					76293
				],
				[
					-261,
					213
				],
				[
					-161,
					207
				],
				[
					-254,
					171
				],
				[
					-233,
					424
				],
				[
					56,
					43
				],
				[
					-127,
					242
				],
				[
					-5,
					195
				],
				[
					-179,
					91
				],
				[
					-85,
					-249
				],
				[
					-82,
					193
				],
				[
					6,
					200
				],
				[
					10,
					9
				]
			],
			[
				[
					53809,
					78032
				],
				[
					194,
					-20
				],
				[
					51,
					98
				],
				[
					94,
					-94
				],
				[
					109,
					-12
				],
				[
					-1,
					161
				],
				[
					97,
					59
				],
				[
					27,
					233
				],
				[
					221,
					153
				]
			],
			[
				[
					54601,
					78610
				],
				[
					88,
					-71
				],
				[
					208,
					-247
				],
				[
					229,
					-111
				],
				[
					104,
					86
				]
			],
			[
				[
					30081,
					62221
				],
				[
					-185,
					98
				],
				[
					-131,
					-40
				],
				[
					-169,
					42
				],
				[
					-130,
					-108
				],
				[
					-149,
					179
				],
				[
					24,
					186
				],
				[
					256,
					-80
				],
				[
					210,
					-46
				],
				[
					100,
					128
				],
				[
					-127,
					250
				],
				[
					2,
					220
				],
				[
					-175,
					89
				],
				[
					62,
					159
				],
				[
					170,
					-25
				],
				[
					241,
					-90
				]
			],
			[
				[
					54716,
					79543
				],
				[
					141,
					-148
				],
				[
					103,
					-62
				],
				[
					233,
					70
				],
				[
					22,
					116
				],
				[
					111,
					17
				],
				[
					135,
					89
				],
				[
					30,
					-37
				],
				[
					130,
					72
				],
				[
					66,
					136
				],
				[
					91,
					35
				],
				[
					297,
					-175
				],
				[
					59,
					59
				]
			],
			[
				[
					56134,
					79715
				],
				[
					155,
					-157
				],
				[
					19,
					-154
				]
			],
			[
				[
					56308,
					79404
				],
				[
					-170,
					-121
				],
				[
					-131,
					-391
				],
				[
					-168,
					-390
				],
				[
					-223,
					-109
				]
			],
			[
				[
					55616,
					78393
				],
				[
					-173,
					26
				],
				[
					-213,
					-152
				]
			],
			[
				[
					54601,
					78610
				],
				[
					-54,
					194
				],
				[
					-47,
					7
				]
			],
			[
				[
					83531,
					45933
				],
				[
					-117,
					-11
				],
				[
					-368,
					403
				],
				[
					259,
					113
				],
				[
					146,
					-175
				],
				[
					97,
					-175
				],
				[
					-17,
					-155
				]
			],
			[
				[
					84713,
					46708
				],
				[
					28,
					-113
				],
				[
					5,
					-175
				]
			],
			[
				[
					84746,
					46420
				],
				[
					-181,
					-430
				],
				[
					-238,
					-127
				],
				[
					-33,
					69
				],
				[
					25,
					196
				],
				[
					119,
					351
				],
				[
					275,
					229
				]
			],
			[
				[
					82749,
					47167
				],
				[
					100,
					-153
				],
				[
					172,
					47
				],
				[
					69,
					-245
				],
				[
					-321,
					-116
				],
				[
					-193,
					-77
				],
				[
					-149,
					4
				],
				[
					95,
					332
				],
				[
					153,
					5
				],
				[
					74,
					203
				]
			],
			[
				[
					84139,
					47168
				],
				[
					-41,
					-320
				],
				[
					-417,
					-163
				],
				[
					-370,
					71
				],
				[
					0,
					210
				],
				[
					220,
					120
				],
				[
					174,
					-173
				],
				[
					185,
					44
				],
				[
					249,
					211
				]
			],
			[
				[
					80172,
					47926
				],
				[
					533,
					-57
				],
				[
					61,
					237
				],
				[
					515,
					-277
				],
				[
					101,
					-373
				],
				[
					417,
					-105
				],
				[
					341,
					-342
				],
				[
					-317,
					-220
				],
				[
					-306,
					232
				],
				[
					-251,
					-15
				],
				[
					-288,
					42
				],
				[
					-260,
					104
				],
				[
					-322,
					220
				],
				[
					-204,
					57
				],
				[
					-116,
					-72
				],
				[
					-506,
					237
				],
				[
					-48,
					247
				],
				[
					-255,
					43
				],
				[
					191,
					550
				],
				[
					337,
					-34
				],
				[
					224,
					-225
				],
				[
					115,
					-44
				],
				[
					38,
					-205
				]
			],
			[
				[
					87423,
					48251
				],
				[
					-143,
					-393
				],
				[
					-27,
					434
				],
				[
					49,
					207
				],
				[
					58,
					195
				],
				[
					63,
					-169
				],
				[
					0,
					-274
				]
			],
			[
				[
					85346,
					49837
				],
				[
					-104,
					-191
				],
				[
					-192,
					106
				],
				[
					-54,
					248
				],
				[
					281,
					27
				],
				[
					69,
					-190
				]
			],
			[
				[
					86241,
					50048
				],
				[
					101,
					-441
				],
				[
					-234,
					238
				],
				[
					-232,
					48
				],
				[
					-157,
					-38
				],
				[
					-192,
					20
				],
				[
					65,
					317
				],
				[
					344,
					24
				],
				[
					305,
					-168
				]
			],
			[
				[
					89166,
					50332
				],
				[
					5,
					-1877
				],
				[
					4,
					-1876
				]
			],
			[
				[
					89175,
					46579
				],
				[
					-247,
					472
				],
				[
					-282,
					116
				],
				[
					-69,
					-164
				],
				[
					-352,
					-18
				],
				[
					118,
					469
				],
				[
					175,
					160
				],
				[
					-72,
					626
				],
				[
					-134,
					483
				],
				[
					-538,
					488
				],
				[
					-229,
					48
				],
				[
					-417,
					532
				],
				[
					-82,
					-279
				],
				[
					-107,
					-51
				],
				[
					-63,
					211
				],
				[
					-1,
					250
				],
				[
					-212,
					283
				],
				[
					299,
					207
				],
				[
					198,
					-11
				],
				[
					-23,
					153
				],
				[
					-407,
					1
				],
				[
					-110,
					343
				],
				[
					-248,
					106
				],
				[
					-117,
					285
				],
				[
					374,
					140
				],
				[
					142,
					188
				],
				[
					446,
					-237
				],
				[
					44,
					-214
				],
				[
					78,
					-931
				],
				[
					287,
					-345
				],
				[
					232,
					611
				],
				[
					319,
					347
				],
				[
					247,
					1
				],
				[
					238,
					-201
				],
				[
					206,
					-206
				],
				[
					298,
					-110
				]
			],
			[
				[
					84788,
					52647
				],
				[
					-223,
					-571
				],
				[
					-209,
					-111
				],
				[
					-267,
					113
				],
				[
					-463,
					-29
				],
				[
					-243,
					-83
				],
				[
					-39,
					-436
				],
				[
					248,
					-512
				],
				[
					150,
					261
				],
				[
					518,
					196
				],
				[
					-22,
					-265
				],
				[
					-121,
					83
				],
				[
					-121,
					-337
				],
				[
					-245,
					-223
				],
				[
					263,
					-738
				],
				[
					-50,
					-198
				],
				[
					249,
					-665
				],
				[
					-2,
					-378
				],
				[
					-148,
					-170
				],
				[
					-109,
					203
				],
				[
					134,
					471
				],
				[
					-273,
					-222
				],
				[
					-69,
					159
				],
				[
					36,
					222
				],
				[
					-200,
					338
				],
				[
					21,
					561
				],
				[
					-186,
					-175
				],
				[
					24,
					-671
				],
				[
					11,
					-824
				],
				[
					-176,
					-84
				],
				[
					-119,
					169
				],
				[
					79,
					530
				],
				[
					-43,
					556
				],
				[
					-117,
					4
				],
				[
					-86,
					395
				],
				[
					115,
					377
				],
				[
					40,
					457
				],
				[
					139,
					868
				],
				[
					58,
					238
				],
				[
					237,
					427
				],
				[
					217,
					-170
				],
				[
					350,
					-80
				],
				[
					319,
					24
				],
				[
					275,
					419
				],
				[
					48,
					-129
				]
			],
			[
				[
					85746,
					52481
				],
				[
					-15,
					-503
				],
				[
					-143,
					57
				],
				[
					-42,
					-351
				],
				[
					114,
					-304
				],
				[
					-78,
					-69
				],
				[
					-112,
					365
				],
				[
					-82,
					736
				],
				[
					56,
					460
				],
				[
					92,
					210
				],
				[
					20,
					-315
				],
				[
					164,
					-50
				],
				[
					26,
					-236
				]
			],
			[
				[
					80461,
					52985
				],
				[
					47,
					-385
				],
				[
					190,
					-325
				],
				[
					179,
					117
				],
				[
					177,
					-42
				],
				[
					162,
					291
				],
				[
					133,
					51
				],
				[
					263,
					-162
				],
				[
					226,
					123
				],
				[
					143,
					801
				],
				[
					107,
					200
				],
				[
					96,
					655
				],
				[
					319,
					0
				],
				[
					241,
					-97
				]
			],
			[
				[
					82744,
					54212
				],
				[
					-158,
					-520
				],
				[
					204,
					-545
				],
				[
					-48,
					-265
				],
				[
					312,
					-533
				],
				[
					-329,
					-68
				],
				[
					-93,
					-393
				],
				[
					12,
					-522
				],
				[
					-267,
					-393
				],
				[
					-7,
					-574
				],
				[
					-107,
					-881
				],
				[
					-41,
					205
				],
				[
					-316,
					-259
				],
				[
					-110,
					352
				],
				[
					-198,
					33
				],
				[
					-139,
					184
				],
				[
					-330,
					-207
				],
				[
					-101,
					279
				],
				[
					-182,
					-32
				],
				[
					-229,
					67
				],
				[
					-43,
					772
				],
				[
					-138,
					160
				],
				[
					-134,
					493
				],
				[
					-38,
					504
				],
				[
					32,
					533
				],
				[
					165,
					383
				]
			],
			[
				[
					79393,
					48459
				],
				[
					-308,
					-12
				],
				[
					-234,
					481
				],
				[
					-356,
					471
				],
				[
					-119,
					349
				],
				[
					-210,
					469
				],
				[
					-138,
					432
				],
				[
					-212,
					806
				],
				[
					-244,
					480
				],
				[
					-81,
					495
				],
				[
					-103,
					449
				],
				[
					-250,
					363
				],
				[
					-145,
					493
				],
				[
					-209,
					322
				],
				[
					-290,
					635
				],
				[
					-24,
					293
				],
				[
					178,
					-23
				],
				[
					430,
					-111
				],
				[
					246,
					-564
				],
				[
					215,
					-390
				],
				[
					153,
					-240
				],
				[
					263,
					-619
				],
				[
					283,
					-9
				],
				[
					233,
					-394
				],
				[
					161,
					-482
				],
				[
					211,
					-263
				],
				[
					-111,
					-471
				],
				[
					159,
					-200
				],
				[
					100,
					-14
				],
				[
					47,
					-402
				],
				[
					97,
					-321
				],
				[
					204,
					-51
				],
				[
					135,
					-365
				],
				[
					-70,
					-716
				],
				[
					-11,
					-891
				]
			],
			[
				[
					72530,
					69211
				],
				[
					-176,
					-261
				],
				[
					-108,
					-538
				],
				[
					269,
					-218
				],
				[
					262,
					-283
				],
				[
					362,
					-323
				],
				[
					381,
					-75
				],
				[
					160,
					-293
				],
				[
					215,
					-54
				],
				[
					334,
					-135
				],
				[
					231,
					10
				],
				[
					32,
					228
				],
				[
					-36,
					366
				],
				[
					21,
					248
				]
			],
			[
				[
					77035,
					68105
				],
				[
					20,
					-219
				],
				[
					-97,
					-105
				],
				[
					23,
					-355
				],
				[
					-199,
					104
				],
				[
					-359,
					-397
				],
				[
					8,
					-330
				],
				[
					-153,
					-483
				],
				[
					-14,
					-281
				],
				[
					-124,
					-474
				],
				[
					-217,
					131
				],
				[
					-11,
					-596
				],
				[
					-63,
					-196
				],
				[
					30,
					-245
				],
				[
					-137,
					-137
				]
			],
			[
				[
					74730,
					64531
				],
				[
					-39,
					-210
				],
				[
					-189,
					7
				],
				[
					-343,
					-120
				],
				[
					16,
					-433
				],
				[
					-148,
					-341
				],
				[
					-400,
					-387
				],
				[
					-311,
					-678
				],
				[
					-209,
					-363
				],
				[
					-276,
					-377
				],
				[
					-1,
					-265
				],
				[
					-138,
					-142
				],
				[
					-251,
					-206
				],
				[
					-129,
					-31
				],
				[
					-84,
					-439
				],
				[
					58,
					-749
				],
				[
					15,
					-478
				],
				[
					-118,
					-547
				],
				[
					-1,
					-978
				],
				[
					-144,
					-28
				],
				[
					-126,
					-439
				],
				[
					84,
					-190
				],
				[
					-253,
					-163
				],
				[
					-93,
					-392
				],
				[
					-112,
					-165
				],
				[
					-263,
					537
				],
				[
					-128,
					807
				],
				[
					-107,
					581
				],
				[
					-97,
					272
				],
				[
					-148,
					553
				],
				[
					-69,
					720
				],
				[
					-48,
					360
				],
				[
					-253,
					791
				],
				[
					-115,
					1116
				],
				[
					-83,
					737
				],
				[
					1,
					698
				],
				[
					-54,
					539
				],
				[
					-404,
					-345
				],
				[
					-196,
					69
				],
				[
					-362,
					698
				],
				[
					133,
					208
				],
				[
					-82,
					226
				],
				[
					-326,
					489
				]
			],
			[
				[
					68937,
					65473
				],
				[
					185,
					384
				],
				[
					612,
					-1
				],
				[
					-56,
					494
				],
				[
					-156,
					292
				],
				[
					-31,
					444
				],
				[
					-182,
					258
				],
				[
					306,
					604
				],
				[
					323,
					-44
				],
				[
					290,
					604
				],
				[
					174,
					584
				],
				[
					270,
					578
				],
				[
					-4,
					411
				],
				[
					236,
					333
				],
				[
					-224,
					284
				],
				[
					-96,
					390
				],
				[
					-99,
					504
				],
				[
					137,
					249
				],
				[
					421,
					-141
				],
				[
					310,
					86
				],
				[
					268,
					484
				]
			],
			[
				[
					48278,
					82851
				],
				[
					46,
					-412
				],
				[
					-210,
					-514
				],
				[
					-493,
					-340
				],
				[
					-393,
					87
				],
				[
					225,
					601
				],
				[
					-145,
					586
				],
				[
					378,
					451
				],
				[
					210,
					269
				]
			],
			[
				[
					64978,
					73251
				],
				[
					244,
					112
				],
				[
					197,
					329
				],
				[
					186,
					-17
				],
				[
					122,
					108
				],
				[
					197,
					-53
				],
				[
					308,
					-292
				],
				[
					221,
					-63
				],
				[
					318,
					-510
				],
				[
					207,
					-21
				],
				[
					24,
					-484
				]
			],
			[
				[
					66909,
					69007
				],
				[
					137,
					-302
				],
				[
					112,
					-348
				],
				[
					266,
					-253
				],
				[
					7,
					-508
				],
				[
					133,
					-93
				],
				[
					23,
					-265
				],
				[
					-400,
					-298
				],
				[
					-105,
					-669
				]
			],
			[
				[
					67082,
					66271
				],
				[
					-523,
					174
				],
				[
					-303,
					133
				],
				[
					-313,
					74
				],
				[
					-118,
					707
				],
				[
					-133,
					102
				],
				[
					-214,
					-103
				],
				[
					-280,
					-279
				],
				[
					-339,
					191
				],
				[
					-281,
					443
				],
				[
					-267,
					164
				],
				[
					-186,
					546
				],
				[
					-205,
					768
				],
				[
					-149,
					-93
				],
				[
					-177,
					190
				],
				[
					-104,
					-224
				]
			],
			[
				[
					63490,
					69064
				],
				[
					-153,
					302
				],
				[
					-3,
					307
				],
				[
					-89,
					0
				],
				[
					46,
					417
				],
				[
					-143,
					438
				],
				[
					-340,
					315
				],
				[
					-193,
					548
				],
				[
					65,
					449
				],
				[
					139,
					199
				],
				[
					-21,
					336
				],
				[
					-182,
					173
				],
				[
					-180,
					687
				]
			],
			[
				[
					62436,
					73235
				],
				[
					-152,
					461
				],
				[
					55,
					179
				],
				[
					-87,
					660
				],
				[
					190,
					164
				]
			],
			[
				[
					63578,
					73897
				],
				[
					88,
					-424
				],
				[
					263,
					-120
				],
				[
					193,
					-289
				],
				[
					395,
					-100
				],
				[
					434,
					153
				],
				[
					27,
					134
				]
			],
			[
				[
					63490,
					69064
				],
				[
					-164,
					28
				]
			],
			[
				[
					63326,
					69092
				],
				[
					-187,
					48
				],
				[
					-204,
					-553
				]
			],
			[
				[
					62935,
					68587
				],
				[
					-516,
					46
				],
				[
					-784,
					1158
				],
				[
					-413,
					403
				],
				[
					-335,
					156
				]
			],
			[
				[
					60887,
					70350
				],
				[
					-112,
					701
				]
			],
			[
				[
					60775,
					71051
				],
				[
					615,
					600
				],
				[
					105,
					696
				],
				[
					-26,
					421
				],
				[
					152,
					142
				],
				[
					142,
					359
				]
			],
			[
				[
					61763,
					73269
				],
				[
					119,
					90
				],
				[
					324,
					-75
				],
				[
					97,
					-146
				],
				[
					133,
					97
				]
			],
			[
				[
					45969,
					90100
				],
				[
					-64,
					-373
				],
				[
					314,
					-392
				],
				[
					-361,
					-440
				],
				[
					-801,
					-394
				],
				[
					-240,
					-105
				],
				[
					-365,
					85
				],
				[
					-775,
					182
				],
				[
					273,
					254
				],
				[
					-605,
					282
				],
				[
					492,
					112
				],
				[
					-12,
					169
				],
				[
					-583,
					134
				],
				[
					188,
					375
				],
				[
					421,
					85
				],
				[
					433,
					-391
				],
				[
					422,
					314
				],
				[
					349,
					-163
				],
				[
					453,
					307
				],
				[
					461,
					-41
				]
			],
			[
				[
					59922,
					70666
				],
				[
					-49,
					-182
				]
			],
			[
				[
					59873,
					70484
				],
				[
					-100,
					80
				],
				[
					-58,
					-383
				],
				[
					69,
					-65
				],
				[
					-71,
					-79
				],
				[
					-12,
					-152
				],
				[
					131,
					78
				]
			],
			[
				[
					59832,
					69963
				],
				[
					7,
					-224
				],
				[
					-139,
					-920
				]
			],
			[
				[
					59518,
					69808
				],
				[
					80,
					190
				],
				[
					-19,
					32
				],
				[
					74,
					270
				],
				[
					56,
					434
				],
				[
					40,
					146
				],
				[
					8,
					6
				]
			],
			[
				[
					59757,
					70886
				],
				[
					93,
					-1
				],
				[
					25,
					101
				],
				[
					75,
					7
				]
			],
			[
				[
					59950,
					70993
				],
				[
					4,
					-236
				],
				[
					-38,
					-87
				],
				[
					6,
					-4
				]
			],
			[
				[
					54311,
					73846
				],
				[
					-100,
					-453
				],
				[
					41,
					-179
				],
				[
					-58,
					-296
				],
				[
					-213,
					217
				],
				[
					-141,
					62
				],
				[
					-387,
					293
				],
				[
					38,
					296
				],
				[
					325,
					-53
				],
				[
					284,
					63
				],
				[
					211,
					50
				]
			],
			[
				[
					52558,
					75561
				],
				[
					166,
					-408
				],
				[
					-39,
					-762
				],
				[
					-126,
					36
				],
				[
					-113,
					-192
				],
				[
					-105,
					153
				],
				[
					-11,
					694
				],
				[
					-64,
					330
				],
				[
					153,
					-29
				],
				[
					139,
					178
				]
			],
			[
				[
					53835,
					78613
				],
				[
					-31,
					-283
				],
				[
					67,
					-246
				]
			],
			[
				[
					53871,
					78084
				],
				[
					-221,
					84
				],
				[
					-226,
					-204
				],
				[
					15,
					-286
				],
				[
					-34,
					-164
				],
				[
					91,
					-293
				],
				[
					261,
					-290
				],
				[
					140,
					-476
				],
				[
					309,
					-464
				],
				[
					217,
					3
				],
				[
					68,
					-127
				],
				[
					-78,
					-115
				],
				[
					249,
					-208
				],
				[
					204,
					-174
				],
				[
					238,
					-301
				],
				[
					29,
					-107
				],
				[
					-52,
					-206
				],
				[
					-154,
					268
				],
				[
					-242,
					95
				],
				[
					-116,
					-372
				],
				[
					200,
					-214
				],
				[
					-33,
					-300
				],
				[
					-116,
					-34
				],
				[
					-148,
					-494
				],
				[
					-116,
					-45
				],
				[
					1,
					176
				],
				[
					57,
					309
				],
				[
					60,
					123
				],
				[
					-108,
					334
				],
				[
					-85,
					290
				],
				[
					-115,
					72
				],
				[
					-82,
					249
				],
				[
					-179,
					104
				],
				[
					-120,
					232
				],
				[
					-206,
					37
				],
				[
					-217,
					260
				],
				[
					-254,
					375
				],
				[
					-189,
					332
				],
				[
					-86,
					569
				],
				[
					-138,
					67
				],
				[
					-226,
					190
				],
				[
					-128,
					-78
				],
				[
					-161,
					-267
				],
				[
					-115,
					-42
				]
			],
			[
				[
					28453,
					62478
				],
				[
					187,
					-52
				],
				[
					147,
					-138
				],
				[
					46,
					-158
				],
				[
					-195,
					-11
				],
				[
					-84,
					-96
				],
				[
					-156,
					92
				],
				[
					-159,
					210
				],
				[
					34,
					132
				],
				[
					116,
					40
				],
				[
					64,
					-19
				]
			],
			[
				[
					59922,
					70666
				],
				[
					309,
					-228
				],
				[
					544,
					613
				]
			],
			[
				[
					60887,
					70350
				],
				[
					-53,
					-87
				],
				[
					-556,
					-289
				],
				[
					277,
					-575
				],
				[
					-92,
					-98
				],
				[
					-46,
					-193
				],
				[
					-212,
					-80
				],
				[
					-66,
					-207
				],
				[
					-120,
					-177
				],
				[
					-310,
					91
				]
			],
			[
				[
					59709,
					68735
				],
				[
					-9,
					84
				]
			],
			[
				[
					59832,
					69963
				],
				[
					41,
					169
				],
				[
					0,
					352
				]
			],
			[
				[
					87399,
					71495
				],
				[
					35,
					-197
				],
				[
					-156,
					-349
				],
				[
					-114,
					185
				],
				[
					-143,
					-134
				],
				[
					-73,
					-337
				],
				[
					-181,
					164
				],
				[
					2,
					273
				],
				[
					154,
					344
				],
				[
					158,
					-67
				],
				[
					114,
					242
				],
				[
					204,
					-124
				]
			],
			[
				[
					89159,
					73219
				],
				[
					-104,
					-460
				],
				[
					48,
					-288
				],
				[
					-145,
					-406
				],
				[
					-355,
					-271
				],
				[
					-488,
					-36
				],
				[
					-396,
					-657
				],
				[
					-186,
					221
				],
				[
					-12,
					431
				],
				[
					-483,
					-127
				],
				[
					-329,
					-271
				],
				[
					-325,
					-11
				],
				[
					282,
					-424
				],
				[
					-186,
					-979
				],
				[
					-179,
					-242
				],
				[
					-135,
					224
				],
				[
					69,
					519
				],
				[
					-176,
					167
				],
				[
					-113,
					395
				],
				[
					263,
					177
				],
				[
					145,
					362
				],
				[
					280,
					298
				],
				[
					203,
					394
				],
				[
					553,
					171
				],
				[
					297,
					-117
				],
				[
					291,
					1024
				],
				[
					185,
					-275
				],
				[
					408,
					575
				],
				[
					158,
					224
				],
				[
					174,
					704
				],
				[
					-47,
					648
				],
				[
					117,
					364
				],
				[
					295,
					105
				],
				[
					152,
					-798
				],
				[
					-9,
					-467
				],
				[
					-256,
					-580
				],
				[
					4,
					-594
				]
			],
			[
				[
					89974,
					77268
				],
				[
					195,
					-122
				],
				[
					197,
					244
				],
				[
					62,
					-647
				],
				[
					-412,
					-157
				],
				[
					-244,
					-572
				],
				[
					-436,
					393
				],
				[
					-152,
					-630
				],
				[
					-308,
					-9
				],
				[
					-39,
					573
				],
				[
					138,
					443
				],
				[
					296,
					32
				],
				[
					81,
					797
				],
				[
					83,
					449
				],
				[
					326,
					-600
				],
				[
					213,
					-194
				]
			],
			[
				[
					69711,
					76170
				],
				[
					-159,
					-107
				],
				[
					-367,
					-401
				],
				[
					-121,
					-412
				],
				[
					-104,
					-4
				],
				[
					-76,
					273
				],
				[
					-353,
					18
				],
				[
					-57,
					472
				],
				[
					-135,
					4
				],
				[
					21,
					578
				],
				[
					-333,
					421
				],
				[
					-476,
					-45
				],
				[
					-326,
					-84
				],
				[
					-265,
					519
				],
				[
					-227,
					218
				],
				[
					-431,
					412
				],
				[
					-52,
					50
				],
				[
					-715,
					-340
				],
				[
					11,
					-2124
				]
			],
			[
				[
					65546,
					75618
				],
				[
					-142,
					-28
				],
				[
					-195,
					452
				],
				[
					-188,
					161
				],
				[
					-315,
					-120
				],
				[
					-123,
					-191
				]
			],
			[
				[
					64583,
					75892
				],
				[
					-15,
					140
				],
				[
					68,
					240
				],
				[
					-53,
					201
				],
				[
					-322,
					196
				],
				[
					-125,
					517
				],
				[
					-154,
					146
				],
				[
					-9,
					187
				],
				[
					270,
					-54
				],
				[
					11,
					421
				],
				[
					236,
					93
				],
				[
					243,
					-86
				],
				[
					50,
					562
				],
				[
					-50,
					356
				],
				[
					-278,
					-28
				],
				[
					-236,
					141
				],
				[
					-321,
					-253
				],
				[
					-259,
					-121
				]
			],
			[
				[
					63639,
					78550
				],
				[
					-142,
					93
				],
				[
					29,
					296
				],
				[
					-177,
					385
				],
				[
					-207,
					-16
				],
				[
					-235,
					391
				],
				[
					160,
					436
				],
				[
					-81,
					118
				],
				[
					222,
					632
				],
				[
					285,
					-334
				],
				[
					35,
					421
				],
				[
					573,
					626
				],
				[
					434,
					15
				],
				[
					612,
					-399
				],
				[
					329,
					-233
				],
				[
					295,
					243
				],
				[
					440,
					12
				],
				[
					356,
					-298
				],
				[
					80,
					170
				],
				[
					391,
					-24
				],
				[
					69,
					272
				],
				[
					-450,
					396
				],
				[
					267,
					281
				],
				[
					-52,
					157
				],
				[
					266,
					150
				],
				[
					-200,
					394
				],
				[
					127,
					197
				],
				[
					1039,
					200
				],
				[
					136,
					142
				],
				[
					695,
					213
				],
				[
					250,
					239
				],
				[
					499,
					-124
				],
				[
					88,
					-597
				],
				[
					290,
					140
				],
				[
					356,
					-197
				],
				[
					-23,
					-314
				],
				[
					267,
					33
				],
				[
					696,
					543
				],
				[
					-102,
					-180
				],
				[
					355,
					-445
				],
				[
					620,
					-1463
				],
				[
					148,
					302
				],
				[
					383,
					-332
				],
				[
					399,
					148
				],
				[
					154,
					-104
				],
				[
					133,
					-332
				],
				[
					194,
					-112
				],
				[
					119,
					-244
				],
				[
					358,
					77
				],
				[
					147,
					-353
				]
			],
			[
				[
					72294,
					76218
				],
				[
					-171,
					84
				],
				[
					-140,
					207
				],
				[
					-412,
					61
				],
				[
					-461,
					15
				],
				[
					-100,
					-63
				],
				[
					-396,
					242
				],
				[
					-158,
					-119
				],
				[
					-43,
					-340
				],
				[
					-457,
					198
				],
				[
					-183,
					-81
				],
				[
					-62,
					-252
				]
			],
			[
				[
					61551,
					50860
				],
				[
					-195,
					-230
				],
				[
					-68,
					-240
				],
				[
					-104,
					-42
				],
				[
					-40,
					-406
				],
				[
					-89,
					-233
				],
				[
					-54,
					-383
				],
				[
					-112,
					-190
				]
			],
			[
				[
					60889,
					49136
				],
				[
					-399,
					576
				],
				[
					-19,
					334
				],
				[
					-1007,
					1173
				],
				[
					-47,
					63
				]
			],
			[
				[
					59417,
					51282
				],
				[
					-3,
					611
				],
				[
					80,
					233
				],
				[
					137,
					381
				],
				[
					101,
					420
				],
				[
					-123,
					661
				],
				[
					-32,
					289
				],
				[
					-132,
					400
				]
			],
			[
				[
					59445,
					54277
				],
				[
					171,
					344
				],
				[
					188,
					379
				]
			],
			[
				[
					61626,
					54086
				],
				[
					-243,
					-653
				],
				[
					3,
					-2098
				],
				[
					165,
					-475
				]
			],
			[
				[
					70465,
					74537
				],
				[
					-526,
					-87
				],
				[
					-343,
					187
				],
				[
					-301,
					-45
				],
				[
					26,
					332
				],
				[
					303,
					-96
				],
				[
					101,
					177
				]
			],
			[
				[
					69725,
					75005
				],
				[
					212,
					-56
				],
				[
					355,
					414
				],
				[
					-329,
					304
				],
				[
					-198,
					-144
				],
				[
					-205,
					217
				],
				[
					234,
					373
				],
				[
					-83,
					57
				]
			],
			[
				[
					78495,
					58847
				],
				[
					-66,
					696
				],
				[
					178,
					479
				],
				[
					359,
					110
				],
				[
					261,
					-83
				]
			],
			[
				[
					79227,
					60049
				],
				[
					229,
					-226
				],
				[
					126,
					397
				],
				[
					246,
					-212
				]
			],
			[
				[
					79828,
					60008
				],
				[
					64,
					-384
				],
				[
					-34,
					-690
				],
				[
					-467,
					-443
				],
				[
					122,
					-349
				],
				[
					-292,
					-42
				],
				[
					-240,
					-232
				]
			],
			[
				[
					78981,
					57868
				],
				[
					-233,
					84
				],
				[
					-112,
					301
				],
				[
					-141,
					594
				]
			],
			[
				[
					85652,
					74065
				],
				[
					240,
					-679
				],
				[
					68,
					-373
				],
				[
					3,
					-664
				],
				[
					-105,
					-316
				],
				[
					-252,
					-111
				],
				[
					-222,
					-239
				],
				[
					-250,
					-49
				],
				[
					-31,
					313
				],
				[
					51,
					432
				],
				[
					-122,
					600
				],
				[
					206,
					97
				],
				[
					-190,
					493
				]
			],
			[
				[
					85048,
					73569
				],
				[
					17,
					52
				],
				[
					124,
					-21
				],
				[
					108,
					260
				],
				[
					197,
					28
				],
				[
					118,
					38
				],
				[
					40,
					139
				]
			],
			[
				[
					55575,
					76355
				],
				[
					52,
					129
				]
			],
			[
				[
					55627,
					76484
				],
				[
					66,
					42
				],
				[
					38,
					191
				],
				[
					50,
					32
				],
				[
					40,
					-81
				],
				[
					52,
					-36
				],
				[
					36,
					-92
				],
				[
					46,
					-27
				],
				[
					54,
					-107
				],
				[
					39,
					3
				],
				[
					-31,
					-140
				],
				[
					-33,
					-68
				],
				[
					9,
					-43
				]
			],
			[
				[
					55993,
					76158
				],
				[
					-62,
					-23
				],
				[
					-164,
					-89
				],
				[
					-13,
					-118
				],
				[
					-35,
					5
				]
			],
			[
				[
					63326,
					69092
				],
				[
					58,
					-254
				],
				[
					-25,
					-132
				],
				[
					89,
					-434
				]
			],
			[
				[
					63448,
					68272
				],
				[
					-196,
					-15
				],
				[
					-69,
					274
				],
				[
					-248,
					56
				]
			],
			[
				[
					79227,
					60049
				],
				[
					90,
					260
				],
				[
					12,
					487
				],
				[
					-224,
					502
				],
				[
					-18,
					568
				],
				[
					-211,
					468
				],
				[
					-210,
					40
				],
				[
					-56,
					-201
				],
				[
					-163,
					-17
				],
				[
					-83,
					102
				],
				[
					-293,
					-344
				],
				[
					-6,
					517
				],
				[
					68,
					606
				],
				[
					-188,
					27
				],
				[
					-16,
					346
				],
				[
					-120,
					178
				]
			],
			[
				[
					77809,
					63588
				],
				[
					59,
					212
				],
				[
					237,
					374
				]
			],
			[
				[
					78380,
					64766
				],
				[
					162,
					-454
				],
				[
					125,
					-524
				],
				[
					342,
					-4
				],
				[
					108,
					-502
				],
				[
					-178,
					-151
				],
				[
					-80,
					-207
				],
				[
					333,
					-345
				],
				[
					231,
					-680
				],
				[
					175,
					-508
				],
				[
					210,
					-400
				],
				[
					70,
					-407
				],
				[
					-50,
					-576
				]
			],
			[
				[
					59757,
					70886
				],
				[
					99,
					469
				],
				[
					138,
					406
				],
				[
					5,
					20
				]
			],
			[
				[
					59999,
					71781
				],
				[
					125,
					-30
				],
				[
					45,
					-226
				],
				[
					-151,
					-217
				],
				[
					-68,
					-315
				]
			],
			[
				[
					47857,
					54343
				],
				[
					-73,
					-5
				],
				[
					-286,
					274
				],
				[
					-252,
					439
				],
				[
					-237,
					315
				],
				[
					-187,
					371
				]
			],
			[
				[
					46822,
					55737
				],
				[
					66,
					184
				],
				[
					15,
					168
				],
				[
					126,
					313
				],
				[
					129,
					268
				]
			],
			[
				[
					54125,
					64996
				],
				[
					-197,
					-214
				],
				[
					-156,
					316
				],
				[
					-439,
					248
				]
			],
			[
				[
					52633,
					69283
				],
				[
					136,
					133
				],
				[
					24,
					244
				],
				[
					-30,
					238
				],
				[
					191,
					222
				],
				[
					86,
					185
				],
				[
					135,
					165
				],
				[
					16,
					442
				]
			],
			[
				[
					53191,
					70912
				],
				[
					326,
					-198
				],
				[
					117,
					50
				],
				[
					232,
					-96
				],
				[
					368,
					-258
				],
				[
					130,
					-512
				],
				[
					250,
					-111
				],
				[
					391,
					-242
				],
				[
					296,
					-286
				],
				[
					136,
					150
				],
				[
					133,
					264
				],
				[
					-65,
					442
				],
				[
					87,
					280
				],
				[
					200,
					270
				],
				[
					192,
					78
				],
				[
					375,
					-118
				],
				[
					95,
					-257
				],
				[
					104,
					-3
				],
				[
					88,
					-98
				],
				[
					276,
					-67
				],
				[
					68,
					-191
				]
			],
			[
				[
					56944,
					64499
				],
				[
					0,
					-1150
				],
				[
					-320,
					-2
				],
				[
					-3,
					-242
				]
			],
			[
				[
					56621,
					63105
				],
				[
					-1108,
					1103
				],
				[
					-1108,
					1103
				],
				[
					-280,
					-315
				]
			],
			[
				[
					72718,
					56162
				],
				[
					-42,
					-600
				],
				[
					-116,
					-164
				],
				[
					-242,
					-132
				],
				[
					-132,
					458
				],
				[
					-49,
					828
				],
				[
					126,
					935
				],
				[
					192,
					-320
				],
				[
					129,
					-406
				],
				[
					134,
					-599
				]
			],
			[
				[
					58049,
					35154
				],
				[
					96,
					-173
				],
				[
					-85,
					-281
				],
				[
					-47,
					-187
				],
				[
					-155,
					-90
				],
				[
					-51,
					-184
				],
				[
					-99,
					-58
				],
				[
					-209,
					443
				],
				[
					148,
					365
				],
				[
					151,
					225
				],
				[
					130,
					118
				],
				[
					121,
					-178
				]
			],
			[
				[
					56314,
					83116
				],
				[
					-23,
					147
				],
				[
					30,
					157
				],
				[
					-123,
					92
				],
				[
					-291,
					100
				]
			],
			[
				[
					55907,
					83612
				],
				[
					-59,
					485
				]
			],
			[
				[
					55848,
					84097
				],
				[
					318,
					176
				],
				[
					466,
					-37
				],
				[
					273,
					57
				],
				[
					39,
					-120
				],
				[
					148,
					-37
				],
				[
					267,
					-279
				]
			],
			[
				[
					56523,
					82877
				],
				[
					-67,
					177
				],
				[
					-142,
					62
				]
			],
			[
				[
					55848,
					84097
				],
				[
					10,
					433
				],
				[
					136,
					362
				],
				[
					262,
					196
				],
				[
					221,
					-430
				],
				[
					223,
					11
				],
				[
					53,
					442
				]
			],
			[
				[
					57579,
					84928
				],
				[
					134,
					-133
				],
				[
					24,
					-279
				],
				[
					89,
					-340
				]
			],
			[
				[
					47592,
					67756
				],
				[
					-42,
					0
				],
				[
					7,
					-308
				],
				[
					-172,
					-19
				],
				[
					-90,
					-131
				],
				[
					-126,
					0
				],
				[
					-100,
					75
				],
				[
					-234,
					-62
				],
				[
					-91,
					-449
				],
				[
					-86,
					-42
				],
				[
					-131,
					-726
				],
				[
					-386,
					-621
				],
				[
					-92,
					-796
				],
				[
					-114,
					-258
				],
				[
					-33,
					-208
				],
				[
					-625,
					-46
				],
				[
					-5,
					1
				]
			],
			[
				[
					45272,
					64166
				],
				[
					13,
					267
				],
				[
					106,
					157
				],
				[
					91,
					300
				],
				[
					-18,
					195
				],
				[
					96,
					406
				],
				[
					155,
					366
				],
				[
					93,
					93
				],
				[
					74,
					336
				],
				[
					6,
					307
				],
				[
					100,
					356
				],
				[
					185,
					210
				],
				[
					177,
					588
				],
				[
					5,
					8
				],
				[
					139,
					221
				],
				[
					259,
					64
				],
				[
					218,
					393
				],
				[
					140,
					154
				],
				[
					232,
					481
				],
				[
					-70,
					716
				],
				[
					106,
					495
				],
				[
					37,
					304
				],
				[
					179,
					389
				],
				[
					278,
					263
				],
				[
					206,
					238
				],
				[
					186,
					596
				],
				[
					87,
					354
				],
				[
					205,
					-3
				],
				[
					167,
					-244
				],
				[
					264,
					39
				],
				[
					288,
					-127
				],
				[
					121,
					-6
				]
			],
			[
				[
					57394,
					79599
				],
				[
					66,
					85
				],
				[
					185,
					57
				],
				[
					204,
					-180
				],
				[
					115,
					-21
				],
				[
					125,
					-155
				],
				[
					-20,
					-195
				],
				[
					101,
					-95
				],
				[
					40,
					-240
				],
				[
					97,
					-147
				],
				[
					-19,
					-86
				],
				[
					52,
					-58
				],
				[
					-74,
					-43
				],
				[
					-164,
					17
				],
				[
					-27,
					80
				],
				[
					-58,
					-46
				],
				[
					20,
					-103
				],
				[
					-76,
					-184
				],
				[
					-49,
					-197
				],
				[
					-70,
					-63
				]
			],
			[
				[
					57842,
					78025
				],
				[
					-50,
					263
				],
				[
					30,
					246
				],
				[
					-9,
					253
				],
				[
					-160,
					342
				],
				[
					-89,
					243
				],
				[
					-86,
					171
				],
				[
					-84,
					56
				]
			],
			[
				[
					63761,
					44648
				],
				[
					74,
					-245
				],
				[
					69,
					-380
				],
				[
					45,
					-693
				],
				[
					72,
					-269
				],
				[
					-28,
					-277
				],
				[
					-49,
					-169
				],
				[
					-94,
					338
				],
				[
					-53,
					-171
				],
				[
					53,
					-427
				],
				[
					-24,
					-244
				],
				[
					-77,
					-133
				],
				[
					-18,
					-488
				],
				[
					-109,
					-671
				],
				[
					-137,
					-793
				],
				[
					-172,
					-1092
				],
				[
					-106,
					-800
				],
				[
					-125,
					-668
				],
				[
					-226,
					-136
				],
				[
					-243,
					-244
				],
				[
					-160,
					147
				],
				[
					-220,
					206
				],
				[
					-77,
					304
				],
				[
					-18,
					510
				],
				[
					-98,
					460
				],
				[
					-26,
					414
				],
				[
					50,
					415
				],
				[
					128,
					100
				],
				[
					1,
					191
				],
				[
					133,
					437
				],
				[
					25,
					367
				],
				[
					-65,
					272
				],
				[
					-52,
					364
				],
				[
					-23,
					530
				],
				[
					97,
					322
				],
				[
					38,
					366
				],
				[
					138,
					21
				],
				[
					155,
					118
				],
				[
					103,
					104
				],
				[
					122,
					8
				],
				[
					158,
					328
				],
				[
					229,
					355
				],
				[
					83,
					289
				],
				[
					-38,
					247
				],
				[
					118,
					-70
				],
				[
					153,
					401
				],
				[
					6,
					346
				],
				[
					92,
					257
				],
				[
					96,
					-247
				]
			],
			[
				[
					23016,
					66727
				],
				[
					-107,
					-505
				],
				[
					-49,
					-415
				],
				[
					-20,
					-771
				],
				[
					-27,
					-281
				],
				[
					48,
					-315
				],
				[
					86,
					-280
				],
				[
					56,
					-447
				],
				[
					184,
					-429
				],
				[
					65,
					-328
				],
				[
					109,
					-284
				],
				[
					295,
					-153
				],
				[
					114,
					-241
				],
				[
					244,
					161
				],
				[
					212,
					58
				],
				[
					208,
					104
				],
				[
					175,
					99
				],
				[
					176,
					235
				],
				[
					67,
					336
				],
				[
					22,
					483
				],
				[
					48,
					169
				],
				[
					188,
					151
				],
				[
					294,
					133
				],
				[
					246,
					-20
				],
				[
					169,
					49
				],
				[
					66,
					-122
				],
				[
					-9,
					-278
				],
				[
					-149,
					-342
				],
				[
					-66,
					-351
				],
				[
					51,
					-100
				],
				[
					-42,
					-249
				],
				[
					-69,
					-449
				],
				[
					-71,
					148
				],
				[
					-58,
					-10
				]
			],
			[
				[
					24381,
					60202
				],
				[
					-314,
					620
				],
				[
					-144,
					187
				],
				[
					-226,
					150
				],
				[
					-156,
					-42
				],
				[
					-223,
					-216
				],
				[
					-140,
					-57
				],
				[
					-196,
					152
				],
				[
					-208,
					109
				],
				[
					-260,
					264
				],
				[
					-208,
					81
				],
				[
					-314,
					268
				],
				[
					-233,
					275
				],
				[
					-70,
					154
				],
				[
					-155,
					34
				],
				[
					-284,
					183
				],
				[
					-116,
					262
				],
				[
					-299,
					327
				],
				[
					-139,
					363
				],
				[
					-66,
					281
				],
				[
					93,
					56
				],
				[
					-29,
					164
				],
				[
					64,
					150
				],
				[
					1,
					199
				],
				[
					-93,
					259
				],
				[
					-25,
					229
				],
				[
					-94,
					290
				],
				[
					-244,
					573
				],
				[
					-280,
					450
				],
				[
					-135,
					359
				],
				[
					-238,
					235
				],
				[
					-51,
					140
				],
				[
					42,
					356
				],
				[
					-142,
					135
				],
				[
					-164,
					279
				],
				[
					-69,
					402
				],
				[
					-149,
					47
				],
				[
					-162,
					303
				],
				[
					-130,
					281
				],
				[
					-12,
					180
				],
				[
					-149,
					434
				],
				[
					-99,
					441
				],
				[
					5,
					221
				],
				[
					-201,
					229
				],
				[
					-93,
					-26
				],
				[
					-159,
					159
				],
				[
					-44,
					-234
				],
				[
					46,
					-276
				],
				[
					27,
					-433
				],
				[
					95,
					-237
				],
				[
					206,
					-397
				],
				[
					46,
					-135
				],
				[
					42,
					-41
				],
				[
					37,
					-198
				],
				[
					49,
					8
				],
				[
					56,
					-372
				],
				[
					85,
					-146
				],
				[
					59,
					-204
				],
				[
					174,
					-293
				],
				[
					92,
					-536
				],
				[
					83,
					-252
				],
				[
					77,
					-270
				],
				[
					15,
					-304
				],
				[
					134,
					-19
				],
				[
					112,
					-261
				],
				[
					100,
					-257
				],
				[
					-6,
					-104
				],
				[
					-117,
					-211
				],
				[
					-49,
					3
				],
				[
					-74,
					350
				],
				[
					-181,
					328
				],
				[
					-201,
					278
				],
				[
					-142,
					147
				],
				[
					9,
					421
				],
				[
					-42,
					312
				],
				[
					-132,
					179
				],
				[
					-191,
					257
				],
				[
					-37,
					-75
				],
				[
					-70,
					151
				],
				[
					-171,
					139
				],
				[
					-164,
					334
				],
				[
					20,
					44
				],
				[
					115,
					-33
				],
				[
					103,
					215
				],
				[
					10,
					260
				],
				[
					-214,
					411
				],
				[
					-163,
					159
				],
				[
					-102,
					360
				],
				[
					-103,
					377
				],
				[
					-129,
					461
				],
				[
					-113,
					518
				]
			],
			[
				[
					17464,
					70566
				],
				[
					316,
					44
				],
				[
					353,
					63
				],
				[
					-26,
					-113
				],
				[
					419,
					-280
				],
				[
					634,
					-406
				],
				[
					552,
					5
				],
				[
					221,
					0
				],
				[
					0,
					237
				],
				[
					481,
					0
				],
				[
					102,
					-204
				],
				[
					142,
					-182
				],
				[
					165,
					-253
				],
				[
					92,
					-301
				],
				[
					69,
					-317
				],
				[
					144,
					-174
				],
				[
					230,
					-172
				],
				[
					175,
					455
				],
				[
					227,
					11
				],
				[
					196,
					-230
				],
				[
					139,
					-394
				],
				[
					96,
					-338
				],
				[
					164,
					-328
				],
				[
					61,
					-403
				],
				[
					78,
					-271
				],
				[
					217,
					-178
				],
				[
					197,
					-127
				],
				[
					108,
					17
				]
			],
			[
				[
					55993,
					76158
				],
				[
					95,
					33
				],
				[
					128,
					10
				]
			],
			[
				[
					46619,
					60247
				],
				[
					93,
					105
				],
				[
					47,
					339
				],
				[
					88,
					13
				],
				[
					194,
					-160
				],
				[
					157,
					114
				],
				[
					107,
					-38
				],
				[
					42,
					128
				],
				[
					1114,
					8
				],
				[
					62,
					404
				],
				[
					-48,
					71
				],
				[
					-134,
					2485
				],
				[
					-134,
					2485
				],
				[
					425,
					11
				]
			],
			[
				[
					51185,
					62860
				],
				[
					1,
					-1326
				],
				[
					-152,
					-384
				],
				[
					-24,
					-355
				],
				[
					-247,
					-92
				],
				[
					-379,
					-49
				],
				[
					-102,
					-205
				],
				[
					-178,
					-22
				]
			],
			[
				[
					46801,
					58995
				],
				[
					13,
					179
				],
				[
					-24,
					223
				],
				[
					-104,
					162
				],
				[
					-54,
					330
				],
				[
					-13,
					358
				]
			],
			[
				[
					77375,
					57550
				],
				[
					-27,
					427
				],
				[
					86,
					441
				],
				[
					-94,
					341
				],
				[
					23,
					627
				],
				[
					-113,
					299
				],
				[
					-90,
					689
				],
				[
					-50,
					727
				],
				[
					-121,
					477
				],
				[
					-183,
					-289
				],
				[
					-315,
					-410
				],
				[
					-156,
					51
				],
				[
					-172,
					135
				],
				[
					96,
					714
				],
				[
					-58,
					539
				],
				[
					-218,
					664
				],
				[
					34,
					208
				],
				[
					-163,
					74
				],
				[
					-197,
					469
				]
			],
			[
				[
					77809,
					63588
				],
				[
					-159,
					-134
				],
				[
					-162,
					-249
				],
				[
					-196,
					-26
				],
				[
					-127,
					-623
				],
				[
					-117,
					-104
				],
				[
					134,
					-506
				],
				[
					177,
					-420
				],
				[
					113,
					-380
				],
				[
					-101,
					-501
				],
				[
					-96,
					-106
				],
				[
					66,
					-289
				],
				[
					185,
					-458
				],
				[
					32,
					-321
				],
				[
					-4,
					-268
				],
				[
					108,
					-525
				],
				[
					-152,
					-537
				],
				[
					-135,
					-591
				]
			],
			[
				[
					55380,
					75946
				],
				[
					-58,
					44
				],
				[
					-78,
					188
				],
				[
					-120,
					115
				]
			],
			[
				[
					55338,
					76894
				],
				[
					74,
					-99
				],
				[
					40,
					-80
				],
				[
					91,
					-62
				],
				[
					106,
					-119
				],
				[
					-22,
					-50
				]
			],
			[
				[
					74375,
					80219
				],
				[
					292,
					99
				],
				[
					530,
					496
				],
				[
					423,
					271
				],
				[
					242,
					-176
				],
				[
					289,
					-9
				],
				[
					186,
					-269
				],
				[
					277,
					-21
				],
				[
					402,
					-144
				],
				[
					270,
					401
				],
				[
					-113,
					339
				],
				[
					288,
					596
				],
				[
					311,
					-238
				],
				[
					252,
					-67
				],
				[
					327,
					-148
				],
				[
					53,
					-432
				],
				[
					394,
					-242
				],
				[
					263,
					107
				],
				[
					351,
					75
				],
				[
					279,
					-76
				],
				[
					272,
					-276
				],
				[
					168,
					-295
				],
				[
					258,
					6
				],
				[
					350,
					-94
				],
				[
					255,
					143
				],
				[
					366,
					96
				],
				[
					407,
					405
				],
				[
					166,
					-62
				],
				[
					146,
					-193
				],
				[
					331,
					48
				]
			],
			[
				[
					59599,
					45195
				],
				[
					209,
					47
				],
				[
					334,
					-163
				],
				[
					73,
					73
				],
				[
					193,
					15
				],
				[
					99,
					173
				],
				[
					167,
					-10
				],
				[
					303,
					224
				],
				[
					221,
					334
				]
			],
			[
				[
					61198,
					45888
				],
				[
					45,
					-258
				],
				[
					-11,
					-574
				],
				[
					34,
					-505
				],
				[
					11,
					-900
				],
				[
					49,
					-282
				],
				[
					-83,
					-412
				],
				[
					-108,
					-400
				],
				[
					-177,
					-357
				],
				[
					-254,
					-219
				],
				[
					-313,
					-279
				],
				[
					-313,
					-618
				],
				[
					-107,
					-106
				],
				[
					-194,
					-409
				],
				[
					-115,
					-133
				],
				[
					-23,
					-411
				],
				[
					132,
					-436
				],
				[
					54,
					-337
				],
				[
					4,
					-173
				],
				[
					49,
					29
				],
				[
					-8,
					-565
				],
				[
					-45,
					-267
				],
				[
					65,
					-99
				],
				[
					-41,
					-239
				],
				[
					-116,
					-205
				],
				[
					-229,
					-195
				],
				[
					-334,
					-312
				],
				[
					-122,
					-213
				],
				[
					24,
					-242
				],
				[
					71,
					-39
				],
				[
					-24,
					-303
				]
			],
			[
				[
					59119,
					36429
				],
				[
					-211,
					5
				]
			],
			[
				[
					58908,
					36434
				],
				[
					-24,
					254
				],
				[
					-41,
					259
				]
			],
			[
				[
					58843,
					36947
				],
				[
					-23,
					206
				],
				[
					49,
					642
				],
				[
					-72,
					410
				],
				[
					-133,
					810
				]
			],
			[
				[
					58664,
					39015
				],
				[
					292,
					654
				],
				[
					74,
					415
				],
				[
					42,
					52
				],
				[
					31,
					339
				],
				[
					-45,
					171
				],
				[
					12,
					430
				],
				[
					54,
					400
				],
				[
					0,
					728
				],
				[
					-145,
					185
				],
				[
					-132,
					42
				],
				[
					-60,
					143
				],
				[
					-128,
					121
				],
				[
					-232,
					-11
				],
				[
					-18,
					215
				]
			],
			[
				[
					58409,
					42899
				],
				[
					-26,
					410
				],
				[
					843,
					474
				]
			],
			[
				[
					59226,
					43783
				],
				[
					159,
					-276
				],
				[
					77,
					53
				],
				[
					110,
					-146
				],
				[
					16,
					-231
				],
				[
					-59,
					-268
				],
				[
					21,
					-405
				],
				[
					181,
					-356
				],
				[
					85,
					399
				],
				[
					120,
					122
				],
				[
					-24,
					740
				],
				[
					-116,
					417
				],
				[
					-100,
					185
				],
				[
					-97,
					-8
				],
				[
					-77,
					748
				],
				[
					77,
					438
				]
			],
			[
				[
					46619,
					60247
				],
				[
					-184,
					395
				],
				[
					-168,
					424
				],
				[
					-184,
					153
				],
				[
					-133,
					169
				],
				[
					-155,
					-6
				],
				[
					-135,
					-126
				],
				[
					-138,
					50
				],
				[
					-96,
					-185
				]
			],
			[
				[
					45426,
					61121
				],
				[
					-24,
					311
				],
				[
					78,
					283
				],
				[
					34,
					543
				],
				[
					-30,
					569
				],
				[
					-34,
					286
				],
				[
					28,
					287
				],
				[
					-72,
					274
				],
				[
					-146,
					249
				]
			],
			[
				[
					45260,
					63923
				],
				[
					60,
					192
				],
				[
					1088,
					-4
				],
				[
					-53,
					832
				],
				[
					68,
					296
				],
				[
					261,
					51
				],
				[
					-9,
					1474
				],
				[
					911,
					-30
				],
				[
					1,
					872
				]
			],
			[
				[
					59226,
					43783
				],
				[
					-147,
					149
				],
				[
					85,
					535
				],
				[
					87,
					201
				],
				[
					-53,
					477
				],
				[
					56,
					467
				],
				[
					47,
					156
				],
				[
					-71,
					489
				],
				[
					-131,
					257
				]
			],
			[
				[
					59099,
					46514
				],
				[
					273,
					-108
				],
				[
					55,
					-159
				],
				[
					95,
					-269
				],
				[
					77,
					-783
				]
			],
			[
				[
					78372,
					55412
				],
				[
					64,
					-54
				],
				[
					164,
					-347
				],
				[
					116,
					-386
				],
				[
					16,
					-388
				],
				[
					-29,
					-262
				],
				[
					27,
					-198
				],
				[
					20,
					-340
				],
				[
					98,
					-159
				],
				[
					109,
					-509
				],
				[
					-5,
					-195
				],
				[
					-197,
					-38
				],
				[
					-263,
					426
				],
				[
					-329,
					457
				],
				[
					-32,
					294
				],
				[
					-161,
					385
				],
				[
					-38,
					477
				],
				[
					-100,
					314
				],
				[
					30,
					419
				],
				[
					-61,
					244
				]
			],
			[
				[
					77801,
					55552
				],
				[
					48,
					103
				],
				[
					227,
					-252
				],
				[
					22,
					-296
				],
				[
					183,
					69
				],
				[
					91,
					236
				]
			],
			[
				[
					80461,
					52985
				],
				[
					204,
					-198
				],
				[
					214,
					108
				],
				[
					56,
					488
				],
				[
					119,
					108
				],
				[
					333,
					125
				],
				[
					199,
					456
				],
				[
					137,
					364
				]
			],
			[
				[
					82069,
					54967
				],
				[
					214,
					400
				],
				[
					140,
					450
				],
				[
					112,
					2
				],
				[
					143,
					-291
				],
				[
					13,
					-251
				],
				[
					183,
					-160
				],
				[
					231,
					-173
				],
				[
					-20,
					-226
				],
				[
					-186,
					-29
				],
				[
					50,
					-281
				],
				[
					-205,
					-196
				]
			],
			[
				[
					54540,
					35373
				],
				[
					-207,
					435
				],
				[
					-108,
					420
				],
				[
					-62,
					561
				],
				[
					-68,
					417
				],
				[
					-93,
					887
				],
				[
					-7,
					689
				],
				[
					-35,
					314
				],
				[
					-108,
					237
				],
				[
					-144,
					476
				],
				[
					-146,
					691
				],
				[
					-60,
					361
				],
				[
					-226,
					563
				],
				[
					-17,
					441
				]
			],
			[
				[
					56448,
					41738
				],
				[
					228,
					131
				],
				[
					180,
					-33
				],
				[
					109,
					-130
				],
				[
					2,
					-48
				]
			],
			[
				[
					55526,
					37566
				],
				[
					0,
					-2127
				],
				[
					-248,
					-294
				],
				[
					-149,
					-42
				],
				[
					-175,
					108
				],
				[
					-125,
					42
				],
				[
					-47,
					247
				],
				[
					-109,
					157
				],
				[
					-133,
					-284
				]
			],
			[
				[
					96049,
					39690
				],
				[
					228,
					-357
				],
				[
					144,
					-265
				],
				[
					-105,
					-138
				],
				[
					-153,
					155
				],
				[
					-199,
					259
				],
				[
					-179,
					306
				],
				[
					-184,
					406
				],
				[
					-38,
					195
				],
				[
					119,
					-8
				],
				[
					156,
					-196
				],
				[
					122,
					-196
				],
				[
					89,
					-161
				]
			],
			[
				[
					54125,
					64996
				],
				[
					68,
					-895
				],
				[
					104,
					-150
				],
				[
					4,
					-183
				],
				[
					116,
					-198
				],
				[
					-60,
					-248
				],
				[
					-107,
					-1168
				],
				[
					-15,
					-749
				],
				[
					-354,
					-543
				],
				[
					-120,
					-759
				],
				[
					115,
					-213
				],
				[
					0,
					-371
				],
				[
					178,
					-13
				],
				[
					-28,
					-271
				]
			],
			[
				[
					53939,
					59018
				],
				[
					-52,
					-12
				],
				[
					-188,
					630
				],
				[
					-65,
					23
				],
				[
					-217,
					-322
				],
				[
					-215,
					168
				],
				[
					-150,
					34
				],
				[
					-80,
					-81
				],
				[
					-163,
					17
				],
				[
					-164,
					-245
				],
				[
					-141,
					-14
				],
				[
					-337,
					298
				],
				[
					-131,
					-142
				],
				[
					-142,
					10
				],
				[
					-104,
					218
				],
				[
					-279,
					214
				],
				[
					-298,
					-68
				],
				[
					-72,
					-124
				],
				[
					-39,
					-331
				],
				[
					-80,
					-233
				],
				[
					-19,
					-514
				]
			],
			[
				[
					52361,
					54577
				],
				[
					-289,
					-207
				],
				[
					-105,
					30
				],
				[
					-107,
					-129
				],
				[
					-222,
					13
				],
				[
					-149,
					360
				],
				[
					-91,
					417
				],
				[
					-197,
					379
				],
				[
					-209,
					-7
				],
				[
					-245,
					1
				]
			],
			[
				[
					26191,
					58215
				],
				[
					-96,
					181
				],
				[
					-130,
					233
				],
				[
					-61,
					194
				],
				[
					-117,
					181
				],
				[
					-140,
					260
				],
				[
					31,
					89
				],
				[
					46,
					-87
				],
				[
					21,
					41
				]
			],
			[
				[
					26903,
					60465
				],
				[
					-24,
					-55
				],
				[
					-14,
					-129
				],
				[
					29,
					-210
				],
				[
					-64,
					-197
				],
				[
					-30,
					-231
				],
				[
					-9,
					-254
				],
				[
					15,
					-148
				],
				[
					7,
					-260
				],
				[
					-43,
					-56
				],
				[
					-26,
					-247
				],
				[
					19,
					-152
				],
				[
					-56,
					-147
				],
				[
					12,
					-156
				],
				[
					43,
					-94
				]
			],
			[
				[
					50920,
					81398
				],
				[
					143,
					159
				],
				[
					244,
					847
				],
				[
					380,
					241
				],
				[
					231,
					-16
				]
			],
			[
				[
					58639,
					91887
				],
				[
					-473,
					-231
				],
				[
					-224,
					-54
				]
			],
			[
				[
					55734,
					91626
				],
				[
					-172,
					-23
				],
				[
					-41,
					-379
				],
				[
					-523,
					92
				],
				[
					-74,
					-321
				],
				[
					-267,
					2
				],
				[
					-183,
					-409
				],
				[
					-278,
					-639
				],
				[
					-431,
					-810
				],
				[
					101,
					-197
				],
				[
					-97,
					-228
				],
				[
					-275,
					10
				],
				[
					-180,
					-540
				],
				[
					17,
					-765
				],
				[
					177,
					-292
				],
				[
					-92,
					-677
				],
				[
					-231,
					-395
				],
				[
					-122,
					-332
				]
			],
			[
				[
					53063,
					85723
				],
				[
					-187,
					354
				],
				[
					-548,
					-666
				],
				[
					-371,
					-135
				],
				[
					-384,
					293
				],
				[
					-99,
					619
				],
				[
					-88,
					1329
				],
				[
					256,
					371
				],
				[
					733,
					483
				],
				[
					549,
					595
				],
				[
					508,
					802
				],
				[
					668,
					1112
				],
				[
					465,
					434
				],
				[
					763,
					722
				],
				[
					610,
					252
				],
				[
					457,
					-31
				],
				[
					423,
					477
				],
				[
					506,
					-25
				],
				[
					499,
					115
				],
				[
					869,
					-422
				],
				[
					-358,
					-154
				],
				[
					305,
					-361
				]
			],
			[
				[
					56867,
					96664
				],
				[
					-620,
					-236
				],
				[
					-490,
					134
				],
				[
					191,
					149
				],
				[
					-167,
					184
				],
				[
					575,
					115
				],
				[
					110,
					-216
				],
				[
					401,
					-130
				]
			],
			[
				[
					55069,
					97728
				],
				[
					915,
					-429
				],
				[
					-699,
					-227
				],
				[
					-155,
					-424
				],
				[
					-243,
					-108
				],
				[
					-132,
					-478
				],
				[
					-335,
					-22
				],
				[
					-598,
					351
				],
				[
					252,
					205
				],
				[
					-416,
					166
				],
				[
					-541,
					487
				],
				[
					-216,
					451
				],
				[
					757,
					206
				],
				[
					152,
					-202
				],
				[
					396,
					8
				],
				[
					105,
					197
				],
				[
					408,
					20
				],
				[
					350,
					-201
				]
			],
			[
				[
					57068,
					98134
				],
				[
					545,
					-202
				],
				[
					-412,
					-310
				],
				[
					-806,
					-68
				],
				[
					-819,
					96
				],
				[
					-50,
					159
				],
				[
					-398,
					10
				],
				[
					-304,
					264
				],
				[
					858,
					161
				],
				[
					403,
					-138
				],
				[
					281,
					172
				],
				[
					702,
					-144
				]
			],
			[
				[
					98060,
					28265
				],
				[
					63,
					-238
				],
				[
					198,
					233
				],
				[
					80,
					-243
				],
				[
					0,
					-242
				],
				[
					-103,
					-267
				],
				[
					-182,
					-424
				],
				[
					-142,
					-232
				],
				[
					103,
					-277
				],
				[
					-214,
					-7
				],
				[
					-238,
					-217
				],
				[
					-75,
					-377
				],
				[
					-157,
					-583
				],
				[
					-219,
					-257
				],
				[
					-138,
					-164
				],
				[
					-256,
					12
				],
				[
					-180,
					190
				],
				[
					-302,
					40
				],
				[
					-46,
					212
				],
				[
					149,
					427
				],
				[
					349,
					568
				],
				[
					179,
					109
				],
				[
					200,
					219
				],
				[
					238,
					301
				],
				[
					167,
					299
				],
				[
					123,
					429
				],
				[
					106,
					146
				],
				[
					41,
					321
				],
				[
					195,
					267
				],
				[
					61,
					-245
				]
			],
			[
				[
					98502,
					31008
				],
				[
					202,
					-607
				],
				[
					5,
					394
				],
				[
					126,
					-158
				],
				[
					41,
					-435
				],
				[
					224,
					-188
				],
				[
					188,
					-46
				],
				[
					158,
					220
				],
				[
					141,
					-67
				],
				[
					-67,
					-511
				],
				[
					-85,
					-336
				],
				[
					-212,
					12
				],
				[
					-74,
					-175
				],
				[
					26,
					-248
				],
				[
					-41,
					-107
				],
				[
					-105,
					-310
				],
				[
					-138,
					-395
				],
				[
					-214,
					-229
				],
				[
					-48,
					151
				],
				[
					-116,
					83
				],
				[
					160,
					474
				],
				[
					-91,
					317
				],
				[
					-299,
					230
				],
				[
					8,
					209
				],
				[
					201,
					200
				],
				[
					47,
					444
				],
				[
					-13,
					372
				],
				[
					-113,
					386
				],
				[
					8,
					102
				],
				[
					-133,
					237
				],
				[
					-218,
					510
				],
				[
					-117,
					408
				],
				[
					104,
					45
				],
				[
					151,
					-320
				],
				[
					216,
					-149
				],
				[
					78,
					-513
				]
			],
			[
				[
					64752,
					61418
				],
				[
					-91,
					403
				],
				[
					-217,
					950
				]
			],
			[
				[
					64444,
					62771
				],
				[
					833,
					576
				],
				[
					185,
					1152
				],
				[
					-127,
					408
				]
			],
			[
				[
					65665,
					66183
				],
				[
					125,
					-393
				],
				[
					155,
					-209
				],
				[
					203,
					-76
				],
				[
					165,
					-105
				],
				[
					125,
					-330
				],
				[
					75,
					-191
				],
				[
					100,
					-73
				],
				[
					-1,
					-128
				],
				[
					-101,
					-344
				],
				[
					-44,
					-161
				],
				[
					-117,
					-184
				],
				[
					-104,
					-395
				],
				[
					-126,
					30
				],
				[
					-58,
					-137
				],
				[
					-44,
					-292
				],
				[
					34,
					-385
				],
				[
					-26,
					-71
				],
				[
					-128,
					2
				],
				[
					-174,
					-215
				],
				[
					-27,
					-281
				],
				[
					-63,
					-121
				],
				[
					-173,
					4
				],
				[
					-109,
					-145
				],
				[
					1,
					-232
				],
				[
					-134,
					-160
				],
				[
					-153,
					54
				],
				[
					-186,
					-194
				],
				[
					-128,
					-33
				]
			],
			[
				[
					65575,
					66834
				],
				[
					80,
					196
				],
				[
					35,
					-50
				],
				[
					-26,
					-238
				],
				[
					-37,
					-104
				]
			],
			[
				[
					68937,
					65473
				],
				[
					-203,
					146
				],
				[
					-83,
					414
				],
				[
					-215,
					438
				],
				[
					-512,
					-108
				],
				[
					-451,
					-11
				],
				[
					-391,
					-81
				]
			],
			[
				[
					28366,
					55989
				],
				[
					-93,
					166
				],
				[
					-59,
					311
				],
				[
					68,
					154
				],
				[
					-70,
					40
				],
				[
					-52,
					190
				],
				[
					-138,
					160
				],
				[
					-122,
					-37
				],
				[
					-56,
					-200
				],
				[
					-112,
					-145
				],
				[
					-61,
					-20
				],
				[
					-27,
					-120
				],
				[
					132,
					-312
				],
				[
					-75,
					-74
				],
				[
					-40,
					-85
				],
				[
					-130,
					-29
				],
				[
					-48,
					344
				],
				[
					-36,
					-98
				],
				[
					-92,
					33
				],
				[
					-56,
					232
				],
				[
					-114,
					38
				],
				[
					-72,
					68
				],
				[
					-119,
					-1
				],
				[
					-8,
					-125
				],
				[
					-32,
					87
				]
			],
			[
				[
					27070,
					57338
				],
				[
					100,
					-206
				],
				[
					-6,
					-122
				],
				[
					111,
					-26
				],
				[
					26,
					47
				],
				[
					77,
					-142
				],
				[
					136,
					42
				],
				[
					119,
					145
				],
				[
					168,
					116
				],
				[
					95,
					172
				],
				[
					153,
					-33
				],
				[
					-10,
					-57
				],
				[
					155,
					-20
				],
				[
					124,
					-99
				],
				[
					90,
					-173
				],
				[
					105,
					-159
				]
			],
			[
				[
					30452,
					41263
				],
				[
					-279,
					331
				],
				[
					-24,
					236
				],
				[
					-551,
					578
				],
				[
					-498,
					630
				],
				[
					-214,
					355
				],
				[
					-115,
					476
				],
				[
					46,
					166
				],
				[
					-236,
					755
				],
				[
					-274,
					1063
				],
				[
					-262,
					1147
				],
				[
					-114,
					262
				],
				[
					-87,
					424
				],
				[
					-216,
					376
				],
				[
					-198,
					233
				],
				[
					90,
					257
				],
				[
					-134,
					550
				],
				[
					86,
					403
				],
				[
					221,
					364
				]
			],
			[
				[
					85104,
					56675
				],
				[
					28,
					-382
				],
				[
					16,
					-323
				],
				[
					-94,
					-527
				],
				[
					-102,
					587
				],
				[
					-130,
					-292
				],
				[
					89,
					-425
				],
				[
					-79,
					-270
				],
				[
					-327,
					335
				],
				[
					-78,
					416
				],
				[
					84,
					274
				],
				[
					-176,
					273
				],
				[
					-87,
					-239
				],
				[
					-131,
					22
				],
				[
					-205,
					-321
				],
				[
					-46,
					168
				],
				[
					109,
					486
				],
				[
					175,
					161
				],
				[
					151,
					217
				],
				[
					98,
					-260
				],
				[
					212,
					157
				],
				[
					45,
					257
				],
				[
					196,
					16
				],
				[
					-16,
					445
				],
				[
					225,
					-273
				],
				[
					23,
					-290
				],
				[
					20,
					-212
				]
			],
			[
				[
					84439,
					57749
				],
				[
					-100,
					-190
				],
				[
					-87,
					-363
				],
				[
					-87,
					-171
				],
				[
					-171,
					398
				],
				[
					57,
					154
				],
				[
					70,
					162
				],
				[
					30,
					357
				],
				[
					153,
					34
				],
				[
					-44,
					-388
				],
				[
					205,
					556
				],
				[
					-26,
					-549
				]
			],
			[
				[
					82917,
					57194
				],
				[
					-369,
					-546
				],
				[
					136,
					403
				],
				[
					200,
					355
				],
				[
					167,
					399
				],
				[
					146,
					572
				],
				[
					49,
					-470
				],
				[
					-183,
					-317
				],
				[
					-146,
					-396
				]
			],
			[
				[
					83856,
					58678
				],
				[
					166,
					-179
				],
				[
					177,
					1
				],
				[
					-5,
					-240
				],
				[
					-129,
					-245
				],
				[
					-176,
					-173
				],
				[
					-10,
					268
				],
				[
					20,
					293
				],
				[
					-43,
					275
				]
			],
			[
				[
					84861,
					58834
				],
				[
					78,
					-643
				],
				[
					-214,
					152
				],
				[
					5,
					-193
				],
				[
					68,
					-355
				],
				[
					-132,
					-129
				],
				[
					-11,
					405
				],
				[
					-84,
					30
				],
				[
					-43,
					348
				],
				[
					163,
					-46
				],
				[
					-4,
					218
				],
				[
					-169,
					440
				],
				[
					266,
					-13
				],
				[
					77,
					-214
				]
			],
			[
				[
					83757,
					59356
				],
				[
					-74,
					-498
				],
				[
					-119,
					288
				],
				[
					-142,
					438
				],
				[
					238,
					-21
				],
				[
					97,
					-207
				]
			],
			[
				[
					83700,
					62485
				],
				[
					171,
					-164
				],
				[
					85,
					150
				],
				[
					26,
					-146
				],
				[
					-46,
					-239
				],
				[
					95,
					-413
				],
				[
					-73,
					-478
				],
				[
					-164,
					-191
				],
				[
					-43,
					-465
				],
				[
					62,
					-458
				],
				[
					147,
					-64
				],
				[
					123,
					68
				],
				[
					347,
					-319
				],
				[
					-27,
					-313
				],
				[
					91,
					-139
				],
				[
					-29,
					-265
				],
				[
					-216,
					283
				],
				[
					-103,
					302
				],
				[
					-71,
					-211
				],
				[
					-177,
					345
				],
				[
					-253,
					-86
				],
				[
					-138,
					128
				],
				[
					14,
					238
				],
				[
					87,
					146
				],
				[
					-83,
					133
				],
				[
					-36,
					-207
				],
				[
					-137,
					331
				],
				[
					-41,
					251
				],
				[
					-11,
					551
				],
				[
					112,
					-190
				],
				[
					29,
					901
				],
				[
					90,
					522
				],
				[
					169,
					-1
				]
			],
			[
				[
					93299,
					47902
				],
				[
					-78,
					-58
				],
				[
					-120,
					221
				],
				[
					-122,
					366
				],
				[
					-59,
					439
				],
				[
					38,
					55
				],
				[
					30,
					-171
				],
				[
					84,
					-130
				],
				[
					135,
					-366
				],
				[
					131,
					-195
				],
				[
					-39,
					-161
				]
			],
			[
				[
					92217,
					48675
				],
				[
					-146,
					-48
				],
				[
					-44,
					-161
				],
				[
					-152,
					-140
				],
				[
					-142,
					-135
				],
				[
					-148,
					1
				],
				[
					-228,
					167
				],
				[
					-158,
					161
				],
				[
					23,
					178
				],
				[
					249,
					-84
				],
				[
					152,
					45
				],
				[
					42,
					276
				],
				[
					40,
					14
				],
				[
					27,
					-306
				],
				[
					158,
					44
				],
				[
					78,
					197
				],
				[
					155,
					206
				],
				[
					-30,
					339
				],
				[
					166,
					11
				],
				[
					56,
					-94
				],
				[
					-5,
					-320
				],
				[
					-93,
					-351
				]
			],
			[
				[
					89166,
					50332
				],
				[
					482,
					-397
				],
				[
					513,
					-329
				],
				[
					192,
					-295
				],
				[
					154,
					-290
				],
				[
					43,
					-339
				],
				[
					462,
					-356
				],
				[
					68,
					-306
				],
				[
					-256,
					-62
				],
				[
					62,
					-383
				],
				[
					248,
					-378
				],
				[
					180,
					-611
				],
				[
					159,
					19
				],
				[
					-11,
					-255
				],
				[
					215,
					-98
				],
				[
					-84,
					-108
				],
				[
					295,
					-243
				],
				[
					-30,
					-166
				],
				[
					-184,
					-40
				],
				[
					-69,
					149
				],
				[
					-238,
					65
				],
				[
					-281,
					86
				],
				[
					-216,
					368
				],
				[
					-158,
					316
				],
				[
					-144,
					504
				],
				[
					-362,
					252
				],
				[
					-235,
					-164
				],
				[
					-170,
					-190
				],
				[
					35,
					-425
				],
				[
					-218,
					-198
				],
				[
					-155,
					96
				],
				[
					-288,
					25
				]
			],
			[
				[
					92538,
					49238
				],
				[
					-87,
					-154
				],
				[
					-52,
					340
				],
				[
					-65,
					223
				],
				[
					-126,
					189
				],
				[
					-158,
					245
				],
				[
					-200,
					170
				],
				[
					77,
					139
				],
				[
					150,
					-162
				],
				[
					94,
					-126
				],
				[
					117,
					-139
				],
				[
					111,
					-241
				],
				[
					106,
					-185
				],
				[
					33,
					-299
				]
			],
			[
				[
					53922,
					82787
				],
				[
					189,
					169
				],
				[
					434,
					266
				],
				[
					350,
					195
				],
				[
					277,
					-97
				],
				[
					21,
					-140
				],
				[
					268,
					-8
				]
			],
			[
				[
					55461,
					83172
				],
				[
					342,
					-65
				],
				[
					511,
					9
				]
			],
			[
				[
					56535,
					81532
				],
				[
					139,
					-502
				],
				[
					-29,
					-162
				],
				[
					-138,
					-67
				],
				[
					-252,
					-479
				],
				[
					71,
					-259
				],
				[
					-60,
					34
				]
			],
			[
				[
					56266,
					80097
				],
				[
					-264,
					221
				],
				[
					-200,
					-81
				],
				[
					-131,
					59
				],
				[
					-165,
					-123
				],
				[
					-140,
					204
				],
				[
					-114,
					-78
				],
				[
					-16,
					34
				]
			],
			[
				[
					31588,
					62492
				],
				[
					142,
					-51
				],
				[
					50,
					-114
				],
				[
					-71,
					-146
				],
				[
					-209,
					4
				],
				[
					-163,
					-21
				],
				[
					-16,
					247
				],
				[
					40,
					84
				],
				[
					227,
					-3
				]
			],
			[
				[
					86288,
					76244
				],
				[
					39,
					-101
				]
			],
			[
				[
					86327,
					76143
				],
				[
					-106,
					35
				],
				[
					-120,
					-195
				],
				[
					-83,
					-196
				],
				[
					10,
					-414
				],
				[
					-143,
					-127
				],
				[
					-50,
					-102
				],
				[
					-104,
					-170
				],
				[
					-185,
					-95
				],
				[
					-121,
					-154
				],
				[
					-9,
					-250
				],
				[
					-32,
					-63
				],
				[
					111,
					-94
				],
				[
					157,
					-253
				]
			],
			[
				[
					85048,
					73569
				],
				[
					-135,
					109
				],
				[
					-34,
					-108
				],
				[
					-81,
					-48
				],
				[
					-10,
					109
				],
				[
					-72,
					52
				],
				[
					-75,
					92
				],
				[
					76,
					254
				],
				[
					66,
					67
				],
				[
					-25,
					105
				],
				[
					71,
					311
				],
				[
					-18,
					94
				],
				[
					-163,
					63
				],
				[
					-131,
					154
				]
			],
			[
				[
					47929,
					73193
				],
				[
					-112,
					-149
				],
				[
					-146,
					81
				],
				[
					-143,
					-64
				],
				[
					42,
					451
				],
				[
					-26,
					354
				],
				[
					-124,
					53
				],
				[
					-67,
					218
				],
				[
					22,
					377
				],
				[
					111,
					210
				],
				[
					20,
					232
				],
				[
					58,
					347
				],
				[
					-6,
					244
				],
				[
					-56,
					206
				],
				[
					-12,
					195
				]
			],
			[
				[
					64113,
					66085
				],
				[
					-18,
					419
				],
				[
					75,
					302
				],
				[
					76,
					62
				],
				[
					84,
					-180
				],
				[
					5,
					-337
				],
				[
					-61,
					-339
				]
			],
			[
				[
					64274,
					66012
				],
				[
					-77,
					-41
				],
				[
					-84,
					114
				]
			],
			[
				[
					56308,
					79404
				],
				[
					120,
					123
				],
				[
					172,
					-64
				],
				[
					178,
					-2
				],
				[
					129,
					-141
				],
				[
					95,
					89
				],
				[
					205,
					55
				],
				[
					69,
					135
				],
				[
					118,
					0
				]
			],
			[
				[
					57842,
					78025
				],
				[
					124,
					-106
				],
				[
					131,
					93
				],
				[
					126,
					-99
				]
			],
			[
				[
					58223,
					77913
				],
				[
					6,
					-149
				],
				[
					-135,
					-124
				],
				[
					-84,
					54
				],
				[
					-78,
					-694
				]
			],
			[
				[
					56293,
					77303
				],
				[
					-51,
					101
				],
				[
					65,
					97
				],
				[
					-69,
					72
				],
				[
					-87,
					-129
				],
				[
					-162,
					167
				],
				[
					-22,
					237
				],
				[
					-169,
					136
				],
				[
					-31,
					183
				],
				[
					-151,
					226
				]
			],
			[
				[
					89901,
					81054
				],
				[
					280,
					-1020
				],
				[
					-411,
					190
				],
				[
					-171,
					-832
				],
				[
					271,
					-590
				],
				[
					-8,
					-403
				],
				[
					-211,
					347
				],
				[
					-182,
					-445
				],
				[
					-51,
					483
				],
				[
					31,
					561
				],
				[
					-32,
					621
				],
				[
					64,
					436
				],
				[
					13,
					770
				],
				[
					-163,
					566
				],
				[
					24,
					787
				],
				[
					257,
					265
				],
				[
					-110,
					267
				],
				[
					123,
					81
				],
				[
					73,
					-381
				],
				[
					96,
					-555
				],
				[
					-7,
					-567
				],
				[
					114,
					-581
				]
			],
			[
				[
					55461,
					83172
				],
				[
					63,
					254
				],
				[
					383,
					186
				]
			],
			[
				[
					99999,
					92620
				],
				[
					-305,
					-29
				],
				[
					-49,
					183
				],
				[
					-99645,
					240
				],
				[
					36,
					24
				],
				[
					235,
					-1
				],
				[
					402,
					-165
				],
				[
					-24,
					-79
				],
				[
					-286,
					-138
				],
				[
					-363,
					-35
				],
				[
					99999,
					0
				]
			],
			[
				[
					89889,
					93991
				],
				[
					-421,
					-4
				],
				[
					-569,
					64
				],
				[
					-49,
					31
				],
				[
					263,
					227
				],
				[
					348,
					54
				],
				[
					394,
					-221
				],
				[
					34,
					-151
				]
			],
			[
				[
					91869,
					95069
				],
				[
					-321,
					-228
				],
				[
					-444,
					52
				],
				[
					-516,
					227
				],
				[
					66,
					187
				],
				[
					518,
					-87
				],
				[
					697,
					-151
				]
			],
			[
				[
					90301,
					95344
				],
				[
					-219,
					-427
				],
				[
					-1023,
					16
				],
				[
					-461,
					-136
				],
				[
					-550,
					374
				],
				[
					149,
					396
				],
				[
					366,
					108
				],
				[
					734,
					-25
				],
				[
					1004,
					-306
				]
			],
			[
				[
					65981,
					92556
				],
				[
					-164,
					-51
				],
				[
					-907,
					75
				],
				[
					-74,
					256
				],
				[
					-503,
					154
				],
				[
					-40,
					311
				],
				[
					284,
					124
				],
				[
					-10,
					314
				],
				[
					551,
					491
				],
				[
					-255,
					70
				],
				[
					665,
					506
				],
				[
					-75,
					261
				],
				[
					621,
					304
				],
				[
					917,
					370
				],
				[
					925,
					108
				],
				[
					475,
					214
				],
				[
					541,
					74
				],
				[
					193,
					-227
				],
				[
					-187,
					-179
				],
				[
					-984,
					-286
				],
				[
					-848,
					-274
				],
				[
					-863,
					-548
				],
				[
					-414,
					-563
				],
				[
					-435,
					-553
				],
				[
					56,
					-479
				],
				[
					531,
					-472
				]
			],
			[
				[
					63639,
					78550
				],
				[
					-127,
					-342
				],
				[
					-269,
					-95
				],
				[
					-276,
					-594
				],
				[
					252,
					-547
				],
				[
					-27,
					-388
				],
				[
					303,
					-678
				]
			],
			[
				[
					61098,
					76843
				],
				[
					-354,
					486
				],
				[
					-317,
					218
				],
				[
					-240,
					338
				],
				[
					202,
					92
				],
				[
					231,
					482
				],
				[
					-156,
					227
				],
				[
					410,
					236
				],
				[
					-8,
					125
				],
				[
					-249,
					-92
				]
			],
			[
				[
					60617,
					78955
				],
				[
					9,
					255
				],
				[
					143,
					161
				],
				[
					269,
					42
				],
				[
					44,
					192
				],
				[
					-62,
					318
				],
				[
					113,
					302
				],
				[
					-3,
					169
				],
				[
					-410,
					187
				],
				[
					-162,
					-6
				],
				[
					-172,
					270
				],
				[
					-213,
					-92
				],
				[
					-352,
					203
				],
				[
					6,
					113
				],
				[
					-99,
					250
				],
				[
					-222,
					28
				],
				[
					-23,
					178
				],
				[
					70,
					117
				],
				[
					-178,
					326
				],
				[
					-288,
					-56
				],
				[
					-84,
					29
				],
				[
					-70,
					-131
				],
				[
					-104,
					24
				]
			],
			[
				[
					57772,
					86080
				],
				[
					316,
					318
				],
				[
					-291,
					274
				]
			],
			[
				[
					58639,
					91887
				],
				[
					286,
					200
				],
				[
					456,
					-348
				],
				[
					761,
					-137
				],
				[
					1050,
					-652
				],
				[
					213,
					-273
				],
				[
					18,
					-384
				],
				[
					-308,
					-302
				],
				[
					-454,
					-154
				],
				[
					-1240,
					438
				],
				[
					-204,
					-73
				],
				[
					453,
					-422
				],
				[
					18,
					-267
				],
				[
					18,
					-589
				],
				[
					358,
					-175
				],
				[
					217,
					-150
				],
				[
					36,
					279
				],
				[
					-168,
					248
				],
				[
					177,
					218
				],
				[
					672,
					-358
				],
				[
					233,
					140
				],
				[
					-186,
					422
				],
				[
					647,
					564
				],
				[
					256,
					-33
				],
				[
					260,
					-202
				],
				[
					161,
					396
				],
				[
					-231,
					343
				],
				[
					136,
					345
				],
				[
					-204,
					357
				],
				[
					777,
					-185
				],
				[
					158,
					-322
				],
				[
					-351,
					-71
				],
				[
					1,
					-321
				],
				[
					219,
					-197
				],
				[
					429,
					125
				],
				[
					68,
					367
				],
				[
					580,
					274
				],
				[
					970,
					495
				],
				[
					209,
					-28
				],
				[
					-273,
					-350
				],
				[
					344,
					-60
				],
				[
					199,
					197
				],
				[
					521,
					16
				],
				[
					412,
					239
				],
				[
					317,
					-347
				],
				[
					315,
					381
				],
				[
					-291,
					334
				],
				[
					145,
					190
				],
				[
					820,
					-175
				],
				[
					385,
					-180
				],
				[
					1006,
					-658
				],
				[
					186,
					302
				],
				[
					-282,
					304
				],
				[
					-8,
					122
				],
				[
					-335,
					57
				],
				[
					92,
					273
				],
				[
					-149,
					449
				],
				[
					-8,
					185
				],
				[
					512,
					521
				],
				[
					183,
					523
				],
				[
					206,
					114
				],
				[
					736,
					-152
				],
				[
					57,
					-320
				],
				[
					-263,
					-468
				],
				[
					173,
					-183
				],
				[
					89,
					-403
				],
				[
					-63,
					-789
				],
				[
					307,
					-353
				],
				[
					-120,
					-384
				],
				[
					-544,
					-818
				],
				[
					318,
					-85
				],
				[
					110,
					207
				],
				[
					306,
					148
				],
				[
					74,
					285
				],
				[
					240,
					274
				],
				[
					-162,
					328
				],
				[
					130,
					380
				],
				[
					-304,
					47
				],
				[
					-67,
					321
				],
				[
					222,
					578
				],
				[
					-361,
					469
				],
				[
					497,
					389
				],
				[
					-64,
					409
				],
				[
					139,
					13
				],
				[
					145,
					-319
				],
				[
					-109,
					-556
				],
				[
					297,
					-105
				],
				[
					-127,
					415
				],
				[
					465,
					227
				],
				[
					577,
					30
				],
				[
					513,
					-328
				],
				[
					-247,
					479
				],
				[
					-28,
					614
				],
				[
					483,
					116
				],
				[
					669,
					-25
				],
				[
					602,
					75
				],
				[
					-226,
					301
				],
				[
					321,
					378
				],
				[
					319,
					16
				],
				[
					540,
					286
				],
				[
					734,
					77
				],
				[
					93,
					157
				],
				[
					729,
					54
				],
				[
					227,
					-129
				],
				[
					624,
					306
				],
				[
					510,
					-10
				],
				[
					77,
					249
				],
				[
					265,
					245
				],
				[
					656,
					236
				],
				[
					476,
					-186
				],
				[
					-378,
					-142
				],
				[
					629,
					-89
				],
				[
					75,
					-284
				],
				[
					254,
					140
				],
				[
					812,
					-8
				],
				[
					626,
					-281
				],
				[
					223,
					-215
				],
				[
					-69,
					-300
				],
				[
					-307,
					-170
				],
				[
					-730,
					-320
				],
				[
					-209,
					-171
				],
				[
					345,
					-80
				],
				[
					410,
					-146
				],
				[
					251,
					109
				],
				[
					141,
					-369
				],
				[
					122,
					149
				],
				[
					444,
					91
				],
				[
					892,
					-95
				],
				[
					67,
					-269
				],
				[
					1162,
					-86
				],
				[
					15,
					440
				],
				[
					590,
					-101
				],
				[
					443,
					3
				],
				[
					449,
					-303
				],
				[
					128,
					-369
				],
				[
					-165,
					-241
				],
				[
					349,
					-453
				],
				[
					437,
					-234
				],
				[
					268,
					605
				],
				[
					446,
					-260
				],
				[
					473,
					155
				],
				[
					538,
					-177
				],
				[
					204,
					162
				],
				[
					455,
					-81
				],
				[
					-201,
					534
				],
				[
					367,
					250
				],
				[
					2509,
					-374
				],
				[
					236,
					-342
				],
				[
					727,
					-440
				],
				[
					1122,
					109
				],
				[
					553,
					-95
				],
				[
					231,
					-238
				],
				[
					-33,
					-421
				],
				[
					342,
					-164
				],
				[
					372,
					118
				],
				[
					492,
					15
				],
				[
					525,
					-113
				],
				[
					526,
					64
				],
				[
					484,
					-512
				],
				[
					344,
					184
				],
				[
					-224,
					368
				],
				[
					123,
					256
				],
				[
					886,
					-161
				],
				[
					578,
					34
				],
				[
					799,
					-275
				],
				[
					-99610,
					-251
				],
				[
					681,
					-440
				],
				[
					728,
					-572
				],
				[
					-24,
					-358
				],
				[
					187,
					-143
				],
				[
					-64,
					418
				],
				[
					754,
					-86
				],
				[
					544,
					-539
				],
				[
					-276,
					-251
				],
				[
					-455,
					-59
				],
				[
					-7,
					-563
				],
				[
					-111,
					-120
				],
				[
					-260,
					17
				],
				[
					-212,
					201
				],
				[
					-369,
					168
				],
				[
					-62,
					250
				],
				[
					-283,
					94
				],
				[
					-315,
					-74
				],
				[
					-151,
					201
				],
				[
					60,
					214
				],
				[
					-333,
					-137
				],
				[
					126,
					-271
				],
				[
					-158,
					-244
				],
				[
					0,
					-3
				],
				[
					99640,
					-253
				],
				[
					-360,
					42
				],
				[
					250,
					-307
				],
				[
					166,
					-474
				],
				[
					128,
					-155
				],
				[
					32,
					-238
				],
				[
					-71,
					-153
				],
				[
					-518,
					126
				],
				[
					-777,
					-434
				],
				[
					-247,
					-67
				],
				[
					-425,
					-405
				],
				[
					-403,
					-353
				],
				[
					-102,
					-262
				],
				[
					-397,
					399
				],
				[
					-724,
					-453
				],
				[
					-126,
					214
				],
				[
					-268,
					-246
				],
				[
					-371,
					79
				],
				[
					-90,
					-379
				],
				[
					-333,
					-557
				],
				[
					10,
					-233
				],
				[
					316,
					-129
				],
				[
					-37,
					-839
				],
				[
					-258,
					-21
				],
				[
					-119,
					-482
				],
				[
					116,
					-248
				],
				[
					-486,
					-294
				],
				[
					-96,
					-657
				],
				[
					-415,
					-141
				],
				[
					-83,
					-585
				],
				[
					-400,
					-536
				],
				[
					-103,
					396
				],
				[
					-119,
					841
				],
				[
					-155,
					1279
				],
				[
					134,
					799
				],
				[
					234,
					344
				],
				[
					14,
					269
				],
				[
					432,
					129
				],
				[
					496,
					725
				],
				[
					479,
					592
				],
				[
					499,
					459
				],
				[
					223,
					812
				],
				[
					-337,
					-49
				],
				[
					-167,
					-474
				],
				[
					-705,
					-632
				],
				[
					-227,
					708
				],
				[
					-717,
					-196
				],
				[
					-696,
					-965
				],
				[
					230,
					-353
				],
				[
					-620,
					-151
				],
				[
					-430,
					-59
				],
				[
					20,
					417
				],
				[
					-431,
					87
				],
				[
					-344,
					-283
				],
				[
					-850,
					99
				],
				[
					-914,
					-171
				],
				[
					-899,
					-1124
				],
				[
					-1065,
					-1358
				],
				[
					438,
					-73
				],
				[
					136,
					-360
				],
				[
					270,
					-128
				],
				[
					178,
					288
				],
				[
					305,
					-38
				],
				[
					401,
					-633
				],
				[
					9,
					-490
				],
				[
					-217,
					-576
				],
				[
					-23,
					-687
				],
				[
					-126,
					-921
				],
				[
					-418,
					-833
				],
				[
					-94,
					-399
				],
				[
					-377,
					-670
				],
				[
					-374,
					-665
				],
				[
					-179,
					-340
				],
				[
					-370,
					-338
				],
				[
					-175,
					-8
				],
				[
					-175,
					280
				],
				[
					-373,
					-421
				],
				[
					-43,
					-192
				]
			],
			[
				[
					79187,
					96925
				],
				[
					-1566,
					-222
				],
				[
					507,
					756
				],
				[
					229,
					64
				],
				[
					208,
					-37
				],
				[
					704,
					-327
				],
				[
					-82,
					-234
				]
			],
			[
				[
					64204,
					98215
				],
				[
					-373,
					-76
				],
				[
					-250,
					-44
				],
				[
					-39,
					-94
				],
				[
					-324,
					-95
				],
				[
					-301,
					136
				],
				[
					158,
					180
				],
				[
					-618,
					17
				],
				[
					542,
					105
				],
				[
					422,
					7
				],
				[
					57,
					-155
				],
				[
					159,
					138
				],
				[
					262,
					95
				],
				[
					412,
					-126
				],
				[
					-107,
					-88
				]
			],
			[
				[
					77760,
					97255
				],
				[
					-606,
					-71
				],
				[
					-773,
					166
				],
				[
					-462,
					220
				],
				[
					-213,
					413
				],
				[
					-379,
					113
				],
				[
					722,
					394
				],
				[
					600,
					130
				],
				[
					540,
					-290
				],
				[
					640,
					-557
				],
				[
					-69,
					-518
				]
			],
			[
				[
					58449,
					51176
				],
				[
					110,
					-325
				],
				[
					-16,
					-339
				],
				[
					-80,
					-73
				]
			],
			[
				[
					58216,
					51057
				],
				[
					67,
					-59
				],
				[
					166,
					178
				]
			],
			[
				[
					45260,
					63923
				],
				[
					12,
					243
				]
			],
			[
				[
					61883,
					61244
				],
				[
					-37,
					246
				],
				[
					-83,
					173
				],
				[
					-22,
					230
				],
				[
					-143,
					206
				],
				[
					-148,
					483
				],
				[
					-79,
					469
				],
				[
					-192,
					397
				],
				[
					-124,
					94
				],
				[
					-184,
					549
				],
				[
					-32,
					400
				],
				[
					12,
					342
				],
				[
					-159,
					638
				],
				[
					-130,
					225
				],
				[
					-150,
					119
				],
				[
					-92,
					330
				],
				[
					15,
					130
				],
				[
					-77,
					299
				],
				[
					-81,
					128
				],
				[
					-108,
					429
				],
				[
					-170,
					464
				],
				[
					-141,
					395
				],
				[
					-139,
					-2
				],
				[
					44,
					316
				],
				[
					12,
					201
				],
				[
					34,
					230
				]
			],
			[
				[
					63448,
					68272
				],
				[
					109,
					-497
				],
				[
					137,
					-131
				],
				[
					47,
					-203
				],
				[
					190,
					-242
				],
				[
					16,
					-237
				],
				[
					-27,
					-192
				],
				[
					35,
					-193
				],
				[
					80,
					-162
				],
				[
					37,
					-189
				],
				[
					41,
					-141
				]
			],
			[
				[
					64274,
					66012
				],
				[
					53,
					-220
				]
			],
			[
				[
					64444,
					62771
				],
				[
					-801,
					-221
				],
				[
					-259,
					-259
				],
				[
					-199,
					-604
				],
				[
					-130,
					-96
				],
				[
					-70,
					191
				],
				[
					-106,
					-28
				],
				[
					-269,
					57
				],
				[
					-50,
					58
				],
				[
					-321,
					-13
				],
				[
					-75,
					-52
				],
				[
					-114,
					149
				],
				[
					-74,
					-283
				],
				[
					28,
					-243
				],
				[
					-121,
					-183
				]
			],
			[
				[
					59434,
					57280
				],
				[
					-39,
					11
				],
				[
					5,
					287
				],
				[
					-33,
					197
				],
				[
					-143,
					228
				],
				[
					-34,
					415
				],
				[
					34,
					425
				],
				[
					-129,
					40
				],
				[
					-19,
					-129
				],
				[
					-167,
					-29
				],
				[
					67,
					-169
				],
				[
					23,
					-346
				],
				[
					-152,
					-316
				],
				[
					-138,
					-415
				],
				[
					-144,
					-59
				],
				[
					-233,
					336
				],
				[
					-105,
					-119
				],
				[
					-29,
					-168
				],
				[
					-143,
					-109
				],
				[
					-9,
					-118
				],
				[
					-277,
					0
				],
				[
					-38,
					118
				],
				[
					-200,
					20
				],
				[
					-100,
					-99
				],
				[
					-77,
					50
				],
				[
					-143,
					336
				],
				[
					-48,
					158
				],
				[
					-200,
					-79
				],
				[
					-76,
					-267
				],
				[
					-72,
					-514
				],
				[
					-95,
					-109
				],
				[
					-85,
					-63
				]
			],
			[
				[
					56635,
					56793
				],
				[
					-23,
					27
				]
			],
			[
				[
					56351,
					58246
				],
				[
					3,
					140
				],
				[
					-102,
					169
				],
				[
					-3,
					335
				],
				[
					-58,
					222
				],
				[
					-98,
					-33
				],
				[
					28,
					211
				],
				[
					72,
					240
				],
				[
					-32,
					239
				],
				[
					92,
					176
				],
				[
					-58,
					135
				],
				[
					73,
					355
				],
				[
					127,
					425
				],
				[
					240,
					-41
				],
				[
					-14,
					2286
				]
			],
			[
				[
					60240,
					64499
				],
				[
					90,
					-565
				],
				[
					-61,
					-105
				],
				[
					40,
					-593
				],
				[
					102,
					-687
				],
				[
					106,
					-142
				],
				[
					152,
					-213
				]
			],
			[
				[
					59433,
					57348
				],
				[
					1,
					-68
				]
			],
			[
				[
					59434,
					57280
				],
				[
					3,
					-449
				]
			],
			[
				[
					59445,
					54277
				],
				[
					-171,
					-265
				],
				[
					-195,
					1
				],
				[
					-224,
					-135
				],
				[
					-176,
					129
				],
				[
					-115,
					-157
				]
			],
			[
				[
					56824,
					56568
				],
				[
					-189,
					225
				]
			],
			[
				[
					45357,
					59658
				],
				[
					-115,
					449
				],
				[
					-138,
					205
				],
				[
					122,
					109
				],
				[
					134,
					404
				],
				[
					66,
					296
				]
			],
			[
				[
					45367,
					58962
				],
				[
					-46,
					441
				]
			],
			[
				[
					95032,
					45793
				],
				[
					78,
					-198
				],
				[
					-194,
					3
				],
				[
					-106,
					355
				],
				[
					166,
					-140
				],
				[
					56,
					-20
				]
			],
			[
				[
					94680,
					46144
				],
				[
					-108,
					-13
				],
				[
					-170,
					58
				],
				[
					-58,
					89
				],
				[
					17,
					228
				],
				[
					183,
					-90
				],
				[
					91,
					-121
				],
				[
					45,
					-151
				]
			],
			[
				[
					94910,
					46301
				],
				[
					-42,
					-106
				],
				[
					-206,
					499
				],
				[
					-57,
					344
				],
				[
					94,
					0
				],
				[
					100,
					-461
				],
				[
					111,
					-276
				]
			],
			[
				[
					94409,
					47028
				],
				[
					12,
					-116
				],
				[
					-218,
					245
				],
				[
					-152,
					206
				],
				[
					-104,
					192
				],
				[
					41,
					59
				],
				[
					128,
					-138
				],
				[
					228,
					-265
				],
				[
					65,
					-183
				]
			],
			[
				[
					93760,
					47598
				],
				[
					-56,
					-33
				],
				[
					-121,
					131
				],
				[
					-114,
					237
				],
				[
					14,
					96
				],
				[
					166,
					-243
				],
				[
					111,
					-188
				]
			],
			[
				[
					46822,
					55737
				],
				[
					-75,
					43
				],
				[
					-200,
					232
				],
				[
					-144,
					308
				],
				[
					-49,
					211
				],
				[
					-34,
					425
				]
			],
			[
				[
					25613,
					59537
				],
				[
					-31,
					-135
				],
				[
					-161,
					8
				],
				[
					-100,
					55
				],
				[
					-115,
					115
				],
				[
					-154,
					36
				],
				[
					-79,
					123
				]
			],
			[
				[
					61984,
					58430
				],
				[
					91,
					-106
				],
				[
					54,
					-238
				],
				[
					125,
					-241
				],
				[
					138,
					-2
				],
				[
					262,
					147
				],
				[
					302,
					68
				],
				[
					245,
					179
				],
				[
					138,
					38
				],
				[
					99,
					105
				],
				[
					158,
					20
				]
			],
			[
				[
					63596,
					58400
				],
				[
					-2,
					-9
				],
				[
					-1,
					-237
				],
				[
					0,
					-581
				],
				[
					0,
					-301
				],
				[
					-125,
					-353
				],
				[
					-194,
					-481
				]
			],
			[
				[
					63596,
					58400
				],
				[
					89,
					12
				],
				[
					128,
					85
				],
				[
					147,
					58
				],
				[
					132,
					198
				],
				[
					105,
					1
				],
				[
					6,
					-159
				],
				[
					-25,
					-335
				],
				[
					1,
					-303
				],
				[
					-59,
					-208
				],
				[
					-78,
					-622
				],
				[
					-134,
					-644
				],
				[
					-172,
					-735
				],
				[
					-238,
					-844
				],
				[
					-237,
					-645
				],
				[
					-327,
					-785
				],
				[
					-278,
					-467
				],
				[
					-415,
					-571
				],
				[
					-259,
					-438
				],
				[
					-304,
					-698
				],
				[
					-64,
					-304
				],
				[
					-63,
					-136
				]
			],
			[
				[
					34125,
					55269
				],
				[
					333,
					-115
				],
				[
					30,
					104
				],
				[
					225,
					41
				],
				[
					298,
					-155
				]
			],
			[
				[
					34889,
					54255
				],
				[
					109,
					-341
				],
				[
					-49,
					-248
				],
				[
					-24,
					-263
				],
				[
					-71,
					-242
				]
			],
			[
				[
					56266,
					80097
				],
				[
					-77,
					-150
				],
				[
					-55,
					-232
				]
			],
			[
				[
					53809,
					78032
				],
				[
					62,
					52
				]
			],
			[
				[
					56639,
					89841
				],
				[
					-478,
					-163
				],
				[
					-269,
					-401
				],
				[
					43,
					-353
				],
				[
					-441,
					-463
				],
				[
					-537,
					-495
				],
				[
					-202,
					-811
				],
				[
					198,
					-406
				],
				[
					265,
					-320
				],
				[
					-255,
					-649
				],
				[
					-289,
					-135
				],
				[
					-106,
					-967
				],
				[
					-157,
					-539
				],
				[
					-337,
					55
				],
				[
					-158,
					-456
				],
				[
					-321,
					-27
				],
				[
					-89,
					545
				],
				[
					-232,
					653
				],
				[
					-211,
					814
				]
			],
			[
				[
					58908,
					36434
				],
				[
					-56,
					-256
				],
				[
					-163,
					-62
				],
				[
					-166,
					312
				],
				[
					-2,
					199
				],
				[
					76,
					216
				],
				[
					26,
					168
				],
				[
					80,
					41
				],
				[
					140,
					-105
				]
			],
			[
				[
					59999,
					71781
				],
				[
					-26,
					440
				],
				[
					68,
					237
				]
			],
			[
				[
					60041,
					72458
				],
				[
					74,
					126
				],
				[
					75,
					127
				],
				[
					15,
					321
				],
				[
					91,
					-112
				],
				[
					306,
					160
				],
				[
					147,
					-108
				],
				[
					229,
					1
				],
				[
					320,
					217
				],
				[
					149,
					-10
				],
				[
					316,
					89
				]
			],
			[
				[
					50518,
					55366
				],
				[
					-224,
					-122
				]
			],
			[
				[
					78495,
					58847
				],
				[
					-249,
					265
				],
				[
					-238,
					-11
				],
				[
					41,
					452
				],
				[
					-245,
					-3
				],
				[
					-22,
					-633
				],
				[
					-150,
					-841
				],
				[
					-90,
					-509
				],
				[
					19,
					-417
				],
				[
					181,
					-18
				],
				[
					113,
					-526
				],
				[
					50,
					-498
				],
				[
					155,
					-330
				],
				[
					168,
					-67
				],
				[
					144,
					-299
				]
			],
			[
				[
					77801,
					55552
				],
				[
					-110,
					221
				],
				[
					-47,
					285
				],
				[
					-148,
					325
				],
				[
					-135,
					274
				],
				[
					-45,
					-339
				],
				[
					-53,
					320
				],
				[
					30,
					359
				],
				[
					82,
					553
				]
			],
			[
				[
					68841,
					73220
				],
				[
					156,
					583
				],
				[
					-60,
					429
				],
				[
					-204,
					137
				],
				[
					72,
					254
				],
				[
					232,
					-27
				],
				[
					132,
					318
				],
				[
					89,
					370
				],
				[
					371,
					134
				],
				[
					-58,
					-267
				],
				[
					40,
					-161
				],
				[
					114,
					15
				]
			],
			[
				[
					64978,
					73251
				],
				[
					-52,
					408
				],
				[
					40,
					602
				],
				[
					-216,
					195
				],
				[
					71,
					394
				],
				[
					-184,
					34
				],
				[
					61,
					485
				],
				[
					262,
					-141
				],
				[
					244,
					184
				],
				[
					-202,
					346
				],
				[
					-80,
					329
				],
				[
					-224,
					-147
				],
				[
					-28,
					-422
				],
				[
					-87,
					374
				]
			],
			[
				[
					65546,
					75618
				],
				[
					313,
					8
				],
				[
					-45,
					290
				],
				[
					237,
					199
				],
				[
					234,
					334
				],
				[
					374,
					-304
				],
				[
					30,
					-460
				],
				[
					106,
					-118
				],
				[
					301,
					27
				],
				[
					93,
					-105
				],
				[
					137,
					-593
				],
				[
					317,
					-398
				],
				[
					181,
					-271
				],
				[
					291,
					-282
				],
				[
					369,
					-247
				],
				[
					-7,
					-352
				]
			],
			[
				[
					84713,
					46708
				],
				[
					32,
					136
				],
				[
					239,
					129
				],
				[
					194,
					20
				],
				[
					87,
					72
				],
				[
					105,
					-72
				],
				[
					-102,
					-156
				],
				[
					-289,
					-252
				],
				[
					-233,
					-165
				]
			],
			[
				[
					32866,
					58026
				],
				[
					160,
					75
				],
				[
					58,
					-20
				],
				[
					-11,
					-430
				],
				[
					-232,
					-63
				],
				[
					-50,
					52
				],
				[
					81,
					158
				],
				[
					-6,
					228
				]
			],
			[
				[
					52339,
					73106
				],
				[
					302,
					232
				],
				[
					195,
					-69
				],
				[
					-9,
					-291
				],
				[
					236,
					212
				],
				[
					20,
					-111
				],
				[
					-139,
					-282
				],
				[
					-2,
					-266
				],
				[
					96,
					-143
				],
				[
					-36,
					-499
				],
				[
					-183,
					-289
				],
				[
					53,
					-314
				],
				[
					143,
					-10
				],
				[
					70,
					-274
				],
				[
					106,
					-90
				]
			],
			[
				[
					60041,
					72458
				],
				[
					-102,
					261
				],
				[
					105,
					217
				],
				[
					-169,
					-49
				],
				[
					-233,
					132
				],
				[
					-191,
					-331
				],
				[
					-421,
					-65
				],
				[
					-225,
					309
				],
				[
					-300,
					19
				],
				[
					-64,
					-238
				],
				[
					-192,
					-69
				],
				[
					-268,
					307
				],
				[
					-303,
					-11
				],
				[
					-165,
					573
				],
				[
					-203,
					320
				],
				[
					135,
					447
				],
				[
					-176,
					276
				],
				[
					308,
					550
				],
				[
					428,
					23
				],
				[
					117,
					438
				],
				[
					529,
					-76
				],
				[
					334,
					373
				],
				[
					324,
					163
				],
				[
					459,
					13
				],
				[
					485,
					-406
				],
				[
					399,
					-223
				],
				[
					323,
					89
				],
				[
					239,
					-52
				],
				[
					328,
					301
				]
			],
			[
				[
					57776,
					76021
				],
				[
					33,
					-222
				],
				[
					243,
					-186
				],
				[
					-51,
					-141
				],
				[
					-330,
					-32
				],
				[
					-118,
					-178
				],
				[
					-232,
					-310
				],
				[
					-87,
					268
				],
				[
					3,
					119
				]
			],
			[
				[
					83826,
					65878
				],
				[
					-167,
					-924
				],
				[
					-119,
					-472
				],
				[
					-146,
					486
				],
				[
					-32,
					427
				],
				[
					163,
					566
				],
				[
					223,
					436
				],
				[
					127,
					-172
				],
				[
					-49,
					-347
				]
			],
			[
				[
					60889,
					49136
				],
				[
					-128,
					-710
				],
				[
					16,
					-326
				],
				[
					178,
					-210
				],
				[
					8,
					-149
				],
				[
					-76,
					-348
				],
				[
					16,
					-175
				],
				[
					-18,
					-275
				],
				[
					97,
					-361
				],
				[
					115,
					-568
				],
				[
					101,
					-126
				]
			],
			[
				[
					59099,
					46514
				],
				[
					-157,
					172
				],
				[
					-177,
					97
				],
				[
					-111,
					97
				],
				[
					-116,
					146
				]
			],
			[
				[
					58449,
					51176
				],
				[
					98,
					69
				],
				[
					304,
					-7
				],
				[
					566,
					44
				]
			],
			[
				[
					60617,
					78955
				],
				[
					-222,
					-46
				],
				[
					-185,
					-187
				],
				[
					-260,
					-30
				],
				[
					-239,
					-215
				],
				[
					16,
					-358
				],
				[
					136,
					-139
				],
				[
					284,
					35
				],
				[
					-55,
					-206
				],
				[
					-304,
					-100
				],
				[
					-377,
					-333
				],
				[
					-154,
					117
				],
				[
					61,
					271
				],
				[
					-304,
					169
				],
				[
					50,
					110
				],
				[
					265,
					191
				],
				[
					-80,
					132
				],
				[
					-432,
					146
				],
				[
					-19,
					215
				],
				[
					-257,
					-71
				],
				[
					-103,
					-317
				],
				[
					-215,
					-426
				]
			],
			[
				[
					35174,
					32383
				],
				[
					-121,
					-362
				],
				[
					-313,
					-320
				],
				[
					-205,
					115
				],
				[
					-151,
					-62
				],
				[
					-256,
					247
				],
				[
					-189,
					-18
				],
				[
					-169,
					319
				]
			],
			[
				[
					6794,
					62819
				],
				[
					-41,
					-96
				],
				[
					-69,
					82
				],
				[
					8,
					161
				],
				[
					-46,
					210
				],
				[
					14,
					64
				],
				[
					48,
					94
				],
				[
					-19,
					113
				],
				[
					16,
					54
				],
				[
					21,
					-11
				],
				[
					107,
					-97
				],
				[
					49,
					-50
				],
				[
					45,
					-77
				],
				[
					71,
					-202
				],
				[
					-7,
					-32
				],
				[
					-108,
					-123
				],
				[
					-89,
					-90
				]
			],
			[
				[
					6645,
					63718
				],
				[
					-94,
					-41
				],
				[
					-47,
					121
				],
				[
					-32,
					47
				],
				[
					-3,
					36
				],
				[
					27,
					49
				],
				[
					99,
					-55
				],
				[
					73,
					-88
				],
				[
					-23,
					-69
				]
			],
			[
				[
					6456,
					64025
				],
				[
					-9,
					-63
				],
				[
					-149,
					17
				],
				[
					21,
					70
				],
				[
					137,
					-24
				]
			],
			[
				[
					6207,
					64108
				],
				[
					-15,
					-33
				],
				[
					-19,
					8
				],
				[
					-97,
					20
				],
				[
					-35,
					130
				],
				[
					-11,
					23
				],
				[
					74,
					80
				],
				[
					23,
					-37
				],
				[
					80,
					-191
				]
			],
			[
				[
					5737,
					64488
				],
				[
					-33,
					-57
				],
				[
					-93,
					105
				],
				[
					14,
					42
				],
				[
					43,
					57
				],
				[
					64,
					-13
				],
				[
					5,
					-134
				]
			],
			[
				[
					31350,
					77823
				],
				[
					48,
					-189
				],
				[
					-296,
					-279
				],
				[
					-286,
					-198
				],
				[
					-293,
					-171
				],
				[
					-147,
					-342
				],
				[
					-47,
					-129
				],
				[
					-3,
					-306
				],
				[
					92,
					-305
				],
				[
					115,
					-14
				],
				[
					-29,
					210
				],
				[
					83,
					-128
				],
				[
					-22,
					-165
				],
				[
					-188,
					-93
				],
				[
					-133,
					11
				],
				[
					-205,
					-100
				],
				[
					-121,
					-29
				],
				[
					-162,
					-28
				],
				[
					-231,
					-167
				],
				[
					408,
					108
				],
				[
					82,
					-109
				],
				[
					-389,
					-173
				],
				[
					-177,
					-1
				],
				[
					8,
					71
				],
				[
					-84,
					-160
				],
				[
					82,
					-26
				],
				[
					-60,
					-414
				],
				[
					-203,
					-443
				],
				[
					-20,
					148
				],
				[
					-61,
					30
				],
				[
					-91,
					144
				],
				[
					57,
					-310
				],
				[
					69,
					-103
				],
				[
					5,
					-217
				],
				[
					-89,
					-224
				],
				[
					-157,
					-460
				],
				[
					-25,
					23
				],
				[
					86,
					392
				],
				[
					-142,
					220
				],
				[
					-33,
					478
				],
				[
					-53,
					-249
				],
				[
					59,
					-365
				],
				[
					-183,
					90
				],
				[
					191,
					-185
				],
				[
					12,
					-548
				],
				[
					79,
					-40
				],
				[
					29,
					-199
				],
				[
					39,
					-577
				],
				[
					-176,
					-427
				],
				[
					-288,
					-171
				],
				[
					-182,
					-338
				],
				[
					-139,
					-37
				],
				[
					-141,
					-211
				],
				[
					-39,
					-193
				],
				[
					-305,
					-374
				],
				[
					-157,
					-274
				],
				[
					-131,
					-342
				],
				[
					-43,
					-409
				],
				[
					50,
					-400
				],
				[
					92,
					-492
				],
				[
					124,
					-408
				],
				[
					1,
					-249
				],
				[
					132,
					-668
				],
				[
					-9,
					-388
				],
				[
					-12,
					-224
				],
				[
					-69,
					-352
				],
				[
					-83,
					-73
				],
				[
					-137,
					70
				],
				[
					-44,
					253
				],
				[
					-105,
					132
				],
				[
					-148,
					496
				],
				[
					-129,
					440
				],
				[
					-42,
					225
				],
				[
					57,
					383
				],
				[
					-77,
					316
				],
				[
					-217,
					482
				],
				[
					-108,
					89
				],
				[
					-281,
					-262
				],
				[
					-49,
					29
				],
				[
					-135,
					269
				],
				[
					-174,
					142
				],
				[
					-314,
					-72
				],
				[
					-247,
					63
				],
				[
					-212,
					-39
				],
				[
					-114,
					-90
				],
				[
					50,
					-153
				],
				[
					-5,
					-234
				],
				[
					59,
					-113
				],
				[
					-53,
					-76
				],
				[
					-103,
					85
				],
				[
					-104,
					-109
				],
				[
					-202,
					17
				],
				[
					-207,
					305
				],
				[
					-242,
					-72
				],
				[
					-202,
					133
				],
				[
					-173,
					-40
				],
				[
					-234,
					-135
				],
				[
					-253,
					-427
				],
				[
					-276,
					-248
				],
				[
					-152,
					-275
				],
				[
					-63,
					-259
				],
				[
					-3,
					-397
				],
				[
					14,
					-277
				],
				[
					52,
					-196
				]
			],
			[
				[
					17464,
					70566
				],
				[
					-46,
					294
				],
				[
					-180,
					331
				],
				[
					-130,
					69
				],
				[
					-30,
					165
				],
				[
					-156,
					29
				],
				[
					-100,
					156
				],
				[
					-258,
					57
				],
				[
					-71,
					93
				],
				[
					-33,
					316
				],
				[
					-270,
					578
				],
				[
					-231,
					801
				],
				[
					10,
					133
				],
				[
					-123,
					190
				],
				[
					-215,
					483
				],
				[
					-38,
					469
				],
				[
					-148,
					315
				],
				[
					61,
					477
				],
				[
					-10,
					494
				],
				[
					-89,
					441
				],
				[
					109,
					543
				],
				[
					34,
					523
				],
				[
					33,
					522
				],
				[
					-50,
					773
				],
				[
					-88,
					492
				],
				[
					-80,
					268
				],
				[
					33,
					112
				],
				[
					402,
					-195
				],
				[
					148,
					-544
				],
				[
					69,
					152
				],
				[
					-45,
					472
				],
				[
					-94,
					473
				]
			],
			[
				[
					7498,
					84721
				],
				[
					-277,
					-219
				],
				[
					-142,
					148
				],
				[
					-43,
					270
				],
				[
					252,
					205
				],
				[
					148,
					88
				],
				[
					185,
					-39
				],
				[
					117,
					-179
				],
				[
					-240,
					-274
				]
			],
			[
				[
					4006,
					86330
				],
				[
					-171,
					-89
				],
				[
					-182,
					107
				],
				[
					-168,
					157
				],
				[
					274,
					98
				],
				[
					220,
					-52
				],
				[
					27,
					-221
				]
			],
			[
				[
					2297,
					88560
				],
				[
					171,
					-109
				],
				[
					173,
					59
				],
				[
					225,
					-152
				],
				[
					276,
					-77
				],
				[
					-23,
					-63
				],
				[
					-211,
					-121
				],
				[
					-211,
					125
				],
				[
					-106,
					104
				],
				[
					-245,
					-33
				],
				[
					-66,
					51
				],
				[
					17,
					216
				]
			],
			[
				[
					13740,
					83389
				],
				[
					-153,
					217
				],
				[
					-245,
					183
				],
				[
					-78,
					503
				],
				[
					-358,
					466
				],
				[
					-150,
					543
				],
				[
					-267,
					38
				],
				[
					-441,
					14
				],
				[
					-326,
					165
				],
				[
					-574,
					598
				],
				[
					-266,
					109
				],
				[
					-486,
					206
				],
				[
					-385,
					-49
				],
				[
					-546,
					264
				],
				[
					-330,
					246
				],
				[
					-309,
					-122
				],
				[
					58,
					-400
				],
				[
					-154,
					-37
				],
				[
					-321,
					-120
				],
				[
					-245,
					-195
				],
				[
					-308,
					-122
				],
				[
					-39,
					339
				],
				[
					125,
					565
				],
				[
					295,
					177
				],
				[
					-76,
					145
				],
				[
					-354,
					-321
				],
				[
					-190,
					-383
				],
				[
					-400,
					-410
				],
				[
					203,
					-280
				],
				[
					-262,
					-413
				],
				[
					-299,
					-241
				],
				[
					-278,
					-176
				],
				[
					-69,
					-255
				],
				[
					-434,
					-297
				],
				[
					-87,
					-271
				],
				[
					-325,
					-246
				],
				[
					-191,
					44
				],
				[
					-259,
					-160
				],
				[
					-282,
					-196
				],
				[
					-231,
					-193
				],
				[
					-477,
					-164
				],
				[
					-43,
					96
				],
				[
					304,
					270
				],
				[
					271,
					177
				],
				[
					296,
					315
				],
				[
					345,
					65
				],
				[
					137,
					236
				],
				[
					385,
					345
				],
				[
					62,
					115
				],
				[
					205,
					204
				],
				[
					48,
					437
				],
				[
					141,
					340
				],
				[
					-320,
					-175
				],
				[
					-90,
					99
				],
				[
					-150,
					-209
				],
				[
					-181,
					292
				],
				[
					-75,
					-207
				],
				[
					-104,
					287
				],
				[
					-278,
					-230
				],
				[
					-170,
					0
				],
				[
					-24,
					343
				],
				[
					50,
					211
				],
				[
					-179,
					205
				],
				[
					-361,
					-110
				],
				[
					-235,
					270
				],
				[
					-190,
					138
				],
				[
					-1,
					327
				],
				[
					-214,
					245
				],
				[
					108,
					331
				],
				[
					226,
					322
				],
				[
					99,
					295
				],
				[
					225,
					42
				],
				[
					191,
					-92
				],
				[
					224,
					278
				],
				[
					201,
					-50
				],
				[
					212,
					179
				],
				[
					-52,
					263
				],
				[
					-155,
					104
				],
				[
					205,
					222
				],
				[
					-170,
					-7
				],
				[
					-295,
					-125
				],
				[
					-85,
					-127
				],
				[
					-219,
					127
				],
				[
					-392,
					-65
				],
				[
					-407,
					138
				],
				[
					-117,
					232
				],
				[
					-351,
					334
				],
				[
					390,
					241
				],
				[
					620,
					282
				],
				[
					228,
					0
				],
				[
					-38,
					-288
				],
				[
					586,
					22
				],
				[
					-225,
					357
				],
				[
					-342,
					219
				],
				[
					-197,
					288
				],
				[
					-267,
					246
				],
				[
					-381,
					182
				],
				[
					155,
					302
				],
				[
					493,
					19
				],
				[
					350,
					262
				],
				[
					66,
					280
				],
				[
					284,
					274
				],
				[
					271,
					66
				],
				[
					526,
					256
				],
				[
					256,
					-39
				],
				[
					427,
					307
				],
				[
					421,
					-121
				],
				[
					201,
					-260
				],
				[
					123,
					112
				],
				[
					469,
					-35
				],
				[
					-16,
					-132
				],
				[
					425,
					-98
				],
				[
					283,
					57
				],
				[
					585,
					-182
				],
				[
					534,
					-54
				],
				[
					214,
					-75
				],
				[
					370,
					94
				],
				[
					421,
					-173
				],
				[
					302,
					-81
				]
			],
			[
				[
					30185,
					58611
				],
				[
					-8,
					-136
				],
				[
					-163,
					-67
				],
				[
					91,
					-262
				],
				[
					-3,
					-301
				],
				[
					-123,
					-334
				],
				[
					105,
					-457
				],
				[
					120,
					37
				],
				[
					62,
					417
				],
				[
					-86,
					202
				],
				[
					-14,
					436
				],
				[
					346,
					234
				],
				[
					-38,
					272
				],
				[
					97,
					181
				],
				[
					100,
					-404
				],
				[
					195,
					-10
				],
				[
					180,
					-321
				],
				[
					11,
					-190
				],
				[
					249,
					-6
				],
				[
					297,
					60
				],
				[
					159,
					-258
				],
				[
					213,
					-71
				],
				[
					155,
					180
				],
				[
					4,
					145
				],
				[
					344,
					34
				],
				[
					333,
					8
				],
				[
					-236,
					-170
				],
				[
					95,
					-272
				],
				[
					222,
					-43
				],
				[
					210,
					-283
				],
				[
					45,
					-462
				],
				[
					144,
					13
				],
				[
					109,
					-135
				]
			],
			[
				[
					80013,
					64241
				],
				[
					-371,
					-493
				],
				[
					-231,
					-544
				],
				[
					-61,
					-399
				],
				[
					212,
					-607
				],
				[
					260,
					-753
				],
				[
					252,
					-356
				],
				[
					169,
					-462
				],
				[
					127,
					-1066
				],
				[
					-37,
					-1013
				],
				[
					-232,
					-379
				],
				[
					-318,
					-371
				],
				[
					-227,
					-480
				],
				[
					-346,
					-536
				],
				[
					-101,
					369
				],
				[
					78,
					390
				],
				[
					-206,
					327
				]
			],
			[
				[
					96623,
					42347
				],
				[
					-92,
					-76
				],
				[
					-93,
					252
				],
				[
					10,
					155
				],
				[
					175,
					-331
				]
			],
			[
				[
					96418,
					43229
				],
				[
					45,
					-464
				],
				[
					-75,
					72
				],
				[
					-58,
					-31
				],
				[
					-39,
					159
				],
				[
					-6,
					441
				],
				[
					133,
					-177
				]
			],
			[
				[
					64752,
					61418
				],
				[
					-201,
					-154
				],
				[
					-54,
					-256
				],
				[
					-6,
					-196
				],
				[
					-277,
					-244
				],
				[
					-444,
					-268
				],
				[
					-249,
					-406
				],
				[
					-122,
					-32
				],
				[
					-83,
					34
				],
				[
					-163,
					-239
				],
				[
					-177,
					-111
				],
				[
					-233,
					-30
				],
				[
					-70,
					-33
				],
				[
					-61,
					-152
				],
				[
					-73,
					-42
				],
				[
					-43,
					-146
				],
				[
					-137,
					12
				],
				[
					-89,
					-78
				],
				[
					-192,
					30
				],
				[
					-72,
					336
				],
				[
					8,
					315
				],
				[
					-46,
					170
				],
				[
					-54,
					426
				],
				[
					-80,
					236
				],
				[
					56,
					28
				],
				[
					-29,
					264
				],
				[
					34,
					111
				],
				[
					-12,
					251
				]
			],
			[
				[
					58175,
					39107
				],
				[
					113,
					-6
				],
				[
					134,
					-97
				],
				[
					94,
					69
				],
				[
					148,
					-58
				]
			],
			[
				[
					59119,
					36429
				],
				[
					-70,
					-419
				],
				[
					-32,
					-479
				],
				[
					-72,
					-260
				],
				[
					-190,
					-290
				],
				[
					-54,
					-84
				],
				[
					-118,
					-292
				],
				[
					-77,
					-296
				],
				[
					-158,
					-413
				],
				[
					-314,
					-594
				],
				[
					-196,
					-345
				],
				[
					-210,
					-262
				],
				[
					-290,
					-224
				],
				[
					-141,
					-30
				],
				[
					-36,
					-160
				],
				[
					-169,
					85
				],
				[
					-138,
					-109
				],
				[
					-301,
					111
				],
				[
					-168,
					-71
				],
				[
					-115,
					31
				],
				[
					-286,
					-228
				],
				[
					-238,
					-91
				],
				[
					-171,
					-218
				],
				[
					-127,
					-13
				],
				[
					-117,
					205
				],
				[
					-94,
					10
				],
				[
					-120,
					258
				],
				[
					-13,
					-80
				],
				[
					-37,
					155
				],
				[
					2,
					337
				],
				[
					-90,
					386
				],
				[
					89,
					105
				],
				[
					-7,
					442
				],
				[
					-182,
					539
				],
				[
					-139,
					488
				],
				[
					-1,
					1
				],
				[
					-199,
					749
				]
			],
			[
				[
					58409,
					42899
				],
				[
					-210,
					-79
				],
				[
					-159,
					-230
				],
				[
					-33,
					-199
				],
				[
					-100,
					-46
				],
				[
					-241,
					-473
				],
				[
					-154,
					-373
				],
				[
					-94,
					-13
				],
				[
					-90,
					66
				],
				[
					-311,
					63
				]
			]
		],
		"transform": {
			"scale": [
				0.0036000360003600037,
				0.0017364686646866468
			],
			"translate": [
				-180,
				-90
			]
		}
	};

/***/ },
/* 932 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": 4,
			"name": "Afghanistan"
		},
		{
			"id": 8,
			"name": "Albania"
		},
		{
			"id": 12,
			"name": "Algeria"
		},
		{
			"id": 24,
			"name": "Angola"
		},
		{
			"id": 10,
			"name": "Antarctica"
		},
		{
			"id": 32,
			"name": "Argentina"
		},
		{
			"id": 51,
			"name": "Armenia"
		},
		{
			"id": 36,
			"name": "Australia"
		},
		{
			"id": 40,
			"name": "Austria"
		},
		{
			"id": 31,
			"name": "Azerbaijan"
		},
		{
			"id": 44,
			"name": "Bahamas"
		},
		{
			"id": 50,
			"name": "Bangladesh"
		},
		{
			"id": 112,
			"name": "Belarus"
		},
		{
			"id": 56,
			"name": "Belgium"
		},
		{
			"id": 84,
			"name": "Belize"
		},
		{
			"id": 204,
			"name": "Benin"
		},
		{
			"id": 64,
			"name": "Bhutan"
		},
		{
			"id": 68,
			"name": "Bolivia, Plurinational State of"
		},
		{
			"id": 70,
			"name": "Bosnia and Herzegovina"
		},
		{
			"id": 72,
			"name": "Botswana"
		},
		{
			"id": 76,
			"name": "Brazil"
		},
		{
			"id": 96,
			"name": "Brunei Darussalam"
		},
		{
			"id": 100,
			"name": "Bulgaria"
		},
		{
			"id": 854,
			"name": "Burkina Faso"
		},
		{
			"id": 108,
			"name": "Burundi"
		},
		{
			"id": 116,
			"name": "Cambodia"
		},
		{
			"id": 120,
			"name": "Cameroon"
		},
		{
			"id": 124,
			"name": "Canada"
		},
		{
			"id": 140,
			"name": "Central African Republic"
		},
		{
			"id": 148,
			"name": "Chad"
		},
		{
			"id": 152,
			"name": "Chile"
		},
		{
			"id": 156,
			"name": "China"
		},
		{
			"id": 170,
			"name": "Colombia"
		},
		{
			"id": 178,
			"name": "Congo"
		},
		{
			"id": 180,
			"name": "Congo, the Democratic Republic of the"
		},
		{
			"id": 188,
			"name": "Costa Rica"
		},
		{
			"id": 384,
			"name": "Cote dIvoire"
		},
		{
			"id": 191,
			"name": "Croatia"
		},
		{
			"id": 192,
			"name": "Cuba"
		},
		{
			"id": 196,
			"name": "Cyprus"
		},
		{
			"id": 203,
			"name": "Czech Republic"
		},
		{
			"id": 208,
			"name": "Denmark"
		},
		{
			"id": 262,
			"name": "Djibouti"
		},
		{
			"id": 214,
			"name": "Dominican Republic"
		},
		{
			"id": 218,
			"name": "Ecuador"
		},
		{
			"id": 818,
			"name": "Egypt"
		},
		{
			"id": 222,
			"name": "El Salvador"
		},
		{
			"id": 226,
			"name": "Equatorial Guinea"
		},
		{
			"id": 232,
			"name": "Eritrea"
		},
		{
			"id": 233,
			"name": "Estonia"
		},
		{
			"id": 231,
			"name": "Ethiopia"
		},
		{
			"id": 238,
			"name": "Falkland Islands (Malvinas)"
		},
		{
			"id": 242,
			"name": "Fiji"
		},
		{
			"id": 246,
			"name": "Finland"
		},
		{
			"id": 250,
			"name": "France"
		},
		{
			"id": 260,
			"name": "French Southern Territories"
		},
		{
			"id": 266,
			"name": "Gabon"
		},
		{
			"id": 270,
			"name": "Gambia"
		},
		{
			"id": 268,
			"name": "Georgia"
		},
		{
			"id": 276,
			"name": "Germany"
		},
		{
			"id": 288,
			"name": "Ghana"
		},
		{
			"id": 300,
			"name": "Greece"
		},
		{
			"id": 304,
			"name": "Greenland"
		},
		{
			"id": 320,
			"name": "Guatemala"
		},
		{
			"id": 324,
			"name": "Guinea"
		},
		{
			"id": 624,
			"name": "Guinea-Bissau"
		},
		{
			"id": 328,
			"name": "Guyana"
		},
		{
			"id": 332,
			"name": "Haiti"
		},
		{
			"id": 340,
			"name": "Honduras"
		},
		{
			"id": 348,
			"name": "Hungary"
		},
		{
			"id": 352,
			"name": "Iceland"
		},
		{
			"id": 356,
			"name": "India"
		},
		{
			"id": 360,
			"name": "Indonesia"
		},
		{
			"id": 364,
			"name": "Iran, Islamic Republic of"
		},
		{
			"id": 368,
			"name": "Iraq"
		},
		{
			"id": 372,
			"name": "Ireland"
		},
		{
			"id": 376,
			"name": "Israel"
		},
		{
			"id": 380,
			"name": "Italy"
		},
		{
			"id": 388,
			"name": "Jamaica"
		},
		{
			"id": 392,
			"name": "Japan"
		},
		{
			"id": 400,
			"name": "Jordan"
		},
		{
			"id": 398,
			"name": "Kazakhstan"
		},
		{
			"id": 404,
			"name": "Kenya"
		},
		{
			"id": 408,
			"name": "Korea, Democratic Peoples Republic of"
		},
		{
			"id": 410,
			"name": "Korea, Republic of"
		},
		{
			"id": 414,
			"name": "Kuwait"
		},
		{
			"id": 417,
			"name": "Kyrgyzstan"
		},
		{
			"id": 418,
			"name": "Lao Peoples Democratic Republic"
		},
		{
			"id": 428,
			"name": "Latvia"
		},
		{
			"id": 422,
			"name": "Lebanon"
		},
		{
			"id": 426,
			"name": "Lesotho"
		},
		{
			"id": 430,
			"name": "Liberia"
		},
		{
			"id": 434,
			"name": "Libya"
		},
		{
			"id": 440,
			"name": "Lithuania"
		},
		{
			"id": 442,
			"name": "Luxembourg"
		},
		{
			"id": 807,
			"name": "Macedonia, the former Yugoslav Republic of"
		},
		{
			"id": 450,
			"name": "Madagascar"
		},
		{
			"id": 454,
			"name": "Malawi"
		},
		{
			"id": 458,
			"name": "Malaysia"
		},
		{
			"id": 466,
			"name": "Mali"
		},
		{
			"id": 478,
			"name": "Mauritania"
		},
		{
			"id": 484,
			"name": "Mexico"
		},
		{
			"id": 498,
			"name": "Moldova, Republic of"
		},
		{
			"id": 496,
			"name": "Mongolia"
		},
		{
			"id": 499,
			"name": "Montenegro"
		},
		{
			"id": 504,
			"name": "Morocco"
		},
		{
			"id": 508,
			"name": "Mozambique"
		},
		{
			"id": 104,
			"name": "Myanmar"
		},
		{
			"id": 516,
			"name": "Namibia"
		},
		{
			"id": 524,
			"name": "Nepal"
		},
		{
			"id": 528,
			"name": "Netherlands"
		},
		{
			"id": 540,
			"name": "New Caledonia"
		},
		{
			"id": 554,
			"name": "New Zealand"
		},
		{
			"id": 558,
			"name": "Nicaragua"
		},
		{
			"id": 562,
			"name": "Niger"
		},
		{
			"id": 566,
			"name": "Nigeria"
		},
		{
			"id": 578,
			"name": "Norway"
		},
		{
			"id": 512,
			"name": "Oman"
		},
		{
			"id": 586,
			"name": "Pakistan"
		},
		{
			"id": 275,
			"name": "Palestinian Territory, Occupied"
		},
		{
			"id": 591,
			"name": "Panama"
		},
		{
			"id": 598,
			"name": "Papua New Guinea"
		},
		{
			"id": 600,
			"name": "Paraguay"
		},
		{
			"id": 604,
			"name": "Peru"
		},
		{
			"id": 608,
			"name": "Philippines"
		},
		{
			"id": 616,
			"name": "Poland"
		},
		{
			"id": 620,
			"name": "Portugal"
		},
		{
			"id": 630,
			"name": "Puerto Rico"
		},
		{
			"id": 634,
			"name": "Qatar"
		},
		{
			"id": 642,
			"name": "Romania"
		},
		{
			"id": 643,
			"name": "Russia"
		},
		{
			"id": 646,
			"name": "Rwanda"
		},
		{
			"id": 682,
			"name": "Saudi Arabia"
		},
		{
			"id": 686,
			"name": "Senegal"
		},
		{
			"id": 688,
			"name": "Serbia"
		},
		{
			"id": 694,
			"name": "Sierra Leone"
		},
		{
			"id": 703,
			"name": "Slovakia"
		},
		{
			"id": 705,
			"name": "Slovenia"
		},
		{
			"id": 90,
			"name": "Solomon Islands"
		},
		{
			"id": 706,
			"name": "Somalia"
		},
		{
			"id": 710,
			"name": "South Africa"
		},
		{
			"id": 728,
			"name": "South Sudan"
		},
		{
			"id": 724,
			"name": "Spain"
		},
		{
			"id": 144,
			"name": "Sri Lanka"
		},
		{
			"id": 729,
			"name": "Sudan"
		},
		{
			"id": 740,
			"name": "Suriname"
		},
		{
			"id": 748,
			"name": "Swaziland"
		},
		{
			"id": 752,
			"name": "Sweden"
		},
		{
			"id": 756,
			"name": "Switzerland"
		},
		{
			"id": 760,
			"name": "Syrian Arab Republic"
		},
		{
			"id": 158,
			"name": "Taiwan, Province of China"
		},
		{
			"id": 762,
			"name": "Tajikistan"
		},
		{
			"id": 834,
			"name": "Tanzania, United Republic of"
		},
		{
			"id": 764,
			"name": "Thailand"
		},
		{
			"id": 626,
			"name": "Timor-Leste"
		},
		{
			"id": 768,
			"name": "Togo"
		},
		{
			"id": 780,
			"name": "Trinidad and Tobago"
		},
		{
			"id": 788,
			"name": "Tunisia"
		},
		{
			"id": 792,
			"name": "Turkey"
		},
		{
			"id": 795,
			"name": "Turkmenistan"
		},
		{
			"id": 800,
			"name": "Uganda"
		},
		{
			"id": 804,
			"name": "Ukraine"
		},
		{
			"id": 784,
			"name": "United Arab Emirates"
		},
		{
			"id": 826,
			"name": "United Kingdom"
		},
		{
			"id": 840,
			"name": "United States"
		},
		{
			"id": 858,
			"name": "Uruguay"
		},
		{
			"id": 860,
			"name": "Uzbekistan"
		},
		{
			"id": 548,
			"name": "Vanuatu"
		},
		{
			"id": 862,
			"name": "Venezuela, Bolivarian Republic of"
		},
		{
			"id": 704,
			"name": "Viet Nam"
		},
		{
			"id": 732,
			"name": "Western Sahara"
		},
		{
			"id": 887,
			"name": "Yemen"
		},
		{
			"id": 894,
			"name": "Zambia"
		},
		{
			"id": 716,
			"name": "Zimbabwe"
		}
	];

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	// css-to-string-loader: transforms styles from css-loader to a string output
	
	// Get the styles
	var styles = __webpack_require__(934);
	
	if (typeof styles === 'string') {
	  // Return an existing string
	  module.exports = styles;
	} else {
	  // Call the custom toString method from css-loader module
	  module.exports = styles.toString();
	}

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(935);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./leaflet.css", function() {
				var newContent = require("!!../../css-loader/index.js!./leaflet.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-image-layer,.leaflet-layer,.leaflet-map-pane,.leaflet-marker-icon,.leaflet-marker-pane,.leaflet-marker-shadow,.leaflet-overlay-pane,.leaflet-overlay-pane svg,.leaflet-popup-pane,.leaflet-shadow-pane,.leaflet-tile,.leaflet-tile-container,.leaflet-tile-pane,.leaflet-zoom-box{position:absolute;left:0;top:0}.leaflet-container{overflow:hidden;-ms-touch-action:none;touch-action:none}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container img{max-width:none!important}.leaflet-container img.leaflet-image-layer{max-width:15000px!important}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{width:0;height:0}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-tile-pane{z-index:2}.leaflet-objects-pane{z-index:3}.leaflet-overlay-pane{z-index:4}.leaflet-shadow-pane{z-index:5}.leaflet-marker-pane{z-index:6}.leaflet-popup-pane{z-index:7}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{position:relative;z-index:7;pointer-events:auto}.leaflet-bottom,.leaflet-top{position:absolute;z-index:1000;pointer-events:none}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-popup,.leaflet-fade-anim .leaflet-tile{opacity:0;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup,.leaflet-fade-anim .leaflet-tile-loaded{opacity:1}.leaflet-zoom-anim .leaflet-zoom-animated{transition:transform .25s cubic-bezier(0,0,.25,1)}.leaflet-pan-anim .leaflet-tile,.leaflet-touching .leaflet-zoom-animated,.leaflet-zoom-anim .leaflet-tile{transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-clickable{cursor:pointer}.leaflet-container{cursor:-moz-grab}.leaflet-control,.leaflet-popup-pane{cursor:auto}.leaflet-dragging .leaflet-clickable,.leaflet-dragging .leaflet-container{cursor:move;cursor:-moz-grabbing}.leaflet-container{background:#ddd;outline:0}.leaflet-container a{color:#0078a8}.leaflet-container a.leaflet-active{outline:2px solid orange}.leaflet-zoom-box{border:2px dotted #38f;background:hsla(0,0%,100%,.5)}.leaflet-container{font:12px/1.5 Helvetica Neue,Arial,Helvetica,sans-serif}.leaflet-bar{box-shadow:0 1px 5px rgba(0,0,0,.65);border-radius:4px}.leaflet-bar a,.leaflet-bar a:hover{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;display:block;text-align:center;text-decoration:none;color:#000}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:700 18px Lucida Console,Monaco,monospace;text-indent:1px}.leaflet-control-zoom-out{font-size:20px}.leaflet-touch .leaflet-control-zoom-in{font-size:22px}.leaflet-touch .leaflet-control-zoom-out{font-size:24px}.leaflet-control-layers{box-shadow:0 1px 5px rgba(0,0,0,.4);background:#fff;border-radius:5px}.leaflet-control-layers-toggle{background-image:url(" + __webpack_require__(936) + ");width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(" + __webpack_require__(937) + ");background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers-expanded .leaflet-control-layers-toggle,.leaflet-control-layers .leaflet-control-layers-list{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{padding:6px 10px 6px 6px;color:#333;background:#fff}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{display:block}.leaflet-control-layers-separator{height:0;border-top:1px solid #ddd;margin:5px -10px 5px -6px}.leaflet-container .leaflet-control-attribution{background:#fff;background:hsla(0,0%,100%,.7);margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{padding:0 5px;color:#333}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover{text-decoration:underline}.leaflet-container .leaflet-control-attribution,.leaflet-container .leaflet-control-scale{font-size:11px}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;box-sizing:content-box;background:#fff;background:hsla(0,0%,100%,.5)}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers{box-shadow:none}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-layers{border:2px solid rgba(0,0,0,.2);background-clip:padding-box}.leaflet-popup{position:absolute;text-align:center}.leaflet-popup-content-wrapper{padding:1px;text-align:left;border-radius:12px}.leaflet-popup-content{margin:13px 19px;line-height:1.4}.leaflet-popup-content p{margin:18px 0}.leaflet-popup-tip-container{margin:0 auto;width:40px;height:20px;position:relative;overflow:hidden}.leaflet-popup-tip{width:17px;height:17px;padding:1px;margin:-10px auto 0;transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{background:#fff;box-shadow:0 3px 14px rgba(0,0,0,.4)}.leaflet-container a.leaflet-popup-close-button{position:absolute;top:0;right:0;padding:4px 4px 0 0;text-align:center;width:18px;height:14px;font:16px/14px Tahoma,Verdana,sans-serif;color:#c3c3c3;text-decoration:none;font-weight:700;background:transparent}.leaflet-container a.leaflet-popup-close-button:hover{color:#999}.leaflet-popup-scrolled{overflow:auto;border-bottom:1px solid #ddd;border-top:1px solid #ddd}.leaflet-oldie .leaflet-popup-content-wrapper{zoom:1}.leaflet-oldie .leaflet-popup-tip{width:24px;margin:0 auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678,M12=0.70710678,M21=-0.70710678,M22=0.70710678)}.leaflet-oldie .leaflet-popup-tip-container{margin-top:-1px}.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}", ""]);
	
	// exports


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7cb0d2482ecadc1b80eb0abe457371b6.png";

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "324b4fcaf164735c627269504b7bc28e.png";

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	var DashboardCardComponent = (function () {
	    function DashboardCardComponent(location, window, document) {
	        this.location = location;
	        this.window = window;
	        this.document = document;
	    }
	    // saveEdit() {
	    //     if (($scope.editableSiteInfo.$invalid) || $scope.editableSiteInfo.$pristine) { return }
	    //     $http({
	    //         method: 'POST',
	    //         url: api+'/api/landing/savesiteinfo',
	    //         data: {
	    //             site: dashCtrl.currentSite
	    //         }
	    //     })
	    //     .success(function (result) {
	    //         // move the point if it's been updated
	    //         dashCtrl.movePoints(result);
	    //         //reset pristine stat
	    //         $scope.editableSiteInfo.$setPristine();
	    //     })
	    //     .error(function (err) {
	    //         console.log(err);
	    //     })
	    // }
	    DashboardCardComponent.prototype.inspect = function () {
	        if (this.location.$$search.hasOwnProperty('start') && this.location.$$search.hasOwnProperty('end')) {
	            // copy the time and strip out any other vars when clicking sidebar items
	            var time = { start: this.location.$$search.start, end: this.location.$$search.end };
	            this.location.path('outbound_ioc').search(time);
	        }
	        else {
	            this.location.path('outbound_ioc').search({});
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardCardComponent.prototype, "fullscreenEnabled", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardCardComponent.prototype, "currentSite", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], DashboardCardComponent.prototype, "sites", void 0);
	    DashboardCardComponent = __decorate([
	        core_1.Component({
	            selector: 'dashboard-card',
	            // template: `
	            //     <div *ngIf="(sites.length > 0) && (!fullscreenEnabled())" id="card-container" class="card-container">
	            //         <form editable-form name="editableSiteInfo" onaftersave="saveEdit()">
	            //             <div class="row1">
	            //                 <div class="topbanner">
	            //                     <p class="sitename">{{currentSite.site}}</p>
	            //                     <span>
	            //                         <button type="button" ng-click="showCard =! showCard" ng-show="!editableSiteInfo.$visible">
	            //                             <svg fill="#333333" height="24" width="24">
	            //                                 <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
	            //                             </svg>
	            //                         </button>
	            //                         <button type="button" ng-click="editableSiteInfo.$show()" ng-show="(!editableSiteInfo.$visible && showCard)">
	            //                             <svg fill="#333333" height="24" width="24">
	            //                                 <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
	            //                             </svg>
	            //                          </button>
	            //                     </span>
	            //                     <span ng-show="editableSiteInfo.$visible">
	            //                          <button type="submit" ng-disabled="editableSiteInfo.$waiting">
	            //                             <svg fill="#333333" height="24" width="24">
	            //                                 <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>
	            //                             </svg>
	            //                         </button>
	            //                          <button type="button" ng-disabled="editableSiteInfo.$waiting" ng-click="editableSiteInfo.$cancel()">
	            //                             <svg fill="#C42420" height="24" width="24">
	            //                                 <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
	            //                             </svg>
	            //                         </button>
	            //                     </span>
	            //                 </div>
	            //                 <div class="leftCol" ng-show="showCard">
	            //                     <p>Email</p>
	            //                     <p>Name</p>
	            //                     <p>Number</p>
	            //                     <p>Position</p>
	            //                     <p ng-show="editableSiteInfo.$visible">Location</p>
	            //                 </div>
	            //                 <div class="rightCol" ng-show="showCard">
	            //                     <p editable-text="currentSite.contact_email" e-name="contact_email" e-required>{{currentSite.contact_email}}</p>
	            //                     <p editable-text="currentSite.contact_name" e-name="contact_name" e-required>{{currentSite.contact_name}}</p>
	            //                     <p editable-text="currentSite.contact_number" e-name="contact_number" e-required>{{currentSite.contact_number}}</p>
	            //                     <p editable-text="currentSite.contact_position" e-name="contact_position" e-required>{{currentSite.contact_position}}</p>
	            //                     <p ng-show="editableSiteInfo.$visible" editable-text="currentSite.location" e-name="location" e-required></p>
	            //                 </div>
	            //             </div>
	            //             <div class="row1" ng-repeat="sensor in currentSite.sensors" ng-show="showCard">
	            //                 <div class="leftCol">
	            //                     <p>Sensor</p>
	            //                     <p>Status</p>
	            //                     <p>Description</p>
	            //                 </div>
	            //                 <div class="rightCol">
	            //                     <p>{{sensor.sensor}}</p>
	            //                     <p class="sensorstatus" ng-class="{ 'red' : (sensor.status != 'ok')}">{{sensor.status}}</p>
	            //                     <p editable-textarea="sensor.description" e-name="{'description' + $index}" e-required>{{sensor.description}}</p>
	            //                 </div>
	            //             </div>
	            //         </form>
	            //         <div ng-click="inspect()" class="inspectBttn">
	            //             <p>Inspect</p>
	            //         </div>
	            //     </div>
	            // `,
	            // template: `
	            //     <div *ngIf="(sites.length > 0) && (!fullscreenEnabled())" id="card-container" class="card-container">
	            //         <form>
	            //             <div class="row1">
	            //                 <div class="topbanner">
	            //                    <p class="sitename">{{currentSite.site}}</p>
	            //                </div>
	            //             </div>
	            //         </form>
	            //         <div (click)="inspect()" class="inspectBttn">
	            //             <p>Inspect</p>
	            //         </div>
	            //     </div>
	            // `,
	            template: "\n        <div *ngIf=\"(sites.length > 0) && (!fullscreenEnabled())\" id=\"card-container\" class=\"card-container\">\n            <form>\n                <div class=\"row1\">\n                    <div class=\"topbanner\">\n                       <p class=\"sitename\">M4Sensor</p>\n                   </div>\n                </div>\n            </form>\n            <div (click)=\"inspect()\" class=\"inspectBttn\">\n                <p>Inspect</p>\n            </div>\n        </div>\n    ",
	        }),
	        __param(0, core_1.Inject('$location')),
	        __param(1, core_1.Inject('Window')),
	        __param(2, core_1.Inject('Document')), 
	        __metadata('design:paramtypes', [Object, Object, Object])
	    ], DashboardCardComponent);
	    return DashboardCardComponent;
	}());
	exports.DashboardCardComponent = DashboardCardComponent;
	//             // create external function for the edit pane to update points with
	//             dashCtrl.movePoints = function(location) {
	//                 // console.log(dashCurrentSite)
	//                 // find the current site and update the latlong
	//                 const current = dashCurrentSite;
	//                 for (let i = 0, len = dashSites; i < len; i++) {
	//                     if (dashSites[i].site === current.site) {
	//                         // update list items
	//                         dashSites[i].lat = location.lat;
	//                         dashSites[i].long = location.lon;
	//                         dashSites[i].LatLng = {
	//                             lat: location.lat,
	//                             lng: location.lon
	//                         }
	//                     }
	//                 }
	//                 // also update the current set location
	//                 dashCurrentSite.lat = location.lat;
	//                 dashCurrentSite.long = location.lon;
	//                 dashCurrentSite.LatLng = {
	//                     lat: location.lat,
	//                     lng: location.lon
	//                 }
	//                 // re-reduce the sites
	//                 const sites = animation.reducer(dashSites);
	//                 // clear everything
	//                 animation.wipeClean();
	//                 // draw the sites
	//                 animation.drawSites(sites);
	//                 // mark current active site
	//                 animation.markCurrentSiteBlock(dashCurrentSite);
	//             }
	//


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div *ngIf=\"sites\">\n    <div class=\"legend-container\">\n        <div *ngIf=\"fullscreenEnabled()\" class=\"legend-image\">\n            <img src=\"" + __webpack_require__(940) + "\">\n        </div>\n        <div class=\"legend\">\n            <div><p class=\"title\">Live Connections Legend</p></div>\n            <div class=\"circle outbound\"></div>\n            <div><p>Outbound</p></div>\n            <div class=\"circle inbound\"></div>\n            <div><p>Inbound</p></div>\n            <div class=\"circle lateral\"></div>\n            <div><p>Lateral</p></div>\n            <div class=\"circle all\"></div>\n            <div><p>All</p></div>\n        </div>\n    </div>\n    <dashboard-card\n        [fullscreenEnabled]=\"fullscreenEnabled\"\n        [currentSite]=\"currentSite\"\n        [sites]=\"sites\"\n    >\n    </dashboard-card>\n    <dashboard-main\n        [newStream]=\"newStream\"\n        (currentSiteIs)=\"setCurrentSite($event)\"\n        (changeSite)=\"changeSite($event)\"\n        [inboundStream]=\"inboundStream\"\n        [outboundStream]=\"outboundStream\"\n        [lateralStream]=\"lateralStream\"\n        [mode]=\"mode\"\n        (modeChanged)=\"changeMode($event)\"\n        [sites]=\"sites\"\n        [parent]=\"'left'\"\n        [fullscreenEnabled]=\"fullscreenEnabled\"\n    >\n    </dashboard-main>\n</div>\n";

/***/ },
/* 940 */
870,
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(4);
	var Fullscreen = (function () {
	    function Fullscreen(document) {
	        this.document = document;
	    }
	    Fullscreen.prototype.ngOnInit = function () {
	        if (!this.select) {
	            console.error('The fullscreen directive requires the attribute \'select\' with an id specified.');
	            return;
	        }
	    };
	    Fullscreen.prototype.clicked = function () {
	        // when clicked, toggle fullscreen mode on the element defined in the attrs.select
	        var elem = this.document.getElementById(this.select);
	        if (!this.document.fullscreenElement &&
	            !this.document.mozFullScreenElement && !this.document.webkitFullscreenElement && !this.document.msFullscreenElement) {
	            if (elem.requestFullscreen) {
	                elem.requestFullscreen();
	            }
	            else if (elem.msRequestFullscreen) {
	                elem.msRequestFullscreen();
	            }
	            else if (elem.mozRequestFullScreen) {
	                elem.mozRequestFullScreen();
	            }
	            else if (elem.webkitRequestFullscreen) {
	                elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
	            }
	        }
	        else {
	            if (this.document.exitFullscreen) {
	                this.document.exitFullscreen();
	            }
	            else if (this.document.msExitFullscreen) {
	                this.document.msExitFullscreen();
	            }
	            else if (this.document.mozCancelFullScreen) {
	                this.document.mozCancelFullScreen();
	            }
	            else if (this.document.webkitExitFullscreen) {
	                this.document.webkitExitFullscreen();
	            }
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], Fullscreen.prototype, "select", void 0);
	    Fullscreen = __decorate([
	        core_1.Component({
	            selector: 'fullscreen',
	            providers: [
	                { provide: 'Document', useValue: document }
	            ],
	            template: "\n        <div (click)=\"clicked()\" class=\"fullscreen-button\">\n            <div class=\"svgBg\">\n                <svg width=\"24\" height=\"24\">\n                    <path class=\"st0\" d=\"M15,3l2.3,2.3l-2.9,2.9l1.4,1.4l2.9-2.9L21,9V3H15z M3,9l2.3-2.3l2.9,2.9l1.4-1.4L6.7,5.3L9,3H3V9z M9,21\n                    l-2.3-2.3l2.9-2.9l-1.4-1.4l-2.9,2.9L3,15v6H9z M21,15l-2.3,2.3l-2.9-2.9l-1.4,1.4l2.9,2.9L15,21h6V15z\"/>\n                </svg>\n            </div>\n        </div>\n    ",
	            // encapsulation: ViewEncapsulation.Native,
	            styles: [
	                __webpack_require__(942)
	            ],
	            directives: [],
	        }),
	        __param(0, core_1.Inject('Document')), 
	        __metadata('design:paramtypes', [Document])
	    ], Fullscreen);
	    return Fullscreen;
	}());
	exports.Fullscreen = Fullscreen;


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	// css-to-string-loader: transforms styles from css-loader to a string output
	
	// Get the styles
	var styles = __webpack_require__(943);
	
	if (typeof styles === 'string') {
	  // Return an existing string
	  module.exports = styles;
	} else {
	  // Call the custom toString method from css-loader module
	  module.exports = styles.toString();
	}

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(944);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=/app/node_modules/compass-mixins/lib!./style.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=/app/node_modules/compass-mixins/lib!./style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(340)();
	// imports
	
	
	// module
	exports.push([module.id, ".fullscreen-button{position:relative;padding:0;margin:0;cursor:pointer;height:0;width:0;top:70px;left:11px;z-index:9999}.fullscreen-button .svgBg{background-color:#fff;width:24px;height:24px;border-radius:4px;box-shadow:0 0 5px 0 rgba(0,0,0,.75)}.fullscreen-button svg{fill:#000;cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    // routes
	    __webpack_require__(946)(ngModule);
	    // controllers
	    __webpack_require__(948)(ngModule);
	    // directives
	    __webpack_require__(951)(ngModule);
	};

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.config(__webpack_require__(947));
	};

/***/ },
/* 947 */
/***/ function(module, exports) {

	'use strict';
	
	function ctrl() {
	    // $stateProvider
	    //     .state('changelog.main', {
	    //         url: '/changelog',
	    //         template: require('../views/main.html'),
	    //         controller: 'changelogMainCtrl',
	    //         controllerAs: 'changelog'
	    //     })
	}
	
	ctrl.$inject = ['$stateProvider'];
	module.exports = ctrl;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.controller('changelogMainCtrl', __webpack_require__(949));
	};

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var changelogHTML = __webpack_require__(950);
	
	function ctrl($scope) {
	   $scope.changelogHTML = changelogHTML;
	}
	
	ctrl.$inject = ['$scope'];
	module.exports = ctrl;

/***/ },
/* 950 */
/***/ function(module, exports) {

	var angular=window.angular,ngModule;
	try {ngModule=angular.module(["ng"])}
	catch(e){ngModule=angular.module("ng",[])}
	var v1="<ul> <li><h2 id=\"v2-6-4-2020-07-02-\">v2.6.4 (2020-07-02)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Bug in two step auth, whenever the code started with 0 it would erase it while authenticating.</li> <li>Bug in lateral map, for resolutions lower than 1300px it would move the map from his position and overlap other items on the window.</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Updated Two Step Auth submit buttons to match Login submit button style.</li> </ul> </li> <li><h2 id=\"v2-6-3-2020-02-18-\">v2.6.3 (2020-02-18)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Changed Anomalies item from sidebar, now instead of being a item directly from the sidebar it belongs to threat hunting submenu.</li> </ul> </li> </ul> <ul> <li><h2 id=\"v2-6-2-2020-02-11-\">v2.6.2 (2020-02-11)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Removed IOC Feeds from sidebar &amp; URL</li> <li>Removed changelog link &amp; URL</li> </ul> </li> </ul> <ul> <li><h2 id=\"v2-6-1-2020-01-14-\">v2.6.1 (2020-01-14)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Updated Forgot Password and Reset Password submit buttons to match Login submit button style.</li> <li>Updated Forgot Password and Reset Password views to show specific errors instead of generic error.</li> <li>Updated Reset password to show the requirements to set a new password.</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Meta information was missing when sending link through social sites.</li> </ul> </li> <li><h2 id=\"v2-5-0-2018-02-20-\">v2.5.0 (2018-02-20)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Added a new threat hunting menu.</li> <li>Added livemap reconnection routine.</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Changed landing dashboard card label to M4Sensor.</li> <li>Updated support button.</li> </ul> </li> <li><h2 id=\"v2-4-21-2016-11-10-\">v2.4.21 (2016-11-10)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Socket closed properly on swimlane page</li> </ul> </li> <li><h2 id=\"v2-4-20-2016-11-07-\">v2.4.20 (2016-11-07)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Updated dependency tracking</li> </ul> </li> <li><h2 id=\"v2-4-19-2016-11-02-\">v2.4.19 (2016-11-02)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Live connections globe display bug</li> </ul> </li> <li><h2 id=\"v2-4-18-2016-10-28-\">v2.4.18 (2016-10-28)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Free form search bug</li> </ul> </li> <li><h2 id=\"v2-4-17-2016-10-20-\">v2.4.17 (2016-10-20)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Stealth config and deployment view information parsing</li> </ul> </li> <li><h2 id=\"v2-4-16-2016-10-14-\">v2.4.16 (2016-10-14)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Right click option that links IOC rules to a VirusTotal search</li> </ul> </li> <li><h2 id=\"v2-4-15-2016-10-06-\">v2.4.15 (2016-10-06)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Stealth visuals</li> </ul> </li> <li><h2 id=\"v2-4-14-2016-09-22-\">v2.4.14 (2016-09-22)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>prevent 0 from being pre-pended to event_id in tables</li> </ul> </li> <li><h2 id=\"v2-4-13-2016-09-21-\">v2.4.13 (2016-09-21)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>added whitelist option to search &#39;indicator seen&#39; and &#39;IOC&#39; to the search tables</li> </ul> </li> <li><h2 id=\"v2-4-12-2016-09-15-\">v2.4.12 (2016-09-15)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Right click actions to create IOC, whitelist IOC rule, instant search</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Site editing in live connections has been disabled temporarily during transition to new user authentication backend system</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Memory leak in live connections</li> <li>Performance enhancements to live connections</li> </ul> </li> <li><h2 id=\"v2-4-11-2016-08-16-\">v2.4.11 (2016-08-16)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Decrease site icon size when live map is inactive</li> </ul> </li> <li><h2 id=\"v2-4-10-2016-08-08-\">v2.4.10 (2016-08-08)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Right click options fix for general network outbound drilldown table</li> </ul> </li> <li><h2 id=\"v2-4-9-2016-07-29-\">v2.4.9 (2016-07-29)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Services code refactor</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Right click menu formating</li> </ul> </li> <li><h2 id=\"v2-4-8-2016-07-27-\">v2.4.8 (2016-07-27)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Lateral connections map refactor to use canvas for display</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Search dropdown list style</li> <li>Changelog display error</li> </ul> </li> <li><h2 id=\"v2-4-7-2016-07-18-\">v2.4.7 (2016-07-18)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>User preferences styling</li> <li>Linechart hover</li> </ul> </li> <li><h2 id=\"v2-4-6-2016-07-15-\">v2.4.6 (2016-07-15)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Active defense toggle when creating custom IOC</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Custom IOC creation</li> <li>User login history display</li> </ul> </li> <li><h2 id=\"v2-4-5-2016-06-22-\">v2.4.5 (2016-06-22)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Highlight current client in selection dropdown</li> </ul> </li> <li><h2 id=\"v2-4-4-2016-06-21-\">v2.4.4 (2016-06-21)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Client dropdown style bug</li> <li>Live map style fixes</li> </ul> </li> <li><h2 id=\"v2-4-3-2016-06-17-\">v2.4.3 (2016-06-17)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Added printer, access point, switch, and phone to lateral view node types</li> <li>Lateral map multi select by holding ctrl</li> <li>Live view style</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Client dropdown styling</li> </ul> </li> <li><h2 id=\"v2-4-2-2016-06-16-\">v2.4.2 (2016-06-16)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Live map globe spins during inactivity</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Lateral map is zoomable once again</li> <li>Lateral map tooltips to show ip/hostname</li> <li>Live map styling</li> </ul> </li> <li><h2 id=\"v2-4-1-2016-06-14-\">v2.4.1 (2016-06-14)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Tweaks to lateral map display settings</li> </ul> </li> <li><h2 id=\"v2-4-0-2016-06-09-\">v2.4.0 (2016-06-09)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Live map includes animated heatmaps on globe</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Refactor lateral map. Includes significant performance and functionality improvements</li> </ul> </li> <li><h2 id=\"v2-3-3-2016-06-07-\">v2.3.3 (2016-06-07)</h2> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Two-Factor QR code insertion bug</li> </ul> </li> <li><h2 id=\"v2-3-2-2016-06-04-\">v2.3.2 (2016-06-04)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Alerts by ioc severity level</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Client site switching bugs</li> </ul> </li> <li><h2 id=\"v2-3-1-2016-05-30-\">v2.3.1 (2016-05-30)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Live page style enhancements</li> <li>Summary page renamed to live</li> </ul> <h4 id=\"fixes\">FIXES</h4> <ul> <li>Live page cpu pinning issue</li> </ul> </li> <li><h2 id=\"v2-3-0-2016-05-29-\">v2.3.0 (2016-05-29)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>New summary page view. Now includes live connections.</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Live connections merged into summary view.</li> </ul> </li> <li><h2 id=\"v2-2-2-2016-05-03-\">v2.2.2 (2016-05-03)</h2> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>Minor data handling and compiling issues</li> </ul> </li> <li><h2 id=\"v2-2-1-2016-04-19-\">v2.2.1 (2016-04-19)</h2> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>User report setting app behaviour</li> </ul> </li> <li><h2 id=\"v2-2-0-2016-04-16-\">v2.2.0 (2016-04-16)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Major changes to backend to refine error handling, and time range logic</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Summary view refinement</li> <li>Search page executes on include/exclude or hitting enter</li> <li>Piechart replaced with donut charts</li> <li>Better quality maps for summary view and different color options</li> </ul> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>More 0 prepend issues fixed</li> <li>Logic fix for determining top 10 for pie/donut charts</li> <li>Firefox styling issues</li> <li>2-Factor QR creation bug</li> </ul> </li> <li><h2 id=\"v2-1-6-2016-03-22-\">v2.1.6 (2016-03-22)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Summary view option to zoom view</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Current Client:Site added to header</li> <li>Human readable timestamp on export</li> <li>Persistent settings for number of rows shown in tables</li> </ul> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>0 being prepended to columns in search</li> </ul> </li> <li><h2 id=\"v2-1-5-2016-03-18-\">v2.1.5 (2016-03-18)</h2> <h4 id=\"new\">NEW</h4> <ul> <li>Support tab to allow for direct submission to ticket tracking system</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Styling on option sliders</li> <li>Styling on outbound ioc timeline reverted to grouping on the hour</li> </ul> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>User creation logic bug</li> </ul> </li> <li><h2 id=\"v2-1-4-2016-03-16-\">v2.1.4 (2016-03-16)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Switched LIN/LOG timeline behaviour. Now displays current selected option</li> <li>Services view performance enhancements</li> </ul> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>Search filtering inconsistencies</li> </ul> </li> <li><h2 id=\"v2-1-3-2016-03-16-\">v2.1.3 (2016-03-16)</h2> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Sort of payload ratios</li> </ul> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>fixed pivot from inbound/lateral ioc pages not loading properly</li> <li>prevent concat of 0 to some columns in tables</li> </ul> </li> <li><h2 id=\"v2-1-2-2016-03-12-\">v2.1.2 (2016-03-12)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>This changelog!</li> <li>Payload ratio visual in tables</li> <li>Timeline togle between log and linear scale</li> <li>User login history</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>http/ssl top-level domain grouping as top level page for Applications/HTTP By Domain and Applications/SSL Server Name</li> <li>Hostname added to services view</li> <li>User management styling</li> <li>Search page performance improvements</li> </ul> </li> <li><h2 id=\"v2-1-1-2016-03-01-\">v2.1.1 (2016-03-01)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>Dynamic sidebar spacing based on window height</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Search bar centered within header</li> </ul> </li> <li><h2 id=\"v2-1-0-2016-03-01-\">v2.1.0 (2016-03-01)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>New data model which breaks traffic down into outbound, inbound, and lateral vector types</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>Enhanced services view</li> </ul> <h4 id=\"bug-fixes\">BUG FIXES</h4> </li> <li><h2 id=\"v2-0-0-2015-10-27-\">v2.0.0 (2015-10-27)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>Free form search</li> <li>Backend database changed to cassandra</li> </ul> </li> <li><h2 id=\"v1-8-1-2015-09-11-\">v1.8.1 (2015-09-11)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>SMS alerting</li> <li>Timeline bandwidth toggle between B/KB/MB</li> <li>Network Assets view with ability to endpoint edit information</li> </ul> <h4 id=\"changes\">CHANGES</h4> <ul> <li>IOC drilldown -&gt; lower panels changed to display endpoint connections and services breakdown</li> </ul> <h4 id=\"bug-fixes\">BUG FIXES</h4> <ul> <li>Stealth Network map view bandwidth bugs</li> <li>Proper subnet collapsing</li> </ul> </li> <li><h2 id=\"v1-8-0-2015-08-30-\">v1.8.0 (2015-08-30)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>Active Defense -&gt; ability to set policy for active defense based IOC type and severity.</li> <li>Ability to create custom IOCs.</li> <li>User login history tracking and display.</li> <li>Search -&gt; Ability to stack modifiers. Eg. IS:Canada,Skype &amp; NOT:192.168.0.10.</li> <li>Detection -&gt; meterpreter payload detection</li> <li>File scan -&gt; Integration with MetaScan local AV scanner.</li> <li>Swimlane view -&gt; navigation via arrow keys.</li> <li>Swimlane view -&gt; export kill chain results.</li> <li>Services view -&gt; ability to collapse local ip by subnet.</li> <li>Services view -&gt; zoomable view.</li> <li>Services view -&gt; toggle between country name and flag.</li> <li>Services view -&gt; toggle between local IP and hostname.</li> </ul> <h3 id=\"changes\">CHANGES</h3> <ul> <li>Services view -&gt; improvements to database for increased performance.</li> <li>Services view -&gt; improved visual style.</li> <li>Search -&gt; &#39;OR&#39; flag changed to &#39;IS&#39; to better represent behavior of flag.</li> <li>Search Page -&gt; added search by file type.</li> <li>System -&gt; enhancements to DB retention policy enforcement.</li> <li>Admin -&gt; ability for admin/superadmin to set passwords for users.</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>Enhanced geoip lookups so that they are more acurate.</li> <li>Page style issues in Firefox.</li> <li>Error handling on VirusTotal API calls.</li> <li>Icon for message/* MIME type in extracted file views.</li> </ul> </li> <li><h2 id=\"v1-7-0-2015-07-01-\">v1.7.0 (2015-07-01)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>Adopting semantic versioning detailed here: <a href=\"http://semver.org/\">http://semver.org/</a></li> <li>New visual -&gt; services local/remote display.</li> <li>Search -&gt; Assisted search now displayed when clicking search box.</li> <li>Search -&gt; Filters &#39;NOT&#39; to exclude results, and &#39;OR&#39; to build list results to include.</li> <li>Alerts -&gt; User has ability to subscribe to alerts based on ioc severity or frequency.</li> <li>Admin -&gt; log user login time, ip, and useragent when attempting to login to portal.</li> </ul> <h3 id=\"changes\">CHANGES</h3> <ul> <li>Refined sql for local/remote services. Now focused on client/server instead of local/remote.</li> <li>Refined timelines to hide data point on graph when value is 0.</li> <li>Application pages group by protocol, service, and layer 7 application.</li> <li>New favicon.</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>Tables -&gt; Fix error in table backend grouping that was hiding info on multiple pages.</li> <li>Tables -&gt; Hide ref to table buttons in column selection dropdown.</li> <li>Admin -&gt; Superadmins can see all clients/zones even if access is not defined in db.</li> </ul> </li> <li><h2 id=\"v1-6-39-2015-06-17-\">v1.6.39 (2015-06-17)</h2> <h4 id=\"new-feature\">NEW FEATURE</h4> <ul> <li>Reorder of sidebar items. HTTP, DNS, Email, FTP, SSH, IRC have been moved to Applications.</li> <li>New view. Local services/Remote Services.</li> <li>DB -&gt; dedicated tracking of local/remote services.</li> <li>Show remote connections on network connections map.</li> <li>User has ability to subscribe to reports with option of selecting subset of clients/zones they have access to.</li> <li>Testing suite for sensor environment.</li> <li>EULA added with requirement for users to agree.</li> </ul> <h3 id=\"changes\">CHANGES</h3> <ul> <li>Refined backend code for user management.</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>Ability to drag nodes on network connections map without filtering.</li> <li>Export CSV quote delimits column info to prevent errors when opening with excel.</li> </ul> </li> <li><h2 id=\"v1-6-38-2015-06-09-\">v1.6.38 (2015-06-09)</h2> <h3 id=\"changes\">CHANGES</h3> <ul> <li>Loading animation for search page</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>Bug in user management report subscription view</li> <li>Proper overlay of toggle on timelines</li> </ul> </li> <li><h2 id=\"v1-6-37-2015-06-05-\">v1.6.37 (2015-06-05)</h2> <h3 id=\"new-feature\">NEW FEATURE</h3> <ul> <li>My Preferences -&gt; New tab to allow user to subscribe to daily reports</li> <li>Scrollable side for easier navigation on small screens</li> </ul> <h3 id=\"changes\">CHANGES</h3> <ul> <li>Search page -&gt; loading animation on search</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>Search page multiple bugs</li> </ul> </li> <li><h2 id=\"v1-6-36-2015-06-04-\">v1.6.36 (2015-06-04)</h2> <h3 id=\"new-feature\">NEW FEATURE</h3> <ul> <li>Search page to query all client zones. Limited search types for now but will be expanded soon.</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>fix to report generation procedural bugs</li> </ul> </li> <li><h2 id=\"v1-6-35-2015-06-03-\">v1.6.35 (2015-06-03)</h2> <h3 id=\"changes\">CHANGES</h3> <ul> <li>swimlane visual -&gt; highlight swimlane icon if selected to filter events</li> <li>swimlane visual -&gt; new filter on to filter out all events unrelated to the local ip, remote ip, and ioc selected</li> <li>heights for ioc drilldown page bottom visuals are responsive, and ioc lineage has collapsible nodes</li> <li>rewrite of report generation to make process more robust</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>code cleanup</li> </ul> </li> <li><h2 id=\"v1-6-34-2015-06-02-\">v1.6.34 (2015-06-02)</h2> <h3 id=\"changes\">CHANGES</h3> <ul> <li>sharepoint events changed to MS events to be a single landing page for MS SQL, Exchange and Sharepoint log events</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>code cleanup</li> </ul> </li> <li><h2 id=\"v1-6-33-2015-06-01-\">v1.6.33 (2015-06-01)</h2> <h3 id=\"changes\">CHANGES</h3> <ul> <li>state of webapp preferences is stored in DB to remain statefull accross sessions</li> </ul> <h3 id=\"bug-fixes\">BUG FIXES</h3> <ul> <li>timestamp in reports</li> <li>timeline rendering on some pages</li> <li>endpoint map minor enhancements</li> <li>user creation backend cleanup</li> <li>changelog requires authentication</li> </ul> </li> <li><h2 id=\"v1-6-32-2015-05-24-\">v1.6.32 (2015-05-24)</h2> <h3 id=\"bug-fixes-changes\">BUG FIXES / CHANGES</h3> <ul> <li>reviewed titles/labels to be consistent</li> <li>consistent layout for timelines and geomaps/charts</li> </ul> </li> <li><h2 id=\"v1-6-31-2015-05-22-\">v1.6.31 (2015-05-22)</h2> <h3 id=\"bug-fixes-changes\">BUG FIXES / CHANGES</h3> <ul> <li>internal connections -&gt; hide nodes instead of graying out when searching/selecting</li> <li>application views</li> <li>fixed bug in drilldown through application giving null results</li> </ul> </li> <li><h2 id=\"v1-6-30-2015-05-21-\">v1.6.30 (2015-05-21)</h2> <h3 id=\"new-features\">NEW FEATURES</h3> <ul> <li>application timelines have each layer broken</li> <li>client/zone selection</li> </ul> <h3 id=\"bug-fixes-changes\">BUG FIXES / CHANGES</h3> <ul> <li>HTTP timelines</li> <li>fixed bug preventing timelines from being drawn</li> </ul> </li> <li><h2 id=\"v1-6-29-2015-05-20-\">v1.6.29 (2015-05-20)</h2> <h3 id=\"new-features\">NEW FEATURES</h3> <ul> <li>this changelog view!</li> <li>stacked graphs for timelines</li> <li>new visual</li> <li>toggle for timelines to switch between stacked and overlaid timelines</li> </ul> <h3 id=\"bug-fixes-changes\">BUG FIXES / CHANGES</h3> <ul> <li>daily reports</li> <li>major bug in report generation and multiple sent emails has been fixed</li> </ul> </li> </ul>";
	ngModule.run(["$templateCache",function(c){c.put("CHANGELOG.md",v1)}]);
	module.exports=v1;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    __webpack_require__(952)(ngModule);
	};

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    ngModule.directive('renderhtml', __webpack_require__(953));
	};

/***/ },
/* 953 */
/***/ function(module, exports) {

	'use strict';
	
	function directive(Global) {
	    return {
	        // restrict: 'A',
	        // transclude : true,
	        link: function link($scope, element, attrs) {
	            var incrimentCountBy = 3;
	            // grab the html string from the attrs
	            var html = attrs.html;
	            // note: we weap the html (markdown) in divs to tell apart the higharchy of the ul > li's
	            html += '<div>' + html + '</div>';
	            // create an empty element to throw it in
	            var el = document.createElement('html');
	            el.innerHTML = html; // fill the empty object
	            // create empty div that will be added to the element
	            var divHolder = document.createElement('div');
	            element[0].appendChild(divHolder);
	            // select div
	            var div = element[0].querySelector('div');
	            // next mark each with a class that will make them easier to style
	            var logs = el.querySelectorAll('div > ul > li');
	            Array.prototype.forEach.call(logs, function (e, i) {
	                if (e.classList) {
	                    e.classList.add('logblock');
	                } else {
	                    e['logblock'] += ' ' + 'logblock';
	                }
	            });
	            var currentOut = 0;
	            function addElementsToOutput(number) {
	                if (currentOut + number < logs.length) {
	                    currentOut += number;
	                } else {
	                    currentOut = logs.length;
	                }
	                var string = '';
	                var array = _.take(logs, currentOut);
	                // array = Array.prototype.slice.call(logs, logs.length -1);
	                array.forEach(function (e) {
	                    string += e.outerHTML;
	                });
	                return string;
	            }
	            // 'load more' function toggle
	            $scope.loadMoreChangeLog = function () {
	                var string = addElementsToOutput(incrimentCountBy);
	                div.innerHTML = string;
	            };
	            // 'load more' function toggle
	            $scope.goBack = function () {
	                window.history.back();
	            };
	            var string = addElementsToOutput(incrimentCountBy);
	            div.innerHTML = string;
	        }
	    };
	}
	
	directive.$inject = ['Global'];
	module.exports = directive;

/***/ },
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	module.exports = function (ngModule) {
	    __webpack_require__(__webpack_module_template_argument_0__)();
	};

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(346)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=/app/node_modules/compass-mixins/lib!./main.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=/app/node_modules/compass-mixins/lib!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }
]);


/** WEBPACK FOOTER **
 ** app.86823d9342468ead0841.js
 **/